(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire366e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire366e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6XFBA", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $511886b7d9d0362d$export$ffb0004e005737fa; }, function (v) { return $511886b7d9d0362d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $511886b7d9d0362d$export$34b9dba7ce09269b; }, function (v) { return $511886b7d9d0362d$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $511886b7d9d0362d$export$25062201e9e25d76; }, function (v) { return $511886b7d9d0362d$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $511886b7d9d0362d$export$ffb0004e005737fa;
var $511886b7d9d0362d$export$34b9dba7ce09269b;
var $511886b7d9d0362d$export$25062201e9e25d76;
"use strict";

var $9nZCP = parcelRequire("9nZCP");
var $511886b7d9d0362d$var$k = Symbol.for("react.element"), $511886b7d9d0362d$var$l = Symbol.for("react.fragment"), $511886b7d9d0362d$var$m = Object.prototype.hasOwnProperty, $511886b7d9d0362d$var$n = $9nZCP.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $511886b7d9d0362d$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $511886b7d9d0362d$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$511886b7d9d0362d$var$m.call(a, b) && !$511886b7d9d0362d$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $511886b7d9d0362d$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $511886b7d9d0362d$var$n.current
    };
}
$511886b7d9d0362d$export$ffb0004e005737fa = $511886b7d9d0362d$var$l;
$511886b7d9d0362d$export$34b9dba7ce09269b = $511886b7d9d0362d$var$q;
$511886b7d9d0362d$export$25062201e9e25d76 = $511886b7d9d0362d$var$q;

});
parcelRegister("9nZCP", function(module, exports) {
"use strict";

module.exports = (parcelRequire("346v6"));

});
parcelRegister("346v6", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $23b6c9b94a5b5dc9$export$dca3b0875bd9a954; }, function (v) { return $23b6c9b94a5b5dc9$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $23b6c9b94a5b5dc9$export$16fa2f45be04daa8; }, function (v) { return $23b6c9b94a5b5dc9$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $23b6c9b94a5b5dc9$export$ffb0004e005737fa; }, function (v) { return $23b6c9b94a5b5dc9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $23b6c9b94a5b5dc9$export$e2c29f18771995cb; }, function (v) { return $23b6c9b94a5b5dc9$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $23b6c9b94a5b5dc9$export$221d75b3f55bb0bd; }, function (v) { return $23b6c9b94a5b5dc9$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $23b6c9b94a5b5dc9$export$5f8d39834fd61797; }, function (v) { return $23b6c9b94a5b5dc9$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $23b6c9b94a5b5dc9$export$74bf444e3cd11ea5; }, function (v) { return $23b6c9b94a5b5dc9$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $23b6c9b94a5b5dc9$export$ae55be85d98224ed; }, function (v) { return $23b6c9b94a5b5dc9$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $23b6c9b94a5b5dc9$export$e530037191fcd5d7; }, function (v) { return $23b6c9b94a5b5dc9$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $23b6c9b94a5b5dc9$export$fd42f52fd3ae1109; }, function (v) { return $23b6c9b94a5b5dc9$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $23b6c9b94a5b5dc9$export$c8a8987d4410bf2d; }, function (v) { return $23b6c9b94a5b5dc9$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $23b6c9b94a5b5dc9$export$d38cd72104c1f0e9; }, function (v) { return $23b6c9b94a5b5dc9$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $23b6c9b94a5b5dc9$export$7d1e3a5e95ceca43; }, function (v) { return $23b6c9b94a5b5dc9$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $23b6c9b94a5b5dc9$export$257a8862b851cb5b; }, function (v) { return $23b6c9b94a5b5dc9$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $23b6c9b94a5b5dc9$export$a8257692ac88316c; }, function (v) { return $23b6c9b94a5b5dc9$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $23b6c9b94a5b5dc9$export$488013bae63b21da; }, function (v) { return $23b6c9b94a5b5dc9$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $23b6c9b94a5b5dc9$export$7c73462e0d25e514; }, function (v) { return $23b6c9b94a5b5dc9$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $23b6c9b94a5b5dc9$export$7568632d0d33d16d; }, function (v) { return $23b6c9b94a5b5dc9$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $23b6c9b94a5b5dc9$export$88948ce120ea2619; }, function (v) { return $23b6c9b94a5b5dc9$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $23b6c9b94a5b5dc9$export$35808ee640e87ca7; }, function (v) { return $23b6c9b94a5b5dc9$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $23b6c9b94a5b5dc9$export$fae74005e78b1a27; }, function (v) { return $23b6c9b94a5b5dc9$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $23b6c9b94a5b5dc9$export$dc8fbce3eb94dc1e; }, function (v) { return $23b6c9b94a5b5dc9$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $23b6c9b94a5b5dc9$export$6a7bc4e911dc01cf; }, function (v) { return $23b6c9b94a5b5dc9$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $23b6c9b94a5b5dc9$export$6d9c69b0de29b591; }, function (v) { return $23b6c9b94a5b5dc9$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $23b6c9b94a5b5dc9$export$f680877a34711e37; }, function (v) { return $23b6c9b94a5b5dc9$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $23b6c9b94a5b5dc9$export$d5a552a76deda3c2; }, function (v) { return $23b6c9b94a5b5dc9$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $23b6c9b94a5b5dc9$export$aaabe4eda9ed9969; }, function (v) { return $23b6c9b94a5b5dc9$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $23b6c9b94a5b5dc9$export$e5c5a5f917a5871c; }, function (v) { return $23b6c9b94a5b5dc9$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $23b6c9b94a5b5dc9$export$1538c33de8887b59; }, function (v) { return $23b6c9b94a5b5dc9$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $23b6c9b94a5b5dc9$export$13e3392192263954; }, function (v) { return $23b6c9b94a5b5dc9$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $23b6c9b94a5b5dc9$export$b8f5890fc79d6aca; }, function (v) { return $23b6c9b94a5b5dc9$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $23b6c9b94a5b5dc9$export$60241385465d0a34; }, function (v) { return $23b6c9b94a5b5dc9$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $23b6c9b94a5b5dc9$export$306c0aa65ff9ec16; }, function (v) { return $23b6c9b94a5b5dc9$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $23b6c9b94a5b5dc9$export$7b286972b8d8ccbf; }, function (v) { return $23b6c9b94a5b5dc9$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $23b6c9b94a5b5dc9$export$83d89fbfd8236492; }, function (v) { return $23b6c9b94a5b5dc9$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $23b6c9b94a5b5dc9$export$dca3b0875bd9a954;
var $23b6c9b94a5b5dc9$export$16fa2f45be04daa8;
var $23b6c9b94a5b5dc9$export$ffb0004e005737fa;
var $23b6c9b94a5b5dc9$export$e2c29f18771995cb;
var $23b6c9b94a5b5dc9$export$221d75b3f55bb0bd;
var $23b6c9b94a5b5dc9$export$5f8d39834fd61797;
var $23b6c9b94a5b5dc9$export$74bf444e3cd11ea5;
var $23b6c9b94a5b5dc9$export$ae55be85d98224ed;
var $23b6c9b94a5b5dc9$export$e530037191fcd5d7;
var $23b6c9b94a5b5dc9$export$fd42f52fd3ae1109;
var $23b6c9b94a5b5dc9$export$c8a8987d4410bf2d;
var $23b6c9b94a5b5dc9$export$d38cd72104c1f0e9;
var $23b6c9b94a5b5dc9$export$7d1e3a5e95ceca43;
var $23b6c9b94a5b5dc9$export$257a8862b851cb5b;
var $23b6c9b94a5b5dc9$export$a8257692ac88316c;
var $23b6c9b94a5b5dc9$export$488013bae63b21da;
var $23b6c9b94a5b5dc9$export$7c73462e0d25e514;
var $23b6c9b94a5b5dc9$export$7568632d0d33d16d;
var $23b6c9b94a5b5dc9$export$88948ce120ea2619;
var $23b6c9b94a5b5dc9$export$35808ee640e87ca7;
var $23b6c9b94a5b5dc9$export$fae74005e78b1a27;
var $23b6c9b94a5b5dc9$export$dc8fbce3eb94dc1e;
var $23b6c9b94a5b5dc9$export$6a7bc4e911dc01cf;
var $23b6c9b94a5b5dc9$export$6d9c69b0de29b591;
var $23b6c9b94a5b5dc9$export$f680877a34711e37;
var $23b6c9b94a5b5dc9$export$d5a552a76deda3c2;
var $23b6c9b94a5b5dc9$export$aaabe4eda9ed9969;
var $23b6c9b94a5b5dc9$export$e5c5a5f917a5871c;
var $23b6c9b94a5b5dc9$export$1538c33de8887b59;
var $23b6c9b94a5b5dc9$export$13e3392192263954;
var $23b6c9b94a5b5dc9$export$b8f5890fc79d6aca;
var $23b6c9b94a5b5dc9$export$60241385465d0a34;
var $23b6c9b94a5b5dc9$export$306c0aa65ff9ec16;
var $23b6c9b94a5b5dc9$export$7b286972b8d8ccbf;
var $23b6c9b94a5b5dc9$export$83d89fbfd8236492;
"use strict";
var $23b6c9b94a5b5dc9$var$l = Symbol.for("react.element"), $23b6c9b94a5b5dc9$var$n = Symbol.for("react.portal"), $23b6c9b94a5b5dc9$var$p = Symbol.for("react.fragment"), $23b6c9b94a5b5dc9$var$q = Symbol.for("react.strict_mode"), $23b6c9b94a5b5dc9$var$r = Symbol.for("react.profiler"), $23b6c9b94a5b5dc9$var$t = Symbol.for("react.provider"), $23b6c9b94a5b5dc9$var$u = Symbol.for("react.context"), $23b6c9b94a5b5dc9$var$v = Symbol.for("react.forward_ref"), $23b6c9b94a5b5dc9$var$w = Symbol.for("react.suspense"), $23b6c9b94a5b5dc9$var$x = Symbol.for("react.memo"), $23b6c9b94a5b5dc9$var$y = Symbol.for("react.lazy"), $23b6c9b94a5b5dc9$var$z = Symbol.iterator;
function $23b6c9b94a5b5dc9$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $23b6c9b94a5b5dc9$var$z && a[$23b6c9b94a5b5dc9$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $23b6c9b94a5b5dc9$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $23b6c9b94a5b5dc9$var$C = Object.assign, $23b6c9b94a5b5dc9$var$D = {};
function $23b6c9b94a5b5dc9$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $23b6c9b94a5b5dc9$var$D;
    this.updater = e || $23b6c9b94a5b5dc9$var$B;
}
$23b6c9b94a5b5dc9$var$E.prototype.isReactComponent = {};
$23b6c9b94a5b5dc9$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$23b6c9b94a5b5dc9$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $23b6c9b94a5b5dc9$var$F() {}
$23b6c9b94a5b5dc9$var$F.prototype = $23b6c9b94a5b5dc9$var$E.prototype;
function $23b6c9b94a5b5dc9$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $23b6c9b94a5b5dc9$var$D;
    this.updater = e || $23b6c9b94a5b5dc9$var$B;
}
var $23b6c9b94a5b5dc9$var$H = $23b6c9b94a5b5dc9$var$G.prototype = new $23b6c9b94a5b5dc9$var$F;
$23b6c9b94a5b5dc9$var$H.constructor = $23b6c9b94a5b5dc9$var$G;
$23b6c9b94a5b5dc9$var$C($23b6c9b94a5b5dc9$var$H, $23b6c9b94a5b5dc9$var$E.prototype);
$23b6c9b94a5b5dc9$var$H.isPureReactComponent = !0;
var $23b6c9b94a5b5dc9$var$I = Array.isArray, $23b6c9b94a5b5dc9$var$J = Object.prototype.hasOwnProperty, $23b6c9b94a5b5dc9$var$K = {
    current: null
}, $23b6c9b94a5b5dc9$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $23b6c9b94a5b5dc9$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$23b6c9b94a5b5dc9$var$J.call(b, d) && !$23b6c9b94a5b5dc9$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $23b6c9b94a5b5dc9$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $23b6c9b94a5b5dc9$var$K.current
    };
}
function $23b6c9b94a5b5dc9$var$N(a, b) {
    return {
        $$typeof: $23b6c9b94a5b5dc9$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $23b6c9b94a5b5dc9$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $23b6c9b94a5b5dc9$var$l;
}
function $23b6c9b94a5b5dc9$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $23b6c9b94a5b5dc9$var$P = /\/+/g;
function $23b6c9b94a5b5dc9$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $23b6c9b94a5b5dc9$var$escape("" + a.key) : b.toString(36);
}
function $23b6c9b94a5b5dc9$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $23b6c9b94a5b5dc9$var$l:
                case $23b6c9b94a5b5dc9$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $23b6c9b94a5b5dc9$var$Q(h, 0) : d, $23b6c9b94a5b5dc9$var$I(c) ? (e = "", null != a && (e = a.replace($23b6c9b94a5b5dc9$var$P, "$&/") + "/"), $23b6c9b94a5b5dc9$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($23b6c9b94a5b5dc9$var$O(c) && (c = $23b6c9b94a5b5dc9$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($23b6c9b94a5b5dc9$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($23b6c9b94a5b5dc9$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $23b6c9b94a5b5dc9$var$Q(k, g);
        h += $23b6c9b94a5b5dc9$var$R(k, b, e, f, c);
    }
    else if (f = $23b6c9b94a5b5dc9$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $23b6c9b94a5b5dc9$var$Q(k, g++), h += $23b6c9b94a5b5dc9$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $23b6c9b94a5b5dc9$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $23b6c9b94a5b5dc9$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $23b6c9b94a5b5dc9$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $23b6c9b94a5b5dc9$var$U = {
    current: null
}, $23b6c9b94a5b5dc9$var$V = {
    transition: null
}, $23b6c9b94a5b5dc9$var$W = {
    ReactCurrentDispatcher: $23b6c9b94a5b5dc9$var$U,
    ReactCurrentBatchConfig: $23b6c9b94a5b5dc9$var$V,
    ReactCurrentOwner: $23b6c9b94a5b5dc9$var$K
};
$23b6c9b94a5b5dc9$export$dca3b0875bd9a954 = {
    map: $23b6c9b94a5b5dc9$var$S,
    forEach: function(a, b, e) {
        $23b6c9b94a5b5dc9$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $23b6c9b94a5b5dc9$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $23b6c9b94a5b5dc9$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$23b6c9b94a5b5dc9$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$23b6c9b94a5b5dc9$export$16fa2f45be04daa8 = $23b6c9b94a5b5dc9$var$E;
$23b6c9b94a5b5dc9$export$ffb0004e005737fa = $23b6c9b94a5b5dc9$var$p;
$23b6c9b94a5b5dc9$export$e2c29f18771995cb = $23b6c9b94a5b5dc9$var$r;
$23b6c9b94a5b5dc9$export$221d75b3f55bb0bd = $23b6c9b94a5b5dc9$var$G;
$23b6c9b94a5b5dc9$export$5f8d39834fd61797 = $23b6c9b94a5b5dc9$var$q;
$23b6c9b94a5b5dc9$export$74bf444e3cd11ea5 = $23b6c9b94a5b5dc9$var$w;
$23b6c9b94a5b5dc9$export$ae55be85d98224ed = $23b6c9b94a5b5dc9$var$W;
$23b6c9b94a5b5dc9$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $23b6c9b94a5b5dc9$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $23b6c9b94a5b5dc9$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$23b6c9b94a5b5dc9$var$J.call(b, f) && !$23b6c9b94a5b5dc9$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $23b6c9b94a5b5dc9$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$23b6c9b94a5b5dc9$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $23b6c9b94a5b5dc9$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $23b6c9b94a5b5dc9$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$23b6c9b94a5b5dc9$export$c8a8987d4410bf2d = $23b6c9b94a5b5dc9$var$M;
$23b6c9b94a5b5dc9$export$d38cd72104c1f0e9 = function(a) {
    var b = $23b6c9b94a5b5dc9$var$M.bind(null, a);
    b.type = a;
    return b;
};
$23b6c9b94a5b5dc9$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$23b6c9b94a5b5dc9$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $23b6c9b94a5b5dc9$var$v,
        render: a
    };
};
$23b6c9b94a5b5dc9$export$a8257692ac88316c = $23b6c9b94a5b5dc9$var$O;
$23b6c9b94a5b5dc9$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $23b6c9b94a5b5dc9$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $23b6c9b94a5b5dc9$var$T
    };
};
$23b6c9b94a5b5dc9$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $23b6c9b94a5b5dc9$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$23b6c9b94a5b5dc9$export$7568632d0d33d16d = function(a) {
    var b = $23b6c9b94a5b5dc9$var$V.transition;
    $23b6c9b94a5b5dc9$var$V.transition = {};
    try {
        a();
    } finally{
        $23b6c9b94a5b5dc9$var$V.transition = b;
    }
};
$23b6c9b94a5b5dc9$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$23b6c9b94a5b5dc9$export$35808ee640e87ca7 = function(a, b) {
    return $23b6c9b94a5b5dc9$var$U.current.useCallback(a, b);
};
$23b6c9b94a5b5dc9$export$fae74005e78b1a27 = function(a) {
    return $23b6c9b94a5b5dc9$var$U.current.useContext(a);
};
$23b6c9b94a5b5dc9$export$dc8fbce3eb94dc1e = function() {};
$23b6c9b94a5b5dc9$export$6a7bc4e911dc01cf = function(a) {
    return $23b6c9b94a5b5dc9$var$U.current.useDeferredValue(a);
};
$23b6c9b94a5b5dc9$export$6d9c69b0de29b591 = function(a, b) {
    return $23b6c9b94a5b5dc9$var$U.current.useEffect(a, b);
};
$23b6c9b94a5b5dc9$export$f680877a34711e37 = function() {
    return $23b6c9b94a5b5dc9$var$U.current.useId();
};
$23b6c9b94a5b5dc9$export$d5a552a76deda3c2 = function(a, b, e) {
    return $23b6c9b94a5b5dc9$var$U.current.useImperativeHandle(a, b, e);
};
$23b6c9b94a5b5dc9$export$aaabe4eda9ed9969 = function(a, b) {
    return $23b6c9b94a5b5dc9$var$U.current.useInsertionEffect(a, b);
};
$23b6c9b94a5b5dc9$export$e5c5a5f917a5871c = function(a, b) {
    return $23b6c9b94a5b5dc9$var$U.current.useLayoutEffect(a, b);
};
$23b6c9b94a5b5dc9$export$1538c33de8887b59 = function(a, b) {
    return $23b6c9b94a5b5dc9$var$U.current.useMemo(a, b);
};
$23b6c9b94a5b5dc9$export$13e3392192263954 = function(a, b, e) {
    return $23b6c9b94a5b5dc9$var$U.current.useReducer(a, b, e);
};
$23b6c9b94a5b5dc9$export$b8f5890fc79d6aca = function(a) {
    return $23b6c9b94a5b5dc9$var$U.current.useRef(a);
};
$23b6c9b94a5b5dc9$export$60241385465d0a34 = function(a) {
    return $23b6c9b94a5b5dc9$var$U.current.useState(a);
};
$23b6c9b94a5b5dc9$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $23b6c9b94a5b5dc9$var$U.current.useSyncExternalStore(a, b, e);
};
$23b6c9b94a5b5dc9$export$7b286972b8d8ccbf = function() {
    return $23b6c9b94a5b5dc9$var$U.current.useTransition();
};
$23b6c9b94a5b5dc9$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("lNe1g", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $fdd90c8cbe9e299b$export$ae55be85d98224ed; }, function (v) { return $fdd90c8cbe9e299b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $fdd90c8cbe9e299b$export$d39a5bbd09211389; }, function (v) { return $fdd90c8cbe9e299b$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $fdd90c8cbe9e299b$export$882461b6382ed46c; }, function (v) { return $fdd90c8cbe9e299b$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $fdd90c8cbe9e299b$export$466bfc07425424d5; }, function (v) { return $fdd90c8cbe9e299b$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $fdd90c8cbe9e299b$export$cd75ccfd720a3cd4; }, function (v) { return $fdd90c8cbe9e299b$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $fdd90c8cbe9e299b$export$fa8d919ba61d84db; }, function (v) { return $fdd90c8cbe9e299b$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $fdd90c8cbe9e299b$export$757ceba2d55c277e; }, function (v) { return $fdd90c8cbe9e299b$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $fdd90c8cbe9e299b$export$b3890eb0ae9dca99; }, function (v) { return $fdd90c8cbe9e299b$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $fdd90c8cbe9e299b$export$502457920280e6be; }, function (v) { return $fdd90c8cbe9e299b$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $fdd90c8cbe9e299b$export$c78a37762a8d58e1; }, function (v) { return $fdd90c8cbe9e299b$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $fdd90c8cbe9e299b$export$dc54d992c10e8a18; }, function (v) { return $fdd90c8cbe9e299b$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $fdd90c8cbe9e299b$export$83d89fbfd8236492; }, function (v) { return $fdd90c8cbe9e299b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $fdd90c8cbe9e299b$export$ae55be85d98224ed;
var $fdd90c8cbe9e299b$export$d39a5bbd09211389;
var $fdd90c8cbe9e299b$export$882461b6382ed46c;
var $fdd90c8cbe9e299b$export$466bfc07425424d5;
var $fdd90c8cbe9e299b$export$cd75ccfd720a3cd4;
var $fdd90c8cbe9e299b$export$fa8d919ba61d84db;
var $fdd90c8cbe9e299b$export$757ceba2d55c277e;
var $fdd90c8cbe9e299b$export$b3890eb0ae9dca99;
var $fdd90c8cbe9e299b$export$502457920280e6be;
var $fdd90c8cbe9e299b$export$c78a37762a8d58e1;
var $fdd90c8cbe9e299b$export$dc54d992c10e8a18;
var $fdd90c8cbe9e299b$export$83d89fbfd8236492;
"use strict";

var $9nZCP = parcelRequire("9nZCP");

var $3tsZj = parcelRequire("3tsZj");
function $fdd90c8cbe9e299b$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $fdd90c8cbe9e299b$var$da = new Set, $fdd90c8cbe9e299b$var$ea = {};
function $fdd90c8cbe9e299b$var$fa(a, b) {
    $fdd90c8cbe9e299b$var$ha(a, b);
    $fdd90c8cbe9e299b$var$ha(a + "Capture", b);
}
function $fdd90c8cbe9e299b$var$ha(a, b) {
    $fdd90c8cbe9e299b$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$fdd90c8cbe9e299b$var$da.add(b[a]);
}
var $fdd90c8cbe9e299b$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $fdd90c8cbe9e299b$var$ja = Object.prototype.hasOwnProperty, $fdd90c8cbe9e299b$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $fdd90c8cbe9e299b$var$la = {}, $fdd90c8cbe9e299b$var$ma = {};
function $fdd90c8cbe9e299b$var$oa(a) {
    if ($fdd90c8cbe9e299b$var$ja.call($fdd90c8cbe9e299b$var$ma, a)) return !0;
    if ($fdd90c8cbe9e299b$var$ja.call($fdd90c8cbe9e299b$var$la, a)) return !1;
    if ($fdd90c8cbe9e299b$var$ka.test(a)) return $fdd90c8cbe9e299b$var$ma[a] = !0;
    $fdd90c8cbe9e299b$var$la[a] = !0;
    return !1;
}
function $fdd90c8cbe9e299b$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $fdd90c8cbe9e299b$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $fdd90c8cbe9e299b$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $fdd90c8cbe9e299b$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $fdd90c8cbe9e299b$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $fdd90c8cbe9e299b$var$z[b] = new $fdd90c8cbe9e299b$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $fdd90c8cbe9e299b$var$ra = /[\-:]([a-z])/g;
function $fdd90c8cbe9e299b$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($fdd90c8cbe9e299b$var$ra, $fdd90c8cbe9e299b$var$sa);
    $fdd90c8cbe9e299b$var$z[b] = new $fdd90c8cbe9e299b$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($fdd90c8cbe9e299b$var$ra, $fdd90c8cbe9e299b$var$sa);
    $fdd90c8cbe9e299b$var$z[b] = new $fdd90c8cbe9e299b$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($fdd90c8cbe9e299b$var$ra, $fdd90c8cbe9e299b$var$sa);
    $fdd90c8cbe9e299b$var$z[b] = new $fdd90c8cbe9e299b$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$fdd90c8cbe9e299b$var$z.xlinkHref = new $fdd90c8cbe9e299b$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $fdd90c8cbe9e299b$var$ta(a, b, c, d) {
    var e = $fdd90c8cbe9e299b$var$z.hasOwnProperty(b) ? $fdd90c8cbe9e299b$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $fdd90c8cbe9e299b$var$qa(b, c, e, d) && (c = null), d || null === e ? $fdd90c8cbe9e299b$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $fdd90c8cbe9e299b$var$ua = $9nZCP.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $fdd90c8cbe9e299b$var$va = Symbol.for("react.element"), $fdd90c8cbe9e299b$var$wa = Symbol.for("react.portal"), $fdd90c8cbe9e299b$var$ya = Symbol.for("react.fragment"), $fdd90c8cbe9e299b$var$za = Symbol.for("react.strict_mode"), $fdd90c8cbe9e299b$var$Aa = Symbol.for("react.profiler"), $fdd90c8cbe9e299b$var$Ba = Symbol.for("react.provider"), $fdd90c8cbe9e299b$var$Ca = Symbol.for("react.context"), $fdd90c8cbe9e299b$var$Da = Symbol.for("react.forward_ref"), $fdd90c8cbe9e299b$var$Ea = Symbol.for("react.suspense"), $fdd90c8cbe9e299b$var$Fa = Symbol.for("react.suspense_list"), $fdd90c8cbe9e299b$var$Ga = Symbol.for("react.memo"), $fdd90c8cbe9e299b$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $fdd90c8cbe9e299b$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $fdd90c8cbe9e299b$var$Ja = Symbol.iterator;
function $fdd90c8cbe9e299b$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $fdd90c8cbe9e299b$var$Ja && a[$fdd90c8cbe9e299b$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $fdd90c8cbe9e299b$var$A = Object.assign, $fdd90c8cbe9e299b$var$La;
function $fdd90c8cbe9e299b$var$Ma(a) {
    if (void 0 === $fdd90c8cbe9e299b$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $fdd90c8cbe9e299b$var$La = b && b[1] || "";
    }
    return "\n" + $fdd90c8cbe9e299b$var$La + a;
}
var $fdd90c8cbe9e299b$var$Na = !1;
function $fdd90c8cbe9e299b$var$Oa(a, b) {
    if (!a || $fdd90c8cbe9e299b$var$Na) return "";
    $fdd90c8cbe9e299b$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $fdd90c8cbe9e299b$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $fdd90c8cbe9e299b$var$Ma(a) : "";
}
function $fdd90c8cbe9e299b$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $fdd90c8cbe9e299b$var$Ma(a.type);
        case 16:
            return $fdd90c8cbe9e299b$var$Ma("Lazy");
        case 13:
            return $fdd90c8cbe9e299b$var$Ma("Suspense");
        case 19:
            return $fdd90c8cbe9e299b$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $fdd90c8cbe9e299b$var$Oa(a.type, !1), a;
        case 11:
            return a = $fdd90c8cbe9e299b$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $fdd90c8cbe9e299b$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $fdd90c8cbe9e299b$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $fdd90c8cbe9e299b$var$ya:
            return "Fragment";
        case $fdd90c8cbe9e299b$var$wa:
            return "Portal";
        case $fdd90c8cbe9e299b$var$Aa:
            return "Profiler";
        case $fdd90c8cbe9e299b$var$za:
            return "StrictMode";
        case $fdd90c8cbe9e299b$var$Ea:
            return "Suspense";
        case $fdd90c8cbe9e299b$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $fdd90c8cbe9e299b$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $fdd90c8cbe9e299b$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $fdd90c8cbe9e299b$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $fdd90c8cbe9e299b$var$Ga:
            return b = a.displayName || null, null !== b ? b : $fdd90c8cbe9e299b$var$Qa(a.type) || "Memo";
        case $fdd90c8cbe9e299b$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $fdd90c8cbe9e299b$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $fdd90c8cbe9e299b$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $fdd90c8cbe9e299b$var$Qa(b);
        case 8:
            return b === $fdd90c8cbe9e299b$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $fdd90c8cbe9e299b$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $fdd90c8cbe9e299b$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $fdd90c8cbe9e299b$var$Ua(a) {
    var b = $fdd90c8cbe9e299b$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $fdd90c8cbe9e299b$var$Va(a) {
    a._valueTracker || (a._valueTracker = $fdd90c8cbe9e299b$var$Ua(a));
}
function $fdd90c8cbe9e299b$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $fdd90c8cbe9e299b$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $fdd90c8cbe9e299b$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $fdd90c8cbe9e299b$var$Ya(a, b) {
    var c = b.checked;
    return $fdd90c8cbe9e299b$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $fdd90c8cbe9e299b$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $fdd90c8cbe9e299b$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $fdd90c8cbe9e299b$var$ab(a, b) {
    b = b.checked;
    null != b && $fdd90c8cbe9e299b$var$ta(a, "checked", b, !1);
}
function $fdd90c8cbe9e299b$var$bb(a, b) {
    $fdd90c8cbe9e299b$var$ab(a, b);
    var c = $fdd90c8cbe9e299b$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $fdd90c8cbe9e299b$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $fdd90c8cbe9e299b$var$cb(a, b.type, $fdd90c8cbe9e299b$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $fdd90c8cbe9e299b$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $fdd90c8cbe9e299b$var$cb(a, b, c) {
    if ("number" !== b || $fdd90c8cbe9e299b$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $fdd90c8cbe9e299b$var$eb = Array.isArray;
function $fdd90c8cbe9e299b$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $fdd90c8cbe9e299b$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $fdd90c8cbe9e299b$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($fdd90c8cbe9e299b$var$p(91));
    return $fdd90c8cbe9e299b$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $fdd90c8cbe9e299b$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($fdd90c8cbe9e299b$var$p(92));
            if ($fdd90c8cbe9e299b$var$eb(c)) {
                if (1 < c.length) throw Error($fdd90c8cbe9e299b$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $fdd90c8cbe9e299b$var$Sa(c)
    };
}
function $fdd90c8cbe9e299b$var$ib(a, b) {
    var c = $fdd90c8cbe9e299b$var$Sa(b.value), d = $fdd90c8cbe9e299b$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $fdd90c8cbe9e299b$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $fdd90c8cbe9e299b$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $fdd90c8cbe9e299b$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $fdd90c8cbe9e299b$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $fdd90c8cbe9e299b$var$mb, $fdd90c8cbe9e299b$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $fdd90c8cbe9e299b$var$mb = $fdd90c8cbe9e299b$var$mb || document.createElement("div");
        $fdd90c8cbe9e299b$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $fdd90c8cbe9e299b$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $fdd90c8cbe9e299b$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $fdd90c8cbe9e299b$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $fdd90c8cbe9e299b$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($fdd90c8cbe9e299b$var$pb).forEach(function(a) {
    $fdd90c8cbe9e299b$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $fdd90c8cbe9e299b$var$pb[b] = $fdd90c8cbe9e299b$var$pb[a];
    });
});
function $fdd90c8cbe9e299b$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $fdd90c8cbe9e299b$var$pb.hasOwnProperty(a) && $fdd90c8cbe9e299b$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $fdd90c8cbe9e299b$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $fdd90c8cbe9e299b$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $fdd90c8cbe9e299b$var$tb = $fdd90c8cbe9e299b$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $fdd90c8cbe9e299b$var$ub(a, b) {
    if (b) {
        if ($fdd90c8cbe9e299b$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($fdd90c8cbe9e299b$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($fdd90c8cbe9e299b$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($fdd90c8cbe9e299b$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($fdd90c8cbe9e299b$var$p(62));
    }
}
function $fdd90c8cbe9e299b$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $fdd90c8cbe9e299b$var$wb = null;
function $fdd90c8cbe9e299b$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $fdd90c8cbe9e299b$var$yb = null, $fdd90c8cbe9e299b$var$zb = null, $fdd90c8cbe9e299b$var$Ab = null;
function $fdd90c8cbe9e299b$var$Bb(a) {
    if (a = $fdd90c8cbe9e299b$var$Cb(a)) {
        if ("function" !== typeof $fdd90c8cbe9e299b$var$yb) throw Error($fdd90c8cbe9e299b$var$p(280));
        var b = a.stateNode;
        b && (b = $fdd90c8cbe9e299b$var$Db(b), $fdd90c8cbe9e299b$var$yb(a.stateNode, a.type, b));
    }
}
function $fdd90c8cbe9e299b$var$Eb(a) {
    $fdd90c8cbe9e299b$var$zb ? $fdd90c8cbe9e299b$var$Ab ? $fdd90c8cbe9e299b$var$Ab.push(a) : $fdd90c8cbe9e299b$var$Ab = [
        a
    ] : $fdd90c8cbe9e299b$var$zb = a;
}
function $fdd90c8cbe9e299b$var$Fb() {
    if ($fdd90c8cbe9e299b$var$zb) {
        var a = $fdd90c8cbe9e299b$var$zb, b = $fdd90c8cbe9e299b$var$Ab;
        $fdd90c8cbe9e299b$var$Ab = $fdd90c8cbe9e299b$var$zb = null;
        $fdd90c8cbe9e299b$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$fdd90c8cbe9e299b$var$Bb(b[a]);
    }
}
function $fdd90c8cbe9e299b$var$Gb(a, b) {
    return a(b);
}
function $fdd90c8cbe9e299b$var$Hb() {}
var $fdd90c8cbe9e299b$var$Ib = !1;
function $fdd90c8cbe9e299b$var$Jb(a, b, c) {
    if ($fdd90c8cbe9e299b$var$Ib) return a(b, c);
    $fdd90c8cbe9e299b$var$Ib = !0;
    try {
        return $fdd90c8cbe9e299b$var$Gb(a, b, c);
    } finally{
        if ($fdd90c8cbe9e299b$var$Ib = !1, null !== $fdd90c8cbe9e299b$var$zb || null !== $fdd90c8cbe9e299b$var$Ab) $fdd90c8cbe9e299b$var$Hb(), $fdd90c8cbe9e299b$var$Fb();
    }
}
function $fdd90c8cbe9e299b$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $fdd90c8cbe9e299b$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($fdd90c8cbe9e299b$var$p(231, b, typeof c));
    return c;
}
var $fdd90c8cbe9e299b$var$Lb = !1;
if ($fdd90c8cbe9e299b$var$ia) try {
    var $fdd90c8cbe9e299b$var$Mb = {};
    Object.defineProperty($fdd90c8cbe9e299b$var$Mb, "passive", {
        get: function() {
            $fdd90c8cbe9e299b$var$Lb = !0;
        }
    });
    window.addEventListener("test", $fdd90c8cbe9e299b$var$Mb, $fdd90c8cbe9e299b$var$Mb);
    window.removeEventListener("test", $fdd90c8cbe9e299b$var$Mb, $fdd90c8cbe9e299b$var$Mb);
} catch (a) {
    $fdd90c8cbe9e299b$var$Lb = !1;
}
function $fdd90c8cbe9e299b$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $fdd90c8cbe9e299b$var$Ob = !1, $fdd90c8cbe9e299b$var$Pb = null, $fdd90c8cbe9e299b$var$Qb = !1, $fdd90c8cbe9e299b$var$Rb = null, $fdd90c8cbe9e299b$var$Sb = {
    onError: function(a) {
        $fdd90c8cbe9e299b$var$Ob = !0;
        $fdd90c8cbe9e299b$var$Pb = a;
    }
};
function $fdd90c8cbe9e299b$var$Tb(a, b, c, d, e, f, g, h, k) {
    $fdd90c8cbe9e299b$var$Ob = !1;
    $fdd90c8cbe9e299b$var$Pb = null;
    $fdd90c8cbe9e299b$var$Nb.apply($fdd90c8cbe9e299b$var$Sb, arguments);
}
function $fdd90c8cbe9e299b$var$Ub(a, b, c, d, e, f, g, h, k) {
    $fdd90c8cbe9e299b$var$Tb.apply(this, arguments);
    if ($fdd90c8cbe9e299b$var$Ob) {
        if ($fdd90c8cbe9e299b$var$Ob) {
            var l = $fdd90c8cbe9e299b$var$Pb;
            $fdd90c8cbe9e299b$var$Ob = !1;
            $fdd90c8cbe9e299b$var$Pb = null;
        } else throw Error($fdd90c8cbe9e299b$var$p(198));
        $fdd90c8cbe9e299b$var$Qb || ($fdd90c8cbe9e299b$var$Qb = !0, $fdd90c8cbe9e299b$var$Rb = l);
    }
}
function $fdd90c8cbe9e299b$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $fdd90c8cbe9e299b$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $fdd90c8cbe9e299b$var$Xb(a) {
    if ($fdd90c8cbe9e299b$var$Vb(a) !== a) throw Error($fdd90c8cbe9e299b$var$p(188));
}
function $fdd90c8cbe9e299b$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $fdd90c8cbe9e299b$var$Vb(a);
        if (null === b) throw Error($fdd90c8cbe9e299b$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $fdd90c8cbe9e299b$var$Xb(e), a;
                if (f === d) return $fdd90c8cbe9e299b$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($fdd90c8cbe9e299b$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($fdd90c8cbe9e299b$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($fdd90c8cbe9e299b$var$p(190));
    }
    if (3 !== c.tag) throw Error($fdd90c8cbe9e299b$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $fdd90c8cbe9e299b$var$Zb(a) {
    a = $fdd90c8cbe9e299b$var$Yb(a);
    return null !== a ? $fdd90c8cbe9e299b$var$$b(a) : null;
}
function $fdd90c8cbe9e299b$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $fdd90c8cbe9e299b$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $fdd90c8cbe9e299b$var$ac = $3tsZj.unstable_scheduleCallback, $fdd90c8cbe9e299b$var$bc = $3tsZj.unstable_cancelCallback, $fdd90c8cbe9e299b$var$cc = $3tsZj.unstable_shouldYield, $fdd90c8cbe9e299b$var$dc = $3tsZj.unstable_requestPaint, $fdd90c8cbe9e299b$var$B = $3tsZj.unstable_now, $fdd90c8cbe9e299b$var$ec = $3tsZj.unstable_getCurrentPriorityLevel, $fdd90c8cbe9e299b$var$fc = $3tsZj.unstable_ImmediatePriority, $fdd90c8cbe9e299b$var$gc = $3tsZj.unstable_UserBlockingPriority, $fdd90c8cbe9e299b$var$hc = $3tsZj.unstable_NormalPriority, $fdd90c8cbe9e299b$var$ic = $3tsZj.unstable_LowPriority, $fdd90c8cbe9e299b$var$jc = $3tsZj.unstable_IdlePriority, $fdd90c8cbe9e299b$var$kc = null, $fdd90c8cbe9e299b$var$lc = null;
function $fdd90c8cbe9e299b$var$mc(a) {
    if ($fdd90c8cbe9e299b$var$lc && "function" === typeof $fdd90c8cbe9e299b$var$lc.onCommitFiberRoot) try {
        $fdd90c8cbe9e299b$var$lc.onCommitFiberRoot($fdd90c8cbe9e299b$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $fdd90c8cbe9e299b$var$oc = Math.clz32 ? Math.clz32 : $fdd90c8cbe9e299b$var$nc, $fdd90c8cbe9e299b$var$pc = Math.log, $fdd90c8cbe9e299b$var$qc = Math.LN2;
function $fdd90c8cbe9e299b$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($fdd90c8cbe9e299b$var$pc(a) / $fdd90c8cbe9e299b$var$qc | 0) | 0;
}
var $fdd90c8cbe9e299b$var$rc = 64, $fdd90c8cbe9e299b$var$sc = 4194304;
function $fdd90c8cbe9e299b$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $fdd90c8cbe9e299b$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $fdd90c8cbe9e299b$var$tc(h) : (f &= g, 0 !== f && (d = $fdd90c8cbe9e299b$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $fdd90c8cbe9e299b$var$tc(g) : 0 !== f && (d = $fdd90c8cbe9e299b$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $fdd90c8cbe9e299b$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $fdd90c8cbe9e299b$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $fdd90c8cbe9e299b$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $fdd90c8cbe9e299b$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $fdd90c8cbe9e299b$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $fdd90c8cbe9e299b$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $fdd90c8cbe9e299b$var$yc() {
    var a = $fdd90c8cbe9e299b$var$rc;
    $fdd90c8cbe9e299b$var$rc <<= 1;
    0 === ($fdd90c8cbe9e299b$var$rc & 4194240) && ($fdd90c8cbe9e299b$var$rc = 64);
    return a;
}
function $fdd90c8cbe9e299b$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $fdd90c8cbe9e299b$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $fdd90c8cbe9e299b$var$oc(b);
    a[b] = c;
}
function $fdd90c8cbe9e299b$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $fdd90c8cbe9e299b$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $fdd90c8cbe9e299b$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $fdd90c8cbe9e299b$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $fdd90c8cbe9e299b$var$C = 0;
function $fdd90c8cbe9e299b$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $fdd90c8cbe9e299b$var$Ec, $fdd90c8cbe9e299b$var$Fc, $fdd90c8cbe9e299b$var$Gc, $fdd90c8cbe9e299b$var$Hc, $fdd90c8cbe9e299b$var$Ic, $fdd90c8cbe9e299b$var$Jc = !1, $fdd90c8cbe9e299b$var$Kc = [], $fdd90c8cbe9e299b$var$Lc = null, $fdd90c8cbe9e299b$var$Mc = null, $fdd90c8cbe9e299b$var$Nc = null, $fdd90c8cbe9e299b$var$Oc = new Map, $fdd90c8cbe9e299b$var$Pc = new Map, $fdd90c8cbe9e299b$var$Qc = [], $fdd90c8cbe9e299b$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $fdd90c8cbe9e299b$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $fdd90c8cbe9e299b$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $fdd90c8cbe9e299b$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $fdd90c8cbe9e299b$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $fdd90c8cbe9e299b$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $fdd90c8cbe9e299b$var$Pc.delete(b.pointerId);
    }
}
function $fdd90c8cbe9e299b$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $fdd90c8cbe9e299b$var$Cb(b), null !== b && $fdd90c8cbe9e299b$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $fdd90c8cbe9e299b$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $fdd90c8cbe9e299b$var$Lc = $fdd90c8cbe9e299b$var$Tc($fdd90c8cbe9e299b$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $fdd90c8cbe9e299b$var$Mc = $fdd90c8cbe9e299b$var$Tc($fdd90c8cbe9e299b$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $fdd90c8cbe9e299b$var$Nc = $fdd90c8cbe9e299b$var$Tc($fdd90c8cbe9e299b$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $fdd90c8cbe9e299b$var$Oc.set(f, $fdd90c8cbe9e299b$var$Tc($fdd90c8cbe9e299b$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $fdd90c8cbe9e299b$var$Pc.set(f, $fdd90c8cbe9e299b$var$Tc($fdd90c8cbe9e299b$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $fdd90c8cbe9e299b$var$Vc(a) {
    var b = $fdd90c8cbe9e299b$var$Wc(a.target);
    if (null !== b) {
        var c = $fdd90c8cbe9e299b$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $fdd90c8cbe9e299b$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $fdd90c8cbe9e299b$var$Ic(a.priority, function() {
                        $fdd90c8cbe9e299b$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $fdd90c8cbe9e299b$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $fdd90c8cbe9e299b$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $fdd90c8cbe9e299b$var$wb = d;
            c.target.dispatchEvent(d);
            $fdd90c8cbe9e299b$var$wb = null;
        } else return b = $fdd90c8cbe9e299b$var$Cb(c), null !== b && $fdd90c8cbe9e299b$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $fdd90c8cbe9e299b$var$Zc(a, b, c) {
    $fdd90c8cbe9e299b$var$Xc(a) && c.delete(b);
}
function $fdd90c8cbe9e299b$var$$c() {
    $fdd90c8cbe9e299b$var$Jc = !1;
    null !== $fdd90c8cbe9e299b$var$Lc && $fdd90c8cbe9e299b$var$Xc($fdd90c8cbe9e299b$var$Lc) && ($fdd90c8cbe9e299b$var$Lc = null);
    null !== $fdd90c8cbe9e299b$var$Mc && $fdd90c8cbe9e299b$var$Xc($fdd90c8cbe9e299b$var$Mc) && ($fdd90c8cbe9e299b$var$Mc = null);
    null !== $fdd90c8cbe9e299b$var$Nc && $fdd90c8cbe9e299b$var$Xc($fdd90c8cbe9e299b$var$Nc) && ($fdd90c8cbe9e299b$var$Nc = null);
    $fdd90c8cbe9e299b$var$Oc.forEach($fdd90c8cbe9e299b$var$Zc);
    $fdd90c8cbe9e299b$var$Pc.forEach($fdd90c8cbe9e299b$var$Zc);
}
function $fdd90c8cbe9e299b$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $fdd90c8cbe9e299b$var$Jc || ($fdd90c8cbe9e299b$var$Jc = !0, $3tsZj.unstable_scheduleCallback($3tsZj.unstable_NormalPriority, $fdd90c8cbe9e299b$var$$c)));
}
function $fdd90c8cbe9e299b$var$bd(a) {
    function b(b) {
        return $fdd90c8cbe9e299b$var$ad(b, a);
    }
    if (0 < $fdd90c8cbe9e299b$var$Kc.length) {
        $fdd90c8cbe9e299b$var$ad($fdd90c8cbe9e299b$var$Kc[0], a);
        for(var c = 1; c < $fdd90c8cbe9e299b$var$Kc.length; c++){
            var d = $fdd90c8cbe9e299b$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $fdd90c8cbe9e299b$var$Lc && $fdd90c8cbe9e299b$var$ad($fdd90c8cbe9e299b$var$Lc, a);
    null !== $fdd90c8cbe9e299b$var$Mc && $fdd90c8cbe9e299b$var$ad($fdd90c8cbe9e299b$var$Mc, a);
    null !== $fdd90c8cbe9e299b$var$Nc && $fdd90c8cbe9e299b$var$ad($fdd90c8cbe9e299b$var$Nc, a);
    $fdd90c8cbe9e299b$var$Oc.forEach(b);
    $fdd90c8cbe9e299b$var$Pc.forEach(b);
    for(c = 0; c < $fdd90c8cbe9e299b$var$Qc.length; c++)d = $fdd90c8cbe9e299b$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $fdd90c8cbe9e299b$var$Qc.length && (c = $fdd90c8cbe9e299b$var$Qc[0], null === c.blockedOn);)$fdd90c8cbe9e299b$var$Vc(c), null === c.blockedOn && $fdd90c8cbe9e299b$var$Qc.shift();
}
var $fdd90c8cbe9e299b$var$cd = $fdd90c8cbe9e299b$var$ua.ReactCurrentBatchConfig, $fdd90c8cbe9e299b$var$dd = !0;
function $fdd90c8cbe9e299b$var$ed(a, b, c, d) {
    var e = $fdd90c8cbe9e299b$var$C, f = $fdd90c8cbe9e299b$var$cd.transition;
    $fdd90c8cbe9e299b$var$cd.transition = null;
    try {
        $fdd90c8cbe9e299b$var$C = 1, $fdd90c8cbe9e299b$var$fd(a, b, c, d);
    } finally{
        $fdd90c8cbe9e299b$var$C = e, $fdd90c8cbe9e299b$var$cd.transition = f;
    }
}
function $fdd90c8cbe9e299b$var$gd(a, b, c, d) {
    var e = $fdd90c8cbe9e299b$var$C, f = $fdd90c8cbe9e299b$var$cd.transition;
    $fdd90c8cbe9e299b$var$cd.transition = null;
    try {
        $fdd90c8cbe9e299b$var$C = 4, $fdd90c8cbe9e299b$var$fd(a, b, c, d);
    } finally{
        $fdd90c8cbe9e299b$var$C = e, $fdd90c8cbe9e299b$var$cd.transition = f;
    }
}
function $fdd90c8cbe9e299b$var$fd(a, b, c, d) {
    if ($fdd90c8cbe9e299b$var$dd) {
        var e = $fdd90c8cbe9e299b$var$Yc(a, b, c, d);
        if (null === e) $fdd90c8cbe9e299b$var$hd(a, b, d, $fdd90c8cbe9e299b$var$id, c), $fdd90c8cbe9e299b$var$Sc(a, d);
        else if ($fdd90c8cbe9e299b$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($fdd90c8cbe9e299b$var$Sc(a, d), b & 4 && -1 < $fdd90c8cbe9e299b$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $fdd90c8cbe9e299b$var$Cb(e);
                null !== f && $fdd90c8cbe9e299b$var$Ec(f);
                f = $fdd90c8cbe9e299b$var$Yc(a, b, c, d);
                null === f && $fdd90c8cbe9e299b$var$hd(a, b, d, $fdd90c8cbe9e299b$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $fdd90c8cbe9e299b$var$hd(a, b, d, null, c);
    }
}
var $fdd90c8cbe9e299b$var$id = null;
function $fdd90c8cbe9e299b$var$Yc(a, b, c, d) {
    $fdd90c8cbe9e299b$var$id = null;
    a = $fdd90c8cbe9e299b$var$xb(d);
    a = $fdd90c8cbe9e299b$var$Wc(a);
    if (null !== a) {
        if (b = $fdd90c8cbe9e299b$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $fdd90c8cbe9e299b$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $fdd90c8cbe9e299b$var$id = a;
    return null;
}
function $fdd90c8cbe9e299b$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($fdd90c8cbe9e299b$var$ec()){
                case $fdd90c8cbe9e299b$var$fc:
                    return 1;
                case $fdd90c8cbe9e299b$var$gc:
                    return 4;
                case $fdd90c8cbe9e299b$var$hc:
                case $fdd90c8cbe9e299b$var$ic:
                    return 16;
                case $fdd90c8cbe9e299b$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $fdd90c8cbe9e299b$var$kd = null, $fdd90c8cbe9e299b$var$ld = null, $fdd90c8cbe9e299b$var$md = null;
function $fdd90c8cbe9e299b$var$nd() {
    if ($fdd90c8cbe9e299b$var$md) return $fdd90c8cbe9e299b$var$md;
    var a, b = $fdd90c8cbe9e299b$var$ld, c = b.length, d, e = "value" in $fdd90c8cbe9e299b$var$kd ? $fdd90c8cbe9e299b$var$kd.value : $fdd90c8cbe9e299b$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $fdd90c8cbe9e299b$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $fdd90c8cbe9e299b$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $fdd90c8cbe9e299b$var$pd() {
    return !0;
}
function $fdd90c8cbe9e299b$var$qd() {
    return !1;
}
function $fdd90c8cbe9e299b$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $fdd90c8cbe9e299b$var$pd : $fdd90c8cbe9e299b$var$qd;
        this.isPropagationStopped = $fdd90c8cbe9e299b$var$qd;
        return this;
    }
    $fdd90c8cbe9e299b$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $fdd90c8cbe9e299b$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $fdd90c8cbe9e299b$var$pd);
        },
        persist: function() {},
        isPersistent: $fdd90c8cbe9e299b$var$pd
    });
    return b;
}
var $fdd90c8cbe9e299b$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $fdd90c8cbe9e299b$var$td = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$sd), $fdd90c8cbe9e299b$var$ud = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$sd, {
    view: 0,
    detail: 0
}), $fdd90c8cbe9e299b$var$vd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$ud), $fdd90c8cbe9e299b$var$wd, $fdd90c8cbe9e299b$var$xd, $fdd90c8cbe9e299b$var$yd, $fdd90c8cbe9e299b$var$Ad = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $fdd90c8cbe9e299b$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $fdd90c8cbe9e299b$var$yd && ($fdd90c8cbe9e299b$var$yd && "mousemove" === a.type ? ($fdd90c8cbe9e299b$var$wd = a.screenX - $fdd90c8cbe9e299b$var$yd.screenX, $fdd90c8cbe9e299b$var$xd = a.screenY - $fdd90c8cbe9e299b$var$yd.screenY) : $fdd90c8cbe9e299b$var$xd = $fdd90c8cbe9e299b$var$wd = 0, $fdd90c8cbe9e299b$var$yd = a);
        return $fdd90c8cbe9e299b$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $fdd90c8cbe9e299b$var$xd;
    }
}), $fdd90c8cbe9e299b$var$Bd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Ad), $fdd90c8cbe9e299b$var$Cd = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$Ad, {
    dataTransfer: 0
}), $fdd90c8cbe9e299b$var$Dd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Cd), $fdd90c8cbe9e299b$var$Ed = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$ud, {
    relatedTarget: 0
}), $fdd90c8cbe9e299b$var$Fd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Ed), $fdd90c8cbe9e299b$var$Gd = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fdd90c8cbe9e299b$var$Hd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Gd), $fdd90c8cbe9e299b$var$Id = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $fdd90c8cbe9e299b$var$Jd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Id), $fdd90c8cbe9e299b$var$Kd = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$sd, {
    data: 0
}), $fdd90c8cbe9e299b$var$Ld = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Kd), $fdd90c8cbe9e299b$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $fdd90c8cbe9e299b$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $fdd90c8cbe9e299b$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $fdd90c8cbe9e299b$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $fdd90c8cbe9e299b$var$Od[a]) ? !!b[a] : !1;
}
function $fdd90c8cbe9e299b$var$zd() {
    return $fdd90c8cbe9e299b$var$Pd;
}
var $fdd90c8cbe9e299b$var$Qd = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $fdd90c8cbe9e299b$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $fdd90c8cbe9e299b$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $fdd90c8cbe9e299b$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $fdd90c8cbe9e299b$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $fdd90c8cbe9e299b$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $fdd90c8cbe9e299b$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $fdd90c8cbe9e299b$var$Rd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Qd), $fdd90c8cbe9e299b$var$Sd = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $fdd90c8cbe9e299b$var$Td = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Sd), $fdd90c8cbe9e299b$var$Ud = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $fdd90c8cbe9e299b$var$zd
}), $fdd90c8cbe9e299b$var$Vd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Ud), $fdd90c8cbe9e299b$var$Wd = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fdd90c8cbe9e299b$var$Xd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Wd), $fdd90c8cbe9e299b$var$Yd = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $fdd90c8cbe9e299b$var$Zd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Yd), $fdd90c8cbe9e299b$var$$d = [
    9,
    13,
    27,
    32
], $fdd90c8cbe9e299b$var$ae = $fdd90c8cbe9e299b$var$ia && "CompositionEvent" in window, $fdd90c8cbe9e299b$var$be = null;
$fdd90c8cbe9e299b$var$ia && "documentMode" in document && ($fdd90c8cbe9e299b$var$be = document.documentMode);
var $fdd90c8cbe9e299b$var$ce = $fdd90c8cbe9e299b$var$ia && "TextEvent" in window && !$fdd90c8cbe9e299b$var$be, $fdd90c8cbe9e299b$var$de = $fdd90c8cbe9e299b$var$ia && (!$fdd90c8cbe9e299b$var$ae || $fdd90c8cbe9e299b$var$be && 8 < $fdd90c8cbe9e299b$var$be && 11 >= $fdd90c8cbe9e299b$var$be), $fdd90c8cbe9e299b$var$ee = String.fromCharCode(32), $fdd90c8cbe9e299b$var$fe = !1;
function $fdd90c8cbe9e299b$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $fdd90c8cbe9e299b$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $fdd90c8cbe9e299b$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $fdd90c8cbe9e299b$var$ie = !1;
function $fdd90c8cbe9e299b$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $fdd90c8cbe9e299b$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $fdd90c8cbe9e299b$var$fe = !0;
            return $fdd90c8cbe9e299b$var$ee;
        case "textInput":
            return a = b.data, a === $fdd90c8cbe9e299b$var$ee && $fdd90c8cbe9e299b$var$fe ? null : a;
        default:
            return null;
    }
}
function $fdd90c8cbe9e299b$var$ke(a, b) {
    if ($fdd90c8cbe9e299b$var$ie) return "compositionend" === a || !$fdd90c8cbe9e299b$var$ae && $fdd90c8cbe9e299b$var$ge(a, b) ? (a = $fdd90c8cbe9e299b$var$nd(), $fdd90c8cbe9e299b$var$md = $fdd90c8cbe9e299b$var$ld = $fdd90c8cbe9e299b$var$kd = null, $fdd90c8cbe9e299b$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $fdd90c8cbe9e299b$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $fdd90c8cbe9e299b$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $fdd90c8cbe9e299b$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$fdd90c8cbe9e299b$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $fdd90c8cbe9e299b$var$ne(a, b, c, d) {
    $fdd90c8cbe9e299b$var$Eb(d);
    b = $fdd90c8cbe9e299b$var$oe(b, "onChange");
    0 < b.length && (c = new $fdd90c8cbe9e299b$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $fdd90c8cbe9e299b$var$pe = null, $fdd90c8cbe9e299b$var$qe = null;
function $fdd90c8cbe9e299b$var$re(a) {
    $fdd90c8cbe9e299b$var$se(a, 0);
}
function $fdd90c8cbe9e299b$var$te(a) {
    var b = $fdd90c8cbe9e299b$var$ue(a);
    if ($fdd90c8cbe9e299b$var$Wa(b)) return a;
}
function $fdd90c8cbe9e299b$var$ve(a, b) {
    if ("change" === a) return b;
}
var $fdd90c8cbe9e299b$var$we = !1;
if ($fdd90c8cbe9e299b$var$ia) {
    var $fdd90c8cbe9e299b$var$xe;
    if ($fdd90c8cbe9e299b$var$ia) {
        var $fdd90c8cbe9e299b$var$ye = "oninput" in document;
        if (!$fdd90c8cbe9e299b$var$ye) {
            var $fdd90c8cbe9e299b$var$ze = document.createElement("div");
            $fdd90c8cbe9e299b$var$ze.setAttribute("oninput", "return;");
            $fdd90c8cbe9e299b$var$ye = "function" === typeof $fdd90c8cbe9e299b$var$ze.oninput;
        }
        $fdd90c8cbe9e299b$var$xe = $fdd90c8cbe9e299b$var$ye;
    } else $fdd90c8cbe9e299b$var$xe = !1;
    $fdd90c8cbe9e299b$var$we = $fdd90c8cbe9e299b$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $fdd90c8cbe9e299b$var$Ae() {
    $fdd90c8cbe9e299b$var$pe && ($fdd90c8cbe9e299b$var$pe.detachEvent("onpropertychange", $fdd90c8cbe9e299b$var$Be), $fdd90c8cbe9e299b$var$qe = $fdd90c8cbe9e299b$var$pe = null);
}
function $fdd90c8cbe9e299b$var$Be(a) {
    if ("value" === a.propertyName && $fdd90c8cbe9e299b$var$te($fdd90c8cbe9e299b$var$qe)) {
        var b = [];
        $fdd90c8cbe9e299b$var$ne(b, $fdd90c8cbe9e299b$var$qe, a, $fdd90c8cbe9e299b$var$xb(a));
        $fdd90c8cbe9e299b$var$Jb($fdd90c8cbe9e299b$var$re, b);
    }
}
function $fdd90c8cbe9e299b$var$Ce(a, b, c) {
    "focusin" === a ? ($fdd90c8cbe9e299b$var$Ae(), $fdd90c8cbe9e299b$var$pe = b, $fdd90c8cbe9e299b$var$qe = c, $fdd90c8cbe9e299b$var$pe.attachEvent("onpropertychange", $fdd90c8cbe9e299b$var$Be)) : "focusout" === a && $fdd90c8cbe9e299b$var$Ae();
}
function $fdd90c8cbe9e299b$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $fdd90c8cbe9e299b$var$te($fdd90c8cbe9e299b$var$qe);
}
function $fdd90c8cbe9e299b$var$Ee(a, b) {
    if ("click" === a) return $fdd90c8cbe9e299b$var$te(b);
}
function $fdd90c8cbe9e299b$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $fdd90c8cbe9e299b$var$te(b);
}
function $fdd90c8cbe9e299b$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $fdd90c8cbe9e299b$var$He = "function" === typeof Object.is ? Object.is : $fdd90c8cbe9e299b$var$Ge;
function $fdd90c8cbe9e299b$var$Ie(a, b) {
    if ($fdd90c8cbe9e299b$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$fdd90c8cbe9e299b$var$ja.call(b, e) || !$fdd90c8cbe9e299b$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $fdd90c8cbe9e299b$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $fdd90c8cbe9e299b$var$Ke(a, b) {
    var c = $fdd90c8cbe9e299b$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $fdd90c8cbe9e299b$var$Je(c);
    }
}
function $fdd90c8cbe9e299b$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $fdd90c8cbe9e299b$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $fdd90c8cbe9e299b$var$Me() {
    for(var a = window, b = $fdd90c8cbe9e299b$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $fdd90c8cbe9e299b$var$Xa(a.document);
    }
    return b;
}
function $fdd90c8cbe9e299b$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $fdd90c8cbe9e299b$var$Oe(a) {
    var b = $fdd90c8cbe9e299b$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $fdd90c8cbe9e299b$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $fdd90c8cbe9e299b$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $fdd90c8cbe9e299b$var$Ke(c, f);
                var g = $fdd90c8cbe9e299b$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $fdd90c8cbe9e299b$var$Pe = $fdd90c8cbe9e299b$var$ia && "documentMode" in document && 11 >= document.documentMode, $fdd90c8cbe9e299b$var$Qe = null, $fdd90c8cbe9e299b$var$Re = null, $fdd90c8cbe9e299b$var$Se = null, $fdd90c8cbe9e299b$var$Te = !1;
function $fdd90c8cbe9e299b$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $fdd90c8cbe9e299b$var$Te || null == $fdd90c8cbe9e299b$var$Qe || $fdd90c8cbe9e299b$var$Qe !== $fdd90c8cbe9e299b$var$Xa(d) || (d = $fdd90c8cbe9e299b$var$Qe, "selectionStart" in d && $fdd90c8cbe9e299b$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $fdd90c8cbe9e299b$var$Se && $fdd90c8cbe9e299b$var$Ie($fdd90c8cbe9e299b$var$Se, d) || ($fdd90c8cbe9e299b$var$Se = d, d = $fdd90c8cbe9e299b$var$oe($fdd90c8cbe9e299b$var$Re, "onSelect"), 0 < d.length && (b = new $fdd90c8cbe9e299b$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $fdd90c8cbe9e299b$var$Qe)));
}
function $fdd90c8cbe9e299b$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $fdd90c8cbe9e299b$var$We = {
    animationend: $fdd90c8cbe9e299b$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $fdd90c8cbe9e299b$var$Ve("Animation", "AnimationIteration"),
    animationstart: $fdd90c8cbe9e299b$var$Ve("Animation", "AnimationStart"),
    transitionend: $fdd90c8cbe9e299b$var$Ve("Transition", "TransitionEnd")
}, $fdd90c8cbe9e299b$var$Xe = {}, $fdd90c8cbe9e299b$var$Ye = {};
$fdd90c8cbe9e299b$var$ia && ($fdd90c8cbe9e299b$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $fdd90c8cbe9e299b$var$We.animationend.animation, delete $fdd90c8cbe9e299b$var$We.animationiteration.animation, delete $fdd90c8cbe9e299b$var$We.animationstart.animation), "TransitionEvent" in window || delete $fdd90c8cbe9e299b$var$We.transitionend.transition);
function $fdd90c8cbe9e299b$var$Ze(a) {
    if ($fdd90c8cbe9e299b$var$Xe[a]) return $fdd90c8cbe9e299b$var$Xe[a];
    if (!$fdd90c8cbe9e299b$var$We[a]) return a;
    var b = $fdd90c8cbe9e299b$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $fdd90c8cbe9e299b$var$Ye) return $fdd90c8cbe9e299b$var$Xe[a] = b[c];
    return a;
}
var $fdd90c8cbe9e299b$var$$e = $fdd90c8cbe9e299b$var$Ze("animationend"), $fdd90c8cbe9e299b$var$af = $fdd90c8cbe9e299b$var$Ze("animationiteration"), $fdd90c8cbe9e299b$var$bf = $fdd90c8cbe9e299b$var$Ze("animationstart"), $fdd90c8cbe9e299b$var$cf = $fdd90c8cbe9e299b$var$Ze("transitionend"), $fdd90c8cbe9e299b$var$df = new Map, $fdd90c8cbe9e299b$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $fdd90c8cbe9e299b$var$ff(a, b) {
    $fdd90c8cbe9e299b$var$df.set(a, b);
    $fdd90c8cbe9e299b$var$fa(b, [
        a
    ]);
}
for(var $fdd90c8cbe9e299b$var$gf = 0; $fdd90c8cbe9e299b$var$gf < $fdd90c8cbe9e299b$var$ef.length; $fdd90c8cbe9e299b$var$gf++){
    var $fdd90c8cbe9e299b$var$hf = $fdd90c8cbe9e299b$var$ef[$fdd90c8cbe9e299b$var$gf], $fdd90c8cbe9e299b$var$jf = $fdd90c8cbe9e299b$var$hf.toLowerCase(), $fdd90c8cbe9e299b$var$kf = $fdd90c8cbe9e299b$var$hf[0].toUpperCase() + $fdd90c8cbe9e299b$var$hf.slice(1);
    $fdd90c8cbe9e299b$var$ff($fdd90c8cbe9e299b$var$jf, "on" + $fdd90c8cbe9e299b$var$kf);
}
$fdd90c8cbe9e299b$var$ff($fdd90c8cbe9e299b$var$$e, "onAnimationEnd");
$fdd90c8cbe9e299b$var$ff($fdd90c8cbe9e299b$var$af, "onAnimationIteration");
$fdd90c8cbe9e299b$var$ff($fdd90c8cbe9e299b$var$bf, "onAnimationStart");
$fdd90c8cbe9e299b$var$ff("dblclick", "onDoubleClick");
$fdd90c8cbe9e299b$var$ff("focusin", "onFocus");
$fdd90c8cbe9e299b$var$ff("focusout", "onBlur");
$fdd90c8cbe9e299b$var$ff($fdd90c8cbe9e299b$var$cf, "onTransitionEnd");
$fdd90c8cbe9e299b$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$fdd90c8cbe9e299b$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$fdd90c8cbe9e299b$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$fdd90c8cbe9e299b$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$fdd90c8cbe9e299b$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$fdd90c8cbe9e299b$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$fdd90c8cbe9e299b$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$fdd90c8cbe9e299b$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$fdd90c8cbe9e299b$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$fdd90c8cbe9e299b$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $fdd90c8cbe9e299b$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $fdd90c8cbe9e299b$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($fdd90c8cbe9e299b$var$lf));
function $fdd90c8cbe9e299b$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $fdd90c8cbe9e299b$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $fdd90c8cbe9e299b$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $fdd90c8cbe9e299b$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $fdd90c8cbe9e299b$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($fdd90c8cbe9e299b$var$Qb) throw a = $fdd90c8cbe9e299b$var$Rb, $fdd90c8cbe9e299b$var$Qb = !1, $fdd90c8cbe9e299b$var$Rb = null, a;
}
function $fdd90c8cbe9e299b$var$D(a, b) {
    var c = b[$fdd90c8cbe9e299b$var$of];
    void 0 === c && (c = b[$fdd90c8cbe9e299b$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($fdd90c8cbe9e299b$var$pf(b, a, 2, !1), c.add(d));
}
function $fdd90c8cbe9e299b$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $fdd90c8cbe9e299b$var$pf(c, a, d, b);
}
var $fdd90c8cbe9e299b$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $fdd90c8cbe9e299b$var$sf(a) {
    if (!a[$fdd90c8cbe9e299b$var$rf]) {
        a[$fdd90c8cbe9e299b$var$rf] = !0;
        $fdd90c8cbe9e299b$var$da.forEach(function(b) {
            "selectionchange" !== b && ($fdd90c8cbe9e299b$var$mf.has(b) || $fdd90c8cbe9e299b$var$qf(b, !1, a), $fdd90c8cbe9e299b$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$fdd90c8cbe9e299b$var$rf] || (b[$fdd90c8cbe9e299b$var$rf] = !0, $fdd90c8cbe9e299b$var$qf("selectionchange", !1, b));
    }
}
function $fdd90c8cbe9e299b$var$pf(a, b, c, d) {
    switch($fdd90c8cbe9e299b$var$jd(b)){
        case 1:
            var e = $fdd90c8cbe9e299b$var$ed;
            break;
        case 4:
            e = $fdd90c8cbe9e299b$var$gd;
            break;
        default:
            e = $fdd90c8cbe9e299b$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$fdd90c8cbe9e299b$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $fdd90c8cbe9e299b$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $fdd90c8cbe9e299b$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $fdd90c8cbe9e299b$var$Jb(function() {
        var d = f, e = $fdd90c8cbe9e299b$var$xb(c), g = [];
        a: {
            var h = $fdd90c8cbe9e299b$var$df.get(a);
            if (void 0 !== h) {
                var k = $fdd90c8cbe9e299b$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $fdd90c8cbe9e299b$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $fdd90c8cbe9e299b$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $fdd90c8cbe9e299b$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $fdd90c8cbe9e299b$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $fdd90c8cbe9e299b$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $fdd90c8cbe9e299b$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $fdd90c8cbe9e299b$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $fdd90c8cbe9e299b$var$Vd;
                        break;
                    case $fdd90c8cbe9e299b$var$$e:
                    case $fdd90c8cbe9e299b$var$af:
                    case $fdd90c8cbe9e299b$var$bf:
                        k = $fdd90c8cbe9e299b$var$Hd;
                        break;
                    case $fdd90c8cbe9e299b$var$cf:
                        k = $fdd90c8cbe9e299b$var$Xd;
                        break;
                    case "scroll":
                        k = $fdd90c8cbe9e299b$var$vd;
                        break;
                    case "wheel":
                        k = $fdd90c8cbe9e299b$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $fdd90c8cbe9e299b$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $fdd90c8cbe9e299b$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $fdd90c8cbe9e299b$var$Kb(w, x), null != F && t.push($fdd90c8cbe9e299b$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $fdd90c8cbe9e299b$var$wb && (n = c.relatedTarget || c.fromElement) && ($fdd90c8cbe9e299b$var$Wc(n) || n[$fdd90c8cbe9e299b$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $fdd90c8cbe9e299b$var$Wc(n) : null, null !== n && (J = $fdd90c8cbe9e299b$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $fdd90c8cbe9e299b$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $fdd90c8cbe9e299b$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $fdd90c8cbe9e299b$var$ue(k);
                        u = null == n ? h : $fdd90c8cbe9e299b$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $fdd90c8cbe9e299b$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $fdd90c8cbe9e299b$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $fdd90c8cbe9e299b$var$vf(F))u++;
                            for(; 0 < w - u;)t = $fdd90c8cbe9e299b$var$vf(t), w--;
                            for(; 0 < u - w;)x = $fdd90c8cbe9e299b$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $fdd90c8cbe9e299b$var$vf(t);
                                x = $fdd90c8cbe9e299b$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $fdd90c8cbe9e299b$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $fdd90c8cbe9e299b$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $fdd90c8cbe9e299b$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $fdd90c8cbe9e299b$var$ve;
                else if ($fdd90c8cbe9e299b$var$me(h)) {
                    if ($fdd90c8cbe9e299b$var$we) na = $fdd90c8cbe9e299b$var$Fe;
                    else {
                        na = $fdd90c8cbe9e299b$var$De;
                        var xa = $fdd90c8cbe9e299b$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $fdd90c8cbe9e299b$var$Ee);
                if (na && (na = na(a, d))) {
                    $fdd90c8cbe9e299b$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $fdd90c8cbe9e299b$var$cb(h, "number", h.value);
            }
            xa = d ? $fdd90c8cbe9e299b$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($fdd90c8cbe9e299b$var$me(xa) || "true" === xa.contentEditable) $fdd90c8cbe9e299b$var$Qe = xa, $fdd90c8cbe9e299b$var$Re = d, $fdd90c8cbe9e299b$var$Se = null;
                    break;
                case "focusout":
                    $fdd90c8cbe9e299b$var$Se = $fdd90c8cbe9e299b$var$Re = $fdd90c8cbe9e299b$var$Qe = null;
                    break;
                case "mousedown":
                    $fdd90c8cbe9e299b$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $fdd90c8cbe9e299b$var$Te = !1;
                    $fdd90c8cbe9e299b$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($fdd90c8cbe9e299b$var$Pe) break;
                case "keydown":
                case "keyup":
                    $fdd90c8cbe9e299b$var$Ue(g, c, e);
            }
            var $a;
            if ($fdd90c8cbe9e299b$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $fdd90c8cbe9e299b$var$ie ? $fdd90c8cbe9e299b$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($fdd90c8cbe9e299b$var$de && "ko" !== c.locale && ($fdd90c8cbe9e299b$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $fdd90c8cbe9e299b$var$ie && ($a = $fdd90c8cbe9e299b$var$nd()) : ($fdd90c8cbe9e299b$var$kd = e, $fdd90c8cbe9e299b$var$ld = "value" in $fdd90c8cbe9e299b$var$kd ? $fdd90c8cbe9e299b$var$kd.value : $fdd90c8cbe9e299b$var$kd.textContent, $fdd90c8cbe9e299b$var$ie = !0)), xa = $fdd90c8cbe9e299b$var$oe(d, ba), 0 < xa.length && (ba = new $fdd90c8cbe9e299b$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $fdd90c8cbe9e299b$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $fdd90c8cbe9e299b$var$ce ? $fdd90c8cbe9e299b$var$je(a, c) : $fdd90c8cbe9e299b$var$ke(a, c)) d = $fdd90c8cbe9e299b$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $fdd90c8cbe9e299b$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $fdd90c8cbe9e299b$var$se(g, b);
    });
}
function $fdd90c8cbe9e299b$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $fdd90c8cbe9e299b$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $fdd90c8cbe9e299b$var$Kb(a, c), null != f && d.unshift($fdd90c8cbe9e299b$var$tf(a, f, e)), f = $fdd90c8cbe9e299b$var$Kb(a, b), null != f && d.push($fdd90c8cbe9e299b$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $fdd90c8cbe9e299b$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $fdd90c8cbe9e299b$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $fdd90c8cbe9e299b$var$Kb(c, f), null != k && g.unshift($fdd90c8cbe9e299b$var$tf(c, k, h))) : e || (k = $fdd90c8cbe9e299b$var$Kb(c, f), null != k && g.push($fdd90c8cbe9e299b$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $fdd90c8cbe9e299b$var$xf = /\r\n?/g, $fdd90c8cbe9e299b$var$yf = /\u0000|\uFFFD/g;
function $fdd90c8cbe9e299b$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($fdd90c8cbe9e299b$var$xf, "\n").replace($fdd90c8cbe9e299b$var$yf, "");
}
function $fdd90c8cbe9e299b$var$Af(a, b, c) {
    b = $fdd90c8cbe9e299b$var$zf(b);
    if ($fdd90c8cbe9e299b$var$zf(a) !== b && c) throw Error($fdd90c8cbe9e299b$var$p(425));
}
function $fdd90c8cbe9e299b$var$Bf() {}
var $fdd90c8cbe9e299b$var$Cf = null, $fdd90c8cbe9e299b$var$Df = null;
function $fdd90c8cbe9e299b$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $fdd90c8cbe9e299b$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $fdd90c8cbe9e299b$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $fdd90c8cbe9e299b$var$Hf = "function" === typeof Promise ? Promise : void 0, $fdd90c8cbe9e299b$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $fdd90c8cbe9e299b$var$Hf ? function(a) {
    return $fdd90c8cbe9e299b$var$Hf.resolve(null).then(a).catch($fdd90c8cbe9e299b$var$If);
} : $fdd90c8cbe9e299b$var$Ff;
function $fdd90c8cbe9e299b$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $fdd90c8cbe9e299b$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $fdd90c8cbe9e299b$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $fdd90c8cbe9e299b$var$bd(b);
}
function $fdd90c8cbe9e299b$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $fdd90c8cbe9e299b$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $fdd90c8cbe9e299b$var$Nf = Math.random().toString(36).slice(2), $fdd90c8cbe9e299b$var$Of = "__reactFiber$" + $fdd90c8cbe9e299b$var$Nf, $fdd90c8cbe9e299b$var$Pf = "__reactProps$" + $fdd90c8cbe9e299b$var$Nf, $fdd90c8cbe9e299b$var$uf = "__reactContainer$" + $fdd90c8cbe9e299b$var$Nf, $fdd90c8cbe9e299b$var$of = "__reactEvents$" + $fdd90c8cbe9e299b$var$Nf, $fdd90c8cbe9e299b$var$Qf = "__reactListeners$" + $fdd90c8cbe9e299b$var$Nf, $fdd90c8cbe9e299b$var$Rf = "__reactHandles$" + $fdd90c8cbe9e299b$var$Nf;
function $fdd90c8cbe9e299b$var$Wc(a) {
    var b = a[$fdd90c8cbe9e299b$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$fdd90c8cbe9e299b$var$uf] || c[$fdd90c8cbe9e299b$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $fdd90c8cbe9e299b$var$Mf(a); null !== a;){
                if (c = a[$fdd90c8cbe9e299b$var$Of]) return c;
                a = $fdd90c8cbe9e299b$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $fdd90c8cbe9e299b$var$Cb(a) {
    a = a[$fdd90c8cbe9e299b$var$Of] || a[$fdd90c8cbe9e299b$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $fdd90c8cbe9e299b$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($fdd90c8cbe9e299b$var$p(33));
}
function $fdd90c8cbe9e299b$var$Db(a) {
    return a[$fdd90c8cbe9e299b$var$Pf] || null;
}
var $fdd90c8cbe9e299b$var$Sf = [], $fdd90c8cbe9e299b$var$Tf = -1;
function $fdd90c8cbe9e299b$var$Uf(a) {
    return {
        current: a
    };
}
function $fdd90c8cbe9e299b$var$E(a) {
    0 > $fdd90c8cbe9e299b$var$Tf || (a.current = $fdd90c8cbe9e299b$var$Sf[$fdd90c8cbe9e299b$var$Tf], $fdd90c8cbe9e299b$var$Sf[$fdd90c8cbe9e299b$var$Tf] = null, $fdd90c8cbe9e299b$var$Tf--);
}
function $fdd90c8cbe9e299b$var$G(a, b) {
    $fdd90c8cbe9e299b$var$Tf++;
    $fdd90c8cbe9e299b$var$Sf[$fdd90c8cbe9e299b$var$Tf] = a.current;
    a.current = b;
}
var $fdd90c8cbe9e299b$var$Vf = {}, $fdd90c8cbe9e299b$var$H = $fdd90c8cbe9e299b$var$Uf($fdd90c8cbe9e299b$var$Vf), $fdd90c8cbe9e299b$var$Wf = $fdd90c8cbe9e299b$var$Uf(!1), $fdd90c8cbe9e299b$var$Xf = $fdd90c8cbe9e299b$var$Vf;
function $fdd90c8cbe9e299b$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $fdd90c8cbe9e299b$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $fdd90c8cbe9e299b$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $fdd90c8cbe9e299b$var$$f() {
    $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Wf);
    $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$H);
}
function $fdd90c8cbe9e299b$var$ag(a, b, c) {
    if ($fdd90c8cbe9e299b$var$H.current !== $fdd90c8cbe9e299b$var$Vf) throw Error($fdd90c8cbe9e299b$var$p(168));
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$H, b);
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$Wf, c);
}
function $fdd90c8cbe9e299b$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($fdd90c8cbe9e299b$var$p(108, $fdd90c8cbe9e299b$var$Ra(a) || "Unknown", e));
    return $fdd90c8cbe9e299b$var$A({}, c, d);
}
function $fdd90c8cbe9e299b$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $fdd90c8cbe9e299b$var$Vf;
    $fdd90c8cbe9e299b$var$Xf = $fdd90c8cbe9e299b$var$H.current;
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$H, a);
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$Wf, $fdd90c8cbe9e299b$var$Wf.current);
    return !0;
}
function $fdd90c8cbe9e299b$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($fdd90c8cbe9e299b$var$p(169));
    c ? (a = $fdd90c8cbe9e299b$var$bg(a, b, $fdd90c8cbe9e299b$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Wf), $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$H), $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$H, a)) : $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Wf);
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$Wf, c);
}
var $fdd90c8cbe9e299b$var$eg = null, $fdd90c8cbe9e299b$var$fg = !1, $fdd90c8cbe9e299b$var$gg = !1;
function $fdd90c8cbe9e299b$var$hg(a) {
    null === $fdd90c8cbe9e299b$var$eg ? $fdd90c8cbe9e299b$var$eg = [
        a
    ] : $fdd90c8cbe9e299b$var$eg.push(a);
}
function $fdd90c8cbe9e299b$var$ig(a) {
    $fdd90c8cbe9e299b$var$fg = !0;
    $fdd90c8cbe9e299b$var$hg(a);
}
function $fdd90c8cbe9e299b$var$jg() {
    if (!$fdd90c8cbe9e299b$var$gg && null !== $fdd90c8cbe9e299b$var$eg) {
        $fdd90c8cbe9e299b$var$gg = !0;
        var a = 0, b = $fdd90c8cbe9e299b$var$C;
        try {
            var c = $fdd90c8cbe9e299b$var$eg;
            for($fdd90c8cbe9e299b$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $fdd90c8cbe9e299b$var$eg = null;
            $fdd90c8cbe9e299b$var$fg = !1;
        } catch (e) {
            throw null !== $fdd90c8cbe9e299b$var$eg && ($fdd90c8cbe9e299b$var$eg = $fdd90c8cbe9e299b$var$eg.slice(a + 1)), $fdd90c8cbe9e299b$var$ac($fdd90c8cbe9e299b$var$fc, $fdd90c8cbe9e299b$var$jg), e;
        } finally{
            $fdd90c8cbe9e299b$var$C = b, $fdd90c8cbe9e299b$var$gg = !1;
        }
    }
    return null;
}
var $fdd90c8cbe9e299b$var$kg = [], $fdd90c8cbe9e299b$var$lg = 0, $fdd90c8cbe9e299b$var$mg = null, $fdd90c8cbe9e299b$var$ng = 0, $fdd90c8cbe9e299b$var$og = [], $fdd90c8cbe9e299b$var$pg = 0, $fdd90c8cbe9e299b$var$qg = null, $fdd90c8cbe9e299b$var$rg = 1, $fdd90c8cbe9e299b$var$sg = "";
function $fdd90c8cbe9e299b$var$tg(a, b) {
    $fdd90c8cbe9e299b$var$kg[$fdd90c8cbe9e299b$var$lg++] = $fdd90c8cbe9e299b$var$ng;
    $fdd90c8cbe9e299b$var$kg[$fdd90c8cbe9e299b$var$lg++] = $fdd90c8cbe9e299b$var$mg;
    $fdd90c8cbe9e299b$var$mg = a;
    $fdd90c8cbe9e299b$var$ng = b;
}
function $fdd90c8cbe9e299b$var$ug(a, b, c) {
    $fdd90c8cbe9e299b$var$og[$fdd90c8cbe9e299b$var$pg++] = $fdd90c8cbe9e299b$var$rg;
    $fdd90c8cbe9e299b$var$og[$fdd90c8cbe9e299b$var$pg++] = $fdd90c8cbe9e299b$var$sg;
    $fdd90c8cbe9e299b$var$og[$fdd90c8cbe9e299b$var$pg++] = $fdd90c8cbe9e299b$var$qg;
    $fdd90c8cbe9e299b$var$qg = a;
    var d = $fdd90c8cbe9e299b$var$rg;
    a = $fdd90c8cbe9e299b$var$sg;
    var e = 32 - $fdd90c8cbe9e299b$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $fdd90c8cbe9e299b$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $fdd90c8cbe9e299b$var$rg = 1 << 32 - $fdd90c8cbe9e299b$var$oc(b) + e | c << e | d;
        $fdd90c8cbe9e299b$var$sg = f + a;
    } else $fdd90c8cbe9e299b$var$rg = 1 << f | c << e | d, $fdd90c8cbe9e299b$var$sg = a;
}
function $fdd90c8cbe9e299b$var$vg(a) {
    null !== a.return && ($fdd90c8cbe9e299b$var$tg(a, 1), $fdd90c8cbe9e299b$var$ug(a, 1, 0));
}
function $fdd90c8cbe9e299b$var$wg(a) {
    for(; a === $fdd90c8cbe9e299b$var$mg;)$fdd90c8cbe9e299b$var$mg = $fdd90c8cbe9e299b$var$kg[--$fdd90c8cbe9e299b$var$lg], $fdd90c8cbe9e299b$var$kg[$fdd90c8cbe9e299b$var$lg] = null, $fdd90c8cbe9e299b$var$ng = $fdd90c8cbe9e299b$var$kg[--$fdd90c8cbe9e299b$var$lg], $fdd90c8cbe9e299b$var$kg[$fdd90c8cbe9e299b$var$lg] = null;
    for(; a === $fdd90c8cbe9e299b$var$qg;)$fdd90c8cbe9e299b$var$qg = $fdd90c8cbe9e299b$var$og[--$fdd90c8cbe9e299b$var$pg], $fdd90c8cbe9e299b$var$og[$fdd90c8cbe9e299b$var$pg] = null, $fdd90c8cbe9e299b$var$sg = $fdd90c8cbe9e299b$var$og[--$fdd90c8cbe9e299b$var$pg], $fdd90c8cbe9e299b$var$og[$fdd90c8cbe9e299b$var$pg] = null, $fdd90c8cbe9e299b$var$rg = $fdd90c8cbe9e299b$var$og[--$fdd90c8cbe9e299b$var$pg], $fdd90c8cbe9e299b$var$og[$fdd90c8cbe9e299b$var$pg] = null;
}
var $fdd90c8cbe9e299b$var$xg = null, $fdd90c8cbe9e299b$var$yg = null, $fdd90c8cbe9e299b$var$I = !1, $fdd90c8cbe9e299b$var$zg = null;
function $fdd90c8cbe9e299b$var$Ag(a, b) {
    var c = $fdd90c8cbe9e299b$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $fdd90c8cbe9e299b$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $fdd90c8cbe9e299b$var$xg = a, $fdd90c8cbe9e299b$var$yg = $fdd90c8cbe9e299b$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $fdd90c8cbe9e299b$var$xg = a, $fdd90c8cbe9e299b$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $fdd90c8cbe9e299b$var$qg ? {
                id: $fdd90c8cbe9e299b$var$rg,
                overflow: $fdd90c8cbe9e299b$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $fdd90c8cbe9e299b$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $fdd90c8cbe9e299b$var$xg = a, $fdd90c8cbe9e299b$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $fdd90c8cbe9e299b$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $fdd90c8cbe9e299b$var$Eg(a) {
    if ($fdd90c8cbe9e299b$var$I) {
        var b = $fdd90c8cbe9e299b$var$yg;
        if (b) {
            var c = b;
            if (!$fdd90c8cbe9e299b$var$Cg(a, b)) {
                if ($fdd90c8cbe9e299b$var$Dg(a)) throw Error($fdd90c8cbe9e299b$var$p(418));
                b = $fdd90c8cbe9e299b$var$Lf(c.nextSibling);
                var d = $fdd90c8cbe9e299b$var$xg;
                b && $fdd90c8cbe9e299b$var$Cg(a, b) ? $fdd90c8cbe9e299b$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $fdd90c8cbe9e299b$var$I = !1, $fdd90c8cbe9e299b$var$xg = a);
            }
        } else {
            if ($fdd90c8cbe9e299b$var$Dg(a)) throw Error($fdd90c8cbe9e299b$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $fdd90c8cbe9e299b$var$I = !1;
            $fdd90c8cbe9e299b$var$xg = a;
        }
    }
}
function $fdd90c8cbe9e299b$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $fdd90c8cbe9e299b$var$xg = a;
}
function $fdd90c8cbe9e299b$var$Gg(a) {
    if (a !== $fdd90c8cbe9e299b$var$xg) return !1;
    if (!$fdd90c8cbe9e299b$var$I) return $fdd90c8cbe9e299b$var$Fg(a), $fdd90c8cbe9e299b$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$fdd90c8cbe9e299b$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $fdd90c8cbe9e299b$var$yg)) {
        if ($fdd90c8cbe9e299b$var$Dg(a)) throw $fdd90c8cbe9e299b$var$Hg(), Error($fdd90c8cbe9e299b$var$p(418));
        for(; b;)$fdd90c8cbe9e299b$var$Ag(a, b), b = $fdd90c8cbe9e299b$var$Lf(b.nextSibling);
    }
    $fdd90c8cbe9e299b$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($fdd90c8cbe9e299b$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $fdd90c8cbe9e299b$var$yg = $fdd90c8cbe9e299b$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $fdd90c8cbe9e299b$var$yg = null;
        }
    } else $fdd90c8cbe9e299b$var$yg = $fdd90c8cbe9e299b$var$xg ? $fdd90c8cbe9e299b$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $fdd90c8cbe9e299b$var$Hg() {
    for(var a = $fdd90c8cbe9e299b$var$yg; a;)a = $fdd90c8cbe9e299b$var$Lf(a.nextSibling);
}
function $fdd90c8cbe9e299b$var$Ig() {
    $fdd90c8cbe9e299b$var$yg = $fdd90c8cbe9e299b$var$xg = null;
    $fdd90c8cbe9e299b$var$I = !1;
}
function $fdd90c8cbe9e299b$var$Jg(a) {
    null === $fdd90c8cbe9e299b$var$zg ? $fdd90c8cbe9e299b$var$zg = [
        a
    ] : $fdd90c8cbe9e299b$var$zg.push(a);
}
var $fdd90c8cbe9e299b$var$Kg = $fdd90c8cbe9e299b$var$ua.ReactCurrentBatchConfig;
function $fdd90c8cbe9e299b$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $fdd90c8cbe9e299b$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $fdd90c8cbe9e299b$var$Mg = $fdd90c8cbe9e299b$var$Uf(null), $fdd90c8cbe9e299b$var$Ng = null, $fdd90c8cbe9e299b$var$Og = null, $fdd90c8cbe9e299b$var$Pg = null;
function $fdd90c8cbe9e299b$var$Qg() {
    $fdd90c8cbe9e299b$var$Pg = $fdd90c8cbe9e299b$var$Og = $fdd90c8cbe9e299b$var$Ng = null;
}
function $fdd90c8cbe9e299b$var$Rg(a) {
    var b = $fdd90c8cbe9e299b$var$Mg.current;
    $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Mg);
    a._currentValue = b;
}
function $fdd90c8cbe9e299b$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $fdd90c8cbe9e299b$var$Tg(a, b) {
    $fdd90c8cbe9e299b$var$Ng = a;
    $fdd90c8cbe9e299b$var$Pg = $fdd90c8cbe9e299b$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($fdd90c8cbe9e299b$var$Ug = !0), a.firstContext = null);
}
function $fdd90c8cbe9e299b$var$Vg(a) {
    var b = a._currentValue;
    if ($fdd90c8cbe9e299b$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $fdd90c8cbe9e299b$var$Og) {
            if (null === $fdd90c8cbe9e299b$var$Ng) throw Error($fdd90c8cbe9e299b$var$p(308));
            $fdd90c8cbe9e299b$var$Og = a;
            $fdd90c8cbe9e299b$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $fdd90c8cbe9e299b$var$Og = $fdd90c8cbe9e299b$var$Og.next = a;
    }
    return b;
}
var $fdd90c8cbe9e299b$var$Wg = null;
function $fdd90c8cbe9e299b$var$Xg(a) {
    null === $fdd90c8cbe9e299b$var$Wg ? $fdd90c8cbe9e299b$var$Wg = [
        a
    ] : $fdd90c8cbe9e299b$var$Wg.push(a);
}
function $fdd90c8cbe9e299b$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $fdd90c8cbe9e299b$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $fdd90c8cbe9e299b$var$Zg(a, d);
}
function $fdd90c8cbe9e299b$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $fdd90c8cbe9e299b$var$$g = !1;
function $fdd90c8cbe9e299b$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $fdd90c8cbe9e299b$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $fdd90c8cbe9e299b$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $fdd90c8cbe9e299b$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($fdd90c8cbe9e299b$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $fdd90c8cbe9e299b$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $fdd90c8cbe9e299b$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $fdd90c8cbe9e299b$var$Zg(a, c);
}
function $fdd90c8cbe9e299b$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $fdd90c8cbe9e299b$var$Cc(a, c);
    }
}
function $fdd90c8cbe9e299b$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $fdd90c8cbe9e299b$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $fdd90c8cbe9e299b$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $fdd90c8cbe9e299b$var$A({}, q, r);
                            break a;
                        case 2:
                            $fdd90c8cbe9e299b$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $fdd90c8cbe9e299b$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $fdd90c8cbe9e299b$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($fdd90c8cbe9e299b$var$p(191, e));
            e.call(d);
        }
    }
}
var $fdd90c8cbe9e299b$var$jh = (new $9nZCP.Component).refs;
function $fdd90c8cbe9e299b$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $fdd90c8cbe9e299b$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $fdd90c8cbe9e299b$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $fdd90c8cbe9e299b$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $fdd90c8cbe9e299b$var$L(), e = $fdd90c8cbe9e299b$var$lh(a), f = $fdd90c8cbe9e299b$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $fdd90c8cbe9e299b$var$dh(a, f, e);
        null !== b && ($fdd90c8cbe9e299b$var$mh(b, a, e, d), $fdd90c8cbe9e299b$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $fdd90c8cbe9e299b$var$L(), e = $fdd90c8cbe9e299b$var$lh(a), f = $fdd90c8cbe9e299b$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $fdd90c8cbe9e299b$var$dh(a, f, e);
        null !== b && ($fdd90c8cbe9e299b$var$mh(b, a, e, d), $fdd90c8cbe9e299b$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $fdd90c8cbe9e299b$var$L(), d = $fdd90c8cbe9e299b$var$lh(a), e = $fdd90c8cbe9e299b$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $fdd90c8cbe9e299b$var$dh(a, e, d);
        null !== b && ($fdd90c8cbe9e299b$var$mh(b, a, d, c), $fdd90c8cbe9e299b$var$eh(b, a, d));
    }
};
function $fdd90c8cbe9e299b$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$fdd90c8cbe9e299b$var$Ie(c, d) || !$fdd90c8cbe9e299b$var$Ie(e, f) : !0;
}
function $fdd90c8cbe9e299b$var$ph(a, b, c) {
    var d = !1, e = $fdd90c8cbe9e299b$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $fdd90c8cbe9e299b$var$Vg(f) : (e = $fdd90c8cbe9e299b$var$Zf(b) ? $fdd90c8cbe9e299b$var$Xf : $fdd90c8cbe9e299b$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $fdd90c8cbe9e299b$var$Yf(a, e) : $fdd90c8cbe9e299b$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $fdd90c8cbe9e299b$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $fdd90c8cbe9e299b$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $fdd90c8cbe9e299b$var$nh.enqueueReplaceState(b, b.state, null);
}
function $fdd90c8cbe9e299b$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $fdd90c8cbe9e299b$var$jh;
    $fdd90c8cbe9e299b$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $fdd90c8cbe9e299b$var$Vg(f) : (f = $fdd90c8cbe9e299b$var$Zf(b) ? $fdd90c8cbe9e299b$var$Xf : $fdd90c8cbe9e299b$var$H.current, e.context = $fdd90c8cbe9e299b$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($fdd90c8cbe9e299b$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $fdd90c8cbe9e299b$var$nh.enqueueReplaceState(e, e.state, null), $fdd90c8cbe9e299b$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $fdd90c8cbe9e299b$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($fdd90c8cbe9e299b$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($fdd90c8cbe9e299b$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $fdd90c8cbe9e299b$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($fdd90c8cbe9e299b$var$p(284));
        if (!c._owner) throw Error($fdd90c8cbe9e299b$var$p(290, a));
    }
    return a;
}
function $fdd90c8cbe9e299b$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($fdd90c8cbe9e299b$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $fdd90c8cbe9e299b$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $fdd90c8cbe9e299b$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $fdd90c8cbe9e299b$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $fdd90c8cbe9e299b$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $fdd90c8cbe9e299b$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $fdd90c8cbe9e299b$var$Ha && $fdd90c8cbe9e299b$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $fdd90c8cbe9e299b$var$sh(a, b, c), d.return = a, d;
        d = $fdd90c8cbe9e299b$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $fdd90c8cbe9e299b$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $fdd90c8cbe9e299b$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $fdd90c8cbe9e299b$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $fdd90c8cbe9e299b$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $fdd90c8cbe9e299b$var$va:
                    return c = $fdd90c8cbe9e299b$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $fdd90c8cbe9e299b$var$sh(a, null, b), c.return = a, c;
                case $fdd90c8cbe9e299b$var$wa:
                    return b = $fdd90c8cbe9e299b$var$zh(b, a.mode, c), b.return = a, b;
                case $fdd90c8cbe9e299b$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($fdd90c8cbe9e299b$var$eb(b) || $fdd90c8cbe9e299b$var$Ka(b)) return b = $fdd90c8cbe9e299b$var$Ah(b, a.mode, c, null), b.return = a, b;
            $fdd90c8cbe9e299b$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $fdd90c8cbe9e299b$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $fdd90c8cbe9e299b$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $fdd90c8cbe9e299b$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($fdd90c8cbe9e299b$var$eb(c) || $fdd90c8cbe9e299b$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $fdd90c8cbe9e299b$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $fdd90c8cbe9e299b$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $fdd90c8cbe9e299b$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $fdd90c8cbe9e299b$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($fdd90c8cbe9e299b$var$eb(d) || $fdd90c8cbe9e299b$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $fdd90c8cbe9e299b$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $fdd90c8cbe9e299b$var$I && $fdd90c8cbe9e299b$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $fdd90c8cbe9e299b$var$I && $fdd90c8cbe9e299b$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $fdd90c8cbe9e299b$var$I && $fdd90c8cbe9e299b$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $fdd90c8cbe9e299b$var$Ka(h);
        if ("function" !== typeof l) throw Error($fdd90c8cbe9e299b$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($fdd90c8cbe9e299b$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $fdd90c8cbe9e299b$var$I && $fdd90c8cbe9e299b$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $fdd90c8cbe9e299b$var$I && $fdd90c8cbe9e299b$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $fdd90c8cbe9e299b$var$I && $fdd90c8cbe9e299b$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $fdd90c8cbe9e299b$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $fdd90c8cbe9e299b$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $fdd90c8cbe9e299b$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $fdd90c8cbe9e299b$var$Ha && $fdd90c8cbe9e299b$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $fdd90c8cbe9e299b$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $fdd90c8cbe9e299b$var$ya ? (d = $fdd90c8cbe9e299b$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $fdd90c8cbe9e299b$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $fdd90c8cbe9e299b$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $fdd90c8cbe9e299b$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $fdd90c8cbe9e299b$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $fdd90c8cbe9e299b$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($fdd90c8cbe9e299b$var$eb(f)) return n(a, d, f, h);
            if ($fdd90c8cbe9e299b$var$Ka(f)) return t(a, d, f, h);
            $fdd90c8cbe9e299b$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $fdd90c8cbe9e299b$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $fdd90c8cbe9e299b$var$Bh = $fdd90c8cbe9e299b$var$vh(!0), $fdd90c8cbe9e299b$var$Ch = $fdd90c8cbe9e299b$var$vh(!1), $fdd90c8cbe9e299b$var$Dh = {}, $fdd90c8cbe9e299b$var$Eh = $fdd90c8cbe9e299b$var$Uf($fdd90c8cbe9e299b$var$Dh), $fdd90c8cbe9e299b$var$Fh = $fdd90c8cbe9e299b$var$Uf($fdd90c8cbe9e299b$var$Dh), $fdd90c8cbe9e299b$var$Gh = $fdd90c8cbe9e299b$var$Uf($fdd90c8cbe9e299b$var$Dh);
function $fdd90c8cbe9e299b$var$Hh(a) {
    if (a === $fdd90c8cbe9e299b$var$Dh) throw Error($fdd90c8cbe9e299b$var$p(174));
    return a;
}
function $fdd90c8cbe9e299b$var$Ih(a, b) {
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$Gh, b);
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$Fh, a);
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$Eh, $fdd90c8cbe9e299b$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $fdd90c8cbe9e299b$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $fdd90c8cbe9e299b$var$lb(b, a);
    }
    $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Eh);
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$Eh, b);
}
function $fdd90c8cbe9e299b$var$Jh() {
    $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Eh);
    $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Fh);
    $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Gh);
}
function $fdd90c8cbe9e299b$var$Kh(a) {
    $fdd90c8cbe9e299b$var$Hh($fdd90c8cbe9e299b$var$Gh.current);
    var b = $fdd90c8cbe9e299b$var$Hh($fdd90c8cbe9e299b$var$Eh.current);
    var c = $fdd90c8cbe9e299b$var$lb(b, a.type);
    b !== c && ($fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$Fh, a), $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$Eh, c));
}
function $fdd90c8cbe9e299b$var$Lh(a) {
    $fdd90c8cbe9e299b$var$Fh.current === a && ($fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Eh), $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Fh));
}
var $fdd90c8cbe9e299b$var$M = $fdd90c8cbe9e299b$var$Uf(0);
function $fdd90c8cbe9e299b$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $fdd90c8cbe9e299b$var$Nh = [];
function $fdd90c8cbe9e299b$var$Oh() {
    for(var a = 0; a < $fdd90c8cbe9e299b$var$Nh.length; a++)$fdd90c8cbe9e299b$var$Nh[a]._workInProgressVersionPrimary = null;
    $fdd90c8cbe9e299b$var$Nh.length = 0;
}
var $fdd90c8cbe9e299b$var$Ph = $fdd90c8cbe9e299b$var$ua.ReactCurrentDispatcher, $fdd90c8cbe9e299b$var$Qh = $fdd90c8cbe9e299b$var$ua.ReactCurrentBatchConfig, $fdd90c8cbe9e299b$var$Rh = 0, $fdd90c8cbe9e299b$var$N = null, $fdd90c8cbe9e299b$var$O = null, $fdd90c8cbe9e299b$var$P = null, $fdd90c8cbe9e299b$var$Sh = !1, $fdd90c8cbe9e299b$var$Th = !1, $fdd90c8cbe9e299b$var$Uh = 0, $fdd90c8cbe9e299b$var$Vh = 0;
function $fdd90c8cbe9e299b$var$Q() {
    throw Error($fdd90c8cbe9e299b$var$p(321));
}
function $fdd90c8cbe9e299b$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$fdd90c8cbe9e299b$var$He(a[c], b[c])) return !1;
    return !0;
}
function $fdd90c8cbe9e299b$var$Xh(a, b, c, d, e, f) {
    $fdd90c8cbe9e299b$var$Rh = f;
    $fdd90c8cbe9e299b$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $fdd90c8cbe9e299b$var$Ph.current = null === a || null === a.memoizedState ? $fdd90c8cbe9e299b$var$Yh : $fdd90c8cbe9e299b$var$Zh;
    a = c(d, e);
    if ($fdd90c8cbe9e299b$var$Th) {
        f = 0;
        do {
            $fdd90c8cbe9e299b$var$Th = !1;
            $fdd90c8cbe9e299b$var$Uh = 0;
            if (25 <= f) throw Error($fdd90c8cbe9e299b$var$p(301));
            f += 1;
            $fdd90c8cbe9e299b$var$P = $fdd90c8cbe9e299b$var$O = null;
            b.updateQueue = null;
            $fdd90c8cbe9e299b$var$Ph.current = $fdd90c8cbe9e299b$var$$h;
            a = c(d, e);
        }while ($fdd90c8cbe9e299b$var$Th);
    }
    $fdd90c8cbe9e299b$var$Ph.current = $fdd90c8cbe9e299b$var$ai;
    b = null !== $fdd90c8cbe9e299b$var$O && null !== $fdd90c8cbe9e299b$var$O.next;
    $fdd90c8cbe9e299b$var$Rh = 0;
    $fdd90c8cbe9e299b$var$P = $fdd90c8cbe9e299b$var$O = $fdd90c8cbe9e299b$var$N = null;
    $fdd90c8cbe9e299b$var$Sh = !1;
    if (b) throw Error($fdd90c8cbe9e299b$var$p(300));
    return a;
}
function $fdd90c8cbe9e299b$var$bi() {
    var a = 0 !== $fdd90c8cbe9e299b$var$Uh;
    $fdd90c8cbe9e299b$var$Uh = 0;
    return a;
}
function $fdd90c8cbe9e299b$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $fdd90c8cbe9e299b$var$P ? $fdd90c8cbe9e299b$var$N.memoizedState = $fdd90c8cbe9e299b$var$P = a : $fdd90c8cbe9e299b$var$P = $fdd90c8cbe9e299b$var$P.next = a;
    return $fdd90c8cbe9e299b$var$P;
}
function $fdd90c8cbe9e299b$var$di() {
    if (null === $fdd90c8cbe9e299b$var$O) {
        var a = $fdd90c8cbe9e299b$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $fdd90c8cbe9e299b$var$O.next;
    var b = null === $fdd90c8cbe9e299b$var$P ? $fdd90c8cbe9e299b$var$N.memoizedState : $fdd90c8cbe9e299b$var$P.next;
    if (null !== b) $fdd90c8cbe9e299b$var$P = b, $fdd90c8cbe9e299b$var$O = a;
    else {
        if (null === a) throw Error($fdd90c8cbe9e299b$var$p(310));
        $fdd90c8cbe9e299b$var$O = a;
        a = {
            memoizedState: $fdd90c8cbe9e299b$var$O.memoizedState,
            baseState: $fdd90c8cbe9e299b$var$O.baseState,
            baseQueue: $fdd90c8cbe9e299b$var$O.baseQueue,
            queue: $fdd90c8cbe9e299b$var$O.queue,
            next: null
        };
        null === $fdd90c8cbe9e299b$var$P ? $fdd90c8cbe9e299b$var$N.memoizedState = $fdd90c8cbe9e299b$var$P = a : $fdd90c8cbe9e299b$var$P = $fdd90c8cbe9e299b$var$P.next = a;
    }
    return $fdd90c8cbe9e299b$var$P;
}
function $fdd90c8cbe9e299b$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $fdd90c8cbe9e299b$var$fi(a) {
    var b = $fdd90c8cbe9e299b$var$di(), c = b.queue;
    if (null === c) throw Error($fdd90c8cbe9e299b$var$p(311));
    c.lastRenderedReducer = a;
    var d = $fdd90c8cbe9e299b$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($fdd90c8cbe9e299b$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $fdd90c8cbe9e299b$var$N.lanes |= m;
                $fdd90c8cbe9e299b$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $fdd90c8cbe9e299b$var$He(d, b.memoizedState) || ($fdd90c8cbe9e299b$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $fdd90c8cbe9e299b$var$N.lanes |= f, $fdd90c8cbe9e299b$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $fdd90c8cbe9e299b$var$gi(a) {
    var b = $fdd90c8cbe9e299b$var$di(), c = b.queue;
    if (null === c) throw Error($fdd90c8cbe9e299b$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $fdd90c8cbe9e299b$var$He(f, b.memoizedState) || ($fdd90c8cbe9e299b$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $fdd90c8cbe9e299b$var$hi() {}
function $fdd90c8cbe9e299b$var$ii(a, b) {
    var c = $fdd90c8cbe9e299b$var$N, d = $fdd90c8cbe9e299b$var$di(), e = b(), f = !$fdd90c8cbe9e299b$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $fdd90c8cbe9e299b$var$Ug = !0);
    d = d.queue;
    $fdd90c8cbe9e299b$var$ji($fdd90c8cbe9e299b$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $fdd90c8cbe9e299b$var$P && $fdd90c8cbe9e299b$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $fdd90c8cbe9e299b$var$li(9, $fdd90c8cbe9e299b$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $fdd90c8cbe9e299b$var$R) throw Error($fdd90c8cbe9e299b$var$p(349));
        0 !== ($fdd90c8cbe9e299b$var$Rh & 30) || $fdd90c8cbe9e299b$var$ni(c, b, e);
    }
    return e;
}
function $fdd90c8cbe9e299b$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $fdd90c8cbe9e299b$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $fdd90c8cbe9e299b$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $fdd90c8cbe9e299b$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $fdd90c8cbe9e299b$var$oi(b) && $fdd90c8cbe9e299b$var$pi(a);
}
function $fdd90c8cbe9e299b$var$ki(a, b, c) {
    return c(function() {
        $fdd90c8cbe9e299b$var$oi(b) && $fdd90c8cbe9e299b$var$pi(a);
    });
}
function $fdd90c8cbe9e299b$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$fdd90c8cbe9e299b$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $fdd90c8cbe9e299b$var$pi(a) {
    var b = $fdd90c8cbe9e299b$var$Zg(a, 1);
    null !== b && $fdd90c8cbe9e299b$var$mh(b, a, 1, -1);
}
function $fdd90c8cbe9e299b$var$qi(a) {
    var b = $fdd90c8cbe9e299b$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $fdd90c8cbe9e299b$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $fdd90c8cbe9e299b$var$ri.bind(null, $fdd90c8cbe9e299b$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $fdd90c8cbe9e299b$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $fdd90c8cbe9e299b$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $fdd90c8cbe9e299b$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $fdd90c8cbe9e299b$var$si() {
    return $fdd90c8cbe9e299b$var$di().memoizedState;
}
function $fdd90c8cbe9e299b$var$ti(a, b, c, d) {
    var e = $fdd90c8cbe9e299b$var$ci();
    $fdd90c8cbe9e299b$var$N.flags |= a;
    e.memoizedState = $fdd90c8cbe9e299b$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $fdd90c8cbe9e299b$var$ui(a, b, c, d) {
    var e = $fdd90c8cbe9e299b$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $fdd90c8cbe9e299b$var$O) {
        var g = $fdd90c8cbe9e299b$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $fdd90c8cbe9e299b$var$Wh(d, g.deps)) {
            e.memoizedState = $fdd90c8cbe9e299b$var$li(b, c, f, d);
            return;
        }
    }
    $fdd90c8cbe9e299b$var$N.flags |= a;
    e.memoizedState = $fdd90c8cbe9e299b$var$li(1 | b, c, f, d);
}
function $fdd90c8cbe9e299b$var$vi(a, b) {
    return $fdd90c8cbe9e299b$var$ti(8390656, 8, a, b);
}
function $fdd90c8cbe9e299b$var$ji(a, b) {
    return $fdd90c8cbe9e299b$var$ui(2048, 8, a, b);
}
function $fdd90c8cbe9e299b$var$wi(a, b) {
    return $fdd90c8cbe9e299b$var$ui(4, 2, a, b);
}
function $fdd90c8cbe9e299b$var$xi(a, b) {
    return $fdd90c8cbe9e299b$var$ui(4, 4, a, b);
}
function $fdd90c8cbe9e299b$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $fdd90c8cbe9e299b$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $fdd90c8cbe9e299b$var$ui(4, 4, $fdd90c8cbe9e299b$var$yi.bind(null, b, a), c);
}
function $fdd90c8cbe9e299b$var$Ai() {}
function $fdd90c8cbe9e299b$var$Bi(a, b) {
    var c = $fdd90c8cbe9e299b$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $fdd90c8cbe9e299b$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $fdd90c8cbe9e299b$var$Ci(a, b) {
    var c = $fdd90c8cbe9e299b$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $fdd90c8cbe9e299b$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $fdd90c8cbe9e299b$var$Di(a, b, c) {
    if (0 === ($fdd90c8cbe9e299b$var$Rh & 21)) return a.baseState && (a.baseState = !1, $fdd90c8cbe9e299b$var$Ug = !0), a.memoizedState = c;
    $fdd90c8cbe9e299b$var$He(c, b) || (c = $fdd90c8cbe9e299b$var$yc(), $fdd90c8cbe9e299b$var$N.lanes |= c, $fdd90c8cbe9e299b$var$hh |= c, a.baseState = !0);
    return b;
}
function $fdd90c8cbe9e299b$var$Ei(a, b) {
    var c = $fdd90c8cbe9e299b$var$C;
    $fdd90c8cbe9e299b$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $fdd90c8cbe9e299b$var$Qh.transition;
    $fdd90c8cbe9e299b$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $fdd90c8cbe9e299b$var$C = c, $fdd90c8cbe9e299b$var$Qh.transition = d;
    }
}
function $fdd90c8cbe9e299b$var$Fi() {
    return $fdd90c8cbe9e299b$var$di().memoizedState;
}
function $fdd90c8cbe9e299b$var$Gi(a, b, c) {
    var d = $fdd90c8cbe9e299b$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fdd90c8cbe9e299b$var$Hi(a)) $fdd90c8cbe9e299b$var$Ii(b, c);
    else if (c = $fdd90c8cbe9e299b$var$Yg(a, b, c, d), null !== c) {
        var e = $fdd90c8cbe9e299b$var$L();
        $fdd90c8cbe9e299b$var$mh(c, a, d, e);
        $fdd90c8cbe9e299b$var$Ji(c, b, d);
    }
}
function $fdd90c8cbe9e299b$var$ri(a, b, c) {
    var d = $fdd90c8cbe9e299b$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fdd90c8cbe9e299b$var$Hi(a)) $fdd90c8cbe9e299b$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($fdd90c8cbe9e299b$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $fdd90c8cbe9e299b$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $fdd90c8cbe9e299b$var$Yg(a, b, e, d);
        null !== c && (e = $fdd90c8cbe9e299b$var$L(), $fdd90c8cbe9e299b$var$mh(c, a, d, e), $fdd90c8cbe9e299b$var$Ji(c, b, d));
    }
}
function $fdd90c8cbe9e299b$var$Hi(a) {
    var b = a.alternate;
    return a === $fdd90c8cbe9e299b$var$N || null !== b && b === $fdd90c8cbe9e299b$var$N;
}
function $fdd90c8cbe9e299b$var$Ii(a, b) {
    $fdd90c8cbe9e299b$var$Th = $fdd90c8cbe9e299b$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $fdd90c8cbe9e299b$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $fdd90c8cbe9e299b$var$Cc(a, c);
    }
}
var $fdd90c8cbe9e299b$var$ai = {
    readContext: $fdd90c8cbe9e299b$var$Vg,
    useCallback: $fdd90c8cbe9e299b$var$Q,
    useContext: $fdd90c8cbe9e299b$var$Q,
    useEffect: $fdd90c8cbe9e299b$var$Q,
    useImperativeHandle: $fdd90c8cbe9e299b$var$Q,
    useInsertionEffect: $fdd90c8cbe9e299b$var$Q,
    useLayoutEffect: $fdd90c8cbe9e299b$var$Q,
    useMemo: $fdd90c8cbe9e299b$var$Q,
    useReducer: $fdd90c8cbe9e299b$var$Q,
    useRef: $fdd90c8cbe9e299b$var$Q,
    useState: $fdd90c8cbe9e299b$var$Q,
    useDebugValue: $fdd90c8cbe9e299b$var$Q,
    useDeferredValue: $fdd90c8cbe9e299b$var$Q,
    useTransition: $fdd90c8cbe9e299b$var$Q,
    useMutableSource: $fdd90c8cbe9e299b$var$Q,
    useSyncExternalStore: $fdd90c8cbe9e299b$var$Q,
    useId: $fdd90c8cbe9e299b$var$Q,
    unstable_isNewReconciler: !1
}, $fdd90c8cbe9e299b$var$Yh = {
    readContext: $fdd90c8cbe9e299b$var$Vg,
    useCallback: function(a, b) {
        $fdd90c8cbe9e299b$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $fdd90c8cbe9e299b$var$Vg,
    useEffect: $fdd90c8cbe9e299b$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $fdd90c8cbe9e299b$var$ti(4194308, 4, $fdd90c8cbe9e299b$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $fdd90c8cbe9e299b$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $fdd90c8cbe9e299b$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $fdd90c8cbe9e299b$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $fdd90c8cbe9e299b$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $fdd90c8cbe9e299b$var$Gi.bind(null, $fdd90c8cbe9e299b$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $fdd90c8cbe9e299b$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $fdd90c8cbe9e299b$var$qi,
    useDebugValue: $fdd90c8cbe9e299b$var$Ai,
    useDeferredValue: function(a) {
        return $fdd90c8cbe9e299b$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $fdd90c8cbe9e299b$var$qi(!1), b = a[0];
        a = $fdd90c8cbe9e299b$var$Ei.bind(null, a[1]);
        $fdd90c8cbe9e299b$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $fdd90c8cbe9e299b$var$N, e = $fdd90c8cbe9e299b$var$ci();
        if ($fdd90c8cbe9e299b$var$I) {
            if (void 0 === c) throw Error($fdd90c8cbe9e299b$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $fdd90c8cbe9e299b$var$R) throw Error($fdd90c8cbe9e299b$var$p(349));
            0 !== ($fdd90c8cbe9e299b$var$Rh & 30) || $fdd90c8cbe9e299b$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $fdd90c8cbe9e299b$var$vi($fdd90c8cbe9e299b$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $fdd90c8cbe9e299b$var$li(9, $fdd90c8cbe9e299b$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $fdd90c8cbe9e299b$var$ci(), b = $fdd90c8cbe9e299b$var$R.identifierPrefix;
        if ($fdd90c8cbe9e299b$var$I) {
            var c = $fdd90c8cbe9e299b$var$sg;
            var d = $fdd90c8cbe9e299b$var$rg;
            c = (d & ~(1 << 32 - $fdd90c8cbe9e299b$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $fdd90c8cbe9e299b$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $fdd90c8cbe9e299b$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $fdd90c8cbe9e299b$var$Zh = {
    readContext: $fdd90c8cbe9e299b$var$Vg,
    useCallback: $fdd90c8cbe9e299b$var$Bi,
    useContext: $fdd90c8cbe9e299b$var$Vg,
    useEffect: $fdd90c8cbe9e299b$var$ji,
    useImperativeHandle: $fdd90c8cbe9e299b$var$zi,
    useInsertionEffect: $fdd90c8cbe9e299b$var$wi,
    useLayoutEffect: $fdd90c8cbe9e299b$var$xi,
    useMemo: $fdd90c8cbe9e299b$var$Ci,
    useReducer: $fdd90c8cbe9e299b$var$fi,
    useRef: $fdd90c8cbe9e299b$var$si,
    useState: function() {
        return $fdd90c8cbe9e299b$var$fi($fdd90c8cbe9e299b$var$ei);
    },
    useDebugValue: $fdd90c8cbe9e299b$var$Ai,
    useDeferredValue: function(a) {
        var b = $fdd90c8cbe9e299b$var$di();
        return $fdd90c8cbe9e299b$var$Di(b, $fdd90c8cbe9e299b$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $fdd90c8cbe9e299b$var$fi($fdd90c8cbe9e299b$var$ei)[0], b = $fdd90c8cbe9e299b$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $fdd90c8cbe9e299b$var$hi,
    useSyncExternalStore: $fdd90c8cbe9e299b$var$ii,
    useId: $fdd90c8cbe9e299b$var$Fi,
    unstable_isNewReconciler: !1
}, $fdd90c8cbe9e299b$var$$h = {
    readContext: $fdd90c8cbe9e299b$var$Vg,
    useCallback: $fdd90c8cbe9e299b$var$Bi,
    useContext: $fdd90c8cbe9e299b$var$Vg,
    useEffect: $fdd90c8cbe9e299b$var$ji,
    useImperativeHandle: $fdd90c8cbe9e299b$var$zi,
    useInsertionEffect: $fdd90c8cbe9e299b$var$wi,
    useLayoutEffect: $fdd90c8cbe9e299b$var$xi,
    useMemo: $fdd90c8cbe9e299b$var$Ci,
    useReducer: $fdd90c8cbe9e299b$var$gi,
    useRef: $fdd90c8cbe9e299b$var$si,
    useState: function() {
        return $fdd90c8cbe9e299b$var$gi($fdd90c8cbe9e299b$var$ei);
    },
    useDebugValue: $fdd90c8cbe9e299b$var$Ai,
    useDeferredValue: function(a) {
        var b = $fdd90c8cbe9e299b$var$di();
        return null === $fdd90c8cbe9e299b$var$O ? b.memoizedState = a : $fdd90c8cbe9e299b$var$Di(b, $fdd90c8cbe9e299b$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $fdd90c8cbe9e299b$var$gi($fdd90c8cbe9e299b$var$ei)[0], b = $fdd90c8cbe9e299b$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $fdd90c8cbe9e299b$var$hi,
    useSyncExternalStore: $fdd90c8cbe9e299b$var$ii,
    useId: $fdd90c8cbe9e299b$var$Fi,
    unstable_isNewReconciler: !1
};
function $fdd90c8cbe9e299b$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $fdd90c8cbe9e299b$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $fdd90c8cbe9e299b$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $fdd90c8cbe9e299b$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $fdd90c8cbe9e299b$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $fdd90c8cbe9e299b$var$Oi(a, b, c) {
    c = $fdd90c8cbe9e299b$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $fdd90c8cbe9e299b$var$Pi || ($fdd90c8cbe9e299b$var$Pi = !0, $fdd90c8cbe9e299b$var$Qi = d);
        $fdd90c8cbe9e299b$var$Mi(a, b);
    };
    return c;
}
function $fdd90c8cbe9e299b$var$Ri(a, b, c) {
    c = $fdd90c8cbe9e299b$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $fdd90c8cbe9e299b$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $fdd90c8cbe9e299b$var$Mi(a, b);
        "function" !== typeof d && (null === $fdd90c8cbe9e299b$var$Si ? $fdd90c8cbe9e299b$var$Si = new Set([
            this
        ]) : $fdd90c8cbe9e299b$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $fdd90c8cbe9e299b$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $fdd90c8cbe9e299b$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $fdd90c8cbe9e299b$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $fdd90c8cbe9e299b$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $fdd90c8cbe9e299b$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $fdd90c8cbe9e299b$var$ch(-1, 1), b.tag = 2, $fdd90c8cbe9e299b$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $fdd90c8cbe9e299b$var$Xi = $fdd90c8cbe9e299b$var$ua.ReactCurrentOwner, $fdd90c8cbe9e299b$var$Ug = !1;
function $fdd90c8cbe9e299b$var$Yi(a, b, c, d) {
    b.child = null === a ? $fdd90c8cbe9e299b$var$Ch(b, null, c, d) : $fdd90c8cbe9e299b$var$Bh(b, a.child, c, d);
}
function $fdd90c8cbe9e299b$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $fdd90c8cbe9e299b$var$Tg(b, e);
    d = $fdd90c8cbe9e299b$var$Xh(a, b, c, d, f, e);
    c = $fdd90c8cbe9e299b$var$bi();
    if (null !== a && !$fdd90c8cbe9e299b$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $fdd90c8cbe9e299b$var$$i(a, b, e);
    $fdd90c8cbe9e299b$var$I && c && $fdd90c8cbe9e299b$var$vg(b);
    b.flags |= 1;
    $fdd90c8cbe9e299b$var$Yi(a, b, d, e);
    return b.child;
}
function $fdd90c8cbe9e299b$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$fdd90c8cbe9e299b$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $fdd90c8cbe9e299b$var$cj(a, b, f, d, e);
        a = $fdd90c8cbe9e299b$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $fdd90c8cbe9e299b$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $fdd90c8cbe9e299b$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $fdd90c8cbe9e299b$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $fdd90c8cbe9e299b$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($fdd90c8cbe9e299b$var$Ie(f, d) && a.ref === b.ref) {
            if ($fdd90c8cbe9e299b$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($fdd90c8cbe9e299b$var$Ug = !0);
            else return b.lanes = a.lanes, $fdd90c8cbe9e299b$var$$i(a, b, e);
        }
    }
    return $fdd90c8cbe9e299b$var$dj(a, b, c, d, e);
}
function $fdd90c8cbe9e299b$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$fj, $fdd90c8cbe9e299b$var$gj), $fdd90c8cbe9e299b$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$fj, $fdd90c8cbe9e299b$var$gj), $fdd90c8cbe9e299b$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$fj, $fdd90c8cbe9e299b$var$gj);
            $fdd90c8cbe9e299b$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$fj, $fdd90c8cbe9e299b$var$gj), $fdd90c8cbe9e299b$var$gj |= d;
    $fdd90c8cbe9e299b$var$Yi(a, b, e, c);
    return b.child;
}
function $fdd90c8cbe9e299b$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $fdd90c8cbe9e299b$var$dj(a, b, c, d, e) {
    var f = $fdd90c8cbe9e299b$var$Zf(c) ? $fdd90c8cbe9e299b$var$Xf : $fdd90c8cbe9e299b$var$H.current;
    f = $fdd90c8cbe9e299b$var$Yf(b, f);
    $fdd90c8cbe9e299b$var$Tg(b, e);
    c = $fdd90c8cbe9e299b$var$Xh(a, b, c, d, f, e);
    d = $fdd90c8cbe9e299b$var$bi();
    if (null !== a && !$fdd90c8cbe9e299b$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $fdd90c8cbe9e299b$var$$i(a, b, e);
    $fdd90c8cbe9e299b$var$I && d && $fdd90c8cbe9e299b$var$vg(b);
    b.flags |= 1;
    $fdd90c8cbe9e299b$var$Yi(a, b, c, e);
    return b.child;
}
function $fdd90c8cbe9e299b$var$ij(a, b, c, d, e) {
    if ($fdd90c8cbe9e299b$var$Zf(c)) {
        var f = !0;
        $fdd90c8cbe9e299b$var$cg(b);
    } else f = !1;
    $fdd90c8cbe9e299b$var$Tg(b, e);
    if (null === b.stateNode) $fdd90c8cbe9e299b$var$jj(a, b), $fdd90c8cbe9e299b$var$ph(b, c, d), $fdd90c8cbe9e299b$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $fdd90c8cbe9e299b$var$Vg(l) : (l = $fdd90c8cbe9e299b$var$Zf(c) ? $fdd90c8cbe9e299b$var$Xf : $fdd90c8cbe9e299b$var$H.current, l = $fdd90c8cbe9e299b$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $fdd90c8cbe9e299b$var$qh(b, g, d, l);
        $fdd90c8cbe9e299b$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $fdd90c8cbe9e299b$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $fdd90c8cbe9e299b$var$Wf.current || $fdd90c8cbe9e299b$var$$g ? ("function" === typeof m && ($fdd90c8cbe9e299b$var$kh(b, c, m, d), k = b.memoizedState), (h = $fdd90c8cbe9e299b$var$$g || $fdd90c8cbe9e299b$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $fdd90c8cbe9e299b$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $fdd90c8cbe9e299b$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $fdd90c8cbe9e299b$var$Vg(k) : (k = $fdd90c8cbe9e299b$var$Zf(c) ? $fdd90c8cbe9e299b$var$Xf : $fdd90c8cbe9e299b$var$H.current, k = $fdd90c8cbe9e299b$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $fdd90c8cbe9e299b$var$qh(b, g, d, k);
        $fdd90c8cbe9e299b$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $fdd90c8cbe9e299b$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $fdd90c8cbe9e299b$var$Wf.current || $fdd90c8cbe9e299b$var$$g ? ("function" === typeof y && ($fdd90c8cbe9e299b$var$kh(b, c, y, d), n = b.memoizedState), (l = $fdd90c8cbe9e299b$var$$g || $fdd90c8cbe9e299b$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $fdd90c8cbe9e299b$var$kj(a, b, c, d, f, e);
}
function $fdd90c8cbe9e299b$var$kj(a, b, c, d, e, f) {
    $fdd90c8cbe9e299b$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $fdd90c8cbe9e299b$var$dg(b, c, !1), $fdd90c8cbe9e299b$var$$i(a, b, f);
    d = b.stateNode;
    $fdd90c8cbe9e299b$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $fdd90c8cbe9e299b$var$Bh(b, a.child, null, f), b.child = $fdd90c8cbe9e299b$var$Bh(b, null, h, f)) : $fdd90c8cbe9e299b$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $fdd90c8cbe9e299b$var$dg(b, c, !0);
    return b.child;
}
function $fdd90c8cbe9e299b$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $fdd90c8cbe9e299b$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $fdd90c8cbe9e299b$var$ag(a, b.context, !1);
    $fdd90c8cbe9e299b$var$Ih(a, b.containerInfo);
}
function $fdd90c8cbe9e299b$var$mj(a, b, c, d, e) {
    $fdd90c8cbe9e299b$var$Ig();
    $fdd90c8cbe9e299b$var$Jg(e);
    b.flags |= 256;
    $fdd90c8cbe9e299b$var$Yi(a, b, c, d);
    return b.child;
}
var $fdd90c8cbe9e299b$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $fdd90c8cbe9e299b$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $fdd90c8cbe9e299b$var$pj(a, b, c) {
    var d = b.pendingProps, e = $fdd90c8cbe9e299b$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$M, e & 1);
    if (null === a) {
        $fdd90c8cbe9e299b$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $fdd90c8cbe9e299b$var$qj(g, d, 0, null), a = $fdd90c8cbe9e299b$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $fdd90c8cbe9e299b$var$oj(c), b.memoizedState = $fdd90c8cbe9e299b$var$nj, a) : $fdd90c8cbe9e299b$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $fdd90c8cbe9e299b$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $fdd90c8cbe9e299b$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $fdd90c8cbe9e299b$var$wh(h, f) : (f = $fdd90c8cbe9e299b$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $fdd90c8cbe9e299b$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $fdd90c8cbe9e299b$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $fdd90c8cbe9e299b$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $fdd90c8cbe9e299b$var$rj(a, b) {
    b = $fdd90c8cbe9e299b$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $fdd90c8cbe9e299b$var$tj(a, b, c, d) {
    null !== d && $fdd90c8cbe9e299b$var$Jg(d);
    $fdd90c8cbe9e299b$var$Bh(b, a.child, null, c);
    a = $fdd90c8cbe9e299b$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $fdd90c8cbe9e299b$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $fdd90c8cbe9e299b$var$Li(Error($fdd90c8cbe9e299b$var$p(422))), $fdd90c8cbe9e299b$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $fdd90c8cbe9e299b$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $fdd90c8cbe9e299b$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $fdd90c8cbe9e299b$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $fdd90c8cbe9e299b$var$oj(g);
        b.memoizedState = $fdd90c8cbe9e299b$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $fdd90c8cbe9e299b$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($fdd90c8cbe9e299b$var$p(419));
        d = $fdd90c8cbe9e299b$var$Li(f, d, void 0);
        return $fdd90c8cbe9e299b$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($fdd90c8cbe9e299b$var$Ug || h) {
        d = $fdd90c8cbe9e299b$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $fdd90c8cbe9e299b$var$Zg(a, e), $fdd90c8cbe9e299b$var$mh(d, a, e, -1));
        }
        $fdd90c8cbe9e299b$var$uj();
        d = $fdd90c8cbe9e299b$var$Li(Error($fdd90c8cbe9e299b$var$p(421)));
        return $fdd90c8cbe9e299b$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $fdd90c8cbe9e299b$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $fdd90c8cbe9e299b$var$yg = $fdd90c8cbe9e299b$var$Lf(e.nextSibling);
    $fdd90c8cbe9e299b$var$xg = b;
    $fdd90c8cbe9e299b$var$I = !0;
    $fdd90c8cbe9e299b$var$zg = null;
    null !== a && ($fdd90c8cbe9e299b$var$og[$fdd90c8cbe9e299b$var$pg++] = $fdd90c8cbe9e299b$var$rg, $fdd90c8cbe9e299b$var$og[$fdd90c8cbe9e299b$var$pg++] = $fdd90c8cbe9e299b$var$sg, $fdd90c8cbe9e299b$var$og[$fdd90c8cbe9e299b$var$pg++] = $fdd90c8cbe9e299b$var$qg, $fdd90c8cbe9e299b$var$rg = a.id, $fdd90c8cbe9e299b$var$sg = a.overflow, $fdd90c8cbe9e299b$var$qg = b);
    b = $fdd90c8cbe9e299b$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $fdd90c8cbe9e299b$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $fdd90c8cbe9e299b$var$Sg(a.return, b, c);
}
function $fdd90c8cbe9e299b$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $fdd90c8cbe9e299b$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $fdd90c8cbe9e299b$var$Yi(a, b, d.children, c);
    d = $fdd90c8cbe9e299b$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $fdd90c8cbe9e299b$var$wj(a, c, b);
            else if (19 === a.tag) $fdd90c8cbe9e299b$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $fdd90c8cbe9e299b$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $fdd90c8cbe9e299b$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $fdd90c8cbe9e299b$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $fdd90c8cbe9e299b$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $fdd90c8cbe9e299b$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $fdd90c8cbe9e299b$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $fdd90c8cbe9e299b$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $fdd90c8cbe9e299b$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($fdd90c8cbe9e299b$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $fdd90c8cbe9e299b$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $fdd90c8cbe9e299b$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $fdd90c8cbe9e299b$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $fdd90c8cbe9e299b$var$lj(b);
            $fdd90c8cbe9e299b$var$Ig();
            break;
        case 5:
            $fdd90c8cbe9e299b$var$Kh(b);
            break;
        case 1:
            $fdd90c8cbe9e299b$var$Zf(b.type) && $fdd90c8cbe9e299b$var$cg(b);
            break;
        case 4:
            $fdd90c8cbe9e299b$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$M, $fdd90c8cbe9e299b$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $fdd90c8cbe9e299b$var$pj(a, b, c);
                $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$M, $fdd90c8cbe9e299b$var$M.current & 1);
                a = $fdd90c8cbe9e299b$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$M, $fdd90c8cbe9e299b$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $fdd90c8cbe9e299b$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$M, $fdd90c8cbe9e299b$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $fdd90c8cbe9e299b$var$ej(a, b, c);
    }
    return $fdd90c8cbe9e299b$var$$i(a, b, c);
}
var $fdd90c8cbe9e299b$var$Aj, $fdd90c8cbe9e299b$var$Bj, $fdd90c8cbe9e299b$var$Cj, $fdd90c8cbe9e299b$var$Dj;
$fdd90c8cbe9e299b$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$fdd90c8cbe9e299b$var$Bj = function() {};
$fdd90c8cbe9e299b$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $fdd90c8cbe9e299b$var$Hh($fdd90c8cbe9e299b$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $fdd90c8cbe9e299b$var$Ya(a, e);
                d = $fdd90c8cbe9e299b$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $fdd90c8cbe9e299b$var$A({}, e, {
                    value: void 0
                });
                d = $fdd90c8cbe9e299b$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $fdd90c8cbe9e299b$var$gb(a, e);
                d = $fdd90c8cbe9e299b$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $fdd90c8cbe9e299b$var$Bf);
        }
        $fdd90c8cbe9e299b$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($fdd90c8cbe9e299b$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($fdd90c8cbe9e299b$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $fdd90c8cbe9e299b$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$fdd90c8cbe9e299b$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $fdd90c8cbe9e299b$var$Ej(a, b) {
    if (!$fdd90c8cbe9e299b$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $fdd90c8cbe9e299b$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $fdd90c8cbe9e299b$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $fdd90c8cbe9e299b$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $fdd90c8cbe9e299b$var$S(b), null;
        case 1:
            return $fdd90c8cbe9e299b$var$Zf(b.type) && $fdd90c8cbe9e299b$var$$f(), $fdd90c8cbe9e299b$var$S(b), null;
        case 3:
            d = b.stateNode;
            $fdd90c8cbe9e299b$var$Jh();
            $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Wf);
            $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$H);
            $fdd90c8cbe9e299b$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $fdd90c8cbe9e299b$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $fdd90c8cbe9e299b$var$zg && ($fdd90c8cbe9e299b$var$Gj($fdd90c8cbe9e299b$var$zg), $fdd90c8cbe9e299b$var$zg = null));
            $fdd90c8cbe9e299b$var$Bj(a, b);
            $fdd90c8cbe9e299b$var$S(b);
            return null;
        case 5:
            $fdd90c8cbe9e299b$var$Lh(b);
            var e = $fdd90c8cbe9e299b$var$Hh($fdd90c8cbe9e299b$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $fdd90c8cbe9e299b$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($fdd90c8cbe9e299b$var$p(166));
                    $fdd90c8cbe9e299b$var$S(b);
                    return null;
                }
                a = $fdd90c8cbe9e299b$var$Hh($fdd90c8cbe9e299b$var$Eh.current);
                if ($fdd90c8cbe9e299b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$fdd90c8cbe9e299b$var$Of] = b;
                    d[$fdd90c8cbe9e299b$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $fdd90c8cbe9e299b$var$D("cancel", d);
                            $fdd90c8cbe9e299b$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $fdd90c8cbe9e299b$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $fdd90c8cbe9e299b$var$lf.length; e++)$fdd90c8cbe9e299b$var$D($fdd90c8cbe9e299b$var$lf[e], d);
                            break;
                        case "source":
                            $fdd90c8cbe9e299b$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $fdd90c8cbe9e299b$var$D("error", d);
                            $fdd90c8cbe9e299b$var$D("load", d);
                            break;
                        case "details":
                            $fdd90c8cbe9e299b$var$D("toggle", d);
                            break;
                        case "input":
                            $fdd90c8cbe9e299b$var$Za(d, f);
                            $fdd90c8cbe9e299b$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $fdd90c8cbe9e299b$var$D("invalid", d);
                            break;
                        case "textarea":
                            $fdd90c8cbe9e299b$var$hb(d, f), $fdd90c8cbe9e299b$var$D("invalid", d);
                    }
                    $fdd90c8cbe9e299b$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $fdd90c8cbe9e299b$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $fdd90c8cbe9e299b$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $fdd90c8cbe9e299b$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $fdd90c8cbe9e299b$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $fdd90c8cbe9e299b$var$Va(d);
                            $fdd90c8cbe9e299b$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $fdd90c8cbe9e299b$var$Va(d);
                            $fdd90c8cbe9e299b$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $fdd90c8cbe9e299b$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $fdd90c8cbe9e299b$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$fdd90c8cbe9e299b$var$Of] = b;
                    a[$fdd90c8cbe9e299b$var$Pf] = d;
                    $fdd90c8cbe9e299b$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $fdd90c8cbe9e299b$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $fdd90c8cbe9e299b$var$D("cancel", a);
                                $fdd90c8cbe9e299b$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $fdd90c8cbe9e299b$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $fdd90c8cbe9e299b$var$lf.length; e++)$fdd90c8cbe9e299b$var$D($fdd90c8cbe9e299b$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $fdd90c8cbe9e299b$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $fdd90c8cbe9e299b$var$D("error", a);
                                $fdd90c8cbe9e299b$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $fdd90c8cbe9e299b$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $fdd90c8cbe9e299b$var$Za(a, d);
                                e = $fdd90c8cbe9e299b$var$Ya(a, d);
                                $fdd90c8cbe9e299b$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $fdd90c8cbe9e299b$var$A({}, d, {
                                    value: void 0
                                });
                                $fdd90c8cbe9e299b$var$D("invalid", a);
                                break;
                            case "textarea":
                                $fdd90c8cbe9e299b$var$hb(a, d);
                                e = $fdd90c8cbe9e299b$var$gb(a, d);
                                $fdd90c8cbe9e299b$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $fdd90c8cbe9e299b$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $fdd90c8cbe9e299b$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $fdd90c8cbe9e299b$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $fdd90c8cbe9e299b$var$ob(a, k) : "number" === typeof k && $fdd90c8cbe9e299b$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($fdd90c8cbe9e299b$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $fdd90c8cbe9e299b$var$D("scroll", a) : null != k && $fdd90c8cbe9e299b$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $fdd90c8cbe9e299b$var$Va(a);
                                $fdd90c8cbe9e299b$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $fdd90c8cbe9e299b$var$Va(a);
                                $fdd90c8cbe9e299b$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $fdd90c8cbe9e299b$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $fdd90c8cbe9e299b$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $fdd90c8cbe9e299b$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $fdd90c8cbe9e299b$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $fdd90c8cbe9e299b$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $fdd90c8cbe9e299b$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($fdd90c8cbe9e299b$var$p(166));
                c = $fdd90c8cbe9e299b$var$Hh($fdd90c8cbe9e299b$var$Gh.current);
                $fdd90c8cbe9e299b$var$Hh($fdd90c8cbe9e299b$var$Eh.current);
                if ($fdd90c8cbe9e299b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$fdd90c8cbe9e299b$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $fdd90c8cbe9e299b$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $fdd90c8cbe9e299b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $fdd90c8cbe9e299b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$fdd90c8cbe9e299b$var$Of] = b, b.stateNode = d;
            }
            $fdd90c8cbe9e299b$var$S(b);
            return null;
        case 13:
            $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($fdd90c8cbe9e299b$var$I && null !== $fdd90c8cbe9e299b$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $fdd90c8cbe9e299b$var$Hg(), $fdd90c8cbe9e299b$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $fdd90c8cbe9e299b$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($fdd90c8cbe9e299b$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($fdd90c8cbe9e299b$var$p(317));
                        f[$fdd90c8cbe9e299b$var$Of] = b;
                    } else $fdd90c8cbe9e299b$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $fdd90c8cbe9e299b$var$S(b);
                    f = !1;
                } else null !== $fdd90c8cbe9e299b$var$zg && ($fdd90c8cbe9e299b$var$Gj($fdd90c8cbe9e299b$var$zg), $fdd90c8cbe9e299b$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($fdd90c8cbe9e299b$var$M.current & 1) ? 0 === $fdd90c8cbe9e299b$var$T && ($fdd90c8cbe9e299b$var$T = 3) : $fdd90c8cbe9e299b$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $fdd90c8cbe9e299b$var$S(b);
            return null;
        case 4:
            return $fdd90c8cbe9e299b$var$Jh(), $fdd90c8cbe9e299b$var$Bj(a, b), null === a && $fdd90c8cbe9e299b$var$sf(b.stateNode.containerInfo), $fdd90c8cbe9e299b$var$S(b), null;
        case 10:
            return $fdd90c8cbe9e299b$var$Rg(b.type._context), $fdd90c8cbe9e299b$var$S(b), null;
        case 17:
            return $fdd90c8cbe9e299b$var$Zf(b.type) && $fdd90c8cbe9e299b$var$$f(), $fdd90c8cbe9e299b$var$S(b), null;
        case 19:
            $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$M);
            f = b.memoizedState;
            if (null === f) return $fdd90c8cbe9e299b$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $fdd90c8cbe9e299b$var$Ej(f, !1);
                else {
                    if (0 !== $fdd90c8cbe9e299b$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $fdd90c8cbe9e299b$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $fdd90c8cbe9e299b$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$M, $fdd90c8cbe9e299b$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $fdd90c8cbe9e299b$var$B() > $fdd90c8cbe9e299b$var$Hj && (b.flags |= 128, d = !0, $fdd90c8cbe9e299b$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $fdd90c8cbe9e299b$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $fdd90c8cbe9e299b$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$fdd90c8cbe9e299b$var$I) return $fdd90c8cbe9e299b$var$S(b), null;
                    } else 2 * $fdd90c8cbe9e299b$var$B() - f.renderingStartTime > $fdd90c8cbe9e299b$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $fdd90c8cbe9e299b$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $fdd90c8cbe9e299b$var$B(), b.sibling = null, c = $fdd90c8cbe9e299b$var$M.current, $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$M, d ? c & 1 | 2 : c & 1), b;
            $fdd90c8cbe9e299b$var$S(b);
            return null;
        case 22:
        case 23:
            return $fdd90c8cbe9e299b$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($fdd90c8cbe9e299b$var$gj & 1073741824) && ($fdd90c8cbe9e299b$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $fdd90c8cbe9e299b$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($fdd90c8cbe9e299b$var$p(156, b.tag));
}
function $fdd90c8cbe9e299b$var$Jj(a, b) {
    $fdd90c8cbe9e299b$var$wg(b);
    switch(b.tag){
        case 1:
            return $fdd90c8cbe9e299b$var$Zf(b.type) && $fdd90c8cbe9e299b$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $fdd90c8cbe9e299b$var$Jh(), $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Wf), $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$H), $fdd90c8cbe9e299b$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $fdd90c8cbe9e299b$var$Lh(b), null;
        case 13:
            $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($fdd90c8cbe9e299b$var$p(340));
                $fdd90c8cbe9e299b$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$M), null;
        case 4:
            return $fdd90c8cbe9e299b$var$Jh(), null;
        case 10:
            return $fdd90c8cbe9e299b$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $fdd90c8cbe9e299b$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $fdd90c8cbe9e299b$var$Kj = !1, $fdd90c8cbe9e299b$var$U = !1, $fdd90c8cbe9e299b$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $fdd90c8cbe9e299b$var$V = null;
function $fdd90c8cbe9e299b$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $fdd90c8cbe9e299b$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $fdd90c8cbe9e299b$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $fdd90c8cbe9e299b$var$W(a, b, d);
    }
}
var $fdd90c8cbe9e299b$var$Oj = !1;
function $fdd90c8cbe9e299b$var$Pj(a, b) {
    $fdd90c8cbe9e299b$var$Cf = $fdd90c8cbe9e299b$var$dd;
    a = $fdd90c8cbe9e299b$var$Me();
    if ($fdd90c8cbe9e299b$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $fdd90c8cbe9e299b$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $fdd90c8cbe9e299b$var$dd = !1;
    for($fdd90c8cbe9e299b$var$V = b; null !== $fdd90c8cbe9e299b$var$V;)if (b = $fdd90c8cbe9e299b$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $fdd90c8cbe9e299b$var$V = a;
    else for(; null !== $fdd90c8cbe9e299b$var$V;){
        b = $fdd90c8cbe9e299b$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $fdd90c8cbe9e299b$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($fdd90c8cbe9e299b$var$p(163));
            }
        } catch (F) {
            $fdd90c8cbe9e299b$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $fdd90c8cbe9e299b$var$V = a;
            break;
        }
        $fdd90c8cbe9e299b$var$V = b.return;
    }
    n = $fdd90c8cbe9e299b$var$Oj;
    $fdd90c8cbe9e299b$var$Oj = !1;
    return n;
}
function $fdd90c8cbe9e299b$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $fdd90c8cbe9e299b$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $fdd90c8cbe9e299b$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $fdd90c8cbe9e299b$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $fdd90c8cbe9e299b$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $fdd90c8cbe9e299b$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$fdd90c8cbe9e299b$var$Of], delete b[$fdd90c8cbe9e299b$var$Pf], delete b[$fdd90c8cbe9e299b$var$of], delete b[$fdd90c8cbe9e299b$var$Qf], delete b[$fdd90c8cbe9e299b$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $fdd90c8cbe9e299b$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $fdd90c8cbe9e299b$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $fdd90c8cbe9e299b$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $fdd90c8cbe9e299b$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $fdd90c8cbe9e299b$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($fdd90c8cbe9e299b$var$Wj(a, b, c), a = a.sibling; null !== a;)$fdd90c8cbe9e299b$var$Wj(a, b, c), a = a.sibling;
}
function $fdd90c8cbe9e299b$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($fdd90c8cbe9e299b$var$Xj(a, b, c), a = a.sibling; null !== a;)$fdd90c8cbe9e299b$var$Xj(a, b, c), a = a.sibling;
}
var $fdd90c8cbe9e299b$var$X = null, $fdd90c8cbe9e299b$var$Yj = !1;
function $fdd90c8cbe9e299b$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$fdd90c8cbe9e299b$var$ak(a, b, c), c = c.sibling;
}
function $fdd90c8cbe9e299b$var$ak(a, b, c) {
    if ($fdd90c8cbe9e299b$var$lc && "function" === typeof $fdd90c8cbe9e299b$var$lc.onCommitFiberUnmount) try {
        $fdd90c8cbe9e299b$var$lc.onCommitFiberUnmount($fdd90c8cbe9e299b$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $fdd90c8cbe9e299b$var$U || $fdd90c8cbe9e299b$var$Mj(c, b);
        case 6:
            var d = $fdd90c8cbe9e299b$var$X, e = $fdd90c8cbe9e299b$var$Yj;
            $fdd90c8cbe9e299b$var$X = null;
            $fdd90c8cbe9e299b$var$Zj(a, b, c);
            $fdd90c8cbe9e299b$var$X = d;
            $fdd90c8cbe9e299b$var$Yj = e;
            null !== $fdd90c8cbe9e299b$var$X && ($fdd90c8cbe9e299b$var$Yj ? (a = $fdd90c8cbe9e299b$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $fdd90c8cbe9e299b$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $fdd90c8cbe9e299b$var$X && ($fdd90c8cbe9e299b$var$Yj ? (a = $fdd90c8cbe9e299b$var$X, c = c.stateNode, 8 === a.nodeType ? $fdd90c8cbe9e299b$var$Kf(a.parentNode, c) : 1 === a.nodeType && $fdd90c8cbe9e299b$var$Kf(a, c), $fdd90c8cbe9e299b$var$bd(a)) : $fdd90c8cbe9e299b$var$Kf($fdd90c8cbe9e299b$var$X, c.stateNode));
            break;
        case 4:
            d = $fdd90c8cbe9e299b$var$X;
            e = $fdd90c8cbe9e299b$var$Yj;
            $fdd90c8cbe9e299b$var$X = c.stateNode.containerInfo;
            $fdd90c8cbe9e299b$var$Yj = !0;
            $fdd90c8cbe9e299b$var$Zj(a, b, c);
            $fdd90c8cbe9e299b$var$X = d;
            $fdd90c8cbe9e299b$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$fdd90c8cbe9e299b$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $fdd90c8cbe9e299b$var$Nj(c, b, g) : 0 !== (f & 4) && $fdd90c8cbe9e299b$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $fdd90c8cbe9e299b$var$Zj(a, b, c);
            break;
        case 1:
            if (!$fdd90c8cbe9e299b$var$U && ($fdd90c8cbe9e299b$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $fdd90c8cbe9e299b$var$W(c, b, h);
            }
            $fdd90c8cbe9e299b$var$Zj(a, b, c);
            break;
        case 21:
            $fdd90c8cbe9e299b$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($fdd90c8cbe9e299b$var$U = (d = $fdd90c8cbe9e299b$var$U) || null !== c.memoizedState, $fdd90c8cbe9e299b$var$Zj(a, b, c), $fdd90c8cbe9e299b$var$U = d) : $fdd90c8cbe9e299b$var$Zj(a, b, c);
            break;
        default:
            $fdd90c8cbe9e299b$var$Zj(a, b, c);
    }
}
function $fdd90c8cbe9e299b$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $fdd90c8cbe9e299b$var$Lj);
        b.forEach(function(b) {
            var d = $fdd90c8cbe9e299b$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $fdd90c8cbe9e299b$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $fdd90c8cbe9e299b$var$X = h.stateNode;
                        $fdd90c8cbe9e299b$var$Yj = !1;
                        break a;
                    case 3:
                        $fdd90c8cbe9e299b$var$X = h.stateNode.containerInfo;
                        $fdd90c8cbe9e299b$var$Yj = !0;
                        break a;
                    case 4:
                        $fdd90c8cbe9e299b$var$X = h.stateNode.containerInfo;
                        $fdd90c8cbe9e299b$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $fdd90c8cbe9e299b$var$X) throw Error($fdd90c8cbe9e299b$var$p(160));
            $fdd90c8cbe9e299b$var$ak(f, g, e);
            $fdd90c8cbe9e299b$var$X = null;
            $fdd90c8cbe9e299b$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $fdd90c8cbe9e299b$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$fdd90c8cbe9e299b$var$ek(b, a), b = b.sibling;
}
function $fdd90c8cbe9e299b$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $fdd90c8cbe9e299b$var$dk(b, a);
            $fdd90c8cbe9e299b$var$fk(a);
            if (d & 4) {
                try {
                    $fdd90c8cbe9e299b$var$Qj(3, a, a.return), $fdd90c8cbe9e299b$var$Rj(3, a);
                } catch (t) {
                    $fdd90c8cbe9e299b$var$W(a, a.return, t);
                }
                try {
                    $fdd90c8cbe9e299b$var$Qj(5, a, a.return);
                } catch (t) {
                    $fdd90c8cbe9e299b$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $fdd90c8cbe9e299b$var$dk(b, a);
            $fdd90c8cbe9e299b$var$fk(a);
            d & 512 && null !== c && $fdd90c8cbe9e299b$var$Mj(c, c.return);
            break;
        case 5:
            $fdd90c8cbe9e299b$var$dk(b, a);
            $fdd90c8cbe9e299b$var$fk(a);
            d & 512 && null !== c && $fdd90c8cbe9e299b$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $fdd90c8cbe9e299b$var$ob(e, "");
                } catch (t) {
                    $fdd90c8cbe9e299b$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $fdd90c8cbe9e299b$var$ab(e, f);
                    $fdd90c8cbe9e299b$var$vb(h, g);
                    var l = $fdd90c8cbe9e299b$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $fdd90c8cbe9e299b$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $fdd90c8cbe9e299b$var$nb(e, q) : "children" === m ? $fdd90c8cbe9e299b$var$ob(e, q) : $fdd90c8cbe9e299b$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $fdd90c8cbe9e299b$var$bb(e, f);
                            break;
                        case "textarea":
                            $fdd90c8cbe9e299b$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $fdd90c8cbe9e299b$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $fdd90c8cbe9e299b$var$fb(e, !!f.multiple, f.defaultValue, !0) : $fdd90c8cbe9e299b$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$fdd90c8cbe9e299b$var$Pf] = f;
                } catch (t) {
                    $fdd90c8cbe9e299b$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $fdd90c8cbe9e299b$var$dk(b, a);
            $fdd90c8cbe9e299b$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($fdd90c8cbe9e299b$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $fdd90c8cbe9e299b$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $fdd90c8cbe9e299b$var$dk(b, a);
            $fdd90c8cbe9e299b$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $fdd90c8cbe9e299b$var$bd(b.containerInfo);
            } catch (t) {
                $fdd90c8cbe9e299b$var$W(a, a.return, t);
            }
            break;
        case 4:
            $fdd90c8cbe9e299b$var$dk(b, a);
            $fdd90c8cbe9e299b$var$fk(a);
            break;
        case 13:
            $fdd90c8cbe9e299b$var$dk(b, a);
            $fdd90c8cbe9e299b$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($fdd90c8cbe9e299b$var$gk = $fdd90c8cbe9e299b$var$B()));
            d & 4 && $fdd90c8cbe9e299b$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($fdd90c8cbe9e299b$var$U = (l = $fdd90c8cbe9e299b$var$U) || m, $fdd90c8cbe9e299b$var$dk(b, a), $fdd90c8cbe9e299b$var$U = l) : $fdd90c8cbe9e299b$var$dk(b, a);
            $fdd90c8cbe9e299b$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($fdd90c8cbe9e299b$var$V = a, m = a.child; null !== m;){
                    for(q = $fdd90c8cbe9e299b$var$V = m; null !== $fdd90c8cbe9e299b$var$V;){
                        r = $fdd90c8cbe9e299b$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $fdd90c8cbe9e299b$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $fdd90c8cbe9e299b$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $fdd90c8cbe9e299b$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $fdd90c8cbe9e299b$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $fdd90c8cbe9e299b$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $fdd90c8cbe9e299b$var$V = y) : $fdd90c8cbe9e299b$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $fdd90c8cbe9e299b$var$rb("display", g));
                            } catch (t) {
                                $fdd90c8cbe9e299b$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $fdd90c8cbe9e299b$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $fdd90c8cbe9e299b$var$dk(b, a);
            $fdd90c8cbe9e299b$var$fk(a);
            d & 4 && $fdd90c8cbe9e299b$var$bk(a);
            break;
        case 21:
            break;
        default:
            $fdd90c8cbe9e299b$var$dk(b, a), $fdd90c8cbe9e299b$var$fk(a);
    }
}
function $fdd90c8cbe9e299b$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($fdd90c8cbe9e299b$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($fdd90c8cbe9e299b$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($fdd90c8cbe9e299b$var$ob(e, ""), d.flags &= -33);
                    var f = $fdd90c8cbe9e299b$var$Vj(a);
                    $fdd90c8cbe9e299b$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $fdd90c8cbe9e299b$var$Vj(a);
                    $fdd90c8cbe9e299b$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($fdd90c8cbe9e299b$var$p(161));
            }
        } catch (k) {
            $fdd90c8cbe9e299b$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $fdd90c8cbe9e299b$var$ik(a, b, c) {
    $fdd90c8cbe9e299b$var$V = a;
    $fdd90c8cbe9e299b$var$jk(a, b, c);
}
function $fdd90c8cbe9e299b$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $fdd90c8cbe9e299b$var$V;){
        var e = $fdd90c8cbe9e299b$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $fdd90c8cbe9e299b$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $fdd90c8cbe9e299b$var$U;
                h = $fdd90c8cbe9e299b$var$Kj;
                var l = $fdd90c8cbe9e299b$var$U;
                $fdd90c8cbe9e299b$var$Kj = g;
                if (($fdd90c8cbe9e299b$var$U = k) && !l) for($fdd90c8cbe9e299b$var$V = e; null !== $fdd90c8cbe9e299b$var$V;)g = $fdd90c8cbe9e299b$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $fdd90c8cbe9e299b$var$kk(e) : null !== k ? (k.return = g, $fdd90c8cbe9e299b$var$V = k) : $fdd90c8cbe9e299b$var$kk(e);
                for(; null !== f;)$fdd90c8cbe9e299b$var$V = f, $fdd90c8cbe9e299b$var$jk(f, b, c), f = f.sibling;
                $fdd90c8cbe9e299b$var$V = e;
                $fdd90c8cbe9e299b$var$Kj = h;
                $fdd90c8cbe9e299b$var$U = l;
            }
            $fdd90c8cbe9e299b$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $fdd90c8cbe9e299b$var$V = f) : $fdd90c8cbe9e299b$var$lk(a, b, c);
    }
}
function $fdd90c8cbe9e299b$var$lk(a) {
    for(; null !== $fdd90c8cbe9e299b$var$V;){
        var b = $fdd90c8cbe9e299b$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $fdd90c8cbe9e299b$var$U || $fdd90c8cbe9e299b$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$fdd90c8cbe9e299b$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $fdd90c8cbe9e299b$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $fdd90c8cbe9e299b$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $fdd90c8cbe9e299b$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $fdd90c8cbe9e299b$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($fdd90c8cbe9e299b$var$p(163));
                }
                $fdd90c8cbe9e299b$var$U || b.flags & 512 && $fdd90c8cbe9e299b$var$Sj(b);
            } catch (r) {
                $fdd90c8cbe9e299b$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $fdd90c8cbe9e299b$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $fdd90c8cbe9e299b$var$V = c;
            break;
        }
        $fdd90c8cbe9e299b$var$V = b.return;
    }
}
function $fdd90c8cbe9e299b$var$hk(a) {
    for(; null !== $fdd90c8cbe9e299b$var$V;){
        var b = $fdd90c8cbe9e299b$var$V;
        if (b === a) {
            $fdd90c8cbe9e299b$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $fdd90c8cbe9e299b$var$V = c;
            break;
        }
        $fdd90c8cbe9e299b$var$V = b.return;
    }
}
function $fdd90c8cbe9e299b$var$kk(a) {
    for(; null !== $fdd90c8cbe9e299b$var$V;){
        var b = $fdd90c8cbe9e299b$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $fdd90c8cbe9e299b$var$Rj(4, b);
                    } catch (k) {
                        $fdd90c8cbe9e299b$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $fdd90c8cbe9e299b$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $fdd90c8cbe9e299b$var$Sj(b);
                    } catch (k) {
                        $fdd90c8cbe9e299b$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $fdd90c8cbe9e299b$var$Sj(b);
                    } catch (k) {
                        $fdd90c8cbe9e299b$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $fdd90c8cbe9e299b$var$W(b, b.return, k);
        }
        if (b === a) {
            $fdd90c8cbe9e299b$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $fdd90c8cbe9e299b$var$V = h;
            break;
        }
        $fdd90c8cbe9e299b$var$V = b.return;
    }
}
var $fdd90c8cbe9e299b$var$mk = Math.ceil, $fdd90c8cbe9e299b$var$nk = $fdd90c8cbe9e299b$var$ua.ReactCurrentDispatcher, $fdd90c8cbe9e299b$var$ok = $fdd90c8cbe9e299b$var$ua.ReactCurrentOwner, $fdd90c8cbe9e299b$var$pk = $fdd90c8cbe9e299b$var$ua.ReactCurrentBatchConfig, $fdd90c8cbe9e299b$var$K = 0, $fdd90c8cbe9e299b$var$R = null, $fdd90c8cbe9e299b$var$Y = null, $fdd90c8cbe9e299b$var$Z = 0, $fdd90c8cbe9e299b$var$gj = 0, $fdd90c8cbe9e299b$var$fj = $fdd90c8cbe9e299b$var$Uf(0), $fdd90c8cbe9e299b$var$T = 0, $fdd90c8cbe9e299b$var$qk = null, $fdd90c8cbe9e299b$var$hh = 0, $fdd90c8cbe9e299b$var$rk = 0, $fdd90c8cbe9e299b$var$sk = 0, $fdd90c8cbe9e299b$var$tk = null, $fdd90c8cbe9e299b$var$uk = null, $fdd90c8cbe9e299b$var$gk = 0, $fdd90c8cbe9e299b$var$Hj = Infinity, $fdd90c8cbe9e299b$var$vk = null, $fdd90c8cbe9e299b$var$Pi = !1, $fdd90c8cbe9e299b$var$Qi = null, $fdd90c8cbe9e299b$var$Si = null, $fdd90c8cbe9e299b$var$wk = !1, $fdd90c8cbe9e299b$var$xk = null, $fdd90c8cbe9e299b$var$yk = 0, $fdd90c8cbe9e299b$var$zk = 0, $fdd90c8cbe9e299b$var$Ak = null, $fdd90c8cbe9e299b$var$Bk = -1, $fdd90c8cbe9e299b$var$Ck = 0;
function $fdd90c8cbe9e299b$var$L() {
    return 0 !== ($fdd90c8cbe9e299b$var$K & 6) ? $fdd90c8cbe9e299b$var$B() : -1 !== $fdd90c8cbe9e299b$var$Bk ? $fdd90c8cbe9e299b$var$Bk : $fdd90c8cbe9e299b$var$Bk = $fdd90c8cbe9e299b$var$B();
}
function $fdd90c8cbe9e299b$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($fdd90c8cbe9e299b$var$K & 2) && 0 !== $fdd90c8cbe9e299b$var$Z) return $fdd90c8cbe9e299b$var$Z & -$fdd90c8cbe9e299b$var$Z;
    if (null !== $fdd90c8cbe9e299b$var$Kg.transition) return 0 === $fdd90c8cbe9e299b$var$Ck && ($fdd90c8cbe9e299b$var$Ck = $fdd90c8cbe9e299b$var$yc()), $fdd90c8cbe9e299b$var$Ck;
    a = $fdd90c8cbe9e299b$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $fdd90c8cbe9e299b$var$jd(a.type);
    return a;
}
function $fdd90c8cbe9e299b$var$mh(a, b, c, d) {
    if (50 < $fdd90c8cbe9e299b$var$zk) throw $fdd90c8cbe9e299b$var$zk = 0, $fdd90c8cbe9e299b$var$Ak = null, Error($fdd90c8cbe9e299b$var$p(185));
    $fdd90c8cbe9e299b$var$Ac(a, c, d);
    if (0 === ($fdd90c8cbe9e299b$var$K & 2) || a !== $fdd90c8cbe9e299b$var$R) a === $fdd90c8cbe9e299b$var$R && (0 === ($fdd90c8cbe9e299b$var$K & 2) && ($fdd90c8cbe9e299b$var$rk |= c), 4 === $fdd90c8cbe9e299b$var$T && $fdd90c8cbe9e299b$var$Dk(a, $fdd90c8cbe9e299b$var$Z)), $fdd90c8cbe9e299b$var$Ek(a, d), 1 === c && 0 === $fdd90c8cbe9e299b$var$K && 0 === (b.mode & 1) && ($fdd90c8cbe9e299b$var$Hj = $fdd90c8cbe9e299b$var$B() + 500, $fdd90c8cbe9e299b$var$fg && $fdd90c8cbe9e299b$var$jg());
}
function $fdd90c8cbe9e299b$var$Ek(a, b) {
    var c = a.callbackNode;
    $fdd90c8cbe9e299b$var$wc(a, b);
    var d = $fdd90c8cbe9e299b$var$uc(a, a === $fdd90c8cbe9e299b$var$R ? $fdd90c8cbe9e299b$var$Z : 0);
    if (0 === d) null !== c && $fdd90c8cbe9e299b$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $fdd90c8cbe9e299b$var$bc(c);
        if (1 === b) 0 === a.tag ? $fdd90c8cbe9e299b$var$ig($fdd90c8cbe9e299b$var$Fk.bind(null, a)) : $fdd90c8cbe9e299b$var$hg($fdd90c8cbe9e299b$var$Fk.bind(null, a)), $fdd90c8cbe9e299b$var$Jf(function() {
            0 === ($fdd90c8cbe9e299b$var$K & 6) && $fdd90c8cbe9e299b$var$jg();
        }), c = null;
        else {
            switch($fdd90c8cbe9e299b$var$Dc(d)){
                case 1:
                    c = $fdd90c8cbe9e299b$var$fc;
                    break;
                case 4:
                    c = $fdd90c8cbe9e299b$var$gc;
                    break;
                case 16:
                    c = $fdd90c8cbe9e299b$var$hc;
                    break;
                case 536870912:
                    c = $fdd90c8cbe9e299b$var$jc;
                    break;
                default:
                    c = $fdd90c8cbe9e299b$var$hc;
            }
            c = $fdd90c8cbe9e299b$var$Gk(c, $fdd90c8cbe9e299b$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $fdd90c8cbe9e299b$var$Hk(a, b) {
    $fdd90c8cbe9e299b$var$Bk = -1;
    $fdd90c8cbe9e299b$var$Ck = 0;
    if (0 !== ($fdd90c8cbe9e299b$var$K & 6)) throw Error($fdd90c8cbe9e299b$var$p(327));
    var c = a.callbackNode;
    if ($fdd90c8cbe9e299b$var$Ik() && a.callbackNode !== c) return null;
    var d = $fdd90c8cbe9e299b$var$uc(a, a === $fdd90c8cbe9e299b$var$R ? $fdd90c8cbe9e299b$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $fdd90c8cbe9e299b$var$Jk(a, d);
    else {
        b = d;
        var e = $fdd90c8cbe9e299b$var$K;
        $fdd90c8cbe9e299b$var$K |= 2;
        var f = $fdd90c8cbe9e299b$var$Kk();
        if ($fdd90c8cbe9e299b$var$R !== a || $fdd90c8cbe9e299b$var$Z !== b) $fdd90c8cbe9e299b$var$vk = null, $fdd90c8cbe9e299b$var$Hj = $fdd90c8cbe9e299b$var$B() + 500, $fdd90c8cbe9e299b$var$Lk(a, b);
        for(;;)try {
            $fdd90c8cbe9e299b$var$Mk();
            break;
        } catch (h) {
            $fdd90c8cbe9e299b$var$Nk(a, h);
        }
        $fdd90c8cbe9e299b$var$Qg();
        $fdd90c8cbe9e299b$var$nk.current = f;
        $fdd90c8cbe9e299b$var$K = e;
        null !== $fdd90c8cbe9e299b$var$Y ? b = 0 : ($fdd90c8cbe9e299b$var$R = null, $fdd90c8cbe9e299b$var$Z = 0, b = $fdd90c8cbe9e299b$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $fdd90c8cbe9e299b$var$xc(a), 0 !== e && (d = e, b = $fdd90c8cbe9e299b$var$Ok(a, e)));
        if (1 === b) throw c = $fdd90c8cbe9e299b$var$qk, $fdd90c8cbe9e299b$var$Lk(a, 0), $fdd90c8cbe9e299b$var$Dk(a, d), $fdd90c8cbe9e299b$var$Ek(a, $fdd90c8cbe9e299b$var$B()), c;
        if (6 === b) $fdd90c8cbe9e299b$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$fdd90c8cbe9e299b$var$Pk(e) && (b = $fdd90c8cbe9e299b$var$Jk(a, d), 2 === b && (f = $fdd90c8cbe9e299b$var$xc(a), 0 !== f && (d = f, b = $fdd90c8cbe9e299b$var$Ok(a, f))), 1 === b)) throw c = $fdd90c8cbe9e299b$var$qk, $fdd90c8cbe9e299b$var$Lk(a, 0), $fdd90c8cbe9e299b$var$Dk(a, d), $fdd90c8cbe9e299b$var$Ek(a, $fdd90c8cbe9e299b$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($fdd90c8cbe9e299b$var$p(345));
                case 2:
                    $fdd90c8cbe9e299b$var$Qk(a, $fdd90c8cbe9e299b$var$uk, $fdd90c8cbe9e299b$var$vk);
                    break;
                case 3:
                    $fdd90c8cbe9e299b$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $fdd90c8cbe9e299b$var$gk + 500 - $fdd90c8cbe9e299b$var$B(), 10 < b)) {
                        if (0 !== $fdd90c8cbe9e299b$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $fdd90c8cbe9e299b$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $fdd90c8cbe9e299b$var$Ff($fdd90c8cbe9e299b$var$Qk.bind(null, a, $fdd90c8cbe9e299b$var$uk, $fdd90c8cbe9e299b$var$vk), b);
                        break;
                    }
                    $fdd90c8cbe9e299b$var$Qk(a, $fdd90c8cbe9e299b$var$uk, $fdd90c8cbe9e299b$var$vk);
                    break;
                case 4:
                    $fdd90c8cbe9e299b$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $fdd90c8cbe9e299b$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $fdd90c8cbe9e299b$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $fdd90c8cbe9e299b$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $fdd90c8cbe9e299b$var$Ff($fdd90c8cbe9e299b$var$Qk.bind(null, a, $fdd90c8cbe9e299b$var$uk, $fdd90c8cbe9e299b$var$vk), d);
                        break;
                    }
                    $fdd90c8cbe9e299b$var$Qk(a, $fdd90c8cbe9e299b$var$uk, $fdd90c8cbe9e299b$var$vk);
                    break;
                case 5:
                    $fdd90c8cbe9e299b$var$Qk(a, $fdd90c8cbe9e299b$var$uk, $fdd90c8cbe9e299b$var$vk);
                    break;
                default:
                    throw Error($fdd90c8cbe9e299b$var$p(329));
            }
        }
    }
    $fdd90c8cbe9e299b$var$Ek(a, $fdd90c8cbe9e299b$var$B());
    return a.callbackNode === c ? $fdd90c8cbe9e299b$var$Hk.bind(null, a) : null;
}
function $fdd90c8cbe9e299b$var$Ok(a, b) {
    var c = $fdd90c8cbe9e299b$var$tk;
    a.current.memoizedState.isDehydrated && ($fdd90c8cbe9e299b$var$Lk(a, b).flags |= 256);
    a = $fdd90c8cbe9e299b$var$Jk(a, b);
    2 !== a && (b = $fdd90c8cbe9e299b$var$uk, $fdd90c8cbe9e299b$var$uk = c, null !== b && $fdd90c8cbe9e299b$var$Gj(b));
    return a;
}
function $fdd90c8cbe9e299b$var$Gj(a) {
    null === $fdd90c8cbe9e299b$var$uk ? $fdd90c8cbe9e299b$var$uk = a : $fdd90c8cbe9e299b$var$uk.push.apply($fdd90c8cbe9e299b$var$uk, a);
}
function $fdd90c8cbe9e299b$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$fdd90c8cbe9e299b$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $fdd90c8cbe9e299b$var$Dk(a, b) {
    b &= ~$fdd90c8cbe9e299b$var$sk;
    b &= ~$fdd90c8cbe9e299b$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $fdd90c8cbe9e299b$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $fdd90c8cbe9e299b$var$Fk(a) {
    if (0 !== ($fdd90c8cbe9e299b$var$K & 6)) throw Error($fdd90c8cbe9e299b$var$p(327));
    $fdd90c8cbe9e299b$var$Ik();
    var b = $fdd90c8cbe9e299b$var$uc(a, 0);
    if (0 === (b & 1)) return $fdd90c8cbe9e299b$var$Ek(a, $fdd90c8cbe9e299b$var$B()), null;
    var c = $fdd90c8cbe9e299b$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $fdd90c8cbe9e299b$var$xc(a);
        0 !== d && (b = d, c = $fdd90c8cbe9e299b$var$Ok(a, d));
    }
    if (1 === c) throw c = $fdd90c8cbe9e299b$var$qk, $fdd90c8cbe9e299b$var$Lk(a, 0), $fdd90c8cbe9e299b$var$Dk(a, b), $fdd90c8cbe9e299b$var$Ek(a, $fdd90c8cbe9e299b$var$B()), c;
    if (6 === c) throw Error($fdd90c8cbe9e299b$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $fdd90c8cbe9e299b$var$Qk(a, $fdd90c8cbe9e299b$var$uk, $fdd90c8cbe9e299b$var$vk);
    $fdd90c8cbe9e299b$var$Ek(a, $fdd90c8cbe9e299b$var$B());
    return null;
}
function $fdd90c8cbe9e299b$var$Rk(a, b) {
    var c = $fdd90c8cbe9e299b$var$K;
    $fdd90c8cbe9e299b$var$K |= 1;
    try {
        return a(b);
    } finally{
        $fdd90c8cbe9e299b$var$K = c, 0 === $fdd90c8cbe9e299b$var$K && ($fdd90c8cbe9e299b$var$Hj = $fdd90c8cbe9e299b$var$B() + 500, $fdd90c8cbe9e299b$var$fg && $fdd90c8cbe9e299b$var$jg());
    }
}
function $fdd90c8cbe9e299b$var$Sk(a) {
    null !== $fdd90c8cbe9e299b$var$xk && 0 === $fdd90c8cbe9e299b$var$xk.tag && 0 === ($fdd90c8cbe9e299b$var$K & 6) && $fdd90c8cbe9e299b$var$Ik();
    var b = $fdd90c8cbe9e299b$var$K;
    $fdd90c8cbe9e299b$var$K |= 1;
    var c = $fdd90c8cbe9e299b$var$pk.transition, d = $fdd90c8cbe9e299b$var$C;
    try {
        if ($fdd90c8cbe9e299b$var$pk.transition = null, $fdd90c8cbe9e299b$var$C = 1, a) return a();
    } finally{
        $fdd90c8cbe9e299b$var$C = d, $fdd90c8cbe9e299b$var$pk.transition = c, $fdd90c8cbe9e299b$var$K = b, 0 === ($fdd90c8cbe9e299b$var$K & 6) && $fdd90c8cbe9e299b$var$jg();
    }
}
function $fdd90c8cbe9e299b$var$Ij() {
    $fdd90c8cbe9e299b$var$gj = $fdd90c8cbe9e299b$var$fj.current;
    $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$fj);
}
function $fdd90c8cbe9e299b$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $fdd90c8cbe9e299b$var$Gf(c));
    if (null !== $fdd90c8cbe9e299b$var$Y) for(c = $fdd90c8cbe9e299b$var$Y.return; null !== c;){
        var d = c;
        $fdd90c8cbe9e299b$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $fdd90c8cbe9e299b$var$$f();
                break;
            case 3:
                $fdd90c8cbe9e299b$var$Jh();
                $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Wf);
                $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$H);
                $fdd90c8cbe9e299b$var$Oh();
                break;
            case 5:
                $fdd90c8cbe9e299b$var$Lh(d);
                break;
            case 4:
                $fdd90c8cbe9e299b$var$Jh();
                break;
            case 13:
                $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$M);
                break;
            case 19:
                $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$M);
                break;
            case 10:
                $fdd90c8cbe9e299b$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $fdd90c8cbe9e299b$var$Ij();
        }
        c = c.return;
    }
    $fdd90c8cbe9e299b$var$R = a;
    $fdd90c8cbe9e299b$var$Y = a = $fdd90c8cbe9e299b$var$wh(a.current, null);
    $fdd90c8cbe9e299b$var$Z = $fdd90c8cbe9e299b$var$gj = b;
    $fdd90c8cbe9e299b$var$T = 0;
    $fdd90c8cbe9e299b$var$qk = null;
    $fdd90c8cbe9e299b$var$sk = $fdd90c8cbe9e299b$var$rk = $fdd90c8cbe9e299b$var$hh = 0;
    $fdd90c8cbe9e299b$var$uk = $fdd90c8cbe9e299b$var$tk = null;
    if (null !== $fdd90c8cbe9e299b$var$Wg) {
        for(b = 0; b < $fdd90c8cbe9e299b$var$Wg.length; b++)if (c = $fdd90c8cbe9e299b$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $fdd90c8cbe9e299b$var$Wg = null;
    }
    return a;
}
function $fdd90c8cbe9e299b$var$Nk(a, b) {
    do {
        var c = $fdd90c8cbe9e299b$var$Y;
        try {
            $fdd90c8cbe9e299b$var$Qg();
            $fdd90c8cbe9e299b$var$Ph.current = $fdd90c8cbe9e299b$var$ai;
            if ($fdd90c8cbe9e299b$var$Sh) {
                for(var d = $fdd90c8cbe9e299b$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $fdd90c8cbe9e299b$var$Sh = !1;
            }
            $fdd90c8cbe9e299b$var$Rh = 0;
            $fdd90c8cbe9e299b$var$P = $fdd90c8cbe9e299b$var$O = $fdd90c8cbe9e299b$var$N = null;
            $fdd90c8cbe9e299b$var$Th = !1;
            $fdd90c8cbe9e299b$var$Uh = 0;
            $fdd90c8cbe9e299b$var$ok.current = null;
            if (null === c || null === c.return) {
                $fdd90c8cbe9e299b$var$T = 1;
                $fdd90c8cbe9e299b$var$qk = b;
                $fdd90c8cbe9e299b$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $fdd90c8cbe9e299b$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $fdd90c8cbe9e299b$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $fdd90c8cbe9e299b$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $fdd90c8cbe9e299b$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $fdd90c8cbe9e299b$var$Ti(f, l, b);
                            $fdd90c8cbe9e299b$var$uj();
                            break a;
                        }
                        k = Error($fdd90c8cbe9e299b$var$p(426));
                    }
                } else if ($fdd90c8cbe9e299b$var$I && h.mode & 1) {
                    var J = $fdd90c8cbe9e299b$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $fdd90c8cbe9e299b$var$Wi(J, g, h, f, b);
                        $fdd90c8cbe9e299b$var$Jg($fdd90c8cbe9e299b$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $fdd90c8cbe9e299b$var$Ki(k, h);
                4 !== $fdd90c8cbe9e299b$var$T && ($fdd90c8cbe9e299b$var$T = 2);
                null === $fdd90c8cbe9e299b$var$tk ? $fdd90c8cbe9e299b$var$tk = [
                    f
                ] : $fdd90c8cbe9e299b$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $fdd90c8cbe9e299b$var$Oi(f, k, b);
                            $fdd90c8cbe9e299b$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $fdd90c8cbe9e299b$var$Si || !$fdd90c8cbe9e299b$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $fdd90c8cbe9e299b$var$Ri(f, h, b);
                                $fdd90c8cbe9e299b$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $fdd90c8cbe9e299b$var$Tk(c);
        } catch (na) {
            b = na;
            $fdd90c8cbe9e299b$var$Y === c && null !== c && ($fdd90c8cbe9e299b$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $fdd90c8cbe9e299b$var$Kk() {
    var a = $fdd90c8cbe9e299b$var$nk.current;
    $fdd90c8cbe9e299b$var$nk.current = $fdd90c8cbe9e299b$var$ai;
    return null === a ? $fdd90c8cbe9e299b$var$ai : a;
}
function $fdd90c8cbe9e299b$var$uj() {
    if (0 === $fdd90c8cbe9e299b$var$T || 3 === $fdd90c8cbe9e299b$var$T || 2 === $fdd90c8cbe9e299b$var$T) $fdd90c8cbe9e299b$var$T = 4;
    null === $fdd90c8cbe9e299b$var$R || 0 === ($fdd90c8cbe9e299b$var$hh & 268435455) && 0 === ($fdd90c8cbe9e299b$var$rk & 268435455) || $fdd90c8cbe9e299b$var$Dk($fdd90c8cbe9e299b$var$R, $fdd90c8cbe9e299b$var$Z);
}
function $fdd90c8cbe9e299b$var$Jk(a, b) {
    var c = $fdd90c8cbe9e299b$var$K;
    $fdd90c8cbe9e299b$var$K |= 2;
    var d = $fdd90c8cbe9e299b$var$Kk();
    if ($fdd90c8cbe9e299b$var$R !== a || $fdd90c8cbe9e299b$var$Z !== b) $fdd90c8cbe9e299b$var$vk = null, $fdd90c8cbe9e299b$var$Lk(a, b);
    for(;;)try {
        $fdd90c8cbe9e299b$var$Uk();
        break;
    } catch (e) {
        $fdd90c8cbe9e299b$var$Nk(a, e);
    }
    $fdd90c8cbe9e299b$var$Qg();
    $fdd90c8cbe9e299b$var$K = c;
    $fdd90c8cbe9e299b$var$nk.current = d;
    if (null !== $fdd90c8cbe9e299b$var$Y) throw Error($fdd90c8cbe9e299b$var$p(261));
    $fdd90c8cbe9e299b$var$R = null;
    $fdd90c8cbe9e299b$var$Z = 0;
    return $fdd90c8cbe9e299b$var$T;
}
function $fdd90c8cbe9e299b$var$Uk() {
    for(; null !== $fdd90c8cbe9e299b$var$Y;)$fdd90c8cbe9e299b$var$Vk($fdd90c8cbe9e299b$var$Y);
}
function $fdd90c8cbe9e299b$var$Mk() {
    for(; null !== $fdd90c8cbe9e299b$var$Y && !$fdd90c8cbe9e299b$var$cc();)$fdd90c8cbe9e299b$var$Vk($fdd90c8cbe9e299b$var$Y);
}
function $fdd90c8cbe9e299b$var$Vk(a) {
    var b = $fdd90c8cbe9e299b$var$Wk(a.alternate, a, $fdd90c8cbe9e299b$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $fdd90c8cbe9e299b$var$Tk(a) : $fdd90c8cbe9e299b$var$Y = b;
    $fdd90c8cbe9e299b$var$ok.current = null;
}
function $fdd90c8cbe9e299b$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $fdd90c8cbe9e299b$var$Fj(c, b, $fdd90c8cbe9e299b$var$gj), null !== c) {
                $fdd90c8cbe9e299b$var$Y = c;
                return;
            }
        } else {
            c = $fdd90c8cbe9e299b$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $fdd90c8cbe9e299b$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $fdd90c8cbe9e299b$var$T = 6;
                $fdd90c8cbe9e299b$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $fdd90c8cbe9e299b$var$Y = b;
            return;
        }
        $fdd90c8cbe9e299b$var$Y = b = a;
    }while (null !== b);
    0 === $fdd90c8cbe9e299b$var$T && ($fdd90c8cbe9e299b$var$T = 5);
}
function $fdd90c8cbe9e299b$var$Qk(a, b, c) {
    var d = $fdd90c8cbe9e299b$var$C, e = $fdd90c8cbe9e299b$var$pk.transition;
    try {
        $fdd90c8cbe9e299b$var$pk.transition = null, $fdd90c8cbe9e299b$var$C = 1, $fdd90c8cbe9e299b$var$Xk(a, b, c, d);
    } finally{
        $fdd90c8cbe9e299b$var$pk.transition = e, $fdd90c8cbe9e299b$var$C = d;
    }
    return null;
}
function $fdd90c8cbe9e299b$var$Xk(a, b, c, d) {
    do $fdd90c8cbe9e299b$var$Ik();
    while (null !== $fdd90c8cbe9e299b$var$xk);
    if (0 !== ($fdd90c8cbe9e299b$var$K & 6)) throw Error($fdd90c8cbe9e299b$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($fdd90c8cbe9e299b$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $fdd90c8cbe9e299b$var$Bc(a, f);
    a === $fdd90c8cbe9e299b$var$R && ($fdd90c8cbe9e299b$var$Y = $fdd90c8cbe9e299b$var$R = null, $fdd90c8cbe9e299b$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $fdd90c8cbe9e299b$var$wk || ($fdd90c8cbe9e299b$var$wk = !0, $fdd90c8cbe9e299b$var$Gk($fdd90c8cbe9e299b$var$hc, function() {
        $fdd90c8cbe9e299b$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $fdd90c8cbe9e299b$var$pk.transition;
        $fdd90c8cbe9e299b$var$pk.transition = null;
        var g = $fdd90c8cbe9e299b$var$C;
        $fdd90c8cbe9e299b$var$C = 1;
        var h = $fdd90c8cbe9e299b$var$K;
        $fdd90c8cbe9e299b$var$K |= 4;
        $fdd90c8cbe9e299b$var$ok.current = null;
        $fdd90c8cbe9e299b$var$Pj(a, c);
        $fdd90c8cbe9e299b$var$ek(c, a);
        $fdd90c8cbe9e299b$var$Oe($fdd90c8cbe9e299b$var$Df);
        $fdd90c8cbe9e299b$var$dd = !!$fdd90c8cbe9e299b$var$Cf;
        $fdd90c8cbe9e299b$var$Df = $fdd90c8cbe9e299b$var$Cf = null;
        a.current = c;
        $fdd90c8cbe9e299b$var$ik(c, a, e);
        $fdd90c8cbe9e299b$var$dc();
        $fdd90c8cbe9e299b$var$K = h;
        $fdd90c8cbe9e299b$var$C = g;
        $fdd90c8cbe9e299b$var$pk.transition = f;
    } else a.current = c;
    $fdd90c8cbe9e299b$var$wk && ($fdd90c8cbe9e299b$var$wk = !1, $fdd90c8cbe9e299b$var$xk = a, $fdd90c8cbe9e299b$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($fdd90c8cbe9e299b$var$Si = null);
    $fdd90c8cbe9e299b$var$mc(c.stateNode, d);
    $fdd90c8cbe9e299b$var$Ek(a, $fdd90c8cbe9e299b$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($fdd90c8cbe9e299b$var$Pi) throw $fdd90c8cbe9e299b$var$Pi = !1, a = $fdd90c8cbe9e299b$var$Qi, $fdd90c8cbe9e299b$var$Qi = null, a;
    0 !== ($fdd90c8cbe9e299b$var$yk & 1) && 0 !== a.tag && $fdd90c8cbe9e299b$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $fdd90c8cbe9e299b$var$Ak ? $fdd90c8cbe9e299b$var$zk++ : ($fdd90c8cbe9e299b$var$zk = 0, $fdd90c8cbe9e299b$var$Ak = a) : $fdd90c8cbe9e299b$var$zk = 0;
    $fdd90c8cbe9e299b$var$jg();
    return null;
}
function $fdd90c8cbe9e299b$var$Ik() {
    if (null !== $fdd90c8cbe9e299b$var$xk) {
        var a = $fdd90c8cbe9e299b$var$Dc($fdd90c8cbe9e299b$var$yk), b = $fdd90c8cbe9e299b$var$pk.transition, c = $fdd90c8cbe9e299b$var$C;
        try {
            $fdd90c8cbe9e299b$var$pk.transition = null;
            $fdd90c8cbe9e299b$var$C = 16 > a ? 16 : a;
            if (null === $fdd90c8cbe9e299b$var$xk) var d = !1;
            else {
                a = $fdd90c8cbe9e299b$var$xk;
                $fdd90c8cbe9e299b$var$xk = null;
                $fdd90c8cbe9e299b$var$yk = 0;
                if (0 !== ($fdd90c8cbe9e299b$var$K & 6)) throw Error($fdd90c8cbe9e299b$var$p(331));
                var e = $fdd90c8cbe9e299b$var$K;
                $fdd90c8cbe9e299b$var$K |= 4;
                for($fdd90c8cbe9e299b$var$V = a.current; null !== $fdd90c8cbe9e299b$var$V;){
                    var f = $fdd90c8cbe9e299b$var$V, g = f.child;
                    if (0 !== ($fdd90c8cbe9e299b$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($fdd90c8cbe9e299b$var$V = l; null !== $fdd90c8cbe9e299b$var$V;){
                                    var m = $fdd90c8cbe9e299b$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $fdd90c8cbe9e299b$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $fdd90c8cbe9e299b$var$V = q;
                                    else for(; null !== $fdd90c8cbe9e299b$var$V;){
                                        m = $fdd90c8cbe9e299b$var$V;
                                        var r = m.sibling, y = m.return;
                                        $fdd90c8cbe9e299b$var$Tj(m);
                                        if (m === l) {
                                            $fdd90c8cbe9e299b$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $fdd90c8cbe9e299b$var$V = r;
                                            break;
                                        }
                                        $fdd90c8cbe9e299b$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $fdd90c8cbe9e299b$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $fdd90c8cbe9e299b$var$V = g;
                    else b: for(; null !== $fdd90c8cbe9e299b$var$V;){
                        f = $fdd90c8cbe9e299b$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $fdd90c8cbe9e299b$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $fdd90c8cbe9e299b$var$V = x;
                            break b;
                        }
                        $fdd90c8cbe9e299b$var$V = f.return;
                    }
                }
                var w = a.current;
                for($fdd90c8cbe9e299b$var$V = w; null !== $fdd90c8cbe9e299b$var$V;){
                    g = $fdd90c8cbe9e299b$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $fdd90c8cbe9e299b$var$V = u;
                    else b: for(g = w; null !== $fdd90c8cbe9e299b$var$V;){
                        h = $fdd90c8cbe9e299b$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $fdd90c8cbe9e299b$var$Rj(9, h);
                            }
                        } catch (na) {
                            $fdd90c8cbe9e299b$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $fdd90c8cbe9e299b$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $fdd90c8cbe9e299b$var$V = F;
                            break b;
                        }
                        $fdd90c8cbe9e299b$var$V = h.return;
                    }
                }
                $fdd90c8cbe9e299b$var$K = e;
                $fdd90c8cbe9e299b$var$jg();
                if ($fdd90c8cbe9e299b$var$lc && "function" === typeof $fdd90c8cbe9e299b$var$lc.onPostCommitFiberRoot) try {
                    $fdd90c8cbe9e299b$var$lc.onPostCommitFiberRoot($fdd90c8cbe9e299b$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $fdd90c8cbe9e299b$var$C = c, $fdd90c8cbe9e299b$var$pk.transition = b;
        }
    }
    return !1;
}
function $fdd90c8cbe9e299b$var$Yk(a, b, c) {
    b = $fdd90c8cbe9e299b$var$Ki(c, b);
    b = $fdd90c8cbe9e299b$var$Oi(a, b, 1);
    a = $fdd90c8cbe9e299b$var$dh(a, b, 1);
    b = $fdd90c8cbe9e299b$var$L();
    null !== a && ($fdd90c8cbe9e299b$var$Ac(a, 1, b), $fdd90c8cbe9e299b$var$Ek(a, b));
}
function $fdd90c8cbe9e299b$var$W(a, b, c) {
    if (3 === a.tag) $fdd90c8cbe9e299b$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $fdd90c8cbe9e299b$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $fdd90c8cbe9e299b$var$Si || !$fdd90c8cbe9e299b$var$Si.has(d))) {
                a = $fdd90c8cbe9e299b$var$Ki(c, a);
                a = $fdd90c8cbe9e299b$var$Ri(b, a, 1);
                b = $fdd90c8cbe9e299b$var$dh(b, a, 1);
                a = $fdd90c8cbe9e299b$var$L();
                null !== b && ($fdd90c8cbe9e299b$var$Ac(b, 1, a), $fdd90c8cbe9e299b$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $fdd90c8cbe9e299b$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $fdd90c8cbe9e299b$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $fdd90c8cbe9e299b$var$R === a && ($fdd90c8cbe9e299b$var$Z & c) === c && (4 === $fdd90c8cbe9e299b$var$T || 3 === $fdd90c8cbe9e299b$var$T && ($fdd90c8cbe9e299b$var$Z & 130023424) === $fdd90c8cbe9e299b$var$Z && 500 > $fdd90c8cbe9e299b$var$B() - $fdd90c8cbe9e299b$var$gk ? $fdd90c8cbe9e299b$var$Lk(a, 0) : $fdd90c8cbe9e299b$var$sk |= c);
    $fdd90c8cbe9e299b$var$Ek(a, b);
}
function $fdd90c8cbe9e299b$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $fdd90c8cbe9e299b$var$sc, $fdd90c8cbe9e299b$var$sc <<= 1, 0 === ($fdd90c8cbe9e299b$var$sc & 130023424) && ($fdd90c8cbe9e299b$var$sc = 4194304)));
    var c = $fdd90c8cbe9e299b$var$L();
    a = $fdd90c8cbe9e299b$var$Zg(a, b);
    null !== a && ($fdd90c8cbe9e299b$var$Ac(a, b, c), $fdd90c8cbe9e299b$var$Ek(a, c));
}
function $fdd90c8cbe9e299b$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $fdd90c8cbe9e299b$var$Zk(a, c);
}
function $fdd90c8cbe9e299b$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($fdd90c8cbe9e299b$var$p(314));
    }
    null !== d && d.delete(b);
    $fdd90c8cbe9e299b$var$Zk(a, c);
}
var $fdd90c8cbe9e299b$var$Wk;
$fdd90c8cbe9e299b$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $fdd90c8cbe9e299b$var$Wf.current) $fdd90c8cbe9e299b$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $fdd90c8cbe9e299b$var$Ug = !1, $fdd90c8cbe9e299b$var$zj(a, b, c);
            $fdd90c8cbe9e299b$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $fdd90c8cbe9e299b$var$Ug = !1, $fdd90c8cbe9e299b$var$I && 0 !== (b.flags & 1048576) && $fdd90c8cbe9e299b$var$ug(b, $fdd90c8cbe9e299b$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $fdd90c8cbe9e299b$var$jj(a, b);
            a = b.pendingProps;
            var e = $fdd90c8cbe9e299b$var$Yf(b, $fdd90c8cbe9e299b$var$H.current);
            $fdd90c8cbe9e299b$var$Tg(b, c);
            e = $fdd90c8cbe9e299b$var$Xh(null, b, d, a, e, c);
            var f = $fdd90c8cbe9e299b$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $fdd90c8cbe9e299b$var$Zf(d) ? (f = !0, $fdd90c8cbe9e299b$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $fdd90c8cbe9e299b$var$ah(b), e.updater = $fdd90c8cbe9e299b$var$nh, b.stateNode = e, e._reactInternals = b, $fdd90c8cbe9e299b$var$rh(b, d, a, c), b = $fdd90c8cbe9e299b$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $fdd90c8cbe9e299b$var$I && f && $fdd90c8cbe9e299b$var$vg(b), $fdd90c8cbe9e299b$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $fdd90c8cbe9e299b$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $fdd90c8cbe9e299b$var$$k(d);
                a = $fdd90c8cbe9e299b$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $fdd90c8cbe9e299b$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $fdd90c8cbe9e299b$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $fdd90c8cbe9e299b$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $fdd90c8cbe9e299b$var$aj(null, b, d, $fdd90c8cbe9e299b$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($fdd90c8cbe9e299b$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fdd90c8cbe9e299b$var$Lg(d, e), $fdd90c8cbe9e299b$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fdd90c8cbe9e299b$var$Lg(d, e), $fdd90c8cbe9e299b$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $fdd90c8cbe9e299b$var$lj(b);
                if (null === a) throw Error($fdd90c8cbe9e299b$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $fdd90c8cbe9e299b$var$bh(a, b);
                $fdd90c8cbe9e299b$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $fdd90c8cbe9e299b$var$Ki(Error($fdd90c8cbe9e299b$var$p(423)), b);
                        b = $fdd90c8cbe9e299b$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $fdd90c8cbe9e299b$var$Ki(Error($fdd90c8cbe9e299b$var$p(424)), b);
                        b = $fdd90c8cbe9e299b$var$mj(a, b, d, c, e);
                        break a;
                    } else for($fdd90c8cbe9e299b$var$yg = $fdd90c8cbe9e299b$var$Lf(b.stateNode.containerInfo.firstChild), $fdd90c8cbe9e299b$var$xg = b, $fdd90c8cbe9e299b$var$I = !0, $fdd90c8cbe9e299b$var$zg = null, c = $fdd90c8cbe9e299b$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $fdd90c8cbe9e299b$var$Ig();
                    if (d === e) {
                        b = $fdd90c8cbe9e299b$var$$i(a, b, c);
                        break a;
                    }
                    $fdd90c8cbe9e299b$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $fdd90c8cbe9e299b$var$Kh(b), null === a && $fdd90c8cbe9e299b$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $fdd90c8cbe9e299b$var$Ef(d, e) ? g = null : null !== f && $fdd90c8cbe9e299b$var$Ef(d, f) && (b.flags |= 32), $fdd90c8cbe9e299b$var$hj(a, b), $fdd90c8cbe9e299b$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $fdd90c8cbe9e299b$var$Eg(b), null;
        case 13:
            return $fdd90c8cbe9e299b$var$pj(a, b, c);
        case 4:
            return $fdd90c8cbe9e299b$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $fdd90c8cbe9e299b$var$Bh(b, null, d, c) : $fdd90c8cbe9e299b$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fdd90c8cbe9e299b$var$Lg(d, e), $fdd90c8cbe9e299b$var$Zi(a, b, d, e, c);
        case 7:
            return $fdd90c8cbe9e299b$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $fdd90c8cbe9e299b$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $fdd90c8cbe9e299b$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($fdd90c8cbe9e299b$var$He(f.value, g)) {
                        if (f.children === e.children && !$fdd90c8cbe9e299b$var$Wf.current) {
                            b = $fdd90c8cbe9e299b$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $fdd90c8cbe9e299b$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $fdd90c8cbe9e299b$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($fdd90c8cbe9e299b$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $fdd90c8cbe9e299b$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $fdd90c8cbe9e299b$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $fdd90c8cbe9e299b$var$Tg(b, c), e = $fdd90c8cbe9e299b$var$Vg(e), d = d(e), b.flags |= 1, $fdd90c8cbe9e299b$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $fdd90c8cbe9e299b$var$Lg(d, b.pendingProps), e = $fdd90c8cbe9e299b$var$Lg(d.type, e), $fdd90c8cbe9e299b$var$aj(a, b, d, e, c);
        case 15:
            return $fdd90c8cbe9e299b$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fdd90c8cbe9e299b$var$Lg(d, e), $fdd90c8cbe9e299b$var$jj(a, b), b.tag = 1, $fdd90c8cbe9e299b$var$Zf(d) ? (a = !0, $fdd90c8cbe9e299b$var$cg(b)) : a = !1, $fdd90c8cbe9e299b$var$Tg(b, c), $fdd90c8cbe9e299b$var$ph(b, d, e), $fdd90c8cbe9e299b$var$rh(b, d, e, c), $fdd90c8cbe9e299b$var$kj(null, b, d, !0, a, c);
        case 19:
            return $fdd90c8cbe9e299b$var$yj(a, b, c);
        case 22:
            return $fdd90c8cbe9e299b$var$ej(a, b, c);
    }
    throw Error($fdd90c8cbe9e299b$var$p(156, b.tag));
};
function $fdd90c8cbe9e299b$var$Gk(a, b) {
    return $fdd90c8cbe9e299b$var$ac(a, b);
}
function $fdd90c8cbe9e299b$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $fdd90c8cbe9e299b$var$Bg(a, b, c, d) {
    return new $fdd90c8cbe9e299b$var$al(a, b, c, d);
}
function $fdd90c8cbe9e299b$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $fdd90c8cbe9e299b$var$$k(a) {
    if ("function" === typeof a) return $fdd90c8cbe9e299b$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $fdd90c8cbe9e299b$var$Da) return 11;
        if (a === $fdd90c8cbe9e299b$var$Ga) return 14;
    }
    return 2;
}
function $fdd90c8cbe9e299b$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $fdd90c8cbe9e299b$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $fdd90c8cbe9e299b$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $fdd90c8cbe9e299b$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $fdd90c8cbe9e299b$var$ya:
            return $fdd90c8cbe9e299b$var$Ah(c.children, e, f, b);
        case $fdd90c8cbe9e299b$var$za:
            g = 8;
            e |= 8;
            break;
        case $fdd90c8cbe9e299b$var$Aa:
            return a = $fdd90c8cbe9e299b$var$Bg(12, c, b, e | 2), a.elementType = $fdd90c8cbe9e299b$var$Aa, a.lanes = f, a;
        case $fdd90c8cbe9e299b$var$Ea:
            return a = $fdd90c8cbe9e299b$var$Bg(13, c, b, e), a.elementType = $fdd90c8cbe9e299b$var$Ea, a.lanes = f, a;
        case $fdd90c8cbe9e299b$var$Fa:
            return a = $fdd90c8cbe9e299b$var$Bg(19, c, b, e), a.elementType = $fdd90c8cbe9e299b$var$Fa, a.lanes = f, a;
        case $fdd90c8cbe9e299b$var$Ia:
            return $fdd90c8cbe9e299b$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $fdd90c8cbe9e299b$var$Ba:
                    g = 10;
                    break a;
                case $fdd90c8cbe9e299b$var$Ca:
                    g = 9;
                    break a;
                case $fdd90c8cbe9e299b$var$Da:
                    g = 11;
                    break a;
                case $fdd90c8cbe9e299b$var$Ga:
                    g = 14;
                    break a;
                case $fdd90c8cbe9e299b$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($fdd90c8cbe9e299b$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $fdd90c8cbe9e299b$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $fdd90c8cbe9e299b$var$Ah(a, b, c, d) {
    a = $fdd90c8cbe9e299b$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $fdd90c8cbe9e299b$var$qj(a, b, c, d) {
    a = $fdd90c8cbe9e299b$var$Bg(22, a, d, b);
    a.elementType = $fdd90c8cbe9e299b$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $fdd90c8cbe9e299b$var$xh(a, b, c) {
    a = $fdd90c8cbe9e299b$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $fdd90c8cbe9e299b$var$zh(a, b, c) {
    b = $fdd90c8cbe9e299b$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $fdd90c8cbe9e299b$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $fdd90c8cbe9e299b$var$zc(0);
    this.expirationTimes = $fdd90c8cbe9e299b$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $fdd90c8cbe9e299b$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $fdd90c8cbe9e299b$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $fdd90c8cbe9e299b$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $fdd90c8cbe9e299b$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $fdd90c8cbe9e299b$var$ah(f);
    return a;
}
function $fdd90c8cbe9e299b$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $fdd90c8cbe9e299b$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $fdd90c8cbe9e299b$var$el(a) {
    if (!a) return $fdd90c8cbe9e299b$var$Vf;
    a = a._reactInternals;
    a: {
        if ($fdd90c8cbe9e299b$var$Vb(a) !== a || 1 !== a.tag) throw Error($fdd90c8cbe9e299b$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($fdd90c8cbe9e299b$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($fdd90c8cbe9e299b$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($fdd90c8cbe9e299b$var$Zf(c)) return $fdd90c8cbe9e299b$var$bg(a, c, b);
    }
    return b;
}
function $fdd90c8cbe9e299b$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $fdd90c8cbe9e299b$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $fdd90c8cbe9e299b$var$el(null);
    c = a.current;
    d = $fdd90c8cbe9e299b$var$L();
    e = $fdd90c8cbe9e299b$var$lh(c);
    f = $fdd90c8cbe9e299b$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $fdd90c8cbe9e299b$var$dh(c, f, e);
    a.current.lanes = e;
    $fdd90c8cbe9e299b$var$Ac(a, e, d);
    $fdd90c8cbe9e299b$var$Ek(a, d);
    return a;
}
function $fdd90c8cbe9e299b$var$gl(a, b, c, d) {
    var e = b.current, f = $fdd90c8cbe9e299b$var$L(), g = $fdd90c8cbe9e299b$var$lh(e);
    c = $fdd90c8cbe9e299b$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $fdd90c8cbe9e299b$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $fdd90c8cbe9e299b$var$dh(e, b, g);
    null !== a && ($fdd90c8cbe9e299b$var$mh(a, e, g, f), $fdd90c8cbe9e299b$var$eh(a, e, g));
    return g;
}
function $fdd90c8cbe9e299b$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $fdd90c8cbe9e299b$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $fdd90c8cbe9e299b$var$jl(a, b) {
    $fdd90c8cbe9e299b$var$il(a, b);
    (a = a.alternate) && $fdd90c8cbe9e299b$var$il(a, b);
}
function $fdd90c8cbe9e299b$var$kl() {
    return null;
}
var $fdd90c8cbe9e299b$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $fdd90c8cbe9e299b$var$ml(a) {
    this._internalRoot = a;
}
$fdd90c8cbe9e299b$var$nl.prototype.render = $fdd90c8cbe9e299b$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($fdd90c8cbe9e299b$var$p(409));
    $fdd90c8cbe9e299b$var$gl(a, b, null, null);
};
$fdd90c8cbe9e299b$var$nl.prototype.unmount = $fdd90c8cbe9e299b$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $fdd90c8cbe9e299b$var$Sk(function() {
            $fdd90c8cbe9e299b$var$gl(null, a, null, null);
        });
        b[$fdd90c8cbe9e299b$var$uf] = null;
    }
};
function $fdd90c8cbe9e299b$var$nl(a) {
    this._internalRoot = a;
}
$fdd90c8cbe9e299b$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $fdd90c8cbe9e299b$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $fdd90c8cbe9e299b$var$Qc.length && 0 !== b && b < $fdd90c8cbe9e299b$var$Qc[c].priority; c++);
        $fdd90c8cbe9e299b$var$Qc.splice(c, 0, a);
        0 === c && $fdd90c8cbe9e299b$var$Vc(a);
    }
};
function $fdd90c8cbe9e299b$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $fdd90c8cbe9e299b$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $fdd90c8cbe9e299b$var$ql() {}
function $fdd90c8cbe9e299b$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $fdd90c8cbe9e299b$var$hl(g);
                f.call(a);
            };
        }
        var g = $fdd90c8cbe9e299b$var$fl(b, d, a, 0, null, !1, !1, "", $fdd90c8cbe9e299b$var$ql);
        a._reactRootContainer = g;
        a[$fdd90c8cbe9e299b$var$uf] = g.current;
        $fdd90c8cbe9e299b$var$sf(8 === a.nodeType ? a.parentNode : a);
        $fdd90c8cbe9e299b$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $fdd90c8cbe9e299b$var$hl(k);
            h.call(a);
        };
    }
    var k = $fdd90c8cbe9e299b$var$cl(a, 0, !1, null, null, !1, !1, "", $fdd90c8cbe9e299b$var$ql);
    a._reactRootContainer = k;
    a[$fdd90c8cbe9e299b$var$uf] = k.current;
    $fdd90c8cbe9e299b$var$sf(8 === a.nodeType ? a.parentNode : a);
    $fdd90c8cbe9e299b$var$Sk(function() {
        $fdd90c8cbe9e299b$var$gl(b, k, c, d);
    });
    return k;
}
function $fdd90c8cbe9e299b$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $fdd90c8cbe9e299b$var$hl(g);
                h.call(a);
            };
        }
        $fdd90c8cbe9e299b$var$gl(b, g, a, e);
    } else g = $fdd90c8cbe9e299b$var$rl(c, b, a, e, d);
    return $fdd90c8cbe9e299b$var$hl(g);
}
$fdd90c8cbe9e299b$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $fdd90c8cbe9e299b$var$tc(b.pendingLanes);
                0 !== c && ($fdd90c8cbe9e299b$var$Cc(b, c | 1), $fdd90c8cbe9e299b$var$Ek(b, $fdd90c8cbe9e299b$var$B()), 0 === ($fdd90c8cbe9e299b$var$K & 6) && ($fdd90c8cbe9e299b$var$Hj = $fdd90c8cbe9e299b$var$B() + 500, $fdd90c8cbe9e299b$var$jg()));
            }
            break;
        case 13:
            $fdd90c8cbe9e299b$var$Sk(function() {
                var b = $fdd90c8cbe9e299b$var$Zg(a, 1);
                if (null !== b) {
                    var c = $fdd90c8cbe9e299b$var$L();
                    $fdd90c8cbe9e299b$var$mh(b, a, 1, c);
                }
            }), $fdd90c8cbe9e299b$var$jl(a, 1);
    }
};
$fdd90c8cbe9e299b$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $fdd90c8cbe9e299b$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $fdd90c8cbe9e299b$var$L();
            $fdd90c8cbe9e299b$var$mh(b, a, 134217728, c);
        }
        $fdd90c8cbe9e299b$var$jl(a, 134217728);
    }
};
$fdd90c8cbe9e299b$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $fdd90c8cbe9e299b$var$lh(a), c = $fdd90c8cbe9e299b$var$Zg(a, b);
        if (null !== c) {
            var d = $fdd90c8cbe9e299b$var$L();
            $fdd90c8cbe9e299b$var$mh(c, a, b, d);
        }
        $fdd90c8cbe9e299b$var$jl(a, b);
    }
};
$fdd90c8cbe9e299b$var$Hc = function() {
    return $fdd90c8cbe9e299b$var$C;
};
$fdd90c8cbe9e299b$var$Ic = function(a, b) {
    var c = $fdd90c8cbe9e299b$var$C;
    try {
        return $fdd90c8cbe9e299b$var$C = a, b();
    } finally{
        $fdd90c8cbe9e299b$var$C = c;
    }
};
$fdd90c8cbe9e299b$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $fdd90c8cbe9e299b$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $fdd90c8cbe9e299b$var$Db(d);
                        if (!e) throw Error($fdd90c8cbe9e299b$var$p(90));
                        $fdd90c8cbe9e299b$var$Wa(d);
                        $fdd90c8cbe9e299b$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $fdd90c8cbe9e299b$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $fdd90c8cbe9e299b$var$fb(a, !!c.multiple, b, !1);
    }
};
$fdd90c8cbe9e299b$var$Gb = $fdd90c8cbe9e299b$var$Rk;
$fdd90c8cbe9e299b$var$Hb = $fdd90c8cbe9e299b$var$Sk;
var $fdd90c8cbe9e299b$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $fdd90c8cbe9e299b$var$Cb,
        $fdd90c8cbe9e299b$var$ue,
        $fdd90c8cbe9e299b$var$Db,
        $fdd90c8cbe9e299b$var$Eb,
        $fdd90c8cbe9e299b$var$Fb,
        $fdd90c8cbe9e299b$var$Rk
    ]
}, $fdd90c8cbe9e299b$var$ul = {
    findFiberByHostInstance: $fdd90c8cbe9e299b$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $fdd90c8cbe9e299b$var$vl = {
    bundleType: $fdd90c8cbe9e299b$var$ul.bundleType,
    version: $fdd90c8cbe9e299b$var$ul.version,
    rendererPackageName: $fdd90c8cbe9e299b$var$ul.rendererPackageName,
    rendererConfig: $fdd90c8cbe9e299b$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $fdd90c8cbe9e299b$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $fdd90c8cbe9e299b$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $fdd90c8cbe9e299b$var$ul.findFiberByHostInstance || $fdd90c8cbe9e299b$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $fdd90c8cbe9e299b$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$fdd90c8cbe9e299b$var$wl.isDisabled && $fdd90c8cbe9e299b$var$wl.supportsFiber) try {
        $fdd90c8cbe9e299b$var$kc = $fdd90c8cbe9e299b$var$wl.inject($fdd90c8cbe9e299b$var$vl), $fdd90c8cbe9e299b$var$lc = $fdd90c8cbe9e299b$var$wl;
    } catch (a) {}
}
$fdd90c8cbe9e299b$export$ae55be85d98224ed = $fdd90c8cbe9e299b$var$tl;
$fdd90c8cbe9e299b$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$fdd90c8cbe9e299b$var$ol(b)) throw Error($fdd90c8cbe9e299b$var$p(200));
    return $fdd90c8cbe9e299b$var$dl(a, b, null, c);
};
$fdd90c8cbe9e299b$export$882461b6382ed46c = function(a, b) {
    if (!$fdd90c8cbe9e299b$var$ol(a)) throw Error($fdd90c8cbe9e299b$var$p(299));
    var c = !1, d = "", e = $fdd90c8cbe9e299b$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $fdd90c8cbe9e299b$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$fdd90c8cbe9e299b$var$uf] = b.current;
    $fdd90c8cbe9e299b$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $fdd90c8cbe9e299b$var$ml(b);
};
$fdd90c8cbe9e299b$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($fdd90c8cbe9e299b$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($fdd90c8cbe9e299b$var$p(268, a));
    }
    a = $fdd90c8cbe9e299b$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$fdd90c8cbe9e299b$export$cd75ccfd720a3cd4 = function(a) {
    return $fdd90c8cbe9e299b$var$Sk(a);
};
$fdd90c8cbe9e299b$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$fdd90c8cbe9e299b$var$pl(b)) throw Error($fdd90c8cbe9e299b$var$p(200));
    return $fdd90c8cbe9e299b$var$sl(null, a, b, !0, c);
};
$fdd90c8cbe9e299b$export$757ceba2d55c277e = function(a, b, c) {
    if (!$fdd90c8cbe9e299b$var$ol(a)) throw Error($fdd90c8cbe9e299b$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $fdd90c8cbe9e299b$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $fdd90c8cbe9e299b$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$fdd90c8cbe9e299b$var$uf] = b.current;
    $fdd90c8cbe9e299b$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $fdd90c8cbe9e299b$var$nl(b);
};
$fdd90c8cbe9e299b$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$fdd90c8cbe9e299b$var$pl(b)) throw Error($fdd90c8cbe9e299b$var$p(200));
    return $fdd90c8cbe9e299b$var$sl(null, a, b, !1, c);
};
$fdd90c8cbe9e299b$export$502457920280e6be = function(a) {
    if (!$fdd90c8cbe9e299b$var$pl(a)) throw Error($fdd90c8cbe9e299b$var$p(40));
    return a._reactRootContainer ? ($fdd90c8cbe9e299b$var$Sk(function() {
        $fdd90c8cbe9e299b$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$fdd90c8cbe9e299b$var$uf] = null;
        });
    }), !0) : !1;
};
$fdd90c8cbe9e299b$export$c78a37762a8d58e1 = $fdd90c8cbe9e299b$var$Rk;
$fdd90c8cbe9e299b$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$fdd90c8cbe9e299b$var$pl(c)) throw Error($fdd90c8cbe9e299b$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($fdd90c8cbe9e299b$var$p(38));
    return $fdd90c8cbe9e299b$var$sl(a, b, c, !1, d);
};
$fdd90c8cbe9e299b$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("3tsZj", function(module, exports) {
"use strict";

module.exports = (parcelRequire("04Zxz"));

});
parcelRegister("04Zxz", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $00f01c7e38db0d01$export$c4744153514ff05d; }, function (v) { return $00f01c7e38db0d01$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $00f01c7e38db0d01$export$3e506c1ccc9cc1a7; }, function (v) { return $00f01c7e38db0d01$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $00f01c7e38db0d01$export$e26fe2ed2fa76875; }, function (v) { return $00f01c7e38db0d01$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $00f01c7e38db0d01$export$502329bbf4b505b1; }, function (v) { return $00f01c7e38db0d01$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $00f01c7e38db0d01$export$6e3807111c4874c4; }, function (v) { return $00f01c7e38db0d01$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $00f01c7e38db0d01$export$c27134553091fb3a; }, function (v) { return $00f01c7e38db0d01$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $00f01c7e38db0d01$export$33ee1acdc04fd2a2; }, function (v) { return $00f01c7e38db0d01$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $00f01c7e38db0d01$export$b00a404bbd5edef2; }, function (v) { return $00f01c7e38db0d01$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $00f01c7e38db0d01$export$8352ce38b91d0c62; }, function (v) { return $00f01c7e38db0d01$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $00f01c7e38db0d01$export$d66a1c1c77bd778b; }, function (v) { return $00f01c7e38db0d01$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $00f01c7e38db0d01$export$d3dfb8e4810cb555; }, function (v) { return $00f01c7e38db0d01$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $00f01c7e38db0d01$export$839f9183b0465a69; }, function (v) { return $00f01c7e38db0d01$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $00f01c7e38db0d01$export$72fdf0e06517287b; }, function (v) { return $00f01c7e38db0d01$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $00f01c7e38db0d01$export$4b844e58a3e414b4; }, function (v) { return $00f01c7e38db0d01$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $00f01c7e38db0d01$export$816d2913ae6b83b1; }, function (v) { return $00f01c7e38db0d01$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $00f01c7e38db0d01$export$61bcfe829111a1d0; }, function (v) { return $00f01c7e38db0d01$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $00f01c7e38db0d01$export$7ee8c9beb337bc3f; }, function (v) { return $00f01c7e38db0d01$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $00f01c7e38db0d01$export$b5836b71941fa3ed; }, function (v) { return $00f01c7e38db0d01$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $00f01c7e38db0d01$export$cf845f2c119da08a; }, function (v) { return $00f01c7e38db0d01$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $00f01c7e38db0d01$export$c4744153514ff05d;
var $00f01c7e38db0d01$export$3e506c1ccc9cc1a7;
var $00f01c7e38db0d01$export$e26fe2ed2fa76875;
var $00f01c7e38db0d01$export$502329bbf4b505b1;
var $00f01c7e38db0d01$export$6e3807111c4874c4;
var $00f01c7e38db0d01$export$c27134553091fb3a;
var $00f01c7e38db0d01$export$33ee1acdc04fd2a2;
var $00f01c7e38db0d01$export$b00a404bbd5edef2;
var $00f01c7e38db0d01$export$8352ce38b91d0c62;
var $00f01c7e38db0d01$export$d66a1c1c77bd778b;
var $00f01c7e38db0d01$export$d3dfb8e4810cb555;
var $00f01c7e38db0d01$export$839f9183b0465a69;
var $00f01c7e38db0d01$export$72fdf0e06517287b;
var $00f01c7e38db0d01$export$4b844e58a3e414b4;
var $00f01c7e38db0d01$export$816d2913ae6b83b1;
var $00f01c7e38db0d01$export$61bcfe829111a1d0;
var $00f01c7e38db0d01$export$7ee8c9beb337bc3f;
var $00f01c7e38db0d01$export$b5836b71941fa3ed;
var $00f01c7e38db0d01$export$cf845f2c119da08a;
"use strict";
function $00f01c7e38db0d01$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $00f01c7e38db0d01$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $00f01c7e38db0d01$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $00f01c7e38db0d01$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $00f01c7e38db0d01$var$g(C, c)) n < e && 0 > $00f01c7e38db0d01$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $00f01c7e38db0d01$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $00f01c7e38db0d01$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $00f01c7e38db0d01$var$l = performance;
    $00f01c7e38db0d01$export$c4744153514ff05d = function() {
        return $00f01c7e38db0d01$var$l.now();
    };
} else {
    var $00f01c7e38db0d01$var$p = Date, $00f01c7e38db0d01$var$q = $00f01c7e38db0d01$var$p.now();
    $00f01c7e38db0d01$export$c4744153514ff05d = function() {
        return $00f01c7e38db0d01$var$p.now() - $00f01c7e38db0d01$var$q;
    };
}
var $00f01c7e38db0d01$var$r = [], $00f01c7e38db0d01$var$t = [], $00f01c7e38db0d01$var$u = 1, $00f01c7e38db0d01$var$v = null, $00f01c7e38db0d01$var$y = 3, $00f01c7e38db0d01$var$z = !1, $00f01c7e38db0d01$var$A = !1, $00f01c7e38db0d01$var$B = !1, $00f01c7e38db0d01$var$D = "function" === typeof setTimeout ? setTimeout : null, $00f01c7e38db0d01$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $00f01c7e38db0d01$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $00f01c7e38db0d01$var$G(a) {
    for(var b = $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$t); null !== b;){
        if (null === b.callback) $00f01c7e38db0d01$var$k($00f01c7e38db0d01$var$t);
        else if (b.startTime <= a) $00f01c7e38db0d01$var$k($00f01c7e38db0d01$var$t), b.sortIndex = b.expirationTime, $00f01c7e38db0d01$var$f($00f01c7e38db0d01$var$r, b);
        else break;
        b = $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$t);
    }
}
function $00f01c7e38db0d01$var$H(a) {
    $00f01c7e38db0d01$var$B = !1;
    $00f01c7e38db0d01$var$G(a);
    if (!$00f01c7e38db0d01$var$A) {
        if (null !== $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$r)) $00f01c7e38db0d01$var$A = !0, $00f01c7e38db0d01$var$I($00f01c7e38db0d01$var$J);
        else {
            var b = $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$t);
            null !== b && $00f01c7e38db0d01$var$K($00f01c7e38db0d01$var$H, b.startTime - a);
        }
    }
}
function $00f01c7e38db0d01$var$J(a, b) {
    $00f01c7e38db0d01$var$A = !1;
    $00f01c7e38db0d01$var$B && ($00f01c7e38db0d01$var$B = !1, $00f01c7e38db0d01$var$E($00f01c7e38db0d01$var$L), $00f01c7e38db0d01$var$L = -1);
    $00f01c7e38db0d01$var$z = !0;
    var c = $00f01c7e38db0d01$var$y;
    try {
        $00f01c7e38db0d01$var$G(b);
        for($00f01c7e38db0d01$var$v = $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$r); null !== $00f01c7e38db0d01$var$v && (!($00f01c7e38db0d01$var$v.expirationTime > b) || a && !$00f01c7e38db0d01$var$M());){
            var d = $00f01c7e38db0d01$var$v.callback;
            if ("function" === typeof d) {
                $00f01c7e38db0d01$var$v.callback = null;
                $00f01c7e38db0d01$var$y = $00f01c7e38db0d01$var$v.priorityLevel;
                var e = d($00f01c7e38db0d01$var$v.expirationTime <= b);
                b = $00f01c7e38db0d01$export$c4744153514ff05d();
                "function" === typeof e ? $00f01c7e38db0d01$var$v.callback = e : $00f01c7e38db0d01$var$v === $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$r) && $00f01c7e38db0d01$var$k($00f01c7e38db0d01$var$r);
                $00f01c7e38db0d01$var$G(b);
            } else $00f01c7e38db0d01$var$k($00f01c7e38db0d01$var$r);
            $00f01c7e38db0d01$var$v = $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$r);
        }
        if (null !== $00f01c7e38db0d01$var$v) var w = !0;
        else {
            var m = $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$t);
            null !== m && $00f01c7e38db0d01$var$K($00f01c7e38db0d01$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $00f01c7e38db0d01$var$v = null, $00f01c7e38db0d01$var$y = c, $00f01c7e38db0d01$var$z = !1;
    }
}
var $00f01c7e38db0d01$var$N = !1, $00f01c7e38db0d01$var$O = null, $00f01c7e38db0d01$var$L = -1, $00f01c7e38db0d01$var$P = 5, $00f01c7e38db0d01$var$Q = -1;
function $00f01c7e38db0d01$var$M() {
    return $00f01c7e38db0d01$export$c4744153514ff05d() - $00f01c7e38db0d01$var$Q < $00f01c7e38db0d01$var$P ? !1 : !0;
}
function $00f01c7e38db0d01$var$R() {
    if (null !== $00f01c7e38db0d01$var$O) {
        var a = $00f01c7e38db0d01$export$c4744153514ff05d();
        $00f01c7e38db0d01$var$Q = a;
        var b = !0;
        try {
            b = $00f01c7e38db0d01$var$O(!0, a);
        } finally{
            b ? $00f01c7e38db0d01$var$S() : ($00f01c7e38db0d01$var$N = !1, $00f01c7e38db0d01$var$O = null);
        }
    } else $00f01c7e38db0d01$var$N = !1;
}
var $00f01c7e38db0d01$var$S;
if ("function" === typeof $00f01c7e38db0d01$var$F) $00f01c7e38db0d01$var$S = function() {
    $00f01c7e38db0d01$var$F($00f01c7e38db0d01$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $00f01c7e38db0d01$var$T = new MessageChannel, $00f01c7e38db0d01$var$U = $00f01c7e38db0d01$var$T.port2;
    $00f01c7e38db0d01$var$T.port1.onmessage = $00f01c7e38db0d01$var$R;
    $00f01c7e38db0d01$var$S = function() {
        $00f01c7e38db0d01$var$U.postMessage(null);
    };
} else $00f01c7e38db0d01$var$S = function() {
    $00f01c7e38db0d01$var$D($00f01c7e38db0d01$var$R, 0);
};
function $00f01c7e38db0d01$var$I(a) {
    $00f01c7e38db0d01$var$O = a;
    $00f01c7e38db0d01$var$N || ($00f01c7e38db0d01$var$N = !0, $00f01c7e38db0d01$var$S());
}
function $00f01c7e38db0d01$var$K(a, b) {
    $00f01c7e38db0d01$var$L = $00f01c7e38db0d01$var$D(function() {
        a($00f01c7e38db0d01$export$c4744153514ff05d());
    }, b);
}
$00f01c7e38db0d01$export$3e506c1ccc9cc1a7 = 5;
$00f01c7e38db0d01$export$e26fe2ed2fa76875 = 1;
$00f01c7e38db0d01$export$502329bbf4b505b1 = 4;
$00f01c7e38db0d01$export$6e3807111c4874c4 = 3;
$00f01c7e38db0d01$export$c27134553091fb3a = null;
$00f01c7e38db0d01$export$33ee1acdc04fd2a2 = 2;
$00f01c7e38db0d01$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$00f01c7e38db0d01$export$8352ce38b91d0c62 = function() {
    $00f01c7e38db0d01$var$A || $00f01c7e38db0d01$var$z || ($00f01c7e38db0d01$var$A = !0, $00f01c7e38db0d01$var$I($00f01c7e38db0d01$var$J));
};
$00f01c7e38db0d01$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $00f01c7e38db0d01$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$00f01c7e38db0d01$export$d3dfb8e4810cb555 = function() {
    return $00f01c7e38db0d01$var$y;
};
$00f01c7e38db0d01$export$839f9183b0465a69 = function() {
    return $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$r);
};
$00f01c7e38db0d01$export$72fdf0e06517287b = function(a) {
    switch($00f01c7e38db0d01$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $00f01c7e38db0d01$var$y;
    }
    var c = $00f01c7e38db0d01$var$y;
    $00f01c7e38db0d01$var$y = b;
    try {
        return a();
    } finally{
        $00f01c7e38db0d01$var$y = c;
    }
};
$00f01c7e38db0d01$export$4b844e58a3e414b4 = function() {};
$00f01c7e38db0d01$export$816d2913ae6b83b1 = function() {};
$00f01c7e38db0d01$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $00f01c7e38db0d01$var$y;
    $00f01c7e38db0d01$var$y = a;
    try {
        return b();
    } finally{
        $00f01c7e38db0d01$var$y = c;
    }
};
$00f01c7e38db0d01$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $00f01c7e38db0d01$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $00f01c7e38db0d01$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $00f01c7e38db0d01$var$f($00f01c7e38db0d01$var$t, a), null === $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$r) && a === $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$t) && ($00f01c7e38db0d01$var$B ? ($00f01c7e38db0d01$var$E($00f01c7e38db0d01$var$L), $00f01c7e38db0d01$var$L = -1) : $00f01c7e38db0d01$var$B = !0, $00f01c7e38db0d01$var$K($00f01c7e38db0d01$var$H, c - d))) : (a.sortIndex = e, $00f01c7e38db0d01$var$f($00f01c7e38db0d01$var$r, a), $00f01c7e38db0d01$var$A || $00f01c7e38db0d01$var$z || ($00f01c7e38db0d01$var$A = !0, $00f01c7e38db0d01$var$I($00f01c7e38db0d01$var$J)));
    return a;
};
$00f01c7e38db0d01$export$b5836b71941fa3ed = $00f01c7e38db0d01$var$M;
$00f01c7e38db0d01$export$cf845f2c119da08a = function(a) {
    var b = $00f01c7e38db0d01$var$y;
    return function() {
        var c = $00f01c7e38db0d01$var$y;
        $00f01c7e38db0d01$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $00f01c7e38db0d01$var$y = c;
        }
    };
};

});



parcelRegister("2yL8S", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $1dd353382616da23$export$2b8d127b894957b9; }, function (v) { return $1dd353382616da23$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $1dd353382616da23$export$cea3a54a6425200c; }, function (v) { return $1dd353382616da23$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $1dd353382616da23$export$a7c73072b1a182ae; }, function (v) { return $1dd353382616da23$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $1dd353382616da23$export$9f27bc3417b4524d; }, function (v) { return $1dd353382616da23$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $1dd353382616da23$export$db77ccec0bb4ccac; }, function (v) { return $1dd353382616da23$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $1dd353382616da23$export$8392c0c9d3dcbd35; }, function (v) { return $1dd353382616da23$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $1dd353382616da23$export$ffb0004e005737fa; }, function (v) { return $1dd353382616da23$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $1dd353382616da23$export$b624eff549462981; }, function (v) { return $1dd353382616da23$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $1dd353382616da23$export$7897aa7841a5380c; }, function (v) { return $1dd353382616da23$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $1dd353382616da23$export$602eac185826482c; }, function (v) { return $1dd353382616da23$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $1dd353382616da23$export$e2c29f18771995cb; }, function (v) { return $1dd353382616da23$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $1dd353382616da23$export$5f8d39834fd61797; }, function (v) { return $1dd353382616da23$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $1dd353382616da23$export$74bf444e3cd11ea5; }, function (v) { return $1dd353382616da23$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $1dd353382616da23$export$92387174baf9b227; }, function (v) { return $1dd353382616da23$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $1dd353382616da23$export$ec112efeb987d9c6; }, function (v) { return $1dd353382616da23$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $1dd353382616da23$export$b706b080d889d2c9; }, function (v) { return $1dd353382616da23$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $1dd353382616da23$export$5be5a87408f70ddc; }, function (v) { return $1dd353382616da23$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $1dd353382616da23$export$45a5e7f76e0caa8d; }, function (v) { return $1dd353382616da23$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $1dd353382616da23$export$455c2e768291efa6; }, function (v) { return $1dd353382616da23$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $1dd353382616da23$export$9522e17588c12572; }, function (v) { return $1dd353382616da23$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $1dd353382616da23$export$2110ac352bb060b9; }, function (v) { return $1dd353382616da23$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $1dd353382616da23$export$56885ab8b9c456ab; }, function (v) { return $1dd353382616da23$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $1dd353382616da23$export$d927fcb6adf8f9de; }, function (v) { return $1dd353382616da23$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $1dd353382616da23$export$b82d16f27459e05a; }, function (v) { return $1dd353382616da23$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $1dd353382616da23$export$522c17b4f5e123e8; }, function (v) { return $1dd353382616da23$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $1dd353382616da23$export$1aabd8a0274ecfd6; }, function (v) { return $1dd353382616da23$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $1dd353382616da23$export$9b621391a187a31a; }, function (v) { return $1dd353382616da23$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $1dd353382616da23$export$f5bbd400c2f4426f; }, function (v) { return $1dd353382616da23$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1dd353382616da23$export$2b8d127b894957b9;
var $1dd353382616da23$export$cea3a54a6425200c;
var $1dd353382616da23$export$a7c73072b1a182ae;
var $1dd353382616da23$export$9f27bc3417b4524d;
var $1dd353382616da23$export$db77ccec0bb4ccac;
var $1dd353382616da23$export$8392c0c9d3dcbd35;
var $1dd353382616da23$export$ffb0004e005737fa;
var $1dd353382616da23$export$b624eff549462981;
var $1dd353382616da23$export$7897aa7841a5380c;
var $1dd353382616da23$export$602eac185826482c;
var $1dd353382616da23$export$e2c29f18771995cb;
var $1dd353382616da23$export$5f8d39834fd61797;
var $1dd353382616da23$export$74bf444e3cd11ea5;
var $1dd353382616da23$export$92387174baf9b227;
var $1dd353382616da23$export$ec112efeb987d9c6;
var $1dd353382616da23$export$b706b080d889d2c9;
var $1dd353382616da23$export$5be5a87408f70ddc;
var $1dd353382616da23$export$45a5e7f76e0caa8d;
var $1dd353382616da23$export$455c2e768291efa6;
var $1dd353382616da23$export$9522e17588c12572;
var $1dd353382616da23$export$2110ac352bb060b9;
var $1dd353382616da23$export$56885ab8b9c456ab;
var $1dd353382616da23$export$d927fcb6adf8f9de;
var $1dd353382616da23$export$b82d16f27459e05a;
var $1dd353382616da23$export$522c17b4f5e123e8;
var $1dd353382616da23$export$1aabd8a0274ecfd6;
var $1dd353382616da23$export$9b621391a187a31a;
var $1dd353382616da23$export$f5bbd400c2f4426f;
"use strict";
var $1dd353382616da23$var$b = "function" === typeof Symbol && Symbol.for, $1dd353382616da23$var$c = $1dd353382616da23$var$b ? Symbol.for("react.element") : 60103, $1dd353382616da23$var$d = $1dd353382616da23$var$b ? Symbol.for("react.portal") : 60106, $1dd353382616da23$var$e = $1dd353382616da23$var$b ? Symbol.for("react.fragment") : 60107, $1dd353382616da23$var$f = $1dd353382616da23$var$b ? Symbol.for("react.strict_mode") : 60108, $1dd353382616da23$var$g = $1dd353382616da23$var$b ? Symbol.for("react.profiler") : 60114, $1dd353382616da23$var$h = $1dd353382616da23$var$b ? Symbol.for("react.provider") : 60109, $1dd353382616da23$var$k = $1dd353382616da23$var$b ? Symbol.for("react.context") : 60110, $1dd353382616da23$var$l = $1dd353382616da23$var$b ? Symbol.for("react.async_mode") : 60111, $1dd353382616da23$var$m = $1dd353382616da23$var$b ? Symbol.for("react.concurrent_mode") : 60111, $1dd353382616da23$var$n = $1dd353382616da23$var$b ? Symbol.for("react.forward_ref") : 60112, $1dd353382616da23$var$p = $1dd353382616da23$var$b ? Symbol.for("react.suspense") : 60113, $1dd353382616da23$var$q = $1dd353382616da23$var$b ? Symbol.for("react.suspense_list") : 60120, $1dd353382616da23$var$r = $1dd353382616da23$var$b ? Symbol.for("react.memo") : 60115, $1dd353382616da23$var$t = $1dd353382616da23$var$b ? Symbol.for("react.lazy") : 60116, $1dd353382616da23$var$v = $1dd353382616da23$var$b ? Symbol.for("react.block") : 60121, $1dd353382616da23$var$w = $1dd353382616da23$var$b ? Symbol.for("react.fundamental") : 60117, $1dd353382616da23$var$x = $1dd353382616da23$var$b ? Symbol.for("react.responder") : 60118, $1dd353382616da23$var$y = $1dd353382616da23$var$b ? Symbol.for("react.scope") : 60119;
function $1dd353382616da23$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $1dd353382616da23$var$c:
                switch(a = a.type, a){
                    case $1dd353382616da23$var$l:
                    case $1dd353382616da23$var$m:
                    case $1dd353382616da23$var$e:
                    case $1dd353382616da23$var$g:
                    case $1dd353382616da23$var$f:
                    case $1dd353382616da23$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $1dd353382616da23$var$k:
                            case $1dd353382616da23$var$n:
                            case $1dd353382616da23$var$t:
                            case $1dd353382616da23$var$r:
                            case $1dd353382616da23$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $1dd353382616da23$var$d:
                return u;
        }
    }
}
function $1dd353382616da23$var$A(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$m;
}
$1dd353382616da23$export$2b8d127b894957b9 = $1dd353382616da23$var$l;
$1dd353382616da23$export$cea3a54a6425200c = $1dd353382616da23$var$m;
$1dd353382616da23$export$a7c73072b1a182ae = $1dd353382616da23$var$k;
$1dd353382616da23$export$9f27bc3417b4524d = $1dd353382616da23$var$h;
$1dd353382616da23$export$db77ccec0bb4ccac = $1dd353382616da23$var$c;
$1dd353382616da23$export$8392c0c9d3dcbd35 = $1dd353382616da23$var$n;
$1dd353382616da23$export$ffb0004e005737fa = $1dd353382616da23$var$e;
$1dd353382616da23$export$b624eff549462981 = $1dd353382616da23$var$t;
$1dd353382616da23$export$7897aa7841a5380c = $1dd353382616da23$var$r;
$1dd353382616da23$export$602eac185826482c = $1dd353382616da23$var$d;
$1dd353382616da23$export$e2c29f18771995cb = $1dd353382616da23$var$g;
$1dd353382616da23$export$5f8d39834fd61797 = $1dd353382616da23$var$f;
$1dd353382616da23$export$74bf444e3cd11ea5 = $1dd353382616da23$var$p;
$1dd353382616da23$export$92387174baf9b227 = function(a) {
    return $1dd353382616da23$var$A(a) || $1dd353382616da23$var$z(a) === $1dd353382616da23$var$l;
};
$1dd353382616da23$export$ec112efeb987d9c6 = $1dd353382616da23$var$A;
$1dd353382616da23$export$b706b080d889d2c9 = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$k;
};
$1dd353382616da23$export$5be5a87408f70ddc = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$h;
};
$1dd353382616da23$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1dd353382616da23$var$c;
};
$1dd353382616da23$export$455c2e768291efa6 = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$n;
};
$1dd353382616da23$export$9522e17588c12572 = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$e;
};
$1dd353382616da23$export$2110ac352bb060b9 = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$t;
};
$1dd353382616da23$export$56885ab8b9c456ab = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$r;
};
$1dd353382616da23$export$d927fcb6adf8f9de = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$d;
};
$1dd353382616da23$export$b82d16f27459e05a = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$g;
};
$1dd353382616da23$export$522c17b4f5e123e8 = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$f;
};
$1dd353382616da23$export$1aabd8a0274ecfd6 = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$p;
};
$1dd353382616da23$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $1dd353382616da23$var$e || a === $1dd353382616da23$var$m || a === $1dd353382616da23$var$g || a === $1dd353382616da23$var$f || a === $1dd353382616da23$var$p || a === $1dd353382616da23$var$q || "object" === typeof a && null !== a && (a.$$typeof === $1dd353382616da23$var$t || a.$$typeof === $1dd353382616da23$var$r || a.$$typeof === $1dd353382616da23$var$h || a.$$typeof === $1dd353382616da23$var$k || a.$$typeof === $1dd353382616da23$var$n || a.$$typeof === $1dd353382616da23$var$w || a.$$typeof === $1dd353382616da23$var$x || a.$$typeof === $1dd353382616da23$var$y || a.$$typeof === $1dd353382616da23$var$v);
};
$1dd353382616da23$export$f5bbd400c2f4426f = $1dd353382616da23$var$z;

});

parcelRegister("hzb7Z", function(module, exports) {

$parcel$export(module.exports, "configureChains", function () { return configureChains; });
$parcel$export(module.exports, "deepEqual", function () { return deepEqual; });
$parcel$export(module.exports, "getCallParameters", function () { return getCallParameters; });
$parcel$export(module.exports, "getSendTransactionParameters", function () { return getSendTransactionParameters; });
$parcel$export(module.exports, "noopStorage", function () { return noopStorage; });
$parcel$export(module.exports, "createStorage", function () { return createStorage; });
$parcel$export(module.exports, "createConfig", function () { return createConfig; });
$parcel$export(module.exports, "connect", function () { return connect; });
$parcel$export(module.exports, "disconnect", function () { return disconnect; });
$parcel$export(module.exports, "erc20ABI", function () { return erc20ABI; });
$parcel$export(module.exports, "fetchToken", function () { return fetchToken; });
$parcel$export(module.exports, "readContracts", function () { return readContracts; });
$parcel$export(module.exports, "getPublicClient", function () { return getPublicClient; });
$parcel$export(module.exports, "getWalletClient", function () { return getWalletClient; });
$parcel$export(module.exports, "getWebSocketPublicClient", function () { return getWebSocketPublicClient; });
$parcel$export(module.exports, "watchPublicClient", function () { return watchPublicClient; });
$parcel$export(module.exports, "watchWalletClient", function () { return watchWalletClient; });
$parcel$export(module.exports, "watchWebSocketPublicClient", function () { return watchWebSocketPublicClient; });
$parcel$export(module.exports, "prepareWriteContract", function () { return prepareWriteContract; });
$parcel$export(module.exports, "getContract", function () { return getContract; });
$parcel$export(module.exports, "readContract", function () { return readContract; });
$parcel$export(module.exports, "watchContractEvent", function () { return watchContractEvent; });
$parcel$export(module.exports, "writeContract", function () { return writeContract; });
$parcel$export(module.exports, "fetchBalance", function () { return fetchBalance; });
$parcel$export(module.exports, "getAccount", function () { return getAccount; });
$parcel$export(module.exports, "getNetwork", function () { return getNetwork; });
$parcel$export(module.exports, "signMessage", function () { return signMessage; });
$parcel$export(module.exports, "signTypedData", function () { return signTypedData; });
$parcel$export(module.exports, "switchNetwork", function () { return switchNetwork; });
$parcel$export(module.exports, "watchAccount", function () { return watchAccount; });
$parcel$export(module.exports, "watchNetwork", function () { return watchNetwork; });
$parcel$export(module.exports, "fetchEnsAddress", function () { return fetchEnsAddress; });
$parcel$export(module.exports, "fetchEnsAvatar", function () { return fetchEnsAvatar; });
$parcel$export(module.exports, "fetchEnsName", function () { return fetchEnsName; });
$parcel$export(module.exports, "fetchEnsResolver", function () { return fetchEnsResolver; });
$parcel$export(module.exports, "fetchBlockNumber", function () { return fetchBlockNumber; });
$parcel$export(module.exports, "fetchFeeData", function () { return fetchFeeData; });
$parcel$export(module.exports, "fetchTransaction", function () { return fetchTransaction; });
$parcel$export(module.exports, "prepareSendTransaction", function () { return prepareSendTransaction; });
$parcel$export(module.exports, "sendTransaction", function () { return sendTransaction; });
$parcel$export(module.exports, "waitForTransaction", function () { return waitForTransaction; });

var $cDSuN = parcelRequire("cDSuN");

var $bWsgL = parcelRequire("bWsgL");

var $3iWI0 = parcelRequire("3iWI0");
var $4wsgh = parcelRequire("4wsgh");
var $jiwJs = parcelRequire("jiwJs");
var $6u2UO = parcelRequire("6u2UO");
var $1r7Xu = parcelRequire("1r7Xu");
var $5YPS7 = parcelRequire("5YPS7");
var $hiAQY = parcelRequire("hiAQY");
var $gvP8M = parcelRequire("gvP8M");
var $fDHPo = parcelRequire("fDHPo");
var $elMwh = parcelRequire("elMwh");
var $ea0vD = parcelRequire("ea0vD");
var $4UOEQ = parcelRequire("4UOEQ");
var $52Zu6 = parcelRequire("52Zu6");

var $5gTQZ = parcelRequire("5gTQZ");

var $co8BQ = parcelRequire("co8BQ");

var $jjoSA = parcelRequire("jjoSA");

var $gxDlk = parcelRequire("gxDlk");
function configureChains(defaultChains, providers, { batch = {
    multicall: {
        wait: 32
    }
}, pollingInterval = 4e3, rank, retryCount, retryDelay, stallTimeout } = {}) {
    if (!defaultChains.length) throw new Error("must have at least one chain");
    let chains = [];
    const httpUrls = {};
    const wsUrls = {};
    for (const chain of defaultChains){
        let configExists = false;
        for (const provider of providers){
            const apiConfig = provider(chain);
            if (!apiConfig) continue;
            configExists = true;
            if (!chains.some(({ id })=>id === chain.id)) chains = [
                ...chains,
                apiConfig.chain
            ];
            httpUrls[chain.id] = [
                ...httpUrls[chain.id] || [],
                ...apiConfig.rpcUrls.http
            ];
            if (apiConfig.rpcUrls.webSocket) wsUrls[chain.id] = [
                ...wsUrls[chain.id] || [],
                ...apiConfig.rpcUrls.webSocket
            ];
        }
        if (!configExists) throw new Error([
            `Could not find valid provider configuration for chain "${chain.name}".
`,
            "You may need to add `jsonRpcProvider` to `configureChains` with the chain's RPC URLs.",
            "Read more: https://wagmi.sh/core/providers/jsonRpc"
        ].join("\n"));
    }
    return {
        chains: chains,
        publicClient: ({ chainId })=>{
            const activeChain = chains.find((x)=>x.id === chainId) ?? defaultChains[0];
            const chainHttpUrls = httpUrls[activeChain.id];
            if (!chainHttpUrls || !chainHttpUrls[0]) throw new Error(`No providers configured for chain "${activeChain.id}"`);
            const publicClient = (0, $4wsgh.createPublicClient)({
                batch: batch,
                chain: activeChain,
                transport: (0, $jiwJs.fallback)(chainHttpUrls.map((url)=>(0, $gvP8M.http)(url, {
                        timeout: stallTimeout
                    })), {
                    rank: rank,
                    retryCount: retryCount,
                    retryDelay: retryDelay
                }),
                pollingInterval: pollingInterval
            });
            return Object.assign(publicClient, {
                chains: chains
            });
        },
        webSocketPublicClient: ({ chainId })=>{
            const activeChain = chains.find((x)=>x.id === chainId) ?? defaultChains[0];
            const chainWsUrls = wsUrls[activeChain.id];
            if (!chainWsUrls || !chainWsUrls[0]) return void 0;
            const publicClient = (0, $4wsgh.createPublicClient)({
                batch: batch,
                chain: activeChain,
                transport: (0, $jiwJs.fallback)(chainWsUrls.map((url)=>(0, $4UOEQ.webSocket)(url, {
                        timeout: stallTimeout
                    })), {
                    rank: rank,
                    retryCount: retryCount,
                    retryDelay: retryDelay
                }),
                pollingInterval: pollingInterval
            });
            return Object.assign(publicClient, {
                chains: chains
            });
        }
    };
}
var ChainMismatchError = class extends Error {
    constructor({ activeChain, targetChain }){
        super(`Chain mismatch: Expected "${targetChain}", received "${activeChain}".`);
        this.name = "ChainMismatchError";
    }
};
var ChainNotConfiguredError = class extends Error {
    constructor({ chainId, connectorId }){
        super(`Chain "${chainId}" not configured${connectorId ? ` for connector "${connectorId}"` : ""}.`);
        this.name = "ChainNotConfigured";
    }
};
var ConnectorAlreadyConnectedError = class extends Error {
    constructor(){
        super(...arguments);
        this.name = "ConnectorAlreadyConnectedError";
        this.message = "Connector already connected";
    }
};
var ConfigChainsNotFound = class extends Error {
    constructor(){
        super(...arguments);
        this.name = "ConfigChainsNotFound";
        this.message = "No chains were found on the wagmi config. Some functions that require a chain may not work.";
    }
};
var SwitchChainNotSupportedError = class extends Error {
    constructor({ connector }){
        super(`"${connector.name}" does not support programmatic chain switching.`);
        this.name = "SwitchChainNotSupportedError";
    }
};
// src/utils/deepEqual.ts
function deepEqual(a, b) {
    if (a === b) return true;
    if (a && b && typeof a === "object" && typeof b === "object") {
        if (a.constructor !== b.constructor) return false;
        let length;
        let i;
        if (Array.isArray(a) && Array.isArray(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!deepEqual(a[i], b[i])) return false;
            return true;
        }
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        const keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key && !deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
// src/utils/deserialize.ts
var findAndReplace = (cacheRef, { find, replace })=>{
    if (cacheRef && find(cacheRef)) return replace(cacheRef);
    if (typeof cacheRef !== "object") return cacheRef;
    if (Array.isArray(cacheRef)) return cacheRef.map((item)=>findAndReplace(item, {
            find: find,
            replace: replace
        }));
    if (cacheRef instanceof Object) return Object.entries(cacheRef).reduce((curr, [key, value])=>({
            ...curr,
            [key]: findAndReplace(value, {
                find: find,
                replace: replace
            })
        }), {});
    return cacheRef;
};
function deserialize(cachedString) {
    const cache = JSON.parse(cachedString);
    const deserializedCacheWithBigInts = findAndReplace(cache, {
        find: (data)=>typeof data === "string" && data.startsWith("#bigint."),
        replace: (data)=>BigInt(data.replace("#bigint.", ""))
    });
    return deserializedCacheWithBigInts;
}
// src/utils/getParameters.ts
function getCallParameters(args) {
    return {
        accessList: args.accessList,
        account: args.account,
        blockNumber: args.blockNumber,
        blockTag: args.blockTag,
        data: args.data,
        gas: args.gas,
        gasPrice: args.gasPrice,
        maxFeePerGas: args.maxFeePerGas,
        maxPriorityFeePerGas: args.maxPriorityFeePerGas,
        nonce: args.nonce,
        to: args.to,
        value: args.value
    };
}
function getSendTransactionParameters(args) {
    return {
        accessList: args.accessList,
        account: args.account,
        data: args.data,
        gas: args.gas,
        gasPrice: args.gasPrice,
        maxFeePerGas: args.maxFeePerGas,
        maxPriorityFeePerGas: args.maxPriorityFeePerGas,
        nonce: args.nonce,
        to: args.to,
        value: args.value
    };
}
function getUnit(unit) {
    if (typeof unit === "number") return unit;
    if (unit === "wei") return 0;
    return Math.abs((0, $52Zu6.weiUnits)[unit]);
}
// src/utils/serialize.ts
function getReferenceKey(keys, cutoff) {
    return keys.slice(0, cutoff).join(".") || ".";
}
function getCutoff(array, value) {
    const { length } = array;
    for(let index = 0; index < length; ++index){
        if (array[index] === value) return index + 1;
    }
    return 0;
}
function createReplacer(replacer, circularReplacer) {
    const hasReplacer = typeof replacer === "function";
    const hasCircularReplacer = typeof circularReplacer === "function";
    const cache = [];
    const keys = [];
    return function replace(key, value) {
        if (typeof value === "object") {
            if (cache.length) {
                const thisCutoff = getCutoff(cache, this);
                if (thisCutoff === 0) cache[cache.length] = this;
                else {
                    cache.splice(thisCutoff);
                    keys.splice(thisCutoff);
                }
                keys[keys.length] = key;
                const valueCutoff = getCutoff(cache, value);
                if (valueCutoff !== 0) return hasCircularReplacer ? circularReplacer.call(this, key, value, getReferenceKey(keys, valueCutoff)) : `[ref=${getReferenceKey(keys, valueCutoff)}]`;
            } else {
                cache[0] = value;
                keys[0] = key;
            }
        }
        return hasReplacer ? replacer.call(this, key, value) : value;
    };
}
function serialize(value, replacer, indent, circularReplacer) {
    return JSON.stringify(value, createReplacer((key, value_)=>{
        const value2 = typeof value_ === "bigint" ? `#bigint.${value_.toString()}` : value_;
        return replacer?.(key, value2) || value2;
    }, circularReplacer), indent ?? void 0);
}
// src/storage.ts
var noopStorage = {
    getItem: (_key)=>"",
    setItem: (_key, _value)=>null,
    removeItem: (_key)=>null
};
function createStorage({ deserialize: deserialize2 = deserialize, key: prefix = "wagmi", serialize: serialize2 = serialize, storage }) {
    return {
        ...storage,
        getItem: (key, defaultState = null)=>{
            const value = storage.getItem(`${prefix}.${key}`);
            try {
                return value ? deserialize2(value) : defaultState;
            } catch (error) {
                console.warn(error);
                return defaultState;
            }
        },
        setItem: (key, value)=>{
            if (value === null) storage.removeItem(`${prefix}.${key}`);
            else try {
                storage.setItem(`${prefix}.${key}`, serialize2(value));
            } catch (err) {
                console.error(err);
            }
        },
        removeItem: (key)=>storage.removeItem(`${prefix}.${key}`)
    };
}
// src/config.ts
var storeKey = "store";
var _isAutoConnecting, _lastUsedConnector, _addEffects, addEffects_fn;
var Config = class {
    constructor({ autoConnect = false, connectors = [
        new (0, $cDSuN.InjectedConnector)()
    ], publicClient, storage = createStorage({
        storage: typeof window !== "undefined" ? window.localStorage : noopStorage
    }), logger = {
        warn: console.warn
    }, webSocketPublicClient }){
        (0, $bWsgL.__privateAdd)(this, _addEffects);
        this.publicClients = /* @__PURE__ */ new Map();
        this.webSocketPublicClients = /* @__PURE__ */ new Map();
        (0, $bWsgL.__privateAdd)(this, _isAutoConnecting, void 0);
        (0, $bWsgL.__privateAdd)(this, _lastUsedConnector, void 0);
        this.args = {
            autoConnect: autoConnect,
            connectors: connectors,
            logger: logger,
            publicClient: publicClient,
            storage: storage,
            webSocketPublicClient: webSocketPublicClient
        };
        let status = "disconnected";
        let chainId;
        if (autoConnect) try {
            const rawState = storage.getItem(storeKey);
            const data = rawState?.state?.data;
            status = data?.account ? "reconnecting" : "connecting";
            chainId = data?.chain?.id;
        } catch (_error) {}
        const connectors_ = typeof connectors === "function" ? connectors() : connectors;
        connectors_.forEach((connector)=>connector.setStorage(storage));
        this.store = (0, $jjoSA.createStore)((0, $co8BQ.subscribeWithSelector)((0, $co8BQ.persist)(()=>({
                connectors: connectors_,
                publicClient: this.getPublicClient({
                    chainId: chainId
                }),
                status: status,
                webSocketPublicClient: this.getWebSocketPublicClient({
                    chainId: chainId
                })
            }), {
            name: storeKey,
            storage: storage,
            partialize: (state)=>({
                    ...autoConnect && {
                        data: {
                            account: state?.data?.account,
                            chain: state?.data?.chain
                        }
                    },
                    chains: state?.chains
                }),
            version: 2
        })));
        this.storage = storage;
        (0, $bWsgL.__privateSet)(this, _lastUsedConnector, storage?.getItem("wallet"));
        (0, $bWsgL.__privateMethod)(this, _addEffects, addEffects_fn).call(this);
        if (autoConnect && typeof window !== "undefined") setTimeout(async ()=>await this.autoConnect(), 0);
    }
    get chains() {
        return this.store.getState().chains;
    }
    get connectors() {
        return this.store.getState().connectors;
    }
    get connector() {
        return this.store.getState().connector;
    }
    get data() {
        return this.store.getState().data;
    }
    get error() {
        return this.store.getState().error;
    }
    get lastUsedChainId() {
        return this.data?.chain?.id;
    }
    get publicClient() {
        return this.store.getState().publicClient;
    }
    get status() {
        return this.store.getState().status;
    }
    get subscribe() {
        return this.store.subscribe;
    }
    get webSocketPublicClient() {
        return this.store.getState().webSocketPublicClient;
    }
    setState(updater) {
        const newState = typeof updater === "function" ? updater(this.store.getState()) : updater;
        this.store.setState(newState, true);
    }
    clearState() {
        this.setState((x)=>({
                ...x,
                chains: void 0,
                connector: void 0,
                data: void 0,
                error: void 0,
                status: "disconnected"
            }));
    }
    async destroy() {
        if (this.connector) await this.connector.disconnect?.();
        (0, $bWsgL.__privateSet)(this, _isAutoConnecting, false);
        this.clearState();
        this.store.destroy();
    }
    async autoConnect() {
        if ((0, $bWsgL.__privateGet)(this, _isAutoConnecting)) return;
        (0, $bWsgL.__privateSet)(this, _isAutoConnecting, true);
        this.setState((x)=>({
                ...x,
                status: x.data?.account ? "reconnecting" : "connecting"
            }));
        const sorted = (0, $bWsgL.__privateGet)(this, _lastUsedConnector) ? [
            ...this.connectors
        ].sort((x)=>x.id === (0, $bWsgL.__privateGet)(this, _lastUsedConnector) ? -1 : 1) : this.connectors;
        let connected = false;
        for (const connector of sorted){
            if (!connector.ready || !connector.isAuthorized) continue;
            const isAuthorized = await connector.isAuthorized();
            if (!isAuthorized) continue;
            const data = await connector.connect();
            this.setState((x)=>({
                    ...x,
                    connector: connector,
                    chains: connector?.chains,
                    data: data,
                    status: "connected"
                }));
            connected = true;
            break;
        }
        if (!connected) this.setState((x)=>({
                ...x,
                data: void 0,
                status: "disconnected"
            }));
        (0, $bWsgL.__privateSet)(this, _isAutoConnecting, false);
        return this.data;
    }
    setConnectors(connectors) {
        this.args = {
            ...this.args,
            connectors: connectors
        };
        const connectors_ = typeof connectors === "function" ? connectors() : connectors;
        connectors_.forEach((connector)=>connector.setStorage(this.args.storage));
        this.setState((x)=>({
                ...x,
                connectors: connectors_
            }));
    }
    getPublicClient({ chainId } = {}) {
        let publicClient_ = this.publicClients.get(-1);
        if (publicClient_ && publicClient_?.chain.id === chainId) return publicClient_;
        publicClient_ = this.publicClients.get(chainId ?? -1);
        if (publicClient_) return publicClient_;
        const { publicClient } = this.args;
        publicClient_ = typeof publicClient === "function" ? publicClient({
            chainId: chainId
        }) : publicClient;
        this.publicClients.set(chainId ?? -1, publicClient_);
        return publicClient_;
    }
    setPublicClient(publicClient) {
        const chainId = this.data?.chain?.id;
        this.args = {
            ...this.args,
            publicClient: publicClient
        };
        this.publicClients.clear();
        this.setState((x)=>({
                ...x,
                publicClient: this.getPublicClient({
                    chainId: chainId
                })
            }));
    }
    getWebSocketPublicClient({ chainId } = {}) {
        let webSocketPublicClient_ = this.webSocketPublicClients.get(-1);
        if (webSocketPublicClient_ && webSocketPublicClient_?.chain.id === chainId) return webSocketPublicClient_;
        webSocketPublicClient_ = this.webSocketPublicClients.get(chainId ?? -1);
        if (webSocketPublicClient_) return webSocketPublicClient_;
        const { webSocketPublicClient } = this.args;
        webSocketPublicClient_ = typeof webSocketPublicClient === "function" ? webSocketPublicClient({
            chainId: chainId
        }) : webSocketPublicClient;
        if (webSocketPublicClient_) this.webSocketPublicClients.set(chainId ?? -1, webSocketPublicClient_);
        return webSocketPublicClient_;
    }
    setWebSocketPublicClient(webSocketPublicClient) {
        const chainId = this.data?.chain?.id;
        this.args = {
            ...this.args,
            webSocketPublicClient: webSocketPublicClient
        };
        this.webSocketPublicClients.clear();
        this.setState((x)=>({
                ...x,
                webSocketPublicClient: this.getWebSocketPublicClient({
                    chainId: chainId
                })
            }));
    }
    setLastUsedConnector(lastUsedConnector = null) {
        this.storage?.setItem("wallet", lastUsedConnector);
    }
};
_isAutoConnecting = new WeakMap();
_lastUsedConnector = new WeakMap();
_addEffects = new WeakSet();
addEffects_fn = function() {
    const onChange = (data)=>{
        this.setState((x)=>({
                ...x,
                data: {
                    ...x.data,
                    ...data
                }
            }));
    };
    const onDisconnect = ()=>{
        this.clearState();
    };
    const onError = (error)=>{
        this.setState((x)=>({
                ...x,
                error: error
            }));
    };
    this.store.subscribe(({ connector })=>connector, (connector, prevConnector)=>{
        prevConnector?.off?.("change", onChange);
        prevConnector?.off?.("disconnect", onDisconnect);
        prevConnector?.off?.("error", onError);
        if (!connector) return;
        connector.on?.("change", onChange);
        connector.on?.("disconnect", onDisconnect);
        connector.on?.("error", onError);
    });
    const { publicClient, webSocketPublicClient } = this.args;
    const subscribePublicClient = typeof publicClient === "function";
    const subscribeWebSocketPublicClient = typeof webSocketPublicClient === "function";
    if (subscribePublicClient || subscribeWebSocketPublicClient) this.store.subscribe(({ data })=>data?.chain?.id, (chainId)=>{
        this.setState((x)=>({
                ...x,
                publicClient: this.getPublicClient({
                    chainId: chainId
                }),
                webSocketPublicClient: this.getWebSocketPublicClient({
                    chainId: chainId
                })
            }));
    });
};
var config;
function createConfig(args) {
    const config_ = new Config(args);
    config = config_;
    return config_;
}
function getConfig() {
    if (!config) throw new Error("No wagmi config found. Ensure you have set up a config: https://wagmi.sh/react/config");
    return config;
}
// src/actions/accounts/connect.ts
async function connect({ chainId, connector }) {
    const config2 = getConfig();
    const activeConnector = config2.connector;
    if (activeConnector && connector.id === activeConnector.id) throw new ConnectorAlreadyConnectedError();
    try {
        config2.setState((x)=>({
                ...x,
                status: "connecting"
            }));
        const data = await connector.connect({
            chainId: chainId
        });
        config2.setLastUsedConnector(connector.id);
        config2.setState((x)=>({
                ...x,
                connector: connector,
                chains: connector?.chains,
                data: data,
                status: "connected"
            }));
        config2.storage.setItem("connected", true);
        return {
            ...data,
            connector: connector
        };
    } catch (err) {
        config2.setState((x)=>{
            return {
                ...x,
                status: x.connector ? "connected" : "disconnected"
            };
        });
        throw err;
    }
}
// src/actions/accounts/disconnect.ts
async function disconnect() {
    const config2 = getConfig();
    if (config2.connector) await config2.connector.disconnect();
    config2.clearState();
    config2.storage.removeItem("connected");
}
// src/constants/abis.ts
var erc20ABI = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "allowance",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint8"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transfer",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    }
];
var erc20ABI_bytes32 = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "allowance",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint8"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32"
            }
        ]
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transfer",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    }
];
var erc721ABI = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: true,
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "ApprovalForAll",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                name: "approved",
                type: "bool"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "payable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "getApproved",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "address"
            }
        ]
    },
    {
        type: "function",
        name: "isApprovedForAll",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "operator",
                type: "address"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "ownerOf",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "owner",
                type: "address"
            }
        ]
    },
    {
        type: "function",
        name: "safeTransferFrom",
        stateMutability: "payable",
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "safeTransferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "id",
                type: "uint256"
            },
            {
                name: "data",
                type: "bytes"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "setApprovalForAll",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "operator",
                type: "address"
            },
            {
                name: "approved",
                type: "bool"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "tokenByIndex",
        stateMutability: "view",
        inputs: [
            {
                name: "index",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "tokenByIndex",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "index",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "tokenURI",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "payable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "tokeId",
                type: "uint256"
            }
        ],
        outputs: []
    }
];
var erc4626ABI = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                name: "receiver",
                type: "address"
            },
            {
                indexed: false,
                name: "assets",
                type: "uint256"
            },
            {
                indexed: false,
                name: "shares",
                type: "uint256"
            }
        ],
        name: "Deposit",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                name: "receiver",
                type: "address"
            },
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: false,
                name: "assets",
                type: "uint256"
            },
            {
                indexed: false,
                name: "shares",
                type: "uint256"
            }
        ],
        name: "Withdraw",
        type: "event"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "asset",
        outputs: [
            {
                name: "assetTokenAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "convertToAssets",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "convertToShares",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            }
        ],
        name: "deposit",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "caller",
                type: "address"
            }
        ],
        name: "maxDeposit",
        outputs: [
            {
                name: "maxAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "caller",
                type: "address"
            }
        ],
        name: "maxMint",
        outputs: [
            {
                name: "maxShares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "maxRedeem",
        outputs: [
            {
                name: "maxShares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "maxWithdraw",
        outputs: [
            {
                name: "maxAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            }
        ],
        name: "mint",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "previewDeposit",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "previewMint",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "previewRedeem",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "previewWithdraw",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            },
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "redeem",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "totalAssets",
        outputs: [
            {
                name: "totalManagedAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "to",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            },
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "withdraw",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];
async function fetchToken({ address, chainId, formatUnits: unit = 18 }) {
    async function fetchToken_({ abi }) {
        const erc20Config = {
            address: address,
            abi: abi,
            chainId: chainId
        };
        const [decimals, name, symbol, totalSupply] = await readContracts({
            allowFailure: false,
            contracts: [
                {
                    ...erc20Config,
                    functionName: "decimals"
                },
                {
                    ...erc20Config,
                    functionName: "name"
                },
                {
                    ...erc20Config,
                    functionName: "symbol"
                },
                {
                    ...erc20Config,
                    functionName: "totalSupply"
                }
            ]
        });
        return {
            address: address,
            decimals: decimals,
            name: name,
            symbol: symbol,
            totalSupply: {
                formatted: (0, $6u2UO.formatUnits)(totalSupply, getUnit(unit)),
                value: totalSupply
            }
        };
    }
    try {
        return await fetchToken_({
            abi: erc20ABI
        });
    } catch (err) {
        if (err instanceof (0, $3iWI0.ContractFunctionExecutionError)) {
            const { name, symbol, ...rest } = await fetchToken_({
                abi: erc20ABI_bytes32
            });
            return {
                name: (0, $hiAQY.hexToString)((0, $ea0vD.trim)(name, {
                    dir: "right"
                })),
                symbol: (0, $hiAQY.hexToString)((0, $ea0vD.trim)(symbol, {
                    dir: "right"
                })),
                ...rest
            };
        }
        throw err;
    }
}
// src/actions/viem/getPublicClient.ts
function getPublicClient({ chainId } = {}) {
    const config2 = getConfig();
    if (chainId) return config2.getPublicClient({
        chainId: chainId
    }) || config2.publicClient;
    return config2.publicClient;
}
// src/actions/viem/getWalletClient.ts
async function getWalletClient({ chainId } = {}) {
    const config2 = getConfig();
    const walletClient = await config2.connector?.getWalletClient?.({
        chainId: chainId
    }) || null;
    return walletClient;
}
// src/actions/viem/getWebSocketPublicClient.ts
function getWebSocketPublicClient({ chainId } = {}) {
    const config2 = getConfig();
    if (chainId) return config2.getWebSocketPublicClient({
        chainId: chainId
    }) || config2.webSocketPublicClient;
    return config2.webSocketPublicClient;
}
// src/actions/viem/watchPublicClient.ts
function watchPublicClient(args, callback) {
    const config2 = getConfig();
    const handleChange = async ()=>callback(getPublicClient(args));
    const unsubscribe = config2.subscribe(({ publicClient })=>publicClient, handleChange);
    return unsubscribe;
}
function watchWalletClient({ chainId }, callback) {
    const config2 = getConfig();
    const handleChange = async ({ chainId: chainId_ })=>{
        if (chainId && chainId_ && chainId !== chainId_) return;
        const walletClient = await getWalletClient({
            chainId: chainId
        });
        if (!getConfig().connector) return callback(null);
        return callback(walletClient);
    };
    const unsubscribe = config2.subscribe(({ data, connector })=>({
            account: data?.account,
            chainId: data?.chain?.id,
            connector: connector
        }), handleChange, {
        equalityFn: (0, $gxDlk.shallow)
    });
    return unsubscribe;
}
// src/actions/viem/watchWebSocketPublicClient.ts
function watchWebSocketPublicClient(args, callback) {
    const config2 = getConfig();
    const handleChange = async ()=>callback(getWebSocketPublicClient(args));
    const unsubscribe = config2.subscribe(({ webSocketPublicClient })=>webSocketPublicClient, handleChange);
    return unsubscribe;
}
// src/actions/contracts/prepareWriteContract.ts
async function prepareWriteContract({ abi, address, args, chainId, dataSuffix, functionName, walletClient: walletClient_, ...config2 }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const walletClient = walletClient_ ?? await getWalletClient({
        chainId: chainId
    });
    if (!walletClient) throw new (0, $5gTQZ.ConnectorNotFoundError)();
    if (chainId) assertActiveChain({
        chainId: chainId
    });
    const { account, accessList, blockNumber, blockTag, gas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, nonce, value } = getCallParameters(config2);
    const { result, request } = await publicClient.simulateContract({
        abi: abi,
        address: address,
        functionName: functionName,
        args: args,
        account: account || walletClient.account,
        accessList: accessList,
        blockNumber: blockNumber,
        blockTag: blockTag,
        dataSuffix: dataSuffix,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        nonce: nonce,
        value: value
    });
    const minimizedAbi = abi.filter((abiItem)=>"name" in abiItem && abiItem.name === functionName);
    return {
        mode: "prepared",
        request: {
            ...request,
            abi: minimizedAbi,
            chainId: chainId
        },
        result: result
    };
}
function getContract({ address, abi, chainId, walletClient }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    return (0, $5YPS7.getContract)({
        address: address,
        abi: abi,
        publicClient: publicClient,
        walletClient: walletClient
    });
}
// src/actions/contracts/multicall.ts
async function multicall({ chainId, contracts, blockNumber, blockTag, ...args }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    if (!publicClient.chains) throw new ConfigChainsNotFound();
    if (chainId && publicClient.chain.id !== chainId) throw new ChainNotConfiguredError({
        chainId: chainId
    });
    return publicClient.multicall({
        allowFailure: args.allowFailure ?? true,
        blockNumber: blockNumber,
        blockTag: blockTag,
        contracts: contracts
    });
}
// src/actions/contracts/readContract.ts
async function readContract({ address, account, chainId, abi, args, functionName, blockNumber, blockTag }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    return publicClient.readContract({
        abi: abi,
        address: address,
        account: account,
        functionName: functionName,
        args: args,
        blockNumber: blockNumber,
        blockTag: blockTag
    });
}
async function readContracts({ contracts, blockNumber, blockTag, ...args }) {
    const { allowFailure = true } = args;
    try {
        const publicClient = getPublicClient();
        const contractsByChainId = contracts.reduce((contracts2, contract, index)=>{
            const chainId = contract.chainId ?? publicClient.chain.id;
            return {
                ...contracts2,
                [chainId]: [
                    ...contracts2[chainId] || [],
                    {
                        contract: contract,
                        index: index
                    }
                ]
            };
        }, {});
        const promises = ()=>Object.entries(contractsByChainId).map(([chainId, contracts2])=>multicall({
                    allowFailure: allowFailure,
                    chainId: parseInt(chainId),
                    contracts: contracts2.map(({ contract })=>contract),
                    blockNumber: blockNumber,
                    blockTag: blockTag
                }));
        const multicallResults = (await Promise.all(promises())).flat();
        const resultIndexes = Object.values(contractsByChainId).flatMap((contracts2)=>contracts2.map(({ index })=>index));
        return multicallResults.reduce((results, result, index)=>{
            if (results) results[resultIndexes[index]] = result;
            return results;
        }, []);
    } catch (err) {
        if (err instanceof (0, $3iWI0.ContractFunctionExecutionError)) throw err;
        const promises = ()=>contracts.map((contract)=>readContract({
                    ...contract,
                    blockNumber: blockNumber,
                    blockTag: blockTag
                }));
        if (allowFailure) return (await Promise.allSettled(promises())).map((result)=>{
            if (result.status === "fulfilled") return {
                result: result.value,
                status: "success"
            };
            return {
                error: result.reason,
                result: void 0,
                status: "failure"
            };
        });
        return await Promise.all(promises());
    }
}
function watchContractEvent({ address, abi, chainId, eventName }, callback) {
    let unwatch;
    const watchEvent = async ()=>{
        if (unwatch) unwatch();
        const publicClient = getWebSocketPublicClient({
            chainId: chainId
        }) || getPublicClient({
            chainId: chainId
        });
        unwatch = publicClient.watchContractEvent({
            address: address,
            abi: abi,
            eventName: eventName,
            onLogs: callback
        });
    };
    watchEvent();
    const config2 = getConfig();
    const unsubscribe = config2.subscribe(({ publicClient, webSocketPublicClient })=>({
            publicClient: publicClient,
            webSocketPublicClient: webSocketPublicClient
        }), watchEvent, {
        equalityFn: (0, $gxDlk.shallow)
    });
    return ()=>{
        unwatch?.();
        unsubscribe();
    };
}
function watchBlockNumber(args, callback) {
    let unwatch;
    const createListener = (publicClient)=>{
        if (unwatch) unwatch();
        unwatch = publicClient.watchBlockNumber({
            onBlockNumber: callback,
            emitOnBegin: true,
            poll: true
        });
    };
    const publicClient_ = getWebSocketPublicClient({
        chainId: args.chainId
    }) ?? getPublicClient({
        chainId: args.chainId
    });
    if (args.listen) createListener(publicClient_);
    const config2 = getConfig();
    const unsubscribe = config2.subscribe(({ publicClient, webSocketPublicClient })=>({
            publicClient: publicClient,
            webSocketPublicClient: webSocketPublicClient
        }), async ({ publicClient, webSocketPublicClient })=>{
        const publicClient_2 = webSocketPublicClient ?? publicClient;
        if (args.listen && !args.chainId && publicClient_2) createListener(publicClient_2);
    }, {
        equalityFn: (0, $gxDlk.shallow)
    });
    return ()=>{
        unsubscribe();
        unwatch?.();
    };
}
// src/actions/contracts/watchMulticall.ts
function watchMulticall(args, callback) {
    const config2 = getConfig();
    const handleChange = async ()=>callback(await multicall(args));
    const unwatch = args.listenToBlock ? watchBlockNumber({
        listen: true
    }, handleChange) : void 0;
    const unsubscribe = config2.subscribe(({ publicClient })=>publicClient, handleChange);
    return ()=>{
        unsubscribe();
        unwatch?.();
    };
}
// src/actions/contracts/watchReadContract.ts
function watchReadContract(args, callback) {
    const config2 = getConfig();
    const handleChange = async ()=>callback(await readContract(args));
    const unwatch = args.listenToBlock ? watchBlockNumber({
        listen: true
    }, handleChange) : void 0;
    const unsubscribe = config2.subscribe(({ publicClient })=>publicClient, handleChange);
    return ()=>{
        unsubscribe();
        unwatch?.();
    };
}
// src/actions/contracts/watchReadContracts.ts
function watchReadContracts(args, callback) {
    const config2 = getConfig();
    const handleChange = async ()=>callback(await readContracts(args));
    const unwatch = args.listenToBlock ? watchBlockNumber({
        listen: true
    }, handleChange) : void 0;
    const unsubscribe = config2.subscribe(({ publicClient })=>publicClient, handleChange);
    return ()=>{
        unsubscribe();
        unwatch?.();
    };
}
// src/actions/contracts/writeContract.ts
async function writeContract(config2) {
    const walletClient = await getWalletClient({
        chainId: config2.chainId
    });
    if (!walletClient) throw new (0, $5gTQZ.ConnectorNotFoundError)();
    if (config2.chainId) assertActiveChain({
        chainId: config2.chainId
    });
    let request;
    if (config2.mode === "prepared") request = config2.request;
    else {
        const { chainId: _, mode: __, ...args } = config2;
        const res = await prepareWriteContract(args);
        request = res.request;
    }
    const hash = await walletClient.writeContract({
        ...request,
        chain: config2.chainId ? {
            id: config2.chainId
        } : null
    });
    return {
        hash: hash
    };
}
// src/actions/accounts/fetchBalance.ts
async function fetchBalance({ address, chainId, formatUnits: unit, token }) {
    const config2 = getConfig();
    const publicClient = getPublicClient({
        chainId: chainId
    });
    if (token) {
        const fetchContractBalance = async ({ abi })=>{
            const erc20Config = {
                abi: abi,
                address: token,
                chainId: chainId
            };
            const [value2, decimals, symbol] = await readContracts({
                allowFailure: false,
                contracts: [
                    {
                        ...erc20Config,
                        functionName: "balanceOf",
                        args: [
                            address
                        ]
                    },
                    {
                        ...erc20Config,
                        functionName: "decimals"
                    },
                    {
                        ...erc20Config,
                        functionName: "symbol"
                    }
                ]
            });
            return {
                decimals: decimals,
                formatted: (0, $6u2UO.formatUnits)(value2 ?? "0", getUnit(unit ?? decimals)),
                symbol: symbol,
                value: value2
            };
        };
        try {
            return await fetchContractBalance({
                abi: erc20ABI
            });
        } catch (err) {
            if (err instanceof (0, $3iWI0.ContractFunctionExecutionError)) {
                const { symbol, ...rest } = await fetchContractBalance({
                    abi: erc20ABI_bytes32
                });
                return {
                    symbol: (0, $hiAQY.hexToString)((0, $ea0vD.trim)(symbol, {
                        dir: "right"
                    })),
                    ...rest
                };
            }
            throw err;
        }
    }
    const chains = [
        ...config2.publicClient.chains || [],
        ...config2.chains ?? []
    ];
    const value = await publicClient.getBalance({
        address: address
    });
    const chain = chains.find((x)=>x.id === publicClient.chain.id);
    return {
        decimals: chain?.nativeCurrency.decimals ?? 18,
        formatted: (0, $6u2UO.formatUnits)(value ?? "0", getUnit(unit ?? 18)),
        symbol: chain?.nativeCurrency.symbol ?? "ETH",
        value: value
    };
}
// src/actions/accounts/getAccount.ts
function getAccount() {
    const { data, connector, status } = getConfig();
    switch(status){
        case "connected":
            return {
                address: data?.account,
                connector: connector,
                isConnected: true,
                isConnecting: false,
                isDisconnected: false,
                isReconnecting: false,
                status: status
            };
        case "reconnecting":
            return {
                address: data?.account,
                connector: connector,
                isConnected: !!data?.account,
                isConnecting: false,
                isDisconnected: false,
                isReconnecting: true,
                status: status
            };
        case "connecting":
            return {
                address: data?.account,
                connector: connector,
                isConnected: false,
                isConnecting: true,
                isDisconnected: false,
                isReconnecting: false,
                status: status
            };
        case "disconnected":
            return {
                address: void 0,
                connector: void 0,
                isConnected: false,
                isConnecting: false,
                isDisconnected: true,
                isReconnecting: false,
                status: status
            };
    }
}
// src/actions/accounts/getNetwork.ts
function getNetwork() {
    const config2 = getConfig();
    const chainId = config2.data?.chain?.id;
    const activeChains = config2.chains ?? [];
    const activeChain = [
        ...config2.publicClient?.chains || [],
        ...activeChains
    ].find((x)=>x.id === chainId) ?? {
        id: chainId,
        name: `Chain ${chainId}`,
        network: `${chainId}`,
        nativeCurrency: {
            name: "Ether",
            decimals: 18,
            symbol: "ETH"
        },
        rpcUrls: {
            default: {
                http: [
                    ""
                ]
            },
            public: {
                http: [
                    ""
                ]
            }
        }
    };
    return {
        chain: chainId ? {
            ...activeChain,
            ...config2.data?.chain,
            id: chainId
        } : void 0,
        chains: activeChains
    };
}
// src/actions/accounts/signMessage.ts
async function signMessage(args) {
    const walletClient = await getWalletClient();
    if (!walletClient) throw new (0, $5gTQZ.ConnectorNotFoundError)();
    return await walletClient.signMessage({
        message: args.message
    });
}
// src/actions/accounts/signTypedData.ts
async function signTypedData({ domain, message, primaryType, types }) {
    const walletClient = await getWalletClient();
    if (!walletClient) throw new (0, $5gTQZ.ConnectorNotFoundError)();
    const { chainId } = domain;
    if (chainId) assertActiveChain({
        chainId: chainId
    });
    return walletClient.signTypedData({
        message: message,
        primaryType: primaryType,
        types: types,
        domain: domain
    });
}
// src/actions/accounts/switchNetwork.ts
async function switchNetwork({ chainId }) {
    const { connector } = getConfig();
    if (!connector) throw new (0, $5gTQZ.ConnectorNotFoundError)();
    if (!connector.switchChain) throw new SwitchChainNotSupportedError({
        connector: connector
    });
    return connector.switchChain(chainId);
}
function watchAccount(callback, { selector = (x)=>x } = {}) {
    const config2 = getConfig();
    const handleChange = ()=>callback(getAccount());
    const unsubscribe = config2.subscribe(({ data, connector, status })=>selector({
            address: data?.account,
            connector: connector,
            status: status
        }), handleChange, {
        equalityFn: (0, $gxDlk.shallow)
    });
    return unsubscribe;
}
function watchNetwork(callback, { selector = (x)=>x } = {}) {
    const config2 = getConfig();
    const handleChange = ()=>callback(getNetwork());
    const unsubscribe = config2.subscribe(({ data, chains })=>selector({
            chainId: data?.chain?.id,
            chains: chains
        }), handleChange, {
        equalityFn: (0, $gxDlk.shallow)
    });
    return unsubscribe;
}

async function fetchEnsAddress({ chainId, name }) {
    const { normalize } = await (parcelRequire("knIGM"));
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const address = await publicClient.getEnsAddress({
        name: normalize(name)
    });
    try {
        if (address === "0x0000000000000000000000000000000000000000") return null;
        return address ? (0, $1r7Xu.getAddress)(address) : null;
    } catch (_error) {
        return null;
    }
}

// src/actions/ens/fetchEnsAvatar.ts
async function fetchEnsAvatar({ name, chainId }) {
    const { normalize } = await (parcelRequire("knIGM"));
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const avatar = await publicClient.getEnsAvatar({
        name: normalize(name)
    });
    return avatar;
}
async function fetchEnsName({ address, chainId }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    return publicClient.getEnsName({
        address: (0, $1r7Xu.getAddress)(address)
    });
}

// src/actions/ens/fetchEnsResolver.ts
async function fetchEnsResolver({ chainId, name }) {
    const { normalize } = await (parcelRequire("knIGM"));
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const resolver = await publicClient.getEnsResolver({
        name: normalize(name)
    });
    return resolver;
}
// src/actions/network-status/fetchBlockNumber.ts
async function fetchBlockNumber({ chainId } = {}) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const blockNumber = await publicClient.getBlockNumber();
    return blockNumber;
}
async function fetchFeeData({ chainId, formatUnits: units = "gwei" } = {}) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const block = await publicClient.getBlock();
    let gasPrice = null;
    try {
        gasPrice = await publicClient.getGasPrice();
    } catch  {}
    let lastBaseFeePerGas = null;
    let maxFeePerGas = null;
    let maxPriorityFeePerGas = null;
    if (block?.baseFeePerGas) {
        lastBaseFeePerGas = block.baseFeePerGas;
        maxPriorityFeePerGas = (0, $elMwh.parseGwei)("1");
        maxFeePerGas = block.baseFeePerGas * 2n + maxPriorityFeePerGas;
    }
    const unit = getUnit(units);
    const formatted = {
        gasPrice: gasPrice ? (0, $6u2UO.formatUnits)(gasPrice, unit) : null,
        maxFeePerGas: maxFeePerGas ? (0, $6u2UO.formatUnits)(maxFeePerGas, unit) : null,
        maxPriorityFeePerGas: maxPriorityFeePerGas ? (0, $6u2UO.formatUnits)(maxPriorityFeePerGas, unit) : null
    };
    return {
        lastBaseFeePerGas: lastBaseFeePerGas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        formatted: formatted
    };
}
// src/actions/transactions/fetchTransaction.ts
async function fetchTransaction({ chainId, hash }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    return publicClient.getTransaction({
        hash: hash
    });
}
async function prepareSendTransaction({ accessList, account, chainId, data, gas: gas_, gasPrice, maxFeePerGas, maxPriorityFeePerGas, nonce, to: to_, value, walletClient: walletClient_ }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const walletClient = walletClient_ ?? await getWalletClient({
        chainId: chainId
    });
    if (!walletClient) throw new (0, $5gTQZ.ConnectorNotFoundError)();
    if (chainId) assertActiveChain({
        chainId: chainId
    });
    const to = (to_ && !(0, $fDHPo.isAddress)(to_) ? await fetchEnsAddress({
        name: to_
    }) : to_) || void 0;
    if (to && !(0, $fDHPo.isAddress)(to)) throw new Error("Invalid address");
    const gas = typeof gas_ === "undefined" ? await publicClient.estimateGas({
        accessList: accessList,
        account: walletClient.account,
        data: data,
        gas: gas_ ?? void 0,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        nonce: nonce,
        to: to,
        value: value
    }) : gas_ || void 0;
    return {
        accessList: accessList,
        account: account,
        data: data,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        mode: "prepared",
        nonce: nonce,
        to: to,
        value: value,
        ...chainId ? {
            chainId: chainId
        } : {}
    };
}
// src/actions/transactions/sendTransaction.ts
async function sendTransaction({ accessList, account, chainId, data, gas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, mode, nonce, to, value }) {
    const walletClient = await getWalletClient({
        chainId: chainId
    });
    if (!walletClient) throw new (0, $5gTQZ.ConnectorNotFoundError)();
    if (chainId) assertActiveChain({
        chainId: chainId
    });
    let args;
    if (mode === "prepared") args = {
        account: account,
        accessList: accessList,
        chain: null,
        data: data,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        nonce: nonce,
        to: to,
        value: value
    };
    else args = await prepareSendTransaction({
        accessList: accessList,
        account: account,
        chainId: chainId,
        data: data,
        gas: gas || null,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        nonce: nonce,
        to: to,
        value: value
    });
    const hash = await walletClient.sendTransaction({
        ...args,
        chain: chainId ? {
            id: chainId
        } : null
    });
    return {
        hash: hash
    };
}
async function waitForTransaction({ chainId, confirmations = 1, hash, onReplaced, timeout = 0 }) {
    const publicClient = getPublicClient({
        chainId: chainId
    });
    const receipt = await publicClient.waitForTransactionReceipt({
        hash: hash,
        confirmations: confirmations,
        onReplaced: onReplaced,
        timeout: timeout
    });
    if (receipt.status === "reverted") {
        const txn = await publicClient.getTransaction({
            hash: receipt.transactionHash
        });
        const code = await publicClient.call({
            ...txn,
            gasPrice: txn.type !== "eip1559" ? txn.gasPrice : void 0,
            maxFeePerGas: txn.type === "eip1559" ? txn.maxFeePerGas : void 0,
            maxPriorityFeePerGas: txn.type === "eip1559" ? txn.maxPriorityFeePerGas : void 0
        });
        const reason = (0, $hiAQY.hexToString)(`0x${code.substring(138)}`);
        throw new Error(reason);
    }
    return receipt;
}
function watchPendingTransactions(args, callback) {
    let unwatch;
    const createListener = (publicClient)=>{
        if (unwatch) unwatch();
        unwatch = publicClient.watchPendingTransactions({
            onTransactions: callback,
            poll: true
        });
    };
    const publicClient_ = getWebSocketPublicClient({
        chainId: args.chainId
    }) ?? getPublicClient({
        chainId: args.chainId
    });
    createListener(publicClient_);
    const config2 = getConfig();
    const unsubscribe = config2.subscribe(({ publicClient, webSocketPublicClient })=>({
            publicClient: publicClient,
            webSocketPublicClient: webSocketPublicClient
        }), async ({ publicClient, webSocketPublicClient })=>{
        const publicClient_2 = webSocketPublicClient ?? publicClient;
        if (!args.chainId && publicClient_2) createListener(publicClient_2);
    }, {
        equalityFn: (0, $gxDlk.shallow)
    });
    return ()=>{
        unsubscribe();
        unwatch?.();
    };
}
// src/utils/assertActiveChain.ts
function assertActiveChain({ chainId }) {
    const { chain: activeChain, chains } = getNetwork();
    const activeChainId = activeChain?.id;
    if (activeChainId && chainId !== activeChainId) throw new ChainMismatchError({
        activeChain: chains.find((x)=>x.id === activeChainId)?.name ?? `Chain ${activeChainId}`,
        targetChain: chains.find((x)=>x.id === chainId)?.name ?? `Chain ${chainId}`
    });
}

});
parcelRegister("cDSuN", function(module, exports) {

$parcel$export(module.exports, "InjectedConnector", function () { return $93436643f7594228$export$2180bbd5f43a00b6; });

var $5gTQZ = parcelRequire("5gTQZ");

var $b9CuF = parcelRequire("b9CuF");

var $2QdCh = parcelRequire("2QdCh");

var $lRux7 = parcelRequire("lRux7");
var $ng60n = parcelRequire("ng60n");
var $1r7Xu = parcelRequire("1r7Xu");
var $9Kb19 = parcelRequire("9Kb19");
var $e2aBg = parcelRequire("e2aBg");
// src/utils/getInjectedName.ts
function $93436643f7594228$var$getInjectedName(ethereum) {
    if (!ethereum) return "Injected";
    const getName = (provider)=>{
        if (provider.isApexWallet) return "Apex Wallet";
        if (provider.isAvalanche) return "Core Wallet";
        if (provider.isBackpack) return "Backpack";
        if (provider.isBifrost) return "Bifrost Wallet";
        if (provider.isBitKeep) return "BitKeep";
        if (provider.isBitski) return "Bitski";
        if (provider.isBlockWallet) return "BlockWallet";
        if (provider.isBraveWallet) return "Brave Wallet";
        if (provider.isCoin98) return "Coin98 Wallet";
        if (provider.isCoinbaseWallet) return "Coinbase Wallet";
        if (provider.isDawn) return "Dawn Wallet";
        if (provider.isDefiant) return "Defiant";
        if (provider.isDesig) return "Desig Wallet";
        if (provider.isEnkrypt) return "Enkrypt";
        if (provider.isExodus) return "Exodus";
        if (provider.isFordefi) return "Fordefi";
        if (provider.isFrame) return "Frame";
        if (provider.isFrontier) return "Frontier Wallet";
        if (provider.isGamestop) return "GameStop Wallet";
        if (provider.isHaqqWallet) return "HAQQ Wallet";
        if (provider.isHyperPay) return "HyperPay Wallet";
        if (provider.isImToken) return "ImToken";
        if (provider.isHaloWallet) return "Halo Wallet";
        if (provider.isKuCoinWallet) return "KuCoin Wallet";
        if (provider.isMathWallet) return "MathWallet";
        if (provider.isNovaWallet) return "Nova Wallet";
        if (provider.isOkxWallet || provider.isOKExWallet) return "OKX Wallet";
        if (provider.isOktoWallet) return "Okto Wallet";
        if (provider.isOneInchIOSWallet || provider.isOneInchAndroidWallet) return "1inch Wallet";
        if (provider.isOneKey) return "OneKey Wallet";
        if (provider.isOpera) return "Opera";
        if (provider.isPhantom) return "Phantom";
        if (provider.isPortal) return "Ripio Portal";
        if (provider.isRabby) return "Rabby Wallet";
        if (provider.isRainbow) return "Rainbow";
        if (provider.isSafePal) return "SafePal Wallet";
        if (provider.isStatus) return "Status";
        if (provider.isSubWallet) return "SubWallet";
        if (provider.isTalisman) return "Talisman";
        if (provider.isTally) return "Taho";
        if (provider.isTokenPocket) return "TokenPocket";
        if (provider.isTokenary) return "Tokenary";
        if (provider.isTrust || provider.isTrustWallet) return "Trust Wallet";
        if (provider.isTTWallet) return "TTWallet";
        if (provider.isXDEFI) return "XDEFI Wallet";
        if (provider.isZeal) return "Zeal";
        if (provider.isZerion) return "Zerion";
        if (provider.isMetaMask) return "MetaMask";
    };
    if (ethereum.providers?.length) {
        const nameSet = /* @__PURE__ */ new Set();
        let unknownCount = 1;
        for (const provider of ethereum.providers){
            let name = getName(provider);
            if (!name) {
                name = `Unknown Wallet #${unknownCount}`;
                unknownCount += 1;
            }
            nameSet.add(name);
        }
        const names = [
            ...nameSet
        ];
        if (names.length) return names;
        return names[0] ?? "Injected";
    }
    return getName(ethereum) ?? "Injected";
}
// src/injected.ts
var $93436643f7594228$var$_provider;
var $93436643f7594228$export$2180bbd5f43a00b6 = class extends (0, $2QdCh.Connector) {
    constructor({ chains: chains, options: options_ } = {}){
        const options = {
            shimDisconnect: true,
            getProvider () {
                if (typeof window === "undefined") return;
                const ethereum = window.ethereum;
                if (ethereum?.providers && ethereum.providers.length > 0) return ethereum.providers[0];
                return ethereum;
            },
            ...options_
        };
        super({
            chains: chains,
            options: options
        });
        this.id = "injected";
        (0, $2QdCh.__privateAdd)(this, $93436643f7594228$var$_provider, void 0);
        this.shimDisconnectKey = `${this.id}.shimDisconnect`;
        this.onAccountsChanged = (accounts)=>{
            if (accounts.length === 0) this.emit("disconnect");
            else this.emit("change", {
                account: (0, $1r7Xu.getAddress)(accounts[0])
            });
        };
        this.onChainChanged = (chainId)=>{
            const id = (0, $b9CuF.normalizeChainId)(chainId);
            const unsupported = this.isChainUnsupported(id);
            this.emit("change", {
                chain: {
                    id: id,
                    unsupported: unsupported
                }
            });
        };
        this.onDisconnect = async (error)=>{
            if (error.code === 1013) {
                const provider = await this.getProvider();
                if (provider) {
                    const isAuthorized = await this.getAccount();
                    if (isAuthorized) return;
                }
            }
            this.emit("disconnect");
            if (this.options.shimDisconnect) this.storage?.removeItem(this.shimDisconnectKey);
        };
        const provider = options.getProvider();
        if (typeof options.name === "string") this.name = options.name;
        else if (provider) {
            const detectedName = $93436643f7594228$var$getInjectedName(provider);
            if (options.name) this.name = options.name(detectedName);
            else if (typeof detectedName === "string") this.name = detectedName;
            else this.name = detectedName[0];
        } else this.name = "Injected";
        this.ready = !!provider;
    }
    async connect({ chainId: chainId } = {}) {
        try {
            const provider = await this.getProvider();
            if (!provider) throw new (0, $5gTQZ.ConnectorNotFoundError)();
            if (provider.on) {
                provider.on("accountsChanged", this.onAccountsChanged);
                provider.on("chainChanged", this.onChainChanged);
                provider.on("disconnect", this.onDisconnect);
            }
            this.emit("message", {
                type: "connecting"
            });
            const accounts = await provider.request({
                method: "eth_requestAccounts"
            });
            const account = (0, $1r7Xu.getAddress)(accounts[0]);
            let id = await this.getChainId();
            let unsupported = this.isChainUnsupported(id);
            if (chainId && id !== chainId) {
                const chain = await this.switchChain(chainId);
                id = chain.id;
                unsupported = this.isChainUnsupported(id);
            }
            if (this.options.shimDisconnect) this.storage?.setItem(this.shimDisconnectKey, true);
            return {
                account: account,
                chain: {
                    id: id,
                    unsupported: unsupported
                }
            };
        } catch (error) {
            if (this.isUserRejectedRequestError(error)) throw new (0, $e2aBg.UserRejectedRequestError)(error);
            if (error.code === -32002) throw new (0, $e2aBg.ResourceUnavailableRpcError)(error);
            throw error;
        }
    }
    async disconnect() {
        const provider = await this.getProvider();
        if (!provider?.removeListener) return;
        provider.removeListener("accountsChanged", this.onAccountsChanged);
        provider.removeListener("chainChanged", this.onChainChanged);
        provider.removeListener("disconnect", this.onDisconnect);
        if (this.options.shimDisconnect) this.storage?.removeItem(this.shimDisconnectKey);
    }
    async getAccount() {
        const provider = await this.getProvider();
        if (!provider) throw new (0, $5gTQZ.ConnectorNotFoundError)();
        const accounts = await provider.request({
            method: "eth_accounts"
        });
        return (0, $1r7Xu.getAddress)(accounts[0]);
    }
    async getChainId() {
        const provider = await this.getProvider();
        if (!provider) throw new (0, $5gTQZ.ConnectorNotFoundError)();
        return provider.request({
            method: "eth_chainId"
        }).then((0, $b9CuF.normalizeChainId));
    }
    async getProvider() {
        const provider = this.options.getProvider();
        if (provider) (0, $2QdCh.__privateSet)(this, $93436643f7594228$var$_provider, provider);
        return (0, $2QdCh.__privateGet)(this, $93436643f7594228$var$_provider);
    }
    async getWalletClient({ chainId: chainId } = {}) {
        const [provider, account] = await Promise.all([
            this.getProvider(),
            this.getAccount()
        ]);
        const chain = this.chains.find((x)=>x.id === chainId);
        if (!provider) throw new Error("provider is required.");
        return (0, $lRux7.createWalletClient)({
            account: account,
            chain: chain,
            transport: (0, $ng60n.custom)(provider)
        });
    }
    async isAuthorized() {
        try {
            if (this.options.shimDisconnect && !this.storage?.getItem(this.shimDisconnectKey)) return false;
            const provider = await this.getProvider();
            if (!provider) throw new (0, $5gTQZ.ConnectorNotFoundError)();
            const account = await this.getAccount();
            return !!account;
        } catch  {
            return false;
        }
    }
    async switchChain(chainId) {
        const provider = await this.getProvider();
        if (!provider) throw new (0, $5gTQZ.ConnectorNotFoundError)();
        const id = (0, $9Kb19.numberToHex)(chainId);
        try {
            await Promise.all([
                provider.request({
                    method: "wallet_switchEthereumChain",
                    params: [
                        {
                            chainId: id
                        }
                    ]
                }),
                new Promise((res)=>this.on("change", ({ chain: chain })=>{
                        if (chain?.id === chainId) res();
                    }))
            ]);
            return this.chains.find((x)=>x.id === chainId) ?? {
                id: chainId,
                name: `Chain ${id}`,
                network: `${id}`,
                nativeCurrency: {
                    name: "Ether",
                    decimals: 18,
                    symbol: "ETH"
                },
                rpcUrls: {
                    default: {
                        http: [
                            ""
                        ]
                    },
                    public: {
                        http: [
                            ""
                        ]
                    }
                }
            };
        } catch (error) {
            const chain = this.chains.find((x)=>x.id === chainId);
            if (!chain) throw new (0, $5gTQZ.ChainNotConfiguredForConnectorError)({
                chainId: chainId,
                connectorId: this.id
            });
            if (error.code === 4902 || error?.data?.originalError?.code === 4902) try {
                await provider.request({
                    method: "wallet_addEthereumChain",
                    params: [
                        {
                            chainId: id,
                            chainName: chain.name,
                            nativeCurrency: chain.nativeCurrency,
                            rpcUrls: [
                                chain.rpcUrls.public?.http[0] ?? ""
                            ],
                            blockExplorerUrls: this.getBlockExplorerUrls(chain)
                        }
                    ]
                });
                const currentChainId = await this.getChainId();
                if (currentChainId !== chainId) throw new (0, $e2aBg.UserRejectedRequestError)(new Error("User rejected switch after adding network."));
                return chain;
            } catch (error2) {
                throw new (0, $e2aBg.UserRejectedRequestError)(error2);
            }
            if (this.isUserRejectedRequestError(error)) throw new (0, $e2aBg.UserRejectedRequestError)(error);
            throw new (0, $e2aBg.SwitchChainError)(error);
        }
    }
    async watchAsset({ address: address, decimals: decimals = 18, image: image, symbol: symbol }) {
        const provider = await this.getProvider();
        if (!provider) throw new (0, $5gTQZ.ConnectorNotFoundError)();
        return provider.request({
            method: "wallet_watchAsset",
            params: {
                type: "ERC20",
                options: {
                    address: address,
                    decimals: decimals,
                    image: image,
                    symbol: symbol
                }
            }
        });
    }
    isUserRejectedRequestError(error) {
        return error.code === 4001;
    }
};
$93436643f7594228$var$_provider = new WeakMap();

});
parcelRegister("5gTQZ", function(module, exports) {

$parcel$export(module.exports, "ChainNotConfiguredForConnectorError", function () { return $3d69c5c380805304$export$9e27fc4704f8e4c3; });
$parcel$export(module.exports, "ConnectorNotFoundError", function () { return $3d69c5c380805304$export$9f8a797207d6544e; });
// src/errors.ts
var $3d69c5c380805304$export$9e27fc4704f8e4c3 = class extends Error {
    constructor({ chainId: chainId, connectorId: connectorId }){
        super(`Chain "${chainId}" not configured for connector "${connectorId}".`);
        this.name = "ChainNotConfiguredForConnectorError";
    }
};
var $3d69c5c380805304$export$9f8a797207d6544e = class extends Error {
    constructor(){
        super(...arguments);
        this.name = "ConnectorNotFoundError";
        this.message = "Connector not found";
    }
};

});

parcelRegister("b9CuF", function(module, exports) {

$parcel$export(module.exports, "normalizeChainId", function () { return $81ee6501edc47184$export$723927690c88894d; });
// src/utils/normalizeChainId.ts
function $81ee6501edc47184$export$723927690c88894d(chainId) {
    if (typeof chainId === "string") return Number.parseInt(chainId, chainId.trim().substring(0, 2) === "0x" ? 16 : 10);
    if (typeof chainId === "bigint") return Number(chainId);
    return chainId;
}

});

parcelRegister("2QdCh", function(module, exports) {

$parcel$export(module.exports, "__privateGet", function () { return $211b0009fac9895f$export$18a094aefa070634; });
$parcel$export(module.exports, "__privateAdd", function () { return $211b0009fac9895f$export$addf369becd23283; });
$parcel$export(module.exports, "__privateSet", function () { return $211b0009fac9895f$export$42432efe6614d3b4; });
$parcel$export(module.exports, "__privateMethod", function () { return $211b0009fac9895f$export$fa92d15b718fce20; });
$parcel$export(module.exports, "Connector", function () { return $211b0009fac9895f$export$b2278035370d6017; });

var $9caoK = parcelRequire("9caoK");

var $j7a6W = parcelRequire("j7a6W");
var $a9nmx = parcelRequire("a9nmx");
var $211b0009fac9895f$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $211b0009fac9895f$export$18a094aefa070634 = (obj, member, getter)=>{
    $211b0009fac9895f$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $211b0009fac9895f$export$addf369becd23283 = (obj, member, value)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var $211b0009fac9895f$export$42432efe6614d3b4 = (obj, member, value, setter)=>{
    $211b0009fac9895f$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value) : member.set(obj, value);
    return value;
};
var $211b0009fac9895f$export$fa92d15b718fce20 = (obj, member, method)=>{
    $211b0009fac9895f$var$__accessCheck(obj, member, "access private method");
    return method;
};
var $211b0009fac9895f$export$b2278035370d6017 = class extends (0, (/*@__PURE__*/$parcel$interopDefault($9caoK))) {
    constructor({ chains: chains = [
        (0, $a9nmx.mainnet),
        (0, $j7a6W.goerli)
    ], options: options }){
        super();
        this.chains = chains;
        this.options = options;
    }
    getBlockExplorerUrls(chain) {
        const { default: blockExplorer, ...blockExplorers } = chain.blockExplorers ?? {};
        if (blockExplorer) return [
            blockExplorer.url,
            ...Object.values(blockExplorers).map((x)=>x.url)
        ];
    }
    isChainUnsupported(chainId) {
        return !this.chains.some((x)=>x.id === chainId);
    }
    setStorage(storage) {
        this.storage = storage;
    }
};

});
parcelRegister("9caoK", function(module, exports) {
"use strict";
var $6b1d4ceb6a218f97$var$has = Object.prototype.hasOwnProperty, $6b1d4ceb6a218f97$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $6b1d4ceb6a218f97$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $6b1d4ceb6a218f97$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $6b1d4ceb6a218f97$var$Events().__proto__) $6b1d4ceb6a218f97$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $6b1d4ceb6a218f97$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $6b1d4ceb6a218f97$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $6b1d4ceb6a218f97$var$EE(fn, context || emitter, once), evt = $6b1d4ceb6a218f97$var$prefix ? $6b1d4ceb6a218f97$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $6b1d4ceb6a218f97$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $6b1d4ceb6a218f97$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $6b1d4ceb6a218f97$var$EventEmitter() {
    this._events = new $6b1d4ceb6a218f97$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $6b1d4ceb6a218f97$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($6b1d4ceb6a218f97$var$has.call(events, name)) names.push($6b1d4ceb6a218f97$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $6b1d4ceb6a218f97$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $6b1d4ceb6a218f97$var$prefix ? $6b1d4ceb6a218f97$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $6b1d4ceb6a218f97$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $6b1d4ceb6a218f97$var$prefix ? $6b1d4ceb6a218f97$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $6b1d4ceb6a218f97$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $6b1d4ceb6a218f97$var$prefix ? $6b1d4ceb6a218f97$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $6b1d4ceb6a218f97$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $6b1d4ceb6a218f97$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $6b1d4ceb6a218f97$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $6b1d4ceb6a218f97$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $6b1d4ceb6a218f97$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $6b1d4ceb6a218f97$var$prefix ? $6b1d4ceb6a218f97$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $6b1d4ceb6a218f97$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $6b1d4ceb6a218f97$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $6b1d4ceb6a218f97$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $6b1d4ceb6a218f97$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $6b1d4ceb6a218f97$var$prefix ? $6b1d4ceb6a218f97$var$prefix + event : event;
        if (this._events[evt]) $6b1d4ceb6a218f97$var$clearEvent(this, evt);
    } else {
        this._events = new $6b1d4ceb6a218f97$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$6b1d4ceb6a218f97$var$EventEmitter.prototype.off = $6b1d4ceb6a218f97$var$EventEmitter.prototype.removeListener;
$6b1d4ceb6a218f97$var$EventEmitter.prototype.addListener = $6b1d4ceb6a218f97$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$6b1d4ceb6a218f97$var$EventEmitter.prefixed = $6b1d4ceb6a218f97$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$6b1d4ceb6a218f97$var$EventEmitter.EventEmitter = $6b1d4ceb6a218f97$var$EventEmitter;
module.exports = $6b1d4ceb6a218f97$var$EventEmitter;

});

parcelRegister("j7a6W", function(module, exports) {

$parcel$export(module.exports, "goerli", function () { return $dea6839752610126$export$50b37201a1017e1e; });

var $bMiPj = parcelRequire("bMiPj");
const $dea6839752610126$export$50b37201a1017e1e = /*#__PURE__*/ (0, $bMiPj.defineChain)({
    id: 5,
    network: "goerli",
    name: "Goerli",
    nativeCurrency: {
        name: "Goerli Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        alchemy: {
            http: [
                "https://eth-goerli.g.alchemy.com/v2"
            ],
            webSocket: [
                "wss://eth-goerli.g.alchemy.com/v2"
            ]
        },
        infura: {
            http: [
                "https://goerli.infura.io/v3"
            ],
            webSocket: [
                "wss://goerli.infura.io/ws/v3"
            ]
        },
        default: {
            http: [
                "https://rpc.ankr.com/eth_goerli"
            ]
        },
        public: {
            http: [
                "https://rpc.ankr.com/eth_goerli"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Etherscan",
            url: "https://goerli.etherscan.io"
        },
        default: {
            name: "Etherscan",
            url: "https://goerli.etherscan.io"
        }
    },
    contracts: {
        ensRegistry: {
            address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
        },
        ensUniversalResolver: {
            address: "0x56522D00C410a43BFfDF00a9A569489297385790",
            blockCreated: 8765204
        },
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 6507670
        }
    },
    testnet: true
});

});
parcelRegister("bMiPj", function(module, exports) {

$parcel$export(module.exports, "defineChain", function () { return $8932c7f61f098658$export$b6380ff64616a4fb; });
function $8932c7f61f098658$export$b6380ff64616a4fb(chain, config = {}) {
    const { fees: fees = chain.fees, formatters: formatters = chain.formatters, serializers: serializers = chain.serializers } = config;
    return {
        ...chain,
        fees: fees,
        formatters: formatters,
        serializers: serializers
    };
}

});


parcelRegister("a9nmx", function(module, exports) {

$parcel$export(module.exports, "mainnet", function () { return $763cddf29a989a65$export$536d3e0d2c7baf54; });

var $bMiPj = parcelRequire("bMiPj");
const $763cddf29a989a65$export$536d3e0d2c7baf54 = /*#__PURE__*/ (0, $bMiPj.defineChain)({
    id: 1,
    network: "homestead",
    name: "Ethereum",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        alchemy: {
            http: [
                "https://eth-mainnet.g.alchemy.com/v2"
            ],
            webSocket: [
                "wss://eth-mainnet.g.alchemy.com/v2"
            ]
        },
        infura: {
            http: [
                "https://mainnet.infura.io/v3"
            ],
            webSocket: [
                "wss://mainnet.infura.io/ws/v3"
            ]
        },
        default: {
            http: [
                "https://cloudflare-eth.com"
            ]
        },
        public: {
            http: [
                "https://cloudflare-eth.com"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Etherscan",
            url: "https://etherscan.io"
        },
        default: {
            name: "Etherscan",
            url: "https://etherscan.io"
        }
    },
    contracts: {
        ensRegistry: {
            address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
        },
        ensUniversalResolver: {
            address: "0xc0497E381f536Be9ce14B0dD3817cBcAe57d2F62",
            blockCreated: 16966585
        },
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 14353601
        }
    }
});

});


parcelRegister("lRux7", function(module, exports) {

$parcel$export(module.exports, "createWalletClient", function () { return $fea63b7411b738a2$export$362b8ea2edbd9090; });

var $1HOlU = parcelRequire("1HOlU");

var $ibqR2 = parcelRequire("ibqR2");
function $fea63b7411b738a2$export$362b8ea2edbd9090(parameters) {
    const { key: key = "wallet", name: name = "Wallet Client", transport: transport } = parameters;
    const client = (0, $1HOlU.createClient)({
        ...parameters,
        key: key,
        name: name,
        transport: (opts)=>transport({
                ...opts,
                retryCount: 0
            }),
        type: "walletClient"
    });
    return client.extend((0, $ibqR2.walletActions));
}

});
parcelRegister("1HOlU", function(module, exports) {

$parcel$export(module.exports, "createClient", function () { return $13e0dd87ce3a8a42$export$5d730b7aed1a3eb0; });

var $gbMK7 = parcelRequire("gbMK7");

var $i2CVT = parcelRequire("i2CVT");
function $13e0dd87ce3a8a42$export$5d730b7aed1a3eb0(parameters) {
    const { batch: batch, cacheTime: cacheTime = parameters.pollingInterval ?? 4000, key: key = "base", name: name = "Base Client", pollingInterval: pollingInterval = 4000, type: type = "base" } = parameters;
    const chain = parameters.chain;
    const account = parameters.account ? (0, $gbMK7.parseAccount)(parameters.account) : undefined;
    const { config: config, request: request, value: value } = parameters.transport({
        chain: chain,
        pollingInterval: pollingInterval
    });
    const transport = {
        ...config,
        ...value
    };
    const client = {
        account: account,
        batch: batch,
        cacheTime: cacheTime,
        chain: chain,
        key: key,
        name: name,
        pollingInterval: pollingInterval,
        request: request,
        transport: transport,
        type: type,
        uid: (0, $i2CVT.uid)()
    };
    function extend(base) {
        return (extendFn)=>{
            const extended = extendFn(base);
            for(const key in client)delete extended[key];
            const combined = {
                ...base,
                ...extended
            };
            return Object.assign(combined, {
                extend: extend(combined)
            });
        };
    }
    return Object.assign(client, {
        extend: extend(client)
    });
}

});
parcelRegister("gbMK7", function(module, exports) {

$parcel$export(module.exports, "parseAccount", function () { return $bc937bbb9a9e10c8$export$11027cbf6cf15da2; });
function $bc937bbb9a9e10c8$export$11027cbf6cf15da2(account) {
    if (typeof account === "string") return {
        address: account,
        type: "json-rpc"
    };
    return account;
}

});

parcelRegister("i2CVT", function(module, exports) {

$parcel$export(module.exports, "uid", function () { return $d2269d1d8231499b$export$e2a22331486dcca0; });
const $d2269d1d8231499b$var$size = 256;
let $d2269d1d8231499b$var$index = $d2269d1d8231499b$var$size;
let $d2269d1d8231499b$var$buffer;
function $d2269d1d8231499b$export$e2a22331486dcca0(length = 11) {
    if (!$d2269d1d8231499b$var$buffer || $d2269d1d8231499b$var$index + length > $d2269d1d8231499b$var$size * 2) {
        $d2269d1d8231499b$var$buffer = "";
        $d2269d1d8231499b$var$index = 0;
        for(let i = 0; i < $d2269d1d8231499b$var$size; i++)$d2269d1d8231499b$var$buffer += (256 + Math.random() * 256 | 0).toString(16).substring(1);
    }
    return $d2269d1d8231499b$var$buffer.substring($d2269d1d8231499b$var$index, $d2269d1d8231499b$var$index++ + length);
}

});


parcelRegister("ibqR2", function(module, exports) {

$parcel$export(module.exports, "walletActions", function () { return $d3ce15d369ff8097$export$d07041b4ed194fbc; });

var $lNfs4 = parcelRequire("lNfs4");

var $edwZV = parcelRequire("edwZV");

var $jXIGs = parcelRequire("jXIGs");

var $kzap2 = parcelRequire("kzap2");

var $l7Rdf = parcelRequire("l7Rdf");

var $8HlMY = parcelRequire("8HlMY");

var $hSmZG = parcelRequire("hSmZG");

var $gY53h = parcelRequire("gY53h");

var $9QGmb = parcelRequire("9QGmb");

var $g5KgQ = parcelRequire("g5KgQ");

var $2ngaX = parcelRequire("2ngaX");

var $fPlcM = parcelRequire("fPlcM");

var $7Rkth = parcelRequire("7Rkth");

var $joybz = parcelRequire("joybz");

var $zTKTN = parcelRequire("zTKTN");

var $3Bki4 = parcelRequire("3Bki4");
function $d3ce15d369ff8097$export$d07041b4ed194fbc(client) {
    return {
        addChain: (args)=>(0, $edwZV.addChain)(client, args),
        deployContract: (args)=>(0, $jXIGs.deployContract)(client, args),
        getAddresses: ()=>(0, $kzap2.getAddresses)(client),
        getChainId: ()=>(0, $lNfs4.getChainId)(client),
        getPermissions: ()=>(0, $l7Rdf.getPermissions)(client),
        prepareTransactionRequest: (args)=>(0, $8HlMY.prepareTransactionRequest)(client, args),
        requestAddresses: ()=>(0, $hSmZG.requestAddresses)(client),
        requestPermissions: (args)=>(0, $gY53h.requestPermissions)(client, args),
        sendRawTransaction: (args)=>(0, $9QGmb.sendRawTransaction)(client, args),
        sendTransaction: (args)=>(0, $g5KgQ.sendTransaction)(client, args),
        signMessage: (args)=>(0, $2ngaX.signMessage)(client, args),
        signTransaction: (args)=>(0, $fPlcM.signTransaction)(client, args),
        signTypedData: (args)=>(0, $7Rkth.signTypedData)(client, args),
        switchChain: (args)=>(0, $joybz.switchChain)(client, args),
        watchAsset: (args)=>(0, $zTKTN.watchAsset)(client, args),
        writeContract: (args)=>(0, $3Bki4.writeContract)(client, args)
    };
}

});
parcelRegister("lNfs4", function(module, exports) {

$parcel$export(module.exports, "getChainId", function () { return $fdda28f8512cc43e$export$850fa7b3891187c; });

var $hiAQY = parcelRequire("hiAQY");
async function $fdda28f8512cc43e$export$850fa7b3891187c(client) {
    const chainIdHex = await client.request({
        method: "eth_chainId"
    });
    return (0, $hiAQY.hexToNumber)(chainIdHex);
}

});
parcelRegister("hiAQY", function(module, exports) {

$parcel$export(module.exports, "assertSize", function () { return $c980b46d169ee342$export$2af489edb7fa35fe; });
$parcel$export(module.exports, "hexToNumber", function () { return $c980b46d169ee342$export$d57f2bacc26b4249; });
$parcel$export(module.exports, "hexToBigInt", function () { return $c980b46d169ee342$export$92a44656ec81b584; });
$parcel$export(module.exports, "hexToString", function () { return $c980b46d169ee342$export$f4bc7e46f3eb3ac3; });
$parcel$export(module.exports, "hexToBool", function () { return $c980b46d169ee342$export$bde1d77e6fe6c41e; });

var $bL2QE = parcelRequire("bL2QE");

var $5pLNq = parcelRequire("5pLNq");

var $ea0vD = parcelRequire("ea0vD");

var $dlz3r = parcelRequire("dlz3r");
function $c980b46d169ee342$export$2af489edb7fa35fe(hexOrBytes, { size: size }) {
    if ((0, $5pLNq.size)(hexOrBytes) > size) throw new (0, $bL2QE.SizeOverflowError)({
        givenSize: (0, $5pLNq.size)(hexOrBytes),
        maxSize: size
    });
}
function $c980b46d169ee342$export$1a8ceedbd5845648(hex, toOrOpts) {
    const opts = typeof toOrOpts === "string" ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === "number") return $c980b46d169ee342$export$d57f2bacc26b4249(hex, opts);
    if (to === "bigint") return $c980b46d169ee342$export$92a44656ec81b584(hex, opts);
    if (to === "string") return $c980b46d169ee342$export$f4bc7e46f3eb3ac3(hex, opts);
    if (to === "boolean") return $c980b46d169ee342$export$bde1d77e6fe6c41e(hex, opts);
    return (0, $dlz3r.hexToBytes)(hex, opts);
}
function $c980b46d169ee342$export$92a44656ec81b584(hex, opts = {}) {
    const { signed: signed } = opts;
    if (opts.size) $c980b46d169ee342$export$2af489edb7fa35fe(hex, {
        size: opts.size
    });
    const value = BigInt(hex);
    if (!signed) return value;
    const size = (hex.length - 2) / 2;
    const max = (1n << BigInt(size) * 8n - 1n) - 1n;
    if (value <= max) return value;
    return value - BigInt(`0x${"f".padStart(size * 2, "f")}`) - 1n;
}
function $c980b46d169ee342$export$bde1d77e6fe6c41e(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        $c980b46d169ee342$export$2af489edb7fa35fe(hex, {
            size: opts.size
        });
        hex = (0, $ea0vD.trim)(hex);
    }
    if ((0, $ea0vD.trim)(hex) === "0x00") return false;
    if ((0, $ea0vD.trim)(hex) === "0x01") return true;
    throw new (0, $bL2QE.InvalidHexBooleanError)(hex);
}
function $c980b46d169ee342$export$d57f2bacc26b4249(hex, opts = {}) {
    return Number($c980b46d169ee342$export$92a44656ec81b584(hex, opts));
}
function $c980b46d169ee342$export$f4bc7e46f3eb3ac3(hex, opts = {}) {
    let bytes = (0, $dlz3r.hexToBytes)(hex);
    if (opts.size) {
        $c980b46d169ee342$export$2af489edb7fa35fe(bytes, {
            size: opts.size
        });
        bytes = (0, $ea0vD.trim)(bytes, {
            dir: "right"
        });
    }
    return new TextDecoder().decode(bytes);
}

});
parcelRegister("bL2QE", function(module, exports) {

$parcel$export(module.exports, "IntegerOutOfRangeError", function () { return $88f64b183ddd105e$export$47d164a8071229a9; });
$parcel$export(module.exports, "InvalidHexBooleanError", function () { return $88f64b183ddd105e$export$f574ac54e35514c; });
$parcel$export(module.exports, "SizeOverflowError", function () { return $88f64b183ddd105e$export$beb44ed4f8747d0e; });

var $hwGC1 = parcelRequire("hwGC1");
class $88f64b183ddd105e$export$8615cc40e20f1eb extends (0, $hwGC1.BaseError) {
    constructor({ consumed: consumed, length: length }){
        super(`Consumed bytes (${consumed}) is shorter than data length (${length - 1}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "DataLengthTooLongError"
        });
    }
}
class $88f64b183ddd105e$export$9579bcdb57e90be3 extends (0, $hwGC1.BaseError) {
    constructor({ length: length, dataLength: dataLength }){
        super(`Data length (${dataLength - 1}) is shorter than consumed bytes length (${length - 1}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "DataLengthTooShortError"
        });
    }
}
class $88f64b183ddd105e$export$47d164a8071229a9 extends (0, $hwGC1.BaseError) {
    constructor({ max: max, min: min, signed: signed, size: size, value: value }){
        super(`Number "${value}" is not in safe ${size ? `${size * 8}-bit ${signed ? "signed" : "unsigned"} ` : ""}integer range ${max ? `(${min} to ${max})` : `(above ${min})`}`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "IntegerOutOfRangeError"
        });
    }
}
class $88f64b183ddd105e$export$52fc62e5266c8838 extends (0, $hwGC1.BaseError) {
    constructor(bytes){
        super(`Bytes value "${bytes}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidBytesBooleanError"
        });
    }
}
class $88f64b183ddd105e$export$f574ac54e35514c extends (0, $hwGC1.BaseError) {
    constructor(hex){
        super(`Hex value "${hex}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidHexBooleanError"
        });
    }
}
class $88f64b183ddd105e$export$ef05eafd11dd4a83 extends (0, $hwGC1.BaseError) {
    constructor(value){
        super(`Hex value "${value}" is an odd length (${value.length}). It must be an even length.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidHexValueError"
        });
    }
}
class $88f64b183ddd105e$export$a63b8c38d2c828ee extends (0, $hwGC1.BaseError) {
    constructor({ nextOffset: nextOffset, offset: offset }){
        super(`Next offset (${nextOffset}) is greater than previous offset + consumed bytes (${offset})`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "OffsetOutOfBoundsError"
        });
    }
}
class $88f64b183ddd105e$export$beb44ed4f8747d0e extends (0, $hwGC1.BaseError) {
    constructor({ givenSize: givenSize, maxSize: maxSize }){
        super(`Size cannot exceed ${maxSize} bytes. Given size: ${givenSize} bytes.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SizeOverflowError"
        });
    }
}

});
parcelRegister("hwGC1", function(module, exports) {

$parcel$export(module.exports, "BaseError", function () { return $cc267ab8d2752302$export$a490eb03cb7a0a5e; });

var $d9Nve = parcelRequire("d9Nve");
class $cc267ab8d2752302$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        super();
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ViemError"
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $d9Nve.getVersion)()
        });
        const details = args.cause instanceof $cc267ab8d2752302$export$a490eb03cb7a0a5e ? args.cause.details : args.cause?.message ? args.cause.message : args.details;
        const docsPath = args.cause instanceof $cc267ab8d2752302$export$a490eb03cb7a0a5e ? args.cause.docsPath || args.docsPath : args.docsPath;
        this.message = [
            shortMessage || "An error occurred.",
            "",
            ...args.metaMessages ? [
                ...args.metaMessages,
                ""
            ] : [],
            ...docsPath ? [
                `Docs: https://viem.sh${docsPath}.html${args.docsSlug ? `#${args.docsSlug}` : ""}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            `Version: ${this.version}`
        ].join("\n");
        if (args.cause) this.cause = args.cause;
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.shortMessage = shortMessage;
    }
    walk(fn) {
        return $cc267ab8d2752302$var$walk(this, fn);
    }
}
function $cc267ab8d2752302$var$walk(err, fn) {
    if (fn?.(err)) return err;
    if (err && typeof err === "object" && "cause" in err) return $cc267ab8d2752302$var$walk(err.cause, fn);
    return fn ? null : err;
}

});
parcelRegister("d9Nve", function(module, exports) {

$parcel$export(module.exports, "getContractAddress", function () { return $994283d43258da6f$export$b7fbffef12272e40; });
$parcel$export(module.exports, "getUrl", function () { return $994283d43258da6f$export$94df0e59ebebf4a7; });
$parcel$export(module.exports, "getVersion", function () { return $994283d43258da6f$export$c506eb22e615ba4a; });

var $2hkFt = parcelRequire("2hkFt");
const $994283d43258da6f$export$b7fbffef12272e40 = (address)=>address;
const $994283d43258da6f$export$94df0e59ebebf4a7 = (url)=>url;
const $994283d43258da6f$export$c506eb22e615ba4a = ()=>`viem@${0, $2hkFt.version}`;

});
parcelRegister("2hkFt", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $1a8d338581d176eb$export$83d89fbfd8236492; });
const $1a8d338581d176eb$export$83d89fbfd8236492 = "1.21.3";

});




parcelRegister("5pLNq", function(module, exports) {

$parcel$export(module.exports, "size", function () { return $3f145cdfdc8d792b$export$346677f925de839c; });

var $6zhhe = parcelRequire("6zhhe");
function $3f145cdfdc8d792b$export$346677f925de839c(value) {
    if ((0, $6zhhe.isHex)(value, {
        strict: false
    })) return Math.ceil((value.length - 2) / 2);
    return value.length;
}

});
parcelRegister("6zhhe", function(module, exports) {

$parcel$export(module.exports, "isHex", function () { return $4c8369ce8214b452$export$8a9b6341a7c96bc; });
function $4c8369ce8214b452$export$8a9b6341a7c96bc(value, { strict: strict = true } = {}) {
    if (!value) return false;
    if (typeof value !== "string") return false;
    return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith("0x");
}

});


parcelRegister("ea0vD", function(module, exports) {

$parcel$export(module.exports, "trim", function () { return $a4f26502185fbc2b$export$87c2784dc9fc4ab; });
function $a4f26502185fbc2b$export$87c2784dc9fc4ab(hexOrBytes, { dir: dir = "left" } = {}) {
    let data = typeof hexOrBytes === "string" ? hexOrBytes.replace("0x", "") : hexOrBytes;
    let sliceLength = 0;
    for(let i = 0; i < data.length - 1; i++){
        if (data[dir === "left" ? i : data.length - i - 1].toString() === "0") sliceLength++;
        else break;
    }
    data = dir === "left" ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    if (typeof hexOrBytes === "string") {
        if (data.length === 1 && dir === "right") data = `${data}0`;
        return `0x${data.length % 2 === 1 ? `0${data}` : data}`;
    }
    return data;
}

});

parcelRegister("dlz3r", function(module, exports) {

$parcel$export(module.exports, "toBytes", function () { return $9b786d9defa5724c$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "hexToBytes", function () { return $9b786d9defa5724c$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "stringToBytes", function () { return $9b786d9defa5724c$export$c8dd6bc66a63753c; });

var $hwGC1 = parcelRequire("hwGC1");

var $6zhhe = parcelRequire("6zhhe");

var $hkqwL = parcelRequire("hkqwL");

var $hiAQY = parcelRequire("hiAQY");

var $9Kb19 = parcelRequire("9Kb19");
const $9b786d9defa5724c$var$encoder = /*#__PURE__*/ new TextEncoder();
function $9b786d9defa5724c$export$30a71edf0753ed6b(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $9b786d9defa5724c$export$49ad9be85c347998(value, opts);
    if (typeof value === "boolean") return $9b786d9defa5724c$export$771517697a68241(value, opts);
    if ((0, $6zhhe.isHex)(value)) return $9b786d9defa5724c$export$31c96b9df38bc8d4(value, opts);
    return $9b786d9defa5724c$export$c8dd6bc66a63753c(value, opts);
}
function $9b786d9defa5724c$export$771517697a68241(value, opts = {}) {
    const bytes = new Uint8Array(1);
    bytes[0] = Number(value);
    if (typeof opts.size === "number") {
        (0, $hiAQY.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $hkqwL.pad)(bytes, {
            size: opts.size
        });
    }
    return bytes;
}
// We use very optimized technique to convert hex string to byte array
const $9b786d9defa5724c$var$charCodeMap = {
    zero: 48,
    nine: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $9b786d9defa5724c$var$charCodeToBase16(char) {
    if (char >= $9b786d9defa5724c$var$charCodeMap.zero && char <= $9b786d9defa5724c$var$charCodeMap.nine) return char - $9b786d9defa5724c$var$charCodeMap.zero;
    if (char >= $9b786d9defa5724c$var$charCodeMap.A && char <= $9b786d9defa5724c$var$charCodeMap.F) return char - ($9b786d9defa5724c$var$charCodeMap.A - 10);
    if (char >= $9b786d9defa5724c$var$charCodeMap.a && char <= $9b786d9defa5724c$var$charCodeMap.f) return char - ($9b786d9defa5724c$var$charCodeMap.a - 10);
    return undefined;
}
function $9b786d9defa5724c$export$31c96b9df38bc8d4(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        (0, $hiAQY.assertSize)(hex, {
            size: opts.size
        });
        hex = (0, $hkqwL.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    let hexString = hex.slice(2);
    if (hexString.length % 2) hexString = `0${hexString}`;
    const length = hexString.length / 2;
    const bytes = new Uint8Array(length);
    for(let index = 0, j = 0; index < length; index++){
        const nibbleLeft = $9b786d9defa5724c$var$charCodeToBase16(hexString.charCodeAt(j++));
        const nibbleRight = $9b786d9defa5724c$var$charCodeToBase16(hexString.charCodeAt(j++));
        if (nibbleLeft === undefined || nibbleRight === undefined) throw new (0, $hwGC1.BaseError)(`Invalid byte sequence ("${hexString[j - 2]}${hexString[j - 1]}" in "${hexString}").`);
        bytes[index] = nibbleLeft * 16 + nibbleRight;
    }
    return bytes;
}
function $9b786d9defa5724c$export$49ad9be85c347998(value, opts) {
    const hex = (0, $9Kb19.numberToHex)(value, opts);
    return $9b786d9defa5724c$export$31c96b9df38bc8d4(hex);
}
function $9b786d9defa5724c$export$c8dd6bc66a63753c(value, opts = {}) {
    const bytes = $9b786d9defa5724c$var$encoder.encode(value);
    if (typeof opts.size === "number") {
        (0, $hiAQY.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $hkqwL.pad)(bytes, {
            dir: "right",
            size: opts.size
        });
    }
    return bytes;
}

});
parcelRegister("hkqwL", function(module, exports) {

$parcel$export(module.exports, "pad", function () { return $c9d8e1b7450f951d$export$5d04458e2a6c373e; });
$parcel$export(module.exports, "padHex", function () { return $c9d8e1b7450f951d$export$1bcd51c0fce8ee55; });

var $4JnjR = parcelRequire("4JnjR");
function $c9d8e1b7450f951d$export$5d04458e2a6c373e(hexOrBytes, { dir: dir, size: size = 32 } = {}) {
    if (typeof hexOrBytes === "string") return $c9d8e1b7450f951d$export$1bcd51c0fce8ee55(hexOrBytes, {
        dir: dir,
        size: size
    });
    return $c9d8e1b7450f951d$export$4c6b868113605df3(hexOrBytes, {
        dir: dir,
        size: size
    });
}
function $c9d8e1b7450f951d$export$1bcd51c0fce8ee55(hex_, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return hex_;
    const hex = hex_.replace("0x", "");
    if (hex.length > size * 2) throw new (0, $4JnjR.SizeExceedsPaddingSizeError)({
        size: Math.ceil(hex.length / 2),
        targetSize: size,
        type: "hex"
    });
    return `0x${hex[dir === "right" ? "padEnd" : "padStart"](size * 2, "0")}`;
}
function $c9d8e1b7450f951d$export$4c6b868113605df3(bytes, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return bytes;
    if (bytes.length > size) throw new (0, $4JnjR.SizeExceedsPaddingSizeError)({
        size: bytes.length,
        targetSize: size,
        type: "bytes"
    });
    const paddedBytes = new Uint8Array(size);
    for(let i = 0; i < size; i++){
        const padEnd = dir === "right";
        paddedBytes[padEnd ? i : size - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
    }
    return paddedBytes;
}

});
parcelRegister("4JnjR", function(module, exports) {

$parcel$export(module.exports, "SliceOffsetOutOfBoundsError", function () { return $371d741d21abbbfe$export$cfcd41bba8b36dbd; });
$parcel$export(module.exports, "SizeExceedsPaddingSizeError", function () { return $371d741d21abbbfe$export$70445dc308a7f3d5; });

var $hwGC1 = parcelRequire("hwGC1");
class $371d741d21abbbfe$export$cfcd41bba8b36dbd extends (0, $hwGC1.BaseError) {
    constructor({ offset: offset, position: position, size: size }){
        super(`Slice ${position === "start" ? "starting" : "ending"} at offset "${offset}" is out-of-bounds (size: ${size}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SliceOffsetOutOfBoundsError"
        });
    }
}
class $371d741d21abbbfe$export$70445dc308a7f3d5 extends (0, $hwGC1.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (${size}) exceeds padding size (${targetSize}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SizeExceedsPaddingSizeError"
        });
    }
}

});


parcelRegister("9Kb19", function(module, exports) {

$parcel$export(module.exports, "toHex", function () { return $7180f4c7e0186988$export$7ea66e3774a60b67; });
$parcel$export(module.exports, "numberToHex", function () { return $7180f4c7e0186988$export$4e87185b7ecfeec4; });
$parcel$export(module.exports, "stringToHex", function () { return $7180f4c7e0186988$export$551c48dea6f88e6d; });
$parcel$export(module.exports, "boolToHex", function () { return $7180f4c7e0186988$export$b5c95dec4f62ef7a; });
$parcel$export(module.exports, "bytesToHex", function () { return $7180f4c7e0186988$export$58b867e287a802c8; });

var $bL2QE = parcelRequire("bL2QE");

var $hkqwL = parcelRequire("hkqwL");

var $hiAQY = parcelRequire("hiAQY");
const $7180f4c7e0186988$var$hexes = /*#__PURE__*/ Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, "0"));
function $7180f4c7e0186988$export$7ea66e3774a60b67(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $7180f4c7e0186988$export$4e87185b7ecfeec4(value, opts);
    if (typeof value === "string") return $7180f4c7e0186988$export$551c48dea6f88e6d(value, opts);
    if (typeof value === "boolean") return $7180f4c7e0186988$export$b5c95dec4f62ef7a(value, opts);
    return $7180f4c7e0186988$export$58b867e287a802c8(value, opts);
}
function $7180f4c7e0186988$export$b5c95dec4f62ef7a(value, opts = {}) {
    const hex = `0x${Number(value)}`;
    if (typeof opts.size === "number") {
        (0, $hiAQY.assertSize)(hex, {
            size: opts.size
        });
        return (0, $hkqwL.pad)(hex, {
            size: opts.size
        });
    }
    return hex;
}
function $7180f4c7e0186988$export$58b867e287a802c8(value, opts = {}) {
    let string = "";
    for(let i = 0; i < value.length; i++)string += $7180f4c7e0186988$var$hexes[value[i]];
    const hex = `0x${string}`;
    if (typeof opts.size === "number") {
        (0, $hiAQY.assertSize)(hex, {
            size: opts.size
        });
        return (0, $hkqwL.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    return hex;
}
function $7180f4c7e0186988$export$4e87185b7ecfeec4(value_, opts = {}) {
    const { signed: signed, size: size } = opts;
    const value = BigInt(value_);
    let maxValue;
    if (size) {
        if (signed) maxValue = (1n << BigInt(size) * 8n - 1n) - 1n;
        else maxValue = 2n ** (BigInt(size) * 8n) - 1n;
    } else if (typeof value_ === "number") maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    const minValue = typeof maxValue === "bigint" && signed ? -maxValue - 1n : 0;
    if (maxValue && value > maxValue || value < minValue) {
        const suffix = typeof value_ === "bigint" ? "n" : "";
        throw new (0, $bL2QE.IntegerOutOfRangeError)({
            max: maxValue ? `${maxValue}${suffix}` : undefined,
            min: `${minValue}${suffix}`,
            signed: signed,
            size: size,
            value: `${value_}${suffix}`
        });
    }
    const hex = `0x${(signed && value < 0 ? (1n << BigInt(size * 8)) + BigInt(value) : value).toString(16)}`;
    if (size) return (0, $hkqwL.pad)(hex, {
        size: size
    });
    return hex;
}
const $7180f4c7e0186988$var$encoder = /*#__PURE__*/ new TextEncoder();
function $7180f4c7e0186988$export$551c48dea6f88e6d(value_, opts = {}) {
    const value = $7180f4c7e0186988$var$encoder.encode(value_);
    return $7180f4c7e0186988$export$58b867e287a802c8(value, opts);
}

});




parcelRegister("edwZV", function(module, exports) {

$parcel$export(module.exports, "addChain", function () { return $a59be03fb12b9852$export$e648161d6b1bb565; });

var $9Kb19 = parcelRequire("9Kb19");
async function $a59be03fb12b9852$export$e648161d6b1bb565(client, { chain: chain }) {
    const { id: id, name: name, nativeCurrency: nativeCurrency, rpcUrls: rpcUrls, blockExplorers: blockExplorers } = chain;
    await client.request({
        method: "wallet_addEthereumChain",
        params: [
            {
                chainId: (0, $9Kb19.numberToHex)(id),
                chainName: name,
                nativeCurrency: nativeCurrency,
                rpcUrls: rpcUrls.default.http,
                blockExplorerUrls: blockExplorers ? Object.values(blockExplorers).map(({ url: url })=>url) : undefined
            }
        ]
    });
}

});

parcelRegister("jXIGs", function(module, exports) {

$parcel$export(module.exports, "deployContract", function () { return $e886304649cda8da$export$46c7a79747abe6a9; });

var $86E5K = parcelRequire("86E5K");

var $g5KgQ = parcelRequire("g5KgQ");
function $e886304649cda8da$export$46c7a79747abe6a9(walletClient, { abi: abi, args: args, bytecode: bytecode, ...request }) {
    const calldata = (0, $86E5K.encodeDeployData)({
        abi: abi,
        args: args,
        bytecode: bytecode
    });
    return (0, $g5KgQ.sendTransaction)(walletClient, {
        ...request,
        data: calldata
    });
}

});
parcelRegister("86E5K", function(module, exports) {

$parcel$export(module.exports, "encodeDeployData", function () { return $5e6dfbaa7577db78$export$d7a7276006273fbd; });

var $lXm9U = parcelRequire("lXm9U");

var $i9PPy = parcelRequire("i9PPy");

var $iqvwC = parcelRequire("iqvwC");
const $5e6dfbaa7577db78$var$docsPath = "/docs/contract/encodeDeployData";
function $5e6dfbaa7577db78$export$d7a7276006273fbd({ abi: abi, args: args, bytecode: bytecode }) {
    if (!args || args.length === 0) return bytecode;
    const description = abi.find((x)=>"type" in x && x.type === "constructor");
    if (!description) throw new (0, $lXm9U.AbiConstructorNotFoundError)({
        docsPath: $5e6dfbaa7577db78$var$docsPath
    });
    if (!("inputs" in description)) throw new (0, $lXm9U.AbiConstructorParamsNotFoundError)({
        docsPath: $5e6dfbaa7577db78$var$docsPath
    });
    if (!description.inputs || description.inputs.length === 0) throw new (0, $lXm9U.AbiConstructorParamsNotFoundError)({
        docsPath: $5e6dfbaa7577db78$var$docsPath
    });
    const data = (0, $iqvwC.encodeAbiParameters)(description.inputs, args);
    return (0, $i9PPy.concatHex)([
        bytecode,
        data
    ]);
}

});
parcelRegister("lXm9U", function(module, exports) {

$parcel$export(module.exports, "AbiConstructorNotFoundError", function () { return $ffc04bf24f8eeaf9$export$efa723f306cf6168; });
$parcel$export(module.exports, "AbiConstructorParamsNotFoundError", function () { return $ffc04bf24f8eeaf9$export$4faec14323ef9c47; });
$parcel$export(module.exports, "AbiDecodingDataSizeTooSmallError", function () { return $ffc04bf24f8eeaf9$export$7a409e433c5f3a8c; });
$parcel$export(module.exports, "AbiDecodingZeroDataError", function () { return $ffc04bf24f8eeaf9$export$a063cde4013f1935; });
$parcel$export(module.exports, "AbiEncodingArrayLengthMismatchError", function () { return $ffc04bf24f8eeaf9$export$a851da9bf50b557; });
$parcel$export(module.exports, "AbiEncodingBytesSizeMismatchError", function () { return $ffc04bf24f8eeaf9$export$19c281dc8e23a2ea; });
$parcel$export(module.exports, "AbiEncodingLengthMismatchError", function () { return $ffc04bf24f8eeaf9$export$20737d495bb13c2d; });
$parcel$export(module.exports, "AbiErrorSignatureNotFoundError", function () { return $ffc04bf24f8eeaf9$export$8959cb729fefe1ea; });
$parcel$export(module.exports, "AbiEventSignatureEmptyTopicsError", function () { return $ffc04bf24f8eeaf9$export$f83210ce5f9b901f; });
$parcel$export(module.exports, "AbiEventSignatureNotFoundError", function () { return $ffc04bf24f8eeaf9$export$3b44baeac92e4d3a; });
$parcel$export(module.exports, "AbiEventNotFoundError", function () { return $ffc04bf24f8eeaf9$export$c7be62baad13b157; });
$parcel$export(module.exports, "AbiFunctionNotFoundError", function () { return $ffc04bf24f8eeaf9$export$c4faa308ea7f9b2; });
$parcel$export(module.exports, "AbiFunctionOutputsNotFoundError", function () { return $ffc04bf24f8eeaf9$export$26f2edb605108b34; });
$parcel$export(module.exports, "AbiItemAmbiguityError", function () { return $ffc04bf24f8eeaf9$export$fdbba54ba15f2c2d; });
$parcel$export(module.exports, "BytesSizeMismatchError", function () { return $ffc04bf24f8eeaf9$export$a0eb884ede5c87eb; });
$parcel$export(module.exports, "DecodeLogDataMismatch", function () { return $ffc04bf24f8eeaf9$export$3978f86c08fc8c25; });
$parcel$export(module.exports, "DecodeLogTopicsMismatch", function () { return $ffc04bf24f8eeaf9$export$6d7c6f419cf52377; });
$parcel$export(module.exports, "InvalidAbiEncodingTypeError", function () { return $ffc04bf24f8eeaf9$export$53ed98b886965f49; });
$parcel$export(module.exports, "InvalidAbiDecodingTypeError", function () { return $ffc04bf24f8eeaf9$export$cf94ccff0ff97c65; });
$parcel$export(module.exports, "InvalidArrayError", function () { return $ffc04bf24f8eeaf9$export$710dd6d4f78cc47e; });
$parcel$export(module.exports, "InvalidDefinitionTypeError", function () { return $ffc04bf24f8eeaf9$export$81781a0fcfb9ed95; });

var $8nER6 = parcelRequire("8nER6");

var $5pLNq = parcelRequire("5pLNq");

var $hwGC1 = parcelRequire("hwGC1");
class $ffc04bf24f8eeaf9$export$efa723f306cf6168 extends (0, $hwGC1.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            "A constructor was not found on the ABI.",
            "Make sure you are using the correct ABI and that the constructor exists on it."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiConstructorNotFoundError"
        });
    }
}
class $ffc04bf24f8eeaf9$export$4faec14323ef9c47 extends (0, $hwGC1.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            "Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.",
            "Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiConstructorParamsNotFoundError"
        });
    }
}
class $ffc04bf24f8eeaf9$export$68a7b570091cba69 extends (0, $hwGC1.BaseError) {
    constructor({ data: data, size: size }){
        super([
            `Data size of ${size} bytes is invalid.`,
            "Size must be in increments of 32 bytes (size % 32 === 0)."
        ].join("\n"), {
            metaMessages: [
                `Data: ${data} (${size} bytes)`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiDecodingDataSizeInvalidError"
        });
    }
}
class $ffc04bf24f8eeaf9$export$7a409e433c5f3a8c extends (0, $hwGC1.BaseError) {
    constructor({ data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for given parameters.`
        ].join("\n"), {
            metaMessages: [
                `Params: (${(0, $8nER6.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiDecodingDataSizeTooSmallError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $ffc04bf24f8eeaf9$export$a063cde4013f1935 extends (0, $hwGC1.BaseError) {
    constructor(){
        super('Cannot decode zero data ("0x") with ABI parameters.');
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiDecodingZeroDataError"
        });
    }
}
class $ffc04bf24f8eeaf9$export$a851da9bf50b557 extends (0, $hwGC1.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength, type: type }){
        super([
            `ABI encoding array length mismatch for type ${type}.`,
            `Expected length: ${expectedLength}`,
            `Given length: ${givenLength}`
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiEncodingArrayLengthMismatchError"
        });
    }
}
class $ffc04bf24f8eeaf9$export$19c281dc8e23a2ea extends (0, $hwGC1.BaseError) {
    constructor({ expectedSize: expectedSize, value: value }){
        super(`Size of bytes "${value}" (bytes${(0, $5pLNq.size)(value)}) does not match expected size (bytes${expectedSize}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiEncodingBytesSizeMismatchError"
        });
    }
}
class $ffc04bf24f8eeaf9$export$20737d495bb13c2d extends (0, $hwGC1.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength }){
        super([
            "ABI encoding params/values length mismatch.",
            `Expected length (params): ${expectedLength}`,
            `Given length (values): ${givenLength}`
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiEncodingLengthMismatchError"
        });
    }
}
class $ffc04bf24f8eeaf9$export$d47cf5ef47eda817 extends (0, $hwGC1.BaseError) {
    constructor(errorName, { docsPath: docsPath }){
        super([
            `Arguments (\`args\`) were provided to "${errorName}", but "${errorName}" on the ABI does not contain any parameters (\`inputs\`).`,
            "Cannot encode error result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the inputs exist on it."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiErrorInputsNotFoundError"
        });
    }
}
class $ffc04bf24f8eeaf9$export$86b719574b683f04 extends (0, $hwGC1.BaseError) {
    constructor(errorName, { docsPath: docsPath } = {}){
        super([
            `Error ${errorName ? `"${errorName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the error exists on it."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiErrorNotFoundError"
        });
    }
}
class $ffc04bf24f8eeaf9$export$8959cb729fefe1ea extends (0, $hwGC1.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded error signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the error exists on it.",
            `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiErrorSignatureNotFoundError"
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.signature = signature;
    }
}
class $ffc04bf24f8eeaf9$export$f83210ce5f9b901f extends (0, $hwGC1.BaseError) {
    constructor({ docsPath: docsPath }){
        super("Cannot extract event signature from empty topics.", {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiEventSignatureEmptyTopicsError"
        });
    }
}
class $ffc04bf24f8eeaf9$export$3b44baeac92e4d3a extends (0, $hwGC1.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded event signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the event exists on it.",
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiEventSignatureNotFoundError"
        });
    }
}
class $ffc04bf24f8eeaf9$export$c7be62baad13b157 extends (0, $hwGC1.BaseError) {
    constructor(eventName, { docsPath: docsPath } = {}){
        super([
            `Event ${eventName ? `"${eventName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the event exists on it."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiEventNotFoundError"
        });
    }
}
class $ffc04bf24f8eeaf9$export$c4faa308ea7f9b2 extends (0, $hwGC1.BaseError) {
    constructor(functionName, { docsPath: docsPath } = {}){
        super([
            `Function ${functionName ? `"${functionName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiFunctionNotFoundError"
        });
    }
}
class $ffc04bf24f8eeaf9$export$26f2edb605108b34 extends (0, $hwGC1.BaseError) {
    constructor(functionName, { docsPath: docsPath }){
        super([
            `Function "${functionName}" does not contain any \`outputs\` on ABI.`,
            "Cannot decode function result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiFunctionOutputsNotFoundError"
        });
    }
}
class $ffc04bf24f8eeaf9$export$14373147a0e60810 extends (0, $hwGC1.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded function signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the function exists on it.",
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiFunctionSignatureNotFoundError"
        });
    }
}
class $ffc04bf24f8eeaf9$export$fdbba54ba15f2c2d extends (0, $hwGC1.BaseError) {
    constructor(x, y){
        super("Found ambiguous types in overloaded ABI items.", {
            metaMessages: [
                `\`${x.type}\` in \`${(0, $8nER6.formatAbiItem)(x.abiItem)}\`, and`,
                `\`${y.type}\` in \`${(0, $8nER6.formatAbiItem)(y.abiItem)}\``,
                "",
                "These types encode differently and cannot be distinguished at runtime.",
                "Remove one of the ambiguous items in the ABI."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiItemAmbiguityError"
        });
    }
}
class $ffc04bf24f8eeaf9$export$a0eb884ede5c87eb extends (0, $hwGC1.BaseError) {
    constructor({ expectedSize: expectedSize, givenSize: givenSize }){
        super(`Expected bytes${expectedSize}, got bytes${givenSize}.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BytesSizeMismatchError"
        });
    }
}
class $ffc04bf24f8eeaf9$export$3978f86c08fc8c25 extends (0, $hwGC1.BaseError) {
    constructor({ abiItem: abiItem, data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for non-indexed event parameters.`
        ].join("\n"), {
            metaMessages: [
                `Params: (${(0, $8nER6.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "DecodeLogDataMismatch"
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $ffc04bf24f8eeaf9$export$6d7c6f419cf52377 extends (0, $hwGC1.BaseError) {
    constructor({ abiItem: abiItem, param: param }){
        super([
            `Expected a topic for indexed event parameter${param.name ? ` "${param.name}"` : ""} on event "${(0, $8nER6.formatAbiItem)(abiItem, {
                includeName: true
            })}".`
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "DecodeLogTopicsMismatch"
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
    }
}
class $ffc04bf24f8eeaf9$export$53ed98b886965f49 extends (0, $hwGC1.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid encoding type.`,
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiEncodingType"
        });
    }
}
class $ffc04bf24f8eeaf9$export$cf94ccff0ff97c65 extends (0, $hwGC1.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid decoding type.`,
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiDecodingType"
        });
    }
}
class $ffc04bf24f8eeaf9$export$710dd6d4f78cc47e extends (0, $hwGC1.BaseError) {
    constructor(value){
        super([
            `Value "${value}" is not a valid array.`
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidArrayError"
        });
    }
}
class $ffc04bf24f8eeaf9$export$81781a0fcfb9ed95 extends (0, $hwGC1.BaseError) {
    constructor(type){
        super([
            `"${type}" is not a valid definition type.`,
            'Valid types: "function", "event", "error"'
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidDefinitionTypeError"
        });
    }
}
class $ffc04bf24f8eeaf9$export$a16541e2fe420ef1 extends (0, $hwGC1.BaseError) {
    constructor(type){
        super(`Type "${type}" is not supported for packed encoding.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnsupportedPackedAbiType"
        });
    }
}

});
parcelRegister("8nER6", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", function () { return $61a029c34480f917$export$dc5d0ff4fc2fdee1; });
$parcel$export(module.exports, "formatAbiParams", function () { return $61a029c34480f917$export$849e499971de75b3; });

var $lXm9U = parcelRequire("lXm9U");
function $61a029c34480f917$export$dc5d0ff4fc2fdee1(abiItem, { includeName: includeName = false } = {}) {
    if (abiItem.type !== "function" && abiItem.type !== "event" && abiItem.type !== "error") throw new (0, $lXm9U.InvalidDefinitionTypeError)(abiItem.type);
    return `${abiItem.name}(${$61a029c34480f917$export$849e499971de75b3(abiItem.inputs, {
        includeName: includeName
    })})`;
}
function $61a029c34480f917$export$849e499971de75b3(params, { includeName: includeName = false } = {}) {
    if (!params) return "";
    return params.map((param)=>$61a029c34480f917$var$formatAbiParam(param, {
            includeName: includeName
        })).join(includeName ? ", " : ",");
}
function $61a029c34480f917$var$formatAbiParam(param, { includeName: includeName }) {
    if (param.type.startsWith("tuple")) return `(${$61a029c34480f917$export$849e499971de75b3(param.components, {
        includeName: includeName
    })})${param.type.slice(5)}`;
    return param.type + (includeName && param.name ? ` ${param.name}` : "");
}

});


parcelRegister("i9PPy", function(module, exports) {

$parcel$export(module.exports, "concat", function () { return $d38145b49bb82fec$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "concatHex", function () { return $d38145b49bb82fec$export$f6cc0b64b5a999af; });
function $d38145b49bb82fec$export$ee1b3e54f0441b22(values) {
    if (typeof values[0] === "string") return $d38145b49bb82fec$export$f6cc0b64b5a999af(values);
    return $d38145b49bb82fec$export$287dd7971339c972(values);
}
function $d38145b49bb82fec$export$287dd7971339c972(values) {
    let length = 0;
    for (const arr of values)length += arr.length;
    const result = new Uint8Array(length);
    let offset = 0;
    for (const arr of values){
        result.set(arr, offset);
        offset += arr.length;
    }
    return result;
}
function $d38145b49bb82fec$export$f6cc0b64b5a999af(values) {
    return `0x${values.reduce((acc, x)=>acc + x.replace("0x", ""), "")}`;
}

});

parcelRegister("iqvwC", function(module, exports) {

$parcel$export(module.exports, "encodeAbiParameters", function () { return $d6a31be87eb79fb9$export$448ea0950d6dd7d7; });
$parcel$export(module.exports, "getArrayComponents", function () { return $d6a31be87eb79fb9$export$ab502cfdbb1a0d07; });

var $lXm9U = parcelRequire("lXm9U");

var $hiO2U = parcelRequire("hiO2U");

var $fDHPo = parcelRequire("fDHPo");

var $i9PPy = parcelRequire("i9PPy");

var $hkqwL = parcelRequire("hkqwL");

var $5pLNq = parcelRequire("5pLNq");

var $66ShJ = parcelRequire("66ShJ");

var $9Kb19 = parcelRequire("9Kb19");
function $d6a31be87eb79fb9$export$448ea0950d6dd7d7(params, values) {
    if (params.length !== values.length) throw new (0, $lXm9U.AbiEncodingLengthMismatchError)({
        expectedLength: params.length,
        givenLength: values.length
    });
    // Prepare the parameters to determine dynamic types to encode.
    const preparedParams = $d6a31be87eb79fb9$var$prepareParams({
        params: params,
        values: values
    });
    const data = $d6a31be87eb79fb9$var$encodeParams(preparedParams);
    if (data.length === 0) return "0x";
    return data;
}
function $d6a31be87eb79fb9$var$prepareParams({ params: params, values: values }) {
    const preparedParams = [];
    for(let i = 0; i < params.length; i++)preparedParams.push($d6a31be87eb79fb9$var$prepareParam({
        param: params[i],
        value: values[i]
    }));
    return preparedParams;
}
function $d6a31be87eb79fb9$var$prepareParam({ param: param, value: value }) {
    const arrayComponents = $d6a31be87eb79fb9$export$ab502cfdbb1a0d07(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $d6a31be87eb79fb9$var$encodeArray(value, {
            length: length,
            param: {
                ...param,
                type: type
            }
        });
    }
    if (param.type === "tuple") return $d6a31be87eb79fb9$var$encodeTuple(value, {
        param: param
    });
    if (param.type === "address") return $d6a31be87eb79fb9$var$encodeAddress(value);
    if (param.type === "bool") return $d6a31be87eb79fb9$var$encodeBool(value);
    if (param.type.startsWith("uint") || param.type.startsWith("int")) {
        const signed = param.type.startsWith("int");
        return $d6a31be87eb79fb9$var$encodeNumber(value, {
            signed: signed
        });
    }
    if (param.type.startsWith("bytes")) return $d6a31be87eb79fb9$var$encodeBytes(value, {
        param: param
    });
    if (param.type === "string") return $d6a31be87eb79fb9$var$encodeString(value);
    throw new (0, $lXm9U.InvalidAbiEncodingTypeError)(param.type, {
        docsPath: "/docs/contract/encodeAbiParameters"
    });
}
function $d6a31be87eb79fb9$var$encodeParams(preparedParams) {
    // 1. Compute the size of the static part of the parameters.
    let staticSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) staticSize += 32;
        else staticSize += (0, $5pLNq.size)(encoded);
    }
    // 2. Split the parameters into static and dynamic parts.
    const staticParams = [];
    const dynamicParams = [];
    let dynamicSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) {
            staticParams.push((0, $9Kb19.numberToHex)(staticSize + dynamicSize, {
                size: 32
            }));
            dynamicParams.push(encoded);
            dynamicSize += (0, $5pLNq.size)(encoded);
        } else staticParams.push(encoded);
    }
    // 3. Concatenate static and dynamic parts.
    return (0, $i9PPy.concat)([
        ...staticParams,
        ...dynamicParams
    ]);
}
function $d6a31be87eb79fb9$var$encodeAddress(value) {
    if (!(0, $fDHPo.isAddress)(value)) throw new (0, $hiO2U.InvalidAddressError)({
        address: value
    });
    return {
        dynamic: false,
        encoded: (0, $hkqwL.padHex)(value.toLowerCase())
    };
}
function $d6a31be87eb79fb9$var$encodeArray(value, { length: length, param: param }) {
    const dynamic = length === null;
    if (!Array.isArray(value)) throw new (0, $lXm9U.InvalidArrayError)(value);
    if (!dynamic && value.length !== length) throw new (0, $lXm9U.AbiEncodingArrayLengthMismatchError)({
        expectedLength: length,
        givenLength: value.length,
        type: `${param.type}[${length}]`
    });
    let dynamicChild = false;
    const preparedParams = [];
    for(let i = 0; i < value.length; i++){
        const preparedParam = $d6a31be87eb79fb9$var$prepareParam({
            param: param,
            value: value[i]
        });
        if (preparedParam.dynamic) dynamicChild = true;
        preparedParams.push(preparedParam);
    }
    if (dynamic || dynamicChild) {
        const data = $d6a31be87eb79fb9$var$encodeParams(preparedParams);
        if (dynamic) {
            const length = (0, $9Kb19.numberToHex)(preparedParams.length, {
                size: 32
            });
            return {
                dynamic: true,
                encoded: preparedParams.length > 0 ? (0, $i9PPy.concat)([
                    length,
                    data
                ]) : length
            };
        }
        if (dynamicChild) return {
            dynamic: true,
            encoded: data
        };
    }
    return {
        dynamic: false,
        encoded: (0, $i9PPy.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $d6a31be87eb79fb9$var$encodeBytes(value, { param: param }) {
    const [, paramSize] = param.type.split("bytes");
    const bytesSize = (0, $5pLNq.size)(value);
    if (!paramSize) {
        let value_ = value;
        // If the size is not divisible by 32 bytes, pad the end
        // with empty bytes to the ceiling 32 bytes.
        if (bytesSize % 32 !== 0) value_ = (0, $hkqwL.padHex)(value_, {
            dir: "right",
            size: Math.ceil((value.length - 2) / 2 / 32) * 32
        });
        return {
            dynamic: true,
            encoded: (0, $i9PPy.concat)([
                (0, $hkqwL.padHex)((0, $9Kb19.numberToHex)(bytesSize, {
                    size: 32
                })),
                value_
            ])
        };
    }
    if (bytesSize !== parseInt(paramSize)) throw new (0, $lXm9U.AbiEncodingBytesSizeMismatchError)({
        expectedSize: parseInt(paramSize),
        value: value
    });
    return {
        dynamic: false,
        encoded: (0, $hkqwL.padHex)(value, {
            dir: "right"
        })
    };
}
function $d6a31be87eb79fb9$var$encodeBool(value) {
    return {
        dynamic: false,
        encoded: (0, $hkqwL.padHex)((0, $9Kb19.boolToHex)(value))
    };
}
function $d6a31be87eb79fb9$var$encodeNumber(value, { signed: signed }) {
    return {
        dynamic: false,
        encoded: (0, $9Kb19.numberToHex)(value, {
            size: 32,
            signed: signed
        })
    };
}
function $d6a31be87eb79fb9$var$encodeString(value) {
    const hexValue = (0, $9Kb19.stringToHex)(value);
    const partsLength = Math.ceil((0, $5pLNq.size)(hexValue) / 32);
    const parts = [];
    for(let i = 0; i < partsLength; i++)parts.push((0, $hkqwL.padHex)((0, $66ShJ.slice)(hexValue, i * 32, (i + 1) * 32), {
        dir: "right"
    }));
    return {
        dynamic: true,
        encoded: (0, $i9PPy.concat)([
            (0, $hkqwL.padHex)((0, $9Kb19.numberToHex)((0, $5pLNq.size)(hexValue), {
                size: 32
            })),
            ...parts
        ])
    };
}
function $d6a31be87eb79fb9$var$encodeTuple(value, { param: param }) {
    let dynamic = false;
    const preparedParams = [];
    for(let i = 0; i < param.components.length; i++){
        const param_ = param.components[i];
        const index = Array.isArray(value) ? i : param_.name;
        const preparedParam = $d6a31be87eb79fb9$var$prepareParam({
            param: param_,
            value: value[index]
        });
        preparedParams.push(preparedParam);
        if (preparedParam.dynamic) dynamic = true;
    }
    return {
        dynamic: dynamic,
        encoded: dynamic ? $d6a31be87eb79fb9$var$encodeParams(preparedParams) : (0, $i9PPy.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $d6a31be87eb79fb9$export$ab502cfdbb1a0d07(type) {
    const matches = type.match(/^(.*)\[(\d+)?\]$/);
    return matches ? [
        matches[2] ? Number(matches[2]) : null,
        matches[1]
    ] : undefined;
}

});
parcelRegister("hiO2U", function(module, exports) {

$parcel$export(module.exports, "InvalidAddressError", function () { return $c98af03338588311$export$66c44d927ffead98; });

var $hwGC1 = parcelRequire("hwGC1");
class $c98af03338588311$export$66c44d927ffead98 extends (0, $hwGC1.BaseError) {
    constructor({ address: address }){
        super(`Address "${address}" is invalid.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAddressError"
        });
    }
}

});

parcelRegister("fDHPo", function(module, exports) {

$parcel$export(module.exports, "isAddress", function () { return $b62c7eda0fdc4ea4$export$977e255126d763d6; });
const $b62c7eda0fdc4ea4$var$addressRegex = /^0x[a-fA-F0-9]{40}$/;
function $b62c7eda0fdc4ea4$export$977e255126d763d6(address) {
    return $b62c7eda0fdc4ea4$var$addressRegex.test(address);
}

});

parcelRegister("66ShJ", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $472d6979bb0790d4$export$58adb3bec8346d0f; });

var $4JnjR = parcelRequire("4JnjR");

var $6zhhe = parcelRequire("6zhhe");

var $5pLNq = parcelRequire("5pLNq");
function $472d6979bb0790d4$export$58adb3bec8346d0f(value, start, end, { strict: strict } = {}) {
    if ((0, $6zhhe.isHex)(value, {
        strict: false
    })) return $472d6979bb0790d4$export$728fe14c970402fe(value, start, end, {
        strict: strict
    });
    return $472d6979bb0790d4$export$8bac03c8c1da551(value, start, end, {
        strict: strict
    });
}
function $472d6979bb0790d4$var$assertStartOffset(value, start) {
    if (typeof start === "number" && start > 0 && start > (0, $5pLNq.size)(value) - 1) throw new (0, $4JnjR.SliceOffsetOutOfBoundsError)({
        offset: start,
        position: "start",
        size: (0, $5pLNq.size)(value)
    });
}
function $472d6979bb0790d4$var$assertEndOffset(value, start, end) {
    if (typeof start === "number" && typeof end === "number" && (0, $5pLNq.size)(value) !== end - start) throw new (0, $4JnjR.SliceOffsetOutOfBoundsError)({
        offset: end,
        position: "end",
        size: (0, $5pLNq.size)(value)
    });
}
function $472d6979bb0790d4$export$8bac03c8c1da551(value_, start, end, { strict: strict } = {}) {
    $472d6979bb0790d4$var$assertStartOffset(value_, start);
    const value = value_.slice(start, end);
    if (strict) $472d6979bb0790d4$var$assertEndOffset(value, start, end);
    return value;
}
function $472d6979bb0790d4$export$728fe14c970402fe(value_, start, end, { strict: strict } = {}) {
    $472d6979bb0790d4$var$assertStartOffset(value_, start);
    const value = `0x${value_.replace("0x", "").slice((start ?? 0) * 2, (end ?? value_.length) * 2)}`;
    if (strict) $472d6979bb0790d4$var$assertEndOffset(value, start, end);
    return value;
}

});



parcelRegister("g5KgQ", function(module, exports) {

$parcel$export(module.exports, "sendTransaction", function () { return $bb71015f549dbfb5$export$8e0e7ffc78696d30; });

var $gbMK7 = parcelRequire("gbMK7");

var $jB4xz = parcelRequire("jB4xz");

var $jEXbw = parcelRequire("jEXbw");

var $3tme3 = parcelRequire("3tme3");

var $aC8nR = parcelRequire("aC8nR");

var $1kDHP = parcelRequire("1kDHP");

var $i7oAr = parcelRequire("i7oAr");

var $6WhrO = parcelRequire("6WhrO");

var $lNfs4 = parcelRequire("lNfs4");

var $8HlMY = parcelRequire("8HlMY");

var $9QGmb = parcelRequire("9QGmb");
async function $bb71015f549dbfb5$export$8e0e7ffc78696d30(client, args) {
    const { account: account_ = client.account, chain: chain = client.chain, accessList: accessList, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, ...rest } = args;
    if (!account_) throw new (0, $jB4xz.AccountNotFoundError)({
        docsPath: "/docs/actions/wallet/sendTransaction"
    });
    const account = (0, $gbMK7.parseAccount)(account_);
    try {
        (0, $6WhrO.assertRequest)(args);
        let chainId;
        if (chain !== null) {
            chainId = await (0, $i7oAr.getAction)(client, (0, $lNfs4.getChainId), "getChainId")({});
            (0, $jEXbw.assertCurrentChain)({
                currentChainId: chainId,
                chain: chain
            });
        }
        if (account.type === "local") {
            // Prepare the request for signing (assign appropriate fees, etc.)
            const request = await (0, $i7oAr.getAction)(client, (0, $8HlMY.prepareTransactionRequest), "prepareTransactionRequest")({
                account: account,
                accessList: accessList,
                chain: chain,
                data: data,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                nonce: nonce,
                to: to,
                value: value,
                ...rest
            });
            if (!chainId) chainId = await (0, $i7oAr.getAction)(client, (0, $lNfs4.getChainId), "getChainId")({});
            const serializer = chain?.serializers?.transaction;
            const serializedTransaction = await account.signTransaction({
                ...request,
                chainId: chainId
            }, {
                serializer: serializer
            });
            return await (0, $i7oAr.getAction)(client, (0, $9QGmb.sendRawTransaction), "sendRawTransaction")({
                serializedTransaction: serializedTransaction
            });
        }
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || (0, $1kDHP.formatTransactionRequest);
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...(0, $aC8nR.extract)(rest, {
                format: chainFormat
            }),
            accessList: accessList,
            data: data,
            from: account.address,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: to,
            value: value
        });
        return await client.request({
            method: "eth_sendTransaction",
            params: [
                request
            ]
        });
    } catch (err) {
        throw (0, $3tme3.getTransactionError)(err, {
            ...args,
            account: account,
            chain: args.chain || undefined
        });
    }
}

});
parcelRegister("jB4xz", function(module, exports) {

$parcel$export(module.exports, "AccountNotFoundError", function () { return $e444fea428fb0069$export$62ee6b05f0767f28; });

var $hwGC1 = parcelRequire("hwGC1");
class $e444fea428fb0069$export$62ee6b05f0767f28 extends (0, $hwGC1.BaseError) {
    constructor({ docsPath: docsPath } = {}){
        super([
            "Could not find an Account to execute with this Action.",
            "Please provide an Account with the `account` argument on the Action, or by supplying an `account` to the WalletClient."
        ].join("\n"), {
            docsPath: docsPath,
            docsSlug: "account"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AccountNotFoundError"
        });
    }
}

});

parcelRegister("jEXbw", function(module, exports) {

$parcel$export(module.exports, "assertCurrentChain", function () { return $e4ffa9a07fb0581d$export$390d312ab46d0597; });

var $7I75L = parcelRequire("7I75L");
function $e4ffa9a07fb0581d$export$390d312ab46d0597({ chain: chain, currentChainId: currentChainId }) {
    if (!chain) throw new (0, $7I75L.ChainNotFoundError)();
    if (currentChainId !== chain.id) throw new (0, $7I75L.ChainMismatchError)({
        chain: chain,
        currentChainId: currentChainId
    });
}

});
parcelRegister("7I75L", function(module, exports) {

$parcel$export(module.exports, "ChainDoesNotSupportContract", function () { return $59d224cb93aaf449$export$f2b2bfa70417796b; });
$parcel$export(module.exports, "ChainMismatchError", function () { return $59d224cb93aaf449$export$535d82255cc17992; });
$parcel$export(module.exports, "ChainNotFoundError", function () { return $59d224cb93aaf449$export$b7f33b26fea1ae0b; });
$parcel$export(module.exports, "ClientChainNotConfiguredError", function () { return $59d224cb93aaf449$export$64807f0e18658482; });

var $hwGC1 = parcelRequire("hwGC1");
class $59d224cb93aaf449$export$f2b2bfa70417796b extends (0, $hwGC1.BaseError) {
    constructor({ blockNumber: blockNumber, chain: chain, contract: contract }){
        super(`Chain "${chain.name}" does not support contract "${contract.name}".`, {
            metaMessages: [
                "This could be due to any of the following:",
                ...blockNumber && contract.blockCreated && contract.blockCreated > blockNumber ? [
                    `- The contract "${contract.name}" was not deployed until block ${contract.blockCreated} (current block ${blockNumber}).`
                ] : [
                    `- The chain does not have the contract "${contract.name}" configured.`
                ]
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ChainDoesNotSupportContract"
        });
    }
}
class $59d224cb93aaf449$export$535d82255cc17992 extends (0, $hwGC1.BaseError) {
    constructor({ chain: chain, currentChainId: currentChainId }){
        super(`The current chain of the wallet (id: ${currentChainId}) does not match the target chain for the transaction (id: ${chain.id} \u{2013} ${chain.name}).`, {
            metaMessages: [
                `Current Chain ID:  ${currentChainId}`,
                `Expected Chain ID: ${chain.id} \u{2013} ${chain.name}`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ChainMismatchError"
        });
    }
}
class $59d224cb93aaf449$export$b7f33b26fea1ae0b extends (0, $hwGC1.BaseError) {
    constructor(){
        super([
            "No chain was provided to the request.",
            "Please provide a chain with the `chain` argument on the Action, or by supplying a `chain` to WalletClient."
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ChainNotFoundError"
        });
    }
}
class $59d224cb93aaf449$export$64807f0e18658482 extends (0, $hwGC1.BaseError) {
    constructor(){
        super("No chain was provided to the Client.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ClientChainNotConfiguredError"
        });
    }
}
class $59d224cb93aaf449$export$4836eb835ffca5b2 extends (0, $hwGC1.BaseError) {
    constructor({ chainId: chainId }){
        super(`Chain ID "${chainId}" is invalid.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidChainIdError"
        });
    }
}

});


parcelRegister("3tme3", function(module, exports) {

$parcel$export(module.exports, "getTransactionError", function () { return $2875521102999e2c$export$da1758db1985646e; });

var $q5jsL = parcelRequire("q5jsL");

var $8M4GY = parcelRequire("8M4GY");

var $cHblc = parcelRequire("cHblc");
function $2875521102999e2c$export$da1758db1985646e(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $cHblc.getNodeError)(err, args);
        if (cause instanceof (0, $q5jsL.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $8M4GY.TransactionExecutionError)(cause, {
        docsPath: docsPath,
        ...args
    });
}

});
parcelRegister("q5jsL", function(module, exports) {

$parcel$export(module.exports, "ExecutionRevertedError", function () { return $04e68cdb87b8e93a$export$a558573a20f90d54; });
$parcel$export(module.exports, "FeeCapTooHighError", function () { return $04e68cdb87b8e93a$export$63c545de2a2ec844; });
$parcel$export(module.exports, "FeeCapTooLowError", function () { return $04e68cdb87b8e93a$export$dbd5936ae1758966; });
$parcel$export(module.exports, "NonceTooHighError", function () { return $04e68cdb87b8e93a$export$6147426561fdc965; });
$parcel$export(module.exports, "NonceTooLowError", function () { return $04e68cdb87b8e93a$export$2bb6d6395b589b3b; });
$parcel$export(module.exports, "NonceMaxValueError", function () { return $04e68cdb87b8e93a$export$71cf1d500f9be262; });
$parcel$export(module.exports, "InsufficientFundsError", function () { return $04e68cdb87b8e93a$export$b276096bbba16879; });
$parcel$export(module.exports, "IntrinsicGasTooHighError", function () { return $04e68cdb87b8e93a$export$7ad883b4998b9615; });
$parcel$export(module.exports, "IntrinsicGasTooLowError", function () { return $04e68cdb87b8e93a$export$813ccdcce0428bcf; });
$parcel$export(module.exports, "TransactionTypeNotSupportedError", function () { return $04e68cdb87b8e93a$export$a20c52a8beca5c20; });
$parcel$export(module.exports, "TipAboveFeeCapError", function () { return $04e68cdb87b8e93a$export$6ef9dd5e2f836046; });
$parcel$export(module.exports, "UnknownNodeError", function () { return $04e68cdb87b8e93a$export$d6085363229de344; });

var $80APP = parcelRequire("80APP");

var $hwGC1 = parcelRequire("hwGC1");
class $04e68cdb87b8e93a$export$a558573a20f90d54 extends (0, $hwGC1.BaseError) {
    constructor({ cause: cause, message: message } = {}){
        const reason = message?.replace("execution reverted: ", "")?.replace("execution reverted", "");
        super(`Execution reverted ${reason ? `with reason: ${reason}` : "for an unknown reason"}.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ExecutionRevertedError"
        });
    }
}
Object.defineProperty($04e68cdb87b8e93a$export$a558573a20f90d54, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 3
});
Object.defineProperty($04e68cdb87b8e93a$export$a558573a20f90d54, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /execution reverted/
});
class $04e68cdb87b8e93a$export$63c545de2a2ec844 extends (0, $hwGC1.BaseError) {
    constructor({ cause: cause, maxFeePerGas: maxFeePerGas } = {}){
        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $80APP.formatGwei)(maxFeePerGas)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "FeeCapTooHigh"
        });
    }
}
Object.defineProperty($04e68cdb87b8e93a$export$63c545de2a2ec844, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class $04e68cdb87b8e93a$export$dbd5936ae1758966 extends (0, $hwGC1.BaseError) {
    constructor({ cause: cause, maxFeePerGas: maxFeePerGas } = {}){
        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $80APP.formatGwei)(maxFeePerGas)}` : ""} gwei) cannot be lower than the block base fee.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "FeeCapTooLow"
        });
    }
}
Object.defineProperty($04e68cdb87b8e93a$export$dbd5936ae1758966, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
class $04e68cdb87b8e93a$export$6147426561fdc965 extends (0, $hwGC1.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}is higher than the next one expected.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "NonceTooHighError"
        });
    }
}
Object.defineProperty($04e68cdb87b8e93a$export$6147426561fdc965, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too high/
});
class $04e68cdb87b8e93a$export$2bb6d6395b589b3b extends (0, $hwGC1.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super([
            `Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}is lower than the current nonce of the account.`,
            "Try increasing the nonce or find the latest nonce with `getTransactionCount`."
        ].join("\n"), {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "NonceTooLowError"
        });
    }
}
Object.defineProperty($04e68cdb87b8e93a$export$2bb6d6395b589b3b, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too low|transaction already imported|already known/
});
class $04e68cdb87b8e93a$export$71cf1d500f9be262 extends (0, $hwGC1.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}exceeds the maximum allowed nonce.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "NonceMaxValueError"
        });
    }
}
Object.defineProperty($04e68cdb87b8e93a$export$71cf1d500f9be262, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce has max value/
});
class $04e68cdb87b8e93a$export$b276096bbba16879 extends (0, $hwGC1.BaseError) {
    constructor({ cause: cause } = {}){
        super([
            "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account."
        ].join("\n"), {
            cause: cause,
            metaMessages: [
                "This error could arise when the account does not have enough funds to:",
                " - pay for the total gas fee,",
                " - pay for the value to send.",
                " ",
                "The cost of the transaction is calculated as `gas * gas fee + value`, where:",
                " - `gas` is the amount of gas needed for transaction to execute,",
                " - `gas fee` is the gas fee,",
                " - `value` is the amount of ether to send to the recipient."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InsufficientFundsError"
        });
    }
}
Object.defineProperty($04e68cdb87b8e93a$export$b276096bbba16879, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /insufficient funds/
});
class $04e68cdb87b8e93a$export$7ad883b4998b9615 extends (0, $hwGC1.BaseError) {
    constructor({ cause: cause, gas: gas } = {}){
        super(`The amount of gas ${gas ? `(${gas}) ` : ""}provided for the transaction exceeds the limit allowed for the block.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "IntrinsicGasTooHighError"
        });
    }
}
Object.defineProperty($04e68cdb87b8e93a$export$7ad883b4998b9615, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too high|gas limit reached/
});
class $04e68cdb87b8e93a$export$813ccdcce0428bcf extends (0, $hwGC1.BaseError) {
    constructor({ cause: cause, gas: gas } = {}){
        super(`The amount of gas ${gas ? `(${gas}) ` : ""}provided for the transaction is too low.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "IntrinsicGasTooLowError"
        });
    }
}
Object.defineProperty($04e68cdb87b8e93a$export$813ccdcce0428bcf, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too low/
});
class $04e68cdb87b8e93a$export$a20c52a8beca5c20 extends (0, $hwGC1.BaseError) {
    constructor({ cause: cause }){
        super("The transaction type is not supported for this chain.", {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TransactionTypeNotSupportedError"
        });
    }
}
Object.defineProperty($04e68cdb87b8e93a$export$a20c52a8beca5c20, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /transaction type not valid/
});
class $04e68cdb87b8e93a$export$6ef9dd5e2f836046 extends (0, $hwGC1.BaseError) {
    constructor({ cause: cause, maxPriorityFeePerGas: maxPriorityFeePerGas, maxFeePerGas: maxFeePerGas } = {}){
        super([
            `The provided tip (\`maxPriorityFeePerGas\`${maxPriorityFeePerGas ? ` = ${(0, $80APP.formatGwei)(maxPriorityFeePerGas)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $80APP.formatGwei)(maxFeePerGas)} gwei` : ""}).`
        ].join("\n"), {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TipAboveFeeCapError"
        });
    }
}
Object.defineProperty($04e68cdb87b8e93a$export$6ef9dd5e2f836046, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
class $04e68cdb87b8e93a$export$d6085363229de344 extends (0, $hwGC1.BaseError) {
    constructor({ cause: cause }){
        super(`An error occurred while executing: ${cause?.shortMessage}`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownNodeError"
        });
    }
}

});
parcelRegister("80APP", function(module, exports) {

$parcel$export(module.exports, "formatGwei", function () { return $5d4ae578324d9551$export$a716d64a7f646b61; });

var $52Zu6 = parcelRequire("52Zu6");

var $6u2UO = parcelRequire("6u2UO");
function $5d4ae578324d9551$export$a716d64a7f646b61(wei, unit = "wei") {
    return (0, $6u2UO.formatUnits)(wei, (0, $52Zu6.gweiUnits)[unit]);
}

});
parcelRegister("52Zu6", function(module, exports) {

$parcel$export(module.exports, "etherUnits", function () { return $3accd536b15b3541$export$5bbd813111ed9646; });
$parcel$export(module.exports, "gweiUnits", function () { return $3accd536b15b3541$export$a26120bf8be88528; });
$parcel$export(module.exports, "weiUnits", function () { return $3accd536b15b3541$export$b959b3594ea07183; });
const $3accd536b15b3541$export$5bbd813111ed9646 = {
    gwei: 9,
    wei: 18
};
const $3accd536b15b3541$export$a26120bf8be88528 = {
    ether: -9,
    wei: 9
};
const $3accd536b15b3541$export$b959b3594ea07183 = {
    ether: -18,
    gwei: -9
};

});

parcelRegister("6u2UO", function(module, exports) {

$parcel$export(module.exports, "formatUnits", function () { return $4b87ce55f44a4bab$export$bd39b96f71da1885; });
/**
 *  Divides a number by a given exponent of base 10 (10exponent), and formats it into a string representation of the number..
 *
 * - Docs: https://viem.sh/docs/utilities/formatUnits.html
 *
 * @example
 * import { formatUnits } from 'viem'
 *
 * formatUnits(420000000000n, 9)
 * // '420'
 */ function $4b87ce55f44a4bab$export$bd39b96f71da1885(value, decimals) {
    let display = value.toString();
    const negative = display.startsWith("-");
    if (negative) display = display.slice(1);
    display = display.padStart(decimals, "0");
    let [integer, fraction] = [
        display.slice(0, display.length - decimals),
        display.slice(display.length - decimals)
    ];
    fraction = fraction.replace(/(0+)$/, "");
    return `${negative ? "-" : ""}${integer || "0"}${fraction ? `.${fraction}` : ""}`;
}

});



parcelRegister("8M4GY", function(module, exports) {

$parcel$export(module.exports, "prettyPrint", function () { return $663672324b0e6340$export$cde3d1388a9feac3; });
$parcel$export(module.exports, "FeeConflictError", function () { return $663672324b0e6340$export$4e13f9693b10724d; });
$parcel$export(module.exports, "InvalidSerializableTransactionError", function () { return $663672324b0e6340$export$f2282ba9c8899971; });
$parcel$export(module.exports, "TransactionExecutionError", function () { return $663672324b0e6340$export$17fc407b5aeb1e96; });
$parcel$export(module.exports, "TransactionNotFoundError", function () { return $663672324b0e6340$export$23c42bc218867b7c; });
$parcel$export(module.exports, "TransactionReceiptNotFoundError", function () { return $663672324b0e6340$export$df65591684d92652; });
$parcel$export(module.exports, "WaitForTransactionReceiptTimeoutError", function () { return $663672324b0e6340$export$69578a09754f4b33; });

var $c6heD = parcelRequire("c6heD");

var $80APP = parcelRequire("80APP");

var $hwGC1 = parcelRequire("hwGC1");
function $663672324b0e6340$export$cde3d1388a9feac3(args) {
    const entries = Object.entries(args).map(([key, value])=>{
        if (value === undefined || value === false) return null;
        return [
            key,
            value
        ];
    }).filter(Boolean);
    const maxLength = entries.reduce((acc, [key])=>Math.max(acc, key.length), 0);
    return entries.map(([key, value])=>`  ${`${key}:`.padEnd(maxLength + 1)}  ${value}`).join("\n");
}
class $663672324b0e6340$export$4e13f9693b10724d extends (0, $hwGC1.BaseError) {
    constructor(){
        super([
            "Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.",
            "Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others."
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "FeeConflictError"
        });
    }
}
class $663672324b0e6340$export$8ffce3f13fa2ade4 extends (0, $hwGC1.BaseError) {
    constructor({ v: v }){
        super(`Invalid \`v\` value "${v}". Expected 27 or 28.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidLegacyVError"
        });
    }
}
class $663672324b0e6340$export$f2282ba9c8899971 extends (0, $hwGC1.BaseError) {
    constructor({ transaction: transaction }){
        super("Cannot infer a transaction type from provided transaction.", {
            metaMessages: [
                "Provided Transaction:",
                "{",
                $663672324b0e6340$export$cde3d1388a9feac3(transaction),
                "}",
                "",
                "To infer the type, either provide:",
                "- a `type` to the Transaction, or",
                "- an EIP-1559 Transaction with `maxFeePerGas`, or",
                "- an EIP-2930 Transaction with `gasPrice` & `accessList`, or",
                "- a Legacy Transaction with `gasPrice`"
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidSerializableTransactionError"
        });
    }
}
class $663672324b0e6340$export$e410925d6bb07863 extends (0, $hwGC1.BaseError) {
    constructor({ serializedType: serializedType }){
        super(`Serialized transaction type "${serializedType}" is invalid.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidSerializedTransactionType"
        });
        Object.defineProperty(this, "serializedType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.serializedType = serializedType;
    }
}
class $663672324b0e6340$export$75fa267d8b74b3b9 extends (0, $hwGC1.BaseError) {
    constructor({ attributes: attributes, serializedTransaction: serializedTransaction, type: type }){
        const missing = Object.entries(attributes).map(([key, value])=>typeof value === "undefined" ? key : undefined).filter(Boolean);
        super(`Invalid serialized transaction of type "${type}" was provided.`, {
            metaMessages: [
                `Serialized Transaction: "${serializedTransaction}"`,
                missing.length > 0 ? `Missing Attributes: ${missing.join(", ")}` : ""
            ].filter(Boolean)
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidSerializedTransactionError"
        });
        Object.defineProperty(this, "serializedTransaction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.serializedTransaction = serializedTransaction;
        this.type = type;
    }
}
class $663672324b0e6340$export$f5e370fd7cd91580 extends (0, $hwGC1.BaseError) {
    constructor({ storageKey: storageKey }){
        super(`Size for storage key "${storageKey}" is invalid. Expected 32 bytes. Got ${Math.floor((storageKey.length - 2) / 2)} bytes.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidStorageKeySizeError"
        });
    }
}
class $663672324b0e6340$export$17fc407b5aeb1e96 extends (0, $hwGC1.BaseError) {
    constructor(cause, { account: account, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }){
        const prettyArgs = $663672324b0e6340$export$cde3d1388a9feac3({
            chain: chain && `${chain?.name} (id: ${chain?.id})`,
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $c6heD.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $80APP.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $80APP.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $80APP.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Request Arguments:",
                prettyArgs
            ].filter(Boolean)
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TransactionExecutionError"
        });
        this.cause = cause;
    }
}
class $663672324b0e6340$export$23c42bc218867b7c extends (0, $hwGC1.BaseError) {
    constructor({ blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag, hash: hash, index: index }){
        let identifier = "Transaction";
        if (blockTag && index !== undefined) identifier = `Transaction at block time "${blockTag}" at index "${index}"`;
        if (blockHash && index !== undefined) identifier = `Transaction at block hash "${blockHash}" at index "${index}"`;
        if (blockNumber && index !== undefined) identifier = `Transaction at block number "${blockNumber}" at index "${index}"`;
        if (hash) identifier = `Transaction with hash "${hash}"`;
        super(`${identifier} could not be found.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TransactionNotFoundError"
        });
    }
}
class $663672324b0e6340$export$df65591684d92652 extends (0, $hwGC1.BaseError) {
    constructor({ hash: hash }){
        super(`Transaction receipt with hash "${hash}" could not be found. The Transaction may not be processed on a block yet.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TransactionReceiptNotFoundError"
        });
    }
}
class $663672324b0e6340$export$69578a09754f4b33 extends (0, $hwGC1.BaseError) {
    constructor({ hash: hash }){
        super(`Timed out while waiting for transaction with hash "${hash}" to be confirmed.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "WaitForTransactionReceiptTimeoutError"
        });
    }
}

});
parcelRegister("c6heD", function(module, exports) {

$parcel$export(module.exports, "formatEther", function () { return $8cf36a16c8adbe44$export$11bc63b4c03ea518; });

var $52Zu6 = parcelRequire("52Zu6");

var $6u2UO = parcelRequire("6u2UO");
function $8cf36a16c8adbe44$export$11bc63b4c03ea518(wei, unit = "wei") {
    return (0, $6u2UO.formatUnits)(wei, (0, $52Zu6.etherUnits)[unit]);
}

});


parcelRegister("cHblc", function(module, exports) {

$parcel$export(module.exports, "getNodeError", function () { return $93e24c4340e7484c$export$218ee3a1c831c34e; });

var $hwGC1 = parcelRequire("hwGC1");

var $q5jsL = parcelRequire("q5jsL");

var $fG0ph = parcelRequire("fG0ph");

var $e2aBg = parcelRequire("e2aBg");
function $93e24c4340e7484c$export$620efda101db5601(err) {
    return err instanceof (0, $e2aBg.TransactionRejectedRpcError) || err instanceof (0, $e2aBg.InvalidInputRpcError) || err instanceof (0, $fG0ph.RpcRequestError) && err.code === (0, $q5jsL.ExecutionRevertedError).code;
}
function $93e24c4340e7484c$export$218ee3a1c831c34e(err, args) {
    const message = (err.details || "").toLowerCase();
    const executionRevertedError = err.walk((e)=>e.code === (0, $q5jsL.ExecutionRevertedError).code);
    if (executionRevertedError instanceof (0, $hwGC1.BaseError)) return new (0, $q5jsL.ExecutionRevertedError)({
        cause: err,
        message: executionRevertedError.details
    });
    if ((0, $q5jsL.ExecutionRevertedError).nodeMessage.test(message)) return new (0, $q5jsL.ExecutionRevertedError)({
        cause: err,
        message: err.details
    });
    if ((0, $q5jsL.FeeCapTooHighError).nodeMessage.test(message)) return new (0, $q5jsL.FeeCapTooHighError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas
    });
    if ((0, $q5jsL.FeeCapTooLowError).nodeMessage.test(message)) return new (0, $q5jsL.FeeCapTooLowError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas
    });
    if ((0, $q5jsL.NonceTooHighError).nodeMessage.test(message)) return new (0, $q5jsL.NonceTooHighError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $q5jsL.NonceTooLowError).nodeMessage.test(message)) return new (0, $q5jsL.NonceTooLowError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $q5jsL.NonceMaxValueError).nodeMessage.test(message)) return new (0, $q5jsL.NonceMaxValueError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $q5jsL.InsufficientFundsError).nodeMessage.test(message)) return new (0, $q5jsL.InsufficientFundsError)({
        cause: err
    });
    if ((0, $q5jsL.IntrinsicGasTooHighError).nodeMessage.test(message)) return new (0, $q5jsL.IntrinsicGasTooHighError)({
        cause: err,
        gas: args?.gas
    });
    if ((0, $q5jsL.IntrinsicGasTooLowError).nodeMessage.test(message)) return new (0, $q5jsL.IntrinsicGasTooLowError)({
        cause: err,
        gas: args?.gas
    });
    if ((0, $q5jsL.TransactionTypeNotSupportedError).nodeMessage.test(message)) return new (0, $q5jsL.TransactionTypeNotSupportedError)({
        cause: err
    });
    if ((0, $q5jsL.TipAboveFeeCapError).nodeMessage.test(message)) return new (0, $q5jsL.TipAboveFeeCapError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas,
        maxPriorityFeePerGas: args?.maxPriorityFeePerGas
    });
    return new (0, $q5jsL.UnknownNodeError)({
        cause: err
    });
}

});
parcelRegister("fG0ph", function(module, exports) {

$parcel$export(module.exports, "HttpRequestError", function () { return $b69b180248172eac$export$715ba3385e9f2cf0; });
$parcel$export(module.exports, "WebSocketRequestError", function () { return $b69b180248172eac$export$e1d72a3a26ed1bc; });
$parcel$export(module.exports, "RpcRequestError", function () { return $b69b180248172eac$export$a823590631c47261; });
$parcel$export(module.exports, "TimeoutError", function () { return $b69b180248172eac$export$66d311bf29d5c89c; });

var $peKQ1 = parcelRequire("peKQ1");

var $hwGC1 = parcelRequire("hwGC1");

var $d9Nve = parcelRequire("d9Nve");
class $b69b180248172eac$export$715ba3385e9f2cf0 extends (0, $hwGC1.BaseError) {
    constructor({ body: body, details: details, headers: headers, status: status, url: url }){
        super("HTTP request failed.", {
            details: details,
            metaMessages: [
                status && `Status: ${status}`,
                `URL: ${(0, $d9Nve.getUrl)(url)}`,
                body && `Request body: ${(0, $peKQ1.stringify)(body)}`
            ].filter(Boolean)
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "HttpRequestError"
        });
        Object.defineProperty(this, "body", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "url", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.body = body;
        this.headers = headers;
        this.status = status;
        this.url = url;
    }
}
class $b69b180248172eac$export$e1d72a3a26ed1bc extends (0, $hwGC1.BaseError) {
    constructor({ body: body, details: details, url: url }){
        super("WebSocket request failed.", {
            details: details,
            metaMessages: [
                `URL: ${(0, $d9Nve.getUrl)(url)}`,
                `Request body: ${(0, $peKQ1.stringify)(body)}`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "WebSocketRequestError"
        });
    }
}
class $b69b180248172eac$export$a823590631c47261 extends (0, $hwGC1.BaseError) {
    constructor({ body: body, error: error, url: url }){
        super("RPC Request failed.", {
            cause: error,
            details: error.message,
            metaMessages: [
                `URL: ${(0, $d9Nve.getUrl)(url)}`,
                `Request body: ${(0, $peKQ1.stringify)(body)}`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "RpcRequestError"
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.code = error.code;
    }
}
class $b69b180248172eac$export$66d311bf29d5c89c extends (0, $hwGC1.BaseError) {
    constructor({ body: body, url: url }){
        super("The request took too long to respond.", {
            details: "The request timed out.",
            metaMessages: [
                `URL: ${(0, $d9Nve.getUrl)(url)}`,
                `Request body: ${(0, $peKQ1.stringify)(body)}`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TimeoutError"
        });
    }
}

});
parcelRegister("peKQ1", function(module, exports) {

$parcel$export(module.exports, "stringify", function () { return $04bdc7d74cff6a84$export$fac44ee5b035f737; });
const $04bdc7d74cff6a84$export$fac44ee5b035f737 = (value, replacer, space)=>JSON.stringify(value, (key, value_)=>{
        const value = typeof value_ === "bigint" ? value_.toString() : value_;
        return typeof replacer === "function" ? replacer(key, value) : value;
    }, space);

});


parcelRegister("e2aBg", function(module, exports) {

$parcel$export(module.exports, "ParseRpcError", function () { return $02a2fdd4e502b66d$export$aa31e6432f136746; });
$parcel$export(module.exports, "InvalidRequestRpcError", function () { return $02a2fdd4e502b66d$export$ff7b9f15f3eb8d4d; });
$parcel$export(module.exports, "MethodNotFoundRpcError", function () { return $02a2fdd4e502b66d$export$4c4044ac99c8d2d3; });
$parcel$export(module.exports, "InvalidParamsRpcError", function () { return $02a2fdd4e502b66d$export$c600faffd3cbd390; });
$parcel$export(module.exports, "InternalRpcError", function () { return $02a2fdd4e502b66d$export$4e62fafb20e19fd7; });
$parcel$export(module.exports, "InvalidInputRpcError", function () { return $02a2fdd4e502b66d$export$3ba2994324ab015e; });
$parcel$export(module.exports, "ResourceNotFoundRpcError", function () { return $02a2fdd4e502b66d$export$466772c50c6d6751; });
$parcel$export(module.exports, "ResourceUnavailableRpcError", function () { return $02a2fdd4e502b66d$export$270451347568a637; });
$parcel$export(module.exports, "TransactionRejectedRpcError", function () { return $02a2fdd4e502b66d$export$f714565c9176e28; });
$parcel$export(module.exports, "MethodNotSupportedRpcError", function () { return $02a2fdd4e502b66d$export$b106fe05a02d89c5; });
$parcel$export(module.exports, "LimitExceededRpcError", function () { return $02a2fdd4e502b66d$export$2c6f5ab73129d9d7; });
$parcel$export(module.exports, "JsonRpcVersionUnsupportedError", function () { return $02a2fdd4e502b66d$export$662f3764fa426a13; });
$parcel$export(module.exports, "UserRejectedRequestError", function () { return $02a2fdd4e502b66d$export$4af5b080d9e9e1a6; });
$parcel$export(module.exports, "UnauthorizedProviderError", function () { return $02a2fdd4e502b66d$export$cc1057a5779c7ffa; });
$parcel$export(module.exports, "UnsupportedProviderMethodError", function () { return $02a2fdd4e502b66d$export$6a557500ae315a49; });
$parcel$export(module.exports, "ProviderDisconnectedError", function () { return $02a2fdd4e502b66d$export$abb104bf1dd9c38b; });
$parcel$export(module.exports, "ChainDisconnectedError", function () { return $02a2fdd4e502b66d$export$ef186cf1cda0444; });
$parcel$export(module.exports, "SwitchChainError", function () { return $02a2fdd4e502b66d$export$d4ddb31968a9d366; });
$parcel$export(module.exports, "UnknownRpcError", function () { return $02a2fdd4e502b66d$export$bfc830e1ec76e31b; });

var $hwGC1 = parcelRequire("hwGC1");

var $fG0ph = parcelRequire("fG0ph");
const $02a2fdd4e502b66d$var$unknownErrorCode = -1;
class $02a2fdd4e502b66d$export$5460eff990f31920 extends (0, $hwGC1.BaseError) {
    constructor(cause, { code: code, docsPath: docsPath, metaMessages: metaMessages, shortMessage: shortMessage }){
        super(shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: metaMessages || cause?.metaMessages
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "RpcError"
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = cause.name;
        this.code = cause instanceof (0, $fG0ph.RpcRequestError) ? cause.code : code ?? $02a2fdd4e502b66d$var$unknownErrorCode;
    }
}
class $02a2fdd4e502b66d$export$417589b978208a8f extends $02a2fdd4e502b66d$export$5460eff990f31920 {
    constructor(cause, options){
        super(cause, options);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ProviderRpcError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = options.data;
    }
}
class $02a2fdd4e502b66d$export$aa31e6432f136746 extends $02a2fdd4e502b66d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $02a2fdd4e502b66d$export$aa31e6432f136746.code,
            shortMessage: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ParseRpcError"
        });
    }
}
Object.defineProperty($02a2fdd4e502b66d$export$aa31e6432f136746, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32700
});
class $02a2fdd4e502b66d$export$ff7b9f15f3eb8d4d extends $02a2fdd4e502b66d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $02a2fdd4e502b66d$export$ff7b9f15f3eb8d4d.code,
            shortMessage: "JSON is not a valid request object."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidRequestRpcError"
        });
    }
}
Object.defineProperty($02a2fdd4e502b66d$export$ff7b9f15f3eb8d4d, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32600
});
class $02a2fdd4e502b66d$export$4c4044ac99c8d2d3 extends $02a2fdd4e502b66d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $02a2fdd4e502b66d$export$4c4044ac99c8d2d3.code,
            shortMessage: "The method does not exist / is not available."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "MethodNotFoundRpcError"
        });
    }
}
Object.defineProperty($02a2fdd4e502b66d$export$4c4044ac99c8d2d3, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32601
});
class $02a2fdd4e502b66d$export$c600faffd3cbd390 extends $02a2fdd4e502b66d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $02a2fdd4e502b66d$export$c600faffd3cbd390.code,
            shortMessage: [
                "Invalid parameters were provided to the RPC method.",
                "Double check you have provided the correct parameters."
            ].join("\n")
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidParamsRpcError"
        });
    }
}
Object.defineProperty($02a2fdd4e502b66d$export$c600faffd3cbd390, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32602
});
class $02a2fdd4e502b66d$export$4e62fafb20e19fd7 extends $02a2fdd4e502b66d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $02a2fdd4e502b66d$export$4e62fafb20e19fd7.code,
            shortMessage: "An internal error was received."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InternalRpcError"
        });
    }
}
Object.defineProperty($02a2fdd4e502b66d$export$4e62fafb20e19fd7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32603
});
class $02a2fdd4e502b66d$export$3ba2994324ab015e extends $02a2fdd4e502b66d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $02a2fdd4e502b66d$export$3ba2994324ab015e.code,
            shortMessage: [
                "Missing or invalid parameters.",
                "Double check you have provided the correct parameters."
            ].join("\n")
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidInputRpcError"
        });
    }
}
Object.defineProperty($02a2fdd4e502b66d$export$3ba2994324ab015e, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32000
});
class $02a2fdd4e502b66d$export$466772c50c6d6751 extends $02a2fdd4e502b66d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $02a2fdd4e502b66d$export$466772c50c6d6751.code,
            shortMessage: "Requested resource not found."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ResourceNotFoundRpcError"
        });
    }
}
Object.defineProperty($02a2fdd4e502b66d$export$466772c50c6d6751, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32001
});
class $02a2fdd4e502b66d$export$270451347568a637 extends $02a2fdd4e502b66d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $02a2fdd4e502b66d$export$270451347568a637.code,
            shortMessage: "Requested resource not available."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ResourceUnavailableRpcError"
        });
    }
}
Object.defineProperty($02a2fdd4e502b66d$export$270451347568a637, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32002
});
class $02a2fdd4e502b66d$export$f714565c9176e28 extends $02a2fdd4e502b66d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $02a2fdd4e502b66d$export$f714565c9176e28.code,
            shortMessage: "Transaction creation failed."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "TransactionRejectedRpcError"
        });
    }
}
Object.defineProperty($02a2fdd4e502b66d$export$f714565c9176e28, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32003
});
class $02a2fdd4e502b66d$export$b106fe05a02d89c5 extends $02a2fdd4e502b66d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $02a2fdd4e502b66d$export$b106fe05a02d89c5.code,
            shortMessage: "Method is not implemented."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "MethodNotSupportedRpcError"
        });
    }
}
Object.defineProperty($02a2fdd4e502b66d$export$b106fe05a02d89c5, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32004
});
class $02a2fdd4e502b66d$export$2c6f5ab73129d9d7 extends $02a2fdd4e502b66d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $02a2fdd4e502b66d$export$2c6f5ab73129d9d7.code,
            shortMessage: "Request exceeds defined limit."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "LimitExceededRpcError"
        });
    }
}
Object.defineProperty($02a2fdd4e502b66d$export$2c6f5ab73129d9d7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32005
});
class $02a2fdd4e502b66d$export$662f3764fa426a13 extends $02a2fdd4e502b66d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $02a2fdd4e502b66d$export$662f3764fa426a13.code,
            shortMessage: "Version of JSON-RPC protocol is not supported."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "JsonRpcVersionUnsupportedError"
        });
    }
}
Object.defineProperty($02a2fdd4e502b66d$export$662f3764fa426a13, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32006
});
class $02a2fdd4e502b66d$export$4af5b080d9e9e1a6 extends $02a2fdd4e502b66d$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $02a2fdd4e502b66d$export$4af5b080d9e9e1a6.code,
            shortMessage: "User rejected the request."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UserRejectedRequestError"
        });
    }
}
Object.defineProperty($02a2fdd4e502b66d$export$4af5b080d9e9e1a6, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4001
});
class $02a2fdd4e502b66d$export$cc1057a5779c7ffa extends $02a2fdd4e502b66d$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $02a2fdd4e502b66d$export$cc1057a5779c7ffa.code,
            shortMessage: "The requested method and/or account has not been authorized by the user."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnauthorizedProviderError"
        });
    }
}
Object.defineProperty($02a2fdd4e502b66d$export$cc1057a5779c7ffa, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4100
});
class $02a2fdd4e502b66d$export$6a557500ae315a49 extends $02a2fdd4e502b66d$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $02a2fdd4e502b66d$export$6a557500ae315a49.code,
            shortMessage: "The Provider does not support the requested method."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnsupportedProviderMethodError"
        });
    }
}
Object.defineProperty($02a2fdd4e502b66d$export$6a557500ae315a49, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4200
});
class $02a2fdd4e502b66d$export$abb104bf1dd9c38b extends $02a2fdd4e502b66d$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $02a2fdd4e502b66d$export$abb104bf1dd9c38b.code,
            shortMessage: "The Provider is disconnected from all chains."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ProviderDisconnectedError"
        });
    }
}
Object.defineProperty($02a2fdd4e502b66d$export$abb104bf1dd9c38b, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4900
});
class $02a2fdd4e502b66d$export$ef186cf1cda0444 extends $02a2fdd4e502b66d$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $02a2fdd4e502b66d$export$ef186cf1cda0444.code,
            shortMessage: "The Provider is not connected to the requested chain."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ChainDisconnectedError"
        });
    }
}
Object.defineProperty($02a2fdd4e502b66d$export$ef186cf1cda0444, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4901
});
class $02a2fdd4e502b66d$export$d4ddb31968a9d366 extends $02a2fdd4e502b66d$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $02a2fdd4e502b66d$export$d4ddb31968a9d366.code,
            shortMessage: "An error occurred when attempting to switch chain."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SwitchChainError"
        });
    }
}
Object.defineProperty($02a2fdd4e502b66d$export$d4ddb31968a9d366, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4902
});
class $02a2fdd4e502b66d$export$bfc830e1ec76e31b extends $02a2fdd4e502b66d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            shortMessage: "An unknown RPC error occurred."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownRpcError"
        });
    }
}

});



parcelRegister("aC8nR", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $7ba3f4dc654d2d2f$export$f9380c9a627682d3; });
/**
 * @description Picks out the keys from `value` that exist in the formatter..
 */ function $7ba3f4dc654d2d2f$export$f9380c9a627682d3(value_, { format: format }) {
    if (!format) return {};
    const value = {};
    function extract_(formatted) {
        const keys = Object.keys(formatted);
        for (const key of keys){
            if (key in value_) value[key] = value_[key];
            if (formatted[key] && typeof formatted[key] === "object" && !Array.isArray(formatted[key])) extract_(formatted[key]);
        }
    }
    const formatted = format(value_ || {});
    extract_(formatted);
    return value;
}

});

parcelRegister("1kDHP", function(module, exports) {

$parcel$export(module.exports, "formatTransactionRequest", function () { return $0f867573e5f753f0$export$d23fcba447c86a8e; });

var $9Kb19 = parcelRequire("9Kb19");

var $a2Hr5 = parcelRequire("a2Hr5");
const $0f867573e5f753f0$export$b2a848539dcbb25f = {
    legacy: "0x0",
    eip2930: "0x1",
    eip1559: "0x2"
};
function $0f867573e5f753f0$export$d23fcba447c86a8e(transactionRequest) {
    return {
        ...transactionRequest,
        gas: typeof transactionRequest.gas !== "undefined" ? (0, $9Kb19.numberToHex)(transactionRequest.gas) : undefined,
        gasPrice: typeof transactionRequest.gasPrice !== "undefined" ? (0, $9Kb19.numberToHex)(transactionRequest.gasPrice) : undefined,
        maxFeePerGas: typeof transactionRequest.maxFeePerGas !== "undefined" ? (0, $9Kb19.numberToHex)(transactionRequest.maxFeePerGas) : undefined,
        maxPriorityFeePerGas: typeof transactionRequest.maxPriorityFeePerGas !== "undefined" ? (0, $9Kb19.numberToHex)(transactionRequest.maxPriorityFeePerGas) : undefined,
        nonce: typeof transactionRequest.nonce !== "undefined" ? (0, $9Kb19.numberToHex)(transactionRequest.nonce) : undefined,
        type: typeof transactionRequest.type !== "undefined" ? $0f867573e5f753f0$export$b2a848539dcbb25f[transactionRequest.type] : undefined,
        value: typeof transactionRequest.value !== "undefined" ? (0, $9Kb19.numberToHex)(transactionRequest.value) : undefined
    };
}
const $0f867573e5f753f0$export$aba208618cee26e3 = /*#__PURE__*/ (0, $a2Hr5.defineFormatter)("transactionRequest", $0f867573e5f753f0$export$d23fcba447c86a8e);

});
parcelRegister("a2Hr5", function(module, exports) {

$parcel$export(module.exports, "defineFormatter", function () { return $74fbc8c6162e4eab$export$5d08535cc975931a; });
function $74fbc8c6162e4eab$export$5d08535cc975931a(type, format) {
    return ({ exclude: exclude, format: overrides })=>{
        return {
            exclude: exclude,
            format: (args)=>{
                const formatted = format(args);
                if (exclude) for (const key of exclude)delete formatted[key];
                return {
                    ...formatted,
                    ...overrides(args)
                };
            },
            type: type
        };
    };
}

});


parcelRegister("i7oAr", function(module, exports) {

$parcel$export(module.exports, "getAction", function () { return $d30bf3d79cf5bf1b$export$6ca3170acb89054; });
/**
 * Retrieves and returns an action from the client (if exists), and falls
 * back to the tree-shakable action.
 *
 * Useful for extracting overridden actions from a client (ie. if a consumer
 * wants to override the `sendTransaction` implementation).
 */ function $d30bf3d79cf5bf1b$export$6ca3170acb89054(client, action, // Some minifiers drop `Function.prototype.name`, meaning that `action.name`
// will not work. For that case, the consumer needs to pass the name explicitly.
name) {
    return (params)=>client[action.name || name]?.(params) ?? action(client, params);
}

});

parcelRegister("6WhrO", function(module, exports) {

$parcel$export(module.exports, "assertRequest", function () { return $50d5b199f1560486$export$5378021d985ceaf8; });

var $gbMK7 = parcelRequire("gbMK7");

var $hiO2U = parcelRequire("hiO2U");

var $q5jsL = parcelRequire("q5jsL");

var $8M4GY = parcelRequire("8M4GY");

var $fDHPo = parcelRequire("fDHPo");
function $50d5b199f1560486$export$5378021d985ceaf8(args) {
    const { account: account_, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, to: to } = args;
    const account = account_ ? (0, $gbMK7.parseAccount)(account_) : undefined;
    if (account && !(0, $fDHPo.isAddress)(account.address)) throw new (0, $hiO2U.InvalidAddressError)({
        address: account.address
    });
    if (to && !(0, $fDHPo.isAddress)(to)) throw new (0, $hiO2U.InvalidAddressError)({
        address: to
    });
    if (typeof gasPrice !== "undefined" && (typeof maxFeePerGas !== "undefined" || typeof maxPriorityFeePerGas !== "undefined")) throw new (0, $8M4GY.FeeConflictError)();
    if (maxFeePerGas && maxFeePerGas > 2n ** 256n - 1n) throw new (0, $q5jsL.FeeCapTooHighError)({
        maxFeePerGas: maxFeePerGas
    });
    if (maxPriorityFeePerGas && maxFeePerGas && maxPriorityFeePerGas > maxFeePerGas) throw new (0, $q5jsL.TipAboveFeeCapError)({
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas
    });
}

});

parcelRegister("8HlMY", function(module, exports) {

$parcel$export(module.exports, "prepareTransactionRequest", function () { return $65533dadceb67ab4$export$2e8a9232fb815d77; });

var $gbMK7 = parcelRequire("gbMK7");

var $flU5t = parcelRequire("flU5t");

var $rXKgZ = parcelRequire("rXKgZ");

var $1bevI = parcelRequire("1bevI");

var $6CyRD = parcelRequire("6CyRD");

var $jB4xz = parcelRequire("jB4xz");

var $dgbcV = parcelRequire("dgbcV");

var $i7oAr = parcelRequire("i7oAr");

var $6WhrO = parcelRequire("6WhrO");

var $4YRsB = parcelRequire("4YRsB");
async function $65533dadceb67ab4$export$2e8a9232fb815d77(client, args) {
    const { account: account_ = client.account, chain: chain, gas: gas, nonce: nonce, type: type } = args;
    if (!account_) throw new (0, $jB4xz.AccountNotFoundError)();
    const account = (0, $gbMK7.parseAccount)(account_);
    const block = await (0, $i7oAr.getAction)(client, (0, $1bevI.getBlock), "getBlock")({
        blockTag: "latest"
    });
    const request = {
        ...args,
        from: account.address
    };
    if (typeof nonce === "undefined") request.nonce = await (0, $i7oAr.getAction)(client, (0, $6CyRD.getTransactionCount), "getTransactionCount")({
        address: account.address,
        blockTag: "pending"
    });
    if (typeof type === "undefined") try {
        request.type = (0, $4YRsB.getTransactionType)(request);
    } catch  {
        // infer type from block
        request.type = typeof block.baseFeePerGas === "bigint" ? "eip1559" : "legacy";
    }
    if (request.type === "eip1559") {
        // EIP-1559 fees
        const { maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas } = await (0, $flU5t.internal_estimateFeesPerGas)(client, {
            block: block,
            chain: chain,
            request: request
        });
        if (typeof args.maxPriorityFeePerGas === "undefined" && args.maxFeePerGas && args.maxFeePerGas < maxPriorityFeePerGas) throw new (0, $dgbcV.MaxFeePerGasTooLowError)({
            maxPriorityFeePerGas: maxPriorityFeePerGas
        });
        request.maxPriorityFeePerGas = maxPriorityFeePerGas;
        request.maxFeePerGas = maxFeePerGas;
    } else {
        // Legacy fees
        if (typeof args.maxFeePerGas !== "undefined" || typeof args.maxPriorityFeePerGas !== "undefined") throw new (0, $dgbcV.Eip1559FeesNotSupportedError)();
        const { gasPrice: gasPrice_ } = await (0, $flU5t.internal_estimateFeesPerGas)(client, {
            block: block,
            chain: chain,
            request: request,
            type: "legacy"
        });
        request.gasPrice = gasPrice_;
    }
    if (typeof gas === "undefined") request.gas = await (0, $i7oAr.getAction)(client, (0, $rXKgZ.estimateGas), "estimateGas")({
        ...request,
        account: {
            address: account.address,
            type: "json-rpc"
        }
    });
    (0, $6WhrO.assertRequest)(request);
    return request;
}

});
parcelRegister("flU5t", function(module, exports) {

$parcel$export(module.exports, "estimateFeesPerGas", function () { return $b2d452f0d73bf89c$export$8193bed8c46d2831; });
$parcel$export(module.exports, "internal_estimateFeesPerGas", function () { return $b2d452f0d73bf89c$export$67115e8707c5a9e; });

var $dgbcV = parcelRequire("dgbcV");

var $i7oAr = parcelRequire("i7oAr");

var $lujmb = parcelRequire("lujmb");

var $1bevI = parcelRequire("1bevI");

var $iGxwD = parcelRequire("iGxwD");
async function $b2d452f0d73bf89c$export$8193bed8c46d2831(client, args) {
    return $b2d452f0d73bf89c$export$67115e8707c5a9e(client, args);
}
async function $b2d452f0d73bf89c$export$67115e8707c5a9e(client, args) {
    const { block: block_, chain: chain = client.chain, request: request, type: type = "eip1559" } = args || {};
    const baseFeeMultiplier = await (async ()=>{
        if (typeof chain?.fees?.baseFeeMultiplier === "function") return chain.fees.baseFeeMultiplier({
            block: block_,
            client: client,
            request: request
        });
        return chain?.fees?.baseFeeMultiplier ?? 1.2;
    })();
    if (baseFeeMultiplier < 1) throw new (0, $dgbcV.BaseFeeScalarError)();
    const decimals = baseFeeMultiplier.toString().split(".")[1]?.length ?? 0;
    const denominator = 10 ** decimals;
    const multiply = (base)=>base * BigInt(Math.ceil(baseFeeMultiplier * denominator)) / BigInt(denominator);
    const block = block_ ? block_ : await (0, $i7oAr.getAction)(client, (0, $1bevI.getBlock), "getBlock")({});
    if (typeof chain?.fees?.estimateFeesPerGas === "function") return chain.fees.estimateFeesPerGas({
        block: block_,
        client: client,
        multiply: multiply,
        request: request,
        type: type
    });
    if (type === "eip1559") {
        if (typeof block.baseFeePerGas !== "bigint") throw new (0, $dgbcV.Eip1559FeesNotSupportedError)();
        const maxPriorityFeePerGas = request?.maxPriorityFeePerGas ? request.maxPriorityFeePerGas : await (0, $lujmb.internal_estimateMaxPriorityFeePerGas)(client, {
            block: block,
            chain: chain,
            request: request
        });
        const baseFeePerGas = multiply(block.baseFeePerGas);
        const maxFeePerGas = request?.maxFeePerGas ?? baseFeePerGas + maxPriorityFeePerGas;
        return {
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas
        };
    }
    const gasPrice = request?.gasPrice ?? multiply(await (0, $i7oAr.getAction)(client, (0, $iGxwD.getGasPrice), "getGasPrice")({}));
    return {
        gasPrice: gasPrice
    };
}

});
parcelRegister("dgbcV", function(module, exports) {

$parcel$export(module.exports, "BaseFeeScalarError", function () { return $9a75768f81135abe$export$200c092bedf29ac0; });
$parcel$export(module.exports, "Eip1559FeesNotSupportedError", function () { return $9a75768f81135abe$export$dcf53c0ae183fb46; });
$parcel$export(module.exports, "MaxFeePerGasTooLowError", function () { return $9a75768f81135abe$export$bcf9730904a1086f; });

var $80APP = parcelRequire("80APP");

var $hwGC1 = parcelRequire("hwGC1");
class $9a75768f81135abe$export$200c092bedf29ac0 extends (0, $hwGC1.BaseError) {
    constructor(){
        super("`baseFeeMultiplier` must be greater than 1.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BaseFeeScalarError"
        });
    }
}
class $9a75768f81135abe$export$dcf53c0ae183fb46 extends (0, $hwGC1.BaseError) {
    constructor(){
        super("Chain does not support EIP-1559 fees.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Eip1559FeesNotSupportedError"
        });
    }
}
class $9a75768f81135abe$export$bcf9730904a1086f extends (0, $hwGC1.BaseError) {
    constructor({ maxPriorityFeePerGas: maxPriorityFeePerGas }){
        super(`\`maxFeePerGas\` cannot be less than the \`maxPriorityFeePerGas\` (${(0, $80APP.formatGwei)(maxPriorityFeePerGas)} gwei).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "MaxFeePerGasTooLowError"
        });
    }
}

});

parcelRegister("lujmb", function(module, exports) {

$parcel$export(module.exports, "estimateMaxPriorityFeePerGas", function () { return $fa4b6a2d1b3f55e6$export$fd79a693887f886c; });
$parcel$export(module.exports, "internal_estimateMaxPriorityFeePerGas", function () { return $fa4b6a2d1b3f55e6$export$59275bafd388148; });

var $dgbcV = parcelRequire("dgbcV");

var $hiAQY = parcelRequire("hiAQY");

var $i7oAr = parcelRequire("i7oAr");

var $1bevI = parcelRequire("1bevI");

var $iGxwD = parcelRequire("iGxwD");
async function $fa4b6a2d1b3f55e6$export$fd79a693887f886c(client, args) {
    return $fa4b6a2d1b3f55e6$export$59275bafd388148(client, args);
}
async function $fa4b6a2d1b3f55e6$export$59275bafd388148(client, args) {
    const { block: block_, chain: chain = client.chain, request: request } = args || {};
    if (typeof chain?.fees?.defaultPriorityFee === "function") {
        const block = block_ || await (0, $i7oAr.getAction)(client, (0, $1bevI.getBlock), "getBlock")({});
        return chain.fees.defaultPriorityFee({
            block: block,
            client: client,
            request: request
        });
    }
    if (typeof chain?.fees?.defaultPriorityFee !== "undefined") return chain?.fees?.defaultPriorityFee;
    try {
        const maxPriorityFeePerGasHex = await client.request({
            method: "eth_maxPriorityFeePerGas"
        });
        return (0, $hiAQY.hexToBigInt)(maxPriorityFeePerGasHex);
    } catch  {
        // If the RPC Provider does not support `eth_maxPriorityFeePerGas`
        // fall back to calculating it manually via `gasPrice - baseFeePerGas`.
        // See: https://github.com/ethereum/pm/issues/328#:~:text=eth_maxPriorityFeePerGas%20after%20London%20will%20effectively%20return%20eth_gasPrice%20%2D%20baseFee
        const [block, gasPrice] = await Promise.all([
            block_ ? Promise.resolve(block_) : (0, $i7oAr.getAction)(client, (0, $1bevI.getBlock), "getBlock")({}),
            (0, $i7oAr.getAction)(client, (0, $iGxwD.getGasPrice), "getGasPrice")({})
        ]);
        if (typeof block.baseFeePerGas !== "bigint") throw new (0, $dgbcV.Eip1559FeesNotSupportedError)();
        const maxPriorityFeePerGas = gasPrice - block.baseFeePerGas;
        if (maxPriorityFeePerGas < 0n) return 0n;
        return maxPriorityFeePerGas;
    }
}

});
parcelRegister("1bevI", function(module, exports) {

$parcel$export(module.exports, "getBlock", function () { return $0dc2130550cff32d$export$ea0af84ed2e77902; });

var $01ane = parcelRequire("01ane");

var $9Kb19 = parcelRequire("9Kb19");

var $hXyDB = parcelRequire("hXyDB");
async function $0dc2130550cff32d$export$ea0af84ed2e77902(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag_, includeTransactions: includeTransactions_ } = {}) {
    const blockTag = blockTag_ ?? "latest";
    const includeTransactions = includeTransactions_ ?? false;
    const blockNumberHex = blockNumber !== undefined ? (0, $9Kb19.numberToHex)(blockNumber) : undefined;
    let block = null;
    if (blockHash) block = await client.request({
        method: "eth_getBlockByHash",
        params: [
            blockHash,
            includeTransactions
        ]
    });
    else block = await client.request({
        method: "eth_getBlockByNumber",
        params: [
            blockNumberHex || blockTag,
            includeTransactions
        ]
    });
    if (!block) throw new (0, $01ane.BlockNotFoundError)({
        blockHash: blockHash,
        blockNumber: blockNumber
    });
    const format = client.chain?.formatters?.block?.format || (0, $hXyDB.formatBlock);
    return format(block);
}

});
parcelRegister("01ane", function(module, exports) {

$parcel$export(module.exports, "BlockNotFoundError", function () { return $0038241f3e8e71e3$export$f5a00468af285e38; });

var $hwGC1 = parcelRequire("hwGC1");
class $0038241f3e8e71e3$export$f5a00468af285e38 extends (0, $hwGC1.BaseError) {
    constructor({ blockHash: blockHash, blockNumber: blockNumber }){
        let identifier = "Block";
        if (blockHash) identifier = `Block at hash "${blockHash}"`;
        if (blockNumber) identifier = `Block at number "${blockNumber}"`;
        super(`${identifier} could not be found.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BlockNotFoundError"
        });
    }
}

});

parcelRegister("hXyDB", function(module, exports) {

$parcel$export(module.exports, "formatBlock", function () { return $d132d0af7476aff4$export$ba1152bc4017d62a; });

var $a2Hr5 = parcelRequire("a2Hr5");

var $2vH81 = parcelRequire("2vH81");
function $d132d0af7476aff4$export$ba1152bc4017d62a(block) {
    const transactions = block.transactions?.map((transaction)=>{
        if (typeof transaction === "string") return transaction;
        return (0, $2vH81.formatTransaction)(transaction);
    });
    return {
        ...block,
        baseFeePerGas: block.baseFeePerGas ? BigInt(block.baseFeePerGas) : null,
        difficulty: block.difficulty ? BigInt(block.difficulty) : undefined,
        gasLimit: block.gasLimit ? BigInt(block.gasLimit) : undefined,
        gasUsed: block.gasUsed ? BigInt(block.gasUsed) : undefined,
        hash: block.hash ? block.hash : null,
        logsBloom: block.logsBloom ? block.logsBloom : null,
        nonce: block.nonce ? block.nonce : null,
        number: block.number ? BigInt(block.number) : null,
        size: block.size ? BigInt(block.size) : undefined,
        timestamp: block.timestamp ? BigInt(block.timestamp) : undefined,
        transactions: transactions,
        totalDifficulty: block.totalDifficulty ? BigInt(block.totalDifficulty) : null
    };
}
const $d132d0af7476aff4$export$9f35cb3327f1a5c5 = /*#__PURE__*/ (0, $a2Hr5.defineFormatter)("block", $d132d0af7476aff4$export$ba1152bc4017d62a);

});
parcelRegister("2vH81", function(module, exports) {

$parcel$export(module.exports, "transactionType", function () { return $1d3fee71376484df$export$cd5f936b62a5e91; });
$parcel$export(module.exports, "formatTransaction", function () { return $1d3fee71376484df$export$b02b16590d26dadc; });

var $hiAQY = parcelRequire("hiAQY");

var $a2Hr5 = parcelRequire("a2Hr5");
const $1d3fee71376484df$export$cd5f936b62a5e91 = {
    "0x0": "legacy",
    "0x1": "eip2930",
    "0x2": "eip1559"
};
function $1d3fee71376484df$export$b02b16590d26dadc(transaction) {
    const transaction_ = {
        ...transaction,
        blockHash: transaction.blockHash ? transaction.blockHash : null,
        blockNumber: transaction.blockNumber ? BigInt(transaction.blockNumber) : null,
        chainId: transaction.chainId ? (0, $hiAQY.hexToNumber)(transaction.chainId) : undefined,
        gas: transaction.gas ? BigInt(transaction.gas) : undefined,
        gasPrice: transaction.gasPrice ? BigInt(transaction.gasPrice) : undefined,
        maxFeePerGas: transaction.maxFeePerGas ? BigInt(transaction.maxFeePerGas) : undefined,
        maxPriorityFeePerGas: transaction.maxPriorityFeePerGas ? BigInt(transaction.maxPriorityFeePerGas) : undefined,
        nonce: transaction.nonce ? (0, $hiAQY.hexToNumber)(transaction.nonce) : undefined,
        to: transaction.to ? transaction.to : null,
        transactionIndex: transaction.transactionIndex ? Number(transaction.transactionIndex) : null,
        type: transaction.type ? $1d3fee71376484df$export$cd5f936b62a5e91[transaction.type] : undefined,
        typeHex: transaction.type ? transaction.type : undefined,
        value: transaction.value ? BigInt(transaction.value) : undefined,
        v: transaction.v ? BigInt(transaction.v) : undefined
    };
    transaction_.yParity = (()=>{
        // If `yParity` is provided, we will use it.
        if (transaction.yParity) return Number(transaction.yParity);
        // If no `yParity` provided, try derive from `v`.
        if (typeof transaction_.v === "bigint") {
            if (transaction_.v === 0n || transaction_.v === 27n) return 0;
            if (transaction_.v === 1n || transaction_.v === 28n) return 1;
            if (transaction_.v >= 35n) return transaction_.v % 2n === 0n ? 1 : 0;
        }
        return undefined;
    })();
    if (transaction_.type === "legacy") {
        delete transaction_.accessList;
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
        delete transaction_.yParity;
    }
    if (transaction_.type === "eip2930") {
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
    }
    return transaction_;
}
const $1d3fee71376484df$export$c19bdc7dbe69198d = /*#__PURE__*/ (0, $a2Hr5.defineFormatter)("transaction", $1d3fee71376484df$export$b02b16590d26dadc);

});



parcelRegister("iGxwD", function(module, exports) {

$parcel$export(module.exports, "getGasPrice", function () { return $d9a627add30e44f8$export$89c15b50d46d3f8c; });
/**
 * Returns the current price of gas (in wei).
 *
 * - Docs: https://viem.sh/docs/actions/public/getGasPrice.html
 * - JSON-RPC Methods: [`eth_gasPrice`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_gasprice)
 *
 * @param client - Client to use
 * @returns The gas price (in wei). {@link GetGasPriceReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getGasPrice } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const gasPrice = await getGasPrice(client)
 */ async function $d9a627add30e44f8$export$89c15b50d46d3f8c(client) {
    const gasPrice = await client.request({
        method: "eth_gasPrice"
    });
    return BigInt(gasPrice);
}

});



parcelRegister("rXKgZ", function(module, exports) {

$parcel$export(module.exports, "estimateGas", function () { return $0540dde92ecfc936$export$e0580ae1f48db848; });

var $gbMK7 = parcelRequire("gbMK7");

var $jB4xz = parcelRequire("jB4xz");

var $9Kb19 = parcelRequire("9Kb19");

var $88WOd = parcelRequire("88WOd");

var $aC8nR = parcelRequire("aC8nR");

var $1kDHP = parcelRequire("1kDHP");

var $6WhrO = parcelRequire("6WhrO");

var $8HlMY = parcelRequire("8HlMY");
async function $0540dde92ecfc936$export$e0580ae1f48db848(client, args) {
    const account_ = args.account ?? client.account;
    if (!account_) throw new (0, $jB4xz.AccountNotFoundError)({
        docsPath: "/docs/actions/public/estimateGas"
    });
    const account = (0, $gbMK7.parseAccount)(account_);
    try {
        const { accessList: accessList, blockNumber: blockNumber, blockTag: blockTag, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, ...rest } = account.type === "local" ? await (0, $8HlMY.prepareTransactionRequest)(client, args) : args;
        const blockNumberHex = blockNumber ? (0, $9Kb19.numberToHex)(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        (0, $6WhrO.assertRequest)(args);
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || (0, $1kDHP.formatTransactionRequest);
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...(0, $aC8nR.extract)(rest, {
                format: chainFormat
            }),
            from: account.address,
            accessList: accessList,
            data: data,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: to,
            value: value
        });
        const balance = await client.request({
            method: "eth_estimateGas",
            params: block ? [
                request,
                block
            ] : [
                request
            ]
        });
        return BigInt(balance);
    } catch (err) {
        throw (0, $88WOd.getEstimateGasError)(err, {
            ...args,
            account: account,
            chain: client.chain
        });
    }
}

});
parcelRegister("88WOd", function(module, exports) {

$parcel$export(module.exports, "getEstimateGasError", function () { return $5edcb0539856cc5a$export$f201b805dbcd7c48; });

var $gocgi = parcelRequire("gocgi");

var $q5jsL = parcelRequire("q5jsL");

var $cHblc = parcelRequire("cHblc");
function $5edcb0539856cc5a$export$f201b805dbcd7c48(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $cHblc.getNodeError)(err, args);
        if (cause instanceof (0, $q5jsL.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $gocgi.EstimateGasExecutionError)(cause, {
        docsPath: docsPath,
        ...args
    });
}

});
parcelRegister("gocgi", function(module, exports) {

$parcel$export(module.exports, "EstimateGasExecutionError", function () { return $bee866314109b992$export$9e393e362ab0c102; });

var $c6heD = parcelRequire("c6heD");

var $80APP = parcelRequire("80APP");

var $hwGC1 = parcelRequire("hwGC1");

var $8M4GY = parcelRequire("8M4GY");
class $bee866314109b992$export$9e393e362ab0c102 extends (0, $hwGC1.BaseError) {
    constructor(cause, { account: account, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }){
        const prettyArgs = (0, $8M4GY.prettyPrint)({
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $c6heD.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $80APP.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $80APP.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $80APP.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Estimate Gas Arguments:",
                prettyArgs
            ].filter(Boolean)
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "EstimateGasExecutionError"
        });
        this.cause = cause;
    }
}

});



parcelRegister("6CyRD", function(module, exports) {

$parcel$export(module.exports, "getTransactionCount", function () { return $4d2155f92a499aa1$export$b18e66333ec1361e; });

var $hiAQY = parcelRequire("hiAQY");

var $9Kb19 = parcelRequire("9Kb19");
async function $4d2155f92a499aa1$export$b18e66333ec1361e(client, { address: address, blockTag: blockTag = "latest", blockNumber: blockNumber }) {
    const count = await client.request({
        method: "eth_getTransactionCount",
        params: [
            address,
            blockNumber ? (0, $9Kb19.numberToHex)(blockNumber) : blockTag
        ]
    });
    return (0, $hiAQY.hexToNumber)(count);
}

});

parcelRegister("4YRsB", function(module, exports) {

$parcel$export(module.exports, "getTransactionType", function () { return $3a063c1c7b408464$export$944c6678cd5a1ea8; });

var $8M4GY = parcelRequire("8M4GY");
function $3a063c1c7b408464$export$944c6678cd5a1ea8(transaction) {
    if (transaction.type) return transaction.type;
    if (typeof transaction.maxFeePerGas !== "undefined" || typeof transaction.maxPriorityFeePerGas !== "undefined") return "eip1559";
    if (typeof transaction.gasPrice !== "undefined") {
        if (typeof transaction.accessList !== "undefined") return "eip2930";
        return "legacy";
    }
    throw new (0, $8M4GY.InvalidSerializableTransactionError)({
        transaction: transaction
    });
}

});


parcelRegister("9QGmb", function(module, exports) {

$parcel$export(module.exports, "sendRawTransaction", function () { return $72b9d38bfbc3f64a$export$4e309754b4830e29; });
/**
 * Sends a **signed** transaction to the network
 *
 * - Docs: https://viem.sh/docs/actions/wallet/sendRawTransaction.html
 * - JSON-RPC Method: [`eth_sendRawTransaction`](https://ethereum.github.io/execution-apis/api-documentation/)
 *
 * @param client - Client to use
 * @param parameters - {@link SendRawTransactionParameters}
 * @returns The transaction hash. {@link SendRawTransactionReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { sendRawTransaction } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 *
 * const hash = await sendRawTransaction(client, {
 *   serializedTransaction: '0x02f850018203118080825208808080c080a04012522854168b27e5dc3d5839bab5e6b39e1a0ffd343901ce1622e3d64b48f1a04e00902ae0502c4728cbf12156290df99c3ed7de85b1dbfe20b5c36931733a33'
 * })
 */ async function $72b9d38bfbc3f64a$export$4e309754b4830e29(client, { serializedTransaction: serializedTransaction }) {
    return client.request({
        method: "eth_sendRawTransaction",
        params: [
            serializedTransaction
        ]
    });
}

});



parcelRegister("kzap2", function(module, exports) {

$parcel$export(module.exports, "getAddresses", function () { return $ef8f254ee856a4f7$export$17d5f00cfd692b8a; });

var $1r7Xu = parcelRequire("1r7Xu");
async function $ef8f254ee856a4f7$export$17d5f00cfd692b8a(client) {
    if (client.account?.type === "local") return [
        client.account.address
    ];
    const addresses = await client.request({
        method: "eth_accounts"
    });
    return addresses.map((address)=>(0, $1r7Xu.checksumAddress)(address));
}

});
parcelRegister("1r7Xu", function(module, exports) {

$parcel$export(module.exports, "checksumAddress", function () { return $10be7c777584c769$export$9ff46e8f6df13548; });
$parcel$export(module.exports, "getAddress", function () { return $10be7c777584c769$export$88411125f012957a; });

var $hiO2U = parcelRequire("hiO2U");

var $dlz3r = parcelRequire("dlz3r");

var $9m1kr = parcelRequire("9m1kr");

var $fDHPo = parcelRequire("fDHPo");
function $10be7c777584c769$export$9ff46e8f6df13548(address_, chainId) {
    const hexAddress = chainId ? `${chainId}${address_.toLowerCase()}` : address_.substring(2).toLowerCase();
    const hash = (0, $9m1kr.keccak256)((0, $dlz3r.stringToBytes)(hexAddress), "bytes");
    const address = (chainId ? hexAddress.substring(`${chainId}0x`.length) : hexAddress).split("");
    for(let i = 0; i < 40; i += 2){
        if (hash[i >> 1] >> 4 >= 8 && address[i]) address[i] = address[i].toUpperCase();
        if ((hash[i >> 1] & 0x0f) >= 8 && address[i + 1]) address[i + 1] = address[i + 1].toUpperCase();
    }
    return `0x${address.join("")}`;
}
function $10be7c777584c769$export$88411125f012957a(address, chainId) {
    if (!(0, $fDHPo.isAddress)(address)) throw new (0, $hiO2U.InvalidAddressError)({
        address: address
    });
    return $10be7c777584c769$export$9ff46e8f6df13548(address, chainId);
}

});
parcelRegister("9m1kr", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return $6cf732f824c40082$export$f8151fce47ad1c35; });

var $5yFE7 = parcelRequire("5yFE7");

var $6zhhe = parcelRequire("6zhhe");

var $dlz3r = parcelRequire("dlz3r");

var $9Kb19 = parcelRequire("9Kb19");
function $6cf732f824c40082$export$f8151fce47ad1c35(value, to_) {
    const to = to_ || "hex";
    const bytes = (0, $5yFE7.keccak_256)((0, $6zhhe.isHex)(value, {
        strict: false
    }) ? (0, $dlz3r.toBytes)(value) : value);
    if (to === "bytes") return bytes;
    return (0, $9Kb19.toHex)(bytes);
}

});
parcelRegister("5yFE7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shake256 = module.exports.shake128 = module.exports.keccak_512 = module.exports.keccak_384 = module.exports.keccak_256 = module.exports.keccak_224 = module.exports.sha3_512 = module.exports.sha3_384 = module.exports.sha3_256 = module.exports.sha3_224 = module.exports.Keccak = module.exports.keccakP = void 0;

var $abRUA = parcelRequire("abRUA");

var $m0DUE = parcelRequire("m0DUE");

var $8I2Yj = parcelRequire("8I2Yj");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$40c06ec1c68a5e96$var$SHA3_PI, $40c06ec1c68a5e96$var$SHA3_ROTL, $40c06ec1c68a5e96$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $40c06ec1c68a5e96$var$_0n = /* @__PURE__ */ BigInt(0);
const $40c06ec1c68a5e96$var$_1n = /* @__PURE__ */ BigInt(1);
const $40c06ec1c68a5e96$var$_2n = /* @__PURE__ */ BigInt(2);
const $40c06ec1c68a5e96$var$_7n = /* @__PURE__ */ BigInt(7);
const $40c06ec1c68a5e96$var$_256n = /* @__PURE__ */ BigInt(256);
const $40c06ec1c68a5e96$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $40c06ec1c68a5e96$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $40c06ec1c68a5e96$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $40c06ec1c68a5e96$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $40c06ec1c68a5e96$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $40c06ec1c68a5e96$var$_1n ^ (R >> $40c06ec1c68a5e96$var$_7n) * $40c06ec1c68a5e96$var$_0x71n) % $40c06ec1c68a5e96$var$_256n;
        if (R & $40c06ec1c68a5e96$var$_2n) t ^= $40c06ec1c68a5e96$var$_1n << ($40c06ec1c68a5e96$var$_1n << /* @__PURE__ */ BigInt(j)) - $40c06ec1c68a5e96$var$_1n;
    }
    $40c06ec1c68a5e96$var$_SHA3_IOTA.push(t);
}
const [$40c06ec1c68a5e96$var$SHA3_IOTA_H, $40c06ec1c68a5e96$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $m0DUE.split)($40c06ec1c68a5e96$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $40c06ec1c68a5e96$var$rotlH = (h, l, s)=>s > 32 ? (0, $m0DUE.rotlBH)(h, l, s) : (0, $m0DUE.rotlSH)(h, l, s);
const $40c06ec1c68a5e96$var$rotlL = (h, l, s)=>s > 32 ? (0, $m0DUE.rotlBL)(h, l, s) : (0, $m0DUE.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $40c06ec1c68a5e96$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $40c06ec1c68a5e96$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $40c06ec1c68a5e96$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $40c06ec1c68a5e96$var$SHA3_ROTL[t];
            const Th = $40c06ec1c68a5e96$var$rotlH(curH, curL, shift);
            const Tl = $40c06ec1c68a5e96$var$rotlL(curH, curL, shift);
            const PI = $40c06ec1c68a5e96$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $40c06ec1c68a5e96$var$SHA3_IOTA_H[round];
        s[1] ^= $40c06ec1c68a5e96$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
module.exports.keccakP = $40c06ec1c68a5e96$var$keccakP;
class $40c06ec1c68a5e96$var$Keccak extends $8I2Yj.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $abRUA.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $8I2Yj.u32)(this.state);
    }
    keccak() {
        $40c06ec1c68a5e96$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $abRUA.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $8I2Yj.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $abRUA.exists)(this, false);
        (0, $abRUA.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $abRUA.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $abRUA.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $40c06ec1c68a5e96$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
module.exports.Keccak = $40c06ec1c68a5e96$var$Keccak;
const $40c06ec1c68a5e96$var$gen = (suffix, blockLen, outputLen)=>(0, $8I2Yj.wrapConstructor)(()=>new $40c06ec1c68a5e96$var$Keccak(blockLen, suffix, outputLen));
module.exports.sha3_224 = $40c06ec1c68a5e96$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ module.exports.sha3_256 = $40c06ec1c68a5e96$var$gen(0x06, 136, 32);
module.exports.sha3_384 = $40c06ec1c68a5e96$var$gen(0x06, 104, 48);
module.exports.sha3_512 = $40c06ec1c68a5e96$var$gen(0x06, 72, 64);
module.exports.keccak_224 = $40c06ec1c68a5e96$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ module.exports.keccak_256 = $40c06ec1c68a5e96$var$gen(0x01, 136, 32);
module.exports.keccak_384 = $40c06ec1c68a5e96$var$gen(0x01, 104, 48);
module.exports.keccak_512 = $40c06ec1c68a5e96$var$gen(0x01, 72, 64);
const $40c06ec1c68a5e96$var$genShake = (suffix, blockLen, outputLen)=>(0, $8I2Yj.wrapXOFConstructorWithOpts)((opts = {})=>new $40c06ec1c68a5e96$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
module.exports.shake128 = $40c06ec1c68a5e96$var$genShake(0x1f, 168, 16);
module.exports.shake256 = $40c06ec1c68a5e96$var$genShake(0x1f, 136, 32);

});
parcelRegister("abRUA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = void 0;
function $76b4c034fde2fde4$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
module.exports.number = $76b4c034fde2fde4$var$number;
function $76b4c034fde2fde4$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
module.exports.bool = $76b4c034fde2fde4$var$bool;
function $76b4c034fde2fde4$var$bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $76b4c034fde2fde4$var$bytes;
function $76b4c034fde2fde4$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $76b4c034fde2fde4$var$number(hash.outputLen);
    $76b4c034fde2fde4$var$number(hash.blockLen);
}
module.exports.hash = $76b4c034fde2fde4$var$hash;
function $76b4c034fde2fde4$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $76b4c034fde2fde4$var$exists;
function $76b4c034fde2fde4$var$output(out, instance) {
    $76b4c034fde2fde4$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $76b4c034fde2fde4$var$output;
const $76b4c034fde2fde4$var$assert = {
    number: $76b4c034fde2fde4$var$number,
    bool: $76b4c034fde2fde4$var$bool,
    bytes: $76b4c034fde2fde4$var$bytes,
    hash: $76b4c034fde2fde4$var$hash,
    exists: $76b4c034fde2fde4$var$exists,
    output: $76b4c034fde2fde4$var$output
};
module.exports.default = $76b4c034fde2fde4$var$assert;

});

parcelRegister("m0DUE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.add = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
const $04228dd36bb288f2$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $04228dd36bb288f2$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $04228dd36bb288f2$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $04228dd36bb288f2$var$U32_MASK64),
        l: Number(n >> $04228dd36bb288f2$var$_32n & $04228dd36bb288f2$var$U32_MASK64)
    };
    return {
        h: Number(n >> $04228dd36bb288f2$var$_32n & $04228dd36bb288f2$var$U32_MASK64) | 0,
        l: Number(n & $04228dd36bb288f2$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $04228dd36bb288f2$var$fromBig;
function $04228dd36bb288f2$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $04228dd36bb288f2$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $04228dd36bb288f2$var$split;
const $04228dd36bb288f2$var$toBig = (h, l)=>BigInt(h >>> 0) << $04228dd36bb288f2$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $04228dd36bb288f2$var$toBig;
// for Shift in [0, 32)
const $04228dd36bb288f2$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $04228dd36bb288f2$var$shrSH;
const $04228dd36bb288f2$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $04228dd36bb288f2$var$shrSL;
// Right rotate for Shift in [1, 32)
const $04228dd36bb288f2$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $04228dd36bb288f2$var$rotrSH;
const $04228dd36bb288f2$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $04228dd36bb288f2$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $04228dd36bb288f2$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $04228dd36bb288f2$var$rotrBH;
const $04228dd36bb288f2$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $04228dd36bb288f2$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $04228dd36bb288f2$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $04228dd36bb288f2$var$rotr32H;
const $04228dd36bb288f2$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $04228dd36bb288f2$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $04228dd36bb288f2$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $04228dd36bb288f2$var$rotlSH;
const $04228dd36bb288f2$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $04228dd36bb288f2$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $04228dd36bb288f2$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $04228dd36bb288f2$var$rotlBH;
const $04228dd36bb288f2$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $04228dd36bb288f2$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $04228dd36bb288f2$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $04228dd36bb288f2$var$add;
// Addition with more than 2 elements
const $04228dd36bb288f2$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $04228dd36bb288f2$var$add3L;
const $04228dd36bb288f2$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $04228dd36bb288f2$var$add3H;
const $04228dd36bb288f2$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $04228dd36bb288f2$var$add4L;
const $04228dd36bb288f2$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $04228dd36bb288f2$var$add4H;
const $04228dd36bb288f2$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $04228dd36bb288f2$var$add5L;
const $04228dd36bb288f2$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $04228dd36bb288f2$var$add5H;
// prettier-ignore
const $04228dd36bb288f2$var$u64 = {
    fromBig: $04228dd36bb288f2$var$fromBig,
    split: $04228dd36bb288f2$var$split,
    toBig: $04228dd36bb288f2$var$toBig,
    shrSH: $04228dd36bb288f2$var$shrSH,
    shrSL: $04228dd36bb288f2$var$shrSL,
    rotrSH: $04228dd36bb288f2$var$rotrSH,
    rotrSL: $04228dd36bb288f2$var$rotrSL,
    rotrBH: $04228dd36bb288f2$var$rotrBH,
    rotrBL: $04228dd36bb288f2$var$rotrBL,
    rotr32H: $04228dd36bb288f2$var$rotr32H,
    rotr32L: $04228dd36bb288f2$var$rotr32L,
    rotlSH: $04228dd36bb288f2$var$rotlSH,
    rotlSL: $04228dd36bb288f2$var$rotlSL,
    rotlBH: $04228dd36bb288f2$var$rotlBH,
    rotlBL: $04228dd36bb288f2$var$rotlBL,
    add: $04228dd36bb288f2$var$add,
    add3L: $04228dd36bb288f2$var$add3L,
    add3H: $04228dd36bb288f2$var$add3H,
    add4L: $04228dd36bb288f2$var$add4L,
    add4H: $04228dd36bb288f2$var$add4H,
    add5H: $04228dd36bb288f2$var$add5H,
    add5L: $04228dd36bb288f2$var$add5L
};
module.exports.default = $04228dd36bb288f2$var$u64;

});

parcelRegister("8I2Yj", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.isLE = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;

var $l1pcs = parcelRequire("l1pcs");
const $6574bced0c4eec38$var$u8a = (a)=>a instanceof Uint8Array;
// Cast array to different type
const $6574bced0c4eec38$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $6574bced0c4eec38$var$u8;
const $6574bced0c4eec38$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $6574bced0c4eec38$var$u32;
// Cast array to view
const $6574bced0c4eec38$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $6574bced0c4eec38$var$createView;
// The rotate right (circular right shift) operation for uint32
const $6574bced0c4eec38$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $6574bced0c4eec38$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!module.exports.isLE) throw new Error("Non little-endian hardware is not supported");
const $6574bced0c4eec38$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $6574bced0c4eec38$var$bytesToHex(bytes) {
    if (!$6574bced0c4eec38$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $6574bced0c4eec38$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $6574bced0c4eec38$var$bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $6574bced0c4eec38$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $6574bced0c4eec38$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $6574bced0c4eec38$var$nextTick = async ()=>{};
module.exports.nextTick = $6574bced0c4eec38$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $6574bced0c4eec38$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $6574bced0c4eec38$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $6574bced0c4eec38$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $6574bced0c4eec38$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $6574bced0c4eec38$var$toBytes(data) {
    if (typeof data === "string") data = $6574bced0c4eec38$var$utf8ToBytes(data);
    if (!$6574bced0c4eec38$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
module.exports.toBytes = $6574bced0c4eec38$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $6574bced0c4eec38$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$6574bced0c4eec38$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $6574bced0c4eec38$var$concatBytes;
// For runtime check if class implements interface
class $6574bced0c4eec38$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $6574bced0c4eec38$var$Hash;
const $6574bced0c4eec38$var$toStr = {}.toString;
function $6574bced0c4eec38$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $6574bced0c4eec38$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $6574bced0c4eec38$var$checkOpts;
function $6574bced0c4eec38$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($6574bced0c4eec38$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $6574bced0c4eec38$var$wrapConstructor;
function $6574bced0c4eec38$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($6574bced0c4eec38$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $6574bced0c4eec38$var$wrapConstructorWithOpts;
function $6574bced0c4eec38$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($6574bced0c4eec38$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $6574bced0c4eec38$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $6574bced0c4eec38$var$randomBytes(bytesLength = 32) {
    if ($l1pcs.crypto && typeof $l1pcs.crypto.getRandomValues === "function") return $l1pcs.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $6574bced0c4eec38$var$randomBytes;

});
parcelRegister("l1pcs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});






parcelRegister("l7Rdf", function(module, exports) {

$parcel$export(module.exports, "getPermissions", function () { return $f6138754fb0e8d96$export$e10fd44ca431fa8e; });
/**
 * Gets the wallets current permissions.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/getPermissions.html
 * - JSON-RPC Methods: [`wallet_getPermissions`](https://eips.ethereum.org/EIPS/eip-2255)
 *
 * @param client - Client to use
 * @returns The wallet permissions. {@link GetPermissionsReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getPermissions } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const permissions = await getPermissions(client)
 */ async function $f6138754fb0e8d96$export$e10fd44ca431fa8e(client) {
    const permissions = await client.request({
        method: "wallet_getPermissions"
    });
    return permissions;
}

});

parcelRegister("hSmZG", function(module, exports) {

$parcel$export(module.exports, "requestAddresses", function () { return $d03950eab2eeaa6d$export$87c5bcc1dede6f06; });

var $1r7Xu = parcelRequire("1r7Xu");
async function $d03950eab2eeaa6d$export$87c5bcc1dede6f06(client) {
    const addresses = await client.request({
        method: "eth_requestAccounts"
    });
    return addresses.map((address)=>(0, $1r7Xu.getAddress)(address));
}

});

parcelRegister("gY53h", function(module, exports) {

$parcel$export(module.exports, "requestPermissions", function () { return $c5a62b23a39f90f4$export$8cec5d3683c6896e; });
/**
 * Requests permissions for a wallet.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/requestPermissions.html
 * - JSON-RPC Methods: [`wallet_requestPermissions`](https://eips.ethereum.org/EIPS/eip-2255)
 *
 * @param client - Client to use
 * @param parameters - {@link RequestPermissionsParameters}
 * @returns The wallet permissions. {@link RequestPermissionsReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { requestPermissions } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const permissions = await requestPermissions(client, {
 *   eth_accounts: {}
 * })
 */ async function $c5a62b23a39f90f4$export$8cec5d3683c6896e(client, permissions) {
    return client.request({
        method: "wallet_requestPermissions",
        params: [
            permissions
        ]
    });
}

});

parcelRegister("2ngaX", function(module, exports) {

$parcel$export(module.exports, "signMessage", function () { return $1baa46ecda8d6d7f$export$1d9a7a8a40780de; });

var $gbMK7 = parcelRequire("gbMK7");

var $jB4xz = parcelRequire("jB4xz");

var $9Kb19 = parcelRequire("9Kb19");
async function $1baa46ecda8d6d7f$export$1d9a7a8a40780de(client, { account: account_ = client.account, message: message }) {
    if (!account_) throw new (0, $jB4xz.AccountNotFoundError)({
        docsPath: "/docs/actions/wallet/signMessage"
    });
    const account = (0, $gbMK7.parseAccount)(account_);
    if (account.type === "local") return account.signMessage({
        message: message
    });
    const message_ = (()=>{
        if (typeof message === "string") return (0, $9Kb19.stringToHex)(message);
        if (message.raw instanceof Uint8Array) return (0, $9Kb19.toHex)(message.raw);
        return message.raw;
    })();
    return client.request({
        method: "personal_sign",
        params: [
            message_,
            account.address
        ]
    });
}

});

parcelRegister("fPlcM", function(module, exports) {

$parcel$export(module.exports, "signTransaction", function () { return $b85c115593ff6193$export$6ad02cc4966b42ab; });

var $gbMK7 = parcelRequire("gbMK7");

var $jB4xz = parcelRequire("jB4xz");


var $jEXbw = parcelRequire("jEXbw");

var $1kDHP = parcelRequire("1kDHP");

var $i7oAr = parcelRequire("i7oAr");

var $9Kb19 = parcelRequire("9Kb19");

var $6WhrO = parcelRequire("6WhrO");

var $lNfs4 = parcelRequire("lNfs4");
async function $b85c115593ff6193$export$6ad02cc4966b42ab(client, args) {
    const { account: account_ = client.account, chain: chain = client.chain, ...transaction } = args;
    if (!account_) throw new (0, $jB4xz.AccountNotFoundError)({
        docsPath: "/docs/actions/wallet/signTransaction"
    });
    const account = (0, $gbMK7.parseAccount)(account_);
    (0, $6WhrO.assertRequest)({
        account: account,
        ...args
    });
    const chainId = await (0, $i7oAr.getAction)(client, (0, $lNfs4.getChainId), "getChainId")({});
    if (chain !== null) (0, $jEXbw.assertCurrentChain)({
        currentChainId: chainId,
        chain: chain
    });
    const formatters = chain?.formatters || client.chain?.formatters;
    const format = formatters?.transactionRequest?.format || (0, $1kDHP.formatTransactionRequest);
    if (account.type === "local") return account.signTransaction({
        ...transaction,
        chainId: chainId
    }, {
        serializer: client.chain?.serializers?.transaction
    });
    return await client.request({
        method: "eth_signTransaction",
        params: [
            {
                ...format(transaction),
                chainId: (0, $9Kb19.numberToHex)(chainId),
                from: account.address
            }
        ]
    });
}

});

parcelRegister("7Rkth", function(module, exports) {

$parcel$export(module.exports, "signTypedData", function () { return $5b8d5cd38d5f20c8$export$9f05de2db4d31153; });

var $gbMK7 = parcelRequire("gbMK7");

var $jB4xz = parcelRequire("jB4xz");

var $6zhhe = parcelRequire("6zhhe");

var $peKQ1 = parcelRequire("peKQ1");

var $kpFEJ = parcelRequire("kpFEJ");
async function $5b8d5cd38d5f20c8$export$9f05de2db4d31153(client, { account: account_ = client.account, domain: domain, message: message, primaryType: primaryType, types: types_ }) {
    if (!account_) throw new (0, $jB4xz.AccountNotFoundError)({
        docsPath: "/docs/actions/wallet/signTypedData"
    });
    const account = (0, $gbMK7.parseAccount)(account_);
    const types = {
        EIP712Domain: (0, $kpFEJ.getTypesForEIP712Domain)({
            domain: domain
        }),
        ...types_
    };
    // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
    // as we can't statically check this with TypeScript.
    (0, $kpFEJ.validateTypedData)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    if (account.type === "local") return account.signTypedData({
        domain: domain,
        primaryType: primaryType,
        types: types,
        message: message
    });
    const typedData = (0, $peKQ1.stringify)({
        domain: domain ?? {},
        primaryType: primaryType,
        types: types,
        message: message
    }, (_, value)=>(0, $6zhhe.isHex)(value) ? value.toLowerCase() : value);
    return client.request({
        method: "eth_signTypedData_v4",
        params: [
            account.address,
            typedData
        ]
    });
}

});
parcelRegister("kpFEJ", function(module, exports) {

$parcel$export(module.exports, "validateTypedData", function () { return $edc674777aa305c9$export$fac174f558903e26; });
$parcel$export(module.exports, "getTypesForEIP712Domain", function () { return $edc674777aa305c9$export$6a292159484ee032; });

var $lXm9U = parcelRequire("lXm9U");

var $hiO2U = parcelRequire("hiO2U");

var $fDHPo = parcelRequire("fDHPo");

var $5pLNq = parcelRequire("5pLNq");

var $9Kb19 = parcelRequire("9Kb19");

var $3YUZm = parcelRequire("3YUZm");

var $8c7Hx = parcelRequire("8c7Hx");
function $edc674777aa305c9$export$fac174f558903e26({ domain: domain, message: message, primaryType: primaryType, types: types_ }) {
    const types = types_;
    const validateData = (struct, value_)=>{
        for (const param of struct){
            const { name: name, type: type_ } = param;
            const type = type_;
            const value = value_[name];
            const integerMatch = type.match((0, $3YUZm.integerRegex));
            if (integerMatch && (typeof value === "number" || typeof value === "bigint")) {
                const [_type, base, size_] = integerMatch;
                // If number cannot be cast to a sized hex value, it is out of range
                // and will throw.
                (0, $9Kb19.numberToHex)(value, {
                    signed: base === "int",
                    size: parseInt(size_) / 8
                });
            }
            if (type === "address" && typeof value === "string" && !(0, $fDHPo.isAddress)(value)) throw new (0, $hiO2U.InvalidAddressError)({
                address: value
            });
            const bytesMatch = type.match((0, $3YUZm.bytesRegex));
            if (bytesMatch) {
                const [_type, size_] = bytesMatch;
                if (size_ && (0, $5pLNq.size)(value) !== parseInt(size_)) throw new (0, $lXm9U.BytesSizeMismatchError)({
                    expectedSize: parseInt(size_),
                    givenSize: (0, $5pLNq.size)(value)
                });
            }
            const struct = types[type];
            if (struct) validateData(struct, value);
        }
    };
    // Validate domain types.
    if (types.EIP712Domain && domain) validateData(types.EIP712Domain, domain);
    if (primaryType !== "EIP712Domain") {
        // Validate message types.
        const type = types[primaryType];
        validateData(type, message);
    }
}
function $edc674777aa305c9$export$6a292159484ee032({ domain: domain }) {
    return [
        typeof domain?.name === "string" && {
            name: "name",
            type: "string"
        },
        domain?.version && {
            name: "version",
            type: "string"
        },
        typeof domain?.chainId === "number" && {
            name: "chainId",
            type: "uint256"
        },
        domain?.verifyingContract && {
            name: "verifyingContract",
            type: "address"
        },
        domain?.salt && {
            name: "salt",
            type: "bytes32"
        }
    ].filter(Boolean);
}
function $edc674777aa305c9$export$a1ffff851efcaaba({ domain: domain }) {
    return (0, $8c7Hx.hashDomain)({
        domain: domain,
        types: {
            EIP712Domain: $edc674777aa305c9$export$6a292159484ee032({
                domain: domain
            })
        }
    });
}

});
parcelRegister("3YUZm", function(module, exports) {

$parcel$export(module.exports, "bytesRegex", function () { return $2e632e7beefe2968$export$94d7303c0d9f263a; });
$parcel$export(module.exports, "integerRegex", function () { return $2e632e7beefe2968$export$45902cc189596eef; });
const $2e632e7beefe2968$export$6cd562aaf6380f0e = /^(.*)\[([0-9]*)\]$/;
const $2e632e7beefe2968$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $2e632e7beefe2968$export$45902cc189596eef = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;

});

parcelRegister("8c7Hx", function(module, exports) {

$parcel$export(module.exports, "hashTypedData", function () { return $5f756b01ab253d40$export$9e2bd399d9aaab56; });
$parcel$export(module.exports, "hashDomain", function () { return $5f756b01ab253d40$export$d4e887b08c47faea; });
// Implementation forked and adapted from https://github.com/MetaMask/eth-sig-util/blob/main/src/sign-typed-data.ts

var $iqvwC = parcelRequire("iqvwC");

var $i9PPy = parcelRequire("i9PPy");

var $9Kb19 = parcelRequire("9Kb19");

var $9m1kr = parcelRequire("9m1kr");

var $kpFEJ = parcelRequire("kpFEJ");
function $5f756b01ab253d40$export$9e2bd399d9aaab56({ domain: domain_, message: message, primaryType: primaryType, types: types_ }) {
    const domain = typeof domain_ === "undefined" ? {} : domain_;
    const types = {
        EIP712Domain: (0, $kpFEJ.getTypesForEIP712Domain)({
            domain: domain
        }),
        ...types_
    };
    // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
    // as we can't statically check this with TypeScript.
    (0, $kpFEJ.validateTypedData)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    const parts = [
        "0x1901"
    ];
    if (domain) parts.push($5f756b01ab253d40$export$d4e887b08c47faea({
        domain: domain,
        types: types
    }));
    if (primaryType !== "EIP712Domain") parts.push($5f756b01ab253d40$var$hashStruct({
        data: message,
        primaryType: primaryType,
        types: types
    }));
    return (0, $9m1kr.keccak256)((0, $i9PPy.concat)(parts));
}
function $5f756b01ab253d40$export$d4e887b08c47faea({ domain: domain, types: types }) {
    return $5f756b01ab253d40$var$hashStruct({
        data: domain,
        primaryType: "EIP712Domain",
        types: types
    });
}
function $5f756b01ab253d40$var$hashStruct({ data: data, primaryType: primaryType, types: types }) {
    const encoded = $5f756b01ab253d40$var$encodeData({
        data: data,
        primaryType: primaryType,
        types: types
    });
    return (0, $9m1kr.keccak256)(encoded);
}
function $5f756b01ab253d40$var$encodeData({ data: data, primaryType: primaryType, types: types }) {
    const encodedTypes = [
        {
            type: "bytes32"
        }
    ];
    const encodedValues = [
        $5f756b01ab253d40$var$hashType({
            primaryType: primaryType,
            types: types
        })
    ];
    for (const field of types[primaryType]){
        const [type, value] = $5f756b01ab253d40$var$encodeField({
            types: types,
            name: field.name,
            type: field.type,
            value: data[field.name]
        });
        encodedTypes.push(type);
        encodedValues.push(value);
    }
    return (0, $iqvwC.encodeAbiParameters)(encodedTypes, encodedValues);
}
function $5f756b01ab253d40$var$hashType({ primaryType: primaryType, types: types }) {
    const encodedHashType = (0, $9Kb19.toHex)($5f756b01ab253d40$var$encodeType({
        primaryType: primaryType,
        types: types
    }));
    return (0, $9m1kr.keccak256)(encodedHashType);
}
function $5f756b01ab253d40$var$encodeType({ primaryType: primaryType, types: types }) {
    let result = "";
    const unsortedDeps = $5f756b01ab253d40$var$findTypeDependencies({
        primaryType: primaryType,
        types: types
    });
    unsortedDeps.delete(primaryType);
    const deps = [
        primaryType,
        ...Array.from(unsortedDeps).sort()
    ];
    for (const type of deps)result += `${type}(${types[type].map(({ name: name, type: t })=>`${t} ${name}`).join(",")})`;
    return result;
}
function $5f756b01ab253d40$var$findTypeDependencies({ primaryType: primaryType_, types: types }, results = new Set()) {
    const match = primaryType_.match(/^\w*/u);
    const primaryType = match?.[0];
    if (results.has(primaryType) || types[primaryType] === undefined) return results;
    results.add(primaryType);
    for (const field of types[primaryType])$5f756b01ab253d40$var$findTypeDependencies({
        primaryType: field.type,
        types: types
    }, results);
    return results;
}
function $5f756b01ab253d40$var$encodeField({ types: types, name: name, type: type, value: value }) {
    if (types[type] !== undefined) return [
        {
            type: "bytes32"
        },
        (0, $9m1kr.keccak256)($5f756b01ab253d40$var$encodeData({
            data: value,
            primaryType: type,
            types: types
        }))
    ];
    if (type === "bytes") {
        const prepend = value.length % 2 ? "0" : "";
        value = `0x${prepend + value.slice(2)}`;
        return [
            {
                type: "bytes32"
            },
            (0, $9m1kr.keccak256)(value)
        ];
    }
    if (type === "string") return [
        {
            type: "bytes32"
        },
        (0, $9m1kr.keccak256)((0, $9Kb19.toHex)(value))
    ];
    if (type.lastIndexOf("]") === type.length - 1) {
        const parsedType = type.slice(0, type.lastIndexOf("["));
        const typeValuePairs = value.map((item)=>$5f756b01ab253d40$var$encodeField({
                name: name,
                type: parsedType,
                types: types,
                value: item
            }));
        return [
            {
                type: "bytes32"
            },
            (0, $9m1kr.keccak256)((0, $iqvwC.encodeAbiParameters)(typeValuePairs.map(([t])=>t), typeValuePairs.map(([, v])=>v)))
        ];
    }
    return [
        {
            type: type
        },
        value
    ];
}

});



parcelRegister("joybz", function(module, exports) {

$parcel$export(module.exports, "switchChain", function () { return $e1eac6c065c21a5d$export$15599da40e72d2f; });

var $9Kb19 = parcelRequire("9Kb19");
async function $e1eac6c065c21a5d$export$15599da40e72d2f(client, { id: id }) {
    await client.request({
        method: "wallet_switchEthereumChain",
        params: [
            {
                chainId: (0, $9Kb19.numberToHex)(id)
            }
        ]
    });
}

});

parcelRegister("zTKTN", function(module, exports) {

$parcel$export(module.exports, "watchAsset", function () { return $06be84ddfc7e7938$export$7eea68d1a70548bd; });
/**
 * Adds an EVM chain to the wallet.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/watchAsset.html
 * - JSON-RPC Methods: [`eth_switchEthereumChain`](https://eips.ethereum.org/EIPS/eip-747)
 *
 * @param client - Client to use
 * @param parameters - {@link WatchAssetParameters}
 * @returns Boolean indicating if the token was successfully added. {@link WatchAssetReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { watchAsset } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const success = await watchAsset(client, {
 *   type: 'ERC20',
 *   options: {
 *     address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
 *     decimals: 18,
 *     symbol: 'WETH',
 *   },
 * })
 */ async function $06be84ddfc7e7938$export$7eea68d1a70548bd(client, params) {
    const added = await client.request({
        method: "wallet_watchAsset",
        params: params
    });
    return added;
}

});

parcelRegister("3Bki4", function(module, exports) {

$parcel$export(module.exports, "writeContract", function () { return $29f4911023604ab8$export$4c0f201bc17cbf23; });

var $93eGZ = parcelRequire("93eGZ");

var $i7oAr = parcelRequire("i7oAr");

var $g5KgQ = parcelRequire("g5KgQ");
async function $29f4911023604ab8$export$4c0f201bc17cbf23(client, { abi: abi, address: address, args: args, dataSuffix: dataSuffix, functionName: functionName, ...request }) {
    const data = (0, $93eGZ.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    const hash = await (0, $i7oAr.getAction)(client, (0, $g5KgQ.sendTransaction), "sendTransaction")({
        data: `${data}${dataSuffix ? dataSuffix.replace("0x", "") : ""}`,
        to: address,
        ...request
    });
    return hash;
}

});
parcelRegister("93eGZ", function(module, exports) {

$parcel$export(module.exports, "encodeFunctionData", function () { return $696fca7c16bced35$export$f4ee15df45da9f03; });

var $lXm9U = parcelRequire("lXm9U");

var $i9PPy = parcelRequire("i9PPy");

var $fPDSV = parcelRequire("fPDSV");

var $iqvwC = parcelRequire("iqvwC");

var $8nER6 = parcelRequire("8nER6");

var $7xdYH = parcelRequire("7xdYH");
function $696fca7c16bced35$export$f4ee15df45da9f03({ abi: abi, args: args, functionName: functionName }) {
    let abiItem = abi[0];
    if (functionName) {
        abiItem = (0, $7xdYH.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!abiItem) throw new (0, $lXm9U.AbiFunctionNotFoundError)(functionName, {
            docsPath: "/docs/contract/encodeFunctionData"
        });
    }
    if (abiItem.type !== "function") throw new (0, $lXm9U.AbiFunctionNotFoundError)(undefined, {
        docsPath: "/docs/contract/encodeFunctionData"
    });
    const definition = (0, $8nER6.formatAbiItem)(abiItem);
    const signature = (0, $fPDSV.getFunctionSelector)(definition);
    const data = "inputs" in abiItem && abiItem.inputs ? (0, $iqvwC.encodeAbiParameters)(abiItem.inputs, args ?? []) : undefined;
    return (0, $i9PPy.concatHex)([
        signature,
        data ?? "0x"
    ]);
}

});
parcelRegister("fPDSV", function(module, exports) {

$parcel$export(module.exports, "getFunctionSelector", function () { return $b86a8ebd1c81766a$export$98bae2de9b88fbac; });

var $66ShJ = parcelRequire("66ShJ");

var $dlz3r = parcelRequire("dlz3r");

var $kMsFU = parcelRequire("kMsFU");

var $9m1kr = parcelRequire("9m1kr");
const $b86a8ebd1c81766a$var$hash = (value)=>(0, $9m1kr.keccak256)((0, $dlz3r.toBytes)(value));
const $b86a8ebd1c81766a$export$98bae2de9b88fbac = (fn)=>(0, $66ShJ.slice)($b86a8ebd1c81766a$var$hash((0, $kMsFU.getFunctionSignature)(fn)), 0, 4);

});
parcelRegister("kMsFU", function(module, exports) {

$parcel$export(module.exports, "getFunctionSignature", function () { return $f20e8893378c78ff$export$d7a3ed3159f7637d; });

var $6J9eq = parcelRequire("6J9eq");

var $4LYRs = parcelRequire("4LYRs");
const $f20e8893378c78ff$export$d7a3ed3159f7637d = (fn_)=>{
    const fn = (()=>{
        if (typeof fn_ === "string") return fn_;
        return (0, $6J9eq.formatAbiItem)(fn_);
    })();
    return (0, $4LYRs.normalizeSignature)(fn);
};

});
parcelRegister("6J9eq", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", function () { return $4e5e1b3eca5c5629$export$dc5d0ff4fc2fdee1; });

var $2nlQK = parcelRequire("2nlQK");
function $4e5e1b3eca5c5629$export$dc5d0ff4fc2fdee1(abiItem) {
    if (abiItem.type === "function") return `function ${abiItem.name}(${(0, $2nlQK.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability && abiItem.stateMutability !== "nonpayable" ? ` ${abiItem.stateMutability}` : ""}${abiItem.outputs.length ? ` returns (${(0, $2nlQK.formatAbiParameters)(abiItem.outputs)})` : ""}`;
    else if (abiItem.type === "event") return `event ${abiItem.name}(${(0, $2nlQK.formatAbiParameters)(abiItem.inputs)})`;
    else if (abiItem.type === "error") return `error ${abiItem.name}(${(0, $2nlQK.formatAbiParameters)(abiItem.inputs)})`;
    else if (abiItem.type === "constructor") return `constructor(${(0, $2nlQK.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability === "payable" ? " payable" : ""}`;
    else if (abiItem.type === "fallback") return "fallback()";
    return "receive() external payable";
}

});
parcelRegister("2nlQK", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameters", function () { return $1baeada9203e30fd$export$c55dbda1a081631e; });

var $1zKcn = parcelRequire("1zKcn");
function $1baeada9203e30fd$export$c55dbda1a081631e(abiParameters) {
    let params = "";
    const length = abiParameters.length;
    for(let i = 0; i < length; i++){
        const abiParameter = abiParameters[i];
        params += (0, $1zKcn.formatAbiParameter)(abiParameter);
        if (i !== length - 1) params += ", ";
    }
    return params;
}

});
parcelRegister("1zKcn", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameter", function () { return $125ce566c0d2d2b5$export$c75e01ebc733dc6b; });

var $jmE2G = parcelRequire("jmE2G");
const $125ce566c0d2d2b5$var$tupleRegex = /^tuple(?<array>(\[(\d*)\])*)$/;
function $125ce566c0d2d2b5$export$c75e01ebc733dc6b(abiParameter) {
    let type = abiParameter.type;
    if ($125ce566c0d2d2b5$var$tupleRegex.test(abiParameter.type) && "components" in abiParameter) {
        type = "(";
        const length = abiParameter.components.length;
        for(let i = 0; i < length; i++){
            const component = abiParameter.components[i];
            type += $125ce566c0d2d2b5$export$c75e01ebc733dc6b(component);
            if (i < length - 1) type += ", ";
        }
        const result = (0, $jmE2G.execTyped)($125ce566c0d2d2b5$var$tupleRegex, abiParameter.type);
        type += `)${result?.array ?? ""}`;
        return $125ce566c0d2d2b5$export$c75e01ebc733dc6b({
            ...abiParameter,
            type: type
        });
    }
    if ("indexed" in abiParameter && abiParameter.indexed) type = `${type} indexed`;
    if (abiParameter.name) return `${type} ${abiParameter.name}`;
    return type;
}

});
parcelRegister("jmE2G", function(module, exports) {

$parcel$export(module.exports, "execTyped", function () { return $e18f21ee9fd6581b$export$1cca4755fb17f5bd; });
function $e18f21ee9fd6581b$export$1cca4755fb17f5bd(regex, string) {
    const match = regex.exec(string);
    return match?.groups;
}
const $e18f21ee9fd6581b$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $e18f21ee9fd6581b$export$45902cc189596eef = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
const $e18f21ee9fd6581b$export$5c1628af1434aed0 = /^\(.+?\).*?$/;

});




parcelRegister("4LYRs", function(module, exports) {

$parcel$export(module.exports, "normalizeSignature", function () { return $379ac2f908243a60$export$5cba87ebe4d0307a; });

var $hwGC1 = parcelRequire("hwGC1");
function $379ac2f908243a60$export$5cba87ebe4d0307a(signature) {
    let active = true;
    let current = "";
    let level = 0;
    let result = "";
    let valid = false;
    for(let i = 0; i < signature.length; i++){
        const char = signature[i];
        // If the character is a separator, we want to reactivate.
        if ([
            "(",
            ")",
            ","
        ].includes(char)) active = true;
        // If the character is a "level" token, we want to increment/decrement.
        if (char === "(") level++;
        if (char === ")") level--;
        // If we aren't active, we don't want to mutate the result.
        if (!active) continue;
        // If level === 0, we are at the definition level.
        if (level === 0) {
            if (char === " " && [
                "event",
                "function",
                ""
            ].includes(result)) result = "";
            else {
                result += char;
                // If we are at the end of the definition, we must be finished.
                if (char === ")") {
                    valid = true;
                    break;
                }
            }
            continue;
        }
        // Ignore spaces
        if (char === " ") {
            // If the previous character is a separator, and the current section isn't empty, we want to deactivate.
            if (signature[i - 1] !== "," && current !== "," && current !== ",(") {
                current = "";
                active = false;
            }
            continue;
        }
        result += char;
        current += char;
    }
    if (!valid) throw new (0, $hwGC1.BaseError)("Unable to normalize signature.");
    return result;
}

});



parcelRegister("7xdYH", function(module, exports) {

$parcel$export(module.exports, "getAbiItem", function () { return $57c6753ab92faa28$export$99b134cd177e9574; });


var $lXm9U = parcelRequire("lXm9U");

var $6zhhe = parcelRequire("6zhhe");

var $jAqrc = parcelRequire("jAqrc");

var $fPDSV = parcelRequire("fPDSV");

var $fDHPo = parcelRequire("fDHPo");
function $57c6753ab92faa28$export$99b134cd177e9574({ abi: abi, args: args = [], name: name }) {
    const isSelector = (0, $6zhhe.isHex)(name, {
        strict: false
    });
    const abiItems = abi.filter((abiItem)=>{
        if (isSelector) {
            if (abiItem.type === "function") return (0, $fPDSV.getFunctionSelector)(abiItem) === name;
            if (abiItem.type === "event") return (0, $jAqrc.getEventSelector)(abiItem) === name;
            return false;
        }
        return "name" in abiItem && abiItem.name === name;
    });
    if (abiItems.length === 0) return undefined;
    if (abiItems.length === 1) return abiItems[0];
    let matchedAbiItem = undefined;
    for (const abiItem of abiItems){
        if (!("inputs" in abiItem)) continue;
        if (!args || args.length === 0) {
            if (!abiItem.inputs || abiItem.inputs.length === 0) return abiItem;
            continue;
        }
        if (!abiItem.inputs) continue;
        if (abiItem.inputs.length === 0) continue;
        if (abiItem.inputs.length !== args.length) continue;
        const matched = args.every((arg, index)=>{
            const abiParameter = "inputs" in abiItem && abiItem.inputs[index];
            if (!abiParameter) return false;
            return $57c6753ab92faa28$export$697eff86d182a8c1(arg, abiParameter);
        });
        if (matched) {
            // Check for ambiguity against already matched parameters (e.g. `address` vs `bytes20`).
            if (matchedAbiItem && "inputs" in matchedAbiItem && matchedAbiItem.inputs) {
                const ambiguousTypes = $57c6753ab92faa28$export$79fd08820d2778aa(abiItem.inputs, matchedAbiItem.inputs, args);
                if (ambiguousTypes) throw new (0, $lXm9U.AbiItemAmbiguityError)({
                    abiItem: abiItem,
                    type: ambiguousTypes[0]
                }, {
                    abiItem: matchedAbiItem,
                    type: ambiguousTypes[1]
                });
            }
            matchedAbiItem = abiItem;
        }
    }
    if (matchedAbiItem) return matchedAbiItem;
    return abiItems[0];
}
function $57c6753ab92faa28$export$697eff86d182a8c1(arg, abiParameter) {
    const argType = typeof arg;
    const abiParameterType = abiParameter.type;
    switch(abiParameterType){
        case "address":
            return (0, $fDHPo.isAddress)(arg);
        case "bool":
            return argType === "boolean";
        case "function":
            return argType === "string";
        case "string":
            return argType === "string";
        default:
            if (abiParameterType === "tuple" && "components" in abiParameter) return Object.values(abiParameter.components).every((component, index)=>{
                return $57c6753ab92faa28$export$697eff86d182a8c1(Object.values(arg)[index], component);
            });
            // `(u)int<M>`: (un)signed integer type of `M` bits, `0 < M <= 256`, `M % 8 == 0`
            // https://regexr.com/6v8hp
            if (/^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(abiParameterType)) return argType === "number" || argType === "bigint";
            // `bytes<M>`: binary type of `M` bytes, `0 < M <= 32`
            // https://regexr.com/6va55
            if (/^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(abiParameterType)) return argType === "string" || arg instanceof Uint8Array;
            // fixed-length (`<type>[M]`) and dynamic (`<type>[]`) arrays
            // https://regexr.com/6va6i
            if (/[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(abiParameterType)) return Array.isArray(arg) && arg.every((x)=>$57c6753ab92faa28$export$697eff86d182a8c1(x, {
                    ...abiParameter,
                    // Pop off `[]` or `[M]` from end of type
                    type: abiParameterType.replace(/(\[[0-9]{0,}\])$/, "")
                }));
            return false;
    }
}
function $57c6753ab92faa28$export$79fd08820d2778aa(sourceParameters, targetParameters, args) {
    for(const parameterIndex in sourceParameters){
        const sourceParameter = sourceParameters[parameterIndex];
        const targetParameter = targetParameters[parameterIndex];
        if (sourceParameter.type === "tuple" && targetParameter.type === "tuple" && "components" in sourceParameter && "components" in targetParameter) return $57c6753ab92faa28$export$79fd08820d2778aa(sourceParameter.components, targetParameter.components, args[parameterIndex]);
        const types = [
            sourceParameter.type,
            targetParameter.type
        ];
        const ambiguous = (()=>{
            if (types.includes("address") && types.includes("bytes20")) return true;
            if (types.includes("address") && types.includes("string")) return (0, $fDHPo.isAddress)(args[parameterIndex]);
            if (types.includes("address") && types.includes("bytes")) return (0, $fDHPo.isAddress)(args[parameterIndex]);
            return false;
        })();
        if (ambiguous) return types;
    }
    return;
}

});
parcelRegister("jAqrc", function(module, exports) {

$parcel$export(module.exports, "getEventSelector", function () { return $e425e318b1a83b25$export$199f4d2b0dfd4569; });

var $dlz3r = parcelRequire("dlz3r");

var $g6pl1 = parcelRequire("g6pl1");

var $9m1kr = parcelRequire("9m1kr");
const $e425e318b1a83b25$var$hash = (value)=>(0, $9m1kr.keccak256)((0, $dlz3r.toBytes)(value));
const $e425e318b1a83b25$export$199f4d2b0dfd4569 = (fn)=>$e425e318b1a83b25$var$hash((0, $g6pl1.getEventSignature)(fn));

});
parcelRegister("g6pl1", function(module, exports) {

$parcel$export(module.exports, "getEventSignature", function () { return $bb90dc79171d7c6f$export$8edf22f667ee2562; });

var $kMsFU = parcelRequire("kMsFU");
const $bb90dc79171d7c6f$export$8edf22f667ee2562 = (fn)=>{
    return (0, $kMsFU.getFunctionSignature)(fn);
};

});







parcelRegister("ng60n", function(module, exports) {

$parcel$export(module.exports, "custom", function () { return $045ea26622df0288$export$4c00f665f0d4b443; });

var $70vH0 = parcelRequire("70vH0");
function $045ea26622df0288$export$4c00f665f0d4b443(provider, config = {}) {
    const { key: key = "custom", name: name = "Custom Provider", retryDelay: retryDelay } = config;
    return ({ retryCount: defaultRetryCount })=>(0, $70vH0.createTransport)({
            key: key,
            name: name,
            request: provider.request.bind(provider),
            retryCount: config.retryCount ?? defaultRetryCount,
            retryDelay: retryDelay,
            type: "custom"
        });
}

});
parcelRegister("70vH0", function(module, exports) {

$parcel$export(module.exports, "createTransport", function () { return $51a11e0214a89d64$export$d09f50d9ab7f7b69; });

var $cgkN7 = parcelRequire("cgkN7");
function $51a11e0214a89d64$export$d09f50d9ab7f7b69({ key: key, name: name, request: request, retryCount: retryCount = 3, retryDelay: retryDelay = 150, timeout: timeout, type: type }, value) {
    return {
        config: {
            key: key,
            name: name,
            request: request,
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: type
        },
        request: (0, $cgkN7.buildRequest)(request, {
            retryCount: retryCount,
            retryDelay: retryDelay
        }),
        value: value
    };
}

});
parcelRegister("cgkN7", function(module, exports) {

$parcel$export(module.exports, "isDeterministicError", function () { return $8ed71b616ce7ea68$export$9c98b0fe9b5c1674; });
$parcel$export(module.exports, "buildRequest", function () { return $8ed71b616ce7ea68$export$6c5295ef7e82f2b2; });

var $hwGC1 = parcelRequire("hwGC1");

var $fG0ph = parcelRequire("fG0ph");

var $e2aBg = parcelRequire("e2aBg");

var $iLYpU = parcelRequire("iLYpU");
const $8ed71b616ce7ea68$export$9c98b0fe9b5c1674 = (error)=>{
    if ("code" in error) return error.code !== -1 && error.code !== -32004 && error.code !== -32005 && error.code !== -32042 && error.code !== -32603;
    if (error instanceof (0, $fG0ph.HttpRequestError) && error.status) return error.status !== 403 && error.status !== 408 && error.status !== 413 && error.status !== 429 && error.status !== 500 && error.status !== 502 && error.status !== 503 && error.status !== 504;
    return false;
};
function $8ed71b616ce7ea68$export$6c5295ef7e82f2b2(request, { retryDelay: retryDelay = 150, retryCount: retryCount = 3 } = {}) {
    return async (args)=>(0, $iLYpU.withRetry)(async ()=>{
            try {
                return await request(args);
            } catch (err_) {
                const err = err_;
                switch(err.code){
                    // -32700
                    case (0, $e2aBg.ParseRpcError).code:
                        throw new (0, $e2aBg.ParseRpcError)(err);
                    // -32600
                    case (0, $e2aBg.InvalidRequestRpcError).code:
                        throw new (0, $e2aBg.InvalidRequestRpcError)(err);
                    // -32601
                    case (0, $e2aBg.MethodNotFoundRpcError).code:
                        throw new (0, $e2aBg.MethodNotFoundRpcError)(err);
                    // -32602
                    case (0, $e2aBg.InvalidParamsRpcError).code:
                        throw new (0, $e2aBg.InvalidParamsRpcError)(err);
                    // -32603
                    case (0, $e2aBg.InternalRpcError).code:
                        throw new (0, $e2aBg.InternalRpcError)(err);
                    // -32000
                    case (0, $e2aBg.InvalidInputRpcError).code:
                        throw new (0, $e2aBg.InvalidInputRpcError)(err);
                    // -32001
                    case (0, $e2aBg.ResourceNotFoundRpcError).code:
                        throw new (0, $e2aBg.ResourceNotFoundRpcError)(err);
                    // -32002
                    case (0, $e2aBg.ResourceUnavailableRpcError).code:
                        throw new (0, $e2aBg.ResourceUnavailableRpcError)(err);
                    // -32003
                    case (0, $e2aBg.TransactionRejectedRpcError).code:
                        throw new (0, $e2aBg.TransactionRejectedRpcError)(err);
                    // -32004
                    case (0, $e2aBg.MethodNotSupportedRpcError).code:
                        throw new (0, $e2aBg.MethodNotSupportedRpcError)(err);
                    // -32005
                    case (0, $e2aBg.LimitExceededRpcError).code:
                        throw new (0, $e2aBg.LimitExceededRpcError)(err);
                    // -32006
                    case (0, $e2aBg.JsonRpcVersionUnsupportedError).code:
                        throw new (0, $e2aBg.JsonRpcVersionUnsupportedError)(err);
                    // 4001
                    case (0, $e2aBg.UserRejectedRequestError).code:
                        throw new (0, $e2aBg.UserRejectedRequestError)(err);
                    // 4100
                    case (0, $e2aBg.UnauthorizedProviderError).code:
                        throw new (0, $e2aBg.UnauthorizedProviderError)(err);
                    // 4200
                    case (0, $e2aBg.UnsupportedProviderMethodError).code:
                        throw new (0, $e2aBg.UnsupportedProviderMethodError)(err);
                    // 4900
                    case (0, $e2aBg.ProviderDisconnectedError).code:
                        throw new (0, $e2aBg.ProviderDisconnectedError)(err);
                    // 4901
                    case (0, $e2aBg.ChainDisconnectedError).code:
                        throw new (0, $e2aBg.ChainDisconnectedError)(err);
                    // 4902
                    case (0, $e2aBg.SwitchChainError).code:
                        throw new (0, $e2aBg.SwitchChainError)(err);
                    // CAIP-25: User Rejected Error
                    // https://docs.walletconnect.com/2.0/specs/clients/sign/error-codes#rejected-caip-25
                    case 5000:
                        throw new (0, $e2aBg.UserRejectedRequestError)(err);
                    default:
                        if (err_ instanceof (0, $hwGC1.BaseError)) throw err_;
                        throw new (0, $e2aBg.UnknownRpcError)(err);
                }
            }
        }, {
            delay: ({ count: count, error: error })=>{
                // If we find a Retry-After header, let's retry after the given time.
                if (error && error instanceof (0, $fG0ph.HttpRequestError)) {
                    const retryAfter = error?.headers?.get("Retry-After");
                    if (retryAfter?.match(/\d/)) return parseInt(retryAfter) * 1000;
                }
                // Otherwise, let's retry with an exponential backoff.
                return ~~(1 << count) * retryDelay;
            },
            retryCount: retryCount,
            shouldRetry: ({ error: error })=>!$8ed71b616ce7ea68$export$9c98b0fe9b5c1674(error)
        });
}

});
parcelRegister("iLYpU", function(module, exports) {

$parcel$export(module.exports, "withRetry", function () { return $daab7b4c7c0f3914$export$188df5ecf8e7961a; });

var $16glA = parcelRequire("16glA");
function $daab7b4c7c0f3914$export$188df5ecf8e7961a(fn, { delay: delay_ = 100, retryCount: retryCount = 2, shouldRetry: shouldRetry = ()=>true } = {}) {
    return new Promise((resolve, reject)=>{
        const attemptRetry = async ({ count: count = 0 } = {})=>{
            const retry = async ({ error: error })=>{
                const delay = typeof delay_ === "function" ? delay_({
                    count: count,
                    error: error
                }) : delay_;
                if (delay) await (0, $16glA.wait)(delay);
                attemptRetry({
                    count: count + 1
                });
            };
            try {
                const data = await fn();
                resolve(data);
            } catch (err) {
                if (count < retryCount && await shouldRetry({
                    count: count,
                    error: err
                })) return retry({
                    error: err
                });
                reject(err);
            }
        };
        attemptRetry();
    });
}

});
parcelRegister("16glA", function(module, exports) {

$parcel$export(module.exports, "wait", function () { return $0cd30831cce9389f$export$5c069c93d2b7493f; });
async function $0cd30831cce9389f$export$5c069c93d2b7493f(time) {
    return new Promise((res)=>setTimeout(res, time));
}

});






parcelRegister("bWsgL", function(module, exports) {

$parcel$export(module.exports, "__privateGet", function () { return $8b1b0a30ee503c90$export$18a094aefa070634; });
$parcel$export(module.exports, "__privateAdd", function () { return $8b1b0a30ee503c90$export$addf369becd23283; });
$parcel$export(module.exports, "__privateSet", function () { return $8b1b0a30ee503c90$export$42432efe6614d3b4; });
$parcel$export(module.exports, "__privateMethod", function () { return $8b1b0a30ee503c90$export$fa92d15b718fce20; });
var $8b1b0a30ee503c90$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $8b1b0a30ee503c90$export$18a094aefa070634 = (obj, member, getter)=>{
    $8b1b0a30ee503c90$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $8b1b0a30ee503c90$export$addf369becd23283 = (obj, member, value)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var $8b1b0a30ee503c90$export$42432efe6614d3b4 = (obj, member, value, setter)=>{
    $8b1b0a30ee503c90$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value) : member.set(obj, value);
    return value;
};
var $8b1b0a30ee503c90$export$fa92d15b718fce20 = (obj, member, method)=>{
    $8b1b0a30ee503c90$var$__accessCheck(obj, member, "access private method");
    return method;
};

});

parcelRegister("3iWI0", function(module, exports) {

$parcel$export(module.exports, "CallExecutionError", function () { return $268097dafa90a6ab$export$e67b04e2cd29b7d; });
$parcel$export(module.exports, "ContractFunctionExecutionError", function () { return $268097dafa90a6ab$export$399e62fddbe24423; });
$parcel$export(module.exports, "ContractFunctionRevertedError", function () { return $268097dafa90a6ab$export$b3a6b9663001535f; });
$parcel$export(module.exports, "ContractFunctionZeroDataError", function () { return $268097dafa90a6ab$export$46f5208cdcd5a621; });
$parcel$export(module.exports, "RawContractError", function () { return $268097dafa90a6ab$export$5b877bc4d7d9d460; });

var $gbMK7 = parcelRequire("gbMK7");

var $kNjur = parcelRequire("kNjur");

var $5VePG = parcelRequire("5VePG");

var $8nER6 = parcelRequire("8nER6");

var $9d7ac = parcelRequire("9d7ac");

var $7xdYH = parcelRequire("7xdYH");

var $c6heD = parcelRequire("c6heD");

var $80APP = parcelRequire("80APP");

var $lXm9U = parcelRequire("lXm9U");

var $hwGC1 = parcelRequire("hwGC1");

var $8M4GY = parcelRequire("8M4GY");

var $d9Nve = parcelRequire("d9Nve");
class $268097dafa90a6ab$export$e67b04e2cd29b7d extends (0, $hwGC1.BaseError) {
    constructor(cause, { account: account_, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }){
        const account = account_ ? (0, $gbMK7.parseAccount)(account_) : undefined;
        const prettyArgs = (0, $8M4GY.prettyPrint)({
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $c6heD.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $80APP.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $80APP.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $80APP.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Raw Call Arguments:",
                prettyArgs
            ].filter(Boolean)
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "CallExecutionError"
        });
        this.cause = cause;
    }
}
class $268097dafa90a6ab$export$399e62fddbe24423 extends (0, $hwGC1.BaseError) {
    constructor(cause, { abi: abi, args: args, contractAddress: contractAddress, docsPath: docsPath, functionName: functionName, sender: sender }){
        const abiItem = (0, $7xdYH.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        const formattedArgs = abiItem ? (0, $9d7ac.formatAbiItemWithArgs)({
            abiItem: abiItem,
            args: args,
            includeFunctionName: false,
            includeName: false
        }) : undefined;
        const functionWithParams = abiItem ? (0, $8nER6.formatAbiItem)(abiItem, {
            includeName: true
        }) : undefined;
        const prettyArgs = (0, $8M4GY.prettyPrint)({
            address: contractAddress && (0, $d9Nve.getContractAddress)(contractAddress),
            function: functionWithParams,
            args: formattedArgs && formattedArgs !== "()" && `${[
                ...Array(functionName?.length ?? 0).keys()
            ].map(()=>" ").join("")}${formattedArgs}`,
            sender: sender
        });
        super(cause.shortMessage || `An unknown error occurred while executing the contract function "${functionName}".`, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Contract Call:",
                prettyArgs
            ].filter(Boolean)
        });
        Object.defineProperty(this, "abi", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "args", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contractAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "formattedArgs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "functionName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sender", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ContractFunctionExecutionError"
        });
        this.abi = abi;
        this.args = args;
        this.cause = cause;
        this.contractAddress = contractAddress;
        this.functionName = functionName;
        this.sender = sender;
    }
}
class $268097dafa90a6ab$export$b3a6b9663001535f extends (0, $hwGC1.BaseError) {
    constructor({ abi: abi, data: data, functionName: functionName, message: message }){
        let cause;
        let decodedData = undefined;
        let metaMessages;
        let reason;
        if (data && data !== "0x") try {
            decodedData = (0, $5VePG.decodeErrorResult)({
                abi: abi,
                data: data
            });
            const { abiItem: abiItem, errorName: errorName, args: errorArgs } = decodedData;
            if (errorName === "Error") reason = errorArgs[0];
            else if (errorName === "Panic") {
                const [firstArg] = errorArgs;
                reason = (0, $kNjur.panicReasons)[firstArg];
            } else {
                const errorWithParams = abiItem ? (0, $8nER6.formatAbiItem)(abiItem, {
                    includeName: true
                }) : undefined;
                const formattedArgs = abiItem && errorArgs ? (0, $9d7ac.formatAbiItemWithArgs)({
                    abiItem: abiItem,
                    args: errorArgs,
                    includeFunctionName: false,
                    includeName: false
                }) : undefined;
                metaMessages = [
                    errorWithParams ? `Error: ${errorWithParams}` : "",
                    formattedArgs && formattedArgs !== "()" ? `       ${[
                        ...Array(errorName?.length ?? 0).keys()
                    ].map(()=>" ").join("")}${formattedArgs}` : ""
                ];
            }
        } catch (err) {
            cause = err;
        }
        else if (message) reason = message;
        let signature;
        if (cause instanceof (0, $lXm9U.AbiErrorSignatureNotFoundError)) {
            signature = cause.signature;
            metaMessages = [
                `Unable to decode signature "${signature}" as it was not found on the provided ABI.`,
                "Make sure you are using the correct ABI and that the error exists on it.",
                `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`
            ];
        }
        super(reason && reason !== "execution reverted" || signature ? [
            `The contract function "${functionName}" reverted with the following ${signature ? "signature" : "reason"}:`,
            reason || signature
        ].join("\n") : `The contract function "${functionName}" reverted.`, {
            cause: cause,
            metaMessages: metaMessages
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ContractFunctionRevertedError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reason", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = decodedData;
        this.reason = reason;
        this.signature = signature;
    }
}
class $268097dafa90a6ab$export$46f5208cdcd5a621 extends (0, $hwGC1.BaseError) {
    constructor({ functionName: functionName }){
        super(`The contract function "${functionName}" returned no data ("0x").`, {
            metaMessages: [
                "This could be due to any of the following:",
                `  - The contract does not have the function "${functionName}",`,
                "  - The parameters passed to the contract function may be invalid, or",
                "  - The address is not a contract."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ContractFunctionZeroDataError"
        });
    }
}
class $268097dafa90a6ab$export$5b877bc4d7d9d460 extends (0, $hwGC1.BaseError) {
    constructor({ data: data, message: message }){
        super(message || "");
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 3
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "RawContractError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
    }
}

});
parcelRegister("kNjur", function(module, exports) {

$parcel$export(module.exports, "panicReasons", function () { return $f237808d8b9d131f$export$a618024566d3d221; });
$parcel$export(module.exports, "solidityError", function () { return $f237808d8b9d131f$export$730e9cc7aaa8ca20; });
$parcel$export(module.exports, "solidityPanic", function () { return $f237808d8b9d131f$export$e45b3aea1c5b33e6; });
// https://docs.soliditylang.org/en/v0.8.16/control-structures.html#panic-via-assert-and-error-via-require
const $f237808d8b9d131f$export$a618024566d3d221 = {
    1: "An `assert` condition failed.",
    17: "Arithmic operation resulted in underflow or overflow.",
    18: "Division or modulo by zero (e.g. `5 / 0` or `23 % 0`).",
    33: "Attempted to convert to an invalid type.",
    34: "Attempted to access a storage byte array that is incorrectly encoded.",
    49: "Performed `.pop()` on an empty array",
    50: "Array index is out of bounds.",
    65: "Allocated too much memory or created an array which is too large.",
    81: "Attempted to call a zero-initialized variable of internal function type."
};
const $f237808d8b9d131f$export$730e9cc7aaa8ca20 = {
    inputs: [
        {
            name: "message",
            type: "string"
        }
    ],
    name: "Error",
    type: "error"
};
const $f237808d8b9d131f$export$e45b3aea1c5b33e6 = {
    inputs: [
        {
            name: "reason",
            type: "uint256"
        }
    ],
    name: "Panic",
    type: "error"
};

});

parcelRegister("5VePG", function(module, exports) {

$parcel$export(module.exports, "decodeErrorResult", function () { return $44fdc810498bc4e8$export$8f7898b7bcae6080; });

var $kNjur = parcelRequire("kNjur");

var $lXm9U = parcelRequire("lXm9U");

var $66ShJ = parcelRequire("66ShJ");

var $fPDSV = parcelRequire("fPDSV");

var $hEJzf = parcelRequire("hEJzf");

var $8nER6 = parcelRequire("8nER6");
function $44fdc810498bc4e8$export$8f7898b7bcae6080({ abi: abi, data: data }) {
    const signature = (0, $66ShJ.slice)(data, 0, 4);
    if (signature === "0x") throw new (0, $lXm9U.AbiDecodingZeroDataError)();
    const abi_ = [
        ...abi || [],
        (0, $kNjur.solidityError),
        (0, $kNjur.solidityPanic)
    ];
    const abiItem = abi_.find((x)=>x.type === "error" && signature === (0, $fPDSV.getFunctionSelector)((0, $8nER6.formatAbiItem)(x)));
    if (!abiItem) throw new (0, $lXm9U.AbiErrorSignatureNotFoundError)(signature, {
        docsPath: "/docs/contract/decodeErrorResult"
    });
    return {
        abiItem: abiItem,
        args: "inputs" in abiItem && abiItem.inputs && abiItem.inputs.length > 0 ? (0, $hEJzf.decodeAbiParameters)(abiItem.inputs, (0, $66ShJ.slice)(data, 4)) : undefined,
        errorName: abiItem.name
    };
}

});
parcelRegister("hEJzf", function(module, exports) {

$parcel$export(module.exports, "decodeAbiParameters", function () { return $cda984dcf7889236$export$84d51ac2fffabd56; });

var $lXm9U = parcelRequire("lXm9U");

var $1r7Xu = parcelRequire("1r7Xu");

var $5pLNq = parcelRequire("5pLNq");

var $66ShJ = parcelRequire("66ShJ");

var $ea0vD = parcelRequire("ea0vD");

var $hiAQY = parcelRequire("hiAQY");

var $iqvwC = parcelRequire("iqvwC");
function $cda984dcf7889236$export$84d51ac2fffabd56(params, data) {
    if (data === "0x" && params.length > 0) throw new (0, $lXm9U.AbiDecodingZeroDataError)();
    if ((0, $5pLNq.size)(data) && (0, $5pLNq.size)(data) < 32) throw new (0, $lXm9U.AbiDecodingDataSizeTooSmallError)({
        data: data,
        params: params,
        size: (0, $5pLNq.size)(data)
    });
    return $cda984dcf7889236$var$decodeParams({
        data: data,
        params: params
    });
}
function $cda984dcf7889236$var$decodeParams({ data: data, params: params }) {
    const decodedValues = [];
    let position = 0;
    for(let i = 0; i < params.length; i++){
        if (position >= (0, $5pLNq.size)(data)) throw new (0, $lXm9U.AbiDecodingDataSizeTooSmallError)({
            data: data,
            params: params,
            size: (0, $5pLNq.size)(data)
        });
        const param = params[i];
        const { consumed: consumed, value: value } = $cda984dcf7889236$var$decodeParam({
            data: data,
            param: param,
            position: position
        });
        decodedValues.push(value);
        // Step across the data by the amount of data consumed by this parameter.
        position += consumed;
    }
    return decodedValues;
}
function $cda984dcf7889236$var$decodeParam({ data: data, param: param, position: position }) {
    const arrayComponents = (0, $iqvwC.getArrayComponents)(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $cda984dcf7889236$var$decodeArray(data, {
            length: length,
            param: {
                ...param,
                type: type
            },
            position: position
        });
    }
    if (param.type === "tuple") return $cda984dcf7889236$var$decodeTuple(data, {
        param: param,
        position: position
    });
    if (param.type === "string") return $cda984dcf7889236$var$decodeString(data, {
        position: position
    });
    if (param.type.startsWith("bytes")) return $cda984dcf7889236$var$decodeBytes(data, {
        param: param,
        position: position
    });
    const value = (0, $66ShJ.slice)(data, position, position + 32, {
        strict: true
    });
    if (param.type.startsWith("uint") || param.type.startsWith("int")) return $cda984dcf7889236$var$decodeNumber(value, {
        param: param
    });
    if (param.type === "address") return $cda984dcf7889236$var$decodeAddress(value);
    if (param.type === "bool") return $cda984dcf7889236$var$decodeBool(value);
    throw new (0, $lXm9U.InvalidAbiDecodingTypeError)(param.type, {
        docsPath: "/docs/contract/decodeAbiParameters"
    });
}
function $cda984dcf7889236$var$decodeAddress(value) {
    return {
        consumed: 32,
        value: (0, $1r7Xu.checksumAddress)((0, $66ShJ.slice)(value, -20))
    };
}
function $cda984dcf7889236$var$decodeArray(data, { param: param, length: length, position: position }) {
    // If the length of the array is not known in advance (dynamic array),
    // we will need to decode the offset of the array data.
    if (!length) {
        // Get the offset of the array data.
        const offset = (0, $hiAQY.hexToNumber)((0, $66ShJ.slice)(data, position, position + 32, {
            strict: true
        }));
        // Get the length of the array from the offset.
        const length = (0, $hiAQY.hexToNumber)((0, $66ShJ.slice)(data, offset, offset + 32, {
            strict: true
        }));
        let consumed = 0;
        const value = [];
        for(let i = 0; i < length; ++i){
            const decodedChild = $cda984dcf7889236$var$decodeParam({
                data: (0, $66ShJ.slice)(data, offset + 32),
                param: param,
                position: consumed
            });
            consumed += decodedChild.consumed;
            value.push(decodedChild.value);
        }
        return {
            value: value,
            consumed: 32
        };
    }
    // If the length of the array is known in advance,
    // and the length of an element deeply nested in the array is not known,
    // we need to decode the offset of the array data.
    if ($cda984dcf7889236$var$hasDynamicChild(param)) {
        // Get the child type of the array.
        const arrayComponents = (0, $iqvwC.getArrayComponents)(param.type);
        // If the child type is not known, the array is dynamic.
        const dynamicChild = !arrayComponents?.[0];
        let consumed = 0;
        const value = [];
        for(let i = 0; i < length; ++i){
            const offset = (0, $hiAQY.hexToNumber)((0, $66ShJ.slice)(data, position, position + 32, {
                strict: true
            }));
            const decodedChild = $cda984dcf7889236$var$decodeParam({
                data: (0, $66ShJ.slice)(data, offset),
                param: param,
                position: dynamicChild ? consumed : i * 32
            });
            consumed += decodedChild.consumed;
            value.push(decodedChild.value);
        }
        return {
            value: value,
            consumed: 32
        };
    }
    // If the length of the array is known in advance,
    // and the length of each element in the array is known,
    // the array data is encoded contiguously after the array.
    let consumed = 0;
    const value = [];
    for(let i = 0; i < length; ++i){
        const decodedChild = $cda984dcf7889236$var$decodeParam({
            data: data,
            param: param,
            position: position + consumed
        });
        consumed += decodedChild.consumed;
        value.push(decodedChild.value);
    }
    return {
        value: value,
        consumed: consumed
    };
}
function $cda984dcf7889236$var$decodeBool(value) {
    return {
        consumed: 32,
        value: (0, $hiAQY.hexToBool)(value)
    };
}
function $cda984dcf7889236$var$decodeBytes(data, { param: param, position: position }) {
    const [_, size] = param.type.split("bytes");
    if (!size) {
        // If we don't have a size, we're dealing with a dynamic-size array
        // so we need to read the offset of the data part first.
        const offset = (0, $hiAQY.hexToNumber)((0, $66ShJ.slice)(data, position, position + 32, {
            strict: true
        }));
        const length = (0, $hiAQY.hexToNumber)((0, $66ShJ.slice)(data, offset, offset + 32, {
            strict: true
        }));
        // If there is no length, we have zero data.
        if (length === 0) return {
            consumed: 32,
            value: "0x"
        };
        const value = (0, $66ShJ.slice)(data, offset + 32, offset + 32 + length, {
            strict: true
        });
        return {
            consumed: 32,
            value: value
        };
    }
    const value = (0, $66ShJ.slice)(data, position, position + parseInt(size), {
        strict: true
    });
    return {
        consumed: 32,
        value: value
    };
}
function $cda984dcf7889236$var$decodeNumber(value, { param: param }) {
    const signed = param.type.startsWith("int");
    const size = parseInt(param.type.split("int")[1] || "256");
    return {
        consumed: 32,
        value: size > 48 ? (0, $hiAQY.hexToBigInt)(value, {
            signed: signed
        }) : (0, $hiAQY.hexToNumber)(value, {
            signed: signed
        })
    };
}
function $cda984dcf7889236$var$decodeString(data, { position: position }) {
    const offset = (0, $hiAQY.hexToNumber)((0, $66ShJ.slice)(data, position, position + 32, {
        strict: true
    }));
    const length = (0, $hiAQY.hexToNumber)((0, $66ShJ.slice)(data, offset, offset + 32, {
        strict: true
    }));
    // If there is no length, we have zero data (empty string).
    if (length === 0) return {
        consumed: 32,
        value: ""
    };
    const value = (0, $hiAQY.hexToString)((0, $ea0vD.trim)((0, $66ShJ.slice)(data, offset + 32, offset + 32 + length, {
        strict: true
    })));
    return {
        consumed: 32,
        value: value
    };
}
function $cda984dcf7889236$var$decodeTuple(data, { param: param, position: position }) {
    // Tuples can have unnamed components (i.e. they are arrays), so we must
    // determine whether the tuple is named or unnamed. In the case of a named
    // tuple, the value will be an object where each property is the name of the
    // component. In the case of an unnamed tuple, the value will be an array.
    const hasUnnamedChild = param.components.length === 0 || param.components.some(({ name: name })=>!name);
    // Initialize the value to an object or an array, depending on whether the
    // tuple is named or unnamed.
    const value = hasUnnamedChild ? [] : {};
    let consumed = 0;
    // If the tuple has a dynamic child, we must first decode the offset to the
    // tuple data.
    if ($cda984dcf7889236$var$hasDynamicChild(param)) {
        const offset = (0, $hiAQY.hexToNumber)((0, $66ShJ.slice)(data, position, position + 32, {
            strict: true
        }));
        // Decode each component of the tuple, starting at the offset.
        for(let i = 0; i < param.components.length; ++i){
            const component = param.components[i];
            const decodedChild = $cda984dcf7889236$var$decodeParam({
                data: (0, $66ShJ.slice)(data, offset),
                param: component,
                position: consumed
            });
            consumed += decodedChild.consumed;
            value[hasUnnamedChild ? i : component?.name] = decodedChild.value;
        }
        return {
            consumed: 32,
            value: value
        };
    }
    // If the tuple has static children, we can just decode each component
    // in sequence.
    for(let i = 0; i < param.components.length; ++i){
        const component = param.components[i];
        const decodedChild = $cda984dcf7889236$var$decodeParam({
            data: data,
            param: component,
            position: position + consumed
        });
        consumed += decodedChild.consumed;
        value[hasUnnamedChild ? i : component?.name] = decodedChild.value;
    }
    return {
        consumed: consumed,
        value: value
    };
}
function $cda984dcf7889236$var$hasDynamicChild(param) {
    const { type: type } = param;
    if (type === "string") return true;
    if (type === "bytes") return true;
    if (type.endsWith("[]")) return true;
    if (type === "tuple") return param.components?.some($cda984dcf7889236$var$hasDynamicChild);
    const arrayComponents = (0, $iqvwC.getArrayComponents)(param.type);
    if (arrayComponents && $cda984dcf7889236$var$hasDynamicChild({
        ...param,
        type: arrayComponents[1]
    })) return true;
    return false;
}

});


parcelRegister("9d7ac", function(module, exports) {

$parcel$export(module.exports, "formatAbiItemWithArgs", function () { return $6b4ae2794241ba48$export$5266ec2b0e3e9205; });

var $peKQ1 = parcelRequire("peKQ1");
function $6b4ae2794241ba48$export$5266ec2b0e3e9205({ abiItem: abiItem, args: args, includeFunctionName: includeFunctionName = true, includeName: includeName = false }) {
    if (!("name" in abiItem)) return;
    if (!("inputs" in abiItem)) return;
    if (!abiItem.inputs) return;
    return `${includeFunctionName ? abiItem.name : ""}(${abiItem.inputs.map((input, i)=>`${includeName && input.name ? `${input.name}: ` : ""}${typeof args[i] === "object" ? (0, $peKQ1.stringify)(args[i]) : args[i]}`).join(", ")})`;
}

});


parcelRegister("4wsgh", function(module, exports) {

$parcel$export(module.exports, "createPublicClient", function () { return $34b012c0d383843f$export$d8e090d8c6a7a6ad; });

var $1HOlU = parcelRequire("1HOlU");

var $kBFT9 = parcelRequire("kBFT9");
function $34b012c0d383843f$export$d8e090d8c6a7a6ad(parameters) {
    const { key: key = "public", name: name = "Public Client" } = parameters;
    const client = (0, $1HOlU.createClient)({
        ...parameters,
        key: key,
        name: name,
        type: "publicClient"
    });
    return client.extend((0, $kBFT9.publicActions));
}

});
parcelRegister("kBFT9", function(module, exports) {

$parcel$export(module.exports, "publicActions", function () { return $f007c18456783cc7$export$8705b583fa097d24; });

var $bLJfl = parcelRequire("bLJfl");

var $kMtSf = parcelRequire("kMtSf");

var $7xR5e = parcelRequire("7xR5e");

var $fdro5 = parcelRequire("fdro5");

var $dKzsc = parcelRequire("dKzsc");

var $8FBLA = parcelRequire("8FBLA");

var $gecKX = parcelRequire("gecKX");

var $f5HGM = parcelRequire("f5HGM");

var $6lCrw = parcelRequire("6lCrw");

var $lpztd = parcelRequire("lpztd");

var $fEPgF = parcelRequire("fEPgF");

var $flU5t = parcelRequire("flU5t");

var $rXKgZ = parcelRequire("rXKgZ");

var $lujmb = parcelRequire("lujmb");

var $ftrSD = parcelRequire("ftrSD");

var $1bevI = parcelRequire("1bevI");

var $9LoLM = parcelRequire("9LoLM");

var $aGYPa = parcelRequire("aGYPa");

var $3m4E5 = parcelRequire("3m4E5");

var $lNfs4 = parcelRequire("lNfs4");

var $kzTKF = parcelRequire("kzTKF");

var $50SKj = parcelRequire("50SKj");

var $cTyyq = parcelRequire("cTyyq");

var $g4ueu = parcelRequire("g4ueu");

var $iGxwD = parcelRequire("iGxwD");

var $fJpOo = parcelRequire("fJpOo");

var $1NeUo = parcelRequire("1NeUo");

var $6Tzsp = parcelRequire("6Tzsp");

var $bTmuW = parcelRequire("bTmuW");

var $6i9eR = parcelRequire("6i9eR");

var $6CyRD = parcelRequire("6CyRD");

var $jv258 = parcelRequire("jv258");

var $kkYFf = parcelRequire("kkYFf");

var $a3Hjr = parcelRequire("a3Hjr");

var $5QQBe = parcelRequire("5QQBe");

var $7rQGl = parcelRequire("7rQGl");

var $4ueyh = parcelRequire("4ueyh");

var $18VfH = parcelRequire("18VfH");

var $dpggW = parcelRequire("dpggW");

var $bmBMp = parcelRequire("bmBMp");

var $gsKWc = parcelRequire("gsKWc");

var $fpwKt = parcelRequire("fpwKt");

var $gTN16 = parcelRequire("gTN16");

var $1ozSx = parcelRequire("1ozSx");

var $8HlMY = parcelRequire("8HlMY");

var $9QGmb = parcelRequire("9QGmb");
function $f007c18456783cc7$export$8705b583fa097d24(client) {
    return {
        call: (args)=>(0, $8FBLA.call)(client, args),
        createBlockFilter: ()=>(0, $gecKX.createBlockFilter)(client),
        createContractEventFilter: (args)=>(0, $f5HGM.createContractEventFilter)(client, args),
        createEventFilter: (args)=>(0, $6lCrw.createEventFilter)(client, args),
        createPendingTransactionFilter: ()=>(0, $lpztd.createPendingTransactionFilter)(client),
        estimateContractGas: (args)=>(0, $fEPgF.estimateContractGas)(client, args),
        estimateGas: (args)=>(0, $rXKgZ.estimateGas)(client, args),
        getBalance: (args)=>(0, $ftrSD.getBalance)(client, args),
        getBlock: (args)=>(0, $1bevI.getBlock)(client, args),
        getBlockNumber: (args)=>(0, $9LoLM.getBlockNumber)(client, args),
        getBlockTransactionCount: (args)=>(0, $aGYPa.getBlockTransactionCount)(client, args),
        getBytecode: (args)=>(0, $3m4E5.getBytecode)(client, args),
        getChainId: ()=>(0, $lNfs4.getChainId)(client),
        getContractEvents: (args)=>(0, $kzTKF.getContractEvents)(client, args),
        getEnsAddress: (args)=>(0, $bLJfl.getEnsAddress)(client, args),
        getEnsAvatar: (args)=>(0, $kMtSf.getEnsAvatar)(client, args),
        getEnsName: (args)=>(0, $7xR5e.getEnsName)(client, args),
        getEnsResolver: (args)=>(0, $fdro5.getEnsResolver)(client, args),
        getEnsText: (args)=>(0, $dKzsc.getEnsText)(client, args),
        getFeeHistory: (args)=>(0, $50SKj.getFeeHistory)(client, args),
        estimateFeesPerGas: (args)=>(0, $flU5t.estimateFeesPerGas)(client, args),
        getFilterChanges: (args)=>(0, $cTyyq.getFilterChanges)(client, args),
        getFilterLogs: (args)=>(0, $g4ueu.getFilterLogs)(client, args),
        getGasPrice: ()=>(0, $iGxwD.getGasPrice)(client),
        getLogs: (args)=>(0, $fJpOo.getLogs)(client, args),
        getProof: (args)=>(0, $1NeUo.getProof)(client, args),
        estimateMaxPriorityFeePerGas: (args)=>(0, $lujmb.estimateMaxPriorityFeePerGas)(client, args),
        getStorageAt: (args)=>(0, $6Tzsp.getStorageAt)(client, args),
        getTransaction: (args)=>(0, $bTmuW.getTransaction)(client, args),
        getTransactionConfirmations: (args)=>(0, $6i9eR.getTransactionConfirmations)(client, args),
        getTransactionCount: (args)=>(0, $6CyRD.getTransactionCount)(client, args),
        getTransactionReceipt: (args)=>(0, $jv258.getTransactionReceipt)(client, args),
        multicall: (args)=>(0, $kkYFf.multicall)(client, args),
        prepareTransactionRequest: (args)=>(0, $8HlMY.prepareTransactionRequest)(client, args),
        readContract: (args)=>(0, $a3Hjr.readContract)(client, args),
        sendRawTransaction: (args)=>(0, $9QGmb.sendRawTransaction)(client, args),
        simulateContract: (args)=>(0, $5QQBe.simulateContract)(client, args),
        verifyMessage: (args)=>(0, $4ueyh.verifyMessage)(client, args),
        verifyTypedData: (args)=>(0, $18VfH.verifyTypedData)(client, args),
        uninstallFilter: (args)=>(0, $7rQGl.uninstallFilter)(client, args),
        waitForTransactionReceipt: (args)=>(0, $dpggW.waitForTransactionReceipt)(client, args),
        watchBlocks: (args)=>(0, $gsKWc.watchBlocks)(client, args),
        watchBlockNumber: (args)=>(0, $bmBMp.watchBlockNumber)(client, args),
        watchContractEvent: (args)=>(0, $fpwKt.watchContractEvent)(client, args),
        watchEvent: (args)=>(0, $gTN16.watchEvent)(client, args),
        watchPendingTransactions: (args)=>(0, $1ozSx.watchPendingTransactions)(client, args)
    };
}

});
parcelRegister("bLJfl", function(module, exports) {

$parcel$export(module.exports, "getEnsAddress", function () { return $89172e7f8af4a1f2$export$24b77c7e87f05b8d; });

var $6alFq = parcelRequire("6alFq");

var $8SJqA = parcelRequire("8SJqA");

var $93eGZ = parcelRequire("93eGZ");

var $8eMSI = parcelRequire("8eMSI");

var $ea0vD = parcelRequire("ea0vD");

var $9Kb19 = parcelRequire("9Kb19");

var $fCcPU = parcelRequire("fCcPU");

var $g8t0c = parcelRequire("g8t0c");

var $g4o73 = parcelRequire("g4o73");

var $i7oAr = parcelRequire("i7oAr");

var $a3Hjr = parcelRequire("a3Hjr");
async function $89172e7f8af4a1f2$export$24b77c7e87f05b8d(client, { blockNumber: blockNumber, blockTag: blockTag, coinType: coinType, name: name, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $8eMSI.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    try {
        const functionData = (0, $93eGZ.encodeFunctionData)({
            abi: (0, $6alFq.addressResolverAbi),
            functionName: "addr",
            ...coinType != null ? {
                args: [
                    (0, $g8t0c.namehash)(name),
                    BigInt(coinType)
                ]
            } : {
                args: [
                    (0, $g8t0c.namehash)(name)
                ]
            }
        });
        const res = await (0, $i7oAr.getAction)(client, (0, $a3Hjr.readContract), "readContract")({
            address: universalResolverAddress,
            abi: (0, $6alFq.universalResolverResolveAbi),
            functionName: "resolve",
            args: [
                (0, $9Kb19.toHex)((0, $g4o73.packetToBytes)(name)),
                functionData
            ],
            blockNumber: blockNumber,
            blockTag: blockTag
        });
        if (res[0] === "0x") return null;
        const address = (0, $8SJqA.decodeFunctionResult)({
            abi: (0, $6alFq.addressResolverAbi),
            args: coinType != null ? [
                (0, $g8t0c.namehash)(name),
                BigInt(coinType)
            ] : undefined,
            functionName: "addr",
            data: res[0]
        });
        if (address === "0x") return null;
        if ((0, $ea0vD.trim)(address) === "0x00") return null;
        return address;
    } catch (err) {
        if ((0, $fCcPU.isNullUniversalResolverError)(err, "resolve")) return null;
        throw err;
    }
}

});
parcelRegister("6alFq", function(module, exports) {

$parcel$export(module.exports, "multicall3Abi", function () { return $47d47be30c9af595$export$4e233219477ffb48; });
$parcel$export(module.exports, "universalResolverResolveAbi", function () { return $47d47be30c9af595$export$400f1d40cf4f98fe; });
$parcel$export(module.exports, "universalResolverReverseAbi", function () { return $47d47be30c9af595$export$fd0db820daeebac9; });
$parcel$export(module.exports, "textResolverAbi", function () { return $47d47be30c9af595$export$4e6990b9fd834e88; });
$parcel$export(module.exports, "addressResolverAbi", function () { return $47d47be30c9af595$export$4c61cc2994c5d90b; });
$parcel$export(module.exports, "universalSignatureValidatorAbi", function () { return $47d47be30c9af595$export$b10682c3fa53fbd1; });
/* [Multicall3](https://github.com/mds1/multicall) */ const $47d47be30c9af595$export$4e233219477ffb48 = [
    {
        inputs: [
            {
                components: [
                    {
                        name: "target",
                        type: "address"
                    },
                    {
                        name: "allowFailure",
                        type: "bool"
                    },
                    {
                        name: "callData",
                        type: "bytes"
                    }
                ],
                name: "calls",
                type: "tuple[]"
            }
        ],
        name: "aggregate3",
        outputs: [
            {
                components: [
                    {
                        name: "success",
                        type: "bool"
                    },
                    {
                        name: "returnData",
                        type: "bytes"
                    }
                ],
                name: "returnData",
                type: "tuple[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $47d47be30c9af595$var$universalResolverErrors = [
    {
        inputs: [],
        name: "ResolverNotFound",
        type: "error"
    },
    {
        inputs: [],
        name: "ResolverWildcardNotSupported",
        type: "error"
    }
];
const $47d47be30c9af595$export$400f1d40cf4f98fe = [
    ...$47d47be30c9af595$var$universalResolverErrors,
    {
        name: "resolve",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes"
            },
            {
                name: "data",
                type: "bytes"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            },
            {
                name: "address",
                type: "address"
            }
        ]
    }
];
const $47d47be30c9af595$export$fd0db820daeebac9 = [
    ...$47d47be30c9af595$var$universalResolverErrors,
    {
        name: "reverse",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                type: "bytes",
                name: "reverseName"
            }
        ],
        outputs: [
            {
                type: "string",
                name: "resolvedName"
            },
            {
                type: "address",
                name: "resolvedAddress"
            },
            {
                type: "address",
                name: "reverseResolver"
            },
            {
                type: "address",
                name: "resolver"
            }
        ]
    }
];
const $47d47be30c9af595$export$4e6990b9fd834e88 = [
    {
        name: "text",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            },
            {
                name: "key",
                type: "string"
            }
        ],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    }
];
const $47d47be30c9af595$export$4c61cc2994c5d90b = [
    {
        name: "addr",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            }
        ],
        outputs: [
            {
                name: "",
                type: "address"
            }
        ]
    },
    {
        name: "addr",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            },
            {
                name: "coinType",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            }
        ]
    }
];
const $47d47be30c9af595$export$429a705aa5b352c0 = [
    {
        name: "isValidSignature",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "hash",
                type: "bytes32"
            },
            {
                name: "signature",
                type: "bytes"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes4"
            }
        ]
    }
];
const $47d47be30c9af595$export$b10682c3fa53fbd1 = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_signer",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "_hash",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "_signature",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    }
];

});

parcelRegister("8SJqA", function(module, exports) {

$parcel$export(module.exports, "decodeFunctionResult", function () { return $67769ae0598a41c0$export$3a05a90c230f925; });

var $lXm9U = parcelRequire("lXm9U");

var $hEJzf = parcelRequire("hEJzf");

var $7xdYH = parcelRequire("7xdYH");
const $67769ae0598a41c0$var$docsPath = "/docs/contract/decodeFunctionResult";
function $67769ae0598a41c0$export$3a05a90c230f925({ abi: abi, args: args, functionName: functionName, data: data }) {
    let abiItem = abi[0];
    if (functionName) {
        abiItem = (0, $7xdYH.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!abiItem) throw new (0, $lXm9U.AbiFunctionNotFoundError)(functionName, {
            docsPath: $67769ae0598a41c0$var$docsPath
        });
    }
    if (abiItem.type !== "function") throw new (0, $lXm9U.AbiFunctionNotFoundError)(undefined, {
        docsPath: $67769ae0598a41c0$var$docsPath
    });
    if (!abiItem.outputs) throw new (0, $lXm9U.AbiFunctionOutputsNotFoundError)(abiItem.name, {
        docsPath: $67769ae0598a41c0$var$docsPath
    });
    const values = (0, $hEJzf.decodeAbiParameters)(abiItem.outputs, data);
    if (values && values.length > 1) return values;
    if (values && values.length === 1) return values[0];
    return undefined;
}

});

parcelRegister("8eMSI", function(module, exports) {

$parcel$export(module.exports, "getChainContractAddress", function () { return $5ff58c5d25acb057$export$cf4414608a078996; });

var $7I75L = parcelRequire("7I75L");
function $5ff58c5d25acb057$export$cf4414608a078996({ blockNumber: blockNumber, chain: chain, contract: name }) {
    const contract = chain?.contracts?.[name];
    if (!contract) throw new (0, $7I75L.ChainDoesNotSupportContract)({
        chain: chain,
        contract: {
            name: name
        }
    });
    if (blockNumber && contract.blockCreated && contract.blockCreated > blockNumber) throw new (0, $7I75L.ChainDoesNotSupportContract)({
        blockNumber: blockNumber,
        chain: chain,
        contract: {
            name: name,
            blockCreated: contract.blockCreated
        }
    });
    return contract.address;
}

});

parcelRegister("fCcPU", function(module, exports) {

$parcel$export(module.exports, "isNullUniversalResolverError", function () { return $b5e45ca42b2ddbd3$export$78f90e26b9356cd7; });

var $kNjur = parcelRequire("kNjur");

var $hwGC1 = parcelRequire("hwGC1");

var $3iWI0 = parcelRequire("3iWI0");
function $b5e45ca42b2ddbd3$export$78f90e26b9356cd7(err, callType) {
    if (!(err instanceof (0, $hwGC1.BaseError))) return false;
    const cause = err.walk((e)=>e instanceof (0, $3iWI0.ContractFunctionRevertedError));
    if (!(cause instanceof (0, $3iWI0.ContractFunctionRevertedError))) return false;
    if (cause.data?.errorName === "ResolverNotFound") return true;
    if (cause.data?.errorName === "ResolverWildcardNotSupported") return true;
    // Backwards compatibility for older UniversalResolver contracts
    if (cause.reason?.includes("Wildcard on non-extended resolvers is not supported")) return true;
    // No primary name set for address.
    if (callType === "reverse" && cause.reason === (0, $kNjur.panicReasons)[50]) return true;
    return false;
}

});

parcelRegister("g8t0c", function(module, exports) {

$parcel$export(module.exports, "namehash", function () { return $bbf3e3f02ecb268e$export$91d651ee363e1209; });

var $i9PPy = parcelRequire("i9PPy");

var $dlz3r = parcelRequire("dlz3r");

var $9Kb19 = parcelRequire("9Kb19");

var $9m1kr = parcelRequire("9m1kr");

var $6gcQb = parcelRequire("6gcQb");
function $bbf3e3f02ecb268e$export$91d651ee363e1209(name) {
    let result = new Uint8Array(32).fill(0);
    if (!name) return (0, $9Kb19.bytesToHex)(result);
    const labels = name.split(".");
    // Iterate in reverse order building up hash
    for(let i = labels.length - 1; i >= 0; i -= 1){
        const hashFromEncodedLabel = (0, $6gcQb.encodedLabelToLabelhash)(labels[i]);
        const hashed = hashFromEncodedLabel ? (0, $dlz3r.toBytes)(hashFromEncodedLabel) : (0, $9m1kr.keccak256)((0, $dlz3r.stringToBytes)(labels[i]), "bytes");
        result = (0, $9m1kr.keccak256)((0, $i9PPy.concat)([
            result,
            hashed
        ]), "bytes");
    }
    return (0, $9Kb19.bytesToHex)(result);
}

});
parcelRegister("6gcQb", function(module, exports) {

$parcel$export(module.exports, "encodedLabelToLabelhash", function () { return $48ee3290d6efad80$export$cbf748cac2e87c52; });

var $6zhhe = parcelRequire("6zhhe");
function $48ee3290d6efad80$export$cbf748cac2e87c52(label) {
    if (label.length !== 66) return null;
    if (label.indexOf("[") !== 0) return null;
    if (label.indexOf("]") !== 65) return null;
    const hash = `0x${label.slice(1, 65)}`;
    if (!(0, $6zhhe.isHex)(hash)) return null;
    return hash;
}

});


parcelRegister("g4o73", function(module, exports) {

$parcel$export(module.exports, "packetToBytes", function () { return $bb2fb955abf4681d$export$8a0899f9ded0844; });

var $dlz3r = parcelRequire("dlz3r");

var $kJIqU = parcelRequire("kJIqU");

var $7k8GN = parcelRequire("7k8GN");
function $bb2fb955abf4681d$export$8a0899f9ded0844(packet) {
    // strip leading and trailing `.`
    const value = packet.replace(/^\.|\.$/gm, "");
    if (value.length === 0) return new Uint8Array(1);
    const bytes = new Uint8Array((0, $dlz3r.stringToBytes)(value).byteLength + 2);
    let offset = 0;
    const list = value.split(".");
    for(let i = 0; i < list.length; i++){
        let encoded = (0, $dlz3r.stringToBytes)(list[i]);
        // if the length is > 255, make the encoded label value a labelhash
        // this is compatible with the universal resolver
        if (encoded.byteLength > 255) encoded = (0, $dlz3r.stringToBytes)((0, $kJIqU.encodeLabelhash)((0, $7k8GN.labelhash)(list[i])));
        bytes[offset] = encoded.length;
        bytes.set(encoded, offset + 1);
        offset += encoded.length + 1;
    }
    if (bytes.byteLength !== offset + 1) return bytes.slice(0, offset + 1);
    return bytes;
}

});
parcelRegister("kJIqU", function(module, exports) {

$parcel$export(module.exports, "encodeLabelhash", function () { return $f18a7a14bf8998ce$export$c23ac52da6ff5062; });
function $f18a7a14bf8998ce$export$c23ac52da6ff5062(hash) {
    return `[${hash.slice(2)}]`;
}

});

parcelRegister("7k8GN", function(module, exports) {

$parcel$export(module.exports, "labelhash", function () { return $555124272be4f578$export$83615f6c30436a69; });

var $dlz3r = parcelRequire("dlz3r");

var $9Kb19 = parcelRequire("9Kb19");

var $9m1kr = parcelRequire("9m1kr");

var $6gcQb = parcelRequire("6gcQb");
function $555124272be4f578$export$83615f6c30436a69(label) {
    const result = new Uint8Array(32).fill(0);
    if (!label) return (0, $9Kb19.bytesToHex)(result);
    return (0, $6gcQb.encodedLabelToLabelhash)(label) || (0, $9m1kr.keccak256)((0, $dlz3r.stringToBytes)(label));
}

});


parcelRegister("a3Hjr", function(module, exports) {

$parcel$export(module.exports, "readContract", function () { return $752bc828afa0f4c4$export$43af7de392176737; });

var $8SJqA = parcelRequire("8SJqA");

var $93eGZ = parcelRequire("93eGZ");

var $9Egf9 = parcelRequire("9Egf9");

var $i7oAr = parcelRequire("i7oAr");

var $8FBLA = parcelRequire("8FBLA");
async function $752bc828afa0f4c4$export$43af7de392176737(client, { abi: abi, address: address, args: args, functionName: functionName, ...callRequest }) {
    const calldata = (0, $93eGZ.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        const { data: data } = await (0, $i7oAr.getAction)(client, (0, $8FBLA.call), "call")({
            data: calldata,
            to: address,
            ...callRequest
        });
        return (0, $8SJqA.decodeFunctionResult)({
            abi: abi,
            args: args,
            functionName: functionName,
            data: data || "0x"
        });
    } catch (err) {
        throw (0, $9Egf9.getContractError)(err, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/readContract",
            functionName: functionName
        });
    }
}

});
parcelRegister("9Egf9", function(module, exports) {

$parcel$export(module.exports, "getContractError", function () { return $706473146d772f36$export$4414444aba6ddd8a; });

var $lXm9U = parcelRequire("lXm9U");

var $hwGC1 = parcelRequire("hwGC1");

var $3iWI0 = parcelRequire("3iWI0");

var $e2aBg = parcelRequire("e2aBg");
const $706473146d772f36$var$EXECUTION_REVERTED_ERROR_CODE = 3;
function $706473146d772f36$export$4414444aba6ddd8a(err, { abi: abi, address: address, args: args, docsPath: docsPath, functionName: functionName, sender: sender }) {
    const { code: code, data: data, message: message, shortMessage: shortMessage } = err instanceof (0, $3iWI0.RawContractError) ? err : err instanceof (0, $hwGC1.BaseError) ? err.walk((err)=>"data" in err) || err.walk() : {};
    const cause = (()=>{
        if (err instanceof (0, $lXm9U.AbiDecodingZeroDataError)) return new (0, $3iWI0.ContractFunctionZeroDataError)({
            functionName: functionName
        });
        if ([
            $706473146d772f36$var$EXECUTION_REVERTED_ERROR_CODE,
            (0, $e2aBg.InternalRpcError).code
        ].includes(code) && (data || message || shortMessage)) return new (0, $3iWI0.ContractFunctionRevertedError)({
            abi: abi,
            data: typeof data === "object" ? data.data : data,
            functionName: functionName,
            message: shortMessage ?? message
        });
        return err;
    })();
    return new (0, $3iWI0.ContractFunctionExecutionError)(cause, {
        abi: abi,
        args: args,
        contractAddress: address,
        docsPath: docsPath,
        functionName: functionName,
        sender: sender
    });
}

});

parcelRegister("8FBLA", function(module, exports) {

$parcel$export(module.exports, "call", function () { return $64ff72b013711065$export$848feb93d8f32b9b; });

var $gbMK7 = parcelRequire("gbMK7");

var $6alFq = parcelRequire("6alFq");

var $ahheP = parcelRequire("ahheP");

var $hwGC1 = parcelRequire("hwGC1");

var $7I75L = parcelRequire("7I75L");

var $3iWI0 = parcelRequire("3iWI0");

var $8SJqA = parcelRequire("8SJqA");

var $93eGZ = parcelRequire("93eGZ");

var $8eMSI = parcelRequire("8eMSI");

var $9Kb19 = parcelRequire("9Kb19");

var $b0onY = parcelRequire("b0onY");

var $aC8nR = parcelRequire("aC8nR");

var $1kDHP = parcelRequire("1kDHP");

var $c4rHA = parcelRequire("c4rHA");

var $6WhrO = parcelRequire("6WhrO");

async function $64ff72b013711065$export$848feb93d8f32b9b(client, args) {
    const { account: account_ = client.account, batch: batch = Boolean(client.batch?.multicall), blockNumber: blockNumber, blockTag: blockTag = "latest", accessList: accessList, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, ...rest } = args;
    const account = account_ ? (0, $gbMK7.parseAccount)(account_) : undefined;
    try {
        (0, $6WhrO.assertRequest)(args);
        const blockNumberHex = blockNumber ? (0, $9Kb19.numberToHex)(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || (0, $1kDHP.formatTransactionRequest);
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...(0, $aC8nR.extract)(rest, {
                format: chainFormat
            }),
            from: account?.address,
            accessList: accessList,
            data: data,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: to,
            value: value
        });
        if (batch && $64ff72b013711065$var$shouldPerformMulticall({
            request: request
        })) try {
            return await $64ff72b013711065$var$scheduleMulticall(client, {
                ...request,
                blockNumber: blockNumber,
                blockTag: blockTag
            });
        } catch (err) {
            if (!(err instanceof (0, $7I75L.ClientChainNotConfiguredError)) && !(err instanceof (0, $7I75L.ChainDoesNotSupportContract))) throw err;
        }
        const response = await client.request({
            method: "eth_call",
            params: block ? [
                request,
                block
            ] : [
                request
            ]
        });
        if (response === "0x") return {
            data: undefined
        };
        return {
            data: response
        };
    } catch (err) {
        const data = $64ff72b013711065$export$6ef1a527f868ca75(err);
        const { offchainLookup: offchainLookup, offchainLookupSignature: offchainLookupSignature } = await (parcelRequire("evJlJ"));
        if (data?.slice(0, 10) === offchainLookupSignature && to) return {
            data: await offchainLookup(client, {
                data: data,
                to: to
            })
        };
        throw (0, $b0onY.getCallError)(err, {
            ...args,
            account: account,
            chain: client.chain
        });
    }
}
// We only want to perform a scheduled multicall if:
// - The request has calldata,
// - The request has a target address,
// - The target address is not already the aggregate3 signature,
// - The request has no other properties (`nonce`, `gas`, etc cannot be sent with a multicall).
function $64ff72b013711065$var$shouldPerformMulticall({ request: request }) {
    const { data: data, to: to, ...request_ } = request;
    if (!data) return false;
    if (data.startsWith((0, $ahheP.aggregate3Signature))) return false;
    if (!to) return false;
    if (Object.values(request_).filter((x)=>typeof x !== "undefined").length > 0) return false;
    return true;
}
async function $64ff72b013711065$var$scheduleMulticall(client, args) {
    const { batchSize: batchSize = 1024, wait: wait = 0 } = typeof client.batch?.multicall === "object" ? client.batch.multicall : {};
    const { blockNumber: blockNumber, blockTag: blockTag = "latest", data: data, multicallAddress: multicallAddress_, to: to } = args;
    let multicallAddress = multicallAddress_;
    if (!multicallAddress) {
        if (!client.chain) throw new (0, $7I75L.ClientChainNotConfiguredError)();
        multicallAddress = (0, $8eMSI.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "multicall3"
        });
    }
    const blockNumberHex = blockNumber ? (0, $9Kb19.numberToHex)(blockNumber) : undefined;
    const block = blockNumberHex || blockTag;
    const { schedule: schedule } = (0, $c4rHA.createBatchScheduler)({
        id: `${client.uid}.${block}`,
        wait: wait,
        shouldSplitBatch (args) {
            const size = args.reduce((size, { data: data })=>size + (data.length - 2), 0);
            return size > batchSize * 2;
        },
        fn: async (requests)=>{
            const calls = requests.map((request)=>({
                    allowFailure: true,
                    callData: request.data,
                    target: request.to
                }));
            const calldata = (0, $93eGZ.encodeFunctionData)({
                abi: (0, $6alFq.multicall3Abi),
                args: [
                    calls
                ],
                functionName: "aggregate3"
            });
            const data = await client.request({
                method: "eth_call",
                params: [
                    {
                        data: calldata,
                        to: multicallAddress
                    },
                    block
                ]
            });
            return (0, $8SJqA.decodeFunctionResult)({
                abi: (0, $6alFq.multicall3Abi),
                args: [
                    calls
                ],
                functionName: "aggregate3",
                data: data || "0x"
            });
        }
    });
    const [{ returnData: returnData, success: success }] = await schedule({
        data: data,
        to: to
    });
    if (!success) throw new (0, $3iWI0.RawContractError)({
        data: returnData
    });
    if (returnData === "0x") return {
        data: undefined
    };
    return {
        data: returnData
    };
}
function $64ff72b013711065$export$6ef1a527f868ca75(err) {
    if (!(err instanceof (0, $hwGC1.BaseError))) return undefined;
    const error = err.walk();
    return typeof error.data === "object" ? error.data.data : error.data;
}

});
parcelRegister("ahheP", function(module, exports) {

$parcel$export(module.exports, "aggregate3Signature", function () { return $77b8dd08d5582e4d$export$25fd9a7ba13a8409; });
const $77b8dd08d5582e4d$export$25fd9a7ba13a8409 = "0x82ad56cb";

});

parcelRegister("b0onY", function(module, exports) {

$parcel$export(module.exports, "getCallError", function () { return $80329c4b782acd98$export$7a3a4dfb724485e1; });

var $3iWI0 = parcelRequire("3iWI0");

var $q5jsL = parcelRequire("q5jsL");

var $cHblc = parcelRequire("cHblc");
function $80329c4b782acd98$export$7a3a4dfb724485e1(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $cHblc.getNodeError)(err, args);
        if (cause instanceof (0, $q5jsL.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $3iWI0.CallExecutionError)(cause, {
        docsPath: docsPath,
        ...args
    });
}

});

parcelRegister("c4rHA", function(module, exports) {

$parcel$export(module.exports, "createBatchScheduler", function () { return $8c9b58d08f7d76f6$export$24d3fde68b7c4167; });
const $8c9b58d08f7d76f6$var$schedulerCache = /*#__PURE__*/ new Map();
function $8c9b58d08f7d76f6$export$24d3fde68b7c4167({ fn: fn, id: id, shouldSplitBatch: shouldSplitBatch, wait: wait = 0, sort: sort }) {
    const exec = async ()=>{
        const scheduler = getScheduler();
        flush();
        const args = scheduler.map(({ args: args })=>args);
        if (args.length === 0) return;
        fn(args).then((data)=>{
            if (sort && Array.isArray(data)) data.sort(sort);
            for(let i = 0; i < scheduler.length; i++){
                const { pendingPromise: pendingPromise } = scheduler[i];
                pendingPromise.resolve?.([
                    data[i],
                    data
                ]);
            }
        }).catch((err)=>{
            for(let i = 0; i < scheduler.length; i++){
                const { pendingPromise: pendingPromise } = scheduler[i];
                pendingPromise.reject?.(err);
            }
        });
    };
    const flush = ()=>$8c9b58d08f7d76f6$var$schedulerCache.delete(id);
    const getBatchedArgs = ()=>getScheduler().map(({ args: args })=>args);
    const getScheduler = ()=>$8c9b58d08f7d76f6$var$schedulerCache.get(id) || [];
    const setScheduler = (item)=>$8c9b58d08f7d76f6$var$schedulerCache.set(id, [
            ...getScheduler(),
            item
        ]);
    return {
        flush: flush,
        async schedule (args) {
            const pendingPromise = {};
            const promise = new Promise((resolve, reject)=>{
                pendingPromise.resolve = resolve;
                pendingPromise.reject = reject;
            });
            const split = shouldSplitBatch?.([
                ...getBatchedArgs(),
                args
            ]);
            if (split) exec();
            const hasActiveScheduler = getScheduler().length > 0;
            if (hasActiveScheduler) {
                setScheduler({
                    args: args,
                    pendingPromise: pendingPromise
                });
                return promise;
            }
            setScheduler({
                args: args,
                pendingPromise: pendingPromise
            });
            setTimeout(exec, wait);
            return promise;
        }
    };
}

});

parcelRegister("evJlJ", function(module, exports) {


module.exports = (parcelRequire("cKPUe"))((parcelRequire("jwisd")).resolve("aHw7m")).then(()=>parcelRequire("lzKnp"));

});
parcelRegister("cKPUe", function(module, exports) {
"use strict";

var $afSQ1 = parcelRequire("afSQ1");
module.exports = $afSQ1(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("afSQ1", function(module, exports) {
"use strict";
var $7775d7cb852cbcad$var$cachedBundles = {};
var $7775d7cb852cbcad$var$cachedPreloads = {};
var $7775d7cb852cbcad$var$cachedPrefetches = {};
function $7775d7cb852cbcad$var$getCache(type) {
    switch(type){
        case "preload":
            return $7775d7cb852cbcad$var$cachedPreloads;
        case "prefetch":
            return $7775d7cb852cbcad$var$cachedPrefetches;
        default:
            return $7775d7cb852cbcad$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $7775d7cb852cbcad$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});






parcelRegister("kMtSf", function(module, exports) {

$parcel$export(module.exports, "getEnsAvatar", function () { return $f20f76aeb510ed60$export$65f1d2b9649a54e5; });

var $7WWH8 = parcelRequire("7WWH8");

var $i7oAr = parcelRequire("i7oAr");

var $dKzsc = parcelRequire("dKzsc");
async function $f20f76aeb510ed60$export$65f1d2b9649a54e5(client, { blockNumber: blockNumber, blockTag: blockTag, gatewayUrls: gatewayUrls, name: name, universalResolverAddress: universalResolverAddress }) {
    const record = await (0, $i7oAr.getAction)(client, (0, $dKzsc.getEnsText), "getEnsText")({
        blockNumber: blockNumber,
        blockTag: blockTag,
        key: "avatar",
        name: name,
        universalResolverAddress: universalResolverAddress
    });
    if (!record) return null;
    try {
        return await (0, $7WWH8.parseAvatarRecord)(client, {
            record: record,
            gatewayUrls: gatewayUrls
        });
    } catch  {
        return null;
    }
}

});
parcelRegister("7WWH8", function(module, exports) {

$parcel$export(module.exports, "parseAvatarRecord", function () { return $5c9b7ac20456c9ee$export$3713446b2fba5; });

var $jyBcv = parcelRequire("jyBcv");
async function $5c9b7ac20456c9ee$export$3713446b2fba5(client, { gatewayUrls: gatewayUrls, record: record }) {
    if (/eip155:/i.test(record)) return $5c9b7ac20456c9ee$var$parseNftAvatarUri(client, {
        gatewayUrls: gatewayUrls,
        record: record
    });
    return (0, $jyBcv.parseAvatarUri)({
        uri: record,
        gatewayUrls: gatewayUrls
    });
}
async function $5c9b7ac20456c9ee$var$parseNftAvatarUri(client, { gatewayUrls: gatewayUrls, record: record }) {
    // parse NFT URI into properties
    const nft = (0, $jyBcv.parseNftUri)(record);
    // fetch tokenURI from the NFT contract
    const nftUri = await (0, $jyBcv.getNftTokenUri)(client, {
        nft: nft
    });
    // resolve the URI from the fetched tokenURI
    const { uri: resolvedNftUri, isOnChain: isOnChain, isEncoded: isEncoded } = (0, $jyBcv.resolveAvatarUri)({
        uri: nftUri,
        gatewayUrls: gatewayUrls
    });
    // if the resolved URI is on chain, return the data
    if (isOnChain && (resolvedNftUri.includes("data:application/json;base64,") || resolvedNftUri.startsWith("{"))) {
        const encodedJson = isEncoded ? atob(resolvedNftUri.replace("data:application/json;base64,", "")) : resolvedNftUri;
        const decoded = JSON.parse(encodedJson);
        return (0, $jyBcv.parseAvatarUri)({
            uri: (0, $jyBcv.getJsonImage)(decoded),
            gatewayUrls: gatewayUrls
        });
    }
    let uriTokenId = nft.tokenID;
    if (nft.namespace === "erc1155") uriTokenId = uriTokenId.replace("0x", "").padStart(64, "0");
    return (0, $jyBcv.getMetadataAvatarUri)({
        gatewayUrls: gatewayUrls,
        uri: resolvedNftUri.replace(/(?:0x)?{id}/, uriTokenId)
    });
}

});
parcelRegister("jyBcv", function(module, exports) {

$parcel$export(module.exports, "resolveAvatarUri", function () { return $e3ce0c957cff5090$export$9c878106a0d8edac; });
$parcel$export(module.exports, "getJsonImage", function () { return $e3ce0c957cff5090$export$9be3fe34a3333ecb; });
$parcel$export(module.exports, "getMetadataAvatarUri", function () { return $e3ce0c957cff5090$export$b9759ed161b5e3c5; });
$parcel$export(module.exports, "parseAvatarUri", function () { return $e3ce0c957cff5090$export$1f4e569649d3a793; });
$parcel$export(module.exports, "parseNftUri", function () { return $e3ce0c957cff5090$export$e78cf22c9d52ca8a; });
$parcel$export(module.exports, "getNftTokenUri", function () { return $e3ce0c957cff5090$export$29b8ee2b96a1ed4f; });

var $a3Hjr = parcelRequire("a3Hjr");

var $6tQKG = parcelRequire("6tQKG");
const $e3ce0c957cff5090$var$networkRegex = /(?<protocol>https?:\/\/[^\/]*|ipfs:\/|ipns:\/|ar:\/)?(?<root>\/)?(?<subpath>ipfs\/|ipns\/)?(?<target>[\w\-.]+)(?<subtarget>\/.*)?/;
const $e3ce0c957cff5090$var$ipfsHashRegex = /^(Qm[1-9A-HJ-NP-Za-km-z]{44,}|b[A-Za-z2-7]{58,}|B[A-Z2-7]{58,}|z[1-9A-HJ-NP-Za-km-z]{48,}|F[0-9A-F]{50,})(\/(?<target>[\w\-.]+))?(?<subtarget>\/.*)?$/;
const $e3ce0c957cff5090$var$base64Regex = /^data:([a-zA-Z\-/+]*);base64,([^"].*)/;
const $e3ce0c957cff5090$var$dataURIRegex = /^data:([a-zA-Z\-/+]*)?(;[a-zA-Z0-9].*?)?(,)/;
async function $e3ce0c957cff5090$export$db9c123edba6463(uri) {
    try {
        const res = await fetch(uri, {
            method: "HEAD"
        });
        // retrieve content type header to check if content is image
        if (res.status === 200) {
            const contentType = res.headers.get("content-type");
            return contentType?.startsWith("image/");
        }
        return false;
    } catch (error) {
        // if error is not cors related then fail
        if (typeof error === "object" && typeof error.response !== "undefined") return false;
        // fail in NodeJS, since the error is not cors but any other network issue
        // biome-ignore lint/suspicious/noPrototypeBuiltins:
        if (!globalThis.hasOwnProperty("Image")) return false;
        // in case of cors, use image api to validate if given url is an actual image
        return new Promise((resolve)=>{
            const img = new Image();
            img.onload = ()=>{
                resolve(true);
            };
            img.onerror = ()=>{
                resolve(false);
            };
            img.src = uri;
        });
    }
}
function $e3ce0c957cff5090$export$90df7f536ca3f624(custom, defaultGateway) {
    if (!custom) return defaultGateway;
    if (custom.endsWith("/")) return custom.slice(0, -1);
    return custom;
}
function $e3ce0c957cff5090$export$9c878106a0d8edac({ uri: uri, gatewayUrls: gatewayUrls }) {
    const isEncoded = $e3ce0c957cff5090$var$base64Regex.test(uri);
    if (isEncoded) return {
        uri: uri,
        isOnChain: true,
        isEncoded: isEncoded
    };
    const ipfsGateway = $e3ce0c957cff5090$export$90df7f536ca3f624(gatewayUrls?.ipfs, "https://ipfs.io");
    const arweaveGateway = $e3ce0c957cff5090$export$90df7f536ca3f624(gatewayUrls?.arweave, "https://arweave.net");
    const networkRegexMatch = uri.match($e3ce0c957cff5090$var$networkRegex);
    const { protocol: protocol, subpath: subpath, target: target, subtarget: subtarget = "" } = networkRegexMatch?.groups || {};
    const isIPNS = protocol === "ipns:/" || subpath === "ipns/";
    const isIPFS = protocol === "ipfs:/" || subpath === "ipfs/" || $e3ce0c957cff5090$var$ipfsHashRegex.test(uri);
    if (uri.startsWith("http") && !isIPNS && !isIPFS) {
        let replacedUri = uri;
        if (gatewayUrls?.arweave) replacedUri = uri.replace(/https:\/\/arweave.net/g, gatewayUrls?.arweave);
        return {
            uri: replacedUri,
            isOnChain: false,
            isEncoded: false
        };
    }
    if ((isIPNS || isIPFS) && target) return {
        uri: `${ipfsGateway}/${isIPNS ? "ipns" : "ipfs"}/${target}${subtarget}`,
        isOnChain: false,
        isEncoded: false
    };
    if (protocol === "ar:/" && target) return {
        uri: `${arweaveGateway}/${target}${subtarget || ""}`,
        isOnChain: false,
        isEncoded: false
    };
    let parsedUri = uri.replace($e3ce0c957cff5090$var$dataURIRegex, "");
    if (parsedUri.startsWith("<svg")) // if svg, base64 encode
    parsedUri = `data:image/svg+xml;base64,${btoa(parsedUri)}`;
    if (parsedUri.startsWith("data:") || parsedUri.startsWith("{")) return {
        uri: parsedUri,
        isOnChain: true,
        isEncoded: false
    };
    throw new (0, $6tQKG.EnsAvatarUriResolutionError)({
        uri: uri
    });
}
function $e3ce0c957cff5090$export$9be3fe34a3333ecb(data) {
    // validation check for json data, must include one of theses properties
    if (typeof data !== "object" || !("image" in data) && !("image_url" in data) && !("image_data" in data)) throw new (0, $6tQKG.EnsAvatarInvalidMetadataError)({
        data: data
    });
    return data.image || data.image_url || data.image_data;
}
async function $e3ce0c957cff5090$export$b9759ed161b5e3c5({ gatewayUrls: gatewayUrls, uri: uri }) {
    try {
        const res = await fetch(uri).then((res)=>res.json());
        const image = await $e3ce0c957cff5090$export$1f4e569649d3a793({
            gatewayUrls: gatewayUrls,
            uri: $e3ce0c957cff5090$export$9be3fe34a3333ecb(res)
        });
        return image;
    } catch  {
        throw new (0, $6tQKG.EnsAvatarUriResolutionError)({
            uri: uri
        });
    }
}
async function $e3ce0c957cff5090$export$1f4e569649d3a793({ gatewayUrls: gatewayUrls, uri: uri }) {
    const { uri: resolvedURI, isOnChain: isOnChain } = $e3ce0c957cff5090$export$9c878106a0d8edac({
        uri: uri,
        gatewayUrls: gatewayUrls
    });
    if (isOnChain) return resolvedURI;
    // check if resolvedURI is an image, if it is return the url
    const isImage = await $e3ce0c957cff5090$export$db9c123edba6463(resolvedURI);
    if (isImage) return resolvedURI;
    throw new (0, $6tQKG.EnsAvatarUriResolutionError)({
        uri: uri
    });
}
function $e3ce0c957cff5090$export$e78cf22c9d52ca8a(uri_) {
    let uri = uri_;
    // parse valid nft spec (CAIP-22/CAIP-29)
    // @see: https://github.com/ChainAgnostic/CAIPs/tree/master/CAIPs
    if (uri.startsWith("did:nft:")) // convert DID to CAIP
    uri = uri.replace("did:nft:", "").replace(/_/g, "/");
    const [reference, asset_namespace, tokenID] = uri.split("/");
    const [eip_namespace, chainID] = reference.split(":");
    const [erc_namespace, contractAddress] = asset_namespace.split(":");
    if (!eip_namespace || eip_namespace.toLowerCase() !== "eip155") throw new (0, $6tQKG.EnsAvatarInvalidNftUriError)({
        reason: "Only EIP-155 supported"
    });
    if (!chainID) throw new (0, $6tQKG.EnsAvatarInvalidNftUriError)({
        reason: "Chain ID not found"
    });
    if (!contractAddress) throw new (0, $6tQKG.EnsAvatarInvalidNftUriError)({
        reason: "Contract address not found"
    });
    if (!tokenID) throw new (0, $6tQKG.EnsAvatarInvalidNftUriError)({
        reason: "Token ID not found"
    });
    if (!erc_namespace) throw new (0, $6tQKG.EnsAvatarInvalidNftUriError)({
        reason: "ERC namespace not found"
    });
    return {
        chainID: parseInt(chainID),
        namespace: erc_namespace.toLowerCase(),
        contractAddress: contractAddress,
        tokenID: tokenID
    };
}
async function $e3ce0c957cff5090$export$29b8ee2b96a1ed4f(client, { nft: nft }) {
    if (nft.namespace === "erc721") return (0, $a3Hjr.readContract)(client, {
        address: nft.contractAddress,
        abi: [
            {
                name: "tokenURI",
                type: "function",
                stateMutability: "view",
                inputs: [
                    {
                        name: "tokenId",
                        type: "uint256"
                    }
                ],
                outputs: [
                    {
                        name: "",
                        type: "string"
                    }
                ]
            }
        ],
        functionName: "tokenURI",
        args: [
            BigInt(nft.tokenID)
        ]
    });
    if (nft.namespace === "erc1155") return (0, $a3Hjr.readContract)(client, {
        address: nft.contractAddress,
        abi: [
            {
                name: "uri",
                type: "function",
                stateMutability: "view",
                inputs: [
                    {
                        name: "_id",
                        type: "uint256"
                    }
                ],
                outputs: [
                    {
                        name: "",
                        type: "string"
                    }
                ]
            }
        ],
        functionName: "uri",
        args: [
            BigInt(nft.tokenID)
        ]
    });
    throw new (0, $6tQKG.EnsAvatarUnsupportedNamespaceError)({
        namespace: nft.namespace
    });
}

});
parcelRegister("6tQKG", function(module, exports) {

$parcel$export(module.exports, "EnsAvatarInvalidMetadataError", function () { return $4b7e5ef3dc734eee$export$3d9377558041f9cf; });
$parcel$export(module.exports, "EnsAvatarInvalidNftUriError", function () { return $4b7e5ef3dc734eee$export$74a8ea52cecec305; });
$parcel$export(module.exports, "EnsAvatarUriResolutionError", function () { return $4b7e5ef3dc734eee$export$f202ff3d50da14eb; });
$parcel$export(module.exports, "EnsAvatarUnsupportedNamespaceError", function () { return $4b7e5ef3dc734eee$export$45137f20297c5e74; });

var $hwGC1 = parcelRequire("hwGC1");
class $4b7e5ef3dc734eee$export$3d9377558041f9cf extends (0, $hwGC1.BaseError) {
    constructor({ data: data }){
        super("Unable to extract image from metadata. The metadata may be malformed or invalid.", {
            metaMessages: [
                "- Metadata must be a JSON object with at least an `image`, `image_url` or `image_data` property.",
                "",
                `Provided data: ${JSON.stringify(data)}`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "EnsAvatarInvalidMetadataError"
        });
    }
}
class $4b7e5ef3dc734eee$export$74a8ea52cecec305 extends (0, $hwGC1.BaseError) {
    constructor({ reason: reason }){
        super(`ENS NFT avatar URI is invalid. ${reason}`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "EnsAvatarInvalidNftUriError"
        });
    }
}
class $4b7e5ef3dc734eee$export$f202ff3d50da14eb extends (0, $hwGC1.BaseError) {
    constructor({ uri: uri }){
        super(`Unable to resolve ENS avatar URI "${uri}". The URI may be malformed, invalid, or does not respond with a valid image.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "EnsAvatarUriResolutionError"
        });
    }
}
class $4b7e5ef3dc734eee$export$45137f20297c5e74 extends (0, $hwGC1.BaseError) {
    constructor({ namespace: namespace }){
        super(`ENS NFT avatar namespace "${namespace}" is not supported. Must be "erc721" or "erc1155".`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "EnsAvatarUnsupportedNamespaceError"
        });
    }
}

});



parcelRegister("dKzsc", function(module, exports) {

$parcel$export(module.exports, "getEnsText", function () { return $a02b12a83114f5ea$export$2b2c96dabd62b431; });

var $6alFq = parcelRequire("6alFq");

var $8SJqA = parcelRequire("8SJqA");

var $93eGZ = parcelRequire("93eGZ");

var $8eMSI = parcelRequire("8eMSI");

var $9Kb19 = parcelRequire("9Kb19");

var $fCcPU = parcelRequire("fCcPU");

var $g8t0c = parcelRequire("g8t0c");

var $g4o73 = parcelRequire("g4o73");

var $i7oAr = parcelRequire("i7oAr");

var $a3Hjr = parcelRequire("a3Hjr");
async function $a02b12a83114f5ea$export$2b2c96dabd62b431(client, { blockNumber: blockNumber, blockTag: blockTag, name: name, key: key, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $8eMSI.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    try {
        const res = await (0, $i7oAr.getAction)(client, (0, $a3Hjr.readContract), "readContract")({
            address: universalResolverAddress,
            abi: (0, $6alFq.universalResolverResolveAbi),
            functionName: "resolve",
            args: [
                (0, $9Kb19.toHex)((0, $g4o73.packetToBytes)(name)),
                (0, $93eGZ.encodeFunctionData)({
                    abi: (0, $6alFq.textResolverAbi),
                    functionName: "text",
                    args: [
                        (0, $g8t0c.namehash)(name),
                        key
                    ]
                })
            ],
            blockNumber: blockNumber,
            blockTag: blockTag
        });
        if (res[0] === "0x") return null;
        const record = (0, $8SJqA.decodeFunctionResult)({
            abi: (0, $6alFq.textResolverAbi),
            functionName: "text",
            data: res[0]
        });
        return record === "" ? null : record;
    } catch (err) {
        if ((0, $fCcPU.isNullUniversalResolverError)(err, "resolve")) return null;
        throw err;
    }
}

});


parcelRegister("7xR5e", function(module, exports) {

$parcel$export(module.exports, "getEnsName", function () { return $57e4cabc34f6eade$export$e1b98d9bc05a9fc2; });

var $6alFq = parcelRequire("6alFq");

var $8eMSI = parcelRequire("8eMSI");

var $9Kb19 = parcelRequire("9Kb19");

var $fCcPU = parcelRequire("fCcPU");

var $g4o73 = parcelRequire("g4o73");

var $i7oAr = parcelRequire("i7oAr");

var $a3Hjr = parcelRequire("a3Hjr");
async function $57e4cabc34f6eade$export$e1b98d9bc05a9fc2(client, { address: address, blockNumber: blockNumber, blockTag: blockTag, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $8eMSI.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    const reverseNode = `${address.toLowerCase().substring(2)}.addr.reverse`;
    try {
        const [name, resolvedAddress] = await (0, $i7oAr.getAction)(client, (0, $a3Hjr.readContract), "readContract")({
            address: universalResolverAddress,
            abi: (0, $6alFq.universalResolverReverseAbi),
            functionName: "reverse",
            args: [
                (0, $9Kb19.toHex)((0, $g4o73.packetToBytes)(reverseNode))
            ],
            blockNumber: blockNumber,
            blockTag: blockTag
        });
        if (address.toLowerCase() !== resolvedAddress.toLowerCase()) return null;
        return name;
    } catch (err) {
        if ((0, $fCcPU.isNullUniversalResolverError)(err, "reverse")) return null;
        throw err;
    }
}

});

parcelRegister("fdro5", function(module, exports) {

$parcel$export(module.exports, "getEnsResolver", function () { return $b13d5084bba0f2ed$export$ba1240cd558e6b31; });

var $8eMSI = parcelRequire("8eMSI");

var $9Kb19 = parcelRequire("9Kb19");

var $g4o73 = parcelRequire("g4o73");

var $i7oAr = parcelRequire("i7oAr");

var $a3Hjr = parcelRequire("a3Hjr");
async function $b13d5084bba0f2ed$export$ba1240cd558e6b31(client, { blockNumber: blockNumber, blockTag: blockTag, name: name, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $8eMSI.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    const [resolverAddress] = await (0, $i7oAr.getAction)(client, (0, $a3Hjr.readContract), "readContract")({
        address: universalResolverAddress,
        abi: [
            {
                inputs: [
                    {
                        type: "bytes"
                    }
                ],
                name: "findResolver",
                outputs: [
                    {
                        type: "address"
                    },
                    {
                        type: "bytes32"
                    }
                ],
                stateMutability: "view",
                type: "function"
            }
        ],
        functionName: "findResolver",
        args: [
            (0, $9Kb19.toHex)((0, $g4o73.packetToBytes)(name))
        ],
        blockNumber: blockNumber,
        blockTag: blockTag
    });
    return resolverAddress;
}

});

parcelRegister("gecKX", function(module, exports) {

$parcel$export(module.exports, "createBlockFilter", function () { return $bd07d951c231e8f1$export$651edd5ecf84bf98; });

var $jOiGM = parcelRequire("jOiGM");
async function $bd07d951c231e8f1$export$651edd5ecf84bf98(client) {
    const getRequest = (0, $jOiGM.createFilterRequestScope)(client, {
        method: "eth_newBlockFilter"
    });
    const id = await client.request({
        method: "eth_newBlockFilter"
    });
    return {
        id: id,
        request: getRequest(id),
        type: "block"
    };
}

});
parcelRegister("jOiGM", function(module, exports) {

$parcel$export(module.exports, "createFilterRequestScope", function () { return $e6c12f112c136059$export$b7aadf80a875f555; });
/**
 * Scopes `request` to the filter ID. If the client is a fallback, it will
 * listen for responses and scope the child transport `request` function
 * to the successful filter ID.
 */ function $e6c12f112c136059$export$b7aadf80a875f555(client, { method: method }) {
    const requestMap = {};
    if (client.transport.type === "fallback") client.transport.onResponse?.(({ method: method_, response: id, status: status, transport: transport })=>{
        if (status === "success" && method === method_) requestMap[id] = transport.request;
    });
    return (id)=>requestMap[id] || client.request;
}

});


parcelRegister("f5HGM", function(module, exports) {

$parcel$export(module.exports, "createContractEventFilter", function () { return $afc93658e2f912c5$export$36f99fdb90149e8b; });

var $ixj1T = parcelRequire("ixj1T");

var $9Kb19 = parcelRequire("9Kb19");

var $jOiGM = parcelRequire("jOiGM");
async function $afc93658e2f912c5$export$36f99fdb90149e8b(client, { address: address, abi: abi, args: args, eventName: eventName, fromBlock: fromBlock, strict: strict, toBlock: toBlock }) {
    const getRequest = (0, $jOiGM.createFilterRequestScope)(client, {
        method: "eth_newFilter"
    });
    const topics = eventName ? (0, $ixj1T.encodeEventTopics)({
        abi: abi,
        args: args,
        eventName: eventName
    }) : undefined;
    const id = await client.request({
        method: "eth_newFilter",
        params: [
            {
                address: address,
                fromBlock: typeof fromBlock === "bigint" ? (0, $9Kb19.numberToHex)(fromBlock) : fromBlock,
                toBlock: typeof toBlock === "bigint" ? (0, $9Kb19.numberToHex)(toBlock) : toBlock,
                topics: topics
            }
        ]
    });
    return {
        abi: abi,
        args: args,
        eventName: eventName,
        id: id,
        request: getRequest(id),
        strict: strict,
        type: "event"
    };
}

});
parcelRegister("ixj1T", function(module, exports) {

$parcel$export(module.exports, "encodeEventTopics", function () { return $d7ea11e7d0410fdf$export$64e9f7ca5ce29acd; });

var $lXm9U = parcelRequire("lXm9U");

var $8xTbh = parcelRequire("8xTbh");

var $dlz3r = parcelRequire("dlz3r");

var $jAqrc = parcelRequire("jAqrc");

var $9m1kr = parcelRequire("9m1kr");

var $iqvwC = parcelRequire("iqvwC");

var $8nER6 = parcelRequire("8nER6");

var $7xdYH = parcelRequire("7xdYH");
function $d7ea11e7d0410fdf$export$64e9f7ca5ce29acd({ abi: abi, eventName: eventName, args: args }) {
    let abiItem = abi[0];
    if (eventName) {
        abiItem = (0, $7xdYH.getAbiItem)({
            abi: abi,
            args: args,
            name: eventName
        });
        if (!abiItem) throw new (0, $lXm9U.AbiEventNotFoundError)(eventName, {
            docsPath: "/docs/contract/encodeEventTopics"
        });
    }
    if (abiItem.type !== "event") throw new (0, $lXm9U.AbiEventNotFoundError)(undefined, {
        docsPath: "/docs/contract/encodeEventTopics"
    });
    const definition = (0, $8nER6.formatAbiItem)(abiItem);
    const signature = (0, $jAqrc.getEventSelector)(definition);
    let topics = [];
    if (args && "inputs" in abiItem) {
        const indexedInputs = abiItem.inputs?.filter((param)=>"indexed" in param && param.indexed);
        const args_ = Array.isArray(args) ? args : Object.values(args).length > 0 ? indexedInputs?.map((x)=>args[x.name]) ?? [] : [];
        if (args_.length > 0) topics = indexedInputs?.map((param, i)=>Array.isArray(args_[i]) ? args_[i].map((_, j)=>$d7ea11e7d0410fdf$var$encodeArg({
                    param: param,
                    value: args_[i][j]
                })) : args_[i] ? $d7ea11e7d0410fdf$var$encodeArg({
                param: param,
                value: args_[i]
            }) : null) ?? [];
    }
    return [
        signature,
        ...topics
    ];
}
function $d7ea11e7d0410fdf$var$encodeArg({ param: param, value: value }) {
    if (param.type === "string" || param.type === "bytes") return (0, $9m1kr.keccak256)((0, $dlz3r.toBytes)(value));
    if (param.type === "tuple" || param.type.match(/^(.*)\[(\d+)?\]$/)) throw new (0, $8xTbh.FilterTypeNotSupportedError)(param.type);
    return (0, $iqvwC.encodeAbiParameters)([
        param
    ], [
        value
    ]);
}

});
parcelRegister("8xTbh", function(module, exports) {

$parcel$export(module.exports, "FilterTypeNotSupportedError", function () { return $638c359b386bfaee$export$f71f080d25382681; });

var $hwGC1 = parcelRequire("hwGC1");
class $638c359b386bfaee$export$f71f080d25382681 extends (0, $hwGC1.BaseError) {
    constructor(type){
        super(`Filter type "${type}" is not supported.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "FilterTypeNotSupportedError"
        });
    }
}

});



parcelRegister("6lCrw", function(module, exports) {

$parcel$export(module.exports, "createEventFilter", function () { return $49f28633740e2a43$export$977ab14bbccde633; });

var $ixj1T = parcelRequire("ixj1T");

var $9Kb19 = parcelRequire("9Kb19");

var $jOiGM = parcelRequire("jOiGM");
async function $49f28633740e2a43$export$977ab14bbccde633(client, { address: address, args: args, event: event, events: events_, fromBlock: fromBlock, strict: strict, toBlock: toBlock } = {}) {
    const events = events_ ?? (event ? [
        event
    ] : undefined);
    const getRequest = (0, $jOiGM.createFilterRequestScope)(client, {
        method: "eth_newFilter"
    });
    let topics = [];
    if (events) {
        topics = [
            events.flatMap((event)=>(0, $ixj1T.encodeEventTopics)({
                    abi: [
                        event
                    ],
                    eventName: event.name,
                    args: args
                }))
        ];
        if (event) topics = topics[0];
    }
    const id = await client.request({
        method: "eth_newFilter",
        params: [
            {
                address: address,
                fromBlock: typeof fromBlock === "bigint" ? (0, $9Kb19.numberToHex)(fromBlock) : fromBlock,
                toBlock: typeof toBlock === "bigint" ? (0, $9Kb19.numberToHex)(toBlock) : toBlock,
                ...topics.length ? {
                    topics: topics
                } : {}
            }
        ]
    });
    return {
        abi: events,
        args: args,
        eventName: event ? event.name : undefined,
        fromBlock: fromBlock,
        id: id,
        request: getRequest(id),
        strict: strict,
        toBlock: toBlock,
        type: "event"
    };
}

});

parcelRegister("lpztd", function(module, exports) {

$parcel$export(module.exports, "createPendingTransactionFilter", function () { return $f96772691102e667$export$d455ed04c3e85241; });

var $jOiGM = parcelRequire("jOiGM");
async function $f96772691102e667$export$d455ed04c3e85241(client) {
    const getRequest = (0, $jOiGM.createFilterRequestScope)(client, {
        method: "eth_newPendingTransactionFilter"
    });
    const id = await client.request({
        method: "eth_newPendingTransactionFilter"
    });
    return {
        id: id,
        request: getRequest(id),
        type: "transaction"
    };
}

});

parcelRegister("fEPgF", function(module, exports) {

$parcel$export(module.exports, "estimateContractGas", function () { return $b6625c30a6f5493d$export$7b896b3a3695de87; });

var $gbMK7 = parcelRequire("gbMK7");

var $93eGZ = parcelRequire("93eGZ");

var $9Egf9 = parcelRequire("9Egf9");

var $i7oAr = parcelRequire("i7oAr");

var $rXKgZ = parcelRequire("rXKgZ");
async function $b6625c30a6f5493d$export$7b896b3a3695de87(client, { abi: abi, address: address, args: args, functionName: functionName, ...request }) {
    const data = (0, $93eGZ.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        const gas = await (0, $i7oAr.getAction)(client, (0, $rXKgZ.estimateGas), "estimateGas")({
            data: data,
            to: address,
            ...request
        });
        return gas;
    } catch (err) {
        const account = request.account ? (0, $gbMK7.parseAccount)(request.account) : undefined;
        throw (0, $9Egf9.getContractError)(err, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/estimateContractGas",
            functionName: functionName,
            sender: account?.address
        });
    }
}

});

parcelRegister("ftrSD", function(module, exports) {

$parcel$export(module.exports, "getBalance", function () { return $b43f30e03fcbf973$export$df96cd8d56be0ab1; });

var $9Kb19 = parcelRequire("9Kb19");
async function $b43f30e03fcbf973$export$df96cd8d56be0ab1(client, { address: address, blockNumber: blockNumber, blockTag: blockTag = "latest" }) {
    const blockNumberHex = blockNumber ? (0, $9Kb19.numberToHex)(blockNumber) : undefined;
    const balance = await client.request({
        method: "eth_getBalance",
        params: [
            address,
            blockNumberHex || blockTag
        ]
    });
    return BigInt(balance);
}

});

parcelRegister("9LoLM", function(module, exports) {

$parcel$export(module.exports, "getBlockNumber", function () { return $71bbb78ffcb7dd1b$export$9328b5c92c53a20e; });

var $lrwYl = parcelRequire("lrwYl");
const $71bbb78ffcb7dd1b$var$cacheKey = (id)=>`blockNumber.${id}`;
function $71bbb78ffcb7dd1b$export$bc78c57a2d1b4a2b(id) {
    return (0, $lrwYl.getCache)($71bbb78ffcb7dd1b$var$cacheKey(id));
}
async function $71bbb78ffcb7dd1b$export$9328b5c92c53a20e(client, { cacheTime: cacheTime = client.cacheTime, maxAge: maxAge } = {}) {
    const blockNumberHex = await (0, $lrwYl.withCache)(()=>client.request({
            method: "eth_blockNumber"
        }), {
        cacheKey: $71bbb78ffcb7dd1b$var$cacheKey(client.uid),
        cacheTime: maxAge ?? cacheTime
    });
    return BigInt(blockNumberHex);
}

});
parcelRegister("lrwYl", function(module, exports) {

$parcel$export(module.exports, "getCache", function () { return $f9c5b2339f30cca1$export$e2575ed62a2f107b; });
$parcel$export(module.exports, "withCache", function () { return $f9c5b2339f30cca1$export$33b32b3abf8170f0; });
const $f9c5b2339f30cca1$export$e89e805418f4d2c = /*#__PURE__*/ new Map();
const $f9c5b2339f30cca1$export$b4c67320c85a8b9d = /*#__PURE__*/ new Map();
function $f9c5b2339f30cca1$export$e2575ed62a2f107b(cacheKey) {
    const buildCache = (cacheKey, cache)=>({
            clear: ()=>cache.delete(cacheKey),
            get: ()=>cache.get(cacheKey),
            set: (data)=>cache.set(cacheKey, data)
        });
    const promise = buildCache(cacheKey, $f9c5b2339f30cca1$export$e89e805418f4d2c);
    const response = buildCache(cacheKey, $f9c5b2339f30cca1$export$b4c67320c85a8b9d);
    return {
        clear: ()=>{
            promise.clear();
            response.clear();
        },
        promise: promise,
        response: response
    };
}
async function $f9c5b2339f30cca1$export$33b32b3abf8170f0(fn, { cacheKey: cacheKey, cacheTime: cacheTime = Infinity }) {
    const cache = $f9c5b2339f30cca1$export$e2575ed62a2f107b(cacheKey);
    // If a response exists in the cache, and it's not expired, return it
    // and do not invoke the promise.
    // If the max age is 0, the cache is disabled.
    const response = cache.response.get();
    if (response && cacheTime > 0) {
        const age = new Date().getTime() - response.created.getTime();
        if (age < cacheTime) return response.data;
    }
    let promise = cache.promise.get();
    if (!promise) {
        promise = fn();
        // Store the promise in the cache so that subsequent invocations
        // will wait for the same promise to resolve (deduping).
        cache.promise.set(promise);
    }
    try {
        const data = await promise;
        // Store the response in the cache so that subsequent invocations
        // will return the same response.
        cache.response.set({
            created: new Date(),
            data: data
        });
        return data;
    } finally{
        // Clear the promise cache so that subsequent invocations will
        // invoke the promise again.
        cache.promise.clear();
    }
}

});


parcelRegister("aGYPa", function(module, exports) {

$parcel$export(module.exports, "getBlockTransactionCount", function () { return $7c8d0214a61f8682$export$8c2de5be7f4dfc0; });

var $hiAQY = parcelRequire("hiAQY");

var $9Kb19 = parcelRequire("9Kb19");
async function $7c8d0214a61f8682$export$8c2de5be7f4dfc0(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag = "latest" } = {}) {
    const blockNumberHex = blockNumber !== undefined ? (0, $9Kb19.numberToHex)(blockNumber) : undefined;
    let count;
    if (blockHash) count = await client.request({
        method: "eth_getBlockTransactionCountByHash",
        params: [
            blockHash
        ]
    });
    else count = await client.request({
        method: "eth_getBlockTransactionCountByNumber",
        params: [
            blockNumberHex || blockTag
        ]
    });
    return (0, $hiAQY.hexToNumber)(count);
}

});

parcelRegister("3m4E5", function(module, exports) {

$parcel$export(module.exports, "getBytecode", function () { return $271707ad097d02b2$export$81e5c8d8c8aa6ce1; });

var $9Kb19 = parcelRequire("9Kb19");
async function $271707ad097d02b2$export$81e5c8d8c8aa6ce1(client, { address: address, blockNumber: blockNumber, blockTag: blockTag = "latest" }) {
    const blockNumberHex = blockNumber !== undefined ? (0, $9Kb19.numberToHex)(blockNumber) : undefined;
    const hex = await client.request({
        method: "eth_getCode",
        params: [
            address,
            blockNumberHex || blockTag
        ]
    });
    if (hex === "0x") return undefined;
    return hex;
}

});

parcelRegister("kzTKF", function(module, exports) {

$parcel$export(module.exports, "getContractEvents", function () { return $efb252a97a184422$export$1e175955db02d8d; });

var $7xdYH = parcelRequire("7xdYH");

var $i7oAr = parcelRequire("i7oAr");

var $fJpOo = parcelRequire("fJpOo");
async function $efb252a97a184422$export$1e175955db02d8d(client, { abi: abi, address: address, args: args, blockHash: blockHash, eventName: eventName, fromBlock: fromBlock, toBlock: toBlock, strict: strict }) {
    const event = eventName ? (0, $7xdYH.getAbiItem)({
        abi: abi,
        name: eventName
    }) : undefined;
    const events = !event ? abi.filter((x)=>x.type === "event") : undefined;
    return (0, $i7oAr.getAction)(client, (0, $fJpOo.getLogs), "getLogs")({
        address: address,
        args: args,
        blockHash: blockHash,
        event: event,
        events: events,
        fromBlock: fromBlock,
        toBlock: toBlock,
        strict: strict
    });
}

});
parcelRegister("fJpOo", function(module, exports) {

$parcel$export(module.exports, "getLogs", function () { return $b73f14a8672a3f3b$export$cb5260c832aab30a; });

var $lXm9U = parcelRequire("lXm9U");

var $iFY2V = parcelRequire("iFY2V");

var $ixj1T = parcelRequire("ixj1T");

var $9Kb19 = parcelRequire("9Kb19");

var $2giDD = parcelRequire("2giDD");
async function $b73f14a8672a3f3b$export$cb5260c832aab30a(client, { address: address, blockHash: blockHash, fromBlock: fromBlock, toBlock: toBlock, event: event, events: events_, args: args, strict: strict_ } = {}) {
    const strict = strict_ ?? false;
    const events = events_ ?? (event ? [
        event
    ] : undefined);
    let topics = [];
    if (events) {
        topics = [
            events.flatMap((event)=>(0, $ixj1T.encodeEventTopics)({
                    abi: [
                        event
                    ],
                    eventName: event.name,
                    args: args
                }))
        ];
        if (event) topics = topics[0];
    }
    let logs;
    if (blockHash) logs = await client.request({
        method: "eth_getLogs",
        params: [
            {
                address: address,
                topics: topics,
                blockHash: blockHash
            }
        ]
    });
    else logs = await client.request({
        method: "eth_getLogs",
        params: [
            {
                address: address,
                topics: topics,
                fromBlock: typeof fromBlock === "bigint" ? (0, $9Kb19.numberToHex)(fromBlock) : fromBlock,
                toBlock: typeof toBlock === "bigint" ? (0, $9Kb19.numberToHex)(toBlock) : toBlock
            }
        ]
    });
    return logs.map((log)=>{
        try {
            const { eventName: eventName, args: args } = events ? (0, $iFY2V.decodeEventLog)({
                abi: events,
                data: log.data,
                topics: log.topics,
                strict: strict
            }) : {
                eventName: undefined,
                args: undefined
            };
            return (0, $2giDD.formatLog)(log, {
                args: args,
                eventName: eventName
            });
        } catch (err) {
            let eventName;
            let isUnnamed;
            if (err instanceof (0, $lXm9U.DecodeLogDataMismatch) || err instanceof (0, $lXm9U.DecodeLogTopicsMismatch)) {
                // If strict mode is on, and log data/topics do not match event definition, skip.
                if (strict) return;
                eventName = err.abiItem.name;
                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
            }
            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
            return (0, $2giDD.formatLog)(log, {
                args: isUnnamed ? [] : {},
                eventName: eventName
            });
        }
    }).filter(Boolean);
}

});
parcelRegister("iFY2V", function(module, exports) {

$parcel$export(module.exports, "decodeEventLog", function () { return $d98aa23c0a2ba4c9$export$ec0597e81db3d947; });

var $lXm9U = parcelRequire("lXm9U");

var $jAqrc = parcelRequire("jAqrc");

var $hEJzf = parcelRequire("hEJzf");

var $8nER6 = parcelRequire("8nER6");
const $d98aa23c0a2ba4c9$var$docsPath = "/docs/contract/decodeEventLog";
function $d98aa23c0a2ba4c9$export$ec0597e81db3d947({ abi: abi, data: data, strict: strict_, topics: topics }) {
    const strict = strict_ ?? true;
    const [signature, ...argTopics] = topics;
    if (!signature) throw new (0, $lXm9U.AbiEventSignatureEmptyTopicsError)({
        docsPath: $d98aa23c0a2ba4c9$var$docsPath
    });
    const abiItem = abi.find((x)=>x.type === "event" && signature === (0, $jAqrc.getEventSelector)((0, $8nER6.formatAbiItem)(x)));
    if (!(abiItem && "name" in abiItem) || abiItem.type !== "event") throw new (0, $lXm9U.AbiEventSignatureNotFoundError)(signature, {
        docsPath: $d98aa23c0a2ba4c9$var$docsPath
    });
    const { name: name, inputs: inputs } = abiItem;
    const isUnnamed = inputs?.some((x)=>!("name" in x && x.name));
    let args = isUnnamed ? [] : {};
    // Decode topics (indexed args).
    const indexedInputs = inputs.filter((x)=>"indexed" in x && x.indexed);
    for(let i = 0; i < indexedInputs.length; i++){
        const param = indexedInputs[i];
        const topic = argTopics[i];
        if (!topic) throw new (0, $lXm9U.DecodeLogTopicsMismatch)({
            abiItem: abiItem,
            param: param
        });
        args[param.name || i] = $d98aa23c0a2ba4c9$var$decodeTopic({
            param: param,
            value: topic
        });
    }
    // Decode data (non-indexed args).
    const nonIndexedInputs = inputs.filter((x)=>!("indexed" in x && x.indexed));
    if (nonIndexedInputs.length > 0) {
        if (data && data !== "0x") try {
            const decodedData = (0, $hEJzf.decodeAbiParameters)(nonIndexedInputs, data);
            if (decodedData) {
                if (isUnnamed) args = [
                    ...args,
                    ...decodedData
                ];
                else for(let i = 0; i < nonIndexedInputs.length; i++)args[nonIndexedInputs[i].name] = decodedData[i];
            }
        } catch (err) {
            if (strict) {
                if (err instanceof (0, $lXm9U.AbiDecodingDataSizeTooSmallError)) throw new (0, $lXm9U.DecodeLogDataMismatch)({
                    abiItem: abiItem,
                    data: err.data,
                    params: err.params,
                    size: err.size
                });
                throw err;
            }
        }
        else if (strict) throw new (0, $lXm9U.DecodeLogDataMismatch)({
            abiItem: abiItem,
            data: "0x",
            params: nonIndexedInputs,
            size: 0
        });
    }
    return {
        eventName: name,
        args: Object.values(args).length > 0 ? args : undefined
    };
}
function $d98aa23c0a2ba4c9$var$decodeTopic({ param: param, value: value }) {
    if (param.type === "string" || param.type === "bytes" || param.type === "tuple" || param.type.match(/^(.*)\[(\d+)?\]$/)) return value;
    const decodedArg = (0, $hEJzf.decodeAbiParameters)([
        param
    ], value) || [];
    return decodedArg[0];
}

});

parcelRegister("2giDD", function(module, exports) {

$parcel$export(module.exports, "formatLog", function () { return $1a5b888ba33935ec$export$fccdbdc2b9d7893; });
function $1a5b888ba33935ec$export$fccdbdc2b9d7893(log, { args: args, eventName: eventName } = {}) {
    return {
        ...log,
        blockHash: log.blockHash ? log.blockHash : null,
        blockNumber: log.blockNumber ? BigInt(log.blockNumber) : null,
        logIndex: log.logIndex ? Number(log.logIndex) : null,
        transactionHash: log.transactionHash ? log.transactionHash : null,
        transactionIndex: log.transactionIndex ? Number(log.transactionIndex) : null,
        ...eventName ? {
            args: args,
            eventName: eventName
        } : {}
    };
}

});



parcelRegister("50SKj", function(module, exports) {

$parcel$export(module.exports, "getFeeHistory", function () { return $3a676b44a412fb85$export$66598bc0c00a958e; });

var $9Kb19 = parcelRequire("9Kb19");

var $jLxqm = parcelRequire("jLxqm");
async function $3a676b44a412fb85$export$66598bc0c00a958e(client, { blockCount: blockCount, blockNumber: blockNumber, blockTag: blockTag = "latest", rewardPercentiles: rewardPercentiles }) {
    const blockNumberHex = blockNumber ? (0, $9Kb19.numberToHex)(blockNumber) : undefined;
    const feeHistory = await client.request({
        method: "eth_feeHistory",
        params: [
            (0, $9Kb19.numberToHex)(blockCount),
            blockNumberHex || blockTag,
            rewardPercentiles
        ]
    });
    return (0, $jLxqm.formatFeeHistory)(feeHistory);
}

});
parcelRegister("jLxqm", function(module, exports) {

$parcel$export(module.exports, "formatFeeHistory", function () { return $e63c556da3ccdada$export$6c26435bc7761d23; });
function $e63c556da3ccdada$export$6c26435bc7761d23(feeHistory) {
    return {
        baseFeePerGas: feeHistory.baseFeePerGas.map((value)=>BigInt(value)),
        gasUsedRatio: feeHistory.gasUsedRatio,
        oldestBlock: BigInt(feeHistory.oldestBlock),
        reward: feeHistory.reward?.map((reward)=>reward.map((value)=>BigInt(value)))
    };
}

});


parcelRegister("cTyyq", function(module, exports) {

$parcel$export(module.exports, "getFilterChanges", function () { return $96356cd632816a1a$export$e69fa84ce52a94fd; });

var $lXm9U = parcelRequire("lXm9U");

var $iFY2V = parcelRequire("iFY2V");

var $2giDD = parcelRequire("2giDD");
async function $96356cd632816a1a$export$e69fa84ce52a94fd(_client, { filter: filter }) {
    const strict = "strict" in filter && filter.strict;
    const logs = await filter.request({
        method: "eth_getFilterChanges",
        params: [
            filter.id
        ]
    });
    return logs.map((log)=>{
        if (typeof log === "string") return log;
        try {
            const { eventName: eventName, args: args } = "abi" in filter && filter.abi ? (0, $iFY2V.decodeEventLog)({
                abi: filter.abi,
                data: log.data,
                topics: log.topics,
                strict: strict
            }) : {
                eventName: undefined,
                args: undefined
            };
            return (0, $2giDD.formatLog)(log, {
                args: args,
                eventName: eventName
            });
        } catch (err) {
            let eventName;
            let isUnnamed;
            if (err instanceof (0, $lXm9U.DecodeLogDataMismatch) || err instanceof (0, $lXm9U.DecodeLogTopicsMismatch)) {
                // If strict mode is on, and log data/topics do not match event definition, skip.
                if ("strict" in filter && filter.strict) return;
                eventName = err.abiItem.name;
                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
            }
            // Set args undefined if there is an error decoding (e.g. indexed/non-indexed params mismatch).
            return (0, $2giDD.formatLog)(log, {
                args: isUnnamed ? [] : {},
                eventName: eventName
            });
        }
    }).filter(Boolean);
}

});

parcelRegister("g4ueu", function(module, exports) {

$parcel$export(module.exports, "getFilterLogs", function () { return $bb3478a0aed478cf$export$776d3b8c33a8b58; });

var $lXm9U = parcelRequire("lXm9U");

var $iFY2V = parcelRequire("iFY2V");

var $2giDD = parcelRequire("2giDD");
async function $bb3478a0aed478cf$export$776d3b8c33a8b58(_client, { filter: filter }) {
    const strict = filter.strict ?? false;
    const logs = await filter.request({
        method: "eth_getFilterLogs",
        params: [
            filter.id
        ]
    });
    return logs.map((log)=>{
        try {
            const { eventName: eventName, args: args } = "abi" in filter && filter.abi ? (0, $iFY2V.decodeEventLog)({
                abi: filter.abi,
                data: log.data,
                topics: log.topics,
                strict: strict
            }) : {
                eventName: undefined,
                args: undefined
            };
            return (0, $2giDD.formatLog)(log, {
                args: args,
                eventName: eventName
            });
        } catch (err) {
            let eventName;
            let isUnnamed;
            if (err instanceof (0, $lXm9U.DecodeLogDataMismatch) || err instanceof (0, $lXm9U.DecodeLogTopicsMismatch)) {
                // If strict mode is on, and log data/topics do not match event definition, skip.
                if ("strict" in filter && filter.strict) return;
                eventName = err.abiItem.name;
                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
            }
            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
            return (0, $2giDD.formatLog)(log, {
                args: isUnnamed ? [] : {},
                eventName: eventName
            });
        }
    }).filter(Boolean);
}

});

parcelRegister("1NeUo", function(module, exports) {

$parcel$export(module.exports, "getProof", function () { return $14e5ee8eac03544f$export$4a314c097411dc17; });

var $9Kb19 = parcelRequire("9Kb19");

var $4giCZ = parcelRequire("4giCZ");
async function $14e5ee8eac03544f$export$4a314c097411dc17(client, { address: address, blockNumber: blockNumber, blockTag: blockTag_, storageKeys: storageKeys }) {
    const blockTag = blockTag_ ?? "latest";
    const blockNumberHex = blockNumber !== undefined ? (0, $9Kb19.numberToHex)(blockNumber) : undefined;
    const proof = await client.request({
        method: "eth_getProof",
        params: [
            address,
            storageKeys,
            blockNumberHex || blockTag
        ]
    });
    return (0, $4giCZ.formatProof)(proof);
}

});
parcelRegister("4giCZ", function(module, exports) {

$parcel$export(module.exports, "formatProof", function () { return $31a71b2ccc23c077$export$f37c234f0c7125e3; });

var $hiAQY = parcelRequire("hiAQY");
function $31a71b2ccc23c077$var$formatStorageProof(storageProof) {
    return storageProof.map((proof)=>({
            ...proof,
            value: BigInt(proof.value)
        }));
}
function $31a71b2ccc23c077$export$f37c234f0c7125e3(proof) {
    return {
        ...proof,
        balance: proof.balance ? BigInt(proof.balance) : undefined,
        nonce: proof.nonce ? (0, $hiAQY.hexToNumber)(proof.nonce) : undefined,
        storageProof: proof.storageProof ? $31a71b2ccc23c077$var$formatStorageProof(proof.storageProof) : undefined
    };
}

});


parcelRegister("6Tzsp", function(module, exports) {

$parcel$export(module.exports, "getStorageAt", function () { return $50536232f89efe11$export$14e244c1a3c8527e; });

var $9Kb19 = parcelRequire("9Kb19");
async function $50536232f89efe11$export$14e244c1a3c8527e(client, { address: address, blockNumber: blockNumber, blockTag: blockTag = "latest", slot: slot }) {
    const blockNumberHex = blockNumber !== undefined ? (0, $9Kb19.numberToHex)(blockNumber) : undefined;
    const data = await client.request({
        method: "eth_getStorageAt",
        params: [
            address,
            slot,
            blockNumberHex || blockTag
        ]
    });
    return data;
}

});

parcelRegister("bTmuW", function(module, exports) {

$parcel$export(module.exports, "getTransaction", function () { return $8a864863669bb9bc$export$ec0c6556a09b65b8; });

var $8M4GY = parcelRequire("8M4GY");

var $9Kb19 = parcelRequire("9Kb19");

var $2vH81 = parcelRequire("2vH81");
async function $8a864863669bb9bc$export$ec0c6556a09b65b8(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag_, hash: hash, index: index }) {
    const blockTag = blockTag_ || "latest";
    const blockNumberHex = blockNumber !== undefined ? (0, $9Kb19.numberToHex)(blockNumber) : undefined;
    let transaction = null;
    if (hash) transaction = await client.request({
        method: "eth_getTransactionByHash",
        params: [
            hash
        ]
    });
    else if (blockHash) transaction = await client.request({
        method: "eth_getTransactionByBlockHashAndIndex",
        params: [
            blockHash,
            (0, $9Kb19.numberToHex)(index)
        ]
    });
    else if (blockNumberHex || blockTag) transaction = await client.request({
        method: "eth_getTransactionByBlockNumberAndIndex",
        params: [
            blockNumberHex || blockTag,
            (0, $9Kb19.numberToHex)(index)
        ]
    });
    if (!transaction) throw new (0, $8M4GY.TransactionNotFoundError)({
        blockHash: blockHash,
        blockNumber: blockNumber,
        blockTag: blockTag,
        hash: hash,
        index: index
    });
    const format = client.chain?.formatters?.transaction?.format || (0, $2vH81.formatTransaction);
    return format(transaction);
}

});

parcelRegister("6i9eR", function(module, exports) {

$parcel$export(module.exports, "getTransactionConfirmations", function () { return $494b971eacb3bc0f$export$e2ccc904d713b66d; });

var $i7oAr = parcelRequire("i7oAr");

var $9LoLM = parcelRequire("9LoLM");

var $bTmuW = parcelRequire("bTmuW");
async function $494b971eacb3bc0f$export$e2ccc904d713b66d(client, { hash: hash, transactionReceipt: transactionReceipt }) {
    const [blockNumber, transaction] = await Promise.all([
        (0, $i7oAr.getAction)(client, (0, $9LoLM.getBlockNumber), "getBlockNumber")({}),
        hash ? (0, $i7oAr.getAction)(client, (0, $bTmuW.getTransaction), "getBlockNumber")({
            hash: hash
        }) : undefined
    ]);
    const transactionBlockNumber = transactionReceipt?.blockNumber || transaction?.blockNumber;
    if (!transactionBlockNumber) return 0n;
    return blockNumber - transactionBlockNumber + 1n;
}

});

parcelRegister("jv258", function(module, exports) {

$parcel$export(module.exports, "getTransactionReceipt", function () { return $e32286fcee142f0c$export$6b1ceb3cd5f8b21f; });

var $8M4GY = parcelRequire("8M4GY");

var $40kBD = parcelRequire("40kBD");
async function $e32286fcee142f0c$export$6b1ceb3cd5f8b21f(client, { hash: hash }) {
    const receipt = await client.request({
        method: "eth_getTransactionReceipt",
        params: [
            hash
        ]
    });
    if (!receipt) throw new (0, $8M4GY.TransactionReceiptNotFoundError)({
        hash: hash
    });
    const format = client.chain?.formatters?.transactionReceipt?.format || (0, $40kBD.formatTransactionReceipt);
    return format(receipt);
}

});
parcelRegister("40kBD", function(module, exports) {

$parcel$export(module.exports, "formatTransactionReceipt", function () { return $2ea7256c11898711$export$30da670e49d6fc31; });

var $hiAQY = parcelRequire("hiAQY");

var $a2Hr5 = parcelRequire("a2Hr5");

var $2giDD = parcelRequire("2giDD");

var $2vH81 = parcelRequire("2vH81");
const $2ea7256c11898711$var$statuses = {
    "0x0": "reverted",
    "0x1": "success"
};
function $2ea7256c11898711$export$30da670e49d6fc31(transactionReceipt) {
    return {
        ...transactionReceipt,
        blockNumber: transactionReceipt.blockNumber ? BigInt(transactionReceipt.blockNumber) : null,
        contractAddress: transactionReceipt.contractAddress ? transactionReceipt.contractAddress : null,
        cumulativeGasUsed: transactionReceipt.cumulativeGasUsed ? BigInt(transactionReceipt.cumulativeGasUsed) : null,
        effectiveGasPrice: transactionReceipt.effectiveGasPrice ? BigInt(transactionReceipt.effectiveGasPrice) : null,
        gasUsed: transactionReceipt.gasUsed ? BigInt(transactionReceipt.gasUsed) : null,
        logs: transactionReceipt.logs ? transactionReceipt.logs.map((log)=>(0, $2giDD.formatLog)(log)) : null,
        to: transactionReceipt.to ? transactionReceipt.to : null,
        transactionIndex: transactionReceipt.transactionIndex ? (0, $hiAQY.hexToNumber)(transactionReceipt.transactionIndex) : null,
        status: transactionReceipt.status ? $2ea7256c11898711$var$statuses[transactionReceipt.status] : null,
        type: transactionReceipt.type ? (0, $2vH81.transactionType)[transactionReceipt.type] || transactionReceipt.type : null
    };
}
const $2ea7256c11898711$export$8d3f90420000ba71 = /*#__PURE__*/ (0, $a2Hr5.defineFormatter)("transactionReceipt", $2ea7256c11898711$export$30da670e49d6fc31);

});


parcelRegister("kkYFf", function(module, exports) {

$parcel$export(module.exports, "multicall", function () { return $ece4bb909f133a56$export$60ef70589ee4f7ad; });

var $6alFq = parcelRequire("6alFq");

var $lXm9U = parcelRequire("lXm9U");

var $hwGC1 = parcelRequire("hwGC1");

var $3iWI0 = parcelRequire("3iWI0");

var $8SJqA = parcelRequire("8SJqA");

var $93eGZ = parcelRequire("93eGZ");

var $8eMSI = parcelRequire("8eMSI");

var $9Egf9 = parcelRequire("9Egf9");

var $i7oAr = parcelRequire("i7oAr");

var $a3Hjr = parcelRequire("a3Hjr");
async function $ece4bb909f133a56$export$60ef70589ee4f7ad(client, args) {
    const { allowFailure: allowFailure = true, batchSize: batchSize_, blockNumber: blockNumber, blockTag: blockTag, contracts: contracts, multicallAddress: multicallAddress_ } = args;
    const batchSize = batchSize_ ?? (typeof client.batch?.multicall === "object" && client.batch.multicall.batchSize || 1024);
    let multicallAddress = multicallAddress_;
    if (!multicallAddress) {
        if (!client.chain) throw new Error("client chain not configured. multicallAddress is required.");
        multicallAddress = (0, $8eMSI.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "multicall3"
        });
    }
    const chunkedCalls = [
        []
    ];
    let currentChunk = 0;
    let currentChunkSize = 0;
    for(let i = 0; i < contracts.length; i++){
        const { abi: abi, address: address, args: args, functionName: functionName } = contracts[i];
        try {
            const callData = (0, $93eGZ.encodeFunctionData)({
                abi: abi,
                args: args,
                functionName: functionName
            });
            currentChunkSize += (callData.length - 2) / 2;
            // Check to see if we need to create a new chunk.
            if (// Check if batching is enabled.
            batchSize > 0 && // Check if the current size of the batch exceeds the size limit.
            currentChunkSize > batchSize && // Check if the current chunk is not already empty.
            chunkedCalls[currentChunk].length > 0) {
                currentChunk++;
                currentChunkSize = (callData.length - 2) / 2;
                chunkedCalls[currentChunk] = [];
            }
            chunkedCalls[currentChunk] = [
                ...chunkedCalls[currentChunk],
                {
                    allowFailure: true,
                    callData: callData,
                    target: address
                }
            ];
        } catch (err) {
            const error = (0, $9Egf9.getContractError)(err, {
                abi: abi,
                address: address,
                args: args,
                docsPath: "/docs/contract/multicall",
                functionName: functionName
            });
            if (!allowFailure) throw error;
            chunkedCalls[currentChunk] = [
                ...chunkedCalls[currentChunk],
                {
                    allowFailure: true,
                    callData: "0x",
                    target: address
                }
            ];
        }
    }
    const aggregate3Results = await Promise.allSettled(chunkedCalls.map((calls)=>(0, $i7oAr.getAction)(client, (0, $a3Hjr.readContract), "readContract")({
            abi: (0, $6alFq.multicall3Abi),
            address: multicallAddress,
            args: [
                calls
            ],
            blockNumber: blockNumber,
            blockTag: blockTag,
            functionName: "aggregate3"
        })));
    const results = [];
    for(let i = 0; i < aggregate3Results.length; i++){
        const result = aggregate3Results[i];
        // If an error occurred in a `readContract` invocation (ie. network error),
        // then append the failure reason to each contract result.
        if (result.status === "rejected") {
            if (!allowFailure) throw result.reason;
            for(let j = 0; j < chunkedCalls[i].length; j++)results.push({
                status: "failure",
                error: result.reason,
                result: undefined
            });
            continue;
        }
        // If the `readContract` call was successful, then decode the results.
        const aggregate3Result = result.value;
        for(let j = 0; j < aggregate3Result.length; j++){
            // Extract the response from `readContract`
            const { returnData: returnData, success: success } = aggregate3Result[j];
            // Extract the request call data from the original call.
            const { callData: callData } = chunkedCalls[i][j];
            // Extract the contract config for this call from the `contracts` argument
            // for decoding.
            const { abi: abi, address: address, functionName: functionName, args: args } = contracts[results.length];
            try {
                if (callData === "0x") throw new (0, $lXm9U.AbiDecodingZeroDataError)();
                if (!success) throw new (0, $3iWI0.RawContractError)({
                    data: returnData
                });
                const result = (0, $8SJqA.decodeFunctionResult)({
                    abi: abi,
                    args: args,
                    data: returnData,
                    functionName: functionName
                });
                results.push(allowFailure ? {
                    result: result,
                    status: "success"
                } : result);
            } catch (err) {
                const error = (0, $9Egf9.getContractError)(err, {
                    abi: abi,
                    address: address,
                    args: args,
                    docsPath: "/docs/contract/multicall",
                    functionName: functionName
                });
                if (!allowFailure) throw error;
                results.push({
                    error: error,
                    result: undefined,
                    status: "failure"
                });
            }
        }
    }
    if (results.length !== contracts.length) throw new (0, $hwGC1.BaseError)("multicall results mismatch");
    return results;
}

});

parcelRegister("5QQBe", function(module, exports) {

$parcel$export(module.exports, "simulateContract", function () { return $442a9c42817d9ac7$export$e8798d551e27a374; });

var $gbMK7 = parcelRequire("gbMK7");

var $8SJqA = parcelRequire("8SJqA");

var $93eGZ = parcelRequire("93eGZ");

var $9Egf9 = parcelRequire("9Egf9");

var $i7oAr = parcelRequire("i7oAr");

var $8FBLA = parcelRequire("8FBLA");
async function $442a9c42817d9ac7$export$e8798d551e27a374(client, { abi: abi, address: address, args: args, dataSuffix: dataSuffix, functionName: functionName, ...callRequest }) {
    const account = callRequest.account ? (0, $gbMK7.parseAccount)(callRequest.account) : undefined;
    const calldata = (0, $93eGZ.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        const { data: data } = await (0, $i7oAr.getAction)(client, (0, $8FBLA.call), "call")({
            batch: false,
            data: `${calldata}${dataSuffix ? dataSuffix.replace("0x", "") : ""}`,
            to: address,
            ...callRequest
        });
        const result = (0, $8SJqA.decodeFunctionResult)({
            abi: abi,
            args: args,
            functionName: functionName,
            data: data || "0x"
        });
        return {
            result: result,
            request: {
                abi: abi,
                address: address,
                args: args,
                dataSuffix: dataSuffix,
                functionName: functionName,
                ...callRequest
            }
        };
    } catch (err) {
        throw (0, $9Egf9.getContractError)(err, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/simulateContract",
            functionName: functionName,
            sender: account?.address
        });
    }
}

});

parcelRegister("7rQGl", function(module, exports) {

$parcel$export(module.exports, "uninstallFilter", function () { return $56c3eb94d8a52240$export$54eb7d691768f7f3; });
/**
 * Destroys a [`Filter`](https://viem.sh/docs/glossary/types.html#filter).
 *
 * - Docs: https://viem.sh/docs/actions/public/uninstallFilter.html
 * - JSON-RPC Methods: [`eth_uninstallFilter`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_uninstallFilter)
 *
 * Destroys a Filter that was created from one of the following Actions:
 * - [`createBlockFilter`](https://viem.sh/docs/actions/public/createBlockFilter.html)
 * - [`createEventFilter`](https://viem.sh/docs/actions/public/createEventFilter.html)
 * - [`createPendingTransactionFilter`](https://viem.sh/docs/actions/public/createPendingTransactionFilter.html)
 *
 * @param client - Client to use
 * @param parameters - {@link UninstallFilterParameters}
 * @returns A boolean indicating if the Filter was successfully uninstalled. {@link UninstallFilterReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { createPendingTransactionFilter, uninstallFilter } from 'viem/public'
 *
 * const filter = await createPendingTransactionFilter(client)
 * const uninstalled = await uninstallFilter(client, { filter })
 * // true
 */ async function $56c3eb94d8a52240$export$54eb7d691768f7f3(_client, { filter: filter }) {
    return filter.request({
        method: "eth_uninstallFilter",
        params: [
            filter.id
        ]
    });
}

});

parcelRegister("4ueyh", function(module, exports) {

$parcel$export(module.exports, "verifyMessage", function () { return $3445407e14b0242e$export$228d0e772cc158cb; });

var $8rfl4 = parcelRequire("8rfl4");

var $aJgit = parcelRequire("aJgit");
async function $3445407e14b0242e$export$228d0e772cc158cb(client, { address: address, message: message, signature: signature, ...callRequest }) {
    const hash = (0, $8rfl4.hashMessage)(message);
    return (0, $aJgit.verifyHash)(client, {
        address: address,
        hash: hash,
        signature: signature,
        ...callRequest
    });
}

});
parcelRegister("8rfl4", function(module, exports) {

$parcel$export(module.exports, "hashMessage", function () { return $624cbe567b821ced$export$d4c241cec96564c1; });

var $9v6Cs = parcelRequire("9v6Cs");

var $i9PPy = parcelRequire("i9PPy");

var $dlz3r = parcelRequire("dlz3r");

var $9m1kr = parcelRequire("9m1kr");
function $624cbe567b821ced$export$d4c241cec96564c1(message, to_) {
    const messageBytes = (()=>{
        if (typeof message === "string") return (0, $dlz3r.stringToBytes)(message);
        if (message.raw instanceof Uint8Array) return message.raw;
        return (0, $dlz3r.toBytes)(message.raw);
    })();
    const prefixBytes = (0, $dlz3r.stringToBytes)(`${(0, $9v6Cs.presignMessagePrefix)}${messageBytes.length}`);
    return (0, $9m1kr.keccak256)((0, $i9PPy.concat)([
        prefixBytes,
        messageBytes
    ]), to_);
}

});
parcelRegister("9v6Cs", function(module, exports) {

$parcel$export(module.exports, "presignMessagePrefix", function () { return $6eac24c6bc220128$export$39d5d904b514ff63; });
const $6eac24c6bc220128$export$39d5d904b514ff63 = "\x19Ethereum Signed Message:\n";

});


parcelRegister("aJgit", function(module, exports) {

$parcel$export(module.exports, "verifyHash", function () { return $7cfabf9110c56cd6$export$434ee6408013d7f2; });

var $6alFq = parcelRequire("6alFq");

var $3GlqA = parcelRequire("3GlqA");

var $3iWI0 = parcelRequire("3iWI0");

var $gCLKf = parcelRequire("gCLKf");

var $i7oAr = parcelRequire("i7oAr");

var $86E5K = parcelRequire("86E5K");
var $6zhhe = parcelRequire("6zhhe");
var $9Kb19 = parcelRequire("9Kb19");

var $8FBLA = parcelRequire("8FBLA");
async function $7cfabf9110c56cd6$export$434ee6408013d7f2(client, { address: address, hash: hash, signature: signature, ...callRequest }) {
    const signatureHex = (0, $6zhhe.isHex)(signature) ? signature : (0, $9Kb19.toHex)(signature);
    try {
        const { data: data } = await (0, $i7oAr.getAction)(client, (0, $8FBLA.call), "call")({
            data: (0, $86E5K.encodeDeployData)({
                abi: (0, $6alFq.universalSignatureValidatorAbi),
                args: [
                    address,
                    hash,
                    signatureHex
                ],
                bytecode: (0, $3GlqA.universalSignatureValidatorByteCode)
            }),
            ...callRequest
        });
        return (0, $gCLKf.isBytesEqual)(data ?? "0x0", "0x1");
    } catch (error) {
        if (error instanceof (0, $3iWI0.CallExecutionError)) // if the execution fails, the signature was not valid and an internal method inside of the validator reverted
        // this can happen for many reasons, for example if signer can not be recovered from the signature
        // or if the signature has no valid format
        return false;
        throw error;
    }
}

});
parcelRegister("3GlqA", function(module, exports) {

$parcel$export(module.exports, "universalSignatureValidatorByteCode", function () { return $2ae5ea7ab90a3c29$export$76c7202cd92b9dbb; });
const $2ae5ea7ab90a3c29$export$76c7202cd92b9dbb = "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";

});

parcelRegister("gCLKf", function(module, exports) {

$parcel$export(module.exports, "isBytesEqual", function () { return $c1a53b2021a7aa0c$export$88282e62826c5bec; });

var $loIfK = parcelRequire("loIfK");

var $dlz3r = parcelRequire("dlz3r");

var $6zhhe = parcelRequire("6zhhe");
function $c1a53b2021a7aa0c$export$88282e62826c5bec(a_, b_) {
    const a = (0, $6zhhe.isHex)(a_) ? (0, $dlz3r.toBytes)(a_) : a_;
    const b = (0, $6zhhe.isHex)(b_) ? (0, $dlz3r.toBytes)(b_) : b_;
    return (0, $loIfK.equalBytes)(a, b);
}

});
parcelRegister("loIfK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateObject = module.exports.createHmacDrbg = module.exports.bitMask = module.exports.bitSet = module.exports.bitGet = module.exports.bitLen = module.exports.utf8ToBytes = module.exports.equalBytes = module.exports.concatBytes = module.exports.ensureBytes = module.exports.numberToVarBytesBE = module.exports.numberToBytesLE = module.exports.numberToBytesBE = module.exports.bytesToNumberLE = module.exports.bytesToNumberBE = module.exports.hexToBytes = module.exports.hexToNumber = module.exports.numberToHexUnpadded = module.exports.bytesToHex = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $f93e2a91f4070906$var$_0n = BigInt(0);
const $f93e2a91f4070906$var$_1n = BigInt(1);
const $f93e2a91f4070906$var$_2n = BigInt(2);
const $f93e2a91f4070906$var$u8a = (a)=>a instanceof Uint8Array;
const $f93e2a91f4070906$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $f93e2a91f4070906$var$bytesToHex(bytes) {
    if (!$f93e2a91f4070906$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $f93e2a91f4070906$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $f93e2a91f4070906$var$bytesToHex;
function $f93e2a91f4070906$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
module.exports.numberToHexUnpadded = $f93e2a91f4070906$var$numberToHexUnpadded;
function $f93e2a91f4070906$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
module.exports.hexToNumber = $f93e2a91f4070906$var$hexToNumber;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $f93e2a91f4070906$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $f93e2a91f4070906$var$hexToBytes;
// BE: Big Endian, LE: Little Endian
function $f93e2a91f4070906$var$bytesToNumberBE(bytes) {
    return $f93e2a91f4070906$var$hexToNumber($f93e2a91f4070906$var$bytesToHex(bytes));
}
module.exports.bytesToNumberBE = $f93e2a91f4070906$var$bytesToNumberBE;
function $f93e2a91f4070906$var$bytesToNumberLE(bytes) {
    if (!$f93e2a91f4070906$var$u8a(bytes)) throw new Error("Uint8Array expected");
    return $f93e2a91f4070906$var$hexToNumber($f93e2a91f4070906$var$bytesToHex(Uint8Array.from(bytes).reverse()));
}
module.exports.bytesToNumberLE = $f93e2a91f4070906$var$bytesToNumberLE;
function $f93e2a91f4070906$var$numberToBytesBE(n, len) {
    return $f93e2a91f4070906$var$hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
module.exports.numberToBytesBE = $f93e2a91f4070906$var$numberToBytesBE;
function $f93e2a91f4070906$var$numberToBytesLE(n, len) {
    return $f93e2a91f4070906$var$numberToBytesBE(n, len).reverse();
}
module.exports.numberToBytesLE = $f93e2a91f4070906$var$numberToBytesLE;
// Unpadded, rarely used
function $f93e2a91f4070906$var$numberToVarBytesBE(n) {
    return $f93e2a91f4070906$var$hexToBytes($f93e2a91f4070906$var$numberToHexUnpadded(n));
}
module.exports.numberToVarBytesBE = $f93e2a91f4070906$var$numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $f93e2a91f4070906$var$ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $f93e2a91f4070906$var$hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($f93e2a91f4070906$var$u8a(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
module.exports.ensureBytes = $f93e2a91f4070906$var$ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $f93e2a91f4070906$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$f93e2a91f4070906$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $f93e2a91f4070906$var$concatBytes;
function $f93e2a91f4070906$var$equalBytes(b1, b2) {
    // We don't care about timing attacks here
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
module.exports.equalBytes = $f93e2a91f4070906$var$equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $f93e2a91f4070906$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $f93e2a91f4070906$var$utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function $f93e2a91f4070906$var$bitLen(n) {
    let len;
    for(len = 0; n > $f93e2a91f4070906$var$_0n; n >>= $f93e2a91f4070906$var$_1n, len += 1);
    return len;
}
module.exports.bitLen = $f93e2a91f4070906$var$bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $f93e2a91f4070906$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $f93e2a91f4070906$var$_1n;
}
module.exports.bitGet = $f93e2a91f4070906$var$bitGet;
/**
 * Sets single bit at position.
 */ const $f93e2a91f4070906$var$bitSet = (n, pos, value)=>{
    return n | (value ? $f93e2a91f4070906$var$_1n : $f93e2a91f4070906$var$_0n) << BigInt(pos);
};
module.exports.bitSet = $f93e2a91f4070906$var$bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const $f93e2a91f4070906$var$bitMask = (n)=>($f93e2a91f4070906$var$_2n << BigInt(n - 1)) - $f93e2a91f4070906$var$_1n;
module.exports.bitMask = $f93e2a91f4070906$var$bitMask;
// DRBG
const $f93e2a91f4070906$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $f93e2a91f4070906$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $f93e2a91f4070906$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $f93e2a91f4070906$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $f93e2a91f4070906$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $f93e2a91f4070906$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($f93e2a91f4070906$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($f93e2a91f4070906$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $f93e2a91f4070906$var$concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
module.exports.createHmacDrbg = $f93e2a91f4070906$var$createHmacDrbg;
// Validating curves and fields
const $f93e2a91f4070906$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || val instanceof Uint8Array,
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $f93e2a91f4070906$var$validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $f93e2a91f4070906$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
module.exports.validateObject = $f93e2a91f4070906$var$validateObject; // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});




parcelRegister("18VfH", function(module, exports) {

$parcel$export(module.exports, "verifyTypedData", function () { return $0d52f2e5ee2cb0a3$export$3603b1c1bcd76798; });

var $8c7Hx = parcelRequire("8c7Hx");

var $aJgit = parcelRequire("aJgit");
async function $0d52f2e5ee2cb0a3$export$3603b1c1bcd76798(client, { address: address, signature: signature, message: message, primaryType: primaryType, types: types, domain: domain, ...callRequest }) {
    const hash = (0, $8c7Hx.hashTypedData)({
        message: message,
        primaryType: primaryType,
        types: types,
        domain: domain
    });
    return (0, $aJgit.verifyHash)(client, {
        address: address,
        hash: hash,
        signature: signature,
        ...callRequest
    });
}

});

parcelRegister("dpggW", function(module, exports) {

$parcel$export(module.exports, "waitForTransactionReceipt", function () { return $9c2a3b7e573902b4$export$694ec9bdf0bb55cf; });

var $01ane = parcelRequire("01ane");

var $8M4GY = parcelRequire("8M4GY");

var $i7oAr = parcelRequire("i7oAr");

var $8dMZo = parcelRequire("8dMZo");

var $iLYpU = parcelRequire("iLYpU");

var $peKQ1 = parcelRequire("peKQ1");

var $1bevI = parcelRequire("1bevI");

var $bTmuW = parcelRequire("bTmuW");

var $jv258 = parcelRequire("jv258");

var $bmBMp = parcelRequire("bmBMp");
async function $9c2a3b7e573902b4$export$694ec9bdf0bb55cf(client, { confirmations: confirmations = 1, hash: hash, onReplaced: onReplaced, pollingInterval: pollingInterval = client.pollingInterval, timeout: timeout }) {
    const observerId = (0, $peKQ1.stringify)([
        "waitForTransactionReceipt",
        client.uid,
        hash
    ]);
    let transaction;
    let replacedTransaction;
    let receipt;
    let retrying = false;
    return new Promise((resolve, reject)=>{
        if (timeout) setTimeout(()=>reject(new (0, $8M4GY.WaitForTransactionReceiptTimeoutError)({
                hash: hash
            })), timeout);
        const _unobserve = (0, $8dMZo.observe)(observerId, {
            onReplaced: onReplaced,
            resolve: resolve,
            reject: reject
        }, (emit)=>{
            const _unwatch = (0, $i7oAr.getAction)(client, (0, $bmBMp.watchBlockNumber), "watchBlockNumber")({
                emitMissed: true,
                emitOnBegin: true,
                poll: true,
                pollingInterval: pollingInterval,
                async onBlockNumber (blockNumber_) {
                    if (retrying) return;
                    let blockNumber = blockNumber_;
                    const done = (fn)=>{
                        _unwatch();
                        fn();
                        _unobserve();
                    };
                    try {
                        // If we already have a valid receipt, let's check if we have enough
                        // confirmations. If we do, then we can resolve.
                        if (receipt) {
                            if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                            done(()=>emit.resolve(receipt));
                            return;
                        }
                        // Get the transaction to check if it's been replaced.
                        // We need to retry as some RPC Providers may be slow to sync
                        // up mined transactions.
                        if (!transaction) {
                            retrying = true;
                            await (0, $iLYpU.withRetry)(async ()=>{
                                transaction = await (0, $i7oAr.getAction)(client, (0, $bTmuW.getTransaction), "getTransaction")({
                                    hash: hash
                                });
                                if (transaction.blockNumber) blockNumber = transaction.blockNumber;
                            }, {
                                // exponential backoff
                                delay: ({ count: count })=>~~(1 << count) * 200,
                                retryCount: 6
                            });
                            retrying = false;
                        }
                        // Get the receipt to check if it's been processed.
                        receipt = await (0, $i7oAr.getAction)(client, (0, $jv258.getTransactionReceipt), "getTransactionReceipt")({
                            hash: hash
                        });
                        // Check if we have enough confirmations. If not, continue polling.
                        if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                        done(()=>emit.resolve(receipt));
                    } catch (err) {
                        // If the receipt is not found, the transaction will be pending.
                        // We need to check if it has potentially been replaced.
                        if (transaction && (err instanceof (0, $8M4GY.TransactionNotFoundError) || err instanceof (0, $8M4GY.TransactionReceiptNotFoundError))) try {
                            replacedTransaction = transaction;
                            // Let's retrieve the transactions from the current block.
                            // We need to retry as some RPC Providers may be slow to sync
                            // up mined blocks.
                            retrying = true;
                            const block = await (0, $iLYpU.withRetry)(()=>(0, $i7oAr.getAction)(client, (0, $1bevI.getBlock), "getBlock")({
                                    blockNumber: blockNumber,
                                    includeTransactions: true
                                }), {
                                // exponential backoff
                                delay: ({ count: count })=>~~(1 << count) * 200,
                                retryCount: 6,
                                shouldRetry: ({ error: error })=>error instanceof (0, $01ane.BlockNotFoundError)
                            });
                            retrying = false;
                            const replacementTransaction = block.transactions.find(({ from: from, nonce: nonce })=>from === replacedTransaction.from && nonce === replacedTransaction.nonce);
                            // If we couldn't find a replacement transaction, continue polling.
                            if (!replacementTransaction) return;
                            // If we found a replacement transaction, return it's receipt.
                            receipt = await (0, $i7oAr.getAction)(client, (0, $jv258.getTransactionReceipt), "getTransactionReceipt")({
                                hash: replacementTransaction.hash
                            });
                            // Check if we have enough confirmations. If not, continue polling.
                            if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                            let reason = "replaced";
                            if (replacementTransaction.to === replacedTransaction.to && replacementTransaction.value === replacedTransaction.value) reason = "repriced";
                            else if (replacementTransaction.from === replacementTransaction.to && replacementTransaction.value === 0n) reason = "cancelled";
                            done(()=>{
                                emit.onReplaced?.({
                                    reason: reason,
                                    replacedTransaction: replacedTransaction,
                                    transaction: replacementTransaction,
                                    transactionReceipt: receipt
                                });
                                emit.resolve(receipt);
                            });
                        } catch (err_) {
                            done(()=>emit.reject(err_));
                        }
                        else done(()=>emit.reject(err));
                    }
                }
            });
        });
    });
}

});
parcelRegister("8dMZo", function(module, exports) {

$parcel$export(module.exports, "observe", function () { return $5fc589e386ecb007$export$d1203567a167490e; });
const $5fc589e386ecb007$export$94ab3a05cb07971d = /*#__PURE__*/ new Map();
const $5fc589e386ecb007$export$b4a4aba7c5f97c17 = /*#__PURE__*/ new Map();
let $5fc589e386ecb007$var$callbackCount = 0;
function $5fc589e386ecb007$export$d1203567a167490e(observerId, callbacks, fn) {
    const callbackId = ++$5fc589e386ecb007$var$callbackCount;
    const getListeners = ()=>$5fc589e386ecb007$export$94ab3a05cb07971d.get(observerId) || [];
    const unsubscribe = ()=>{
        const listeners = getListeners();
        $5fc589e386ecb007$export$94ab3a05cb07971d.set(observerId, listeners.filter((cb)=>cb.id !== callbackId));
    };
    const unwatch = ()=>{
        const cleanup = $5fc589e386ecb007$export$b4a4aba7c5f97c17.get(observerId);
        if (getListeners().length === 1 && cleanup) cleanup();
        unsubscribe();
    };
    const listeners = getListeners();
    $5fc589e386ecb007$export$94ab3a05cb07971d.set(observerId, [
        ...listeners,
        {
            id: callbackId,
            fns: callbacks
        }
    ]);
    if (listeners && listeners.length > 0) return unwatch;
    const emit = {};
    for(const key in callbacks)emit[key] = (...args)=>{
        const listeners = getListeners();
        if (listeners.length === 0) return;
        for (const listener of listeners)listener.fns[key]?.(...args);
    };
    const cleanup = fn(emit);
    if (typeof cleanup === "function") $5fc589e386ecb007$export$b4a4aba7c5f97c17.set(observerId, cleanup);
    return unwatch;
}

});

parcelRegister("bmBMp", function(module, exports) {

$parcel$export(module.exports, "watchBlockNumber", function () { return $845f0e15e44a488e$export$fc5f622dd0d82466; });

var $hiAQY = parcelRequire("hiAQY");

var $i7oAr = parcelRequire("i7oAr");

var $8dMZo = parcelRequire("8dMZo");

var $aVpWI = parcelRequire("aVpWI");

var $peKQ1 = parcelRequire("peKQ1");

var $9LoLM = parcelRequire("9LoLM");
function $845f0e15e44a488e$export$fc5f622dd0d82466(client, { emitOnBegin: emitOnBegin = false, emitMissed: emitMissed = false, onBlockNumber: onBlockNumber, onError: onError, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval }) {
    const enablePolling = typeof poll_ !== "undefined" ? poll_ : client.transport.type !== "webSocket";
    let prevBlockNumber;
    const pollBlockNumber = ()=>{
        const observerId = (0, $peKQ1.stringify)([
            "watchBlockNumber",
            client.uid,
            emitOnBegin,
            emitMissed,
            pollingInterval
        ]);
        return (0, $8dMZo.observe)(observerId, {
            onBlockNumber: onBlockNumber,
            onError: onError
        }, (emit)=>(0, $aVpWI.poll)(async ()=>{
                try {
                    const blockNumber = await (0, $i7oAr.getAction)(client, (0, $9LoLM.getBlockNumber), "getBlockNumber")({
                        cacheTime: 0
                    });
                    if (prevBlockNumber) {
                        // If the current block number is the same as the previous,
                        // we can skip.
                        if (blockNumber === prevBlockNumber) return;
                        // If we have missed out on some previous blocks, and the
                        // `emitMissed` flag is truthy, let's emit those blocks.
                        if (blockNumber - prevBlockNumber > 1 && emitMissed) for(let i = prevBlockNumber + 1n; i < blockNumber; i++){
                            emit.onBlockNumber(i, prevBlockNumber);
                            prevBlockNumber = i;
                        }
                    }
                    // If the next block number is greater than the previous,
                    // it is not in the past, and we can emit the new block number.
                    if (!prevBlockNumber || blockNumber > prevBlockNumber) {
                        emit.onBlockNumber(blockNumber, prevBlockNumber);
                        prevBlockNumber = blockNumber;
                    }
                } catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: emitOnBegin,
                interval: pollingInterval
            }));
    };
    const subscribeBlockNumber = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
                    params: [
                        "newHeads"
                    ],
                    onData (data) {
                        if (!active) return;
                        const blockNumber = (0, $hiAQY.hexToBigInt)(data.result?.number);
                        onBlockNumber(blockNumber, prevBlockNumber);
                        prevBlockNumber = blockNumber;
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return unsubscribe;
    };
    return enablePolling ? pollBlockNumber() : subscribeBlockNumber();
}

});
parcelRegister("aVpWI", function(module, exports) {

$parcel$export(module.exports, "poll", function () { return $7f435a9b37527126$export$e0c10349b2c5e1d4; });

var $16glA = parcelRequire("16glA");
function $7f435a9b37527126$export$e0c10349b2c5e1d4(fn, { emitOnBegin: emitOnBegin, initialWaitTime: initialWaitTime, interval: interval }) {
    let active = true;
    const unwatch = ()=>active = false;
    const watch = async ()=>{
        let data = undefined;
        if (emitOnBegin) data = await fn({
            unpoll: unwatch
        });
        const initialWait = await initialWaitTime?.(data) ?? interval;
        await (0, $16glA.wait)(initialWait);
        const poll = async ()=>{
            if (!active) return;
            await fn({
                unpoll: unwatch
            });
            await (0, $16glA.wait)(interval);
            poll();
        };
        poll();
    };
    watch();
    return unwatch;
}

});



parcelRegister("gsKWc", function(module, exports) {

$parcel$export(module.exports, "watchBlocks", function () { return $bfc3abb544502a76$export$f04bd2888af8db20; });

var $hXyDB = parcelRequire("hXyDB");

var $i7oAr = parcelRequire("i7oAr");

var $8dMZo = parcelRequire("8dMZo");

var $aVpWI = parcelRequire("aVpWI");

var $peKQ1 = parcelRequire("peKQ1");

var $1bevI = parcelRequire("1bevI");
function $bfc3abb544502a76$export$f04bd2888af8db20(client, { blockTag: blockTag = "latest", emitMissed: emitMissed = false, emitOnBegin: emitOnBegin = false, onBlock: onBlock, onError: onError, includeTransactions: includeTransactions_, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval }) {
    const enablePolling = typeof poll_ !== "undefined" ? poll_ : client.transport.type !== "webSocket";
    const includeTransactions = includeTransactions_ ?? false;
    let prevBlock;
    const pollBlocks = ()=>{
        const observerId = (0, $peKQ1.stringify)([
            "watchBlocks",
            client.uid,
            emitMissed,
            emitOnBegin,
            includeTransactions,
            pollingInterval
        ]);
        return (0, $8dMZo.observe)(observerId, {
            onBlock: onBlock,
            onError: onError
        }, (emit)=>(0, $aVpWI.poll)(async ()=>{
                try {
                    const block = await (0, $i7oAr.getAction)(client, (0, $1bevI.getBlock), "getBlock")({
                        blockTag: blockTag,
                        includeTransactions: includeTransactions
                    });
                    if (block.number && prevBlock?.number) {
                        // If the current block number is the same as the previous,
                        // we can skip.
                        if (block.number === prevBlock.number) return;
                        // If we have missed out on some previous blocks, and the
                        // `emitMissed` flag is truthy, let's emit those blocks.
                        if (block.number - prevBlock.number > 1 && emitMissed) for(let i = prevBlock?.number + 1n; i < block.number; i++){
                            const block = await (0, $i7oAr.getAction)(client, (0, $1bevI.getBlock), "getBlock")({
                                blockNumber: i,
                                includeTransactions: includeTransactions
                            });
                            emit.onBlock(block, prevBlock);
                            prevBlock = block;
                        }
                    }
                    if (// If no previous block exists, emit.
                    !prevBlock?.number || // If the block tag is "pending" with no block number, emit.
                    blockTag === "pending" && !block?.number || // If the next block number is greater than the previous block number, emit.
                    // We don't want to emit blocks in the past.
                    block.number && block.number > prevBlock.number) {
                        emit.onBlock(block, prevBlock);
                        prevBlock = block;
                    }
                } catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: emitOnBegin,
                interval: pollingInterval
            }));
    };
    const subscribeBlocks = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
                    params: [
                        "newHeads"
                    ],
                    onData (data) {
                        if (!active) return;
                        const format = client.chain?.formatters?.block?.format || (0, $hXyDB.formatBlock);
                        const block = format(data.result);
                        onBlock(block, prevBlock);
                        prevBlock = block;
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return unsubscribe;
    };
    return enablePolling ? pollBlocks() : subscribeBlocks();
}

});

parcelRegister("fpwKt", function(module, exports) {

$parcel$export(module.exports, "watchContractEvent", function () { return $b38297f9cb825055$export$2a02a63daa2df376; });

var $8dMZo = parcelRequire("8dMZo");

var $aVpWI = parcelRequire("aVpWI");

var $peKQ1 = parcelRequire("peKQ1");

var $lXm9U = parcelRequire("lXm9U");

var $e2aBg = parcelRequire("e2aBg");

var $iFY2V = parcelRequire("iFY2V");

var $ixj1T = parcelRequire("ixj1T");

var $2giDD = parcelRequire("2giDD");

var $i7oAr = parcelRequire("i7oAr");

var $f5HGM = parcelRequire("f5HGM");

var $9LoLM = parcelRequire("9LoLM");

var $kzTKF = parcelRequire("kzTKF");

var $cTyyq = parcelRequire("cTyyq");

var $7rQGl = parcelRequire("7rQGl");
function $b38297f9cb825055$export$2a02a63daa2df376(client, { abi: abi, address: address, args: args, batch: batch = true, eventName: eventName, onError: onError, onLogs: onLogs, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval, strict: strict_ }) {
    const enablePolling = typeof poll_ !== "undefined" ? poll_ : client.transport.type !== "webSocket";
    const pollContractEvent = ()=>{
        const observerId = (0, $peKQ1.stringify)([
            "watchContractEvent",
            address,
            args,
            batch,
            client.uid,
            eventName,
            pollingInterval
        ]);
        const strict = strict_ ?? false;
        return (0, $8dMZo.observe)(observerId, {
            onLogs: onLogs,
            onError: onError
        }, (emit)=>{
            let previousBlockNumber;
            let filter;
            let initialized = false;
            const unwatch = (0, $aVpWI.poll)(async ()=>{
                if (!initialized) {
                    try {
                        filter = await (0, $i7oAr.getAction)(client, (0, $f5HGM.createContractEventFilter), "createContractEventFilter")({
                            abi: abi,
                            address: address,
                            args: args,
                            eventName: eventName,
                            strict: strict
                        });
                    } catch  {}
                    initialized = true;
                    return;
                }
                try {
                    let logs;
                    if (filter) logs = await (0, $i7oAr.getAction)(client, (0, $cTyyq.getFilterChanges), "getFilterChanges")({
                        filter: filter
                    });
                    else {
                        // If the filter doesn't exist, we will fall back to use `getLogs`.
                        // The fall back exists because some RPC Providers do not support filters.
                        // Fetch the block number to use for `getLogs`.
                        const blockNumber = await (0, $i7oAr.getAction)(client, (0, $9LoLM.getBlockNumber), "getBlockNumber")({});
                        // If the block number has changed, we will need to fetch the logs.
                        // If the block number doesn't exist, we are yet to reach the first poll interval,
                        // so do not emit any logs.
                        if (previousBlockNumber && previousBlockNumber !== blockNumber) logs = await (0, $i7oAr.getAction)(client, (0, $kzTKF.getContractEvents), "getContractEvents")({
                            abi: abi,
                            address: address,
                            args: args,
                            eventName: eventName,
                            fromBlock: previousBlockNumber + 1n,
                            toBlock: blockNumber,
                            strict: strict
                        });
                        else logs = [];
                        previousBlockNumber = blockNumber;
                    }
                    if (logs.length === 0) return;
                    if (batch) emit.onLogs(logs);
                    else for (const log of logs)emit.onLogs([
                        log
                    ]);
                } catch (err) {
                    // If a filter has been set and gets uninstalled, providers will throw an InvalidInput error.
                    // Reinitalize the filter when this occurs
                    if (filter && err instanceof (0, $e2aBg.InvalidInputRpcError)) initialized = false;
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: true,
                interval: pollingInterval
            });
            return async ()=>{
                if (filter) await (0, $i7oAr.getAction)(client, (0, $7rQGl.uninstallFilter), "uninstallFilter")({
                    filter: filter
                });
                unwatch();
            };
        });
    };
    const subscribeContractEvent = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const topics = eventName ? (0, $ixj1T.encodeEventTopics)({
                    abi: abi,
                    eventName: eventName,
                    args: args
                }) : [];
                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
                    params: [
                        "logs",
                        {
                            address: address,
                            topics: topics
                        }
                    ],
                    onData (data) {
                        if (!active) return;
                        const log = data.result;
                        try {
                            const { eventName: eventName, args: args } = (0, $iFY2V.decodeEventLog)({
                                abi: abi,
                                data: log.data,
                                topics: log.topics,
                                strict: strict_
                            });
                            const formatted = (0, $2giDD.formatLog)(log, {
                                args: args,
                                eventName: eventName
                            });
                            onLogs([
                                formatted
                            ]);
                        } catch (err) {
                            let eventName;
                            let isUnnamed;
                            if (err instanceof (0, $lXm9U.DecodeLogDataMismatch) || err instanceof (0, $lXm9U.DecodeLogTopicsMismatch)) {
                                // If strict mode is on, and log data/topics do not match event definition, skip.
                                if (strict_) return;
                                eventName = err.abiItem.name;
                                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
                            }
                            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
                            const formatted = (0, $2giDD.formatLog)(log, {
                                args: isUnnamed ? [] : {},
                                eventName: eventName
                            });
                            onLogs([
                                formatted
                            ]);
                        }
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return unsubscribe;
    };
    return enablePolling ? pollContractEvent() : subscribeContractEvent();
}

});

parcelRegister("gTN16", function(module, exports) {

$parcel$export(module.exports, "watchEvent", function () { return $c4d7ce1b1f077978$export$f6260ad5441916b4; });

var $8dMZo = parcelRequire("8dMZo");

var $aVpWI = parcelRequire("aVpWI");

var $peKQ1 = parcelRequire("peKQ1");

var $lXm9U = parcelRequire("lXm9U");

var $e2aBg = parcelRequire("e2aBg");

var $i7oAr = parcelRequire("i7oAr");

var $iFY2V = parcelRequire("iFY2V");
var $ixj1T = parcelRequire("ixj1T");
var $2giDD = parcelRequire("2giDD");

var $6lCrw = parcelRequire("6lCrw");

var $9LoLM = parcelRequire("9LoLM");

var $cTyyq = parcelRequire("cTyyq");

var $fJpOo = parcelRequire("fJpOo");

var $7rQGl = parcelRequire("7rQGl");
function $c4d7ce1b1f077978$export$f6260ad5441916b4(client, { address: address, args: args, batch: batch = true, event: event, events: events, onError: onError, onLogs: onLogs, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval, strict: strict_ }) {
    const enablePolling = typeof poll_ !== "undefined" ? poll_ : client.transport.type !== "webSocket";
    const strict = strict_ ?? false;
    const pollEvent = ()=>{
        const observerId = (0, $peKQ1.stringify)([
            "watchEvent",
            address,
            args,
            batch,
            client.uid,
            event,
            pollingInterval
        ]);
        return (0, $8dMZo.observe)(observerId, {
            onLogs: onLogs,
            onError: onError
        }, (emit)=>{
            let previousBlockNumber;
            let filter;
            let initialized = false;
            const unwatch = (0, $aVpWI.poll)(async ()=>{
                if (!initialized) {
                    try {
                        filter = await (0, $i7oAr.getAction)(client, (0, $6lCrw.createEventFilter), "createEventFilter")({
                            address: address,
                            args: args,
                            event: event,
                            events: events,
                            strict: strict
                        });
                    } catch  {}
                    initialized = true;
                    return;
                }
                try {
                    let logs;
                    if (filter) logs = await (0, $i7oAr.getAction)(client, (0, $cTyyq.getFilterChanges), "getFilterChanges")({
                        filter: filter
                    });
                    else {
                        // If the filter doesn't exist, we will fall back to use `getLogs`.
                        // The fall back exists because some RPC Providers do not support filters.
                        // Fetch the block number to use for `getLogs`.
                        const blockNumber = await (0, $i7oAr.getAction)(client, (0, $9LoLM.getBlockNumber), "getBlockNumber")({});
                        // If the block number has changed, we will need to fetch the logs.
                        // If the block number doesn't exist, we are yet to reach the first poll interval,
                        // so do not emit any logs.
                        if (previousBlockNumber && previousBlockNumber !== blockNumber) logs = await (0, $i7oAr.getAction)(client, (0, $fJpOo.getLogs), "getLogs")({
                            address: address,
                            args: args,
                            event: event,
                            events: events,
                            fromBlock: previousBlockNumber + 1n,
                            toBlock: blockNumber
                        });
                        else logs = [];
                        previousBlockNumber = blockNumber;
                    }
                    if (logs.length === 0) return;
                    if (batch) emit.onLogs(logs);
                    else for (const log of logs)emit.onLogs([
                        log
                    ]);
                } catch (err) {
                    // If a filter has been set and gets uninstalled, providers will throw an InvalidInput error.
                    // Reinitalize the filter when this occurs
                    if (filter && err instanceof (0, $e2aBg.InvalidInputRpcError)) initialized = false;
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: true,
                interval: pollingInterval
            });
            return async ()=>{
                if (filter) await (0, $i7oAr.getAction)(client, (0, $7rQGl.uninstallFilter), "uninstallFilter")({
                    filter: filter
                });
                unwatch();
            };
        });
    };
    const subscribeEvent = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const events_ = events ?? (event ? [
                    event
                ] : undefined);
                let topics = [];
                if (events_) {
                    topics = [
                        events_.flatMap((event)=>(0, $ixj1T.encodeEventTopics)({
                                abi: [
                                    event
                                ],
                                eventName: event.name,
                                args: args
                            }))
                    ];
                    if (event) topics = topics[0];
                }
                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
                    params: [
                        "logs",
                        {
                            address: address,
                            topics: topics
                        }
                    ],
                    onData (data) {
                        if (!active) return;
                        const log = data.result;
                        try {
                            const { eventName: eventName, args: args } = (0, $iFY2V.decodeEventLog)({
                                abi: events_,
                                data: log.data,
                                topics: log.topics,
                                strict: strict
                            });
                            const formatted = (0, $2giDD.formatLog)(log, {
                                args: args,
                                eventName: eventName
                            });
                            onLogs([
                                formatted
                            ]);
                        } catch (err) {
                            let eventName;
                            let isUnnamed;
                            if (err instanceof (0, $lXm9U.DecodeLogDataMismatch) || err instanceof (0, $lXm9U.DecodeLogTopicsMismatch)) {
                                // If strict mode is on, and log data/topics do not match event definition, skip.
                                if (strict_) return;
                                eventName = err.abiItem.name;
                                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
                            }
                            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
                            const formatted = (0, $2giDD.formatLog)(log, {
                                args: isUnnamed ? [] : {},
                                eventName: eventName
                            });
                            onLogs([
                                formatted
                            ]);
                        }
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return unsubscribe;
    };
    return enablePolling ? pollEvent() : subscribeEvent();
}

});

parcelRegister("1ozSx", function(module, exports) {

$parcel$export(module.exports, "watchPendingTransactions", function () { return $1043dd179a80a476$export$223080172c87e789; });

var $i7oAr = parcelRequire("i7oAr");

var $8dMZo = parcelRequire("8dMZo");

var $aVpWI = parcelRequire("aVpWI");

var $peKQ1 = parcelRequire("peKQ1");

var $lpztd = parcelRequire("lpztd");

var $cTyyq = parcelRequire("cTyyq");

var $7rQGl = parcelRequire("7rQGl");
function $1043dd179a80a476$export$223080172c87e789(client, { batch: batch = true, onError: onError, onTransactions: onTransactions, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval }) {
    const enablePolling = typeof poll_ !== "undefined" ? poll_ : client.transport.type !== "webSocket";
    const pollPendingTransactions = ()=>{
        const observerId = (0, $peKQ1.stringify)([
            "watchPendingTransactions",
            client.uid,
            batch,
            pollingInterval
        ]);
        return (0, $8dMZo.observe)(observerId, {
            onTransactions: onTransactions,
            onError: onError
        }, (emit)=>{
            let filter;
            const unwatch = (0, $aVpWI.poll)(async ()=>{
                try {
                    if (!filter) try {
                        filter = await (0, $i7oAr.getAction)(client, (0, $lpztd.createPendingTransactionFilter), "createPendingTransactionFilter")({});
                        return;
                    } catch (err) {
                        unwatch();
                        throw err;
                    }
                    const hashes = await (0, $i7oAr.getAction)(client, (0, $cTyyq.getFilterChanges), "getFilterChanges")({
                        filter: filter
                    });
                    if (hashes.length === 0) return;
                    if (batch) emit.onTransactions(hashes);
                    else for (const hash of hashes)emit.onTransactions([
                        hash
                    ]);
                } catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: true,
                interval: pollingInterval
            });
            return async ()=>{
                if (filter) await (0, $i7oAr.getAction)(client, (0, $7rQGl.uninstallFilter), "uninstallFilter")({
                    filter: filter
                });
                unwatch();
            };
        });
    };
    const subscribePendingTransactions = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
                    params: [
                        "newPendingTransactions"
                    ],
                    onData (data) {
                        if (!active) return;
                        const transaction = data.result;
                        onTransactions([
                            transaction
                        ]);
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return unsubscribe;
    };
    return enablePolling ? pollPendingTransactions() : subscribePendingTransactions();
}

});



parcelRegister("jiwJs", function(module, exports) {

$parcel$export(module.exports, "fallback", function () { return $e0c916b011d80228$export$bcd1dd1f397bba12; });

var $cgkN7 = parcelRequire("cgkN7");

var $16glA = parcelRequire("16glA");

var $70vH0 = parcelRequire("70vH0");
function $e0c916b011d80228$export$bcd1dd1f397bba12(transports_, config = {}) {
    const { key: key = "fallback", name: name = "Fallback", rank: rank = false, retryCount: retryCount, retryDelay: retryDelay } = config;
    return ({ chain: chain, pollingInterval: pollingInterval = 4000, timeout: timeout })=>{
        let transports = transports_;
        let onResponse = ()=>{};
        const transport = (0, $70vH0.createTransport)({
            key: key,
            name: name,
            async request ({ method: method, params: params }) {
                const fetch = async (i = 0)=>{
                    const transport = transports[i]({
                        chain: chain,
                        retryCount: 0,
                        timeout: timeout
                    });
                    try {
                        const response = await transport.request({
                            method: method,
                            params: params
                        });
                        onResponse({
                            method: method,
                            params: params,
                            response: response,
                            transport: transport,
                            status: "success"
                        });
                        return response;
                    } catch (err) {
                        onResponse({
                            error: err,
                            method: method,
                            params: params,
                            transport: transport,
                            status: "error"
                        });
                        // If the error is deterministic, we don't need to fall back.
                        // So throw the error.
                        if ((0, $cgkN7.isDeterministicError)(err)) throw err;
                        // If we've reached the end of the fallbacks, throw the error.
                        if (i === transports.length - 1) throw err;
                        // Otherwise, try the next fallback.
                        return fetch(i + 1);
                    }
                };
                return fetch();
            },
            retryCount: retryCount,
            retryDelay: retryDelay,
            type: "fallback"
        }, {
            onResponse: (fn)=>onResponse = fn,
            transports: transports.map((fn)=>fn({
                    chain: chain,
                    retryCount: 0
                }))
        });
        if (rank) {
            const rankOptions = typeof rank === "object" ? rank : {};
            $e0c916b011d80228$export$f2bce5ae3fda4e76({
                chain: chain,
                interval: rankOptions.interval ?? pollingInterval,
                onTransports: (transports_)=>transports = transports_,
                sampleCount: rankOptions.sampleCount,
                timeout: rankOptions.timeout,
                transports: transports,
                weights: rankOptions.weights
            });
        }
        return transport;
    };
}
function $e0c916b011d80228$export$f2bce5ae3fda4e76({ chain: chain, interval: interval = 4000, onTransports: onTransports, sampleCount: sampleCount = 10, timeout: timeout = 1000, transports: transports, weights: weights = {} }) {
    const { stability: stabilityWeight = 0.7, latency: latencyWeight = 0.3 } = weights;
    const samples = [];
    const rankTransports_ = async ()=>{
        // 1. Take a sample from each Transport.
        const sample = await Promise.all(transports.map(async (transport)=>{
            const transport_ = transport({
                chain: chain,
                retryCount: 0,
                timeout: timeout
            });
            const start = Date.now();
            let end;
            let success;
            try {
                await transport_.request({
                    method: "net_listening"
                });
                success = 1;
            } catch  {
                success = 0;
            } finally{
                end = Date.now();
            }
            const latency = end - start;
            return {
                latency: latency,
                success: success
            };
        }));
        // 2. Store the sample. If we have more than `sampleCount` samples, remove
        // the oldest sample.
        samples.push(sample);
        if (samples.length > sampleCount) samples.shift();
        // 3. Calculate the max latency from samples.
        const maxLatency = Math.max(...samples.map((sample)=>Math.max(...sample.map(({ latency: latency })=>latency))));
        // 4. Calculate the score for each Transport.
        const scores = transports.map((_, i)=>{
            const latencies = samples.map((sample)=>sample[i].latency);
            const meanLatency = latencies.reduce((acc, latency)=>acc + latency, 0) / latencies.length;
            const latencyScore = 1 - meanLatency / maxLatency;
            const successes = samples.map((sample)=>sample[i].success);
            const stabilityScore = successes.reduce((acc, success)=>acc + success, 0) / successes.length;
            if (stabilityScore === 0) return [
                0,
                i
            ];
            return [
                latencyWeight * latencyScore + stabilityWeight * stabilityScore,
                i
            ];
        }).sort((a, b)=>b[0] - a[0]);
        // 5. Sort the Transports by score.
        onTransports(scores.map(([, i])=>transports[i]));
        // 6. Wait, and then rank again.
        await (0, $16glA.wait)(interval);
        rankTransports_();
    };
    rankTransports_();
}

});

parcelRegister("5YPS7", function(module, exports) {

$parcel$export(module.exports, "getContract", function () { return $45aacb0375a385e6$export$f518c38144e1f9d; });

var $i7oAr = parcelRequire("i7oAr");

var $f5HGM = parcelRequire("f5HGM");

var $fEPgF = parcelRequire("fEPgF");

var $kzTKF = parcelRequire("kzTKF");

var $a3Hjr = parcelRequire("a3Hjr");

var $5QQBe = parcelRequire("5QQBe");

var $fpwKt = parcelRequire("fpwKt");

var $3Bki4 = parcelRequire("3Bki4");
function $45aacb0375a385e6$export$f518c38144e1f9d({ abi: abi, address: address, publicClient: publicClient, walletClient: walletClient }) {
    const hasPublicClient = publicClient !== undefined && publicClient !== null;
    const hasWalletClient = walletClient !== undefined && walletClient !== null;
    const contract = {};
    let hasReadFunction = false;
    let hasWriteFunction = false;
    let hasEvent = false;
    for (const item of abi){
        if (item.type === "function") {
            if (item.stateMutability === "view" || item.stateMutability === "pure") hasReadFunction = true;
            else hasWriteFunction = true;
        } else if (item.type === "event") hasEvent = true;
        // Exit early if all flags are `true`
        if (hasReadFunction && hasWriteFunction && hasEvent) break;
    }
    if (hasPublicClient) {
        if (hasReadFunction) contract.read = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $45aacb0375a385e6$export$b1d653474fdb0f41(parameters);
                    return (0, $i7oAr.getAction)(publicClient, (0, $a3Hjr.readContract), "readContract")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options
                    });
                };
            }
        });
        if (hasWriteFunction) contract.simulate = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $45aacb0375a385e6$export$b1d653474fdb0f41(parameters);
                    return (0, $i7oAr.getAction)(publicClient, (0, $5QQBe.simulateContract), "simulateContract")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options
                    });
                };
            }
        });
        if (hasEvent) {
            contract.createEventFilter = new Proxy({}, {
                get (_, eventName) {
                    return (...parameters)=>{
                        const abiEvent = abi.find((x)=>x.type === "event" && x.name === eventName);
                        const { args: args, options: options } = $45aacb0375a385e6$export$5d0aafa8249eb606(parameters, abiEvent);
                        return (0, $i7oAr.getAction)(publicClient, (0, $f5HGM.createContractEventFilter), "createContractEventFilter")({
                            abi: abi,
                            address: address,
                            eventName: eventName,
                            args: args,
                            ...options
                        });
                    };
                }
            });
            contract.getEvents = new Proxy({}, {
                get (_, eventName) {
                    return (...parameters)=>{
                        const abiEvent = abi.find((x)=>x.type === "event" && x.name === eventName);
                        const { args: args, options: options } = $45aacb0375a385e6$export$5d0aafa8249eb606(parameters, abiEvent);
                        return (0, $i7oAr.getAction)(publicClient, (0, $kzTKF.getContractEvents), "getContractEvents")({
                            abi: abi,
                            address: address,
                            eventName: eventName,
                            args: args,
                            ...options
                        });
                    };
                }
            });
            contract.watchEvent = new Proxy({}, {
                get (_, eventName) {
                    return (...parameters)=>{
                        const abiEvent = abi.find((x)=>x.type === "event" && x.name === eventName);
                        const { args: args, options: options } = $45aacb0375a385e6$export$5d0aafa8249eb606(parameters, abiEvent);
                        return (0, $i7oAr.getAction)(publicClient, (0, $fpwKt.watchContractEvent), "watchContractEvent")({
                            abi: abi,
                            address: address,
                            eventName: eventName,
                            args: args,
                            ...options
                        });
                    };
                }
            });
        }
    }
    if (hasWalletClient) {
        if (hasWriteFunction) contract.write = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $45aacb0375a385e6$export$b1d653474fdb0f41(parameters);
                    return (0, $i7oAr.getAction)(walletClient, (0, $3Bki4.writeContract), "writeContract")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options
                    });
                };
            }
        });
    }
    if (hasPublicClient || hasWalletClient) {
        if (hasWriteFunction) contract.estimateGas = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $45aacb0375a385e6$export$b1d653474fdb0f41(parameters);
                    const client = publicClient ?? walletClient;
                    return (0, $i7oAr.getAction)(client, (0, $fEPgF.estimateContractGas), "estimateContractGas")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options,
                        account: options.account ?? walletClient.account
                    });
                };
            }
        });
    }
    contract.address = address;
    contract.abi = abi;
    return contract;
}
function $45aacb0375a385e6$export$b1d653474fdb0f41(values) {
    const hasArgs = values.length && Array.isArray(values[0]);
    const args = hasArgs ? values[0] : [];
    const options = (hasArgs ? values[1] : values[0]) ?? {};
    return {
        args: args,
        options: options
    };
}
function $45aacb0375a385e6$export$5d0aafa8249eb606(values, abiEvent) {
    let hasArgs = false;
    // If first item is array, must be `args`
    if (Array.isArray(values[0])) hasArgs = true;
    else if (values.length === 1) // if event has indexed inputs, must have `args`
    hasArgs = abiEvent.inputs.some((x)=>x.indexed);
    else if (values.length === 2) hasArgs = true;
    const args = hasArgs ? values[0] : undefined;
    const options = (hasArgs ? values[1] : values[0]) ?? {};
    return {
        args: args,
        options: options
    };
}

});

parcelRegister("gvP8M", function(module, exports) {

$parcel$export(module.exports, "http", function () { return $c0573613902afcb0$export$7d6f1c8842f9f527; });

var $fG0ph = parcelRequire("fG0ph");

var $alGS0 = parcelRequire("alGS0");

var $c4rHA = parcelRequire("c4rHA");

var $9EPcc = parcelRequire("9EPcc");

var $70vH0 = parcelRequire("70vH0");
function $c0573613902afcb0$export$7d6f1c8842f9f527(/** URL of the JSON-RPC API. Defaults to the chain's public RPC URL. */ url, config = {}) {
    const { batch: batch, fetchOptions: fetchOptions, key: key = "http", name: name = "HTTP JSON-RPC", retryDelay: retryDelay } = config;
    return ({ chain: chain, retryCount: retryCount_, timeout: timeout_ })=>{
        const { batchSize: batchSize = 1000, wait: wait = 0 } = typeof batch === "object" ? batch : {};
        const retryCount = config.retryCount ?? retryCount_;
        const timeout = timeout_ ?? config.timeout ?? 10000;
        const url_ = url || chain?.rpcUrls.default.http[0];
        if (!url_) throw new (0, $alGS0.UrlRequiredError)();
        return (0, $70vH0.createTransport)({
            key: key,
            name: name,
            async request ({ method: method, params: params }) {
                const body = {
                    method: method,
                    params: params
                };
                const { schedule: schedule } = (0, $c4rHA.createBatchScheduler)({
                    id: `${url}`,
                    wait: wait,
                    shouldSplitBatch (requests) {
                        return requests.length > batchSize;
                    },
                    fn: (body)=>(0, $9EPcc.rpc).http(url_, {
                            body: body,
                            fetchOptions: fetchOptions,
                            timeout: timeout
                        }),
                    sort: (a, b)=>a.id - b.id
                });
                const fn = async (body)=>batch ? schedule(body) : [
                        await (0, $9EPcc.rpc).http(url_, {
                            body: body,
                            fetchOptions: fetchOptions,
                            timeout: timeout
                        })
                    ];
                const [{ error: error, result: result }] = await fn(body);
                if (error) throw new (0, $fG0ph.RpcRequestError)({
                    body: body,
                    error: error,
                    url: url_
                });
                return result;
            },
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: "http"
        }, {
            fetchOptions: fetchOptions,
            url: url
        });
    };
}

});
parcelRegister("alGS0", function(module, exports) {

$parcel$export(module.exports, "UrlRequiredError", function () { return $788d1ea359ce2fc7$export$d0a48bf953f3c239; });

var $hwGC1 = parcelRequire("hwGC1");
class $788d1ea359ce2fc7$export$d0a48bf953f3c239 extends (0, $hwGC1.BaseError) {
    constructor(){
        super("No URL was provided to the Transport. Please provide a valid RPC URL to the Transport.", {
            docsPath: "/docs/clients/intro"
        });
    }
}

});

parcelRegister("9EPcc", function(module, exports) {

$parcel$export(module.exports, "getSocket", function () { return $707f8feb381de775$export$361cf94c2d913fd4; });
$parcel$export(module.exports, "rpc", function () { return $707f8feb381de775$export$82f5954781486db2; });

var $4QCGV = parcelRequire("4QCGV");

var $fG0ph = parcelRequire("fG0ph");

var $c4rHA = parcelRequire("c4rHA");

var $7lqVq = parcelRequire("7lqVq");

var $peKQ1 = parcelRequire("peKQ1");
let $707f8feb381de775$var$id = 0;
async function $707f8feb381de775$var$http(url, { body: body, fetchOptions: fetchOptions = {}, timeout: timeout = 10000 }) {
    const { headers: headers, method: method, signal: signal_ } = fetchOptions;
    try {
        const response = await (0, $7lqVq.withTimeout)(async ({ signal: signal })=>{
            const response = await fetch(url, {
                ...fetchOptions,
                body: Array.isArray(body) ? (0, $peKQ1.stringify)(body.map((body)=>({
                        jsonrpc: "2.0",
                        id: body.id ?? $707f8feb381de775$var$id++,
                        ...body
                    }))) : (0, $peKQ1.stringify)({
                    jsonrpc: "2.0",
                    id: body.id ?? $707f8feb381de775$var$id++,
                    ...body
                }),
                headers: {
                    ...headers,
                    "Content-Type": "application/json"
                },
                method: method || "POST",
                signal: signal_ || (timeout > 0 ? signal : undefined)
            });
            return response;
        }, {
            errorInstance: new (0, $fG0ph.TimeoutError)({
                body: body,
                url: url
            }),
            timeout: timeout,
            signal: true
        });
        let data;
        if (response.headers.get("Content-Type")?.startsWith("application/json")) data = await response.json();
        else data = await response.text();
        if (!response.ok) throw new (0, $fG0ph.HttpRequestError)({
            body: body,
            details: (0, $peKQ1.stringify)(data.error) || response.statusText,
            headers: response.headers,
            status: response.status,
            url: url
        });
        return data;
    } catch (err) {
        if (err instanceof (0, $fG0ph.HttpRequestError)) throw err;
        if (err instanceof (0, $fG0ph.TimeoutError)) throw err;
        throw new (0, $fG0ph.HttpRequestError)({
            body: body,
            details: err.message,
            url: url
        });
    }
}
const $707f8feb381de775$export$d1a9365cd3e8f4dd = /*#__PURE__*/ new Map();
async function $707f8feb381de775$export$361cf94c2d913fd4(url) {
    let socket = $707f8feb381de775$export$d1a9365cd3e8f4dd.get(url);
    // If the socket already exists, return it.
    if (socket) return socket;
    const { schedule: schedule } = (0, $c4rHA.createBatchScheduler)({
        id: url,
        fn: async ()=>{
            const webSocket = new (0, $4QCGV.WebSocket)(url);
            // Set up a cache for incoming "synchronous" requests.
            const requests = new Map();
            // Set up a cache for subscriptions (eth_subscribe).
            const subscriptions = new Map();
            const onMessage = ({ data: data })=>{
                const message = JSON.parse(data);
                const isSubscription = message.method === "eth_subscription";
                const id = isSubscription ? message.params.subscription : message.id;
                const cache = isSubscription ? subscriptions : requests;
                const callback = cache.get(id);
                if (callback) callback({
                    data: data
                });
                if (!isSubscription) cache.delete(id);
            };
            const onClose = ()=>{
                $707f8feb381de775$export$d1a9365cd3e8f4dd.delete(url);
                webSocket.removeEventListener("close", onClose);
                webSocket.removeEventListener("message", onMessage);
            };
            // Setup event listeners for RPC & subscription responses.
            webSocket.addEventListener("close", onClose);
            webSocket.addEventListener("message", onMessage);
            // Wait for the socket to open.
            if (webSocket.readyState === (0, $4QCGV.WebSocket).CONNECTING) await new Promise((resolve, reject)=>{
                if (!webSocket) return;
                webSocket.onopen = resolve;
                webSocket.onerror = reject;
            });
            // Create a new socket instance.
            socket = Object.assign(webSocket, {
                requests: requests,
                subscriptions: subscriptions
            });
            $707f8feb381de775$export$d1a9365cd3e8f4dd.set(url, socket);
            return [
                socket
            ];
        }
    });
    const [_, [socket_]] = await schedule();
    return socket_;
}
function $707f8feb381de775$var$webSocket(socket, { body: body, onResponse: onResponse }) {
    if (socket.readyState === socket.CLOSED || socket.readyState === socket.CLOSING) throw new (0, $fG0ph.WebSocketRequestError)({
        body: body,
        url: socket.url,
        details: "Socket is closed."
    });
    const id_ = $707f8feb381de775$var$id++;
    const callback = ({ data: data })=>{
        const message = JSON.parse(data);
        if (typeof message.id === "number" && id_ !== message.id) return;
        onResponse?.(message);
        // If we are subscribing to a topic, we want to set up a listener for incoming
        // messages.
        if (body.method === "eth_subscribe" && typeof message.result === "string") socket.subscriptions.set(message.result, callback);
        // If we are unsubscribing from a topic, we want to remove the listener.
        if (body.method === "eth_unsubscribe") socket.subscriptions.delete(body.params?.[0]);
    };
    socket.requests.set(id_, callback);
    socket.send(JSON.stringify({
        jsonrpc: "2.0",
        ...body,
        id: id_
    }));
    return socket;
}
async function $707f8feb381de775$var$webSocketAsync(socket, { body: body, timeout: timeout = 10000 }) {
    return (0, $7lqVq.withTimeout)(()=>new Promise((onResponse)=>$707f8feb381de775$export$82f5954781486db2.webSocket(socket, {
                body: body,
                onResponse: onResponse
            })), {
        errorInstance: new (0, $fG0ph.TimeoutError)({
            body: body,
            url: socket.url
        }),
        timeout: timeout
    });
}
const $707f8feb381de775$export$82f5954781486db2 = {
    http: $707f8feb381de775$var$http,
    webSocket: $707f8feb381de775$var$webSocket,
    webSocketAsync: $707f8feb381de775$var$webSocketAsync
};

});
parcelRegister("4QCGV", function(module, exports) {

$parcel$export(module.exports, "WebSocket", function () { return $387a080dbb54bf2d$export$3909fb301d3dc8c9; });

var $jHGH4 = parcelRequire("jHGH4");
const $387a080dbb54bf2d$export$3909fb301d3dc8c9 = (0, $jHGH4.getNativeWebSocket)();

});
parcelRegister("jHGH4", function(module, exports) {

$parcel$export(module.exports, "getNativeWebSocket", function () { return $e5832692b763d345$export$f67cfa4655f7ea21; });
function $e5832692b763d345$export$f67cfa4655f7ea21() {
    if (typeof WebSocket !== "undefined") return WebSocket;
    if (typeof $parcel$global.WebSocket !== "undefined") return $parcel$global.WebSocket;
    if (typeof window.WebSocket !== "undefined") return window.WebSocket;
    if (typeof self.WebSocket !== "undefined") return self.WebSocket;
    throw new Error("`WebSocket` is not supported in this environment");
}

});


parcelRegister("7lqVq", function(module, exports) {

$parcel$export(module.exports, "withTimeout", function () { return $558f615ac22dd146$export$e86e19342bc4850e; });
function $558f615ac22dd146$export$e86e19342bc4850e(fn, { errorInstance: errorInstance = new Error("timed out"), timeout: timeout, signal: signal }) {
    return new Promise((resolve, reject)=>{
        (async ()=>{
            let timeoutId;
            try {
                const controller = new AbortController();
                if (timeout > 0) timeoutId = setTimeout(()=>{
                    if (signal) controller.abort();
                    else reject(errorInstance);
                }, timeout);
                resolve(await fn({
                    signal: controller?.signal
                }));
            } catch (err) {
                if (err.name === "AbortError") reject(errorInstance);
                reject(err);
            } finally{
                clearTimeout(timeoutId);
            }
        })();
    });
}

});



parcelRegister("elMwh", function(module, exports) {

$parcel$export(module.exports, "parseGwei", function () { return $a728a9da521b9327$export$7a255715fecbb534; });

var $52Zu6 = parcelRequire("52Zu6");

var $k3teG = parcelRequire("k3teG");
function $a728a9da521b9327$export$7a255715fecbb534(ether, unit = "wei") {
    return (0, $k3teG.parseUnits)(ether, (0, $52Zu6.gweiUnits)[unit]);
}

});
parcelRegister("k3teG", function(module, exports) {

$parcel$export(module.exports, "parseUnits", function () { return $e99ac4163ec05187$export$203ae30b4f6490b3; });
/**
 * Multiplies a string representation of a number by a given exponent of base 10 (10exponent).
 *
 * - Docs: https://viem.sh/docs/utilities/parseUnits.html
 *
 * @example
 * import { parseUnits } from 'viem'
 *
 * parseUnits('420', 9)
 * // 420000000000n
 */ function $e99ac4163ec05187$export$203ae30b4f6490b3(value, decimals) {
    let [integer, fraction = "0"] = value.split(".");
    const negative = integer.startsWith("-");
    if (negative) integer = integer.slice(1);
    // trim leading zeros.
    fraction = fraction.replace(/(0+)$/, "");
    // round off if the fraction is larger than the number of decimals.
    if (decimals === 0) {
        if (Math.round(Number(`.${fraction}`)) === 1) integer = `${BigInt(integer) + 1n}`;
        fraction = "";
    } else if (fraction.length > decimals) {
        const [left, unit, right] = [
            fraction.slice(0, decimals - 1),
            fraction.slice(decimals - 1, decimals),
            fraction.slice(decimals)
        ];
        const rounded = Math.round(Number(`${unit}.${right}`));
        if (rounded > 9) fraction = `${BigInt(left) + BigInt(1)}0`.padStart(left.length + 1, "0");
        else fraction = `${left}${rounded}`;
        if (fraction.length > decimals) {
            fraction = fraction.slice(1);
            integer = `${BigInt(integer) + 1n}`;
        }
        fraction = fraction.slice(0, decimals);
    } else fraction = fraction.padEnd(decimals, "0");
    return BigInt(`${negative ? "-" : ""}${integer}${fraction}`);
}

});


parcelRegister("4UOEQ", function(module, exports) {

$parcel$export(module.exports, "webSocket", function () { return $3943affa7869e5b1$export$debf5095acd2163f; });

var $fG0ph = parcelRequire("fG0ph");

var $alGS0 = parcelRequire("alGS0");

var $9EPcc = parcelRequire("9EPcc");

var $70vH0 = parcelRequire("70vH0");
function $3943affa7869e5b1$export$debf5095acd2163f(/** URL of the JSON-RPC API. Defaults to the chain's public RPC URL. */ url, config = {}) {
    const { key: key = "webSocket", name: name = "WebSocket JSON-RPC", retryDelay: retryDelay } = config;
    return ({ chain: chain, retryCount: retryCount_, timeout: timeout_ })=>{
        const retryCount = config.retryCount ?? retryCount_;
        const timeout = timeout_ ?? config.timeout ?? 10000;
        const url_ = url || chain?.rpcUrls.default.webSocket?.[0];
        if (!url_) throw new (0, $alGS0.UrlRequiredError)();
        return (0, $70vH0.createTransport)({
            key: key,
            name: name,
            async request ({ method: method, params: params }) {
                const body = {
                    method: method,
                    params: params
                };
                const socket = await (0, $9EPcc.getSocket)(url_);
                const { error: error, result: result } = await (0, $9EPcc.rpc).webSocketAsync(socket, {
                    body: body,
                    timeout: timeout
                });
                if (error) throw new (0, $fG0ph.RpcRequestError)({
                    body: body,
                    error: error,
                    url: url_
                });
                return result;
            },
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: "webSocket"
        }, {
            getSocket () {
                return (0, $9EPcc.getSocket)(url_);
            },
            async subscribe ({ params: params, onData: onData, onError: onError }) {
                const socket = await (0, $9EPcc.getSocket)(url_);
                const { result: subscriptionId } = await new Promise((resolve, reject)=>(0, $9EPcc.rpc).webSocket(socket, {
                        body: {
                            method: "eth_subscribe",
                            params: params
                        },
                        onResponse (response) {
                            if (response.error) {
                                reject(response.error);
                                onError?.(response.error);
                                return;
                            }
                            if (typeof response.id === "number") {
                                resolve(response);
                                return;
                            }
                            if (response.method !== "eth_subscription") return;
                            onData(response.params);
                        }
                    }));
                return {
                    subscriptionId: subscriptionId,
                    async unsubscribe () {
                        return new Promise((resolve)=>(0, $9EPcc.rpc).webSocket(socket, {
                                body: {
                                    method: "eth_unsubscribe",
                                    params: [
                                        subscriptionId
                                    ]
                                },
                                onResponse: resolve
                            }));
                    }
                };
            }
        });
    };
}

});

parcelRegister("co8BQ", function(module, exports) {

$parcel$export(module.exports, "persist", function () { return $0253d8614e23c8eb$export$9a6132153fba2e0; }, function (v) { return $0253d8614e23c8eb$export$9a6132153fba2e0 = v; });
$parcel$export(module.exports, "subscribeWithSelector", function () { return $0253d8614e23c8eb$export$5c593627aef9f076; }, function (v) { return $0253d8614e23c8eb$export$5c593627aef9f076 = v; });
var $0253d8614e23c8eb$export$1be1fc439b849fdf;
var $0253d8614e23c8eb$export$95a3b7b12ab518f9;
var $0253d8614e23c8eb$export$6922d3b3a607469e;
var $0253d8614e23c8eb$export$9a6132153fba2e0;
var $0253d8614e23c8eb$export$4feba8a1bc8e9afd;
var $0253d8614e23c8eb$export$5c593627aef9f076;
"use strict";
function $0253d8614e23c8eb$var$_extends() {
    $0253d8614e23c8eb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0253d8614e23c8eb$var$_extends.apply(this, arguments);
}
function $0253d8614e23c8eb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0253d8614e23c8eb$var$reduxImpl = function reduxImpl(reducer, initial) {
    return function(set, _get, api) {
        api.dispatch = function(action) {
            set(function(state) {
                return reducer(state, action);
            }, false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return $0253d8614e23c8eb$var$_extends({
            dispatch: function dispatch() {
                var _ref;
                return (_ref = api).dispatch.apply(_ref, arguments);
            }
        }, initial);
    };
};
var $0253d8614e23c8eb$var$redux = $0253d8614e23c8eb$var$reduxImpl;
var $0253d8614e23c8eb$var$_excluded = [
    "enabled",
    "anonymousActionType",
    "store"
], $0253d8614e23c8eb$var$_excluded2 = [
    "connection"
];
var $0253d8614e23c8eb$var$trackedConnections = new Map();
var $0253d8614e23c8eb$var$getTrackedConnectionState = function getTrackedConnectionState(name) {
    var api = $0253d8614e23c8eb$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(function(_ref) {
        var key = _ref[0], api = _ref[1];
        return [
            key,
            api.getState()
        ];
    }));
};
var $0253d8614e23c8eb$var$extractConnectionInformation = function extractConnectionInformation(store, extensionConnector, options) {
    if (store === undefined) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    var existingConnection = $0253d8614e23c8eb$var$trackedConnections.get(options.name);
    if (existingConnection) return $0253d8614e23c8eb$var$_extends({
        type: "tracked",
        store: store
    }, existingConnection);
    var newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $0253d8614e23c8eb$var$trackedConnections.set(options.name, newConnection);
    return $0253d8614e23c8eb$var$_extends({
        type: "tracked",
        store: store
    }, newConnection);
};
var $0253d8614e23c8eb$var$devtoolsImpl = function devtoolsImpl(fn, devtoolsOptions) {
    if (devtoolsOptions === void 0) devtoolsOptions = {};
    return function(set, get, api) {
        var _devtoolsOptions = devtoolsOptions, enabled = _devtoolsOptions.enabled, anonymousActionType = _devtoolsOptions.anonymousActionType, store = _devtoolsOptions.store, options = $0253d8614e23c8eb$var$_objectWithoutPropertiesLoose(_devtoolsOptions, $0253d8614e23c8eb$var$_excluded);
        var extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : false) && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) return fn(set, get, api);
        var _extractConnectionInf = $0253d8614e23c8eb$var$extractConnectionInformation(store, extensionConnector, options), connection = _extractConnectionInf.connection, connectionInformation = $0253d8614e23c8eb$var$_objectWithoutPropertiesLoose(_extractConnectionInf, $0253d8614e23c8eb$var$_excluded2);
        var isRecording = true;
        api.setState = function(state, replace, nameOrAction) {
            var _extends2;
            var r = set(state, replace);
            if (!isRecording) return r;
            var action = nameOrAction === undefined ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === undefined) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send($0253d8614e23c8eb$var$_extends({}, action, {
                type: store + "/" + action.type
            }), $0253d8614e23c8eb$var$_extends({}, $0253d8614e23c8eb$var$getTrackedConnectionState(options.name), (_extends2 = {}, _extends2[store] = api.getState(), _extends2)));
            return r;
        };
        var setStateFromDevtools = function setStateFromDevtools() {
            var originalIsRecording = isRecording;
            isRecording = false;
            set.apply(void 0, arguments);
            isRecording = originalIsRecording;
        };
        var initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(function(_ref2) {
                var key = _ref2[0], store = _ref2[1];
                return [
                    key,
                    key === connectionInformation.store ? initialState : store.getState()
                ];
            })));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            var didWarnAboutReservedActionType = false;
            var originalDispatch = api.dispatch;
            api.dispatch = function() {
                for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++)a[_key] = arguments[_key];
                originalDispatch.apply(void 0, a);
            };
        }
        connection.subscribe(function(message) {
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $0253d8614e23c8eb$var$parseJsonThen(message.payload, function(action) {
                        if (action.type === "__setState") {
                            if (store === undefined) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error('\n                    [zustand devtools middleware] Unsupported __setState action format. \n                    When using \'store\' option in devtools(), the \'state\' should have only one key, which is a value of \'store\' that was passed in devtools(),\n                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }\n                    ');
                            var stateFromDevtools = action.state[store];
                            if (stateFromDevtools === undefined || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === undefined) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($0253d8614e23c8eb$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === undefined) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($0253d8614e23c8eb$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $0253d8614e23c8eb$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($0253d8614e23c8eb$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $0253d8614e23c8eb$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            var _nextLiftedState$comp;
                            var nextLiftedState = message.payload.nextLiftedState;
                            var lastComputedState = (_nextLiftedState$comp = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _nextLiftedState$comp.state;
                            if (!lastComputedState) return;
                            if (store === undefined) setStateFromDevtools(lastComputedState);
                            else setStateFromDevtools(lastComputedState[store]);
                            connection == null || connection.send(null, nextLiftedState);
                            return;
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
};
var $0253d8614e23c8eb$var$devtools = $0253d8614e23c8eb$var$devtoolsImpl;
var $0253d8614e23c8eb$var$parseJsonThen = function parseJsonThen(stringified, f) {
    var parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== undefined) f(parsed);
};
var $0253d8614e23c8eb$var$subscribeWithSelectorImpl = function subscribeWithSelectorImpl(fn) {
    return function(set, get, api) {
        var origSubscribe = api.subscribe;
        api.subscribe = function(selector, optListener, options) {
            var listener = selector;
            if (optListener) {
                var equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                var currentSlice = selector(api.getState());
                listener = function listener(state) {
                    var nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        var previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options != null && options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        var initialState = fn(set, get, api);
        return initialState;
    };
};
var $0253d8614e23c8eb$var$subscribeWithSelector = $0253d8614e23c8eb$var$subscribeWithSelectorImpl;
var $0253d8614e23c8eb$var$combine = function combine(initialState, create) {
    return function() {
        return Object.assign({}, initialState, create.apply(void 0, arguments));
    };
};
function $0253d8614e23c8eb$var$createJSONStorage(getStorage, options) {
    var storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    var persistStorage = {
        getItem: function getItem(name) {
            var _getItem;
            var parse = function parse(str) {
                if (str === null) return null;
                return JSON.parse(str, options == null ? void 0 : options.reviver);
            };
            var str = (_getItem = storage.getItem(name)) != null ? _getItem : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: function setItem(name, newValue) {
            return storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer));
        },
        removeItem: function removeItem(name) {
            return storage.removeItem(name);
        }
    };
    return persistStorage;
}
var $0253d8614e23c8eb$var$toThenable = function toThenable(fn) {
    return function(input) {
        try {
            var result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then: function then(onFulfilled) {
                    return toThenable(onFulfilled)(result);
                },
                catch: function _catch(_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then: function then(_onFulfilled) {
                    return this;
                },
                catch: function _catch(onRejected) {
                    return toThenable(onRejected)(e);
                }
            };
        }
    };
};
var $0253d8614e23c8eb$var$oldImpl = function oldImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $0253d8614e23c8eb$var$_extends({
            getStorage: function getStorage() {
                return localStorage;
            },
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $0253d8614e23c8eb$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var thenableSerialize = $0253d8614e23c8eb$var$toThenable(options.serialize);
        var setItem = function setItem() {
            var state = options.partialize($0253d8614e23c8eb$var$_extends({}, get()));
            var errorInSync;
            var thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then(function(serializedValue) {
                return storage.setItem(options.name, serializedValue);
            }).catch(function(e) {
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        var stateFromStorage;
        var hydrate = function hydrate() {
            if (!storage) return;
            _hasHydrated = false;
            hydrationListeners.forEach(function(cb) {
                return cb(get());
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage(get())) || undefined;
            return $0253d8614e23c8eb$var$toThenable(storage.getItem.bind(storage))(options.name).then(function(storageValue) {
                if (storageValue) return options.deserialize(storageValue);
            }).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                var _get;
                stateFromStorage = options.merge(migratedState, (_get = get()) != null ? _get : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                _hasHydrated = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $0253d8614e23c8eb$var$_extends({}, options, newOptions);
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: function clearStorage() {
                var _storage;
                (_storage = storage) == null || _storage.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
};
var $0253d8614e23c8eb$var$newImpl = function newImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $0253d8614e23c8eb$var$_extends({
            storage: $0253d8614e23c8eb$var$createJSONStorage(function() {
                return localStorage;
            }),
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $0253d8614e23c8eb$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated2 = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage = options.storage;
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var setItem = function setItem() {
            var state = options.partialize($0253d8614e23c8eb$var$_extends({}, get()));
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        var stateFromStorage;
        var hydrate = function hydrate() {
            var _get3;
            if (!storage) return;
            _hasHydrated2 = false;
            hydrationListeners.forEach(function(cb) {
                var _get2;
                return cb((_get2 = get()) != null ? _get2 : configResult);
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage((_get3 = get()) != null ? _get3 : configResult)) || undefined;
            return $0253d8614e23c8eb$var$toThenable(storage.getItem.bind(storage))(options.name).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                var _get4;
                stateFromStorage = options.merge(migratedState, (_get4 = get()) != null ? _get4 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                stateFromStorage = get();
                _hasHydrated2 = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $0253d8614e23c8eb$var$_extends({}, options, newOptions);
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: function clearStorage() {
                var _storage2;
                (_storage2 = storage) == null || _storage2.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated2;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
};
var $0253d8614e23c8eb$var$persistImpl = function persistImpl(config, baseOptions) {
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) return $0253d8614e23c8eb$var$oldImpl(config, baseOptions);
    return $0253d8614e23c8eb$var$newImpl(config, baseOptions);
};
var $0253d8614e23c8eb$var$persist = $0253d8614e23c8eb$var$persistImpl;
$0253d8614e23c8eb$export$1be1fc439b849fdf = $0253d8614e23c8eb$var$combine;
$0253d8614e23c8eb$export$95a3b7b12ab518f9 = $0253d8614e23c8eb$var$createJSONStorage;
$0253d8614e23c8eb$export$6922d3b3a607469e = $0253d8614e23c8eb$var$devtools;
$0253d8614e23c8eb$export$9a6132153fba2e0 = $0253d8614e23c8eb$var$persist;
$0253d8614e23c8eb$export$4feba8a1bc8e9afd = $0253d8614e23c8eb$var$redux;
$0253d8614e23c8eb$export$5c593627aef9f076 = $0253d8614e23c8eb$var$subscribeWithSelector;

});

parcelRegister("jjoSA", function(module, exports) {
"use strict";
var $e0f317390df10659$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
};
var $e0f317390df10659$var$createStore = function createStore(createState) {
    return createState ? $e0f317390df10659$var$createStoreImpl(createState) : $e0f317390df10659$var$createStoreImpl;
};
var $e0f317390df10659$var$vanilla = function(createState) {
    return $e0f317390df10659$var$createStore(createState);
};
module.exports.createStore = $e0f317390df10659$var$createStore;
module.exports.default = $e0f317390df10659$var$vanilla;
module.exports = $e0f317390df10659$var$vanilla;
module.exports.createStore = $e0f317390df10659$var$createStore;
module.exports.default = module.exports;

});

parcelRegister("gxDlk", function(module, exports) {
"use strict";
function $c0ae3f1f218eae4c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c0ae3f1f218eae4c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c0ae3f1f218eae4c$var$_arrayLikeToArray(o, minLen);
}
function $c0ae3f1f218eae4c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c0ae3f1f218eae4c$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $c0ae3f1f218eae4c$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c0ae3f1f218eae4c$var$shallow$1(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    if (objA instanceof Map && objB instanceof Map) {
        if (objA.size !== objB.size) return false;
        for(var _iterator = $c0ae3f1f218eae4c$var$_createForOfIteratorHelperLoose(objA), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            if (!Object.is(value, objB.get(key))) return false;
        }
        return true;
    }
    if (objA instanceof Set && objB instanceof Set) {
        if (objA.size !== objB.size) return false;
        for(var _iterator2 = $c0ae3f1f218eae4c$var$_createForOfIteratorHelperLoose(objA), _step2; !(_step2 = _iterator2()).done;){
            var _value = _step2.value;
            if (!objB.has(_value)) return false;
        }
        return true;
    }
    var keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
var $c0ae3f1f218eae4c$var$shallow = function(objA, objB) {
    return $c0ae3f1f218eae4c$var$shallow$1(objA, objB);
};
module.exports.default = $c0ae3f1f218eae4c$var$shallow;
module.exports.shallow = $c0ae3f1f218eae4c$var$shallow$1;
module.exports = $c0ae3f1f218eae4c$var$shallow;
module.exports.shallow = $c0ae3f1f218eae4c$var$shallow$1;
module.exports.default = module.exports;

});

parcelRegister("knIGM", function(module, exports) {


module.exports = (parcelRequire("cKPUe"))((parcelRequire("jwisd")).resolve("fZo0x")).then(()=>parcelRequire("5jHDe"));

});


parcelRegister("57KGK", function(module, exports) {

$parcel$export(module.exports, "parseChainId", function () { return $3bb1d28ab2c881a5$export$4764229d78de4437; });
$parcel$export(module.exports, "getAccountsFromNamespaces", function () { return $3bb1d28ab2c881a5$export$23329703ad972840; });
$parcel$export(module.exports, "BASE16", function () { return $3bb1d28ab2c881a5$export$49eb910ab2518105; });
$parcel$export(module.exports, "TYPE_1", function () { return $3bb1d28ab2c881a5$export$406e97c329f0f3d4; });
$parcel$export(module.exports, "generateKeyPair", function () { return $3bb1d28ab2c881a5$export$a949d36eab55b41f; });
$parcel$export(module.exports, "generateRandomBytes32", function () { return $3bb1d28ab2c881a5$export$d15a28e4f1821243; });
$parcel$export(module.exports, "deriveSymKey", function () { return $3bb1d28ab2c881a5$export$f8378f68e053f5c6; });
$parcel$export(module.exports, "hashKey", function () { return $3bb1d28ab2c881a5$export$1e87d19d4aab5805; });
$parcel$export(module.exports, "hashMessage", function () { return $3bb1d28ab2c881a5$export$d4c241cec96564c1; });
$parcel$export(module.exports, "decodeTypeByte", function () { return $3bb1d28ab2c881a5$export$7547a514ee29b9d4; });
$parcel$export(module.exports, "encrypt", function () { return $3bb1d28ab2c881a5$export$5b0f6292f11d1d18; });
$parcel$export(module.exports, "decrypt", function () { return $3bb1d28ab2c881a5$export$e85a0c9a1067c5d3; });
$parcel$export(module.exports, "deserialize", function () { return $3bb1d28ab2c881a5$export$efcd34ab6248d3cd; });
$parcel$export(module.exports, "validateDecoding", function () { return $3bb1d28ab2c881a5$export$177f3e316562333d; });
$parcel$export(module.exports, "validateEncoding", function () { return $3bb1d28ab2c881a5$export$7949f60f2444aef2; });
$parcel$export(module.exports, "isTypeOneEnvelope", function () { return $3bb1d28ab2c881a5$export$8c165704db2d5c15; });
$parcel$export(module.exports, "isNode", function () { return $3bb1d28ab2c881a5$export$8ee0fc9ee280b4ee; });
$parcel$export(module.exports, "isReactNative", function () { return $3bb1d28ab2c881a5$export$f7a1e23e542d38e3; });
$parcel$export(module.exports, "isBrowser", function () { return $3bb1d28ab2c881a5$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "getBundleId", function () { return $3bb1d28ab2c881a5$export$40a40f90174d197c; });
$parcel$export(module.exports, "getAppMetadata", function () { return $3bb1d28ab2c881a5$export$ba31e015127122bb; });
$parcel$export(module.exports, "formatRelayRpcUrl", function () { return $3bb1d28ab2c881a5$export$d875b3963ef774f5; });
$parcel$export(module.exports, "mapToObj", function () { return $3bb1d28ab2c881a5$export$c4b8dfeb6e237eb9; });
$parcel$export(module.exports, "objToMap", function () { return $3bb1d28ab2c881a5$export$ac31b37c726bc3ba; });
$parcel$export(module.exports, "createDelayedPromise", function () { return $3bb1d28ab2c881a5$export$cbf9e3cc9ffc85cb; });
$parcel$export(module.exports, "createExpiringPromise", function () { return $3bb1d28ab2c881a5$export$3da2293b007ed708; });
$parcel$export(module.exports, "formatTopicTarget", function () { return $3bb1d28ab2c881a5$export$43ab92477f8713b9; });
$parcel$export(module.exports, "formatIdTarget", function () { return $3bb1d28ab2c881a5$export$bd13103c2e5cc0c3; });
$parcel$export(module.exports, "parseExpirerTarget", function () { return $3bb1d28ab2c881a5$export$93adeb0f16e8e51d; });
$parcel$export(module.exports, "calcExpiry", function () { return $3bb1d28ab2c881a5$export$b136d03015bfc12; });
$parcel$export(module.exports, "isExpired", function () { return $3bb1d28ab2c881a5$export$57947cfd429801a2; });
$parcel$export(module.exports, "engineEvent", function () { return $3bb1d28ab2c881a5$export$e3eb27ce66c0f6d9; });
$parcel$export(module.exports, "mergeArrays", function () { return $3bb1d28ab2c881a5$export$9826fe7ad3921016; });
$parcel$export(module.exports, "handleDeeplinkRedirect", function () { return $3bb1d28ab2c881a5$export$694a208c8abca99a; });
$parcel$export(module.exports, "getDeepLink", function () { return $3bb1d28ab2c881a5$export$e55bfdac47149a32; });
$parcel$export(module.exports, "getRelayProtocolName", function () { return $3bb1d28ab2c881a5$export$cf77af25151525db; });
$parcel$export(module.exports, "getRelayProtocolApi", function () { return $3bb1d28ab2c881a5$export$604e3deb95e1b734; });
$parcel$export(module.exports, "parseUri", function () { return $3bb1d28ab2c881a5$export$59f58847421cfb28; });
$parcel$export(module.exports, "formatUri", function () { return $3bb1d28ab2c881a5$export$b2786ede34fb2350; });
$parcel$export(module.exports, "getRequiredNamespacesFromNamespaces", function () { return $3bb1d28ab2c881a5$export$a8daa26a7c60ef90; });
$parcel$export(module.exports, "isValidNamespaces", function () { return $3bb1d28ab2c881a5$export$93f7b81dc815a714; });
$parcel$export(module.exports, "normalizeNamespaces", function () { return $3bb1d28ab2c881a5$export$2994550cda701c96; });
$parcel$export(module.exports, "isConformingNamespaces", function () { return $3bb1d28ab2c881a5$export$ba5b0a4b585cd1b4; });
$parcel$export(module.exports, "isCaipNamespace", function () { return $3bb1d28ab2c881a5$export$e03e993df4723bde; });
$parcel$export(module.exports, "parseNamespaceKey", function () { return $3bb1d28ab2c881a5$export$dd404c96fbbb1ff8; });
$parcel$export(module.exports, "isValidObject", function () { return $3bb1d28ab2c881a5$export$16a0268bc22b47b0; });
$parcel$export(module.exports, "getInternalError", function () { return $3bb1d28ab2c881a5$export$500d4c4a8fafe35; });
$parcel$export(module.exports, "getSdkError", function () { return $3bb1d28ab2c881a5$export$8203ef1531c8b5b5; });
$parcel$export(module.exports, "isValidArray", function () { return $3bb1d28ab2c881a5$export$41dd3d480aac4a71; });
$parcel$export(module.exports, "isUndefined", function () { return $3bb1d28ab2c881a5$export$fce6876652108ab; });
$parcel$export(module.exports, "isValidString", function () { return $3bb1d28ab2c881a5$export$ee898ca48ab56c74; });
$parcel$export(module.exports, "isSessionCompatible", function () { return $3bb1d28ab2c881a5$export$6fc4971bf8f326a; });
$parcel$export(module.exports, "isValidUrl", function () { return $3bb1d28ab2c881a5$export$bef94a5618bf18bf; });
$parcel$export(module.exports, "isProposalStruct", function () { return $3bb1d28ab2c881a5$export$f657f7976bb2769d; });
$parcel$export(module.exports, "isSessionStruct", function () { return $3bb1d28ab2c881a5$export$c96d5113768aaf5e; });
$parcel$export(module.exports, "isValidController", function () { return $3bb1d28ab2c881a5$export$5e1c5c89613c213f; });
$parcel$export(module.exports, "isValidRequiredNamespaces", function () { return $3bb1d28ab2c881a5$export$9e2b2cae22c6a8b3; });
$parcel$export(module.exports, "isValidRelay", function () { return $3bb1d28ab2c881a5$export$1b3fc298be8c9a7b; });
$parcel$export(module.exports, "isValidRelays", function () { return $3bb1d28ab2c881a5$export$6294c30b976bd21e; });
$parcel$export(module.exports, "isValidId", function () { return $3bb1d28ab2c881a5$export$53551be28ad5e34d; });
$parcel$export(module.exports, "isValidParams", function () { return $3bb1d28ab2c881a5$export$b3f5fcca1d210454; });
$parcel$export(module.exports, "isValidErrorReason", function () { return $3bb1d28ab2c881a5$export$766fe78377d96f2a; });
$parcel$export(module.exports, "isValidRequest", function () { return $3bb1d28ab2c881a5$export$1a2af3c017fb6d42; });
$parcel$export(module.exports, "isValidResponse", function () { return $3bb1d28ab2c881a5$export$1ae38cf0a848f651; });
$parcel$export(module.exports, "isValidEvent", function () { return $3bb1d28ab2c881a5$export$cbe4cdc5960cfa11; });
$parcel$export(module.exports, "isValidNamespacesChainId", function () { return $3bb1d28ab2c881a5$export$144fc36610eb6522; });
$parcel$export(module.exports, "isValidNamespacesRequest", function () { return $3bb1d28ab2c881a5$export$8db4804e3a6de711; });
$parcel$export(module.exports, "isValidNamespacesEvent", function () { return $3bb1d28ab2c881a5$export$df2c67ef8baad16b; });
$parcel$export(module.exports, "isValidRequestExpiry", function () { return $3bb1d28ab2c881a5$export$59fba2af1ac782b; });
$parcel$export(module.exports, "isOnline", function () { return $3bb1d28ab2c881a5$export$53c2fd0173ad2b80; });
$parcel$export(module.exports, "subscribeToNetworkChange", function () { return $3bb1d28ab2c881a5$export$600a1ee4bc680996; });
$parcel$export(module.exports, "MemoryStore", function () { return $3bb1d28ab2c881a5$export$b72d712fed4d036d; });

var $d2sHe = parcelRequire("d2sHe");

var $cWicQ = parcelRequire("cWicQ");

var $6CzCo = parcelRequire("6CzCo");

var $fhdxA = parcelRequire("fhdxA");

var $5qHj8 = parcelRequire("5qHj8");

var $4hI5Z = parcelRequire("4hI5Z");

var $7gpqF = parcelRequire("7gpqF");

var $aGNdt = parcelRequire("aGNdt");

var $6qPmi = parcelRequire("6qPmi");

var $bsIGZ = parcelRequire("bsIGZ");

var $3J7fK = parcelRequire("3J7fK");
parcelRequire("6e20P");
var $5HwuL = parcelRequire("5HwuL");

var $bNDrn = parcelRequire("bNDrn");
const $3bb1d28ab2c881a5$var$K = ":";
function $3bb1d28ab2c881a5$export$4764229d78de4437(e) {
    const [n, t] = e.split($3bb1d28ab2c881a5$var$K);
    return {
        namespace: n,
        reference: t
    };
}
function $3bb1d28ab2c881a5$export$a5999672e4930644(e) {
    const { namespace: n, reference: t } = e;
    return [
        n,
        t
    ].join($3bb1d28ab2c881a5$var$K);
}
function $3bb1d28ab2c881a5$export$276ab0158c66e3d(e) {
    const [n, t, r] = e.split($3bb1d28ab2c881a5$var$K);
    return {
        namespace: n,
        reference: t,
        address: r
    };
}
function $3bb1d28ab2c881a5$export$566a25328fb93a18(e) {
    const { namespace: n, reference: t, address: r } = e;
    return [
        n,
        t,
        r
    ].join($3bb1d28ab2c881a5$var$K);
}
function $3bb1d28ab2c881a5$export$d579bc26e95946b5(e, n) {
    const t = [];
    return e.forEach((r)=>{
        const o = n(r);
        t.includes(o) || t.push(o);
    }), t;
}
function $3bb1d28ab2c881a5$export$2806d446053abd1d(e) {
    const { address: n } = $3bb1d28ab2c881a5$export$276ab0158c66e3d(e);
    return n;
}
function $3bb1d28ab2c881a5$export$93512919ec2ab555(e) {
    const { namespace: n, reference: t } = $3bb1d28ab2c881a5$export$276ab0158c66e3d(e);
    return $3bb1d28ab2c881a5$export$a5999672e4930644({
        namespace: n,
        reference: t
    });
}
function $3bb1d28ab2c881a5$export$40283ddc77f27f6e(e, n) {
    const { namespace: t, reference: r } = $3bb1d28ab2c881a5$export$4764229d78de4437(n);
    return $3bb1d28ab2c881a5$export$566a25328fb93a18({
        namespace: t,
        reference: r,
        address: e
    });
}
function $3bb1d28ab2c881a5$export$aa4a6b630dfcfa83(e) {
    return $3bb1d28ab2c881a5$export$d579bc26e95946b5(e, $3bb1d28ab2c881a5$export$2806d446053abd1d);
}
function $3bb1d28ab2c881a5$export$d5ee58c6b13696e9(e) {
    return $3bb1d28ab2c881a5$export$d579bc26e95946b5(e, $3bb1d28ab2c881a5$export$93512919ec2ab555);
}
function $3bb1d28ab2c881a5$export$23329703ad972840(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...o.accounts);
    }), t;
}
function $3bb1d28ab2c881a5$export$6281ff29da5f85fe(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$3bb1d28ab2c881a5$export$d5ee58c6b13696e9(o.accounts));
    }), t;
}
function $3bb1d28ab2c881a5$export$d1109eeb751412cf(e, n = []) {
    const t = [];
    return Object.keys(e).forEach((r)=>{
        if (n.length && !n.includes(r)) return;
        const o = e[r];
        t.push(...$3bb1d28ab2c881a5$export$376384387cd15b27(r, o));
    }), t;
}
function $3bb1d28ab2c881a5$export$376384387cd15b27(e, n) {
    return e.includes(":") ? [
        e
    ] : n.chains || [];
}
const $3bb1d28ab2c881a5$export$a524ae552db7912 = (e)=>e?.split(":"), $3bb1d28ab2c881a5$export$85f23c05c80b194 = (e)=>{
    const n = e && $3bb1d28ab2c881a5$export$a524ae552db7912(e);
    if (n) return n[3];
}, $3bb1d28ab2c881a5$export$a8b149927aef7051 = (e)=>{
    const n = e && $3bb1d28ab2c881a5$export$a524ae552db7912(e);
    if (n) return n[2] + ":" + n[3];
}, $3bb1d28ab2c881a5$export$bf43cfbb4bd95de9 = (e)=>{
    const n = e && $3bb1d28ab2c881a5$export$a524ae552db7912(e);
    if (n) return n.pop();
}, $3bb1d28ab2c881a5$export$25868d1e8e76735f = (e, n)=>{
    const t = `${e.domain} wants you to sign in with your Ethereum account:`, r = $3bb1d28ab2c881a5$export$bf43cfbb4bd95de9(n), o = e.statement, s = `URI: ${e.aud}`, i = `Version: ${e.version}`, d = `Chain ID: ${$3bb1d28ab2c881a5$export$85f23c05c80b194(n)}`, l = `Nonce: ${e.nonce}`, c = `Issued At: ${e.iat}`, u = e.resources && e.resources.length > 0 ? `Resources:
${e.resources.map((a)=>`- ${a}`).join(`
`)}` : void 0;
    return [
        t,
        r,
        "",
        o,
        "",
        s,
        i,
        d,
        l,
        c,
        u
    ].filter((a)=>a != null).join(`
`);
}, $3bb1d28ab2c881a5$export$f7403969428298bd = "base10", $3bb1d28ab2c881a5$export$49eb910ab2518105 = "base16", $3bb1d28ab2c881a5$export$9bff723d552e6bcf = "base64pad", $3bb1d28ab2c881a5$export$9560dad2a83e4f04 = "utf8", $3bb1d28ab2c881a5$export$3425bd336a9673d8 = 0, $3bb1d28ab2c881a5$export$406e97c329f0f3d4 = 1, $3bb1d28ab2c881a5$var$Dn = 0, $3bb1d28ab2c881a5$var$Pe = 1, $3bb1d28ab2c881a5$var$Z = 12, $3bb1d28ab2c881a5$var$X = 32;
function $3bb1d28ab2c881a5$export$a949d36eab55b41f() {
    const e = $5qHj8.generateKeyPair();
    return {
        privateKey: (0, $4hI5Z.toString)(e.secretKey, $3bb1d28ab2c881a5$export$49eb910ab2518105),
        publicKey: (0, $4hI5Z.toString)(e.publicKey, $3bb1d28ab2c881a5$export$49eb910ab2518105)
    };
}
function $3bb1d28ab2c881a5$export$d15a28e4f1821243() {
    const e = (0, $6CzCo.randomBytes)($3bb1d28ab2c881a5$var$X);
    return (0, $4hI5Z.toString)(e, $3bb1d28ab2c881a5$export$49eb910ab2518105);
}
function $3bb1d28ab2c881a5$export$f8378f68e053f5c6(e, n) {
    const t = $5qHj8.sharedKey((0, $4hI5Z.fromString)(e, $3bb1d28ab2c881a5$export$49eb910ab2518105), (0, $4hI5Z.fromString)(n, $3bb1d28ab2c881a5$export$49eb910ab2518105), !0), r = new (0, $cWicQ.HKDF)((0, $fhdxA.SHA256), t).expand($3bb1d28ab2c881a5$var$X);
    return (0, $4hI5Z.toString)(r, $3bb1d28ab2c881a5$export$49eb910ab2518105);
}
function $3bb1d28ab2c881a5$export$1e87d19d4aab5805(e) {
    const n = (0, $fhdxA.hash)((0, $4hI5Z.fromString)(e, $3bb1d28ab2c881a5$export$49eb910ab2518105));
    return (0, $4hI5Z.toString)(n, $3bb1d28ab2c881a5$export$49eb910ab2518105);
}
function $3bb1d28ab2c881a5$export$d4c241cec96564c1(e) {
    const n = (0, $fhdxA.hash)((0, $4hI5Z.fromString)(e, $3bb1d28ab2c881a5$export$9560dad2a83e4f04));
    return (0, $4hI5Z.toString)(n, $3bb1d28ab2c881a5$export$49eb910ab2518105);
}
function $3bb1d28ab2c881a5$export$e9d2f9ba70428fb6(e) {
    return (0, $4hI5Z.fromString)(`${e}`, $3bb1d28ab2c881a5$export$f7403969428298bd);
}
function $3bb1d28ab2c881a5$export$7547a514ee29b9d4(e) {
    return Number((0, $4hI5Z.toString)(e, $3bb1d28ab2c881a5$export$f7403969428298bd));
}
function $3bb1d28ab2c881a5$export$5b0f6292f11d1d18(e) {
    const n = $3bb1d28ab2c881a5$export$e9d2f9ba70428fb6(typeof e.type < "u" ? e.type : $3bb1d28ab2c881a5$export$3425bd336a9673d8);
    if ($3bb1d28ab2c881a5$export$7547a514ee29b9d4(n) === $3bb1d28ab2c881a5$export$406e97c329f0f3d4 && typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
    const t = typeof e.senderPublicKey < "u" ? (0, $4hI5Z.fromString)(e.senderPublicKey, $3bb1d28ab2c881a5$export$49eb910ab2518105) : void 0, r = typeof e.iv < "u" ? (0, $4hI5Z.fromString)(e.iv, $3bb1d28ab2c881a5$export$49eb910ab2518105) : (0, $6CzCo.randomBytes)($3bb1d28ab2c881a5$var$Z), o = new (0, $d2sHe.ChaCha20Poly1305)((0, $4hI5Z.fromString)(e.symKey, $3bb1d28ab2c881a5$export$49eb910ab2518105)).seal(r, (0, $4hI5Z.fromString)(e.message, $3bb1d28ab2c881a5$export$9560dad2a83e4f04));
    return $3bb1d28ab2c881a5$export$dfdc1655ccc5b9cb({
        type: n,
        sealed: o,
        iv: r,
        senderPublicKey: t
    });
}
function $3bb1d28ab2c881a5$export$e85a0c9a1067c5d3(e) {
    const n = new (0, $d2sHe.ChaCha20Poly1305)((0, $4hI5Z.fromString)(e.symKey, $3bb1d28ab2c881a5$export$49eb910ab2518105)), { sealed: t, iv: r } = $3bb1d28ab2c881a5$export$efcd34ab6248d3cd(e.encoded), o = n.open(r, t);
    if (o === null) throw new Error("Failed to decrypt");
    return (0, $4hI5Z.toString)(o, $3bb1d28ab2c881a5$export$9560dad2a83e4f04);
}
function $3bb1d28ab2c881a5$export$dfdc1655ccc5b9cb(e) {
    if ($3bb1d28ab2c881a5$export$7547a514ee29b9d4(e.type) === $3bb1d28ab2c881a5$export$406e97c329f0f3d4) {
        if (typeof e.senderPublicKey > "u") throw new Error("Missing sender public key for type 1 envelope");
        return (0, $4hI5Z.toString)((0, $4hI5Z.concat)([
            e.type,
            e.senderPublicKey,
            e.iv,
            e.sealed
        ]), $3bb1d28ab2c881a5$export$9bff723d552e6bcf);
    }
    return (0, $4hI5Z.toString)((0, $4hI5Z.concat)([
        e.type,
        e.iv,
        e.sealed
    ]), $3bb1d28ab2c881a5$export$9bff723d552e6bcf);
}
function $3bb1d28ab2c881a5$export$efcd34ab6248d3cd(e) {
    const n = (0, $4hI5Z.fromString)(e, $3bb1d28ab2c881a5$export$9bff723d552e6bcf), t = n.slice($3bb1d28ab2c881a5$var$Dn, $3bb1d28ab2c881a5$var$Pe), r = $3bb1d28ab2c881a5$var$Pe;
    if ($3bb1d28ab2c881a5$export$7547a514ee29b9d4(t) === $3bb1d28ab2c881a5$export$406e97c329f0f3d4) {
        const d = r + $3bb1d28ab2c881a5$var$X, l = d + $3bb1d28ab2c881a5$var$Z, c = n.slice(r, d), u = n.slice(d, l), a = n.slice(l);
        return {
            type: t,
            sealed: a,
            iv: u,
            senderPublicKey: c
        };
    }
    const o = r + $3bb1d28ab2c881a5$var$Z, s = n.slice(r, o), i = n.slice(o);
    return {
        type: t,
        sealed: i,
        iv: s
    };
}
function $3bb1d28ab2c881a5$export$177f3e316562333d(e, n) {
    const t = $3bb1d28ab2c881a5$export$efcd34ab6248d3cd(e);
    return $3bb1d28ab2c881a5$export$7949f60f2444aef2({
        type: $3bb1d28ab2c881a5$export$7547a514ee29b9d4(t.type),
        senderPublicKey: typeof t.senderPublicKey < "u" ? (0, $4hI5Z.toString)(t.senderPublicKey, $3bb1d28ab2c881a5$export$49eb910ab2518105) : void 0,
        receiverPublicKey: n?.receiverPublicKey
    });
}
function $3bb1d28ab2c881a5$export$7949f60f2444aef2(e) {
    const n = e?.type || $3bb1d28ab2c881a5$export$3425bd336a9673d8;
    if (n === $3bb1d28ab2c881a5$export$406e97c329f0f3d4) {
        if (typeof e?.senderPublicKey > "u") throw new Error("missing sender public key");
        if (typeof e?.receiverPublicKey > "u") throw new Error("missing receiver public key");
    }
    return {
        type: n,
        senderPublicKey: e?.senderPublicKey,
        receiverPublicKey: e?.receiverPublicKey
    };
}
function $3bb1d28ab2c881a5$export$8c165704db2d5c15(e) {
    return e.type === $3bb1d28ab2c881a5$export$406e97c329f0f3d4 && typeof e.senderPublicKey == "string" && typeof e.receiverPublicKey == "string";
}
var $3bb1d28ab2c881a5$var$Bn = Object.defineProperty, $3bb1d28ab2c881a5$var$Ue = Object.getOwnPropertySymbols, $3bb1d28ab2c881a5$var$Gn = Object.prototype.hasOwnProperty, $3bb1d28ab2c881a5$var$Wn = Object.prototype.propertyIsEnumerable, $3bb1d28ab2c881a5$var$_e = (e, n, t)=>n in e ? $3bb1d28ab2c881a5$var$Bn(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $3bb1d28ab2c881a5$var$Ce = (e, n)=>{
    for(var t in n || (n = {}))$3bb1d28ab2c881a5$var$Gn.call(n, t) && $3bb1d28ab2c881a5$var$_e(e, t, n[t]);
    if ($3bb1d28ab2c881a5$var$Ue) for (var t of $3bb1d28ab2c881a5$var$Ue(n))$3bb1d28ab2c881a5$var$Wn.call(n, t) && $3bb1d28ab2c881a5$var$_e(e, t, n[t]);
    return e;
};
const $3bb1d28ab2c881a5$export$f12873d77424d47b = "ReactNative", $3bb1d28ab2c881a5$export$86b1301a63b15dd9 = {
    reactNative: "react-native",
    node: "node",
    browser: "browser",
    unknown: "unknown"
}, $3bb1d28ab2c881a5$export$657dee6d5648750a = " ", $3bb1d28ab2c881a5$export$96c3628b3b9d2079 = ":", $3bb1d28ab2c881a5$export$98238152dfccf046 = "/", $3bb1d28ab2c881a5$export$7f882bb969de14a3 = 2, $3bb1d28ab2c881a5$export$77baccb4c6bd5852 = 1e3, $3bb1d28ab2c881a5$export$e08b61c98317d88c = "js";
function $3bb1d28ab2c881a5$export$8ee0fc9ee280b4ee() {
    return typeof $bNDrn < "u" && typeof $bNDrn.versions < "u" && typeof $bNDrn.versions.node < "u";
}
function $3bb1d28ab2c881a5$export$f7a1e23e542d38e3() {
    return !(0, $6qPmi.getDocument)() && !!(0, $6qPmi.getNavigator)() && navigator.product === $3bb1d28ab2c881a5$export$f12873d77424d47b;
}
function $3bb1d28ab2c881a5$export$4e09c449d6c407f7() {
    return !$3bb1d28ab2c881a5$export$8ee0fc9ee280b4ee() && !!(0, $6qPmi.getNavigator)() && !!(0, $6qPmi.getDocument)();
}
function $3bb1d28ab2c881a5$export$57570b1603cf6adb() {
    return $3bb1d28ab2c881a5$export$f7a1e23e542d38e3() ? $3bb1d28ab2c881a5$export$86b1301a63b15dd9.reactNative : $3bb1d28ab2c881a5$export$8ee0fc9ee280b4ee() ? $3bb1d28ab2c881a5$export$86b1301a63b15dd9.node : $3bb1d28ab2c881a5$export$4e09c449d6c407f7() ? $3bb1d28ab2c881a5$export$86b1301a63b15dd9.browser : $3bb1d28ab2c881a5$export$86b1301a63b15dd9.unknown;
}
function $3bb1d28ab2c881a5$export$40a40f90174d197c() {
    var e;
    try {
        return $3bb1d28ab2c881a5$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Application) < "u" ? (e = $parcel$global.Application) == null ? void 0 : e.applicationId : void 0;
    } catch  {
        return;
    }
}
function $3bb1d28ab2c881a5$export$c4147c69f6845da(e, n) {
    let t = $3J7fK.parse(e);
    return t = $3bb1d28ab2c881a5$var$Ce($3bb1d28ab2c881a5$var$Ce({}, t), n), e = $3J7fK.stringify(t), e;
}
function $3bb1d28ab2c881a5$export$ba31e015127122bb() {
    return (0, $bsIGZ.getWindowMetadata)() || {
        name: "",
        description: "",
        url: "",
        icons: [
            ""
        ]
    };
}
function $3bb1d28ab2c881a5$export$6b05aa0115b6fc2d(e, n) {
    var t;
    const r = $3bb1d28ab2c881a5$export$57570b1603cf6adb(), o = {
        protocol: e,
        version: n,
        env: r
    };
    return r === "browser" && (o.host = ((t = (0, $6qPmi.getLocation)()) == null ? void 0 : t.host) || "unknown"), o;
}
function $3bb1d28ab2c881a5$export$20d4a3cb5829b8b6() {
    if ($3bb1d28ab2c881a5$export$57570b1603cf6adb() === $3bb1d28ab2c881a5$export$86b1301a63b15dd9.reactNative && typeof $parcel$global < "u" && typeof ($parcel$global == null ? void 0 : $parcel$global.Platform) < "u") {
        const { OS: t, Version: r } = $parcel$global.Platform;
        return [
            t,
            r
        ].join("-");
    }
    const e = (0, $7gpqF.detect)();
    if (e === null) return "unknown";
    const n = e.os ? e.os.replace(" ", "").toLowerCase() : "unknown";
    return e.type === "browser" ? [
        n,
        e.name,
        e.version
    ].join("-") : [
        n,
        e.version
    ].join("-");
}
function $3bb1d28ab2c881a5$export$4389b0987726d52d() {
    var e;
    const n = $3bb1d28ab2c881a5$export$57570b1603cf6adb();
    return n === $3bb1d28ab2c881a5$export$86b1301a63b15dd9.browser ? [
        n,
        ((e = (0, $6qPmi.getLocation)()) == null ? void 0 : e.host) || "unknown"
    ].join(":") : n;
}
function $3bb1d28ab2c881a5$export$b55a4c6e272b719f(e, n, t) {
    const r = $3bb1d28ab2c881a5$export$20d4a3cb5829b8b6(), o = $3bb1d28ab2c881a5$export$4389b0987726d52d();
    return [
        [
            e,
            n
        ].join("-"),
        [
            $3bb1d28ab2c881a5$export$e08b61c98317d88c,
            t
        ].join("-"),
        r,
        o
    ].join("/");
}
function $3bb1d28ab2c881a5$export$d875b3963ef774f5({ protocol: e, version: n, relayUrl: t, sdkVersion: r, auth: o, projectId: s, useOnCloseEvent: i, bundleId: d }) {
    const l = t.split("?"), c = $3bb1d28ab2c881a5$export$b55a4c6e272b719f(e, n, r), u = {
        auth: o,
        ua: c,
        projectId: s,
        useOnCloseEvent: i || void 0,
        origin: d || void 0
    }, a = $3bb1d28ab2c881a5$export$c4147c69f6845da(l[1] || "", u);
    return l[0] + "?" + a;
}
function $3bb1d28ab2c881a5$export$ed08891a8a54eb(e) {
    let n = (e.match(/^[^:]+(?=:\/\/)/gi) || [])[0];
    const t = typeof n < "u" ? e.split("://")[1] : e;
    return n = n === "wss" ? "https" : "http", [
        n,
        t
    ].join("://");
}
function $3bb1d28ab2c881a5$export$804de46662e4ac95(e, n, t) {
    if (!e[n] || typeof e[n] !== t) throw new Error(`Missing or invalid "${n}" param`);
}
function $3bb1d28ab2c881a5$export$1e21530e896c0b0b(e, n = $3bb1d28ab2c881a5$export$7f882bb969de14a3) {
    return $3bb1d28ab2c881a5$export$7f00885504704576(e.split($3bb1d28ab2c881a5$export$98238152dfccf046), n);
}
function $3bb1d28ab2c881a5$export$80bffd46c37a96f6(e) {
    return $3bb1d28ab2c881a5$export$1e21530e896c0b0b(e).join($3bb1d28ab2c881a5$export$657dee6d5648750a);
}
function $3bb1d28ab2c881a5$export$1468a49de573f7f9(e, n) {
    return e.filter((t)=>n.includes(t)).length === e.length;
}
function $3bb1d28ab2c881a5$export$7f00885504704576(e, n = $3bb1d28ab2c881a5$export$7f882bb969de14a3) {
    return e.slice(Math.max(e.length - n, 0));
}
function $3bb1d28ab2c881a5$export$c4b8dfeb6e237eb9(e) {
    return Object.fromEntries(e.entries());
}
function $3bb1d28ab2c881a5$export$ac31b37c726bc3ba(e) {
    return new Map(Object.entries(e));
}
function $3bb1d28ab2c881a5$export$592ef47eabb05614(e, n) {
    const t = {};
    return Object.keys(e).forEach((r)=>{
        t[r] = n(e[r]);
    }), t;
}
const $3bb1d28ab2c881a5$export$85c927578394b28b = (e)=>e;
function $3bb1d28ab2c881a5$export$e9f8fcacef3bca4b(e) {
    return e.trim().replace(/^\w/, (n)=>n.toUpperCase());
}
function $3bb1d28ab2c881a5$export$9a00dee1beb8f576(e) {
    return e.split($3bb1d28ab2c881a5$export$657dee6d5648750a).map((n)=>$3bb1d28ab2c881a5$export$e9f8fcacef3bca4b(n)).join($3bb1d28ab2c881a5$export$657dee6d5648750a);
}
function $3bb1d28ab2c881a5$export$cbf9e3cc9ffc85cb(e = (0, $aGNdt.FIVE_MINUTES), n) {
    const t = (0, $aGNdt.toMiliseconds)(e || (0, $aGNdt.FIVE_MINUTES));
    let r, o, s;
    return {
        resolve: (i)=>{
            s && r && (clearTimeout(s), r(i));
        },
        reject: (i)=>{
            s && o && (clearTimeout(s), o(i));
        },
        done: ()=>new Promise((i, d)=>{
                s = setTimeout(()=>{
                    d(new Error(n));
                }, t), r = i, o = d;
            })
    };
}
function $3bb1d28ab2c881a5$export$3da2293b007ed708(e, n, t) {
    return new Promise(async (r, o)=>{
        const s = setTimeout(()=>o(new Error(t)), n);
        try {
            const i = await e;
            r(i);
        } catch (i) {
            o(i);
        }
        clearTimeout(s);
    });
}
function $3bb1d28ab2c881a5$export$187ab6574b2ae23f(e, n) {
    if (typeof n == "string" && n.startsWith(`${e}:`)) return n;
    if (e.toLowerCase() === "topic") {
        if (typeof n != "string") throw new Error('Value must be "string" for expirer target type: topic');
        return `topic:${n}`;
    } else if (e.toLowerCase() === "id") {
        if (typeof n != "number") throw new Error('Value must be "number" for expirer target type: id');
        return `id:${n}`;
    }
    throw new Error(`Unknown expirer target type: ${e}`);
}
function $3bb1d28ab2c881a5$export$43ab92477f8713b9(e) {
    return $3bb1d28ab2c881a5$export$187ab6574b2ae23f("topic", e);
}
function $3bb1d28ab2c881a5$export$bd13103c2e5cc0c3(e) {
    return $3bb1d28ab2c881a5$export$187ab6574b2ae23f("id", e);
}
function $3bb1d28ab2c881a5$export$93adeb0f16e8e51d(e) {
    const [n, t] = e.split(":"), r = {
        id: void 0,
        topic: void 0
    };
    if (n === "topic" && typeof t == "string") r.topic = t;
    else if (n === "id" && Number.isInteger(Number(t))) r.id = Number(t);
    else throw new Error(`Invalid target, expected id:number or topic:string, got ${n}:${t}`);
    return r;
}
function $3bb1d28ab2c881a5$export$b136d03015bfc12(e, n) {
    return (0, $aGNdt.fromMiliseconds)((n || Date.now()) + (0, $aGNdt.toMiliseconds)(e));
}
function $3bb1d28ab2c881a5$export$57947cfd429801a2(e) {
    return Date.now() >= (0, $aGNdt.toMiliseconds)(e);
}
function $3bb1d28ab2c881a5$export$e3eb27ce66c0f6d9(e, n) {
    return `${e}${n ? `:${n}` : ""}`;
}
function $3bb1d28ab2c881a5$export$9826fe7ad3921016(e = [], n = []) {
    return [
        ...new Set([
            ...e,
            ...n
        ])
    ];
}
async function $3bb1d28ab2c881a5$export$694a208c8abca99a({ id: e, topic: n, wcDeepLink: t }) {
    try {
        if (!t) return;
        const r = typeof t == "string" ? JSON.parse(t) : t;
        let o = r?.href;
        if (typeof o != "string") return;
        o.endsWith("/") && (o = o.slice(0, -1));
        const s = `${o}/wc?requestId=${e}&sessionTopic=${n}`, i = $3bb1d28ab2c881a5$export$57570b1603cf6adb();
        i === $3bb1d28ab2c881a5$export$86b1301a63b15dd9.browser ? s.startsWith("https://") ? window.open(s, "_blank", "noreferrer noopener") : window.open(s, "_self", "noreferrer noopener") : i === $3bb1d28ab2c881a5$export$86b1301a63b15dd9.reactNative && typeof ($parcel$global == null ? void 0 : $parcel$global.Linking) < "u" && await $parcel$global.Linking.openURL(s);
    } catch (r) {
        console.error(r);
    }
}
async function $3bb1d28ab2c881a5$export$e55bfdac47149a32(e, n) {
    try {
        return await e.getItem(n) || ($3bb1d28ab2c881a5$export$4e09c449d6c407f7() ? localStorage.getItem(n) : void 0);
    } catch (t) {
        console.error(t);
    }
}
const $3bb1d28ab2c881a5$export$822d0bd1635d5360 = "irn";
function $3bb1d28ab2c881a5$export$cf77af25151525db(e) {
    return e?.relay || {
        protocol: $3bb1d28ab2c881a5$export$822d0bd1635d5360
    };
}
function $3bb1d28ab2c881a5$export$604e3deb95e1b734(e) {
    const n = (0, $5HwuL.RELAY_JSONRPC)[e];
    if (typeof n > "u") throw new Error(`Relay Protocol not supported: ${e}`);
    return n;
}
var $3bb1d28ab2c881a5$var$bt = Object.defineProperty, $3bb1d28ab2c881a5$var$qe = Object.getOwnPropertySymbols, $3bb1d28ab2c881a5$var$Nt = Object.prototype.hasOwnProperty, $3bb1d28ab2c881a5$var$Ot = Object.prototype.propertyIsEnumerable, $3bb1d28ab2c881a5$var$Be = (e, n, t)=>n in e ? $3bb1d28ab2c881a5$var$bt(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $3bb1d28ab2c881a5$var$St = (e, n)=>{
    for(var t in n || (n = {}))$3bb1d28ab2c881a5$var$Nt.call(n, t) && $3bb1d28ab2c881a5$var$Be(e, t, n[t]);
    if ($3bb1d28ab2c881a5$var$qe) for (var t of $3bb1d28ab2c881a5$var$qe(n))$3bb1d28ab2c881a5$var$Ot.call(n, t) && $3bb1d28ab2c881a5$var$Be(e, t, n[t]);
    return e;
};
function $3bb1d28ab2c881a5$export$3d24f408c2ac468a(e, n = "-") {
    const t = {}, r = "relay" + n;
    return Object.keys(e).forEach((o)=>{
        if (o.startsWith(r)) {
            const s = o.replace(r, ""), i = e[o];
            t[s] = i;
        }
    }), t;
}
function $3bb1d28ab2c881a5$export$59f58847421cfb28(e) {
    e = e.includes("wc://") ? e.replace("wc://", "") : e, e = e.includes("wc:") ? e.replace("wc:", "") : e;
    const n = e.indexOf(":"), t = e.indexOf("?") !== -1 ? e.indexOf("?") : void 0, r = e.substring(0, n), o = e.substring(n + 1, t).split("@"), s = typeof t < "u" ? e.substring(t) : "", i = $3J7fK.parse(s);
    return {
        protocol: r,
        topic: $3bb1d28ab2c881a5$export$5ddc9ebef1d00f28(o[0]),
        version: parseInt(o[1], 10),
        symKey: i.symKey,
        relay: $3bb1d28ab2c881a5$export$3d24f408c2ac468a(i)
    };
}
function $3bb1d28ab2c881a5$export$5ddc9ebef1d00f28(e) {
    return e.startsWith("//") ? e.substring(2) : e;
}
function $3bb1d28ab2c881a5$export$65c55c7ccd19bb8f(e, n = "-") {
    const t = "relay", r = {};
    return Object.keys(e).forEach((o)=>{
        const s = t + n + o;
        e[o] && (r[s] = e[o]);
    }), r;
}
function $3bb1d28ab2c881a5$export$b2786ede34fb2350(e) {
    return `${e.protocol}:${e.topic}@${e.version}?` + $3J7fK.stringify($3bb1d28ab2c881a5$var$St({
        symKey: e.symKey
    }, $3bb1d28ab2c881a5$export$65c55c7ccd19bb8f(e.relay)));
}
var $3bb1d28ab2c881a5$var$Pt = Object.defineProperty, $3bb1d28ab2c881a5$var$Rt = Object.defineProperties, $3bb1d28ab2c881a5$var$Tt = Object.getOwnPropertyDescriptors, $3bb1d28ab2c881a5$var$Ye = Object.getOwnPropertySymbols, $3bb1d28ab2c881a5$var$At = Object.prototype.hasOwnProperty, $3bb1d28ab2c881a5$var$Ut = Object.prototype.propertyIsEnumerable, $3bb1d28ab2c881a5$var$Je = (e, n, t)=>n in e ? $3bb1d28ab2c881a5$var$Pt(e, n, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : e[n] = t, $3bb1d28ab2c881a5$var$_t = (e, n)=>{
    for(var t in n || (n = {}))$3bb1d28ab2c881a5$var$At.call(n, t) && $3bb1d28ab2c881a5$var$Je(e, t, n[t]);
    if ($3bb1d28ab2c881a5$var$Ye) for (var t of $3bb1d28ab2c881a5$var$Ye(n))$3bb1d28ab2c881a5$var$Ut.call(n, t) && $3bb1d28ab2c881a5$var$Je(e, t, n[t]);
    return e;
}, $3bb1d28ab2c881a5$var$Ct = (e, n)=>$3bb1d28ab2c881a5$var$Rt(e, $3bb1d28ab2c881a5$var$Tt(n));
function $3bb1d28ab2c881a5$export$d46695d9c3664fe9(e) {
    const n = [];
    return e.forEach((t)=>{
        const [r, o] = t.split(":");
        n.push(`${r}:${o}`);
    }), n;
}
function $3bb1d28ab2c881a5$export$fb6db6038e742b14(e) {
    const n = [];
    return Object.values(e).forEach((t)=>{
        n.push(...$3bb1d28ab2c881a5$export$d46695d9c3664fe9(t.accounts));
    }), n;
}
function $3bb1d28ab2c881a5$export$7dcf4808e17b15ac(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $3bb1d28ab2c881a5$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.methods);
    }), t;
}
function $3bb1d28ab2c881a5$export$94ee6d00e384a22(e, n) {
    const t = [];
    return Object.values(e).forEach((r)=>{
        $3bb1d28ab2c881a5$export$d46695d9c3664fe9(r.accounts).includes(n) && t.push(...r.events);
    }), t;
}
function $3bb1d28ab2c881a5$export$a8daa26a7c60ef90(e, n) {
    const t = $3bb1d28ab2c881a5$export$93f7b81dc815a714(e, n);
    if (t) throw new Error(t.message);
    const r = {};
    for (const [o, s] of Object.entries(e))r[o] = {
        methods: s.methods,
        events: s.events,
        chains: s.accounts.map((i)=>`${i.split(":")[0]}:${i.split(":")[1]}`)
    };
    return r;
}
function $3bb1d28ab2c881a5$export$c0b86bc9b7d9f338(e) {
    const { proposal: { requiredNamespaces: n, optionalNamespaces: t = {} }, supportedNamespaces: r } = e, o = $3bb1d28ab2c881a5$export$2994550cda701c96(n), s = $3bb1d28ab2c881a5$export$2994550cda701c96(t), i = {};
    Object.keys(r).forEach((c)=>{
        const u = r[c].chains, a = r[c].methods, b = r[c].events, I = r[c].accounts;
        u.forEach((y)=>{
            if (!I.some((f)=>f.includes(y))) throw new Error(`No accounts provided for chain ${y} in namespace ${c}`);
        }), i[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    });
    const d = $3bb1d28ab2c881a5$export$ba5b0a4b585cd1b4(n, i, "approve()");
    if (d) throw new Error(d.message);
    const l = {};
    return !Object.keys(n).length && !Object.keys(t).length ? i : (Object.keys(o).forEach((c)=>{
        const u = r[c].chains.filter((y)=>{
            var f, g;
            return (g = (f = o[c]) == null ? void 0 : f.chains) == null ? void 0 : g.includes(y);
        }), a = r[c].methods.filter((y)=>{
            var f, g;
            return (g = (f = o[c]) == null ? void 0 : f.methods) == null ? void 0 : g.includes(y);
        }), b = r[c].events.filter((y)=>{
            var f, g;
            return (g = (f = o[c]) == null ? void 0 : f.events) == null ? void 0 : g.includes(y);
        }), I = u.map((y)=>r[c].accounts.filter((f)=>f.includes(`${y}:`))).flat();
        l[c] = {
            chains: u,
            methods: a,
            events: b,
            accounts: I
        };
    }), Object.keys(s).forEach((c)=>{
        var u, a, b, I, y, f;
        if (!r[c]) return;
        const g = (a = (u = s[c]) == null ? void 0 : u.chains) == null ? void 0 : a.filter((P)=>r[c].chains.includes(P)), En = r[c].methods.filter((P)=>{
            var R, j;
            return (j = (R = s[c]) == null ? void 0 : R.methods) == null ? void 0 : j.includes(P);
        }), bn = r[c].events.filter((P)=>{
            var R, j;
            return (j = (R = s[c]) == null ? void 0 : R.events) == null ? void 0 : j.includes(P);
        }), Nn = g?.map((P)=>r[c].accounts.filter((R)=>R.includes(`${P}:`))).flat();
        l[c] = {
            chains: $3bb1d28ab2c881a5$export$9826fe7ad3921016((b = l[c]) == null ? void 0 : b.chains, g),
            methods: $3bb1d28ab2c881a5$export$9826fe7ad3921016((I = l[c]) == null ? void 0 : I.methods, En),
            events: $3bb1d28ab2c881a5$export$9826fe7ad3921016((y = l[c]) == null ? void 0 : y.events, bn),
            accounts: $3bb1d28ab2c881a5$export$9826fe7ad3921016((f = l[c]) == null ? void 0 : f.accounts, Nn)
        };
    }), l);
}
function $3bb1d28ab2c881a5$export$e03e993df4723bde(e) {
    return e.includes(":");
}
function $3bb1d28ab2c881a5$export$dd404c96fbbb1ff8(e) {
    return $3bb1d28ab2c881a5$export$e03e993df4723bde(e) ? e.split(":")[0] : e;
}
function $3bb1d28ab2c881a5$export$2994550cda701c96(e) {
    var n, t, r;
    const o = {};
    if (!$3bb1d28ab2c881a5$export$16a0268bc22b47b0(e)) return o;
    for (const [s, i] of Object.entries(e)){
        const d = $3bb1d28ab2c881a5$export$e03e993df4723bde(s) ? [
            s
        ] : i.chains, l = i.methods || [], c = i.events || [], u = $3bb1d28ab2c881a5$export$dd404c96fbbb1ff8(s);
        o[u] = $3bb1d28ab2c881a5$var$Ct($3bb1d28ab2c881a5$var$_t({}, o[u]), {
            chains: $3bb1d28ab2c881a5$export$9826fe7ad3921016(d, (n = o[u]) == null ? void 0 : n.chains),
            methods: $3bb1d28ab2c881a5$export$9826fe7ad3921016(l, (t = o[u]) == null ? void 0 : t.methods),
            events: $3bb1d28ab2c881a5$export$9826fe7ad3921016(c, (r = o[u]) == null ? void 0 : r.events)
        });
    }
    return o;
}
const $3bb1d28ab2c881a5$export$990de0b632caca05 = {
    INVALID_METHOD: {
        message: "Invalid method.",
        code: 1001
    },
    INVALID_EVENT: {
        message: "Invalid event.",
        code: 1002
    },
    INVALID_UPDATE_REQUEST: {
        message: "Invalid update request.",
        code: 1003
    },
    INVALID_EXTEND_REQUEST: {
        message: "Invalid extend request.",
        code: 1004
    },
    INVALID_SESSION_SETTLE_REQUEST: {
        message: "Invalid session settle request.",
        code: 1005
    },
    UNAUTHORIZED_METHOD: {
        message: "Unauthorized method.",
        code: 3001
    },
    UNAUTHORIZED_EVENT: {
        message: "Unauthorized event.",
        code: 3002
    },
    UNAUTHORIZED_UPDATE_REQUEST: {
        message: "Unauthorized update request.",
        code: 3003
    },
    UNAUTHORIZED_EXTEND_REQUEST: {
        message: "Unauthorized extend request.",
        code: 3004
    },
    USER_REJECTED: {
        message: "User rejected.",
        code: 5e3
    },
    USER_REJECTED_CHAINS: {
        message: "User rejected chains.",
        code: 5001
    },
    USER_REJECTED_METHODS: {
        message: "User rejected methods.",
        code: 5002
    },
    USER_REJECTED_EVENTS: {
        message: "User rejected events.",
        code: 5003
    },
    UNSUPPORTED_CHAINS: {
        message: "Unsupported chains.",
        code: 5100
    },
    UNSUPPORTED_METHODS: {
        message: "Unsupported methods.",
        code: 5101
    },
    UNSUPPORTED_EVENTS: {
        message: "Unsupported events.",
        code: 5102
    },
    UNSUPPORTED_ACCOUNTS: {
        message: "Unsupported accounts.",
        code: 5103
    },
    UNSUPPORTED_NAMESPACE_KEY: {
        message: "Unsupported namespace key.",
        code: 5104
    },
    USER_DISCONNECTED: {
        message: "User disconnected.",
        code: 6e3
    },
    SESSION_SETTLEMENT_FAILED: {
        message: "Session settlement failed.",
        code: 7e3
    },
    WC_METHOD_UNSUPPORTED: {
        message: "Unsupported wc_ method.",
        code: 10001
    }
}, $3bb1d28ab2c881a5$export$77b3faa414a0ce61 = {
    NOT_INITIALIZED: {
        message: "Not initialized.",
        code: 1
    },
    NO_MATCHING_KEY: {
        message: "No matching key.",
        code: 2
    },
    RESTORE_WILL_OVERRIDE: {
        message: "Restore will override.",
        code: 3
    },
    RESUBSCRIBED: {
        message: "Resubscribed.",
        code: 4
    },
    MISSING_OR_INVALID: {
        message: "Missing or invalid.",
        code: 5
    },
    EXPIRED: {
        message: "Expired.",
        code: 6
    },
    UNKNOWN_TYPE: {
        message: "Unknown type.",
        code: 7
    },
    MISMATCHED_TOPIC: {
        message: "Mismatched topic.",
        code: 8
    },
    NON_CONFORMING_NAMESPACES: {
        message: "Non conforming namespaces.",
        code: 9
    }
};
function $3bb1d28ab2c881a5$export$500d4c4a8fafe35(e, n) {
    const { message: t, code: r } = $3bb1d28ab2c881a5$export$77b3faa414a0ce61[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $3bb1d28ab2c881a5$export$8203ef1531c8b5b5(e, n) {
    const { message: t, code: r } = $3bb1d28ab2c881a5$export$990de0b632caca05[e];
    return {
        message: n ? `${t} ${n}` : t,
        code: r
    };
}
function $3bb1d28ab2c881a5$export$41dd3d480aac4a71(e, n) {
    return Array.isArray(e) ? typeof n < "u" && e.length ? e.every(n) : !0 : !1;
}
function $3bb1d28ab2c881a5$export$16a0268bc22b47b0(e) {
    return Object.getPrototypeOf(e) === Object.prototype && Object.keys(e).length;
}
function $3bb1d28ab2c881a5$export$fce6876652108ab(e) {
    return typeof e > "u";
}
function $3bb1d28ab2c881a5$export$ee898ca48ab56c74(e, n) {
    return n && $3bb1d28ab2c881a5$export$fce6876652108ab(e) ? !0 : typeof e == "string" && !!e.trim().length;
}
function $3bb1d28ab2c881a5$export$d6781b696a0576d1(e, n) {
    return n && $3bb1d28ab2c881a5$export$fce6876652108ab(e) ? !0 : typeof e == "number" && !isNaN(e);
}
function $3bb1d28ab2c881a5$export$6fc4971bf8f326a(e, n) {
    const { requiredNamespaces: t } = n, r = Object.keys(e.namespaces), o = Object.keys(t);
    let s = !0;
    return $3bb1d28ab2c881a5$export$1468a49de573f7f9(o, r) ? (r.forEach((i)=>{
        const { accounts: d, methods: l, events: c } = e.namespaces[i], u = $3bb1d28ab2c881a5$export$d46695d9c3664fe9(d), a = t[i];
        (!$3bb1d28ab2c881a5$export$1468a49de573f7f9($3bb1d28ab2c881a5$export$376384387cd15b27(i, a), u) || !$3bb1d28ab2c881a5$export$1468a49de573f7f9(a.methods, l) || !$3bb1d28ab2c881a5$export$1468a49de573f7f9(a.events, c)) && (s = !1);
    }), s) : !1;
}
function $3bb1d28ab2c881a5$export$e544b39f0a22e47a(e) {
    return $3bb1d28ab2c881a5$export$ee898ca48ab56c74(e, !1) && e.includes(":") ? e.split(":").length === 2 : !1;
}
function $3bb1d28ab2c881a5$export$49e4a5b6862e3c71(e) {
    if ($3bb1d28ab2c881a5$export$ee898ca48ab56c74(e, !1) && e.includes(":")) {
        const n = e.split(":");
        if (n.length === 3) {
            const t = n[0] + ":" + n[1];
            return !!n[2] && $3bb1d28ab2c881a5$export$e544b39f0a22e47a(t);
        }
    }
    return !1;
}
function $3bb1d28ab2c881a5$export$bef94a5618bf18bf(e) {
    if ($3bb1d28ab2c881a5$export$ee898ca48ab56c74(e, !1)) try {
        return typeof new URL(e) < "u";
    } catch  {
        return !1;
    }
    return !1;
}
function $3bb1d28ab2c881a5$export$f657f7976bb2769d(e) {
    var n;
    return (n = e?.proposer) == null ? void 0 : n.publicKey;
}
function $3bb1d28ab2c881a5$export$c96d5113768aaf5e(e) {
    return e?.topic;
}
function $3bb1d28ab2c881a5$export$5e1c5c89613c213f(e, n) {
    let t = null;
    return $3bb1d28ab2c881a5$export$ee898ca48ab56c74(e?.publicKey, !1) || (t = $3bb1d28ab2c881a5$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n} controller public key should be a string`)), t;
}
function $3bb1d28ab2c881a5$export$c12fced8176774f3(e) {
    let n = !0;
    return $3bb1d28ab2c881a5$export$41dd3d480aac4a71(e) ? e.length && (n = e.every((t)=>$3bb1d28ab2c881a5$export$ee898ca48ab56c74(t, !1))) : n = !1, n;
}
function $3bb1d28ab2c881a5$export$df46c123d7e298ce(e, n, t) {
    let r = null;
    return $3bb1d28ab2c881a5$export$41dd3d480aac4a71(n) && n.length ? n.forEach((o)=>{
        r || $3bb1d28ab2c881a5$export$e544b39f0a22e47a(o) || (r = $3bb1d28ab2c881a5$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chain ${o} should be a string and conform to "namespace:chainId" format`));
    }) : $3bb1d28ab2c881a5$export$e544b39f0a22e47a(e) || (r = $3bb1d28ab2c881a5$export$8203ef1531c8b5b5("UNSUPPORTED_CHAINS", `${t}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)), r;
}
function $3bb1d28ab2c881a5$export$94ae96fb66f29e08(e, n, t) {
    let r = null;
    return Object.entries(e).forEach(([o, s])=>{
        if (r) return;
        const i = $3bb1d28ab2c881a5$export$df46c123d7e298ce(o, $3bb1d28ab2c881a5$export$376384387cd15b27(o, s), `${n} ${t}`);
        i && (r = i);
    }), r;
}
function $3bb1d28ab2c881a5$export$d5644026aaffb9e7(e, n) {
    let t = null;
    return $3bb1d28ab2c881a5$export$41dd3d480aac4a71(e) ? e.forEach((r)=>{
        t || $3bb1d28ab2c881a5$export$49e4a5b6862e3c71(r) || (t = $3bb1d28ab2c881a5$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, account ${r} should be a string and conform to "namespace:chainId:address" format`));
    }) : t = $3bb1d28ab2c881a5$export$8203ef1531c8b5b5("UNSUPPORTED_ACCOUNTS", `${n}, accounts should be an array of strings conforming to "namespace:chainId:address" format`), t;
}
function $3bb1d28ab2c881a5$export$2a2012e7bfa1cfb4(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $3bb1d28ab2c881a5$export$d5644026aaffb9e7(r?.accounts, `${n} namespace`);
        o && (t = o);
    }), t;
}
function $3bb1d28ab2c881a5$export$b32541d63753af56(e, n) {
    let t = null;
    return $3bb1d28ab2c881a5$export$c12fced8176774f3(e?.methods) ? $3bb1d28ab2c881a5$export$c12fced8176774f3(e?.events) || (t = $3bb1d28ab2c881a5$export$8203ef1531c8b5b5("UNSUPPORTED_EVENTS", `${n}, events should be an array of strings or empty array for no events`)) : t = $3bb1d28ab2c881a5$export$8203ef1531c8b5b5("UNSUPPORTED_METHODS", `${n}, methods should be an array of strings or empty array for no methods`), t;
}
function $3bb1d28ab2c881a5$export$27682c78deeca9d7(e, n) {
    let t = null;
    return Object.values(e).forEach((r)=>{
        if (t) return;
        const o = $3bb1d28ab2c881a5$export$b32541d63753af56(r, `${n}, namespace`);
        o && (t = o);
    }), t;
}
function $3bb1d28ab2c881a5$export$9e2b2cae22c6a8b3(e, n, t) {
    let r = null;
    if (e && $3bb1d28ab2c881a5$export$16a0268bc22b47b0(e)) {
        const o = $3bb1d28ab2c881a5$export$27682c78deeca9d7(e, n);
        o && (r = o);
        const s = $3bb1d28ab2c881a5$export$94ae96fb66f29e08(e, n, t);
        s && (r = s);
    } else r = $3bb1d28ab2c881a5$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, ${t} should be an object with data`);
    return r;
}
function $3bb1d28ab2c881a5$export$93f7b81dc815a714(e, n) {
    let t = null;
    if (e && $3bb1d28ab2c881a5$export$16a0268bc22b47b0(e)) {
        const r = $3bb1d28ab2c881a5$export$27682c78deeca9d7(e, n);
        r && (t = r);
        const o = $3bb1d28ab2c881a5$export$2a2012e7bfa1cfb4(e, n);
        o && (t = o);
    } else t = $3bb1d28ab2c881a5$export$500d4c4a8fafe35("MISSING_OR_INVALID", `${n}, namespaces should be an object with data`);
    return t;
}
function $3bb1d28ab2c881a5$export$1b3fc298be8c9a7b(e) {
    return $3bb1d28ab2c881a5$export$ee898ca48ab56c74(e.protocol, !0);
}
function $3bb1d28ab2c881a5$export$6294c30b976bd21e(e, n) {
    let t = !1;
    return n && !e ? t = !0 : e && $3bb1d28ab2c881a5$export$41dd3d480aac4a71(e) && e.length && e.forEach((r)=>{
        t = $3bb1d28ab2c881a5$export$1b3fc298be8c9a7b(r);
    }), t;
}
function $3bb1d28ab2c881a5$export$53551be28ad5e34d(e) {
    return typeof e == "number";
}
function $3bb1d28ab2c881a5$export$b3f5fcca1d210454(e) {
    return typeof e < "u" && true;
}
function $3bb1d28ab2c881a5$export$766fe78377d96f2a(e) {
    return !(!e || typeof e != "object" || !e.code || !$3bb1d28ab2c881a5$export$d6781b696a0576d1(e.code, !1) || !e.message || !$3bb1d28ab2c881a5$export$ee898ca48ab56c74(e.message, !1));
}
function $3bb1d28ab2c881a5$export$1a2af3c017fb6d42(e) {
    return !($3bb1d28ab2c881a5$export$fce6876652108ab(e) || !$3bb1d28ab2c881a5$export$ee898ca48ab56c74(e.method, !1));
}
function $3bb1d28ab2c881a5$export$1ae38cf0a848f651(e) {
    return !($3bb1d28ab2c881a5$export$fce6876652108ab(e) || $3bb1d28ab2c881a5$export$fce6876652108ab(e.result) && $3bb1d28ab2c881a5$export$fce6876652108ab(e.error) || !$3bb1d28ab2c881a5$export$d6781b696a0576d1(e.id, !1) || !$3bb1d28ab2c881a5$export$ee898ca48ab56c74(e.jsonrpc, !1));
}
function $3bb1d28ab2c881a5$export$cbe4cdc5960cfa11(e) {
    return !($3bb1d28ab2c881a5$export$fce6876652108ab(e) || !$3bb1d28ab2c881a5$export$ee898ca48ab56c74(e.name, !1));
}
function $3bb1d28ab2c881a5$export$144fc36610eb6522(e, n) {
    return !(!$3bb1d28ab2c881a5$export$e544b39f0a22e47a(n) || !$3bb1d28ab2c881a5$export$fb6db6038e742b14(e).includes(n));
}
function $3bb1d28ab2c881a5$export$8db4804e3a6de711(e, n, t) {
    return $3bb1d28ab2c881a5$export$ee898ca48ab56c74(t, !1) ? $3bb1d28ab2c881a5$export$7dcf4808e17b15ac(e, n).includes(t) : !1;
}
function $3bb1d28ab2c881a5$export$df2c67ef8baad16b(e, n, t) {
    return $3bb1d28ab2c881a5$export$ee898ca48ab56c74(t, !1) ? $3bb1d28ab2c881a5$export$94ee6d00e384a22(e, n).includes(t) : !1;
}
function $3bb1d28ab2c881a5$export$ba5b0a4b585cd1b4(e, n, t) {
    let r = null;
    const o = $3bb1d28ab2c881a5$var$Qt(e), s = $3bb1d28ab2c881a5$var$Zt(n), i = Object.keys(o), d = Object.keys(s), l = $3bb1d28ab2c881a5$var$pn(Object.keys(e)), c = $3bb1d28ab2c881a5$var$pn(Object.keys(n)), u = l.filter((a)=>!c.includes(a));
    return u.length && (r = $3bb1d28ab2c881a5$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces keys don't satisfy requiredNamespaces.
      Required: ${u.toString()}
      Received: ${Object.keys(n).toString()}`)), $3bb1d28ab2c881a5$export$1468a49de573f7f9(i, d) || (r = $3bb1d28ab2c881a5$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces chains don't satisfy required namespaces.
      Required: ${i.toString()}
      Approved: ${d.toString()}`)), Object.keys(n).forEach((a)=>{
        if (!a.includes(":") || r) return;
        const b = $3bb1d28ab2c881a5$export$d46695d9c3664fe9(n[a].accounts);
        b.includes(a) || (r = $3bb1d28ab2c881a5$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces accounts don't satisfy namespace accounts for ${a}
        Required: ${a}
        Approved: ${b.toString()}`));
    }), i.forEach((a)=>{
        r || ($3bb1d28ab2c881a5$export$1468a49de573f7f9(o[a].methods, s[a].methods) ? $3bb1d28ab2c881a5$export$1468a49de573f7f9(o[a].events, s[a].events) || (r = $3bb1d28ab2c881a5$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces events don't satisfy namespace events for ${a}`)) : r = $3bb1d28ab2c881a5$export$500d4c4a8fafe35("NON_CONFORMING_NAMESPACES", `${t} namespaces methods don't satisfy namespace methods for ${a}`));
    }), r;
}
function $3bb1d28ab2c881a5$var$Qt(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        var r;
        t.includes(":") ? n[t] = e[t] : (r = e[t].chains) == null || r.forEach((o)=>{
            n[o] = {
                methods: e[t].methods,
                events: e[t].events
            };
        });
    }), n;
}
function $3bb1d28ab2c881a5$var$pn(e) {
    return [
        ...new Set(e.map((n)=>n.includes(":") ? n.split(":")[0] : n))
    ];
}
function $3bb1d28ab2c881a5$var$Zt(e) {
    const n = {};
    return Object.keys(e).forEach((t)=>{
        if (t.includes(":")) n[t] = e[t];
        else {
            const r = $3bb1d28ab2c881a5$export$d46695d9c3664fe9(e[t].accounts);
            r?.forEach((o)=>{
                n[o] = {
                    accounts: e[t].accounts.filter((s)=>s.includes(`${o}:`)),
                    methods: e[t].methods,
                    events: e[t].events
                };
            });
        }
    }), n;
}
function $3bb1d28ab2c881a5$export$59fba2af1ac782b(e, n) {
    return $3bb1d28ab2c881a5$export$d6781b696a0576d1(e, !1) && e <= n.max && e >= n.min;
}
function $3bb1d28ab2c881a5$export$53c2fd0173ad2b80() {
    const e = $3bb1d28ab2c881a5$export$57570b1603cf6adb();
    return new Promise((n)=>{
        switch(e){
            case $3bb1d28ab2c881a5$export$86b1301a63b15dd9.browser:
                n($3bb1d28ab2c881a5$export$2f147c609a999e49());
                break;
            case $3bb1d28ab2c881a5$export$86b1301a63b15dd9.reactNative:
                n($3bb1d28ab2c881a5$export$1444c95b1570bd12());
                break;
            case $3bb1d28ab2c881a5$export$86b1301a63b15dd9.node:
                n($3bb1d28ab2c881a5$export$aec5b2d627eec500());
                break;
            default:
                n(!0);
        }
    });
}
function $3bb1d28ab2c881a5$export$2f147c609a999e49() {
    return $3bb1d28ab2c881a5$export$4e09c449d6c407f7() && navigator?.onLine;
}
async function $3bb1d28ab2c881a5$export$1444c95b1570bd12() {
    if ($3bb1d28ab2c881a5$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo) {
        const e = await ($parcel$global == null ? void 0 : $parcel$global.NetInfo.fetch());
        return e?.isConnected;
    }
    return !0;
}
function $3bb1d28ab2c881a5$export$aec5b2d627eec500() {
    return !0;
}
function $3bb1d28ab2c881a5$export$600a1ee4bc680996(e) {
    switch($3bb1d28ab2c881a5$export$57570b1603cf6adb()){
        case $3bb1d28ab2c881a5$export$86b1301a63b15dd9.browser:
            $3bb1d28ab2c881a5$export$d32b24f18d96c5f2(e);
            break;
        case $3bb1d28ab2c881a5$export$86b1301a63b15dd9.reactNative:
            $3bb1d28ab2c881a5$export$904edb1c18ec91c7(e);
            break;
        case $3bb1d28ab2c881a5$export$86b1301a63b15dd9.node:
            break;
    }
}
function $3bb1d28ab2c881a5$export$d32b24f18d96c5f2(e) {
    !$3bb1d28ab2c881a5$export$f7a1e23e542d38e3() && $3bb1d28ab2c881a5$export$4e09c449d6c407f7() && (window.addEventListener("online", ()=>e(!0)), window.addEventListener("offline", ()=>e(!1)));
}
function $3bb1d28ab2c881a5$export$904edb1c18ec91c7(e) {
    $3bb1d28ab2c881a5$export$f7a1e23e542d38e3() && typeof $parcel$global < "u" && $parcel$global != null && $parcel$global.NetInfo && $parcel$global?.NetInfo.addEventListener((n)=>e(n?.isConnected));
}
const $3bb1d28ab2c881a5$var$ae = {};
class $3bb1d28ab2c881a5$export$b72d712fed4d036d {
    static get(n) {
        return $3bb1d28ab2c881a5$var$ae[n];
    }
    static set(n, t) {
        $3bb1d28ab2c881a5$var$ae[n] = t;
    }
    static delete(n) {
        delete $3bb1d28ab2c881a5$var$ae[n];
    }
}

});
parcelRegister("d2sHe", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2F1AY = parcelRequire("2F1AY");

var $bXnHS = parcelRequire("bXnHS");

var $4PQ6C = parcelRequire("4PQ6C");

var $D8NP9 = parcelRequire("D8NP9");

var $cPPqL = parcelRequire("cPPqL");
module.exports.KEY_LENGTH = 32;
module.exports.NONCE_LENGTH = 12;
module.exports.TAG_LENGTH = 16;
var $97e1b8bd531f86d7$var$ZEROS = new Uint8Array(16);
/**
 * ChaCha20-Poly1305 Authenticated Encryption with Associated Data.
 *
 * Defined in RFC7539.
 */ var $97e1b8bd531f86d7$var$ChaCha20Poly1305 = /** @class */ function() {
    /**
     * Creates a new instance with the given 32-byte key.
     */ function ChaCha20Poly1305(key) {
        this.nonceLength = module.exports.NONCE_LENGTH;
        this.tagLength = module.exports.TAG_LENGTH;
        if (key.length !== module.exports.KEY_LENGTH) throw new Error("ChaCha20Poly1305 needs 32-byte key");
        // Copy key.
        this._key = new Uint8Array(key);
    }
    /**
     * Encrypts and authenticates plaintext, authenticates associated data,
     * and returns sealed ciphertext, which includes authentication tag.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If dst is given (it must be the size of plaintext + the size of tag
     * length) the result will be put into it. Dst and plaintext must not
     * overlap.
     */ ChaCha20Poly1305.prototype.seal = function(nonce, plaintext, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        // We pass full counter, which has 12-byte nonce and 4-byte block counter,
        // and it will get incremented after generating the block, which is
        // exactly what we need: we only use the first 32 bytes of 64-byte
        // ChaCha block and discard the next 32 bytes.
        var authKey = new Uint8Array(32);
        $2F1AY.stream(this._key, counter, authKey, 4);
        // Allocate space for sealed ciphertext.
        var resultLength = plaintext.length + this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Encrypt plaintext.
        $2F1AY.streamXOR(this._key, counter, plaintext, result, 4);
        // Authenticate.
        // XXX: can "simplify" here: pass full result (which is already padded
        // due to zeroes prepared for tag), and ciphertext length instead of
        // subarray of result.
        this._authenticate(result.subarray(result.length - this.tagLength, result.length), authKey, result.subarray(0, result.length - this.tagLength), associatedData);
        // Cleanup.
        $4PQ6C.wipe(counter);
        return result;
    };
    /**
     * Authenticates sealed ciphertext (which includes authentication tag) and
     * associated data, decrypts ciphertext and returns decrypted plaintext.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If authentication fails, it returns null.
     *
     * If dst is given (it must be of ciphertext length minus tag length),
     * the result will be put into it. Dst and plaintext must not overlap.
     */ ChaCha20Poly1305.prototype.open = function(nonce, sealed, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Sealed ciphertext should at least contain tag.
        if (sealed.length < this.tagLength) // TODO(dchest): should we throw here instead?
        return null;
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        var authKey = new Uint8Array(32);
        $2F1AY.stream(this._key, counter, authKey, 4);
        // Authenticate.
        // XXX: can simplify and avoid allocation: since authenticate()
        // already allocates tag (from Poly1305.digest(), it can return)
        // it instead of copying to calculatedTag. But then in seal()
        // we'll need to copy it.
        var calculatedTag = new Uint8Array(this.tagLength);
        this._authenticate(calculatedTag, authKey, sealed.subarray(0, sealed.length - this.tagLength), associatedData);
        // Constant-time compare tags and return null if they differ.
        if (!$cPPqL.equal(calculatedTag, sealed.subarray(sealed.length - this.tagLength, sealed.length))) return null;
        // Allocate space for decrypted plaintext.
        var resultLength = sealed.length - this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Decrypt.
        $2F1AY.streamXOR(this._key, counter, sealed.subarray(0, sealed.length - this.tagLength), result, 4);
        // Cleanup.
        $4PQ6C.wipe(counter);
        return result;
    };
    ChaCha20Poly1305.prototype.clean = function() {
        $4PQ6C.wipe(this._key);
        return this;
    };
    ChaCha20Poly1305.prototype._authenticate = function(tagOut, authKey, ciphertext, associatedData) {
        // Initialize Poly1305 with authKey.
        var h = new $bXnHS.Poly1305(authKey);
        // Authenticate padded associated data.
        if (associatedData) {
            h.update(associatedData);
            if (associatedData.length % 16 > 0) h.update($97e1b8bd531f86d7$var$ZEROS.subarray(associatedData.length % 16));
        }
        // Authenticate padded ciphertext.
        h.update(ciphertext);
        if (ciphertext.length % 16 > 0) h.update($97e1b8bd531f86d7$var$ZEROS.subarray(ciphertext.length % 16));
        // Authenticate length of associated data.
        // XXX: can avoid allocation here?
        var length = new Uint8Array(8);
        if (associatedData) $D8NP9.writeUint64LE(associatedData.length, length);
        h.update(length);
        // Authenticate length of ciphertext.
        $D8NP9.writeUint64LE(ciphertext.length, length);
        h.update(length);
        // Get tag and copy it into tagOut.
        var tag = h.digest();
        for(var i = 0; i < tag.length; i++)tagOut[i] = tag[i];
        // Cleanup.
        h.clean();
        $4PQ6C.wipe(tag);
        $4PQ6C.wipe(length);
    };
    return ChaCha20Poly1305;
}();
module.exports.ChaCha20Poly1305 = $97e1b8bd531f86d7$var$ChaCha20Poly1305;

});
parcelRegister("2F1AY", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $D8NP9 = parcelRequire("D8NP9");

var $4PQ6C = parcelRequire("4PQ6C");
// Number of ChaCha rounds (ChaCha20).
var $1f00a5e3d3eafbab$var$ROUNDS = 20;
// Applies the ChaCha core function to 16-byte input,
// 32-byte key key, and puts the result into 64-byte array out.
function $1f00a5e3d3eafbab$var$core(out, input, key) {
    var j0 = 0x61707865; // "expa"  -- ChaCha's "sigma" constant
    var j1 = 0x3320646E; // "nd 3"     for 32-byte keys
    var j2 = 0x79622D32; // "2-by"
    var j3 = 0x6B206574; // "te k"
    var j4 = key[3] << 24 | key[2] << 16 | key[1] << 8 | key[0];
    var j5 = key[7] << 24 | key[6] << 16 | key[5] << 8 | key[4];
    var j6 = key[11] << 24 | key[10] << 16 | key[9] << 8 | key[8];
    var j7 = key[15] << 24 | key[14] << 16 | key[13] << 8 | key[12];
    var j8 = key[19] << 24 | key[18] << 16 | key[17] << 8 | key[16];
    var j9 = key[23] << 24 | key[22] << 16 | key[21] << 8 | key[20];
    var j10 = key[27] << 24 | key[26] << 16 | key[25] << 8 | key[24];
    var j11 = key[31] << 24 | key[30] << 16 | key[29] << 8 | key[28];
    var j12 = input[3] << 24 | input[2] << 16 | input[1] << 8 | input[0];
    var j13 = input[7] << 24 | input[6] << 16 | input[5] << 8 | input[4];
    var j14 = input[11] << 24 | input[10] << 16 | input[9] << 8 | input[8];
    var j15 = input[15] << 24 | input[14] << 16 | input[13] << 8 | input[12];
    var x0 = j0;
    var x1 = j1;
    var x2 = j2;
    var x3 = j3;
    var x4 = j4;
    var x5 = j5;
    var x6 = j6;
    var x7 = j7;
    var x8 = j8;
    var x9 = j9;
    var x10 = j10;
    var x11 = j11;
    var x12 = j12;
    var x13 = j13;
    var x14 = j14;
    var x15 = j15;
    for(var i = 0; i < $1f00a5e3d3eafbab$var$ROUNDS; i += 2){
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 16 | x12 << 16;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 20 | x4 << 12;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 16 | x13 << 16;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 20 | x5 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 16 | x14 << 16;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 20 | x6 << 12;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 16 | x15 << 16;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 20 | x7 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 24 | x14 << 8;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 25 | x6 << 7;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 24 | x15 << 8;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 25 | x7 << 7;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 24 | x13 << 8;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 25 | x5 << 7;
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 24 | x12 << 8;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 25 | x4 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 16 | x15 << 16;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 20 | x5 << 12;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 16 | x12 << 16;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 20 | x6 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 16 | x13 << 16;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 20 | x7 << 12;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 16 | x14 << 16;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 20 | x4 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 24 | x13 << 8;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 25 | x7 << 7;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 24 | x14 << 8;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 25 | x4 << 7;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 24 | x12 << 8;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 25 | x6 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 24 | x15 << 8;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 25 | x5 << 7;
    }
    $D8NP9.writeUint32LE(x0 + j0 | 0, out, 0);
    $D8NP9.writeUint32LE(x1 + j1 | 0, out, 4);
    $D8NP9.writeUint32LE(x2 + j2 | 0, out, 8);
    $D8NP9.writeUint32LE(x3 + j3 | 0, out, 12);
    $D8NP9.writeUint32LE(x4 + j4 | 0, out, 16);
    $D8NP9.writeUint32LE(x5 + j5 | 0, out, 20);
    $D8NP9.writeUint32LE(x6 + j6 | 0, out, 24);
    $D8NP9.writeUint32LE(x7 + j7 | 0, out, 28);
    $D8NP9.writeUint32LE(x8 + j8 | 0, out, 32);
    $D8NP9.writeUint32LE(x9 + j9 | 0, out, 36);
    $D8NP9.writeUint32LE(x10 + j10 | 0, out, 40);
    $D8NP9.writeUint32LE(x11 + j11 | 0, out, 44);
    $D8NP9.writeUint32LE(x12 + j12 | 0, out, 48);
    $D8NP9.writeUint32LE(x13 + j13 | 0, out, 52);
    $D8NP9.writeUint32LE(x14 + j14 | 0, out, 56);
    $D8NP9.writeUint32LE(x15 + j15 | 0, out, 60);
}
/**
 * Encrypt src with ChaCha20 stream generated for the given 32-byte key and
 * 8-byte (as in original implementation) or 12-byte (as in RFC7539) nonce and
 * write the result into dst and return it.
 *
 * dst and src may be the same, but otherwise must not overlap.
 *
 * If nonce is 12 bytes, users should not encrypt more than 256 GiB with the
 * same key and nonce, otherwise the stream will repeat. The function will
 * throw error if counter overflows to prevent this.
 *
 * If nonce is 8 bytes, the output is practically unlimited (2^70 bytes, which
 * is more than a million petabytes). However, it is not recommended to
 * generate 8-byte nonces randomly, as the chance of collision is high.
 *
 * Never use the same key and nonce to encrypt more than one message.
 *
 * If nonceInplaceCounterLength is not 0, the nonce is assumed to be a 16-byte
 * array with stream counter in first nonceInplaceCounterLength bytes and nonce
 * in the last remaining bytes. The counter will be incremented inplace for
 * each ChaCha block. This is useful if you need to encrypt one stream of data
 * in chunks.
 */ function $1f00a5e3d3eafbab$var$streamXOR(key, nonce, src, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    // We only support 256-bit keys.
    if (key.length !== 32) throw new Error("ChaCha: key size must be 32 bytes");
    if (dst.length < src.length) throw new Error("ChaCha: destination is shorter than source");
    var nc;
    var counterLength;
    if (nonceInplaceCounterLength === 0) {
        if (nonce.length !== 8 && nonce.length !== 12) throw new Error("ChaCha nonce must be 8 or 12 bytes");
        nc = new Uint8Array(16);
        // First counterLength bytes of nc are counter, starting with zero.
        counterLength = nc.length - nonce.length;
        // Last bytes of nc after counterLength are nonce, set them.
        nc.set(nonce, counterLength);
    } else {
        if (nonce.length !== 16) throw new Error("ChaCha nonce with counter must be 16 bytes");
        // This will update passed nonce with counter inplace.
        nc = nonce;
        counterLength = nonceInplaceCounterLength;
    }
    // Allocate temporary space for ChaCha block.
    var block = new Uint8Array(64);
    for(var i = 0; i < src.length; i += 64){
        // Generate a block.
        $1f00a5e3d3eafbab$var$core(block, nc, key);
        // XOR block bytes with src into dst.
        for(var j = i; j < i + 64 && j < src.length; j++)dst[j] = src[j] ^ block[j - i];
        // Increment counter.
        $1f00a5e3d3eafbab$var$incrementCounter(nc, 0, counterLength);
    }
    // Cleanup temporary space.
    $4PQ6C.wipe(block);
    if (nonceInplaceCounterLength === 0) // Cleanup counter.
    $4PQ6C.wipe(nc);
    return dst;
}
module.exports.streamXOR = $1f00a5e3d3eafbab$var$streamXOR;
/**
 * Generate ChaCha20 stream for the given 32-byte key and 8-byte or 12-byte
 * nonce and write it into dst and return it.
 *
 * Never use the same key and nonce to generate more than one stream.
 *
 * If nonceInplaceCounterLength is not 0, it behaves the same with respect to
 * the nonce as described in the streamXOR documentation.
 *
 * stream is like streamXOR with all-zero src.
 */ function $1f00a5e3d3eafbab$var$stream(key, nonce, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    $4PQ6C.wipe(dst);
    return $1f00a5e3d3eafbab$var$streamXOR(key, nonce, dst, dst, nonceInplaceCounterLength);
}
module.exports.stream = $1f00a5e3d3eafbab$var$stream;
function $1f00a5e3d3eafbab$var$incrementCounter(counter, pos, len) {
    var carry = 1;
    while(len--){
        carry = carry + (counter[pos] & 0xff) | 0;
        counter[pos] = carry & 0xff;
        carry >>>= 8;
        pos++;
    }
    if (carry > 0) throw new Error("ChaCha: counter overflow");
}

});
parcelRegister("D8NP9", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6YKQ3 = parcelRequire("6YKQ3");
// TODO(dchest): add asserts for correct value ranges and array offsets.
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * signed 16-bit integer and returns it.
 */ function $075a78a61142e197$var$readInt16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) << 16 >> 16;
}
module.exports.readInt16BE = $075a78a61142e197$var$readInt16BE;
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * unsigned 16-bit integer and returns it.
 */ function $075a78a61142e197$var$readUint16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) >>> 0;
}
module.exports.readUint16BE = $075a78a61142e197$var$readUint16BE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * signed 16-bit integer and returns it.
 */ function $075a78a61142e197$var$readInt16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) << 16 >> 16;
}
module.exports.readInt16LE = $075a78a61142e197$var$readInt16LE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * unsigned 16-bit integer and returns it.
 */ function $075a78a61142e197$var$readUint16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) >>> 0;
}
module.exports.readUint16LE = $075a78a61142e197$var$readUint16LE;
/**
 * Writes 2-byte big-endian representation of 16-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $075a78a61142e197$var$writeUint16BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 8;
    out[offset + 1] = value >>> 0;
    return out;
}
module.exports.writeUint16BE = $075a78a61142e197$var$writeUint16BE;
module.exports.writeInt16BE = $075a78a61142e197$var$writeUint16BE;
/**
 * Writes 2-byte little-endian representation of 16-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $075a78a61142e197$var$writeUint16LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    return out;
}
module.exports.writeUint16LE = $075a78a61142e197$var$writeUint16LE;
module.exports.writeInt16LE = $075a78a61142e197$var$writeUint16LE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * signed 32-bit integer and returns it.
 */ function $075a78a61142e197$var$readInt32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3];
}
module.exports.readInt32BE = $075a78a61142e197$var$readInt32BE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * unsigned 32-bit integer and returns it.
 */ function $075a78a61142e197$var$readUint32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3]) >>> 0;
}
module.exports.readUint32BE = $075a78a61142e197$var$readUint32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * signed 32-bit integer and returns it.
 */ function $075a78a61142e197$var$readInt32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset];
}
module.exports.readInt32LE = $075a78a61142e197$var$readInt32LE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * unsigned 32-bit integer and returns it.
 */ function $075a78a61142e197$var$readUint32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset]) >>> 0;
}
module.exports.readUint32LE = $075a78a61142e197$var$readUint32LE;
/**
 * Writes 4-byte big-endian representation of 32-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $075a78a61142e197$var$writeUint32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 24;
    out[offset + 1] = value >>> 16;
    out[offset + 2] = value >>> 8;
    out[offset + 3] = value >>> 0;
    return out;
}
module.exports.writeUint32BE = $075a78a61142e197$var$writeUint32BE;
module.exports.writeInt32BE = $075a78a61142e197$var$writeUint32BE;
/**
 * Writes 4-byte little-endian representation of 32-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $075a78a61142e197$var$writeUint32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    out[offset + 2] = value >>> 16;
    out[offset + 3] = value >>> 24;
    return out;
}
module.exports.writeUint32LE = $075a78a61142e197$var$writeUint32LE;
module.exports.writeInt32LE = $075a78a61142e197$var$writeUint32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $075a78a61142e197$var$readInt64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $075a78a61142e197$var$readInt32BE(array, offset);
    var lo = $075a78a61142e197$var$readInt32BE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
module.exports.readInt64BE = $075a78a61142e197$var$readInt64BE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $075a78a61142e197$var$readUint64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $075a78a61142e197$var$readUint32BE(array, offset);
    var lo = $075a78a61142e197$var$readUint32BE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
module.exports.readUint64BE = $075a78a61142e197$var$readUint64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $075a78a61142e197$var$readInt64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $075a78a61142e197$var$readInt32LE(array, offset);
    var hi = $075a78a61142e197$var$readInt32LE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
module.exports.readInt64LE = $075a78a61142e197$var$readInt64LE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $075a78a61142e197$var$readUint64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $075a78a61142e197$var$readUint32LE(array, offset);
    var hi = $075a78a61142e197$var$readUint32LE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
module.exports.readUint64LE = $075a78a61142e197$var$readUint64LE;
/**
 * Writes 8-byte big-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $075a78a61142e197$var$writeUint64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $075a78a61142e197$var$writeUint32BE(value / 0x100000000 >>> 0, out, offset);
    $075a78a61142e197$var$writeUint32BE(value >>> 0, out, offset + 4);
    return out;
}
module.exports.writeUint64BE = $075a78a61142e197$var$writeUint64BE;
module.exports.writeInt64BE = $075a78a61142e197$var$writeUint64BE;
/**
 * Writes 8-byte little-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $075a78a61142e197$var$writeUint64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $075a78a61142e197$var$writeUint32LE(value >>> 0, out, offset);
    $075a78a61142e197$var$writeUint32LE(value / 0x100000000 >>> 0, out, offset + 4);
    return out;
}
module.exports.writeUint64LE = $075a78a61142e197$var$writeUint64LE;
module.exports.writeInt64LE = $075a78a61142e197$var$writeUint64LE;
/**
 * Reads bytes from array starting at offset as big-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $075a78a61142e197$var$readUintBE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintBE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintBE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
module.exports.readUintBE = $075a78a61142e197$var$readUintBE;
/**
 * Reads bytes from array starting at offset as little-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $075a78a61142e197$var$readUintLE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintLE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintLE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
module.exports.readUintLE = $075a78a61142e197$var$readUintLE;
/**
 * Writes a big-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $075a78a61142e197$var$writeUintBE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintBE supports only bitLengths divisible by 8");
    if (!$6YKQ3.isSafeInteger(value)) throw new Error("writeUintBE value must be an integer");
    var div = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
module.exports.writeUintBE = $075a78a61142e197$var$writeUintBE;
/**
 * Writes a little-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $075a78a61142e197$var$writeUintLE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintLE supports only bitLengths divisible by 8");
    if (!$6YKQ3.isSafeInteger(value)) throw new Error("writeUintLE value must be an integer");
    var div = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
module.exports.writeUintLE = $075a78a61142e197$var$writeUintLE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * 32-bit floating-point number and returns it.
 */ function $075a78a61142e197$var$readFloat32BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset);
}
module.exports.readFloat32BE = $075a78a61142e197$var$readFloat32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * 32-bit floating-point number and returns it.
 */ function $075a78a61142e197$var$readFloat32LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset, true);
}
module.exports.readFloat32LE = $075a78a61142e197$var$readFloat32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $075a78a61142e197$var$readFloat64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset);
}
module.exports.readFloat64BE = $075a78a61142e197$var$readFloat64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $075a78a61142e197$var$readFloat64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset, true);
}
module.exports.readFloat64LE = $075a78a61142e197$var$readFloat64LE;
/**
 * Writes 4-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $075a78a61142e197$var$writeFloat32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value);
    return out;
}
module.exports.writeFloat32BE = $075a78a61142e197$var$writeFloat32BE;
/**
 * Writes 4-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $075a78a61142e197$var$writeFloat32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value, true);
    return out;
}
module.exports.writeFloat32LE = $075a78a61142e197$var$writeFloat32LE;
/**
 * Writes 8-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $075a78a61142e197$var$writeFloat64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value);
    return out;
}
module.exports.writeFloat64BE = $075a78a61142e197$var$writeFloat64BE;
/**
 * Writes 8-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $075a78a61142e197$var$writeFloat64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value, true);
    return out;
}
module.exports.writeFloat64LE = $075a78a61142e197$var$writeFloat64LE;

});
parcelRegister("6YKQ3", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Package int provides helper functions for integerss.
 */ // Shim using 16-bit pieces.
function $514cadd75a7e5607$var$imulShim(a, b) {
    var ah = a >>> 16 & 0xffff, al = a & 0xffff;
    var bh = b >>> 16 & 0xffff, bl = b & 0xffff;
    return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
}
/** 32-bit integer multiplication.  */ // Use system Math.imul if available, otherwise use our shim.
module.exports.mul = Math.imul || $514cadd75a7e5607$var$imulShim;
/** 32-bit integer addition.  */ function $514cadd75a7e5607$var$add(a, b) {
    return a + b | 0;
}
module.exports.add = $514cadd75a7e5607$var$add;
/**  32-bit integer subtraction.  */ function $514cadd75a7e5607$var$sub(a, b) {
    return a - b | 0;
}
module.exports.sub = $514cadd75a7e5607$var$sub;
/** 32-bit integer left rotation */ function $514cadd75a7e5607$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
module.exports.rotl = $514cadd75a7e5607$var$rotl;
/** 32-bit integer left rotation */ function $514cadd75a7e5607$var$rotr(x, n) {
    return x << 32 - n | x >>> n;
}
module.exports.rotr = $514cadd75a7e5607$var$rotr;
function $514cadd75a7e5607$var$isIntegerShim(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
}
/**
 * Returns true if the argument is an integer number.
 *
 * In ES2015, Number.isInteger.
 */ module.exports.isInteger = Number.isInteger || $514cadd75a7e5607$var$isIntegerShim;
/**
 *  Math.pow(2, 53) - 1
 *
 *  In ES2015 Number.MAX_SAFE_INTEGER.
 */ module.exports.MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Returns true if the argument is a safe integer number
 * (-MIN_SAFE_INTEGER < number <= MAX_SAFE_INTEGER)
 *
 * In ES2015, Number.isSafeInteger.
 */ module.exports.isSafeInteger = function(n) {
    return module.exports.isInteger(n) && n >= -module.exports.MAX_SAFE_INTEGER && n <= module.exports.MAX_SAFE_INTEGER;
};

});


parcelRegister("4PQ6C", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Sets all values in the given array to zero and returns it.
 *
 * The fact that it sets bytes to zero can be relied on.
 *
 * There is no guarantee that this function makes data disappear from memory,
 * as runtime implementation can, for example, have copying garbage collector
 * that will make copies of sensitive data before we wipe it. Or that an
 * operating system will write our data to swap or sleep image. Another thing
 * is that an optimizing compiler can remove calls to this function or make it
 * no-op. There's nothing we can do with it, so we just do our best and hope
 * that everything will be okay and good will triumph over evil.
 */ function $385457fbc602a4c1$var$wipe(array) {
    // Right now it's similar to array.fill(0). If it turns
    // out that runtimes optimize this call away, maybe
    // we can try something else.
    for(var i = 0; i < array.length; i++)array[i] = 0;
    return array;
}
module.exports.wipe = $385457fbc602a4c1$var$wipe;

});


parcelRegister("bXnHS", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cPPqL = parcelRequire("cPPqL");

var $4PQ6C = parcelRequire("4PQ6C");
module.exports.DIGEST_LENGTH = 16;
// Port of Andrew Moon's Poly1305-donna-16. Public domain.
// https://github.com/floodyberry/poly1305-donna
/**
 * Poly1305 computes 16-byte authenticator of message using
 * a one-time 32-byte key.
 *
 * Important: key should be used for only one message,
 * it should never repeat.
 */ var $8b479812183230e7$var$Poly1305 = /** @class */ function() {
    function Poly1305(key) {
        this.digestLength = module.exports.DIGEST_LENGTH;
        this._buffer = new Uint8Array(16);
        this._r = new Uint16Array(10);
        this._h = new Uint16Array(10);
        this._pad = new Uint16Array(8);
        this._leftover = 0;
        this._fin = 0;
        this._finished = false;
        var t0 = key[0] | key[1] << 8;
        this._r[0] = t0 & 0x1fff;
        var t1 = key[2] | key[3] << 8;
        this._r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        var t2 = key[4] | key[5] << 8;
        this._r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        var t3 = key[6] | key[7] << 8;
        this._r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        var t4 = key[8] | key[9] << 8;
        this._r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this._r[5] = t4 >>> 1 & 0x1ffe;
        var t5 = key[10] | key[11] << 8;
        this._r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        var t6 = key[12] | key[13] << 8;
        this._r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        var t7 = key[14] | key[15] << 8;
        this._r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this._r[9] = t7 >>> 5 & 0x007f;
        this._pad[0] = key[16] | key[17] << 8;
        this._pad[1] = key[18] | key[19] << 8;
        this._pad[2] = key[20] | key[21] << 8;
        this._pad[3] = key[22] | key[23] << 8;
        this._pad[4] = key[24] | key[25] << 8;
        this._pad[5] = key[26] | key[27] << 8;
        this._pad[6] = key[28] | key[29] << 8;
        this._pad[7] = key[30] | key[31] << 8;
    }
    Poly1305.prototype._blocks = function(m, mpos, bytes) {
        var hibit = this._fin ? 0 : 2048;
        var h0 = this._h[0], h1 = this._h[1], h2 = this._h[2], h3 = this._h[3], h4 = this._h[4], h5 = this._h[5], h6 = this._h[6], h7 = this._h[7], h8 = this._h[8], h9 = this._h[9];
        var r0 = this._r[0], r1 = this._r[1], r2 = this._r[2], r3 = this._r[3], r4 = this._r[4], r5 = this._r[5], r6 = this._r[6], r7 = this._r[7], r8 = this._r[8], r9 = this._r[9];
        while(bytes >= 16){
            var t0 = m[mpos + 0] | m[mpos + 1] << 8;
            h0 += t0 & 0x1fff;
            var t1 = m[mpos + 2] | m[mpos + 3] << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            var t2 = m[mpos + 4] | m[mpos + 5] << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            var t3 = m[mpos + 6] | m[mpos + 7] << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            var t4 = m[mpos + 8] | m[mpos + 9] << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            var t5 = m[mpos + 10] | m[mpos + 11] << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            var t6 = m[mpos + 12] | m[mpos + 13] << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            var t7 = m[mpos + 14] | m[mpos + 15] << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            var c = 0;
            var d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            var d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            var d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            var d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            var d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            var d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            var d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            var d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            var d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            var d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this._h[0] = h0;
        this._h[1] = h1;
        this._h[2] = h2;
        this._h[3] = h3;
        this._h[4] = h4;
        this._h[5] = h5;
        this._h[6] = h6;
        this._h[7] = h7;
        this._h[8] = h8;
        this._h[9] = h9;
    };
    Poly1305.prototype.finish = function(mac, macpos) {
        if (macpos === void 0) macpos = 0;
        var g = new Uint16Array(10);
        var c;
        var mask;
        var f;
        var i;
        if (this._leftover) {
            i = this._leftover;
            this._buffer[i++] = 1;
            for(; i < 16; i++)this._buffer[i] = 0;
            this._fin = 1;
            this._blocks(this._buffer, 0, 16);
        }
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this._h[i] += c;
            c = this._h[i] >>> 13;
            this._h[i] &= 0x1fff;
        }
        this._h[0] += c * 5;
        c = this._h[0] >>> 13;
        this._h[0] &= 0x1fff;
        this._h[1] += c;
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        this._h[2] += c;
        g[0] = this._h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this._h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this._h[i] = this._h[i] & mask | g[i];
        this._h[0] = (this._h[0] | this._h[1] << 13) & 0xffff;
        this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 0xffff;
        this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 0xffff;
        this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 0xffff;
        this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 0xffff;
        this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 0xffff;
        this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 0xffff;
        this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 0xffff;
        f = this._h[0] + this._pad[0];
        this._h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this._h[i] + this._pad[i] | 0) + (f >>> 16) | 0;
            this._h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this._h[0] >>> 0;
        mac[macpos + 1] = this._h[0] >>> 8;
        mac[macpos + 2] = this._h[1] >>> 0;
        mac[macpos + 3] = this._h[1] >>> 8;
        mac[macpos + 4] = this._h[2] >>> 0;
        mac[macpos + 5] = this._h[2] >>> 8;
        mac[macpos + 6] = this._h[3] >>> 0;
        mac[macpos + 7] = this._h[3] >>> 8;
        mac[macpos + 8] = this._h[4] >>> 0;
        mac[macpos + 9] = this._h[4] >>> 8;
        mac[macpos + 10] = this._h[5] >>> 0;
        mac[macpos + 11] = this._h[5] >>> 8;
        mac[macpos + 12] = this._h[6] >>> 0;
        mac[macpos + 13] = this._h[6] >>> 8;
        mac[macpos + 14] = this._h[7] >>> 0;
        mac[macpos + 15] = this._h[7] >>> 8;
        this._finished = true;
        return this;
    };
    Poly1305.prototype.update = function(m) {
        var mpos = 0;
        var bytes = m.length;
        var want;
        if (this._leftover) {
            want = 16 - this._leftover;
            if (want > bytes) want = bytes;
            for(var i = 0; i < want; i++)this._buffer[this._leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this._leftover += want;
            if (this._leftover < 16) return this;
            this._blocks(this._buffer, 0, 16);
            this._leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this._blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(var i = 0; i < bytes; i++)this._buffer[this._leftover + i] = m[mpos + i];
            this._leftover += bytes;
        }
        return this;
    };
    Poly1305.prototype.digest = function() {
        // TODO(dchest): it behaves differently than other hashes/HMAC,
        // because it throws when finished — others just return saved result.
        if (this._finished) throw new Error("Poly1305 was finished");
        var mac = new Uint8Array(16);
        this.finish(mac);
        return mac;
    };
    Poly1305.prototype.clean = function() {
        $4PQ6C.wipe(this._buffer);
        $4PQ6C.wipe(this._r);
        $4PQ6C.wipe(this._h);
        $4PQ6C.wipe(this._pad);
        this._leftover = 0;
        this._fin = 0;
        this._finished = true; // mark as finished even if not
        return this;
    };
    return Poly1305;
}();
module.exports.Poly1305 = $8b479812183230e7$var$Poly1305;
/**
 * Returns 16-byte authenticator of data using a one-time 32-byte key.
 *
 * Important: key should be used for only one message, it should never repeat.
 */ function $8b479812183230e7$var$oneTimeAuth(key, data) {
    var h = new $8b479812183230e7$var$Poly1305(key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.oneTimeAuth = $8b479812183230e7$var$oneTimeAuth;
/**
 * Returns true if two authenticators are 16-byte long and equal.
 * Uses contant-time comparison to avoid leaking timing information.
 */ function $8b479812183230e7$var$equal(a, b) {
    if (a.length !== module.exports.DIGEST_LENGTH || b.length !== module.exports.DIGEST_LENGTH) return false;
    return $cPPqL.equal(a, b);
}
module.exports.equal = $8b479812183230e7$var$equal;

});
parcelRegister("cPPqL", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Package constant-time provides functions for performing algorithmically constant-time operations.
 */ /**
 * NOTE! Due to the inability to guarantee real constant time evaluation of
 * anything in JavaScript VM, this is module is the best effort.
 */ /**
 * Returns resultIfOne if subject is 1, or resultIfZero if subject is 0.
 *
 * Supports only 32-bit integers, so resultIfOne or resultIfZero are not
 * integers, they'll be converted to them with bitwise operations.
 */ function $95822480f5798c23$var$select(subject, resultIfOne, resultIfZero) {
    return ~(subject - 1) & resultIfOne | subject - 1 & resultIfZero;
}
module.exports.select = $95822480f5798c23$var$select;
/**
 * Returns 1 if a <= b, or 0 if not.
 * Arguments must be positive 32-bit integers less than or equal to 2^31 - 1.
 */ function $95822480f5798c23$var$lessOrEqual(a, b) {
    return (a | 0) - (b | 0) - 1 >>> 31 & 1;
}
module.exports.lessOrEqual = $95822480f5798c23$var$lessOrEqual;
/**
 * Returns 1 if a and b are of equal length and their contents
 * are equal, or 0 otherwise.
 *
 * Note that unlike in equal(), zero-length inputs are considered
 * the same, so this function will return 1.
 */ function $95822480f5798c23$var$compare(a, b) {
    if (a.length !== b.length) return 0;
    var result = 0;
    for(var i = 0; i < a.length; i++)result |= a[i] ^ b[i];
    return 1 & result - 1 >>> 8;
}
module.exports.compare = $95822480f5798c23$var$compare;
/**
 * Returns true if a and b are of equal non-zero length,
 * and their contents are equal, or false otherwise.
 *
 * Note that unlike in compare() zero-length inputs are considered
 * _not_ equal, so this function will return false.
 */ function $95822480f5798c23$var$equal(a, b) {
    if (a.length === 0 || b.length === 0) return false;
    return $95822480f5798c23$var$compare(a, b) !== 0;
}
module.exports.equal = $95822480f5798c23$var$equal;

});



parcelRegister("cWicQ", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $beP6m = parcelRequire("beP6m");

var $4PQ6C = parcelRequire("4PQ6C");
/**
 * HMAC-based Extract-and-Expand Key Derivation Function.
 *
 * Implements HKDF from RFC5869.
 *
 * Expands the given master key with salt and info into
 * a limited stream of key material.
 */ var $96b90629a336bc0f$var$HKDF = /** @class */ function() {
    /**
     * Create a new HKDF instance for the given hash function
     * with the master key, optional salt, and info.
     *
     * - Master key is a high-entropy secret key (not a password).
     * - Salt is a non-secret random value.
     * - Info is application- and/or context-specific information.
     */ function HKDF(hash, key, salt, info) {
        if (salt === void 0) salt = new Uint8Array(0);
        this._counter = new Uint8Array(1); // starts with zero
        this._hash = hash;
        this._info = info;
        // HKDF-Extract uses salt as HMAC key, and key as data.
        var okm = $beP6m.hmac(this._hash, salt, key);
        // Initialize HMAC for expanding with extracted key.
        this._hmac = new $beP6m.HMAC(hash, okm);
        // Allocate buffer.
        this._buffer = new Uint8Array(this._hmac.digestLength);
        this._bufpos = this._buffer.length;
    }
    // Fill buffer with new block of HKDF-Extract output.
    HKDF.prototype._fillBuffer = function() {
        // Increment counter.
        this._counter[0]++;
        var ctr = this._counter[0];
        // Check if counter overflowed.
        if (ctr === 0) throw new Error("hkdf: cannot expand more");
        // Prepare HMAC instance for new data with old key.
        this._hmac.reset();
        // Hash in previous output if it was generated
        // (i.e. counter is greater than 1).
        if (ctr > 1) this._hmac.update(this._buffer);
        // Hash in info if it exists.
        if (this._info) this._hmac.update(this._info);
        // Hash in the counter.
        this._hmac.update(this._counter);
        // Output result to buffer and clean HMAC instance.
        this._hmac.finish(this._buffer);
        // Reset buffer position.
        this._bufpos = 0;
    };
    /**
     * Expand returns next key material of the given length.
     *
     * It throws if expansion limit is reached (which is
     * 254 digests of the underlying HMAC function).
     */ HKDF.prototype.expand = function(length) {
        var out = new Uint8Array(length);
        for(var i = 0; i < out.length; i++){
            if (this._bufpos === this._buffer.length) this._fillBuffer();
            out[i] = this._buffer[this._bufpos++];
        }
        return out;
    };
    HKDF.prototype.clean = function() {
        this._hmac.clean();
        $4PQ6C.wipe(this._buffer);
        $4PQ6C.wipe(this._counter);
        this._bufpos = 0;
    };
    return HKDF;
}();
module.exports.HKDF = $96b90629a336bc0f$var$HKDF; // TODO(dchest): maybe implement deriveKey?

});
parcelRegister("beP6m", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4SZpN = parcelRequire("4SZpN");

var $cPPqL = parcelRequire("cPPqL");

var $4PQ6C = parcelRequire("4PQ6C");
/**
 *  HMAC implements hash-based message authentication algorithm.
 */ var $82e8a439e372e3be$var$HMAC = /** @class */ function() {
    /**
     * Constructs a new HMAC with the given Hash and secret key.
     */ function HMAC(hash, key) {
        this._finished = false; // true if HMAC was finalized
        // Initialize inner and outer hashes.
        this._inner = new hash();
        this._outer = new hash();
        // Set block and digest sizes for this HMAC
        // instance to values from the hash.
        this.blockSize = this._outer.blockSize;
        this.digestLength = this._outer.digestLength;
        // Pad temporary stores a key (or its hash) padded with zeroes.
        var pad = new Uint8Array(this.blockSize);
        if (key.length > this.blockSize) // If key is bigger than hash block size, it must be
        // hashed and this hash is used as a key instead.
        this._inner.update(key).finish(pad).clean();
        else // Otherwise, copy the key into pad.
        pad.set(key);
        // Now two different keys are derived from padded key
        // by xoring a different byte value to each.
        // To make inner hash key, xor byte 0x36 into pad.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        // Update inner hash with the result.
        this._inner.update(pad);
        // To make outer hash key, xor byte 0x5c into pad.
        // But since we already xored 0x36 there, we must
        // first undo this by xoring it again.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 106;
        // Update outer hash with the result.
        this._outer.update(pad);
        // Save states of both hashes, so that we can quickly restore
        // them later in reset() without the need to remember the actual
        // key and perform this initialization again.
        if ($4SZpN.isSerializableHash(this._inner) && $4SZpN.isSerializableHash(this._outer)) {
            this._innerKeyedState = this._inner.saveState();
            this._outerKeyedState = this._outer.saveState();
        }
        // Clean pad.
        $4PQ6C.wipe(pad);
    }
    /**
     * Returns HMAC state to the state initialized with key
     * to make it possible to run HMAC over the other data with the same
     * key without creating a new instance.
     */ HMAC.prototype.reset = function() {
        if (!$4SZpN.isSerializableHash(this._inner) || !$4SZpN.isSerializableHash(this._outer)) throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
        // Restore keyed states of inner and outer hashes.
        this._inner.restoreState(this._innerKeyedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    /**
     * Cleans HMAC state.
     */ HMAC.prototype.clean = function() {
        if ($4SZpN.isSerializableHash(this._inner)) this._inner.cleanSavedState(this._innerKeyedState);
        if ($4SZpN.isSerializableHash(this._outer)) this._outer.cleanSavedState(this._outerKeyedState);
        this._inner.clean();
        this._outer.clean();
    };
    /**
     * Updates state with provided data.
     */ HMAC.prototype.update = function(data) {
        this._inner.update(data);
        return this;
    };
    /**
     * Finalizes HMAC and puts the result in out.
     */ HMAC.prototype.finish = function(out) {
        if (this._finished) {
            // If HMAC was finalized, outer hash is also finalized,
            // so it produces the same digest it produced when it
            // was finalized.
            this._outer.finish(out);
            return this;
        }
        // Finalize inner hash and store the result temporarily.
        this._inner.finish(out);
        // Update outer hash with digest of inner hash and and finalize it.
        this._outer.update(out.subarray(0, this.digestLength)).finish(out);
        this._finished = true;
        return this;
    };
    /**
     * Returns the computed message authentication code.
     */ HMAC.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Saves HMAC state.
     * This function is needed for PBKDF2 optimization.
     */ HMAC.prototype.saveState = function() {
        if (!$4SZpN.isSerializableHash(this._inner)) throw new Error("hmac: can't saveState() because hash doesn't implement it");
        return this._inner.saveState();
    };
    HMAC.prototype.restoreState = function(savedState) {
        if (!$4SZpN.isSerializableHash(this._inner) || !$4SZpN.isSerializableHash(this._outer)) throw new Error("hmac: can't restoreState() because hash doesn't implement it");
        this._inner.restoreState(savedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    HMAC.prototype.cleanSavedState = function(savedState) {
        if (!$4SZpN.isSerializableHash(this._inner)) throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
        this._inner.cleanSavedState(savedState);
    };
    return HMAC;
}();
module.exports.HMAC = $82e8a439e372e3be$var$HMAC;
/**
 * Returns HMAC using the given hash constructor for the key over data.
 */ function $82e8a439e372e3be$var$hmac(hash, key, data) {
    var h = new $82e8a439e372e3be$var$HMAC(hash, key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.hmac = $82e8a439e372e3be$var$hmac;
/**
 * Returns true if two HMAC digests are equal.
 * Uses constant-time comparison to avoid leaking timing information.
 *
 * Example:
 *
 *    const receivedDigest = ...
 *    const realDigest = hmac(SHA256, key, data);
 *    if (!equal(receivedDigest, realDigest)) {
 *        throw new Error("Authentication error");
 *    }
 */ module.exports.equal = $cPPqL.equal;

});
parcelRegister("4SZpN", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $38ebd85699c65faa$var$isSerializableHash(h) {
    return typeof h.saveState !== "undefined" && typeof h.restoreState !== "undefined" && typeof h.cleanSavedState !== "undefined";
}
module.exports.isSerializableHash = $38ebd85699c65faa$var$isSerializableHash; // TODO(dchest): figure out the standardized interface for XOF such as
 // SHAKE and BLAKE2X.

});



parcelRegister("6CzCo", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomStringForEntropy = module.exports.randomString = module.exports.randomUint32 = module.exports.randomBytes = module.exports.defaultRandomSource = void 0;

var $eMCOd = parcelRequire("eMCOd");

var $D8NP9 = parcelRequire("D8NP9");

var $4PQ6C = parcelRequire("4PQ6C");
module.exports.defaultRandomSource = new $eMCOd.SystemRandomSource();
function $4d21ebb4ccc2df19$var$randomBytes(length, prng = module.exports.defaultRandomSource) {
    return prng.randomBytes(length);
}
module.exports.randomBytes = $4d21ebb4ccc2df19$var$randomBytes;
/**
 * Returns a uniformly random unsigned 32-bit integer.
 */ function $4d21ebb4ccc2df19$var$randomUint32(prng = module.exports.defaultRandomSource) {
    // Generate 4-byte random buffer.
    const buf = $4d21ebb4ccc2df19$var$randomBytes(4, prng);
    // Convert bytes from buffer into a 32-bit integer.
    // It's not important which byte order to use, since
    // the result is random.
    const result = (0, $D8NP9.readUint32LE)(buf);
    // Clean the buffer.
    (0, $4PQ6C.wipe)(buf);
    return result;
}
module.exports.randomUint32 = $4d21ebb4ccc2df19$var$randomUint32;
/** 62 alphanumeric characters for default charset of randomString() */ const $4d21ebb4ccc2df19$var$ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
/**
 * Returns a uniform random string of the given length
 * with characters from the given charset.
 *
 * Charset must not have more than 256 characters.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $4d21ebb4ccc2df19$var$randomString(length, charset = $4d21ebb4ccc2df19$var$ALPHANUMERIC, prng = module.exports.defaultRandomSource) {
    if (charset.length < 2) throw new Error("randomString charset is too short");
    if (charset.length > 256) throw new Error("randomString charset is too long");
    let out = "";
    const charsLen = charset.length;
    const maxByte = 256 - 256 % charsLen;
    while(length > 0){
        const buf = $4d21ebb4ccc2df19$var$randomBytes(Math.ceil(length * 256 / maxByte), prng);
        for(let i = 0; i < buf.length && length > 0; i++){
            const randomByte = buf[i];
            if (randomByte < maxByte) {
                out += charset.charAt(randomByte % charsLen);
                length--;
            }
        }
        (0, $4PQ6C.wipe)(buf);
    }
    return out;
}
module.exports.randomString = $4d21ebb4ccc2df19$var$randomString;
/**
 * Returns uniform random string containing at least the given
 * number of bits of entropy.
 *
 * For example, randomStringForEntropy(128) will return a 22-character
 * alphanumeric string, while randomStringForEntropy(128, "0123456789")
 * will return a 39-character numeric string, both will contain at
 * least 128 bits of entropy.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $4d21ebb4ccc2df19$var$randomStringForEntropy(bits, charset = $4d21ebb4ccc2df19$var$ALPHANUMERIC, prng = module.exports.defaultRandomSource) {
    const length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
    return $4d21ebb4ccc2df19$var$randomString(length, charset, prng);
}
module.exports.randomStringForEntropy = $4d21ebb4ccc2df19$var$randomStringForEntropy;

});
parcelRegister("eMCOd", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SystemRandomSource = void 0;

var $bXEYU = parcelRequire("bXEYU");

var $7b3ks = parcelRequire("7b3ks");
class $ac33a7098b3b5cff$var$SystemRandomSource {
    constructor(){
        this.isAvailable = false;
        this.name = "";
        // Try browser.
        this._source = new $bXEYU.BrowserRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Browser";
            return;
        }
        // If no browser source, try Node.
        this._source = new $7b3ks.NodeRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Node";
            return;
        }
    // No sources, we're out of options.
    }
    randomBytes(length) {
        if (!this.isAvailable) throw new Error("System random byte generator is not available.");
        return this._source.randomBytes(length);
    }
}
module.exports.SystemRandomSource = $ac33a7098b3b5cff$var$SystemRandomSource;

});
parcelRegister("bXEYU", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserRandomSource = void 0;
const $8b54fe78ff5ed362$var$QUOTA = 65536;
class $8b54fe78ff5ed362$var$BrowserRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        const browserCrypto = typeof self !== "undefined" ? self.crypto || self.msCrypto // IE11 has msCrypto
         : null;
        if (browserCrypto && browserCrypto.getRandomValues !== undefined) {
            this._crypto = browserCrypto;
            this.isAvailable = true;
            this.isInstantiated = true;
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Browser random byte generator is not available.");
        const out = new Uint8Array(length);
        for(let i = 0; i < out.length; i += $8b54fe78ff5ed362$var$QUOTA)this._crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, $8b54fe78ff5ed362$var$QUOTA)));
        return out;
    }
}
module.exports.BrowserRandomSource = $8b54fe78ff5ed362$var$BrowserRandomSource;

});

parcelRegister("7b3ks", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeRandomSource = void 0;

var $4PQ6C = parcelRequire("4PQ6C");

class $539c2490c7c95ec1$var$NodeRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        {
            const nodeCrypto = (parcelRequire("gJoSY"));
            if (nodeCrypto && nodeCrypto.randomBytes) {
                this._crypto = nodeCrypto;
                this.isAvailable = true;
                this.isInstantiated = true;
            }
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Node.js random byte generator is not available.");
        // Get random bytes (result is Buffer).
        let buffer = this._crypto.randomBytes(length);
        // Make sure we got the length that we requested.
        if (buffer.length !== length) throw new Error("NodeRandomSource: got fewer bytes than requested");
        // Allocate output array.
        const out = new Uint8Array(length);
        // Copy bytes from buffer to output.
        for(let i = 0; i < out.length; i++)out[i] = buffer[i];
        // Cleanup.
        (0, $4PQ6C.wipe)(buffer);
        return out;
    }
}
module.exports.NodeRandomSource = $539c2490c7c95ec1$var$NodeRandomSource;

});
parcelRegister("gJoSY", function(module, exports) {
"use strict";

});




parcelRegister("fhdxA", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $D8NP9 = parcelRequire("D8NP9");

var $4PQ6C = parcelRequire("4PQ6C");
module.exports.DIGEST_LENGTH = 32;
module.exports.BLOCK_SIZE = 64;
/**
 * SHA2-256 cryptographic hash algorithm.
 */ var $02dec1d89a7758e6$var$SHA256 = /** @class */ function() {
    function SHA256() {
        /** Length of hash output */ this.digestLength = module.exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = module.exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._state = new Int32Array(8); // hash state
        this._temp = new Int32Array(64); // temporary state
        this._buffer = new Uint8Array(128); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA256.prototype._initState = function() {
        this._state[0] = 0x6a09e667;
        this._state[1] = 0xbb67ae85;
        this._state[2] = 0x3c6ef372;
        this._state[3] = 0xa54ff53a;
        this._state[4] = 0x510e527f;
        this._state[5] = 0x9b05688c;
        this._state[6] = 0x1f83d9ab;
        this._state[7] = 0x5be0cd19;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA256.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA256.prototype.clean = function() {
        $4PQ6C.wipe(this._buffer);
        $4PQ6C.wipe(this._temp);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA256.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA256: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < this.blockSize && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $02dec1d89a7758e6$var$hashBlocks(this._temp, this._state, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $02dec1d89a7758e6$var$hashBlocks(this._temp, this._state, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA256.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 64 < 56 ? 64 : 128;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $D8NP9.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $D8NP9.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $02dec1d89a7758e6$var$hashBlocks(this._temp, this._state, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 4; i++)$D8NP9.writeUint32BE(this._state[i], out, i * 4);
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA256.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Returns hash state to be used with restoreState().
     * Only chain value is saved, not buffers or other
     * state variables.
     */ SHA256.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            state: new Int32Array(this._state),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Restores state saved by saveState() and sets bytesHashed
     * to the given value.
     */ SHA256.prototype.restoreState = function(savedState) {
        this._state.set(savedState.state);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA256.prototype.cleanSavedState = function(savedState) {
        $4PQ6C.wipe(savedState.state);
        if (savedState.buffer) $4PQ6C.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA256;
}();
module.exports.SHA256 = $02dec1d89a7758e6$var$SHA256;
// Constants
var $02dec1d89a7758e6$var$K = new Int32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
function $02dec1d89a7758e6$var$hashBlocks(w, v, p, pos, len) {
    while(len >= 64){
        var a = v[0];
        var b = v[1];
        var c = v[2];
        var d = v[3];
        var e = v[4];
        var f = v[5];
        var g = v[6];
        var h = v[7];
        for(var i = 0; i < 16; i++){
            var j = pos + i * 4;
            w[i] = $D8NP9.readUint32BE(p, j);
        }
        for(var i = 16; i < 64; i++){
            var u = w[i - 2];
            var t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
            u = w[i - 15];
            var t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
            w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
        }
        for(var i = 0; i < 64; i++){
            var t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + ($02dec1d89a7758e6$var$K[i] + w[i] | 0) | 0) | 0;
            var t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
            h = g;
            g = f;
            f = e;
            e = d + t1 | 0;
            d = c;
            c = b;
            b = a;
            a = t1 + t2 | 0;
        }
        v[0] += a;
        v[1] += b;
        v[2] += c;
        v[3] += d;
        v[4] += e;
        v[5] += f;
        v[6] += g;
        v[7] += h;
        pos += 64;
        len -= 64;
    }
    return pos;
}
function $02dec1d89a7758e6$var$hash(data) {
    var h = new $02dec1d89a7758e6$var$SHA256();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.hash = $02dec1d89a7758e6$var$hash;

});

parcelRegister("5qHj8", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sharedKey = module.exports.generateKeyPair = module.exports.generateKeyPairFromSeed = module.exports.scalarMultBase = module.exports.scalarMult = module.exports.SHARED_KEY_LENGTH = module.exports.SECRET_KEY_LENGTH = module.exports.PUBLIC_KEY_LENGTH = void 0;

var $6CzCo = parcelRequire("6CzCo");

var $4PQ6C = parcelRequire("4PQ6C");
module.exports.PUBLIC_KEY_LENGTH = 32;
module.exports.SECRET_KEY_LENGTH = 32;
module.exports.SHARED_KEY_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $3f40f978c7c2ee94$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $3f40f978c7c2ee94$var$_9 = new Uint8Array(32);
$3f40f978c7c2ee94$var$_9[0] = 9;
const $3f40f978c7c2ee94$var$_121665 = $3f40f978c7c2ee94$var$gf([
    0xdb41,
    1
]);
function $3f40f978c7c2ee94$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $3f40f978c7c2ee94$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $3f40f978c7c2ee94$var$pack25519(o, n) {
    const m = $3f40f978c7c2ee94$var$gf();
    const t = $3f40f978c7c2ee94$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $3f40f978c7c2ee94$var$car25519(t);
    $3f40f978c7c2ee94$var$car25519(t);
    $3f40f978c7c2ee94$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $3f40f978c7c2ee94$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $3f40f978c7c2ee94$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $3f40f978c7c2ee94$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $3f40f978c7c2ee94$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $3f40f978c7c2ee94$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $3f40f978c7c2ee94$var$square(o, a) {
    $3f40f978c7c2ee94$var$mul(o, a, a);
}
function $3f40f978c7c2ee94$var$inv25519(o, inp) {
    const c = $3f40f978c7c2ee94$var$gf();
    for(let i = 0; i < 16; i++)c[i] = inp[i];
    for(let i = 253; i >= 0; i--){
        $3f40f978c7c2ee94$var$square(c, c);
        if (i !== 2 && i !== 4) $3f40f978c7c2ee94$var$mul(c, c, inp);
    }
    for(let i = 0; i < 16; i++)o[i] = c[i];
}
function $3f40f978c7c2ee94$var$scalarMult(n, p) {
    const z = new Uint8Array(32);
    const x = new Float64Array(80);
    const a = $3f40f978c7c2ee94$var$gf(), b = $3f40f978c7c2ee94$var$gf(), c = $3f40f978c7c2ee94$var$gf(), d = $3f40f978c7c2ee94$var$gf(), e = $3f40f978c7c2ee94$var$gf(), f = $3f40f978c7c2ee94$var$gf();
    for(let i = 0; i < 31; i++)z[i] = n[i];
    z[31] = n[31] & 127 | 64;
    z[0] &= 248;
    $3f40f978c7c2ee94$var$unpack25519(x, p);
    for(let i = 0; i < 16; i++)b[i] = x[i];
    a[0] = d[0] = 1;
    for(let i = 254; i >= 0; --i){
        const r = z[i >>> 3] >>> (i & 7) & 1;
        $3f40f978c7c2ee94$var$sel25519(a, b, r);
        $3f40f978c7c2ee94$var$sel25519(c, d, r);
        $3f40f978c7c2ee94$var$add(e, a, c);
        $3f40f978c7c2ee94$var$sub(a, a, c);
        $3f40f978c7c2ee94$var$add(c, b, d);
        $3f40f978c7c2ee94$var$sub(b, b, d);
        $3f40f978c7c2ee94$var$square(d, e);
        $3f40f978c7c2ee94$var$square(f, a);
        $3f40f978c7c2ee94$var$mul(a, c, a);
        $3f40f978c7c2ee94$var$mul(c, b, e);
        $3f40f978c7c2ee94$var$add(e, a, c);
        $3f40f978c7c2ee94$var$sub(a, a, c);
        $3f40f978c7c2ee94$var$square(b, a);
        $3f40f978c7c2ee94$var$sub(c, d, f);
        $3f40f978c7c2ee94$var$mul(a, c, $3f40f978c7c2ee94$var$_121665);
        $3f40f978c7c2ee94$var$add(a, a, d);
        $3f40f978c7c2ee94$var$mul(c, c, a);
        $3f40f978c7c2ee94$var$mul(a, d, f);
        $3f40f978c7c2ee94$var$mul(d, b, x);
        $3f40f978c7c2ee94$var$square(b, e);
        $3f40f978c7c2ee94$var$sel25519(a, b, r);
        $3f40f978c7c2ee94$var$sel25519(c, d, r);
    }
    for(let i = 0; i < 16; i++){
        x[i + 16] = a[i];
        x[i + 32] = c[i];
        x[i + 48] = b[i];
        x[i + 64] = d[i];
    }
    const x32 = x.subarray(32);
    const x16 = x.subarray(16);
    $3f40f978c7c2ee94$var$inv25519(x32, x32);
    $3f40f978c7c2ee94$var$mul(x16, x16, x32);
    const q = new Uint8Array(32);
    $3f40f978c7c2ee94$var$pack25519(q, x16);
    return q;
}
module.exports.scalarMult = $3f40f978c7c2ee94$var$scalarMult;
function $3f40f978c7c2ee94$var$scalarMultBase(n) {
    return $3f40f978c7c2ee94$var$scalarMult(n, $3f40f978c7c2ee94$var$_9);
}
module.exports.scalarMultBase = $3f40f978c7c2ee94$var$scalarMultBase;
function $3f40f978c7c2ee94$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== module.exports.SECRET_KEY_LENGTH) throw new Error(`x25519: seed must be ${module.exports.SECRET_KEY_LENGTH} bytes`);
    const secretKey = new Uint8Array(seed);
    const publicKey = $3f40f978c7c2ee94$var$scalarMultBase(secretKey);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
module.exports.generateKeyPairFromSeed = $3f40f978c7c2ee94$var$generateKeyPairFromSeed;
function $3f40f978c7c2ee94$var$generateKeyPair(prng) {
    const seed = (0, $6CzCo.randomBytes)(32, prng);
    const result = $3f40f978c7c2ee94$var$generateKeyPairFromSeed(seed);
    (0, $4PQ6C.wipe)(seed);
    return result;
}
module.exports.generateKeyPair = $3f40f978c7c2ee94$var$generateKeyPair;
/**
 * Returns a shared key between our secret key and a peer's public key.
 *
 * Throws an error if the given keys are of wrong length.
 *
 * If rejectZero is true throws if the calculated shared key is all-zero.
 * From RFC 7748:
 *
 * > Protocol designers using Diffie-Hellman over the curves defined in
 * > this document must not assume "contributory behavior".  Specially,
 * > contributory behavior means that both parties' private keys
 * > contribute to the resulting shared key.  Since curve25519 and
 * > curve448 have cofactors of 8 and 4 (respectively), an input point of
 * > small order will eliminate any contribution from the other party's
 * > private key.  This situation can be detected by checking for the all-
 * > zero output, which implementations MAY do, as specified in Section 6.
 * > However, a large number of existing implementations do not do this.
 *
 * IMPORTANT: the returned key is a raw result of scalar multiplication.
 * To use it as a key material, hash it with a cryptographic hash function.
 */ function $3f40f978c7c2ee94$var$sharedKey(mySecretKey, theirPublicKey, rejectZero = false) {
    if (mySecretKey.length !== module.exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect secret key length");
    if (theirPublicKey.length !== module.exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect public key length");
    const result = $3f40f978c7c2ee94$var$scalarMult(mySecretKey, theirPublicKey);
    if (rejectZero) {
        let zeros = 0;
        for(let i = 0; i < result.length; i++)zeros |= result[i];
        if (zeros === 0) throw new Error("X25519: invalid shared key");
    }
    return result;
}
module.exports.sharedKey = $3f40f978c7c2ee94$var$sharedKey;

});

parcelRegister("4hI5Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bk5R3 = parcelRequire("bk5R3");

var $3xBSp = parcelRequire("3xBSp");

var $dCz5B = parcelRequire("dCz5B");

var $gCvPX = parcelRequire("gCvPX");

var $3Q6TL = parcelRequire("3Q6TL");

var $laeIY = parcelRequire("laeIY");
module.exports.compare = $bk5R3.compare;
module.exports.concat = $3xBSp.concat;
module.exports.equals = $dCz5B.equals;
module.exports.fromString = $gCvPX.fromString;
module.exports.toString = $3Q6TL.toString;
module.exports.xor = $laeIY.xor;

});
parcelRegister("bk5R3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $83e61a9a660aacbb$var$compare(a, b) {
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] < b[i]) return -1;
        if (a[i] > b[i]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}
module.exports.compare = $83e61a9a660aacbb$var$compare;

});

parcelRegister("3xBSp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dtatA = parcelRequire("dtatA");

var $eSzfq = parcelRequire("eSzfq");
function $2941d5a356936d3b$var$concat(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = $dtatA.allocUnsafe(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return $eSzfq.asUint8Array(output);
}
module.exports.concat = $2941d5a356936d3b$var$concat;

});
parcelRegister("dtatA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eSzfq = parcelRequire("eSzfq");
function $9ce61c241dd59445$var$alloc(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.alloc != null) return $eSzfq.asUint8Array(globalThis.Buffer.alloc(size));
    return new Uint8Array(size);
}
function $9ce61c241dd59445$var$allocUnsafe(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) return $eSzfq.asUint8Array(globalThis.Buffer.allocUnsafe(size));
    return new Uint8Array(size);
}
module.exports.alloc = $9ce61c241dd59445$var$alloc;
module.exports.allocUnsafe = $9ce61c241dd59445$var$allocUnsafe;

});
parcelRegister("eSzfq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $ad51735080240d8d$var$asUint8Array(buf) {
    if (globalThis.Buffer != null) return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    return buf;
}
module.exports.asUint8Array = $ad51735080240d8d$var$asUint8Array;

});



parcelRegister("dCz5B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $9eaa0b01b54d9afa$var$equals(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.equals = $9eaa0b01b54d9afa$var$equals;

});

parcelRegister("gCvPX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1Ycjr = parcelRequire("1Ycjr");

var $eSzfq = parcelRequire("eSzfq");
function $c198e420800c7da5$var$fromString(string, encoding = "utf8") {
    const base = $1Ycjr[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return $eSzfq.asUint8Array(globalThis.Buffer.from(string, "utf-8"));
    return base.decoder.decode(`${base.prefix}${string}`);
}
module.exports.fromString = $c198e420800c7da5$var$fromString;

});
parcelRegister("1Ycjr", function(module, exports) {
"use strict";

var $1JO5m = parcelRequire("1JO5m");

var $dtatA = parcelRequire("dtatA");
function $16f4f211372bd865$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
const $16f4f211372bd865$var$string = $16f4f211372bd865$var$createCodec("utf8", "u", (buf)=>{
    const decoder = new TextDecoder("utf8");
    return "u" + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const $16f4f211372bd865$var$ascii = $16f4f211372bd865$var$createCodec("ascii", "a", (buf)=>{
    let string = "a";
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = $dtatA.allocUnsafe(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
const $16f4f211372bd865$var$BASES = {
    utf8: $16f4f211372bd865$var$string,
    "utf-8": $16f4f211372bd865$var$string,
    hex: $1JO5m.bases.base16,
    latin1: $16f4f211372bd865$var$ascii,
    ascii: $16f4f211372bd865$var$ascii,
    binary: $16f4f211372bd865$var$ascii,
    ...$1JO5m.bases
};
module.exports = $16f4f211372bd865$var$BASES;

});
parcelRegister("1JO5m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7n06G = parcelRequire("7n06G");

var $8Lmap = parcelRequire("8Lmap");

var $klsIn = parcelRequire("klsIn");

var $6UJtY = parcelRequire("6UJtY");

var $cE4YZ = parcelRequire("cE4YZ");

var $4bZaa = parcelRequire("4bZaa");

var $4pyF4 = parcelRequire("4pyF4");

var $aEZxI = parcelRequire("aEZxI");

var $6nwwD = parcelRequire("6nwwD");

var $3E4xl = parcelRequire("3E4xl");

var $6agnT = parcelRequire("6agnT");

var $kIhg8 = parcelRequire("kIhg8");

var $2DcJZ = parcelRequire("2DcJZ");

var $f4LlI = parcelRequire("f4LlI");
parcelRequire("2AR97");

var $jTlrF = parcelRequire("jTlrF");

var $53w5E = parcelRequire("53w5E");

var $g0nQn = parcelRequire("g0nQn");

var $gLcj3 = parcelRequire("gLcj3");

var $7od6w = parcelRequire("7od6w");
const $1440d85ce24bccad$var$bases = {
    ...$7n06G,
    ...$8Lmap,
    ...$klsIn,
    ...$6UJtY,
    ...$cE4YZ,
    ...$4bZaa,
    ...$4pyF4,
    ...$aEZxI,
    ...$6nwwD,
    ...$3E4xl
};
const $1440d85ce24bccad$var$hashes = {
    ...$6agnT,
    ...$kIhg8
};
const $1440d85ce24bccad$var$codecs = {
    raw: $2DcJZ,
    json: $f4LlI
};
module.exports.CID = $jTlrF.CID;
module.exports.hasher = $53w5E;
module.exports.digest = $g0nQn;
module.exports.varint = $gLcj3;
module.exports.bytes = $7od6w;
module.exports.bases = $1440d85ce24bccad$var$bases;
module.exports.codecs = $1440d85ce24bccad$var$codecs;
module.exports.hashes = $1440d85ce24bccad$var$hashes;

});
parcelRegister("7n06G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hoSkN = parcelRequire("hoSkN");

var $7od6w = parcelRequire("7od6w");
const $55dac39a5090aaee$var$identity = $hoSkN.from({
    prefix: "\x00",
    name: "identity",
    encode: (buf)=>$7od6w.toString(buf),
    decode: (str)=>$7od6w.fromString(str)
});
module.exports.identity = $55dac39a5090aaee$var$identity;

});
parcelRegister("hoSkN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $22WwP = parcelRequire("22WwP");

var $7od6w = parcelRequire("7od6w");
class $caaed341b23868d9$var$Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error("Unknown type, must be binary type");
    }
}
class $caaed341b23868d9$var$Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error("Invalid prefix character");
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === "string") {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(decoder) {
        return $caaed341b23868d9$var$or(this, decoder);
    }
}
class $caaed341b23868d9$var$ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return $caaed341b23868d9$var$or(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $caaed341b23868d9$var$or = (left, right)=>new $caaed341b23868d9$var$ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class $caaed341b23868d9$var$Codec {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new $caaed341b23868d9$var$Encoder(name, prefix, baseEncode);
        this.decoder = new $caaed341b23868d9$var$Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const $caaed341b23868d9$var$from = ({ name: name, prefix: prefix, encode: encode, decode: decode })=>new $caaed341b23868d9$var$Codec(name, prefix, encode, decode);
const $caaed341b23868d9$var$baseX = ({ prefix: prefix, name: name, alphabet: alphabet })=>{
    const { encode: encode, decode: decode } = $22WwP(alphabet, name);
    return $caaed341b23868d9$var$from({
        prefix: prefix,
        name: name,
        encode: encode,
        decode: (text)=>$7od6w.coerce(decode(text))
    });
};
const $caaed341b23868d9$var$decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === "=")--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError("Unexpected end of data");
    return out;
};
const $caaed341b23868d9$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === "=";
    const mask = (1 << bitsPerChar) - 1;
    let out = "";
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += "=";
    return out;
};
const $caaed341b23868d9$var$rfc4648 = ({ name: name, prefix: prefix, bitsPerChar: bitsPerChar, alphabet: alphabet })=>{
    return $caaed341b23868d9$var$from({
        prefix: prefix,
        name: name,
        encode (input) {
            return $caaed341b23868d9$var$encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return $caaed341b23868d9$var$decode(input, alphabet, bitsPerChar, name);
        }
    });
};
module.exports.Codec = $caaed341b23868d9$var$Codec;
module.exports.baseX = $caaed341b23868d9$var$baseX;
module.exports.from = $caaed341b23868d9$var$from;
module.exports.or = $caaed341b23868d9$var$or;
module.exports.rfc4648 = $caaed341b23868d9$var$rfc4648;

});
parcelRegister("22WwP", function(module, exports) {
"use strict";
function $17d92b316f1d2f8c$var$base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === " ") return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        if (source[psz] === " ") return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $17d92b316f1d2f8c$var$src = $17d92b316f1d2f8c$var$base;
var $17d92b316f1d2f8c$var$_brrp__multiformats_scope_baseX = $17d92b316f1d2f8c$var$src;
module.exports = $17d92b316f1d2f8c$var$_brrp__multiformats_scope_baseX;

});

parcelRegister("7od6w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $5614f086d5ca6343$var$empty = new Uint8Array(0);
const $5614f086d5ca6343$var$toHex = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, "0"), "");
const $5614f086d5ca6343$var$fromHex = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : $5614f086d5ca6343$var$empty;
};
const $5614f086d5ca6343$var$equals = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const $5614f086d5ca6343$var$coerce = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
};
const $5614f086d5ca6343$var$isBinary = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const $5614f086d5ca6343$var$fromString = (str)=>new TextEncoder().encode(str);
const $5614f086d5ca6343$var$toString = (b)=>new TextDecoder().decode(b);
module.exports.coerce = $5614f086d5ca6343$var$coerce;
module.exports.empty = $5614f086d5ca6343$var$empty;
module.exports.equals = $5614f086d5ca6343$var$equals;
module.exports.fromHex = $5614f086d5ca6343$var$fromHex;
module.exports.fromString = $5614f086d5ca6343$var$fromString;
module.exports.isBinary = $5614f086d5ca6343$var$isBinary;
module.exports.toHex = $5614f086d5ca6343$var$toHex;
module.exports.toString = $5614f086d5ca6343$var$toString;

});



parcelRegister("8Lmap", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hoSkN = parcelRequire("hoSkN");
const $6613e865b9415e39$var$base2 = $hoSkN.rfc4648({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
module.exports.base2 = $6613e865b9415e39$var$base2;

});

parcelRegister("klsIn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hoSkN = parcelRequire("hoSkN");
const $ecfc0af2af790f7d$var$base8 = $hoSkN.rfc4648({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
module.exports.base8 = $ecfc0af2af790f7d$var$base8;

});

parcelRegister("6UJtY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hoSkN = parcelRequire("hoSkN");
const $508b40e35dfad955$var$base10 = $hoSkN.baseX({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
module.exports.base10 = $508b40e35dfad955$var$base10;

});

parcelRegister("cE4YZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hoSkN = parcelRequire("hoSkN");
const $934d15f10503941e$var$base16 = $hoSkN.rfc4648({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
});
const $934d15f10503941e$var$base16upper = $hoSkN.rfc4648({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
module.exports.base16 = $934d15f10503941e$var$base16;
module.exports.base16upper = $934d15f10503941e$var$base16upper;

});

parcelRegister("4bZaa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hoSkN = parcelRequire("hoSkN");
const $30d7a232b1f7b202$var$base32 = $hoSkN.rfc4648({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
});
const $30d7a232b1f7b202$var$base32upper = $hoSkN.rfc4648({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
});
const $30d7a232b1f7b202$var$base32pad = $hoSkN.rfc4648({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
});
const $30d7a232b1f7b202$var$base32padupper = $hoSkN.rfc4648({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
});
const $30d7a232b1f7b202$var$base32hex = $hoSkN.rfc4648({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
});
const $30d7a232b1f7b202$var$base32hexupper = $hoSkN.rfc4648({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
});
const $30d7a232b1f7b202$var$base32hexpad = $hoSkN.rfc4648({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
});
const $30d7a232b1f7b202$var$base32hexpadupper = $hoSkN.rfc4648({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
});
const $30d7a232b1f7b202$var$base32z = $hoSkN.rfc4648({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
module.exports.base32 = $30d7a232b1f7b202$var$base32;
module.exports.base32hex = $30d7a232b1f7b202$var$base32hex;
module.exports.base32hexpad = $30d7a232b1f7b202$var$base32hexpad;
module.exports.base32hexpadupper = $30d7a232b1f7b202$var$base32hexpadupper;
module.exports.base32hexupper = $30d7a232b1f7b202$var$base32hexupper;
module.exports.base32pad = $30d7a232b1f7b202$var$base32pad;
module.exports.base32padupper = $30d7a232b1f7b202$var$base32padupper;
module.exports.base32upper = $30d7a232b1f7b202$var$base32upper;
module.exports.base32z = $30d7a232b1f7b202$var$base32z;

});

parcelRegister("4pyF4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hoSkN = parcelRequire("hoSkN");
const $3364623ff8b9064b$var$base36 = $hoSkN.baseX({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
});
const $3364623ff8b9064b$var$base36upper = $hoSkN.baseX({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
module.exports.base36 = $3364623ff8b9064b$var$base36;
module.exports.base36upper = $3364623ff8b9064b$var$base36upper;

});

parcelRegister("aEZxI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hoSkN = parcelRequire("hoSkN");
const $7c2d60ef0bef017c$var$base58btc = $hoSkN.baseX({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
});
const $7c2d60ef0bef017c$var$base58flickr = $hoSkN.baseX({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
module.exports.base58btc = $7c2d60ef0bef017c$var$base58btc;
module.exports.base58flickr = $7c2d60ef0bef017c$var$base58flickr;

});

parcelRegister("6nwwD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hoSkN = parcelRequire("hoSkN");
const $4a4e1ef1d8c1d6b1$var$base64 = $hoSkN.rfc4648({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
});
const $4a4e1ef1d8c1d6b1$var$base64pad = $hoSkN.rfc4648({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
});
const $4a4e1ef1d8c1d6b1$var$base64url = $hoSkN.rfc4648({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
});
const $4a4e1ef1d8c1d6b1$var$base64urlpad = $hoSkN.rfc4648({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
module.exports.base64 = $4a4e1ef1d8c1d6b1$var$base64;
module.exports.base64pad = $4a4e1ef1d8c1d6b1$var$base64pad;
module.exports.base64url = $4a4e1ef1d8c1d6b1$var$base64url;
module.exports.base64urlpad = $4a4e1ef1d8c1d6b1$var$base64urlpad;

});

parcelRegister("3E4xl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hoSkN = parcelRequire("hoSkN");
const $2a78a06ff0229f53$var$alphabet = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42");
const $2a78a06ff0229f53$var$alphabetBytesToChars = $2a78a06ff0229f53$var$alphabet.reduce((p, c, i)=>{
    p[i] = c;
    return p;
}, []);
const $2a78a06ff0229f53$var$alphabetCharsToBytes = $2a78a06ff0229f53$var$alphabet.reduce((p, c, i)=>{
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function $2a78a06ff0229f53$var$encode(data) {
    return data.reduce((p, c)=>{
        p += $2a78a06ff0229f53$var$alphabetBytesToChars[c];
        return p;
    }, "");
}
function $2a78a06ff0229f53$var$decode(str) {
    const byts = [];
    for (const char of str){
        const byt = $2a78a06ff0229f53$var$alphabetCharsToBytes[char.codePointAt(0)];
        if (byt === undefined) throw new Error(`Non-base256emoji character: ${char}`);
        byts.push(byt);
    }
    return new Uint8Array(byts);
}
const $2a78a06ff0229f53$var$base256emoji = $hoSkN.from({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $2a78a06ff0229f53$var$encode,
    decode: $2a78a06ff0229f53$var$decode
});
module.exports.base256emoji = $2a78a06ff0229f53$var$base256emoji;

});

parcelRegister("6agnT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $53w5E = parcelRequire("53w5E");
const $47d062d22585b848$var$sha = (name)=>async (data)=>new Uint8Array(await crypto.subtle.digest(name, data));
const $47d062d22585b848$var$sha256 = $53w5E.from({
    name: "sha2-256",
    code: 18,
    encode: $47d062d22585b848$var$sha("SHA-256")
});
const $47d062d22585b848$var$sha512 = $53w5E.from({
    name: "sha2-512",
    code: 19,
    encode: $47d062d22585b848$var$sha("SHA-512")
});
module.exports.sha256 = $47d062d22585b848$var$sha256;
module.exports.sha512 = $47d062d22585b848$var$sha512;

});
parcelRegister("53w5E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $g0nQn = parcelRequire("g0nQn");
const $3ae61ffc06785488$var$from = ({ name: name, code: code, encode: encode })=>new $3ae61ffc06785488$var$Hasher(name, code, encode);
class $3ae61ffc06785488$var$Hasher {
    constructor(name, code, encode){
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    digest(input) {
        if (input instanceof Uint8Array) {
            const result = this.encode(input);
            return result instanceof Uint8Array ? $g0nQn.create(this.code, result) : result.then((digest$1)=>$g0nQn.create(this.code, digest$1));
        } else throw Error("Unknown type, must be binary type");
    }
}
module.exports.Hasher = $3ae61ffc06785488$var$Hasher;
module.exports.from = $3ae61ffc06785488$var$from;

});
parcelRegister("g0nQn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7od6w = parcelRequire("7od6w");

var $gLcj3 = parcelRequire("gLcj3");
const $ba6f2448856cdd9d$var$create = (code, digest)=>{
    const size = digest.byteLength;
    const sizeOffset = $gLcj3.encodingLength(code);
    const digestOffset = sizeOffset + $gLcj3.encodingLength(size);
    const bytes = new Uint8Array(digestOffset + size);
    $gLcj3.encodeTo(code, bytes, 0);
    $gLcj3.encodeTo(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new $ba6f2448856cdd9d$var$Digest(code, size, digest, bytes);
};
const $ba6f2448856cdd9d$var$decode = (multihash)=>{
    const bytes$1 = $7od6w.coerce(multihash);
    const [code, sizeOffset] = $gLcj3.decode(bytes$1);
    const [size, digestOffset] = $gLcj3.decode(bytes$1.subarray(sizeOffset));
    const digest = bytes$1.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error("Incorrect length");
    return new $ba6f2448856cdd9d$var$Digest(code, size, digest, bytes$1);
};
const $ba6f2448856cdd9d$var$equals = (a, b)=>{
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && $7od6w.equals(a.bytes, b.bytes);
};
class $ba6f2448856cdd9d$var$Digest {
    constructor(code, size, digest, bytes){
        this.code = code;
        this.size = size;
        this.digest = digest;
        this.bytes = bytes;
    }
}
module.exports.Digest = $ba6f2448856cdd9d$var$Digest;
module.exports.create = $ba6f2448856cdd9d$var$create;
module.exports.decode = $ba6f2448856cdd9d$var$decode;
module.exports.equals = $ba6f2448856cdd9d$var$equals;

});
parcelRegister("gLcj3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $akxFm = parcelRequire("akxFm");
const $c33a94e6c3ef1d75$var$decode = (data, offset = 0)=>{
    const code = $akxFm.decode(data, offset);
    return [
        code,
        $akxFm.decode.bytes
    ];
};
const $c33a94e6c3ef1d75$var$encodeTo = (int, target, offset = 0)=>{
    $akxFm.encode(int, target, offset);
    return target;
};
const $c33a94e6c3ef1d75$var$encodingLength = (int)=>{
    return $akxFm.encodingLength(int);
};
module.exports.decode = $c33a94e6c3ef1d75$var$decode;
module.exports.encodeTo = $c33a94e6c3ef1d75$var$encodeTo;
module.exports.encodingLength = $c33a94e6c3ef1d75$var$encodingLength;

});
parcelRegister("akxFm", function(module, exports) {
"use strict";
var $7855e30a956155de$var$encode_1 = $7855e30a956155de$var$encode;
var $7855e30a956155de$var$MSB = 128, $7855e30a956155de$var$REST = 127, $7855e30a956155de$var$MSBALL = ~$7855e30a956155de$var$REST, $7855e30a956155de$var$INT = Math.pow(2, 31);
function $7855e30a956155de$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $7855e30a956155de$var$INT){
        out[offset++] = num & 255 | $7855e30a956155de$var$MSB;
        num /= 128;
    }
    while(num & $7855e30a956155de$var$MSBALL){
        out[offset++] = num & 255 | $7855e30a956155de$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $7855e30a956155de$var$encode.bytes = offset - oldOffset + 1;
    return out;
}
var $7855e30a956155de$var$decode = $7855e30a956155de$var$read;
var $7855e30a956155de$var$MSB$1 = 128, $7855e30a956155de$var$REST$1 = 127;
function $7855e30a956155de$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $7855e30a956155de$var$read.bytes = 0;
            throw new RangeError("Could not decode varint");
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $7855e30a956155de$var$REST$1) << shift : (b & $7855e30a956155de$var$REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $7855e30a956155de$var$MSB$1);
    $7855e30a956155de$var$read.bytes = counter - offset;
    return res;
}
var $7855e30a956155de$var$N1 = Math.pow(2, 7);
var $7855e30a956155de$var$N2 = Math.pow(2, 14);
var $7855e30a956155de$var$N3 = Math.pow(2, 21);
var $7855e30a956155de$var$N4 = Math.pow(2, 28);
var $7855e30a956155de$var$N5 = Math.pow(2, 35);
var $7855e30a956155de$var$N6 = Math.pow(2, 42);
var $7855e30a956155de$var$N7 = Math.pow(2, 49);
var $7855e30a956155de$var$N8 = Math.pow(2, 56);
var $7855e30a956155de$var$N9 = Math.pow(2, 63);
var $7855e30a956155de$var$length = function(value) {
    return value < $7855e30a956155de$var$N1 ? 1 : value < $7855e30a956155de$var$N2 ? 2 : value < $7855e30a956155de$var$N3 ? 3 : value < $7855e30a956155de$var$N4 ? 4 : value < $7855e30a956155de$var$N5 ? 5 : value < $7855e30a956155de$var$N6 ? 6 : value < $7855e30a956155de$var$N7 ? 7 : value < $7855e30a956155de$var$N8 ? 8 : value < $7855e30a956155de$var$N9 ? 9 : 10;
};
var $7855e30a956155de$var$varint = {
    encode: $7855e30a956155de$var$encode_1,
    decode: $7855e30a956155de$var$decode,
    encodingLength: $7855e30a956155de$var$length
};
var $7855e30a956155de$var$_brrp_varint = $7855e30a956155de$var$varint;
var $7855e30a956155de$var$varint$1 = $7855e30a956155de$var$_brrp_varint;
module.exports = $7855e30a956155de$var$varint$1;

});





parcelRegister("kIhg8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7od6w = parcelRequire("7od6w");

var $g0nQn = parcelRequire("g0nQn");
const $f1454e0277e42f82$var$code = 0;
const $f1454e0277e42f82$var$name = "identity";
const $f1454e0277e42f82$var$encode = $7od6w.coerce;
const $f1454e0277e42f82$var$digest = (input)=>$g0nQn.create($f1454e0277e42f82$var$code, $f1454e0277e42f82$var$encode(input));
const $f1454e0277e42f82$var$identity = {
    code: $f1454e0277e42f82$var$code,
    name: $f1454e0277e42f82$var$name,
    encode: $f1454e0277e42f82$var$encode,
    digest: $f1454e0277e42f82$var$digest
};
module.exports.identity = $f1454e0277e42f82$var$identity;

});

parcelRegister("2DcJZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7od6w = parcelRequire("7od6w");
const $1ea91b591052b447$var$name = "raw";
const $1ea91b591052b447$var$code = 85;
const $1ea91b591052b447$var$encode = (node)=>$7od6w.coerce(node);
const $1ea91b591052b447$var$decode = (data)=>$7od6w.coerce(data);
module.exports.code = $1ea91b591052b447$var$code;
module.exports.decode = $1ea91b591052b447$var$decode;
module.exports.encode = $1ea91b591052b447$var$encode;
module.exports.name = $1ea91b591052b447$var$name;

});

parcelRegister("f4LlI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $af9bf55592c4bbfc$var$textEncoder = new TextEncoder();
const $af9bf55592c4bbfc$var$textDecoder = new TextDecoder();
const $af9bf55592c4bbfc$var$name = "json";
const $af9bf55592c4bbfc$var$code = 512;
const $af9bf55592c4bbfc$var$encode = (node)=>$af9bf55592c4bbfc$var$textEncoder.encode(JSON.stringify(node));
const $af9bf55592c4bbfc$var$decode = (data)=>JSON.parse($af9bf55592c4bbfc$var$textDecoder.decode(data));
module.exports.code = $af9bf55592c4bbfc$var$code;
module.exports.decode = $af9bf55592c4bbfc$var$decode;
module.exports.encode = $af9bf55592c4bbfc$var$encode;
module.exports.name = $af9bf55592c4bbfc$var$name;

});

parcelRegister("2AR97", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jTlrF = parcelRequire("jTlrF");

var $gLcj3 = parcelRequire("gLcj3");

var $7od6w = parcelRequire("7od6w");

var $53w5E = parcelRequire("53w5E");

var $g0nQn = parcelRequire("g0nQn");
module.exports.CID = $jTlrF.CID;
module.exports.varint = $gLcj3;
module.exports.bytes = $7od6w;
module.exports.hasher = $53w5E;
module.exports.digest = $g0nQn;

});
parcelRegister("jTlrF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gLcj3 = parcelRequire("gLcj3");

var $g0nQn = parcelRequire("g0nQn");

var $aEZxI = parcelRequire("aEZxI");

var $4bZaa = parcelRequire("4bZaa");

var $7od6w = parcelRequire("7od6w");
class $e7b3c9f87ec32c53$var$CID {
    constructor(version, code, multihash, bytes){
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: $e7b3c9f87ec32c53$var$hidden,
            byteLength: $e7b3c9f87ec32c53$var$hidden,
            code: $e7b3c9f87ec32c53$var$readonly,
            version: $e7b3c9f87ec32c53$var$readonly,
            multihash: $e7b3c9f87ec32c53$var$readonly,
            bytes: $e7b3c9f87ec32c53$var$readonly,
            _baseCache: $e7b3c9f87ec32c53$var$hidden,
            asCID: $e7b3c9f87ec32c53$var$hidden
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code: code, multihash: multihash } = this;
                    if (code !== $e7b3c9f87ec32c53$var$DAG_PB_CODE) throw new Error("Cannot convert a non dag-pb CID to CIDv0");
                    if (multihash.code !== $e7b3c9f87ec32c53$var$SHA_256_CODE) throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
                    return $e7b3c9f87ec32c53$var$CID.createV0(multihash);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code: code, digest: digest$1 } = this.multihash;
                    const multihash = $g0nQn.create(code, digest$1);
                    return $e7b3c9f87ec32c53$var$CID.createV1(this.code, multihash);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(other) {
        return other && this.code === other.code && this.version === other.version && $g0nQn.equals(this.multihash, other.multihash);
    }
    toString(base) {
        const { bytes: bytes, version: version, _baseCache: _baseCache } = this;
        switch(version){
            case 0:
                return $e7b3c9f87ec32c53$var$toStringV0(bytes, _baseCache, base || $aEZxI.base58btc.encoder);
            default:
                return $e7b3c9f87ec32c53$var$toStringV1(bytes, _baseCache, base || $4bZaa.base32.encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return "CID";
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return "CID(" + this.toString() + ")";
    }
    static isCID(value) {
        $e7b3c9f87ec32c53$var$deprecate(/^0\.0/, $e7b3c9f87ec32c53$var$IS_CID_DEPRECATION);
        return !!(value && (value[$e7b3c9f87ec32c53$var$cidSymbol] || value.asCID === value));
    }
    get toBaseEncodedString() {
        throw new Error("Deprecated, use .toString()");
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error("Deprecated .buffer property, use .bytes to get Uint8Array instead");
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(value) {
        if (value instanceof $e7b3c9f87ec32c53$var$CID) return value;
        else if (value != null && value.asCID === value) {
            const { version: version, code: code, multihash: multihash, bytes: bytes } = value;
            return new $e7b3c9f87ec32c53$var$CID(version, code, multihash, bytes || $e7b3c9f87ec32c53$var$encodeCID(version, code, multihash.bytes));
        } else if (value != null && value[$e7b3c9f87ec32c53$var$cidSymbol] === true) {
            const { version: version, multihash: multihash, code: code } = value;
            const digest$1 = $g0nQn.decode(multihash);
            return $e7b3c9f87ec32c53$var$CID.create(version, code, digest$1);
        } else return null;
    }
    static create(version, code, digest) {
        if (typeof code !== "number") throw new Error("String codecs are no longer supported");
        switch(version){
            case 0:
                if (code !== $e7b3c9f87ec32c53$var$DAG_PB_CODE) throw new Error(`Version 0 CID must use dag-pb (code: ${$e7b3c9f87ec32c53$var$DAG_PB_CODE}) block encoding`);
                else return new $e7b3c9f87ec32c53$var$CID(version, code, digest, digest.bytes);
            case 1:
                {
                    const bytes = $e7b3c9f87ec32c53$var$encodeCID(version, code, digest.bytes);
                    return new $e7b3c9f87ec32c53$var$CID(version, code, digest, bytes);
                }
            default:
                throw new Error("Invalid version");
        }
    }
    static createV0(digest) {
        return $e7b3c9f87ec32c53$var$CID.create(0, $e7b3c9f87ec32c53$var$DAG_PB_CODE, digest);
    }
    static createV1(code, digest) {
        return $e7b3c9f87ec32c53$var$CID.create(1, code, digest);
    }
    static decode(bytes) {
        const [cid, remainder] = $e7b3c9f87ec32c53$var$CID.decodeFirst(bytes);
        if (remainder.length) throw new Error("Incorrect length");
        return cid;
    }
    static decodeFirst(bytes$1) {
        const specs = $e7b3c9f87ec32c53$var$CID.inspectBytes(bytes$1);
        const prefixSize = specs.size - specs.multihashSize;
        const multihashBytes = $7od6w.coerce(bytes$1.subarray(prefixSize, prefixSize + specs.multihashSize));
        if (multihashBytes.byteLength !== specs.multihashSize) throw new Error("Incorrect length");
        const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
        const digest$1 = new $g0nQn.Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
        const cid = specs.version === 0 ? $e7b3c9f87ec32c53$var$CID.createV0(digest$1) : $e7b3c9f87ec32c53$var$CID.createV1(specs.codec, digest$1);
        return [
            cid,
            bytes$1.subarray(specs.size)
        ];
    }
    static inspectBytes(initialBytes) {
        let offset = 0;
        const next = ()=>{
            const [i, length] = $gLcj3.decode(initialBytes.subarray(offset));
            offset += length;
            return i;
        };
        let version = next();
        let codec = $e7b3c9f87ec32c53$var$DAG_PB_CODE;
        if (version === 18) {
            version = 0;
            offset = 0;
        } else if (version === 1) codec = next();
        if (version !== 0 && version !== 1) throw new RangeError(`Invalid CID version ${version}`);
        const prefixSize = offset;
        const multihashCode = next();
        const digestSize = next();
        const size = offset + digestSize;
        const multihashSize = size - prefixSize;
        return {
            version: version,
            codec: codec,
            multihashCode: multihashCode,
            digestSize: digestSize,
            multihashSize: multihashSize,
            size: size
        };
    }
    static parse(source, base) {
        const [prefix, bytes] = $e7b3c9f87ec32c53$var$parseCIDtoBytes(source, base);
        const cid = $e7b3c9f87ec32c53$var$CID.decode(bytes);
        cid._baseCache.set(prefix, source);
        return cid;
    }
}
const $e7b3c9f87ec32c53$var$parseCIDtoBytes = (source, base)=>{
    switch(source[0]){
        case "Q":
            {
                const decoder = base || $aEZxI.base58btc;
                return [
                    $aEZxI.base58btc.prefix,
                    decoder.decode(`${$aEZxI.base58btc.prefix}${source}`)
                ];
            }
        case $aEZxI.base58btc.prefix:
            {
                const decoder = base || $aEZxI.base58btc;
                return [
                    $aEZxI.base58btc.prefix,
                    decoder.decode(source)
                ];
            }
        case $4bZaa.base32.prefix:
            {
                const decoder = base || $4bZaa.base32;
                return [
                    $4bZaa.base32.prefix,
                    decoder.decode(source)
                ];
            }
        default:
            if (base == null) throw Error("To parse non base32 or base58btc encoded CID multibase decoder must be provided");
            return [
                source[0],
                base.decode(source)
            ];
    }
};
const $e7b3c9f87ec32c53$var$toStringV0 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    if (prefix !== $aEZxI.base58btc.prefix) throw Error(`Cannot string encode V0 in ${base.name} encoding`);
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes).slice(1);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $e7b3c9f87ec32c53$var$toStringV1 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $e7b3c9f87ec32c53$var$DAG_PB_CODE = 112;
const $e7b3c9f87ec32c53$var$SHA_256_CODE = 18;
const $e7b3c9f87ec32c53$var$encodeCID = (version, code, multihash)=>{
    const codeOffset = $gLcj3.encodingLength(version);
    const hashOffset = codeOffset + $gLcj3.encodingLength(code);
    const bytes = new Uint8Array(hashOffset + multihash.byteLength);
    $gLcj3.encodeTo(version, bytes, 0);
    $gLcj3.encodeTo(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
const $e7b3c9f87ec32c53$var$cidSymbol = Symbol.for("@ipld/js-cid/CID");
const $e7b3c9f87ec32c53$var$readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
const $e7b3c9f87ec32c53$var$hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
const $e7b3c9f87ec32c53$var$version = "0.0.0-dev";
const $e7b3c9f87ec32c53$var$deprecate = (range, message)=>{
    if (range.test($e7b3c9f87ec32c53$var$version)) console.warn(message);
    else throw new Error(message);
};
const $e7b3c9f87ec32c53$var$IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;
module.exports.CID = $e7b3c9f87ec32c53$var$CID;

});





parcelRegister("3Q6TL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1Ycjr = parcelRequire("1Ycjr");
function $2cbb9455286d4a35$var$toString(array, encoding = "utf8") {
    const base = $1Ycjr[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString("utf8");
    return base.encoder.encode(array).substring(1);
}
module.exports.toString = $2cbb9455286d4a35$var$toString;

});

parcelRegister("laeIY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dtatA = parcelRequire("dtatA");

var $eSzfq = parcelRequire("eSzfq");
function $f685f41b17e863ae$var$xor(a, b) {
    if (a.length !== b.length) throw new Error("Inputs should have the same length");
    const result = $dtatA.allocUnsafe(a.length);
    for(let i = 0; i < a.length; i++)result[i] = a[i] ^ b[i];
    return $eSzfq.asUint8Array(result);
}
module.exports.xor = $f685f41b17e863ae$var$xor;

});


parcelRegister("7gpqF", function(module, exports) {

$parcel$export(module.exports, "detect", function () { return $549dc0b210bf0abb$export$17b446b869dad473; });

var $bNDrn = parcelRequire("bNDrn");
var $549dc0b210bf0abb$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $549dc0b210bf0abb$export$8fa985da04a86f0 = /** @class */ function() {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = "browser";
    }
    return BrowserInfo;
}();
var $549dc0b210bf0abb$export$62457c674e0167c0 = /** @class */ function() {
    function NodeInfo(version) {
        this.version = version;
        this.type = "node";
        this.name = "node";
        this.os = $bNDrn.platform;
    }
    return NodeInfo;
}();
var $549dc0b210bf0abb$export$775de176f06fc21 = /** @class */ function() {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = "bot-device";
    }
    return SearchBotDeviceInfo;
}();
var $549dc0b210bf0abb$export$cb435e1e9f86c1ff = /** @class */ function() {
    function BotInfo() {
        this.type = "bot";
        this.bot = true; // NOTE: deprecated test name instead
        this.name = "bot";
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}();
var $549dc0b210bf0abb$export$7c78fe95a9d9b03e = /** @class */ function() {
    function ReactNativeInfo() {
        this.type = "react-native";
        this.name = "react-native";
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}();
// tslint:disable-next-line:max-line-length
var $549dc0b210bf0abb$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var $549dc0b210bf0abb$var$SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var $549dc0b210bf0abb$var$REQUIRED_VERSION_PARTS = 3;
var $549dc0b210bf0abb$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $549dc0b210bf0abb$var$SEARCHBOX_UA_REGEX
    ]
];
var $549dc0b210bf0abb$var$operatingSystemRules = [
    [
        "iOS",
        /iP(hone|od|ad)/
    ],
    [
        "Android OS",
        /Android/
    ],
    [
        "BlackBerry OS",
        /BlackBerry|BB10/
    ],
    [
        "Windows Mobile",
        /IEMobile/
    ],
    [
        "Amazon OS",
        /Kindle/
    ],
    [
        "Windows 3.11",
        /Win16/
    ],
    [
        "Windows 95",
        /(Windows 95)|(Win95)|(Windows_95)/
    ],
    [
        "Windows 98",
        /(Windows 98)|(Win98)/
    ],
    [
        "Windows 2000",
        /(Windows NT 5.0)|(Windows 2000)/
    ],
    [
        "Windows XP",
        /(Windows NT 5.1)|(Windows XP)/
    ],
    [
        "Windows Server 2003",
        /(Windows NT 5.2)/
    ],
    [
        "Windows Vista",
        /(Windows NT 6.0)/
    ],
    [
        "Windows 7",
        /(Windows NT 6.1)/
    ],
    [
        "Windows 8",
        /(Windows NT 6.2)/
    ],
    [
        "Windows 8.1",
        /(Windows NT 6.3)/
    ],
    [
        "Windows 10",
        /(Windows NT 10.0)/
    ],
    [
        "Windows ME",
        /Windows ME/
    ],
    [
        "Windows CE",
        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
    ],
    [
        "Open BSD",
        /OpenBSD/
    ],
    [
        "Sun OS",
        /SunOS/
    ],
    [
        "Chrome OS",
        /CrOS/
    ],
    [
        "Linux",
        /(Linux)|(X11)/
    ],
    [
        "Mac OS",
        /(Mac_PowerPC)|(Macintosh)/
    ],
    [
        "QNX",
        /QNX/
    ],
    [
        "BeOS",
        /BeOS/
    ],
    [
        "OS/2",
        /OS\/2/
    ]
];
function $549dc0b210bf0abb$export$17b446b869dad473(userAgent) {
    if (!!userAgent) return $549dc0b210bf0abb$export$1184956100eddc3c(userAgent);
    if (typeof document === "undefined" && typeof navigator !== "undefined" && navigator.product === "ReactNative") return new $549dc0b210bf0abb$export$7c78fe95a9d9b03e();
    if (typeof navigator !== "undefined") return $549dc0b210bf0abb$export$1184956100eddc3c(navigator.userAgent);
    return $549dc0b210bf0abb$export$bf2c6630ab904918();
}
function $549dc0b210bf0abb$var$matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return ua !== "" && $549dc0b210bf0abb$var$userAgentRules.reduce(function(matched, _a) {
        var browser = _a[0], regex = _a[1];
        if (matched) return matched;
        var uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
}
function $549dc0b210bf0abb$export$89ca9f8ca1a50fd5(ua) {
    var data = $549dc0b210bf0abb$var$matchUserAgent(ua);
    return data ? data[0] : null;
}
function $549dc0b210bf0abb$export$1184956100eddc3c(ua) {
    var matchedRule = $549dc0b210bf0abb$var$matchUserAgent(ua);
    if (!matchedRule) return null;
    var name = matchedRule[0], match = matchedRule[1];
    if (name === "searchbot") return new $549dc0b210bf0abb$export$cb435e1e9f86c1ff();
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split(".").join("_").split("_").slice(0, 3);
    if (versionParts) {
        if (versionParts.length < $549dc0b210bf0abb$var$REQUIRED_VERSION_PARTS) versionParts = $549dc0b210bf0abb$var$__spreadArray($549dc0b210bf0abb$var$__spreadArray([], versionParts, true), $549dc0b210bf0abb$var$createVersionParts($549dc0b210bf0abb$var$REQUIRED_VERSION_PARTS - versionParts.length), true);
    } else versionParts = [];
    var version = versionParts.join(".");
    var os = $549dc0b210bf0abb$export$3070bd282ec37ea8(ua);
    var searchBotMatch = $549dc0b210bf0abb$var$SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) return new $549dc0b210bf0abb$export$775de176f06fc21(name, version, os, searchBotMatch[1]);
    return new $549dc0b210bf0abb$export$8fa985da04a86f0(name, version, os);
}
function $549dc0b210bf0abb$export$3070bd282ec37ea8(ua) {
    for(var ii = 0, count = $549dc0b210bf0abb$var$operatingSystemRules.length; ii < count; ii++){
        var _a = $549dc0b210bf0abb$var$operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) return os;
    }
    return null;
}
function $549dc0b210bf0abb$export$bf2c6630ab904918() {
    var isNode = typeof $bNDrn !== "undefined" && $bNDrn.version;
    return isNode ? new $549dc0b210bf0abb$export$62457c674e0167c0($bNDrn.version.slice(1)) : null;
}
function $549dc0b210bf0abb$var$createVersionParts(count) {
    var output = [];
    for(var ii = 0; ii < count; ii++)output.push("0");
    return output;
}

});
parcelRegister("bNDrn", function(module, exports) {
// shim for using process in browser
var $8972dd6366fe5fef$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $8972dd6366fe5fef$var$cachedSetTimeout;
var $8972dd6366fe5fef$var$cachedClearTimeout;
function $8972dd6366fe5fef$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $8972dd6366fe5fef$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $8972dd6366fe5fef$var$cachedSetTimeout = setTimeout;
        else $8972dd6366fe5fef$var$cachedSetTimeout = $8972dd6366fe5fef$var$defaultSetTimout;
    } catch (e) {
        $8972dd6366fe5fef$var$cachedSetTimeout = $8972dd6366fe5fef$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $8972dd6366fe5fef$var$cachedClearTimeout = clearTimeout;
        else $8972dd6366fe5fef$var$cachedClearTimeout = $8972dd6366fe5fef$var$defaultClearTimeout;
    } catch (e) {
        $8972dd6366fe5fef$var$cachedClearTimeout = $8972dd6366fe5fef$var$defaultClearTimeout;
    }
})();
function $8972dd6366fe5fef$var$runTimeout(fun) {
    if ($8972dd6366fe5fef$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($8972dd6366fe5fef$var$cachedSetTimeout === $8972dd6366fe5fef$var$defaultSetTimout || !$8972dd6366fe5fef$var$cachedSetTimeout) && setTimeout) {
        $8972dd6366fe5fef$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8972dd6366fe5fef$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $8972dd6366fe5fef$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $8972dd6366fe5fef$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $8972dd6366fe5fef$var$runClearTimeout(marker) {
    if ($8972dd6366fe5fef$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($8972dd6366fe5fef$var$cachedClearTimeout === $8972dd6366fe5fef$var$defaultClearTimeout || !$8972dd6366fe5fef$var$cachedClearTimeout) && clearTimeout) {
        $8972dd6366fe5fef$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8972dd6366fe5fef$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $8972dd6366fe5fef$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $8972dd6366fe5fef$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $8972dd6366fe5fef$var$queue = [];
var $8972dd6366fe5fef$var$draining = false;
var $8972dd6366fe5fef$var$currentQueue;
var $8972dd6366fe5fef$var$queueIndex = -1;
function $8972dd6366fe5fef$var$cleanUpNextTick() {
    if (!$8972dd6366fe5fef$var$draining || !$8972dd6366fe5fef$var$currentQueue) return;
    $8972dd6366fe5fef$var$draining = false;
    if ($8972dd6366fe5fef$var$currentQueue.length) $8972dd6366fe5fef$var$queue = $8972dd6366fe5fef$var$currentQueue.concat($8972dd6366fe5fef$var$queue);
    else $8972dd6366fe5fef$var$queueIndex = -1;
    if ($8972dd6366fe5fef$var$queue.length) $8972dd6366fe5fef$var$drainQueue();
}
function $8972dd6366fe5fef$var$drainQueue() {
    if ($8972dd6366fe5fef$var$draining) return;
    var timeout = $8972dd6366fe5fef$var$runTimeout($8972dd6366fe5fef$var$cleanUpNextTick);
    $8972dd6366fe5fef$var$draining = true;
    var len = $8972dd6366fe5fef$var$queue.length;
    while(len){
        $8972dd6366fe5fef$var$currentQueue = $8972dd6366fe5fef$var$queue;
        $8972dd6366fe5fef$var$queue = [];
        while(++$8972dd6366fe5fef$var$queueIndex < len)if ($8972dd6366fe5fef$var$currentQueue) $8972dd6366fe5fef$var$currentQueue[$8972dd6366fe5fef$var$queueIndex].run();
        $8972dd6366fe5fef$var$queueIndex = -1;
        len = $8972dd6366fe5fef$var$queue.length;
    }
    $8972dd6366fe5fef$var$currentQueue = null;
    $8972dd6366fe5fef$var$draining = false;
    $8972dd6366fe5fef$var$runClearTimeout(timeout);
}
$8972dd6366fe5fef$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $8972dd6366fe5fef$var$queue.push(new $8972dd6366fe5fef$var$Item(fun, args));
    if ($8972dd6366fe5fef$var$queue.length === 1 && !$8972dd6366fe5fef$var$draining) $8972dd6366fe5fef$var$runTimeout($8972dd6366fe5fef$var$drainQueue);
};
// v8 likes predictible objects
function $8972dd6366fe5fef$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$8972dd6366fe5fef$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$8972dd6366fe5fef$var$process.title = "browser";
$8972dd6366fe5fef$var$process.browser = true;
$8972dd6366fe5fef$var$process.env = {};
$8972dd6366fe5fef$var$process.argv = [];
$8972dd6366fe5fef$var$process.version = ""; // empty string to avoid regexp issues
$8972dd6366fe5fef$var$process.versions = {};
function $8972dd6366fe5fef$var$noop() {}
$8972dd6366fe5fef$var$process.on = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.addListener = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.once = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.off = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.removeListener = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.removeAllListeners = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.emit = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.prependListener = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.prependOnceListener = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.listeners = function(name) {
    return [];
};
$8972dd6366fe5fef$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$8972dd6366fe5fef$var$process.cwd = function() {
    return "/";
};
$8972dd6366fe5fef$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$8972dd6366fe5fef$var$process.umask = function() {
    return 0;
};

});


parcelRegister("aGNdt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3kXsr = parcelRequire("3kXsr");

$3kXsr.__exportStar((parcelRequire("jKCFF")), module.exports);

$3kXsr.__exportStar((parcelRequire("4zbZg")), module.exports);

$3kXsr.__exportStar((parcelRequire("iIx5e")), module.exports);

$3kXsr.__exportStar((parcelRequire("17Aso")), module.exports);

});
parcelRegister("3kXsr", function(module, exports) {

$parcel$export(module.exports, "__exportStar", function () { return $26e15c6c40a76ef5$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $26e15c6c40a76ef5$var$extendStatics = function(d, b) {
    $26e15c6c40a76ef5$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $26e15c6c40a76ef5$var$extendStatics(d, b);
};
function $26e15c6c40a76ef5$export$a8ba968b8961cb8a(d, b) {
    $26e15c6c40a76ef5$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $26e15c6c40a76ef5$export$18ce0697a983be9b = function() {
    $26e15c6c40a76ef5$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $26e15c6c40a76ef5$export$18ce0697a983be9b.apply(this, arguments);
};
function $26e15c6c40a76ef5$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $26e15c6c40a76ef5$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $26e15c6c40a76ef5$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $26e15c6c40a76ef5$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $26e15c6c40a76ef5$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $26e15c6c40a76ef5$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $26e15c6c40a76ef5$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $26e15c6c40a76ef5$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $26e15c6c40a76ef5$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $26e15c6c40a76ef5$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $26e15c6c40a76ef5$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($26e15c6c40a76ef5$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $26e15c6c40a76ef5$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $26e15c6c40a76ef5$export$10c90e4f7922046c(v) {
    return this instanceof $26e15c6c40a76ef5$export$10c90e4f7922046c ? (this.v = v, this) : new $26e15c6c40a76ef5$export$10c90e4f7922046c(v);
}
function $26e15c6c40a76ef5$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $26e15c6c40a76ef5$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $26e15c6c40a76ef5$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $26e15c6c40a76ef5$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $26e15c6c40a76ef5$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $26e15c6c40a76ef5$export$19a8beecd37a4c45 === "function" ? $26e15c6c40a76ef5$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $26e15c6c40a76ef5$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $26e15c6c40a76ef5$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $26e15c6c40a76ef5$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $26e15c6c40a76ef5$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $26e15c6c40a76ef5$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("jKCFF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3kXsr = parcelRequire("3kXsr");

$3kXsr.__exportStar((parcelRequire("aU26v")), module.exports);

$3kXsr.__exportStar((parcelRequire("aV6Rz")), module.exports);

});
parcelRegister("aU26v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.delay = void 0;
function $7f00c4246bcb406e$var$delay(timeout) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve(true);
        }, timeout);
    });
}
module.exports.delay = $7f00c4246bcb406e$var$delay;

});

parcelRegister("aV6Rz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromMiliseconds = module.exports.toMiliseconds = void 0;

var $17Aso = parcelRequire("17Aso");
function $7f348d19ab255330$var$toMiliseconds(seconds) {
    return seconds * $17Aso.ONE_THOUSAND;
}
module.exports.toMiliseconds = $7f348d19ab255330$var$toMiliseconds;
function $7f348d19ab255330$var$fromMiliseconds(miliseconds) {
    return Math.floor(miliseconds / $17Aso.ONE_THOUSAND);
}
module.exports.fromMiliseconds = $7f348d19ab255330$var$fromMiliseconds;

});
parcelRegister("17Aso", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3kXsr = parcelRequire("3kXsr");

$3kXsr.__exportStar((parcelRequire("gSHrY")), module.exports);

$3kXsr.__exportStar((parcelRequire("hWGl7")), module.exports);

});
parcelRegister("gSHrY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_THOUSAND = module.exports.ONE_HUNDRED = void 0;
module.exports.ONE_HUNDRED = 100;
module.exports.ONE_THOUSAND = 1000;

});

parcelRegister("hWGl7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ONE_YEAR = module.exports.FOUR_WEEKS = module.exports.THREE_WEEKS = module.exports.TWO_WEEKS = module.exports.ONE_WEEK = module.exports.THIRTY_DAYS = module.exports.SEVEN_DAYS = module.exports.FIVE_DAYS = module.exports.THREE_DAYS = module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS = module.exports.TWELVE_HOURS = module.exports.SIX_HOURS = module.exports.THREE_HOURS = module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES = module.exports.THIRTY_MINUTES = module.exports.TEN_MINUTES = module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS = module.exports.THIRTY_SECONDS = module.exports.TEN_SECONDS = module.exports.FIVE_SECONDS = module.exports.ONE_SECOND = void 0;
module.exports.ONE_SECOND = 1;
module.exports.FIVE_SECONDS = 5;
module.exports.TEN_SECONDS = 10;
module.exports.THIRTY_SECONDS = 30;
module.exports.SIXTY_SECONDS = 60;
module.exports.ONE_MINUTE = module.exports.SIXTY_SECONDS;
module.exports.FIVE_MINUTES = module.exports.ONE_MINUTE * 5;
module.exports.TEN_MINUTES = module.exports.ONE_MINUTE * 10;
module.exports.THIRTY_MINUTES = module.exports.ONE_MINUTE * 30;
module.exports.SIXTY_MINUTES = module.exports.ONE_MINUTE * 60;
module.exports.ONE_HOUR = module.exports.SIXTY_MINUTES;
module.exports.THREE_HOURS = module.exports.ONE_HOUR * 3;
module.exports.SIX_HOURS = module.exports.ONE_HOUR * 6;
module.exports.TWELVE_HOURS = module.exports.ONE_HOUR * 12;
module.exports.TWENTY_FOUR_HOURS = module.exports.ONE_HOUR * 24;
module.exports.ONE_DAY = module.exports.TWENTY_FOUR_HOURS;
module.exports.THREE_DAYS = module.exports.ONE_DAY * 3;
module.exports.FIVE_DAYS = module.exports.ONE_DAY * 5;
module.exports.SEVEN_DAYS = module.exports.ONE_DAY * 7;
module.exports.THIRTY_DAYS = module.exports.ONE_DAY * 30;
module.exports.ONE_WEEK = module.exports.SEVEN_DAYS;
module.exports.TWO_WEEKS = module.exports.ONE_WEEK * 2;
module.exports.THREE_WEEKS = module.exports.ONE_WEEK * 3;
module.exports.FOUR_WEEKS = module.exports.ONE_WEEK * 4;
module.exports.ONE_YEAR = module.exports.ONE_DAY * 365;

});




parcelRegister("4zbZg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Watch = void 0;
class $3533baae104bbd86$var$Watch {
    constructor(){
        this.timestamps = new Map();
    }
    start(label) {
        if (this.timestamps.has(label)) throw new Error(`Watch already started for label: ${label}`);
        this.timestamps.set(label, {
            started: Date.now()
        });
    }
    stop(label) {
        const timestamp = this.get(label);
        if (typeof timestamp.elapsed !== "undefined") throw new Error(`Watch already stopped for label: ${label}`);
        const elapsed = Date.now() - timestamp.started;
        this.timestamps.set(label, {
            started: timestamp.started,
            elapsed: elapsed
        });
    }
    get(label) {
        const timestamp = this.timestamps.get(label);
        if (typeof timestamp === "undefined") throw new Error(`No timestamp found for label: ${label}`);
        return timestamp;
    }
    elapsed(label) {
        const timestamp = this.get(label);
        const elapsed = timestamp.elapsed || Date.now() - timestamp.started;
        return elapsed;
    }
}
module.exports.Watch = $3533baae104bbd86$var$Watch;
module.exports.default = $3533baae104bbd86$var$Watch;

});

parcelRegister("iIx5e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3kXsr = parcelRequire("3kXsr");

$3kXsr.__exportStar((parcelRequire("ltFW3")), module.exports);

});
parcelRegister("ltFW3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IWatch = void 0;
class $fa2cd5eb20a3bb90$var$IWatch {
}
module.exports.IWatch = $fa2cd5eb20a3bb90$var$IWatch;

});



parcelRegister("6qPmi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLocalStorage = module.exports.getLocalStorageOrThrow = module.exports.getCrypto = module.exports.getCryptoOrThrow = module.exports.getLocation = module.exports.getLocationOrThrow = module.exports.getNavigator = module.exports.getNavigatorOrThrow = module.exports.getDocument = module.exports.getDocumentOrThrow = module.exports.getFromWindowOrThrow = module.exports.getFromWindow = void 0;
function $4aed0284c851e66e$var$getFromWindow(name) {
    let res = undefined;
    if (typeof window !== "undefined" && typeof window[name] !== "undefined") res = window[name];
    return res;
}
module.exports.getFromWindow = $4aed0284c851e66e$var$getFromWindow;
function $4aed0284c851e66e$var$getFromWindowOrThrow(name) {
    const res = $4aed0284c851e66e$var$getFromWindow(name);
    if (!res) throw new Error(`${name} is not defined in Window`);
    return res;
}
module.exports.getFromWindowOrThrow = $4aed0284c851e66e$var$getFromWindowOrThrow;
function $4aed0284c851e66e$var$getDocumentOrThrow() {
    return $4aed0284c851e66e$var$getFromWindowOrThrow("document");
}
module.exports.getDocumentOrThrow = $4aed0284c851e66e$var$getDocumentOrThrow;
function $4aed0284c851e66e$var$getDocument() {
    return $4aed0284c851e66e$var$getFromWindow("document");
}
module.exports.getDocument = $4aed0284c851e66e$var$getDocument;
function $4aed0284c851e66e$var$getNavigatorOrThrow() {
    return $4aed0284c851e66e$var$getFromWindowOrThrow("navigator");
}
module.exports.getNavigatorOrThrow = $4aed0284c851e66e$var$getNavigatorOrThrow;
function $4aed0284c851e66e$var$getNavigator() {
    return $4aed0284c851e66e$var$getFromWindow("navigator");
}
module.exports.getNavigator = $4aed0284c851e66e$var$getNavigator;
function $4aed0284c851e66e$var$getLocationOrThrow() {
    return $4aed0284c851e66e$var$getFromWindowOrThrow("location");
}
module.exports.getLocationOrThrow = $4aed0284c851e66e$var$getLocationOrThrow;
function $4aed0284c851e66e$var$getLocation() {
    return $4aed0284c851e66e$var$getFromWindow("location");
}
module.exports.getLocation = $4aed0284c851e66e$var$getLocation;
function $4aed0284c851e66e$var$getCryptoOrThrow() {
    return $4aed0284c851e66e$var$getFromWindowOrThrow("crypto");
}
module.exports.getCryptoOrThrow = $4aed0284c851e66e$var$getCryptoOrThrow;
function $4aed0284c851e66e$var$getCrypto() {
    return $4aed0284c851e66e$var$getFromWindow("crypto");
}
module.exports.getCrypto = $4aed0284c851e66e$var$getCrypto;
function $4aed0284c851e66e$var$getLocalStorageOrThrow() {
    return $4aed0284c851e66e$var$getFromWindowOrThrow("localStorage");
}
module.exports.getLocalStorageOrThrow = $4aed0284c851e66e$var$getLocalStorageOrThrow;
function $4aed0284c851e66e$var$getLocalStorage() {
    return $4aed0284c851e66e$var$getFromWindow("localStorage");
}
module.exports.getLocalStorage = $4aed0284c851e66e$var$getLocalStorage;

});

parcelRegister("bsIGZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getWindowMetadata = void 0;

var $6qPmi = parcelRequire("6qPmi");
function $8584fa3415fdea0b$var$getWindowMetadata() {
    let doc;
    let loc;
    try {
        doc = $6qPmi.getDocumentOrThrow();
        loc = $6qPmi.getLocationOrThrow();
    } catch (e) {
        return null;
    }
    function getIcons() {
        const links = doc.getElementsByTagName("link");
        const icons = [];
        for(let i = 0; i < links.length; i++){
            const link = links[i];
            const rel = link.getAttribute("rel");
            if (rel) {
                if (rel.toLowerCase().indexOf("icon") > -1) {
                    const href = link.getAttribute("href");
                    if (href) {
                        if (href.toLowerCase().indexOf("https:") === -1 && href.toLowerCase().indexOf("http:") === -1 && href.indexOf("//") !== 0) {
                            let absoluteHref = loc.protocol + "//" + loc.host;
                            if (href.indexOf("/") === 0) absoluteHref += href;
                            else {
                                const path = loc.pathname.split("/");
                                path.pop();
                                const finalPath = path.join("/");
                                absoluteHref += finalPath + "/" + href;
                            }
                            icons.push(absoluteHref);
                        } else if (href.indexOf("//") === 0) {
                            const absoluteUrl = loc.protocol + href;
                            icons.push(absoluteUrl);
                        } else icons.push(href);
                    }
                }
            }
        }
        return icons;
    }
    function getWindowMetadataOfAny(...args) {
        const metaTags = doc.getElementsByTagName("meta");
        for(let i = 0; i < metaTags.length; i++){
            const tag = metaTags[i];
            const attributes = [
                "itemprop",
                "property",
                "name"
            ].map((target)=>tag.getAttribute(target)).filter((attr)=>{
                if (attr) return args.includes(attr);
                return false;
            });
            if (attributes.length && attributes) {
                const content = tag.getAttribute("content");
                if (content) return content;
            }
        }
        return "";
    }
    function getName() {
        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
        if (!name) name = doc.title;
        return name;
    }
    function getDescription() {
        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
        return description;
    }
    const name = getName();
    const description = getDescription();
    const url = loc.origin;
    const icons = getIcons();
    const meta = {
        description: description,
        url: url,
        icons: icons,
        name: name
    };
    return meta;
}
module.exports.getWindowMetadata = $8584fa3415fdea0b$var$getWindowMetadata;

});

parcelRegister("3J7fK", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $2b6b335c4c447926$export$f9380c9a627682d3; }, function (v) { return $2b6b335c4c447926$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $2b6b335c4c447926$export$98e6a39c04603d36; }, function (v) { return $2b6b335c4c447926$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $2b6b335c4c447926$export$fac44ee5b035f737; }, function (v) { return $2b6b335c4c447926$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $2b6b335c4c447926$export$7a5253c0f62e0150; }, function (v) { return $2b6b335c4c447926$export$7a5253c0f62e0150 = v; });
$parcel$export(module.exports, "stringifyUrl", function () { return $2b6b335c4c447926$export$a8c1621ea79325d3; }, function (v) { return $2b6b335c4c447926$export$a8c1621ea79325d3 = v; });
$parcel$export(module.exports, "pick", function () { return $2b6b335c4c447926$export$357523c63a2253b9; }, function (v) { return $2b6b335c4c447926$export$357523c63a2253b9 = v; });
var $2b6b335c4c447926$export$f9380c9a627682d3;
var $2b6b335c4c447926$export$98e6a39c04603d36;
var $2b6b335c4c447926$export$fac44ee5b035f737;
var $2b6b335c4c447926$export$7a5253c0f62e0150;
var $2b6b335c4c447926$export$a8c1621ea79325d3;
var $2b6b335c4c447926$export$357523c63a2253b9;
var $2b6b335c4c447926$export$44c361b8ec72ef7f;
"use strict";

var $jHJ97 = parcelRequire("jHJ97");

var $qhYRx = parcelRequire("qhYRx");

var $j2VFJ = parcelRequire("j2VFJ");

var $hjJq9 = parcelRequire("hjJq9");
const $2b6b335c4c447926$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $2b6b335c4c447926$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $2b6b335c4c447926$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $2b6b335c4c447926$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $2b6b335c4c447926$var$encode(key, options),
                            "[",
                            $2b6b335c4c447926$var$encode(index, options),
                            "]=",
                            $2b6b335c4c447926$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $2b6b335c4c447926$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $2b6b335c4c447926$var$encode(key, options),
                            "[]=",
                            $2b6b335c4c447926$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $2b6b335c4c447926$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $2b6b335c4c447926$var$encode(key, options),
                            ":list=",
                            $2b6b335c4c447926$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $2b6b335c4c447926$var$encode(key, options),
                                keyValueSep,
                                $2b6b335c4c447926$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $2b6b335c4c447926$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $2b6b335c4c447926$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $2b6b335c4c447926$var$encode(key, options),
                            "=",
                            $2b6b335c4c447926$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $2b6b335c4c447926$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $2b6b335c4c447926$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $2b6b335c4c447926$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$2b6b335c4c447926$var$decode(item, options)) : value === null ? value : $2b6b335c4c447926$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $2b6b335c4c447926$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$2b6b335c4c447926$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $2b6b335c4c447926$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $2b6b335c4c447926$var$encode(value, options) {
    if (options.encode) return options.strict ? $jHJ97(value) : encodeURIComponent(value);
    return value;
}
function $2b6b335c4c447926$var$decode(value, options) {
    if (options.decode) return $qhYRx(value);
    return value;
}
function $2b6b335c4c447926$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $2b6b335c4c447926$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $2b6b335c4c447926$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $2b6b335c4c447926$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $2b6b335c4c447926$var$extract(input) {
    input = $2b6b335c4c447926$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $2b6b335c4c447926$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $2b6b335c4c447926$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $2b6b335c4c447926$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $2b6b335c4c447926$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $j2VFJ(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $2b6b335c4c447926$var$decode(value, options);
        formatter($2b6b335c4c447926$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $2b6b335c4c447926$var$parseValue(value[k], options);
        else ret[key] = $2b6b335c4c447926$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $2b6b335c4c447926$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$2b6b335c4c447926$export$f9380c9a627682d3 = $2b6b335c4c447926$var$extract;
$2b6b335c4c447926$export$98e6a39c04603d36 = $2b6b335c4c447926$var$parse;
$2b6b335c4c447926$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $2b6b335c4c447926$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $2b6b335c4c447926$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $2b6b335c4c447926$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $2b6b335c4c447926$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $2b6b335c4c447926$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $2b6b335c4c447926$var$encode(key, options) + "=" + $2b6b335c4c447926$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$2b6b335c4c447926$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $j2VFJ(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $2b6b335c4c447926$var$parse($2b6b335c4c447926$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $2b6b335c4c447926$var$decode(hash, options)
    } : {});
};
$2b6b335c4c447926$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$2b6b335c4c447926$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $2b6b335c4c447926$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $2b6b335c4c447926$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $2b6b335c4c447926$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $2b6b335c4c447926$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $2b6b335c4c447926$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$2b6b335c4c447926$var$encodeFragmentIdentifier] ? $2b6b335c4c447926$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$2b6b335c4c447926$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$2b6b335c4c447926$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $2b6b335c4c447926$export$7a5253c0f62e0150(input, options);
    return $2b6b335c4c447926$export$a8c1621ea79325d3({
        url: url,
        query: $hjJq9(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$2b6b335c4c447926$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $2b6b335c4c447926$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("jHJ97", function(module, exports) {
"use strict";
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("qhYRx", function(module, exports) {
"use strict";
var $04f06067d55a4066$var$token = "%[a-f0-9]{2}";
var $04f06067d55a4066$var$singleMatcher = new RegExp("(" + $04f06067d55a4066$var$token + ")|([^%]+?)", "gi");
var $04f06067d55a4066$var$multiMatcher = new RegExp("(" + $04f06067d55a4066$var$token + ")+", "gi");
function $04f06067d55a4066$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $04f06067d55a4066$var$decodeComponents(left), $04f06067d55a4066$var$decodeComponents(right));
}
function $04f06067d55a4066$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($04f06067d55a4066$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $04f06067d55a4066$var$decodeComponents(tokens, i).join("");
            tokens = input.match($04f06067d55a4066$var$singleMatcher) || [];
        }
        return input;
    }
}
function $04f06067d55a4066$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $04f06067d55a4066$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $04f06067d55a4066$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $04f06067d55a4066$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $04f06067d55a4066$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("j2VFJ", function(module, exports) {
"use strict";
module.exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("hjJq9", function(module, exports) {
"use strict";
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("6e20P", function(module, exports) {
$parcel$export(module.exports, "RELAY_JSONRPC", function () { return (parcelRequire("5HwuL")).RELAY_JSONRPC; });

var $88il8 = parcelRequire("88il8");
parcelRequire("uVhVk");
parcelRequire("5HwuL");
parcelRequire("6DxD7");
$parcel$exportWildcard(module.exports, $88il8);

});
parcelRegister("88il8", function(module, exports) {

});

parcelRegister("uVhVk", function(module, exports) {

var $kPmf2 = parcelRequire("kPmf2");

var $6DxD7 = parcelRequire("6DxD7");
function $05cf3dad9bfdaafd$export$abdf96c288cb375(request) {
    if (!(0, $6DxD7.isSubscribeMethod)(request.method)) throw new Error("JSON-RPC Request has invalid subscribe method");
    if (!(0, $6DxD7.isSubscribeParams)(request.params)) throw new Error("JSON-RPC Request has invalid subscribe params");
    const params = request.params;
    (0, $kPmf2.assertType)(params, "topic");
    return params;
}
function $05cf3dad9bfdaafd$export$eac3e45ac5c5c9fa(request) {
    if (!(0, $6DxD7.isPublishMethod)(request.method)) throw new Error("JSON-RPC Request has invalid publish method");
    if (!(0, $6DxD7.isPublishParams)(request.params)) throw new Error("JSON-RPC Request has invalid publish params");
    const params = request.params;
    (0, $kPmf2.assertType)(params, "topic");
    (0, $kPmf2.assertType)(params, "message");
    (0, $kPmf2.assertType)(params, "ttl", "number");
    return params;
}
function $05cf3dad9bfdaafd$export$78baa72f78156594(request) {
    if (!(0, $6DxD7.isUnsubscribeMethod)(request.method)) throw new Error("JSON-RPC Request has invalid unsubscribe method");
    if (!(0, $6DxD7.isUnsubscribeParams)(request.params)) throw new Error("JSON-RPC Request has invalid unsubscribe params");
    const params = request.params;
    (0, $kPmf2.assertType)(params, "id");
    return params;
}
function $05cf3dad9bfdaafd$export$4d5822edd41f3b48(request) {
    if (!(0, $6DxD7.isSubscriptionMethod)(request.method)) throw new Error("JSON-RPC Request has invalid subscription method");
    if (!(0, $6DxD7.isSubscriptionParams)(request.params)) throw new Error("JSON-RPC Request has invalid subscription params");
    const params = request.params;
    (0, $kPmf2.assertType)(params, "id");
    (0, $kPmf2.assertType)(params, "data");
    return params;
}

});
parcelRegister("kPmf2", function(module, exports) {

$parcel$export(module.exports, "assertType", function () { return $f299d2c079f5a445$export$804de46662e4ac95; });
$parcel$export(module.exports, "checkParams", function () { return $f299d2c079f5a445$export$19e8e281e27dafad; });
$parcel$export(module.exports, "methodEndsWith", function () { return $f299d2c079f5a445$export$18337b4ba58d5c33; });
function $f299d2c079f5a445$export$804de46662e4ac95(obj, key, type = "string") {
    if (!obj[key] || typeof obj[key] !== type) throw new Error(`Missing or invalid "${key}" param`);
}
function $f299d2c079f5a445$export$c538c02216fcdc03(params, required) {
    let matches = true;
    required.forEach((key)=>{
        const exists = key in params;
        if (!exists) matches = false;
    });
    return matches;
}
function $f299d2c079f5a445$export$e4b3f942a6d00ef9(params, length) {
    return Array.isArray(params) ? params.length === length : Object.keys(params).length === length;
}
function $f299d2c079f5a445$export$8fcd263f2845753e(params, minLength) {
    return Array.isArray(params) ? params.length >= minLength : Object.keys(params).length >= minLength;
}
function $f299d2c079f5a445$export$19e8e281e27dafad(params, required, optional) {
    const exact = !optional.length;
    const matchesLength = exact ? $f299d2c079f5a445$export$e4b3f942a6d00ef9(params, required.length) : $f299d2c079f5a445$export$8fcd263f2845753e(params, required.length);
    if (!matchesLength) return false;
    return $f299d2c079f5a445$export$c538c02216fcdc03(params, required);
}
function $f299d2c079f5a445$export$18337b4ba58d5c33(method, expected, separator = "_") {
    const split = method.split(separator);
    return split[split.length - 1].trim().toLowerCase() === expected.trim().toLowerCase();
}

});

parcelRegister("6DxD7", function(module, exports) {

$parcel$export(module.exports, "isSubscribeMethod", function () { return $4d5078c7e1cbb3f9$export$f576347163de0984; });
$parcel$export(module.exports, "isSubscribeParams", function () { return $4d5078c7e1cbb3f9$export$dae2311546d43680; });
$parcel$export(module.exports, "isPublishMethod", function () { return $4d5078c7e1cbb3f9$export$71d4d33ac7f7a269; });
$parcel$export(module.exports, "isPublishParams", function () { return $4d5078c7e1cbb3f9$export$71e8d1aa48c3e86f; });
$parcel$export(module.exports, "isUnsubscribeMethod", function () { return $4d5078c7e1cbb3f9$export$568d956f39536025; });
$parcel$export(module.exports, "isUnsubscribeParams", function () { return $4d5078c7e1cbb3f9$export$cbc597c53c3b4f80; });
$parcel$export(module.exports, "isSubscriptionMethod", function () { return $4d5078c7e1cbb3f9$export$3cb4ad320e3a46a4; });
$parcel$export(module.exports, "isSubscriptionParams", function () { return $4d5078c7e1cbb3f9$export$6366ff9a39f2da4c; });

var $kPmf2 = parcelRequire("kPmf2");
function $4d5078c7e1cbb3f9$export$c75580565fa025bd(request) {
    return $4d5078c7e1cbb3f9$export$f576347163de0984(request.method) && $4d5078c7e1cbb3f9$export$dae2311546d43680(request.params);
}
function $4d5078c7e1cbb3f9$export$f576347163de0984(method) {
    return (0, $kPmf2.methodEndsWith)(method, "subscribe");
}
function $4d5078c7e1cbb3f9$export$dae2311546d43680(params) {
    const required = [
        "topic"
    ];
    const optional = [];
    return (0, $kPmf2.checkParams)(params, required, optional);
}
function $4d5078c7e1cbb3f9$export$8fa7cf76b41caee0(request) {
    return $4d5078c7e1cbb3f9$export$71d4d33ac7f7a269(request.method) && $4d5078c7e1cbb3f9$export$71e8d1aa48c3e86f(request.params);
}
function $4d5078c7e1cbb3f9$export$71d4d33ac7f7a269(method) {
    return (0, $kPmf2.methodEndsWith)(method, "publish");
}
function $4d5078c7e1cbb3f9$export$71e8d1aa48c3e86f(params) {
    const required = [
        "message",
        "topic",
        "ttl"
    ];
    const optional = [
        "prompt",
        "tag"
    ];
    return (0, $kPmf2.checkParams)(params, required, optional);
}
function $4d5078c7e1cbb3f9$export$83e292763180b41b(request) {
    return $4d5078c7e1cbb3f9$export$568d956f39536025(request.method) && $4d5078c7e1cbb3f9$export$cbc597c53c3b4f80(request.params);
}
function $4d5078c7e1cbb3f9$export$568d956f39536025(method) {
    return (0, $kPmf2.methodEndsWith)(method, "unsubscribe");
}
function $4d5078c7e1cbb3f9$export$cbc597c53c3b4f80(params) {
    const required = [
        "id",
        "topic"
    ];
    const optional = [];
    return (0, $kPmf2.checkParams)(params, required, optional);
}
function $4d5078c7e1cbb3f9$export$43cf4100d6287b8e(request) {
    return $4d5078c7e1cbb3f9$export$3cb4ad320e3a46a4(request.method) && $4d5078c7e1cbb3f9$export$6366ff9a39f2da4c(request.params);
}
function $4d5078c7e1cbb3f9$export$3cb4ad320e3a46a4(method) {
    return (0, $kPmf2.methodEndsWith)(method, "subscription");
}
function $4d5078c7e1cbb3f9$export$6366ff9a39f2da4c(params) {
    const required = [
        "id",
        "data"
    ];
    const optional = [];
    return (0, $kPmf2.checkParams)(params, required, optional);
}

});


parcelRegister("5HwuL", function(module, exports) {

$parcel$export(module.exports, "RELAY_JSONRPC", function () { return $426a2cbefa6488de$export$af490b3b9a6de00f; });
const $426a2cbefa6488de$export$af490b3b9a6de00f = {
    waku: {
        publish: "waku_publish",
        batchPublish: "waku_batchPublish",
        subscribe: "waku_subscribe",
        batchSubscribe: "waku_batchSubscribe",
        subscription: "waku_subscription",
        unsubscribe: "waku_unsubscribe",
        batchUnsubscribe: "waku_batchUnsubscribe"
    },
    irn: {
        publish: "irn_publish",
        batchPublish: "irn_batchPublish",
        subscribe: "irn_subscribe",
        batchSubscribe: "irn_batchSubscribe",
        subscription: "irn_subscription",
        unsubscribe: "irn_unsubscribe",
        batchUnsubscribe: "irn_batchUnsubscribe"
    },
    iridium: {
        publish: "iridium_publish",
        batchPublish: "iridium_batchPublish",
        subscribe: "iridium_subscribe",
        batchSubscribe: "iridium_batchSubscribe",
        subscription: "iridium_subscription",
        unsubscribe: "iridium_unsubscribe",
        batchUnsubscribe: "iridium_batchUnsubscribe"
    }
};

});



parcelRegister("4nuqd", function(module, exports) {


module.exports = (parcelRequire("cKPUe"))((parcelRequire("jwisd")).resolve("9u4nt")).then(()=>parcelRequire("3ImU3"));

});

parcelRegister("eLb5d", function(module, exports) {

$parcel$export(module.exports, "RouterCtrl", function () { return $abee0d548a3d974c$export$2dd8023fb2cd44c; });
$parcel$export(module.exports, "CoreUtil", function () { return $abee0d548a3d974c$export$2ff3ceb398d6f444; });
$parcel$export(module.exports, "ClientCtrl", function () { return $abee0d548a3d974c$export$7d2d093f32eecd30; });
$parcel$export(module.exports, "EventsCtrl", function () { return $abee0d548a3d974c$export$59a837b99037295; });
$parcel$export(module.exports, "OptionsCtrl", function () { return $abee0d548a3d974c$export$5f7b08e38aeeee56; });
$parcel$export(module.exports, "ConfigCtrl", function () { return $abee0d548a3d974c$export$5239b2e4de4e2646; });
$parcel$export(module.exports, "AccountCtrl", function () { return $abee0d548a3d974c$export$7a9b1b1b32fe2386; });
$parcel$export(module.exports, "ExplorerCtrl", function () { return $abee0d548a3d974c$export$8a0e3ad54b37ee57; });
$parcel$export(module.exports, "WcConnectionCtrl", function () { return $abee0d548a3d974c$export$d3e2d95fafb02657; });
$parcel$export(module.exports, "ModalCtrl", function () { return $abee0d548a3d974c$export$f6ef1648e6110c37; });
$parcel$export(module.exports, "ThemeCtrl", function () { return $abee0d548a3d974c$export$fed0363cf09933ba; });
$parcel$export(module.exports, "ToastCtrl", function () { return $abee0d548a3d974c$export$49bec3d5b199c07; });

var $49umM = parcelRequire("49umM");
const $abee0d548a3d974c$var$o = (0, $49umM.proxy)({
    history: [
        "ConnectWallet"
    ],
    view: "ConnectWallet",
    data: void 0
}), $abee0d548a3d974c$export$2dd8023fb2cd44c = {
    state: $abee0d548a3d974c$var$o,
    subscribe (e) {
        return (0, $49umM.subscribe)($abee0d548a3d974c$var$o, ()=>e($abee0d548a3d974c$var$o));
    },
    push (e, t) {
        e !== $abee0d548a3d974c$var$o.view && ($abee0d548a3d974c$var$o.view = e, t && ($abee0d548a3d974c$var$o.data = t), $abee0d548a3d974c$var$o.history.push(e));
    },
    reset (e) {
        $abee0d548a3d974c$var$o.view = e, $abee0d548a3d974c$var$o.history = [
            e
        ];
    },
    replace (e) {
        $abee0d548a3d974c$var$o.history.length > 1 && ($abee0d548a3d974c$var$o.history[$abee0d548a3d974c$var$o.history.length - 1] = e, $abee0d548a3d974c$var$o.view = e);
    },
    goBack () {
        if ($abee0d548a3d974c$var$o.history.length > 1) {
            $abee0d548a3d974c$var$o.history.pop();
            const [e] = $abee0d548a3d974c$var$o.history.slice(-1);
            $abee0d548a3d974c$var$o.view = e;
        }
    },
    setData (e) {
        $abee0d548a3d974c$var$o.data = e;
    }
}, $abee0d548a3d974c$export$2ff3ceb398d6f444 = {
    WALLETCONNECT_DEEPLINK_CHOICE: "WALLETCONNECT_DEEPLINK_CHOICE",
    W3M_VERSION: "W3M_VERSION",
    W3M_PREFER_INJECTED_URL_FLAG: "w3mPreferInjected",
    RECOMMENDED_WALLET_AMOUNT: 9,
    isMobile () {
        return typeof window < "u" ? Boolean(window.matchMedia("(pointer:coarse)").matches || /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/u.test(navigator.userAgent)) : !1;
    },
    isAndroid () {
        return $abee0d548a3d974c$export$2ff3ceb398d6f444.isMobile() && navigator.userAgent.toLowerCase().includes("android");
    },
    isIos () {
        const e = navigator.userAgent.toLowerCase();
        return $abee0d548a3d974c$export$2ff3ceb398d6f444.isMobile() && (e.includes("iphone") || e.includes("ipad"));
    },
    isHttpUrl (e) {
        return e.startsWith("http://") || e.startsWith("https://");
    },
    isArray (e) {
        return Array.isArray(e) && e.length > 0;
    },
    formatNativeUrl (e, t, n) {
        if ($abee0d548a3d974c$export$2ff3ceb398d6f444.isHttpUrl(e)) return this.formatUniversalUrl(e, t, n);
        let s = e;
        s.includes("://") || (s = e.replaceAll("/", "").replaceAll(":", ""), s = `${s}://`), s.endsWith("/") || (s = `${s}/`), this.setWalletConnectDeepLink(s, n);
        const a = encodeURIComponent(t);
        return `${s}wc?uri=${a}`;
    },
    formatUniversalUrl (e, t, n) {
        if (!$abee0d548a3d974c$export$2ff3ceb398d6f444.isHttpUrl(e)) return this.formatNativeUrl(e, t, n);
        let s = e;
        s.endsWith("/") || (s = `${s}/`), this.setWalletConnectDeepLink(s, n);
        const a = encodeURIComponent(t);
        return `${s}wc?uri=${a}`;
    },
    async wait (e) {
        return new Promise((t)=>{
            setTimeout(t, e);
        });
    },
    openHref (e, t) {
        window.open(e, t, "noreferrer noopener");
    },
    setWalletConnectDeepLink (e, t) {
        try {
            localStorage.setItem($abee0d548a3d974c$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
                href: e,
                name: t
            }));
        } catch  {
            console.info("Unable to set WalletConnect deep link");
        }
    },
    setWalletConnectAndroidDeepLink (e) {
        try {
            const [t] = e.split("?");
            localStorage.setItem($abee0d548a3d974c$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
                href: t,
                name: "Android"
            }));
        } catch  {
            console.info("Unable to set WalletConnect android deep link");
        }
    },
    removeWalletConnectDeepLink () {
        try {
            localStorage.removeItem($abee0d548a3d974c$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE);
        } catch  {
            console.info("Unable to remove WalletConnect deep link");
        }
    },
    setWeb3ModalVersionInStorage () {
        try {
            typeof localStorage < "u" && localStorage.setItem($abee0d548a3d974c$export$2ff3ceb398d6f444.W3M_VERSION, "2.7.1");
        } catch  {
            console.info("Unable to set Web3Modal version in storage");
        }
    },
    getWalletRouterData () {
        var e;
        const t = (e = $abee0d548a3d974c$export$2dd8023fb2cd44c.state.data) == null ? void 0 : e.Wallet;
        if (!t) throw new Error('Missing "Wallet" view data');
        return t;
    },
    getSwitchNetworkRouterData () {
        var e;
        const t = (e = $abee0d548a3d974c$export$2dd8023fb2cd44c.state.data) == null ? void 0 : e.SwitchNetwork;
        if (!t) throw new Error('Missing "SwitchNetwork" view data');
        return t;
    },
    isPreferInjectedFlag () {
        return typeof location < "u" ? new URLSearchParams(location.search).has($abee0d548a3d974c$export$2ff3ceb398d6f444.W3M_PREFER_INJECTED_URL_FLAG) : !1;
    }
};
let $abee0d548a3d974c$var$k;
const $abee0d548a3d974c$export$7d2d093f32eecd30 = {
    ethereumClient: void 0,
    setEthereumClient (e) {
        $abee0d548a3d974c$var$k = e;
    },
    client () {
        if ($abee0d548a3d974c$var$k) return $abee0d548a3d974c$var$k;
        throw new Error("ClientCtrl has no client set");
    }
}, $abee0d548a3d974c$var$K = typeof location < "u" && (location.hostname.includes("localhost") || location.protocol.includes("https")), $abee0d548a3d974c$var$l = (0, $49umM.proxy)({
    enabled: $abee0d548a3d974c$var$K,
    userSessionId: "",
    events: [],
    connectedWalletId: void 0
}), $abee0d548a3d974c$export$59a837b99037295 = {
    state: $abee0d548a3d974c$var$l,
    subscribe (e) {
        return (0, $49umM.subscribe)($abee0d548a3d974c$var$l.events, ()=>e((0, $49umM.snapshot)($abee0d548a3d974c$var$l.events[$abee0d548a3d974c$var$l.events.length - 1])));
    },
    initialize () {
        $abee0d548a3d974c$var$l.enabled && typeof (crypto == null ? void 0 : crypto.randomUUID) < "u" && ($abee0d548a3d974c$var$l.userSessionId = crypto.randomUUID());
    },
    setConnectedWalletId (e) {
        $abee0d548a3d974c$var$l.connectedWalletId = e;
    },
    click (e) {
        if ($abee0d548a3d974c$var$l.enabled) {
            const t = {
                type: "CLICK",
                name: e.name,
                userSessionId: $abee0d548a3d974c$var$l.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $abee0d548a3d974c$var$l.events.push(t);
        }
    },
    track (e) {
        if ($abee0d548a3d974c$var$l.enabled) {
            const t = {
                type: "TRACK",
                name: e.name,
                userSessionId: $abee0d548a3d974c$var$l.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $abee0d548a3d974c$var$l.events.push(t);
        }
    },
    view (e) {
        if ($abee0d548a3d974c$var$l.enabled) {
            const t = {
                type: "VIEW",
                name: e.name,
                userSessionId: $abee0d548a3d974c$var$l.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $abee0d548a3d974c$var$l.events.push(t);
        }
    }
}, $abee0d548a3d974c$var$p = (0, $49umM.proxy)({
    selectedChain: void 0,
    chains: void 0,
    isCustomDesktop: !1,
    isCustomMobile: !1,
    isDataLoaded: !1,
    isUiLoaded: !1,
    isPreferInjected: !1
}), $abee0d548a3d974c$export$5f7b08e38aeeee56 = {
    state: $abee0d548a3d974c$var$p,
    subscribe (e) {
        return (0, $49umM.subscribe)($abee0d548a3d974c$var$p, ()=>e($abee0d548a3d974c$var$p));
    },
    setChains (e) {
        $abee0d548a3d974c$var$p.chains = e;
    },
    getSelectedChain () {
        const e = $abee0d548a3d974c$export$7d2d093f32eecd30.client().getNetwork().chain;
        return e && ($abee0d548a3d974c$var$p.selectedChain = e), $abee0d548a3d974c$var$p.selectedChain;
    },
    setSelectedChain (e) {
        $abee0d548a3d974c$var$p.selectedChain = e;
    },
    setIsCustomDesktop (e) {
        $abee0d548a3d974c$var$p.isCustomDesktop = e;
    },
    setIsCustomMobile (e) {
        $abee0d548a3d974c$var$p.isCustomMobile = e;
    },
    setIsDataLoaded (e) {
        $abee0d548a3d974c$var$p.isDataLoaded = e;
    },
    setIsUiLoaded (e) {
        $abee0d548a3d974c$var$p.isUiLoaded = e;
    },
    setIsPreferInjected (e) {
        $abee0d548a3d974c$var$p.isPreferInjected = e;
    }
}, $abee0d548a3d974c$var$O = (0, $49umM.proxy)({
    projectId: "",
    mobileWallets: void 0,
    desktopWallets: void 0,
    walletImages: void 0,
    chainImages: void 0,
    tokenImages: void 0,
    tokenContracts: void 0,
    enableNetworkView: !1,
    enableAccountView: !0,
    enableExplorer: !0,
    defaultChain: void 0,
    explorerExcludedWalletIds: void 0,
    explorerRecommendedWalletIds: void 0,
    termsOfServiceUrl: void 0,
    privacyPolicyUrl: void 0
}), $abee0d548a3d974c$export$5239b2e4de4e2646 = {
    state: $abee0d548a3d974c$var$O,
    subscribe (e) {
        return (0, $49umM.subscribe)($abee0d548a3d974c$var$O, ()=>e($abee0d548a3d974c$var$O));
    },
    setConfig (e) {
        var t, n;
        $abee0d548a3d974c$export$59a837b99037295.initialize(), $abee0d548a3d974c$export$5f7b08e38aeeee56.setIsCustomMobile(Boolean((t = e.mobileWallets) == null ? void 0 : t.length)), $abee0d548a3d974c$export$5f7b08e38aeeee56.setIsCustomDesktop(Boolean((n = e.desktopWallets) == null ? void 0 : n.length)), $abee0d548a3d974c$export$5f7b08e38aeeee56.setChains($abee0d548a3d974c$export$7d2d093f32eecd30.client().chains), $abee0d548a3d974c$export$5f7b08e38aeeee56.setIsPreferInjected($abee0d548a3d974c$export$7d2d093f32eecd30.client().isInjectedProviderInstalled() && $abee0d548a3d974c$export$2ff3ceb398d6f444.isPreferInjectedFlag()), e.defaultChain && $abee0d548a3d974c$export$5f7b08e38aeeee56.setSelectedChain(e.defaultChain), $abee0d548a3d974c$export$2ff3ceb398d6f444.setWeb3ModalVersionInStorage(), Object.assign($abee0d548a3d974c$var$O, e);
    }
}, $abee0d548a3d974c$var$J = "eip155", $abee0d548a3d974c$var$z = "https://rpc.walletconnect.com", $abee0d548a3d974c$var$G = {
    async getIdentity (e, t) {
        const { projectId: n } = $abee0d548a3d974c$export$5239b2e4de4e2646.state, s = `${$abee0d548a3d974c$var$J}:${t}`, a = `${$abee0d548a3d974c$var$z}/v1/identity/${e}?chainId=${s}&projectId=${n}`;
        return (await fetch(a)).json();
    }
}, $abee0d548a3d974c$var$r = (0, $49umM.proxy)({
    address: void 0,
    profileName: void 0,
    profileAvatar: void 0,
    profileLoading: !1,
    balanceLoading: !1,
    balance: void 0,
    isConnected: !1
}), $abee0d548a3d974c$export$7a9b1b1b32fe2386 = {
    state: $abee0d548a3d974c$var$r,
    subscribe (e) {
        return (0, $49umM.subscribe)($abee0d548a3d974c$var$r, ()=>e($abee0d548a3d974c$var$r));
    },
    getAccount () {
        const e = $abee0d548a3d974c$export$7d2d093f32eecd30.client().getAccount();
        $abee0d548a3d974c$var$r.address = e.address, $abee0d548a3d974c$var$r.isConnected = e.isConnected;
    },
    async fetchProfile (e, t) {
        var n;
        try {
            $abee0d548a3d974c$var$r.profileLoading = !0, $abee0d548a3d974c$var$r.profileName = null, $abee0d548a3d974c$var$r.profileAvatar = null;
            const s = t ?? $abee0d548a3d974c$var$r.address, a = 1, c = (n = $abee0d548a3d974c$export$5f7b08e38aeeee56.state.chains) == null ? void 0 : n.find((d)=>d.id === a);
            if (s && c) {
                try {
                    const d = await $abee0d548a3d974c$var$G.getIdentity(s, a);
                    $abee0d548a3d974c$var$r.profileName = d.name, $abee0d548a3d974c$var$r.profileAvatar = d.avatar;
                } catch  {
                    const m = await $abee0d548a3d974c$export$7d2d093f32eecd30.client().fetchEnsName({
                        address: s,
                        chainId: a
                    });
                    if ($abee0d548a3d974c$var$r.profileName = m, m) {
                        const v = await $abee0d548a3d974c$export$7d2d093f32eecd30.client().fetchEnsAvatar({
                            name: m,
                            chainId: a
                        });
                        $abee0d548a3d974c$var$r.profileAvatar = v;
                    }
                }
                $abee0d548a3d974c$var$r.profileAvatar && await e($abee0d548a3d974c$var$r.profileAvatar);
            }
        } finally{
            $abee0d548a3d974c$var$r.profileLoading = !1;
        }
    },
    async fetchBalance (e) {
        try {
            const { chain: t } = $abee0d548a3d974c$export$7d2d093f32eecd30.client().getNetwork(), { tokenContracts: n } = $abee0d548a3d974c$export$5239b2e4de4e2646.state;
            let s;
            t && n && (s = n[t.id]), $abee0d548a3d974c$var$r.balanceLoading = !0;
            const a = e ?? $abee0d548a3d974c$var$r.address;
            if (a) {
                const c = await $abee0d548a3d974c$export$7d2d093f32eecd30.client().fetchBalance({
                    address: a,
                    token: s
                });
                $abee0d548a3d974c$var$r.balance = {
                    amount: c.formatted,
                    symbol: c.symbol
                };
            }
        } finally{
            $abee0d548a3d974c$var$r.balanceLoading = !1;
        }
    },
    setAddress (e) {
        $abee0d548a3d974c$var$r.address = e;
    },
    setIsConnected (e) {
        $abee0d548a3d974c$var$r.isConnected = e;
    },
    resetBalance () {
        $abee0d548a3d974c$var$r.balance = void 0;
    },
    resetAccount () {
        $abee0d548a3d974c$var$r.address = void 0, $abee0d548a3d974c$var$r.isConnected = !1, $abee0d548a3d974c$var$r.profileName = void 0, $abee0d548a3d974c$var$r.profileAvatar = void 0, $abee0d548a3d974c$var$r.balance = void 0;
    }
};
var $abee0d548a3d974c$var$Q = Object.defineProperty, $abee0d548a3d974c$var$S = Object.getOwnPropertySymbols, $abee0d548a3d974c$var$X = Object.prototype.hasOwnProperty, $abee0d548a3d974c$var$Y = Object.prototype.propertyIsEnumerable, $abee0d548a3d974c$var$T = (e, t, n)=>t in e ? $abee0d548a3d974c$var$Q(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : e[t] = n, $abee0d548a3d974c$var$Z = (e, t)=>{
    for(var n in t || (t = {}))$abee0d548a3d974c$var$X.call(t, n) && $abee0d548a3d974c$var$T(e, n, t[n]);
    if ($abee0d548a3d974c$var$S) for (var n of $abee0d548a3d974c$var$S(t))$abee0d548a3d974c$var$Y.call(t, n) && $abee0d548a3d974c$var$T(e, n, t[n]);
    return e;
};
const $abee0d548a3d974c$var$D = "https://explorer-api.walletconnect.com", $abee0d548a3d974c$var$M = "w3m", $abee0d548a3d974c$var$$ = "js-2.7.1";
async function $abee0d548a3d974c$var$U(e, t) {
    const n = $abee0d548a3d974c$var$Z({
        sdkType: $abee0d548a3d974c$var$M,
        sdkVersion: $abee0d548a3d974c$var$$
    }, t), s = new URL(e, $abee0d548a3d974c$var$D);
    return s.searchParams.append("projectId", $abee0d548a3d974c$export$5239b2e4de4e2646.state.projectId), Object.entries(n).forEach(([a, c])=>{
        c && s.searchParams.append(a, String(c));
    }), (await fetch(s)).json();
}
const $abee0d548a3d974c$var$I = {
    async getDesktopListings (e) {
        return $abee0d548a3d974c$var$U("/w3m/v1/getDesktopListings", e);
    },
    async getMobileListings (e) {
        return $abee0d548a3d974c$var$U("/w3m/v1/getMobileListings", e);
    },
    async getInjectedListings (e) {
        return $abee0d548a3d974c$var$U("/w3m/v1/getInjectedListings", e);
    },
    async getAllListings (e) {
        return $abee0d548a3d974c$var$U("/w3m/v1/getAllListings", e);
    },
    getWalletImageUrl (e) {
        return `${$abee0d548a3d974c$var$D}/w3m/v1/getWalletImage/${e}?projectId=${$abee0d548a3d974c$export$5239b2e4de4e2646.state.projectId}&sdkType=${$abee0d548a3d974c$var$M}&sdkVersion=${$abee0d548a3d974c$var$$}`;
    },
    getAssetImageUrl (e) {
        return `${$abee0d548a3d974c$var$D}/w3m/v1/getAssetImage/${e}?projectId=${$abee0d548a3d974c$export$5239b2e4de4e2646.state.projectId}&sdkType=${$abee0d548a3d974c$var$M}&sdkVersion=${$abee0d548a3d974c$var$$}`;
    }
};
var $abee0d548a3d974c$var$ee = Object.defineProperty, $abee0d548a3d974c$var$_ = Object.getOwnPropertySymbols, $abee0d548a3d974c$var$te = Object.prototype.hasOwnProperty, $abee0d548a3d974c$var$ne = Object.prototype.propertyIsEnumerable, $abee0d548a3d974c$var$x = (e, t, n)=>t in e ? $abee0d548a3d974c$var$ee(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : e[t] = n, $abee0d548a3d974c$var$se = (e, t)=>{
    for(var n in t || (t = {}))$abee0d548a3d974c$var$te.call(t, n) && $abee0d548a3d974c$var$x(e, n, t[n]);
    if ($abee0d548a3d974c$var$_) for (var n of $abee0d548a3d974c$var$_(t))$abee0d548a3d974c$var$ne.call(t, n) && $abee0d548a3d974c$var$x(e, n, t[n]);
    return e;
};
const $abee0d548a3d974c$var$R = $abee0d548a3d974c$export$2ff3ceb398d6f444.isMobile(), $abee0d548a3d974c$var$u = (0, $49umM.proxy)({
    wallets: {
        listings: [],
        total: 0,
        page: 1
    },
    injectedWallets: [],
    search: {
        listings: [],
        total: 0,
        page: 1
    },
    recomendedWallets: []
}), $abee0d548a3d974c$export$8a0e3ad54b37ee57 = {
    state: $abee0d548a3d974c$var$u,
    async getRecomendedWallets () {
        const { explorerRecommendedWalletIds: e, explorerExcludedWalletIds: t } = $abee0d548a3d974c$export$5239b2e4de4e2646.state;
        if (e === "NONE" || t === "ALL" && !e) return $abee0d548a3d974c$var$u.recomendedWallets;
        if ($abee0d548a3d974c$export$2ff3ceb398d6f444.isArray(e)) {
            const n = {
                recommendedIds: e.join(",")
            }, { listings: s } = await $abee0d548a3d974c$var$I.getAllListings(n), a = Object.values(s);
            a.sort((c, d)=>{
                const m = e.indexOf(c.id), v = e.indexOf(d.id);
                return m - v;
            }), $abee0d548a3d974c$var$u.recomendedWallets = a;
        } else {
            const n = $abee0d548a3d974c$export$2ff3ceb398d6f444.isArray(t), s = {
                page: 1,
                entries: $abee0d548a3d974c$export$2ff3ceb398d6f444.RECOMMENDED_WALLET_AMOUNT,
                version: 2,
                excludedIds: n ? t.join(",") : void 0
            }, { listings: a } = $abee0d548a3d974c$var$R ? await $abee0d548a3d974c$var$I.getMobileListings(s) : await $abee0d548a3d974c$var$I.getDesktopListings(s);
            $abee0d548a3d974c$var$u.recomendedWallets = Object.values(a);
        }
        return $abee0d548a3d974c$var$u.recomendedWallets;
    },
    async getWallets (e) {
        const t = $abee0d548a3d974c$var$se({}, e), { explorerRecommendedWalletIds: n, explorerExcludedWalletIds: s } = $abee0d548a3d974c$export$5239b2e4de4e2646.state, { recomendedWallets: a } = $abee0d548a3d974c$var$u;
        if (s === "ALL") return $abee0d548a3d974c$var$u.wallets;
        a.length ? t.excludedIds = a.map((N)=>N.id).join(",") : $abee0d548a3d974c$export$2ff3ceb398d6f444.isArray(n) && (t.excludedIds = n.join(",")), $abee0d548a3d974c$export$2ff3ceb398d6f444.isArray(s) && (t.excludedIds = [
            t.excludedIds,
            s
        ].filter(Boolean).join(","));
        const { page: c, search: d } = e, { listings: m, total: v } = $abee0d548a3d974c$var$R ? await $abee0d548a3d974c$var$I.getMobileListings(t) : await $abee0d548a3d974c$var$I.getDesktopListings(t), w = Object.values(m), A = d ? "search" : "wallets";
        return $abee0d548a3d974c$var$u[A] = {
            listings: [
                ...$abee0d548a3d974c$var$u[A].listings,
                ...w
            ],
            total: v,
            page: c ?? 1
        }, {
            listings: w,
            total: v
        };
    },
    async getInjectedWallets () {
        const { listings: e } = await $abee0d548a3d974c$var$I.getInjectedListings({}), t = Object.values(e);
        return $abee0d548a3d974c$var$u.injectedWallets = t, $abee0d548a3d974c$var$u.injectedWallets;
    },
    getWalletImageUrl (e) {
        return $abee0d548a3d974c$var$I.getWalletImageUrl(e);
    },
    getAssetImageUrl (e) {
        return $abee0d548a3d974c$var$I.getAssetImageUrl(e);
    },
    resetSearch () {
        $abee0d548a3d974c$var$u.search = {
            listings: [],
            total: 0,
            page: 1
        };
    }
}, $abee0d548a3d974c$var$E = (0, $49umM.proxy)({
    pairingEnabled: !1,
    pairingUri: "",
    pairingError: !1
}), $abee0d548a3d974c$export$d3e2d95fafb02657 = {
    state: $abee0d548a3d974c$var$E,
    subscribe (e) {
        return (0, $49umM.subscribe)($abee0d548a3d974c$var$E, ()=>e($abee0d548a3d974c$var$E));
    },
    setPairingUri (e) {
        $abee0d548a3d974c$var$E.pairingUri = e;
    },
    setPairingError (e) {
        $abee0d548a3d974c$var$E.pairingError = e;
    },
    setPairingEnabled (e) {
        $abee0d548a3d974c$var$E.pairingEnabled = e;
    }
}, $abee0d548a3d974c$var$L = (0, $49umM.proxy)({
    open: !1
}), $abee0d548a3d974c$export$f6ef1648e6110c37 = {
    state: $abee0d548a3d974c$var$L,
    subscribe (e) {
        return (0, $49umM.subscribe)($abee0d548a3d974c$var$L, ()=>e($abee0d548a3d974c$var$L));
    },
    async open (e) {
        return new Promise((t)=>{
            const { isUiLoaded: n, isDataLoaded: s, isPreferInjected: a, selectedChain: c } = $abee0d548a3d974c$export$5f7b08e38aeeee56.state, { isConnected: d } = $abee0d548a3d974c$export$7a9b1b1b32fe2386.state, { enableNetworkView: m } = $abee0d548a3d974c$export$5239b2e4de4e2646.state;
            if ($abee0d548a3d974c$export$d3e2d95fafb02657.setPairingEnabled(!0), d || $abee0d548a3d974c$export$2ff3ceb398d6f444.removeWalletConnectDeepLink(), e != null && e.route) $abee0d548a3d974c$export$2dd8023fb2cd44c.reset(e.route);
            else if (d) $abee0d548a3d974c$export$2dd8023fb2cd44c.reset("Account");
            else if (m) $abee0d548a3d974c$export$2dd8023fb2cd44c.reset("SelectNetwork");
            else if (a) {
                $abee0d548a3d974c$export$7d2d093f32eecd30.client().connectConnector("injected", c?.id).catch((w)=>console.error(w)), t();
                return;
            } else $abee0d548a3d974c$export$2dd8023fb2cd44c.reset("ConnectWallet");
            const { pairingUri: v } = $abee0d548a3d974c$export$d3e2d95fafb02657.state;
            if (n && s && (v || d)) $abee0d548a3d974c$var$L.open = !0, t();
            else {
                const w = setInterval(()=>{
                    const A = $abee0d548a3d974c$export$5f7b08e38aeeee56.state, N = $abee0d548a3d974c$export$d3e2d95fafb02657.state;
                    A.isUiLoaded && A.isDataLoaded && (N.pairingUri || d) && (clearInterval(w), $abee0d548a3d974c$var$L.open = !0, t());
                }, 200);
            }
        });
    },
    close () {
        $abee0d548a3d974c$var$L.open = !1;
    }
};
var $abee0d548a3d974c$var$re = Object.defineProperty, $abee0d548a3d974c$var$V = Object.getOwnPropertySymbols, $abee0d548a3d974c$var$ae = Object.prototype.hasOwnProperty, $abee0d548a3d974c$var$oe = Object.prototype.propertyIsEnumerable, $abee0d548a3d974c$var$B = (e, t, n)=>t in e ? $abee0d548a3d974c$var$re(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : e[t] = n, $abee0d548a3d974c$var$ie = (e, t)=>{
    for(var n in t || (t = {}))$abee0d548a3d974c$var$ae.call(t, n) && $abee0d548a3d974c$var$B(e, n, t[n]);
    if ($abee0d548a3d974c$var$V) for (var n of $abee0d548a3d974c$var$V(t))$abee0d548a3d974c$var$oe.call(t, n) && $abee0d548a3d974c$var$B(e, n, t[n]);
    return e;
};
function $abee0d548a3d974c$var$le() {
    return typeof matchMedia < "u" && matchMedia("(prefers-color-scheme: dark)").matches;
}
const $abee0d548a3d974c$var$j = (0, $49umM.proxy)({
    themeMode: $abee0d548a3d974c$var$le() ? "dark" : "light"
}), $abee0d548a3d974c$export$fed0363cf09933ba = {
    state: $abee0d548a3d974c$var$j,
    subscribe (e) {
        return (0, $49umM.subscribe)($abee0d548a3d974c$var$j, ()=>e($abee0d548a3d974c$var$j));
    },
    setThemeConfig (e) {
        const { themeMode: t, themeVariables: n } = e;
        t && ($abee0d548a3d974c$var$j.themeMode = t), n && ($abee0d548a3d974c$var$j.themeVariables = $abee0d548a3d974c$var$ie({}, n));
    }
}, $abee0d548a3d974c$var$y = (0, $49umM.proxy)({
    open: !1,
    message: "",
    variant: "success"
}), $abee0d548a3d974c$export$49bec3d5b199c07 = {
    state: $abee0d548a3d974c$var$y,
    subscribe (e) {
        return (0, $49umM.subscribe)($abee0d548a3d974c$var$y, ()=>e($abee0d548a3d974c$var$y));
    },
    openToast (e, t) {
        $abee0d548a3d974c$var$y.open = !0, $abee0d548a3d974c$var$y.message = e, $abee0d548a3d974c$var$y.variant = t;
    },
    closeToast () {
        $abee0d548a3d974c$var$y.open = !1;
    }
};

});
parcelRegister("49umM", function(module, exports) {

$parcel$export(module.exports, "proxy", function () { return $305f8ed5a7ba8bff$export$923f96dd5afa9ce6; }, function (v) { return $305f8ed5a7ba8bff$export$923f96dd5afa9ce6 = v; });
$parcel$export(module.exports, "snapshot", function () { return $305f8ed5a7ba8bff$export$b8801ea43165ed7d; }, function (v) { return $305f8ed5a7ba8bff$export$b8801ea43165ed7d = v; });
$parcel$export(module.exports, "subscribe", function () { return $305f8ed5a7ba8bff$export$ec068583843480e7; }, function (v) { return $305f8ed5a7ba8bff$export$ec068583843480e7 = v; });
var $305f8ed5a7ba8bff$export$c506eb22e615ba4a;
var $305f8ed5a7ba8bff$export$923f96dd5afa9ce6;
var $305f8ed5a7ba8bff$export$eff4d24c3ff7876e;
var $305f8ed5a7ba8bff$export$b8801ea43165ed7d;
var $305f8ed5a7ba8bff$export$ec068583843480e7;
var $305f8ed5a7ba8bff$export$e7b04d37d9502758;
"use strict";

var $EDHxj = parcelRequire("EDHxj");
function $305f8ed5a7ba8bff$var$_extends() {
    $305f8ed5a7ba8bff$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $305f8ed5a7ba8bff$var$_extends.apply(this, arguments);
}
var $305f8ed5a7ba8bff$var$isObject = function isObject(x) {
    return typeof x === "object" && x !== null;
};
var $305f8ed5a7ba8bff$var$proxyStateMap = new WeakMap();
var $305f8ed5a7ba8bff$var$refSet = new WeakSet();
var $305f8ed5a7ba8bff$var$buildProxyFunction = function buildProxyFunction(objectIs, newProxy, canProxy, shouldTrapDefineProperty, defaultHandlePromise, snapCache, createSnapshot, proxyCache, versionHolder, _proxyFunction) {
    if (objectIs === void 0) objectIs = Object.is;
    if (newProxy === void 0) newProxy = function newProxy(target, handler) {
        return new Proxy(target, handler);
    };
    if (canProxy === void 0) canProxy = function canProxy(x) {
        return $305f8ed5a7ba8bff$var$isObject(x) && !$305f8ed5a7ba8bff$var$refSet.has(x) && (Array.isArray(x) || !(Symbol.iterator in x)) && !(x instanceof WeakMap) && !(x instanceof WeakSet) && !(x instanceof Error) && !(x instanceof Number) && !(x instanceof Date) && !(x instanceof String) && !(x instanceof RegExp) && !(x instanceof ArrayBuffer);
    };
    if (shouldTrapDefineProperty === void 0) shouldTrapDefineProperty = function shouldTrapDefineProperty(desc) {
        return desc.configurable && desc.enumerable && desc.writable;
    };
    if (defaultHandlePromise === void 0) defaultHandlePromise = function defaultHandlePromise(promise) {
        switch(promise.status){
            case "fulfilled":
                return promise.value;
            case "rejected":
                throw promise.reason;
            default:
                throw promise;
        }
    };
    if (snapCache === void 0) snapCache = new WeakMap();
    if (createSnapshot === void 0) createSnapshot = function(_createSnapshot) {
        function createSnapshot(_x, _x2, _x3) {
            return _createSnapshot.apply(this, arguments);
        }
        createSnapshot.toString = function() {
            return _createSnapshot.toString();
        };
        return createSnapshot;
    }(function(target, version, handlePromise) {
        if (handlePromise === void 0) handlePromise = defaultHandlePromise;
        var cache = snapCache.get(target);
        if ((cache == null ? void 0 : cache[0]) === version) return cache[1];
        var snap = Array.isArray(target) ? [] : Object.create(Object.getPrototypeOf(target));
        $EDHxj.markToTrack(snap, true);
        snapCache.set(target, [
            version,
            snap
        ]);
        Reflect.ownKeys(target).forEach(function(key) {
            if (Object.getOwnPropertyDescriptor(snap, key)) return;
            var value = Reflect.get(target, key);
            var desc = {
                value: value,
                enumerable: true,
                configurable: true
            };
            if ($305f8ed5a7ba8bff$var$refSet.has(value)) $EDHxj.markToTrack(value, false);
            else if (value instanceof Promise) {
                delete desc.value;
                desc.get = function() {
                    return handlePromise(value);
                };
            } else if ($305f8ed5a7ba8bff$var$proxyStateMap.has(value)) {
                var _ref = $305f8ed5a7ba8bff$var$proxyStateMap.get(value), _target = _ref[0], _ensureVersion = _ref[1];
                desc.value = createSnapshot(_target, _ensureVersion(), handlePromise);
            }
            Object.defineProperty(snap, key, desc);
        });
        return Object.preventExtensions(snap);
    });
    if (proxyCache === void 0) proxyCache = new WeakMap();
    if (versionHolder === void 0) versionHolder = [
        1,
        1
    ];
    if (_proxyFunction === void 0) _proxyFunction = function proxyFunction(initialObject) {
        if (!$305f8ed5a7ba8bff$var$isObject(initialObject)) throw new Error("object required");
        var found = proxyCache.get(initialObject);
        if (found) return found;
        var version = versionHolder[0];
        var listeners = new Set();
        var notifyUpdate = function notifyUpdate(op, nextVersion) {
            if (nextVersion === void 0) nextVersion = ++versionHolder[0];
            if (version !== nextVersion) {
                version = nextVersion;
                listeners.forEach(function(listener) {
                    return listener(op, nextVersion);
                });
            }
        };
        var checkVersion = versionHolder[1];
        var ensureVersion = function ensureVersion(nextCheckVersion) {
            if (nextCheckVersion === void 0) nextCheckVersion = ++versionHolder[1];
            if (checkVersion !== nextCheckVersion && !listeners.size) {
                checkVersion = nextCheckVersion;
                propProxyStates.forEach(function(_ref2) {
                    var propProxyState = _ref2[0];
                    var propVersion = propProxyState[1](nextCheckVersion);
                    if (propVersion > version) version = propVersion;
                });
            }
            return version;
        };
        var createPropListener = function createPropListener(prop) {
            return function(op, nextVersion) {
                var newOp = [].concat(op);
                newOp[1] = [
                    prop
                ].concat(newOp[1]);
                notifyUpdate(newOp, nextVersion);
            };
        };
        var propProxyStates = new Map();
        var addPropListener = function addPropListener(prop, propProxyState) {
            if (listeners.size) {
                var remove = propProxyState[3](createPropListener(prop));
                propProxyStates.set(prop, [
                    propProxyState,
                    remove
                ]);
            } else propProxyStates.set(prop, [
                propProxyState
            ]);
        };
        var removePropListener = function removePropListener(prop) {
            var entry = propProxyStates.get(prop);
            if (entry) {
                var _entry$;
                propProxyStates.delete(prop);
                (_entry$ = entry[1]) == null || _entry$.call(entry);
            }
        };
        var addListener = function addListener(listener) {
            listeners.add(listener);
            if (listeners.size === 1) propProxyStates.forEach(function(_ref3, prop) {
                var propProxyState = _ref3[0], prevRemove = _ref3[1];
                var remove = propProxyState[3](createPropListener(prop));
                propProxyStates.set(prop, [
                    propProxyState,
                    remove
                ]);
            });
            var removeListener = function removeListener() {
                listeners.delete(listener);
                if (listeners.size === 0) propProxyStates.forEach(function(_ref4, prop) {
                    var propProxyState = _ref4[0], remove = _ref4[1];
                    if (remove) {
                        remove();
                        propProxyStates.set(prop, [
                            propProxyState
                        ]);
                    }
                });
            };
            return removeListener;
        };
        var baseObject = Array.isArray(initialObject) ? [] : Object.create(Object.getPrototypeOf(initialObject));
        var trapSet = function trapSet(hasPrevValue, prevValue, prop, value, setValue) {
            if (hasPrevValue && (objectIs(prevValue, value) || proxyCache.has(value) && objectIs(prevValue, proxyCache.get(value)))) return;
            removePropListener(prop);
            if ($305f8ed5a7ba8bff$var$isObject(value)) value = $EDHxj.getUntracked(value) || value;
            var nextValue = value;
            if (value instanceof Promise) value.then(function(v) {
                value.status = "fulfilled";
                value.value = v;
                notifyUpdate([
                    "resolve",
                    [
                        prop
                    ],
                    v
                ]);
            }).catch(function(e) {
                value.status = "rejected";
                value.reason = e;
                notifyUpdate([
                    "reject",
                    [
                        prop
                    ],
                    e
                ]);
            });
            else {
                if (!$305f8ed5a7ba8bff$var$proxyStateMap.has(value) && canProxy(value)) nextValue = _proxyFunction(value);
                var childProxyState = !$305f8ed5a7ba8bff$var$refSet.has(nextValue) && $305f8ed5a7ba8bff$var$proxyStateMap.get(nextValue);
                if (childProxyState) addPropListener(prop, childProxyState);
            }
            setValue(nextValue);
            notifyUpdate([
                "set",
                [
                    prop
                ],
                value,
                prevValue
            ]);
        };
        var handler = {
            deleteProperty: function deleteProperty(target, prop) {
                var prevValue = Reflect.get(target, prop);
                removePropListener(prop);
                var deleted = Reflect.deleteProperty(target, prop);
                if (deleted) notifyUpdate([
                    "delete",
                    [
                        prop
                    ],
                    prevValue
                ]);
                return deleted;
            },
            set: function set(target, prop, value, receiver) {
                var hasPrevValue = Reflect.has(target, prop);
                var prevValue = Reflect.get(target, prop, receiver);
                trapSet(hasPrevValue, prevValue, prop, value, function(nextValue) {
                    Reflect.set(target, prop, nextValue, receiver);
                });
                return true;
            },
            defineProperty: function defineProperty(target, prop, desc) {
                if (shouldTrapDefineProperty(desc)) {
                    var prevDesc = Reflect.getOwnPropertyDescriptor(target, prop);
                    if (!prevDesc || shouldTrapDefineProperty(prevDesc)) {
                        trapSet(!!prevDesc && "value" in prevDesc, prevDesc == null ? void 0 : prevDesc.value, prop, desc.value, function(nextValue) {
                            Reflect.defineProperty(target, prop, $305f8ed5a7ba8bff$var$_extends({}, desc, {
                                value: nextValue
                            }));
                        });
                        return true;
                    }
                }
                return Reflect.defineProperty(target, prop, desc);
            }
        };
        var proxyObject = newProxy(baseObject, handler);
        proxyCache.set(initialObject, proxyObject);
        var proxyState = [
            baseObject,
            ensureVersion,
            createSnapshot,
            addListener
        ];
        $305f8ed5a7ba8bff$var$proxyStateMap.set(proxyObject, proxyState);
        Reflect.ownKeys(initialObject).forEach(function(key) {
            var desc = Object.getOwnPropertyDescriptor(initialObject, key);
            if ("value" in desc) {
                proxyObject[key] = initialObject[key];
                delete desc.value;
                delete desc.writable;
            }
            Object.defineProperty(baseObject, key, desc);
        });
        return proxyObject;
    };
    return [
        _proxyFunction,
        $305f8ed5a7ba8bff$var$proxyStateMap,
        $305f8ed5a7ba8bff$var$refSet,
        objectIs,
        newProxy,
        canProxy,
        shouldTrapDefineProperty,
        defaultHandlePromise,
        snapCache,
        createSnapshot,
        proxyCache,
        versionHolder
    ];
};
var $305f8ed5a7ba8bff$var$_buildProxyFunction = $305f8ed5a7ba8bff$var$buildProxyFunction(), $305f8ed5a7ba8bff$var$defaultProxyFunction = $305f8ed5a7ba8bff$var$_buildProxyFunction[0];
function $305f8ed5a7ba8bff$var$proxy(initialObject) {
    if (initialObject === void 0) initialObject = {};
    return $305f8ed5a7ba8bff$var$defaultProxyFunction(initialObject);
}
function $305f8ed5a7ba8bff$var$getVersion(proxyObject) {
    var proxyState = $305f8ed5a7ba8bff$var$proxyStateMap.get(proxyObject);
    return proxyState == null ? void 0 : proxyState[1]();
}
function $305f8ed5a7ba8bff$var$subscribe(proxyObject, callback, notifyInSync) {
    var proxyState = $305f8ed5a7ba8bff$var$proxyStateMap.get(proxyObject);
    var promise;
    var ops = [];
    var addListener = proxyState[3];
    var isListenerActive = false;
    var listener = function listener(op) {
        ops.push(op);
        if (notifyInSync) {
            callback(ops.splice(0));
            return;
        }
        if (!promise) promise = Promise.resolve().then(function() {
            promise = undefined;
            if (isListenerActive) callback(ops.splice(0));
        });
    };
    var removeListener = addListener(listener);
    isListenerActive = true;
    return function() {
        isListenerActive = false;
        removeListener();
    };
}
function $305f8ed5a7ba8bff$var$snapshot(proxyObject, handlePromise) {
    var proxyState = $305f8ed5a7ba8bff$var$proxyStateMap.get(proxyObject);
    var _ref5 = proxyState, target = _ref5[0], ensureVersion = _ref5[1], createSnapshot = _ref5[2];
    return createSnapshot(target, ensureVersion(), handlePromise);
}
function $305f8ed5a7ba8bff$var$ref(obj) {
    $305f8ed5a7ba8bff$var$refSet.add(obj);
    return obj;
}
var $305f8ed5a7ba8bff$var$unstable_buildProxyFunction = $305f8ed5a7ba8bff$var$buildProxyFunction;
$305f8ed5a7ba8bff$export$c506eb22e615ba4a = $305f8ed5a7ba8bff$var$getVersion;
$305f8ed5a7ba8bff$export$923f96dd5afa9ce6 = $305f8ed5a7ba8bff$var$proxy;
$305f8ed5a7ba8bff$export$eff4d24c3ff7876e = $305f8ed5a7ba8bff$var$ref;
$305f8ed5a7ba8bff$export$b8801ea43165ed7d = $305f8ed5a7ba8bff$var$snapshot;
$305f8ed5a7ba8bff$export$ec068583843480e7 = $305f8ed5a7ba8bff$var$subscribe;
$305f8ed5a7ba8bff$export$e7b04d37d9502758 = $305f8ed5a7ba8bff$var$unstable_buildProxyFunction;

});
parcelRegister("EDHxj", function(module, exports) {

$parcel$export(module.exports, "getUntracked", function () { return $07a2885f6f28e2ce$export$80d2cee7ee556e99; });
$parcel$export(module.exports, "markToTrack", function () { return $07a2885f6f28e2ce$export$2c8383c890e26a1c; });
const $07a2885f6f28e2ce$var$e = Symbol(), $07a2885f6f28e2ce$var$t = Symbol(), $07a2885f6f28e2ce$var$r = "a", $07a2885f6f28e2ce$var$n = "w";
let $07a2885f6f28e2ce$var$o = (e, t)=>new Proxy(e, t);
const $07a2885f6f28e2ce$var$s = Object.getPrototypeOf, $07a2885f6f28e2ce$var$c = new WeakMap, $07a2885f6f28e2ce$var$l = (e)=>e && ($07a2885f6f28e2ce$var$c.has(e) ? $07a2885f6f28e2ce$var$c.get(e) : $07a2885f6f28e2ce$var$s(e) === Object.prototype || $07a2885f6f28e2ce$var$s(e) === Array.prototype), $07a2885f6f28e2ce$var$f = (e)=>"object" == typeof e && null !== e, $07a2885f6f28e2ce$var$i = (e)=>{
    if (Array.isArray(e)) return Array.from(e);
    const t = Object.getOwnPropertyDescriptors(e);
    return Object.values(t).forEach((e)=>{
        e.configurable = !0;
    }), Object.create($07a2885f6f28e2ce$var$s(e), t);
}, $07a2885f6f28e2ce$var$u = (e)=>e[$07a2885f6f28e2ce$var$t] || e, $07a2885f6f28e2ce$export$7865d0c7f908de6b = (s, c, f, p)=>{
    if (!$07a2885f6f28e2ce$var$l(s)) return s;
    let g = p && p.get(s);
    if (!g) {
        const e = $07a2885f6f28e2ce$var$u(s);
        g = ((e)=>Object.values(Object.getOwnPropertyDescriptors(e)).some((e)=>!e.configurable && !e.writable))(e) ? [
            e,
            $07a2885f6f28e2ce$var$i(e)
        ] : [
            e
        ], null == p || p.set(s, g);
    }
    const [y, h] = g;
    let w = f && f.get(y);
    return w && w[1].f === !!h || (w = ((o, s)=>{
        const c = {
            f: s
        };
        let l = !1;
        const f = (e, t)=>{
            if (!l) {
                let s = c[$07a2885f6f28e2ce$var$r].get(o);
                if (s || (s = {}, c[$07a2885f6f28e2ce$var$r].set(o, s)), e === $07a2885f6f28e2ce$var$n) s[$07a2885f6f28e2ce$var$n] = !0;
                else {
                    let r = s[e];
                    r || (r = new Set, s[e] = r), r.add(t);
                }
            }
        }, i = {
            get: (e, n)=>n === $07a2885f6f28e2ce$var$t ? o : (f("k", n), $07a2885f6f28e2ce$export$7865d0c7f908de6b(Reflect.get(e, n), c[$07a2885f6f28e2ce$var$r], c.c, c.t)),
            has: (t, n)=>n === $07a2885f6f28e2ce$var$e ? (l = !0, c[$07a2885f6f28e2ce$var$r].delete(o), !0) : (f("h", n), Reflect.has(t, n)),
            getOwnPropertyDescriptor: (e, t)=>(f("o", t), Reflect.getOwnPropertyDescriptor(e, t)),
            ownKeys: (e)=>(f($07a2885f6f28e2ce$var$n), Reflect.ownKeys(e))
        };
        return s && (i.set = i.deleteProperty = ()=>!1), [
            i,
            c
        ];
    })(y, !!h), w[1].p = $07a2885f6f28e2ce$var$o(h || y, w[0]), f && f.set(y, w)), w[1][$07a2885f6f28e2ce$var$r] = c, w[1].c = f, w[1].t = p, w[1].p;
}, $07a2885f6f28e2ce$export$3a85b3f4caf02b6f = (e, t, r, o)=>{
    if (Object.is(e, t)) return !1;
    if (!$07a2885f6f28e2ce$var$f(e) || !$07a2885f6f28e2ce$var$f(t)) return !0;
    const s = r.get($07a2885f6f28e2ce$var$u(e));
    if (!s) return !0;
    if (o) {
        const r = o.get(e);
        if (r && r.n === t) return r.g;
        o.set(e, {
            n: t,
            g: !1
        });
    }
    let c = null;
    try {
        for (const r of s.h || [])if (c = Reflect.has(e, r) !== Reflect.has(t, r), c) return c;
        if (!0 === s[$07a2885f6f28e2ce$var$n]) {
            if (c = ((e, t)=>{
                const r = Reflect.ownKeys(e), n = Reflect.ownKeys(t);
                return r.length !== n.length || r.some((e, t)=>e !== n[t]);
            })(e, t), c) return c;
        } else for (const r of s.o || [])if (c = !!Reflect.getOwnPropertyDescriptor(e, r) != !!Reflect.getOwnPropertyDescriptor(t, r), c) return c;
        for (const n of s.k || [])if (c = $07a2885f6f28e2ce$export$3a85b3f4caf02b6f(e[n], t[n], r, o), c) return c;
        return null === c && (c = !0), c;
    } finally{
        o && o.set(e, {
            n: t,
            g: c
        });
    }
}, $07a2885f6f28e2ce$export$badc26589cf7bb38 = (t)=>!!$07a2885f6f28e2ce$var$l(t) && $07a2885f6f28e2ce$var$e in t, $07a2885f6f28e2ce$export$80d2cee7ee556e99 = (e)=>$07a2885f6f28e2ce$var$l(e) && e[$07a2885f6f28e2ce$var$t] || null, $07a2885f6f28e2ce$export$2c8383c890e26a1c = (e, t = !0)=>{
    $07a2885f6f28e2ce$var$c.set(e, t);
}, $07a2885f6f28e2ce$export$10e85fc10e680a16 = (e, t, r)=>{
    const o = [], s = new WeakSet, c = (e, l)=>{
        if (s.has(e)) return;
        $07a2885f6f28e2ce$var$f(e) && s.add(e);
        const i = $07a2885f6f28e2ce$var$f(e) && t.get($07a2885f6f28e2ce$var$u(e));
        if (i) {
            var a, p;
            if (null == (a = i.h) || a.forEach((e)=>{
                const t = `:has(${String(e)})`;
                o.push(l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            }), !0 === i[$07a2885f6f28e2ce$var$n]) {
                const e = ":ownKeys";
                o.push(l ? [
                    ...l,
                    e
                ] : [
                    e
                ]);
            } else {
                var g;
                null == (g = i.o) || g.forEach((e)=>{
                    const t = `:hasOwn(${String(e)})`;
                    o.push(l ? [
                        ...l,
                        t
                    ] : [
                        t
                    ]);
                });
            }
            null == (p = i.k) || p.forEach((t)=>{
                r && !("value" in (Object.getOwnPropertyDescriptor(e, t) || {})) || c(e[t], l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            });
        } else l && o.push(l);
    };
    return c(e), o;
}, $07a2885f6f28e2ce$export$9b4d5450dbd8e67e = (e)=>{
    $07a2885f6f28e2ce$var$o = e;
};

});



parcelRegister("geKiF", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("cKPUe"))((parcelRequire("jwisd")).resolve("emskj")),
    (parcelRequire("cKPUe"))((parcelRequire("jwisd")).resolve("hfPUx"))
]).then(()=>parcelRequire("6Xe3r"));

});

parcelRegister("cK8E4", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $94707cb5155c7208$export$306c0aa65ff9ec16; }, function (v) { return $94707cb5155c7208$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $94707cb5155c7208$export$306c0aa65ff9ec16;
"use strict";

var $9nZCP = parcelRequire("9nZCP");
function $94707cb5155c7208$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $94707cb5155c7208$var$k = "function" === typeof Object.is ? Object.is : $94707cb5155c7208$var$h, $94707cb5155c7208$var$l = $9nZCP.useState, $94707cb5155c7208$var$m = $9nZCP.useEffect, $94707cb5155c7208$var$n = $9nZCP.useLayoutEffect, $94707cb5155c7208$var$p = $9nZCP.useDebugValue;
function $94707cb5155c7208$var$q(a, b) {
    var d = b(), f = $94707cb5155c7208$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $94707cb5155c7208$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $94707cb5155c7208$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $94707cb5155c7208$var$m(function() {
        $94707cb5155c7208$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $94707cb5155c7208$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $94707cb5155c7208$var$p(d);
    return d;
}
function $94707cb5155c7208$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$94707cb5155c7208$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $94707cb5155c7208$var$t(a, b) {
    return b();
}
var $94707cb5155c7208$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $94707cb5155c7208$var$t : $94707cb5155c7208$var$q;
$94707cb5155c7208$export$306c0aa65ff9ec16 = void 0 !== $9nZCP.useSyncExternalStore ? $9nZCP.useSyncExternalStore : $94707cb5155c7208$var$u;

});

parcelRegister("ld1vO", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $f70bfc224f69dbca$export$bf730a2d8bf68b42; }, function (v) { return $f70bfc224f69dbca$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f70bfc224f69dbca$export$bf730a2d8bf68b42;
"use strict";

var $9nZCP = parcelRequire("9nZCP");

var $fathW = parcelRequire("fathW");
function $f70bfc224f69dbca$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $f70bfc224f69dbca$var$q = "function" === typeof Object.is ? Object.is : $f70bfc224f69dbca$var$p, $f70bfc224f69dbca$var$r = $fathW.useSyncExternalStore, $f70bfc224f69dbca$var$t = $9nZCP.useRef, $f70bfc224f69dbca$var$u = $9nZCP.useEffect, $f70bfc224f69dbca$var$v = $9nZCP.useMemo, $f70bfc224f69dbca$var$w = $9nZCP.useDebugValue;
$f70bfc224f69dbca$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $f70bfc224f69dbca$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $f70bfc224f69dbca$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($f70bfc224f69dbca$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $f70bfc224f69dbca$var$r(a, c[0], c[1]);
    $f70bfc224f69dbca$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $f70bfc224f69dbca$var$w(d);
    return d;
};

});
parcelRegister("fathW", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cK8E4"));

});


parcelRegister("3bLDg", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $252758f1bfeb9310$export$a7c73072b1a182ae; }, function (v) { return $252758f1bfeb9310$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $252758f1bfeb9310$export$9f27bc3417b4524d; }, function (v) { return $252758f1bfeb9310$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $252758f1bfeb9310$export$db77ccec0bb4ccac; }, function (v) { return $252758f1bfeb9310$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $252758f1bfeb9310$export$8392c0c9d3dcbd35; }, function (v) { return $252758f1bfeb9310$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $252758f1bfeb9310$export$ffb0004e005737fa; }, function (v) { return $252758f1bfeb9310$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $252758f1bfeb9310$export$b624eff549462981; }, function (v) { return $252758f1bfeb9310$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $252758f1bfeb9310$export$7897aa7841a5380c; }, function (v) { return $252758f1bfeb9310$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $252758f1bfeb9310$export$602eac185826482c; }, function (v) { return $252758f1bfeb9310$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $252758f1bfeb9310$export$e2c29f18771995cb; }, function (v) { return $252758f1bfeb9310$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $252758f1bfeb9310$export$5f8d39834fd61797; }, function (v) { return $252758f1bfeb9310$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $252758f1bfeb9310$export$74bf444e3cd11ea5; }, function (v) { return $252758f1bfeb9310$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $252758f1bfeb9310$export$998bcd577473dd93; }, function (v) { return $252758f1bfeb9310$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $252758f1bfeb9310$export$92387174baf9b227; }, function (v) { return $252758f1bfeb9310$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $252758f1bfeb9310$export$ec112efeb987d9c6; }, function (v) { return $252758f1bfeb9310$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $252758f1bfeb9310$export$b706b080d889d2c9; }, function (v) { return $252758f1bfeb9310$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $252758f1bfeb9310$export$5be5a87408f70ddc; }, function (v) { return $252758f1bfeb9310$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $252758f1bfeb9310$export$45a5e7f76e0caa8d; }, function (v) { return $252758f1bfeb9310$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $252758f1bfeb9310$export$455c2e768291efa6; }, function (v) { return $252758f1bfeb9310$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $252758f1bfeb9310$export$9522e17588c12572; }, function (v) { return $252758f1bfeb9310$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $252758f1bfeb9310$export$2110ac352bb060b9; }, function (v) { return $252758f1bfeb9310$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $252758f1bfeb9310$export$56885ab8b9c456ab; }, function (v) { return $252758f1bfeb9310$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $252758f1bfeb9310$export$d927fcb6adf8f9de; }, function (v) { return $252758f1bfeb9310$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $252758f1bfeb9310$export$b82d16f27459e05a; }, function (v) { return $252758f1bfeb9310$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $252758f1bfeb9310$export$522c17b4f5e123e8; }, function (v) { return $252758f1bfeb9310$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $252758f1bfeb9310$export$1aabd8a0274ecfd6; }, function (v) { return $252758f1bfeb9310$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $252758f1bfeb9310$export$3d6c20d97e46b957; }, function (v) { return $252758f1bfeb9310$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $252758f1bfeb9310$export$9b621391a187a31a; }, function (v) { return $252758f1bfeb9310$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $252758f1bfeb9310$export$f5bbd400c2f4426f; }, function (v) { return $252758f1bfeb9310$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $252758f1bfeb9310$export$a7c73072b1a182ae;
var $252758f1bfeb9310$export$9f27bc3417b4524d;
var $252758f1bfeb9310$export$db77ccec0bb4ccac;
var $252758f1bfeb9310$export$8392c0c9d3dcbd35;
var $252758f1bfeb9310$export$ffb0004e005737fa;
var $252758f1bfeb9310$export$b624eff549462981;
var $252758f1bfeb9310$export$7897aa7841a5380c;
var $252758f1bfeb9310$export$602eac185826482c;
var $252758f1bfeb9310$export$e2c29f18771995cb;
var $252758f1bfeb9310$export$5f8d39834fd61797;
var $252758f1bfeb9310$export$74bf444e3cd11ea5;
var $252758f1bfeb9310$export$998bcd577473dd93;
var $252758f1bfeb9310$export$92387174baf9b227;
var $252758f1bfeb9310$export$ec112efeb987d9c6;
var $252758f1bfeb9310$export$b706b080d889d2c9;
var $252758f1bfeb9310$export$5be5a87408f70ddc;
var $252758f1bfeb9310$export$45a5e7f76e0caa8d;
var $252758f1bfeb9310$export$455c2e768291efa6;
var $252758f1bfeb9310$export$9522e17588c12572;
var $252758f1bfeb9310$export$2110ac352bb060b9;
var $252758f1bfeb9310$export$56885ab8b9c456ab;
var $252758f1bfeb9310$export$d927fcb6adf8f9de;
var $252758f1bfeb9310$export$b82d16f27459e05a;
var $252758f1bfeb9310$export$522c17b4f5e123e8;
var $252758f1bfeb9310$export$1aabd8a0274ecfd6;
var $252758f1bfeb9310$export$3d6c20d97e46b957;
var $252758f1bfeb9310$export$9b621391a187a31a;
var $252758f1bfeb9310$export$f5bbd400c2f4426f;
"use strict";
var $252758f1bfeb9310$var$b = Symbol.for("react.element"), $252758f1bfeb9310$var$c = Symbol.for("react.portal"), $252758f1bfeb9310$var$d = Symbol.for("react.fragment"), $252758f1bfeb9310$var$e = Symbol.for("react.strict_mode"), $252758f1bfeb9310$var$f = Symbol.for("react.profiler"), $252758f1bfeb9310$var$g = Symbol.for("react.provider"), $252758f1bfeb9310$var$h = Symbol.for("react.context"), $252758f1bfeb9310$var$k = Symbol.for("react.server_context"), $252758f1bfeb9310$var$l = Symbol.for("react.forward_ref"), $252758f1bfeb9310$var$m = Symbol.for("react.suspense"), $252758f1bfeb9310$var$n = Symbol.for("react.suspense_list"), $252758f1bfeb9310$var$p = Symbol.for("react.memo"), $252758f1bfeb9310$var$q = Symbol.for("react.lazy"), $252758f1bfeb9310$var$t = Symbol.for("react.offscreen"), $252758f1bfeb9310$var$u;
$252758f1bfeb9310$var$u = Symbol.for("react.module.reference");
function $252758f1bfeb9310$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $252758f1bfeb9310$var$b:
                switch(a = a.type, a){
                    case $252758f1bfeb9310$var$d:
                    case $252758f1bfeb9310$var$f:
                    case $252758f1bfeb9310$var$e:
                    case $252758f1bfeb9310$var$m:
                    case $252758f1bfeb9310$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $252758f1bfeb9310$var$k:
                            case $252758f1bfeb9310$var$h:
                            case $252758f1bfeb9310$var$l:
                            case $252758f1bfeb9310$var$q:
                            case $252758f1bfeb9310$var$p:
                            case $252758f1bfeb9310$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $252758f1bfeb9310$var$c:
                return r;
        }
    }
}
$252758f1bfeb9310$export$a7c73072b1a182ae = $252758f1bfeb9310$var$h;
$252758f1bfeb9310$export$9f27bc3417b4524d = $252758f1bfeb9310$var$g;
$252758f1bfeb9310$export$db77ccec0bb4ccac = $252758f1bfeb9310$var$b;
$252758f1bfeb9310$export$8392c0c9d3dcbd35 = $252758f1bfeb9310$var$l;
$252758f1bfeb9310$export$ffb0004e005737fa = $252758f1bfeb9310$var$d;
$252758f1bfeb9310$export$b624eff549462981 = $252758f1bfeb9310$var$q;
$252758f1bfeb9310$export$7897aa7841a5380c = $252758f1bfeb9310$var$p;
$252758f1bfeb9310$export$602eac185826482c = $252758f1bfeb9310$var$c;
$252758f1bfeb9310$export$e2c29f18771995cb = $252758f1bfeb9310$var$f;
$252758f1bfeb9310$export$5f8d39834fd61797 = $252758f1bfeb9310$var$e;
$252758f1bfeb9310$export$74bf444e3cd11ea5 = $252758f1bfeb9310$var$m;
$252758f1bfeb9310$export$998bcd577473dd93 = $252758f1bfeb9310$var$n;
$252758f1bfeb9310$export$92387174baf9b227 = function() {
    return !1;
};
$252758f1bfeb9310$export$ec112efeb987d9c6 = function() {
    return !1;
};
$252758f1bfeb9310$export$b706b080d889d2c9 = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$h;
};
$252758f1bfeb9310$export$5be5a87408f70ddc = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$g;
};
$252758f1bfeb9310$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $252758f1bfeb9310$var$b;
};
$252758f1bfeb9310$export$455c2e768291efa6 = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$l;
};
$252758f1bfeb9310$export$9522e17588c12572 = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$d;
};
$252758f1bfeb9310$export$2110ac352bb060b9 = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$q;
};
$252758f1bfeb9310$export$56885ab8b9c456ab = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$p;
};
$252758f1bfeb9310$export$d927fcb6adf8f9de = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$c;
};
$252758f1bfeb9310$export$b82d16f27459e05a = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$f;
};
$252758f1bfeb9310$export$522c17b4f5e123e8 = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$e;
};
$252758f1bfeb9310$export$1aabd8a0274ecfd6 = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$m;
};
$252758f1bfeb9310$export$3d6c20d97e46b957 = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$n;
};
$252758f1bfeb9310$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $252758f1bfeb9310$var$d || a === $252758f1bfeb9310$var$f || a === $252758f1bfeb9310$var$e || a === $252758f1bfeb9310$var$m || a === $252758f1bfeb9310$var$n || a === $252758f1bfeb9310$var$t || "object" === typeof a && null !== a && (a.$$typeof === $252758f1bfeb9310$var$q || a.$$typeof === $252758f1bfeb9310$var$p || a.$$typeof === $252758f1bfeb9310$var$g || a.$$typeof === $252758f1bfeb9310$var$h || a.$$typeof === $252758f1bfeb9310$var$l || a.$$typeof === $252758f1bfeb9310$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$252758f1bfeb9310$export$f5bbd400c2f4426f = $252758f1bfeb9310$var$v;

});

parcelRegister("hFdkQ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $2VFtY = parcelRequire("2VFtY");
function $cdc09c1de74df641$var$emptyFunction() {}
function $cdc09c1de74df641$var$emptyFunctionWithReset() {}
$cdc09c1de74df641$var$emptyFunctionWithReset.resetWarningCache = $cdc09c1de74df641$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $2VFtY) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cdc09c1de74df641$var$emptyFunctionWithReset,
        resetWarningCache: $cdc09c1de74df641$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("2VFtY", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $22211530d000fb5c$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $22211530d000fb5c$var$ReactPropTypesSecret;

});


parcelRegister("a141p", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("k7M45", function(module, exports) {
"use strict";
var $ea69becd2fee5391$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ea69becd2fee5391$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ea69becd2fee5391$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ea69becd2fee5391$var$__createBinding(result, mod, k);
    }
    $ea69becd2fee5391$var$__setModuleDefault(result, mod);
    return result;
};
var $ea69becd2fee5391$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SiweMessage = void 0;

var $11jMC = parcelRequire("11jMC");

const $ea69becd2fee5391$var$uri = $ea69becd2fee5391$var$__importStar((parcelRequire("k09Qs")));

var $jGqzU = parcelRequire("jGqzU");

var $brXJH = parcelRequire("brXJH");

var $eiyYC = parcelRequire("eiyYC");
class $ea69becd2fee5391$var$SiweMessage {
    /**
     * Creates a parsed Sign-In with Ethereum Message (EIP-4361) object from a
     * string or an object. If a string is used an ABNF parser is called to
     * validate the parameter, otherwise the fields are attributed.
     * @param param {string | SiweMessage} Sign message as a string or an object.
     */ constructor(param){
        if (typeof param === "string") {
            const parsedMessage = new $11jMC.ParsedMessage(param);
            this.scheme = parsedMessage.scheme;
            this.domain = parsedMessage.domain;
            this.address = parsedMessage.address;
            this.statement = parsedMessage.statement;
            this.uri = parsedMessage.uri;
            this.version = parsedMessage.version;
            this.nonce = parsedMessage.nonce;
            this.issuedAt = parsedMessage.issuedAt;
            this.expirationTime = parsedMessage.expirationTime;
            this.notBefore = parsedMessage.notBefore;
            this.requestId = parsedMessage.requestId;
            this.chainId = parsedMessage.chainId;
            this.resources = parsedMessage.resources;
        } else {
            this.scheme = param === null || param === void 0 ? void 0 : param.scheme;
            this.domain = param.domain;
            this.address = param.address;
            this.statement = param === null || param === void 0 ? void 0 : param.statement;
            this.uri = param.uri;
            this.version = param.version;
            this.chainId = param.chainId;
            this.nonce = param.nonce;
            this.issuedAt = param === null || param === void 0 ? void 0 : param.issuedAt;
            this.expirationTime = param === null || param === void 0 ? void 0 : param.expirationTime;
            this.notBefore = param === null || param === void 0 ? void 0 : param.notBefore;
            this.requestId = param === null || param === void 0 ? void 0 : param.requestId;
            this.resources = param === null || param === void 0 ? void 0 : param.resources;
            if (typeof this.chainId === "string") this.chainId = (0, $11jMC.parseIntegerNumber)(this.chainId);
        }
        this.nonce = this.nonce || (0, $eiyYC.generateNonce)();
        this.validateMessage();
    }
    /**
     * This function can be used to retrieve an EIP-4361 formated message for
     * signature, although you can call it directly it's advised to use
     * [prepareMessage()] instead which will resolve to the correct method based
     * on the [type] attribute of this object, in case of other formats being
     * implemented.
     * @returns {string} EIP-4361 formated message, ready for EIP-191 signing.
     */ toMessage() {
        /** Validates all fields of the object */ this.validateMessage();
        const headerPrefx = this.scheme ? `${this.scheme}://${this.domain}` : this.domain;
        const header = `${headerPrefx} wants you to sign in with your Ethereum account:`;
        const uriField = `URI: ${this.uri}`;
        let prefix = [
            header,
            this.address
        ].join("\n");
        const versionField = `Version: ${this.version}`;
        if (!this.nonce) this.nonce = (0, $eiyYC.generateNonce)();
        const chainField = `Chain ID: ` + this.chainId || "1";
        const nonceField = `Nonce: ${this.nonce}`;
        const suffixArray = [
            uriField,
            versionField,
            chainField,
            nonceField
        ];
        this.issuedAt = this.issuedAt || new Date().toISOString();
        suffixArray.push(`Issued At: ${this.issuedAt}`);
        if (this.expirationTime) {
            const expiryField = `Expiration Time: ${this.expirationTime}`;
            suffixArray.push(expiryField);
        }
        if (this.notBefore) suffixArray.push(`Not Before: ${this.notBefore}`);
        if (this.requestId) suffixArray.push(`Request ID: ${this.requestId}`);
        if (this.resources) suffixArray.push([
            `Resources:`,
            ...this.resources.map((x)=>`- ${x}`)
        ].join("\n"));
        const suffix = suffixArray.join("\n");
        prefix = [
            prefix,
            this.statement
        ].join("\n\n");
        if (this.statement) prefix += "\n";
        return [
            prefix,
            suffix
        ].join("\n");
    }
    /**
     * This method parses all the fields in the object and creates a messaging for signing
     * message according with the type defined.
     * @returns {string} Returns a message ready to be signed according with the
     * type defined in the object.
     */ prepareMessage() {
        let message;
        switch(this.version){
            case "1":
                message = this.toMessage();
                break;
            default:
                message = this.toMessage();
                break;
        }
        return message;
    }
    /**
     * @deprecated
     * Verifies the integrity of the object by matching its signature.
     * @param signature Signature to match the address in the message.
     * @param provider Ethers provider to be used for EIP-1271 validation
     */ validate(signature, provider) {
        return $ea69becd2fee5391$var$__awaiter(this, void 0, void 0, function*() {
            console.warn("validate() has been deprecated, please update your code to use verify(). validate() may be removed in future versions.");
            return this.verify({
                signature: signature
            }, {
                provider: provider,
                suppressExceptions: false
            }).then(({ data: data })=>data).catch(({ error: error })=>{
                throw error;
            });
        });
    }
    /**
     * Verifies the integrity of the object by matching its signature.
     * @param params Parameters to verify the integrity of the message, signature is required.
     * @returns {Promise<SiweMessage>} This object if valid.
     */ verify(params, opts = {
        suppressExceptions: false
    }) {
        return $ea69becd2fee5391$var$__awaiter(this, void 0, void 0, function*() {
            return new Promise((resolve, reject)=>{
                var _a, _b, _c;
                const fail = (result)=>{
                    if (opts.suppressExceptions) return resolve(result);
                    else return reject(result);
                };
                const invalidParams = (0, $eiyYC.checkInvalidKeys)(params, $brXJH.VerifyParamsKeys);
                if (invalidParams.length > 0) fail({
                    success: false,
                    data: this,
                    error: new Error(`${invalidParams.join(", ")} is/are not valid key(s) for VerifyParams.`)
                });
                const invalidOpts = (0, $eiyYC.checkInvalidKeys)(opts, $brXJH.VerifyOptsKeys);
                if (invalidParams.length > 0) fail({
                    success: false,
                    data: this,
                    error: new Error(`${invalidOpts.join(", ")} is/are not valid key(s) for VerifyOpts.`)
                });
                const { signature: signature, scheme: scheme, domain: domain, nonce: nonce, time: time } = params;
                /** Scheme for domain binding */ if (scheme && scheme !== this.scheme) fail({
                    success: false,
                    data: this,
                    error: new $brXJH.SiweError($brXJH.SiweErrorType.SCHEME_MISMATCH, scheme, this.scheme)
                });
                /** Domain binding */ if (domain && domain !== this.domain) fail({
                    success: false,
                    data: this,
                    error: new $brXJH.SiweError($brXJH.SiweErrorType.DOMAIN_MISMATCH, domain, this.domain)
                });
                /** Nonce binding */ if (nonce && nonce !== this.nonce) fail({
                    success: false,
                    data: this,
                    error: new $brXJH.SiweError($brXJH.SiweErrorType.NONCE_MISMATCH, nonce, this.nonce)
                });
                /** Check time or now */ const checkTime = new Date(time || new Date());
                /** Message not expired */ if (this.expirationTime) {
                    const expirationDate = new Date(this.expirationTime);
                    if (checkTime.getTime() >= expirationDate.getTime()) fail({
                        success: false,
                        data: this,
                        error: new $brXJH.SiweError($brXJH.SiweErrorType.EXPIRED_MESSAGE, `${checkTime.toISOString()} < ${expirationDate.toISOString()}`, `${checkTime.toISOString()} >= ${expirationDate.toISOString()}`)
                    });
                }
                /** Message is valid already */ if (this.notBefore) {
                    const notBefore = new Date(this.notBefore);
                    if (checkTime.getTime() < notBefore.getTime()) fail({
                        success: false,
                        data: this,
                        error: new $brXJH.SiweError($brXJH.SiweErrorType.NOT_YET_VALID_MESSAGE, `${checkTime.toISOString()} >= ${notBefore.toISOString()}`, `${checkTime.toISOString()} < ${notBefore.toISOString()}`)
                    });
                }
                let EIP4361Message;
                try {
                    EIP4361Message = this.prepareMessage();
                } catch (e) {
                    fail({
                        success: false,
                        data: this,
                        error: e
                    });
                }
                /** Recover address from signature */ let addr;
                try {
                    addr = (0, $jGqzU.verifyMessage)(EIP4361Message, signature);
                } catch (e) {
                    console.error(e);
                }
                /** Match signature with message's address */ if (addr === this.address) return resolve({
                    success: true,
                    data: this
                });
                else {
                    const EIP1271Promise = (0, $eiyYC.checkContractWalletSignature)(this, signature, opts.provider).then((isValid)=>{
                        if (!isValid) return {
                            success: false,
                            data: this,
                            error: new $brXJH.SiweError($brXJH.SiweErrorType.INVALID_SIGNATURE, addr, `Resolved address to be ${this.address}`)
                        };
                        return {
                            success: true,
                            data: this
                        };
                    }).catch((error)=>{
                        return {
                            success: false,
                            data: this,
                            error: error
                        };
                    });
                    Promise.all([
                        EIP1271Promise,
                        (_c = (_b = (_a = opts === null || opts === void 0 ? void 0 : opts.verificationFallback) === null || _a === void 0 ? void 0 : _a.call(opts, params, opts, this, EIP1271Promise)) === null || _b === void 0 ? void 0 : _b.then((res)=>res)) === null || _c === void 0 ? void 0 : _c.catch((res)=>res)
                    ]).then(([EIP1271Response, fallbackResponse])=>{
                        if (fallbackResponse) {
                            if (fallbackResponse.success) return resolve(fallbackResponse);
                            else fail(fallbackResponse);
                        } else {
                            if (EIP1271Response.success) return resolve(EIP1271Response);
                            else fail(EIP1271Response);
                        }
                    });
                }
            });
        });
    }
    /**
     * Validates the values of this object fields.
     * @throws Throws an {ErrorType} if a field is invalid.
     */ validateMessage(...args) {
        var _a;
        /** Checks if the user might be using the function to verify instead of validate. */ if (args.length > 0) throw new $brXJH.SiweError($brXJH.SiweErrorType.UNABLE_TO_PARSE, `Unexpected argument in the validateMessage function.`);
        /** `domain` check. */ if (!this.domain || this.domain.length === 0 || !/[^#?]*/.test(this.domain)) throw new $brXJH.SiweError($brXJH.SiweErrorType.INVALID_DOMAIN, `${this.domain} to be a valid domain.`);
        /** EIP-55 `address` check. */ if (!(0, $11jMC.isEIP55Address)(this.address)) throw new $brXJH.SiweError($brXJH.SiweErrorType.INVALID_ADDRESS, (0, $jGqzU.getAddress)(this.address), this.address);
        /** Check if the URI is valid. */ if (!$ea69becd2fee5391$var$uri.isUri(this.uri)) throw new $brXJH.SiweError($brXJH.SiweErrorType.INVALID_URI, `${this.uri} to be a valid uri.`);
        /** Check if the version is 1. */ if (this.version !== "1") throw new $brXJH.SiweError($brXJH.SiweErrorType.INVALID_MESSAGE_VERSION, "1", this.version);
        /** Check if the nonce is alphanumeric and bigger then 8 characters */ const nonce = (_a = this === null || this === void 0 ? void 0 : this.nonce) === null || _a === void 0 ? void 0 : _a.match(/[a-zA-Z0-9]{8,}/);
        if (!nonce || this.nonce.length < 8 || nonce[0] !== this.nonce) throw new $brXJH.SiweError($brXJH.SiweErrorType.INVALID_NONCE, `Length > 8 (${nonce.length}). Alphanumeric.`, this.nonce);
        /** `issuedAt` conforms to ISO-8601 and is a valid date. */ if (this.issuedAt) {
            if (!(0, $eiyYC.isValidISO8601Date)(this.issuedAt)) throw new Error($brXJH.SiweErrorType.INVALID_TIME_FORMAT);
        }
        /** `expirationTime` conforms to ISO-8601 and is a valid date. */ if (this.expirationTime) {
            if (!(0, $eiyYC.isValidISO8601Date)(this.expirationTime)) throw new Error($brXJH.SiweErrorType.INVALID_TIME_FORMAT);
        }
        /** `notBefore` conforms to ISO-8601 and is a valid date. */ if (this.notBefore) {
            if (!(0, $eiyYC.isValidISO8601Date)(this.notBefore)) throw new Error($brXJH.SiweErrorType.INVALID_TIME_FORMAT);
        }
    }
}
module.exports.SiweMessage = $ea69becd2fee5391$var$SiweMessage;

});
parcelRegister("11jMC", function(module, exports) {
"use strict";
var $0be53af69dc6b990$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0be53af69dc6b990$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0be53af69dc6b990$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParsedMessage = void 0;

var $8UCdp = parcelRequire("8UCdp");
Object.defineProperty(module.exports, "ParsedMessage", {
    enumerable: true,
    get: function() {
        return $8UCdp.ParsedMessage;
    }
});

$0be53af69dc6b990$var$__exportStar((parcelRequire("58dei")), module.exports);

});
parcelRegister("8UCdp", function(module, exports) {
"use strict";
var $67d132711807aebd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $67d132711807aebd$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParsedMessage = void 0;

const $67d132711807aebd$var$api_1 = $67d132711807aebd$var$__importDefault((parcelRequire("99dVb")));

const $67d132711807aebd$var$node_exports_1 = $67d132711807aebd$var$__importDefault((parcelRequire("k9qkr")));

var $58dei = parcelRequire("58dei");
const $67d132711807aebd$var$GRAMMAR = `
sign-in-with-ethereum =
    [ scheme "://" ] domain %s" wants you to sign in with your Ethereum account:" LF
    address LF
    LF
    [ statement LF ]
    LF
    %s"URI: " URI LF
    %s"Version: " version LF
    %s"Chain ID: " chain-id LF
    %s"Nonce: " nonce LF
    %s"Issued At: " issued-at
    [ LF %s"Expiration Time: " expiration-time ]
    [ LF %s"Not Before: " not-before ]
    [ LF %s"Request ID: " request-id ]
    [ LF %s"Resources:"
    resources ]

domain = authority

address = "0x" 40*40HEXDIG
    ; Must also conform to captilization
    ; checksum encoding specified in EIP-55
    ; where applicable (EOAs).

statement = 1*( reserved / unreserved / " " )
    ; The purpose is to exclude LF (line breaks).

version = "1"

nonce = 8*( ALPHA / DIGIT )

issued-at = date-time
expiration-time = date-time
not-before = date-time

request-id = *pchar

chain-id = 1*DIGIT
    ; See EIP-155 for valid CHAIN_IDs.

resources = *( LF resource )

resource = "- " URI

; ------------------------------------------------------------------------------
; RFC 3986

URI           = scheme ":" hier-part [ "?" query ] [ "#" fragment ]

hier-part     = "//" authority path-abempty
              / path-absolute
              / path-rootless
              / path-empty

scheme        = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )

authority     = [ userinfo "@" ] host [ ":" port ]
userinfo      = *( unreserved / pct-encoded / sub-delims / ":" )
host          = IP-literal / IPv4address / reg-name
port          = *DIGIT

IP-literal    = "[" ( IPv6address / IPvFuture  ) "]"

IPvFuture     = "v" 1*HEXDIG "." 1*( unreserved / sub-delims / ":" )

IPv6address   =                            6( h16 ":" ) ls32
              /                       "::" 5( h16 ":" ) ls32
              / [               h16 ] "::" 4( h16 ":" ) ls32
              / [ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
              / [ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
              / [ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
              / [ *4( h16 ":" ) h16 ] "::"              ls32
              / [ *5( h16 ":" ) h16 ] "::"              h16
              / [ *6( h16 ":" ) h16 ] "::"

h16           = 1*4HEXDIG
ls32          = ( h16 ":" h16 ) / IPv4address
IPv4address   = dec-octet "." dec-octet "." dec-octet "." dec-octet
dec-octet     = DIGIT                 ; 0-9
                 / %x31-39 DIGIT         ; 10-99
                 / "1" 2DIGIT            ; 100-199
                 / "2" %x30-34 DIGIT     ; 200-249
                 / "25" %x30-35          ; 250-255

reg-name      = *( unreserved / pct-encoded / sub-delims )

path-abempty  = *( "/" segment )
path-absolute = "/" [ segment-nz *( "/" segment ) ]
path-rootless = segment-nz *( "/" segment )
path-empty    = 0pchar

segment       = *pchar
segment-nz    = 1*pchar

pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"

query         = *( pchar / "/" / "?" )

fragment      = *( pchar / "/" / "?" )

pct-encoded   = "%" HEXDIG HEXDIG

unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
reserved      = gen-delims / sub-delims
gen-delims    = ":" / "/" / "?" / "#" / "[" / "]" / "@"
sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
              / "*" / "+" / "," / ";" / "="

; ------------------------------------------------------------------------------
; RFC 3339

date-fullyear   = 4DIGIT
date-month      = 2DIGIT  ; 01-12
date-mday       = 2DIGIT  ; 01-28, 01-29, 01-30, 01-31 based on
                          ; month/year
time-hour       = 2DIGIT  ; 00-23
time-minute     = 2DIGIT  ; 00-59
time-second     = 2DIGIT  ; 00-58, 00-59, 00-60 based on leap second
                          ; rules
time-secfrac    = "." 1*DIGIT
time-numoffset  = ("+" / "-") time-hour ":" time-minute
time-offset     = "Z" / time-numoffset

partial-time    = time-hour ":" time-minute ":" time-second
                  [time-secfrac]
full-date       = date-fullyear "-" date-month "-" date-mday
full-time       = partial-time time-offset

date-time       = full-date "T" full-time

; ------------------------------------------------------------------------------
; RFC 5234

ALPHA          =  %x41-5A / %x61-7A   ; A-Z / a-z
LF             =  %x0A
                  ; linefeed
DIGIT          =  %x30-39
                  ; 0-9
HEXDIG         =  DIGIT / "A" / "B" / "C" / "D" / "E" / "F"
`;
class $67d132711807aebd$var$GrammarApi {
    static generateApi() {
        const api = new $67d132711807aebd$var$api_1.default($67d132711807aebd$var$GRAMMAR);
        api.generate();
        if (api.errors.length) {
            console.error(api.errorsToAscii());
            console.error(api.linesToAscii());
            console.log(api.displayAttributeErrors());
            throw new Error(`ABNF grammar has errors`);
        }
        return api.toObject();
    }
}
$67d132711807aebd$var$_a = $67d132711807aebd$var$GrammarApi;
$67d132711807aebd$var$GrammarApi.grammarObj = $67d132711807aebd$var$_a.generateApi();
class $67d132711807aebd$var$ParsedMessage {
    constructor(msg){
        const parser = new $67d132711807aebd$var$node_exports_1.default.parser();
        parser.ast = new $67d132711807aebd$var$node_exports_1.default.ast();
        const id = $67d132711807aebd$var$node_exports_1.default.ids;
        const scheme = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE && phraseIndex === 0) data.scheme = $67d132711807aebd$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks.scheme = scheme;
        const domain = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.domain = $67d132711807aebd$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks.domain = domain;
        const address = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.address = $67d132711807aebd$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks.address = address;
        const statement = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.statement = $67d132711807aebd$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks.statement = statement;
        const uri = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) {
                if (!data.uri) data.uri = $67d132711807aebd$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            }
            return ret;
        };
        parser.ast.callbacks.uri = uri;
        const version = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.version = $67d132711807aebd$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks.version = version;
        const chainId = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.chainId = (0, $58dei.parseIntegerNumber)($67d132711807aebd$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength));
            return ret;
        };
        parser.ast.callbacks["chain-id"] = chainId;
        const nonce = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.nonce = $67d132711807aebd$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks.nonce = nonce;
        const issuedAt = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.issuedAt = $67d132711807aebd$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks["issued-at"] = issuedAt;
        const expirationTime = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.expirationTime = $67d132711807aebd$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks["expiration-time"] = expirationTime;
        const notBefore = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.notBefore = $67d132711807aebd$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks["not-before"] = notBefore;
        const requestId = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.requestId = $67d132711807aebd$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            return ret;
        };
        parser.ast.callbacks["request-id"] = requestId;
        const resources = function(state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) data.resources = $67d132711807aebd$var$node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength).slice(3).split("\n- ");
            return ret;
        };
        parser.ast.callbacks.resources = resources;
        const result = parser.parse($67d132711807aebd$var$GrammarApi.grammarObj, "sign-in-with-ethereum", msg);
        if (!result.success) throw new Error(`Invalid message: ${JSON.stringify(result)}`);
        const elements = {};
        parser.ast.translate(elements);
        for (const [key, value] of Object.entries(elements))this[key] = value;
        if (this.domain.length === 0) throw new Error("Domain cannot be empty.");
        if (!(0, $58dei.isEIP55Address)(this.address)) throw new Error("Address not conformant to EIP-55.");
    }
}
module.exports.ParsedMessage = $67d132711807aebd$var$ParsedMessage;

});
parcelRegister("99dVb", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module is Application Programming Interface (API) for **APG** - the ABNF Parser Generator.
//
// *Note on teminology.*
// APG is a parser generator.
// However, it really only generates a "grammar object" (see below) from the defining SABNF grammar.
// The generated parser is incomplete at this stage.
// Remaining, it is the job of the user to develop the generated parser from the grammar object and the **APG** Library (**apg-lib**).
//
// The following terminology my help clear up any confusion between the idea of a "generated parser" versus a "generated grammar object".
// - The generating parser: **APG** is an **APG** parser (yes, there is a circular dependence between **apg-api** and **apg-lib**). We'll call it the generating parser.
// - The target parser: **APG**'s goal is to generate a parser. We'll call it the target parser.
// - The target grammar: this is the (ASCII) SABNF grammar defining the target parser.
// - The target grammar object: **APG** parses the SABNF grammar and generates the JavaScript source for a target grammar object constructor function
// and/or an actual grammar object.
// - The final target parser: The user then develops the final target parser using the generated target grammar
// object and the **APG** parsing library, **apg-lib**.
// Throws execeptions on fatal errors.
//
// src: the input SABNF grammar<br>
// may be one of:
// - Buffer of bytes
// - JavaScript string
// - Array of integer character codes







module.exports = function api(src) {
    const { Buffer: Buffer } = (parcelRequire("7ulbJ"));
    const thisFileName = "api.js: ";
    const thisObject = this;
    /* PRIVATE PROPERTIES */ const apglib = (parcelRequire("k9qkr"));
    const converter = (parcelRequire("aII0i"));
    const scanner = (parcelRequire("dDEWY"));
    const parser = new (parcelRequire("bXN6J"))();
    const { attributes: attributes, showAttributes: showAttributes, showAttributeErrors: showAttributeErrors, showRuleDependencies: showRuleDependencies } = (parcelRequire("6xKFX"));
    const showRules = (parcelRequire("aavuS"));
    /* PRIVATE MEMBERS (FUNCTIONS) */ /* Convert a phrase (array of character codes) to HTML. */ const abnfToHtml = function abnfToHtml(chars, beg, len) {
        const NORMAL = 0;
        const CONTROL = 1;
        const INVALID = 2;
        const CONTROL_BEG = `<span class="${apglib.style.CLASS_CTRLCHAR}">`;
        const CONTROL_END = "</span>";
        const INVALID_BEG = `<span class="${apglib.style.CLASS_NOMATCH}">`;
        const INVALID_END = "</span>";
        let end;
        let html = "";
        const TRUE = true;
        while(TRUE){
            if (!Array.isArray(chars) || chars.length === 0) break;
            if (typeof beg !== "number") throw new Error("abnfToHtml: beg must be type number");
            if (beg >= chars.length) break;
            if (typeof len !== "number" || beg + len >= chars.length) end = chars.length;
            else end = beg + len;
            let state = NORMAL;
            for(let i = beg; i < end; i += 1){
                const ch = chars[i];
                if (ch >= 32 && ch <= 126) {
                    /* normal - printable ASCII characters */ if (state === CONTROL) {
                        html += CONTROL_END;
                        state = NORMAL;
                    } else if (state === INVALID) {
                        html += INVALID_END;
                        state = NORMAL;
                    }
                    /* handle reserved HTML entity characters */ switch(ch){
                        case 32:
                            html += "&nbsp;";
                            break;
                        case 60:
                            html += "&lt;";
                            break;
                        case 62:
                            html += "&gt;";
                            break;
                        case 38:
                            html += "&amp;";
                            break;
                        case 34:
                            html += "&quot;";
                            break;
                        case 39:
                            html += "&#039;";
                            break;
                        case 92:
                            html += "&#092;";
                            break;
                        default:
                            html += String.fromCharCode(ch);
                            break;
                    }
                } else if (ch === 9 || ch === 10 || ch === 13) {
                    /* control characters */ if (state === NORMAL) {
                        html += CONTROL_BEG;
                        state = CONTROL;
                    } else if (state === INVALID) {
                        html += INVALID_END + CONTROL_BEG;
                        state = CONTROL;
                    }
                    if (ch === 9) html += "TAB";
                    if (ch === 10) html += "LF";
                    if (ch === 13) html += "CR";
                } else {
                    /* invalid characters */ if (state === NORMAL) {
                        html += INVALID_BEG;
                        state = INVALID;
                    } else if (state === CONTROL) {
                        html += CONTROL_END + INVALID_BEG;
                        state = INVALID;
                    }
                    /* display character as hexadecimal value */ html += `\\x${apglib.utils.charToHex(ch)}`;
                }
            }
            if (state === INVALID) html += INVALID_END;
            if (state === CONTROL) html += CONTROL_END;
            break;
        }
        return html;
    };
    /* Convert a phrase (array of character codes) to ASCII text. */ const abnfToAscii = function abnfToAscii(chars, beg, len) {
        let str = "";
        for(let i = beg; i < beg + len; i += 1){
            const ch = chars[i];
            if (ch >= 32 && ch <= 126) str += String.fromCharCode(ch);
            else switch(ch){
                case 9:
                    str += "\\t";
                    break;
                case 10:
                    str += "\\n";
                    break;
                case 13:
                    str += "\\r";
                    break;
                default:
                    str += "\\unknown";
                    break;
            }
        }
        return str;
    };
    /* translate lines (SABNF grammar) to ASCII text */ const linesToAscii = function linesToAscii(lines) {
        let str = "Annotated Input Grammar";
        lines.forEach((val)=>{
            str += "\n";
            str += `line no: ${val.lineNo}`;
            str += ` : char index: ${val.beginChar}`;
            str += ` : length: ${val.length}`;
            str += ` : abnf: ${abnfToAscii(thisObject.chars, val.beginChar, val.length)}`;
        });
        str += "\n";
        return str;
    };
    /* translate lines (SABNF grammar) to HTML */ const linesToHtml = function linesToHtml(lines) {
        let html = "";
        html += `<table class="${apglib.style.CLASS_GRAMMAR}">\n`;
        const title = "Annotated Input Grammar";
        html += `<caption>${title}</caption>\n`;
        html += "<tr>";
        html += "<th>line<br>no.</th><th>first<br>char</th><th><br>length</th><th><br>text</th>";
        html += "</tr>\n";
        lines.forEach((val)=>{
            html += "<tr>";
            html += `<td>${val.lineNo}`;
            html += `</td><td>${val.beginChar}`;
            html += `</td><td>${val.length}`;
            html += `</td><td>${abnfToHtml(thisObject.chars, val.beginChar, val.length)}`;
            html += "</td>";
            html += "</tr>\n";
        });
        html += "</table>\n";
        return html;
    };
    /* Format the error messages to HTML, for page display. */ const errorsToHtml = function errorsToHtml(errors, lines, chars, title) {
        const [style] = apglib;
        let html = "";
        const errorArrow = `<span class="${style.CLASS_NOMATCH}">&raquo;</span>`;
        html += `<p><table class="${style.CLASS_GRAMMAR}">\n`;
        if (title && typeof title === "string") html += `<caption>${title}</caption>\n`;
        html += "<tr><th>line<br>no.</th><th>line<br>offset</th><th>error<br>offset</th><th><br>text</th></tr>\n";
        errors.forEach((val)=>{
            let line;
            let relchar;
            let beg;
            let end;
            let text;
            let prefix = "";
            let suffix = "";
            if (lines.length === 0) {
                text = errorArrow;
                relchar = 0;
            } else {
                line = lines[val.line];
                beg = line.beginChar;
                if (val.char > beg) prefix = abnfToHtml(chars, beg, val.char - beg);
                beg = val.char;
                end = line.beginChar + line.length;
                if (beg < end) suffix = abnfToHtml(chars, beg, end - beg);
                text = prefix + errorArrow + suffix;
                relchar = val.char - line.beginChar;
                html += "<tr>";
                html += `<td>${val.line}</td><td>${line.beginChar}</td><td>${relchar}</td><td>${text}</td>`;
                html += "</tr>\n";
                html += "<tr>";
                html += `<td colspan="3"></td><td>&uarr;:&nbsp;${apglib.utils.stringToAsciiHtml(val.msg)}</td>`;
                html += "</tr>\n";
            }
        });
        html += "</table></p>\n";
        return html;
    };
    /* Display an array of errors in ASCII text */ const errorsToAscii = function errorsToAscii(errors, lines, chars) {
        let str;
        let line;
        let beg;
        let len;
        str = "";
        errors.forEach((error)=>{
            line = lines[error.line];
            str += `${line.lineNo}: `;
            str += `${line.beginChar}: `;
            str += `${error.char - line.beginChar}: `;
            beg = line.beginChar;
            len = error.char - line.beginChar;
            str += abnfToAscii(chars, beg, len);
            str += " >> ";
            beg = error.char;
            len = line.beginChar + line.length - error.char;
            str += abnfToAscii(chars, beg, len);
            str += "\n";
            str += `${line.lineNo}: `;
            str += `${line.beginChar}: `;
            str += `${error.char - line.beginChar}: `;
            str += "error: ";
            str += error.msg;
            str += "\n";
        });
        return str;
    };
    let isScanned = false;
    let isParsed = false;
    let isTranslated = false;
    let haveAttributes = false;
    let attributeErrors = 0;
    let lineMap;
    /* PUBLIC PROPERTIES */ // The input SABNF grammar as a JavaScript string.
    // this.sabnf;
    // The input SABNF grammar as an array of character codes.
    // this.chars;
    // An array of line objects, defining each line of the input SABNF grammar
    // - lineNo : the zero-based line number
    // - beginChar : offset (into `this.chars`) of the first character in the line
    // - length : the number of characters in the line
    // - textLength : the number of characters of text in the line, excluding the line ending characters
    // - endType : "CRLF", "LF", "CR" or "none" if the last line has no line ending characters
    // - invalidChars : `true` if the line contains invalid characters, `false` otherwise
    // this.lines;
    // An array of rule names and data.
    // - name : the rule name
    // - lower : the rule name in lower case
    // - index : the index of the rule (ordered by appearance in SABNF grammar)
    // - isBkr : `true` if this rule has been back referenced, `false` otherwise
    // - opcodes : array of opcodes for this rule
    // - attrs : the rule attributes
    // - ctrl : system data
    // this.rules;
    // An array of UDT names and data.
    // this.udts;
    // An array of errors, if any.
    // - line : the line number containing the error
    // - char : the character offset of the error
    // - msg : the error message
    this.errors = [];
    /* CONSTRUCTOR */ if (Buffer.isBuffer(src)) this.chars = converter.decode("BINARY", src);
    else if (Array.isArray(src)) this.chars = src.slice();
    else if (typeof src === "string") this.chars = converter.decode("STRING", src);
    else throw new Error(`${thisFileName}input source is not a string, byte Buffer or character array`);
    this.sabnf = converter.encode("STRING", this.chars);
    /* PUBLIC MEMBERS (FUNCTIONS) */ // Scan the input SABNF grammar for invalid characters and catalog the lines via `this.lines`.
    // - strict : (optional) if `true`, all lines, including the last must end with CRLF (\r\n),
    // if `false` (in any JavaScript sense) then line endings may be any mix of CRLF, LF, CR, or end-of-file.
    // - trace (*) : (optional) a parser trace object, which will trace the parser that does the scan
    this.scan = function scan(strict, trace) {
        this.lines = scanner(this.chars, this.errors, strict, trace);
        isScanned = true;
    };
    // Parse the input SABNF grammar for correct syntax.
    // - strict : (optional) if `true`, the input grammar must be strict ABNF, conforming to [RFC 5234](https://tools.ietf.org/html/rfc5234)
    // and [RFC 7405](https://tools.ietf.org/html/rfc7405). No superset features allowed.
    // - trace (\*) : (optional) a parser trace object, which will trace the syntax parser
    //
    // <i>(*)NOTE: the trace option was used primarily during development.
    // Error detection and reporting is now fairly robust and tracing should be unnecessary. Use at your own peril.</i>
    this.parse = function parse(strict, lite, trace) {
        if (!isScanned) throw new Error(`${thisFileName}grammar not scanned`);
        parser.syntax(this.chars, this.lines, this.errors, strict, lite, trace);
        isParsed = true;
    };
    // Translate the SABNF grammar syntax into the opcodes that will guide the parser for this grammar.
    this.translate = function translate() {
        if (!isParsed) throw new Error(`${thisFileName}grammar not scanned and parsed`);
        const ret = parser.semantic(this.chars, this.lines, this.errors);
        if (this.errors.length === 0) {
            this.rules = ret.rules;
            this.udts = ret.udts;
            lineMap = ret.lineMap;
            isTranslated = true;
        }
    };
    // Compute the attributes of each rule.
    this.attributes = function attrs() {
        if (!isTranslated) throw new Error(`${thisFileName}grammar not scanned, parsed and translated`);
        attributeErrors = attributes(this.rules, this.udts, lineMap, this.errors);
        haveAttributes = true;
        return attributeErrors;
    };
    // This function will perform the full suite of steps required to generate a parser grammar object
    // from the input SABNF grammar.
    this.generate = function generate(strict) {
        this.lines = scanner(this.chars, this.errors, strict);
        if (this.errors.length) return;
        parser.syntax(this.chars, this.lines, this.errors, strict);
        if (this.errors.length) return;
        const ret = parser.semantic(this.chars, this.lines, this.errors);
        if (this.errors.length) return;
        this.rules = ret.rules;
        this.udts = ret.udts;
        lineMap = ret.lineMap;
        attributeErrors = attributes(this.rules, this.udts, lineMap, this.errors);
        haveAttributes = true;
    };
    // Display the rules.
    // Must scan, parse and translate before calling this function, otherwise there are no rules to display.
    // - order
    //      - "index" or "i", index order (default)
    //      - "alpha" or "a", alphabetical order
    //      - none of above, index order (default)
    this.displayRules = function displayRules(order = "index") {
        if (!isTranslated) throw new Error(`${thisFileName}grammar not scanned, parsed and translated`);
        return showRules(this.rules, this.udts, order);
    };
    // Display the rule dependencies.
    // Must scan, parse, translate and compute attributes before calling this function.
    // Otherwise the rule dependencies are not known.
    // - order
    //      - "index" or "i", index order (default)
    //      - "alpha" or "a", alphabetical order
    //      - "type" or "t", ordered by type (alphabetical within each type/group)
    //      - none of above, index order (default)
    this.displayRuleDependencies = function displayRuleDependencies(order = "index") {
        if (!haveAttributes) throw new Error(`${thisFileName}no attributes - must be preceeded by call to attributes()`);
        return showRuleDependencies(order);
    };
    // Display the attributes.
    // Must scan, parse, translate and compute attributes before calling this function.
    // - order
    //      - "index" or "i", index order (default)
    //      - "alpha" or "a", alphabetical order
    //      - "type" or "t", ordered by type (alphabetical within each type/group)
    //      - none of above, type order (default)
    this.displayAttributes = function displayAttributes(order = "index") {
        if (!haveAttributes) throw new Error(`${thisFileName}no attributes - must be preceeded by call to attributes()`);
        if (attributeErrors) showAttributeErrors(order);
        return showAttributes(order);
    };
    this.displayAttributeErrors = function displayAttributeErrors() {
        if (!haveAttributes) throw new Error(`${thisFileName}no attributes - must be preceeded by call to attributes()`);
        return showAttributeErrors();
    };
    // Returns a parser grammar object constructor function as a JavaScript string.
    // This object can then be used to construct a parser.
    this.toSource = function toSource(config) {
        if (!haveAttributes) throw new Error(`${thisFileName}can't generate parser source - must be preceeded by call to attributes()`);
        if (attributeErrors) throw new Error(`${thisFileName}can't generate parser source - attributes have ${attributeErrors} errors`);
        return parser.generateSource(this.chars, this.lines, this.rules, this.udts, config);
    };
    // Returns a parser grammar object.
    // This grammar object may be used by the application to construct a parser.
    this.toObject = function toObject() {
        if (!haveAttributes) throw new Error(`${thisFileName}can't generate parser source - must be preceeded by call to attributes()`);
        if (attributeErrors) throw new Error(`${thisFileName}can't generate parser source - attributes have ${attributeErrors} errors`);
        return parser.generateObject(this.sabnf, this.rules, this.udts);
    };
    // Display errors in text format, suitable for `console.log()`.
    this.errorsToAscii = function errorsToAsciiFunc() {
        return errorsToAscii(this.errors, this.lines, this.chars);
    };
    // Display errors in HTML format, suitable for web page display.
    // (`apg-lib.css` required for proper styling)
    this.errorsToHtml = function errorsToHtmlFunc(title) {
        return errorsToHtml(this.errors, this.lines, this.chars, title);
    };
    // Generate an annotated the SABNF grammar display in text format.
    this.linesToAscii = function linesToAsciiFunc() {
        return linesToAscii(this.lines);
    };
    // Generate an annotated the SABNF grammar display in HTML format.
    // (`apg-lib.css` required for proper styling)
    this.linesToHtml = function linesToHtmlFunc() {
        return linesToHtml(this.lines);
    };
// This function was only used by apg.html which has been abandoned.
/*
    this.getAttributesObject = function () {
        return null;
    };
    */ };

});
parcelRegister("7ulbJ", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $573bc54e9e97125d$export$a143d493d941bafc; }, function (v) { return $573bc54e9e97125d$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $573bc54e9e97125d$export$e4cf37d7f6fb9e0a; }, function (v) { return $573bc54e9e97125d$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $573bc54e9e97125d$export$f99ded8fe4b79145; }, function (v) { return $573bc54e9e97125d$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $573bc54e9e97125d$export$599f31c3813fae4d; }, function (v) { return $573bc54e9e97125d$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $573bc54e9e97125d$export$a143d493d941bafc;
var $573bc54e9e97125d$export$e4cf37d7f6fb9e0a;
var $573bc54e9e97125d$export$f99ded8fe4b79145;
var $573bc54e9e97125d$export$599f31c3813fae4d;
"use strict";

var $gaa8e = parcelRequire("gaa8e");

var $jSbqZ = parcelRequire("jSbqZ");
var $573bc54e9e97125d$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$573bc54e9e97125d$export$a143d493d941bafc = $573bc54e9e97125d$var$Buffer;
$573bc54e9e97125d$export$e4cf37d7f6fb9e0a = $573bc54e9e97125d$var$SlowBuffer;
$573bc54e9e97125d$export$f99ded8fe4b79145 = 50;
var $573bc54e9e97125d$var$K_MAX_LENGTH = 0x7fffffff;
$573bc54e9e97125d$export$599f31c3813fae4d = $573bc54e9e97125d$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $573bc54e9e97125d$var$Buffer.TYPED_ARRAY_SUPPORT = $573bc54e9e97125d$var$typedArraySupport();
if (!$573bc54e9e97125d$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $573bc54e9e97125d$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($573bc54e9e97125d$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$573bc54e9e97125d$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($573bc54e9e97125d$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$573bc54e9e97125d$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $573bc54e9e97125d$var$createBuffer(length) {
    if (length > $573bc54e9e97125d$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $573bc54e9e97125d$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $573bc54e9e97125d$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $573bc54e9e97125d$var$allocUnsafe(arg);
    }
    return $573bc54e9e97125d$var$from(arg, encodingOrOffset, length);
}
$573bc54e9e97125d$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $573bc54e9e97125d$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $573bc54e9e97125d$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $573bc54e9e97125d$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($573bc54e9e97125d$var$isInstance(value, ArrayBuffer) || value && $573bc54e9e97125d$var$isInstance(value.buffer, ArrayBuffer)) return $573bc54e9e97125d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($573bc54e9e97125d$var$isInstance(value, SharedArrayBuffer) || value && $573bc54e9e97125d$var$isInstance(value.buffer, SharedArrayBuffer))) return $573bc54e9e97125d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $573bc54e9e97125d$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $573bc54e9e97125d$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $573bc54e9e97125d$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $573bc54e9e97125d$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $573bc54e9e97125d$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($573bc54e9e97125d$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($573bc54e9e97125d$var$Buffer, Uint8Array);
function $573bc54e9e97125d$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $573bc54e9e97125d$var$alloc(size, fill, encoding) {
    $573bc54e9e97125d$var$assertSize(size);
    if (size <= 0) return $573bc54e9e97125d$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $573bc54e9e97125d$var$createBuffer(size).fill(fill, encoding) : $573bc54e9e97125d$var$createBuffer(size).fill(fill);
    return $573bc54e9e97125d$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $573bc54e9e97125d$var$Buffer.alloc = function(size, fill, encoding) {
    return $573bc54e9e97125d$var$alloc(size, fill, encoding);
};
function $573bc54e9e97125d$var$allocUnsafe(size) {
    $573bc54e9e97125d$var$assertSize(size);
    return $573bc54e9e97125d$var$createBuffer(size < 0 ? 0 : $573bc54e9e97125d$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $573bc54e9e97125d$var$Buffer.allocUnsafe = function(size) {
    return $573bc54e9e97125d$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $573bc54e9e97125d$var$Buffer.allocUnsafeSlow = function(size) {
    return $573bc54e9e97125d$var$allocUnsafe(size);
};
function $573bc54e9e97125d$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$573bc54e9e97125d$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $573bc54e9e97125d$var$byteLength(string, encoding) | 0;
    var buf = $573bc54e9e97125d$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $573bc54e9e97125d$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $573bc54e9e97125d$var$checked(array.length) | 0;
    var buf = $573bc54e9e97125d$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $573bc54e9e97125d$var$fromArrayView(arrayView) {
    if ($573bc54e9e97125d$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $573bc54e9e97125d$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $573bc54e9e97125d$var$fromArrayLike(arrayView);
}
function $573bc54e9e97125d$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $573bc54e9e97125d$var$Buffer.prototype);
    return buf;
}
function $573bc54e9e97125d$var$fromObject(obj) {
    if ($573bc54e9e97125d$var$Buffer.isBuffer(obj)) {
        var len = $573bc54e9e97125d$var$checked(obj.length) | 0;
        var buf = $573bc54e9e97125d$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $573bc54e9e97125d$var$numberIsNaN(obj.length)) return $573bc54e9e97125d$var$createBuffer(0);
        return $573bc54e9e97125d$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $573bc54e9e97125d$var$fromArrayLike(obj.data);
}
function $573bc54e9e97125d$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $573bc54e9e97125d$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $573bc54e9e97125d$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $573bc54e9e97125d$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $573bc54e9e97125d$var$Buffer.alloc(+length);
}
$573bc54e9e97125d$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $573bc54e9e97125d$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$573bc54e9e97125d$var$Buffer.compare = function compare(a, b) {
    if ($573bc54e9e97125d$var$isInstance(a, Uint8Array)) a = $573bc54e9e97125d$var$Buffer.from(a, a.offset, a.byteLength);
    if ($573bc54e9e97125d$var$isInstance(b, Uint8Array)) b = $573bc54e9e97125d$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$573bc54e9e97125d$var$Buffer.isBuffer(a) || !$573bc54e9e97125d$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$573bc54e9e97125d$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$573bc54e9e97125d$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $573bc54e9e97125d$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $573bc54e9e97125d$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($573bc54e9e97125d$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $573bc54e9e97125d$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$573bc54e9e97125d$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $573bc54e9e97125d$var$byteLength(string, encoding) {
    if ($573bc54e9e97125d$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $573bc54e9e97125d$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $573bc54e9e97125d$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $573bc54e9e97125d$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $573bc54e9e97125d$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$573bc54e9e97125d$var$Buffer.byteLength = $573bc54e9e97125d$var$byteLength;
function $573bc54e9e97125d$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $573bc54e9e97125d$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $573bc54e9e97125d$var$utf8Slice(this, start, end);
        case "ascii":
            return $573bc54e9e97125d$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $573bc54e9e97125d$var$latin1Slice(this, start, end);
        case "base64":
            return $573bc54e9e97125d$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $573bc54e9e97125d$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$573bc54e9e97125d$var$Buffer.prototype._isBuffer = true;
function $573bc54e9e97125d$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$573bc54e9e97125d$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$573bc54e9e97125d$var$swap(this, i, i + 1);
    return this;
};
$573bc54e9e97125d$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $573bc54e9e97125d$var$swap(this, i, i + 3);
        $573bc54e9e97125d$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$573bc54e9e97125d$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $573bc54e9e97125d$var$swap(this, i, i + 7);
        $573bc54e9e97125d$var$swap(this, i + 1, i + 6);
        $573bc54e9e97125d$var$swap(this, i + 2, i + 5);
        $573bc54e9e97125d$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$573bc54e9e97125d$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $573bc54e9e97125d$var$utf8Slice(this, 0, length);
    return $573bc54e9e97125d$var$slowToString.apply(this, arguments);
};
$573bc54e9e97125d$var$Buffer.prototype.toLocaleString = $573bc54e9e97125d$var$Buffer.prototype.toString;
$573bc54e9e97125d$var$Buffer.prototype.equals = function equals(b) {
    if (!$573bc54e9e97125d$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $573bc54e9e97125d$var$Buffer.compare(this, b) === 0;
};
$573bc54e9e97125d$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $573bc54e9e97125d$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($573bc54e9e97125d$var$customInspectSymbol) $573bc54e9e97125d$var$Buffer.prototype[$573bc54e9e97125d$var$customInspectSymbol] = $573bc54e9e97125d$var$Buffer.prototype.inspect;
$573bc54e9e97125d$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($573bc54e9e97125d$var$isInstance(target, Uint8Array)) target = $573bc54e9e97125d$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$573bc54e9e97125d$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $573bc54e9e97125d$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($573bc54e9e97125d$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $573bc54e9e97125d$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($573bc54e9e97125d$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $573bc54e9e97125d$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $573bc54e9e97125d$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $573bc54e9e97125d$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$573bc54e9e97125d$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$573bc54e9e97125d$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $573bc54e9e97125d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$573bc54e9e97125d$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $573bc54e9e97125d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $573bc54e9e97125d$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($573bc54e9e97125d$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $573bc54e9e97125d$var$utf8Write(buf, string, offset, length) {
    return $573bc54e9e97125d$var$blitBuffer($573bc54e9e97125d$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $573bc54e9e97125d$var$asciiWrite(buf, string, offset, length) {
    return $573bc54e9e97125d$var$blitBuffer($573bc54e9e97125d$var$asciiToBytes(string), buf, offset, length);
}
function $573bc54e9e97125d$var$base64Write(buf, string, offset, length) {
    return $573bc54e9e97125d$var$blitBuffer($573bc54e9e97125d$var$base64ToBytes(string), buf, offset, length);
}
function $573bc54e9e97125d$var$ucs2Write(buf, string, offset, length) {
    return $573bc54e9e97125d$var$blitBuffer($573bc54e9e97125d$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$573bc54e9e97125d$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $573bc54e9e97125d$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $573bc54e9e97125d$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $573bc54e9e97125d$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $573bc54e9e97125d$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $573bc54e9e97125d$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$573bc54e9e97125d$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $573bc54e9e97125d$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gaa8e.fromByteArray(buf);
    else return $gaa8e.fromByteArray(buf.slice(start, end));
}
function $573bc54e9e97125d$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $573bc54e9e97125d$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $573bc54e9e97125d$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $573bc54e9e97125d$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $573bc54e9e97125d$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $573bc54e9e97125d$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $573bc54e9e97125d$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $573bc54e9e97125d$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $573bc54e9e97125d$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $573bc54e9e97125d$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $573bc54e9e97125d$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$573bc54e9e97125d$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $573bc54e9e97125d$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $573bc54e9e97125d$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$573bc54e9e97125d$var$Buffer.prototype.readUintLE = $573bc54e9e97125d$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$573bc54e9e97125d$var$Buffer.prototype.readUintBE = $573bc54e9e97125d$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$573bc54e9e97125d$var$Buffer.prototype.readUint8 = $573bc54e9e97125d$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$573bc54e9e97125d$var$Buffer.prototype.readUint16LE = $573bc54e9e97125d$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$573bc54e9e97125d$var$Buffer.prototype.readUint16BE = $573bc54e9e97125d$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$573bc54e9e97125d$var$Buffer.prototype.readUint32LE = $573bc54e9e97125d$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$573bc54e9e97125d$var$Buffer.prototype.readUint32BE = $573bc54e9e97125d$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$573bc54e9e97125d$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$573bc54e9e97125d$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$573bc54e9e97125d$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$573bc54e9e97125d$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$573bc54e9e97125d$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$573bc54e9e97125d$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$573bc54e9e97125d$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$573bc54e9e97125d$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 4, this.length);
    return $jSbqZ.read(this, offset, true, 23, 4);
};
$573bc54e9e97125d$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 4, this.length);
    return $jSbqZ.read(this, offset, false, 23, 4);
};
$573bc54e9e97125d$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 8, this.length);
    return $jSbqZ.read(this, offset, true, 52, 8);
};
$573bc54e9e97125d$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkOffset(offset, 8, this.length);
    return $jSbqZ.read(this, offset, false, 52, 8);
};
function $573bc54e9e97125d$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$573bc54e9e97125d$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$573bc54e9e97125d$var$Buffer.prototype.writeUintLE = $573bc54e9e97125d$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $573bc54e9e97125d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$573bc54e9e97125d$var$Buffer.prototype.writeUintBE = $573bc54e9e97125d$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $573bc54e9e97125d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$573bc54e9e97125d$var$Buffer.prototype.writeUint8 = $573bc54e9e97125d$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$573bc54e9e97125d$var$Buffer.prototype.writeUint16LE = $573bc54e9e97125d$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$573bc54e9e97125d$var$Buffer.prototype.writeUint16BE = $573bc54e9e97125d$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$573bc54e9e97125d$var$Buffer.prototype.writeUint32LE = $573bc54e9e97125d$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$573bc54e9e97125d$var$Buffer.prototype.writeUint32BE = $573bc54e9e97125d$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$573bc54e9e97125d$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $573bc54e9e97125d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$573bc54e9e97125d$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $573bc54e9e97125d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$573bc54e9e97125d$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$573bc54e9e97125d$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$573bc54e9e97125d$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$573bc54e9e97125d$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$573bc54e9e97125d$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $573bc54e9e97125d$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $573bc54e9e97125d$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $jSbqZ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$573bc54e9e97125d$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $573bc54e9e97125d$var$writeFloat(this, value, offset, true, noAssert);
};
$573bc54e9e97125d$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $573bc54e9e97125d$var$writeFloat(this, value, offset, false, noAssert);
};
function $573bc54e9e97125d$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $573bc54e9e97125d$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $jSbqZ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$573bc54e9e97125d$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $573bc54e9e97125d$var$writeDouble(this, value, offset, true, noAssert);
};
$573bc54e9e97125d$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $573bc54e9e97125d$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$573bc54e9e97125d$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$573bc54e9e97125d$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$573bc54e9e97125d$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$573bc54e9e97125d$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $573bc54e9e97125d$var$Buffer.isBuffer(val) ? val : $573bc54e9e97125d$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $573bc54e9e97125d$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $573bc54e9e97125d$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($573bc54e9e97125d$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $573bc54e9e97125d$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $573bc54e9e97125d$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $573bc54e9e97125d$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $573bc54e9e97125d$var$base64ToBytes(str) {
    return $gaa8e.toByteArray($573bc54e9e97125d$var$base64clean(str));
}
function $573bc54e9e97125d$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $573bc54e9e97125d$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $573bc54e9e97125d$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $573bc54e9e97125d$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("gaa8e", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $bc4570760301b666$export$d622b2ad8d90c771; }, function (v) { return $bc4570760301b666$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $bc4570760301b666$export$6100ba28696e12de; }, function (v) { return $bc4570760301b666$export$6100ba28696e12de = v; });
var $bc4570760301b666$export$a48f0734ac7c2329;
var $bc4570760301b666$export$d622b2ad8d90c771;
var $bc4570760301b666$export$6100ba28696e12de;
"use strict";
$bc4570760301b666$export$a48f0734ac7c2329 = $bc4570760301b666$var$byteLength;
$bc4570760301b666$export$d622b2ad8d90c771 = $bc4570760301b666$var$toByteArray;
$bc4570760301b666$export$6100ba28696e12de = $bc4570760301b666$var$fromByteArray;
var $bc4570760301b666$var$lookup = [];
var $bc4570760301b666$var$revLookup = [];
var $bc4570760301b666$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $bc4570760301b666$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $bc4570760301b666$var$i = 0, $bc4570760301b666$var$len = $bc4570760301b666$var$code.length; $bc4570760301b666$var$i < $bc4570760301b666$var$len; ++$bc4570760301b666$var$i){
    $bc4570760301b666$var$lookup[$bc4570760301b666$var$i] = $bc4570760301b666$var$code[$bc4570760301b666$var$i];
    $bc4570760301b666$var$revLookup[$bc4570760301b666$var$code.charCodeAt($bc4570760301b666$var$i)] = $bc4570760301b666$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$bc4570760301b666$var$revLookup["-".charCodeAt(0)] = 62;
$bc4570760301b666$var$revLookup["_".charCodeAt(0)] = 63;
function $bc4570760301b666$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $bc4570760301b666$var$byteLength(b64) {
    var lens = $bc4570760301b666$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bc4570760301b666$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bc4570760301b666$var$toByteArray(b64) {
    var tmp;
    var lens = $bc4570760301b666$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $bc4570760301b666$var$Arr($bc4570760301b666$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $bc4570760301b666$var$revLookup[b64.charCodeAt(i)] << 18 | $bc4570760301b666$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $bc4570760301b666$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $bc4570760301b666$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $bc4570760301b666$var$revLookup[b64.charCodeAt(i)] << 2 | $bc4570760301b666$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $bc4570760301b666$var$revLookup[b64.charCodeAt(i)] << 10 | $bc4570760301b666$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $bc4570760301b666$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $bc4570760301b666$var$tripletToBase64(num) {
    return $bc4570760301b666$var$lookup[num >> 18 & 0x3F] + $bc4570760301b666$var$lookup[num >> 12 & 0x3F] + $bc4570760301b666$var$lookup[num >> 6 & 0x3F] + $bc4570760301b666$var$lookup[num & 0x3F];
}
function $bc4570760301b666$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($bc4570760301b666$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $bc4570760301b666$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($bc4570760301b666$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($bc4570760301b666$var$lookup[tmp >> 2] + $bc4570760301b666$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($bc4570760301b666$var$lookup[tmp >> 10] + $bc4570760301b666$var$lookup[tmp >> 4 & 0x3F] + $bc4570760301b666$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("jSbqZ", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $e77bee13fbc24763$export$aafa59e2e03f2942; }, function (v) { return $e77bee13fbc24763$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $e77bee13fbc24763$export$68d8715fc104d294; }, function (v) { return $e77bee13fbc24763$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $e77bee13fbc24763$export$aafa59e2e03f2942;
var $e77bee13fbc24763$export$68d8715fc104d294;
$e77bee13fbc24763$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$e77bee13fbc24763$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("k9qkr", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module serves to export all library objects and object constructors with the `require("apg-lib")` statement.
// For example, to create a new parser in your program,
// ````
// let apglib = require("../apg-lib/node-exports");
// let my-parser = new apglib.parser();
// ````









module.exports = {
    ast: (parcelRequire("hcpaP")),
    circular: (parcelRequire("cH6Qg")),
    ids: (parcelRequire("aGWMb")),
    parser: (parcelRequire("iFDSO")),
    stats: (parcelRequire("foSKy")),
    trace: (parcelRequire("fFocM")),
    utils: (parcelRequire("abgIo")),
    emitcss: (parcelRequire("ahTZ3")),
    style: (parcelRequire("fHN1N"))
};

});
parcelRegister("hcpaP", function(module, exports) {
/* eslint-disable guard-for-in */ /* eslint-disable no-restricted-syntax */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module is used by the parser to build an [Abstract Syntax Tree](https://en.wikipedia.org/wiki/Abstract_syntax_tree) (AST).
// The AST can be thought of as a subset of the full parse tree.
// Each node of the AST holds the phrase that was matched at the corresponding, named parse tree node.
// It is built as the parser successfully matches phrases to the rule names
// (`RNM` operators) and `UDT`s as it parses an input string.
// The user controls which `RNM` or `UDT` names to keep on the AST.
// The user can also associate callback functions with some or all of the retained
// AST nodes to be used to translate the node phrases. That is, associate semantic
// actions to the matched phrases.
// Translating the AST rather that attempting to apply semantic actions during
// the parsing process, has the advantage that there is no backtracking and that the phrases
// are known while traversing down tree as will as up.
//
// Let `ast` be an `ast.js` object. To identify a node to be kept on the AST:
// ```
// ast.callbacks["rulename"] = true; (all nodes default to false)
// ```
// To associate a callback function with a node:
// ```
// ast.callbacks["rulename"] = fn
// ```
// `rulename` is any `RNM` or `UDT` name defined by the associated grammar
// and `fn` is a user-written callback function.
// (See [`apg-examples`](https://github.com/ldthomas/apg-js2-examples/tree/master/ast) for examples of how to create an AST,
// define the nodes and callback functions and attach it to a parser.)


module.exports = function exportsAst() {
    const id = (parcelRequire("aGWMb"));
    const utils = (parcelRequire("abgIo"));
    const thisFileName = "ast.js: ";
    const that = this;
    let rules = null;
    let udts = null;
    let chars = null;
    let nodeCount = 0;
    const nodesDefined = [];
    const nodeCallbacks = [];
    const stack = [];
    const records = [];
    this.callbacks = [];
    this.astObject = "astObject";
    /* called by the parser to initialize the AST with the rules, UDTs and the input characters */ this.init = function init(rulesIn, udtsIn, charsIn) {
        stack.length = 0;
        records.length = 0;
        nodesDefined.length = 0;
        nodeCount = 0;
        rules = rulesIn;
        udts = udtsIn;
        chars = charsIn;
        let i;
        const list = [];
        for(i = 0; i < rules.length; i += 1)list.push(rules[i].lower);
        for(i = 0; i < udts.length; i += 1)list.push(udts[i].lower);
        nodeCount = rules.length + udts.length;
        for(i = 0; i < nodeCount; i += 1){
            nodesDefined[i] = false;
            nodeCallbacks[i] = null;
        }
        for(const index in that.callbacks){
            const lower = index.toLowerCase();
            i = list.indexOf(lower);
            if (i < 0) throw new Error(`${thisFileName}init: node '${index}' not a rule or udt name`);
            if (typeof that.callbacks[index] === "function") {
                nodesDefined[i] = true;
                nodeCallbacks[i] = that.callbacks[index];
            }
            if (that.callbacks[index] === true) nodesDefined[i] = true;
        }
    };
    /* AST node definitions - called by the parser's `RNM` operator */ this.ruleDefined = function ruleDefined(index) {
        return nodesDefined[index] !== false;
    };
    /* AST node definitions - called by the parser's `UDT` operator */ this.udtDefined = function udtDefined(index) {
        return nodesDefined[rules.length + index] !== false;
    };
    /* called by the parser's `RNM` & `UDT` operators */ /* builds a record for the downward traversal of the node */ this.down = function down(callbackIndex, name) {
        const thisIndex = records.length;
        stack.push(thisIndex);
        records.push({
            name: name,
            thisIndex: thisIndex,
            thatIndex: null,
            state: id.SEM_PRE,
            callbackIndex: callbackIndex,
            phraseIndex: null,
            phraseLength: null,
            stack: stack.length
        });
        return thisIndex;
    };
    /* called by the parser's `RNM` & `UDT` operators */ /* builds a record for the upward traversal of the node */ this.up = function up(callbackIndex, name, phraseIndex, phraseLength) {
        const thisIndex = records.length;
        const thatIndex = stack.pop();
        records.push({
            name: name,
            thisIndex: thisIndex,
            thatIndex: thatIndex,
            state: id.SEM_POST,
            callbackIndex: callbackIndex,
            phraseIndex: phraseIndex,
            phraseLength: phraseLength,
            stack: stack.length
        });
        records[thatIndex].thatIndex = thisIndex;
        records[thatIndex].phraseIndex = phraseIndex;
        records[thatIndex].phraseLength = phraseLength;
        return thisIndex;
    };
    // Called by the user to translate the AST.
    // Translate means to associate or apply some semantic action to the
    // phrases that were syntactically matched to the AST nodes according
    // to the defining grammar.
    // ```
    // data - optional user-defined data
    //        passed to the callback functions by the translator
    // ```
    this.translate = function translate(data) {
        let ret;
        let callback;
        let record;
        for(let i = 0; i < records.length; i += 1){
            record = records[i];
            callback = nodeCallbacks[record.callbackIndex];
            if (record.state === id.SEM_PRE) {
                if (callback !== null) {
                    ret = callback(id.SEM_PRE, chars, record.phraseIndex, record.phraseLength, data);
                    if (ret === id.SEM_SKIP) i = record.thatIndex;
                }
            } else if (callback !== null) callback(id.SEM_POST, chars, record.phraseIndex, record.phraseLength, data);
        }
    };
    /* called by the parser to reset the length of the records array */ /* necessary on backtracking */ this.setLength = function setLength(length) {
        records.length = length;
        if (length > 0) stack.length = records[length - 1].stack;
        else stack.length = 0;
    };
    /* called by the parser to get the length of the records array */ this.getLength = function getLength() {
        return records.length;
    };
    /* helper for XML display */ function indent(n) {
        let ret = "";
        for(let i = 0; i < n; i += 1)ret += " ";
        return ret;
    }
    // Generate an `XML` version of the AST.
    // Useful if you want to use a special or favorite XML parser to translate the
    // AST.
    // ```
    // mode - the display mode of the captured phrases
    //      - default mode is "ascii"
    //      - can be: "ascii"
    //                "decimal"
    //                "hexadecimal"
    //                "unicode"
    // ```
    this.toXml = function toSml(modeArg) {
        let display = utils.charsToDec;
        let caption = "decimal integer character codes";
        if (typeof modeArg === "string" && modeArg.length >= 3) {
            const mode = modeArg.slice(0, 3).toLowerCase();
            if (mode === "asc") {
                display = utils.charsToAscii;
                caption = "ASCII for printing characters, hex for non-printing";
            } else if (mode === "hex") {
                display = utils.charsToHex;
                caption = "hexadecimal integer character codes";
            } else if (mode === "uni") {
                display = utils.charsToUnicode;
                caption = "Unicode UTF-32 integer character codes";
            }
        }
        let xml = "";
        let depth = 0;
        xml += '<?xml version="1.0" encoding="utf-8"?>\n';
        xml += `<root nodes="${records.length / 2}" characters="${chars.length}">\n`;
        xml += `<!-- input string, ${caption} -->\n`;
        xml += indent(depth + 2);
        xml += display(chars);
        xml += "\n";
        records.forEach((rec)=>{
            if (rec.state === id.SEM_PRE) {
                depth += 1;
                xml += indent(depth);
                xml += `<node name="${rec.name}" index="${rec.phraseIndex}" length="${rec.phraseLength}">\n`;
                xml += indent(depth + 2);
                xml += display(chars, rec.phraseIndex, rec.phraseLength);
                xml += "\n";
            } else {
                xml += indent(depth);
                xml += `</node><!-- name="${rec.name}" -->\n`;
                depth -= 1;
            }
        });
        xml += "</root>\n";
        return xml;
    };
    /* generate a JavaScript object version of the AST */ /* for the phrase-matching engine apg-exp */ this.phrases = function phrases() {
        const obj = {};
        let i;
        let record;
        for(i = 0; i < records.length; i += 1){
            record = records[i];
            if (record.state === id.SEM_PRE) {
                if (!Array.isArray(obj[record.name])) obj[record.name] = [];
                obj[record.name].push({
                    index: record.phraseIndex,
                    length: record.phraseLength
                });
            }
        }
        return obj;
    };
};

});
parcelRegister("aGWMb", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module exposes a list of named identifiers, shared across the parser generator
// and the parsers that are generated.
module.exports = {
    // Identifies the operator type. Used by the generator
    // to indicate operator types in the grammar object.
    // Used by the [parser](./parser.html) when interpreting the grammar object.
    /* the original ABNF operators */ ALT: 1 /* alternation */ ,
    CAT: 2 /* concatenation */ ,
    REP: 3 /* repetition */ ,
    RNM: 4 /* rule name */ ,
    TRG: 5 /* terminal range */ ,
    TBS: 6 /* terminal binary string, case sensitive */ ,
    TLS: 7 /* terminal literal string, case insensitive */ ,
    /* the super set, SABNF operators */ UDT: 11 /* user-defined terminal */ ,
    AND: 12 /* positive look ahead */ ,
    NOT: 13 /* negative look ahead */ ,
    BKR: 14 /* back reference to a previously matched rule name */ ,
    BKA: 15 /* positive look behind */ ,
    BKN: 16 /* negative look behind */ ,
    ABG: 17 /* anchor - begin of string */ ,
    AEN: 18 /* anchor - end of string */ ,
    // Used by the parser and the user's `RNM` and `UDT` callback functions.
    // Identifies the parser state as it traverses the parse tree nodes.
    // - *ACTIVE* - indicates the downward direction through the parse tree node.
    // - *MATCH* - indicates the upward direction and a phrase, of length \> 0, has been successfully matched
    // - *EMPTY* - indicates the upward direction and a phrase, of length = 0, has been successfully matched
    // - *NOMATCH* - indicates the upward direction and the parser failed to match any phrase at all
    ACTIVE: 100,
    MATCH: 101,
    EMPTY: 102,
    NOMATCH: 103,
    // Used by [`AST` translator](./ast.html) (semantic analysis) and the user's callback functions
    // to indicate the direction of flow through the `AST` nodes.
    // - *SEM_PRE* - indicates the downward (pre-branch) direction through the `AST` node.
    // - *SEM_POST* - indicates the upward (post-branch) direction through the `AST` node.
    SEM_PRE: 200,
    SEM_POST: 201,
    // Used by the user's callback functions to indicate to the `AST` translator (semantic analysis) how to proceed.
    // - *SEM_OK* - normal return value
    // - *SEM_SKIP* - if a callback function returns this value from the SEM_PRE state,
    // the translator will skip processing all `AST` nodes in the branch below the current node.
    // Ignored if returned from the SEM_POST state.
    SEM_OK: 300,
    SEM_SKIP: 301,
    // Used in attribute generation to distinguish the necessary attribute categories.
    // - *ATTR_N* - non-recursive
    // - *ATTR_R* - recursive
    // - *ATTR_MR* - belongs to a mutually-recursive set
    ATTR_N: 400,
    ATTR_R: 401,
    ATTR_MR: 402,
    // Look around values indicate whether the parser is in look ahead or look behind mode.
    // Used by the tracing facility to indicate the look around mode in the trace records display.
    // - *LOOKAROUND_NONE* - the parser is in normal parsing mode
    // - *LOOKAROUND_AHEAD* - the parse is in look-ahead mode, phrase matching for operator `AND(&)` or `NOT(!)`
    // - *LOOKAROUND_BEHIND* - the parse is in look-behind mode, phrase matching for operator `BKA(&&)` or `BKN(!!)`
    LOOKAROUND_NONE: 500,
    LOOKAROUND_AHEAD: 501,
    LOOKAROUND_BEHIND: 502,
    // Back reference rule mode indicators
    // - *BKR_MODE_UM* - the back reference is using universal mode
    // - *BKR_MODE_PM* - the back reference is using parent frame mode
    // - *BKR_MODE_CS* - the back reference is using case-sensitive phrase matching
    // - *BKR_MODE_CI* - the back reference is using case-insensitive phrase matching
    BKR_MODE_UM: 601,
    BKR_MODE_PM: 602,
    BKR_MODE_CS: 603,
    BKR_MODE_CI: 604
};

});

parcelRegister("abgIo", function(module, exports) {
/* eslint-disable func-names */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module exports a variety of utility functions that support
// [`apg`](https://github.com/ldthomas/apg-js2), [`apg-lib`](https://github.com/ldthomas/apg-js2-lib)
// and the generated parser applications.

var $fHN1N = parcelRequire("fHN1N");

var $aII0i = parcelRequire("aII0i");

var $ahTZ3 = parcelRequire("ahTZ3");

var $aGWMb = parcelRequire("aGWMb");
const thisFileName = "utilities.js: ";
/* translate (implied) phrase beginning character and length to actual first and last character indexes */ /* used by multiple phrase handling functions */ const getBounds = function(length, begArg, len) {
    let end;
    let beg = begArg;
    const TRUE = true;
    while(TRUE){
        if (length <= 0) {
            beg = 0;
            end = 0;
            break;
        }
        if (typeof beg !== "number") {
            beg = 0;
            end = length;
            break;
        }
        if (beg >= length) {
            beg = length;
            end = length;
            break;
        }
        if (typeof len !== "number") {
            end = length;
            break;
        }
        end = beg + len;
        if (end > length) {
            end = length;
            break;
        }
        break;
    }
    return {
        beg: beg,
        end: end
    };
};
// Generates a complete, minimal HTML5 page, inserting the user's HTML text on the page.
// - *html* - the page text in HTML format
// - *title* - the HTML page `<title>` - defaults to `htmlToPage`.
exports.htmlToPage = function(html, titleArg) {
    let title;
    if (typeof html !== "string") throw new Error(`${thisFileName}htmlToPage: input HTML is not a string`);
    if (typeof titleArg !== "string") title = "htmlToPage";
    else title = titleArg;
    let page = "";
    page += "<!DOCTYPE html>\n";
    page += '<html lang="en">\n';
    page += "<head>\n";
    page += '<meta charset="utf-8">\n';
    page += `<title>${title}</title>\n`;
    page += "<style>\n";
    page += $ahTZ3();
    page += "</style>\n";
    page += "</head>\n<body>\n";
    page += `<p>${new Date()}</p>\n`;
    page += html;
    page += "</body>\n</html>\n";
    return page;
};
// Formats the returned object from `parser.parse()`
// into an HTML table.
// ```
// return {
//   success : sysData.success,
//   state : sysData.state,
//   length : charsLength,
//   matched : sysData.phraseLength,
//   maxMatched : maxMatched,
//   maxTreeDepth : maxTreeDepth,
//   nodeHits : nodeHits,
//   inputLength : chars.length,
//   subBegin : charsBegin,
//   subEnd : charsEnd,
//   subLength : charsLength
// };
// ```
exports.parserResultToHtml = function(result, caption) {
    let cap = null;
    if (typeof caption === "string" && caption !== "") cap = caption;
    let success;
    let state;
    if (result.success === true) success = `<span class="${$fHN1N.CLASS_MATCH}">true</span>`;
    else success = `<span class="${$fHN1N.CLASS_NOMATCH}">false</span>`;
    if (result.state === $aGWMb.EMPTY) state = `<span class="${$fHN1N.CLASS_EMPTY}">EMPTY</span>`;
    else if (result.state === $aGWMb.MATCH) state = `<span class="${$fHN1N.CLASS_MATCH}">MATCH</span>`;
    else if (result.state === $aGWMb.NOMATCH) state = `<span class="${$fHN1N.CLASS_NOMATCH}">NOMATCH</span>`;
    else state = `<span class="${$fHN1N.CLASS_NOMATCH}">unrecognized</span>`;
    let html = "";
    html += `<table class="${$fHN1N.CLASS_STATE}">\n`;
    if (cap) html += `<caption>${cap}</caption>\n`;
    html += "<tr><th>state item</th><th>value</th><th>description</th></tr>\n";
    html += `<tr><td>parser success</td><td>${success}</td>\n`;
    html += `<td><span class="${$fHN1N.CLASS_MATCH}">true</span> if the parse succeeded,\n`;
    html += ` <span class="${$fHN1N.CLASS_NOMATCH}">false</span> otherwise`;
    html += "<br><i>NOTE: for success, entire string must be matched</i></td></tr>\n";
    html += `<tr><td>parser state</td><td>${state}</td>\n`;
    html += `<td><span class="${$fHN1N.CLASS_EMPTY}">EMPTY</span>, `;
    html += `<span class="${$fHN1N.CLASS_MATCH}">MATCH</span> or \n`;
    html += `<span class="${$fHN1N.CLASS_NOMATCH}">NOMATCH</span></td></tr>\n`;
    html += `<tr><td>string length</td><td>${result.length}</td><td>length of the input (sub)string</td></tr>\n`;
    html += `<tr><td>matched length</td><td>${result.matched}</td><td>number of input string characters matched</td></tr>\n`;
    html += `<tr><td>max matched</td><td>${result.maxMatched}</td><td>maximum number of input string characters matched</td></tr>\n`;
    html += `<tr><td>max tree depth</td><td>${result.maxTreeDepth}</td><td>maximum depth of the parse tree reached</td></tr>\n`;
    html += `<tr><td>node hits</td><td>${result.nodeHits}</td><td>number of parse tree node hits (opcode function calls)</td></tr>\n`;
    html += `<tr><td>input length</td><td>${result.inputLength}</td><td>length of full input string</td></tr>\n`;
    html += `<tr><td>sub-string begin</td><td>${result.subBegin}</td><td>sub-string first character index</td></tr>\n`;
    html += `<tr><td>sub-string end</td><td>${result.subEnd}</td><td>sub-string end-of-string index</td></tr>\n`;
    html += `<tr><td>sub-string length</td><td>${result.subLength}</td><td>sub-string length</td></tr>\n`;
    html += "</table>\n";
    return html;
};
// Translates a sub-array of integer character codes into a string.
// Very useful in callback functions to translate the matched phrases into strings.
exports.charsToString = function(chars, phraseIndex, phraseLength) {
    let beg;
    let end;
    if (typeof phraseIndex === "number") {
        if (phraseIndex >= chars.length) return "";
        beg = phraseIndex < 0 ? 0 : phraseIndex;
    } else beg = 0;
    if (typeof phraseLength === "number") {
        if (phraseLength <= 0) return "";
        end = phraseLength > chars.length - beg ? chars.length : beg + phraseLength;
    } else end = chars.length;
    if (beg < end) return $aII0i.encode("UTF16LE", chars.slice(beg, end)).toString("utf16le");
    return "";
};
// Translates a string into an array of integer character codes.
exports.stringToChars = function(string) {
    return $aII0i.decode("STRING", string);
};
// Translates an opcode identifier into a human-readable string.
exports.opcodeToString = function(type) {
    let ret = "unknown";
    switch(type){
        case $aGWMb.ALT:
            ret = "ALT";
            break;
        case $aGWMb.CAT:
            ret = "CAT";
            break;
        case $aGWMb.RNM:
            ret = "RNM";
            break;
        case $aGWMb.UDT:
            ret = "UDT";
            break;
        case $aGWMb.AND:
            ret = "AND";
            break;
        case $aGWMb.NOT:
            ret = "NOT";
            break;
        case $aGWMb.REP:
            ret = "REP";
            break;
        case $aGWMb.TRG:
            ret = "TRG";
            break;
        case $aGWMb.TBS:
            ret = "TBS";
            break;
        case $aGWMb.TLS:
            ret = "TLS";
            break;
        case $aGWMb.BKR:
            ret = "BKR";
            break;
        case $aGWMb.BKA:
            ret = "BKA";
            break;
        case $aGWMb.BKN:
            ret = "BKN";
            break;
        case $aGWMb.ABG:
            ret = "ABG";
            break;
        case $aGWMb.AEN:
            ret = "AEN";
            break;
        default:
            throw new Error("unrecognized opcode");
    }
    return ret;
};
// Translates an state identifier into a human-readable string.
exports.stateToString = function(state) {
    let ret = "unknown";
    switch(state){
        case $aGWMb.ACTIVE:
            ret = "ACTIVE";
            break;
        case $aGWMb.MATCH:
            ret = "MATCH";
            break;
        case $aGWMb.EMPTY:
            ret = "EMPTY";
            break;
        case $aGWMb.NOMATCH:
            ret = "NOMATCH";
            break;
        default:
            throw new Error("unrecognized state");
    }
    return ret;
};
// Array which translates all 128, 7-bit ASCII character codes to their respective HTML format.
exports.asciiChars = [
    "NUL",
    "SOH",
    "STX",
    "ETX",
    "EOT",
    "ENQ",
    "ACK",
    "BEL",
    "BS",
    "TAB",
    "LF",
    "VT",
    "FF",
    "CR",
    "SO",
    "SI",
    "DLE",
    "DC1",
    "DC2",
    "DC3",
    "DC4",
    "NAK",
    "SYN",
    "ETB",
    "CAN",
    "EM",
    "SUB",
    "ESC",
    "FS",
    "GS",
    "RS",
    "US",
    "&nbsp;",
    "!",
    "&#34;",
    "#",
    "$",
    "%",
    "&#38;",
    "&#39;",
    "(",
    ")",
    "*",
    "+",
    ",",
    "-",
    ".",
    "/",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    ":",
    ";",
    "&#60;",
    "=",
    "&#62;",
    "?",
    "@",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "[",
    "&#92;",
    "]",
    "^",
    "_",
    "`",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "{",
    "|",
    "}",
    "~",
    "DEL"
];
// Translates a single character to hexadecimal with leading zeros for 2, 4, or 8 digit display.
exports.charToHex = function(char) {
    let ch = char.toString(16).toUpperCase();
    switch(ch.length){
        case 1:
        case 3:
        case 7:
            ch = `0${ch}`;
            break;
        case 2:
        case 6:
            ch = `00${ch}`;
            break;
        case 4:
            break;
        case 5:
            ch = `000${ch}`;
            break;
        default:
            throw new Error("unrecognized option");
    }
    return ch;
};
// Translates a sub-array of character codes to decimal display format.
exports.charsToDec = function(chars, beg, len) {
    let ret = "";
    if (!Array.isArray(chars)) throw new Error(`${thisFileName}charsToDec: input must be an array of integers`);
    const bounds = getBounds(chars.length, beg, len);
    if (bounds.end > bounds.beg) {
        ret += chars[bounds.beg];
        for(let i = bounds.beg + 1; i < bounds.end; i += 1)ret += `,${chars[i]}`;
    }
    return ret;
};
// Translates a sub-array of character codes to hexadecimal display format.
exports.charsToHex = function(chars, beg, len) {
    let ret = "";
    if (!Array.isArray(chars)) throw new Error(`${thisFileName}charsToHex: input must be an array of integers`);
    const bounds = getBounds(chars.length, beg, len);
    if (bounds.end > bounds.beg) {
        ret += `\\x${exports.charToHex(chars[bounds.beg])}`;
        for(let i = bounds.beg + 1; i < bounds.end; i += 1)ret += `,\\x${exports.charToHex(chars[i])}`;
    }
    return ret;
};
exports.charsToHtmlEntities = function(chars, beg, len) {
    let ret = "";
    if (!Array.isArray(chars)) throw new Error(`${thisFileName}charsToHex: input must be an array of integers`);
    const bounds = getBounds(chars.length, beg, len);
    if (bounds.end > bounds.beg) for(let i = bounds.beg; i < bounds.end; i += 1)ret += `&#x${chars[i].toString(16)};`;
    return ret;
};
// Translates a sub-array of character codes to Unicode display format.
function isUnicode(char) {
    if (char >= 0xd800 && char <= 0xdfff) return false;
    if (char > 0x10ffff) return false;
    return true;
}
exports.charsToUnicode = function(chars, beg, len) {
    let ret = "";
    if (!Array.isArray(chars)) throw new Error(`${thisFileName}charsToUnicode: input must be an array of integers`);
    const bounds = getBounds(chars.length, beg, len);
    if (bounds.end > bounds.beg) {
        for(let i = bounds.beg; i < bounds.end; i += 1)if (isUnicode(chars[i])) ret += `&#${chars[i]};`;
        else ret += ` U+${exports.charToHex(chars[i])}`;
    }
    return ret;
};
// Translates a sub-array of character codes to JavaScript Unicode display format (`\uXXXX`).
exports.charsToJsUnicode = function(chars, beg, len) {
    let ret = "";
    if (!Array.isArray(chars)) throw new Error(`${thisFileName}charsToJsUnicode: input must be an array of integers`);
    const bounds = getBounds(chars.length, beg, len);
    if (bounds.end > bounds.beg) {
        ret += `\\u${exports.charToHex(chars[bounds.beg])}`;
        for(let i = bounds.beg + 1; i < bounds.end; i += 1)ret += `,\\u${exports.charToHex(chars[i])}`;
    }
    return ret;
};
// Translates a sub-array of character codes to printing ASCII character display format.
exports.charsToAscii = function(chars, beg, len) {
    let ret = "";
    if (!Array.isArray(chars)) throw new Error(`${thisFileName}charsToAscii: input must be an array of integers`);
    const bounds = getBounds(chars.length, beg, len);
    for(let i = bounds.beg; i < bounds.end; i += 1){
        const char = chars[i];
        if (char >= 32 && char <= 126) ret += String.fromCharCode(char);
        else ret += `\\x${exports.charToHex(char)}`;
    }
    return ret;
};
// Translates a sub-array of character codes to HTML display format.
exports.charsToAsciiHtml = function(chars, beg, len) {
    if (!Array.isArray(chars)) throw new Error(`${thisFileName}charsToAsciiHtml: input must be an array of integers`);
    let html = "";
    let char;
    const bounds = getBounds(chars.length, beg, len);
    for(let i = bounds.beg; i < bounds.end; i += 1){
        char = chars[i];
        if (char < 32 || char === 127) /* control characters */ html += `<span class="${$fHN1N.CLASS_CTRLCHAR}">${exports.asciiChars[char]}</span>`;
        else if (char > 127) /* non-ASCII */ html += `<span class="${$fHN1N.CLASS_CTRLCHAR}">U+${exports.charToHex(char)}</span>`;
        else /* printing ASCII, 32 <= char <= 126 */ html += exports.asciiChars[char];
    }
    return html;
};
// Translates a JavaScript string to HTML display format.
exports.stringToAsciiHtml = function(str) {
    const chars = $aII0i.decode("STRING", str);
    return this.charsToAsciiHtml(chars);
};

});
parcelRegister("fHN1N", function(module, exports) {
module.exports = {
    // Generated by apglib/style.js 
    CLASS_MONOSPACE: "apg-mono",
    CLASS_ACTIVE: "apg-active",
    CLASS_EMPTY: "apg-empty",
    CLASS_MATCH: "apg-match",
    CLASS_NOMATCH: "apg-nomatch",
    CLASS_LOOKAHEAD: "apg-lh-match",
    CLASS_LOOKBEHIND: "apg-lb-match",
    CLASS_REMAINDER: "apg-remainder",
    CLASS_CTRLCHAR: "apg-ctrl-char",
    CLASS_LINEEND: "apg-line-end",
    CLASS_ERROR: "apg-error",
    CLASS_PHRASE: "apg-phrase",
    CLASS_EMPTYPHRASE: "apg-empty-phrase",
    CLASS_STATE: "apg-state",
    CLASS_STATS: "apg-stats",
    CLASS_TRACE: "apg-trace",
    CLASS_GRAMMAR: "apg-grammar",
    CLASS_RULES: "apg-rules",
    CLASS_RULESLINK: "apg-rules-link",
    CLASS_ATTRIBUTES: "apg-attrs"
};

});

parcelRegister("aII0i", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $7ce025a7524c360d$export$2f872c0f2117be69; }, function (v) { return $7ce025a7524c360d$export$2f872c0f2117be69 = v; });
$parcel$export(module.exports, "encode", function () { return $7ce025a7524c360d$export$c564cdbbe6da493; }, function (v) { return $7ce025a7524c360d$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "convert", function () { return $7ce025a7524c360d$export$9c68d69a4c5bbcf9; }, function (v) { return $7ce025a7524c360d$export$9c68d69a4c5bbcf9 = v; });
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module exposes the public encoding, decoding and conversion functions.
// Its private functions provide the disassembling and interpetation of the source and destination encoding types.
// In the case of Unicode encodings, private functions determine the presence of Byte Order Marks (BOMs), if any.
//
// Throws "TypeError" exceptions on input errors.
//
// The public decoding function. Returns an array of integers.
var $7ce025a7524c360d$export$2f872c0f2117be69;
// The public encoding function. Returns a Buffer-typed byte array.
var $7ce025a7524c360d$export$c564cdbbe6da493;
var $7ce025a7524c360d$export$9c68d69a4c5bbcf9;
"use strict;";

var $7ulbJ = parcelRequire("7ulbJ");
var $7ce025a7524c360d$require$Buffer = $7ulbJ.Buffer;

var $81yVs = parcelRequire("81yVs");
/* types */ const $7ce025a7524c360d$var$UTF8 = "UTF8";
const $7ce025a7524c360d$var$UTF16 = "UTF16";
const $7ce025a7524c360d$var$UTF16BE = "UTF16BE";
const $7ce025a7524c360d$var$UTF16LE = "UTF16LE";
const $7ce025a7524c360d$var$UTF32 = "UTF32";
const $7ce025a7524c360d$var$UTF32BE = "UTF32BE";
const $7ce025a7524c360d$var$UTF32LE = "UTF32LE";
const $7ce025a7524c360d$var$UINT7 = "UINT7";
const $7ce025a7524c360d$var$ASCII = "ASCII";
const $7ce025a7524c360d$var$BINARY = "BINARY";
const $7ce025a7524c360d$var$UINT8 = "UINT8";
const $7ce025a7524c360d$var$UINT16 = "UINT16";
const $7ce025a7524c360d$var$UINT16LE = "UINT16LE";
const $7ce025a7524c360d$var$UINT16BE = "UINT16BE";
const $7ce025a7524c360d$var$UINT32 = "UINT32";
const $7ce025a7524c360d$var$UINT32LE = "UINT32LE";
const $7ce025a7524c360d$var$UINT32BE = "UINT32BE";
const $7ce025a7524c360d$var$ESCAPED = "ESCAPED";
const $7ce025a7524c360d$var$STRING = "STRING";
/* private functions */ // Find the UTF8 BOM, if any.
const $7ce025a7524c360d$var$bom8 = function bom8(src) {
    src.type = $7ce025a7524c360d$var$UTF8;
    const buf = src.data;
    src.bom = 0;
    if (buf.length >= 3) {
        if (buf[0] === 0xef && buf[1] === 0xbb && buf[2] === 0xbf) src.bom = 3;
    }
};
// Find the UTF16 BOM, if any, and determine the UTF16 type.
// Defaults to UTF16BE.
// Throws TypeError exception if BOM does not match the specified type.
const $7ce025a7524c360d$var$bom16 = function bom16(src) {
    const buf = src.data;
    src.bom = 0;
    switch(src.type){
        case $7ce025a7524c360d$var$UTF16:
            src.type = $7ce025a7524c360d$var$UTF16BE;
            if (buf.length >= 2) {
                if (buf[0] === 0xfe && buf[1] === 0xff) src.bom = 2;
                else if (buf[0] === 0xff && buf[1] === 0xfe) {
                    src.type = $7ce025a7524c360d$var$UTF16LE;
                    src.bom = 2;
                }
            }
            break;
        case $7ce025a7524c360d$var$UTF16BE:
            src.type = $7ce025a7524c360d$var$UTF16BE;
            if (buf.length >= 2) {
                if (buf[0] === 0xfe && buf[1] === 0xff) src.bom = 2;
                else if (buf[0] === 0xff && buf[1] === 0xfe) throw new TypeError(`src type: "${$7ce025a7524c360d$var$UTF16BE}" specified but BOM is for "${$7ce025a7524c360d$var$UTF16LE}"`);
            }
            break;
        case $7ce025a7524c360d$var$UTF16LE:
            src.type = $7ce025a7524c360d$var$UTF16LE;
            if (buf.length >= 0) {
                if (buf[0] === 0xfe && buf[1] === 0xff) throw new TypeError(`src type: "${$7ce025a7524c360d$var$UTF16LE}" specified but BOM is for "${$7ce025a7524c360d$var$UTF16BE}"`);
                else if (buf[0] === 0xff && buf[1] === 0xfe) src.bom = 2;
            }
            break;
        default:
            throw new TypeError(`UTF16 BOM: src type "${src.type}" unrecognized`);
    }
};
// Find the UTF32 BOM, if any, and determine the UTF32 type.
// Defaults to UTF32BE.
// Throws exception if BOM does not match the specified type.
const $7ce025a7524c360d$var$bom32 = function bom32(src) {
    const buf = src.data;
    src.bom = 0;
    switch(src.type){
        case $7ce025a7524c360d$var$UTF32:
            src.type = $7ce025a7524c360d$var$UTF32BE;
            if (buf.length >= 4) {
                if (buf[0] === 0 && buf[1] === 0 && buf[2] === 0xfe && buf[3] === 0xff) src.bom = 4;
                if (buf[0] === 0xff && buf[1] === 0xfe && buf[2] === 0 && buf[3] === 0) {
                    src.type = $7ce025a7524c360d$var$UTF32LE;
                    src.bom = 4;
                }
            }
            break;
        case $7ce025a7524c360d$var$UTF32BE:
            src.type = $7ce025a7524c360d$var$UTF32BE;
            if (buf.length >= 4) {
                if (buf[0] === 0 && buf[1] === 0 && buf[2] === 0xfe && buf[3] === 0xff) src.bom = 4;
                if (buf[0] === 0xff && buf[1] === 0xfe && buf[2] === 0 && buf[3] === 0) throw new TypeError(`src type: ${$7ce025a7524c360d$var$UTF32BE} specified but BOM is for ${$7ce025a7524c360d$var$UTF32LE}"`);
            }
            break;
        case $7ce025a7524c360d$var$UTF32LE:
            src.type = $7ce025a7524c360d$var$UTF32LE;
            if (buf.length >= 4) {
                if (buf[0] === 0 && buf[1] === 0 && buf[2] === 0xfe && buf[3] === 0xff) throw new TypeError(`src type: "${$7ce025a7524c360d$var$UTF32LE}" specified but BOM is for "${$7ce025a7524c360d$var$UTF32BE}"`);
                if (buf[0] === 0xff && buf[1] === 0xfe && buf[2] === 0 && buf[3] === 0) src.bom = 4;
            }
            break;
        default:
            throw new TypeError(`UTF32 BOM: src type "${src.type}" unrecognized`);
    }
};
// Validates the source encoding type and matching data.
// If the BASE64: prefix is present, the base 64 decoding is done here as the initial step.
// - For type STRING, data must be a JavaScript string.
// - For type BASE64:*, data may be a string or Buffer.
// - For all other types, data must be a Buffer.
// - The BASE64: prefix is not allowed for type STRING.
const $7ce025a7524c360d$var$validateSrc = function validateSrc(type, data) {
    function getType(typeArg) {
        const ret = {
            type: "",
            base64: false
        };
        const rx = /^(base64:)?([a-zA-Z0-9]+)$/i;
        const result = rx.exec(typeArg);
        if (result) {
            if (result[2]) ret.type = result[2].toUpperCase();
            if (result[1]) ret.base64 = true;
        }
        return ret;
    }
    const ret = getType(type.toUpperCase());
    if (ret.base64) {
        /* handle base 64 */ if (ret.type === $7ce025a7524c360d$var$STRING) throw new TypeError(`type: "${type} "BASE64:" prefix not allowed with type ${$7ce025a7524c360d$var$STRING}`);
        if ($7ce025a7524c360d$require$Buffer.isBuffer(data)) ret.data = $81yVs.base64.decode(data);
        else if (typeof data === "string") {
            const buf = $7ce025a7524c360d$require$Buffer.from(data, "ascii");
            ret.data = $81yVs.base64.decode(buf);
        } else throw new TypeError(`type: "${type} unrecognized data type: typeof(data): ${typeof data}`);
    } else ret.data = data;
    switch(ret.type){
        case $7ce025a7524c360d$var$UTF8:
            $7ce025a7524c360d$var$bom8(ret);
            break;
        case $7ce025a7524c360d$var$UTF16:
        case $7ce025a7524c360d$var$UTF16BE:
        case $7ce025a7524c360d$var$UTF16LE:
            $7ce025a7524c360d$var$bom16(ret);
            break;
        case $7ce025a7524c360d$var$UTF32:
        case $7ce025a7524c360d$var$UTF32BE:
        case $7ce025a7524c360d$var$UTF32LE:
            $7ce025a7524c360d$var$bom32(ret);
            break;
        case $7ce025a7524c360d$var$UINT16:
            ret.type = $7ce025a7524c360d$var$UINT16BE;
            break;
        case $7ce025a7524c360d$var$UINT32:
            ret.type = $7ce025a7524c360d$var$UINT32BE;
            break;
        case $7ce025a7524c360d$var$ASCII:
            ret.type = $7ce025a7524c360d$var$UINT7;
            break;
        case $7ce025a7524c360d$var$BINARY:
            ret.type = $7ce025a7524c360d$var$UINT8;
            break;
        case $7ce025a7524c360d$var$UINT7:
        case $7ce025a7524c360d$var$UINT8:
        case $7ce025a7524c360d$var$UINT16LE:
        case $7ce025a7524c360d$var$UINT16BE:
        case $7ce025a7524c360d$var$UINT32LE:
        case $7ce025a7524c360d$var$UINT32BE:
        case $7ce025a7524c360d$var$STRING:
        case $7ce025a7524c360d$var$ESCAPED:
            break;
        default:
            throw new TypeError(`type: "${type}" not recognized`);
    }
    if (ret.type === $7ce025a7524c360d$var$STRING) {
        if (typeof ret.data !== "string") throw new TypeError(`type: "${type}" but data is not a string`);
    } else if (!$7ce025a7524c360d$require$Buffer.isBuffer(ret.data)) throw new TypeError(`type: "${type}" but data is not a Buffer`);
    return ret;
};
// Disassembles and validates the destination type.
// `chars` must be an Array of integers.
// The :BASE64 suffix is not allowed for type STRING.
const $7ce025a7524c360d$var$validateDst = function validateDst(type, chars) {
    function getType(typeArg) {
        let fix;
        let rem;
        const ret = {
            crlf: false,
            lf: false,
            base64: false,
            type: ""
        };
        /* prefix, if any */ const TRUE = true;
        while(TRUE){
            rem = typeArg;
            fix = typeArg.slice(0, 5);
            if (fix === "CRLF:") {
                ret.crlf = true;
                rem = typeArg.slice(5);
                break;
            }
            fix = typeArg.slice(0, 3);
            if (fix === "LF:") {
                ret.lf = true;
                rem = typeArg.slice(3);
                break;
            }
            break;
        }
        /* suffix, if any */ fix = rem.split(":");
        if (fix.length === 1) // eslint-disable-next-line prefer-destructuring
        ret.type = fix[0];
        else if (fix.length === 2 && fix[1] === "BASE64") {
            ret.base64 = true;
            // eslint-disable-next-line prefer-destructuring
            ret.type = fix[0];
        }
        return ret;
    }
    if (!Array.isArray(chars)) throw new TypeError(`dst chars: not array: "${typeof chars}`);
    if (typeof type !== "string") throw new TypeError(`dst type: not string: "${typeof type}`);
    const ret = getType(type.toUpperCase());
    switch(ret.type){
        case $7ce025a7524c360d$var$UTF8:
        case $7ce025a7524c360d$var$UTF16BE:
        case $7ce025a7524c360d$var$UTF16LE:
        case $7ce025a7524c360d$var$UTF32BE:
        case $7ce025a7524c360d$var$UTF32LE:
        case $7ce025a7524c360d$var$UINT7:
        case $7ce025a7524c360d$var$UINT8:
        case $7ce025a7524c360d$var$UINT16LE:
        case $7ce025a7524c360d$var$UINT16BE:
        case $7ce025a7524c360d$var$UINT32LE:
        case $7ce025a7524c360d$var$UINT32BE:
        case $7ce025a7524c360d$var$ESCAPED:
            break;
        case $7ce025a7524c360d$var$STRING:
            if (ret.base64) throw new TypeError(`":BASE64" suffix not allowed with type ${$7ce025a7524c360d$var$STRING}`);
            break;
        case $7ce025a7524c360d$var$ASCII:
            ret.type = $7ce025a7524c360d$var$UINT7;
            break;
        case $7ce025a7524c360d$var$BINARY:
            ret.type = $7ce025a7524c360d$var$UINT8;
            break;
        case $7ce025a7524c360d$var$UTF16:
            ret.type = $7ce025a7524c360d$var$UTF16BE;
            break;
        case $7ce025a7524c360d$var$UTF32:
            ret.type = $7ce025a7524c360d$var$UTF32BE;
            break;
        case $7ce025a7524c360d$var$UINT16:
            ret.type = $7ce025a7524c360d$var$UINT16BE;
            break;
        case $7ce025a7524c360d$var$UINT32:
            ret.type = $7ce025a7524c360d$var$UINT32BE;
            break;
        default:
            throw new TypeError(`dst type unrecognized: "${type}" : must have form [crlf:|lf:]type[:base64]`);
    }
    return ret;
};
// Select and call the requested encoding function.
const $7ce025a7524c360d$var$encode = function encode(type, chars) {
    switch(type){
        case $7ce025a7524c360d$var$UTF8:
            return $81yVs.utf8.encode(chars);
        case $7ce025a7524c360d$var$UTF16BE:
            return $81yVs.utf16be.encode(chars);
        case $7ce025a7524c360d$var$UTF16LE:
            return $81yVs.utf16le.encode(chars);
        case $7ce025a7524c360d$var$UTF32BE:
            return $81yVs.utf32be.encode(chars);
        case $7ce025a7524c360d$var$UTF32LE:
            return $81yVs.utf32le.encode(chars);
        case $7ce025a7524c360d$var$UINT7:
            return $81yVs.uint7.encode(chars);
        case $7ce025a7524c360d$var$UINT8:
            return $81yVs.uint8.encode(chars);
        case $7ce025a7524c360d$var$UINT16BE:
            return $81yVs.uint16be.encode(chars);
        case $7ce025a7524c360d$var$UINT16LE:
            return $81yVs.uint16le.encode(chars);
        case $7ce025a7524c360d$var$UINT32BE:
            return $81yVs.uint32be.encode(chars);
        case $7ce025a7524c360d$var$UINT32LE:
            return $81yVs.uint32le.encode(chars);
        case $7ce025a7524c360d$var$STRING:
            return $81yVs.string.encode(chars);
        case $7ce025a7524c360d$var$ESCAPED:
            return $81yVs.escaped.encode(chars);
        default:
            throw new TypeError(`encode type "${type}" not recognized`);
    }
};
// Select and call the requested decoding function.
// `src` contains BOM information as well as the source type and data.
const $7ce025a7524c360d$var$decode = function decode(src) {
    switch(src.type){
        case $7ce025a7524c360d$var$UTF8:
            return $81yVs.utf8.decode(src.data, src.bom);
        case $7ce025a7524c360d$var$UTF16LE:
            return $81yVs.utf16le.decode(src.data, src.bom);
        case $7ce025a7524c360d$var$UTF16BE:
            return $81yVs.utf16be.decode(src.data, src.bom);
        case $7ce025a7524c360d$var$UTF32BE:
            return $81yVs.utf32be.decode(src.data, src.bom);
        case $7ce025a7524c360d$var$UTF32LE:
            return $81yVs.utf32le.decode(src.data, src.bom);
        case $7ce025a7524c360d$var$UINT7:
            return $81yVs.uint7.decode(src.data);
        case $7ce025a7524c360d$var$UINT8:
            return $81yVs.uint8.decode(src.data);
        case $7ce025a7524c360d$var$UINT16BE:
            return $81yVs.uint16be.decode(src.data);
        case $7ce025a7524c360d$var$UINT16LE:
            return $81yVs.uint16le.decode(src.data);
        case $7ce025a7524c360d$var$UINT32BE:
            return $81yVs.uint32be.decode(src.data);
        case $7ce025a7524c360d$var$UINT32LE:
            return $81yVs.uint32le.decode(src.data);
        case $7ce025a7524c360d$var$STRING:
            return $81yVs.string.decode(src.data);
        case $7ce025a7524c360d$var$ESCAPED:
            return $81yVs.escaped.decode(src.data);
        default:
            throw new TypeError(`decode type "${src.type}" not recognized`);
    }
};
$7ce025a7524c360d$export$2f872c0f2117be69 = function exportsDecode(type, data) {
    const src = $7ce025a7524c360d$var$validateSrc(type, data);
    return $7ce025a7524c360d$var$decode(src);
};
$7ce025a7524c360d$export$c564cdbbe6da493 = function exportsEncode(type, chars) {
    let c;
    let buf;
    const dst = $7ce025a7524c360d$var$validateDst(type, chars);
    if (dst.crlf) {
        /* prefix with CRLF line end conversion, don't contaminate caller's chars array */ c = $81yVs.lineEnds.crlf(chars);
        buf = $7ce025a7524c360d$var$encode(dst.type, c);
    } else if (dst.lf) {
        /* prefix with LF line end conversion, don't contaminate caller's chars array */ c = $81yVs.lineEnds.lf(chars);
        buf = $7ce025a7524c360d$var$encode(dst.type, c);
    } else buf = $7ce025a7524c360d$var$encode(dst.type, chars);
    if (dst.base64) /* post base 64 encoding */ buf = $81yVs.base64.encode(buf);
    return buf;
};
// Converts data of type `srcType` to data of type `dstType`.
// `srcData` may be a JavaScript String, or node.js Buffer, depending on the corresponding type.
const $7ce025a7524c360d$var$convert = function convert(srcType, srcData, dstType) {
    return $7ce025a7524c360d$export$c564cdbbe6da493(dstType, $7ce025a7524c360d$export$2f872c0f2117be69(srcType, srcData));
};
$7ce025a7524c360d$export$9c68d69a4c5bbcf9 = $7ce025a7524c360d$var$convert;

});
parcelRegister("81yVs", function(module, exports) {

$parcel$export(module.exports, "utf8", function () { return $5d79823aa35daf7c$export$74329b762b589566; }, function (v) { return $5d79823aa35daf7c$export$74329b762b589566 = v; });
$parcel$export(module.exports, "utf16be", function () { return $5d79823aa35daf7c$export$8b9ec48b10867f55; }, function (v) { return $5d79823aa35daf7c$export$8b9ec48b10867f55 = v; });
$parcel$export(module.exports, "utf16le", function () { return $5d79823aa35daf7c$export$38eba41b60a2d16f; }, function (v) { return $5d79823aa35daf7c$export$38eba41b60a2d16f = v; });
$parcel$export(module.exports, "utf32be", function () { return $5d79823aa35daf7c$export$197feba3617118ca; }, function (v) { return $5d79823aa35daf7c$export$197feba3617118ca = v; });
$parcel$export(module.exports, "utf32le", function () { return $5d79823aa35daf7c$export$8ab18849c577cec0; }, function (v) { return $5d79823aa35daf7c$export$8ab18849c577cec0 = v; });
$parcel$export(module.exports, "uint7", function () { return $5d79823aa35daf7c$export$b0c04bc19f7bc936; }, function (v) { return $5d79823aa35daf7c$export$b0c04bc19f7bc936 = v; });
$parcel$export(module.exports, "uint8", function () { return $5d79823aa35daf7c$export$52e103c63c4e68cf; }, function (v) { return $5d79823aa35daf7c$export$52e103c63c4e68cf = v; });
$parcel$export(module.exports, "uint16be", function () { return $5d79823aa35daf7c$export$60dfe43c8297a8f8; }, function (v) { return $5d79823aa35daf7c$export$60dfe43c8297a8f8 = v; });
$parcel$export(module.exports, "uint16le", function () { return $5d79823aa35daf7c$export$b92d76f0ca6d1789; }, function (v) { return $5d79823aa35daf7c$export$b92d76f0ca6d1789 = v; });
$parcel$export(module.exports, "uint32be", function () { return $5d79823aa35daf7c$export$74c16dba6c885532; }, function (v) { return $5d79823aa35daf7c$export$74c16dba6c885532 = v; });
$parcel$export(module.exports, "uint32le", function () { return $5d79823aa35daf7c$export$5f744bb30a534bc9; }, function (v) { return $5d79823aa35daf7c$export$5f744bb30a534bc9 = v; });
$parcel$export(module.exports, "string", function () { return $5d79823aa35daf7c$export$22b082955e083ec3; }, function (v) { return $5d79823aa35daf7c$export$22b082955e083ec3 = v; });
$parcel$export(module.exports, "escaped", function () { return $5d79823aa35daf7c$export$a005f694cca0c8bd; }, function (v) { return $5d79823aa35daf7c$export$a005f694cca0c8bd = v; });
$parcel$export(module.exports, "lineEnds", function () { return $5d79823aa35daf7c$export$835798d3a82482b; }, function (v) { return $5d79823aa35daf7c$export$835798d3a82482b = v; });
$parcel$export(module.exports, "base64", function () { return $5d79823aa35daf7c$export$b3b2de96497acc47; }, function (v) { return $5d79823aa35daf7c$export$b3b2de96497acc47 = v; });
/* eslint-disable prefer-destructuring */ /* eslint-disable no-plusplus */ /* eslint-disable no-bitwise */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module contains the actual encoding and decoding algorithms.
// Throws "RangeError" exceptions on characters or bytes out of range for the given encoding.
// The UTF8 algorithms.
var $5d79823aa35daf7c$export$74329b762b589566;
// The UTF16BE algorithms.
var $5d79823aa35daf7c$export$8b9ec48b10867f55;
// The UTF16LE algorithms.
var $5d79823aa35daf7c$export$38eba41b60a2d16f;
// The UTF32BE algorithms.
var $5d79823aa35daf7c$export$197feba3617118ca;
// The UTF32LE algorithms.
var $5d79823aa35daf7c$export$8ab18849c577cec0;
// The UINT7 algorithms. ASCII or 7-bit unsigned integers.
var $5d79823aa35daf7c$export$b0c04bc19f7bc936;
// The UINT8 algorithms. BINARY, Latin 1 or 8-bit unsigned integers.
var $5d79823aa35daf7c$export$52e103c63c4e68cf;
// The UINT16BE algorithms. Big-endian 16-bit unsigned integers.
var $5d79823aa35daf7c$export$60dfe43c8297a8f8;
// The UINT16LE algorithms. Little-endian 16-bit unsigned integers.
var $5d79823aa35daf7c$export$b92d76f0ca6d1789;
// The UINT32BE algorithms. Big-endian 32-bit unsigned integers.
var $5d79823aa35daf7c$export$74c16dba6c885532;
// The UINT32LE algorithms. Little-endian 32-bit unsigned integers.
var $5d79823aa35daf7c$export$5f744bb30a534bc9;
// The STRING algorithms. Converts JavaScript strings to Array of 32-bit integers and vice versa.
// Uses the node.js Buffer's native "utf16le" capabilites.
var $5d79823aa35daf7c$export$22b082955e083ec3;
// The ESCAPED algorithms.
// Note that ESCAPED format contains only ASCII characters.
// The characters are always in the form of a Buffer of bytes.
var $5d79823aa35daf7c$export$a005f694cca0c8bd;
var $5d79823aa35daf7c$export$835798d3a82482b;
// The base 64 algorithms.
var $5d79823aa35daf7c$export$b3b2de96497acc47;
"use strict;";

var $7ulbJ = parcelRequire("7ulbJ");
var $5d79823aa35daf7c$require$Buffer = $7ulbJ.Buffer;
/* decoding error codes */ const $5d79823aa35daf7c$var$NON_SHORTEST = 0xfffffffc;
const $5d79823aa35daf7c$var$TRAILING = 0xfffffffd;
const $5d79823aa35daf7c$var$RANGE = 0xfffffffe;
const $5d79823aa35daf7c$var$ILL_FORMED = 0xffffffff;
/* mask[n] = 2**n - 1, ie. mask[n] = n bits on. e.g. mask[6] = %b111111 */ const $5d79823aa35daf7c$var$mask = [
    0,
    1,
    3,
    7,
    15,
    31,
    63,
    127,
    255,
    511,
    1023
];
/* ascii[n] = 'HH', where 0xHH = n, eg. ascii[254] = 'FE' */ const $5d79823aa35daf7c$var$ascii = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0A",
    "0B",
    "0C",
    "0D",
    "0E",
    "0F",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1A",
    "1B",
    "1C",
    "1D",
    "1E",
    "1F",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2A",
    "2B",
    "2C",
    "2D",
    "2E",
    "2F",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3A",
    "3B",
    "3C",
    "3D",
    "3E",
    "3F",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4A",
    "4B",
    "4C",
    "4D",
    "4E",
    "4F",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5A",
    "5B",
    "5C",
    "5D",
    "5E",
    "5F",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6A",
    "6B",
    "6C",
    "6D",
    "6E",
    "6F",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7A",
    "7B",
    "7C",
    "7D",
    "7E",
    "7F",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8A",
    "8B",
    "8C",
    "8D",
    "8E",
    "8F",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9A",
    "9B",
    "9C",
    "9D",
    "9E",
    "9F",
    "A0",
    "A1",
    "A2",
    "A3",
    "A4",
    "A5",
    "A6",
    "A7",
    "A8",
    "A9",
    "AA",
    "AB",
    "AC",
    "AD",
    "AE",
    "AF",
    "B0",
    "B1",
    "B2",
    "B3",
    "B4",
    "B5",
    "B6",
    "B7",
    "B8",
    "B9",
    "BA",
    "BB",
    "BC",
    "BD",
    "BE",
    "BF",
    "C0",
    "C1",
    "C2",
    "C3",
    "C4",
    "C5",
    "C6",
    "C7",
    "C8",
    "C9",
    "CA",
    "CB",
    "CC",
    "CD",
    "CE",
    "CF",
    "D0",
    "D1",
    "D2",
    "D3",
    "D4",
    "D5",
    "D6",
    "D7",
    "D8",
    "D9",
    "DA",
    "DB",
    "DC",
    "DD",
    "DE",
    "DF",
    "E0",
    "E1",
    "E2",
    "E3",
    "E4",
    "E5",
    "E6",
    "E7",
    "E8",
    "E9",
    "EA",
    "EB",
    "EC",
    "ED",
    "EE",
    "EF",
    "F0",
    "F1",
    "F2",
    "F3",
    "F4",
    "F5",
    "F6",
    "F7",
    "F8",
    "F9",
    "FA",
    "FB",
    "FC",
    "FD",
    "FE",
    "FF"
];
/* vector of base 64 characters */ const $5d79823aa35daf7c$var$base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".split("");
/* vector of base 64 character codes */ const $5d79823aa35daf7c$var$base64codes = [];
$5d79823aa35daf7c$var$base64chars.forEach((char)=>{
    $5d79823aa35daf7c$var$base64codes.push(char.charCodeAt(0));
});
$5d79823aa35daf7c$export$74329b762b589566 = {
    encode (chars) {
        const bytes = [];
        chars.forEach((char)=>{
            if (char >= 0 && char <= 0x7f) bytes.push(char);
            else if (char <= 0x7ff) {
                bytes.push(0xc0 + (char >> 6 & $5d79823aa35daf7c$var$mask[5]));
                bytes.push(0x80 + (char & $5d79823aa35daf7c$var$mask[6]));
            } else if (char < 0xd800 || char > 0xdfff && char <= 0xffff) {
                bytes.push(0xe0 + (char >> 12 & $5d79823aa35daf7c$var$mask[4]));
                bytes.push(0x80 + (char >> 6 & $5d79823aa35daf7c$var$mask[6]));
                bytes.push(0x80 + (char & $5d79823aa35daf7c$var$mask[6]));
            } else if (char >= 0x10000 && char <= 0x10ffff) {
                const u = char >> 16 & $5d79823aa35daf7c$var$mask[5];
                bytes.push(0xf0 + (u >> 2));
                bytes.push(0x80 + ((u & $5d79823aa35daf7c$var$mask[2]) << 4) + (char >> 12 & $5d79823aa35daf7c$var$mask[4]));
                bytes.push(0x80 + (char >> 6 & $5d79823aa35daf7c$var$mask[6]));
                bytes.push(0x80 + (char & $5d79823aa35daf7c$var$mask[6]));
            } else throw new RangeError(`utf8.encode: character out of range: char: ${char}`);
        });
        return $5d79823aa35daf7c$require$Buffer.from(bytes);
    },
    decode (buf, bom) {
        /* bytes functions return error for non-shortest forms & values out of range */ function bytes2(b1, b2) {
            /* U+0080..U+07FF */ /* 00000000 00000yyy yyxxxxxx | 110yyyyy 10xxxxxx */ if ((b2 & 0xc0) !== 0x80) return $5d79823aa35daf7c$var$TRAILING;
            const x = ((b1 & $5d79823aa35daf7c$var$mask[5]) << 6) + (b2 & $5d79823aa35daf7c$var$mask[6]);
            if (x < 0x80) return $5d79823aa35daf7c$var$NON_SHORTEST;
            return x;
        }
        function bytes3(b1, b2, b3) {
            /* U+0800..U+FFFF */ /* 00000000 zzzzyyyy yyxxxxxx | 1110zzzz 10yyyyyy 10xxxxxx */ if ((b3 & 0xc0) !== 0x80 || (b2 & 0xc0) !== 0x80) return $5d79823aa35daf7c$var$TRAILING;
            const x = ((b1 & $5d79823aa35daf7c$var$mask[4]) << 12) + ((b2 & $5d79823aa35daf7c$var$mask[6]) << 6) + (b3 & $5d79823aa35daf7c$var$mask[6]);
            if (x < 0x800) return $5d79823aa35daf7c$var$NON_SHORTEST;
            if (x >= 0xd800 && x <= 0xdfff) return $5d79823aa35daf7c$var$RANGE;
            return x;
        }
        function bytes4(b1, b2, b3, b4) {
            /* U+10000..U+10FFFF */ /* 000uuuuu zzzzyyyy yyxxxxxx | 11110uuu 10uuzzzz 10yyyyyy 10xxxxxx */ if ((b4 & 0xc0) !== 0x80 || (b3 & 0xc0) !== 0x80 || (b2 & 0xc0) !== 0x80) return $5d79823aa35daf7c$var$TRAILING;
            const x = (((b1 & $5d79823aa35daf7c$var$mask[3]) << 2) + (b2 >> 4 & $5d79823aa35daf7c$var$mask[2]) << 16) + ((b2 & $5d79823aa35daf7c$var$mask[4]) << 12) + ((b3 & $5d79823aa35daf7c$var$mask[6]) << 6) + (b4 & $5d79823aa35daf7c$var$mask[6]);
            if (x < 0x10000) return $5d79823aa35daf7c$var$NON_SHORTEST;
            if (x > 0x10ffff) return $5d79823aa35daf7c$var$RANGE;
            return x;
        }
        let c;
        let b1;
        let i1;
        let i2;
        let i3;
        let inc;
        const len = buf.length;
        let i = bom ? 3 : 0;
        const chars = [];
        while(i < len){
            b1 = buf[i];
            c = $5d79823aa35daf7c$var$ILL_FORMED;
            const TRUE = true;
            while(TRUE){
                if (b1 >= 0 && b1 <= 0x7f) {
                    /* U+0000..U+007F 00..7F */ c = b1;
                    inc = 1;
                    break;
                }
                i1 = i + 1;
                if (i1 < len && b1 >= 0xc2 && b1 <= 0xdf) {
                    /* U+0080..U+07FF C2..DF 80..BF */ c = bytes2(b1, buf[i1]);
                    inc = 2;
                    break;
                }
                i2 = i + 2;
                if (i2 < len && b1 >= 0xe0 && b1 <= 0xef) {
                    /* U+0800..U+FFFF */ c = bytes3(b1, buf[i1], buf[i2]);
                    inc = 3;
                    break;
                }
                i3 = i + 3;
                if (i3 < len && b1 >= 0xf0 && b1 <= 0xf4) {
                    /* U+10000..U+10FFFF */ c = bytes4(b1, buf[i1], buf[i2], buf[i3]);
                    inc = 4;
                    break;
                }
                break;
            }
            if (c > 0x10ffff) {
                const at = `byte[${i}]`;
                if (c === $5d79823aa35daf7c$var$ILL_FORMED) throw new RangeError(`utf8.decode: ill-formed UTF8 byte sequence found at: ${at}`);
                if (c === $5d79823aa35daf7c$var$TRAILING) throw new RangeError(`utf8.decode: illegal trailing byte found at: ${at}`);
                if (c === $5d79823aa35daf7c$var$RANGE) throw new RangeError(`utf8.decode: code point out of range found at: ${at}`);
                if (c === $5d79823aa35daf7c$var$NON_SHORTEST) throw new RangeError(`utf8.decode: non-shortest form found at: ${at}`);
                throw new RangeError(`utf8.decode: unrecognized error found at: ${at}`);
            }
            chars.push(c);
            i += inc;
        }
        return chars;
    }
};
$5d79823aa35daf7c$export$8b9ec48b10867f55 = {
    encode (chars) {
        const bytes = [];
        let char;
        let h;
        let l;
        for(let i = 0; i < chars.length; i += 1){
            char = chars[i];
            if (char >= 0 && char <= 0xd7ff || char >= 0xe000 && char <= 0xffff) {
                bytes.push(char >> 8 & $5d79823aa35daf7c$var$mask[8]);
                bytes.push(char & $5d79823aa35daf7c$var$mask[8]);
            } else if (char >= 0x10000 && char <= 0x10ffff) {
                l = char - 0x10000;
                h = 0xd800 + (l >> 10);
                l = 0xdc00 + (l & $5d79823aa35daf7c$var$mask[10]);
                bytes.push(h >> 8 & $5d79823aa35daf7c$var$mask[8]);
                bytes.push(h & $5d79823aa35daf7c$var$mask[8]);
                bytes.push(l >> 8 & $5d79823aa35daf7c$var$mask[8]);
                bytes.push(l & $5d79823aa35daf7c$var$mask[8]);
            } else throw new RangeError(`utf16be.encode: UTF16BE value out of range: char[${i}]: ${char}`);
        }
        return $5d79823aa35daf7c$require$Buffer.from(bytes);
    },
    decode (buf, bom) {
        /* assumes caller has insured that buf is a Buffer of bytes */ if (buf.length % 2 > 0) throw new RangeError(`utf16be.decode: data length must be even multiple of 2: length: ${buf.length}`);
        const chars = [];
        const len = buf.length;
        let i = bom ? 2 : 0;
        let j = 0;
        let c;
        let inc;
        let i1;
        let i3;
        let high;
        let low;
        while(i < len){
            const TRUE = true;
            while(TRUE){
                i1 = i + 1;
                if (i1 < len) {
                    high = (buf[i] << 8) + buf[i1];
                    if (high < 0xd800 || high > 0xdfff) {
                        c = high;
                        inc = 2;
                        break;
                    }
                    i3 = i + 3;
                    if (i3 < len) {
                        low = (buf[i + 2] << 8) + buf[i3];
                        if (high <= 0xdbff && low >= 0xdc00 && low <= 0xdfff) {
                            c = 0x10000 + (high - 0xd800 << 10) + (low - 0xdc00);
                            inc = 4;
                            break;
                        }
                    }
                }
                /* if we fall through to here, it is an ill-formed sequence */ throw new RangeError(`utf16be.decode: ill-formed UTF16BE byte sequence found: byte[${i}]`);
            }
            chars[j++] = c;
            i += inc;
        }
        return chars;
    }
};
$5d79823aa35daf7c$export$38eba41b60a2d16f = {
    encode (chars) {
        const bytes = [];
        let char;
        let h;
        let l;
        for(let i = 0; i < chars.length; i += 1){
            char = chars[i];
            if (char >= 0 && char <= 0xd7ff || char >= 0xe000 && char <= 0xffff) {
                bytes.push(char & $5d79823aa35daf7c$var$mask[8]);
                bytes.push(char >> 8 & $5d79823aa35daf7c$var$mask[8]);
            } else if (char >= 0x10000 && char <= 0x10ffff) {
                l = char - 0x10000;
                h = 0xd800 + (l >> 10);
                l = 0xdc00 + (l & $5d79823aa35daf7c$var$mask[10]);
                bytes.push(h & $5d79823aa35daf7c$var$mask[8]);
                bytes.push(h >> 8 & $5d79823aa35daf7c$var$mask[8]);
                bytes.push(l & $5d79823aa35daf7c$var$mask[8]);
                bytes.push(l >> 8 & $5d79823aa35daf7c$var$mask[8]);
            } else throw new RangeError(`utf16le.encode: UTF16LE value out of range: char[${i}]: ${char}`);
        }
        return $5d79823aa35daf7c$require$Buffer.from(bytes);
    },
    decode (buf, bom) {
        /* assumes caller has insured that buf is a Buffer of bytes */ if (buf.length % 2 > 0) throw new RangeError(`utf16le.decode: data length must be even multiple of 2: length: ${buf.length}`);
        const chars = [];
        const len = buf.length;
        let i = bom ? 2 : 0;
        let j = 0;
        let c;
        let inc;
        let i1;
        let i3;
        let high;
        let low;
        while(i < len){
            const TRUE = true;
            while(TRUE){
                i1 = i + 1;
                if (i1 < len) {
                    high = (buf[i1] << 8) + buf[i];
                    if (high < 0xd800 || high > 0xdfff) {
                        c = high;
                        inc = 2;
                        break;
                    }
                    i3 = i + 3;
                    if (i3 < len) {
                        low = (buf[i3] << 8) + buf[i + 2];
                        if (high <= 0xdbff && low >= 0xdc00 && low <= 0xdfff) {
                            c = 0x10000 + (high - 0xd800 << 10) + (low - 0xdc00);
                            inc = 4;
                            break;
                        }
                    }
                }
                /* if we fall through to here, it is an ill-formed sequence */ throw new RangeError(`utf16le.decode: ill-formed UTF16LE byte sequence found: byte[${i}]`);
            }
            chars[j++] = c;
            i += inc;
        }
        return chars;
    }
};
$5d79823aa35daf7c$export$197feba3617118ca = {
    encode (chars) {
        const buf = $5d79823aa35daf7c$require$Buffer.alloc(chars.length * 4);
        let i = 0;
        chars.forEach((char)=>{
            if (char >= 0xd800 && char <= 0xdfff || char > 0x10ffff) throw new RangeError(`utf32be.encode: UTF32BE character code out of range: char[${i / 4}]: ${char}`);
            buf[i++] = char >> 24 & $5d79823aa35daf7c$var$mask[8];
            buf[i++] = char >> 16 & $5d79823aa35daf7c$var$mask[8];
            buf[i++] = char >> 8 & $5d79823aa35daf7c$var$mask[8];
            buf[i++] = char & $5d79823aa35daf7c$var$mask[8];
        });
        return buf;
    },
    decode (buf, bom) {
        /* caller to insure buf is a Buffer of bytes */ if (buf.length % 4 > 0) throw new RangeError(`utf32be.decode: UTF32BE byte length must be even multiple of 4: length: ${buf.length}`);
        const chars = [];
        let i = bom ? 4 : 0;
        for(; i < buf.length; i += 4){
            const char = (buf[i] << 24) + (buf[i + 1] << 16) + (buf[i + 2] << 8) + buf[i + 3];
            if (char >= 0xd800 && char <= 0xdfff || char > 0x10ffff) throw new RangeError(`utf32be.decode: UTF32BE character code out of range: char[${i / 4}]: ${char}`);
            chars.push(char);
        }
        return chars;
    }
};
$5d79823aa35daf7c$export$8ab18849c577cec0 = {
    encode (chars) {
        const buf = $5d79823aa35daf7c$require$Buffer.alloc(chars.length * 4);
        let i = 0;
        chars.forEach((char)=>{
            if (char >= 0xd800 && char <= 0xdfff || char > 0x10ffff) throw new RangeError(`utf32le.encode: UTF32LE character code out of range: char[${i / 4}]: ${char}`);
            buf[i++] = char & $5d79823aa35daf7c$var$mask[8];
            buf[i++] = char >> 8 & $5d79823aa35daf7c$var$mask[8];
            buf[i++] = char >> 16 & $5d79823aa35daf7c$var$mask[8];
            buf[i++] = char >> 24 & $5d79823aa35daf7c$var$mask[8];
        });
        return buf;
    },
    decode (buf, bom) {
        /* caller to insure buf is a Buffer of bytes */ if (buf.length % 4 > 0) throw new RangeError(`utf32be.decode: UTF32LE byte length must be even multiple of 4: length: ${buf.length}`);
        const chars = [];
        let i = bom ? 4 : 0;
        for(; i < buf.length; i += 4){
            const char = (buf[i + 3] << 24) + (buf[i + 2] << 16) + (buf[i + 1] << 8) + buf[i];
            if (char >= 0xd800 && char <= 0xdfff || char > 0x10ffff) throw new RangeError(`utf32le.encode: UTF32LE character code out of range: char[${i / 4}]: ${char}`);
            chars.push(char);
        }
        return chars;
    }
};
$5d79823aa35daf7c$export$b0c04bc19f7bc936 = {
    encode (chars) {
        const buf = $5d79823aa35daf7c$require$Buffer.alloc(chars.length);
        for(let i = 0; i < chars.length; i += 1){
            if (chars[i] > 0x7f) throw new RangeError(`uint7.encode: UINT7 character code out of range: char[${i}]: ${chars[i]}`);
            buf[i] = chars[i];
        }
        return buf;
    },
    decode (buf) {
        const chars = [];
        for(let i = 0; i < buf.length; i += 1){
            if (buf[i] > 0x7f) throw new RangeError(`uint7.decode: UINT7 character code out of range: byte[${i}]: ${buf[i]}`);
            chars[i] = buf[i];
        }
        return chars;
    }
};
$5d79823aa35daf7c$export$52e103c63c4e68cf = {
    encode (chars) {
        const buf = $5d79823aa35daf7c$require$Buffer.alloc(chars.length);
        for(let i = 0; i < chars.length; i += 1){
            if (chars[i] > 0xff) throw new RangeError(`uint8.encode: UINT8 character code out of range: char[${i}]: ${chars[i]}`);
            buf[i] = chars[i];
        }
        return buf;
    },
    decode (buf) {
        const chars = [];
        for(let i = 0; i < buf.length; i += 1)chars[i] = buf[i];
        return chars;
    }
};
$5d79823aa35daf7c$export$60dfe43c8297a8f8 = {
    encode (chars) {
        const buf = $5d79823aa35daf7c$require$Buffer.alloc(chars.length * 2);
        let i = 0;
        chars.forEach((char)=>{
            if (char > 0xffff) throw new RangeError(`uint16be.encode: UINT16BE character code out of range: char[${i / 2}]: ${char}`);
            buf[i++] = char >> 8 & $5d79823aa35daf7c$var$mask[8];
            buf[i++] = char & $5d79823aa35daf7c$var$mask[8];
        });
        return buf;
    },
    decode (buf) {
        if (buf.length % 2 > 0) throw new RangeError(`uint16be.decode: UINT16BE byte length must be even multiple of 2: length: ${buf.length}`);
        const chars = [];
        for(let i = 0; i < buf.length; i += 2)chars.push((buf[i] << 8) + buf[i + 1]);
        return chars;
    }
};
$5d79823aa35daf7c$export$b92d76f0ca6d1789 = {
    encode (chars) {
        const buf = $5d79823aa35daf7c$require$Buffer.alloc(chars.length * 2);
        let i = 0;
        chars.forEach((char)=>{
            if (char > 0xffff) throw new RangeError(`uint16le.encode: UINT16LE character code out of range: char[${i / 2}]: ${char}`);
            buf[i++] = char & $5d79823aa35daf7c$var$mask[8];
            buf[i++] = char >> 8 & $5d79823aa35daf7c$var$mask[8];
        });
        return buf;
    },
    decode (buf) {
        if (buf.length % 2 > 0) throw new RangeError(`uint16le.decode: UINT16LE byte length must be even multiple of 2: length: ${buf.length}`);
        const chars = [];
        for(let i = 0; i < buf.length; i += 2)chars.push((buf[i + 1] << 8) + buf[i]);
        return chars;
    }
};
$5d79823aa35daf7c$export$74c16dba6c885532 = {
    encode (chars) {
        const buf = $5d79823aa35daf7c$require$Buffer.alloc(chars.length * 4);
        let i = 0;
        chars.forEach((char)=>{
            buf[i++] = char >> 24 & $5d79823aa35daf7c$var$mask[8];
            buf[i++] = char >> 16 & $5d79823aa35daf7c$var$mask[8];
            buf[i++] = char >> 8 & $5d79823aa35daf7c$var$mask[8];
            buf[i++] = char & $5d79823aa35daf7c$var$mask[8];
        });
        return buf;
    },
    decode (buf) {
        if (buf.length % 4 > 0) throw new RangeError(`uint32be.decode: UINT32BE byte length must be even multiple of 4: length: ${buf.length}`);
        const chars = [];
        for(let i = 0; i < buf.length; i += 4)chars.push((buf[i] << 24) + (buf[i + 1] << 16) + (buf[i + 2] << 8) + buf[i + 3]);
        return chars;
    }
};
$5d79823aa35daf7c$export$5f744bb30a534bc9 = {
    encode (chars) {
        const buf = $5d79823aa35daf7c$require$Buffer.alloc(chars.length * 4);
        let i = 0;
        chars.forEach((char)=>{
            buf[i++] = char & $5d79823aa35daf7c$var$mask[8];
            buf[i++] = char >> 8 & $5d79823aa35daf7c$var$mask[8];
            buf[i++] = char >> 16 & $5d79823aa35daf7c$var$mask[8];
            buf[i++] = char >> 24 & $5d79823aa35daf7c$var$mask[8];
        });
        return buf;
    },
    decode (buf) {
        /* caller to insure buf is a Buffer of bytes */ if (buf.length % 4 > 0) throw new RangeError(`uint32le.decode: UINT32LE byte length must be even multiple of 4: length: ${buf.length}`);
        const chars = [];
        for(let i = 0; i < buf.length; i += 4)chars.push((buf[i + 3] << 24) + (buf[i + 2] << 16) + (buf[i + 1] << 8) + buf[i]);
        return chars;
    }
};
$5d79823aa35daf7c$export$22b082955e083ec3 = {
    encode (chars) {
        return $5d79823aa35daf7c$export$38eba41b60a2d16f.encode(chars).toString("utf16le");
    },
    decode (str) {
        return $5d79823aa35daf7c$export$38eba41b60a2d16f.decode($5d79823aa35daf7c$require$Buffer.from(str, "utf16le"), 0);
    }
};
$5d79823aa35daf7c$export$a005f694cca0c8bd = {
    // Encodes an Array of 32-bit integers into ESCAPED format.
    encode (chars) {
        const bytes = [];
        for(let i = 0; i < chars.length; i += 1){
            const char = chars[i];
            if (char === 96) {
                bytes.push(char);
                bytes.push(char);
            } else if (char === 10) bytes.push(char);
            else if (char >= 32 && char <= 126) bytes.push(char);
            else {
                let str = "";
                if (char >= 0 && char <= 31) str += `\`x${$5d79823aa35daf7c$var$ascii[char]}`;
                else if (char >= 127 && char <= 255) str += `\`x${$5d79823aa35daf7c$var$ascii[char]}`;
                else if (char >= 0x100 && char <= 0xffff) str += `\`u${$5d79823aa35daf7c$var$ascii[char >> 8 & $5d79823aa35daf7c$var$mask[8]]}${$5d79823aa35daf7c$var$ascii[char & $5d79823aa35daf7c$var$mask[8]]}`;
                else if (char >= 0x10000 && char <= 0xffffffff) {
                    str += "`u{";
                    const digit = char >> 24 & $5d79823aa35daf7c$var$mask[8];
                    if (digit > 0) str += $5d79823aa35daf7c$var$ascii[digit];
                    str += `${$5d79823aa35daf7c$var$ascii[char >> 16 & $5d79823aa35daf7c$var$mask[8]] + $5d79823aa35daf7c$var$ascii[char >> 8 & $5d79823aa35daf7c$var$mask[8]] + $5d79823aa35daf7c$var$ascii[char & $5d79823aa35daf7c$var$mask[8]]}}`;
                } else throw new Error("escape.encode(char): char > 0xffffffff not allowed");
                const buf = $5d79823aa35daf7c$require$Buffer.from(str);
                buf.forEach((b)=>{
                    bytes.push(b);
                });
            }
        }
        return $5d79823aa35daf7c$require$Buffer.from(bytes);
    },
    // Decodes ESCAPED format from a Buffer of bytes to an Array of 32-bit integers.
    decode (buf) {
        function isHex(hex) {
            if (hex >= 48 && hex <= 57 || hex >= 65 && hex <= 70 || hex >= 97 && hex <= 102) return true;
            return false;
        }
        function getx(i, len, bufArg) {
            const ret = {
                char: null,
                nexti: i + 2,
                error: true
            };
            if (i + 1 < len) {
                if (isHex(bufArg[i]) && isHex(bufArg[i + 1])) {
                    const str = String.fromCodePoint(bufArg[i], bufArg[i + 1]);
                    ret.char = parseInt(str, 16);
                    if (!Number.isNaN(ret.char)) ret.error = false;
                }
            }
            return ret;
        }
        function getu(i, len, bufArg) {
            const ret = {
                char: null,
                nexti: i + 4,
                error: true
            };
            if (i + 3 < len) {
                if (isHex(bufArg[i]) && isHex(bufArg[i + 1]) && isHex(bufArg[i + 2]) && isHex(bufArg[i + 3])) {
                    const str = String.fromCodePoint(bufArg[i], bufArg[i + 1], bufArg[i + 2], bufArg[i + 3]);
                    ret.char = parseInt(str, 16);
                    if (!Number.isNaN(ret.char)) ret.error = false;
                }
            }
            return ret;
        }
        function getU(i, len, bufArg) {
            const ret = {
                char: null,
                nexti: i + 4,
                error: true
            };
            let str = "";
            while(i < len && isHex(bufArg[i])){
                str += String.fromCodePoint(bufArg[i]);
                // eslint-disable-next-line no-param-reassign
                i += 1;
            }
            ret.char = parseInt(str, 16);
            if (bufArg[i] === 125 && !Number.isNaN(ret.char)) ret.error = false;
            ret.nexti = i + 1;
            return ret;
        }
        const chars = [];
        const len = buf.length;
        let i1;
        let ret;
        let error;
        let i = 0;
        while(i < len){
            const TRUE = true;
            while(TRUE){
                error = true;
                if (buf[i] !== 96) {
                    /* unescaped character */ chars.push(buf[i]);
                    i += 1;
                    error = false;
                    break;
                }
                i1 = i + 1;
                if (i1 >= len) break;
                if (buf[i1] === 96) {
                    /* escaped grave accent */ chars.push(96);
                    i += 2;
                    error = false;
                    break;
                }
                if (buf[i1] === 120) {
                    ret = getx(i1 + 1, len, buf);
                    if (ret.error) break;
                    /* escaped hex */ chars.push(ret.char);
                    i = ret.nexti;
                    error = false;
                    break;
                }
                if (buf[i1] === 117) {
                    if (buf[i1 + 1] === 123) {
                        ret = getU(i1 + 2, len, buf);
                        if (ret.error) break;
                        /* escaped utf-32 */ chars.push(ret.char);
                        i = ret.nexti;
                        error = false;
                        break;
                    }
                    ret = getu(i1 + 1, len, buf);
                    if (ret.error) break;
                    /* escaped utf-16 */ chars.push(ret.char);
                    i = ret.nexti;
                    error = false;
                    break;
                }
                break;
            }
            if (error) throw new Error(`escaped.decode: ill-formed escape sequence at buf[${i}]`);
        }
        return chars;
    }
};
// The line end conversion algorigthms.
const $5d79823aa35daf7c$var$CR = 13;
const $5d79823aa35daf7c$var$LF = 10;
$5d79823aa35daf7c$export$835798d3a82482b = {
    crlf (chars) {
        const lfchars = [];
        let i = 0;
        while(i < chars.length)switch(chars[i]){
            case $5d79823aa35daf7c$var$CR:
                if (i + 1 < chars.length && chars[i + 1] === $5d79823aa35daf7c$var$LF) i += 2;
                else i += 1;
                lfchars.push($5d79823aa35daf7c$var$CR);
                lfchars.push($5d79823aa35daf7c$var$LF);
                break;
            case $5d79823aa35daf7c$var$LF:
                lfchars.push($5d79823aa35daf7c$var$CR);
                lfchars.push($5d79823aa35daf7c$var$LF);
                i += 1;
                break;
            default:
                lfchars.push(chars[i]);
                i += 1;
                break;
        }
        if (lfchars.length > 0 && lfchars[lfchars.length - 1] !== $5d79823aa35daf7c$var$LF) {
            lfchars.push($5d79823aa35daf7c$var$CR);
            lfchars.push($5d79823aa35daf7c$var$LF);
        }
        return lfchars;
    },
    lf (chars) {
        const lfchars = [];
        let i = 0;
        while(i < chars.length)switch(chars[i]){
            case $5d79823aa35daf7c$var$CR:
                if (i + 1 < chars.length && chars[i + 1] === $5d79823aa35daf7c$var$LF) i += 2;
                else i += 1;
                lfchars.push($5d79823aa35daf7c$var$LF);
                break;
            case $5d79823aa35daf7c$var$LF:
                lfchars.push($5d79823aa35daf7c$var$LF);
                i += 1;
                break;
            default:
                lfchars.push(chars[i]);
                i += 1;
                break;
        }
        if (lfchars.length > 0 && lfchars[lfchars.length - 1] !== $5d79823aa35daf7c$var$LF) lfchars.push($5d79823aa35daf7c$var$LF);
        return lfchars;
    }
};
$5d79823aa35daf7c$export$b3b2de96497acc47 = {
    encode (buf) {
        if (buf.length === 0) return $5d79823aa35daf7c$require$Buffer.alloc(0);
        let i;
        let j;
        let n;
        let tail = buf.length % 3;
        tail = tail > 0 ? 3 - tail : 0;
        let units = (buf.length + tail) / 3;
        const base64 = $5d79823aa35daf7c$require$Buffer.alloc(units * 4);
        if (tail > 0) units -= 1;
        i = 0;
        j = 0;
        for(let u = 0; u < units; u += 1){
            n = buf[i++] << 16;
            n += buf[i++] << 8;
            n += buf[i++];
            base64[j++] = $5d79823aa35daf7c$var$base64codes[n >> 18 & $5d79823aa35daf7c$var$mask[6]];
            base64[j++] = $5d79823aa35daf7c$var$base64codes[n >> 12 & $5d79823aa35daf7c$var$mask[6]];
            base64[j++] = $5d79823aa35daf7c$var$base64codes[n >> 6 & $5d79823aa35daf7c$var$mask[6]];
            base64[j++] = $5d79823aa35daf7c$var$base64codes[n & $5d79823aa35daf7c$var$mask[6]];
        }
        if (tail === 0) return base64;
        if (tail === 1) {
            n = buf[i++] << 16;
            n += buf[i] << 8;
            base64[j++] = $5d79823aa35daf7c$var$base64codes[n >> 18 & $5d79823aa35daf7c$var$mask[6]];
            base64[j++] = $5d79823aa35daf7c$var$base64codes[n >> 12 & $5d79823aa35daf7c$var$mask[6]];
            base64[j++] = $5d79823aa35daf7c$var$base64codes[n >> 6 & $5d79823aa35daf7c$var$mask[6]];
            base64[j] = $5d79823aa35daf7c$var$base64codes[64];
            return base64;
        }
        if (tail === 2) {
            n = buf[i] << 16;
            base64[j++] = $5d79823aa35daf7c$var$base64codes[n >> 18 & $5d79823aa35daf7c$var$mask[6]];
            base64[j++] = $5d79823aa35daf7c$var$base64codes[n >> 12 & $5d79823aa35daf7c$var$mask[6]];
            base64[j++] = $5d79823aa35daf7c$var$base64codes[64];
            base64[j] = $5d79823aa35daf7c$var$base64codes[64];
            return base64;
        }
        return undefined;
    },
    decode (codes) {
        /* remove white space and ctrl characters, validate & translate characters */ function validate(buf) {
            const chars = [];
            let tail = 0;
            for(let i = 0; i < buf.length; i += 1){
                const char = buf[i];
                const TRUE = true;
                while(TRUE){
                    if (char === 32 || char === 9 || char === 10 || char === 13) break;
                    if (char >= 65 && char <= 90) {
                        chars.push(char - 65);
                        break;
                    }
                    if (char >= 97 && char <= 122) {
                        chars.push(char - 71);
                        break;
                    }
                    if (char >= 48 && char <= 57) {
                        chars.push(char + 4);
                        break;
                    }
                    if (char === 43) {
                        chars.push(62);
                        break;
                    }
                    if (char === 47) {
                        chars.push(63);
                        break;
                    }
                    if (char === 61) {
                        chars.push(64);
                        tail += 1;
                        break;
                    }
                    /* invalid character */ throw new RangeError(`base64.decode: invalid character buf[${i}]: ${char}`);
                }
            }
            /* validate length */ if (chars.length % 4 > 0) throw new RangeError(`base64.decode: string length not integral multiple of 4: ${chars.length}`);
            /* validate tail */ switch(tail){
                case 0:
                    break;
                case 1:
                    if (chars[chars.length - 1] !== 64) throw new RangeError("base64.decode: one tail character found: not last character");
                    break;
                case 2:
                    if (chars[chars.length - 1] !== 64 || chars[chars.length - 2] !== 64) throw new RangeError("base64.decode: two tail characters found: not last characters");
                    break;
                default:
                    throw new RangeError(`base64.decode: more than two tail characters found: ${tail}`);
            }
            return {
                tail: tail,
                buf: $5d79823aa35daf7c$require$Buffer.from(chars)
            };
        }
        if (codes.length === 0) return $5d79823aa35daf7c$require$Buffer.alloc(0);
        const val = validate(codes);
        const { tail: tail } = val;
        const base64 = val.buf;
        let i;
        let j;
        let n;
        let units = base64.length / 4;
        const buf = $5d79823aa35daf7c$require$Buffer.alloc(units * 3 - tail);
        if (tail > 0) units -= 1;
        j = 0;
        i = 0;
        for(let u = 0; u < units; u += 1){
            n = base64[i++] << 18;
            n += base64[i++] << 12;
            n += base64[i++] << 6;
            n += base64[i++];
            buf[j++] = n >> 16 & $5d79823aa35daf7c$var$mask[8];
            buf[j++] = n >> 8 & $5d79823aa35daf7c$var$mask[8];
            buf[j++] = n & $5d79823aa35daf7c$var$mask[8];
        }
        if (tail === 1) {
            n = base64[i++] << 18;
            n += base64[i++] << 12;
            n += base64[i] << 6;
            buf[j++] = n >> 16 & $5d79823aa35daf7c$var$mask[8];
            buf[j] = n >> 8 & $5d79823aa35daf7c$var$mask[8];
        }
        if (tail === 2) {
            n = base64[i++] << 18;
            n += base64[i++] << 12;
            buf[j] = n >> 16 & $5d79823aa35daf7c$var$mask[8];
        }
        return buf;
    },
    // Converts a base 64 Buffer of bytes to a JavaScript string with line breaks.
    toString (buf) {
        if (buf.length % 4 > 0) throw new RangeError(`base64.toString: input buffer length not multiple of 4: ${buf.length}`);
        let str = "";
        let lineLen = 0;
        function buildLine(c1, c2, c3, c4) {
            switch(lineLen){
                case 76:
                    str += `\r\n${c1}${c2}${c3}${c4}`;
                    lineLen = 4;
                    break;
                case 75:
                    str += `${c1}\r\n${c2}${c3}${c4}`;
                    lineLen = 3;
                    break;
                case 74:
                    str += `${c1 + c2}\r\n${c3}${c4}`;
                    lineLen = 2;
                    break;
                case 73:
                    str += `${c1 + c2 + c3}\r\n${c4}`;
                    lineLen = 1;
                    break;
                default:
                    str += c1 + c2 + c3 + c4;
                    lineLen += 4;
                    break;
            }
        }
        function validate(c) {
            if (c >= 65 && c <= 90) return true;
            if (c >= 97 && c <= 122) return true;
            if (c >= 48 && c <= 57) return true;
            if (c === 43) return true;
            if (c === 47) return true;
            if (c === 61) return true;
            return false;
        }
        for(let i = 0; i < buf.length; i += 4){
            for(let j = i; j < i + 4; j += 1){
                if (!validate(buf[j])) throw new RangeError(`base64.toString: buf[${j}]: ${buf[j]} : not valid base64 character code`);
            }
            buildLine(String.fromCharCode(buf[i]), String.fromCharCode(buf[i + 1]), String.fromCharCode(buf[i + 2]), String.fromCharCode(buf[i + 3]));
        }
        return str;
    }
};

});


parcelRegister("ahTZ3", function(module, exports) {
// This module has been developed programmatically in the `apg-lib` build process.
// It is used to build web pages programatically on the fly without the need for <script> or <style> tags.
module.exports = function emittcss() {
    return "/* This file automatically generated by jsonToless() and LESS. */\n.apg-mono {\n  font-family: monospace;\n}\n.apg-active {\n  font-weight: bold;\n  color: #000000;\n}\n.apg-match {\n  font-weight: bold;\n  color: #264BFF;\n}\n.apg-empty {\n  font-weight: bold;\n  color: #0fbd0f;\n}\n.apg-nomatch {\n  font-weight: bold;\n  color: #FF4000;\n}\n.apg-lh-match {\n  font-weight: bold;\n  color: #1A97BA;\n}\n.apg-lb-match {\n  font-weight: bold;\n  color: #5F1687;\n}\n.apg-remainder {\n  font-weight: bold;\n  color: #999999;\n}\n.apg-ctrl-char {\n  font-weight: bolder;\n  font-style: italic;\n  font-size: 0.6em;\n}\n.apg-line-end {\n  font-weight: bold;\n  color: #000000;\n}\n.apg-error {\n  font-weight: bold;\n  color: #FF4000;\n}\n.apg-phrase {\n  color: #000000;\n  background-color: #8caae6;\n}\n.apg-empty-phrase {\n  color: #0fbd0f;\n}\ntable.apg-state {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: left;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-state th,\ntable.apg-state td {\n  text-align: left;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-state th:nth-last-child(2),\ntable.apg-state td:nth-last-child(2) {\n  text-align: right;\n}\ntable.apg-state caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-stats {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-stats th,\ntable.apg-stats td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-stats caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-trace {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-trace caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-trace th,\ntable.apg-trace td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-trace th:last-child,\ntable.apg-trace th:nth-last-child(2),\ntable.apg-trace td:last-child,\ntable.apg-trace td:nth-last-child(2) {\n  text-align: left;\n}\ntable.apg-grammar {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-grammar caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-grammar th,\ntable.apg-grammar td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-grammar th:last-child,\ntable.apg-grammar td:last-child {\n  text-align: left;\n}\ntable.apg-rules {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-rules caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-rules th,\ntable.apg-rules td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-rules a {\n  color: #003399 !important;\n}\ntable.apg-rules a:hover {\n  color: #8caae6 !important;\n}\ntable.apg-attrs {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: center;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-attrs caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-attrs th,\ntable.apg-attrs td {\n  text-align: center;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-attrs th:nth-child(1),\ntable.apg-attrs th:nth-child(2),\ntable.apg-attrs th:nth-child(3) {\n  text-align: right;\n}\ntable.apg-attrs td:nth-child(1),\ntable.apg-attrs td:nth-child(2),\ntable.apg-attrs td:nth-child(3) {\n  text-align: right;\n}\ntable.apg-attrs a {\n  color: #003399 !important;\n}\ntable.apg-attrs a:hover {\n  color: #8caae6 !important;\n}\n";
};

});



parcelRegister("cH6Qg", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module acts as a "circular buffer". It is used to keep track
// only the last N records in an array of records. If more than N records
// are saved, each additional record overwrites the previously oldest record.
// This module deals only with the record indexes and does not save
// any actual records. It is used by [`trace.js`](./trace.html) for limiting the number of
// trace records saved.
module.exports = function exportsCircularBuffer() {
    "use strict;";
    const thisFileName = "circular-buffer.js: ";
    let itemIndex = -1;
    let maxListSize = 0;
    // Initialize buffer.<br>
    // *size* is `maxListSize`, the maximum number of records saved before overwriting begins.
    this.init = function init(size) {
        if (typeof size !== "number" || size <= 0) throw new Error(`${thisFileName}init: circular buffer size must an integer > 0`);
        maxListSize = Math.ceil(size);
        itemIndex = -1;
    };
    // Call this to increment the number of records collected.<br>
    // Returns the array index number to store the next record in.
    this.increment = function increment() {
        itemIndex += 1;
        return (itemIndex + maxListSize) % maxListSize;
    };
    // Returns `maxListSize` - the maximum number of records to keep in the buffer.
    this.maxSize = function maxSize() {
        return maxListSize;
    };
    // Returns the highest number of items saved.<br>
    // (The number of items is the actual number of records processed
    // even though only `maxListSize` records are actually retained.)
    this.items = function items() {
        return itemIndex + 1;
    };
    // Returns the record number associated with this item index.
    this.getListIndex = function getListIndex(item) {
        if (itemIndex === -1) return -1;
        if (item < 0 || item > itemIndex) return -1;
        if (itemIndex - item >= maxListSize) return -1;
        return (item + maxListSize) % maxListSize;
    };
    // The iterator over the circular buffer.
    // The user's function, `fn`, will be called with arguments `fn(listIndex, itemIndex)`
    // where `listIndex` is the saved record index and `itemIndex` is the actual item index.
    this.forEach = function forEach(fn) {
        if (itemIndex === -1) /* no records have been collected */ return;
        if (itemIndex < maxListSize) {
            /* fewer than maxListSize records have been collected - number of items = number of records */ for(let i = 0; i <= itemIndex; i += 1)fn(i, i);
            return;
        }
        /* start with the oldest record saved and finish with the most recent record saved */ for(let i = itemIndex - maxListSize + 1; i <= itemIndex; i += 1){
            const listIndex = (i + maxListSize) % maxListSize;
            fn(listIndex, i);
        }
    };
};

});

parcelRegister("iFDSO", function(module, exports) {
/* eslint-disable func-names */ /* eslint-disable no-restricted-syntax */ /* eslint-disable new-cap */ /* eslint-disable guard-for-in */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This is the primary object of `apg-lib`. Calling its `parse()` member function
// walks the parse tree of opcodes, matching phrases from the input string as it goes.
// The working code for all of the operators, `ALT`, `CAT`, etc. is in this module.


module.exports = function parser() {
    const id = (parcelRequire("aGWMb"));
    const utils = (parcelRequire("abgIo"));
    const thisFileName = "parser.js: ";
    const thisThis = this;
    let opExecute;
    this.ast = null;
    this.stats = null;
    this.trace = null;
    this.callbacks = [];
    let opcodes = null;
    let chars = null;
    let charsBegin;
    let charsLength;
    let charsEnd;
    let lookAround;
    let treeDepth = 0;
    let maxTreeDepth = 0;
    let nodeHits = 0;
    let ruleCallbacks = null;
    let udtCallbacks = null;
    let rules = null;
    let udts = null;
    let syntaxData = null;
    let maxMatched = 0;
    let limitTreeDepth = Infinity;
    let limitNodeHits = Infinity;
    // Evaluates any given rule. This can be called from the syntax callback
    // functions to evaluate any rule in the grammar's rule list. Great caution
    // should be used. Use of this function will alter the language that the
    // parser accepts.
    const evaluateRule = function evaluateRule(ruleIndex, phraseIndex, sysData) {
        const functionName = `${thisFileName}evaluateRule(): `;
        if (ruleIndex >= rules.length) throw new Error(`${functionName}rule index: ${ruleIndex} out of range`);
        if (phraseIndex >= charsEnd) throw new Error(`${functionName}phrase index: ${phraseIndex} out of range`);
        const { length: length } = opcodes;
        opcodes.push({
            type: id.RNM,
            index: ruleIndex
        });
        opExecute(length, phraseIndex, sysData);
        opcodes.pop();
    };
    // Evaluates any given UDT. This can be called from the syntax callback
    // functions to evaluate any UDT in the grammar's UDT list. Great caution
    // should be used. Use of this function will alter the language that the
    // parser accepts.
    const evaluateUdt = function(udtIndex, phraseIndex, sysData) {
        const functionName = `${thisFileName}evaluateUdt(): `;
        if (udtIndex >= udts.length) throw new Error(`${functionName}udt index: ${udtIndex} out of range`);
        if (phraseIndex >= charsEnd) throw new Error(`${functionName}phrase index: ${phraseIndex} out of range`);
        const { length: length } = opcodes;
        opcodes.push({
            type: id.UDT,
            empty: udts[udtIndex].empty,
            index: udtIndex
        });
        opExecute(length, phraseIndex, sysData);
        opcodes.pop();
    };
    /* Clears this object of any/all data that has been initialized or added to it. */ /* Called by parse() on initialization, allowing this object to be re-used for multiple parsing calls. */ const clear = function() {
        treeDepth = 0;
        maxTreeDepth = 0;
        nodeHits = 0;
        maxMatched = 0;
        lookAround = [
            {
                lookAround: id.LOOKAROUND_NONE,
                anchor: 0,
                charsEnd: 0,
                charsLength: 0
            }
        ];
        rules = null;
        udts = null;
        chars = null;
        charsBegin = 0;
        charsLength = 0;
        charsEnd = 0;
        ruleCallbacks = null;
        udtCallbacks = null;
        syntaxData = null;
        opcodes = null;
    };
    /* object for maintaining a stack of back reference frames */ const backRef = function() {
        const stack = [];
        const init = function() {
            const obj = {};
            rules.forEach((rule)=>{
                if (rule.isBkr) obj[rule.lower] = null;
            });
            if (udts.length > 0) udts.forEach((udt)=>{
                if (udt.isBkr) obj[udt.lower] = null;
            });
            stack.push(obj);
        };
        const copy = function() {
            const top = stack[stack.length - 1];
            const obj = {};
            /* // eslint-disable-next-line no-restricted-syntax */ for(const name in top)obj[name] = top[name];
            return obj;
        };
        this.push = function push() {
            stack.push(copy());
        };
        this.pop = function pop(lengthArg) {
            let length = lengthArg;
            if (!length) length = stack.length - 1;
            if (length < 1 || length > stack.length) throw new Error(`${thisFileName}backRef.pop(): bad length: ${length}`);
            stack.length = length;
            return stack[stack.length - 1];
        };
        this.length = function length() {
            return stack.length;
        };
        this.savePhrase = function savePhrase(name, index, length) {
            stack[stack.length - 1][name] = {
                phraseIndex: index,
                phraseLength: length
            };
        };
        this.getPhrase = function(name) {
            return stack[stack.length - 1][name];
        };
        /* constructor */ init();
    };
    // The system data structure that relays system information to and from the rule and UDT callback functions.
    // - *state* - the state of the parser, ACTIVE, MATCH, EMPTY or NOMATCH (see the `identifiers` object in
    // [`apg-lib`](https://github.com/ldthomas/apg-js2-lib))
    // - *phraseLength* - the number of characters matched if the state is MATCHED or EMPTY
    // - *lookaround* - the top of the stack holds the current look around state,
    // LOOKAROUND_NONE, LOOKAROUND_AHEAD or LOOKAROUND_BEHIND,
    // - *uFrame* - the "universal" back reference frame.
    // Holds the last matched phrase for each of the back referenced rules and UDTs.
    // - *pFrame* - the stack of "parent" back reference frames.
    // Holds the matched phrase from the parent frame of each back referenced rules and UDTs.
    // - *evaluateRule* - a reference to this object's `evaluateRule()` function.
    // Can be called from a callback function (use with extreme caution!)
    // - *evaluateUdt* - a reference to this object's `evaluateUdt()` function.
    // Can be called from a callback function (use with extreme caution!)
    const systemData = function systemData() {
        const thisData = this;
        this.state = id.ACTIVE;
        this.phraseLength = 0;
        this.ruleIndex = 0;
        this.udtIndex = 0;
        this.lookAround = lookAround[lookAround.length - 1];
        this.uFrame = new backRef();
        this.pFrame = new backRef();
        this.evaluateRule = evaluateRule;
        this.evaluateUdt = evaluateUdt;
        /* refresh the parser state for the next operation */ this.refresh = function refresh() {
            thisData.state = id.ACTIVE;
            thisData.phraseLength = 0;
            thisData.lookAround = lookAround[lookAround.length - 1];
        };
    };
    /* some look around helper functions */ const lookAroundValue = function lookAroundValue() {
        return lookAround[lookAround.length - 1];
    };
    /* return true if parser is in look around (ahead or behind) state */ const inLookAround = function inLookAround() {
        return lookAround.length > 1;
    };
    /* return true if parser is in look behind state */ const inLookBehind = function() {
        return lookAround[lookAround.length - 1].lookAround === id.LOOKAROUND_BEHIND;
    };
    /* called by parse() to initialize the AST object, if one has been defined */ const initializeAst = function() {
        const functionName = `${thisFileName}initializeAst(): `;
        const TRUE = true;
        while(TRUE){
            if (thisThis.ast === undefined) {
                thisThis.ast = null;
                break;
            }
            if (thisThis.ast === null) break;
            if (thisThis.ast.astObject !== "astObject") throw new Error(`${functionName}ast object not recognized`);
            break;
        }
        if (thisThis.ast !== null) thisThis.ast.init(rules, udts, chars);
    };
    /* called by parse() to initialize the trace object, if one has been defined */ const initializeTrace = function() {
        const functionName = `${thisFileName}initializeTrace(): `;
        const TRUE = true;
        while(TRUE){
            if (thisThis.trace === undefined) {
                thisThis.trace = null;
                break;
            }
            if (thisThis.trace === null) break;
            if (thisThis.trace.traceObject !== "traceObject") throw new Error(`${functionName}trace object not recognized`);
            break;
        }
        if (thisThis.trace !== null) thisThis.trace.init(rules, udts, chars);
    };
    /* called by parse() to initialize the statistics object, if one has been defined */ const initializeStats = function() {
        const functionName = `${thisFileName}initializeStats(): `;
        const TRUE = true;
        while(TRUE){
            if (thisThis.stats === undefined) {
                thisThis.stats = null;
                break;
            }
            if (thisThis.stats === null) break;
            if (thisThis.stats.statsObject !== "statsObject") throw new Error(`${functionName}stats object not recognized`);
            break;
        }
        if (thisThis.stats !== null) thisThis.stats.init(rules, udts);
    };
    /* called by parse() to initialize the rules & udts from the grammar object */ /* (the grammar object generated previously by apg) */ const initializeGrammar = function(grammar) {
        const functionName = `${thisFileName}initializeGrammar(): `;
        if (!grammar) throw new Error(`${functionName}grammar object undefined`);
        if (grammar.grammarObject !== "grammarObject") throw new Error(`${functionName}bad grammar object`);
        rules = grammar.rules;
        udts = grammar.udts;
    };
    /* called by parse() to initialize the start rule */ const initializeStartRule = function(startRule) {
        const functionName = `${thisFileName}initializeStartRule(): `;
        let start = null;
        if (typeof startRule === "number") {
            if (startRule >= rules.length) throw new Error(`${functionName}start rule index too large: max: ${rules.length}: index: ${startRule}`);
            start = startRule;
        } else if (typeof startRule === "string") {
            const lower = startRule.toLowerCase();
            for(let i = 0; i < rules.length; i += 1)if (lower === rules[i].lower) {
                start = rules[i].index;
                break;
            }
            if (start === null) throw new Error(`${functionName}start rule name '${startRule}' not recognized`);
        } else throw new Error(`${functionName}type of start rule '${typeof startRule}' not recognized`);
        return start;
    };
    /* called by parse() to initialize the array of characters codes representing the input string */ const initializeInputChars = function initializeInputChars(inputArg, begArg, lenArg) {
        const functionName = `${thisFileName}initializeInputChars(): `;
        /* varify and normalize input */ let input = inputArg;
        let beg = begArg;
        let len = lenArg;
        if (input === undefined) throw new Error(`${functionName}input string is undefined`);
        if (input === null) throw new Error(`${functionName}input string is null`);
        if (typeof input === "string") input = utils.stringToChars(input);
        else if (!Array.isArray(input)) throw new Error(`${functionName}input string is not a string or array`);
        if (input.length > 0) {
            if (typeof input[0] !== "number") throw new Error(`${functionName}input string not an array of integers`);
        }
        /* verify and normalize beginning index */ if (typeof beg !== "number") beg = 0;
        else {
            beg = Math.floor(beg);
            if (beg < 0 || beg > input.length) throw new Error(`${functionName}input beginning index out of range: ${beg}`);
        }
        /* verify and normalize input length */ if (typeof len !== "number") len = input.length - beg;
        else {
            len = Math.floor(len);
            if (len < 0 || len > input.length - beg) throw new Error(`${functionName}input length out of range: ${len}`);
        }
        chars = input;
        charsBegin = beg;
        charsLength = len;
        charsEnd = charsBegin + charsLength;
    };
    /* called by parse() to initialize the user-written, syntax callback functions, if any */ const initializeCallbacks = function() {
        const functionName = `${thisFileName}initializeCallbacks(): `;
        let i;
        ruleCallbacks = [];
        udtCallbacks = [];
        for(i = 0; i < rules.length; i += 1)ruleCallbacks[i] = null;
        for(i = 0; i < udts.length; i += 1)udtCallbacks[i] = null;
        let func;
        const list = [];
        for(i = 0; i < rules.length; i += 1)list.push(rules[i].lower);
        for(i = 0; i < udts.length; i += 1)list.push(udts[i].lower);
        for(const index in thisThis.callbacks){
            i = list.indexOf(index.toLowerCase());
            if (i < 0) throw new Error(`${functionName}syntax callback '${index}' not a rule or udt name`);
            func = thisThis.callbacks[index];
            if (!func) func = null;
            if (typeof func === "function" || func === null) {
                if (i < rules.length) ruleCallbacks[i] = func;
                else udtCallbacks[i - rules.length] = func;
            } else throw new Error(`${functionName}syntax callback[${index}] must be function reference or 'false' (false/null/undefined/etc.)`);
        }
        /* make sure all udts have been defined - the parser can't work without them */ for(i = 0; i < udts.length; i += 1){
            if (udtCallbacks[i] === null) throw new Error(`${functionName}all UDT callbacks must be defined. UDT callback[${udts[i].lower}] not a function reference`);
        }
    };
    // Set the maximum parse tree depth allowed. The default is `Infinity`.
    // A limit is not normally needed, but can be used to protect against an
    // exponentual or "catastrophically backtracking" grammar.
    // <ul>
    // <li>
    // depth - max allowed parse tree depth. An exception is thrown if exceeded.
    // </li>
    // </ul>
    this.setMaxTreeDepth = function(depth) {
        if (typeof depth !== "number") throw new Error(`parser: max tree depth must be integer > 0: ${depth}`);
        limitTreeDepth = Math.floor(depth);
        if (limitTreeDepth <= 0) throw new Error(`parser: max tree depth must be integer > 0: ${depth}`);
    };
    // Set the maximum number of node hits (parser unit steps or opcode function calls) allowed.
    // The default is `Infinity`.
    // A limit is not normally needed, but can be used to protect against an
    // exponentual or "catastrophically backtracking" grammar.
    // <ul>
    // <li>
    // hits - maximum number of node hits or parser unit steps allowed.
    // An exception thrown if exceeded.
    // </li>
    // </ul>
    this.setMaxNodeHits = function(hits) {
        if (typeof hits !== "number") throw new Error(`parser: max node hits must be integer > 0: ${hits}`);
        limitNodeHits = Math.floor(hits);
        if (limitNodeHits <= 0) throw new Error(`parser: max node hits must be integer > 0: ${hits}`);
    };
    /* the main parser function */ const privateParse = function(grammar, startRuleArg, callbackData) {
        let success;
        const functionName = `${thisFileName}parse(): `;
        initializeGrammar(grammar);
        const startRule = initializeStartRule(startRuleArg);
        initializeCallbacks();
        initializeTrace();
        initializeStats();
        initializeAst();
        const sysData = new systemData();
        if (!(callbackData === undefined || callbackData === null)) syntaxData = callbackData;
        /* create a dummy opcode for the start rule */ opcodes = [
            {
                type: id.RNM,
                index: startRule
            }
        ];
        /* execute the start rule */ opExecute(0, charsBegin, sysData);
        opcodes = null;
        /* test and return the sysData */ switch(sysData.state){
            case id.ACTIVE:
                throw new Error(`${functionName}final state should never be 'ACTIVE'`);
            case id.NOMATCH:
                success = false;
                break;
            case id.EMPTY:
            case id.MATCH:
                if (sysData.phraseLength === charsLength) success = true;
                else success = false;
                break;
            default:
                throw new Error("unrecognized state");
        }
        return {
            success: success,
            state: sysData.state,
            length: charsLength,
            matched: sysData.phraseLength,
            maxMatched: maxMatched,
            maxTreeDepth: maxTreeDepth,
            nodeHits: nodeHits,
            inputLength: chars.length,
            subBegin: charsBegin,
            subEnd: charsEnd,
            subLength: charsLength
        };
    };
    // This form allows parsing of a sub-string of the full input string.
    // <ul>
    // <li>*inputIndex* - index of the first character in the sub-string</li>
    // <li>*inputLength* - length of the sub-string</li>
    // </ul>
    // All other parameters as for the above function `parse()`.
    this.parseSubstring = function parseSubstring(grammar, startRule, inputChars, inputIndex, inputLength, callbackData) {
        clear();
        initializeInputChars(inputChars, inputIndex, inputLength);
        return privateParse(grammar, startRule, callbackData);
    };
    // This is the main function, called to parse an input string.
    // <ul>
    // <li>*grammar* - an instantiated grammar object - the output of `apg` for a
    // specific SABNF grammar</li>
    // <li>*startRule* - the rule name or rule index to be used as the root of the
    // parse tree. This is usually the first rule, index = 0, of the grammar
    // but can be any rule defined in the above grammar object.</li>
    // <li>*inputChars* - the input string. Can be a string or an array of integer character codes representing the
    // string.</li>
    // <li>*callbackData* - user-defined data object to be passed to the user's
    // callback functions.
    // This is not used by the parser in any way, merely passed on to the user.
    // May be `null` or omitted.</li>
    // </ul>
    this.parse = function parse(grammar, startRule, inputChars, callbackData) {
        clear();
        initializeInputChars(inputChars, 0, inputChars.length);
        return privateParse(grammar, startRule, callbackData);
    };
    // The `ALT` operator.<br>
    // Executes its child nodes, from left to right, until it finds a match.
    // Fails if *all* of its child nodes fail.
    const opALT = function(opIndex, phraseIndex, sysData) {
        const op = opcodes[opIndex];
        for(let i = 0; i < op.children.length; i += 1){
            opExecute(op.children[i], phraseIndex, sysData);
            if (sysData.state !== id.NOMATCH) break;
        }
    };
    // The `CAT` operator.<br>
    // Executes all of its child nodes, from left to right,
    // concatenating the matched phrases.
    // Fails if *any* child nodes fail.
    const opCAT = function(opIndex, phraseIndex, sysData) {
        let success;
        let astLength;
        let catCharIndex;
        let catPhrase;
        const op = opcodes[opIndex];
        const ulen = sysData.uFrame.length();
        const plen = sysData.pFrame.length();
        if (thisThis.ast) astLength = thisThis.ast.getLength();
        success = true;
        catCharIndex = phraseIndex;
        catPhrase = 0;
        for(let i = 0; i < op.children.length; i += 1){
            opExecute(op.children[i], catCharIndex, sysData);
            if (sysData.state === id.NOMATCH) {
                success = false;
                break;
            } else {
                catCharIndex += sysData.phraseLength;
                catPhrase += sysData.phraseLength;
            }
        }
        if (success) {
            sysData.state = catPhrase === 0 ? id.EMPTY : id.MATCH;
            sysData.phraseLength = catPhrase;
        } else {
            sysData.state = id.NOMATCH;
            sysData.phraseLength = 0;
            /* reset the back referencing frames on failure */ sysData.uFrame.pop(ulen);
            sysData.pFrame.pop(plen);
            if (thisThis.ast) thisThis.ast.setLength(astLength);
        }
    };
    // The `REP` operator.<br>
    // Repeatedly executes its single child node,
    // concatenating each of the matched phrases found.
    // The number of repetitions executed and its final sysData depends
    // on its `min` & `max` repetition values.
    const opREP = function(opIndex, phraseIndex, sysData) {
        let astLength;
        let repCharIndex;
        let repPhrase;
        let repCount;
        const op = opcodes[opIndex];
        if (op.max === 0) {
            // this is an empty-string acceptor
            // deprecated: use the TLS empty string operator, "", instead
            sysData.state = id.EMPTY;
            sysData.phraseLength = 0;
            return;
        }
        repCharIndex = phraseIndex;
        repPhrase = 0;
        repCount = 0;
        const ulen = sysData.uFrame.length();
        const plen = sysData.pFrame.length();
        if (thisThis.ast) astLength = thisThis.ast.getLength();
        const TRUE = true;
        while(TRUE){
            if (repCharIndex >= charsEnd) break;
            opExecute(opIndex + 1, repCharIndex, sysData);
            if (sysData.state === id.NOMATCH) break;
            if (sysData.state === id.EMPTY) break;
            repCount += 1;
            repPhrase += sysData.phraseLength;
            repCharIndex += sysData.phraseLength;
            if (repCount === op.max) break;
        }
        /* evaluate the match count according to the min, max values */ if (sysData.state === id.EMPTY) {
            sysData.state = repPhrase === 0 ? id.EMPTY : id.MATCH;
            sysData.phraseLength = repPhrase;
        } else if (repCount >= op.min) {
            sysData.state = repPhrase === 0 ? id.EMPTY : id.MATCH;
            sysData.phraseLength = repPhrase;
        } else {
            sysData.state = id.NOMATCH;
            sysData.phraseLength = 0;
            /* reset the back referencing frames on failure */ sysData.uFrame.pop(ulen);
            sysData.pFrame.pop(plen);
            if (thisThis.ast) thisThis.ast.setLength(astLength);
        }
    };
    // Validate the callback function's returned sysData values.
    // It's the user's responsibility to get them right
    // but `RNM` fails if not.
    const validateRnmCallbackResult = function(rule, sysData, charsLeft, down) {
        if (sysData.phraseLength > charsLeft) {
            let str = `${thisFileName}opRNM(${rule.name}): callback function error: `;
            str += `sysData.phraseLength: ${sysData.phraseLength}`;
            str += ` must be <= remaining chars: ${charsLeft}`;
            throw new Error(str);
        }
        switch(sysData.state){
            case id.ACTIVE:
                if (down !== true) throw new Error(`${thisFileName}opRNM(${rule.name}): callback function return error. ACTIVE state not allowed.`);
                break;
            case id.EMPTY:
                sysData.phraseLength = 0;
                break;
            case id.MATCH:
                if (sysData.phraseLength === 0) sysData.state = id.EMPTY;
                break;
            case id.NOMATCH:
                sysData.phraseLength = 0;
                break;
            default:
                throw new Error(`${thisFileName}opRNM(${rule.name}): callback function return error. Unrecognized return state: ${sysData.state}`);
        }
    };
    // The `RNM` operator.<br>
    // This operator will acts as a root node for a parse tree branch below and
    // returns the matched phrase to its parent.
    // However, its larger responsibility is handling user-defined callback functions, back references and `AST` nodes.
    // Note that the `AST` is a separate object, but `RNM` calls its functions to create its nodes.
    // See [`ast.js`](./ast.html) for usage.
    const opRNM = function(opIndex, phraseIndex, sysData) {
        let astLength;
        let astDefined;
        let savedOpcodes;
        let ulen;
        let plen;
        let saveFrame;
        const op = opcodes[opIndex];
        const rule = rules[op.index];
        const callback = ruleCallbacks[rule.index];
        const notLookAround = !inLookAround();
        /* ignore AST and back references in lookaround */ if (notLookAround) {
            /* begin AST and back references */ astDefined = thisThis.ast && thisThis.ast.ruleDefined(op.index);
            if (astDefined) {
                astLength = thisThis.ast.getLength();
                thisThis.ast.down(op.index, rules[op.index].name);
            }
            ulen = sysData.uFrame.length();
            plen = sysData.pFrame.length();
            sysData.uFrame.push();
            sysData.pFrame.push();
            saveFrame = sysData.pFrame;
            sysData.pFrame = new backRef();
        }
        if (callback === null) {
            /* no callback - just execute the rule */ savedOpcodes = opcodes;
            opcodes = rule.opcodes;
            opExecute(0, phraseIndex, sysData);
            opcodes = savedOpcodes;
        } else {
            /* call user's callback */ const charsLeft = charsEnd - phraseIndex;
            sysData.ruleIndex = rule.index;
            callback(sysData, chars, phraseIndex, syntaxData);
            validateRnmCallbackResult(rule, sysData, charsLeft, true);
            if (sysData.state === id.ACTIVE) {
                savedOpcodes = opcodes;
                opcodes = rule.opcodes;
                opExecute(0, phraseIndex, sysData);
                opcodes = savedOpcodes;
                sysData.ruleIndex = rule.index;
                callback(sysData, chars, phraseIndex, syntaxData);
                validateRnmCallbackResult(rule, sysData, charsLeft, false);
            } /* implied else clause: just accept the callback sysData - RNM acting as UDT */ 
        }
        if (notLookAround) {
            /* end AST */ if (astDefined) {
                if (sysData.state === id.NOMATCH) thisThis.ast.setLength(astLength);
                else thisThis.ast.up(op.index, rule.name, phraseIndex, sysData.phraseLength);
            }
            /* end back reference */ sysData.pFrame = saveFrame;
            if (sysData.state === id.NOMATCH) {
                sysData.uFrame.pop(ulen);
                sysData.pFrame.pop(plen);
            } else if (rule.isBkr) {
                /* save phrase on both the parent and universal frames */ /* BKR operator will decide which to use later */ sysData.pFrame.savePhrase(rule.lower, phraseIndex, sysData.phraseLength);
                sysData.uFrame.savePhrase(rule.lower, phraseIndex, sysData.phraseLength);
            }
        }
    };
    // Validate the callback function's returned sysData values.
    // It's the user's responsibility to get it right but `UDT` fails if not.
    const validateUdtCallbackResult = function(udt, sysData, charsLeft) {
        if (sysData.phraseLength > charsLeft) {
            let str = `${thisFileName}opUDT(${udt.name}): callback function error: `;
            str += `sysData.phraseLength: ${sysData.phraseLength}`;
            str += ` must be <= remaining chars: ${charsLeft}`;
            throw new Error(str);
        }
        switch(sysData.state){
            case id.ACTIVE:
                throw new Error(`${thisFileName}opUDT(${udt.name}): callback function return error. ACTIVE state not allowed.`);
            case id.EMPTY:
                if (udt.empty === false) throw new Error(`${thisFileName}opUDT(${udt.name}): callback function return error. May not return EMPTY.`);
                else sysData.phraseLength = 0;
                break;
            case id.MATCH:
                if (sysData.phraseLength === 0) {
                    if (udt.empty === false) throw new Error(`${thisFileName}opUDT(${udt.name}): callback function return error. May not return EMPTY.`);
                    else sysData.state = id.EMPTY;
                }
                break;
            case id.NOMATCH:
                sysData.phraseLength = 0;
                break;
            default:
                throw new Error(`${thisFileName}opUDT(${udt.name}): callback function return error. Unrecognized return state: ${sysData.state}`);
        }
    };
    // The `UDT` operator.<br>
    // Simply calls the user's callback function, but operates like `RNM` with regard to the `AST`
    // and back referencing.
    // There is some ambiguity here. `UDT`s act as terminals for phrase recognition but as named rules
    // for `AST` nodes and back referencing.
    // See [`ast.js`](./ast.html) for usage.
    const opUDT = function(opIndex, phraseIndex, sysData) {
        let astLength;
        let astIndex;
        let astDefined;
        let ulen;
        let plen;
        let saveFrame;
        const op = opcodes[opIndex];
        const udt = udts[op.index];
        sysData.UdtIndex = udt.index;
        const notLookAround = !inLookAround();
        /* ignore AST and back references in lookaround */ if (notLookAround) {
            /* begin AST and back reference */ astDefined = thisThis.ast && thisThis.ast.udtDefined(op.index);
            if (astDefined) {
                astIndex = rules.length + op.index;
                astLength = thisThis.ast.getLength();
                thisThis.ast.down(astIndex, udt.name);
            }
            /* NOTE: push and pop of the back reference frame is normally not necessary */ /* only in the case that the UDT calls evaluateRule() or evaluateUdt() */ ulen = sysData.uFrame.length();
            plen = sysData.pFrame.length();
            sysData.uFrame.push();
            sysData.pFrame.push();
            saveFrame = sysData.pFrame;
            sysData.pFrame = new backRef();
        }
        /* call the UDT */ const charsLeft = charsEnd - phraseIndex;
        udtCallbacks[op.index](sysData, chars, phraseIndex, syntaxData);
        validateUdtCallbackResult(udt, sysData, charsLeft);
        if (notLookAround) {
            /* end AST */ if (astDefined) {
                if (sysData.state === id.NOMATCH) thisThis.ast.setLength(astLength);
                else thisThis.ast.up(astIndex, udt.name, phraseIndex, sysData.phraseLength);
            }
            /* end back reference */ sysData.pFrame = saveFrame;
            if (sysData.state === id.NOMATCH) {
                sysData.uFrame.pop(ulen);
                sysData.pFrame.pop(plen);
            } else if (udt.isBkr) {
                /* save phrase on both the parent and universal frames */ /* BKR operator will decide which to use later */ sysData.pFrame.savePhrase(udt.lower, phraseIndex, sysData.phraseLength);
                sysData.uFrame.savePhrase(udt.lower, phraseIndex, sysData.phraseLength);
            }
        }
    };
    // The `AND` operator.<br>
    // This is the positive `look ahead` operator.
    // Executes its single child node, returning the EMPTY state
    // if it succeedsand NOMATCH if it fails.
    // *Always* backtracks on any matched phrase and returns EMPTY on success.
    const opAND = function(opIndex, phraseIndex, sysData) {
        lookAround.push({
            lookAround: id.LOOKAROUND_AHEAD,
            anchor: phraseIndex,
            charsEnd: charsEnd,
            charsLength: charsLength
        });
        charsEnd = chars.length;
        charsLength = chars.length - charsBegin;
        opExecute(opIndex + 1, phraseIndex, sysData);
        const pop = lookAround.pop();
        charsEnd = pop.charsEnd;
        charsLength = pop.charsLength;
        sysData.phraseLength = 0;
        switch(sysData.state){
            case id.EMPTY:
                sysData.state = id.EMPTY;
                break;
            case id.MATCH:
                sysData.state = id.EMPTY;
                break;
            case id.NOMATCH:
                sysData.state = id.NOMATCH;
                break;
            default:
                throw new Error(`opAND: invalid state ${sysData.state}`);
        }
    };
    // The `NOT` operator.<br>
    // This is the negative `look ahead` operator.
    // Executes its single child node, returning the EMPTY state
    // if it *fails* and NOMATCH if it succeeds.
    // *Always* backtracks on any matched phrase and returns EMPTY
    // on success (failure of its child node).
    const opNOT = function(opIndex, phraseIndex, sysData) {
        lookAround.push({
            lookAround: id.LOOKAROUND_AHEAD,
            anchor: phraseIndex,
            charsEnd: charsEnd,
            charsLength: charsLength
        });
        charsEnd = chars.length;
        charsLength = chars.length - charsBegin;
        opExecute(opIndex + 1, phraseIndex, sysData);
        const pop = lookAround.pop();
        charsEnd = pop.charsEnd;
        charsLength = pop.charsLength;
        sysData.phraseLength = 0;
        switch(sysData.state){
            case id.EMPTY:
            case id.MATCH:
                sysData.state = id.NOMATCH;
                break;
            case id.NOMATCH:
                sysData.state = id.EMPTY;
                break;
            default:
                throw new Error(`opNOT: invalid state ${sysData.state}`);
        }
    };
    // The `TRG` operator.<br>
    // Succeeds if the single first character of the phrase is
    // within the `min - max` range.
    const opTRG = function(opIndex, phraseIndex, sysData) {
        const op = opcodes[opIndex];
        sysData.state = id.NOMATCH;
        if (phraseIndex < charsEnd) {
            if (op.min <= chars[phraseIndex] && chars[phraseIndex] <= op.max) {
                sysData.state = id.MATCH;
                sysData.phraseLength = 1;
            }
        }
    };
    // The `TBS` operator.<br>
    // Matches its pre-defined phrase against the input string.
    // All characters must match exactly.
    // Case-sensitive literal strings (`'string'` & `%s"string"`) are translated to `TBS`
    // operators by `apg`.
    // Phrase length of zero is not allowed.
    // Empty phrases can only be defined with `TLS` operators.
    const opTBS = function(opIndex, phraseIndex, sysData) {
        let i;
        const op = opcodes[opIndex];
        const len = op.string.length;
        sysData.state = id.NOMATCH;
        if (phraseIndex + len <= charsEnd) {
            for(i = 0; i < len; i += 1){
                if (chars[phraseIndex + i] !== op.string[i]) return;
            }
            sysData.state = id.MATCH;
            sysData.phraseLength = len;
        } /* implied else NOMATCH */ 
    };
    // The `TLS` operator.<br>
    // Matches its pre-defined phrase against the input string.
    // A case-insensitive match is attempted for ASCII alphbetical characters.
    // `TLS` is the only operator that explicitly allows empty phrases.
    // `apg` will fail for empty `TBS`, case-sensitive strings (`''`) or
    // zero repetitions (`0*0RuleName` or `0RuleName`).
    const opTLS = function(opIndex, phraseIndex, sysData) {
        let i;
        let code;
        const op = opcodes[opIndex];
        sysData.state = id.NOMATCH;
        const len = op.string.length;
        if (len === 0) {
            /* EMPTY match allowed for TLS */ sysData.state = id.EMPTY;
            return;
        }
        if (phraseIndex + len <= charsEnd) {
            for(i = 0; i < len; i += 1){
                code = chars[phraseIndex + i];
                if (code >= 65 && code <= 90) code += 32;
                if (code !== op.string[i]) return;
            }
            sysData.state = id.MATCH;
            sysData.phraseLength = len;
        } /* implied else NOMATCH */ 
    };
    // The `ABG` operator.<br>
    // This is an "anchor" for the beginning of the string, similar to the familiar regex `^` anchor.
    // An anchor matches a position rather than a phrase.
    // Returns EMPTY if `phraseIndex` is 0, NOMATCH otherwise.
    const opABG = function(opIndex, phraseIndex, sysData) {
        sysData.state = id.NOMATCH;
        sysData.phraseLength = 0;
        sysData.state = phraseIndex === 0 ? id.EMPTY : id.NOMATCH;
    };
    // The `AEN` operator.<br>
    // This is an "anchor" for the end of the string, similar to the familiar regex `$` anchor.
    // An anchor matches a position rather than a phrase.
    // Returns EMPTY if `phraseIndex` equals the input string length, NOMATCH otherwise.
    const opAEN = function(opIndex, phraseIndex, sysData) {
        sysData.state = id.NOMATCH;
        sysData.phraseLength = 0;
        sysData.state = phraseIndex === chars.length ? id.EMPTY : id.NOMATCH;
    };
    // The `BKR` operator.<br>
    // The back reference operator.
    // Matches the last matched phrase of the named rule or UDT against the input string.
    // For ASCII alphbetical characters the match may be case sensitive (`%s`) or insensitive (`%i`),
    // depending on the back reference definition.
    // For `universal` mode (`%u`) matches the last phrase found anywhere in the grammar.
    // For `parent frame` mode (`%p`) matches the last phrase found in the parent rule only.
    const opBKR = function(opIndex, phraseIndex, sysData) {
        let i;
        let code;
        let lmcode;
        let lower;
        const op = opcodes[opIndex];
        sysData.state = id.NOMATCH;
        if (op.index < rules.length) lower = rules[op.index].lower;
        else lower = udts[op.index - rules.length].lower;
        const frame = op.bkrMode === id.BKR_MODE_PM ? sysData.pFrame.getPhrase(lower) : sysData.uFrame.getPhrase(lower);
        const insensitive = op.bkrCase === id.BKR_MODE_CI;
        if (frame === null) return;
        const lmIndex = frame.phraseIndex;
        const len = frame.phraseLength;
        if (len === 0) {
            sysData.state = id.EMPTY;
            return;
        }
        if (phraseIndex + len <= charsEnd) {
            if (insensitive) {
                /* case-insensitive match */ for(i = 0; i < len; i += 1){
                    code = chars[phraseIndex + i];
                    lmcode = chars[lmIndex + i];
                    if (code >= 65 && code <= 90) code += 32;
                    if (lmcode >= 65 && lmcode <= 90) lmcode += 32;
                    if (code !== lmcode) return;
                }
                sysData.state = id.MATCH;
                sysData.phraseLength = len;
            } else /* case-sensitive match */ for(i = 0; i < len; i += 1){
                code = chars[phraseIndex + i];
                lmcode = chars[lmIndex + i];
                if (code !== lmcode) return;
            }
            sysData.state = id.MATCH;
            sysData.phraseLength = len;
        }
    };
    // The `BKA` operator.<br>
    // This is the positive `look behind` operator.
    // It's child node is parsed right-to-left.
    // Returns the EMPTY state if a match is found, NOMATCH otherwise.
    // Like the look ahead operators, it always backtracks to `phraseIndex`.
    const opBKA = function(opIndex, phraseIndex, sysData) {
        lookAround.push({
            lookAround: id.LOOKAROUND_BEHIND,
            anchor: phraseIndex
        });
        opExecute(opIndex + 1, phraseIndex, sysData);
        lookAround.pop();
        sysData.phraseLength = 0;
        switch(sysData.state){
            case id.EMPTY:
                sysData.state = id.EMPTY;
                break;
            case id.MATCH:
                sysData.state = id.EMPTY;
                break;
            case id.NOMATCH:
                sysData.state = id.NOMATCH;
                break;
            default:
                throw new Error(`opBKA: invalid state ${sysData.state}`);
        }
    };
    // The `BKN` operator.<br>
    // This is the negative `look behind` operator.
    // It's child node is parsed right-to-left.
    // Returns the EMPTY state if a match is *not* found, NOMATCH otherwise.
    // Like the look ahead operators, it always backtracks to `phraseIndex`.
    const opBKN = function(opIndex, phraseIndex, sysData) {
        // let op;
        // op = opcodes[opIndex];
        lookAround.push({
            lookAround: id.LOOKAROUND_BEHIND,
            anchor: phraseIndex
        });
        opExecute(opIndex + 1, phraseIndex, sysData);
        lookAround.pop();
        sysData.phraseLength = 0;
        switch(sysData.state){
            case id.EMPTY:
            case id.MATCH:
                sysData.state = id.NOMATCH;
                break;
            case id.NOMATCH:
                sysData.state = id.EMPTY;
                break;
            default:
                throw new Error(`opBKN: invalid state ${sysData.state}`);
        }
    };
    // The right-to-left `CAT` operator.<br>
    // Called for `CAT` operators when in look behind mode.
    // Calls its child nodes from right to left concatenating matched phrases right to left.
    const opCATBehind = function(opIndex, phraseIndex, sysData) {
        let success;
        let astLength;
        let catCharIndex;
        let catMatched;
        const op = opcodes[opIndex];
        const ulen = sysData.uFrame.length();
        const plen = sysData.pFrame.length();
        if (thisThis.ast) astLength = thisThis.ast.getLength();
        success = true;
        catCharIndex = phraseIndex;
        catMatched = 0;
        // catPhrase = 0;
        for(let i = op.children.length - 1; i >= 0; i -= 1){
            opExecute(op.children[i], catCharIndex, sysData);
            catCharIndex -= sysData.phraseLength;
            catMatched += sysData.phraseLength;
            // catPhrase += sysData.phraseLength;
            if (sysData.state === id.NOMATCH) {
                success = false;
                break;
            }
        }
        if (success) {
            sysData.state = catMatched === 0 ? id.EMPTY : id.MATCH;
            sysData.phraseLength = catMatched;
        } else {
            sysData.state = id.NOMATCH;
            sysData.phraseLength = 0;
            sysData.uFrame.pop(ulen);
            sysData.pFrame.pop(plen);
            if (thisThis.ast) thisThis.ast.setLength(astLength);
        }
    };
    // The right-to-left `REP` operator.<br>
    // Called for `REP` operators in look behind mode.
    // Makes repeated calls to its child node, concatenating matched phrases right to left.
    const opREPBehind = function(opIndex, phraseIndex, sysData) {
        let astLength;
        let repCharIndex;
        let repPhrase;
        let repCount;
        const op = opcodes[opIndex];
        repCharIndex = phraseIndex;
        repPhrase = 0;
        repCount = 0;
        const ulen = sysData.uFrame.length();
        const plen = sysData.pFrame.length();
        if (thisThis.ast) astLength = thisThis.ast.getLength();
        const TRUE = true;
        while(TRUE){
            if (repCharIndex <= 0) break;
            opExecute(opIndex + 1, repCharIndex, sysData);
            if (sysData.state === id.NOMATCH) break;
            if (sysData.state === id.EMPTY) break;
            repCount += 1;
            repPhrase += sysData.phraseLength;
            repCharIndex -= sysData.phraseLength;
            if (repCount === op.max) break;
        }
        /* evaluate the match count according to the min, max values */ if (sysData.state === id.EMPTY) {
            sysData.state = repPhrase === 0 ? id.EMPTY : id.MATCH;
            sysData.phraseLength = repPhrase;
        } else if (repCount >= op.min) {
            sysData.state = repPhrase === 0 ? id.EMPTY : id.MATCH;
            sysData.phraseLength = repPhrase;
        } else {
            sysData.state = id.NOMATCH;
            sysData.phraseLength = 0;
            sysData.uFrame.pop(ulen);
            sysData.pFrame.pop(plen);
            if (thisThis.ast) thisThis.ast.setLength(astLength);
        }
    };
    // The right-to-left `TRG` operator.<br>
    // Called for `TRG` operators in look behind mode.
    // Matches a single character at `phraseIndex - 1` to the `min` - `max` range.
    const opTRGBehind = function(opIndex, phraseIndex, sysData) {
        const op = opcodes[opIndex];
        sysData.state = id.NOMATCH;
        sysData.phraseLength = 0;
        if (phraseIndex > 0) {
            const char = chars[phraseIndex - 1];
            if (op.min <= char && char <= op.max) {
                sysData.state = id.MATCH;
                sysData.phraseLength = 1;
            }
        }
    };
    // The right-to-left `TBS` operator.<br>
    // Called for `TBS` operators in look behind mode.
    // Matches the `TBS` phrase to the left of `phraseIndex`.
    const opTBSBehind = function(opIndex, phraseIndex, sysData) {
        let i;
        const op = opcodes[opIndex];
        sysData.state = id.NOMATCH;
        const len = op.string.length;
        const beg = phraseIndex - len;
        if (beg >= 0) {
            for(i = 0; i < len; i += 1){
                if (chars[beg + i] !== op.string[i]) return;
            }
            sysData.state = id.MATCH;
            sysData.phraseLength = len;
        }
    };
    // The right-to-left `TLS` operator.<br>
    // Called for `TLS` operators in look behind mode.
    // Matches the `TLS` phrase to the left of `phraseIndex`.
    const opTLSBehind = function(opIndex, phraseIndex, sysData) {
        let char;
        const op = opcodes[opIndex];
        sysData.state = id.NOMATCH;
        const len = op.string.length;
        if (len === 0) {
            /* EMPTY match allowed for TLS */ sysData.state = id.EMPTY;
            return;
        }
        const beg = phraseIndex - len;
        if (beg >= 0) {
            for(let i = 0; i < len; i += 1){
                char = chars[beg + i];
                if (char >= 65 && char <= 90) char += 32;
                if (char !== op.string[i]) return;
            }
            sysData.state = id.MATCH;
            sysData.phraseLength = len;
        }
    };
    // The right-to-left back reference operator.<br>
    // Matches the back referenced phrase to the left of `phraseIndex`.
    const opBKRBehind = function(opIndex, phraseIndex, sysData) {
        let i;
        let code;
        let lmcode;
        let lower;
        const op = opcodes[opIndex];
        /* NOMATCH default */ sysData.state = id.NOMATCH;
        sysData.phraseLength = 0;
        if (op.index < rules.length) lower = rules[op.index].lower;
        else lower = udts[op.index - rules.length].lower;
        const frame = op.bkrMode === id.BKR_MODE_PM ? sysData.pFrame.getPhrase(lower) : sysData.uFrame.getPhrase(lower);
        const insensitive = op.bkrCase === id.BKR_MODE_CI;
        if (frame === null) return;
        const lmIndex = frame.phraseIndex;
        const len = frame.phraseLength;
        if (len === 0) {
            sysData.state = id.EMPTY;
            sysData.phraseLength = 0;
            return;
        }
        const beg = phraseIndex - len;
        if (beg >= 0) {
            if (insensitive) {
                /* case-insensitive match */ for(i = 0; i < len; i += 1){
                    code = chars[beg + i];
                    lmcode = chars[lmIndex + i];
                    if (code >= 65 && code <= 90) code += 32;
                    if (lmcode >= 65 && lmcode <= 90) lmcode += 32;
                    if (code !== lmcode) return;
                }
                sysData.state = id.MATCH;
                sysData.phraseLength = len;
            } else /* case-sensitive match */ for(i = 0; i < len; i += 1){
                code = chars[beg + i];
                lmcode = chars[lmIndex + i];
                if (code !== lmcode) return;
            }
            sysData.state = id.MATCH;
            sysData.phraseLength = len;
        }
    };
    // Generalized execution function.<br>
    // Having a single, generalized function, allows a single location
    // for tracing and statistics gathering functions to be called.
    // Tracing and statistics are handled in separate objects.
    // However, the parser calls their API to build the object data records.
    // See [`trace.js`](./trace.html) and [`stats.js`](./stats.html) for their
    // usage.
    opExecute = function opExecuteFunc(opIndex, phraseIndex, sysData) {
        let ret = true;
        const op = opcodes[opIndex];
        nodeHits += 1;
        if (nodeHits > limitNodeHits) throw new Error(`parser: maximum number of node hits exceeded: ${limitNodeHits}`);
        treeDepth += 1;
        if (treeDepth > maxTreeDepth) {
            maxTreeDepth = treeDepth;
            if (maxTreeDepth > limitTreeDepth) throw new Error(`parser: maximum parse tree depth exceeded: ${limitTreeDepth}`);
        }
        sysData.refresh();
        if (thisThis.trace !== null) {
            /* collect the trace record for down the parse tree */ const lk = lookAroundValue();
            thisThis.trace.down(op, sysData.state, phraseIndex, sysData.phraseLength, lk.anchor, lk.lookAround);
        }
        if (inLookBehind()) switch(op.type){
            case id.ALT:
                opALT(opIndex, phraseIndex, sysData);
                break;
            case id.CAT:
                opCATBehind(opIndex, phraseIndex, sysData);
                break;
            case id.REP:
                opREPBehind(opIndex, phraseIndex, sysData);
                break;
            case id.RNM:
                opRNM(opIndex, phraseIndex, sysData);
                break;
            case id.UDT:
                opUDT(opIndex, phraseIndex, sysData);
                break;
            case id.AND:
                opAND(opIndex, phraseIndex, sysData);
                break;
            case id.NOT:
                opNOT(opIndex, phraseIndex, sysData);
                break;
            case id.TRG:
                opTRGBehind(opIndex, phraseIndex, sysData);
                break;
            case id.TBS:
                opTBSBehind(opIndex, phraseIndex, sysData);
                break;
            case id.TLS:
                opTLSBehind(opIndex, phraseIndex, sysData);
                break;
            case id.BKR:
                opBKRBehind(opIndex, phraseIndex, sysData);
                break;
            case id.BKA:
                opBKA(opIndex, phraseIndex, sysData);
                break;
            case id.BKN:
                opBKN(opIndex, phraseIndex, sysData);
                break;
            case id.ABG:
                opABG(opIndex, phraseIndex, sysData);
                break;
            case id.AEN:
                opAEN(opIndex, phraseIndex, sysData);
                break;
            default:
                ret = false;
                break;
        }
        else switch(op.type){
            case id.ALT:
                opALT(opIndex, phraseIndex, sysData);
                break;
            case id.CAT:
                opCAT(opIndex, phraseIndex, sysData);
                break;
            case id.REP:
                opREP(opIndex, phraseIndex, sysData);
                break;
            case id.RNM:
                opRNM(opIndex, phraseIndex, sysData);
                break;
            case id.UDT:
                opUDT(opIndex, phraseIndex, sysData);
                break;
            case id.AND:
                opAND(opIndex, phraseIndex, sysData);
                break;
            case id.NOT:
                opNOT(opIndex, phraseIndex, sysData);
                break;
            case id.TRG:
                opTRG(opIndex, phraseIndex, sysData);
                break;
            case id.TBS:
                opTBS(opIndex, phraseIndex, sysData);
                break;
            case id.TLS:
                opTLS(opIndex, phraseIndex, sysData);
                break;
            case id.BKR:
                opBKR(opIndex, phraseIndex, sysData);
                break;
            case id.BKA:
                opBKA(opIndex, phraseIndex, sysData);
                break;
            case id.BKN:
                opBKN(opIndex, phraseIndex, sysData);
                break;
            case id.ABG:
                opABG(opIndex, phraseIndex, sysData);
                break;
            case id.AEN:
                opAEN(opIndex, phraseIndex, sysData);
                break;
            default:
                ret = false;
                break;
        }
        if (!inLookAround() && phraseIndex + sysData.phraseLength > maxMatched) maxMatched = phraseIndex + sysData.phraseLength;
        if (thisThis.stats !== null) /* collect the statistics */ thisThis.stats.collect(op, sysData);
        if (thisThis.trace !== null) {
            /* collect the trace record for up the parse tree */ const lk = lookAroundValue();
            thisThis.trace.up(op, sysData.state, phraseIndex, sysData.phraseLength, lk.anchor, lk.lookAround);
        }
        treeDepth -= 1;
        return ret;
    };
};

});

parcelRegister("foSKy", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module is the constructor for the statistics gathering object.
// The statistics are nothing more than keeping a count of the
// number of times each node in the parse tree is traversed.
//
// Counts are collected for each of the individual types of operators.
// Additionally, counts are collected for each of the individually named
// `RNM` and `UDT` operators.



module.exports = function statsFunc() {
    const id = (parcelRequire("aGWMb"));
    const utils = (parcelRequire("abgIo"));
    const style = (parcelRequire("fHN1N"));
    const thisFileName = "stats.js: ";
    let rules = [];
    let udts = [];
    const stats = [];
    let totals;
    const ruleStats = [];
    const udtStats = [];
    this.statsObject = "statsObject";
    const nameId = "stats";
    /* `Array.sort()` callback function for sorting `RNM` and `UDT` operators alphabetically by name. */ const sortAlpha = function sortAlpha(lhs, rhs) {
        if (lhs.lower < rhs.lower) return -1;
        if (lhs.lower > rhs.lower) return 1;
        return 0;
    };
    /* `Array.sort()` callback function for sorting `RNM` and `UDT` operators by hit count. */ const sortHits = function sortHits(lhs, rhs) {
        if (lhs.total < rhs.total) return 1;
        if (lhs.total > rhs.total) return -1;
        return sortAlpha(lhs, rhs);
    };
    /* `Array.sort()` callback function for sorting `RNM` and `UDT` operators by index */ /* (in the order in which they appear in the SABNF grammar). */ const sortIndex = function sortIndex(lhs, rhs) {
        if (lhs.index < rhs.index) return -1;
        if (lhs.index > rhs.index) return 1;
        return 0;
    };
    const EmptyStat = function EmptyStat() {
        this.empty = 0;
        this.match = 0;
        this.nomatch = 0;
        this.total = 0;
    };
    /* Zero out all stats */ const clear = function clear() {
        stats.length = 0;
        totals = new EmptyStat();
        stats[id.ALT] = new EmptyStat();
        stats[id.CAT] = new EmptyStat();
        stats[id.REP] = new EmptyStat();
        stats[id.RNM] = new EmptyStat();
        stats[id.TRG] = new EmptyStat();
        stats[id.TBS] = new EmptyStat();
        stats[id.TLS] = new EmptyStat();
        stats[id.UDT] = new EmptyStat();
        stats[id.AND] = new EmptyStat();
        stats[id.NOT] = new EmptyStat();
        stats[id.BKR] = new EmptyStat();
        stats[id.BKA] = new EmptyStat();
        stats[id.BKN] = new EmptyStat();
        stats[id.ABG] = new EmptyStat();
        stats[id.AEN] = new EmptyStat();
        ruleStats.length = 0;
        for(let i = 0; i < rules.length; i += 1)ruleStats.push({
            empty: 0,
            match: 0,
            nomatch: 0,
            total: 0,
            name: rules[i].name,
            lower: rules[i].lower,
            index: rules[i].index
        });
        if (udts.length > 0) {
            udtStats.length = 0;
            for(let i = 0; i < udts.length; i += 1)udtStats.push({
                empty: 0,
                match: 0,
                nomatch: 0,
                total: 0,
                name: udts[i].name,
                lower: udts[i].lower,
                index: udts[i].index
            });
        }
    };
    /* increment the designated operator hit count by one */ const incStat = function incStat(stat, state) {
        stat.total += 1;
        switch(state){
            case id.EMPTY:
                stat.empty += 1;
                break;
            case id.MATCH:
                stat.match += 1;
                break;
            case id.NOMATCH:
                stat.nomatch += 1;
                break;
            default:
                throw new Error(`${thisFileName}collect(): incStat(): unrecognized state: ${state}`);
        }
    };
    /* helper for toHtml() */ const displayRow = function displayRow(name, stat) {
        let html = "";
        html += "<tr>";
        html += `<td class="${style.CLASS_ACTIVE}">${name}</td>`;
        html += `<td class="${style.CLASS_EMPTY}">${stat.empty}</td>`;
        html += `<td class="${style.CLASS_MATCH}">${stat.match}</td>`;
        html += `<td class="${style.CLASS_NOMATCH}">${stat.nomatch}</td>`;
        html += `<td class="${style.CLASS_ACTIVE}">${stat.total}</td>`;
        html += "</tr>\n";
        return html;
    };
    const displayOpsOnly = function displayOpsOnly() {
        let html = "";
        html += displayRow("ALT", stats[id.ALT]);
        html += displayRow("CAT", stats[id.CAT]);
        html += displayRow("REP", stats[id.REP]);
        html += displayRow("RNM", stats[id.RNM]);
        html += displayRow("TRG", stats[id.TRG]);
        html += displayRow("TBS", stats[id.TBS]);
        html += displayRow("TLS", stats[id.TLS]);
        html += displayRow("UDT", stats[id.UDT]);
        html += displayRow("AND", stats[id.AND]);
        html += displayRow("NOT", stats[id.NOT]);
        html += displayRow("BKR", stats[id.BKR]);
        html += displayRow("BKA", stats[id.BKA]);
        html += displayRow("BKN", stats[id.BKN]);
        html += displayRow("ABG", stats[id.ABG]);
        html += displayRow("AEN", stats[id.AEN]);
        html += displayRow("totals", totals);
        return html;
    };
    /* helper for toHtml() */ const displayRules = function displayRules() {
        let html = "";
        html += "<tr><th></th><th></th><th></th><th></th><th></th></tr>\n";
        html += "<tr><th>rules</th><th></th><th></th><th></th><th></th></tr>\n";
        for(let i = 0; i < rules.length; i += 1)if (ruleStats[i].total > 0) {
            html += "<tr>";
            html += `<td class="${style.CLASS_ACTIVE}">${ruleStats[i].name}</td>`;
            html += `<td class="${style.CLASS_EMPTY}">${ruleStats[i].empty}</td>`;
            html += `<td class="${style.CLASS_MATCH}">${ruleStats[i].match}</td>`;
            html += `<td class="${style.CLASS_NOMATCH}">${ruleStats[i].nomatch}</td>`;
            html += `<td class="${style.CLASS_ACTIVE}">${ruleStats[i].total}</td>`;
            html += "</tr>\n";
        }
        if (udts.length > 0) {
            html += "<tr><th></th><th></th><th></th><th></th><th></th></tr>\n";
            html += "<tr><th>udts</th><th></th><th></th><th></th><th></th></tr>\n";
            for(let i = 0; i < udts.length; i += 1)if (udtStats[i].total > 0) {
                html += "<tr>";
                html += `<td class="${style.CLASS_ACTIVE}">${udtStats[i].name}</td>`;
                html += `<td class="${style.CLASS_EMPTY}">${udtStats[i].empty}</td>`;
                html += `<td class="${style.CLASS_MATCH}">${udtStats[i].match}</td>`;
                html += `<td class="${style.CLASS_NOMATCH}">${udtStats[i].nomatch}</td>`;
                html += `<td class="${style.CLASS_ACTIVE}">${udtStats[i].total}</td>`;
                html += "</tr>\n";
            }
        }
        return html;
    };
    /* called only by the parser to validate a stats object */ this.validate = function validate(name) {
        let ret = false;
        if (typeof name === "string" && nameId === name) ret = true;
        return ret;
    };
    /* no verification of input - only called by parser() */ this.init = function init(inputRules, inputUdts) {
        rules = inputRules;
        udts = inputUdts;
        clear();
    };
    /* This function is the main interaction with the parser. */ /* The parser calls it after each node has been traversed. */ this.collect = function collect(op, result) {
        incStat(totals, result.state, result.phraseLength);
        incStat(stats[op.type], result.state, result.phraseLength);
        if (op.type === id.RNM) incStat(ruleStats[op.index], result.state, result.phraseLength);
        if (op.type === id.UDT) incStat(udtStats[op.index], result.state, result.phraseLength);
    };
    // Display the statistics as an HTML table.
    // - *type*
    //   - "ops" - (default) display only the total hit counts for all operator types.
    //   - "index" - additionally, display the hit counts for the individual `RNM` and `UDT` operators ordered by index.
    //   - "hits" - additionally, display the hit counts for the individual `RNM` and `UDT` operators by hit count.
    //   - "alpha" - additionally, display the hit counts for the individual `RNM` and `UDT` operators by name alphabetically.
    // - *caption* - optional caption for the table
    this.toHtml = function toHtml(type, caption) {
        let html = "";
        html += `<table class="${style.CLASS_STATS}">\n`;
        if (typeof caption === "string") html += `<caption>${caption}</caption>\n`;
        html += `<tr><th class="${style.CLASS_ACTIVE}">ops</th>\n`;
        html += `<th class="${style.CLASS_EMPTY}">EMPTY</th>\n`;
        html += `<th class="${style.CLASS_MATCH}">MATCH</th>\n`;
        html += `<th class="${style.CLASS_NOMATCH}">NOMATCH</th>\n`;
        html += `<th class="${style.CLASS_ACTIVE}">totals</th></tr>\n`;
        const test = true;
        while(test){
            if (type === undefined) {
                html += displayOpsOnly();
                break;
            }
            if (type === null) {
                html += displayOpsOnly();
                break;
            }
            if (type === "ops") {
                html += displayOpsOnly();
                break;
            }
            if (type === "index") {
                ruleStats.sort(sortIndex);
                if (udtStats.length > 0) udtStats.sort(sortIndex);
                html += displayOpsOnly();
                html += displayRules();
                break;
            }
            if (type === "hits") {
                ruleStats.sort(sortHits);
                if (udtStats.length > 0) udtStats.sort(sortIndex);
                html += displayOpsOnly();
                html += displayRules();
                break;
            }
            if (type === "alpha") {
                ruleStats.sort(sortAlpha);
                if (udtStats.length > 0) udtStats.sort(sortAlpha);
                html += displayOpsOnly();
                html += displayRules();
                break;
            }
            break;
        }
        html += "</table>\n";
        return html;
    };
    // Display the stats table in a complete HTML5 page.
    this.toHtmlPage = function toHtmlPage(type, caption, title) {
        return utils.htmlToPage(this.toHtml(type, caption), title);
    };
};

});

parcelRegister("fFocM", function(module, exports) {
/* eslint-disable func-names */ /* eslint-disable prefer-destructuring */ /* eslint-disable no-restricted-syntax */ /* eslint-disable guard-for-in */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module provides a means of tracing the parser through the parse tree as it goes.
// It is the primary debugging facility for debugging both the SABNF grammar syntax
// and the input strings that are supposed to be valid grammar sentences.
// It is also a very informative and educational tool for understanding
// how a parser actually operates for a given language.
//
// Tracing is the process of generating and saving a record of information for each passage
// of the parser through a parse tree node. And since it traverses each node twice, once down the tree
// and once coming back up, there are two records for each node.
// This, obviously, has the potential of generating lots of records.
// And since these records are normally displayed on a web page
// it is important to have a means to limit the actual number of records generated to
// probably no more that a few thousand. This is almost always enough to find any errors.
// The problem is to get the *right* few thousand records.
// Therefore, this module has a number of ways of limiting and/or filtering, the number and type of records.
// Considerable effort has been made to make this filtering of the trace output as simple
// and intuitive as possible.
//
// However, the ability to filter the trace records, or for that matter even understand what they are
// and the information they contain, does require a minimum amount of understanding of the APG parsing
// method. The parse tree nodes are all represented by APG operators. They break down into two natural groups.
// - The `RNM` operators and `UDT` operators are named phrases.
// These are names chosen by the writer of the SABNF grammar to represent special phrases of interest.
// - All others collect, concatenate and otherwise manipulate various intermediate phrases along the way.
//
// There are separate means of filtering which of these operators in each of these two groups get traced.
// Let `trace` be an instantiated `trace.js` object.
// Prior to parsing the string, filtering the rules and UDTs can be defined as follows:
// ```
// trace.filter.rules["rulename"] = true;
//     /* trace rule name "rulename" */
// trace.filter.rules["udtname"]  = true;
//     /* trace UDT name "udtname" */
// trace.filter.rules["<ALL>"]    = true;
//     /* trace all rules and UDTs (the default) */
// trace.filter.rules["<NONE>"]   = true;
//     /* trace no rules or UDTS */
// ```
// If any rule or UDT name other than "&lt;ALL>" or "&lt;NONE>" is specified, all other names are turned off.
// Therefore, to be selective of rule names, a filter statement is required for each rule/UDT name desired.
//
// Filtering of the other operators follows a similar procedure.
// ```
// trace.filter.operators["TRG"] = true;
//     /* trace the terminal range, TRG, operators */
// trace.filter.operators["CAT"]  = true;
//     /* trace the concatenations, CAT, operators */
// trace.filter.operators["<ALL>"]    = true;
//     /* trace all operators */
// trace.filter.operators["<NONE>"]   = true;
//     /* trace no operators (the default) */
// ```
// If any operator name other than "&lt;ALL>" or "&lt;NONE>" is specified, all other names are turned off.
// Therefore, to be selective of operator names, a filter statement is required for each name desired.
//
// There is, additionally, a means for limiting the total number of filtered or saved trace records.
// See the function, `setMaxRecords(max)` below. This will result in only the last `max` records being saved.
//
// (See [`apg-examples`](https://github.com/ldthomas/apg-js-examples) for examples of using `trace.js`.)




module.exports = function exportTrace() {
    const utils = (parcelRequire("abgIo"));
    const style = (parcelRequire("fHN1N"));
    const circular = new (parcelRequire("cH6Qg"))();
    const id = (parcelRequire("aGWMb"));
    const thisFileName = "trace.js: ";
    const that = this;
    const MODE_HEX = 16;
    const MODE_DEC = 10;
    const MODE_ASCII = 8;
    const MODE_UNICODE = 32;
    const MAX_PHRASE = 80;
    const MAX_TLS = 5;
    const records = [];
    let maxRecords = 5000;
    let lastRecord = -1;
    let filteredRecords = 0;
    let treeDepth = 0;
    const recordStack = [];
    let chars = null;
    let rules = null;
    let udts = null;
    const operatorFilter = [];
    const ruleFilter = [];
    /* special trace table phrases */ const PHRASE_END = `<span class="${style.CLASS_LINEEND}">&bull;</span>`;
    const PHRASE_CONTINUE = `<span class="${style.CLASS_LINEEND}">&hellip;</span>`;
    const PHRASE_EMPTY = `<span class="${style.CLASS_EMPTY}">&#120634;</span>`;
    /* filter the non-RNM & non-UDT operators */ const initOperatorFilter = function() {
        const setOperators = function(set) {
            operatorFilter[id.ALT] = set;
            operatorFilter[id.CAT] = set;
            operatorFilter[id.REP] = set;
            operatorFilter[id.TLS] = set;
            operatorFilter[id.TBS] = set;
            operatorFilter[id.TRG] = set;
            operatorFilter[id.AND] = set;
            operatorFilter[id.NOT] = set;
            operatorFilter[id.BKR] = set;
            operatorFilter[id.BKA] = set;
            operatorFilter[id.BKN] = set;
            operatorFilter[id.ABG] = set;
            operatorFilter[id.AEN] = set;
        };
        let items = 0;
        // eslint-disable-next-line no-unused-vars
        for(const name in that.filter.operators)items += 1;
        if (items === 0) {
            /* case 1: no operators specified: default: do not trace any operators */ setOperators(false);
            return;
        }
        for(const name in that.filter.operators){
            const upper = name.toUpperCase();
            if (upper === "<ALL>") {
                /* case 2: <all> operators specified: trace all operators ignore all other operator commands */ setOperators(true);
                return;
            }
            if (upper === "<NONE>") {
                /* case 3: <none> operators specified: trace NO operators ignore all other operator commands */ setOperators(false);
                return;
            }
        }
        setOperators(false);
        for(const name in that.filter.operators){
            const upper = name.toUpperCase();
            /* case 4: one or more individual operators specified: trace 'true' operators only */ if (upper === "ALT") operatorFilter[id.ALT] = that.filter.operators[name] === true;
            else if (upper === "CAT") operatorFilter[id.CAT] = that.filter.operators[name] === true;
            else if (upper === "REP") operatorFilter[id.REP] = that.filter.operators[name] === true;
            else if (upper === "AND") operatorFilter[id.AND] = that.filter.operators[name] === true;
            else if (upper === "NOT") operatorFilter[id.NOT] = that.filter.operators[name] === true;
            else if (upper === "TLS") operatorFilter[id.TLS] = that.filter.operators[name] === true;
            else if (upper === "TBS") operatorFilter[id.TBS] = that.filter.operators[name] === true;
            else if (upper === "TRG") operatorFilter[id.TRG] = that.filter.operators[name] === true;
            else if (upper === "BKR") operatorFilter[id.BKR] = that.filter.operators[name] === true;
            else if (upper === "BKA") operatorFilter[id.BKA] = that.filter.operators[name] === true;
            else if (upper === "BKN") operatorFilter[id.BKN] = that.filter.operators[name] === true;
            else if (upper === "ABG") operatorFilter[id.ABG] = that.filter.operators[name] === true;
            else if (upper === "AEN") operatorFilter[id.AEN] = that.filter.operators[name] === true;
            else throw new Error(`${thisFileName}initOpratorFilter: '${name}' not a valid operator name.` + ` Must be <all>, <none>, alt, cat, rep, tls, tbs, trg, and, not, bkr, bka or bkn`);
        }
    };
    /* filter the rule and `UDT` named operators */ const initRuleFilter = function() {
        const setRules = function(set) {
            operatorFilter[id.RNM] = set;
            operatorFilter[id.UDT] = set;
            const count = rules.length + udts.length;
            ruleFilter.length = 0;
            for(let i = 0; i < count; i += 1)ruleFilter.push(set);
        };
        let items;
        let i;
        const list = [];
        for(i = 0; i < rules.length; i += 1)list.push(rules[i].lower);
        for(i = 0; i < udts.length; i += 1)list.push(udts[i].lower);
        ruleFilter.length = 0;
        items = 0;
        // eslint-disable-next-line no-unused-vars
        for(const name in that.filter.rules)items += 1;
        if (items === 0) {
            /* case 1: default to all rules & udts */ setRules(true);
            return;
        }
        for(const name in that.filter.rules){
            const lower = name.toLowerCase();
            if (lower === "<all>") {
                /* case 2: trace all rules ignore all other rule commands */ setRules(true);
                return;
            }
            if (lower === "<none>") {
                /* case 3: trace no rules */ setRules(false);
                return;
            }
        }
        /* case 4: trace only individually specified rules */ setRules(false);
        operatorFilter[id.RNM] = true;
        operatorFilter[id.UDT] = true;
        for(const name in that.filter.rules){
            const lower = name.toLowerCase();
            i = list.indexOf(lower);
            if (i < 0) throw new Error(`${thisFileName}initRuleFilter: '${name}' not a valid rule or udt name`);
            ruleFilter[i] = that.filter.rules[name] === true;
        }
    };
    /* used by other APG components to verify that they have a valid trace object */ this.traceObject = "traceObject";
    this.filter = {
        operators: [],
        rules: []
    };
    // Set the maximum number of records to keep (default = 5000).
    // Each record number larger than `maxRecords`
    // will result in deleting the previously oldest record.
    // - `max`: maximum number of records to retain (default = 5000)
    // - `last`: last record number to retain, (default = -1 for (unknown) actual last record)
    this.setMaxRecords = function(max, last) {
        lastRecord = -1;
        if (typeof max === "number" && max > 0) maxRecords = Math.ceil(max);
        else {
            maxRecords = 0;
            return;
        }
        if (typeof last === "number") {
            lastRecord = Math.floor(last);
            if (lastRecord < 0) lastRecord = -1;
        }
    };
    // Returns `maxRecords` to the caller.
    this.getMaxRecords = function() {
        return maxRecords;
    };
    // Returns `lastRecord` to the caller.
    this.getLastRecord = function() {
        return lastRecord;
    };
    /* Called only by the `parser.js` object. No verification of input. */ this.init = function(rulesIn, udtsIn, charsIn) {
        records.length = 0;
        recordStack.length = 0;
        filteredRecords = 0;
        treeDepth = 0;
        chars = charsIn;
        rules = rulesIn;
        udts = udtsIn;
        initOperatorFilter();
        initRuleFilter();
        circular.init(maxRecords);
    };
    /* returns true if this records passes through the designated filter, false if the record is to be skipped */ const filterOps = function(op) {
        let ret = false;
        if (op.type === id.RNM) {
            if (operatorFilter[op.type] && ruleFilter[op.index]) ret = true;
            else ret = false;
        } else if (op.type === id.UDT) {
            if (operatorFilter[op.type] && ruleFilter[rules.length + op.index]) ret = true;
            else ret = false;
        } else ret = operatorFilter[op.type];
        return ret;
    };
    const filterRecords = function(record) {
        if (lastRecord === -1) return true;
        if (record <= lastRecord) return true;
        return false;
    };
    /* Collect the "down" record. */ this.down = function(op, state, offset, length, anchor, lookAround) {
        if (filterRecords(filteredRecords) && filterOps(op)) {
            recordStack.push(filteredRecords);
            records[circular.increment()] = {
                dirUp: false,
                depth: treeDepth,
                thisLine: filteredRecords,
                thatLine: undefined,
                opcode: op,
                state: state,
                phraseIndex: offset,
                phraseLength: length,
                lookAnchor: anchor,
                lookAround: lookAround
            };
            filteredRecords += 1;
            treeDepth += 1;
        }
    };
    /* Collect the "up" record. */ this.up = function(op, state, offset, length, anchor, lookAround) {
        if (filterRecords(filteredRecords) && filterOps(op)) {
            const thisLine = filteredRecords;
            const thatLine = recordStack.pop();
            const thatRecord = circular.getListIndex(thatLine);
            if (thatRecord !== -1) records[thatRecord].thatLine = thisLine;
            treeDepth -= 1;
            records[circular.increment()] = {
                dirUp: true,
                depth: treeDepth,
                thisLine: thisLine,
                thatLine: thatLine,
                opcode: op,
                state: state,
                phraseIndex: offset,
                phraseLength: length,
                lookAnchor: anchor,
                lookAround: lookAround
            };
            filteredRecords += 1;
        }
    };
    /* convert the trace records to a tree of nodes */ const toTreeObj = function() {
        /* private helper functions */ function nodeOpcode(node, opcode) {
            let name;
            let casetype;
            let modetype;
            if (opcode) {
                node.op = {
                    id: opcode.type,
                    name: utils.opcodeToString(opcode.type)
                };
                node.opData = undefined;
                switch(opcode.type){
                    case id.RNM:
                        node.opData = rules[opcode.index].name;
                        break;
                    case id.UDT:
                        node.opData = udts[opcode.index].name;
                        break;
                    case id.BKR:
                        if (opcode.index < rules.length) name = rules[opcode.index].name;
                        else name = udts[opcode.index - rules.length].name;
                        casetype = opcode.bkrCase === id.BKR_MODE_CI ? "%i" : "%s";
                        modetype = opcode.bkrMode === id.BKR_MODE_UM ? "%u" : "%p";
                        node.opData = `\\\\${casetype}${modetype}${name}`;
                        break;
                    case id.TLS:
                        node.opData = [];
                        for(let i = 0; i < opcode.string.length; i += 1)node.opData.push(opcode.string[i]);
                        break;
                    case id.TBS:
                        node.opData = [];
                        for(let i = 0; i < opcode.string.length; i += 1)node.opData.push(opcode.string[i]);
                        break;
                    case id.TRG:
                        node.opData = [
                            opcode.min,
                            opcode.max
                        ];
                        break;
                    case id.REP:
                        node.opData = [
                            opcode.min,
                            opcode.max
                        ];
                        break;
                    default:
                        throw new Error("unrecognized opcode");
                }
            } else {
                node.op = {
                    id: undefined,
                    name: undefined
                };
                node.opData = undefined;
            }
        }
        function nodePhrase(state, index, length) {
            if (state === id.MATCH) return {
                index: index,
                length: length
            };
            if (state === id.NOMATCH) return {
                index: index,
                length: 0
            };
            if (state === id.EMPTY) return {
                index: index,
                length: 0
            };
            return null;
        }
        let nodeId = -1;
        function nodeDown(parent, record, depth) {
            const node = {
                // eslint-disable-next-line no-plusplus
                id: nodeId++,
                branch: -1,
                parent: parent,
                up: false,
                down: false,
                depth: depth,
                children: []
            };
            if (record) {
                node.down = true;
                node.state = {
                    id: record.state,
                    name: utils.stateToString(record.state)
                };
                node.phrase = null;
                nodeOpcode(node, record.opcode);
            } else {
                node.state = {
                    id: undefined,
                    name: undefined
                };
                node.phrase = nodePhrase();
                nodeOpcode(node, undefined);
            }
            return node;
        }
        function nodeUp(node, record) {
            if (record) {
                node.up = true;
                node.state = {
                    id: record.state,
                    name: utils.stateToString(record.state)
                };
                node.phrase = nodePhrase(record.state, record.phraseIndex, record.phraseLength);
                if (!node.down) nodeOpcode(node, record.opcode);
            }
        }
        /* walk the final tree: label branches and count leaf nodes */ let leafNodes = 0;
        let depth = -1;
        let branchCount = 1;
        function walk(node) {
            depth += 1;
            node.branch = branchCount;
            if (depth > treeDepth) treeDepth = depth;
            if (node.children.length === 0) leafNodes += 1;
            else for(let i = 0; i < node.children.length; i += 1){
                if (i > 0) branchCount += 1;
                node.children[i].leftMost = false;
                node.children[i].rightMost = false;
                if (node.leftMost) node.children[i].leftMost = i === 0;
                if (node.rightMost) node.children[i].rightMost = i === node.children.length - 1;
                walk(node.children[i]);
            }
            depth -= 1;
        }
        function display(node, offset) {
            let name;
            const obj = {};
            obj.id = node.id;
            obj.branch = node.branch;
            obj.leftMost = node.leftMost;
            obj.rightMost = node.rightMost;
            name = node.state.name ? node.state.name : "ACTIVE";
            obj.state = {
                id: node.state.id,
                name: name
            };
            name = node.op.name ? node.op.name : "?";
            obj.op = {
                id: node.op.id,
                name: name
            };
            if (typeof node.opData === "string") obj.opData = node.opData;
            else if (Array.isArray(node.opData)) {
                obj.opData = [];
                for(let i = 0; i < node.opData.length; i += 1)obj.opData[i] = node.opData[i];
            } else obj.opData = undefined;
            if (node.phrase) obj.phrase = {
                index: node.phrase.index,
                length: node.phrase.length
            };
            else obj.phrase = null;
            obj.depth = node.depth;
            obj.children = [];
            for(let i = 0; i < node.children.length; i += 1){
                const c = i !== node.children.length - 1;
                obj.children[i] = display(node.children[i], offset, c);
            }
            return obj;
        }
        /* construct the tree beginning here */ const branch = [];
        let root;
        let node;
        let parent;
        let record;
        let firstRecord = true;
        /* push a dummy node so the root node will have a non-null parent */ const dummy = nodeDown(null, null, -1);
        branch.push(dummy);
        node = dummy;
        circular.forEach((lineIndex)=>{
            record = records[lineIndex];
            if (firstRecord) {
                firstRecord = false;
                if (record.depth > 0) {
                    /* push some dummy nodes to fill in for missing records */ const num = record.dirUp ? record.depth + 1 : record.depth;
                    for(let i = 0; i < num; i += 1){
                        parent = node;
                        node = nodeDown(node, null, i);
                        branch.push(node);
                        parent.children.push(node);
                    }
                }
            }
            if (record.dirUp) {
                /* handle the next record up */ node = branch.pop();
                nodeUp(node, record);
                node = branch[branch.length - 1];
            } else {
                /* handle the next record down */ parent = node;
                node = nodeDown(node, record, record.depth);
                branch.push(node);
                parent.children.push(node);
            }
        });
        /* if not at root, walk it up to root */ while(branch.length > 1){
            node = branch.pop();
            nodeUp(node, null);
        }
        /* maybe redundant or paranoid tests: these should never happen */ if (dummy.children.length === 0) throw new Error("trace.toTree(): parse tree has no nodes");
        if (branch.length === 0) throw new Error("trace.toTree(): integrity check: dummy root node disappeared?");
        /* if no record for start rule: find the pseudo root node (first dummy node above a real node) */ root = dummy.children[0];
        let prev = root;
        while(root && !root.down && !root.up){
            prev = root;
            root = root.children[0];
        }
        root = prev;
        /* walk the tree of nodes: label brances and count leaves */ root.leftMost = true;
        root.rightMost = true;
        walk(root);
        root.branch = 0;
        /* generate the exported object */ const obj = {};
        obj.string = [];
        for(let i = 0; i < chars.length; i += 1)obj.string[i] = chars[i];
        /* generate the exported rule names */ obj.rules = [];
        for(let i = 0; i < rules.length; i += 1)obj.rules[i] = rules[i].name;
        /* generate the exported UDT names */ obj.udts = [];
        for(let i = 0; i < udts.length; i += 1)obj.udts[i] = udts[i].name;
        /* generate the ids */ obj.id = {};
        obj.id.ALT = {
            id: id.ALT,
            name: "ALT"
        };
        obj.id.CAT = {
            id: id.CAT,
            name: "CAT"
        };
        obj.id.REP = {
            id: id.REP,
            name: "REP"
        };
        obj.id.RNM = {
            id: id.RNM,
            name: "RNM"
        };
        obj.id.TLS = {
            id: id.TLS,
            name: "TLS"
        };
        obj.id.TBS = {
            id: id.TBS,
            name: "TBS"
        };
        obj.id.TRG = {
            id: id.TRG,
            name: "TRG"
        };
        obj.id.UDT = {
            id: id.UDT,
            name: "UDT"
        };
        obj.id.AND = {
            id: id.AND,
            name: "AND"
        };
        obj.id.NOT = {
            id: id.NOT,
            name: "NOT"
        };
        obj.id.BKR = {
            id: id.BKR,
            name: "BKR"
        };
        obj.id.BKA = {
            id: id.BKA,
            name: "BKA"
        };
        obj.id.BKN = {
            id: id.BKN,
            name: "BKN"
        };
        obj.id.ABG = {
            id: id.ABG,
            name: "ABG"
        };
        obj.id.AEN = {
            id: id.AEN,
            name: "AEN"
        };
        obj.id.ACTIVE = {
            id: id.ACTIVE,
            name: "ACTIVE"
        };
        obj.id.MATCH = {
            id: id.MATCH,
            name: "MATCH"
        };
        obj.id.EMPTY = {
            id: id.EMPTY,
            name: "EMPTY"
        };
        obj.id.NOMATCH = {
            id: id.NOMATCH,
            name: "NOMATCH"
        };
        /* generate the max tree depth */ obj.treeDepth = treeDepth;
        /* generate the number of leaf nodes (branches) */ obj.leafNodes = leafNodes;
        /* generate the types of the left- and right-most branches */ let branchesIncomplete;
        if (root.down) {
            if (root.up) branchesIncomplete = "none";
            else branchesIncomplete = "right";
        } else if (root.up) branchesIncomplete = "left";
        else branchesIncomplete = "both";
        obj.branchesIncomplete = branchesIncomplete;
        obj.tree = display(root, root.depth, false);
        return obj;
    };
    // Returns the trace records as JSON parse tree object.
    // - stringify: if `true`, the object is 'stringified' before returning, otherwise, the object itself is returned.
    this.toTree = function(stringify) {
        const obj = toTreeObj();
        if (stringify) return JSON.stringify(obj);
        return obj;
    };
    // Translate the trace records to HTML format and create a complete HTML page for browser display.
    this.toHtmlPage = function(mode, caption, title) {
        return utils.htmlToPage(this.toHtml(mode, caption), title);
    };
    /* From here on down, these are just helper functions for `toHtml()`. */ const htmlHeader = function(mode, caption) {
        /* open the page */ /* write the HTML5 header with table style */ /* open the <table> tag */ let modeName;
        switch(mode){
            case MODE_HEX:
                modeName = "hexadecimal";
                break;
            case MODE_DEC:
                modeName = "decimal";
                break;
            case MODE_ASCII:
                modeName = "ASCII";
                break;
            case MODE_UNICODE:
                modeName = "UNICODE";
                break;
            default:
                throw new Error(`${thisFileName}htmlHeader: unrecognized mode: ${mode}`);
        }
        let header = "";
        header += `<p>display mode: ${modeName}</p>\n`;
        header += `<table class="${style.CLASS_TRACE}">\n`;
        if (typeof caption === "string") header += `<caption>${caption}</caption>`;
        return header;
    };
    const htmlFooter = function() {
        let footer = "";
        /* close the </table> tag */ footer += "</table>\n";
        /* display a table legend */ footer += `<p class="${style.CLASS_MONOSPACE}">legend:<br>\n`;
        footer += "(a)&nbsp;-&nbsp;line number<br>\n";
        footer += "(b)&nbsp;-&nbsp;matching line number<br>\n";
        footer += "(c)&nbsp;-&nbsp;phrase offset<br>\n";
        footer += "(d)&nbsp;-&nbsp;phrase length<br>\n";
        footer += "(e)&nbsp;-&nbsp;tree depth<br>\n";
        footer += "(f)&nbsp;-&nbsp;operator state<br>\n";
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_ACTIVE}">&darr;</span>&nbsp;&nbsp;phrase opened<br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_MATCH}">&uarr;M</span> phrase matched<br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_EMPTY}">&uarr;E</span> empty phrase matched<br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_NOMATCH}">&uarr;N</span> phrase not matched<br>\n`;
        footer += "operator&nbsp;-&nbsp;ALT, CAT, REP, RNM, TRG, TLS, TBS<sup>&dagger;</sup>, UDT, AND, NOT, BKA, BKN, BKR, ABG, AEN<sup>&Dagger;</sup><br>\n";
        footer += `phrase&nbsp;&nbsp;&nbsp;-&nbsp;up to ${MAX_PHRASE} characters of the phrase being matched<br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_MATCH}">matched characters</span><br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_LOOKAHEAD}">matched characters in look ahead mode</span><br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_LOOKBEHIND}">matched characters in look behind mode</span><br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_REMAINDER}">remainder characters(not yet examined by parser)</span><br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_CTRLCHAR}">control characters, TAB, LF, CR, etc. (ASCII mode only)</span><br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;${PHRASE_EMPTY} empty string<br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;${PHRASE_END} end of input string<br>\n`;
        footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;${PHRASE_CONTINUE} input string display truncated<br>\n`;
        footer += "</p>\n";
        footer += `<p class="${style.CLASS_MONOSPACE}">\n`;
        footer += "<sup>&dagger;</sup>original ABNF operators:<br>\n";
        footer += "ALT - alternation<br>\n";
        footer += "CAT - concatenation<br>\n";
        footer += "REP - repetition<br>\n";
        footer += "RNM - rule name<br>\n";
        footer += "TRG - terminal range<br>\n";
        footer += "TLS - terminal literal string (case insensitive)<br>\n";
        footer += "TBS - terminal binary string (case sensitive)<br>\n";
        footer += "<br>\n";
        footer += "<sup>&Dagger;</sup>super set SABNF operators:<br>\n";
        footer += "UDT - user-defined terminal<br>\n";
        footer += "AND - positive look ahead<br>\n";
        footer += "NOT - negative look ahead<br>\n";
        footer += "BKA - positive look behind<br>\n";
        footer += "BKN - negative look behind<br>\n";
        footer += "BKR - back reference<br>\n";
        footer += "ABG - anchor - begin of input string<br>\n";
        footer += "AEN - anchor - end of input string<br>\n";
        footer += "</p>\n";
        return footer;
    };
    this.indent = function(depth) {
        let html = "";
        for(let i = 0; i < depth; i += 1)html += ".";
        return html;
    };
    /* format the TRG operator */ const displayTrg = function(mode, op) {
        let html = "";
        if (op.type === id.TRG) {
            if (mode === MODE_HEX || mode === MODE_UNICODE) {
                let hex = op.min.toString(16).toUpperCase();
                if (hex.length % 2 !== 0) hex = `0${hex}`;
                html += mode === MODE_HEX ? "%x" : "U+";
                html += hex;
                hex = op.max.toString(16).toUpperCase();
                if (hex.length % 2 !== 0) hex = `0${hex}`;
                html += `&ndash;${hex}`;
            } else html = `%d${op.min.toString(10)}&ndash;${op.max.toString(10)}`;
        }
        return html;
    };
    /* format the REP operator */ const displayRep = function(mode, op) {
        let html = "";
        if (op.type === id.REP) {
            if (mode === MODE_HEX) {
                let hex = op.min.toString(16).toUpperCase();
                if (hex.length % 2 !== 0) hex = `0${hex}`;
                html = `x${hex}`;
                if (op.max < Infinity) {
                    hex = op.max.toString(16).toUpperCase();
                    if (hex.length % 2 !== 0) hex = `0${hex}`;
                } else hex = "inf";
                html += `&ndash;${hex}`;
            } else if (op.max < Infinity) html = `${op.min.toString(10)}&ndash;${op.max.toString(10)}`;
            else html = `${op.min.toString(10)}&ndash;inf`;
        }
        return html;
    };
    /* format the TBS operator */ const displayTbs = function(mode, op) {
        let html = "";
        if (op.type === id.TBS) {
            const len = Math.min(op.string.length, MAX_TLS * 2);
            if (mode === MODE_HEX || mode === MODE_UNICODE) {
                html += mode === MODE_HEX ? "%x" : "U+";
                for(let i = 0; i < len; i += 1){
                    let hex;
                    if (i > 0) html += ".";
                    hex = op.string[i].toString(16).toUpperCase();
                    if (hex.length % 2 !== 0) hex = `0${hex}`;
                    html += hex;
                }
            } else {
                html = "%d";
                for(let i = 0; i < len; i += 1){
                    if (i > 0) html += ".";
                    html += op.string[i].toString(10);
                }
            }
            if (len < op.string.length) html += PHRASE_CONTINUE;
        }
        return html;
    };
    /* format the TLS operator */ const displayTls = function(mode, op) {
        let html = "";
        if (op.type === id.TLS) {
            const len = Math.min(op.string.length, MAX_TLS);
            if (mode === MODE_HEX || mode === MODE_DEC) {
                let charu;
                let charl;
                let base;
                if (mode === MODE_HEX) {
                    html = "%x";
                    base = 16;
                } else {
                    html = "%d";
                    base = 10;
                }
                for(let i = 0; i < len; i += 1){
                    if (i > 0) html += ".";
                    charl = op.string[i];
                    if (charl >= 97 && charl <= 122) {
                        charu = charl - 32;
                        html += `${charu.toString(base)}/${charl.toString(base)}`.toUpperCase();
                    } else if (charl >= 65 && charl <= 90) {
                        charu = charl;
                        charl += 32;
                        html += `${charu.toString(base)}/${charl.toString(base)}`.toUpperCase();
                    } else html += charl.toString(base).toUpperCase();
                }
                if (len < op.string.length) html += PHRASE_CONTINUE;
            } else {
                html = '"';
                for(let i = 0; i < len; i += 1)html += utils.asciiChars[op.string[i]];
                if (len < op.string.length) html += PHRASE_CONTINUE;
                html += '"';
            }
        }
        return html;
    };
    const subPhrase = function(mode, charsArg, index, length, prev) {
        if (length === 0) return "";
        let phrase = "";
        const comma = prev ? "," : "";
        switch(mode){
            case MODE_HEX:
                phrase = comma + utils.charsToHex(charsArg, index, length);
                break;
            case MODE_DEC:
                if (prev) return `,${utils.charsToDec(charsArg, index, length)}`;
                phrase = comma + utils.charsToDec(charsArg, index, length);
                break;
            case MODE_UNICODE:
                phrase = utils.charsToUnicode(charsArg, index, length);
                break;
            case MODE_ASCII:
            default:
                phrase = utils.charsToAsciiHtml(charsArg, index, length);
                break;
        }
        return phrase;
    };
    /* display phrases matched in look-behind mode */ const displayBehind = function(mode, charsArg, state, index, length, anchor) {
        let html = "";
        let beg1;
        let len1;
        let beg2;
        let len2;
        let lastchar = PHRASE_END;
        const spanBehind = `<span class="${style.CLASS_LOOKBEHIND}">`;
        const spanRemainder = `<span class="${style.CLASS_REMAINDER}">`;
        const spanend = "</span>";
        let prev = false;
        switch(state){
            case id.EMPTY:
                html += PHRASE_EMPTY;
            /* // eslint-disable-next-line no-fallthrough */ case id.NOMATCH:
            case id.MATCH:
            case id.ACTIVE:
                beg1 = index - length;
                len1 = anchor - beg1;
                beg2 = anchor;
                len2 = charsArg.length - beg2;
                break;
            default:
                throw new Error("unrecognized state");
        }
        lastchar = PHRASE_END;
        if (len1 > MAX_PHRASE) {
            len1 = MAX_PHRASE;
            lastchar = PHRASE_CONTINUE;
            len2 = 0;
        } else if (len1 + len2 > MAX_PHRASE) {
            lastchar = PHRASE_CONTINUE;
            len2 = MAX_PHRASE - len1;
        }
        if (len1 > 0) {
            html += spanBehind;
            html += subPhrase(mode, charsArg, beg1, len1, prev);
            html += spanend;
            prev = true;
        }
        if (len2 > 0) {
            html += spanRemainder;
            html += subPhrase(mode, charsArg, beg2, len2, prev);
            html += spanend;
        }
        return html + lastchar;
    };
    const displayForward = function(mode, charsArg, state, index, length, spanAhead) {
        let html = "";
        let beg1;
        let len1;
        let beg2;
        let len2;
        let lastchar = PHRASE_END;
        const spanRemainder = `<span class="${style.CLASS_REMAINDER}">`;
        const spanend = "</span>";
        let prev = false;
        switch(state){
            case id.EMPTY:
                html += PHRASE_EMPTY;
            /* // eslint-disable-next-line no-fallthrough */ case id.NOMATCH:
            case id.ACTIVE:
                beg1 = index;
                len1 = 0;
                beg2 = index;
                len2 = charsArg.length - beg2;
                break;
            case id.MATCH:
                beg1 = index;
                len1 = length;
                beg2 = index + len1;
                len2 = charsArg.length - beg2;
                break;
            default:
                throw new Error("unrecognized state");
        }
        lastchar = PHRASE_END;
        if (len1 > MAX_PHRASE) {
            len1 = MAX_PHRASE;
            lastchar = PHRASE_CONTINUE;
            len2 = 0;
        } else if (len1 + len2 > MAX_PHRASE) {
            lastchar = PHRASE_CONTINUE;
            len2 = MAX_PHRASE - len1;
        }
        if (len1 > 0) {
            html += spanAhead;
            html += subPhrase(mode, charsArg, beg1, len1, prev);
            html += spanend;
            prev = true;
        }
        if (len2 > 0) {
            html += spanRemainder;
            html += subPhrase(mode, charsArg, beg2, len2, prev);
            html += spanend;
        }
        return html + lastchar;
    };
    /* display phrases matched in look-ahead mode */ const displayAhead = function(mode, charsArg, state, index, length) {
        const spanAhead = `<span class="${style.CLASS_LOOKAHEAD}">`;
        return displayForward(mode, charsArg, state, index, length, spanAhead);
    };
    /* display phrases matched in normal parsing mode */ const displayNone = function(mode, charsArg, state, index, length) {
        const spanAhead = `<span class="${style.CLASS_MATCH}">`;
        return displayForward(mode, charsArg, state, index, length, spanAhead);
    };
    /* Returns the filtered records, formatted as an HTML table. */ const htmlTable = function(mode) {
        if (rules === null) return "";
        let html = "";
        let thisLine;
        let thatLine;
        let lookAhead;
        let lookBehind;
        let lookAround;
        let anchor;
        html += "<tr><th>(a)</th><th>(b)</th><th>(c)</th><th>(d)</th><th>(e)</th><th>(f)</th>";
        html += "<th>operator</th><th>phrase</th></tr>\n";
        circular.forEach((lineIndex)=>{
            const line = records[lineIndex];
            thisLine = line.thisLine;
            thatLine = line.thatLine !== undefined ? line.thatLine : "--";
            lookAhead = false;
            lookBehind = false;
            lookAround = false;
            if (line.lookAround === id.LOOKAROUND_AHEAD) {
                lookAhead = true;
                lookAround = true;
                anchor = line.lookAnchor;
            }
            if (line.opcode.type === id.AND || line.opcode.type === id.NOT) {
                lookAhead = true;
                lookAround = true;
                anchor = line.phraseIndex;
            }
            if (line.lookAround === id.LOOKAROUND_BEHIND) {
                lookBehind = true;
                lookAround = true;
                anchor = line.lookAnchor;
            }
            if (line.opcode.type === id.BKA || line.opcode.type === id.BKN) {
                lookBehind = true;
                lookAround = true;
                anchor = line.phraseIndex;
            }
            html += "<tr>";
            html += `<td>${thisLine}</td><td>${thatLine}</td>`;
            html += `<td>${line.phraseIndex}</td>`;
            html += `<td>${line.phraseLength}</td>`;
            html += `<td>${line.depth}</td>`;
            html += "<td>";
            switch(line.state){
                case id.ACTIVE:
                    html += `<span class="${style.CLASS_ACTIVE}">&darr;&nbsp;</span>`;
                    break;
                case id.MATCH:
                    html += `<span class="${style.CLASS_MATCH}">&uarr;M</span>`;
                    break;
                case id.NOMATCH:
                    html += `<span class="${style.CLASS_NOMATCH}">&uarr;N</span>`;
                    break;
                case id.EMPTY:
                    html += `<span class="${style.CLASS_EMPTY}">&uarr;E</span>`;
                    break;
                default:
                    html += `<span class="${style.CLASS_ACTIVE}">--</span>`;
                    break;
            }
            html += "</td>";
            html += "<td>";
            html += that.indent(line.depth);
            if (lookAhead) html += `<span class="${style.CLASS_LOOKAHEAD}">`;
            else if (lookBehind) html += `<span class="${style.CLASS_LOOKBEHIND}">`;
            html += utils.opcodeToString(line.opcode.type);
            if (line.opcode.type === id.RNM) html += `(${rules[line.opcode.index].name}) `;
            if (line.opcode.type === id.BKR) {
                const casetype = line.opcode.bkrCase === id.BKR_MODE_CI ? "%i" : "%s";
                const modetype = line.opcode.bkrMode === id.BKR_MODE_UM ? "%u" : "%p";
                html += `(\\${casetype}${modetype}${rules[line.opcode.index].name}) `;
            }
            if (line.opcode.type === id.UDT) html += `(${udts[line.opcode.index].name}) `;
            if (line.opcode.type === id.TRG) html += `(${displayTrg(mode, line.opcode)}) `;
            if (line.opcode.type === id.TBS) html += `(${displayTbs(mode, line.opcode)}) `;
            if (line.opcode.type === id.TLS) html += `(${displayTls(mode, line.opcode)}) `;
            if (line.opcode.type === id.REP) html += `(${displayRep(mode, line.opcode)}) `;
            if (lookAround) html += "</span>";
            html += "</td>";
            html += "<td>";
            if (lookBehind) html += displayBehind(mode, chars, line.state, line.phraseIndex, line.phraseLength, anchor);
            else if (lookAhead) html += displayAhead(mode, chars, line.state, line.phraseIndex, line.phraseLength);
            else html += displayNone(mode, chars, line.state, line.phraseIndex, line.phraseLength);
            html += "</td></tr>\n";
        });
        html += "<tr><th>(a)</th><th>(b)</th><th>(c)</th><th>(d)</th><th>(e)</th><th>(f)</th>";
        html += "<th>operator</th><th>phrase</th></tr>\n";
        html += "</table>\n";
        return html;
    };
    // Translate the trace records to HTML format.
    // - *modearg* - can be `"ascii"`, `"decimal"`, `"hexadecimal"` or `"unicode"`.
    // Determines the format of the string character code display.
    // - *caption* - optional caption for the HTML table.
    this.toHtml = function(modearg, caption) {
        /* writes the trace records as a table in a complete html page */ let mode = MODE_ASCII;
        if (typeof modearg === "string" && modearg.length >= 3) {
            const modein = modearg.toLowerCase().slice(0, 3);
            if (modein === "hex") mode = MODE_HEX;
            else if (modein === "dec") mode = MODE_DEC;
            else if (modein === "uni") mode = MODE_UNICODE;
        }
        let html = "";
        html += htmlHeader(mode, caption);
        html += htmlTable(mode);
        html += htmlFooter();
        return html;
    };
};

});


parcelRegister("dDEWY", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module reads the input grammar file and does a preliminary analysis
// before attempting to parse it into a grammar object.
// See:<br>
// `./dist/scanner-grammar.bnf`<br>
// for the grammar file this parser is based on.
//
// It has two primary functions.
// - verify the character codes - no non-printing ASCII characters
// - catalog the lines - create an array with a line object for each line.
// The object carries information about the line number and character length which is used
// by the parser generator primarily for error reporting.



module.exports = function exfn(chars, errors, strict, trace) {
    const thisFileName = "scanner.js: ";
    const apglib = (parcelRequire("k9qkr"));
    const grammar = new (parcelRequire("7i1KX"))();
    const { callbacks: callbacks } = (parcelRequire("hgIdu"));
    /* Scan the grammar for character code errors and catalog the lines. */ const lines = [];
    // eslint-disable-next-line new-cap
    const parser = new apglib.parser();
    // eslint-disable-next-line new-cap
    parser.ast = new apglib.ast();
    parser.ast.callbacks = callbacks;
    if (trace) {
        if (trace.traceObject !== "traceObject") throw new TypeError(`${thisFileName}trace argument is not a trace object`);
        parser.trace = trace;
    }
    /* parse the input SABNF grammar */ const test = parser.parse(grammar, "file", chars);
    if (test.success !== true) {
        errors.push({
            line: 0,
            char: 0,
            msg: "syntax analysis error analyzing input SABNF grammar"
        });
        return;
    }
    const data = {
        lines: lines,
        lineNo: 0,
        errors: errors,
        strict: !!strict
    };
    /* translate (analyze) the input SABNF grammar */ parser.ast.translate(data);
    // eslint-disable-next-line consistent-return
    return lines;
};

});
parcelRegister("7i1KX", function(module, exports) {
// copyright: Copyright (c) 2024 Lowell D. Thomas, all rights reserved<br>
//   license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)<br>
//
// Generated by apg-js, Version 4.4.0 [apg-js](https://github.com/ldthomas/apg-js)
module.exports = function grammar() {
    // ```
    // SUMMARY
    //      rules = 10
    //       udts = 0
    //    opcodes = 31
    //        ---   ABNF original opcodes
    //        ALT = 5
    //        CAT = 2
    //        REP = 4
    //        RNM = 11
    //        TLS = 0
    //        TBS = 4
    //        TRG = 5
    //        ---   SABNF superset opcodes
    //        UDT = 0
    //        AND = 0
    //        NOT = 0
    //        BKA = 0
    //        BKN = 0
    //        BKR = 0
    //        ABG = 0
    //        AEN = 0
    // characters = [0 - 4294967295]
    // ```
    /* OBJECT IDENTIFIER (for internal parser use) */ this.grammarObject = "grammarObject";
    /* RULES */ this.rules = [];
    this.rules[0] = {
        name: "file",
        lower: "file",
        index: 0,
        isBkr: false
    };
    this.rules[1] = {
        name: "line",
        lower: "line",
        index: 1,
        isBkr: false
    };
    this.rules[2] = {
        name: "line-text",
        lower: "line-text",
        index: 2,
        isBkr: false
    };
    this.rules[3] = {
        name: "last-line",
        lower: "last-line",
        index: 3,
        isBkr: false
    };
    this.rules[4] = {
        name: "valid",
        lower: "valid",
        index: 4,
        isBkr: false
    };
    this.rules[5] = {
        name: "invalid",
        lower: "invalid",
        index: 5,
        isBkr: false
    };
    this.rules[6] = {
        name: "end",
        lower: "end",
        index: 6,
        isBkr: false
    };
    this.rules[7] = {
        name: "CRLF",
        lower: "crlf",
        index: 7,
        isBkr: false
    };
    this.rules[8] = {
        name: "LF",
        lower: "lf",
        index: 8,
        isBkr: false
    };
    this.rules[9] = {
        name: "CR",
        lower: "cr",
        index: 9,
        isBkr: false
    };
    /* UDTS */ this.udts = [];
    /* OPCODES */ /* file */ this.rules[0].opcodes = [];
    this.rules[0].opcodes[0] = {
        type: 2,
        children: [
            1,
            3
        ]
    }; // CAT
    this.rules[0].opcodes[1] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[0].opcodes[2] = {
        type: 4,
        index: 1
    }; // RNM(line)
    this.rules[0].opcodes[3] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[0].opcodes[4] = {
        type: 4,
        index: 3
    }; // RNM(last-line)
    /* line */ this.rules[1].opcodes = [];
    this.rules[1].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[1].opcodes[1] = {
        type: 4,
        index: 2
    }; // RNM(line-text)
    this.rules[1].opcodes[2] = {
        type: 4,
        index: 6
    }; // RNM(end)
    /* line-text */ this.rules[2].opcodes = [];
    this.rules[2].opcodes[0] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[2].opcodes[1] = {
        type: 1,
        children: [
            2,
            3
        ]
    }; // ALT
    this.rules[2].opcodes[2] = {
        type: 4,
        index: 4
    }; // RNM(valid)
    this.rules[2].opcodes[3] = {
        type: 4,
        index: 5
    }; // RNM(invalid)
    /* last-line */ this.rules[3].opcodes = [];
    this.rules[3].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[3].opcodes[1] = {
        type: 1,
        children: [
            2,
            3
        ]
    }; // ALT
    this.rules[3].opcodes[2] = {
        type: 4,
        index: 4
    }; // RNM(valid)
    this.rules[3].opcodes[3] = {
        type: 4,
        index: 5
    }; // RNM(invalid)
    /* valid */ this.rules[4].opcodes = [];
    this.rules[4].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[4].opcodes[1] = {
        type: 5,
        min: 32,
        max: 126
    }; // TRG
    this.rules[4].opcodes[2] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    /* invalid */ this.rules[5].opcodes = [];
    this.rules[5].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[5].opcodes[1] = {
        type: 5,
        min: 0,
        max: 8
    }; // TRG
    this.rules[5].opcodes[2] = {
        type: 5,
        min: 11,
        max: 12
    }; // TRG
    this.rules[5].opcodes[3] = {
        type: 5,
        min: 14,
        max: 31
    }; // TRG
    this.rules[5].opcodes[4] = {
        type: 5,
        min: 127,
        max: 4294967295
    }; // TRG
    /* end */ this.rules[6].opcodes = [];
    this.rules[6].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3
        ]
    }; // ALT
    this.rules[6].opcodes[1] = {
        type: 4,
        index: 7
    }; // RNM(CRLF)
    this.rules[6].opcodes[2] = {
        type: 4,
        index: 8
    }; // RNM(LF)
    this.rules[6].opcodes[3] = {
        type: 4,
        index: 9
    }; // RNM(CR)
    /* CRLF */ this.rules[7].opcodes = [];
    this.rules[7].opcodes[0] = {
        type: 6,
        string: [
            13,
            10
        ]
    }; // TBS
    /* LF */ this.rules[8].opcodes = [];
    this.rules[8].opcodes[0] = {
        type: 6,
        string: [
            10
        ]
    }; // TBS
    /* CR */ this.rules[9].opcodes = [];
    this.rules[9].opcodes[0] = {
        type: 6,
        string: [
            13
        ]
    }; // TBS
    // The `toString()` function will display the original grammar file(s) that produced these opcodes.
    this.toString = function toString() {
        let str = "";
        str += "file = *line [last-line]\n";
        str += "line = line-text end\n";
        str += "line-text = *(valid/invalid)\n";
        str += "last-line = 1*(valid/invalid)\n";
        str += "valid = %d32-126 / %d9\n";
        str += "invalid = %d0-8 / %d11-12 /%d14-31 / %x7f-ffffffff\n";
        str += "end = CRLF / LF / CR\n";
        str += "CRLF = %d13.10\n";
        str += "LF = %d10\n";
        str += "CR = %d13\n";
        return str;
    };
};

});

parcelRegister("hgIdu", function(module, exports) {

$parcel$export(module.exports, "callbacks", function () { return $c9263acc5fd3a1b6$export$b89c5c1b934d8237; }, function (v) { return $c9263acc5fd3a1b6$export$b89c5c1b934d8237 = v; });
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // These are the AST translation callback functions used by the scanner
// to analyze the characters and lines.
var $c9263acc5fd3a1b6$export$b89c5c1b934d8237;

var $aGWMb = parcelRequire("aGWMb");

var $abgIo = parcelRequire("abgIo");
function $c9263acc5fd3a1b6$var$semLine(state, chars, phraseIndex, phraseCount, data) {
    if (state === $aGWMb.SEM_PRE) {
        data.endLength = 0;
        data.textLength = 0;
        data.invalidCount = 0;
    } else data.lines.push({
        lineNo: data.lines.length,
        beginChar: phraseIndex,
        length: phraseCount,
        textLength: data.textLength,
        endType: data.endType,
        invalidChars: data.invalidCount
    });
    return $aGWMb.SEM_OK;
}
function $c9263acc5fd3a1b6$var$semLineText(state, chars, phraseIndex, phraseCount, data) {
    if (state === $aGWMb.SEM_PRE) data.textLength = phraseCount;
    return $aGWMb.SEM_OK;
}
function $c9263acc5fd3a1b6$var$semLastLine(state, chars, phraseIndex, phraseCount, data) {
    if (state === $aGWMb.SEM_PRE) {
        data.endLength = 0;
        data.textLength = 0;
        data.invalidCount = 0;
    } else if (data.strict) {
        data.lines.push({
            lineNo: data.lines.length,
            beginChar: phraseIndex,
            length: phraseCount,
            textLength: phraseCount,
            endType: "none",
            invalidChars: data.invalidCount
        });
        data.errors.push({
            line: data.lineNo,
            char: phraseIndex + phraseCount,
            msg: "no line end on last line - strict ABNF specifies CRLF(\\r\\n, \\x0D\\x0A)"
        });
    } else {
        /* add a line ender */ chars.push(10);
        data.lines.push({
            lineNo: data.lines.length,
            beginChar: phraseIndex,
            length: phraseCount + 1,
            textLength: phraseCount,
            endType: "LF",
            invalidChars: data.invalidCount
        });
    }
    return $aGWMb.SEM_OK;
}
function $c9263acc5fd3a1b6$var$semInvalid(state, chars, phraseIndex, phraseCount, data) {
    if (state === $aGWMb.SEM_PRE) data.errors.push({
        line: data.lineNo,
        char: phraseIndex,
        msg: `invalid character found '\\x${$abgIo.charToHex(chars[phraseIndex])}'`
    });
    return $aGWMb.SEM_OK;
}
function $c9263acc5fd3a1b6$var$semEnd(state, chars, phraseIndex, phraseCount, data) {
    if (state === $aGWMb.SEM_POST) data.lineNo += 1;
    return $aGWMb.SEM_OK;
}
function $c9263acc5fd3a1b6$var$semLF(state, chars, phraseIndex, phraseCount, data) {
    if (state === $aGWMb.SEM_PRE) {
        data.endType = "LF";
        if (data.strict) data.errors.push({
            line: data.lineNo,
            char: phraseIndex,
            msg: "line end character LF(\\n, \\x0A) - strict ABNF specifies CRLF(\\r\\n, \\x0D\\x0A)"
        });
    }
    return $aGWMb.SEM_OK;
}
function $c9263acc5fd3a1b6$var$semCR(state, chars, phraseIndex, phraseCount, data) {
    if (state === $aGWMb.SEM_PRE) {
        data.endType = "CR";
        if (data.strict) data.errors.push({
            line: data.lineNo,
            char: phraseIndex,
            msg: "line end character CR(\\r, \\x0D) - strict ABNF specifies CRLF(\\r\\n, \\x0D\\x0A)"
        });
    }
    return $aGWMb.SEM_OK;
}
function $c9263acc5fd3a1b6$var$semCRLF(state, chars, phraseIndex, phraseCount, data) {
    if (state === $aGWMb.SEM_PRE) data.endType = "CRLF";
    return $aGWMb.SEM_OK;
}
const $c9263acc5fd3a1b6$var$callbacks = [];
$c9263acc5fd3a1b6$var$callbacks.line = $c9263acc5fd3a1b6$var$semLine;
$c9263acc5fd3a1b6$var$callbacks["line-text"] = $c9263acc5fd3a1b6$var$semLineText;
$c9263acc5fd3a1b6$var$callbacks["last-line"] = $c9263acc5fd3a1b6$var$semLastLine;
$c9263acc5fd3a1b6$var$callbacks.invalid = $c9263acc5fd3a1b6$var$semInvalid;
$c9263acc5fd3a1b6$var$callbacks.end = $c9263acc5fd3a1b6$var$semEnd;
$c9263acc5fd3a1b6$var$callbacks.lf = $c9263acc5fd3a1b6$var$semLF;
$c9263acc5fd3a1b6$var$callbacks.cr = $c9263acc5fd3a1b6$var$semCR;
$c9263acc5fd3a1b6$var$callbacks.crlf = $c9263acc5fd3a1b6$var$semCRLF;
$c9263acc5fd3a1b6$export$b89c5c1b934d8237 = $c9263acc5fd3a1b6$var$callbacks;

});


parcelRegister("bXN6J", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module converts an input SABNF grammar text file into a
// grammar object that can be used with `apg-lib` in an application parser.
// **apg** is, in fact itself, an ABNF parser that generates an SABNF parser.
// It is based on the grammar<br>
// `./dist/abnf-for-sabnf-grammar.bnf`.<br>
// In its syntax phase, **apg** analyzes the user's input SABNF grammar for correct syntax, generating an AST as it goes.
// In its semantic phase, **apg** translates the AST to generate the parser for the input grammar.




module.exports = function exportParser() {
    const thisFileName = "parser: ";
    const ApgLib = (parcelRequire("k9qkr"));
    const id = ApgLib.ids;
    const syn = new (parcelRequire("1AH4n"))();
    const sem = new (parcelRequire("5jlYN"))();
    const sabnfGrammar = new (parcelRequire("2cX0y"))();
    // eslint-disable-next-line new-cap
    const parser = new ApgLib.parser();
    // eslint-disable-next-line new-cap
    parser.ast = new ApgLib.ast();
    parser.callbacks = syn.callbacks;
    parser.ast.callbacks = sem.callbacks;
    /* find the line containing the given character index */ const findLine = function findLine(lines, charIndex, charLength) {
        if (charIndex < 0 || charIndex >= charLength) /* return error if out of range */ return -1;
        for(let i = 0; i < lines.length; i += 1){
            if (charIndex >= lines[i].beginChar && charIndex < lines[i].beginChar + lines[i].length) return i;
        }
        /* should never reach here */ return -1;
    };
    const translateIndex = function translateIndex(map, index) {
        let ret = -1;
        if (index < map.length) {
            for(let i = index; i < map.length; i += 1)if (map[i] !== null) {
                ret = map[i];
                break;
            }
        }
        return ret;
    };
    /* helper function when removing redundant opcodes */ const reduceOpcodes = function reduceOpcodes(rules) {
        rules.forEach((rule)=>{
            const opcodes = [];
            const map = [];
            let reducedIndex = 0;
            rule.opcodes.forEach((op)=>{
                if (op.type === id.ALT && op.children.length === 1) map.push(null);
                else if (op.type === id.CAT && op.children.length === 1) map.push(null);
                else if (op.type === id.REP && op.min === 1 && op.max === 1) map.push(null);
                else {
                    map.push(reducedIndex);
                    opcodes.push(op);
                    reducedIndex += 1;
                }
            });
            map.push(reducedIndex);
            /* translate original opcode indexes to the reduced set. */ opcodes.forEach((op)=>{
                if (op.type === id.ALT || op.type === id.CAT) for(let i = 0; i < op.children.length; i += 1)op.children[i] = translateIndex(map, op.children[i]);
            });
            rule.opcodes = opcodes;
        });
    };
    /* Parse the grammar - the syntax phase. */ /* SABNF grammar syntax errors are caught and reported here. */ this.syntax = function syntax(chars, lines, errors, strict, lite, trace) {
        if (trace) {
            if (trace.traceObject !== "traceObject") throw new TypeError(`${thisFileName}trace argument is not a trace object`);
            parser.trace = trace;
        }
        const data = {};
        data.errors = errors;
        data.strict = !!strict;
        data.lite = !!lite;
        data.lines = lines;
        data.findLine = findLine;
        data.charsLength = chars.length;
        data.ruleCount = 0;
        const result = parser.parse(sabnfGrammar, "file", chars, data);
        if (!result.success) errors.push({
            line: 0,
            char: 0,
            msg: "syntax analysis of input grammar failed"
        });
    };
    /* Parse the grammar - the semantic phase, translates the AST. */ /* SABNF grammar syntax errors are caught and reported here. */ this.semantic = function semantic(chars, lines, errors) {
        const data = {};
        data.errors = errors;
        data.lines = lines;
        data.findLine = findLine;
        data.charsLength = chars.length;
        parser.ast.translate(data);
        if (errors.length) return null;
        /* Remove unneeded operators. */ /* ALT operators with a single alternate */ /* CAT operators with a single phrase to concatenate */ /* REP(1,1) operators (`1*1RuleName` or `1RuleName` is the same as just `RuleName`.) */ reduceOpcodes(data.rules);
        return {
            rules: data.rules,
            udts: data.udts,
            lineMap: data.rulesLineMap
        };
    };
    // Generate a grammar constructor function.
    // An object instantiated from this constructor is used with the `apg-lib` `parser()` function.
    this.generateSource = function generateSource(chars, lines, rules, udts, config) {
        let source = "";
        let typescript = false;
        let lite = false;
        // config may have multiple grammar object type options in which case
        // --typescript > --lite  > no options
        if (config) {
            if (config.typescript) {
                typescript = true;
                lite = false;
            } else if (config.lite) {
                typescript = false;
                lite = true;
            }
        }
        let i;
        let bkrname;
        let bkrlower;
        let opcodeCount = 0;
        let charCodeMin = Infinity;
        let charCodeMax = 0;
        const ruleNames = [];
        const udtNames = [];
        let alt = 0;
        let cat = 0;
        let rnm = 0;
        let udt = 0;
        let rep = 0;
        let and = 0;
        let not = 0;
        let tls = 0;
        let tbs = 0;
        let trg = 0;
        let bkr = 0;
        let bka = 0;
        let bkn = 0;
        let abg = 0;
        let aen = 0;
        rules.forEach((rule)=>{
            ruleNames.push(rule.lower);
            opcodeCount += rule.opcodes.length;
            rule.opcodes.forEach((op)=>{
                switch(op.type){
                    case id.ALT:
                        alt += 1;
                        break;
                    case id.CAT:
                        cat += 1;
                        break;
                    case id.RNM:
                        rnm += 1;
                        break;
                    case id.UDT:
                        udt += 1;
                        break;
                    case id.REP:
                        rep += 1;
                        break;
                    case id.AND:
                        and += 1;
                        break;
                    case id.NOT:
                        not += 1;
                        break;
                    case id.BKA:
                        bka += 1;
                        break;
                    case id.BKN:
                        bkn += 1;
                        break;
                    case id.BKR:
                        bkr += 1;
                        break;
                    case id.ABG:
                        abg += 1;
                        break;
                    case id.AEN:
                        aen += 1;
                        break;
                    case id.TLS:
                        tls += 1;
                        for(i = 0; i < op.string.length; i += 1){
                            if (op.string[i] < charCodeMin) charCodeMin = op.string[i];
                            if (op.string[i] > charCodeMax) charCodeMax = op.string[i];
                        }
                        break;
                    case id.TBS:
                        tbs += 1;
                        for(i = 0; i < op.string.length; i += 1){
                            if (op.string[i] < charCodeMin) charCodeMin = op.string[i];
                            if (op.string[i] > charCodeMax) charCodeMax = op.string[i];
                        }
                        break;
                    case id.TRG:
                        trg += 1;
                        if (op.min < charCodeMin) charCodeMin = op.min;
                        if (op.max > charCodeMax) charCodeMax = op.max;
                        break;
                    default:
                        throw new Error("generateSource: unrecognized opcode");
                }
            });
        });
        ruleNames.sort();
        if (udts.length > 0) {
            udts.forEach((udtFunc)=>{
                udtNames.push(udtFunc.lower);
            });
            udtNames.sort();
        }
        source += "// copyright: Copyright (c) 2024 Lowell D. Thomas, all rights reserved<br>\n";
        source += "//   license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)<br>\n";
        source += "//\n";
        source += "// Generated by apg-js, Version 4.4.0 [apg-js](https://github.com/ldthomas/apg-js)\n";
        if (config) {
            if (config.funcName) source += `const ${config.funcName} = function grammar(){\n`;
            else if (typescript) source += "export function grammar(){\n";
            else if (lite) source += "export default function grammar(){\n";
            else source += `module.exports = function grammar(){\n`;
        } else source += `module.exports = function grammar(){\n`;
        source += "  // ```\n";
        source += "  // SUMMARY\n";
        source += `  //      rules = ${rules.length}\n`;
        source += `  //       udts = ${udts.length}\n`;
        source += `  //    opcodes = ${opcodeCount}\n`;
        source += "  //        ---   ABNF original opcodes\n";
        source += `  //        ALT = ${alt}\n`;
        source += `  //        CAT = ${cat}\n`;
        source += `  //        REP = ${rep}\n`;
        source += `  //        RNM = ${rnm}\n`;
        source += `  //        TLS = ${tls}\n`;
        source += `  //        TBS = ${tbs}\n`;
        source += `  //        TRG = ${trg}\n`;
        source += "  //        ---   SABNF superset opcodes\n";
        source += `  //        UDT = ${udt}\n`;
        source += `  //        AND = ${and}\n`;
        source += `  //        NOT = ${not}\n`;
        if (!lite) {
            source += `  //        BKA = ${bka}\n`;
            source += `  //        BKN = ${bkn}\n`;
            source += `  //        BKR = ${bkr}\n`;
            source += `  //        ABG = ${abg}\n`;
            source += `  //        AEN = ${aen}\n`;
        }
        source += "  // characters = [";
        if (tls + tbs + trg === 0) source += " none defined ]";
        else source += `${charCodeMin} - ${charCodeMax}]`;
        if (udt > 0) source += " + user defined";
        source += "\n";
        source += "  // ```\n";
        source += "  /* OBJECT IDENTIFIER (for internal parser use) */\n";
        source += "  this.grammarObject = 'grammarObject';\n";
        source += "\n";
        source += "  /* RULES */\n";
        source += "  this.rules = [];\n";
        rules.forEach((rule, ii)=>{
            let thisRule = "  this.rules[";
            thisRule += ii;
            thisRule += "] = { name: '";
            thisRule += rule.name;
            thisRule += "', lower: '";
            thisRule += rule.lower;
            thisRule += "', index: ";
            thisRule += rule.index;
            thisRule += ", isBkr: ";
            thisRule += rule.isBkr;
            thisRule += " };\n";
            source += thisRule;
        });
        source += "\n";
        source += "  /* UDTS */\n";
        source += "  this.udts = [];\n";
        if (udts.length > 0) udts.forEach((udtFunc, ii)=>{
            let thisUdt = "  this.udts[";
            thisUdt += ii;
            thisUdt += "] = { name: '";
            thisUdt += udtFunc.name;
            thisUdt += "', lower: '";
            thisUdt += udtFunc.lower;
            thisUdt += "', index: ";
            thisUdt += udtFunc.index;
            thisUdt += ", empty: ";
            thisUdt += udtFunc.empty;
            thisUdt += ", isBkr: ";
            thisUdt += udtFunc.isBkr;
            thisUdt += " };\n";
            source += thisUdt;
        });
        source += "\n";
        source += "  /* OPCODES */\n";
        rules.forEach((rule, ruleIndex)=>{
            if (ruleIndex > 0) source += "\n";
            source += `  /* ${rule.name} */\n`;
            source += `  this.rules[${ruleIndex}].opcodes = [];\n`;
            rule.opcodes.forEach((op, opIndex)=>{
                let prefix;
                switch(op.type){
                    case id.ALT:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type}, children: [${op.children.toString()}] };// ALT\n`;
                        break;
                    case id.CAT:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type}, children: [${op.children.toString()}] };// CAT\n`;
                        break;
                    case id.RNM:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type}, index: ${op.index} };// RNM(${rules[op.index].name})\n`;
                        break;
                    case id.BKR:
                        if (op.index >= rules.length) {
                            bkrname = udts[op.index - rules.length].name;
                            bkrlower = udts[op.index - rules.length].lower;
                        } else {
                            bkrname = rules[op.index].name;
                            bkrlower = rules[op.index].lower;
                        }
                        prefix = "%i";
                        if (op.bkrCase === id.BKR_MODE_CS) prefix = "%s";
                        if (op.bkrMode === id.BKR_MODE_UM) prefix += "%u";
                        else prefix += "%p";
                        bkrname = prefix + bkrname;
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type}, index: ${op.index}, lower: '${bkrlower}'` + `, bkrCase: ${op.bkrCase}, bkrMode: ${op.bkrMode} };// BKR(\\${bkrname})\n`;
                        break;
                    case id.UDT:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type}, empty: ${op.empty}, index: ${op.index} };// UDT(${udts[op.index].name})\n`;
                        break;
                    case id.REP:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type}, min: ${op.min}, max: ${op.max} };// REP\n`;
                        break;
                    case id.AND:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type} };// AND\n`;
                        break;
                    case id.NOT:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type} };// NOT\n`;
                        break;
                    case id.ABG:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type} };// ABG(%^)\n`;
                        break;
                    case id.AEN:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type} };// AEN(%$)\n`;
                        break;
                    case id.BKA:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type} };// BKA\n`;
                        break;
                    case id.BKN:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type} };// BKN\n`;
                        break;
                    case id.TLS:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type}, string: [${op.string.toString()}] };// TLS\n`;
                        break;
                    case id.TBS:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type}, string: [${op.string.toString()}] };// TBS\n`;
                        break;
                    case id.TRG:
                        source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = { type: ${op.type}, min: ${op.min}, max: ${op.max} };// TRG\n`;
                        break;
                    default:
                        throw new Error("parser.js: ~143: unrecognized opcode");
                }
            });
        });
        source += "\n";
        source += "  // The `toString()` function will display the original grammar file(s) that produced these opcodes.\n";
        source += "  this.toString = function toString(){\n";
        source += '    let str = "";\n';
        let str;
        lines.forEach((line)=>{
            const end = line.beginChar + line.length;
            str = "";
            source += '    str += "';
            for(let ii = line.beginChar; ii < end; ii += 1){
                switch(chars[ii]){
                    case 9:
                        str = " ";
                        break;
                    case 10:
                        str = "\\n";
                        break;
                    case 13:
                        str = "\\r";
                        break;
                    case 34:
                        str = '\\"';
                        break;
                    case 92:
                        str = "\\\\";
                        break;
                    default:
                        str = String.fromCharCode(chars[ii]);
                        break;
                }
                source += str;
            }
            source += '";\n';
        });
        source += "    return str;\n";
        source += "  }\n";
        source += "}\n";
        return source;
    };
    // Generate a grammar file object.
    // Returns the same object as instantiating the constructor function returned by<br>
    // `this.generateSource()`.<br>
    this.generateObject = function generateObject(stringArg, rules, udts) {
        const obj = {};
        const ruleNames = [];
        const udtNames = [];
        const string = stringArg.slice(0);
        obj.grammarObject = "grammarObject";
        rules.forEach((rule)=>{
            ruleNames.push(rule.lower);
        });
        ruleNames.sort();
        if (udts.length > 0) {
            udts.forEach((udtFunc)=>{
                udtNames.push(udtFunc.lower);
            });
            udtNames.sort();
        }
        obj.callbacks = [];
        ruleNames.forEach((name)=>{
            obj.callbacks[name] = false;
        });
        if (udts.length > 0) udtNames.forEach((name)=>{
            obj.callbacks[name] = false;
        });
        obj.rules = rules;
        obj.udts = udts;
        obj.toString = function toStringFunc() {
            return string;
        };
        return obj;
    };
};

});
parcelRegister("1AH4n", function(module, exports) {
/* eslint-disable func-names */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module has all of the callback functions for the syntax phase of the generation.
// See:<br>
// `./dist/abnf-for-sabnf-grammar.bnf`<br>
// for the grammar file these callback functions are based on.

module.exports = function exfn() {
    const thisFileName = "syntax-callbacks.js: ";
    const apglib = (parcelRequire("k9qkr"));
    const id = apglib.ids;
    let topAlt;
    /* syntax, RNM, callback functions */ const synFile = function synFile(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                data.altStack = [];
                data.repCount = 0;
                break;
            case id.EMPTY:
                data.errors.push({
                    line: 0,
                    char: 0,
                    msg: "grammar file is empty"
                });
                break;
            case id.MATCH:
                if (data.ruleCount === 0) data.errors.push({
                    line: 0,
                    char: 0,
                    msg: "no rules defined"
                });
                break;
            case id.NOMATCH:
                throw new Error(`${thisFileName}synFile: grammar file NOMATCH: design error: should never happen.`);
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    // eslint-disable-next-line func-names
    const synRule = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                data.altStack.length = 0;
                topAlt = {
                    groupOpen: null,
                    groupError: false,
                    optionOpen: null,
                    optionError: false,
                    tlsOpen: null,
                    clsOpen: null,
                    prosValOpen: null,
                    basicError: false
                };
                data.altStack.push(topAlt);
                break;
            case id.EMPTY:
                throw new Error(`${thisFileName}synRule: EMPTY: rule cannot be empty`);
            case id.NOMATCH:
                break;
            case id.MATCH:
                data.ruleCount += 1;
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synRuleError = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Unrecognized SABNF line. Invalid rule, comment or blank line."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synRuleNameError = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Rule names must be alphanum and begin with alphabetic character."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synDefinedAsError = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Expected '=' or '=/'. Not found."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synAndOp = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "AND operator(&) found - strict ABNF specified."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synNotOp = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "NOT operator(!) found - strict ABNF specified."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synBkaOp = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Positive look-behind operator(&&) found - strict ABNF specified."
                });
                else if (data.lite) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Positive look-behind operator(&&) found - apg-lite specified."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synBknOp = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Negative look-behind operator(!!) found - strict ABNF specified."
                });
                else if (data.lite) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Negative look-behind operator(!!) found - apg-lite specified."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synAbgOp = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Beginning of string anchor(%^) found - strict ABNF specified."
                });
                else if (data.lite) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Beginning of string anchor(%^) found - apg-lite specified."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synAenOp = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "End of string anchor(%$) found - strict ABNF specified."
                });
                else if (data.lite) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "End of string anchor(%$) found - apg-lite specified."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synBkrOp = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) {
                    const name = apglib.utils.charsToString(chars, phraseIndex, result.phraseLength);
                    data.errors.push({
                        line: data.findLine(data.lines, phraseIndex, data.charsLength),
                        char: phraseIndex,
                        msg: `Back reference operator(${name}) found - strict ABNF specified.`
                    });
                } else if (data.lite) {
                    const name = apglib.utils.charsToString(chars, phraseIndex, result.phraseLength);
                    data.errors.push({
                        line: data.findLine(data.lines, phraseIndex, data.charsLength),
                        char: phraseIndex,
                        msg: `Back reference operator(${name}) found - apg-lite specified.`
                    });
                }
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synUdtOp = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.strict) {
                    const name = apglib.utils.charsToString(chars, phraseIndex, result.phraseLength);
                    data.errors.push({
                        line: data.findLine(data.lines, phraseIndex, data.charsLength),
                        char: phraseIndex,
                        msg: `UDT operator found(${name}) - strict ABNF specified.`
                    });
                }
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synTlsOpen = function(result, chars, phraseIndex) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                topAlt.tlsOpen = phraseIndex;
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synTlsString = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                data.stringTabChar = false;
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.stringTabChar !== false) data.errors.push({
                    line: data.findLine(data.lines, data.stringTabChar),
                    char: data.stringTabChar,
                    msg: "Tab character (\\t, x09) not allowed in literal string (see 'quoted-string' definition, RFC 7405.)"
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synStringTab = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                data.stringTabChar = phraseIndex;
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synTlsClose = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                data.errors.push({
                    line: data.findLine(data.lines, topAlt.tlsOpen),
                    char: topAlt.tlsOpen,
                    msg: 'Case-insensitive literal string("...") opened but not closed.'
                });
                topAlt.basicError = true;
                topAlt.tlsOpen = null;
                break;
            case id.MATCH:
                topAlt.tlsOpen = null;
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synClsOpen = function(result, chars, phraseIndex) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                topAlt.clsOpen = phraseIndex;
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synClsString = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                data.stringTabChar = false;
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.stringTabChar !== false) data.errors.push({
                    line: data.findLine(data.lines, data.stringTabChar),
                    char: data.stringTabChar,
                    msg: "Tab character (\\t, x09) not allowed in literal string."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synClsClose = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                data.errors.push({
                    line: data.findLine(data.lines, topAlt.clsOpen),
                    char: topAlt.clsOpen,
                    msg: "Case-sensitive literal string('...') opened but not closed."
                });
                topAlt.clsOpen = null;
                topAlt.basicError = true;
                break;
            case id.MATCH:
                if (data.strict) data.errors.push({
                    line: data.findLine(data.lines, topAlt.clsOpen),
                    char: topAlt.clsOpen,
                    msg: "Case-sensitive string operator('...') found - strict ABNF specified."
                });
                topAlt.clsOpen = null;
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synProsValOpen = function(result, chars, phraseIndex) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                topAlt.prosValOpen = phraseIndex;
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synProsValString = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                data.stringTabChar = false;
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (data.stringTabChar !== false) data.errors.push({
                    line: data.findLine(data.lines, data.stringTabChar),
                    char: data.stringTabChar,
                    msg: "Tab character (\\t, x09) not allowed in prose value string."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synProsValClose = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                data.errors.push({
                    line: data.findLine(data.lines, topAlt.prosValOpen),
                    char: topAlt.prosValOpen,
                    msg: "Prose value operator(<...>) opened but not closed."
                });
                topAlt.basicError = true;
                topAlt.prosValOpen = null;
                break;
            case id.MATCH:
                data.errors.push({
                    line: data.findLine(data.lines, topAlt.prosValOpen),
                    char: topAlt.prosValOpen,
                    msg: "Prose value operator(<...>) found. The ABNF syntax is valid, but a parser cannot be generated from this grammar."
                });
                topAlt.prosValOpen = null;
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synGroupOpen = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                topAlt = {
                    groupOpen: phraseIndex,
                    groupError: false,
                    optionOpen: null,
                    optionError: false,
                    tlsOpen: null,
                    clsOpen: null,
                    prosValOpen: null,
                    basicError: false
                };
                data.altStack.push(topAlt);
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synGroupClose = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                data.errors.push({
                    line: data.findLine(data.lines, topAlt.groupOpen),
                    char: topAlt.groupOpen,
                    msg: 'Group "(...)" opened but not closed.'
                });
                topAlt = data.altStack.pop();
                topAlt.groupError = true;
                break;
            case id.MATCH:
                topAlt = data.altStack.pop();
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synOptionOpen = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                topAlt = {
                    groupOpen: null,
                    groupError: false,
                    optionOpen: phraseIndex,
                    optionError: false,
                    tlsOpen: null,
                    clsOpen: null,
                    prosValOpen: null,
                    basicError: false
                };
                data.altStack.push(topAlt);
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synOptionClose = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                data.errors.push({
                    line: data.findLine(data.lines, topAlt.optionOpen),
                    char: topAlt.optionOpen,
                    msg: 'Option "[...]" opened but not closed.'
                });
                topAlt = data.altStack.pop();
                topAlt.optionError = true;
                break;
            case id.MATCH:
                topAlt = data.altStack.pop();
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synBasicElementError = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (topAlt.basicError === false) data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Unrecognized SABNF element."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synLineEnd = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                if (result.phraseLength === 1 && data.strict) {
                    const end = chars[phraseIndex] === 13 ? "CR" : "LF";
                    data.errors.push({
                        line: data.findLine(data.lines, phraseIndex, data.charsLength),
                        char: phraseIndex,
                        msg: `Line end '${end}' found - strict ABNF specified, only CRLF allowed.`
                    });
                }
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synLineEndError = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                break;
            case id.MATCH:
                data.errors.push({
                    line: data.findLine(data.lines, phraseIndex, data.charsLength),
                    char: phraseIndex,
                    msg: "Unrecognized grammar element or characters."
                });
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    const synRepetition = function(result, chars, phraseIndex, data) {
        switch(result.state){
            case id.ACTIVE:
                break;
            case id.EMPTY:
                break;
            case id.NOMATCH:
                data.repCount += 1;
                break;
            case id.MATCH:
                data.repCount += 1;
                break;
            default:
                throw new Error(`${thisFileName}synFile: unrecognized case.`);
        }
    };
    // Define the list of callback functions.
    this.callbacks = [];
    this.callbacks.andop = synAndOp;
    this.callbacks.basicelementerr = synBasicElementError;
    this.callbacks.clsclose = synClsClose;
    this.callbacks.clsopen = synClsOpen;
    this.callbacks.clsstring = synClsString;
    this.callbacks.definedaserror = synDefinedAsError;
    this.callbacks.file = synFile;
    this.callbacks.groupclose = synGroupClose;
    this.callbacks.groupopen = synGroupOpen;
    this.callbacks.lineenderror = synLineEndError;
    this.callbacks.lineend = synLineEnd;
    this.callbacks.notop = synNotOp;
    this.callbacks.optionclose = synOptionClose;
    this.callbacks.optionopen = synOptionOpen;
    this.callbacks.prosvalclose = synProsValClose;
    this.callbacks.prosvalopen = synProsValOpen;
    this.callbacks.prosvalstring = synProsValString;
    this.callbacks.repetition = synRepetition;
    this.callbacks.rule = synRule;
    this.callbacks.ruleerror = synRuleError;
    this.callbacks.rulenameerror = synRuleNameError;
    this.callbacks.stringtab = synStringTab;
    this.callbacks.tlsclose = synTlsClose;
    this.callbacks.tlsopen = synTlsOpen;
    this.callbacks.tlsstring = synTlsString;
    this.callbacks.udtop = synUdtOp;
    this.callbacks.bkaop = synBkaOp;
    this.callbacks.bknop = synBknOp;
    this.callbacks.bkrop = synBkrOp;
    this.callbacks.abgop = synAbgOp;
    this.callbacks.aenop = synAenOp;
};

});

parcelRegister("5jlYN", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module has all of the AST translation callback functions for the semantic analysis
// phase of the generator.
// See:<br>
// `./dist/abnf-for-sabnf-grammar.bnf`<br>
// for the grammar file these callback functions are based on.

module.exports = function exfn() {
    const apglib = (parcelRequire("k9qkr"));
    const id = apglib.ids;
    /* Some helper functions. */ const NameList = function NameList() {
        this.names = [];
        /* Adds a new rule name object to the list. Returns -1 if the name already exists. */ /* Returns the added name object if the name does not already exist. */ this.add = function add(name) {
            let ret = -1;
            const find = this.get(name);
            if (find === -1) {
                ret = {
                    name: name,
                    lower: name.toLowerCase(),
                    index: this.names.length
                };
                this.names.push(ret);
            }
            return ret;
        };
        /* Brute-force look up. */ this.get = function get(name) {
            let ret = -1;
            const lower = name.toLowerCase();
            for(let i = 0; i < this.names.length; i += 1)if (this.names[i].lower === lower) {
                ret = this.names[i];
                break;
            }
            return ret;
        };
    };
    /* converts text decimal numbers from, e.g. %d99, to an integer */ const decnum = function decnum(chars, beg, len) {
        let num = 0;
        for(let i = beg; i < beg + len; i += 1)num = 10 * num + chars[i] - 48;
        return num;
    };
    /* converts text binary numbers from, e.g. %b10, to an integer */ const binnum = function binnum(chars, beg, len) {
        let num = 0;
        for(let i = beg; i < beg + len; i += 1)num = 2 * num + chars[i] - 48;
        return num;
    };
    /* converts text hexadecimal numbers from, e.g. %xff, to an integer */ const hexnum = function hexnum(chars, beg, len) {
        let num = 0;
        for(let i = beg; i < beg + len; i += 1){
            let digit = chars[i];
            if (digit >= 48 && digit <= 57) digit -= 48;
            else if (digit >= 65 && digit <= 70) digit -= 55;
            else if (digit >= 97 && digit <= 102) digit -= 87;
            else throw new Error("hexnum out of range");
            num = 16 * num + digit;
        }
        return num;
    };
    // This is the prototype for all semantic analysis callback functions.
    // ````
    // state - the translator state
    //   id.SEM_PRE for downward (pre-branch) traversal of the AST
    //   id.SEM_POST for upward (post branch) traversal of the AST
    // chars - the array of character codes for the input string
    // phraseIndex - index into the chars array to the first
    //               character of the phrase
    // phraseCount - the number of characters in the phrase
    // data - user-defined data passed to the translator
    //        for use by the callback functions.
    // @return id.SEM_OK, normal return.
    //         id.SEM_SKIP in state id.SEM_PRE will
    //         skip the branch below.
    //         Any thing else is an error which will
    //         stop the translation.
    // ````
    /*
  function semCallbackPrototype(state, chars, phraseIndex, phraseCount, data) {
    let ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
    } else if (state === id.SEM_POST) {
    }
    return ret;
  }
  */ // The AST callback functions.
    function semFile(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.ruleNames = new NameList();
            data.udtNames = new NameList();
            data.rules = [];
            data.udts = [];
            data.rulesLineMap = [];
            data.opcodes = [];
            data.altStack = [];
            data.topStack = null;
            data.topRule = null;
        } else if (state === id.SEM_POST) {
            /* validate RNM rule names and set opcode rule index */ let nameObj;
            data.rules.forEach((rule)=>{
                rule.isBkr = false;
                rule.opcodes.forEach((op)=>{
                    if (op.type === id.RNM) {
                        nameObj = data.ruleNames.get(op.index.name);
                        if (nameObj === -1) {
                            data.errors.push({
                                line: data.findLine(data.lines, op.index.phraseIndex, data.charsLength),
                                char: op.index.phraseIndex,
                                msg: `Rule name '${op.index.name}' used but not defined.`
                            });
                            op.index = -1;
                        } else op.index = nameObj.index;
                    }
                });
            });
            /* validate BKR rule names and set opcode rule index */ data.udts.forEach((udt)=>{
                udt.isBkr = false;
            });
            data.rules.forEach((rule)=>{
                rule.opcodes.forEach((op)=>{
                    if (op.type === id.BKR) {
                        rule.hasBkr = true;
                        nameObj = data.ruleNames.get(op.index.name);
                        if (nameObj !== -1) {
                            data.rules[nameObj.index].isBkr = true;
                            op.index = nameObj.index;
                        } else {
                            nameObj = data.udtNames.get(op.index.name);
                            if (nameObj !== -1) {
                                data.udts[nameObj.index].isBkr = true;
                                op.index = data.rules.length + nameObj.index;
                            } else {
                                data.errors.push({
                                    line: data.findLine(data.lines, op.index.phraseIndex, data.charsLength),
                                    char: op.index.phraseIndex,
                                    msg: `Back reference name '${op.index.name}' refers to undefined rule or unamed UDT.`
                                });
                                op.index = -1;
                            }
                        }
                    }
                });
            });
        }
        return ret;
    }
    function semRule(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.altStack.length = 0;
            data.topStack = null;
            data.rulesLineMap.push({
                line: data.findLine(data.lines, phraseIndex, data.charsLength),
                char: phraseIndex
            });
        }
        return ret;
    }
    function semRuleLookup(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.ruleName = "";
            data.definedas = "";
        } else if (state === id.SEM_POST) {
            let ruleName;
            if (data.definedas === "=") {
                ruleName = data.ruleNames.add(data.ruleName);
                if (ruleName === -1) {
                    data.definedas = null;
                    data.errors.push({
                        line: data.findLine(data.lines, phraseIndex, data.charsLength),
                        char: phraseIndex,
                        msg: `Rule name '${data.ruleName}' previously defined.`
                    });
                } else {
                    /* start a new rule */ data.topRule = {
                        name: ruleName.name,
                        lower: ruleName.lower,
                        opcodes: [],
                        index: ruleName.index
                    };
                    data.rules.push(data.topRule);
                    data.opcodes = data.topRule.opcodes;
                }
            } else {
                ruleName = data.ruleNames.get(data.ruleName);
                if (ruleName === -1) {
                    data.definedas = null;
                    data.errors.push({
                        line: data.findLine(data.lines, phraseIndex, data.charsLength),
                        char: phraseIndex,
                        msg: `Rule name '${data.ruleName}' for incremental alternate not previously defined.`
                    });
                } else {
                    data.topRule = data.rules[ruleName.index];
                    data.opcodes = data.topRule.opcodes;
                }
            }
        }
        return ret;
    }
    function semAlternation(state, chars, phraseIndex, phraseCount, data) {
        let ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            const TRUE = true;
            while(TRUE){
                if (data.definedas === null) {
                    /* rule error - skip opcode generation */ ret = id.SEM_SKIP;
                    break;
                }
                if (data.topStack === null) {
                    /* top-level ALT */ if (data.definedas === "=") {
                        /* "=" new rule */ data.topStack = {
                            alt: {
                                type: id.ALT,
                                children: []
                            },
                            cat: null
                        };
                        data.altStack.push(data.topStack);
                        data.opcodes.push(data.topStack.alt);
                        break;
                    }
                    /* "=/" incremental alternate */ data.topStack = {
                        alt: data.opcodes[0],
                        cat: null
                    };
                    data.altStack.push(data.topStack);
                    break;
                }
                /* lower-level ALT */ data.topStack = {
                    alt: {
                        type: id.ALT,
                        children: []
                    },
                    cat: null
                };
                data.altStack.push(data.topStack);
                data.opcodes.push(data.topStack.alt);
                break;
            }
        } else if (state === id.SEM_POST) {
            data.altStack.pop();
            if (data.altStack.length > 0) data.topStack = data.altStack[data.altStack.length - 1];
            else data.topStack = null;
        }
        return ret;
    }
    function semConcatenation(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.topStack.alt.children.push(data.opcodes.length);
            data.topStack.cat = {
                type: id.CAT,
                children: []
            };
            data.opcodes.push(data.topStack.cat);
        } else if (state === id.SEM_POST) data.topStack.cat = null;
        return ret;
    }
    function semRepetition(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.topStack.cat.children.push(data.opcodes.length);
        return ret;
    }
    function semOptionOpen(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.REP,
            min: 0,
            max: 1,
            char: phraseIndex
        });
        return ret;
    }
    function semRuleName(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.ruleName = apglib.utils.charsToString(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semDefined(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.definedas = "=";
        return ret;
    }
    function semIncAlt(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.definedas = "=/";
        return ret;
    }
    function semRepOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.min = 0;
            data.max = Infinity;
            data.topRep = {
                type: id.REP,
                min: 0,
                max: Infinity
            };
            data.opcodes.push(data.topRep);
        } else if (state === id.SEM_POST) {
            if (data.min > data.max) data.errors.push({
                line: data.findLine(data.lines, phraseIndex, data.charsLength),
                char: phraseIndex,
                msg: `repetition min cannot be greater than max: min: ${data.min}: max: ${data.max}`
            });
            data.topRep.min = data.min;
            data.topRep.max = data.max;
        }
        return ret;
    }
    function semRepMin(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.min = decnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semRepMax(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.max = decnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semRepMinMax(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) {
            data.max = decnum(chars, phraseIndex, phraseCount);
            data.min = data.max;
        }
        return ret;
    }
    function semAndOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.AND
        });
        return ret;
    }
    function semNotOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.NOT
        });
        return ret;
    }
    function semRnmOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.RNM,
            /* NOTE: this is temporary info, index will be replaced with integer later. */ /* Probably not the best coding practice but here you go. */ index: {
                phraseIndex: phraseIndex,
                name: apglib.utils.charsToString(chars, phraseIndex, phraseCount)
            }
        });
        return ret;
    }
    function semAbgOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.ABG
        });
        return ret;
    }
    function semAenOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.AEN
        });
        return ret;
    }
    function semBkaOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.BKA
        });
        return ret;
    }
    function semBknOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.opcodes.push({
            type: id.BKN
        });
        return ret;
    }
    function semBkrOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.ci = true; /* default to case insensitive */ 
            data.cs = false;
            data.um = true;
            data.pm = false;
        } else if (state === id.SEM_POST) data.opcodes.push({
            type: id.BKR,
            bkrCase: data.cs === true ? id.BKR_MODE_CS : id.BKR_MODE_CI,
            bkrMode: data.pm === true ? id.BKR_MODE_PM : id.BKR_MODE_UM,
            /* NOTE: this is temporary info, index will be replaced with integer later. */ /* Probably not the best coding practice but here you go. */ index: {
                phraseIndex: data.bkrname.phraseIndex,
                name: apglib.utils.charsToString(chars, data.bkrname.phraseIndex, data.bkrname.phraseLength)
            }
        });
        return ret;
    }
    function semBkrCi(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.ci = true;
        return ret;
    }
    function semBkrCs(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.cs = true;
        return ret;
    }
    function semBkrUm(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.um = true;
        return ret;
    }
    function semBkrPm(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.pm = true;
        return ret;
    }
    function semBkrName(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.bkrname = {
            phraseIndex: phraseIndex,
            phraseLength: phraseCount
        };
        return ret;
    }
    function semUdtEmpty(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) {
            const name = apglib.utils.charsToString(chars, phraseIndex, phraseCount);
            let udtName = data.udtNames.add(name);
            if (udtName === -1) {
                udtName = data.udtNames.get(name);
                if (udtName === -1) throw new Error("semUdtEmpty: name look up error");
            } else data.udts.push({
                name: udtName.name,
                lower: udtName.lower,
                index: udtName.index,
                empty: true
            });
            data.opcodes.push({
                type: id.UDT,
                empty: true,
                index: udtName.index
            });
        }
        return ret;
    }
    function semUdtNonEmpty(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) {
            const name = apglib.utils.charsToString(chars, phraseIndex, phraseCount);
            let udtName = data.udtNames.add(name);
            if (udtName === -1) {
                udtName = data.udtNames.get(name);
                if (udtName === -1) throw new Error("semUdtNonEmpty: name look up error");
            } else data.udts.push({
                name: udtName.name,
                lower: udtName.lower,
                index: udtName.index,
                empty: false
            });
            data.opcodes.push({
                type: id.UDT,
                empty: false,
                index: udtName.index,
                syntax: null,
                semantic: null
            });
        }
        return ret;
    }
    function semTlsOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.tlscase = true; /* default to case insensitive */ 
        return ret;
    }
    function semTlsCase(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) {
            if (phraseCount > 0 && (chars[phraseIndex + 1] === 83 || chars[phraseIndex + 1] === 115)) data.tlscase = false; /* set to case sensitive */ 
        }
        return ret;
    }
    function semTlsString(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) {
            if (data.tlscase) {
                const str = chars.slice(phraseIndex, phraseIndex + phraseCount);
                for(let i = 0; i < str.length; i += 1)if (str[i] >= 65 && str[i] <= 90) str[i] += 32;
                data.opcodes.push({
                    type: id.TLS,
                    string: str
                });
            } else data.opcodes.push({
                type: id.TBS,
                string: chars.slice(phraseIndex, phraseIndex + phraseCount)
            });
        }
        return ret;
    }
    function semClsOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) {
            if (phraseCount <= 2) /* only TLS is allowed to be empty */ data.opcodes.push({
                type: id.TLS,
                string: []
            });
            else data.opcodes.push({
                type: id.TBS,
                string: chars.slice(phraseIndex + 1, phraseIndex + phraseCount - 1)
            });
        }
        return ret;
    }
    function semTbsOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) data.tbsstr = [];
        else if (state === id.SEM_POST) data.opcodes.push({
            type: id.TBS,
            string: data.tbsstr
        });
        return ret;
    }
    function semTrgOp(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_PRE) {
            data.min = 0;
            data.max = 0;
        } else if (state === id.SEM_POST) {
            if (data.min > data.max) data.errors.push({
                line: data.findLine(data.lines, phraseIndex, data.charsLength),
                char: phraseIndex,
                msg: `TRG, (%dmin-max), min cannot be greater than max: min: ${data.min}: max: ${data.max}`
            });
            data.opcodes.push({
                type: id.TRG,
                min: data.min,
                max: data.max
            });
        }
        return ret;
    }
    function semDmin(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.min = decnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semDmax(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.max = decnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semBmin(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.min = binnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semBmax(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.max = binnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semXmin(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.min = hexnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semXmax(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.max = hexnum(chars, phraseIndex, phraseCount);
        return ret;
    }
    function semDstring(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.tbsstr.push(decnum(chars, phraseIndex, phraseCount));
        return ret;
    }
    function semBstring(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.tbsstr.push(binnum(chars, phraseIndex, phraseCount));
        return ret;
    }
    function semXstring(state, chars, phraseIndex, phraseCount, data) {
        const ret = id.SEM_OK;
        if (state === id.SEM_POST) data.tbsstr.push(hexnum(chars, phraseIndex, phraseCount));
        return ret;
    }
    // Define the callback functions to the AST object.
    this.callbacks = [];
    this.callbacks.abgop = semAbgOp;
    this.callbacks.aenop = semAenOp;
    this.callbacks.alternation = semAlternation;
    this.callbacks.andop = semAndOp;
    this.callbacks.bmax = semBmax;
    this.callbacks.bmin = semBmin;
    this.callbacks.bkaop = semBkaOp;
    this.callbacks.bknop = semBknOp;
    this.callbacks.bkrop = semBkrOp;
    this.callbacks["bkr-name"] = semBkrName;
    this.callbacks.bstring = semBstring;
    this.callbacks.clsop = semClsOp;
    this.callbacks.ci = semBkrCi;
    this.callbacks.cs = semBkrCs;
    this.callbacks.um = semBkrUm;
    this.callbacks.pm = semBkrPm;
    this.callbacks.concatenation = semConcatenation;
    this.callbacks.defined = semDefined;
    this.callbacks.dmax = semDmax;
    this.callbacks.dmin = semDmin;
    this.callbacks.dstring = semDstring;
    this.callbacks.file = semFile;
    this.callbacks.incalt = semIncAlt;
    this.callbacks.notop = semNotOp;
    this.callbacks.optionopen = semOptionOpen;
    this.callbacks["rep-max"] = semRepMax;
    this.callbacks["rep-min"] = semRepMin;
    this.callbacks["rep-min-max"] = semRepMinMax;
    this.callbacks.repetition = semRepetition;
    this.callbacks.repop = semRepOp;
    this.callbacks.rnmop = semRnmOp;
    this.callbacks.rule = semRule;
    this.callbacks.rulelookup = semRuleLookup;
    this.callbacks.rulename = semRuleName;
    this.callbacks.tbsop = semTbsOp;
    this.callbacks.tlscase = semTlsCase;
    this.callbacks.tlsstring = semTlsString;
    this.callbacks.tlsop = semTlsOp;
    this.callbacks.trgop = semTrgOp;
    this.callbacks["udt-empty"] = semUdtEmpty;
    this.callbacks["udt-non-empty"] = semUdtNonEmpty;
    this.callbacks.xmax = semXmax;
    this.callbacks.xmin = semXmin;
    this.callbacks.xstring = semXstring;
};

});

parcelRegister("2cX0y", function(module, exports) {
// copyright: Copyright (c) 2024 Lowell D. Thomas, all rights reserved<br>
//   license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)<br>
//
// Generated by apg-js, Version 4.4.0 [apg-js](https://github.com/ldthomas/apg-js)
module.exports = function grammar() {
    // ```
    // SUMMARY
    //      rules = 95
    //       udts = 0
    //    opcodes = 372
    //        ---   ABNF original opcodes
    //        ALT = 43
    //        CAT = 48
    //        REP = 34
    //        RNM = 149
    //        TLS = 2
    //        TBS = 61
    //        TRG = 35
    //        ---   SABNF superset opcodes
    //        UDT = 0
    //        AND = 0
    //        NOT = 0
    //        BKA = 0
    //        BKN = 0
    //        BKR = 0
    //        ABG = 0
    //        AEN = 0
    // characters = [9 - 126]
    // ```
    /* OBJECT IDENTIFIER (for internal parser use) */ this.grammarObject = "grammarObject";
    /* RULES */ this.rules = [];
    this.rules[0] = {
        name: "File",
        lower: "file",
        index: 0,
        isBkr: false
    };
    this.rules[1] = {
        name: "BlankLine",
        lower: "blankline",
        index: 1,
        isBkr: false
    };
    this.rules[2] = {
        name: "Rule",
        lower: "rule",
        index: 2,
        isBkr: false
    };
    this.rules[3] = {
        name: "RuleLookup",
        lower: "rulelookup",
        index: 3,
        isBkr: false
    };
    this.rules[4] = {
        name: "RuleNameTest",
        lower: "rulenametest",
        index: 4,
        isBkr: false
    };
    this.rules[5] = {
        name: "RuleName",
        lower: "rulename",
        index: 5,
        isBkr: false
    };
    this.rules[6] = {
        name: "RuleNameError",
        lower: "rulenameerror",
        index: 6,
        isBkr: false
    };
    this.rules[7] = {
        name: "DefinedAsTest",
        lower: "definedastest",
        index: 7,
        isBkr: false
    };
    this.rules[8] = {
        name: "DefinedAsError",
        lower: "definedaserror",
        index: 8,
        isBkr: false
    };
    this.rules[9] = {
        name: "DefinedAs",
        lower: "definedas",
        index: 9,
        isBkr: false
    };
    this.rules[10] = {
        name: "Defined",
        lower: "defined",
        index: 10,
        isBkr: false
    };
    this.rules[11] = {
        name: "IncAlt",
        lower: "incalt",
        index: 11,
        isBkr: false
    };
    this.rules[12] = {
        name: "RuleError",
        lower: "ruleerror",
        index: 12,
        isBkr: false
    };
    this.rules[13] = {
        name: "LineEndError",
        lower: "lineenderror",
        index: 13,
        isBkr: false
    };
    this.rules[14] = {
        name: "Alternation",
        lower: "alternation",
        index: 14,
        isBkr: false
    };
    this.rules[15] = {
        name: "Concatenation",
        lower: "concatenation",
        index: 15,
        isBkr: false
    };
    this.rules[16] = {
        name: "Repetition",
        lower: "repetition",
        index: 16,
        isBkr: false
    };
    this.rules[17] = {
        name: "Modifier",
        lower: "modifier",
        index: 17,
        isBkr: false
    };
    this.rules[18] = {
        name: "Predicate",
        lower: "predicate",
        index: 18,
        isBkr: false
    };
    this.rules[19] = {
        name: "BasicElement",
        lower: "basicelement",
        index: 19,
        isBkr: false
    };
    this.rules[20] = {
        name: "BasicElementErr",
        lower: "basicelementerr",
        index: 20,
        isBkr: false
    };
    this.rules[21] = {
        name: "Group",
        lower: "group",
        index: 21,
        isBkr: false
    };
    this.rules[22] = {
        name: "GroupError",
        lower: "grouperror",
        index: 22,
        isBkr: false
    };
    this.rules[23] = {
        name: "GroupOpen",
        lower: "groupopen",
        index: 23,
        isBkr: false
    };
    this.rules[24] = {
        name: "GroupClose",
        lower: "groupclose",
        index: 24,
        isBkr: false
    };
    this.rules[25] = {
        name: "Option",
        lower: "option",
        index: 25,
        isBkr: false
    };
    this.rules[26] = {
        name: "OptionError",
        lower: "optionerror",
        index: 26,
        isBkr: false
    };
    this.rules[27] = {
        name: "OptionOpen",
        lower: "optionopen",
        index: 27,
        isBkr: false
    };
    this.rules[28] = {
        name: "OptionClose",
        lower: "optionclose",
        index: 28,
        isBkr: false
    };
    this.rules[29] = {
        name: "RnmOp",
        lower: "rnmop",
        index: 29,
        isBkr: false
    };
    this.rules[30] = {
        name: "BkrOp",
        lower: "bkrop",
        index: 30,
        isBkr: false
    };
    this.rules[31] = {
        name: "bkrModifier",
        lower: "bkrmodifier",
        index: 31,
        isBkr: false
    };
    this.rules[32] = {
        name: "cs",
        lower: "cs",
        index: 32,
        isBkr: false
    };
    this.rules[33] = {
        name: "ci",
        lower: "ci",
        index: 33,
        isBkr: false
    };
    this.rules[34] = {
        name: "um",
        lower: "um",
        index: 34,
        isBkr: false
    };
    this.rules[35] = {
        name: "pm",
        lower: "pm",
        index: 35,
        isBkr: false
    };
    this.rules[36] = {
        name: "bkr-name",
        lower: "bkr-name",
        index: 36,
        isBkr: false
    };
    this.rules[37] = {
        name: "rname",
        lower: "rname",
        index: 37,
        isBkr: false
    };
    this.rules[38] = {
        name: "uname",
        lower: "uname",
        index: 38,
        isBkr: false
    };
    this.rules[39] = {
        name: "ename",
        lower: "ename",
        index: 39,
        isBkr: false
    };
    this.rules[40] = {
        name: "UdtOp",
        lower: "udtop",
        index: 40,
        isBkr: false
    };
    this.rules[41] = {
        name: "udt-non-empty",
        lower: "udt-non-empty",
        index: 41,
        isBkr: false
    };
    this.rules[42] = {
        name: "udt-empty",
        lower: "udt-empty",
        index: 42,
        isBkr: false
    };
    this.rules[43] = {
        name: "RepOp",
        lower: "repop",
        index: 43,
        isBkr: false
    };
    this.rules[44] = {
        name: "AltOp",
        lower: "altop",
        index: 44,
        isBkr: false
    };
    this.rules[45] = {
        name: "CatOp",
        lower: "catop",
        index: 45,
        isBkr: false
    };
    this.rules[46] = {
        name: "StarOp",
        lower: "starop",
        index: 46,
        isBkr: false
    };
    this.rules[47] = {
        name: "AndOp",
        lower: "andop",
        index: 47,
        isBkr: false
    };
    this.rules[48] = {
        name: "NotOp",
        lower: "notop",
        index: 48,
        isBkr: false
    };
    this.rules[49] = {
        name: "BkaOp",
        lower: "bkaop",
        index: 49,
        isBkr: false
    };
    this.rules[50] = {
        name: "BknOp",
        lower: "bknop",
        index: 50,
        isBkr: false
    };
    this.rules[51] = {
        name: "AbgOp",
        lower: "abgop",
        index: 51,
        isBkr: false
    };
    this.rules[52] = {
        name: "AenOp",
        lower: "aenop",
        index: 52,
        isBkr: false
    };
    this.rules[53] = {
        name: "TrgOp",
        lower: "trgop",
        index: 53,
        isBkr: false
    };
    this.rules[54] = {
        name: "TbsOp",
        lower: "tbsop",
        index: 54,
        isBkr: false
    };
    this.rules[55] = {
        name: "TlsOp",
        lower: "tlsop",
        index: 55,
        isBkr: false
    };
    this.rules[56] = {
        name: "TlsCase",
        lower: "tlscase",
        index: 56,
        isBkr: false
    };
    this.rules[57] = {
        name: "TlsOpen",
        lower: "tlsopen",
        index: 57,
        isBkr: false
    };
    this.rules[58] = {
        name: "TlsClose",
        lower: "tlsclose",
        index: 58,
        isBkr: false
    };
    this.rules[59] = {
        name: "TlsString",
        lower: "tlsstring",
        index: 59,
        isBkr: false
    };
    this.rules[60] = {
        name: "StringTab",
        lower: "stringtab",
        index: 60,
        isBkr: false
    };
    this.rules[61] = {
        name: "ClsOp",
        lower: "clsop",
        index: 61,
        isBkr: false
    };
    this.rules[62] = {
        name: "ClsOpen",
        lower: "clsopen",
        index: 62,
        isBkr: false
    };
    this.rules[63] = {
        name: "ClsClose",
        lower: "clsclose",
        index: 63,
        isBkr: false
    };
    this.rules[64] = {
        name: "ClsString",
        lower: "clsstring",
        index: 64,
        isBkr: false
    };
    this.rules[65] = {
        name: "ProsVal",
        lower: "prosval",
        index: 65,
        isBkr: false
    };
    this.rules[66] = {
        name: "ProsValOpen",
        lower: "prosvalopen",
        index: 66,
        isBkr: false
    };
    this.rules[67] = {
        name: "ProsValString",
        lower: "prosvalstring",
        index: 67,
        isBkr: false
    };
    this.rules[68] = {
        name: "ProsValClose",
        lower: "prosvalclose",
        index: 68,
        isBkr: false
    };
    this.rules[69] = {
        name: "rep-min",
        lower: "rep-min",
        index: 69,
        isBkr: false
    };
    this.rules[70] = {
        name: "rep-min-max",
        lower: "rep-min-max",
        index: 70,
        isBkr: false
    };
    this.rules[71] = {
        name: "rep-max",
        lower: "rep-max",
        index: 71,
        isBkr: false
    };
    this.rules[72] = {
        name: "rep-num",
        lower: "rep-num",
        index: 72,
        isBkr: false
    };
    this.rules[73] = {
        name: "dString",
        lower: "dstring",
        index: 73,
        isBkr: false
    };
    this.rules[74] = {
        name: "xString",
        lower: "xstring",
        index: 74,
        isBkr: false
    };
    this.rules[75] = {
        name: "bString",
        lower: "bstring",
        index: 75,
        isBkr: false
    };
    this.rules[76] = {
        name: "Dec",
        lower: "dec",
        index: 76,
        isBkr: false
    };
    this.rules[77] = {
        name: "Hex",
        lower: "hex",
        index: 77,
        isBkr: false
    };
    this.rules[78] = {
        name: "Bin",
        lower: "bin",
        index: 78,
        isBkr: false
    };
    this.rules[79] = {
        name: "dmin",
        lower: "dmin",
        index: 79,
        isBkr: false
    };
    this.rules[80] = {
        name: "dmax",
        lower: "dmax",
        index: 80,
        isBkr: false
    };
    this.rules[81] = {
        name: "bmin",
        lower: "bmin",
        index: 81,
        isBkr: false
    };
    this.rules[82] = {
        name: "bmax",
        lower: "bmax",
        index: 82,
        isBkr: false
    };
    this.rules[83] = {
        name: "xmin",
        lower: "xmin",
        index: 83,
        isBkr: false
    };
    this.rules[84] = {
        name: "xmax",
        lower: "xmax",
        index: 84,
        isBkr: false
    };
    this.rules[85] = {
        name: "dnum",
        lower: "dnum",
        index: 85,
        isBkr: false
    };
    this.rules[86] = {
        name: "bnum",
        lower: "bnum",
        index: 86,
        isBkr: false
    };
    this.rules[87] = {
        name: "xnum",
        lower: "xnum",
        index: 87,
        isBkr: false
    };
    this.rules[88] = {
        name: "alphanum",
        lower: "alphanum",
        index: 88,
        isBkr: false
    };
    this.rules[89] = {
        name: "owsp",
        lower: "owsp",
        index: 89,
        isBkr: false
    };
    this.rules[90] = {
        name: "wsp",
        lower: "wsp",
        index: 90,
        isBkr: false
    };
    this.rules[91] = {
        name: "space",
        lower: "space",
        index: 91,
        isBkr: false
    };
    this.rules[92] = {
        name: "comment",
        lower: "comment",
        index: 92,
        isBkr: false
    };
    this.rules[93] = {
        name: "LineEnd",
        lower: "lineend",
        index: 93,
        isBkr: false
    };
    this.rules[94] = {
        name: "LineContinue",
        lower: "linecontinue",
        index: 94,
        isBkr: false
    };
    /* UDTS */ this.udts = [];
    /* OPCODES */ /* File */ this.rules[0].opcodes = [];
    this.rules[0].opcodes[0] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[0].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[0].opcodes[2] = {
        type: 4,
        index: 1
    }; // RNM(BlankLine)
    this.rules[0].opcodes[3] = {
        type: 4,
        index: 2
    }; // RNM(Rule)
    this.rules[0].opcodes[4] = {
        type: 4,
        index: 12
    }; // RNM(RuleError)
    /* BlankLine */ this.rules[1].opcodes = [];
    this.rules[1].opcodes[0] = {
        type: 2,
        children: [
            1,
            5,
            7
        ]
    }; // CAT
    this.rules[1].opcodes[1] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[1].opcodes[2] = {
        type: 1,
        children: [
            3,
            4
        ]
    }; // ALT
    this.rules[1].opcodes[3] = {
        type: 6,
        string: [
            32
        ]
    }; // TBS
    this.rules[1].opcodes[4] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    this.rules[1].opcodes[5] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[1].opcodes[6] = {
        type: 4,
        index: 92
    }; // RNM(comment)
    this.rules[1].opcodes[7] = {
        type: 4,
        index: 93
    }; // RNM(LineEnd)
    /* Rule */ this.rules[2].opcodes = [];
    this.rules[2].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3,
            4
        ]
    }; // CAT
    this.rules[2].opcodes[1] = {
        type: 4,
        index: 3
    }; // RNM(RuleLookup)
    this.rules[2].opcodes[2] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    this.rules[2].opcodes[3] = {
        type: 4,
        index: 14
    }; // RNM(Alternation)
    this.rules[2].opcodes[4] = {
        type: 1,
        children: [
            5,
            8
        ]
    }; // ALT
    this.rules[2].opcodes[5] = {
        type: 2,
        children: [
            6,
            7
        ]
    }; // CAT
    this.rules[2].opcodes[6] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    this.rules[2].opcodes[7] = {
        type: 4,
        index: 93
    }; // RNM(LineEnd)
    this.rules[2].opcodes[8] = {
        type: 2,
        children: [
            9,
            10
        ]
    }; // CAT
    this.rules[2].opcodes[9] = {
        type: 4,
        index: 13
    }; // RNM(LineEndError)
    this.rules[2].opcodes[10] = {
        type: 4,
        index: 93
    }; // RNM(LineEnd)
    /* RuleLookup */ this.rules[3].opcodes = [];
    this.rules[3].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3
        ]
    }; // CAT
    this.rules[3].opcodes[1] = {
        type: 4,
        index: 4
    }; // RNM(RuleNameTest)
    this.rules[3].opcodes[2] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    this.rules[3].opcodes[3] = {
        type: 4,
        index: 7
    }; // RNM(DefinedAsTest)
    /* RuleNameTest */ this.rules[4].opcodes = [];
    this.rules[4].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[4].opcodes[1] = {
        type: 4,
        index: 5
    }; // RNM(RuleName)
    this.rules[4].opcodes[2] = {
        type: 4,
        index: 6
    }; // RNM(RuleNameError)
    /* RuleName */ this.rules[5].opcodes = [];
    this.rules[5].opcodes[0] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* RuleNameError */ this.rules[6].opcodes = [];
    this.rules[6].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[6].opcodes[1] = {
        type: 1,
        children: [
            2,
            3
        ]
    }; // ALT
    this.rules[6].opcodes[2] = {
        type: 5,
        min: 33,
        max: 60
    }; // TRG
    this.rules[6].opcodes[3] = {
        type: 5,
        min: 62,
        max: 126
    }; // TRG
    /* DefinedAsTest */ this.rules[7].opcodes = [];
    this.rules[7].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[7].opcodes[1] = {
        type: 4,
        index: 9
    }; // RNM(DefinedAs)
    this.rules[7].opcodes[2] = {
        type: 4,
        index: 8
    }; // RNM(DefinedAsError)
    /* DefinedAsError */ this.rules[8].opcodes = [];
    this.rules[8].opcodes[0] = {
        type: 3,
        min: 1,
        max: 2
    }; // REP
    this.rules[8].opcodes[1] = {
        type: 5,
        min: 33,
        max: 126
    }; // TRG
    /* DefinedAs */ this.rules[9].opcodes = [];
    this.rules[9].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[9].opcodes[1] = {
        type: 4,
        index: 11
    }; // RNM(IncAlt)
    this.rules[9].opcodes[2] = {
        type: 4,
        index: 10
    }; // RNM(Defined)
    /* Defined */ this.rules[10].opcodes = [];
    this.rules[10].opcodes[0] = {
        type: 6,
        string: [
            61
        ]
    }; // TBS
    /* IncAlt */ this.rules[11].opcodes = [];
    this.rules[11].opcodes[0] = {
        type: 6,
        string: [
            61,
            47
        ]
    }; // TBS
    /* RuleError */ this.rules[12].opcodes = [];
    this.rules[12].opcodes[0] = {
        type: 2,
        children: [
            1,
            6
        ]
    }; // CAT
    this.rules[12].opcodes[1] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[12].opcodes[2] = {
        type: 1,
        children: [
            3,
            4,
            5
        ]
    }; // ALT
    this.rules[12].opcodes[3] = {
        type: 5,
        min: 32,
        max: 126
    }; // TRG
    this.rules[12].opcodes[4] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    this.rules[12].opcodes[5] = {
        type: 4,
        index: 94
    }; // RNM(LineContinue)
    this.rules[12].opcodes[6] = {
        type: 4,
        index: 93
    }; // RNM(LineEnd)
    /* LineEndError */ this.rules[13].opcodes = [];
    this.rules[13].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[13].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[13].opcodes[2] = {
        type: 5,
        min: 32,
        max: 126
    }; // TRG
    this.rules[13].opcodes[3] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    this.rules[13].opcodes[4] = {
        type: 4,
        index: 94
    }; // RNM(LineContinue)
    /* Alternation */ this.rules[14].opcodes = [];
    this.rules[14].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[14].opcodes[1] = {
        type: 4,
        index: 15
    }; // RNM(Concatenation)
    this.rules[14].opcodes[2] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[14].opcodes[3] = {
        type: 2,
        children: [
            4,
            5,
            6
        ]
    }; // CAT
    this.rules[14].opcodes[4] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    this.rules[14].opcodes[5] = {
        type: 4,
        index: 44
    }; // RNM(AltOp)
    this.rules[14].opcodes[6] = {
        type: 4,
        index: 15
    }; // RNM(Concatenation)
    /* Concatenation */ this.rules[15].opcodes = [];
    this.rules[15].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[15].opcodes[1] = {
        type: 4,
        index: 16
    }; // RNM(Repetition)
    this.rules[15].opcodes[2] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[15].opcodes[3] = {
        type: 2,
        children: [
            4,
            5
        ]
    }; // CAT
    this.rules[15].opcodes[4] = {
        type: 4,
        index: 45
    }; // RNM(CatOp)
    this.rules[15].opcodes[5] = {
        type: 4,
        index: 16
    }; // RNM(Repetition)
    /* Repetition */ this.rules[16].opcodes = [];
    this.rules[16].opcodes[0] = {
        type: 2,
        children: [
            1,
            3
        ]
    }; // CAT
    this.rules[16].opcodes[1] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[16].opcodes[2] = {
        type: 4,
        index: 17
    }; // RNM(Modifier)
    this.rules[16].opcodes[3] = {
        type: 1,
        children: [
            4,
            5,
            6,
            7
        ]
    }; // ALT
    this.rules[16].opcodes[4] = {
        type: 4,
        index: 21
    }; // RNM(Group)
    this.rules[16].opcodes[5] = {
        type: 4,
        index: 25
    }; // RNM(Option)
    this.rules[16].opcodes[6] = {
        type: 4,
        index: 19
    }; // RNM(BasicElement)
    this.rules[16].opcodes[7] = {
        type: 4,
        index: 20
    }; // RNM(BasicElementErr)
    /* Modifier */ this.rules[17].opcodes = [];
    this.rules[17].opcodes[0] = {
        type: 1,
        children: [
            1,
            5
        ]
    }; // ALT
    this.rules[17].opcodes[1] = {
        type: 2,
        children: [
            2,
            3
        ]
    }; // CAT
    this.rules[17].opcodes[2] = {
        type: 4,
        index: 18
    }; // RNM(Predicate)
    this.rules[17].opcodes[3] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[17].opcodes[4] = {
        type: 4,
        index: 43
    }; // RNM(RepOp)
    this.rules[17].opcodes[5] = {
        type: 4,
        index: 43
    }; // RNM(RepOp)
    /* Predicate */ this.rules[18].opcodes = [];
    this.rules[18].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[18].opcodes[1] = {
        type: 4,
        index: 49
    }; // RNM(BkaOp)
    this.rules[18].opcodes[2] = {
        type: 4,
        index: 50
    }; // RNM(BknOp)
    this.rules[18].opcodes[3] = {
        type: 4,
        index: 47
    }; // RNM(AndOp)
    this.rules[18].opcodes[4] = {
        type: 4,
        index: 48
    }; // RNM(NotOp)
    /* BasicElement */ this.rules[19].opcodes = [];
    this.rules[19].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10
        ]
    }; // ALT
    this.rules[19].opcodes[1] = {
        type: 4,
        index: 40
    }; // RNM(UdtOp)
    this.rules[19].opcodes[2] = {
        type: 4,
        index: 29
    }; // RNM(RnmOp)
    this.rules[19].opcodes[3] = {
        type: 4,
        index: 53
    }; // RNM(TrgOp)
    this.rules[19].opcodes[4] = {
        type: 4,
        index: 54
    }; // RNM(TbsOp)
    this.rules[19].opcodes[5] = {
        type: 4,
        index: 55
    }; // RNM(TlsOp)
    this.rules[19].opcodes[6] = {
        type: 4,
        index: 61
    }; // RNM(ClsOp)
    this.rules[19].opcodes[7] = {
        type: 4,
        index: 30
    }; // RNM(BkrOp)
    this.rules[19].opcodes[8] = {
        type: 4,
        index: 51
    }; // RNM(AbgOp)
    this.rules[19].opcodes[9] = {
        type: 4,
        index: 52
    }; // RNM(AenOp)
    this.rules[19].opcodes[10] = {
        type: 4,
        index: 65
    }; // RNM(ProsVal)
    /* BasicElementErr */ this.rules[20].opcodes = [];
    this.rules[20].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[20].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4,
            5
        ]
    }; // ALT
    this.rules[20].opcodes[2] = {
        type: 5,
        min: 33,
        max: 40
    }; // TRG
    this.rules[20].opcodes[3] = {
        type: 5,
        min: 42,
        max: 46
    }; // TRG
    this.rules[20].opcodes[4] = {
        type: 5,
        min: 48,
        max: 92
    }; // TRG
    this.rules[20].opcodes[5] = {
        type: 5,
        min: 94,
        max: 126
    }; // TRG
    /* Group */ this.rules[21].opcodes = [];
    this.rules[21].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3
        ]
    }; // CAT
    this.rules[21].opcodes[1] = {
        type: 4,
        index: 23
    }; // RNM(GroupOpen)
    this.rules[21].opcodes[2] = {
        type: 4,
        index: 14
    }; // RNM(Alternation)
    this.rules[21].opcodes[3] = {
        type: 1,
        children: [
            4,
            5
        ]
    }; // ALT
    this.rules[21].opcodes[4] = {
        type: 4,
        index: 24
    }; // RNM(GroupClose)
    this.rules[21].opcodes[5] = {
        type: 4,
        index: 22
    }; // RNM(GroupError)
    /* GroupError */ this.rules[22].opcodes = [];
    this.rules[22].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[22].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4,
            5
        ]
    }; // ALT
    this.rules[22].opcodes[2] = {
        type: 5,
        min: 33,
        max: 40
    }; // TRG
    this.rules[22].opcodes[3] = {
        type: 5,
        min: 42,
        max: 46
    }; // TRG
    this.rules[22].opcodes[4] = {
        type: 5,
        min: 48,
        max: 92
    }; // TRG
    this.rules[22].opcodes[5] = {
        type: 5,
        min: 94,
        max: 126
    }; // TRG
    /* GroupOpen */ this.rules[23].opcodes = [];
    this.rules[23].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[23].opcodes[1] = {
        type: 6,
        string: [
            40
        ]
    }; // TBS
    this.rules[23].opcodes[2] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    /* GroupClose */ this.rules[24].opcodes = [];
    this.rules[24].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[24].opcodes[1] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    this.rules[24].opcodes[2] = {
        type: 6,
        string: [
            41
        ]
    }; // TBS
    /* Option */ this.rules[25].opcodes = [];
    this.rules[25].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3
        ]
    }; // CAT
    this.rules[25].opcodes[1] = {
        type: 4,
        index: 27
    }; // RNM(OptionOpen)
    this.rules[25].opcodes[2] = {
        type: 4,
        index: 14
    }; // RNM(Alternation)
    this.rules[25].opcodes[3] = {
        type: 1,
        children: [
            4,
            5
        ]
    }; // ALT
    this.rules[25].opcodes[4] = {
        type: 4,
        index: 28
    }; // RNM(OptionClose)
    this.rules[25].opcodes[5] = {
        type: 4,
        index: 26
    }; // RNM(OptionError)
    /* OptionError */ this.rules[26].opcodes = [];
    this.rules[26].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[26].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4,
            5
        ]
    }; // ALT
    this.rules[26].opcodes[2] = {
        type: 5,
        min: 33,
        max: 40
    }; // TRG
    this.rules[26].opcodes[3] = {
        type: 5,
        min: 42,
        max: 46
    }; // TRG
    this.rules[26].opcodes[4] = {
        type: 5,
        min: 48,
        max: 92
    }; // TRG
    this.rules[26].opcodes[5] = {
        type: 5,
        min: 94,
        max: 126
    }; // TRG
    /* OptionOpen */ this.rules[27].opcodes = [];
    this.rules[27].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[27].opcodes[1] = {
        type: 6,
        string: [
            91
        ]
    }; // TBS
    this.rules[27].opcodes[2] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    /* OptionClose */ this.rules[28].opcodes = [];
    this.rules[28].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[28].opcodes[1] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    this.rules[28].opcodes[2] = {
        type: 6,
        string: [
            93
        ]
    }; // TBS
    /* RnmOp */ this.rules[29].opcodes = [];
    this.rules[29].opcodes[0] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* BkrOp */ this.rules[30].opcodes = [];
    this.rules[30].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            4
        ]
    }; // CAT
    this.rules[30].opcodes[1] = {
        type: 6,
        string: [
            92
        ]
    }; // TBS
    this.rules[30].opcodes[2] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[30].opcodes[3] = {
        type: 4,
        index: 31
    }; // RNM(bkrModifier)
    this.rules[30].opcodes[4] = {
        type: 4,
        index: 36
    }; // RNM(bkr-name)
    /* bkrModifier */ this.rules[31].opcodes = [];
    this.rules[31].opcodes[0] = {
        type: 1,
        children: [
            1,
            7,
            13,
            19
        ]
    }; // ALT
    this.rules[31].opcodes[1] = {
        type: 2,
        children: [
            2,
            3
        ]
    }; // CAT
    this.rules[31].opcodes[2] = {
        type: 4,
        index: 32
    }; // RNM(cs)
    this.rules[31].opcodes[3] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[31].opcodes[4] = {
        type: 1,
        children: [
            5,
            6
        ]
    }; // ALT
    this.rules[31].opcodes[5] = {
        type: 4,
        index: 34
    }; // RNM(um)
    this.rules[31].opcodes[6] = {
        type: 4,
        index: 35
    }; // RNM(pm)
    this.rules[31].opcodes[7] = {
        type: 2,
        children: [
            8,
            9
        ]
    }; // CAT
    this.rules[31].opcodes[8] = {
        type: 4,
        index: 33
    }; // RNM(ci)
    this.rules[31].opcodes[9] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[31].opcodes[10] = {
        type: 1,
        children: [
            11,
            12
        ]
    }; // ALT
    this.rules[31].opcodes[11] = {
        type: 4,
        index: 34
    }; // RNM(um)
    this.rules[31].opcodes[12] = {
        type: 4,
        index: 35
    }; // RNM(pm)
    this.rules[31].opcodes[13] = {
        type: 2,
        children: [
            14,
            15
        ]
    }; // CAT
    this.rules[31].opcodes[14] = {
        type: 4,
        index: 34
    }; // RNM(um)
    this.rules[31].opcodes[15] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[31].opcodes[16] = {
        type: 1,
        children: [
            17,
            18
        ]
    }; // ALT
    this.rules[31].opcodes[17] = {
        type: 4,
        index: 32
    }; // RNM(cs)
    this.rules[31].opcodes[18] = {
        type: 4,
        index: 33
    }; // RNM(ci)
    this.rules[31].opcodes[19] = {
        type: 2,
        children: [
            20,
            21
        ]
    }; // CAT
    this.rules[31].opcodes[20] = {
        type: 4,
        index: 35
    }; // RNM(pm)
    this.rules[31].opcodes[21] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[31].opcodes[22] = {
        type: 1,
        children: [
            23,
            24
        ]
    }; // ALT
    this.rules[31].opcodes[23] = {
        type: 4,
        index: 32
    }; // RNM(cs)
    this.rules[31].opcodes[24] = {
        type: 4,
        index: 33
    }; // RNM(ci)
    /* cs */ this.rules[32].opcodes = [];
    this.rules[32].opcodes[0] = {
        type: 6,
        string: [
            37,
            115
        ]
    }; // TBS
    /* ci */ this.rules[33].opcodes = [];
    this.rules[33].opcodes[0] = {
        type: 6,
        string: [
            37,
            105
        ]
    }; // TBS
    /* um */ this.rules[34].opcodes = [];
    this.rules[34].opcodes[0] = {
        type: 6,
        string: [
            37,
            117
        ]
    }; // TBS
    /* pm */ this.rules[35].opcodes = [];
    this.rules[35].opcodes[0] = {
        type: 6,
        string: [
            37,
            112
        ]
    }; // TBS
    /* bkr-name */ this.rules[36].opcodes = [];
    this.rules[36].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3
        ]
    }; // ALT
    this.rules[36].opcodes[1] = {
        type: 4,
        index: 38
    }; // RNM(uname)
    this.rules[36].opcodes[2] = {
        type: 4,
        index: 39
    }; // RNM(ename)
    this.rules[36].opcodes[3] = {
        type: 4,
        index: 37
    }; // RNM(rname)
    /* rname */ this.rules[37].opcodes = [];
    this.rules[37].opcodes[0] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* uname */ this.rules[38].opcodes = [];
    this.rules[38].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[38].opcodes[1] = {
        type: 6,
        string: [
            117,
            95
        ]
    }; // TBS
    this.rules[38].opcodes[2] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* ename */ this.rules[39].opcodes = [];
    this.rules[39].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[39].opcodes[1] = {
        type: 6,
        string: [
            101,
            95
        ]
    }; // TBS
    this.rules[39].opcodes[2] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* UdtOp */ this.rules[40].opcodes = [];
    this.rules[40].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[40].opcodes[1] = {
        type: 4,
        index: 42
    }; // RNM(udt-empty)
    this.rules[40].opcodes[2] = {
        type: 4,
        index: 41
    }; // RNM(udt-non-empty)
    /* udt-non-empty */ this.rules[41].opcodes = [];
    this.rules[41].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[41].opcodes[1] = {
        type: 6,
        string: [
            117,
            95
        ]
    }; // TBS
    this.rules[41].opcodes[2] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* udt-empty */ this.rules[42].opcodes = [];
    this.rules[42].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[42].opcodes[1] = {
        type: 6,
        string: [
            101,
            95
        ]
    }; // TBS
    this.rules[42].opcodes[2] = {
        type: 4,
        index: 88
    }; // RNM(alphanum)
    /* RepOp */ this.rules[43].opcodes = [];
    this.rules[43].opcodes[0] = {
        type: 1,
        children: [
            1,
            5,
            8,
            11,
            12
        ]
    }; // ALT
    this.rules[43].opcodes[1] = {
        type: 2,
        children: [
            2,
            3,
            4
        ]
    }; // CAT
    this.rules[43].opcodes[2] = {
        type: 4,
        index: 69
    }; // RNM(rep-min)
    this.rules[43].opcodes[3] = {
        type: 4,
        index: 46
    }; // RNM(StarOp)
    this.rules[43].opcodes[4] = {
        type: 4,
        index: 71
    }; // RNM(rep-max)
    this.rules[43].opcodes[5] = {
        type: 2,
        children: [
            6,
            7
        ]
    }; // CAT
    this.rules[43].opcodes[6] = {
        type: 4,
        index: 69
    }; // RNM(rep-min)
    this.rules[43].opcodes[7] = {
        type: 4,
        index: 46
    }; // RNM(StarOp)
    this.rules[43].opcodes[8] = {
        type: 2,
        children: [
            9,
            10
        ]
    }; // CAT
    this.rules[43].opcodes[9] = {
        type: 4,
        index: 46
    }; // RNM(StarOp)
    this.rules[43].opcodes[10] = {
        type: 4,
        index: 71
    }; // RNM(rep-max)
    this.rules[43].opcodes[11] = {
        type: 4,
        index: 46
    }; // RNM(StarOp)
    this.rules[43].opcodes[12] = {
        type: 4,
        index: 70
    }; // RNM(rep-min-max)
    /* AltOp */ this.rules[44].opcodes = [];
    this.rules[44].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[44].opcodes[1] = {
        type: 6,
        string: [
            47
        ]
    }; // TBS
    this.rules[44].opcodes[2] = {
        type: 4,
        index: 89
    }; // RNM(owsp)
    /* CatOp */ this.rules[45].opcodes = [];
    this.rules[45].opcodes[0] = {
        type: 4,
        index: 90
    }; // RNM(wsp)
    /* StarOp */ this.rules[46].opcodes = [];
    this.rules[46].opcodes[0] = {
        type: 6,
        string: [
            42
        ]
    }; // TBS
    /* AndOp */ this.rules[47].opcodes = [];
    this.rules[47].opcodes[0] = {
        type: 6,
        string: [
            38
        ]
    }; // TBS
    /* NotOp */ this.rules[48].opcodes = [];
    this.rules[48].opcodes[0] = {
        type: 6,
        string: [
            33
        ]
    }; // TBS
    /* BkaOp */ this.rules[49].opcodes = [];
    this.rules[49].opcodes[0] = {
        type: 6,
        string: [
            38,
            38
        ]
    }; // TBS
    /* BknOp */ this.rules[50].opcodes = [];
    this.rules[50].opcodes[0] = {
        type: 6,
        string: [
            33,
            33
        ]
    }; // TBS
    /* AbgOp */ this.rules[51].opcodes = [];
    this.rules[51].opcodes[0] = {
        type: 6,
        string: [
            37,
            94
        ]
    }; // TBS
    /* AenOp */ this.rules[52].opcodes = [];
    this.rules[52].opcodes[0] = {
        type: 6,
        string: [
            37,
            36
        ]
    }; // TBS
    /* TrgOp */ this.rules[53].opcodes = [];
    this.rules[53].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[53].opcodes[1] = {
        type: 6,
        string: [
            37
        ]
    }; // TBS
    this.rules[53].opcodes[2] = {
        type: 1,
        children: [
            3,
            8,
            13
        ]
    }; // ALT
    this.rules[53].opcodes[3] = {
        type: 2,
        children: [
            4,
            5,
            6,
            7
        ]
    }; // CAT
    this.rules[53].opcodes[4] = {
        type: 4,
        index: 76
    }; // RNM(Dec)
    this.rules[53].opcodes[5] = {
        type: 4,
        index: 79
    }; // RNM(dmin)
    this.rules[53].opcodes[6] = {
        type: 6,
        string: [
            45
        ]
    }; // TBS
    this.rules[53].opcodes[7] = {
        type: 4,
        index: 80
    }; // RNM(dmax)
    this.rules[53].opcodes[8] = {
        type: 2,
        children: [
            9,
            10,
            11,
            12
        ]
    }; // CAT
    this.rules[53].opcodes[9] = {
        type: 4,
        index: 77
    }; // RNM(Hex)
    this.rules[53].opcodes[10] = {
        type: 4,
        index: 83
    }; // RNM(xmin)
    this.rules[53].opcodes[11] = {
        type: 6,
        string: [
            45
        ]
    }; // TBS
    this.rules[53].opcodes[12] = {
        type: 4,
        index: 84
    }; // RNM(xmax)
    this.rules[53].opcodes[13] = {
        type: 2,
        children: [
            14,
            15,
            16,
            17
        ]
    }; // CAT
    this.rules[53].opcodes[14] = {
        type: 4,
        index: 78
    }; // RNM(Bin)
    this.rules[53].opcodes[15] = {
        type: 4,
        index: 81
    }; // RNM(bmin)
    this.rules[53].opcodes[16] = {
        type: 6,
        string: [
            45
        ]
    }; // TBS
    this.rules[53].opcodes[17] = {
        type: 4,
        index: 82
    }; // RNM(bmax)
    /* TbsOp */ this.rules[54].opcodes = [];
    this.rules[54].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[54].opcodes[1] = {
        type: 6,
        string: [
            37
        ]
    }; // TBS
    this.rules[54].opcodes[2] = {
        type: 1,
        children: [
            3,
            10,
            17
        ]
    }; // ALT
    this.rules[54].opcodes[3] = {
        type: 2,
        children: [
            4,
            5,
            6
        ]
    }; // CAT
    this.rules[54].opcodes[4] = {
        type: 4,
        index: 76
    }; // RNM(Dec)
    this.rules[54].opcodes[5] = {
        type: 4,
        index: 73
    }; // RNM(dString)
    this.rules[54].opcodes[6] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[54].opcodes[7] = {
        type: 2,
        children: [
            8,
            9
        ]
    }; // CAT
    this.rules[54].opcodes[8] = {
        type: 6,
        string: [
            46
        ]
    }; // TBS
    this.rules[54].opcodes[9] = {
        type: 4,
        index: 73
    }; // RNM(dString)
    this.rules[54].opcodes[10] = {
        type: 2,
        children: [
            11,
            12,
            13
        ]
    }; // CAT
    this.rules[54].opcodes[11] = {
        type: 4,
        index: 77
    }; // RNM(Hex)
    this.rules[54].opcodes[12] = {
        type: 4,
        index: 74
    }; // RNM(xString)
    this.rules[54].opcodes[13] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[54].opcodes[14] = {
        type: 2,
        children: [
            15,
            16
        ]
    }; // CAT
    this.rules[54].opcodes[15] = {
        type: 6,
        string: [
            46
        ]
    }; // TBS
    this.rules[54].opcodes[16] = {
        type: 4,
        index: 74
    }; // RNM(xString)
    this.rules[54].opcodes[17] = {
        type: 2,
        children: [
            18,
            19,
            20
        ]
    }; // CAT
    this.rules[54].opcodes[18] = {
        type: 4,
        index: 78
    }; // RNM(Bin)
    this.rules[54].opcodes[19] = {
        type: 4,
        index: 75
    }; // RNM(bString)
    this.rules[54].opcodes[20] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[54].opcodes[21] = {
        type: 2,
        children: [
            22,
            23
        ]
    }; // CAT
    this.rules[54].opcodes[22] = {
        type: 6,
        string: [
            46
        ]
    }; // TBS
    this.rules[54].opcodes[23] = {
        type: 4,
        index: 75
    }; // RNM(bString)
    /* TlsOp */ this.rules[55].opcodes = [];
    this.rules[55].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3,
            4
        ]
    }; // CAT
    this.rules[55].opcodes[1] = {
        type: 4,
        index: 56
    }; // RNM(TlsCase)
    this.rules[55].opcodes[2] = {
        type: 4,
        index: 57
    }; // RNM(TlsOpen)
    this.rules[55].opcodes[3] = {
        type: 4,
        index: 59
    }; // RNM(TlsString)
    this.rules[55].opcodes[4] = {
        type: 4,
        index: 58
    }; // RNM(TlsClose)
    /* TlsCase */ this.rules[56].opcodes = [];
    this.rules[56].opcodes[0] = {
        type: 3,
        min: 0,
        max: 1
    }; // REP
    this.rules[56].opcodes[1] = {
        type: 1,
        children: [
            2,
            3
        ]
    }; // ALT
    this.rules[56].opcodes[2] = {
        type: 7,
        string: [
            37,
            105
        ]
    }; // TLS
    this.rules[56].opcodes[3] = {
        type: 7,
        string: [
            37,
            115
        ]
    }; // TLS
    /* TlsOpen */ this.rules[57].opcodes = [];
    this.rules[57].opcodes[0] = {
        type: 6,
        string: [
            34
        ]
    }; // TBS
    /* TlsClose */ this.rules[58].opcodes = [];
    this.rules[58].opcodes[0] = {
        type: 6,
        string: [
            34
        ]
    }; // TBS
    /* TlsString */ this.rules[59].opcodes = [];
    this.rules[59].opcodes[0] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[59].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[59].opcodes[2] = {
        type: 5,
        min: 32,
        max: 33
    }; // TRG
    this.rules[59].opcodes[3] = {
        type: 5,
        min: 35,
        max: 126
    }; // TRG
    this.rules[59].opcodes[4] = {
        type: 4,
        index: 60
    }; // RNM(StringTab)
    /* StringTab */ this.rules[60].opcodes = [];
    this.rules[60].opcodes[0] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    /* ClsOp */ this.rules[61].opcodes = [];
    this.rules[61].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3
        ]
    }; // CAT
    this.rules[61].opcodes[1] = {
        type: 4,
        index: 62
    }; // RNM(ClsOpen)
    this.rules[61].opcodes[2] = {
        type: 4,
        index: 64
    }; // RNM(ClsString)
    this.rules[61].opcodes[3] = {
        type: 4,
        index: 63
    }; // RNM(ClsClose)
    /* ClsOpen */ this.rules[62].opcodes = [];
    this.rules[62].opcodes[0] = {
        type: 6,
        string: [
            39
        ]
    }; // TBS
    /* ClsClose */ this.rules[63].opcodes = [];
    this.rules[63].opcodes[0] = {
        type: 6,
        string: [
            39
        ]
    }; // TBS
    /* ClsString */ this.rules[64].opcodes = [];
    this.rules[64].opcodes[0] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[64].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[64].opcodes[2] = {
        type: 5,
        min: 32,
        max: 38
    }; // TRG
    this.rules[64].opcodes[3] = {
        type: 5,
        min: 40,
        max: 126
    }; // TRG
    this.rules[64].opcodes[4] = {
        type: 4,
        index: 60
    }; // RNM(StringTab)
    /* ProsVal */ this.rules[65].opcodes = [];
    this.rules[65].opcodes[0] = {
        type: 2,
        children: [
            1,
            2,
            3
        ]
    }; // CAT
    this.rules[65].opcodes[1] = {
        type: 4,
        index: 66
    }; // RNM(ProsValOpen)
    this.rules[65].opcodes[2] = {
        type: 4,
        index: 67
    }; // RNM(ProsValString)
    this.rules[65].opcodes[3] = {
        type: 4,
        index: 68
    }; // RNM(ProsValClose)
    /* ProsValOpen */ this.rules[66].opcodes = [];
    this.rules[66].opcodes[0] = {
        type: 6,
        string: [
            60
        ]
    }; // TBS
    /* ProsValString */ this.rules[67].opcodes = [];
    this.rules[67].opcodes[0] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[67].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[67].opcodes[2] = {
        type: 5,
        min: 32,
        max: 61
    }; // TRG
    this.rules[67].opcodes[3] = {
        type: 5,
        min: 63,
        max: 126
    }; // TRG
    this.rules[67].opcodes[4] = {
        type: 4,
        index: 60
    }; // RNM(StringTab)
    /* ProsValClose */ this.rules[68].opcodes = [];
    this.rules[68].opcodes[0] = {
        type: 6,
        string: [
            62
        ]
    }; // TBS
    /* rep-min */ this.rules[69].opcodes = [];
    this.rules[69].opcodes[0] = {
        type: 4,
        index: 72
    }; // RNM(rep-num)
    /* rep-min-max */ this.rules[70].opcodes = [];
    this.rules[70].opcodes[0] = {
        type: 4,
        index: 72
    }; // RNM(rep-num)
    /* rep-max */ this.rules[71].opcodes = [];
    this.rules[71].opcodes[0] = {
        type: 4,
        index: 72
    }; // RNM(rep-num)
    /* rep-num */ this.rules[72].opcodes = [];
    this.rules[72].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[72].opcodes[1] = {
        type: 5,
        min: 48,
        max: 57
    }; // TRG
    /* dString */ this.rules[73].opcodes = [];
    this.rules[73].opcodes[0] = {
        type: 4,
        index: 85
    }; // RNM(dnum)
    /* xString */ this.rules[74].opcodes = [];
    this.rules[74].opcodes[0] = {
        type: 4,
        index: 87
    }; // RNM(xnum)
    /* bString */ this.rules[75].opcodes = [];
    this.rules[75].opcodes[0] = {
        type: 4,
        index: 86
    }; // RNM(bnum)
    /* Dec */ this.rules[76].opcodes = [];
    this.rules[76].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[76].opcodes[1] = {
        type: 6,
        string: [
            68
        ]
    }; // TBS
    this.rules[76].opcodes[2] = {
        type: 6,
        string: [
            100
        ]
    }; // TBS
    /* Hex */ this.rules[77].opcodes = [];
    this.rules[77].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[77].opcodes[1] = {
        type: 6,
        string: [
            88
        ]
    }; // TBS
    this.rules[77].opcodes[2] = {
        type: 6,
        string: [
            120
        ]
    }; // TBS
    /* Bin */ this.rules[78].opcodes = [];
    this.rules[78].opcodes[0] = {
        type: 1,
        children: [
            1,
            2
        ]
    }; // ALT
    this.rules[78].opcodes[1] = {
        type: 6,
        string: [
            66
        ]
    }; // TBS
    this.rules[78].opcodes[2] = {
        type: 6,
        string: [
            98
        ]
    }; // TBS
    /* dmin */ this.rules[79].opcodes = [];
    this.rules[79].opcodes[0] = {
        type: 4,
        index: 85
    }; // RNM(dnum)
    /* dmax */ this.rules[80].opcodes = [];
    this.rules[80].opcodes[0] = {
        type: 4,
        index: 85
    }; // RNM(dnum)
    /* bmin */ this.rules[81].opcodes = [];
    this.rules[81].opcodes[0] = {
        type: 4,
        index: 86
    }; // RNM(bnum)
    /* bmax */ this.rules[82].opcodes = [];
    this.rules[82].opcodes[0] = {
        type: 4,
        index: 86
    }; // RNM(bnum)
    /* xmin */ this.rules[83].opcodes = [];
    this.rules[83].opcodes[0] = {
        type: 4,
        index: 87
    }; // RNM(xnum)
    /* xmax */ this.rules[84].opcodes = [];
    this.rules[84].opcodes[0] = {
        type: 4,
        index: 87
    }; // RNM(xnum)
    /* dnum */ this.rules[85].opcodes = [];
    this.rules[85].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[85].opcodes[1] = {
        type: 5,
        min: 48,
        max: 57
    }; // TRG
    /* bnum */ this.rules[86].opcodes = [];
    this.rules[86].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[86].opcodes[1] = {
        type: 5,
        min: 48,
        max: 49
    }; // TRG
    /* xnum */ this.rules[87].opcodes = [];
    this.rules[87].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[87].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[87].opcodes[2] = {
        type: 5,
        min: 48,
        max: 57
    }; // TRG
    this.rules[87].opcodes[3] = {
        type: 5,
        min: 65,
        max: 70
    }; // TRG
    this.rules[87].opcodes[4] = {
        type: 5,
        min: 97,
        max: 102
    }; // TRG
    /* alphanum */ this.rules[88].opcodes = [];
    this.rules[88].opcodes[0] = {
        type: 2,
        children: [
            1,
            4
        ]
    }; // CAT
    this.rules[88].opcodes[1] = {
        type: 1,
        children: [
            2,
            3
        ]
    }; // ALT
    this.rules[88].opcodes[2] = {
        type: 5,
        min: 97,
        max: 122
    }; // TRG
    this.rules[88].opcodes[3] = {
        type: 5,
        min: 65,
        max: 90
    }; // TRG
    this.rules[88].opcodes[4] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[88].opcodes[5] = {
        type: 1,
        children: [
            6,
            7,
            8,
            9
        ]
    }; // ALT
    this.rules[88].opcodes[6] = {
        type: 5,
        min: 97,
        max: 122
    }; // TRG
    this.rules[88].opcodes[7] = {
        type: 5,
        min: 65,
        max: 90
    }; // TRG
    this.rules[88].opcodes[8] = {
        type: 5,
        min: 48,
        max: 57
    }; // TRG
    this.rules[88].opcodes[9] = {
        type: 6,
        string: [
            45
        ]
    }; // TBS
    /* owsp */ this.rules[89].opcodes = [];
    this.rules[89].opcodes[0] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[89].opcodes[1] = {
        type: 4,
        index: 91
    }; // RNM(space)
    /* wsp */ this.rules[90].opcodes = [];
    this.rules[90].opcodes[0] = {
        type: 3,
        min: 1,
        max: Infinity
    }; // REP
    this.rules[90].opcodes[1] = {
        type: 4,
        index: 91
    }; // RNM(space)
    /* space */ this.rules[91].opcodes = [];
    this.rules[91].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[91].opcodes[1] = {
        type: 6,
        string: [
            32
        ]
    }; // TBS
    this.rules[91].opcodes[2] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    this.rules[91].opcodes[3] = {
        type: 4,
        index: 92
    }; // RNM(comment)
    this.rules[91].opcodes[4] = {
        type: 4,
        index: 94
    }; // RNM(LineContinue)
    /* comment */ this.rules[92].opcodes = [];
    this.rules[92].opcodes[0] = {
        type: 2,
        children: [
            1,
            2
        ]
    }; // CAT
    this.rules[92].opcodes[1] = {
        type: 6,
        string: [
            59
        ]
    }; // TBS
    this.rules[92].opcodes[2] = {
        type: 3,
        min: 0,
        max: Infinity
    }; // REP
    this.rules[92].opcodes[3] = {
        type: 1,
        children: [
            4,
            5
        ]
    }; // ALT
    this.rules[92].opcodes[4] = {
        type: 5,
        min: 32,
        max: 126
    }; // TRG
    this.rules[92].opcodes[5] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    /* LineEnd */ this.rules[93].opcodes = [];
    this.rules[93].opcodes[0] = {
        type: 1,
        children: [
            1,
            2,
            3
        ]
    }; // ALT
    this.rules[93].opcodes[1] = {
        type: 6,
        string: [
            13,
            10
        ]
    }; // TBS
    this.rules[93].opcodes[2] = {
        type: 6,
        string: [
            10
        ]
    }; // TBS
    this.rules[93].opcodes[3] = {
        type: 6,
        string: [
            13
        ]
    }; // TBS
    /* LineContinue */ this.rules[94].opcodes = [];
    this.rules[94].opcodes[0] = {
        type: 2,
        children: [
            1,
            5
        ]
    }; // CAT
    this.rules[94].opcodes[1] = {
        type: 1,
        children: [
            2,
            3,
            4
        ]
    }; // ALT
    this.rules[94].opcodes[2] = {
        type: 6,
        string: [
            13,
            10
        ]
    }; // TBS
    this.rules[94].opcodes[3] = {
        type: 6,
        string: [
            10
        ]
    }; // TBS
    this.rules[94].opcodes[4] = {
        type: 6,
        string: [
            13
        ]
    }; // TBS
    this.rules[94].opcodes[5] = {
        type: 1,
        children: [
            6,
            7
        ]
    }; // ALT
    this.rules[94].opcodes[6] = {
        type: 6,
        string: [
            32
        ]
    }; // TBS
    this.rules[94].opcodes[7] = {
        type: 6,
        string: [
            9
        ]
    }; // TBS
    // The `toString()` function will display the original grammar file(s) that produced these opcodes.
    this.toString = function toString() {
        let str = "";
        str += ";\n";
        str += "; ABNF for JavaScript APG 2.0 SABNF\n";
        str += "; RFC 5234 with some restrictions and additions.\n";
        str += "; Updated 11/24/2015 for RFC 7405 case-sensitive literal string notation\n";
        str += ';  - accepts %s"string" as a case-sensitive string\n';
        str += ';  - accepts %i"string" as a case-insensitive string\n';
        str += ';  - accepts "string" as a case-insensitive string\n';
        str += ";\n";
        str += "; Some restrictions:\n";
        str += ";   1. Rules must begin at first character of each line.\n";
        str += ";      Indentations on first rule and rules thereafter are not allowed.\n";
        str += ";   2. Relaxed line endings. CRLF, LF or CR are accepted as valid line ending.\n";
        str += ";   3. Prose values, i.e. <prose value>, are accepted as valid grammar syntax.\n";
        str += ";      However, a working parser cannot be generated from them.\n";
        str += ";\n";
        str += "; Super set (SABNF) additions:\n";
        str += ";   1. Look-ahead (syntactic predicate) operators are accepted as element prefixes.\n";
        str += ";      & is the positive look-ahead operator, succeeds and backtracks if the look-ahead phrase is found\n";
        str += ";      ! is the negative look-ahead operator, succeeds and backtracks if the look-ahead phrase is NOT found\n";
        str += ";      e.g. &%d13 or &rule or !(A / B)\n";
        str += ";   2. User-Defined Terminals (UDT) of the form, u_name and e_name are accepted.\n";
        str += ";      'name' is alpha followed by alpha/num/hyphen just like a rule name.\n";
        str += ";      u_name may be used as an element but no rule definition is given.\n";
        str += ";      e.g. rule = A / u_myUdt\n";
        str += ';           A = "a"\n';
        str += ";      would be a valid grammar.\n";
        str += ";   3. Case-sensitive, single-quoted strings are accepted.\n";
        str += ";      e.g. 'abc' would be equivalent to %d97.98.99\n";
        str += ';      (kept for backward compatibility, but superseded by %s"abc")  \n';
        str += "; New 12/26/2015\n";
        str += ";   4. Look-behind operators are accepted as element prefixes.\n";
        str += ";      && is the positive look-behind operator, succeeds and backtracks if the look-behind phrase is found\n";
        str += ";      !! is the negative look-behind operator, succeeds and backtracks if the look-behind phrase is NOT found\n";
        str += ";      e.g. &&%d13 or &&rule or !!(A / B)\n";
        str += ";   5. Back reference operators, i.e. \\rulename, are accepted.\n";
        str += ";      A back reference operator acts like a TLS or TBS terminal except that the phrase it attempts\n";
        str += ";      to match is a phrase previously matched by the rule 'rulename'.\n";
        str += ";      There are two modes of previous phrase matching - the parent-frame mode and the universal mode.\n";
        str += ";      In universal mode, \\rulename matches the last match to 'rulename' regardless of where it was found.\n";
        str += ";      In parent-frame mode, \\rulename matches only the last match found on the parent's frame or parse tree level.\n";
        str += ";      Back reference modifiers can be used to specify case and mode.\n";
        str += ";      \\A defaults to case-insensitive and universal mode, e.g. \\A === \\%i%uA\n";
        str += ";      Modifiers %i and %s determine case-insensitive and case-sensitive mode, respectively.\n";
        str += ";      Modifiers %u and %p determine universal mode and parent frame mode, respectively.\n";
        str += ";      Case and mode modifiers can appear in any order, e.g. \\%s%pA === \\%p%sA. \n";
        str += ";   7. String begin anchor, ABG(%^) matches the beginning of the input string location.\n";
        str += ";      Returns EMPTY or NOMATCH. Never consumes any characters.\n";
        str += ";   8. String end anchor, AEN(%$) matches the end of the input string location.\n";
        str += ";      Returns EMPTY or NOMATCH. Never consumes any characters.\n";
        str += ";\n";
        str += "File            = *(BlankLine / Rule / RuleError)\n";
        str += "BlankLine       = *(%d32/%d9) [comment] LineEnd\n";
        str += "Rule            = RuleLookup owsp Alternation ((owsp LineEnd)\n";
        str += "                / (LineEndError LineEnd))\n";
        str += "RuleLookup      = RuleNameTest owsp DefinedAsTest\n";
        str += "RuleNameTest    = RuleName/RuleNameError\n";
        str += "RuleName        = alphanum\n";
        str += "RuleNameError   = 1*(%d33-60/%d62-126)\n";
        str += "DefinedAsTest   = DefinedAs / DefinedAsError\n";
        str += "DefinedAsError  = 1*2%d33-126\n";
        str += "DefinedAs       = IncAlt / Defined\n";
        str += "Defined         = %d61\n";
        str += "IncAlt          = %d61.47\n";
        str += "RuleError       = 1*(%d32-126 / %d9  / LineContinue) LineEnd\n";
        str += "LineEndError    = 1*(%d32-126 / %d9  / LineContinue)\n";
        str += "Alternation     = Concatenation *(owsp AltOp Concatenation)\n";
        str += "Concatenation   = Repetition *(CatOp Repetition)\n";
        str += "Repetition      = [Modifier] (Group / Option / BasicElement / BasicElementErr)\n";
        str += "Modifier        = (Predicate [RepOp])\n";
        str += "                / RepOp\n";
        str += "Predicate       = BkaOp\n";
        str += "                / BknOp\n";
        str += "                / AndOp\n";
        str += "                / NotOp\n";
        str += "BasicElement    = UdtOp\n";
        str += "                / RnmOp\n";
        str += "                / TrgOp\n";
        str += "                / TbsOp\n";
        str += "                / TlsOp\n";
        str += "                / ClsOp\n";
        str += "                / BkrOp\n";
        str += "                / AbgOp\n";
        str += "                / AenOp\n";
        str += "                / ProsVal\n";
        str += "BasicElementErr = 1*(%d33-40/%d42-46/%d48-92/%d94-126)\n";
        str += "Group           = GroupOpen  Alternation (GroupClose / GroupError)\n";
        str += "GroupError      = 1*(%d33-40/%d42-46/%d48-92/%d94-126) ; same as BasicElementErr\n";
        str += "GroupOpen       = %d40 owsp\n";
        str += "GroupClose      = owsp %d41\n";
        str += "Option          = OptionOpen Alternation (OptionClose / OptionError)\n";
        str += "OptionError     = 1*(%d33-40/%d42-46/%d48-92/%d94-126) ; same as BasicElementErr\n";
        str += "OptionOpen      = %d91 owsp\n";
        str += "OptionClose     = owsp %d93\n";
        str += "RnmOp           = alphanum\n";
        str += "BkrOp           = %d92 [bkrModifier] bkr-name\n";
        str += "bkrModifier     = (cs [um / pm]) / (ci [um / pm]) / (um [cs /ci]) / (pm [cs / ci])\n";
        str += "cs              = '%s'\n";
        str += "ci              = '%i'\n";
        str += "um              = '%u'\n";
        str += "pm              = '%p'\n";
        str += "bkr-name        = uname / ename / rname\n";
        str += "rname           = alphanum\n";
        str += "uname           = %d117.95 alphanum\n";
        str += "ename           = %d101.95 alphanum\n";
        str += "UdtOp           = udt-empty\n";
        str += "                / udt-non-empty\n";
        str += "udt-non-empty   = %d117.95 alphanum\n";
        str += "udt-empty       = %d101.95 alphanum\n";
        str += "RepOp           = (rep-min StarOp rep-max)\n";
        str += "                / (rep-min StarOp)\n";
        str += "                / (StarOp rep-max)\n";
        str += "                / StarOp\n";
        str += "                / rep-min-max\n";
        str += "AltOp           = %d47 owsp\n";
        str += "CatOp           = wsp\n";
        str += "StarOp          = %d42\n";
        str += "AndOp           = %d38\n";
        str += "NotOp           = %d33\n";
        str += "BkaOp           = %d38.38\n";
        str += "BknOp           = %d33.33\n";
        str += "AbgOp           = %d37.94\n";
        str += "AenOp           = %d37.36\n";
        str += "TrgOp           = %d37 ((Dec dmin %d45 dmax) / (Hex xmin %d45 xmax) / (Bin bmin %d45 bmax))\n";
        str += "TbsOp           = %d37 ((Dec dString *(%d46 dString)) / (Hex xString *(%d46 xString)) / (Bin bString *(%d46 bString)))\n";
        str += "TlsOp           = TlsCase TlsOpen TlsString TlsClose\n";
        str += 'TlsCase         = ["%i" / "%s"]\n';
        str += "TlsOpen         = %d34\n";
        str += "TlsClose        = %d34\n";
        str += "TlsString       = *(%d32-33/%d35-126/StringTab)\n";
        str += "StringTab       = %d9\n";
        str += "ClsOp           = ClsOpen ClsString ClsClose\n";
        str += "ClsOpen         = %d39\n";
        str += "ClsClose        = %d39\n";
        str += "ClsString       = *(%d32-38/%d40-126/StringTab)\n";
        str += "ProsVal         = ProsValOpen ProsValString ProsValClose\n";
        str += "ProsValOpen     = %d60\n";
        str += "ProsValString   = *(%d32-61/%d63-126/StringTab)\n";
        str += "ProsValClose    = %d62\n";
        str += "rep-min         = rep-num\n";
        str += "rep-min-max     = rep-num\n";
        str += "rep-max         = rep-num\n";
        str += "rep-num         = 1*(%d48-57)\n";
        str += "dString         = dnum\n";
        str += "xString         = xnum\n";
        str += "bString         = bnum\n";
        str += "Dec             = (%d68/%d100)\n";
        str += "Hex             = (%d88/%d120)\n";
        str += "Bin             = (%d66/%d98)\n";
        str += "dmin            = dnum\n";
        str += "dmax            = dnum\n";
        str += "bmin            = bnum\n";
        str += "bmax            = bnum\n";
        str += "xmin            = xnum\n";
        str += "xmax            = xnum\n";
        str += "dnum            = 1*(%d48-57)\n";
        str += "bnum            = 1*%d48-49\n";
        str += "xnum            = 1*(%d48-57 / %d65-70 / %d97-102)\n";
        str += ";\n";
        str += "; Basics\n";
        str += "alphanum        = (%d97-122/%d65-90) *(%d97-122/%d65-90/%d48-57/%d45)\n";
        str += "owsp            = *space\n";
        str += "wsp             = 1*space\n";
        str += "space           = %d32\n";
        str += "                / %d9\n";
        str += "                / comment\n";
        str += "                / LineContinue\n";
        str += "comment         = %d59 *(%d32-126 / %d9)\n";
        str += "LineEnd         = %d13.10\n";
        str += "                / %d10\n";
        str += "                / %d13\n";
        str += "LineContinue    = (%d13.10 / %d10 / %d13) (%d32 / %d9)\n";
        return str;
    };
};

});


parcelRegister("6xKFX", function(module, exports) {
/* eslint-disable class-methods-use-this */ /*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // Attributes Validation
//
// It is well known that recursive-descent parsers will fail if a rule is left recursive.
// Besides left recursion, there are a couple of other fatal attributes that need to be disclosed as well.
// There are several non-fatal attributes that are of interest also.
// This module will determine six different attributes listed here with simple examples.
//
// **fatal attributes**<br>
// left recursion<br>
// S = S "x" / "y"
//
// cyclic<br>
// S = S
//
// infinite<br>
// S = "y" S
//
// **non-fatal attributes** (but nice to know)<br>
// nested recursion<br>
// S = "a" S "b" / "y"
//
// right recursion<br>
// S = "x" S / "y"
//
// empty string<br>
// S = "x" S / ""
//
// Note that these are “aggregate” attributes, in that if the attribute is true it only means that it can be true,
// not that it will always be true for every input string.
// In the simple examples above the attributes may be obvious and definite – always true or false.
// However, for a large grammar with possibly hundreds of rules and parse tree branches,
// it can be obscure which branches lead to which attributes.
// Furthermore, different input strings will lead the parser down different branches.
// One input string may parse perfectly while another will hit a left-recursive branch and bottom out the call stack.
//
// It is for this reason that the APG parser generator computes these attributes.
// When using the API the attributes call is optional but generating a parser without checking the attributes - proceed at your own peril.
//
// Additionally, the attribute phase will identify rule dependencies and mutually-recursive groups. For example,
//
// S = "a" A "b" / "y"<br>
// A = "x"
//
// S is dependent on A but A is not dependent on S.
//
// S = "a" A "b" / "c"<br>
// A = "x" S "y" / "z"
//
// S and A are dependent on one another and are mutually recursive.



module.exports = function exportAttributes() {
    const id = (parcelRequire("aGWMb"));
    const { ruleAttributes: ruleAttributes, showAttributes: showAttributes, showAttributeErrors: showAttributeErrors } = (parcelRequire("8sWW2"));
    const { ruleDependencies: ruleDependencies, showRuleDependencies: showRuleDependencies } = (parcelRequire("f626h"));
    class State {
        constructor(rules, udts){
            this.rules = rules;
            this.udts = udts;
            this.ruleCount = rules.length;
            this.udtCount = udts.length;
            this.startRule = 0;
            this.dependenciesComplete = false;
            this.attributesComplete = false;
            this.isMutuallyRecursive = false;
            this.ruleIndexes = this.indexArray(this.ruleCount);
            this.ruleAlphaIndexes = this.indexArray(this.ruleCount);
            this.ruleTypeIndexes = this.indexArray(this.ruleCount);
            this.udtIndexes = this.indexArray(this.udtCount);
            this.udtAlphaIndexes = this.indexArray(this.udtCount);
            this.attrsErrorCount = 0;
            this.attrs = [];
            this.attrsErrors = [];
            this.attrsWorking = [];
            this.ruleDeps = [];
            for(let i = 0; i < this.ruleCount; i += 1){
                this.attrs.push(this.attrGen(this.rules[i]));
                this.attrsWorking.push(this.attrGen(this.rules[i]));
                this.ruleDeps.push(this.rdGen(rules[i], this.ruleCount, this.udtCount));
            }
            this.compRulesAlpha = this.compRulesAlpha.bind(this);
            this.compUdtsAlpha = this.compUdtsAlpha.bind(this);
            this.compRulesType = this.compRulesType.bind(this);
            this.compRulesGroup = this.compRulesGroup.bind(this);
        }
        // eslint-disable-next-line class-methods-use-this
        attrGen(rule) {
            return {
                left: false,
                nested: false,
                right: false,
                empty: false,
                finite: false,
                cyclic: false,
                leaf: false,
                isOpen: false,
                isComplete: false,
                rule: rule
            };
        }
        // eslint-disable-next-line class-methods-use-this
        attrInit(attr) {
            attr.left = false;
            attr.nested = false;
            attr.right = false;
            attr.empty = false;
            attr.finite = false;
            attr.cyclic = false;
            attr.leaf = false;
            attr.isOpen = false;
            attr.isComplete = false;
        }
        attrCopy(dst, src) {
            dst.left = src.left;
            dst.nested = src.nested;
            dst.right = src.right;
            dst.empty = src.empty;
            dst.finite = src.finite;
            dst.cyclic = src.cyclic;
            dst.leaf = src.leaf;
            dst.isOpen = src.isOpen;
            dst.isComplete = src.isComplete;
            dst.rule = src.rule;
        }
        rdGen(rule, ruleCount, udtCount) {
            const ret = {
                rule: rule,
                recursiveType: id.ATTR_N,
                groupNumber: -1,
                refersTo: this.falseArray(ruleCount),
                refersToUdt: this.falseArray(udtCount),
                referencedBy: this.falseArray(ruleCount)
            };
            return ret;
        }
        typeToString(recursiveType) {
            switch(recursiveType){
                case id.ATTR_N:
                    return " N";
                case id.ATTR_R:
                    return " R";
                case id.ATTR_MR:
                    return "MR";
                default:
                    return "UNKNOWN";
            }
        }
        falseArray(length) {
            const ret = [];
            if (length > 0) for(let i = 0; i < length; i += 1)ret.push(false);
            return ret;
        }
        falsifyArray(a) {
            for(let i = 0; i < a.length; i += 1)a[i] = false;
        }
        indexArray(length) {
            const ret = [];
            if (length > 0) for(let i = 0; i < length; i += 1)ret.push(i);
            return ret;
        }
        compRulesAlpha(left, right) {
            if (this.rules[left].lower < this.rules[right].lower) return -1;
            if (this.rules[left].lower > this.rules[right].lower) return 1;
            return 0;
        }
        compUdtsAlpha(left, right) {
            if (this.udts[left].lower < this.udts[right].lower) return -1;
            if (this.udts[left].lower > this.udts[right].lower) return 1;
            return 0;
        }
        compRulesType(left, right) {
            if (this.ruleDeps[left].recursiveType < this.ruleDeps[right].recursiveType) return -1;
            if (this.ruleDeps[left].recursiveType > this.ruleDeps[right].recursiveType) return 1;
            return 0;
        }
        compRulesGroup(left, right) {
            if (this.ruleDeps[left].recursiveType === id.ATTR_MR && this.ruleDeps[right].recursiveType === id.ATTR_MR) {
                if (this.ruleDeps[left].groupNumber < this.ruleDeps[right].groupNumber) return -1;
                if (this.ruleDeps[left].groupNumber > this.ruleDeps[right].groupNumber) return 1;
            }
            return 0;
        }
    }
    // eslint-disable-next-line no-unused-vars
    const attributes = function attributes(rules = [], udts = [], lineMap = [], errors = []) {
        // let i = 0;
        // Initialize the state. The state of the computation get passed around to multiple functions in multiple files.
        const state = new State(rules, udts);
        // Determine all rule dependencies
        //  - which rules each rule refers to
        //  - which rules reference each rule
        ruleDependencies(state);
        // Determine the attributes for each rule.
        ruleAttributes(state);
        if (state.attrsErrorCount) errors.push({
            line: 0,
            char: 0,
            msg: `${state.attrsErrorCount} attribute errors`
        });
        // Return the number of attribute errors to the caller.
        return state.attrsErrorCount;
    };
    /* Destructuring assignment - see MDN Web Docs */ return {
        attributes: attributes,
        showAttributes: showAttributes,
        showAttributeErrors: showAttributeErrors,
        showRuleDependencies: showRuleDependencies
    };
}();

});
parcelRegister("8sWW2", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // This module does the heavy lifting for attribute generation.

module.exports = function exportRuleAttributes() {
    const id = (parcelRequire("aGWMb"));
    const thisFile = "rule-attributes.js";
    let state = null;
    function isEmptyOnly(attr) {
        if (attr.left || attr.nested || attr.right || attr.cyclic) return false;
        return attr.empty;
    }
    function isRecursive(attr) {
        if (attr.left || attr.nested || attr.right || attr.cyclic) return true;
        return false;
    }
    function isCatNested(attrs, count) {
        let i = 0;
        let j = 0;
        let k = 0;
        /* 1. if any child is nested, CAT is nested */ for(i = 0; i < count; i += 1){
            if (attrs[i].nested) return true;
        }
        /* 2.) the left-most right recursive child
               is followed by at least one non-empty child */ for(i = 0; i < count; i += 1){
            if (attrs[i].right && !attrs[i].leaf) for(j = i + 1; j < count; j += 1){
                if (!isEmptyOnly(attrs[j])) return true;
            }
        }
        /* 3.) the right-most left recursive child
               is preceded by at least one non-empty child */ for(i = count - 1; i >= 0; i -= 1){
            if (attrs[i].left && !attrs[i].leaf) for(j = i - 1; j >= 0; j -= 1){
                if (!isEmptyOnly(attrs[j])) return true;
            }
        }
        /* 4. there is at lease one recursive child between
              the left-most and right-most non-recursive, non-empty children */ for(i = 0; i < count; i += 1){
            if (!attrs[i].empty && !isRecursive(attrs[i])) for(j = i + 1; j < count; j += 1){
                if (isRecursive(attrs[j])) for(k = j + 1; k < count; k += 1){
                    if (!attrs[k].empty && !isRecursive(attrs[k])) return true;
                }
            }
        }
        /* none of the above */ return false;
    }
    function isCatCyclic(attrs, count) {
        /* if all children are cyclic, CAT is cyclic */ for(let i = 0; i < count; i += 1){
            if (!attrs[i].cyclic) return false;
        }
        return true;
    }
    function isCatLeft(attrs, count) {
        /* if the left-most non-empty is left, CAT is left */ for(let i = 0; i < count; i += 1){
            if (attrs[i].left) return true;
            if (!attrs[i].empty) return false;
        /* keep looking */ }
        return false; /* all left-most are empty */ 
    }
    function isCatRight(attrs, count) {
        /* if the right-most non-empty is right, CAT is right */ for(let i = count - 1; i >= 0; i -= 1){
            if (attrs[i].right) return true;
            if (!attrs[i].empty) return false;
        /* keep looking */ }
        return false;
    }
    function isCatEmpty(attrs, count) {
        /* if all children are empty, CAT is empty */ for(let i = 0; i < count; i += 1){
            if (!attrs[i].empty) return false;
        }
        return true;
    }
    function isCatFinite(attrs, count) {
        /* if all children are finite, CAT is finite */ for(let i = 0; i < count; i += 1){
            if (!attrs[i].finite) return false;
        }
        return true;
    }
    function cat(stateArg, opcodes, opIndex, iAttr) {
        let i = 0;
        const opCat = opcodes[opIndex];
        const count = opCat.children.length;
        /* generate an empty array of child attributes */ const childAttrs = [];
        for(i = 0; i < count; i += 1)childAttrs.push(stateArg.attrGen());
        for(i = 0; i < count; i += 1)// eslint-disable-next-line no-use-before-define
        opEval(stateArg, opcodes, opCat.children[i], childAttrs[i]);
        iAttr.left = isCatLeft(childAttrs, count);
        iAttr.right = isCatRight(childAttrs, count);
        iAttr.nested = isCatNested(childAttrs, count);
        iAttr.empty = isCatEmpty(childAttrs, count);
        iAttr.finite = isCatFinite(childAttrs, count);
        iAttr.cyclic = isCatCyclic(childAttrs, count);
    }
    function alt(stateArg, opcodes, opIndex, iAttr) {
        let i = 0;
        const opAlt = opcodes[opIndex];
        const count = opAlt.children.length;
        /* generate an empty array of child attributes */ const childAttrs = [];
        for(i = 0; i < count; i += 1)childAttrs.push(stateArg.attrGen());
        for(i = 0; i < count; i += 1)// eslint-disable-next-line no-use-before-define
        opEval(stateArg, opcodes, opAlt.children[i], childAttrs[i]);
        /* if any child attribute is true, ALT is true */ iAttr.left = false;
        iAttr.right = false;
        iAttr.nested = false;
        iAttr.empty = false;
        iAttr.finite = false;
        iAttr.cyclic = false;
        for(i = 0; i < count; i += 1){
            if (childAttrs[i].left) iAttr.left = true;
            if (childAttrs[i].nested) iAttr.nested = true;
            if (childAttrs[i].right) iAttr.right = true;
            if (childAttrs[i].empty) iAttr.empty = true;
            if (childAttrs[i].finite) iAttr.finite = true;
            if (childAttrs[i].cyclic) iAttr.cyclic = true;
        }
    }
    function bkr(stateArg, opcodes, opIndex, iAttr) {
        const opBkr = opcodes[opIndex];
        if (opBkr.index >= stateArg.ruleCount) {
            /* use UDT values */ iAttr.empty = stateArg.udts[opBkr.index - stateArg.ruleCount].empty;
            iAttr.finite = true;
        } else {
            /* use the empty and finite values from the back referenced rule */ // eslint-disable-next-line no-use-before-define
            ruleAttrsEval(stateArg, opBkr.index, iAttr);
            /* however, this is a terminal node like TLS */ iAttr.left = false;
            iAttr.nested = false;
            iAttr.right = false;
            iAttr.cyclic = false;
        }
    }
    function opEval(stateArg, opcodes, opIndex, iAttr) {
        stateArg.attrInit(iAttr);
        const opi = opcodes[opIndex];
        switch(opi.type){
            case id.ALT:
                alt(stateArg, opcodes, opIndex, iAttr);
                break;
            case id.CAT:
                cat(stateArg, opcodes, opIndex, iAttr);
                break;
            case id.REP:
                opEval(stateArg, opcodes, opIndex + 1, iAttr);
                if (opi.min === 0) {
                    iAttr.empty = true;
                    iAttr.finite = true;
                }
                break;
            case id.RNM:
                // eslint-disable-next-line no-use-before-define
                ruleAttrsEval(stateArg, opcodes[opIndex].index, iAttr);
                break;
            case id.BKR:
                bkr(stateArg, opcodes, opIndex, iAttr);
                break;
            case id.AND:
            case id.NOT:
            case id.BKA:
            case id.BKN:
                opEval(stateArg, opcodes, opIndex + 1, iAttr);
                iAttr.empty = true;
                break;
            case id.TLS:
                iAttr.empty = !opcodes[opIndex].string.length;
                iAttr.finite = true;
                iAttr.cyclic = false;
                break;
            case id.TBS:
            case id.TRG:
                iAttr.empty = false;
                iAttr.finite = true;
                iAttr.cyclic = false;
                break;
            case id.UDT:
                iAttr.empty = opi.empty;
                iAttr.finite = true;
                iAttr.cyclic = false;
                break;
            case id.ABG:
            case id.AEN:
                iAttr.empty = true;
                iAttr.finite = true;
                iAttr.cyclic = false;
                break;
            default:
                throw new Error(`unknown opcode type: ${opi}`);
        }
    }
    // The main logic for handling rules that:
    //  - have already be evaluated
    //  - have not been evaluated and is the first occurrence on this branch
    //  - second occurrence on this branch for the start rule
    //  - second occurrence on this branch for non-start rules
    function ruleAttrsEval(stateArg, ruleIndex, iAttr) {
        const attri = stateArg.attrsWorking[ruleIndex];
        if (attri.isComplete) /* just use the completed values */ stateArg.attrCopy(iAttr, attri);
        else if (!attri.isOpen) {
            /* open the rule and traverse it */ attri.isOpen = true;
            opEval(stateArg, attri.rule.opcodes, 0, iAttr);
            /* complete this rule's attributes */ attri.left = iAttr.left;
            attri.right = iAttr.right;
            attri.nested = iAttr.nested;
            attri.empty = iAttr.empty;
            attri.finite = iAttr.finite;
            attri.cyclic = iAttr.cyclic;
            attri.leaf = false;
            attri.isOpen = false;
            attri.isComplete = true;
        } else if (ruleIndex === stateArg.startRule) /* use recursive leaf values */ {
            if (ruleIndex === stateArg.startRule) {
                iAttr.left = true;
                iAttr.right = true;
                iAttr.cyclic = true;
                iAttr.leaf = true;
            }
        } else /* non-start rule terminal leaf */ iAttr.finite = true;
    }
    // The main driver for the attribute generation.
    const ruleAttributes = (stateArg)=>{
        state = stateArg;
        let i = 0;
        let j = 0;
        const iAttr = state.attrGen();
        for(i = 0; i < state.ruleCount; i += 1){
            /* initialize working attributes */ for(j = 0; j < state.ruleCount; j += 1)state.attrInit(state.attrsWorking[j]);
            state.startRule = i;
            ruleAttrsEval(state, i, iAttr);
            /* save off the working attributes for this rule */ state.attrCopy(state.attrs[i], state.attrsWorking[i]);
        }
        state.attributesComplete = true;
        let attri = null;
        for(i = 0; i < state.ruleCount; i += 1){
            attri = state.attrs[i];
            if (attri.left || !attri.finite || attri.cyclic) {
                const temp = state.attrGen(attri.rule);
                state.attrCopy(temp, attri);
                state.attrsErrors.push(temp);
                state.attrsErrorCount += 1;
            }
        }
    };
    const truth = (val)=>val ? "t" : "f";
    const tError = (val)=>val ? "e" : "f";
    const fError = (val)=>val ? "t" : "e";
    const showAttr = (seq, index, attr, dep)=>{
        let str = `${seq}:${index}:`;
        str += `${tError(attr.left)} `;
        str += `${truth(attr.nested)} `;
        str += `${truth(attr.right)} `;
        str += `${tError(attr.cyclic)} `;
        str += `${fError(attr.finite)} `;
        str += `${truth(attr.empty)}:`;
        str += `${state.typeToString(dep.recursiveType)}:`;
        str += dep.recursiveType === id.ATTR_MR ? dep.groupNumber : "-";
        str += `:${attr.rule.name}\n`;
        return str;
    };
    const showLegend = ()=>{
        let str = "LEGEND - t=true, f=false, e=error\n";
        str += "sequence:rule index:left nested right cyclic finite empty:type:group number:rule name\n";
        return str;
    };
    const showAttributeErrors = ()=>{
        let attri = null;
        let depi = null;
        let str = "";
        str += "RULE ATTRIBUTES WITH ERRORS\n";
        str += showLegend();
        if (state.attrsErrorCount) for(let i = 0; i < state.attrsErrorCount; i += 1){
            attri = state.attrsErrors[i];
            depi = state.ruleDeps[attri.rule.index];
            str += showAttr(i, attri.rule.index, attri, depi);
        }
        else str += "<none>\n";
        return str;
    };
    const show = (type)=>{
        let i = 0;
        let ii = 0;
        let attri = null;
        let depi = null;
        let str = "";
        let { ruleIndexes: ruleIndexes } = state;
        // let udtIndexes = state.udtIndexes;
        if (type === 97) ruleIndexes = state.ruleAlphaIndexes;
        else if (type === 116) ruleIndexes = state.ruleTypeIndexes;
        /* show all attributes */ for(i = 0; i < state.ruleCount; i += 1){
            ii = ruleIndexes[i];
            attri = state.attrs[ii];
            depi = state.ruleDeps[ii];
            str += showAttr(i, ii, attri, depi);
        }
        return str;
    };
    // Display the rule attributes.
    // - order
    //      - "index" or "i", index order (default)
    //      - "alpha" or "a", alphabetical order
    //      - "type" or "t", ordered by type (alphabetical within each type/group)
    //      - none of above, index order (default)
    const showAttributes = (order = "index")=>{
        if (!state.attributesComplete) throw new Error(`${thisFile}:showAttributes: attributes not available`);
        let str = "";
        const leader = "RULE ATTRIBUTES\n";
        if (order.charCodeAt(0) === 97) {
            str += "alphabetical by rule name\n";
            str += leader;
            str += showLegend();
            str += show(97);
        } else if (order.charCodeAt(0) === 116) {
            str += "ordered by rule type\n";
            str += leader;
            str += showLegend();
            str += show(116);
        } else {
            str += "ordered by rule index\n";
            str += leader;
            str += showLegend();
            str += show();
        }
        return str;
    };
    /* Destructuring assignment - see MDN Web Docs */ return {
        ruleAttributes: ruleAttributes,
        showAttributes: showAttributes,
        showAttributeErrors: showAttributeErrors
    };
}();

});

parcelRegister("f626h", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ // Determine rule dependencies and types.
// For each rule, determine which other rules it refers to
// and which of the other rules refer back to it.
//
// Rule types are:
//  - non-recursive - the rule never refers to itself, even indirectly
//  - recursive - the rule refers to itself, possibly indirectly
//  - mutually-recursive - belongs to a group of two or more rules, each of which refers to every other rule in the group, including itself.

module.exports = (()=>{
    const id = (parcelRequire("aGWMb"));
    let state = null; /* keep a global reference to the state for the show functions */ 
    /* scan the opcodes of the indexed rule and discover which rules it references and which rule refer back to it */ const scan = (ruleCount, ruleDeps, index, isScanned)=>{
        let i = 0;
        let j = 0;
        const rdi = ruleDeps[index];
        isScanned[index] = true;
        const op = rdi.rule.opcodes;
        for(i = 0; i < op.length; i += 1){
            const opi = op[i];
            if (opi.type === id.RNM) {
                rdi.refersTo[opi.index] = true;
                if (!isScanned[opi.index]) scan(ruleCount, ruleDeps, opi.index, isScanned);
                for(j = 0; j < ruleCount; j += 1)if (ruleDeps[opi.index].refersTo[j]) rdi.refersTo[j] = true;
            } else if (opi.type === id.UDT) rdi.refersToUdt[opi.index] = true;
            else if (opi.type === id.BKR) {
                if (opi.index < ruleCount) {
                    rdi.refersTo[opi.index] = true;
                    if (!isScanned[opi.index]) scan(ruleCount, ruleDeps, opi.index, isScanned);
                } else rdi.refersToUdt[ruleCount - opi.index] = true;
            }
        }
    };
    // Determine the rule dependencies, types and mutually recursive groups.
    const ruleDependencies = (stateArg)=>{
        state = stateArg; /* make it global */ 
        let i = 0;
        let j = 0;
        let groupCount = 0;
        let rdi = null;
        let rdj = null;
        let newGroup = false;
        state.dependenciesComplete = false;
        /* make a working array of rule scanned markers */ const isScanned = state.falseArray(state.ruleCount);
        /* discover the rule dependencies */ for(i = 0; i < state.ruleCount; i += 1){
            state.falsifyArray(isScanned);
            scan(state.ruleCount, state.ruleDeps, i, isScanned);
        }
        /* discover all rules referencing each rule */ for(i = 0; i < state.ruleCount; i += 1)for(j = 0; j < state.ruleCount; j += 1){
            if (i !== j) {
                if (state.ruleDeps[j].refersTo[i]) state.ruleDeps[i].referencedBy[j] = true;
            }
        }
        /* find the non-recursive and recursive types */ for(i = 0; i < state.ruleCount; i += 1){
            state.ruleDeps[i].recursiveType = id.ATTR_N;
            if (state.ruleDeps[i].refersTo[i]) state.ruleDeps[i].recursiveType = id.ATTR_R;
        }
        /* find the mutually-recursive groups, if any */ groupCount = -1;
        for(i = 0; i < state.ruleCount; i += 1){
            rdi = state.ruleDeps[i];
            if (rdi.recursiveType === id.ATTR_R) {
                newGroup = true;
                for(j = 0; j < state.ruleCount; j += 1)if (i !== j) {
                    rdj = state.ruleDeps[j];
                    if (rdj.recursiveType === id.ATTR_R) {
                        if (rdi.refersTo[j] && rdj.refersTo[i]) {
                            if (newGroup) {
                                groupCount += 1;
                                rdi.recursiveType = id.ATTR_MR;
                                rdi.groupNumber = groupCount;
                                newGroup = false;
                            }
                            rdj.recursiveType = id.ATTR_MR;
                            rdj.groupNumber = groupCount;
                        }
                    }
                }
            }
        }
        state.isMutuallyRecursive = groupCount > -1;
        /* sort the rules/UDTS */ state.ruleAlphaIndexes.sort(state.compRulesAlpha);
        state.ruleTypeIndexes.sort(state.compRulesAlpha);
        state.ruleTypeIndexes.sort(state.compRulesType);
        if (state.isMutuallyRecursive) state.ruleTypeIndexes.sort(state.compRulesGroup);
        if (state.udtCount) state.udtAlphaIndexes.sort(state.compUdtsAlpha);
        state.dependenciesComplete = true;
    };
    const show = (type = null)=>{
        let i = 0;
        let j = 0;
        let count = 0;
        let startSeg = 0;
        const maxRule = state.ruleCount - 1;
        const maxUdt = state.udtCount - 1;
        const lineLength = 100;
        let str = "";
        let pre = "";
        const toArrow = "=> ";
        const byArrow = "<= ";
        let first = false;
        let rdi = null;
        let { ruleIndexes: ruleIndexes } = state;
        let { udtIndexes: udtIndexes } = state;
        if (type === 97) {
            ruleIndexes = state.ruleAlphaIndexes;
            udtIndexes = state.udtAlphaIndexes;
        } else if (type === 116) {
            ruleIndexes = state.ruleTypeIndexes;
            udtIndexes = state.udtAlphaIndexes;
        }
        for(i = 0; i < state.ruleCount; i += 1){
            rdi = state.ruleDeps[ruleIndexes[i]];
            pre = `${ruleIndexes[i]}:${state.typeToString(rdi.recursiveType)}:`;
            if (state.isMutuallyRecursive) {
                pre += rdi.groupNumber > -1 ? rdi.groupNumber : "-";
                pre += ":";
            }
            pre += " ";
            str += `${pre + state.rules[ruleIndexes[i]].name}\n`;
            first = true;
            count = 0;
            startSeg = str.length;
            str += pre;
            for(j = 0; j < state.ruleCount; j += 1){
                if (rdi.refersTo[ruleIndexes[j]]) {
                    if (first) {
                        str += toArrow;
                        first = false;
                        str += state.ruleDeps[ruleIndexes[j]].rule.name;
                    } else str += `, ${state.ruleDeps[ruleIndexes[j]].rule.name}`;
                    count += 1;
                }
                if (str.length - startSeg > lineLength && j !== maxRule) {
                    str += `\n${pre}${toArrow}`;
                    startSeg = str.length;
                }
            }
            if (state.udtCount) for(j = 0; j < state.udtCount; j += 1){
                if (rdi.refersToUdt[udtIndexes[j]]) {
                    if (first) {
                        str += toArrow;
                        first = false;
                        str += state.udts[udtIndexes[j]].name;
                    } else str += `, ${state.udts[udtIndexes[j]].name}`;
                    count += 1;
                }
                if (str.length - startSeg > lineLength && j !== maxUdt) {
                    str += `\n${pre}${toArrow}`;
                    startSeg = str.length;
                }
            }
            if (count === 0) str += "=> <none>\n";
            if (first === false) str += "\n";
            first = true;
            count = 0;
            startSeg = str.length;
            str += pre;
            for(j = 0; j < state.ruleCount; j += 1){
                if (rdi.referencedBy[ruleIndexes[j]]) {
                    if (first) {
                        str += byArrow;
                        first = false;
                        str += state.ruleDeps[ruleIndexes[j]].rule.name;
                    } else str += `, ${state.ruleDeps[ruleIndexes[j]].rule.name}`;
                    count += 1;
                }
                if (str.length - startSeg > lineLength && j !== maxRule) {
                    str += `\n${pre}${toArrow}`;
                    startSeg = str.length;
                }
            }
            if (count === 0) str += "<= <none>\n";
            if (first === false) str += "\n";
            str += "\n";
        }
        return str;
    };
    // Display the rule dependencies.
    // - order
    //      - "index" or "i", index order (default)
    //      - "alpha" or "a", alphabetical order
    //      - "type" or "t", ordered by type (alphabetical within each type/group)
    //      - none of above, index order (default)
    const showRuleDependencies = (order = "index")=>{
        let str = "RULE DEPENDENCIES(index:type:[group number:])\n";
        str += "=> refers to rule names\n";
        str += "<= referenced by rule names\n";
        if (!state.dependenciesComplete) return str;
        if (order.charCodeAt(0) === 97) {
            str += "alphabetical by rule name\n";
            str += show(97);
        } else if (order.charCodeAt(0) === 116) {
            str += "ordered by rule type\n";
            str += show(116);
        } else {
            str += "ordered by rule index\n";
            str += show(null);
        }
        return str;
    };
    /* Destructuring assignment - see MDN Web Docs */ return {
        ruleDependencies: ruleDependencies,
        showRuleDependencies: showRuleDependencies
    };
})();

});


parcelRegister("aavuS", function(module, exports) {
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */ module.exports = function exfn() {
    const thisFileName = "show-rules.js";
    // Display the rules.
    // This function may be called before the attributes calculation.
    // Sorting is done independently from the attributes.
    // - order
    //      - "index" or "i", index order (default)
    //      - "alpha" or "a", alphabetical order
    //      - none of above, index order (default)
    const showRules = function showRules(rulesIn = [], udtsIn = [], order = "index") {
        const thisFuncName = "showRules";
        let alphaArray = [];
        let udtAlphaArray = [];
        const indexArray = [];
        const udtIndexArray = [];
        const rules = rulesIn;
        const udts = udtsIn;
        const ruleCount = rulesIn.length;
        const udtCount = udtsIn.length;
        let str = "RULE/UDT NAMES";
        let i;
        function compRulesAlpha(left, right) {
            if (rules[left].lower < rules[right].lower) return -1;
            if (rules[left].lower > rules[right].lower) return 1;
            return 0;
        }
        function compUdtsAlpha(left, right) {
            if (udts[left].lower < udts[right].lower) return -1;
            if (udts[left].lower > udts[right].lower) return 1;
            return 0;
        }
        if (!(Array.isArray(rulesIn) && rulesIn.length)) throw new Error(`${thisFileName}:${thisFuncName}: rules arg must be array with length > 0`);
        if (!Array.isArray(udtsIn)) throw new Error(`${thisFileName}:${thisFuncName}: udts arg must be array`);
        for(i = 0; i < ruleCount; i += 1)indexArray.push(i);
        alphaArray = indexArray.slice(0);
        alphaArray.sort(compRulesAlpha);
        if (udtCount) {
            for(i = 0; i < udtCount; i += 1)udtIndexArray.push(i);
            udtAlphaArray = udtIndexArray.slice(0);
            udtAlphaArray.sort(compUdtsAlpha);
        }
        if (order.charCodeAt(0) === 97) {
            str += " - alphabetical by rule/UDT name\n";
            for(i = 0; i < ruleCount; i += 1)str += `${i}: ${alphaArray[i]}: ${rules[alphaArray[i]].name}\n`;
            if (udtCount) for(i = 0; i < udtCount; i += 1)str += `${i}: ${udtAlphaArray[i]}: ${udts[udtAlphaArray[i]].name}\n`;
        } else {
            str += " - ordered by rule/UDT index\n";
            for(i = 0; i < ruleCount; i += 1)str += `${i}: ${rules[i].name}\n`;
            if (udtCount) for(i = 0; i < udtCount; i += 1)str += `${i}: ${udts[i].name}\n`;
        }
        return str;
    };
    return showRules;
}();

});


parcelRegister("58dei", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseIntegerNumber = module.exports.isEIP55Address = void 0;

var $iXzJR = parcelRequire("iXzJR");

var $2wly8 = parcelRequire("2wly8");
/**
 * This method is supposed to check if an address is conforming to EIP-55.
 * @param address Address to be checked if conforms with EIP-55.
 * @returns Either the return is or not in the EIP-55 format.
 */ const $3bc7f63efd3503f1$var$isEIP55Address = (address)=>{
    if (address.length != 42) return false;
    const lowerAddress = `${address}`.toLowerCase().replace("0x", "");
    const hash = (0, $2wly8.bytesToHex)((0, $iXzJR.keccak_256)(lowerAddress));
    let ret = "0x";
    for(let i = 0; i < lowerAddress.length; i++)if (parseInt(hash[i], 16) >= 8) ret += lowerAddress[i].toUpperCase();
    else ret += lowerAddress[i];
    return address === ret;
};
module.exports.isEIP55Address = $3bc7f63efd3503f1$var$isEIP55Address;
const $3bc7f63efd3503f1$var$parseIntegerNumber = (number)=>{
    const parsed = parseInt(number);
    if (isNaN(parsed)) throw new Error("Invalid number.");
    if (parsed === Infinity) throw new Error("Invalid number.");
    return parsed;
};
module.exports.parseIntegerNumber = $3bc7f63efd3503f1$var$parseIntegerNumber;

});
parcelRegister("iXzJR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shake256 = module.exports.shake128 = module.exports.keccak_512 = module.exports.keccak_384 = module.exports.keccak_256 = module.exports.keccak_224 = module.exports.sha3_512 = module.exports.sha3_384 = module.exports.sha3_256 = module.exports.sha3_224 = module.exports.Keccak = module.exports.keccakP = void 0;

var $hhPJK = parcelRequire("hhPJK");

var $eihiZ = parcelRequire("eihiZ");

var $2wly8 = parcelRequire("2wly8");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const $dcd9759e86af5002$var$SHA3_PI = [];
const $dcd9759e86af5002$var$SHA3_ROTL = [];
const $dcd9759e86af5002$var$_SHA3_IOTA = [];
const $dcd9759e86af5002$var$_0n = /* @__PURE__ */ BigInt(0);
const $dcd9759e86af5002$var$_1n = /* @__PURE__ */ BigInt(1);
const $dcd9759e86af5002$var$_2n = /* @__PURE__ */ BigInt(2);
const $dcd9759e86af5002$var$_7n = /* @__PURE__ */ BigInt(7);
const $dcd9759e86af5002$var$_256n = /* @__PURE__ */ BigInt(256);
const $dcd9759e86af5002$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $dcd9759e86af5002$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $dcd9759e86af5002$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $dcd9759e86af5002$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $dcd9759e86af5002$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $dcd9759e86af5002$var$_1n ^ (R >> $dcd9759e86af5002$var$_7n) * $dcd9759e86af5002$var$_0x71n) % $dcd9759e86af5002$var$_256n;
        if (R & $dcd9759e86af5002$var$_2n) t ^= $dcd9759e86af5002$var$_1n << ($dcd9759e86af5002$var$_1n << /* @__PURE__ */ BigInt(j)) - $dcd9759e86af5002$var$_1n;
    }
    $dcd9759e86af5002$var$_SHA3_IOTA.push(t);
}
const [$dcd9759e86af5002$var$SHA3_IOTA_H, $dcd9759e86af5002$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $eihiZ.split)($dcd9759e86af5002$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $dcd9759e86af5002$var$rotlH = (h, l, s)=>s > 32 ? (0, $eihiZ.rotlBH)(h, l, s) : (0, $eihiZ.rotlSH)(h, l, s);
const $dcd9759e86af5002$var$rotlL = (h, l, s)=>s > 32 ? (0, $eihiZ.rotlBL)(h, l, s) : (0, $eihiZ.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $dcd9759e86af5002$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $dcd9759e86af5002$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $dcd9759e86af5002$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $dcd9759e86af5002$var$SHA3_ROTL[t];
            const Th = $dcd9759e86af5002$var$rotlH(curH, curL, shift);
            const Tl = $dcd9759e86af5002$var$rotlL(curH, curL, shift);
            const PI = $dcd9759e86af5002$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $dcd9759e86af5002$var$SHA3_IOTA_H[round];
        s[1] ^= $dcd9759e86af5002$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
module.exports.keccakP = $dcd9759e86af5002$var$keccakP;
class $dcd9759e86af5002$var$Keccak extends $2wly8.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $hhPJK.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $2wly8.u32)(this.state);
    }
    keccak() {
        if (!$2wly8.isLE) (0, $2wly8.byteSwap32)(this.state32);
        $dcd9759e86af5002$var$keccakP(this.state32, this.rounds);
        if (!$2wly8.isLE) (0, $2wly8.byteSwap32)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $hhPJK.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $2wly8.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $hhPJK.exists)(this, false);
        (0, $hhPJK.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $hhPJK.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $hhPJK.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $dcd9759e86af5002$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
module.exports.Keccak = $dcd9759e86af5002$var$Keccak;
const $dcd9759e86af5002$var$gen = (suffix, blockLen, outputLen)=>(0, $2wly8.wrapConstructor)(()=>new $dcd9759e86af5002$var$Keccak(blockLen, suffix, outputLen));
module.exports.sha3_224 = $dcd9759e86af5002$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ module.exports.sha3_256 = $dcd9759e86af5002$var$gen(0x06, 136, 32);
module.exports.sha3_384 = $dcd9759e86af5002$var$gen(0x06, 104, 48);
module.exports.sha3_512 = $dcd9759e86af5002$var$gen(0x06, 72, 64);
module.exports.keccak_224 = $dcd9759e86af5002$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ module.exports.keccak_256 = $dcd9759e86af5002$var$gen(0x01, 136, 32);
module.exports.keccak_384 = $dcd9759e86af5002$var$gen(0x01, 104, 48);
module.exports.keccak_512 = $dcd9759e86af5002$var$gen(0x01, 72, 64);
const $dcd9759e86af5002$var$genShake = (suffix, blockLen, outputLen)=>(0, $2wly8.wrapXOFConstructorWithOpts)((opts = {})=>new $dcd9759e86af5002$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
module.exports.shake128 = $dcd9759e86af5002$var$genShake(0x1f, 168, 16);
module.exports.shake256 = $dcd9759e86af5002$var$genShake(0x1f, 136, 32);

});
parcelRegister("hhPJK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = module.exports.isBytes = void 0;
function $c95c2813ef726f7a$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
module.exports.number = $c95c2813ef726f7a$var$number;
function $c95c2813ef726f7a$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`boolean expected, not ${b}`);
}
module.exports.bool = $c95c2813ef726f7a$var$bool;
// copied from utils
function $c95c2813ef726f7a$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
module.exports.isBytes = $c95c2813ef726f7a$var$isBytes;
function $c95c2813ef726f7a$var$bytes(b, ...lengths) {
    if (!$c95c2813ef726f7a$var$isBytes(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $c95c2813ef726f7a$var$bytes;
function $c95c2813ef726f7a$var$hash(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $c95c2813ef726f7a$var$number(h.outputLen);
    $c95c2813ef726f7a$var$number(h.blockLen);
}
module.exports.hash = $c95c2813ef726f7a$var$hash;
function $c95c2813ef726f7a$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $c95c2813ef726f7a$var$exists;
function $c95c2813ef726f7a$var$output(out, instance) {
    $c95c2813ef726f7a$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $c95c2813ef726f7a$var$output;
const $c95c2813ef726f7a$var$assert = {
    number: $c95c2813ef726f7a$var$number,
    bool: $c95c2813ef726f7a$var$bool,
    bytes: $c95c2813ef726f7a$var$bytes,
    hash: $c95c2813ef726f7a$var$hash,
    exists: $c95c2813ef726f7a$var$exists,
    output: $c95c2813ef726f7a$var$output
};
module.exports.default = $c95c2813ef726f7a$var$assert;

});

parcelRegister("eihiZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.add = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
const $a6802b9333302e9b$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $a6802b9333302e9b$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $a6802b9333302e9b$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $a6802b9333302e9b$var$U32_MASK64),
        l: Number(n >> $a6802b9333302e9b$var$_32n & $a6802b9333302e9b$var$U32_MASK64)
    };
    return {
        h: Number(n >> $a6802b9333302e9b$var$_32n & $a6802b9333302e9b$var$U32_MASK64) | 0,
        l: Number(n & $a6802b9333302e9b$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $a6802b9333302e9b$var$fromBig;
function $a6802b9333302e9b$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $a6802b9333302e9b$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $a6802b9333302e9b$var$split;
const $a6802b9333302e9b$var$toBig = (h, l)=>BigInt(h >>> 0) << $a6802b9333302e9b$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $a6802b9333302e9b$var$toBig;
// for Shift in [0, 32)
const $a6802b9333302e9b$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $a6802b9333302e9b$var$shrSH;
const $a6802b9333302e9b$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $a6802b9333302e9b$var$shrSL;
// Right rotate for Shift in [1, 32)
const $a6802b9333302e9b$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $a6802b9333302e9b$var$rotrSH;
const $a6802b9333302e9b$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $a6802b9333302e9b$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $a6802b9333302e9b$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $a6802b9333302e9b$var$rotrBH;
const $a6802b9333302e9b$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $a6802b9333302e9b$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $a6802b9333302e9b$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $a6802b9333302e9b$var$rotr32H;
const $a6802b9333302e9b$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $a6802b9333302e9b$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $a6802b9333302e9b$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $a6802b9333302e9b$var$rotlSH;
const $a6802b9333302e9b$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $a6802b9333302e9b$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $a6802b9333302e9b$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $a6802b9333302e9b$var$rotlBH;
const $a6802b9333302e9b$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $a6802b9333302e9b$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $a6802b9333302e9b$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $a6802b9333302e9b$var$add;
// Addition with more than 2 elements
const $a6802b9333302e9b$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $a6802b9333302e9b$var$add3L;
const $a6802b9333302e9b$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $a6802b9333302e9b$var$add3H;
const $a6802b9333302e9b$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $a6802b9333302e9b$var$add4L;
const $a6802b9333302e9b$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $a6802b9333302e9b$var$add4H;
const $a6802b9333302e9b$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $a6802b9333302e9b$var$add5L;
const $a6802b9333302e9b$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $a6802b9333302e9b$var$add5H;
// prettier-ignore
const $a6802b9333302e9b$var$u64 = {
    fromBig: $a6802b9333302e9b$var$fromBig,
    split: $a6802b9333302e9b$var$split,
    toBig: $a6802b9333302e9b$var$toBig,
    shrSH: $a6802b9333302e9b$var$shrSH,
    shrSL: $a6802b9333302e9b$var$shrSL,
    rotrSH: $a6802b9333302e9b$var$rotrSH,
    rotrSL: $a6802b9333302e9b$var$rotrSL,
    rotrBH: $a6802b9333302e9b$var$rotrBH,
    rotrBL: $a6802b9333302e9b$var$rotrBL,
    rotr32H: $a6802b9333302e9b$var$rotr32H,
    rotr32L: $a6802b9333302e9b$var$rotr32L,
    rotlSH: $a6802b9333302e9b$var$rotlSH,
    rotlSL: $a6802b9333302e9b$var$rotlSL,
    rotlBH: $a6802b9333302e9b$var$rotlBH,
    rotlBL: $a6802b9333302e9b$var$rotlBL,
    add: $a6802b9333302e9b$var$add,
    add3L: $a6802b9333302e9b$var$add3L,
    add3H: $a6802b9333302e9b$var$add3H,
    add4L: $a6802b9333302e9b$var$add4L,
    add4H: $a6802b9333302e9b$var$add4H,
    add5H: $a6802b9333302e9b$var$add5H,
    add5L: $a6802b9333302e9b$var$add5L
};
module.exports.default = $a6802b9333302e9b$var$u64;

});

parcelRegister("2wly8", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.byteSwap32 = module.exports.byteSwapIfBE = module.exports.byteSwap = module.exports.isLE = module.exports.rotl = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = module.exports.isBytes = void 0;

var $ec7r5 = parcelRequire("ec7r5");

var $hhPJK = parcelRequire("hhPJK");
// export { isBytes } from './_assert.js';
// We can't reuse isBytes from _assert, because somehow this causes huge perf issues
function $1d5f49382dd5a9ba$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
module.exports.isBytes = $1d5f49382dd5a9ba$var$isBytes;
// Cast array to different type
const $1d5f49382dd5a9ba$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $1d5f49382dd5a9ba$var$u8;
const $1d5f49382dd5a9ba$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $1d5f49382dd5a9ba$var$u32;
// Cast array to view
const $1d5f49382dd5a9ba$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $1d5f49382dd5a9ba$var$createView;
// The rotate right (circular right shift) operation for uint32
const $1d5f49382dd5a9ba$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $1d5f49382dd5a9ba$var$rotr;
// The rotate left (circular left shift) operation for uint32
const $1d5f49382dd5a9ba$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
module.exports.rotl = $1d5f49382dd5a9ba$var$rotl;
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
// The byte swap operation for uint32
const $1d5f49382dd5a9ba$var$byteSwap = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
module.exports.byteSwap = $1d5f49382dd5a9ba$var$byteSwap;
// Conditionally byte swap if on a big-endian platform
module.exports.byteSwapIfBE = module.exports.isLE ? (n)=>n : (n)=>(0, module.exports.byteSwap)(n);
// In place byte swap for Uint32Array
function $1d5f49382dd5a9ba$var$byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = (0, module.exports.byteSwap)(arr[i]);
}
module.exports.byteSwap32 = $1d5f49382dd5a9ba$var$byteSwap32;
// Array where index 0xf0 (240) is mapped to string 'f0'
const $1d5f49382dd5a9ba$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $1d5f49382dd5a9ba$var$bytesToHex(bytes) {
    (0, $hhPJK.bytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $1d5f49382dd5a9ba$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $1d5f49382dd5a9ba$var$bytesToHex;
// We use optimized technique to convert hex string to byte array
const $1d5f49382dd5a9ba$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $1d5f49382dd5a9ba$var$asciiToBase16(char) {
    if (char >= $1d5f49382dd5a9ba$var$asciis._0 && char <= $1d5f49382dd5a9ba$var$asciis._9) return char - $1d5f49382dd5a9ba$var$asciis._0;
    if (char >= $1d5f49382dd5a9ba$var$asciis._A && char <= $1d5f49382dd5a9ba$var$asciis._F) return char - ($1d5f49382dd5a9ba$var$asciis._A - 10);
    if (char >= $1d5f49382dd5a9ba$var$asciis._a && char <= $1d5f49382dd5a9ba$var$asciis._f) return char - ($1d5f49382dd5a9ba$var$asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $1d5f49382dd5a9ba$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $1d5f49382dd5a9ba$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $1d5f49382dd5a9ba$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
module.exports.hexToBytes = $1d5f49382dd5a9ba$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $1d5f49382dd5a9ba$var$nextTick = async ()=>{};
module.exports.nextTick = $1d5f49382dd5a9ba$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $1d5f49382dd5a9ba$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $1d5f49382dd5a9ba$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $1d5f49382dd5a9ba$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $1d5f49382dd5a9ba$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $1d5f49382dd5a9ba$var$toBytes(data) {
    if (typeof data === "string") data = $1d5f49382dd5a9ba$var$utf8ToBytes(data);
    (0, $hhPJK.bytes)(data);
    return data;
}
module.exports.toBytes = $1d5f49382dd5a9ba$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $1d5f49382dd5a9ba$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $hhPJK.bytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
module.exports.concatBytes = $1d5f49382dd5a9ba$var$concatBytes;
// For runtime check if class implements interface
class $1d5f49382dd5a9ba$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $1d5f49382dd5a9ba$var$Hash;
const $1d5f49382dd5a9ba$var$toStr = {}.toString;
function $1d5f49382dd5a9ba$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $1d5f49382dd5a9ba$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $1d5f49382dd5a9ba$var$checkOpts;
function $1d5f49382dd5a9ba$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($1d5f49382dd5a9ba$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $1d5f49382dd5a9ba$var$wrapConstructor;
function $1d5f49382dd5a9ba$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($1d5f49382dd5a9ba$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $1d5f49382dd5a9ba$var$wrapConstructorWithOpts;
function $1d5f49382dd5a9ba$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($1d5f49382dd5a9ba$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $1d5f49382dd5a9ba$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $1d5f49382dd5a9ba$var$randomBytes(bytesLength = 32) {
    if ($ec7r5.crypto && typeof $ec7r5.crypto.getRandomValues === "function") return $ec7r5.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $1d5f49382dd5a9ba$var$randomBytes;

});
parcelRegister("ec7r5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});






parcelRegister("k09Qs", function(module, exports) {
(function(module1) {
    "use strict";
    module1.exports.is_uri = is_iri;
    module1.exports.is_http_uri = is_http_iri;
    module1.exports.is_https_uri = is_https_iri;
    module1.exports.is_web_uri = is_web_iri;
    // Create aliases
    module1.exports.isUri = is_iri;
    module1.exports.isHttpUri = is_http_iri;
    module1.exports.isHttpsUri = is_https_iri;
    module1.exports.isWebUri = is_web_iri;
    // private function
    // internal URI spitter method - direct from RFC 3986
    var splitUri = function(uri) {
        var splitted = uri.match(/(?:([^:\/?#]+):)?(?:\/\/([^\/?#]*))?([^?#]*)(?:\?([^#]*))?(?:#(.*))?/);
        return splitted;
    };
    function is_iri(value) {
        if (!value) return;
        // check for illegal characters
        if (/[^a-z0-9\:\/\?\#\[\]\@\!\$\&\'\(\)\*\+\,\;\=\.\-\_\~\%]/i.test(value)) return;
        // check for hex escapes that aren't complete
        if (/%[^0-9a-f]/i.test(value)) return;
        if (/%[0-9a-f](:?[^0-9a-f]|$)/i.test(value)) return;
        var splitted = [];
        var scheme = "";
        var authority = "";
        var path = "";
        var query = "";
        var fragment = "";
        var out = "";
        // from RFC 3986
        splitted = splitUri(value);
        scheme = splitted[1];
        authority = splitted[2];
        path = splitted[3];
        query = splitted[4];
        fragment = splitted[5];
        // scheme and path are required, though the path can be empty
        if (!(scheme && scheme.length && path.length >= 0)) return;
        // if authority is present, the path must be empty or begin with a /
        if (authority && authority.length) {
            if (!(path.length === 0 || /^\//.test(path))) return;
        } else {
            // if authority is not present, the path must not start with //
            if (/^\/\//.test(path)) return;
        }
        // scheme must begin with a letter, then consist of letters, digits, +, ., or -
        if (!/^[a-z][a-z0-9\+\-\.]*$/.test(scheme.toLowerCase())) return;
        // re-assemble the URL per section 5.3 in RFC 3986
        out += scheme + ":";
        if (authority && authority.length) out += "//" + authority;
        out += path;
        if (query && query.length) out += "?" + query;
        if (fragment && fragment.length) out += "#" + fragment;
        return out;
    }
    function is_http_iri(value, allowHttps) {
        if (!is_iri(value)) return;
        var splitted = [];
        var scheme = "";
        var authority = "";
        var path = "";
        var port = "";
        var query = "";
        var fragment = "";
        var out = "";
        // from RFC 3986
        splitted = splitUri(value);
        scheme = splitted[1];
        authority = splitted[2];
        path = splitted[3];
        query = splitted[4];
        fragment = splitted[5];
        if (!scheme) return;
        if (allowHttps) {
            if (scheme.toLowerCase() != "https") return;
        } else {
            if (scheme.toLowerCase() != "http") return;
        }
        // fully-qualified URIs must have an authority section that is
        // a valid host
        if (!authority) return;
        // enable port component
        if (/:(\d+)$/.test(authority)) {
            port = authority.match(/:(\d+)$/)[0];
            authority = authority.replace(/:\d+$/, "");
        }
        out += scheme + ":";
        out += "//" + authority;
        if (port) out += port;
        out += path;
        if (query && query.length) out += "?" + query;
        if (fragment && fragment.length) out += "#" + fragment;
        return out;
    }
    function is_https_iri(value) {
        return is_http_iri(value, true);
    }
    function is_web_iri(value) {
        return is_http_iri(value) || is_https_iri(value);
    }
})(module);

});

parcelRegister("jGqzU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAddress = module.exports.hashMessage = module.exports.verifyMessage = void 0;
parcelRequire("kCE6e");
var $2nd1e = parcelRequire("2nd1e");
let $e5468e69f61227df$var$ethersVerifyMessage = null;
let $e5468e69f61227df$var$ethersHashMessage = null;
let $e5468e69f61227df$var$ethersGetAddress = null;
try {
    // @ts-expect-error -- v6 compatibility hack
    $e5468e69f61227df$var$ethersVerifyMessage = $2nd1e.utils.verifyMessage;
    // @ts-expect-error -- v6 compatibility hack
    $e5468e69f61227df$var$ethersHashMessage = $2nd1e.utils.hashMessage;
    // @ts-expect-error -- v6 compatibility hack
    $e5468e69f61227df$var$ethersGetAddress = $2nd1e.utils.getAddress;
} catch (_a) {
    $e5468e69f61227df$var$ethersVerifyMessage = $2nd1e.verifyMessage;
    $e5468e69f61227df$var$ethersHashMessage = $2nd1e.hashMessage;
    $e5468e69f61227df$var$ethersGetAddress = $2nd1e.getAddress;
}
module.exports.verifyMessage = $e5468e69f61227df$var$ethersVerifyMessage;
module.exports.hashMessage = $e5468e69f61227df$var$ethersHashMessage;
module.exports.getAddress = $e5468e69f61227df$var$ethersGetAddress;

});
parcelRegister("kCE6e", function(module, exports) {

$parcel$export(module.exports, "ethers", function () { return (parcelRequire("2nd1e")); });

var $2nd1e = parcelRequire("2nd1e");
var $glz4p = parcelRequire("glz4p");
var $7Um1T = parcelRequire("7Um1T");
var $fz5pm = parcelRequire("fz5pm");
var $9TnCu = parcelRequire("9TnCu");
var $20M69 = parcelRequire("20M69");
var $jR8eo = parcelRequire("jR8eo");
var $fFBPF = parcelRequire("fFBPF");
var $4NCF1 = parcelRequire("4NCF1");
var $01Dt9 = parcelRequire("01Dt9");
var $h7tuR = parcelRequire("h7tuR");
var $lEEPI = parcelRequire("lEEPI");
var $lUSfR = parcelRequire("lUSfR");
"use strict";
try {
    const anyGlobal = window;
    if (anyGlobal._ethers == null) anyGlobal._ethers = $2nd1e;
} catch (error) {}

});
parcelRegister("2nd1e", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $1ba7d403ff6f32be$export$af88d00dbe7f521; });
$parcel$export(module.exports, "Signer", function () { return (parcelRequire("glz4p")).Signer; });
$parcel$export(module.exports, "Wallet", function () { return (parcelRequire("7Um1T")).Wallet; });
$parcel$export(module.exports, "VoidSigner", function () { return (parcelRequire("glz4p")).VoidSigner; });
$parcel$export(module.exports, "getDefaultProvider", function () { return (parcelRequire("fz5pm")).getDefaultProvider; });
$parcel$export(module.exports, "providers", function () { return (parcelRequire("fz5pm")); });
$parcel$export(module.exports, "BaseContract", function () { return (parcelRequire("9TnCu")).BaseContract; });
$parcel$export(module.exports, "Contract", function () { return (parcelRequire("9TnCu")).Contract; });
$parcel$export(module.exports, "ContractFactory", function () { return (parcelRequire("9TnCu")).ContractFactory; });
$parcel$export(module.exports, "BigNumber", function () { return (parcelRequire("20M69")).BigNumber; });
$parcel$export(module.exports, "FixedNumber", function () { return (parcelRequire("jR8eo")).FixedNumber; });
$parcel$export(module.exports, "constants", function () { return (parcelRequire("fFBPF")); });
$parcel$export(module.exports, "errors", function () { return (parcelRequire("4NCF1")).ErrorCode; });
$parcel$export(module.exports, "utils", function () { return (parcelRequire("01Dt9")); });
$parcel$export(module.exports, "wordlists", function () { return (parcelRequire("h7tuR")).wordlists; });
$parcel$export(module.exports, "version", function () { return (parcelRequire("lEEPI")).version; });
$parcel$export(module.exports, "Wordlist", function () { return (parcelRequire("lUSfR")).Wordlist; });

var $9TnCu = parcelRequire("9TnCu");

var $20M69 = parcelRequire("20M69");
var $jR8eo = parcelRequire("jR8eo");

var $glz4p = parcelRequire("glz4p");

var $7Um1T = parcelRequire("7Um1T");

var $fFBPF = parcelRequire("fFBPF");

var $fz5pm = parcelRequire("fz5pm");

var $lUSfR = parcelRequire("lUSfR");
var $h7tuR = parcelRequire("h7tuR");

var $01Dt9 = parcelRequire("01Dt9");

var $4NCF1 = parcelRequire("4NCF1");

var $lEEPI = parcelRequire("lEEPI");
"use strict";
const $1ba7d403ff6f32be$export$af88d00dbe7f521 = new (0, $4NCF1.Logger)((0, $lEEPI.version));

});
parcelRegister("9TnCu", function(module, exports) {

$parcel$export(module.exports, "BaseContract", function () { return $733b9283c8dc7dc3$export$304faa4fc17528db; });
$parcel$export(module.exports, "Contract", function () { return $733b9283c8dc7dc3$export$8517d80acf00e19a; });
$parcel$export(module.exports, "ContractFactory", function () { return $733b9283c8dc7dc3$export$505569a6bf584fd9; });

var $b924P = parcelRequire("b924P");
var $iAVJ5 = parcelRequire("iAVJ5");

var $lOWlX = parcelRequire("lOWlX");

var $glz4p = parcelRequire("glz4p");

var $ak7re = parcelRequire("ak7re");

var $20M69 = parcelRequire("20M69");

var $eBLyT = parcelRequire("eBLyT");

var $j0dXC = parcelRequire("j0dXC");

var $ABz8M = parcelRequire("ABz8M");

var $4NCF1 = parcelRequire("4NCF1");

var $gipJy = parcelRequire("gipJy");
"use strict";
var $733b9283c8dc7dc3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $733b9283c8dc7dc3$var$logger = new (0, $4NCF1.Logger)((0, $gipJy.version));
///////////////////////////////
const $733b9283c8dc7dc3$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    from: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true,
    customData: true,
    ccipReadEnabled: true
};
function $733b9283c8dc7dc3$var$resolveName(resolver, nameOrPromise) {
    return $733b9283c8dc7dc3$var$__awaiter(this, void 0, void 0, function*() {
        const name = yield nameOrPromise;
        if (typeof name !== "string") $733b9283c8dc7dc3$var$logger.throwArgumentError("invalid address or ENS name", "name", name);
        // If it is already an address, just use it (after adding checksum)
        try {
            return (0, $ak7re.getAddress)(name);
        } catch (error) {}
        if (!resolver) $733b9283c8dc7dc3$var$logger.throwError("a provider or signer is needed to resolve ENS names", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "resolveName"
        });
        const address = yield resolver.resolveName(name);
        if (address == null) $733b9283c8dc7dc3$var$logger.throwArgumentError("resolver or addr is not configured for ENS name", "name", name);
        return address;
    });
}
// Recursively replaces ENS names with promises to resolve the name and resolves all properties
function $733b9283c8dc7dc3$var$resolveAddresses(resolver, value, paramType) {
    return $733b9283c8dc7dc3$var$__awaiter(this, void 0, void 0, function*() {
        if (Array.isArray(paramType)) return yield Promise.all(paramType.map((paramType, index)=>{
            return $733b9283c8dc7dc3$var$resolveAddresses(resolver, Array.isArray(value) ? value[index] : value[paramType.name], paramType);
        }));
        if (paramType.type === "address") return yield $733b9283c8dc7dc3$var$resolveName(resolver, value);
        if (paramType.type === "tuple") return yield $733b9283c8dc7dc3$var$resolveAddresses(resolver, value, paramType.components);
        if (paramType.baseType === "array") {
            if (!Array.isArray(value)) return Promise.reject($733b9283c8dc7dc3$var$logger.makeError("invalid value for array", (0, $4NCF1.Logger).errors.INVALID_ARGUMENT, {
                argument: "value",
                value: value
            }));
            return yield Promise.all(value.map((v)=>$733b9283c8dc7dc3$var$resolveAddresses(resolver, v, paramType.arrayChildren)));
        }
        return value;
    });
}
function $733b9283c8dc7dc3$var$populateTransaction(contract, fragment, args) {
    return $733b9283c8dc7dc3$var$__awaiter(this, void 0, void 0, function*() {
        // If an extra argument is given, it is overrides
        let overrides = {};
        if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") overrides = (0, $j0dXC.shallowCopy)(args.pop());
        // Make sure the parameter count matches
        $733b9283c8dc7dc3$var$logger.checkArgumentCount(args.length, fragment.inputs.length, "passed to contract");
        // Populate "from" override (allow promises)
        if (contract.signer) {
            if (overrides.from) // Contracts with a Signer are from the Signer's frame-of-reference;
            // but we allow overriding "from" if it matches the signer
            overrides.from = (0, $j0dXC.resolveProperties)({
                override: $733b9283c8dc7dc3$var$resolveName(contract.signer, overrides.from),
                signer: contract.signer.getAddress()
            }).then((check)=>$733b9283c8dc7dc3$var$__awaiter(this, void 0, void 0, function*() {
                    if ((0, $ak7re.getAddress)(check.signer) !== check.override) $733b9283c8dc7dc3$var$logger.throwError("Contract with a Signer cannot override from", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "overrides.from"
                    });
                    return check.override;
                }));
            else overrides.from = contract.signer.getAddress();
        } else if (overrides.from) overrides.from = $733b9283c8dc7dc3$var$resolveName(contract.provider, overrides.from);
        // Wait for all dependencies to be resolved (prefer the signer over the provider)
        const resolved = yield (0, $j0dXC.resolveProperties)({
            args: $733b9283c8dc7dc3$var$resolveAddresses(contract.signer || contract.provider, args, fragment.inputs),
            address: contract.resolvedAddress,
            overrides: (0, $j0dXC.resolveProperties)(overrides) || {}
        });
        // The ABI coded transaction
        const data = contract.interface.encodeFunctionData(fragment, resolved.args);
        const tx = {
            data: data,
            to: resolved.address
        };
        // Resolved Overrides
        const ro = resolved.overrides;
        // Populate simple overrides
        if (ro.nonce != null) tx.nonce = (0, $20M69.BigNumber).from(ro.nonce).toNumber();
        if (ro.gasLimit != null) tx.gasLimit = (0, $20M69.BigNumber).from(ro.gasLimit);
        if (ro.gasPrice != null) tx.gasPrice = (0, $20M69.BigNumber).from(ro.gasPrice);
        if (ro.maxFeePerGas != null) tx.maxFeePerGas = (0, $20M69.BigNumber).from(ro.maxFeePerGas);
        if (ro.maxPriorityFeePerGas != null) tx.maxPriorityFeePerGas = (0, $20M69.BigNumber).from(ro.maxPriorityFeePerGas);
        if (ro.from != null) tx.from = ro.from;
        if (ro.type != null) tx.type = ro.type;
        if (ro.accessList != null) tx.accessList = (0, $ABz8M.accessListify)(ro.accessList);
        // If there was no "gasLimit" override, but the ABI specifies a default, use it
        if (tx.gasLimit == null && fragment.gas != null) {
            // Compute the intrinsic gas cost for this transaction
            // @TODO: This is based on the yellow paper as of Petersburg; this is something
            // we may wish to parameterize in v6 as part of the Network object. Since this
            // is always a non-nil to address, we can ignore G_create, but may wish to add
            // similar logic to the ContractFactory.
            let intrinsic = 21000;
            const bytes = (0, $eBLyT.arrayify)(data);
            for(let i = 0; i < bytes.length; i++){
                intrinsic += 4;
                if (bytes[i]) intrinsic += 64;
            }
            tx.gasLimit = (0, $20M69.BigNumber).from(fragment.gas).add(intrinsic);
        }
        // Populate "value" override
        if (ro.value) {
            const roValue = (0, $20M69.BigNumber).from(ro.value);
            if (!roValue.isZero() && !fragment.payable) $733b9283c8dc7dc3$var$logger.throwError("non-payable method cannot override value", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: overrides.value
            });
            tx.value = roValue;
        }
        if (ro.customData) tx.customData = (0, $j0dXC.shallowCopy)(ro.customData);
        if (ro.ccipReadEnabled) tx.ccipReadEnabled = !!ro.ccipReadEnabled;
        // Remove the overrides
        delete overrides.nonce;
        delete overrides.gasLimit;
        delete overrides.gasPrice;
        delete overrides.from;
        delete overrides.value;
        delete overrides.type;
        delete overrides.accessList;
        delete overrides.maxFeePerGas;
        delete overrides.maxPriorityFeePerGas;
        delete overrides.customData;
        delete overrides.ccipReadEnabled;
        // Make sure there are no stray overrides, which may indicate a
        // typo or using an unsupported key.
        const leftovers = Object.keys(overrides).filter((key)=>overrides[key] != null);
        if (leftovers.length) $733b9283c8dc7dc3$var$logger.throwError(`cannot override ${leftovers.map((l)=>JSON.stringify(l)).join(",")}`, (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "overrides",
            overrides: leftovers
        });
        return tx;
    });
}
function $733b9283c8dc7dc3$var$buildPopulate(contract, fragment) {
    return function(...args) {
        return $733b9283c8dc7dc3$var$populateTransaction(contract, fragment, args);
    };
}
function $733b9283c8dc7dc3$var$buildEstimate(contract, fragment) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $733b9283c8dc7dc3$var$__awaiter(this, void 0, void 0, function*() {
            if (!signerOrProvider) $733b9283c8dc7dc3$var$logger.throwError("estimate require a provider or signer", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "estimateGas"
            });
            const tx = yield $733b9283c8dc7dc3$var$populateTransaction(contract, fragment, args);
            return yield signerOrProvider.estimateGas(tx);
        });
    };
}
function $733b9283c8dc7dc3$var$addContractWait(contract, tx) {
    const wait = tx.wait.bind(tx);
    tx.wait = (confirmations)=>{
        return wait(confirmations).then((receipt)=>{
            receipt.events = receipt.logs.map((log)=>{
                let event = (0, $j0dXC.deepCopy)(log);
                let parsed = null;
                try {
                    parsed = contract.interface.parseLog(log);
                } catch (e) {}
                // Successfully parsed the event log; include it
                if (parsed) {
                    event.args = parsed.args;
                    event.decode = (data, topics)=>{
                        return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                }
                // Useful operations
                event.removeListener = ()=>{
                    return contract.provider;
                };
                event.getBlock = ()=>{
                    return contract.provider.getBlock(receipt.blockHash);
                };
                event.getTransaction = ()=>{
                    return contract.provider.getTransaction(receipt.transactionHash);
                };
                event.getTransactionReceipt = ()=>{
                    return Promise.resolve(receipt);
                };
                return event;
            });
            return receipt;
        });
    };
}
function $733b9283c8dc7dc3$var$buildCall(contract, fragment, collapseSimple) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $733b9283c8dc7dc3$var$__awaiter(this, void 0, void 0, function*() {
            // Extract the "blockTag" override if present
            let blockTag = undefined;
            if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") {
                const overrides = (0, $j0dXC.shallowCopy)(args.pop());
                if (overrides.blockTag != null) blockTag = yield overrides.blockTag;
                delete overrides.blockTag;
                args.push(overrides);
            }
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed(blockTag);
            // Call a node and get the result
            const tx = yield $733b9283c8dc7dc3$var$populateTransaction(contract, fragment, args);
            const result = yield signerOrProvider.call(tx, blockTag);
            try {
                let value = contract.interface.decodeFunctionResult(fragment, result);
                if (collapseSimple && fragment.outputs.length === 1) value = value[0];
                return value;
            } catch (error) {
                if (error.code === (0, $4NCF1.Logger).errors.CALL_EXCEPTION) {
                    error.address = contract.address;
                    error.args = args;
                    error.transaction = tx;
                }
                throw error;
            }
        });
    };
}
function $733b9283c8dc7dc3$var$buildSend(contract, fragment) {
    return function(...args) {
        return $733b9283c8dc7dc3$var$__awaiter(this, void 0, void 0, function*() {
            if (!contract.signer) $733b9283c8dc7dc3$var$logger.throwError("sending a transaction requires a signer", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "sendTransaction"
            });
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed();
            const txRequest = yield $733b9283c8dc7dc3$var$populateTransaction(contract, fragment, args);
            const tx = yield contract.signer.sendTransaction(txRequest);
            // Tweak the tx.wait so the receipt has extra properties
            $733b9283c8dc7dc3$var$addContractWait(contract, tx);
            return tx;
        });
    };
}
function $733b9283c8dc7dc3$var$buildDefault(contract, fragment, collapseSimple) {
    if (fragment.constant) return $733b9283c8dc7dc3$var$buildCall(contract, fragment, collapseSimple);
    return $733b9283c8dc7dc3$var$buildSend(contract, fragment);
}
function $733b9283c8dc7dc3$var$getEventTag(filter) {
    if (filter.address && (filter.topics == null || filter.topics.length === 0)) return "*";
    return (filter.address || "*") + "@" + (filter.topics ? filter.topics.map((topic)=>{
        if (Array.isArray(topic)) return topic.join("|");
        return topic;
    }).join(":") : "");
}
class $733b9283c8dc7dc3$var$RunningEvent {
    constructor(tag, filter){
        (0, $j0dXC.defineReadOnly)(this, "tag", tag);
        (0, $j0dXC.defineReadOnly)(this, "filter", filter);
        this._listeners = [];
    }
    addListener(listener, once) {
        this._listeners.push({
            listener: listener,
            once: once
        });
    }
    removeListener(listener) {
        let done = false;
        this._listeners = this._listeners.filter((item)=>{
            if (done || item.listener !== listener) return true;
            done = true;
            return false;
        });
    }
    removeAllListeners() {
        this._listeners = [];
    }
    listeners() {
        return this._listeners.map((i)=>i.listener);
    }
    listenerCount() {
        return this._listeners.length;
    }
    run(args) {
        const listenerCount = this.listenerCount();
        this._listeners = this._listeners.filter((item)=>{
            const argsCopy = args.slice();
            // Call the callback in the next event loop
            setTimeout(()=>{
                item.listener.apply(this, argsCopy);
            }, 0);
            // Reschedule it if it not "once"
            return !item.once;
        });
        return listenerCount;
    }
    prepareEvent(event) {}
    // Returns the array that will be applied to an emit
    getEmit(event) {
        return [
            event
        ];
    }
}
class $733b9283c8dc7dc3$var$ErrorRunningEvent extends $733b9283c8dc7dc3$var$RunningEvent {
    constructor(){
        super("error", null);
    }
}
// @TODO Fragment should inherit Wildcard? and just override getEmit?
//       or have a common abstract super class, with enough constructor
//       options to configure both.
// A Fragment Event will populate all the properties that Wildcard
// will, and additionally dereference the arguments when emitting
class $733b9283c8dc7dc3$var$FragmentRunningEvent extends $733b9283c8dc7dc3$var$RunningEvent {
    constructor(address, contractInterface, fragment, topics){
        const filter = {
            address: address
        };
        let topic = contractInterface.getEventTopic(fragment);
        if (topics) {
            if (topic !== topics[0]) $733b9283c8dc7dc3$var$logger.throwArgumentError("topic mismatch", "topics", topics);
            filter.topics = topics.slice();
        } else filter.topics = [
            topic
        ];
        super($733b9283c8dc7dc3$var$getEventTag(filter), filter);
        (0, $j0dXC.defineReadOnly)(this, "address", address);
        (0, $j0dXC.defineReadOnly)(this, "interface", contractInterface);
        (0, $j0dXC.defineReadOnly)(this, "fragment", fragment);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        event.event = this.fragment.name;
        event.eventSignature = this.fragment.format();
        event.decode = (data, topics)=>{
            return this.interface.decodeEventLog(this.fragment, data, topics);
        };
        try {
            event.args = this.interface.decodeEventLog(this.fragment, event.data, event.topics);
        } catch (error) {
            event.args = null;
            event.decodeError = error;
        }
    }
    getEmit(event) {
        const errors = (0, $b924P.checkResultErrors)(event.args);
        if (errors.length) throw errors[0].error;
        const args = (event.args || []).slice();
        args.push(event);
        return args;
    }
}
// A Wildcard Event will attempt to populate:
//  - event            The name of the event name
//  - eventSignature   The full signature of the event
//  - decode           A function to decode data and topics
//  - args             The decoded data and topics
class $733b9283c8dc7dc3$var$WildcardRunningEvent extends $733b9283c8dc7dc3$var$RunningEvent {
    constructor(address, contractInterface){
        super("*", {
            address: address
        });
        (0, $j0dXC.defineReadOnly)(this, "address", address);
        (0, $j0dXC.defineReadOnly)(this, "interface", contractInterface);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        try {
            const parsed = this.interface.parseLog(event);
            event.event = parsed.name;
            event.eventSignature = parsed.signature;
            event.decode = (data, topics)=>{
                return this.interface.decodeEventLog(parsed.eventFragment, data, topics);
            };
            event.args = parsed.args;
        } catch (error) {
        // No matching event
        }
    }
}
class $733b9283c8dc7dc3$export$304faa4fc17528db {
    constructor(addressOrName, contractInterface, signerOrProvider){
        // @TODO: Maybe still check the addressOrName looks like a valid address or name?
        //address = getAddress(address);
        (0, $j0dXC.defineReadOnly)(this, "interface", (0, $j0dXC.getStatic)(new.target, "getInterface")(contractInterface));
        if (signerOrProvider == null) {
            (0, $j0dXC.defineReadOnly)(this, "provider", null);
            (0, $j0dXC.defineReadOnly)(this, "signer", null);
        } else if ((0, $glz4p.Signer).isSigner(signerOrProvider)) {
            (0, $j0dXC.defineReadOnly)(this, "provider", signerOrProvider.provider || null);
            (0, $j0dXC.defineReadOnly)(this, "signer", signerOrProvider);
        } else if ((0, $lOWlX.Provider).isProvider(signerOrProvider)) {
            (0, $j0dXC.defineReadOnly)(this, "provider", signerOrProvider);
            (0, $j0dXC.defineReadOnly)(this, "signer", null);
        } else $733b9283c8dc7dc3$var$logger.throwArgumentError("invalid signer or provider", "signerOrProvider", signerOrProvider);
        (0, $j0dXC.defineReadOnly)(this, "callStatic", {});
        (0, $j0dXC.defineReadOnly)(this, "estimateGas", {});
        (0, $j0dXC.defineReadOnly)(this, "functions", {});
        (0, $j0dXC.defineReadOnly)(this, "populateTransaction", {});
        (0, $j0dXC.defineReadOnly)(this, "filters", {});
        {
            const uniqueFilters = {};
            Object.keys(this.interface.events).forEach((eventSignature)=>{
                const event = this.interface.events[eventSignature];
                (0, $j0dXC.defineReadOnly)(this.filters, eventSignature, (...args)=>{
                    return {
                        address: this.address,
                        topics: this.interface.encodeFilterTopics(event, args)
                    };
                });
                if (!uniqueFilters[event.name]) uniqueFilters[event.name] = [];
                uniqueFilters[event.name].push(eventSignature);
            });
            Object.keys(uniqueFilters).forEach((name)=>{
                const filters = uniqueFilters[name];
                if (filters.length === 1) (0, $j0dXC.defineReadOnly)(this.filters, name, this.filters[filters[0]]);
                else $733b9283c8dc7dc3$var$logger.warn(`Duplicate definition of ${name} (${filters.join(", ")})`);
            });
        }
        (0, $j0dXC.defineReadOnly)(this, "_runningEvents", {});
        (0, $j0dXC.defineReadOnly)(this, "_wrappedEmits", {});
        if (addressOrName == null) $733b9283c8dc7dc3$var$logger.throwArgumentError("invalid contract address or ENS name", "addressOrName", addressOrName);
        (0, $j0dXC.defineReadOnly)(this, "address", addressOrName);
        if (this.provider) (0, $j0dXC.defineReadOnly)(this, "resolvedAddress", $733b9283c8dc7dc3$var$resolveName(this.provider, addressOrName));
        else try {
            (0, $j0dXC.defineReadOnly)(this, "resolvedAddress", Promise.resolve((0, $ak7re.getAddress)(addressOrName)));
        } catch (error) {
            // Without a provider, we cannot use ENS names
            $733b9283c8dc7dc3$var$logger.throwError("provider is required to use ENS name as contract address", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "new Contract"
            });
        }
        // Swallow bad ENS names to prevent Unhandled Exceptions
        this.resolvedAddress.catch((e)=>{});
        const uniqueNames = {};
        const uniqueSignatures = {};
        Object.keys(this.interface.functions).forEach((signature)=>{
            const fragment = this.interface.functions[signature];
            // Check that the signature is unique; if not the ABI generation has
            // not been cleaned or may be incorrectly generated
            if (uniqueSignatures[signature]) {
                $733b9283c8dc7dc3$var$logger.warn(`Duplicate ABI entry for ${JSON.stringify(signature)}`);
                return;
            }
            uniqueSignatures[signature] = true;
            // Track unique names; we only expose bare named functions if they
            // are ambiguous
            {
                const name = fragment.name;
                if (!uniqueNames[`%${name}`]) uniqueNames[`%${name}`] = [];
                uniqueNames[`%${name}`].push(signature);
            }
            if (this[signature] == null) (0, $j0dXC.defineReadOnly)(this, signature, $733b9283c8dc7dc3$var$buildDefault(this, fragment, true));
            // We do not collapse simple calls on this bucket, which allows
            // frameworks to safely use this without introspection as well as
            // allows decoding error recovery.
            if (this.functions[signature] == null) (0, $j0dXC.defineReadOnly)(this.functions, signature, $733b9283c8dc7dc3$var$buildDefault(this, fragment, false));
            if (this.callStatic[signature] == null) (0, $j0dXC.defineReadOnly)(this.callStatic, signature, $733b9283c8dc7dc3$var$buildCall(this, fragment, true));
            if (this.populateTransaction[signature] == null) (0, $j0dXC.defineReadOnly)(this.populateTransaction, signature, $733b9283c8dc7dc3$var$buildPopulate(this, fragment));
            if (this.estimateGas[signature] == null) (0, $j0dXC.defineReadOnly)(this.estimateGas, signature, $733b9283c8dc7dc3$var$buildEstimate(this, fragment));
        });
        Object.keys(uniqueNames).forEach((name)=>{
            // Ambiguous names to not get attached as bare names
            const signatures = uniqueNames[name];
            if (signatures.length > 1) return;
            // Strip off the leading "%" used for prototype protection
            name = name.substring(1);
            const signature = signatures[0];
            // If overwriting a member property that is null, swallow the error
            try {
                if (this[name] == null) (0, $j0dXC.defineReadOnly)(this, name, this[signature]);
            } catch (e) {}
            if (this.functions[name] == null) (0, $j0dXC.defineReadOnly)(this.functions, name, this.functions[signature]);
            if (this.callStatic[name] == null) (0, $j0dXC.defineReadOnly)(this.callStatic, name, this.callStatic[signature]);
            if (this.populateTransaction[name] == null) (0, $j0dXC.defineReadOnly)(this.populateTransaction, name, this.populateTransaction[signature]);
            if (this.estimateGas[name] == null) (0, $j0dXC.defineReadOnly)(this.estimateGas, name, this.estimateGas[signature]);
        });
    }
    static getContractAddress(transaction) {
        return (0, $ak7re.getContractAddress)(transaction);
    }
    static getInterface(contractInterface) {
        if ((0, $iAVJ5.Interface).isInterface(contractInterface)) return contractInterface;
        return new (0, $iAVJ5.Interface)(contractInterface);
    }
    // @TODO: Allow timeout?
    deployed() {
        return this._deployed();
    }
    _deployed(blockTag) {
        if (!this._deployedPromise) {
            // If we were just deployed, we know the transaction we should occur in
            if (this.deployTransaction) this._deployedPromise = this.deployTransaction.wait().then(()=>{
                return this;
            });
            else // @TODO: Once we allow a timeout to be passed in, we will wait
            // up to that many blocks for getCode
            // Otherwise, poll for our code to be deployed
            this._deployedPromise = this.provider.getCode(this.address, blockTag).then((code)=>{
                if (code === "0x") $733b9283c8dc7dc3$var$logger.throwError("contract not deployed", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                    contractAddress: this.address,
                    operation: "getDeployed"
                });
                return this;
            });
        }
        return this._deployedPromise;
    }
    // @TODO:
    // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
    // @TODO:
    // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
    fallback(overrides) {
        if (!this.signer) $733b9283c8dc7dc3$var$logger.throwError("sending a transactions require a signer", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "sendTransaction(fallback)"
        });
        const tx = (0, $j0dXC.shallowCopy)(overrides || {});
        [
            "from",
            "to"
        ].forEach(function(key) {
            if (tx[key] == null) return;
            $733b9283c8dc7dc3$var$logger.throwError("cannot override " + key, (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        tx.to = this.resolvedAddress;
        return this.deployed().then(()=>{
            return this.signer.sendTransaction(tx);
        });
    }
    // Reconnect to a different signer or provider
    connect(signerOrProvider) {
        if (typeof signerOrProvider === "string") signerOrProvider = new (0, $glz4p.VoidSigner)(signerOrProvider, this.provider);
        const contract = new this.constructor(this.address, this.interface, signerOrProvider);
        if (this.deployTransaction) (0, $j0dXC.defineReadOnly)(contract, "deployTransaction", this.deployTransaction);
        return contract;
    }
    // Re-attach to a different on-chain instance of this contract
    attach(addressOrName) {
        return new this.constructor(addressOrName, this.interface, this.signer || this.provider);
    }
    static isIndexed(value) {
        return (0, $iAVJ5.Indexed).isIndexed(value);
    }
    _normalizeRunningEvent(runningEvent) {
        // Already have an instance of this event running; we can re-use it
        if (this._runningEvents[runningEvent.tag]) return this._runningEvents[runningEvent.tag];
        return runningEvent;
    }
    _getRunningEvent(eventName) {
        if (typeof eventName === "string") {
            // Listen for "error" events (if your contract has an error event, include
            // the full signature to bypass this special event keyword)
            if (eventName === "error") return this._normalizeRunningEvent(new $733b9283c8dc7dc3$var$ErrorRunningEvent());
            // Listen for any event that is registered
            if (eventName === "event") return this._normalizeRunningEvent(new $733b9283c8dc7dc3$var$RunningEvent("event", null));
            // Listen for any event
            if (eventName === "*") return this._normalizeRunningEvent(new $733b9283c8dc7dc3$var$WildcardRunningEvent(this.address, this.interface));
            // Get the event Fragment (throws if ambiguous/unknown event)
            const fragment = this.interface.getEvent(eventName);
            return this._normalizeRunningEvent(new $733b9283c8dc7dc3$var$FragmentRunningEvent(this.address, this.interface, fragment));
        }
        // We have topics to filter by...
        if (eventName.topics && eventName.topics.length > 0) {
            // Is it a known topichash? (throws if no matching topichash)
            try {
                const topic = eventName.topics[0];
                if (typeof topic !== "string") throw new Error("invalid topic"); // @TODO: May happen for anonymous events
                const fragment = this.interface.getEvent(topic);
                return this._normalizeRunningEvent(new $733b9283c8dc7dc3$var$FragmentRunningEvent(this.address, this.interface, fragment, eventName.topics));
            } catch (error) {}
            // Filter by the unknown topichash
            const filter = {
                address: this.address,
                topics: eventName.topics
            };
            return this._normalizeRunningEvent(new $733b9283c8dc7dc3$var$RunningEvent($733b9283c8dc7dc3$var$getEventTag(filter), filter));
        }
        return this._normalizeRunningEvent(new $733b9283c8dc7dc3$var$WildcardRunningEvent(this.address, this.interface));
    }
    _checkRunningEvents(runningEvent) {
        if (runningEvent.listenerCount() === 0) {
            delete this._runningEvents[runningEvent.tag];
            // If we have a poller for this, remove it
            const emit = this._wrappedEmits[runningEvent.tag];
            if (emit && runningEvent.filter) {
                this.provider.off(runningEvent.filter, emit);
                delete this._wrappedEmits[runningEvent.tag];
            }
        }
    }
    // Subclasses can override this to gracefully recover
    // from parse errors if they wish
    _wrapEvent(runningEvent, log, listener) {
        const event = (0, $j0dXC.deepCopy)(log);
        event.removeListener = ()=>{
            if (!listener) return;
            runningEvent.removeListener(listener);
            this._checkRunningEvents(runningEvent);
        };
        event.getBlock = ()=>{
            return this.provider.getBlock(log.blockHash);
        };
        event.getTransaction = ()=>{
            return this.provider.getTransaction(log.transactionHash);
        };
        event.getTransactionReceipt = ()=>{
            return this.provider.getTransactionReceipt(log.transactionHash);
        };
        // This may throw if the topics and data mismatch the signature
        runningEvent.prepareEvent(event);
        return event;
    }
    _addEventListener(runningEvent, listener, once) {
        if (!this.provider) $733b9283c8dc7dc3$var$logger.throwError("events require a provider or a signer with a provider", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "once"
        });
        runningEvent.addListener(listener, once);
        // Track this running event and its listeners (may already be there; but no hard in updating)
        this._runningEvents[runningEvent.tag] = runningEvent;
        // If we are not polling the provider, start polling
        if (!this._wrappedEmits[runningEvent.tag]) {
            const wrappedEmit = (log)=>{
                let event = this._wrapEvent(runningEvent, log, listener);
                // Try to emit the result for the parameterized event...
                if (event.decodeError == null) try {
                    const args = runningEvent.getEmit(event);
                    this.emit(runningEvent.filter, ...args);
                } catch (error) {
                    event.decodeError = error.error;
                }
                // Always emit "event" for fragment-base events
                if (runningEvent.filter != null) this.emit("event", event);
                // Emit "error" if there was an error
                if (event.decodeError != null) this.emit("error", event.decodeError, event);
            };
            this._wrappedEmits[runningEvent.tag] = wrappedEmit;
            // Special events, like "error" do not have a filter
            if (runningEvent.filter != null) this.provider.on(runningEvent.filter, wrappedEmit);
        }
    }
    queryFilter(event, fromBlockOrBlockhash, toBlock) {
        const runningEvent = this._getRunningEvent(event);
        const filter = (0, $j0dXC.shallowCopy)(runningEvent.filter);
        if (typeof fromBlockOrBlockhash === "string" && (0, $eBLyT.isHexString)(fromBlockOrBlockhash, 32)) {
            if (toBlock != null) $733b9283c8dc7dc3$var$logger.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", toBlock);
            filter.blockHash = fromBlockOrBlockhash;
        } else {
            filter.fromBlock = fromBlockOrBlockhash != null ? fromBlockOrBlockhash : 0;
            filter.toBlock = toBlock != null ? toBlock : "latest";
        }
        return this.provider.getLogs(filter).then((logs)=>{
            return logs.map((log)=>this._wrapEvent(runningEvent, log, null));
        });
    }
    on(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, false);
        return this;
    }
    once(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, true);
        return this;
    }
    emit(eventName, ...args) {
        if (!this.provider) return false;
        const runningEvent = this._getRunningEvent(eventName);
        const result = runningEvent.run(args) > 0;
        // May have drained all the "once" events; check for living events
        this._checkRunningEvents(runningEvent);
        return result;
    }
    listenerCount(eventName) {
        if (!this.provider) return 0;
        if (eventName == null) return Object.keys(this._runningEvents).reduce((accum, key)=>{
            return accum + this._runningEvents[key].listenerCount();
        }, 0);
        return this._getRunningEvent(eventName).listenerCount();
    }
    listeners(eventName) {
        if (!this.provider) return [];
        if (eventName == null) {
            const result = [];
            for(let tag in this._runningEvents)this._runningEvents[tag].listeners().forEach((listener)=>{
                result.push(listener);
            });
            return result;
        }
        return this._getRunningEvent(eventName).listeners();
    }
    removeAllListeners(eventName) {
        if (!this.provider) return this;
        if (eventName == null) {
            for(const tag in this._runningEvents){
                const runningEvent = this._runningEvents[tag];
                runningEvent.removeAllListeners();
                this._checkRunningEvents(runningEvent);
            }
            return this;
        }
        // Delete any listeners
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeAllListeners();
        this._checkRunningEvents(runningEvent);
        return this;
    }
    off(eventName, listener) {
        if (!this.provider) return this;
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeListener(listener);
        this._checkRunningEvents(runningEvent);
        return this;
    }
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
}
class $733b9283c8dc7dc3$export$8517d80acf00e19a extends $733b9283c8dc7dc3$export$304faa4fc17528db {
}
class $733b9283c8dc7dc3$export$505569a6bf584fd9 {
    constructor(contractInterface, bytecode, signer){
        let bytecodeHex = null;
        if (typeof bytecode === "string") bytecodeHex = bytecode;
        else if ((0, $eBLyT.isBytes)(bytecode)) bytecodeHex = (0, $eBLyT.hexlify)(bytecode);
        else if (bytecode && typeof bytecode.object === "string") // Allow the bytecode object from the Solidity compiler
        bytecodeHex = bytecode.object;
        else // Crash in the next verification step
        bytecodeHex = "!";
        // Make sure it is 0x prefixed
        if (bytecodeHex.substring(0, 2) !== "0x") bytecodeHex = "0x" + bytecodeHex;
        // Make sure the final result is valid bytecode
        if (!(0, $eBLyT.isHexString)(bytecodeHex) || bytecodeHex.length % 2) $733b9283c8dc7dc3$var$logger.throwArgumentError("invalid bytecode", "bytecode", bytecode);
        // If we have a signer, make sure it is valid
        if (signer && !(0, $glz4p.Signer).isSigner(signer)) $733b9283c8dc7dc3$var$logger.throwArgumentError("invalid signer", "signer", signer);
        (0, $j0dXC.defineReadOnly)(this, "bytecode", bytecodeHex);
        (0, $j0dXC.defineReadOnly)(this, "interface", (0, $j0dXC.getStatic)(new.target, "getInterface")(contractInterface));
        (0, $j0dXC.defineReadOnly)(this, "signer", signer || null);
    }
    // @TODO: Future; rename to populateTransaction?
    getDeployTransaction(...args) {
        let tx = {};
        // If we have 1 additional argument, we allow transaction overrides
        if (args.length === this.interface.deploy.inputs.length + 1 && typeof args[args.length - 1] === "object") {
            tx = (0, $j0dXC.shallowCopy)(args.pop());
            for(const key in tx){
                if (!$733b9283c8dc7dc3$var$allowedTransactionKeys[key]) throw new Error("unknown transaction override " + key);
            }
        }
        // Do not allow these to be overridden in a deployment transaction
        [
            "data",
            "from",
            "to"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            $733b9283c8dc7dc3$var$logger.throwError("cannot override " + key, (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        if (tx.value) {
            const value = (0, $20M69.BigNumber).from(tx.value);
            if (!value.isZero() && !this.interface.deploy.payable) $733b9283c8dc7dc3$var$logger.throwError("non-payable constructor cannot override value", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: tx.value
            });
        }
        // Make sure the call matches the constructor signature
        $733b9283c8dc7dc3$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
        // Set the data to the bytecode + the encoded constructor arguments
        tx.data = (0, $eBLyT.hexlify)((0, $eBLyT.concat)([
            this.bytecode,
            this.interface.encodeDeploy(args)
        ]));
        return tx;
    }
    deploy(...args) {
        return $733b9283c8dc7dc3$var$__awaiter(this, void 0, void 0, function*() {
            let overrides = {};
            // If 1 extra parameter was passed in, it contains overrides
            if (args.length === this.interface.deploy.inputs.length + 1) overrides = args.pop();
            // Make sure the call matches the constructor signature
            $733b9283c8dc7dc3$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
            // Resolve ENS names and promises in the arguments
            const params = yield $733b9283c8dc7dc3$var$resolveAddresses(this.signer, args, this.interface.deploy.inputs);
            params.push(overrides);
            // Get the deployment transaction (with optional overrides)
            const unsignedTx = this.getDeployTransaction(...params);
            // Send the deployment transaction
            const tx = yield this.signer.sendTransaction(unsignedTx);
            const address = (0, $j0dXC.getStatic)(this.constructor, "getContractAddress")(tx);
            const contract = (0, $j0dXC.getStatic)(this.constructor, "getContract")(address, this.interface, this.signer);
            // Add the modified wait that wraps events
            $733b9283c8dc7dc3$var$addContractWait(contract, tx);
            (0, $j0dXC.defineReadOnly)(contract, "deployTransaction", tx);
            return contract;
        });
    }
    attach(address) {
        return this.constructor.getContract(address, this.interface, this.signer);
    }
    connect(signer) {
        return new this.constructor(this.interface, this.bytecode, signer);
    }
    static fromSolidity(compilerOutput, signer) {
        if (compilerOutput == null) $733b9283c8dc7dc3$var$logger.throwError("missing compiler output", (0, $4NCF1.Logger).errors.MISSING_ARGUMENT, {
            argument: "compilerOutput"
        });
        if (typeof compilerOutput === "string") compilerOutput = JSON.parse(compilerOutput);
        const abi = compilerOutput.abi;
        let bytecode = null;
        if (compilerOutput.bytecode) bytecode = compilerOutput.bytecode;
        else if (compilerOutput.evm && compilerOutput.evm.bytecode) bytecode = compilerOutput.evm.bytecode;
        return new this(abi, bytecode, signer);
    }
    static getInterface(contractInterface) {
        return $733b9283c8dc7dc3$export$8517d80acf00e19a.getInterface(contractInterface);
    }
    static getContractAddress(tx) {
        return (0, $ak7re.getContractAddress)(tx);
    }
    static getContract(address, contractInterface, signer) {
        return new $733b9283c8dc7dc3$export$8517d80acf00e19a(address, contractInterface, signer);
    }
}

});
parcelRegister("b924P", function(module, exports) {

$parcel$export(module.exports, "checkResultErrors", function () { return $81d2256969620616$export$5546b9ec21157cc2; });
$parcel$export(module.exports, "Coder", function () { return $81d2256969620616$export$2c0c39526f8bad46; });
$parcel$export(module.exports, "Writer", function () { return $81d2256969620616$export$d7a960146e1a269e; });
$parcel$export(module.exports, "Reader", function () { return $81d2256969620616$export$2f7a2f0e90c07dc4; });

var $eBLyT = parcelRequire("eBLyT");

var $20M69 = parcelRequire("20M69");

var $j0dXC = parcelRequire("j0dXC");

var $4NCF1 = parcelRequire("4NCF1");

var $cWQrS = parcelRequire("cWQrS");
"use strict";
const $81d2256969620616$var$logger = new (0, $4NCF1.Logger)((0, $cWQrS.version));
function $81d2256969620616$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
class $81d2256969620616$export$2c0c39526f8bad46 {
    constructor(name, type, localName, dynamic){
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    _throwError(message, value) {
        $81d2256969620616$var$logger.throwArgumentError(message, this.localName, value);
    }
}
class $81d2256969620616$export$d7a960146e1a269e {
    constructor(wordSize){
        (0, $j0dXC.defineReadOnly)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    get data() {
        return (0, $eBLyT.hexConcat)(this._data);
    }
    get length() {
        return this._dataLength;
    }
    _writeData(data) {
        this._data.push(data);
        this._dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this._writeData((0, $eBLyT.concat)(writer._data));
    }
    // Arrayish items; padded on the right to wordSize
    writeBytes(value) {
        let bytes = (0, $eBLyT.arrayify)(value);
        const paddingOffset = bytes.length % this.wordSize;
        if (paddingOffset) bytes = (0, $eBLyT.concat)([
            bytes,
            this._padding.slice(paddingOffset)
        ]);
        return this._writeData(bytes);
    }
    _getValue(value) {
        let bytes = (0, $eBLyT.arrayify)((0, $20M69.BigNumber).from(value));
        if (bytes.length > this.wordSize) $81d2256969620616$var$logger.throwError("value out-of-bounds", (0, $4NCF1.Logger).errors.BUFFER_OVERRUN, {
            length: this.wordSize,
            offset: bytes.length
        });
        if (bytes.length % this.wordSize) bytes = (0, $eBLyT.concat)([
            this._padding.slice(bytes.length % this.wordSize),
            bytes
        ]);
        return bytes;
    }
    // BigNumberish items; padded on the left to wordSize
    writeValue(value) {
        return this._writeData(this._getValue(value));
    }
    writeUpdatableValue() {
        const offset = this._data.length;
        this._data.push(this._padding);
        this._dataLength += this.wordSize;
        return (value)=>{
            this._data[offset] = this._getValue(value);
        };
    }
}
class $81d2256969620616$export$2f7a2f0e90c07dc4 {
    constructor(data, wordSize, coerceFunc, allowLoose){
        (0, $j0dXC.defineReadOnly)(this, "_data", (0, $eBLyT.arrayify)(data));
        (0, $j0dXC.defineReadOnly)(this, "wordSize", wordSize || 32);
        (0, $j0dXC.defineReadOnly)(this, "_coerceFunc", coerceFunc);
        (0, $j0dXC.defineReadOnly)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    get data() {
        return (0, $eBLyT.hexlify)(this._data);
    }
    get consumed() {
        return this._offset;
    }
    // The default Coerce function
    static coerce(name, value) {
        let match = name.match("^u?int([0-9]+)$");
        if (match && parseInt(match[1]) <= 48) value = value.toNumber();
        return value;
    }
    coerce(name, value) {
        if (this._coerceFunc) return this._coerceFunc(name, value);
        return $81d2256969620616$export$2f7a2f0e90c07dc4.coerce(name, value);
    }
    _peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
        if (this._offset + alignedLength > this._data.length) {
            if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
            else $81d2256969620616$var$logger.throwError("data out-of-bounds", (0, $4NCF1.Logger).errors.BUFFER_OVERRUN, {
                length: this._data.length,
                offset: this._offset + alignedLength
            });
        }
        return this._data.slice(this._offset, this._offset + alignedLength);
    }
    subReader(offset) {
        return new $81d2256969620616$export$2f7a2f0e90c07dc4(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
    }
    readBytes(length, loose) {
        let bytes = this._peekBytes(0, length, !!loose);
        this._offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    readValue() {
        return (0, $20M69.BigNumber).from(this.readBytes(this.wordSize));
    }
}

});
parcelRegister("eBLyT", function(module, exports) {

$parcel$export(module.exports, "isBytesLike", function () { return $aa296a2e4f6a3937$export$9a14abb1a440cd5e; });
$parcel$export(module.exports, "isHexString", function () { return $aa296a2e4f6a3937$export$b02a40aff8e4ad18; });
$parcel$export(module.exports, "isBytes", function () { return $aa296a2e4f6a3937$export$c6fabfbfd097fc30; });
$parcel$export(module.exports, "arrayify", function () { return $aa296a2e4f6a3937$export$3131421a7d01b4fb; });
$parcel$export(module.exports, "concat", function () { return $aa296a2e4f6a3937$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "stripZeros", function () { return $aa296a2e4f6a3937$export$a8f4574d0e56446c; });
$parcel$export(module.exports, "zeroPad", function () { return $aa296a2e4f6a3937$export$3cdc770bf8b2ed3d; });
$parcel$export(module.exports, "hexlify", function () { return $aa296a2e4f6a3937$export$2b0d6b5fbe698c70; });
$parcel$export(module.exports, "hexDataLength", function () { return $aa296a2e4f6a3937$export$13882f896d3c0683; });
$parcel$export(module.exports, "hexDataSlice", function () { return $aa296a2e4f6a3937$export$15da666eba198c18; });
$parcel$export(module.exports, "hexConcat", function () { return $aa296a2e4f6a3937$export$6d4b99629b38754a; });
$parcel$export(module.exports, "hexValue", function () { return $aa296a2e4f6a3937$export$6916af760a341dd3; });
$parcel$export(module.exports, "hexStripZeros", function () { return $aa296a2e4f6a3937$export$967bc0082a978949; });
$parcel$export(module.exports, "hexZeroPad", function () { return $aa296a2e4f6a3937$export$e9c46a54370b47e8; });
$parcel$export(module.exports, "splitSignature", function () { return $aa296a2e4f6a3937$export$7fb170f1e457988f; });
$parcel$export(module.exports, "joinSignature", function () { return $aa296a2e4f6a3937$export$71bb9d78a59bbe25; });

var $4NCF1 = parcelRequire("4NCF1");

var $kaFDI = parcelRequire("kaFDI");
"use strict";
const $aa296a2e4f6a3937$var$logger = new (0, $4NCF1.Logger)((0, $kaFDI.version));
///////////////////////////////
function $aa296a2e4f6a3937$var$isHexable(value) {
    return !!value.toHexString;
}
function $aa296a2e4f6a3937$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $aa296a2e4f6a3937$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $aa296a2e4f6a3937$export$9a14abb1a440cd5e(value) {
    return $aa296a2e4f6a3937$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $aa296a2e4f6a3937$export$c6fabfbfd097fc30(value);
}
function $aa296a2e4f6a3937$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $aa296a2e4f6a3937$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$aa296a2e4f6a3937$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$aa296a2e4f6a3937$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $aa296a2e4f6a3937$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $aa296a2e4f6a3937$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $aa296a2e4f6a3937$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($aa296a2e4f6a3937$var$isHexable(value)) value = value.toHexString();
    if ($aa296a2e4f6a3937$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $aa296a2e4f6a3937$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $aa296a2e4f6a3937$var$addSlice(new Uint8Array(result));
    }
    if ($aa296a2e4f6a3937$export$c6fabfbfd097fc30(value)) return $aa296a2e4f6a3937$var$addSlice(new Uint8Array(value));
    return $aa296a2e4f6a3937$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $aa296a2e4f6a3937$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$aa296a2e4f6a3937$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $aa296a2e4f6a3937$var$addSlice(result);
}
function $aa296a2e4f6a3937$export$a8f4574d0e56446c(value) {
    let result = $aa296a2e4f6a3937$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $aa296a2e4f6a3937$export$3cdc770bf8b2ed3d(value, length) {
    value = $aa296a2e4f6a3937$export$3131421a7d01b4fb(value);
    if (value.length > length) $aa296a2e4f6a3937$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $aa296a2e4f6a3937$var$addSlice(result);
}
function $aa296a2e4f6a3937$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $aa296a2e4f6a3937$var$HexCharacters = "0123456789abcdef";
function $aa296a2e4f6a3937$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $aa296a2e4f6a3937$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $aa296a2e4f6a3937$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($aa296a2e4f6a3937$var$isHexable(value)) return value.toHexString();
    if ($aa296a2e4f6a3937$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $aa296a2e4f6a3937$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($aa296a2e4f6a3937$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $aa296a2e4f6a3937$var$HexCharacters[(v & 0xf0) >> 4] + $aa296a2e4f6a3937$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $aa296a2e4f6a3937$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $aa296a2e4f6a3937$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $aa296a2e4f6a3937$export$2b0d6b5fbe698c70(data);
    else if (!$aa296a2e4f6a3937$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $aa296a2e4f6a3937$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $aa296a2e4f6a3937$export$2b0d6b5fbe698c70(data);
    else if (!$aa296a2e4f6a3937$export$b02a40aff8e4ad18(data) || data.length % 2) $aa296a2e4f6a3937$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $aa296a2e4f6a3937$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $aa296a2e4f6a3937$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $aa296a2e4f6a3937$export$6916af760a341dd3(value) {
    const trimmed = $aa296a2e4f6a3937$export$967bc0082a978949($aa296a2e4f6a3937$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $aa296a2e4f6a3937$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $aa296a2e4f6a3937$export$2b0d6b5fbe698c70(value);
    if (!$aa296a2e4f6a3937$export$b02a40aff8e4ad18(value)) $aa296a2e4f6a3937$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $aa296a2e4f6a3937$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $aa296a2e4f6a3937$export$2b0d6b5fbe698c70(value);
    else if (!$aa296a2e4f6a3937$export$b02a40aff8e4ad18(value)) $aa296a2e4f6a3937$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $aa296a2e4f6a3937$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $aa296a2e4f6a3937$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($aa296a2e4f6a3937$export$9a14abb1a440cd5e(signature)) {
        let bytes = $aa296a2e4f6a3937$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $aa296a2e4f6a3937$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $aa296a2e4f6a3937$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $aa296a2e4f6a3937$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $aa296a2e4f6a3937$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $aa296a2e4f6a3937$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $aa296a2e4f6a3937$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $aa296a2e4f6a3937$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $aa296a2e4f6a3937$export$3cdc770bf8b2ed3d($aa296a2e4f6a3937$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $aa296a2e4f6a3937$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $aa296a2e4f6a3937$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $aa296a2e4f6a3937$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $aa296a2e4f6a3937$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $aa296a2e4f6a3937$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $aa296a2e4f6a3937$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$aa296a2e4f6a3937$export$b02a40aff8e4ad18(result.r)) $aa296a2e4f6a3937$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $aa296a2e4f6a3937$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$aa296a2e4f6a3937$export$b02a40aff8e4ad18(result.s)) $aa296a2e4f6a3937$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $aa296a2e4f6a3937$export$e9c46a54370b47e8(result.s, 32);
        const vs = $aa296a2e4f6a3937$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $aa296a2e4f6a3937$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $aa296a2e4f6a3937$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$aa296a2e4f6a3937$export$b02a40aff8e4ad18(result._vs)) $aa296a2e4f6a3937$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $aa296a2e4f6a3937$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $aa296a2e4f6a3937$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $aa296a2e4f6a3937$export$71bb9d78a59bbe25(signature) {
    signature = $aa296a2e4f6a3937$export$7fb170f1e457988f(signature);
    return $aa296a2e4f6a3937$export$2b0d6b5fbe698c70($aa296a2e4f6a3937$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}

});
parcelRegister("4NCF1", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $37e9ba37b1334de5$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "Logger", function () { return $37e9ba37b1334de5$export$efa9a398d6368992; });

var $cCioT = parcelRequire("cCioT");
"use strict";
let $37e9ba37b1334de5$var$_permanentCensorErrors = false;
let $37e9ba37b1334de5$var$_censorErrors = false;
const $37e9ba37b1334de5$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $37e9ba37b1334de5$var$_logLevel = $37e9ba37b1334de5$var$LogLevels["default"];
let $37e9ba37b1334de5$var$_globalLogger = null;
function $37e9ba37b1334de5$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $37e9ba37b1334de5$var$_normalizeError = $37e9ba37b1334de5$var$_checkNormalize();
var $37e9ba37b1334de5$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($37e9ba37b1334de5$export$243e62d78d3b544d || ($37e9ba37b1334de5$export$243e62d78d3b544d = {}));
var $37e9ba37b1334de5$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})($37e9ba37b1334de5$export$d4e71bc0b80dc0fb || ($37e9ba37b1334de5$export$d4e71bc0b80dc0fb = {}));
const $37e9ba37b1334de5$var$HEX = "0123456789abcdef";
class $37e9ba37b1334de5$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($37e9ba37b1334de5$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($37e9ba37b1334de5$var$_logLevel > $37e9ba37b1334de5$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($37e9ba37b1334de5$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($37e9ba37b1334de5$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($37e9ba37b1334de5$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($37e9ba37b1334de5$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $37e9ba37b1334de5$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $37e9ba37b1334de5$var$HEX[value[i] >> 4];
                        hex += $37e9ba37b1334de5$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $37e9ba37b1334de5$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $37e9ba37b1334de5$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $37e9ba37b1334de5$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $37e9ba37b1334de5$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $37e9ba37b1334de5$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $37e9ba37b1334de5$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $37e9ba37b1334de5$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $37e9ba37b1334de5$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $37e9ba37b1334de5$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($37e9ba37b1334de5$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $37e9ba37b1334de5$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $37e9ba37b1334de5$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $37e9ba37b1334de5$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $37e9ba37b1334de5$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $37e9ba37b1334de5$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $37e9ba37b1334de5$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $37e9ba37b1334de5$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $37e9ba37b1334de5$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $37e9ba37b1334de5$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$37e9ba37b1334de5$var$_globalLogger) $37e9ba37b1334de5$var$_globalLogger = new $37e9ba37b1334de5$export$efa9a398d6368992((0, $cCioT.version));
        return $37e9ba37b1334de5$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $37e9ba37b1334de5$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($37e9ba37b1334de5$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $37e9ba37b1334de5$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $37e9ba37b1334de5$var$_censorErrors = !!censorship;
        $37e9ba37b1334de5$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $37e9ba37b1334de5$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $37e9ba37b1334de5$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $37e9ba37b1334de5$var$_logLevel = level;
    }
    static from(version) {
        return new $37e9ba37b1334de5$export$efa9a398d6368992(version);
    }
}
$37e9ba37b1334de5$export$efa9a398d6368992.errors = $37e9ba37b1334de5$export$d4e71bc0b80dc0fb;
$37e9ba37b1334de5$export$efa9a398d6368992.levels = $37e9ba37b1334de5$export$243e62d78d3b544d;

});
parcelRegister("cCioT", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $92f74e977b568a97$export$83d89fbfd8236492; });
const $92f74e977b568a97$export$83d89fbfd8236492 = "logger/5.7.0";

});


parcelRegister("kaFDI", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $eaf50a976a7457f4$export$83d89fbfd8236492; });
const $eaf50a976a7457f4$export$83d89fbfd8236492 = "bytes/5.7.0";

});


parcelRegister("20M69", function(module, exports) {

$parcel$export(module.exports, "isBigNumberish", function () { return $1770e4238de89854$export$a3d0a7fa9b65683b; });
$parcel$export(module.exports, "BigNumber", function () { return $1770e4238de89854$export$d97aa349ed20696; });
$parcel$export(module.exports, "_base36To16", function () { return $1770e4238de89854$export$51e4a08295f7770f; });
$parcel$export(module.exports, "_base16To36", function () { return $1770e4238de89854$export$1293db5d29c264ff; });

var $cCgSA = parcelRequire("cCgSA");

var $eBLyT = parcelRequire("eBLyT");

var $4NCF1 = parcelRequire("4NCF1");

var $ccRSE = parcelRequire("ccRSE");
"use strict";
var $1770e4238de89854$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA))).BN;
const $1770e4238de89854$var$logger = new (0, $4NCF1.Logger)((0, $ccRSE.version));
const $1770e4238de89854$var$_constructorGuard = {};
const $1770e4238de89854$var$MAX_SAFE = 0x1fffffffffffff;
function $1770e4238de89854$export$a3d0a7fa9b65683b(value) {
    return value != null && ($1770e4238de89854$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $eBLyT.isHexString)(value) || typeof value === "bigint" || (0, $eBLyT.isBytes)(value));
}
// Only warn about passing 10 into radix once
let $1770e4238de89854$var$_warnedToStringRadix = false;
class $1770e4238de89854$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        if (constructorGuard !== $1770e4238de89854$var$_constructorGuard) $1770e4238de89854$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $1770e4238de89854$var$toBigNumber($1770e4238de89854$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $1770e4238de89854$var$toBigNumber($1770e4238de89854$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $1770e4238de89854$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $1770e4238de89854$var$toBigNumber($1770e4238de89854$var$toBN(this).add($1770e4238de89854$var$toBN(other)));
    }
    sub(other) {
        return $1770e4238de89854$var$toBigNumber($1770e4238de89854$var$toBN(this).sub($1770e4238de89854$var$toBN(other)));
    }
    div(other) {
        const o = $1770e4238de89854$export$d97aa349ed20696.from(other);
        if (o.isZero()) $1770e4238de89854$var$throwFault("division-by-zero", "div");
        return $1770e4238de89854$var$toBigNumber($1770e4238de89854$var$toBN(this).div($1770e4238de89854$var$toBN(other)));
    }
    mul(other) {
        return $1770e4238de89854$var$toBigNumber($1770e4238de89854$var$toBN(this).mul($1770e4238de89854$var$toBN(other)));
    }
    mod(other) {
        const value = $1770e4238de89854$var$toBN(other);
        if (value.isNeg()) $1770e4238de89854$var$throwFault("division-by-zero", "mod");
        return $1770e4238de89854$var$toBigNumber($1770e4238de89854$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $1770e4238de89854$var$toBN(other);
        if (value.isNeg()) $1770e4238de89854$var$throwFault("negative-power", "pow");
        return $1770e4238de89854$var$toBigNumber($1770e4238de89854$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $1770e4238de89854$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $1770e4238de89854$var$throwFault("unbound-bitwise-result", "and");
        return $1770e4238de89854$var$toBigNumber($1770e4238de89854$var$toBN(this).and(value));
    }
    or(other) {
        const value = $1770e4238de89854$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $1770e4238de89854$var$throwFault("unbound-bitwise-result", "or");
        return $1770e4238de89854$var$toBigNumber($1770e4238de89854$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $1770e4238de89854$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $1770e4238de89854$var$throwFault("unbound-bitwise-result", "xor");
        return $1770e4238de89854$var$toBigNumber($1770e4238de89854$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $1770e4238de89854$var$throwFault("negative-width", "mask");
        return $1770e4238de89854$var$toBigNumber($1770e4238de89854$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $1770e4238de89854$var$throwFault("negative-width", "shl");
        return $1770e4238de89854$var$toBigNumber($1770e4238de89854$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $1770e4238de89854$var$throwFault("negative-width", "shr");
        return $1770e4238de89854$var$toBigNumber($1770e4238de89854$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $1770e4238de89854$var$toBN(this).eq($1770e4238de89854$var$toBN(other));
    }
    lt(other) {
        return $1770e4238de89854$var$toBN(this).lt($1770e4238de89854$var$toBN(other));
    }
    lte(other) {
        return $1770e4238de89854$var$toBN(this).lte($1770e4238de89854$var$toBN(other));
    }
    gt(other) {
        return $1770e4238de89854$var$toBN(this).gt($1770e4238de89854$var$toBN(other));
    }
    gte(other) {
        return $1770e4238de89854$var$toBN(this).gte($1770e4238de89854$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $1770e4238de89854$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $1770e4238de89854$var$toBN(this).toNumber();
        } catch (error) {
            $1770e4238de89854$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $1770e4238de89854$var$logger.throwError("this platform does not support BigInt", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$1770e4238de89854$var$_warnedToStringRadix) {
                    $1770e4238de89854$var$_warnedToStringRadix = true;
                    $1770e4238de89854$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $1770e4238de89854$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $4NCF1.Logger).errors.UNEXPECTED_ARGUMENT, {});
            else $1770e4238de89854$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $4NCF1.Logger).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $1770e4238de89854$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $1770e4238de89854$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $1770e4238de89854$export$d97aa349ed20696($1770e4238de89854$var$_constructorGuard, $1770e4238de89854$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $1770e4238de89854$export$d97aa349ed20696($1770e4238de89854$var$_constructorGuard, $1770e4238de89854$var$toHex(new $1770e4238de89854$var$BN(value)));
            return $1770e4238de89854$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $1770e4238de89854$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $1770e4238de89854$var$MAX_SAFE || value <= -$1770e4238de89854$var$MAX_SAFE) $1770e4238de89854$var$throwFault("overflow", "BigNumber.from", value);
            return $1770e4238de89854$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $1770e4238de89854$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $eBLyT.isBytes)(anyValue)) return $1770e4238de89854$export$d97aa349ed20696.from((0, $eBLyT.hexlify)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $1770e4238de89854$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $eBLyT.isHexString)(hex) || hex[0] === "-" && (0, $eBLyT.isHexString)(hex.substring(1))) return $1770e4238de89854$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $1770e4238de89854$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $1770e4238de89854$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $1770e4238de89854$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $1770e4238de89854$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $1770e4238de89854$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $1770e4238de89854$var$toBigNumber(value) {
    return $1770e4238de89854$export$d97aa349ed20696.from($1770e4238de89854$var$toHex(value));
}
function $1770e4238de89854$var$toBN(value) {
    const hex = $1770e4238de89854$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $1770e4238de89854$var$BN("-" + hex.substring(3), 16);
    return new $1770e4238de89854$var$BN(hex.substring(2), 16);
}
function $1770e4238de89854$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $1770e4238de89854$var$logger.throwError(fault, (0, $4NCF1.Logger).errors.NUMERIC_FAULT, params);
}
function $1770e4238de89854$export$51e4a08295f7770f(value) {
    return new $1770e4238de89854$var$BN(value, 36).toString(16);
}
function $1770e4238de89854$export$1293db5d29c264ff(value) {
    return new $1770e4238de89854$var$BN(value, 16).toString(36);
}

});
parcelRegister("cCgSA", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("7ulbJ")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("ccRSE", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $8e30669093f8f6ce$export$83d89fbfd8236492; });
const $8e30669093f8f6ce$export$83d89fbfd8236492 = "bignumber/5.7.0";

});


parcelRegister("j0dXC", function(module, exports) {

$parcel$export(module.exports, "defineReadOnly", function () { return $dd58d8aea397c4c5$export$104236534534f9be; });
$parcel$export(module.exports, "getStatic", function () { return $dd58d8aea397c4c5$export$f695fbbf3cdaaf47; });
$parcel$export(module.exports, "resolveProperties", function () { return $dd58d8aea397c4c5$export$d503dd157d963b60; });
$parcel$export(module.exports, "checkProperties", function () { return $dd58d8aea397c4c5$export$ae5a316ba623b73a; });
$parcel$export(module.exports, "shallowCopy", function () { return $dd58d8aea397c4c5$export$9c13236873b118a5; });
$parcel$export(module.exports, "deepCopy", function () { return $dd58d8aea397c4c5$export$6c40052bed430212; });
$parcel$export(module.exports, "Description", function () { return $dd58d8aea397c4c5$export$393edc798c47379d; });

var $4NCF1 = parcelRequire("4NCF1");

var $fOSly = parcelRequire("fOSly");
"use strict";
var $dd58d8aea397c4c5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $dd58d8aea397c4c5$var$logger = new (0, $4NCF1.Logger)((0, $fOSly.version));
function $dd58d8aea397c4c5$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $dd58d8aea397c4c5$export$f695fbbf3cdaaf47(ctor, key) {
    for(let i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $dd58d8aea397c4c5$export$d503dd157d963b60(object) {
    return $dd58d8aea397c4c5$var$__awaiter(this, void 0, void 0, function*() {
        const promises = Object.keys(object).map((key)=>{
            const value = object[key];
            return Promise.resolve(value).then((v)=>({
                    key: key,
                    value: v
                }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result)=>{
            accum[result.key] = result.value;
            return accum;
        }, {});
    });
}
function $dd58d8aea397c4c5$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $dd58d8aea397c4c5$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach((key)=>{
        if (!properties[key]) $dd58d8aea397c4c5$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $dd58d8aea397c4c5$export$9c13236873b118a5(object) {
    const result = {};
    for(const key in object)result[key] = object[key];
    return result;
}
const $dd58d8aea397c4c5$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $dd58d8aea397c4c5$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $dd58d8aea397c4c5$var$opaque[typeof object]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        const keys = Object.keys(object);
        for(let i = 0; i < keys.length; i++){
            let value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!$dd58d8aea397c4c5$var$_isFrozen(value)) return false;
        }
        return true;
    }
    return $dd58d8aea397c4c5$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $dd58d8aea397c4c5$var$_deepCopy(object) {
    if ($dd58d8aea397c4c5$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map((item)=>$dd58d8aea397c4c5$export$6c40052bed430212(item)));
    if (typeof object === "object") {
        const result = {};
        for(const key in object){
            const value = object[key];
            if (value === undefined) continue;
            $dd58d8aea397c4c5$export$104236534534f9be(result, key, $dd58d8aea397c4c5$export$6c40052bed430212(value));
        }
        return result;
    }
    return $dd58d8aea397c4c5$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
function $dd58d8aea397c4c5$export$6c40052bed430212(object) {
    return $dd58d8aea397c4c5$var$_deepCopy(object);
}
class $dd58d8aea397c4c5$export$393edc798c47379d {
    constructor(info){
        for(const key in info)this[key] = $dd58d8aea397c4c5$export$6c40052bed430212(info[key]);
    }
}

});
parcelRegister("fOSly", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $b845ae9ebde7d82e$export$83d89fbfd8236492; });
const $b845ae9ebde7d82e$export$83d89fbfd8236492 = "properties/5.7.0";

});


parcelRegister("cWQrS", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $96d39600b24abf46$export$83d89fbfd8236492; });
const $96d39600b24abf46$export$83d89fbfd8236492 = "abi/5.7.0";

});


parcelRegister("iAVJ5", function(module, exports) {

$parcel$export(module.exports, "LogDescription", function () { return $d8985dfe0b32c51f$export$c2ab6499be98b3c5; });
$parcel$export(module.exports, "TransactionDescription", function () { return $d8985dfe0b32c51f$export$7a3223b0fadb690b; });
$parcel$export(module.exports, "Indexed", function () { return $d8985dfe0b32c51f$export$8ef99100a3c56f8c; });
$parcel$export(module.exports, "Interface", function () { return $d8985dfe0b32c51f$export$48cefb51a4e315b2; });

var $ak7re = parcelRequire("ak7re");

var $20M69 = parcelRequire("20M69");

var $eBLyT = parcelRequire("eBLyT");

var $6mINK = parcelRequire("6mINK");

var $bnbYM = parcelRequire("bnbYM");

var $j0dXC = parcelRequire("j0dXC");

var $6LFgl = parcelRequire("6LFgl");

var $b924P = parcelRequire("b924P");

var $f4mbX = parcelRequire("f4mbX");

var $4NCF1 = parcelRequire("4NCF1");

var $cWQrS = parcelRequire("cWQrS");
"use strict";
const $d8985dfe0b32c51f$var$logger = new (0, $4NCF1.Logger)((0, $cWQrS.version));
class $d8985dfe0b32c51f$export$c2ab6499be98b3c5 extends (0, $j0dXC.Description) {
}
class $d8985dfe0b32c51f$export$7a3223b0fadb690b extends (0, $j0dXC.Description) {
}
class $d8985dfe0b32c51f$export$cfba08fc0e40e2ab extends (0, $j0dXC.Description) {
}
class $d8985dfe0b32c51f$export$8ef99100a3c56f8c extends (0, $j0dXC.Description) {
    static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
}
const $d8985dfe0b32c51f$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: true
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ]
    }
};
function $d8985dfe0b32c51f$var$wrapAccessError(property, error) {
    const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
    wrap.error = error;
    return wrap;
}
class $d8985dfe0b32c51f$export$48cefb51a4e315b2 {
    constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, $j0dXC.defineReadOnly)(this, "fragments", abi.map((fragment)=>{
            return (0, $f4mbX.Fragment).from(fragment);
        }).filter((fragment)=>fragment != null));
        (0, $j0dXC.defineReadOnly)(this, "_abiCoder", (0, $j0dXC.getStatic)(new.target, "getAbiCoder")());
        (0, $j0dXC.defineReadOnly)(this, "functions", {});
        (0, $j0dXC.defineReadOnly)(this, "errors", {});
        (0, $j0dXC.defineReadOnly)(this, "events", {});
        (0, $j0dXC.defineReadOnly)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach((fragment)=>{
            let bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        $d8985dfe0b32c51f$var$logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $j0dXC.defineReadOnly)(this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.events;
                    break;
                case "error":
                    bucket = this.errors;
                    break;
                default:
                    return;
            }
            let signature = fragment.format();
            if (bucket[signature]) {
                $d8985dfe0b32c51f$var$logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $j0dXC.defineReadOnly)(this, "deploy", (0, $f4mbX.ConstructorFragment).from({
            payable: false,
            type: "constructor"
        }));
        (0, $j0dXC.defineReadOnly)(this, "_isInterface", true);
    }
    format(format) {
        if (!format) format = (0, $f4mbX.FormatTypes).full;
        if (format === (0, $f4mbX.FormatTypes).sighash) $d8985dfe0b32c51f$var$logger.throwArgumentError("interface does not support formatting sighash", "format", format);
        const abi = this.fragments.map((fragment)=>fragment.format(format));
        // We need to re-bundle the JSON fragments a bit
        if (format === (0, $f4mbX.FormatTypes).json) return JSON.stringify(abi.map((j)=>JSON.parse(j)));
        return abi;
    }
    // Sub-classes can override these to handle other blockchains
    static getAbiCoder() {
        return 0, $6LFgl.defaultAbiCoder;
    }
    static getAddress(address) {
        return (0, $ak7re.getAddress)(address);
    }
    static getSighash(fragment) {
        return (0, $eBLyT.hexDataSlice)((0, $6mINK.id)(fragment.format()), 0, 4);
    }
    static getEventTopic(eventFragment) {
        return (0, $6mINK.id)(eventFragment.format());
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getFunction(nameOrSignatureOrSighash) {
        if ((0, $eBLyT.isHexString)(nameOrSignatureOrSighash)) {
            for(const name in this.functions){
                if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
            }
            $d8985dfe0b32c51f$var$logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.functions).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $d8985dfe0b32c51f$var$logger.throwArgumentError("no matching function", "name", name);
            else if (matching.length > 1) $d8985dfe0b32c51f$var$logger.throwArgumentError("multiple matching functions", "name", name);
            return this.functions[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.functions[(0, $f4mbX.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $d8985dfe0b32c51f$var$logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    getEvent(nameOrSignatureOrTopic) {
        if ((0, $eBLyT.isHexString)(nameOrSignatureOrTopic)) {
            const topichash = nameOrSignatureOrTopic.toLowerCase();
            for(const name in this.events){
                if (topichash === this.getEventTopic(name)) return this.events[name];
            }
            $d8985dfe0b32c51f$var$logger.throwArgumentError("no matching event", "topichash", topichash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrTopic.indexOf("(") === -1) {
            const name = nameOrSignatureOrTopic.trim();
            const matching = Object.keys(this.events).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $d8985dfe0b32c51f$var$logger.throwArgumentError("no matching event", "name", name);
            else if (matching.length > 1) $d8985dfe0b32c51f$var$logger.throwArgumentError("multiple matching events", "name", name);
            return this.events[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.events[(0, $f4mbX.EventFragment).fromString(nameOrSignatureOrTopic).format()];
        if (!result) $d8985dfe0b32c51f$var$logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
        return result;
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getError(nameOrSignatureOrSighash) {
        if ((0, $eBLyT.isHexString)(nameOrSignatureOrSighash)) {
            const getSighash = (0, $j0dXC.getStatic)(this.constructor, "getSighash");
            for(const name in this.errors){
                const error = this.errors[name];
                if (nameOrSignatureOrSighash === getSighash(error)) return this.errors[name];
            }
            $d8985dfe0b32c51f$var$logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.errors).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $d8985dfe0b32c51f$var$logger.throwArgumentError("no matching error", "name", name);
            else if (matching.length > 1) $d8985dfe0b32c51f$var$logger.throwArgumentError("multiple matching errors", "name", name);
            return this.errors[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.errors[(0, $f4mbX.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $d8985dfe0b32c51f$var$logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Get the sighash (the bytes4 selector) used by Solidity to identify a function
    getSighash(fragment) {
        if (typeof fragment === "string") try {
            fragment = this.getFunction(fragment);
        } catch (error) {
            try {
                fragment = this.getError(fragment);
            } catch (_) {
                throw error;
            }
        }
        return (0, $j0dXC.getStatic)(this.constructor, "getSighash")(fragment);
    }
    // Get the topic (the bytes32 hash) used by Solidity to identify an event
    getEventTopic(eventFragment) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        return (0, $j0dXC.getStatic)(this.constructor, "getEventTopic")(eventFragment);
    }
    _decodeParams(params, data) {
        return this._abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this._abiCoder.encode(params, values);
    }
    encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        const bytes = (0, $eBLyT.arrayify)(data);
        if ((0, $eBLyT.hexlify)(bytes.slice(0, 4)) !== this.getSighash(fragment)) $d8985dfe0b32c51f$var$logger.throwArgumentError(`data signature does not match error ${fragment.name}.`, "data", (0, $eBLyT.hexlify)(bytes));
        return this._decodeParams(fragment.inputs, bytes.slice(4));
    }
    encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        return (0, $eBLyT.hexlify)((0, $eBLyT.concat)([
            this.getSighash(fragment),
            this._encodeParams(fragment.inputs, values || [])
        ]));
    }
    // Decode the data for a function call (e.g. tx.data)
    decodeFunctionData(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        const bytes = (0, $eBLyT.arrayify)(data);
        if ((0, $eBLyT.hexlify)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) $d8985dfe0b32c51f$var$logger.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", (0, $eBLyT.hexlify)(bytes));
        return this._decodeParams(functionFragment.inputs, bytes.slice(4));
    }
    // Encode the data for a function call (e.g. tx.data)
    encodeFunctionData(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $eBLyT.hexlify)((0, $eBLyT.concat)([
            this.getSighash(functionFragment),
            this._encodeParams(functionFragment.inputs, values || [])
        ]));
    }
    // Decode the result from a function call (e.g. from eth_call)
    decodeFunctionResult(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        let bytes = (0, $eBLyT.arrayify)(data);
        let reason = null;
        let message = "";
        let errorArgs = null;
        let errorName = null;
        let errorSignature = null;
        switch(bytes.length % this._abiCoder._getWordSize()){
            case 0:
                try {
                    return this._abiCoder.decode(functionFragment.outputs, bytes);
                } catch (error) {}
                break;
            case 4:
                {
                    const selector = (0, $eBLyT.hexlify)(bytes.slice(0, 4));
                    const builtin = $d8985dfe0b32c51f$var$BuiltinErrors[selector];
                    if (builtin) {
                        errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                        errorName = builtin.name;
                        errorSignature = builtin.signature;
                        if (builtin.reason) reason = errorArgs[0];
                        if (errorName === "Error") message = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(errorArgs[0])}`;
                        else if (errorName === "Panic") message = `; VM Exception while processing transaction: reverted with panic code ${errorArgs[0]}`;
                    } else try {
                        const error = this.getError(selector);
                        errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
                        errorName = error.name;
                        errorSignature = error.format();
                    } catch (error) {}
                    break;
                }
        }
        return $d8985dfe0b32c51f$var$logger.throwError("call revert exception" + message, (0, $4NCF1.Logger).errors.CALL_EXCEPTION, {
            method: functionFragment.format(),
            data: (0, $eBLyT.hexlify)(data),
            errorArgs: errorArgs,
            errorName: errorName,
            errorSignature: errorSignature,
            reason: reason
        });
    }
    // Encode the result for a function call (e.g. for eth_call)
    encodeFunctionResult(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $eBLyT.hexlify)(this._abiCoder.encode(functionFragment.outputs, values || []));
    }
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (values.length > eventFragment.inputs.length) $d8985dfe0b32c51f$var$logger.throwError("too many arguments for " + eventFragment.format(), (0, $4NCF1.Logger).errors.UNEXPECTED_ARGUMENT, {
            argument: "values",
            value: values
        });
        let topics = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $6mINK.id)(value);
            else if (param.type === "bytes") return (0, $bnbYM.keccak256)((0, $eBLyT.hexlify)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            if (param.type.match(/^u?int/)) value = (0, $20M69.BigNumber).from(value).toHexString();
            // Check addresses are valid
            if (param.type === "address") this._abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $eBLyT.hexZeroPad)((0, $eBLyT.hexlify)(value), 32);
        };
        values.forEach((value, index)=>{
            let param = eventFragment.inputs[index];
            if (!param.indexed) {
                if (value != null) $d8985dfe0b32c51f$var$logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") $d8985dfe0b32c51f$var$logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        if (values.length !== eventFragment.inputs.length) $d8985dfe0b32c51f$var$logger.throwArgumentError("event arguments/values mismatch", "values", values);
        eventFragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $6mINK.id)(value));
                else if (param.type === "bytes") topics.push((0, $bnbYM.keccak256)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this._abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this._abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(eventFragment, data, topics) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (topics != null && !eventFragment.anonymous) {
            let topicHash = this.getEventTopic(eventFragment);
            if (!(0, $eBLyT.isHexString)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) $d8985dfe0b32c51f$var$logger.throwError("fragment/topic mismatch", (0, $4NCF1.Logger).errors.INVALID_ARGUMENT, {
                argument: "topics[0]",
                expected: topicHash,
                value: topics[0]
            });
            topics = topics.slice(1);
        }
        let indexed = [];
        let nonIndexed = [];
        let dynamic = [];
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $f4mbX.ParamType).fromObject({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        let resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, $eBLyT.concat)(topics)) : null;
        let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
        let result = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (resultIndexed == null) result[index] = new $d8985dfe0b32c51f$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: null
                });
                else if (dynamic[index]) result[index] = new $d8985dfe0b32c51f$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: resultIndexed[indexedIndex++]
                });
                else try {
                    result[index] = resultIndexed[indexedIndex++];
                } catch (error) {
                    result[index] = error;
                }
            } else try {
                result[index] = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                result[index] = error;
            }
            // Add the keyword argument if named and safe
            if (param.name && result[param.name] == null) {
                const value = result[index];
                // Make error named values throw on access
                if (value instanceof Error) Object.defineProperty(result, param.name, {
                    enumerable: true,
                    get: ()=>{
                        throw $d8985dfe0b32c51f$var$wrapAccessError(`property ${JSON.stringify(param.name)}`, value);
                    }
                });
                else result[param.name] = value;
            }
        });
        // Make all error indexed values throw on access
        for(let i = 0; i < result.length; i++){
            const value = result[i];
            if (value instanceof Error) Object.defineProperty(result, i, {
                enumerable: true,
                get: ()=>{
                    throw $d8985dfe0b32c51f$var$wrapAccessError(`index ${i}`, value);
                }
            });
        }
        return Object.freeze(result);
    }
    // Given a transaction, find the matching function fragment (if any) and
    // determine all its properties and call parameters
    parseTransaction(tx) {
        let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $d8985dfe0b32c51f$export$7a3223b0fadb690b({
            args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
            functionFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
            value: (0, $20M69.BigNumber).from(tx.value || "0")
        });
    }
    // @TODO
    //parseCallResult(data: BytesLike): ??
    // Given an event log, find the matching event fragment (if any) and
    // determine all its properties and values
    parseLog(log) {
        let fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $d8985dfe0b32c51f$export$c2ab6499be98b3c5({
            eventFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            topic: this.getEventTopic(fragment),
            args: this.decodeEventLog(fragment, log.data, log.topics)
        });
    }
    parseError(data) {
        const hexData = (0, $eBLyT.hexlify)(data);
        let fragment = this.getError(hexData.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $d8985dfe0b32c51f$export$cfba08fc0e40e2ab({
            args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
            errorFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment)
        });
    }
    /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ static isInterface(value) {
        return !!(value && value._isInterface);
    }
}

});
parcelRegister("ak7re", function(module, exports) {

$parcel$export(module.exports, "getAddress", function () { return $78418ab8978870ec$export$88411125f012957a; });
$parcel$export(module.exports, "isAddress", function () { return $78418ab8978870ec$export$977e255126d763d6; });
$parcel$export(module.exports, "getIcapAddress", function () { return $78418ab8978870ec$export$962c4ddada9f668f; });
$parcel$export(module.exports, "getContractAddress", function () { return $78418ab8978870ec$export$b7fbffef12272e40; });
$parcel$export(module.exports, "getCreate2Address", function () { return $78418ab8978870ec$export$e0b22d96621f73a2; });

var $eBLyT = parcelRequire("eBLyT");

var $20M69 = parcelRequire("20M69");

var $bnbYM = parcelRequire("bnbYM");

var $esBpx = parcelRequire("esBpx");

var $4NCF1 = parcelRequire("4NCF1");

var $1kXkY = parcelRequire("1kXkY");
"use strict";
const $78418ab8978870ec$var$logger = new (0, $4NCF1.Logger)((0, $1kXkY.version));
function $78418ab8978870ec$var$getChecksumAddress(address) {
    if (!(0, $eBLyT.isHexString)(address, 20)) $78418ab8978870ec$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $eBLyT.arrayify)((0, $bnbYM.keccak256)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $78418ab8978870ec$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $78418ab8978870ec$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $78418ab8978870ec$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$78418ab8978870ec$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$78418ab8978870ec$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $78418ab8978870ec$var$safeDigits = Math.floor($78418ab8978870ec$var$log10($78418ab8978870ec$var$MAX_SAFE_INTEGER));
function $78418ab8978870ec$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $78418ab8978870ec$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $78418ab8978870ec$var$safeDigits){
        let block = expanded.substring(0, $78418ab8978870ec$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $78418ab8978870ec$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $78418ab8978870ec$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $78418ab8978870ec$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $78418ab8978870ec$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $78418ab8978870ec$var$ibanChecksum(address)) $78418ab8978870ec$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $20M69._base36To16)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $78418ab8978870ec$var$getChecksumAddress("0x" + result);
    } else $78418ab8978870ec$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $78418ab8978870ec$export$977e255126d763d6(address) {
    try {
        $78418ab8978870ec$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $78418ab8978870ec$export$962c4ddada9f668f(address) {
    let base36 = (0, $20M69._base16To36)($78418ab8978870ec$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $78418ab8978870ec$var$ibanChecksum("XE00" + base36) + base36;
}
function $78418ab8978870ec$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $78418ab8978870ec$export$88411125f012957a(transaction.from);
    } catch (error) {
        $78418ab8978870ec$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $eBLyT.stripZeros)((0, $eBLyT.arrayify)((0, $20M69.BigNumber).from(transaction.nonce).toHexString()));
    return $78418ab8978870ec$export$88411125f012957a((0, $eBLyT.hexDataSlice)((0, $bnbYM.keccak256)((0, $esBpx.encode)([
        from,
        nonce
    ])), 12));
}
function $78418ab8978870ec$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $eBLyT.hexDataLength)(salt) !== 32) $78418ab8978870ec$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $eBLyT.hexDataLength)(initCodeHash) !== 32) $78418ab8978870ec$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $78418ab8978870ec$export$88411125f012957a((0, $eBLyT.hexDataSlice)((0, $bnbYM.keccak256)((0, $eBLyT.concat)([
        "0xff",
        $78418ab8978870ec$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}

});
parcelRegister("bnbYM", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return $847b22887105a466$export$f8151fce47ad1c35; });

var $69MC1 = parcelRequire("69MC1");

var $eBLyT = parcelRequire("eBLyT");
"use strict";
function $847b22887105a466$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($69MC1))).keccak_256((0, $eBLyT.arrayify)(data));
}

});
parcelRegister("69MC1", function(module, exports) {

var $bNDrn = parcelRequire("bNDrn");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $bNDrn === "object" && $bNDrn.versions && $bNDrn.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

});


parcelRegister("esBpx", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $a870b33fe40bf01e$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $a870b33fe40bf01e$export$2f872c0f2117be69; });

var $eBLyT = parcelRequire("eBLyT");

var $4NCF1 = parcelRequire("4NCF1");

var $5cdJh = parcelRequire("5cdJh");
"use strict";
const $a870b33fe40bf01e$var$logger = new (0, $4NCF1.Logger)((0, $5cdJh.version));
function $a870b33fe40bf01e$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $a870b33fe40bf01e$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $a870b33fe40bf01e$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($a870b33fe40bf01e$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $a870b33fe40bf01e$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $eBLyT.isBytesLike)(object)) $a870b33fe40bf01e$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $eBLyT.arrayify)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $a870b33fe40bf01e$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $a870b33fe40bf01e$export$c564cdbbe6da493(object) {
    return (0, $eBLyT.hexlify)($a870b33fe40bf01e$var$_encode(object));
}
function $a870b33fe40bf01e$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $a870b33fe40bf01e$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $a870b33fe40bf01e$var$logger.throwError("child data too short", (0, $4NCF1.Logger).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $a870b33fe40bf01e$var$_decode(data, offset) {
    if (data.length === 0) $a870b33fe40bf01e$var$logger.throwError("data too short", (0, $4NCF1.Logger).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $a870b33fe40bf01e$var$logger.throwError("data short segment too short", (0, $4NCF1.Logger).errors.BUFFER_OVERRUN, {});
        const length = $a870b33fe40bf01e$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $a870b33fe40bf01e$var$logger.throwError("data long segment too short", (0, $4NCF1.Logger).errors.BUFFER_OVERRUN, {});
        return $a870b33fe40bf01e$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $a870b33fe40bf01e$var$logger.throwError("data array too short", (0, $4NCF1.Logger).errors.BUFFER_OVERRUN, {});
        return $a870b33fe40bf01e$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $a870b33fe40bf01e$var$logger.throwError("data array too short", (0, $4NCF1.Logger).errors.BUFFER_OVERRUN, {});
        const length = $a870b33fe40bf01e$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $a870b33fe40bf01e$var$logger.throwError("data array too short", (0, $4NCF1.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $eBLyT.hexlify)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $a870b33fe40bf01e$var$logger.throwError("data too short", (0, $4NCF1.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $eBLyT.hexlify)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $eBLyT.hexlify)(data[offset])
    };
}
function $a870b33fe40bf01e$export$2f872c0f2117be69(data) {
    const bytes = (0, $eBLyT.arrayify)(data);
    const decoded = $a870b33fe40bf01e$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $a870b33fe40bf01e$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}

});
parcelRegister("5cdJh", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $3c88b9154d5c4658$export$83d89fbfd8236492; });
const $3c88b9154d5c4658$export$83d89fbfd8236492 = "rlp/5.7.0";

});


parcelRegister("1kXkY", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $0f95afde5d4ee763$export$83d89fbfd8236492; });
const $0f95afde5d4ee763$export$83d89fbfd8236492 = "address/5.7.0";

});


parcelRegister("6mINK", function(module, exports) {

$parcel$export(module.exports, "id", function () { return $4a278cc0ff3142ad$export$d560c7e4a29451c2; });

var $bnbYM = parcelRequire("bnbYM");

var $5kral = parcelRequire("5kral");
function $4a278cc0ff3142ad$export$d560c7e4a29451c2(text) {
    return (0, $bnbYM.keccak256)((0, $5kral.toUtf8Bytes)(text));
}

});
parcelRegister("5kral", function(module, exports) {

$parcel$export(module.exports, "UnicodeNormalizationForm", function () { return $3e13e4929703aec7$export$c6986442964129f5; });
$parcel$export(module.exports, "Utf8ErrorReason", function () { return $3e13e4929703aec7$export$c285fa6ac15ff6a6; });
$parcel$export(module.exports, "Utf8ErrorFuncs", function () { return $3e13e4929703aec7$export$c6e2180c5bb5bc05; });
$parcel$export(module.exports, "toUtf8Bytes", function () { return $3e13e4929703aec7$export$8feeb310b4b4752f; });
$parcel$export(module.exports, "_toEscapedUtf8String", function () { return $3e13e4929703aec7$export$a7a0ec15960b9055; });
$parcel$export(module.exports, "_toUtf8String", function () { return $3e13e4929703aec7$export$232e1dab03132235; });
$parcel$export(module.exports, "toUtf8String", function () { return $3e13e4929703aec7$export$7643a1dc2c38d5eb; });
$parcel$export(module.exports, "toUtf8CodePoints", function () { return $3e13e4929703aec7$export$ae470a36a31b28c2; });

var $eBLyT = parcelRequire("eBLyT");

var $4NCF1 = parcelRequire("4NCF1");

var $hAooF = parcelRequire("hAooF");
"use strict";
const $3e13e4929703aec7$var$logger = new (0, $4NCF1.Logger)((0, $hAooF.version));
var $3e13e4929703aec7$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($3e13e4929703aec7$export$c6986442964129f5 || ($3e13e4929703aec7$export$c6986442964129f5 = {}));
var $3e13e4929703aec7$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($3e13e4929703aec7$export$c285fa6ac15ff6a6 || ($3e13e4929703aec7$export$c285fa6ac15ff6a6 = {}));
function $3e13e4929703aec7$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $3e13e4929703aec7$var$logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $3e13e4929703aec7$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $3e13e4929703aec7$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $3e13e4929703aec7$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $3e13e4929703aec7$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $3e13e4929703aec7$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $3e13e4929703aec7$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $3e13e4929703aec7$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $3e13e4929703aec7$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $3e13e4929703aec7$var$errorFunc,
    ignore: $3e13e4929703aec7$var$ignoreFunc,
    replace: $3e13e4929703aec7$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $3e13e4929703aec7$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $3e13e4929703aec7$export$c6e2180c5bb5bc05.error;
    bytes = (0, $eBLyT.arrayify)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($3e13e4929703aec7$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($3e13e4929703aec7$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($3e13e4929703aec7$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($3e13e4929703aec7$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($3e13e4929703aec7$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($3e13e4929703aec7$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($3e13e4929703aec7$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $3e13e4929703aec7$export$8feeb310b4b4752f(str, form = $3e13e4929703aec7$export$c6986442964129f5.current) {
    if (form != $3e13e4929703aec7$export$c6986442964129f5.current) {
        $3e13e4929703aec7$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $eBLyT.arrayify)(result);
}
function $3e13e4929703aec7$var$escapeChar(value) {
    const hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $3e13e4929703aec7$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $3e13e4929703aec7$var$getUtf8CodePoints(bytes, onError).map((codePoint)=>{
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $3e13e4929703aec7$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $3e13e4929703aec7$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $3e13e4929703aec7$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $3e13e4929703aec7$export$232e1dab03132235(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $3e13e4929703aec7$export$7643a1dc2c38d5eb(bytes, onError) {
    return $3e13e4929703aec7$export$232e1dab03132235($3e13e4929703aec7$var$getUtf8CodePoints(bytes, onError));
}
function $3e13e4929703aec7$export$ae470a36a31b28c2(str, form = $3e13e4929703aec7$export$c6986442964129f5.current) {
    return $3e13e4929703aec7$var$getUtf8CodePoints($3e13e4929703aec7$export$8feeb310b4b4752f(str, form));
}

});
parcelRegister("hAooF", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $ccd8b92bdd2ea556$export$83d89fbfd8236492; });
const $ccd8b92bdd2ea556$export$83d89fbfd8236492 = "strings/5.7.0";

});



parcelRegister("6LFgl", function(module, exports) {

$parcel$export(module.exports, "AbiCoder", function () { return $4ed723c783221daf$export$fe041e1a83d3efc6; });
$parcel$export(module.exports, "defaultAbiCoder", function () { return $4ed723c783221daf$export$51d1cfcdb913adff; });

var $eBLyT = parcelRequire("eBLyT");

var $j0dXC = parcelRequire("j0dXC");

var $4NCF1 = parcelRequire("4NCF1");

var $cWQrS = parcelRequire("cWQrS");

var $b924P = parcelRequire("b924P");

var $3EDQD = parcelRequire("3EDQD");

var $kZOrQ = parcelRequire("kZOrQ");

var $9Ym7z = parcelRequire("9Ym7z");

var $bIBT2 = parcelRequire("bIBT2");

var $744CI = parcelRequire("744CI");

var $gNOF5 = parcelRequire("gNOF5");

var $jlEnc = parcelRequire("jlEnc");

var $jzBDG = parcelRequire("jzBDG");

var $b8KIL = parcelRequire("b8KIL");

var $f4mbX = parcelRequire("f4mbX");
"use strict";
const $4ed723c783221daf$var$logger = new (0, $4NCF1.Logger)((0, $cWQrS.version));
const $4ed723c783221daf$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $4ed723c783221daf$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class $4ed723c783221daf$export$fe041e1a83d3efc6 {
    constructor(coerceFunc){
        (0, $j0dXC.defineReadOnly)(this, "coerceFunc", coerceFunc || null);
    }
    _getCoder(param) {
        switch(param.baseType){
            case "address":
                return new (0, $3EDQD.AddressCoder)(param.name);
            case "bool":
                return new (0, $9Ym7z.BooleanCoder)(param.name);
            case "string":
                return new (0, $jzBDG.StringCoder)(param.name);
            case "bytes":
                return new (0, $bIBT2.BytesCoder)(param.name);
            case "array":
                return new (0, $kZOrQ.ArrayCoder)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
            case "tuple":
                return new (0, $b8KIL.TupleCoder)((param.components || []).map((component)=>{
                    return this._getCoder(component);
                }), param.name);
            case "":
                return new (0, $gNOF5.NullCoder)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($4ed723c783221daf$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            if (size === 0 || size > 256 || size % 8 !== 0) $4ed723c783221daf$var$logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
            return new (0, $jlEnc.NumberCoder)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($4ed723c783221daf$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            if (size === 0 || size > 32) $4ed723c783221daf$var$logger.throwArgumentError("invalid bytes length", "param", param);
            return new (0, $744CI.FixedBytesCoder)(size, param.name);
        }
        return $4ed723c783221daf$var$logger.throwArgumentError("invalid type", "type", param.type);
    }
    _getWordSize() {
        return 32;
    }
    _getReader(data, allowLoose) {
        return new (0, $b924P.Reader)(data, this._getWordSize(), this.coerceFunc, allowLoose);
    }
    _getWriter() {
        return new (0, $b924P.Writer)(this._getWordSize());
    }
    getDefaultValue(types) {
        const coders = types.map((type)=>this._getCoder((0, $f4mbX.ParamType).from(type)));
        const coder = new (0, $b8KIL.TupleCoder)(coders, "_");
        return coder.defaultValue();
    }
    encode(types, values) {
        if (types.length !== values.length) $4ed723c783221daf$var$logger.throwError("types/values length mismatch", (0, $4NCF1.Logger).errors.INVALID_ARGUMENT, {
            count: {
                types: types.length,
                values: values.length
            },
            value: {
                types: types,
                values: values
            }
        });
        const coders = types.map((type)=>this._getCoder((0, $f4mbX.ParamType).from(type)));
        const coder = new (0, $b8KIL.TupleCoder)(coders, "_");
        const writer = this._getWriter();
        coder.encode(writer, values);
        return writer.data;
    }
    decode(types, data, loose) {
        const coders = types.map((type)=>this._getCoder((0, $f4mbX.ParamType).from(type)));
        const coder = new (0, $b8KIL.TupleCoder)(coders, "_");
        return coder.decode(this._getReader((0, $eBLyT.arrayify)(data), loose));
    }
}
const $4ed723c783221daf$export$51d1cfcdb913adff = new $4ed723c783221daf$export$fe041e1a83d3efc6();

});
parcelRegister("3EDQD", function(module, exports) {

$parcel$export(module.exports, "AddressCoder", function () { return $2a940478e07ff5dc$export$59dbbded7775bfe7; });

var $ak7re = parcelRequire("ak7re");

var $eBLyT = parcelRequire("eBLyT");

var $b924P = parcelRequire("b924P");
"use strict";
class $2a940478e07ff5dc$export$59dbbded7775bfe7 extends (0, $b924P.Coder) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, value) {
        try {
            value = (0, $ak7re.getAddress)(value);
        } catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $ak7re.getAddress)((0, $eBLyT.hexZeroPad)(reader.readValue().toHexString(), 20));
    }
}

});

parcelRegister("kZOrQ", function(module, exports) {

$parcel$export(module.exports, "pack", function () { return $f490a31c03a9ea1b$export$2a703dbb0cb35339; });
$parcel$export(module.exports, "unpack", function () { return $f490a31c03a9ea1b$export$417857010dc9287f; });
$parcel$export(module.exports, "ArrayCoder", function () { return $f490a31c03a9ea1b$export$88bc419d2df11f54; });

var $4NCF1 = parcelRequire("4NCF1");

var $cWQrS = parcelRequire("cWQrS");

var $b924P = parcelRequire("b924P");

var $9dkBu = parcelRequire("9dkBu");
"use strict";
const $f490a31c03a9ea1b$var$logger = new (0, $4NCF1.Logger)((0, $cWQrS.version));
function $f490a31c03a9ea1b$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            if (!name) $f490a31c03a9ea1b$var$logger.throwError("cannot encode object for signature with missing names", (0, $4NCF1.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) $f490a31c03a9ea1b$var$logger.throwError("cannot encode object for signature with duplicate names", (0, $4NCF1.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else $f490a31c03a9ea1b$var$logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) $f490a31c03a9ea1b$var$logger.throwArgumentError("types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $b924P.Writer)(writer.wordSize);
    let dynamicWriter = new (0, $b924P.Writer)(writer.wordSize);
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $f490a31c03a9ea1b$export$417857010dc9287f(reader, coders) {
    let values = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readValue();
            let offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, $4NCF1.Logger).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, $4NCF1.Logger).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    const uniqueNames = coders.reduce((accum, coder)=>{
        const name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach((coder, index)=>{
        let name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        const value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
        else values[name] = value;
    });
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
    }
    return Object.freeze(values);
}
class $f490a31c03a9ea1b$export$88bc419d2df11f54 extends (0, $b924P.Coder) {
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        this.coder = coder;
        this.length = length;
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, value) {
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        $f490a31c03a9ea1b$var$logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $f490a31c03a9ea1b$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readValue().toNumber();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            if (count * 32 > reader._data.length) $f490a31c03a9ea1b$var$logger.throwError("insufficient data length", (0, $4NCF1.Logger).errors.BUFFER_OVERRUN, {
                length: reader._data.length,
                count: count
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $9dkBu.AnonymousCoder)(this.coder));
        return reader.coerce(this.name, $f490a31c03a9ea1b$export$417857010dc9287f(reader, coders));
    }
}

});
parcelRegister("9dkBu", function(module, exports) {

$parcel$export(module.exports, "AnonymousCoder", function () { return $6b554f6b13ef915b$export$87c41d1139a03fa2; });

var $b924P = parcelRequire("b924P");
"use strict";
class $6b554f6b13ef915b$export$87c41d1139a03fa2 extends (0, $b924P.Coder) {
    constructor(coder){
        super(coder.name, coder.type, undefined, coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}

});


parcelRegister("9Ym7z", function(module, exports) {

$parcel$export(module.exports, "BooleanCoder", function () { return $742ae074f6920f6c$export$fe9118d6c093150c; });

var $b924P = parcelRequire("b924P");
"use strict";
class $742ae074f6920f6c$export$fe9118d6c093150c extends (0, $b924P.Coder) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
}

});

parcelRegister("bIBT2", function(module, exports) {

$parcel$export(module.exports, "DynamicBytesCoder", function () { return $8881314c5fc86ad7$export$db9eadd8df12ad2e; });
$parcel$export(module.exports, "BytesCoder", function () { return $8881314c5fc86ad7$export$e5823e9574df18d2; });

var $eBLyT = parcelRequire("eBLyT");

var $b924P = parcelRequire("b924P");
"use strict";
class $8881314c5fc86ad7$export$db9eadd8df12ad2e extends (0, $b924P.Coder) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $eBLyT.arrayify)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readValue().toNumber(), true);
    }
}
class $8881314c5fc86ad7$export$e5823e9574df18d2 extends $8881314c5fc86ad7$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $eBLyT.hexlify)(super.decode(reader)));
    }
}

});

parcelRegister("744CI", function(module, exports) {

$parcel$export(module.exports, "FixedBytesCoder", function () { return $524c7e40eda162d4$export$7dec9db68e6bcf5a; });

var $eBLyT = parcelRequire("eBLyT");

var $b924P = parcelRequire("b924P");
"use strict";
class $524c7e40eda162d4$export$7dec9db68e6bcf5a extends (0, $b924P.Coder) {
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        this.size = size;
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, value) {
        let data = (0, $eBLyT.arrayify)(value);
        if (data.length !== this.size) this._throwError("incorrect data length", value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $eBLyT.hexlify)(reader.readBytes(this.size)));
    }
}

});

parcelRegister("gNOF5", function(module, exports) {

$parcel$export(module.exports, "NullCoder", function () { return $c3b8854beb430d7e$export$70982cadf2d6b4ec; });

var $b924P = parcelRequire("b924P");
"use strict";
class $c3b8854beb430d7e$export$70982cadf2d6b4ec extends (0, $b924P.Coder) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes([]);
    }
    decode(reader) {
        reader.readBytes(0);
        return reader.coerce(this.name, null);
    }
}

});

parcelRegister("jlEnc", function(module, exports) {

$parcel$export(module.exports, "NumberCoder", function () { return $e15f4bc43d0c6d8d$export$b934dc8cfe13938c; });

var $20M69 = parcelRequire("20M69");

var $M3r56 = parcelRequire("M3r56");

var $b924P = parcelRequire("b924P");
"use strict";
class $e15f4bc43d0c6d8d$export$b934dc8cfe13938c extends (0, $b924P.Coder) {
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        this.size = size;
        this.signed = signed;
    }
    defaultValue() {
        return 0;
    }
    encode(writer, value) {
        let v = (0, $20M69.BigNumber).from(value);
        // Check bounds are safe for encoding
        let maxUintValue = (0, $M3r56.MaxUint256).mask(writer.wordSize * 8);
        if (this.signed) {
            let bounds = maxUintValue.mask(this.size * 8 - 1);
            if (v.gt(bounds) || v.lt(bounds.add((0, $M3r56.One)).mul((0, $M3r56.NegativeOne)))) this._throwError("value out-of-bounds", value);
        } else if (v.lt((0, $M3r56.Zero)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
        v = v.toTwos(this.size * 8).mask(this.size * 8);
        if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
        return writer.writeValue(v);
    }
    decode(reader) {
        let value = reader.readValue().mask(this.size * 8);
        if (this.signed) value = value.fromTwos(this.size * 8);
        return reader.coerce(this.name, value);
    }
}

});
parcelRegister("M3r56", function(module, exports) {

$parcel$export(module.exports, "NegativeOne", function () { return $090726162c000429$export$c83ef0909a6ddeec; });
$parcel$export(module.exports, "Zero", function () { return $090726162c000429$export$aaef8a3eae948f03; });
$parcel$export(module.exports, "One", function () { return $090726162c000429$export$9aa05a5866350bcf; });
$parcel$export(module.exports, "Two", function () { return $090726162c000429$export$9276dd97bf62cc8d; });
$parcel$export(module.exports, "WeiPerEther", function () { return $090726162c000429$export$c8db55bd7405209e; });
$parcel$export(module.exports, "MaxUint256", function () { return $090726162c000429$export$1b53890de5aabdd0; });
$parcel$export(module.exports, "MinInt256", function () { return $090726162c000429$export$963c9b9317b80aaf; });
$parcel$export(module.exports, "MaxInt256", function () { return $090726162c000429$export$6f8dbb07ebe6d738; });

var $20M69 = parcelRequire("20M69");
const $090726162c000429$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $20M69.BigNumber).from(-1);
const $090726162c000429$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $20M69.BigNumber).from(0);
const $090726162c000429$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $20M69.BigNumber).from(1);
const $090726162c000429$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $20M69.BigNumber).from(2);
const $090726162c000429$export$c8db55bd7405209e = /*#__PURE__*/ (0, $20M69.BigNumber).from("1000000000000000000");
const $090726162c000429$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $20M69.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $090726162c000429$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $20M69.BigNumber).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const $090726162c000429$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $20M69.BigNumber).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");

});


parcelRegister("jzBDG", function(module, exports) {

$parcel$export(module.exports, "StringCoder", function () { return $e3fe7b8a5313141b$export$2d1b854518731426; });

var $5kral = parcelRequire("5kral");

var $bIBT2 = parcelRequire("bIBT2");
"use strict";
class $e3fe7b8a5313141b$export$2d1b854518731426 extends (0, $bIBT2.DynamicBytesCoder) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, value) {
        return super.encode(writer, (0, $5kral.toUtf8Bytes)(value));
    }
    decode(reader) {
        return (0, $5kral.toUtf8String)(super.decode(reader));
    }
}

});

parcelRegister("b8KIL", function(module, exports) {

$parcel$export(module.exports, "TupleCoder", function () { return $81c4aee750f3026e$export$e9fceba8f110fea6; });

var $b924P = parcelRequire("b924P");

var $kZOrQ = parcelRequire("kZOrQ");
"use strict";
class $81c4aee750f3026e$export$e9fceba8f110fea6 extends (0, $b924P.Coder) {
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        this.coders = coders;
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, value) {
        return (0, $kZOrQ.pack)(writer, this.coders, value);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $kZOrQ.unpack)(reader, this.coders));
    }
}

});

parcelRegister("f4mbX", function(module, exports) {

$parcel$export(module.exports, "FormatTypes", function () { return $af887190705af914$export$f010f239efc4d445; });
$parcel$export(module.exports, "ParamType", function () { return $af887190705af914$export$426dc07f493a4c47; });
$parcel$export(module.exports, "Fragment", function () { return $af887190705af914$export$ffb0004e005737fa; });
$parcel$export(module.exports, "FunctionFragment", function () { return $af887190705af914$export$8d576c928b93668f; });
$parcel$export(module.exports, "EventFragment", function () { return $af887190705af914$export$958548f08bac2833; });
$parcel$export(module.exports, "ConstructorFragment", function () { return $af887190705af914$export$3ac5c9504f801ea4; });
$parcel$export(module.exports, "ErrorFragment", function () { return $af887190705af914$export$2c42c6d543aa9b59; });

var $20M69 = parcelRequire("20M69");

var $j0dXC = parcelRequire("j0dXC");

var $4NCF1 = parcelRequire("4NCF1");

var $cWQrS = parcelRequire("cWQrS");
"use strict";
const $af887190705af914$var$logger = new (0, $4NCF1.Logger)((0, $cWQrS.version));
const $af887190705af914$var$_constructorGuard = {};
let $af887190705af914$var$ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
let $af887190705af914$var$ModifiersNest = {
    calldata: true,
    memory: true
};
function $af887190705af914$var$checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if ($af887190705af914$var$ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if ($af887190705af914$var$ModifiersNest[name]) return true;
    }
    if ($af887190705af914$var$ModifiersBytes[name] || name === "payable") $af887190705af914$var$logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function $af887190705af914$var$parseParamType(param, allowIndexed) {
    let originalParam = param;
    function throwError(i) {
        $af887190705af914$var$logger.throwArgumentError(`unexpected character at position ${i}`, "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        let node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    }
    let parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    let node = parent;
    for(let i = 0; i < param.length; i++){
        let c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $af887190705af914$var$verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($af887190705af914$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $af887190705af914$var$verifyType(node.type);
                let child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($af887190705af914$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $af887190705af914$var$verifyType(node.type);
                let sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $af887190705af914$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if ($af887190705af914$var$checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) $af887190705af914$var$logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if ($af887190705af914$var$checkModifier(node.type, node.name)) node.name = "";
    parent.type = $af887190705af914$var$verifyType(parent.type);
    return parent;
}
function $af887190705af914$var$populate(object, params) {
    for(let key in params)(0, $j0dXC.defineReadOnly)(object, key, params[key]);
}
const $af887190705af914$export$f010f239efc4d445 = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
const $af887190705af914$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class $af887190705af914$export$426dc07f493a4c47 {
    constructor(constructorGuard, params){
        if (constructorGuard !== $af887190705af914$var$_constructorGuard) $af887190705af914$var$logger.throwError("use fromString", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        $af887190705af914$var$populate(this, params);
        let match = this.type.match($af887190705af914$var$paramTypeArray);
        if (match) $af887190705af914$var$populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: $af887190705af914$export$426dc07f493a4c47.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else $af887190705af914$var$populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
    // Format the parameter fragment
    //   - sighash: "(uint256,address)"
    //   - minimal: "tuple(uint256,address) indexed"
    //   - full:    "tuple(uint256 foo, address bar) indexed baz"
    format(format) {
        if (!format) format = $af887190705af914$export$f010f239efc4d445.sighash;
        if (!$af887190705af914$export$f010f239efc4d445[format]) $af887190705af914$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $af887190705af914$export$f010f239efc4d445.json) {
            let result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: this.name || undefined
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.components) result.components = this.components.map((comp)=>JSON.parse(comp.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.baseType === "array") {
            result += this.arrayChildren.format(format);
            result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
        } else if (this.baseType === "tuple") {
            if (format !== $af887190705af914$export$f010f239efc4d445.sighash) result += this.type;
            result += "(" + this.components.map((comp)=>comp.format(format)).join(format === $af887190705af914$export$f010f239efc4d445.full ? ", " : ",") + ")";
        } else result += this.type;
        if (format !== $af887190705af914$export$f010f239efc4d445.sighash) {
            if (this.indexed === true) result += " indexed";
            if (format === $af887190705af914$export$f010f239efc4d445.full && this.name) result += " " + this.name;
        }
        return result;
    }
    static from(value, allowIndexed) {
        if (typeof value === "string") return $af887190705af914$export$426dc07f493a4c47.fromString(value, allowIndexed);
        return $af887190705af914$export$426dc07f493a4c47.fromObject(value);
    }
    static fromObject(value) {
        if ($af887190705af914$export$426dc07f493a4c47.isParamType(value)) return value;
        return new $af887190705af914$export$426dc07f493a4c47($af887190705af914$var$_constructorGuard, {
            name: value.name || null,
            type: $af887190705af914$var$verifyType(value.type),
            indexed: value.indexed == null ? null : !!value.indexed,
            components: value.components ? value.components.map($af887190705af914$export$426dc07f493a4c47.fromObject) : null
        });
    }
    static fromString(value, allowIndexed) {
        function ParamTypify(node) {
            return $af887190705af914$export$426dc07f493a4c47.fromObject({
                name: node.name,
                type: node.type,
                indexed: node.indexed,
                components: node.components
            });
        }
        return ParamTypify($af887190705af914$var$parseParamType(value, !!allowIndexed));
    }
    static isParamType(value) {
        return !!(value != null && value._isParamType);
    }
}
function $af887190705af914$var$parseParams(value, allowIndex) {
    return $af887190705af914$var$splitNesting(value).map((param)=>$af887190705af914$export$426dc07f493a4c47.fromString(param, allowIndex));
}
class $af887190705af914$export$ffb0004e005737fa {
    constructor(constructorGuard, params){
        if (constructorGuard !== $af887190705af914$var$_constructorGuard) $af887190705af914$var$logger.throwError("use a static from method", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        $af887190705af914$var$populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    static from(value) {
        if ($af887190705af914$export$ffb0004e005737fa.isFragment(value)) return value;
        if (typeof value === "string") return $af887190705af914$export$ffb0004e005737fa.fromString(value);
        return $af887190705af914$export$ffb0004e005737fa.fromObject(value);
    }
    static fromObject(value) {
        if ($af887190705af914$export$ffb0004e005737fa.isFragment(value)) return value;
        switch(value.type){
            case "function":
                return $af887190705af914$export$8d576c928b93668f.fromObject(value);
            case "event":
                return $af887190705af914$export$958548f08bac2833.fromObject(value);
            case "constructor":
                return $af887190705af914$export$3ac5c9504f801ea4.fromObject(value);
            case "error":
                return $af887190705af914$export$2c42c6d543aa9b59.fromObject(value);
            case "fallback":
            case "receive":
                // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                return null;
        }
        return $af887190705af914$var$logger.throwArgumentError("invalid fragment object", "value", value);
    }
    static fromString(value) {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        value = value.replace(/\s/g, " ");
        value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        value = value.trim();
        if (value.split(" ")[0] === "event") return $af887190705af914$export$958548f08bac2833.fromString(value.substring(5).trim());
        else if (value.split(" ")[0] === "function") return $af887190705af914$export$8d576c928b93668f.fromString(value.substring(8).trim());
        else if (value.split("(")[0].trim() === "constructor") return $af887190705af914$export$3ac5c9504f801ea4.fromString(value.trim());
        else if (value.split(" ")[0] === "error") return $af887190705af914$export$2c42c6d543aa9b59.fromString(value.substring(5).trim());
        return $af887190705af914$var$logger.throwArgumentError("unsupported fragment", "value", value);
    }
    static isFragment(value) {
        return !!(value && value._isFragment);
    }
}
class $af887190705af914$export$958548f08bac2833 extends $af887190705af914$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $af887190705af914$export$f010f239efc4d445.sighash;
        if (!$af887190705af914$export$f010f239efc4d445[format]) $af887190705af914$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $af887190705af914$export$f010f239efc4d445.json) return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $af887190705af914$export$f010f239efc4d445.sighash) result += "event ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $af887190705af914$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $af887190705af914$export$f010f239efc4d445.sighash) {
            if (this.anonymous) result += "anonymous ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $af887190705af914$export$958548f08bac2833.fromString(value);
        return $af887190705af914$export$958548f08bac2833.fromObject(value);
    }
    static fromObject(value) {
        if ($af887190705af914$export$958548f08bac2833.isEventFragment(value)) return value;
        if (value.type !== "event") $af887190705af914$var$logger.throwArgumentError("invalid event object", "value", value);
        const params = {
            name: $af887190705af914$var$verifyIdentifier(value.name),
            anonymous: value.anonymous,
            inputs: value.inputs ? value.inputs.map($af887190705af914$export$426dc07f493a4c47.fromObject) : [],
            type: "event"
        };
        return new $af887190705af914$export$958548f08bac2833($af887190705af914$var$_constructorGuard, params);
    }
    static fromString(value) {
        let match = value.match($af887190705af914$var$regexParen);
        if (!match) $af887190705af914$var$logger.throwArgumentError("invalid event string", "value", value);
        let anonymous = false;
        match[3].split(" ").forEach((modifier)=>{
            switch(modifier.trim()){
                case "anonymous":
                    anonymous = true;
                    break;
                case "":
                    break;
                default:
                    $af887190705af914$var$logger.warn("unknown modifier: " + modifier);
            }
        });
        return $af887190705af914$export$958548f08bac2833.fromObject({
            name: match[1].trim(),
            anonymous: anonymous,
            inputs: $af887190705af914$var$parseParams(match[2], true),
            type: "event"
        });
    }
    static isEventFragment(value) {
        return value && value._isFragment && value.type === "event";
    }
}
function $af887190705af914$var$parseGas(value, params) {
    params.gas = null;
    let comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) $af887190705af914$var$logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) $af887190705af914$var$logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, $20M69.BigNumber).from(comps[1]);
        return comps[0];
    }
    return value;
}
function $af887190705af914$var$parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach((modifier)=>{
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function $af887190705af914$var$verifyState(value) {
    let result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) $af887190705af914$var$logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) $af887190705af914$var$logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") $af887190705af914$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) $af887190705af914$var$logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") $af887190705af914$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
class $af887190705af914$export$3ac5c9504f801ea4 extends $af887190705af914$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $af887190705af914$export$f010f239efc4d445.sighash;
        if (!$af887190705af914$export$f010f239efc4d445[format]) $af887190705af914$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $af887190705af914$export$f010f239efc4d445.json) return JSON.stringify({
            type: "constructor",
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        if (format === $af887190705af914$export$f010f239efc4d445.sighash) $af887190705af914$var$logger.throwError("cannot format a constructor for sighash", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "format(sighash)"
        });
        let result = "constructor(" + this.inputs.map((input)=>input.format(format)).join(format === $af887190705af914$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $af887190705af914$export$3ac5c9504f801ea4.fromString(value);
        return $af887190705af914$export$3ac5c9504f801ea4.fromObject(value);
    }
    static fromObject(value) {
        if ($af887190705af914$export$3ac5c9504f801ea4.isConstructorFragment(value)) return value;
        if (value.type !== "constructor") $af887190705af914$var$logger.throwArgumentError("invalid constructor object", "value", value);
        let state = $af887190705af914$var$verifyState(value);
        if (state.constant) $af887190705af914$var$logger.throwArgumentError("constructor cannot be constant", "value", value);
        const params = {
            name: null,
            type: value.type,
            inputs: value.inputs ? value.inputs.map($af887190705af914$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $20M69.BigNumber).from(value.gas) : null
        };
        return new $af887190705af914$export$3ac5c9504f801ea4($af887190705af914$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "constructor"
        };
        value = $af887190705af914$var$parseGas(value, params);
        let parens = value.match($af887190705af914$var$regexParen);
        if (!parens || parens[1].trim() !== "constructor") $af887190705af914$var$logger.throwArgumentError("invalid constructor string", "value", value);
        params.inputs = $af887190705af914$var$parseParams(parens[2].trim(), false);
        $af887190705af914$var$parseModifiers(parens[3].trim(), params);
        return $af887190705af914$export$3ac5c9504f801ea4.fromObject(params);
    }
    static isConstructorFragment(value) {
        return value && value._isFragment && value.type === "constructor";
    }
}
class $af887190705af914$export$8d576c928b93668f extends $af887190705af914$export$3ac5c9504f801ea4 {
    format(format) {
        if (!format) format = $af887190705af914$export$f010f239efc4d445.sighash;
        if (!$af887190705af914$export$f010f239efc4d445[format]) $af887190705af914$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $af887190705af914$export$f010f239efc4d445.json) return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format))),
            outputs: this.outputs.map((output)=>JSON.parse(output.format(format)))
        });
        let result = "";
        if (format !== $af887190705af914$export$f010f239efc4d445.sighash) result += "function ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $af887190705af914$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $af887190705af914$export$f010f239efc4d445.sighash) {
            if (this.stateMutability) {
                if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
            } else if (this.constant) result += "view ";
            if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map((output)=>output.format(format)).join(", ") + ") ";
            if (this.gas != null) result += "@" + this.gas.toString() + " ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $af887190705af914$export$8d576c928b93668f.fromString(value);
        return $af887190705af914$export$8d576c928b93668f.fromObject(value);
    }
    static fromObject(value) {
        if ($af887190705af914$export$8d576c928b93668f.isFunctionFragment(value)) return value;
        if (value.type !== "function") $af887190705af914$var$logger.throwArgumentError("invalid function object", "value", value);
        let state = $af887190705af914$var$verifyState(value);
        const params = {
            type: value.type,
            name: $af887190705af914$var$verifyIdentifier(value.name),
            constant: state.constant,
            inputs: value.inputs ? value.inputs.map($af887190705af914$export$426dc07f493a4c47.fromObject) : [],
            outputs: value.outputs ? value.outputs.map($af887190705af914$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $20M69.BigNumber).from(value.gas) : null
        };
        return new $af887190705af914$export$8d576c928b93668f($af887190705af914$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "function"
        };
        value = $af887190705af914$var$parseGas(value, params);
        let comps = value.split(" returns ");
        if (comps.length > 2) $af887190705af914$var$logger.throwArgumentError("invalid function string", "value", value);
        let parens = comps[0].match($af887190705af914$var$regexParen);
        if (!parens) $af887190705af914$var$logger.throwArgumentError("invalid function signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $af887190705af914$var$verifyIdentifier(params.name);
        params.inputs = $af887190705af914$var$parseParams(parens[2], false);
        $af887190705af914$var$parseModifiers(parens[3].trim(), params);
        // We have outputs
        if (comps.length > 1) {
            let returns = comps[1].match($af887190705af914$var$regexParen);
            if (returns[1].trim() != "" || returns[3].trim() != "") $af887190705af914$var$logger.throwArgumentError("unexpected tokens", "value", value);
            params.outputs = $af887190705af914$var$parseParams(returns[2], false);
        } else params.outputs = [];
        return $af887190705af914$export$8d576c928b93668f.fromObject(params);
    }
    static isFunctionFragment(value) {
        return value && value._isFragment && value.type === "function";
    }
}
//export class StructFragment extends Fragment {
//}
function $af887190705af914$var$checkForbidden(fragment) {
    const sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") $af887190705af914$var$logger.throwArgumentError(`cannot specify user defined ${sig} error`, "fragment", fragment);
    return fragment;
}
class $af887190705af914$export$2c42c6d543aa9b59 extends $af887190705af914$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $af887190705af914$export$f010f239efc4d445.sighash;
        if (!$af887190705af914$export$f010f239efc4d445[format]) $af887190705af914$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $af887190705af914$export$f010f239efc4d445.json) return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $af887190705af914$export$f010f239efc4d445.sighash) result += "error ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $af887190705af914$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $af887190705af914$export$2c42c6d543aa9b59.fromString(value);
        return $af887190705af914$export$2c42c6d543aa9b59.fromObject(value);
    }
    static fromObject(value) {
        if ($af887190705af914$export$2c42c6d543aa9b59.isErrorFragment(value)) return value;
        if (value.type !== "error") $af887190705af914$var$logger.throwArgumentError("invalid error object", "value", value);
        const params = {
            type: value.type,
            name: $af887190705af914$var$verifyIdentifier(value.name),
            inputs: value.inputs ? value.inputs.map($af887190705af914$export$426dc07f493a4c47.fromObject) : []
        };
        return $af887190705af914$var$checkForbidden(new $af887190705af914$export$2c42c6d543aa9b59($af887190705af914$var$_constructorGuard, params));
    }
    static fromString(value) {
        let params = {
            type: "error"
        };
        let parens = value.match($af887190705af914$var$regexParen);
        if (!parens) $af887190705af914$var$logger.throwArgumentError("invalid error signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $af887190705af914$var$verifyIdentifier(params.name);
        params.inputs = $af887190705af914$var$parseParams(parens[2], false);
        return $af887190705af914$var$checkForbidden($af887190705af914$export$2c42c6d543aa9b59.fromObject(params));
    }
    static isErrorFragment(value) {
        return value && value._isFragment && value.type === "error";
    }
}
function $af887190705af914$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
const $af887190705af914$var$regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function $af887190705af914$var$verifyIdentifier(value) {
    if (!value || !value.match($af887190705af914$var$regexIdentifier)) $af887190705af914$var$logger.throwArgumentError(`invalid identifier "${value}"`, "value", value);
    return value;
}
const $af887190705af914$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function $af887190705af914$var$splitNesting(value) {
    value = value.trim();
    let result = [];
    let accum = "";
    let depth = 0;
    for(let offset = 0; offset < value.length; offset++){
        let c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) $af887190705af914$var$logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}

});



parcelRegister("lOWlX", function(module, exports) {

$parcel$export(module.exports, "ForkEvent", function () { return $fe2b88314bf10b56$export$406ece1549ccd00e; });
$parcel$export(module.exports, "Provider", function () { return $fe2b88314bf10b56$export$2881499e37b75b9a; });

var $20M69 = parcelRequire("20M69");

var $eBLyT = parcelRequire("eBLyT");

var $j0dXC = parcelRequire("j0dXC");

var $4NCF1 = parcelRequire("4NCF1");

var $eAW04 = parcelRequire("eAW04");
"use strict";
var $fe2b88314bf10b56$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $fe2b88314bf10b56$var$logger = new (0, $4NCF1.Logger)((0, $eAW04.version));
class $fe2b88314bf10b56$export$406ece1549ccd00e extends (0, $j0dXC.Description) {
    static isForkEvent(value) {
        return !!(value && value._isForkEvent);
    }
}
class $fe2b88314bf10b56$export$5b2cada8494f9d99 extends $fe2b88314bf10b56$export$406ece1549ccd00e {
    constructor(blockHash, expiry){
        if (!(0, $eBLyT.isHexString)(blockHash, 32)) $fe2b88314bf10b56$var$logger.throwArgumentError("invalid blockHash", "blockHash", blockHash);
        super({
            _isForkEvent: true,
            _isBlockForkEvent: true,
            expiry: expiry || 0,
            blockHash: blockHash
        });
    }
}
class $fe2b88314bf10b56$export$26bcd61a55716c98 extends $fe2b88314bf10b56$export$406ece1549ccd00e {
    constructor(hash, expiry){
        if (!(0, $eBLyT.isHexString)(hash, 32)) $fe2b88314bf10b56$var$logger.throwArgumentError("invalid transaction hash", "hash", hash);
        super({
            _isForkEvent: true,
            _isTransactionForkEvent: true,
            expiry: expiry || 0,
            hash: hash
        });
    }
}
class $fe2b88314bf10b56$export$8f8609bfee47c93 extends $fe2b88314bf10b56$export$406ece1549ccd00e {
    constructor(beforeHash, afterHash, expiry){
        if (!(0, $eBLyT.isHexString)(beforeHash, 32)) $fe2b88314bf10b56$var$logger.throwArgumentError("invalid transaction hash", "beforeHash", beforeHash);
        if (!(0, $eBLyT.isHexString)(afterHash, 32)) $fe2b88314bf10b56$var$logger.throwArgumentError("invalid transaction hash", "afterHash", afterHash);
        super({
            _isForkEvent: true,
            _isTransactionOrderForkEvent: true,
            expiry: expiry || 0,
            beforeHash: beforeHash,
            afterHash: afterHash
        });
    }
}
class $fe2b88314bf10b56$export$2881499e37b75b9a {
    constructor(){
        $fe2b88314bf10b56$var$logger.checkAbstract(new.target, $fe2b88314bf10b56$export$2881499e37b75b9a);
        (0, $j0dXC.defineReadOnly)(this, "_isProvider", true);
    }
    getFeeData() {
        return $fe2b88314bf10b56$var$__awaiter(this, void 0, void 0, function*() {
            const { block: block, gasPrice: gasPrice } = yield (0, $j0dXC.resolveProperties)({
                block: this.getBlock("latest"),
                gasPrice: this.getGasPrice().catch((error)=>{
                    // @TODO: Why is this now failing on Calaveras?
                    //console.log(error);
                    return null;
                })
            });
            let lastBaseFeePerGas = null, maxFeePerGas = null, maxPriorityFeePerGas = null;
            if (block && block.baseFeePerGas) {
                // We may want to compute this more accurately in the future,
                // using the formula "check if the base fee is correct".
                // See: https://eips.ethereum.org/EIPS/eip-1559
                lastBaseFeePerGas = block.baseFeePerGas;
                maxPriorityFeePerGas = (0, $20M69.BigNumber).from("1500000000");
                maxFeePerGas = block.baseFeePerGas.mul(2).add(maxPriorityFeePerGas);
            }
            return {
                lastBaseFeePerGas: lastBaseFeePerGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                gasPrice: gasPrice
            };
        });
    }
    // Alias for "on"
    addListener(eventName, listener) {
        return this.on(eventName, listener);
    }
    // Alias for "off"
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
    static isProvider(value) {
        return !!(value && value._isProvider);
    }
}

});
parcelRegister("eAW04", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $aa016b17c8549999$export$83d89fbfd8236492; });
const $aa016b17c8549999$export$83d89fbfd8236492 = "abstract-provider/5.7.0";

});


parcelRegister("glz4p", function(module, exports) {

$parcel$export(module.exports, "Signer", function () { return $be69cfb5095d905e$export$fdf54fdde81cc9f0; });
$parcel$export(module.exports, "VoidSigner", function () { return $be69cfb5095d905e$export$7dbc56d9b9612bad; });

var $j0dXC = parcelRequire("j0dXC");

var $4NCF1 = parcelRequire("4NCF1");

var $7Xz7z = parcelRequire("7Xz7z");
"use strict";
var $be69cfb5095d905e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $be69cfb5095d905e$var$logger = new (0, $4NCF1.Logger)((0, $7Xz7z.version));
const $be69cfb5095d905e$var$allowedTransactionKeys = [
    "accessList",
    "ccipReadEnabled",
    "chainId",
    "customData",
    "data",
    "from",
    "gasLimit",
    "gasPrice",
    "maxFeePerGas",
    "maxPriorityFeePerGas",
    "nonce",
    "to",
    "type",
    "value"
];
const $be69cfb5095d905e$var$forwardErrors = [
    (0, $4NCF1.Logger).errors.INSUFFICIENT_FUNDS,
    (0, $4NCF1.Logger).errors.NONCE_EXPIRED,
    (0, $4NCF1.Logger).errors.REPLACEMENT_UNDERPRICED
];
class $be69cfb5095d905e$export$fdf54fdde81cc9f0 {
    ///////////////////
    // Sub-classes MUST call super
    constructor(){
        $be69cfb5095d905e$var$logger.checkAbstract(new.target, $be69cfb5095d905e$export$fdf54fdde81cc9f0);
        (0, $j0dXC.defineReadOnly)(this, "_isSigner", true);
    }
    ///////////////////
    // Sub-classes MAY override these
    getBalance(blockTag) {
        return $be69cfb5095d905e$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getBalance");
            return yield this.provider.getBalance(this.getAddress(), blockTag);
        });
    }
    getTransactionCount(blockTag) {
        return $be69cfb5095d905e$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getTransactionCount");
            return yield this.provider.getTransactionCount(this.getAddress(), blockTag);
        });
    }
    // Populates "from" if unspecified, and estimates the gas for the transaction
    estimateGas(transaction) {
        return $be69cfb5095d905e$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("estimateGas");
            const tx = yield (0, $j0dXC.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.estimateGas(tx);
        });
    }
    // Populates "from" if unspecified, and calls with the transaction
    call(transaction, blockTag) {
        return $be69cfb5095d905e$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("call");
            const tx = yield (0, $j0dXC.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.call(tx, blockTag);
        });
    }
    // Populates all fields in a transaction, signs it and sends it to the network
    sendTransaction(transaction) {
        return $be69cfb5095d905e$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("sendTransaction");
            const tx = yield this.populateTransaction(transaction);
            const signedTx = yield this.signTransaction(tx);
            return yield this.provider.sendTransaction(signedTx);
        });
    }
    getChainId() {
        return $be69cfb5095d905e$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getChainId");
            const network = yield this.provider.getNetwork();
            return network.chainId;
        });
    }
    getGasPrice() {
        return $be69cfb5095d905e$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getGasPrice");
            return yield this.provider.getGasPrice();
        });
    }
    getFeeData() {
        return $be69cfb5095d905e$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getFeeData");
            return yield this.provider.getFeeData();
        });
    }
    resolveName(name) {
        return $be69cfb5095d905e$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("resolveName");
            return yield this.provider.resolveName(name);
        });
    }
    // Checks a transaction does not contain invalid keys and if
    // no "from" is provided, populates it.
    // - does NOT require a provider
    // - adds "from" is not present
    // - returns a COPY (safe to mutate the result)
    // By default called from: (overriding these prevents it)
    //   - call
    //   - estimateGas
    //   - populateTransaction (and therefor sendTransaction)
    checkTransaction(transaction) {
        for(const key in transaction)if ($be69cfb5095d905e$var$allowedTransactionKeys.indexOf(key) === -1) $be69cfb5095d905e$var$logger.throwArgumentError("invalid transaction key: " + key, "transaction", transaction);
        const tx = (0, $j0dXC.shallowCopy)(transaction);
        if (tx.from == null) tx.from = this.getAddress();
        else // Make sure any provided address matches this signer
        tx.from = Promise.all([
            Promise.resolve(tx.from),
            this.getAddress()
        ]).then((result)=>{
            if (result[0].toLowerCase() !== result[1].toLowerCase()) $be69cfb5095d905e$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            return result[0];
        });
        return tx;
    }
    // Populates ALL keys for a transaction and checks that "from" matches
    // this Signer. Should be used by sendTransaction but NOT by signTransaction.
    // By default called from: (overriding these prevents it)
    //   - sendTransaction
    //
    // Notes:
    //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
    populateTransaction(transaction) {
        return $be69cfb5095d905e$var$__awaiter(this, void 0, void 0, function*() {
            const tx = yield (0, $j0dXC.resolveProperties)(this.checkTransaction(transaction));
            if (tx.to != null) {
                tx.to = Promise.resolve(tx.to).then((to)=>$be69cfb5095d905e$var$__awaiter(this, void 0, void 0, function*() {
                        if (to == null) return null;
                        const address = yield this.resolveName(to);
                        if (address == null) $be69cfb5095d905e$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                        return address;
                    }));
                // Prevent this error from causing an UnhandledPromiseException
                tx.to.catch((error)=>{});
            }
            // Do not allow mixing pre-eip-1559 and eip-1559 properties
            const hasEip1559 = tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null;
            if (tx.gasPrice != null && (tx.type === 2 || hasEip1559)) $be69cfb5095d905e$var$logger.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", transaction);
            else if ((tx.type === 0 || tx.type === 1) && hasEip1559) $be69cfb5095d905e$var$logger.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", transaction);
            if ((tx.type === 2 || tx.type == null) && tx.maxFeePerGas != null && tx.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
            tx.type = 2;
            else if (tx.type === 0 || tx.type === 1) // Explicit Legacy or EIP-2930 transaction
            // Populate missing gasPrice
            {
                if (tx.gasPrice == null) tx.gasPrice = this.getGasPrice();
            } else {
                // We need to get fee data to determine things
                const feeData = yield this.getFeeData();
                if (tx.type == null) {
                    // We need to auto-detect the intended type of this transaction...
                    if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                        // The network supports EIP-1559!
                        // Upgrade transaction from null to eip-1559
                        tx.type = 2;
                        if (tx.gasPrice != null) {
                            // Using legacy gasPrice property on an eip-1559 network,
                            // so use gasPrice as both fee properties
                            const gasPrice = tx.gasPrice;
                            delete tx.gasPrice;
                            tx.maxFeePerGas = gasPrice;
                            tx.maxPriorityFeePerGas = gasPrice;
                        } else {
                            // Populate missing fee data
                            if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                            if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                        }
                    } else if (feeData.gasPrice != null) {
                        // Network doesn't support EIP-1559...
                        // ...but they are trying to use EIP-1559 properties
                        if (hasEip1559) $be69cfb5095d905e$var$logger.throwError("network does not support EIP-1559", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                            operation: "populateTransaction"
                        });
                        // Populate missing fee data
                        if (tx.gasPrice == null) tx.gasPrice = feeData.gasPrice;
                        // Explicitly set untyped transaction to legacy
                        tx.type = 0;
                    } else // getFeeData has failed us.
                    $be69cfb5095d905e$var$logger.throwError("failed to get consistent fee data", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "signer.getFeeData"
                    });
                } else if (tx.type === 2) {
                    // Explicitly using EIP-1559
                    // Populate missing fee data
                    if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                    if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                }
            }
            if (tx.nonce == null) tx.nonce = this.getTransactionCount("pending");
            if (tx.gasLimit == null) tx.gasLimit = this.estimateGas(tx).catch((error)=>{
                if ($be69cfb5095d905e$var$forwardErrors.indexOf(error.code) >= 0) throw error;
                return $be69cfb5095d905e$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $4NCF1.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
                    error: error,
                    tx: tx
                });
            });
            if (tx.chainId == null) tx.chainId = this.getChainId();
            else tx.chainId = Promise.all([
                Promise.resolve(tx.chainId),
                this.getChainId()
            ]).then((results)=>{
                if (results[1] !== 0 && results[0] !== results[1]) $be69cfb5095d905e$var$logger.throwArgumentError("chainId address mismatch", "transaction", transaction);
                return results[0];
            });
            return yield (0, $j0dXC.resolveProperties)(tx);
        });
    }
    ///////////////////
    // Sub-classes SHOULD leave these alone
    _checkProvider(operation) {
        if (!this.provider) $be69cfb5095d905e$var$logger.throwError("missing provider", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: operation || "_checkProvider"
        });
    }
    static isSigner(value) {
        return !!(value && value._isSigner);
    }
}
class $be69cfb5095d905e$export$7dbc56d9b9612bad extends $be69cfb5095d905e$export$fdf54fdde81cc9f0 {
    constructor(address, provider){
        super();
        (0, $j0dXC.defineReadOnly)(this, "address", address);
        (0, $j0dXC.defineReadOnly)(this, "provider", provider || null);
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    _fail(message, operation) {
        return Promise.resolve().then(()=>{
            $be69cfb5095d905e$var$logger.throwError(message, (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: operation
            });
        });
    }
    signMessage(message) {
        return this._fail("VoidSigner cannot sign messages", "signMessage");
    }
    signTransaction(transaction) {
        return this._fail("VoidSigner cannot sign transactions", "signTransaction");
    }
    _signTypedData(domain, types, value) {
        return this._fail("VoidSigner cannot sign typed data", "signTypedData");
    }
    connect(provider) {
        return new $be69cfb5095d905e$export$7dbc56d9b9612bad(this.address, provider);
    }
}

});
parcelRegister("7Xz7z", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $5cb9496cab1ba8cd$export$83d89fbfd8236492; });
const $5cb9496cab1ba8cd$export$83d89fbfd8236492 = "abstract-signer/5.7.0";

});


parcelRegister("ABz8M", function(module, exports) {

$parcel$export(module.exports, "TransactionTypes", function () { return $06e080b08b1921c8$export$80349e05e0724e11; });
$parcel$export(module.exports, "computeAddress", function () { return $06e080b08b1921c8$export$e67e2732ba9803f9; });
$parcel$export(module.exports, "recoverAddress", function () { return $06e080b08b1921c8$export$23cc18f96d8510e2; });
$parcel$export(module.exports, "accessListify", function () { return $06e080b08b1921c8$export$6c8662b1600dce2; });
$parcel$export(module.exports, "serialize", function () { return $06e080b08b1921c8$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "parse", function () { return $06e080b08b1921c8$export$98e6a39c04603d36; });

var $ak7re = parcelRequire("ak7re");

var $20M69 = parcelRequire("20M69");

var $eBLyT = parcelRequire("eBLyT");

var $M3r56 = parcelRequire("M3r56");

var $bnbYM = parcelRequire("bnbYM");

var $j0dXC = parcelRequire("j0dXC");

var $esBpx = parcelRequire("esBpx");

var $aDAF4 = parcelRequire("aDAF4");

var $4NCF1 = parcelRequire("4NCF1");

var $igClu = parcelRequire("igClu");
"use strict";
const $06e080b08b1921c8$var$logger = new (0, $4NCF1.Logger)((0, $igClu.version));
var $06e080b08b1921c8$export$80349e05e0724e11;
(function(TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})($06e080b08b1921c8$export$80349e05e0724e11 || ($06e080b08b1921c8$export$80349e05e0724e11 = {}));
///////////////////////////////
function $06e080b08b1921c8$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $ak7re.getAddress)(value);
}
function $06e080b08b1921c8$var$handleNumber(value) {
    if (value === "0x") return 0, $M3r56.Zero;
    return (0, $20M69.BigNumber).from(value);
}
// Legacy Transaction Fields
const $06e080b08b1921c8$var$transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
const $06e080b08b1921c8$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    type: true,
    value: true
};
function $06e080b08b1921c8$export$e67e2732ba9803f9(key) {
    const publicKey = (0, $aDAF4.computePublicKey)(key);
    return (0, $ak7re.getAddress)((0, $eBLyT.hexDataSlice)((0, $bnbYM.keccak256)((0, $eBLyT.hexDataSlice)(publicKey, 1)), 12));
}
function $06e080b08b1921c8$export$23cc18f96d8510e2(digest, signature) {
    return $06e080b08b1921c8$export$e67e2732ba9803f9((0, $aDAF4.recoverPublicKey)((0, $eBLyT.arrayify)(digest), signature));
}
function $06e080b08b1921c8$var$formatNumber(value, name) {
    const result = (0, $eBLyT.stripZeros)((0, $20M69.BigNumber).from(value).toHexString());
    if (result.length > 32) $06e080b08b1921c8$var$logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function $06e080b08b1921c8$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $ak7re.getAddress)(addr),
        storageKeys: (storageKeys || []).map((storageKey, index)=>{
            if ((0, $eBLyT.hexDataLength)(storageKey) !== 32) $06e080b08b1921c8$var$logger.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $06e080b08b1921c8$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            if (set.length > 2) $06e080b08b1921c8$var$logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
            return $06e080b08b1921c8$var$accessSetify(set[0], set[1]);
        }
        return $06e080b08b1921c8$var$accessSetify(set.address, set.storageKeys);
    });
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $06e080b08b1921c8$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}
function $06e080b08b1921c8$var$formatAccessList(value) {
    return $06e080b08b1921c8$export$6c8662b1600dce2(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $06e080b08b1921c8$var$_serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        const gasPrice = (0, $20M69.BigNumber).from(transaction.gasPrice);
        const maxFeePerGas = (0, $20M69.BigNumber).from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) $06e080b08b1921c8$var$logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas
        });
    }
    const fields = [
        $06e080b08b1921c8$var$formatNumber(transaction.chainId || 0, "chainId"),
        $06e080b08b1921c8$var$formatNumber(transaction.nonce || 0, "nonce"),
        $06e080b08b1921c8$var$formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $06e080b08b1921c8$var$formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        $06e080b08b1921c8$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $ak7re.getAddress)(transaction.to) : "0x",
        $06e080b08b1921c8$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $06e080b08b1921c8$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $eBLyT.splitSignature)(signature);
        fields.push($06e080b08b1921c8$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $eBLyT.stripZeros)(sig.r));
        fields.push((0, $eBLyT.stripZeros)(sig.s));
    }
    return (0, $eBLyT.hexConcat)([
        "0x02",
        $esBpx.encode(fields)
    ]);
}
function $06e080b08b1921c8$var$_serializeEip2930(transaction, signature) {
    const fields = [
        $06e080b08b1921c8$var$formatNumber(transaction.chainId || 0, "chainId"),
        $06e080b08b1921c8$var$formatNumber(transaction.nonce || 0, "nonce"),
        $06e080b08b1921c8$var$formatNumber(transaction.gasPrice || 0, "gasPrice"),
        $06e080b08b1921c8$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $ak7re.getAddress)(transaction.to) : "0x",
        $06e080b08b1921c8$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $06e080b08b1921c8$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $eBLyT.splitSignature)(signature);
        fields.push($06e080b08b1921c8$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $eBLyT.stripZeros)(sig.r));
        fields.push((0, $eBLyT.stripZeros)(sig.s));
    }
    return (0, $eBLyT.hexConcat)([
        "0x01",
        $esBpx.encode(fields)
    ]);
}
// Legacy Transactions and EIP-155
function $06e080b08b1921c8$var$_serialize(transaction, signature) {
    (0, $j0dXC.checkProperties)(transaction, $06e080b08b1921c8$var$allowedTransactionKeys);
    const raw = [];
    $06e080b08b1921c8$var$transactionFields.forEach(function(fieldInfo) {
        let value = transaction[fieldInfo.name] || [];
        const options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, $eBLyT.arrayify)((0, $eBLyT.hexlify)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) $06e080b08b1921c8$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, $eBLyT.stripZeros)(value);
            if (value.length > fieldInfo.maxLength) $06e080b08b1921c8$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, $eBLyT.hexlify)(value));
    });
    let chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") $06e080b08b1921c8$var$logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, $eBLyT.isBytesLike)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, $eBLyT.hexlify)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) return $esBpx.encode(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    const sig = (0, $eBLyT.splitSignature)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    let v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) $06e080b08b1921c8$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) $06e080b08b1921c8$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, $eBLyT.hexlify)(v));
    raw.push((0, $eBLyT.stripZeros)((0, $eBLyT.arrayify)(sig.r)));
    raw.push((0, $eBLyT.stripZeros)((0, $eBLyT.arrayify)(sig.s)));
    return $esBpx.encode(raw);
}
function $06e080b08b1921c8$export$dfdc1655ccc5b9cb(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) $06e080b08b1921c8$var$logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return $06e080b08b1921c8$var$_serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return $06e080b08b1921c8$var$_serializeEip2930(transaction, signature);
        case 2:
            return $06e080b08b1921c8$var$_serializeEip1559(transaction, signature);
        default:
            break;
    }
    return $06e080b08b1921c8$var$logger.throwError(`unsupported transaction type: ${transaction.type}`, (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function $06e080b08b1921c8$var$_parseEipSignature(tx, fields, serialize) {
    try {
        const recid = $06e080b08b1921c8$var$handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        $06e080b08b1921c8$var$logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0, $eBLyT.hexZeroPad)(fields[1], 32);
    tx.s = (0, $eBLyT.hexZeroPad)(fields[2], 32);
    try {
        const digest = (0, $bnbYM.keccak256)(serialize(tx));
        tx.from = $06e080b08b1921c8$export$23cc18f96d8510e2(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {}
}
function $06e080b08b1921c8$var$_parseEip1559(payload) {
    const transaction = $esBpx.decode(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) $06e080b08b1921c8$var$logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, $eBLyT.hexlify)(payload));
    const maxPriorityFeePerGas = $06e080b08b1921c8$var$handleNumber(transaction[2]);
    const maxFeePerGas = $06e080b08b1921c8$var$handleNumber(transaction[3]);
    const tx = {
        type: 2,
        chainId: $06e080b08b1921c8$var$handleNumber(transaction[0]).toNumber(),
        nonce: $06e080b08b1921c8$var$handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: $06e080b08b1921c8$var$handleNumber(transaction[4]),
        to: $06e080b08b1921c8$var$handleAddress(transaction[5]),
        value: $06e080b08b1921c8$var$handleNumber(transaction[6]),
        data: transaction[7],
        accessList: $06e080b08b1921c8$export$6c8662b1600dce2(transaction[8])
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) return tx;
    tx.hash = (0, $bnbYM.keccak256)(payload);
    $06e080b08b1921c8$var$_parseEipSignature(tx, transaction.slice(9), $06e080b08b1921c8$var$_serializeEip1559);
    return tx;
}
function $06e080b08b1921c8$var$_parseEip2930(payload) {
    const transaction = $esBpx.decode(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) $06e080b08b1921c8$var$logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, $eBLyT.hexlify)(payload));
    const tx = {
        type: 1,
        chainId: $06e080b08b1921c8$var$handleNumber(transaction[0]).toNumber(),
        nonce: $06e080b08b1921c8$var$handleNumber(transaction[1]).toNumber(),
        gasPrice: $06e080b08b1921c8$var$handleNumber(transaction[2]),
        gasLimit: $06e080b08b1921c8$var$handleNumber(transaction[3]),
        to: $06e080b08b1921c8$var$handleAddress(transaction[4]),
        value: $06e080b08b1921c8$var$handleNumber(transaction[5]),
        data: transaction[6],
        accessList: $06e080b08b1921c8$export$6c8662b1600dce2(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    tx.hash = (0, $bnbYM.keccak256)(payload);
    $06e080b08b1921c8$var$_parseEipSignature(tx, transaction.slice(8), $06e080b08b1921c8$var$_serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function $06e080b08b1921c8$var$_parse(rawTransaction) {
    const transaction = $esBpx.decode(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) $06e080b08b1921c8$var$logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    const tx = {
        nonce: $06e080b08b1921c8$var$handleNumber(transaction[0]).toNumber(),
        gasPrice: $06e080b08b1921c8$var$handleNumber(transaction[1]),
        gasLimit: $06e080b08b1921c8$var$handleNumber(transaction[2]),
        to: $06e080b08b1921c8$var$handleAddress(transaction[3]),
        value: $06e080b08b1921c8$var$handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, $20M69.BigNumber).from(transaction[6]).toNumber();
    } catch (error) {
        // @TODO: What makes snese to do? The v is too big
        return tx;
    }
    tx.r = (0, $eBLyT.hexZeroPad)(transaction[7], 32);
    tx.s = (0, $eBLyT.hexZeroPad)(transaction[8], 32);
    if ((0, $20M69.BigNumber).from(tx.r).isZero() && (0, $20M69.BigNumber).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, $eBLyT.hexlify)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = (0, $bnbYM.keccak256)($esBpx.encode(raw));
        try {
            tx.from = $06e080b08b1921c8$export$23cc18f96d8510e2(digest, {
                r: (0, $eBLyT.hexlify)(tx.r),
                s: (0, $eBLyT.hexlify)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {}
        tx.hash = (0, $bnbYM.keccak256)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function $06e080b08b1921c8$export$98e6a39c04603d36(rawTransaction) {
    const payload = (0, $eBLyT.arrayify)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return $06e080b08b1921c8$var$_parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return $06e080b08b1921c8$var$_parseEip2930(payload);
        case 2:
            return $06e080b08b1921c8$var$_parseEip1559(payload);
        default:
            break;
    }
    return $06e080b08b1921c8$var$logger.throwError(`unsupported transaction type: ${payload[0]}`, (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}

});
parcelRegister("aDAF4", function(module, exports) {

$parcel$export(module.exports, "SigningKey", function () { return $7be9fc16a5e19cfa$export$21643ca94aed3e83; });
$parcel$export(module.exports, "computePublicKey", function () { return $7be9fc16a5e19cfa$export$4a89473d39301224; });
$parcel$export(module.exports, "recoverPublicKey", function () { return $7be9fc16a5e19cfa$export$952dd09fbe0232b7; });

var $4U9Xx = parcelRequire("4U9Xx");

var $eBLyT = parcelRequire("eBLyT");

var $j0dXC = parcelRequire("j0dXC");

var $4NCF1 = parcelRequire("4NCF1");

var $bL3SH = parcelRequire("bL3SH");
"use strict";
const $7be9fc16a5e19cfa$var$logger = new (0, $4NCF1.Logger)((0, $bL3SH.version));
let $7be9fc16a5e19cfa$var$_curve = null;
function $7be9fc16a5e19cfa$var$getCurve() {
    if (!$7be9fc16a5e19cfa$var$_curve) $7be9fc16a5e19cfa$var$_curve = new (0, $4U9Xx.EC)("secp256k1");
    return $7be9fc16a5e19cfa$var$_curve;
}
class $7be9fc16a5e19cfa$export$21643ca94aed3e83 {
    constructor(privateKey){
        (0, $j0dXC.defineReadOnly)(this, "curve", "secp256k1");
        (0, $j0dXC.defineReadOnly)(this, "privateKey", (0, $eBLyT.hexlify)(privateKey));
        if ((0, $eBLyT.hexDataLength)(this.privateKey) !== 32) $7be9fc16a5e19cfa$var$logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        const keyPair = $7be9fc16a5e19cfa$var$getCurve().keyFromPrivate((0, $eBLyT.arrayify)(this.privateKey));
        (0, $j0dXC.defineReadOnly)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, $j0dXC.defineReadOnly)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, $j0dXC.defineReadOnly)(this, "_isSigningKey", true);
    }
    _addPoint(other) {
        const p0 = $7be9fc16a5e19cfa$var$getCurve().keyFromPublic((0, $eBLyT.arrayify)(this.publicKey));
        const p1 = $7be9fc16a5e19cfa$var$getCurve().keyFromPublic((0, $eBLyT.arrayify)(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = $7be9fc16a5e19cfa$var$getCurve().keyFromPrivate((0, $eBLyT.arrayify)(this.privateKey));
        const digestBytes = (0, $eBLyT.arrayify)(digest);
        if (digestBytes.length !== 32) $7be9fc16a5e19cfa$var$logger.throwArgumentError("bad digest length", "digest", digest);
        const signature = keyPair.sign(digestBytes, {
            canonical: true
        });
        return (0, $eBLyT.splitSignature)({
            recoveryParam: signature.recoveryParam,
            r: (0, $eBLyT.hexZeroPad)("0x" + signature.r.toString(16), 32),
            s: (0, $eBLyT.hexZeroPad)("0x" + signature.s.toString(16), 32)
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = $7be9fc16a5e19cfa$var$getCurve().keyFromPrivate((0, $eBLyT.arrayify)(this.privateKey));
        const otherKeyPair = $7be9fc16a5e19cfa$var$getCurve().keyFromPublic((0, $eBLyT.arrayify)($7be9fc16a5e19cfa$export$4a89473d39301224(otherKey)));
        return (0, $eBLyT.hexZeroPad)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
}
function $7be9fc16a5e19cfa$export$952dd09fbe0232b7(digest, signature) {
    const sig = (0, $eBLyT.splitSignature)(signature);
    const rs = {
        r: (0, $eBLyT.arrayify)(sig.r),
        s: (0, $eBLyT.arrayify)(sig.s)
    };
    return "0x" + $7be9fc16a5e19cfa$var$getCurve().recoverPubKey((0, $eBLyT.arrayify)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function $7be9fc16a5e19cfa$export$4a89473d39301224(key, compressed) {
    const bytes = (0, $eBLyT.arrayify)(key);
    if (bytes.length === 32) {
        const signingKey = new $7be9fc16a5e19cfa$export$21643ca94aed3e83(bytes);
        if (compressed) return "0x" + $7be9fc16a5e19cfa$var$getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, $eBLyT.hexlify)(bytes);
        return "0x" + $7be9fc16a5e19cfa$var$getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, $eBLyT.hexlify)(bytes);
        return "0x" + $7be9fc16a5e19cfa$var$getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return $7be9fc16a5e19cfa$var$logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}

});
parcelRegister("4U9Xx", function(module, exports) {

$parcel$export(module.exports, "EC", function () { return $39241e18a41dcfcb$export$129fe12d32abc311; });

var $cCgSA = parcelRequire("cCgSA");

var $ay5ZU = parcelRequire("ay5ZU");
var $39241e18a41dcfcb$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $39241e18a41dcfcb$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function $39241e18a41dcfcb$var$createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function(path, base) {
            return $39241e18a41dcfcb$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $39241e18a41dcfcb$var$getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") ? n["default"] : n;
}
function $39241e18a41dcfcb$var$getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") && Object.keys(n).length === 1 ? n["default"] : n;
}
function $39241e18a41dcfcb$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
function $39241e18a41dcfcb$var$commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $39241e18a41dcfcb$var$minimalisticAssert = $39241e18a41dcfcb$var$assert;
function $39241e18a41dcfcb$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$39241e18a41dcfcb$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};
var $39241e18a41dcfcb$var$utils_1 = $39241e18a41dcfcb$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== "string") {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
        if (word.length === 1) return "0" + word;
        else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
        var res = "";
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === "hex") return toHex(arr);
        else return arr;
    };
});
var $39241e18a41dcfcb$var$utils_1$1 = $39241e18a41dcfcb$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    utils.assert = $39241e18a41dcfcb$var$minimalisticAssert;
    utils.toArray = $39241e18a41dcfcb$var$utils_1.toArray;
    utils.zero2 = $39241e18a41dcfcb$var$utils_1.zero2;
    utils.toHex = $39241e18a41dcfcb$var$utils_1.toHex;
    utils.encode = $39241e18a41dcfcb$var$utils_1.encode;
    // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);
        var ws = 1 << w + 1;
        var k = num.clone();
        for(var i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    utils.getNAF = getNAF;
    // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
        var key = "_" + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
        return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(bytes, "hex", "le");
    }
    utils.intFromLE = intFromLE;
});
"use strict";
var $39241e18a41dcfcb$var$getNAF = $39241e18a41dcfcb$var$utils_1$1.getNAF;
var $39241e18a41dcfcb$var$getJSF = $39241e18a41dcfcb$var$utils_1$1.getJSF;
var $39241e18a41dcfcb$var$assert$1 = $39241e18a41dcfcb$var$utils_1$1.assert;
function $39241e18a41dcfcb$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA))).red(conf.prime) : (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA))).mont(this.p);
    // Useful for many curves
    this.zero = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(0).toRed(this.red);
    this.one = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(1).toRed(this.red);
    this.two = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var $39241e18a41dcfcb$var$base = $39241e18a41dcfcb$var$BaseCurve;
$39241e18a41dcfcb$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$39241e18a41dcfcb$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$39241e18a41dcfcb$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $39241e18a41dcfcb$var$assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $39241e18a41dcfcb$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$39241e18a41dcfcb$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $39241e18a41dcfcb$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $39241e18a41dcfcb$var$assert$1(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$39241e18a41dcfcb$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $39241e18a41dcfcb$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $39241e18a41dcfcb$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $39241e18a41dcfcb$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $39241e18a41dcfcb$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$39241e18a41dcfcb$var$BaseCurve.BasePoint = $39241e18a41dcfcb$var$BasePoint;
$39241e18a41dcfcb$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$39241e18a41dcfcb$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$39241e18a41dcfcb$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $39241e18a41dcfcb$var$utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $39241e18a41dcfcb$var$assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $39241e18a41dcfcb$var$assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$39241e18a41dcfcb$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$39241e18a41dcfcb$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$39241e18a41dcfcb$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $39241e18a41dcfcb$var$utils_1$1.encode(this._encode(compact), enc);
};
$39241e18a41dcfcb$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$39241e18a41dcfcb$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$39241e18a41dcfcb$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$39241e18a41dcfcb$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$39241e18a41dcfcb$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$39241e18a41dcfcb$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var $39241e18a41dcfcb$var$inherits_browser = $39241e18a41dcfcb$var$createCommonjsModule(function(module) {
    if (typeof Object.create === "function") // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
"use strict";
var $39241e18a41dcfcb$var$assert$2 = $39241e18a41dcfcb$var$utils_1$1.assert;
function $39241e18a41dcfcb$var$ShortCurve(conf) {
    $39241e18a41dcfcb$var$base.call(this, "short", conf);
    this.a = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(conf.a, 16).toRed(this.red);
    this.b = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$39241e18a41dcfcb$var$inherits_browser($39241e18a41dcfcb$var$ShortCurve, $39241e18a41dcfcb$var$base);
var $39241e18a41dcfcb$var$short_1 = $39241e18a41dcfcb$var$ShortCurve;
$39241e18a41dcfcb$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $39241e18a41dcfcb$var$assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(vec.a, 16),
            b: new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$39241e18a41dcfcb$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA))).mont(num);
    var tinv = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$39241e18a41dcfcb$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(1);
    var y1 = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(0);
    var x2 = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(0);
    var y2 = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$39241e18a41dcfcb$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$39241e18a41dcfcb$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$39241e18a41dcfcb$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$39241e18a41dcfcb$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $39241e18a41dcfcb$var$Point(curve, x, y, isRed) {
    $39241e18a41dcfcb$var$base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$39241e18a41dcfcb$var$inherits_browser($39241e18a41dcfcb$var$Point, $39241e18a41dcfcb$var$base.BasePoint);
$39241e18a41dcfcb$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $39241e18a41dcfcb$var$Point(this, x, y, isRed);
};
$39241e18a41dcfcb$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $39241e18a41dcfcb$var$Point.fromJSON(this, obj, red);
};
$39241e18a41dcfcb$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$39241e18a41dcfcb$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$39241e18a41dcfcb$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$39241e18a41dcfcb$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$39241e18a41dcfcb$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$39241e18a41dcfcb$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$39241e18a41dcfcb$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$39241e18a41dcfcb$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$39241e18a41dcfcb$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$39241e18a41dcfcb$var$Point.prototype.mul = function mul(k) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$39241e18a41dcfcb$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$39241e18a41dcfcb$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$39241e18a41dcfcb$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$39241e18a41dcfcb$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$39241e18a41dcfcb$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $39241e18a41dcfcb$var$JPoint(curve, x, y, z) {
    $39241e18a41dcfcb$var$base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(0);
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(y, 16);
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$39241e18a41dcfcb$var$inherits_browser($39241e18a41dcfcb$var$JPoint, $39241e18a41dcfcb$var$base.BasePoint);
$39241e18a41dcfcb$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $39241e18a41dcfcb$var$JPoint(this, x, y, z);
};
$39241e18a41dcfcb$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$39241e18a41dcfcb$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$39241e18a41dcfcb$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$39241e18a41dcfcb$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$39241e18a41dcfcb$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$39241e18a41dcfcb$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$39241e18a41dcfcb$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$39241e18a41dcfcb$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$39241e18a41dcfcb$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$39241e18a41dcfcb$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$39241e18a41dcfcb$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(k, kbase);
    return this.curve._wnafMul(this, k);
};
$39241e18a41dcfcb$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$39241e18a41dcfcb$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$39241e18a41dcfcb$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$39241e18a41dcfcb$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var $39241e18a41dcfcb$var$curve_1 = $39241e18a41dcfcb$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curve = exports;
    curve.base = $39241e18a41dcfcb$var$base;
    curve.short = $39241e18a41dcfcb$var$short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var $39241e18a41dcfcb$var$curves_1 = $39241e18a41dcfcb$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curves = exports;
    var assert = $39241e18a41dcfcb$var$utils_1$1.assert;
    function PresetCurve(options) {
        if (options.type === "short") this.curve = new $39241e18a41dcfcb$var$curve_1.short(options);
        else if (options.type === "edwards") this.curve = new $39241e18a41dcfcb$var$curve_1.edwards(options);
        else this.curve = new $39241e18a41dcfcb$var$curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        assert(this.g.validate(), "Invalid curve");
        assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    defineCurve("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($ay5ZU))).sha256,
        gRed: false,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    });
    defineCurve("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($ay5ZU))).sha256,
        gRed: false,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    });
    defineCurve("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($ay5ZU))).sha256,
        gRed: false,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    });
    defineCurve("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($ay5ZU))).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($ay5ZU))).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($ay5ZU))).sha256,
        gRed: false,
        g: [
            "9"
        ]
    });
    defineCurve("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        // -121665 * (121666^(-1)) (mod P)
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($ay5ZU))).sha256,
        gRed: false,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            // 4/5
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($ay5ZU))).sha256,
        // Precomputed endomorphism
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: false,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            pre
        ]
    });
});
"use strict";
function $39241e18a41dcfcb$var$HmacDRBG(options) {
    if (!(this instanceof $39241e18a41dcfcb$var$HmacDRBG)) return new $39241e18a41dcfcb$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $39241e18a41dcfcb$var$utils_1.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $39241e18a41dcfcb$var$utils_1.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $39241e18a41dcfcb$var$utils_1.toArray(options.pers, options.persEnc || "hex");
    $39241e18a41dcfcb$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
var $39241e18a41dcfcb$var$hmacDrbg = $39241e18a41dcfcb$var$HmacDRBG;
$39241e18a41dcfcb$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$39241e18a41dcfcb$var$HmacDRBG.prototype._hmac = function hmac() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($ay5ZU))).hmac(this.hash, this.K);
};
$39241e18a41dcfcb$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$39241e18a41dcfcb$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $39241e18a41dcfcb$var$utils_1.toArray(entropy, entropyEnc);
    add = $39241e18a41dcfcb$var$utils_1.toArray(add, addEnc);
    $39241e18a41dcfcb$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$39241e18a41dcfcb$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $39241e18a41dcfcb$var$utils_1.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $39241e18a41dcfcb$var$utils_1.encode(res, enc);
};
"use strict";
var $39241e18a41dcfcb$var$assert$3 = $39241e18a41dcfcb$var$utils_1$1.assert;
function $39241e18a41dcfcb$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var $39241e18a41dcfcb$var$key = $39241e18a41dcfcb$var$KeyPair;
$39241e18a41dcfcb$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $39241e18a41dcfcb$var$KeyPair) return pub;
    return new $39241e18a41dcfcb$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$39241e18a41dcfcb$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $39241e18a41dcfcb$var$KeyPair) return priv;
    return new $39241e18a41dcfcb$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$39241e18a41dcfcb$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$39241e18a41dcfcb$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$39241e18a41dcfcb$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$39241e18a41dcfcb$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$39241e18a41dcfcb$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $39241e18a41dcfcb$var$assert$3(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $39241e18a41dcfcb$var$assert$3(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$39241e18a41dcfcb$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $39241e18a41dcfcb$var$assert$3(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$39241e18a41dcfcb$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$39241e18a41dcfcb$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$39241e18a41dcfcb$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
"use strict";
var $39241e18a41dcfcb$var$assert$4 = $39241e18a41dcfcb$var$utils_1$1.assert;
function $39241e18a41dcfcb$var$Signature(options, enc) {
    if (options instanceof $39241e18a41dcfcb$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $39241e18a41dcfcb$var$assert$4(options.r && options.s, "Signature without r or s");
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(options.r, 16);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var $39241e18a41dcfcb$var$signature = $39241e18a41dcfcb$var$Signature;
function $39241e18a41dcfcb$var$Position() {
    this.place = 0;
}
function $39241e18a41dcfcb$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $39241e18a41dcfcb$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$39241e18a41dcfcb$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $39241e18a41dcfcb$var$utils_1$1.toArray(data, enc);
    var p = new $39241e18a41dcfcb$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $39241e18a41dcfcb$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $39241e18a41dcfcb$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $39241e18a41dcfcb$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(r);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(s);
    this.recoveryParam = null;
    return true;
};
function $39241e18a41dcfcb$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$39241e18a41dcfcb$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $39241e18a41dcfcb$var$rmPadding(r);
    s = $39241e18a41dcfcb$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $39241e18a41dcfcb$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $39241e18a41dcfcb$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $39241e18a41dcfcb$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $39241e18a41dcfcb$var$utils_1$1.encode(res, enc);
};
"use strict";
var $39241e18a41dcfcb$var$rand = /*RicMoo:ethers:require(brorand)*/ function() {
    throw new Error("unsupported");
};
var $39241e18a41dcfcb$var$assert$5 = $39241e18a41dcfcb$var$utils_1$1.assert;
function $39241e18a41dcfcb$var$EC(options) {
    if (!(this instanceof $39241e18a41dcfcb$var$EC)) return new $39241e18a41dcfcb$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $39241e18a41dcfcb$var$assert$5(Object.prototype.hasOwnProperty.call($39241e18a41dcfcb$var$curves_1, options), "Unknown curve " + options);
        options = $39241e18a41dcfcb$var$curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $39241e18a41dcfcb$var$curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var $39241e18a41dcfcb$var$ec = $39241e18a41dcfcb$var$EC;
$39241e18a41dcfcb$var$EC.prototype.keyPair = function keyPair(options) {
    return new $39241e18a41dcfcb$var$key(this, options);
};
$39241e18a41dcfcb$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $39241e18a41dcfcb$var$key.fromPrivate(this, priv, enc);
};
$39241e18a41dcfcb$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $39241e18a41dcfcb$var$key.fromPublic(this, pub, enc);
};
$39241e18a41dcfcb$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $39241e18a41dcfcb$var$hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $39241e18a41dcfcb$var$rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(2));
    for(;;){
        var priv = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$39241e18a41dcfcb$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$39241e18a41dcfcb$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $39241e18a41dcfcb$var$hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $39241e18a41dcfcb$var$signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$39241e18a41dcfcb$var$EC.prototype.verify = function verify(msg, signature$1, key, enc) {
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature$1 = new $39241e18a41dcfcb$var$signature(signature$1, "hex");
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$39241e18a41dcfcb$var$EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    $39241e18a41dcfcb$var$assert$5((3 & j) === j, "The recovery param is more than two bits");
    signature$1 = new $39241e18a41dcfcb$var$signature(signature$1, enc);
    var n = this.n;
    var e = new (0, (/*@__PURE__*/$parcel$interopDefault($cCgSA)))(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$39241e18a41dcfcb$var$EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new $39241e18a41dcfcb$var$signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $39241e18a41dcfcb$var$elliptic_1 = $39241e18a41dcfcb$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var elliptic = exports;
    elliptic.version = "6.5.4";
    elliptic.utils = $39241e18a41dcfcb$var$utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error("unsupported");
    };
    elliptic.curve = $39241e18a41dcfcb$var$curve_1;
    elliptic.curves = $39241e18a41dcfcb$var$curves_1;
    // Protocols
    elliptic.ec = $39241e18a41dcfcb$var$ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var $39241e18a41dcfcb$export$129fe12d32abc311 = $39241e18a41dcfcb$var$elliptic_1.ec;

});
parcelRegister("ay5ZU", function(module, exports) {
var $7ae1bb5649d9a6af$var$hash = module.exports;

$7ae1bb5649d9a6af$var$hash.utils = (parcelRequire("bQpLZ"));

$7ae1bb5649d9a6af$var$hash.common = (parcelRequire("lvZCX"));

$7ae1bb5649d9a6af$var$hash.sha = (parcelRequire("fxTOD"));

$7ae1bb5649d9a6af$var$hash.ripemd = (parcelRequire("107Nk"));

$7ae1bb5649d9a6af$var$hash.hmac = (parcelRequire("1AmBq"));
// Proxy hash functions to the main object
$7ae1bb5649d9a6af$var$hash.sha1 = $7ae1bb5649d9a6af$var$hash.sha.sha1;
$7ae1bb5649d9a6af$var$hash.sha256 = $7ae1bb5649d9a6af$var$hash.sha.sha256;
$7ae1bb5649d9a6af$var$hash.sha224 = $7ae1bb5649d9a6af$var$hash.sha.sha224;
$7ae1bb5649d9a6af$var$hash.sha384 = $7ae1bb5649d9a6af$var$hash.sha.sha384;
$7ae1bb5649d9a6af$var$hash.sha512 = $7ae1bb5649d9a6af$var$hash.sha.sha512;
$7ae1bb5649d9a6af$var$hash.ripemd160 = $7ae1bb5649d9a6af$var$hash.ripemd.ripemd160;

});
parcelRegister("bQpLZ", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $89f88b01f83b341b$export$69f1b2dcda23c5f8; }, function (v) { return $89f88b01f83b341b$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $89f88b01f83b341b$export$45b10814cc054894; }, function (v) { return $89f88b01f83b341b$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $89f88b01f83b341b$export$7ea66e3774a60b67; }, function (v) { return $89f88b01f83b341b$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $89f88b01f83b341b$export$34a52f00f601f6f1; }, function (v) { return $89f88b01f83b341b$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $89f88b01f83b341b$export$812b0cbd5e8a72ab; }, function (v) { return $89f88b01f83b341b$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $89f88b01f83b341b$export$f24f9e11d63bb314; }, function (v) { return $89f88b01f83b341b$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $89f88b01f83b341b$export$b71357c7e07ca1f1; }, function (v) { return $89f88b01f83b341b$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $89f88b01f83b341b$export$2e58a4b541fdcbe8; }, function (v) { return $89f88b01f83b341b$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $89f88b01f83b341b$export$183b950bde9faab8; }, function (v) { return $89f88b01f83b341b$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $89f88b01f83b341b$export$4785c77169fea59e; }, function (v) { return $89f88b01f83b341b$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $89f88b01f83b341b$export$242a185dfcffac5b; }, function (v) { return $89f88b01f83b341b$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $89f88b01f83b341b$export$58c04ae0ae31877d; }, function (v) { return $89f88b01f83b341b$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $89f88b01f83b341b$export$d058ca695f8c6f11; }, function (v) { return $89f88b01f83b341b$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $89f88b01f83b341b$export$a1efd7fc3e986367; }, function (v) { return $89f88b01f83b341b$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $89f88b01f83b341b$export$bbfea4a2b5abaab4; }, function (v) { return $89f88b01f83b341b$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $89f88b01f83b341b$export$97ad4afc7de86152; }, function (v) { return $89f88b01f83b341b$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $89f88b01f83b341b$export$ce4673d9a79f6a4b; }, function (v) { return $89f88b01f83b341b$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $89f88b01f83b341b$export$786cc99fc6eedc0b; }, function (v) { return $89f88b01f83b341b$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $89f88b01f83b341b$export$45c59b9a1848dd0; }, function (v) { return $89f88b01f83b341b$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $89f88b01f83b341b$export$50d8f613e76d3034; }, function (v) { return $89f88b01f83b341b$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $89f88b01f83b341b$export$b8e83683c60ee162; }, function (v) { return $89f88b01f83b341b$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $89f88b01f83b341b$export$aeeb51790d1bcc4a; }, function (v) { return $89f88b01f83b341b$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $89f88b01f83b341b$export$bb7c616f719ad9c; }, function (v) { return $89f88b01f83b341b$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $89f88b01f83b341b$export$4d63290824f9d7df; }, function (v) { return $89f88b01f83b341b$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $89f88b01f83b341b$export$2f64ceb90ef28ea1; }, function (v) { return $89f88b01f83b341b$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $89f88b01f83b341b$export$8d2089d465f6d10d; }, function (v) { return $89f88b01f83b341b$export$8d2089d465f6d10d = v; });
var $89f88b01f83b341b$export$69f1b2dcda23c5f8;
var $89f88b01f83b341b$export$45b10814cc054894;
var $89f88b01f83b341b$export$7ea66e3774a60b67;
var $89f88b01f83b341b$export$34a52f00f601f6f1;
var $89f88b01f83b341b$export$812b0cbd5e8a72ab;
var $89f88b01f83b341b$export$f24f9e11d63bb314;
var $89f88b01f83b341b$export$b71357c7e07ca1f1;
var $89f88b01f83b341b$export$2e58a4b541fdcbe8;
var $89f88b01f83b341b$export$183b950bde9faab8;
var $89f88b01f83b341b$export$4785c77169fea59e;
var $89f88b01f83b341b$export$242a185dfcffac5b;
var $89f88b01f83b341b$export$58c04ae0ae31877d;
var $89f88b01f83b341b$export$d058ca695f8c6f11;
var $89f88b01f83b341b$export$a1efd7fc3e986367;
var $89f88b01f83b341b$export$bbfea4a2b5abaab4;
var $89f88b01f83b341b$export$97ad4afc7de86152;
var $89f88b01f83b341b$export$ce4673d9a79f6a4b;
var $89f88b01f83b341b$export$786cc99fc6eedc0b;
var $89f88b01f83b341b$export$45c59b9a1848dd0;
var $89f88b01f83b341b$export$50d8f613e76d3034;
var $89f88b01f83b341b$export$b8e83683c60ee162;
var $89f88b01f83b341b$export$aeeb51790d1bcc4a;
var $89f88b01f83b341b$export$bb7c616f719ad9c;
var $89f88b01f83b341b$export$4d63290824f9d7df;
var $89f88b01f83b341b$export$2f64ceb90ef28ea1;
var $89f88b01f83b341b$export$8d2089d465f6d10d;
"use strict";

var $jELZv = parcelRequire("jELZv");

var $dncHQ = parcelRequire("dncHQ");
$89f88b01f83b341b$export$69f1b2dcda23c5f8 = $dncHQ;
function $89f88b01f83b341b$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $89f88b01f83b341b$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($89f88b01f83b341b$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$89f88b01f83b341b$export$45b10814cc054894 = $89f88b01f83b341b$var$toArray;
function $89f88b01f83b341b$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $89f88b01f83b341b$var$zero2(msg[i].toString(16));
    return res;
}
$89f88b01f83b341b$export$7ea66e3774a60b67 = $89f88b01f83b341b$var$toHex;
function $89f88b01f83b341b$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$89f88b01f83b341b$export$34a52f00f601f6f1 = $89f88b01f83b341b$var$htonl;
function $89f88b01f83b341b$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $89f88b01f83b341b$var$htonl(w);
        res += $89f88b01f83b341b$var$zero8(w.toString(16));
    }
    return res;
}
$89f88b01f83b341b$export$812b0cbd5e8a72ab = $89f88b01f83b341b$var$toHex32;
function $89f88b01f83b341b$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$89f88b01f83b341b$export$f24f9e11d63bb314 = $89f88b01f83b341b$var$zero2;
function $89f88b01f83b341b$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$89f88b01f83b341b$export$b71357c7e07ca1f1 = $89f88b01f83b341b$var$zero8;
function $89f88b01f83b341b$var$join32(msg, start, end, endian) {
    var len = end - start;
    $jELZv(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$89f88b01f83b341b$export$2e58a4b541fdcbe8 = $89f88b01f83b341b$var$join32;
function $89f88b01f83b341b$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$89f88b01f83b341b$export$183b950bde9faab8 = $89f88b01f83b341b$var$split32;
function $89f88b01f83b341b$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$89f88b01f83b341b$export$4785c77169fea59e = $89f88b01f83b341b$var$rotr32;
function $89f88b01f83b341b$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$89f88b01f83b341b$export$242a185dfcffac5b = $89f88b01f83b341b$var$rotl32;
function $89f88b01f83b341b$var$sum32(a, b) {
    return a + b >>> 0;
}
$89f88b01f83b341b$export$58c04ae0ae31877d = $89f88b01f83b341b$var$sum32;
function $89f88b01f83b341b$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$89f88b01f83b341b$export$d058ca695f8c6f11 = $89f88b01f83b341b$var$sum32_3;
function $89f88b01f83b341b$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$89f88b01f83b341b$export$a1efd7fc3e986367 = $89f88b01f83b341b$var$sum32_4;
function $89f88b01f83b341b$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$89f88b01f83b341b$export$bbfea4a2b5abaab4 = $89f88b01f83b341b$var$sum32_5;
function $89f88b01f83b341b$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$89f88b01f83b341b$export$97ad4afc7de86152 = $89f88b01f83b341b$var$sum64;
function $89f88b01f83b341b$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$89f88b01f83b341b$export$ce4673d9a79f6a4b = $89f88b01f83b341b$var$sum64_hi;
function $89f88b01f83b341b$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$89f88b01f83b341b$export$786cc99fc6eedc0b = $89f88b01f83b341b$var$sum64_lo;
function $89f88b01f83b341b$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$89f88b01f83b341b$export$45c59b9a1848dd0 = $89f88b01f83b341b$var$sum64_4_hi;
function $89f88b01f83b341b$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$89f88b01f83b341b$export$50d8f613e76d3034 = $89f88b01f83b341b$var$sum64_4_lo;
function $89f88b01f83b341b$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$89f88b01f83b341b$export$b8e83683c60ee162 = $89f88b01f83b341b$var$sum64_5_hi;
function $89f88b01f83b341b$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$89f88b01f83b341b$export$aeeb51790d1bcc4a = $89f88b01f83b341b$var$sum64_5_lo;
function $89f88b01f83b341b$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$89f88b01f83b341b$export$bb7c616f719ad9c = $89f88b01f83b341b$var$rotr64_hi;
function $89f88b01f83b341b$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$89f88b01f83b341b$export$4d63290824f9d7df = $89f88b01f83b341b$var$rotr64_lo;
function $89f88b01f83b341b$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$89f88b01f83b341b$export$2f64ceb90ef28ea1 = $89f88b01f83b341b$var$shr64_hi;
function $89f88b01f83b341b$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$89f88b01f83b341b$export$8d2089d465f6d10d = $89f88b01f83b341b$var$shr64_lo;

});
parcelRegister("jELZv", function(module, exports) {
module.exports = $e4f6fabe40207fd0$var$assert;
function $e4f6fabe40207fd0$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$e4f6fabe40207fd0$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});

parcelRegister("dncHQ", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("lvZCX", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $fa9c4c281ae66363$export$8687658379b577e6; }, function (v) { return $fa9c4c281ae66363$export$8687658379b577e6 = v; });
var $fa9c4c281ae66363$export$8687658379b577e6;
"use strict";

var $bQpLZ = parcelRequire("bQpLZ");

var $jELZv = parcelRequire("jELZv");
function $fa9c4c281ae66363$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$fa9c4c281ae66363$export$8687658379b577e6 = $fa9c4c281ae66363$var$BlockHash;
$fa9c4c281ae66363$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $bQpLZ.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $bQpLZ.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$fa9c4c281ae66363$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $jELZv(this.pending === null);
    return this._digest(enc);
};
$fa9c4c281ae66363$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("fxTOD", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $b5153bed64ed2126$export$5091bdda49ba90f5; }, function (v) { return $b5153bed64ed2126$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $b5153bed64ed2126$export$97b70509d4e397ea; }, function (v) { return $b5153bed64ed2126$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $b5153bed64ed2126$export$bced8d2aada2d1c9; }, function (v) { return $b5153bed64ed2126$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $b5153bed64ed2126$export$612d47d55dedde45; }, function (v) { return $b5153bed64ed2126$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $b5153bed64ed2126$export$a888d2532e6dc7bb; }, function (v) { return $b5153bed64ed2126$export$a888d2532e6dc7bb = v; });
var $b5153bed64ed2126$export$5091bdda49ba90f5;
var $b5153bed64ed2126$export$97b70509d4e397ea;
var $b5153bed64ed2126$export$bced8d2aada2d1c9;
var $b5153bed64ed2126$export$612d47d55dedde45;
var $b5153bed64ed2126$export$a888d2532e6dc7bb;
"use strict";

$b5153bed64ed2126$export$5091bdda49ba90f5 = (parcelRequire("8bNBR"));

$b5153bed64ed2126$export$97b70509d4e397ea = (parcelRequire("f76xe"));

$b5153bed64ed2126$export$bced8d2aada2d1c9 = (parcelRequire("eRvSh"));

$b5153bed64ed2126$export$612d47d55dedde45 = (parcelRequire("dfWTA"));

$b5153bed64ed2126$export$a888d2532e6dc7bb = (parcelRequire("fkKN3"));

});
parcelRegister("8bNBR", function(module, exports) {
"use strict";

var $bQpLZ = parcelRequire("bQpLZ");

var $lvZCX = parcelRequire("lvZCX");

var $4bKMe = parcelRequire("4bKMe");
var $5f65d541207db996$var$rotl32 = $bQpLZ.rotl32;
var $5f65d541207db996$var$sum32 = $bQpLZ.sum32;
var $5f65d541207db996$var$sum32_5 = $bQpLZ.sum32_5;
var $5f65d541207db996$var$ft_1 = $4bKMe.ft_1;
var $5f65d541207db996$var$BlockHash = $lvZCX.BlockHash;
var $5f65d541207db996$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $5f65d541207db996$var$SHA1() {
    if (!(this instanceof $5f65d541207db996$var$SHA1)) return new $5f65d541207db996$var$SHA1();
    $5f65d541207db996$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$bQpLZ.inherits($5f65d541207db996$var$SHA1, $5f65d541207db996$var$BlockHash);
module.exports = $5f65d541207db996$var$SHA1;
$5f65d541207db996$var$SHA1.blockSize = 512;
$5f65d541207db996$var$SHA1.outSize = 160;
$5f65d541207db996$var$SHA1.hmacStrength = 80;
$5f65d541207db996$var$SHA1.padLength = 64;
$5f65d541207db996$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $5f65d541207db996$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $5f65d541207db996$var$sum32_5($5f65d541207db996$var$rotl32(a, 5), $5f65d541207db996$var$ft_1(s, b, c, d), e, W[i], $5f65d541207db996$var$sha1_K[s]);
        e = d;
        d = c;
        c = $5f65d541207db996$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $5f65d541207db996$var$sum32(this.h[0], a);
    this.h[1] = $5f65d541207db996$var$sum32(this.h[1], b);
    this.h[2] = $5f65d541207db996$var$sum32(this.h[2], c);
    this.h[3] = $5f65d541207db996$var$sum32(this.h[3], d);
    this.h[4] = $5f65d541207db996$var$sum32(this.h[4], e);
};
$5f65d541207db996$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $bQpLZ.toHex32(this.h, "big");
    else return $bQpLZ.split32(this.h, "big");
};

});
parcelRegister("4bKMe", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $30cc796db0c6e5fb$export$5a92649d7ddb9f63; }, function (v) { return $30cc796db0c6e5fb$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $30cc796db0c6e5fb$export$c6d0d020c3a6269; }, function (v) { return $30cc796db0c6e5fb$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $30cc796db0c6e5fb$export$eb90c27fca05f956; }, function (v) { return $30cc796db0c6e5fb$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $30cc796db0c6e5fb$export$14a4a98e063b1999; }, function (v) { return $30cc796db0c6e5fb$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $30cc796db0c6e5fb$export$d20cecfa1564c686; }, function (v) { return $30cc796db0c6e5fb$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $30cc796db0c6e5fb$export$44fd472a12fc6db; }, function (v) { return $30cc796db0c6e5fb$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $30cc796db0c6e5fb$export$1ed238bb6ea1dd47; }, function (v) { return $30cc796db0c6e5fb$export$1ed238bb6ea1dd47 = v; });
var $30cc796db0c6e5fb$export$5a92649d7ddb9f63;
var $30cc796db0c6e5fb$export$c6d0d020c3a6269;
var $30cc796db0c6e5fb$export$eb90c27fca05f956;
var $30cc796db0c6e5fb$export$cc992891a14496a1;
var $30cc796db0c6e5fb$export$14a4a98e063b1999;
var $30cc796db0c6e5fb$export$d20cecfa1564c686;
var $30cc796db0c6e5fb$export$44fd472a12fc6db;
var $30cc796db0c6e5fb$export$1ed238bb6ea1dd47;
"use strict";

var $bQpLZ = parcelRequire("bQpLZ");
var $30cc796db0c6e5fb$var$rotr32 = $bQpLZ.rotr32;
function $30cc796db0c6e5fb$var$ft_1(s, x, y, z) {
    if (s === 0) return $30cc796db0c6e5fb$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $30cc796db0c6e5fb$var$p32(x, y, z);
    if (s === 2) return $30cc796db0c6e5fb$var$maj32(x, y, z);
}
$30cc796db0c6e5fb$export$5a92649d7ddb9f63 = $30cc796db0c6e5fb$var$ft_1;
function $30cc796db0c6e5fb$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$30cc796db0c6e5fb$export$c6d0d020c3a6269 = $30cc796db0c6e5fb$var$ch32;
function $30cc796db0c6e5fb$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$30cc796db0c6e5fb$export$eb90c27fca05f956 = $30cc796db0c6e5fb$var$maj32;
function $30cc796db0c6e5fb$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$30cc796db0c6e5fb$export$cc992891a14496a1 = $30cc796db0c6e5fb$var$p32;
function $30cc796db0c6e5fb$var$s0_256(x) {
    return $30cc796db0c6e5fb$var$rotr32(x, 2) ^ $30cc796db0c6e5fb$var$rotr32(x, 13) ^ $30cc796db0c6e5fb$var$rotr32(x, 22);
}
$30cc796db0c6e5fb$export$14a4a98e063b1999 = $30cc796db0c6e5fb$var$s0_256;
function $30cc796db0c6e5fb$var$s1_256(x) {
    return $30cc796db0c6e5fb$var$rotr32(x, 6) ^ $30cc796db0c6e5fb$var$rotr32(x, 11) ^ $30cc796db0c6e5fb$var$rotr32(x, 25);
}
$30cc796db0c6e5fb$export$d20cecfa1564c686 = $30cc796db0c6e5fb$var$s1_256;
function $30cc796db0c6e5fb$var$g0_256(x) {
    return $30cc796db0c6e5fb$var$rotr32(x, 7) ^ $30cc796db0c6e5fb$var$rotr32(x, 18) ^ x >>> 3;
}
$30cc796db0c6e5fb$export$44fd472a12fc6db = $30cc796db0c6e5fb$var$g0_256;
function $30cc796db0c6e5fb$var$g1_256(x) {
    return $30cc796db0c6e5fb$var$rotr32(x, 17) ^ $30cc796db0c6e5fb$var$rotr32(x, 19) ^ x >>> 10;
}
$30cc796db0c6e5fb$export$1ed238bb6ea1dd47 = $30cc796db0c6e5fb$var$g1_256;

});


parcelRegister("f76xe", function(module, exports) {
"use strict";

var $bQpLZ = parcelRequire("bQpLZ");

var $eRvSh = parcelRequire("eRvSh");
function $b00c9427febdbae9$var$SHA224() {
    if (!(this instanceof $b00c9427febdbae9$var$SHA224)) return new $b00c9427febdbae9$var$SHA224();
    $eRvSh.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$bQpLZ.inherits($b00c9427febdbae9$var$SHA224, $eRvSh);
module.exports = $b00c9427febdbae9$var$SHA224;
$b00c9427febdbae9$var$SHA224.blockSize = 512;
$b00c9427febdbae9$var$SHA224.outSize = 224;
$b00c9427febdbae9$var$SHA224.hmacStrength = 192;
$b00c9427febdbae9$var$SHA224.padLength = 64;
$b00c9427febdbae9$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $bQpLZ.toHex32(this.h.slice(0, 7), "big");
    else return $bQpLZ.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("eRvSh", function(module, exports) {
"use strict";

var $bQpLZ = parcelRequire("bQpLZ");

var $lvZCX = parcelRequire("lvZCX");

var $4bKMe = parcelRequire("4bKMe");

var $jELZv = parcelRequire("jELZv");
var $ad1ebd8677e4a391$var$sum32 = $bQpLZ.sum32;
var $ad1ebd8677e4a391$var$sum32_4 = $bQpLZ.sum32_4;
var $ad1ebd8677e4a391$var$sum32_5 = $bQpLZ.sum32_5;
var $ad1ebd8677e4a391$var$ch32 = $4bKMe.ch32;
var $ad1ebd8677e4a391$var$maj32 = $4bKMe.maj32;
var $ad1ebd8677e4a391$var$s0_256 = $4bKMe.s0_256;
var $ad1ebd8677e4a391$var$s1_256 = $4bKMe.s1_256;
var $ad1ebd8677e4a391$var$g0_256 = $4bKMe.g0_256;
var $ad1ebd8677e4a391$var$g1_256 = $4bKMe.g1_256;
var $ad1ebd8677e4a391$var$BlockHash = $lvZCX.BlockHash;
var $ad1ebd8677e4a391$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $ad1ebd8677e4a391$var$SHA256() {
    if (!(this instanceof $ad1ebd8677e4a391$var$SHA256)) return new $ad1ebd8677e4a391$var$SHA256();
    $ad1ebd8677e4a391$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $ad1ebd8677e4a391$var$sha256_K;
    this.W = new Array(64);
}
$bQpLZ.inherits($ad1ebd8677e4a391$var$SHA256, $ad1ebd8677e4a391$var$BlockHash);
module.exports = $ad1ebd8677e4a391$var$SHA256;
$ad1ebd8677e4a391$var$SHA256.blockSize = 512;
$ad1ebd8677e4a391$var$SHA256.outSize = 256;
$ad1ebd8677e4a391$var$SHA256.hmacStrength = 192;
$ad1ebd8677e4a391$var$SHA256.padLength = 64;
$ad1ebd8677e4a391$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $ad1ebd8677e4a391$var$sum32_4($ad1ebd8677e4a391$var$g1_256(W[i - 2]), W[i - 7], $ad1ebd8677e4a391$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $jELZv(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $ad1ebd8677e4a391$var$sum32_5(h, $ad1ebd8677e4a391$var$s1_256(e), $ad1ebd8677e4a391$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $ad1ebd8677e4a391$var$sum32($ad1ebd8677e4a391$var$s0_256(a), $ad1ebd8677e4a391$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $ad1ebd8677e4a391$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $ad1ebd8677e4a391$var$sum32(T1, T2);
    }
    this.h[0] = $ad1ebd8677e4a391$var$sum32(this.h[0], a);
    this.h[1] = $ad1ebd8677e4a391$var$sum32(this.h[1], b);
    this.h[2] = $ad1ebd8677e4a391$var$sum32(this.h[2], c);
    this.h[3] = $ad1ebd8677e4a391$var$sum32(this.h[3], d);
    this.h[4] = $ad1ebd8677e4a391$var$sum32(this.h[4], e);
    this.h[5] = $ad1ebd8677e4a391$var$sum32(this.h[5], f);
    this.h[6] = $ad1ebd8677e4a391$var$sum32(this.h[6], g);
    this.h[7] = $ad1ebd8677e4a391$var$sum32(this.h[7], h);
};
$ad1ebd8677e4a391$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $bQpLZ.toHex32(this.h, "big");
    else return $bQpLZ.split32(this.h, "big");
};

});


parcelRegister("dfWTA", function(module, exports) {
"use strict";

var $bQpLZ = parcelRequire("bQpLZ");

var $fkKN3 = parcelRequire("fkKN3");
function $9a6a5c8593782ac0$var$SHA384() {
    if (!(this instanceof $9a6a5c8593782ac0$var$SHA384)) return new $9a6a5c8593782ac0$var$SHA384();
    $fkKN3.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$bQpLZ.inherits($9a6a5c8593782ac0$var$SHA384, $fkKN3);
module.exports = $9a6a5c8593782ac0$var$SHA384;
$9a6a5c8593782ac0$var$SHA384.blockSize = 1024;
$9a6a5c8593782ac0$var$SHA384.outSize = 384;
$9a6a5c8593782ac0$var$SHA384.hmacStrength = 192;
$9a6a5c8593782ac0$var$SHA384.padLength = 128;
$9a6a5c8593782ac0$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $bQpLZ.toHex32(this.h.slice(0, 12), "big");
    else return $bQpLZ.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("fkKN3", function(module, exports) {
"use strict";

var $bQpLZ = parcelRequire("bQpLZ");

var $lvZCX = parcelRequire("lvZCX");

var $jELZv = parcelRequire("jELZv");
var $b29d04d7d526adb2$var$rotr64_hi = $bQpLZ.rotr64_hi;
var $b29d04d7d526adb2$var$rotr64_lo = $bQpLZ.rotr64_lo;
var $b29d04d7d526adb2$var$shr64_hi = $bQpLZ.shr64_hi;
var $b29d04d7d526adb2$var$shr64_lo = $bQpLZ.shr64_lo;
var $b29d04d7d526adb2$var$sum64 = $bQpLZ.sum64;
var $b29d04d7d526adb2$var$sum64_hi = $bQpLZ.sum64_hi;
var $b29d04d7d526adb2$var$sum64_lo = $bQpLZ.sum64_lo;
var $b29d04d7d526adb2$var$sum64_4_hi = $bQpLZ.sum64_4_hi;
var $b29d04d7d526adb2$var$sum64_4_lo = $bQpLZ.sum64_4_lo;
var $b29d04d7d526adb2$var$sum64_5_hi = $bQpLZ.sum64_5_hi;
var $b29d04d7d526adb2$var$sum64_5_lo = $bQpLZ.sum64_5_lo;
var $b29d04d7d526adb2$var$BlockHash = $lvZCX.BlockHash;
var $b29d04d7d526adb2$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $b29d04d7d526adb2$var$SHA512() {
    if (!(this instanceof $b29d04d7d526adb2$var$SHA512)) return new $b29d04d7d526adb2$var$SHA512();
    $b29d04d7d526adb2$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $b29d04d7d526adb2$var$sha512_K;
    this.W = new Array(160);
}
$bQpLZ.inherits($b29d04d7d526adb2$var$SHA512, $b29d04d7d526adb2$var$BlockHash);
module.exports = $b29d04d7d526adb2$var$SHA512;
$b29d04d7d526adb2$var$SHA512.blockSize = 1024;
$b29d04d7d526adb2$var$SHA512.outSize = 512;
$b29d04d7d526adb2$var$SHA512.hmacStrength = 192;
$b29d04d7d526adb2$var$SHA512.padLength = 128;
$b29d04d7d526adb2$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $b29d04d7d526adb2$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $b29d04d7d526adb2$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $b29d04d7d526adb2$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $b29d04d7d526adb2$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $b29d04d7d526adb2$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $b29d04d7d526adb2$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$b29d04d7d526adb2$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $jELZv(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $b29d04d7d526adb2$var$s1_512_hi(eh, el);
        var c1_lo = $b29d04d7d526adb2$var$s1_512_lo(eh, el);
        var c2_hi = $b29d04d7d526adb2$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $b29d04d7d526adb2$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $b29d04d7d526adb2$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $b29d04d7d526adb2$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $b29d04d7d526adb2$var$s0_512_hi(ah, al);
        c0_lo = $b29d04d7d526adb2$var$s0_512_lo(ah, al);
        c1_hi = $b29d04d7d526adb2$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $b29d04d7d526adb2$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $b29d04d7d526adb2$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $b29d04d7d526adb2$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $b29d04d7d526adb2$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $b29d04d7d526adb2$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $b29d04d7d526adb2$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $b29d04d7d526adb2$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $b29d04d7d526adb2$var$sum64(this.h, 0, ah, al);
    $b29d04d7d526adb2$var$sum64(this.h, 2, bh, bl);
    $b29d04d7d526adb2$var$sum64(this.h, 4, ch, cl);
    $b29d04d7d526adb2$var$sum64(this.h, 6, dh, dl);
    $b29d04d7d526adb2$var$sum64(this.h, 8, eh, el);
    $b29d04d7d526adb2$var$sum64(this.h, 10, fh, fl);
    $b29d04d7d526adb2$var$sum64(this.h, 12, gh, gl);
    $b29d04d7d526adb2$var$sum64(this.h, 14, hh, hl);
};
$b29d04d7d526adb2$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $bQpLZ.toHex32(this.h, "big");
    else return $bQpLZ.split32(this.h, "big");
};
function $b29d04d7d526adb2$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $b29d04d7d526adb2$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $b29d04d7d526adb2$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $b29d04d7d526adb2$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $b29d04d7d526adb2$var$s0_512_hi(xh, xl) {
    var c0_hi = $b29d04d7d526adb2$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $b29d04d7d526adb2$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $b29d04d7d526adb2$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $b29d04d7d526adb2$var$s0_512_lo(xh, xl) {
    var c0_lo = $b29d04d7d526adb2$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $b29d04d7d526adb2$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $b29d04d7d526adb2$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $b29d04d7d526adb2$var$s1_512_hi(xh, xl) {
    var c0_hi = $b29d04d7d526adb2$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $b29d04d7d526adb2$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $b29d04d7d526adb2$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $b29d04d7d526adb2$var$s1_512_lo(xh, xl) {
    var c0_lo = $b29d04d7d526adb2$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $b29d04d7d526adb2$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $b29d04d7d526adb2$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $b29d04d7d526adb2$var$g0_512_hi(xh, xl) {
    var c0_hi = $b29d04d7d526adb2$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $b29d04d7d526adb2$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $b29d04d7d526adb2$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $b29d04d7d526adb2$var$g0_512_lo(xh, xl) {
    var c0_lo = $b29d04d7d526adb2$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $b29d04d7d526adb2$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $b29d04d7d526adb2$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $b29d04d7d526adb2$var$g1_512_hi(xh, xl) {
    var c0_hi = $b29d04d7d526adb2$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $b29d04d7d526adb2$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $b29d04d7d526adb2$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $b29d04d7d526adb2$var$g1_512_lo(xh, xl) {
    var c0_lo = $b29d04d7d526adb2$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $b29d04d7d526adb2$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $b29d04d7d526adb2$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("107Nk", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $0babd6627fd08834$export$d1cea0ee4e3f0d3e; }, function (v) { return $0babd6627fd08834$export$d1cea0ee4e3f0d3e = v; });
var $0babd6627fd08834$export$d1cea0ee4e3f0d3e;
"use strict";

var $bQpLZ = parcelRequire("bQpLZ");

var $lvZCX = parcelRequire("lvZCX");
var $0babd6627fd08834$var$rotl32 = $bQpLZ.rotl32;
var $0babd6627fd08834$var$sum32 = $bQpLZ.sum32;
var $0babd6627fd08834$var$sum32_3 = $bQpLZ.sum32_3;
var $0babd6627fd08834$var$sum32_4 = $bQpLZ.sum32_4;
var $0babd6627fd08834$var$BlockHash = $lvZCX.BlockHash;
function $0babd6627fd08834$var$RIPEMD160() {
    if (!(this instanceof $0babd6627fd08834$var$RIPEMD160)) return new $0babd6627fd08834$var$RIPEMD160();
    $0babd6627fd08834$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$bQpLZ.inherits($0babd6627fd08834$var$RIPEMD160, $0babd6627fd08834$var$BlockHash);
$0babd6627fd08834$export$d1cea0ee4e3f0d3e = $0babd6627fd08834$var$RIPEMD160;
$0babd6627fd08834$var$RIPEMD160.blockSize = 512;
$0babd6627fd08834$var$RIPEMD160.outSize = 160;
$0babd6627fd08834$var$RIPEMD160.hmacStrength = 192;
$0babd6627fd08834$var$RIPEMD160.padLength = 64;
$0babd6627fd08834$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $0babd6627fd08834$var$sum32($0babd6627fd08834$var$rotl32($0babd6627fd08834$var$sum32_4(A, $0babd6627fd08834$var$f(j, B, C, D), msg[$0babd6627fd08834$var$r[j] + start], $0babd6627fd08834$var$K(j)), $0babd6627fd08834$var$s[j]), E);
        A = E;
        E = D;
        D = $0babd6627fd08834$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $0babd6627fd08834$var$sum32($0babd6627fd08834$var$rotl32($0babd6627fd08834$var$sum32_4(Ah, $0babd6627fd08834$var$f(79 - j, Bh, Ch, Dh), msg[$0babd6627fd08834$var$rh[j] + start], $0babd6627fd08834$var$Kh(j)), $0babd6627fd08834$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $0babd6627fd08834$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $0babd6627fd08834$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $0babd6627fd08834$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $0babd6627fd08834$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $0babd6627fd08834$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $0babd6627fd08834$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$0babd6627fd08834$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $bQpLZ.toHex32(this.h, "little");
    else return $bQpLZ.split32(this.h, "little");
};
function $0babd6627fd08834$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $0babd6627fd08834$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $0babd6627fd08834$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $0babd6627fd08834$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $0babd6627fd08834$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $0babd6627fd08834$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $0babd6627fd08834$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("1AmBq", function(module, exports) {
"use strict";

var $bQpLZ = parcelRequire("bQpLZ");

var $jELZv = parcelRequire("jELZv");
function $127aafaccd611722$var$Hmac(hash, key, enc) {
    if (!(this instanceof $127aafaccd611722$var$Hmac)) return new $127aafaccd611722$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($bQpLZ.toArray(key, enc));
}
module.exports = $127aafaccd611722$var$Hmac;
$127aafaccd611722$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $jELZv(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$127aafaccd611722$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$127aafaccd611722$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});



parcelRegister("bL3SH", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $88f71838da10cc2d$export$83d89fbfd8236492; });
const $88f71838da10cc2d$export$83d89fbfd8236492 = "signing-key/5.7.0";

});


parcelRegister("igClu", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $d4c7773e94574ecf$export$83d89fbfd8236492; });
const $d4c7773e94574ecf$export$83d89fbfd8236492 = "transactions/5.7.0";

});


parcelRegister("gipJy", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $bdd249f459716199$export$83d89fbfd8236492; });
const $bdd249f459716199$export$83d89fbfd8236492 = "contracts/5.7.0";

});


parcelRegister("jR8eo", function(module, exports) {

$parcel$export(module.exports, "formatFixed", function () { return $e7495a1a2cd64df4$export$cc011b843b5d69f2; });
$parcel$export(module.exports, "parseFixed", function () { return $e7495a1a2cd64df4$export$1b039987e86d7269; });
$parcel$export(module.exports, "FixedNumber", function () { return $e7495a1a2cd64df4$export$d4693c66c2213e45; });

var $eBLyT = parcelRequire("eBLyT");

var $4NCF1 = parcelRequire("4NCF1");

var $ccRSE = parcelRequire("ccRSE");

var $20M69 = parcelRequire("20M69");
"use strict";
const $e7495a1a2cd64df4$var$logger = new (0, $4NCF1.Logger)((0, $ccRSE.version));
const $e7495a1a2cd64df4$var$_constructorGuard = {};
const $e7495a1a2cd64df4$var$Zero = (0, $20M69.BigNumber).from(0);
const $e7495a1a2cd64df4$var$NegativeOne = (0, $20M69.BigNumber).from(-1);
function $e7495a1a2cd64df4$var$throwFault(message, fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value !== undefined) params.value = value;
    return $e7495a1a2cd64df4$var$logger.throwError(message, (0, $4NCF1.Logger).errors.NUMERIC_FAULT, params);
}
// Constant to pull zeros from for multipliers
let $e7495a1a2cd64df4$var$zeros = "0";
while($e7495a1a2cd64df4$var$zeros.length < 256)$e7495a1a2cd64df4$var$zeros += $e7495a1a2cd64df4$var$zeros;
// Returns a string "1" followed by decimal "0"s
function $e7495a1a2cd64df4$var$getMultiplier(decimals) {
    if (typeof decimals !== "number") try {
        decimals = (0, $20M69.BigNumber).from(decimals).toNumber();
    } catch (e) {}
    if (typeof decimals === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) return "1" + $e7495a1a2cd64df4$var$zeros.substring(0, decimals);
    return $e7495a1a2cd64df4$var$logger.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function $e7495a1a2cd64df4$export$cc011b843b5d69f2(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $e7495a1a2cd64df4$var$getMultiplier(decimals);
    // Make sure wei is a big number (convert as necessary)
    value = (0, $20M69.BigNumber).from(value);
    const negative = value.lt($e7495a1a2cd64df4$var$Zero);
    if (negative) value = value.mul($e7495a1a2cd64df4$var$NegativeOne);
    let fraction = value.mod(multiplier).toString();
    while(fraction.length < multiplier.length - 1)fraction = "0" + fraction;
    // Strip training 0
    fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    const whole = value.div(multiplier).toString();
    if (multiplier.length === 1) value = whole;
    else value = whole + "." + fraction;
    if (negative) value = "-" + value;
    return value;
}
function $e7495a1a2cd64df4$export$1b039987e86d7269(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $e7495a1a2cd64df4$var$getMultiplier(decimals);
    if (typeof value !== "string" || !value.match(/^-?[0-9.]+$/)) $e7495a1a2cd64df4$var$logger.throwArgumentError("invalid decimal value", "value", value);
    // Is it negative?
    const negative = value.substring(0, 1) === "-";
    if (negative) value = value.substring(1);
    if (value === ".") $e7495a1a2cd64df4$var$logger.throwArgumentError("missing value", "value", value);
    // Split it into a whole and fractional part
    const comps = value.split(".");
    if (comps.length > 2) $e7495a1a2cd64df4$var$logger.throwArgumentError("too many decimal points", "value", value);
    let whole = comps[0], fraction = comps[1];
    if (!whole) whole = "0";
    if (!fraction) fraction = "0";
    // Trim trailing zeros
    while(fraction[fraction.length - 1] === "0")fraction = fraction.substring(0, fraction.length - 1);
    // Check the fraction doesn't exceed our decimals size
    if (fraction.length > multiplier.length - 1) $e7495a1a2cd64df4$var$throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
    // If decimals is 0, we have an empty string for fraction
    if (fraction === "") fraction = "0";
    // Fully pad the string with zeros to get to wei
    while(fraction.length < multiplier.length - 1)fraction += "0";
    const wholeValue = (0, $20M69.BigNumber).from(whole);
    const fractionValue = (0, $20M69.BigNumber).from(fraction);
    let wei = wholeValue.mul(multiplier).add(fractionValue);
    if (negative) wei = wei.mul($e7495a1a2cd64df4$var$NegativeOne);
    return wei;
}
class $e7495a1a2cd64df4$export$1f3ec5b8f47ebd4d {
    constructor(constructorGuard, signed, width, decimals){
        if (constructorGuard !== $e7495a1a2cd64df4$var$_constructorGuard) $e7495a1a2cd64df4$var$logger.throwError("cannot use FixedFormat constructor; use FixedFormat.from", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.signed = signed;
        this.width = width;
        this.decimals = decimals;
        this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
        this._multiplier = $e7495a1a2cd64df4$var$getMultiplier(decimals);
        Object.freeze(this);
    }
    static from(value) {
        if (value instanceof $e7495a1a2cd64df4$export$1f3ec5b8f47ebd4d) return value;
        if (typeof value === "number") value = `fixed128x${value}`;
        let signed = true;
        let width = 128;
        let decimals = 18;
        if (typeof value === "string") {
            if (value === "fixed") ;
            else if (value === "ufixed") signed = false;
            else {
                const match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                if (!match) $e7495a1a2cd64df4$var$logger.throwArgumentError("invalid fixed format", "format", value);
                signed = match[1] !== "u";
                width = parseInt(match[2]);
                decimals = parseInt(match[3]);
            }
        } else if (value) {
            const check = (key, type, defaultValue)=>{
                if (value[key] == null) return defaultValue;
                if (typeof value[key] !== type) $e7495a1a2cd64df4$var$logger.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
                return value[key];
            };
            signed = check("signed", "boolean", signed);
            width = check("width", "number", width);
            decimals = check("decimals", "number", decimals);
        }
        if (width % 8) $e7495a1a2cd64df4$var$logger.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
        if (decimals > 80) $e7495a1a2cd64df4$var$logger.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
        return new $e7495a1a2cd64df4$export$1f3ec5b8f47ebd4d($e7495a1a2cd64df4$var$_constructorGuard, signed, width, decimals);
    }
}
class $e7495a1a2cd64df4$export$d4693c66c2213e45 {
    constructor(constructorGuard, hex, value, format){
        if (constructorGuard !== $e7495a1a2cd64df4$var$_constructorGuard) $e7495a1a2cd64df4$var$logger.throwError("cannot use FixedNumber constructor; use FixedNumber.from", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.format = format;
        this._hex = hex;
        this._value = value;
        this._isFixedNumber = true;
        Object.freeze(this);
    }
    _checkFormat(other) {
        if (this.format.name !== other.format.name) $e7495a1a2cd64df4$var$logger.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
    }
    addUnsafe(other) {
        this._checkFormat(other);
        const a = $e7495a1a2cd64df4$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $e7495a1a2cd64df4$export$1b039987e86d7269(other._value, other.format.decimals);
        return $e7495a1a2cd64df4$export$d4693c66c2213e45.fromValue(a.add(b), this.format.decimals, this.format);
    }
    subUnsafe(other) {
        this._checkFormat(other);
        const a = $e7495a1a2cd64df4$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $e7495a1a2cd64df4$export$1b039987e86d7269(other._value, other.format.decimals);
        return $e7495a1a2cd64df4$export$d4693c66c2213e45.fromValue(a.sub(b), this.format.decimals, this.format);
    }
    mulUnsafe(other) {
        this._checkFormat(other);
        const a = $e7495a1a2cd64df4$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $e7495a1a2cd64df4$export$1b039987e86d7269(other._value, other.format.decimals);
        return $e7495a1a2cd64df4$export$d4693c66c2213e45.fromValue(a.mul(b).div(this.format._multiplier), this.format.decimals, this.format);
    }
    divUnsafe(other) {
        this._checkFormat(other);
        const a = $e7495a1a2cd64df4$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $e7495a1a2cd64df4$export$1b039987e86d7269(other._value, other.format.decimals);
        return $e7495a1a2cd64df4$export$d4693c66c2213e45.fromValue(a.mul(this.format._multiplier).div(b), this.format.decimals, this.format);
    }
    floor() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $e7495a1a2cd64df4$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (this.isNegative() && hasFraction) result = result.subUnsafe($e7495a1a2cd64df4$var$ONE.toFormat(result.format));
        return result;
    }
    ceiling() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $e7495a1a2cd64df4$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (!this.isNegative() && hasFraction) result = result.addUnsafe($e7495a1a2cd64df4$var$ONE.toFormat(result.format));
        return result;
    }
    // @TODO: Support other rounding algorithms
    round(decimals) {
        if (decimals == null) decimals = 0;
        // If we are already in range, we're done
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        if (decimals < 0 || decimals > 80 || decimals % 1) $e7495a1a2cd64df4$var$logger.throwArgumentError("invalid decimal count", "decimals", decimals);
        if (comps[1].length <= decimals) return this;
        const factor = $e7495a1a2cd64df4$export$d4693c66c2213e45.from("1" + $e7495a1a2cd64df4$var$zeros.substring(0, decimals), this.format);
        const bump = $e7495a1a2cd64df4$var$BUMP.toFormat(this.format);
        return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
    }
    isZero() {
        return this._value === "0.0" || this._value === "0";
    }
    isNegative() {
        return this._value[0] === "-";
    }
    toString() {
        return this._value;
    }
    toHexString(width) {
        if (width == null) return this._hex;
        if (width % 8) $e7495a1a2cd64df4$var$logger.throwArgumentError("invalid byte width", "width", width);
        const hex = (0, $20M69.BigNumber).from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
        return (0, $eBLyT.hexZeroPad)(hex, width / 8);
    }
    toUnsafeFloat() {
        return parseFloat(this.toString());
    }
    toFormat(format) {
        return $e7495a1a2cd64df4$export$d4693c66c2213e45.fromString(this._value, format);
    }
    static fromValue(value, decimals, format) {
        // If decimals looks more like a format, and there is no format, shift the parameters
        if (format == null && decimals != null && !(0, $20M69.isBigNumberish)(decimals)) {
            format = decimals;
            decimals = null;
        }
        if (decimals == null) decimals = 0;
        if (format == null) format = "fixed";
        return $e7495a1a2cd64df4$export$d4693c66c2213e45.fromString($e7495a1a2cd64df4$export$cc011b843b5d69f2(value, decimals), $e7495a1a2cd64df4$export$1f3ec5b8f47ebd4d.from(format));
    }
    static fromString(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $e7495a1a2cd64df4$export$1f3ec5b8f47ebd4d.from(format);
        const numeric = $e7495a1a2cd64df4$export$1b039987e86d7269(value, fixedFormat.decimals);
        if (!fixedFormat.signed && numeric.lt($e7495a1a2cd64df4$var$Zero)) $e7495a1a2cd64df4$var$throwFault("unsigned value cannot be negative", "overflow", "value", value);
        let hex = null;
        if (fixedFormat.signed) hex = numeric.toTwos(fixedFormat.width).toHexString();
        else {
            hex = numeric.toHexString();
            hex = (0, $eBLyT.hexZeroPad)(hex, fixedFormat.width / 8);
        }
        const decimal = $e7495a1a2cd64df4$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $e7495a1a2cd64df4$export$d4693c66c2213e45($e7495a1a2cd64df4$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static fromBytes(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $e7495a1a2cd64df4$export$1f3ec5b8f47ebd4d.from(format);
        if ((0, $eBLyT.arrayify)(value).length > fixedFormat.width / 8) throw new Error("overflow");
        let numeric = (0, $20M69.BigNumber).from(value);
        if (fixedFormat.signed) numeric = numeric.fromTwos(fixedFormat.width);
        const hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
        const decimal = $e7495a1a2cd64df4$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $e7495a1a2cd64df4$export$d4693c66c2213e45($e7495a1a2cd64df4$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static from(value, format) {
        if (typeof value === "string") return $e7495a1a2cd64df4$export$d4693c66c2213e45.fromString(value, format);
        if ((0, $eBLyT.isBytes)(value)) return $e7495a1a2cd64df4$export$d4693c66c2213e45.fromBytes(value, format);
        try {
            return $e7495a1a2cd64df4$export$d4693c66c2213e45.fromValue(value, 0, format);
        } catch (error) {
            // Allow NUMERIC_FAULT to bubble up
            if (error.code !== (0, $4NCF1.Logger).errors.INVALID_ARGUMENT) throw error;
        }
        return $e7495a1a2cd64df4$var$logger.throwArgumentError("invalid FixedNumber value", "value", value);
    }
    static isFixedNumber(value) {
        return !!(value && value._isFixedNumber);
    }
}
const $e7495a1a2cd64df4$var$ONE = $e7495a1a2cd64df4$export$d4693c66c2213e45.from(1);
const $e7495a1a2cd64df4$var$BUMP = $e7495a1a2cd64df4$export$d4693c66c2213e45.from("0.5");

});

parcelRegister("7Um1T", function(module, exports) {

$parcel$export(module.exports, "Wallet", function () { return $5c1ed9fa7c86a5b1$export$bcca3ea514774656; });
$parcel$export(module.exports, "verifyMessage", function () { return $5c1ed9fa7c86a5b1$export$228d0e772cc158cb; });
$parcel$export(module.exports, "verifyTypedData", function () { return $5c1ed9fa7c86a5b1$export$3603b1c1bcd76798; });

var $ak7re = parcelRequire("ak7re");

var $lOWlX = parcelRequire("lOWlX");

var $glz4p = parcelRequire("glz4p");

var $eBLyT = parcelRequire("eBLyT");

var $9qSpn = parcelRequire("9qSpn");
var $3vwDR = parcelRequire("3vwDR");

var $1ISM5 = parcelRequire("1ISM5");

var $bnbYM = parcelRequire("bnbYM");

var $j0dXC = parcelRequire("j0dXC");

var $8hiLm = parcelRequire("8hiLm");

var $aDAF4 = parcelRequire("aDAF4");

var $9aZfL = parcelRequire("9aZfL");
var $LwPxX = parcelRequire("LwPxX");

var $ABz8M = parcelRequire("ABz8M");

var $4NCF1 = parcelRequire("4NCF1");

var $eyxQ7 = parcelRequire("eyxQ7");
"use strict";
var $5c1ed9fa7c86a5b1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $5c1ed9fa7c86a5b1$var$logger = new (0, $4NCF1.Logger)((0, $eyxQ7.version));
function $5c1ed9fa7c86a5b1$var$isAccount(value) {
    return value != null && (0, $eBLyT.isHexString)(value.privateKey, 32) && value.address != null;
}
function $5c1ed9fa7c86a5b1$var$hasMnemonic(value) {
    const mnemonic = value.mnemonic;
    return mnemonic && mnemonic.phrase;
}
class $5c1ed9fa7c86a5b1$export$bcca3ea514774656 extends (0, $glz4p.Signer) {
    constructor(privateKey, provider){
        super();
        if ($5c1ed9fa7c86a5b1$var$isAccount(privateKey)) {
            const signingKey = new (0, $aDAF4.SigningKey)(privateKey.privateKey);
            (0, $j0dXC.defineReadOnly)(this, "_signingKey", ()=>signingKey);
            (0, $j0dXC.defineReadOnly)(this, "address", (0, $ABz8M.computeAddress)(this.publicKey));
            if (this.address !== (0, $ak7re.getAddress)(privateKey.address)) $5c1ed9fa7c86a5b1$var$logger.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]");
            if ($5c1ed9fa7c86a5b1$var$hasMnemonic(privateKey)) {
                const srcMnemonic = privateKey.mnemonic;
                (0, $j0dXC.defineReadOnly)(this, "_mnemonic", ()=>({
                        phrase: srcMnemonic.phrase,
                        path: srcMnemonic.path || (0, $1ISM5.defaultPath),
                        locale: srcMnemonic.locale || "en"
                    }));
                const mnemonic = this.mnemonic;
                const node = (0, $1ISM5.HDNode).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path);
                if ((0, $ABz8M.computeAddress)(node.privateKey) !== this.address) $5c1ed9fa7c86a5b1$var$logger.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
            } else (0, $j0dXC.defineReadOnly)(this, "_mnemonic", ()=>null);
        } else {
            if ((0, $aDAF4.SigningKey).isSigningKey(privateKey)) {
                /* istanbul ignore if */ if (privateKey.curve !== "secp256k1") $5c1ed9fa7c86a5b1$var$logger.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]");
                (0, $j0dXC.defineReadOnly)(this, "_signingKey", ()=>privateKey);
            } else {
                // A lot of common tools do not prefix private keys with a 0x (see: #1166)
                if (typeof privateKey === "string") {
                    if (privateKey.match(/^[0-9a-f]*$/i) && privateKey.length === 64) privateKey = "0x" + privateKey;
                }
                const signingKey = new (0, $aDAF4.SigningKey)(privateKey);
                (0, $j0dXC.defineReadOnly)(this, "_signingKey", ()=>signingKey);
            }
            (0, $j0dXC.defineReadOnly)(this, "_mnemonic", ()=>null);
            (0, $j0dXC.defineReadOnly)(this, "address", (0, $ABz8M.computeAddress)(this.publicKey));
        }
        /* istanbul ignore if */ if (provider && !(0, $lOWlX.Provider).isProvider(provider)) $5c1ed9fa7c86a5b1$var$logger.throwArgumentError("invalid provider", "provider", provider);
        (0, $j0dXC.defineReadOnly)(this, "provider", provider || null);
    }
    get mnemonic() {
        return this._mnemonic();
    }
    get privateKey() {
        return this._signingKey().privateKey;
    }
    get publicKey() {
        return this._signingKey().publicKey;
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    connect(provider) {
        return new $5c1ed9fa7c86a5b1$export$bcca3ea514774656(this, provider);
    }
    signTransaction(transaction) {
        return (0, $j0dXC.resolveProperties)(transaction).then((tx)=>{
            if (tx.from != null) {
                if ((0, $ak7re.getAddress)(tx.from) !== this.address) $5c1ed9fa7c86a5b1$var$logger.throwArgumentError("transaction from address mismatch", "transaction.from", transaction.from);
                delete tx.from;
            }
            const signature = this._signingKey().signDigest((0, $bnbYM.keccak256)((0, $ABz8M.serialize)(tx)));
            return (0, $ABz8M.serialize)(tx, signature);
        });
    }
    signMessage(message) {
        return $5c1ed9fa7c86a5b1$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $eBLyT.joinSignature)(this._signingKey().signDigest((0, $3vwDR.hashMessage)(message)));
        });
    }
    _signTypedData(domain, types, value) {
        return $5c1ed9fa7c86a5b1$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names
            const populated = yield (0, $9qSpn.TypedDataEncoder).resolveNames(domain, types, value, (name)=>{
                if (this.provider == null) $5c1ed9fa7c86a5b1$var$logger.throwError("cannot resolve ENS names without a provider", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "resolveName",
                    value: name
                });
                return this.provider.resolveName(name);
            });
            return (0, $eBLyT.joinSignature)(this._signingKey().signDigest((0, $9qSpn.TypedDataEncoder).hash(populated.domain, types, populated.value)));
        });
    }
    encrypt(password, options, progressCallback) {
        if (typeof options === "function" && !progressCallback) {
            progressCallback = options;
            options = {};
        }
        if (progressCallback && typeof progressCallback !== "function") throw new Error("invalid callback");
        if (!options) options = {};
        return (0, $LwPxX.encrypt)(this, password, options, progressCallback);
    }
    /**
     *  Static methods to create Wallet instances.
     */ static createRandom(options) {
        let entropy = (0, $8hiLm.randomBytes)(16);
        if (!options) options = {};
        if (options.extraEntropy) entropy = (0, $eBLyT.arrayify)((0, $eBLyT.hexDataSlice)((0, $bnbYM.keccak256)((0, $eBLyT.concat)([
            entropy,
            options.extraEntropy
        ])), 0, 16));
        const mnemonic = (0, $1ISM5.entropyToMnemonic)(entropy, options.locale);
        return $5c1ed9fa7c86a5b1$export$bcca3ea514774656.fromMnemonic(mnemonic, options.path, options.locale);
    }
    static fromEncryptedJson(json, password, progressCallback) {
        return (0, $9aZfL.decryptJsonWallet)(json, password, progressCallback).then((account)=>{
            return new $5c1ed9fa7c86a5b1$export$bcca3ea514774656(account);
        });
    }
    static fromEncryptedJsonSync(json, password) {
        return new $5c1ed9fa7c86a5b1$export$bcca3ea514774656((0, $9aZfL.decryptJsonWalletSync)(json, password));
    }
    static fromMnemonic(mnemonic, path, wordlist) {
        if (!path) path = (0, $1ISM5.defaultPath);
        return new $5c1ed9fa7c86a5b1$export$bcca3ea514774656((0, $1ISM5.HDNode).fromMnemonic(mnemonic, null, wordlist).derivePath(path));
    }
}
function $5c1ed9fa7c86a5b1$export$228d0e772cc158cb(message, signature) {
    return (0, $ABz8M.recoverAddress)((0, $3vwDR.hashMessage)(message), signature);
}
function $5c1ed9fa7c86a5b1$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $ABz8M.recoverAddress)((0, $9qSpn.TypedDataEncoder).hash(domain, types, value), signature);
}

});
parcelRegister("9qSpn", function(module, exports) {

$parcel$export(module.exports, "TypedDataEncoder", function () { return $6de0bf1cd45b9c15$export$458ab927ae635c3; });

var $ak7re = parcelRequire("ak7re");

var $20M69 = parcelRequire("20M69");

var $eBLyT = parcelRequire("eBLyT");

var $bnbYM = parcelRequire("bnbYM");

var $j0dXC = parcelRequire("j0dXC");

var $4NCF1 = parcelRequire("4NCF1");

var $kLgzk = parcelRequire("kLgzk");

var $6mINK = parcelRequire("6mINK");
var $6de0bf1cd45b9c15$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $6de0bf1cd45b9c15$var$logger = new (0, $4NCF1.Logger)((0, $kLgzk.version));
const $6de0bf1cd45b9c15$var$padding = new Uint8Array(32);
$6de0bf1cd45b9c15$var$padding.fill(0);
const $6de0bf1cd45b9c15$var$NegativeOne = (0, $20M69.BigNumber).from(-1);
const $6de0bf1cd45b9c15$var$Zero = (0, $20M69.BigNumber).from(0);
const $6de0bf1cd45b9c15$var$One = (0, $20M69.BigNumber).from(1);
const $6de0bf1cd45b9c15$var$MaxUint256 = (0, $20M69.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $6de0bf1cd45b9c15$var$hexPadRight(value) {
    const bytes = (0, $eBLyT.arrayify)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $eBLyT.hexConcat)([
        bytes,
        $6de0bf1cd45b9c15$var$padding.slice(padOffset)
    ]);
    return (0, $eBLyT.hexlify)(bytes);
}
const $6de0bf1cd45b9c15$var$hexTrue = (0, $eBLyT.hexZeroPad)($6de0bf1cd45b9c15$var$One.toHexString(), 32);
const $6de0bf1cd45b9c15$var$hexFalse = (0, $eBLyT.hexZeroPad)($6de0bf1cd45b9c15$var$Zero.toHexString(), 32);
const $6de0bf1cd45b9c15$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $6de0bf1cd45b9c15$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $6de0bf1cd45b9c15$var$checkString(key) {
    return function(value) {
        if (typeof value !== "string") $6de0bf1cd45b9c15$var$logger.throwArgumentError(`invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $6de0bf1cd45b9c15$var$domainChecks = {
    name: $6de0bf1cd45b9c15$var$checkString("name"),
    version: $6de0bf1cd45b9c15$var$checkString("version"),
    chainId: function(value) {
        try {
            return (0, $20M69.BigNumber).from(value).toString();
        } catch (error) {}
        return $6de0bf1cd45b9c15$var$logger.throwArgumentError(`invalid domain value for "chainId"`, "domain.chainId", value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $ak7re.getAddress)(value).toLowerCase();
        } catch (error) {}
        return $6de0bf1cd45b9c15$var$logger.throwArgumentError(`invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        try {
            const bytes = (0, $eBLyT.arrayify)(value);
            if (bytes.length !== 32) throw new Error("bad length");
            return (0, $eBLyT.hexlify)(bytes);
        } catch (error) {}
        return $6de0bf1cd45b9c15$var$logger.throwArgumentError(`invalid domain value "salt"`, "domain.salt", value);
    }
};
function $6de0bf1cd45b9c15$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d*)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2] || "256");
            if (width % 8 !== 0 || width > 256 || match[2] && match[2] !== String(width)) $6de0bf1cd45b9c15$var$logger.throwArgumentError("invalid numeric width", "type", type);
            const boundsUpper = $6de0bf1cd45b9c15$var$MaxUint256.mask(signed ? width - 1 : width);
            const boundsLower = signed ? boundsUpper.add($6de0bf1cd45b9c15$var$One).mul($6de0bf1cd45b9c15$var$NegativeOne) : $6de0bf1cd45b9c15$var$Zero;
            return function(value) {
                const v = (0, $20M69.BigNumber).from(value);
                if (v.lt(boundsLower) || v.gt(boundsUpper)) $6de0bf1cd45b9c15$var$logger.throwArgumentError(`value out-of-bounds for ${type}`, "value", value);
                return (0, $eBLyT.hexZeroPad)(v.toTwos(256).toHexString(), 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            if (width === 0 || width > 32 || match[1] !== String(width)) $6de0bf1cd45b9c15$var$logger.throwArgumentError("invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $eBLyT.arrayify)(value);
                if (bytes.length !== width) $6de0bf1cd45b9c15$var$logger.throwArgumentError(`invalid length for ${type}`, "value", value);
                return $6de0bf1cd45b9c15$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $eBLyT.hexZeroPad)((0, $ak7re.getAddress)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $6de0bf1cd45b9c15$var$hexFalse : $6de0bf1cd45b9c15$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $bnbYM.keccak256)(value);
            };
        case "string":
            return function(value) {
                return (0, $6mINK.id)(value);
            };
    }
    return null;
}
function $6de0bf1cd45b9c15$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
class $6de0bf1cd45b9c15$export$458ab927ae635c3 {
    constructor(types){
        (0, $j0dXC.defineReadOnly)(this, "types", Object.freeze((0, $j0dXC.deepCopy)(types)));
        (0, $j0dXC.defineReadOnly)(this, "_encoderCache", {});
        (0, $j0dXC.defineReadOnly)(this, "_types", {});
        // Link struct types to their direct child structs
        const links = {};
        // Link structs to structs which contain them as a child
        const parents = {};
        // Link all subtypes within a given struct
        const subtypes = {};
        Object.keys(types).forEach((type)=>{
            links[type] = {};
            parents[type] = [];
            subtypes[type] = {};
        });
        for(const name in types){
            const uniqueNames = {};
            types[name].forEach((field)=>{
                // Check each field has a unique name
                if (uniqueNames[field.name]) $6de0bf1cd45b9c15$var$logger.throwArgumentError(`duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", types);
                uniqueNames[field.name] = true;
                // Get the base type (drop any array specifiers)
                const baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
                if (baseType === name) $6de0bf1cd45b9c15$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(baseType)}`, "types", types);
                // Is this a base encoding type?
                const encoder = $6de0bf1cd45b9c15$var$getBaseEncoder(baseType);
                if (encoder) return;
                if (!parents[baseType]) $6de0bf1cd45b9c15$var$logger.throwArgumentError(`unknown type ${JSON.stringify(baseType)}`, "types", types);
                // Add linkage
                parents[baseType].push(name);
                links[name][baseType] = true;
            });
        }
        // Deduce the primary type
        const primaryTypes = Object.keys(parents).filter((n)=>parents[n].length === 0);
        if (primaryTypes.length === 0) $6de0bf1cd45b9c15$var$logger.throwArgumentError("missing primary type", "types", types);
        else if (primaryTypes.length > 1) $6de0bf1cd45b9c15$var$logger.throwArgumentError(`ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", types);
        (0, $j0dXC.defineReadOnly)(this, "primaryType", primaryTypes[0]);
        // Check for circular type references
        function checkCircular(type, found) {
            if (found[type]) $6de0bf1cd45b9c15$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(type)}`, "types", types);
            found[type] = true;
            Object.keys(links[type]).forEach((child)=>{
                if (!parents[child]) return;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                Object.keys(found).forEach((subtype)=>{
                    subtypes[subtype][child] = true;
                });
            });
            delete found[type];
        }
        checkCircular(this.primaryType, {});
        // Compute each fully describe type
        for(const name in subtypes){
            const st = Object.keys(subtypes[name]);
            st.sort();
            this._types[name] = $6de0bf1cd45b9c15$var$encodeType(name, types[name]) + st.map((t)=>$6de0bf1cd45b9c15$var$encodeType(t, types[t])).join("");
        }
    }
    getEncoder(type) {
        let encoder = this._encoderCache[type];
        if (!encoder) encoder = this._encoderCache[type] = this._getEncoder(type);
        return encoder;
    }
    _getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $6de0bf1cd45b9c15$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const subEncoder = this.getEncoder(subtype);
            const length = parseInt(match[3]);
            return (value)=>{
                if (length >= 0 && value.length !== length) $6de0bf1cd45b9c15$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                let result = value.map(subEncoder);
                if (this._types[subtype]) result = result.map((0, $bnbYM.keccak256));
                return (0, $bnbYM.keccak256)((0, $eBLyT.hexConcat)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $6mINK.id)(this._types[type]);
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this._types[type]) return (0, $bnbYM.keccak256)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $eBLyT.hexConcat)(values);
            };
        }
        return $6de0bf1cd45b9c15$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    encodeType(name) {
        const result = this._types[name];
        if (!result) $6de0bf1cd45b9c15$var$logger.throwArgumentError(`unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    hashStruct(name, value) {
        return (0, $bnbYM.keccak256)(this.encodeData(name, value));
    }
    encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $6de0bf1cd45b9c15$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const length = parseInt(match[3]);
            if (length >= 0 && value.length !== length) $6de0bf1cd45b9c15$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
            return value.map((v)=>this._visit(subtype, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        return $6de0bf1cd45b9c15$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    static from(types) {
        return new $6de0bf1cd45b9c15$export$458ab927ae635c3(types);
    }
    static getPrimaryType(types) {
        return $6de0bf1cd45b9c15$export$458ab927ae635c3.from(types).primaryType;
    }
    static hashStruct(name, types, value) {
        return $6de0bf1cd45b9c15$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            const type = $6de0bf1cd45b9c15$var$domainFieldTypes[name];
            if (!type) $6de0bf1cd45b9c15$var$logger.throwArgumentError(`invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $6de0bf1cd45b9c15$var$domainFieldNames.indexOf(a.name) - $6de0bf1cd45b9c15$var$domainFieldNames.indexOf(b.name);
        });
        return $6de0bf1cd45b9c15$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    static encode(domain, types, value) {
        return (0, $eBLyT.hexConcat)([
            "0x1901",
            $6de0bf1cd45b9c15$export$458ab927ae635c3.hashDomain(domain),
            $6de0bf1cd45b9c15$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    static hash(domain, types, value) {
        return (0, $bnbYM.keccak256)($6de0bf1cd45b9c15$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    static resolveNames(domain, types, value, resolveName) {
        return $6de0bf1cd45b9c15$var$__awaiter(this, void 0, void 0, function*() {
            // Make a copy to isolate it from the object passed in
            domain = (0, $j0dXC.shallowCopy)(domain);
            // Look up all ENS names
            const ensCache = {};
            // Do we need to look up the domain's verifyingContract?
            if (domain.verifyingContract && !(0, $eBLyT.isHexString)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
            // We are going to use the encoder to visit all the base values
            const encoder = $6de0bf1cd45b9c15$export$458ab927ae635c3.from(types);
            // Get a list of all the addresses
            encoder.visit(value, (type, value)=>{
                if (type === "address" && !(0, $eBLyT.isHexString)(value, 20)) ensCache[value] = "0x";
                return value;
            });
            // Lookup each name
            for(const name in ensCache)ensCache[name] = yield resolveName(name);
            // Replace the domain verifyingContract if needed
            if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
            // Replace all ENS names with their address
            value = encoder.visit(value, (type, value)=>{
                if (type === "address" && ensCache[value]) return ensCache[value];
                return value;
            });
            return {
                domain: domain,
                value: value
            };
        });
    }
    static getPayload(domain, types, value) {
        // Validate the domain fields
        $6de0bf1cd45b9c15$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $6de0bf1cd45b9c15$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $6de0bf1cd45b9c15$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $6de0bf1cd45b9c15$var$domainFieldTypes[name]
            });
        });
        const encoder = $6de0bf1cd45b9c15$export$458ab927ae635c3.from(types);
        const typesWithDomain = (0, $j0dXC.shallowCopy)(types);
        if (typesWithDomain.EIP712Domain) $6de0bf1cd45b9c15$var$logger.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", types);
        else typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $eBLyT.hexlify)((0, $eBLyT.arrayify)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $20M69.BigNumber).from(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        if (typeof value !== "string") $6de0bf1cd45b9c15$var$logger.throwArgumentError(`invalid string`, "value", value);
                        return value;
                }
                return $6de0bf1cd45b9c15$var$logger.throwArgumentError("unsupported type", "type", type);
            })
        };
    }
}

});
parcelRegister("kLgzk", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $f1d50cad9c4e1113$export$83d89fbfd8236492; });
const $f1d50cad9c4e1113$export$83d89fbfd8236492 = "hash/5.7.0";

});


parcelRegister("3vwDR", function(module, exports) {

$parcel$export(module.exports, "hashMessage", function () { return $28dd965a08bafb1b$export$d4c241cec96564c1; });

var $eBLyT = parcelRequire("eBLyT");

var $bnbYM = parcelRequire("bnbYM");

var $5kral = parcelRequire("5kral");
const $28dd965a08bafb1b$export$1ff3fdc4802a2ba6 = "\x19Ethereum Signed Message:\n";
function $28dd965a08bafb1b$export$d4c241cec96564c1(message) {
    if (typeof message === "string") message = (0, $5kral.toUtf8Bytes)(message);
    return (0, $bnbYM.keccak256)((0, $eBLyT.concat)([
        (0, $5kral.toUtf8Bytes)($28dd965a08bafb1b$export$1ff3fdc4802a2ba6),
        (0, $5kral.toUtf8Bytes)(String(message.length)),
        message
    ]));
}

});

parcelRegister("1ISM5", function(module, exports) {

$parcel$export(module.exports, "defaultPath", function () { return $1414639a3e297515$export$d48ad89f7e11a603; });
$parcel$export(module.exports, "HDNode", function () { return $1414639a3e297515$export$b68640c53e22b952; });
$parcel$export(module.exports, "entropyToMnemonic", function () { return $1414639a3e297515$export$4becd65eb23312e6; });
$parcel$export(module.exports, "mnemonicToEntropy", function () { return $1414639a3e297515$export$135e090d58b310ca; });
$parcel$export(module.exports, "mnemonicToSeed", function () { return $1414639a3e297515$export$3dee74f1204ab09f; });
$parcel$export(module.exports, "isValidMnemonic", function () { return $1414639a3e297515$export$5eea3393c6119c80; });
$parcel$export(module.exports, "getAccountPath", function () { return $1414639a3e297515$export$22b80e4f9eff636d; });

var $aK83G = parcelRequire("aK83G");

var $eBLyT = parcelRequire("eBLyT");

var $20M69 = parcelRequire("20M69");

var $5kral = parcelRequire("5kral");

var $bj8Mn = parcelRequire("bj8Mn");

var $j0dXC = parcelRequire("j0dXC");

var $aDAF4 = parcelRequire("aDAF4");

var $8EXlS = parcelRequire("8EXlS");
var $5FAou = parcelRequire("5FAou");

var $ABz8M = parcelRequire("ABz8M");

var $h7tuR = parcelRequire("h7tuR");

var $4NCF1 = parcelRequire("4NCF1");

var $giazr = parcelRequire("giazr");
"use strict";
const $1414639a3e297515$var$logger = new (0, $4NCF1.Logger)((0, $giazr.version));
const $1414639a3e297515$var$N = (0, $20M69.BigNumber).from("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
// "Bitcoin seed"
const $1414639a3e297515$var$MasterSecret = (0, $5kral.toUtf8Bytes)("Bitcoin seed");
const $1414639a3e297515$var$HardenedBit = 0x80000000;
// Returns a byte with the MSB bits set
function $1414639a3e297515$var$getUpperMask(bits) {
    return (1 << bits) - 1 << 8 - bits;
}
// Returns a byte with the LSB bits set
function $1414639a3e297515$var$getLowerMask(bits) {
    return (1 << bits) - 1;
}
function $1414639a3e297515$var$bytes32(value) {
    return (0, $eBLyT.hexZeroPad)((0, $eBLyT.hexlify)(value), 32);
}
function $1414639a3e297515$var$base58check(data) {
    return (0, $aK83G.Base58).encode((0, $eBLyT.concat)([
        data,
        (0, $eBLyT.hexDataSlice)((0, $8EXlS.sha256)((0, $8EXlS.sha256)(data)), 0, 4)
    ]));
}
function $1414639a3e297515$var$getWordlist(wordlist) {
    if (wordlist == null) return (0, $h7tuR.wordlists)["en"];
    if (typeof wordlist === "string") {
        const words = (0, $h7tuR.wordlists)[wordlist];
        if (words == null) $1414639a3e297515$var$logger.throwArgumentError("unknown locale", "wordlist", wordlist);
        return words;
    }
    return wordlist;
}
const $1414639a3e297515$var$_constructorGuard = {};
const $1414639a3e297515$export$d48ad89f7e11a603 = "m/44'/60'/0'/0/0";
class $1414639a3e297515$export$b68640c53e22b952 {
    /**
     *  This constructor should not be called directly.
     *
     *  Please use:
     *   - fromMnemonic
     *   - fromSeed
     */ constructor(constructorGuard, privateKey, publicKey, parentFingerprint, chainCode, index, depth, mnemonicOrPath){
        /* istanbul ignore if */ if (constructorGuard !== $1414639a3e297515$var$_constructorGuard) throw new Error("HDNode constructor cannot be called directly");
        if (privateKey) {
            const signingKey = new (0, $aDAF4.SigningKey)(privateKey);
            (0, $j0dXC.defineReadOnly)(this, "privateKey", signingKey.privateKey);
            (0, $j0dXC.defineReadOnly)(this, "publicKey", signingKey.compressedPublicKey);
        } else {
            (0, $j0dXC.defineReadOnly)(this, "privateKey", null);
            (0, $j0dXC.defineReadOnly)(this, "publicKey", (0, $eBLyT.hexlify)(publicKey));
        }
        (0, $j0dXC.defineReadOnly)(this, "parentFingerprint", parentFingerprint);
        (0, $j0dXC.defineReadOnly)(this, "fingerprint", (0, $eBLyT.hexDataSlice)((0, $8EXlS.ripemd160)((0, $8EXlS.sha256)(this.publicKey)), 0, 4));
        (0, $j0dXC.defineReadOnly)(this, "address", (0, $ABz8M.computeAddress)(this.publicKey));
        (0, $j0dXC.defineReadOnly)(this, "chainCode", chainCode);
        (0, $j0dXC.defineReadOnly)(this, "index", index);
        (0, $j0dXC.defineReadOnly)(this, "depth", depth);
        if (mnemonicOrPath == null) {
            // From a source that does not preserve the path (e.g. extended keys)
            (0, $j0dXC.defineReadOnly)(this, "mnemonic", null);
            (0, $j0dXC.defineReadOnly)(this, "path", null);
        } else if (typeof mnemonicOrPath === "string") {
            // From a source that does not preserve the mnemonic (e.g. neutered)
            (0, $j0dXC.defineReadOnly)(this, "mnemonic", null);
            (0, $j0dXC.defineReadOnly)(this, "path", mnemonicOrPath);
        } else {
            // From a fully qualified source
            (0, $j0dXC.defineReadOnly)(this, "mnemonic", mnemonicOrPath);
            (0, $j0dXC.defineReadOnly)(this, "path", mnemonicOrPath.path);
        }
    }
    get extendedKey() {
        // We only support the mainnet values for now, but if anyone needs
        // testnet values, let me know. I believe current sentiment is that
        // we should always use mainnet, and use BIP-44 to derive the network
        //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
        //   - Testnet: public=0x043587CF, private=0x04358394
        if (this.depth >= 256) throw new Error("Depth too large!");
        return $1414639a3e297515$var$base58check((0, $eBLyT.concat)([
            this.privateKey != null ? "0x0488ADE4" : "0x0488B21E",
            (0, $eBLyT.hexlify)(this.depth),
            this.parentFingerprint,
            (0, $eBLyT.hexZeroPad)((0, $eBLyT.hexlify)(this.index), 4),
            this.chainCode,
            this.privateKey != null ? (0, $eBLyT.concat)([
                "0x00",
                this.privateKey
            ]) : this.publicKey
        ]));
    }
    neuter() {
        return new $1414639a3e297515$export$b68640c53e22b952($1414639a3e297515$var$_constructorGuard, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, this.path);
    }
    _derive(index) {
        if (index > 0xffffffff) throw new Error("invalid index - " + String(index));
        // Base path
        let path = this.path;
        if (path) path += "/" + (index & ~$1414639a3e297515$var$HardenedBit);
        const data = new Uint8Array(37);
        if (index & $1414639a3e297515$var$HardenedBit) {
            if (!this.privateKey) throw new Error("cannot derive child of neutered node");
            // Data = 0x00 || ser_256(k_par)
            data.set((0, $eBLyT.arrayify)(this.privateKey), 1);
            // Hardened path
            if (path) path += "'";
        } else // Data = ser_p(point(k_par))
        data.set((0, $eBLyT.arrayify)(this.publicKey));
        // Data += ser_32(i)
        for(let i = 24; i >= 0; i -= 8)data[33 + (i >> 3)] = index >> 24 - i & 0xff;
        const I = (0, $eBLyT.arrayify)((0, $8EXlS.computeHmac)((0, $5FAou.SupportedAlgorithm).sha512, this.chainCode, data));
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // The private key
        let ki = null;
        // The public key
        let Ki = null;
        if (this.privateKey) ki = $1414639a3e297515$var$bytes32((0, $20M69.BigNumber).from(IL).add(this.privateKey).mod($1414639a3e297515$var$N));
        else {
            const ek = new (0, $aDAF4.SigningKey)((0, $eBLyT.hexlify)(IL));
            Ki = ek._addPoint(this.publicKey);
        }
        let mnemonicOrPath = path;
        const srcMnemonic = this.mnemonic;
        if (srcMnemonic) mnemonicOrPath = Object.freeze({
            phrase: srcMnemonic.phrase,
            path: path,
            locale: srcMnemonic.locale || "en"
        });
        return new $1414639a3e297515$export$b68640c53e22b952($1414639a3e297515$var$_constructorGuard, ki, Ki, this.fingerprint, $1414639a3e297515$var$bytes32(IR), index, this.depth + 1, mnemonicOrPath);
    }
    derivePath(path) {
        const components = path.split("/");
        if (components.length === 0 || components[0] === "m" && this.depth !== 0) throw new Error("invalid path - " + path);
        if (components[0] === "m") components.shift();
        let result = this;
        for(let i = 0; i < components.length; i++){
            const component = components[i];
            if (component.match(/^[0-9]+'$/)) {
                const index = parseInt(component.substring(0, component.length - 1));
                if (index >= $1414639a3e297515$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive($1414639a3e297515$var$HardenedBit + index);
            } else if (component.match(/^[0-9]+$/)) {
                const index = parseInt(component);
                if (index >= $1414639a3e297515$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive(index);
            } else throw new Error("invalid path component - " + component);
        }
        return result;
    }
    static _fromSeed(seed, mnemonic) {
        const seedArray = (0, $eBLyT.arrayify)(seed);
        if (seedArray.length < 16 || seedArray.length > 64) throw new Error("invalid seed");
        const I = (0, $eBLyT.arrayify)((0, $8EXlS.computeHmac)((0, $5FAou.SupportedAlgorithm).sha512, $1414639a3e297515$var$MasterSecret, seedArray));
        return new $1414639a3e297515$export$b68640c53e22b952($1414639a3e297515$var$_constructorGuard, $1414639a3e297515$var$bytes32(I.slice(0, 32)), null, "0x00000000", $1414639a3e297515$var$bytes32(I.slice(32)), 0, 0, mnemonic);
    }
    static fromMnemonic(mnemonic, password, wordlist) {
        // If a locale name was passed in, find the associated wordlist
        wordlist = $1414639a3e297515$var$getWordlist(wordlist);
        // Normalize the case and spacing in the mnemonic (throws if the mnemonic is invalid)
        mnemonic = $1414639a3e297515$export$4becd65eb23312e6($1414639a3e297515$export$135e090d58b310ca(mnemonic, wordlist), wordlist);
        return $1414639a3e297515$export$b68640c53e22b952._fromSeed($1414639a3e297515$export$3dee74f1204ab09f(mnemonic, password), {
            phrase: mnemonic,
            path: "m",
            locale: wordlist.locale
        });
    }
    static fromSeed(seed) {
        return $1414639a3e297515$export$b68640c53e22b952._fromSeed(seed, null);
    }
    static fromExtendedKey(extendedKey) {
        const bytes = (0, $aK83G.Base58).decode(extendedKey);
        if (bytes.length !== 82 || $1414639a3e297515$var$base58check(bytes.slice(0, 78)) !== extendedKey) $1414639a3e297515$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
        const depth = bytes[4];
        const parentFingerprint = (0, $eBLyT.hexlify)(bytes.slice(5, 9));
        const index = parseInt((0, $eBLyT.hexlify)(bytes.slice(9, 13)).substring(2), 16);
        const chainCode = (0, $eBLyT.hexlify)(bytes.slice(13, 45));
        const key = bytes.slice(45, 78);
        switch((0, $eBLyT.hexlify)(bytes.slice(0, 4))){
            // Public Key
            case "0x0488b21e":
            case "0x043587cf":
                return new $1414639a3e297515$export$b68640c53e22b952($1414639a3e297515$var$_constructorGuard, null, (0, $eBLyT.hexlify)(key), parentFingerprint, chainCode, index, depth, null);
            // Private Key
            case "0x0488ade4":
            case "0x04358394 ":
                if (key[0] !== 0) break;
                return new $1414639a3e297515$export$b68640c53e22b952($1414639a3e297515$var$_constructorGuard, (0, $eBLyT.hexlify)(key.slice(1)), null, parentFingerprint, chainCode, index, depth, null);
        }
        return $1414639a3e297515$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
    }
}
function $1414639a3e297515$export$3dee74f1204ab09f(mnemonic, password) {
    if (!password) password = "";
    const salt = (0, $5kral.toUtf8Bytes)("mnemonic" + password, (0, $5kral.UnicodeNormalizationForm).NFKD);
    return (0, $bj8Mn.pbkdf2)((0, $5kral.toUtf8Bytes)(mnemonic, (0, $5kral.UnicodeNormalizationForm).NFKD), salt, 2048, 64, "sha512");
}
function $1414639a3e297515$export$135e090d58b310ca(mnemonic, wordlist) {
    wordlist = $1414639a3e297515$var$getWordlist(wordlist);
    $1414639a3e297515$var$logger.checkNormalize();
    const words = wordlist.split(mnemonic);
    if (words.length % 3 !== 0) throw new Error("invalid mnemonic");
    const entropy = (0, $eBLyT.arrayify)(new Uint8Array(Math.ceil(11 * words.length / 8)));
    let offset = 0;
    for(let i = 0; i < words.length; i++){
        let index = wordlist.getWordIndex(words[i].normalize("NFKD"));
        if (index === -1) throw new Error("invalid mnemonic");
        for(let bit = 0; bit < 11; bit++){
            if (index & 1 << 10 - bit) entropy[offset >> 3] |= 1 << 7 - offset % 8;
            offset++;
        }
    }
    const entropyBits = 32 * words.length / 3;
    const checksumBits = words.length / 3;
    const checksumMask = $1414639a3e297515$var$getUpperMask(checksumBits);
    const checksum = (0, $eBLyT.arrayify)((0, $8EXlS.sha256)(entropy.slice(0, entropyBits / 8)))[0] & checksumMask;
    if (checksum !== (entropy[entropy.length - 1] & checksumMask)) throw new Error("invalid checksum");
    return (0, $eBLyT.hexlify)(entropy.slice(0, entropyBits / 8));
}
function $1414639a3e297515$export$4becd65eb23312e6(entropy, wordlist) {
    wordlist = $1414639a3e297515$var$getWordlist(wordlist);
    entropy = (0, $eBLyT.arrayify)(entropy);
    if (entropy.length % 4 !== 0 || entropy.length < 16 || entropy.length > 32) throw new Error("invalid entropy");
    const indices = [
        0
    ];
    let remainingBits = 11;
    for(let i = 0; i < entropy.length; i++)// Consume the whole byte (with still more to go)
    if (remainingBits > 8) {
        indices[indices.length - 1] <<= 8;
        indices[indices.length - 1] |= entropy[i];
        remainingBits -= 8;
    // This byte will complete an 11-bit index
    } else {
        indices[indices.length - 1] <<= remainingBits;
        indices[indices.length - 1] |= entropy[i] >> 8 - remainingBits;
        // Start the next word
        indices.push(entropy[i] & $1414639a3e297515$var$getLowerMask(8 - remainingBits));
        remainingBits += 3;
    }
    // Compute the checksum bits
    const checksumBits = entropy.length / 4;
    const checksum = (0, $eBLyT.arrayify)((0, $8EXlS.sha256)(entropy))[0] & $1414639a3e297515$var$getUpperMask(checksumBits);
    // Shift the checksum into the word indices
    indices[indices.length - 1] <<= checksumBits;
    indices[indices.length - 1] |= checksum >> 8 - checksumBits;
    return wordlist.join(indices.map((index)=>wordlist.getWord(index)));
}
function $1414639a3e297515$export$5eea3393c6119c80(mnemonic, wordlist) {
    try {
        $1414639a3e297515$export$135e090d58b310ca(mnemonic, wordlist);
        return true;
    } catch (error) {}
    return false;
}
function $1414639a3e297515$export$22b80e4f9eff636d(index) {
    if (typeof index !== "number" || index < 0 || index >= $1414639a3e297515$var$HardenedBit || index % 1) $1414639a3e297515$var$logger.throwArgumentError("invalid account index", "index", index);
    return `m/44'/60'/${index}'/0/0`;
}

});
parcelRegister("aK83G", function(module, exports) {

$parcel$export(module.exports, "Base58", function () { return $7d247379e3af7930$export$45a587635c9954b2; });
/**
 * var basex = require("base-x");
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */ 
var $eBLyT = parcelRequire("eBLyT");

var $j0dXC = parcelRequire("j0dXC");
class $7d247379e3af7930$export$240043ab8e806ec7 {
    constructor(alphabet){
        (0, $j0dXC.defineReadOnly)(this, "alphabet", alphabet);
        (0, $j0dXC.defineReadOnly)(this, "base", alphabet.length);
        (0, $j0dXC.defineReadOnly)(this, "_alphabetMap", {});
        (0, $j0dXC.defineReadOnly)(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for(let i = 0; i < alphabet.length; i++)this._alphabetMap[alphabet.charAt(i)] = i;
    }
    encode(value) {
        let source = (0, $eBLyT.arrayify)(value);
        if (source.length === 0) return "";
        let digits = [
            0
        ];
        for(let i = 0; i < source.length; ++i){
            let carry = source[i];
            for(let j = 0; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % this.base;
                carry = carry / this.base | 0;
            }
            while(carry > 0){
                digits.push(carry % this.base);
                carry = carry / this.base | 0;
            }
        }
        let string = "";
        // deal with leading zeros
        for(let k = 0; source[k] === 0 && k < source.length - 1; ++k)string += this._leader;
        // convert digits to a string
        for(let q = digits.length - 1; q >= 0; --q)string += this.alphabet[digits[q]];
        return string;
    }
    decode(value) {
        if (typeof value !== "string") throw new TypeError("Expected String");
        let bytes = [];
        if (value.length === 0) return new Uint8Array(bytes);
        bytes.push(0);
        for(let i = 0; i < value.length; i++){
            let byte = this._alphabetMap[value[i]];
            if (byte === undefined) throw new Error("Non-base" + this.base + " character");
            let carry = byte;
            for(let j = 0; j < bytes.length; ++j){
                carry += bytes[j] * this.base;
                bytes[j] = carry & 0xff;
                carry >>= 8;
            }
            while(carry > 0){
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for(let k = 0; value[k] === this._leader && k < value.length - 1; ++k)bytes.push(0);
        return (0, $eBLyT.arrayify)(new Uint8Array(bytes.reverse()));
    }
}
const $7d247379e3af7930$export$cfabb2852920f5ec = new $7d247379e3af7930$export$240043ab8e806ec7("abcdefghijklmnopqrstuvwxyz234567");
const $7d247379e3af7930$export$45a587635c9954b2 = new $7d247379e3af7930$export$240043ab8e806ec7("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
 //console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
 //console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))

});

parcelRegister("bj8Mn", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $83b847761eab2bc2$export$448fa22aedc9dbca; });

var $eBLyT = parcelRequire("eBLyT");

var $8EXlS = parcelRequire("8EXlS");
"use strict";
function $83b847761eab2bc2$export$448fa22aedc9dbca(password, salt, iterations, keylen, hashAlgorithm) {
    password = (0, $eBLyT.arrayify)(password);
    salt = (0, $eBLyT.arrayify)(salt);
    let hLen;
    let l = 1;
    const DK = new Uint8Array(keylen);
    const block1 = new Uint8Array(salt.length + 4);
    block1.set(salt);
    //salt.copy(block1, 0, 0, salt.length)
    let r;
    let T;
    for(let i = 1; i <= l; i++){
        //block1.writeUInt32BE(i, salt.length)
        block1[salt.length] = i >> 24 & 0xff;
        block1[salt.length + 1] = i >> 16 & 0xff;
        block1[salt.length + 2] = i >> 8 & 0xff;
        block1[salt.length + 3] = i & 0xff;
        //let U = createHmac(password).update(block1).digest();
        let U = (0, $eBLyT.arrayify)((0, $8EXlS.computeHmac)(hashAlgorithm, password, block1));
        if (!hLen) {
            hLen = U.length;
            T = new Uint8Array(hLen);
            l = Math.ceil(keylen / hLen);
            r = keylen - (l - 1) * hLen;
        }
        //U.copy(T, 0, 0, hLen)
        T.set(U);
        for(let j = 1; j < iterations; j++){
            //U = createHmac(password).update(U).digest();
            U = (0, $eBLyT.arrayify)((0, $8EXlS.computeHmac)(hashAlgorithm, password, U));
            for(let k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        const destPos = (i - 1) * hLen;
        const len = i === l ? r : hLen;
        //T.copy(DK, destPos, 0, len)
        DK.set((0, $eBLyT.arrayify)(T).slice(0, len), destPos);
    }
    return (0, $eBLyT.hexlify)(DK);
}

});
parcelRegister("8EXlS", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $64e0193189b70dbd$export$d1cea0ee4e3f0d3e; });
$parcel$export(module.exports, "sha256", function () { return $64e0193189b70dbd$export$bced8d2aada2d1c9; });
$parcel$export(module.exports, "sha512", function () { return $64e0193189b70dbd$export$a888d2532e6dc7bb; });
$parcel$export(module.exports, "computeHmac", function () { return $64e0193189b70dbd$export$967075d2f3b8e7ff; });

var $ay5ZU = parcelRequire("ay5ZU");

var $eBLyT = parcelRequire("eBLyT");

var $5FAou = parcelRequire("5FAou");

var $4NCF1 = parcelRequire("4NCF1");

var $efnUw = parcelRequire("efnUw");
"use strict";
const $64e0193189b70dbd$var$logger = new (0, $4NCF1.Logger)((0, $efnUw.version));
function $64e0193189b70dbd$export$d1cea0ee4e3f0d3e(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($ay5ZU))).ripemd160().update((0, $eBLyT.arrayify)(data)).digest("hex");
}
function $64e0193189b70dbd$export$bced8d2aada2d1c9(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($ay5ZU))).sha256().update((0, $eBLyT.arrayify)(data)).digest("hex");
}
function $64e0193189b70dbd$export$a888d2532e6dc7bb(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($ay5ZU))).sha512().update((0, $eBLyT.arrayify)(data)).digest("hex");
}
function $64e0193189b70dbd$export$967075d2f3b8e7ff(algorithm, key, data) {
    if (!(0, $5FAou.SupportedAlgorithm)[algorithm]) $64e0193189b70dbd$var$logger.throwError("unsupported algorithm " + algorithm, (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "hmac",
        algorithm: algorithm
    });
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($ay5ZU))).hmac((0, (/*@__PURE__*/$parcel$interopDefault($ay5ZU)))[algorithm], (0, $eBLyT.arrayify)(key)).update((0, $eBLyT.arrayify)(data)).digest("hex");
}

});
parcelRegister("5FAou", function(module, exports) {

$parcel$export(module.exports, "SupportedAlgorithm", function () { return $420d032f5f60c4b5$export$d2a8849cfb277c; });
var $420d032f5f60c4b5$export$d2a8849cfb277c;
(function(SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})($420d032f5f60c4b5$export$d2a8849cfb277c || ($420d032f5f60c4b5$export$d2a8849cfb277c = {}));

});

parcelRegister("efnUw", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $a5f503932ef18a19$export$83d89fbfd8236492; });
const $a5f503932ef18a19$export$83d89fbfd8236492 = "sha2/5.7.0";

});



parcelRegister("h7tuR", function(module, exports) {

$parcel$export(module.exports, "wordlists", function () { return $c769f893b5516a0a$export$e8e1b4711c2d1939; });

var $lCmNE = parcelRequire("lCmNE");
"use strict";
const $c769f893b5516a0a$export$e8e1b4711c2d1939 = {
    en: (0, $lCmNE.langEn)
};

});
parcelRegister("lCmNE", function(module, exports) {

$parcel$export(module.exports, "langEn", function () { return $fbced527c0992dfb$export$a2c9518710cf1f49; });

var $lUSfR = parcelRequire("lUSfR");
"use strict";
const $fbced527c0992dfb$var$words = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
let $fbced527c0992dfb$var$wordlist = null;
function $fbced527c0992dfb$var$loadWords(lang) {
    if ($fbced527c0992dfb$var$wordlist != null) return;
    $fbced527c0992dfb$var$wordlist = $fbced527c0992dfb$var$words.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" ");
    // Verify the computed list matches the official list
    /* istanbul ignore if */ if ((0, $lUSfR.Wordlist).check(lang) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60") {
        $fbced527c0992dfb$var$wordlist = null;
        throw new Error("BIP39 Wordlist for en (English) FAILED");
    }
}
class $fbced527c0992dfb$var$LangEn extends (0, $lUSfR.Wordlist) {
    constructor(){
        super("en");
    }
    getWord(index) {
        $fbced527c0992dfb$var$loadWords(this);
        return $fbced527c0992dfb$var$wordlist[index];
    }
    getWordIndex(word) {
        $fbced527c0992dfb$var$loadWords(this);
        return $fbced527c0992dfb$var$wordlist.indexOf(word);
    }
}
const $fbced527c0992dfb$export$a2c9518710cf1f49 = new $fbced527c0992dfb$var$LangEn();
(0, $lUSfR.Wordlist).register($fbced527c0992dfb$export$a2c9518710cf1f49);

});
parcelRegister("lUSfR", function(module, exports) {

$parcel$export(module.exports, "Wordlist", function () { return $ff48e9d64e1dde3c$export$4d9531a8ddb0ebca; });

var $6mINK = parcelRequire("6mINK");

var $j0dXC = parcelRequire("j0dXC");

var $4NCF1 = parcelRequire("4NCF1");

var $6sL7N = parcelRequire("6sL7N");
"use strict";
// This gets overridden by rollup
const $ff48e9d64e1dde3c$var$exportWordlist = false;
const $ff48e9d64e1dde3c$export$af88d00dbe7f521 = new (0, $4NCF1.Logger)((0, $6sL7N.version));
class $ff48e9d64e1dde3c$export$4d9531a8ddb0ebca {
    constructor(locale){
        $ff48e9d64e1dde3c$export$af88d00dbe7f521.checkAbstract(new.target, $ff48e9d64e1dde3c$export$4d9531a8ddb0ebca);
        (0, $j0dXC.defineReadOnly)(this, "locale", locale);
    }
    // Subclasses may override this
    split(mnemonic) {
        return mnemonic.toLowerCase().split(/ +/g);
    }
    // Subclasses may override this
    join(words) {
        return words.join(" ");
    }
    static check(wordlist) {
        const words = [];
        for(let i = 0; i < 2048; i++){
            const word = wordlist.getWord(i);
            /* istanbul ignore if */ if (i !== wordlist.getWordIndex(word)) return "0x";
            words.push(word);
        }
        return (0, $6mINK.id)(words.join("\n") + "\n");
    }
    static register(lang, name) {
        if (!name) name = lang.locale;
        /* istanbul ignore if */ if ($ff48e9d64e1dde3c$var$exportWordlist) try {
            const anyGlobal = window;
            if (anyGlobal._ethers && anyGlobal._ethers.wordlists) {
                if (!anyGlobal._ethers.wordlists[name]) (0, $j0dXC.defineReadOnly)(anyGlobal._ethers.wordlists, name, lang);
            }
        } catch (error) {}
    }
}

});
parcelRegister("6sL7N", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $4b49e998ed22a478$export$83d89fbfd8236492; });
const $4b49e998ed22a478$export$83d89fbfd8236492 = "wordlists/5.7.0";

});




parcelRegister("giazr", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $bdc686e78056ebb0$export$83d89fbfd8236492; });
const $bdc686e78056ebb0$export$83d89fbfd8236492 = "hdnode/5.7.0";

});


parcelRegister("8hiLm", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $606e7729564a4a2a$export$5f828d93ff035aa8; });

var $eBLyT = parcelRequire("eBLyT");

var $4NCF1 = parcelRequire("4NCF1");

var $bDIWm = parcelRequire("bDIWm");
"use strict";
const $606e7729564a4a2a$var$logger = new (0, $4NCF1.Logger)((0, $bDIWm.version));
// Debugging line for testing browser lib in node
//const window = { crypto: { getRandomValues: () => { } } };
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $606e7729564a4a2a$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $606e7729564a4a2a$var$anyGlobal = $606e7729564a4a2a$var$getGlobal();
let $606e7729564a4a2a$var$crypto = $606e7729564a4a2a$var$anyGlobal.crypto || $606e7729564a4a2a$var$anyGlobal.msCrypto;
if (!$606e7729564a4a2a$var$crypto || !$606e7729564a4a2a$var$crypto.getRandomValues) {
    $606e7729564a4a2a$var$logger.warn("WARNING: Missing strong random number source");
    $606e7729564a4a2a$var$crypto = {
        getRandomValues: function(buffer) {
            return $606e7729564a4a2a$var$logger.throwError("no secure random source avaialble", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "crypto.getRandomValues"
            });
        }
    };
}
function $606e7729564a4a2a$export$5f828d93ff035aa8(length) {
    if (length <= 0 || length > 1024 || length % 1 || length != length) $606e7729564a4a2a$var$logger.throwArgumentError("invalid length", "length", length);
    const result = new Uint8Array(length);
    $606e7729564a4a2a$var$crypto.getRandomValues(result);
    return (0, $eBLyT.arrayify)(result);
}

});
parcelRegister("bDIWm", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $8796326f4b4f4b35$export$83d89fbfd8236492; });
const $8796326f4b4f4b35$export$83d89fbfd8236492 = "random/5.7.0";

});


parcelRegister("9aZfL", function(module, exports) {

$parcel$export(module.exports, "decryptJsonWallet", function () { return $6ae48fd979ef54fd$export$e74fcde37488267a; });
$parcel$export(module.exports, "decryptJsonWalletSync", function () { return $6ae48fd979ef54fd$export$7a81c437a678891a; });

var $6QpSh = parcelRequire("6QpSh");

var $aPFrR = parcelRequire("aPFrR");

var $LwPxX = parcelRequire("LwPxX");
"use strict";
function $6ae48fd979ef54fd$export$e74fcde37488267a(json, password, progressCallback) {
    if ((0, $aPFrR.isCrowdsaleWallet)(json)) {
        if (progressCallback) progressCallback(0);
        const account = (0, $6QpSh.decrypt)(json, password);
        if (progressCallback) progressCallback(1);
        return Promise.resolve(account);
    }
    if ((0, $aPFrR.isKeystoreWallet)(json)) return (0, $LwPxX.decrypt)(json, password, progressCallback);
    return Promise.reject(new Error("invalid JSON wallet"));
}
function $6ae48fd979ef54fd$export$7a81c437a678891a(json, password) {
    if ((0, $aPFrR.isCrowdsaleWallet)(json)) return (0, $6QpSh.decrypt)(json, password);
    if ((0, $aPFrR.isKeystoreWallet)(json)) return (0, $LwPxX.decryptSync)(json, password);
    throw new Error("invalid JSON wallet");
}

});
parcelRegister("6QpSh", function(module, exports) {

$parcel$export(module.exports, "decrypt", function () { return $4fbbab89f0e5a502$export$e85a0c9a1067c5d3; });

var $7gxQg = parcelRequire("7gxQg");

var $ak7re = parcelRequire("ak7re");

var $eBLyT = parcelRequire("eBLyT");

var $bnbYM = parcelRequire("bnbYM");

var $bj8Mn = parcelRequire("bj8Mn");

var $5kral = parcelRequire("5kral");

var $j0dXC = parcelRequire("j0dXC");

var $4NCF1 = parcelRequire("4NCF1");

var $dZMS9 = parcelRequire("dZMS9");

var $8kBCw = parcelRequire("8kBCw");
"use strict";
const $4fbbab89f0e5a502$var$logger = new (0, $4NCF1.Logger)((0, $dZMS9.version));
class $4fbbab89f0e5a502$export$93a76d16f88f2b3 extends (0, $j0dXC.Description) {
    isCrowdsaleAccount(value) {
        return !!(value && value._isCrowdsaleAccount);
    }
}
function $4fbbab89f0e5a502$export$e85a0c9a1067c5d3(json, password) {
    const data = JSON.parse(json);
    password = (0, $8kBCw.getPassword)(password);
    // Ethereum Address
    const ethaddr = (0, $ak7re.getAddress)((0, $8kBCw.searchPath)(data, "ethaddr"));
    // Encrypted Seed
    const encseed = (0, $8kBCw.looseArrayify)((0, $8kBCw.searchPath)(data, "encseed"));
    if (!encseed || encseed.length % 16 !== 0) $4fbbab89f0e5a502$var$logger.throwArgumentError("invalid encseed", "json", json);
    const key = (0, $eBLyT.arrayify)((0, $bj8Mn.pbkdf2)(password, password, 2000, 32, "sha256")).slice(0, 16);
    const iv = encseed.slice(0, 16);
    const encryptedSeed = encseed.slice(16);
    // Decrypt the seed
    const aesCbc = new (0, (/*@__PURE__*/$parcel$interopDefault($7gxQg))).ModeOfOperation.cbc(key, iv);
    const seed = (0, (/*@__PURE__*/$parcel$interopDefault($7gxQg))).padding.pkcs7.strip((0, $eBLyT.arrayify)(aesCbc.decrypt(encryptedSeed)));
    // This wallet format is weird... Convert the binary encoded hex to a string.
    let seedHex = "";
    for(let i = 0; i < seed.length; i++)seedHex += String.fromCharCode(seed[i]);
    const seedHexBytes = (0, $5kral.toUtf8Bytes)(seedHex);
    const privateKey = (0, $bnbYM.keccak256)(seedHexBytes);
    return new $4fbbab89f0e5a502$export$93a76d16f88f2b3({
        _isCrowdsaleAccount: true,
        address: ethaddr,
        privateKey: privateKey
    });
}

});
parcelRegister("7gxQg", function(module, exports) {
"use strict";
(function(root) {
    function checkInt(value) {
        return parseInt(value) === value;
    }
    function checkInts(arrayish) {
        if (!checkInt(arrayish.length)) return false;
        for(var i = 0; i < arrayish.length; i++){
            if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) return false;
        }
        return true;
    }
    function coerceArray(arg, copy) {
        // ArrayBuffer view
        if (arg.buffer && ArrayBuffer.isView(arg) && arg.name === "Uint8Array") {
            if (copy) {
                if (arg.slice) arg = arg.slice();
                else arg = Array.prototype.slice.call(arg);
            }
            return arg;
        }
        // It's an array; check it is a valid representation of a byte
        if (Array.isArray(arg)) {
            if (!checkInts(arg)) throw new Error("Array contains invalid value: " + arg);
            return new Uint8Array(arg);
        }
        // Something else, but behaves like an array (maybe a Buffer? Arguments?)
        if (checkInt(arg.length) && checkInts(arg)) return new Uint8Array(arg);
        throw new Error("unsupported array-like object");
    }
    function createArray(length) {
        return new Uint8Array(length);
    }
    function copyArray(sourceArray, targetArray, targetStart, sourceStart, sourceEnd) {
        if (sourceStart != null || sourceEnd != null) {
            if (sourceArray.slice) sourceArray = sourceArray.slice(sourceStart, sourceEnd);
            else sourceArray = Array.prototype.slice.call(sourceArray, sourceStart, sourceEnd);
        }
        targetArray.set(sourceArray, targetStart);
    }
    var convertUtf8 = function() {
        function toBytes(text) {
            var result = [], i = 0;
            text = encodeURI(text);
            while(i < text.length){
                var c = text.charCodeAt(i++);
                // if it is a % sign, encode the following 2 bytes as a hex value
                if (c === 37) {
                    result.push(parseInt(text.substr(i, 2), 16));
                    i += 2;
                // otherwise, just the actual byte
                } else result.push(c);
            }
            return coerceArray(result);
        }
        function fromBytes(bytes) {
            var result = [], i = 0;
            while(i < bytes.length){
                var c = bytes[i];
                if (c < 128) {
                    result.push(String.fromCharCode(c));
                    i++;
                } else if (c > 191 && c < 224) {
                    result.push(String.fromCharCode((c & 0x1f) << 6 | bytes[i + 1] & 0x3f));
                    i += 2;
                } else {
                    result.push(String.fromCharCode((c & 0x0f) << 12 | (bytes[i + 1] & 0x3f) << 6 | bytes[i + 2] & 0x3f));
                    i += 3;
                }
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    var convertHex = function() {
        function toBytes(text) {
            var result = [];
            for(var i = 0; i < text.length; i += 2)result.push(parseInt(text.substr(i, 2), 16));
            return result;
        }
        // http://ixti.net/development/javascript/2011/11/11/base64-encodedecode-of-utf8-in-browser-with-js.html
        var Hex = "0123456789abcdef";
        function fromBytes(bytes) {
            var result = [];
            for(var i = 0; i < bytes.length; i++){
                var v = bytes[i];
                result.push(Hex[(v & 0xf0) >> 4] + Hex[v & 0x0f]);
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    // Number of rounds by keysize
    var numberOfRounds = {
        16: 10,
        24: 12,
        32: 14
    };
    // Round constant words
    var rcon = [
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1b,
        0x36,
        0x6c,
        0xd8,
        0xab,
        0x4d,
        0x9a,
        0x2f,
        0x5e,
        0xbc,
        0x63,
        0xc6,
        0x97,
        0x35,
        0x6a,
        0xd4,
        0xb3,
        0x7d,
        0xfa,
        0xef,
        0xc5,
        0x91
    ];
    // S-box and Inverse S-box (S is for Substitution)
    var S = [
        0x63,
        0x7c,
        0x77,
        0x7b,
        0xf2,
        0x6b,
        0x6f,
        0xc5,
        0x30,
        0x01,
        0x67,
        0x2b,
        0xfe,
        0xd7,
        0xab,
        0x76,
        0xca,
        0x82,
        0xc9,
        0x7d,
        0xfa,
        0x59,
        0x47,
        0xf0,
        0xad,
        0xd4,
        0xa2,
        0xaf,
        0x9c,
        0xa4,
        0x72,
        0xc0,
        0xb7,
        0xfd,
        0x93,
        0x26,
        0x36,
        0x3f,
        0xf7,
        0xcc,
        0x34,
        0xa5,
        0xe5,
        0xf1,
        0x71,
        0xd8,
        0x31,
        0x15,
        0x04,
        0xc7,
        0x23,
        0xc3,
        0x18,
        0x96,
        0x05,
        0x9a,
        0x07,
        0x12,
        0x80,
        0xe2,
        0xeb,
        0x27,
        0xb2,
        0x75,
        0x09,
        0x83,
        0x2c,
        0x1a,
        0x1b,
        0x6e,
        0x5a,
        0xa0,
        0x52,
        0x3b,
        0xd6,
        0xb3,
        0x29,
        0xe3,
        0x2f,
        0x84,
        0x53,
        0xd1,
        0x00,
        0xed,
        0x20,
        0xfc,
        0xb1,
        0x5b,
        0x6a,
        0xcb,
        0xbe,
        0x39,
        0x4a,
        0x4c,
        0x58,
        0xcf,
        0xd0,
        0xef,
        0xaa,
        0xfb,
        0x43,
        0x4d,
        0x33,
        0x85,
        0x45,
        0xf9,
        0x02,
        0x7f,
        0x50,
        0x3c,
        0x9f,
        0xa8,
        0x51,
        0xa3,
        0x40,
        0x8f,
        0x92,
        0x9d,
        0x38,
        0xf5,
        0xbc,
        0xb6,
        0xda,
        0x21,
        0x10,
        0xff,
        0xf3,
        0xd2,
        0xcd,
        0x0c,
        0x13,
        0xec,
        0x5f,
        0x97,
        0x44,
        0x17,
        0xc4,
        0xa7,
        0x7e,
        0x3d,
        0x64,
        0x5d,
        0x19,
        0x73,
        0x60,
        0x81,
        0x4f,
        0xdc,
        0x22,
        0x2a,
        0x90,
        0x88,
        0x46,
        0xee,
        0xb8,
        0x14,
        0xde,
        0x5e,
        0x0b,
        0xdb,
        0xe0,
        0x32,
        0x3a,
        0x0a,
        0x49,
        0x06,
        0x24,
        0x5c,
        0xc2,
        0xd3,
        0xac,
        0x62,
        0x91,
        0x95,
        0xe4,
        0x79,
        0xe7,
        0xc8,
        0x37,
        0x6d,
        0x8d,
        0xd5,
        0x4e,
        0xa9,
        0x6c,
        0x56,
        0xf4,
        0xea,
        0x65,
        0x7a,
        0xae,
        0x08,
        0xba,
        0x78,
        0x25,
        0x2e,
        0x1c,
        0xa6,
        0xb4,
        0xc6,
        0xe8,
        0xdd,
        0x74,
        0x1f,
        0x4b,
        0xbd,
        0x8b,
        0x8a,
        0x70,
        0x3e,
        0xb5,
        0x66,
        0x48,
        0x03,
        0xf6,
        0x0e,
        0x61,
        0x35,
        0x57,
        0xb9,
        0x86,
        0xc1,
        0x1d,
        0x9e,
        0xe1,
        0xf8,
        0x98,
        0x11,
        0x69,
        0xd9,
        0x8e,
        0x94,
        0x9b,
        0x1e,
        0x87,
        0xe9,
        0xce,
        0x55,
        0x28,
        0xdf,
        0x8c,
        0xa1,
        0x89,
        0x0d,
        0xbf,
        0xe6,
        0x42,
        0x68,
        0x41,
        0x99,
        0x2d,
        0x0f,
        0xb0,
        0x54,
        0xbb,
        0x16
    ];
    var Si = [
        0x52,
        0x09,
        0x6a,
        0xd5,
        0x30,
        0x36,
        0xa5,
        0x38,
        0xbf,
        0x40,
        0xa3,
        0x9e,
        0x81,
        0xf3,
        0xd7,
        0xfb,
        0x7c,
        0xe3,
        0x39,
        0x82,
        0x9b,
        0x2f,
        0xff,
        0x87,
        0x34,
        0x8e,
        0x43,
        0x44,
        0xc4,
        0xde,
        0xe9,
        0xcb,
        0x54,
        0x7b,
        0x94,
        0x32,
        0xa6,
        0xc2,
        0x23,
        0x3d,
        0xee,
        0x4c,
        0x95,
        0x0b,
        0x42,
        0xfa,
        0xc3,
        0x4e,
        0x08,
        0x2e,
        0xa1,
        0x66,
        0x28,
        0xd9,
        0x24,
        0xb2,
        0x76,
        0x5b,
        0xa2,
        0x49,
        0x6d,
        0x8b,
        0xd1,
        0x25,
        0x72,
        0xf8,
        0xf6,
        0x64,
        0x86,
        0x68,
        0x98,
        0x16,
        0xd4,
        0xa4,
        0x5c,
        0xcc,
        0x5d,
        0x65,
        0xb6,
        0x92,
        0x6c,
        0x70,
        0x48,
        0x50,
        0xfd,
        0xed,
        0xb9,
        0xda,
        0x5e,
        0x15,
        0x46,
        0x57,
        0xa7,
        0x8d,
        0x9d,
        0x84,
        0x90,
        0xd8,
        0xab,
        0x00,
        0x8c,
        0xbc,
        0xd3,
        0x0a,
        0xf7,
        0xe4,
        0x58,
        0x05,
        0xb8,
        0xb3,
        0x45,
        0x06,
        0xd0,
        0x2c,
        0x1e,
        0x8f,
        0xca,
        0x3f,
        0x0f,
        0x02,
        0xc1,
        0xaf,
        0xbd,
        0x03,
        0x01,
        0x13,
        0x8a,
        0x6b,
        0x3a,
        0x91,
        0x11,
        0x41,
        0x4f,
        0x67,
        0xdc,
        0xea,
        0x97,
        0xf2,
        0xcf,
        0xce,
        0xf0,
        0xb4,
        0xe6,
        0x73,
        0x96,
        0xac,
        0x74,
        0x22,
        0xe7,
        0xad,
        0x35,
        0x85,
        0xe2,
        0xf9,
        0x37,
        0xe8,
        0x1c,
        0x75,
        0xdf,
        0x6e,
        0x47,
        0xf1,
        0x1a,
        0x71,
        0x1d,
        0x29,
        0xc5,
        0x89,
        0x6f,
        0xb7,
        0x62,
        0x0e,
        0xaa,
        0x18,
        0xbe,
        0x1b,
        0xfc,
        0x56,
        0x3e,
        0x4b,
        0xc6,
        0xd2,
        0x79,
        0x20,
        0x9a,
        0xdb,
        0xc0,
        0xfe,
        0x78,
        0xcd,
        0x5a,
        0xf4,
        0x1f,
        0xdd,
        0xa8,
        0x33,
        0x88,
        0x07,
        0xc7,
        0x31,
        0xb1,
        0x12,
        0x10,
        0x59,
        0x27,
        0x80,
        0xec,
        0x5f,
        0x60,
        0x51,
        0x7f,
        0xa9,
        0x19,
        0xb5,
        0x4a,
        0x0d,
        0x2d,
        0xe5,
        0x7a,
        0x9f,
        0x93,
        0xc9,
        0x9c,
        0xef,
        0xa0,
        0xe0,
        0x3b,
        0x4d,
        0xae,
        0x2a,
        0xf5,
        0xb0,
        0xc8,
        0xeb,
        0xbb,
        0x3c,
        0x83,
        0x53,
        0x99,
        0x61,
        0x17,
        0x2b,
        0x04,
        0x7e,
        0xba,
        0x77,
        0xd6,
        0x26,
        0xe1,
        0x69,
        0x14,
        0x63,
        0x55,
        0x21,
        0x0c,
        0x7d
    ];
    // Transformations for encryption
    var T1 = [
        0xc66363a5,
        0xf87c7c84,
        0xee777799,
        0xf67b7b8d,
        0xfff2f20d,
        0xd66b6bbd,
        0xde6f6fb1,
        0x91c5c554,
        0x60303050,
        0x02010103,
        0xce6767a9,
        0x562b2b7d,
        0xe7fefe19,
        0xb5d7d762,
        0x4dababe6,
        0xec76769a,
        0x8fcaca45,
        0x1f82829d,
        0x89c9c940,
        0xfa7d7d87,
        0xeffafa15,
        0xb25959eb,
        0x8e4747c9,
        0xfbf0f00b,
        0x41adadec,
        0xb3d4d467,
        0x5fa2a2fd,
        0x45afafea,
        0x239c9cbf,
        0x53a4a4f7,
        0xe4727296,
        0x9bc0c05b,
        0x75b7b7c2,
        0xe1fdfd1c,
        0x3d9393ae,
        0x4c26266a,
        0x6c36365a,
        0x7e3f3f41,
        0xf5f7f702,
        0x83cccc4f,
        0x6834345c,
        0x51a5a5f4,
        0xd1e5e534,
        0xf9f1f108,
        0xe2717193,
        0xabd8d873,
        0x62313153,
        0x2a15153f,
        0x0804040c,
        0x95c7c752,
        0x46232365,
        0x9dc3c35e,
        0x30181828,
        0x379696a1,
        0x0a05050f,
        0x2f9a9ab5,
        0x0e070709,
        0x24121236,
        0x1b80809b,
        0xdfe2e23d,
        0xcdebeb26,
        0x4e272769,
        0x7fb2b2cd,
        0xea75759f,
        0x1209091b,
        0x1d83839e,
        0x582c2c74,
        0x341a1a2e,
        0x361b1b2d,
        0xdc6e6eb2,
        0xb45a5aee,
        0x5ba0a0fb,
        0xa45252f6,
        0x763b3b4d,
        0xb7d6d661,
        0x7db3b3ce,
        0x5229297b,
        0xdde3e33e,
        0x5e2f2f71,
        0x13848497,
        0xa65353f5,
        0xb9d1d168,
        0x00000000,
        0xc1eded2c,
        0x40202060,
        0xe3fcfc1f,
        0x79b1b1c8,
        0xb65b5bed,
        0xd46a6abe,
        0x8dcbcb46,
        0x67bebed9,
        0x7239394b,
        0x944a4ade,
        0x984c4cd4,
        0xb05858e8,
        0x85cfcf4a,
        0xbbd0d06b,
        0xc5efef2a,
        0x4faaaae5,
        0xedfbfb16,
        0x864343c5,
        0x9a4d4dd7,
        0x66333355,
        0x11858594,
        0x8a4545cf,
        0xe9f9f910,
        0x04020206,
        0xfe7f7f81,
        0xa05050f0,
        0x783c3c44,
        0x259f9fba,
        0x4ba8a8e3,
        0xa25151f3,
        0x5da3a3fe,
        0x804040c0,
        0x058f8f8a,
        0x3f9292ad,
        0x219d9dbc,
        0x70383848,
        0xf1f5f504,
        0x63bcbcdf,
        0x77b6b6c1,
        0xafdada75,
        0x42212163,
        0x20101030,
        0xe5ffff1a,
        0xfdf3f30e,
        0xbfd2d26d,
        0x81cdcd4c,
        0x180c0c14,
        0x26131335,
        0xc3ecec2f,
        0xbe5f5fe1,
        0x359797a2,
        0x884444cc,
        0x2e171739,
        0x93c4c457,
        0x55a7a7f2,
        0xfc7e7e82,
        0x7a3d3d47,
        0xc86464ac,
        0xba5d5de7,
        0x3219192b,
        0xe6737395,
        0xc06060a0,
        0x19818198,
        0x9e4f4fd1,
        0xa3dcdc7f,
        0x44222266,
        0x542a2a7e,
        0x3b9090ab,
        0x0b888883,
        0x8c4646ca,
        0xc7eeee29,
        0x6bb8b8d3,
        0x2814143c,
        0xa7dede79,
        0xbc5e5ee2,
        0x160b0b1d,
        0xaddbdb76,
        0xdbe0e03b,
        0x64323256,
        0x743a3a4e,
        0x140a0a1e,
        0x924949db,
        0x0c06060a,
        0x4824246c,
        0xb85c5ce4,
        0x9fc2c25d,
        0xbdd3d36e,
        0x43acacef,
        0xc46262a6,
        0x399191a8,
        0x319595a4,
        0xd3e4e437,
        0xf279798b,
        0xd5e7e732,
        0x8bc8c843,
        0x6e373759,
        0xda6d6db7,
        0x018d8d8c,
        0xb1d5d564,
        0x9c4e4ed2,
        0x49a9a9e0,
        0xd86c6cb4,
        0xac5656fa,
        0xf3f4f407,
        0xcfeaea25,
        0xca6565af,
        0xf47a7a8e,
        0x47aeaee9,
        0x10080818,
        0x6fbabad5,
        0xf0787888,
        0x4a25256f,
        0x5c2e2e72,
        0x381c1c24,
        0x57a6a6f1,
        0x73b4b4c7,
        0x97c6c651,
        0xcbe8e823,
        0xa1dddd7c,
        0xe874749c,
        0x3e1f1f21,
        0x964b4bdd,
        0x61bdbddc,
        0x0d8b8b86,
        0x0f8a8a85,
        0xe0707090,
        0x7c3e3e42,
        0x71b5b5c4,
        0xcc6666aa,
        0x904848d8,
        0x06030305,
        0xf7f6f601,
        0x1c0e0e12,
        0xc26161a3,
        0x6a35355f,
        0xae5757f9,
        0x69b9b9d0,
        0x17868691,
        0x99c1c158,
        0x3a1d1d27,
        0x279e9eb9,
        0xd9e1e138,
        0xebf8f813,
        0x2b9898b3,
        0x22111133,
        0xd26969bb,
        0xa9d9d970,
        0x078e8e89,
        0x339494a7,
        0x2d9b9bb6,
        0x3c1e1e22,
        0x15878792,
        0xc9e9e920,
        0x87cece49,
        0xaa5555ff,
        0x50282878,
        0xa5dfdf7a,
        0x038c8c8f,
        0x59a1a1f8,
        0x09898980,
        0x1a0d0d17,
        0x65bfbfda,
        0xd7e6e631,
        0x844242c6,
        0xd06868b8,
        0x824141c3,
        0x299999b0,
        0x5a2d2d77,
        0x1e0f0f11,
        0x7bb0b0cb,
        0xa85454fc,
        0x6dbbbbd6,
        0x2c16163a
    ];
    var T2 = [
        0xa5c66363,
        0x84f87c7c,
        0x99ee7777,
        0x8df67b7b,
        0x0dfff2f2,
        0xbdd66b6b,
        0xb1de6f6f,
        0x5491c5c5,
        0x50603030,
        0x03020101,
        0xa9ce6767,
        0x7d562b2b,
        0x19e7fefe,
        0x62b5d7d7,
        0xe64dabab,
        0x9aec7676,
        0x458fcaca,
        0x9d1f8282,
        0x4089c9c9,
        0x87fa7d7d,
        0x15effafa,
        0xebb25959,
        0xc98e4747,
        0x0bfbf0f0,
        0xec41adad,
        0x67b3d4d4,
        0xfd5fa2a2,
        0xea45afaf,
        0xbf239c9c,
        0xf753a4a4,
        0x96e47272,
        0x5b9bc0c0,
        0xc275b7b7,
        0x1ce1fdfd,
        0xae3d9393,
        0x6a4c2626,
        0x5a6c3636,
        0x417e3f3f,
        0x02f5f7f7,
        0x4f83cccc,
        0x5c683434,
        0xf451a5a5,
        0x34d1e5e5,
        0x08f9f1f1,
        0x93e27171,
        0x73abd8d8,
        0x53623131,
        0x3f2a1515,
        0x0c080404,
        0x5295c7c7,
        0x65462323,
        0x5e9dc3c3,
        0x28301818,
        0xa1379696,
        0x0f0a0505,
        0xb52f9a9a,
        0x090e0707,
        0x36241212,
        0x9b1b8080,
        0x3ddfe2e2,
        0x26cdebeb,
        0x694e2727,
        0xcd7fb2b2,
        0x9fea7575,
        0x1b120909,
        0x9e1d8383,
        0x74582c2c,
        0x2e341a1a,
        0x2d361b1b,
        0xb2dc6e6e,
        0xeeb45a5a,
        0xfb5ba0a0,
        0xf6a45252,
        0x4d763b3b,
        0x61b7d6d6,
        0xce7db3b3,
        0x7b522929,
        0x3edde3e3,
        0x715e2f2f,
        0x97138484,
        0xf5a65353,
        0x68b9d1d1,
        0x00000000,
        0x2cc1eded,
        0x60402020,
        0x1fe3fcfc,
        0xc879b1b1,
        0xedb65b5b,
        0xbed46a6a,
        0x468dcbcb,
        0xd967bebe,
        0x4b723939,
        0xde944a4a,
        0xd4984c4c,
        0xe8b05858,
        0x4a85cfcf,
        0x6bbbd0d0,
        0x2ac5efef,
        0xe54faaaa,
        0x16edfbfb,
        0xc5864343,
        0xd79a4d4d,
        0x55663333,
        0x94118585,
        0xcf8a4545,
        0x10e9f9f9,
        0x06040202,
        0x81fe7f7f,
        0xf0a05050,
        0x44783c3c,
        0xba259f9f,
        0xe34ba8a8,
        0xf3a25151,
        0xfe5da3a3,
        0xc0804040,
        0x8a058f8f,
        0xad3f9292,
        0xbc219d9d,
        0x48703838,
        0x04f1f5f5,
        0xdf63bcbc,
        0xc177b6b6,
        0x75afdada,
        0x63422121,
        0x30201010,
        0x1ae5ffff,
        0x0efdf3f3,
        0x6dbfd2d2,
        0x4c81cdcd,
        0x14180c0c,
        0x35261313,
        0x2fc3ecec,
        0xe1be5f5f,
        0xa2359797,
        0xcc884444,
        0x392e1717,
        0x5793c4c4,
        0xf255a7a7,
        0x82fc7e7e,
        0x477a3d3d,
        0xacc86464,
        0xe7ba5d5d,
        0x2b321919,
        0x95e67373,
        0xa0c06060,
        0x98198181,
        0xd19e4f4f,
        0x7fa3dcdc,
        0x66442222,
        0x7e542a2a,
        0xab3b9090,
        0x830b8888,
        0xca8c4646,
        0x29c7eeee,
        0xd36bb8b8,
        0x3c281414,
        0x79a7dede,
        0xe2bc5e5e,
        0x1d160b0b,
        0x76addbdb,
        0x3bdbe0e0,
        0x56643232,
        0x4e743a3a,
        0x1e140a0a,
        0xdb924949,
        0x0a0c0606,
        0x6c482424,
        0xe4b85c5c,
        0x5d9fc2c2,
        0x6ebdd3d3,
        0xef43acac,
        0xa6c46262,
        0xa8399191,
        0xa4319595,
        0x37d3e4e4,
        0x8bf27979,
        0x32d5e7e7,
        0x438bc8c8,
        0x596e3737,
        0xb7da6d6d,
        0x8c018d8d,
        0x64b1d5d5,
        0xd29c4e4e,
        0xe049a9a9,
        0xb4d86c6c,
        0xfaac5656,
        0x07f3f4f4,
        0x25cfeaea,
        0xafca6565,
        0x8ef47a7a,
        0xe947aeae,
        0x18100808,
        0xd56fbaba,
        0x88f07878,
        0x6f4a2525,
        0x725c2e2e,
        0x24381c1c,
        0xf157a6a6,
        0xc773b4b4,
        0x5197c6c6,
        0x23cbe8e8,
        0x7ca1dddd,
        0x9ce87474,
        0x213e1f1f,
        0xdd964b4b,
        0xdc61bdbd,
        0x860d8b8b,
        0x850f8a8a,
        0x90e07070,
        0x427c3e3e,
        0xc471b5b5,
        0xaacc6666,
        0xd8904848,
        0x05060303,
        0x01f7f6f6,
        0x121c0e0e,
        0xa3c26161,
        0x5f6a3535,
        0xf9ae5757,
        0xd069b9b9,
        0x91178686,
        0x5899c1c1,
        0x273a1d1d,
        0xb9279e9e,
        0x38d9e1e1,
        0x13ebf8f8,
        0xb32b9898,
        0x33221111,
        0xbbd26969,
        0x70a9d9d9,
        0x89078e8e,
        0xa7339494,
        0xb62d9b9b,
        0x223c1e1e,
        0x92158787,
        0x20c9e9e9,
        0x4987cece,
        0xffaa5555,
        0x78502828,
        0x7aa5dfdf,
        0x8f038c8c,
        0xf859a1a1,
        0x80098989,
        0x171a0d0d,
        0xda65bfbf,
        0x31d7e6e6,
        0xc6844242,
        0xb8d06868,
        0xc3824141,
        0xb0299999,
        0x775a2d2d,
        0x111e0f0f,
        0xcb7bb0b0,
        0xfca85454,
        0xd66dbbbb,
        0x3a2c1616
    ];
    var T3 = [
        0x63a5c663,
        0x7c84f87c,
        0x7799ee77,
        0x7b8df67b,
        0xf20dfff2,
        0x6bbdd66b,
        0x6fb1de6f,
        0xc55491c5,
        0x30506030,
        0x01030201,
        0x67a9ce67,
        0x2b7d562b,
        0xfe19e7fe,
        0xd762b5d7,
        0xabe64dab,
        0x769aec76,
        0xca458fca,
        0x829d1f82,
        0xc94089c9,
        0x7d87fa7d,
        0xfa15effa,
        0x59ebb259,
        0x47c98e47,
        0xf00bfbf0,
        0xadec41ad,
        0xd467b3d4,
        0xa2fd5fa2,
        0xafea45af,
        0x9cbf239c,
        0xa4f753a4,
        0x7296e472,
        0xc05b9bc0,
        0xb7c275b7,
        0xfd1ce1fd,
        0x93ae3d93,
        0x266a4c26,
        0x365a6c36,
        0x3f417e3f,
        0xf702f5f7,
        0xcc4f83cc,
        0x345c6834,
        0xa5f451a5,
        0xe534d1e5,
        0xf108f9f1,
        0x7193e271,
        0xd873abd8,
        0x31536231,
        0x153f2a15,
        0x040c0804,
        0xc75295c7,
        0x23654623,
        0xc35e9dc3,
        0x18283018,
        0x96a13796,
        0x050f0a05,
        0x9ab52f9a,
        0x07090e07,
        0x12362412,
        0x809b1b80,
        0xe23ddfe2,
        0xeb26cdeb,
        0x27694e27,
        0xb2cd7fb2,
        0x759fea75,
        0x091b1209,
        0x839e1d83,
        0x2c74582c,
        0x1a2e341a,
        0x1b2d361b,
        0x6eb2dc6e,
        0x5aeeb45a,
        0xa0fb5ba0,
        0x52f6a452,
        0x3b4d763b,
        0xd661b7d6,
        0xb3ce7db3,
        0x297b5229,
        0xe33edde3,
        0x2f715e2f,
        0x84971384,
        0x53f5a653,
        0xd168b9d1,
        0x00000000,
        0xed2cc1ed,
        0x20604020,
        0xfc1fe3fc,
        0xb1c879b1,
        0x5bedb65b,
        0x6abed46a,
        0xcb468dcb,
        0xbed967be,
        0x394b7239,
        0x4ade944a,
        0x4cd4984c,
        0x58e8b058,
        0xcf4a85cf,
        0xd06bbbd0,
        0xef2ac5ef,
        0xaae54faa,
        0xfb16edfb,
        0x43c58643,
        0x4dd79a4d,
        0x33556633,
        0x85941185,
        0x45cf8a45,
        0xf910e9f9,
        0x02060402,
        0x7f81fe7f,
        0x50f0a050,
        0x3c44783c,
        0x9fba259f,
        0xa8e34ba8,
        0x51f3a251,
        0xa3fe5da3,
        0x40c08040,
        0x8f8a058f,
        0x92ad3f92,
        0x9dbc219d,
        0x38487038,
        0xf504f1f5,
        0xbcdf63bc,
        0xb6c177b6,
        0xda75afda,
        0x21634221,
        0x10302010,
        0xff1ae5ff,
        0xf30efdf3,
        0xd26dbfd2,
        0xcd4c81cd,
        0x0c14180c,
        0x13352613,
        0xec2fc3ec,
        0x5fe1be5f,
        0x97a23597,
        0x44cc8844,
        0x17392e17,
        0xc45793c4,
        0xa7f255a7,
        0x7e82fc7e,
        0x3d477a3d,
        0x64acc864,
        0x5de7ba5d,
        0x192b3219,
        0x7395e673,
        0x60a0c060,
        0x81981981,
        0x4fd19e4f,
        0xdc7fa3dc,
        0x22664422,
        0x2a7e542a,
        0x90ab3b90,
        0x88830b88,
        0x46ca8c46,
        0xee29c7ee,
        0xb8d36bb8,
        0x143c2814,
        0xde79a7de,
        0x5ee2bc5e,
        0x0b1d160b,
        0xdb76addb,
        0xe03bdbe0,
        0x32566432,
        0x3a4e743a,
        0x0a1e140a,
        0x49db9249,
        0x060a0c06,
        0x246c4824,
        0x5ce4b85c,
        0xc25d9fc2,
        0xd36ebdd3,
        0xacef43ac,
        0x62a6c462,
        0x91a83991,
        0x95a43195,
        0xe437d3e4,
        0x798bf279,
        0xe732d5e7,
        0xc8438bc8,
        0x37596e37,
        0x6db7da6d,
        0x8d8c018d,
        0xd564b1d5,
        0x4ed29c4e,
        0xa9e049a9,
        0x6cb4d86c,
        0x56faac56,
        0xf407f3f4,
        0xea25cfea,
        0x65afca65,
        0x7a8ef47a,
        0xaee947ae,
        0x08181008,
        0xbad56fba,
        0x7888f078,
        0x256f4a25,
        0x2e725c2e,
        0x1c24381c,
        0xa6f157a6,
        0xb4c773b4,
        0xc65197c6,
        0xe823cbe8,
        0xdd7ca1dd,
        0x749ce874,
        0x1f213e1f,
        0x4bdd964b,
        0xbddc61bd,
        0x8b860d8b,
        0x8a850f8a,
        0x7090e070,
        0x3e427c3e,
        0xb5c471b5,
        0x66aacc66,
        0x48d89048,
        0x03050603,
        0xf601f7f6,
        0x0e121c0e,
        0x61a3c261,
        0x355f6a35,
        0x57f9ae57,
        0xb9d069b9,
        0x86911786,
        0xc15899c1,
        0x1d273a1d,
        0x9eb9279e,
        0xe138d9e1,
        0xf813ebf8,
        0x98b32b98,
        0x11332211,
        0x69bbd269,
        0xd970a9d9,
        0x8e89078e,
        0x94a73394,
        0x9bb62d9b,
        0x1e223c1e,
        0x87921587,
        0xe920c9e9,
        0xce4987ce,
        0x55ffaa55,
        0x28785028,
        0xdf7aa5df,
        0x8c8f038c,
        0xa1f859a1,
        0x89800989,
        0x0d171a0d,
        0xbfda65bf,
        0xe631d7e6,
        0x42c68442,
        0x68b8d068,
        0x41c38241,
        0x99b02999,
        0x2d775a2d,
        0x0f111e0f,
        0xb0cb7bb0,
        0x54fca854,
        0xbbd66dbb,
        0x163a2c16
    ];
    var T4 = [
        0x6363a5c6,
        0x7c7c84f8,
        0x777799ee,
        0x7b7b8df6,
        0xf2f20dff,
        0x6b6bbdd6,
        0x6f6fb1de,
        0xc5c55491,
        0x30305060,
        0x01010302,
        0x6767a9ce,
        0x2b2b7d56,
        0xfefe19e7,
        0xd7d762b5,
        0xababe64d,
        0x76769aec,
        0xcaca458f,
        0x82829d1f,
        0xc9c94089,
        0x7d7d87fa,
        0xfafa15ef,
        0x5959ebb2,
        0x4747c98e,
        0xf0f00bfb,
        0xadadec41,
        0xd4d467b3,
        0xa2a2fd5f,
        0xafafea45,
        0x9c9cbf23,
        0xa4a4f753,
        0x727296e4,
        0xc0c05b9b,
        0xb7b7c275,
        0xfdfd1ce1,
        0x9393ae3d,
        0x26266a4c,
        0x36365a6c,
        0x3f3f417e,
        0xf7f702f5,
        0xcccc4f83,
        0x34345c68,
        0xa5a5f451,
        0xe5e534d1,
        0xf1f108f9,
        0x717193e2,
        0xd8d873ab,
        0x31315362,
        0x15153f2a,
        0x04040c08,
        0xc7c75295,
        0x23236546,
        0xc3c35e9d,
        0x18182830,
        0x9696a137,
        0x05050f0a,
        0x9a9ab52f,
        0x0707090e,
        0x12123624,
        0x80809b1b,
        0xe2e23ddf,
        0xebeb26cd,
        0x2727694e,
        0xb2b2cd7f,
        0x75759fea,
        0x09091b12,
        0x83839e1d,
        0x2c2c7458,
        0x1a1a2e34,
        0x1b1b2d36,
        0x6e6eb2dc,
        0x5a5aeeb4,
        0xa0a0fb5b,
        0x5252f6a4,
        0x3b3b4d76,
        0xd6d661b7,
        0xb3b3ce7d,
        0x29297b52,
        0xe3e33edd,
        0x2f2f715e,
        0x84849713,
        0x5353f5a6,
        0xd1d168b9,
        0x00000000,
        0xeded2cc1,
        0x20206040,
        0xfcfc1fe3,
        0xb1b1c879,
        0x5b5bedb6,
        0x6a6abed4,
        0xcbcb468d,
        0xbebed967,
        0x39394b72,
        0x4a4ade94,
        0x4c4cd498,
        0x5858e8b0,
        0xcfcf4a85,
        0xd0d06bbb,
        0xefef2ac5,
        0xaaaae54f,
        0xfbfb16ed,
        0x4343c586,
        0x4d4dd79a,
        0x33335566,
        0x85859411,
        0x4545cf8a,
        0xf9f910e9,
        0x02020604,
        0x7f7f81fe,
        0x5050f0a0,
        0x3c3c4478,
        0x9f9fba25,
        0xa8a8e34b,
        0x5151f3a2,
        0xa3a3fe5d,
        0x4040c080,
        0x8f8f8a05,
        0x9292ad3f,
        0x9d9dbc21,
        0x38384870,
        0xf5f504f1,
        0xbcbcdf63,
        0xb6b6c177,
        0xdada75af,
        0x21216342,
        0x10103020,
        0xffff1ae5,
        0xf3f30efd,
        0xd2d26dbf,
        0xcdcd4c81,
        0x0c0c1418,
        0x13133526,
        0xecec2fc3,
        0x5f5fe1be,
        0x9797a235,
        0x4444cc88,
        0x1717392e,
        0xc4c45793,
        0xa7a7f255,
        0x7e7e82fc,
        0x3d3d477a,
        0x6464acc8,
        0x5d5de7ba,
        0x19192b32,
        0x737395e6,
        0x6060a0c0,
        0x81819819,
        0x4f4fd19e,
        0xdcdc7fa3,
        0x22226644,
        0x2a2a7e54,
        0x9090ab3b,
        0x8888830b,
        0x4646ca8c,
        0xeeee29c7,
        0xb8b8d36b,
        0x14143c28,
        0xdede79a7,
        0x5e5ee2bc,
        0x0b0b1d16,
        0xdbdb76ad,
        0xe0e03bdb,
        0x32325664,
        0x3a3a4e74,
        0x0a0a1e14,
        0x4949db92,
        0x06060a0c,
        0x24246c48,
        0x5c5ce4b8,
        0xc2c25d9f,
        0xd3d36ebd,
        0xacacef43,
        0x6262a6c4,
        0x9191a839,
        0x9595a431,
        0xe4e437d3,
        0x79798bf2,
        0xe7e732d5,
        0xc8c8438b,
        0x3737596e,
        0x6d6db7da,
        0x8d8d8c01,
        0xd5d564b1,
        0x4e4ed29c,
        0xa9a9e049,
        0x6c6cb4d8,
        0x5656faac,
        0xf4f407f3,
        0xeaea25cf,
        0x6565afca,
        0x7a7a8ef4,
        0xaeaee947,
        0x08081810,
        0xbabad56f,
        0x787888f0,
        0x25256f4a,
        0x2e2e725c,
        0x1c1c2438,
        0xa6a6f157,
        0xb4b4c773,
        0xc6c65197,
        0xe8e823cb,
        0xdddd7ca1,
        0x74749ce8,
        0x1f1f213e,
        0x4b4bdd96,
        0xbdbddc61,
        0x8b8b860d,
        0x8a8a850f,
        0x707090e0,
        0x3e3e427c,
        0xb5b5c471,
        0x6666aacc,
        0x4848d890,
        0x03030506,
        0xf6f601f7,
        0x0e0e121c,
        0x6161a3c2,
        0x35355f6a,
        0x5757f9ae,
        0xb9b9d069,
        0x86869117,
        0xc1c15899,
        0x1d1d273a,
        0x9e9eb927,
        0xe1e138d9,
        0xf8f813eb,
        0x9898b32b,
        0x11113322,
        0x6969bbd2,
        0xd9d970a9,
        0x8e8e8907,
        0x9494a733,
        0x9b9bb62d,
        0x1e1e223c,
        0x87879215,
        0xe9e920c9,
        0xcece4987,
        0x5555ffaa,
        0x28287850,
        0xdfdf7aa5,
        0x8c8c8f03,
        0xa1a1f859,
        0x89898009,
        0x0d0d171a,
        0xbfbfda65,
        0xe6e631d7,
        0x4242c684,
        0x6868b8d0,
        0x4141c382,
        0x9999b029,
        0x2d2d775a,
        0x0f0f111e,
        0xb0b0cb7b,
        0x5454fca8,
        0xbbbbd66d,
        0x16163a2c
    ];
    // Transformations for decryption
    var T5 = [
        0x51f4a750,
        0x7e416553,
        0x1a17a4c3,
        0x3a275e96,
        0x3bab6bcb,
        0x1f9d45f1,
        0xacfa58ab,
        0x4be30393,
        0x2030fa55,
        0xad766df6,
        0x88cc7691,
        0xf5024c25,
        0x4fe5d7fc,
        0xc52acbd7,
        0x26354480,
        0xb562a38f,
        0xdeb15a49,
        0x25ba1b67,
        0x45ea0e98,
        0x5dfec0e1,
        0xc32f7502,
        0x814cf012,
        0x8d4697a3,
        0x6bd3f9c6,
        0x038f5fe7,
        0x15929c95,
        0xbf6d7aeb,
        0x955259da,
        0xd4be832d,
        0x587421d3,
        0x49e06929,
        0x8ec9c844,
        0x75c2896a,
        0xf48e7978,
        0x99583e6b,
        0x27b971dd,
        0xbee14fb6,
        0xf088ad17,
        0xc920ac66,
        0x7dce3ab4,
        0x63df4a18,
        0xe51a3182,
        0x97513360,
        0x62537f45,
        0xb16477e0,
        0xbb6bae84,
        0xfe81a01c,
        0xf9082b94,
        0x70486858,
        0x8f45fd19,
        0x94de6c87,
        0x527bf8b7,
        0xab73d323,
        0x724b02e2,
        0xe31f8f57,
        0x6655ab2a,
        0xb2eb2807,
        0x2fb5c203,
        0x86c57b9a,
        0xd33708a5,
        0x302887f2,
        0x23bfa5b2,
        0x02036aba,
        0xed16825c,
        0x8acf1c2b,
        0xa779b492,
        0xf307f2f0,
        0x4e69e2a1,
        0x65daf4cd,
        0x0605bed5,
        0xd134621f,
        0xc4a6fe8a,
        0x342e539d,
        0xa2f355a0,
        0x058ae132,
        0xa4f6eb75,
        0x0b83ec39,
        0x4060efaa,
        0x5e719f06,
        0xbd6e1051,
        0x3e218af9,
        0x96dd063d,
        0xdd3e05ae,
        0x4de6bd46,
        0x91548db5,
        0x71c45d05,
        0x0406d46f,
        0x605015ff,
        0x1998fb24,
        0xd6bde997,
        0x894043cc,
        0x67d99e77,
        0xb0e842bd,
        0x07898b88,
        0xe7195b38,
        0x79c8eedb,
        0xa17c0a47,
        0x7c420fe9,
        0xf8841ec9,
        0x00000000,
        0x09808683,
        0x322bed48,
        0x1e1170ac,
        0x6c5a724e,
        0xfd0efffb,
        0x0f853856,
        0x3daed51e,
        0x362d3927,
        0x0a0fd964,
        0x685ca621,
        0x9b5b54d1,
        0x24362e3a,
        0x0c0a67b1,
        0x9357e70f,
        0xb4ee96d2,
        0x1b9b919e,
        0x80c0c54f,
        0x61dc20a2,
        0x5a774b69,
        0x1c121a16,
        0xe293ba0a,
        0xc0a02ae5,
        0x3c22e043,
        0x121b171d,
        0x0e090d0b,
        0xf28bc7ad,
        0x2db6a8b9,
        0x141ea9c8,
        0x57f11985,
        0xaf75074c,
        0xee99ddbb,
        0xa37f60fd,
        0xf701269f,
        0x5c72f5bc,
        0x44663bc5,
        0x5bfb7e34,
        0x8b432976,
        0xcb23c6dc,
        0xb6edfc68,
        0xb8e4f163,
        0xd731dcca,
        0x42638510,
        0x13972240,
        0x84c61120,
        0x854a247d,
        0xd2bb3df8,
        0xaef93211,
        0xc729a16d,
        0x1d9e2f4b,
        0xdcb230f3,
        0x0d8652ec,
        0x77c1e3d0,
        0x2bb3166c,
        0xa970b999,
        0x119448fa,
        0x47e96422,
        0xa8fc8cc4,
        0xa0f03f1a,
        0x567d2cd8,
        0x223390ef,
        0x87494ec7,
        0xd938d1c1,
        0x8ccaa2fe,
        0x98d40b36,
        0xa6f581cf,
        0xa57ade28,
        0xdab78e26,
        0x3fadbfa4,
        0x2c3a9de4,
        0x5078920d,
        0x6a5fcc9b,
        0x547e4662,
        0xf68d13c2,
        0x90d8b8e8,
        0x2e39f75e,
        0x82c3aff5,
        0x9f5d80be,
        0x69d0937c,
        0x6fd52da9,
        0xcf2512b3,
        0xc8ac993b,
        0x10187da7,
        0xe89c636e,
        0xdb3bbb7b,
        0xcd267809,
        0x6e5918f4,
        0xec9ab701,
        0x834f9aa8,
        0xe6956e65,
        0xaaffe67e,
        0x21bccf08,
        0xef15e8e6,
        0xbae79bd9,
        0x4a6f36ce,
        0xea9f09d4,
        0x29b07cd6,
        0x31a4b2af,
        0x2a3f2331,
        0xc6a59430,
        0x35a266c0,
        0x744ebc37,
        0xfc82caa6,
        0xe090d0b0,
        0x33a7d815,
        0xf104984a,
        0x41ecdaf7,
        0x7fcd500e,
        0x1791f62f,
        0x764dd68d,
        0x43efb04d,
        0xccaa4d54,
        0xe49604df,
        0x9ed1b5e3,
        0x4c6a881b,
        0xc12c1fb8,
        0x4665517f,
        0x9d5eea04,
        0x018c355d,
        0xfa877473,
        0xfb0b412e,
        0xb3671d5a,
        0x92dbd252,
        0xe9105633,
        0x6dd64713,
        0x9ad7618c,
        0x37a10c7a,
        0x59f8148e,
        0xeb133c89,
        0xcea927ee,
        0xb761c935,
        0xe11ce5ed,
        0x7a47b13c,
        0x9cd2df59,
        0x55f2733f,
        0x1814ce79,
        0x73c737bf,
        0x53f7cdea,
        0x5ffdaa5b,
        0xdf3d6f14,
        0x7844db86,
        0xcaaff381,
        0xb968c43e,
        0x3824342c,
        0xc2a3405f,
        0x161dc372,
        0xbce2250c,
        0x283c498b,
        0xff0d9541,
        0x39a80171,
        0x080cb3de,
        0xd8b4e49c,
        0x6456c190,
        0x7bcb8461,
        0xd532b670,
        0x486c5c74,
        0xd0b85742
    ];
    var T6 = [
        0x5051f4a7,
        0x537e4165,
        0xc31a17a4,
        0x963a275e,
        0xcb3bab6b,
        0xf11f9d45,
        0xabacfa58,
        0x934be303,
        0x552030fa,
        0xf6ad766d,
        0x9188cc76,
        0x25f5024c,
        0xfc4fe5d7,
        0xd7c52acb,
        0x80263544,
        0x8fb562a3,
        0x49deb15a,
        0x6725ba1b,
        0x9845ea0e,
        0xe15dfec0,
        0x02c32f75,
        0x12814cf0,
        0xa38d4697,
        0xc66bd3f9,
        0xe7038f5f,
        0x9515929c,
        0xebbf6d7a,
        0xda955259,
        0x2dd4be83,
        0xd3587421,
        0x2949e069,
        0x448ec9c8,
        0x6a75c289,
        0x78f48e79,
        0x6b99583e,
        0xdd27b971,
        0xb6bee14f,
        0x17f088ad,
        0x66c920ac,
        0xb47dce3a,
        0x1863df4a,
        0x82e51a31,
        0x60975133,
        0x4562537f,
        0xe0b16477,
        0x84bb6bae,
        0x1cfe81a0,
        0x94f9082b,
        0x58704868,
        0x198f45fd,
        0x8794de6c,
        0xb7527bf8,
        0x23ab73d3,
        0xe2724b02,
        0x57e31f8f,
        0x2a6655ab,
        0x07b2eb28,
        0x032fb5c2,
        0x9a86c57b,
        0xa5d33708,
        0xf2302887,
        0xb223bfa5,
        0xba02036a,
        0x5ced1682,
        0x2b8acf1c,
        0x92a779b4,
        0xf0f307f2,
        0xa14e69e2,
        0xcd65daf4,
        0xd50605be,
        0x1fd13462,
        0x8ac4a6fe,
        0x9d342e53,
        0xa0a2f355,
        0x32058ae1,
        0x75a4f6eb,
        0x390b83ec,
        0xaa4060ef,
        0x065e719f,
        0x51bd6e10,
        0xf93e218a,
        0x3d96dd06,
        0xaedd3e05,
        0x464de6bd,
        0xb591548d,
        0x0571c45d,
        0x6f0406d4,
        0xff605015,
        0x241998fb,
        0x97d6bde9,
        0xcc894043,
        0x7767d99e,
        0xbdb0e842,
        0x8807898b,
        0x38e7195b,
        0xdb79c8ee,
        0x47a17c0a,
        0xe97c420f,
        0xc9f8841e,
        0x00000000,
        0x83098086,
        0x48322bed,
        0xac1e1170,
        0x4e6c5a72,
        0xfbfd0eff,
        0x560f8538,
        0x1e3daed5,
        0x27362d39,
        0x640a0fd9,
        0x21685ca6,
        0xd19b5b54,
        0x3a24362e,
        0xb10c0a67,
        0x0f9357e7,
        0xd2b4ee96,
        0x9e1b9b91,
        0x4f80c0c5,
        0xa261dc20,
        0x695a774b,
        0x161c121a,
        0x0ae293ba,
        0xe5c0a02a,
        0x433c22e0,
        0x1d121b17,
        0x0b0e090d,
        0xadf28bc7,
        0xb92db6a8,
        0xc8141ea9,
        0x8557f119,
        0x4caf7507,
        0xbbee99dd,
        0xfda37f60,
        0x9ff70126,
        0xbc5c72f5,
        0xc544663b,
        0x345bfb7e,
        0x768b4329,
        0xdccb23c6,
        0x68b6edfc,
        0x63b8e4f1,
        0xcad731dc,
        0x10426385,
        0x40139722,
        0x2084c611,
        0x7d854a24,
        0xf8d2bb3d,
        0x11aef932,
        0x6dc729a1,
        0x4b1d9e2f,
        0xf3dcb230,
        0xec0d8652,
        0xd077c1e3,
        0x6c2bb316,
        0x99a970b9,
        0xfa119448,
        0x2247e964,
        0xc4a8fc8c,
        0x1aa0f03f,
        0xd8567d2c,
        0xef223390,
        0xc787494e,
        0xc1d938d1,
        0xfe8ccaa2,
        0x3698d40b,
        0xcfa6f581,
        0x28a57ade,
        0x26dab78e,
        0xa43fadbf,
        0xe42c3a9d,
        0x0d507892,
        0x9b6a5fcc,
        0x62547e46,
        0xc2f68d13,
        0xe890d8b8,
        0x5e2e39f7,
        0xf582c3af,
        0xbe9f5d80,
        0x7c69d093,
        0xa96fd52d,
        0xb3cf2512,
        0x3bc8ac99,
        0xa710187d,
        0x6ee89c63,
        0x7bdb3bbb,
        0x09cd2678,
        0xf46e5918,
        0x01ec9ab7,
        0xa8834f9a,
        0x65e6956e,
        0x7eaaffe6,
        0x0821bccf,
        0xe6ef15e8,
        0xd9bae79b,
        0xce4a6f36,
        0xd4ea9f09,
        0xd629b07c,
        0xaf31a4b2,
        0x312a3f23,
        0x30c6a594,
        0xc035a266,
        0x37744ebc,
        0xa6fc82ca,
        0xb0e090d0,
        0x1533a7d8,
        0x4af10498,
        0xf741ecda,
        0x0e7fcd50,
        0x2f1791f6,
        0x8d764dd6,
        0x4d43efb0,
        0x54ccaa4d,
        0xdfe49604,
        0xe39ed1b5,
        0x1b4c6a88,
        0xb8c12c1f,
        0x7f466551,
        0x049d5eea,
        0x5d018c35,
        0x73fa8774,
        0x2efb0b41,
        0x5ab3671d,
        0x5292dbd2,
        0x33e91056,
        0x136dd647,
        0x8c9ad761,
        0x7a37a10c,
        0x8e59f814,
        0x89eb133c,
        0xeecea927,
        0x35b761c9,
        0xede11ce5,
        0x3c7a47b1,
        0x599cd2df,
        0x3f55f273,
        0x791814ce,
        0xbf73c737,
        0xea53f7cd,
        0x5b5ffdaa,
        0x14df3d6f,
        0x867844db,
        0x81caaff3,
        0x3eb968c4,
        0x2c382434,
        0x5fc2a340,
        0x72161dc3,
        0x0cbce225,
        0x8b283c49,
        0x41ff0d95,
        0x7139a801,
        0xde080cb3,
        0x9cd8b4e4,
        0x906456c1,
        0x617bcb84,
        0x70d532b6,
        0x74486c5c,
        0x42d0b857
    ];
    var T7 = [
        0xa75051f4,
        0x65537e41,
        0xa4c31a17,
        0x5e963a27,
        0x6bcb3bab,
        0x45f11f9d,
        0x58abacfa,
        0x03934be3,
        0xfa552030,
        0x6df6ad76,
        0x769188cc,
        0x4c25f502,
        0xd7fc4fe5,
        0xcbd7c52a,
        0x44802635,
        0xa38fb562,
        0x5a49deb1,
        0x1b6725ba,
        0x0e9845ea,
        0xc0e15dfe,
        0x7502c32f,
        0xf012814c,
        0x97a38d46,
        0xf9c66bd3,
        0x5fe7038f,
        0x9c951592,
        0x7aebbf6d,
        0x59da9552,
        0x832dd4be,
        0x21d35874,
        0x692949e0,
        0xc8448ec9,
        0x896a75c2,
        0x7978f48e,
        0x3e6b9958,
        0x71dd27b9,
        0x4fb6bee1,
        0xad17f088,
        0xac66c920,
        0x3ab47dce,
        0x4a1863df,
        0x3182e51a,
        0x33609751,
        0x7f456253,
        0x77e0b164,
        0xae84bb6b,
        0xa01cfe81,
        0x2b94f908,
        0x68587048,
        0xfd198f45,
        0x6c8794de,
        0xf8b7527b,
        0xd323ab73,
        0x02e2724b,
        0x8f57e31f,
        0xab2a6655,
        0x2807b2eb,
        0xc2032fb5,
        0x7b9a86c5,
        0x08a5d337,
        0x87f23028,
        0xa5b223bf,
        0x6aba0203,
        0x825ced16,
        0x1c2b8acf,
        0xb492a779,
        0xf2f0f307,
        0xe2a14e69,
        0xf4cd65da,
        0xbed50605,
        0x621fd134,
        0xfe8ac4a6,
        0x539d342e,
        0x55a0a2f3,
        0xe132058a,
        0xeb75a4f6,
        0xec390b83,
        0xefaa4060,
        0x9f065e71,
        0x1051bd6e,
        0x8af93e21,
        0x063d96dd,
        0x05aedd3e,
        0xbd464de6,
        0x8db59154,
        0x5d0571c4,
        0xd46f0406,
        0x15ff6050,
        0xfb241998,
        0xe997d6bd,
        0x43cc8940,
        0x9e7767d9,
        0x42bdb0e8,
        0x8b880789,
        0x5b38e719,
        0xeedb79c8,
        0x0a47a17c,
        0x0fe97c42,
        0x1ec9f884,
        0x00000000,
        0x86830980,
        0xed48322b,
        0x70ac1e11,
        0x724e6c5a,
        0xfffbfd0e,
        0x38560f85,
        0xd51e3dae,
        0x3927362d,
        0xd9640a0f,
        0xa621685c,
        0x54d19b5b,
        0x2e3a2436,
        0x67b10c0a,
        0xe70f9357,
        0x96d2b4ee,
        0x919e1b9b,
        0xc54f80c0,
        0x20a261dc,
        0x4b695a77,
        0x1a161c12,
        0xba0ae293,
        0x2ae5c0a0,
        0xe0433c22,
        0x171d121b,
        0x0d0b0e09,
        0xc7adf28b,
        0xa8b92db6,
        0xa9c8141e,
        0x198557f1,
        0x074caf75,
        0xddbbee99,
        0x60fda37f,
        0x269ff701,
        0xf5bc5c72,
        0x3bc54466,
        0x7e345bfb,
        0x29768b43,
        0xc6dccb23,
        0xfc68b6ed,
        0xf163b8e4,
        0xdccad731,
        0x85104263,
        0x22401397,
        0x112084c6,
        0x247d854a,
        0x3df8d2bb,
        0x3211aef9,
        0xa16dc729,
        0x2f4b1d9e,
        0x30f3dcb2,
        0x52ec0d86,
        0xe3d077c1,
        0x166c2bb3,
        0xb999a970,
        0x48fa1194,
        0x642247e9,
        0x8cc4a8fc,
        0x3f1aa0f0,
        0x2cd8567d,
        0x90ef2233,
        0x4ec78749,
        0xd1c1d938,
        0xa2fe8cca,
        0x0b3698d4,
        0x81cfa6f5,
        0xde28a57a,
        0x8e26dab7,
        0xbfa43fad,
        0x9de42c3a,
        0x920d5078,
        0xcc9b6a5f,
        0x4662547e,
        0x13c2f68d,
        0xb8e890d8,
        0xf75e2e39,
        0xaff582c3,
        0x80be9f5d,
        0x937c69d0,
        0x2da96fd5,
        0x12b3cf25,
        0x993bc8ac,
        0x7da71018,
        0x636ee89c,
        0xbb7bdb3b,
        0x7809cd26,
        0x18f46e59,
        0xb701ec9a,
        0x9aa8834f,
        0x6e65e695,
        0xe67eaaff,
        0xcf0821bc,
        0xe8e6ef15,
        0x9bd9bae7,
        0x36ce4a6f,
        0x09d4ea9f,
        0x7cd629b0,
        0xb2af31a4,
        0x23312a3f,
        0x9430c6a5,
        0x66c035a2,
        0xbc37744e,
        0xcaa6fc82,
        0xd0b0e090,
        0xd81533a7,
        0x984af104,
        0xdaf741ec,
        0x500e7fcd,
        0xf62f1791,
        0xd68d764d,
        0xb04d43ef,
        0x4d54ccaa,
        0x04dfe496,
        0xb5e39ed1,
        0x881b4c6a,
        0x1fb8c12c,
        0x517f4665,
        0xea049d5e,
        0x355d018c,
        0x7473fa87,
        0x412efb0b,
        0x1d5ab367,
        0xd25292db,
        0x5633e910,
        0x47136dd6,
        0x618c9ad7,
        0x0c7a37a1,
        0x148e59f8,
        0x3c89eb13,
        0x27eecea9,
        0xc935b761,
        0xe5ede11c,
        0xb13c7a47,
        0xdf599cd2,
        0x733f55f2,
        0xce791814,
        0x37bf73c7,
        0xcdea53f7,
        0xaa5b5ffd,
        0x6f14df3d,
        0xdb867844,
        0xf381caaf,
        0xc43eb968,
        0x342c3824,
        0x405fc2a3,
        0xc372161d,
        0x250cbce2,
        0x498b283c,
        0x9541ff0d,
        0x017139a8,
        0xb3de080c,
        0xe49cd8b4,
        0xc1906456,
        0x84617bcb,
        0xb670d532,
        0x5c74486c,
        0x5742d0b8
    ];
    var T8 = [
        0xf4a75051,
        0x4165537e,
        0x17a4c31a,
        0x275e963a,
        0xab6bcb3b,
        0x9d45f11f,
        0xfa58abac,
        0xe303934b,
        0x30fa5520,
        0x766df6ad,
        0xcc769188,
        0x024c25f5,
        0xe5d7fc4f,
        0x2acbd7c5,
        0x35448026,
        0x62a38fb5,
        0xb15a49de,
        0xba1b6725,
        0xea0e9845,
        0xfec0e15d,
        0x2f7502c3,
        0x4cf01281,
        0x4697a38d,
        0xd3f9c66b,
        0x8f5fe703,
        0x929c9515,
        0x6d7aebbf,
        0x5259da95,
        0xbe832dd4,
        0x7421d358,
        0xe0692949,
        0xc9c8448e,
        0xc2896a75,
        0x8e7978f4,
        0x583e6b99,
        0xb971dd27,
        0xe14fb6be,
        0x88ad17f0,
        0x20ac66c9,
        0xce3ab47d,
        0xdf4a1863,
        0x1a3182e5,
        0x51336097,
        0x537f4562,
        0x6477e0b1,
        0x6bae84bb,
        0x81a01cfe,
        0x082b94f9,
        0x48685870,
        0x45fd198f,
        0xde6c8794,
        0x7bf8b752,
        0x73d323ab,
        0x4b02e272,
        0x1f8f57e3,
        0x55ab2a66,
        0xeb2807b2,
        0xb5c2032f,
        0xc57b9a86,
        0x3708a5d3,
        0x2887f230,
        0xbfa5b223,
        0x036aba02,
        0x16825ced,
        0xcf1c2b8a,
        0x79b492a7,
        0x07f2f0f3,
        0x69e2a14e,
        0xdaf4cd65,
        0x05bed506,
        0x34621fd1,
        0xa6fe8ac4,
        0x2e539d34,
        0xf355a0a2,
        0x8ae13205,
        0xf6eb75a4,
        0x83ec390b,
        0x60efaa40,
        0x719f065e,
        0x6e1051bd,
        0x218af93e,
        0xdd063d96,
        0x3e05aedd,
        0xe6bd464d,
        0x548db591,
        0xc45d0571,
        0x06d46f04,
        0x5015ff60,
        0x98fb2419,
        0xbde997d6,
        0x4043cc89,
        0xd99e7767,
        0xe842bdb0,
        0x898b8807,
        0x195b38e7,
        0xc8eedb79,
        0x7c0a47a1,
        0x420fe97c,
        0x841ec9f8,
        0x00000000,
        0x80868309,
        0x2bed4832,
        0x1170ac1e,
        0x5a724e6c,
        0x0efffbfd,
        0x8538560f,
        0xaed51e3d,
        0x2d392736,
        0x0fd9640a,
        0x5ca62168,
        0x5b54d19b,
        0x362e3a24,
        0x0a67b10c,
        0x57e70f93,
        0xee96d2b4,
        0x9b919e1b,
        0xc0c54f80,
        0xdc20a261,
        0x774b695a,
        0x121a161c,
        0x93ba0ae2,
        0xa02ae5c0,
        0x22e0433c,
        0x1b171d12,
        0x090d0b0e,
        0x8bc7adf2,
        0xb6a8b92d,
        0x1ea9c814,
        0xf1198557,
        0x75074caf,
        0x99ddbbee,
        0x7f60fda3,
        0x01269ff7,
        0x72f5bc5c,
        0x663bc544,
        0xfb7e345b,
        0x4329768b,
        0x23c6dccb,
        0xedfc68b6,
        0xe4f163b8,
        0x31dccad7,
        0x63851042,
        0x97224013,
        0xc6112084,
        0x4a247d85,
        0xbb3df8d2,
        0xf93211ae,
        0x29a16dc7,
        0x9e2f4b1d,
        0xb230f3dc,
        0x8652ec0d,
        0xc1e3d077,
        0xb3166c2b,
        0x70b999a9,
        0x9448fa11,
        0xe9642247,
        0xfc8cc4a8,
        0xf03f1aa0,
        0x7d2cd856,
        0x3390ef22,
        0x494ec787,
        0x38d1c1d9,
        0xcaa2fe8c,
        0xd40b3698,
        0xf581cfa6,
        0x7ade28a5,
        0xb78e26da,
        0xadbfa43f,
        0x3a9de42c,
        0x78920d50,
        0x5fcc9b6a,
        0x7e466254,
        0x8d13c2f6,
        0xd8b8e890,
        0x39f75e2e,
        0xc3aff582,
        0x5d80be9f,
        0xd0937c69,
        0xd52da96f,
        0x2512b3cf,
        0xac993bc8,
        0x187da710,
        0x9c636ee8,
        0x3bbb7bdb,
        0x267809cd,
        0x5918f46e,
        0x9ab701ec,
        0x4f9aa883,
        0x956e65e6,
        0xffe67eaa,
        0xbccf0821,
        0x15e8e6ef,
        0xe79bd9ba,
        0x6f36ce4a,
        0x9f09d4ea,
        0xb07cd629,
        0xa4b2af31,
        0x3f23312a,
        0xa59430c6,
        0xa266c035,
        0x4ebc3774,
        0x82caa6fc,
        0x90d0b0e0,
        0xa7d81533,
        0x04984af1,
        0xecdaf741,
        0xcd500e7f,
        0x91f62f17,
        0x4dd68d76,
        0xefb04d43,
        0xaa4d54cc,
        0x9604dfe4,
        0xd1b5e39e,
        0x6a881b4c,
        0x2c1fb8c1,
        0x65517f46,
        0x5eea049d,
        0x8c355d01,
        0x877473fa,
        0x0b412efb,
        0x671d5ab3,
        0xdbd25292,
        0x105633e9,
        0xd647136d,
        0xd7618c9a,
        0xa10c7a37,
        0xf8148e59,
        0x133c89eb,
        0xa927eece,
        0x61c935b7,
        0x1ce5ede1,
        0x47b13c7a,
        0xd2df599c,
        0xf2733f55,
        0x14ce7918,
        0xc737bf73,
        0xf7cdea53,
        0xfdaa5b5f,
        0x3d6f14df,
        0x44db8678,
        0xaff381ca,
        0x68c43eb9,
        0x24342c38,
        0xa3405fc2,
        0x1dc37216,
        0xe2250cbc,
        0x3c498b28,
        0x0d9541ff,
        0xa8017139,
        0x0cb3de08,
        0xb4e49cd8,
        0x56c19064,
        0xcb84617b,
        0x32b670d5,
        0x6c5c7448,
        0xb85742d0
    ];
    // Transformations for decryption key expansion
    var U1 = [
        0x00000000,
        0x0e090d0b,
        0x1c121a16,
        0x121b171d,
        0x3824342c,
        0x362d3927,
        0x24362e3a,
        0x2a3f2331,
        0x70486858,
        0x7e416553,
        0x6c5a724e,
        0x62537f45,
        0x486c5c74,
        0x4665517f,
        0x547e4662,
        0x5a774b69,
        0xe090d0b0,
        0xee99ddbb,
        0xfc82caa6,
        0xf28bc7ad,
        0xd8b4e49c,
        0xd6bde997,
        0xc4a6fe8a,
        0xcaaff381,
        0x90d8b8e8,
        0x9ed1b5e3,
        0x8ccaa2fe,
        0x82c3aff5,
        0xa8fc8cc4,
        0xa6f581cf,
        0xb4ee96d2,
        0xbae79bd9,
        0xdb3bbb7b,
        0xd532b670,
        0xc729a16d,
        0xc920ac66,
        0xe31f8f57,
        0xed16825c,
        0xff0d9541,
        0xf104984a,
        0xab73d323,
        0xa57ade28,
        0xb761c935,
        0xb968c43e,
        0x9357e70f,
        0x9d5eea04,
        0x8f45fd19,
        0x814cf012,
        0x3bab6bcb,
        0x35a266c0,
        0x27b971dd,
        0x29b07cd6,
        0x038f5fe7,
        0x0d8652ec,
        0x1f9d45f1,
        0x119448fa,
        0x4be30393,
        0x45ea0e98,
        0x57f11985,
        0x59f8148e,
        0x73c737bf,
        0x7dce3ab4,
        0x6fd52da9,
        0x61dc20a2,
        0xad766df6,
        0xa37f60fd,
        0xb16477e0,
        0xbf6d7aeb,
        0x955259da,
        0x9b5b54d1,
        0x894043cc,
        0x87494ec7,
        0xdd3e05ae,
        0xd33708a5,
        0xc12c1fb8,
        0xcf2512b3,
        0xe51a3182,
        0xeb133c89,
        0xf9082b94,
        0xf701269f,
        0x4de6bd46,
        0x43efb04d,
        0x51f4a750,
        0x5ffdaa5b,
        0x75c2896a,
        0x7bcb8461,
        0x69d0937c,
        0x67d99e77,
        0x3daed51e,
        0x33a7d815,
        0x21bccf08,
        0x2fb5c203,
        0x058ae132,
        0x0b83ec39,
        0x1998fb24,
        0x1791f62f,
        0x764dd68d,
        0x7844db86,
        0x6a5fcc9b,
        0x6456c190,
        0x4e69e2a1,
        0x4060efaa,
        0x527bf8b7,
        0x5c72f5bc,
        0x0605bed5,
        0x080cb3de,
        0x1a17a4c3,
        0x141ea9c8,
        0x3e218af9,
        0x302887f2,
        0x223390ef,
        0x2c3a9de4,
        0x96dd063d,
        0x98d40b36,
        0x8acf1c2b,
        0x84c61120,
        0xaef93211,
        0xa0f03f1a,
        0xb2eb2807,
        0xbce2250c,
        0xe6956e65,
        0xe89c636e,
        0xfa877473,
        0xf48e7978,
        0xdeb15a49,
        0xd0b85742,
        0xc2a3405f,
        0xccaa4d54,
        0x41ecdaf7,
        0x4fe5d7fc,
        0x5dfec0e1,
        0x53f7cdea,
        0x79c8eedb,
        0x77c1e3d0,
        0x65daf4cd,
        0x6bd3f9c6,
        0x31a4b2af,
        0x3fadbfa4,
        0x2db6a8b9,
        0x23bfa5b2,
        0x09808683,
        0x07898b88,
        0x15929c95,
        0x1b9b919e,
        0xa17c0a47,
        0xaf75074c,
        0xbd6e1051,
        0xb3671d5a,
        0x99583e6b,
        0x97513360,
        0x854a247d,
        0x8b432976,
        0xd134621f,
        0xdf3d6f14,
        0xcd267809,
        0xc32f7502,
        0xe9105633,
        0xe7195b38,
        0xf5024c25,
        0xfb0b412e,
        0x9ad7618c,
        0x94de6c87,
        0x86c57b9a,
        0x88cc7691,
        0xa2f355a0,
        0xacfa58ab,
        0xbee14fb6,
        0xb0e842bd,
        0xea9f09d4,
        0xe49604df,
        0xf68d13c2,
        0xf8841ec9,
        0xd2bb3df8,
        0xdcb230f3,
        0xcea927ee,
        0xc0a02ae5,
        0x7a47b13c,
        0x744ebc37,
        0x6655ab2a,
        0x685ca621,
        0x42638510,
        0x4c6a881b,
        0x5e719f06,
        0x5078920d,
        0x0a0fd964,
        0x0406d46f,
        0x161dc372,
        0x1814ce79,
        0x322bed48,
        0x3c22e043,
        0x2e39f75e,
        0x2030fa55,
        0xec9ab701,
        0xe293ba0a,
        0xf088ad17,
        0xfe81a01c,
        0xd4be832d,
        0xdab78e26,
        0xc8ac993b,
        0xc6a59430,
        0x9cd2df59,
        0x92dbd252,
        0x80c0c54f,
        0x8ec9c844,
        0xa4f6eb75,
        0xaaffe67e,
        0xb8e4f163,
        0xb6edfc68,
        0x0c0a67b1,
        0x02036aba,
        0x10187da7,
        0x1e1170ac,
        0x342e539d,
        0x3a275e96,
        0x283c498b,
        0x26354480,
        0x7c420fe9,
        0x724b02e2,
        0x605015ff,
        0x6e5918f4,
        0x44663bc5,
        0x4a6f36ce,
        0x587421d3,
        0x567d2cd8,
        0x37a10c7a,
        0x39a80171,
        0x2bb3166c,
        0x25ba1b67,
        0x0f853856,
        0x018c355d,
        0x13972240,
        0x1d9e2f4b,
        0x47e96422,
        0x49e06929,
        0x5bfb7e34,
        0x55f2733f,
        0x7fcd500e,
        0x71c45d05,
        0x63df4a18,
        0x6dd64713,
        0xd731dcca,
        0xd938d1c1,
        0xcb23c6dc,
        0xc52acbd7,
        0xef15e8e6,
        0xe11ce5ed,
        0xf307f2f0,
        0xfd0efffb,
        0xa779b492,
        0xa970b999,
        0xbb6bae84,
        0xb562a38f,
        0x9f5d80be,
        0x91548db5,
        0x834f9aa8,
        0x8d4697a3
    ];
    var U2 = [
        0x00000000,
        0x0b0e090d,
        0x161c121a,
        0x1d121b17,
        0x2c382434,
        0x27362d39,
        0x3a24362e,
        0x312a3f23,
        0x58704868,
        0x537e4165,
        0x4e6c5a72,
        0x4562537f,
        0x74486c5c,
        0x7f466551,
        0x62547e46,
        0x695a774b,
        0xb0e090d0,
        0xbbee99dd,
        0xa6fc82ca,
        0xadf28bc7,
        0x9cd8b4e4,
        0x97d6bde9,
        0x8ac4a6fe,
        0x81caaff3,
        0xe890d8b8,
        0xe39ed1b5,
        0xfe8ccaa2,
        0xf582c3af,
        0xc4a8fc8c,
        0xcfa6f581,
        0xd2b4ee96,
        0xd9bae79b,
        0x7bdb3bbb,
        0x70d532b6,
        0x6dc729a1,
        0x66c920ac,
        0x57e31f8f,
        0x5ced1682,
        0x41ff0d95,
        0x4af10498,
        0x23ab73d3,
        0x28a57ade,
        0x35b761c9,
        0x3eb968c4,
        0x0f9357e7,
        0x049d5eea,
        0x198f45fd,
        0x12814cf0,
        0xcb3bab6b,
        0xc035a266,
        0xdd27b971,
        0xd629b07c,
        0xe7038f5f,
        0xec0d8652,
        0xf11f9d45,
        0xfa119448,
        0x934be303,
        0x9845ea0e,
        0x8557f119,
        0x8e59f814,
        0xbf73c737,
        0xb47dce3a,
        0xa96fd52d,
        0xa261dc20,
        0xf6ad766d,
        0xfda37f60,
        0xe0b16477,
        0xebbf6d7a,
        0xda955259,
        0xd19b5b54,
        0xcc894043,
        0xc787494e,
        0xaedd3e05,
        0xa5d33708,
        0xb8c12c1f,
        0xb3cf2512,
        0x82e51a31,
        0x89eb133c,
        0x94f9082b,
        0x9ff70126,
        0x464de6bd,
        0x4d43efb0,
        0x5051f4a7,
        0x5b5ffdaa,
        0x6a75c289,
        0x617bcb84,
        0x7c69d093,
        0x7767d99e,
        0x1e3daed5,
        0x1533a7d8,
        0x0821bccf,
        0x032fb5c2,
        0x32058ae1,
        0x390b83ec,
        0x241998fb,
        0x2f1791f6,
        0x8d764dd6,
        0x867844db,
        0x9b6a5fcc,
        0x906456c1,
        0xa14e69e2,
        0xaa4060ef,
        0xb7527bf8,
        0xbc5c72f5,
        0xd50605be,
        0xde080cb3,
        0xc31a17a4,
        0xc8141ea9,
        0xf93e218a,
        0xf2302887,
        0xef223390,
        0xe42c3a9d,
        0x3d96dd06,
        0x3698d40b,
        0x2b8acf1c,
        0x2084c611,
        0x11aef932,
        0x1aa0f03f,
        0x07b2eb28,
        0x0cbce225,
        0x65e6956e,
        0x6ee89c63,
        0x73fa8774,
        0x78f48e79,
        0x49deb15a,
        0x42d0b857,
        0x5fc2a340,
        0x54ccaa4d,
        0xf741ecda,
        0xfc4fe5d7,
        0xe15dfec0,
        0xea53f7cd,
        0xdb79c8ee,
        0xd077c1e3,
        0xcd65daf4,
        0xc66bd3f9,
        0xaf31a4b2,
        0xa43fadbf,
        0xb92db6a8,
        0xb223bfa5,
        0x83098086,
        0x8807898b,
        0x9515929c,
        0x9e1b9b91,
        0x47a17c0a,
        0x4caf7507,
        0x51bd6e10,
        0x5ab3671d,
        0x6b99583e,
        0x60975133,
        0x7d854a24,
        0x768b4329,
        0x1fd13462,
        0x14df3d6f,
        0x09cd2678,
        0x02c32f75,
        0x33e91056,
        0x38e7195b,
        0x25f5024c,
        0x2efb0b41,
        0x8c9ad761,
        0x8794de6c,
        0x9a86c57b,
        0x9188cc76,
        0xa0a2f355,
        0xabacfa58,
        0xb6bee14f,
        0xbdb0e842,
        0xd4ea9f09,
        0xdfe49604,
        0xc2f68d13,
        0xc9f8841e,
        0xf8d2bb3d,
        0xf3dcb230,
        0xeecea927,
        0xe5c0a02a,
        0x3c7a47b1,
        0x37744ebc,
        0x2a6655ab,
        0x21685ca6,
        0x10426385,
        0x1b4c6a88,
        0x065e719f,
        0x0d507892,
        0x640a0fd9,
        0x6f0406d4,
        0x72161dc3,
        0x791814ce,
        0x48322bed,
        0x433c22e0,
        0x5e2e39f7,
        0x552030fa,
        0x01ec9ab7,
        0x0ae293ba,
        0x17f088ad,
        0x1cfe81a0,
        0x2dd4be83,
        0x26dab78e,
        0x3bc8ac99,
        0x30c6a594,
        0x599cd2df,
        0x5292dbd2,
        0x4f80c0c5,
        0x448ec9c8,
        0x75a4f6eb,
        0x7eaaffe6,
        0x63b8e4f1,
        0x68b6edfc,
        0xb10c0a67,
        0xba02036a,
        0xa710187d,
        0xac1e1170,
        0x9d342e53,
        0x963a275e,
        0x8b283c49,
        0x80263544,
        0xe97c420f,
        0xe2724b02,
        0xff605015,
        0xf46e5918,
        0xc544663b,
        0xce4a6f36,
        0xd3587421,
        0xd8567d2c,
        0x7a37a10c,
        0x7139a801,
        0x6c2bb316,
        0x6725ba1b,
        0x560f8538,
        0x5d018c35,
        0x40139722,
        0x4b1d9e2f,
        0x2247e964,
        0x2949e069,
        0x345bfb7e,
        0x3f55f273,
        0x0e7fcd50,
        0x0571c45d,
        0x1863df4a,
        0x136dd647,
        0xcad731dc,
        0xc1d938d1,
        0xdccb23c6,
        0xd7c52acb,
        0xe6ef15e8,
        0xede11ce5,
        0xf0f307f2,
        0xfbfd0eff,
        0x92a779b4,
        0x99a970b9,
        0x84bb6bae,
        0x8fb562a3,
        0xbe9f5d80,
        0xb591548d,
        0xa8834f9a,
        0xa38d4697
    ];
    var U3 = [
        0x00000000,
        0x0d0b0e09,
        0x1a161c12,
        0x171d121b,
        0x342c3824,
        0x3927362d,
        0x2e3a2436,
        0x23312a3f,
        0x68587048,
        0x65537e41,
        0x724e6c5a,
        0x7f456253,
        0x5c74486c,
        0x517f4665,
        0x4662547e,
        0x4b695a77,
        0xd0b0e090,
        0xddbbee99,
        0xcaa6fc82,
        0xc7adf28b,
        0xe49cd8b4,
        0xe997d6bd,
        0xfe8ac4a6,
        0xf381caaf,
        0xb8e890d8,
        0xb5e39ed1,
        0xa2fe8cca,
        0xaff582c3,
        0x8cc4a8fc,
        0x81cfa6f5,
        0x96d2b4ee,
        0x9bd9bae7,
        0xbb7bdb3b,
        0xb670d532,
        0xa16dc729,
        0xac66c920,
        0x8f57e31f,
        0x825ced16,
        0x9541ff0d,
        0x984af104,
        0xd323ab73,
        0xde28a57a,
        0xc935b761,
        0xc43eb968,
        0xe70f9357,
        0xea049d5e,
        0xfd198f45,
        0xf012814c,
        0x6bcb3bab,
        0x66c035a2,
        0x71dd27b9,
        0x7cd629b0,
        0x5fe7038f,
        0x52ec0d86,
        0x45f11f9d,
        0x48fa1194,
        0x03934be3,
        0x0e9845ea,
        0x198557f1,
        0x148e59f8,
        0x37bf73c7,
        0x3ab47dce,
        0x2da96fd5,
        0x20a261dc,
        0x6df6ad76,
        0x60fda37f,
        0x77e0b164,
        0x7aebbf6d,
        0x59da9552,
        0x54d19b5b,
        0x43cc8940,
        0x4ec78749,
        0x05aedd3e,
        0x08a5d337,
        0x1fb8c12c,
        0x12b3cf25,
        0x3182e51a,
        0x3c89eb13,
        0x2b94f908,
        0x269ff701,
        0xbd464de6,
        0xb04d43ef,
        0xa75051f4,
        0xaa5b5ffd,
        0x896a75c2,
        0x84617bcb,
        0x937c69d0,
        0x9e7767d9,
        0xd51e3dae,
        0xd81533a7,
        0xcf0821bc,
        0xc2032fb5,
        0xe132058a,
        0xec390b83,
        0xfb241998,
        0xf62f1791,
        0xd68d764d,
        0xdb867844,
        0xcc9b6a5f,
        0xc1906456,
        0xe2a14e69,
        0xefaa4060,
        0xf8b7527b,
        0xf5bc5c72,
        0xbed50605,
        0xb3de080c,
        0xa4c31a17,
        0xa9c8141e,
        0x8af93e21,
        0x87f23028,
        0x90ef2233,
        0x9de42c3a,
        0x063d96dd,
        0x0b3698d4,
        0x1c2b8acf,
        0x112084c6,
        0x3211aef9,
        0x3f1aa0f0,
        0x2807b2eb,
        0x250cbce2,
        0x6e65e695,
        0x636ee89c,
        0x7473fa87,
        0x7978f48e,
        0x5a49deb1,
        0x5742d0b8,
        0x405fc2a3,
        0x4d54ccaa,
        0xdaf741ec,
        0xd7fc4fe5,
        0xc0e15dfe,
        0xcdea53f7,
        0xeedb79c8,
        0xe3d077c1,
        0xf4cd65da,
        0xf9c66bd3,
        0xb2af31a4,
        0xbfa43fad,
        0xa8b92db6,
        0xa5b223bf,
        0x86830980,
        0x8b880789,
        0x9c951592,
        0x919e1b9b,
        0x0a47a17c,
        0x074caf75,
        0x1051bd6e,
        0x1d5ab367,
        0x3e6b9958,
        0x33609751,
        0x247d854a,
        0x29768b43,
        0x621fd134,
        0x6f14df3d,
        0x7809cd26,
        0x7502c32f,
        0x5633e910,
        0x5b38e719,
        0x4c25f502,
        0x412efb0b,
        0x618c9ad7,
        0x6c8794de,
        0x7b9a86c5,
        0x769188cc,
        0x55a0a2f3,
        0x58abacfa,
        0x4fb6bee1,
        0x42bdb0e8,
        0x09d4ea9f,
        0x04dfe496,
        0x13c2f68d,
        0x1ec9f884,
        0x3df8d2bb,
        0x30f3dcb2,
        0x27eecea9,
        0x2ae5c0a0,
        0xb13c7a47,
        0xbc37744e,
        0xab2a6655,
        0xa621685c,
        0x85104263,
        0x881b4c6a,
        0x9f065e71,
        0x920d5078,
        0xd9640a0f,
        0xd46f0406,
        0xc372161d,
        0xce791814,
        0xed48322b,
        0xe0433c22,
        0xf75e2e39,
        0xfa552030,
        0xb701ec9a,
        0xba0ae293,
        0xad17f088,
        0xa01cfe81,
        0x832dd4be,
        0x8e26dab7,
        0x993bc8ac,
        0x9430c6a5,
        0xdf599cd2,
        0xd25292db,
        0xc54f80c0,
        0xc8448ec9,
        0xeb75a4f6,
        0xe67eaaff,
        0xf163b8e4,
        0xfc68b6ed,
        0x67b10c0a,
        0x6aba0203,
        0x7da71018,
        0x70ac1e11,
        0x539d342e,
        0x5e963a27,
        0x498b283c,
        0x44802635,
        0x0fe97c42,
        0x02e2724b,
        0x15ff6050,
        0x18f46e59,
        0x3bc54466,
        0x36ce4a6f,
        0x21d35874,
        0x2cd8567d,
        0x0c7a37a1,
        0x017139a8,
        0x166c2bb3,
        0x1b6725ba,
        0x38560f85,
        0x355d018c,
        0x22401397,
        0x2f4b1d9e,
        0x642247e9,
        0x692949e0,
        0x7e345bfb,
        0x733f55f2,
        0x500e7fcd,
        0x5d0571c4,
        0x4a1863df,
        0x47136dd6,
        0xdccad731,
        0xd1c1d938,
        0xc6dccb23,
        0xcbd7c52a,
        0xe8e6ef15,
        0xe5ede11c,
        0xf2f0f307,
        0xfffbfd0e,
        0xb492a779,
        0xb999a970,
        0xae84bb6b,
        0xa38fb562,
        0x80be9f5d,
        0x8db59154,
        0x9aa8834f,
        0x97a38d46
    ];
    var U4 = [
        0x00000000,
        0x090d0b0e,
        0x121a161c,
        0x1b171d12,
        0x24342c38,
        0x2d392736,
        0x362e3a24,
        0x3f23312a,
        0x48685870,
        0x4165537e,
        0x5a724e6c,
        0x537f4562,
        0x6c5c7448,
        0x65517f46,
        0x7e466254,
        0x774b695a,
        0x90d0b0e0,
        0x99ddbbee,
        0x82caa6fc,
        0x8bc7adf2,
        0xb4e49cd8,
        0xbde997d6,
        0xa6fe8ac4,
        0xaff381ca,
        0xd8b8e890,
        0xd1b5e39e,
        0xcaa2fe8c,
        0xc3aff582,
        0xfc8cc4a8,
        0xf581cfa6,
        0xee96d2b4,
        0xe79bd9ba,
        0x3bbb7bdb,
        0x32b670d5,
        0x29a16dc7,
        0x20ac66c9,
        0x1f8f57e3,
        0x16825ced,
        0x0d9541ff,
        0x04984af1,
        0x73d323ab,
        0x7ade28a5,
        0x61c935b7,
        0x68c43eb9,
        0x57e70f93,
        0x5eea049d,
        0x45fd198f,
        0x4cf01281,
        0xab6bcb3b,
        0xa266c035,
        0xb971dd27,
        0xb07cd629,
        0x8f5fe703,
        0x8652ec0d,
        0x9d45f11f,
        0x9448fa11,
        0xe303934b,
        0xea0e9845,
        0xf1198557,
        0xf8148e59,
        0xc737bf73,
        0xce3ab47d,
        0xd52da96f,
        0xdc20a261,
        0x766df6ad,
        0x7f60fda3,
        0x6477e0b1,
        0x6d7aebbf,
        0x5259da95,
        0x5b54d19b,
        0x4043cc89,
        0x494ec787,
        0x3e05aedd,
        0x3708a5d3,
        0x2c1fb8c1,
        0x2512b3cf,
        0x1a3182e5,
        0x133c89eb,
        0x082b94f9,
        0x01269ff7,
        0xe6bd464d,
        0xefb04d43,
        0xf4a75051,
        0xfdaa5b5f,
        0xc2896a75,
        0xcb84617b,
        0xd0937c69,
        0xd99e7767,
        0xaed51e3d,
        0xa7d81533,
        0xbccf0821,
        0xb5c2032f,
        0x8ae13205,
        0x83ec390b,
        0x98fb2419,
        0x91f62f17,
        0x4dd68d76,
        0x44db8678,
        0x5fcc9b6a,
        0x56c19064,
        0x69e2a14e,
        0x60efaa40,
        0x7bf8b752,
        0x72f5bc5c,
        0x05bed506,
        0x0cb3de08,
        0x17a4c31a,
        0x1ea9c814,
        0x218af93e,
        0x2887f230,
        0x3390ef22,
        0x3a9de42c,
        0xdd063d96,
        0xd40b3698,
        0xcf1c2b8a,
        0xc6112084,
        0xf93211ae,
        0xf03f1aa0,
        0xeb2807b2,
        0xe2250cbc,
        0x956e65e6,
        0x9c636ee8,
        0x877473fa,
        0x8e7978f4,
        0xb15a49de,
        0xb85742d0,
        0xa3405fc2,
        0xaa4d54cc,
        0xecdaf741,
        0xe5d7fc4f,
        0xfec0e15d,
        0xf7cdea53,
        0xc8eedb79,
        0xc1e3d077,
        0xdaf4cd65,
        0xd3f9c66b,
        0xa4b2af31,
        0xadbfa43f,
        0xb6a8b92d,
        0xbfa5b223,
        0x80868309,
        0x898b8807,
        0x929c9515,
        0x9b919e1b,
        0x7c0a47a1,
        0x75074caf,
        0x6e1051bd,
        0x671d5ab3,
        0x583e6b99,
        0x51336097,
        0x4a247d85,
        0x4329768b,
        0x34621fd1,
        0x3d6f14df,
        0x267809cd,
        0x2f7502c3,
        0x105633e9,
        0x195b38e7,
        0x024c25f5,
        0x0b412efb,
        0xd7618c9a,
        0xde6c8794,
        0xc57b9a86,
        0xcc769188,
        0xf355a0a2,
        0xfa58abac,
        0xe14fb6be,
        0xe842bdb0,
        0x9f09d4ea,
        0x9604dfe4,
        0x8d13c2f6,
        0x841ec9f8,
        0xbb3df8d2,
        0xb230f3dc,
        0xa927eece,
        0xa02ae5c0,
        0x47b13c7a,
        0x4ebc3774,
        0x55ab2a66,
        0x5ca62168,
        0x63851042,
        0x6a881b4c,
        0x719f065e,
        0x78920d50,
        0x0fd9640a,
        0x06d46f04,
        0x1dc37216,
        0x14ce7918,
        0x2bed4832,
        0x22e0433c,
        0x39f75e2e,
        0x30fa5520,
        0x9ab701ec,
        0x93ba0ae2,
        0x88ad17f0,
        0x81a01cfe,
        0xbe832dd4,
        0xb78e26da,
        0xac993bc8,
        0xa59430c6,
        0xd2df599c,
        0xdbd25292,
        0xc0c54f80,
        0xc9c8448e,
        0xf6eb75a4,
        0xffe67eaa,
        0xe4f163b8,
        0xedfc68b6,
        0x0a67b10c,
        0x036aba02,
        0x187da710,
        0x1170ac1e,
        0x2e539d34,
        0x275e963a,
        0x3c498b28,
        0x35448026,
        0x420fe97c,
        0x4b02e272,
        0x5015ff60,
        0x5918f46e,
        0x663bc544,
        0x6f36ce4a,
        0x7421d358,
        0x7d2cd856,
        0xa10c7a37,
        0xa8017139,
        0xb3166c2b,
        0xba1b6725,
        0x8538560f,
        0x8c355d01,
        0x97224013,
        0x9e2f4b1d,
        0xe9642247,
        0xe0692949,
        0xfb7e345b,
        0xf2733f55,
        0xcd500e7f,
        0xc45d0571,
        0xdf4a1863,
        0xd647136d,
        0x31dccad7,
        0x38d1c1d9,
        0x23c6dccb,
        0x2acbd7c5,
        0x15e8e6ef,
        0x1ce5ede1,
        0x07f2f0f3,
        0x0efffbfd,
        0x79b492a7,
        0x70b999a9,
        0x6bae84bb,
        0x62a38fb5,
        0x5d80be9f,
        0x548db591,
        0x4f9aa883,
        0x4697a38d
    ];
    function convertToInt32(bytes) {
        var result = [];
        for(var i = 0; i < bytes.length; i += 4)result.push(bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]);
        return result;
    }
    var AES = function(key) {
        if (!(this instanceof AES)) throw Error("AES must be instanitated with `new`");
        Object.defineProperty(this, "key", {
            value: coerceArray(key, true)
        });
        this._prepare();
    };
    AES.prototype._prepare = function() {
        var rounds = numberOfRounds[this.key.length];
        if (rounds == null) throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
        // encryption round keys
        this._Ke = [];
        // decryption round keys
        this._Kd = [];
        for(var i = 0; i <= rounds; i++){
            this._Ke.push([
                0,
                0,
                0,
                0
            ]);
            this._Kd.push([
                0,
                0,
                0,
                0
            ]);
        }
        var roundKeyCount = (rounds + 1) * 4;
        var KC = this.key.length / 4;
        // convert the key into ints
        var tk = convertToInt32(this.key);
        // copy values into round key arrays
        var index;
        for(var i = 0; i < KC; i++){
            index = i >> 2;
            this._Ke[index][i % 4] = tk[i];
            this._Kd[rounds - index][i % 4] = tk[i];
        }
        // key expansion (fips-197 section 5.2)
        var rconpointer = 0;
        var t = KC, tt;
        while(t < roundKeyCount){
            tt = tk[KC - 1];
            tk[0] ^= S[tt >> 16 & 0xFF] << 24 ^ S[tt >> 8 & 0xFF] << 16 ^ S[tt & 0xFF] << 8 ^ S[tt >> 24 & 0xFF] ^ rcon[rconpointer] << 24;
            rconpointer += 1;
            // key expansion (for non-256 bit)
            if (KC != 8) for(var i = 1; i < KC; i++)tk[i] ^= tk[i - 1];
            else {
                for(var i = 1; i < KC / 2; i++)tk[i] ^= tk[i - 1];
                tt = tk[KC / 2 - 1];
                tk[KC / 2] ^= S[tt & 0xFF] ^ S[tt >> 8 & 0xFF] << 8 ^ S[tt >> 16 & 0xFF] << 16 ^ S[tt >> 24 & 0xFF] << 24;
                for(var i = KC / 2 + 1; i < KC; i++)tk[i] ^= tk[i - 1];
            }
            // copy values into round key arrays
            var i = 0, r, c;
            while(i < KC && t < roundKeyCount){
                r = t >> 2;
                c = t % 4;
                this._Ke[r][c] = tk[i];
                this._Kd[rounds - r][c] = tk[i++];
                t++;
            }
        }
        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for(var r = 1; r < rounds; r++)for(var c = 0; c < 4; c++){
            tt = this._Kd[r][c];
            this._Kd[r][c] = U1[tt >> 24 & 0xFF] ^ U2[tt >> 16 & 0xFF] ^ U3[tt >> 8 & 0xFF] ^ U4[tt & 0xFF];
        }
    };
    AES.prototype.encrypt = function(plaintext) {
        if (plaintext.length != 16) throw new Error("invalid plaintext size (must be 16 bytes)");
        var rounds = this._Ke.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(plaintext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Ke[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T1[t[i] >> 24 & 0xff] ^ T2[t[(i + 1) % 4] >> 16 & 0xff] ^ T3[t[(i + 2) % 4] >> 8 & 0xff] ^ T4[t[(i + 3) % 4] & 0xff] ^ this._Ke[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Ke[rounds][i];
            result[4 * i] = (S[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (S[t[(i + 1) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (S[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (S[t[(i + 3) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    AES.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length != 16) throw new Error("invalid ciphertext size (must be 16 bytes)");
        var rounds = this._Kd.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(ciphertext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Kd[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T5[t[i] >> 24 & 0xff] ^ T6[t[(i + 3) % 4] >> 16 & 0xff] ^ T7[t[(i + 2) % 4] >> 8 & 0xff] ^ T8[t[(i + 1) % 4] & 0xff] ^ this._Kd[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Kd[rounds][i];
            result[4 * i] = (Si[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (Si[t[(i + 3) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (Si[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (Si[t[(i + 1) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    /**
     *  Mode Of Operation - Electonic Codebook (ECB)
     */ var ModeOfOperationECB = function(key) {
        if (!(this instanceof ModeOfOperationECB)) throw Error("AES must be instanitated with `new`");
        this.description = "Electronic Code Block";
        this.name = "ecb";
        this._aes = new AES(key);
    };
    ModeOfOperationECB.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            block = this._aes.encrypt(block);
            copyArray(block, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationECB.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            copyArray(block, plaintext, i);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Block Chaining (CBC)
     */ var ModeOfOperationCBC = function(key, iv) {
        if (!(this instanceof ModeOfOperationCBC)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Block Chaining";
        this.name = "cbc";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastCipherblock = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCBC.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            for(var j = 0; j < 16; j++)block[j] ^= this._lastCipherblock[j];
            this._lastCipherblock = this._aes.encrypt(block);
            copyArray(this._lastCipherblock, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationCBC.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            for(var j = 0; j < 16; j++)plaintext[i + j] = block[j] ^ this._lastCipherblock[j];
            copyArray(ciphertext, this._lastCipherblock, 0, i, i + 16);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Feedback (CFB)
     */ var ModeOfOperationCFB = function(key, iv, segmentSize) {
        if (!(this instanceof ModeOfOperationCFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Feedback";
        this.name = "cfb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 size)");
        if (!segmentSize) segmentSize = 1;
        this.segmentSize = segmentSize;
        this._shiftRegister = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCFB.prototype.encrypt = function(plaintext) {
        if (plaintext.length % this.segmentSize != 0) throw new Error("invalid plaintext size (must be segmentSize bytes)");
        var encrypted = coerceArray(plaintext, true);
        var xorSegment;
        for(var i = 0; i < encrypted.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)encrypted[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(encrypted, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return encrypted;
    };
    ModeOfOperationCFB.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length % this.segmentSize != 0) throw new Error("invalid ciphertext size (must be segmentSize bytes)");
        var plaintext = coerceArray(ciphertext, true);
        var xorSegment;
        for(var i = 0; i < plaintext.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)plaintext[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(ciphertext, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Output Feedback (OFB)
     */ var ModeOfOperationOFB = function(key, iv) {
        if (!(this instanceof ModeOfOperationOFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Output Feedback";
        this.name = "ofb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastPrecipher = coerceArray(iv, true);
        this._lastPrecipherIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationOFB.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._lastPrecipherIndex === 16) {
                this._lastPrecipher = this._aes.encrypt(this._lastPrecipher);
                this._lastPrecipherIndex = 0;
            }
            encrypted[i] ^= this._lastPrecipher[this._lastPrecipherIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationOFB.prototype.decrypt = ModeOfOperationOFB.prototype.encrypt;
    /**
     *  Counter object for CTR common mode of operation
     */ var Counter = function(initialValue) {
        if (!(this instanceof Counter)) throw Error("Counter must be instanitated with `new`");
        // We allow 0, but anything false-ish uses the default 1
        if (initialValue !== 0 && !initialValue) initialValue = 1;
        if (typeof initialValue === "number") {
            this._counter = createArray(16);
            this.setValue(initialValue);
        } else this.setBytes(initialValue);
    };
    Counter.prototype.setValue = function(value) {
        if (typeof value !== "number" || parseInt(value) != value) throw new Error("invalid counter value (must be an integer)");
        for(var index = 15; index >= 0; --index){
            this._counter[index] = value % 256;
            value = value >> 8;
        }
    };
    Counter.prototype.setBytes = function(bytes) {
        bytes = coerceArray(bytes, true);
        if (bytes.length != 16) throw new Error("invalid counter bytes size (must be 16 bytes)");
        this._counter = bytes;
    };
    Counter.prototype.increment = function() {
        for(var i = 15; i >= 0; i--)if (this._counter[i] === 255) this._counter[i] = 0;
        else {
            this._counter[i]++;
            break;
        }
    };
    /**
     *  Mode Of Operation - Counter (CTR)
     */ var ModeOfOperationCTR = function(key, counter) {
        if (!(this instanceof ModeOfOperationCTR)) throw Error("AES must be instanitated with `new`");
        this.description = "Counter";
        this.name = "ctr";
        if (!(counter instanceof Counter)) counter = new Counter(counter);
        this._counter = counter;
        this._remainingCounter = null;
        this._remainingCounterIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationCTR.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._remainingCounterIndex === 16) {
                this._remainingCounter = this._aes.encrypt(this._counter._counter);
                this._remainingCounterIndex = 0;
                this._counter.increment();
            }
            encrypted[i] ^= this._remainingCounter[this._remainingCounterIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationCTR.prototype.decrypt = ModeOfOperationCTR.prototype.encrypt;
    ///////////////////////
    // Padding
    // See:https://tools.ietf.org/html/rfc2315
    function pkcs7pad(data) {
        data = coerceArray(data, true);
        var padder = 16 - data.length % 16;
        var result = createArray(data.length + padder);
        copyArray(data, result);
        for(var i = data.length; i < result.length; i++)result[i] = padder;
        return result;
    }
    function pkcs7strip(data) {
        data = coerceArray(data, true);
        if (data.length < 16) throw new Error("PKCS#7 invalid length");
        var padder = data[data.length - 1];
        if (padder > 16) throw new Error("PKCS#7 padding byte out of range");
        var length = data.length - padder;
        for(var i = 0; i < padder; i++){
            if (data[length + i] !== padder) throw new Error("PKCS#7 invalid padding byte");
        }
        var result = createArray(length);
        copyArray(data, result, 0, 0, length);
        return result;
    }
    ///////////////////////
    // Exporting
    // The block cipher
    var aesjs = {
        AES: AES,
        Counter: Counter,
        ModeOfOperation: {
            ecb: ModeOfOperationECB,
            cbc: ModeOfOperationCBC,
            cfb: ModeOfOperationCFB,
            ofb: ModeOfOperationOFB,
            ctr: ModeOfOperationCTR
        },
        utils: {
            hex: convertHex,
            utf8: convertUtf8
        },
        padding: {
            pkcs7: {
                pad: pkcs7pad,
                strip: pkcs7strip
            }
        },
        _arrayTest: {
            coerceArray: coerceArray,
            createArray: createArray,
            copyArray: copyArray
        }
    };
    module.exports = aesjs;
})(module.exports);

});

parcelRegister("dZMS9", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $a306e1ec98c44913$export$83d89fbfd8236492; });
const $a306e1ec98c44913$export$83d89fbfd8236492 = "json-wallets/5.7.0";

});

parcelRegister("8kBCw", function(module, exports) {

$parcel$export(module.exports, "looseArrayify", function () { return $610d5f94549c6929$export$2cde08bde0cfd932; });
$parcel$export(module.exports, "zpad", function () { return $610d5f94549c6929$export$67752b99d3bc61c6; });
$parcel$export(module.exports, "getPassword", function () { return $610d5f94549c6929$export$350bd33120f7413e; });
$parcel$export(module.exports, "searchPath", function () { return $610d5f94549c6929$export$5a5c1dbd910e2c32; });
$parcel$export(module.exports, "uuidV4", function () { return $610d5f94549c6929$export$ec7b18ebad55a3a9; });

var $eBLyT = parcelRequire("eBLyT");

var $5kral = parcelRequire("5kral");
"use strict";
function $610d5f94549c6929$export$2cde08bde0cfd932(hexString) {
    if (typeof hexString === "string" && hexString.substring(0, 2) !== "0x") hexString = "0x" + hexString;
    return (0, $eBLyT.arrayify)(hexString);
}
function $610d5f94549c6929$export$67752b99d3bc61c6(value, length) {
    value = String(value);
    while(value.length < length)value = "0" + value;
    return value;
}
function $610d5f94549c6929$export$350bd33120f7413e(password) {
    if (typeof password === "string") return (0, $5kral.toUtf8Bytes)(password, (0, $5kral.UnicodeNormalizationForm).NFKC);
    return (0, $eBLyT.arrayify)(password);
}
function $610d5f94549c6929$export$5a5c1dbd910e2c32(object, path) {
    let currentChild = object;
    const comps = path.toLowerCase().split("/");
    for(let i = 0; i < comps.length; i++){
        // Search for a child object with a case-insensitive matching key
        let matchingChild = null;
        for(const key in currentChild)if (key.toLowerCase() === comps[i]) {
            matchingChild = currentChild[key];
            break;
        }
        // Didn't find one. :'(
        if (matchingChild === null) return null;
        // Now check this child...
        currentChild = matchingChild;
    }
    return currentChild;
}
function $610d5f94549c6929$export$ec7b18ebad55a3a9(randomBytes) {
    const bytes = (0, $eBLyT.arrayify)(randomBytes);
    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = bytes[6] & 0x0f | 0x40;
    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = bytes[8] & 0x3f | 0x80;
    const value = (0, $eBLyT.hexlify)(bytes);
    return [
        value.substring(2, 10),
        value.substring(10, 14),
        value.substring(14, 18),
        value.substring(18, 22),
        value.substring(22, 34)
    ].join("-");
}

});


parcelRegister("aPFrR", function(module, exports) {

$parcel$export(module.exports, "isCrowdsaleWallet", function () { return $7e2ed19a35e74cd9$export$724d6cf6b9fd8578; });
$parcel$export(module.exports, "isKeystoreWallet", function () { return $7e2ed19a35e74cd9$export$67dc926b8e68b2d8; });
$parcel$export(module.exports, "getJsonWalletAddress", function () { return $7e2ed19a35e74cd9$export$9a68ee9f8f3afd38; });

var $ak7re = parcelRequire("ak7re");
"use strict";
function $7e2ed19a35e74cd9$export$724d6cf6b9fd8578(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    return data.encseed && data.ethaddr;
}
function $7e2ed19a35e74cd9$export$67dc926b8e68b2d8(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    if (!data.version || parseInt(data.version) !== data.version || parseInt(data.version) !== 3) return false;
    // @TODO: Put more checks to make sure it has kdf, iv and all that good stuff
    return true;
}
function $7e2ed19a35e74cd9$export$9a68ee9f8f3afd38(json) {
    if ($7e2ed19a35e74cd9$export$724d6cf6b9fd8578(json)) try {
        return (0, $ak7re.getAddress)(JSON.parse(json).ethaddr);
    } catch (error) {
        return null;
    }
    if ($7e2ed19a35e74cd9$export$67dc926b8e68b2d8(json)) try {
        return (0, $ak7re.getAddress)(JSON.parse(json).address);
    } catch (error) {
        return null;
    }
    return null;
}

});

parcelRegister("LwPxX", function(module, exports) {

$parcel$export(module.exports, "decryptSync", function () { return $08eddb559844203e$export$9bd2c37889ee5e36; });
$parcel$export(module.exports, "decrypt", function () { return $08eddb559844203e$export$e85a0c9a1067c5d3; });
$parcel$export(module.exports, "encrypt", function () { return $08eddb559844203e$export$5b0f6292f11d1d18; });

var $7gxQg = parcelRequire("7gxQg");

var $10Zug = parcelRequire("10Zug");

var $ak7re = parcelRequire("ak7re");

var $eBLyT = parcelRequire("eBLyT");

var $1ISM5 = parcelRequire("1ISM5");

var $bnbYM = parcelRequire("bnbYM");

var $bj8Mn = parcelRequire("bj8Mn");

var $8hiLm = parcelRequire("8hiLm");

var $j0dXC = parcelRequire("j0dXC");

var $ABz8M = parcelRequire("ABz8M");

var $8kBCw = parcelRequire("8kBCw");

var $4NCF1 = parcelRequire("4NCF1");

var $dZMS9 = parcelRequire("dZMS9");
"use strict";
var $08eddb559844203e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $08eddb559844203e$var$logger = new (0, $4NCF1.Logger)((0, $dZMS9.version));
// Exported Types
function $08eddb559844203e$var$hasMnemonic(value) {
    return value != null && value.mnemonic && value.mnemonic.phrase;
}
class $08eddb559844203e$export$cf9dc4fd6dde0315 extends (0, $j0dXC.Description) {
    isKeystoreAccount(value) {
        return !!(value && value._isKeystoreAccount);
    }
}
function $08eddb559844203e$var$_decrypt(data, key, ciphertext) {
    const cipher = (0, $8kBCw.searchPath)(data, "crypto/cipher");
    if (cipher === "aes-128-ctr") {
        const iv = (0, $8kBCw.looseArrayify)((0, $8kBCw.searchPath)(data, "crypto/cipherparams/iv"));
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($7gxQg))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($7gxQg))).ModeOfOperation.ctr(key, counter);
        return (0, $eBLyT.arrayify)(aesCtr.decrypt(ciphertext));
    }
    return null;
}
function $08eddb559844203e$var$_getAccount(data, key) {
    const ciphertext = (0, $8kBCw.looseArrayify)((0, $8kBCw.searchPath)(data, "crypto/ciphertext"));
    const computedMAC = (0, $eBLyT.hexlify)((0, $bnbYM.keccak256)((0, $eBLyT.concat)([
        key.slice(16, 32),
        ciphertext
    ]))).substring(2);
    if (computedMAC !== (0, $8kBCw.searchPath)(data, "crypto/mac").toLowerCase()) throw new Error("invalid password");
    const privateKey = $08eddb559844203e$var$_decrypt(data, key.slice(0, 16), ciphertext);
    if (!privateKey) $08eddb559844203e$var$logger.throwError("unsupported cipher", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "decrypt"
    });
    const mnemonicKey = key.slice(32, 64);
    const address = (0, $ABz8M.computeAddress)(privateKey);
    if (data.address) {
        let check = data.address.toLowerCase();
        if (check.substring(0, 2) !== "0x") check = "0x" + check;
        if ((0, $ak7re.getAddress)(check) !== address) throw new Error("address mismatch");
    }
    const account = {
        _isKeystoreAccount: true,
        address: address,
        privateKey: (0, $eBLyT.hexlify)(privateKey)
    };
    // Version 0.1 x-ethers metadata must contain an encrypted mnemonic phrase
    if ((0, $8kBCw.searchPath)(data, "x-ethers/version") === "0.1") {
        const mnemonicCiphertext = (0, $8kBCw.looseArrayify)((0, $8kBCw.searchPath)(data, "x-ethers/mnemonicCiphertext"));
        const mnemonicIv = (0, $8kBCw.looseArrayify)((0, $8kBCw.searchPath)(data, "x-ethers/mnemonicCounter"));
        const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($7gxQg))).Counter(mnemonicIv);
        const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($7gxQg))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
        const path = (0, $8kBCw.searchPath)(data, "x-ethers/path") || (0, $1ISM5.defaultPath);
        const locale = (0, $8kBCw.searchPath)(data, "x-ethers/locale") || "en";
        const entropy = (0, $eBLyT.arrayify)(mnemonicAesCtr.decrypt(mnemonicCiphertext));
        try {
            const mnemonic = (0, $1ISM5.entropyToMnemonic)(entropy, locale);
            const node = (0, $1ISM5.HDNode).fromMnemonic(mnemonic, null, locale).derivePath(path);
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
            account.mnemonic = node.mnemonic;
        } catch (error) {
            // If we don't have the locale wordlist installed to
            // read this mnemonic, just bail and don't set the
            // mnemonic
            if (error.code !== (0, $4NCF1.Logger).errors.INVALID_ARGUMENT || error.argument !== "wordlist") throw error;
        }
    }
    return new $08eddb559844203e$export$cf9dc4fd6dde0315(account);
}
function $08eddb559844203e$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc) {
    return (0, $eBLyT.arrayify)((0, $bj8Mn.pbkdf2)(passwordBytes, salt, count, dkLen, prfFunc));
}
function $08eddb559844203e$var$pbkdf2(passwordBytes, salt, count, dkLen, prfFunc) {
    return Promise.resolve($08eddb559844203e$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc));
}
function $08eddb559844203e$var$_computeKdfKey(data, password, pbkdf2Func, scryptFunc, progressCallback) {
    const passwordBytes = (0, $8kBCw.getPassword)(password);
    const kdf = (0, $8kBCw.searchPath)(data, "crypto/kdf");
    if (kdf && typeof kdf === "string") {
        const throwError = function(name, value) {
            return $08eddb559844203e$var$logger.throwArgumentError("invalid key-derivation function parameters", name, value);
        };
        if (kdf.toLowerCase() === "scrypt") {
            const salt = (0, $8kBCw.looseArrayify)((0, $8kBCw.searchPath)(data, "crypto/kdfparams/salt"));
            const N = parseInt((0, $8kBCw.searchPath)(data, "crypto/kdfparams/n"));
            const r = parseInt((0, $8kBCw.searchPath)(data, "crypto/kdfparams/r"));
            const p = parseInt((0, $8kBCw.searchPath)(data, "crypto/kdfparams/p"));
            // Check for all required parameters
            if (!N || !r || !p) throwError("kdf", kdf);
            // Make sure N is a power of 2
            if ((N & N - 1) !== 0) throwError("N", N);
            const dkLen = parseInt((0, $8kBCw.searchPath)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return scryptFunc(passwordBytes, salt, N, r, p, 64, progressCallback);
        } else if (kdf.toLowerCase() === "pbkdf2") {
            const salt = (0, $8kBCw.looseArrayify)((0, $8kBCw.searchPath)(data, "crypto/kdfparams/salt"));
            let prfFunc = null;
            const prf = (0, $8kBCw.searchPath)(data, "crypto/kdfparams/prf");
            if (prf === "hmac-sha256") prfFunc = "sha256";
            else if (prf === "hmac-sha512") prfFunc = "sha512";
            else throwError("prf", prf);
            const count = parseInt((0, $8kBCw.searchPath)(data, "crypto/kdfparams/c"));
            const dkLen = parseInt((0, $8kBCw.searchPath)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return pbkdf2Func(passwordBytes, salt, count, dkLen, prfFunc);
        }
    }
    return $08eddb559844203e$var$logger.throwArgumentError("unsupported key-derivation function", "kdf", kdf);
}
function $08eddb559844203e$export$9bd2c37889ee5e36(json, password) {
    const data = JSON.parse(json);
    const key = $08eddb559844203e$var$_computeKdfKey(data, password, $08eddb559844203e$var$pbkdf2Sync, (0, (/*@__PURE__*/$parcel$interopDefault($10Zug))).syncScrypt);
    return $08eddb559844203e$var$_getAccount(data, key);
}
function $08eddb559844203e$export$e85a0c9a1067c5d3(json, password, progressCallback) {
    return $08eddb559844203e$var$__awaiter(this, void 0, void 0, function*() {
        const data = JSON.parse(json);
        const key = yield $08eddb559844203e$var$_computeKdfKey(data, password, $08eddb559844203e$var$pbkdf2, (0, (/*@__PURE__*/$parcel$interopDefault($10Zug))).scrypt, progressCallback);
        return $08eddb559844203e$var$_getAccount(data, key);
    });
}
function $08eddb559844203e$export$5b0f6292f11d1d18(account, password, options, progressCallback) {
    try {
        // Check the address matches the private key
        if ((0, $ak7re.getAddress)(account.address) !== (0, $ABz8M.computeAddress)(account.privateKey)) throw new Error("address/privateKey mismatch");
        // Check the mnemonic (if any) matches the private key
        if ($08eddb559844203e$var$hasMnemonic(account)) {
            const mnemonic = account.mnemonic;
            const node = (0, $1ISM5.HDNode).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path || (0, $1ISM5.defaultPath));
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
        }
    } catch (e) {
        return Promise.reject(e);
    }
    // The options are optional, so adjust the call as needed
    if (typeof options === "function" && !progressCallback) {
        progressCallback = options;
        options = {};
    }
    if (!options) options = {};
    const privateKey = (0, $eBLyT.arrayify)(account.privateKey);
    const passwordBytes = (0, $8kBCw.getPassword)(password);
    let entropy = null;
    let path = null;
    let locale = null;
    if ($08eddb559844203e$var$hasMnemonic(account)) {
        const srcMnemonic = account.mnemonic;
        entropy = (0, $eBLyT.arrayify)((0, $1ISM5.mnemonicToEntropy)(srcMnemonic.phrase, srcMnemonic.locale || "en"));
        path = srcMnemonic.path || (0, $1ISM5.defaultPath);
        locale = srcMnemonic.locale || "en";
    }
    let client = options.client;
    if (!client) client = "ethers.js";
    // Check/generate the salt
    let salt = null;
    if (options.salt) salt = (0, $eBLyT.arrayify)(options.salt);
    else salt = (0, $8hiLm.randomBytes)(32);
    // Override initialization vector
    let iv = null;
    if (options.iv) {
        iv = (0, $eBLyT.arrayify)(options.iv);
        if (iv.length !== 16) throw new Error("invalid iv");
    } else iv = (0, $8hiLm.randomBytes)(16);
    // Override the uuid
    let uuidRandom = null;
    if (options.uuid) {
        uuidRandom = (0, $eBLyT.arrayify)(options.uuid);
        if (uuidRandom.length !== 16) throw new Error("invalid uuid");
    } else uuidRandom = (0, $8hiLm.randomBytes)(16);
    // Override the scrypt password-based key derivation function parameters
    let N = 131072, r = 8, p = 1;
    if (options.scrypt) {
        if (options.scrypt.N) N = options.scrypt.N;
        if (options.scrypt.r) r = options.scrypt.r;
        if (options.scrypt.p) p = options.scrypt.p;
    }
    // We take 64 bytes:
    //   - 32 bytes   As normal for the Web3 secret storage (derivedKey, macPrefix)
    //   - 32 bytes   AES key to encrypt mnemonic with (required here to be Ethers Wallet)
    return (0, (/*@__PURE__*/$parcel$interopDefault($10Zug))).scrypt(passwordBytes, salt, N, r, p, 64, progressCallback).then((key)=>{
        key = (0, $eBLyT.arrayify)(key);
        // This will be used to encrypt the wallet (as per Web3 secret storage)
        const derivedKey = key.slice(0, 16);
        const macPrefix = key.slice(16, 32);
        // This will be used to encrypt the mnemonic phrase (if any)
        const mnemonicKey = key.slice(32, 64);
        // Encrypt the private key
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($7gxQg))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($7gxQg))).ModeOfOperation.ctr(derivedKey, counter);
        const ciphertext = (0, $eBLyT.arrayify)(aesCtr.encrypt(privateKey));
        // Compute the message authentication code, used to check the password
        const mac = (0, $bnbYM.keccak256)((0, $eBLyT.concat)([
            macPrefix,
            ciphertext
        ]));
        // See: https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition
        const data = {
            address: account.address.substring(2).toLowerCase(),
            id: (0, $8kBCw.uuidV4)(uuidRandom),
            version: 3,
            crypto: {
                cipher: "aes-128-ctr",
                cipherparams: {
                    iv: (0, $eBLyT.hexlify)(iv).substring(2)
                },
                ciphertext: (0, $eBLyT.hexlify)(ciphertext).substring(2),
                kdf: "scrypt",
                kdfparams: {
                    salt: (0, $eBLyT.hexlify)(salt).substring(2),
                    n: N,
                    dklen: 32,
                    p: p,
                    r: r
                },
                mac: mac.substring(2)
            }
        };
        // If we have a mnemonic, encrypt it into the JSON wallet
        if (entropy) {
            const mnemonicIv = (0, $8hiLm.randomBytes)(16);
            const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($7gxQg))).Counter(mnemonicIv);
            const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($7gxQg))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
            const mnemonicCiphertext = (0, $eBLyT.arrayify)(mnemonicAesCtr.encrypt(entropy));
            const now = new Date();
            const timestamp = now.getUTCFullYear() + "-" + (0, $8kBCw.zpad)(now.getUTCMonth() + 1, 2) + "-" + (0, $8kBCw.zpad)(now.getUTCDate(), 2) + "T" + (0, $8kBCw.zpad)(now.getUTCHours(), 2) + "-" + (0, $8kBCw.zpad)(now.getUTCMinutes(), 2) + "-" + (0, $8kBCw.zpad)(now.getUTCSeconds(), 2) + ".0Z";
            data["x-ethers"] = {
                client: client,
                gethFilename: "UTC--" + timestamp + "--" + data.address,
                mnemonicCounter: (0, $eBLyT.hexlify)(mnemonicIv).substring(2),
                mnemonicCiphertext: (0, $eBLyT.hexlify)(mnemonicCiphertext).substring(2),
                path: path,
                locale: locale,
                version: "0.1"
            };
        }
        return JSON.stringify(data);
    });
}

});
parcelRegister("10Zug", function(module, exports) {
"use strict";
(function(root) {
    const MAX_VALUE = 0x7fffffff;
    // The SHA256 and PBKDF2 implementation are from scrypt-async-js:
    // See: https://github.com/dchest/scrypt-async-js
    function SHA256(m) {
        const K = new Uint32Array([
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
        ]);
        let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a;
        let h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
        const w = new Uint32Array(64);
        function blocks(p) {
            let off = 0, len = p.length;
            while(len >= 64){
                let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, u, i, j, t1, t2;
                for(i = 0; i < 16; i++){
                    j = off + i * 4;
                    w[i] = (p[j] & 0xff) << 24 | (p[j + 1] & 0xff) << 16 | (p[j + 2] & 0xff) << 8 | p[j + 3] & 0xff;
                }
                for(i = 16; i < 64; i++){
                    u = w[i - 2];
                    t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                    u = w[i - 15];
                    t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                    w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0) | 0;
                }
                for(i = 0; i < 64; i++){
                    t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + (K[i] + w[i] | 0) | 0) | 0;
                    t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                h0 = h0 + a | 0;
                h1 = h1 + b | 0;
                h2 = h2 + c | 0;
                h3 = h3 + d | 0;
                h4 = h4 + e | 0;
                h5 = h5 + f | 0;
                h6 = h6 + g | 0;
                h7 = h7 + h | 0;
                off += 64;
                len -= 64;
            }
        }
        blocks(m);
        let i, bytesLeft = m.length % 64, bitLenHi = m.length / 0x20000000 | 0, bitLenLo = m.length << 3, numZeros = bytesLeft < 56 ? 56 : 120, p = m.slice(m.length - bytesLeft, m.length);
        p.push(0x80);
        for(i = bytesLeft + 1; i < numZeros; i++)p.push(0);
        p.push(bitLenHi >>> 24 & 0xff);
        p.push(bitLenHi >>> 16 & 0xff);
        p.push(bitLenHi >>> 8 & 0xff);
        p.push(bitLenHi >>> 0 & 0xff);
        p.push(bitLenLo >>> 24 & 0xff);
        p.push(bitLenLo >>> 16 & 0xff);
        p.push(bitLenLo >>> 8 & 0xff);
        p.push(bitLenLo >>> 0 & 0xff);
        blocks(p);
        return [
            h0 >>> 24 & 0xff,
            h0 >>> 16 & 0xff,
            h0 >>> 8 & 0xff,
            h0 >>> 0 & 0xff,
            h1 >>> 24 & 0xff,
            h1 >>> 16 & 0xff,
            h1 >>> 8 & 0xff,
            h1 >>> 0 & 0xff,
            h2 >>> 24 & 0xff,
            h2 >>> 16 & 0xff,
            h2 >>> 8 & 0xff,
            h2 >>> 0 & 0xff,
            h3 >>> 24 & 0xff,
            h3 >>> 16 & 0xff,
            h3 >>> 8 & 0xff,
            h3 >>> 0 & 0xff,
            h4 >>> 24 & 0xff,
            h4 >>> 16 & 0xff,
            h4 >>> 8 & 0xff,
            h4 >>> 0 & 0xff,
            h5 >>> 24 & 0xff,
            h5 >>> 16 & 0xff,
            h5 >>> 8 & 0xff,
            h5 >>> 0 & 0xff,
            h6 >>> 24 & 0xff,
            h6 >>> 16 & 0xff,
            h6 >>> 8 & 0xff,
            h6 >>> 0 & 0xff,
            h7 >>> 24 & 0xff,
            h7 >>> 16 & 0xff,
            h7 >>> 8 & 0xff,
            h7 >>> 0 & 0xff
        ];
    }
    function PBKDF2_HMAC_SHA256_OneIter(password, salt, dkLen) {
        // compress password if it's longer than hash block length
        password = password.length <= 64 ? password : SHA256(password);
        const innerLen = 64 + salt.length + 4;
        const inner = new Array(innerLen);
        const outerKey = new Array(64);
        let i;
        let dk = [];
        // inner = (password ^ ipad) || salt || counter
        for(i = 0; i < 64; i++)inner[i] = 0x36;
        for(i = 0; i < password.length; i++)inner[i] ^= password[i];
        for(i = 0; i < salt.length; i++)inner[64 + i] = salt[i];
        for(i = innerLen - 4; i < innerLen; i++)inner[i] = 0;
        // outerKey = password ^ opad
        for(i = 0; i < 64; i++)outerKey[i] = 0x5c;
        for(i = 0; i < password.length; i++)outerKey[i] ^= password[i];
        // increments counter inside inner
        function incrementCounter() {
            for(let i = innerLen - 1; i >= innerLen - 4; i--){
                inner[i]++;
                if (inner[i] <= 0xff) return;
                inner[i] = 0;
            }
        }
        // output blocks = SHA256(outerKey || SHA256(inner)) ...
        while(dkLen >= 32){
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))));
            dkLen -= 32;
        }
        if (dkLen > 0) {
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))).slice(0, dkLen));
        }
        return dk;
    }
    // The following is an adaptation of scryptsy
    // See: https://www.npmjs.com/package/scryptsy
    function blockmix_salsa8(BY, Yi, r, x, _X) {
        let i;
        arraycopy(BY, (2 * r - 1) * 16, _X, 0, 16);
        for(i = 0; i < 2 * r; i++){
            blockxor(BY, i * 16, _X, 16);
            salsa20_8(_X, x);
            arraycopy(_X, 0, BY, Yi + i * 16, 16);
        }
        for(i = 0; i < r; i++)arraycopy(BY, Yi + i * 32, BY, i * 16, 16);
        for(i = 0; i < r; i++)arraycopy(BY, Yi + (i * 2 + 1) * 16, BY, (i + r) * 16, 16);
    }
    function R(a, b) {
        return a << b | a >>> 32 - b;
    }
    function salsa20_8(B, x) {
        arraycopy(B, 0, x, 0, 16);
        for(let i = 8; i > 0; i -= 2){
            x[4] ^= R(x[0] + x[12], 7);
            x[8] ^= R(x[4] + x[0], 9);
            x[12] ^= R(x[8] + x[4], 13);
            x[0] ^= R(x[12] + x[8], 18);
            x[9] ^= R(x[5] + x[1], 7);
            x[13] ^= R(x[9] + x[5], 9);
            x[1] ^= R(x[13] + x[9], 13);
            x[5] ^= R(x[1] + x[13], 18);
            x[14] ^= R(x[10] + x[6], 7);
            x[2] ^= R(x[14] + x[10], 9);
            x[6] ^= R(x[2] + x[14], 13);
            x[10] ^= R(x[6] + x[2], 18);
            x[3] ^= R(x[15] + x[11], 7);
            x[7] ^= R(x[3] + x[15], 9);
            x[11] ^= R(x[7] + x[3], 13);
            x[15] ^= R(x[11] + x[7], 18);
            x[1] ^= R(x[0] + x[3], 7);
            x[2] ^= R(x[1] + x[0], 9);
            x[3] ^= R(x[2] + x[1], 13);
            x[0] ^= R(x[3] + x[2], 18);
            x[6] ^= R(x[5] + x[4], 7);
            x[7] ^= R(x[6] + x[5], 9);
            x[4] ^= R(x[7] + x[6], 13);
            x[5] ^= R(x[4] + x[7], 18);
            x[11] ^= R(x[10] + x[9], 7);
            x[8] ^= R(x[11] + x[10], 9);
            x[9] ^= R(x[8] + x[11], 13);
            x[10] ^= R(x[9] + x[8], 18);
            x[12] ^= R(x[15] + x[14], 7);
            x[13] ^= R(x[12] + x[15], 9);
            x[14] ^= R(x[13] + x[12], 13);
            x[15] ^= R(x[14] + x[13], 18);
        }
        for(let i = 0; i < 16; ++i)B[i] += x[i];
    }
    // naive approach... going back to loop unrolling may yield additional performance
    function blockxor(S, Si, D, len) {
        for(let i = 0; i < len; i++)D[i] ^= S[Si + i];
    }
    function arraycopy(src, srcPos, dest, destPos, length) {
        while(length--)dest[destPos++] = src[srcPos++];
    }
    function checkBufferish(o) {
        if (!o || typeof o.length !== "number") return false;
        for(let i = 0; i < o.length; i++){
            const v = o[i];
            if (typeof v !== "number" || v % 1 || v < 0 || v >= 256) return false;
        }
        return true;
    }
    function ensureInteger(value, name) {
        if (typeof value !== "number" || value % 1) throw new Error("invalid " + name);
        return value;
    }
    // N = Cpu cost, r = Memory cost, p = parallelization cost
    // callback(error, progress, key)
    function _scrypt(password, salt, N, r, p, dkLen, callback) {
        N = ensureInteger(N, "N");
        r = ensureInteger(r, "r");
        p = ensureInteger(p, "p");
        dkLen = ensureInteger(dkLen, "dkLen");
        if (N === 0 || (N & N - 1) !== 0) throw new Error("N must be power of 2");
        if (N > MAX_VALUE / 128 / r) throw new Error("N too large");
        if (r > MAX_VALUE / 128 / p) throw new Error("r too large");
        if (!checkBufferish(password)) throw new Error("password must be an array or buffer");
        password = Array.prototype.slice.call(password);
        if (!checkBufferish(salt)) throw new Error("salt must be an array or buffer");
        salt = Array.prototype.slice.call(salt);
        let b = PBKDF2_HMAC_SHA256_OneIter(password, salt, p * 128 * r);
        const B = new Uint32Array(p * 32 * r);
        for(let i = 0; i < B.length; i++){
            const j = i * 4;
            B[i] = (b[j + 3] & 0xff) << 24 | (b[j + 2] & 0xff) << 16 | (b[j + 1] & 0xff) << 8 | (b[j + 0] & 0xff) << 0;
        }
        const XY = new Uint32Array(64 * r);
        const V = new Uint32Array(32 * r * N);
        const Yi = 32 * r;
        // scratch space
        const x = new Uint32Array(16); // salsa20_8
        const _X = new Uint32Array(16); // blockmix_salsa8
        const totalOps = p * N * 2;
        let currentOp = 0;
        let lastPercent10 = null;
        // Set this to true to abandon the scrypt on the next step
        let stop = false;
        // State information
        let state = 0;
        let i0 = 0, i1;
        let Bi;
        // How many blockmix_salsa8 can we do per step?
        const limit = callback ? parseInt(1000 / r) : 0xffffffff;
        // Trick from scrypt-async; if there is a setImmediate shim in place, use it
        const nextTick = typeof setImmediate !== "undefined" ? setImmediate : setTimeout;
        // This is really all I changed; making scryptsy a state machine so we occasionally
        // stop and give other evnts on the evnt loop a chance to run. ~RicMoo
        const incrementalSMix = function() {
            if (stop) return callback(new Error("cancelled"), currentOp / totalOps);
            let steps;
            switch(state){
                case 0:
                    // for (var i = 0; i < p; i++)...
                    Bi = i0 * 32 * r;
                    arraycopy(B, Bi, XY, 0, Yi); // ROMix - 1
                    state = 1; // Move to ROMix 2
                    i1 = 0;
                // Fall through
                case 1:
                    // Run up to 1000 steps of the first inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        arraycopy(XY, 0, V, (i1 + i) * Yi, Yi) // ROMix - 3
                        ;
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 4
                    }
                    // for (var i = 0; i < N; i++)
                    i1 += steps;
                    currentOp += steps;
                    if (callback) {
                        // Call the callback with the progress (optionally stopping us)
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    i1 = 0; // Move to ROMix 6
                    state = 2;
                // Fall through
                case 2:
                    // Run up to 1000 steps of the second inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        const offset = (2 * r - 1) * 16; // ROMix - 7
                        const j = XY[offset] & N - 1;
                        blockxor(V, j * Yi, XY, Yi); // ROMix - 8 (inner)
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 9 (outer)
                    }
                    // for (var i = 0; i < N; i++)...
                    i1 += steps;
                    currentOp += steps;
                    // Call the callback with the progress (optionally stopping us)
                    if (callback) {
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    arraycopy(XY, 0, B, Bi, Yi); // ROMix - 10
                    // for (var i = 0; i < p; i++)...
                    i0++;
                    if (i0 < p) {
                        state = 0;
                        break;
                    }
                    b = [];
                    for(let i = 0; i < B.length; i++){
                        b.push(B[i] >> 0 & 0xff);
                        b.push(B[i] >> 8 & 0xff);
                        b.push(B[i] >> 16 & 0xff);
                        b.push(B[i] >> 24 & 0xff);
                    }
                    const derivedKey = PBKDF2_HMAC_SHA256_OneIter(password, b, dkLen);
                    // Send the result to the callback
                    if (callback) callback(null, 1.0, derivedKey);
                    // Done; don't break (which would reschedule)
                    return derivedKey;
            }
            // Schedule the next steps
            if (callback) nextTick(incrementalSMix);
        };
        // Run the smix state machine until completion
        if (!callback) while(true){
            const derivedKey = incrementalSMix();
            if (derivedKey != undefined) return derivedKey;
        }
        // Bootstrap the async incremental smix
        incrementalSMix();
    }
    const lib = {
        scrypt: function(password, salt, N, r, p, dkLen, progressCallback) {
            return new Promise(function(resolve, reject) {
                let lastProgress = 0;
                if (progressCallback) progressCallback(0);
                _scrypt(password, salt, N, r, p, dkLen, function(error, progress, key) {
                    if (error) reject(error);
                    else if (key) {
                        if (progressCallback && lastProgress !== 1) progressCallback(1);
                        resolve(new Uint8Array(key));
                    } else if (progressCallback && progress !== lastProgress) {
                        lastProgress = progress;
                        return progressCallback(progress);
                    }
                });
            });
        },
        syncScrypt: function(password, salt, N, r, p, dkLen) {
            return new Uint8Array(_scrypt(password, salt, N, r, p, dkLen));
        }
    };
    // node.js
    if (typeof module.exports !== "undefined") module.exports = lib;
    else if (typeof define === "function" && define.amd) define(lib);
    else if (root) {
        // If there was an existing library "scrypt", make sure it is still available
        if (root.scrypt) root._scrypt = root.scrypt;
        root.scrypt = lib;
    }
})(module.exports);

});



parcelRegister("eyxQ7", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $a98e7d8348132a98$export$83d89fbfd8236492; });
const $a98e7d8348132a98$export$83d89fbfd8236492 = "wallet/5.7.0";

});


parcelRegister("fFBPF", function(module, exports) {

$parcel$export(module.exports, "AddressZero", function () { return (parcelRequire("lBb3p")).AddressZero; });
$parcel$export(module.exports, "NegativeOne", function () { return (parcelRequire("M3r56")).NegativeOne; });
$parcel$export(module.exports, "Zero", function () { return (parcelRequire("M3r56")).Zero; });
$parcel$export(module.exports, "One", function () { return (parcelRequire("M3r56")).One; });
$parcel$export(module.exports, "Two", function () { return (parcelRequire("M3r56")).Two; });
$parcel$export(module.exports, "WeiPerEther", function () { return (parcelRequire("M3r56")).WeiPerEther; });
$parcel$export(module.exports, "MaxUint256", function () { return (parcelRequire("M3r56")).MaxUint256; });
$parcel$export(module.exports, "MinInt256", function () { return (parcelRequire("M3r56")).MinInt256; });
$parcel$export(module.exports, "MaxInt256", function () { return (parcelRequire("M3r56")).MaxInt256; });
$parcel$export(module.exports, "HashZero", function () { return (parcelRequire("9n5JS")).HashZero; });
$parcel$export(module.exports, "EtherSymbol", function () { return (parcelRequire("f0RRM")).EtherSymbol; });

var $lBb3p = parcelRequire("lBb3p");

var $M3r56 = parcelRequire("M3r56");

var $9n5JS = parcelRequire("9n5JS");

var $f0RRM = parcelRequire("f0RRM");
"use strict";

});
parcelRegister("lBb3p", function(module, exports) {

$parcel$export(module.exports, "AddressZero", function () { return $fb95a0c7f9f57d15$export$badd13187c087617; });
const $fb95a0c7f9f57d15$export$badd13187c087617 = "0x0000000000000000000000000000000000000000";

});

parcelRegister("9n5JS", function(module, exports) {

$parcel$export(module.exports, "HashZero", function () { return $6d2ab6ad10a74723$export$71c2e4e213dcb7f2; });
const $6d2ab6ad10a74723$export$71c2e4e213dcb7f2 = "0x0000000000000000000000000000000000000000000000000000000000000000";

});

parcelRegister("f0RRM", function(module, exports) {

$parcel$export(module.exports, "EtherSymbol", function () { return $aee0a3dc35d7554c$export$c7e79fcb6f8ac048; });
// NFKC (composed)             // (decomposed)
const $aee0a3dc35d7554c$export$c7e79fcb6f8ac048 = "\u039E"; // "\uD835\uDF63";

});


parcelRegister("fz5pm", function(module, exports) {

$parcel$export(module.exports, "getDefaultProvider", function () { return $b54e51d2e5b32ecf$export$4f77a1d3c1ac6642; });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("lOWlX")).Provider; });
$parcel$export(module.exports, "BaseProvider", function () { return (parcelRequire("ieSzc")).BaseProvider; });
$parcel$export(module.exports, "Resolver", function () { return (parcelRequire("ieSzc")).Resolver; });
$parcel$export(module.exports, "UrlJsonRpcProvider", function () { return (parcelRequire("6QpjG")).UrlJsonRpcProvider; });
$parcel$export(module.exports, "FallbackProvider", function () { return (parcelRequire("3cIU7")).FallbackProvider; });
$parcel$export(module.exports, "AlchemyProvider", function () { return (parcelRequire("ewyTU")).AlchemyProvider; });
$parcel$export(module.exports, "AlchemyWebSocketProvider", function () { return (parcelRequire("ewyTU")).AlchemyWebSocketProvider; });
$parcel$export(module.exports, "AnkrProvider", function () { return (parcelRequire("doBXu")).AnkrProvider; });
$parcel$export(module.exports, "CloudflareProvider", function () { return (parcelRequire("4PkQF")).CloudflareProvider; });
$parcel$export(module.exports, "EtherscanProvider", function () { return (parcelRequire("aL8Ez")).EtherscanProvider; });
$parcel$export(module.exports, "InfuraProvider", function () { return (parcelRequire("8iXgl")).InfuraProvider; });
$parcel$export(module.exports, "InfuraWebSocketProvider", function () { return (parcelRequire("8iXgl")).InfuraWebSocketProvider; });
$parcel$export(module.exports, "JsonRpcProvider", function () { return (parcelRequire("lDinN")).JsonRpcProvider; });
$parcel$export(module.exports, "JsonRpcBatchProvider", function () { return (parcelRequire("7pPzE")).JsonRpcBatchProvider; });
$parcel$export(module.exports, "NodesmithProvider", function () { return (parcelRequire("9Kok0")).NodesmithProvider; });
$parcel$export(module.exports, "PocketProvider", function () { return (parcelRequire("9oKQj")).PocketProvider; });
$parcel$export(module.exports, "StaticJsonRpcProvider", function () { return (parcelRequire("6QpjG")).StaticJsonRpcProvider; });
$parcel$export(module.exports, "Web3Provider", function () { return (parcelRequire("cneXW")).Web3Provider; });
$parcel$export(module.exports, "WebSocketProvider", function () { return (parcelRequire("eDTlN")).WebSocketProvider; });
$parcel$export(module.exports, "IpcProvider", function () { return (parcelRequire("2SUd6")).IpcProvider; });
$parcel$export(module.exports, "JsonRpcSigner", function () { return (parcelRequire("lDinN")).JsonRpcSigner; });
$parcel$export(module.exports, "getNetwork", function () { return (parcelRequire("ceeku")).getNetwork; });
$parcel$export(module.exports, "isCommunityResource", function () { return (parcelRequire("iUcRi")).isCommunityResource; });
$parcel$export(module.exports, "isCommunityResourcable", function () { return (parcelRequire("iUcRi")).isCommunityResourcable; });
$parcel$export(module.exports, "showThrottleMessage", function () { return (parcelRequire("iUcRi")).showThrottleMessage; });
$parcel$export(module.exports, "Formatter", function () { return (parcelRequire("iUcRi")).Formatter; });

var $lOWlX = parcelRequire("lOWlX");

var $ceeku = parcelRequire("ceeku");

var $ieSzc = parcelRequire("ieSzc");

var $ewyTU = parcelRequire("ewyTU");

var $doBXu = parcelRequire("doBXu");

var $4PkQF = parcelRequire("4PkQF");

var $aL8Ez = parcelRequire("aL8Ez");

var $3cIU7 = parcelRequire("3cIU7");

var $2SUd6 = parcelRequire("2SUd6");

var $8iXgl = parcelRequire("8iXgl");

var $lDinN = parcelRequire("lDinN");

var $7pPzE = parcelRequire("7pPzE");

var $9Kok0 = parcelRequire("9Kok0");

var $9oKQj = parcelRequire("9oKQj");

var $6QpjG = parcelRequire("6QpjG");

var $cneXW = parcelRequire("cneXW");

var $eDTlN = parcelRequire("eDTlN");

var $iUcRi = parcelRequire("iUcRi");

var $4NCF1 = parcelRequire("4NCF1");

var $5EnYk = parcelRequire("5EnYk");
"use strict";
const $b54e51d2e5b32ecf$var$logger = new (0, $4NCF1.Logger)((0, $5EnYk.version));
////////////////////////
// Helper Functions
function $b54e51d2e5b32ecf$export$4f77a1d3c1ac6642(network, options) {
    if (network == null) network = "homestead";
    // If passed a URL, figure out the right type of provider based on the scheme
    if (typeof network === "string") {
        // @TODO: Add support for IpcProvider; maybe if it ends in ".ipc"?
        // Handle http and ws (and their secure variants)
        const match = network.match(/^(ws|http)s?:/i);
        if (match) switch(match[1].toLowerCase()){
            case "http":
            case "https":
                return new (0, $lDinN.JsonRpcProvider)(network);
            case "ws":
            case "wss":
                return new (0, $eDTlN.WebSocketProvider)(network);
            default:
                $b54e51d2e5b32ecf$var$logger.throwArgumentError("unsupported URL scheme", "network", network);
        }
    }
    const n = (0, $ceeku.getNetwork)(network);
    if (!n || !n._defaultProvider) $b54e51d2e5b32ecf$var$logger.throwError("unsupported getDefaultProvider network", (0, $4NCF1.Logger).errors.NETWORK_ERROR, {
        operation: "getDefaultProvider",
        network: network
    });
    return n._defaultProvider({
        FallbackProvider: $3cIU7.FallbackProvider,
        AlchemyProvider: $ewyTU.AlchemyProvider,
        AnkrProvider: $doBXu.AnkrProvider,
        CloudflareProvider: $4PkQF.CloudflareProvider,
        EtherscanProvider: $aL8Ez.EtherscanProvider,
        InfuraProvider: $8iXgl.InfuraProvider,
        JsonRpcProvider: $lDinN.JsonRpcProvider,
        NodesmithProvider: $9Kok0.NodesmithProvider,
        PocketProvider: $9oKQj.PocketProvider,
        Web3Provider: $cneXW.Web3Provider,
        IpcProvider: $2SUd6.IpcProvider
    }, options);
}

});
parcelRegister("ceeku", function(module, exports) {

$parcel$export(module.exports, "getNetwork", function () { return $8e71e86173bef926$export$7de4970ebfd8206d; });

var $4NCF1 = parcelRequire("4NCF1");

var $elQWD = parcelRequire("elQWD");
"use strict";
const $8e71e86173bef926$var$logger = new (0, $4NCF1.Logger)((0, $elQWD.version));
function $8e71e86173bef926$var$isRenetworkable(value) {
    return value && typeof value.renetwork === "function";
}
function $8e71e86173bef926$var$ethDefaultProvider(network) {
    const func = function(providers, options) {
        if (options == null) options = {};
        const providerList = [];
        if (providers.InfuraProvider && options.infura !== "-") try {
            providerList.push(new providers.InfuraProvider(network, options.infura));
        } catch (error) {}
        if (providers.EtherscanProvider && options.etherscan !== "-") try {
            providerList.push(new providers.EtherscanProvider(network, options.etherscan));
        } catch (error) {}
        if (providers.AlchemyProvider && options.alchemy !== "-") try {
            providerList.push(new providers.AlchemyProvider(network, options.alchemy));
        } catch (error) {}
        if (providers.PocketProvider && options.pocket !== "-") {
            // These networks are currently faulty on Pocket as their
            // network does not handle the Berlin hardfork, which is
            // live on these ones.
            // @TODO: This goes away once Pocket has upgraded their nodes
            const skip = [
                "goerli",
                "ropsten",
                "rinkeby",
                "sepolia"
            ];
            try {
                const provider = new providers.PocketProvider(network, options.pocket);
                if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
            } catch (error) {}
        }
        if (providers.CloudflareProvider && options.cloudflare !== "-") try {
            providerList.push(new providers.CloudflareProvider(network));
        } catch (error) {}
        if (providers.AnkrProvider && options.ankr !== "-") try {
            const skip = [
                "ropsten"
            ];
            const provider = new providers.AnkrProvider(network, options.ankr);
            if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
        } catch (error) {}
        if (providerList.length === 0) return null;
        if (providers.FallbackProvider) {
            let quorum = 1;
            if (options.quorum != null) quorum = options.quorum;
            else if (network === "homestead") quorum = 2;
            return new providers.FallbackProvider(providerList, quorum);
        }
        return providerList[0];
    };
    func.renetwork = function(network) {
        return $8e71e86173bef926$var$ethDefaultProvider(network);
    };
    return func;
}
function $8e71e86173bef926$var$etcDefaultProvider(url, network) {
    const func = function(providers, options) {
        if (providers.JsonRpcProvider) return new providers.JsonRpcProvider(url, network);
        return null;
    };
    func.renetwork = function(network) {
        return $8e71e86173bef926$var$etcDefaultProvider(url, network);
    };
    return func;
}
const $8e71e86173bef926$var$homestead = {
    chainId: 1,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "homestead",
    _defaultProvider: $8e71e86173bef926$var$ethDefaultProvider("homestead")
};
const $8e71e86173bef926$var$ropsten = {
    chainId: 3,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "ropsten",
    _defaultProvider: $8e71e86173bef926$var$ethDefaultProvider("ropsten")
};
const $8e71e86173bef926$var$classicMordor = {
    chainId: 63,
    name: "classicMordor",
    _defaultProvider: $8e71e86173bef926$var$etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
};
// See: https://chainlist.org
const $8e71e86173bef926$var$networks = {
    unspecified: {
        chainId: 0,
        name: "unspecified"
    },
    homestead: $8e71e86173bef926$var$homestead,
    mainnet: $8e71e86173bef926$var$homestead,
    morden: {
        chainId: 2,
        name: "morden"
    },
    ropsten: $8e71e86173bef926$var$ropsten,
    testnet: $8e71e86173bef926$var$ropsten,
    rinkeby: {
        chainId: 4,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "rinkeby",
        _defaultProvider: $8e71e86173bef926$var$ethDefaultProvider("rinkeby")
    },
    kovan: {
        chainId: 42,
        name: "kovan",
        _defaultProvider: $8e71e86173bef926$var$ethDefaultProvider("kovan")
    },
    goerli: {
        chainId: 5,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "goerli",
        _defaultProvider: $8e71e86173bef926$var$ethDefaultProvider("goerli")
    },
    kintsugi: {
        chainId: 1337702,
        name: "kintsugi"
    },
    sepolia: {
        chainId: 11155111,
        name: "sepolia",
        _defaultProvider: $8e71e86173bef926$var$ethDefaultProvider("sepolia")
    },
    // ETC (See: #351)
    classic: {
        chainId: 61,
        name: "classic",
        _defaultProvider: $8e71e86173bef926$var$etcDefaultProvider("https://www.ethercluster.com/etc", "classic")
    },
    classicMorden: {
        chainId: 62,
        name: "classicMorden"
    },
    classicMordor: $8e71e86173bef926$var$classicMordor,
    classicTestnet: $8e71e86173bef926$var$classicMordor,
    classicKotti: {
        chainId: 6,
        name: "classicKotti",
        _defaultProvider: $8e71e86173bef926$var$etcDefaultProvider("https://www.ethercluster.com/kotti", "classicKotti")
    },
    xdai: {
        chainId: 100,
        name: "xdai"
    },
    matic: {
        chainId: 137,
        name: "matic",
        _defaultProvider: $8e71e86173bef926$var$ethDefaultProvider("matic")
    },
    maticmum: {
        chainId: 80001,
        name: "maticmum"
    },
    optimism: {
        chainId: 10,
        name: "optimism",
        _defaultProvider: $8e71e86173bef926$var$ethDefaultProvider("optimism")
    },
    "optimism-kovan": {
        chainId: 69,
        name: "optimism-kovan"
    },
    "optimism-goerli": {
        chainId: 420,
        name: "optimism-goerli"
    },
    arbitrum: {
        chainId: 42161,
        name: "arbitrum"
    },
    "arbitrum-rinkeby": {
        chainId: 421611,
        name: "arbitrum-rinkeby"
    },
    "arbitrum-goerli": {
        chainId: 421613,
        name: "arbitrum-goerli"
    },
    bnb: {
        chainId: 56,
        name: "bnb"
    },
    bnbt: {
        chainId: 97,
        name: "bnbt"
    }
};
function $8e71e86173bef926$export$7de4970ebfd8206d(network) {
    // No network (null)
    if (network == null) return null;
    if (typeof network === "number") {
        for(const name in $8e71e86173bef926$var$networks){
            const standard = $8e71e86173bef926$var$networks[name];
            if (standard.chainId === network) return {
                name: standard.name,
                chainId: standard.chainId,
                ensAddress: standard.ensAddress || null,
                _defaultProvider: standard._defaultProvider || null
            };
        }
        return {
            chainId: network,
            name: "unknown"
        };
    }
    if (typeof network === "string") {
        const standard = $8e71e86173bef926$var$networks[network];
        if (standard == null) return null;
        return {
            name: standard.name,
            chainId: standard.chainId,
            ensAddress: standard.ensAddress,
            _defaultProvider: standard._defaultProvider || null
        };
    }
    const standard = $8e71e86173bef926$var$networks[network.name];
    // Not a standard network; check that it is a valid network in general
    if (!standard) {
        if (typeof network.chainId !== "number") $8e71e86173bef926$var$logger.throwArgumentError("invalid network chainId", "network", network);
        return network;
    }
    // Make sure the chainId matches the expected network chainId (or is 0; disable EIP-155)
    if (network.chainId !== 0 && network.chainId !== standard.chainId) $8e71e86173bef926$var$logger.throwArgumentError("network chainId mismatch", "network", network);
    // @TODO: In the next major version add an attach function to a defaultProvider
    // class and move the _defaultProvider internal to this file (extend Network)
    let defaultProvider = network._defaultProvider || null;
    if (defaultProvider == null && standard._defaultProvider) {
        if ($8e71e86173bef926$var$isRenetworkable(standard._defaultProvider)) defaultProvider = standard._defaultProvider.renetwork(network);
        else defaultProvider = standard._defaultProvider;
    }
    // Standard Network (allow overriding the ENS address)
    return {
        name: network.name,
        chainId: standard.chainId,
        ensAddress: network.ensAddress || standard.ensAddress || null,
        _defaultProvider: defaultProvider
    };
}

});
parcelRegister("elQWD", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $a72c18983d48a8d7$export$83d89fbfd8236492; });
const $a72c18983d48a8d7$export$83d89fbfd8236492 = "networks/5.7.1";

});


parcelRegister("ieSzc", function(module, exports) {

$parcel$export(module.exports, "Resolver", function () { return $d473dc998aab152b$export$8b4c839865b08288; });
$parcel$export(module.exports, "BaseProvider", function () { return $d473dc998aab152b$export$ff3f6dd83125ac45; });

var $lOWlX = parcelRequire("lOWlX");

var $hNIlN = parcelRequire("hNIlN");

var $aK83G = parcelRequire("aK83G");

var $20M69 = parcelRequire("20M69");

var $eBLyT = parcelRequire("eBLyT");

var $9n5JS = parcelRequire("9n5JS");

var $iQ9BG = parcelRequire("iQ9BG");

var $ceeku = parcelRequire("ceeku");

var $j0dXC = parcelRequire("j0dXC");

var $8EXlS = parcelRequire("8EXlS");

var $5kral = parcelRequire("5kral");

var $lg5bp = parcelRequire("lg5bp");

var $5p4zw = parcelRequire("5p4zw");

var $4NCF1 = parcelRequire("4NCF1");

var $5EnYk = parcelRequire("5EnYk");

var $iUcRi = parcelRequire("iUcRi");
"use strict";
var $d473dc998aab152b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $d473dc998aab152b$var$logger = new (0, $4NCF1.Logger)((0, $5EnYk.version));
const $d473dc998aab152b$var$MAX_CCIP_REDIRECTS = 10;
//////////////////////////////
// Event Serializeing
function $d473dc998aab152b$var$checkTopic(topic) {
    if (topic == null) return "null";
    if ((0, $eBLyT.hexDataLength)(topic) !== 32) $d473dc998aab152b$var$logger.throwArgumentError("invalid topic", "topic", topic);
    return topic.toLowerCase();
}
function $d473dc998aab152b$var$serializeTopics(topics) {
    // Remove trailing null AND-topics; they are redundant
    topics = topics.slice();
    while(topics.length > 0 && topics[topics.length - 1] == null)topics.pop();
    return topics.map((topic)=>{
        if (Array.isArray(topic)) {
            // Only track unique OR-topics
            const unique = {};
            topic.forEach((topic)=>{
                unique[$d473dc998aab152b$var$checkTopic(topic)] = true;
            });
            // The order of OR-topics does not matter
            const sorted = Object.keys(unique);
            sorted.sort();
            return sorted.join("|");
        } else return $d473dc998aab152b$var$checkTopic(topic);
    }).join("&");
}
function $d473dc998aab152b$var$deserializeTopics(data) {
    if (data === "") return [];
    return data.split(/&/g).map((topic)=>{
        if (topic === "") return [];
        const comps = topic.split("|").map((topic)=>{
            return topic === "null" ? null : topic;
        });
        return comps.length === 1 ? comps[0] : comps;
    });
}
function $d473dc998aab152b$var$getEventTag(eventName) {
    if (typeof eventName === "string") {
        eventName = eventName.toLowerCase();
        if ((0, $eBLyT.hexDataLength)(eventName) === 32) return "tx:" + eventName;
        if (eventName.indexOf(":") === -1) return eventName;
    } else if (Array.isArray(eventName)) return "filter:*:" + $d473dc998aab152b$var$serializeTopics(eventName);
    else if ((0, $lOWlX.ForkEvent).isForkEvent(eventName)) {
        $d473dc998aab152b$var$logger.warn("not implemented");
        throw new Error("not implemented");
    } else if (eventName && typeof eventName === "object") return "filter:" + (eventName.address || "*") + ":" + $d473dc998aab152b$var$serializeTopics(eventName.topics || []);
    throw new Error("invalid event - " + eventName);
}
//////////////////////////////
// Helper Object
function $d473dc998aab152b$var$getTime() {
    return new Date().getTime();
}
function $d473dc998aab152b$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
//////////////////////////////
// Provider Object
/**
 *  EventType
 *   - "block"
 *   - "poll"
 *   - "didPoll"
 *   - "pending"
 *   - "error"
 *   - "network"
 *   - filter
 *   - topics array
 *   - transaction hash
 */ const $d473dc998aab152b$var$PollableEvents = [
    "block",
    "network",
    "pending",
    "poll"
];
class $d473dc998aab152b$export$d61e24a684f9e51 {
    constructor(tag, listener, once){
        (0, $j0dXC.defineReadOnly)(this, "tag", tag);
        (0, $j0dXC.defineReadOnly)(this, "listener", listener);
        (0, $j0dXC.defineReadOnly)(this, "once", once);
        this._lastBlockNumber = -2;
        this._inflight = false;
    }
    get event() {
        switch(this.type){
            case "tx":
                return this.hash;
            case "filter":
                return this.filter;
        }
        return this.tag;
    }
    get type() {
        return this.tag.split(":")[0];
    }
    get hash() {
        const comps = this.tag.split(":");
        if (comps[0] !== "tx") return null;
        return comps[1];
    }
    get filter() {
        const comps = this.tag.split(":");
        if (comps[0] !== "filter") return null;
        const address = comps[1];
        const topics = $d473dc998aab152b$var$deserializeTopics(comps[2]);
        const filter = {};
        if (topics.length > 0) filter.topics = topics;
        if (address && address !== "*") filter.address = address;
        return filter;
    }
    pollable() {
        return this.tag.indexOf(":") >= 0 || $d473dc998aab152b$var$PollableEvents.indexOf(this.tag) >= 0;
    }
}
// https://github.com/satoshilabs/slips/blob/master/slip-0044.md
const $d473dc998aab152b$var$coinInfos = {
    "0": {
        symbol: "btc",
        p2pkh: 0x00,
        p2sh: 0x05,
        prefix: "bc"
    },
    "2": {
        symbol: "ltc",
        p2pkh: 0x30,
        p2sh: 0x32,
        prefix: "ltc"
    },
    "3": {
        symbol: "doge",
        p2pkh: 0x1e,
        p2sh: 0x16
    },
    "60": {
        symbol: "eth",
        ilk: "eth"
    },
    "61": {
        symbol: "etc",
        ilk: "eth"
    },
    "700": {
        symbol: "xdai",
        ilk: "eth"
    }
};
function $d473dc998aab152b$var$bytes32ify(value) {
    return (0, $eBLyT.hexZeroPad)((0, $20M69.BigNumber).from(value).toHexString(), 32);
}
// Compute the Base58Check encoded data (checksum is first 4 bytes of sha256d)
function $d473dc998aab152b$var$base58Encode(data) {
    return (0, $aK83G.Base58).encode((0, $eBLyT.concat)([
        data,
        (0, $eBLyT.hexDataSlice)((0, $8EXlS.sha256)((0, $8EXlS.sha256)(data)), 0, 4)
    ]));
}
const $d473dc998aab152b$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
const $d473dc998aab152b$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $d473dc998aab152b$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
function $d473dc998aab152b$var$_parseString(result, start) {
    try {
        return (0, $5kral.toUtf8String)($d473dc998aab152b$var$_parseBytes(result, start));
    } catch (error) {}
    return null;
}
function $d473dc998aab152b$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    const offset = (0, $20M69.BigNumber).from((0, $eBLyT.hexDataSlice)(result, start, start + 32)).toNumber();
    const length = (0, $20M69.BigNumber).from((0, $eBLyT.hexDataSlice)(result, offset, offset + 32)).toNumber();
    return (0, $eBLyT.hexDataSlice)(result, offset + 32, offset + 32 + length);
}
// Trim off the ipfs:// prefix and return the default gateway URL
function $d473dc998aab152b$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else $d473dc998aab152b$var$logger.throwArgumentError("unsupported IPFS format", "link", link);
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
function $d473dc998aab152b$var$numPad(value) {
    const result = (0, $eBLyT.arrayify)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $d473dc998aab152b$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
// ABI Encodes a series of (bytes, bytes, ...)
function $d473dc998aab152b$var$encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for(let i = 0; i < datas.length; i++){
        result.push(null);
        byteCount += 32;
    }
    for(let i = 0; i < datas.length; i++){
        const data = (0, $eBLyT.arrayify)(datas[i]);
        // Update the bytes offset
        result[i] = $d473dc998aab152b$var$numPad(byteCount);
        // The length and padded value of data
        result.push($d473dc998aab152b$var$numPad(data.length));
        result.push($d473dc998aab152b$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $eBLyT.hexConcat)(result);
}
class $d473dc998aab152b$export$8b4c839865b08288 {
    // The resolvedAddress is only for creating a ReverseLookup resolver
    constructor(provider, address, name, resolvedAddress){
        (0, $j0dXC.defineReadOnly)(this, "provider", provider);
        (0, $j0dXC.defineReadOnly)(this, "name", name);
        (0, $j0dXC.defineReadOnly)(this, "address", provider.formatter.address(address));
        (0, $j0dXC.defineReadOnly)(this, "_resolvedAddress", resolvedAddress);
    }
    supportsWildcard() {
        if (!this._supportsEip2544) // supportsInterface(bytes4 = selector("resolve(bytes,bytes)"))
        this._supportsEip2544 = this.provider.call({
            to: this.address,
            data: "0x01ffc9a79061b92300000000000000000000000000000000000000000000000000000000"
        }).then((result)=>{
            return (0, $20M69.BigNumber).from(result).eq(1);
        }).catch((error)=>{
            if (error.code === (0, $4NCF1.Logger).errors.CALL_EXCEPTION) return false;
            // Rethrow the error: link is down, etc. Let future attempts retry.
            this._supportsEip2544 = null;
            throw error;
        });
        return this._supportsEip2544;
    }
    _fetch(selector, parameters) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            // e.g. keccak256("addr(bytes32,uint256)")
            const tx = {
                to: this.address,
                ccipReadEnabled: true,
                data: (0, $eBLyT.hexConcat)([
                    selector,
                    (0, $iQ9BG.namehash)(this.name),
                    parameters || "0x"
                ])
            };
            // Wildcard support; use EIP-2544 to resolve the request
            let parseBytes = false;
            if (yield this.supportsWildcard()) {
                parseBytes = true;
                // selector("resolve(bytes,bytes)")
                tx.data = (0, $eBLyT.hexConcat)([
                    "0x9061b923",
                    $d473dc998aab152b$var$encodeBytes([
                        (0, $iQ9BG.dnsEncode)(this.name),
                        tx.data
                    ])
                ]);
            }
            try {
                let result = yield this.provider.call(tx);
                if ((0, $eBLyT.arrayify)(result).length % 32 === 4) $d473dc998aab152b$var$logger.throwError("resolver threw error", (0, $4NCF1.Logger).errors.CALL_EXCEPTION, {
                    transaction: tx,
                    data: result
                });
                if (parseBytes) result = $d473dc998aab152b$var$_parseBytes(result, 0);
                return result;
            } catch (error) {
                if (error.code === (0, $4NCF1.Logger).errors.CALL_EXCEPTION) return null;
                throw error;
            }
        });
    }
    _fetchBytes(selector, parameters) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._fetch(selector, parameters);
            if (result != null) return $d473dc998aab152b$var$_parseBytes(result, 0);
            return null;
        });
    }
    _getAddress(coinType, hexBytes) {
        const coinInfo = $d473dc998aab152b$var$coinInfos[String(coinType)];
        if (coinInfo == null) $d473dc998aab152b$var$logger.throwError(`unsupported coin type: ${coinType}`, (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: `getAddress(${coinType})`
        });
        if (coinInfo.ilk === "eth") return this.provider.formatter.address(hexBytes);
        const bytes = (0, $eBLyT.arrayify)(hexBytes);
        // P2PKH: OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG
        if (coinInfo.p2pkh != null) {
            const p2pkh = hexBytes.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
            if (p2pkh) {
                const length = parseInt(p2pkh[1], 16);
                if (p2pkh[2].length === length * 2 && length >= 1 && length <= 75) return $d473dc998aab152b$var$base58Encode((0, $eBLyT.concat)([
                    [
                        coinInfo.p2pkh
                    ],
                    "0x" + p2pkh[2]
                ]));
            }
        }
        // P2SH: OP_HASH160 <scriptHash> OP_EQUAL
        if (coinInfo.p2sh != null) {
            const p2sh = hexBytes.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
            if (p2sh) {
                const length = parseInt(p2sh[1], 16);
                if (p2sh[2].length === length * 2 && length >= 1 && length <= 75) return $d473dc998aab152b$var$base58Encode((0, $eBLyT.concat)([
                    [
                        coinInfo.p2sh
                    ],
                    "0x" + p2sh[2]
                ]));
            }
        }
        // Bech32
        if (coinInfo.prefix != null) {
            const length = bytes[1];
            // https://github.com/bitcoin/bips/blob/master/bip-0141.mediawiki#witness-program
            let version = bytes[0];
            if (version === 0x00) {
                if (length !== 20 && length !== 32) version = -1;
            } else version = -1;
            if (version >= 0 && bytes.length === 2 + length && length >= 1 && length <= 75) {
                const words = (0, (/*@__PURE__*/$parcel$interopDefault($5p4zw))).toWords(bytes.slice(2));
                words.unshift(version);
                return (0, (/*@__PURE__*/$parcel$interopDefault($5p4zw))).encode(coinInfo.prefix, words);
            }
        }
        return null;
    }
    getAddress(coinType) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            if (coinType == null) coinType = 60;
            // If Ethereum, use the standard `addr(bytes32)`
            if (coinType === 60) try {
                // keccak256("addr(bytes32)")
                const result = yield this._fetch("0x3b3b57de");
                // No address
                if (result === "0x" || result === (0, $9n5JS.HashZero)) return null;
                return this.provider.formatter.callAddress(result);
            } catch (error) {
                if (error.code === (0, $4NCF1.Logger).errors.CALL_EXCEPTION) return null;
                throw error;
            }
            // keccak256("addr(bytes32,uint256")
            const hexBytes = yield this._fetchBytes("0xf1cb7e06", $d473dc998aab152b$var$bytes32ify(coinType));
            // No address
            if (hexBytes == null || hexBytes === "0x") return null;
            // Compute the address
            const address = this._getAddress(coinType, hexBytes);
            if (address == null) $d473dc998aab152b$var$logger.throwError(`invalid or unsupported coin data`, (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: `getAddress(${coinType})`,
                coinType: coinType,
                data: hexBytes
            });
            return address;
        });
    }
    getAvatar() {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            const linkage = [
                {
                    type: "name",
                    content: this.name
                }
            ];
            try {
                // test data for ricmoo.eth
                //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
                const avatar = yield this.getText("avatar");
                if (avatar == null) return null;
                for(let i = 0; i < $d473dc998aab152b$var$matchers.length; i++){
                    const match = avatar.match($d473dc998aab152b$var$matchers[i]);
                    if (match == null) continue;
                    const scheme = match[1].toLowerCase();
                    switch(scheme){
                        case "https":
                            linkage.push({
                                type: "url",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "data":
                            linkage.push({
                                type: "data",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "ipfs":
                            linkage.push({
                                type: "ipfs",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: $d473dc998aab152b$var$getIpfsLink(avatar)
                            };
                        case "erc721":
                        case "erc1155":
                            {
                                // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                                const selector = scheme === "erc721" ? "0xc87b56dd" : "0x0e89341c";
                                linkage.push({
                                    type: scheme,
                                    content: avatar
                                });
                                // The owner of this name
                                const owner = this._resolvedAddress || (yield this.getAddress());
                                const comps = (match[2] || "").split("/");
                                if (comps.length !== 2) return null;
                                const addr = yield this.provider.formatter.address(comps[0]);
                                const tokenId = (0, $eBLyT.hexZeroPad)((0, $20M69.BigNumber).from(comps[1]).toHexString(), 32);
                                // Check that this account owns the token
                                if (scheme === "erc721") {
                                    // ownerOf(uint256 tokenId)
                                    const tokenOwner = this.provider.formatter.callAddress((yield this.provider.call({
                                        to: addr,
                                        data: (0, $eBLyT.hexConcat)([
                                            "0x6352211e",
                                            tokenId
                                        ])
                                    })));
                                    if (owner !== tokenOwner) return null;
                                    linkage.push({
                                        type: "owner",
                                        content: tokenOwner
                                    });
                                } else if (scheme === "erc1155") {
                                    // balanceOf(address owner, uint256 tokenId)
                                    const balance = (0, $20M69.BigNumber).from((yield this.provider.call({
                                        to: addr,
                                        data: (0, $eBLyT.hexConcat)([
                                            "0x00fdd58e",
                                            (0, $eBLyT.hexZeroPad)(owner, 32),
                                            tokenId
                                        ])
                                    })));
                                    if (balance.isZero()) return null;
                                    linkage.push({
                                        type: "balance",
                                        content: balance.toString()
                                    });
                                }
                                // Call the token contract for the metadata URL
                                const tx = {
                                    to: this.provider.formatter.address(comps[0]),
                                    data: (0, $eBLyT.hexConcat)([
                                        selector,
                                        tokenId
                                    ])
                                };
                                let metadataUrl = $d473dc998aab152b$var$_parseString((yield this.provider.call(tx)), 0);
                                if (metadataUrl == null) return null;
                                linkage.push({
                                    type: "metadata-url-base",
                                    content: metadataUrl
                                });
                                // ERC-1155 allows a generic {id} in the URL
                                if (scheme === "erc1155") {
                                    metadataUrl = metadataUrl.replace("{id}", tokenId.substring(2));
                                    linkage.push({
                                        type: "metadata-url-expanded",
                                        content: metadataUrl
                                    });
                                }
                                // Transform IPFS metadata links
                                if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $d473dc998aab152b$var$getIpfsLink(metadataUrl);
                                linkage.push({
                                    type: "metadata-url",
                                    content: metadataUrl
                                });
                                // Get the token metadata
                                const metadata = yield (0, $lg5bp.fetchJson)(metadataUrl);
                                if (!metadata) return null;
                                linkage.push({
                                    type: "metadata",
                                    content: JSON.stringify(metadata)
                                });
                                // Pull the image URL out
                                let imageUrl = metadata.image;
                                if (typeof imageUrl !== "string") return null;
                                if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                                else {
                                    // Transform IPFS link to gateway
                                    const ipfs = imageUrl.match($d473dc998aab152b$var$matcherIpfs);
                                    if (ipfs == null) return null;
                                    linkage.push({
                                        type: "url-ipfs",
                                        content: imageUrl
                                    });
                                    imageUrl = $d473dc998aab152b$var$getIpfsLink(imageUrl);
                                }
                                linkage.push({
                                    type: "url",
                                    content: imageUrl
                                });
                                return {
                                    linkage: linkage,
                                    url: imageUrl
                                };
                            }
                    }
                }
            } catch (error) {}
            return null;
        });
    }
    getContentHash() {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            // keccak256("contenthash()")
            const hexBytes = yield this._fetchBytes("0xbc1c58d1");
            // No contenthash
            if (hexBytes == null || hexBytes === "0x") return null;
            // IPFS (CID: 1, Type: DAG-PB)
            const ipfs = hexBytes.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipfs) {
                const length = parseInt(ipfs[3], 16);
                if (ipfs[4].length === length * 2) return "ipfs://" + (0, $aK83G.Base58).encode("0x" + ipfs[1]);
            }
            // IPNS (CID: 1, Type: libp2p-key)
            const ipns = hexBytes.match(/^0xe5010172(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipns) {
                const length = parseInt(ipns[3], 16);
                if (ipns[4].length === length * 2) return "ipns://" + (0, $aK83G.Base58).encode("0x" + ipns[1]);
            }
            // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
            const swarm = hexBytes.match(/^0xe40101fa011b20([0-9a-f]*)$/);
            if (swarm) {
                if (swarm[1].length === 64) return "bzz://" + swarm[1];
            }
            const skynet = hexBytes.match(/^0x90b2c605([0-9a-f]*)$/);
            if (skynet) {
                if (skynet[1].length === 68) {
                    // URL Safe base64; https://datatracker.ietf.org/doc/html/rfc4648#section-5
                    const urlSafe = {
                        "=": "",
                        "+": "-",
                        "/": "_"
                    };
                    const hash = (0, $hNIlN.encode)("0x" + skynet[1]).replace(/[=+\/]/g, (a)=>urlSafe[a]);
                    return "sia://" + hash;
                }
            }
            return $d473dc998aab152b$var$logger.throwError(`invalid or unsupported content hash data`, (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "getContentHash()",
                data: hexBytes
            });
        });
    }
    getText(key) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            // The key encoded as parameter to fetchBytes
            let keyBytes = (0, $5kral.toUtf8Bytes)(key);
            // The nodehash consumes the first slot, so the string pointer targets
            // offset 64, with the length at offset 64 and data starting at offset 96
            keyBytes = (0, $eBLyT.concat)([
                $d473dc998aab152b$var$bytes32ify(64),
                $d473dc998aab152b$var$bytes32ify(keyBytes.length),
                keyBytes
            ]);
            // Pad to word-size (32 bytes)
            if (keyBytes.length % 32 !== 0) keyBytes = (0, $eBLyT.concat)([
                keyBytes,
                (0, $eBLyT.hexZeroPad)("0x", 32 - key.length % 32)
            ]);
            const hexBytes = yield this._fetchBytes("0x59d1d43c", (0, $eBLyT.hexlify)(keyBytes));
            if (hexBytes == null || hexBytes === "0x") return null;
            return (0, $5kral.toUtf8String)(hexBytes);
        });
    }
}
let $d473dc998aab152b$var$defaultFormatter = null;
let $d473dc998aab152b$var$nextPollId = 1;
class $d473dc998aab152b$export$ff3f6dd83125ac45 extends (0, $lOWlX.Provider) {
    /**
     *  ready
     *
     *  A Promise<Network> that resolves only once the provider is ready.
     *
     *  Sub-classes that call the super with a network without a chainId
     *  MUST set this. Standard named networks have a known chainId.
     *
     */ constructor(network){
        super();
        // Events being listened to
        this._events = [];
        this._emitted = {
            block: -2
        };
        this.disableCcipRead = false;
        this.formatter = new.target.getFormatter();
        // If network is any, this Provider allows the underlying
        // network to change dynamically, and we auto-detect the
        // current network
        (0, $j0dXC.defineReadOnly)(this, "anyNetwork", network === "any");
        if (this.anyNetwork) network = this.detectNetwork();
        if (network instanceof Promise) {
            this._networkPromise = network;
            // Squash any "unhandled promise" errors; that do not need to be handled
            network.catch((error)=>{});
            // Trigger initial network setting (async)
            this._ready().catch((error)=>{});
        } else {
            const knownNetwork = (0, $j0dXC.getStatic)(new.target, "getNetwork")(network);
            if (knownNetwork) {
                (0, $j0dXC.defineReadOnly)(this, "_network", knownNetwork);
                this.emit("network", knownNetwork, null);
            } else $d473dc998aab152b$var$logger.throwArgumentError("invalid network", "network", network);
        }
        this._maxInternalBlockNumber = -1024;
        this._lastBlockNumber = -2;
        this._maxFilterBlockRange = 10;
        this._pollingInterval = 4000;
        this._fastQueryDate = 0;
    }
    _ready() {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            if (this._network == null) {
                let network = null;
                if (this._networkPromise) try {
                    network = yield this._networkPromise;
                } catch (error) {}
                // Try the Provider's network detection (this MUST throw if it cannot)
                if (network == null) network = yield this.detectNetwork();
                // This should never happen; every Provider sub-class should have
                // suggested a network by here (or have thrown).
                if (!network) $d473dc998aab152b$var$logger.throwError("no network detected", (0, $4NCF1.Logger).errors.UNKNOWN_ERROR, {});
                // Possible this call stacked so do not call defineReadOnly again
                if (this._network == null) {
                    if (this.anyNetwork) this._network = network;
                    else (0, $j0dXC.defineReadOnly)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return this._network;
        });
    }
    // This will always return the most recently established network.
    // For "any", this can change (a "network" event is emitted before
    // any change is reflected); otherwise this cannot change
    get ready() {
        return (0, $lg5bp.poll)(()=>{
            return this._ready().then((network)=>{
                return network;
            }, (error)=>{
                // If the network isn't running yet, we will wait
                if (error.code === (0, $4NCF1.Logger).errors.NETWORK_ERROR && error.event === "noNetwork") return undefined;
                throw error;
            });
        });
    }
    // @TODO: Remove this and just create a singleton formatter
    static getFormatter() {
        if ($d473dc998aab152b$var$defaultFormatter == null) $d473dc998aab152b$var$defaultFormatter = new (0, $iUcRi.Formatter)();
        return $d473dc998aab152b$var$defaultFormatter;
    }
    // @TODO: Remove this and just use getNetwork
    static getNetwork(network) {
        return (0, $ceeku.getNetwork)(network == null ? "homestead" : network);
    }
    ccipReadFetch(tx, calldata, urls) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            if (this.disableCcipRead || urls.length === 0) return null;
            const sender = tx.to.toLowerCase();
            const data = calldata.toLowerCase();
            const errorMessages = [];
            for(let i = 0; i < urls.length; i++){
                const url = urls[i];
                // URL expansion
                const href = url.replace("{sender}", sender).replace("{data}", data);
                // If no {data} is present, use POST; otherwise GET
                const json = url.indexOf("{data}") >= 0 ? null : JSON.stringify({
                    data: data,
                    sender: sender
                });
                const result = yield (0, $lg5bp.fetchJson)({
                    url: href,
                    errorPassThrough: true
                }, json, (value, response)=>{
                    value.status = response.statusCode;
                    return value;
                });
                if (result.data) return result.data;
                const errorMessage = result.message || "unknown error";
                // 4xx indicates the result is not present; stop
                if (result.status >= 400 && result.status < 500) return $d473dc998aab152b$var$logger.throwError(`response not found during CCIP fetch: ${errorMessage}`, (0, $4NCF1.Logger).errors.SERVER_ERROR, {
                    url: url,
                    errorMessage: errorMessage
                });
                // 5xx indicates server issue; try the next url
                errorMessages.push(errorMessage);
            }
            return $d473dc998aab152b$var$logger.throwError(`error encountered during CCIP fetch: ${errorMessages.map((m)=>JSON.stringify(m)).join(", ")}`, (0, $4NCF1.Logger).errors.SERVER_ERROR, {
                urls: urls,
                errorMessages: errorMessages
            });
        });
    }
    // Fetches the blockNumber, but will reuse any result that is less
    // than maxAge old or has been requested since the last request
    _getInternalBlockNumber(maxAge) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            yield this._ready();
            // Allowing stale data up to maxAge old
            if (maxAge > 0) // While there are pending internal block requests...
            while(this._internalBlockNumber){
                // ..."remember" which fetch we started with
                const internalBlockNumber = this._internalBlockNumber;
                try {
                    // Check the result is not too stale
                    const result = yield internalBlockNumber;
                    if ($d473dc998aab152b$var$getTime() - result.respTime <= maxAge) return result.blockNumber;
                    break;
                } catch (error) {
                    // The fetch rejected; if we are the first to get the
                    // rejection, drop through so we replace it with a new
                    // fetch; all others blocked will then get that fetch
                    // which won't match the one they "remembered" and loop
                    if (this._internalBlockNumber === internalBlockNumber) break;
                }
            }
            const reqTime = $d473dc998aab152b$var$getTime();
            const checkInternalBlockNumber = (0, $j0dXC.resolveProperties)({
                blockNumber: this.perform("getBlockNumber", {}),
                networkError: this.getNetwork().then((network)=>null, (error)=>error)
            }).then(({ blockNumber: blockNumber, networkError: networkError })=>{
                if (networkError) {
                    // Unremember this bad internal block number
                    if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
                    throw networkError;
                }
                const respTime = $d473dc998aab152b$var$getTime();
                blockNumber = (0, $20M69.BigNumber).from(blockNumber).toNumber();
                if (blockNumber < this._maxInternalBlockNumber) blockNumber = this._maxInternalBlockNumber;
                this._maxInternalBlockNumber = blockNumber;
                this._setFastBlockNumber(blockNumber); // @TODO: Still need this?
                return {
                    blockNumber: blockNumber,
                    reqTime: reqTime,
                    respTime: respTime
                };
            });
            this._internalBlockNumber = checkInternalBlockNumber;
            // Swallow unhandled exceptions; if needed they are handled else where
            checkInternalBlockNumber.catch((error)=>{
                // Don't null the dead (rejected) fetch, if it has already been updated
                if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
            });
            return (yield checkInternalBlockNumber).blockNumber;
        });
    }
    poll() {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            const pollId = $d473dc998aab152b$var$nextPollId++;
            // Track all running promises, so we can trigger a post-poll once they are complete
            const runners = [];
            let blockNumber = null;
            try {
                blockNumber = yield this._getInternalBlockNumber(100 + this.pollingInterval / 2);
            } catch (error) {
                this.emit("error", error);
                return;
            }
            this._setFastBlockNumber(blockNumber);
            // Emit a poll event after we have the latest (fast) block number
            this.emit("poll", pollId, blockNumber);
            // If the block has not changed, meh.
            if (blockNumber === this._lastBlockNumber) {
                this.emit("didPoll", pollId);
                return;
            }
            // First polling cycle, trigger a "block" events
            if (this._emitted.block === -2) this._emitted.block = blockNumber - 1;
            if (Math.abs(this._emitted.block - blockNumber) > 1000) {
                $d473dc998aab152b$var$logger.warn(`network block skew detected; skipping block events (emitted=${this._emitted.block} blockNumber${blockNumber})`);
                this.emit("error", $d473dc998aab152b$var$logger.makeError("network block skew detected", (0, $4NCF1.Logger).errors.NETWORK_ERROR, {
                    blockNumber: blockNumber,
                    event: "blockSkew",
                    previousBlockNumber: this._emitted.block
                }));
                this.emit("block", blockNumber);
            } else // Notify all listener for each block that has passed
            for(let i = this._emitted.block + 1; i <= blockNumber; i++)this.emit("block", i);
            // The emitted block was updated, check for obsolete events
            if (this._emitted.block !== blockNumber) {
                this._emitted.block = blockNumber;
                Object.keys(this._emitted).forEach((key)=>{
                    // The block event does not expire
                    if (key === "block") return;
                    // The block we were at when we emitted this event
                    const eventBlockNumber = this._emitted[key];
                    // We cannot garbage collect pending transactions or blocks here
                    // They should be garbage collected by the Provider when setting
                    // "pending" events
                    if (eventBlockNumber === "pending") return;
                    // Evict any transaction hashes or block hashes over 12 blocks
                    // old, since they should not return null anyways
                    if (blockNumber - eventBlockNumber > 12) delete this._emitted[key];
                });
            }
            // First polling cycle
            if (this._lastBlockNumber === -2) this._lastBlockNumber = blockNumber - 1;
            // Find all transaction hashes we are waiting on
            this._events.forEach((event)=>{
                switch(event.type){
                    case "tx":
                        {
                            const hash = event.hash;
                            let runner = this.getTransactionReceipt(hash).then((receipt)=>{
                                if (!receipt || receipt.blockNumber == null) return null;
                                this._emitted["t:" + hash] = receipt.blockNumber;
                                this.emit(hash, receipt);
                                return null;
                            }).catch((error)=>{
                                this.emit("error", error);
                            });
                            runners.push(runner);
                            break;
                        }
                    case "filter":
                        // We only allow a single getLogs to be in-flight at a time
                        if (!event._inflight) {
                            event._inflight = true;
                            // This is the first filter for this event, so we want to
                            // restrict events to events that happened no earlier than now
                            if (event._lastBlockNumber === -2) event._lastBlockNumber = blockNumber - 1;
                            // Filter from the last *known* event; due to load-balancing
                            // and some nodes returning updated block numbers before
                            // indexing events, a logs result with 0 entries cannot be
                            // trusted and we must retry a range which includes it again
                            const filter = event.filter;
                            filter.fromBlock = event._lastBlockNumber + 1;
                            filter.toBlock = blockNumber;
                            // Prevent fitler ranges from growing too wild, since it is quite
                            // likely there just haven't been any events to move the lastBlockNumber.
                            const minFromBlock = filter.toBlock - this._maxFilterBlockRange;
                            if (minFromBlock > filter.fromBlock) filter.fromBlock = minFromBlock;
                            if (filter.fromBlock < 0) filter.fromBlock = 0;
                            const runner = this.getLogs(filter).then((logs)=>{
                                // Allow the next getLogs
                                event._inflight = false;
                                if (logs.length === 0) return;
                                logs.forEach((log)=>{
                                    // Only when we get an event for a given block number
                                    // can we trust the events are indexed
                                    if (log.blockNumber > event._lastBlockNumber) event._lastBlockNumber = log.blockNumber;
                                    // Make sure we stall requests to fetch blocks and txs
                                    this._emitted["b:" + log.blockHash] = log.blockNumber;
                                    this._emitted["t:" + log.transactionHash] = log.blockNumber;
                                    this.emit(filter, log);
                                });
                            }).catch((error)=>{
                                this.emit("error", error);
                                // Allow another getLogs (the range was not updated)
                                event._inflight = false;
                            });
                            runners.push(runner);
                        }
                        break;
                }
            });
            this._lastBlockNumber = blockNumber;
            // Once all events for this loop have been processed, emit "didPoll"
            Promise.all(runners).then(()=>{
                this.emit("didPoll", pollId);
            }).catch((error)=>{
                this.emit("error", error);
            });
            return;
        });
    }
    // Deprecated; do not use this
    resetEventsBlock(blockNumber) {
        this._lastBlockNumber = blockNumber - 1;
        if (this.polling) this.poll();
    }
    get network() {
        return this._network;
    }
    // This method should query the network if the underlying network
    // can change, such as when connected to a JSON-RPC backend
    detectNetwork() {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            return $d473dc998aab152b$var$logger.throwError("provider does not support network detection", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "provider.detectNetwork"
            });
        });
    }
    getNetwork() {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            const network = yield this._ready();
            // Make sure we are still connected to the same network; this is
            // only an external call for backends which can have the underlying
            // network change spontaneously
            const currentNetwork = yield this.detectNetwork();
            if (network.chainId !== currentNetwork.chainId) {
                // We are allowing network changes, things can get complex fast;
                // make sure you know what you are doing if you use "any"
                if (this.anyNetwork) {
                    this._network = currentNetwork;
                    // Reset all internal block number guards and caches
                    this._lastBlockNumber = -2;
                    this._fastBlockNumber = null;
                    this._fastBlockNumberPromise = null;
                    this._fastQueryDate = 0;
                    this._emitted.block = -2;
                    this._maxInternalBlockNumber = -1024;
                    this._internalBlockNumber = null;
                    // The "network" event MUST happen before this method resolves
                    // so any events have a chance to unregister, so we stall an
                    // additional event loop before returning from /this/ call
                    this.emit("network", currentNetwork, network);
                    yield $d473dc998aab152b$var$stall(0);
                    return this._network;
                }
                const error = $d473dc998aab152b$var$logger.makeError("underlying network changed", (0, $4NCF1.Logger).errors.NETWORK_ERROR, {
                    event: "changed",
                    network: network,
                    detectedNetwork: currentNetwork
                });
                this.emit("error", error);
                throw error;
            }
            return network;
        });
    }
    get blockNumber() {
        this._getInternalBlockNumber(100 + this.pollingInterval / 2).then((blockNumber)=>{
            this._setFastBlockNumber(blockNumber);
        }, (error)=>{});
        return this._fastBlockNumber != null ? this._fastBlockNumber : -1;
    }
    get polling() {
        return this._poller != null;
    }
    set polling(value) {
        if (value && !this._poller) {
            this._poller = setInterval(()=>{
                this.poll();
            }, this.pollingInterval);
            if (!this._bootstrapPoll) this._bootstrapPoll = setTimeout(()=>{
                this.poll();
                // We block additional polls until the polling interval
                // is done, to prevent overwhelming the poll function
                this._bootstrapPoll = setTimeout(()=>{
                    // If polling was disabled, something may require a poke
                    // since starting the bootstrap poll and it was disabled
                    if (!this._poller) this.poll();
                    // Clear out the bootstrap so we can do another
                    this._bootstrapPoll = null;
                }, this.pollingInterval);
            }, 0);
        } else if (!value && this._poller) {
            clearInterval(this._poller);
            this._poller = null;
        }
    }
    get pollingInterval() {
        return this._pollingInterval;
    }
    set pollingInterval(value) {
        if (typeof value !== "number" || value <= 0 || parseInt(String(value)) != value) throw new Error("invalid polling interval");
        this._pollingInterval = value;
        if (this._poller) {
            clearInterval(this._poller);
            this._poller = setInterval(()=>{
                this.poll();
            }, this._pollingInterval);
        }
    }
    _getFastBlockNumber() {
        const now = $d473dc998aab152b$var$getTime();
        // Stale block number, request a newer value
        if (now - this._fastQueryDate > 2 * this._pollingInterval) {
            this._fastQueryDate = now;
            this._fastBlockNumberPromise = this.getBlockNumber().then((blockNumber)=>{
                if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) this._fastBlockNumber = blockNumber;
                return this._fastBlockNumber;
            });
        }
        return this._fastBlockNumberPromise;
    }
    _setFastBlockNumber(blockNumber) {
        // Older block, maybe a stale request
        if (this._fastBlockNumber != null && blockNumber < this._fastBlockNumber) return;
        // Update the time we updated the blocknumber
        this._fastQueryDate = $d473dc998aab152b$var$getTime();
        // Newer block number, use  it
        if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
            this._fastBlockNumber = blockNumber;
            this._fastBlockNumberPromise = Promise.resolve(blockNumber);
        }
    }
    waitForTransaction(transactionHash, confirmations, timeout) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            return this._waitForTransaction(transactionHash, confirmations == null ? 1 : confirmations, timeout || 0, null);
        });
    }
    _waitForTransaction(transactionHash, confirmations, timeout, replaceable) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            const receipt = yield this.getTransactionReceipt(transactionHash);
            // Receipt is already good
            if ((receipt ? receipt.confirmations : 0) >= confirmations) return receipt;
            // Poll until the receipt is good...
            return new Promise((resolve, reject)=>{
                const cancelFuncs = [];
                let done = false;
                const alreadyDone = function() {
                    if (done) return true;
                    done = true;
                    cancelFuncs.forEach((func)=>{
                        func();
                    });
                    return false;
                };
                const minedHandler = (receipt)=>{
                    if (receipt.confirmations < confirmations) return;
                    if (alreadyDone()) return;
                    resolve(receipt);
                };
                this.on(transactionHash, minedHandler);
                cancelFuncs.push(()=>{
                    this.removeListener(transactionHash, minedHandler);
                });
                if (replaceable) {
                    let lastBlockNumber = replaceable.startBlock;
                    let scannedBlock = null;
                    const replaceHandler = (blockNumber)=>$d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
                            if (done) return;
                            // Wait 1 second; this is only used in the case of a fault, so
                            // we will trade off a little bit of latency for more consistent
                            // results and fewer JSON-RPC calls
                            yield $d473dc998aab152b$var$stall(1000);
                            this.getTransactionCount(replaceable.from).then((nonce)=>$d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
                                    if (done) return;
                                    if (nonce <= replaceable.nonce) lastBlockNumber = blockNumber;
                                    else {
                                        // First check if the transaction was mined
                                        {
                                            const mined = yield this.getTransaction(transactionHash);
                                            if (mined && mined.blockNumber != null) return;
                                        }
                                        // First time scanning. We start a little earlier for some
                                        // wiggle room here to handle the eventually consistent nature
                                        // of blockchain (e.g. the getTransactionCount was for a
                                        // different block)
                                        if (scannedBlock == null) {
                                            scannedBlock = lastBlockNumber - 3;
                                            if (scannedBlock < replaceable.startBlock) scannedBlock = replaceable.startBlock;
                                        }
                                        while(scannedBlock <= blockNumber){
                                            if (done) return;
                                            const block = yield this.getBlockWithTransactions(scannedBlock);
                                            for(let ti = 0; ti < block.transactions.length; ti++){
                                                const tx = block.transactions[ti];
                                                // Successfully mined!
                                                if (tx.hash === transactionHash) return;
                                                // Matches our transaction from and nonce; its a replacement
                                                if (tx.from === replaceable.from && tx.nonce === replaceable.nonce) {
                                                    if (done) return;
                                                    // Get the receipt of the replacement
                                                    const receipt = yield this.waitForTransaction(tx.hash, confirmations);
                                                    // Already resolved or rejected (prolly a timeout)
                                                    if (alreadyDone()) return;
                                                    // The reason we were replaced
                                                    let reason = "replaced";
                                                    if (tx.data === replaceable.data && tx.to === replaceable.to && tx.value.eq(replaceable.value)) reason = "repriced";
                                                    else if (tx.data === "0x" && tx.from === tx.to && tx.value.isZero()) reason = "cancelled";
                                                    // Explain why we were replaced
                                                    reject($d473dc998aab152b$var$logger.makeError("transaction was replaced", (0, $4NCF1.Logger).errors.TRANSACTION_REPLACED, {
                                                        cancelled: reason === "replaced" || reason === "cancelled",
                                                        reason: reason,
                                                        replacement: this._wrapTransaction(tx),
                                                        hash: transactionHash,
                                                        receipt: receipt
                                                    }));
                                                    return;
                                                }
                                            }
                                            scannedBlock++;
                                        }
                                    }
                                    if (done) return;
                                    this.once("block", replaceHandler);
                                }), (error)=>{
                                if (done) return;
                                this.once("block", replaceHandler);
                            });
                        });
                    if (done) return;
                    this.once("block", replaceHandler);
                    cancelFuncs.push(()=>{
                        this.removeListener("block", replaceHandler);
                    });
                }
                if (typeof timeout === "number" && timeout > 0) {
                    const timer = setTimeout(()=>{
                        if (alreadyDone()) return;
                        reject($d473dc998aab152b$var$logger.makeError("timeout exceeded", (0, $4NCF1.Logger).errors.TIMEOUT, {
                            timeout: timeout
                        }));
                    }, timeout);
                    if (timer.unref) timer.unref();
                    cancelFuncs.push(()=>{
                        clearTimeout(timer);
                    });
                }
            });
        });
    }
    getBlockNumber() {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            return this._getInternalBlockNumber(0);
        });
    }
    getGasPrice() {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const result = yield this.perform("getGasPrice", {});
            try {
                return (0, $20M69.BigNumber).from(result);
            } catch (error) {
                return $d473dc998aab152b$var$logger.throwError("bad result from backend", (0, $4NCF1.Logger).errors.SERVER_ERROR, {
                    method: "getGasPrice",
                    result: result,
                    error: error
                });
            }
        });
    }
    getBalance(addressOrName, blockTag) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $j0dXC.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getBalance", params);
            try {
                return (0, $20M69.BigNumber).from(result);
            } catch (error) {
                return $d473dc998aab152b$var$logger.throwError("bad result from backend", (0, $4NCF1.Logger).errors.SERVER_ERROR, {
                    method: "getBalance",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getTransactionCount(addressOrName, blockTag) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $j0dXC.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getTransactionCount", params);
            try {
                return (0, $20M69.BigNumber).from(result).toNumber();
            } catch (error) {
                return $d473dc998aab152b$var$logger.throwError("bad result from backend", (0, $4NCF1.Logger).errors.SERVER_ERROR, {
                    method: "getTransactionCount",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getCode(addressOrName, blockTag) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $j0dXC.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getCode", params);
            try {
                return (0, $eBLyT.hexlify)(result);
            } catch (error) {
                return $d473dc998aab152b$var$logger.throwError("bad result from backend", (0, $4NCF1.Logger).errors.SERVER_ERROR, {
                    method: "getCode",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getStorageAt(addressOrName, position, blockTag) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $j0dXC.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag),
                position: Promise.resolve(position).then((p)=>(0, $eBLyT.hexValue)(p))
            });
            const result = yield this.perform("getStorageAt", params);
            try {
                return (0, $eBLyT.hexlify)(result);
            } catch (error) {
                return $d473dc998aab152b$var$logger.throwError("bad result from backend", (0, $4NCF1.Logger).errors.SERVER_ERROR, {
                    method: "getStorageAt",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    // This should be called by any subclass wrapping a TransactionResponse
    _wrapTransaction(tx, hash, startBlock) {
        if (hash != null && (0, $eBLyT.hexDataLength)(hash) !== 32) throw new Error("invalid response - sendTransaction");
        const result = tx;
        // Check the hash we expect is the same as the hash the server reported
        if (hash != null && tx.hash !== hash) $d473dc998aab152b$var$logger.throwError("Transaction hash mismatch from Provider.sendTransaction.", (0, $4NCF1.Logger).errors.UNKNOWN_ERROR, {
            expectedHash: tx.hash,
            returnedHash: hash
        });
        result.wait = (confirms, timeout)=>$d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
                if (confirms == null) confirms = 1;
                if (timeout == null) timeout = 0;
                // Get the details to detect replacement
                let replacement = undefined;
                if (confirms !== 0 && startBlock != null) replacement = {
                    data: tx.data,
                    from: tx.from,
                    nonce: tx.nonce,
                    to: tx.to,
                    value: tx.value,
                    startBlock: startBlock
                };
                const receipt = yield this._waitForTransaction(tx.hash, confirms, timeout, replacement);
                if (receipt == null && confirms === 0) return null;
                // No longer pending, allow the polling loop to garbage collect this
                this._emitted["t:" + tx.hash] = receipt.blockNumber;
                if (receipt.status === 0) $d473dc998aab152b$var$logger.throwError("transaction failed", (0, $4NCF1.Logger).errors.CALL_EXCEPTION, {
                    transactionHash: tx.hash,
                    transaction: tx,
                    receipt: receipt
                });
                return receipt;
            });
        return result;
    }
    sendTransaction(signedTransaction) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const hexTx = yield Promise.resolve(signedTransaction).then((t)=>(0, $eBLyT.hexlify)(t));
            const tx = this.formatter.transaction(signedTransaction);
            if (tx.confirmations == null) tx.confirmations = 0;
            const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
            try {
                const hash = yield this.perform("sendTransaction", {
                    signedTransaction: hexTx
                });
                return this._wrapTransaction(tx, hash, blockNumber);
            } catch (error) {
                error.transaction = tx;
                error.transactionHash = tx.hash;
                throw error;
            }
        });
    }
    _getTransactionRequest(transaction) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            const values = yield transaction;
            const tx = {};
            [
                "from",
                "to"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? this._getAddress(v) : null);
            });
            [
                "gasLimit",
                "gasPrice",
                "maxFeePerGas",
                "maxPriorityFeePerGas",
                "value"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $20M69.BigNumber).from(v) : null);
            });
            [
                "type"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v != null ? v : null);
            });
            if (values.accessList) tx.accessList = this.formatter.accessList(values.accessList);
            [
                "data"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $eBLyT.hexlify)(v) : null);
            });
            return this.formatter.transactionRequest((yield (0, $j0dXC.resolveProperties)(tx)));
        });
    }
    _getFilter(filter) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            filter = yield filter;
            const result = {};
            if (filter.address != null) result.address = this._getAddress(filter.address);
            [
                "blockHash",
                "topics"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = filter[key];
            });
            [
                "fromBlock",
                "toBlock"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = this._getBlockTag(filter[key]);
            });
            return this.formatter.filter((yield (0, $j0dXC.resolveProperties)(result)));
        });
    }
    _call(transaction, blockTag, attempt) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            if (attempt >= $d473dc998aab152b$var$MAX_CCIP_REDIRECTS) $d473dc998aab152b$var$logger.throwError("CCIP read exceeded maximum redirections", (0, $4NCF1.Logger).errors.SERVER_ERROR, {
                redirects: attempt,
                transaction: transaction
            });
            const txSender = transaction.to;
            const result = yield this.perform("call", {
                transaction: transaction,
                blockTag: blockTag
            });
            // CCIP Read request via OffchainLookup(address,string[],bytes,bytes4,bytes)
            if (attempt >= 0 && blockTag === "latest" && txSender != null && result.substring(0, 10) === "0x556f1830" && (0, $eBLyT.hexDataLength)(result) % 32 === 4) try {
                const data = (0, $eBLyT.hexDataSlice)(result, 4);
                // Check the sender of the OffchainLookup matches the transaction
                const sender = (0, $eBLyT.hexDataSlice)(data, 0, 32);
                if (!(0, $20M69.BigNumber).from(sender).eq(txSender)) $d473dc998aab152b$var$logger.throwError("CCIP Read sender did not match", (0, $4NCF1.Logger).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                // Read the URLs from the response
                const urls = [];
                const urlsOffset = (0, $20M69.BigNumber).from((0, $eBLyT.hexDataSlice)(data, 32, 64)).toNumber();
                const urlsLength = (0, $20M69.BigNumber).from((0, $eBLyT.hexDataSlice)(data, urlsOffset, urlsOffset + 32)).toNumber();
                const urlsData = (0, $eBLyT.hexDataSlice)(data, urlsOffset + 32);
                for(let u = 0; u < urlsLength; u++){
                    const url = $d473dc998aab152b$var$_parseString(urlsData, u * 32);
                    if (url == null) $d473dc998aab152b$var$logger.throwError("CCIP Read contained corrupt URL string", (0, $4NCF1.Logger).errors.CALL_EXCEPTION, {
                        name: "OffchainLookup",
                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                        transaction: transaction,
                        data: result
                    });
                    urls.push(url);
                }
                // Get the CCIP calldata to forward
                const calldata = $d473dc998aab152b$var$_parseBytes(data, 64);
                // Get the callbackSelector (bytes4)
                if (!(0, $20M69.BigNumber).from((0, $eBLyT.hexDataSlice)(data, 100, 128)).isZero()) $d473dc998aab152b$var$logger.throwError("CCIP Read callback selector included junk", (0, $4NCF1.Logger).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const callbackSelector = (0, $eBLyT.hexDataSlice)(data, 96, 100);
                // Get the extra data to send back to the contract as context
                const extraData = $d473dc998aab152b$var$_parseBytes(data, 128);
                const ccipResult = yield this.ccipReadFetch(transaction, calldata, urls);
                if (ccipResult == null) $d473dc998aab152b$var$logger.throwError("CCIP Read disabled or provided no URLs", (0, $4NCF1.Logger).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const tx = {
                    to: txSender,
                    data: (0, $eBLyT.hexConcat)([
                        callbackSelector,
                        $d473dc998aab152b$var$encodeBytes([
                            ccipResult,
                            extraData
                        ])
                    ])
                };
                return this._call(tx, blockTag, attempt + 1);
            } catch (error) {
                if (error.code === (0, $4NCF1.Logger).errors.SERVER_ERROR) throw error;
            }
            try {
                return (0, $eBLyT.hexlify)(result);
            } catch (error) {
                return $d473dc998aab152b$var$logger.throwError("bad result from backend", (0, $4NCF1.Logger).errors.SERVER_ERROR, {
                    method: "call",
                    params: {
                        transaction: transaction,
                        blockTag: blockTag
                    },
                    result: result,
                    error: error
                });
            }
        });
    }
    call(transaction, blockTag) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const resolved = yield (0, $j0dXC.resolveProperties)({
                transaction: this._getTransactionRequest(transaction),
                blockTag: this._getBlockTag(blockTag),
                ccipReadEnabled: Promise.resolve(transaction.ccipReadEnabled)
            });
            return this._call(resolved.transaction, resolved.blockTag, resolved.ccipReadEnabled ? 0 : -1);
        });
    }
    estimateGas(transaction) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $j0dXC.resolveProperties)({
                transaction: this._getTransactionRequest(transaction)
            });
            const result = yield this.perform("estimateGas", params);
            try {
                return (0, $20M69.BigNumber).from(result);
            } catch (error) {
                return $d473dc998aab152b$var$logger.throwError("bad result from backend", (0, $4NCF1.Logger).errors.SERVER_ERROR, {
                    method: "estimateGas",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    _getAddress(addressOrName) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            addressOrName = yield addressOrName;
            if (typeof addressOrName !== "string") $d473dc998aab152b$var$logger.throwArgumentError("invalid address or ENS name", "name", addressOrName);
            const address = yield this.resolveName(addressOrName);
            if (address == null) $d473dc998aab152b$var$logger.throwError("ENS name not configured", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: `resolveName(${JSON.stringify(addressOrName)})`
            });
            return address;
        });
    }
    _getBlock(blockHashOrBlockTag, includeTransactions) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            blockHashOrBlockTag = yield blockHashOrBlockTag;
            // If blockTag is a number (not "latest", etc), this is the block number
            let blockNumber = -128;
            const params = {
                includeTransactions: !!includeTransactions
            };
            if ((0, $eBLyT.isHexString)(blockHashOrBlockTag, 32)) params.blockHash = blockHashOrBlockTag;
            else try {
                params.blockTag = yield this._getBlockTag(blockHashOrBlockTag);
                if ((0, $eBLyT.isHexString)(params.blockTag)) blockNumber = parseInt(params.blockTag.substring(2), 16);
            } catch (error) {
                $d473dc998aab152b$var$logger.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", blockHashOrBlockTag);
            }
            return (0, $lg5bp.poll)(()=>$d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
                    const block = yield this.perform("getBlock", params);
                    // Block was not found
                    if (block == null) {
                        // For blockhashes, if we didn't say it existed, that blockhash may
                        // not exist. If we did see it though, perhaps from a log, we know
                        // it exists, and this node is just not caught up yet.
                        if (params.blockHash != null) {
                            if (this._emitted["b:" + params.blockHash] == null) return null;
                        }
                        // For block tags, if we are asking for a future block, we return null
                        if (params.blockTag != null) {
                            if (blockNumber > this._emitted.block) return null;
                        }
                        // Retry on the next block
                        return undefined;
                    }
                    // Add transactions
                    if (includeTransactions) {
                        let blockNumber = null;
                        for(let i = 0; i < block.transactions.length; i++){
                            const tx = block.transactions[i];
                            if (tx.blockNumber == null) tx.confirmations = 0;
                            else if (tx.confirmations == null) {
                                if (blockNumber == null) blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                                // Add the confirmations using the fast block number (pessimistic)
                                let confirmations = blockNumber - tx.blockNumber + 1;
                                if (confirmations <= 0) confirmations = 1;
                                tx.confirmations = confirmations;
                            }
                        }
                        const blockWithTxs = this.formatter.blockWithTransactions(block);
                        blockWithTxs.transactions = blockWithTxs.transactions.map((tx)=>this._wrapTransaction(tx));
                        return blockWithTxs;
                    }
                    return this.formatter.block(block);
                }), {
                oncePoll: this
            });
        });
    }
    getBlock(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, false);
    }
    getBlockWithTransactions(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, true);
    }
    getTransaction(transactionHash) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $lg5bp.poll)(()=>$d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransaction", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    const tx = this.formatter.transactionResponse(result);
                    if (tx.blockNumber == null) tx.confirmations = 0;
                    else if (tx.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - tx.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        tx.confirmations = confirmations;
                    }
                    return this._wrapTransaction(tx);
                }), {
                oncePoll: this
            });
        });
    }
    getTransactionReceipt(transactionHash) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $lg5bp.poll)(()=>$d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransactionReceipt", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    // "geth-etc" returns receipts before they are ready
                    if (result.blockHash == null) return undefined;
                    const receipt = this.formatter.receipt(result);
                    if (receipt.blockNumber == null) receipt.confirmations = 0;
                    else if (receipt.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - receipt.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        receipt.confirmations = confirmations;
                    }
                    return receipt;
                }), {
                oncePoll: this
            });
        });
    }
    getLogs(filter) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $j0dXC.resolveProperties)({
                filter: this._getFilter(filter)
            });
            const logs = yield this.perform("getLogs", params);
            logs.forEach((log)=>{
                if (log.removed == null) log.removed = false;
            });
            return (0, $iUcRi.Formatter).arrayOf(this.formatter.filterLog.bind(this.formatter))(logs);
        });
    }
    getEtherPrice() {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            return this.perform("getEtherPrice", {});
        });
    }
    _getBlockTag(blockTag) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            blockTag = yield blockTag;
            if (typeof blockTag === "number" && blockTag < 0) {
                if (blockTag % 1) $d473dc998aab152b$var$logger.throwArgumentError("invalid BlockTag", "blockTag", blockTag);
                let blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                blockNumber += blockTag;
                if (blockNumber < 0) blockNumber = 0;
                return this.formatter.blockTag(blockNumber);
            }
            return this.formatter.blockTag(blockTag);
        });
    }
    getResolver(name) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            let currentName = name;
            while(true){
                if (currentName === "" || currentName === ".") return null;
                // Optimization since the eth node cannot change and does
                // not have a wildcard resolver
                if (name !== "eth" && currentName === "eth") return null;
                // Check the current node for a resolver
                const addr = yield this._getResolver(currentName, "getResolver");
                // Found a resolver!
                if (addr != null) {
                    const resolver = new $d473dc998aab152b$export$8b4c839865b08288(this, addr, name);
                    // Legacy resolver found, using EIP-2544 so it isn't safe to use
                    if (currentName !== name && !(yield resolver.supportsWildcard())) return null;
                    return resolver;
                }
                // Get the parent node
                currentName = currentName.split(".").slice(1).join(".");
            }
        });
    }
    _getResolver(name, operation) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            if (operation == null) operation = "ENS";
            const network = yield this.getNetwork();
            // No ENS...
            if (!network.ensAddress) $d473dc998aab152b$var$logger.throwError("network does not support ENS", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: operation,
                network: network.name
            });
            try {
                // keccak256("resolver(bytes32)")
                const addrData = yield this.call({
                    to: network.ensAddress,
                    data: "0x0178b8bf" + (0, $iQ9BG.namehash)(name).substring(2)
                });
                return this.formatter.callAddress(addrData);
            } catch (error) {
            // ENS registry cannot throw errors on resolver(bytes32)
            }
            return null;
        });
    }
    resolveName(name) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            name = yield name;
            // If it is already an address, nothing to resolve
            try {
                return Promise.resolve(this.formatter.address(name));
            } catch (error) {
                // If is is a hexstring, the address is bad (See #694)
                if ((0, $eBLyT.isHexString)(name)) throw error;
            }
            if (typeof name !== "string") $d473dc998aab152b$var$logger.throwArgumentError("invalid ENS name", "name", name);
            // Get the addr from the resolver
            const resolver = yield this.getResolver(name);
            if (!resolver) return null;
            return yield resolver.getAddress();
        });
    }
    lookupAddress(address) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            address = yield address;
            address = this.formatter.address(address);
            const node = address.substring(2).toLowerCase() + ".addr.reverse";
            const resolverAddr = yield this._getResolver(node, "lookupAddress");
            if (resolverAddr == null) return null;
            // keccak("name(bytes32)")
            const name = $d473dc998aab152b$var$_parseString((yield this.call({
                to: resolverAddr,
                data: "0x691f3431" + (0, $iQ9BG.namehash)(node).substring(2)
            })), 0);
            const addr = yield this.resolveName(name);
            if (addr != address) return null;
            return name;
        });
    }
    getAvatar(nameOrAddress) {
        return $d473dc998aab152b$var$__awaiter(this, void 0, void 0, function*() {
            let resolver = null;
            if ((0, $eBLyT.isHexString)(nameOrAddress)) {
                // Address; reverse lookup
                const address = this.formatter.address(nameOrAddress);
                const node = address.substring(2).toLowerCase() + ".addr.reverse";
                const resolverAddress = yield this._getResolver(node, "getAvatar");
                if (!resolverAddress) return null;
                // Try resolving the avatar against the addr.reverse resolver
                resolver = new $d473dc998aab152b$export$8b4c839865b08288(this, resolverAddress, node);
                try {
                    const avatar = yield resolver.getAvatar();
                    if (avatar) return avatar.url;
                } catch (error) {
                    if (error.code !== (0, $4NCF1.Logger).errors.CALL_EXCEPTION) throw error;
                }
                // Try getting the name and performing forward lookup; allowing wildcards
                try {
                    // keccak("name(bytes32)")
                    const name = $d473dc998aab152b$var$_parseString((yield this.call({
                        to: resolverAddress,
                        data: "0x691f3431" + (0, $iQ9BG.namehash)(node).substring(2)
                    })), 0);
                    resolver = yield this.getResolver(name);
                } catch (error) {
                    if (error.code !== (0, $4NCF1.Logger).errors.CALL_EXCEPTION) throw error;
                    return null;
                }
            } else {
                // ENS name; forward lookup with wildcard
                resolver = yield this.getResolver(nameOrAddress);
                if (!resolver) return null;
            }
            const avatar = yield resolver.getAvatar();
            if (avatar == null) return null;
            return avatar.url;
        });
    }
    perform(method, params) {
        return $d473dc998aab152b$var$logger.throwError(method + " not implemented", (0, $4NCF1.Logger).errors.NOT_IMPLEMENTED, {
            operation: method
        });
    }
    _startEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _stopEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _addEventListener(eventName, listener, once) {
        const event = new $d473dc998aab152b$export$d61e24a684f9e51($d473dc998aab152b$var$getEventTag(eventName), listener, once);
        this._events.push(event);
        this._startEvent(event);
        return this;
    }
    on(eventName, listener) {
        return this._addEventListener(eventName, listener, false);
    }
    once(eventName, listener) {
        return this._addEventListener(eventName, listener, true);
    }
    emit(eventName, ...args) {
        let result = false;
        let stopped = [];
        let eventTag = $d473dc998aab152b$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag) return true;
            setTimeout(()=>{
                event.listener.apply(this, args);
            }, 0);
            result = true;
            if (event.once) {
                stopped.push(event);
                return false;
            }
            return true;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return result;
    }
    listenerCount(eventName) {
        if (!eventName) return this._events.length;
        let eventTag = $d473dc998aab152b$var$getEventTag(eventName);
        return this._events.filter((event)=>{
            return event.tag === eventTag;
        }).length;
    }
    listeners(eventName) {
        if (eventName == null) return this._events.map((event)=>event.listener);
        let eventTag = $d473dc998aab152b$var$getEventTag(eventName);
        return this._events.filter((event)=>event.tag === eventTag).map((event)=>event.listener);
    }
    off(eventName, listener) {
        if (listener == null) return this.removeAllListeners(eventName);
        const stopped = [];
        let found = false;
        let eventTag = $d473dc998aab152b$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag || event.listener != listener) return true;
            if (found) return true;
            found = true;
            stopped.push(event);
            return false;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
    removeAllListeners(eventName) {
        let stopped = [];
        if (eventName == null) {
            stopped = this._events;
            this._events = [];
        } else {
            const eventTag = $d473dc998aab152b$var$getEventTag(eventName);
            this._events = this._events.filter((event)=>{
                if (event.tag !== eventTag) return true;
                stopped.push(event);
                return false;
            });
        }
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
}

});
parcelRegister("hNIlN", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $cf596a60b7fdcfe0$export$2f872c0f2117be69; });
$parcel$export(module.exports, "encode", function () { return $cf596a60b7fdcfe0$export$c564cdbbe6da493; });

var $eBLyT = parcelRequire("eBLyT");
"use strict";
function $cf596a60b7fdcfe0$export$2f872c0f2117be69(textData) {
    textData = atob(textData);
    const data = [];
    for(let i = 0; i < textData.length; i++)data.push(textData.charCodeAt(i));
    return (0, $eBLyT.arrayify)(data);
}
function $cf596a60b7fdcfe0$export$c564cdbbe6da493(data) {
    data = (0, $eBLyT.arrayify)(data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}

});

parcelRegister("iQ9BG", function(module, exports) {

$parcel$export(module.exports, "isValidName", function () { return $db748908ec455b60$export$cce2300886e7ace6; });
$parcel$export(module.exports, "namehash", function () { return $db748908ec455b60$export$91d651ee363e1209; });
$parcel$export(module.exports, "dnsEncode", function () { return $db748908ec455b60$export$6c0a8cdae51cb512; });

var $eBLyT = parcelRequire("eBLyT");

var $5kral = parcelRequire("5kral");

var $bnbYM = parcelRequire("bnbYM");

var $4NCF1 = parcelRequire("4NCF1");

var $kLgzk = parcelRequire("kLgzk");

var $5KtcZ = parcelRequire("5KtcZ");
const $db748908ec455b60$var$logger = new (0, $4NCF1.Logger)((0, $kLgzk.version));
const $db748908ec455b60$var$Zeros = new Uint8Array(32);
$db748908ec455b60$var$Zeros.fill(0);
function $db748908ec455b60$var$checkComponent(comp) {
    if (comp.length === 0) throw new Error("invalid ENS name; empty component");
    return comp;
}
function $db748908ec455b60$var$ensNameSplit(name) {
    const bytes = (0, $5kral.toUtf8Bytes)((0, $5KtcZ.ens_normalize)(name));
    const comps = [];
    if (name.length === 0) return comps;
    let last = 0;
    for(let i = 0; i < bytes.length; i++){
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push($db748908ec455b60$var$checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    if (last >= bytes.length) throw new Error("invalid ENS name; empty component");
    comps.push($db748908ec455b60$var$checkComponent(bytes.slice(last)));
    return comps;
}
function $db748908ec455b60$export$5f232fd2f1a1e8ac(name) {
    return $db748908ec455b60$var$ensNameSplit(name).map((comp)=>(0, $5kral.toUtf8String)(comp)).join(".");
}
function $db748908ec455b60$export$cce2300886e7ace6(name) {
    try {
        return $db748908ec455b60$var$ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function $db748908ec455b60$export$91d651ee363e1209(name) {
    /* istanbul ignore if */ if (typeof name !== "string") $db748908ec455b60$var$logger.throwArgumentError("invalid ENS name; not a string", "name", name);
    let result = $db748908ec455b60$var$Zeros;
    const comps = $db748908ec455b60$var$ensNameSplit(name);
    while(comps.length)result = (0, $bnbYM.keccak256)((0, $eBLyT.concat)([
        result,
        (0, $bnbYM.keccak256)(comps.pop())
    ]));
    return (0, $eBLyT.hexlify)(result);
}
function $db748908ec455b60$export$6c0a8cdae51cb512(name) {
    return (0, $eBLyT.hexlify)((0, $eBLyT.concat)($db748908ec455b60$var$ensNameSplit(name).map((comp)=>{
        // DNS does not allow components over 63 bytes in length
        if (comp.length > 63) throw new Error("invalid DNS encoded entry; length exceeds 63 bytes");
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}

});
parcelRegister("5KtcZ", function(module, exports) {

$parcel$export(module.exports, "ens_normalize", function () { return $42f7e7d9a2659840$export$499f715881831a51; });
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
var $5kral = parcelRequire("5kral");

var $bPwX0 = parcelRequire("bPwX0");

var $gigrG = parcelRequire("gigrG");
const $42f7e7d9a2659840$var$r = (0, $bPwX0.getData)();
// @TODO: This should be lazily loaded
const $42f7e7d9a2659840$var$VALID = new Set((0, $gigrG.read_member_array)($42f7e7d9a2659840$var$r));
const $42f7e7d9a2659840$var$IGNORED = new Set((0, $gigrG.read_member_array)($42f7e7d9a2659840$var$r));
const $42f7e7d9a2659840$var$MAPPED = (0, $gigrG.read_mapped_map)($42f7e7d9a2659840$var$r);
const $42f7e7d9a2659840$var$EMOJI_ROOT = (0, $gigrG.read_emoji_trie)($42f7e7d9a2659840$var$r);
//const NFC_CHECK = new Set(read_member_array(r, Array.from(VALID.values()).sort((a, b) => a - b)));
//const STOP = 0x2E;
const $42f7e7d9a2659840$var$HYPHEN = 0x2D;
const $42f7e7d9a2659840$var$UNDERSCORE = 0x5F;
function $42f7e7d9a2659840$var$explode_cp(name) {
    return (0, $5kral.toUtf8CodePoints)(name);
}
function $42f7e7d9a2659840$var$filter_fe0f(cps) {
    return cps.filter((cp)=>cp != 0xFE0F);
}
function $42f7e7d9a2659840$export$5252e54b57fcf4fd(name) {
    for (let label of name.split(".")){
        let cps = $42f7e7d9a2659840$var$explode_cp(label);
        try {
            for(let i = cps.lastIndexOf($42f7e7d9a2659840$var$UNDERSCORE) - 1; i >= 0; i--){
                if (cps[i] !== $42f7e7d9a2659840$var$UNDERSCORE) throw new Error(`underscore only allowed at start`);
            }
            if (cps.length >= 4 && cps.every((cp)=>cp < 0x80) && cps[2] === $42f7e7d9a2659840$var$HYPHEN && cps[3] === $42f7e7d9a2659840$var$HYPHEN) throw new Error(`invalid label extension`);
        } catch (err) {
            throw new Error(`Invalid label "${label}": ${err.message}`);
        }
    }
    return name;
}
function $42f7e7d9a2659840$export$499f715881831a51(name) {
    return $42f7e7d9a2659840$export$5252e54b57fcf4fd($42f7e7d9a2659840$var$normalize(name, $42f7e7d9a2659840$var$filter_fe0f));
}
function $42f7e7d9a2659840$var$normalize(name, emoji_filter) {
    let input = $42f7e7d9a2659840$var$explode_cp(name).reverse(); // flip for pop
    let output = [];
    while(input.length){
        let emoji = $42f7e7d9a2659840$var$consume_emoji_reversed(input);
        if (emoji) {
            output.push(...emoji_filter(emoji));
            continue;
        }
        let cp = input.pop();
        if ($42f7e7d9a2659840$var$VALID.has(cp)) {
            output.push(cp);
            continue;
        }
        if ($42f7e7d9a2659840$var$IGNORED.has(cp)) continue;
        let cps = $42f7e7d9a2659840$var$MAPPED[cp];
        if (cps) {
            output.push(...cps);
            continue;
        }
        throw new Error(`Disallowed codepoint: 0x${cp.toString(16).toUpperCase()}`);
    }
    return $42f7e7d9a2659840$export$5252e54b57fcf4fd($42f7e7d9a2659840$var$nfc(String.fromCodePoint(...output)));
}
function $42f7e7d9a2659840$var$nfc(s) {
    return s.normalize("NFC");
}
function $42f7e7d9a2659840$var$consume_emoji_reversed(cps, eaten) {
    var _a;
    let node = $42f7e7d9a2659840$var$EMOJI_ROOT;
    let emoji;
    let saved;
    let stack = [];
    let pos = cps.length;
    if (eaten) eaten.length = 0; // clear input buffer (if needed)
    while(pos){
        let cp = cps[--pos];
        node = (_a = node.branches.find((x)=>x.set.has(cp))) === null || _a === void 0 ? void 0 : _a.node;
        if (!node) break;
        if (node.save) saved = cp;
        else if (node.check) {
            if (cp === saved) break;
        }
        stack.push(cp);
        if (node.fe0f) {
            stack.push(0xFE0F);
            if (pos > 0 && cps[pos - 1] == 0xFE0F) pos--; // consume optional FE0F
        }
        if (node.valid) {
            emoji = stack.slice(); // copy stack
            if (node.valid == 2) emoji.splice(1, 1); // delete FE0F at position 1 (RGI ZWJ don't follow spec!)
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // copy input (if needed)
            cps.length = pos; // truncate
        }
    }
    return emoji;
}

});
parcelRegister("bPwX0", function(module, exports) {

$parcel$export(module.exports, "getData", function () { return $89ce0475fd026e95$export$7a171f172be0782e; });
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
var $hNIlN = parcelRequire("hNIlN");

var $gigrG = parcelRequire("gigrG");
function $89ce0475fd026e95$export$7a171f172be0782e() {
    return (0, $gigrG.read_compressed_payload)((0, $hNIlN.decode)("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"));
}

});
parcelRegister("gigrG", function(module, exports) {

$parcel$export(module.exports, "read_compressed_payload", function () { return $bdcb157e122316be$export$671d8b4ebc0c42ad; });
$parcel$export(module.exports, "read_member_array", function () { return $bdcb157e122316be$export$9303bf4e1ede4914; });
$parcel$export(module.exports, "read_mapped_map", function () { return $bdcb157e122316be$export$824d00fb01c38bd9; });
$parcel$export(module.exports, "read_emoji_trie", function () { return $bdcb157e122316be$export$d7b24c6ce369e1b7; });
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ // https://github.com/behnammodi/polyfill/blob/master/array.polyfill.js
function $bdcb157e122316be$var$flat(array, depth) {
    if (depth == null) depth = 1;
    const result = [];
    const forEach = result.forEach;
    const flatDeep = function(arr, depth) {
        forEach.call(arr, function(val) {
            if (depth > 0 && Array.isArray(val)) flatDeep(val, depth - 1);
            else result.push(val);
        });
    };
    flatDeep(array, depth);
    return result;
}
function $bdcb157e122316be$var$fromEntries(array) {
    const result = {};
    for(let i = 0; i < array.length; i++){
        const value = array[i];
        result[value[0]] = value[1];
    }
    return result;
}
function $bdcb157e122316be$export$956eeed0f8f2ceff(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = Math.pow(2, N);
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
function $bdcb157e122316be$export$2cda812f22276871(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function $bdcb157e122316be$export$671d8b4ebc0c42ad(bytes) {
    return $bdcb157e122316be$export$2cda812f22276871($bdcb157e122316be$export$956eeed0f8f2ceff(bytes));
}
function $bdcb157e122316be$export$a785de3a2a8dd1aa(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $bdcb157e122316be$var$read_counts(n, next) {
    let v = Array(n);
    for(let i = 0; i < n; i++)v[i] = 1 + next();
    return v;
}
function $bdcb157e122316be$var$read_ascending(n, next) {
    let v = Array(n);
    for(let i = 0, x = -1; i < n; i++)v[i] = x += 1 + next();
    return v;
}
function $bdcb157e122316be$var$read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += $bdcb157e122316be$export$a785de3a2a8dd1aa(next());
    return v;
}
function $bdcb157e122316be$export$9303bf4e1ede4914(next, lookup) {
    let v = $bdcb157e122316be$var$read_ascending(next(), next);
    let n = next();
    let vX = $bdcb157e122316be$var$read_ascending(n, next);
    let vN = $bdcb157e122316be$var$read_counts(n, next);
    for(let i = 0; i < n; i++)for(let j = 0; j < vN[i]; j++)v.push(vX[i] + j);
    return lookup ? v.map((x)=>lookup[x]) : v;
}
function $bdcb157e122316be$export$824d00fb01c38bd9(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push($bdcb157e122316be$var$read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push($bdcb157e122316be$var$read_replacement_table(w, next));
    }
    return $bdcb157e122316be$var$fromEntries($bdcb157e122316be$var$flat(ret));
}
function $bdcb157e122316be$export$e9011071590ab431(next) {
    let v = [];
    while(true){
        let i = next();
        if (i == 0) break;
        v.push(i);
    }
    return v;
}
function $bdcb157e122316be$var$read_transposed(n, w, next) {
    let m = Array(n).fill(undefined).map(()=>[]);
    for(let i = 0; i < w; i++)$bdcb157e122316be$var$read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
function $bdcb157e122316be$var$read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = $bdcb157e122316be$export$e9011071590ab431(next);
    let m = $bdcb157e122316be$var$read_transposed(vN.length, 1 + w, next);
    return $bdcb157e122316be$var$flat(m.map((v, i)=>{
        const x = v[0], ys = v.slice(1);
        //let [x, ...ys] = v;
        //return Array(vN[i]).fill().map((_, j) => {
        return Array(vN[i]).fill(undefined).map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    }));
}
function $bdcb157e122316be$var$read_replacement_table(w, next) {
    let n = 1 + next();
    let m = $bdcb157e122316be$var$read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
function $bdcb157e122316be$export$d7b24c6ce369e1b7(next) {
    let sorted = $bdcb157e122316be$export$9303bf4e1ede4914(next).sort((a, b)=>a - b);
    return read();
    function read() {
        let branches = [];
        while(true){
            let keys = $bdcb157e122316be$export$9303bf4e1ede4914(next, sorted);
            if (keys.length == 0) break;
            branches.push({
                set: new Set(keys),
                node: read()
            });
        }
        branches.sort((a, b)=>b.set.size - a.set.size); // sort by likelihood
        let temp = next();
        let valid = temp % 3;
        temp = temp / 3 | 0;
        let fe0f = !!(temp & 1);
        temp >>= 1;
        let save = temp == 1;
        let check = temp == 2;
        return {
            branches: branches,
            valid: valid,
            fe0f: fe0f,
            save: save,
            check: check
        };
    }
}

});




parcelRegister("lg5bp", function(module, exports) {

$parcel$export(module.exports, "_fetchData", function () { return $f79f1cdcaa84ec60$export$e37fa27017c6c012; });
$parcel$export(module.exports, "fetchJson", function () { return $f79f1cdcaa84ec60$export$6d71b655afe1638d; });
$parcel$export(module.exports, "poll", function () { return $f79f1cdcaa84ec60$export$e0c10349b2c5e1d4; });

var $hNIlN = parcelRequire("hNIlN");

var $eBLyT = parcelRequire("eBLyT");

var $j0dXC = parcelRequire("j0dXC");

var $5kral = parcelRequire("5kral");

var $4NCF1 = parcelRequire("4NCF1");

var $5uKIa = parcelRequire("5uKIa");

var $aDAhQ = parcelRequire("aDAhQ");
"use strict";
var $f79f1cdcaa84ec60$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $f79f1cdcaa84ec60$var$logger = new (0, $4NCF1.Logger)((0, $5uKIa.version));
function $f79f1cdcaa84ec60$var$staller(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $f79f1cdcaa84ec60$var$bodyify(value, type) {
    if (value == null) return null;
    if (typeof value === "string") return value;
    if ((0, $eBLyT.isBytesLike)(value)) {
        if (type && (type.split("/")[0] === "text" || type.split(";")[0].trim() === "application/json")) try {
            return (0, $5kral.toUtf8String)(value);
        } catch (error) {}
        return (0, $eBLyT.hexlify)(value);
    }
    return value;
}
function $f79f1cdcaa84ec60$var$unpercent(value) {
    return (0, $5kral.toUtf8Bytes)(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code)=>{
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function $f79f1cdcaa84ec60$export$e37fa27017c6c012(connection, body, processFunc) {
    // How many times to retry in the event of a throttle
    const attemptLimit = typeof connection === "object" && connection.throttleLimit != null ? connection.throttleLimit : 12;
    $f79f1cdcaa84ec60$var$logger.assertArgument(attemptLimit > 0 && attemptLimit % 1 === 0, "invalid connection throttle limit", "connection.throttleLimit", attemptLimit);
    const throttleCallback = typeof connection === "object" ? connection.throttleCallback : null;
    const throttleSlotInterval = typeof connection === "object" && typeof connection.throttleSlotInterval === "number" ? connection.throttleSlotInterval : 100;
    $f79f1cdcaa84ec60$var$logger.assertArgument(throttleSlotInterval > 0 && throttleSlotInterval % 1 === 0, "invalid connection throttle slot interval", "connection.throttleSlotInterval", throttleSlotInterval);
    const errorPassThrough = typeof connection === "object" ? !!connection.errorPassThrough : false;
    const headers = {};
    let url = null;
    // @TODO: Allow ConnectionInfo to override some of these values
    const options = {
        method: "GET"
    };
    let allow304 = false;
    let timeout = 120000;
    if (typeof connection === "string") url = connection;
    else if (typeof connection === "object") {
        if (connection == null || connection.url == null) $f79f1cdcaa84ec60$var$logger.throwArgumentError("missing URL", "connection.url", connection);
        url = connection.url;
        if (typeof connection.timeout === "number" && connection.timeout > 0) timeout = connection.timeout;
        if (connection.headers) for(const key in connection.headers){
            headers[key.toLowerCase()] = {
                key: key,
                value: String(connection.headers[key])
            };
            if ([
                "if-none-match",
                "if-modified-since"
            ].indexOf(key.toLowerCase()) >= 0) allow304 = true;
        }
        options.allowGzip = !!connection.allowGzip;
        if (connection.user != null && connection.password != null) {
            if (url.substring(0, 6) !== "https:" && connection.allowInsecureAuthentication !== true) $f79f1cdcaa84ec60$var$logger.throwError("basic authentication requires a secure https url", (0, $4NCF1.Logger).errors.INVALID_ARGUMENT, {
                argument: "url",
                url: url,
                user: connection.user,
                password: "[REDACTED]"
            });
            const authorization = connection.user + ":" + connection.password;
            headers["authorization"] = {
                key: "Authorization",
                value: "Basic " + (0, $hNIlN.encode)((0, $5kral.toUtf8Bytes)(authorization))
            };
        }
        if (connection.skipFetchSetup != null) options.skipFetchSetup = !!connection.skipFetchSetup;
        if (connection.fetchOptions != null) options.fetchOptions = (0, $j0dXC.shallowCopy)(connection.fetchOptions);
    }
    const reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
    const dataMatch = url ? url.match(reData) : null;
    if (dataMatch) try {
        const response = {
            statusCode: 200,
            statusMessage: "OK",
            headers: {
                "content-type": dataMatch[1] || "text/plain"
            },
            body: dataMatch[2] ? (0, $hNIlN.decode)(dataMatch[3]) : $f79f1cdcaa84ec60$var$unpercent(dataMatch[3])
        };
        let result = response.body;
        if (processFunc) result = processFunc(response.body, response);
        return Promise.resolve(result);
    } catch (error) {
        $f79f1cdcaa84ec60$var$logger.throwError("processing response error", (0, $4NCF1.Logger).errors.SERVER_ERROR, {
            body: $f79f1cdcaa84ec60$var$bodyify(dataMatch[1], dataMatch[2]),
            error: error,
            requestBody: null,
            requestMethod: "GET",
            url: url
        });
    }
    if (body) {
        options.method = "POST";
        options.body = body;
        if (headers["content-type"] == null) headers["content-type"] = {
            key: "Content-Type",
            value: "application/octet-stream"
        };
        if (headers["content-length"] == null) headers["content-length"] = {
            key: "Content-Length",
            value: String(body.length)
        };
    }
    const flatHeaders = {};
    Object.keys(headers).forEach((key)=>{
        const header = headers[key];
        flatHeaders[header.key] = header.value;
    });
    options.headers = flatHeaders;
    const runningTimeout = function() {
        let timer = null;
        const promise = new Promise(function(resolve, reject) {
            if (timeout) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                reject($f79f1cdcaa84ec60$var$logger.makeError("timeout", (0, $4NCF1.Logger).errors.TIMEOUT, {
                    requestBody: $f79f1cdcaa84ec60$var$bodyify(options.body, flatHeaders["content-type"]),
                    requestMethod: options.method,
                    timeout: timeout,
                    url: url
                }));
            }, timeout);
        });
        const cancel = function() {
            if (timer == null) return;
            clearTimeout(timer);
            timer = null;
        };
        return {
            promise: promise,
            cancel: cancel
        };
    }();
    const runningFetch = function() {
        return $f79f1cdcaa84ec60$var$__awaiter(this, void 0, void 0, function*() {
            for(let attempt = 0; attempt < attemptLimit; attempt++){
                let response = null;
                try {
                    response = yield (0, $aDAhQ.getUrl)(url, options);
                    if (attempt < attemptLimit) {
                        if (response.statusCode === 301 || response.statusCode === 302) {
                            // Redirection; for now we only support absolute locataions
                            const location = response.headers.location || "";
                            if (options.method === "GET" && location.match(/^https:/)) {
                                url = response.headers.location;
                                continue;
                            }
                        } else if (response.statusCode === 429) {
                            // Exponential back-off throttling
                            let tryAgain = true;
                            if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                            if (tryAgain) {
                                let stall = 0;
                                const retryAfter = response.headers["retry-after"];
                                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) stall = parseInt(retryAfter) * 1000;
                                else stall = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                                //console.log("Stalling 429");
                                yield $f79f1cdcaa84ec60$var$staller(stall);
                                continue;
                            }
                        }
                    }
                } catch (error) {
                    response = error.response;
                    if (response == null) {
                        runningTimeout.cancel();
                        $f79f1cdcaa84ec60$var$logger.throwError("missing response", (0, $4NCF1.Logger).errors.SERVER_ERROR, {
                            requestBody: $f79f1cdcaa84ec60$var$bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            serverError: error,
                            url: url
                        });
                    }
                }
                let body = response.body;
                if (allow304 && response.statusCode === 304) body = null;
                else if (!errorPassThrough && (response.statusCode < 200 || response.statusCode >= 300)) {
                    runningTimeout.cancel();
                    $f79f1cdcaa84ec60$var$logger.throwError("bad response", (0, $4NCF1.Logger).errors.SERVER_ERROR, {
                        status: response.statusCode,
                        headers: response.headers,
                        body: $f79f1cdcaa84ec60$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        requestBody: $f79f1cdcaa84ec60$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                if (processFunc) try {
                    const result = yield processFunc(body, response);
                    runningTimeout.cancel();
                    return result;
                } catch (error) {
                    // Allow the processFunc to trigger a throttle
                    if (error.throttleRetry && attempt < attemptLimit) {
                        let tryAgain = true;
                        if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                        if (tryAgain) {
                            const timeout = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                            //console.log("Stalling callback");
                            yield $f79f1cdcaa84ec60$var$staller(timeout);
                            continue;
                        }
                    }
                    runningTimeout.cancel();
                    $f79f1cdcaa84ec60$var$logger.throwError("processing response error", (0, $4NCF1.Logger).errors.SERVER_ERROR, {
                        body: $f79f1cdcaa84ec60$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        error: error,
                        requestBody: $f79f1cdcaa84ec60$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                runningTimeout.cancel();
                // If we had a processFunc, it either returned a T or threw above.
                // The "body" is now a Uint8Array.
                return body;
            }
            return $f79f1cdcaa84ec60$var$logger.throwError("failed response", (0, $4NCF1.Logger).errors.SERVER_ERROR, {
                requestBody: $f79f1cdcaa84ec60$var$bodyify(options.body, flatHeaders["content-type"]),
                requestMethod: options.method,
                url: url
            });
        });
    }();
    return Promise.race([
        runningTimeout.promise,
        runningFetch
    ]);
}
function $f79f1cdcaa84ec60$export$6d71b655afe1638d(connection, json, processFunc) {
    let processJsonFunc = (value, response)=>{
        let result = null;
        if (value != null) try {
            result = JSON.parse((0, $5kral.toUtf8String)(value));
        } catch (error) {
            $f79f1cdcaa84ec60$var$logger.throwError("invalid JSON", (0, $4NCF1.Logger).errors.SERVER_ERROR, {
                body: value,
                error: error
            });
        }
        if (processFunc) result = processFunc(result, response);
        return result;
    };
    // If we have json to send, we must
    // - add content-type of application/json (unless already overridden)
    // - convert the json to bytes
    let body = null;
    if (json != null) {
        body = (0, $5kral.toUtf8Bytes)(json);
        // Create a connection with the content-type set for JSON
        const updated = typeof connection === "string" ? {
            url: connection
        } : (0, $j0dXC.shallowCopy)(connection);
        if (updated.headers) {
            const hasContentType = Object.keys(updated.headers).filter((k)=>k.toLowerCase() === "content-type").length !== 0;
            if (!hasContentType) {
                updated.headers = (0, $j0dXC.shallowCopy)(updated.headers);
                updated.headers["content-type"] = "application/json";
            }
        } else updated.headers = {
            "content-type": "application/json"
        };
        connection = updated;
    }
    return $f79f1cdcaa84ec60$export$e37fa27017c6c012(connection, body, processJsonFunc);
}
function $f79f1cdcaa84ec60$export$e0c10349b2c5e1d4(func, options) {
    if (!options) options = {};
    options = (0, $j0dXC.shallowCopy)(options);
    if (options.floor == null) options.floor = 0;
    if (options.ceiling == null) options.ceiling = 10000;
    if (options.interval == null) options.interval = 250;
    return new Promise(function(resolve, reject) {
        let timer = null;
        let done = false;
        // Returns true if cancel was successful. Unsuccessful cancel means we're already done.
        const cancel = ()=>{
            if (done) return false;
            done = true;
            if (timer) clearTimeout(timer);
            return true;
        };
        if (options.timeout) timer = setTimeout(()=>{
            if (cancel()) reject(new Error("timeout"));
        }, options.timeout);
        const retryLimit = options.retryLimit;
        let attempt = 0;
        function check() {
            return func().then(function(result) {
                // If we have a result, or are allowed null then we're done
                if (result !== undefined) {
                    if (cancel()) resolve(result);
                } else if (options.oncePoll) options.oncePoll.once("poll", check);
                else if (options.onceBlock) options.onceBlock.once("block", check);
                else if (!done) {
                    attempt++;
                    if (attempt > retryLimit) {
                        if (cancel()) reject(new Error("retry limit reached"));
                        return;
                    }
                    let timeout = options.interval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                    if (timeout < options.floor) timeout = options.floor;
                    if (timeout > options.ceiling) timeout = options.ceiling;
                    setTimeout(check, timeout);
                }
                return null;
            }, function(error) {
                if (cancel()) reject(error);
            });
        }
        check();
    });
}

});
parcelRegister("5uKIa", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $4003fd03dc4e7a70$export$83d89fbfd8236492; });
const $4003fd03dc4e7a70$export$83d89fbfd8236492 = "web/5.7.1";

});

parcelRegister("aDAhQ", function(module, exports) {

$parcel$export(module.exports, "getUrl", function () { return $7be9b1b71d5e3c70$export$94df0e59ebebf4a7; });

var $eBLyT = parcelRequire("eBLyT");
"use strict";
var $7be9b1b71d5e3c70$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $7be9b1b71d5e3c70$export$94df0e59ebebf4a7(href, options) {
    return $7be9b1b71d5e3c70$var$__awaiter(this, void 0, void 0, function*() {
        if (options == null) options = {};
        const request = {
            method: options.method || "GET",
            headers: options.headers || {},
            body: options.body || undefined
        };
        if (options.skipFetchSetup !== true) {
            request.mode = "cors"; // no-cors, cors, *same-origin
            request.cache = "no-cache"; // *default, no-cache, reload, force-cache, only-if-cached
            request.credentials = "same-origin"; // include, *same-origin, omit
            request.redirect = "follow"; // manual, *follow, error
            request.referrer = "client"; // no-referrer, *client
        }
        if (options.fetchOptions != null) {
            const opts = options.fetchOptions;
            if (opts.mode) request.mode = opts.mode;
            if (opts.cache) request.cache = opts.cache;
            if (opts.credentials) request.credentials = opts.credentials;
            if (opts.redirect) request.redirect = opts.redirect;
            if (opts.referrer) request.referrer = opts.referrer;
        }
        const response = yield fetch(href, request);
        const body = yield response.arrayBuffer();
        const headers = {};
        if (response.headers.forEach) response.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        else response.headers.keys().forEach((key)=>{
            headers[key.toLowerCase()] = response.headers.get(key);
        });
        return {
            headers: headers,
            statusCode: response.status,
            statusMessage: response.statusText,
            body: (0, $eBLyT.arrayify)(new Uint8Array(body))
        };
    });
}

});


parcelRegister("5p4zw", function(module, exports) {
"use strict";
var $3ef2d57780b6c015$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
// pre-compute lookup table
var $3ef2d57780b6c015$var$ALPHABET_MAP = {};
for(var $3ef2d57780b6c015$var$z = 0; $3ef2d57780b6c015$var$z < $3ef2d57780b6c015$var$ALPHABET.length; $3ef2d57780b6c015$var$z++){
    var $3ef2d57780b6c015$var$x = $3ef2d57780b6c015$var$ALPHABET.charAt($3ef2d57780b6c015$var$z);
    if ($3ef2d57780b6c015$var$ALPHABET_MAP[$3ef2d57780b6c015$var$x] !== undefined) throw new TypeError($3ef2d57780b6c015$var$x + " is ambiguous");
    $3ef2d57780b6c015$var$ALPHABET_MAP[$3ef2d57780b6c015$var$x] = $3ef2d57780b6c015$var$z;
}
function $3ef2d57780b6c015$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $3ef2d57780b6c015$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $3ef2d57780b6c015$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $3ef2d57780b6c015$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $3ef2d57780b6c015$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $3ef2d57780b6c015$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $3ef2d57780b6c015$var$prefixChk(prefix);
    if (typeof chk === "string") throw new Error(chk);
    var result = prefix + "1";
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error("Non 5-bit word");
        chk = $3ef2d57780b6c015$var$polymodStep(chk) ^ x;
        result += $3ef2d57780b6c015$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $3ef2d57780b6c015$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $3ef2d57780b6c015$var$ALPHABET.charAt(v);
    }
    return result;
}
function $3ef2d57780b6c015$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + " too short";
    if (str.length > LIMIT) return "Exceeds length limit";
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
    str = lowered;
    var split = str.lastIndexOf("1");
    if (split === -1) return "No separator character for " + str;
    if (split === 0) return "Missing prefix for " + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return "Data too short";
    var chk = $3ef2d57780b6c015$var$prefixChk(prefix);
    if (typeof chk === "string") return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $3ef2d57780b6c015$var$ALPHABET_MAP[c];
        if (v === undefined) return "Unknown character " + c;
        chk = $3ef2d57780b6c015$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return "Invalid checksum for " + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $3ef2d57780b6c015$var$decodeUnsafe() {
    var res = $3ef2d57780b6c015$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
}
function $3ef2d57780b6c015$var$decode(str) {
    var res = $3ef2d57780b6c015$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
    throw new Error(res);
}
function $3ef2d57780b6c015$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $3ef2d57780b6c015$var$toWordsUnsafe(bytes) {
    var res = $3ef2d57780b6c015$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $3ef2d57780b6c015$var$toWords(bytes) {
    var res = $3ef2d57780b6c015$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $3ef2d57780b6c015$var$fromWordsUnsafe(words) {
    var res = $3ef2d57780b6c015$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $3ef2d57780b6c015$var$fromWords(words) {
    var res = $3ef2d57780b6c015$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
module.exports = {
    decodeUnsafe: $3ef2d57780b6c015$var$decodeUnsafe,
    decode: $3ef2d57780b6c015$var$decode,
    encode: $3ef2d57780b6c015$var$encode,
    toWordsUnsafe: $3ef2d57780b6c015$var$toWordsUnsafe,
    toWords: $3ef2d57780b6c015$var$toWords,
    fromWordsUnsafe: $3ef2d57780b6c015$var$fromWordsUnsafe,
    fromWords: $3ef2d57780b6c015$var$fromWords
};

});

parcelRegister("5EnYk", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $41d34886ef95b4f3$export$83d89fbfd8236492; });
const $41d34886ef95b4f3$export$83d89fbfd8236492 = "providers/5.7.2";

});

parcelRegister("iUcRi", function(module, exports) {

$parcel$export(module.exports, "Formatter", function () { return $dc376e6d14c59de6$export$a06636add2a09fd8; });
$parcel$export(module.exports, "isCommunityResourcable", function () { return $dc376e6d14c59de6$export$3091239f5b20b896; });
$parcel$export(module.exports, "isCommunityResource", function () { return $dc376e6d14c59de6$export$d93d5f61c2498b6; });
$parcel$export(module.exports, "showThrottleMessage", function () { return $dc376e6d14c59de6$export$4c41bd49e82e82ab; });

var $ak7re = parcelRequire("ak7re");

var $20M69 = parcelRequire("20M69");

var $eBLyT = parcelRequire("eBLyT");

var $lBb3p = parcelRequire("lBb3p");

var $j0dXC = parcelRequire("j0dXC");

var $ABz8M = parcelRequire("ABz8M");

var $4NCF1 = parcelRequire("4NCF1");

var $5EnYk = parcelRequire("5EnYk");
"use strict";
const $dc376e6d14c59de6$var$logger = new (0, $4NCF1.Logger)((0, $5EnYk.version));
class $dc376e6d14c59de6$export$a06636add2a09fd8 {
    constructor(){
        this.formats = this.getDefaultFormats();
    }
    getDefaultFormats() {
        const formats = {};
        const address = this.address.bind(this);
        const bigNumber = this.bigNumber.bind(this);
        const blockTag = this.blockTag.bind(this);
        const data = this.data.bind(this);
        const hash = this.hash.bind(this);
        const hex = this.hex.bind(this);
        const number = this.number.bind(this);
        const type = this.type.bind(this);
        const strictData = (v)=>{
            return this.data(v, true);
        };
        formats.transaction = {
            hash: hash,
            type: type,
            accessList: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null),
            blockHash: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(hash, null),
            blockNumber: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(number, null),
            transactionIndex: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(number, null),
            confirmations: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(number, null),
            from: address,
            // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
            // must be set
            gasPrice: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(bigNumber),
            gasLimit: bigNumber,
            to: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(address, null),
            value: bigNumber,
            nonce: number,
            data: data,
            r: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(this.uint256),
            s: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(this.uint256),
            v: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(number),
            creates: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(address, null),
            raw: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(data)
        };
        formats.transactionRequest = {
            from: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(address),
            nonce: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(number),
            gasLimit: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(bigNumber),
            gasPrice: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(bigNumber),
            to: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(address),
            value: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(bigNumber),
            data: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(strictData),
            type: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(number),
            accessList: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null)
        };
        formats.receiptLog = {
            transactionIndex: number,
            blockNumber: number,
            transactionHash: hash,
            address: address,
            topics: $dc376e6d14c59de6$export$a06636add2a09fd8.arrayOf(hash),
            data: data,
            logIndex: number,
            blockHash: hash
        };
        formats.receipt = {
            to: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(this.address, null),
            from: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(this.address, null),
            contractAddress: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(address, null),
            transactionIndex: number,
            // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
            root: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(hex),
            gasUsed: bigNumber,
            logsBloom: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(data),
            blockHash: hash,
            transactionHash: hash,
            logs: $dc376e6d14c59de6$export$a06636add2a09fd8.arrayOf(this.receiptLog.bind(this)),
            blockNumber: number,
            confirmations: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(number, null),
            cumulativeGasUsed: bigNumber,
            effectiveGasPrice: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(bigNumber),
            status: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(number),
            type: type
        };
        formats.block = {
            hash: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(hash),
            parentHash: hash,
            number: number,
            timestamp: number,
            nonce: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(hex),
            difficulty: this.difficulty.bind(this),
            gasLimit: bigNumber,
            gasUsed: bigNumber,
            miner: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(address),
            extraData: data,
            transactions: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull($dc376e6d14c59de6$export$a06636add2a09fd8.arrayOf(hash)),
            baseFeePerGas: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(bigNumber)
        };
        formats.blockWithTransactions = (0, $j0dXC.shallowCopy)(formats.block);
        formats.blockWithTransactions.transactions = $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull($dc376e6d14c59de6$export$a06636add2a09fd8.arrayOf(this.transactionResponse.bind(this)));
        formats.filter = {
            fromBlock: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            toBlock: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            blockHash: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(hash, undefined),
            address: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(address, undefined),
            topics: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(this.topics.bind(this), undefined)
        };
        formats.filterLog = {
            blockNumber: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(number),
            blockHash: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(hash),
            transactionIndex: number,
            removed: $dc376e6d14c59de6$export$a06636add2a09fd8.allowNull(this.boolean.bind(this)),
            address: address,
            data: $dc376e6d14c59de6$export$a06636add2a09fd8.allowFalsish(data, "0x"),
            topics: $dc376e6d14c59de6$export$a06636add2a09fd8.arrayOf(hash),
            transactionHash: hash,
            logIndex: number
        };
        return formats;
    }
    accessList(accessList) {
        return (0, $ABz8M.accessListify)(accessList || []);
    }
    // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
    // Strict! Used on input.
    number(number) {
        if (number === "0x") return 0;
        return (0, $20M69.BigNumber).from(number).toNumber();
    }
    type(number) {
        if (number === "0x" || number == null) return 0;
        return (0, $20M69.BigNumber).from(number).toNumber();
    }
    // Strict! Used on input.
    bigNumber(value) {
        return (0, $20M69.BigNumber).from(value);
    }
    // Requires a boolean, "true" or  "false"; returns a boolean
    boolean(value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "string") {
            value = value.toLowerCase();
            if (value === "true") return true;
            if (value === "false") return false;
        }
        throw new Error("invalid boolean - " + value);
    }
    hex(value, strict) {
        if (typeof value === "string") {
            if (!strict && value.substring(0, 2) !== "0x") value = "0x" + value;
            if ((0, $eBLyT.isHexString)(value)) return value.toLowerCase();
        }
        return $dc376e6d14c59de6$var$logger.throwArgumentError("invalid hash", "value", value);
    }
    data(value, strict) {
        const result = this.hex(value, strict);
        if (result.length % 2 !== 0) throw new Error("invalid data; odd-length - " + value);
        return result;
    }
    // Requires an address
    // Strict! Used on input.
    address(value) {
        return (0, $ak7re.getAddress)(value);
    }
    callAddress(value) {
        if (!(0, $eBLyT.isHexString)(value, 32)) return null;
        const address = (0, $ak7re.getAddress)((0, $eBLyT.hexDataSlice)(value, 12));
        return address === (0, $lBb3p.AddressZero) ? null : address;
    }
    contractAddress(value) {
        return (0, $ak7re.getContractAddress)(value);
    }
    // Strict! Used on input.
    blockTag(blockTag) {
        if (blockTag == null) return "latest";
        if (blockTag === "earliest") return "0x0";
        switch(blockTag){
            case "earliest":
                return "0x0";
            case "latest":
            case "pending":
            case "safe":
            case "finalized":
                return blockTag;
        }
        if (typeof blockTag === "number" || (0, $eBLyT.isHexString)(blockTag)) return (0, $eBLyT.hexValue)(blockTag);
        throw new Error("invalid blockTag");
    }
    // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
    hash(value, strict) {
        const result = this.hex(value, strict);
        if ((0, $eBLyT.hexDataLength)(result) !== 32) return $dc376e6d14c59de6$var$logger.throwArgumentError("invalid hash", "value", value);
        return result;
    }
    // Returns the difficulty as a number, or if too large (i.e. PoA network) null
    difficulty(value) {
        if (value == null) return null;
        const v = (0, $20M69.BigNumber).from(value);
        try {
            return v.toNumber();
        } catch (error) {}
        return null;
    }
    uint256(value) {
        if (!(0, $eBLyT.isHexString)(value)) throw new Error("invalid uint256");
        return (0, $eBLyT.hexZeroPad)(value, 32);
    }
    _block(value, format) {
        if (value.author != null && value.miner == null) value.miner = value.author;
        // The difficulty may need to come from _difficulty in recursed blocks
        const difficulty = value._difficulty != null ? value._difficulty : value.difficulty;
        const result = $dc376e6d14c59de6$export$a06636add2a09fd8.check(format, value);
        result._difficulty = difficulty == null ? null : (0, $20M69.BigNumber).from(difficulty);
        return result;
    }
    block(value) {
        return this._block(value, this.formats.block);
    }
    blockWithTransactions(value) {
        return this._block(value, this.formats.blockWithTransactions);
    }
    // Strict! Used on input.
    transactionRequest(value) {
        return $dc376e6d14c59de6$export$a06636add2a09fd8.check(this.formats.transactionRequest, value);
    }
    transactionResponse(transaction) {
        // Rename gas to gasLimit
        if (transaction.gas != null && transaction.gasLimit == null) transaction.gasLimit = transaction.gas;
        // Some clients (TestRPC) do strange things like return 0x0 for the
        // 0 address; correct this to be a real address
        if (transaction.to && (0, $20M69.BigNumber).from(transaction.to).isZero()) transaction.to = "0x0000000000000000000000000000000000000000";
        // Rename input to data
        if (transaction.input != null && transaction.data == null) transaction.data = transaction.input;
        // If to and creates are empty, populate the creates from the transaction
        if (transaction.to == null && transaction.creates == null) transaction.creates = this.contractAddress(transaction);
        if ((transaction.type === 1 || transaction.type === 2) && transaction.accessList == null) transaction.accessList = [];
        const result = $dc376e6d14c59de6$export$a06636add2a09fd8.check(this.formats.transaction, transaction);
        if (transaction.chainId != null) {
            let chainId = transaction.chainId;
            if ((0, $eBLyT.isHexString)(chainId)) chainId = (0, $20M69.BigNumber).from(chainId).toNumber();
            result.chainId = chainId;
        } else {
            let chainId = transaction.networkId;
            // geth-etc returns chainId
            if (chainId == null && result.v == null) chainId = transaction.chainId;
            if ((0, $eBLyT.isHexString)(chainId)) chainId = (0, $20M69.BigNumber).from(chainId).toNumber();
            if (typeof chainId !== "number" && result.v != null) {
                chainId = (result.v - 35) / 2;
                if (chainId < 0) chainId = 0;
                chainId = parseInt(chainId);
            }
            if (typeof chainId !== "number") chainId = 0;
            result.chainId = chainId;
        }
        // 0x0000... should actually be null
        if (result.blockHash && result.blockHash.replace(/0/g, "") === "x") result.blockHash = null;
        return result;
    }
    transaction(value) {
        return (0, $ABz8M.parse)(value);
    }
    receiptLog(value) {
        return $dc376e6d14c59de6$export$a06636add2a09fd8.check(this.formats.receiptLog, value);
    }
    receipt(value) {
        const result = $dc376e6d14c59de6$export$a06636add2a09fd8.check(this.formats.receipt, value);
        // RSK incorrectly implemented EIP-658, so we munge things a bit here for it
        if (result.root != null) {
            if (result.root.length <= 4) {
                // Could be 0x00, 0x0, 0x01 or 0x1
                const value = (0, $20M69.BigNumber).from(result.root).toNumber();
                if (value === 0 || value === 1) {
                    // Make sure if both are specified, they match
                    if (result.status != null && result.status !== value) $dc376e6d14c59de6$var$logger.throwArgumentError("alt-root-status/status mismatch", "value", {
                        root: result.root,
                        status: result.status
                    });
                    result.status = value;
                    delete result.root;
                } else $dc376e6d14c59de6$var$logger.throwArgumentError("invalid alt-root-status", "value.root", result.root);
            } else if (result.root.length !== 66) // Must be a valid bytes32
            $dc376e6d14c59de6$var$logger.throwArgumentError("invalid root hash", "value.root", result.root);
        }
        if (result.status != null) result.byzantium = true;
        return result;
    }
    topics(value) {
        if (Array.isArray(value)) return value.map((v)=>this.topics(v));
        else if (value != null) return this.hash(value, true);
        return null;
    }
    filter(value) {
        return $dc376e6d14c59de6$export$a06636add2a09fd8.check(this.formats.filter, value);
    }
    filterLog(value) {
        return $dc376e6d14c59de6$export$a06636add2a09fd8.check(this.formats.filterLog, value);
    }
    static check(format, object) {
        const result = {};
        for(const key in format)try {
            const value = format[key](object[key]);
            if (value !== undefined) result[key] = value;
        } catch (error) {
            error.checkKey = key;
            error.checkValue = object[key];
            throw error;
        }
        return result;
    }
    // if value is null-ish, nullValue is returned
    static allowNull(format, nullValue) {
        return function(value) {
            if (value == null) return nullValue;
            return format(value);
        };
    }
    // If value is false-ish, replaceValue is returned
    static allowFalsish(format, replaceValue) {
        return function(value) {
            if (!value) return replaceValue;
            return format(value);
        };
    }
    // Requires an Array satisfying check
    static arrayOf(format) {
        return function(array) {
            if (!Array.isArray(array)) throw new Error("not an array");
            const result = [];
            array.forEach(function(value) {
                result.push(format(value));
            });
            return result;
        };
    }
}
function $dc376e6d14c59de6$export$3091239f5b20b896(value) {
    return value && typeof value.isCommunityResource === "function";
}
function $dc376e6d14c59de6$export$d93d5f61c2498b6(value) {
    return $dc376e6d14c59de6$export$3091239f5b20b896(value) && value.isCommunityResource();
}
// Show the throttle message only once
let $dc376e6d14c59de6$var$throttleMessage = false;
function $dc376e6d14c59de6$export$4c41bd49e82e82ab() {
    if ($dc376e6d14c59de6$var$throttleMessage) return;
    $dc376e6d14c59de6$var$throttleMessage = true;
    console.log("========= NOTICE =========");
    console.log("Request-Rate Exceeded  (this message will not be repeated)");
    console.log("");
    console.log("The default API keys for each service are provided as a highly-throttled,");
    console.log("community resource for low-traffic projects and early prototyping.");
    console.log("");
    console.log("While your application will continue to function, we highly recommended");
    console.log("signing up for your own API keys to improve performance, increase your");
    console.log("request rate/limit and enable other perks, such as metrics and advanced APIs.");
    console.log("");
    console.log("For more details: https://docs.ethers.io/api-keys/");
    console.log("==========================");
}

});


parcelRegister("ewyTU", function(module, exports) {

$parcel$export(module.exports, "AlchemyWebSocketProvider", function () { return $a92f206af48bbac0$export$f6c13301c7b76371; });
$parcel$export(module.exports, "AlchemyProvider", function () { return $a92f206af48bbac0$export$999cc40da3fbc6f; });

var $j0dXC = parcelRequire("j0dXC");

var $iUcRi = parcelRequire("iUcRi");

var $eDTlN = parcelRequire("eDTlN");

var $4NCF1 = parcelRequire("4NCF1");

var $5EnYk = parcelRequire("5EnYk");

var $6QpjG = parcelRequire("6QpjG");
"use strict";
const $a92f206af48bbac0$var$logger = new (0, $4NCF1.Logger)((0, $5EnYk.version));
// This key was provided to ethers.js by Alchemy to be used by the
// default provider, but it is recommended that for your own
// production environments, that you acquire your own API key at:
//   https://dashboard.alchemyapi.io
const $a92f206af48bbac0$var$defaultApiKey = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
class $a92f206af48bbac0$export$f6c13301c7b76371 extends (0, $eDTlN.WebSocketProvider) {
    constructor(network, apiKey){
        const provider = new $a92f206af48bbac0$export$999cc40da3fbc6f(network, apiKey);
        const url = provider.connection.url.replace(/^http/i, "ws").replace(".alchemyapi.", ".ws.alchemyapi.");
        super(url, provider.network);
        (0, $j0dXC.defineReadOnly)(this, "apiKey", provider.apiKey);
    }
    isCommunityResource() {
        return this.apiKey === $a92f206af48bbac0$var$defaultApiKey;
    }
}
class $a92f206af48bbac0$export$999cc40da3fbc6f extends (0, $6QpjG.UrlJsonRpcProvider) {
    static getWebSocketProvider(network, apiKey) {
        return new $a92f206af48bbac0$export$f6c13301c7b76371(network, apiKey);
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $a92f206af48bbac0$var$defaultApiKey;
        if (apiKey && typeof apiKey !== "string") $a92f206af48bbac0$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "eth-mainnet.alchemyapi.io/v2/";
                break;
            case "goerli":
                host = "eth-goerli.g.alchemy.com/v2/";
                break;
            case "matic":
                host = "polygon-mainnet.g.alchemy.com/v2/";
                break;
            case "maticmum":
                host = "polygon-mumbai.g.alchemy.com/v2/";
                break;
            case "arbitrum":
                host = "arb-mainnet.g.alchemy.com/v2/";
                break;
            case "arbitrum-goerli":
                host = "arb-goerli.g.alchemy.com/v2/";
                break;
            case "optimism":
                host = "opt-mainnet.g.alchemy.com/v2/";
                break;
            case "optimism-goerli":
                host = "opt-goerli.g.alchemy.com/v2/";
                break;
            default:
                $a92f206af48bbac0$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return {
            allowGzip: true,
            url: "https://" + host + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey === $a92f206af48bbac0$var$defaultApiKey) (0, $iUcRi.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
    }
    isCommunityResource() {
        return this.apiKey === $a92f206af48bbac0$var$defaultApiKey;
    }
}

});
parcelRegister("eDTlN", function(module, exports) {

$parcel$export(module.exports, "WebSocketProvider", function () { return $aa8fa4b2473cd497$export$bfafe629242f30bd; });

var $20M69 = parcelRequire("20M69");

var $j0dXC = parcelRequire("j0dXC");

var $lDinN = parcelRequire("lDinN");

var $e8Tbp = parcelRequire("e8Tbp");

var $4NCF1 = parcelRequire("4NCF1");

var $5EnYk = parcelRequire("5EnYk");
"use strict";
var $aa8fa4b2473cd497$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $aa8fa4b2473cd497$var$logger = new (0, $4NCF1.Logger)((0, $5EnYk.version));
/**
 *  Notes:
 *
 *  This provider differs a bit from the polling providers. One main
 *  difference is how it handles consistency. The polling providers
 *  will stall responses to ensure a consistent state, while this
 *  WebSocket provider assumes the connected backend will manage this.
 *
 *  For example, if a polling provider emits an event which indicates
 *  the event occurred in blockhash XXX, a call to fetch that block by
 *  its hash XXX, if not present will retry until it is present. This
 *  can occur when querying a pool of nodes that are mildly out of sync
 *  with each other.
 */ let $aa8fa4b2473cd497$var$NextId = 1;
class $aa8fa4b2473cd497$export$bfafe629242f30bd extends (0, $lDinN.JsonRpcProvider) {
    constructor(url, network){
        // This will be added in the future; please open an issue to expedite
        if (network === "any") $aa8fa4b2473cd497$var$logger.throwError("WebSocketProvider does not support 'any' network yet", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "network:any"
        });
        if (typeof url === "string") super(url, network);
        else super("_websocket", network);
        this._pollingInterval = -1;
        this._wsReady = false;
        if (typeof url === "string") (0, $j0dXC.defineReadOnly)(this, "_websocket", new (0, $e8Tbp.WebSocket)(this.connection.url));
        else (0, $j0dXC.defineReadOnly)(this, "_websocket", url);
        (0, $j0dXC.defineReadOnly)(this, "_requests", {});
        (0, $j0dXC.defineReadOnly)(this, "_subs", {});
        (0, $j0dXC.defineReadOnly)(this, "_subIds", {});
        (0, $j0dXC.defineReadOnly)(this, "_detectNetwork", super.detectNetwork());
        // Stall sending requests until the socket is open...
        this.websocket.onopen = ()=>{
            this._wsReady = true;
            Object.keys(this._requests).forEach((id)=>{
                this.websocket.send(this._requests[id].payload);
            });
        };
        this.websocket.onmessage = (messageEvent)=>{
            const data = messageEvent.data;
            const result = JSON.parse(data);
            if (result.id != null) {
                const id = String(result.id);
                const request = this._requests[id];
                delete this._requests[id];
                if (result.result !== undefined) {
                    request.callback(null, result.result);
                    this.emit("debug", {
                        action: "response",
                        request: JSON.parse(request.payload),
                        response: result.result,
                        provider: this
                    });
                } else {
                    let error = null;
                    if (result.error) {
                        error = new Error(result.error.message || "unknown error");
                        (0, $j0dXC.defineReadOnly)(error, "code", result.error.code || null);
                        (0, $j0dXC.defineReadOnly)(error, "response", data);
                    } else error = new Error("unknown error");
                    request.callback(error, undefined);
                    this.emit("debug", {
                        action: "response",
                        error: error,
                        request: JSON.parse(request.payload),
                        provider: this
                    });
                }
            } else if (result.method === "eth_subscription") {
                // Subscription...
                const sub = this._subs[result.params.subscription];
                if (sub) //this.emit.apply(this,                  );
                sub.processFunc(result.params.result);
            } else console.warn("this should not happen");
        };
        // This Provider does not actually poll, but we want to trigger
        // poll events for things that depend on them (like stalling for
        // block and transaction lookups)
        const fauxPoll = setInterval(()=>{
            this.emit("poll");
        }, 1000);
        if (fauxPoll.unref) fauxPoll.unref();
    }
    // Cannot narrow the type of _websocket, as that is not backwards compatible
    // so we add a getter and let the WebSocket be a public API.
    get websocket() {
        return this._websocket;
    }
    detectNetwork() {
        return this._detectNetwork;
    }
    get pollingInterval() {
        return 0;
    }
    resetEventsBlock(blockNumber) {
        $aa8fa4b2473cd497$var$logger.throwError("cannot reset events block on WebSocketProvider", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "resetEventBlock"
        });
    }
    set pollingInterval(value) {
        $aa8fa4b2473cd497$var$logger.throwError("cannot set polling interval on WebSocketProvider", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "setPollingInterval"
        });
    }
    poll() {
        return $aa8fa4b2473cd497$var$__awaiter(this, void 0, void 0, function*() {
            return null;
        });
    }
    set polling(value) {
        if (!value) return;
        $aa8fa4b2473cd497$var$logger.throwError("cannot set polling on WebSocketProvider", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "setPolling"
        });
    }
    send(method, params) {
        const rid = $aa8fa4b2473cd497$var$NextId++;
        return new Promise((resolve, reject)=>{
            function callback(error, result) {
                if (error) return reject(error);
                return resolve(result);
            }
            const payload = JSON.stringify({
                method: method,
                params: params,
                id: rid,
                jsonrpc: "2.0"
            });
            this.emit("debug", {
                action: "request",
                request: JSON.parse(payload),
                provider: this
            });
            this._requests[String(rid)] = {
                callback: callback,
                payload: payload
            };
            if (this._wsReady) this.websocket.send(payload);
        });
    }
    static defaultUrl() {
        return "ws://localhost:8546";
    }
    _subscribe(tag, param, processFunc) {
        return $aa8fa4b2473cd497$var$__awaiter(this, void 0, void 0, function*() {
            let subIdPromise = this._subIds[tag];
            if (subIdPromise == null) {
                subIdPromise = Promise.all(param).then((param)=>{
                    return this.send("eth_subscribe", param);
                });
                this._subIds[tag] = subIdPromise;
            }
            const subId = yield subIdPromise;
            this._subs[subId] = {
                tag: tag,
                processFunc: processFunc
            };
        });
    }
    _startEvent(event) {
        switch(event.type){
            case "block":
                this._subscribe("block", [
                    "newHeads"
                ], (result)=>{
                    const blockNumber = (0, $20M69.BigNumber).from(result.number).toNumber();
                    this._emitted.block = blockNumber;
                    this.emit("block", blockNumber);
                });
                break;
            case "pending":
                this._subscribe("pending", [
                    "newPendingTransactions"
                ], (result)=>{
                    this.emit("pending", result);
                });
                break;
            case "filter":
                this._subscribe(event.tag, [
                    "logs",
                    this._getFilter(event.filter)
                ], (result)=>{
                    if (result.removed == null) result.removed = false;
                    this.emit(event.filter, this.formatter.filterLog(result));
                });
                break;
            case "tx":
                {
                    const emitReceipt = (event)=>{
                        const hash = event.hash;
                        this.getTransactionReceipt(hash).then((receipt)=>{
                            if (!receipt) return;
                            this.emit(hash, receipt);
                        });
                    };
                    // In case it is already mined
                    emitReceipt(event);
                    // To keep things simple, we start up a single newHeads subscription
                    // to keep an eye out for transactions we are watching for.
                    // Starting a subscription for an event (i.e. "tx") that is already
                    // running is (basically) a nop.
                    this._subscribe("tx", [
                        "newHeads"
                    ], (result)=>{
                        this._events.filter((e)=>e.type === "tx").forEach(emitReceipt);
                    });
                    break;
                }
            // Nothing is needed
            case "debug":
            case "poll":
            case "willPoll":
            case "didPoll":
            case "error":
                break;
            default:
                console.log("unhandled:", event);
                break;
        }
    }
    _stopEvent(event) {
        let tag = event.tag;
        if (event.type === "tx") {
            // There are remaining transaction event listeners
            if (this._events.filter((e)=>e.type === "tx").length) return;
            tag = "tx";
        } else if (this.listenerCount(event.event)) // There are remaining event listeners
        return;
        const subId = this._subIds[tag];
        if (!subId) return;
        delete this._subIds[tag];
        subId.then((subId)=>{
            if (!this._subs[subId]) return;
            delete this._subs[subId];
            this.send("eth_unsubscribe", [
                subId
            ]);
        });
    }
    destroy() {
        return $aa8fa4b2473cd497$var$__awaiter(this, void 0, void 0, function*() {
            // Wait until we have connected before trying to disconnect
            if (this.websocket.readyState === (0, $e8Tbp.WebSocket).CONNECTING) yield new Promise((resolve)=>{
                this.websocket.onopen = function() {
                    resolve(true);
                };
                this.websocket.onerror = function() {
                    resolve(false);
                };
            });
            // Hangup
            // See: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes
            this.websocket.close(1000);
        });
    }
}

});
parcelRegister("lDinN", function(module, exports) {

$parcel$export(module.exports, "JsonRpcSigner", function () { return $fbfb7ff5008f281e$export$5f7b5fca3508545a; });
$parcel$export(module.exports, "JsonRpcProvider", function () { return $fbfb7ff5008f281e$export$da28308012bf6748; });

var $glz4p = parcelRequire("glz4p");

var $20M69 = parcelRequire("20M69");

var $eBLyT = parcelRequire("eBLyT");

var $9qSpn = parcelRequire("9qSpn");

var $j0dXC = parcelRequire("j0dXC");

var $5kral = parcelRequire("5kral");

var $ABz8M = parcelRequire("ABz8M");

var $lg5bp = parcelRequire("lg5bp");

var $4NCF1 = parcelRequire("4NCF1");

var $5EnYk = parcelRequire("5EnYk");

var $ieSzc = parcelRequire("ieSzc");
"use strict";
var $fbfb7ff5008f281e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $fbfb7ff5008f281e$var$logger = new (0, $4NCF1.Logger)((0, $5EnYk.version));
const $fbfb7ff5008f281e$var$errorGas = [
    "call",
    "estimateGas"
];
function $fbfb7ff5008f281e$var$spelunk(value, requireData) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match("reverted")) {
        const data = (0, $eBLyT.isHexString)(value.data) ? value.data : null;
        if (!requireData || data) return {
            message: value.message,
            data: data
        };
    }
    // Spelunk further...
    if (typeof value === "object") {
        for(const key in value){
            const result = $fbfb7ff5008f281e$var$spelunk(value[key], requireData);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $fbfb7ff5008f281e$var$spelunk(JSON.parse(value), requireData);
    } catch (error) {}
    return null;
}
function $fbfb7ff5008f281e$var$checkError(method, error, params) {
    const transaction = params.transaction || params.signedTransaction;
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call") {
        const result = $fbfb7ff5008f281e$var$spelunk(error, true);
        if (result) return result.data;
        // Nothing descriptive..
        $fbfb7ff5008f281e$var$logger.throwError("missing revert data in call exception; Transaction reverted without a reason string", (0, $4NCF1.Logger).errors.CALL_EXCEPTION, {
            data: "0x",
            transaction: transaction,
            error: error
        });
    }
    if (method === "estimateGas") {
        // Try to find something, with a preference on SERVER_ERROR body
        let result = $fbfb7ff5008f281e$var$spelunk(error.body, false);
        if (result == null) result = $fbfb7ff5008f281e$var$spelunk(error, false);
        // Found "reverted", this is a CALL_EXCEPTION
        if (result) $fbfb7ff5008f281e$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $4NCF1.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
            reason: result.message,
            method: method,
            transaction: transaction,
            error: error
        });
    }
    // @TODO: Should we spelunk for message too?
    let message = error.message;
    if (error.code === (0, $4NCF1.Logger).errors.SERVER_ERROR && error.error && typeof error.error.message === "string") message = error.error.message;
    else if (typeof error.body === "string") message = error.body;
    else if (typeof error.responseText === "string") message = error.responseText;
    message = (message || "").toLowerCase();
    // "insufficient funds for gas * price + value + cost(data)"
    if (message.match(/insufficient funds|base fee exceeds gas limit|InsufficientFunds/i)) $fbfb7ff5008f281e$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $4NCF1.Logger).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "nonce too low"
    if (message.match(/nonce (is )?too low/i)) $fbfb7ff5008f281e$var$logger.throwError("nonce has already been used", (0, $4NCF1.Logger).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/replacement transaction underpriced|transaction gas price.*too low/i)) $fbfb7ff5008f281e$var$logger.throwError("replacement fee too low", (0, $4NCF1.Logger).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/only replay-protected/i)) $fbfb7ff5008f281e$var$logger.throwError("legacy pre-eip-155 transactions not supported", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
        error: error,
        method: method,
        transaction: transaction
    });
    if ($fbfb7ff5008f281e$var$errorGas.indexOf(method) >= 0 && message.match(/gas required exceeds allowance|always failing transaction|execution reverted|revert/)) $fbfb7ff5008f281e$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $4NCF1.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
function $fbfb7ff5008f281e$var$timer(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $fbfb7ff5008f281e$var$getResult(payload) {
    if (payload.error) {
        // @TODO: not any
        const error = new Error(payload.error.message);
        error.code = payload.error.code;
        error.data = payload.error.data;
        throw error;
    }
    return payload.result;
}
function $fbfb7ff5008f281e$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
const $fbfb7ff5008f281e$var$_constructorGuard = {};
class $fbfb7ff5008f281e$export$5f7b5fca3508545a extends (0, $glz4p.Signer) {
    constructor(constructorGuard, provider, addressOrIndex){
        super();
        if (constructorGuard !== $fbfb7ff5008f281e$var$_constructorGuard) throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
        (0, $j0dXC.defineReadOnly)(this, "provider", provider);
        if (addressOrIndex == null) addressOrIndex = 0;
        if (typeof addressOrIndex === "string") {
            (0, $j0dXC.defineReadOnly)(this, "_address", this.provider.formatter.address(addressOrIndex));
            (0, $j0dXC.defineReadOnly)(this, "_index", null);
        } else if (typeof addressOrIndex === "number") {
            (0, $j0dXC.defineReadOnly)(this, "_index", addressOrIndex);
            (0, $j0dXC.defineReadOnly)(this, "_address", null);
        } else $fbfb7ff5008f281e$var$logger.throwArgumentError("invalid address or index", "addressOrIndex", addressOrIndex);
    }
    connect(provider) {
        return $fbfb7ff5008f281e$var$logger.throwError("cannot alter JSON-RPC Signer connection", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "connect"
        });
    }
    connectUnchecked() {
        return new $fbfb7ff5008f281e$var$UncheckedJsonRpcSigner($fbfb7ff5008f281e$var$_constructorGuard, this.provider, this._address || this._index);
    }
    getAddress() {
        if (this._address) return Promise.resolve(this._address);
        return this.provider.send("eth_accounts", []).then((accounts)=>{
            if (accounts.length <= this._index) $fbfb7ff5008f281e$var$logger.throwError("unknown account #" + this._index, (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "getAddress"
            });
            return this.provider.formatter.address(accounts[this._index]);
        });
    }
    sendUncheckedTransaction(transaction) {
        transaction = (0, $j0dXC.shallowCopy)(transaction);
        const fromAddress = this.getAddress().then((address)=>{
            if (address) address = address.toLowerCase();
            return address;
        });
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (transaction.gasLimit == null) {
            const estimate = (0, $j0dXC.shallowCopy)(transaction);
            estimate.from = fromAddress;
            transaction.gasLimit = this.provider.estimateGas(estimate);
        }
        if (transaction.to != null) transaction.to = Promise.resolve(transaction.to).then((to)=>$fbfb7ff5008f281e$var$__awaiter(this, void 0, void 0, function*() {
                if (to == null) return null;
                const address = yield this.provider.resolveName(to);
                if (address == null) $fbfb7ff5008f281e$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                return address;
            }));
        return (0, $j0dXC.resolveProperties)({
            tx: (0, $j0dXC.resolveProperties)(transaction),
            sender: fromAddress
        }).then(({ tx: tx, sender: sender })=>{
            if (tx.from != null) {
                if (tx.from.toLowerCase() !== sender) $fbfb7ff5008f281e$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            } else tx.from = sender;
            const hexTx = this.provider.constructor.hexlifyTransaction(tx, {
                from: true
            });
            return this.provider.send("eth_sendTransaction", [
                hexTx
            ]).then((hash)=>{
                return hash;
            }, (error)=>{
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $fbfb7ff5008f281e$var$logger.throwError("user rejected transaction", (0, $4NCF1.Logger).errors.ACTION_REJECTED, {
                    action: "sendTransaction",
                    transaction: tx
                });
                return $fbfb7ff5008f281e$var$checkError("sendTransaction", error, hexTx);
            });
        });
    }
    signTransaction(transaction) {
        return $fbfb7ff5008f281e$var$logger.throwError("signing transactions is unsupported", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "signTransaction"
        });
    }
    sendTransaction(transaction) {
        return $fbfb7ff5008f281e$var$__awaiter(this, void 0, void 0, function*() {
            // This cannot be mined any earlier than any recent block
            const blockNumber = yield this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval);
            // Send the transaction
            const hash = yield this.sendUncheckedTransaction(transaction);
            try {
                // Unfortunately, JSON-RPC only provides and opaque transaction hash
                // for a response, and we need the actual transaction, so we poll
                // for it; it should show up very quickly
                return yield (0, $lg5bp.poll)(()=>$fbfb7ff5008f281e$var$__awaiter(this, void 0, void 0, function*() {
                        const tx = yield this.provider.getTransaction(hash);
                        if (tx === null) return undefined;
                        return this.provider._wrapTransaction(tx, hash, blockNumber);
                    }), {
                    oncePoll: this.provider
                });
            } catch (error) {
                error.transactionHash = hash;
                throw error;
            }
        });
    }
    signMessage(message) {
        return $fbfb7ff5008f281e$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $5kral.toUtf8Bytes)(message) : message;
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("personal_sign", [
                    (0, $eBLyT.hexlify)(data),
                    address.toLowerCase()
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $fbfb7ff5008f281e$var$logger.throwError("user rejected signing", (0, $4NCF1.Logger).errors.ACTION_REJECTED, {
                    action: "signMessage",
                    from: address,
                    messageData: message
                });
                throw error;
            }
        });
    }
    _legacySignMessage(message) {
        return $fbfb7ff5008f281e$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $5kral.toUtf8Bytes)(message) : message;
            const address = yield this.getAddress();
            try {
                // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
                return yield this.provider.send("eth_sign", [
                    address.toLowerCase(),
                    (0, $eBLyT.hexlify)(data)
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $fbfb7ff5008f281e$var$logger.throwError("user rejected signing", (0, $4NCF1.Logger).errors.ACTION_REJECTED, {
                    action: "_legacySignMessage",
                    from: address,
                    messageData: message
                });
                throw error;
            }
        });
    }
    _signTypedData(domain, types, value) {
        return $fbfb7ff5008f281e$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names (in-place)
            const populated = yield (0, $9qSpn.TypedDataEncoder).resolveNames(domain, types, value, (name)=>{
                return this.provider.resolveName(name);
            });
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("eth_signTypedData_v4", [
                    address.toLowerCase(),
                    JSON.stringify((0, $9qSpn.TypedDataEncoder).getPayload(populated.domain, types, populated.value))
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $fbfb7ff5008f281e$var$logger.throwError("user rejected signing", (0, $4NCF1.Logger).errors.ACTION_REJECTED, {
                    action: "_signTypedData",
                    from: address,
                    messageData: {
                        domain: populated.domain,
                        types: types,
                        value: populated.value
                    }
                });
                throw error;
            }
        });
    }
    unlock(password) {
        return $fbfb7ff5008f281e$var$__awaiter(this, void 0, void 0, function*() {
            const provider = this.provider;
            const address = yield this.getAddress();
            return provider.send("personal_unlockAccount", [
                address.toLowerCase(),
                password,
                null
            ]);
        });
    }
}
class $fbfb7ff5008f281e$var$UncheckedJsonRpcSigner extends $fbfb7ff5008f281e$export$5f7b5fca3508545a {
    sendTransaction(transaction) {
        return this.sendUncheckedTransaction(transaction).then((hash)=>{
            return {
                hash: hash,
                nonce: null,
                gasLimit: null,
                gasPrice: null,
                data: null,
                value: null,
                chainId: null,
                confirmations: 0,
                from: null,
                wait: (confirmations)=>{
                    return this.provider.waitForTransaction(hash, confirmations);
                }
            };
        });
    }
}
const $fbfb7ff5008f281e$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true
};
class $fbfb7ff5008f281e$export$da28308012bf6748 extends (0, $ieSzc.BaseProvider) {
    constructor(url, network){
        let networkOrReady = network;
        // The network is unknown, query the JSON-RPC for it
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then((network)=>{
                    resolve(network);
                }, (error)=>{
                    reject(error);
                });
            }, 0);
        });
        super(networkOrReady);
        // Default URL
        if (!url) url = (0, $j0dXC.getStatic)(this.constructor, "defaultUrl")();
        if (typeof url === "string") (0, $j0dXC.defineReadOnly)(this, "connection", Object.freeze({
            url: url
        }));
        else (0, $j0dXC.defineReadOnly)(this, "connection", Object.freeze((0, $j0dXC.shallowCopy)(url)));
        this._nextId = 42;
    }
    get _cache() {
        if (this._eventLoopCache == null) this._eventLoopCache = {};
        return this._eventLoopCache;
    }
    static defaultUrl() {
        return "http://localhost:8545";
    }
    detectNetwork() {
        if (!this._cache["detectNetwork"]) {
            this._cache["detectNetwork"] = this._uncachedDetectNetwork();
            // Clear this cache at the beginning of the next event loop
            setTimeout(()=>{
                this._cache["detectNetwork"] = null;
            }, 0);
        }
        return this._cache["detectNetwork"];
    }
    _uncachedDetectNetwork() {
        return $fbfb7ff5008f281e$var$__awaiter(this, void 0, void 0, function*() {
            yield $fbfb7ff5008f281e$var$timer(0);
            let chainId = null;
            try {
                chainId = yield this.send("eth_chainId", []);
            } catch (error) {
                try {
                    chainId = yield this.send("net_version", []);
                } catch (error) {}
            }
            if (chainId != null) {
                const getNetwork = (0, $j0dXC.getStatic)(this.constructor, "getNetwork");
                try {
                    return getNetwork((0, $20M69.BigNumber).from(chainId).toNumber());
                } catch (error) {
                    return $fbfb7ff5008f281e$var$logger.throwError("could not detect network", (0, $4NCF1.Logger).errors.NETWORK_ERROR, {
                        chainId: chainId,
                        event: "invalidNetwork",
                        serverError: error
                    });
                }
            }
            return $fbfb7ff5008f281e$var$logger.throwError("could not detect network", (0, $4NCF1.Logger).errors.NETWORK_ERROR, {
                event: "noNetwork"
            });
        });
    }
    getSigner(addressOrIndex) {
        return new $fbfb7ff5008f281e$export$5f7b5fca3508545a($fbfb7ff5008f281e$var$_constructorGuard, this, addressOrIndex);
    }
    getUncheckedSigner(addressOrIndex) {
        return this.getSigner(addressOrIndex).connectUnchecked();
    }
    listAccounts() {
        return this.send("eth_accounts", []).then((accounts)=>{
            return accounts.map((a)=>this.formatter.address(a));
        });
    }
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        this.emit("debug", {
            action: "request",
            request: (0, $j0dXC.deepCopy)(request),
            provider: this
        });
        // We can expand this in the future to any call, but for now these
        // are the biggest wins and do not require any serializing parameters.
        const cache = [
            "eth_chainId",
            "eth_blockNumber"
        ].indexOf(method) >= 0;
        if (cache && this._cache[method]) return this._cache[method];
        const result = (0, $lg5bp.fetchJson)(this.connection, JSON.stringify(request), $fbfb7ff5008f281e$var$getResult).then((result)=>{
            this.emit("debug", {
                action: "response",
                request: request,
                response: result,
                provider: this
            });
            return result;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                error: error,
                request: request,
                provider: this
            });
            throw error;
        });
        // Cache the fetch, but clear it on the next event loop
        if (cache) {
            this._cache[method] = result;
            setTimeout(()=>{
                this._cache[method] = null;
            }, 0);
        }
        return result;
    }
    prepareRequest(method, params) {
        switch(method){
            case "getBlockNumber":
                return [
                    "eth_blockNumber",
                    []
                ];
            case "getGasPrice":
                return [
                    "eth_gasPrice",
                    []
                ];
            case "getBalance":
                return [
                    "eth_getBalance",
                    [
                        $fbfb7ff5008f281e$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getTransactionCount":
                return [
                    "eth_getTransactionCount",
                    [
                        $fbfb7ff5008f281e$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getCode":
                return [
                    "eth_getCode",
                    [
                        $fbfb7ff5008f281e$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getStorageAt":
                return [
                    "eth_getStorageAt",
                    [
                        $fbfb7ff5008f281e$var$getLowerCase(params.address),
                        (0, $eBLyT.hexZeroPad)(params.position, 32),
                        params.blockTag
                    ]
                ];
            case "sendTransaction":
                return [
                    "eth_sendRawTransaction",
                    [
                        params.signedTransaction
                    ]
                ];
            case "getBlock":
                if (params.blockTag) return [
                    "eth_getBlockByNumber",
                    [
                        params.blockTag,
                        !!params.includeTransactions
                    ]
                ];
                else if (params.blockHash) return [
                    "eth_getBlockByHash",
                    [
                        params.blockHash,
                        !!params.includeTransactions
                    ]
                ];
                return null;
            case "getTransaction":
                return [
                    "eth_getTransactionByHash",
                    [
                        params.transactionHash
                    ]
                ];
            case "getTransactionReceipt":
                return [
                    "eth_getTransactionReceipt",
                    [
                        params.transactionHash
                    ]
                ];
            case "call":
                {
                    const hexlifyTransaction = (0, $j0dXC.getStatic)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_call",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            }),
                            params.blockTag
                        ]
                    ];
                }
            case "estimateGas":
                {
                    const hexlifyTransaction = (0, $j0dXC.getStatic)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_estimateGas",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            })
                        ]
                    ];
                }
            case "getLogs":
                if (params.filter && params.filter.address != null) params.filter.address = $fbfb7ff5008f281e$var$getLowerCase(params.filter.address);
                return [
                    "eth_getLogs",
                    [
                        params.filter
                    ]
                ];
            default:
                break;
        }
        return null;
    }
    perform(method, params) {
        return $fbfb7ff5008f281e$var$__awaiter(this, void 0, void 0, function*() {
            // Legacy networks do not like the type field being passed along (which
            // is fair), so we delete type if it is 0 and a non-EIP-1559 network
            if (method === "call" || method === "estimateGas") {
                const tx = params.transaction;
                if (tx && tx.type != null && (0, $20M69.BigNumber).from(tx.type).isZero()) // If there are no EIP-1559 properties, it might be non-EIP-1559
                {
                    if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                        const feeData = yield this.getFeeData();
                        if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) {
                            // Network doesn't know about EIP-1559 (and hence type)
                            params = (0, $j0dXC.shallowCopy)(params);
                            params.transaction = (0, $j0dXC.shallowCopy)(tx);
                            delete params.transaction.type;
                        }
                    }
                }
            }
            const args = this.prepareRequest(method, params);
            if (args == null) $fbfb7ff5008f281e$var$logger.throwError(method + " not implemented", (0, $4NCF1.Logger).errors.NOT_IMPLEMENTED, {
                operation: method
            });
            try {
                return yield this.send(args[0], args[1]);
            } catch (error) {
                return $fbfb7ff5008f281e$var$checkError(method, error, params);
            }
        });
    }
    _startEvent(event) {
        if (event.tag === "pending") this._startPending();
        super._startEvent(event);
    }
    _startPending() {
        if (this._pendingFilter != null) return;
        const self = this;
        const pendingFilter = this.send("eth_newPendingTransactionFilter", []);
        this._pendingFilter = pendingFilter;
        pendingFilter.then(function(filterId) {
            function poll() {
                self.send("eth_getFilterChanges", [
                    filterId
                ]).then(function(hashes) {
                    if (self._pendingFilter != pendingFilter) return null;
                    let seq = Promise.resolve();
                    hashes.forEach(function(hash) {
                        // @TODO: This should be garbage collected at some point... How? When?
                        self._emitted["t:" + hash.toLowerCase()] = "pending";
                        seq = seq.then(function() {
                            return self.getTransaction(hash).then(function(tx) {
                                self.emit("pending", tx);
                                return null;
                            });
                        });
                    });
                    return seq.then(function() {
                        return $fbfb7ff5008f281e$var$timer(1000);
                    });
                }).then(function() {
                    if (self._pendingFilter != pendingFilter) {
                        self.send("eth_uninstallFilter", [
                            filterId
                        ]);
                        return;
                    }
                    setTimeout(function() {
                        poll();
                    }, 0);
                    return null;
                }).catch((error)=>{});
            }
            poll();
            return filterId;
        }).catch((error)=>{});
    }
    _stopEvent(event) {
        if (event.tag === "pending" && this.listenerCount("pending") === 0) this._pendingFilter = null;
        super._stopEvent(event);
    }
    // Convert an ethers.js transaction into a JSON-RPC transaction
    //  - gasLimit => gas
    //  - All values hexlified
    //  - All numeric values zero-striped
    //  - All addresses are lowercased
    // NOTE: This allows a TransactionRequest, but all values should be resolved
    //       before this is called
    // @TODO: This will likely be removed in future versions and prepareRequest
    //        will be the preferred method for this.
    static hexlifyTransaction(transaction, allowExtra) {
        // Check only allowed properties are given
        const allowed = (0, $j0dXC.shallowCopy)($fbfb7ff5008f281e$var$allowedTransactionKeys);
        if (allowExtra) {
            for(const key in allowExtra)if (allowExtra[key]) allowed[key] = true;
        }
        (0, $j0dXC.checkProperties)(transaction, allowed);
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        [
            "chainId",
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            const value = (0, $eBLyT.hexValue)((0, $20M69.BigNumber).from(transaction[key]));
            if (key === "gasLimit") key = "gas";
            result[key] = value;
        });
        [
            "from",
            "to",
            "data"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            result[key] = (0, $eBLyT.hexlify)(transaction[key]);
        });
        if (transaction.accessList) result["accessList"] = (0, $ABz8M.accessListify)(transaction.accessList);
        return result;
    }
}

});

parcelRegister("e8Tbp", function(module, exports) {

$parcel$export(module.exports, "WebSocket", function () { return $a4bc9e3d66879410$export$3909fb301d3dc8c9; });

var $4NCF1 = parcelRequire("4NCF1");

var $5EnYk = parcelRequire("5EnYk");
"use strict";
let $a4bc9e3d66879410$export$3909fb301d3dc8c9 = null;
try {
    $a4bc9e3d66879410$export$3909fb301d3dc8c9 = WebSocket;
    if ($a4bc9e3d66879410$export$3909fb301d3dc8c9 == null) throw new Error("inject please");
} catch (error) {
    const logger = new (0, $4NCF1.Logger)((0, $5EnYk.version));
    $a4bc9e3d66879410$export$3909fb301d3dc8c9 = function() {
        logger.throwError("WebSockets not supported in this environment", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new WebSocket()"
        });
    };
}

});


parcelRegister("6QpjG", function(module, exports) {

$parcel$export(module.exports, "StaticJsonRpcProvider", function () { return $4fbb3cb936505777$export$b3d647c1c29df44d; });
$parcel$export(module.exports, "UrlJsonRpcProvider", function () { return $4fbb3cb936505777$export$664128d6239ccf96; });

var $j0dXC = parcelRequire("j0dXC");

var $4NCF1 = parcelRequire("4NCF1");

var $5EnYk = parcelRequire("5EnYk");

var $lDinN = parcelRequire("lDinN");
"use strict";
var $4fbb3cb936505777$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $4fbb3cb936505777$var$logger = new (0, $4NCF1.Logger)((0, $5EnYk.version));
class $4fbb3cb936505777$export$b3d647c1c29df44d extends (0, $lDinN.JsonRpcProvider) {
    detectNetwork() {
        const _super = Object.create(null, {
            detectNetwork: {
                get: ()=>super.detectNetwork
            }
        });
        return $4fbb3cb936505777$var$__awaiter(this, void 0, void 0, function*() {
            let network = this.network;
            if (network == null) {
                network = yield _super.detectNetwork.call(this);
                if (!network) $4fbb3cb936505777$var$logger.throwError("no network detected", (0, $4NCF1.Logger).errors.UNKNOWN_ERROR, {});
                // If still not set, set it
                if (this._network == null) {
                    // A static network does not support "any"
                    (0, $j0dXC.defineReadOnly)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return network;
        });
    }
}
class $4fbb3cb936505777$export$664128d6239ccf96 extends $4fbb3cb936505777$export$b3d647c1c29df44d {
    constructor(network, apiKey){
        $4fbb3cb936505777$var$logger.checkAbstract(new.target, $4fbb3cb936505777$export$664128d6239ccf96);
        // Normalize the Network and API Key
        network = (0, $j0dXC.getStatic)(new.target, "getNetwork")(network);
        apiKey = (0, $j0dXC.getStatic)(new.target, "getApiKey")(apiKey);
        const connection = (0, $j0dXC.getStatic)(new.target, "getUrl")(network, apiKey);
        super(connection, network);
        if (typeof apiKey === "string") (0, $j0dXC.defineReadOnly)(this, "apiKey", apiKey);
        else if (apiKey != null) Object.keys(apiKey).forEach((key)=>{
            (0, $j0dXC.defineReadOnly)(this, key, apiKey[key]);
        });
    }
    _startPending() {
        $4fbb3cb936505777$var$logger.warn("WARNING: API provider does not support pending filters");
    }
    isCommunityResource() {
        return false;
    }
    getSigner(address) {
        return $4fbb3cb936505777$var$logger.throwError("API provider does not support signing", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "getSigner"
        });
    }
    listAccounts() {
        return Promise.resolve([]);
    }
    // Return a defaultApiKey if null, otherwise validate the API key
    static getApiKey(apiKey) {
        return apiKey;
    }
    // Returns the url or connection for the given network and API key. The
    // API key will have been sanitized by the getApiKey first, so any validation
    // or transformations can be done there.
    static getUrl(network, apiKey) {
        return $4fbb3cb936505777$var$logger.throwError("not implemented; sub-classes must override getUrl", (0, $4NCF1.Logger).errors.NOT_IMPLEMENTED, {
            operation: "getUrl"
        });
    }
}

});


parcelRegister("doBXu", function(module, exports) {

$parcel$export(module.exports, "AnkrProvider", function () { return $9c0af6002a1d636b$export$72783b2aefa72a45; });

var $iUcRi = parcelRequire("iUcRi");

var $6QpjG = parcelRequire("6QpjG");

var $4NCF1 = parcelRequire("4NCF1");

var $5EnYk = parcelRequire("5EnYk");
const $9c0af6002a1d636b$var$logger = new (0, $4NCF1.Logger)((0, $5EnYk.version));
const $9c0af6002a1d636b$var$defaultApiKey = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
function $9c0af6002a1d636b$var$getHost(name) {
    switch(name){
        case "homestead":
            return "rpc.ankr.com/eth/";
        case "ropsten":
            return "rpc.ankr.com/eth_ropsten/";
        case "rinkeby":
            return "rpc.ankr.com/eth_rinkeby/";
        case "goerli":
            return "rpc.ankr.com/eth_goerli/";
        case "matic":
            return "rpc.ankr.com/polygon/";
        case "arbitrum":
            return "rpc.ankr.com/arbitrum/";
    }
    return $9c0af6002a1d636b$var$logger.throwArgumentError("unsupported network", "name", name);
}
class $9c0af6002a1d636b$export$72783b2aefa72a45 extends (0, $6QpjG.UrlJsonRpcProvider) {
    isCommunityResource() {
        return this.apiKey === $9c0af6002a1d636b$var$defaultApiKey;
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $9c0af6002a1d636b$var$defaultApiKey;
        return apiKey;
    }
    static getUrl(network, apiKey) {
        if (apiKey == null) apiKey = $9c0af6002a1d636b$var$defaultApiKey;
        const connection = {
            allowGzip: true,
            url: "https://" + $9c0af6002a1d636b$var$getHost(network.name) + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey.apiKey === $9c0af6002a1d636b$var$defaultApiKey) (0, $iUcRi.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
}

});

parcelRegister("4PkQF", function(module, exports) {

$parcel$export(module.exports, "CloudflareProvider", function () { return $383c18eadea68a63$export$7113381f8f264fc0; });

var $6QpjG = parcelRequire("6QpjG");

var $4NCF1 = parcelRequire("4NCF1");

var $5EnYk = parcelRequire("5EnYk");
"use strict";
var $383c18eadea68a63$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $383c18eadea68a63$var$logger = new (0, $4NCF1.Logger)((0, $5EnYk.version));
class $383c18eadea68a63$export$7113381f8f264fc0 extends (0, $6QpjG.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        if (apiKey != null) $383c18eadea68a63$var$logger.throwArgumentError("apiKey not supported for cloudflare", "apiKey", apiKey);
        return null;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://cloudflare-eth.com/";
                break;
            default:
                $383c18eadea68a63$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host;
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $383c18eadea68a63$var$__awaiter(this, void 0, void 0, function*() {
            // The Cloudflare provider does not support eth_blockNumber,
            // so we get the latest block and pull it from that
            if (method === "getBlockNumber") {
                const block = yield _super.perform.call(this, "getBlock", {
                    blockTag: "latest"
                });
                return block.number;
            }
            return _super.perform.call(this, method, params);
        });
    }
}

});

parcelRegister("aL8Ez", function(module, exports) {

$parcel$export(module.exports, "EtherscanProvider", function () { return $7d55018aef93e9b0$export$dd1d942a536c7912; });

var $eBLyT = parcelRequire("eBLyT");

var $j0dXC = parcelRequire("j0dXC");

var $ABz8M = parcelRequire("ABz8M");

var $lg5bp = parcelRequire("lg5bp");

var $iUcRi = parcelRequire("iUcRi");

var $4NCF1 = parcelRequire("4NCF1");

var $5EnYk = parcelRequire("5EnYk");

var $ieSzc = parcelRequire("ieSzc");
"use strict";
var $7d55018aef93e9b0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $7d55018aef93e9b0$var$logger = new (0, $4NCF1.Logger)((0, $5EnYk.version));
// The transaction has already been sanitized by the calls in Provider
function $7d55018aef93e9b0$var$getTransactionPostData(transaction) {
    const result = {};
    for(let key in transaction){
        if (transaction[key] == null) continue;
        let value = transaction[key];
        if (key === "type" && value === 0) continue;
        // Quantity-types require no leading zero, unless 0
        if (({
            type: true,
            gasLimit: true,
            gasPrice: true,
            maxFeePerGs: true,
            maxPriorityFeePerGas: true,
            nonce: true,
            value: true
        })[key]) value = (0, $eBLyT.hexValue)((0, $eBLyT.hexlify)(value));
        else if (key === "accessList") value = "[" + (0, $ABz8M.accessListify)(value).map((set)=>{
            return `{address:"${set.address}",storageKeys:["${set.storageKeys.join('","')}"]}`;
        }).join(",") + "]";
        else value = (0, $eBLyT.hexlify)(value);
        result[key] = value;
    }
    return result;
}
function $7d55018aef93e9b0$var$getResult(result) {
    // getLogs, getHistory have weird success responses
    if (result.status == 0 && (result.message === "No records found" || result.message === "No transactions found")) return result.result;
    if (result.status != 1 || typeof result.message !== "string" || !result.message.match(/^OK/)) {
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        if ((result.result || "").toLowerCase().indexOf("rate limit") >= 0) error.throttleRetry = true;
        throw error;
    }
    return result.result;
}
function $7d55018aef93e9b0$var$getJsonResult(result) {
    // This response indicates we are being throttled
    if (result && result.status == 0 && result.message == "NOTOK" && (result.result || "").toLowerCase().indexOf("rate limit") >= 0) {
        const error = new Error("throttled response");
        error.result = JSON.stringify(result);
        error.throttleRetry = true;
        throw error;
    }
    if (result.jsonrpc != "2.0") {
        // @TODO: not any
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        throw error;
    }
    if (result.error) {
        // @TODO: not any
        const error = new Error(result.error.message || "unknown error");
        if (result.error.code) error.code = result.error.code;
        if (result.error.data) error.data = result.error.data;
        throw error;
    }
    return result.result;
}
// The blockTag was normalized as a string by the Provider pre-perform operations
function $7d55018aef93e9b0$var$checkLogTag(blockTag) {
    if (blockTag === "pending") throw new Error("pending not supported");
    if (blockTag === "latest") return blockTag;
    return parseInt(blockTag.substring(2), 16);
}
function $7d55018aef93e9b0$var$checkError(method, error, transaction) {
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call" && error.code === (0, $4NCF1.Logger).errors.SERVER_ERROR) {
        const e = error.error;
        // Etherscan keeps changing their string
        if (e && (e.message.match(/reverted/i) || e.message.match(/VM execution error/i))) {
            // Etherscan prefixes the data like "Reverted 0x1234"
            let data = e.data;
            if (data) data = "0x" + data.replace(/^.*0x/i, "");
            if ((0, $eBLyT.isHexString)(data)) return data;
            $7d55018aef93e9b0$var$logger.throwError("missing revert data in call exception", (0, $4NCF1.Logger).errors.CALL_EXCEPTION, {
                error: error,
                data: "0x"
            });
        }
    }
    // Get the message from any nested error structure
    let message = error.message;
    if (error.code === (0, $4NCF1.Logger).errors.SERVER_ERROR) {
        if (error.error && typeof error.error.message === "string") message = error.error.message;
        else if (typeof error.body === "string") message = error.body;
        else if (typeof error.responseText === "string") message = error.responseText;
    }
    message = (message || "").toLowerCase();
    // "Insufficient funds. The account you tried to send transaction from does not have enough funds. Required 21464000000000 and got: 0"
    if (message.match(/insufficient funds/)) $7d55018aef93e9b0$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $4NCF1.Logger).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction with the same hash was already imported."
    if (message.match(/same hash was already imported|transaction nonce is too low|nonce too low/)) $7d55018aef93e9b0$var$logger.throwError("nonce has already been used", (0, $4NCF1.Logger).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction gas price is too low. There is another transaction with same nonce in the queue. Try increasing the gas price or incrementing the nonce."
    if (message.match(/another transaction with same nonce/)) $7d55018aef93e9b0$var$logger.throwError("replacement fee too low", (0, $4NCF1.Logger).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    if (message.match(/execution failed due to an exception|execution reverted/)) $7d55018aef93e9b0$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $4NCF1.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
class $7d55018aef93e9b0$export$dd1d942a536c7912 extends (0, $ieSzc.BaseProvider) {
    constructor(network, apiKey){
        super(network);
        (0, $j0dXC.defineReadOnly)(this, "baseUrl", this.getBaseUrl());
        (0, $j0dXC.defineReadOnly)(this, "apiKey", apiKey || null);
    }
    getBaseUrl() {
        switch(this.network ? this.network.name : "invalid"){
            case "homestead":
                return "https://api.etherscan.io";
            case "goerli":
                return "https://api-goerli.etherscan.io";
            case "sepolia":
                return "https://api-sepolia.etherscan.io";
            case "matic":
                return "https://api.polygonscan.com";
            case "maticmum":
                return "https://api-testnet.polygonscan.com";
            case "arbitrum":
                return "https://api.arbiscan.io";
            case "arbitrum-goerli":
                return "https://api-goerli.arbiscan.io";
            case "optimism":
                return "https://api-optimistic.etherscan.io";
            case "optimism-goerli":
                return "https://api-goerli-optimistic.etherscan.io";
            default:
        }
        return $7d55018aef93e9b0$var$logger.throwArgumentError("unsupported network", "network", this.network.name);
    }
    getUrl(module, params) {
        const query = Object.keys(params).reduce((accum, key)=>{
            const value = params[key];
            if (value != null) accum += `&${key}=${value}`;
            return accum;
        }, "");
        const apiKey = this.apiKey ? `&apikey=${this.apiKey}` : "";
        return `${this.baseUrl}/api?module=${module}${query}${apiKey}`;
    }
    getPostUrl() {
        return `${this.baseUrl}/api`;
    }
    getPostData(module, params) {
        params.module = module;
        params.apikey = this.apiKey;
        return params;
    }
    fetch(module, params, post) {
        return $7d55018aef93e9b0$var$__awaiter(this, void 0, void 0, function*() {
            const url = post ? this.getPostUrl() : this.getUrl(module, params);
            const payload = post ? this.getPostData(module, params) : null;
            const procFunc = module === "proxy" ? $7d55018aef93e9b0$var$getJsonResult : $7d55018aef93e9b0$var$getResult;
            this.emit("debug", {
                action: "request",
                request: url,
                provider: this
            });
            const connection = {
                url: url,
                throttleSlotInterval: 1000,
                throttleCallback: (attempt, url)=>{
                    if (this.isCommunityResource()) (0, $iUcRi.showThrottleMessage)();
                    return Promise.resolve(true);
                }
            };
            let payloadStr = null;
            if (payload) {
                connection.headers = {
                    "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
                };
                payloadStr = Object.keys(payload).map((key)=>{
                    return `${key}=${payload[key]}`;
                }).join("&");
            }
            const result = yield (0, $lg5bp.fetchJson)(connection, payloadStr, procFunc || $7d55018aef93e9b0$var$getJsonResult);
            this.emit("debug", {
                action: "response",
                request: url,
                response: (0, $j0dXC.deepCopy)(result),
                provider: this
            });
            return result;
        });
    }
    detectNetwork() {
        return $7d55018aef93e9b0$var$__awaiter(this, void 0, void 0, function*() {
            return this.network;
        });
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $7d55018aef93e9b0$var$__awaiter(this, void 0, void 0, function*() {
            switch(method){
                case "getBlockNumber":
                    return this.fetch("proxy", {
                        action: "eth_blockNumber"
                    });
                case "getGasPrice":
                    return this.fetch("proxy", {
                        action: "eth_gasPrice"
                    });
                case "getBalance":
                    // Returns base-10 result
                    return this.fetch("account", {
                        action: "balance",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getTransactionCount":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionCount",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getCode":
                    return this.fetch("proxy", {
                        action: "eth_getCode",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getStorageAt":
                    return this.fetch("proxy", {
                        action: "eth_getStorageAt",
                        address: params.address,
                        position: params.position,
                        tag: params.blockTag
                    });
                case "sendTransaction":
                    return this.fetch("proxy", {
                        action: "eth_sendRawTransaction",
                        hex: params.signedTransaction
                    }, true).catch((error)=>{
                        return $7d55018aef93e9b0$var$checkError("sendTransaction", error, params.signedTransaction);
                    });
                case "getBlock":
                    if (params.blockTag) return this.fetch("proxy", {
                        action: "eth_getBlockByNumber",
                        tag: params.blockTag,
                        boolean: params.includeTransactions ? "true" : "false"
                    });
                    throw new Error("getBlock by blockHash not implemented");
                case "getTransaction":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionByHash",
                        txhash: params.transactionHash
                    });
                case "getTransactionReceipt":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionReceipt",
                        txhash: params.transactionHash
                    });
                case "call":
                    {
                        if (params.blockTag !== "latest") throw new Error("EtherscanProvider does not support blockTag for call");
                        const postData = $7d55018aef93e9b0$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_call";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $7d55018aef93e9b0$var$checkError("call", error, params.transaction);
                        }
                    }
                case "estimateGas":
                    {
                        const postData = $7d55018aef93e9b0$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_estimateGas";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $7d55018aef93e9b0$var$checkError("estimateGas", error, params.transaction);
                        }
                    }
                case "getLogs":
                    {
                        const args = {
                            action: "getLogs"
                        };
                        if (params.filter.fromBlock) args.fromBlock = $7d55018aef93e9b0$var$checkLogTag(params.filter.fromBlock);
                        if (params.filter.toBlock) args.toBlock = $7d55018aef93e9b0$var$checkLogTag(params.filter.toBlock);
                        if (params.filter.address) args.address = params.filter.address;
                        // @TODO: We can handle slightly more complicated logs using the logs API
                        if (params.filter.topics && params.filter.topics.length > 0) {
                            if (params.filter.topics.length > 1) $7d55018aef93e9b0$var$logger.throwError("unsupported topic count", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                                topics: params.filter.topics
                            });
                            if (params.filter.topics.length === 1) {
                                const topic0 = params.filter.topics[0];
                                if (typeof topic0 !== "string" || topic0.length !== 66) $7d55018aef93e9b0$var$logger.throwError("unsupported topic format", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
                                    topic0: topic0
                                });
                                args.topic0 = topic0;
                            }
                        }
                        const logs = yield this.fetch("logs", args);
                        // Cache txHash => blockHash
                        let blocks = {};
                        // Add any missing blockHash to the logs
                        for(let i = 0; i < logs.length; i++){
                            const log = logs[i];
                            if (log.blockHash != null) continue;
                            if (blocks[log.blockNumber] == null) {
                                const block = yield this.getBlock(log.blockNumber);
                                if (block) blocks[log.blockNumber] = block.hash;
                            }
                            log.blockHash = blocks[log.blockNumber];
                        }
                        return logs;
                    }
                case "getEtherPrice":
                    if (this.network.name !== "homestead") return 0.0;
                    return parseFloat((yield this.fetch("stats", {
                        action: "ethprice"
                    })).ethusd);
                default:
                    break;
            }
            return _super.perform.call(this, method, params);
        });
    }
    // Note: The `page` page parameter only allows pagination within the
    //       10,000 window available without a page and offset parameter
    //       Error: Result window is too large, PageNo x Offset size must
    //              be less than or equal to 10000
    getHistory(addressOrName, startBlock, endBlock) {
        return $7d55018aef93e9b0$var$__awaiter(this, void 0, void 0, function*() {
            const params = {
                action: "txlist",
                address: yield this.resolveName(addressOrName),
                startblock: startBlock == null ? 0 : startBlock,
                endblock: endBlock == null ? 99999999 : endBlock,
                sort: "asc"
            };
            const result = yield this.fetch("account", params);
            return result.map((tx)=>{
                [
                    "contractAddress",
                    "to"
                ].forEach(function(key) {
                    if (tx[key] == "") delete tx[key];
                });
                if (tx.creates == null && tx.contractAddress != null) tx.creates = tx.contractAddress;
                const item = this.formatter.transactionResponse(tx);
                if (tx.timeStamp) item.timestamp = parseInt(tx.timeStamp);
                return item;
            });
        });
    }
    isCommunityResource() {
        return this.apiKey == null;
    }
}

});

parcelRegister("3cIU7", function(module, exports) {

$parcel$export(module.exports, "FallbackProvider", function () { return $2555531e7ae71ede$export$cb1d0beacb55feb7; });

var $lOWlX = parcelRequire("lOWlX");

var $20M69 = parcelRequire("20M69");

var $eBLyT = parcelRequire("eBLyT");

var $j0dXC = parcelRequire("j0dXC");

var $a6YDT = parcelRequire("a6YDT");

var $lg5bp = parcelRequire("lg5bp");

var $ieSzc = parcelRequire("ieSzc");

var $iUcRi = parcelRequire("iUcRi");

var $4NCF1 = parcelRequire("4NCF1");

var $5EnYk = parcelRequire("5EnYk");
"use strict";
var $2555531e7ae71ede$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $2555531e7ae71ede$var$logger = new (0, $4NCF1.Logger)((0, $5EnYk.version));
function $2555531e7ae71ede$var$now() {
    return new Date().getTime();
}
// Returns to network as long as all agree, or null if any is null.
// Throws an error if any two networks do not match.
function $2555531e7ae71ede$var$checkNetworks(networks) {
    let result = null;
    for(let i = 0; i < networks.length; i++){
        const network = networks[i];
        // Null! We do not know our network; bail.
        if (network == null) return null;
        if (result) // Make sure the network matches the previous networks
        {
            if (!(result.name === network.name && result.chainId === network.chainId && (result.ensAddress === network.ensAddress || result.ensAddress == null && network.ensAddress == null))) $2555531e7ae71ede$var$logger.throwArgumentError("provider mismatch", "networks", networks);
        } else result = network;
    }
    return result;
}
function $2555531e7ae71ede$var$median(values, maxDelta) {
    values = values.slice().sort();
    const middle = Math.floor(values.length / 2);
    // Odd length; take the middle
    if (values.length % 2) return values[middle];
    // Even length; take the average of the two middle
    const a = values[middle - 1], b = values[middle];
    if (maxDelta != null && Math.abs(a - b) > maxDelta) return null;
    return (a + b) / 2;
}
function $2555531e7ae71ede$var$serialize(value) {
    if (value === null) return "null";
    else if (typeof value === "number" || typeof value === "boolean") return JSON.stringify(value);
    else if (typeof value === "string") return value;
    else if ((0, $20M69.BigNumber).isBigNumber(value)) return value.toString();
    else if (Array.isArray(value)) return JSON.stringify(value.map((i)=>$2555531e7ae71ede$var$serialize(i)));
    else if (typeof value === "object") {
        const keys = Object.keys(value);
        keys.sort();
        return "{" + keys.map((key)=>{
            let v = value[key];
            if (typeof v === "function") v = "[function]";
            else v = $2555531e7ae71ede$var$serialize(v);
            return JSON.stringify(key) + ":" + v;
        }).join(",") + "}";
    }
    throw new Error("unknown value type: " + typeof value);
}
// Next request ID to use for emitting debug info
let $2555531e7ae71ede$var$nextRid = 1;
function $2555531e7ae71ede$var$stall(duration) {
    let cancel = null;
    let timer = null;
    let promise = new Promise((resolve)=>{
        cancel = function() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            resolve();
        };
        timer = setTimeout(cancel, duration);
    });
    const wait = (func)=>{
        promise = promise.then(func);
        return promise;
    };
    function getPromise() {
        return promise;
    }
    return {
        cancel: cancel,
        getPromise: getPromise,
        wait: wait
    };
}
const $2555531e7ae71ede$var$ForwardErrors = [
    (0, $4NCF1.Logger).errors.CALL_EXCEPTION,
    (0, $4NCF1.Logger).errors.INSUFFICIENT_FUNDS,
    (0, $4NCF1.Logger).errors.NONCE_EXPIRED,
    (0, $4NCF1.Logger).errors.REPLACEMENT_UNDERPRICED,
    (0, $4NCF1.Logger).errors.UNPREDICTABLE_GAS_LIMIT
];
const $2555531e7ae71ede$var$ForwardProperties = [
    "address",
    "args",
    "errorArgs",
    "errorSignature",
    "method",
    "transaction"
];
function $2555531e7ae71ede$var$exposeDebugConfig(config, now) {
    const result = {
        weight: config.weight
    };
    Object.defineProperty(result, "provider", {
        get: ()=>config.provider
    });
    if (config.start) result.start = config.start;
    if (now) result.duration = now - config.start;
    if (config.done) {
        if (config.error) result.error = config.error;
        else result.result = config.result || null;
    }
    return result;
}
function $2555531e7ae71ede$var$normalizedTally(normalize, quorum) {
    return function(configs) {
        // Count the votes for each result
        const tally = {};
        configs.forEach((c)=>{
            const value = normalize(c.result);
            if (!tally[value]) tally[value] = {
                count: 0,
                result: c.result
            };
            tally[value].count++;
        });
        // Check for a quorum on any given result
        const keys = Object.keys(tally);
        for(let i = 0; i < keys.length; i++){
            const check = tally[keys[i]];
            if (check.count >= quorum) return check.result;
        }
        // No quroum
        return undefined;
    };
}
function $2555531e7ae71ede$var$getProcessFunc(provider, method, params) {
    let normalize = $2555531e7ae71ede$var$serialize;
    switch(method){
        case "getBlockNumber":
            // Return the median value, unless there is (median + 1) is also
            // present, in which case that is probably true and the median
            // is going to be stale soon. In the event of a malicious node,
            // the lie will be true soon enough.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                // Get the median block number
                let blockNumber = $2555531e7ae71ede$var$median(configs.map((c)=>c.result), 2);
                if (blockNumber == null) return undefined;
                blockNumber = Math.ceil(blockNumber);
                // If the next block height is present, its prolly safe to use
                if (values.indexOf(blockNumber + 1) >= 0) blockNumber++;
                // Don't ever roll back the blockNumber
                if (blockNumber >= provider._highestBlockNumber) provider._highestBlockNumber = blockNumber;
                return provider._highestBlockNumber;
            };
        case "getGasPrice":
            // Return the middle (round index up) value, similar to median
            // but do not average even entries and choose the higher.
            // Malicious actors must compromise 50% of the nodes to lie.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                values.sort();
                return values[Math.floor(values.length / 2)];
            };
        case "getEtherPrice":
            // Returns the median price. Malicious actors must compromise at
            // least 50% of the nodes to lie (in a meaningful way).
            return function(configs) {
                return $2555531e7ae71ede$var$median(configs.map((c)=>c.result));
            };
        // No additional normalizing required; serialize is enough
        case "getBalance":
        case "getTransactionCount":
        case "getCode":
        case "getStorageAt":
        case "call":
        case "estimateGas":
        case "getLogs":
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getTransaction":
        case "getTransactionReceipt":
            normalize = function(tx) {
                if (tx == null) return null;
                tx = (0, $j0dXC.shallowCopy)(tx);
                tx.confirmations = -1;
                return $2555531e7ae71ede$var$serialize(tx);
            };
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getBlock":
            // We drop the confirmations from transactions as it is approximate
            if (params.includeTransactions) normalize = function(block) {
                if (block == null) return null;
                block = (0, $j0dXC.shallowCopy)(block);
                block.transactions = block.transactions.map((tx)=>{
                    tx = (0, $j0dXC.shallowCopy)(tx);
                    tx.confirmations = -1;
                    return tx;
                });
                return $2555531e7ae71ede$var$serialize(block);
            };
            else normalize = function(block) {
                if (block == null) return null;
                return $2555531e7ae71ede$var$serialize(block);
            };
            break;
        default:
            throw new Error("unknown method: " + method);
    }
    // Return the result if and only if the expected quorum is
    // satisfied and agreed upon for the final result.
    return $2555531e7ae71ede$var$normalizedTally(normalize, provider.quorum);
}
// If we are doing a blockTag query, we need to make sure the backend is
// caught up to the FallbackProvider, before sending a request to it.
function $2555531e7ae71ede$var$waitForSync(config, blockNumber) {
    return $2555531e7ae71ede$var$__awaiter(this, void 0, void 0, function*() {
        const provider = config.provider;
        if (provider.blockNumber != null && provider.blockNumber >= blockNumber || blockNumber === -1) return provider;
        return (0, $lg5bp.poll)(()=>{
            return new Promise((resolve, reject)=>{
                setTimeout(function() {
                    // We are synced
                    if (provider.blockNumber >= blockNumber) return resolve(provider);
                    // We're done; just quit
                    if (config.cancelled) return resolve(null);
                    // Try again, next block
                    return resolve(undefined);
                }, 0);
            });
        }, {
            oncePoll: provider
        });
    });
}
function $2555531e7ae71ede$var$getRunner(config, currentBlockNumber, method, params) {
    return $2555531e7ae71ede$var$__awaiter(this, void 0, void 0, function*() {
        let provider = config.provider;
        switch(method){
            case "getBlockNumber":
            case "getGasPrice":
                return provider[method]();
            case "getEtherPrice":
                if (provider.getEtherPrice) return provider.getEtherPrice();
                break;
            case "getBalance":
            case "getTransactionCount":
            case "getCode":
                if (params.blockTag && (0, $eBLyT.isHexString)(params.blockTag)) provider = yield $2555531e7ae71ede$var$waitForSync(config, currentBlockNumber);
                return provider[method](params.address, params.blockTag || "latest");
            case "getStorageAt":
                if (params.blockTag && (0, $eBLyT.isHexString)(params.blockTag)) provider = yield $2555531e7ae71ede$var$waitForSync(config, currentBlockNumber);
                return provider.getStorageAt(params.address, params.position, params.blockTag || "latest");
            case "getBlock":
                if (params.blockTag && (0, $eBLyT.isHexString)(params.blockTag)) provider = yield $2555531e7ae71ede$var$waitForSync(config, currentBlockNumber);
                return provider[params.includeTransactions ? "getBlockWithTransactions" : "getBlock"](params.blockTag || params.blockHash);
            case "call":
            case "estimateGas":
                if (params.blockTag && (0, $eBLyT.isHexString)(params.blockTag)) provider = yield $2555531e7ae71ede$var$waitForSync(config, currentBlockNumber);
                if (method === "call" && params.blockTag) return provider[method](params.transaction, params.blockTag);
                return provider[method](params.transaction);
            case "getTransaction":
            case "getTransactionReceipt":
                return provider[method](params.transactionHash);
            case "getLogs":
                {
                    let filter = params.filter;
                    if (filter.fromBlock && (0, $eBLyT.isHexString)(filter.fromBlock) || filter.toBlock && (0, $eBLyT.isHexString)(filter.toBlock)) provider = yield $2555531e7ae71ede$var$waitForSync(config, currentBlockNumber);
                    return provider.getLogs(filter);
                }
        }
        return $2555531e7ae71ede$var$logger.throwError("unknown method error", (0, $4NCF1.Logger).errors.UNKNOWN_ERROR, {
            method: method,
            params: params
        });
    });
}
class $2555531e7ae71ede$export$cb1d0beacb55feb7 extends (0, $ieSzc.BaseProvider) {
    constructor(providers, quorum){
        if (providers.length === 0) $2555531e7ae71ede$var$logger.throwArgumentError("missing providers", "providers", providers);
        const providerConfigs = providers.map((configOrProvider, index)=>{
            if ((0, $lOWlX.Provider).isProvider(configOrProvider)) {
                const stallTimeout = (0, $iUcRi.isCommunityResource)(configOrProvider) ? 2000 : 750;
                const priority = 1;
                return Object.freeze({
                    provider: configOrProvider,
                    weight: 1,
                    stallTimeout: stallTimeout,
                    priority: priority
                });
            }
            const config = (0, $j0dXC.shallowCopy)(configOrProvider);
            if (config.priority == null) config.priority = 1;
            if (config.stallTimeout == null) config.stallTimeout = (0, $iUcRi.isCommunityResource)(configOrProvider) ? 2000 : 750;
            if (config.weight == null) config.weight = 1;
            const weight = config.weight;
            if (weight % 1 || weight > 512 || weight < 1) $2555531e7ae71ede$var$logger.throwArgumentError("invalid weight; must be integer in [1, 512]", `providers[${index}].weight`, weight);
            return Object.freeze(config);
        });
        const total = providerConfigs.reduce((accum, c)=>accum + c.weight, 0);
        if (quorum == null) quorum = total / 2;
        else if (quorum > total) $2555531e7ae71ede$var$logger.throwArgumentError("quorum will always fail; larger than total weight", "quorum", quorum);
        // Are all providers' networks are known
        let networkOrReady = $2555531e7ae71ede$var$checkNetworks(providerConfigs.map((c)=>c.provider.network));
        // Not all networks are known; we must stall
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then(resolve, reject);
            }, 0);
        });
        super(networkOrReady);
        // Preserve a copy, so we do not get mutated
        (0, $j0dXC.defineReadOnly)(this, "providerConfigs", Object.freeze(providerConfigs));
        (0, $j0dXC.defineReadOnly)(this, "quorum", quorum);
        this._highestBlockNumber = -1;
    }
    detectNetwork() {
        return $2555531e7ae71ede$var$__awaiter(this, void 0, void 0, function*() {
            const networks = yield Promise.all(this.providerConfigs.map((c)=>c.provider.getNetwork()));
            return $2555531e7ae71ede$var$checkNetworks(networks);
        });
    }
    perform(method, params) {
        return $2555531e7ae71ede$var$__awaiter(this, void 0, void 0, function*() {
            // Sending transactions is special; always broadcast it to all backends
            if (method === "sendTransaction") {
                const results = yield Promise.all(this.providerConfigs.map((c)=>{
                    return c.provider.sendTransaction(params.signedTransaction).then((result)=>{
                        return result.hash;
                    }, (error)=>{
                        return error;
                    });
                }));
                // Any success is good enough (other errors are likely "already seen" errors
                for(let i = 0; i < results.length; i++){
                    const result = results[i];
                    if (typeof result === "string") return result;
                }
                // They were all an error; pick the first error
                throw results[0];
            }
            // We need to make sure we are in sync with our backends, so we need
            // to know this before we can make a lot of calls
            if (this._highestBlockNumber === -1 && method !== "getBlockNumber") yield this.getBlockNumber();
            const processFunc = $2555531e7ae71ede$var$getProcessFunc(this, method, params);
            // Shuffle the providers and then sort them by their priority; we
            // shallowCopy them since we will store the result in them too
            const configs = (0, $a6YDT.shuffled)(this.providerConfigs.map((0, $j0dXC.shallowCopy)));
            configs.sort((a, b)=>a.priority - b.priority);
            const currentBlockNumber = this._highestBlockNumber;
            let i = 0;
            let first = true;
            while(true){
                const t0 = $2555531e7ae71ede$var$now();
                // Compute the inflight weight (exclude anything past)
                let inflightWeight = configs.filter((c)=>c.runner && t0 - c.start < c.stallTimeout).reduce((accum, c)=>accum + c.weight, 0);
                // Start running enough to meet quorum
                while(inflightWeight < this.quorum && i < configs.length){
                    const config = configs[i++];
                    const rid = $2555531e7ae71ede$var$nextRid++;
                    config.start = $2555531e7ae71ede$var$now();
                    config.staller = $2555531e7ae71ede$var$stall(config.stallTimeout);
                    config.staller.wait(()=>{
                        config.staller = null;
                    });
                    config.runner = $2555531e7ae71ede$var$getRunner(config, currentBlockNumber, method, params).then((result)=>{
                        config.done = true;
                        config.result = result;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $2555531e7ae71ede$var$exposeDebugConfig(config, $2555531e7ae71ede$var$now()),
                            request: {
                                method: method,
                                params: (0, $j0dXC.deepCopy)(params)
                            },
                            provider: this
                        });
                    }, (error)=>{
                        config.done = true;
                        config.error = error;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $2555531e7ae71ede$var$exposeDebugConfig(config, $2555531e7ae71ede$var$now()),
                            request: {
                                method: method,
                                params: (0, $j0dXC.deepCopy)(params)
                            },
                            provider: this
                        });
                    });
                    if (this.listenerCount("debug")) this.emit("debug", {
                        action: "request",
                        rid: rid,
                        backend: $2555531e7ae71ede$var$exposeDebugConfig(config, null),
                        request: {
                            method: method,
                            params: (0, $j0dXC.deepCopy)(params)
                        },
                        provider: this
                    });
                    inflightWeight += config.weight;
                }
                // Wait for anything meaningful to finish or stall out
                const waiting = [];
                configs.forEach((c)=>{
                    if (c.done || !c.runner) return;
                    waiting.push(c.runner);
                    if (c.staller) waiting.push(c.staller.getPromise());
                });
                if (waiting.length) yield Promise.race(waiting);
                // Check the quorum and process the results; the process function
                // may additionally decide the quorum is not met
                const results = configs.filter((c)=>c.done && c.error == null);
                if (results.length >= this.quorum) {
                    const result = processFunc(results);
                    if (result !== undefined) {
                        // Shut down any stallers
                        configs.forEach((c)=>{
                            if (c.staller) c.staller.cancel();
                            c.cancelled = true;
                        });
                        return result;
                    }
                    if (!first) yield $2555531e7ae71ede$var$stall(100).getPromise();
                    first = false;
                }
                // No result, check for errors that should be forwarded
                const errors = configs.reduce((accum, c)=>{
                    if (!c.done || c.error == null) return accum;
                    const code = c.error.code;
                    if ($2555531e7ae71ede$var$ForwardErrors.indexOf(code) >= 0) {
                        if (!accum[code]) accum[code] = {
                            error: c.error,
                            weight: 0
                        };
                        accum[code].weight += c.weight;
                    }
                    return accum;
                }, {});
                Object.keys(errors).forEach((errorCode)=>{
                    const tally = errors[errorCode];
                    if (tally.weight < this.quorum) return;
                    // Shut down any stallers
                    configs.forEach((c)=>{
                        if (c.staller) c.staller.cancel();
                        c.cancelled = true;
                    });
                    const e = tally.error;
                    const props = {};
                    $2555531e7ae71ede$var$ForwardProperties.forEach((name)=>{
                        if (e[name] == null) return;
                        props[name] = e[name];
                    });
                    $2555531e7ae71ede$var$logger.throwError(e.reason || e.message, errorCode, props);
                });
                // All configs have run to completion; we will never get more data
                if (configs.filter((c)=>!c.done).length === 0) break;
            }
            // Shut down any stallers; shouldn't be any
            configs.forEach((c)=>{
                if (c.staller) c.staller.cancel();
                c.cancelled = true;
            });
            return $2555531e7ae71ede$var$logger.throwError("failed to meet quorum", (0, $4NCF1.Logger).errors.SERVER_ERROR, {
                method: method,
                params: params,
                //results: configs.map((c) => c.result),
                //errors: configs.map((c) => c.error),
                results: configs.map((c)=>$2555531e7ae71ede$var$exposeDebugConfig(c)),
                provider: this
            });
        });
    }
}

});
parcelRegister("a6YDT", function(module, exports) {

$parcel$export(module.exports, "shuffled", function () { return $75c9814375ad27b0$export$e6c7296801b9b341; });
"use strict";
function $75c9814375ad27b0$export$e6c7296801b9b341(array) {
    array = array.slice();
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
    return array;
}

});


parcelRegister("2SUd6", function(module, exports) {

$parcel$export(module.exports, "IpcProvider", function () { return $219c3a1dabf7d95f$export$fbe151f90a1ece01; });
"use strict";
const $219c3a1dabf7d95f$export$fbe151f90a1ece01 = null;

});

parcelRegister("8iXgl", function(module, exports) {

$parcel$export(module.exports, "InfuraWebSocketProvider", function () { return $60bdf97b3c9e831b$export$dd168a807d60da4f; });
$parcel$export(module.exports, "InfuraProvider", function () { return $60bdf97b3c9e831b$export$60ff1a559b5c6ebd; });

var $j0dXC = parcelRequire("j0dXC");

var $eDTlN = parcelRequire("eDTlN");

var $iUcRi = parcelRequire("iUcRi");

var $4NCF1 = parcelRequire("4NCF1");

var $5EnYk = parcelRequire("5EnYk");

var $6QpjG = parcelRequire("6QpjG");
"use strict";
const $60bdf97b3c9e831b$var$logger = new (0, $4NCF1.Logger)((0, $5EnYk.version));
const $60bdf97b3c9e831b$var$defaultProjectId = "84842078b09946638c03157f83405213";
class $60bdf97b3c9e831b$export$dd168a807d60da4f extends (0, $eDTlN.WebSocketProvider) {
    constructor(network, apiKey){
        const provider = new $60bdf97b3c9e831b$export$60ff1a559b5c6ebd(network, apiKey);
        const connection = provider.connection;
        if (connection.password) $60bdf97b3c9e831b$var$logger.throwError("INFURA WebSocket project secrets unsupported", (0, $4NCF1.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "InfuraProvider.getWebSocketProvider()"
        });
        const url = connection.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
        super(url, network);
        (0, $j0dXC.defineReadOnly)(this, "apiKey", provider.projectId);
        (0, $j0dXC.defineReadOnly)(this, "projectId", provider.projectId);
        (0, $j0dXC.defineReadOnly)(this, "projectSecret", provider.projectSecret);
    }
    isCommunityResource() {
        return this.projectId === $60bdf97b3c9e831b$var$defaultProjectId;
    }
}
class $60bdf97b3c9e831b$export$60ff1a559b5c6ebd extends (0, $6QpjG.UrlJsonRpcProvider) {
    static getWebSocketProvider(network, apiKey) {
        return new $60bdf97b3c9e831b$export$dd168a807d60da4f(network, apiKey);
    }
    static getApiKey(apiKey) {
        const apiKeyObj = {
            apiKey: $60bdf97b3c9e831b$var$defaultProjectId,
            projectId: $60bdf97b3c9e831b$var$defaultProjectId,
            projectSecret: null
        };
        if (apiKey == null) return apiKeyObj;
        if (typeof apiKey === "string") apiKeyObj.projectId = apiKey;
        else if (apiKey.projectSecret != null) {
            $60bdf97b3c9e831b$var$logger.assertArgument(typeof apiKey.projectId === "string", "projectSecret requires a projectId", "projectId", apiKey.projectId);
            $60bdf97b3c9e831b$var$logger.assertArgument(typeof apiKey.projectSecret === "string", "invalid projectSecret", "projectSecret", "[REDACTED]");
            apiKeyObj.projectId = apiKey.projectId;
            apiKeyObj.projectSecret = apiKey.projectSecret;
        } else if (apiKey.projectId) apiKeyObj.projectId = apiKey.projectId;
        apiKeyObj.apiKey = apiKeyObj.projectId;
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "homestead":
                host = "mainnet.infura.io";
                break;
            case "goerli":
                host = "goerli.infura.io";
                break;
            case "sepolia":
                host = "sepolia.infura.io";
                break;
            case "matic":
                host = "polygon-mainnet.infura.io";
                break;
            case "maticmum":
                host = "polygon-mumbai.infura.io";
                break;
            case "optimism":
                host = "optimism-mainnet.infura.io";
                break;
            case "optimism-goerli":
                host = "optimism-goerli.infura.io";
                break;
            case "arbitrum":
                host = "arbitrum-mainnet.infura.io";
                break;
            case "arbitrum-goerli":
                host = "arbitrum-goerli.infura.io";
                break;
            default:
                $60bdf97b3c9e831b$var$logger.throwError("unsupported network", (0, $4NCF1.Logger).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const connection = {
            allowGzip: true,
            url: "https://" + host + "/v3/" + apiKey.projectId,
            throttleCallback: (attempt, url)=>{
                if (apiKey.projectId === $60bdf97b3c9e831b$var$defaultProjectId) (0, $iUcRi.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
    isCommunityResource() {
        return this.projectId === $60bdf97b3c9e831b$var$defaultProjectId;
    }
}

});

parcelRegister("7pPzE", function(module, exports) {

$parcel$export(module.exports, "JsonRpcBatchProvider", function () { return $5662dfbc9556b81e$export$5a16092bf20edf97; });

var $j0dXC = parcelRequire("j0dXC");

var $lg5bp = parcelRequire("lg5bp");

var $lDinN = parcelRequire("lDinN");
class $5662dfbc9556b81e$export$5a16092bf20edf97 extends (0, $lDinN.JsonRpcProvider) {
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        if (this._pendingBatch == null) this._pendingBatch = [];
        const inflightRequest = {
            request: request,
            resolve: null,
            reject: null
        };
        const promise = new Promise((resolve, reject)=>{
            inflightRequest.resolve = resolve;
            inflightRequest.reject = reject;
        });
        this._pendingBatch.push(inflightRequest);
        if (!this._pendingBatchAggregator) // Schedule batch for next event loop + short duration
        this._pendingBatchAggregator = setTimeout(()=>{
            // Get teh current batch and clear it, so new requests
            // go into the next batch
            const batch = this._pendingBatch;
            this._pendingBatch = null;
            this._pendingBatchAggregator = null;
            // Get the request as an array of requests
            const request = batch.map((inflight)=>inflight.request);
            this.emit("debug", {
                action: "requestBatch",
                request: (0, $j0dXC.deepCopy)(request),
                provider: this
            });
            return (0, $lg5bp.fetchJson)(this.connection, JSON.stringify(request)).then((result)=>{
                this.emit("debug", {
                    action: "response",
                    request: request,
                    response: result,
                    provider: this
                });
                // For each result, feed it to the correct Promise, depending
                // on whether it was a success or error
                batch.forEach((inflightRequest, index)=>{
                    const payload = result[index];
                    if (payload.error) {
                        const error = new Error(payload.error.message);
                        error.code = payload.error.code;
                        error.data = payload.error.data;
                        inflightRequest.reject(error);
                    } else inflightRequest.resolve(payload.result);
                });
            }, (error)=>{
                this.emit("debug", {
                    action: "response",
                    error: error,
                    request: request,
                    provider: this
                });
                batch.forEach((inflightRequest)=>{
                    inflightRequest.reject(error);
                });
            });
        }, 10);
        return promise;
    }
}

});

parcelRegister("9Kok0", function(module, exports) {

$parcel$export(module.exports, "NodesmithProvider", function () { return $718b46b9762791b5$export$8235cbce3ce273bd; });
/* istanbul ignore file */ 
var $6QpjG = parcelRequire("6QpjG");

var $4NCF1 = parcelRequire("4NCF1");

var $5EnYk = parcelRequire("5EnYk");
"use strict";
const $718b46b9762791b5$var$logger = new (0, $4NCF1.Logger)((0, $5EnYk.version));
// Special API key provided by Nodesmith for ethers.js
const $718b46b9762791b5$var$defaultApiKey = "ETHERS_JS_SHARED";
class $718b46b9762791b5$export$8235cbce3ce273bd extends (0, $6QpjG.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        if (apiKey && typeof apiKey !== "string") $718b46b9762791b5$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey || $718b46b9762791b5$var$defaultApiKey;
    }
    static getUrl(network, apiKey) {
        $718b46b9762791b5$var$logger.warn("NodeSmith will be discontinued on 2019-12-20; please migrate to another platform.");
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://ethereum.api.nodesmith.io/v1/mainnet/jsonrpc";
                break;
            case "ropsten":
                host = "https://ethereum.api.nodesmith.io/v1/ropsten/jsonrpc";
                break;
            case "rinkeby":
                host = "https://ethereum.api.nodesmith.io/v1/rinkeby/jsonrpc";
                break;
            case "goerli":
                host = "https://ethereum.api.nodesmith.io/v1/goerli/jsonrpc";
                break;
            case "kovan":
                host = "https://ethereum.api.nodesmith.io/v1/kovan/jsonrpc";
                break;
            default:
                $718b46b9762791b5$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host + "?apiKey=" + apiKey;
    }
}

});

parcelRegister("9oKQj", function(module, exports) {

$parcel$export(module.exports, "PocketProvider", function () { return $6d7ab0f384d526ba$export$58bb47e42f6b092e; });

var $4NCF1 = parcelRequire("4NCF1");

var $5EnYk = parcelRequire("5EnYk");

var $6QpjG = parcelRequire("6QpjG");
"use strict";
const $6d7ab0f384d526ba$var$logger = new (0, $4NCF1.Logger)((0, $5EnYk.version));
const $6d7ab0f384d526ba$var$defaultApplicationId = "62e1ad51b37b8e00394bda3b";
class $6d7ab0f384d526ba$export$58bb47e42f6b092e extends (0, $6QpjG.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        const apiKeyObj = {
            applicationId: null,
            loadBalancer: true,
            applicationSecretKey: null
        };
        // Parse applicationId and applicationSecretKey
        if (apiKey == null) apiKeyObj.applicationId = $6d7ab0f384d526ba$var$defaultApplicationId;
        else if (typeof apiKey === "string") apiKeyObj.applicationId = apiKey;
        else if (apiKey.applicationSecretKey != null) {
            apiKeyObj.applicationId = apiKey.applicationId;
            apiKeyObj.applicationSecretKey = apiKey.applicationSecretKey;
        } else if (apiKey.applicationId) apiKeyObj.applicationId = apiKey.applicationId;
        else $6d7ab0f384d526ba$var$logger.throwArgumentError("unsupported PocketProvider apiKey", "apiKey", apiKey);
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "goerli":
                host = "eth-goerli.gateway.pokt.network";
                break;
            case "homestead":
                host = "eth-mainnet.gateway.pokt.network";
                break;
            case "kovan":
                host = "poa-kovan.gateway.pokt.network";
                break;
            case "matic":
                host = "poly-mainnet.gateway.pokt.network";
                break;
            case "maticmum":
                host = "polygon-mumbai-rpc.gateway.pokt.network";
                break;
            case "rinkeby":
                host = "eth-rinkeby.gateway.pokt.network";
                break;
            case "ropsten":
                host = "eth-ropsten.gateway.pokt.network";
                break;
            default:
                $6d7ab0f384d526ba$var$logger.throwError("unsupported network", (0, $4NCF1.Logger).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const url = `https:/\/${host}/v1/lb/${apiKey.applicationId}`;
        const connection = {
            headers: {},
            url: url
        };
        if (apiKey.applicationSecretKey != null) {
            connection.user = "";
            connection.password = apiKey.applicationSecretKey;
        }
        return connection;
    }
    isCommunityResource() {
        return this.applicationId === $6d7ab0f384d526ba$var$defaultApplicationId;
    }
}

});

parcelRegister("cneXW", function(module, exports) {

$parcel$export(module.exports, "Web3Provider", function () { return $90233dec5e08d140$export$d05096c9fd9d936d; });

var $j0dXC = parcelRequire("j0dXC");

var $4NCF1 = parcelRequire("4NCF1");

var $5EnYk = parcelRequire("5EnYk");

var $lDinN = parcelRequire("lDinN");
"use strict";
const $90233dec5e08d140$var$logger = new (0, $4NCF1.Logger)((0, $5EnYk.version));
let $90233dec5e08d140$var$_nextId = 1;
function $90233dec5e08d140$var$buildWeb3LegacyFetcher(provider, sendFunc) {
    const fetcher = "Web3LegacyFetcher";
    return function(method, params) {
        const request = {
            method: method,
            params: params,
            id: $90233dec5e08d140$var$_nextId++,
            jsonrpc: "2.0"
        };
        return new Promise((resolve, reject)=>{
            this.emit("debug", {
                action: "request",
                fetcher: fetcher,
                request: (0, $j0dXC.deepCopy)(request),
                provider: this
            });
            sendFunc(request, (error, response)=>{
                if (error) {
                    this.emit("debug", {
                        action: "response",
                        fetcher: fetcher,
                        error: error,
                        request: request,
                        provider: this
                    });
                    return reject(error);
                }
                this.emit("debug", {
                    action: "response",
                    fetcher: fetcher,
                    request: request,
                    response: response,
                    provider: this
                });
                if (response.error) {
                    const error = new Error(response.error.message);
                    error.code = response.error.code;
                    error.data = response.error.data;
                    return reject(error);
                }
                resolve(response.result);
            });
        });
    };
}
function $90233dec5e08d140$var$buildEip1193Fetcher(provider) {
    return function(method, params) {
        if (params == null) params = [];
        const request = {
            method: method,
            params: params
        };
        this.emit("debug", {
            action: "request",
            fetcher: "Eip1193Fetcher",
            request: (0, $j0dXC.deepCopy)(request),
            provider: this
        });
        return provider.request(request).then((response)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                response: response,
                provider: this
            });
            return response;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                error: error,
                provider: this
            });
            throw error;
        });
    };
}
class $90233dec5e08d140$export$d05096c9fd9d936d extends (0, $lDinN.JsonRpcProvider) {
    constructor(provider, network){
        if (provider == null) $90233dec5e08d140$var$logger.throwArgumentError("missing provider", "provider", provider);
        let path = null;
        let jsonRpcFetchFunc = null;
        let subprovider = null;
        if (typeof provider === "function") {
            path = "unknown:";
            jsonRpcFetchFunc = provider;
        } else {
            path = provider.host || provider.path || "";
            if (!path && provider.isMetaMask) path = "metamask";
            subprovider = provider;
            if (provider.request) {
                if (path === "") path = "eip-1193:";
                jsonRpcFetchFunc = $90233dec5e08d140$var$buildEip1193Fetcher(provider);
            } else if (provider.sendAsync) jsonRpcFetchFunc = $90233dec5e08d140$var$buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
            else if (provider.send) jsonRpcFetchFunc = $90233dec5e08d140$var$buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
            else $90233dec5e08d140$var$logger.throwArgumentError("unsupported provider", "provider", provider);
            if (!path) path = "unknown:";
        }
        super(path, network);
        (0, $j0dXC.defineReadOnly)(this, "jsonRpcFetchFunc", jsonRpcFetchFunc);
        (0, $j0dXC.defineReadOnly)(this, "provider", subprovider);
    }
    send(method, params) {
        return this.jsonRpcFetchFunc(method, params);
    }
}

});


parcelRegister("01Dt9", function(module, exports) {

$parcel$export(module.exports, "AbiCoder", function () { return (parcelRequire("6LFgl")).AbiCoder; });
$parcel$export(module.exports, "defaultAbiCoder", function () { return (parcelRequire("6LFgl")).defaultAbiCoder; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("f4mbX")).Fragment; });
$parcel$export(module.exports, "ConstructorFragment", function () { return (parcelRequire("f4mbX")).ConstructorFragment; });
$parcel$export(module.exports, "ErrorFragment", function () { return (parcelRequire("f4mbX")).ErrorFragment; });
$parcel$export(module.exports, "EventFragment", function () { return (parcelRequire("f4mbX")).EventFragment; });
$parcel$export(module.exports, "FunctionFragment", function () { return (parcelRequire("f4mbX")).FunctionFragment; });
$parcel$export(module.exports, "ParamType", function () { return (parcelRequire("f4mbX")).ParamType; });
$parcel$export(module.exports, "FormatTypes", function () { return (parcelRequire("f4mbX")).FormatTypes; });
$parcel$export(module.exports, "checkResultErrors", function () { return (parcelRequire("b924P")).checkResultErrors; });
$parcel$export(module.exports, "Logger", function () { return (parcelRequire("4NCF1")).Logger; });
$parcel$export(module.exports, "RLP", function () { return (parcelRequire("esBpx")); });
$parcel$export(module.exports, "_fetchData", function () { return (parcelRequire("lg5bp"))._fetchData; });
$parcel$export(module.exports, "fetchJson", function () { return (parcelRequire("lg5bp")).fetchJson; });
$parcel$export(module.exports, "poll", function () { return (parcelRequire("lg5bp")).poll; });
$parcel$export(module.exports, "checkProperties", function () { return (parcelRequire("j0dXC")).checkProperties; });
$parcel$export(module.exports, "deepCopy", function () { return (parcelRequire("j0dXC")).deepCopy; });
$parcel$export(module.exports, "defineReadOnly", function () { return (parcelRequire("j0dXC")).defineReadOnly; });
$parcel$export(module.exports, "getStatic", function () { return (parcelRequire("j0dXC")).getStatic; });
$parcel$export(module.exports, "resolveProperties", function () { return (parcelRequire("j0dXC")).resolveProperties; });
$parcel$export(module.exports, "shallowCopy", function () { return (parcelRequire("j0dXC")).shallowCopy; });
$parcel$export(module.exports, "arrayify", function () { return (parcelRequire("eBLyT")).arrayify; });
$parcel$export(module.exports, "concat", function () { return (parcelRequire("eBLyT")).concat; });
$parcel$export(module.exports, "stripZeros", function () { return (parcelRequire("eBLyT")).stripZeros; });
$parcel$export(module.exports, "zeroPad", function () { return (parcelRequire("eBLyT")).zeroPad; });
$parcel$export(module.exports, "isBytes", function () { return (parcelRequire("eBLyT")).isBytes; });
$parcel$export(module.exports, "isBytesLike", function () { return (parcelRequire("eBLyT")).isBytesLike; });
$parcel$export(module.exports, "defaultPath", function () { return (parcelRequire("1ISM5")).defaultPath; });
$parcel$export(module.exports, "HDNode", function () { return (parcelRequire("1ISM5")).HDNode; });
$parcel$export(module.exports, "SigningKey", function () { return (parcelRequire("aDAF4")).SigningKey; });
$parcel$export(module.exports, "Interface", function () { return (parcelRequire("iAVJ5")).Interface; });
$parcel$export(module.exports, "LogDescription", function () { return (parcelRequire("iAVJ5")).LogDescription; });
$parcel$export(module.exports, "TransactionDescription", function () { return (parcelRequire("iAVJ5")).TransactionDescription; });
$parcel$export(module.exports, "base58", function () { return (parcelRequire("aK83G")).Base58; });
$parcel$export(module.exports, "base64", function () { return (parcelRequire("hM5FZ")); });
$parcel$export(module.exports, "hexlify", function () { return (parcelRequire("eBLyT")).hexlify; });
$parcel$export(module.exports, "isHexString", function () { return (parcelRequire("eBLyT")).isHexString; });
$parcel$export(module.exports, "hexConcat", function () { return (parcelRequire("eBLyT")).hexConcat; });
$parcel$export(module.exports, "hexStripZeros", function () { return (parcelRequire("eBLyT")).hexStripZeros; });
$parcel$export(module.exports, "hexValue", function () { return (parcelRequire("eBLyT")).hexValue; });
$parcel$export(module.exports, "hexZeroPad", function () { return (parcelRequire("eBLyT")).hexZeroPad; });
$parcel$export(module.exports, "hexDataLength", function () { return (parcelRequire("eBLyT")).hexDataLength; });
$parcel$export(module.exports, "hexDataSlice", function () { return (parcelRequire("eBLyT")).hexDataSlice; });
$parcel$export(module.exports, "nameprep", function () { return (parcelRequire("cP9lc")).nameprep; });
$parcel$export(module.exports, "_toEscapedUtf8String", function () { return (parcelRequire("5kral"))._toEscapedUtf8String; });
$parcel$export(module.exports, "toUtf8Bytes", function () { return (parcelRequire("5kral")).toUtf8Bytes; });
$parcel$export(module.exports, "toUtf8CodePoints", function () { return (parcelRequire("5kral")).toUtf8CodePoints; });
$parcel$export(module.exports, "toUtf8String", function () { return (parcelRequire("5kral")).toUtf8String; });
$parcel$export(module.exports, "Utf8ErrorFuncs", function () { return (parcelRequire("5kral")).Utf8ErrorFuncs; });
$parcel$export(module.exports, "formatBytes32String", function () { return (parcelRequire("aEZAK")).formatBytes32String; });
$parcel$export(module.exports, "parseBytes32String", function () { return (parcelRequire("aEZAK")).parseBytes32String; });
$parcel$export(module.exports, "dnsEncode", function () { return (parcelRequire("iQ9BG")).dnsEncode; });
$parcel$export(module.exports, "hashMessage", function () { return (parcelRequire("3vwDR")).hashMessage; });
$parcel$export(module.exports, "namehash", function () { return (parcelRequire("iQ9BG")).namehash; });
$parcel$export(module.exports, "isValidName", function () { return (parcelRequire("iQ9BG")).isValidName; });
$parcel$export(module.exports, "id", function () { return (parcelRequire("6mINK")).id; });
$parcel$export(module.exports, "_TypedDataEncoder", function () { return (parcelRequire("9qSpn")).TypedDataEncoder; });
$parcel$export(module.exports, "getAddress", function () { return (parcelRequire("ak7re")).getAddress; });
$parcel$export(module.exports, "getIcapAddress", function () { return (parcelRequire("ak7re")).getIcapAddress; });
$parcel$export(module.exports, "getContractAddress", function () { return (parcelRequire("ak7re")).getContractAddress; });
$parcel$export(module.exports, "getCreate2Address", function () { return (parcelRequire("ak7re")).getCreate2Address; });
$parcel$export(module.exports, "isAddress", function () { return (parcelRequire("ak7re")).isAddress; });
$parcel$export(module.exports, "formatEther", function () { return (parcelRequire("i5QkU")).formatEther; });
$parcel$export(module.exports, "parseEther", function () { return (parcelRequire("i5QkU")).parseEther; });
$parcel$export(module.exports, "formatUnits", function () { return (parcelRequire("i5QkU")).formatUnits; });
$parcel$export(module.exports, "parseUnits", function () { return (parcelRequire("i5QkU")).parseUnits; });
$parcel$export(module.exports, "commify", function () { return (parcelRequire("i5QkU")).commify; });
$parcel$export(module.exports, "computeHmac", function () { return (parcelRequire("8EXlS")).computeHmac; });
$parcel$export(module.exports, "keccak256", function () { return (parcelRequire("bnbYM")).keccak256; });
$parcel$export(module.exports, "ripemd160", function () { return (parcelRequire("8EXlS")).ripemd160; });
$parcel$export(module.exports, "sha256", function () { return (parcelRequire("8EXlS")).sha256; });
$parcel$export(module.exports, "sha512", function () { return (parcelRequire("8EXlS")).sha512; });
$parcel$export(module.exports, "randomBytes", function () { return (parcelRequire("8hiLm")).randomBytes; });
$parcel$export(module.exports, "shuffled", function () { return (parcelRequire("a6YDT")).shuffled; });
$parcel$export(module.exports, "solidityPack", function () { return (parcelRequire("kc9bC")).pack; });
$parcel$export(module.exports, "solidityKeccak256", function () { return (parcelRequire("kc9bC")).keccak256; });
$parcel$export(module.exports, "soliditySha256", function () { return (parcelRequire("kc9bC")).sha256; });
$parcel$export(module.exports, "splitSignature", function () { return (parcelRequire("eBLyT")).splitSignature; });
$parcel$export(module.exports, "joinSignature", function () { return (parcelRequire("eBLyT")).joinSignature; });
$parcel$export(module.exports, "accessListify", function () { return (parcelRequire("ABz8M")).accessListify; });
$parcel$export(module.exports, "parseTransaction", function () { return (parcelRequire("ABz8M")).parse; });
$parcel$export(module.exports, "serializeTransaction", function () { return (parcelRequire("ABz8M")).serialize; });
$parcel$export(module.exports, "TransactionTypes", function () { return (parcelRequire("ABz8M")).TransactionTypes; });
$parcel$export(module.exports, "getJsonWalletAddress", function () { return (parcelRequire("aPFrR")).getJsonWalletAddress; });
$parcel$export(module.exports, "computeAddress", function () { return (parcelRequire("ABz8M")).computeAddress; });
$parcel$export(module.exports, "recoverAddress", function () { return (parcelRequire("ABz8M")).recoverAddress; });
$parcel$export(module.exports, "computePublicKey", function () { return (parcelRequire("aDAF4")).computePublicKey; });
$parcel$export(module.exports, "recoverPublicKey", function () { return (parcelRequire("aDAF4")).recoverPublicKey; });
$parcel$export(module.exports, "verifyMessage", function () { return (parcelRequire("7Um1T")).verifyMessage; });
$parcel$export(module.exports, "verifyTypedData", function () { return (parcelRequire("7Um1T")).verifyTypedData; });
$parcel$export(module.exports, "getAccountPath", function () { return (parcelRequire("1ISM5")).getAccountPath; });
$parcel$export(module.exports, "mnemonicToEntropy", function () { return (parcelRequire("1ISM5")).mnemonicToEntropy; });
$parcel$export(module.exports, "entropyToMnemonic", function () { return (parcelRequire("1ISM5")).entropyToMnemonic; });
$parcel$export(module.exports, "isValidMnemonic", function () { return (parcelRequire("1ISM5")).isValidMnemonic; });
$parcel$export(module.exports, "mnemonicToSeed", function () { return (parcelRequire("1ISM5")).mnemonicToSeed; });
$parcel$export(module.exports, "SupportedAlgorithm", function () { return (parcelRequire("5FAou")).SupportedAlgorithm; });
$parcel$export(module.exports, "UnicodeNormalizationForm", function () { return (parcelRequire("5kral")).UnicodeNormalizationForm; });
$parcel$export(module.exports, "Utf8ErrorReason", function () { return (parcelRequire("5kral")).Utf8ErrorReason; });
$parcel$export(module.exports, "Indexed", function () { return (parcelRequire("iAVJ5")).Indexed; });

var $6LFgl = parcelRequire("6LFgl");
var $b924P = parcelRequire("b924P");
var $f4mbX = parcelRequire("f4mbX");
var $iAVJ5 = parcelRequire("iAVJ5");

var $ak7re = parcelRequire("ak7re");

var $hM5FZ = parcelRequire("hM5FZ");

var $aK83G = parcelRequire("aK83G");

var $eBLyT = parcelRequire("eBLyT");

var $9qSpn = parcelRequire("9qSpn");
var $iQ9BG = parcelRequire("iQ9BG");
var $3vwDR = parcelRequire("3vwDR");
var $6mINK = parcelRequire("6mINK");

var $1ISM5 = parcelRequire("1ISM5");

var $aPFrR = parcelRequire("aPFrR");

var $bnbYM = parcelRequire("bnbYM");

var $4NCF1 = parcelRequire("4NCF1");

var $8EXlS = parcelRequire("8EXlS");
var $5FAou = parcelRequire("5FAou");

var $kc9bC = parcelRequire("kc9bC");

var $8hiLm = parcelRequire("8hiLm");
var $a6YDT = parcelRequire("a6YDT");

var $j0dXC = parcelRequire("j0dXC");

var $esBpx = parcelRequire("esBpx");

var $aDAF4 = parcelRequire("aDAF4");

var $5kral = parcelRequire("5kral");
var $aEZAK = parcelRequire("aEZAK");
var $cP9lc = parcelRequire("cP9lc");

var $ABz8M = parcelRequire("ABz8M");

var $i5QkU = parcelRequire("i5QkU");

var $7Um1T = parcelRequire("7Um1T");

var $lg5bp = parcelRequire("lg5bp");
"use strict";

});
parcelRegister("hM5FZ", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return (parcelRequire("hNIlN")).decode; });
$parcel$export(module.exports, "encode", function () { return (parcelRequire("hNIlN")).encode; });

var $hNIlN = parcelRequire("hNIlN");
"use strict";

});

parcelRegister("kc9bC", function(module, exports) {

$parcel$export(module.exports, "pack", function () { return $eb3c0ddf8dc34b54$export$2a703dbb0cb35339; });
$parcel$export(module.exports, "keccak256", function () { return $eb3c0ddf8dc34b54$export$f8151fce47ad1c35; });
$parcel$export(module.exports, "sha256", function () { return $eb3c0ddf8dc34b54$export$bced8d2aada2d1c9; });

var $20M69 = parcelRequire("20M69");

var $eBLyT = parcelRequire("eBLyT");

var $bnbYM = parcelRequire("bnbYM");

var $8EXlS = parcelRequire("8EXlS");

var $5kral = parcelRequire("5kral");

var $4NCF1 = parcelRequire("4NCF1");

var $9TlZe = parcelRequire("9TlZe");
"use strict";
const $eb3c0ddf8dc34b54$var$regexBytes = new RegExp("^bytes([0-9]+)$");
const $eb3c0ddf8dc34b54$var$regexNumber = new RegExp("^(u?int)([0-9]*)$");
const $eb3c0ddf8dc34b54$var$regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$");
const $eb3c0ddf8dc34b54$var$Zeros = "0000000000000000000000000000000000000000000000000000000000000000";
const $eb3c0ddf8dc34b54$var$logger = new (0, $4NCF1.Logger)((0, $9TlZe.version));
function $eb3c0ddf8dc34b54$var$_pack(type, value, isArray) {
    switch(type){
        case "address":
            if (isArray) return (0, $eBLyT.zeroPad)(value, 32);
            return (0, $eBLyT.arrayify)(value);
        case "string":
            return (0, $5kral.toUtf8Bytes)(value);
        case "bytes":
            return (0, $eBLyT.arrayify)(value);
        case "bool":
            value = value ? "0x01" : "0x00";
            if (isArray) return (0, $eBLyT.zeroPad)(value, 32);
            return (0, $eBLyT.arrayify)(value);
    }
    let match = type.match($eb3c0ddf8dc34b54$var$regexNumber);
    if (match) {
        //let signed = (match[1] === "int")
        let size = parseInt(match[2] || "256");
        if (match[2] && String(size) !== match[2] || size % 8 !== 0 || size === 0 || size > 256) $eb3c0ddf8dc34b54$var$logger.throwArgumentError("invalid number type", "type", type);
        if (isArray) size = 256;
        value = (0, $20M69.BigNumber).from(value).toTwos(size);
        return (0, $eBLyT.zeroPad)(value, size / 8);
    }
    match = type.match($eb3c0ddf8dc34b54$var$regexBytes);
    if (match) {
        const size = parseInt(match[1]);
        if (String(size) !== match[1] || size === 0 || size > 32) $eb3c0ddf8dc34b54$var$logger.throwArgumentError("invalid bytes type", "type", type);
        if ((0, $eBLyT.arrayify)(value).byteLength !== size) $eb3c0ddf8dc34b54$var$logger.throwArgumentError(`invalid value for ${type}`, "value", value);
        if (isArray) return (0, $eBLyT.arrayify)((value + $eb3c0ddf8dc34b54$var$Zeros).substring(0, 66));
        return value;
    }
    match = type.match($eb3c0ddf8dc34b54$var$regexArray);
    if (match && Array.isArray(value)) {
        const baseType = match[1];
        const count = parseInt(match[2] || String(value.length));
        if (count != value.length) $eb3c0ddf8dc34b54$var$logger.throwArgumentError(`invalid array length for ${type}`, "value", value);
        const result = [];
        value.forEach(function(value) {
            result.push($eb3c0ddf8dc34b54$var$_pack(baseType, value, true));
        });
        return (0, $eBLyT.concat)(result);
    }
    return $eb3c0ddf8dc34b54$var$logger.throwArgumentError("invalid type", "type", type);
}
function $eb3c0ddf8dc34b54$export$2a703dbb0cb35339(types, values) {
    if (types.length != values.length) $eb3c0ddf8dc34b54$var$logger.throwArgumentError("wrong number of values; expected ${ types.length }", "values", values);
    const tight = [];
    types.forEach(function(type, index) {
        tight.push($eb3c0ddf8dc34b54$var$_pack(type, values[index]));
    });
    return (0, $eBLyT.hexlify)((0, $eBLyT.concat)(tight));
}
function $eb3c0ddf8dc34b54$export$f8151fce47ad1c35(types, values) {
    return (0, $bnbYM.keccak256)($eb3c0ddf8dc34b54$export$2a703dbb0cb35339(types, values));
}
function $eb3c0ddf8dc34b54$export$bced8d2aada2d1c9(types, values) {
    return (0, $8EXlS.sha256)($eb3c0ddf8dc34b54$export$2a703dbb0cb35339(types, values));
}

});
parcelRegister("9TlZe", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $733a4e2c30f87637$export$83d89fbfd8236492; });
const $733a4e2c30f87637$export$83d89fbfd8236492 = "solidity/5.7.0";

});


parcelRegister("aEZAK", function(module, exports) {

$parcel$export(module.exports, "formatBytes32String", function () { return $7c2d6aa430655e17$export$b97e949c0076e971; });
$parcel$export(module.exports, "parseBytes32String", function () { return $7c2d6aa430655e17$export$49340cb8f3954db8; });

var $9n5JS = parcelRequire("9n5JS");

var $eBLyT = parcelRequire("eBLyT");

var $5kral = parcelRequire("5kral");
"use strict";
function $7c2d6aa430655e17$export$b97e949c0076e971(text) {
    // Get the bytes
    const bytes = (0, $5kral.toUtf8Bytes)(text);
    // Check we have room for null-termination
    if (bytes.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
    // Zero-pad (implicitly null-terminates)
    return (0, $eBLyT.hexlify)((0, $eBLyT.concat)([
        bytes,
        (0, $9n5JS.HashZero)
    ]).slice(0, 32));
}
function $7c2d6aa430655e17$export$49340cb8f3954db8(bytes) {
    const data = (0, $eBLyT.arrayify)(bytes);
    // Must be 32 bytes with a null-termination
    if (data.length !== 32) throw new Error("invalid bytes32 - not 32 bytes long");
    if (data[31] !== 0) throw new Error("invalid bytes32 string - no null terminator");
    // Find the null termination
    let length = 31;
    while(data[length - 1] === 0)length--;
    // Determine the string value
    return (0, $5kral.toUtf8String)(data.slice(0, length));
}

});

parcelRegister("cP9lc", function(module, exports) {

$parcel$export(module.exports, "nameprep", function () { return $95617e5b0c89fabb$export$94f0b6f93c619bc; });

var $5kral = parcelRequire("5kral");
"use strict";
function $95617e5b0c89fabb$var$bytes2(data) {
    if (data.length % 4 !== 0) throw new Error("bad data");
    let result = [];
    for(let i = 0; i < data.length; i += 4)result.push(parseInt(data.substring(i, i + 4), 16));
    return result;
}
function $95617e5b0c89fabb$var$createTable(data, func) {
    if (!func) func = function(value) {
        return [
            parseInt(value, 16)
        ];
    };
    let lo = 0;
    let result = {};
    data.split(",").forEach((pair)=>{
        let comps = pair.split(":");
        lo += parseInt(comps[0], 16);
        result[lo] = func(comps[1]);
    });
    return result;
}
function $95617e5b0c89fabb$var$createRangeTable(data) {
    let hi = 0;
    return data.split(",").map((v)=>{
        let comps = v.split("-");
        if (comps.length === 1) comps[1] = "0";
        else if (comps[1] === "") comps[1] = "1";
        let lo = hi + parseInt(comps[0], 16);
        hi = parseInt(comps[1], 16);
        return {
            l: lo,
            h: hi
        };
    });
}
function $95617e5b0c89fabb$var$matchMap(value, ranges) {
    let lo = 0;
    for(let i = 0; i < ranges.length; i++){
        let range = ranges[i];
        lo += range.l;
        if (value >= lo && value <= lo + range.h && (value - lo) % (range.d || 1) === 0) {
            if (range.e && range.e.indexOf(value - lo) !== -1) continue;
            return range;
        }
    }
    return null;
}
const $95617e5b0c89fabb$var$Table_A_1_ranges = $95617e5b0c89fabb$var$createRangeTable("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d");
// @TODO: Make this relative...
const $95617e5b0c89fabb$var$Table_B_1_flags = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((v)=>parseInt(v, 16));
const $95617e5b0c89fabb$var$Table_B_2_ranges = [
    {
        h: 25,
        s: 32,
        l: 65
    },
    {
        h: 30,
        s: 32,
        e: [
            23
        ],
        l: 127
    },
    {
        h: 54,
        s: 1,
        e: [
            48
        ],
        l: 64,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 57,
        d: 2
    },
    {
        h: 44,
        s: 1,
        l: 17,
        d: 2
    },
    {
        h: 10,
        s: 1,
        e: [
            2,
            6,
            8
        ],
        l: 61,
        d: 2
    },
    {
        h: 16,
        s: 1,
        l: 68,
        d: 2
    },
    {
        h: 84,
        s: 1,
        e: [
            18,
            24,
            66
        ],
        l: 19,
        d: 2
    },
    {
        h: 26,
        s: 32,
        e: [
            17
        ],
        l: 435
    },
    {
        h: 22,
        s: 1,
        l: 71,
        d: 2
    },
    {
        h: 15,
        s: 80,
        l: 40
    },
    {
        h: 31,
        s: 32,
        l: 16
    },
    {
        h: 32,
        s: 1,
        l: 80,
        d: 2
    },
    {
        h: 52,
        s: 1,
        l: 42,
        d: 2
    },
    {
        h: 12,
        s: 1,
        l: 55,
        d: 2
    },
    {
        h: 40,
        s: 1,
        e: [
            38
        ],
        l: 15,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 48,
        d: 2
    },
    {
        h: 37,
        s: 48,
        l: 49
    },
    {
        h: 148,
        s: 1,
        l: 6351,
        d: 2
    },
    {
        h: 88,
        s: 1,
        l: 160,
        d: 2
    },
    {
        h: 15,
        s: 16,
        l: 704
    },
    {
        h: 25,
        s: 26,
        l: 854
    },
    {
        h: 25,
        s: 32,
        l: 55915
    },
    {
        h: 37,
        s: 40,
        l: 1247
    },
    {
        h: 25,
        s: -119711,
        l: 53248
    },
    {
        h: 25,
        s: -119763,
        l: 52
    },
    {
        h: 25,
        s: -119815,
        l: 52
    },
    {
        h: 25,
        s: -119867,
        e: [
            1,
            4,
            5,
            7,
            8,
            11,
            12,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -119919,
        l: 52
    },
    {
        h: 24,
        s: -119971,
        e: [
            2,
            7,
            8,
            17
        ],
        l: 52
    },
    {
        h: 24,
        s: -120023,
        e: [
            2,
            7,
            13,
            15,
            16,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -120075,
        l: 52
    },
    {
        h: 25,
        s: -120127,
        l: 52
    },
    {
        h: 25,
        s: -120179,
        l: 52
    },
    {
        h: 25,
        s: -120231,
        l: 52
    },
    {
        h: 25,
        s: -120283,
        l: 52
    },
    {
        h: 25,
        s: -120335,
        l: 52
    },
    {
        h: 24,
        s: -119543,
        e: [
            17
        ],
        l: 56
    },
    {
        h: 24,
        s: -119601,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119659,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119717,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119775,
        e: [
            17
        ],
        l: 58
    }
];
const $95617e5b0c89fabb$var$Table_B_2_lut_abs = $95617e5b0c89fabb$var$createTable("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3");
const $95617e5b0c89fabb$var$Table_B_2_lut_rel = $95617e5b0c89fabb$var$createTable("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7");
const $95617e5b0c89fabb$var$Table_B_2_complex = $95617e5b0c89fabb$var$createTable("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $95617e5b0c89fabb$var$bytes2);
const $95617e5b0c89fabb$var$Table_C_ranges = $95617e5b0c89fabb$var$createRangeTable("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function $95617e5b0c89fabb$var$flatten(values) {
    return values.reduce((accum, value)=>{
        value.forEach((value)=>{
            accum.push(value);
        });
        return accum;
    }, []);
}
function $95617e5b0c89fabb$export$d1ae0d802533bef0(codepoint) {
    return !!$95617e5b0c89fabb$var$matchMap(codepoint, $95617e5b0c89fabb$var$Table_A_1_ranges);
}
function $95617e5b0c89fabb$export$9630a1f26a43b76c(codepoint) {
    let range = $95617e5b0c89fabb$var$matchMap(codepoint, $95617e5b0c89fabb$var$Table_B_2_ranges);
    if (range) return [
        codepoint + range.s
    ];
    let codes = $95617e5b0c89fabb$var$Table_B_2_lut_abs[codepoint];
    if (codes) return codes;
    let shift = $95617e5b0c89fabb$var$Table_B_2_lut_rel[codepoint];
    if (shift) return [
        codepoint + shift[0]
    ];
    let complex = $95617e5b0c89fabb$var$Table_B_2_complex[codepoint];
    if (complex) return complex;
    return null;
}
function $95617e5b0c89fabb$export$e07a548cae6d1553(codepoint) {
    return !!$95617e5b0c89fabb$var$matchMap(codepoint, $95617e5b0c89fabb$var$Table_C_ranges);
}
function $95617e5b0c89fabb$export$94f0b6f93c619bc(value) {
    // This allows platforms with incomplete normalize to bypass
    // it for very basic names which the built-in toLowerCase
    // will certainly handle correctly
    if (value.match(/^[a-z0-9-]*$/i) && value.length <= 59) return value.toLowerCase();
    // Get the code points (keeping the current normalization)
    let codes = (0, $5kral.toUtf8CodePoints)(value);
    codes = $95617e5b0c89fabb$var$flatten(codes.map((code)=>{
        // Substitute Table B.1 (Maps to Nothing)
        if ($95617e5b0c89fabb$var$Table_B_1_flags.indexOf(code) >= 0) return [];
        if (code >= 0xfe00 && code <= 0xfe0f) return [];
        // Substitute Table B.2 (Case Folding)
        let codesTableB2 = $95617e5b0c89fabb$export$9630a1f26a43b76c(code);
        if (codesTableB2) return codesTableB2;
        // No Substitution
        return [
            code
        ];
    }));
    // Normalize using form KC
    codes = (0, $5kral.toUtf8CodePoints)((0, $5kral._toUtf8String)(codes), (0, $5kral.UnicodeNormalizationForm).NFKC);
    // Prohibit Tables C.1.2, C.2.2, C.3, C.4, C.5, C.6, C.7, C.8, C.9
    codes.forEach((code)=>{
        if ($95617e5b0c89fabb$export$e07a548cae6d1553(code)) throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
    });
    // Prohibit Unassigned Code Points (Table A.1)
    codes.forEach((code)=>{
        if ($95617e5b0c89fabb$export$d1ae0d802533bef0(code)) throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
    });
    // IDNA extras
    let name = (0, $5kral._toUtf8String)(codes);
    // IDNA: 4.2.3.1
    if (name.substring(0, 1) === "-" || name.substring(2, 4) === "--" || name.substring(name.length - 1) === "-") throw new Error("invalid hyphen");
    return name;
}

});

parcelRegister("i5QkU", function(module, exports) {

$parcel$export(module.exports, "commify", function () { return $d2c14a86438314a5$export$de1294767e6ef661; });
$parcel$export(module.exports, "formatUnits", function () { return $d2c14a86438314a5$export$bd39b96f71da1885; });
$parcel$export(module.exports, "parseUnits", function () { return $d2c14a86438314a5$export$203ae30b4f6490b3; });
$parcel$export(module.exports, "formatEther", function () { return $d2c14a86438314a5$export$11bc63b4c03ea518; });
$parcel$export(module.exports, "parseEther", function () { return $d2c14a86438314a5$export$642c4e67bbdc0bc7; });

var $jR8eo = parcelRequire("jR8eo");

var $4NCF1 = parcelRequire("4NCF1");

var $71nbi = parcelRequire("71nbi");
"use strict";
const $d2c14a86438314a5$var$logger = new (0, $4NCF1.Logger)((0, $71nbi.version));
const $d2c14a86438314a5$var$names = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
];
function $d2c14a86438314a5$export$de1294767e6ef661(value) {
    const comps = String(value).split(".");
    if (comps.length > 2 || !comps[0].match(/^-?[0-9]*$/) || comps[1] && !comps[1].match(/^[0-9]*$/) || value === "." || value === "-.") $d2c14a86438314a5$var$logger.throwArgumentError("invalid value", "value", value);
    // Make sure we have at least one whole digit (0 if none)
    let whole = comps[0];
    let negative = "";
    if (whole.substring(0, 1) === "-") {
        negative = "-";
        whole = whole.substring(1);
    }
    // Make sure we have at least 1 whole digit with no leading zeros
    while(whole.substring(0, 1) === "0")whole = whole.substring(1);
    if (whole === "") whole = "0";
    let suffix = "";
    if (comps.length === 2) suffix = "." + (comps[1] || "0");
    while(suffix.length > 2 && suffix[suffix.length - 1] === "0")suffix = suffix.substring(0, suffix.length - 1);
    const formatted = [];
    while(whole.length)if (whole.length <= 3) {
        formatted.unshift(whole);
        break;
    } else {
        const index = whole.length - 3;
        formatted.unshift(whole.substring(index));
        whole = whole.substring(0, index);
    }
    return negative + formatted.join(",") + suffix;
}
function $d2c14a86438314a5$export$bd39b96f71da1885(value, unitName) {
    if (typeof unitName === "string") {
        const index = $d2c14a86438314a5$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $jR8eo.formatFixed)(value, unitName != null ? unitName : 18);
}
function $d2c14a86438314a5$export$203ae30b4f6490b3(value, unitName) {
    if (typeof value !== "string") $d2c14a86438314a5$var$logger.throwArgumentError("value must be a string", "value", value);
    if (typeof unitName === "string") {
        const index = $d2c14a86438314a5$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $jR8eo.parseFixed)(value, unitName != null ? unitName : 18);
}
function $d2c14a86438314a5$export$11bc63b4c03ea518(wei) {
    return $d2c14a86438314a5$export$bd39b96f71da1885(wei, 18);
}
function $d2c14a86438314a5$export$642c4e67bbdc0bc7(ether) {
    return $d2c14a86438314a5$export$203ae30b4f6490b3(ether, 18);
}

});
parcelRegister("71nbi", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $51ca9baee7735db5$export$83d89fbfd8236492; });
const $51ca9baee7735db5$export$83d89fbfd8236492 = "units/5.7.0";

});



parcelRegister("lEEPI", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $fc3d020060152121$export$83d89fbfd8236492; });
const $fc3d020060152121$export$83d89fbfd8236492 = "ethers/5.7.2";

});




parcelRegister("brXJH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SiweErrorType = module.exports.SiweError = module.exports.VerifyOptsKeys = module.exports.VerifyParamsKeys = void 0;
module.exports.VerifyParamsKeys = [
    "signature",
    "scheme",
    "domain",
    "nonce",
    "time"
];
module.exports.VerifyOptsKeys = [
    "provider",
    "suppressExceptions",
    "verificationFallback"
];
/**
 * Interface used to return errors in SiweResponses.
 */ class $85608dadc0cbe1df$var$SiweError {
    constructor(type, expected, received){
        this.type = type;
        this.expected = expected;
        this.received = received;
    }
}
module.exports.SiweError = $85608dadc0cbe1df$var$SiweError;
/**
 * Possible message error types.
 */ var $85608dadc0cbe1df$var$SiweErrorType;
(function(SiweErrorType) {
    /** `expirationTime` is present and in the past. */ SiweErrorType["EXPIRED_MESSAGE"] = "Expired message.";
    /** `domain` is not a valid authority or is empty. */ SiweErrorType["INVALID_DOMAIN"] = "Invalid domain.";
    /** `scheme` don't match the scheme provided for verification. */ SiweErrorType["SCHEME_MISMATCH"] = "Scheme does not match provided scheme for verification.";
    /** `domain` don't match the domain provided for verification. */ SiweErrorType["DOMAIN_MISMATCH"] = "Domain does not match provided domain for verification.";
    /** `nonce` don't match the nonce provided for verification. */ SiweErrorType["NONCE_MISMATCH"] = "Nonce does not match provided nonce for verification.";
    /** `address` does not conform to EIP-55 or is not a valid address. */ SiweErrorType["INVALID_ADDRESS"] = "Invalid address.";
    /** `uri` does not conform to RFC 3986. */ SiweErrorType["INVALID_URI"] = "URI does not conform to RFC 3986.";
    /** `nonce` is smaller then 8 characters or is not alphanumeric */ SiweErrorType["INVALID_NONCE"] = "Nonce size smaller then 8 characters or is not alphanumeric.";
    /** `notBefore` is present and in the future. */ SiweErrorType["NOT_YET_VALID_MESSAGE"] = "Message is not valid yet.";
    /** Signature doesn't match the address of the message. */ SiweErrorType["INVALID_SIGNATURE"] = "Signature does not match address of the message.";
    /** `expirationTime`, `notBefore` or `issuedAt` not complient to ISO-8601. */ SiweErrorType["INVALID_TIME_FORMAT"] = "Invalid time format.";
    /** `version` is not 1. */ SiweErrorType["INVALID_MESSAGE_VERSION"] = "Invalid message version.";
    /** Thrown when some required field is missing. */ SiweErrorType["UNABLE_TO_PARSE"] = "Unable to parse the message.";
})($85608dadc0cbe1df$var$SiweErrorType = module.exports.SiweErrorType || (module.exports.SiweErrorType = {}));

});

parcelRegister("eiyYC", function(module, exports) {
"use strict";
var $a68de0c725cf7949$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkInvalidKeys = module.exports.isValidISO8601Date = module.exports.generateNonce = module.exports.checkContractWalletSignature = void 0;

var $6CzCo = parcelRequire("6CzCo");

var $9TnCu = parcelRequire("9TnCu");

var $jGqzU = parcelRequire("jGqzU");
const $a68de0c725cf7949$var$EIP1271_ABI = [
    "function isValidSignature(bytes32 _message, bytes _signature) public view returns (bytes4)"
];
const $a68de0c725cf7949$var$EIP1271_MAGICVALUE = "0x1626ba7e";
const $a68de0c725cf7949$var$ISO8601 = /^(?<date>[0-9]{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01]))[Tt]([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9]|60)(.[0-9]+)?(([Zz])|([+|-]([01][0-9]|2[0-3]):[0-5][0-9]))$/;
/**
 * This method calls the EIP-1271 method for Smart Contract wallets
 * @param message The EIP-4361 parsed message
 * @param provider Web3 provider able to perform a contract check (Web3/EthersJS).
 * @returns {Promise<boolean>} Checks for the smart contract (if it exists) if
 * the signature is valid for given address.
 */ const $a68de0c725cf7949$var$checkContractWalletSignature = (message, signature, provider)=>$a68de0c725cf7949$var$__awaiter(void 0, void 0, void 0, function*() {
        if (!provider) return false;
        const walletContract = new $9TnCu.Contract(message.address, $a68de0c725cf7949$var$EIP1271_ABI, provider);
        const hashedMessage = (0, $jGqzU.hashMessage)(message.prepareMessage());
        const res = yield walletContract.isValidSignature(hashedMessage, signature);
        return res === $a68de0c725cf7949$var$EIP1271_MAGICVALUE;
    });
module.exports.checkContractWalletSignature = $a68de0c725cf7949$var$checkContractWalletSignature;
/**
 * This method leverages a native CSPRNG with support for both browser and Node.js
 * environments in order generate a cryptographically secure nonce for use in the
 * SiweMessage in order to prevent replay attacks.
 *
 * 96 bits has been chosen as a number to sufficiently balance size and security considerations
 * relative to the lifespan of it's usage.
 *
 * @returns cryptographically generated random nonce with 96 bits of entropy encoded with
 * an alphanumeric character set.
 */ const $a68de0c725cf7949$var$generateNonce = ()=>{
    const nonce = (0, $6CzCo.randomStringForEntropy)(96);
    if (!nonce || nonce.length < 8) throw new Error("Error during nonce creation.");
    return nonce;
};
module.exports.generateNonce = $a68de0c725cf7949$var$generateNonce;
/**
 * This method matches the given date string against the ISO-8601 regex and also
 * performs checks if it's a valid date.
 * @param inputDate any string to be validated against ISO-8601
 * @returns boolean indicating if the providade date is valid and conformant to ISO-8601
 */ const $a68de0c725cf7949$var$isValidISO8601Date = (inputDate)=>{
    /* Split groups and make sure inputDate is in ISO8601 format */ const inputMatch = $a68de0c725cf7949$var$ISO8601.exec(inputDate);
    /* if inputMatch is null the date is not ISO-8601 */ if (!inputDate) return false;
    /* Creates a date object with input date to parse for invalid days e.g. Feb, 30 -> Mar, 01 */ const inputDateParsed = new Date(inputMatch.groups.date).toISOString();
    /* Get groups from new parsed date to compare with the original input */ const parsedInputMatch = $a68de0c725cf7949$var$ISO8601.exec(inputDateParsed);
    /* Compare remaining fields */ return inputMatch.groups.date === parsedInputMatch.groups.date;
};
module.exports.isValidISO8601Date = $a68de0c725cf7949$var$isValidISO8601Date;
const $a68de0c725cf7949$var$checkInvalidKeys = (obj, keys)=>{
    const invalidKeys = [];
    Object.keys(obj).forEach((key)=>{
        if (!keys.includes(key)) invalidKeys.push(key);
    });
    return invalidKeys;
};
module.exports.checkInvalidKeys = $a68de0c725cf7949$var$checkInvalidKeys;

});


parcelRegister("l06UM", function(module, exports) {

$parcel$export(module.exports, "N", function () { return Network; });
$parcel$export(module.exports, "j", function () { return AlchemySubscription; });
$parcel$export(module.exports, "_", function () { return __awaiter$1; });
$parcel$export(module.exports, "D", function () { return DEFAULT_ALCHEMY_API_KEY; });
$parcel$export(module.exports, "a", function () { return DEFAULT_NETWORK; });
$parcel$export(module.exports, "g", function () { return getAlchemyHttpUrl; });
$parcel$export(module.exports, "b", function () { return getAlchemyWsUrl; });
$parcel$export(module.exports, "E", function () { return EthersNetwork; });
$parcel$export(module.exports, "C", function () { return CustomNetworks; });
$parcel$export(module.exports, "n", function () { return noop; });
$parcel$export(module.exports, "d", function () { return deepCopy; });
$parcel$export(module.exports, "f", function () { return fromHex; });
$parcel$export(module.exports, "t", function () { return toHex; });
$parcel$export(module.exports, "I", function () { return IS_BROWSER; });
$parcel$export(module.exports, "l", function () { return logWarn; });
$parcel$export(module.exports, "V", function () { return VERSION; });
$parcel$export(module.exports, "h", function () { return ALCHEMY_PENDING_TRANSACTIONS_EVENT_TYPE; });
$parcel$export(module.exports, "k", function () { return ALCHEMY_MINED_TRANSACTIONS_EVENT_TYPE; });
$parcel$export(module.exports, "A", function () { return ALCHEMY_EVENT_TYPES; });
$parcel$export(module.exports, "c", function () { return EthersEvent; });
$parcel$export(module.exports, "i", function () { return isAlchemyEvent; });
$parcel$export(module.exports, "e", function () { return getAlchemyEventTag; });
$parcel$export(module.exports, "v", function () { return verifyAlchemyEventName; });
$parcel$export(module.exports, "m", function () { return Alchemy; });

var $i5QkU = parcelRequire("i5QkU");
var $eBLyT = parcelRequire("eBLyT");

var $20M69 = parcelRequire("20M69");
parcelRequire("pyHeF");
var $8AUfX = parcelRequire("8AUfX");

var $lOWlX = parcelRequire("lOWlX");

var $7Um1T = parcelRequire("7Um1T");

var $9TnCu = parcelRequire("9TnCu");
/**
 * The supported networks by Alchemy. Note that some functions are not available
 * on all networks. Please refer to the Alchemy documentation for which APIs are
 * available on which networks
 * {@link https://docs.alchemy.com/alchemy/apis/feature-support-by-chain}
 *
 * @public
 */ var Network;
(function(Network) {
    Network["ETH_MAINNET"] = "eth-mainnet";
    Network["ETH_GOERLI"] = "eth-goerli";
    Network["ETH_SEPOLIA"] = "eth-sepolia";
    Network["OPT_MAINNET"] = "opt-mainnet";
    Network["OPT_GOERLI"] = "opt-goerli";
    Network["OPT_SEPOLIA"] = "opt-sepolia";
    Network["ARB_MAINNET"] = "arb-mainnet";
    Network["ARB_GOERLI"] = "arb-goerli";
    Network["ARB_SEPOLIA"] = "arb-sepolia";
    Network["MATIC_MAINNET"] = "polygon-mainnet";
    Network["MATIC_MUMBAI"] = "polygon-mumbai";
    Network["MATIC_AMOY"] = "polygon-amoy";
    Network["ASTAR_MAINNET"] = "astar-mainnet";
    Network["POLYGONZKEVM_MAINNET"] = "polygonzkevm-mainnet";
    Network["POLYGONZKEVM_TESTNET"] = "polygonzkevm-testnet";
    Network["BASE_MAINNET"] = "base-mainnet";
    Network["BASE_GOERLI"] = "base-goerli";
    Network["BASE_SEPOLIA"] = "base-sepolia";
    Network["ZKSYNC_MAINNET"] = "zksync-mainnet";
    Network["ZKSYNC_SEPOLIA"] = "zksync-sepolia";
})(Network || (Network = {}));
/** Token Types for the `getTokenBalances()` endpoint. */ var TokenBalanceType;
(function(TokenBalanceType) {
    /**
     * Option to fetch the top 100 tokens by 24-hour volume. This option is only
     * available on Mainnet in Ethereum, Polygon, and Arbitrum.
     */ TokenBalanceType["DEFAULT_TOKENS"] = "DEFAULT_TOKENS";
    /**
     * Option to fetch the set of ERC-20 tokens that the address as ever held. his
     * list is produced by an address's historical transfer activity and includes
     * all tokens that the address has ever received.
     */ TokenBalanceType["ERC20"] = "erc20";
})(TokenBalanceType || (TokenBalanceType = {}));
/**
 * Categories of transfers to use with the {@link AssetTransfersParams} request
 * object when using {@link CoreNamespace.getAssetTransfers}.
 *
 * @public
 */ var AssetTransfersCategory;
(function(AssetTransfersCategory) {
    /**
     * Top level ETH transactions that occur where the `fromAddress` is an
     * external user-created address. External addresses have private keys and are
     * accessed by users.
     */ AssetTransfersCategory["EXTERNAL"] = "external";
    /**
     * Top level ETH transactions that occur where the `fromAddress` is an
     * internal, smart contract address. For example, a smart contract calling
     * another smart contract or sending
     */ AssetTransfersCategory["INTERNAL"] = "internal";
    /** ERC20 transfers. */ AssetTransfersCategory["ERC20"] = "erc20";
    /** ERC721 transfers. */ AssetTransfersCategory["ERC721"] = "erc721";
    /** ERC1155 transfers. */ AssetTransfersCategory["ERC1155"] = "erc1155";
    /** Special contracts that don't follow ERC 721/1155, (ex: CryptoKitties). */ AssetTransfersCategory["SPECIALNFT"] = "specialnft";
})(AssetTransfersCategory || (AssetTransfersCategory = {}));
/**
 * The type of transfer for the request. Note that using `TO` will also include
 * NFTs that were minted by the owner.
 */ var GetTransfersForOwnerTransferType;
(function(GetTransfersForOwnerTransferType) {
    GetTransfersForOwnerTransferType["TO"] = "TO";
    GetTransfersForOwnerTransferType["FROM"] = "FROM";
})(GetTransfersForOwnerTransferType || (GetTransfersForOwnerTransferType = {}));
/**
 * Enum for representing the supported sorting orders of the API.
 *
 * @public
 */ var SortingOrder;
(function(SortingOrder) {
    SortingOrder["ASCENDING"] = "asc";
    SortingOrder["DESCENDING"] = "desc";
})(SortingOrder || (SortingOrder = {}));
/** An OpenSea collection's approval status. */ var OpenSeaSafelistRequestStatus;
(function(OpenSeaSafelistRequestStatus) {
    /** Verified collection. */ OpenSeaSafelistRequestStatus["VERIFIED"] = "verified";
    /** Collections that are approved on open sea and can be found in search results. */ OpenSeaSafelistRequestStatus["APPROVED"] = "approved";
    /** Collections that requested safelisting on OpenSea. */ OpenSeaSafelistRequestStatus["REQUESTED"] = "requested";
    /** Brand new collections. */ OpenSeaSafelistRequestStatus["NOT_REQUESTED"] = "not_requested";
})(OpenSeaSafelistRequestStatus || (OpenSeaSafelistRequestStatus = {}));
/**
 * Method names for Alchemy's custom Subscription API endpoints.
 *
 * This value is provided in the `method` field when creating an event filter on
 * the Websocket Namespace.
 */ var AlchemySubscription;
(function(AlchemySubscription) {
    AlchemySubscription["PENDING_TRANSACTIONS"] = "alchemy_pendingTransactions";
    AlchemySubscription["MINED_TRANSACTIONS"] = "alchemy_minedTransactions";
})(AlchemySubscription || (AlchemySubscription = {}));
/**
 * Asset type returned when calling {@link TransactNamespace.simulateAssetChanges}.
 * Allows you to determine if the assets approved or / and transferred are
 * native, tokens or NFTs.
 */ var SimulateAssetType;
(function(SimulateAssetType) {
    /**
     * Native transfers that involve the currency of the chain the simulation is
     * run on (ex: ETH for Ethereum, MATIC for Polygon, ETH for Arbitrum).
     */ SimulateAssetType["NATIVE"] = "NATIVE";
    /** ERC20 approval or transfers. */ SimulateAssetType["ERC20"] = "ERC20";
    /** ERC721 approval or transfers. */ SimulateAssetType["ERC721"] = "ERC721";
    /** ERC1155 approval or transfers. */ SimulateAssetType["ERC1155"] = "ERC1155";
    /**
     * Special contracts that don't follow ERC 721/1155.Currently limited to
     * CryptoKitties and CryptoPunks.
     */ SimulateAssetType["SPECIAL_NFT"] = "SPECIAL_NFT";
})(SimulateAssetType || (SimulateAssetType = {}));
/**
 * Change type returned when calling {@link TransactNamespace.simulateAssetChanges}.
 */ var SimulateChangeType;
(function(SimulateChangeType) {
    /**
     * Represents a transaction that approved or disapproved permissions for a
     * contract.
     *
     * APPROVE without token ID → approve all tokens
     * APPROVE without amount → approve all amount
     * APPROVE with zero amount → approval being cleared
     */ SimulateChangeType["APPROVE"] = "APPROVE";
    /**
     * Represents a transaction that transferred tokens from one address to another.
     */ SimulateChangeType["TRANSFER"] = "TRANSFER";
})(SimulateChangeType || (SimulateChangeType = {}));
/**
 * Authority used to decode calls and logs when using the
 * {@link TransactNamespace.simulateExecution} method.
 */ var DecodingAuthority;
(function(DecodingAuthority) {
    DecodingAuthority["ETHERSCAN"] = "ETHERSCAN";
})(DecodingAuthority || (DecodingAuthority = {}));
/** The type of call in a debug call trace. */ var DebugCallType;
(function(DebugCallType) {
    DebugCallType["CREATE"] = "CREATE";
    DebugCallType["CALL"] = "CALL";
    DebugCallType["STATICCALL"] = "STATICCALL";
    DebugCallType["DELEGATECALL"] = "DELEGATECALL";
})(DebugCallType || (DebugCallType = {}));
/**
 * Potential transaction job statuses for a {@link GasOptimizedTransactionResponse}
 *
 * @internal
 */ // TODO(txjob): Remove internal tag once this feature is released.
var GasOptimizedTransactionStatus;
(function(GasOptimizedTransactionStatus) {
    GasOptimizedTransactionStatus["UNSPECIFIED"] = "TRANSACTION_JOB_STATUS_UNSPECIFIED";
    GasOptimizedTransactionStatus["IN_PROGRESS"] = "IN_PROGRESS";
    GasOptimizedTransactionStatus["COMPLETE"] = "COMPLETE";
    GasOptimizedTransactionStatus["ABANDONED"] = "ABANDONED";
})(GasOptimizedTransactionStatus || (GasOptimizedTransactionStatus = {}));
/** The version of the webhook. All newly created webhooks default to V2. */ var WebhookVersion;
(function(WebhookVersion) {
    WebhookVersion["V1"] = "V1";
    WebhookVersion["V2"] = "V2";
})(WebhookVersion || (WebhookVersion = {}));
/** The type of {@link Webhook}. */ var WebhookType;
(function(WebhookType) {
    WebhookType["MINED_TRANSACTION"] = "MINED_TRANSACTION";
    WebhookType["DROPPED_TRANSACTION"] = "DROPPED_TRANSACTION";
    WebhookType["ADDRESS_ACTIVITY"] = "ADDRESS_ACTIVITY";
    WebhookType["NFT_ACTIVITY"] = "NFT_ACTIVITY";
    WebhookType["NFT_METADATA_UPDATE"] = "NFT_METADATA_UPDATE";
    WebhookType["GRAPHQL"] = "GRAPHQL";
})(WebhookType || (WebhookType = {}));
/**
 * Commitment level of the target block with using methods in the
 * {@link DebugNamespace}
 */ var CommitmentLevel;
(function(CommitmentLevel) {
    /**
     * Sample next block inferred by Alchemy built on top of the latest block.
     * This contains the set of transactions taken from the local mempool and
     * is a proxy for blocks that have not been mined yet.
     */ CommitmentLevel["PENDING"] = "pending";
    /**
     * The most recent block in the canonical chain observed by Alchemy. Note that
     * this block may be re-orged out of the canonical chain.
     */ CommitmentLevel["LATEST"] = "latest";
    /**
     * The most recent crypto-economically secure block that cannot be re-orged
     * outside of manual intervention driven by community coordination. This is
     * only available on {@link Network.ETH_GOERLI} and {@link Network.ETH_SEPOLIA}.
     */ CommitmentLevel["SAFE"] = "safe";
    /**
     * The most recent secure block that has been accepted by >2/3 of validators.
     * This block is very unlikely to be re-orged. This is only available on
     * {@link Network.ETH_GOERLI} and {@link Network.ETH_SEPOLIA}.
     */ CommitmentLevel["FINALIZED"] = "finalized";
    /**
     * The lowest numbered block available that is usually the first block created.
     */ CommitmentLevel["EARLIEST"] = "earliest";
})(CommitmentLevel || (CommitmentLevel = {}));
/**
 * The type of tracer to use when running debug methods in the
 * {@link DebugNamespace}.
 */ var DebugTracerType;
(function(DebugTracerType) {
    DebugTracerType["CALL_TRACER"] = "callTracer";
    DebugTracerType["PRESTATE_TRACER"] = "prestateTracer";
})(DebugTracerType || (DebugTracerType = {}));
/**
 * An enum for specifying the token type on NFTs.
 *
 * @public
 */ var NftTokenType;
(function(NftTokenType) {
    NftTokenType["ERC721"] = "ERC721";
    NftTokenType["ERC1155"] = "ERC1155";
    NftTokenType["NO_SUPPORTED_NFT_STANDARD"] = "NO_SUPPORTED_NFT_STANDARD";
    NftTokenType["NOT_A_CONTRACT"] = "NOT_A_CONTRACT";
    NftTokenType["UNKNOWN"] = "UNKNOWN";
})(NftTokenType || (NftTokenType = {}));
/** Potential reasons why an NFT contract was classified as spam. */ var NftSpamClassification;
(function(NftSpamClassification) {
    NftSpamClassification["Erc721TooManyOwners"] = "Erc721TooManyOwners";
    NftSpamClassification["Erc721TooManyTokens"] = "Erc721TooManyTokens";
    NftSpamClassification["Erc721DishonestTotalSupply"] = "Erc721DishonestTotalSupply";
    NftSpamClassification["MostlyHoneyPotOwners"] = "MostlyHoneyPotOwners";
    NftSpamClassification["OwnedByMostHoneyPots"] = "OwnedByMostHoneyPots";
    NftSpamClassification["LowDistinctOwnersPercent"] = "LowDistinctOwnersPercent";
    NftSpamClassification["HighHoneyPotOwnerPercent"] = "HighHoneyPotOwnerPercent";
    NftSpamClassification["HighHoneyPotPercent"] = "HighHoneyPotPercent";
    NftSpamClassification["HoneyPotsOwnMultipleTokens"] = "HoneyPotsOwnMultipleTokens";
    NftSpamClassification["NoSalesActivity"] = "NoSalesActivity";
    NftSpamClassification["HighAirdropPercent"] = "HighAirdropPercent";
    NftSpamClassification["Unknown"] = "Unknown";
})(NftSpamClassification || (NftSpamClassification = {}));
/**
 * Enum of NFT filters that can be applied to a {@link getNftsForOwner} or a
 * {@link getContractsForOwner} request.
 *
 * @beta
 */ var NftFilters;
(function(NftFilters) {
    /** NFTs that have been classified as spam. */ NftFilters["SPAM"] = "SPAM";
    /** NFTs that have been airdropped to a user. */ NftFilters["AIRDROPS"] = "AIRDROPS";
})(NftFilters || (NftFilters = {}));
/**
 * Enum of ordering that can be applied to a {@link getNftsForOwner} or a
 * {@link getContractsForOwner} response.
 *
 * @beta
 */ var NftOrdering;
(function(NftOrdering) {
    NftOrdering["TRANSFERTIME"] = "TRANSFERTIME";
})(NftOrdering || (NftOrdering = {}));
/**
 * Enum representing the supported NFT marketplaces by the
 * {@link NftNamespace.getNftSales} method.
 *
 * @public
 */ var NftSaleMarketplace;
(function(NftSaleMarketplace) {
    NftSaleMarketplace["SEAPORT"] = "seaport";
    NftSaleMarketplace["LOOKSRARE"] = "looksrare";
    NftSaleMarketplace["X2Y2"] = "x2y2";
    NftSaleMarketplace["WYVERN"] = "wyvern";
    NftSaleMarketplace["CRYPTOPUNKS"] = "cryptopunks";
    NftSaleMarketplace["BLUR"] = "blur";
    NftSaleMarketplace["UNKNOWN"] = "unknown";
})(NftSaleMarketplace || (NftSaleMarketplace = {}));
/**
 * Enum for specifying the taker type for the {@link NftNamespace.getNftSales}
 * method.
 *
 * @public
 */ var NftSaleTakerType;
(function(NftSaleTakerType) {
    NftSaleTakerType["BUYER"] = "buyer";
    NftSaleTakerType["SELLER"] = "seller";
})(NftSaleTakerType || (NftSaleTakerType = {}));
/** The current state of the NFT contract refresh process. */ var NftRefreshState;
(function(NftRefreshState) {
    /** The provided contract is not an NFT or does not contain metadata. */ NftRefreshState["DOES_NOT_EXIST"] = "does_not_exist";
    /** The contract has already been queued for refresh. */ NftRefreshState["ALREADY_QUEUED"] = "already_queued";
    /** The contract is currently being refreshed. */ NftRefreshState["IN_PROGRESS"] = "in_progress";
    /** The contract refresh is complete. */ NftRefreshState["FINISHED"] = "finished";
    /** The contract refresh has been queued and await execution. */ NftRefreshState["QUEUED"] = "queued";
    /** The contract was unable to be queued due to an internal error. */ NftRefreshState["QUEUE_FAILED"] = "queue_failed";
})(NftRefreshState || (NftRefreshState = {}));
/**
 * Enum representing the supported NFT marketplaces on a
 * {@link NftCollectionFloorPrice} object.
 */ var NftCollectionMarketplace;
(function(NftCollectionMarketplace) {
    NftCollectionMarketplace["OPENSEA"] = "OpenSea";
})(NftCollectionMarketplace || (NftCollectionMarketplace = {}));
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __awaiter$1(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
const DEFAULT_ALCHEMY_API_KEY = "demo";
const DEFAULT_NETWORK = Network.ETH_MAINNET;
const DEFAULT_MAX_RETRIES = 5;
const DEFAULT_REQUEST_TIMEOUT = 0; // 0 = no timeout
/**
 * Returns the base URL for making Alchemy API requests. The `alchemy.com`
 * endpoints only work with non eth json-rpc requests.
 *
 * @internal
 */ function getAlchemyHttpUrl(network, apiKey) {
    return `https://${network}.g.alchemy.com/v2/${apiKey}`;
}
function getAlchemyNftHttpUrl(network, apiKey) {
    return `https://${network}.g.alchemy.com/nft/v3/${apiKey}`;
}
function getAlchemyWsUrl(network, apiKey) {
    return `wss://${network}.g.alchemy.com/v2/${apiKey}`;
}
function getAlchemyWebhookHttpUrl() {
    return "https://dashboard.alchemy.com/api";
}
var AlchemyApiType;
(function(AlchemyApiType) {
    AlchemyApiType[AlchemyApiType["BASE"] = 0] = "BASE";
    AlchemyApiType[AlchemyApiType["NFT"] = 1] = "NFT";
    AlchemyApiType[AlchemyApiType["WEBHOOK"] = 2] = "WEBHOOK";
})(AlchemyApiType || (AlchemyApiType = {}));
/**
 * Mapping of network names to their corresponding Network strings used to
 * create an Ethers.js Provider instance.
 */ const EthersNetwork = {
    [Network.ETH_MAINNET]: "mainnet",
    [Network.ETH_GOERLI]: "goerli",
    [Network.ETH_SEPOLIA]: "sepolia",
    [Network.OPT_MAINNET]: "optimism",
    [Network.OPT_GOERLI]: "optimism-goerli",
    [Network.OPT_SEPOLIA]: "optimism-sepolia",
    [Network.ARB_MAINNET]: "arbitrum",
    [Network.ARB_GOERLI]: "arbitrum-goerli",
    [Network.ARB_SEPOLIA]: "arbitrum-sepolia",
    [Network.MATIC_MAINNET]: "matic",
    [Network.MATIC_MUMBAI]: "maticmum",
    [Network.MATIC_AMOY]: "maticamoy",
    [Network.ASTAR_MAINNET]: "astar-mainnet",
    [Network.POLYGONZKEVM_MAINNET]: "polygonzkevm-mainnet",
    [Network.POLYGONZKEVM_TESTNET]: "polygonzkevm-testnet",
    [Network.BASE_MAINNET]: "base-mainnet",
    [Network.BASE_GOERLI]: "base-goerli",
    [Network.BASE_SEPOLIA]: "base-sepolia",
    [Network.ZKSYNC_MAINNET]: "zksync-mainnet",
    [Network.ZKSYNC_SEPOLIA]: "zksync-sepolia"
};
/**
 * Mapping of network names to their corresponding Ethers Network objects. These
 * networks are not yet supported by Ethers and are listed here to be overriden
 * in the provider.
 */ const CustomNetworks = {
    "arbitrum-goerli": {
        chainId: 421613,
        name: "arbitrum-goerli"
    },
    "arbitrum-sepolia": {
        chainId: 421614,
        name: "arbitrum-sepolia"
    },
    "astar-mainnet": {
        chainId: 592,
        name: "astar-mainnet"
    },
    sepolia: {
        chainId: 11155111,
        name: "sepolia"
    },
    "optimism-sepolia": {
        chainId: 11155420,
        name: "optimism-sepolia"
    },
    "polygonzkevm-mainnet": {
        chainId: 1101,
        name: "polygonzkevm-mainnet"
    },
    "polygonzkevm-testnet": {
        chainId: 1442,
        name: "polygonzkevm-testnet"
    },
    "base-mainnet": {
        chainId: 8453,
        name: "base-mainnet"
    },
    "base-goerli": {
        chainId: 84531,
        name: "base-goerli"
    },
    "base-sepolia": {
        chainId: 84532,
        name: "base-sepolia"
    },
    maticamoy: {
        chainId: 80002,
        name: "maticamoy"
    },
    "zksync-mainnet": {
        chainId: 324,
        name: "zksync-mainnet"
    },
    "zksync-sepolia": {
        chainId: 300,
        name: "zksync-sepolia"
    }
};
function noop() {
// It's a no-op
}
const ETH_NULL_VALUE = "0x";
const ETH_NULL_ADDRESS = "0x0000000000000000000000000000000000000000";


/**
 * This class holds the config information for the SDK client instance and
 * exposes the underlying providers for more advanced use cases.
 *
 * @public
 */ class AlchemyConfig {
    constructor(config){
        this.apiKey = (config === null || config === void 0 ? void 0 : config.apiKey) || DEFAULT_ALCHEMY_API_KEY;
        this.network = (config === null || config === void 0 ? void 0 : config.network) || DEFAULT_NETWORK;
        this.maxRetries = (config === null || config === void 0 ? void 0 : config.maxRetries) || DEFAULT_MAX_RETRIES;
        this.url = config === null || config === void 0 ? void 0 : config.url;
        this.authToken = config === null || config === void 0 ? void 0 : config.authToken;
        this.batchRequests = (config === null || config === void 0 ? void 0 : config.batchRequests) || false;
        this.requestTimeout = (config === null || config === void 0 ? void 0 : config.requestTimeout) || DEFAULT_REQUEST_TIMEOUT;
        this.connectionInfoOverrides = config === null || config === void 0 ? void 0 : config.connectionInfoOverrides;
    }
    /**
     * Returns the URL endpoint to send the HTTP request to. If a custom URL was
     * provided in the config, that URL is returned. Otherwise, the default URL is
     * from the network and API key.
     *
     * @param apiType - The type of API to get the URL for.
     * @internal
     */ _getRequestUrl(apiType) {
        if (this.url !== undefined) return this.url;
        else if (apiType === AlchemyApiType.NFT) return getAlchemyNftHttpUrl(this.network, this.apiKey);
        else if (apiType === AlchemyApiType.WEBHOOK) return getAlchemyWebhookHttpUrl();
        else return getAlchemyHttpUrl(this.network, this.apiKey);
    }
    /**
     * Returns an AlchemyProvider instance. Only one provider is created per
     * Alchemy instance.
     *
     * The AlchemyProvider is a wrapper around ether's `AlchemyProvider` class and
     * has been expanded to support Alchemy's Enhanced APIs.
     *
     * Most common methods on the provider are available as top-level methods on
     * the {@link Alchemy} instance, but the provider is exposed here to access
     * other less-common methods.
     *
     * @public
     */ getProvider() {
        if (!this._baseAlchemyProvider) this._baseAlchemyProvider = (()=>__awaiter$1(this, void 0, void 0, function*() {
                const { AlchemyProvider } = yield (parcelRequire("36jM4"));
                return new AlchemyProvider(this);
            }))();
        return this._baseAlchemyProvider;
    }
    /**
     * Returns an AlchemyWebsocketProvider instance. Only one provider is created
     * per Alchemy instance.
     *
     * The AlchemyWebSocketProvider is a wrapper around ether's
     * `AlchemyWebSocketProvider` class and has been expanded to support Alchemy's
     * Subscription APIs, automatic backfilling, and other performance improvements.
     *
     * Most common methods on the provider are available as top-level methods on
     * the {@link Alchemy} instance, but the provider is exposed here to access
     * other less-common methods.
     */ getWebSocketProvider() {
        if (!this._baseAlchemyWssProvider) this._baseAlchemyWssProvider = (()=>__awaiter$1(this, void 0, void 0, function*() {
                const { AlchemyWebSocketProvider } = yield (parcelRequire("9Dozk"));
                return new AlchemyWebSocketProvider(this);
            }))();
        return this._baseAlchemyWssProvider;
    }
}
const version$1 = "logger/5.7.0";
let _permanentCensorErrors = false;
let _censorErrors = false;
const LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let _logLevel = LogLevels["default"];
let _globalLogger = null;
function _checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const _normalizeError = _checkNormalize();
var LogLevel$1;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})(LogLevel$1 || (LogLevel$1 = {}));
var ErrorCode;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})(ErrorCode || (ErrorCode = {}));
const HEX = "0123456789abcdef";
class Logger$1 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if (LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if (_logLevel > LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log(Logger$1.levels.DEBUG, args);
    }
    info(...args) {
        this._log(Logger$1.levels.INFO, args);
    }
    warn(...args) {
        this._log(Logger$1.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if (_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = Logger$1.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += HEX[value[i] >> 4];
                        hex += HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case ErrorCode.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case ErrorCode.CALL_EXCEPTION:
            case ErrorCode.INSUFFICIENT_FUNDS:
            case ErrorCode.MISSING_NEW:
            case ErrorCode.NONCE_EXPIRED:
            case ErrorCode.REPLACEMENT_UNDERPRICED:
            case ErrorCode.TRANSACTION_REPLACED:
            case ErrorCode.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, Logger$1.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (_normalizeError) this.throwError("platform missing String.prototype.normalize", Logger$1.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: _normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, Logger$1.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, Logger$1.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, Logger$1.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, Logger$1.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", Logger$1.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", Logger$1.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", Logger$1.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!_globalLogger) _globalLogger = new Logger$1(version$1);
        return _globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", Logger$1.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if (_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", Logger$1.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        _censorErrors = !!censorship;
        _permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            Logger$1.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        _logLevel = level;
    }
    static from(version) {
        return new Logger$1(version);
    }
}
Logger$1.errors = ErrorCode;
Logger$1.levels = LogLevel$1;
const version = "properties/5.7.0";
var __awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const logger = new Logger$1(version);
function defineReadOnly(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function resolveProperties(object) {
    return __awaiter(this, void 0, void 0, function*() {
        const promises = Object.keys(object).map((key)=>{
            const value = object[key];
            return Promise.resolve(value).then((v)=>({
                    key: key,
                    value: v
                }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result)=>{
            accum[result.key] = result.value;
            return accum;
        }, {});
    });
}
const opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function _isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || opaque[typeof object]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        const keys = Object.keys(object);
        for(let i = 0; i < keys.length; i++){
            let value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!_isFrozen(value)) return false;
        }
        return true;
    }
    return logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function _deepCopy(object) {
    if (_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map((item)=>deepCopy(item)));
    if (typeof object === "object") {
        const result = {};
        for(const key in object){
            const value = object[key];
            if (value === undefined) continue;
            defineReadOnly(result, key, deepCopy(value));
        }
        return result;
    }
    return logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
function deepCopy(object) {
    return _deepCopy(object);
}
/**
 * Converts a hex string to a decimal number.
 *
 * @param hexString - The hex string to convert.
 * @public
 */ function fromHex(hexString) {
    return (0, $20M69.BigNumber).from(hexString).toNumber();
}
/**
 * Converts a number to a hex string.
 *
 * @param num - The number to convert to hex.
 * @public
 */ function toHex(num) {
    return (0, $20M69.BigNumber).from(num).toHexString();
}
/**
 * Checks if a value is a hex string.
 *
 * @param possibleHexString - The value to check.
 * @public
 */ function isHex(possibleHexString) {
    return /^0x[0-9a-fA-F]+$/.test(possibleHexString);
}
function formatBlock(block) {
    if (typeof block === "string") return block;
    else if (Number.isInteger(block)) return toHex(block);
    return block.toString();
}
function stringToEnum(x, enumb) {
    return Object.values(enumb).includes(x) ? x : null;
}
function getNftContractForNftFromRaw(rawNftContract) {
    return nullsToUndefined(Object.assign(Object.assign({}, getNftContractFromRaw(rawNftContract)), {
        spamClassifications: rawNftContract.spamClassifications.map(parseNftSpamClassification)
    }));
}
function getNftContractsForOwnerFromRaw(rawNftContract) {
    return nullsToUndefined(Object.assign(Object.assign({}, getNftContractFromRaw(rawNftContract)), {
        displayNft: rawNftContract.displayNft,
        image: rawNftContract.image,
        totalBalance: rawNftContract.totalBalance,
        numDistinctTokensOwned: rawNftContract.numDistinctTokensOwned,
        isSpam: rawNftContract.isSpam
    }));
}
function getNftContractFromRaw(rawNftContract) {
    var _a;
    return nullsToUndefined(Object.assign(Object.assign({}, rawNftContract), {
        tokenType: parseNftTokenType(rawNftContract.tokenType),
        openSeaMetadata: Object.assign(Object.assign({}, rawNftContract.openSeaMetadata), {
            safelistRequestStatus: ((_a = rawNftContract.openSeaMetadata) === null || _a === void 0 ? void 0 : _a.safelistRequestStatus) !== null ? stringToEnum(rawNftContract.openSeaMetadata.safelistRequestStatus, OpenSeaSafelistRequestStatus) : null
        })
    }));
}
function getNftCollectionFromRaw(rawNftCollection) {
    return nullsToUndefined(Object.assign(Object.assign({}, rawNftCollection), {
        floorPrice: Object.assign(Object.assign({}, rawNftCollection.floorPrice), {
            marketplace: parseNftCollectionMarketplace(rawNftCollection.floorPrice.marketplace)
        })
    }));
}
function getBaseNftFromRaw(rawBaseNft, contractAddress) {
    return {
        contractAddress: contractAddress ? contractAddress : rawBaseNft.contractAddress,
        tokenId: rawBaseNft.tokenId
    };
}
function getNftFromRaw(rawNft) {
    return nullsToUndefined(Object.assign(Object.assign({}, rawNft), {
        contract: getNftContractForNftFromRaw(rawNft.contract),
        tokenType: parseNftTokenType(rawNft.tokenType),
        acquiredAt: rawNft.acquiredAt,
        collection: rawNft.collection,
        mint: rawNft.mint
    }));
}
function getNftSalesFromRaw(rawNftSales) {
    return nullsToUndefined({
        nftSales: rawNftSales.nftSales.map((rawNftSale)=>Object.assign(Object.assign({}, rawNftSale), {
                marketplace: parseNftSaleMarketplace(rawNftSale.marketplace),
                taker: parseNftTaker(rawNftSale.taker)
            })),
        validAt: rawNftSales.validAt,
        pageKey: rawNftSales.pageKey
    });
}
function parseNftSaleMarketplace(marketplace) {
    switch(marketplace){
        case "looksrare":
            return NftSaleMarketplace.LOOKSRARE;
        case "seaport":
            return NftSaleMarketplace.SEAPORT;
        case "x2y2":
            return NftSaleMarketplace.X2Y2;
        case "wyvern":
            return NftSaleMarketplace.WYVERN;
        case "cryptopunks":
            return NftSaleMarketplace.CRYPTOPUNKS;
        case "blur":
            return NftSaleMarketplace.BLUR;
        default:
            return NftSaleMarketplace.UNKNOWN;
    }
}
function parseNftCollectionMarketplace(marketplace) {
    switch(marketplace){
        case "OpenSea":
            return NftCollectionMarketplace.OPENSEA;
        default:
            return undefined;
    }
}
function parseNftTaker(taker) {
    // The `.toLowerCase()` call is needed because the API returns the capitalized values
    switch(taker.toLowerCase()){
        case "buyer":
            return NftSaleTakerType.BUYER;
        case "seller":
            return NftSaleTakerType.SELLER;
        default:
            throw new Error(`Unsupported NftSaleTakerType ${taker}`);
    }
}
function parseNftSpamClassification(s) {
    const res = stringToEnum(s, NftSpamClassification);
    if (res == null) return NftSpamClassification.Unknown;
    return res;
}
function parseNftTokenType(tokenType) {
    switch(tokenType){
        case "erc721":
        case "ERC721":
            return NftTokenType.ERC721;
        case "erc1155":
        case "ERC1155":
            return NftTokenType.ERC1155;
        case "no_supported_nft_standard":
        case "NO_SUPPORTED_NFT_STANDARD":
            return NftTokenType.NO_SUPPORTED_NFT_STANDARD;
        case "not_a_contract":
        case "NOT_A_CONTRACT":
            return NftTokenType.NOT_A_CONTRACT;
        default:
            return NftTokenType.UNKNOWN;
    }
}
const IS_BROWSER = typeof window !== "undefined" && window !== null;
function nullsToUndefined(obj) {
    if (obj === null || obj === undefined) return undefined;
    if (obj.constructor.name === "Object" || Array.isArray(obj)) for(const key in obj)obj[key] = nullsToUndefined(obj[key]);
    return obj;
}
/**
 * This file contains the underlying implementations for exposed API surface in
 * the {@link CoreNamespace}. By moving the methods out into a separate file,
 * other namespaces can access these methods without depending on the entire
 * CoreNamespace, or override the `srcMethod` param used for logging.
 */ /**
 * Gets the asset transfers for the provided params.
 */ function getAssetTransfers(config, params, srcMethod = "getAssetTransfers") {
    return __awaiter$1(this, void 0, void 0, function*() {
        const provider = yield config.getProvider();
        if (params.fromAddress) params.fromAddress = yield provider._getAddress(params.fromAddress);
        if (params.toAddress) params.toAddress = yield provider._getAddress(params.toAddress);
        return provider._send("alchemy_getAssetTransfers", [
            Object.assign(Object.assign({}, params), {
                fromBlock: params.fromBlock != null ? formatBlock(params.fromBlock) : undefined,
                toBlock: params.toBlock != null ? formatBlock(params.toBlock) : undefined,
                maxCount: params.maxCount != null ? toHex(params.maxCount) : undefined
            })
        ], srcMethod);
    });
}
function getTransactionReceipts(config, params, srcMethod = "getTransactionReceipts") {
    return __awaiter$1(this, void 0, void 0, function*() {
        const provider = yield config.getProvider();
        return provider._send("alchemy_getTransactionReceipts", [
            params
        ], srcMethod);
    });
}
/**
 * This method is based on the ethers implementation of getLogs, but is expanded
 * to support specifying an address array in the filter.
 *
 * The main modifications made to support an address array are:
 * - Custom `getFilter()` method that supports an address array
 * - Use of `arrayOf()` formatter to format the logs to avoid the `Formatter` import.
 * - Use of `provider.send()` to avoid formatting logic in `provider.perform()`.
 */ function getLogs(config, filter) {
    return __awaiter$1(this, void 0, void 0, function*() {
        const provider = yield config.getProvider();
        yield provider.getNetwork();
        const params = yield resolveProperties({
            filter: getFilter(config, filter)
        });
        const logs = yield provider.send("eth_getLogs", [
            params.filter
        ]);
        logs.forEach((log)=>{
            if (log.removed == null) log.removed = false;
        });
        return arrayOf(provider.formatter.filterLog.bind(provider.formatter))(logs);
    });
}
/**
 * This method is based on and copied from the ethers implementation of
 * `JsonRpcProvider._getFilter()`, but is extended to support an address array.
 *
 * This implementation is a hacky way to get around the ethers formatter. The
 * formatter is used to check the types of the `filter` params, but ethers does
 * not allow an array in the `address` field. To preserve the ethers formatter
 * on the other fields, we use the formatter to check the types of those other
 * fields, and then manually check the `address` field last.
 */ function getFilter(config, filter) {
    return __awaiter$1(this, void 0, void 0, function*() {
        // START MODIFIED CODE
        const provider = yield config.getProvider();
        const resolvedFilter = yield filter;
        let result = {};
        // END MODIFIED CODE
        [
            "blockHash",
            "topics"
        ].forEach((key)=>{
            if (resolvedFilter[key] == null) return;
            result[key] = resolvedFilter[key];
        });
        [
            "fromBlock",
            "toBlock"
        ].forEach((key)=>{
            if (resolvedFilter[key] == null) return;
            result[key] = provider._getBlockTag(resolvedFilter[key]);
        });
        // BEGIN MODIFIED CODE
        // Format the `result` object using the ethers formatter without the `address`
        // field.
        result = provider.formatter.filter((yield resolveProperties(result)));
        // After formatting the other fields, manually format the `address` field
        // before adding it to the `result` object.
        if (Array.isArray(resolvedFilter.address)) result.address = yield Promise.all(resolvedFilter.address.map((address)=>__awaiter$1(this, void 0, void 0, function*() {
                return provider._getAddress(address);
            })));
        else if (resolvedFilter.address != null) result.address = yield provider._getAddress(resolvedFilter.address);
        return result;
    // END MODIFIED CODE
    });
}
/**
 * DO NOT MODIFY.
 *
 * This function is directly copied over from ethers implementation of
 * `Formatter.arrayOf()`. It is copied here to avoid having to import the
 * `Formatter` class or `FormatterFunc` type from ethers, that are not part of
 * the default export.
 *
 * This function returns a function that applies the formatter to an array of
 * values, and is used to format the logs returned by `getLogs()`.
 */ function arrayOf(format) {
    return function(array) {
        if (!Array.isArray(array)) throw new Error("not an array");
        const result = [];
        array.forEach((value)=>{
            result.push(format(value));
        });
        return result;
    };
}
/**
 * The core namespace contains all commonly-used [Ethers.js
 * Provider](https://docs.ethers.io/v5/api/providers/api-providers/#AlchemyProvider)
 * methods. If you are already using Ethers.js, you should be simply able to
 * replace the Ethers.js Provider object with `alchemy.core` when accessing
 * provider methods and it should just work.
 *
 * Do not call this constructor directly. Instead, instantiate an Alchemy object
 * with `const alchemy = new Alchemy(config)` and then access the core namespace
 * via `alchemy.core`.
 */ class CoreNamespace {
    /** @internal */ constructor(config){
        this.config = config;
    }
    /**
     * Returns the balance of a given address as of the provided block.
     *
     * @param addressOrName The address or name of the account to get the balance for.
     * @param blockTag The optional block number or hash to get the balance for.
     *   Defaults to 'latest' if unspecified.
     * @public
     */ getBalance(addressOrName, blockTag) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.getBalance(addressOrName, blockTag);
        });
    }
    /**
     * Checks if the provided address is a smart contract.
     *
     * @param address The address to check type for.
     * @public
     */ isContractAddress(address) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            const code = yield provider.getCode(address);
            return code !== "0x";
        });
    }
    /**
     * Returns the contract code of the provided address at the block. If there is
     * no contract deployed, the result is `0x`.
     *
     * @param addressOrName The address or name of the account to get the code for.
     * @param blockTag The optional block number or hash to get the code for.
     *   Defaults to 'latest' if unspecified.
     * @public
     */ getCode(addressOrName, blockTag) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.getCode(addressOrName, blockTag);
        });
    }
    /**
     * Return the value of the provided position at the provided address, at the
     * provided block in `Bytes32` format.
     *
     * @param addressOrName The address or name of the account to get the code for.
     * @param position The position of the storage slot to get.
     * @param blockTag The optional block number or hash to get the code for.
     *   Defaults to 'latest' if unspecified.
     * @public
     */ getStorageAt(addressOrName, position, blockTag) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.getStorageAt(addressOrName, position, blockTag);
        });
    }
    /**
     * Returns the number of transactions ever sent from the provided address, as
     * of the provided block tag. This value is used as the nonce for the next
     * transaction from the address sent to the network.
     *
     * @param addressOrName The address or name of the account to get the nonce for.
     * @param blockTag The optional block number or hash to get the nonce for.
     * @public
     */ getTransactionCount(addressOrName, blockTag) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.getTransactionCount(addressOrName, blockTag);
        });
    }
    /**
     * Returns the block from the network based on the provided block number or
     * hash. Transactions on the block are represented as an array of transaction
     * hashes. To get the full transaction details on the block, use
     * {@link getBlockWithTransactions} instead.
     *
     * @param blockHashOrBlockTag The block number or hash to get the block for.
     * @public
     */ getBlock(blockHashOrBlockTag) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.getBlock(blockHashOrBlockTag);
        });
    }
    /**
     * Returns the block from the network based on the provided block number or
     * hash. Transactions on the block are represented as an array of
     * {@link TransactionResponse} objects.
     *
     * @param blockHashOrBlockTag The block number or hash to get the block for.
     * @public
     */ getBlockWithTransactions(blockHashOrBlockTag) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.getBlockWithTransactions(blockHashOrBlockTag);
        });
    }
    /**
     * Returns the {@link EthersNetworkAlias} Alchemy is connected to.
     *
     * @public
     */ getNetwork() {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.getNetwork();
        });
    }
    /**
     * Returns the block number of the most recently mined block.
     *
     * @public
     */ getBlockNumber() {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.getBlockNumber();
        });
    }
    /**
     * Returns the best guess of the current gas price to use in a transaction.
     *
     * @public
     */ getGasPrice() {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.getGasPrice();
        });
    }
    /**
     * Returns the recommended fee data to use in a transaction.
     *
     * For an EIP-1559 transaction, the maxFeePerGas and maxPriorityFeePerGas
     * should be used.
     *
     * For legacy transactions and networks which do not support EIP-1559, the
     * gasPrice should be used.
     *
     * @public
     */ getFeeData() {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.getFeeData();
        });
    }
    /**
     * Returns a Promise which will stall until the network has heen established,
     * ignoring errors due to the target node not being active yet.
     *
     * This can be used for testing or attaching scripts to wait until the node is
     * up and running smoothly.
     *
     * @public
     */ ready() {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.ready;
        });
    }
    /**
     * Returns the result of executing the transaction, using call. A call does
     * not require any ether, but cannot change any state. This is useful for
     * calling getters on Contracts.
     *
     * @param transaction The transaction to execute.
     * @param blockTag The optional block number or hash to get the call for.
     * @public
     */ call(transaction, blockTag) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.call(transaction, blockTag);
        });
    }
    /**
     * Returns an estimate of the amount of gas that would be required to submit
     * transaction to the network.
     *
     * An estimate may not be accurate since there could be another transaction on
     * the network that was not accounted for, but after being mined affects the
     * relevant state.
     *
     * This is an alias for {@link TransactNamespace.estimateGas}.
     *
     * @param transaction The transaction to estimate gas for.
     * @public
     */ estimateGas(transaction) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.estimateGas(transaction);
        });
    }
    /**
     * Returns the transaction with hash or null if the transaction is unknown.
     *
     * If a transaction has not been mined, this method will search the
     * transaction pool. Various backends may have more restrictive transaction
     * pool access (e.g. if the gas price is too low or the transaction was only
     * recently sent and not yet indexed) in which case this method may also return null.
     *
     * NOTE: This is an alias for {@link TransactNamespace.getTransaction}.
     *
     * @param transactionHash The hash of the transaction to get.
     * @public
     */ getTransaction(transactionHash) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.getTransaction(transactionHash);
        });
    }
    /**
     * Returns the transaction receipt for hash or null if the transaction has not
     * been mined.
     *
     * To stall until the transaction has been mined, consider the
     * waitForTransaction method below.
     *
     * @param transactionHash The hash of the transaction to get.
     * @public
     */ getTransactionReceipt(transactionHash) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.getTransactionReceipt(transactionHash);
        });
    }
    /**
     * Submits transaction to the network to be mined. The transaction must be
     * signed, and be valid (i.e. the nonce is correct and the account has
     * sufficient balance to pay for the transaction).
     *
     * NOTE: This is an alias for {@link TransactNamespace.getTransaction}.
     *
     * @param signedTransaction The signed transaction to send.
     * @public
     */ sendTransaction(signedTransaction) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.sendTransaction(signedTransaction);
        });
    }
    /**
     * Returns a promise which will not resolve until specified transaction hash is mined.
     *
     * If {@link confirmations} is 0, this method is non-blocking and if the
     * transaction has not been mined returns null. Otherwise, this method will
     * block until the transaction has confirmed blocks mined on top of the block
     * in which it was mined.
     *
     * NOTE: This is an alias for {@link TransactNamespace.getTransaction}.
     *
     * @param transactionHash The hash of the transaction to wait for.
     * @param confirmations The number of blocks to wait for.
     * @param timeout The maximum time to wait for the transaction to confirm.
     * @public
     */ waitForTransaction(transactionHash, confirmations, timeout) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.waitForTransaction(transactionHash, confirmations, timeout);
        });
    }
    /**
     * Returns an array of logs that match the provided filter.
     *
     * @param filter The filter object to use.
     * @public
     */ getLogs(filter) {
        return __awaiter$1(this, void 0, void 0, function*() {
            return getLogs(this.config, filter);
        });
    }
    /**
     * Allows sending a raw message to the Alchemy backend.
     *
     * @param method The method to call.
     * @param params The parameters to pass to the method.
     * @public
     */ send(method, params) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.send(method, params);
        });
    }
    /**
     * Finds the address that deployed the provided contract and block number it
     * was deployed in.
     *
     * NOTE: This method performs a binary search across all blocks since genesis
     * and can take a long time to complete. This method is a convenience method
     * that will eventually be replaced by a single call to an Alchemy endpoint
     * with this information cached.
     *
     * @param contractAddress - The contract address to find the deployer for.
     * @beta
     */ findContractDeployer(contractAddress) {
        var _a;
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            const currentBlockNum = yield provider.getBlockNumber();
            if ((yield provider.getCode(contractAddress, currentBlockNum)) === ETH_NULL_VALUE) throw new Error(`Contract '${contractAddress}' does not exist`);
            // Binary search for the block number that the contract was deployed in.
            const firstBlock = yield binarySearchFirstBlock(0, currentBlockNum + 1, contractAddress, this.config);
            // Find the first transaction in the block that matches the provided address.
            const txReceipts = yield getTransactionReceipts(this.config, {
                blockNumber: toHex(firstBlock)
            }, "findContractDeployer");
            const matchingReceipt = (_a = txReceipts.receipts) === null || _a === void 0 ? void 0 : _a.find((receipt)=>receipt.contractAddress === contractAddress.toLowerCase());
            return {
                deployerAddress: matchingReceipt === null || matchingReceipt === void 0 ? void 0 : matchingReceipt.from,
                blockNumber: firstBlock
            };
        });
    }
    getTokenBalances(addressOrName, contractAddressesOrOptions) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            const address = yield provider._getAddress(addressOrName);
            if (Array.isArray(contractAddressesOrOptions)) {
                if (contractAddressesOrOptions.length > 1500) throw new Error("You cannot pass in more than 1500 contract addresses to getTokenBalances()");
                if (contractAddressesOrOptions.length === 0) throw new Error("getTokenBalances() requires at least one contractAddress when using an array");
                return provider._send("alchemy_getTokenBalances", [
                    address,
                    contractAddressesOrOptions
                ], "getTokenBalances");
            } else {
                const tokenType = contractAddressesOrOptions === undefined ? TokenBalanceType.ERC20 : contractAddressesOrOptions.type;
                const params = [
                    address,
                    tokenType
                ];
                if ((contractAddressesOrOptions === null || contractAddressesOrOptions === void 0 ? void 0 : contractAddressesOrOptions.type) === TokenBalanceType.ERC20 && contractAddressesOrOptions.pageKey) params.push({
                    pageKey: contractAddressesOrOptions.pageKey
                });
                return provider._send("alchemy_getTokenBalances", params, "getTokenBalances");
            }
        });
    }
    /**
     * Returns the tokens that the specified address owns, along with the amount
     * of each token and the relevant metadata.
     *
     * @param addressOrName The owner address to get the tokens with balances for.
     * @param options Additional options to pass to the request.
     * @public
     */ getTokensForOwner(addressOrName, options) {
        var _a;
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            const address = yield provider._getAddress(addressOrName);
            const params = [
                address,
                (_a = options === null || options === void 0 ? void 0 : options.contractAddresses) !== null && _a !== void 0 ? _a : TokenBalanceType.ERC20
            ];
            if (options === null || options === void 0 ? void 0 : options.pageKey) params.push({
                pageKey: options.pageKey
            });
            const response = yield provider._send("alchemy_getTokenBalances", params, "getTokensForOwner");
            const formattedBalances = response.tokenBalances.map((balance)=>({
                    contractAddress: balance.contractAddress,
                    rawBalance: (0, $20M69.BigNumber).from(balance.tokenBalance).toString()
                }));
            const metadataPromises = yield Promise.allSettled(response.tokenBalances.map((token)=>provider._send("alchemy_getTokenMetadata", [
                    token.contractAddress
                ], "getTokensForOwner", /* forceBatch= */ true)));
            const metadata = metadataPromises.map((p)=>p.status === "fulfilled" ? p.value : {
                    name: null,
                    symbol: null,
                    decimals: null,
                    logo: null
                });
            const ownedTokens = formattedBalances.map((balance, index)=>Object.assign(Object.assign(Object.assign({}, balance), metadata[index]), {
                    balance: metadata[index].decimals !== null ? (0, $i5QkU.formatUnits)(balance.rawBalance, metadata[index].decimals) : undefined
                }));
            return {
                tokens: ownedTokens.map((t)=>nullsToUndefined(t)),
                pageKey: response.pageKey
            };
        });
    }
    /**
     * Returns metadata for a given token contract address.
     *
     * @param address The contract address to get metadata for.
     * @public
     */ getTokenMetadata(address) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider._send("alchemy_getTokenMetadata", [
                address
            ], "getTokenMetadata");
        });
    }
    getAssetTransfers(params) {
        return __awaiter$1(this, void 0, void 0, function*() {
            return getAssetTransfers(this.config, params);
        });
    }
    /**
     * Gets all transaction receipts for a given block by number or block hash.
     *
     * @param params An object containing fields for the transaction receipt query.
     * @public
     */ getTransactionReceipts(params) {
        return __awaiter$1(this, void 0, void 0, function*() {
            return getTransactionReceipts(this.config, params);
        });
    }
    /**
     * Returns the underlying owner address for the provided ENS address, or `null`
     * if the ENS name does not have an underlying address.
     *
     * @param name The ENS address name to resolve.
     */ resolveName(name) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.resolveName(name);
        });
    }
    /**
     * Performs a reverse lookup of the address in ENS using the Reverse Registrar. If the name does not exist, or the forward lookup does not match, null is returned.
     *
     * An ENS name requires additional configuration to setup a reverse record, so not all ENS addresses will map back to the original ENS domain.
     *
     * @param address The address to look up the ENS domain name for.
     */ lookupAddress(address) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.lookupAddress(address);
        });
    }
}
/**
 * Perform a binary search between an integer range of block numbers to find the
 * block number where the contract was deployed.
 *
 * @internal
 */ function binarySearchFirstBlock(start, end, address, config) {
    return __awaiter$1(this, void 0, void 0, function*() {
        if (start >= end) return end;
        const mid = Math.floor((start + end) / 2);
        const provider = yield config.getProvider();
        const code = yield provider.getCode(address, mid);
        if (code === ETH_NULL_VALUE) return binarySearchFirstBlock(mid + 1, end, address, config);
        return binarySearchFirstBlock(start, mid, address, config);
    });
}
/**
 * The Debug namespace contains methods to access the non-standard RPC methods
 * for inspecting and debugging transactions.
 *
 * For more information on the different methods and use cases please read our
 * [documentation](https://docs.alchemy.com/reference/debug-api-quickstart).
 *
 * Do not call this constructor directly. Instead, instantiate an Alchemy object
 * with `const alchemy = new Alchemy(config)` and then access the debug namespace
 * via `alchemy.debug`.
 */ class DebugNamespace {
    /** @internal */ constructor(config){
        this.config = config;
    }
    traceCall(transaction, blockIdentifier, tracer) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            const params = [
                transaction,
                blockIdentifier,
                parseTracerParams(tracer)
            ];
            return provider._send("debug_traceCall", params, "traceCall");
        });
    }
    traceTransaction(transactionHash, tracer, timeout) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            const params = [
                transactionHash,
                parseTracerParams(tracer, timeout)
            ];
            return provider._send("debug_traceTransaction", params, "traceTransaction");
        });
    }
    traceBlock(blockIdentifier, tracer) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            let method;
            let params;
            if ((0, $eBLyT.isHexString)(blockIdentifier, 32)) {
                method = "debug_traceBlockByHash";
                params = [
                    blockIdentifier,
                    parseTracerParams(tracer)
                ];
            } else {
                method = "debug_traceBlockByNumber";
                const block = typeof blockIdentifier === "number" ? (0, $eBLyT.hexStripZeros)((0, $eBLyT.hexValue)(blockIdentifier)) : blockIdentifier;
                params = [
                    block,
                    parseTracerParams(tracer)
                ];
            }
            return provider._send(method, params, "traceBlock");
        });
    }
}
function parseTracerParams(tracer, timeout) {
    return Object.assign({
        tracer: tracer.type
    }, tracer.onlyTopCall !== undefined && {
        tracerConfig: {
            onlyTopCall: tracer.onlyTopCall,
            timeout: timeout
        }
    });
}
function sanitizeTokenType(tokenType) {
    if (tokenType === NftTokenType.ERC1155 || tokenType === NftTokenType.ERC721) return tokenType;
    return undefined;
}
/**
 * The SDK has 4 log levels and a 5th option for disabling all logging. By
 * default, the log level is set to INFO.
 *
 * The order is a follows: DEBUG < INFO < WARN < ERROR
 *
 * All log types above the current log level will be outputted.
 */ var LogLevel;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 1] = "INFO";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["ERROR"] = 3] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 4] = "SILENT";
})(LogLevel || (LogLevel = {}));
const logLevelStringToEnum = {
    debug: LogLevel.DEBUG,
    info: LogLevel.INFO,
    warn: LogLevel.WARN,
    error: LogLevel.ERROR,
    silent: LogLevel.SILENT
};
// HACKY: Use the console method as a string rather than the function itself
// in order to allow for mocking in tests.
const logLevelToConsoleFn = {
    [LogLevel.DEBUG]: "log",
    [LogLevel.INFO]: "info",
    [LogLevel.WARN]: "warn",
    [LogLevel.ERROR]: "error"
};
const DEFAULT_LOG_LEVEL = LogLevel.INFO;
/**
 * Configures the verbosity of logging. The default log level is `info`.
 *
 * @param logLevel - The verbosity of logging. Can be any of the following values:
 *
 *   - `debug`: The most verbose logging level.
 *   - `info`: The default logging level.
 *   - `warn`: A logging level for non-critical issues.
 *   - `error`: A logging level for critical issues.
 *   - `silent`: Turn off all logging.
 *
 * @public
 */ function setLogLevel(logLevel) {
    loggerClient.logLevel = logLevelStringToEnum[logLevel];
}
function logDebug(message, ...args) {
    loggerClient.debug(message, args);
}
function logInfo(message, ...args) {
    loggerClient.info(message, args);
}
function logWarn(message, ...args) {
    loggerClient.warn(message, args);
}
class Logger {
    constructor(){
        /** The log level of the given Logger instance. */ this._logLevel = DEFAULT_LOG_LEVEL;
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in LogLevel)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    debug(...args) {
        this._log(LogLevel.DEBUG, ...args);
    }
    info(...args) {
        this._log(LogLevel.INFO, ...args);
    }
    warn(...args) {
        this._log(LogLevel.WARN, ...args);
    }
    error(...args) {
        this._log(LogLevel.ERROR, ...args);
    }
    /**
     * Forwards log messages to their corresponding console counterparts if the
     * log level allows it.
     */ _log(logLevel, ...args) {
        if (logLevel < this._logLevel) return;
        const now = new Date().toISOString();
        const method = logLevelToConsoleFn[logLevel];
        if (method) console[method](`[${now}] Alchemy:`, ...args.map(stringify));
        else throw new Error(`Logger received an invalid logLevel (value: ${logLevel})`);
    }
}
function stringify(obj) {
    if (typeof obj === "string") return obj;
    else try {
        return JSON.stringify(obj);
    } catch (e) {
        // Failed to convert to JSON, log the object directly.
        return obj;
    }
}
// Instantiate default logger for the SDK.
const loggerClient = new Logger();
// This file is autogenerated by injectVersion.js. Any changes will be
// overwritten on commit!
const VERSION = "3.3.1";
/**
 * Given a REST endpoint, method, and params, sends the request with axios and
 * returns the response.
 */ /**
 * Helper function to send http requests using Axis.
 *
 * @private
 */ function sendAxiosRequest(baseUrl, restApiName, methodName, params, overrides) {
    var _a;
    const requestUrl = baseUrl + "/" + restApiName;
    const config = Object.assign(Object.assign({}, overrides), {
        headers: Object.assign(Object.assign(Object.assign({}, overrides === null || overrides === void 0 ? void 0 : overrides.headers), !IS_BROWSER && {
            "Accept-Encoding": "gzip"
        }), {
            "Alchemy-Ethers-Sdk-Version": VERSION,
            "Alchemy-Ethers-Sdk-Method": methodName
        }),
        method: (_a = overrides === null || overrides === void 0 ? void 0 : overrides.method) !== null && _a !== void 0 ? _a : "GET",
        url: requestUrl,
        params: params
    });
    return (0, $8AUfX.default)(config);
}
const DEFAULT_BACKOFF_INITIAL_DELAY_MS = 1000;
const DEFAULT_BACKOFF_MULTIPLIER = 1.5;
const DEFAULT_BACKOFF_MAX_DELAY_MS = 30000;
const DEFAULT_BACKOFF_MAX_ATTEMPTS = 5;
/**
 * Helper class for implementing exponential backoff and max retry attempts.
 *
 * @private
 * @internal
 */ class ExponentialBackoff {
    constructor(maxAttempts = DEFAULT_BACKOFF_MAX_ATTEMPTS){
        this.maxAttempts = maxAttempts;
        this.initialDelayMs = DEFAULT_BACKOFF_INITIAL_DELAY_MS;
        this.backoffMultiplier = DEFAULT_BACKOFF_MULTIPLIER;
        this.maxDelayMs = DEFAULT_BACKOFF_MAX_DELAY_MS;
        this.numAttempts = 0;
        this.currentDelayMs = 0;
        this.isInBackoff = false;
    }
    /**
     * Returns a promise that resolves after the the backoff delay. The delay is
     * increased for each attempt. The promise is rejected if the maximum number
     * of attempts is exceeded.
     */ // TODO: beautify this into an async iterator.
    backoff() {
        if (this.numAttempts >= this.maxAttempts) return Promise.reject(new Error(`Exceeded maximum number of attempts: ${this.maxAttempts}`));
        if (this.isInBackoff) return Promise.reject(new Error("A backoff operation is already in progress"));
        const backoffDelayWithJitterMs = this.withJitterMs(this.currentDelayMs);
        if (backoffDelayWithJitterMs > 0) logDebug("ExponentialBackoff.backoff", `Backing off for ${backoffDelayWithJitterMs}ms`);
        // Calculate the next delay.
        this.currentDelayMs *= this.backoffMultiplier;
        this.currentDelayMs = Math.max(this.currentDelayMs, this.initialDelayMs);
        this.currentDelayMs = Math.min(this.currentDelayMs, this.maxDelayMs);
        this.numAttempts += 1;
        return new Promise((resolve)=>{
            this.isInBackoff = true;
            setTimeout(()=>{
                this.isInBackoff = false;
                resolve();
            }, backoffDelayWithJitterMs);
        });
    }
    /**
     * Applies +/- 50% jitter to the backoff delay, up to the max delay cap.
     *
     * @private
     * @param delayMs
     */ withJitterMs(delayMs) {
        return Math.min(delayMs + (Math.random() - 0.5) * delayMs, this.maxDelayMs);
    }
}
/**
 * A wrapper function to make http requests and retry if the request fails.
 *
 * @internal
 */ // TODO: Wrap Axios error in AlchemyError.
function requestHttpWithBackoff(config, apiType, restApiName, methodName, params, overrides) {
    return __awaiter$1(this, void 0, void 0, function*() {
        let lastError = undefined;
        const backoff = new ExponentialBackoff(config.maxRetries);
        for(let attempt = 0; attempt < config.maxRetries + 1; attempt++)try {
            if (lastError !== undefined) logInfo("requestHttp", `Retrying after error: ${lastError.message}`);
            try {
                yield backoff.backoff();
            } catch (err) {
                break;
            }
            const response = yield sendAxiosRequest(config._getRequestUrl(apiType), restApiName, methodName, params, Object.assign(Object.assign({}, overrides), {
                timeout: config.requestTimeout
            }));
            if (response.status === 200) {
                logDebug(restApiName, `Successful request: ${restApiName}`);
                return response.data;
            } else {
                logInfo(restApiName, `Request failed: ${restApiName}, ${response.status}, ${response.data}`);
                lastError = new Error(response.status + ": " + response.data);
            }
        } catch (err) {
            if (!(0, $8AUfX.default).isAxiosError(err) || err.response === undefined) throw err;
            // TODO: Standardize all errors into AlchemyError
            lastError = new Error(err.response.status + ": " + JSON.stringify(err.response.data));
            if (!isRetryableHttpError(err, apiType)) break;
        }
        return Promise.reject(lastError);
    });
}
function isRetryableHttpError(err, apiType) {
    // TODO: remove 500s after webhooks are more stable.
    const retryableCodes = apiType === AlchemyApiType.WEBHOOK ? [
        429,
        500
    ] : [
        429
    ];
    return err.response !== undefined && retryableCodes.includes(err.response.status);
}
/**
 * Fetches all pages in a paginated endpoint, given a `pageKey` field that
 * represents the property name containing the next page token.
 *
 * @internal
 */ function paginateEndpoint(config, apiType, restApiName, methodName, reqPageKey, resPageKey, params) {
    return __asyncGenerator(this, arguments, function* paginateEndpoint_1() {
        let hasNext = true;
        const requestParams = Object.assign({}, params);
        while(hasNext){
            const response = yield __await(requestHttpWithBackoff(config, apiType, restApiName, methodName, requestParams));
            yield yield __await(response);
            if (response[resPageKey] !== null) requestParams[reqPageKey] = response[resPageKey];
            else hasNext = false;
        }
    });
}
/**
 * This file contains the underlying implementations for exposed API surface in
 * the {@link NftNamespace}. By moving the methods out into a separate file,
 * other namespaces can access these methods without depending on the entire
 * NftNamespace.
 */ /**
 * Get the NFT metadata for the provided contract address.
 */ function getNftMetadata(config, contractAddress, tokenId, options, srcMethod = "getNftMetadata") {
    return __awaiter$1(this, void 0, void 0, function*() {
        const response = yield requestHttpWithBackoff(config, AlchemyApiType.NFT, "getNFTMetadata", srcMethod, {
            contractAddress: contractAddress,
            tokenId: (0, $20M69.BigNumber).from(tokenId).toString(),
            tokenType: sanitizeTokenType(options === null || options === void 0 ? void 0 : options.tokenType),
            tokenUriTimeoutInMs: options === null || options === void 0 ? void 0 : options.tokenUriTimeoutInMs,
            refreshCache: options === null || options === void 0 ? void 0 : options.refreshCache
        });
        return getNftFromRaw(response);
    });
}
function getNftMetadataBatch(config, tokens, options) {
    return __awaiter$1(this, void 0, void 0, function*() {
        const data = {
            tokens: tokens,
            tokenUriTimeoutInMs: options === null || options === void 0 ? void 0 : options.tokenUriTimeoutInMs,
            refreshCache: options === null || options === void 0 ? void 0 : options.refreshCache
        };
        const response = yield requestHttpWithBackoff(config, AlchemyApiType.NFT, "getNFTMetadataBatch", "getNftMetadataBatch", {}, {
            method: "POST",
            data: data
        });
        return {
            nfts: response.nfts.map((nft)=>getNftFromRaw(nft))
        };
    });
}
function getContractMetadata(config, contractAddress, srcMethod = "getContractMetadata") {
    return __awaiter$1(this, void 0, void 0, function*() {
        const response = yield requestHttpWithBackoff(config, AlchemyApiType.NFT, "getContractMetadata", srcMethod, {
            contractAddress: contractAddress
        });
        return getNftContractFromRaw(response);
    });
}
function getContractMetadataBatch(config, contractAddresses) {
    return __awaiter$1(this, void 0, void 0, function*() {
        const response = yield requestHttpWithBackoff(config, AlchemyApiType.NFT, "getContractMetadataBatch", "getContractMetadataBatch", {}, {
            method: "POST",
            data: {
                contractAddresses: contractAddresses
            }
        });
        return {
            contracts: response.contracts.map(getNftContractFromRaw)
        };
    });
}
function getCollectionMetadata(config, collectionSlug, srcMethod = "getCollectionMetadata") {
    return __awaiter$1(this, void 0, void 0, function*() {
        const response = yield requestHttpWithBackoff(config, AlchemyApiType.NFT, "getCollectionMetadata", srcMethod, {
            collectionSlug: collectionSlug
        });
        return getNftCollectionFromRaw(response);
    });
}
function getNftsForOwnerIterator(config, owner, options, srcMethod = "getNftsForOwnerIterator") {
    return __asyncGenerator(this, arguments, function* getNftsForOwnerIterator_1() {
        var e_1, _a;
        const withMetadata = omitMetadataToWithMetadata(options === null || options === void 0 ? void 0 : options.omitMetadata);
        try {
            for(var _b = __asyncValues(paginateEndpoint(config, AlchemyApiType.NFT, "getNFTsForOwner", srcMethod, "pageKey", "pageKey", {
                contractAddresses: options === null || options === void 0 ? void 0 : options.contractAddresses,
                pageKey: options === null || options === void 0 ? void 0 : options.pageKey,
                excludeFilters: options === null || options === void 0 ? void 0 : options.excludeFilters,
                includeFilters: options === null || options === void 0 ? void 0 : options.includeFilters,
                owner: owner,
                withMetadata: withMetadata,
                tokenUriTimeoutInMs: options === null || options === void 0 ? void 0 : options.tokenUriTimeoutInMs,
                orderBy: options === null || options === void 0 ? void 0 : options.orderBy
            })), _c; _c = yield __await(_b.next()), !_c.done;){
                const response = _c.value;
                for (const ownedNft of response.ownedNfts)yield yield __await(Object.assign(Object.assign({}, nftFromGetNftResponse(ownedNft)), {
                    balance: ownedNft.balance
                }));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) yield __await(_a.call(_b));
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    });
}
function getNftsForOwner(config, owner, options, srcMethod = "getNftsForOwner") {
    return __awaiter$1(this, void 0, void 0, function*() {
        const withMetadata = omitMetadataToWithMetadata(options === null || options === void 0 ? void 0 : options.omitMetadata);
        const response = yield requestHttpWithBackoff(config, AlchemyApiType.NFT, "getNFTsForOwner", srcMethod, {
            contractAddresses: options === null || options === void 0 ? void 0 : options.contractAddresses,
            pageKey: options === null || options === void 0 ? void 0 : options.pageKey,
            excludeFilters: options === null || options === void 0 ? void 0 : options.excludeFilters,
            includeFilters: options === null || options === void 0 ? void 0 : options.includeFilters,
            owner: owner,
            pageSize: options === null || options === void 0 ? void 0 : options.pageSize,
            withMetadata: withMetadata,
            tokenUriTimeoutInMs: options === null || options === void 0 ? void 0 : options.tokenUriTimeoutInMs,
            orderBy: options === null || options === void 0 ? void 0 : options.orderBy
        });
        if (withMetadata) return nullsToUndefined({
            ownedNfts: response.ownedNfts.map((res)=>Object.assign(Object.assign({}, getNftFromRaw(res)), {
                    balance: res.balance
                })),
            pageKey: response.pageKey,
            totalCount: response.totalCount,
            validAt: response.validAt
        });
        return nullsToUndefined({
            ownedNfts: response.ownedNfts.map((res)=>Object.assign(Object.assign({}, getBaseNftFromRaw(res)), {
                    balance: res.balance
                })),
            pageKey: response.pageKey,
            totalCount: response.totalCount,
            validAt: response.validAt
        });
    });
}
function getNftsForContract(config, contractAddress, options, srcMethod = "getNftsForContract") {
    var _a;
    return __awaiter$1(this, void 0, void 0, function*() {
        const withMetadata = omitMetadataToWithMetadata(options === null || options === void 0 ? void 0 : options.omitMetadata);
        const response = yield requestHttpWithBackoff(config, AlchemyApiType.NFT, "getNFTsForContract", srcMethod, {
            contractAddress: contractAddress,
            pageKey: options === null || options === void 0 ? void 0 : options.pageKey,
            withMetadata: withMetadata,
            limit: (_a = options === null || options === void 0 ? void 0 : options.pageSize) !== null && _a !== void 0 ? _a : undefined,
            tokenUriTimeoutInMs: options === null || options === void 0 ? void 0 : options.tokenUriTimeoutInMs
        });
        if (withMetadata) return nullsToUndefined({
            nfts: response.nfts.map((res)=>getNftFromRaw(res)),
            pageKey: response.pageKey
        });
        return nullsToUndefined({
            nfts: response.nfts.map((res)=>getBaseNftFromRaw(res, contractAddress)),
            pageKey: response.pageKey
        });
    });
}
function getNftsForContractIterator(config, contractAddress, options, srcMethod = "getNftsForContractIterator") {
    return __asyncGenerator(this, arguments, function* getNftsForContractIterator_1() {
        var e_2, _a;
        const withMetadata = omitMetadataToWithMetadata(options === null || options === void 0 ? void 0 : options.omitMetadata);
        try {
            for(var _b = __asyncValues(paginateEndpoint(config, AlchemyApiType.NFT, "getNFTsForContract", srcMethod, "pageKey", "pageKey", {
                contractAddress: contractAddress,
                pageKey: options === null || options === void 0 ? void 0 : options.pageKey,
                withMetadata: withMetadata
            })), _c; _c = yield __await(_b.next()), !_c.done;){
                const response = _c.value;
                for (const nft of response.nfts)yield yield __await(nftFromGetNftContractResponse(nft, contractAddress));
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) yield __await(_a.call(_b));
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    });
}
function getOwnersForContract(config, contractAddress, options, srcMethod = "getOwnersForContract") {
    return __awaiter$1(this, void 0, void 0, function*() {
        // Cast to `any` to avoid more type wrangling.
        const response = yield requestHttpWithBackoff(config, AlchemyApiType.NFT, "getOwnersForContract", srcMethod, Object.assign(Object.assign({}, options), {
            contractAddress: contractAddress
        }));
        if (options === null || options === void 0 ? void 0 : options.withTokenBalances) return nullsToUndefined({
            owners: response.owners,
            pageKey: response.pageKey
        });
        return nullsToUndefined({
            owners: response.owners,
            pageKey: response.pageKey
        });
    });
}
function getContractsForOwner(config, owner, options, srcMethod = "getContractsForOwner") {
    return __awaiter$1(this, void 0, void 0, function*() {
        const response = yield requestHttpWithBackoff(config, AlchemyApiType.NFT, "getContractsForOwner", srcMethod, {
            owner: owner,
            excludeFilters: options === null || options === void 0 ? void 0 : options.excludeFilters,
            includeFilters: options === null || options === void 0 ? void 0 : options.includeFilters,
            pageKey: options === null || options === void 0 ? void 0 : options.pageKey,
            pageSize: options === null || options === void 0 ? void 0 : options.pageSize,
            orderBy: options === null || options === void 0 ? void 0 : options.orderBy
        });
        return nullsToUndefined({
            contracts: response.contracts.map(getNftContractsForOwnerFromRaw),
            pageKey: response.pageKey,
            totalCount: response.totalCount
        });
    });
}
function getOwnersForNft(config, contractAddress, tokenId, options, srcMethod = "getOwnersForNft") {
    return __awaiter$1(this, void 0, void 0, function*() {
        return requestHttpWithBackoff(config, AlchemyApiType.NFT, "getOwnersForNFT", srcMethod, Object.assign({
            contractAddress: contractAddress,
            tokenId: (0, $20M69.BigNumber).from(tokenId).toString()
        }, options));
    });
}
function getMintedNfts(config, owner, options) {
    return __awaiter$1(this, void 0, void 0, function*() {
        const provider = yield config.getProvider();
        const ownerAddress = yield provider._getAddress(owner);
        const category = nftTokenTypeToCategory(options === null || options === void 0 ? void 0 : options.tokenType);
        const params = {
            fromBlock: "0x0",
            fromAddress: ETH_NULL_ADDRESS,
            toAddress: ownerAddress,
            excludeZeroValue: true,
            contractAddresses: options === null || options === void 0 ? void 0 : options.contractAddresses,
            category: category,
            maxCount: 100,
            pageKey: options === null || options === void 0 ? void 0 : options.pageKey
        };
        const response = yield getAssetTransfers(config, params, "getMintedNfts");
        return getNftsForTransfers(config, response);
    });
}
function getTransfersForOwner(config, owner, transferType, options) {
    return __awaiter$1(this, void 0, void 0, function*() {
        const provider = yield config.getProvider();
        const ownerAddress = yield provider._getAddress(owner);
        const category = nftTokenTypeToCategory(options === null || options === void 0 ? void 0 : options.tokenType);
        const params = {
            fromBlock: "0x0",
            excludeZeroValue: true,
            contractAddresses: options === null || options === void 0 ? void 0 : options.contractAddresses,
            category: category,
            maxCount: 100,
            pageKey: options === null || options === void 0 ? void 0 : options.pageKey
        };
        if (transferType === GetTransfersForOwnerTransferType.TO) params.toAddress = ownerAddress;
        else params.fromAddress = ownerAddress;
        const transfersResponse = yield getAssetTransfers(config, params, "getTransfersForOwner");
        return getNftsForTransfers(config, transfersResponse);
    });
}
function getTransfersForContract(config, contract, options) {
    return __awaiter$1(this, void 0, void 0, function*() {
        const category = [
            AssetTransfersCategory.ERC721,
            AssetTransfersCategory.ERC1155,
            AssetTransfersCategory.SPECIALNFT
        ];
        const provider = yield config.getProvider();
        const fromBlock = (options === null || options === void 0 ? void 0 : options.fromBlock) ? provider.formatter.blockTag((yield provider._getBlockTag(options.fromBlock))) : "0x0";
        const toBlock = (options === null || options === void 0 ? void 0 : options.toBlock) ? provider.formatter.blockTag((yield provider._getBlockTag(options.toBlock))) : undefined;
        const params = {
            fromBlock: fromBlock,
            toBlock: toBlock,
            excludeZeroValue: true,
            contractAddresses: [
                contract
            ],
            order: options === null || options === void 0 ? void 0 : options.order,
            category: category,
            maxCount: 100,
            pageKey: options === null || options === void 0 ? void 0 : options.pageKey
        };
        const transfersResponse = yield getAssetTransfers(config, params, "getTransfersForContract");
        return getNftsForTransfers(config, transfersResponse);
    });
}
function nftTokenTypeToCategory(tokenType) {
    switch(tokenType){
        case NftTokenType.ERC721:
            return [
                AssetTransfersCategory.ERC721
            ];
        case NftTokenType.ERC1155:
            return [
                AssetTransfersCategory.ERC1155
            ];
        default:
            return [
                AssetTransfersCategory.ERC721,
                AssetTransfersCategory.ERC1155,
                AssetTransfersCategory.SPECIALNFT
            ];
    }
}
function parse1155Transfer(transfer) {
    return transfer.erc1155Metadata.map((metadata)=>({
            contractAddress: transfer.rawContract.address,
            tokenId: metadata.tokenId,
            tokenType: NftTokenType.ERC1155
        }));
}
function verifyNftOwnership(config, owner, contractAddresses, srcMethod = "verifyNftOwnership") {
    return __awaiter$1(this, void 0, void 0, function*() {
        if (typeof contractAddresses === "string") {
            const response = yield getNftsForOwner(config, owner, {
                contractAddresses: [
                    contractAddresses
                ],
                omitMetadata: true
            }, srcMethod);
            return response.ownedNfts.length > 0;
        } else {
            if (contractAddresses.length === 0) throw new Error("Must provide at least one contract address");
            const response = yield getNftsForOwner(config, owner, {
                contractAddresses: contractAddresses,
                omitMetadata: true
            }, srcMethod);
            // Create map where all input contract addresses are set to false, then flip
            // owned nfts to true.
            const result = contractAddresses.reduce((acc, curr)=>{
                acc[curr] = false;
                return acc;
            }, {});
            for (const nft of response.ownedNfts)result[nft.contractAddress] = true;
            return result;
        }
    });
}
function isSpamContract(config, contractAddress, srcMethod = "isSpamContract") {
    return __awaiter$1(this, void 0, void 0, function*() {
        return requestHttpWithBackoff(config, AlchemyApiType.NFT, "isSpamContract", srcMethod, {
            contractAddress: contractAddress
        });
    });
}
function getSpamContracts(config, srcMethod = "getSpamContracts") {
    return __awaiter$1(this, void 0, void 0, function*() {
        return requestHttpWithBackoff(config, AlchemyApiType.NFT, "getSpamContracts", srcMethod, undefined);
    });
}
function reportSpam(config, contractAddress, srcMethod = "reportSpam") {
    return __awaiter$1(this, void 0, void 0, function*() {
        requestHttpWithBackoff(config, AlchemyApiType.NFT, "reportSpam", srcMethod, {
            contractAddress: contractAddress
        });
    });
}
function isAirdropNft(config, contractAddress, tokenId, srcMethod = "isAirdropNft") {
    return __awaiter$1(this, void 0, void 0, function*() {
        return requestHttpWithBackoff(config, AlchemyApiType.NFT, "isAirdropNFT", srcMethod, {
            contractAddress: contractAddress,
            tokenId: tokenId
        });
    });
}
function getFloorPrice(config, contractAddress, srcMethod = "getFloorPrice") {
    return __awaiter$1(this, void 0, void 0, function*() {
        const response = yield requestHttpWithBackoff(config, AlchemyApiType.NFT, "getFloorPrice", srcMethod, {
            contractAddress: contractAddress
        });
        return nullsToUndefined(response);
    });
}
function getNftSales(config, options = {}, srcMethod = "getNftSales") {
    return __awaiter$1(this, void 0, void 0, function*() {
        // Avoid ts compiler complaining about the contractAddress field.
        const params = Object.assign({}, options);
        const response = yield requestHttpWithBackoff(config, AlchemyApiType.NFT, "getNFTSales", srcMethod, {
            fromBlock: params === null || params === void 0 ? void 0 : params.fromBlock,
            toBlock: params === null || params === void 0 ? void 0 : params.toBlock,
            order: params === null || params === void 0 ? void 0 : params.order,
            marketplace: params === null || params === void 0 ? void 0 : params.marketplace,
            contractAddress: params === null || params === void 0 ? void 0 : params.contractAddress,
            tokenId: (params === null || params === void 0 ? void 0 : params.tokenId) ? (0, $20M69.BigNumber).from(params === null || params === void 0 ? void 0 : params.tokenId).toString() : undefined,
            sellerAddress: params === null || params === void 0 ? void 0 : params.sellerAddress,
            buyerAddress: params === null || params === void 0 ? void 0 : params.buyerAddress,
            taker: params === null || params === void 0 ? void 0 : params.taker,
            limit: params === null || params === void 0 ? void 0 : params.limit,
            pageKey: params === null || params === void 0 ? void 0 : params.pageKey
        });
        return getNftSalesFromRaw(response);
    });
}
function computeRarity(config, contractAddress, tokenId, srcMethod = "computeRarity") {
    return __awaiter$1(this, void 0, void 0, function*() {
        const response = yield requestHttpWithBackoff(config, AlchemyApiType.NFT, "computeRarity", srcMethod, {
            contractAddress: contractAddress,
            tokenId: (0, $20M69.BigNumber).from(tokenId).toString()
        });
        return nullsToUndefined(response);
    });
}
function searchContractMetadata(config, query, srcMethod = "searchContractMetadata") {
    return __awaiter$1(this, void 0, void 0, function*() {
        const response = yield requestHttpWithBackoff(config, AlchemyApiType.NFT, "searchContractMetadata", srcMethod, {
            query: query
        });
        return {
            contracts: response.contracts.map(getNftContractFromRaw)
        };
    });
}
function summarizeNftAttributes(config, contractAddress, srcMethod = "summarizeNftAttributes") {
    return __awaiter$1(this, void 0, void 0, function*() {
        return requestHttpWithBackoff(config, AlchemyApiType.NFT, "summarizeNFTAttributes", srcMethod, {
            contractAddress: contractAddress
        });
    });
}
function refreshNftMetadata(config, contractAddress, tokenId, srcMethod = "refreshNftMetadata") {
    return __awaiter$1(this, void 0, void 0, function*() {
        const tokenIdString = (0, $20M69.BigNumber).from(tokenId).toString();
        const first = yield getNftMetadata(config, contractAddress, tokenIdString, undefined, srcMethod);
        const second = yield refresh(config, contractAddress, tokenIdString, srcMethod);
        return first.timeLastUpdated !== second.timeLastUpdated;
    });
}
function refreshContract(config, contractAddress, srcMethod = "refreshContract") {
    return __awaiter$1(this, void 0, void 0, function*() {
        const response = yield requestHttpWithBackoff(config, AlchemyApiType.NFT, "reingestContract", srcMethod, {
            contractAddress: contractAddress
        });
        return {
            contractAddress: response.contractAddress,
            refreshState: parseReingestionState(response.reingestionState),
            progress: response.progress
        };
    });
}
function refresh(config, contractAddress, tokenId, srcMethod) {
    return __awaiter$1(this, void 0, void 0, function*() {
        const response = yield requestHttpWithBackoff(config, AlchemyApiType.NFT, "getNFTMetadata", srcMethod, {
            contractAddress: contractAddress,
            tokenId: (0, $20M69.BigNumber).from(tokenId).toString(),
            refreshCache: true
        });
        return getNftFromRaw(response);
    });
}
/**
 * Helper method to convert a NFT response received from Alchemy backend to an
 * SDK NFT type.
 *
 * @internal
 */ function nftFromGetNftResponse(ownedNft) {
    if (isNftWithMetadata(ownedNft)) return getNftFromRaw(ownedNft);
    else return getBaseNftFromRaw(ownedNft);
}
/**
 * Helper method to convert a NFT response received from Alchemy backend to an
 * SDK NFT type.
 *
 * @internal
 */ function nftFromGetNftContractResponse(ownedNft, contractAddress) {
    if (isNftWithMetadata(ownedNft)) return getNftFromRaw(ownedNft);
    else return getBaseNftFromRaw(ownedNft, contractAddress);
}
/** @internal */ // TODO: more comprehensive type check
function isNftWithMetadata(response) {
    return response.name !== undefined;
}
/**
 * Given an AssetTransfersResponse, fetches the NFTs associated with the
 * transfers and collates them with transfer metadata.
 *
 * VISIBLE FOR TESTING
 */ function getNftsForTransfers(config, response) {
    return __awaiter$1(this, void 0, void 0, function*() {
        const metadataTransfers = response.transfers.filter((transfer)=>transfer.rawContract.address !== null)// Use flatMap to flatten 1155 transfers that contain multiple NFTs.
        .flatMap((transfer)=>{
            var _a;
            const tokens = getTokensFromTransfer(transfer);
            const metadata = {
                from: transfer.from,
                to: (_a = transfer.to) !== null && _a !== void 0 ? _a : undefined,
                transactionHash: transfer.hash,
                blockNumber: transfer.blockNum
            };
            return tokens.map((token)=>({
                    metadata: metadata,
                    token: token
                }));
        });
        if (metadataTransfers.length === 0) return {
            nfts: []
        };
        // If we have more than 100 elements after unrolling 1155 transfers, split
        // transfers into batches of 100 to stay under endpoint batch size limit.
        const batchSize = 100;
        const requestBatches = [];
        for(let i = 0; i < metadataTransfers.length; i += batchSize)requestBatches.push(metadataTransfers.slice(i, i + batchSize));
        const responseBatches = yield Promise.all(requestBatches.map((batch)=>getNftMetadataBatch(config, batch.map((transfer)=>transfer.token))));
        const nfts = responseBatches.map((r)=>r.nfts).flat();
        // The same NFT can be transferred multiple times in the same transfers response.
        // We want to return one NFT for each transfer, so we create a mapping for
        // each NFT to pair with the transfer metadata.
        const nftsByTokenId = new Map();
        nfts.forEach((nft)=>{
            const key = `${nft.contract.address.toLowerCase()}-${(0, $20M69.BigNumber).from(nft.tokenId).toString()}`;
            nftsByTokenId.set(key, nft);
        });
        const transferredNfts = metadataTransfers.map((t)=>{
            const key = `${t.token.contractAddress.toLowerCase()}-${(0, $20M69.BigNumber).from(t.token.tokenId).toString()}`;
            return Object.assign(Object.assign({}, nftsByTokenId.get(key)), t.metadata);
        });
        return {
            nfts: transferredNfts,
            pageKey: response.pageKey
        };
    });
}
/**
 * Returns the underlying NFT tokens from a transfer as the params for a
 * `getNftMetadataBatch` call. Handles the 1155 case where multiple NFTs can be
 * transferred in a single transaction.
 */ function getTokensFromTransfer(transfer) {
    // ERC1155 NFTs can contain multiple tokens in a single transfer, which
    // requires special logic.
    if (transfer.category === AssetTransfersCategory.ERC1155) return parse1155Transfer(transfer);
    else return [
        {
            contractAddress: transfer.rawContract.address,
            tokenId: transfer.tokenId,
            tokenType: transfer.category === AssetTransfersCategory.ERC721 ? NftTokenType.ERC721 : undefined
        }
    ];
}
/**
 * Flips the `omitMetadata` SDK parameter type to the `withMetadata` parameter
 * required by the Alchemy API. If `omitMetadata` is undefined, the SDK defaults
 * to including metadata.
 *
 * @internal
 */ function omitMetadataToWithMetadata(omitMetadata) {
    return omitMetadata === undefined ? true : !omitMetadata;
}
function parseReingestionState(reingestionState) {
    switch(reingestionState){
        case "does_not_exist":
            return NftRefreshState.DOES_NOT_EXIST;
        case "already_queued":
            return NftRefreshState.ALREADY_QUEUED;
        case "in_progress":
            return NftRefreshState.IN_PROGRESS;
        case "finished":
            return NftRefreshState.FINISHED;
        case "queued":
            return NftRefreshState.QUEUED;
        case "queue_failed":
            return NftRefreshState.QUEUE_FAILED;
        default:
            throw new Error("Unknown reingestion state: " + reingestionState);
    }
}
/**
 * The NFT namespace contains all the functionality related to NFTs.
 *
 * Do not call this constructor directly. Instead, instantiate an Alchemy object
 * with `const alchemy = new Alchemy(config)` and then access the core namespace
 * via `alchemy.nft`.
 */ class NftNamespace {
    /** @internal */ constructor(config){
        this.config = config;
    }
    getNftMetadata(contractAddress, tokenId, optionsOrTokenType, tokenUriTimeoutInMs) {
        let options;
        if (typeof optionsOrTokenType === "object") options = {
            tokenType: optionsOrTokenType.tokenType,
            tokenUriTimeoutInMs: optionsOrTokenType.tokenUriTimeoutInMs,
            refreshCache: optionsOrTokenType.refreshCache
        };
        else options = {
            tokenType: optionsOrTokenType,
            tokenUriTimeoutInMs: tokenUriTimeoutInMs
        };
        return getNftMetadata(this.config, contractAddress, tokenId, options);
    }
    /**
     * Gets the NFT metadata for multiple NFT tokens.
     *
     * @param tokens An array of NFT tokens to fetch metadata for.
     * @param options Configuration options for making the request.
     */ getNftMetadataBatch(tokens, options) {
        return getNftMetadataBatch(this.config, tokens, options);
    }
    /**
     * Get the NFT contract metadata associated with the provided parameters.
     *
     * @param contractAddress - The contract address of the NFT.
     * @public
     */ getContractMetadata(contractAddress) {
        return getContractMetadata(this.config, contractAddress);
    }
    /**
     * Get the NFT contract metadata for multiple NFT contracts in a single request.
     *
     * @param contractAddresses - An array of contract addresses to fetch metadata for.
     */ getContractMetadataBatch(contractAddresses) {
        return getContractMetadataBatch(this.config, contractAddresses);
    }
    /**
     * Get the NFT collection metadata associated with the provided parameters.
     *
     * @param collectionSlug - The OpenSea collection slug of the NFT.
     * @beta
     */ getCollectionMetadata(collectionSlug) {
        return getCollectionMetadata(this.config, collectionSlug);
    }
    getNftsForOwnerIterator(owner, options) {
        return getNftsForOwnerIterator(this.config, owner, options);
    }
    getNftsForOwner(owner, options) {
        return getNftsForOwner(this.config, owner, options);
    }
    getNftsForContract(contractAddress, options) {
        return getNftsForContract(this.config, contractAddress, options);
    }
    getNftsForContractIterator(contractAddress, options) {
        return getNftsForContractIterator(this.config, contractAddress, options);
    }
    getOwnersForContract(contractAddress, options) {
        return getOwnersForContract(this.config, contractAddress, options);
    }
    /**
     * Gets all the owners for a given NFT contract address and token ID.
     *
     * @param contractAddress - The NFT contract address.
     * @param tokenId - Token id of the NFT.
     * @param options - Optional parameters to use for the request.
     * @beta
     */ getOwnersForNft(contractAddress, tokenId, options) {
        return getOwnersForNft(this.config, contractAddress, tokenId, options);
    }
    /**
     * Gets all NFT contracts held by the specified owner address.
     *
     * @param owner - Address for NFT owner (can be in ENS format!).
     * @param options - The optional parameters to use for the request.
     * @public
     */ // TODO(v3): Add overload for withMetadata=false
    getContractsForOwner(owner, options) {
        return getContractsForOwner(this.config, owner, options);
    }
    /**
     * Gets all NFT transfers for a given owner's address.
     *
     * @param owner The owner to get transfers for.
     * @param category Whether to get transfers to or from the owner address.
     * @param options Additional options for the request.
     */ getTransfersForOwner(owner, category, options) {
        return getTransfersForOwner(this.config, owner, category, options);
    }
    /**
     * Gets all NFT transfers for a given NFT contract address.
     *
     * Defaults to all transfers for the contract. To get transfers for a specific
     * block range, use {@link GetTransfersForContractOptions}.
     *
     * @param contract The NFT contract to get transfers for.
     * @param options Additional options for the request.
     */ getTransfersForContract(contract, options) {
        return getTransfersForContract(this.config, contract, options);
    }
    /**
     * Get all the NFTs minted by a specified owner address.
     *
     * @param owner - Address for the NFT owner (can be in ENS format).
     * @param options - The optional parameters to use for the request.
     */ getMintedNfts(owner, options) {
        return __awaiter$1(this, void 0, void 0, function*() {
            return getMintedNfts(this.config, owner, options);
        });
    }
    verifyNftOwnership(owner, contractAddress) {
        return verifyNftOwnership(this.config, owner, contractAddress);
    }
    /**
     * Returns whether a contract is marked as spam or not by Alchemy. For more
     * information on how we classify spam, go to our NFT API FAQ at
     * https://docs.alchemy.com/alchemy/enhanced-apis/nft-api/nft-api-faq#nft-spam-classification.
     *
     * @param contractAddress - The contract address to check.
     */ isSpamContract(contractAddress) {
        return isSpamContract(this.config, contractAddress);
    }
    /**
     * Returns a list of all spam contracts marked by Alchemy. For details on how
     * Alchemy marks spam contracts, go to
     * https://docs.alchemy.com/alchemy/enhanced-apis/nft-api/nft-api-faq#nft-spam-classification.
     */ getSpamContracts() {
        return getSpamContracts(this.config);
    }
    /**
     * Returns whether a contract is marked as spam or not by Alchemy. For more
     * information on how we classify spam, go to our NFT API FAQ at
     * https://docs.alchemy.com/alchemy/enhanced-apis/nft-api/nft-api-faq#nft-spam-classification.
     *
     * @param contractAddress - The contract address to check.
     */ reportSpam(contractAddress) {
        return reportSpam(this.config, contractAddress);
    }
    /**
     * Returns whether a token is marked as an airdrop or not.
     * Airdrops are defined as NFTs that were minted to a user address in a transaction
     * sent by a different address.
     *
     * @param contractAddress - The contract address to check.
     * @param tokenId - Token id of the NFT.
     */ isAirdropNft(contractAddress, tokenId) {
        return isAirdropNft(this.config, contractAddress, tokenId);
    }
    /**
     * Returns the floor prices of a NFT contract by marketplace.
     *
     * @param contractAddress - The contract address for the NFT collection.
     * @beta
     */ getFloorPrice(contractAddress) {
        return getFloorPrice(this.config, contractAddress);
    }
    getNftSales(options) {
        return getNftSales(this.config, options);
    }
    /**
     * Get the rarity of each attribute of an NFT.
     *
     * @param contractAddress - Contract address for the NFT collection.
     * @param tokenId - Token id of the NFT.
     */ computeRarity(contractAddress, tokenId) {
        return computeRarity(this.config, contractAddress, tokenId);
    }
    /**
     * Search for a keyword across metadata of all ERC-721 and ERC-1155 smart contracts.
     *
     * @param query - The search string that you want to search for in contract metadata.
     */ searchContractMetadata(query) {
        return searchContractMetadata(this.config, query);
    }
    /**
     * Get a summary of attribute prevalence for an NFT collection.
     *
     * @param contractAddress - Contract address for the NFT collection.
     */ summarizeNftAttributes(contractAddress) {
        return summarizeNftAttributes(this.config, contractAddress);
    }
    /**
     * Refreshes the cached metadata for a provided NFT contract address and token
     * id. Returns a boolean value indicating whether the metadata was refreshed.
     *
     * This method is useful when you want to refresh the metadata for a NFT that
     * has been updated since the last time it was fetched. Note that the backend
     * only allows one refresh per token every 15 minutes, globally for all users.
     * The last refresh time for an NFT can be accessed on the
     * {@link Nft.timeLastUpdated} field.
     *
     * To trigger a refresh for all NFTs in a contract, use {@link refreshContract} instead.
     *
     * @param contractAddress - The contract address of the NFT.
     * @param tokenId - The token id of the NFT.
     */ refreshNftMetadata(contractAddress, tokenId) {
        return refreshNftMetadata(this.config, contractAddress, tokenId);
    }
    /**
     * Triggers a metadata refresh all NFTs in the provided contract address. This
     * method is useful after an NFT collection is revealed.
     *
     * Refreshes are queued on the Alchemy backend and may take time to fully
     * process. To refresh the metadata for a specific token, use the
     * {@link refreshNftMetadata} method instead.
     *
     * @param contractAddress - The contract address of the NFT collection.
     * @beta
     */ refreshContract(contractAddress) {
        return refreshContract(this.config, contractAddress);
    }
}
/**
 * The Notify namespace contains methods used for creating, reading, updating,
 * and deleting webhooks in the Notify API.
 *
 * To use the methods in the API, you must provide your team's auth token in the
 * {@link AlchemySettings.authToken} field when configuring
 * {@link AlchemySettings}. The auth token can be found in the Alchemy Dashboard
 * on the Notify tab.
 *
 * Note that not all networks are supported in the Notify API. Please consult
 * the documentation for which networks are supported.
 *
 * Do not call this constructor directly. Instead, instantiate an Alchemy object
 * with `const alchemy = new Alchemy(config)` and then access the notify
 * namespace via `alchemy.notify`.
 */ class NotifyNamespace {
    /** @internal */ constructor(config){
        this.config = config;
    }
    /**
     * Get all webhooks on your team.
     *
     * The team is determined by the `authToken` provided into the {@link AlchemySettings}
     * object when creating a new {@link Alchemy} instance.
     *
     * This method returns a response object containing all the webhooks
     */ getAllWebhooks() {
        return __awaiter$1(this, void 0, void 0, function*() {
            this.verifyConfig();
            const response = yield this.sendWebhookRequest("team-webhooks", "getAllWebhooks", {});
            return {
                webhooks: parseRawWebhookResponse(response),
                totalCount: response.data.length
            };
        });
    }
    getAddresses(webhookOrId, options) {
        return __awaiter$1(this, void 0, void 0, function*() {
            this.verifyConfig();
            const webhookId = typeof webhookOrId === "string" ? webhookOrId : webhookOrId.id;
            const response = yield this.sendWebhookRequest("webhook-addresses", "getAddresses", {
                webhook_id: webhookId,
                limit: options === null || options === void 0 ? void 0 : options.limit,
                after: options === null || options === void 0 ? void 0 : options.pageKey
            });
            return parseRawAddressActivityResponse(response);
        });
    }
    getGraphqlQuery(webhookOrId) {
        return __awaiter$1(this, void 0, void 0, function*() {
            this.verifyConfig();
            const webhookId = typeof webhookOrId === "string" ? webhookOrId : webhookOrId.id;
            const response = yield this.sendWebhookRequest("dashboard-webhook-graphql-query", "getGraphqlQuery", {
                webhook_id: webhookId
            });
            return parseRawCustomGraphqlWebhookResponse(response);
        });
    }
    getNftFilters(webhookOrId, options) {
        return __awaiter$1(this, void 0, void 0, function*() {
            this.verifyConfig();
            const webhookId = typeof webhookOrId === "string" ? webhookOrId : webhookOrId.id;
            const response = yield this.sendWebhookRequest("webhook-nft-filters", "getNftFilters", {
                webhook_id: webhookId,
                limit: options === null || options === void 0 ? void 0 : options.limit,
                after: options === null || options === void 0 ? void 0 : options.pageKey
            });
            return parseRawNftFiltersResponse(response);
        });
    }
    updateWebhook(webhookOrId, update) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const webhookId = typeof webhookOrId === "string" ? webhookOrId : webhookOrId.id;
            let restApiName;
            let methodName;
            let method;
            let data;
            if ("isActive" in update) {
                restApiName = "update-webhook";
                methodName = "updateWebhook";
                method = "PUT";
                data = {
                    webhook_id: webhookId,
                    is_active: update.isActive
                };
            } else if ("addFilters" in update || "removeFilters" in update) {
                restApiName = "update-webhook-nft-filters";
                methodName = "updateWebhookNftFilters";
                method = "PATCH";
                data = {
                    webhook_id: webhookId,
                    nft_filters_to_add: update.addFilters ? update.addFilters.map(nftFilterToParam) : [],
                    nft_filters_to_remove: update.removeFilters ? update.removeFilters.map(nftFilterToParam) : []
                };
            } else if ("addMetadataFilters" in update || "removeMetadataFilters" in update) {
                restApiName = "update-webhook-nft-metadata-filters";
                methodName = "updateWebhookNftMetadataFilters";
                method = "PATCH";
                data = {
                    webhook_id: webhookId,
                    nft_metadata_filters_to_add: update.addMetadataFilters ? update.addMetadataFilters.map(nftFilterToParam) : [],
                    nft_metadata_filters_to_remove: update.removeMetadataFilters ? update.removeMetadataFilters.map(nftFilterToParam) : []
                };
            } else if ("addAddresses" in update || "removeAddresses" in update) {
                restApiName = "update-webhook-addresses";
                methodName = "webhook:updateWebhookAddresses";
                method = "PATCH";
                data = {
                    webhook_id: webhookId,
                    addresses_to_add: yield this.resolveAddresses(update.addAddresses),
                    addresses_to_remove: yield this.resolveAddresses(update.removeAddresses)
                };
            } else if ("newAddresses" in update) {
                restApiName = "update-webhook-addresses";
                methodName = "webhook:updateWebhookAddress";
                method = "PUT";
                data = {
                    webhook_id: webhookId,
                    addresses: yield this.resolveAddresses(update.newAddresses)
                };
            } else throw new Error("Invalid `update` param passed into `updateWebhook`");
            yield this.sendWebhookRequest(restApiName, methodName, {}, {
                method: method,
                data: data
            });
        });
    }
    createWebhook(url, type, params) {
        return __awaiter$1(this, void 0, void 0, function*() {
            let appId;
            if (type === WebhookType.MINED_TRANSACTION || type === WebhookType.DROPPED_TRANSACTION) {
                if (!("appId" in params)) throw new Error("Transaction Webhooks require an app id.");
                appId = params.appId;
            }
            let network = NETWORK_TO_WEBHOOK_NETWORK.get(this.config.network);
            let nftFilterObj;
            let addresses;
            let graphqlQuery;
            if (type === WebhookType.NFT_ACTIVITY || type === WebhookType.NFT_METADATA_UPDATE) {
                if (!("filters" in params) || params.filters.length === 0) throw new Error("Nft Activity Webhooks require a non-empty array input.");
                network = params.network ? NETWORK_TO_WEBHOOK_NETWORK.get(params.network) : network;
                const filters = params.filters.map((filter)=>filter.tokenId ? {
                        contract_address: filter.contractAddress,
                        token_id: (0, $20M69.BigNumber).from(filter.tokenId).toString()
                    } : {
                        contract_address: filter.contractAddress
                    });
                nftFilterObj = type === WebhookType.NFT_ACTIVITY ? {
                    nft_filters: filters
                } : {
                    nft_metadata_filters: filters
                };
            } else if (type === WebhookType.ADDRESS_ACTIVITY) {
                if (params === undefined || !("addresses" in params) || params.addresses.length === 0) throw new Error("Address Activity Webhooks require a non-empty array input.");
                network = params.network ? NETWORK_TO_WEBHOOK_NETWORK.get(params.network) : network;
                addresses = yield this.resolveAddresses(params.addresses);
            } else if (type == WebhookType.GRAPHQL) {
                if (params === undefined || !("graphqlQuery" in params) || params.graphqlQuery.length === 0) throw new Error("Custom Webhooks require a non-empty graphql query.");
                network = params.network ? NETWORK_TO_WEBHOOK_NETWORK.get(params.network) : network;
                graphqlQuery = params.graphqlQuery;
            }
            const data = Object.assign(Object.assign(Object.assign(Object.assign({
                network: network,
                webhook_type: type,
                webhook_url: url
            }, appId && {
                app_id: appId
            }), nftFilterObj), addresses && {
                addresses: addresses
            }), graphqlQuery && {
                graphql_query: graphqlQuery
            });
            const response = yield this.sendWebhookRequest("create-webhook", "createWebhook", {}, {
                method: "POST",
                data: data
            });
            return parseRawWebhook(response.data);
        });
    }
    deleteWebhook(webhookOrId) {
        return __awaiter$1(this, void 0, void 0, function*() {
            this.verifyConfig();
            const webhookId = typeof webhookOrId === "string" ? webhookOrId : webhookOrId.id;
            const response = yield this.sendWebhookRequest("delete-webhook", "deleteWebhook", {
                webhook_id: webhookId
            }, {
                method: "DELETE"
            });
            if ("message" in response) throw new Error(`Webhook not found. Failed to delete webhook: ${webhookId}`);
        });
    }
    verifyConfig() {
        if (this.config.authToken === undefined) throw new Error("Using the Notify API requires setting the Alchemy Auth Token in the settings object when initializing Alchemy.");
    }
    sendWebhookRequest(restApiName, methodName, params, overrides) {
        return requestHttpWithBackoff(this.config, AlchemyApiType.WEBHOOK, restApiName, methodName, params, Object.assign(Object.assign({}, overrides), {
            headers: Object.assign({
                "X-Alchemy-Token": this.config.authToken
            }, overrides === null || overrides === void 0 ? void 0 : overrides.headers)
        }));
    }
    /** Resolves ENS addresses to the raw address.
     * @internal */ resolveAddresses(addresses) {
        return __awaiter$1(this, void 0, void 0, function*() {
            if (addresses === undefined) return [];
            const resolvedAddresses = [];
            const provider = yield this.config.getProvider();
            for (const address of addresses){
                const rawAddress = yield provider.resolveName(address);
                if (rawAddress === null) throw new Error(`Unable to resolve the ENS address: ${address}`);
                resolvedAddresses.push(rawAddress);
            }
            return resolvedAddresses;
        });
    }
}
/**
 * Mapping of webhook network representations to the SDK's network representation.
 *
 * @internal
 */ const WEBHOOK_NETWORK_TO_NETWORK = {
    ETH_MAINNET: Network.ETH_MAINNET,
    ETH_GOERLI: Network.ETH_GOERLI,
    ETH_SEPOLIA: Network.ETH_SEPOLIA,
    MATIC_MAINNET: Network.MATIC_MAINNET,
    MATIC_MUMBAI: Network.MATIC_MUMBAI,
    MATIC_AMOY: Network.MATIC_AMOY,
    ARB_MAINNET: Network.ARB_MAINNET,
    ARB_GOERLI: Network.ARB_GOERLI,
    ARB_SEPOLIA: Network.ARB_SEPOLIA,
    OPT_MAINNET: Network.OPT_MAINNET,
    OPT_GOERLI: Network.OPT_GOERLI,
    OPT_SEPOLIA: Network.OPT_SEPOLIA,
    BASE_MAINNET: Network.BASE_MAINNET,
    BASE_GOERLI: Network.BASE_GOERLI,
    BASE_SEPOLIA: Network.BASE_SEPOLIA,
    ZKSYNC_MAINNET: Network.ZKSYNC_MAINNET,
    ZKSYNC_SEPOLIA: Network.ZKSYNC_SEPOLIA
};
/** Mapping of the SDK's network representation the webhook API's network representation. */ const NETWORK_TO_WEBHOOK_NETWORK = Object.keys(Network).reduce((map, key)=>{
    if (key in WEBHOOK_NETWORK_TO_NETWORK) map.set(WEBHOOK_NETWORK_TO_NETWORK[key], key);
    return map;
}, new Map());
function parseRawWebhookResponse(response) {
    return response.data.map(parseRawWebhook);
}
function parseRawWebhook(rawWebhook) {
    return Object.assign({
        id: rawWebhook.id,
        network: WEBHOOK_NETWORK_TO_NETWORK[rawWebhook.network],
        type: rawWebhook.webhook_type,
        url: rawWebhook.webhook_url,
        isActive: rawWebhook.is_active,
        timeCreated: new Date(rawWebhook.time_created).toISOString(),
        signingKey: rawWebhook.signing_key,
        version: rawWebhook.version
    }, rawWebhook.app_id !== undefined && {
        appId: rawWebhook.app_id
    });
}
function parseRawAddressActivityResponse(response) {
    return {
        addresses: response.data,
        totalCount: response.pagination.total_count,
        pageKey: response.pagination.cursors.after
    };
}
function parseRawCustomGraphqlWebhookResponse(response) {
    return {
        graphqlQuery: response.data.graphql_query
    };
}
function parseRawNftFiltersResponse(response) {
    return {
        filters: response.data.map((f)=>f.token_id ? {
                contractAddress: f.contract_address,
                tokenId: (0, $20M69.BigNumber).from(f.token_id).toString()
            } : {
                contractAddress: f.contract_address
            }),
        totalCount: response.pagination.total_count,
        pageKey: response.pagination.cursors.after
    };
}
function nftFilterToParam(filter) {
    return filter.tokenId ? {
        contract_address: filter.contractAddress,
        token_id: (0, $20M69.BigNumber).from(filter.tokenId).toString()
    } : {
        contract_address: filter.contractAddress
    };
}
/**
 * Multiples to increment fee per gas when using
 * {@link TransactNamespace.sendGasOptimizedTransaction}.
 *
 * @internal
 */ const GAS_OPTIMIZED_TX_FEE_MULTIPLES = [
    0.9,
    1,
    1.1,
    1.2,
    1.3
];
/**
 * The Transact namespace contains methods used for sending transactions and
 * checking on the state of submitted transactions.
 *
 * Do not call this constructor directly. Instead, instantiate an Alchemy object
 * with `const alchemy = new Alchemy(config)` and then access the transact
 * namespace via `alchemy.transact`.
 */ class TransactNamespace {
    /** @internal */ constructor(config){
        this.config = config;
    }
    /**
     * Used to send a single transaction to Flashbots. Flashbots will attempt to
     * send the transaction to miners for the next 25 blocks.
     *
     * Returns the transaction hash of the submitted transaction.
     *
     * @param signedTransaction The raw, signed transaction as a hash.
     * @param maxBlockNumber Optional highest block number in which the
     *   transaction should be included.
     * @param options Options to configure the request.
     */ sendPrivateTransaction(signedTransaction, maxBlockNumber, options) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            const hexBlockNumber = maxBlockNumber ? toHex(maxBlockNumber) : undefined;
            return provider._send("eth_sendPrivateTransaction", [
                {
                    tx: signedTransaction,
                    maxBlockNumber: hexBlockNumber,
                    preferences: options
                }
            ], "sendPrivateTransaction");
        });
    }
    /**
     * Stops the provided private transaction from being submitted for future
     * blocks. A transaction can only be cancelled if the request is signed by the
     * same key as the {@link sendPrivateTransaction} call submitting the
     * transaction in first place.
     *
     * Please note that fast mode transactions cannot be cancelled using this method.
     *
     * Returns a boolean indicating whether the cancellation was successful.
     *
     * @param transactionHash Transaction hash of private tx to be cancelled
     */ cancelPrivateTransaction(transactionHash) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider._send("eth_cancelPrivateTransaction", [
                {
                    txHash: transactionHash
                }
            ], "cancelPrivateTransaction");
        });
    }
    /**
     * Simulates the asset changes resulting from a list of transactions simulated
     * in sequence.
     *
     * Returns a list of asset changes for each transaction during simulation.
     *
     * @param transactions Transactions list of max 3 transactions to simulate.
     * @param blockIdentifier Optional block identifier to simulate the
     * transaction in.
     */ simulateAssetChangesBundle(transactions, blockIdentifier) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            const params = blockIdentifier !== undefined ? [
                transactions,
                blockIdentifier
            ] : [
                transactions
            ];
            const res = yield provider._send("alchemy_simulateAssetChangesBundle", params, "simulateAssetChangesBundle");
            return nullsToUndefined(res);
        });
    }
    /**
     * Simulates the asset changes resulting from a single transaction.
     *
     * Returns list of asset changes that occurred during the transaction
     * simulation. Note that this method does not run the transaction on the
     * blockchain.
     *
     * @param transaction The transaction to simulate.
     * @param blockIdentifier Optional block identifier to simulate the
     * transaction in.
     */ simulateAssetChanges(transaction, blockIdentifier) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            const params = blockIdentifier !== undefined ? [
                transaction,
                blockIdentifier
            ] : [
                transaction
            ];
            const res = yield provider._send("alchemy_simulateAssetChanges", params, "simulateAssetChanges");
            return nullsToUndefined(res);
        });
    }
    /**
     * Simulates a list of transactions in sequence and returns list of decoded
     * traces and logs that occurred for each transaction during simulation.
     *
     * Note that this method does not run any transactions on the blockchain.
     *
     * @param transactions Transactions list of max 3 transactions to simulate.
     * @param blockIdentifier Optional block identifier to simulate the
     * transaction in.
     */ simulateExecutionBundle(transactions, blockIdentifier) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            const params = blockIdentifier !== undefined ? [
                transactions,
                blockIdentifier
            ] : [
                transactions
            ];
            const res = provider._send("alchemy_simulateExecutionBundle", params, "simulateExecutionBundle");
            return nullsToUndefined(res);
        });
    }
    /**
     * Simulates a single transaction and the resulting and returns list of
     * decoded traces and logs that occurred during the transaction simulation.
     *
     * Note that this method does not run the transaction on the blockchain.
     *
     * @param transaction The transaction to simulate.
     * @param blockIdentifier Optional block identifier to simulate the
     * transaction in.
     */ simulateExecution(transaction, blockIdentifier) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            const params = blockIdentifier !== undefined ? [
                transaction,
                blockIdentifier
            ] : [
                transaction
            ];
            const res = provider._send("alchemy_simulateExecution", params, "simulateExecution");
            return nullsToUndefined(res);
        });
    }
    /**
     * Returns the transaction with hash or null if the transaction is unknown.
     *
     * If a transaction has not been mined, this method will search the
     * transaction pool. Various backends may have more restrictive transaction
     * pool access (e.g. if the gas price is too low or the transaction was only
     * recently sent and not yet indexed) in which case this method may also return null.
     *
     * NOTE: This is an alias for {@link CoreNamespace.getTransaction}.
     *
     * @param transactionHash The hash of the transaction to get.
     * @public
     */ getTransaction(transactionHash) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.getTransaction(transactionHash);
        });
    }
    /**
     * Submits transaction to the network to be mined. The transaction must be
     * signed, and be valid (i.e. the nonce is correct and the account has
     * sufficient balance to pay for the transaction).
     *
     * NOTE: This is an alias for {@link CoreNamespace.sendTransaction}.
     *
     * @param signedTransaction The signed transaction to send.
     * @public
     */ sendTransaction(signedTransaction) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.sendTransaction(signedTransaction);
        });
    }
    /**
     * Returns an estimate of the amount of gas that would be required to submit
     * transaction to the network.
     *
     * An estimate may not be accurate since there could be another transaction on
     * the network that was not accounted for, but after being mined affects the
     * relevant state.
     *
     * This is an alias for {@link CoreNamespace.estimateGas}.
     *
     * @param transaction The transaction to estimate gas for.
     * @public
     */ estimateGas(transaction) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.estimateGas(transaction);
        });
    }
    /**
     * Returns a fee per gas (in wei) that is an estimate of how much you can pay
     * as a priority fee, or "tip", to get a transaction included in the current block.
     *
     * This number is generally used to set the `maxPriorityFeePerGas` field in a
     * transaction request.
     *
     * @public
     */ getMaxPriorityFeePerGas() {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            const feeHex = yield provider._send("eth_maxPriorityFeePerGas", [], "getMaxPriorityFeePerGas");
            return fromHex(feeHex);
        });
    }
    /**
     * Returns a promise which will not resolve until specified transaction hash is mined.
     *
     * If {@link confirmations} is 0, this method is non-blocking and if the
     * transaction has not been mined returns null. Otherwise, this method will
     * block until the transaction has confirmed blocks mined on top of the block
     * in which it was mined.
     *
     * NOTE: This is an alias for {@link CoreNamespace.waitForTransaction}.
     *
     * @param transactionHash The hash of the transaction to wait for.
     * @param confirmations The number of blocks to wait for.
     * @param timeout The maximum time to wait for the transaction to confirm.
     * @public
     */ waitForTransaction(transactionHash, confirmations, timeout) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider.waitForTransaction(transactionHash, confirmations, timeout);
        });
    }
    sendGasOptimizedTransaction(transactionOrSignedTxs, wallet) {
        return __awaiter$1(this, void 0, void 0, function*() {
            if (Array.isArray(transactionOrSignedTxs)) return this._sendGasOptimizedTransaction(transactionOrSignedTxs, "sendGasOptimizedTransactionPreSigned");
            let gasLimit;
            let priorityFee;
            let baseFee;
            const provider = yield this.config.getProvider();
            try {
                gasLimit = yield this.estimateGas(transactionOrSignedTxs);
                priorityFee = yield this.getMaxPriorityFeePerGas();
                const currentBlock = yield provider.getBlock("latest");
                baseFee = currentBlock.baseFeePerGas.toNumber();
            } catch (e) {
                throw new Error(`Failed to estimate gas for transaction: ${e}`);
            }
            const gasSpreadTransactions = generateGasSpreadTransactions(transactionOrSignedTxs, gasLimit.toNumber(), baseFee, priorityFee);
            const signedTransactions = yield Promise.all(gasSpreadTransactions.map((tx)=>wallet.signTransaction(tx)));
            return this._sendGasOptimizedTransaction(signedTransactions, "sendGasOptimizedTransactionGenerated");
        });
    }
    /**
     * Returns the state of the transaction job returned by the
     * {@link sendGasOptimizedTransaction}.
     *
     * @param trackingId The tracking id from the response of the sent gas optimized transaction.
     * @internal
     */ // TODO(txjob): Remove internal tag once this feature is released.
    getGasOptimizedTransactionStatus(trackingId) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider._send("alchemy_getGasOptimizedTransactionStatus", [
                trackingId
            ], "getGasOptimizedTransactionStatus");
        });
    }
    /** @internal */ _sendGasOptimizedTransaction(signedTransactions, methodName) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            return provider._send("alchemy_sendGasOptimizedTransaction", [
                {
                    rawTransactions: signedTransactions
                }
            ], methodName);
        });
    }
}
/**
 * Helper method to generate the raw transaction with the given gas limit and
 * priority fee across a spread of different gas prices.
 *
 * @internal
 */ // Visible for testing
function generateGasSpreadTransactions(transaction, gasLimit, baseFee, priorityFee) {
    return GAS_OPTIMIZED_TX_FEE_MULTIPLES.map((feeMultiplier)=>{
        return Object.assign(Object.assign({}, transaction), {
            gasLimit: gasLimit,
            maxFeePerGas: Math.round(baseFee * feeMultiplier + priorityFee * feeMultiplier),
            maxPriorityFeePerGas: Math.round(feeMultiplier * priorityFee)
        });
    });
}
/** This file contains internal types used by the SDK and are not exposed to the end user. */ /**
 * Prefix for `alchemy_pendingTransactions` subscriptions when serializing to
 * ethers events.
 *
 * This tag is used internally by ethers to track different event filters.
 */ const ALCHEMY_PENDING_TRANSACTIONS_EVENT_TYPE = "alchemy-pending-transactions";
/**
 * Prefix for `alchemy_minedTransactions` subscriptions when serializing to ethers events.
 *
 * This tag is used internally by ethers to track different event filters.
 */ const ALCHEMY_MINED_TRANSACTIONS_EVENT_TYPE = "alchemy-mined-transactions";
/**
 * Array containing all the custom event tags used internally by ethers to track
 * event filters.
 */ const ALCHEMY_EVENT_TYPES = [
    ALCHEMY_PENDING_TRANSACTIONS_EVENT_TYPE,
    ALCHEMY_MINED_TRANSACTIONS_EVENT_TYPE
];
/**
 * DO NOT MODIFY.
 *
 * Event class copied directly over from ethers.js's `BaseProvider` class.
 *
 * This class is used to represent events and their corresponding listeners. The
 * SDK needs to extend this class in order to support Alchemy's custom
 * Subscription API types. The original class is not exported by ethers. Minimal
 * changes have been made in order to get TS to compile.
 */ class Event {
    constructor(tag, listener, once){
        this.listener = listener;
        this.tag = tag;
        this.once = once;
        this._lastBlockNumber = -2;
        this._inflight = false;
    }
    get event() {
        switch(this.type){
            case "tx":
                return this.hash;
            case "filter":
                return this.filter;
            default:
                return this.tag;
        }
    }
    get type() {
        return this.tag.split(":")[0];
    }
    get hash() {
        const comps = this.tag.split(":");
        if (comps[0] !== "tx") throw new Error("Not a transaction event");
        return comps[1];
    }
    get filter() {
        const comps = this.tag.split(":");
        if (comps[0] !== "filter") throw new Error("Not a transaction event");
        const address = comps[1];
        const topics = deserializeTopics(comps[2]);
        const filter = {};
        if (topics.length > 0) filter.topics = topics;
        if (address && address !== "*") filter.address = address;
        return filter;
    }
    pollable() {
        const PollableEvents = [
            "block",
            "network",
            "pending",
            "poll"
        ];
        return this.tag.indexOf(":") >= 0 || PollableEvents.indexOf(this.tag) >= 0;
    }
}
/**
 * Wrapper class around the ethers `Event` class in order to add support for
 * Alchemy's custom subscriptions types.
 *
 * The serialization and deserialization mechanism requires the order of the
 * fields to be the same across different {@link ALCHEMY_EVENT_TYPES}. Before
 * using a getter on a new event filter, make sure that the position of the
 * field in serialization is correct.
 *
 * The getters on this class deserialize the event tag generated by
 * {@link getAlchemyEventTag} into the original fields passed into the event.
 */ class EthersEvent extends Event {
    /**
     * Converts the event tag into the original `fromAddress` field in
     * {@link AlchemyPendingTransactionsEventFilter}.
     */ get fromAddress() {
        const comps = this.tag.split(":");
        if (comps[0] !== ALCHEMY_PENDING_TRANSACTIONS_EVENT_TYPE) return undefined;
        if (comps[1] && comps[1] !== "*") return deserializeAddressField(comps[1]);
        else return undefined;
    }
    /**
     * Converts the event tag into the original `toAddress` field in
     * {@link AlchemyPendingTransactionsEventFilter}.
     */ get toAddress() {
        const comps = this.tag.split(":");
        if (comps[0] !== ALCHEMY_PENDING_TRANSACTIONS_EVENT_TYPE) return undefined;
        if (comps[2] && comps[2] !== "*") return deserializeAddressField(comps[2]);
        else return undefined;
    }
    /**
     * Converts the event tag into the original `hashesOnly` field in
     * {@link AlchemyPendingTransactionsEventFilter} and {@link AlchemyMinedTransactionsEventFilter}.
     */ get hashesOnly() {
        const comps = this.tag.split(":");
        if (!ALCHEMY_EVENT_TYPES.includes(comps[0])) return undefined;
        if (comps[3] && comps[3] !== "*") return comps[3] === "true";
        else return undefined;
    }
    get includeRemoved() {
        const comps = this.tag.split(":");
        if (comps[0] !== ALCHEMY_MINED_TRANSACTIONS_EVENT_TYPE) return undefined;
        if (comps[2] && comps[2] !== "*") return comps[2] === "true";
        else return undefined;
    }
    get addresses() {
        const comps = this.tag.split(":");
        if (comps[0] !== ALCHEMY_MINED_TRANSACTIONS_EVENT_TYPE) return undefined;
        if (comps[1] && comps[1] !== "*") return deserializeAddressesField(comps[1]);
        else return undefined;
    }
}
function isAlchemyEvent(event) {
    return typeof event === "object" && "method" in event;
}
/**
 * Creates a string representation of an `alchemy_pendingTransaction`
 * subscription filter that is compatible with the ethers implementation of
 * `getEventTag()`. The method is not an exported function in ethers, which is
 * why the SDK has its own implementation.
 *
 * The event tag is then deserialized by the SDK's {@link EthersEvent} getters.
 *
 * @example
 *   ```js
 *   // Returns 'alchemy-pending-transactions:0xABC:0xDEF|0xGHI:true'
 *   const eventTag =  getAlchemyEventTag(
 *   {
 *     "method": "alchemy_pendingTransactions",
 *     "fromAddress": "0xABC",
 *     "toAddress": ["0xDEF", "0xGHI"],
 *     "hashesOnly: true
 *   });
 *   ```;
 *
 * @param event
 * @internal
 */ function getAlchemyEventTag(event) {
    if (!isAlchemyEvent(event)) throw new Error("Event tag requires AlchemyEventType");
    if (event.method === AlchemySubscription.PENDING_TRANSACTIONS) return serializePendingTransactionsEvent(event);
    else if (event.method === AlchemySubscription.MINED_TRANSACTIONS) return serializeMinedTransactionsEvent(event);
    else throw new Error(`Unrecognized AlchemyFilterEvent: ${event}`);
}
function verifyAlchemyEventName(eventName) {
    if (!Object.values(AlchemySubscription).includes(eventName.method)) throw new Error(`Invalid method name ${eventName.method}. Accepted method names: ${Object.values(AlchemySubscription)}`);
}
/**
 * Serializes the provided {@link AlchemyPendingTransactionsEventFilter} into an ethers
 * compatible event tag.
 *
 * For the example event:
 * ```
 *  {
 *     "method": "alchemy_pendingTransactions",
 *     "fromAddress": "0xABC",
 *     "toAddress": ["0xDEF", "0xGHI"],
 *     "hashesOnly: true
 *   }
 * ```
 *
 * The resulting serialization is:
 * `alchemy_pendingTransactions:0xABC:0xDEF|0xGHI:true`
 *
 * If a field is omitted, it is replaced with a `*`.
 */ function serializePendingTransactionsEvent(event) {
    const fromAddress = serializeAddressField(event.fromAddress);
    const toAddress = serializeAddressField(event.toAddress);
    const hashesOnly = serializeBooleanField(event.hashesOnly);
    return ALCHEMY_PENDING_TRANSACTIONS_EVENT_TYPE + ":" + fromAddress + ":" + toAddress + ":" + hashesOnly;
}
/**
 * Serializes the provided {@link AlchemyPendingTransactionsEventFilter} into an ethers
 * compatible event tag.
 *
 * For the example event:
 * ```
 *  {
 *     "method": "alchemy_minedTransactions",
 *     "addresses": [
 *       {
 *         from: "0xABC"
 *       },
 *       {
 *         to: "0xDEF",
 *         from: "0x123"
 *       }
 *     ]
 *     "includeRemoved": false
 *     "hashesOnly: true
 *   }
 * ```
 *
 * The resulting serialization is:
 * `alchemy_minedTransactions:*,0xABC|0xDEF,0x123:false:true`
 *
 * If a field is omitted, it is replaced with a `*`.
 *
 * The `addresses` array is split by the '|' character, and each to/from address
 * pair is separated by a ',' character.
 *
 */ function serializeMinedTransactionsEvent(event) {
    const addresses = serializeAddressesField(event.addresses);
    const includeRemoved = serializeBooleanField(event.includeRemoved);
    const hashesOnly = serializeBooleanField(event.hashesOnly);
    return ALCHEMY_MINED_TRANSACTIONS_EVENT_TYPE + ":" + addresses + ":" + includeRemoved + ":" + hashesOnly;
}
function serializeAddressesField(addresses) {
    if (addresses === undefined) return "*";
    return addresses.map((filter)=>serializeAddressField(filter.to) + "," + serializeAddressField(filter.from)).join("|");
}
function serializeAddressField(field) {
    if (field === undefined) return "*";
    else if (Array.isArray(field)) return field.join("|");
    else return field;
}
function serializeBooleanField(field) {
    if (field === undefined) return "*";
    else return field.toString();
}
function deserializeTopics(data) {
    if (data === "") return [];
    return data.split(/&/g).map((topic)=>{
        if (topic === "") return [];
        const comps = topic.split("|").map((topic)=>{
            return topic === "null" ? null : topic;
        });
        return comps.length === 1 ? comps[0] : comps;
    });
}
function deserializeAddressField(data) {
    if (data === "") return undefined;
    const addresses = data.split("|");
    return addresses.length === 1 ? addresses[0] : addresses;
}
function deserializeAddressesField(data) {
    if (data === "") return undefined;
    // Perform a cast here since TS doesn't know we're guaranteed a non-empty
    // array from deserializing.
    return data.split("|").map((addressStr)=>addressStr.split(",")).map((addressPair)=>Object.assign(Object.assign({}, addressPair[0] !== "*" && {
            to: addressPair[0]
        }), addressPair[1] !== "*" && {
            from: addressPair[1]
        }));
}
/**
 * The Websocket namespace contains all subscription related functions that
 * allow you to subscribe to events and receive updates as they occur. The
 * underlying WebSocket provider has additional logic to handle reconnections
 * and automatically backfills missed events.
 *
 * Do not call this constructor directly. Instead, instantiate an Alchemy object
 * with `const alchemy = new Alchemy(config)` and then access the core namespace
 * via `alchemy.ws`.
 */ class WebSocketNamespace {
    /** @internal */ constructor(config){
        this.config = config;
    }
    /**
     * Adds a listener to be triggered for each {@link eventName} event. Also
     * includes Alchemy's Subscription API events. See {@link AlchemyEventType} for
     * how to use them.
     *
     * @param eventName The event to listen for.
     * @param listener The listener to call when the event is triggered.
     * @public
     */ on(eventName, listener) {
        (()=>__awaiter$1(this, void 0, void 0, function*() {
                const provider = yield this.config.getWebSocketProvider();
                const processedEvent = yield this._resolveEnsAlchemyEvent(eventName);
                provider.on(processedEvent, listener);
            }))();
        return this;
    }
    /**
     * Adds a listener to be triggered for only the next {@link eventName} event,
     * after which it will be removed. Also includes Alchemy's Subscription API
     * events. See {@link AlchemyEventType} for how to use them.
     *
     * @param eventName The event to listen for.
     * @param listener The listener to call when the event is triggered.
     * @public
     */ once(eventName, listener) {
        (()=>__awaiter$1(this, void 0, void 0, function*() {
                const provider = yield this.config.getWebSocketProvider();
                const processedEvent = yield this._resolveEnsAlchemyEvent(eventName);
                provider.once(processedEvent, listener);
            }))();
        return this;
    }
    /**
     * Removes the provided {@link listener} for the {@link eventName} event. If no
     * listener is provided, all listeners for the event will be removed.
     *
     * @param eventName The event to unlisten to.
     * @param listener The listener to remove.
     * @public
     */ off(eventName, listener) {
        (()=>__awaiter$1(this, void 0, void 0, function*() {
                const provider = yield this.config.getWebSocketProvider();
                const processedEvent = yield this._resolveEnsAlchemyEvent(eventName);
                return provider.off(processedEvent, listener);
            }))();
        return this;
    }
    /**
     * Remove all listeners for the provided {@link eventName} event. If no event
     * is provided, all events and their listeners are removed.
     *
     * @param eventName The event to remove all listeners for.
     * @public
     */ removeAllListeners(eventName) {
        (()=>__awaiter$1(this, void 0, void 0, function*() {
                const provider = yield this.config.getWebSocketProvider();
                const processedEvent = eventName ? yield this._resolveEnsAlchemyEvent(eventName) : undefined;
                provider.removeAllListeners(processedEvent);
            }))();
        return this;
    }
    /**
     * Returns the number of listeners for the provided {@link eventName} event. If
     * no event is provided, the total number of listeners for all events is returned.
     *
     * @param eventName The event to get the number of listeners for.
     * @public
     */ listenerCount(eventName) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getWebSocketProvider();
            const processedEvent = eventName ? yield this._resolveEnsAlchemyEvent(eventName) : undefined;
            return provider.listenerCount(processedEvent);
        });
    }
    /**
     * Returns an array of listeners for the provided {@link eventName} event. If
     * no event is provided, all listeners will be included.
     *
     * @param eventName The event to get the listeners for.
     */ listeners(eventName) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getWebSocketProvider();
            const processedEvent = eventName ? yield this._resolveEnsAlchemyEvent(eventName) : undefined;
            return provider.listeners(processedEvent);
        });
    }
    /**
     * Converts ENS addresses in an Alchemy Event to the underlying resolved
     * address.
     *
     * VISIBLE ONLY FOR TESTING.
     *
     * @internal
     */ _resolveEnsAlchemyEvent(eventName) {
        return __awaiter$1(this, void 0, void 0, function*() {
            if (!isAlchemyEvent(eventName)) return eventName;
            if (eventName.method === AlchemySubscription.MINED_TRANSACTIONS && eventName.addresses) {
                const processedAddresses = [];
                for (const address of eventName.addresses){
                    if (address.to) address.to = yield this._resolveNameOrError(address.to);
                    if (address.from) address.from = yield this._resolveNameOrError(address.from);
                    processedAddresses.push(address);
                }
                eventName.addresses = processedAddresses;
            } else if (eventName.method === AlchemySubscription.PENDING_TRANSACTIONS) {
                if (eventName.fromAddress) {
                    if (typeof eventName.fromAddress === "string") eventName.fromAddress = yield this._resolveNameOrError(eventName.fromAddress);
                    else eventName.fromAddress = yield Promise.all(eventName.fromAddress.map((address)=>this._resolveNameOrError(address)));
                }
                if (eventName.toAddress) {
                    if (typeof eventName.toAddress === "string") eventName.toAddress = yield this._resolveNameOrError(eventName.toAddress);
                    else eventName.toAddress = yield Promise.all(eventName.toAddress.map((address)=>this._resolveNameOrError(address)));
                }
            }
            return eventName;
        });
    }
    /**
     * Converts the provided ENS address or throws an error. This improves code
     * readability and type safety in other methods.
     *
     * VISIBLE ONLY FOR TESTING.
     *
     * @internal
     */ _resolveNameOrError(name) {
        return __awaiter$1(this, void 0, void 0, function*() {
            const provider = yield this.config.getProvider();
            const resolved = yield provider.resolveName(name);
            if (resolved === null) throw new Error(`Unable to resolve the ENS address: ${name}`);
            return resolved;
        });
    }
}
/**
 * The Alchemy SDK client. This class is the main entry point into Alchemy's
 * APIs and separates functionality into different namespaces.
 *
 * Each SDK instance is associated with a specific network and API key. To use a
 * different network or API key, create a new instance of {@link Alchemy}.
 *
 * @public
 */ class Alchemy {
    /**
     * @param {string} [settings.apiKey] - The API key to use for Alchemy
     * @param {Network} [settings.network] - The network to use for Alchemy
     * @param {number} [settings.maxRetries] - The maximum number of retries to attempt
     * @param {number} [settings.requestTimeout] - The timeout after which request should fail
     * @public
     */ constructor(settings){
        this.config = new AlchemyConfig(settings);
        this.core = new CoreNamespace(this.config);
        this.nft = new NftNamespace(this.config);
        this.ws = new WebSocketNamespace(this.config);
        this.transact = new TransactNamespace(this.config);
        this.notify = new NotifyNamespace(this.config);
        this.debug = new DebugNamespace(this.config);
    }
}
/**
 * The Wallet class inherits Signer and can sign transactions and messages using
 * a private key as a standard Externally Owned Account (EOA).
 *
 * SDK's custom implementation of Ethers.js's 'Wallet'.
 *
 * Primary difference from Ethers.js 'Wallet' is that you can pass in either a
 * Provider or an Alchemy object. This implementation will intelligently detect
 * the format and set the provider accordingly.
 *
 * @public
 * @override
 */ class Wallet extends (0, $7Um1T.Wallet) {
    /**
     * Overload permits users to pass in either a standard Provider or an Alchemy
     * object. The constructor will detect the object type and handle appropriately.
     *
     * @override
     */ constructor(privateKey, alchemyOrProvider){
        // If object passed in is a provider, send to super
        let superProvider;
        if (alchemyOrProvider && (0, $lOWlX.Provider).isProvider(alchemyOrProvider)) superProvider = alchemyOrProvider;
        super(privateKey, superProvider);
        // If object passed in is an Alchemy object, just set Alchemy
        if (alchemyOrProvider && !(0, $lOWlX.Provider).isProvider(alchemyOrProvider)) this.alchemyProviderPromise = alchemyOrProvider.config.getProvider();
    }
    //////////////////////////////////////////////////////////////////
    // Set of overrides from Signer to handle async provider retrieval.
    //////////////////////////////////////////////////////////////////
    /**
     * Returns the balance of this wallet at blockTag.
     *
     * @param blockTag The block to check the balance of
     * @override
     */ getBalance(blockTag) {
        return this.getWallet().then((wallet)=>wallet.getBalance(blockTag));
    }
    /**
     * Returns the number of transactions this account has ever sent. This is the
     * value required to be included in transactions as the nonce.
     *
     * @param blockTag The block to check the transaction count on
     * @override
     */ getTransactionCount(blockTag) {
        return this.getWallet().then((wallet)=>wallet.getTransactionCount(blockTag));
    }
    /**
     * Returns the result of estimating the cost to send the transactionRequest,
     * with this account address being used as the from field.
     *
     * @param transaction Transaction to estimate the gas on
     * @override
     */ estimateGas(transaction) {
        return this.getWallet().then((wallet)=>wallet.estimateGas(transaction));
    }
    /**
     * Returns the result of calling using the transactionRequest, with this
     * account address being used as the from field.
     *
     * @param transaction To make a call on
     * @param blockTag The block to make the call on
     * @override
     */ call(transaction, blockTag) {
        return this.getWallet().then((wallet)=>wallet.call(transaction, blockTag));
    }
    /**
     * Populates ALL keys for a transaction and checks that `from` matches this
     * `Signer`. Resolves ENS names and populates fields like `gasPrice`, `gasLimit`,
     * `nonce`, and `chainId` if they are not provided.
     *
     * @param transaction The transaction to populate.
     * @override
     */ populateTransaction(transaction) {
        return this.getWallet().then((wallet)=>wallet.populateTransaction(transaction));
    }
    /**
     * Populates all fields in a transaction, signs it and sends it to the network
     *
     * @param transaction The transaction to send.
     * @override
     */ sendTransaction(transaction) {
        return this.getWallet().then((wallet)=>wallet.sendTransaction(transaction));
    }
    /**
     * Returns the chain ID this wallet is connected to.
     *
     * @override
     */ getChainId() {
        return this.getWallet().then((wallet)=>wallet.getChainId());
    }
    /**
     * Returns the current gas price.
     *
     * @override
     */ getGasPrice() {
        return this.getWallet().then((wallet)=>wallet.getGasPrice());
    }
    /**
     * Returns the current recommended FeeData to use in a transaction.
     *
     * For an EIP-1559 transaction, the maxFeePerGas and maxPriorityFeePerGas
     * should be used.
     *
     * For legacy transactions and networks which do not support EIP-1559, the
     * gasPrice should be used.
     *
     * @override
     */ getFeeData() {
        return this.getWallet().then((wallet)=>wallet.getFeeData());
    }
    /**
     * Looks up the address of name. If the name is not owned, or does not have a
     * Resolver configured, or the Resolver does not have an address configured,
     * null is returned.
     *
     * @param name Name of the ENS address
     * @override
     */ resolveName(name) {
        return this.getWallet().then((wallet)=>wallet.resolveName(name));
    }
    getWallet() {
        return __awaiter$1(this, void 0, void 0, function*() {
            if (!this.alchemyProviderPromise) return this.connect(this.provider);
            return this.connect((yield this.alchemyProviderPromise));
        });
    }
}
/**
 * The Contract class is a wrapper around the Contract class from ethers.js and
 * is exported here for convenience.
 *
 * @public
 */ // TODO: support passing in Alchemy instance into the contract.
class Contract extends (0, $9TnCu.Contract) {
}
/**
 * The ContractFactory class is a wrapper around the ContractFactory class from
 * ethers.js and is exported here for convenience.
 *
 * @public
 */ class ContractFactory extends (0, $9TnCu.ContractFactory) {
}

});
parcelRegister("pyHeF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("8AUfX")).default; });

var $8AUfX = parcelRequire("8AUfX");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $04cd3fe2ce3759d4$export$1c00760e9e5a4e95, AxiosError: $04cd3fe2ce3759d4$export$c1fbed17c2f6a328, CanceledError: $04cd3fe2ce3759d4$export$1ab0c6b20d94fa14, isCancel: $04cd3fe2ce3759d4$export$3b22524397b493c6, CancelToken: $04cd3fe2ce3759d4$export$fd08e3cb425f0d61, VERSION: $04cd3fe2ce3759d4$export$a4ad2735b021c132, all: $04cd3fe2ce3759d4$export$84bf76cd7afc7469, Cancel: $04cd3fe2ce3759d4$export$848c9b7ead0df967, isAxiosError: $04cd3fe2ce3759d4$export$fbafdbe06a5b5a9a, spread: $04cd3fe2ce3759d4$export$3ae0fd4797ed47c8, toFormData: $04cd3fe2ce3759d4$export$10ae0d317ea97f8b, AxiosHeaders: $04cd3fe2ce3759d4$export$4e7d6ff0f3e6520, HttpStatusCode: $04cd3fe2ce3759d4$export$a972f69c851492b3, formToJSON: $04cd3fe2ce3759d4$export$86d7c59254d6a2c9, getAdapter: $04cd3fe2ce3759d4$export$17ddc20a97d669e2, mergeConfig: $04cd3fe2ce3759d4$export$7ec1ebcfa9d8bd6a } = (0, $8AUfX.default);

});
parcelRegister("8AUfX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $641d52d8bbda754f$export$2e2bcd8739ae039; });

var $7RwZO = parcelRequire("7RwZO");

var $fudlz = parcelRequire("fudlz");

var $kdMiU = parcelRequire("kdMiU");

var $1GBuV = parcelRequire("1GBuV");

var $kZZ3C = parcelRequire("kZZ3C");

var $bM8ad = parcelRequire("bM8ad");

var $d6ASq = parcelRequire("d6ASq");

var $hzGSx = parcelRequire("hzGSx");

var $bGCAq = parcelRequire("bGCAq");

var $kh2mD = parcelRequire("kh2mD");

var $8Lado = parcelRequire("8Lado");

var $3RcsV = parcelRequire("3RcsV");

var $hZZky = parcelRequire("hZZky");

var $bIIk2 = parcelRequire("bIIk2");

var $gGGbe = parcelRequire("gGGbe");

var $lop3r = parcelRequire("lop3r");

var $aBt7R = parcelRequire("aBt7R");
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $641d52d8bbda754f$var$createInstance(defaultConfig) {
    const context = new (0, $kdMiU.default)(defaultConfig);
    const instance = (0, $fudlz.default)((0, $kdMiU.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $7RwZO.default).extend(instance, (0, $kdMiU.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $7RwZO.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $641d52d8bbda754f$var$createInstance((0, $1GBuV.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $641d52d8bbda754f$var$axios = $641d52d8bbda754f$var$createInstance((0, $kZZ3C.default));
// Expose Axios class to allow class inheritance
$641d52d8bbda754f$var$axios.Axios = (0, $kdMiU.default);
// Expose Cancel & CancelToken
$641d52d8bbda754f$var$axios.CanceledError = (0, $d6ASq.default);
$641d52d8bbda754f$var$axios.CancelToken = (0, $hzGSx.default);
$641d52d8bbda754f$var$axios.isCancel = (0, $bGCAq.default);
$641d52d8bbda754f$var$axios.VERSION = (0, $kh2mD.VERSION);
$641d52d8bbda754f$var$axios.toFormData = (0, $8Lado.default);
// Expose AxiosError class
$641d52d8bbda754f$var$axios.AxiosError = (0, $3RcsV.default);
// alias for CanceledError for backward compatibility
$641d52d8bbda754f$var$axios.Cancel = $641d52d8bbda754f$var$axios.CanceledError;
// Expose all/spread
$641d52d8bbda754f$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$641d52d8bbda754f$var$axios.spread = (0, $hZZky.default);
// Expose isAxiosError
$641d52d8bbda754f$var$axios.isAxiosError = (0, $bIIk2.default);
// Expose mergeConfig
$641d52d8bbda754f$var$axios.mergeConfig = (0, $1GBuV.default);
$641d52d8bbda754f$var$axios.AxiosHeaders = (0, $gGGbe.default);
$641d52d8bbda754f$var$axios.formToJSON = (thing)=>(0, $bM8ad.default)((0, $7RwZO.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$641d52d8bbda754f$var$axios.getAdapter = (0, $lop3r.default).getAdapter;
$641d52d8bbda754f$var$axios.HttpStatusCode = (0, $aBt7R.default);
$641d52d8bbda754f$var$axios.default = $641d52d8bbda754f$var$axios;
var // this module should only have a default export
$641d52d8bbda754f$export$2e2bcd8739ae039 = $641d52d8bbda754f$var$axios;

});
parcelRegister("7RwZO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b9713f3c388ef29$export$2e2bcd8739ae039; });

var $fudlz = parcelRequire("fudlz");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $5b9713f3c388ef29$var$toString } = Object.prototype;
const { getPrototypeOf: $5b9713f3c388ef29$var$getPrototypeOf } = Object;
const $5b9713f3c388ef29$var$kindOf = ((cache)=>(thing)=>{
        const str = $5b9713f3c388ef29$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $5b9713f3c388ef29$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$5b9713f3c388ef29$var$kindOf(thing) === type;
};
const $5b9713f3c388ef29$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $5b9713f3c388ef29$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $5b9713f3c388ef29$var$isUndefined = $5b9713f3c388ef29$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $5b9713f3c388ef29$var$isBuffer(val) {
    return val !== null && !$5b9713f3c388ef29$var$isUndefined(val) && val.constructor !== null && !$5b9713f3c388ef29$var$isUndefined(val.constructor) && $5b9713f3c388ef29$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $5b9713f3c388ef29$var$isArrayBuffer = $5b9713f3c388ef29$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $5b9713f3c388ef29$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $5b9713f3c388ef29$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $5b9713f3c388ef29$var$isString = $5b9713f3c388ef29$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $5b9713f3c388ef29$var$isFunction = $5b9713f3c388ef29$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $5b9713f3c388ef29$var$isNumber = $5b9713f3c388ef29$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $5b9713f3c388ef29$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $5b9713f3c388ef29$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $5b9713f3c388ef29$var$isPlainObject = (val)=>{
    if ($5b9713f3c388ef29$var$kindOf(val) !== "object") return false;
    const prototype = $5b9713f3c388ef29$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $5b9713f3c388ef29$var$isDate = $5b9713f3c388ef29$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $5b9713f3c388ef29$var$isFile = $5b9713f3c388ef29$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $5b9713f3c388ef29$var$isBlob = $5b9713f3c388ef29$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $5b9713f3c388ef29$var$isFileList = $5b9713f3c388ef29$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $5b9713f3c388ef29$var$isStream = (val)=>$5b9713f3c388ef29$var$isObject(val) && $5b9713f3c388ef29$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $5b9713f3c388ef29$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $5b9713f3c388ef29$var$isFunction(thing.append) && ((kind = $5b9713f3c388ef29$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $5b9713f3c388ef29$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $5b9713f3c388ef29$var$isURLSearchParams = $5b9713f3c388ef29$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $5b9713f3c388ef29$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $5b9713f3c388ef29$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($5b9713f3c388ef29$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $5b9713f3c388ef29$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $5b9713f3c388ef29$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $5b9713f3c388ef29$var$isContextDefined = (context)=>!$5b9713f3c388ef29$var$isUndefined(context) && context !== $5b9713f3c388ef29$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $5b9713f3c388ef29$var$merge() {
    const { caseless: caseless } = $5b9713f3c388ef29$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $5b9713f3c388ef29$var$findKey(result, key) || key;
        if ($5b9713f3c388ef29$var$isPlainObject(result[targetKey]) && $5b9713f3c388ef29$var$isPlainObject(val)) result[targetKey] = $5b9713f3c388ef29$var$merge(result[targetKey], val);
        else if ($5b9713f3c388ef29$var$isPlainObject(val)) result[targetKey] = $5b9713f3c388ef29$var$merge({}, val);
        else if ($5b9713f3c388ef29$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $5b9713f3c388ef29$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $5b9713f3c388ef29$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $5b9713f3c388ef29$var$forEach(b, (val, key)=>{
        if (thisArg && $5b9713f3c388ef29$var$isFunction(val)) a[key] = (0, $fudlz.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $5b9713f3c388ef29$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $5b9713f3c388ef29$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $5b9713f3c388ef29$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $5b9713f3c388ef29$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $5b9713f3c388ef29$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $5b9713f3c388ef29$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($5b9713f3c388ef29$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$5b9713f3c388ef29$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $5b9713f3c388ef29$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $5b9713f3c388ef29$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $5b9713f3c388ef29$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $5b9713f3c388ef29$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $5b9713f3c388ef29$var$isHTMLForm = $5b9713f3c388ef29$var$kindOfTest("HTMLFormElement");
const $5b9713f3c388ef29$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $5b9713f3c388ef29$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $5b9713f3c388ef29$var$isRegExp = $5b9713f3c388ef29$var$kindOfTest("RegExp");
const $5b9713f3c388ef29$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $5b9713f3c388ef29$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $5b9713f3c388ef29$var$freezeMethods = (obj)=>{
    $5b9713f3c388ef29$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($5b9713f3c388ef29$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$5b9713f3c388ef29$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $5b9713f3c388ef29$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $5b9713f3c388ef29$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $5b9713f3c388ef29$var$noop = ()=>{};
const $5b9713f3c388ef29$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $5b9713f3c388ef29$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $5b9713f3c388ef29$var$DIGIT = "0123456789";
const $5b9713f3c388ef29$var$ALPHABET = {
    DIGIT: $5b9713f3c388ef29$var$DIGIT,
    ALPHA: $5b9713f3c388ef29$var$ALPHA,
    ALPHA_DIGIT: $5b9713f3c388ef29$var$ALPHA + $5b9713f3c388ef29$var$ALPHA.toUpperCase() + $5b9713f3c388ef29$var$DIGIT
};
const $5b9713f3c388ef29$var$generateString = (size = 16, alphabet = $5b9713f3c388ef29$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $5b9713f3c388ef29$var$isSpecCompliantForm(thing) {
    return !!(thing && $5b9713f3c388ef29$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $5b9713f3c388ef29$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($5b9713f3c388ef29$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $5b9713f3c388ef29$var$isArray(source) ? [] : {};
                $5b9713f3c388ef29$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$5b9713f3c388ef29$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $5b9713f3c388ef29$var$isAsyncFn = $5b9713f3c388ef29$var$kindOfTest("AsyncFunction");
const $5b9713f3c388ef29$var$isThenable = (thing)=>thing && ($5b9713f3c388ef29$var$isObject(thing) || $5b9713f3c388ef29$var$isFunction(thing)) && $5b9713f3c388ef29$var$isFunction(thing.then) && $5b9713f3c388ef29$var$isFunction(thing.catch);
var $5b9713f3c388ef29$export$2e2bcd8739ae039 = {
    isArray: $5b9713f3c388ef29$var$isArray,
    isArrayBuffer: $5b9713f3c388ef29$var$isArrayBuffer,
    isBuffer: $5b9713f3c388ef29$var$isBuffer,
    isFormData: $5b9713f3c388ef29$var$isFormData,
    isArrayBufferView: $5b9713f3c388ef29$var$isArrayBufferView,
    isString: $5b9713f3c388ef29$var$isString,
    isNumber: $5b9713f3c388ef29$var$isNumber,
    isBoolean: $5b9713f3c388ef29$var$isBoolean,
    isObject: $5b9713f3c388ef29$var$isObject,
    isPlainObject: $5b9713f3c388ef29$var$isPlainObject,
    isUndefined: $5b9713f3c388ef29$var$isUndefined,
    isDate: $5b9713f3c388ef29$var$isDate,
    isFile: $5b9713f3c388ef29$var$isFile,
    isBlob: $5b9713f3c388ef29$var$isBlob,
    isRegExp: $5b9713f3c388ef29$var$isRegExp,
    isFunction: $5b9713f3c388ef29$var$isFunction,
    isStream: $5b9713f3c388ef29$var$isStream,
    isURLSearchParams: $5b9713f3c388ef29$var$isURLSearchParams,
    isTypedArray: $5b9713f3c388ef29$var$isTypedArray,
    isFileList: $5b9713f3c388ef29$var$isFileList,
    forEach: $5b9713f3c388ef29$var$forEach,
    merge: $5b9713f3c388ef29$var$merge,
    extend: $5b9713f3c388ef29$var$extend,
    trim: $5b9713f3c388ef29$var$trim,
    stripBOM: $5b9713f3c388ef29$var$stripBOM,
    inherits: $5b9713f3c388ef29$var$inherits,
    toFlatObject: $5b9713f3c388ef29$var$toFlatObject,
    kindOf: $5b9713f3c388ef29$var$kindOf,
    kindOfTest: $5b9713f3c388ef29$var$kindOfTest,
    endsWith: $5b9713f3c388ef29$var$endsWith,
    toArray: $5b9713f3c388ef29$var$toArray,
    forEachEntry: $5b9713f3c388ef29$var$forEachEntry,
    matchAll: $5b9713f3c388ef29$var$matchAll,
    isHTMLForm: $5b9713f3c388ef29$var$isHTMLForm,
    hasOwnProperty: $5b9713f3c388ef29$var$hasOwnProperty,
    hasOwnProp: $5b9713f3c388ef29$var$hasOwnProperty,
    reduceDescriptors: $5b9713f3c388ef29$var$reduceDescriptors,
    freezeMethods: $5b9713f3c388ef29$var$freezeMethods,
    toObjectSet: $5b9713f3c388ef29$var$toObjectSet,
    toCamelCase: $5b9713f3c388ef29$var$toCamelCase,
    noop: $5b9713f3c388ef29$var$noop,
    toFiniteNumber: $5b9713f3c388ef29$var$toFiniteNumber,
    findKey: $5b9713f3c388ef29$var$findKey,
    global: $5b9713f3c388ef29$var$_global,
    isContextDefined: $5b9713f3c388ef29$var$isContextDefined,
    ALPHABET: $5b9713f3c388ef29$var$ALPHABET,
    generateString: $5b9713f3c388ef29$var$generateString,
    isSpecCompliantForm: $5b9713f3c388ef29$var$isSpecCompliantForm,
    toJSONObject: $5b9713f3c388ef29$var$toJSONObject,
    isAsyncFn: $5b9713f3c388ef29$var$isAsyncFn,
    isThenable: $5b9713f3c388ef29$var$isThenable
};

});
parcelRegister("fudlz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b46402ca51b9d848$export$2e2bcd8739ae039; });
"use strict";
function $b46402ca51b9d848$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("kdMiU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb8a7db82136a1db$export$2e2bcd8739ae039; });

var $7RwZO = parcelRequire("7RwZO");

var $9sFHI = parcelRequire("9sFHI");

var $4hdy1 = parcelRequire("4hdy1");

var $50aQc = parcelRequire("50aQc");

var $1GBuV = parcelRequire("1GBuV");

var $hVRNn = parcelRequire("hVRNn");

var $gl3dP = parcelRequire("gl3dP");

var $gGGbe = parcelRequire("gGGbe");
"use strict";
const $eb8a7db82136a1db$var$validators = (0, $gl3dP.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $eb8a7db82136a1db$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $4hdy1.default)(),
            response: new (0, $4hdy1.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                if (!err.stack) err.stack = stack;
                else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $1GBuV.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $gl3dP.default).assertOptions(transitional, {
            silentJSONParsing: $eb8a7db82136a1db$var$validators.transitional($eb8a7db82136a1db$var$validators.boolean),
            forcedJSONParsing: $eb8a7db82136a1db$var$validators.transitional($eb8a7db82136a1db$var$validators.boolean),
            clarifyTimeoutError: $eb8a7db82136a1db$var$validators.transitional($eb8a7db82136a1db$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $7RwZO.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $gl3dP.default).assertOptions(paramsSerializer, {
                encode: $eb8a7db82136a1db$var$validators.function,
                serialize: $eb8a7db82136a1db$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $7RwZO.default).merge(headers.common, headers[config.method]);
        headers && (0, $7RwZO.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $gGGbe.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $50aQc.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $50aQc.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $1GBuV.default)(this.defaults, config);
        const fullPath = (0, $hVRNn.default)(config.baseURL, config.url);
        return (0, $9sFHI.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $7RwZO.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $eb8a7db82136a1db$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $1GBuV.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $7RwZO.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $1GBuV.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $eb8a7db82136a1db$var$Axios.prototype[method] = generateHTTPMethod();
    $eb8a7db82136a1db$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $eb8a7db82136a1db$export$2e2bcd8739ae039 = $eb8a7db82136a1db$var$Axios;

});
parcelRegister("9sFHI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e37142bb1e4d8e7$export$2e2bcd8739ae039; });

var $7RwZO = parcelRequire("7RwZO");

var $7RIH3 = parcelRequire("7RIH3");
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $6e37142bb1e4d8e7$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $6e37142bb1e4d8e7$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $6e37142bb1e4d8e7$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $7RwZO.default).isURLSearchParams(params) ? params.toString() : new (0, $7RIH3.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

});
parcelRegister("7RIH3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ba026d229511467$export$2e2bcd8739ae039; });

var $8Lado = parcelRequire("8Lado");
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $5ba026d229511467$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $5ba026d229511467$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $8Lado.default)(params, this, options);
}
const $5ba026d229511467$var$prototype = $5ba026d229511467$var$AxiosURLSearchParams.prototype;
$5ba026d229511467$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$5ba026d229511467$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $5ba026d229511467$var$encode);
    } : $5ba026d229511467$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $5ba026d229511467$export$2e2bcd8739ae039 = $5ba026d229511467$var$AxiosURLSearchParams;

});
parcelRegister("8Lado", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $660aa2ffcbb70858$export$2e2bcd8739ae039; });

var $7RwZO = parcelRequire("7RwZO");

var $3RcsV = parcelRequire("3RcsV");

var $fH6EJ = parcelRequire("fH6EJ");

var $7ulbJ = parcelRequire("7ulbJ");
var $660aa2ffcbb70858$require$Buffer = $7ulbJ.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $660aa2ffcbb70858$var$isVisitable(thing) {
    return (0, $7RwZO.default).isPlainObject(thing) || (0, $7RwZO.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $660aa2ffcbb70858$var$removeBrackets(key) {
    return (0, $7RwZO.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $660aa2ffcbb70858$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $660aa2ffcbb70858$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $660aa2ffcbb70858$var$isFlatArray(arr) {
    return (0, $7RwZO.default).isArray(arr) && !arr.some($660aa2ffcbb70858$var$isVisitable);
}
const $660aa2ffcbb70858$var$predicates = (0, $7RwZO.default).toFlatObject((0, $7RwZO.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $660aa2ffcbb70858$var$toFormData(obj, formData, options) {
    if (!(0, $7RwZO.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $fH6EJ.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $7RwZO.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $7RwZO.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $7RwZO.default).isSpecCompliantForm(formData);
    if (!(0, $7RwZO.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $7RwZO.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $7RwZO.default).isBlob(value)) throw new (0, $3RcsV.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, $7RwZO.default).isArrayBuffer(value) || (0, $7RwZO.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $660aa2ffcbb70858$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $7RwZO.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $7RwZO.default).isArray(value) && $660aa2ffcbb70858$var$isFlatArray(value) || ((0, $7RwZO.default).isFileList(value) || (0, $7RwZO.default).endsWith(key, "[]")) && (arr = (0, $7RwZO.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $660aa2ffcbb70858$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $7RwZO.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $660aa2ffcbb70858$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($660aa2ffcbb70858$var$isVisitable(value)) return true;
        formData.append($660aa2ffcbb70858$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($660aa2ffcbb70858$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $660aa2ffcbb70858$var$isVisitable
    });
    function build(value, path) {
        if ((0, $7RwZO.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $7RwZO.default).forEach(value, function each(el, key) {
            const result = !((0, $7RwZO.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $7RwZO.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $7RwZO.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $660aa2ffcbb70858$export$2e2bcd8739ae039 = $660aa2ffcbb70858$var$toFormData;

});
parcelRegister("3RcsV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ceffdba23138a9a$export$2e2bcd8739ae039; });

var $7RwZO = parcelRequire("7RwZO");
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $2ceffdba23138a9a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $7RwZO.default).inherits($2ceffdba23138a9a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $7RwZO.default).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $2ceffdba23138a9a$var$prototype = $2ceffdba23138a9a$var$AxiosError.prototype;
const $2ceffdba23138a9a$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $2ceffdba23138a9a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($2ceffdba23138a9a$var$AxiosError, $2ceffdba23138a9a$var$descriptors);
Object.defineProperty($2ceffdba23138a9a$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$2ceffdba23138a9a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($2ceffdba23138a9a$var$prototype);
    (0, $7RwZO.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $2ceffdba23138a9a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $2ceffdba23138a9a$export$2e2bcd8739ae039 = $2ceffdba23138a9a$var$AxiosError;

});

parcelRegister("fH6EJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6d008e7026423b1$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $b6d008e7026423b1$export$2e2bcd8739ae039 = null;

});




parcelRegister("4hdy1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31d342405fa786b0$export$2e2bcd8739ae039; });

var $7RwZO = parcelRequire("7RwZO");
"use strict";
class $31d342405fa786b0$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $7RwZO.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $31d342405fa786b0$export$2e2bcd8739ae039 = $31d342405fa786b0$var$InterceptorManager;

});

parcelRegister("50aQc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a455c98c85d4363$export$2e2bcd8739ae039; });

var $7eOdD = parcelRequire("7eOdD");

var $bGCAq = parcelRequire("bGCAq");

var $kZZ3C = parcelRequire("kZZ3C");

var $d6ASq = parcelRequire("d6ASq");

var $gGGbe = parcelRequire("gGGbe");

var $lop3r = parcelRequire("lop3r");
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $3a455c98c85d4363$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $d6ASq.default)(null, config);
}
function $3a455c98c85d4363$export$2e2bcd8739ae039(config) {
    $3a455c98c85d4363$var$throwIfCancellationRequested(config);
    config.headers = (0, $gGGbe.default).from(config.headers);
    // Transform request data
    config.data = (0, $7eOdD.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $lop3r.default).getAdapter(config.adapter || (0, $kZZ3C.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $3a455c98c85d4363$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $7eOdD.default).call(config, config.transformResponse, response);
        response.headers = (0, $gGGbe.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $bGCAq.default)(reason)) {
            $3a455c98c85d4363$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $7eOdD.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $gGGbe.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("7eOdD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5450cba380c47367$export$2e2bcd8739ae039; });

var $7RwZO = parcelRequire("7RwZO");

var $kZZ3C = parcelRequire("kZZ3C");

var $gGGbe = parcelRequire("gGGbe");
"use strict";
function $5450cba380c47367$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $kZZ3C.default);
    const context = response || config;
    const headers = (0, $gGGbe.default).from(context.headers);
    let data = context.data;
    (0, $7RwZO.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("kZZ3C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f498dde26bc3c11a$export$2e2bcd8739ae039; });

var $7RwZO = parcelRequire("7RwZO");

var $3RcsV = parcelRequire("3RcsV");

var $4RLdO = parcelRequire("4RLdO");

var $8Lado = parcelRequire("8Lado");

var $5rRS9 = parcelRequire("5rRS9");

var $jXyyC = parcelRequire("jXyyC");

var $bM8ad = parcelRequire("bM8ad");
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $f498dde26bc3c11a$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $7RwZO.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $7RwZO.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $f498dde26bc3c11a$var$defaults = {
    transitional: (0, $4RLdO.default),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $7RwZO.default).isObject(data);
            if (isObjectPayload && (0, $7RwZO.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $7RwZO.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $bM8ad.default)(data)) : data;
            if ((0, $7RwZO.default).isArrayBuffer(data) || (0, $7RwZO.default).isBuffer(data) || (0, $7RwZO.default).isStream(data) || (0, $7RwZO.default).isFile(data) || (0, $7RwZO.default).isBlob(data)) return data;
            if ((0, $7RwZO.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $7RwZO.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $5rRS9.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $7RwZO.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $8Lado.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $f498dde26bc3c11a$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $f498dde26bc3c11a$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $7RwZO.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $3RcsV.default).from(e, (0, $3RcsV.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $jXyyC.default).classes.FormData,
        Blob: (0, $jXyyC.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $7RwZO.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $f498dde26bc3c11a$var$defaults.headers[method] = {};
});
var $f498dde26bc3c11a$export$2e2bcd8739ae039 = $f498dde26bc3c11a$var$defaults;

});
parcelRegister("4RLdO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38b0bde9bf431c95$export$2e2bcd8739ae039; });
"use strict";
var $38b0bde9bf431c95$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("5rRS9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f79434aaf2049f1$export$2e2bcd8739ae039; });

var $7RwZO = parcelRequire("7RwZO");

var $8Lado = parcelRequire("8Lado");

var $jXyyC = parcelRequire("jXyyC");
"use strict";
function $3f79434aaf2049f1$export$2e2bcd8739ae039(data, options) {
    return (0, $8Lado.default)(data, new (0, $jXyyC.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $jXyyC.default).isNode && (0, $7RwZO.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("jXyyC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e87e55668dff4ebc$export$2e2bcd8739ae039; });

var $4Wig1 = parcelRequire("4Wig1");

var $4zBy4 = parcelRequire("4zBy4");
var $e87e55668dff4ebc$export$2e2bcd8739ae039 = {
    ...$4zBy4,
    ...(0, $4Wig1.default)
};

});
parcelRegister("4Wig1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $398abdc58c6ddff8$export$2e2bcd8739ae039; });

var $aGFKc = parcelRequire("aGFKc");

var $iZt3J = parcelRequire("iZt3J");

var $5M9wj = parcelRequire("5M9wj");
var $398abdc58c6ddff8$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $aGFKc.default,
        FormData: $iZt3J.default,
        Blob: $5M9wj.default
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

});
parcelRegister("aGFKc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c7e352a21d3e21f$export$2e2bcd8739ae039; });

var $7RIH3 = parcelRequire("7RIH3");
"use strict";
var $7c7e352a21d3e21f$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $7RIH3.default);

});

parcelRegister("iZt3J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd34770bbdf3811d$export$2e2bcd8739ae039; });
"use strict";
var $dd34770bbdf3811d$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;

});

parcelRegister("5M9wj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4348d1f570a61775$export$2e2bcd8739ae039; });
"use strict";
var $4348d1f570a61775$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;

});


parcelRegister("4zBy4", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $35478eaadef4d915$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $35478eaadef4d915$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $35478eaadef4d915$export$c81692cf5af97dac; });
const $35478eaadef4d915$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $35478eaadef4d915$export$c0bcc9250309d66 = ((product)=>{
    return $35478eaadef4d915$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $35478eaadef4d915$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();

});



parcelRegister("bM8ad", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $892a828bb198d42d$export$2e2bcd8739ae039; });

var $7RwZO = parcelRequire("7RwZO");
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $892a828bb198d42d$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $7RwZO.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $892a828bb198d42d$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $892a828bb198d42d$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $7RwZO.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $7RwZO.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $7RwZO.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $7RwZO.default).isArray(target[name])) target[name] = $892a828bb198d42d$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $7RwZO.default).isFormData(formData) && (0, $7RwZO.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $7RwZO.default).forEachEntry(formData, (name, value)=>{
            buildPath($892a828bb198d42d$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $892a828bb198d42d$export$2e2bcd8739ae039 = $892a828bb198d42d$var$formDataToJSON;

});


parcelRegister("gGGbe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c26149a9da2bf8e3$export$2e2bcd8739ae039; });

var $7RwZO = parcelRequire("7RwZO");

var $7BbhE = parcelRequire("7BbhE");
"use strict";
const $c26149a9da2bf8e3$var$$internals = Symbol("internals");
function $c26149a9da2bf8e3$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c26149a9da2bf8e3$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $7RwZO.default).isArray(value) ? value.map($c26149a9da2bf8e3$var$normalizeValue) : String(value);
}
function $c26149a9da2bf8e3$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c26149a9da2bf8e3$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c26149a9da2bf8e3$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $7RwZO.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $7RwZO.default).isString(value)) return;
    if ((0, $7RwZO.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $7RwZO.default).isRegExp(filter)) return filter.test(value);
}
function $c26149a9da2bf8e3$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c26149a9da2bf8e3$var$buildAccessors(obj, header) {
    const accessorName = (0, $7RwZO.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c26149a9da2bf8e3$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c26149a9da2bf8e3$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $7RwZO.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c26149a9da2bf8e3$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $7RwZO.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $7RwZO.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $7RwZO.default).isString(header) && (header = header.trim()) && !$c26149a9da2bf8e3$var$isValidHeaderName(header)) setHeaders((0, $7BbhE.default)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c26149a9da2bf8e3$var$normalizeHeader(header);
        if (header) {
            const key = (0, $7RwZO.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c26149a9da2bf8e3$var$parseTokens(value);
                if ((0, $7RwZO.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $7RwZO.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $c26149a9da2bf8e3$var$normalizeHeader(header);
        if (header) {
            const key = (0, $7RwZO.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c26149a9da2bf8e3$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c26149a9da2bf8e3$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $7RwZO.default).findKey(self, _header);
                if (key && (!matcher || $c26149a9da2bf8e3$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $7RwZO.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c26149a9da2bf8e3$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $7RwZO.default).forEach(this, (value, header)=>{
            const key = (0, $7RwZO.default).findKey(headers, header);
            if (key) {
                self[key] = $c26149a9da2bf8e3$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c26149a9da2bf8e3$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c26149a9da2bf8e3$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $7RwZO.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $7RwZO.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c26149a9da2bf8e3$var$$internals] = this[$c26149a9da2bf8e3$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c26149a9da2bf8e3$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c26149a9da2bf8e3$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $7RwZO.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$c26149a9da2bf8e3$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $7RwZO.default).reduceDescriptors($c26149a9da2bf8e3$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $7RwZO.default).freezeMethods($c26149a9da2bf8e3$var$AxiosHeaders);
var $c26149a9da2bf8e3$export$2e2bcd8739ae039 = $c26149a9da2bf8e3$var$AxiosHeaders;

});
parcelRegister("7BbhE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5884bdcce8e89141$export$2e2bcd8739ae039; });

var $7RwZO = parcelRequire("7RwZO");
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $5884bdcce8e89141$var$ignoreDuplicateOf = (0, $7RwZO.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $5884bdcce8e89141$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $5884bdcce8e89141$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

});



parcelRegister("bGCAq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88218c738ec3a297$export$2e2bcd8739ae039; });
"use strict";
function $88218c738ec3a297$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("d6ASq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98a870e4257dcc38$export$2e2bcd8739ae039; });

var $3RcsV = parcelRequire("3RcsV");

var $7RwZO = parcelRequire("7RwZO");
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $98a870e4257dcc38$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $3RcsV.default).call(this, message == null ? "canceled" : message, (0, $3RcsV.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $7RwZO.default).inherits($98a870e4257dcc38$var$CanceledError, (0, $3RcsV.default), {
    __CANCEL__: true
});
var $98a870e4257dcc38$export$2e2bcd8739ae039 = $98a870e4257dcc38$var$CanceledError;

});

parcelRegister("lop3r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f92f4624efa9cabc$export$2e2bcd8739ae039; });

var $7RwZO = parcelRequire("7RwZO");

var $fH6EJ = parcelRequire("fH6EJ");

var $lwanz = parcelRequire("lwanz");

var $3RcsV = parcelRequire("3RcsV");
const $f92f4624efa9cabc$var$knownAdapters = {
    http: (0, $fH6EJ.default),
    xhr: (0, $lwanz.default)
};
(0, $7RwZO.default).forEach($f92f4624efa9cabc$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $f92f4624efa9cabc$var$renderReason = (reason)=>`- ${reason}`;
const $f92f4624efa9cabc$var$isResolvedHandle = (adapter)=>(0, $7RwZO.default).isFunction(adapter) || adapter === null || adapter === false;
var $f92f4624efa9cabc$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $7RwZO.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$f92f4624efa9cabc$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $f92f4624efa9cabc$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $3RcsV.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($f92f4624efa9cabc$var$renderReason).join("\n") : " " + $f92f4624efa9cabc$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $3RcsV.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $f92f4624efa9cabc$var$knownAdapters
};

});
parcelRegister("lwanz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faa4a33c938b3cc1$export$2e2bcd8739ae039; });

var $7RwZO = parcelRequire("7RwZO");

var $gUf0D = parcelRequire("gUf0D");

var $bxd0G = parcelRequire("bxd0G");

var $9sFHI = parcelRequire("9sFHI");

var $hVRNn = parcelRequire("hVRNn");

var $ka5QT = parcelRequire("ka5QT");

var $4RLdO = parcelRequire("4RLdO");

var $3RcsV = parcelRequire("3RcsV");

var $d6ASq = parcelRequire("d6ASq");

var $hPWSA = parcelRequire("hPWSA");

var $jXyyC = parcelRequire("jXyyC");

var $gGGbe = parcelRequire("gGGbe");

var $iBR0U = parcelRequire("iBR0U");
"use strict";
function $faa4a33c938b3cc1$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $iBR0U.default)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $faa4a33c938b3cc1$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $faa4a33c938b3cc1$export$2e2bcd8739ae039 = $faa4a33c938b3cc1$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $gGGbe.default).from(config.headers).normalize();
        let { responseType: responseType, withXSRFToken: withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, $7RwZO.default).isFormData(requestData)) {
            if ((0, $jXyyC.default).hasStandardBrowserEnv || (0, $jXyyC.default).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $hVRNn.default)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $9sFHI.default)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $gGGbe.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $gUf0D.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $3RcsV.default)("Request aborted", (0, $3RcsV.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $3RcsV.default)("Network Error", (0, $3RcsV.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $4RLdO.default);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $3RcsV.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $3RcsV.default).ETIMEDOUT : (0, $3RcsV.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $jXyyC.default).hasStandardBrowserEnv) {
            withXSRFToken && (0, $7RwZO.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, $ka5QT.default)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, $bxd0G.default).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $7RwZO.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $7RwZO.default).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $faa4a33c938b3cc1$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $faa4a33c938b3cc1$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $d6ASq.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $hPWSA.default)(fullPath);
        if (protocol && (0, $jXyyC.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $3RcsV.default)("Unsupported protocol " + protocol + ":", (0, $3RcsV.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("gUf0D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4ed84d6df3724cf$export$2e2bcd8739ae039; });

var $3RcsV = parcelRequire("3RcsV");
"use strict";
function $c4ed84d6df3724cf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $3RcsV.default)("Request failed with status code " + response.status, [
        (0, $3RcsV.default).ERR_BAD_REQUEST,
        (0, $3RcsV.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("bxd0G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $865cde45a3161431$export$2e2bcd8739ae039; });

var $7RwZO = parcelRequire("7RwZO");

var $jXyyC = parcelRequire("jXyyC");
var $865cde45a3161431$export$2e2bcd8739ae039 = (0, $jXyyC.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $7RwZO.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $7RwZO.default).isString(path) && cookie.push("path=" + path);
        (0, $7RwZO.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("hVRNn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0e17d32095e35ed$export$2e2bcd8739ae039; });

var $1KQip = parcelRequire("1KQip");

var $9uPPq = parcelRequire("9uPPq");
"use strict";
function $d0e17d32095e35ed$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $1KQip.default)(requestedURL)) return (0, $9uPPq.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("1KQip", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1472a739c4a121ce$export$2e2bcd8739ae039; });
"use strict";
function $1472a739c4a121ce$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("9uPPq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e9f1e710e805b44$export$2e2bcd8739ae039; });
"use strict";
function $6e9f1e710e805b44$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

});


parcelRegister("ka5QT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ead947ea20f680b7$export$2e2bcd8739ae039; });

var $7RwZO = parcelRequire("7RwZO");

var $jXyyC = parcelRequire("jXyyC");
"use strict";
var $ead947ea20f680b7$export$2e2bcd8739ae039 = (0, $jXyyC.default).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $7RwZO.default).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("hPWSA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfc4df4dca4f32e4$export$2e2bcd8739ae039; });
"use strict";
function $cfc4df4dca4f32e4$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

});

parcelRegister("iBR0U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8c4ce18c9baf9f3$export$2e2bcd8739ae039; });
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $d8c4ce18c9baf9f3$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $d8c4ce18c9baf9f3$export$2e2bcd8739ae039 = $d8c4ce18c9baf9f3$var$speedometer;

});




parcelRegister("1GBuV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13a6ccf31ebd16b6$export$2e2bcd8739ae039; });

var $7RwZO = parcelRequire("7RwZO");

var $gGGbe = parcelRequire("gGGbe");
"use strict";
const $13a6ccf31ebd16b6$var$headersToObject = (thing)=>thing instanceof (0, $gGGbe.default) ? {
        ...thing
    } : thing;
function $13a6ccf31ebd16b6$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $7RwZO.default).isPlainObject(target) && (0, $7RwZO.default).isPlainObject(source)) return (0, $7RwZO.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $7RwZO.default).isPlainObject(source)) return (0, $7RwZO.default).merge({}, source);
        else if ((0, $7RwZO.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $7RwZO.default).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $7RwZO.default).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $7RwZO.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $7RwZO.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $7RwZO.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($13a6ccf31ebd16b6$var$headersToObject(a), $13a6ccf31ebd16b6$var$headersToObject(b), true)
    };
    (0, $7RwZO.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $7RwZO.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});

parcelRegister("gl3dP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be511b5951617af9$export$2e2bcd8739ae039; });

var $kh2mD = parcelRequire("kh2mD");

var $3RcsV = parcelRequire("3RcsV");
"use strict";
const $be511b5951617af9$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $be511b5951617af9$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $be511b5951617af9$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $be511b5951617af9$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $kh2mD.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $3RcsV.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $3RcsV.default).ERR_DEPRECATED);
        if (version && !$be511b5951617af9$var$deprecatedWarnings[opt]) {
            $be511b5951617af9$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $be511b5951617af9$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $3RcsV.default)("options must be an object", (0, $3RcsV.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $3RcsV.default)("option " + opt + " must be " + result, (0, $3RcsV.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $3RcsV.default)("Unknown option " + opt, (0, $3RcsV.default).ERR_BAD_OPTION);
    }
}
var $be511b5951617af9$export$2e2bcd8739ae039 = {
    assertOptions: $be511b5951617af9$var$assertOptions,
    validators: $be511b5951617af9$var$validators
};

});
parcelRegister("kh2mD", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $ec273aa66f03f41f$export$a4ad2735b021c132; });
const $ec273aa66f03f41f$export$a4ad2735b021c132 = "1.6.8";

});



parcelRegister("hzGSx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccb6f7616ca020c2$export$2e2bcd8739ae039; });

var $d6ASq = parcelRequire("d6ASq");
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $ccb6f7616ca020c2$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $d6ASq.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $ccb6f7616ca020c2$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $ccb6f7616ca020c2$export$2e2bcd8739ae039 = $ccb6f7616ca020c2$var$CancelToken;

});

parcelRegister("hZZky", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1a7b52407b6909e$export$2e2bcd8739ae039; });
"use strict";
function $d1a7b52407b6909e$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("bIIk2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88862f42a0d94c0e$export$2e2bcd8739ae039; });

var $7RwZO = parcelRequire("7RwZO");
"use strict";
function $88862f42a0d94c0e$export$2e2bcd8739ae039(payload) {
    return (0, $7RwZO.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("aBt7R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b83f3d5530b96f8$export$2e2bcd8739ae039; });
const $7b83f3d5530b96f8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($7b83f3d5530b96f8$var$HttpStatusCode).forEach(([key, value])=>{
    $7b83f3d5530b96f8$var$HttpStatusCode[value] = key;
});
var $7b83f3d5530b96f8$export$2e2bcd8739ae039 = $7b83f3d5530b96f8$var$HttpStatusCode;

});



parcelRegister("36jM4", function(module, exports) {


module.exports = (parcelRequire("cKPUe"))((parcelRequire("jwisd")).resolve("6Y5IT")).then(()=>parcelRequire("2KOJH"));

});

parcelRegister("9Dozk", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("cKPUe"))((parcelRequire("jwisd")).resolve("6Y5IT")),
    (parcelRequire("cKPUe"))((parcelRequire("jwisd")).resolve("jtn0q"))
]).then(()=>parcelRequire("iyb4Z"));

});


parcelRegister("dmOVR", function(module, exports) {
"use strict";
// ref: https://github.com/tc39/proposal-global
var getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
};
var globalObject = getGlobal();
module.exports = exports = globalObject.fetch;
// Needed for TypeScript and Webpack.
if (globalObject.fetch) exports.default = globalObject.fetch.bind(globalObject);
exports.Headers = globalObject.Headers;
exports.Request = globalObject.Request;
exports.Response = globalObject.Response;

});

var $dde41420777b5d34$exports = {};
"use strict";

$dde41420777b5d34$exports = (parcelRequire("6XFBA"));



var $9nZCP = parcelRequire("9nZCP");
var $d6d573f2d6b6d1f8$export$882461b6382ed46c;
var $d6d573f2d6b6d1f8$export$757ceba2d55c277e;
"use strict";
var $06928105ffc753ea$exports = {};
"use strict";
function $06928105ffc753ea$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($06928105ffc753ea$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$06928105ffc753ea$var$checkDCE();

$06928105ffc753ea$exports = (parcelRequire("lNe1g"));


var $d6d573f2d6b6d1f8$var$i;
$d6d573f2d6b6d1f8$export$882461b6382ed46c = $06928105ffc753ea$exports.createRoot;
$d6d573f2d6b6d1f8$export$757ceba2d55c277e = $06928105ffc753ea$exports.hydrateRoot;



parcelRequire("9nZCP");
/**
 * React Router v6.21.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $9nZCP = parcelRequire("9nZCP");
/**
 * @remix-run/router v1.14.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $6ab4d96c61a6f348$var$_extends() {
    $6ab4d96c61a6f348$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6ab4d96c61a6f348$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $6ab4d96c61a6f348$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($6ab4d96c61a6f348$export$e19cd5f9376f8cee || ($6ab4d96c61a6f348$export$e19cd5f9376f8cee = {}));
const $6ab4d96c61a6f348$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $6ab4d96c61a6f348$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $6ab4d96c61a6f348$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $6ab4d96c61a6f348$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $6ab4d96c61a6f348$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $6ab4d96c61a6f348$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $6ab4d96c61a6f348$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $6ab4d96c61a6f348$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $6ab4d96c61a6f348$export$fe53371bee54353d(to);
    }
    return $6ab4d96c61a6f348$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $6ab4d96c61a6f348$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $6ab4d96c61a6f348$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $6ab4d96c61a6f348$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $6ab4d96c61a6f348$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $6ab4d96c61a6f348$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $6ab4d96c61a6f348$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $6ab4d96c61a6f348$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $6ab4d96c61a6f348$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $6ab4d96c61a6f348$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $6ab4d96c61a6f348$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $6ab4d96c61a6f348$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $6ab4d96c61a6f348$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $6ab4d96c61a6f348$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $6ab4d96c61a6f348$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $6ab4d96c61a6f348$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $6ab4d96c61a6f348$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $6ab4d96c61a6f348$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($6ab4d96c61a6f348$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Push;
        let location = $6ab4d96c61a6f348$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $6ab4d96c61a6f348$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Replace;
        let location = $6ab4d96c61a6f348$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $6ab4d96c61a6f348$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $6ab4d96c61a6f348$export$fe53371bee54353d(to);
        $6ab4d96c61a6f348$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($6ab4d96c61a6f348$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($6ab4d96c61a6f348$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $6ab4d96c61a6f348$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($6ab4d96c61a6f348$var$ResultType || ($6ab4d96c61a6f348$var$ResultType = {}));
const $6ab4d96c61a6f348$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $6ab4d96c61a6f348$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $6ab4d96c61a6f348$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $6ab4d96c61a6f348$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $6ab4d96c61a6f348$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($6ab4d96c61a6f348$var$isIndexRoute(route)) {
            let indexRoute = $6ab4d96c61a6f348$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $6ab4d96c61a6f348$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $6ab4d96c61a6f348$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $6ab4d96c61a6f348$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $6ab4d96c61a6f348$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $6ab4d96c61a6f348$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $6ab4d96c61a6f348$var$flattenRoutes(routes);
    $6ab4d96c61a6f348$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $6ab4d96c61a6f348$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $6ab4d96c61a6f348$var$safelyDecodeURI(pathname));
    return matches;
}
function $6ab4d96c61a6f348$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $6ab4d96c61a6f348$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $6ab4d96c61a6f348$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $6ab4d96c61a6f348$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $6ab4d96c61a6f348$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $6ab4d96c61a6f348$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $6ab4d96c61a6f348$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $6ab4d96c61a6f348$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $6ab4d96c61a6f348$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $6ab4d96c61a6f348$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $6ab4d96c61a6f348$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $6ab4d96c61a6f348$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $6ab4d96c61a6f348$var$paramRe = /^:[\w-]+$/;
const $6ab4d96c61a6f348$var$dynamicSegmentValue = 3;
const $6ab4d96c61a6f348$var$indexRouteValue = 2;
const $6ab4d96c61a6f348$var$emptySegmentValue = 1;
const $6ab4d96c61a6f348$var$staticSegmentValue = 10;
const $6ab4d96c61a6f348$var$splatPenalty = -2;
const $6ab4d96c61a6f348$var$isSplat = (s)=>s === "*";
function $6ab4d96c61a6f348$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($6ab4d96c61a6f348$var$isSplat)) initialScore += $6ab4d96c61a6f348$var$splatPenalty;
    if (index) initialScore += $6ab4d96c61a6f348$var$indexRouteValue;
    return segments.filter((s)=>!$6ab4d96c61a6f348$var$isSplat(s)).reduce((score, segment)=>score + ($6ab4d96c61a6f348$var$paramRe.test(segment) ? $6ab4d96c61a6f348$var$dynamicSegmentValue : segment === "" ? $6ab4d96c61a6f348$var$emptySegmentValue : $6ab4d96c61a6f348$var$staticSegmentValue), initialScore);
}
function $6ab4d96c61a6f348$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $6ab4d96c61a6f348$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $6ab4d96c61a6f348$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $6ab4d96c61a6f348$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $6ab4d96c61a6f348$export$a5c6d149b50c1d86($6ab4d96c61a6f348$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $6ab4d96c61a6f348$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $6ab4d96c61a6f348$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $6ab4d96c61a6f348$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $6ab4d96c61a6f348$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $6ab4d96c61a6f348$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $6ab4d96c61a6f348$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $6ab4d96c61a6f348$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $6ab4d96c61a6f348$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $6ab4d96c61a6f348$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $6ab4d96c61a6f348$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $6ab4d96c61a6f348$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $6ab4d96c61a6f348$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $6ab4d96c61a6f348$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $6ab4d96c61a6f348$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $6ab4d96c61a6f348$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $6ab4d96c61a6f348$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $6ab4d96c61a6f348$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $6ab4d96c61a6f348$var$normalizeSearch(search),
        hash: $6ab4d96c61a6f348$var$normalizeHash(hash)
    };
}
function $6ab4d96c61a6f348$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $6ab4d96c61a6f348$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $6ab4d96c61a6f348$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $6ab4d96c61a6f348$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $6ab4d96c61a6f348$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $6ab4d96c61a6f348$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $6ab4d96c61a6f348$export$8ccf933b0513f8d0(toArg);
    else {
        to = $6ab4d96c61a6f348$var$_extends({}, toArg);
        $6ab4d96c61a6f348$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $6ab4d96c61a6f348$var$getInvalidPathError("?", "pathname", "search", to));
        $6ab4d96c61a6f348$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $6ab4d96c61a6f348$var$getInvalidPathError("#", "pathname", "hash", to));
        $6ab4d96c61a6f348$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $6ab4d96c61a6f348$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $6ab4d96c61a6f348$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $6ab4d96c61a6f348$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $6ab4d96c61a6f348$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $6ab4d96c61a6f348$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $6ab4d96c61a6f348$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $6ab4d96c61a6f348$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $6ab4d96c61a6f348$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $6ab4d96c61a6f348$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $6ab4d96c61a6f348$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $6ab4d96c61a6f348$export$42a99a7a4bc0e76a extends Error {
}
class $6ab4d96c61a6f348$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $6ab4d96c61a6f348$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $6ab4d96c61a6f348$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $6ab4d96c61a6f348$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $6ab4d96c61a6f348$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $6ab4d96c61a6f348$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $6ab4d96c61a6f348$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $6ab4d96c61a6f348$var$unwrapTrackedPromise(value) {
    if (!$6ab4d96c61a6f348$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $6ab4d96c61a6f348$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $6ab4d96c61a6f348$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $6ab4d96c61a6f348$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $6ab4d96c61a6f348$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $6ab4d96c61a6f348$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $6ab4d96c61a6f348$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $6ab4d96c61a6f348$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $6ab4d96c61a6f348$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $6ab4d96c61a6f348$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $6ab4d96c61a6f348$var$validMutationMethods = new Set($6ab4d96c61a6f348$var$validMutationMethodsArr);
const $6ab4d96c61a6f348$var$validRequestMethodsArr = [
    "get",
    ...$6ab4d96c61a6f348$var$validMutationMethodsArr
];
const $6ab4d96c61a6f348$var$validRequestMethods = new Set($6ab4d96c61a6f348$var$validRequestMethodsArr);
const $6ab4d96c61a6f348$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $6ab4d96c61a6f348$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $6ab4d96c61a6f348$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $6ab4d96c61a6f348$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $6ab4d96c61a6f348$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $6ab4d96c61a6f348$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $6ab4d96c61a6f348$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $6ab4d96c61a6f348$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $6ab4d96c61a6f348$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $6ab4d96c61a6f348$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $6ab4d96c61a6f348$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $6ab4d96c61a6f348$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $6ab4d96c61a6f348$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $6ab4d96c61a6f348$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $6ab4d96c61a6f348$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $6ab4d96c61a6f348$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every((m)=>m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $6ab4d96c61a6f348$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $6ab4d96c61a6f348$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $6ab4d96c61a6f348$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $6ab4d96c61a6f348$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$6ab4d96c61a6f348$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($6ab4d96c61a6f348$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $6ab4d96c61a6f348$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $6ab4d96c61a6f348$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $6ab4d96c61a6f348$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $6ab4d96c61a6f348$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $6ab4d96c61a6f348$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($6ab4d96c61a6f348$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $6ab4d96c61a6f348$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $6ab4d96c61a6f348$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $6ab4d96c61a6f348$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $6ab4d96c61a6f348$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $6ab4d96c61a6f348$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $6ab4d96c61a6f348$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $6ab4d96c61a6f348$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $6ab4d96c61a6f348$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $6ab4d96c61a6f348$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $6ab4d96c61a6f348$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $6ab4d96c61a6f348$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $6ab4d96c61a6f348$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $6ab4d96c61a6f348$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$6ab4d96c61a6f348$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $6ab4d96c61a6f348$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $6ab4d96c61a6f348$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $6ab4d96c61a6f348$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $6ab4d96c61a6f348$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $6ab4d96c61a6f348$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $6ab4d96c61a6f348$var$ResultType.error,
            error: $6ab4d96c61a6f348$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $6ab4d96c61a6f348$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($6ab4d96c61a6f348$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($6ab4d96c61a6f348$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $6ab4d96c61a6f348$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($6ab4d96c61a6f348$var$isDeferredResult(result)) throw $6ab4d96c61a6f348$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $6ab4d96c61a6f348$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $6ab4d96c61a6f348$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $6ab4d96c61a6f348$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $6ab4d96c61a6f348$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since iot's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $6ab4d96c61a6f348$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($6ab4d96c61a6f348$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $6ab4d96c61a6f348$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $6ab4d96c61a6f348$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $6ab4d96c61a6f348$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $6ab4d96c61a6f348$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $6ab4d96c61a6f348$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $6ab4d96c61a6f348$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $6ab4d96c61a6f348$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $6ab4d96c61a6f348$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $6ab4d96c61a6f348$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $6ab4d96c61a6f348$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $6ab4d96c61a6f348$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $6ab4d96c61a6f348$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $6ab4d96c61a6f348$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($6ab4d96c61a6f348$var$isRedirectResult(actionResult) || $6ab4d96c61a6f348$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $6ab4d96c61a6f348$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($6ab4d96c61a6f348$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $6ab4d96c61a6f348$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $6ab4d96c61a6f348$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($6ab4d96c61a6f348$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($6ab4d96c61a6f348$var$isDeferredResult(actionResult)) throw $6ab4d96c61a6f348$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $6ab4d96c61a6f348$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $6ab4d96c61a6f348$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $6ab4d96c61a6f348$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $6ab4d96c61a6f348$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $6ab4d96c61a6f348$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $6ab4d96c61a6f348$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $6ab4d96c61a6f348$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $6ab4d96c61a6f348$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $6ab4d96c61a6f348$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $6ab4d96c61a6f348$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $6ab4d96c61a6f348$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $6ab4d96c61a6f348$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $6ab4d96c61a6f348$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $6ab4d96c61a6f348$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($6ab4d96c61a6f348$var$isDeferredResult(result)) result = await $6ab4d96c61a6f348$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $6ab4d96c61a6f348$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($6ab4d96c61a6f348$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $6ab4d96c61a6f348$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($6ab4d96c61a6f348$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $6ab4d96c61a6f348$export$3e9cee6b33872309(!$6ab4d96c61a6f348$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $6ab4d96c61a6f348$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $6ab4d96c61a6f348$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $6ab4d96c61a6f348$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($6ab4d96c61a6f348$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $6ab4d96c61a6f348$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Replace : $6ab4d96c61a6f348$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $6ab4d96c61a6f348$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($6ab4d96c61a6f348$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $6ab4d96c61a6f348$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $6ab4d96c61a6f348$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $6ab4d96c61a6f348$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$6ab4d96c61a6f348$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $6ab4d96c61a6f348$var$callLoaderOrAction("loader", $6ab4d96c61a6f348$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $6ab4d96c61a6f348$var$ResultType.error,
                        error: $6ab4d96c61a6f348$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $6ab4d96c61a6f348$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $6ab4d96c61a6f348$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $6ab4d96c61a6f348$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $6ab4d96c61a6f348$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $6ab4d96c61a6f348$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $6ab4d96c61a6f348$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $6ab4d96c61a6f348$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $6ab4d96c61a6f348$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $6ab4d96c61a6f348$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $6ab4d96c61a6f348$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $6ab4d96c61a6f348$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $6ab4d96c61a6f348$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $6ab4d96c61a6f348$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$6ab4d96c61a6f348$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $6ab4d96c61a6f348$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $6ab4d96c61a6f348$export$4d0306f8f6a4585b = Symbol("deferred");
function $6ab4d96c61a6f348$export$3336b097a6fbc59a(routes, opts) {
    $6ab4d96c61a6f348$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $6ab4d96c61a6f348$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $6ab4d96c61a6f348$var$_extends({
        v7_relativeSplatPath: false
    }, opts ? opts.future : null);
    let dataRoutes = $6ab4d96c61a6f348$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $6ab4d96c61a6f348$var$createLocation("", $6ab4d96c61a6f348$export$fe53371bee54353d(url), null, "default");
        let matches = $6ab4d96c61a6f348$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$6ab4d96c61a6f348$var$isValidMethod(method) && method !== "HEAD") {
            let error = $6ab4d96c61a6f348$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $6ab4d96c61a6f348$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $6ab4d96c61a6f348$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $6ab4d96c61a6f348$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($6ab4d96c61a6f348$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $6ab4d96c61a6f348$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $6ab4d96c61a6f348$var$createLocation("", $6ab4d96c61a6f348$export$fe53371bee54353d(url), null, "default");
        let matches = $6ab4d96c61a6f348$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$6ab4d96c61a6f348$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $6ab4d96c61a6f348$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $6ab4d96c61a6f348$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $6ab4d96c61a6f348$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $6ab4d96c61a6f348$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $6ab4d96c61a6f348$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($6ab4d96c61a6f348$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$6ab4d96c61a6f348$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $6ab4d96c61a6f348$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($6ab4d96c61a6f348$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $6ab4d96c61a6f348$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $6ab4d96c61a6f348$var$isResponse(result) ? result : $6ab4d96c61a6f348$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($6ab4d96c61a6f348$var$isQueryRouteResponse(e)) {
                if (e.type === $6ab4d96c61a6f348$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($6ab4d96c61a6f348$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $6ab4d96c61a6f348$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $6ab4d96c61a6f348$var$ResultType.error,
                error: error
            };
        } else {
            result = await $6ab4d96c61a6f348$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($6ab4d96c61a6f348$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($6ab4d96c61a6f348$var$isDeferredResult(result)) {
            let error = $6ab4d96c61a6f348$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $6ab4d96c61a6f348$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($6ab4d96c61a6f348$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($6ab4d96c61a6f348$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $6ab4d96c61a6f348$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $6ab4d96c61a6f348$var$_extends({}, context, {
                statusCode: $6ab4d96c61a6f348$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $6ab4d96c61a6f348$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $6ab4d96c61a6f348$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $6ab4d96c61a6f348$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $6ab4d96c61a6f348$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $6ab4d96c61a6f348$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$6ab4d96c61a6f348$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $6ab4d96c61a6f348$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $6ab4d96c61a6f348$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $6ab4d96c61a6f348$export$fec11da027c70692(routes, context, error) {
    let newContext = $6ab4d96c61a6f348$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $6ab4d96c61a6f348$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $6ab4d96c61a6f348$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $6ab4d96c61a6f348$export$cae722b0cc860f13(to ? to : ".", $6ab4d96c61a6f348$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $6ab4d96c61a6f348$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$6ab4d96c61a6f348$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $6ab4d96c61a6f348$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $6ab4d96c61a6f348$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $6ab4d96c61a6f348$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$6ab4d96c61a6f348$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$6ab4d96c61a6f348$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $6ab4d96c61a6f348$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $6ab4d96c61a6f348$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $6ab4d96c61a6f348$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$6ab4d96c61a6f348$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$6ab4d96c61a6f348$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $6ab4d96c61a6f348$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $6ab4d96c61a6f348$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $6ab4d96c61a6f348$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $6ab4d96c61a6f348$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $6ab4d96c61a6f348$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($6ab4d96c61a6f348$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $6ab4d96c61a6f348$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $6ab4d96c61a6f348$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $6ab4d96c61a6f348$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $6ab4d96c61a6f348$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $6ab4d96c61a6f348$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $6ab4d96c61a6f348$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($6ab4d96c61a6f348$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $6ab4d96c61a6f348$var$shouldRevalidateLoader(match, $6ab4d96c61a6f348$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $6ab4d96c61a6f348$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $6ab4d96c61a6f348$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $6ab4d96c61a6f348$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $6ab4d96c61a6f348$var$shouldRevalidateLoader(fetcherMatch, $6ab4d96c61a6f348$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $6ab4d96c61a6f348$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $6ab4d96c61a6f348$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $6ab4d96c61a6f348$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $6ab4d96c61a6f348$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $6ab4d96c61a6f348$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $6ab4d96c61a6f348$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$6ab4d96c61a6f348$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $6ab4d96c61a6f348$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $6ab4d96c61a6f348$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $6ab4d96c61a6f348$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $6ab4d96c61a6f348$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $6ab4d96c61a6f348$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $6ab4d96c61a6f348$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $6ab4d96c61a6f348$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $6ab4d96c61a6f348$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $6ab4d96c61a6f348$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($6ab4d96c61a6f348$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($6ab4d96c61a6f348$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $6ab4d96c61a6f348$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$6ab4d96c61a6f348$var$ABSOLUTE_URL_REGEX.test(location)) location = $6ab4d96c61a6f348$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $6ab4d96c61a6f348$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $6ab4d96c61a6f348$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $6ab4d96c61a6f348$var$ResultType.error ? $6ab4d96c61a6f348$var$ResultType.error : $6ab4d96c61a6f348$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $6ab4d96c61a6f348$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $6ab4d96c61a6f348$var$ResultType.error) return {
            type: resultType,
            error: new $6ab4d96c61a6f348$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $6ab4d96c61a6f348$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $6ab4d96c61a6f348$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($6ab4d96c61a6f348$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $6ab4d96c61a6f348$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $6ab4d96c61a6f348$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $6ab4d96c61a6f348$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($6ab4d96c61a6f348$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $6ab4d96c61a6f348$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $6ab4d96c61a6f348$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $6ab4d96c61a6f348$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $6ab4d96c61a6f348$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $6ab4d96c61a6f348$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $6ab4d96c61a6f348$export$3e9cee6b33872309(!$6ab4d96c61a6f348$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($6ab4d96c61a6f348$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $6ab4d96c61a6f348$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $6ab4d96c61a6f348$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($6ab4d96c61a6f348$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $6ab4d96c61a6f348$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $6ab4d96c61a6f348$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $6ab4d96c61a6f348$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($6ab4d96c61a6f348$var$isErrorResult(result)) {
            let boundaryMatch = $6ab4d96c61a6f348$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $6ab4d96c61a6f348$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($6ab4d96c61a6f348$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $6ab4d96c61a6f348$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($6ab4d96c61a6f348$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $6ab4d96c61a6f348$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $6ab4d96c61a6f348$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $6ab4d96c61a6f348$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $6ab4d96c61a6f348$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $6ab4d96c61a6f348$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $6ab4d96c61a6f348$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $6ab4d96c61a6f348$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $6ab4d96c61a6f348$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $6ab4d96c61a6f348$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($6ab4d96c61a6f348$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $6ab4d96c61a6f348$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $6ab4d96c61a6f348$export$8ccf933b0513f8d0(path) : path;
    return $6ab4d96c61a6f348$export$fe53371bee54353d($6ab4d96c61a6f348$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $6ab4d96c61a6f348$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $6ab4d96c61a6f348$var$isDeferredResult(result) {
    return result.type === $6ab4d96c61a6f348$var$ResultType.deferred;
}
function $6ab4d96c61a6f348$var$isErrorResult(result) {
    return result.type === $6ab4d96c61a6f348$var$ResultType.error;
}
function $6ab4d96c61a6f348$var$isRedirectResult(result) {
    return (result && result.type) === $6ab4d96c61a6f348$var$ResultType.redirect;
}
function $6ab4d96c61a6f348$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $6ab4d96c61a6f348$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $6ab4d96c61a6f348$var$isRedirectResponse(result) {
    if (!$6ab4d96c61a6f348$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $6ab4d96c61a6f348$var$isQueryRouteResponse(obj) {
    return obj && $6ab4d96c61a6f348$var$isResponse(obj.response) && (obj.type === $6ab4d96c61a6f348$var$ResultType.data || obj.type === $6ab4d96c61a6f348$var$ResultType.error);
}
function $6ab4d96c61a6f348$var$isValidMethod(method) {
    return $6ab4d96c61a6f348$var$validRequestMethods.has(method.toLowerCase());
}
function $6ab4d96c61a6f348$var$isMutationMethod(method) {
    return $6ab4d96c61a6f348$var$validMutationMethods.has(method.toLowerCase());
}
async function $6ab4d96c61a6f348$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$6ab4d96c61a6f348$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($6ab4d96c61a6f348$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $6ab4d96c61a6f348$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $6ab4d96c61a6f348$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $6ab4d96c61a6f348$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $6ab4d96c61a6f348$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $6ab4d96c61a6f348$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $6ab4d96c61a6f348$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $6ab4d96c61a6f348$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $6ab4d96c61a6f348$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $6ab4d96c61a6f348$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $6ab4d96c61a6f348$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $6ab4d96c61a6f348$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $6ab4d96c61a6f348$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $6ab4d96c61a6f348$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $6ab4d96c61a6f348$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $6ab4d96c61a6f348$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $6ab4d96c61a6f348$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $6ab4d96c61a6f348$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $6ab4d96c61a6f348$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($6ab4d96c61a6f348$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $6ab4d96c61a6f348$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($6ab4d96c61a6f348$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $6ab4d96c61a6f348$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}


function $cb6812e0fa529c57$var$_extends() {
    $cb6812e0fa529c57$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cb6812e0fa529c57$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $cb6812e0fa529c57$export$3add0d5dce533e2e = /*#__PURE__*/ $9nZCP.createContext(null);
const $cb6812e0fa529c57$export$145dfa71566a64dc = /*#__PURE__*/ $9nZCP.createContext(null);
const $cb6812e0fa529c57$var$AwaitContext = /*#__PURE__*/ $9nZCP.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $cb6812e0fa529c57$export$26749e8557646306 = /*#__PURE__*/ $9nZCP.createContext(null);
const $cb6812e0fa529c57$export$c7914228fb69b0f5 = /*#__PURE__*/ $9nZCP.createContext(null);
const $cb6812e0fa529c57$export$9072aa6dd1f93057 = /*#__PURE__*/ $9nZCP.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $cb6812e0fa529c57$var$RouteErrorContext = /*#__PURE__*/ $9nZCP.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $cb6812e0fa529c57$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$cb6812e0fa529c57$export$9c954a9d03d32f4a() && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $9nZCP.useContext($cb6812e0fa529c57$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $cb6812e0fa529c57$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $6ab4d96c61a6f348$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $cb6812e0fa529c57$export$9c954a9d03d32f4a() {
    return $9nZCP.useContext($cb6812e0fa529c57$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $cb6812e0fa529c57$export$45d76561a5302f2b() {
    !$cb6812e0fa529c57$export$9c954a9d03d32f4a() && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
    return $9nZCP.useContext($cb6812e0fa529c57$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $cb6812e0fa529c57$export$1b3f31771c5d07c() {
    return $9nZCP.useContext($cb6812e0fa529c57$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $cb6812e0fa529c57$export$6c330e8992e8a295(pattern) {
    !$cb6812e0fa529c57$export$9c954a9d03d32f4a() && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $cb6812e0fa529c57$export$45d76561a5302f2b();
    return $9nZCP.useMemo(()=>(0, $6ab4d96c61a6f348$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $cb6812e0fa529c57$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $cb6812e0fa529c57$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $9nZCP.useContext($cb6812e0fa529c57$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $9nZCP.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $cb6812e0fa529c57$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $9nZCP.useContext($cb6812e0fa529c57$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $cb6812e0fa529c57$var$useNavigateStable() : $cb6812e0fa529c57$var$useNavigateUnstable();
}
function $cb6812e0fa529c57$var$useNavigateUnstable() {
    !$cb6812e0fa529c57$export$9c954a9d03d32f4a() && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
    let dataRouterContext = $9nZCP.useContext($cb6812e0fa529c57$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $9nZCP.useContext($cb6812e0fa529c57$export$26749e8557646306);
    let { matches: matches } = $9nZCP.useContext($cb6812e0fa529c57$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $cb6812e0fa529c57$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $6ab4d96c61a6f348$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $9nZCP.useRef(false);
    $cb6812e0fa529c57$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $9nZCP.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $6ab4d96c61a6f348$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $6ab4d96c61a6f348$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $cb6812e0fa529c57$var$OutletContext = /*#__PURE__*/ $9nZCP.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $cb6812e0fa529c57$export$4138103a3ae699cc() {
    return $9nZCP.useContext($cb6812e0fa529c57$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $cb6812e0fa529c57$export$a3be3530d8e40d0b(context) {
    let outlet = $9nZCP.useContext($cb6812e0fa529c57$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $9nZCP.createElement($cb6812e0fa529c57$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $cb6812e0fa529c57$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $9nZCP.useContext($cb6812e0fa529c57$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $cb6812e0fa529c57$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $9nZCP.useContext($cb6812e0fa529c57$export$26749e8557646306);
    let { matches: matches } = $9nZCP.useContext($cb6812e0fa529c57$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $cb6812e0fa529c57$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $6ab4d96c61a6f348$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $9nZCP.useMemo(()=>(0, $6ab4d96c61a6f348$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $cb6812e0fa529c57$export$5d3fca4a98652595(routes, locationArg) {
    return $cb6812e0fa529c57$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $cb6812e0fa529c57$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$cb6812e0fa529c57$export$9c954a9d03d32f4a() && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $9nZCP.useContext($cb6812e0fa529c57$export$26749e8557646306);
    let { matches: parentMatches } = $9nZCP.useContext($cb6812e0fa529c57$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $cb6812e0fa529c57$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $6ab4d96c61a6f348$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $6ab4d96c61a6f348$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $cb6812e0fa529c57$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $6ab4d96c61a6f348$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $6ab4d96c61a6f348$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $9nZCP.createElement($cb6812e0fa529c57$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $cb6812e0fa529c57$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $6ab4d96c61a6f348$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $cb6812e0fa529c57$var$DefaultErrorComponent() {
    let error = $cb6812e0fa529c57$export$ed527bf60f6e05f2();
    let message = (0, $6ab4d96c61a6f348$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $9nZCP.createElement($9nZCP.Fragment, null, /*#__PURE__*/ $9nZCP.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $9nZCP.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $9nZCP.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $cb6812e0fa529c57$var$defaultErrorElement = /*#__PURE__*/ $9nZCP.createElement($cb6812e0fa529c57$var$DefaultErrorComponent, null);
class $cb6812e0fa529c57$var$RenderErrorBoundary extends $9nZCP.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $9nZCP.createElement($cb6812e0fa529c57$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $9nZCP.createElement($cb6812e0fa529c57$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $cb6812e0fa529c57$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $9nZCP.useContext($cb6812e0fa529c57$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $9nZCP.createElement($cb6812e0fa529c57$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $cb6812e0fa529c57$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $cb6812e0fa529c57$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $cb6812e0fa529c57$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $9nZCP.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $9nZCP.createElement($cb6812e0fa529c57$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $9nZCP.createElement($cb6812e0fa529c57$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $cb6812e0fa529c57$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($cb6812e0fa529c57$var$DataRouterHook || {});
var $cb6812e0fa529c57$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($cb6812e0fa529c57$var$DataRouterStateHook || {});
function $cb6812e0fa529c57$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $cb6812e0fa529c57$var$useDataRouterContext(hookName) {
    let ctx = $9nZCP.useContext($cb6812e0fa529c57$export$3add0d5dce533e2e);
    !ctx && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
    return ctx;
}
function $cb6812e0fa529c57$var$useDataRouterState(hookName) {
    let state = $9nZCP.useContext($cb6812e0fa529c57$export$145dfa71566a64dc);
    !state && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
    return state;
}
function $cb6812e0fa529c57$var$useRouteContext(hookName) {
    let route = $9nZCP.useContext($cb6812e0fa529c57$export$9072aa6dd1f93057);
    !route && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $cb6812e0fa529c57$var$useCurrentRouteId(hookName) {
    let route = $cb6812e0fa529c57$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $cb6812e0fa529c57$export$5fc8298006ad9e58() {
    return $cb6812e0fa529c57$var$useCurrentRouteId($cb6812e0fa529c57$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $cb6812e0fa529c57$export$d0fd4b7106de2769() {
    let state = $cb6812e0fa529c57$var$useDataRouterState($cb6812e0fa529c57$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $cb6812e0fa529c57$export$600dc272ed516c15() {
    let dataRouterContext = $cb6812e0fa529c57$var$useDataRouterContext($cb6812e0fa529c57$var$DataRouterHook.UseRevalidator);
    let state = $cb6812e0fa529c57$var$useDataRouterState($cb6812e0fa529c57$var$DataRouterStateHook.UseRevalidator);
    return $9nZCP.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $cb6812e0fa529c57$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $cb6812e0fa529c57$var$useDataRouterState($cb6812e0fa529c57$var$DataRouterStateHook.UseMatches);
    return $9nZCP.useMemo(()=>matches.map((m)=>(0, $6ab4d96c61a6f348$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $cb6812e0fa529c57$export$1448a5050d252c4d() {
    let state = $cb6812e0fa529c57$var$useDataRouterState($cb6812e0fa529c57$var$DataRouterStateHook.UseLoaderData);
    let routeId = $cb6812e0fa529c57$var$useCurrentRouteId($cb6812e0fa529c57$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $cb6812e0fa529c57$export$fd5d37484eab868d(routeId) {
    let state = $cb6812e0fa529c57$var$useDataRouterState($cb6812e0fa529c57$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $cb6812e0fa529c57$export$fdc00f3f26066d5e() {
    let state = $cb6812e0fa529c57$var$useDataRouterState($cb6812e0fa529c57$var$DataRouterStateHook.UseActionData);
    let routeId = $cb6812e0fa529c57$var$useCurrentRouteId($cb6812e0fa529c57$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $cb6812e0fa529c57$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $9nZCP.useContext($cb6812e0fa529c57$var$RouteErrorContext);
    let state = $cb6812e0fa529c57$var$useDataRouterState($cb6812e0fa529c57$var$DataRouterStateHook.UseRouteError);
    let routeId = $cb6812e0fa529c57$var$useCurrentRouteId($cb6812e0fa529c57$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $cb6812e0fa529c57$export$78a72ddb39bdd145() {
    let value = $9nZCP.useContext($cb6812e0fa529c57$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $cb6812e0fa529c57$export$17f53340677d5831() {
    let value = $9nZCP.useContext($cb6812e0fa529c57$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $cb6812e0fa529c57$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $cb6812e0fa529c57$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $cb6812e0fa529c57$var$useDataRouterContext($cb6812e0fa529c57$var$DataRouterHook.UseBlocker);
    let state = $cb6812e0fa529c57$var$useDataRouterState($cb6812e0fa529c57$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $9nZCP.useState("");
    let blockerFunction = $9nZCP.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $cb6812e0fa529c57$var$_extends({}, currentLocation, {
                pathname: (0, $6ab4d96c61a6f348$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $cb6812e0fa529c57$var$_extends({}, nextLocation, {
                pathname: (0, $6ab4d96c61a6f348$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $9nZCP.useEffect(()=>{
        let key = String(++$cb6812e0fa529c57$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $9nZCP.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $6ab4d96c61a6f348$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $cb6812e0fa529c57$var$useNavigateStable() {
    let { router: router } = $cb6812e0fa529c57$var$useDataRouterContext($cb6812e0fa529c57$var$DataRouterHook.UseNavigateStable);
    let id = $cb6812e0fa529c57$var$useCurrentRouteId($cb6812e0fa529c57$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $9nZCP.useRef(false);
    $cb6812e0fa529c57$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $9nZCP.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $cb6812e0fa529c57$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $cb6812e0fa529c57$var$alreadyWarned = {};
function $cb6812e0fa529c57$var$warningOnce(key, cond, message) {
    if (!cond && !$cb6812e0fa529c57$var$alreadyWarned[key]) $cb6812e0fa529c57$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $cb6812e0fa529c57$var$START_TRANSITION = "startTransition";
const $cb6812e0fa529c57$var$startTransitionImpl = $9nZCP[$cb6812e0fa529c57$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $cb6812e0fa529c57$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $9nZCP.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $9nZCP.useCallback((newState)=>{
        if (v7_startTransition && $cb6812e0fa529c57$var$startTransitionImpl) $cb6812e0fa529c57$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $9nZCP.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $9nZCP.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $9nZCP.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $9nZCP.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $9nZCP.createElement($9nZCP.Fragment, null, /*#__PURE__*/ $9nZCP.createElement($cb6812e0fa529c57$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $9nZCP.createElement($cb6812e0fa529c57$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $9nZCP.createElement($cb6812e0fa529c57$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $9nZCP.createElement($cb6812e0fa529c57$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $cb6812e0fa529c57$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $cb6812e0fa529c57$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $cb6812e0fa529c57$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $9nZCP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $6ab4d96c61a6f348$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $9nZCP.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $9nZCP.useCallback((newState)=>{
        v7_startTransition && $cb6812e0fa529c57$var$startTransitionImpl ? $cb6812e0fa529c57$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $9nZCP.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $9nZCP.createElement($cb6812e0fa529c57$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $cb6812e0fa529c57$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$cb6812e0fa529c57$export$9c954a9d03d32f4a() && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $9nZCP.useContext($cb6812e0fa529c57$export$26749e8557646306);
    let { matches: matches } = $9nZCP.useContext($cb6812e0fa529c57$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $cb6812e0fa529c57$export$45d76561a5302f2b();
    let navigate = $cb6812e0fa529c57$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $6ab4d96c61a6f348$export$cae722b0cc860f13)(to, (0, $6ab4d96c61a6f348$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $9nZCP.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $cb6812e0fa529c57$export$910ae8079b2c2852(props) {
    return $cb6812e0fa529c57$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $cb6812e0fa529c57$export$e7b0ac011bb776c6(_props) {
    (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $cb6812e0fa529c57$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $6ab4d96c61a6f348$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$cb6812e0fa529c57$export$9c954a9d03d32f4a() && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $9nZCP.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $cb6812e0fa529c57$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $6ab4d96c61a6f348$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $9nZCP.useMemo(()=>{
        let trailingPathname = (0, $6ab4d96c61a6f348$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $9nZCP.createElement($cb6812e0fa529c57$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $9nZCP.createElement($cb6812e0fa529c57$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $cb6812e0fa529c57$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $cb6812e0fa529c57$export$5d3fca4a98652595($cb6812e0fa529c57$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $cb6812e0fa529c57$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $9nZCP.createElement($cb6812e0fa529c57$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $9nZCP.createElement($cb6812e0fa529c57$var$ResolveAwait, null, children));
}
var $cb6812e0fa529c57$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($cb6812e0fa529c57$var$AwaitRenderStatus || {});
const $cb6812e0fa529c57$var$neverSettledPromise = new Promise(()=>{});
class $cb6812e0fa529c57$var$AwaitErrorBoundary extends $9nZCP.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $cb6812e0fa529c57$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $cb6812e0fa529c57$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $cb6812e0fa529c57$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $cb6812e0fa529c57$var$AwaitRenderStatus.error : promise._data !== undefined ? $cb6812e0fa529c57$var$AwaitRenderStatus.success : $cb6812e0fa529c57$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $cb6812e0fa529c57$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $cb6812e0fa529c57$var$AwaitRenderStatus.error && promise._error instanceof (0, $6ab4d96c61a6f348$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $cb6812e0fa529c57$var$neverSettledPromise;
        if (status === $cb6812e0fa529c57$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $cb6812e0fa529c57$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $9nZCP.createElement($cb6812e0fa529c57$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $cb6812e0fa529c57$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $9nZCP.createElement($cb6812e0fa529c57$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $cb6812e0fa529c57$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $cb6812e0fa529c57$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $9nZCP.createElement($9nZCP.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $cb6812e0fa529c57$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $9nZCP.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $9nZCP.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $9nZCP.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $cb6812e0fa529c57$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $cb6812e0fa529c57$export$e7b0ac011bb776c6) && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $cb6812e0fa529c57$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $cb6812e0fa529c57$export$daf73786167a7f72(matches) {
    return $cb6812e0fa529c57$var$_renderMatches(matches);
}
function $cb6812e0fa529c57$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $9nZCP.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $9nZCP.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $9nZCP.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $cb6812e0fa529c57$export$f30f7e456d254e83(routes, opts) {
    return (0, $6ab4d96c61a6f348$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $cb6812e0fa529c57$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $6ab4d96c61a6f348$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $cb6812e0fa529c57$export$52b333d321859367
    }).initialize();
}



var $9nZCP = parcelRequire("9nZCP");
// eslint-disable-next-line @typescript-eslint/unbound-method
const $15f0bc38c7419bb4$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $15f0bc38c7419bb4$export$e6127cc7fe7395c3(wat) {
    switch($15f0bc38c7419bb4$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $15f0bc38c7419bb4$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $15f0bc38c7419bb4$var$isBuiltin(wat, className) {
    return $15f0bc38c7419bb4$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $15f0bc38c7419bb4$export$9f9636d330b71954(wat) {
    return $15f0bc38c7419bb4$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $15f0bc38c7419bb4$export$ef9e2056653f0c8e(wat) {
    return $15f0bc38c7419bb4$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $15f0bc38c7419bb4$export$12e869b2a583f783(wat) {
    return $15f0bc38c7419bb4$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $15f0bc38c7419bb4$export$844ec244b1367d54(wat) {
    return $15f0bc38c7419bb4$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $15f0bc38c7419bb4$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $15f0bc38c7419bb4$export$c3825b437cbdea5c(wat) {
    return wat === null || $15f0bc38c7419bb4$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $15f0bc38c7419bb4$export$53b83ca8eaab0383(wat) {
    return $15f0bc38c7419bb4$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $15f0bc38c7419bb4$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $15f0bc38c7419bb4$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $15f0bc38c7419bb4$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $15f0bc38c7419bb4$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $15f0bc38c7419bb4$export$49841c62b9eff15(wat) {
    return $15f0bc38c7419bb4$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $15f0bc38c7419bb4$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $15f0bc38c7419bb4$export$bc2894c7158efbac(wat) {
    return $15f0bc38c7419bb4$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $15f0bc38c7419bb4$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $15f0bc38c7419bb4$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $15f0bc38c7419bb4$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}


/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $81e469fe9ab1c810$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $81e469fe9ab1c810$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $81e469fe9ab1c810$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $81e469fe9ab1c810$var$isGlobalObj(window) || typeof self == "object" && $81e469fe9ab1c810$var$isGlobalObj(self) || typeof $parcel$global == "object" && $81e469fe9ab1c810$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $81e469fe9ab1c810$export$256479dc0cea61c4() {
    return $81e469fe9ab1c810$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $81e469fe9ab1c810$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $81e469fe9ab1c810$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}


// eslint-disable-next-line deprecation/deprecation
const $1406e1e4fc31c9ca$var$WINDOW = (0, $81e469fe9ab1c810$export$256479dc0cea61c4)();
const $1406e1e4fc31c9ca$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $1406e1e4fc31c9ca$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $1406e1e4fc31c9ca$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $1406e1e4fc31c9ca$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $1406e1e4fc31c9ca$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($1406e1e4fc31c9ca$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $15f0bc38c7419bb4$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $1406e1e4fc31c9ca$export$1cfafeee2987818b() {
    try {
        return $1406e1e4fc31c9ca$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1406e1e4fc31c9ca$export$c660c1f3ab49225c(selector) {
    if ($1406e1e4fc31c9ca$var$WINDOW.document && $1406e1e4fc31c9ca$var$WINDOW.document.querySelector) return $1406e1e4fc31c9ca$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $1406e1e4fc31c9ca$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$1406e1e4fc31c9ca$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $9a1e45eb0df10cda$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;





/** Prefix for logging strings */ const $00cc87bc34693c04$var$PREFIX = "Sentry Logger ";
const $00cc87bc34693c04$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $00cc87bc34693c04$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $00cc87bc34693c04$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($00cc87bc34693c04$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $00cc87bc34693c04$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $00cc87bc34693c04$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $9a1e45eb0df10cda$export$16a28057038b10ef) $00cc87bc34693c04$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $00cc87bc34693c04$export$cda52e2a8927a2ca(()=>{
                (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1).console[name](`${$00cc87bc34693c04$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $00cc87bc34693c04$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $00cc87bc34693c04$export$af88d00dbe7f521 = $00cc87bc34693c04$var$makeLogger();



/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $6ead621f18d70699$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $6ead621f18d70699$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6ead621f18d70699$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $15f0bc38c7419bb4$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $6ead621f18d70699$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $15f0bc38c7419bb4$export$844ec244b1367d54)(value)) return false;
    if ((0, $15f0bc38c7419bb4$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $15f0bc38c7419bb4$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $6ead621f18d70699$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$6ead621f18d70699$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $380d67425f19a6e7$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $380d67425f19a6e7$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $380d67425f19a6e7$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $9a1e45eb0df10cda$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $380d67425f19a6e7$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $380d67425f19a6e7$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $380d67425f19a6e7$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $380d67425f19a6e7$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $380d67425f19a6e7$export$62ff257738bf57f5(value) {
    if ((0, $15f0bc38c7419bb4$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$380d67425f19a6e7$var$getOwnProperties(value)
    };
    else if ((0, $15f0bc38c7419bb4$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $380d67425f19a6e7$var$serializeEventTarget(value.target),
            currentTarget: $380d67425f19a6e7$var$serializeEventTarget(value.currentTarget),
            ...$380d67425f19a6e7$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $15f0bc38c7419bb4$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $380d67425f19a6e7$var$serializeEventTarget(target) {
    try {
        return (0, $15f0bc38c7419bb4$export$45a5e7f76e0caa8d)(target) ? (0, $1406e1e4fc31c9ca$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $380d67425f19a6e7$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $380d67425f19a6e7$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($380d67425f19a6e7$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $6ead621f18d70699$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $6ead621f18d70699$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $380d67425f19a6e7$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $380d67425f19a6e7$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $380d67425f19a6e7$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($380d67425f19a6e7$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $380d67425f19a6e7$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($380d67425f19a6e7$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $380d67425f19a6e7$var$isPojo(input) {
    if (!(0, $15f0bc38c7419bb4$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $380d67425f19a6e7$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $15f0bc38c7419bb4$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $e23e8bb8c54ccb6f$export$19f53698e68b2496() {
    const gbl = (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $e23e8bb8c54ccb6f$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $e23e8bb8c54ccb6f$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $e23e8bb8c54ccb6f$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $e23e8bb8c54ccb6f$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $e23e8bb8c54ccb6f$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $e23e8bb8c54ccb6f$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $e23e8bb8c54ccb6f$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $e23e8bb8c54ccb6f$export$d364f2020ab30578(input) {
    const match = input.match($e23e8bb8c54ccb6f$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $e23e8bb8c54ccb6f$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $6ead621f18d70699$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $6ead621f18d70699$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $6ead621f18d70699$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $e23e8bb8c54ccb6f$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $380d67425f19a6e7$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $e23e8bb8c54ccb6f$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $34ae909229820d8f$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $432efb3c08046c53$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($432efb3c08046c53$var$States || ($432efb3c08046c53$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $432efb3c08046c53$export$1fda8aa4d135f8aa(value) {
    return new $432efb3c08046c53$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $432efb3c08046c53$export$78e43115b553f358(reason) {
    return new $432efb3c08046c53$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $432efb3c08046c53$export$6f292d4960313241 {
    constructor(executor){
        $432efb3c08046c53$export$6f292d4960313241.prototype.__init.call(this);
        $432efb3c08046c53$export$6f292d4960313241.prototype.__init2.call(this);
        $432efb3c08046c53$export$6f292d4960313241.prototype.__init3.call(this);
        $432efb3c08046c53$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $432efb3c08046c53$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $432efb3c08046c53$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $432efb3c08046c53$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($432efb3c08046c53$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($432efb3c08046c53$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $432efb3c08046c53$var$States.PENDING) return;
            if ((0, $15f0bc38c7419bb4$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $432efb3c08046c53$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $432efb3c08046c53$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $432efb3c08046c53$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $a5c82115844d4a21$export$3c4238858b85e8ac() {
    return (0, $81e469fe9ab1c810$export$7e223ec222791509)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $a5c82115844d4a21$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $a5c82115844d4a21$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $a5c82115844d4a21$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $432efb3c08046c53$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $34ae909229820d8f$export$16a28057038b10ef) && processor.id && result === null && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $15f0bc38c7419bb4$export$f5b060c2914b97c8)(result)) result.then((final)=>$a5c82115844d4a21$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $a5c82115844d4a21$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}



const $a4e39c7e45099c0d$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $a4e39c7e45099c0d$export$7740643b9eeaf0c4() {
    return Date.now() / $a4e39c7e45099c0d$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $a4e39c7e45099c0d$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $a4e39c7e45099c0d$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $a4e39c7e45099c0d$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $a4e39c7e45099c0d$export$ee52dced521e3e18 = $a4e39c7e45099c0d$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $a4e39c7e45099c0d$export$c5907b5a8838db13 = $a4e39c7e45099c0d$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $a4e39c7e45099c0d$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $a4e39c7e45099c0d$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $a4e39c7e45099c0d$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $a4e39c7e45099c0d$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $a4e39c7e45099c0d$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $a4e39c7e45099c0d$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();


const $8be83a4b5a336d5a$export$849dbeeeda01ae98 = "production";









/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $9ca2ec03d999f85f$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $a4e39c7e45099c0d$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$9ca2ec03d999f85f$var$sessionToJSON(session)
    };
    if (context) $9ca2ec03d999f85f$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $9ca2ec03d999f85f$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $a4e39c7e45099c0d$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $9ca2ec03d999f85f$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $9ca2ec03d999f85f$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $9ca2ec03d999f85f$var$sessionToJSON(session) {
    return (0, $380d67425f19a6e7$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}






/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $f49fa6c697b46265$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}





const $af09eea94c90b603$export$9ca9946bd449ac06 = "baggage";
const $af09eea94c90b603$export$6e69537d67fa20f = "sentry-";
const $af09eea94c90b603$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $af09eea94c90b603$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $af09eea94c90b603$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $15f0bc38c7419bb4$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $af09eea94c90b603$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $af09eea94c90b603$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($af09eea94c90b603$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($af09eea94c90b603$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $af09eea94c90b603$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$af09eea94c90b603$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $af09eea94c90b603$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $af09eea94c90b603$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $af09eea94c90b603$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $af09eea94c90b603$export$bdd844ddb2def819) {
            (0, $9a1e45eb0df10cda$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $ca032ccd622f944d$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $ca032ccd622f944d$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($ca032ccd622f944d$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 */ function $ca032ccd622f944d$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $ca032ccd622f944d$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $af09eea94c90b603$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    const propagationContext = {
        traceId: traceId || (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)(),
        spanId: (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled
    };
    if (parentSpanId) propagationContext.parentSpanId = parentSpanId;
    if (dynamicSamplingContext) propagationContext.dsc = dynamicSamplingContext;
    return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext,
        propagationContext: propagationContext
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $ca032ccd622f944d$export$f35d907436da45cf(traceId = (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)(), spanId = (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}


// These are aligned with OpenTelemetry trace flags
const $406b3ceb32322c72$export$208d5b368507fb8b = 0x0;
const $406b3ceb32322c72$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $406b3ceb32322c72$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $406b3ceb32322c72$export$92d8c23565496537(span);
    return (0, $380d67425f19a6e7$export$d25f2688db1bb433)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $406b3ceb32322c72$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $406b3ceb32322c72$export$5caecac1caaf3a71(span);
    return (0, $ca032ccd622f944d$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $406b3ceb32322c72$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $406b3ceb32322c72$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $406b3ceb32322c72$var$ensureTimestampInSeconds(input.getTime());
    return (0, $a4e39c7e45099c0d$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $406b3ceb32322c72$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $406b3ceb32322c72$export$92d8c23565496537(span) {
    if ($406b3ceb32322c72$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $406b3ceb32322c72$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $406b3ceb32322c72$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $406b3ceb32322c72$export$eb571cd9b5d98de8);
}


/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $0f19d7480cf01213$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $380d67425f19a6e7$export$d25f2688db1bb433)({
        environment: options.environment || (0, $8be83a4b5a336d5a$export$849dbeeeda01ae98),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $0f19d7480cf01213$export$a117f995597e25df(span) {
    const client = (0, $fead0e8ca16cc636$export$6bb76d6eba7e258c)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $0f19d7480cf01213$export$366bad00d6815eed((0, $406b3ceb32322c72$export$92d8c23565496537)(span).trace_id || "", client, (0, $fead0e8ca16cc636$export$c7be4b0125a10cba)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $f49fa6c697b46265$export$c4c6a79b1260ca1b)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $406b3ceb32322c72$export$92d8c23565496537)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $406b3ceb32322c72$export$5caecac1caaf3a71)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $1471a757bb211ef6$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata, propagationContext: propagationContext } = data;
    // Apply general data
    $1471a757bb211ef6$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $1471a757bb211ef6$var$applySpanToEvent(event, span);
    $1471a757bb211ef6$var$applyFingerprintToEvent(event, fingerprint);
    $1471a757bb211ef6$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $1471a757bb211ef6$var$applySdkMetadataToEvent(event, sdkProcessingMetadata, propagationContext);
}
/** Merge data of two scopes together. */ function $1471a757bb211ef6$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $1471a757bb211ef6$export$b1a120a2871faa46(data, "extra", extra);
    $1471a757bb211ef6$export$b1a120a2871faa46(data, "tags", tags);
    $1471a757bb211ef6$export$b1a120a2871faa46(data, "user", user);
    $1471a757bb211ef6$export$b1a120a2871faa46(data, "contexts", contexts);
    $1471a757bb211ef6$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $1471a757bb211ef6$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $1471a757bb211ef6$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $380d67425f19a6e7$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $380d67425f19a6e7$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $380d67425f19a6e7$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $380d67425f19a6e7$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $1471a757bb211ef6$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $1471a757bb211ef6$var$applySdkMetadataToEvent(event, sdkProcessingMetadata, propagationContext) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata,
        propagationContext: propagationContext
    };
}
function $1471a757bb211ef6$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $406b3ceb32322c72$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    const rootSpan = (0, $f49fa6c697b46265$export$c4c6a79b1260ca1b)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $0f19d7480cf01213$export$a117f995597e25df)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $406b3ceb32322c72$export$92d8c23565496537)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $1471a757bb211ef6$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $e23e8bb8c54ccb6f$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $ebfd05af35fcc0a2$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $ebfd05af35fcc0a2$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $ebfd05af35fcc0a2$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $ebfd05af35fcc0a2$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $ebfd05af35fcc0a2$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $ebfd05af35fcc0a2$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $9ca2ec03d999f85f$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   * @deprecated Use extra or tags instead.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === "function") {
            const updatedScope = captureContext(this);
            return updatedScope instanceof $ebfd05af35fcc0a2$export$775b6bb06e53a214 ? updatedScope : this;
        }
        if (captureContext instanceof $ebfd05af35fcc0a2$export$775b6bb06e53a214) {
            this._tags = {
                ...this._tags,
                ...captureContext._tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext._extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext._contexts
            };
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
            if (captureContext._propagationContext) this._propagationContext = captureContext._propagationContext;
        } else if ((0, $15f0bc38c7419bb4$export$53b83ca8eaab0383)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = {
                ...this._tags,
                ...captureContext.tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext.contexts
            };
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
            if (captureContext.propagationContext) this._propagationContext = captureContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $ebfd05af35fcc0a2$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $ebfd05af35fcc0a2$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $a4e39c7e45099c0d$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $1471a757bb211ef6$export$43988bc651a80216)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $a5c82115844d4a21$export$3c4238858b85e8ac)(),
            ...this._eventProcessors
        ];
        return (0, $a5c82115844d4a21$export$bf2a096c3e883e79)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $ebfd05af35fcc0a2$export$aa55d5ab8e05984f() {
    if (!$ebfd05af35fcc0a2$var$globalScope) $ebfd05af35fcc0a2$var$globalScope = new $ebfd05af35fcc0a2$export$775b6bb06e53a214();
    return $ebfd05af35fcc0a2$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $ebfd05af35fcc0a2$export$c83048efd17527d6(scope) {
    $ebfd05af35fcc0a2$var$globalScope = scope;
}
function $ebfd05af35fcc0a2$var$generatePropagationContext() {
    return {
        traceId: (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)(),
        spanId: (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)().substring(16)
    };
}



const $cab9a602399ef8c5$export$31499a9cd224b78c = "7.94.1";


/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $9f8f0bc84d498322$export$24a86ef7798177e4 = parseFloat((0, $cab9a602399ef8c5$export$31499a9cd224b78c));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $9f8f0bc84d498322$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ class $9f8f0bc84d498322$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */ constructor(client, scope, isolationScope, _version = $9f8f0bc84d498322$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $ebfd05af35fcc0a2$export$775b6bb06e53a214)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $ebfd05af35fcc0a2$export$775b6bb06e53a214)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $15f0bc38c7419bb4$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $9f8f0bc84d498322$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $a4e39c7e45099c0d$export$7740643b9eeaf0c4)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $00cc87bc34693c04$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $9f8f0bc84d498322$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $9f8f0bc84d498322$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $34ae909229820d8f$export$16a28057038b10ef) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $9ca2ec03d999f85f$export$56521d9ba90f62ee)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $8be83a4b5a336d5a$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1).navigator || {};
        const session = (0, $9ca2ec03d999f85f$export$14a186326edbb264)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $9ca2ec03d999f85f$export$531818e825e774db)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $9f8f0bc84d498322$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $9f8f0bc84d498322$export$19eade501500c6c1() {
    (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1).__SENTRY__ = (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ function $9f8f0bc84d498322$export$4188a14ad302d1bc(hub) {
    const registry = $9f8f0bc84d498322$export$19eade501500c6c1();
    const oldHub = $9f8f0bc84d498322$export$bfa8a924a84a76b7(registry);
    $9f8f0bc84d498322$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ function $9f8f0bc84d498322$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $9f8f0bc84d498322$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $9f8f0bc84d498322$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $9f8f0bc84d498322$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $9f8f0bc84d498322$export$a07cdf6544bbd7c().getIsolationScope();
}
function $9f8f0bc84d498322$var$getGlobalHub(registry = $9f8f0bc84d498322$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$9f8f0bc84d498322$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $9f8f0bc84d498322$export$bfa8a924a84a76b7(registry).isOlderThan($9f8f0bc84d498322$export$24a86ef7798177e4)) $9f8f0bc84d498322$export$849f05434e95d2f2(registry, new $9f8f0bc84d498322$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $9f8f0bc84d498322$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ function $9f8f0bc84d498322$export$236689a79f5aa020(carrier, parent = $9f8f0bc84d498322$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$9f8f0bc84d498322$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $9f8f0bc84d498322$export$bfa8a924a84a76b7(carrier).isOlderThan($9f8f0bc84d498322$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        $9f8f0bc84d498322$export$849f05434e95d2f2(carrier, new $9f8f0bc84d498322$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $9f8f0bc84d498322$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $9f8f0bc84d498322$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $9f8f0bc84d498322$export$70d775fb1f267027(callback, options = {}) {
    const registry = $9f8f0bc84d498322$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $9f8f0bc84d498322$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ function $9f8f0bc84d498322$export$bfa8a924a84a76b7(carrier) {
    return (0, $81e469fe9ab1c810$export$7e223ec222791509)("hub", ()=>new $9f8f0bc84d498322$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ function $9f8f0bc84d498322$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}




/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $fc4c618887ca5bb5$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Does this filename look like it's part of the app code?
 */ function $7a50e6582b72b20b$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $7a50e6582b72b20b$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $7a50e6582b72b20b$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}


const $65291a370105e130$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $65291a370105e130$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $65291a370105e130$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $65291a370105e130$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $65291a370105e130$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($65291a370105e130$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $65291a370105e130$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $65291a370105e130$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $65291a370105e130$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $65291a370105e130$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $65291a370105e130$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($65291a370105e130$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($65291a370105e130$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $65291a370105e130$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $65291a370105e130$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $65291a370105e130$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $65291a370105e130$var$defaultFunctionName;
        return fn.name || $65291a370105e130$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $65291a370105e130$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $65291a370105e130$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $7a50e6582b72b20b$export$35059013cd4a06db)(getModule)
    ];
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $091fe0c9bd9da15b$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $091fe0c9bd9da15b$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $091fe0c9bd9da15b$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $091fe0c9bd9da15b$export$a3295358bff77e(object, depth);
    if ($091fe0c9bd9da15b$var$jsonSize(normalized) > maxSize) return $091fe0c9bd9da15b$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $091fe0c9bd9da15b$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $fc4c618887ca5bb5$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $15f0bc38c7419bb4$export$c9f5652083b8129d)(value)) return value;
    const stringified = $091fe0c9bd9da15b$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $091fe0c9bd9da15b$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $380d67425f19a6e7$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $091fe0c9bd9da15b$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $091fe0c9bd9da15b$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $15f0bc38c7419bb4$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $15f0bc38c7419bb4$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $65291a370105e130$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $091fe0c9bd9da15b$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $091fe0c9bd9da15b$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $091fe0c9bd9da15b$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $091fe0c9bd9da15b$var$jsonSize(value) {
    return $091fe0c9bd9da15b$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $091fe0c9bd9da15b$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}







/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $93dcc91b82d1c710$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $a4e39c7e45099c0d$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $93dcc91b82d1c710$var$applyClientOptions(prepared, options);
    $93dcc91b82d1c710$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $93dcc91b82d1c710$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $93dcc91b82d1c710$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $e23e8bb8c54ccb6f$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $ebfd05af35fcc0a2$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $1471a757bb211ef6$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $1471a757bb211ef6$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $1471a757bb211ef6$export$43988bc651a80216)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $a5c82115844d4a21$export$3c4238858b85e8ac)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $a5c82115844d4a21$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $93dcc91b82d1c710$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $93dcc91b82d1c710$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $93dcc91b82d1c710$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $8be83a4b5a336d5a$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $6ead621f18d70699$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $6ead621f18d70699$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $6ead621f18d70699$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $93dcc91b82d1c710$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $93dcc91b82d1c710$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $93dcc91b82d1c710$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $93dcc91b82d1c710$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $93dcc91b82d1c710$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $93dcc91b82d1c710$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $93dcc91b82d1c710$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $091fe0c9bd9da15b$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $091fe0c9bd9da15b$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $091fe0c9bd9da15b$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $091fe0c9bd9da15b$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $091fe0c9bd9da15b$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $406b3ceb32322c72$export$92d8c23565496537)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $091fe0c9bd9da15b$export$a3295358bff77e)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $93dcc91b82d1c710$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $ebfd05af35fcc0a2$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $93dcc91b82d1c710$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($93dcc91b82d1c710$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($93dcc91b82d1c710$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $93dcc91b82d1c710$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $ebfd05af35fcc0a2$export$775b6bb06e53a214) || typeof hint === "function";
}
const $93dcc91b82d1c710$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $93dcc91b82d1c710$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$93dcc91b82d1c710$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $fead0e8ca16cc636$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)().captureException(exception, (0, $93dcc91b82d1c710$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $fead0e8ca16cc636$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $fead0e8ca16cc636$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ function $fead0e8ca16cc636$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ function $fead0e8ca16cc636$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $fead0e8ca16cc636$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $fead0e8ca16cc636$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $fead0e8ca16cc636$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $fead0e8ca16cc636$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $fead0e8ca16cc636$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $fead0e8ca16cc636$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $fead0e8ca16cc636$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $fead0e8ca16cc636$export$9a4fed82c350c2bd(callback) {
    return (0, $9f8f0bc84d498322$export$70d775fb1f267027)(()=>{
        return callback((0, $9f8f0bc84d498322$export$68f3af03034c9e90)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $fead0e8ca16cc636$export$e57ac09b143d92a2(span, callback) {
    return $fead0e8ca16cc636$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $fead0e8ca16cc636$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $fead0e8ca16cc636$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $fead0e8ca16cc636$export$c7be4b0125a10cba();
    const client = $fead0e8ca16cc636$export$6bb76d6eba7e258c();
    if (!client) (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $fead0e8ca16cc636$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $fead0e8ca16cc636$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $a4e39c7e45099c0d$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $fead0e8ca16cc636$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $a4e39c7e45099c0d$export$ee52dced521e3e18)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $15f0bc38c7419bb4$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $fead0e8ca16cc636$export$4909b86c8034bf73(timeout) {
    const client = $fead0e8ca16cc636$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $fead0e8ca16cc636$export$8360e631d277ea4d(timeout) {
    const client = $fead0e8ca16cc636$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 * @deprecated This function will be removed in the next major version of the Sentry SDK.
 */ function $fead0e8ca16cc636$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $fead0e8ca16cc636$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)().getClient();
}
/**
 * Get the currently active scope.
 */ function $fead0e8ca16cc636$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $fead0e8ca16cc636$export$c0d84948cecf78d8(context) {
    const client = $fead0e8ca16cc636$export$6bb76d6eba7e258c();
    const isolationScope = (0, $9f8f0bc84d498322$export$68f3af03034c9e90)();
    const currentScope = $fead0e8ca16cc636$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $8be83a4b5a336d5a$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $9ca2ec03d999f85f$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $9ca2ec03d999f85f$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $fead0e8ca16cc636$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $fead0e8ca16cc636$export$17a5be43989a0bc1() {
    const isolationScope = (0, $9f8f0bc84d498322$export$68f3af03034c9e90)();
    const currentScope = $fead0e8ca16cc636$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $9ca2ec03d999f85f$export$56521d9ba90f62ee)(session);
    $fead0e8ca16cc636$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $fead0e8ca16cc636$var$_sendSessionUpdate() {
    const isolationScope = (0, $9f8f0bc84d498322$export$68f3af03034c9e90)();
    const currentScope = $fead0e8ca16cc636$export$c7be4b0125a10cba();
    const client = $fead0e8ca16cc636$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $fead0e8ca16cc636$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $fead0e8ca16cc636$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $fead0e8ca16cc636$var$_sendSessionUpdate();
}



const $382eff120bb43d6f$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $382eff120bb43d6f$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $382eff120bb43d6f$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $e23e8bb8c54ccb6f$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $382eff120bb43d6f$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $382eff120bb43d6f$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $382eff120bb43d6f$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $382eff120bb43d6f$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/** Setup a single integration.  */ function $382eff120bb43d6f$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($382eff120bb43d6f$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $a5c82115844d4a21$export$8e4e25f54d456511), (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c));
        $382eff120bb43d6f$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $382eff120bb43d6f$export$2d8f5188773bcddd(integration) {
    const client = (0, $fead0e8ca16cc636$export$6bb76d6eba7e258c)();
    if (!client || !client.addIntegration) {
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $382eff120bb43d6f$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $382eff120bb43d6f$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $382eff120bb43d6f$export$2323046b9414659f(fn) {
    return fn;
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $ade9b105e5b71e91$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;







const $e96e526caeb721c7$export$56d8a8a25bd48b81 = (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1);
let $e96e526caeb721c7$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $e96e526caeb721c7$export$b79738ab10c590b2() {
    return $e96e526caeb721c7$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $e96e526caeb721c7$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $e96e526caeb721c7$var$ignoreOnError++;
    setTimeout(()=>{
        $e96e526caeb721c7$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $e96e526caeb721c7$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $380d67425f19a6e7$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$e96e526caeb721c7$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $e96e526caeb721c7$export$1265a142ff5ba165();
            (0, $fead0e8ca16cc636$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $e23e8bb8c54ccb6f$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $e23e8bb8c54ccb6f$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $fead0e8ca16cc636$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $380d67425f19a6e7$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $380d67425f19a6e7$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}





/** Regular expression used to parse a Dsn. */ const $f33780998a3a623d$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $f33780998a3a623d$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $f33780998a3a623d$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $f33780998a3a623d$export$b892860177f70a30(str) {
    const match = $f33780998a3a623d$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $00cc87bc34693c04$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $f33780998a3a623d$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $f33780998a3a623d$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $f33780998a3a623d$var$validateDsn(dsn) {
    if (!(0, $9a1e45eb0df10cda$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $00cc87bc34693c04$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $00cc87bc34693c04$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$f33780998a3a623d$var$isValidProtocol(protocol)) {
        (0, $00cc87bc34693c04$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $00cc87bc34693c04$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $f33780998a3a623d$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $f33780998a3a623d$export$b892860177f70a30(from) : $f33780998a3a623d$var$dsnFromComponents(from);
    if (!components || !$f33780998a3a623d$var$validateDsn(components)) return undefined;
    return components;
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $be27cfb68e15613c$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $be27cfb68e15613c$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $be27cfb68e15613c$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $be27cfb68e15613c$export$604a45d95a155e2b(envelope, types) {
    return $be27cfb68e15613c$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $be27cfb68e15613c$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $be27cfb68e15613c$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $be27cfb68e15613c$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $be27cfb68e15613c$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $091fe0c9bd9da15b$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $be27cfb68e15613c$var$concatBuffers(parts);
}
function $be27cfb68e15613c$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $be27cfb68e15613c$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $be27cfb68e15613c$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $be27cfb68e15613c$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $380d67425f19a6e7$export$d25f2688db1bb433)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $be27cfb68e15613c$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    // TODO: This is a temporary workaround until we have a proper data category for metrics
    statsd: "unknown"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $be27cfb68e15613c$export$b11169581eeaf237(type) {
    return $be27cfb68e15613c$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from from the metadata or an events */ function $be27cfb68e15613c$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $be27cfb68e15613c$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $f33780998a3a623d$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $380d67425f19a6e7$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}




/* eslint-disable max-lines */ const $d82d58dda182313b$var$MS_TO_NS = 1e6;
// Use 0 as main thread id which is identical to threadId in node:worker_threads
// where main logs 0 and workers seem to log in increments of 1
const $d82d58dda182313b$var$THREAD_ID_STRING = String(0);
const $d82d58dda182313b$var$THREAD_NAME = "main";
// Machine properties (eval only once)
let $d82d58dda182313b$var$OS_PLATFORM = "";
let $d82d58dda182313b$var$OS_PLATFORM_VERSION = "";
let $d82d58dda182313b$var$OS_ARCH = "";
let $d82d58dda182313b$var$OS_BROWSER = (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).navigator && (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).navigator.userAgent || "";
let $d82d58dda182313b$var$OS_MODEL = "";
const $d82d58dda182313b$var$OS_LOCALE = (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).navigator && (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).navigator.language || (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).navigator && (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).navigator.languages && (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).navigator.languages[0] || "";
function $d82d58dda182313b$var$isUserAgentData(data) {
    return typeof data === "object" && data !== null && "getHighEntropyValues" in data;
}
// @ts-expect-error userAgentData is not part of the navigator interface yet
const $d82d58dda182313b$var$userAgentData = (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).navigator && (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).navigator.userAgentData;
if ($d82d58dda182313b$var$isUserAgentData($d82d58dda182313b$var$userAgentData)) $d82d58dda182313b$var$userAgentData.getHighEntropyValues([
    "architecture",
    "model",
    "platform",
    "platformVersion",
    "fullVersionList"
]).then((ua)=>{
    $d82d58dda182313b$var$OS_PLATFORM = ua.platform || "";
    $d82d58dda182313b$var$OS_ARCH = ua.architecture || "";
    $d82d58dda182313b$var$OS_MODEL = ua.model || "";
    $d82d58dda182313b$var$OS_PLATFORM_VERSION = ua.platformVersion || "";
    if (ua.fullVersionList && ua.fullVersionList.length > 0) {
        const firstUa = ua.fullVersionList[ua.fullVersionList.length - 1];
        $d82d58dda182313b$var$OS_BROWSER = `${firstUa.brand} ${firstUa.version}`;
    }
}).catch((e)=>void 0);
function $d82d58dda182313b$var$isProcessedJSSelfProfile(profile) {
    return !("thread_metadata" in profile);
}
// Enriches the profile with threadId of the current thread.
// This is done in node as we seem to not be able to get the info from C native code.
/**
 *
 */ function $d82d58dda182313b$export$7cbe6c4f12ea8325(profile) {
    if (!$d82d58dda182313b$var$isProcessedJSSelfProfile(profile)) return profile;
    return $d82d58dda182313b$export$f4122c775dfac1c2(profile);
}
// Profile is marked as optional because it is deleted from the metadata
// by the integration before the event is processed by other integrations.
function $d82d58dda182313b$var$getTraceId(event) {
    const traceId = event && event.contexts && event.contexts["trace"] && event.contexts["trace"]["trace_id"];
    // Log a warning if the profile has an invalid traceId (should be uuidv4).
    // All profiles and transactions are rejected if this is the case and we want to
    // warn users that this is happening if they enable debug flag
    if (typeof traceId === "string" && traceId.length !== 32) {
        if (0, $ade9b105e5b71e91$export$16a28057038b10ef) (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`[Profiling] Invalid traceId: ${traceId} on profiled event`);
    }
    if (typeof traceId !== "string") return "";
    return traceId;
}
/**
 * Creates a profiling event envelope from a Sentry event. If profile does not pass
 * validation, returns null.
 * @param event
 * @param dsn
 * @param metadata
 * @param tunnel
 * @returns {EventEnvelope | null}
 */ /**
 * Creates a profiling event envelope from a Sentry event.
 */ function $d82d58dda182313b$export$5c9f6e262288b7db(profile_id, start_timestamp, processed_profile, event) {
    if (event.type !== "transaction") // createProfilingEventEnvelope should only be called for transactions,
    // we type guard this behavior with isProfiledTransactionEvent.
    throw new TypeError("Profiling events may only be attached to transactions, this should never occur.");
    if (processed_profile === undefined || processed_profile === null) throw new TypeError(`Cannot construct profiling event envelope without a valid profile. Got ${processed_profile} instead.`);
    const traceId = $d82d58dda182313b$var$getTraceId(event);
    const enrichedThreadProfile = $d82d58dda182313b$export$7cbe6c4f12ea8325(processed_profile);
    const transactionStartMs = start_timestamp ? start_timestamp : typeof event.start_timestamp === "number" ? event.start_timestamp * 1000 : Date.now();
    const transactionEndMs = typeof event.timestamp === "number" ? event.timestamp * 1000 : Date.now();
    const profile = {
        event_id: profile_id,
        timestamp: new Date(transactionStartMs).toISOString(),
        platform: "javascript",
        version: "1",
        release: event.release || "",
        environment: event.environment || (0, $8be83a4b5a336d5a$export$849dbeeeda01ae98),
        runtime: {
            name: "javascript",
            version: (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).navigator.userAgent
        },
        os: {
            name: $d82d58dda182313b$var$OS_PLATFORM,
            version: $d82d58dda182313b$var$OS_PLATFORM_VERSION,
            build_number: $d82d58dda182313b$var$OS_BROWSER
        },
        device: {
            locale: $d82d58dda182313b$var$OS_LOCALE,
            model: $d82d58dda182313b$var$OS_MODEL,
            manufacturer: $d82d58dda182313b$var$OS_BROWSER,
            architecture: $d82d58dda182313b$var$OS_ARCH,
            is_emulator: false
        },
        debug_meta: {
            images: $d82d58dda182313b$export$4c0b0d8ee0d018b5(processed_profile.resources)
        },
        profile: enrichedThreadProfile,
        transactions: [
            {
                name: event.transaction || "",
                id: event.event_id || (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)(),
                trace_id: traceId,
                active_thread_id: $d82d58dda182313b$var$THREAD_ID_STRING,
                relative_start_ns: "0",
                relative_end_ns: ((transactionEndMs - transactionStartMs) * 1e6).toFixed(0)
            }
        ]
    };
    return profile;
}
/*
  See packages/tracing-internal/src/browser/router.ts
*/ /**
 *
 */ function $d82d58dda182313b$export$7c501dd6adb8177c(transaction) {
    return transaction.op === "pageload";
}
/**
 * Converts a JSSelfProfile to a our sampled format.
 * Does not currently perform stack indexing.
 */ function $d82d58dda182313b$export$f4122c775dfac1c2(input) {
    let EMPTY_STACK_ID = undefined;
    let STACK_ID = 0;
    // Initialize the profile that we will fill with data
    const profile = {
        samples: [],
        stacks: [],
        frames: [],
        thread_metadata: {
            [$d82d58dda182313b$var$THREAD_ID_STRING]: {
                name: $d82d58dda182313b$var$THREAD_NAME
            }
        }
    };
    if (!input.samples.length) return profile;
    // We assert samples.length > 0 above and timestamp should always be present
    const start = input.samples[0].timestamp;
    // The JS SDK might change it's time origin based on some heuristic (see See packages/utils/src/time.ts)
    // when that happens, we need to ensure we are correcting the profile timings so the two timelines stay in sync.
    // Since JS self profiling time origin is always initialized to performance.timeOrigin, we need to adjust for
    // the drift between the SDK selected value and our profile time origin.
    const origin = typeof performance.timeOrigin === "number" ? performance.timeOrigin : (0, $a4e39c7e45099c0d$export$baf075a948ffc0bf) || 0;
    const adjustForOriginChange = origin - ((0, $a4e39c7e45099c0d$export$baf075a948ffc0bf) || origin);
    for(let i = 0; i < input.samples.length; i++){
        const jsSample = input.samples[i];
        // If sample has no stack, add an empty sample
        if (jsSample.stackId === undefined) {
            if (EMPTY_STACK_ID === undefined) {
                EMPTY_STACK_ID = STACK_ID;
                profile.stacks[EMPTY_STACK_ID] = [];
                STACK_ID++;
            }
            profile["samples"][i] = {
                // convert ms timestamp to ns
                elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * $d82d58dda182313b$var$MS_TO_NS).toFixed(0),
                stack_id: EMPTY_STACK_ID,
                thread_id: $d82d58dda182313b$var$THREAD_ID_STRING
            };
            continue;
        }
        let stackTop = input.stacks[jsSample.stackId];
        // Functions in top->down order (root is last)
        // We follow the stackTop.parentId trail and collect each visited frameId
        const stack = [];
        while(stackTop){
            stack.push(stackTop.frameId);
            const frame = input.frames[stackTop.frameId];
            // If our frame has not been indexed yet, index it
            if (profile.frames[stackTop.frameId] === undefined) profile.frames[stackTop.frameId] = {
                function: frame.name,
                abs_path: typeof frame.resourceId === "number" ? input.resources[frame.resourceId] : undefined,
                lineno: frame.line,
                colno: frame.column
            };
            stackTop = stackTop.parentId === undefined ? undefined : input.stacks[stackTop.parentId];
        }
        const sample = {
            // convert ms timestamp to ns
            elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * $d82d58dda182313b$var$MS_TO_NS).toFixed(0),
            stack_id: STACK_ID,
            thread_id: $d82d58dda182313b$var$THREAD_ID_STRING
        };
        profile["stacks"][STACK_ID] = stack;
        profile["samples"][i] = sample;
        STACK_ID++;
    }
    return profile;
}
/**
 * Adds items to envelope if they are not already present - mutates the envelope.
 * @param envelope
 */ function $d82d58dda182313b$export$4df36760a75f76bc(envelope, profiles) {
    if (!profiles.length) return envelope;
    for (const profile of profiles)envelope[1].push([
        {
            type: "profile"
        },
        profile
    ]);
    return envelope;
}
/**
 * Finds transactions with profile_id context in the envelope
 * @param envelope
 * @returns
 */ function $d82d58dda182313b$export$df9bb0fc214ff8cd(envelope) {
    const events = [];
    (0, $be27cfb68e15613c$export$c56c55acf0136fd3)(envelope, (item, type)=>{
        if (type !== "transaction") return;
        for(let j = 1; j < item.length; j++){
            const event = item[j];
            if (event && event.contexts && event.contexts["profile"] && event.contexts["profile"]["profile_id"]) events.push(item[j]);
        }
    });
    return events;
}
const $d82d58dda182313b$var$debugIdStackParserCache = new WeakMap();
/**
 * Applies debug meta data to an event from a list of paths to resources (sourcemaps)
 */ function $d82d58dda182313b$export$4c0b0d8ee0d018b5(resource_paths) {
    const debugIdMap = (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return [];
    const client = (0, $fead0e8ca16cc636$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions();
    const stackParser = options && options.stackParser;
    if (!stackParser) return [];
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $d82d58dda182313b$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $d82d58dda182313b$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            const file = stackFrame && stackFrame.filename;
            if (stackFrame && file) {
                acc[file] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: "sourcemap",
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $d82d58dda182313b$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    if (typeof rate !== "number" && typeof rate !== "boolean" || typeof rate === "number" && isNaN(rate)) {
        (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`[Profiling] Invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // Boolean sample rates are always valid
    if (rate === true || rate === false) return true;
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`[Profiling] Invalid sample rate. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
function $d82d58dda182313b$var$isValidProfile(profile) {
    if (profile.samples.length < 2) {
        if (0, $ade9b105e5b71e91$export$16a28057038b10ef) // Log a warning if the profile has less than 2 samples so users can know why
        // they are not seeing any profiling data and we cant avoid the back and forth
        // of asking them to provide us with a dump of the profile data.
        (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Profiling] Discarding profile because it contains less than 2 samples");
        return false;
    }
    if (!profile.frames.length) {
        if (0, $ade9b105e5b71e91$export$16a28057038b10ef) (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Profiling] Discarding profile because it contains no frames");
        return false;
    }
    return true;
}
// Keep a flag value to avoid re-initializing the profiler constructor. If it fails
// once, it will always fail and this allows us to early return.
let $d82d58dda182313b$var$PROFILING_CONSTRUCTOR_FAILED = false;
const $d82d58dda182313b$export$8640c0b5c7d98a81 = 30000;
/**
 * Check if profiler constructor is available.
 * @param maybeProfiler
 */ function $d82d58dda182313b$var$isJSProfilerSupported(maybeProfiler) {
    return typeof maybeProfiler === "function";
}
/**
 * Starts the profiler and returns the profiler instance.
 */ function $d82d58dda182313b$export$9f4f648547a4284f() {
    // Feature support check first
    const JSProfilerConstructor = (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).Profiler;
    if (!$d82d58dda182313b$var$isJSProfilerSupported(JSProfilerConstructor)) {
        if (0, $ade9b105e5b71e91$export$16a28057038b10ef) (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Profiling] Profiling is not supported by this browser, Profiler interface missing on window object.");
        return;
    }
    // From initial testing, it seems that the minimum value for sampleInterval is 10ms.
    const samplingIntervalMS = 10;
    // Start the profiler
    const maxSamples = Math.floor($d82d58dda182313b$export$8640c0b5c7d98a81 / samplingIntervalMS);
    // Attempt to initialize the profiler constructor, if it fails, we disable profiling for the current user session.
    // This is likely due to a missing 'Document-Policy': 'js-profiling' header. We do not want to throw an error if this happens
    // as we risk breaking the user's application, so just disable profiling and log an error.
    try {
        return new JSProfilerConstructor({
            sampleInterval: samplingIntervalMS,
            maxBufferSize: maxSamples
        });
    } catch (e) {
        if (0, $ade9b105e5b71e91$export$16a28057038b10ef) {
            (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Profiling] Failed to initialize the Profiling constructor, this is likely due to a missing 'Document-Policy': 'js-profiling' header.");
            (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Profiling] Disabling profiling for current user session.");
        }
        $d82d58dda182313b$var$PROFILING_CONSTRUCTOR_FAILED = true;
    }
    return;
}
/**
 * Determine if a profile should be profiled.
 */ function $d82d58dda182313b$export$ea6683c0c72c1201(transaction) {
    // If constructor failed once, it will always fail, so we can early return.
    if ($d82d58dda182313b$var$PROFILING_CONSTRUCTOR_FAILED) {
        if (0, $ade9b105e5b71e91$export$16a28057038b10ef) (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Profiling] Profiling has been disabled for the duration of the current user session.");
        return false;
    }
    if (!transaction.isRecording()) {
        if (0, $ade9b105e5b71e91$export$16a28057038b10ef) (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Profiling] Discarding profile because transaction was not sampled.");
        return false;
    }
    const client = (0, $fead0e8ca16cc636$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions();
    if (!options) {
        (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Profiling] Profiling disabled, no options found.");
        return false;
    }
    // @ts-expect-error profilesSampleRate is not part of the browser options yet
    const profilesSampleRate = options.profilesSampleRate;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$d82d58dda182313b$export$2603c8d332a51c42(profilesSampleRate)) {
        (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("[Profiling] Discarding profile because of invalid sample rate.");
        return false;
    }
    // if the function returned 0 (or false), or if `profileSampleRate` is 0, it's a sign the profile should be dropped
    if (!profilesSampleRate) {
        (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Profiling] Discarding profile because a negative sampling decision was inherited or profileSampleRate is set to 0");
        return false;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    const sampled = profilesSampleRate === true ? true : Math.random() < profilesSampleRate;
    // Check if we should sample this profile
    if (!sampled) {
        (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`[Profiling] Discarding profile because it's not included in the random sample (sampling rate = ${Number(profilesSampleRate)})`);
        return false;
    }
    return true;
}
/**
 * Creates a profiling envelope item, if the profile does not pass validation, returns null.
 * @param event
 * @returns {Profile | null}
 */ function $d82d58dda182313b$export$5c2c5e805edd874f(profile_id, start_timestamp, profile, event) {
    if (!$d82d58dda182313b$var$isValidProfile(profile)) return null;
    return $d82d58dda182313b$export$5c9f6e262288b7db(profile_id, start_timestamp, profile, event);
}
const $d82d58dda182313b$var$PROFILE_MAP = new Map();
/**
 *
 */ function $d82d58dda182313b$export$9d723f414195854a() {
    return $d82d58dda182313b$var$PROFILE_MAP.size;
}
/**
 * Retrieves profile from global cache and removes it.
 */ function $d82d58dda182313b$export$6285310796363de1(profile_id) {
    const profile = $d82d58dda182313b$var$PROFILE_MAP.get(profile_id);
    if (profile) $d82d58dda182313b$var$PROFILE_MAP.delete(profile_id);
    return profile;
}
/**
 * Adds profile to global cache and evicts the oldest profile if the cache is full.
 */ function $d82d58dda182313b$export$7ddae68097f7e530(profile_id, profile) {
    $d82d58dda182313b$var$PROFILE_MAP.set(profile_id, profile);
    if ($d82d58dda182313b$var$PROFILE_MAP.size > 30) {
        const last = $d82d58dda182313b$var$PROFILE_MAP.keys().next().value;
        $d82d58dda182313b$var$PROFILE_MAP.delete(last);
    }
}


/* eslint-disable complexity */ /**
 * Safety wrapper for startTransaction for the unlikely case that transaction starts before tracing is imported -
 * if that happens we want to avoid throwing an error from profiling code.
 * see https://github.com/getsentry/sentry-javascript/issues/4731.
 *
 * @experimental
 */ function $95ff814a6b703707$export$410ca53b300571c6(transaction) {
    if (!transaction) {
        if (0, $ade9b105e5b71e91$export$16a28057038b10ef) (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Profiling] Transaction is undefined, skipping profiling");
        return transaction;
    }
    if ((0, $d82d58dda182313b$export$ea6683c0c72c1201)(transaction)) return $95ff814a6b703707$export$a5c90b2530e76e64(transaction);
    return transaction;
}
/**
 * Wraps startTransaction and stopTransaction with profiling related logic.
 * startProfileForTransaction is called after the call to startTransaction in order to avoid our own code from
 * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
 */ function $95ff814a6b703707$export$a5c90b2530e76e64(transaction) {
    // Start the profiler and get the profiler instance.
    let startTimestamp;
    if ((0, $d82d58dda182313b$export$7c501dd6adb8177c)(transaction)) startTimestamp = (0, $a4e39c7e45099c0d$export$ee52dced521e3e18)() * 1000;
    const profiler = (0, $d82d58dda182313b$export$9f4f648547a4284f)();
    // We failed to construct the profiler, fallback to original transaction.
    // No need to log anything as this has already been logged in startProfile.
    if (!profiler) return transaction;
    if (0, $ade9b105e5b71e91$export$16a28057038b10ef) (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`[Profiling] started profiling transaction: ${(0, $406b3ceb32322c72$export$92d8c23565496537)(transaction).description}`);
    // We create "unique" transaction names to avoid concurrent transactions with same names
    // from being ignored by the profiler. From here on, only this transaction name should be used when
    // calling the profiler methods. Note: we log the original name to the user to avoid confusion.
    const profileId = (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)();
    /**
   * Idempotent handler for profile stop
   */ async function onProfileHandler() {
        // Check if the profile exists and return it the behavior has to be idempotent as users may call transaction.finish multiple times.
        if (!transaction) return null;
        // Satisfy the type checker, but profiler will always be defined here.
        if (!profiler) return null;
        return profiler.stop().then((profile)=>{
            if (maxDurationTimeoutID) {
                (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).clearTimeout(maxDurationTimeoutID);
                maxDurationTimeoutID = undefined;
            }
            if (0, $ade9b105e5b71e91$export$16a28057038b10ef) (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`[Profiling] stopped profiling of transaction: ${(0, $406b3ceb32322c72$export$92d8c23565496537)(transaction).description}`);
            // In case of an overlapping transaction, stopProfiling may return null and silently ignore the overlapping profile.
            if (!profile) {
                if (0, $ade9b105e5b71e91$export$16a28057038b10ef) (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`[Profiling] profiler returned null profile for: ${(0, $406b3ceb32322c72$export$92d8c23565496537)(transaction).description}`, "this may indicate an overlapping transaction or a call to stopProfiling with a profile title that was never started");
                return null;
            }
            (0, $d82d58dda182313b$export$7ddae68097f7e530)(profileId, profile);
            return null;
        }).catch((error)=>{
            if (0, $ade9b105e5b71e91$export$16a28057038b10ef) (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Profiling] error while stopping profiler:", error);
            return null;
        });
    }
    // Enqueue a timeout to prevent profiles from running over max duration.
    let maxDurationTimeoutID = (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).setTimeout(()=>{
        if (0, $ade9b105e5b71e91$export$16a28057038b10ef) (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Profiling] max profile duration elapsed, stopping profiling for:", (0, $406b3ceb32322c72$export$92d8c23565496537)(transaction).description);
        // If the timeout exceeds, we want to stop profiling, but not finish the transaction
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        onProfileHandler();
    }, (0, $d82d58dda182313b$export$8640c0b5c7d98a81));
    // We need to reference the original end call to avoid creating an infinite loop
    const originalEnd = transaction.end.bind(transaction);
    /**
   * Wraps startTransaction and stopTransaction with profiling related logic.
   * startProfiling is called after the call to startTransaction in order to avoid our own code from
   * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
   */ function profilingWrappedTransactionEnd() {
        if (!transaction) return originalEnd();
        // onProfileHandler should always return the same profile even if this is called multiple times.
        // Always call onProfileHandler to ensure stopProfiling is called and the timeout is cleared.
        onProfileHandler().then(()=>{
            // TODO: Can we rewrite this to use attributes?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setContext("profile", {
                profile_id: profileId,
                start_timestamp: startTimestamp
            });
            originalEnd();
        }, ()=>{
            // If onProfileHandler fails, we still want to call the original finish method.
            originalEnd();
        });
        return transaction;
    }
    transaction.end = profilingWrappedTransactionEnd;
    return transaction;
}



const $43daeb1fbba91c9d$var$INTEGRATION_NAME = "BrowserProfiling";
const $43daeb1fbba91c9d$var$browserProfilingIntegration = ()=>{
    return {
        name: $43daeb1fbba91c9d$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            const scope = (0, $fead0e8ca16cc636$export$c7be4b0125a10cba)();
            // eslint-disable-next-line deprecation/deprecation
            const transaction = scope.getTransaction();
            if (transaction && (0, $d82d58dda182313b$export$7c501dd6adb8177c)(transaction)) {
                if ((0, $d82d58dda182313b$export$ea6683c0c72c1201)(transaction)) (0, $95ff814a6b703707$export$a5c90b2530e76e64)(transaction);
            }
            if (typeof client.on !== "function") {
                (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("[Profiling] Client does not support hooks, profiling will be disabled");
                return;
            }
            client.on("startTransaction", (transaction)=>{
                if ((0, $d82d58dda182313b$export$ea6683c0c72c1201)(transaction)) (0, $95ff814a6b703707$export$a5c90b2530e76e64)(transaction);
            });
            client.on("beforeEnvelope", (envelope)=>{
                // if not profiles are in queue, there is nothing to add to the envelope.
                if (!(0, $d82d58dda182313b$export$9d723f414195854a)()) return;
                const profiledTransactionEvents = (0, $d82d58dda182313b$export$df9bb0fc214ff8cd)(envelope);
                if (!profiledTransactionEvents.length) return;
                const profilesToAddToEnvelope = [];
                for (const profiledTransaction of profiledTransactionEvents){
                    const context = profiledTransaction && profiledTransaction.contexts;
                    const profile_id = context && context["profile"] && context["profile"]["profile_id"];
                    const start_timestamp = context && context["profile"] && context["profile"]["start_timestamp"];
                    if (typeof profile_id !== "string") {
                        (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Profiling] cannot find profile for a transaction without a profile context");
                        continue;
                    }
                    if (!profile_id) {
                        (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Profiling] cannot find profile for a transaction without a profile context");
                        continue;
                    }
                    // Remove the profile from the transaction context before sending, relay will take care of the rest.
                    if (context && context["profile"]) delete context.profile;
                    const profile = (0, $d82d58dda182313b$export$6285310796363de1)(profile_id);
                    if (!profile) {
                        (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`[Profiling] Could not retrieve profile for transaction: ${profile_id}`);
                        continue;
                    }
                    const profileEvent = (0, $d82d58dda182313b$export$5c2c5e805edd874f)(profile_id, start_timestamp, profile, profiledTransaction);
                    if (profileEvent) profilesToAddToEnvelope.push(profileEvent);
                }
                (0, $d82d58dda182313b$export$4df36760a75f76bc)(envelope, profilesToAddToEnvelope);
            });
        }
    };
};
/**
 * Browser profiling integration. Stores any event that has contexts["profile"]["profile_id"]
 * This exists because we do not want to await async profiler.stop calls as transaction.finish is called
 * in a synchronous context. Instead, we handle sending the profile async from the promise callback and
 * rely on being able to pull the event from the cache when we need to construct the envelope. This makes the
 * integration less reliable as we might be dropping profiles when the cache is full.
 *
 * @experimental
 */ // eslint-disable-next-line deprecation/deprecation
const $43daeb1fbba91c9d$export$b0fe88803ed435e0 = (0, $382eff120bb43d6f$export$afa219bf23651160)($43daeb1fbba91c9d$var$INTEGRATION_NAME, $43daeb1fbba91c9d$var$browserProfilingIntegration);









// We keep the handlers globally
const $21ff179dbda73e8f$var$handlers = {};
const $21ff179dbda73e8f$var$instrumented = {};
/** Add a handler function. */ function $21ff179dbda73e8f$export$a4e09611e30da72e(type, handler) {
    $21ff179dbda73e8f$var$handlers[type] = $21ff179dbda73e8f$var$handlers[type] || [];
    $21ff179dbda73e8f$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $21ff179dbda73e8f$export$b17eab759a1cb5fe() {
    Object.keys($21ff179dbda73e8f$var$handlers).forEach((key)=>{
        $21ff179dbda73e8f$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $21ff179dbda73e8f$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$21ff179dbda73e8f$var$instrumented[type]) {
        instrumentFn();
        $21ff179dbda73e8f$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $21ff179dbda73e8f$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $21ff179dbda73e8f$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $9a1e45eb0df10cda$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $65291a370105e130$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


let $16305507a650302d$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $16305507a650302d$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $21ff179dbda73e8f$export$a4e09611e30da72e)(type, handler);
    (0, $21ff179dbda73e8f$export$e18d6c5462c01368)(type, $16305507a650302d$var$instrumentError);
}
function $16305507a650302d$var$instrumentError() {
    $16305507a650302d$var$_oldOnErrorHandler = (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1).onerror;
    (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $21ff179dbda73e8f$export$b18c893e424d3127)("error", handlerData);
        if ($16305507a650302d$var$_oldOnErrorHandler && !$16305507a650302d$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $16305507a650302d$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $450b32e1145ae417$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $450b32e1145ae417$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $21ff179dbda73e8f$export$a4e09611e30da72e)(type, handler);
    (0, $21ff179dbda73e8f$export$e18d6c5462c01368)(type, $450b32e1145ae417$var$instrumentUnhandledRejection);
}
function $450b32e1145ae417$var$instrumentUnhandledRejection() {
    $450b32e1145ae417$var$_oldOnUnhandledRejectionHandler = (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $21ff179dbda73e8f$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($450b32e1145ae417$var$_oldOnUnhandledRejectionHandler && !$450b32e1145ae417$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $450b32e1145ae417$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ function $a768906ca77dcb07$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $a768906ca77dcb07$export$8e9a29865c0a1226 = (0, $ca032ccd622f944d$export$8e9a29865c0a1226);


let $d2f378ed800cb407$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $d2f378ed800cb407$export$637857c1d87b640c() {
    if ($d2f378ed800cb407$var$errorsInstrumented) return;
    $d2f378ed800cb407$var$errorsInstrumented = true;
    (0, $16305507a650302d$export$55b5c3ba2194f0c6)($d2f378ed800cb407$var$errorCallback);
    (0, $450b32e1145ae417$export$8bf4fc6858821a4e)($d2f378ed800cb407$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $d2f378ed800cb407$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $a768906ca77dcb07$export$a7feb32fdd923295)();
    if (activeTransaction) {
        const status = "internal_error";
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$d2f378ed800cb407$var$errorCallback.tag = "sentry_tracingErrorCallback";







/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $ef6d4d4437d520f6$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $ef6d4d4437d520f6$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $ef6d4d4437d520f6$export$1a413bd9a88fdb09 = "sentry.op";




/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $370c15bf15662c83$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $370c15bf15662c83$export$5f1714a13ed34c01 {
    /**
   * @inheritDoc
   */ /**
   * Tags for the span.
   * @deprecated Use `getSpanAttributes(span)` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `getSpanAttributes(span)` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /**
   * The origin of the span, giving context about what created the span.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $a4e39c7e45099c0d$export$ee52dced521e3e18)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        this._attributes = spanContext.attributes ? {
            ...spanContext.attributes
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || "sentry";
        this.origin = spanContext.origin || "manual";
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this.parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.op) this.setAttribute((0, $ef6d4d4437d520f6$export$1a413bd9a88fdb09), spanContext.op);
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || "";
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `getSpanAttributes(span)` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $ef6d4d4437d520f6$export$1a413bd9a88fdb09];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $ef6d4d4437d520f6$export$1a413bd9a88fdb09), op);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $406b3ceb32322c72$export$eb571cd9b5d98de8) : (0, $406b3ceb32322c72$export$208d5b368507fb8b)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $370c15bf15662c83$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $f49fa6c697b46265$export$c4c6a79b1260ca1b)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $34ae909229820d8f$export$16a28057038b10ef) && rootSpan) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = (0, $406b3ceb32322c72$export$92d8c23565496537)(childSpan).description || "< unknown name >";
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ setHttpStatus(httpStatus) {
        // eslint-disable-next-line deprecation/deprecation
        this.setTag("http.status_code", String(httpStatus));
        // eslint-disable-next-line deprecation/deprecation
        this.setData("http.response.status_code", httpStatus);
        const spanStatus = $370c15bf15662c83$export$ac65c70d78fcdb55(httpStatus);
        if (spanStatus !== "unknown_error") this.setStatus(spanStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === "ok";
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $f49fa6c697b46265$export$c4c6a79b1260ca1b)(this);
        if ((0, $34ae909229820d8f$export$16a28057038b10ef) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(logMessage.replace("Starting", "Finishing"));
        }
        this._endTime = (0, $406b3ceb32322c72$export$3f7581298f56c6d7)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $406b3ceb32322c72$export$7e9f8ae9e4a328ab)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $380d67425f19a6e7$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this.parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this.parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $406b3ceb32322c72$export$46c6fbd1d265ebf0)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $380d67425f19a6e7$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $ef6d4d4437d520f6$export$1a413bd9a88fdb09],
            parent_span_id: this.parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this.origin
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $370c15bf15662c83$export$ac65c70d78fcdb55(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}









/** JSDoc */ class $36c3ed95df388771$export$febc5573c75cefb0 extends (0, $370c15bf15662c83$export$5f1714a13ed34c01) {
    /**
   * The reference to the current hub.
   */ // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, hub){
        super(transactionContext);
        this._measurements = {};
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)();
        this._name = transactionContext.name || "";
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: "custom",
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $ef6d4d4437d520f6$export$d7a7d984b0791405] && {
                source: this._attributes[0, $ef6d4d4437d520f6$export$d7a7d984b0791405]
            },
            ...this._attributes[0, $ef6d4d4437d520f6$export$ccfe0a40627cc34b] && {
                sampleRate: this._attributes[0, $ef6d4d4437d520f6$export$ccfe0a40627cc34b]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = "custom") {
        this._name = name;
        this.setAttribute((0, $ef6d4d4437d520f6$export$d7a7d984b0791405), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $370c15bf15662c83$export$10c95c129cd0d4fe)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $406b3ceb32322c72$export$3f7581298f56c6d7)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $380d67425f19a6e7$export$d25f2688db1bb433)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $0f19d7480cf01213$export$a117f995597e25df)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ setHub(hub) {
        this._hub = hub;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit("finishTransaction", this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $406b3ceb32322c72$export$92d8c23565496537)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $406b3ceb32322c72$export$92d8c23565496537)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $406b3ceb32322c72$export$46c6fbd1d265ebf0)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                dynamicSamplingContext: (0, $0f19d7480cf01213$export$a117f995597e25df)(this)
            },
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}


const $9a2e67346f23dd0c$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $9a2e67346f23dd0c$var$FINISH_REASON_TAG = "finishReason";
const $9a2e67346f23dd0c$var$IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ class $9a2e67346f23dd0c$export$370d6113c18ba86c extends (0, $370c15bf15662c83$export$10c95c129cd0d4fe) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $406b3ceb32322c72$export$92d8c23565496537)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $9a2e67346f23dd0c$export$b279e6bd7040371f extends (0, $36c3ed95df388771$export$febc5573c75cefb0) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $9a2e67346f23dd0c$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $9a2e67346f23dd0c$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $9a2e67346f23dd0c$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $9a2e67346f23dd0c$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this._finishReason = $9a2e67346f23dd0c$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $406b3ceb32322c72$export$3f7581298f56c6d7)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === "ui.action.click") this.setAttribute($9a2e67346f23dd0c$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $34ae909229820d8f$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
            (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Tracing] finishing IdleTransaction", new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $406b3ceb32322c72$export$92d8c23565496537)(span).timestamp) {
                    span.setStatus("cancelled");
                    span.end(endTimestampInS);
                    (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $406b3ceb32322c72$export$92d8c23565496537)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $34ae909229820d8f$export$16a28057038b10ef) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Tracing] flushing IdleTransaction");
        } else (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $9a2e67346f23dd0c$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $9a2e67346f23dd0c$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Tracing] Received finish signal for idle transaction.");
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $9a2e67346f23dd0c$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $a4e39c7e45099c0d$export$ee52dced521e3e18)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $9a2e67346f23dd0c$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Tracing] Transaction finished because of no change for 3 heart beats");
                this.setStatus("deadline_exceeded");
                this._finishReason = $9a2e67346f23dd0c$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}






// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $d58cb168a3883042$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $fead0e8ca16cc636$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}



/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $51eac3ae60a130a4$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $d58cb168a3883042$export$5008da00b1b6dee6)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $ef6d4d4437d520f6$export$ccfe0a40627cc34b), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $ef6d4d4437d520f6$export$ccfe0a40627cc34b), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $ef6d4d4437d520f6$export$ccfe0a40627cc34b), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $ef6d4d4437d520f6$export$ccfe0a40627cc34b), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$51eac3ae60a130a4$var$isValidSampleRate(sampleRate)) {
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $34ae909229820d8f$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
    (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $406b3ceb32322c72$export$92d8c23565496537)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $51eac3ae60a130a4$var$isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $15f0bc38c7419bb4$export$c9f5652083b8129d)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}



/** Returns all trace headers that are currently on the top scope. */ function $26d0c645e3dcc3ba$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        "sentry-trace": (0, $406b3ceb32322c72$export$7e9f8ae9e4a328ab)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $26d0c645e3dcc3ba$var$_startTransaction(transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $36c3ed95df388771$export$febc5573c75cefb0)(transactionContext, this);
    transaction = (0, $51eac3ae60a130a4$export$b3258c3993bc9b71)(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $26d0c645e3dcc3ba$export$479dbd817e392a4f(hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $9a2e67346f23dd0c$export$b279e6bd7040371f)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $51eac3ae60a130a4$export$b3258c3993bc9b71)(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $26d0c645e3dcc3ba$export$653d0ef2bad9cdf9() {
    const carrier = (0, $9f8f0bc84d498322$export$19eade501500c6c1)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $26d0c645e3dcc3ba$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $26d0c645e3dcc3ba$var$traceHeaders;
    (0, $d2f378ed800cb407$export$637857c1d87b640c)();
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $a2358ec17780dc03$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;






const $2635737a01c2d332$export$56d8a8a25bd48b81 = (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $f265a87ea74d2d02$export$6f18f55521af71a1() {
    if ((0, $2635737a01c2d332$export$56d8a8a25bd48b81) && (0, $2635737a01c2d332$export$56d8a8a25bd48b81).document) (0, $2635737a01c2d332$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $a768906ca77dcb07$export$a7feb32fdd923295)();
        if ((0, $2635737a01c2d332$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = "cancelled";
            const { op: op, status: status } = (0, $406b3ceb32322c72$export$92d8c23565496537)(activeTransaction);
            (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.end();
        }
    });
    else (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}



/**
 * Adds a measurement to the current active transaction.
 */ function $f86347d83a35e52a$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $a768906ca77dcb07$export$a7feb32fdd923295)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}


/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $12db4a4eadd18394$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $12db4a4eadd18394$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $12db4a4eadd18394$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $12db4a4eadd18394$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}





const $aed18db8041fc5b6$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $ca5523a20cd2d0ed$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b411aabaf8fc3fac$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $2635737a01c2d332$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $2635737a01c2d332$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(const key in timing)if (key !== "navigationStart" && key !== "toJSON") // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $b411aabaf8fc3fac$export$6431553786c94949 = ()=>{
    if ((0, $2635737a01c2d332$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $2635737a01c2d332$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || $b411aabaf8fc3fac$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $2635737a01c2d332$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4fbedf605147894b$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $b411aabaf8fc3fac$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1e953c5abf8d4ce$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $b411aabaf8fc3fac$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $2635737a01c2d332$export$56d8a8a25bd48b81).document.prerendering || (0, $4fbedf605147894b$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, $ca5523a20cd2d0ed$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $3d1eb33c35c1f37e$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c57ac347db1472ed$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $2635737a01c2d332$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener("visibilitychange", onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener("pagehide", onHiddenOrPageHide, true);
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $7b83ee2062f5e67c$export$a7873055838e5ad8 = (onReport)=>{
    const metric = (0, $b1e953c5abf8d4ce$export$3c29b44508a0612b)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $3d1eb33c35c1f37e$export$d1203567a167490e)("layout-shift", handleEntries);
    if (po) {
        report = (0, $aed18db8041fc5b6$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $c57ac347db1472ed$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $037dcfc476eb72c5$var$firstHiddenTime = -1;
const $037dcfc476eb72c5$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    return (0, $2635737a01c2d332$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && !(0, $2635737a01c2d332$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $037dcfc476eb72c5$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $c57ac347db1472ed$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $037dcfc476eb72c5$var$firstHiddenTime = timeStamp;
    }, true);
};
const $037dcfc476eb72c5$export$443f86b2c77012c4 = ()=>{
    if ($037dcfc476eb72c5$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $037dcfc476eb72c5$var$firstHiddenTime = $037dcfc476eb72c5$var$initHiddenTime();
        $037dcfc476eb72c5$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $037dcfc476eb72c5$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $6e95a35ec303d9f3$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $037dcfc476eb72c5$export$443f86b2c77012c4)();
    const metric = (0, $b1e953c5abf8d4ce$export$3c29b44508a0612b)("FID");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $3d1eb33c35c1f37e$export$d1203567a167490e)("first-input", handleEntries);
    report = (0, $aed18db8041fc5b6$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $c57ac347db1472ed$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $ad640241538a5ae2$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $ad640241538a5ae2$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $037dcfc476eb72c5$export$443f86b2c77012c4)();
    const metric = (0, $b1e953c5abf8d4ce$export$3c29b44508a0612b)("LCP");
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $4fbedf605147894b$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $3d1eb33c35c1f37e$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, $aed18db8041fc5b6$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$ad640241538a5ae2$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $ad640241538a5ae2$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $c57ac347db1472ed$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};



const $4f8b2749ff9eb7bb$var$handlers = {};
const $4f8b2749ff9eb7bb$var$instrumented = {};
let $4f8b2749ff9eb7bb$var$_previousCls;
let $4f8b2749ff9eb7bb$var$_previousFid;
let $4f8b2749ff9eb7bb$var$_previousLcp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $4f8b2749ff9eb7bb$export$861b82818b37ba5b(callback) {
    return $4f8b2749ff9eb7bb$var$addMetricObserver("cls", callback, $4f8b2749ff9eb7bb$var$instrumentCls, $4f8b2749ff9eb7bb$var$_previousCls);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $4f8b2749ff9eb7bb$export$3fd4b53331200102(callback) {
    return $4f8b2749ff9eb7bb$var$addMetricObserver("lcp", callback, $4f8b2749ff9eb7bb$var$instrumentLcp, $4f8b2749ff9eb7bb$var$_previousLcp);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $4f8b2749ff9eb7bb$export$2707d7471c0b918f(callback) {
    return $4f8b2749ff9eb7bb$var$addMetricObserver("fid", callback, $4f8b2749ff9eb7bb$var$instrumentFid, $4f8b2749ff9eb7bb$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $4f8b2749ff9eb7bb$export$69816c1a049f8db6(type, callback) {
    $4f8b2749ff9eb7bb$var$addHandler(type, callback);
    if (!$4f8b2749ff9eb7bb$var$instrumented[type]) {
        $4f8b2749ff9eb7bb$var$instrumentPerformanceObserver(type);
        $4f8b2749ff9eb7bb$var$instrumented[type] = true;
    }
    return $4f8b2749ff9eb7bb$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $4f8b2749ff9eb7bb$var$triggerHandlers(type, data) {
    const typeHandlers = $4f8b2749ff9eb7bb$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $65291a370105e130$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $4f8b2749ff9eb7bb$var$instrumentCls() {
    (0, $7b83ee2062f5e67c$export$a7873055838e5ad8)((metric)=>{
        $4f8b2749ff9eb7bb$var$triggerHandlers("cls", {
            metric: metric
        });
        $4f8b2749ff9eb7bb$var$_previousCls = metric;
    });
}
function $4f8b2749ff9eb7bb$var$instrumentFid() {
    (0, $6e95a35ec303d9f3$export$39705a25c49af873)((metric)=>{
        $4f8b2749ff9eb7bb$var$triggerHandlers("fid", {
            metric: metric
        });
        $4f8b2749ff9eb7bb$var$_previousFid = metric;
    });
}
function $4f8b2749ff9eb7bb$var$instrumentLcp() {
    (0, $ad640241538a5ae2$export$947b1626ab8d5632)((metric)=>{
        $4f8b2749ff9eb7bb$var$triggerHandlers("lcp", {
            metric: metric
        });
        $4f8b2749ff9eb7bb$var$_previousLcp = metric;
    });
}
function $4f8b2749ff9eb7bb$var$addMetricObserver(type, callback, instrumentFn, previousValue) {
    $4f8b2749ff9eb7bb$var$addHandler(type, callback);
    if (!$4f8b2749ff9eb7bb$var$instrumented[type]) {
        instrumentFn();
        $4f8b2749ff9eb7bb$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $4f8b2749ff9eb7bb$var$getCleanupCallback(type, callback);
}
function $4f8b2749ff9eb7bb$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $3d1eb33c35c1f37e$export$d1203567a167490e)(type, (entries)=>{
        $4f8b2749ff9eb7bb$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $4f8b2749ff9eb7bb$var$addHandler(type, handler) {
    $4f8b2749ff9eb7bb$var$handlers[type] = $4f8b2749ff9eb7bb$var$handlers[type] || [];
    $4f8b2749ff9eb7bb$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $4f8b2749ff9eb7bb$var$getCleanupCallback(type, callback) {
    return ()=>{
        const typeHandlers = $4f8b2749ff9eb7bb$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}




/**
 * Checks if a given value is a valid measurement value.
 */ function $6ac272ffeb2a8ada$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $6ac272ffeb2a8ada$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}


const $a33c91c426e0cf2d$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $a33c91c426e0cf2d$var$msToSec(time) {
    return time / 1000;
}
function $a33c91c426e0cf2d$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $2635737a01c2d332$export$56d8a8a25bd48b81) && (0, $2635737a01c2d332$export$56d8a8a25bd48b81).addEventListener && (0, $2635737a01c2d332$export$56d8a8a25bd48b81).performance;
}
let $a33c91c426e0cf2d$var$_performanceCursor = 0;
let $a33c91c426e0cf2d$var$_measurements = {};
let $a33c91c426e0cf2d$var$_lcpEntry;
let $a33c91c426e0cf2d$var$_clsEntry;
/**
 * Start tracking web vitals
 *
 * @returns A function that forces web vitals collection
 */ function $a33c91c426e0cf2d$export$7c69f0412d101b88() {
    const performance = $a33c91c426e0cf2d$var$getBrowserPerformanceAPI();
    if (performance && (0, $a4e39c7e45099c0d$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $2635737a01c2d332$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const fidCallback = $a33c91c426e0cf2d$var$_trackFID();
        const clsCallback = $a33c91c426e0cf2d$var$_trackCLS();
        const lcpCallback = $a33c91c426e0cf2d$var$_trackLCP();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $a33c91c426e0cf2d$export$f396d19077034ad2() {
    (0, $4f8b2749ff9eb7bb$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $a768906ca77dcb07$export$a7feb32fdd923295)();
            if (!transaction) return;
            const startTime = $a33c91c426e0cf2d$var$msToSec((0, $a4e39c7e45099c0d$export$baf075a948ffc0bf) + entry.startTime);
            const duration = $a33c91c426e0cf2d$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: "Main UI thread blocked",
                op: "ui.long-task",
                origin: "auto.ui.browser.metrics",
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $a33c91c426e0cf2d$export$e27543e0976315e4() {
    (0, $4f8b2749ff9eb7bb$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $a768906ca77dcb07$export$a7feb32fdd923295)();
            if (!transaction) return;
            if (entry.name === "click") {
                const startTime = $a33c91c426e0cf2d$var$msToSec((0, $a4e39c7e45099c0d$export$baf075a948ffc0bf) + entry.startTime);
                const duration = $a33c91c426e0cf2d$var$msToSec(entry.duration);
                const span = {
                    description: (0, $1406e1e4fc31c9ca$export$5647df6b7814ac86)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $1406e1e4fc31c9ca$export$26727cfcc4d7e0fc)(entry.target);
                if (componentName) span.attributes = {
                    "ui.component_name": componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $a33c91c426e0cf2d$var$_trackCLS() {
    return (0, $4f8b2749ff9eb7bb$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Measurements] Adding CLS");
        $a33c91c426e0cf2d$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $a33c91c426e0cf2d$var$_clsEntry = entry;
    });
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $a33c91c426e0cf2d$var$_trackLCP() {
    return (0, $4f8b2749ff9eb7bb$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Measurements] Adding LCP");
        $a33c91c426e0cf2d$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $a33c91c426e0cf2d$var$_lcpEntry = entry;
    });
}
/** Starts tracking the First Input Delay on the current page. */ function $a33c91c426e0cf2d$var$_trackFID() {
    return (0, $4f8b2749ff9eb7bb$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        const timeOrigin = $a33c91c426e0cf2d$var$msToSec((0, $a4e39c7e45099c0d$export$baf075a948ffc0bf));
        const startTime = $a33c91c426e0cf2d$var$msToSec(entry.startTime);
        (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Measurements] Adding FID");
        $a33c91c426e0cf2d$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $a33c91c426e0cf2d$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
/** Add performance related spans to a transaction */ function $a33c91c426e0cf2d$export$5f8fa6b3467a7443(transaction) {
    const performance = $a33c91c426e0cf2d$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $2635737a01c2d332$export$56d8a8a25bd48b81).performance.getEntries || !(0, $a4e39c7e45099c0d$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = $a33c91c426e0cf2d$var$msToSec((0, $a4e39c7e45099c0d$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    let responseStartTimestamp;
    let requestStartTimestamp;
    const { op: op, start_timestamp: transactionStartTime } = (0, $406b3ceb32322c72$export$92d8c23565496537)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($a33c91c426e0cf2d$var$_performanceCursor).forEach((entry)=>{
        const startTime = $a33c91c426e0cf2d$var$msToSec(entry.startTime);
        const duration = $a33c91c426e0cf2d$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $a33c91c426e0cf2d$var$_addNavigationSpans(transaction, entry, timeOrigin);
                responseStartTimestamp = timeOrigin + $a33c91c426e0cf2d$var$msToSec(entry.responseStart);
                requestStartTimestamp = timeOrigin + $a33c91c426e0cf2d$var$msToSec(entry.requestStart);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $a33c91c426e0cf2d$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $037dcfc476eb72c5$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Measurements] Adding FP");
                        $a33c91c426e0cf2d$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Measurements] Adding FCP");
                        $a33c91c426e0cf2d$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                $a33c91c426e0cf2d$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $a33c91c426e0cf2d$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $a33c91c426e0cf2d$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
        // start of the response in milliseconds
        if (typeof responseStartTimestamp === "number" && transactionStartTime) {
            (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Measurements] Adding TTFB");
            $a33c91c426e0cf2d$var$_measurements["ttfb"] = {
                value: (responseStartTimestamp - transactionStartTime) * 1000,
                unit: "millisecond"
            };
            if (typeof requestStartTimestamp === "number" && requestStartTimestamp <= responseStartTimestamp) // Capture the time spent making the request and receiving the first byte of the response.
            // This is the time between the start of the request and the start of the response in milliseconds.
            $a33c91c426e0cf2d$var$_measurements["ttfb.requestTime"] = {
                value: (responseStartTimestamp - requestStartTimestamp) * 1000,
                unit: "millisecond"
            };
        }
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!$a33c91c426e0cf2d$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $a33c91c426e0cf2d$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $a33c91c426e0cf2d$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $a33c91c426e0cf2d$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $a33c91c426e0cf2d$var$_measurements["mark.fid"];
        if (fidMark && $a33c91c426e0cf2d$var$_measurements["fid"]) {
            // create span for FID
            (0, $6ac272ffeb2a8ada$export$8bd469e1f37aa721)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + $a33c91c426e0cf2d$var$msToSec($a33c91c426e0cf2d$var$_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $a33c91c426e0cf2d$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $a33c91c426e0cf2d$var$_measurements)) delete $a33c91c426e0cf2d$var$_measurements.cls;
        Object.keys($a33c91c426e0cf2d$var$_measurements).forEach((measurementName)=>{
            (0, $f86347d83a35e52a$export$7cc31b475d33a706)(measurementName, $a33c91c426e0cf2d$var$_measurements[measurementName].value, $a33c91c426e0cf2d$var$_measurements[measurementName].unit);
        });
        $a33c91c426e0cf2d$var$_tagMetricInfo(transaction);
    }
    $a33c91c426e0cf2d$var$_lcpEntry = undefined;
    $a33c91c426e0cf2d$var$_clsEntry = undefined;
    $a33c91c426e0cf2d$var$_measurements = {};
}
/** Create measure related spans */ function $a33c91c426e0cf2d$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $6ac272ffeb2a8ada$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a33c91c426e0cf2d$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $a33c91c426e0cf2d$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $a33c91c426e0cf2d$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $a33c91c426e0cf2d$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $a33c91c426e0cf2d$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $a33c91c426e0cf2d$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $a33c91c426e0cf2d$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $6ac272ffeb2a8ada$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + $a33c91c426e0cf2d$var$msToSec(start),
        endTimestamp: timeOrigin + $a33c91c426e0cf2d$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a33c91c426e0cf2d$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $6ac272ffeb2a8ada$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "request",
            startTimestamp: timeOrigin + $a33c91c426e0cf2d$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $a33c91c426e0cf2d$var$msToSec(entry.responseEnd)
        });
        (0, $6ac272ffeb2a8ada$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "response",
            startTimestamp: timeOrigin + $a33c91c426e0cf2d$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $a33c91c426e0cf2d$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $a33c91c426e0cf2d$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $12db4a4eadd18394$export$7a5253c0f62e0150)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $a33c91c426e0cf2d$var$setResourceEntrySizeData(data, entry, "transferSize", "http.response_transfer_size");
    $a33c91c426e0cf2d$var$setResourceEntrySizeData(data, entry, "encodedBodySize", "http.response_content_length");
    $a33c91c426e0cf2d$var$setResourceEntrySizeData(data, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data["server.address"] = parsedUrl.host;
    data["url.same_origin"] = resourceUrl.includes((0, $2635737a01c2d332$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $6ac272ffeb2a8ada$export$8bd469e1f37aa721)(transaction, {
        description: resourceUrl.replace((0, $2635737a01c2d332$export$56d8a8a25bd48b81).location.origin, ""),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $a33c91c426e0cf2d$var$_trackNavigator(transaction) {
    const navigator = (0, $2635737a01c2d332$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("connectionType", connection.type);
        if ((0, $6ac272ffeb2a8ada$export$27169ccae1b439e3)(connection.rtt)) $a33c91c426e0cf2d$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $6ac272ffeb2a8ada$export$27169ccae1b439e3)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $6ac272ffeb2a8ada$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $a33c91c426e0cf2d$var$_tagMetricInfo(transaction) {
    if ($a33c91c426e0cf2d$var$_lcpEntry) {
        (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($a33c91c426e0cf2d$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.element", (0, $1406e1e4fc31c9ca$export$5647df6b7814ac86)($a33c91c426e0cf2d$var$_lcpEntry.element));
        if ($a33c91c426e0cf2d$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.id", $a33c91c426e0cf2d$var$_lcpEntry.id);
        if ($a33c91c426e0cf2d$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.url", $a33c91c426e0cf2d$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.size", $a33c91c426e0cf2d$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($a33c91c426e0cf2d$var$_clsEntry && $a33c91c426e0cf2d$var$_clsEntry.sources) {
        (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("[Measurements] Adding CLS Data");
        $a33c91c426e0cf2d$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $1406e1e4fc31c9ca$export$5647df6b7814ac86)(source.node)));
    }
}
function $a33c91c426e0cf2d$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $a33c91c426e0cf2d$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}







/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $e44e6580b6864caf$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $e44e6580b6864caf$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $e44e6580b6864caf$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $15f0bc38c7419bb4$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}




/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $1f0647b8f789dfb4$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)();
    const scope = (0, $fead0e8ca16cc636$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const ctx = $1f0647b8f789dfb4$var$normalizeContext(context);
    const activeSpan = $1f0647b8f789dfb4$var$createChildSpanOrTransaction(hub, parentSpan, ctx);
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $e44e6580b6864caf$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus("internal_error");
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $1f0647b8f789dfb4$export$a1bd95187356f372(context, callback) {
    const ctx = $1f0647b8f789dfb4$var$normalizeContext(context);
    return (0, $fead0e8ca16cc636$export$ec58d9285c204497)(context.scope, (scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        const hub = (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)();
        // eslint-disable-next-line deprecation/deprecation
        const parentSpan = scope.getSpan();
        const activeSpan = $1f0647b8f789dfb4$var$createChildSpanOrTransaction(hub, parentSpan, ctx);
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(activeSpan);
        return (0, $e44e6580b6864caf$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
            // Only update the span status if it hasn't been changed yet
            if (activeSpan) {
                const { status: status } = (0, $406b3ceb32322c72$export$92d8c23565496537)(activeSpan);
                if (!status || status === "ok") activeSpan.setStatus("internal_error");
            }
        }, ()=>activeSpan && activeSpan.end());
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $1f0647b8f789dfb4$export$cb9e396e6b90b703 = $1f0647b8f789dfb4$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $1f0647b8f789dfb4$export$c10292ad04b92aea(context, callback) {
    const ctx = $1f0647b8f789dfb4$var$normalizeContext(context);
    return (0, $fead0e8ca16cc636$export$ec58d9285c204497)(context.scope, (scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        const hub = (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)();
        // eslint-disable-next-line deprecation/deprecation
        const parentSpan = scope.getSpan();
        const activeSpan = $1f0647b8f789dfb4$var$createChildSpanOrTransaction(hub, parentSpan, ctx);
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(activeSpan);
        function finishAndSetSpan() {
            activeSpan && activeSpan.end();
        }
        return (0, $e44e6580b6864caf$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
            // Only update the span status if it hasn't been changed yet, and the span is not yet finished
            if (activeSpan && activeSpan.isRecording()) {
                const { status: status } = (0, $406b3ceb32322c72$export$92d8c23565496537)(activeSpan);
                if (!status || status === "ok") activeSpan.setStatus("internal_error");
            }
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $1f0647b8f789dfb4$export$63dbba021a6b4047(context) {
    if (!(0, $d58cb168a3883042$export$5008da00b1b6dee6)()) return undefined;
    const ctx = $1f0647b8f789dfb4$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)();
    const parentSpan = context.scope ? context.scope.getSpan() : $1f0647b8f789dfb4$export$1be426a8e585c83e();
    return parentSpan ? parentSpan.startChild(ctx) : hub.startTransaction(ctx);
}
/**
 * Returns the currently active span.
 */ function $1f0647b8f789dfb4$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $fead0e8ca16cc636$export$c7be4b0125a10cba)().getSpan();
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers,
 * or in the browser from `<meta name="sentry-trace">` and `<meta name="baggage">` HTML tags.
 *
 * The callback receives a transactionContext that may be used for `startTransaction` or `startSpan`.
 */ function $1f0647b8f789dfb4$export$d2ee9b39b25437b3({ sentryTrace: sentryTrace, baggage: baggage }, callback) {
    const currentScope = (0, $fead0e8ca16cc636$export$c7be4b0125a10cba)();
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $ca032ccd622f944d$export$ca5c066532785b6e)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $34ae909229820d8f$export$16a28057038b10ef) && traceparentData) (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $380d67425f19a6e7$export$d25f2688db1bb433)({
            dynamicSamplingContext: traceparentData && !dynamicSamplingContext ? {} : dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return callback(transactionContext);
}
function $1f0647b8f789dfb4$var$createChildSpanOrTransaction(hub, parentSpan, ctx) {
    if (!(0, $d58cb168a3883042$export$5008da00b1b6dee6)()) return undefined;
    return parentSpan ? parentSpan.startChild(ctx) : hub.startTransaction(ctx);
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $1f0647b8f789dfb4$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $406b3ceb32322c72$export$3f7581298f56c6d7)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}






// eslint-disable-next-line deprecation/deprecation
const $97960cd9a3a7b583$var$WINDOW = (0, $81e469fe9ab1c810$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $97960cd9a3a7b583$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $97960cd9a3a7b583$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $97960cd9a3a7b583$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $97960cd9a3a7b583$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $97960cd9a3a7b583$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $97960cd9a3a7b583$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $97960cd9a3a7b583$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$97960cd9a3a7b583$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($97960cd9a3a7b583$export$18cf36ed71d733e7($97960cd9a3a7b583$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $97960cd9a3a7b583$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $97960cd9a3a7b583$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $9a1e45eb0df10cda$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $97960cd9a3a7b583$export$531055a6c684a70a() {
    return "ReportingObserver" in $97960cd9a3a7b583$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $97960cd9a3a7b583$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$97960cd9a3a7b583$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}




/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $efd9e6f08942efa4$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $21ff179dbda73e8f$export$a4e09611e30da72e)(type, handler);
    (0, $21ff179dbda73e8f$export$e18d6c5462c01368)(type, $efd9e6f08942efa4$var$instrumentFetch);
}
function $efd9e6f08942efa4$var$instrumentFetch() {
    if (!(0, $97960cd9a3a7b583$export$c82d238e23c40b21)()) return;
    (0, $380d67425f19a6e7$export$9563e054e6f787fb)((0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $efd9e6f08942efa4$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $21ff179dbda73e8f$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $21ff179dbda73e8f$export$b18c893e424d3127)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $21ff179dbda73e8f$export$b18c893e424d3127)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $efd9e6f08942efa4$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $efd9e6f08942efa4$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($efd9e6f08942efa4$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $efd9e6f08942efa4$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $efd9e6f08942efa4$var$getUrlFromResource(url),
            method: $efd9e6f08942efa4$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $efd9e6f08942efa4$var$getUrlFromResource(arg),
        method: $efd9e6f08942efa4$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}





const $0df962f0ceb7104b$var$WINDOW = (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1);
const $0df962f0ceb7104b$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $0df962f0ceb7104b$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $21ff179dbda73e8f$export$a4e09611e30da72e)(type, handler);
    (0, $21ff179dbda73e8f$export$e18d6c5462c01368)(type, $0df962f0ceb7104b$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $0df962f0ceb7104b$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$0df962f0ceb7104b$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $380d67425f19a6e7$export$9563e054e6f787fb)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $15f0bc38c7419bb4$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $0df962f0ceb7104b$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$0df962f0ceb7104b$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$0df962f0ceb7104b$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $21ff179dbda73e8f$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $380d67425f19a6e7$export$9563e054e6f787fb)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $380d67425f19a6e7$export$9563e054e6f787fb)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$0df962f0ceb7104b$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $15f0bc38c7419bb4$export$844ec244b1367d54)(header) && (0, $15f0bc38c7419bb4$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $380d67425f19a6e7$export$9563e054e6f787fb)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$0df962f0ceb7104b$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $21ff179dbda73e8f$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $0df962f0ceb7104b$var$parseUrl(url) {
    if ((0, $15f0bc38c7419bb4$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}




/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $1f80eeb52fa9bf3e$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!(0, $d58cb168a3883042$export$5008da00b1b6dee6)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            if (handlerData.response) {
                span.setHttpStatus(handlerData.response.status);
                const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
                if (contentLength) {
                    const contentLengthNum = parseInt(contentLength);
                    if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
                }
            } else if (handlerData.error) span.setStatus("internal_error");
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $fead0e8ca16cc636$export$c7be4b0125a10cba)();
    const client = (0, $fead0e8ca16cc636$export$6bb76d6eba7e258c)();
    const parentSpan = (0, $1f0647b8f789dfb4$export$1be426a8e585c83e)();
    const { method: method, url: url } = handlerData.fetchData;
    const span = shouldCreateSpanResult && parentSpan ? parentSpan.startChild({
        data: {
            url: url,
            type: "fetch",
            "http.method": method
        },
        description: `${method} ${url}`,
        op: "http.client",
        origin: spanOrigin
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $1f80eeb52fa9bf3e$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $1f80eeb52fa9bf3e$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const transaction = span && (0, $f49fa6c697b46265$export$c4c6a79b1260ca1b)(span);
    const { traceId: traceId, sampled: sampled, dsc: dsc } = scope.getPropagationContext();
    const sentryTraceHeader = span ? (0, $406b3ceb32322c72$export$7e9f8ae9e4a328ab)(span) : (0, $ca032ccd622f944d$export$f35d907436da45cf)(traceId, undefined, sampled);
    const dynamicSamplingContext = transaction ? (0, $0f19d7480cf01213$export$a117f995597e25df)(transaction) : dsc ? dsc : (0, $0f19d7480cf01213$export$366bad00d6815eed)(traceId, client, scope);
    const sentryBaggageHeader = (0, $af09eea94c90b603$export$56766feef403f365)(dynamicSamplingContext);
    const headers = options.headers || (typeof Request !== "undefined" && (0, $15f0bc38c7419bb4$export$49034edbe6b62415)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $15f0bc38c7419bb4$export$49034edbe6b62415)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $af09eea94c90b603$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $af09eea94c90b603$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}



/* eslint-disable max-lines */ const $9eddc880b17ae5c6$export$15bd0305d05ad07b = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $9eddc880b17ae5c6$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $9eddc880b17ae5c6$export$15bd0305d05ad07b,
    tracePropagationTargets: $9eddc880b17ae5c6$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $9eddc880b17ae5c6$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $9eddc880b17ae5c6$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $9eddc880b17ae5c6$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$9eddc880b17ae5c6$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $efd9e6f08942efa4$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $1f80eeb52fa9bf3e$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $9eddc880b17ae5c6$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $0df962f0ceb7104b$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $9eddc880b17ae5c6$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $9eddc880b17ae5c6$var$addHTTPTimings(createdSpan);
    });
}
function $9eddc880b17ae5c6$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $9eddc880b17ae5c6$var$addHTTPTimings(span) {
    const { url: url } = (0, $406b3ceb32322c72$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $4f8b2749ff9eb7bb$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($9eddc880b17ae5c6$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $9eddc880b17ae5c6$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $9eddc880b17ae5c6$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $9eddc880b17ae5c6$var$getAbsoluteTime(time = 0) {
    return (((0, $a4e39c7e45099c0d$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $9eddc880b17ae5c6$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $9eddc880b17ae5c6$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $a4e39c7e45099c0d$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $9eddc880b17ae5c6$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $9eddc880b17ae5c6$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $9eddc880b17ae5c6$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $9eddc880b17ae5c6$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $9eddc880b17ae5c6$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $9eddc880b17ae5c6$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $9eddc880b17ae5c6$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $9eddc880b17ae5c6$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $9eddc880b17ae5c6$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $9eddc880b17ae5c6$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $9eddc880b17ae5c6$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $6ead621f18d70699$export$a7a5ec66062ea5d)(url, tracePropagationTargets || $9eddc880b17ae5c6$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $9eddc880b17ae5c6$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $0df962f0ceb7104b$export$55b6bb1e45c6cf59];
    if (!(0, $d58cb168a3883042$export$5008da00b1b6dee6)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            span.setHttpStatus(sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $fead0e8ca16cc636$export$c7be4b0125a10cba)();
    const parentSpan = (0, $1f0647b8f789dfb4$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && parentSpan ? parentSpan.startChild({
        data: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            url: sentryXhrData.url
        },
        description: `${sentryXhrData.method} ${sentryXhrData.url}`,
        op: "http.client",
        origin: "auto.http.browser"
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url)) {
        if (span) {
            const transaction = span && (0, $f49fa6c697b46265$export$c4c6a79b1260ca1b)(span);
            const dynamicSamplingContext = transaction && (0, $0f19d7480cf01213$export$a117f995597e25df)(transaction);
            const sentryBaggageHeader = (0, $af09eea94c90b603$export$56766feef403f365)(dynamicSamplingContext);
            $9eddc880b17ae5c6$var$setHeaderOnXhr(xhr, (0, $406b3ceb32322c72$export$7e9f8ae9e4a328ab)(span), sentryBaggageHeader);
        } else {
            const client = (0, $fead0e8ca16cc636$export$6bb76d6eba7e258c)();
            const { traceId: traceId, sampled: sampled, dsc: dsc } = scope.getPropagationContext();
            const sentryTraceHeader = (0, $ca032ccd622f944d$export$f35d907436da45cf)(traceId, undefined, sampled);
            const dynamicSamplingContext = dsc || (client ? (0, $0f19d7480cf01213$export$366bad00d6815eed)(traceId, client, scope) : undefined);
            const sentryBaggageHeader = (0, $af09eea94c90b603$export$56766feef403f365)(dynamicSamplingContext);
            $9eddc880b17ae5c6$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
        }
    }
    return span;
}
function $9eddc880b17ae5c6$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $af09eea94c90b603$export$9ca9946bd449ac06), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}







// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $298890ca05cec2e1$var$WINDOW = (0, $81e469fe9ab1c810$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $298890ca05cec2e1$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chrome = $298890ca05cec2e1$var$WINDOW.chrome;
    const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $298890ca05cec2e1$var$WINDOW && !!$298890ca05cec2e1$var$WINDOW.history.pushState && !!$298890ca05cec2e1$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



const $8e5e4ba8e6a66d1f$var$WINDOW = (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1);
let $8e5e4ba8e6a66d1f$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $8e5e4ba8e6a66d1f$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $21ff179dbda73e8f$export$a4e09611e30da72e)(type, handler);
    (0, $21ff179dbda73e8f$export$e18d6c5462c01368)(type, $8e5e4ba8e6a66d1f$var$instrumentHistory);
}
function $8e5e4ba8e6a66d1f$var$instrumentHistory() {
    if (!(0, $298890ca05cec2e1$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $8e5e4ba8e6a66d1f$var$WINDOW.onpopstate;
    $8e5e4ba8e6a66d1f$var$WINDOW.onpopstate = function(...args) {
        const to = $8e5e4ba8e6a66d1f$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $8e5e4ba8e6a66d1f$var$lastHref;
        $8e5e4ba8e6a66d1f$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $21ff179dbda73e8f$export$b18c893e424d3127)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $8e5e4ba8e6a66d1f$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $8e5e4ba8e6a66d1f$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $21ff179dbda73e8f$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $380d67425f19a6e7$export$9563e054e6f787fb)($8e5e4ba8e6a66d1f$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $380d67425f19a6e7$export$9563e054e6f787fb)($8e5e4ba8e6a66d1f$var$WINDOW.history, "replaceState", historyReplacementFunction);
}




/**
 * Default function implementing pageload and navigation transactions
 */ function $47dea50309b278a9$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $2635737a01c2d332$export$56d8a8a25bd48b81) || !(0, $2635737a01c2d332$export$56d8a8a25bd48b81).location) {
        (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("Could not initialize routing instrumentation due to invalid location");
        return;
    }
    let startingUrl = (0, $2635737a01c2d332$export$56d8a8a25bd48b81).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $2635737a01c2d332$export$56d8a8a25bd48b81).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $a4e39c7e45099c0d$export$baf075a948ffc0bf) ? (0, $a4e39c7e45099c0d$export$baf075a948ffc0bf) / 1000 : undefined,
        op: "pageload",
        origin: "auto.pageload.browser",
        metadata: {
            source: "url"
        }
    });
    if (startTransactionOnLocationChange) (0, $8e5e4ba8e6a66d1f$export$3f18c56c58114e75)(({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.end();
            }
            activeTransaction = customStartTransaction({
                name: (0, $2635737a01c2d332$export$56d8a8a25bd48b81).location.pathname,
                op: "navigation",
                origin: "auto.navigation.browser",
                metadata: {
                    source: "url"
                }
            });
        }
    });
}



const $9441be368c328d2c$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $9441be368c328d2c$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $9a2e67346f23dd0c$export$809a2b7987fd5306),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $47dea50309b278a9$export$86649cc09fe75143),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    _experiments: {},
    ...(0, $9eddc880b17ae5c6$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */ class $9441be368c328d2c$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ constructor(_options){
        this.name = $9441be368c328d2c$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $26d0c645e3dcc3ba$export$653d0ef2bad9cdf9)();
        if (0, $a2358ec17780dc03$export$16a28057038b10ef) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = {
            ...$9441be368c328d2c$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $a33c91c426e0cf2d$export$7c69f0412d101b88)();
        if (this.options.enableLongTask) (0, $a33c91c426e0cf2d$export$f396d19077034ad2)();
        if (this.options._experiments.enableInteractions) (0, $a33c91c426e0cf2d$export$e27543e0976315e4)();
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const hub = getCurrentHub();
        // eslint-disable-next-line deprecation/deprecation
        const client = hub.getClient();
        const clientOptions = client && client.getOptions();
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = this.options;
        const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
        // There are three ways to configure tracePropagationTargets:
        // 1. via top level client option `tracePropagationTargets`
        // 2. via BrowserTracing option `tracePropagationTargets`
        // 3. via BrowserTracing option `tracingOrigins` (deprecated)
        //
        // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
        // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
        // This is done as it minimizes bundle size (we don't have to have undefined checks).
        //
        // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
        // eslint-disable-next-line deprecation/deprecation
        const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
        if ((0, $a2358ec17780dc03$export$16a28057038b10ef) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $f265a87ea74d2d02$export$6f18f55521af71a1)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        (0, $9eddc880b17ae5c6$export$864489cb3478db3e)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest,
            enableHTTPTimings: enableHTTPTimings
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const hub = this._getCurrentHub();
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === "pageload";
        const sentryTrace = isPageloadTransaction ? $9441be368c328d2c$export$f147b32b03c9cf11("sentry-trace") : "";
        const baggage = isPageloadTransaction ? $9441be368c328d2c$export$f147b32b03c9cf11("baggage") : "";
        const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $ca032ccd622f944d$export$ca5c066532785b6e)(sentryTrace, baggage);
        const expandedContext = {
            ...context,
            ...traceparentData,
            metadata: {
                // eslint-disable-next-line deprecation/deprecation
                ...context.metadata,
                dynamicSamplingContext: traceparentData && !dynamicSamplingContext ? {} : dynamicSamplingContext
            },
            trimEnd: true
        };
        const modifiedContext = typeof beforeNavigate === "function" ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        this._latestRouteName = finalContext.name;
        // eslint-disable-next-line deprecation/deprecation
        const sourceFromData = context.data && context.data[0, $ef6d4d4437d520f6$export$d7a7d984b0791405];
        // eslint-disable-next-line deprecation/deprecation
        const sourceFromMetadata = finalContext.metadata && finalContext.metadata.source;
        this._latestRouteSource = sourceFromData || sourceFromMetadata;
        // eslint-disable-next-line deprecation/deprecation
        if (finalContext.sampled === false) (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $2635737a01c2d332$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $26d0c645e3dcc3ba$export$479dbd817e392a4f)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction) {
            (0, $2635737a01c2d332$export$56d8a8a25bd48b81).document.addEventListener("readystatechange", ()=>{
                if ([
                    "interactive",
                    "complete"
                ].includes((0, $2635737a01c2d332$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
            });
            if ([
                "interactive",
                "complete"
            ].includes((0, $2635737a01c2d332$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
        }
        // eslint-disable-next-line deprecation/deprecation
        const scope = hub.getScope();
        // If it's a pageload and there is a meta tag set
        // use the traceparentData as the propagation context
        if (isPageloadTransaction && traceparentData) scope.setPropagationContext(propagationContext);
        else // Navigation transactions should set a new propagation context based on the
        // created idle transaction.
        scope.setPropagationContext({
            traceId: idleTransaction.spanContext().traceId,
            spanId: idleTransaction.spanContext().spanId,
            parentSpanId: idleTransaction.parentSpanId,
            sampled: (0, $406b3ceb32322c72$export$5caecac1caaf3a71)(idleTransaction)
        });
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $a33c91c426e0cf2d$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = "ui.action.click";
            // eslint-disable-next-line deprecation/deprecation
            const currentTransaction = (0, $a768906ca77dcb07$export$a7feb32fdd923295)();
            if (currentTransaction && currentTransaction.op && [
                "navigation",
                "pageload"
            ].includes(currentTransaction.op)) {
                (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason("interactionInterrupted");
                inflightInteractionTransaction.end();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRouteName) {
                (0, $a2358ec17780dc03$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $2635737a01c2d332$export$56d8a8a25bd48b81);
            const context = {
                name: this._latestRouteName,
                op: op,
                trimEnd: true,
                data: {
                    [(0, $ef6d4d4437d520f6$export$d7a7d984b0791405)]: this._latestRouteSource || "url"
                }
            };
            inflightInteractionTransaction = (0, $26d0c645e3dcc3ba$export$479dbd817e392a4f)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            "click"
        ].forEach((type)=>{
            addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
}
/** Returns the value of a meta tag */ function $9441be368c328d2c$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $1406e1e4fc31c9ca$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}



let $61af8f18dd91d870$var$originalFunctionToString;
const $61af8f18dd91d870$var$INTEGRATION_NAME = "FunctionToString";
const $61af8f18dd91d870$var$_functionToStringIntegration = ()=>{
    return {
        name: $61af8f18dd91d870$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $61af8f18dd91d870$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const context = (0, $380d67425f19a6e7$export$e6cc1e135e2092e5)(this) || this;
                    return $61af8f18dd91d870$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        }
    };
};
const $61af8f18dd91d870$export$7918117e9202e4fb = (0, $382eff120bb43d6f$export$2323046b9414659f)($61af8f18dd91d870$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $61af8f18dd91d870$export$da4704525c20ae79 = (0, $382eff120bb43d6f$export$afa219bf23651160)($61af8f18dd91d870$var$INTEGRATION_NAME, $61af8f18dd91d870$export$7918117e9202e4fb);


const $609b0bed1a3d24e1$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $609b0bed1a3d24e1$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $609b0bed1a3d24e1$var$_getIngestEndpoint(dsn) {
    return `${$609b0bed1a3d24e1$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $609b0bed1a3d24e1$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $380d67425f19a6e7$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $609b0bed1a3d24e1$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $609b0bed1a3d24e1$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$609b0bed1a3d24e1$var$_getIngestEndpoint(dsn)}?${$609b0bed1a3d24e1$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $609b0bed1a3d24e1$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $f33780998a3a623d$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$609b0bed1a3d24e1$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $f33780998a3a623d$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $821a0b33ca4a8e85$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
const $821a0b33ca4a8e85$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $821a0b33ca4a8e85$var$INTEGRATION_NAME = "InboundFilters";
const $821a0b33ca4a8e85$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $821a0b33ca4a8e85$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $821a0b33ca4a8e85$var$_mergeOptions(options, clientOptions);
            return $821a0b33ca4a8e85$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $821a0b33ca4a8e85$export$cb3c5c2ceb9818ba = (0, $382eff120bb43d6f$export$2323046b9414659f)($821a0b33ca4a8e85$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $821a0b33ca4a8e85$export$2ffbb5359dcc6be4 = (0, $382eff120bb43d6f$export$afa219bf23651160)($821a0b33ca4a8e85$var$INTEGRATION_NAME, $821a0b33ca4a8e85$export$cb3c5c2ceb9818ba);
function $821a0b33ca4a8e85$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $821a0b33ca4a8e85$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $821a0b33ca4a8e85$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $821a0b33ca4a8e85$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $821a0b33ca4a8e85$var$_isSentryError(event)) {
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $e23e8bb8c54ccb6f$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($821a0b33ca4a8e85$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $e23e8bb8c54ccb6f$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($821a0b33ca4a8e85$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $e23e8bb8c54ccb6f$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($821a0b33ca4a8e85$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $e23e8bb8c54ccb6f$export$4157119e2b157127)(event)}.\nUrl: ${$821a0b33ca4a8e85$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$821a0b33ca4a8e85$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $e23e8bb8c54ccb6f$export$4157119e2b157127)(event)}.\nUrl: ${$821a0b33ca4a8e85$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $821a0b33ca4a8e85$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $821a0b33ca4a8e85$var$_getPossibleEventMessages(event).some((message)=>(0, $6ead621f18d70699$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $821a0b33ca4a8e85$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $6ead621f18d70699$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $821a0b33ca4a8e85$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $821a0b33ca4a8e85$var$_getEventFilterUrl(event);
    return !url ? false : (0, $6ead621f18d70699$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $821a0b33ca4a8e85$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $821a0b33ca4a8e85$var$_getEventFilterUrl(event);
    return !url ? true : (0, $6ead621f18d70699$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $821a0b33ca4a8e85$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $34ae909229820d8f$export$16a28057038b10ef) && possibleMessages.length === 0) (0, $00cc87bc34693c04$export$af88d00dbe7f521).error(`Could not extract message for event ${(0, $e23e8bb8c54ccb6f$export$4157119e2b157127)(event)}`);
    return possibleMessages;
}
function $821a0b33ca4a8e85$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $821a0b33ca4a8e85$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $821a0b33ca4a8e85$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $821a0b33ca4a8e85$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $e23e8bb8c54ccb6f$export$4157119e2b157127)(event)}`);
        return null;
    }
}





/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $b6a0c61fb779964d$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $34ae909229820d8f$export$16a28057038b10ef) (0, $00cc87bc34693c04$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $00cc87bc34693c04$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $fead0e8ca16cc636$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $b6a0c61fb779964d$export$ecb76f41d43c0e43(client);
    $b6a0c61fb779964d$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $b6a0c61fb779964d$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $b6a0c61fb779964d$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}



/** An error emitted by Sentry SDKs and related utilities. */ class $b2ffe92d6e817982$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $81e9f87da8658256$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $81e9f87da8658256$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $be27cfb68e15613c$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $f33780998a3a623d$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $be27cfb68e15613c$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $81e9f87da8658256$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $be27cfb68e15613c$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $81e9f87da8658256$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $be27cfb68e15613c$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $be27cfb68e15613c$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}







const $74a720a8d0f2db55$export$ffbd59c90957aeda = "c";
const $74a720a8d0f2db55$export$41106537ee4dbdd = "g";
const $74a720a8d0f2db55$export$d2e7506772279f4e = "s";
const $74a720a8d0f2db55$export$9818d6472d7991f0 = "d";
/**
 * Normalization regex for metric names and metric tag names.
 *
 * This enforces that names and tag keys only contain alphanumeric characters,
 * underscores, forward slashes, periods, and dashes.
 *
 * See: https://develop.sentry.dev/sdk/metrics/#normalization
 */ const $74a720a8d0f2db55$export$73db7eda248c6468 = /[^a-zA-Z0-9_/.-]+/g;
/**
 * Normalization regex for metric tag values.
 *
 * This enforces that values only contain words, digits, or the following
 * special characters: _:/@.{}[\]$-
 *
 * See: https://develop.sentry.dev/sdk/metrics/#normalization
 */ const $74a720a8d0f2db55$export$2699a97e88d47e55 = /[^\w\d_:/@.{}[\]$-]+/g;
/**
 * This does not match spec in https://develop.sentry.dev/sdk/metrics
 * but was chosen to optimize for the most common case in browser environments.
 */ const $74a720a8d0f2db55$export$9fcf9b73aae4b12 = 5000;
/**
 * SDKs are required to bucket into 10 second intervals (rollup in seconds)
 * which is the current lower bound of metric accuracy.
 */ const $74a720a8d0f2db55$export$8f071e089fcfe0c = 10000;
/**
 * The maximum number of metrics that should be stored in memory.
 */ const $74a720a8d0f2db55$export$aa41e9d920739c1a = 10000;


/**
 * Generate bucket key from metric properties.
 */ function $165415809d9252f4$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $380d67425f19a6e7$export$d25f2688db1bb433)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $165415809d9252f4$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $165415809d9252f4$export$66decd709db01dc8(metricBucketItems) {
    let out = "";
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(",")}` : "";
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/**
 * Sanitizes tags.
 */ function $165415809d9252f4$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = key.replace((0, $74a720a8d0f2db55$export$73db7eda248c6468), "_");
        tags[sanitizedKey] = String(unsanitizedTags[key]).replace((0, $74a720a8d0f2db55$export$2699a97e88d47e55), "_");
    }
    return tags;
}


/**
 * Create envelope from a metric aggregate.
 */ function $f1cf8dd6cc68658d$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $f33780998a3a623d$export$44d472fbb931a776)(dsn);
    const item = $f1cf8dd6cc68658d$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $be27cfb68e15613c$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $f1cf8dd6cc68658d$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $165415809d9252f4$export$66decd709db01dc8)(metricBucketItems);
    const metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}





const $a1e68f6f2d1224be$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $a1e68f6f2d1224be$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $f33780998a3a623d$export$128827c3562ec0cb)(options.dsn);
        else (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $609b0bed1a3d24e1$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $e23e8bb8c54ccb6f$export$6de4ffac6a2f1098)(exception)) {
            (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log($a1e68f6f2d1224be$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $15f0bc38c7419bb4$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $15f0bc38c7419bb4$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $e23e8bb8c54ccb6f$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log($a1e68f6f2d1224be$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $9ca2ec03d999f85f$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $432efb3c08046c53$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        (0, $382eff120bb43d6f$export$e7390a03b70a6f2f)(this, integration, this._integrations);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $81e9f87da8658256$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $be27cfb68e15613c$export$d650323442802f6f)(env, (0, $be27cfb68e15613c$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $81e9f87da8658256$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $f1cf8dd6cc68658d$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        this._integrations = (0, $382eff120bb43d6f$export$51abed9797baa598)(this, this._options.integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $9ca2ec03d999f85f$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $432efb3c08046c53$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $9f8f0bc84d498322$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $93dcc91b82d1c710$export$2d67fb380bd11267)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            // If a trace context is not set on the event, we use the propagationContext set on the event to
            // generate a trace context. If the propagationContext does not have a dynamic sampling context, we
            // also generate one for it.
            const { propagationContext: propagationContext } = evt.sdkProcessingMetadata || {};
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $0f19d7480cf01213$export$366bad00d6815eed)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $34ae909229820d8f$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $a1e68f6f2d1224be$var$isTransactionEvent(event);
        const isError = $a1e68f6f2d1224be$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $432efb3c08046c53$export$78e43115b553f358)(new (0, $b2ffe92d6e817982$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        return this._prepareEvent(event, hint, scope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $b2ffe92d6e817982$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $a1e68f6f2d1224be$var$processBeforeSend(options, prepared, hint);
            return $a1e68f6f2d1224be$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                throw new (0, $b2ffe92d6e817982$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $b2ffe92d6e817982$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $b2ffe92d6e817982$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).error("Error while sending event:", reason);
        });
        else (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $a1e68f6f2d1224be$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $15f0bc38c7419bb4$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $15f0bc38c7419bb4$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $b2ffe92d6e817982$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $b2ffe92d6e817982$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $15f0bc38c7419bb4$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $b2ffe92d6e817982$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $a1e68f6f2d1224be$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($a1e68f6f2d1224be$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($a1e68f6f2d1224be$var$isTransactionEvent(event) && beforeSendTransaction) return beforeSendTransaction(event, hint);
    return event;
}
function $a1e68f6f2d1224be$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $a1e68f6f2d1224be$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $a1e68f6f2d1224be$export$9aac0b9f77928fbf(callback) {
    const client = (0, $fead0e8ca16cc636$export$6bb76d6eba7e258c)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $6c1ef7c81d39e631$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $a4e39c7e45099c0d$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $be27cfb68e15613c$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $086d9edb13339004$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $086d9edb13339004$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}





/**
 * This function creates an exception from a JavaScript Error
 */ function $4f960f6cc44628d8$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $4f960f6cc44628d8$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $4f960f6cc44628d8$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $4f960f6cc44628d8$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $fead0e8ca16cc636$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $15f0bc38c7419bb4$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $4f960f6cc44628d8$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $091fe0c9bd9da15b$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $4f960f6cc44628d8$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $4f960f6cc44628d8$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $4f960f6cc44628d8$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $4f960f6cc44628d8$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $4f960f6cc44628d8$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $4f960f6cc44628d8$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $4f960f6cc44628d8$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($4f960f6cc44628d8$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $4f960f6cc44628d8$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $4f960f6cc44628d8$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $4f960f6cc44628d8$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $e23e8bb8c54ccb6f$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $432efb3c08046c53$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $4f960f6cc44628d8$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $4f960f6cc44628d8$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $432efb3c08046c53$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $4f960f6cc44628d8$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $15f0bc38c7419bb4$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $4f960f6cc44628d8$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $15f0bc38c7419bb4$export$ef9e2056653f0c8e)(exception) || (0, $15f0bc38c7419bb4$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $4f960f6cc44628d8$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $15f0bc38c7419bb4$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $4f960f6cc44628d8$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $e23e8bb8c54ccb6f$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $15f0bc38c7419bb4$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $4f960f6cc44628d8$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $15f0bc38c7419bb4$export$53b83ca8eaab0383)(exception) || (0, $15f0bc38c7419bb4$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $4f960f6cc44628d8$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $e23e8bb8c54ccb6f$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $4f960f6cc44628d8$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $e23e8bb8c54ccb6f$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $e23e8bb8c54ccb6f$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $4f960f6cc44628d8$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $4f960f6cc44628d8$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $15f0bc38c7419bb4$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $4f960f6cc44628d8$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $380d67425f19a6e7$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $15f0bc38c7419bb4$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $15f0bc38c7419bb4$export$9671ea99bd126ace)(exception)) {
        const className = $4f960f6cc44628d8$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $4f960f6cc44628d8$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}




/**
 * Creates an envelope from a user feedback.
 */ function $a07bca341e41f083$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $f33780998a3a623d$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $a07bca341e41f083$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $be27cfb68e15613c$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $a07bca341e41f083$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $85eb3a2581faf765$export$1df9218a526d318d extends (0, $a1e68f6f2d1224be$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $086d9edb13339004$export$8ad33f488b1ab046)();
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: "sentry.javascript.browser",
            packages: [
                {
                    name: `${sdkSource}:@sentry/browser`,
                    version: (0, $cab9a602399ef8c5$export$31499a9cd224b78c)
                }
            ],
            version: (0, $cab9a602399ef8c5$export$31499a9cd224b78c)
        };
        super(options);
        if (options.sendClientReports && (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).document) (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $e96e526caeb721c7$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $4f960f6cc44628d8$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $4f960f6cc44628d8$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $a07bca341e41f083$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $6c1ef7c81d39e631$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $f33780998a3a623d$export$44d472fbb931a776)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}









/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $a1f0a03f17a163ec$var$INTEGRATION_NAME = "GlobalHandlers";
const $a1f0a03f17a163ec$var$globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $a1f0a03f17a163ec$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $a1f0a03f17a163ec$var$_installGlobalOnErrorHandler(client);
                $a1f0a03f17a163ec$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $a1f0a03f17a163ec$var$_installGlobalOnUnhandledRejectionHandler(client);
                $a1f0a03f17a163ec$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
/** Global handlers */ // eslint-disable-next-line deprecation/deprecation
const $a1f0a03f17a163ec$export$204155decbc90e5a = (0, $382eff120bb43d6f$export$afa219bf23651160)($a1f0a03f17a163ec$var$INTEGRATION_NAME, $a1f0a03f17a163ec$var$globalHandlersIntegration);
function $a1f0a03f17a163ec$var$_installGlobalOnErrorHandler(client) {
    (0, $16305507a650302d$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $a1f0a03f17a163ec$var$getOptions();
        if ((0, $fead0e8ca16cc636$export$6bb76d6eba7e258c)() !== client || (0, $e96e526caeb721c7$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $15f0bc38c7419bb4$export$844ec244b1367d54)(msg) ? $a1f0a03f17a163ec$var$_eventFromIncompleteOnError(msg, url, line, column) : $a1f0a03f17a163ec$var$_enhanceEventWithInitialFrame((0, $4f960f6cc44628d8$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $fead0e8ca16cc636$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $a1f0a03f17a163ec$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $450b32e1145ae417$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $a1f0a03f17a163ec$var$getOptions();
        if ((0, $fead0e8ca16cc636$export$6bb76d6eba7e258c)() !== client || (0, $e96e526caeb721c7$export$b79738ab10c590b2)()) return;
        const error = $a1f0a03f17a163ec$var$_getUnhandledRejectionError(e);
        const event = (0, $15f0bc38c7419bb4$export$c3825b437cbdea5c)(error) ? $a1f0a03f17a163ec$var$_eventFromRejectionWithPrimitive(error) : (0, $4f960f6cc44628d8$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $fead0e8ca16cc636$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $a1f0a03f17a163ec$var$_getUnhandledRejectionError(error) {
    if ((0, $15f0bc38c7419bb4$export$c3825b437cbdea5c)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) return e.reason;
        else if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $a1f0a03f17a163ec$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a1f0a03f17a163ec$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $15f0bc38c7419bb4$export$9f9636d330b71954)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $a1f0a03f17a163ec$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a1f0a03f17a163ec$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $15f0bc38c7419bb4$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $1406e1e4fc31c9ca$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $a1f0a03f17a163ec$var$globalHandlerLog(type) {
    (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $a1f0a03f17a163ec$var$getOptions() {
    const client = (0, $fead0e8ca16cc636$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}





const $43100f49af762fe1$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $43100f49af762fe1$var$INTEGRATION_NAME = "TryCatch";
const $43100f49af762fe1$var$browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $43100f49af762fe1$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $380d67425f19a6e7$export$9563e054e6f787fb)((0, $e96e526caeb721c7$export$56d8a8a25bd48b81), "setTimeout", $43100f49af762fe1$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $380d67425f19a6e7$export$9563e054e6f787fb)((0, $e96e526caeb721c7$export$56d8a8a25bd48b81), "setInterval", $43100f49af762fe1$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $380d67425f19a6e7$export$9563e054e6f787fb)((0, $e96e526caeb721c7$export$56d8a8a25bd48b81), "requestAnimationFrame", $43100f49af762fe1$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $e96e526caeb721c7$export$56d8a8a25bd48b81)) (0, $380d67425f19a6e7$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $43100f49af762fe1$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $43100f49af762fe1$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($43100f49af762fe1$var$_wrapEventTarget);
            }
        }
    };
};
/** Wrap timer functions and event targets to catch errors and provide better meta data */ // eslint-disable-next-line deprecation/deprecation
const $43100f49af762fe1$export$f1a018517668e6d3 = (0, $382eff120bb43d6f$export$afa219bf23651160)($43100f49af762fe1$var$INTEGRATION_NAME, $43100f49af762fe1$var$browserApiErrorsIntegration);
function $43100f49af762fe1$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $e96e526caeb721c7$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $65291a370105e130$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $43100f49af762fe1$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $e96e526caeb721c7$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $65291a370105e130$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $43100f49af762fe1$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $380d67425f19a6e7$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $65291a370105e130$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $380d67425f19a6e7$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $65291a370105e130$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $e96e526caeb721c7$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $43100f49af762fe1$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $e96e526caeb721c7$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $380d67425f19a6e7$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $e96e526caeb721c7$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $65291a370105e130$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $e96e526caeb721c7$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $65291a370105e130$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $380d67425f19a6e7$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}







const $d0b3b83fdc0d0356$var$WINDOW = (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1);
const $d0b3b83fdc0d0356$var$DEBOUNCE_DURATION = 1000;
let $d0b3b83fdc0d0356$var$debounceTimerID;
let $d0b3b83fdc0d0356$var$lastCapturedEventType;
let $d0b3b83fdc0d0356$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d0b3b83fdc0d0356$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $21ff179dbda73e8f$export$a4e09611e30da72e)(type, handler);
    (0, $21ff179dbda73e8f$export$e18d6c5462c01368)(type, $d0b3b83fdc0d0356$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $d0b3b83fdc0d0356$export$3014bbf0af0e1d4a() {
    if (!$d0b3b83fdc0d0356$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $21ff179dbda73e8f$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $d0b3b83fdc0d0356$var$makeDOMEventHandler(triggerDOMHandler, true);
    $d0b3b83fdc0d0356$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $d0b3b83fdc0d0356$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $d0b3b83fdc0d0356$var$WINDOW[target] && $d0b3b83fdc0d0356$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $380d67425f19a6e7$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $d0b3b83fdc0d0356$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $380d67425f19a6e7$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $d0b3b83fdc0d0356$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $d0b3b83fdc0d0356$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $d0b3b83fdc0d0356$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $d0b3b83fdc0d0356$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $d0b3b83fdc0d0356$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $d0b3b83fdc0d0356$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($d0b3b83fdc0d0356$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $380d67425f19a6e7$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $380d67425f19a6e7$export$e73679ffaf56810e)(target, "_sentryId", (0, $e23e8bb8c54ccb6f$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$d0b3b83fdc0d0356$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $d0b3b83fdc0d0356$var$lastCapturedEventType = event.type;
            $d0b3b83fdc0d0356$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($d0b3b83fdc0d0356$var$debounceTimerID);
        $d0b3b83fdc0d0356$var$debounceTimerID = $d0b3b83fdc0d0356$var$WINDOW.setTimeout(()=>{
            $d0b3b83fdc0d0356$var$lastCapturedEventTargetId = undefined;
            $d0b3b83fdc0d0356$var$lastCapturedEventType = undefined;
        }, $d0b3b83fdc0d0356$var$DEBOUNCE_DURATION);
    };
}
function $d0b3b83fdc0d0356$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d510e49262b04868$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $21ff179dbda73e8f$export$a4e09611e30da72e)(type, handler);
    (0, $21ff179dbda73e8f$export$e18d6c5462c01368)(type, $d510e49262b04868$var$instrumentConsole);
}
function $d510e49262b04868$var$instrumentConsole() {
    if (!("console" in (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1))) return;
    (0, $00cc87bc34693c04$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1).console)) return;
        (0, $380d67425f19a6e7$export$9563e054e6f787fb)((0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $00cc87bc34693c04$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $21ff179dbda73e8f$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $00cc87bc34693c04$export$77c4ce905194557b)[level];
                log && log.apply((0, $81e469fe9ab1c810$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $6da01ef7311e3201$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $6da01ef7311e3201$export$e01cef29b4327697(level) {
    return $6da01ef7311e3201$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $6da01ef7311e3201$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $6da01ef7311e3201$export$411d0ffdba845b6c.includes(level) ? level : "log";
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $d6e75a4fc5a20d5c$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $d6e75a4fc5a20d5c$var$INTEGRATION_NAME = "Breadcrumbs";
const $d6e75a4fc5a20d5c$var$breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $d6e75a4fc5a20d5c$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $d510e49262b04868$export$1d6e0d073f9e6723)($d6e75a4fc5a20d5c$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $d0b3b83fdc0d0356$export$5aeffd3db2cf9df7)($d6e75a4fc5a20d5c$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $0df962f0ceb7104b$export$26ace48dd54c9aea)($d6e75a4fc5a20d5c$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $efd9e6f08942efa4$export$f75d3c772c923df0)($d6e75a4fc5a20d5c$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $8e5e4ba8e6a66d1f$export$3f18c56c58114e75)($d6e75a4fc5a20d5c$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on("beforeSendEvent", $d6e75a4fc5a20d5c$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
/**
 * Default Breadcrumbs instrumentations
 */ // eslint-disable-next-line deprecation/deprecation
const $d6e75a4fc5a20d5c$export$2dc68d50d56fbbd = (0, $382eff120bb43d6f$export$afa219bf23651160)($d6e75a4fc5a20d5c$var$INTEGRATION_NAME, $d6e75a4fc5a20d5c$var$breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $d6e75a4fc5a20d5c$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $fead0e8ca16cc636$export$6bb76d6eba7e258c)() !== client) return;
        (0, $fead0e8ca16cc636$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $e23e8bb8c54ccb6f$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $d6e75a4fc5a20d5c$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $fead0e8ca16cc636$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $d6e75a4fc5a20d5c$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$d6e75a4fc5a20d5c$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$d6e75a4fc5a20d5c$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $d6e75a4fc5a20d5c$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $d6e75a4fc5a20d5c$var$_isEvent(event) ? event.target : event;
            target = (0, $1406e1e4fc31c9ca$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $1406e1e4fc31c9ca$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $fead0e8ca16cc636$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $d6e75a4fc5a20d5c$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $fead0e8ca16cc636$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $6da01ef7311e3201$export$d771ef054122c30a)(handlerData.level),
            message: (0, $6ead621f18d70699$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $6ead621f18d70699$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $fead0e8ca16cc636$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $d6e75a4fc5a20d5c$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $fead0e8ca16cc636$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $0df962f0ceb7104b$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $fead0e8ca16cc636$export$efda9a273d7a036d)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $d6e75a4fc5a20d5c$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $fead0e8ca16cc636$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $fead0e8ca16cc636$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $fead0e8ca16cc636$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $d6e75a4fc5a20d5c$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $fead0e8ca16cc636$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $12db4a4eadd18394$export$7a5253c0f62e0150)((0, $e96e526caeb721c7$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $12db4a4eadd18394$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $12db4a4eadd18394$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $fead0e8ca16cc636$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $d6e75a4fc5a20d5c$var$_isEvent(event) {
    return !!event && !!event.target;
}





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $6f4d989ea83489fa$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $15f0bc38c7419bb4$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $6f4d989ea83489fa$var$truncateAggregateExceptions($6f4d989ea83489fa$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $6f4d989ea83489fa$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    if ((0, $15f0bc38c7419bb4$export$49034edbe6b62415)(error[key], Error)) {
        $6f4d989ea83489fa$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $6f4d989ea83489fa$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $6f4d989ea83489fa$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $15f0bc38c7419bb4$export$49034edbe6b62415)(childError, Error)) {
            $6f4d989ea83489fa$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $6f4d989ea83489fa$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $6f4d989ea83489fa$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $6f4d989ea83489fa$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        is_exception_group: true,
        exception_id: exceptionId
    };
}
function $6f4d989ea83489fa$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $6f4d989ea83489fa$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $6ead621f18d70699$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $778a48669d43290a$var$DEFAULT_KEY = "cause";
const $778a48669d43290a$var$DEFAULT_LIMIT = 5;
const $778a48669d43290a$var$INTEGRATION_NAME = "LinkedErrors";
const $778a48669d43290a$var$linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $778a48669d43290a$var$DEFAULT_LIMIT;
    const key = options.key || $778a48669d43290a$var$DEFAULT_KEY;
    return {
        name: $778a48669d43290a$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $6f4d989ea83489fa$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $4f960f6cc44628d8$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
/** Aggregrate linked errors in an event. */ // eslint-disable-next-line deprecation/deprecation
const $778a48669d43290a$export$8d1e60aaf616fb4f = (0, $382eff120bb43d6f$export$afa219bf23651160)($778a48669d43290a$var$INTEGRATION_NAME, $778a48669d43290a$var$linkedErrorsIntegration);




const $05e2deee2b8d5352$var$INTEGRATION_NAME = "HttpContext";
const $05e2deee2b8d5352$var$httpContextIntegration = ()=>{
    return {
        name: $05e2deee2b8d5352$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $e96e526caeb721c7$export$56d8a8a25bd48b81).navigator && !(0, $e96e526caeb721c7$export$56d8a8a25bd48b81).location && !(0, $e96e526caeb721c7$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).location && (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
/** HttpContext integration collects information about HTTP request headers */ // eslint-disable-next-line deprecation/deprecation
const $05e2deee2b8d5352$export$5d2ee9a544b09a94 = (0, $382eff120bb43d6f$export$afa219bf23651160)($05e2deee2b8d5352$var$INTEGRATION_NAME, $05e2deee2b8d5352$var$httpContextIntegration);





const $797779b5f1cfa49f$var$INTEGRATION_NAME = "Dedupe";
const $797779b5f1cfa49f$var$dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $797779b5f1cfa49f$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($797779b5f1cfa49f$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/** Deduplication filter */ // eslint-disable-next-line deprecation/deprecation
const $797779b5f1cfa49f$export$688d98c249d31ad3 = (0, $382eff120bb43d6f$export$afa219bf23651160)($797779b5f1cfa49f$var$INTEGRATION_NAME, $797779b5f1cfa49f$var$dedupeIntegration);
function $797779b5f1cfa49f$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($797779b5f1cfa49f$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($797779b5f1cfa49f$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $797779b5f1cfa49f$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$797779b5f1cfa49f$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$797779b5f1cfa49f$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $797779b5f1cfa49f$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $797779b5f1cfa49f$var$_getExceptionFromEvent(previousEvent);
    const currentException = $797779b5f1cfa49f$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$797779b5f1cfa49f$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$797779b5f1cfa49f$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $797779b5f1cfa49f$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $797779b5f1cfa49f$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $797779b5f1cfa49f$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $797779b5f1cfa49f$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $797779b5f1cfa49f$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $797779b5f1cfa49f$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}



// global reference to slice
const $ff0ce0770dc8fe89$var$UNKNOWN_FUNCTION = "?";
const $ff0ce0770dc8fe89$var$OPERA10_PRIORITY = 10;
const $ff0ce0770dc8fe89$var$OPERA11_PRIORITY = 20;
const $ff0ce0770dc8fe89$var$CHROME_PRIORITY = 30;
const $ff0ce0770dc8fe89$var$WINJS_PRIORITY = 40;
const $ff0ce0770dc8fe89$var$GECKO_PRIORITY = 50;
function $ff0ce0770dc8fe89$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $ff0ce0770dc8fe89$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $ff0ce0770dc8fe89$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $ff0ce0770dc8fe89$var$chrome = (line)=>{
    const parts = $ff0ce0770dc8fe89$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $ff0ce0770dc8fe89$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $ff0ce0770dc8fe89$var$extractSafariExtensionDetails(parts[1] || $ff0ce0770dc8fe89$var$UNKNOWN_FUNCTION, parts[2]);
        return $ff0ce0770dc8fe89$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $ff0ce0770dc8fe89$export$263a749fff749872 = [
    $ff0ce0770dc8fe89$var$CHROME_PRIORITY,
    $ff0ce0770dc8fe89$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $ff0ce0770dc8fe89$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $ff0ce0770dc8fe89$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $ff0ce0770dc8fe89$var$gecko = (line)=>{
    const parts = $ff0ce0770dc8fe89$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $ff0ce0770dc8fe89$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $ff0ce0770dc8fe89$var$UNKNOWN_FUNCTION;
        [func, filename] = $ff0ce0770dc8fe89$var$extractSafariExtensionDetails(func, filename);
        return $ff0ce0770dc8fe89$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $ff0ce0770dc8fe89$export$cdba47a5dd2804d = [
    $ff0ce0770dc8fe89$var$GECKO_PRIORITY,
    $ff0ce0770dc8fe89$var$gecko
];
const $ff0ce0770dc8fe89$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $ff0ce0770dc8fe89$var$winjs = (line)=>{
    const parts = $ff0ce0770dc8fe89$var$winjsRegex.exec(line);
    return parts ? $ff0ce0770dc8fe89$var$createFrame(parts[2], parts[1] || $ff0ce0770dc8fe89$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $ff0ce0770dc8fe89$export$179460296da408e8 = [
    $ff0ce0770dc8fe89$var$WINJS_PRIORITY,
    $ff0ce0770dc8fe89$var$winjs
];
const $ff0ce0770dc8fe89$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $ff0ce0770dc8fe89$var$opera10 = (line)=>{
    const parts = $ff0ce0770dc8fe89$var$opera10Regex.exec(line);
    return parts ? $ff0ce0770dc8fe89$var$createFrame(parts[2], parts[3] || $ff0ce0770dc8fe89$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $ff0ce0770dc8fe89$export$f892b52c880ffc7a = [
    $ff0ce0770dc8fe89$var$OPERA10_PRIORITY,
    $ff0ce0770dc8fe89$var$opera10
];
const $ff0ce0770dc8fe89$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $ff0ce0770dc8fe89$var$opera11 = (line)=>{
    const parts = $ff0ce0770dc8fe89$var$opera11Regex.exec(line);
    return parts ? $ff0ce0770dc8fe89$var$createFrame(parts[5], parts[3] || parts[4] || $ff0ce0770dc8fe89$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $ff0ce0770dc8fe89$export$af11af13f09fb0dc = [
    $ff0ce0770dc8fe89$var$OPERA11_PRIORITY,
    $ff0ce0770dc8fe89$var$opera11
];
const $ff0ce0770dc8fe89$export$7197c0fe6554c079 = [
    $ff0ce0770dc8fe89$export$263a749fff749872,
    $ff0ce0770dc8fe89$export$cdba47a5dd2804d,
    $ff0ce0770dc8fe89$export$179460296da408e8
];
const $ff0ce0770dc8fe89$export$2b2b997d81bf3907 = (0, $65291a370105e130$export$a5739666fb2d03d4)(...$ff0ce0770dc8fe89$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $ff0ce0770dc8fe89$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $ff0ce0770dc8fe89$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $94f73e7ba54c3793$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $94f73e7ba54c3793$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $94f73e7ba54c3793$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $94f73e7ba54c3793$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $94f73e7ba54c3793$export$6c91fec22056810a(limits, category, now = Date.now()) {
    return $94f73e7ba54c3793$export$b89fc7b2e4c799e7(limits, category) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $94f73e7ba54c3793$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories] = limit.split(":", 2);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";"))updatedRateLimits[category] = now + delay;
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $94f73e7ba54c3793$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $2fcaf108d1ff7a78$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $432efb3c08046c53$export$78e43115b553f358)(new (0, $b2ffe92d6e817982$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $432efb3c08046c53$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $432efb3c08046c53$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $fff2ef227d13dca4$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $fff2ef227d13dca4$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $2fcaf108d1ff7a78$export$85a4f67f852183e6)(options.bufferSize || $fff2ef227d13dca4$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $be27cfb68e15613c$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const envelopeItemDataCategory = (0, $be27cfb68e15613c$export$b11169581eeaf237)(type);
            if ((0, $94f73e7ba54c3793$export$6c91fec22056810a)(rateLimits, envelopeItemDataCategory)) {
                const event = $fff2ef227d13dca4$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", envelopeItemDataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $432efb3c08046c53$export$1fda8aa4d135f8aa)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $be27cfb68e15613c$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $be27cfb68e15613c$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $fff2ef227d13dca4$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $be27cfb68e15613c$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $be27cfb68e15613c$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $94f73e7ba54c3793$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $b2ffe92d6e817982$export$5949942ba2a7c0e2)) {
                (0, $34ae909229820d8f$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $432efb3c08046c53$export$1fda8aa4d135f8aa)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $fff2ef227d13dca4$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}






let $997d79d3c84318e0$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $997d79d3c84318e0$export$8be2119ce08e3379() {
    if ($997d79d3c84318e0$var$cachedFetchImpl) return $997d79d3c84318e0$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $97960cd9a3a7b583$export$18cf36ed71d733e7)((0, $e96e526caeb721c7$export$56d8a8a25bd48b81).fetch)) return $997d79d3c84318e0$var$cachedFetchImpl = (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).fetch.bind((0, $e96e526caeb721c7$export$56d8a8a25bd48b81));
    const document = (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $997d79d3c84318e0$var$cachedFetchImpl = fetchImpl.bind((0, $e96e526caeb721c7$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $997d79d3c84318e0$export$d499686d2dd738c6() {
    $997d79d3c84318e0$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $50a8d241af9264d5$export$b2311068c46d7cc8(options, nativeFetch = (0, $997d79d3c84318e0$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $997d79d3c84318e0$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $432efb3c08046c53$export$78e43115b553f358)(e);
        }
    }
    return (0, $fff2ef227d13dca4$export$d09f50d9ab7f7b69)(options, makeRequest);
}




/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $186b18ad4178f77d$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $186b18ad4178f77d$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $432efb3c08046c53$export$6f292d4960313241)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $186b18ad4178f77d$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $fff2ef227d13dca4$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/* eslint-disable deprecation/deprecation */ const $0a858927878a7c64$export$5ef831fccfce35e5 = [
    new (0, $821a0b33ca4a8e85$export$2ffbb5359dcc6be4)(),
    new (0, $61af8f18dd91d870$export$da4704525c20ae79)(),
    new (0, $43100f49af762fe1$export$f1a018517668e6d3)(),
    new (0, $d6e75a4fc5a20d5c$export$2dc68d50d56fbbd)(),
    new (0, $a1f0a03f17a163ec$export$204155decbc90e5a)(),
    new (0, $778a48669d43290a$export$8d1e60aaf616fb4f)(),
    new (0, $797779b5f1cfa49f$export$688d98c249d31ad3)(),
    new (0, $05e2deee2b8d5352$export$5d2ee9a544b09a94)()
];
/* eslint-enable deprecation/deprecation */ /**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $0a858927878a7c64$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $0a858927878a7c64$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $e96e526caeb721c7$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $65291a370105e130$export$1d5cf88b347146d4)(options.stackParser || (0, $ff0ce0770dc8fe89$export$2b2b997d81bf3907)),
        integrations: (0, $382eff120bb43d6f$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $97960cd9a3a7b583$export$edf3cb81fd7d2a3e)() ? (0, $50a8d241af9264d5$export$b2311068c46d7cc8) : (0, $186b18ad4178f77d$export$5e1441cee30d5a39))
    };
    (0, $b6a0c61fb779964d$export$5333c3f1c58d9bc1)((0, $85eb3a2581faf765$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $0a858927878a7c64$var$startSessionTracking();
}
const $0a858927878a7c64$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $9f8f0bc84d498322$export$a07cdf6544bbd7c)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $e96e526caeb721c7$export$56d8a8a25bd48b81).document) {
        (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    // TODO(v8): Remove this entire if statement. `eventId` will be a required option.
    // eslint-disable-next-line deprecation/deprecation
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $609b0bed1a3d24e1$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).document.head || (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $0a858927878a7c64$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $0a858927878a7c64$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0a858927878a7c64$export$4997ffc0176396a6(fn) {
    return (0, $e96e526caeb721c7$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $0a858927878a7c64$var$startSessionTracking() {
    if (typeof (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).document === "undefined") {
        (0, $ade9b105e5b71e91$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $fead0e8ca16cc636$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $fead0e8ca16cc636$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $8e5e4ba8e6a66d1f$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $fead0e8ca16cc636$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $fead0e8ca16cc636$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $0a858927878a7c64$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $fead0e8ca16cc636$export$6bb76d6eba7e258c)();
    if (client) client.captureUserFeedback(feedback);
}


/**
 * Inits the React SDK
 */ function $eef6187dab2bf3b9$export$2cd8252107eb640b(options) {
    const opts = {
        _metadata: {},
        ...options
    };
    opts._metadata.sdk = opts._metadata.sdk || {
        name: "sentry.javascript.react",
        packages: [
            {
                name: "npm:@sentry/react",
                version: (0, $cab9a602399ef8c5$export$31499a9cd224b78c)
            }
        ],
        version: (0, $cab9a602399ef8c5$export$31499a9cd224b78c)
    };
    (0, $0a858927878a7c64$export$2cd8252107eb640b)(opts);
}









































var $53e5ed32560fa1ae$exports = {};

$parcel$export($53e5ed32560fa1ae$exports, "FunctionToString", function () { return $61af8f18dd91d870$export$da4704525c20ae79; });
$parcel$export($53e5ed32560fa1ae$exports, "InboundFilters", function () { return $821a0b33ca4a8e85$export$2ffbb5359dcc6be4; });
$parcel$export($53e5ed32560fa1ae$exports, "LinkedErrors", function () { return $c81d4f21825a8cbc$export$8d1e60aaf616fb4f; });






/**
 * Extracts stack frames from the error.stack string
 */ function $932309d33885aa4c$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $932309d33885aa4c$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    const frames = $932309d33885aa4c$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $932309d33885aa4c$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    else // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    return `Object captured as exception with keys: ${(0, $380d67425f19a6e7$export$b0244d5063c0b61b)(exception)}`;
}
/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */ function $932309d33885aa4c$export$9dd56ed1ef0c3420(getHubOrClient, stackParser, exception, hint) {
    const client = typeof getHubOrClient === "function" ? getHubOrClient().getClient() : getHubOrClient;
    let ex = exception;
    const providedMechanism = hint && hint.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    let extras;
    if (!(0, $15f0bc38c7419bb4$export$e6127cc7fe7395c3)(exception)) {
        if ((0, $15f0bc38c7419bb4$export$53b83ca8eaab0383)(exception)) {
            const normalizeDepth = client && client.getOptions().normalizeDepth;
            extras = {
                ["__serialized__"]: (0, $091fe0c9bd9da15b$export$23fbbb20bed71033)(exception, normalizeDepth)
            };
            const message = $932309d33885aa4c$var$getMessageForObject(exception);
            ex = hint && hint.syntheticException || new Error(message);
            ex.message = message;
        } else {
            // This handles when someone does: `throw "something awesome";`
            // We use synthesized Error here so we can extract a (rough) stack trace.
            ex = hint && hint.syntheticException || new Error(exception);
            ex.message = exception;
        }
        mechanism.synthetic = true;
    }
    const event = {
        exception: {
            values: [
                $932309d33885aa4c$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $e23e8bb8c54ccb6f$export$f26508487bf83ee7)(event, undefined, undefined);
    (0, $e23e8bb8c54ccb6f$export$c69a9a0313b03bb1)(event, mechanism);
    return {
        ...event,
        event_id: hint && hint.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $932309d33885aa4c$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint && hint.event_id,
        level: level
    };
    if (attachStacktrace && hint && hint.syntheticException) {
        const frames = $932309d33885aa4c$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $15f0bc38c7419bb4$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}



const $c81d4f21825a8cbc$var$DEFAULT_KEY = "cause";
const $c81d4f21825a8cbc$var$DEFAULT_LIMIT = 5;
const $c81d4f21825a8cbc$var$INTEGRATION_NAME = "LinkedErrors";
const $c81d4f21825a8cbc$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $c81d4f21825a8cbc$var$DEFAULT_LIMIT;
    const key = options.key || $c81d4f21825a8cbc$var$DEFAULT_KEY;
    return {
        name: $c81d4f21825a8cbc$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $6f4d989ea83489fa$export$b91c38ed7d8ae9b2)((0, $932309d33885aa4c$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $c81d4f21825a8cbc$export$ebabb00eb7f3a395 = (0, $382eff120bb43d6f$export$2323046b9414659f)($c81d4f21825a8cbc$var$_linkedErrorsIntegration);
/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $c81d4f21825a8cbc$export$8d1e60aaf616fb4f = (0, $382eff120bb43d6f$export$afa219bf23651160)($c81d4f21825a8cbc$var$INTEGRATION_NAME, $c81d4f21825a8cbc$export$ebabb00eb7f3a395);


 /* eslint-disable deprecation/deprecation */ 


/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $a6ed0f822d9c338e$export$99d02219d259eb94 = $53e5ed32560fa1ae$exports;










var $5c390124dde4c214$exports = {};

$parcel$export($5c390124dde4c214$exports, "GlobalHandlers", function () { return $a1f0a03f17a163ec$export$204155decbc90e5a; });
$parcel$export($5c390124dde4c214$exports, "TryCatch", function () { return $43100f49af762fe1$export$f1a018517668e6d3; });
$parcel$export($5c390124dde4c214$exports, "Breadcrumbs", function () { return $d6e75a4fc5a20d5c$export$2dc68d50d56fbbd; });
$parcel$export($5c390124dde4c214$exports, "LinkedErrors", function () { return $778a48669d43290a$export$8d1e60aaf616fb4f; });
$parcel$export($5c390124dde4c214$exports, "HttpContext", function () { return $05e2deee2b8d5352$export$5d2ee9a544b09a94; });
$parcel$export($5c390124dde4c214$exports, "Dedupe", function () { return $797779b5f1cfa49f$export$688d98c249d31ad3; });





















let $2f3707c4f7ec7ddc$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
if ((0, $e96e526caeb721c7$export$56d8a8a25bd48b81).Sentry && (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).Sentry.Integrations) $2f3707c4f7ec7ddc$var$windowIntegrations = (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).Sentry.Integrations;
const $2f3707c4f7ec7ddc$export$99d02219d259eb94 = {
    ...$2f3707c4f7ec7ddc$var$windowIntegrations,
    // eslint-disable-next-line deprecation/deprecation
    ...(0, $a6ed0f822d9c338e$export$99d02219d259eb94),
    ...$5c390124dde4c214$exports
};




var $732263a4f5417bca$exports = {};
"use strict";
var $c1125ce14f41c46e$exports = {};
"use strict";

$c1125ce14f41c46e$exports = (parcelRequire("2yL8S"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $732263a4f5417bca$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $732263a4f5417bca$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $732263a4f5417bca$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $732263a4f5417bca$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $732263a4f5417bca$var$TYPE_STATICS = {};
$732263a4f5417bca$var$TYPE_STATICS[$c1125ce14f41c46e$exports.ForwardRef] = $732263a4f5417bca$var$FORWARD_REF_STATICS;
$732263a4f5417bca$var$TYPE_STATICS[$c1125ce14f41c46e$exports.Memo] = $732263a4f5417bca$var$MEMO_STATICS;
function $732263a4f5417bca$var$getStatics(component) {
    // React v16.11 and below
    if ($c1125ce14f41c46e$exports.isMemo(component)) return $732263a4f5417bca$var$MEMO_STATICS;
     // React v16.12 and above
    return $732263a4f5417bca$var$TYPE_STATICS[component["$$typeof"]] || $732263a4f5417bca$var$REACT_STATICS;
}
var $732263a4f5417bca$var$defineProperty = Object.defineProperty;
var $732263a4f5417bca$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $732263a4f5417bca$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $732263a4f5417bca$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $732263a4f5417bca$var$getPrototypeOf = Object.getPrototypeOf;
var $732263a4f5417bca$var$objectPrototype = Object.prototype;
function $732263a4f5417bca$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($732263a4f5417bca$var$objectPrototype) {
            var inheritedComponent = $732263a4f5417bca$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $732263a4f5417bca$var$objectPrototype) $732263a4f5417bca$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $732263a4f5417bca$var$getOwnPropertyNames(sourceComponent);
        if ($732263a4f5417bca$var$getOwnPropertySymbols) keys = keys.concat($732263a4f5417bca$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $732263a4f5417bca$var$getStatics(targetComponent);
        var sourceStatics = $732263a4f5417bca$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$732263a4f5417bca$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $732263a4f5417bca$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $732263a4f5417bca$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$732263a4f5417bca$exports = $732263a4f5417bca$var$hoistNonReactStatics;



var $9nZCP = parcelRequire("9nZCP");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $fe9fb5a3d50e8fd9$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


const $466fe0467b5e5168$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouterv6.tsx"; // Inspired from Donnie McNeal's solution:
let $466fe0467b5e5168$var$activeTransaction;
let $466fe0467b5e5168$var$_useEffect;
let $466fe0467b5e5168$var$_useLocation;
let $466fe0467b5e5168$var$_useNavigationType;
let $466fe0467b5e5168$var$_createRoutesFromChildren;
let $466fe0467b5e5168$var$_matchRoutes;
let $466fe0467b5e5168$var$_customStartTransaction;
let $466fe0467b5e5168$var$_startTransactionOnLocationChange;
const $466fe0467b5e5168$var$SENTRY_TAGS = {
    "routing.instrumentation": "react-router-v6"
};
function $466fe0467b5e5168$export$e6e76890c5208db1(useEffect, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes) {
    return (customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true)=>{
        const initPathName = (0, $e96e526caeb721c7$export$56d8a8a25bd48b81) && (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).location && (0, $e96e526caeb721c7$export$56d8a8a25bd48b81).location.pathname;
        if (startTransactionOnPageLoad && initPathName) $466fe0467b5e5168$var$activeTransaction = customStartTransaction({
            name: initPathName,
            op: "pageload",
            origin: "auto.pageload.react.reactrouterv6",
            tags: $466fe0467b5e5168$var$SENTRY_TAGS,
            metadata: {
                source: "url"
            }
        });
        $466fe0467b5e5168$var$_useEffect = useEffect;
        $466fe0467b5e5168$var$_useLocation = useLocation;
        $466fe0467b5e5168$var$_useNavigationType = useNavigationType;
        $466fe0467b5e5168$var$_matchRoutes = matchRoutes;
        $466fe0467b5e5168$var$_createRoutesFromChildren = createRoutesFromChildren;
        $466fe0467b5e5168$var$_customStartTransaction = customStartTransaction;
        $466fe0467b5e5168$var$_startTransactionOnLocationChange = startTransactionOnLocationChange;
    };
}
function $466fe0467b5e5168$var$getNormalizedName(routes, location, branches, basename = "") {
    if (!routes || routes.length === 0) return [
        location.pathname,
        "url"
    ];
    let pathBuilder = "";
    if (branches) // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let x = 0; x < branches.length; x++){
        const branch = branches[x];
        const route = branch.route;
        if (route) {
            // Early return if index route
            if (route.index) return [
                branch.pathname,
                "route"
            ];
            const path = route.path;
            if (path) {
                const newPath = path[0] === "/" || pathBuilder[pathBuilder.length - 1] === "/" ? path : `/${path}`;
                pathBuilder += newPath;
                if (basename + branch.pathname === location.pathname) {
                    if (// If the route defined on the element is something like
                    // <Route path="/stores/:storeId/products/:productId" element={<div>Product</div>} />
                    // We should check against the branch.pathname for the number of / seperators
                    (0, $12db4a4eadd18394$export$69dd85280a8d374c)(pathBuilder) !== (0, $12db4a4eadd18394$export$69dd85280a8d374c)(branch.pathname) && // We should not count wildcard operators in the url segments calculation
                    pathBuilder.slice(-2) !== "/*") return [
                        basename + newPath,
                        "route"
                    ];
                    return [
                        basename + pathBuilder,
                        "route"
                    ];
                }
            }
        }
    }
    return [
        location.pathname,
        "url"
    ];
}
function $466fe0467b5e5168$var$updatePageloadTransaction(location, routes, matches, basename) {
    const branches = Array.isArray(matches) ? matches : $466fe0467b5e5168$var$_matchRoutes(routes, location, basename);
    if ($466fe0467b5e5168$var$activeTransaction && branches) {
        const [name, source] = $466fe0467b5e5168$var$getNormalizedName(routes, location, branches, basename);
        $466fe0467b5e5168$var$activeTransaction.updateName(name);
        $466fe0467b5e5168$var$activeTransaction.setAttribute((0, $ef6d4d4437d520f6$export$d7a7d984b0791405), source);
    }
}
function $466fe0467b5e5168$var$handleNavigation(location, routes, navigationType, matches, basename) {
    const branches = Array.isArray(matches) ? matches : $466fe0467b5e5168$var$_matchRoutes(routes, location, basename);
    if ($466fe0467b5e5168$var$_startTransactionOnLocationChange && (navigationType === "PUSH" || navigationType === "POP") && branches) {
        if ($466fe0467b5e5168$var$activeTransaction) $466fe0467b5e5168$var$activeTransaction.end();
        const [name, source] = $466fe0467b5e5168$var$getNormalizedName(routes, location, branches, basename);
        $466fe0467b5e5168$var$activeTransaction = $466fe0467b5e5168$var$_customStartTransaction({
            name: name,
            op: "navigation",
            origin: "auto.navigation.react.reactrouterv6",
            tags: $466fe0467b5e5168$var$SENTRY_TAGS,
            metadata: {
                source: source
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $466fe0467b5e5168$export$c6111e8561a02a8b(Routes) {
    if (!$466fe0467b5e5168$var$_useEffect || !$466fe0467b5e5168$var$_useLocation || !$466fe0467b5e5168$var$_useNavigationType || !$466fe0467b5e5168$var$_createRoutesFromChildren || !$466fe0467b5e5168$var$_matchRoutes || !$466fe0467b5e5168$var$_customStartTransaction) {
        (0, $fe9fb5a3d50e8fd9$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn(`reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.
      useEffect: ${$466fe0467b5e5168$var$_useEffect}. useLocation: ${$466fe0467b5e5168$var$_useLocation}. useNavigationType: ${$466fe0467b5e5168$var$_useNavigationType}.
      createRoutesFromChildren: ${$466fe0467b5e5168$var$_createRoutesFromChildren}. matchRoutes: ${$466fe0467b5e5168$var$_matchRoutes}. customStartTransaction: ${$466fe0467b5e5168$var$_customStartTransaction}.`);
        return Routes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const location = $466fe0467b5e5168$var$_useLocation();
        const navigationType = $466fe0467b5e5168$var$_useNavigationType();
        $466fe0467b5e5168$var$_useEffect(()=>{
            const routes = $466fe0467b5e5168$var$_createRoutesFromChildren(props.children);
            if (isMountRenderPass) {
                $466fe0467b5e5168$var$updatePageloadTransaction(location, routes);
                isMountRenderPass = false;
            } else $466fe0467b5e5168$var$handleNavigation(location, routes, navigationType);
        }, // `props.children` is purpusely not included in the dependency array, because we do not want to re-run this effect
        // when the children change. We only want to start transactions when the location or navigation type change.
        [
            location,
            navigationType
        ]);
        // @ts-expect-error Setting more specific React Component typing for `R` generic above
        // will break advanced type inference done by react router params
        return $9nZCP.createElement(Routes, {
            ...props,
            __self: this,
            __source: {
                fileName: $466fe0467b5e5168$var$_jsxFileName,
                lineNumber: 213
            }
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($732263a4f5417bca$exports)))(SentryRoutes, Routes);
    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params
    return SentryRoutes;
}
function $466fe0467b5e5168$export$1f41b3e298c8040f(origUseRoutes) {
    if (!$466fe0467b5e5168$var$_useEffect || !$466fe0467b5e5168$var$_useLocation || !$466fe0467b5e5168$var$_useNavigationType || !$466fe0467b5e5168$var$_matchRoutes || !$466fe0467b5e5168$var$_customStartTransaction) {
        (0, $fe9fb5a3d50e8fd9$export$16a28057038b10ef) && (0, $00cc87bc34693c04$export$af88d00dbe7f521).warn("reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.");
        return origUseRoutes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const { routes: routes, locationArg: locationArg } = props;
        const Routes = origUseRoutes(routes, locationArg);
        const location = $466fe0467b5e5168$var$_useLocation();
        const navigationType = $466fe0467b5e5168$var$_useNavigationType();
        // A value with stable identity to either pick `locationArg` if available or `location` if not
        const stableLocationParam = typeof locationArg === "string" || locationArg && locationArg.pathname ? locationArg : location;
        $466fe0467b5e5168$var$_useEffect(()=>{
            const normalizedLocation = typeof stableLocationParam === "string" ? {
                pathname: stableLocationParam
            } : stableLocationParam;
            if (isMountRenderPass) {
                $466fe0467b5e5168$var$updatePageloadTransaction(normalizedLocation, routes);
                isMountRenderPass = false;
            } else $466fe0467b5e5168$var$handleNavigation(normalizedLocation, routes, navigationType);
        }, [
            navigationType,
            stableLocationParam
        ]);
        return Routes;
    };
    // eslint-disable-next-line react/display-name
    return (routes, locationArg)=>{
        return $9nZCP.createElement(SentryRoutes, {
            routes: routes,
            locationArg: locationArg,
            __self: this,
            __source: {
                fileName: $466fe0467b5e5168$var$_jsxFileName,
                lineNumber: 270
            }
        });
    };
}
function $466fe0467b5e5168$export$7f4c656bd7ebbb6b(createRouterFunction) {
    // `opts` for createBrowserHistory and createMemoryHistory are different, but also not relevant for us at the moment.
    // `basename` is the only option that is relevant for us, and it is the same for all.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(routes, opts) {
        const router = createRouterFunction(routes, opts);
        const basename = opts && opts.basename;
        // The initial load ends when `createBrowserRouter` is called.
        // This is the earliest convenient time to update the transaction name.
        // Callbacks to `router.subscribe` are not called for the initial load.
        if (router.state.historyAction === "POP" && $466fe0467b5e5168$var$activeTransaction) $466fe0467b5e5168$var$updatePageloadTransaction(router.state.location, routes, undefined, basename);
        router.subscribe((state)=>{
            const location = state.location;
            if ($466fe0467b5e5168$var$_startTransactionOnLocationChange && (state.historyAction === "PUSH" || state.historyAction === "POP") && $466fe0467b5e5168$var$activeTransaction) $466fe0467b5e5168$var$handleNavigation(location, routes, state.historyAction, undefined, basename);
        });
        return router;
    };
}


/**
 * React Router DOM v6.21.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $9nZCP = parcelRequire("9nZCP");



function $544fc37a064f4916$var$_extends() {
    $544fc37a064f4916$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $544fc37a064f4916$var$_extends.apply(this, arguments);
}
function $544fc37a064f4916$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $544fc37a064f4916$var$defaultMethod = "get";
const $544fc37a064f4916$var$defaultEncType = "application/x-www-form-urlencoded";
function $544fc37a064f4916$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $544fc37a064f4916$var$isButtonElement(object) {
    return $544fc37a064f4916$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $544fc37a064f4916$var$isFormElement(object) {
    return $544fc37a064f4916$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $544fc37a064f4916$var$isInputElement(object) {
    return $544fc37a064f4916$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $544fc37a064f4916$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $544fc37a064f4916$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$544fc37a064f4916$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $544fc37a064f4916$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $544fc37a064f4916$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $544fc37a064f4916$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $544fc37a064f4916$var$_formDataSupportsSubmitter = null;
function $544fc37a064f4916$var$isFormDataSubmitterSupported() {
    if ($544fc37a064f4916$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $544fc37a064f4916$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $544fc37a064f4916$var$_formDataSupportsSubmitter = true;
    }
    return $544fc37a064f4916$var$_formDataSupportsSubmitter;
}
const $544fc37a064f4916$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $544fc37a064f4916$var$getFormEncType(encType) {
    if (encType != null && !$544fc37a064f4916$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $544fc37a064f4916$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($544fc37a064f4916$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $6ab4d96c61a6f348$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $544fc37a064f4916$var$defaultMethod;
        encType = $544fc37a064f4916$var$getFormEncType(target.getAttribute("enctype")) || $544fc37a064f4916$var$defaultEncType;
        formData = new FormData(target);
    } else if ($544fc37a064f4916$var$isButtonElement(target) || $544fc37a064f4916$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $6ab4d96c61a6f348$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $544fc37a064f4916$var$defaultMethod;
        encType = $544fc37a064f4916$var$getFormEncType(target.getAttribute("formenctype")) || $544fc37a064f4916$var$getFormEncType(form.getAttribute("enctype")) || $544fc37a064f4916$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$544fc37a064f4916$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($544fc37a064f4916$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $544fc37a064f4916$var$defaultMethod;
        action = null;
        encType = $544fc37a064f4916$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $544fc37a064f4916$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $544fc37a064f4916$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $544fc37a064f4916$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $544fc37a064f4916$export$1f3f55432a00e06d(routes, opts) {
    return (0, $6ab4d96c61a6f348$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $544fc37a064f4916$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $6ab4d96c61a6f348$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $544fc37a064f4916$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $cb6812e0fa529c57$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $544fc37a064f4916$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $6ab4d96c61a6f348$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $544fc37a064f4916$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $6ab4d96c61a6f348$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $544fc37a064f4916$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $cb6812e0fa529c57$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $544fc37a064f4916$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $544fc37a064f4916$var$_extends({}, state, {
        errors: $544fc37a064f4916$var$deserializeErrors(state.errors)
    });
    return state;
}
function $544fc37a064f4916$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $6ab4d96c61a6f348$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $544fc37a064f4916$export$7ad602f0e94e62d1 = /*#__PURE__*/ $9nZCP.createContext({
    isTransitioning: false
});
const $544fc37a064f4916$export$148fd98d095596d4 = /*#__PURE__*/ $9nZCP.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $544fc37a064f4916$var$START_TRANSITION = "startTransition";
const $544fc37a064f4916$var$startTransitionImpl = $9nZCP[$544fc37a064f4916$var$START_TRANSITION];
const $544fc37a064f4916$var$FLUSH_SYNC = "flushSync";
const $544fc37a064f4916$var$flushSyncImpl = $06928105ffc753ea$exports[$544fc37a064f4916$var$FLUSH_SYNC];
const $544fc37a064f4916$var$USE_ID = "useId";
const $544fc37a064f4916$var$useIdImpl = $9nZCP[$544fc37a064f4916$var$USE_ID];
function $544fc37a064f4916$var$startTransitionSafe(cb) {
    if ($544fc37a064f4916$var$startTransitionImpl) $544fc37a064f4916$var$startTransitionImpl(cb);
    else cb();
}
function $544fc37a064f4916$var$flushSyncSafe(cb) {
    if ($544fc37a064f4916$var$flushSyncImpl) $544fc37a064f4916$var$flushSyncImpl(cb);
    else cb();
}
class $544fc37a064f4916$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $544fc37a064f4916$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $9nZCP.useState(router.state);
    let [pendingState, setPendingState] = $9nZCP.useState();
    let [vtContext, setVtContext] = $9nZCP.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $9nZCP.useState();
    let [transition, setTransition] = $9nZCP.useState();
    let [interruption, setInterruption] = $9nZCP.useState();
    let fetcherData = $9nZCP.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $9nZCP.useCallback((cb)=>{
        if (v7_startTransition) $544fc37a064f4916$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $9nZCP.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $544fc37a064f4916$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $544fc37a064f4916$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $544fc37a064f4916$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $544fc37a064f4916$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $544fc37a064f4916$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $9nZCP.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $9nZCP.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $544fc37a064f4916$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $9nZCP.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $9nZCP.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $9nZCP.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $9nZCP.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $9nZCP.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $9nZCP.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $9nZCP.createElement($9nZCP.Fragment, null, /*#__PURE__*/ $9nZCP.createElement((0, $cb6812e0fa529c57$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $9nZCP.createElement((0, $cb6812e0fa529c57$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $9nZCP.createElement($544fc37a064f4916$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $9nZCP.createElement($544fc37a064f4916$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $9nZCP.createElement((0, $cb6812e0fa529c57$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $9nZCP.createElement($544fc37a064f4916$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $544fc37a064f4916$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $cb6812e0fa529c57$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $544fc37a064f4916$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $9nZCP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $6ab4d96c61a6f348$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $9nZCP.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $9nZCP.useCallback((newState)=>{
        v7_startTransition && $544fc37a064f4916$var$startTransitionImpl ? $544fc37a064f4916$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $9nZCP.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $9nZCP.createElement((0, $cb6812e0fa529c57$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $544fc37a064f4916$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $9nZCP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $6ab4d96c61a6f348$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $9nZCP.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $9nZCP.useCallback((newState)=>{
        v7_startTransition && $544fc37a064f4916$var$startTransitionImpl ? $544fc37a064f4916$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $9nZCP.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $9nZCP.createElement((0, $cb6812e0fa529c57$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $544fc37a064f4916$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $9nZCP.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $9nZCP.useCallback((newState)=>{
        v7_startTransition && $544fc37a064f4916$var$startTransitionImpl ? $544fc37a064f4916$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $9nZCP.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $9nZCP.createElement((0, $cb6812e0fa529c57$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $544fc37a064f4916$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $544fc37a064f4916$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $544fc37a064f4916$export$a6c7ac8248d6e38a = /*#__PURE__*/ $9nZCP.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $544fc37a064f4916$var$_objectWithoutPropertiesLoose(_ref7, $544fc37a064f4916$var$_excluded);
    let { basename: basename } = $9nZCP.useContext((0, $cb6812e0fa529c57$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $544fc37a064f4916$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($544fc37a064f4916$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $6ab4d96c61a6f348$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $cb6812e0fa529c57$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $544fc37a064f4916$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $9nZCP.createElement("a", $544fc37a064f4916$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $544fc37a064f4916$export$b0d92dbee9b5b60d = /*#__PURE__*/ $9nZCP.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $544fc37a064f4916$var$_objectWithoutPropertiesLoose(_ref8, $544fc37a064f4916$var$_excluded2);
    let path = (0, $cb6812e0fa529c57$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $cb6812e0fa529c57$export$45d76561a5302f2b)();
    let routerState = $9nZCP.useContext((0, $cb6812e0fa529c57$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $9nZCP.useContext((0, $cb6812e0fa529c57$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $544fc37a064f4916$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $6ab4d96c61a6f348$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $9nZCP.createElement($544fc37a064f4916$export$a6c7ac8248d6e38a, $544fc37a064f4916$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $544fc37a064f4916$export$a7fed597f4b8afd8 = /*#__PURE__*/ $9nZCP.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $544fc37a064f4916$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $544fc37a064f4916$var$_objectWithoutPropertiesLoose(_ref9, $544fc37a064f4916$var$_excluded3);
    let submit = $544fc37a064f4916$export$47c85c6e3a081d3();
    let formAction = $544fc37a064f4916$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $9nZCP.createElement("form", $544fc37a064f4916$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $544fc37a064f4916$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $544fc37a064f4916$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $544fc37a064f4916$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($544fc37a064f4916$var$DataRouterHook || ($544fc37a064f4916$var$DataRouterHook = {}));
var $544fc37a064f4916$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($544fc37a064f4916$var$DataRouterStateHook || ($544fc37a064f4916$var$DataRouterStateHook = {}));
// Internal hooks
function $544fc37a064f4916$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $544fc37a064f4916$var$useDataRouterContext(hookName) {
    let ctx = $9nZCP.useContext((0, $cb6812e0fa529c57$export$3add0d5dce533e2e));
    !ctx && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
    return ctx;
}
function $544fc37a064f4916$var$useDataRouterState(hookName) {
    let state = $9nZCP.useContext((0, $cb6812e0fa529c57$export$145dfa71566a64dc));
    !state && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $544fc37a064f4916$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $cb6812e0fa529c57$export$9770f232ac06a008)();
    let location = (0, $cb6812e0fa529c57$export$45d76561a5302f2b)();
    let path = (0, $cb6812e0fa529c57$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $9nZCP.useCallback((event)=>{
        if ($544fc37a064f4916$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $6ab4d96c61a6f348$export$fe53371bee54353d)(location) === (0, $6ab4d96c61a6f348$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $544fc37a064f4916$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $9nZCP.useRef($544fc37a064f4916$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $9nZCP.useRef(false);
    let location = (0, $cb6812e0fa529c57$export$45d76561a5302f2b)();
    let searchParams = $9nZCP.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $544fc37a064f4916$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $cb6812e0fa529c57$export$9770f232ac06a008)();
    let setSearchParams = $9nZCP.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $544fc37a064f4916$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $544fc37a064f4916$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $544fc37a064f4916$var$fetcherId = 0;
let $544fc37a064f4916$var$getUniqueFetcherId = ()=>"__" + String(++$544fc37a064f4916$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $544fc37a064f4916$export$47c85c6e3a081d3() {
    let { router: router } = $544fc37a064f4916$var$useDataRouterContext($544fc37a064f4916$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $9nZCP.useContext((0, $cb6812e0fa529c57$export$26749e8557646306));
    let currentRouteId = (0, $cb6812e0fa529c57$export$5fc8298006ad9e58)();
    return $9nZCP.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $544fc37a064f4916$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $544fc37a064f4916$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $544fc37a064f4916$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $544fc37a064f4916$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $9nZCP.useContext((0, $cb6812e0fa529c57$export$26749e8557646306));
    let routeContext = $9nZCP.useContext((0, $cb6812e0fa529c57$export$9072aa6dd1f93057));
    !routeContext && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $544fc37a064f4916$var$_extends({}, (0, $cb6812e0fa529c57$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $cb6812e0fa529c57$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $6ab4d96c61a6f348$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $6ab4d96c61a6f348$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $544fc37a064f4916$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $544fc37a064f4916$var$useDataRouterContext($544fc37a064f4916$var$DataRouterHook.UseFetcher);
    let state = $544fc37a064f4916$var$useDataRouterState($544fc37a064f4916$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $9nZCP.useContext($544fc37a064f4916$export$148fd98d095596d4);
    let route = $9nZCP.useContext((0, $cb6812e0fa529c57$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
    !route && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $544fc37a064f4916$var$useIdImpl ? $544fc37a064f4916$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $9nZCP.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($544fc37a064f4916$var$getUniqueFetcherId());
    // Registration/cleanup
    $9nZCP.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $9nZCP.useCallback((href, opts)=>{
        !routeId && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $544fc37a064f4916$export$47c85c6e3a081d3();
    let submit = $9nZCP.useCallback((target, opts)=>{
        submitImpl(target, $544fc37a064f4916$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $9nZCP.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $9nZCP.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $9nZCP.createElement($544fc37a064f4916$export$a7fed597f4b8afd8, $544fc37a064f4916$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $6ab4d96c61a6f348$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $9nZCP.useMemo(()=>$544fc37a064f4916$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $544fc37a064f4916$export$fa996778a3a31087() {
    let state = $544fc37a064f4916$var$useDataRouterState($544fc37a064f4916$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $544fc37a064f4916$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $544fc37a064f4916$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $544fc37a064f4916$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $544fc37a064f4916$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $544fc37a064f4916$var$useDataRouterContext($544fc37a064f4916$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $544fc37a064f4916$var$useDataRouterState($544fc37a064f4916$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $9nZCP.useContext((0, $cb6812e0fa529c57$export$26749e8557646306));
    let location = (0, $cb6812e0fa529c57$export$45d76561a5302f2b)();
    let matches = (0, $cb6812e0fa529c57$export$2378eb7f5ff86053)();
    let navigation = (0, $cb6812e0fa529c57$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $9nZCP.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $544fc37a064f4916$var$usePageHide($9nZCP.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $544fc37a064f4916$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $544fc37a064f4916$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($544fc37a064f4916$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $9nZCP.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $544fc37a064f4916$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $544fc37a064f4916$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $9nZCP.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($544fc37a064f4916$var$_extends({}, location, {
                    pathname: (0, $6ab4d96c61a6f348$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($544fc37a064f4916$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $9nZCP.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $544fc37a064f4916$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $9nZCP.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $544fc37a064f4916$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $9nZCP.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $544fc37a064f4916$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $cb6812e0fa529c57$export$b273b3273281a049)(when);
    $9nZCP.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $9nZCP.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $544fc37a064f4916$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $9nZCP.useContext($544fc37a064f4916$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $6ab4d96c61a6f348$export$3e9cee6b33872309)(false);
    let { basename: basename } = $544fc37a064f4916$var$useDataRouterContext($544fc37a064f4916$var$DataRouterHook.useViewTransitionState);
    let path = (0, $cb6812e0fa529c57$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $6ab4d96c61a6f348$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $6ab4d96c61a6f348$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $6ab4d96c61a6f348$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $6ab4d96c61a6f348$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


var $4feb02df2927cf33$exports = {};
$4feb02df2927cf33$exports = JSON.parse('{"version":"2.0.0","gitCommitHash":"99675d829dd52544e57d4c80d47aac440434d61c","gitCommitShortHash":"99675d8","gitBranch":"HEAD","gitTags":"","clean":true}');


const $4ec8515f3272cbaa$export$ae4e5f23793d4e6f = 10000n;
const $4ec8515f3272cbaa$export$8c255d03248f12ab = "https://cdn.kleros.link";
const $4ec8515f3272cbaa$export$512554f3e5add99 = (0, $4feb02df2927cf33$exports.gitBranch);
const $4ec8515f3272cbaa$export$ac95da7ac2645a99 = (0, $4feb02df2927cf33$exports.gitTags);
const $4ec8515f3272cbaa$export$8439c9c045e5384d = (0, $4feb02df2927cf33$exports.gitCommitShortHash);
const $4ec8515f3272cbaa$export$91f55afd4519d50b = (0, $4feb02df2927cf33$exports.clean) ? "" : "-dirty";
const $4ec8515f3272cbaa$export$1c46d8639ab5b0b = `https://github.com/kleros/escrow-v2/tree/${(0, $4feb02df2927cf33$exports.gitCommitHash)}/web`;
const $4ec8515f3272cbaa$export$f1af843f4d252578 = (0, $4feb02df2927cf33$exports.version);
const $4ec8515f3272cbaa$export$7b7637218245c8a = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
const $4ec8515f3272cbaa$export$6314dddca181ba3d = /^@\w{5,32}$/;
const $4ec8515f3272cbaa$export$8a608dfcf39ad5a = /^0x[a-fA-F0-9]{40}$/;
const $4ec8515f3272cbaa$export$339f64b97ec8e1cc = /^0x[a-fA-F0-9]{130}$/;


$eef6187dab2bf3b9$export$2cd8252107eb640b({
    dsn: undefined,
    environment: undefined,
    release: `court-v2@${(0, $4ec8515f3272cbaa$export$f1af843f4d252578)}-${(0, $4ec8515f3272cbaa$export$8439c9c045e5384d)}${(0, $4ec8515f3272cbaa$export$91f55afd4519d50b)}`,
    integrations: [
        new $43daeb1fbba91c9d$export$b0fe88803ed435e0(),
        new $9441be368c328d2c$export$46d3bbd0375f5fa4({
            routingInstrumentation: $466fe0467b5e5168$export$e6e76890c5208db1((0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useEffect, (0, $cb6812e0fa529c57$export$45d76561a5302f2b), (0, $cb6812e0fa529c57$export$1b3f31771c5d07c), (0, $cb6812e0fa529c57$export$16da398f5434bdec), (0, $6ab4d96c61a6f348$export$2708184779ceb39d))
        })
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        "localhost",
        /^https:\/\/.*--escrow-v2\.netlify\.app/
    ],
    // Set profilesSampleRate to 1.0 to profile every transaction.
    // Since profilesSampleRate is relative to tracesSampleRate,
    // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
    // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
    // results in 25% of transactions being profiled (0.5*0.5=0.25)
    profilesSampleRate: 1.0
});
const $db670e23ef84c511$export$22a2709142043366 = $466fe0467b5e5168$export$c6111e8561a02a8b((0, $cb6812e0fa529c57$export$3565eb3d00ca5a74));





parcelRequire("9nZCP");

var $hzb7Z = parcelRequire("hzb7Z");
var $cDSuN = parcelRequire("cDSuN");

var $2QdCh = parcelRequire("2QdCh");

var $57KGK = parcelRequire("57KGK");

var $lRux7 = parcelRequire("lRux7");
var $ng60n = parcelRequire("ng60n");
var $1r7Xu = parcelRequire("1r7Xu");
var $9Kb19 = parcelRequire("9Kb19");
var $e2aBg = parcelRequire("e2aBg");
var $77d3b32f7566bdd7$var$NAMESPACE = "eip155";
var $77d3b32f7566bdd7$var$STORE_KEY = "store";
var $77d3b32f7566bdd7$var$REQUESTED_CHAINS_KEY = "requestedChains";
var $77d3b32f7566bdd7$var$ADD_ETH_CHAIN_METHOD = "wallet_addEthereumChain";
var $77d3b32f7566bdd7$var$_provider, $77d3b32f7566bdd7$var$_initProviderPromise, $77d3b32f7566bdd7$var$_createProvider, $77d3b32f7566bdd7$var$createProvider_fn, $77d3b32f7566bdd7$var$_initProvider, $77d3b32f7566bdd7$var$initProvider_fn, $77d3b32f7566bdd7$var$_isChainsStale, $77d3b32f7566bdd7$var$isChainsStale_fn, $77d3b32f7566bdd7$var$_setupListeners, $77d3b32f7566bdd7$var$setupListeners_fn, $77d3b32f7566bdd7$var$_removeListeners, $77d3b32f7566bdd7$var$removeListeners_fn, $77d3b32f7566bdd7$var$_setRequestedChainsIds, $77d3b32f7566bdd7$var$setRequestedChainsIds_fn, $77d3b32f7566bdd7$var$_getRequestedChainsIds, $77d3b32f7566bdd7$var$getRequestedChainsIds_fn, $77d3b32f7566bdd7$var$_getNamespaceChainsIds, $77d3b32f7566bdd7$var$getNamespaceChainsIds_fn, $77d3b32f7566bdd7$var$_getNamespaceMethods, $77d3b32f7566bdd7$var$getNamespaceMethods_fn;
var $77d3b32f7566bdd7$export$c456b2d327ac201f = class extends (0, $2QdCh.Connector) {
    constructor(config){
        super({
            ...config,
            options: {
                isNewChainsStale: true,
                ...config.options
            }
        });
        (0, $2QdCh.__privateAdd)(this, $77d3b32f7566bdd7$var$_createProvider);
        (0, $2QdCh.__privateAdd)(this, $77d3b32f7566bdd7$var$_initProvider);
        (0, $2QdCh.__privateAdd)(this, $77d3b32f7566bdd7$var$_isChainsStale);
        (0, $2QdCh.__privateAdd)(this, $77d3b32f7566bdd7$var$_setupListeners);
        (0, $2QdCh.__privateAdd)(this, $77d3b32f7566bdd7$var$_removeListeners);
        (0, $2QdCh.__privateAdd)(this, $77d3b32f7566bdd7$var$_setRequestedChainsIds);
        (0, $2QdCh.__privateAdd)(this, $77d3b32f7566bdd7$var$_getRequestedChainsIds);
        (0, $2QdCh.__privateAdd)(this, $77d3b32f7566bdd7$var$_getNamespaceChainsIds);
        (0, $2QdCh.__privateAdd)(this, $77d3b32f7566bdd7$var$_getNamespaceMethods);
        this.id = "walletConnect";
        this.name = "WalletConnect";
        this.ready = true;
        (0, $2QdCh.__privateAdd)(this, $77d3b32f7566bdd7$var$_provider, void 0);
        (0, $2QdCh.__privateAdd)(this, $77d3b32f7566bdd7$var$_initProviderPromise, void 0);
        this.onAccountsChanged = (accounts)=>{
            if (accounts.length === 0) this.emit("disconnect");
            else this.emit("change", {
                account: (0, $1r7Xu.getAddress)(accounts[0])
            });
        };
        this.onChainChanged = (chainId)=>{
            const id = Number(chainId);
            const unsupported = this.isChainUnsupported(id);
            this.emit("change", {
                chain: {
                    id: id,
                    unsupported: unsupported
                }
            });
        };
        this.onDisconnect = ()=>{
            (0, $2QdCh.__privateMethod)(this, $77d3b32f7566bdd7$var$_setRequestedChainsIds, $77d3b32f7566bdd7$var$setRequestedChainsIds_fn).call(this, []);
            this.emit("disconnect");
        };
        this.onDisplayUri = (uri)=>{
            this.emit("message", {
                type: "display_uri",
                data: uri
            });
        };
        this.onConnect = ()=>{
            this.emit("connect", {});
        };
        (0, $2QdCh.__privateMethod)(this, $77d3b32f7566bdd7$var$_createProvider, $77d3b32f7566bdd7$var$createProvider_fn).call(this);
    }
    async connect({ chainId: chainId, pairingTopic: pairingTopic } = {}) {
        try {
            let targetChainId = chainId;
            if (!targetChainId) {
                const store = this.storage?.getItem($77d3b32f7566bdd7$var$STORE_KEY);
                const lastUsedChainId = store?.state?.data?.chain?.id;
                if (lastUsedChainId && !this.isChainUnsupported(lastUsedChainId)) targetChainId = lastUsedChainId;
                else targetChainId = this.chains[0]?.id;
            }
            if (!targetChainId) throw new Error("No chains found on connector.");
            const provider = await this.getProvider();
            (0, $2QdCh.__privateMethod)(this, $77d3b32f7566bdd7$var$_setupListeners, $77d3b32f7566bdd7$var$setupListeners_fn).call(this);
            const isChainsStale = (0, $2QdCh.__privateMethod)(this, $77d3b32f7566bdd7$var$_isChainsStale, $77d3b32f7566bdd7$var$isChainsStale_fn).call(this);
            if (provider.session && isChainsStale) await provider.disconnect();
            if (!provider.session || isChainsStale) {
                const optionalChains = this.chains.filter((chain)=>chain.id !== targetChainId).map((optionalChain)=>optionalChain.id);
                this.emit("message", {
                    type: "connecting"
                });
                await provider.connect({
                    pairingTopic: pairingTopic,
                    optionalChains: [
                        targetChainId,
                        ...optionalChains
                    ]
                });
                (0, $2QdCh.__privateMethod)(this, $77d3b32f7566bdd7$var$_setRequestedChainsIds, $77d3b32f7566bdd7$var$setRequestedChainsIds_fn).call(this, this.chains.map(({ id: id2 })=>id2));
            }
            const accounts = await provider.enable();
            const account = (0, $1r7Xu.getAddress)(accounts[0]);
            const id = await this.getChainId();
            const unsupported = this.isChainUnsupported(id);
            return {
                account: account,
                chain: {
                    id: id,
                    unsupported: unsupported
                }
            };
        } catch (error) {
            if (/user rejected/i.test(error?.message)) throw new (0, $e2aBg.UserRejectedRequestError)(error);
            throw error;
        }
    }
    async disconnect() {
        const provider = await this.getProvider();
        try {
            await provider.disconnect();
        } catch (error) {
            if (!/No matching key/i.test(error.message)) throw error;
        } finally{
            (0, $2QdCh.__privateMethod)(this, $77d3b32f7566bdd7$var$_removeListeners, $77d3b32f7566bdd7$var$removeListeners_fn).call(this);
            (0, $2QdCh.__privateMethod)(this, $77d3b32f7566bdd7$var$_setRequestedChainsIds, $77d3b32f7566bdd7$var$setRequestedChainsIds_fn).call(this, []);
        }
    }
    async getAccount() {
        const { accounts: accounts } = await this.getProvider();
        return (0, $1r7Xu.getAddress)(accounts[0]);
    }
    async getChainId() {
        const { chainId: chainId } = await this.getProvider();
        return chainId;
    }
    async getProvider({ chainId: chainId } = {}) {
        if (!(0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider)) await (0, $2QdCh.__privateMethod)(this, $77d3b32f7566bdd7$var$_createProvider, $77d3b32f7566bdd7$var$createProvider_fn).call(this);
        if (chainId) await this.switchChain(chainId);
        return (0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider);
    }
    async getWalletClient({ chainId: chainId } = {}) {
        const [provider, account] = await Promise.all([
            this.getProvider({
                chainId: chainId
            }),
            this.getAccount()
        ]);
        const chain = this.chains.find((x)=>x.id === chainId);
        if (!provider) throw new Error("provider is required.");
        return (0, $lRux7.createWalletClient)({
            account: account,
            chain: chain,
            transport: (0, $ng60n.custom)(provider)
        });
    }
    async isAuthorized() {
        try {
            const [account, provider] = await Promise.all([
                this.getAccount(),
                this.getProvider()
            ]);
            const isChainsStale = (0, $2QdCh.__privateMethod)(this, $77d3b32f7566bdd7$var$_isChainsStale, $77d3b32f7566bdd7$var$isChainsStale_fn).call(this);
            if (!account) return false;
            if (isChainsStale && provider.session) {
                try {
                    await provider.disconnect();
                } catch  {}
                return false;
            }
            return true;
        } catch  {
            return false;
        }
    }
    async switchChain(chainId) {
        const chain = this.chains.find((chain2)=>chain2.id === chainId);
        if (!chain) throw new (0, $e2aBg.SwitchChainError)(new Error("chain not found on connector."));
        try {
            const provider = await this.getProvider();
            const namespaceChains = (0, $2QdCh.__privateMethod)(this, $77d3b32f7566bdd7$var$_getNamespaceChainsIds, $77d3b32f7566bdd7$var$getNamespaceChainsIds_fn).call(this);
            const namespaceMethods = (0, $2QdCh.__privateMethod)(this, $77d3b32f7566bdd7$var$_getNamespaceMethods, $77d3b32f7566bdd7$var$getNamespaceMethods_fn).call(this);
            const isChainApproved = namespaceChains.includes(chainId);
            if (!isChainApproved && namespaceMethods.includes($77d3b32f7566bdd7$var$ADD_ETH_CHAIN_METHOD)) {
                await provider.request({
                    method: $77d3b32f7566bdd7$var$ADD_ETH_CHAIN_METHOD,
                    params: [
                        {
                            chainId: (0, $9Kb19.numberToHex)(chain.id),
                            blockExplorerUrls: [
                                chain.blockExplorers?.default?.url
                            ],
                            chainName: chain.name,
                            nativeCurrency: chain.nativeCurrency,
                            rpcUrls: [
                                ...chain.rpcUrls.default.http
                            ]
                        }
                    ]
                });
                const requestedChains = (0, $2QdCh.__privateMethod)(this, $77d3b32f7566bdd7$var$_getRequestedChainsIds, $77d3b32f7566bdd7$var$getRequestedChainsIds_fn).call(this);
                requestedChains.push(chainId);
                (0, $2QdCh.__privateMethod)(this, $77d3b32f7566bdd7$var$_setRequestedChainsIds, $77d3b32f7566bdd7$var$setRequestedChainsIds_fn).call(this, requestedChains);
            }
            await provider.request({
                method: "wallet_switchEthereumChain",
                params: [
                    {
                        chainId: (0, $9Kb19.numberToHex)(chainId)
                    }
                ]
            });
            return chain;
        } catch (error) {
            const message = typeof error === "string" ? error : error?.message;
            if (/user rejected request/i.test(message)) throw new (0, $e2aBg.UserRejectedRequestError)(error);
            throw new (0, $e2aBg.SwitchChainError)(error);
        }
    }
};
$77d3b32f7566bdd7$var$_provider = new WeakMap();
$77d3b32f7566bdd7$var$_initProviderPromise = new WeakMap();
$77d3b32f7566bdd7$var$_createProvider = new WeakSet();
$77d3b32f7566bdd7$var$createProvider_fn = async function() {
    if (!(0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_initProviderPromise) && typeof window !== "undefined") (0, $2QdCh.__privateSet)(this, $77d3b32f7566bdd7$var$_initProviderPromise, (0, $2QdCh.__privateMethod)(this, $77d3b32f7566bdd7$var$_initProvider, $77d3b32f7566bdd7$var$initProvider_fn).call(this));
    return (0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_initProviderPromise);
};
$77d3b32f7566bdd7$var$_initProvider = new WeakSet();

$77d3b32f7566bdd7$var$initProvider_fn = async function() {
    const { EthereumProvider: EthereumProvider } = await (parcelRequire("4nuqd"));
    const optionalChains = this.chains.map(({ id: id })=>id);
    if (optionalChains.length) {
        const { projectId: projectId, showQrModal: showQrModal = true, qrModalOptions: qrModalOptions, metadata: metadata, relayUrl: relayUrl } = this.options;
        (0, $2QdCh.__privateSet)(this, $77d3b32f7566bdd7$var$_provider, await EthereumProvider.init({
            showQrModal: showQrModal,
            qrModalOptions: qrModalOptions,
            projectId: projectId,
            optionalChains: optionalChains,
            rpcMap: Object.fromEntries(this.chains.map((chain)=>[
                    chain.id,
                    chain.rpcUrls.default.http[0]
                ])),
            metadata: metadata,
            relayUrl: relayUrl
        }));
    }
};
$77d3b32f7566bdd7$var$_isChainsStale = new WeakSet();
$77d3b32f7566bdd7$var$isChainsStale_fn = function() {
    const namespaceMethods = (0, $2QdCh.__privateMethod)(this, $77d3b32f7566bdd7$var$_getNamespaceMethods, $77d3b32f7566bdd7$var$getNamespaceMethods_fn).call(this);
    if (namespaceMethods.includes($77d3b32f7566bdd7$var$ADD_ETH_CHAIN_METHOD)) return false;
    if (!this.options.isNewChainsStale) return false;
    const requestedChains = (0, $2QdCh.__privateMethod)(this, $77d3b32f7566bdd7$var$_getRequestedChainsIds, $77d3b32f7566bdd7$var$getRequestedChainsIds_fn).call(this);
    const connectorChains = this.chains.map(({ id: id })=>id);
    const namespaceChains = (0, $2QdCh.__privateMethod)(this, $77d3b32f7566bdd7$var$_getNamespaceChainsIds, $77d3b32f7566bdd7$var$getNamespaceChainsIds_fn).call(this);
    if (namespaceChains.length && !namespaceChains.some((id)=>connectorChains.includes(id))) return false;
    return !connectorChains.every((id)=>requestedChains.includes(id));
};
$77d3b32f7566bdd7$var$_setupListeners = new WeakSet();
$77d3b32f7566bdd7$var$setupListeners_fn = function() {
    if (!(0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider)) return;
    (0, $2QdCh.__privateMethod)(this, $77d3b32f7566bdd7$var$_removeListeners, $77d3b32f7566bdd7$var$removeListeners_fn).call(this);
    (0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider).on("accountsChanged", this.onAccountsChanged);
    (0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider).on("chainChanged", this.onChainChanged);
    (0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider).on("disconnect", this.onDisconnect);
    (0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider).on("session_delete", this.onDisconnect);
    (0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider).on("display_uri", this.onDisplayUri);
    (0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider).on("connect", this.onConnect);
};
$77d3b32f7566bdd7$var$_removeListeners = new WeakSet();
$77d3b32f7566bdd7$var$removeListeners_fn = function() {
    if (!(0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider)) return;
    (0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider).removeListener("accountsChanged", this.onAccountsChanged);
    (0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider).removeListener("chainChanged", this.onChainChanged);
    (0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider).removeListener("disconnect", this.onDisconnect);
    (0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider).removeListener("session_delete", this.onDisconnect);
    (0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider).removeListener("display_uri", this.onDisplayUri);
    (0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider).removeListener("connect", this.onConnect);
};
$77d3b32f7566bdd7$var$_setRequestedChainsIds = new WeakSet();
$77d3b32f7566bdd7$var$setRequestedChainsIds_fn = function(chains) {
    this.storage?.setItem($77d3b32f7566bdd7$var$REQUESTED_CHAINS_KEY, chains);
};
$77d3b32f7566bdd7$var$_getRequestedChainsIds = new WeakSet();
$77d3b32f7566bdd7$var$getRequestedChainsIds_fn = function() {
    return this.storage?.getItem($77d3b32f7566bdd7$var$REQUESTED_CHAINS_KEY) ?? [];
};
$77d3b32f7566bdd7$var$_getNamespaceChainsIds = new WeakSet();
$77d3b32f7566bdd7$var$getNamespaceChainsIds_fn = function() {
    if (!(0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider)) return [];
    const namespaces = (0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider).session?.namespaces;
    if (!namespaces) return [];
    const normalizedNamespaces = (0, $57KGK.normalizeNamespaces)(namespaces);
    const chainIds = normalizedNamespaces[$77d3b32f7566bdd7$var$NAMESPACE]?.chains?.map((chain)=>parseInt(chain.split(":")[1] || ""));
    return chainIds ?? [];
};
$77d3b32f7566bdd7$var$_getNamespaceMethods = new WeakSet();
$77d3b32f7566bdd7$var$getNamespaceMethods_fn = function() {
    if (!(0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider)) return [];
    const namespaces = (0, $2QdCh.__privateGet)(this, $77d3b32f7566bdd7$var$_provider).session?.namespaces;
    if (!namespaces) return [];
    const normalizedNamespaces = (0, $57KGK.normalizeNamespaces)(namespaces);
    const methods = normalizedNamespaces[$77d3b32f7566bdd7$var$NAMESPACE]?.methods;
    return methods ?? [];
};



// src/providers/jsonRpc.ts
function $95d131fcc106cbb5$export$2dc41f6df3d9d4cf({ rpc: rpc }) {
    return function(chain) {
        const rpcConfig = rpc(chain);
        if (!rpcConfig || rpcConfig.http === "") return null;
        return {
            chain: {
                ...chain,
                rpcUrls: {
                    ...chain.rpcUrls,
                    default: {
                        http: [
                            rpcConfig.http
                        ]
                    }
                }
            },
            rpcUrls: {
                http: [
                    rpcConfig.http
                ],
                webSocket: rpcConfig.webSocket ? [
                    rpcConfig.webSocket
                ] : void 0
            }
        };
    };
}


const $fb6877b271dac1d3$var$A = "wallet_addEthereumChain";
class $fb6877b271dac1d3$export$de370d1517aed7bb {
    constructor(t, e){
        this.wagmi = {}, this.chains = [], this.namespace = "eip155", this.disconnect = (0, $hzb7Z.disconnect), this.getAccount = (0, $hzb7Z.getAccount), this.watchAccount = (0, $hzb7Z.watchAccount), this.fetchBalance = (0, $hzb7Z.fetchBalance), this.getNetwork = (0, $hzb7Z.getNetwork), this.watchNetwork = (0, $hzb7Z.watchNetwork), this.switchNetwork = (0, $hzb7Z.switchNetwork), this.fetchEnsName = (0, $hzb7Z.fetchEnsName), this.fetchEnsAvatar = (0, $hzb7Z.fetchEnsAvatar), this.wagmi = t, this.chains = e;
    }
    getWalletConnectConnector() {
        const t = this.wagmi.connectors.find((e)=>e.id === "walletConnect");
        if (!t) throw new Error("WalletConnectConnector is required");
        return t;
    }
    async connectWalletConnectProvider(t, e) {
        return await t.getProvider(), new Promise((n)=>{
            t.once("message", (o)=>{
                o.type === "display_uri" && (e(o.data), n());
            });
        });
    }
    getConnectorById(t) {
        const e = this.wagmi.connectors.find((n)=>n.id === t);
        if (!e) throw new Error(`Connector for id ${t} was not found`);
        return e;
    }
    getConnectors() {
        return this.wagmi.connectors.filter((t)=>!t.id.includes("walletConnect"));
    }
    async connectWalletConnect(t, e) {
        const n = this.getWalletConnectConnector(), o = {
            connector: n
        };
        return e && (o.chainId = e), Promise.all([
            (0, $hzb7Z.connect)(o),
            this.connectWalletConnectProvider(n, t)
        ]);
    }
    async connectConnector(t, e) {
        const n = {
            connector: this.getConnectorById(t)
        };
        return e && (n.chainId = e), await (0, $hzb7Z.connect)(n);
    }
    isInjectedProviderInstalled() {
        return typeof window.ethereum < "u";
    }
    safeCheckInjectedProvider(t) {
        var e;
        try {
            const n = String(t);
            return Boolean((e = window.ethereum) == null ? void 0 : e[n]);
        } catch (n) {
            return console.error(n), !1;
        }
    }
    async getConnectedChainIds() {
        var t, e, n;
        const o = (e = (t = (await this.getWalletConnectConnector().getProvider()).signer) == null ? void 0 : t.session) == null ? void 0 : e.namespaces, s = (n = o?.[this.namespace]) == null ? void 0 : n.methods;
        if (s != null && s.includes($fb6877b271dac1d3$var$A)) return "ALL";
        if (o) {
            const i = [];
            return Object.keys(o).forEach((r)=>{
                r.includes(this.namespace) && i.push(...o[r].accounts);
            }), i?.map((r)=>r.split(":")[1]);
        }
        return "ALL";
    }
}
const $fb6877b271dac1d3$var$P = "eip155", $fb6877b271dac1d3$var$y = "https://rpc.walletconnect.com";
function $fb6877b271dac1d3$export$c6fada22b311e8ce({ projectId: c }) {
    return (0, $95d131fcc106cbb5$export$2dc41f6df3d9d4cf)({
        rpc: (t)=>{
            var e;
            return [
                1,
                3,
                4,
                5,
                10,
                42,
                56,
                69,
                97,
                100,
                137,
                280,
                324,
                420,
                42161,
                42220,
                43114,
                80001,
                421611,
                421613,
                1313161554,
                1313161555
            ].includes(t.id) ? {
                http: `${$fb6877b271dac1d3$var$y}/v1/?chainId=${$fb6877b271dac1d3$var$P}:${t.id}&projectId=${c}`
            } : {
                http: t.rpcUrls.default.http[0],
                webSocket: (e = t.rpcUrls.default.webSocket) == null ? void 0 : e[0]
            };
        }
    });
}
function $fb6877b271dac1d3$export$1fa55742dee269b2({ chains: c, projectId: t }) {
    return [
        new (0, $77d3b32f7566bdd7$export$c456b2d327ac201f)({
            chains: c,
            options: {
                projectId: t,
                showQrModal: !1
            }
        }),
        new (0, $cDSuN.InjectedConnector)({
            chains: c,
            options: {
                shimDisconnect: !0
            }
        })
    ];
}



// src/providers/alchemy.ts
function $7b57abd4ae2a8075$export$da85a315824a4e0e({ apiKey: apiKey }) {
    return function(chain) {
        const baseHttpUrl = chain.rpcUrls.alchemy?.http[0];
        const baseWsUrl = chain.rpcUrls.alchemy?.webSocket?.[0];
        if (!baseHttpUrl) return null;
        return {
            chain: {
                ...chain,
                rpcUrls: {
                    ...chain.rpcUrls,
                    default: {
                        http: [
                            `${baseHttpUrl}/${apiKey}`
                        ]
                    }
                }
            },
            rpcUrls: {
                http: [
                    `${baseHttpUrl}/${apiKey}`
                ],
                webSocket: [
                    `${baseWsUrl}/${apiKey}`
                ]
            }
        };
    };
}



var $9nZCP = parcelRequire("9nZCP");

var $eLb5d = parcelRequire("eLb5d");
var $e6fafce87905c9df$var$M = Object.defineProperty, $e6fafce87905c9df$var$b = Object.getOwnPropertySymbols, $e6fafce87905c9df$var$S = Object.prototype.hasOwnProperty, $e6fafce87905c9df$var$I = Object.prototype.propertyIsEnumerable, $e6fafce87905c9df$var$s = (t, e, r)=>e in t ? $e6fafce87905c9df$var$M(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : t[e] = r, $e6fafce87905c9df$var$W = (t, e)=>{
    for(var r in e || (e = {}))$e6fafce87905c9df$var$S.call(e, r) && $e6fafce87905c9df$var$s(t, r, e[r]);
    if ($e6fafce87905c9df$var$b) for (var r of $e6fafce87905c9df$var$b(e))$e6fafce87905c9df$var$I.call(e, r) && $e6fafce87905c9df$var$s(t, r, e[r]);
    return t;
};
function $e6fafce87905c9df$export$26f4bb56b75cc260(t) {
    const { size: e } = t;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        style: {
            width: e,
            height: e
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("w3m-qrcode", $e6fafce87905c9df$var$W({}, t)));
}
var $e6fafce87905c9df$var$T = Object.defineProperty, $e6fafce87905c9df$var$p = Object.getOwnPropertySymbols, $e6fafce87905c9df$var$V = Object.prototype.hasOwnProperty, $e6fafce87905c9df$var$k = Object.prototype.propertyIsEnumerable, $e6fafce87905c9df$var$u = (t, e, r)=>e in t ? $e6fafce87905c9df$var$T(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : t[e] = r, $e6fafce87905c9df$var$x = (t, e)=>{
    for(var r in e || (e = {}))$e6fafce87905c9df$var$V.call(e, r) && $e6fafce87905c9df$var$u(t, r, e[r]);
    if ($e6fafce87905c9df$var$p) for (var r of $e6fafce87905c9df$var$p(e))$e6fafce87905c9df$var$k.call(e, r) && $e6fafce87905c9df$var$u(t, r, e[r]);
    return t;
};
function $e6fafce87905c9df$export$ed89f3ab37730d1a(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("w3m-core-button", $e6fafce87905c9df$var$x({}, t));
}
var $e6fafce87905c9df$var$q = Object.defineProperty, $e6fafce87905c9df$var$f = Object.getOwnPropertySymbols, $e6fafce87905c9df$var$z = Object.prototype.hasOwnProperty, $e6fafce87905c9df$var$B = Object.prototype.propertyIsEnumerable, $e6fafce87905c9df$var$m = (t, e, r)=>e in t ? $e6fafce87905c9df$var$q(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : t[e] = r, $e6fafce87905c9df$var$D = (t, e)=>{
    for(var r in e || (e = {}))$e6fafce87905c9df$var$z.call(e, r) && $e6fafce87905c9df$var$m(t, r, e[r]);
    if ($e6fafce87905c9df$var$f) for (var r of $e6fafce87905c9df$var$f(e))$e6fafce87905c9df$var$B.call(e, r) && $e6fafce87905c9df$var$m(t, r, e[r]);
    return t;
};
function $e6fafce87905c9df$var$L(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("w3m-modal", $e6fafce87905c9df$var$D({}, t));
}
var $e6fafce87905c9df$var$v = Object.getOwnPropertySymbols, $e6fafce87905c9df$var$N = Object.prototype.hasOwnProperty, $e6fafce87905c9df$var$Q = Object.prototype.propertyIsEnumerable, $e6fafce87905c9df$var$U = (t, e)=>{
    var r = {};
    for(var o in t)$e6fafce87905c9df$var$N.call(t, o) && e.indexOf(o) < 0 && (r[o] = t[o]);
    if (t != null && $e6fafce87905c9df$var$v) for (var o of $e6fafce87905c9df$var$v(t))e.indexOf(o) < 0 && $e6fafce87905c9df$var$Q.call(t, o) && (r[o] = t[o]);
    return r;
};

function $e6fafce87905c9df$var$A(t) {
    var e = t, { ethereumClient: r } = e, o = $e6fafce87905c9df$var$U(e, [
        "ethereumClient"
    ]);
    const i = (0, $9nZCP.useCallback)(async ()=>{
        (0, $eLb5d.ThemeCtrl).setThemeConfig(o), r && (0, $eLb5d.ClientCtrl).setEthereumClient(r), (0, $eLb5d.ConfigCtrl).setConfig(o), await (parcelRequire("geKiF")), (0, $eLb5d.OptionsCtrl).setIsUiLoaded(!0);
    }, [
        r,
        o
    ]);
    return (0, $9nZCP.useEffect)(()=>{
        i();
    }, [
        i
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement($e6fafce87905c9df$var$L, null);
}
const $e6fafce87905c9df$export$c03599cd5308d12b = (0, $9nZCP.memo)($e6fafce87905c9df$var$A);
var $e6fafce87905c9df$var$F = Object.defineProperty, $e6fafce87905c9df$var$y = Object.getOwnPropertySymbols, $e6fafce87905c9df$var$G = Object.prototype.hasOwnProperty, $e6fafce87905c9df$var$H = Object.prototype.propertyIsEnumerable, $e6fafce87905c9df$var$O = (t, e, r)=>e in t ? $e6fafce87905c9df$var$F(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : t[e] = r, $e6fafce87905c9df$var$J = (t, e)=>{
    for(var r in e || (e = {}))$e6fafce87905c9df$var$G.call(e, r) && $e6fafce87905c9df$var$O(t, r, e[r]);
    if ($e6fafce87905c9df$var$y) for (var r of $e6fafce87905c9df$var$y(e))$e6fafce87905c9df$var$H.call(e, r) && $e6fafce87905c9df$var$O(t, r, e[r]);
    return t;
};
function $e6fafce87905c9df$export$f4f967f17655ea54(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("w3m-network-switch", $e6fafce87905c9df$var$J({}, t));
}
var $e6fafce87905c9df$var$K = Object.defineProperty, $e6fafce87905c9df$var$h = Object.getOwnPropertySymbols, $e6fafce87905c9df$var$R = Object.prototype.hasOwnProperty, $e6fafce87905c9df$var$X = Object.prototype.propertyIsEnumerable, $e6fafce87905c9df$var$w = (t, e, r)=>e in t ? $e6fafce87905c9df$var$K(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : t[e] = r, $e6fafce87905c9df$var$Y = (t, e)=>{
    for(var r in e || (e = {}))$e6fafce87905c9df$var$R.call(e, r) && $e6fafce87905c9df$var$w(t, r, e[r]);
    if ($e6fafce87905c9df$var$h) for (var r of $e6fafce87905c9df$var$h(e))$e6fafce87905c9df$var$X.call(e, r) && $e6fafce87905c9df$var$w(t, r, e[r]);
    return t;
};
function $e6fafce87905c9df$export$69804ca079d47f29() {
    const [t, e] = (0, $9nZCP.useState)((0, $eLb5d.ModalCtrl).state);
    return (0, $9nZCP.useEffect)(()=>{
        const r = (0, $eLb5d.ModalCtrl).subscribe((o)=>e($e6fafce87905c9df$var$Y({}, o)));
        return ()=>{
            r();
        };
    }, []), {
        isOpen: t.open,
        open: (0, $eLb5d.ModalCtrl).open,
        close: (0, $eLb5d.ModalCtrl).close,
        setDefaultChain: (0, $eLb5d.OptionsCtrl).setSelectedChain
    };
}
function $e6fafce87905c9df$export$cd17534826f46144(t) {
    (0, $9nZCP.useEffect)(()=>{
        const e = (0, $eLb5d.EventsCtrl).subscribe(t);
        return ()=>{
            e();
        };
    }, []);
}
function $e6fafce87905c9df$export$7cb034a59823159f() {
    const [t, e] = (0, $9nZCP.useState)({
        themeMode: (0, $eLb5d.ThemeCtrl).state.themeMode,
        themeVariables: (0, $eLb5d.ThemeCtrl).state.themeVariables
    });
    return (0, $9nZCP.useEffect)(()=>{
        const r = (0, $eLb5d.ThemeCtrl).subscribe((o)=>e({
                themeMode: o.themeMode,
                themeVariables: o.themeVariables
            }));
        return ()=>{
            r();
        };
    }, []), {
        theme: t,
        setTheme: (0, $eLb5d.ThemeCtrl).setThemeConfig
    };
}



var $hzb7Z = parcelRequire("hzb7Z");function $2b016d4b9c30a5ee$export$35561f995d4e487d({ storage: storage, key: key = "REACT_QUERY_OFFLINE_CACHE", throttleTime: throttleTime = 1000, serialize: serialize = JSON.stringify, deserialize: deserialize = JSON.parse, retry: retry }) {
    if (storage) {
        const trySave = (persistedClient)=>{
            try {
                storage.setItem(key, serialize(persistedClient));
                return;
            } catch (error) {
                return error;
            }
        };
        return {
            persistClient: $2b016d4b9c30a5ee$var$throttle((persistedClient)=>{
                let client = persistedClient;
                let error = trySave(client);
                let errorCount = 0;
                while(error && client){
                    errorCount++;
                    client = retry == null ? void 0 : retry({
                        persistedClient: client,
                        error: error,
                        errorCount: errorCount
                    });
                    if (client) error = trySave(client);
                }
            }, throttleTime),
            restoreClient: ()=>{
                const cacheString = storage.getItem(key);
                if (!cacheString) return;
                return deserialize(cacheString);
            },
            removeClient: ()=>{
                storage.removeItem(key);
            }
        };
    }
    return {
        persistClient: $2b016d4b9c30a5ee$var$noop,
        restoreClient: ()=>undefined,
        removeClient: $2b016d4b9c30a5ee$var$noop
    };
}
function $2b016d4b9c30a5ee$var$throttle(func, wait = 100) {
    let timer = null;
    let params;
    return function(...args) {
        params = args;
        if (timer === null) timer = setTimeout(()=>{
            func(...params);
            timer = null;
        }, wait);
    };
} // eslint-disable-next-line @typescript-eslint/no-empty-function
function $2b016d4b9c30a5ee$var$noop() {}


// TYPES
// UTILS
const $013477420ae0c1cc$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in window;
function $013477420ae0c1cc$export$8793edee2d425525() {
    return undefined;
}
function $013477420ae0c1cc$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $013477420ae0c1cc$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $013477420ae0c1cc$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $013477420ae0c1cc$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $013477420ae0c1cc$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $013477420ae0c1cc$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$013477420ae0c1cc$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === "function") return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $013477420ae0c1cc$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($013477420ae0c1cc$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === "function") return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === "function") return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function $013477420ae0c1cc$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $013477420ae0c1cc$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $013477420ae0c1cc$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $013477420ae0c1cc$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $013477420ae0c1cc$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($013477420ae0c1cc$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $013477420ae0c1cc$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$013477420ae0c1cc$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $013477420ae0c1cc$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($013477420ae0c1cc$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($013477420ae0c1cc$export$5fcb678681417b54(mutation.options.mutationKey) !== $013477420ae0c1cc$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$013477420ae0c1cc$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $013477420ae0c1cc$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $013477420ae0c1cc$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $013477420ae0c1cc$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$013477420ae0c1cc$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $013477420ae0c1cc$export$2f07189bb9fa26a7(a, b) {
    return $013477420ae0c1cc$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $013477420ae0c1cc$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$013477420ae0c1cc$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $013477420ae0c1cc$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $013477420ae0c1cc$export$7a8558113332b71e(a) && $013477420ae0c1cc$export$7a8558113332b71e(b);
    if (array || $013477420ae0c1cc$export$53b83ca8eaab0383(a) && $013477420ae0c1cc$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $013477420ae0c1cc$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $013477420ae0c1cc$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $013477420ae0c1cc$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $013477420ae0c1cc$export$53b83ca8eaab0383(o) {
    if (!$013477420ae0c1cc$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$013477420ae0c1cc$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function $013477420ae0c1cc$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $013477420ae0c1cc$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $013477420ae0c1cc$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $013477420ae0c1cc$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $013477420ae0c1cc$export$4304cb76768ca134(callback) {
    $013477420ae0c1cc$export$e772c8ff12451969(0).then(callback);
}
function $013477420ae0c1cc$export$382ca5d13a8f252c() {
    if (typeof AbortController === "function") return new AbortController();
    return;
}
function $013477420ae0c1cc$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $013477420ae0c1cc$export$77a71fc411098696(prevData, data);
    return data;
}



function $95cde0856394eaca$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $013477420ae0c1cc$export$4304cb76768ca134)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $013477420ae0c1cc$export$4304cb76768ca134)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $95cde0856394eaca$export$520687f44db6e1ab = $95cde0856394eaca$export$316a8efd03cd1458();


class $88da8163c4fbe8fc$export$d26086b469ecdbcc {
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
}



class $de75752fca34521f$export$86f1af424b2ca4de extends (0, $88da8163c4fbe8fc$export$d26086b469ecdbcc) {
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $013477420ae0c1cc$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    }
}
const $de75752fca34521f$export$6bf54661be5b02cf = new $de75752fca34521f$export$86f1af424b2ca4de();






const $6c5e1603cb7533aa$var$onlineEvents = [
    "online",
    "offline"
];
class $6c5e1603cb7533aa$export$58774fb55d5ff7fc extends (0, $88da8163c4fbe8fc$export$d26086b469ecdbcc) {
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $013477420ae0c1cc$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                $6c5e1603cb7533aa$var$onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    $6c5e1603cb7533aa$var$onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === "boolean") this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    }
}
const $6c5e1603cb7533aa$export$b113e788b2dd3fdc = new $6c5e1603cb7533aa$export$58774fb55d5ff7fc();



function $9ffb20db37442141$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $9ffb20db37442141$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : "online") === "online" ? (0, $6c5e1603cb7533aa$export$b113e788b2dd3fdc).isOnline() : true;
}
class $9ffb20db37442141$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $9ffb20db37442141$export$986cc6445c1d323(value) {
    return value instanceof $9ffb20db37442141$export$a8430ed4188f35a9;
}
function $9ffb20db37442141$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $9ffb20db37442141$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $de75752fca34521f$export$6bf54661be5b02cf).isFocused() || config.networkMode !== "always" && !(0, $6c5e1603cb7533aa$export$b113e788b2dd3fdc).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $9ffb20db37442141$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $013477420ae0c1cc$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($9ffb20db37442141$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}


class $2e43c33ae708cf27$export$a06cf8c0066f0d4c extends (0, $88da8163c4fbe8fc$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($2e43c33ae708cf27$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $2e43c33ae708cf27$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $2e43c33ae708cf27$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $013477420ae0c1cc$export$3e67810a3f0e9f1c)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $2e43c33ae708cf27$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if ($2e43c33ae708cf27$var$shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage: refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage: refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $013477420ae0c1cc$export$8793edee2d425525));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $013477420ae0c1cc$export$6acf61af03e62db) || this.currentResult.isStale || !(0, $013477420ae0c1cc$export$e539f754e934e270)(this.options.staleTime)) return;
        const time = (0, $013477420ae0c1cc$export$811b83d62bcf47f0)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $013477420ae0c1cc$export$6acf61af03e62db) || this.options.enabled === false || !(0, $013477420ae0c1cc$export$e539f754e934e270)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $de75752fca34521f$export$6bf54661be5b02cf).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $2e43c33ae708cf27$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $2e43c33ae708cf27$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $9ffb20db37442141$export$61b92f63f30245cf)(query.options.networkMode) ? "fetching" : "paused";
                if (!dataUpdatedAt) status = "loading";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $013477420ae0c1cc$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "loading") {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, $013477420ae0c1cc$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isLoading = status === "loading";
        const isError = status === "error";
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $2e43c33ae708cf27$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $013477420ae0c1cc$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add("error");
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = !action.manual;
        else if (action.type === "error" && !(0, $9ffb20db37442141$export$986cc6445c1d323)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $95cde0856394eaca$export$520687f44db6e1ab).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
}
function $2e43c33ae708cf27$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $2e43c33ae708cf27$var$shouldFetchOnMount(query, options) {
    return $2e43c33ae708cf27$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $2e43c33ae708cf27$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $2e43c33ae708cf27$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $2e43c33ae708cf27$var$isStale(query, options);
    }
    return false;
}
function $2e43c33ae708cf27$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $2e43c33ae708cf27$var$isStale(query, options);
}
function $2e43c33ae708cf27$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function $2e43c33ae708cf27$var$shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, $013477420ae0c1cc$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}


function $052cc4c6cbf6ab46$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener("abort", ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $052cc4c6cbf6ab46$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $052cc4c6cbf6ab46$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === "undefined";
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $052cc4c6cbf6ab46$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $052cc4c6cbf6ab46$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $052cc4c6cbf6ab46$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $052cc4c6cbf6ab46$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $052cc4c6cbf6ab46$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $052cc4c6cbf6ab46$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $052cc4c6cbf6ab46$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}


class $3975a2794194275d$export$85d960eb3ab339c8 extends (0, $2e43c33ae708cf27$export$a06cf8c0066f0d4c) {
    // Type override
    // Type override
    // Type override
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(client, options){
        super(client, options);
    }
    bindMethods() {
        super.bindMethods();
        this.fetchNextPage = this.fetchNextPage.bind(this);
        this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
    }
    setOptions(options, notifyOptions) {
        super.setOptions({
            ...options,
            behavior: (0, $052cc4c6cbf6ab46$export$84470d1367601e8d)()
        }, notifyOptions);
    }
    getOptimisticResult(options) {
        options.behavior = (0, $052cc4c6cbf6ab46$export$84470d1367601e8d)();
        return super.getOptimisticResult(options);
    }
    fetchNextPage({ pageParam: pageParam, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                fetchMore: {
                    direction: "forward",
                    pageParam: pageParam
                }
            }
        });
    }
    fetchPreviousPage({ pageParam: pageParam, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                fetchMore: {
                    direction: "backward",
                    pageParam: pageParam
                }
            }
        });
    }
    createResult(query, options) {
        var _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet, _state$data, _state$data2;
        const { state: state } = query;
        const result = super.createResult(query, options);
        const { isFetching: isFetching, isRefetching: isRefetching } = result;
        const isFetchingNextPage = isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === "forward";
        const isFetchingPreviousPage = isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === "backward";
        return {
            ...result,
            fetchNextPage: this.fetchNextPage,
            fetchPreviousPage: this.fetchPreviousPage,
            hasNextPage: (0, $052cc4c6cbf6ab46$export$b9c88add8b8b5e6a)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
            hasPreviousPage: (0, $052cc4c6cbf6ab46$export$db1663b730a8e6e4)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
            isFetchingNextPage: isFetchingNextPage,
            isFetchingPreviousPage: isFetchingPreviousPage,
            isRefetching: isRefetching && !isFetchingNextPage && !isFetchingPreviousPage
        };
    }
}




const $b0e648df5dd3cfff$export$1cf3d545f2d4635c = console;





class $da70579a7323b556$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $013477420ae0c1cc$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $013477420ae0c1cc$export$6acf61af03e62db) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}


// CLASS
class $bcecc2c48ec410ee$export$62297b13309008b2 extends (0, $da70579a7323b556$export$e09608847fcc8c59) {
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $b0e648df5dd3cfff$export$1cf3d545f2d4635c);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $bcecc2c48ec410ee$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $013477420ae0c1cc$export$17619bac5b909b23)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $013477420ae0c1cc$export$8793edee2d425525)).catch((0, $013477420ae0c1cc$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $013477420ae0c1cc$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, $013477420ae0c1cc$export$382ca5d13a8f252c)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $9ffb20db37442141$export$986cc6445c1d323)(error) && error.silent)) this.dispatch({
                type: "error",
                error: error
            });
            if (!(0, $9ffb20db37442141$export$986cc6445c1d323)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $9ffb20db37442141$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === "undefined") {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $9ffb20db37442141$export$61b92f63f30245cf)(this.options.networkMode) ? "fetching" : "paused",
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: "loading"
                        }
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, $9ffb20db37442141$export$986cc6445c1d323)(error) && error.revert && this.revertState) return {
                        ...this.revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $95cde0856394eaca$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
}
function $bcecc2c48ec410ee$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = typeof data !== "undefined";
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "loading",
        fetchStatus: "idle"
    };
}




// CLASS
class $ac9b2aea35d6e943$export$5dde0cd941da8468 extends (0, $88da8163c4fbe8fc$export$d26086b469ecdbcc) {
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $013477420ae0c1cc$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $bcecc2c48ec410ee$export$62297b13309008b2)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $95cde0856394eaca$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    find(arg1, arg2) {
        const [filters] = (0, $013477420ae0c1cc$export$18e8f4b987e6c111)(arg1, arg2);
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find((query)=>(0, $013477420ae0c1cc$export$c5d1efe363797780)(filters, query));
    }
    findAll(arg1, arg2) {
        const [filters] = (0, $013477420ae0c1cc$export$18e8f4b987e6c111)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $013477420ae0c1cc$export$c5d1efe363797780)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $95cde0856394eaca$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $95cde0856394eaca$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $95cde0856394eaca$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
}







// CLASS
class $fe97caffc8986233$export$17b8b19c814bcf56 extends (0, $da70579a7323b556$export$e09608847fcc8c59) {
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $b0e648df5dd3cfff$export$1cf3d545f2d4635c);
        this.observers = [];
        this.state = config.state || $fe97caffc8986233$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: "setState",
            state: state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === "loading") this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $9ffb20db37442141$export$2cbd00fe8a2c8d85)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject("No mutationFn found");
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: "failed",
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: "continue"
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === "loading";
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: "loading",
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: "loading",
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: "error",
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "loading":
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $9ffb20db37442141$export$61b92f63f30245cf)(this.options.networkMode),
                        status: "loading",
                        variables: action.variables
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $95cde0856394eaca$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
}
function $fe97caffc8986233$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}




// CLASS
class $13e7f435d7c51927$export$1fcfd9a244434844 extends (0, $88da8163c4fbe8fc$export$d26086b469ecdbcc) {
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
    build(client, options, state) {
        const mutation = new (0, $fe97caffc8986233$export$17b8b19c814bcf56)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $95cde0856394eaca$export$520687f44db6e1ab).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find((mutation)=>(0, $013477420ae0c1cc$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $013477420ae0c1cc$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $95cde0856394eaca$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $95cde0856394eaca$export$520687f44db6e1ab).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $013477420ae0c1cc$export$8793edee2d425525))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
}







// CLASS
class $bfadaea4e3067d9d$export$405d0624ed55a03f {
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $ac9b2aea35d6e943$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $13e7f435d7c51927$export$1fcfd9a244434844)();
        this.logger = config.logger || (0, $b0e648df5dd3cfff$export$1cf3d545f2d4635c);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $de75752fca34521f$export$6bf54661be5b02cf).subscribe(()=>{
            if ((0, $de75752fca34521f$export$6bf54661be5b02cf).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $6c5e1603cb7533aa$export$b113e788b2dd3fdc).subscribe(()=>{
            if ((0, $6c5e1603cb7533aa$export$b113e788b2dd3fdc).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    isFetching(arg1, arg2) {
        const [filters] = (0, $013477420ae0c1cc$export$18e8f4b987e6c111)(arg1, arg2);
        filters.fetchStatus = "fetching";
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $013477420ae0c1cc$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $013477420ae0c1cc$export$7f095f455ad5af3f)(updater, prevData);
        if (typeof data === "undefined") return undefined;
        const parsedOptions = (0, $013477420ae0c1cc$export$8a11fbc2c8ea08fd)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $95cde0856394eaca$export$520687f44db6e1ab).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    removeQueries(arg1, arg2) {
        const [filters] = (0, $013477420ae0c1cc$export$18e8f4b987e6c111)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $95cde0856394eaca$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $013477420ae0c1cc$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $95cde0856394eaca$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $013477420ae0c1cc$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        const promises = (0, $95cde0856394eaca$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $013477420ae0c1cc$export$8793edee2d425525)).catch((0, $013477420ae0c1cc$export$8793edee2d425525));
    }
    invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $013477420ae0c1cc$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        return (0, $95cde0856394eaca$export$520687f44db6e1ab).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $013477420ae0c1cc$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const promises = (0, $95cde0856394eaca$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, $013477420ae0c1cc$export$8793edee2d425525));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $013477420ae0c1cc$export$8793edee2d425525));
        return promise;
    }
    fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $013477420ae0c1cc$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $013477420ae0c1cc$export$8793edee2d425525)).catch((0, $013477420ae0c1cc$export$8793edee2d425525));
    }
    fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $013477420ae0c1cc$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $052cc4c6cbf6ab46$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    }
    prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $013477420ae0c1cc$export$8793edee2d425525)).catch((0, $013477420ae0c1cc$export$8793edee2d425525));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $013477420ae0c1cc$export$5fcb678681417b54)(queryKey) === (0, $013477420ae0c1cc$export$5fcb678681417b54)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $013477420ae0c1cc$export$2f07189bb9fa26a7)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $013477420ae0c1cc$export$5fcb678681417b54)(mutationKey) === (0, $013477420ae0c1cc$export$5fcb678681417b54)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $013477420ae0c1cc$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $013477420ae0c1cc$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.useErrorBoundary === "undefined") defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
}


var $9nZCP = parcelRequire("9nZCP");
"use client";
const $6d6ab9aaa62ea16f$export$2fba198b5b2e37fa = /*#__PURE__*/ $9nZCP.createContext(undefined);
const $6d6ab9aaa62ea16f$var$QueryClientSharingContext = /*#__PURE__*/ $9nZCP.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $6d6ab9aaa62ea16f$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $6d6ab9aaa62ea16f$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $6d6ab9aaa62ea16f$export$2fba198b5b2e37fa;
}
const $6d6ab9aaa62ea16f$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $9nZCP.useContext($6d6ab9aaa62ea16f$var$getQueryClientContext(context, $9nZCP.useContext($6d6ab9aaa62ea16f$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
const $6d6ab9aaa62ea16f$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $9nZCP.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $6d6ab9aaa62ea16f$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $9nZCP.createElement($6d6ab9aaa62ea16f$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $9nZCP.createElement(Context.Provider, {
        value: client
    }, children));
};


var $9nZCP = parcelRequire("9nZCP");
"use client";
const $01256efc3ced208c$var$IsRestoringContext = /*#__PURE__*/ $9nZCP.createContext(false);
const $01256efc3ced208c$export$4da0178d6b5f553 = ()=>$9nZCP.useContext($01256efc3ced208c$var$IsRestoringContext);
const $01256efc3ced208c$export$593807d4e94f9621 = $01256efc3ced208c$var$IsRestoringContext.Provider;


var $9nZCP = parcelRequire("9nZCP");




// CLASS
class $68122633c087f790$export$d3c1860ee66f291a extends (0, $88da8163c4fbe8fc$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.client = client;
        this.setOptions(options);
        this.bindMethods();
        this.updateResult();
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _this$currentMutation;
        const prevOptions = this.options;
        this.options = this.client.defaultMutationOptions(options);
        if (!(0, $013477420ae0c1cc$export$3e67810a3f0e9f1c)(prevOptions, this.options)) this.client.getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: this.currentMutation,
            observer: this
        });
        (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$currentMutation2;
            (_this$currentMutation2 = this.currentMutation) == null || _this$currentMutation2.removeObserver(this);
        }
    }
    onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        const notifyOptions = {
            listeners: true
        };
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error") notifyOptions.onError = true;
        this.notify(notifyOptions);
    }
    getCurrentResult() {
        return this.currentResult;
    }
    reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    }
    mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, {
            ...this.options,
            variables: typeof variables !== "undefined" ? variables : this.options.variables
        });
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    }
    updateResult() {
        const state = this.currentMutation ? this.currentMutation.state : (0, $fe97caffc8986233$export$a1659b54bac3252a)();
        const result = {
            ...state,
            isLoading: state.status === "loading",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        };
        this.currentResult = result;
    }
    notify(options) {
        (0, $95cde0856394eaca$export$520687f44db6e1ab).batch(()=>{
            // First trigger the mutate callbacks
            if (this.mutateOptions && this.hasListeners()) {
                if (options.onSuccess) {
                    var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;
                    (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null || _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
                } else if (options.onError) {
                    var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;
                    (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null || _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
        });
    }
}



var $fathW = parcelRequire("fathW");
"use client";
const $35a9e77badf401d4$export$306c0aa65ff9ec16 = (0, $fathW.useSyncExternalStore);



function $26824e177b094e25$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}


"use client";
function $b600b0ad69e6ec87$export$609860bf8b0084c(arg1, arg2, arg3) {
    const options = (0, $013477420ae0c1cc$export$b646c531ea475334)(arg1, arg2, arg3);
    const queryClient = (0, $6d6ab9aaa62ea16f$export$22e77b9572c4fded)({
        context: options.context
    });
    const [observer] = $9nZCP.useState(()=>new (0, $68122633c087f790$export$d3c1860ee66f291a)(queryClient, options));
    $9nZCP.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = (0, $35a9e77badf401d4$export$306c0aa65ff9ec16)($9nZCP.useCallback((onStoreChange)=>observer.subscribe((0, $95cde0856394eaca$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $9nZCP.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch($b600b0ad69e6ec87$var$noop);
    }, [
        observer
    ]);
    if (result.error && (0, $26824e177b094e25$export$2072f68e6c3507cf)(observer.options.useErrorBoundary, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
} // eslint-disable-next-line @typescript-eslint/no-empty-function
function $b600b0ad69e6ec87$var$noop() {}


var $9nZCP = parcelRequire("9nZCP");
"use client";
function $5b612932a4d5ecb0$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $5b612932a4d5ecb0$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $9nZCP.createContext($5b612932a4d5ecb0$var$createValue()); // HOOK
const $5b612932a4d5ecb0$export$50dfac555130cafd = ()=>$9nZCP.useContext($5b612932a4d5ecb0$var$QueryErrorResetBoundaryContext); // COMPONENT
const $5b612932a4d5ecb0$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $9nZCP.useState(()=>$5b612932a4d5ecb0$var$createValue());
    return /*#__PURE__*/ $9nZCP.createElement($5b612932a4d5ecb0$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};


// TYPES
// FUNCTIONS
function $5f4f8645ba54cb5e$var$dehydrateMutation(mutation) {
    return {
        mutationKey: mutation.options.mutationKey,
        state: mutation.state
    };
} // Most config is not dehydrated but instead meant to configure again when
// consuming the de/rehydrated data, typically with useQuery on the client.
// Sometimes it might make sense to prefetch data on the server and include
// in the html-payload, but not consume it on the initial render.
function $5f4f8645ba54cb5e$var$dehydrateQuery(query) {
    return {
        state: query.state,
        queryKey: query.queryKey,
        queryHash: query.queryHash
    };
}
function $5f4f8645ba54cb5e$export$3aa4c2840e01e53(mutation) {
    return mutation.state.isPaused;
}
function $5f4f8645ba54cb5e$export$e71bc20295698fa1(query) {
    return query.state.status === "success";
}
function $5f4f8645ba54cb5e$export$12aee8bb597e7dfe(client, options = {}) {
    const mutations = [];
    const queries = [];
    if (options.dehydrateMutations !== false) {
        const shouldDehydrateMutation = options.shouldDehydrateMutation || $5f4f8645ba54cb5e$export$3aa4c2840e01e53;
        client.getMutationCache().getAll().forEach((mutation)=>{
            if (shouldDehydrateMutation(mutation)) mutations.push($5f4f8645ba54cb5e$var$dehydrateMutation(mutation));
        });
    }
    if (options.dehydrateQueries !== false) {
        const shouldDehydrateQuery = options.shouldDehydrateQuery || $5f4f8645ba54cb5e$export$e71bc20295698fa1;
        client.getQueryCache().getAll().forEach((query)=>{
            if (shouldDehydrateQuery(query)) queries.push($5f4f8645ba54cb5e$var$dehydrateQuery(query));
        });
    }
    return {
        mutations: mutations,
        queries: queries
    };
}
function $5f4f8645ba54cb5e$export$fa8d919ba61d84db(client, dehydratedState, options) {
    if (typeof dehydratedState !== "object" || dehydratedState === null) return;
    const mutationCache = client.getMutationCache();
    const queryCache = client.getQueryCache(); // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const mutations = dehydratedState.mutations || []; // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const queries = dehydratedState.queries || [];
    mutations.forEach((dehydratedMutation)=>{
        var _options$defaultOptio;
        mutationCache.build(client, {
            ...options == null ? void 0 : (_options$defaultOptio = options.defaultOptions) == null ? void 0 : _options$defaultOptio.mutations,
            mutationKey: dehydratedMutation.mutationKey
        }, dehydratedMutation.state);
    });
    queries.forEach(({ queryKey: queryKey, state: state, queryHash: queryHash })=>{
        var _options$defaultOptio2;
        const query = queryCache.get(queryHash); // Do not hydrate if an existing query exists with newer data
        if (query) {
            if (query.state.dataUpdatedAt < state.dataUpdatedAt) {
                // omit fetchStatus from dehydrated state
                // so that query stays in its current fetchStatus
                const { fetchStatus: _ignored, ...dehydratedQueryState } = state;
                query.setState(dehydratedQueryState);
            }
            return;
        } // Restore query
        queryCache.build(client, {
            ...options == null ? void 0 : (_options$defaultOptio2 = options.defaultOptions) == null ? void 0 : _options$defaultOptio2.queries,
            queryKey: queryKey,
            queryHash: queryHash
        }, // query being stuck in fetching state upon hydration
        {
            ...state,
            fetchStatus: "idle"
        });
    });
}


/**
 * Checks if emitted event is about cache change and not about observers.
 * Useful for persist, where we only want to trigger save when cache is changed.
 */ const $99532ec7b7e86a9b$var$cacheableEventTypes = [
    "added",
    "removed",
    "updated"
];
function $99532ec7b7e86a9b$var$isCacheableEventType(eventType) {
    return $99532ec7b7e86a9b$var$cacheableEventTypes.includes(eventType);
}
/**
 * Restores persisted data to the QueryCache
 *  - data obtained from persister.restoreClient
 *  - data is hydrated using hydrateOptions
 * If data is expired, busted, empty, or throws, it runs persister.removeClient
 */ async function $99532ec7b7e86a9b$export$781eb0ebad7272a1({ queryClient: queryClient, persister: persister, maxAge: maxAge = 86400000, buster: buster = "", hydrateOptions: hydrateOptions }) {
    try {
        const persistedClient = await persister.restoreClient();
        if (persistedClient) {
            if (persistedClient.timestamp) {
                const expired = Date.now() - persistedClient.timestamp > maxAge;
                const busted = persistedClient.buster !== buster;
                if (expired || busted) persister.removeClient();
                else (0, $5f4f8645ba54cb5e$export$fa8d919ba61d84db)(queryClient, persistedClient.clientState, hydrateOptions);
            } else persister.removeClient();
        }
    } catch (err) {
        persister.removeClient();
    }
}
/**
 * Persists data from the QueryCache
 *  - data dehydrated using dehydrateOptions
 *  - data is persisted using persister.persistClient
 */ async function $99532ec7b7e86a9b$export$8a3b4786a14f2528({ queryClient: queryClient, persister: persister, buster: buster = "", dehydrateOptions: dehydrateOptions }) {
    const persistClient = {
        buster: buster,
        timestamp: Date.now(),
        clientState: (0, $5f4f8645ba54cb5e$export$12aee8bb597e7dfe)(queryClient, dehydrateOptions)
    };
    await persister.persistClient(persistClient);
}
/**
 * Subscribe to QueryCache and MutationCache updates (for persisting)
 * @returns an unsubscribe function (to discontinue monitoring)
 */ function $99532ec7b7e86a9b$export$9fe01d80627be88c(props) {
    const unsubscribeQueryCache = props.queryClient.getQueryCache().subscribe((event)=>{
        if ($99532ec7b7e86a9b$var$isCacheableEventType(event.type)) $99532ec7b7e86a9b$export$8a3b4786a14f2528(props);
    });
    const unusbscribeMutationCache = props.queryClient.getMutationCache().subscribe((event)=>{
        if ($99532ec7b7e86a9b$var$isCacheableEventType(event.type)) $99532ec7b7e86a9b$export$8a3b4786a14f2528(props);
    });
    return ()=>{
        unsubscribeQueryCache();
        unusbscribeMutationCache();
    };
}
/**
 * Restores persisted data to QueryCache and persists further changes.
 */ function $99532ec7b7e86a9b$export$217ab42a80f50b3b(props) {
    let hasUnsubscribed = false;
    let persistQueryClientUnsubscribe;
    const unsubscribe = ()=>{
        hasUnsubscribed = true;
        persistQueryClientUnsubscribe == null || persistQueryClientUnsubscribe();
    }; // Attempt restore
    const restorePromise = $99532ec7b7e86a9b$export$781eb0ebad7272a1(props).then(()=>{
        if (!hasUnsubscribed) // Subscribe to changes in the query cache to trigger the save
        persistQueryClientUnsubscribe = $99532ec7b7e86a9b$export$9fe01d80627be88c(props);
    });
    return [
        unsubscribe,
        restorePromise
    ];
}



var $hzb7Z = parcelRequire("hzb7Z");

var $9nZCP = parcelRequire("9nZCP");

var $fathW = parcelRequire("fathW");
var $7a1082458380e640$exports = {};
"use strict";

$7a1082458380e640$exports = (parcelRequire("ld1vO"));



var $hzb7Z = parcelRequire("hzb7Z");

"use client";
function $b9a08c139e2d6879$export$45a69314cf48a3eb({ queryClient: queryClient = new (0, $bfadaea4e3067d9d$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            cacheTime: 86400000,
            networkMode: "offlineFirst",
            refetchOnWindowFocus: false,
            retry: 0
        },
        mutations: {
            networkMode: "offlineFirst"
        }
    }
}), storage: storage = (0, $hzb7Z.createStorage)({
    storage: typeof window !== "undefined" && window.localStorage ? window.localStorage : (0, $hzb7Z.noopStorage)
}), persister: persister = typeof window !== "undefined" ? (0, $2b016d4b9c30a5ee$export$35561f995d4e487d)({
    key: "cache",
    storage: storage,
    serialize: (x)=>x,
    deserialize: (x)=>x
}) : void 0, ...args }) {
    const config = (0, $hzb7Z.createConfig)({
        ...args,
        storage: storage
    });
    if (persister) (0, $99532ec7b7e86a9b$export$217ab42a80f50b3b)({
        queryClient: queryClient,
        persister: persister,
        dehydrateOptions: {
            shouldDehydrateQuery: (query)=>query.cacheTime !== 0 && query.queryKey[0].persist !== false
        }
    });
    return Object.assign(config, {
        queryClient: queryClient
    });
}
var $b9a08c139e2d6879$export$841858b892ce1f4c = $9nZCP.createContext(void 0);
var $b9a08c139e2d6879$var$queryClientContext = $9nZCP.createContext(void 0);
function $b9a08c139e2d6879$export$c3a561dea2adc16c({ children: children, config: config }) {
    return $9nZCP.createElement($b9a08c139e2d6879$export$841858b892ce1f4c.Provider, {
        children: $9nZCP.createElement((0, $6d6ab9aaa62ea16f$export$45604f0cc8ae667b), {
            children: children,
            client: config.queryClient,
            context: $b9a08c139e2d6879$var$queryClientContext
        }),
        value: config
    });
}
function $b9a08c139e2d6879$export$b3611e87cd5ba6ce() {
    const config = $9nZCP.useContext($b9a08c139e2d6879$export$841858b892ce1f4c);
    if (!config) throw new Error([
        "`useConfig` must be used within `WagmiConfig`.\n",
        "Read more: https://wagmi.sh/react/WagmiConfig"
    ].join("\n"));
    return config;
}
var $b9a08c139e2d6879$var$useSyncExternalStore2 = $fathW.useSyncExternalStore;
// src/hooks/utils/query/utils.ts
function $b9a08c139e2d6879$var$isQueryKey(value) {
    return Array.isArray(value);
}
function $b9a08c139e2d6879$var$isPlainObject(o) {
    if (!$b9a08c139e2d6879$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
    const prot = ctor.prototype;
    if (!$b9a08c139e2d6879$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    return true;
}
function $b9a08c139e2d6879$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $b9a08c139e2d6879$var$parseQueryArgs(arg1, arg2, arg3) {
    if (!$b9a08c139e2d6879$var$isQueryKey(arg1)) return arg1;
    if (typeof arg2 === "function") return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $b9a08c139e2d6879$var$queryKeyHashFn(queryKey17) {
    return JSON.stringify(queryKey17, (_, val)=>$b9a08c139e2d6879$var$isPlainObject(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : typeof val === "bigint" ? val.toString() : val);
}
function $b9a08c139e2d6879$var$shouldThrowError(_useErrorBoundary, params) {
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}
function $b9a08c139e2d6879$var$trackResult(result, observer) {
    const trackedResult = {};
    Object.keys(result).forEach((key)=>{
        Object.defineProperty(trackedResult, key, {
            configurable: false,
            enumerable: true,
            get: ()=>{
                observer.trackedProps.add(key);
                return result[key];
            }
        });
    });
    return trackedResult;
}
// src/hooks/utils/query/useBaseQuery.ts
function $b9a08c139e2d6879$var$useBaseQuery(options, Observer) {
    const queryClient = (0, $6d6ab9aaa62ea16f$export$22e77b9572c4fded)({
        context: options.context
    });
    const isRestoring = (0, $01256efc3ced208c$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $5b612932a4d5ecb0$export$50dfac555130cafd)();
    const defaultedOptions = queryClient.defaultQueryOptions({
        ...options,
        queryKeyHashFn: $b9a08c139e2d6879$var$queryKeyHashFn
    });
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $95cde0856394eaca$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $95cde0856394eaca$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $95cde0856394eaca$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    if (defaultedOptions.suspense) {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1e3;
    }
    if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
        if (!errorResetBoundary.isReset()) defaultedOptions.retryOnMount = false;
    }
    const [observer] = $9nZCP.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    $b9a08c139e2d6879$var$useSyncExternalStore2($9nZCP.useCallback((onStoreChange)=>isRestoring ? ()=>void 0 : observer.subscribe((0, $95cde0856394eaca$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $9nZCP.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
    $9nZCP.useEffect(()=>{
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]);
    if (defaultedOptions.suspense && result.isLoading && result.isFetching && !isRestoring) throw observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess?.(data);
        defaultedOptions.onSettled?.(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError?.(error);
        defaultedOptions.onSettled?.(void 0, error);
    });
    if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && $b9a08c139e2d6879$var$shouldThrowError(defaultedOptions.useErrorBoundary, [
        result.error,
        observer.getCurrentQuery()
    ])) throw result.error;
    const status = result.status === "loading" && result.fetchStatus === "idle" ? "idle" : result.status;
    const isIdle = status === "idle";
    const isLoading = status === "loading" && result.fetchStatus === "fetching";
    return {
        ...result,
        defaultedOptions: defaultedOptions,
        isIdle: isIdle,
        isLoading: isLoading,
        observer: observer,
        status: status
    };
}
function $b9a08c139e2d6879$export$bdc59d3c1a6569aa(arg1, arg2, arg3) {
    const parsedOptions = $b9a08c139e2d6879$var$parseQueryArgs(arg1, arg2, arg3);
    const baseQuery = $b9a08c139e2d6879$var$useBaseQuery({
        context: $b9a08c139e2d6879$var$queryClientContext,
        ...parsedOptions
    }, (0, $3975a2794194275d$export$85d960eb3ab339c8));
    const result = {
        data: baseQuery.data,
        error: baseQuery.error,
        fetchNextPage: baseQuery.fetchNextPage,
        fetchStatus: baseQuery.fetchStatus,
        hasNextPage: baseQuery.hasNextPage,
        isError: baseQuery.isError,
        isFetched: baseQuery.isFetched,
        isFetchedAfterMount: baseQuery.isFetchedAfterMount,
        isFetching: baseQuery.isFetching,
        isFetchingNextPage: baseQuery.isFetchingNextPage,
        isIdle: baseQuery.isIdle,
        isLoading: baseQuery.isLoading,
        isRefetching: baseQuery.isRefetching,
        isSuccess: baseQuery.isSuccess,
        refetch: baseQuery.refetch,
        status: baseQuery.status,
        internal: {
            dataUpdatedAt: baseQuery.dataUpdatedAt,
            errorUpdatedAt: baseQuery.errorUpdatedAt,
            failureCount: baseQuery.failureCount,
            isFetchedAfterMount: baseQuery.isFetchedAfterMount,
            isLoadingError: baseQuery.isLoadingError,
            isPaused: baseQuery.isPaused,
            isPlaceholderData: baseQuery.isPlaceholderData,
            isPreviousData: baseQuery.isPreviousData,
            isRefetchError: baseQuery.isRefetchError,
            isStale: baseQuery.isStale,
            remove: baseQuery.remove
        }
    };
    return !baseQuery.defaultedOptions.notifyOnChangeProps ? $b9a08c139e2d6879$var$trackResult(result, baseQuery.observer) : result;
}
function $b9a08c139e2d6879$export$609860bf8b0084c(arg1, arg2, arg3) {
    const options = (0, $013477420ae0c1cc$export$b646c531ea475334)(arg1, arg2, arg3);
    return (0, $b600b0ad69e6ec87$export$609860bf8b0084c)({
        context: $b9a08c139e2d6879$var$queryClientContext,
        ...options
    });
}
function $b9a08c139e2d6879$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = $b9a08c139e2d6879$var$parseQueryArgs(arg1, arg2, arg3);
    const baseQuery = $b9a08c139e2d6879$var$useBaseQuery({
        context: $b9a08c139e2d6879$var$queryClientContext,
        ...parsedOptions
    }, (0, $2e43c33ae708cf27$export$a06cf8c0066f0d4c));
    const result = {
        data: baseQuery.data,
        error: baseQuery.error,
        fetchStatus: baseQuery.fetchStatus,
        isError: baseQuery.isError,
        isFetched: baseQuery.isFetched,
        isFetchedAfterMount: baseQuery.isFetchedAfterMount,
        isFetching: baseQuery.isFetching,
        isIdle: baseQuery.isIdle,
        isLoading: baseQuery.isLoading,
        isRefetching: baseQuery.isRefetching,
        isSuccess: baseQuery.isSuccess,
        refetch: baseQuery.refetch,
        status: baseQuery.status,
        internal: {
            dataUpdatedAt: baseQuery.dataUpdatedAt,
            errorUpdatedAt: baseQuery.errorUpdatedAt,
            failureCount: baseQuery.failureCount,
            isFetchedAfterMount: baseQuery.isFetchedAfterMount,
            isLoadingError: baseQuery.isLoadingError,
            isPaused: baseQuery.isPaused,
            isPlaceholderData: baseQuery.isPlaceholderData,
            isPreviousData: baseQuery.isPreviousData,
            isRefetchError: baseQuery.isRefetchError,
            isStale: baseQuery.isStale,
            remove: baseQuery.remove
        }
    };
    return !baseQuery.defaultedOptions.notifyOnChangeProps ? $b9a08c139e2d6879$var$trackResult(result, baseQuery.observer) : result;
}
var $b9a08c139e2d6879$export$22e77b9572c4fded = ()=>(0, $6d6ab9aaa62ea16f$export$22e77b9572c4fded)({
        context: $b9a08c139e2d6879$var$queryClientContext
    });
function $b9a08c139e2d6879$export$3ca3483c611a99c4({ chainId: chainId } = {}) {
    return (0, $7a1082458380e640$exports.useSyncExternalStoreWithSelector)((cb)=>(0, $hzb7Z.watchPublicClient)({
            chainId: chainId
        }, cb), ()=>(0, $hzb7Z.getPublicClient)({
            chainId: chainId
        }), ()=>(0, $hzb7Z.getPublicClient)({
            chainId: chainId
        }), (x)=>x, (a, b)=>a.uid === b.uid);
}
function $b9a08c139e2d6879$var$queryKey({ chainId: chainId }) {
    return [
        {
            entity: "walletClient",
            chainId: chainId,
            persist: false
        }
    ];
}
function $b9a08c139e2d6879$var$queryFn({ queryKey: [{ chainId: chainId }] }) {
    return (0, $hzb7Z.getWalletClient)({
        chainId: chainId
    });
}
function $b9a08c139e2d6879$export$742c698ad1033029({ chainId: chainId_, suspense: suspense, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const { connector: connector } = $b9a08c139e2d6879$export$83a8e409853da004();
    const chainId = $b9a08c139e2d6879$export$dc276622421ed31d({
        chainId: chainId_
    });
    const walletClientQuery = $b9a08c139e2d6879$export$dd0a697e1782aedd($b9a08c139e2d6879$var$queryKey({
        chainId: chainId
    }), $b9a08c139e2d6879$var$queryFn, {
        cacheTime: 0,
        enabled: Boolean(connector),
        staleTime: Infinity,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    const queryClient = $b9a08c139e2d6879$export$22e77b9572c4fded();
    $9nZCP.useEffect(()=>{
        const unwatch = (0, $hzb7Z.watchWalletClient)({
            chainId: chainId
        }, (walletClient)=>{
            if (walletClient) queryClient.invalidateQueries($b9a08c139e2d6879$var$queryKey({
                chainId: chainId
            }));
            else queryClient.removeQueries($b9a08c139e2d6879$var$queryKey({
                chainId: chainId
            }));
        });
        return unwatch;
    }, [
        queryClient,
        chainId
    ]);
    return walletClientQuery;
}
function $b9a08c139e2d6879$export$724f5280724585ed({ chainId: chainId } = {}) {
    return (0, $7a1082458380e640$exports.useSyncExternalStoreWithSelector)((cb)=>(0, $hzb7Z.watchWebSocketPublicClient)({
            chainId: chainId
        }, cb), ()=>(0, $hzb7Z.getWebSocketPublicClient)({
            chainId: chainId
        }), ()=>(0, $hzb7Z.getWebSocketPublicClient)({
            chainId: chainId
        }), (x)=>x, (a, b)=>a?.uid === b?.uid);
}
// src/hooks/utils/useChainId.ts
function $b9a08c139e2d6879$export$dc276622421ed31d({ chainId: chainId } = {}) {
    const publicClient = $b9a08c139e2d6879$export$3ca3483c611a99c4({
        chainId: chainId
    });
    return publicClient.chain.id;
}
function $b9a08c139e2d6879$var$useForceUpdate() {
    const [, forceUpdate] = $9nZCP.useReducer((x)=>x + 1, 0);
    return forceUpdate;
}
function $b9a08c139e2d6879$var$queryKey2({ chainId: chainId, scopeKey: scopeKey }) {
    return [
        {
            entity: "blockNumber",
            chainId: chainId,
            scopeKey: scopeKey
        }
    ];
}
function $b9a08c139e2d6879$var$queryFn2({ queryKey: [{ chainId: chainId }] }) {
    return (0, $hzb7Z.fetchBlockNumber)({
        chainId: chainId
    });
}
function $b9a08c139e2d6879$export$8bf0355f69442463({ cacheTime: cacheTime = 0, chainId: chainId_, enabled: enabled = true, scopeKey: scopeKey, staleTime: staleTime, suspense: suspense, watch: watch = false, onBlock: onBlock, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $b9a08c139e2d6879$export$dc276622421ed31d({
        chainId: chainId_
    });
    const publicClient = $b9a08c139e2d6879$export$3ca3483c611a99c4({
        chainId: chainId
    });
    const webSocketPublicClient = $b9a08c139e2d6879$export$724f5280724585ed({
        chainId: chainId
    });
    const queryClient = $b9a08c139e2d6879$export$22e77b9572c4fded();
    $9nZCP.useEffect(()=>{
        if (!enabled) return;
        if (!watch && !onBlock) return;
        const publicClient_ = webSocketPublicClient ?? publicClient;
        const unwatch = publicClient_.watchBlockNumber({
            onBlockNumber: (blockNumber)=>{
                if (watch) queryClient.setQueryData($b9a08c139e2d6879$var$queryKey2({
                    chainId: chainId,
                    scopeKey: scopeKey
                }), blockNumber);
                if (onBlock) onBlock(blockNumber);
            },
            emitOnBegin: true
        });
        return unwatch;
    }, [
        chainId,
        scopeKey,
        onBlock,
        publicClient,
        queryClient,
        watch,
        webSocketPublicClient,
        enabled
    ]);
    return $b9a08c139e2d6879$export$dd0a697e1782aedd($b9a08c139e2d6879$var$queryKey2({
        scopeKey: scopeKey,
        chainId: chainId
    }), $b9a08c139e2d6879$var$queryFn2, {
        cacheTime: cacheTime,
        enabled: enabled,
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $b9a08c139e2d6879$var$queryKey3({ chainId: chainId, formatUnits: formatUnits, scopeKey: scopeKey }) {
    return [
        {
            entity: "feeData",
            chainId: chainId,
            formatUnits: formatUnits,
            scopeKey: scopeKey
        }
    ];
}
function $b9a08c139e2d6879$var$queryFn3({ queryKey: [{ chainId: chainId, formatUnits: formatUnits }] }) {
    return (0, $hzb7Z.fetchFeeData)({
        chainId: chainId,
        formatUnits: formatUnits
    });
}
function $b9a08c139e2d6879$export$a72889bdc63e24a6({ cacheTime: cacheTime, chainId: chainId_, enabled: enabled = true, formatUnits: formatUnits = "gwei", scopeKey: scopeKey, staleTime: staleTime, suspense: suspense, watch: watch, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $b9a08c139e2d6879$export$dc276622421ed31d({
        chainId: chainId_
    });
    const queryKey_ = $9nZCP.useMemo(()=>$b9a08c139e2d6879$var$queryKey3({
            chainId: chainId,
            formatUnits: formatUnits,
            scopeKey: scopeKey
        }), [
        chainId,
        formatUnits,
        scopeKey
    ]);
    const feeDataQuery = $b9a08c139e2d6879$export$dd0a697e1782aedd(queryKey_, $b9a08c139e2d6879$var$queryFn3, {
        cacheTime: cacheTime,
        enabled: enabled,
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    $b9a08c139e2d6879$var$useInvalidateOnBlock({
        chainId: chainId,
        enabled: Boolean(enabled && watch),
        queryKey: queryKey_
    });
    return feeDataQuery;
}
// src/hooks/utils/useInvalidateOnBlock.ts
function $b9a08c139e2d6879$var$useInvalidateOnBlock({ chainId: chainId, enabled: enabled, queryKey: queryKey17 }) {
    const queryClient = $b9a08c139e2d6879$export$22e77b9572c4fded();
    const onBlock = $9nZCP.useCallback(()=>queryClient.invalidateQueries({
            queryKey: queryKey17
        }, {
            cancelRefetch: false
        }), [
        queryClient,
        queryKey17
    ]);
    $b9a08c139e2d6879$export$8bf0355f69442463({
        chainId: chainId,
        enabled: enabled,
        onBlock: enabled ? onBlock : void 0,
        scopeKey: enabled ? void 0 : "idle"
    });
}
var $b9a08c139e2d6879$var$isPlainObject2 = (obj)=>typeof obj === "object" && !Array.isArray(obj);
function $b9a08c139e2d6879$var$useSyncExternalStoreWithTracked(subscribe, getSnapshot, getServerSnapshot = getSnapshot, isEqual = (0, $hzb7Z.deepEqual)) {
    const trackedKeys = $9nZCP.useRef([]);
    const result = (0, $7a1082458380e640$exports.useSyncExternalStoreWithSelector)(subscribe, getSnapshot, getServerSnapshot, (x)=>x, (a, b)=>{
        if ($b9a08c139e2d6879$var$isPlainObject2(a) && $b9a08c139e2d6879$var$isPlainObject2(b) && trackedKeys.current.length) {
            for (const key of trackedKeys.current){
                const equal = isEqual(a[key], b[key]);
                if (!equal) return false;
            }
            return true;
        }
        return isEqual(a, b);
    });
    if ($b9a08c139e2d6879$var$isPlainObject2(result)) {
        const trackedResult = {
            ...result
        };
        Object.defineProperties(trackedResult, Object.entries(trackedResult).reduce((res, [key, value])=>{
            return {
                ...res,
                [key]: {
                    configurable: false,
                    enumerable: true,
                    get: ()=>{
                        if (!trackedKeys.current.includes(key)) trackedKeys.current.push(key);
                        return value;
                    }
                }
            };
        }, {}));
        return trackedResult;
    }
    return result;
}
// src/hooks/accounts/useAccount.ts
function $b9a08c139e2d6879$export$83a8e409853da004({ onConnect: onConnect, onDisconnect: onDisconnect } = {}) {
    const config = $b9a08c139e2d6879$export$b3611e87cd5ba6ce();
    const watchAccount_ = $9nZCP.useCallback((callback)=>(0, $hzb7Z.watchAccount)(callback), [
        config
    ]);
    const account = $b9a08c139e2d6879$var$useSyncExternalStoreWithTracked(watchAccount_, (0, $hzb7Z.getAccount));
    const previousAccountRef = $9nZCP.useRef();
    const previousAccount = previousAccountRef.current;
    $9nZCP.useEffect(()=>{
        if (previousAccount?.status !== "connected" && account.status === "connected") onConnect?.({
            address: account.address,
            connector: account.connector,
            isReconnected: previousAccount?.status === "reconnecting" || previousAccount?.status === void 0
        });
        if (previousAccount?.status === "connected" && account.status === "disconnected") onDisconnect?.();
        previousAccountRef.current = account;
    }, [
        onConnect,
        onDisconnect,
        previousAccount,
        account
    ]);
    return account;
}
function $b9a08c139e2d6879$var$queryKey4({ address: address, chainId: chainId, formatUnits: formatUnits, scopeKey: scopeKey, token: token }) {
    return [
        {
            entity: "balance",
            address: address,
            chainId: chainId,
            formatUnits: formatUnits,
            scopeKey: scopeKey,
            token: token
        }
    ];
}
function $b9a08c139e2d6879$var$queryFn4({ queryKey: [{ address: address, chainId: chainId, formatUnits: formatUnits, token: token }] }) {
    if (!address) throw new Error("address is required");
    return (0, $hzb7Z.fetchBalance)({
        address: address,
        chainId: chainId,
        formatUnits: formatUnits,
        token: token
    });
}
function $b9a08c139e2d6879$export$4f026b09e764c1f8({ address: address, cacheTime: cacheTime, chainId: chainId_, enabled: enabled = true, formatUnits: formatUnits, scopeKey: scopeKey, staleTime: staleTime, suspense: suspense, token: token, watch: watch, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $b9a08c139e2d6879$export$dc276622421ed31d({
        chainId: chainId_
    });
    const queryKey_ = $9nZCP.useMemo(()=>$b9a08c139e2d6879$var$queryKey4({
            address: address,
            chainId: chainId,
            formatUnits: formatUnits,
            scopeKey: scopeKey,
            token: token
        }), [
        address,
        chainId,
        formatUnits,
        scopeKey,
        token
    ]);
    const balanceQuery = $b9a08c139e2d6879$export$dd0a697e1782aedd(queryKey_, $b9a08c139e2d6879$var$queryFn4, {
        cacheTime: cacheTime,
        enabled: Boolean(enabled && address),
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    $b9a08c139e2d6879$var$useInvalidateOnBlock({
        chainId: chainId,
        enabled: Boolean(enabled && watch && address),
        queryKey: queryKey_
    });
    return balanceQuery;
}
var $b9a08c139e2d6879$var$mutationKey = (args)=>[
        {
            entity: "connect",
            ...args
        }
    ];
var $b9a08c139e2d6879$var$mutationFn = (args)=>{
    const { connector: connector, chainId: chainId } = args;
    if (!connector) throw new Error("connector is required");
    return (0, $hzb7Z.connect)({
        connector: connector,
        chainId: chainId
    });
};
function $b9a08c139e2d6879$export$5daf65c1af3b369f({ chainId: chainId, connector: connector, onError: onError, onMutate: onMutate, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const config = $b9a08c139e2d6879$export$b3611e87cd5ba6ce();
    const { data: data, error: error, isError: isError, isIdle: isIdle, isLoading: isLoading, isSuccess: isSuccess, mutate: mutate, mutateAsync: mutateAsync, reset: reset, status: status, variables: variables } = $b9a08c139e2d6879$export$609860bf8b0084c($b9a08c139e2d6879$var$mutationKey({
        connector: connector,
        chainId: chainId
    }), $b9a08c139e2d6879$var$mutationFn, {
        onError: onError,
        onMutate: onMutate,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    const connect2 = $9nZCP.useCallback((args)=>{
        return mutate({
            chainId: args?.chainId ?? chainId,
            connector: args?.connector ?? connector
        });
    }, [
        chainId,
        connector,
        mutate
    ]);
    const connectAsync = $9nZCP.useCallback((args)=>{
        return mutateAsync({
            chainId: args?.chainId ?? chainId,
            connector: args?.connector ?? connector
        });
    }, [
        chainId,
        connector,
        mutateAsync
    ]);
    return {
        connect: connect2,
        connectAsync: connectAsync,
        connectors: config.connectors,
        data: data,
        error: error,
        isError: isError,
        isIdle: isIdle,
        isLoading: isLoading,
        isSuccess: isSuccess,
        pendingConnector: variables?.connector,
        reset: reset,
        status: status,
        variables: variables
    };
}
var $b9a08c139e2d6879$var$mutationKey2 = [
    {
        entity: "disconnect"
    }
];
var $b9a08c139e2d6879$var$mutationFn2 = ()=>(0, $hzb7Z.disconnect)();
function $b9a08c139e2d6879$export$83bebf2fe7fead4e({ onError: onError, onMutate: onMutate, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const { error: error, isError: isError, isIdle: isIdle, isLoading: isLoading, isSuccess: isSuccess, mutate: disconnect2, mutateAsync: disconnectAsync, reset: reset, status: status } = $b9a08c139e2d6879$export$609860bf8b0084c($b9a08c139e2d6879$var$mutationKey2, $b9a08c139e2d6879$var$mutationFn2, {
        ...onError ? {
            onError (error2, _variables, context) {
                onError(error2, context);
            }
        } : {},
        onMutate: onMutate,
        ...onSettled ? {
            onSettled (_data, error2, _variables, context) {
                onSettled(error2, context);
            }
        } : {},
        ...onSuccess ? {
            onSuccess (_data, _variables, context) {
                onSuccess(context);
            }
        } : {}
    });
    return {
        disconnect: disconnect2,
        disconnectAsync: disconnectAsync,
        error: error,
        isError: isError,
        isIdle: isIdle,
        isLoading: isLoading,
        isSuccess: isSuccess,
        reset: reset,
        status: status
    };
}
function $b9a08c139e2d6879$export$553aaf59afc1a2d8() {
    const config = $b9a08c139e2d6879$export$b3611e87cd5ba6ce();
    const watchNetwork_ = (0, $9nZCP.useCallback)((callback)=>(0, $hzb7Z.watchNetwork)(callback), [
        config
    ]);
    return $b9a08c139e2d6879$var$useSyncExternalStoreWithTracked(watchNetwork_, (0, $hzb7Z.getNetwork));
}
var $b9a08c139e2d6879$var$mutationKey3 = (args)=>[
        {
            entity: "signMessage",
            ...args
        }
    ];
var $b9a08c139e2d6879$var$mutationFn3 = (args)=>{
    const { message: message } = args;
    if (!message) throw new Error("message is required");
    return (0, $hzb7Z.signMessage)({
        message: message
    });
};
function $b9a08c139e2d6879$export$2ec0271a2697cc5f({ message: message, onError: onError, onMutate: onMutate, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const { data: data, error: error, isError: isError, isIdle: isIdle, isLoading: isLoading, isSuccess: isSuccess, mutate: mutate, mutateAsync: mutateAsync, reset: reset, status: status, variables: variables } = $b9a08c139e2d6879$export$609860bf8b0084c($b9a08c139e2d6879$var$mutationKey3({
        message: message
    }), $b9a08c139e2d6879$var$mutationFn3, {
        onError: onError,
        onMutate: onMutate,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    const signMessage2 = $9nZCP.useCallback((args)=>mutate(args || {
            message: message
        }), [
        message,
        mutate
    ]);
    const signMessageAsync = $9nZCP.useCallback((args)=>mutateAsync(args || {
            message: message
        }), [
        message,
        mutateAsync
    ]);
    return {
        data: data,
        error: error,
        isError: isError,
        isIdle: isIdle,
        isLoading: isLoading,
        isSuccess: isSuccess,
        reset: reset,
        signMessage: signMessage2,
        signMessageAsync: signMessageAsync,
        status: status,
        variables: variables
    };
}
function $b9a08c139e2d6879$var$mutationKey4({ domain: domain, types: types, message: message, primaryType: primaryType }) {
    return [
        {
            entity: "signTypedData",
            domain: domain,
            types: types,
            message: message,
            primaryType: primaryType
        }
    ];
}
function $b9a08c139e2d6879$var$mutationFn4(args) {
    const { domain: domain, types: types, primaryType: primaryType, message: message } = args;
    if (!domain) throw new Error("domain is required");
    if (!types) throw new Error("types is required");
    if (!primaryType) throw new Error("primaryType is required");
    if (!message) throw new Error("message is required");
    return (0, $hzb7Z.signTypedData)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
}
function $b9a08c139e2d6879$export$d9a762c0326d0ef4({ domain: domain, types: types, message: message, primaryType: primaryType, onError: onError, onMutate: onMutate, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const { data: data, error: error, isError: isError, isIdle: isIdle, isLoading: isLoading, isSuccess: isSuccess, mutate: mutate, mutateAsync: mutateAsync, reset: reset, status: status, variables: variables } = $b9a08c139e2d6879$export$609860bf8b0084c($b9a08c139e2d6879$var$mutationKey4({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    }), $b9a08c139e2d6879$var$mutationFn4, {
        onError: onError,
        onMutate: onMutate,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    const signTypedData2 = $9nZCP.useCallback((args)=>mutate({
            domain: args?.domain ?? domain,
            types: args?.types ?? types,
            message: args?.message ?? message,
            primaryType: args?.primaryType ?? primaryType
        }), [
        domain,
        types,
        primaryType,
        message,
        mutate
    ]);
    const signTypedDataAsync = $9nZCP.useCallback((args)=>mutateAsync({
            domain: args?.domain ?? domain,
            types: args?.types ?? types,
            message: args?.message ?? message,
            primaryType: args?.primaryType ?? primaryType
        }), [
        domain,
        types,
        primaryType,
        message,
        mutateAsync
    ]);
    return {
        data: data,
        error: error,
        isError: isError,
        isIdle: isIdle,
        isLoading: isLoading,
        isSuccess: isSuccess,
        reset: reset,
        signTypedData: signTypedData2,
        signTypedDataAsync: signTypedDataAsync,
        status: status,
        variables: variables
    };
}
var $b9a08c139e2d6879$var$mutationKey5 = (args)=>[
        {
            entity: "switchNetwork",
            ...args
        }
    ];
var $b9a08c139e2d6879$var$mutationFn5 = (args)=>{
    const { chainId: chainId } = args;
    if (!chainId) throw new Error("chainId is required");
    return (0, $hzb7Z.switchNetwork)({
        chainId: chainId
    });
};
function $b9a08c139e2d6879$export$71b0470720f288c1({ chainId: chainId, throwForSwitchChainNotSupported: throwForSwitchChainNotSupported, onError: onError, onMutate: onMutate, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const config = $b9a08c139e2d6879$export$b3611e87cd5ba6ce();
    const forceUpdate = $b9a08c139e2d6879$var$useForceUpdate();
    const { data: data, error: error, isError: isError, isIdle: isIdle, isLoading: isLoading, isSuccess: isSuccess, mutate: mutate, mutateAsync: mutateAsync, reset: reset, status: status, variables: variables } = $b9a08c139e2d6879$export$609860bf8b0084c($b9a08c139e2d6879$var$mutationKey5({
        chainId: chainId
    }), $b9a08c139e2d6879$var$mutationFn5, {
        onError: onError,
        onMutate: onMutate,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    const switchNetwork_ = $9nZCP.useCallback((chainId_)=>mutate({
            chainId: chainId_ ?? chainId
        }), [
        chainId,
        mutate
    ]);
    const switchNetworkAsync_ = $9nZCP.useCallback((chainId_)=>mutateAsync({
            chainId: chainId_ ?? chainId
        }), [
        chainId,
        mutateAsync
    ]);
    $9nZCP.useEffect(()=>{
        const unwatch = config.subscribe(({ chains: chains, connector: connector })=>({
                chains: chains,
                connector: connector
            }), forceUpdate);
        return unwatch;
    }, [
        config,
        forceUpdate
    ]);
    let switchNetwork2;
    let switchNetworkAsync;
    const supportsSwitchChain = !!config.connector?.switchChain;
    if (throwForSwitchChainNotSupported || supportsSwitchChain) {
        switchNetwork2 = switchNetwork_;
        switchNetworkAsync = switchNetworkAsync_;
    }
    return {
        chains: config.chains ?? [],
        data: data,
        error: error,
        isError: isError,
        isIdle: isIdle,
        isLoading: isLoading,
        isSuccess: isSuccess,
        pendingChainId: variables?.chainId,
        reset: reset,
        status: status,
        switchNetwork: switchNetwork2,
        switchNetworkAsync: switchNetworkAsync,
        variables: variables
    };
}
function $b9a08c139e2d6879$export$fa3bb2588a62576e({ address: address, chainId: chainId, abi: abi, listener: listener, eventName: eventName } = {}) {
    const publicClient = $b9a08c139e2d6879$export$3ca3483c611a99c4({
        chainId: chainId
    });
    const webSocketPublicClient = $b9a08c139e2d6879$export$724f5280724585ed({
        chainId: chainId
    });
    const unwatch = $9nZCP.useRef();
    $9nZCP.useEffect(()=>{
        if (!abi || !address || !eventName) return;
        const publicClient_ = webSocketPublicClient || publicClient;
        unwatch.current = publicClient_.watchContractEvent({
            abi: abi,
            address: address,
            eventName: eventName,
            onLogs: listener
        });
        return unwatch.current;
    }, [
        abi,
        address,
        eventName,
        publicClient.uid,
        webSocketPublicClient?.uid
    ]);
    return unwatch.current;
}
function $b9a08c139e2d6879$var$queryKey5({ allowFailure: allowFailure, blockNumber: blockNumber, blockTag: blockTag, cacheKey: cacheKey, scopeKey: scopeKey }) {
    return [
        {
            entity: "readContractsInfinite",
            allowFailure: allowFailure,
            blockNumber: blockNumber,
            blockTag: blockTag,
            cacheKey: cacheKey,
            scopeKey: scopeKey
        }
    ];
}
function $b9a08c139e2d6879$var$queryFn5({ contracts: contracts }) {
    return ({ queryKey: [{ allowFailure: allowFailure, blockNumber: blockNumber, blockTag: blockTag }], pageParam: pageParam })=>{
        return (0, $hzb7Z.readContracts)({
            allowFailure: allowFailure,
            blockNumber: blockNumber,
            blockTag: blockTag,
            contracts: contracts(pageParam || void 0)
        });
    };
}
function $b9a08c139e2d6879$export$22c281f017fd3229({ allowFailure: allowFailure, blockNumber: blockNumber, blockTag: blockTag, cacheKey: cacheKey, cacheTime: cacheTime, contracts: contracts, enabled: enabled_ = true, getNextPageParam: getNextPageParam, isDataEqual: isDataEqual, keepPreviousData: keepPreviousData, onError: onError, onSettled: onSettled, onSuccess: onSuccess, scopeKey: scopeKey, select: select, staleTime: staleTime, structuralSharing: structuralSharing = (oldData, newData)=>(0, $hzb7Z.deepEqual)(oldData, newData) ? oldData : (0, $013477420ae0c1cc$export$77a71fc411098696)(oldData, newData), suspense: suspense }) {
    const queryKey_ = $9nZCP.useMemo(()=>$b9a08c139e2d6879$var$queryKey5({
            allowFailure: allowFailure,
            blockNumber: blockNumber,
            blockTag: blockTag,
            cacheKey: cacheKey,
            scopeKey: scopeKey
        }), [
        allowFailure,
        blockNumber,
        blockTag,
        cacheKey,
        scopeKey
    ]);
    const enabled = $9nZCP.useMemo(()=>{
        const enabled2 = Boolean(enabled_ && contracts);
        return enabled2;
    }, [
        contracts,
        enabled_
    ]);
    return $b9a08c139e2d6879$export$bdc59d3c1a6569aa(queryKey_, $b9a08c139e2d6879$var$queryFn5({
        contracts: contracts
    }), {
        cacheTime: cacheTime,
        enabled: enabled,
        getNextPageParam: getNextPageParam,
        isDataEqual: isDataEqual,
        keepPreviousData: keepPreviousData,
        select: select,
        staleTime: staleTime,
        structuralSharing: structuralSharing,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $b9a08c139e2d6879$export$ea82e4a36c28628e(fn, { perPage: perPage, start: start, direction: direction }) {
    const contracts = (page = 0)=>[
            ...Array(perPage).keys()
        ].map((index)=>{
            return direction === "increment" ? start + index + page * perPage : start - index - page * perPage;
        }).filter((index)=>index >= 0).flatMap(fn);
    return {
        contracts: contracts,
        getNextPageParam (lastPage, pages) {
            return lastPage?.length === perPage ? pages.length : void 0;
        }
    };
}
function $b9a08c139e2d6879$var$queryKey6({ account: account, address: address, args: args, blockNumber: blockNumber, blockTag: blockTag, chainId: chainId, functionName: functionName, scopeKey: scopeKey }) {
    return [
        {
            entity: "readContract",
            account: account,
            address: address,
            args: args,
            blockNumber: blockNumber,
            blockTag: blockTag,
            chainId: chainId,
            functionName: functionName,
            scopeKey: scopeKey
        }
    ];
}
function $b9a08c139e2d6879$var$queryFn6({ abi: abi }) {
    return async ({ queryKey: [{ account: account, address: address, args: args, blockNumber: blockNumber, blockTag: blockTag, chainId: chainId, functionName: functionName }] })=>{
        if (!abi) throw new Error("abi is required");
        if (!address) throw new Error("address is required");
        return await (0, $hzb7Z.readContract)({
            account: account,
            address: address,
            args: args,
            blockNumber: blockNumber,
            blockTag: blockTag,
            chainId: chainId,
            abi: abi,
            functionName: functionName
        }) ?? null;
    };
}
function $b9a08c139e2d6879$export$6f78c1774963fe2d({ abi: abi, address: address, account: account, args: args, blockNumber: blockNumberOverride, blockTag: blockTag, cacheOnBlock: cacheOnBlock = false, cacheTime: cacheTime, chainId: chainId_, enabled: enabled_ = true, functionName: functionName, isDataEqual: isDataEqual, keepPreviousData: keepPreviousData, onError: onError, onSettled: onSettled, onSuccess: onSuccess, scopeKey: scopeKey, select: select, staleTime: staleTime, structuralSharing: structuralSharing = (oldData, newData)=>(0, $hzb7Z.deepEqual)(oldData, newData) ? oldData : (0, $013477420ae0c1cc$export$77a71fc411098696)(oldData, newData), suspense: suspense, watch: watch } = {}) {
    const chainId = $b9a08c139e2d6879$export$dc276622421ed31d({
        chainId: chainId_
    });
    const { data: blockNumber_ } = $b9a08c139e2d6879$export$8bf0355f69442463({
        chainId: chainId,
        enabled: watch || cacheOnBlock,
        scopeKey: watch || cacheOnBlock ? void 0 : "idle",
        watch: watch
    });
    const blockNumber = blockNumberOverride ?? blockNumber_;
    const queryKey_ = $9nZCP.useMemo(()=>$b9a08c139e2d6879$var$queryKey6({
            account: account,
            address: address,
            args: args,
            blockNumber: cacheOnBlock ? blockNumber : void 0,
            blockTag: blockTag,
            chainId: chainId,
            functionName: functionName,
            scopeKey: scopeKey
        }), [
        account,
        address,
        args,
        blockNumber,
        blockTag,
        cacheOnBlock,
        chainId,
        functionName,
        scopeKey
    ]);
    const enabled = $9nZCP.useMemo(()=>{
        let enabled2 = Boolean(enabled_ && abi && address && functionName);
        if (cacheOnBlock) enabled2 = Boolean(enabled2 && blockNumber);
        return enabled2;
    }, [
        abi,
        address,
        blockNumber,
        cacheOnBlock,
        enabled_,
        functionName
    ]);
    $b9a08c139e2d6879$var$useInvalidateOnBlock({
        chainId: chainId,
        enabled: Boolean(enabled && watch && !cacheOnBlock),
        queryKey: queryKey_
    });
    return $b9a08c139e2d6879$export$dd0a697e1782aedd(queryKey_, $b9a08c139e2d6879$var$queryFn6({
        abi: abi
    }), {
        cacheTime: cacheTime,
        enabled: enabled,
        isDataEqual: isDataEqual,
        keepPreviousData: keepPreviousData,
        select: select,
        staleTime: staleTime,
        structuralSharing: structuralSharing,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $b9a08c139e2d6879$var$queryKey7({ allowFailure: allowFailure, blockNumber: blockNumber, blockTag: blockTag, chainId: chainId, contracts: contracts, scopeKey: scopeKey }) {
    return [
        {
            entity: "readContracts",
            allowFailure: allowFailure,
            blockNumber: blockNumber,
            blockTag: blockTag,
            chainId: chainId,
            scopeKey: scopeKey,
            contracts: (contracts ?? []).map(({ address: address, args: args, chainId: chainId2, functionName: functionName })=>({
                    address: address,
                    args: args,
                    chainId: chainId2,
                    functionName: functionName
                }))
        }
    ];
}
function $b9a08c139e2d6879$var$queryFn7({ abis: abis }) {
    return ({ queryKey: [{ allowFailure: allowFailure, blockNumber: blockNumber, blockTag: blockTag, contracts: contracts_ }] })=>{
        const contracts = contracts_.map((contract, i)=>({
                ...contract,
                abi: abis[i]
            }));
        return (0, $hzb7Z.readContracts)({
            allowFailure: allowFailure,
            contracts: contracts,
            blockNumber: blockNumber,
            blockTag: blockTag
        });
    };
}
function $b9a08c139e2d6879$export$f36bb0f54b7a8d18({ allowFailure: allowFailure_, blockNumber: blockNumberOverride, blockTag: blockTag, cacheOnBlock: cacheOnBlock = false, cacheTime: cacheTime, contracts: contracts, enabled: enabled_ = true, isDataEqual: isDataEqual, keepPreviousData: keepPreviousData, onError: onError, onSettled: onSettled, onSuccess: onSuccess, scopeKey: scopeKey, select: select, staleTime: staleTime, structuralSharing: structuralSharing = (oldData, newData)=>(0, $hzb7Z.deepEqual)(oldData, newData) ? oldData : (0, $013477420ae0c1cc$export$77a71fc411098696)(oldData, newData), suspense: suspense, watch: watch } = {}) {
    const allowFailure = allowFailure_ ?? true;
    const { data: blockNumber_ } = $b9a08c139e2d6879$export$8bf0355f69442463({
        enabled: watch || cacheOnBlock,
        watch: watch
    });
    const chainId = $b9a08c139e2d6879$export$dc276622421ed31d();
    const blockNumber = blockNumberOverride ?? blockNumber_;
    const queryKey_ = $9nZCP.useMemo(()=>$b9a08c139e2d6879$var$queryKey7({
            allowFailure: allowFailure,
            blockNumber: cacheOnBlock ? blockNumber : void 0,
            blockTag: blockTag,
            chainId: chainId,
            contracts: contracts,
            scopeKey: scopeKey
        }), [
        allowFailure,
        blockNumber,
        blockTag,
        cacheOnBlock,
        chainId,
        scopeKey,
        contracts
    ]);
    const enabled = $9nZCP.useMemo(()=>{
        let enabled2 = Boolean(enabled_ && contracts?.every((x)=>x.abi && x.address && x.functionName));
        if (cacheOnBlock) enabled2 = Boolean(enabled2 && blockNumber);
        return enabled2;
    }, [
        blockNumber,
        cacheOnBlock,
        contracts,
        enabled_
    ]);
    $b9a08c139e2d6879$var$useInvalidateOnBlock({
        enabled: Boolean(enabled && watch && !cacheOnBlock),
        queryKey: queryKey_
    });
    const abis = (contracts ?? []).map(({ abi: abi })=>abi);
    return $b9a08c139e2d6879$export$dd0a697e1782aedd(queryKey_, $b9a08c139e2d6879$var$queryFn7({
        abis: abis
    }), {
        cacheTime: cacheTime,
        enabled: enabled,
        isDataEqual: isDataEqual,
        keepPreviousData: keepPreviousData,
        staleTime: staleTime,
        select: select,
        structuralSharing: structuralSharing,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $b9a08c139e2d6879$var$mutationKey6({ address: address, abi: abi, functionName: functionName, ...config }) {
    const { args: args, accessList: accessList, account: account, dataSuffix: dataSuffix, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, request: request, value: value } = config;
    return [
        {
            entity: "writeContract",
            address: address,
            args: args,
            abi: abi,
            accessList: accessList,
            account: account,
            dataSuffix: dataSuffix,
            functionName: functionName,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            request: request,
            value: value
        }
    ];
}
function $b9a08c139e2d6879$var$mutationFn6(config) {
    if (config.mode === "prepared") {
        if (!config.request) throw new Error("request is required");
        return (0, $hzb7Z.writeContract)({
            mode: "prepared",
            request: config.request
        });
    }
    if (!config.address) throw new Error("address is required");
    if (!config.abi) throw new Error("abi is required");
    if (!config.functionName) throw new Error("functionName is required");
    return (0, $hzb7Z.writeContract)({
        address: config.address,
        args: config.args,
        chainId: config.chainId,
        abi: config.abi,
        functionName: config.functionName,
        accessList: config.accessList,
        account: config.account,
        dataSuffix: config.dataSuffix,
        gas: config.gas,
        gasPrice: config.gasPrice,
        maxFeePerGas: config.maxFeePerGas,
        maxPriorityFeePerGas: config.maxPriorityFeePerGas,
        nonce: config.nonce,
        value: config.value
    });
}
function $b9a08c139e2d6879$export$f65fbf805a7dc8c5(config) {
    const { address: address, abi: abi, args: args, chainId: chainId, functionName: functionName, mode: mode, request: request, dataSuffix: dataSuffix } = config;
    const { accessList: accessList, account: account, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, value: value } = (0, $hzb7Z.getSendTransactionParameters)(config);
    const { data: data, error: error, isError: isError, isIdle: isIdle, isLoading: isLoading, isSuccess: isSuccess, mutate: mutate, mutateAsync: mutateAsync, reset: reset, status: status, variables: variables } = $b9a08c139e2d6879$export$609860bf8b0084c($b9a08c139e2d6879$var$mutationKey6({
        address: address,
        abi: abi,
        functionName: functionName,
        chainId: chainId,
        mode: mode,
        args: args,
        accessList: accessList,
        account: account,
        dataSuffix: dataSuffix,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        nonce: nonce,
        request: request,
        value: value
    }), $b9a08c139e2d6879$var$mutationFn6, {
        onError: config.onError,
        onMutate: config.onMutate,
        onSettled: config.onSettled,
        onSuccess: config.onSuccess
    });
    const write = $9nZCP.useMemo(()=>{
        if (config.mode === "prepared") {
            if (!request) return void 0;
            return ()=>mutate({
                    mode: "prepared",
                    request: config.request,
                    chainId: config.chainId
                });
        }
        return (overrideConfig)=>mutate({
                address: address,
                args: args,
                abi: abi,
                functionName: functionName,
                chainId: chainId,
                accessList: accessList,
                account: account,
                dataSuffix: dataSuffix,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                nonce: nonce,
                value: value,
                ...overrideConfig
            });
    }, [
        accessList,
        account,
        abi,
        address,
        args,
        chainId,
        config.chainId,
        config.mode,
        config.request,
        dataSuffix,
        functionName,
        gas,
        gasPrice,
        maxFeePerGas,
        maxPriorityFeePerGas,
        mutate,
        nonce,
        request,
        value
    ]);
    const writeAsync = $9nZCP.useMemo(()=>{
        if (config.mode === "prepared") {
            if (!request) return void 0;
            return ()=>mutateAsync({
                    mode: "prepared",
                    request: config.request
                });
        }
        return (overrideConfig)=>mutateAsync({
                address: address,
                args: args,
                abi: abi,
                chainId: chainId,
                functionName: functionName,
                accessList: accessList,
                account: account,
                dataSuffix: dataSuffix,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                nonce: nonce,
                value: value,
                ...overrideConfig
            });
    }, [
        accessList,
        account,
        abi,
        address,
        args,
        chainId,
        config.mode,
        config.request,
        dataSuffix,
        functionName,
        gas,
        gasPrice,
        maxFeePerGas,
        maxPriorityFeePerGas,
        mutateAsync,
        nonce,
        request,
        value
    ]);
    return {
        data: data,
        error: error,
        isError: isError,
        isIdle: isIdle,
        isLoading: isLoading,
        isSuccess: isSuccess,
        reset: reset,
        status: status,
        variables: variables,
        write: write,
        writeAsync: writeAsync
    };
}
function $b9a08c139e2d6879$var$queryKey8({ accessList: accessList, account: account, activeChainId: activeChainId, args: args, address: address, blockNumber: blockNumber, blockTag: blockTag, chainId: chainId, dataSuffix: dataSuffix, functionName: functionName, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, scopeKey: scopeKey, walletClientAddress: walletClientAddress, value: value }) {
    return [
        {
            entity: "prepareContractTransaction",
            accessList: accessList,
            account: account,
            activeChainId: activeChainId,
            address: address,
            args: args,
            blockNumber: blockNumber,
            blockTag: blockTag,
            chainId: chainId,
            dataSuffix: dataSuffix,
            functionName: functionName,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            scopeKey: scopeKey,
            walletClientAddress: walletClientAddress,
            value: value
        }
    ];
}
function $b9a08c139e2d6879$var$queryFn8({ abi: abi, walletClient: walletClient }) {
    return ({ queryKey: [{ accessList: accessList, account: account, args: args, address: address, blockNumber: blockNumber, blockTag: blockTag, chainId: chainId, dataSuffix: dataSuffix, functionName: functionName, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, value: value }] })=>{
        if (!abi) throw new Error("abi is required");
        if (!address) throw new Error("address is required");
        if (!functionName) throw new Error("functionName is required");
        return (0, $hzb7Z.prepareWriteContract)({
            abi: abi,
            accessList: accessList,
            account: account,
            args: args,
            address: address,
            blockNumber: blockNumber,
            blockTag: blockTag,
            chainId: chainId,
            dataSuffix: dataSuffix,
            functionName: functionName,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            walletClient: walletClient,
            value: value
        });
    };
}
function $b9a08c139e2d6879$export$f08fad0d21112083({ address: address, abi: abi, functionName: functionName, chainId: chainId, args: args, cacheTime: cacheTime, dataSuffix: dataSuffix, enabled: enabled = true, scopeKey: scopeKey, staleTime: staleTime, suspense: suspense, onError: onError, onSettled: onSettled, onSuccess: onSuccess, ...config } = {}) {
    const { chain: activeChain } = $b9a08c139e2d6879$export$553aaf59afc1a2d8();
    const { data: walletClient } = $b9a08c139e2d6879$export$742c698ad1033029({
        chainId: chainId
    });
    const { accessList: accessList, account: account, blockNumber: blockNumber, blockTag: blockTag, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, value: value } = (0, $hzb7Z.getCallParameters)(config);
    const prepareContractWriteQuery = $b9a08c139e2d6879$export$dd0a697e1782aedd($b9a08c139e2d6879$var$queryKey8({
        accessList: accessList,
        account: account,
        activeChainId: activeChain?.id,
        address: address,
        args: args,
        blockNumber: blockNumber,
        blockTag: blockTag,
        chainId: chainId,
        dataSuffix: dataSuffix,
        functionName: functionName,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        nonce: nonce,
        scopeKey: scopeKey,
        walletClientAddress: walletClient?.account.address,
        value: value
    }), $b9a08c139e2d6879$var$queryFn8({
        abi: abi,
        walletClient: walletClient
    }), {
        cacheTime: cacheTime,
        enabled: Boolean(enabled && abi && address && functionName && walletClient),
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    return Object.assign(prepareContractWriteQuery, {
        config: {
            chainId: chainId,
            mode: "prepared",
            request: void 0,
            ...prepareContractWriteQuery.data
        }
    });
}
function $b9a08c139e2d6879$var$queryKey9({ address: address, chainId: chainId, formatUnits: formatUnits, scopeKey: scopeKey }) {
    return [
        {
            entity: "token",
            address: address,
            chainId: chainId,
            formatUnits: formatUnits,
            scopeKey: scopeKey
        }
    ];
}
function $b9a08c139e2d6879$var$queryFn9({ queryKey: [{ address: address, chainId: chainId, formatUnits: formatUnits }] }) {
    if (!address) throw new Error("address is required");
    return (0, $hzb7Z.fetchToken)({
        address: address,
        chainId: chainId,
        formatUnits: formatUnits
    });
}
function $b9a08c139e2d6879$export$31dcd79391e423fe({ address: address, chainId: chainId_, formatUnits: formatUnits = "ether", cacheTime: cacheTime, enabled: enabled = true, scopeKey: scopeKey, staleTime: staleTime = 86400000, suspense: suspense, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $b9a08c139e2d6879$export$dc276622421ed31d({
        chainId: chainId_
    });
    return $b9a08c139e2d6879$export$dd0a697e1782aedd($b9a08c139e2d6879$var$queryKey9({
        address: address,
        chainId: chainId,
        formatUnits: formatUnits,
        scopeKey: scopeKey
    }), $b9a08c139e2d6879$var$queryFn9, {
        cacheTime: cacheTime,
        enabled: Boolean(enabled && address),
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $b9a08c139e2d6879$var$queryKey10({ chainId: chainId, name: name, scopeKey: scopeKey }) {
    return [
        {
            entity: "ensAddress",
            chainId: chainId,
            name: name,
            scopeKey: scopeKey
        }
    ];
}
function $b9a08c139e2d6879$var$queryFn10({ queryKey: [{ chainId: chainId, name: name }] }) {
    if (!name) throw new Error("name is required");
    return (0, $hzb7Z.fetchEnsAddress)({
        chainId: chainId,
        name: name
    });
}
function $b9a08c139e2d6879$export$882e13b9ff368f82({ cacheTime: cacheTime, chainId: chainId_, enabled: enabled = true, name: name, scopeKey: scopeKey, staleTime: staleTime = 86400000, suspense: suspense, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $b9a08c139e2d6879$export$dc276622421ed31d({
        chainId: chainId_
    });
    return $b9a08c139e2d6879$export$dd0a697e1782aedd($b9a08c139e2d6879$var$queryKey10({
        chainId: chainId,
        name: name,
        scopeKey: scopeKey
    }), $b9a08c139e2d6879$var$queryFn10, {
        cacheTime: cacheTime,
        enabled: Boolean(enabled && chainId && name),
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $b9a08c139e2d6879$var$queryKey11({ name: name, chainId: chainId, scopeKey: scopeKey }) {
    return [
        {
            entity: "ensAvatar",
            name: name,
            chainId: chainId,
            scopeKey: scopeKey
        }
    ];
}
function $b9a08c139e2d6879$var$queryFn11({ queryKey: [{ name: name, chainId: chainId }] }) {
    if (!name) throw new Error("name is required");
    return (0, $hzb7Z.fetchEnsAvatar)({
        name: name,
        chainId: chainId
    });
}
function $b9a08c139e2d6879$export$182f359dd9766fbb({ cacheTime: cacheTime, chainId: chainId_, enabled: enabled = true, name: name, scopeKey: scopeKey, staleTime: staleTime = 86400000, suspense: suspense, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $b9a08c139e2d6879$export$dc276622421ed31d({
        chainId: chainId_
    });
    return $b9a08c139e2d6879$export$dd0a697e1782aedd($b9a08c139e2d6879$var$queryKey11({
        name: name,
        chainId: chainId,
        scopeKey: scopeKey
    }), $b9a08c139e2d6879$var$queryFn11, {
        cacheTime: cacheTime,
        enabled: Boolean(enabled && name && chainId),
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $b9a08c139e2d6879$var$queryKey12({ address: address, chainId: chainId, scopeKey: scopeKey }) {
    return [
        {
            entity: "ensName",
            address: address,
            chainId: chainId,
            scopeKey: scopeKey
        }
    ];
}
function $b9a08c139e2d6879$var$queryFn12({ queryKey: [{ address: address, chainId: chainId }] }) {
    if (!address) throw new Error("address is required");
    return (0, $hzb7Z.fetchEnsName)({
        address: address,
        chainId: chainId
    });
}
function $b9a08c139e2d6879$export$e7302f55b2684d23({ address: address, cacheTime: cacheTime, chainId: chainId_, enabled: enabled = true, scopeKey: scopeKey, staleTime: staleTime = 86400000, suspense: suspense, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $b9a08c139e2d6879$export$dc276622421ed31d({
        chainId: chainId_
    });
    return $b9a08c139e2d6879$export$dd0a697e1782aedd($b9a08c139e2d6879$var$queryKey12({
        address: address,
        chainId: chainId,
        scopeKey: scopeKey
    }), $b9a08c139e2d6879$var$queryFn12, {
        cacheTime: cacheTime,
        enabled: Boolean(enabled && address && chainId),
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $b9a08c139e2d6879$var$queryKey13({ chainId: chainId, name: name, scopeKey: scopeKey }) {
    return [
        {
            entity: "ensResolver",
            chainId: chainId,
            name: name,
            scopeKey: scopeKey,
            persist: false
        }
    ];
}
function $b9a08c139e2d6879$var$queryFn13({ queryKey: [{ chainId: chainId, name: name }] }) {
    if (!name) throw new Error("name is required");
    return (0, $hzb7Z.fetchEnsResolver)({
        chainId: chainId,
        name: name
    });
}
function $b9a08c139e2d6879$export$659f7b1a330aed84({ chainId: chainId_, name: name, enabled: enabled = true, scopeKey: scopeKey, suspense: suspense, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $b9a08c139e2d6879$export$dc276622421ed31d({
        chainId: chainId_
    });
    return $b9a08c139e2d6879$export$dd0a697e1782aedd($b9a08c139e2d6879$var$queryKey13({
        chainId: chainId,
        name: name,
        scopeKey: scopeKey
    }), $b9a08c139e2d6879$var$queryFn13, {
        cacheTime: 0,
        enabled: Boolean(enabled && chainId && name),
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $b9a08c139e2d6879$var$queryKey14({ accessList: accessList, account: account, activeChainId: activeChainId, chainId: chainId, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, scopeKey: scopeKey, walletClientAddress: walletClientAddress }) {
    return [
        {
            entity: "prepareSendTransaction",
            activeChainId: activeChainId,
            accessList: accessList,
            account: account,
            chainId: chainId,
            data: data,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: to,
            value: value,
            scopeKey: scopeKey,
            walletClientAddress: walletClientAddress
        }
    ];
}
function $b9a08c139e2d6879$var$queryFn14({ walletClient: walletClient }) {
    return ({ queryKey: [{ accessList: accessList, account: account, chainId: chainId, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }] })=>{
        if (!to) throw new Error("to is required");
        return (0, $hzb7Z.prepareSendTransaction)({
            accessList: accessList,
            account: account,
            chainId: chainId,
            data: data,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: to,
            value: value,
            walletClient: walletClient
        });
    };
}
function $b9a08c139e2d6879$export$f8ca5822352fabc7({ accessList: accessList, account: account, chainId: chainId, cacheTime: cacheTime, data: data, enabled: enabled = true, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, scopeKey: scopeKey, staleTime: staleTime, suspense: suspense, to: to, value: value, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const { chain: activeChain } = $b9a08c139e2d6879$export$553aaf59afc1a2d8();
    const { data: walletClient } = $b9a08c139e2d6879$export$742c698ad1033029({
        chainId: chainId
    });
    const prepareSendTransactionQuery = $b9a08c139e2d6879$export$dd0a697e1782aedd($b9a08c139e2d6879$var$queryKey14({
        accessList: accessList,
        activeChainId: activeChain?.id,
        account: account,
        chainId: chainId,
        data: data,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        nonce: nonce,
        scopeKey: scopeKey,
        to: to,
        value: value,
        walletClientAddress: walletClient?.account.address
    }), $b9a08c139e2d6879$var$queryFn14({
        walletClient: walletClient
    }), {
        cacheTime: cacheTime,
        enabled: Boolean(enabled && walletClient && to),
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    return Object.assign(prepareSendTransactionQuery, {
        config: {
            mode: "prepared",
            ...prepareSendTransactionQuery.isSuccess ? prepareSendTransactionQuery.data : void 0
        }
    });
}
var $b9a08c139e2d6879$var$mutationKey7 = (args)=>[
        {
            entity: "sendTransaction",
            ...args
        }
    ];
var $b9a08c139e2d6879$var$mutationFn7 = ({ accessList: accessList, account: account, chainId: chainId, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, mode: mode, nonce: nonce, to: to, value: value })=>{
    if (!to) throw new Error("to is required.");
    return (0, $hzb7Z.sendTransaction)({
        accessList: accessList,
        account: account,
        chainId: chainId,
        data: data,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        mode: mode,
        nonce: nonce,
        to: to,
        value: value
    });
};
function $b9a08c139e2d6879$export$c4f10d35244ef225({ accessList: accessList, account: account, chainId: chainId, data: data_, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, mode: mode, nonce: nonce, to: to, value: value, onError: onError, onMutate: onMutate, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const { data: data, error: error, isError: isError, isIdle: isIdle, isLoading: isLoading, isSuccess: isSuccess, mutate: mutate, mutateAsync: mutateAsync, reset: reset, status: status, variables: variables } = $b9a08c139e2d6879$export$609860bf8b0084c($b9a08c139e2d6879$var$mutationKey7({
        accessList: accessList,
        account: account,
        chainId: chainId,
        data: data_,
        gas: gas,
        gasPrice: gasPrice,
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        mode: mode,
        nonce: nonce,
        to: to,
        value: value
    }), $b9a08c139e2d6879$var$mutationFn7, {
        onError: onError,
        onMutate: onMutate,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
    const sendTransaction2 = $9nZCP.useCallback((args)=>mutate({
            chainId: chainId,
            mode: mode,
            ...args || {
                accessList: accessList,
                account: account,
                chainId: chainId,
                data: data_,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                mode: mode,
                nonce: nonce,
                value: value,
                to: to
            }
        }), [
        accessList,
        account,
        chainId,
        data_,
        gas,
        gasPrice,
        maxFeePerGas,
        maxPriorityFeePerGas,
        mode,
        mutate,
        nonce,
        to,
        value
    ]);
    const sendTransactionAsync = $9nZCP.useCallback((args)=>mutateAsync({
            chainId: chainId,
            mode: mode,
            ...args || {
                accessList: accessList,
                account: account,
                chainId: chainId,
                data: data_,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                mode: mode,
                nonce: nonce,
                value: value,
                to: to
            }
        }), [
        accessList,
        account,
        chainId,
        data_,
        gas,
        gasPrice,
        maxFeePerGas,
        maxPriorityFeePerGas,
        mode,
        mutateAsync,
        nonce,
        to,
        value
    ]);
    return {
        data: data,
        error: error,
        isError: isError,
        isIdle: isIdle,
        isLoading: isLoading,
        isSuccess: isSuccess,
        reset: reset,
        sendTransaction: mode === "prepared" && !to ? void 0 : sendTransaction2,
        sendTransactionAsync: mode === "prepared" && !to ? void 0 : sendTransactionAsync,
        status: status,
        variables: variables
    };
}
function $b9a08c139e2d6879$var$queryKey15({ chainId: chainId, hash: hash, scopeKey: scopeKey }) {
    return [
        {
            entity: "transaction",
            chainId: chainId,
            hash: hash,
            scopeKey: scopeKey
        }
    ];
}
function $b9a08c139e2d6879$var$queryFn15({ queryKey: [{ chainId: chainId, hash: hash }] }) {
    if (!hash) throw new Error("hash is required");
    return (0, $hzb7Z.fetchTransaction)({
        chainId: chainId,
        hash: hash
    });
}
function $b9a08c139e2d6879$export$244eac3470cf24ad({ cacheTime: cacheTime = 0, chainId: chainId_, enabled: enabled = true, hash: hash, scopeKey: scopeKey, staleTime: staleTime, suspense: suspense, onError: onError, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $b9a08c139e2d6879$export$dc276622421ed31d({
        chainId: chainId_
    });
    return $b9a08c139e2d6879$export$dd0a697e1782aedd($b9a08c139e2d6879$var$queryKey15({
        chainId: chainId,
        hash: hash,
        scopeKey: scopeKey
    }), $b9a08c139e2d6879$var$queryFn15, {
        cacheTime: cacheTime,
        enabled: Boolean(enabled && hash),
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $b9a08c139e2d6879$var$queryKey16({ confirmations: confirmations, chainId: chainId, hash: hash, scopeKey: scopeKey, timeout: timeout }) {
    return [
        {
            entity: "waitForTransaction",
            confirmations: confirmations,
            chainId: chainId,
            hash: hash,
            scopeKey: scopeKey,
            timeout: timeout
        }
    ];
}
function $b9a08c139e2d6879$var$queryFn16({ onReplaced: onReplaced }) {
    return ({ queryKey: [{ chainId: chainId, confirmations: confirmations, hash: hash, timeout: timeout }] })=>{
        if (!hash) throw new Error("hash is required");
        return (0, $hzb7Z.waitForTransaction)({
            chainId: chainId,
            confirmations: confirmations,
            hash: hash,
            onReplaced: onReplaced,
            timeout: timeout
        });
    };
}
function $b9a08c139e2d6879$export$421837b4be863851({ chainId: chainId_, confirmations: confirmations, hash: hash, timeout: timeout, cacheTime: cacheTime, enabled: enabled = true, scopeKey: scopeKey, staleTime: staleTime, suspense: suspense, onError: onError, onReplaced: onReplaced, onSettled: onSettled, onSuccess: onSuccess } = {}) {
    const chainId = $b9a08c139e2d6879$export$dc276622421ed31d({
        chainId: chainId_
    });
    return $b9a08c139e2d6879$export$dd0a697e1782aedd($b9a08c139e2d6879$var$queryKey16({
        chainId: chainId,
        confirmations: confirmations,
        hash: hash,
        scopeKey: scopeKey,
        timeout: timeout
    }), $b9a08c139e2d6879$var$queryFn16({
        onReplaced: onReplaced
    }), {
        cacheTime: cacheTime,
        enabled: Boolean(enabled && hash),
        staleTime: staleTime,
        suspense: suspense,
        onError: onError,
        onSettled: onSettled,
        onSuccess: onSuccess
    });
}
function $b9a08c139e2d6879$export$1225b17756115209({ chainId: chainId_, enabled: enabled = true, listener: listener }) {
    const chainId = $b9a08c139e2d6879$export$dc276622421ed31d({
        chainId: chainId_
    });
    const publicClient = $b9a08c139e2d6879$export$3ca3483c611a99c4({
        chainId: chainId
    });
    const webSocketPublicClient = $b9a08c139e2d6879$export$724f5280724585ed({
        chainId: chainId
    });
    $9nZCP.useEffect(()=>{
        if (!enabled) return;
        const publicClient_ = webSocketPublicClient ?? publicClient;
        return publicClient_.watchPendingTransactions({
            onTransactions: listener
        });
    }, [
        enabled,
        listener,
        publicClient,
        webSocketPublicClient
    ]);
}



var $bMiPj = parcelRequire("bMiPj");
const $6a02c0f0c34d6c61$export$21799e7ae6cc115 = /*#__PURE__*/ (0, $bMiPj.defineChain)({
    id: 421614,
    name: "Arbitrum Sepolia",
    network: "arbitrum-sepolia",
    nativeCurrency: {
        name: "Arbitrum Sepolia Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        alchemy: {
            http: [
                "https://arb-sepolia.g.alchemy.com/v2"
            ],
            webSocket: [
                "wss://arb-sepolia.g.alchemy.com/v2"
            ]
        },
        default: {
            http: [
                "https://sepolia-rollup.arbitrum.io/rpc"
            ]
        },
        public: {
            http: [
                "https://sepolia-rollup.arbitrum.io/rpc"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Arbiscan",
            url: "https://sepolia.arbiscan.io"
        },
        default: {
            name: "Arbiscan",
            url: "https://sepolia.arbiscan.io"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 81930
        }
    },
    testnet: true
});


var $bMiPj = parcelRequire("bMiPj");
const $29073ff13918eb95$export$7a430fb03087826a = /*#__PURE__*/ (0, $bMiPj.defineChain)({
    id: 10200,
    name: "Gnosis Chiado",
    network: "chiado",
    nativeCurrency: {
        decimals: 18,
        name: "Gnosis",
        symbol: "xDAI"
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.chiadochain.net"
            ],
            webSocket: [
                "wss://rpc.chiadochain.net/wss"
            ]
        },
        public: {
            http: [
                "https://rpc.chiadochain.net"
            ],
            webSocket: [
                "wss://rpc.chiadochain.net/wss"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Blockscout",
            url: "https://blockscout.chiadochain.net"
        }
    },
    contracts: {
        multicall3: {
            address: "0xcA11bde05977b3631167028862bE2a173976CA11",
            blockCreated: 4967313
        }
    },
    testnet: true
});


var $a9nmx = parcelRequire("a9nmx");



var $9nZCP = parcelRequire("9nZCP");
const $9bc8dca83e4f2710$var$Context = /*#__PURE__*/ (0, $9nZCP.createContext)([
    "light",
    ()=>{
    // default empty-function
    }
]);
const $9bc8dca83e4f2710$export$d3df7f168cf26f4 = ({ theme: theme, toggleTheme: toggleTheme, children: children })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($9bc8dca83e4f2710$var$Context.Provider, {
        value: [
            theme,
            toggleTheme
        ],
        children: children
    });
};
const $9bc8dca83e4f2710$export$c07acc0415d9f757 = ()=>{
    return (0, $9nZCP.useContext)($9bc8dca83e4f2710$var$Context);
};


var $1d9bd5c523349ec4$exports = {};

$parcel$defineInteropFlag($1d9bd5c523349ec4$exports);

$parcel$export($1d9bd5c523349ec4$exports, "isStyledComponent", function () { return $1d9bd5c523349ec4$export$7ba318d8d2f06c76; });
$parcel$export($1d9bd5c523349ec4$exports, "version", function () { return $1d9bd5c523349ec4$export$83d89fbfd8236492; });
$parcel$export($1d9bd5c523349ec4$exports, "StyleSheetContext", function () { return $1d9bd5c523349ec4$export$8c190ef828af4c86; });
$parcel$export($1d9bd5c523349ec4$exports, "StyleSheetConsumer", function () { return $1d9bd5c523349ec4$export$91317688fc694efa; });
$parcel$export($1d9bd5c523349ec4$exports, "StyleSheetManager", function () { return $1d9bd5c523349ec4$export$a473771da2f0ff7c; });
$parcel$export($1d9bd5c523349ec4$exports, "css", function () { return $1d9bd5c523349ec4$export$dbf350e5966cf602; });
$parcel$export($1d9bd5c523349ec4$exports, "ThemeContext", function () { return $1d9bd5c523349ec4$export$2c657da244d00bd6; });
$parcel$export($1d9bd5c523349ec4$exports, "ThemeConsumer", function () { return $1d9bd5c523349ec4$export$b631efc24e9d5e2f; });
$parcel$export($1d9bd5c523349ec4$exports, "ThemeProvider", function () { return $1d9bd5c523349ec4$export$d8964aec282183a3; });
$parcel$export($1d9bd5c523349ec4$exports, "createGlobalStyle", function () { return $1d9bd5c523349ec4$export$f0f03736edb61697; });
$parcel$export($1d9bd5c523349ec4$exports, "keyframes", function () { return $1d9bd5c523349ec4$export$d25ddfdf17c3ad3e; });
$parcel$export($1d9bd5c523349ec4$exports, "ServerStyleSheet", function () { return $1d9bd5c523349ec4$export$ae8c7d15c8b89a20; });
$parcel$export($1d9bd5c523349ec4$exports, "withTheme", function () { return $1d9bd5c523349ec4$export$e8748c6a27b910dc; });
$parcel$export($1d9bd5c523349ec4$exports, "useTheme", function () { return $1d9bd5c523349ec4$export$93d4e7f90805808f; });
$parcel$export($1d9bd5c523349ec4$exports, "__PRIVATE__", function () { return $1d9bd5c523349ec4$export$5c87cfe6c475f500; });
$parcel$export($1d9bd5c523349ec4$exports, "default", function () { return $1d9bd5c523349ec4$export$2e2bcd8739ae039; });
var $641555432cc96e57$exports = {};
"use strict";

$641555432cc96e57$exports = (parcelRequire("3bLDg"));



var $9nZCP = parcelRequire("9nZCP");
var $6c6fcafea3e67b1c$exports = {};
//
$6c6fcafea3e67b1c$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $4592fee8d7fd368d$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\x00\x00"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\x00");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $4592fee8d7fd368d$export$2e2bcd8739ae039 = $4592fee8d7fd368d$var$stylis_min;


var $8f8653a6518971cd$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $8f8653a6518971cd$export$2e2bcd8739ae039 = $8f8653a6518971cd$var$unitlessKeys;


function $3a9bed4c6f1a8239$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $8cc731d47fbd173f$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $8cc731d47fbd173f$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $3a9bed4c6f1a8239$export$2e2bcd8739ae039)(function(prop) {
    return $8cc731d47fbd173f$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});




var $bNDrn = parcelRequire("bNDrn");
function $1d9bd5c523349ec4$var$y() {
    return ($1d9bd5c523349ec4$var$y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $1d9bd5c523349ec4$var$v = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $1d9bd5c523349ec4$var$g = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $641555432cc96e57$exports.typeOf)(t);
}, $1d9bd5c523349ec4$var$S = Object.freeze([]), $1d9bd5c523349ec4$var$w = Object.freeze({});
function $1d9bd5c523349ec4$var$E(e) {
    return "function" == typeof e;
}
function $1d9bd5c523349ec4$var$b(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $1d9bd5c523349ec4$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $1d9bd5c523349ec4$var$N = ("undefined" != typeof $bNDrn && void 0 !== $bNDrn.env && undefined, "data-styled"), $1d9bd5c523349ec4$export$83d89fbfd8236492 = "5.3.11", $1d9bd5c523349ec4$var$C = "undefined" != typeof window && "HTMLElement" in window, $1d9bd5c523349ec4$var$I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof $bNDrn && void 0 !== $bNDrn.env && false), $1d9bd5c523349ec4$var$P = {}, $1d9bd5c523349ec4$var$O = {};
function $1d9bd5c523349ec4$var$R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $1d9bd5c523349ec4$var$D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $1d9bd5c523349ec4$var$j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $1d9bd5c523349ec4$var$D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $1d9bd5c523349ec4$var$T = new Map, $1d9bd5c523349ec4$var$x = new Map, $1d9bd5c523349ec4$var$k = 1, $1d9bd5c523349ec4$var$V = function(e) {
    if ($1d9bd5c523349ec4$var$T.has(e)) return $1d9bd5c523349ec4$var$T.get(e);
    for(; $1d9bd5c523349ec4$var$x.has($1d9bd5c523349ec4$var$k);)$1d9bd5c523349ec4$var$k++;
    var t = $1d9bd5c523349ec4$var$k++;
    return $1d9bd5c523349ec4$var$T.set(e, t), $1d9bd5c523349ec4$var$x.set(t, e), t;
}, $1d9bd5c523349ec4$var$B = function(e) {
    return $1d9bd5c523349ec4$var$x.get(e);
}, $1d9bd5c523349ec4$var$z = function(e, t) {
    t >= $1d9bd5c523349ec4$var$k && ($1d9bd5c523349ec4$var$k = t + 1), $1d9bd5c523349ec4$var$T.set(e, t), $1d9bd5c523349ec4$var$x.set(t, e);
}, $1d9bd5c523349ec4$var$M = "style[" + $1d9bd5c523349ec4$var$N + '][data-styled-version="5.3.11"]', $1d9bd5c523349ec4$var$G = new RegExp("^" + $1d9bd5c523349ec4$var$N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $1d9bd5c523349ec4$var$L = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $1d9bd5c523349ec4$var$F = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($1d9bd5c523349ec4$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($1d9bd5c523349ec4$var$z(u, c), $1d9bd5c523349ec4$var$L(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $1d9bd5c523349ec4$var$Y = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $1d9bd5c523349ec4$var$q = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($1d9bd5c523349ec4$var$N)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($1d9bd5c523349ec4$var$N, "active"), r.setAttribute("data-styled-version", "5.3.11");
    var i = $1d9bd5c523349ec4$var$Y();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $1d9bd5c523349ec4$var$H = function() {
    function e(e) {
        var t = this.element = $1d9bd5c523349ec4$var$q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $1d9bd5c523349ec4$var$D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $1d9bd5c523349ec4$var$$ = function() {
    function e(e) {
        var t = this.element = $1d9bd5c523349ec4$var$q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $1d9bd5c523349ec4$var$W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $1d9bd5c523349ec4$var$U = $1d9bd5c523349ec4$var$C, $1d9bd5c523349ec4$var$J = {
    isServer: !$1d9bd5c523349ec4$var$C,
    useCSSOMInjection: !$1d9bd5c523349ec4$var$I
}, $1d9bd5c523349ec4$var$X = function() {
    function e(e, t, n) {
        void 0 === e && (e = $1d9bd5c523349ec4$var$w), void 0 === t && (t = {}), this.options = $1d9bd5c523349ec4$var$y({}, $1d9bd5c523349ec4$var$J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $1d9bd5c523349ec4$var$C && $1d9bd5c523349ec4$var$U && ($1d9bd5c523349ec4$var$U = !1, function(e) {
            for(var t = document.querySelectorAll($1d9bd5c523349ec4$var$M), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($1d9bd5c523349ec4$var$N) && ($1d9bd5c523349ec4$var$F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $1d9bd5c523349ec4$var$V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($1d9bd5c523349ec4$var$y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $1d9bd5c523349ec4$var$W(o) : r ? new $1d9bd5c523349ec4$var$H(o) : new $1d9bd5c523349ec4$var$$(o), new $1d9bd5c523349ec4$var$j(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($1d9bd5c523349ec4$var$V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($1d9bd5c523349ec4$var$V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($1d9bd5c523349ec4$var$V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $1d9bd5c523349ec4$var$B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $1d9bd5c523349ec4$var$N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $1d9bd5c523349ec4$var$Z = /(a)(d)/gi, $1d9bd5c523349ec4$var$K = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $1d9bd5c523349ec4$var$Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $1d9bd5c523349ec4$var$K(t % 52) + n;
    return ($1d9bd5c523349ec4$var$K(t % 52) + n).replace($1d9bd5c523349ec4$var$Z, "$1-$2");
}
var $1d9bd5c523349ec4$var$ee = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $1d9bd5c523349ec4$var$te = function(e) {
    return $1d9bd5c523349ec4$var$ee(5381, e);
};
function $1d9bd5c523349ec4$var$ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($1d9bd5c523349ec4$var$E(n) && !$1d9bd5c523349ec4$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $1d9bd5c523349ec4$var$re = $1d9bd5c523349ec4$var$te("5.3.11"), $1d9bd5c523349ec4$var$oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $1d9bd5c523349ec4$var$ne(e), this.componentId = t, this.baseHash = $1d9bd5c523349ec4$var$ee($1d9bd5c523349ec4$var$re, t), this.baseStyle = n, $1d9bd5c523349ec4$var$X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $1d9bd5c523349ec4$var$_e(this.rules, e, t, n).join(""), i = $1d9bd5c523349ec4$var$Q($1d9bd5c523349ec4$var$ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $1d9bd5c523349ec4$var$ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $1d9bd5c523349ec4$var$_e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $1d9bd5c523349ec4$var$ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $1d9bd5c523349ec4$var$Q(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $1d9bd5c523349ec4$var$se = /^\s*\/\/.*$/gm, $1d9bd5c523349ec4$var$ie = [
    ":",
    "[",
    ".",
    "#"
];
function $1d9bd5c523349ec4$var$ae(e) {
    var t, n, r, o, s = void 0 === e ? $1d9bd5c523349ec4$var$w : e, i = s.options, a = void 0 === i ? $1d9bd5c523349ec4$var$w : i, c = s.plugins, u = void 0 === c ? $1d9bd5c523349ec4$var$S : c, l = new (0, $4592fee8d7fd368d$export$2e2bcd8739ae039)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $1d9bd5c523349ec4$var$ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($1d9bd5c523349ec4$var$se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $1d9bd5c523349ec4$var$D(15), $1d9bd5c523349ec4$var$ee(e, t.name);
    }, 5381).toString() : "", m;
}
var $1d9bd5c523349ec4$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createContext(), $1d9bd5c523349ec4$export$91317688fc694efa = $1d9bd5c523349ec4$export$8c190ef828af4c86.Consumer, $1d9bd5c523349ec4$var$le = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createContext(), $1d9bd5c523349ec4$var$de = ($1d9bd5c523349ec4$var$le.Consumer, new $1d9bd5c523349ec4$var$X), $1d9bd5c523349ec4$var$he = $1d9bd5c523349ec4$var$ae();
function $1d9bd5c523349ec4$var$pe() {
    return (0, $9nZCP.useContext)($1d9bd5c523349ec4$export$8c190ef828af4c86) || $1d9bd5c523349ec4$var$de;
}
function $1d9bd5c523349ec4$var$fe() {
    return (0, $9nZCP.useContext)($1d9bd5c523349ec4$var$le) || $1d9bd5c523349ec4$var$he;
}
function $1d9bd5c523349ec4$export$a473771da2f0ff7c(e) {
    var t = (0, $9nZCP.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $1d9bd5c523349ec4$var$pe(), u = (0, $9nZCP.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $9nZCP.useMemo)(function() {
        return $1d9bd5c523349ec4$var$ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $9nZCP.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6c6fcafea3e67b1c$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement($1d9bd5c523349ec4$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement($1d9bd5c523349ec4$var$le.Provider, {
        value: l
    }, (0, e.children)));
}
var $1d9bd5c523349ec4$var$ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $1d9bd5c523349ec4$var$he);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $1d9bd5c523349ec4$var$D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $1d9bd5c523349ec4$var$he), this.name + e.hash;
    }, e;
}(), $1d9bd5c523349ec4$var$ve = /([A-Z])/, $1d9bd5c523349ec4$var$ge = /([A-Z])/g, $1d9bd5c523349ec4$var$Se = /^ms-/, $1d9bd5c523349ec4$var$we = function(e) {
    return "-" + e.toLowerCase();
};
function $1d9bd5c523349ec4$var$Ee(e) {
    return $1d9bd5c523349ec4$var$ve.test(e) ? e.replace($1d9bd5c523349ec4$var$ge, $1d9bd5c523349ec4$var$we).replace($1d9bd5c523349ec4$var$Se, "-ms-") : e;
}
var $1d9bd5c523349ec4$var$be = function(e) {
    return null == e || !1 === e || "" === e;
};
function $1d9bd5c523349ec4$var$_e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $1d9bd5c523349ec4$var$_e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($1d9bd5c523349ec4$var$be(e)) return "";
    if ($1d9bd5c523349ec4$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($1d9bd5c523349ec4$var$E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $1d9bd5c523349ec4$var$_e(u, n, r, o);
    }
    var l;
    return e instanceof $1d9bd5c523349ec4$var$ye ? r ? (e.inject(r, o), e.getName(o)) : e : $1d9bd5c523349ec4$var$g(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$1d9bd5c523349ec4$var$be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $1d9bd5c523349ec4$var$E(t[i]) ? s.push($1d9bd5c523349ec4$var$Ee(i) + ":", t[i], ";") : $1d9bd5c523349ec4$var$g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($1d9bd5c523349ec4$var$Ee(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $8f8653a6518971cd$export$2e2bcd8739ae039) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $1d9bd5c523349ec4$var$Ne = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $1d9bd5c523349ec4$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $1d9bd5c523349ec4$var$E(e) || $1d9bd5c523349ec4$var$g(e) ? $1d9bd5c523349ec4$var$Ne($1d9bd5c523349ec4$var$_e($1d9bd5c523349ec4$var$v($1d9bd5c523349ec4$var$S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $1d9bd5c523349ec4$var$Ne($1d9bd5c523349ec4$var$_e($1d9bd5c523349ec4$var$v(e, n)));
}
var $1d9bd5c523349ec4$var$Ce = /invalid hook call/i, $1d9bd5c523349ec4$var$Ie = new Set, $1d9bd5c523349ec4$var$Pe = function(e, t) {
    var n, r, o, e1;
}, $1d9bd5c523349ec4$var$Oe = function(e, t, n) {
    return void 0 === n && (n = $1d9bd5c523349ec4$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}, $1d9bd5c523349ec4$var$Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $1d9bd5c523349ec4$var$De = /(^-|-$)/g;
function $1d9bd5c523349ec4$var$je(e) {
    return e.replace($1d9bd5c523349ec4$var$Re, "-").replace($1d9bd5c523349ec4$var$De, "");
}
var $1d9bd5c523349ec4$var$Te = function(e) {
    return $1d9bd5c523349ec4$var$Q($1d9bd5c523349ec4$var$te(e) >>> 0);
};
function $1d9bd5c523349ec4$var$xe(e) {
    return "string" == typeof e && true;
}
var $1d9bd5c523349ec4$var$ke = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $1d9bd5c523349ec4$var$Ve = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $1d9bd5c523349ec4$var$Be(e, t, n) {
    var r = e[n];
    $1d9bd5c523349ec4$var$ke(t) && $1d9bd5c523349ec4$var$ke(r) ? $1d9bd5c523349ec4$var$ze(r, t) : e[n] = t;
}
function $1d9bd5c523349ec4$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($1d9bd5c523349ec4$var$ke(i)) for(var a in i)$1d9bd5c523349ec4$var$Ve(a) && $1d9bd5c523349ec4$var$Be(e, i[a], a);
    }
    return e;
}
var $1d9bd5c523349ec4$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createContext(), $1d9bd5c523349ec4$export$b631efc24e9d5e2f = $1d9bd5c523349ec4$export$2c657da244d00bd6.Consumer;
function $1d9bd5c523349ec4$export$d8964aec282183a3(e) {
    var t = (0, $9nZCP.useContext)($1d9bd5c523349ec4$export$2c657da244d00bd6), n = (0, $9nZCP.useMemo)(function() {
        return function(e, t) {
            if (!e) return $1d9bd5c523349ec4$var$D(14);
            if ($1d9bd5c523349ec4$var$E(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $1d9bd5c523349ec4$var$D(8) : t ? $1d9bd5c523349ec4$var$y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement($1d9bd5c523349ec4$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $1d9bd5c523349ec4$var$Fe = {};
function $1d9bd5c523349ec4$var$Ye(e, t, n) {
    var o = $1d9bd5c523349ec4$export$7ba318d8d2f06c76(e), i = !$1d9bd5c523349ec4$var$xe(e), a = t.attrs, c = void 0 === a ? $1d9bd5c523349ec4$var$S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $1d9bd5c523349ec4$var$je(e);
        $1d9bd5c523349ec4$var$Fe[n] = ($1d9bd5c523349ec4$var$Fe[n] || 0) + 1;
        var r = n + "-" + $1d9bd5c523349ec4$var$Te("5.3.11" + n + $1d9bd5c523349ec4$var$Fe[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return $1d9bd5c523349ec4$var$xe(e) ? "styled." + e : "Styled(" + $1d9bd5c523349ec4$var$b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? $1d9bd5c523349ec4$var$je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new $1d9bd5c523349ec4$var$oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = $1d9bd5c523349ec4$var$w);
                var r = $1d9bd5c523349ec4$var$y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $1d9bd5c523349ec4$var$E(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($1d9bd5c523349ec4$var$Oe(t, (0, $9nZCP.useContext)($1d9bd5c523349ec4$export$2c657da244d00bd6), a) || $1d9bd5c523349ec4$var$w, t, o), m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = $1d9bd5c523349ec4$var$pe(), s = $1d9bd5c523349ec4$var$fe(), i = t ? e.generateAndInjectStyles($1d9bd5c523349ec4$var$w, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, m, void 0), S = n, b = v.$as || t.$as || v.as || t.as || h, _ = $1d9bd5c523349ec4$var$xe(b), N = v !== t ? $1d9bd5c523349ec4$var$y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, $8cc731d47fbd173f$export$2e2bcd8739ae039), b) : !_ || (0, $8cc731d47fbd173f$export$2e2bcd8739ae039)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = $1d9bd5c523349ec4$var$y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, $9nZCP.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $1d9bd5c523349ec4$var$S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($1d9bd5c523349ec4$var$xe(e) ? e : $1d9bd5c523349ec4$var$je($1d9bd5c523349ec4$var$b(e)));
        return $1d9bd5c523349ec4$var$Ye(e, $1d9bd5c523349ec4$var$y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $1d9bd5c523349ec4$var$ze({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(A, "toString", {
        value: function() {
            return "." + A.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($732263a4f5417bca$exports)))(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var $1d9bd5c523349ec4$var$qe = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $1d9bd5c523349ec4$var$w), !(0, $641555432cc96e57$exports.isValidElementType)(r)) return $1d9bd5c523349ec4$var$D(1, String(r));
        var s = function() {
            return t(r, o, $1d9bd5c523349ec4$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $1d9bd5c523349ec4$var$y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $1d9bd5c523349ec4$var$y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($1d9bd5c523349ec4$var$Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $1d9bd5c523349ec4$var$qe[e] = $1d9bd5c523349ec4$var$qe(e);
});
var $1d9bd5c523349ec4$var$He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $1d9bd5c523349ec4$var$ne(e), $1d9bd5c523349ec4$var$X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($1d9bd5c523349ec4$var$_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $1d9bd5c523349ec4$var$X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $1d9bd5c523349ec4$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $1d9bd5c523349ec4$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $1d9bd5c523349ec4$var$Te(JSON.stringify(i)), u = new $1d9bd5c523349ec4$var$He(i, a);
    function d(e) {
        var t = $1d9bd5c523349ec4$var$pe(), n = $1d9bd5c523349ec4$var$fe(), o = (0, $9nZCP.useContext)($1d9bd5c523349ec4$export$2c657da244d00bd6), d = (0, $9nZCP.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(d, e, t, o, n), (0, $9nZCP.useLayoutEffect)(function() {
            if (!t.server) return h(d, e, t, o, n), function() {
                return u.removeStyles(d, t);
            };
        }, [
            d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $1d9bd5c523349ec4$var$P, n, o);
        else {
            var s = $1d9bd5c523349ec4$var$y({}, t, {
                theme: $1d9bd5c523349ec4$var$Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).memo(d);
}
function $1d9bd5c523349ec4$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $1d9bd5c523349ec4$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $1d9bd5c523349ec4$var$Te(o);
    return new $1d9bd5c523349ec4$var$ye(s, o);
}
var $1d9bd5c523349ec4$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $1d9bd5c523349ec4$var$Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $1d9bd5c523349ec4$var$N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $1d9bd5c523349ec4$var$D(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $1d9bd5c523349ec4$var$D(2);
            var n = ((t = {})[$1d9bd5c523349ec4$var$N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $1d9bd5c523349ec4$var$Y();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("style", $1d9bd5c523349ec4$var$y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $1d9bd5c523349ec4$var$X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $1d9bd5c523349ec4$var$D(2) : (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement($1d9bd5c523349ec4$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $1d9bd5c523349ec4$var$D(3);
    }, e;
}(), $1d9bd5c523349ec4$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).forwardRef(function(t, n) {
        var o = (0, $9nZCP.useContext)($1d9bd5c523349ec4$export$2c657da244d00bd6), i = e.defaultProps, a = $1d9bd5c523349ec4$var$Oe(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement(e, $1d9bd5c523349ec4$var$y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($732263a4f5417bca$exports)))(t, e), t.displayName = "WithTheme(" + $1d9bd5c523349ec4$var$b(e) + ")", t;
}, $1d9bd5c523349ec4$export$93d4e7f90805808f = function() {
    return (0, $9nZCP.useContext)($1d9bd5c523349ec4$export$2c657da244d00bd6);
}, $1d9bd5c523349ec4$export$5c87cfe6c475f500 = {
    StyleSheet: $1d9bd5c523349ec4$var$X,
    masterSheet: $1d9bd5c523349ec4$var$de
};
var $1d9bd5c523349ec4$export$2e2bcd8739ae039 = $1d9bd5c523349ec4$var$qe;


const $93cb5c29b614ea9a$var$chains = [
    (0, $6a02c0f0c34d6c61$export$21799e7ae6cc115),
    (0, $a9nmx.mainnet),
    (0, $29073ff13918eb95$export$7a430fb03087826a)
];
const $93cb5c29b614ea9a$var$projectId = "f78b8edecd9d3c07c116dc2ca33928e7" ?? "";
const $93cb5c29b614ea9a$export$1078a9b7607c322d = "PR2J5GgbdIpL2YfAwXKLpm_B9IHLgaRI" ?? "";
const { publicClient: $93cb5c29b614ea9a$var$publicClient, webSocketPublicClient: $93cb5c29b614ea9a$var$webSocketPublicClient } = (0, $hzb7Z.configureChains)($93cb5c29b614ea9a$var$chains, [
    (0, $7b57abd4ae2a8075$export$da85a315824a4e0e)({
        apiKey: $93cb5c29b614ea9a$export$1078a9b7607c322d
    }),
    (0, $95d131fcc106cbb5$export$2dc41f6df3d9d4cf)({
        rpc: ()=>({
                http: `https://rpc.chiadochain.net`,
                webSocket: `wss://rpc.chiadochain.net/wss`
            })
    })
]);
const $93cb5c29b614ea9a$var$wagmiConfig = (0, $b9a08c139e2d6879$export$45a69314cf48a3eb)({
    autoConnect: true,
    connectors: (0, $fb6877b271dac1d3$export$1fa55742dee269b2)({
        projectId: $93cb5c29b614ea9a$var$projectId,
        version: 2,
        chains: $93cb5c29b614ea9a$var$chains
    }),
    publicClient: $93cb5c29b614ea9a$var$publicClient,
    webSocketPublicClient: $93cb5c29b614ea9a$var$webSocketPublicClient
});
const $93cb5c29b614ea9a$var$ethereumClient = new (0, $fb6877b271dac1d3$export$de370d1517aed7bb)($93cb5c29b614ea9a$var$wagmiConfig, $93cb5c29b614ea9a$var$chains);
const $93cb5c29b614ea9a$var$Web3Provider = ({ children: children })=>{
    const [themeToggle] = (0, $9bc8dca83e4f2710$export$c07acc0415d9f757)();
    const theme = (0, $1d9bd5c523349ec4$export$93d4e7f90805808f)();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e6fafce87905c9df$export$c03599cd5308d12b), {
                themeMode: themeToggle,
                themeVariables: {
                    "--w3m-accent-color": theme.primaryPurple,
                    "--w3m-background-color": theme.primaryPurple,
                    "--w3m-overlay-background-color": "rgba(0, 0, 0, 0.6)",
                    "--w3m-overlay-backdrop-filter": "blur(3px)",
                    "--w3m-logo-image-url": "https://github.com/kleros/kleros-v2/blob/dev/docs/kleros-logo-white.png?raw=true",
                    "--w3m-color-bg-1": theme.lightBackground
                },
                projectId: $93cb5c29b614ea9a$var$projectId,
                ethereumClient: $93cb5c29b614ea9a$var$ethereumClient
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $b9a08c139e2d6879$export$c3a561dea2adc16c), {
                config: $93cb5c29b614ea9a$var$wagmiConfig,
                children: [
                    " ",
                    children,
                    " "
                ]
            })
        ]
    });
};
var $93cb5c29b614ea9a$export$2e2bcd8739ae039 = $93cb5c29b614ea9a$var$Web3Provider;




var $9nZCP = parcelRequire("9nZCP");

var $9nZCP = parcelRequire("9nZCP");
var $934ed287249205c1$export$8793edee2d425525 = function() {};
function $934ed287249205c1$export$af631764ddc44097(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.addEventListener) obj.addEventListener.apply(obj, args);
}
function $934ed287249205c1$export$8c8705df4a2dcec9(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.removeEventListener) obj.removeEventListener.apply(obj, args);
}
var $934ed287249205c1$export$4e09c449d6c407f7 = typeof window !== "undefined";
var $934ed287249205c1$export$42e7ac6120dd324e = typeof navigator !== "undefined";


var $ee2306e9d516d2d5$var$useLocalStorage = function(key, initialValue, options) {
    if (!(0, $934ed287249205c1$export$4e09c449d6c407f7)) return [
        initialValue,
        (0, $934ed287249205c1$export$8793edee2d425525),
        (0, $934ed287249205c1$export$8793edee2d425525)
    ];
    if (!key) throw new Error("useLocalStorage key may not be falsy");
    var deserializer = options ? options.raw ? function(value) {
        return value;
    } : options.deserializer : JSON.parse;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var initializer = (0, $9nZCP.useRef)(function(key) {
        try {
            var serializer = options ? options.raw ? String : options.serializer : JSON.stringify;
            var localStorageValue = localStorage.getItem(key);
            if (localStorageValue !== null) return deserializer(localStorageValue);
            else {
                initialValue && localStorage.setItem(key, serializer(initialValue));
                return initialValue;
            }
        } catch (_a) {
            // If user is in private mode or has storage restriction
            // localStorage can throw. JSON.parse and JSON.stringify
            // can throw, too.
            return initialValue;
        }
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _a = (0, $9nZCP.useState)(function() {
        return initializer.current(key);
    }), state = _a[0], setState = _a[1];
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $9nZCP.useLayoutEffect)(function() {
        return setState(initializer.current(key));
    }, [
        key
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var set = (0, $9nZCP.useCallback)(function(valOrFunc) {
        try {
            var newState = typeof valOrFunc === "function" ? valOrFunc(state) : valOrFunc;
            if (typeof newState === "undefined") return;
            var value = void 0;
            if (options) {
                if (options.raw) {
                    if (typeof newState === "string") value = newState;
                    else value = JSON.stringify(newState);
                } else if (options.serializer) value = options.serializer(newState);
                else value = JSON.stringify(newState);
            } else value = JSON.stringify(newState);
            localStorage.setItem(key, value);
            setState(deserializer(value));
        } catch (_a) {
        // If user is in private mode or has storage restriction
        // localStorage can throw. Also JSON.stringify can throw.
        }
    }, [
        key,
        setState
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var remove = (0, $9nZCP.useCallback)(function() {
        try {
            localStorage.removeItem(key);
            setState(undefined);
        } catch (_a) {
        // If user is in private mode or has storage restriction
        // localStorage can throw.
        }
    }, [
        key,
        setState
    ]);
    return [
        state,
        set,
        remove
    ];
};
var $ee2306e9d516d2d5$export$2e2bcd8739ae039 = $ee2306e9d516d2d5$var$useLocalStorage;


var $9nZCP = parcelRequire("9nZCP");
var $b2e41656ab938cc0$var$toggleReducer = function(state, nextValue) {
    return typeof nextValue === "boolean" ? nextValue : !state;
};
var $b2e41656ab938cc0$var$useToggle = function(initialValue) {
    return (0, $9nZCP.useReducer)($b2e41656ab938cc0$var$toggleReducer, initialValue);
};
var $b2e41656ab938cc0$export$2e2bcd8739ae039 = $b2e41656ab938cc0$var$useToggle;


const $42c890363ed32eb3$var$Context = /*#__PURE__*/ (0, $9nZCP.createContext)({
    isList: false,
    setIsList: ()=>{
    //
    }
});
const $42c890363ed32eb3$var$IsListProvider = ({ children: children })=>{
    const [isListStorage, setIsListStorage] = (0, $ee2306e9d516d2d5$export$2e2bcd8739ae039)("isList", false);
    const [isList, setIsListState] = (0, $b2e41656ab938cc0$export$2e2bcd8739ae039)(isListStorage ?? false);
    const setIsList = (toggle)=>{
        setIsListState(toggle);
        setIsListStorage(toggle);
    };
    const value = {
        isList: isList,
        setIsList: setIsList
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($42c890363ed32eb3$var$Context.Provider, {
        value: value,
        children: children
    });
};
const $42c890363ed32eb3$export$efcb02388d4a2108 = ()=>(0, $9nZCP.useContext)($42c890363ed32eb3$var$Context);
var $42c890363ed32eb3$export$2e2bcd8739ae039 = $42c890363ed32eb3$var$IsListProvider;



parcelRequire("9nZCP");

const $e1e67658a6d492c4$var$queryClient = new (0, $bfadaea4e3067d9d$export$405d0624ed55a03f)();
const $e1e67658a6d492c4$var$QueryClientProvider = ({ children: children })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $6d6ab9aaa62ea16f$export$45604f0cc8ae667b), {
        client: $e1e67658a6d492c4$var$queryClient,
        children: [
            " ",
            children,
            " "
        ]
    });
var $e1e67658a6d492c4$export$2e2bcd8739ae039 = $e1e67658a6d492c4$var$QueryClientProvider;



parcelRequire("9nZCP");


var $9nZCP = parcelRequire("9nZCP");
function $02bde888b770a5cd$export$86e2cef2561044ac(keyName, defaultValue) {
    const [storedValue, setStoredValue] = (0, $9nZCP.useState)(()=>{
        try {
            const value = window.localStorage.getItem(keyName);
            return value ? JSON.parse(value) : defaultValue;
        } catch (err) {
            return defaultValue;
        }
    });
    const setValue = (newValue)=>{
        try {
            window.localStorage.setItem(keyName, JSON.stringify(newValue));
        } finally{
            setStoredValue(newValue);
        }
    };
    return [
        storedValue,
        setValue
    ];
}




const $fadba3057c087eb0$export$f05794e648629f6c = (0, $1d9bd5c523349ec4$export$f0f03736edb61697)`
  :root {
    --toastify-color-info: ${({ theme: theme })=>theme.primaryBlue};
    --toastify-color-success: ${({ theme: theme })=>theme.success};
    --toastify-color-warning: ${({ theme: theme })=>theme.warning};
    --toastify-color-error: ${({ theme: theme })=>theme.error};
  }

  .react-loading-skeleton {
    z-index: 0;
    --base-color: ${({ theme: theme })=>theme.skeletonBackground};
    --highlight-color: ${({ theme: theme })=>theme.skeletonHighlight};
  }

  body {
    font-family: "Open Sans", sans-serif;
    margin: 0px;
  }

  html {
    box-sizing: border-box;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  *:focus {
    outline: none;
  }

  .ReactModal__Overlay {
    background-color: #1b003fcc !important;
  }

  h1 {
    margin: 0 0 16px 0;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: ${({ theme: theme })=>theme.primaryText};
  }

  h2 {
    margin: 0 0 16px 0;
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    color: ${({ theme: theme })=>theme.primaryText};
  }

  h3 {
    margin: 0 0 16px 0;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: ${({ theme: theme })=>theme.primaryText};
  }

  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${({ theme: theme })=>theme.primaryText};
  }

  textarea {
    font-family: "Open Sans";
    font-size: 14px;
  }

  small {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: ${({ theme: theme })=>theme.primaryText};
  }

  label {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: ${({ theme: theme })=>theme.secondaryText};
  }

  a {
    font-weight: 400;
    font-size: 14px;
    text-decoration: none;
    color: ${({ theme: theme })=>theme.primaryBlue};
  }

  hr {
    opacity: 1;
    border: 1px solid ${({ theme: theme })=>theme.stroke};
  }

  svg, img {
    display: inline-block;
    vertical-align: middle;
  visibility: visible;

  }

  ul {
    li {
      color: ${({ theme: theme })=>theme.primaryText};
    }
  }

  .os-theme-dark {
    --os-handle-bg: ${({ theme: theme })=>theme.violetPurple};
    --os-handle-bg-hover: ${({ theme: theme })=>theme.secondaryPurple};
    --os-handle-bg-active: ${({ theme: theme })=>theme.lavenderPurple};
  }
`;


var $48090fca70e3183a$exports = {};


var $9nZCP = parcelRequire("9nZCP");


var $9nZCP = parcelRequire("9nZCP");
function $697318c29ddcbce3$export$c32275ecbd12948f(defaultValue) {
    const [value, setValue] = (0, $9nZCP.useState)(!!defaultValue);
    const setTrue = (0, $9nZCP.useCallback)(()=>setValue(true), []);
    const setFalse = (0, $9nZCP.useCallback)(()=>setValue(false), []);
    const toggle = (0, $9nZCP.useCallback)(()=>setValue((x)=>!x), []);
    return {
        value: value,
        setValue: setValue,
        setTrue: setTrue,
        setFalse: setFalse,
        toggle: toggle
    };
}



function $9f84e327a4598c1c$export$5139c081cbc6c8bb(handler) {
    (0, $43b84ecb2c55fe21$export$7080b3e976bc91ab)("click", (event)=>{
        handler(event);
    });
}



var $9nZCP = parcelRequire("9nZCP");
var $240fabc79a0cbaf4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $240fabc79a0cbaf4$export$b2199c37e85de4a7() {
    const [copiedText, setCopiedText] = (0, $9nZCP.useState)(null);
    const copy = (text)=>$240fabc79a0cbaf4$var$__awaiter(this, void 0, void 0, function*() {
            if (!(navigator === null || navigator === void 0 ? void 0 : navigator.clipboard)) {
                console.warn("Clipboard not supported");
                return false;
            }
            try {
                yield navigator.clipboard.writeText(text);
                setCopiedText(text);
                return true;
            } catch (error) {
                console.warn("Copy failed", error);
                setCopiedText(null);
                return false;
            }
        });
    return [
        copiedText,
        copy
    ];
}



var $9nZCP = parcelRequire("9nZCP");

function $81f19effac3d019c$export$8103f7eb37e19f7b(countdownOption) {
    let isDeprecated = false;
    let countStart, intervalMs, isIncrement, countStop;
    if ("seconds" in countdownOption) {
        console.warn("[useCountdown:DEPRECATED] new interface is already available (see https://usehooks-ts.com/react-hook/use-countdown), the old version will retire on usehooks-ts@3.");
        isDeprecated = true;
        countStart = countdownOption.seconds;
        intervalMs = countdownOption.interval;
        isIncrement = countdownOption.isIncrement;
    } else ({ countStart: countStart, intervalMs: intervalMs, isIncrement: isIncrement, countStop: countStop } = countdownOption);
    intervalMs = intervalMs !== null && intervalMs !== void 0 ? intervalMs : 1000;
    isIncrement = isIncrement !== null && isIncrement !== void 0 ? isIncrement : false;
    countStop = countStop !== null && countStop !== void 0 ? countStop : 0;
    const { count: count, increment: increment, decrement: decrement, reset: resetCounter } = (0, $598cdd6a6603de65$export$70c4067197c60e2d)(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown } = (0, $697318c29ddcbce3$export$c32275ecbd12948f)(false);
    const resetCountdown = ()=>{
        stopCountdown();
        resetCounter();
    };
    const countdownCallback = (0, $9nZCP.useCallback)(()=>{
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) increment();
        else decrement();
    }, [
        count,
        countStop,
        decrement,
        increment,
        isIncrement,
        stopCountdown
    ]);
    (0, $1c3d3558e91e4208$export$f4b266cd2aae9cb1)(countdownCallback, isCountdownRunning ? intervalMs : null);
    return isDeprecated ? [
        count,
        {
            start: startCountdown,
            stop: stopCountdown,
            reset: resetCountdown
        }
    ] : [
        count,
        {
            startCountdown: startCountdown,
            stopCountdown: stopCountdown,
            resetCountdown: resetCountdown
        }
    ];
}



var $9nZCP = parcelRequire("9nZCP");
function $598cdd6a6603de65$export$70c4067197c60e2d(initialValue) {
    const [count, setCount] = (0, $9nZCP.useState)(initialValue || 0);
    const increment = ()=>setCount((x)=>x + 1);
    const decrement = ()=>setCount((x)=>x - 1);
    const reset = ()=>setCount(initialValue || 0);
    return {
        count: count,
        increment: increment,
        decrement: decrement,
        reset: reset,
        setCount: setCount
    };
}



const $429bbe2d2847ae2d$var$COLOR_SCHEME_QUERY = "(prefers-color-scheme: dark)";
function $429bbe2d2847ae2d$export$4673cbff94e146e2(defaultValue) {
    var _a;
    const isDarkOS = (0, $a133bfd5af9e1765$export$32d5543ab307c01)($429bbe2d2847ae2d$var$COLOR_SCHEME_QUERY);
    const [isDarkMode, setDarkMode] = (0, $f0815febfb475ac4$export$86e2cef2561044ac)("usehooks-ts-dark-mode", (_a = defaultValue !== null && defaultValue !== void 0 ? defaultValue : isDarkOS) !== null && _a !== void 0 ? _a : false);
    (0, $f85a33081ad7471a$export$496315a1608d9602)(()=>{
        setDarkMode(isDarkOS);
    }, [
        isDarkOS
    ]);
    return {
        isDarkMode: isDarkMode,
        toggle: ()=>setDarkMode((prev)=>!prev),
        enable: ()=>setDarkMode(true),
        disable: ()=>setDarkMode(false)
    };
}



var $9nZCP = parcelRequire("9nZCP");
function $af1e1177e9439242$export$21805fee57372823(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0, $9nZCP.useState)(value);
    (0, $9nZCP.useEffect)(()=>{
        const timer = setTimeout(()=>setDebouncedValue(value), delay || 500);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}



function $df90c51f53d2a671$export$4b208edda918084f(title) {
    (0, $4347d2e3aabe144e$export$700979bc83e7db82)(()=>{
        window.document.title = title;
    }, [
        title
    ]);
}



var $9nZCP = parcelRequire("9nZCP");
function $2ef1e20855007e72$export$b558662bb0641046(effect) {
    (0, $9nZCP.useEffect)(effect, []);
}



var $9nZCP = parcelRequire("9nZCP");

function $629256ad26baf52c$export$2b86bedf890eab8() {
    const [ref, setRef] = (0, $9nZCP.useState)(null);
    const [size, setSize] = (0, $9nZCP.useState)({
        width: 0,
        height: 0
    });
    const handleSize = (0, $9nZCP.useCallback)(()=>{
        setSize({
            width: (ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0,
            height: (ref === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0
        });
    }, [
        ref === null || ref === void 0 ? void 0 : ref.offsetHeight,
        ref === null || ref === void 0 ? void 0 : ref.offsetWidth
    ]);
    (0, $43b84ecb2c55fe21$export$7080b3e976bc91ab)("resize", handleSize);
    (0, $4347d2e3aabe144e$export$700979bc83e7db82)(()=>{
        handleSize();
    }, [
        ref === null || ref === void 0 ? void 0 : ref.offsetHeight,
        ref === null || ref === void 0 ? void 0 : ref.offsetWidth
    ]);
    return [
        setRef,
        size
    ];
}



var $9nZCP = parcelRequire("9nZCP");

function $66e4a04ac812005a$export$ee5b5d04074a389e(fn) {
    const ref = (0, $9nZCP.useRef)(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    (0, $4347d2e3aabe144e$export$700979bc83e7db82)(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    return (0, $9nZCP.useCallback)((...args)=>ref.current(...args), [
        ref
    ]);
}



var $9nZCP = parcelRequire("9nZCP");

function $43b84ecb2c55fe21$export$7080b3e976bc91ab(eventName, handler, element, options) {
    const savedHandler = (0, $9nZCP.useRef)(handler);
    (0, $4347d2e3aabe144e$export$700979bc83e7db82)(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, $9nZCP.useEffect)(()=>{
        var _a;
        const targetElement = (_a = element === null || element === void 0 ? void 0 : element.current) !== null && _a !== void 0 ? _a : window;
        if (!(targetElement && targetElement.addEventListener)) return;
        const listener = (event)=>savedHandler.current(event);
        targetElement.addEventListener(eventName, listener, options);
        return ()=>{
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
}



var $9nZCP = parcelRequire("9nZCP");
var $519f13ec5881d423$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $519f13ec5881d423$export$d852f5f778460fa4(url, options) {
    const cache = (0, $9nZCP.useRef)({});
    const cancelRequest = (0, $9nZCP.useRef)(false);
    const initialState = {
        error: undefined,
        data: undefined
    };
    const fetchReducer = (state, action)=>{
        switch(action.type){
            case "loading":
                return Object.assign({}, initialState);
            case "fetched":
                return Object.assign(Object.assign({}, initialState), {
                    data: action.payload
                });
            case "error":
                return Object.assign(Object.assign({}, initialState), {
                    error: action.payload
                });
            default:
                return state;
        }
    };
    const [state, dispatch] = (0, $9nZCP.useReducer)(fetchReducer, initialState);
    (0, $9nZCP.useEffect)(()=>{
        if (!url) return;
        cancelRequest.current = false;
        const fetchData = ()=>$519f13ec5881d423$var$__awaiter(this, void 0, void 0, function*() {
                dispatch({
                    type: "loading"
                });
                if (cache.current[url]) {
                    dispatch({
                        type: "fetched",
                        payload: cache.current[url]
                    });
                    return;
                }
                try {
                    const response = yield fetch(url, options);
                    if (!response.ok) throw new Error(response.statusText);
                    const data = yield response.json();
                    cache.current[url] = data;
                    if (cancelRequest.current) return;
                    dispatch({
                        type: "fetched",
                        payload: data
                    });
                } catch (error) {
                    if (cancelRequest.current) return;
                    dispatch({
                        type: "error",
                        payload: error
                    });
                }
            });
        fetchData();
        return ()=>{
            cancelRequest.current = true;
        };
    }, [
        url
    ]);
    return state;
}



var $9nZCP = parcelRequire("9nZCP");

function $0904ffb4cc7869ba$export$ae780daf29e6d456(elementRef) {
    const [value, setValue] = (0, $9nZCP.useState)(false);
    const handleMouseEnter = ()=>setValue(true);
    const handleMouseLeave = ()=>setValue(false);
    (0, $43b84ecb2c55fe21$export$7080b3e976bc91ab)("mouseenter", handleMouseEnter, elementRef);
    (0, $43b84ecb2c55fe21$export$7080b3e976bc91ab)("mouseleave", handleMouseLeave, elementRef);
    return value;
}



var $9nZCP = parcelRequire("9nZCP");
function $34469f15c84e2e17$export$c822f44b98c8bbf2() {
    const [isLoaded, setIsLoaded] = (0, $9nZCP.useState)(false);
    const handleImageOnLoad = ()=>{
        setIsLoaded(true);
    };
    const css = {
        thumbnail: {
            visibility: isLoaded ? "hidden" : "visible",
            filter: "blur(8px)",
            transition: "visibility 0ms ease-out 500ms"
        },
        fullSize: {
            opacity: isLoaded ? 1 : 0,
            transition: "opacity 500ms ease-in 0ms"
        }
    };
    return {
        handleImageOnLoad: handleImageOnLoad,
        css: css
    };
}



var $9nZCP = parcelRequire("9nZCP");
function $e8cf460b032b7b01$export$a7395f9832c00176(elementRef, { threshold: threshold = 0, root: root = null, rootMargin: rootMargin = "0%", freezeOnceVisible: freezeOnceVisible = false }) {
    const [entry, setEntry] = (0, $9nZCP.useState)();
    const frozen = (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && freezeOnceVisible;
    const updateEntry = ([entry])=>{
        setEntry(entry);
    };
    (0, $9nZCP.useEffect)(()=>{
        const node = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        const hasIOSupport = !!window.IntersectionObserver;
        if (!hasIOSupport || frozen || !node) return;
        const observerParams = {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        };
        const observer = new IntersectionObserver(updateEntry, observerParams);
        observer.observe(node);
        return ()=>observer.disconnect();
    }, [
        elementRef === null || elementRef === void 0 ? void 0 : elementRef.current,
        JSON.stringify(threshold),
        root,
        rootMargin,
        frozen
    ]);
    return entry;
}



var $9nZCP = parcelRequire("9nZCP");

function $1c3d3558e91e4208$export$f4b266cd2aae9cb1(callback, delay) {
    const savedCallback = (0, $9nZCP.useRef)(callback);
    (0, $4347d2e3aabe144e$export$700979bc83e7db82)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $9nZCP.useEffect)(()=>{
        if (!delay && delay !== 0) return;
        const id = setInterval(()=>savedCallback.current(), delay);
        return ()=>clearInterval(id);
    }, [
        delay
    ]);
}



var $9nZCP = parcelRequire("9nZCP");
function $de5285ec607e95a7$export$7c8949515a63d2a1() {
    const [isClient, setClient] = (0, $9nZCP.useState)(false);
    (0, $9nZCP.useEffect)(()=>{
        setClient(true);
    }, []);
    return isClient;
}



var $9nZCP = parcelRequire("9nZCP");
function $d4656f962bc9bb3c$export$5964c316e853650f() {
    const isFirst = (0, $9nZCP.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}



var $9nZCP = parcelRequire("9nZCP");
function $e2c705033b05fff0$export$80c2a3957bcb42ea() {
    const isMounted = (0, $9nZCP.useRef)(false);
    (0, $9nZCP.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $9nZCP.useCallback)(()=>isMounted.current, []);
}



var $9nZCP = parcelRequire("9nZCP");
const $4347d2e3aabe144e$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $9nZCP.useLayoutEffect) : (0, $9nZCP.useEffect);



var $9nZCP = parcelRequire("9nZCP");

function $f0815febfb475ac4$export$86e2cef2561044ac(key, initialValue) {
    const readValue = (0, $9nZCP.useCallback)(()=>{
        if (typeof window === "undefined") return initialValue;
        try {
            const item = window.localStorage.getItem(key);
            return item ? $f0815febfb475ac4$var$parseJSON(item) : initialValue;
        } catch (error) {
            console.warn(`Error reading localStorage key \u{201C}${key}\u{201D}:`, error);
            return initialValue;
        }
    }, [
        initialValue,
        key
    ]);
    const [storedValue, setStoredValue] = (0, $9nZCP.useState)(readValue);
    const setValue = (0, $66e4a04ac812005a$export$ee5b5d04074a389e)((value)=>{
        if (typeof window === "undefined") console.warn(`Tried setting localStorage key \u{201C}${key}\u{201D} even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(storedValue) : value;
            window.localStorage.setItem(key, JSON.stringify(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new Event("local-storage"));
        } catch (error) {
            console.warn(`Error setting localStorage key \u{201C}${key}\u{201D}:`, error);
        }
    });
    (0, $9nZCP.useEffect)(()=>{
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = (0, $9nZCP.useCallback)((event)=>{
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    (0, $43b84ecb2c55fe21$export$7080b3e976bc91ab)("storage", handleStorageChange);
    (0, $43b84ecb2c55fe21$export$7080b3e976bc91ab)("local-storage", handleStorageChange);
    return [
        storedValue,
        setValue
    ];
}
function $f0815febfb475ac4$var$parseJSON(value) {
    try {
        return value === "undefined" ? undefined : JSON.parse(value !== null && value !== void 0 ? value : "");
    } catch (_a) {
        console.log("parsing error on", {
            value: value
        });
        return undefined;
    }
}



var $9nZCP = parcelRequire("9nZCP");

function $f3db303d33a2ec98$export$314db5846aaeae6e(initialLocked = false, rootId = "___gatsby") {
    const [locked, setLocked] = (0, $9nZCP.useState)(initialLocked);
    (0, $4347d2e3aabe144e$export$700979bc83e7db82)(()=>{
        if (!locked) return;
        const originalOverflow = document.body.style.overflow;
        const originalPaddingRight = document.body.style.paddingRight;
        document.body.style.overflow = "hidden";
        const root = document.getElementById(rootId);
        const scrollBarWidth = root ? root.offsetWidth - root.scrollWidth : 0;
        if (scrollBarWidth) document.body.style.paddingRight = `${scrollBarWidth}px`;
        return ()=>{
            document.body.style.overflow = originalOverflow;
            if (scrollBarWidth) document.body.style.paddingRight = originalPaddingRight;
        };
    }, [
        locked
    ]);
    (0, $9nZCP.useEffect)(()=>{
        if (locked !== initialLocked) setLocked(initialLocked);
    }, [
        initialLocked
    ]);
    return [
        locked,
        setLocked
    ];
}
var $f3db303d33a2ec98$export$2e2bcd8739ae039 = $f3db303d33a2ec98$export$314db5846aaeae6e;



var $9nZCP = parcelRequire("9nZCP");
function $a2b3299b5bf469d6$export$86f8f9f08863e403(initialState = new Map()) {
    const [map, setMap] = (0, $9nZCP.useState)(new Map(initialState));
    const actions = {
        set: (0, $9nZCP.useCallback)((key, value)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: (0, $9nZCP.useCallback)((entries)=>{
            setMap(()=>new Map(entries));
        }, []),
        remove: (0, $9nZCP.useCallback)((key)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: (0, $9nZCP.useCallback)(()=>{
            setMap(()=>new Map());
        }, [])
    };
    return [
        map,
        actions
    ];
}



var $9nZCP = parcelRequire("9nZCP");
function $a133bfd5af9e1765$export$32d5543ab307c01(query) {
    const getMatches = (query)=>{
        if (typeof window !== "undefined") return window.matchMedia(query).matches;
        return false;
    };
    const [matches, setMatches] = (0, $9nZCP.useState)(getMatches(query));
    function handleChange() {
        setMatches(getMatches(query));
    }
    (0, $9nZCP.useEffect)(()=>{
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) matchMedia.addListener(handleChange);
        else matchMedia.addEventListener("change", handleChange);
        return ()=>{
            if (matchMedia.removeListener) matchMedia.removeListener(handleChange);
            else matchMedia.removeEventListener("change", handleChange);
        };
    }, [
        query
    ]);
    return matches;
}



function $e6f6299555b2ac6f$export$9afc64c180e82dc4(ref, handler, mouseEvent = "mousedown") {
    (0, $43b84ecb2c55fe21$export$7080b3e976bc91ab)(mouseEvent, (event)=>{
        const el = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!el || el.contains(event.target)) return;
        handler(event);
    });
}



var $9nZCP = parcelRequire("9nZCP");

function $8824a35c007ff5e6$export$558ff211cfc1c1fe(key) {
    const readValue = (0, $9nZCP.useCallback)(()=>{
        if (typeof window === "undefined") return null;
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        } catch (error) {
            console.warn(`Error reading localStorage key \u{201C}${key}\u{201D}:`, error);
            return null;
        }
    }, [
        key
    ]);
    const [storedValue, setStoredValue] = (0, $9nZCP.useState)(readValue);
    (0, $9nZCP.useEffect)(()=>{
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = (0, $9nZCP.useCallback)((event)=>{
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    (0, $43b84ecb2c55fe21$export$7080b3e976bc91ab)("storage", handleStorageChange);
    (0, $43b84ecb2c55fe21$export$7080b3e976bc91ab)("local-storage", handleStorageChange);
    return storedValue;
}



var $9nZCP = parcelRequire("9nZCP");

function $e865f0ca19d9f1f3$export$654d3fb7a8fef387() {
    const getScreen = ()=>{
        if (typeof window !== "undefined" && window.screen) return window.screen;
        return undefined;
    };
    const [screen, setScreen] = (0, $9nZCP.useState)(getScreen());
    function handleSize() {
        setScreen(getScreen());
    }
    (0, $43b84ecb2c55fe21$export$7080b3e976bc91ab)("resize", handleSize);
    (0, $4347d2e3aabe144e$export$700979bc83e7db82)(()=>{
        handleSize();
    }, []);
    return screen;
}



var $9nZCP = parcelRequire("9nZCP");
const $af983314e29e4528$var$cachedScriptStatuses = {};
function $af983314e29e4528$var$getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node === null || node === void 0 ? void 0 : node.getAttribute("data-status");
    return {
        node: node,
        status: status
    };
}
function $af983314e29e4528$export$1d3955b0b5cace9c(src, options) {
    const [status, setStatus] = (0, $9nZCP.useState)(()=>{
        var _a;
        if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) return "idle";
        if (typeof window === "undefined") return "loading";
        return (_a = $af983314e29e4528$var$cachedScriptStatuses[src]) !== null && _a !== void 0 ? _a : "loading";
    });
    (0, $9nZCP.useEffect)(()=>{
        var _a, _b;
        if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) return;
        const cachedScriptStatus = $af983314e29e4528$var$cachedScriptStatuses[src];
        if (cachedScriptStatus === "ready" || cachedScriptStatus === "error") {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = $af983314e29e4528$var$getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement("script");
            scriptNode.src = src;
            scriptNode.async = true;
            scriptNode.setAttribute("data-status", "loading");
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event)=>{
                const scriptStatus = event.type === "load" ? "ready" : "error";
                scriptNode === null || scriptNode === void 0 || scriptNode.setAttribute("data-status", scriptStatus);
            };
            scriptNode.addEventListener("load", setAttributeFromEvent);
            scriptNode.addEventListener("error", setAttributeFromEvent);
        } else setStatus((_b = (_a = script.status) !== null && _a !== void 0 ? _a : cachedScriptStatus) !== null && _b !== void 0 ? _b : "loading");
        const setStateFromEvent = (event)=>{
            const newStatus = event.type === "load" ? "ready" : "error";
            setStatus(newStatus);
            $af983314e29e4528$var$cachedScriptStatuses[src] = newStatus;
        };
        scriptNode.addEventListener("load", setStateFromEvent);
        scriptNode.addEventListener("error", setStateFromEvent);
        return ()=>{
            if (scriptNode) {
                scriptNode.removeEventListener("load", setStateFromEvent);
                scriptNode.removeEventListener("error", setStateFromEvent);
            }
            if (scriptNode && (options === null || options === void 0 ? void 0 : options.removeOnUnmount)) scriptNode.remove();
        };
    }, [
        src,
        options === null || options === void 0 ? void 0 : options.shouldPreventLoad,
        options === null || options === void 0 ? void 0 : options.removeOnUnmount
    ]);
    return status;
}



var $9nZCP = parcelRequire("9nZCP");

function $58adf50ed41707d2$export$864b6828bd07eda6(key, initialValue) {
    const readValue = (0, $9nZCP.useCallback)(()=>{
        if (typeof window === "undefined") return initialValue;
        try {
            const item = window.sessionStorage.getItem(key);
            return item ? $58adf50ed41707d2$var$parseJSON(item) : initialValue;
        } catch (error) {
            console.warn(`Error reading sessionStorage key \u{201C}${key}\u{201D}:`, error);
            return initialValue;
        }
    }, [
        initialValue,
        key
    ]);
    const [storedValue, setStoredValue] = (0, $9nZCP.useState)(readValue);
    const setValue = (0, $66e4a04ac812005a$export$ee5b5d04074a389e)((value)=>{
        if (typeof window == "undefined") console.warn(`Tried setting sessionStorage key \u{201C}${key}\u{201D} even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(storedValue) : value;
            window.sessionStorage.setItem(key, JSON.stringify(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new Event("session-storage"));
        } catch (error) {
            console.warn(`Error setting sessionStorage key \u{201C}${key}\u{201D}:`, error);
        }
    });
    (0, $9nZCP.useEffect)(()=>{
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = (0, $9nZCP.useCallback)((event)=>{
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    (0, $43b84ecb2c55fe21$export$7080b3e976bc91ab)("storage", handleStorageChange);
    (0, $43b84ecb2c55fe21$export$7080b3e976bc91ab)("session-storage", handleStorageChange);
    return [
        storedValue,
        setValue
    ];
}
function $58adf50ed41707d2$var$parseJSON(value) {
    try {
        return value === "undefined" ? undefined : JSON.parse(value !== null && value !== void 0 ? value : "");
    } catch (_a) {
        console.log("parsing error on", {
            value: value
        });
        return undefined;
    }
}


function $bfde644256c1cfa5$export$f4eafc809f5e6ccc() {
    const isDOM = typeof window !== "undefined" && window.document && window.document.documentElement;
    return {
        isBrowser: isDOM,
        isServer: !isDOM
    };
}



var $9nZCP = parcelRequire("9nZCP");
function $2f2ee96811e293ef$export$7896576cb7635832(maxStep) {
    const [currentStep, setCurrentStep] = (0, $9nZCP.useState)(1);
    const canGoToNextStep = (0, $9nZCP.useMemo)(()=>currentStep + 1 <= maxStep, [
        currentStep,
        maxStep
    ]);
    const canGoToPrevStep = (0, $9nZCP.useMemo)(()=>currentStep - 1 >= 1, [
        currentStep
    ]);
    const setStep = (0, $9nZCP.useCallback)((step)=>{
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error("Step not valid");
    }, [
        maxStep,
        currentStep
    ]);
    const goToNextStep = (0, $9nZCP.useCallback)(()=>{
        if (canGoToNextStep) setCurrentStep((step)=>step + 1);
    }, [
        canGoToNextStep
    ]);
    const goToPrevStep = (0, $9nZCP.useCallback)(()=>{
        if (canGoToPrevStep) setCurrentStep((step)=>step - 1);
    }, [
        canGoToPrevStep
    ]);
    const reset = (0, $9nZCP.useCallback)(()=>{
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep: goToNextStep,
            goToPrevStep: goToPrevStep,
            canGoToNextStep: canGoToNextStep,
            canGoToPrevStep: canGoToPrevStep,
            setStep: setStep,
            reset: reset
        }
    ];
}



var $9nZCP = parcelRequire("9nZCP");

const $f84e7cae1382d6bb$var$COLOR_SCHEME_QUERY = "(prefers-color-scheme: dark)";
function $f84e7cae1382d6bb$export$ec561688e440eda6() {
    const isDarkOS = (0, $a133bfd5af9e1765$export$32d5543ab307c01)($f84e7cae1382d6bb$var$COLOR_SCHEME_QUERY);
    const [ternaryDarkMode, setTernaryDarkMode] = (0, $f0815febfb475ac4$export$86e2cef2561044ac)("usehooks-ts-ternary-dark-mode", "system");
    const [isDarkMode, setDarkMode] = (0, $9nZCP.useState)(isDarkOS);
    (0, $f85a33081ad7471a$export$496315a1608d9602)(()=>{
        if (ternaryDarkMode === "system") setDarkMode(isDarkOS);
    }, [
        isDarkOS
    ]);
    (0, $9nZCP.useEffect)(()=>{
        switch(ternaryDarkMode){
            case "light":
                setDarkMode(false);
                break;
            case "system":
                setDarkMode(isDarkOS);
                break;
            case "dark":
                setDarkMode(true);
                break;
        }
    }, [
        ternaryDarkMode,
        isDarkOS
    ]);
    function toggleTernaryDarkMode() {
        const toggleDict = {
            light: "system",
            system: "dark",
            dark: "light"
        };
        setTernaryDarkMode((prevMode)=>toggleDict[prevMode]);
    }
    return {
        isDarkMode: isDarkMode,
        ternaryDarkMode: ternaryDarkMode,
        setTernaryDarkMode: setTernaryDarkMode,
        toggleTernaryDarkMode: toggleTernaryDarkMode
    };
}



var $9nZCP = parcelRequire("9nZCP");

function $dc3309061cd6303c$export$d8e6abf214c9ec0f(callback, delay) {
    const savedCallback = (0, $9nZCP.useRef)(callback);
    (0, $4347d2e3aabe144e$export$700979bc83e7db82)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $9nZCP.useEffect)(()=>{
        if (!delay && delay !== 0) return;
        const id = setTimeout(()=>savedCallback.current(), delay);
        return ()=>clearTimeout(id);
    }, [
        delay
    ]);
}



var $9nZCP = parcelRequire("9nZCP");
function $e1243e9448f6fa0e$export$cbe85ee05b554577(defaultValue) {
    const [value, setValue] = (0, $9nZCP.useState)(!!defaultValue);
    const toggle = (0, $9nZCP.useCallback)(()=>setValue((x)=>!x), []);
    return [
        value,
        toggle,
        setValue
    ];
}



var $9nZCP = parcelRequire("9nZCP");

function $f85a33081ad7471a$export$496315a1608d9602(effect, deps) {
    const isFirst = (0, $d4656f962bc9bb3c$export$5964c316e853650f)();
    (0, $9nZCP.useEffect)(()=>{
        if (!isFirst) return effect();
    }, deps);
}



var $9nZCP = parcelRequire("9nZCP");

function $0526c45f56aa5595$export$42c02f33970a2afa() {
    const [windowSize, setWindowSize] = (0, $9nZCP.useState)({
        width: 0,
        height: 0
    });
    const handleSize = ()=>{
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };
    (0, $43b84ecb2c55fe21$export$7080b3e976bc91ab)("resize", handleSize);
    (0, $4347d2e3aabe144e$export$700979bc83e7db82)(()=>{
        handleSize();
    }, []);
    return windowSize;
}




var $b76fad9a3dd6491d$exports = {};

$parcel$defineInteropFlag($b76fad9a3dd6491d$exports);

$parcel$export($b76fad9a3dd6491d$exports, "default", function () { return $b76fad9a3dd6491d$export$2e2bcd8739ae039; });
/**
 * simplebar-react - v2.4.3
 * React component for SimpleBar
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat
 * Under MIT License
 */ 
var $9nZCP = parcelRequire("9nZCP");
var $0287d6dd1c5d0193$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0287d6dd1c5d0193$var$ReactIs, $0287d6dd1c5d0193$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$0287d6dd1c5d0193$exports = (parcelRequire("hFdkQ"))();


/**
 * SimpleBar.js - v5.3.9
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */ "use strict";
var $621e6bc7a2f56e42$exports = {};
"use strict";
var $818e316f8a39904d$exports = {};
"use strict";
var $818e316f8a39904d$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$818e316f8a39904d$exports = // eslint-disable-next-line es/no-global-this -- safe
$818e316f8a39904d$var$check(typeof globalThis == "object" && globalThis) || $818e316f8a39904d$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$818e316f8a39904d$var$check(typeof self == "object" && self) || $818e316f8a39904d$var$check(typeof $parcel$global == "object" && $parcel$global) || $818e316f8a39904d$var$check(typeof $818e316f8a39904d$exports == "object" && $818e316f8a39904d$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $5dee88fe230545da$export$2d1720544b23b823;
"use strict";
var $a934004253d25a42$exports = {};
"use strict";
var $1c0f139a1a463ce1$exports = {};
"use strict";
$1c0f139a1a463ce1$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$a934004253d25a42$exports = !$1c0f139a1a463ce1$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $ba3e81ca5de34305$exports = {};
"use strict";
var $13cf557f31fcb3db$exports = {};
"use strict";

$13cf557f31fcb3db$exports = !$1c0f139a1a463ce1$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $ba3e81ca5de34305$var$call = Function.prototype.call;
$ba3e81ca5de34305$exports = $13cf557f31fcb3db$exports ? $ba3e81ca5de34305$var$call.bind($ba3e81ca5de34305$var$call) : function() {
    return $ba3e81ca5de34305$var$call.apply($ba3e81ca5de34305$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $37435e8ffd2f28b9$export$2d1720544b23b823;
"use strict";
var $37435e8ffd2f28b9$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $37435e8ffd2f28b9$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $37435e8ffd2f28b9$var$NASHORN_BUG = $37435e8ffd2f28b9$var$getOwnPropertyDescriptor && !$37435e8ffd2f28b9$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$37435e8ffd2f28b9$export$2d1720544b23b823 = $37435e8ffd2f28b9$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $37435e8ffd2f28b9$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $37435e8ffd2f28b9$var$$propertyIsEnumerable;


var $7f001fc6b2d5740c$exports = {};
"use strict";
$7f001fc6b2d5740c$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $08ccc8de002b7975$exports = {};
"use strict";
var $9d1a1577a6ed79d1$exports = {};
"use strict";
var $86d27fcf3ddb374a$exports = {};
"use strict";

var $86d27fcf3ddb374a$var$FunctionPrototype = Function.prototype;
var $86d27fcf3ddb374a$var$call = $86d27fcf3ddb374a$var$FunctionPrototype.call;
var $86d27fcf3ddb374a$var$uncurryThisWithBind = $13cf557f31fcb3db$exports && $86d27fcf3ddb374a$var$FunctionPrototype.bind.bind($86d27fcf3ddb374a$var$call, $86d27fcf3ddb374a$var$call);
$86d27fcf3ddb374a$exports = $13cf557f31fcb3db$exports ? $86d27fcf3ddb374a$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $86d27fcf3ddb374a$var$call.apply(fn, arguments);
    };
};



var $f65b6a6904086b61$exports = {};
"use strict";

var $f65b6a6904086b61$var$toString = $86d27fcf3ddb374a$exports({}.toString);
var $f65b6a6904086b61$var$stringSlice = $86d27fcf3ddb374a$exports("".slice);
$f65b6a6904086b61$exports = function(it) {
    return $f65b6a6904086b61$var$stringSlice($f65b6a6904086b61$var$toString(it), 8, -1);
};


var $9d1a1577a6ed79d1$var$$Object = Object;
var $9d1a1577a6ed79d1$var$split = $86d27fcf3ddb374a$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$9d1a1577a6ed79d1$exports = $1c0f139a1a463ce1$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$9d1a1577a6ed79d1$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $f65b6a6904086b61$exports(it) === "String" ? $9d1a1577a6ed79d1$var$split(it, "") : $9d1a1577a6ed79d1$var$$Object(it);
} : $9d1a1577a6ed79d1$var$$Object;


var $ce17aed0e5032df3$exports = {};
"use strict";
var $896d3aa83f9594d3$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$896d3aa83f9594d3$exports = function(it) {
    return it === null || it === undefined;
};


var $ce17aed0e5032df3$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$ce17aed0e5032df3$exports = function(it) {
    if ($896d3aa83f9594d3$exports(it)) throw new $ce17aed0e5032df3$var$$TypeError("Can't call method on " + it);
    return it;
};


$08ccc8de002b7975$exports = function(it) {
    return $9d1a1577a6ed79d1$exports($ce17aed0e5032df3$exports(it));
};


var $aa87b438f737b110$exports = {};
"use strict";
var $f834c60b1a0b755b$exports = {};
"use strict";

var $abc01766c6ffc0a1$exports = {};
"use strict";
var $da9965769ab8d492$exports = {};
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $da9965769ab8d492$var$documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$da9965769ab8d492$exports = typeof $da9965769ab8d492$var$documentAll == "undefined" && $da9965769ab8d492$var$documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === $da9965769ab8d492$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


$abc01766c6ffc0a1$exports = function(it) {
    return typeof it == "object" ? it !== null : $da9965769ab8d492$exports(it);
};


var $5df20ec038ad0f10$exports = {};
"use strict";
var $18c5ef8b38a03108$exports = {};
"use strict";


var $18c5ef8b38a03108$var$aFunction = function(argument) {
    return $da9965769ab8d492$exports(argument) ? argument : undefined;
};
$18c5ef8b38a03108$exports = function(namespace, method) {
    return arguments.length < 2 ? $18c5ef8b38a03108$var$aFunction($818e316f8a39904d$exports[namespace]) : $818e316f8a39904d$exports[namespace] && $818e316f8a39904d$exports[namespace][method];
};



var $d5379fc5818962a4$exports = {};
"use strict";

$d5379fc5818962a4$exports = $86d27fcf3ddb374a$exports({}.isPrototypeOf);


var $08fd740cb2cfbfcb$exports = {};
"use strict";
var $371337e1b5a91d41$exports = {};
"use strict";
var $e5ab0d050bcf2c0f$exports = {};
"use strict";

var $cda96ddf7fc4ff92$exports = {};
"use strict";
$cda96ddf7fc4ff92$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $e5ab0d050bcf2c0f$var$process = $818e316f8a39904d$exports.process;
var $e5ab0d050bcf2c0f$var$Deno = $818e316f8a39904d$exports.Deno;
var $e5ab0d050bcf2c0f$var$versions = $e5ab0d050bcf2c0f$var$process && $e5ab0d050bcf2c0f$var$process.versions || $e5ab0d050bcf2c0f$var$Deno && $e5ab0d050bcf2c0f$var$Deno.version;
var $e5ab0d050bcf2c0f$var$v8 = $e5ab0d050bcf2c0f$var$versions && $e5ab0d050bcf2c0f$var$versions.v8;
var $e5ab0d050bcf2c0f$var$match, $e5ab0d050bcf2c0f$var$version;
if ($e5ab0d050bcf2c0f$var$v8) {
    $e5ab0d050bcf2c0f$var$match = $e5ab0d050bcf2c0f$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $e5ab0d050bcf2c0f$var$version = $e5ab0d050bcf2c0f$var$match[0] > 0 && $e5ab0d050bcf2c0f$var$match[0] < 4 ? 1 : +($e5ab0d050bcf2c0f$var$match[0] + $e5ab0d050bcf2c0f$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$e5ab0d050bcf2c0f$var$version && $cda96ddf7fc4ff92$exports) {
    $e5ab0d050bcf2c0f$var$match = $cda96ddf7fc4ff92$exports.match(/Edge\/(\d+)/);
    if (!$e5ab0d050bcf2c0f$var$match || $e5ab0d050bcf2c0f$var$match[1] >= 74) {
        $e5ab0d050bcf2c0f$var$match = $cda96ddf7fc4ff92$exports.match(/Chrome\/(\d+)/);
        if ($e5ab0d050bcf2c0f$var$match) $e5ab0d050bcf2c0f$var$version = +$e5ab0d050bcf2c0f$var$match[1];
    }
}
$e5ab0d050bcf2c0f$exports = $e5ab0d050bcf2c0f$var$version;




var $371337e1b5a91d41$var$$String = $818e316f8a39904d$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$371337e1b5a91d41$exports = !!Object.getOwnPropertySymbols && !$1c0f139a1a463ce1$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$371337e1b5a91d41$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $e5ab0d050bcf2c0f$exports && $e5ab0d050bcf2c0f$exports < 41;
});


$08fd740cb2cfbfcb$exports = $371337e1b5a91d41$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $5df20ec038ad0f10$var$$Object = Object;
$5df20ec038ad0f10$exports = $08fd740cb2cfbfcb$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $18c5ef8b38a03108$exports("Symbol");
    return $da9965769ab8d492$exports($Symbol) && $d5379fc5818962a4$exports($Symbol.prototype, $5df20ec038ad0f10$var$$Object(it));
};


var $ea805a34e9f0856a$exports = {};
"use strict";
var $a339c863cff407d1$exports = {};
"use strict";

var $3ad1d00e209ff694$exports = {};
"use strict";
var $3ad1d00e209ff694$var$$String = String;
$3ad1d00e209ff694$exports = function(argument) {
    try {
        return $3ad1d00e209ff694$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $a339c863cff407d1$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$a339c863cff407d1$exports = function(argument) {
    if ($da9965769ab8d492$exports(argument)) return argument;
    throw new $a339c863cff407d1$var$$TypeError($3ad1d00e209ff694$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$ea805a34e9f0856a$exports = function(V, P) {
    var func = V[P];
    return $896d3aa83f9594d3$exports(func) ? undefined : $a339c863cff407d1$exports(func);
};


var $7320fa2e6fa65726$exports = {};
"use strict";



var $7320fa2e6fa65726$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$7320fa2e6fa65726$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $da9965769ab8d492$exports(fn = input.toString) && !$abc01766c6ffc0a1$exports(val = $ba3e81ca5de34305$exports(fn, input))) return val;
    if ($da9965769ab8d492$exports(fn = input.valueOf) && !$abc01766c6ffc0a1$exports(val = $ba3e81ca5de34305$exports(fn, input))) return val;
    if (pref !== "string" && $da9965769ab8d492$exports(fn = input.toString) && !$abc01766c6ffc0a1$exports(val = $ba3e81ca5de34305$exports(fn, input))) return val;
    throw new $7320fa2e6fa65726$var$$TypeError("Can't convert object to primitive value");
};


var $06b7b285e3a7068a$exports = {};
"use strict";

var $9b42448d053bd3c4$exports = {};
"use strict";
var $8a834a2771c3d77e$exports = {};
"use strict";
$8a834a2771c3d77e$exports = false;


var $b1111eb01f23fc98$exports = {};
"use strict";

var $85363e39cdbcb0f8$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $85363e39cdbcb0f8$var$defineProperty = Object.defineProperty;
$85363e39cdbcb0f8$exports = function(key, value) {
    try {
        $85363e39cdbcb0f8$var$defineProperty($818e316f8a39904d$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $818e316f8a39904d$exports[key] = value;
    }
    return value;
};


var $b1111eb01f23fc98$var$SHARED = "__core-js_shared__";
var $b1111eb01f23fc98$var$store = $818e316f8a39904d$exports[$b1111eb01f23fc98$var$SHARED] || $85363e39cdbcb0f8$exports($b1111eb01f23fc98$var$SHARED, {});
$b1111eb01f23fc98$exports = $b1111eb01f23fc98$var$store;


($9b42448d053bd3c4$exports = function(key, value) {
    return $b1111eb01f23fc98$exports[key] || ($b1111eb01f23fc98$exports[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.35.0",
    mode: $8a834a2771c3d77e$exports ? "pure" : "global",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.35.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


var $9fd86a02d78d2d99$exports = {};
"use strict";

var $c9b4f3ef4a96c778$exports = {};
"use strict";

var $c9b4f3ef4a96c778$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$c9b4f3ef4a96c778$exports = function(argument) {
    return $c9b4f3ef4a96c778$var$$Object($ce17aed0e5032df3$exports(argument));
};


var $9fd86a02d78d2d99$var$hasOwnProperty = $86d27fcf3ddb374a$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$9fd86a02d78d2d99$exports = Object.hasOwn || function hasOwn(it, key) {
    return $9fd86a02d78d2d99$var$hasOwnProperty($c9b4f3ef4a96c778$exports(it), key);
};


var $2e904edd887c2aab$exports = {};
"use strict";

var $2e904edd887c2aab$var$id = 0;
var $2e904edd887c2aab$var$postfix = Math.random();
var $2e904edd887c2aab$var$toString = $86d27fcf3ddb374a$exports(1.0.toString);
$2e904edd887c2aab$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $2e904edd887c2aab$var$toString(++$2e904edd887c2aab$var$id + $2e904edd887c2aab$var$postfix, 36);
};




var $06b7b285e3a7068a$var$Symbol = $818e316f8a39904d$exports.Symbol;
var $06b7b285e3a7068a$var$WellKnownSymbolsStore = $9b42448d053bd3c4$exports("wks");
var $06b7b285e3a7068a$var$createWellKnownSymbol = $08fd740cb2cfbfcb$exports ? $06b7b285e3a7068a$var$Symbol["for"] || $06b7b285e3a7068a$var$Symbol : $06b7b285e3a7068a$var$Symbol && $06b7b285e3a7068a$var$Symbol.withoutSetter || $2e904edd887c2aab$exports;
$06b7b285e3a7068a$exports = function(name) {
    if (!$9fd86a02d78d2d99$exports($06b7b285e3a7068a$var$WellKnownSymbolsStore, name)) $06b7b285e3a7068a$var$WellKnownSymbolsStore[name] = $371337e1b5a91d41$exports && $9fd86a02d78d2d99$exports($06b7b285e3a7068a$var$Symbol, name) ? $06b7b285e3a7068a$var$Symbol[name] : $06b7b285e3a7068a$var$createWellKnownSymbol("Symbol." + name);
    return $06b7b285e3a7068a$var$WellKnownSymbolsStore[name];
};


var $f834c60b1a0b755b$var$$TypeError = TypeError;
var $f834c60b1a0b755b$var$TO_PRIMITIVE = $06b7b285e3a7068a$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$f834c60b1a0b755b$exports = function(input, pref) {
    if (!$abc01766c6ffc0a1$exports(input) || $5df20ec038ad0f10$exports(input)) return input;
    var exoticToPrim = $ea805a34e9f0856a$exports(input, $f834c60b1a0b755b$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $ba3e81ca5de34305$exports(exoticToPrim, input, pref);
        if (!$abc01766c6ffc0a1$exports(result) || $5df20ec038ad0f10$exports(result)) return result;
        throw new $f834c60b1a0b755b$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $7320fa2e6fa65726$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$aa87b438f737b110$exports = function(argument) {
    var key = $f834c60b1a0b755b$exports(argument, "string");
    return $5df20ec038ad0f10$exports(key) ? key : key + "";
};



var $a4f0c82f3dc91231$exports = {};
"use strict";


var $6a21b3c3b047179b$exports = {};
"use strict";


var $6a21b3c3b047179b$var$document = $818e316f8a39904d$exports.document;
// typeof document.createElement is 'object' in old IE
var $6a21b3c3b047179b$var$EXISTS = $abc01766c6ffc0a1$exports($6a21b3c3b047179b$var$document) && $abc01766c6ffc0a1$exports($6a21b3c3b047179b$var$document.createElement);
$6a21b3c3b047179b$exports = function(it) {
    return $6a21b3c3b047179b$var$EXISTS ? $6a21b3c3b047179b$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$a4f0c82f3dc91231$exports = !$a934004253d25a42$exports && !$1c0f139a1a463ce1$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($6a21b3c3b047179b$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $5dee88fe230545da$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$5dee88fe230545da$export$2d1720544b23b823 = $a934004253d25a42$exports ? $5dee88fe230545da$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $08ccc8de002b7975$exports(O);
    P = $aa87b438f737b110$exports(P);
    if ($a4f0c82f3dc91231$exports) try {
        return $5dee88fe230545da$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($9fd86a02d78d2d99$exports(O, P)) return $7f001fc6b2d5740c$exports(!$ba3e81ca5de34305$exports($37435e8ffd2f28b9$export$2d1720544b23b823, O, P), O[P]);
};


var $621e6bc7a2f56e42$require$getOwnPropertyDescriptor = $5dee88fe230545da$export$2d1720544b23b823;
var $3d5a463be44ffeea$exports = {};
"use strict";

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $96bd28438ee2eee5$export$2d1720544b23b823;
"use strict";


var $99f023d30bb6ec12$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$99f023d30bb6ec12$exports = $a934004253d25a42$exports && $1c0f139a1a463ce1$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $c53804bbcc663539$exports = {};
"use strict";

var $c53804bbcc663539$var$$String = String;
var $c53804bbcc663539$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$c53804bbcc663539$exports = function(argument) {
    if ($abc01766c6ffc0a1$exports(argument)) return argument;
    throw new $c53804bbcc663539$var$$TypeError($c53804bbcc663539$var$$String(argument) + " is not an object");
};



var $96bd28438ee2eee5$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $96bd28438ee2eee5$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $96bd28438ee2eee5$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $96bd28438ee2eee5$var$ENUMERABLE = "enumerable";
var $96bd28438ee2eee5$var$CONFIGURABLE = "configurable";
var $96bd28438ee2eee5$var$WRITABLE = "writable";
$96bd28438ee2eee5$export$2d1720544b23b823 = $a934004253d25a42$exports ? $99f023d30bb6ec12$exports ? function defineProperty(O, P, Attributes) {
    $c53804bbcc663539$exports(O);
    P = $aa87b438f737b110$exports(P);
    $c53804bbcc663539$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $96bd28438ee2eee5$var$WRITABLE in Attributes && !Attributes[$96bd28438ee2eee5$var$WRITABLE]) {
        var current = $96bd28438ee2eee5$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$96bd28438ee2eee5$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $96bd28438ee2eee5$var$CONFIGURABLE in Attributes ? Attributes[$96bd28438ee2eee5$var$CONFIGURABLE] : current[$96bd28438ee2eee5$var$CONFIGURABLE],
                enumerable: $96bd28438ee2eee5$var$ENUMERABLE in Attributes ? Attributes[$96bd28438ee2eee5$var$ENUMERABLE] : current[$96bd28438ee2eee5$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $96bd28438ee2eee5$var$$defineProperty(O, P, Attributes);
} : $96bd28438ee2eee5$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $c53804bbcc663539$exports(O);
    P = $aa87b438f737b110$exports(P);
    $c53804bbcc663539$exports(Attributes);
    if ($a4f0c82f3dc91231$exports) try {
        return $96bd28438ee2eee5$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $96bd28438ee2eee5$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};



$3d5a463be44ffeea$exports = $a934004253d25a42$exports ? function(object, key, value) {
    return $96bd28438ee2eee5$export$2d1720544b23b823(object, key, $7f001fc6b2d5740c$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $cc8a5761541cd35d$exports = {};
"use strict";


var $157fbe5a4073e8a8$exports = {};
"use strict";





var $b82122a7f3a0fd21$exports = {};
"use strict";


var $b82122a7f3a0fd21$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $b82122a7f3a0fd21$var$getDescriptor = $a934004253d25a42$exports && Object.getOwnPropertyDescriptor;
var $b82122a7f3a0fd21$var$EXISTS = $9fd86a02d78d2d99$exports($b82122a7f3a0fd21$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $b82122a7f3a0fd21$var$PROPER = $b82122a7f3a0fd21$var$EXISTS && (function something() {}).name === "something";
var $b82122a7f3a0fd21$var$CONFIGURABLE = $b82122a7f3a0fd21$var$EXISTS && (!$a934004253d25a42$exports || $a934004253d25a42$exports && $b82122a7f3a0fd21$var$getDescriptor($b82122a7f3a0fd21$var$FunctionPrototype, "name").configurable);
$b82122a7f3a0fd21$exports = {
    EXISTS: $b82122a7f3a0fd21$var$EXISTS,
    PROPER: $b82122a7f3a0fd21$var$PROPER,
    CONFIGURABLE: $b82122a7f3a0fd21$var$CONFIGURABLE
};


var $157fbe5a4073e8a8$require$CONFIGURABLE_FUNCTION_NAME = $b82122a7f3a0fd21$exports.CONFIGURABLE;
var $33a7bcb147d04741$exports = {};
"use strict";



var $33a7bcb147d04741$var$functionToString = $86d27fcf3ddb374a$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$da9965769ab8d492$exports($b1111eb01f23fc98$exports.inspectSource)) $b1111eb01f23fc98$exports.inspectSource = function(it) {
    return $33a7bcb147d04741$var$functionToString(it);
};
$33a7bcb147d04741$exports = $b1111eb01f23fc98$exports.inspectSource;


var $033d4cca21ca5361$exports = {};
"use strict";
var $d5d26662890f9fd9$exports = {};
"use strict";


var $d5d26662890f9fd9$var$WeakMap = $818e316f8a39904d$exports.WeakMap;
$d5d26662890f9fd9$exports = $da9965769ab8d492$exports($d5d26662890f9fd9$var$WeakMap) && /native code/.test(String($d5d26662890f9fd9$var$WeakMap));







var $8bce327c7c566c42$exports = {};
"use strict";


var $8bce327c7c566c42$var$keys = $9b42448d053bd3c4$exports("keys");
$8bce327c7c566c42$exports = function(key) {
    return $8bce327c7c566c42$var$keys[key] || ($8bce327c7c566c42$var$keys[key] = $2e904edd887c2aab$exports(key));
};


var $c134b99a007ffe97$exports = {};
"use strict";
$c134b99a007ffe97$exports = {};


var $033d4cca21ca5361$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $033d4cca21ca5361$var$TypeError = $818e316f8a39904d$exports.TypeError;
var $033d4cca21ca5361$var$WeakMap = $818e316f8a39904d$exports.WeakMap;
var $033d4cca21ca5361$var$set, $033d4cca21ca5361$var$get, $033d4cca21ca5361$var$has;
var $033d4cca21ca5361$var$enforce = function(it) {
    return $033d4cca21ca5361$var$has(it) ? $033d4cca21ca5361$var$get(it) : $033d4cca21ca5361$var$set(it, {});
};
var $033d4cca21ca5361$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$abc01766c6ffc0a1$exports(it) || (state = $033d4cca21ca5361$var$get(it)).type !== TYPE) throw new $033d4cca21ca5361$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($d5d26662890f9fd9$exports || $b1111eb01f23fc98$exports.state) {
    var $033d4cca21ca5361$var$store = $b1111eb01f23fc98$exports.state || ($b1111eb01f23fc98$exports.state = new $033d4cca21ca5361$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $033d4cca21ca5361$var$store.get = $033d4cca21ca5361$var$store.get;
    $033d4cca21ca5361$var$store.has = $033d4cca21ca5361$var$store.has;
    $033d4cca21ca5361$var$store.set = $033d4cca21ca5361$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $033d4cca21ca5361$var$set = function(it, metadata) {
        if ($033d4cca21ca5361$var$store.has(it)) throw new $033d4cca21ca5361$var$TypeError($033d4cca21ca5361$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $033d4cca21ca5361$var$store.set(it, metadata);
        return metadata;
    };
    $033d4cca21ca5361$var$get = function(it) {
        return $033d4cca21ca5361$var$store.get(it) || {};
    };
    $033d4cca21ca5361$var$has = function(it) {
        return $033d4cca21ca5361$var$store.has(it);
    };
} else {
    var $033d4cca21ca5361$var$STATE = $8bce327c7c566c42$exports("state");
    $c134b99a007ffe97$exports[$033d4cca21ca5361$var$STATE] = true;
    $033d4cca21ca5361$var$set = function(it, metadata) {
        if ($9fd86a02d78d2d99$exports(it, $033d4cca21ca5361$var$STATE)) throw new $033d4cca21ca5361$var$TypeError($033d4cca21ca5361$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $3d5a463be44ffeea$exports(it, $033d4cca21ca5361$var$STATE, metadata);
        return metadata;
    };
    $033d4cca21ca5361$var$get = function(it) {
        return $9fd86a02d78d2d99$exports(it, $033d4cca21ca5361$var$STATE) ? it[$033d4cca21ca5361$var$STATE] : {};
    };
    $033d4cca21ca5361$var$has = function(it) {
        return $9fd86a02d78d2d99$exports(it, $033d4cca21ca5361$var$STATE);
    };
}
$033d4cca21ca5361$exports = {
    set: $033d4cca21ca5361$var$set,
    get: $033d4cca21ca5361$var$get,
    has: $033d4cca21ca5361$var$has,
    enforce: $033d4cca21ca5361$var$enforce,
    getterFor: $033d4cca21ca5361$var$getterFor
};


var $157fbe5a4073e8a8$var$enforceInternalState = $033d4cca21ca5361$exports.enforce;
var $157fbe5a4073e8a8$var$getInternalState = $033d4cca21ca5361$exports.get;
var $157fbe5a4073e8a8$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $157fbe5a4073e8a8$var$defineProperty = Object.defineProperty;
var $157fbe5a4073e8a8$var$stringSlice = $86d27fcf3ddb374a$exports("".slice);
var $157fbe5a4073e8a8$var$replace = $86d27fcf3ddb374a$exports("".replace);
var $157fbe5a4073e8a8$var$join = $86d27fcf3ddb374a$exports([].join);
var $157fbe5a4073e8a8$var$CONFIGURABLE_LENGTH = $a934004253d25a42$exports && !$1c0f139a1a463ce1$exports(function() {
    return $157fbe5a4073e8a8$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $157fbe5a4073e8a8$var$TEMPLATE = String(String).split("String");
var $157fbe5a4073e8a8$var$makeBuiltIn = $157fbe5a4073e8a8$exports = function(value, name, options) {
    if ($157fbe5a4073e8a8$var$stringSlice($157fbe5a4073e8a8$var$$String(name), 0, 7) === "Symbol(") name = "[" + $157fbe5a4073e8a8$var$replace($157fbe5a4073e8a8$var$$String(name), /^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$9fd86a02d78d2d99$exports(value, "name") || $157fbe5a4073e8a8$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($a934004253d25a42$exports) $157fbe5a4073e8a8$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($157fbe5a4073e8a8$var$CONFIGURABLE_LENGTH && options && $9fd86a02d78d2d99$exports(options, "arity") && value.length !== options.arity) $157fbe5a4073e8a8$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $9fd86a02d78d2d99$exports(options, "constructor") && options.constructor) {
            if ($a934004253d25a42$exports) $157fbe5a4073e8a8$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $157fbe5a4073e8a8$var$enforceInternalState(value);
    if (!$9fd86a02d78d2d99$exports(state, "source")) state.source = $157fbe5a4073e8a8$var$join($157fbe5a4073e8a8$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $157fbe5a4073e8a8$var$makeBuiltIn(function toString() {
    return $da9965769ab8d492$exports(this) && $157fbe5a4073e8a8$var$getInternalState(this).source || $33a7bcb147d04741$exports(this);
}, "toString");



$cc8a5761541cd35d$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($da9965769ab8d492$exports(value)) $157fbe5a4073e8a8$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $85363e39cdbcb0f8$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $96bd28438ee2eee5$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $ea8d859a0429cd4d$exports = {};
"use strict";

var $e6692f8ed69dfc75$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $f160027a9f5364b6$export$2d1720544b23b823;
"use strict";
var $9b74ee65fcf3f4aa$exports = {};
"use strict";



var $2d3f31e9ada712f4$exports = {};
"use strict";

var $03a189a753198cb5$exports = {};
"use strict";
var $8abe88bfd140bd58$exports = {};
"use strict";
var $2d58632983b0e2dc$exports = {};
"use strict";
var $2d58632983b0e2dc$var$ceil = Math.ceil;
var $2d58632983b0e2dc$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$2d58632983b0e2dc$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $2d58632983b0e2dc$var$floor : $2d58632983b0e2dc$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$8abe88bfd140bd58$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $2d58632983b0e2dc$exports(number);
};


var $03a189a753198cb5$var$max = Math.max;
var $03a189a753198cb5$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$03a189a753198cb5$exports = function(index, length) {
    var integer = $8abe88bfd140bd58$exports(index);
    return integer < 0 ? $03a189a753198cb5$var$max(integer + length, 0) : $03a189a753198cb5$var$min(integer, length);
};


var $86912fee58c01fd8$exports = {};
"use strict";
var $d6e59aaba77a5f67$exports = {};
"use strict";

var $d6e59aaba77a5f67$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$d6e59aaba77a5f67$exports = function(argument) {
    return argument > 0 ? $d6e59aaba77a5f67$var$min($8abe88bfd140bd58$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$86912fee58c01fd8$exports = function(obj) {
    return $d6e59aaba77a5f67$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $2d3f31e9ada712f4$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $08ccc8de002b7975$exports($this);
        var length = $86912fee58c01fd8$exports(O);
        var index = $03a189a753198cb5$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$2d3f31e9ada712f4$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $2d3f31e9ada712f4$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $2d3f31e9ada712f4$var$createMethod(false)
};


var $9b74ee65fcf3f4aa$require$indexOf = $2d3f31e9ada712f4$exports.indexOf;

var $9b74ee65fcf3f4aa$var$push = $86d27fcf3ddb374a$exports([].push);
$9b74ee65fcf3f4aa$exports = function(object, names) {
    var O = $08ccc8de002b7975$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$9fd86a02d78d2d99$exports($c134b99a007ffe97$exports, key) && $9fd86a02d78d2d99$exports(O, key) && $9b74ee65fcf3f4aa$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($9fd86a02d78d2d99$exports(O, key = names[i++])) ~$9b74ee65fcf3f4aa$require$indexOf(result, key) || $9b74ee65fcf3f4aa$var$push(result, key);
    return result;
};


var $af891a628637cbe1$exports = {};
"use strict";
// IE8- don't enum bug keys
$af891a628637cbe1$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $f160027a9f5364b6$var$hiddenKeys = $af891a628637cbe1$exports.concat("length", "prototype");
$f160027a9f5364b6$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $9b74ee65fcf3f4aa$exports(O, $f160027a9f5364b6$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $a58edbe542a39e4c$export$2d1720544b23b823;
"use strict";
$a58edbe542a39e4c$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $e6692f8ed69dfc75$var$concat = $86d27fcf3ddb374a$exports([].concat);
// all object keys, includes non-enumerable and symbols
$e6692f8ed69dfc75$exports = $18c5ef8b38a03108$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $f160027a9f5364b6$export$2d1720544b23b823($c53804bbcc663539$exports(it));
    var getOwnPropertySymbols = $a58edbe542a39e4c$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $e6692f8ed69dfc75$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$ea8d859a0429cd4d$exports = function(target, source, exceptions) {
    var keys = $e6692f8ed69dfc75$exports(source);
    var defineProperty = $96bd28438ee2eee5$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $5dee88fe230545da$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$9fd86a02d78d2d99$exports(target, key) && !(exceptions && $9fd86a02d78d2d99$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $32073ab696b14d8d$exports = {};
"use strict";


var $32073ab696b14d8d$var$replacement = /#|\.prototype\./;
var $32073ab696b14d8d$var$isForced = function(feature, detection) {
    var value = $32073ab696b14d8d$var$data[$32073ab696b14d8d$var$normalize(feature)];
    return value === $32073ab696b14d8d$var$POLYFILL ? true : value === $32073ab696b14d8d$var$NATIVE ? false : $da9965769ab8d492$exports(detection) ? $1c0f139a1a463ce1$exports(detection) : !!detection;
};
var $32073ab696b14d8d$var$normalize = $32073ab696b14d8d$var$isForced.normalize = function(string) {
    return String(string).replace($32073ab696b14d8d$var$replacement, ".").toLowerCase();
};
var $32073ab696b14d8d$var$data = $32073ab696b14d8d$var$isForced.data = {};
var $32073ab696b14d8d$var$NATIVE = $32073ab696b14d8d$var$isForced.NATIVE = "N";
var $32073ab696b14d8d$var$POLYFILL = $32073ab696b14d8d$var$isForced.POLYFILL = "P";
$32073ab696b14d8d$exports = $32073ab696b14d8d$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $621e6bc7a2f56e42$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $818e316f8a39904d$exports;
    else if (STATIC) target = $818e316f8a39904d$exports[TARGET] || $85363e39cdbcb0f8$exports(TARGET, {});
    else target = ($818e316f8a39904d$exports[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $621e6bc7a2f56e42$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $32073ab696b14d8d$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $ea8d859a0429cd4d$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $3d5a463be44ffeea$exports(sourceProperty, "sham", true);
        $cc8a5761541cd35d$exports(target, key, sourceProperty, options);
    }
};


var $d0c673959784318b$exports = {};
"use strict";



var $0f08e96df1c6e400$exports = {};
"use strict";
var $28938e7b08ad8d2f$exports = {};
"use strict";
var $0cd6fb43abc87faf$exports = {};
"use strict";

var $0cd6fb43abc87faf$var$TO_STRING_TAG = $06b7b285e3a7068a$exports("toStringTag");
var $0cd6fb43abc87faf$var$test = {};
$0cd6fb43abc87faf$var$test[$0cd6fb43abc87faf$var$TO_STRING_TAG] = "z";
$0cd6fb43abc87faf$exports = String($0cd6fb43abc87faf$var$test) === "[object z]";





var $28938e7b08ad8d2f$var$TO_STRING_TAG = $06b7b285e3a7068a$exports("toStringTag");
var $28938e7b08ad8d2f$var$$Object = Object;
// ES3 wrong here
var $28938e7b08ad8d2f$var$CORRECT_ARGUMENTS = $f65b6a6904086b61$exports(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var $28938e7b08ad8d2f$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$28938e7b08ad8d2f$exports = $0cd6fb43abc87faf$exports ? $f65b6a6904086b61$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $28938e7b08ad8d2f$var$tryGet(O = $28938e7b08ad8d2f$var$$Object(it), $28938e7b08ad8d2f$var$TO_STRING_TAG)) == "string" ? tag : $28938e7b08ad8d2f$var$CORRECT_ARGUMENTS ? $f65b6a6904086b61$exports(O) : (result = $f65b6a6904086b61$exports(O)) === "Object" && $da9965769ab8d492$exports(O.callee) ? "Arguments" : result;
};


var $0f08e96df1c6e400$var$$String = String;
$0f08e96df1c6e400$exports = function(argument) {
    if ($28938e7b08ad8d2f$exports(argument) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return $0f08e96df1c6e400$var$$String(argument);
};


var $3fbb288b6dc9417e$exports = {};
"use strict";



var $36f5638d99a5ed32$exports = {};
"use strict";
// a string of all valid unicode whitespaces
$36f5638d99a5ed32$exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";


var $3fbb288b6dc9417e$var$replace = $86d27fcf3ddb374a$exports("".replace);
var $3fbb288b6dc9417e$var$ltrim = RegExp("^[" + $36f5638d99a5ed32$exports + "]+");
var $3fbb288b6dc9417e$var$rtrim = RegExp("(^|[^" + $36f5638d99a5ed32$exports + "])[" + $36f5638d99a5ed32$exports + "]+$");
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $3fbb288b6dc9417e$var$createMethod = function(TYPE) {
    return function($this) {
        var string = $0f08e96df1c6e400$exports($ce17aed0e5032df3$exports($this));
        if (TYPE & 1) string = $3fbb288b6dc9417e$var$replace(string, $3fbb288b6dc9417e$var$ltrim, "");
        if (TYPE & 2) string = $3fbb288b6dc9417e$var$replace(string, $3fbb288b6dc9417e$var$rtrim, "$1");
        return string;
    };
};
$3fbb288b6dc9417e$exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $3fbb288b6dc9417e$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $3fbb288b6dc9417e$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $3fbb288b6dc9417e$var$createMethod(3)
};


var $d0c673959784318b$require$trim = $3fbb288b6dc9417e$exports.trim;

var $d0c673959784318b$var$$parseInt = $818e316f8a39904d$exports.parseInt;
var $d0c673959784318b$var$Symbol = $818e316f8a39904d$exports.Symbol;
var $d0c673959784318b$var$ITERATOR = $d0c673959784318b$var$Symbol && $d0c673959784318b$var$Symbol.iterator;
var $d0c673959784318b$var$hex = /^[+-]?0x/i;
var $d0c673959784318b$var$exec = $86d27fcf3ddb374a$exports($d0c673959784318b$var$hex.exec);
var $d0c673959784318b$var$FORCED = $d0c673959784318b$var$$parseInt($36f5638d99a5ed32$exports + "08") !== 8 || $d0c673959784318b$var$$parseInt($36f5638d99a5ed32$exports + "0x16") !== 22 || $d0c673959784318b$var$ITERATOR && !$1c0f139a1a463ce1$exports(function() {
    $d0c673959784318b$var$$parseInt(Object($d0c673959784318b$var$ITERATOR));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$d0c673959784318b$exports = $d0c673959784318b$var$FORCED ? function parseInt(string, radix) {
    var S = $d0c673959784318b$require$trim($0f08e96df1c6e400$exports(string));
    return $d0c673959784318b$var$$parseInt(S, radix >>> 0 || ($d0c673959784318b$var$exec($d0c673959784318b$var$hex, S) ? 16 : 10));
} : $d0c673959784318b$var$$parseInt;


// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$621e6bc7a2f56e42$exports({
    global: true,
    forced: parseInt !== $d0c673959784318b$exports
}, {
    parseInt: $d0c673959784318b$exports
});


"use strict";

var $4f76b280750aac79$exports = {};
"use strict";




var $b70a4de23bb82696$exports = {};
"use strict";


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$b70a4de23bb82696$exports = Object.keys || function keys(O) {
    return $9b74ee65fcf3f4aa$exports(O, $af891a628637cbe1$exports);
};






// eslint-disable-next-line es/no-object-assign -- safe
var $4f76b280750aac79$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $4f76b280750aac79$var$defineProperty = Object.defineProperty;
var $4f76b280750aac79$var$concat = $86d27fcf3ddb374a$exports([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
$4f76b280750aac79$exports = !$4f76b280750aac79$var$$assign || $1c0f139a1a463ce1$exports(function() {
    // should have correct order of operations (Edge bug)
    if ($a934004253d25a42$exports && $4f76b280750aac79$var$$assign({
        b: 1
    }, $4f76b280750aac79$var$$assign($4f76b280750aac79$var$defineProperty({}, "a", {
        enumerable: true,
        get: function() {
            $4f76b280750aac79$var$defineProperty(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol("assign detection");
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $4f76b280750aac79$var$$assign({}, A)[symbol] !== 7 || $b70a4de23bb82696$exports($4f76b280750aac79$var$$assign({}, B)).join("") !== alphabet;
}) ? function assign(target, source) {
    var T = $c9b4f3ef4a96c778$exports(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $a58edbe542a39e4c$export$2d1720544b23b823;
    var propertyIsEnumerable = $37435e8ffd2f28b9$export$2d1720544b23b823;
    while(argumentsLength > index){
        var S = $9d1a1577a6ed79d1$exports(arguments[index++]);
        var keys = getOwnPropertySymbols ? $4f76b280750aac79$var$concat($b70a4de23bb82696$exports(S), getOwnPropertySymbols(S)) : $b70a4de23bb82696$exports(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$a934004253d25a42$exports || $ba3e81ca5de34305$exports(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $4f76b280750aac79$var$$assign;


// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$621e6bc7a2f56e42$exports({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $4f76b280750aac79$exports
}, {
    assign: $4f76b280750aac79$exports
});


"use strict";

var $bec34a0e29a6ea95$exports = {};
"use strict";
var $e702529819d2fe6f$exports = {};
"use strict";
var $c0f7cba2112dcc1e$exports = {};
"use strict";


$c0f7cba2112dcc1e$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($f65b6a6904086b61$exports(fn) === "Function") return $86d27fcf3ddb374a$exports(fn);
};




var $e702529819d2fe6f$var$bind = $c0f7cba2112dcc1e$exports($c0f7cba2112dcc1e$exports.bind);
// optional / simple context binding
$e702529819d2fe6f$exports = function(fn, that) {
    $a339c863cff407d1$exports(fn);
    return that === undefined ? fn : $13cf557f31fcb3db$exports ? $e702529819d2fe6f$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};






var $4c23e7d9602bf3b9$exports = {};
"use strict";
var $d22419573b71a9b5$exports = {};
"use strict";
var $9bfde3ac2a1c2ebe$exports = {};
"use strict";

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
$9bfde3ac2a1c2ebe$exports = Array.isArray || function isArray(argument) {
    return $f65b6a6904086b61$exports(argument) === "Array";
};


var $fe31ea0376f692ac$exports = {};
"use strict";






var $fe31ea0376f692ac$var$noop = function() {};
var $fe31ea0376f692ac$var$empty = [];
var $fe31ea0376f692ac$var$construct = $18c5ef8b38a03108$exports("Reflect", "construct");
var $fe31ea0376f692ac$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $fe31ea0376f692ac$var$exec = $86d27fcf3ddb374a$exports($fe31ea0376f692ac$var$constructorRegExp.exec);
var $fe31ea0376f692ac$var$INCORRECT_TO_STRING = !$fe31ea0376f692ac$var$constructorRegExp.test($fe31ea0376f692ac$var$noop);
var $fe31ea0376f692ac$var$isConstructorModern = function isConstructor(argument) {
    if (!$da9965769ab8d492$exports(argument)) return false;
    try {
        $fe31ea0376f692ac$var$construct($fe31ea0376f692ac$var$noop, $fe31ea0376f692ac$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $fe31ea0376f692ac$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$da9965769ab8d492$exports(argument)) return false;
    switch($28938e7b08ad8d2f$exports(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $fe31ea0376f692ac$var$INCORRECT_TO_STRING || !!$fe31ea0376f692ac$var$exec($fe31ea0376f692ac$var$constructorRegExp, $33a7bcb147d04741$exports(argument));
    } catch (error) {
        return true;
    }
};
$fe31ea0376f692ac$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$fe31ea0376f692ac$exports = !$fe31ea0376f692ac$var$construct || $1c0f139a1a463ce1$exports(function() {
    var called;
    return $fe31ea0376f692ac$var$isConstructorModern($fe31ea0376f692ac$var$isConstructorModern.call) || !$fe31ea0376f692ac$var$isConstructorModern(Object) || !$fe31ea0376f692ac$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $fe31ea0376f692ac$var$isConstructorLegacy : $fe31ea0376f692ac$var$isConstructorModern;




var $d22419573b71a9b5$var$SPECIES = $06b7b285e3a7068a$exports("species");
var $d22419573b71a9b5$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$d22419573b71a9b5$exports = function(originalArray) {
    var C;
    if ($9bfde3ac2a1c2ebe$exports(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($fe31ea0376f692ac$exports(C) && (C === $d22419573b71a9b5$var$$Array || $9bfde3ac2a1c2ebe$exports(C.prototype))) C = undefined;
        else if ($abc01766c6ffc0a1$exports(C)) {
            C = C[$d22419573b71a9b5$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $d22419573b71a9b5$var$$Array : C;
};


// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$4c23e7d9602bf3b9$exports = function(originalArray, length) {
    return new ($d22419573b71a9b5$exports(originalArray))(length === 0 ? 0 : length);
};


var $bec34a0e29a6ea95$var$push = $86d27fcf3ddb374a$exports([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $bec34a0e29a6ea95$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $c9b4f3ef4a96c778$exports($this);
        var self = $9d1a1577a6ed79d1$exports(O);
        var length = $86912fee58c01fd8$exports(self);
        var boundFunction = $e702529819d2fe6f$exports(callbackfn, that);
        var index = 0;
        var create = specificCreate || $4c23e7d9602bf3b9$exports;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $bec34a0e29a6ea95$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $bec34a0e29a6ea95$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
$bec34a0e29a6ea95$exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $bec34a0e29a6ea95$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $bec34a0e29a6ea95$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $bec34a0e29a6ea95$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $bec34a0e29a6ea95$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $bec34a0e29a6ea95$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $bec34a0e29a6ea95$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $bec34a0e29a6ea95$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $bec34a0e29a6ea95$var$createMethod(7)
};


var $a9e8817e1c9ddd72$require$$filter = $bec34a0e29a6ea95$exports.filter;
var $ae48b81f8a6445c9$exports = {};
"use strict";



var $ae48b81f8a6445c9$var$SPECIES = $06b7b285e3a7068a$exports("species");
$ae48b81f8a6445c9$exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $e5ab0d050bcf2c0f$exports >= 51 || !$1c0f139a1a463ce1$exports(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$ae48b81f8a6445c9$var$SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};


var $a9e8817e1c9ddd72$var$HAS_SPECIES_SUPPORT = $ae48b81f8a6445c9$exports("filter");
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$621e6bc7a2f56e42$exports({
    target: "Array",
    proto: true,
    forced: !$a9e8817e1c9ddd72$var$HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $a9e8817e1c9ddd72$require$$filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});


"use strict";


var $f2c024c47d1aba50$exports = {};
"use strict";


// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
$f2c024c47d1aba50$exports = $0cd6fb43abc87faf$exports ? ({}).toString : function toString() {
    return "[object " + $28938e7b08ad8d2f$exports(this) + "]";
};


// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!$0cd6fb43abc87faf$exports) $cc8a5761541cd35d$exports(Object.prototype, "toString", $f2c024c47d1aba50$exports, {
    unsafe: true
});


var $121e9cdb73c6da98$exports = {};
"use strict";

var $374bab7f556b652b$exports = {};
"use strict";

var $ee4937dd0bdfcee6$exports = {};
"use strict";

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $68b6a7cfb9f3eb01$export$2d1720544b23b823;
"use strict";






$68b6a7cfb9f3eb01$export$2d1720544b23b823 = $a934004253d25a42$exports && !$99f023d30bb6ec12$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $c53804bbcc663539$exports(O);
    var props = $08ccc8de002b7975$exports(Properties);
    var keys = $b70a4de23bb82696$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$96bd28438ee2eee5$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $2892e8717adda2e1$exports = {};
"use strict";

$2892e8717adda2e1$exports = $18c5ef8b38a03108$exports("document", "documentElement");




var $ee4937dd0bdfcee6$var$GT = ">";
var $ee4937dd0bdfcee6$var$LT = "<";
var $ee4937dd0bdfcee6$var$PROTOTYPE = "prototype";
var $ee4937dd0bdfcee6$var$SCRIPT = "script";
var $ee4937dd0bdfcee6$var$IE_PROTO = $8bce327c7c566c42$exports("IE_PROTO");
var $ee4937dd0bdfcee6$var$EmptyConstructor = function() {};
var $ee4937dd0bdfcee6$var$scriptTag = function(content) {
    return $ee4937dd0bdfcee6$var$LT + $ee4937dd0bdfcee6$var$SCRIPT + $ee4937dd0bdfcee6$var$GT + content + $ee4937dd0bdfcee6$var$LT + "/" + $ee4937dd0bdfcee6$var$SCRIPT + $ee4937dd0bdfcee6$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $ee4937dd0bdfcee6$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($ee4937dd0bdfcee6$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $ee4937dd0bdfcee6$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $6a21b3c3b047179b$exports("iframe");
    var JS = "java" + $ee4937dd0bdfcee6$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $2892e8717adda2e1$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($ee4937dd0bdfcee6$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $ee4937dd0bdfcee6$var$activeXDocument;
var $ee4937dd0bdfcee6$var$NullProtoObject = function() {
    try {
        $ee4937dd0bdfcee6$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $ee4937dd0bdfcee6$var$NullProtoObject = typeof document != "undefined" ? document.domain && $ee4937dd0bdfcee6$var$activeXDocument ? $ee4937dd0bdfcee6$var$NullProtoObjectViaActiveX($ee4937dd0bdfcee6$var$activeXDocument) // old IE
     : $ee4937dd0bdfcee6$var$NullProtoObjectViaIFrame() : $ee4937dd0bdfcee6$var$NullProtoObjectViaActiveX($ee4937dd0bdfcee6$var$activeXDocument); // WSH
    var length = $af891a628637cbe1$exports.length;
    while(length--)delete $ee4937dd0bdfcee6$var$NullProtoObject[$ee4937dd0bdfcee6$var$PROTOTYPE][$af891a628637cbe1$exports[length]];
    return $ee4937dd0bdfcee6$var$NullProtoObject();
};
$c134b99a007ffe97$exports[$ee4937dd0bdfcee6$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$ee4937dd0bdfcee6$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $ee4937dd0bdfcee6$var$EmptyConstructor[$ee4937dd0bdfcee6$var$PROTOTYPE] = $c53804bbcc663539$exports(O);
        result = new $ee4937dd0bdfcee6$var$EmptyConstructor();
        $ee4937dd0bdfcee6$var$EmptyConstructor[$ee4937dd0bdfcee6$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$ee4937dd0bdfcee6$var$IE_PROTO] = O;
    } else result = $ee4937dd0bdfcee6$var$NullProtoObject();
    return Properties === undefined ? result : $68b6a7cfb9f3eb01$export$2d1720544b23b823(result, Properties);
};



var $374bab7f556b652b$require$defineProperty = $96bd28438ee2eee5$export$2d1720544b23b823;
var $374bab7f556b652b$var$UNSCOPABLES = $06b7b285e3a7068a$exports("unscopables");
var $374bab7f556b652b$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($374bab7f556b652b$var$ArrayPrototype[$374bab7f556b652b$var$UNSCOPABLES] === undefined) $374bab7f556b652b$require$defineProperty($374bab7f556b652b$var$ArrayPrototype, $374bab7f556b652b$var$UNSCOPABLES, {
    configurable: true,
    value: $ee4937dd0bdfcee6$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$374bab7f556b652b$exports = function(key) {
    $374bab7f556b652b$var$ArrayPrototype[$374bab7f556b652b$var$UNSCOPABLES][key] = true;
};


var $898708d156ba5812$exports = {};
"use strict";
$898708d156ba5812$exports = {};




var $121e9cdb73c6da98$require$defineProperty = $96bd28438ee2eee5$export$2d1720544b23b823;
var $ad4a3702b8819b30$exports = {};
"use strict";





var $ffcc0f6e93e42ad7$exports = {};
"use strict";
var $a763eda09a06e511$exports = {};
"use strict";




var $5e684cfc91407f82$exports = {};
"use strict";




var $e74801456a5e63d3$exports = {};
"use strict";

$e74801456a5e63d3$exports = !$1c0f139a1a463ce1$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $5e684cfc91407f82$var$IE_PROTO = $8bce327c7c566c42$exports("IE_PROTO");
var $5e684cfc91407f82$var$$Object = Object;
var $5e684cfc91407f82$var$ObjectPrototype = $5e684cfc91407f82$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$5e684cfc91407f82$exports = $e74801456a5e63d3$exports ? $5e684cfc91407f82$var$$Object.getPrototypeOf : function(O) {
    var object = $c9b4f3ef4a96c778$exports(O);
    if ($9fd86a02d78d2d99$exports(object, $5e684cfc91407f82$var$IE_PROTO)) return object[$5e684cfc91407f82$var$IE_PROTO];
    var constructor = object.constructor;
    if ($da9965769ab8d492$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $5e684cfc91407f82$var$$Object ? $5e684cfc91407f82$var$ObjectPrototype : null;
};





var $a763eda09a06e511$var$ITERATOR = $06b7b285e3a7068a$exports("iterator");
var $a763eda09a06e511$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $a763eda09a06e511$var$IteratorPrototype, $a763eda09a06e511$var$PrototypeOfArrayIteratorPrototype, $a763eda09a06e511$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $a763eda09a06e511$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $a763eda09a06e511$var$arrayIterator)) $a763eda09a06e511$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $a763eda09a06e511$var$PrototypeOfArrayIteratorPrototype = $5e684cfc91407f82$exports($5e684cfc91407f82$exports($a763eda09a06e511$var$arrayIterator));
        if ($a763eda09a06e511$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $a763eda09a06e511$var$IteratorPrototype = $a763eda09a06e511$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $a763eda09a06e511$var$NEW_ITERATOR_PROTOTYPE = !$abc01766c6ffc0a1$exports($a763eda09a06e511$var$IteratorPrototype) || $1c0f139a1a463ce1$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $a763eda09a06e511$var$IteratorPrototype[$a763eda09a06e511$var$ITERATOR].call(test) !== test;
});
if ($a763eda09a06e511$var$NEW_ITERATOR_PROTOTYPE) $a763eda09a06e511$var$IteratorPrototype = {};
else if ($8a834a2771c3d77e$exports) $a763eda09a06e511$var$IteratorPrototype = $ee4937dd0bdfcee6$exports($a763eda09a06e511$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$da9965769ab8d492$exports($a763eda09a06e511$var$IteratorPrototype[$a763eda09a06e511$var$ITERATOR])) $cc8a5761541cd35d$exports($a763eda09a06e511$var$IteratorPrototype, $a763eda09a06e511$var$ITERATOR, function() {
    return this;
});
$a763eda09a06e511$exports = {
    IteratorPrototype: $a763eda09a06e511$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $a763eda09a06e511$var$BUGGY_SAFARI_ITERATORS
};


var $ffcc0f6e93e42ad7$require$IteratorPrototype = $a763eda09a06e511$exports.IteratorPrototype;


var $8f25367a6f31c129$exports = {};
"use strict";

var $8f25367a6f31c129$require$defineProperty = $96bd28438ee2eee5$export$2d1720544b23b823;


var $8f25367a6f31c129$var$TO_STRING_TAG = $06b7b285e3a7068a$exports("toStringTag");
$8f25367a6f31c129$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$9fd86a02d78d2d99$exports(target, $8f25367a6f31c129$var$TO_STRING_TAG)) $8f25367a6f31c129$require$defineProperty(target, $8f25367a6f31c129$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};



var $ffcc0f6e93e42ad7$var$returnThis = function() {
    return this;
};
$ffcc0f6e93e42ad7$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $ee4937dd0bdfcee6$exports($ffcc0f6e93e42ad7$require$IteratorPrototype, {
        next: $7f001fc6b2d5740c$exports(+!ENUMERABLE_NEXT, next)
    });
    $8f25367a6f31c129$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $898708d156ba5812$exports[TO_STRING_TAG] = $ffcc0f6e93e42ad7$var$returnThis;
    return IteratorConstructor;
};



var $e667f1deebc629ea$exports = {};
"use strict";
var $f14cf30eaeb0d4f0$exports = {};
"use strict";


$f14cf30eaeb0d4f0$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $86d27fcf3ddb374a$exports($a339c863cff407d1$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};



var $bbeac7cd1e985d4e$exports = {};
"use strict";
var $653d18f0057902f3$exports = {};
"use strict";

$653d18f0057902f3$exports = function(argument) {
    return $abc01766c6ffc0a1$exports(argument) || argument === null;
};


var $bbeac7cd1e985d4e$var$$String = String;
var $bbeac7cd1e985d4e$var$$TypeError = TypeError;
$bbeac7cd1e985d4e$exports = function(argument) {
    if ($653d18f0057902f3$exports(argument)) return argument;
    throw new $bbeac7cd1e985d4e$var$$TypeError("Can't set " + $bbeac7cd1e985d4e$var$$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$e667f1deebc629ea$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $f14cf30eaeb0d4f0$exports(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $c53804bbcc663539$exports(O);
        $bbeac7cd1e985d4e$exports(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);








var $ad4a3702b8819b30$var$PROPER_FUNCTION_NAME = $b82122a7f3a0fd21$exports.PROPER;
var $ad4a3702b8819b30$var$CONFIGURABLE_FUNCTION_NAME = $b82122a7f3a0fd21$exports.CONFIGURABLE;
var $ad4a3702b8819b30$var$IteratorPrototype = $a763eda09a06e511$exports.IteratorPrototype;
var $ad4a3702b8819b30$var$BUGGY_SAFARI_ITERATORS = $a763eda09a06e511$exports.BUGGY_SAFARI_ITERATORS;
var $ad4a3702b8819b30$var$ITERATOR = $06b7b285e3a7068a$exports("iterator");
var $ad4a3702b8819b30$var$KEYS = "keys";
var $ad4a3702b8819b30$var$VALUES = "values";
var $ad4a3702b8819b30$var$ENTRIES = "entries";
var $ad4a3702b8819b30$var$returnThis = function() {
    return this;
};
$ad4a3702b8819b30$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $ffcc0f6e93e42ad7$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$ad4a3702b8819b30$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $ad4a3702b8819b30$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $ad4a3702b8819b30$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $ad4a3702b8819b30$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$ad4a3702b8819b30$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$ad4a3702b8819b30$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $5e684cfc91407f82$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$8a834a2771c3d77e$exports && $5e684cfc91407f82$exports(CurrentIteratorPrototype) !== $ad4a3702b8819b30$var$IteratorPrototype) {
                if ($e667f1deebc629ea$exports) $e667f1deebc629ea$exports(CurrentIteratorPrototype, $ad4a3702b8819b30$var$IteratorPrototype);
                else if (!$da9965769ab8d492$exports(CurrentIteratorPrototype[$ad4a3702b8819b30$var$ITERATOR])) $cc8a5761541cd35d$exports(CurrentIteratorPrototype, $ad4a3702b8819b30$var$ITERATOR, $ad4a3702b8819b30$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $8f25367a6f31c129$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($8a834a2771c3d77e$exports) $898708d156ba5812$exports[TO_STRING_TAG] = $ad4a3702b8819b30$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($ad4a3702b8819b30$var$PROPER_FUNCTION_NAME && DEFAULT === $ad4a3702b8819b30$var$VALUES && nativeIterator && nativeIterator.name !== $ad4a3702b8819b30$var$VALUES) {
        if (!$8a834a2771c3d77e$exports && $ad4a3702b8819b30$var$CONFIGURABLE_FUNCTION_NAME) $3d5a463be44ffeea$exports(IterablePrototype, "name", $ad4a3702b8819b30$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $ba3e81ca5de34305$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($ad4a3702b8819b30$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($ad4a3702b8819b30$var$KEYS),
            entries: getIterationMethod($ad4a3702b8819b30$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($ad4a3702b8819b30$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $cc8a5761541cd35d$exports(IterablePrototype, KEY, methods[KEY]);
        } else $621e6bc7a2f56e42$exports({
            target: NAME,
            proto: true,
            forced: $ad4a3702b8819b30$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$8a834a2771c3d77e$exports || FORCED) && IterablePrototype[$ad4a3702b8819b30$var$ITERATOR] !== defaultIterator) $cc8a5761541cd35d$exports(IterablePrototype, $ad4a3702b8819b30$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $898708d156ba5812$exports[NAME] = defaultIterator;
    return methods;
};


var $f38e0f43c1e0dbb1$exports = {};
"use strict";
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$f38e0f43c1e0dbb1$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};




var $121e9cdb73c6da98$var$ARRAY_ITERATOR = "Array Iterator";
var $121e9cdb73c6da98$var$setInternalState = $033d4cca21ca5361$exports.set;
var $121e9cdb73c6da98$var$getInternalState = $033d4cca21ca5361$exports.getterFor($121e9cdb73c6da98$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$121e9cdb73c6da98$exports = $ad4a3702b8819b30$exports(Array, "Array", function(iterated, kind) {
    $121e9cdb73c6da98$var$setInternalState(this, {
        type: $121e9cdb73c6da98$var$ARRAY_ITERATOR,
        target: $08ccc8de002b7975$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $121e9cdb73c6da98$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $f38e0f43c1e0dbb1$exports(undefined, true);
    }
    switch(state.kind){
        case "keys":
            return $f38e0f43c1e0dbb1$exports(index, false);
        case "values":
            return $f38e0f43c1e0dbb1$exports(target[index], false);
    }
    return $f38e0f43c1e0dbb1$exports([
        index,
        target[index]
    ], false);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $121e9cdb73c6da98$var$values = $898708d156ba5812$exports.Arguments = $898708d156ba5812$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$374bab7f556b652b$exports("keys");
$374bab7f556b652b$exports("values");
$374bab7f556b652b$exports("entries");
// V8 ~ Chrome 45- bug
if (!$8a834a2771c3d77e$exports && $a934004253d25a42$exports && $121e9cdb73c6da98$var$values.name !== "values") try {
    $121e9cdb73c6da98$require$defineProperty($121e9cdb73c6da98$var$values, "name", {
        value: "values"
    });
} catch (error) {}


"use strict";
var $ac5e43fd8976501e$exports = {};
"use strict";




var $ac5e43fd8976501e$var$charAt = $86d27fcf3ddb374a$exports("".charAt);
var $ac5e43fd8976501e$var$charCodeAt = $86d27fcf3ddb374a$exports("".charCodeAt);
var $ac5e43fd8976501e$var$stringSlice = $86d27fcf3ddb374a$exports("".slice);
var $ac5e43fd8976501e$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $0f08e96df1c6e400$exports($ce17aed0e5032df3$exports($this));
        var position = $8abe88bfd140bd58$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $ac5e43fd8976501e$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $ac5e43fd8976501e$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $ac5e43fd8976501e$var$charAt(S, position) : first : CONVERT_TO_STRING ? $ac5e43fd8976501e$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$ac5e43fd8976501e$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $ac5e43fd8976501e$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $ac5e43fd8976501e$var$createMethod(true)
};


var $0b4586806b35418f$require$charAt = $ac5e43fd8976501e$exports.charAt;




var $0b4586806b35418f$var$STRING_ITERATOR = "String Iterator";
var $0b4586806b35418f$var$setInternalState = $033d4cca21ca5361$exports.set;
var $0b4586806b35418f$var$getInternalState = $033d4cca21ca5361$exports.getterFor($0b4586806b35418f$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$ad4a3702b8819b30$exports(String, "String", function(iterated) {
    $0b4586806b35418f$var$setInternalState(this, {
        type: $0b4586806b35418f$var$STRING_ITERATOR,
        string: $0f08e96df1c6e400$exports(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $0b4586806b35418f$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $f38e0f43c1e0dbb1$exports(undefined, true);
    point = $0b4586806b35418f$require$charAt(string, index);
    state.index += point.length;
    return $f38e0f43c1e0dbb1$exports(point, false);
});


"use strict";
"use strict";
var $0e06fdda58a9995f$exports = {};
"use strict";

$0e06fdda58a9995f$exports = !$1c0f139a1a463ce1$exports(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});




var $b741a7223573301b$exports = {};
"use strict";

$b741a7223573301b$exports = function(target, src, options) {
    for(var key in src)$cc8a5761541cd35d$exports(target, key, src[key], options);
    return target;
};


var $c659de18108f2b9d$exports = {};
"use strict";






var $c659de18108f2b9d$require$defineProperty = $96bd28438ee2eee5$export$2d1720544b23b823;

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $870bf0ae771919e5$export$2d1720544b23b823;
"use strict";



var $870bf0ae771919e5$require$$getOwnPropertyNames = $f160027a9f5364b6$export$2d1720544b23b823;
var $c884eb1b9a961956$exports = {};
"use strict";

$c884eb1b9a961956$exports = $86d27fcf3ddb374a$exports([].slice);


var $870bf0ae771919e5$var$windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $870bf0ae771919e5$var$getWindowNames = function(it) {
    try {
        return $870bf0ae771919e5$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $c884eb1b9a961956$exports($870bf0ae771919e5$var$windowNames);
    }
};
$870bf0ae771919e5$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $870bf0ae771919e5$var$windowNames && $f65b6a6904086b61$exports(it) === "Window" ? $870bf0ae771919e5$var$getWindowNames(it) : $870bf0ae771919e5$require$$getOwnPropertyNames($08ccc8de002b7975$exports(it));
};


var $90dc3c5a8ac0491b$exports = {};
"use strict";



var $563445bc992b5636$exports = {};
"use strict";

$563445bc992b5636$exports = $1c0f139a1a463ce1$exports(function() {
    if (typeof ArrayBuffer == "function") {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, "a", {
            value: 8
        });
    }
});


// eslint-disable-next-line es/no-object-isextensible -- safe
var $90dc3c5a8ac0491b$var$$isExtensible = Object.isExtensible;
var $90dc3c5a8ac0491b$var$FAILS_ON_PRIMITIVES = $1c0f139a1a463ce1$exports(function() {
    $90dc3c5a8ac0491b$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
$90dc3c5a8ac0491b$exports = $90dc3c5a8ac0491b$var$FAILS_ON_PRIMITIVES || $563445bc992b5636$exports ? function isExtensible(it) {
    if (!$abc01766c6ffc0a1$exports(it)) return false;
    if ($563445bc992b5636$exports && $f65b6a6904086b61$exports(it) === "ArrayBuffer") return false;
    return $90dc3c5a8ac0491b$var$$isExtensible ? $90dc3c5a8ac0491b$var$$isExtensible(it) : true;
} : $90dc3c5a8ac0491b$var$$isExtensible;




var $c659de18108f2b9d$var$REQUIRED = false;
var $c659de18108f2b9d$var$METADATA = $2e904edd887c2aab$exports("meta");
var $c659de18108f2b9d$var$id = 0;
var $c659de18108f2b9d$var$setMetadata = function(it) {
    $c659de18108f2b9d$require$defineProperty(it, $c659de18108f2b9d$var$METADATA, {
        value: {
            objectID: "O" + $c659de18108f2b9d$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $c659de18108f2b9d$var$fastKey = function(it, create) {
    // return a primitive with prefix
    if (!$abc01766c6ffc0a1$exports(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!$9fd86a02d78d2d99$exports(it, $c659de18108f2b9d$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$90dc3c5a8ac0491b$exports(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        $c659de18108f2b9d$var$setMetadata(it);
    // return object ID
    }
    return it[$c659de18108f2b9d$var$METADATA].objectID;
};
var $c659de18108f2b9d$var$getWeakData = function(it, create) {
    if (!$9fd86a02d78d2d99$exports(it, $c659de18108f2b9d$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$90dc3c5a8ac0491b$exports(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $c659de18108f2b9d$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$c659de18108f2b9d$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $c659de18108f2b9d$var$onFreeze = function(it) {
    if ($0e06fdda58a9995f$exports && $c659de18108f2b9d$var$REQUIRED && $90dc3c5a8ac0491b$exports(it) && !$9fd86a02d78d2d99$exports(it, $c659de18108f2b9d$var$METADATA)) $c659de18108f2b9d$var$setMetadata(it);
    return it;
};
var $c659de18108f2b9d$var$enable = function() {
    $c659de18108f2b9d$var$meta.enable = function() {};
    $c659de18108f2b9d$var$REQUIRED = true;
    var getOwnPropertyNames = $f160027a9f5364b6$export$2d1720544b23b823;
    var splice = $86d27fcf3ddb374a$exports([].splice);
    var test = {};
    test[$c659de18108f2b9d$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $f160027a9f5364b6$export$2d1720544b23b823 = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $c659de18108f2b9d$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $621e6bc7a2f56e42$exports({
            target: "Object",
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $870bf0ae771919e5$export$2d1720544b23b823
        });
    }
};
var $c659de18108f2b9d$var$meta = $c659de18108f2b9d$exports = {
    enable: $c659de18108f2b9d$var$enable,
    fastKey: $c659de18108f2b9d$var$fastKey,
    getWeakData: $c659de18108f2b9d$var$getWeakData,
    onFreeze: $c659de18108f2b9d$var$onFreeze
};
$c134b99a007ffe97$exports[$c659de18108f2b9d$var$METADATA] = true;


var $feb3547d1b47cd95$exports = {};
"use strict";






var $3e11f2a1874c6bd7$exports = {};
"use strict";




var $6ef3986b7be069bb$exports = {};
"use strict";


var $6ef3986b7be069bb$var$ITERATOR = $06b7b285e3a7068a$exports("iterator");
var $6ef3986b7be069bb$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$6ef3986b7be069bb$exports = function(it) {
    return it !== undefined && ($898708d156ba5812$exports.Array === it || $6ef3986b7be069bb$var$ArrayPrototype[$6ef3986b7be069bb$var$ITERATOR] === it);
};




var $39f784c36ed16836$exports = {};
"use strict";




var $e4f2c4d8bd8780b9$exports = {};
"use strict";





var $e4f2c4d8bd8780b9$var$ITERATOR = $06b7b285e3a7068a$exports("iterator");
$e4f2c4d8bd8780b9$exports = function(it) {
    if (!$896d3aa83f9594d3$exports(it)) return $ea805a34e9f0856a$exports(it, $e4f2c4d8bd8780b9$var$ITERATOR) || $ea805a34e9f0856a$exports(it, "@@iterator") || $898708d156ba5812$exports[$28938e7b08ad8d2f$exports(it)];
};


var $39f784c36ed16836$var$$TypeError = TypeError;
$39f784c36ed16836$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $e4f2c4d8bd8780b9$exports(argument) : usingIterator;
    if ($a339c863cff407d1$exports(iteratorMethod)) return $c53804bbcc663539$exports($ba3e81ca5de34305$exports(iteratorMethod, argument));
    throw new $39f784c36ed16836$var$$TypeError($3ad1d00e209ff694$exports(argument) + " is not iterable");
};



var $3d1d3a3160c5a95a$exports = {};
"use strict";



$3d1d3a3160c5a95a$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $c53804bbcc663539$exports(iterator);
    try {
        innerResult = $ea805a34e9f0856a$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $ba3e81ca5de34305$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $c53804bbcc663539$exports(innerResult);
    return value;
};


var $3e11f2a1874c6bd7$var$$TypeError = TypeError;
var $3e11f2a1874c6bd7$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $3e11f2a1874c6bd7$var$ResultPrototype = $3e11f2a1874c6bd7$var$Result.prototype;
$3e11f2a1874c6bd7$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $e702529819d2fe6f$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $3d1d3a3160c5a95a$exports(iterator, "normal", condition);
        return new $3e11f2a1874c6bd7$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $c53804bbcc663539$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $e4f2c4d8bd8780b9$exports(iterable);
        if (!iterFn) throw new $3e11f2a1874c6bd7$var$$TypeError($3ad1d00e209ff694$exports(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($6ef3986b7be069bb$exports(iterFn)) {
            for(index = 0, length = $86912fee58c01fd8$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $d5379fc5818962a4$exports($3e11f2a1874c6bd7$var$ResultPrototype, result)) return result;
            }
            return new $3e11f2a1874c6bd7$var$Result(false);
        }
        iterator = $39f784c36ed16836$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $ba3e81ca5de34305$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $3d1d3a3160c5a95a$exports(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $d5379fc5818962a4$exports($3e11f2a1874c6bd7$var$ResultPrototype, result)) return result;
    }
    return new $3e11f2a1874c6bd7$var$Result(false);
};


var $b771e1b4d81409fe$exports = {};
"use strict";

var $b771e1b4d81409fe$var$$TypeError = TypeError;
$b771e1b4d81409fe$exports = function(it, Prototype) {
    if ($d5379fc5818962a4$exports(Prototype, it)) return it;
    throw new $b771e1b4d81409fe$var$$TypeError("Incorrect invocation");
};






var $e1138293a817967b$exports = {};
"use strict";

var $e1138293a817967b$var$ITERATOR = $06b7b285e3a7068a$exports("iterator");
var $e1138293a817967b$var$SAFE_CLOSING = false;
try {
    var $e1138293a817967b$var$called = 0;
    var $e1138293a817967b$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$e1138293a817967b$var$called++
            };
        },
        "return": function() {
            $e1138293a817967b$var$SAFE_CLOSING = true;
        }
    };
    $e1138293a817967b$var$iteratorWithReturn[$e1138293a817967b$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($e1138293a817967b$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$e1138293a817967b$exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$e1138293a817967b$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$e1138293a817967b$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};



var $1164434a76a3b13b$exports = {};
"use strict";



// makes subclassing work correct for wrapped built-ins
$1164434a76a3b13b$exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    $e667f1deebc629ea$exports && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    $da9965769ab8d492$exports(NewTarget = dummy.constructor) && NewTarget !== Wrapper && $abc01766c6ffc0a1$exports(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) $e667f1deebc629ea$exports($this, NewTargetPrototype);
    return $this;
};


$feb3547d1b47cd95$exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
    var ADDER = IS_MAP ? "set" : "add";
    var NativeConstructor = $818e316f8a39904d$exports[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function(KEY) {
        var uncurriedNativeMethod = $86d27fcf3ddb374a$exports(NativePrototype[KEY]);
        $cc8a5761541cd35d$exports(NativePrototype, KEY, KEY === "add" ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY === "delete" ? function(key) {
            return IS_WEAK && !$abc01766c6ffc0a1$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === "get" ? function get(key) {
            return IS_WEAK && !$abc01766c6ffc0a1$exports(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === "has" ? function has(key) {
            return IS_WEAK && !$abc01766c6ffc0a1$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = $32073ab696b14d8d$exports(CONSTRUCTOR_NAME, !$da9965769ab8d492$exports(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$1c0f139a1a463ce1$exports(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $c659de18108f2b9d$exports.enable();
    } else if ($32073ab696b14d8d$exports(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $1c0f139a1a463ce1$exports(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = $e1138293a817967b$exports(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $1c0f139a1a463ce1$exports(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                $b771e1b4d81409fe$exports(dummy, NativePrototype);
                var that = $1164434a76a3b13b$exports(new NativeConstructor(), dummy, Constructor);
                if (!$896d3aa83f9594d3$exports(iterable)) $3e11f2a1874c6bd7$exports(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod("delete");
            fixMethod("has");
            IS_MAP && fixMethod("get");
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $621e6bc7a2f56e42$exports({
        global: true,
        constructor: true,
        forced: Constructor !== NativeConstructor
    }, exported);
    $8f25367a6f31c129$exports(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};


var $ff795a54b9068452$exports = {};
"use strict";



var $ff795a54b9068452$require$getWeakData = $c659de18108f2b9d$exports.getWeakData;








var $ff795a54b9068452$var$setInternalState = $033d4cca21ca5361$exports.set;
var $ff795a54b9068452$var$internalStateGetterFor = $033d4cca21ca5361$exports.getterFor;
var $ff795a54b9068452$var$find = $bec34a0e29a6ea95$exports.find;
var $ff795a54b9068452$var$findIndex = $bec34a0e29a6ea95$exports.findIndex;
var $ff795a54b9068452$var$splice = $86d27fcf3ddb374a$exports([].splice);
var $ff795a54b9068452$var$id = 0;
// fallback for uncaught frozen keys
var $ff795a54b9068452$var$uncaughtFrozenStore = function(state) {
    return state.frozen || (state.frozen = new $ff795a54b9068452$var$UncaughtFrozenStore());
};
var $ff795a54b9068452$var$UncaughtFrozenStore = function() {
    this.entries = [];
};
var $ff795a54b9068452$var$findUncaughtFrozen = function(store, key) {
    return $ff795a54b9068452$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$ff795a54b9068452$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $ff795a54b9068452$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$ff795a54b9068452$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $ff795a54b9068452$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    "delete": function(key) {
        var index = $ff795a54b9068452$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $ff795a54b9068452$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
$ff795a54b9068452$exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $b771e1b4d81409fe$exports(that, Prototype);
            $ff795a54b9068452$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $ff795a54b9068452$var$id++,
                frozen: undefined
            });
            if (!$896d3aa83f9594d3$exports(iterable)) $3e11f2a1874c6bd7$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $ff795a54b9068452$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = $ff795a54b9068452$require$getWeakData($c53804bbcc663539$exports(key), true);
            if (data === true) $ff795a54b9068452$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $b741a7223573301b$exports(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            "delete": function(key) {
                var state = getInternalState(this);
                if (!$abc01766c6ffc0a1$exports(key)) return false;
                var data = $ff795a54b9068452$require$getWeakData(key);
                if (data === true) return $ff795a54b9068452$var$uncaughtFrozenStore(state)["delete"](key);
                return data && $9fd86a02d78d2d99$exports(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$abc01766c6ffc0a1$exports(key)) return false;
                var data = $ff795a54b9068452$require$getWeakData(key);
                if (data === true) return $ff795a54b9068452$var$uncaughtFrozenStore(state).has(key);
                return data && $9fd86a02d78d2d99$exports(data, state.id);
            }
        });
        $b741a7223573301b$exports(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($abc01766c6ffc0a1$exports(key)) {
                    var data = $ff795a54b9068452$require$getWeakData(key);
                    if (data === true) return $ff795a54b9068452$var$uncaughtFrozenStore(state).get(key);
                    return data ? data[state.id] : undefined;
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};




var $f8f2a2e5d7739272$require$enforceInternalState = $033d4cca21ca5361$exports.enforce;


var $f8f2a2e5d7739272$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $f8f2a2e5d7739272$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $f8f2a2e5d7739272$var$isExtensible = $f8f2a2e5d7739272$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $f8f2a2e5d7739272$var$isFrozen = $f8f2a2e5d7739272$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $f8f2a2e5d7739272$var$isSealed = $f8f2a2e5d7739272$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $f8f2a2e5d7739272$var$freeze = $f8f2a2e5d7739272$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $f8f2a2e5d7739272$var$seal = $f8f2a2e5d7739272$var$$Object.seal;
var $f8f2a2e5d7739272$var$IS_IE11 = !$818e316f8a39904d$exports.ActiveXObject && "ActiveXObject" in $818e316f8a39904d$exports;
var $f8f2a2e5d7739272$var$InternalWeakMap;
var $f8f2a2e5d7739272$var$wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $f8f2a2e5d7739272$var$$WeakMap = $feb3547d1b47cd95$exports("WeakMap", $f8f2a2e5d7739272$var$wrapper, $ff795a54b9068452$exports);
var $f8f2a2e5d7739272$var$WeakMapPrototype = $f8f2a2e5d7739272$var$$WeakMap.prototype;
var $f8f2a2e5d7739272$var$nativeSet = $86d27fcf3ddb374a$exports($f8f2a2e5d7739272$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $f8f2a2e5d7739272$var$hasMSEdgeFreezingBug = function() {
    return $0e06fdda58a9995f$exports && $1c0f139a1a463ce1$exports(function() {
        var frozenArray = $f8f2a2e5d7739272$var$freeze([]);
        $f8f2a2e5d7739272$var$nativeSet(new $f8f2a2e5d7739272$var$$WeakMap(), frozenArray, 1);
        return !$f8f2a2e5d7739272$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($d5d26662890f9fd9$exports) {
    if ($f8f2a2e5d7739272$var$IS_IE11) {
        $f8f2a2e5d7739272$var$InternalWeakMap = $ff795a54b9068452$exports.getConstructor($f8f2a2e5d7739272$var$wrapper, "WeakMap", true);
        $c659de18108f2b9d$exports.enable();
        var $f8f2a2e5d7739272$var$nativeDelete = $86d27fcf3ddb374a$exports($f8f2a2e5d7739272$var$WeakMapPrototype["delete"]);
        var $f8f2a2e5d7739272$var$nativeHas = $86d27fcf3ddb374a$exports($f8f2a2e5d7739272$var$WeakMapPrototype.has);
        var $f8f2a2e5d7739272$var$nativeGet = $86d27fcf3ddb374a$exports($f8f2a2e5d7739272$var$WeakMapPrototype.get);
        $b741a7223573301b$exports($f8f2a2e5d7739272$var$WeakMapPrototype, {
            "delete": function(key) {
                if ($abc01766c6ffc0a1$exports(key) && !$f8f2a2e5d7739272$var$isExtensible(key)) {
                    var state = $f8f2a2e5d7739272$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $f8f2a2e5d7739272$var$InternalWeakMap();
                    return $f8f2a2e5d7739272$var$nativeDelete(this, key) || state.frozen["delete"](key);
                }
                return $f8f2a2e5d7739272$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($abc01766c6ffc0a1$exports(key) && !$f8f2a2e5d7739272$var$isExtensible(key)) {
                    var state = $f8f2a2e5d7739272$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $f8f2a2e5d7739272$var$InternalWeakMap();
                    return $f8f2a2e5d7739272$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $f8f2a2e5d7739272$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($abc01766c6ffc0a1$exports(key) && !$f8f2a2e5d7739272$var$isExtensible(key)) {
                    var state = $f8f2a2e5d7739272$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $f8f2a2e5d7739272$var$InternalWeakMap();
                    return $f8f2a2e5d7739272$var$nativeHas(this, key) ? $f8f2a2e5d7739272$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $f8f2a2e5d7739272$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($abc01766c6ffc0a1$exports(key) && !$f8f2a2e5d7739272$var$isExtensible(key)) {
                    var state = $f8f2a2e5d7739272$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $f8f2a2e5d7739272$var$InternalWeakMap();
                    $f8f2a2e5d7739272$var$nativeHas(this, key) ? $f8f2a2e5d7739272$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $f8f2a2e5d7739272$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($f8f2a2e5d7739272$var$hasMSEdgeFreezingBug()) $b741a7223573301b$exports($f8f2a2e5d7739272$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($f8f2a2e5d7739272$var$isArray(key)) {
                if ($f8f2a2e5d7739272$var$isFrozen(key)) arrayIntegrityLevel = $f8f2a2e5d7739272$var$freeze;
                else if ($f8f2a2e5d7739272$var$isSealed(key)) arrayIntegrityLevel = $f8f2a2e5d7739272$var$seal;
            }
            $f8f2a2e5d7739272$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel) arrayIntegrityLevel(key);
            return this;
        }
    });
}




"use strict";

var $2c2d10dfcf45ad43$exports = {};
"use strict";
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$2c2d10dfcf45ad43$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};


var $c1bce5d1e69c6b84$exports = {};
"use strict";

var $c1bce5d1e69c6b84$var$classList = $6a21b3c3b047179b$exports("span").classList;
var $c1bce5d1e69c6b84$var$DOMTokenListPrototype = $c1bce5d1e69c6b84$var$classList && $c1bce5d1e69c6b84$var$classList.constructor && $c1bce5d1e69c6b84$var$classList.constructor.prototype;
$c1bce5d1e69c6b84$exports = $c1bce5d1e69c6b84$var$DOMTokenListPrototype === Object.prototype ? undefined : $c1bce5d1e69c6b84$var$DOMTokenListPrototype;






var $d6f0ecee22d99965$var$ITERATOR = $06b7b285e3a7068a$exports("iterator");
var $d6f0ecee22d99965$var$ArrayValues = $121e9cdb73c6da98$exports.values;
var $d6f0ecee22d99965$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$d6f0ecee22d99965$var$ITERATOR] !== $d6f0ecee22d99965$var$ArrayValues) try {
            $3d5a463be44ffeea$exports(CollectionPrototype, $d6f0ecee22d99965$var$ITERATOR, $d6f0ecee22d99965$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$d6f0ecee22d99965$var$ITERATOR] = $d6f0ecee22d99965$var$ArrayValues;
        }
        $8f25367a6f31c129$exports(CollectionPrototype, COLLECTION_NAME, true);
        if ($2c2d10dfcf45ad43$exports[COLLECTION_NAME]) for(var METHOD_NAME in $121e9cdb73c6da98$exports){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $121e9cdb73c6da98$exports[METHOD_NAME]) try {
                $3d5a463be44ffeea$exports(CollectionPrototype, METHOD_NAME, $121e9cdb73c6da98$exports[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $121e9cdb73c6da98$exports[METHOD_NAME];
            }
        }
    }
};
for(var $d6f0ecee22d99965$var$COLLECTION_NAME in $2c2d10dfcf45ad43$exports)$d6f0ecee22d99965$var$handlePrototype($818e316f8a39904d$exports[$d6f0ecee22d99965$var$COLLECTION_NAME] && $818e316f8a39904d$exports[$d6f0ecee22d99965$var$COLLECTION_NAME].prototype, $d6f0ecee22d99965$var$COLLECTION_NAME);
$d6f0ecee22d99965$var$handlePrototype($c1bce5d1e69c6b84$exports, "DOMTokenList");


var $ac15e73f2bda9226$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $ac15e73f2bda9226$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $ac15e73f2bda9226$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $ac15e73f2bda9226$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $ac15e73f2bda9226$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $ac15e73f2bda9226$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $ac15e73f2bda9226$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $ac15e73f2bda9226$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $ac15e73f2bda9226$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $ac15e73f2bda9226$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $ac15e73f2bda9226$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $ac15e73f2bda9226$var$root = $ac15e73f2bda9226$var$freeGlobal || $ac15e73f2bda9226$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $ac15e73f2bda9226$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ac15e73f2bda9226$var$objectToString = $ac15e73f2bda9226$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ac15e73f2bda9226$var$nativeMax = Math.max, $ac15e73f2bda9226$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $ac15e73f2bda9226$var$now = function() {
    return $ac15e73f2bda9226$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $ac15e73f2bda9226$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($ac15e73f2bda9226$var$FUNC_ERROR_TEXT);
    wait = $ac15e73f2bda9226$var$toNumber(wait) || 0;
    if ($ac15e73f2bda9226$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $ac15e73f2bda9226$var$nativeMax($ac15e73f2bda9226$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $ac15e73f2bda9226$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $ac15e73f2bda9226$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($ac15e73f2bda9226$var$now());
    }
    function debounced() {
        var time = $ac15e73f2bda9226$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $ac15e73f2bda9226$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($ac15e73f2bda9226$var$FUNC_ERROR_TEXT);
    if ($ac15e73f2bda9226$var$isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $ac15e73f2bda9226$var$debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $ac15e73f2bda9226$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $ac15e73f2bda9226$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $ac15e73f2bda9226$var$isSymbol(value) {
    return typeof value == "symbol" || $ac15e73f2bda9226$var$isObjectLike(value) && $ac15e73f2bda9226$var$objectToString.call(value) == $ac15e73f2bda9226$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $ac15e73f2bda9226$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($ac15e73f2bda9226$var$isSymbol(value)) return $ac15e73f2bda9226$var$NAN;
    if ($ac15e73f2bda9226$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $ac15e73f2bda9226$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($ac15e73f2bda9226$var$reTrim, "");
    var isBinary = $ac15e73f2bda9226$var$reIsBinary.test(value);
    return isBinary || $ac15e73f2bda9226$var$reIsOctal.test(value) ? $ac15e73f2bda9226$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $ac15e73f2bda9226$var$reIsBadHex.test(value) ? $ac15e73f2bda9226$var$NAN : +value;
}
$ac15e73f2bda9226$exports = $ac15e73f2bda9226$var$throttle;


var $b38ef1abffe94323$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $b38ef1abffe94323$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $b38ef1abffe94323$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $b38ef1abffe94323$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $b38ef1abffe94323$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $b38ef1abffe94323$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $b38ef1abffe94323$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $b38ef1abffe94323$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $b38ef1abffe94323$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $b38ef1abffe94323$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $b38ef1abffe94323$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $b38ef1abffe94323$var$root = $b38ef1abffe94323$var$freeGlobal || $b38ef1abffe94323$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $b38ef1abffe94323$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b38ef1abffe94323$var$objectToString = $b38ef1abffe94323$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b38ef1abffe94323$var$nativeMax = Math.max, $b38ef1abffe94323$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $b38ef1abffe94323$var$now = function() {
    return $b38ef1abffe94323$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $b38ef1abffe94323$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($b38ef1abffe94323$var$FUNC_ERROR_TEXT);
    wait = $b38ef1abffe94323$var$toNumber(wait) || 0;
    if ($b38ef1abffe94323$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $b38ef1abffe94323$var$nativeMax($b38ef1abffe94323$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $b38ef1abffe94323$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $b38ef1abffe94323$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($b38ef1abffe94323$var$now());
    }
    function debounced() {
        var time = $b38ef1abffe94323$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $b38ef1abffe94323$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $b38ef1abffe94323$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b38ef1abffe94323$var$isSymbol(value) {
    return typeof value == "symbol" || $b38ef1abffe94323$var$isObjectLike(value) && $b38ef1abffe94323$var$objectToString.call(value) == $b38ef1abffe94323$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $b38ef1abffe94323$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($b38ef1abffe94323$var$isSymbol(value)) return $b38ef1abffe94323$var$NAN;
    if ($b38ef1abffe94323$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $b38ef1abffe94323$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($b38ef1abffe94323$var$reTrim, "");
    var isBinary = $b38ef1abffe94323$var$reIsBinary.test(value);
    return isBinary || $b38ef1abffe94323$var$reIsOctal.test(value) ? $b38ef1abffe94323$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $b38ef1abffe94323$var$reIsBadHex.test(value) ? $b38ef1abffe94323$var$NAN : +value;
}
$b38ef1abffe94323$exports = $b38ef1abffe94323$var$debounce;


var $3d80b95f583ab164$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $3d80b95f583ab164$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var $3d80b95f583ab164$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** `Object#toString` result references. */ var $3d80b95f583ab164$var$funcTag = "[object Function]", $3d80b95f583ab164$var$genTag = "[object GeneratorFunction]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $3d80b95f583ab164$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $3d80b95f583ab164$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $3d80b95f583ab164$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $3d80b95f583ab164$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $3d80b95f583ab164$var$root = $3d80b95f583ab164$var$freeGlobal || $3d80b95f583ab164$var$freeSelf || Function("return this")();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $3d80b95f583ab164$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $3d80b95f583ab164$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $3d80b95f583ab164$var$arrayProto = Array.prototype, $3d80b95f583ab164$var$funcProto = Function.prototype, $3d80b95f583ab164$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $3d80b95f583ab164$var$coreJsData = $3d80b95f583ab164$var$root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var $3d80b95f583ab164$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($3d80b95f583ab164$var$coreJsData && $3d80b95f583ab164$var$coreJsData.keys && $3d80b95f583ab164$var$coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var $3d80b95f583ab164$var$funcToString = $3d80b95f583ab164$var$funcProto.toString;
/** Used to check objects for own properties. */ var $3d80b95f583ab164$var$hasOwnProperty = $3d80b95f583ab164$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3d80b95f583ab164$var$objectToString = $3d80b95f583ab164$var$objectProto.toString;
/** Used to detect if a method is native. */ var $3d80b95f583ab164$var$reIsNative = RegExp("^" + $3d80b95f583ab164$var$funcToString.call($3d80b95f583ab164$var$hasOwnProperty).replace($3d80b95f583ab164$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var $3d80b95f583ab164$var$splice = $3d80b95f583ab164$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $3d80b95f583ab164$var$Map = $3d80b95f583ab164$var$getNative($3d80b95f583ab164$var$root, "Map"), $3d80b95f583ab164$var$nativeCreate = $3d80b95f583ab164$var$getNative(Object, "create");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3d80b95f583ab164$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $3d80b95f583ab164$var$hashClear() {
    this.__data__ = $3d80b95f583ab164$var$nativeCreate ? $3d80b95f583ab164$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3d80b95f583ab164$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3d80b95f583ab164$var$hashGet(key) {
    var data = this.__data__;
    if ($3d80b95f583ab164$var$nativeCreate) {
        var result = data[key];
        return result === $3d80b95f583ab164$var$HASH_UNDEFINED ? undefined : result;
    }
    return $3d80b95f583ab164$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3d80b95f583ab164$var$hashHas(key) {
    var data = this.__data__;
    return $3d80b95f583ab164$var$nativeCreate ? data[key] !== undefined : $3d80b95f583ab164$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $3d80b95f583ab164$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $3d80b95f583ab164$var$nativeCreate && value === undefined ? $3d80b95f583ab164$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$3d80b95f583ab164$var$Hash.prototype.clear = $3d80b95f583ab164$var$hashClear;
$3d80b95f583ab164$var$Hash.prototype["delete"] = $3d80b95f583ab164$var$hashDelete;
$3d80b95f583ab164$var$Hash.prototype.get = $3d80b95f583ab164$var$hashGet;
$3d80b95f583ab164$var$Hash.prototype.has = $3d80b95f583ab164$var$hashHas;
$3d80b95f583ab164$var$Hash.prototype.set = $3d80b95f583ab164$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3d80b95f583ab164$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $3d80b95f583ab164$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3d80b95f583ab164$var$listCacheDelete(key) {
    var data = this.__data__, index = $3d80b95f583ab164$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $3d80b95f583ab164$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3d80b95f583ab164$var$listCacheGet(key) {
    var data = this.__data__, index = $3d80b95f583ab164$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3d80b95f583ab164$var$listCacheHas(key) {
    return $3d80b95f583ab164$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $3d80b95f583ab164$var$listCacheSet(key, value) {
    var data = this.__data__, index = $3d80b95f583ab164$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$3d80b95f583ab164$var$ListCache.prototype.clear = $3d80b95f583ab164$var$listCacheClear;
$3d80b95f583ab164$var$ListCache.prototype["delete"] = $3d80b95f583ab164$var$listCacheDelete;
$3d80b95f583ab164$var$ListCache.prototype.get = $3d80b95f583ab164$var$listCacheGet;
$3d80b95f583ab164$var$ListCache.prototype.has = $3d80b95f583ab164$var$listCacheHas;
$3d80b95f583ab164$var$ListCache.prototype.set = $3d80b95f583ab164$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3d80b95f583ab164$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $3d80b95f583ab164$var$mapCacheClear() {
    this.__data__ = {
        "hash": new $3d80b95f583ab164$var$Hash,
        "map": new ($3d80b95f583ab164$var$Map || $3d80b95f583ab164$var$ListCache),
        "string": new $3d80b95f583ab164$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3d80b95f583ab164$var$mapCacheDelete(key) {
    return $3d80b95f583ab164$var$getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3d80b95f583ab164$var$mapCacheGet(key) {
    return $3d80b95f583ab164$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3d80b95f583ab164$var$mapCacheHas(key) {
    return $3d80b95f583ab164$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $3d80b95f583ab164$var$mapCacheSet(key, value) {
    $3d80b95f583ab164$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$3d80b95f583ab164$var$MapCache.prototype.clear = $3d80b95f583ab164$var$mapCacheClear;
$3d80b95f583ab164$var$MapCache.prototype["delete"] = $3d80b95f583ab164$var$mapCacheDelete;
$3d80b95f583ab164$var$MapCache.prototype.get = $3d80b95f583ab164$var$mapCacheGet;
$3d80b95f583ab164$var$MapCache.prototype.has = $3d80b95f583ab164$var$mapCacheHas;
$3d80b95f583ab164$var$MapCache.prototype.set = $3d80b95f583ab164$var$mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $3d80b95f583ab164$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($3d80b95f583ab164$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $3d80b95f583ab164$var$baseIsNative(value) {
    if (!$3d80b95f583ab164$var$isObject(value) || $3d80b95f583ab164$var$isMasked(value)) return false;
    var pattern = $3d80b95f583ab164$var$isFunction(value) || $3d80b95f583ab164$var$isHostObject(value) ? $3d80b95f583ab164$var$reIsNative : $3d80b95f583ab164$var$reIsHostCtor;
    return pattern.test($3d80b95f583ab164$var$toSource(value));
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $3d80b95f583ab164$var$getMapData(map, key) {
    var data = map.__data__;
    return $3d80b95f583ab164$var$isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $3d80b95f583ab164$var$getNative(object, key) {
    var value = $3d80b95f583ab164$var$getValue(object, key);
    return $3d80b95f583ab164$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $3d80b95f583ab164$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $3d80b95f583ab164$var$isMasked(func) {
    return !!$3d80b95f583ab164$var$maskSrcKey && $3d80b95f583ab164$var$maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $3d80b95f583ab164$var$toSource(func) {
    if (func != null) {
        try {
            return $3d80b95f583ab164$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $3d80b95f583ab164$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError($3d80b95f583ab164$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($3d80b95f583ab164$var$memoize.Cache || $3d80b95f583ab164$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$3d80b95f583ab164$var$memoize.Cache = $3d80b95f583ab164$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $3d80b95f583ab164$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $3d80b95f583ab164$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $3d80b95f583ab164$var$isObject(value) ? $3d80b95f583ab164$var$objectToString.call(value) : "";
    return tag == $3d80b95f583ab164$var$funcTag || tag == $3d80b95f583ab164$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $3d80b95f583ab164$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
$3d80b95f583ab164$exports = $3d80b95f583ab164$var$memoize;


var $9f6cc918bbd0f399$export$402e76927ebf6a24 = [];


var $44d5933aae3bd66d$export$63c81bd924f89474 = function() {
    return (0, $9f6cc918bbd0f399$export$402e76927ebf6a24).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};



var $ca048bcf49b62a94$export$8ca35300535e324d = function() {
    return (0, $9f6cc918bbd0f399$export$402e76927ebf6a24).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};


var $1fe74cf0a2ddb5d8$var$msg = "ResizeObserver loop completed with undelivered notifications.";
var $1fe74cf0a2ddb5d8$export$888cb69481582149 = function() {
    var event;
    if (typeof ErrorEvent === "function") event = new ErrorEvent("error", {
        message: $1fe74cf0a2ddb5d8$var$msg
    });
    else {
        event = document.createEvent("Event");
        event.initEvent("error", false, false);
        event.message = $1fe74cf0a2ddb5d8$var$msg;
    }
    window.dispatchEvent(event);
};



var $8314067dec4b2950$export$416d111b83cd1483;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})($8314067dec4b2950$export$416d111b83cd1483 || ($8314067dec4b2950$export$416d111b83cd1483 = {}));


var $76d63437f73f4f9f$export$792f3d81ea979f55 = function(obj) {
    return Object.freeze(obj);
};


var $30aaee0efb79fe49$export$c9ad8cdf6bbd331c = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, $76d63437f73f4f9f$export$792f3d81ea979f55)(this);
    }
    return ResizeObserverSize;
}();



var $17bf486e956e5d87$export$51d7a67026f4e0b7 = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, $76d63437f73f4f9f$export$792f3d81ea979f55)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();


var $80f87743c2cc41ed$export$165b39ed277223c2 = function(target) {
    return target instanceof SVGElement && "getBBox" in target;
};
var $80f87743c2cc41ed$export$ee695c13482bb5dd = function(target) {
    if ($80f87743c2cc41ed$export$165b39ed277223c2(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var $80f87743c2cc41ed$export$45a5e7f76e0caa8d = function(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var $80f87743c2cc41ed$export$a6eb60f7e7c182ba = function(target) {
    switch(target.tagName){
        case "INPUT":
            if (target.type !== "image") break;
        case "VIDEO":
        case "AUDIO":
        case "EMBED":
        case "OBJECT":
        case "CANVAS":
        case "IFRAME":
        case "IMG":
            return true;
    }
    return false;
};



var $9b2ebe639ac9e1e0$export$90b4d2ff6acb88af = typeof window !== "undefined" ? window : {};


var $a77d2204e7ff4fc3$var$cache = new WeakMap();
var $a77d2204e7ff4fc3$var$scrollRegexp = /auto|scroll/;
var $a77d2204e7ff4fc3$var$verticalRegexp = /^tb|vertical/;
var $a77d2204e7ff4fc3$var$IE = /msie|trident/i.test((0, $9b2ebe639ac9e1e0$export$90b4d2ff6acb88af).navigator && (0, $9b2ebe639ac9e1e0$export$90b4d2ff6acb88af).navigator.userAgent);
var $a77d2204e7ff4fc3$var$parseDimension = function(pixel) {
    return parseFloat(pixel || "0");
};
var $a77d2204e7ff4fc3$var$size = function(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, $30aaee0efb79fe49$export$c9ad8cdf6bbd331c)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var $a77d2204e7ff4fc3$var$zeroBoxes = (0, $76d63437f73f4f9f$export$792f3d81ea979f55)({
    devicePixelContentBoxSize: $a77d2204e7ff4fc3$var$size(),
    borderBoxSize: $a77d2204e7ff4fc3$var$size(),
    contentBoxSize: $a77d2204e7ff4fc3$var$size(),
    contentRect: new (0, $17bf486e956e5d87$export$51d7a67026f4e0b7)(0, 0, 0, 0)
});
var $a77d2204e7ff4fc3$export$504d039a9c501c94 = function(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if ($a77d2204e7ff4fc3$var$cache.has(target) && !forceRecalculation) return $a77d2204e7ff4fc3$var$cache.get(target);
    if ((0, $80f87743c2cc41ed$export$ee695c13482bb5dd)(target)) {
        $a77d2204e7ff4fc3$var$cache.set(target, $a77d2204e7ff4fc3$var$zeroBoxes);
        return $a77d2204e7ff4fc3$var$zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, $80f87743c2cc41ed$export$165b39ed277223c2)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !$a77d2204e7ff4fc3$var$IE && cs.boxSizing === "border-box";
    var switchSizes = $a77d2204e7ff4fc3$var$verticalRegexp.test(cs.writingMode || "");
    var canScrollVertically = !svg && $a77d2204e7ff4fc3$var$scrollRegexp.test(cs.overflowY || "");
    var canScrollHorizontally = !svg && $a77d2204e7ff4fc3$var$scrollRegexp.test(cs.overflowX || "");
    var paddingTop = svg ? 0 : $a77d2204e7ff4fc3$var$parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : $a77d2204e7ff4fc3$var$parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : $a77d2204e7ff4fc3$var$parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : $a77d2204e7ff4fc3$var$parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : $a77d2204e7ff4fc3$var$parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : $a77d2204e7ff4fc3$var$parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : $a77d2204e7ff4fc3$var$parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : $a77d2204e7ff4fc3$var$parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : $a77d2204e7ff4fc3$var$parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : $a77d2204e7ff4fc3$var$parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, $76d63437f73f4f9f$export$792f3d81ea979f55)({
        devicePixelContentBoxSize: $a77d2204e7ff4fc3$var$size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: $a77d2204e7ff4fc3$var$size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: $a77d2204e7ff4fc3$var$size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, $17bf486e956e5d87$export$51d7a67026f4e0b7)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    $a77d2204e7ff4fc3$var$cache.set(target, boxes);
    return boxes;
};
var $a77d2204e7ff4fc3$export$1a78030b04106bdb = function(target, observedBox, forceRecalculation) {
    var _a = $a77d2204e7ff4fc3$export$504d039a9c501c94(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, $8314067dec4b2950$export$416d111b83cd1483).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, $8314067dec4b2950$export$416d111b83cd1483).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};



var $d5be95add2fa60d9$export$226159b441fc89f8 = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, $a77d2204e7ff4fc3$export$504d039a9c501c94)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, $76d63437f73f4f9f$export$792f3d81ea979f55)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, $76d63437f73f4f9f$export$792f3d81ea979f55)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, $76d63437f73f4f9f$export$792f3d81ea979f55)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();



var $74f7269ef8367517$export$f8c8e3b5da1f41d2 = function(node) {
    if ((0, $80f87743c2cc41ed$export$ee695c13482bb5dd)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};



var $af2802e502a5e189$export$9cac928141e5443b = function() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, $9f6cc918bbd0f399$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, $d5be95add2fa60d9$export$226159b441fc89f8)(ot.target);
            var targetDepth = (0, $74f7269ef8367517$export$f8c8e3b5da1f41d2)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, $a77d2204e7ff4fc3$export$1a78030b04106bdb)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};




var $83ed81c9ea1756c2$export$9c17b8913a2a3572 = function(depth) {
    (0, $9f6cc918bbd0f399$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, $74f7269ef8367517$export$f8c8e3b5da1f41d2)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};


var $f8517573e873feed$export$e54fe5b0f43758f7 = function() {
    var depth = 0;
    (0, $83ed81c9ea1756c2$export$9c17b8913a2a3572)(depth);
    while((0, $44d5933aae3bd66d$export$63c81bd924f89474)()){
        depth = (0, $af2802e502a5e189$export$9cac928141e5443b)();
        (0, $83ed81c9ea1756c2$export$9c17b8913a2a3572)(depth);
    }
    if ((0, $ca048bcf49b62a94$export$8ca35300535e324d)()) (0, $1fe74cf0a2ddb5d8$export$888cb69481582149)();
    return depth > 0;
};



var $630e9c3d4d5be402$var$trigger;
var $630e9c3d4d5be402$var$callbacks = [];
var $630e9c3d4d5be402$var$notify = function() {
    return $630e9c3d4d5be402$var$callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var $630e9c3d4d5be402$export$4c995d4933c4abb = function(callback) {
    if (!$630e9c3d4d5be402$var$trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode("");
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return $630e9c3d4d5be402$var$notify();
        }).observe(el_1, config);
        $630e9c3d4d5be402$var$trigger = function() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    $630e9c3d4d5be402$var$callbacks.push(callback);
    $630e9c3d4d5be402$var$trigger();
};


var $8625626a068d8071$export$5755c7b572e34c6 = function(cb) {
    (0, $630e9c3d4d5be402$export$4c995d4933c4abb)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};


var $ceaa7b0fb49ab085$var$watching = 0;
var $ceaa7b0fb49ab085$var$isWatching = function() {
    return !!$ceaa7b0fb49ab085$var$watching;
};
var $ceaa7b0fb49ab085$var$CATCH_PERIOD = 250;
var $ceaa7b0fb49ab085$var$observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var $ceaa7b0fb49ab085$var$events = [
    "resize",
    "load",
    "transitionend",
    "animationend",
    "animationstart",
    "animationiteration",
    "keyup",
    "keydown",
    "mouseup",
    "mousedown",
    "mouseover",
    "mouseout",
    "blur",
    "focus"
];
var $ceaa7b0fb49ab085$var$time = function(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var $ceaa7b0fb49ab085$var$scheduled = false;
var $ceaa7b0fb49ab085$var$Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = $ceaa7b0fb49ab085$var$CATCH_PERIOD;
        if ($ceaa7b0fb49ab085$var$scheduled) return;
        $ceaa7b0fb49ab085$var$scheduled = true;
        var until = $ceaa7b0fb49ab085$var$time(timeout);
        (0, $8625626a068d8071$export$5755c7b572e34c6)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, $f8517573e873feed$export$e54fe5b0f43758f7)();
            } finally{
                $ceaa7b0fb49ab085$var$scheduled = false;
                timeout = until - $ceaa7b0fb49ab085$var$time();
                if (!$ceaa7b0fb49ab085$var$isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function() {
            return _this.observer && _this.observer.observe(document.body, $ceaa7b0fb49ab085$var$observerConfig);
        };
        document.body ? cb() : (0, $9b2ebe639ac9e1e0$export$90b4d2ff6acb88af).addEventListener("DOMContentLoaded", cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            $ceaa7b0fb49ab085$var$events.forEach(function(name) {
                return (0, $9b2ebe639ac9e1e0$export$90b4d2ff6acb88af).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            $ceaa7b0fb49ab085$var$events.forEach(function(name) {
                return (0, $9b2ebe639ac9e1e0$export$90b4d2ff6acb88af).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var $ceaa7b0fb49ab085$export$d30788f2c20241cd = new $ceaa7b0fb49ab085$var$Scheduler();
var $ceaa7b0fb49ab085$export$1f18a74d42722835 = function(n) {
    !$ceaa7b0fb49ab085$var$watching && n > 0 && $ceaa7b0fb49ab085$export$d30788f2c20241cd.start();
    $ceaa7b0fb49ab085$var$watching += n;
    !$ceaa7b0fb49ab085$var$watching && $ceaa7b0fb49ab085$export$d30788f2c20241cd.stop();
};





var $6f08a140fa0cf6f3$var$skipNotifyOnElement = function(target) {
    return !(0, $80f87743c2cc41ed$export$165b39ed277223c2)(target) && !(0, $80f87743c2cc41ed$export$a6eb60f7e7c182ba)(target) && getComputedStyle(target).display === "inline";
};
var $6f08a140fa0cf6f3$export$fea412043713122 = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, $8314067dec4b2950$export$416d111b83cd1483).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, $a77d2204e7ff4fc3$export$1a78030b04106bdb)(this.target, this.observedBox, true);
        if ($6f08a140fa0cf6f3$var$skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();


var $3c10bfd5b2fe44df$export$d86966e6e4bc97e1 = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();



var $0a4dd209e7047afa$var$observerMap = new WeakMap();
var $0a4dd209e7047afa$var$getObservationIndex = function(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var $0a4dd209e7047afa$export$ed99c5bafbaf8300 = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, $3c10bfd5b2fe44df$export$d86966e6e4bc97e1)(resizeObserver, callback);
        $0a4dd209e7047afa$var$observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = $0a4dd209e7047afa$var$observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if ($0a4dd209e7047afa$var$getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, $9f6cc918bbd0f399$export$402e76927ebf6a24).push(detail);
            detail.observationTargets.push(new (0, $6f08a140fa0cf6f3$export$fea412043713122)(target, options && options.box));
            (0, $ceaa7b0fb49ab085$export$1f18a74d42722835)(1);
            (0, $ceaa7b0fb49ab085$export$d30788f2c20241cd).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = $0a4dd209e7047afa$var$observerMap.get(resizeObserver);
        var index = $0a4dd209e7047afa$var$getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, $9f6cc918bbd0f399$export$402e76927ebf6a24).splice((0, $9f6cc918bbd0f399$export$402e76927ebf6a24).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, $ceaa7b0fb49ab085$export$1f18a74d42722835)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = $0a4dd209e7047afa$var$observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();



var $31609950d3966c62$export$9caf76241ca21a11 = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== "function") throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, $0a4dd209e7047afa$export$ed99c5bafbaf8300).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $80f87743c2cc41ed$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $0a4dd209e7047afa$export$ed99c5bafbaf8300).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $80f87743c2cc41ed$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $0a4dd209e7047afa$export$ed99c5bafbaf8300).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, $0a4dd209e7047afa$export$ed99c5bafbaf8300).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return "function ResizeObserver () { [polyfill code] }";
    };
    return ResizeObserver;
}();






var $b696bbfb437150c8$exports = {};
var $b696bbfb437150c8$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
$b696bbfb437150c8$exports = $b696bbfb437150c8$var$canUseDOM;


"use strict";

var $471f29b552388c63$exports = {};
"use strict";




var $471f29b552388c63$var$$TypeError = TypeError;
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $471f29b552388c63$var$createMethod = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        var O = $c9b4f3ef4a96c778$exports(that);
        var self = $9d1a1577a6ed79d1$exports(O);
        var length = $86912fee58c01fd8$exports(O);
        $a339c863cff407d1$exports(callbackfn);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw new $471f29b552388c63$var$$TypeError("Reduce of empty array with no initial value");
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
$471f29b552388c63$exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $471f29b552388c63$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $471f29b552388c63$var$createMethod(true)
};


var $b5b769674ac65a84$require$$reduce = $471f29b552388c63$exports.left;
var $517ea068d2123fd0$exports = {};
"use strict";

$517ea068d2123fd0$exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $1c0f139a1a463ce1$exports(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};



var $03bf4e21cdf0b81b$exports = {};
"use strict";


$03bf4e21cdf0b81b$exports = $f65b6a6904086b61$exports($818e316f8a39904d$exports.process) === "process";


// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $b5b769674ac65a84$var$CHROME_BUG = !$03bf4e21cdf0b81b$exports && $e5ab0d050bcf2c0f$exports > 79 && $e5ab0d050bcf2c0f$exports < 83;
var $b5b769674ac65a84$var$FORCED = $b5b769674ac65a84$var$CHROME_BUG || !$517ea068d2123fd0$exports("reduce");
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$621e6bc7a2f56e42$exports({
    target: "Array",
    proto: true,
    forced: $b5b769674ac65a84$var$FORCED
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $b5b769674ac65a84$require$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});


"use strict";

var $743bfc98b506a5f7$exports = {};
"use strict";



var $3aa38f04e131e4f8$exports = {};
"use strict";

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$3aa38f04e131e4f8$exports = function() {
    var that = $c53804bbcc663539$exports(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};


var $d4aad8f9752f515c$exports = {};
"use strict";


// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $d4aad8f9752f515c$var$$RegExp = $818e316f8a39904d$exports.RegExp;
var $d4aad8f9752f515c$var$UNSUPPORTED_Y = $1c0f139a1a463ce1$exports(function() {
    var re = $d4aad8f9752f515c$var$$RegExp("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") !== null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $d4aad8f9752f515c$var$MISSED_STICKY = $d4aad8f9752f515c$var$UNSUPPORTED_Y || $1c0f139a1a463ce1$exports(function() {
    return !$d4aad8f9752f515c$var$$RegExp("a", "y").sticky;
});
var $d4aad8f9752f515c$var$BROKEN_CARET = $d4aad8f9752f515c$var$UNSUPPORTED_Y || $1c0f139a1a463ce1$exports(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $d4aad8f9752f515c$var$$RegExp("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") !== null;
});
$d4aad8f9752f515c$exports = {
    BROKEN_CARET: $d4aad8f9752f515c$var$BROKEN_CARET,
    MISSED_STICKY: $d4aad8f9752f515c$var$MISSED_STICKY,
    UNSUPPORTED_Y: $d4aad8f9752f515c$var$UNSUPPORTED_Y
};





var $743bfc98b506a5f7$require$getInternalState = $033d4cca21ca5361$exports.get;
var $1bd6d24d1518b39c$exports = {};
"use strict";


// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $1bd6d24d1518b39c$var$$RegExp = $818e316f8a39904d$exports.RegExp;
$1bd6d24d1518b39c$exports = $1c0f139a1a463ce1$exports(function() {
    var re = $1bd6d24d1518b39c$var$$RegExp(".", "s");
    return !(re.dotAll && re.test("\n") && re.flags === "s");
});


var $c010815a869b49b5$exports = {};
"use strict";


// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $c010815a869b49b5$var$$RegExp = $818e316f8a39904d$exports.RegExp;
$c010815a869b49b5$exports = $1c0f139a1a463ce1$exports(function() {
    var re = $c010815a869b49b5$var$$RegExp("(?<a>b)", "g");
    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});


var $743bfc98b506a5f7$var$nativeReplace = $9b42448d053bd3c4$exports("native-string-replace", String.prototype.replace);
var $743bfc98b506a5f7$var$nativeExec = RegExp.prototype.exec;
var $743bfc98b506a5f7$var$patchedExec = $743bfc98b506a5f7$var$nativeExec;
var $743bfc98b506a5f7$var$charAt = $86d27fcf3ddb374a$exports("".charAt);
var $743bfc98b506a5f7$var$indexOf = $86d27fcf3ddb374a$exports("".indexOf);
var $743bfc98b506a5f7$var$replace = $86d27fcf3ddb374a$exports("".replace);
var $743bfc98b506a5f7$var$stringSlice = $86d27fcf3ddb374a$exports("".slice);
var $743bfc98b506a5f7$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $ba3e81ca5de34305$exports($743bfc98b506a5f7$var$nativeExec, re1, "a");
    $ba3e81ca5de34305$exports($743bfc98b506a5f7$var$nativeExec, re2, "a");
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $743bfc98b506a5f7$var$UNSUPPORTED_Y = $d4aad8f9752f515c$exports.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $743bfc98b506a5f7$var$NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
var $743bfc98b506a5f7$var$PATCH = $743bfc98b506a5f7$var$UPDATES_LAST_INDEX_WRONG || $743bfc98b506a5f7$var$NPCG_INCLUDED || $743bfc98b506a5f7$var$UNSUPPORTED_Y || $1bd6d24d1518b39c$exports || $c010815a869b49b5$exports;
if ($743bfc98b506a5f7$var$PATCH) $743bfc98b506a5f7$var$patchedExec = function exec(string) {
    var re = this;
    var state = $743bfc98b506a5f7$require$getInternalState(re);
    var str = $0f08e96df1c6e400$exports(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $ba3e81ca5de34305$exports($743bfc98b506a5f7$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $743bfc98b506a5f7$var$UNSUPPORTED_Y && re.sticky;
    var flags = $ba3e81ca5de34305$exports($3aa38f04e131e4f8$exports, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $743bfc98b506a5f7$var$replace(flags, "y", "");
        if ($743bfc98b506a5f7$var$indexOf(flags, "g") === -1) flags += "g";
        strCopy = $743bfc98b506a5f7$var$stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $743bfc98b506a5f7$var$charAt(str, re.lastIndex - 1) !== "\n")) {
            source = "(?: " + source + ")";
            strCopy = " " + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if ($743bfc98b506a5f7$var$NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    if ($743bfc98b506a5f7$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $ba3e81ca5de34305$exports($743bfc98b506a5f7$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $743bfc98b506a5f7$var$stringSlice(match.input, charsAdded);
            match[0] = $743bfc98b506a5f7$var$stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($743bfc98b506a5f7$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($743bfc98b506a5f7$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
    $ba3e81ca5de34305$exports($743bfc98b506a5f7$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $ee4937dd0bdfcee6$exports(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
$743bfc98b506a5f7$exports = $743bfc98b506a5f7$var$patchedExec;


// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$621e6bc7a2f56e42$exports({
    target: "RegExp",
    proto: true,
    forced: /./.exec !== $743bfc98b506a5f7$exports
}, {
    exec: $743bfc98b506a5f7$exports
});


"use strict";

var $99ec118ba57bfc2e$exports = {};
"use strict";







var $99ec118ba57bfc2e$var$SPECIES = $06b7b285e3a7068a$exports("species");
var $99ec118ba57bfc2e$var$RegExpPrototype = RegExp.prototype;
$99ec118ba57bfc2e$exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $06b7b285e3a7068a$exports(KEY);
    var DELEGATES_TO_SYMBOL = !$1c0f139a1a463ce1$exports(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ""[KEY](O) !== 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$1c0f139a1a463ce1$exports(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === "split") {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$99ec118ba57bfc2e$var$SPECIES] = function() {
                return re;
            };
            re.flags = "";
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]("");
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var uncurriedNativeRegExpMethod = $c0f7cba2112dcc1e$exports(/./[SYMBOL]);
        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var uncurriedNativeMethod = $c0f7cba2112dcc1e$exports(nativeMethod);
            var $exec = regexp.exec;
            if ($exec === $743bfc98b506a5f7$exports || $exec === $99ec118ba57bfc2e$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: uncurriedNativeRegExpMethod(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: uncurriedNativeMethod(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $cc8a5761541cd35d$exports(String.prototype, KEY, methods[0]);
        $cc8a5761541cd35d$exports($99ec118ba57bfc2e$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $3d5a463be44ffeea$exports($99ec118ba57bfc2e$var$RegExpPrototype[SYMBOL], "sham", true);
};








var $a4fcf085d59bf86c$exports = {};
"use strict";

var $a4fcf085d59bf86c$require$charAt = $ac5e43fd8976501e$exports.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
$a4fcf085d59bf86c$exports = function(S, index, unicode) {
    return index + (unicode ? $a4fcf085d59bf86c$require$charAt(S, index).length : 1);
};


var $a9f5a13b846be821$exports = {};
"use strict";





var $a9f5a13b846be821$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
$a9f5a13b846be821$exports = function(R, S) {
    var exec = R.exec;
    if ($da9965769ab8d492$exports(exec)) {
        var result = $ba3e81ca5de34305$exports(exec, R, S);
        if (result !== null) $c53804bbcc663539$exports(result);
        return result;
    }
    if ($f65b6a6904086b61$exports(R) === "RegExp") return $ba3e81ca5de34305$exports($743bfc98b506a5f7$exports, R, S);
    throw new $a9f5a13b846be821$var$$TypeError("RegExp#exec called on incompatible receiver");
};


// @@match logic
$99ec118ba57bfc2e$exports("match", function(MATCH, nativeMatch, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.es/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = $ce17aed0e5032df3$exports(this);
            var matcher = $896d3aa83f9594d3$exports(regexp) ? undefined : $ea805a34e9f0856a$exports(regexp, MATCH);
            return matcher ? $ba3e81ca5de34305$exports(matcher, regexp, O) : new RegExp(regexp)[MATCH]($0f08e96df1c6e400$exports(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
        function(string) {
            var rx = $c53804bbcc663539$exports(this);
            var S = $0f08e96df1c6e400$exports(string);
            var res = maybeCallNative(nativeMatch, rx, S);
            if (res.done) return res.value;
            if (!rx.global) return $a9f5a13b846be821$exports(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = $a9f5a13b846be821$exports(rx, S)) !== null){
                var matchStr = $0f08e96df1c6e400$exports(result[0]);
                A[n] = matchStr;
                if (matchStr === "") rx.lastIndex = $a4fcf085d59bf86c$exports(S, $d6e59aaba77a5f67$exports(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});


"use strict";


var $695195722cd8c925$require$FUNCTION_NAME_EXISTS = $b82122a7f3a0fd21$exports.EXISTS;

var $aa953b3cd6d43062$exports = {};
"use strict";


$aa953b3cd6d43062$exports = function(target, name, descriptor) {
    if (descriptor.get) $157fbe5a4073e8a8$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $157fbe5a4073e8a8$exports(descriptor.set, name, {
        setter: true
    });
    return $96bd28438ee2eee5$export$2d1720544b23b823(target, name, descriptor);
};


var $695195722cd8c925$var$FunctionPrototype = Function.prototype;
var $695195722cd8c925$var$functionToString = $86d27fcf3ddb374a$exports($695195722cd8c925$var$FunctionPrototype.toString);
var $695195722cd8c925$var$nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var $695195722cd8c925$var$regExpExec = $86d27fcf3ddb374a$exports($695195722cd8c925$var$nameRE.exec);
var $695195722cd8c925$var$NAME = "name";
// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if ($a934004253d25a42$exports && !$695195722cd8c925$require$FUNCTION_NAME_EXISTS) $aa953b3cd6d43062$exports($695195722cd8c925$var$FunctionPrototype, $695195722cd8c925$var$NAME, {
    configurable: true,
    get: function() {
        try {
            return $695195722cd8c925$var$regExpExec($695195722cd8c925$var$nameRE, $695195722cd8c925$var$functionToString(this))[1];
        } catch (error) {
            return "";
        }
    }
});


"use strict";
var $1ca25e06778db054$exports = {};
"use strict";

var $1ca25e06778db054$var$FunctionPrototype = Function.prototype;
var $1ca25e06778db054$var$apply = $1ca25e06778db054$var$FunctionPrototype.apply;
var $1ca25e06778db054$var$call = $1ca25e06778db054$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$1ca25e06778db054$exports = typeof Reflect == "object" && Reflect.apply || ($13cf557f31fcb3db$exports ? $1ca25e06778db054$var$call.bind($1ca25e06778db054$var$apply) : function() {
    return $1ca25e06778db054$var$call.apply($1ca25e06778db054$var$apply, arguments);
});















var $2c1a80e70d71e019$exports = {};
"use strict";


var $2c1a80e70d71e019$var$floor = Math.floor;
var $2c1a80e70d71e019$var$charAt = $86d27fcf3ddb374a$exports("".charAt);
var $2c1a80e70d71e019$var$replace = $86d27fcf3ddb374a$exports("".replace);
var $2c1a80e70d71e019$var$stringSlice = $86d27fcf3ddb374a$exports("".slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var $2c1a80e70d71e019$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $2c1a80e70d71e019$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
$2c1a80e70d71e019$exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $2c1a80e70d71e019$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $c9b4f3ef4a96c778$exports(namedCaptures);
        symbols = $2c1a80e70d71e019$var$SUBSTITUTION_SYMBOLS;
    }
    return $2c1a80e70d71e019$var$replace(replacement, symbols, function(match, ch) {
        var capture;
        switch($2c1a80e70d71e019$var$charAt(ch, 0)){
            case "$":
                return "$";
            case "&":
                return matched;
            case "`":
                return $2c1a80e70d71e019$var$stringSlice(str, 0, position);
            case "'":
                return $2c1a80e70d71e019$var$stringSlice(str, tailPos);
            case "<":
                capture = namedCaptures[$2c1a80e70d71e019$var$stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $2c1a80e70d71e019$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? $2c1a80e70d71e019$var$charAt(ch, 1) : captures[f - 1] + $2c1a80e70d71e019$var$charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? "" : capture;
    });
};




var $973427c5c04dbb8a$var$REPLACE = $06b7b285e3a7068a$exports("replace");
var $973427c5c04dbb8a$var$max = Math.max;
var $973427c5c04dbb8a$var$min = Math.min;
var $973427c5c04dbb8a$var$concat = $86d27fcf3ddb374a$exports([].concat);
var $973427c5c04dbb8a$var$push = $86d27fcf3ddb374a$exports([].push);
var $973427c5c04dbb8a$var$stringIndexOf = $86d27fcf3ddb374a$exports("".indexOf);
var $973427c5c04dbb8a$var$stringSlice = $86d27fcf3ddb374a$exports("".slice);
var $973427c5c04dbb8a$var$maybeToString = function(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $973427c5c04dbb8a$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return "a".replace(/./, "$0") === "$0";
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $973427c5c04dbb8a$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$973427c5c04dbb8a$var$REPLACE]) return /./[$973427c5c04dbb8a$var$REPLACE]("a", "$0") === "";
    return false;
}();
var $973427c5c04dbb8a$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$1c0f139a1a463ce1$exports(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: "7"
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return "".replace(re, "$<a>") !== "7";
});
// @@replace logic
$99ec118ba57bfc2e$exports("replace", function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $973427c5c04dbb8a$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $ce17aed0e5032df3$exports(this);
            var replacer = $896d3aa83f9594d3$exports(searchValue) ? undefined : $ea805a34e9f0856a$exports(searchValue, $973427c5c04dbb8a$var$REPLACE);
            return replacer ? $ba3e81ca5de34305$exports(replacer, searchValue, O, replaceValue) : $ba3e81ca5de34305$exports(nativeReplace, $0f08e96df1c6e400$exports(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $c53804bbcc663539$exports(this);
            var S = $0f08e96df1c6e400$exports(string);
            if (typeof replaceValue == "string" && $973427c5c04dbb8a$var$stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && $973427c5c04dbb8a$var$stringIndexOf(replaceValue, "$<") === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = $da9965769ab8d492$exports(replaceValue);
            if (!functionalReplace) replaceValue = $0f08e96df1c6e400$exports(replaceValue);
            var global = rx.global;
            var fullUnicode;
            if (global) {
                fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            var result;
            while(true){
                result = $a9f5a13b846be821$exports(rx, S);
                if (result === null) break;
                $973427c5c04dbb8a$var$push(results, result);
                if (!global) break;
                var matchStr = $0f08e96df1c6e400$exports(result[0]);
                if (matchStr === "") rx.lastIndex = $a4fcf085d59bf86c$exports(S, $d6e59aaba77a5f67$exports(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = "";
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $0f08e96df1c6e400$exports(result[0]);
                var position = $973427c5c04dbb8a$var$max($973427c5c04dbb8a$var$min($8abe88bfd140bd58$exports(result.index), S.length), 0);
                var captures = [];
                var replacement;
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)$973427c5c04dbb8a$var$push(captures, $973427c5c04dbb8a$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = $973427c5c04dbb8a$var$concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) $973427c5c04dbb8a$var$push(replacerArgs, namedCaptures);
                    replacement = $0f08e96df1c6e400$exports($1ca25e06778db054$exports(replaceValue, undefined, replacerArgs));
                } else replacement = $2c1a80e70d71e019$exports(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += $973427c5c04dbb8a$var$stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + $973427c5c04dbb8a$var$stringSlice(S, nextSourcePosition);
        }
    ];
}, !$973427c5c04dbb8a$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$973427c5c04dbb8a$var$REPLACE_KEEPS_$0 || $973427c5c04dbb8a$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


function $8cbbb70f74567bd0$var$getElementWindow(element) {
    if (!element || !element.ownerDocument || !element.ownerDocument.defaultView) return window;
    return element.ownerDocument.defaultView;
}
function $8cbbb70f74567bd0$var$getElementDocument(element) {
    if (!element || !element.ownerDocument) return document;
    return element.ownerDocument;
}
var $8cbbb70f74567bd0$var$cachedScrollbarWidth = null;
var $8cbbb70f74567bd0$var$cachedDevicePixelRatio = null;
if (0, (/*@__PURE__*/$parcel$interopDefault($b696bbfb437150c8$exports))) window.addEventListener("resize", function() {
    if ($8cbbb70f74567bd0$var$cachedDevicePixelRatio !== window.devicePixelRatio) {
        $8cbbb70f74567bd0$var$cachedDevicePixelRatio = window.devicePixelRatio;
        $8cbbb70f74567bd0$var$cachedScrollbarWidth = null;
    }
});
function $8cbbb70f74567bd0$var$scrollbarWidth(el) {
    if ($8cbbb70f74567bd0$var$cachedScrollbarWidth === null) {
        var document1 = $8cbbb70f74567bd0$var$getElementDocument(el);
        if (typeof document1 === "undefined") {
            $8cbbb70f74567bd0$var$cachedScrollbarWidth = 0;
            return $8cbbb70f74567bd0$var$cachedScrollbarWidth;
        }
        var body = document1.body;
        var box = document1.createElement("div");
        box.classList.add("simplebar-hide-scrollbar");
        body.appendChild(box);
        var width = box.getBoundingClientRect().right;
        body.removeChild(box);
        $8cbbb70f74567bd0$var$cachedScrollbarWidth = width;
    }
    return $8cbbb70f74567bd0$var$cachedScrollbarWidth;
}
var $8cbbb70f74567bd0$var$SimpleBar = /*#__PURE__*/ function() {
    function SimpleBar(element, options) {
        var _this = this;
        this.onScroll = function() {
            var elWindow = $8cbbb70f74567bd0$var$getElementWindow(_this.el);
            if (!_this.scrollXTicking) {
                elWindow.requestAnimationFrame(_this.scrollX);
                _this.scrollXTicking = true;
            }
            if (!_this.scrollYTicking) {
                elWindow.requestAnimationFrame(_this.scrollY);
                _this.scrollYTicking = true;
            }
        };
        this.scrollX = function() {
            if (_this.axis.x.isOverflowing) {
                _this.showScrollbar("x");
                _this.positionScrollbar("x");
            }
            _this.scrollXTicking = false;
        };
        this.scrollY = function() {
            if (_this.axis.y.isOverflowing) {
                _this.showScrollbar("y");
                _this.positionScrollbar("y");
            }
            _this.scrollYTicking = false;
        };
        this.onMouseEnter = function() {
            _this.showScrollbar("x");
            _this.showScrollbar("y");
        };
        this.onMouseMove = function(e) {
            _this.mouseX = e.clientX;
            _this.mouseY = e.clientY;
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseMoveForAxis("x");
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseMoveForAxis("y");
        };
        this.onMouseLeave = function() {
            _this.onMouseMove.cancel();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseLeaveForAxis("x");
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseLeaveForAxis("y");
            _this.mouseX = -1;
            _this.mouseY = -1;
        };
        this.onWindowResize = function() {
            // Recalculate scrollbarWidth in case it's a zoom
            _this.scrollbarWidth = _this.getScrollbarWidth();
            _this.hideNativeScrollbar();
        };
        this.hideScrollbars = function() {
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (!_this.isWithinBounds(_this.axis.y.track.rect)) {
                _this.axis.y.scrollbar.el.classList.remove(_this.classNames.visible);
                _this.axis.y.isVisible = false;
            }
            if (!_this.isWithinBounds(_this.axis.x.track.rect)) {
                _this.axis.x.scrollbar.el.classList.remove(_this.classNames.visible);
                _this.axis.x.isVisible = false;
            }
        };
        this.onPointerEvent = function(e) {
            var isWithinTrackXBounds, isWithinTrackYBounds;
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) isWithinTrackXBounds = _this.isWithinBounds(_this.axis.x.track.rect);
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) isWithinTrackYBounds = _this.isWithinBounds(_this.axis.y.track.rect);
             // If any pointer event is called on the scrollbar
            if (isWithinTrackXBounds || isWithinTrackYBounds) {
                // Preventing the event's default action stops text being
                // selectable during the drag.
                e.preventDefault(); // Prevent event leaking
                e.stopPropagation();
                if (e.type === "mousedown") {
                    if (isWithinTrackXBounds) {
                        _this.axis.x.scrollbar.rect = _this.axis.x.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.x.scrollbar.rect)) _this.onDragStart(e, "x");
                        else _this.onTrackClick(e, "x");
                    }
                    if (isWithinTrackYBounds) {
                        _this.axis.y.scrollbar.rect = _this.axis.y.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.y.scrollbar.rect)) _this.onDragStart(e, "y");
                        else _this.onTrackClick(e, "y");
                    }
                }
            }
        };
        this.drag = function(e) {
            var eventOffset;
            var track = _this.axis[_this.draggedAxis].track;
            var trackSize = track.rect[_this.axis[_this.draggedAxis].sizeAttr];
            var scrollbar = _this.axis[_this.draggedAxis].scrollbar;
            var contentSize = _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollSizeAttr];
            var hostSize = parseInt(_this.elStyles[_this.axis[_this.draggedAxis].sizeAttr], 10);
            e.preventDefault();
            e.stopPropagation();
            if (_this.draggedAxis === "y") eventOffset = e.pageY;
            else eventOffset = e.pageX;
             // Calculate how far the user's mouse is from the top/left of the scrollbar (minus the dragOffset).
            var dragPos = eventOffset - track.rect[_this.axis[_this.draggedAxis].offsetAttr] - _this.axis[_this.draggedAxis].dragOffset; // Convert the mouse position into a percentage of the scrollbar height/width.
            var dragPerc = dragPos / (trackSize - scrollbar.size); // Scroll the content by the same percentage.
            var scrollPos = dragPerc * (contentSize - hostSize); // Fix browsers inconsistency on RTL
            if (_this.draggedAxis === "x") {
                scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? scrollPos - (trackSize + scrollbar.size) : scrollPos;
                scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollPos : scrollPos;
            }
            _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollOffsetAttr] = scrollPos;
        };
        this.onEndDrag = function(e) {
            var elDocument = $8cbbb70f74567bd0$var$getElementDocument(_this.el);
            var elWindow = $8cbbb70f74567bd0$var$getElementWindow(_this.el);
            e.preventDefault();
            e.stopPropagation();
            _this.el.classList.remove(_this.classNames.dragging);
            elDocument.removeEventListener("mousemove", _this.drag, true);
            elDocument.removeEventListener("mouseup", _this.onEndDrag, true);
            _this.removePreventClickId = elWindow.setTimeout(function() {
                // Remove these asynchronously so we still suppress click events
                // generated simultaneously with mouseup.
                elDocument.removeEventListener("click", _this.preventClick, true);
                elDocument.removeEventListener("dblclick", _this.preventClick, true);
                _this.removePreventClickId = null;
            });
        };
        this.preventClick = function(e) {
            e.preventDefault();
            e.stopPropagation();
        };
        this.el = element;
        this.minScrollbarWidth = 20;
        this.options = Object.assign({}, SimpleBar.defaultOptions, options);
        this.classNames = Object.assign({}, SimpleBar.defaultOptions.classNames, this.options.classNames);
        this.axis = {
            x: {
                scrollOffsetAttr: "scrollLeft",
                sizeAttr: "width",
                scrollSizeAttr: "scrollWidth",
                offsetSizeAttr: "offsetWidth",
                offsetAttr: "left",
                overflowAttr: "overflowX",
                dragOffset: 0,
                isOverflowing: true,
                isVisible: false,
                forceVisible: false,
                track: {},
                scrollbar: {}
            },
            y: {
                scrollOffsetAttr: "scrollTop",
                sizeAttr: "height",
                scrollSizeAttr: "scrollHeight",
                offsetSizeAttr: "offsetHeight",
                offsetAttr: "top",
                overflowAttr: "overflowY",
                dragOffset: 0,
                isOverflowing: true,
                isVisible: false,
                forceVisible: false,
                track: {},
                scrollbar: {}
            }
        };
        this.removePreventClickId = null; // Don't re-instantiate over an existing one
        if (SimpleBar.instances.has(this.el)) return;
        this.recalculate = (0, (/*@__PURE__*/$parcel$interopDefault($ac15e73f2bda9226$exports)))(this.recalculate.bind(this), 64);
        this.onMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($ac15e73f2bda9226$exports)))(this.onMouseMove.bind(this), 64);
        this.hideScrollbars = (0, (/*@__PURE__*/$parcel$interopDefault($b38ef1abffe94323$exports)))(this.hideScrollbars.bind(this), this.options.timeout);
        this.onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($b38ef1abffe94323$exports)))(this.onWindowResize.bind(this), 64, {
            leading: true
        });
        SimpleBar.getRtlHelpers = (0, (/*@__PURE__*/$parcel$interopDefault($3d80b95f583ab164$exports)))(SimpleBar.getRtlHelpers);
        this.init();
    }
    /**
   * Static properties
   */ /**
   * Helper to fix browsers inconsistency on RTL:
   *  - Firefox inverts the scrollbar initial position
   *  - IE11 inverts both scrollbar position and scrolling offset
   * Directly inspired by @KingSora's OverlayScrollbars https://github.com/KingSora/OverlayScrollbars/blob/master/js/OverlayScrollbars.js#L1634
   */ SimpleBar.getRtlHelpers = function getRtlHelpers() {
        var dummyDiv = document.createElement("div");
        dummyDiv.innerHTML = '<div class="hs-dummy-scrollbar-size"><div style="height: 200%; width: 200%; margin: 10px 0;"></div></div>';
        var scrollbarDummyEl = dummyDiv.firstElementChild;
        document.body.appendChild(scrollbarDummyEl);
        var dummyContainerChild = scrollbarDummyEl.firstElementChild;
        scrollbarDummyEl.scrollLeft = 0;
        var dummyContainerOffset = SimpleBar.getOffset(scrollbarDummyEl);
        var dummyContainerChildOffset = SimpleBar.getOffset(dummyContainerChild);
        scrollbarDummyEl.scrollLeft = 999;
        var dummyContainerScrollOffsetAfterScroll = SimpleBar.getOffset(dummyContainerChild);
        return {
            // determines if the scrolling is responding with negative values
            isRtlScrollingInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left && dummyContainerChildOffset.left - dummyContainerScrollOffsetAfterScroll.left !== 0,
            // determines if the origin scrollbar position is inverted or not (positioned on left or right)
            isRtlScrollbarInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left
        };
    };
    SimpleBar.getOffset = function getOffset(el) {
        var rect = el.getBoundingClientRect();
        var elDocument = $8cbbb70f74567bd0$var$getElementDocument(el);
        var elWindow = $8cbbb70f74567bd0$var$getElementWindow(el);
        return {
            top: rect.top + (elWindow.pageYOffset || elDocument.documentElement.scrollTop),
            left: rect.left + (elWindow.pageXOffset || elDocument.documentElement.scrollLeft)
        };
    };
    var _proto = SimpleBar.prototype;
    _proto.init = function init() {
        // Save a reference to the instance, so we know this DOM node has already been instancied
        SimpleBar.instances.set(this.el, this); // We stop here on server-side
        if (0, (/*@__PURE__*/$parcel$interopDefault($b696bbfb437150c8$exports))) {
            this.initDOM();
            this.setAccessibilityAttributes();
            this.scrollbarWidth = this.getScrollbarWidth();
            this.recalculate();
            this.initListeners();
        }
    };
    _proto.initDOM = function initDOM() {
        var _this2 = this;
        // make sure this element doesn't have the elements yet
        if (Array.prototype.filter.call(this.el.children, function(child) {
            return child.classList.contains(_this2.classNames.wrapper);
        }).length) {
            // assume that element has his DOM already initiated
            this.wrapperEl = this.el.querySelector("." + this.classNames.wrapper);
            this.contentWrapperEl = this.options.scrollableNode || this.el.querySelector("." + this.classNames.contentWrapper);
            this.contentEl = this.options.contentNode || this.el.querySelector("." + this.classNames.contentEl);
            this.offsetEl = this.el.querySelector("." + this.classNames.offset);
            this.maskEl = this.el.querySelector("." + this.classNames.mask);
            this.placeholderEl = this.findChild(this.wrapperEl, "." + this.classNames.placeholder);
            this.heightAutoObserverWrapperEl = this.el.querySelector("." + this.classNames.heightAutoObserverWrapperEl);
            this.heightAutoObserverEl = this.el.querySelector("." + this.classNames.heightAutoObserverEl);
            this.axis.x.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.horizontal);
            this.axis.y.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.vertical);
        } else {
            // Prepare DOM
            this.wrapperEl = document.createElement("div");
            this.contentWrapperEl = document.createElement("div");
            this.offsetEl = document.createElement("div");
            this.maskEl = document.createElement("div");
            this.contentEl = document.createElement("div");
            this.placeholderEl = document.createElement("div");
            this.heightAutoObserverWrapperEl = document.createElement("div");
            this.heightAutoObserverEl = document.createElement("div");
            this.wrapperEl.classList.add(this.classNames.wrapper);
            this.contentWrapperEl.classList.add(this.classNames.contentWrapper);
            this.offsetEl.classList.add(this.classNames.offset);
            this.maskEl.classList.add(this.classNames.mask);
            this.contentEl.classList.add(this.classNames.contentEl);
            this.placeholderEl.classList.add(this.classNames.placeholder);
            this.heightAutoObserverWrapperEl.classList.add(this.classNames.heightAutoObserverWrapperEl);
            this.heightAutoObserverEl.classList.add(this.classNames.heightAutoObserverEl);
            while(this.el.firstChild)this.contentEl.appendChild(this.el.firstChild);
            this.contentWrapperEl.appendChild(this.contentEl);
            this.offsetEl.appendChild(this.contentWrapperEl);
            this.maskEl.appendChild(this.offsetEl);
            this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl);
            this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl);
            this.wrapperEl.appendChild(this.maskEl);
            this.wrapperEl.appendChild(this.placeholderEl);
            this.el.appendChild(this.wrapperEl);
        }
        if (!this.axis.x.track.el || !this.axis.y.track.el) {
            var track = document.createElement("div");
            var scrollbar = document.createElement("div");
            track.classList.add(this.classNames.track);
            scrollbar.classList.add(this.classNames.scrollbar);
            track.appendChild(scrollbar);
            this.axis.x.track.el = track.cloneNode(true);
            this.axis.x.track.el.classList.add(this.classNames.horizontal);
            this.axis.y.track.el = track.cloneNode(true);
            this.axis.y.track.el.classList.add(this.classNames.vertical);
            this.el.appendChild(this.axis.x.track.el);
            this.el.appendChild(this.axis.y.track.el);
        }
        this.axis.x.scrollbar.el = this.axis.x.track.el.querySelector("." + this.classNames.scrollbar);
        this.axis.y.scrollbar.el = this.axis.y.track.el.querySelector("." + this.classNames.scrollbar);
        if (!this.options.autoHide) {
            this.axis.x.scrollbar.el.classList.add(this.classNames.visible);
            this.axis.y.scrollbar.el.classList.add(this.classNames.visible);
        }
        this.el.setAttribute("data-simplebar", "init");
    };
    _proto.setAccessibilityAttributes = function setAccessibilityAttributes() {
        var ariaLabel = this.options.ariaLabel || "scrollable content";
        this.contentWrapperEl.setAttribute("tabindex", "0");
        this.contentWrapperEl.setAttribute("role", "region");
        this.contentWrapperEl.setAttribute("aria-label", ariaLabel);
    };
    _proto.initListeners = function initListeners() {
        var _this3 = this;
        var elWindow = $8cbbb70f74567bd0$var$getElementWindow(this.el); // Event listeners
        if (this.options.autoHide) this.el.addEventListener("mouseenter", this.onMouseEnter);
        [
            "mousedown",
            "click",
            "dblclick"
        ].forEach(function(e) {
            _this3.el.addEventListener(e, _this3.onPointerEvent, true);
        });
        [
            "touchstart",
            "touchend",
            "touchmove"
        ].forEach(function(e) {
            _this3.el.addEventListener(e, _this3.onPointerEvent, {
                capture: true,
                passive: true
            });
        });
        this.el.addEventListener("mousemove", this.onMouseMove);
        this.el.addEventListener("mouseleave", this.onMouseLeave);
        this.contentWrapperEl.addEventListener("scroll", this.onScroll); // Browser zoom triggers a window resize
        elWindow.addEventListener("resize", this.onWindowResize); // Hack for https://github.com/WICG/ResizeObserver/issues/38
        var resizeObserverStarted = false;
        var resizeAnimationFrameId = null;
        var resizeObserver = elWindow.ResizeObserver || (0, $31609950d3966c62$export$9caf76241ca21a11);
        this.resizeObserver = new resizeObserver(function() {
            if (!resizeObserverStarted || resizeAnimationFrameId !== null) return;
            resizeAnimationFrameId = elWindow.requestAnimationFrame(function() {
                _this3.recalculate();
                resizeAnimationFrameId = null;
            });
        });
        this.resizeObserver.observe(this.el);
        this.resizeObserver.observe(this.contentEl);
        elWindow.requestAnimationFrame(function() {
            resizeObserverStarted = true;
        }); // This is required to detect horizontal scroll. Vertical scroll only needs the resizeObserver.
        this.mutationObserver = new elWindow.MutationObserver(this.recalculate);
        this.mutationObserver.observe(this.contentEl, {
            childList: true,
            subtree: true,
            characterData: true
        });
    };
    _proto.recalculate = function recalculate() {
        var elWindow = $8cbbb70f74567bd0$var$getElementWindow(this.el);
        this.elStyles = elWindow.getComputedStyle(this.el);
        this.isRtl = this.elStyles.direction === "rtl";
        var isHeightAuto = this.heightAutoObserverEl.offsetHeight <= 1;
        var isWidthAuto = this.heightAutoObserverEl.offsetWidth <= 1;
        var contentElOffsetWidth = this.contentEl.offsetWidth;
        var contentWrapperElOffsetWidth = this.contentWrapperEl.offsetWidth;
        var elOverflowX = this.elStyles.overflowX;
        var elOverflowY = this.elStyles.overflowY;
        this.contentEl.style.padding = this.elStyles.paddingTop + " " + this.elStyles.paddingRight + " " + this.elStyles.paddingBottom + " " + this.elStyles.paddingLeft;
        this.wrapperEl.style.margin = "-" + this.elStyles.paddingTop + " -" + this.elStyles.paddingRight + " -" + this.elStyles.paddingBottom + " -" + this.elStyles.paddingLeft;
        var contentElScrollHeight = this.contentEl.scrollHeight;
        var contentElScrollWidth = this.contentEl.scrollWidth;
        this.contentWrapperEl.style.height = isHeightAuto ? "auto" : "100%"; // Determine placeholder size
        this.placeholderEl.style.width = isWidthAuto ? contentElOffsetWidth + "px" : "auto";
        this.placeholderEl.style.height = contentElScrollHeight + "px";
        var contentWrapperElOffsetHeight = this.contentWrapperEl.offsetHeight;
        this.axis.x.isOverflowing = contentElScrollWidth > contentElOffsetWidth;
        this.axis.y.isOverflowing = contentElScrollHeight > contentWrapperElOffsetHeight; // Set isOverflowing to false if user explicitely set hidden overflow
        this.axis.x.isOverflowing = elOverflowX === "hidden" ? false : this.axis.x.isOverflowing;
        this.axis.y.isOverflowing = elOverflowY === "hidden" ? false : this.axis.y.isOverflowing;
        this.axis.x.forceVisible = this.options.forceVisible === "x" || this.options.forceVisible === true;
        this.axis.y.forceVisible = this.options.forceVisible === "y" || this.options.forceVisible === true;
        this.hideNativeScrollbar(); // Set isOverflowing to false if scrollbar is not necessary (content is shorter than offset)
        var offsetForXScrollbar = this.axis.x.isOverflowing ? this.scrollbarWidth : 0;
        var offsetForYScrollbar = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
        this.axis.x.isOverflowing = this.axis.x.isOverflowing && contentElScrollWidth > contentWrapperElOffsetWidth - offsetForYScrollbar;
        this.axis.y.isOverflowing = this.axis.y.isOverflowing && contentElScrollHeight > contentWrapperElOffsetHeight - offsetForXScrollbar;
        this.axis.x.scrollbar.size = this.getScrollbarSize("x");
        this.axis.y.scrollbar.size = this.getScrollbarSize("y");
        this.axis.x.scrollbar.el.style.width = this.axis.x.scrollbar.size + "px";
        this.axis.y.scrollbar.el.style.height = this.axis.y.scrollbar.size + "px";
        this.positionScrollbar("x");
        this.positionScrollbar("y");
        this.toggleTrackVisibility("x");
        this.toggleTrackVisibility("y");
    } /**
   * Calculate scrollbar size
   */ ;
    _proto.getScrollbarSize = function getScrollbarSize(axis) {
        if (axis === void 0) axis = "y";
        if (!this.axis[axis].isOverflowing) return 0;
        var contentSize = this.contentEl[this.axis[axis].scrollSizeAttr];
        var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
        var scrollbarSize;
        var scrollbarRatio = trackSize / contentSize; // Calculate new height/position of drag handle.
        scrollbarSize = Math.max(~~(scrollbarRatio * trackSize), this.options.scrollbarMinSize);
        if (this.options.scrollbarMaxSize) scrollbarSize = Math.min(scrollbarSize, this.options.scrollbarMaxSize);
        return scrollbarSize;
    };
    _proto.positionScrollbar = function positionScrollbar(axis) {
        if (axis === void 0) axis = "y";
        if (!this.axis[axis].isOverflowing) return;
        var contentSize = this.contentWrapperEl[this.axis[axis].scrollSizeAttr];
        var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrollbar = this.axis[axis].scrollbar;
        var scrollOffset = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        scrollOffset = axis === "x" && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollOffset : scrollOffset;
        var scrollPourcent = scrollOffset / (contentSize - hostSize);
        var handleOffset = ~~((trackSize - scrollbar.size) * scrollPourcent);
        handleOffset = axis === "x" && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? handleOffset + (trackSize - scrollbar.size) : handleOffset;
        scrollbar.el.style.transform = axis === "x" ? "translate3d(" + handleOffset + "px, 0, 0)" : "translate3d(0, " + handleOffset + "px, 0)";
    };
    _proto.toggleTrackVisibility = function toggleTrackVisibility(axis) {
        if (axis === void 0) axis = "y";
        var track = this.axis[axis].track.el;
        var scrollbar = this.axis[axis].scrollbar.el;
        if (this.axis[axis].isOverflowing || this.axis[axis].forceVisible) {
            track.style.visibility = "visible";
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = "scroll";
        } else {
            track.style.visibility = "hidden";
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = "hidden";
        } // Even if forceVisible is enabled, scrollbar itself should be hidden
        if (this.axis[axis].isOverflowing) scrollbar.style.display = "block";
        else scrollbar.style.display = "none";
    };
    _proto.hideNativeScrollbar = function hideNativeScrollbar() {
        this.offsetEl.style[this.isRtl ? "left" : "right"] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
        this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
    } /**
   * On scroll event handling
   */ ;
    _proto.onMouseMoveForAxis = function onMouseMoveForAxis(axis) {
        if (axis === void 0) axis = "y";
        this.axis[axis].track.rect = this.axis[axis].track.el.getBoundingClientRect();
        this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
        var isWithinScrollbarBoundsX = this.isWithinBounds(this.axis[axis].scrollbar.rect);
        if (isWithinScrollbarBoundsX) this.axis[axis].scrollbar.el.classList.add(this.classNames.hover);
        else this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
        if (this.isWithinBounds(this.axis[axis].track.rect)) {
            this.showScrollbar(axis);
            this.axis[axis].track.el.classList.add(this.classNames.hover);
        } else this.axis[axis].track.el.classList.remove(this.classNames.hover);
    };
    _proto.onMouseLeaveForAxis = function onMouseLeaveForAxis(axis) {
        if (axis === void 0) axis = "y";
        this.axis[axis].track.el.classList.remove(this.classNames.hover);
        this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
    };
    /**
   * Show scrollbar
   */ _proto.showScrollbar = function showScrollbar(axis) {
        if (axis === void 0) axis = "y";
        var scrollbar = this.axis[axis].scrollbar.el;
        if (!this.axis[axis].isVisible) {
            scrollbar.classList.add(this.classNames.visible);
            this.axis[axis].isVisible = true;
        }
        if (this.options.autoHide) this.hideScrollbars();
    } /**
   * Hide Scrollbar
   */ ;
    /**
   * on scrollbar handle drag movement starts
   */ _proto.onDragStart = function onDragStart(e, axis) {
        if (axis === void 0) axis = "y";
        var elDocument = $8cbbb70f74567bd0$var$getElementDocument(this.el);
        var elWindow = $8cbbb70f74567bd0$var$getElementWindow(this.el);
        var scrollbar = this.axis[axis].scrollbar; // Measure how far the user's mouse is from the top of the scrollbar drag handle.
        var eventOffset = axis === "y" ? e.pageY : e.pageX;
        this.axis[axis].dragOffset = eventOffset - scrollbar.rect[this.axis[axis].offsetAttr];
        this.draggedAxis = axis;
        this.el.classList.add(this.classNames.dragging);
        elDocument.addEventListener("mousemove", this.drag, true);
        elDocument.addEventListener("mouseup", this.onEndDrag, true);
        if (this.removePreventClickId === null) {
            elDocument.addEventListener("click", this.preventClick, true);
            elDocument.addEventListener("dblclick", this.preventClick, true);
        } else {
            elWindow.clearTimeout(this.removePreventClickId);
            this.removePreventClickId = null;
        }
    } /**
   * Drag scrollbar handle
   */ ;
    _proto.onTrackClick = function onTrackClick(e, axis) {
        var _this4 = this;
        if (axis === void 0) axis = "y";
        if (!this.options.clickOnTrack) return;
        var elWindow = $8cbbb70f74567bd0$var$getElementWindow(this.el);
        this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
        var scrollbar = this.axis[axis].scrollbar;
        var scrollbarOffset = scrollbar.rect[this.axis[axis].offsetAttr];
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrolled = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        var t = axis === "y" ? this.mouseY - scrollbarOffset : this.mouseX - scrollbarOffset;
        var dir = t < 0 ? -1 : 1;
        var scrollSize = dir === -1 ? scrolled - hostSize : scrolled + hostSize;
        var scrollTo = function scrollTo() {
            if (dir === -1) {
                if (scrolled > scrollSize) {
                    var _this4$contentWrapper;
                    scrolled -= _this4.options.clickOnTrackSpeed;
                    _this4.contentWrapperEl.scrollTo((_this4$contentWrapper = {}, _this4$contentWrapper[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper));
                    elWindow.requestAnimationFrame(scrollTo);
                }
            } else if (scrolled < scrollSize) {
                var _this4$contentWrapper2;
                scrolled += _this4.options.clickOnTrackSpeed;
                _this4.contentWrapperEl.scrollTo((_this4$contentWrapper2 = {}, _this4$contentWrapper2[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper2));
                elWindow.requestAnimationFrame(scrollTo);
            }
        };
        scrollTo();
    } /**
   * Getter for content element
   */ ;
    _proto.getContentElement = function getContentElement() {
        return this.contentEl;
    } /**
   * Getter for original scrolling element
   */ ;
    _proto.getScrollElement = function getScrollElement() {
        return this.contentWrapperEl;
    };
    _proto.getScrollbarWidth = function getScrollbarWidth() {
        // Try/catch for FF 56 throwing on undefined computedStyles
        try {
            // Detect browsers supporting CSS scrollbar styling and do not calculate
            if (getComputedStyle(this.contentWrapperEl, "::-webkit-scrollbar").display === "none" || "scrollbarWidth" in document.documentElement.style || "-ms-overflow-style" in document.documentElement.style) return 0;
            else return $8cbbb70f74567bd0$var$scrollbarWidth(this.el);
        } catch (e) {
            return $8cbbb70f74567bd0$var$scrollbarWidth(this.el);
        }
    };
    _proto.removeListeners = function removeListeners() {
        var _this5 = this;
        var elWindow = $8cbbb70f74567bd0$var$getElementWindow(this.el); // Event listeners
        if (this.options.autoHide) this.el.removeEventListener("mouseenter", this.onMouseEnter);
        [
            "mousedown",
            "click",
            "dblclick"
        ].forEach(function(e) {
            _this5.el.removeEventListener(e, _this5.onPointerEvent, true);
        });
        [
            "touchstart",
            "touchend",
            "touchmove"
        ].forEach(function(e) {
            _this5.el.removeEventListener(e, _this5.onPointerEvent, {
                capture: true,
                passive: true
            });
        });
        this.el.removeEventListener("mousemove", this.onMouseMove);
        this.el.removeEventListener("mouseleave", this.onMouseLeave);
        if (this.contentWrapperEl) this.contentWrapperEl.removeEventListener("scroll", this.onScroll);
        elWindow.removeEventListener("resize", this.onWindowResize);
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
         // Cancel all debounced functions
        this.recalculate.cancel();
        this.onMouseMove.cancel();
        this.hideScrollbars.cancel();
        this.onWindowResize.cancel();
    } /**
   * UnMount mutation observer and delete SimpleBar instance from DOM element
   */ ;
    _proto.unMount = function unMount() {
        this.removeListeners();
        SimpleBar.instances.delete(this.el);
    } /**
   * Check if mouse is within bounds
   */ ;
    _proto.isWithinBounds = function isWithinBounds(bbox) {
        return this.mouseX >= bbox.left && this.mouseX <= bbox.left + bbox.width && this.mouseY >= bbox.top && this.mouseY <= bbox.top + bbox.height;
    } /**
   * Find element children matches query
   */ ;
    _proto.findChild = function findChild(el, query) {
        var matches = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
        return Array.prototype.filter.call(el.children, function(child) {
            return matches.call(child, query);
        })[0];
    };
    return SimpleBar;
}();
$8cbbb70f74567bd0$var$SimpleBar.defaultOptions = {
    autoHide: true,
    forceVisible: false,
    clickOnTrack: true,
    clickOnTrackSpeed: 40,
    classNames: {
        contentEl: "simplebar-content",
        contentWrapper: "simplebar-content-wrapper",
        offset: "simplebar-offset",
        mask: "simplebar-mask",
        wrapper: "simplebar-wrapper",
        placeholder: "simplebar-placeholder",
        scrollbar: "simplebar-scrollbar",
        track: "simplebar-track",
        heightAutoObserverWrapperEl: "simplebar-height-auto-observer-wrapper",
        heightAutoObserverEl: "simplebar-height-auto-observer",
        visible: "simplebar-visible",
        horizontal: "simplebar-horizontal",
        vertical: "simplebar-vertical",
        hover: "simplebar-hover",
        dragging: "simplebar-dragging"
    },
    scrollbarMinSize: 25,
    scrollbarMaxSize: 0,
    timeout: 1000
};
$8cbbb70f74567bd0$var$SimpleBar.instances = new WeakMap();
var $8cbbb70f74567bd0$export$2e2bcd8739ae039 = $8cbbb70f74567bd0$var$SimpleBar;


function $b76fad9a3dd6491d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b76fad9a3dd6491d$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b76fad9a3dd6491d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b76fad9a3dd6491d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b76fad9a3dd6491d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b76fad9a3dd6491d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b76fad9a3dd6491d$var$_extends() {
    $b76fad9a3dd6491d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b76fad9a3dd6491d$var$_extends.apply(this, arguments);
}
function $b76fad9a3dd6491d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b76fad9a3dd6491d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b76fad9a3dd6491d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $b76fad9a3dd6491d$var$_excluded = [
    "children",
    "scrollableNodeProps",
    "tag"
];
/* Deprecated
 * Hardcore this here until we can safely deprecated it.
 * Helper function to retrieve options from element attributes
 */ var $b76fad9a3dd6491d$var$getOptions = function getOptions(obj) {
    var options = Array.prototype.reduce.call(obj, function(acc, attribute) {
        var option = attribute.name.match(/data-simplebar-(.+)/);
        if (option) {
            var key = option[1].replace(/\W+(.)/g, function(x, chr) {
                return chr.toUpperCase();
            });
            switch(attribute.value){
                case "true":
                    acc[key] = true;
                    break;
                case "false":
                    acc[key] = false;
                    break;
                case undefined:
                    acc[key] = true;
                    break;
                default:
                    acc[key] = attribute.value;
            }
        }
        return acc;
    }, {});
    return options;
};
var $b76fad9a3dd6491d$var$SimpleBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).forwardRef(function(_ref, ref) {
    var children = _ref.children, _ref$scrollableNodePr = _ref.scrollableNodeProps, scrollableNodeProps = _ref$scrollableNodePr === void 0 ? {} : _ref$scrollableNodePr, _ref$tag = _ref.tag, tag = _ref$tag === void 0 ? "div" : _ref$tag, otherProps = $b76fad9a3dd6491d$var$_objectWithoutProperties(_ref, $b76fad9a3dd6491d$var$_excluded);
    var RootTag = tag;
    var instance;
    var scrollableNodeRef = (0, $9nZCP.useRef)();
    var elRef = (0, $9nZCP.useRef)();
    var contentNodeRef = (0, $9nZCP.useRef)();
    var options = {};
    var rest = {};
    var deprecatedOptions = [];
    Object.keys(otherProps).forEach(function(key) {
        if (Object.prototype.hasOwnProperty.call((0, $8cbbb70f74567bd0$export$2e2bcd8739ae039).defaultOptions, key)) options[key] = otherProps[key];
        else if (key.match(/data-simplebar-(.+)/) && key !== "data-simplebar-direction") deprecatedOptions.push({
            name: key,
            value: otherProps[key]
        });
        else rest[key] = otherProps[key];
    });
    if (deprecatedOptions.length) console.warn("simplebar-react: this way of passing options is deprecated. Pass it like normal props instead:\n        'data-simplebar-auto-hide=\"false\"' \u2014> 'autoHide=\"false\"'\n      ");
    (0, $9nZCP.useEffect)(function() {
        scrollableNodeRef = scrollableNodeProps.ref || scrollableNodeRef;
        if (elRef.current) {
            instance = new (0, $8cbbb70f74567bd0$export$2e2bcd8739ae039)(elRef.current, $b76fad9a3dd6491d$var$_objectSpread2($b76fad9a3dd6491d$var$_objectSpread2($b76fad9a3dd6491d$var$_objectSpread2($b76fad9a3dd6491d$var$_objectSpread2({}, $b76fad9a3dd6491d$var$getOptions(deprecatedOptions)), options), scrollableNodeRef && {
                scrollableNode: scrollableNodeRef.current
            }), contentNodeRef.current && {
                contentNode: contentNodeRef.current
            }));
            if (typeof ref === "function") ref(instance);
            else if (ref) ref.current = instance;
        }
        return function() {
            instance.unMount();
            instance = null;
            if (typeof ref === "function") ref(null);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement(RootTag, $b76fad9a3dd6491d$var$_extends({
        ref: elRef,
        "data-simplebar": true
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-height-auto-observer-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-height-auto-observer"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-mask"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-offset"
    }, typeof children === "function" ? children({
        scrollableNodeRef: scrollableNodeRef,
        contentNodeRef: contentNodeRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", $b76fad9a3dd6491d$var$_extends({}, scrollableNodeProps, {
        className: "simplebar-content-wrapper".concat(scrollableNodeProps.className ? " ".concat(scrollableNodeProps.className) : "")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-content"
    }, children)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-placeholder"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-track simplebar-horizontal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-scrollbar"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-track simplebar-vertical"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-scrollbar"
    })));
});
$b76fad9a3dd6491d$var$SimpleBar.displayName = "SimpleBar";
$b76fad9a3dd6491d$var$SimpleBar.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($0287d6dd1c5d0193$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($0287d6dd1c5d0193$exports))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($0287d6dd1c5d0193$exports))).func
    ]),
    scrollableNodeProps: (0, (/*@__PURE__*/$parcel$interopDefault($0287d6dd1c5d0193$exports))).object,
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($0287d6dd1c5d0193$exports))).string
};
var $b76fad9a3dd6491d$export$2e2bcd8739ae039 = $b76fad9a3dd6491d$var$SimpleBar;



var $95dd3fa9eb45140c$exports = {};

$parcel$defineInteropFlag($95dd3fa9eb45140c$exports);

$parcel$export($95dd3fa9eb45140c$exports, "default", function () { return $95dd3fa9eb45140c$export$2e2bcd8739ae039; });
function $41b38629d66853aa$var$t(t) {
    return "object" == typeof t && null != t && 1 === t.nodeType;
}
function $41b38629d66853aa$var$e(t, e) {
    return (!e || "hidden" !== t) && "visible" !== t && "clip" !== t;
}
function $41b38629d66853aa$var$n(t, n) {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        var r = getComputedStyle(t, null);
        return $41b38629d66853aa$var$e(r.overflowY, n) || $41b38629d66853aa$var$e(r.overflowX, n) || function(t) {
            var e = function(t) {
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            }(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        }(t);
    }
    return !1;
}
function $41b38629d66853aa$var$r(t, e, n, r, i, o, l, d) {
    return o < t && l > e || o > t && l < e ? 0 : o <= t && d <= n || l >= e && d >= n ? o - t - r : l > e && d < n || o < t && d > n ? l - e + i : 0;
}
var $41b38629d66853aa$export$2e2bcd8739ae039 = function(e, i) {
    var o = window, l = i.scrollMode, d = i.block, f = i.inline, h = i.boundary, u = i.skipOverflowHiddenElements, s = "function" == typeof h ? h : function(t) {
        return t !== h;
    };
    if (!$41b38629d66853aa$var$t(e)) throw new TypeError("Invalid target");
    for(var a, c, g = document.scrollingElement || document.documentElement, p = [], m = e; $41b38629d66853aa$var$t(m) && s(m);){
        if ((m = null == (c = (a = m).parentElement) ? a.getRootNode().host || null : c) === g) {
            p.push(m);
            break;
        }
        null != m && m === document.body && $41b38629d66853aa$var$n(m) && !$41b38629d66853aa$var$n(document.documentElement) || null != m && $41b38629d66853aa$var$n(m, u) && p.push(m);
    }
    for(var w = o.visualViewport ? o.visualViewport.width : innerWidth, v = o.visualViewport ? o.visualViewport.height : innerHeight, W = window.scrollX || pageXOffset, H = window.scrollY || pageYOffset, b = e.getBoundingClientRect(), y = b.height, E = b.width, M = b.top, V = b.right, x = b.bottom, I = b.left, C = "start" === d || "nearest" === d ? M : "end" === d ? x : M + y / 2, R = "center" === f ? I + E / 2 : "end" === f ? V : I, T = [], k = 0; k < p.length; k++){
        var B = p[k], D = B.getBoundingClientRect(), O = D.height, X = D.width, Y = D.top, L = D.right, S = D.bottom, j = D.left;
        if ("if-needed" === l && M >= 0 && I >= 0 && x <= v && V <= w && M >= Y && x <= S && I >= j && V <= L) return T;
        var N = getComputedStyle(B), q = parseInt(N.borderLeftWidth, 10), z = parseInt(N.borderTopWidth, 10), A = parseInt(N.borderRightWidth, 10), F = parseInt(N.borderBottomWidth, 10), G = 0, J = 0, K = "offsetWidth" in B ? B.offsetWidth - B.clientWidth - q - A : 0, P = "offsetHeight" in B ? B.offsetHeight - B.clientHeight - z - F : 0, Q = "offsetWidth" in B ? 0 === B.offsetWidth ? 0 : X / B.offsetWidth : 0, U = "offsetHeight" in B ? 0 === B.offsetHeight ? 0 : O / B.offsetHeight : 0;
        if (g === B) G = "start" === d ? C : "end" === d ? C - v : "nearest" === d ? $41b38629d66853aa$var$r(H, H + v, v, z, F, H + C, H + C + y, y) : C - v / 2, J = "start" === f ? R : "center" === f ? R - w / 2 : "end" === f ? R - w : $41b38629d66853aa$var$r(W, W + w, w, q, A, W + R, W + R + E, E), G = Math.max(0, G + H), J = Math.max(0, J + W);
        else {
            G = "start" === d ? C - Y - z : "end" === d ? C - S + F + P : "nearest" === d ? $41b38629d66853aa$var$r(Y, S, O, z, F + P, C, C + y, y) : C - (Y + O / 2) + P / 2, J = "start" === f ? R - j - q : "center" === f ? R - (j + X / 2) + K / 2 : "end" === f ? R - L + A + K : $41b38629d66853aa$var$r(j, L, X, q, A + K, R, R + E, E);
            var Z = B.scrollLeft, $ = B.scrollTop;
            C += $ - (G = Math.max(0, Math.min($ + G / U, B.scrollHeight - O / U + P))), R += Z - (J = Math.max(0, Math.min(Z + J / Q, B.scrollWidth - X / Q + K)));
        }
        T.push({
            el: B,
            top: G,
            left: J
        });
    }
    return T;
};


function $cf968986cd650ffb$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $cf968986cd650ffb$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = "auto";
    var canSmoothScroll = "scrollBehavior" in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $cf968986cd650ffb$var$getOptions(options) {
    if (options === false) return {
        block: "end",
        inline: "nearest"
    };
    if ($cf968986cd650ffb$var$isOptionsObject(options)) return options;
    return {
        block: "start",
        inline: "nearest"
    };
}
function $cf968986cd650ffb$var$scrollIntoView(target, options) {
    var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
    if ($cf968986cd650ffb$var$isOptionsObject(options) && typeof options.behavior === "function") return options.behavior(isTargetAttached ? (0, $41b38629d66853aa$export$2e2bcd8739ae039)(target, options) : []);
    if (!isTargetAttached) return;
    var computeOptions = $cf968986cd650ffb$var$getOptions(options);
    return $cf968986cd650ffb$var$defaultBehavior((0, $41b38629d66853aa$export$2e2bcd8739ae039)(target, computeOptions), computeOptions.behavior);
}
var $cf968986cd650ffb$export$2e2bcd8739ae039 = $cf968986cd650ffb$var$scrollIntoView;


var $95dd3fa9eb45140c$var$memoizedNow;
var $95dd3fa9eb45140c$var$now = function now() {
    if (!$95dd3fa9eb45140c$var$memoizedNow) $95dd3fa9eb45140c$var$memoizedNow = "performance" in window ? performance.now.bind(performance) : Date.now;
    return $95dd3fa9eb45140c$var$memoizedNow();
};
function $95dd3fa9eb45140c$var$step(context) {
    var time = $95dd3fa9eb45140c$var$now();
    var elapsed = Math.min((time - context.startTime) / context.duration, 1);
    var value = context.ease(elapsed);
    var currentX = context.startX + (context.x - context.startX) * value;
    var currentY = context.startY + (context.y - context.startY) * value;
    context.method(currentX, currentY);
    if (currentX !== context.x || currentY !== context.y) requestAnimationFrame(function() {
        return $95dd3fa9eb45140c$var$step(context);
    });
    else context.cb();
}
function $95dd3fa9eb45140c$var$smoothScroll(el, x, y, duration, ease, cb) {
    if (duration === void 0) duration = 600;
    if (ease === void 0) ease = function ease(t) {
        return 1 + --t * t * t * t * t;
    };
    var scrollable;
    var startX;
    var startY;
    var method;
    scrollable = el;
    startX = el.scrollLeft;
    startY = el.scrollTop;
    method = function method(x, y) {
        el.scrollLeft = Math.ceil(x);
        el.scrollTop = Math.ceil(y);
    };
    $95dd3fa9eb45140c$var$step({
        scrollable: scrollable,
        method: method,
        startTime: $95dd3fa9eb45140c$var$now(),
        startX: startX,
        startY: startY,
        x: x,
        y: y,
        duration: duration,
        ease: ease,
        cb: cb
    });
}
var $95dd3fa9eb45140c$var$shouldSmoothScroll = function shouldSmoothScroll(options) {
    return options && !options.behavior || options.behavior === "smooth";
};
function $95dd3fa9eb45140c$var$scroll(target, options) {
    var overrides = options || {};
    if ($95dd3fa9eb45140c$var$shouldSmoothScroll(overrides)) return (0, $cf968986cd650ffb$export$2e2bcd8739ae039)(target, {
        block: overrides.block,
        inline: overrides.inline,
        scrollMode: overrides.scrollMode,
        boundary: overrides.boundary,
        behavior: function behavior(actions) {
            return Promise.all(actions.reduce(function(results, _ref) {
                var el = _ref.el, left = _ref.left, top = _ref.top;
                var startLeft = el.scrollLeft;
                var startTop = el.scrollTop;
                if (startLeft === left && startTop === top) return results;
                return [].concat(results, [
                    new Promise(function(resolve) {
                        return $95dd3fa9eb45140c$var$smoothScroll(el, left, top, overrides.duration, overrides.ease, function() {
                            return resolve({
                                el: el,
                                left: [
                                    startLeft,
                                    left
                                ],
                                top: [
                                    startTop,
                                    top
                                ]
                            });
                        });
                    })
                ]);
            }, []));
        }
    });
    return Promise.resolve((0, $cf968986cd650ffb$export$2e2bcd8739ae039)(target, options));
}
var $95dd3fa9eb45140c$var$smoothScrollIntoView = $95dd3fa9eb45140c$var$scroll;
var $95dd3fa9eb45140c$export$2e2bcd8739ae039 = $95dd3fa9eb45140c$var$smoothScrollIntoView;


var $8fc1eb2c15e0076e$exports = {};

$parcel$defineInteropFlag($8fc1eb2c15e0076e$exports);

$parcel$export($8fc1eb2c15e0076e$exports, "default", function () { return $8fc1eb2c15e0076e$export$2e2bcd8739ae039; });
$parcel$export($8fc1eb2c15e0076e$exports, "Range", function () { return $1333fa204e4662b3$export$2e2bcd8739ae039; });
$parcel$export($8fc1eb2c15e0076e$exports, "Handle", function () { return $49e439059d842d52$export$2e2bcd8739ae039; });
$parcel$export($8fc1eb2c15e0076e$exports, "createSliderWithTooltip", function () { return $63d3d36722fc19de$export$2e2bcd8739ae039; });
$parcel$export($8fc1eb2c15e0076e$exports, "SliderTooltip", function () { return $f7939232b8700452$export$2e2bcd8739ae039; });
function $b97407360a5cbf3c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b97407360a5cbf3c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b97407360a5cbf3c$export$2e2bcd8739ae039(o);
}



function $49b43895e7ccc5c1$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $20af1ec26fc848f1$export$2e2bcd8739ae039(t) {
    var i = (0, $49b43895e7ccc5c1$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(i) ? i : String(i);
}


function $0e91f7da3580de3e$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $20af1ec26fc848f1$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $835511f338e067d8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $835511f338e067d8$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $835511f338e067d8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $835511f338e067d8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $760550b9da8dc9e1$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



function $e2992e4fbdf715a4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $20af1ec26fc848f1$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $e2992e4fbdf715a4$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $e2992e4fbdf715a4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e2992e4fbdf715a4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}


function $228dd0b0569f35b6$export$2e2bcd8739ae039(o, p) {
    $228dd0b0569f35b6$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $228dd0b0569f35b6$export$2e2bcd8739ae039(o, p);
}


function $e9432b2dc1794836$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $228dd0b0569f35b6$export$2e2bcd8739ae039)(subClass, superClass);
}


function $53b14ef86235fdcb$export$2e2bcd8739ae039(o) {
    $53b14ef86235fdcb$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $53b14ef86235fdcb$export$2e2bcd8739ae039(o);
}


function $111ef934f90d625c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($111ef934f90d625c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $940bcf9a64d33faf$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $50a2c7dbcf58753e$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(self);
}


function $d9bb25c2822f374b$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $111ef934f90d625c$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $53b14ef86235fdcb$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $53b14ef86235fdcb$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $50a2c7dbcf58753e$export$2e2bcd8739ae039)(this, result);
    };
}



var $9nZCP = parcelRequire("9nZCP");
/* eslint-disable no-console */ var $c196facde74adb39$var$warned = {};
var $c196facde74adb39$var$preWarningFns = [];
var $c196facde74adb39$export$61616f168f0e5a05 = function preMessage(fn) {
    $c196facde74adb39$var$preWarningFns.push(fn);
};
function $c196facde74adb39$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $c196facde74adb39$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $c196facde74adb39$export$60eef1277fe463e4() {
    $c196facde74adb39$var$warned = {};
}
function $c196facde74adb39$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$c196facde74adb39$var$warned[message]) {
        method(false, message);
        $c196facde74adb39$var$warned[message] = true;
    }
}
function $c196facde74adb39$export$82934adf09101657(valid, message) {
    $c196facde74adb39$export$848feb93d8f32b9b($c196facde74adb39$export$491112666e282270, valid, message);
}
function $c196facde74adb39$export$89ff31684837bbbf(valid, message) {
    $c196facde74adb39$export$848feb93d8f32b9b($c196facde74adb39$export$a92e4c44d367d0af, valid, message);
}
$c196facde74adb39$export$82934adf09101657.preMessage = $c196facde74adb39$export$61616f168f0e5a05;
$c196facde74adb39$export$82934adf09101657.resetWarned = $c196facde74adb39$export$60eef1277fe463e4;
$c196facde74adb39$export$82934adf09101657.noteOnce = $c196facde74adb39$export$89ff31684837bbbf;
var $c196facde74adb39$export$2e2bcd8739ae039 /* eslint-enable */  = $c196facde74adb39$export$82934adf09101657;





var $9nZCP = parcelRequire("9nZCP");
var $50b2e2071653f08e$var$Track = function Track(props) {
    var _ref, _ref2;
    var className = props.className, included = props.included, vertical = props.vertical, style = props.style;
    var length = props.length, offset = props.offset, reverse = props.reverse;
    if (length < 0) {
        reverse = !reverse;
        length = Math.abs(length);
        offset = 100 - offset;
    }
    var positonStyle = vertical ? (_ref = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref, reverse ? "top" : "bottom", "".concat(offset, "%")), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref, reverse ? "bottom" : "top", "auto"), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref, "height", "".concat(length, "%")), _ref) : (_ref2 = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref2, reverse ? "right" : "left", "".concat(offset, "%")), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref2, reverse ? "left" : "right", "auto"), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref2, "width", "".concat(length, "%")), _ref2);
    var elStyle = (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, style), positonStyle);
    return included ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: className,
        style: elStyle
    }) : null;
};
var $50b2e2071653f08e$export$2e2bcd8739ae039 = $50b2e2071653f08e$var$Track;


function $d3700a4be188dae5$export$2e2bcd8739ae039() {
    $d3700a4be188dae5$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d3700a4be188dae5$export$2e2bcd8739ae039.apply(this, arguments);
}


function $94c08baf51322beb$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $d757eeb1353aad21$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $94c08baf51322beb$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}




function $82c21e0f607951b1$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $4fd1e7788390d081$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $82c21e0f607951b1$export$2e2bcd8739ae039)(arr);
}


function $d13b6ea07b6676dc$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $972a974728b0ca3d$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $82c21e0f607951b1$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $82c21e0f607951b1$export$2e2bcd8739ae039)(o, minLen);
}


function $08898464f1376a72$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $513d655c75612b28$export$2e2bcd8739ae039(arr) {
    return (0, $4fd1e7788390d081$export$2e2bcd8739ae039)(arr) || (0, $d13b6ea07b6676dc$export$2e2bcd8739ae039)(arr) || (0, $972a974728b0ca3d$export$2e2bcd8739ae039)(arr) || (0, $08898464f1376a72$export$2e2bcd8739ae039)();
}





function $c24f65a6bf43193c$export$2e2bcd8739ae039(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $53b14ef86235fdcb$export$2e2bcd8739ae039)(object);
        if (object === null) break;
    }
    return object;
}


function $64b283de2d7de7c1$export$2e2bcd8739ae039() {
    if (typeof Reflect !== "undefined" && Reflect.get) $64b283de2d7de7c1$export$2e2bcd8739ae039 = Reflect.get.bind();
    else $64b283de2d7de7c1$export$2e2bcd8739ae039 = function _get(target, property, receiver) {
        var base = (0, $c24f65a6bf43193c$export$2e2bcd8739ae039)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(arguments.length < 3 ? target : receiver);
        return desc.value;
    };
    return $64b283de2d7de7c1$export$2e2bcd8739ae039.apply(this, arguments);
}






var $9nZCP = parcelRequire("9nZCP");

function $2c9c50b08e6db3ce$export$2e2bcd8739ae039(target, eventType, cb, option) {
    /* eslint camelcase: 2 */ var callback = (0, (/*@__PURE__*/$parcel$interopDefault($06928105ffc753ea$exports))).unstable_batchedUpdates ? function run(e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($06928105ffc753ea$exports))).unstable_batchedUpdates(cb, e);
    } : cb;
    if (target !== null && target !== void 0 && target.addEventListener) target.addEventListener(eventType, callback, option);
    return {
        remove: function remove() {
            if (target !== null && target !== void 0 && target.removeEventListener) target.removeEventListener(eventType, callback, option);
        }
    };
}


var $81466bf476712888$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $81466bf476712888$exports) {
        classNames.default = classNames;
        $81466bf476712888$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();






var $9nZCP = parcelRequire("9nZCP");


var $0c53fbe1c5ac04a8$var$calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
    (0, $c196facde74adb39$export$2e2bcd8739ae039)(dots ? step > 0 : true, "`Slider[step]` should be a positive number in order to make Slider[dots] work.");
    var points = Object.keys(marks).map(parseFloat).sort(function(a, b) {
        return a - b;
    });
    if (dots && step) {
        for(var i = min; i <= max; i += step)if (points.indexOf(i) === -1) points.push(i);
    }
    return points;
};
var $0c53fbe1c5ac04a8$var$Steps = function Steps(_ref) {
    var prefixCls = _ref.prefixCls, vertical = _ref.vertical, reverse = _ref.reverse, marks = _ref.marks, dots = _ref.dots, step = _ref.step, included = _ref.included, lowerBound = _ref.lowerBound, upperBound = _ref.upperBound, max = _ref.max, min = _ref.min, dotStyle = _ref.dotStyle, activeDotStyle = _ref.activeDotStyle;
    var range = max - min;
    var elements = $0c53fbe1c5ac04a8$var$calcPoints(vertical, marks, dots, step, min, max).map(function(point) {
        var _classNames;
        var offset = "".concat(Math.abs(point - min) / range * 100, "%");
        var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
        var style = vertical ? (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, dotStyle), {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)({}, reverse ? "top" : "bottom", offset)) : (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, dotStyle), {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)({}, reverse ? "right" : "left", offset));
        if (isActived) style = (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, style), activeDotStyle);
        var pointClassName = (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))((_classNames = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-dot"), true), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-dot-active"), isActived), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-dot-reverse"), reverse), _classNames));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("span", {
            className: pointClassName,
            style: style,
            key: point
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "".concat(prefixCls, "-step")
    }, elements);
};
var $0c53fbe1c5ac04a8$export$2e2bcd8739ae039 = $0c53fbe1c5ac04a8$var$Steps;






var $9nZCP = parcelRequire("9nZCP");

var $d3bad4f6579d6632$var$Marks = function Marks(_ref) {
    var className = _ref.className, vertical = _ref.vertical, reverse = _ref.reverse, marks = _ref.marks, included = _ref.included, upperBound = _ref.upperBound, lowerBound = _ref.lowerBound, max = _ref.max, min = _ref.min, onClickLabel = _ref.onClickLabel;
    var marksKeys = Object.keys(marks);
    var range = max - min;
    var elements = marksKeys.map(parseFloat).sort(function(a, b) {
        return a - b;
    }).map(function(point) {
        var _classNames;
        var markPoint = marks[point];
        var markPointIsObject = (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(markPoint) === "object" && !/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).isValidElement(markPoint);
        var markLabel = markPointIsObject ? markPoint.label : markPoint;
        if (!markLabel && markLabel !== 0) return null;
        var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
        var markClassName = (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))((_classNames = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(className, "-text"), true), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(className, "-text-active"), isActive), _classNames));
        var bottomStyle = (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)({
            marginBottom: "-50%"
        }, reverse ? "top" : "bottom", "".concat((point - min) / range * 100, "%"));
        var leftStyle = (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)({
            transform: "translateX(".concat(reverse ? "50%" : "-50%", ")"),
            msTransform: "translateX(".concat(reverse ? "50%" : "-50%", ")")
        }, reverse ? "right" : "left", "".concat((point - min) / range * 100, "%"));
        var style = vertical ? bottomStyle : leftStyle;
        var markStyle = markPointIsObject ? (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, style), markPoint.style) : style;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("span", {
            className: markClassName,
            style: markStyle,
            key: point,
            onMouseDown: function onMouseDown(e) {
                return onClickLabel(e, point);
            },
            onTouchStart: function onTouchStart(e) {
                return onClickLabel(e, point);
            }
        }, markLabel);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: className
    }, elements);
};
var $d3bad4f6579d6632$export$2e2bcd8739ae039 = $d3bad4f6579d6632$var$Marks;











var $9nZCP = parcelRequire("9nZCP");


var $49e439059d842d52$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $e9432b2dc1794836$export$2e2bcd8739ae039)(Handle, _React$Component);
    var _super = (0, $d9bb25c2822f374b$export$2e2bcd8739ae039)(Handle);
    function Handle() {
        var _this;
        (0, $760550b9da8dc9e1$export$2e2bcd8739ae039)(this, Handle);
        _this = _super.apply(this, arguments);
        _this.state = {
            clickFocused: false
        };
        _this.setHandleRef = function(node) {
            _this.handle = node;
        };
        _this.handleMouseUp = function() {
            if (document.activeElement === _this.handle) _this.setClickFocus(true);
        };
        _this.handleMouseDown = function(e) {
            // avoid selecting text during drag
            // https://github.com/ant-design/ant-design/issues/25010
            e.preventDefault(); // fix https://github.com/ant-design/ant-design/issues/15324
            _this.focus();
        };
        _this.handleBlur = function() {
            _this.setClickFocus(false);
        };
        _this.handleKeyDown = function() {
            _this.setClickFocus(false);
        };
        return _this;
    }
    (0, $e2992e4fbdf715a4$export$2e2bcd8739ae039)(Handle, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // mouseup won't trigger if mouse moved out of handle,
                // so we listen on document here.
                this.onMouseUpListener = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(document, "mouseup", this.handleMouseUp);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.onMouseUpListener) this.onMouseUpListener.remove();
            }
        },
        {
            key: "setClickFocus",
            value: function setClickFocus(focused) {
                this.setState({
                    clickFocused: focused
                });
            }
        },
        {
            key: "clickFocus",
            value: function clickFocus() {
                this.setClickFocus(true);
                this.focus();
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.handle.focus();
            }
        },
        {
            key: "blur",
            value: function blur() {
                this.handle.blur();
            }
        },
        {
            key: "render",
            value: function render() {
                var _ref, _ref2;
                var _this$props = this.props, prefixCls = _this$props.prefixCls, vertical = _this$props.vertical, reverse = _this$props.reverse, offset = _this$props.offset, style = _this$props.style, disabled = _this$props.disabled, min = _this$props.min, max = _this$props.max, value = _this$props.value, tabIndex = _this$props.tabIndex, ariaLabel = _this$props.ariaLabel, ariaLabelledBy = _this$props.ariaLabelledBy, ariaValueTextFormatter = _this$props.ariaValueTextFormatter, restProps = (0, $d757eeb1353aad21$export$2e2bcd8739ae039)(_this$props, [
                    "prefixCls",
                    "vertical",
                    "reverse",
                    "offset",
                    "style",
                    "disabled",
                    "min",
                    "max",
                    "value",
                    "tabIndex",
                    "ariaLabel",
                    "ariaLabelledBy",
                    "ariaValueTextFormatter"
                ]);
                var className = (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))(this.props.className, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-handle-click-focused"), this.state.clickFocused));
                var positionStyle = vertical ? (_ref = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref, reverse ? "top" : "bottom", "".concat(offset, "%")), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref, reverse ? "bottom" : "top", "auto"), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref, "transform", reverse ? null : "translateY(+50%)"), _ref) : (_ref2 = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref2, reverse ? "right" : "left", "".concat(offset, "%")), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref2, reverse ? "left" : "right", "auto"), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref2, "transform", "translateX(".concat(reverse ? "+" : "-", "50%)")), _ref2);
                var elStyle = (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, style), positionStyle);
                var mergedTabIndex = tabIndex || 0;
                if (disabled || tabIndex === null) mergedTabIndex = null;
                var ariaValueText;
                if (ariaValueTextFormatter) ariaValueText = ariaValueTextFormatter(value);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({
                    ref: this.setHandleRef,
                    tabIndex: mergedTabIndex
                }, restProps, {
                    className: className,
                    style: elStyle,
                    onBlur: this.handleBlur,
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleMouseDown // aria attribute
                    ,
                    role: "slider",
                    "aria-valuemin": min,
                    "aria-valuemax": max,
                    "aria-valuenow": value,
                    "aria-disabled": !!disabled,
                    "aria-label": ariaLabel,
                    "aria-labelledby": ariaLabelledBy,
                    "aria-valuetext": ariaValueText
                }));
            }
        }
    ]);
    return Handle;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).Component);




/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $d3a8d9285e373915$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $d3a8d9285e373915$var$KeyCode.F1 && keyCode <= $d3a8d9285e373915$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $d3a8d9285e373915$var$KeyCode.ALT:
            case $d3a8d9285e373915$var$KeyCode.CAPS_LOCK:
            case $d3a8d9285e373915$var$KeyCode.CONTEXT_MENU:
            case $d3a8d9285e373915$var$KeyCode.CTRL:
            case $d3a8d9285e373915$var$KeyCode.DOWN:
            case $d3a8d9285e373915$var$KeyCode.END:
            case $d3a8d9285e373915$var$KeyCode.ESC:
            case $d3a8d9285e373915$var$KeyCode.HOME:
            case $d3a8d9285e373915$var$KeyCode.INSERT:
            case $d3a8d9285e373915$var$KeyCode.LEFT:
            case $d3a8d9285e373915$var$KeyCode.MAC_FF_META:
            case $d3a8d9285e373915$var$KeyCode.META:
            case $d3a8d9285e373915$var$KeyCode.NUMLOCK:
            case $d3a8d9285e373915$var$KeyCode.NUM_CENTER:
            case $d3a8d9285e373915$var$KeyCode.PAGE_DOWN:
            case $d3a8d9285e373915$var$KeyCode.PAGE_UP:
            case $d3a8d9285e373915$var$KeyCode.PAUSE:
            case $d3a8d9285e373915$var$KeyCode.PRINT_SCREEN:
            case $d3a8d9285e373915$var$KeyCode.RIGHT:
            case $d3a8d9285e373915$var$KeyCode.SHIFT:
            case $d3a8d9285e373915$var$KeyCode.UP:
            case $d3a8d9285e373915$var$KeyCode.WIN_KEY:
            case $d3a8d9285e373915$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $d3a8d9285e373915$var$KeyCode.ZERO && keyCode <= $d3a8d9285e373915$var$KeyCode.NINE) return true;
        if (keyCode >= $d3a8d9285e373915$var$KeyCode.NUM_ZERO && keyCode <= $d3a8d9285e373915$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $d3a8d9285e373915$var$KeyCode.A && keyCode <= $d3a8d9285e373915$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf("WebKit") !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $d3a8d9285e373915$var$KeyCode.SPACE:
            case $d3a8d9285e373915$var$KeyCode.QUESTION_MARK:
            case $d3a8d9285e373915$var$KeyCode.NUM_PLUS:
            case $d3a8d9285e373915$var$KeyCode.NUM_MINUS:
            case $d3a8d9285e373915$var$KeyCode.NUM_PERIOD:
            case $d3a8d9285e373915$var$KeyCode.NUM_DIVISION:
            case $d3a8d9285e373915$var$KeyCode.SEMICOLON:
            case $d3a8d9285e373915$var$KeyCode.DASH:
            case $d3a8d9285e373915$var$KeyCode.EQUALS:
            case $d3a8d9285e373915$var$KeyCode.COMMA:
            case $d3a8d9285e373915$var$KeyCode.PERIOD:
            case $d3a8d9285e373915$var$KeyCode.SLASH:
            case $d3a8d9285e373915$var$KeyCode.APOSTROPHE:
            case $d3a8d9285e373915$var$KeyCode.SINGLE_QUOTE:
            case $d3a8d9285e373915$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $d3a8d9285e373915$var$KeyCode.BACKSLASH:
            case $d3a8d9285e373915$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $d3a8d9285e373915$export$2e2bcd8739ae039 = $d3a8d9285e373915$var$KeyCode;


function $9595af4ca8f59963$export$597415897f3287c9(e, handles) {
    try {
        return Object.keys(handles).some(function(key) {
            return e.target === (0, $06928105ffc753ea$exports.findDOMNode)(handles[key]);
        });
    } catch (error) {
        return false;
    }
}
function $9595af4ca8f59963$export$f4657b4dc4cc2ea4(value, _ref) {
    var min = _ref.min, max = _ref.max;
    return value < min || value > max;
}
function $9595af4ca8f59963$export$eaf0efc71c45a02(e) {
    return e.touches.length > 1 || e.type.toLowerCase() === "touchend" && e.touches.length > 0;
}
function $9595af4ca8f59963$export$e3e031d5dec39373(val, _ref2) {
    var marks = _ref2.marks, step = _ref2.step, min = _ref2.min, max = _ref2.max;
    var points = Object.keys(marks).map(parseFloat);
    if (step !== null) {
        var baseNum = Math.pow(10, $9595af4ca8f59963$export$e0c74b50bbd10f68(step));
        var maxSteps = Math.floor((max * baseNum - min * baseNum) / (step * baseNum));
        var steps = Math.min((val - min) / step, maxSteps);
        var closestStep = Math.round(steps) * step + min;
        points.push(closestStep);
    }
    var diffs = points.map(function(point) {
        return Math.abs(val - point);
    });
    return points[diffs.indexOf(Math.min.apply(Math, (0, $513d655c75612b28$export$2e2bcd8739ae039)(diffs)))];
}
function $9595af4ca8f59963$export$e0c74b50bbd10f68(step) {
    var stepString = step.toString();
    var precision = 0;
    if (stepString.indexOf(".") >= 0) precision = stepString.length - stepString.indexOf(".") - 1;
    return precision;
}
function $9595af4ca8f59963$export$642213d516a9b928(vertical, e) {
    return vertical ? e.clientY : e.pageX;
}
function $9595af4ca8f59963$export$7e1d3da113d10e8e(vertical, e) {
    return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}
function $9595af4ca8f59963$export$ec6357f54996b379(vertical, handle) {
    var coords = handle.getBoundingClientRect();
    return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
}
function $9595af4ca8f59963$export$65e4339c6f9d8d24(val, _ref3) {
    var max = _ref3.max, min = _ref3.min;
    if (val <= min) return min;
    if (val >= max) return max;
    return val;
}
function $9595af4ca8f59963$export$5bea24a9dfe5ab1a(val, props) {
    var step = props.step;
    var closestPoint = isFinite($9595af4ca8f59963$export$e3e031d5dec39373(val, props)) ? $9595af4ca8f59963$export$e3e031d5dec39373(val, props) : 0; // eslint-disable-line
    return step === null ? closestPoint : parseFloat(closestPoint.toFixed($9595af4ca8f59963$export$e0c74b50bbd10f68(step)));
}
function $9595af4ca8f59963$export$3f9ffdaf2961f43f(e) {
    e.stopPropagation();
    e.preventDefault();
}
function $9595af4ca8f59963$export$e5722e0a8bbb32d9(func, value, props) {
    var operations = {
        increase: function increase(a, b) {
            return a + b;
        },
        decrease: function decrease(a, b) {
            return a - b;
        }
    };
    var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
    var keyToGet = Object.keys(props.marks)[indexToGet];
    if (props.step) return operations[func](value, props.step);
    if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) return props.marks[keyToGet];
    return value;
}
function $9595af4ca8f59963$export$3bef836a1fb84ee6(e, vertical, reverse) {
    var increase = "increase";
    var decrease = "decrease";
    var method = increase;
    switch(e.keyCode){
        case (0, $d3a8d9285e373915$export$2e2bcd8739ae039).UP:
            method = vertical && reverse ? decrease : increase;
            break;
        case (0, $d3a8d9285e373915$export$2e2bcd8739ae039).RIGHT:
            method = !vertical && reverse ? decrease : increase;
            break;
        case (0, $d3a8d9285e373915$export$2e2bcd8739ae039).DOWN:
            method = vertical && reverse ? increase : decrease;
            break;
        case (0, $d3a8d9285e373915$export$2e2bcd8739ae039).LEFT:
            method = !vertical && reverse ? increase : decrease;
            break;
        case (0, $d3a8d9285e373915$export$2e2bcd8739ae039).END:
            return function(value, props) {
                return props.max;
            };
        case (0, $d3a8d9285e373915$export$2e2bcd8739ae039).HOME:
            return function(value, props) {
                return props.min;
            };
        case (0, $d3a8d9285e373915$export$2e2bcd8739ae039).PAGE_UP:
            return function(value, props) {
                return value + props.step * 2;
            };
        case (0, $d3a8d9285e373915$export$2e2bcd8739ae039).PAGE_DOWN:
            return function(value, props) {
                return value - props.step * 2;
            };
        default:
            return undefined;
    }
    return function(value, props) {
        return $9595af4ca8f59963$export$e5722e0a8bbb32d9(method, value, props);
    };
}


/* eslint-disable @typescript-eslint/no-explicit-any */ function $2ccbbbdef185509f$var$noop() {}
function $2ccbbbdef185509f$export$2e2bcd8739ae039(Component) {
    var _a; // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return _a = /*#__PURE__*/ function(_Component) {
        (0, $e9432b2dc1794836$export$2e2bcd8739ae039)(ComponentEnhancer, _Component);
        var _super = (0, $d9bb25c2822f374b$export$2e2bcd8739ae039)(ComponentEnhancer);
        function ComponentEnhancer(props) {
            var _this;
            (0, $760550b9da8dc9e1$export$2e2bcd8739ae039)(this, ComponentEnhancer);
            _this = _super.call(this, props);
            _this.onDown = function(e, position) {
                var p = position;
                var _this$props = _this.props, draggableTrack = _this$props.draggableTrack, isVertical = _this$props.vertical;
                var bounds = _this.state.bounds;
                var value = draggableTrack && _this.positionGetValue ? _this.positionGetValue(p) || [] : [];
                var inPoint = $9595af4ca8f59963$export$597415897f3287c9(e, _this.handlesRefs);
                _this.dragTrack = draggableTrack && bounds.length >= 2 && !inPoint && !value.map(function(n, i) {
                    var v = !i ? n >= bounds[i] : true;
                    return i === value.length - 1 ? n <= bounds[i] : v;
                }).some(function(c) {
                    return !c;
                });
                if (_this.dragTrack) {
                    _this.dragOffset = p;
                    _this.startBounds = (0, $513d655c75612b28$export$2e2bcd8739ae039)(bounds);
                } else {
                    if (!inPoint) _this.dragOffset = 0;
                    else {
                        var handlePosition = $9595af4ca8f59963$export$ec6357f54996b379(isVertical, e.target);
                        _this.dragOffset = p - handlePosition;
                        p = handlePosition;
                    }
                    _this.onStart(p);
                }
            };
            _this.onMouseDown = function(e) {
                if (e.button !== 0) return;
                _this.removeDocumentEvents();
                var isVertical = _this.props.vertical;
                var position = $9595af4ca8f59963$export$642213d516a9b928(isVertical, e);
                _this.onDown(e, position);
                _this.addDocumentMouseEvents();
            };
            _this.onTouchStart = function(e) {
                if ($9595af4ca8f59963$export$eaf0efc71c45a02(e)) return;
                var isVertical = _this.props.vertical;
                var position = $9595af4ca8f59963$export$7e1d3da113d10e8e(isVertical, e);
                _this.onDown(e, position);
                _this.addDocumentTouchEvents();
                $9595af4ca8f59963$export$3f9ffdaf2961f43f(e);
            };
            _this.onFocus = function(e) {
                var _this$props2 = _this.props, onFocus = _this$props2.onFocus, vertical = _this$props2.vertical;
                if ($9595af4ca8f59963$export$597415897f3287c9(e, _this.handlesRefs) && !_this.dragTrack) {
                    var handlePosition = $9595af4ca8f59963$export$ec6357f54996b379(vertical, e.target);
                    _this.dragOffset = 0;
                    _this.onStart(handlePosition);
                    $9595af4ca8f59963$export$3f9ffdaf2961f43f(e);
                    if (onFocus) onFocus(e);
                }
            };
            _this.onBlur = function(e) {
                var onBlur = _this.props.onBlur;
                if (!_this.dragTrack) _this.onEnd();
                if (onBlur) onBlur(e);
            };
            _this.onMouseUp = function() {
                if (_this.handlesRefs[_this.prevMovedHandleIndex]) _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
            };
            _this.onMouseMove = function(e) {
                if (!_this.sliderRef) {
                    _this.onEnd();
                    return;
                }
                var position = $9595af4ca8f59963$export$642213d516a9b928(_this.props.vertical, e);
                _this.onMove(e, position - _this.dragOffset, _this.dragTrack, _this.startBounds);
            };
            _this.onTouchMove = function(e) {
                if ($9595af4ca8f59963$export$eaf0efc71c45a02(e) || !_this.sliderRef) {
                    _this.onEnd();
                    return;
                }
                var position = $9595af4ca8f59963$export$7e1d3da113d10e8e(_this.props.vertical, e);
                _this.onMove(e, position - _this.dragOffset, _this.dragTrack, _this.startBounds);
            };
            _this.onKeyDown = function(e) {
                if (_this.sliderRef && $9595af4ca8f59963$export$597415897f3287c9(e, _this.handlesRefs)) _this.onKeyboard(e);
            };
            _this.onClickMarkLabel = function(e, value) {
                e.stopPropagation();
                _this.onChange({
                    value: value
                }); // eslint-disable-next-line react/no-unused-state
                _this.setState({
                    value: value
                }, function() {
                    return _this.onEnd(true);
                });
            };
            _this.saveSlider = function(slider) {
                _this.sliderRef = slider;
            };
            var step = props.step, max = props.max, min = props.min;
            var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line
            (0, $c196facde74adb39$export$2e2bcd8739ae039)(step && Math.floor(step) === step ? isPointDiffEven : true, "Slider[max] - Slider[min] (".concat(max - min, ") should be a multiple of Slider[step] (").concat(step, ")"));
            _this.handlesRefs = {};
            return _this;
        }
        (0, $e2992e4fbdf715a4$export$2e2bcd8739ae039)(ComponentEnhancer, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    // Snapshot testing cannot handle refs, so be sure to null-check this.
                    this.document = this.sliderRef && this.sliderRef.ownerDocument;
                    var _this$props3 = this.props, autoFocus = _this$props3.autoFocus, disabled = _this$props3.disabled;
                    if (autoFocus && !disabled) this.focus();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if ((0, $64b283de2d7de7c1$export$2e2bcd8739ae039)((0, $53b14ef86235fdcb$export$2e2bcd8739ae039)(ComponentEnhancer.prototype), "componentWillUnmount", this)) (0, $64b283de2d7de7c1$export$2e2bcd8739ae039)((0, $53b14ef86235fdcb$export$2e2bcd8739ae039)(ComponentEnhancer.prototype), "componentWillUnmount", this).call(this);
                    this.removeDocumentEvents();
                }
            },
            {
                key: "getSliderStart",
                value: function getSliderStart() {
                    var slider = this.sliderRef;
                    var _this$props4 = this.props, vertical = _this$props4.vertical, reverse = _this$props4.reverse;
                    var rect = slider.getBoundingClientRect();
                    if (vertical) return reverse ? rect.bottom : rect.top;
                    return window.pageXOffset + (reverse ? rect.right : rect.left);
                }
            },
            {
                key: "getSliderLength",
                value: function getSliderLength() {
                    var slider = this.sliderRef;
                    if (!slider) return 0;
                    var coords = slider.getBoundingClientRect();
                    return this.props.vertical ? coords.height : coords.width;
                }
            },
            {
                key: "addDocumentTouchEvents",
                value: function addDocumentTouchEvents() {
                    // just work for Chrome iOS Safari and Android Browser
                    this.onTouchMoveListener = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(this.document, "touchmove", this.onTouchMove);
                    this.onTouchUpListener = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(this.document, "touchend", this.onEnd);
                }
            },
            {
                key: "addDocumentMouseEvents",
                value: function addDocumentMouseEvents() {
                    this.onMouseMoveListener = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(this.document, "mousemove", this.onMouseMove);
                    this.onMouseUpListener = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(this.document, "mouseup", this.onEnd);
                }
            },
            {
                key: "removeDocumentEvents",
                value: function removeDocumentEvents() {
                    /* eslint-disable @typescript-eslint/no-unused-expressions */ this.onTouchMoveListener && this.onTouchMoveListener.remove();
                    this.onTouchUpListener && this.onTouchUpListener.remove();
                    this.onMouseMoveListener && this.onMouseMoveListener.remove();
                    this.onMouseUpListener && this.onMouseUpListener.remove();
                /* eslint-enable no-unused-expressions */ }
            },
            {
                key: "focus",
                value: function focus() {
                    var _this$handlesRefs$;
                    if (this.props.disabled) return;
                    (_this$handlesRefs$ = this.handlesRefs[0]) === null || _this$handlesRefs$ === void 0 || _this$handlesRefs$.focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    var _this2 = this;
                    if (this.props.disabled) return;
                    Object.keys(this.handlesRefs).forEach(function(key) {
                        var _this2$handlesRefs$ke, _this2$handlesRefs$ke2;
                        (_this2$handlesRefs$ke = _this2.handlesRefs[key]) === null || _this2$handlesRefs$ke === void 0 || (_this2$handlesRefs$ke2 = _this2$handlesRefs$ke.blur) === null || _this2$handlesRefs$ke2 === void 0 || _this2$handlesRefs$ke2.call(_this2$handlesRefs$ke);
                    });
                }
            },
            {
                key: "calcValue",
                value: function calcValue(offset) {
                    var _this$props5 = this.props, vertical = _this$props5.vertical, min = _this$props5.min, max = _this$props5.max;
                    var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
                    var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
                    return value;
                }
            },
            {
                key: "calcValueByPos",
                value: function calcValueByPos(position) {
                    var sign = this.props.reverse ? -1 : 1;
                    var pixelOffset = sign * (position - this.getSliderStart());
                    var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
                    return nextValue;
                }
            },
            {
                key: "calcOffset",
                value: function calcOffset(value) {
                    var _this$props6 = this.props, min = _this$props6.min, max = _this$props6.max;
                    var ratio = (value - min) / (max - min);
                    return Math.max(0, ratio * 100);
                }
            },
            {
                key: "saveHandle",
                value: function saveHandle(index, handle) {
                    this.handlesRefs[index] = handle;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _classNames;
                    var _this$props7 = this.props, prefixCls = _this$props7.prefixCls, className = _this$props7.className, marks = _this$props7.marks, dots = _this$props7.dots, step = _this$props7.step, included = _this$props7.included, disabled = _this$props7.disabled, vertical = _this$props7.vertical, reverse = _this$props7.reverse, min = _this$props7.min, max = _this$props7.max, children = _this$props7.children, maximumTrackStyle = _this$props7.maximumTrackStyle, style = _this$props7.style, railStyle = _this$props7.railStyle, dotStyle = _this$props7.dotStyle, activeDotStyle = _this$props7.activeDotStyle;
                    var _get$call = (0, $64b283de2d7de7c1$export$2e2bcd8739ae039)((0, $53b14ef86235fdcb$export$2e2bcd8739ae039)(ComponentEnhancer.prototype), "render", this).call(this), tracks = _get$call.tracks, handles = _get$call.handles;
                    var sliderClassName = (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))(prefixCls, (_classNames = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-with-marks"), Object.keys(marks).length), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-disabled"), disabled), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-vertical"), vertical), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, className, className), _classNames));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
                        ref: this.saveSlider,
                        className: sliderClassName,
                        onTouchStart: disabled ? $2ccbbbdef185509f$var$noop : this.onTouchStart,
                        onMouseDown: disabled ? $2ccbbbdef185509f$var$noop : this.onMouseDown,
                        onMouseUp: disabled ? $2ccbbbdef185509f$var$noop : this.onMouseUp,
                        onKeyDown: disabled ? $2ccbbbdef185509f$var$noop : this.onKeyDown,
                        onFocus: disabled ? $2ccbbbdef185509f$var$noop : this.onFocus,
                        onBlur: disabled ? $2ccbbbdef185509f$var$noop : this.onBlur,
                        style: style
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
                        className: "".concat(prefixCls, "-rail"),
                        style: (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, maximumTrackStyle), railStyle)
                    }), tracks, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement((0, $0c53fbe1c5ac04a8$export$2e2bcd8739ae039), {
                        prefixCls: prefixCls,
                        vertical: vertical,
                        reverse: reverse,
                        marks: marks,
                        dots: dots,
                        step: step,
                        included: included,
                        lowerBound: this.getLowerBound(),
                        upperBound: this.getUpperBound(),
                        max: max,
                        min: min,
                        dotStyle: dotStyle,
                        activeDotStyle: activeDotStyle
                    }), handles, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement((0, $d3bad4f6579d6632$export$2e2bcd8739ae039), {
                        className: "".concat(prefixCls, "-mark"),
                        onClickLabel: disabled ? $2ccbbbdef185509f$var$noop : this.onClickMarkLabel,
                        vertical: vertical,
                        marks: marks,
                        included: included,
                        lowerBound: this.getLowerBound(),
                        upperBound: this.getUpperBound(),
                        max: max,
                        min: min,
                        reverse: reverse
                    }), children);
                }
            }
        ]);
        return ComponentEnhancer;
    }(Component), _a.displayName = "ComponentEnhancer(".concat(Component.displayName, ")"), _a.defaultProps = (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, Component.defaultProps), {}, {
        prefixCls: "rc-slider",
        className: "",
        min: 0,
        max: 100,
        step: 1,
        marks: {},
        handle: function handle(props) {
            var index = props.index, restProps = (0, $d757eeb1353aad21$export$2e2bcd8739ae039)(props, [
                "index"
            ]);
            delete restProps.dragging;
            if (restProps.value === null) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement((0, $49e439059d842d52$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({}, restProps, {
                key: index
            }));
        },
        onBeforeChange: $2ccbbbdef185509f$var$noop,
        onChange: $2ccbbbdef185509f$var$noop,
        onAfterChange: $2ccbbbdef185509f$var$noop,
        included: true,
        disabled: false,
        dots: false,
        vertical: false,
        reverse: false,
        trackStyle: [
            {}
        ],
        handleStyle: [
            {}
        ],
        railStyle: {},
        dotStyle: {},
        activeDotStyle: {}
    }), _a;
}



var $424139e045fedefc$var$Slider = /*#__PURE__*/ function(_React$Component) {
    (0, $e9432b2dc1794836$export$2e2bcd8739ae039)(Slider, _React$Component);
    var _super = (0, $d9bb25c2822f374b$export$2e2bcd8739ae039)(Slider);
    /* eslint-enable */ function Slider(props) {
        var _this;
        (0, $760550b9da8dc9e1$export$2e2bcd8739ae039)(this, Slider);
        _this = _super.call(this, props);
        _this.positionGetValue = function(position) {
            return [];
        };
        _this.onEnd = function(force) {
            var dragging = _this.state.dragging;
            _this.removeDocumentEvents();
            if (dragging || force) _this.props.onAfterChange(_this.getValue());
            _this.setState({
                dragging: false
            });
        };
        var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
        var value = props.value !== undefined ? props.value : defaultValue;
        _this.state = {
            value: _this.trimAlignValue(value),
            dragging: false
        };
        (0, $c196facde74adb39$export$2e2bcd8739ae039)(!("minimumTrackStyle" in props), "minimumTrackStyle will be deprecated, please use trackStyle instead.");
        (0, $c196facde74adb39$export$2e2bcd8739ae039)(!("maximumTrackStyle" in props), "maximumTrackStyle will be deprecated, please use railStyle instead.");
        return _this;
    }
    /**
   * [Legacy] Used for inherit other component.
   * It's a bad code style which should be refactor.
   */ /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */ (0, $e2992e4fbdf715a4$export$2e2bcd8739ae039)(Slider, [
        {
            key: "calcValueByPos",
            value: function calcValueByPos(value) {
                return 0;
            }
        },
        {
            key: "calcOffset",
            value: function calcOffset(value) {
                return 0;
            }
        },
        {
            key: "saveHandle",
            value: function saveHandle(index, h) {}
        },
        {
            key: "removeDocumentEvents",
            value: function removeDocumentEvents() {}
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this$props = this.props, min = _this$props.min, max = _this$props.max, value = _this$props.value, onChange = _this$props.onChange;
                if (!("min" in this.props || "max" in this.props)) return;
                var theValue = value !== undefined ? value : prevState.value;
                var nextValue = this.trimAlignValue(theValue, this.props);
                if (nextValue === prevState.value) return;
                 // eslint-disable-next-line
                this.setState({
                    value: nextValue
                });
                if (!(min === prevProps.min && max === prevProps.max) && $9595af4ca8f59963$export$f4657b4dc4cc2ea4(theValue, this.props)) onChange(nextValue);
            }
        },
        {
            key: "onChange",
            value: function onChange(state) {
                var props = this.props;
                var isNotControlled = !("value" in props);
                var nextState = state.value > this.props.max ? (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, state), {}, {
                    value: this.props.max
                }) : state;
                if (isNotControlled) this.setState(nextState);
                var changedValue = nextState.value;
                props.onChange(changedValue);
            }
        },
        {
            key: "onStart",
            value: function onStart(position) {
                this.setState({
                    dragging: true
                });
                var props = this.props;
                var prevValue = this.getValue();
                props.onBeforeChange(prevValue);
                var value = this.calcValueByPos(position);
                this.startValue = value;
                this.startPosition = position;
                if (value === prevValue) return;
                this.prevMovedHandleIndex = 0;
                this.onChange({
                    value: value
                });
            }
        },
        {
            key: "onMove",
            value: function onMove(e, position) {
                $9595af4ca8f59963$export$3f9ffdaf2961f43f(e);
                var oldValue = this.state.value;
                var value = this.calcValueByPos(position);
                if (value === oldValue) return;
                this.onChange({
                    value: value
                });
            }
        },
        {
            key: "onKeyboard",
            value: function onKeyboard(e) {
                var _this$props2 = this.props, reverse = _this$props2.reverse, vertical = _this$props2.vertical;
                var valueMutator = $9595af4ca8f59963$export$3bef836a1fb84ee6(e, vertical, reverse);
                if (valueMutator) {
                    $9595af4ca8f59963$export$3f9ffdaf2961f43f(e);
                    var state = this.state;
                    var oldValue = state.value;
                    var mutatedValue = valueMutator(oldValue, this.props);
                    var value = this.trimAlignValue(mutatedValue);
                    if (value === oldValue) return;
                    this.onChange({
                        value: value
                    });
                    this.props.onAfterChange(value);
                    this.onEnd();
                }
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.state.value;
            }
        },
        {
            key: "getLowerBound",
            value: function getLowerBound() {
                var minPoint = this.props.startPoint || this.props.min;
                return this.state.value > minPoint ? minPoint : this.state.value;
            }
        },
        {
            key: "getUpperBound",
            value: function getUpperBound() {
                if (this.state.value < this.props.startPoint) return this.props.startPoint;
                return this.state.value;
            }
        },
        {
            key: "trimAlignValue",
            value: function trimAlignValue(v) {
                var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (v === null) return null;
                var mergedProps = (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, this.props), nextProps);
                var val = $9595af4ca8f59963$export$65e4339c6f9d8d24(v, mergedProps);
                return $9595af4ca8f59963$export$5bea24a9dfe5ab1a(val, mergedProps);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, prefixCls = _this$props3.prefixCls, vertical = _this$props3.vertical, included = _this$props3.included, disabled = _this$props3.disabled, minimumTrackStyle = _this$props3.minimumTrackStyle, trackStyle = _this$props3.trackStyle, handleStyle = _this$props3.handleStyle, tabIndex = _this$props3.tabIndex, ariaLabelForHandle = _this$props3.ariaLabelForHandle, ariaLabelledByForHandle = _this$props3.ariaLabelledByForHandle, ariaValueTextFormatterForHandle = _this$props3.ariaValueTextFormatterForHandle, min = _this$props3.min, max = _this$props3.max, startPoint = _this$props3.startPoint, reverse = _this$props3.reverse, handleGenerator = _this$props3.handle;
                var _this$state = this.state, value = _this$state.value, dragging = _this$state.dragging;
                var offset = this.calcOffset(value);
                var handle = handleGenerator({
                    className: "".concat(prefixCls, "-handle"),
                    prefixCls: prefixCls,
                    vertical: vertical,
                    offset: offset,
                    value: value,
                    dragging: dragging,
                    disabled: disabled,
                    min: min,
                    max: max,
                    reverse: reverse,
                    index: 0,
                    tabIndex: tabIndex,
                    ariaLabel: ariaLabelForHandle,
                    ariaLabelledBy: ariaLabelledByForHandle,
                    ariaValueTextFormatter: ariaValueTextFormatterForHandle,
                    style: handleStyle[0] || handleStyle,
                    ref: function ref(h) {
                        return _this2.saveHandle(0, h);
                    }
                });
                var trackOffset = startPoint !== undefined ? this.calcOffset(startPoint) : 0;
                var mergedTrackStyle = trackStyle[0] || trackStyle;
                var track = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement((0, $50b2e2071653f08e$export$2e2bcd8739ae039), {
                    className: "".concat(prefixCls, "-track"),
                    vertical: vertical,
                    included: included,
                    offset: trackOffset,
                    reverse: reverse,
                    length: offset - trackOffset,
                    style: (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, minimumTrackStyle), mergedTrackStyle)
                });
                return {
                    tracks: track,
                    handles: handle
                };
            }
        }
    ]);
    return Slider;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).Component);
var $424139e045fedefc$export$2e2bcd8739ae039 = (0, $2ccbbbdef185509f$export$2e2bcd8739ae039)($424139e045fedefc$var$Slider);










var $9nZCP = parcelRequire("9nZCP");




var $1333fa204e4662b3$var$_trimAlignValue = function trimAlignValue(_ref) {
    var value = _ref.value, handle = _ref.handle, bounds = _ref.bounds, props = _ref.props;
    var allowCross = props.allowCross, pushable = props.pushable;
    var thershold = Number(pushable);
    var valInRange = $9595af4ca8f59963$export$65e4339c6f9d8d24(value, props);
    var valNotConflict = valInRange;
    if (!allowCross && handle != null && bounds !== undefined) {
        if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) valNotConflict = bounds[handle - 1] + thershold;
        if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) valNotConflict = bounds[handle + 1] - thershold;
    }
    return $9595af4ca8f59963$export$5bea24a9dfe5ab1a(valNotConflict, props);
};
var $1333fa204e4662b3$var$Range = /*#__PURE__*/ function(_React$Component) {
    (0, $e9432b2dc1794836$export$2e2bcd8739ae039)(Range, _React$Component);
    var _super = (0, $d9bb25c2822f374b$export$2e2bcd8739ae039)(Range);
    function Range(props) {
        var _this;
        (0, $760550b9da8dc9e1$export$2e2bcd8739ae039)(this, Range);
        _this = _super.call(this, props);
        _this.positionGetValue = function(position) {
            var bounds = _this.getValue();
            var value = _this.calcValueByPos(position);
            var closestBound = _this.getClosestBound(value);
            var index = _this.getBoundNeedMoving(value, closestBound);
            var prevValue = bounds[index];
            if (value === prevValue) return null;
            var nextBounds = (0, $513d655c75612b28$export$2e2bcd8739ae039)(bounds);
            nextBounds[index] = value;
            return nextBounds;
        };
        _this.onEnd = function(force) {
            var handle = _this.state.handle;
            _this.removeDocumentEvents();
            if (!handle) _this.dragTrack = false;
            if (handle !== null || force) _this.props.onAfterChange(_this.getValue());
            _this.setState({
                handle: null
            });
        };
        var count = props.count, min = props.min, max = props.max;
        var initialValue = Array.apply(void 0, (0, $513d655c75612b28$export$2e2bcd8739ae039)(Array(count + 1))).map(function() {
            return min;
        });
        var defaultValue = "defaultValue" in props ? props.defaultValue : initialValue;
        var value = props.value !== undefined ? props.value : defaultValue;
        var bounds = value.map(function(v, i) {
            return $1333fa204e4662b3$var$_trimAlignValue({
                value: v,
                handle: i,
                props: props
            });
        });
        var recent = bounds[0] === max ? 0 : bounds.length - 1;
        _this.state = {
            handle: null,
            recent: recent,
            bounds: bounds
        };
        return _this;
    }
    /**
   * [Legacy] Used for inherit other component.
   * It's a bad code style which should be refactor.
   */ /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */ (0, $e2992e4fbdf715a4$export$2e2bcd8739ae039)(Range, [
        {
            key: "calcValueByPos",
            value: function calcValueByPos(value) {
                return 0;
            }
        },
        {
            key: "getSliderLength",
            value: function getSliderLength() {
                return 0;
            }
        },
        {
            key: "calcOffset",
            value: function calcOffset(value) {
                return 0;
            }
        },
        {
            key: "saveHandle",
            value: function saveHandle(index, h) {}
        },
        {
            key: "removeDocumentEvents",
            value: function removeDocumentEvents() {}
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                var _this$props = this.props, onChange = _this$props.onChange, value = _this$props.value, min = _this$props.min, max = _this$props.max;
                if (!("min" in this.props || "max" in this.props)) return;
                if (min === prevProps.min && max === prevProps.max) return;
                var currentValue = value || prevState.bounds;
                if (currentValue.some(function(v) {
                    return $9595af4ca8f59963$export$f4657b4dc4cc2ea4(v, _this2.props);
                })) {
                    var newValues = currentValue.map(function(v) {
                        return $9595af4ca8f59963$export$65e4339c6f9d8d24(v, _this2.props);
                    });
                    onChange(newValues);
                }
            }
        },
        {
            key: "onChange",
            value: function onChange(state) {
                var props = this.props;
                var isNotControlled = !("value" in props);
                if (isNotControlled) this.setState(state);
                else {
                    var controlledState = {};
                    [
                        "handle",
                        "recent"
                    ].forEach(function(item) {
                        if (state[item] !== undefined) controlledState[item] = state[item];
                    });
                    if (Object.keys(controlledState).length) this.setState(controlledState);
                }
                var data = (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, this.state), state);
                var changedValue = data.bounds;
                props.onChange(changedValue);
            }
        },
        {
            key: "onStart",
            value: function onStart(position) {
                var props = this.props, state = this.state;
                var bounds = this.getValue();
                props.onBeforeChange(bounds);
                var value = this.calcValueByPos(position);
                this.startValue = value;
                this.startPosition = position;
                var closestBound = this.getClosestBound(value);
                this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);
                this.setState({
                    handle: this.prevMovedHandleIndex,
                    recent: this.prevMovedHandleIndex
                });
                var prevValue = bounds[this.prevMovedHandleIndex];
                if (value === prevValue) return;
                var nextBounds = (0, $513d655c75612b28$export$2e2bcd8739ae039)(state.bounds);
                nextBounds[this.prevMovedHandleIndex] = value;
                this.onChange({
                    bounds: nextBounds
                });
            }
        },
        {
            key: "onMove",
            value: function onMove(e, position, dragTrack, startBounds) {
                $9595af4ca8f59963$export$3f9ffdaf2961f43f(e);
                var state = this.state, props = this.props;
                var maxValue = props.max || 100;
                var minValue = props.min || 0;
                if (dragTrack) {
                    var pos = props.vertical ? -position : position;
                    pos = props.reverse ? -pos : pos;
                    var max = maxValue - Math.max.apply(Math, (0, $513d655c75612b28$export$2e2bcd8739ae039)(startBounds));
                    var min = minValue - Math.min.apply(Math, (0, $513d655c75612b28$export$2e2bcd8739ae039)(startBounds));
                    var ratio = Math.min(Math.max(pos / (this.getSliderLength() / (maxValue - minValue)), min), max);
                    var nextBounds = startBounds.map(function(v) {
                        return Math.floor(Math.max(Math.min(v + ratio, maxValue), minValue));
                    });
                    if (state.bounds.map(function(c, i) {
                        return c === nextBounds[i];
                    }).some(function(c) {
                        return !c;
                    })) this.onChange({
                        bounds: nextBounds
                    });
                    return;
                }
                var value = this.calcValueByPos(position);
                var oldValue = state.bounds[state.handle];
                if (value === oldValue) return;
                this.moveTo(value);
            }
        },
        {
            key: "onKeyboard",
            value: function onKeyboard(e) {
                var _this$props2 = this.props, reverse = _this$props2.reverse, vertical = _this$props2.vertical;
                var valueMutator = $9595af4ca8f59963$export$3bef836a1fb84ee6(e, vertical, reverse);
                if (valueMutator) {
                    $9595af4ca8f59963$export$3f9ffdaf2961f43f(e);
                    var state = this.state, props = this.props;
                    var bounds = state.bounds, handle = state.handle;
                    var oldValue = bounds[handle === null ? state.recent : handle];
                    var mutatedValue = valueMutator(oldValue, props);
                    var value = $1333fa204e4662b3$var$_trimAlignValue({
                        value: mutatedValue,
                        handle: handle,
                        bounds: state.bounds,
                        props: props
                    });
                    if (value === oldValue) return;
                    var isFromKeyboardEvent = true;
                    this.moveTo(value, isFromKeyboardEvent);
                }
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.state.bounds;
            }
        },
        {
            key: "getClosestBound",
            value: function getClosestBound(value) {
                var bounds = this.state.bounds;
                var closestBound = 0;
                for(var i = 1; i < bounds.length - 1; i += 1)if (value >= bounds[i]) closestBound = i;
                if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) closestBound += 1;
                return closestBound;
            }
        },
        {
            key: "getBoundNeedMoving",
            value: function getBoundNeedMoving(value, closestBound) {
                var _this$state = this.state, bounds = _this$state.bounds, recent = _this$state.recent;
                var boundNeedMoving = closestBound;
                var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];
                if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) boundNeedMoving = recent;
                if (isAtTheSamePoint && value !== bounds[closestBound + 1]) boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
                return boundNeedMoving;
            }
        },
        {
            key: "getLowerBound",
            value: function getLowerBound() {
                return this.state.bounds[0];
            }
        },
        {
            key: "getUpperBound",
            value: function getUpperBound() {
                var bounds = this.state.bounds;
                return bounds[bounds.length - 1];
            }
        },
        {
            key: "getPoints",
            value: function getPoints() {
                var _this$props3 = this.props, marks = _this$props3.marks, step = _this$props3.step, min = _this$props3.min, max = _this$props3.max;
                var cache = this.internalPointsCache;
                if (!cache || cache.marks !== marks || cache.step !== step) {
                    var pointsObject = (0, $835511f338e067d8$export$2e2bcd8739ae039)({}, marks);
                    if (step !== null) for(var point = min; point <= max; point += step)pointsObject[point] = point;
                    var points = Object.keys(pointsObject).map(parseFloat);
                    points.sort(function(a, b) {
                        return a - b;
                    });
                    this.internalPointsCache = {
                        marks: marks,
                        step: step,
                        points: points
                    };
                }
                return this.internalPointsCache.points;
            }
        },
        {
            key: "moveTo",
            value: function moveTo(value, isFromKeyboardEvent) {
                var _this3 = this;
                var state = this.state, props = this.props;
                var nextBounds = (0, $513d655c75612b28$export$2e2bcd8739ae039)(state.bounds);
                var handle = state.handle === null ? state.recent : state.handle;
                nextBounds[handle] = value;
                var nextHandle = handle;
                if (props.pushable !== false) this.pushSurroundingHandles(nextBounds, nextHandle);
                else if (props.allowCross) {
                    nextBounds.sort(function(a, b) {
                        return a - b;
                    });
                    nextHandle = nextBounds.indexOf(value);
                }
                this.onChange({
                    recent: nextHandle,
                    handle: nextHandle,
                    bounds: nextBounds
                });
                if (isFromKeyboardEvent) {
                    // known problem: because setState is async,
                    // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
                    // cause onBeforeChange and onAfterChange receive wrong value.
                    // here use setState callback to hack，but not elegant
                    this.props.onAfterChange(nextBounds);
                    this.setState({}, function() {
                        _this3.handlesRefs[nextHandle].focus();
                    });
                    this.onEnd();
                }
            }
        },
        {
            key: "pushSurroundingHandles",
            value: function pushSurroundingHandles(bounds, handle) {
                var value = bounds[handle];
                var pushable = this.props.pushable;
                var threshold = Number(pushable);
                var direction = 0;
                if (bounds[handle + 1] - value < threshold) direction = 1; // push to right
                if (value - bounds[handle - 1] < threshold) direction = -1; // push to left
                if (direction === 0) return;
                var nextHandle = handle + direction;
                var diffToNext = direction * (bounds[nextHandle] - value);
                if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) // revert to original value if pushing is impossible
                // eslint-disable-next-line no-param-reassign
                bounds[handle] = bounds[nextHandle] - direction * threshold;
            }
        },
        {
            key: "pushHandle",
            value: function pushHandle(bounds, handle, direction, amount) {
                var originalValue = bounds[handle];
                var currentValue = bounds[handle];
                while(direction * (currentValue - originalValue) < amount){
                    if (!this.pushHandleOnePoint(bounds, handle, direction)) {
                        // can't push handle enough to create the needed `amount` gap, so we
                        // revert its position to the original value
                        // eslint-disable-next-line no-param-reassign
                        bounds[handle] = originalValue;
                        return false;
                    }
                    currentValue = bounds[handle];
                } // the handle was pushed enough to create the needed `amount` gap
                return true;
            }
        },
        {
            key: "pushHandleOnePoint",
            value: function pushHandleOnePoint(bounds, handle, direction) {
                var points = this.getPoints();
                var pointIndex = points.indexOf(bounds[handle]);
                var nextPointIndex = pointIndex + direction;
                if (nextPointIndex >= points.length || nextPointIndex < 0) // reached the minimum or maximum available point, can't push anymore
                return false;
                var nextHandle = handle + direction;
                var nextValue = points[nextPointIndex];
                var pushable = this.props.pushable;
                var threshold = Number(pushable);
                var diffToNext = direction * (bounds[nextHandle] - nextValue);
                if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) // couldn't push next handle, so we won't push this one either
                return false;
                 // push the handle
                // eslint-disable-next-line no-param-reassign
                bounds[handle] = nextValue;
                return true;
            }
        },
        {
            key: "trimAlignValue",
            value: function trimAlignValue(value) {
                var _this$state2 = this.state, handle = _this$state2.handle, bounds = _this$state2.bounds;
                return $1333fa204e4662b3$var$_trimAlignValue({
                    value: value,
                    handle: handle,
                    bounds: bounds,
                    props: this.props
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                var _this$state3 = this.state, handle = _this$state3.handle, bounds = _this$state3.bounds;
                var _this$props4 = this.props, prefixCls = _this$props4.prefixCls, vertical = _this$props4.vertical, included = _this$props4.included, disabled = _this$props4.disabled, min = _this$props4.min, max = _this$props4.max, reverse = _this$props4.reverse, handleGenerator = _this$props4.handle, trackStyle = _this$props4.trackStyle, handleStyle = _this$props4.handleStyle, tabIndex = _this$props4.tabIndex, ariaLabelGroupForHandles = _this$props4.ariaLabelGroupForHandles, ariaLabelledByGroupForHandles = _this$props4.ariaLabelledByGroupForHandles, ariaValueTextFormatterGroupForHandles = _this$props4.ariaValueTextFormatterGroupForHandles;
                var offsets = bounds.map(function(v) {
                    return _this4.calcOffset(v);
                });
                var handleClassName = "".concat(prefixCls, "-handle");
                var handles = bounds.map(function(v, i) {
                    var _classNames;
                    var mergedTabIndex = tabIndex[i] || 0;
                    if (disabled || tabIndex[i] === null) mergedTabIndex = null;
                    var dragging = handle === i;
                    return handleGenerator({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))((_classNames = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, handleClassName, true), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(handleClassName, "-").concat(i + 1), true), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(handleClassName, "-dragging"), dragging), _classNames)),
                        prefixCls: prefixCls,
                        vertical: vertical,
                        dragging: dragging,
                        offset: offsets[i],
                        value: v,
                        index: i,
                        tabIndex: mergedTabIndex,
                        min: min,
                        max: max,
                        reverse: reverse,
                        disabled: disabled,
                        style: handleStyle[i],
                        ref: function ref(h) {
                            return _this4.saveHandle(i, h);
                        },
                        ariaLabel: ariaLabelGroupForHandles[i],
                        ariaLabelledBy: ariaLabelledByGroupForHandles[i],
                        ariaValueTextFormatter: ariaValueTextFormatterGroupForHandles[i]
                    });
                });
                var tracks = bounds.slice(0, -1).map(function(_, index) {
                    var _classNames2;
                    var i = index + 1;
                    var trackClassName = (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))((_classNames2 = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-track"), true), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-track-").concat(i), true), _classNames2));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement((0, $50b2e2071653f08e$export$2e2bcd8739ae039), {
                        className: trackClassName,
                        vertical: vertical,
                        reverse: reverse,
                        included: included,
                        offset: offsets[i - 1],
                        length: offsets[i] - offsets[i - 1],
                        style: trackStyle[index],
                        key: i
                    });
                });
                return {
                    tracks: tracks,
                    handles: handles
                };
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (!("value" in props || "min" in props || "max" in props)) return null;
                var value = props.value || state.bounds;
                var nextBounds = value.map(function(v, i) {
                    return $1333fa204e4662b3$var$_trimAlignValue({
                        value: v,
                        handle: i,
                        bounds: state.bounds,
                        props: props
                    });
                });
                if (state.bounds.length === nextBounds.length) {
                    if (nextBounds.every(function(v, i) {
                        return v === state.bounds[i];
                    })) return null;
                } else nextBounds = value.map(function(v, i) {
                    return $1333fa204e4662b3$var$_trimAlignValue({
                        value: v,
                        handle: i,
                        props: props
                    });
                });
                return (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, state), {}, {
                    bounds: nextBounds
                });
            }
        }
    ]);
    return Range;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).Component);
/* eslint-enable */ $1333fa204e4662b3$var$Range.displayName = "Range";
$1333fa204e4662b3$var$Range.defaultProps = {
    count: 1,
    allowCross: true,
    pushable: false,
    draggableTrack: false,
    tabIndex: [],
    ariaLabelGroupForHandles: [],
    ariaLabelledByGroupForHandles: [],
    ariaValueTextFormatterGroupForHandles: []
};
var $1333fa204e4662b3$export$2e2bcd8739ae039 = (0, $2ccbbbdef185509f$export$2e2bcd8739ae039)($1333fa204e4662b3$var$Range);












var $9nZCP = parcelRequire("9nZCP");


var $9nZCP = parcelRequire("9nZCP");





var $9nZCP = parcelRequire("9nZCP");









var $9nZCP = parcelRequire("9nZCP");

var $74c50fa010549a87$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $74c50fa010549a87$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== "undefined" && "requestAnimationFrame" in window) {
    $74c50fa010549a87$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $74c50fa010549a87$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $74c50fa010549a87$var$rafUUID = 0;
var $74c50fa010549a87$var$rafIds = new Map();
function $74c50fa010549a87$var$cleanup(id) {
    $74c50fa010549a87$var$rafIds.delete(id);
}
var $74c50fa010549a87$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $74c50fa010549a87$var$rafUUID += 1;
    var id = $74c50fa010549a87$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $74c50fa010549a87$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $74c50fa010549a87$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $74c50fa010549a87$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$74c50fa010549a87$var$wrapperRaf.cancel = function(id) {
    var realId = $74c50fa010549a87$var$rafIds.get(id);
    $74c50fa010549a87$var$cleanup(id);
    return $74c50fa010549a87$var$caf(realId);
};
var $74c50fa010549a87$export$2e2bcd8739ae039 = $74c50fa010549a87$var$wrapperRaf;


function $a5f4fb2511f41816$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}



var $9nZCP = parcelRequire("9nZCP");

function $93bb6ec4cced17a6$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $93bb6ec4cced17a6$export$2e2bcd8739ae039(node) {
    if ($93bb6ec4cced17a6$export$41e30d8dd0ba7a50(node)) return node;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).Component) return (0, (/*@__PURE__*/$parcel$interopDefault($06928105ffc753ea$exports))).findDOMNode(node);
    return null;
}




var $9nZCP = parcelRequire("9nZCP");


var $9nZCP = parcelRequire("9nZCP");
function $78ee045b99bd059c$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $9nZCP.useRef({});
    if (!("value" in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}


function $ece7587e1886b1b9$export$f17fd18fa51dcb5b(ref, node) {
    if (typeof ref === "function") ref(node);
    else if ((0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(ref) === "object" && ref && "current" in ref) ref.current = node;
}
function $ece7587e1886b1b9$export$ab452c34e8e05029() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(function(ref) {
        return ref;
    });
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $ece7587e1886b1b9$export$f17fd18fa51dcb5b(ref, node);
        });
    };
}
function $ece7587e1886b1b9$export$1d1c999670a1285d() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $78ee045b99bd059c$export$2e2bcd8739ae039)(function() {
        return $ece7587e1886b1b9$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
}
function $ece7587e1886b1b9$export$c1cec34af06bcf7(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    var type = (0, $641555432cc96e57$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === "function" && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render)) return false;
    // Class component
    if (typeof nodeOrComponent === "function" && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render)) return false;
    return true;
}
function $ece7587e1886b1b9$export$b51ae67c7882a242(node) {
    if (!/*#__PURE__*/ (0, $9nZCP.isValidElement)(node)) return false;
    if ((0, $641555432cc96e57$exports.isFragment)(node)) return false;
    return $ece7587e1886b1b9$export$c1cec34af06bcf7(node);
} /* eslint-enable */ 




var $9nZCP = parcelRequire("9nZCP");

function $f14589e789dffb0e$export$2e2bcd8739ae039() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}


var $f28890857a395782$var$Portal = /*#__PURE__*/ (0, $9nZCP.forwardRef)(function(props, ref) {
    var didUpdate = props.didUpdate, getContainer = props.getContainer, children = props.children;
    var parentRef = (0, $9nZCP.useRef)();
    var containerRef = (0, $9nZCP.useRef)();
    // Ref return nothing, only for wrapper check exist
    (0, $9nZCP.useImperativeHandle)(ref, function() {
        return {};
    });
    // Create container in client side with sync to avoid useEffect not get ref
    var initRef = (0, $9nZCP.useRef)(false);
    if (!initRef.current && (0, $f14589e789dffb0e$export$2e2bcd8739ae039)()) {
        containerRef.current = getContainer();
        parentRef.current = containerRef.current.parentNode;
        initRef.current = true;
    }
    // [Legacy] Used by `rc-trigger`
    (0, $9nZCP.useEffect)(function() {
        didUpdate === null || didUpdate === void 0 || didUpdate(props);
    });
    (0, $9nZCP.useEffect)(function() {
        // Restore container to original place
        // React 18 StrictMode will unmount first and mount back for effect test:
        // https://reactjs.org/blog/2022/03/29/react-v18.html#new-strict-mode-behaviors
        if (containerRef.current.parentNode === null && parentRef.current !== null) parentRef.current.appendChild(containerRef.current);
        return function() {
            var _containerRef$current;
            // [Legacy] This should not be handle by Portal but parent PortalWrapper instead.
            // Since some component use `Portal` directly, we have to keep the logic here.
            (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || (_containerRef$current = _containerRef$current.parentNode) === null || _containerRef$current === void 0 || _containerRef$current.removeChild(containerRef.current);
        };
    }, []);
    return containerRef.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($06928105ffc753ea$exports))).createPortal(children, containerRef.current) : null;
});
var $f28890857a395782$export$2e2bcd8739ae039 = $f28890857a395782$var$Portal;




function $d5666b43b133354b$var$isPointsEq(a1, a2, isAlignPoint) {
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $d5666b43b133354b$export$44605b74f7c5d944(builtinPlacements, placementStr, align) {
    var baseAlign = builtinPlacements[placementStr] || {};
    return (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, baseAlign), align);
}
function $d5666b43b133354b$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for(var i = 0; i < placements.length; i += 1){
        var placement = placements[i];
        if ($d5666b43b133354b$var$isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) return "".concat(prefixCls, "-placement-").concat(placement);
    }
    return "";
}




function $7b7118c37340dbc2$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $66926ee39021de02$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $0512d7435b9a4ed1$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $5364cf1643bb9b6d$export$2e2bcd8739ae039(arr, i) {
    return (0, $7b7118c37340dbc2$export$2e2bcd8739ae039)(arr) || (0, $66926ee39021de02$export$2e2bcd8739ae039)(arr, i) || (0, $972a974728b0ca3d$export$2e2bcd8739ae039)(arr, i) || (0, $0512d7435b9a4ed1$export$2e2bcd8739ae039)();
}




var $9nZCP = parcelRequire("9nZCP");
var $0be4b22dededee67$export$2e2bcd8739ae039 = function() {
    if (typeof navigator === "undefined" || typeof window === "undefined") return false;
    var agent = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
};





var $9nZCP = parcelRequire("9nZCP");









var $9nZCP = parcelRequire("9nZCP");


var $9nZCP = parcelRequire("9nZCP");
var $6f49c89efcd6b8a4$var$_excluded = [
    "children"
];
var $6f49c89efcd6b8a4$export$841858b892ce1f4c = /*#__PURE__*/ $9nZCP.createContext({});
function $6f49c89efcd6b8a4$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $d757eeb1353aad21$export$2e2bcd8739ae039)(_ref, $6f49c89efcd6b8a4$var$_excluded);
    return /*#__PURE__*/ $9nZCP.createElement($6f49c89efcd6b8a4$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}







var $9nZCP = parcelRequire("9nZCP");
var $67a41eee446def57$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $e9432b2dc1794836$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $d9bb25c2822f374b$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $760550b9da8dc9e1$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $e2992e4fbdf715a4$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($9nZCP.Component);
var $67a41eee446def57$export$2e2bcd8739ae039 = $67a41eee446def57$var$DomWrapper;







var $9nZCP = parcelRequire("9nZCP");
function $4e01688ba8da34ba$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $9nZCP.useRef(false);
    var _React$useState = $9nZCP.useState(defaultValue), _React$useState2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $9nZCP.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}



var $9nZCP = parcelRequire("9nZCP");
var $7d9f27a1ecfcb923$export$de71442bbf2143da = "none";
var $7d9f27a1ecfcb923$export$4fc3521687bcacd2 = "appear";
var $7d9f27a1ecfcb923$export$5d6af549241fe2e8 = "enter";
var $7d9f27a1ecfcb923$export$59b1c493d29f68e4 = "leave";
var $7d9f27a1ecfcb923$export$40b34dd77d5522bf = "none";
var $7d9f27a1ecfcb923$export$1b792916a5fac4fc = "prepare";
var $7d9f27a1ecfcb923$export$9563153dd25a3ce8 = "start";
var $7d9f27a1ecfcb923$export$e205886172277ec6 = "active";
var $7d9f27a1ecfcb923$export$3a846c3d2fac10b8 = "end";
var $7d9f27a1ecfcb923$export$98351fa4e6b4f204 = "prepared";



var $9nZCP = parcelRequire("9nZCP");


// ================= Transition =================
// Event wrapper. Copy from react source code
function $65be73a51576fb77$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $65be73a51576fb77$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $65be73a51576fb77$var$makePrefixMap("Animation", "AnimationEnd"),
        transitionend: $65be73a51576fb77$var$makePrefixMap("Transition", "TransitionEnd")
    };
    if (domSupport) {
        if (!("AnimationEvent" in win)) delete prefixes.animationend.animation;
        if (!("TransitionEvent" in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $65be73a51576fb77$var$vendorPrefixes = $65be73a51576fb77$export$6e8b350b1a8958a0((0, $f14589e789dffb0e$export$2e2bcd8739ae039)(), typeof window !== "undefined" ? window : {});
var $65be73a51576fb77$var$style = {};
if ((0, $f14589e789dffb0e$export$2e2bcd8739ae039)()) {
    var $65be73a51576fb77$var$_document$createEleme = document.createElement("div");
    $65be73a51576fb77$var$style = $65be73a51576fb77$var$_document$createEleme.style;
}
var $65be73a51576fb77$var$prefixedEventNames = {};
function $65be73a51576fb77$export$a032e4f39350c1d8(eventName) {
    if ($65be73a51576fb77$var$prefixedEventNames[eventName]) return $65be73a51576fb77$var$prefixedEventNames[eventName];
    var prefixMap = $65be73a51576fb77$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $65be73a51576fb77$var$style) {
                $65be73a51576fb77$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $65be73a51576fb77$var$prefixedEventNames[eventName];
            }
        }
    }
    return "";
}
var $65be73a51576fb77$var$internalAnimationEndName = $65be73a51576fb77$export$a032e4f39350c1d8("animationend");
var $65be73a51576fb77$var$internalTransitionEndName = $65be73a51576fb77$export$a032e4f39350c1d8("transitionend");
var $65be73a51576fb77$export$d28133ed3ad06c8b = !!($65be73a51576fb77$var$internalAnimationEndName && $65be73a51576fb77$var$internalTransitionEndName);
var $65be73a51576fb77$export$760cc9769c51b738 = $65be73a51576fb77$var$internalAnimationEndName || "animationend";
var $65be73a51576fb77$export$44baea64b8602e3c = $65be73a51576fb77$var$internalTransitionEndName || "transitionend";
function $65be73a51576fb77$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(transitionName) === "object") {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}


var $e852ff56348c9091$export$2e2bcd8739ae039 = function(callback) {
    var cacheElementRef = (0, $9nZCP.useRef)();
    // Cache callback
    var callbackRef = (0, $9nZCP.useRef)(callback);
    callbackRef.current = callback;
    // Internal motion event handler
    var onInternalMotionEnd = $9nZCP.useCallback(function(event) {
        callbackRef.current(event);
    }, []);
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $65be73a51576fb77$export$44baea64b8602e3c), onInternalMotionEnd);
            element.removeEventListener((0, $65be73a51576fb77$export$760cc9769c51b738), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $65be73a51576fb77$export$44baea64b8602e3c), onInternalMotionEnd);
            element.addEventListener((0, $65be73a51576fb77$export$760cc9769c51b738), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $9nZCP.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};




var $9nZCP = parcelRequire("9nZCP");
// It's safe to use `useLayoutEffect` but the warning is annoying
var $272eb0a7d82dfb31$var$useIsomorphicLayoutEffect = (0, $f14589e789dffb0e$export$2e2bcd8739ae039)() ? (0, $9nZCP.useLayoutEffect) : (0, $9nZCP.useEffect);
var $272eb0a7d82dfb31$export$2e2bcd8739ae039 = $272eb0a7d82dfb31$var$useIsomorphicLayoutEffect;





var $9nZCP = parcelRequire("9nZCP");




var $9nZCP = parcelRequire("9nZCP");
var $6904c33263bf6c3a$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $9nZCP.useRef(null);
    function cancelNextFrame() {
        (0, $74c50fa010549a87$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $74c50fa010549a87$export$2e2bcd8739ae039)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $9nZCP.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};


var $3bfe7cebc04eb42c$var$FULL_STEP_QUEUE = [
    (0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc),
    (0, $7d9f27a1ecfcb923$export$9563153dd25a3ce8),
    (0, $7d9f27a1ecfcb923$export$e205886172277ec6),
    (0, $7d9f27a1ecfcb923$export$3a846c3d2fac10b8)
];
var $3bfe7cebc04eb42c$var$SIMPLE_STEP_QUEUE = [
    (0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc),
    (0, $7d9f27a1ecfcb923$export$98351fa4e6b4f204)
];
var $3bfe7cebc04eb42c$export$c2029bf6cfdbc28a = false;
var $3bfe7cebc04eb42c$export$dbee1e282e8c4830 = true;
function $3bfe7cebc04eb42c$export$39e04e72f972b885(step) {
    return step === (0, $7d9f27a1ecfcb923$export$e205886172277ec6) || step === (0, $7d9f27a1ecfcb923$export$3a846c3d2fac10b8);
}
var $3bfe7cebc04eb42c$export$2e2bcd8739ae039 = function(status, prepareOnly, callback) {
    var _useState = (0, $4e01688ba8da34ba$export$2e2bcd8739ae039)((0, $7d9f27a1ecfcb923$export$40b34dd77d5522bf)), _useState2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $6904c33263bf6c3a$export$2e2bcd8739ae039)(), _useNextFrame2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc), true);
    }
    var STEP_QUEUE = prepareOnly ? $3bfe7cebc04eb42c$var$SIMPLE_STEP_QUEUE : $3bfe7cebc04eb42c$var$FULL_STEP_QUEUE;
    (0, $272eb0a7d82dfb31$export$2e2bcd8739ae039)(function() {
        if (step !== (0, $7d9f27a1ecfcb923$export$40b34dd77d5522bf) && step !== (0, $7d9f27a1ecfcb923$export$3a846c3d2fac10b8)) {
            var index = STEP_QUEUE.indexOf(step);
            var nextStep = STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $3bfe7cebc04eb42c$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $9nZCP.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};


function $b63fc9da4878f335$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $4e01688ba8da34ba$export$2e2bcd8739ae039)(), _useState2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useState3 = (0, $4e01688ba8da34ba$export$2e2bcd8739ae039)((0, $7d9f27a1ecfcb923$export$de71442bbf2143da)), _useState4 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useState3, 2), status = _useState4[0], setStatus = _useState4[1];
    var _useState5 = (0, $4e01688ba8da34ba$export$2e2bcd8739ae039)(null), _useState6 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useState5, 2), style = _useState6[0], setStyle = _useState6[1];
    var mountedRef = (0, $9nZCP.useRef)(false);
    var deadlineRef = (0, $9nZCP.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    var activeRef = (0, $9nZCP.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $7d9f27a1ecfcb923$export$de71442bbf2143da), true);
        setStyle(null, true);
    }
    function onInternalMotionEnd(event) {
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $7d9f27a1ecfcb923$export$4fc3521687bcacd2) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $7d9f27a1ecfcb923$export$5d6af549241fe2e8) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $7d9f27a1ecfcb923$export$59b1c493d29f68e4) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
        // Only update status when `canEnd` and not destroyed
        if (status !== (0, $7d9f27a1ecfcb923$export$de71442bbf2143da) && currentActive && canEnd !== false) updateMotionEndStatus();
    }
    var _useDomMotionEvents = (0, $e852ff56348c9091$export$2e2bcd8739ae039)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
    // ============================= Step =============================
    var getEventHandlers = function getEventHandlers(targetStatus) {
        var _ref2, _ref3, _ref4;
        switch(targetStatus){
            case 0, $7d9f27a1ecfcb923$export$4fc3521687bcacd2:
                return _ref2 = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref2, (0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc), onAppearPrepare), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref2, (0, $7d9f27a1ecfcb923$export$9563153dd25a3ce8), onAppearStart), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref2, (0, $7d9f27a1ecfcb923$export$e205886172277ec6), onAppearActive), _ref2;
            case 0, $7d9f27a1ecfcb923$export$5d6af549241fe2e8:
                return _ref3 = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref3, (0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc), onEnterPrepare), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref3, (0, $7d9f27a1ecfcb923$export$9563153dd25a3ce8), onEnterStart), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref3, (0, $7d9f27a1ecfcb923$export$e205886172277ec6), onEnterActive), _ref3;
            case 0, $7d9f27a1ecfcb923$export$59b1c493d29f68e4:
                return _ref4 = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref4, (0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc), onLeavePrepare), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref4, (0, $7d9f27a1ecfcb923$export$9563153dd25a3ce8), onLeaveStart), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref4, (0, $7d9f27a1ecfcb923$export$e205886172277ec6), onLeaveActive), _ref4;
            default:
                return {};
        }
    };
    var eventHandlers = $9nZCP.useMemo(function() {
        return getEventHandlers(status);
    }, [
        status
    ]);
    var _useStepQueue = (0, $3bfe7cebc04eb42c$export$2e2bcd8739ae039)(status, !supportMotion, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc)) {
            var onPrepare = eventHandlers[0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc];
            if (!onPrepare) return 0, $3bfe7cebc04eb42c$export$c2029bf6cfdbc28a;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $7d9f27a1ecfcb923$export$e205886172277ec6)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $7d9f27a1ecfcb923$export$98351fa4e6b4f204)) updateMotionEndStatus();
        return 0, $3bfe7cebc04eb42c$export$dbee1e282e8c4830;
    }), _useStepQueue2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $3bfe7cebc04eb42c$export$39e04e72f972b885)(step);
    activeRef.current = active;
    // ============================ Status ============================
    // Update with new status
    (0, $272eb0a7d82dfb31$export$2e2bcd8739ae039)(function() {
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        var nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $7d9f27a1ecfcb923$export$4fc3521687bcacd2);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $7d9f27a1ecfcb923$export$5d6af549241fe2e8);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $7d9f27a1ecfcb923$export$59b1c493d29f68e4);
        var nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $7d9f27a1ecfcb923$export$de71442bbf2143da));
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $9nZCP.useEffect)(function() {
        if (// Cancel appear
        status === (0, $7d9f27a1ecfcb923$export$4fc3521687bcacd2) && !motionAppear || // Cancel enter
        status === (0, $7d9f27a1ecfcb923$export$5d6af549241fe2e8) && !motionEnter || // Cancel leave
        status === (0, $7d9f27a1ecfcb923$export$59b1c493d29f68e4) && !motionLeave) setStatus((0, $7d9f27a1ecfcb923$export$de71442bbf2143da));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $9nZCP.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []);
    // Trigger `onVisibleChanged`
    var firstMountChangeRef = $9nZCP.useRef(false);
    (0, $9nZCP.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && status === (0, $7d9f27a1ecfcb923$export$de71442bbf2143da)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        status
    ]);
    // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc] && step === (0, $7d9f27a1ecfcb923$export$9563153dd25a3ce8)) mergedStyle = (0, $835511f338e067d8$export$2e2bcd8739ae039)({
        transition: "none"
    }, mergedStyle);
    return [
        status,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}





function $c4ab6975dfa295b2$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(config) === "object") transitionSupport = config.transitionSupport;
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    var CSSMotion = /*#__PURE__*/ $9nZCP.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var _React$useContext = $9nZCP.useContext((0, $6f49c89efcd6b8a4$export$841858b892ce1f4c)), contextMotion = _React$useContext.motion;
        var supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $9nZCP.useRef)();
        // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $9nZCP.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $93bb6ec4cced17a6$export$2e2bcd8739ae039)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $b63fc9da4878f335$export$2e2bcd8739ae039)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $9nZCP.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        var setNodeRef = $9nZCP.useCallback(function(node) {
            nodeRef.current = node;
            (0, $ece7587e1886b1b9$export$f17fd18fa51dcb5b)(ref, node);
        }, [
            ref
        ]);
        // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $7d9f27a1ecfcb923$export$de71442bbf2143da)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                style: {
                    display: "none"
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            var _classNames;
            // In motion
            var statusSuffix;
            if (statusStep === (0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc)) statusSuffix = "prepare";
            else if ((0, $3bfe7cebc04eb42c$export$39e04e72f972b885)(statusStep)) statusSuffix = "active";
            else if (statusStep === (0, $7d9f27a1ecfcb923$export$9563153dd25a3ce8)) statusSuffix = "start";
            var motionCls = (0, $65be73a51576fb77$export$27c72201b1d09951)(motionName, "".concat(status, "-").concat(statusSuffix));
            motionChildren = children((0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))((0, $65be73a51576fb77$export$27c72201b1d09951)(motionName, status), (_classNames = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, motionCls, motionCls && statusSuffix), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, motionName, typeof motionName === "string"), _classNames)),
                style: statusStyle
            }), setNodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $9nZCP.isValidElement(motionChildren) && (0, $ece7587e1886b1b9$export$c1cec34af06bcf7)(motionChildren)) {
            var _ref = motionChildren, originNodeRef = _ref.ref;
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $9nZCP.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $9nZCP.createElement((0, $67a41eee446def57$export$2e2bcd8739ae039), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = "CSSMotion";
    return CSSMotion;
}
var $c4ab6975dfa295b2$export$2e2bcd8739ae039 = $c4ab6975dfa295b2$export$e265d52a86a9f199((0, $65be73a51576fb77$export$d28133ed3ad06c8b));












var $9nZCP = parcelRequire("9nZCP");



var $9e3a6d91ab4ec0d6$export$3904baa009bc026e = "add";
var $9e3a6d91ab4ec0d6$export$851162f0adad2cbc = "keep";
var $9e3a6d91ab4ec0d6$export$c8b3fb08b68cfc85 = "remove";
var $9e3a6d91ab4ec0d6$export$2ac1bd1808d2e43a = "removed";
function $9e3a6d91ab4ec0d6$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(key) === "object" && "key" in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $9e3a6d91ab4ec0d6$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($9e3a6d91ab4ec0d6$export$c47fd798e598c85c);
}
function $9e3a6d91ab4ec0d6$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $9e3a6d91ab4ec0d6$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $9e3a6d91ab4ec0d6$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, obj), {}, {
                            status: $9e3a6d91ab4ec0d6$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, currentKeyObj), {}, {
                    status: $9e3a6d91ab4ec0d6$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push((0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, keyObj), {}, {
            status: $9e3a6d91ab4ec0d6$export$c8b3fb08b68cfc85
        }));
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, obj), {}, {
            status: $9e3a6d91ab4ec0d6$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $9e3a6d91ab4ec0d6$export$c8b3fb08b68cfc85;
        });
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $9e3a6d91ab4ec0d6$export$851162f0adad2cbc;
        });
    });
    return list;
}



var $3c4117f4af9ea6fe$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $3c4117f4af9ea6fe$var$_excluded2 = [
    "status"
];
var $3c4117f4af9ea6fe$var$MOTION_PROP_NAMES = [
    "eventProps",
    "visible",
    "children",
    "motionName",
    "motionAppear",
    "motionEnter",
    "motionLeave",
    "motionLeaveImmediately",
    "motionDeadline",
    "removeOnLeave",
    "leavedClassName",
    "onAppearPrepare",
    "onAppearStart",
    "onAppearActive",
    "onAppearEnd",
    "onEnterStart",
    "onEnterActive",
    "onEnterEnd",
    "onLeaveStart",
    "onLeaveActive",
    "onLeaveEnd"
];
function $3c4117f4af9ea6fe$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $c4ab6975dfa295b2$export$2e2bcd8739ae039);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $e9432b2dc1794836$export$2e2bcd8739ae039)(CSSMotionList, _React$Component);
        var _super = (0, $d9bb25c2822f374b$export$2e2bcd8739ae039)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $760550b9da8dc9e1$export$2e2bcd8739ae039)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "state", {
                keyEntities: []
            });
            // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "removeKey", function(removeKey) {
                var keyEntities = _this.state.keyEntities;
                var nextKeyEntities = keyEntities.map(function(entity) {
                    if (entity.key !== removeKey) return entity;
                    return (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, entity), {}, {
                        status: (0, $9e3a6d91ab4ec0d6$export$2ac1bd1808d2e43a)
                    });
                });
                _this.setState({
                    keyEntities: nextKeyEntities
                });
                return nextKeyEntities.filter(function(_ref) {
                    var status = _ref.status;
                    return status !== (0, $9e3a6d91ab4ec0d6$export$2ac1bd1808d2e43a);
                }).length;
            });
            return _this;
        }
        (0, $e2992e4fbdf715a4$export$2e2bcd8739ae039)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $d757eeb1353aad21$export$2e2bcd8739ae039)(_this$props, $3c4117f4af9ea6fe$var$_excluded);
                    var Component = component || $9nZCP.Fragment;
                    var motionProps = {};
                    $3c4117f4af9ea6fe$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $9nZCP.createElement(Component, restProps, keyEntities.map(function(_ref2, index) {
                        var status = _ref2.status, eventProps = (0, $d757eeb1353aad21$export$2e2bcd8739ae039)(_ref2, $3c4117f4af9ea6fe$var$_excluded2);
                        var visible = status === (0, $9e3a6d91ab4ec0d6$export$3904baa009bc026e) || status === (0, $9e3a6d91ab4ec0d6$export$851162f0adad2cbc);
                        return /*#__PURE__*/ $9nZCP.createElement(CSSMotion, (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) {
                                    var restKeysCount = _this2.removeKey(eventProps.key);
                                    if (restKeysCount === 0 && onAllRemoved) onAllRemoved();
                                }
                            }
                        }), function(props, ref) {
                            return children((0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, props), {}, {
                                index: index
                            }), ref);
                        });
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $9e3a6d91ab4ec0d6$export$84bd7bd42ccc0f72)(keys);
                    var mixedKeyEntities = (0, $9e3a6d91ab4ec0d6$export$14527669107aa301)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            });
                            // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $9e3a6d91ab4ec0d6$export$2ac1bd1808d2e43a) && entity.status === (0, $9e3a6d91ab4ec0d6$export$c8b3fb08b68cfc85)) return false;
                            return true;
                        })
                    };
                }
            }
        ]);
        return CSSMotionList;
    }($9nZCP.Component);
    (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(CSSMotionList, "defaultProps", {
        component: "div"
    });
    return CSSMotionList;
}
var $3c4117f4af9ea6fe$export$2e2bcd8739ae039 = $3c4117f4af9ea6fe$export$fcfc62c1d33d5e2e((0, $65be73a51576fb77$export$d28133ed3ad06c8b));



var $ba55528cb86ff86c$export$2e2bcd8739ae039 = (0, $c4ab6975dfa295b2$export$2e2bcd8739ae039);


function $daa737f1914dfdb8$export$7b8936ddc277a29a(_ref) {
    var prefixCls = _ref.prefixCls, motion = _ref.motion, animation = _ref.animation, transitionName = _ref.transitionName;
    if (motion) return motion;
    if (animation) return {
        motionName: "".concat(prefixCls, "-").concat(animation)
    };
    if (transitionName) return {
        motionName: transitionName
    };
    return null;
}


function $2c5306aae19cdf6e$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, mask = props.mask, maskMotion = props.maskMotion, maskAnimation = props.maskAnimation, maskTransitionName = props.maskTransitionName;
    if (!mask) return null;
    var motion = {};
    if (maskMotion || maskTransitionName || maskAnimation) motion = (0, $835511f338e067d8$export$2e2bcd8739ae039)({
        motionAppear: true
    }, (0, $daa737f1914dfdb8$export$7b8936ddc277a29a)({
        motion: maskMotion,
        prefixCls: prefixCls,
        transitionName: maskTransitionName,
        animation: maskAnimation
    }));
    return /*#__PURE__*/ $9nZCP.createElement((0, $ba55528cb86ff86c$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({}, motion, {
        visible: visible,
        removeOnLeave: true
    }), function(_ref) {
        var className = _ref.className;
        return /*#__PURE__*/ $9nZCP.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))("".concat(prefixCls, "-mask"), className)
        });
    });
}






var $9nZCP = parcelRequire("9nZCP");
// export this package's api


function $d519476296871852$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d519476296871852$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d519476296871852$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d519476296871852$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d519476296871852$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d519476296871852$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d519476296871852$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d519476296871852$var$_typeof(obj);
}
function $d519476296871852$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d519476296871852$var$vendorPrefix;
var $d519476296871852$var$jsCssMap = {
    Webkit: "-webkit-",
    Moz: "-moz-",
    // IE did it wrong again ...
    ms: "-ms-",
    O: "-o-"
};
function $d519476296871852$var$getVendorPrefix() {
    if ($d519476296871852$var$vendorPrefix !== undefined) return $d519476296871852$var$vendorPrefix;
    $d519476296871852$var$vendorPrefix = "";
    var style = document.createElement("p").style;
    var testProp = "Transform";
    for(var key in $d519476296871852$var$jsCssMap)if (key + testProp in style) $d519476296871852$var$vendorPrefix = key;
    return $d519476296871852$var$vendorPrefix;
}
function $d519476296871852$var$getTransitionName() {
    return $d519476296871852$var$getVendorPrefix() ? "".concat($d519476296871852$var$getVendorPrefix(), "TransitionProperty") : "transitionProperty";
}
function $d519476296871852$var$getTransformName() {
    return $d519476296871852$var$getVendorPrefix() ? "".concat($d519476296871852$var$getVendorPrefix(), "Transform") : "transform";
}
function $d519476296871852$var$setTransitionProperty(node, value) {
    var name = $d519476296871852$var$getTransitionName();
    if (name) {
        node.style[name] = value;
        if (name !== "transitionProperty") node.style.transitionProperty = value;
    }
}
function $d519476296871852$var$setTransform(node, value) {
    var name = $d519476296871852$var$getTransformName();
    if (name) {
        node.style[name] = value;
        if (name !== "transform") node.style.transform = value;
    }
}
function $d519476296871852$var$getTransitionProperty(node) {
    return node.style.transitionProperty || node.style[$d519476296871852$var$getTransitionName()];
}
function $d519476296871852$var$getTransformXY(node) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue("transform") || style.getPropertyValue($d519476296871852$var$getTransformName());
    if (transform && transform !== "none") {
        var matrix = transform.replace(/[^0-9\-.,]/g, "").split(",");
        return {
            x: parseFloat(matrix[12] || matrix[4], 0),
            y: parseFloat(matrix[13] || matrix[5], 0)
        };
    }
    return {
        x: 0,
        y: 0
    };
}
var $d519476296871852$var$matrix2d = /matrix\((.*)\)/;
var $d519476296871852$var$matrix3d = /matrix3d\((.*)\)/;
function $d519476296871852$var$setTransformXY(node, xy) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue("transform") || style.getPropertyValue($d519476296871852$var$getTransformName());
    if (transform && transform !== "none") {
        var arr;
        var match2d = transform.match($d519476296871852$var$matrix2d);
        if (match2d) {
            match2d = match2d[1];
            arr = match2d.split(",").map(function(item) {
                return parseFloat(item, 10);
            });
            arr[4] = xy.x;
            arr[5] = xy.y;
            $d519476296871852$var$setTransform(node, "matrix(".concat(arr.join(","), ")"));
        } else {
            var match3d = transform.match($d519476296871852$var$matrix3d)[1];
            arr = match3d.split(",").map(function(item) {
                return parseFloat(item, 10);
            });
            arr[12] = xy.x;
            arr[13] = xy.y;
            $d519476296871852$var$setTransform(node, "matrix3d(".concat(arr.join(","), ")"));
        }
    } else $d519476296871852$var$setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
}
var $d519476296871852$var$RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var $d519476296871852$var$getComputedStyleX;
// https://stackoverflow.com/a/3485654/3040605
function $d519476296871852$var$forceRelayout(elem) {
    var originalStyle = elem.style.display;
    elem.style.display = "none";
    elem.offsetHeight; // eslint-disable-line
    elem.style.display = originalStyle;
}
function $d519476296871852$var$css(el, name, v) {
    var value = v;
    if ($d519476296871852$var$_typeof(name) === "object") {
        for(var i in name)if (name.hasOwnProperty(i)) $d519476296871852$var$css(el, i, name[i]);
        return undefined;
    }
    if (typeof value !== "undefined") {
        if (typeof value === "number") value = "".concat(value, "px");
        el.style[name] = value;
        return undefined;
    }
    return $d519476296871852$var$getComputedStyleX(el, name);
}
function $d519476296871852$var$getClientPosition(elem) {
    var box;
    var x;
    var y;
    var doc = elem.ownerDocument;
    var body = doc.body;
    var docElem = doc && doc.documentElement;
    // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
    box = elem.getBoundingClientRect();
    // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
    // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
    // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
    x = Math.floor(box.left);
    y = Math.floor(box.top);
    // In IE, most of the time, 2 extra pixels are added to the top and left
    // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
    // IE6 standards mode, this border can be overridden by setting the
    // document element's border to zero -- thus, we cannot rely on the
    // offset always being 2 pixels.
    // In quirks mode, the offset can be determined by querying the body's
    // clientLeft/clientTop, but in standards mode, it is found by querying
    // the document element's clientLeft/clientTop.  Since we already called
    // getClientBoundingRect we have already forced a reflow, so it is not
    // too expensive just to query them all.
    // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
    // 窗口边框标准是设 documentElement ,quirks 时设置 body
    // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
    // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
    // 标准 ie 下 docElem.clientTop 就是 border-top
    // ie7 html 即窗口边框改变不了。永远为 2
    // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
    x -= docElem.clientLeft || body.clientLeft || 0;
    y -= docElem.clientTop || body.clientTop || 0;
    return {
        left: x,
        top: y
    };
}
function $d519476296871852$var$getScroll(w, top) {
    var ret = w["page".concat(top ? "Y" : "X", "Offset")];
    var method = "scroll".concat(top ? "Top" : "Left");
    if (typeof ret !== "number") {
        var d = w.document;
        // ie6,7,8 standard mode
        ret = d.documentElement[method];
        if (typeof ret !== "number") // quirks mode
        ret = d.body[method];
    }
    return ret;
}
function $d519476296871852$var$getScrollLeft(w) {
    return $d519476296871852$var$getScroll(w);
}
function $d519476296871852$var$getScrollTop(w) {
    return $d519476296871852$var$getScroll(w, true);
}
function $d519476296871852$var$getOffset(el) {
    var pos = $d519476296871852$var$getClientPosition(el);
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $d519476296871852$var$getScrollLeft(w);
    pos.top += $d519476296871852$var$getScrollTop(w);
    return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */ function $d519476296871852$var$isWindow(obj) {
    // must use == for ie8
    /* eslint eqeqeq:0 */ return obj !== null && obj !== undefined && obj == obj.window;
}
function $d519476296871852$var$getDocument(node) {
    if ($d519476296871852$var$isWindow(node)) return node.document;
    if (node.nodeType === 9) return node;
    return node.ownerDocument;
}
function $d519476296871852$var$_getComputedStyle(elem, name, cs) {
    var computedStyle = cs;
    var val = "";
    var d = $d519476296871852$var$getDocument(elem);
    computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
    // https://github.com/kissyteam/kissy/issues/61
    if (computedStyle) val = computedStyle.getPropertyValue(name) || computedStyle[name];
    return val;
}
var $d519476296871852$var$_RE_NUM_NO_PX = new RegExp("^(".concat($d519476296871852$var$RE_NUM, ")(?!px)[a-z%]+$"), "i");
var $d519476296871852$var$RE_POS = /^(top|right|bottom|left)$/;
var $d519476296871852$var$CURRENT_STYLE = "currentStyle";
var $d519476296871852$var$RUNTIME_STYLE = "runtimeStyle";
var $d519476296871852$var$LEFT = "left";
var $d519476296871852$var$PX = "px";
function $d519476296871852$var$_getComputedStyleIE(elem, name) {
    // currentStyle maybe null
    // http://msdn.microsoft.com/en-us/library/ms535231.aspx
    var ret = elem[$d519476296871852$var$CURRENT_STYLE] && elem[$d519476296871852$var$CURRENT_STYLE][name];
    // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
    // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
    // 在 ie 下不对，需要直接用 offset 方式
    // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
    // From the awesome hack by Dean Edwards
    // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
    // If we're not dealing with a regular pixel number
    // but a number that has a weird ending, we need to convert it to pixels
    // exclude left right for relativity
    if ($d519476296871852$var$_RE_NUM_NO_PX.test(ret) && !$d519476296871852$var$RE_POS.test(name)) {
        // Remember the original values
        var style = elem.style;
        var left = style[$d519476296871852$var$LEFT];
        var rsLeft = elem[$d519476296871852$var$RUNTIME_STYLE][$d519476296871852$var$LEFT];
        // prevent flashing of content
        elem[$d519476296871852$var$RUNTIME_STYLE][$d519476296871852$var$LEFT] = elem[$d519476296871852$var$CURRENT_STYLE][$d519476296871852$var$LEFT];
        // Put in the new values to get a computed value out
        style[$d519476296871852$var$LEFT] = name === "fontSize" ? "1em" : ret || 0;
        ret = style.pixelLeft + $d519476296871852$var$PX;
        // Revert the changed values
        style[$d519476296871852$var$LEFT] = left;
        elem[$d519476296871852$var$RUNTIME_STYLE][$d519476296871852$var$LEFT] = rsLeft;
    }
    return ret === "" ? "auto" : ret;
}
if (typeof window !== "undefined") $d519476296871852$var$getComputedStyleX = window.getComputedStyle ? $d519476296871852$var$_getComputedStyle : $d519476296871852$var$_getComputedStyleIE;
function $d519476296871852$var$getOffsetDirection(dir, option) {
    if (dir === "left") return option.useCssRight ? "right" : dir;
    return option.useCssBottom ? "bottom" : dir;
}
function $d519476296871852$var$oppositeOffsetDirection(dir) {
    if (dir === "left") return "right";
    else if (dir === "right") return "left";
    else if (dir === "top") return "bottom";
    else if (dir === "bottom") return "top";
}
// 设置 elem 相对 elem.ownerDocument 的坐标
function $d519476296871852$var$setLeftTop(elem, offset, option) {
    // set position first, in-case top/left are set even on static elem
    if ($d519476296871852$var$css(elem, "position") === "static") elem.style.position = "relative";
    var presetH = -999;
    var presetV = -999;
    var horizontalProperty = $d519476296871852$var$getOffsetDirection("left", option);
    var verticalProperty = $d519476296871852$var$getOffsetDirection("top", option);
    var oppositeHorizontalProperty = $d519476296871852$var$oppositeOffsetDirection(horizontalProperty);
    var oppositeVerticalProperty = $d519476296871852$var$oppositeOffsetDirection(verticalProperty);
    if (horizontalProperty !== "left") presetH = 999;
    if (verticalProperty !== "top") presetV = 999;
    var originalTransition = "";
    var originalOffset = $d519476296871852$var$getOffset(elem);
    if ("left" in offset || "top" in offset) {
        originalTransition = $d519476296871852$var$getTransitionProperty(elem) || "";
        $d519476296871852$var$setTransitionProperty(elem, "none");
    }
    if ("left" in offset) {
        elem.style[oppositeHorizontalProperty] = "";
        elem.style[horizontalProperty] = "".concat(presetH, "px");
    }
    if ("top" in offset) {
        elem.style[oppositeVerticalProperty] = "";
        elem.style[verticalProperty] = "".concat(presetV, "px");
    }
    // force relayout
    $d519476296871852$var$forceRelayout(elem);
    var old = $d519476296871852$var$getOffset(elem);
    var originalStyle = {};
    for(var key in offset)if (offset.hasOwnProperty(key)) {
        var dir = $d519476296871852$var$getOffsetDirection(key, option);
        var preset = key === "left" ? presetH : presetV;
        var off = originalOffset[key] - old[key];
        if (dir === key) originalStyle[dir] = preset + off;
        else originalStyle[dir] = preset - off;
    }
    $d519476296871852$var$css(elem, originalStyle);
    // force relayout
    $d519476296871852$var$forceRelayout(elem);
    if ("left" in offset || "top" in offset) $d519476296871852$var$setTransitionProperty(elem, originalTransition);
    var ret = {};
    for(var _key in offset)if (offset.hasOwnProperty(_key)) {
        var _dir = $d519476296871852$var$getOffsetDirection(_key, option);
        var _off = offset[_key] - originalOffset[_key];
        if (_key === _dir) ret[_dir] = originalStyle[_dir] + _off;
        else ret[_dir] = originalStyle[_dir] - _off;
    }
    $d519476296871852$var$css(elem, ret);
}
function $d519476296871852$var$setTransform$1(elem, offset) {
    var originalOffset = $d519476296871852$var$getOffset(elem);
    var originalXY = $d519476296871852$var$getTransformXY(elem);
    var resultXY = {
        x: originalXY.x,
        y: originalXY.y
    };
    if ("left" in offset) resultXY.x = originalXY.x + offset.left - originalOffset.left;
    if ("top" in offset) resultXY.y = originalXY.y + offset.top - originalOffset.top;
    $d519476296871852$var$setTransformXY(elem, resultXY);
}
function $d519476296871852$var$setOffset(elem, offset, option) {
    if (option.ignoreShake) {
        var oriOffset = $d519476296871852$var$getOffset(elem);
        var oLeft = oriOffset.left.toFixed(0);
        var oTop = oriOffset.top.toFixed(0);
        var tLeft = offset.left.toFixed(0);
        var tTop = offset.top.toFixed(0);
        if (oLeft === tLeft && oTop === tTop) return;
    }
    if (option.useCssRight || option.useCssBottom) $d519476296871852$var$setLeftTop(elem, offset, option);
    else if (option.useCssTransform && $d519476296871852$var$getTransformName() in document.body.style) $d519476296871852$var$setTransform$1(elem, offset);
    else $d519476296871852$var$setLeftTop(elem, offset, option);
}
function $d519476296871852$var$each(arr, fn) {
    for(var i = 0; i < arr.length; i++)fn(arr[i]);
}
function $d519476296871852$var$isBorderBoxFn(elem) {
    return $d519476296871852$var$getComputedStyleX(elem, "boxSizing") === "border-box";
}
var $d519476296871852$var$BOX_MODELS = [
    "margin",
    "border",
    "padding"
];
var $d519476296871852$var$CONTENT_INDEX = -1;
var $d519476296871852$var$PADDING_INDEX = 2;
var $d519476296871852$var$BORDER_INDEX = 1;
var $d519476296871852$var$MARGIN_INDEX = 0;
function $d519476296871852$var$swap(elem, options, callback) {
    var old = {};
    var style = elem.style;
    var name;
    // Remember the old values, and insert the new ones
    for(name in options)if (options.hasOwnProperty(name)) {
        old[name] = style[name];
        style[name] = options[name];
    }
    callback.call(elem);
    // Revert the old values
    for(name in options)if (options.hasOwnProperty(name)) style[name] = old[name];
}
function $d519476296871852$var$getPBMWidth(elem, props, which) {
    var value = 0;
    var prop;
    var j;
    var i;
    for(j = 0; j < props.length; j++){
        prop = props[j];
        if (prop) for(i = 0; i < which.length; i++){
            var cssProp = void 0;
            if (prop === "border") cssProp = "".concat(prop).concat(which[i], "Width");
            else cssProp = prop + which[i];
            value += parseFloat($d519476296871852$var$getComputedStyleX(elem, cssProp)) || 0;
        }
    }
    return value;
}
var $d519476296871852$var$domUtils = {
    getParent: function getParent(element) {
        var parent = element;
        do if (parent.nodeType === 11 && parent.host) parent = parent.host;
        else parent = parent.parentNode;
        while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
        return parent;
    }
};
$d519476296871852$var$each([
    "Width",
    "Height"
], function(name) {
    $d519476296871852$var$domUtils["doc".concat(name)] = function(refWin) {
        var d = refWin.document;
        return Math.max(// firefox chrome documentElement.scrollHeight< body.scrollHeight
        // ie standard mode : documentElement.scrollHeight> body.scrollHeight
        d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
        d.body["scroll".concat(name)], $d519476296871852$var$domUtils["viewport".concat(name)](d));
    };
    $d519476296871852$var$domUtils["viewport".concat(name)] = function(win) {
        // pc browser includes scrollbar in window.innerWidth
        var prop = "client".concat(name);
        var doc = win.document;
        var body = doc.body;
        var documentElement = doc.documentElement;
        var documentElementProp = documentElement[prop];
        // 标准模式取 documentElement
        // backcompat 取 body
        return doc.compatMode === "CSS1Compat" && documentElementProp || body && body[prop] || documentElementProp;
    };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */ function $d519476296871852$var$getWH(elem, name, ex) {
    var extra = ex;
    if ($d519476296871852$var$isWindow(elem)) return name === "width" ? $d519476296871852$var$domUtils.viewportWidth(elem) : $d519476296871852$var$domUtils.viewportHeight(elem);
    else if (elem.nodeType === 9) return name === "width" ? $d519476296871852$var$domUtils.docWidth(elem) : $d519476296871852$var$domUtils.docHeight(elem);
    var which = name === "width" ? [
        "Left",
        "Right"
    ] : [
        "Top",
        "Bottom"
    ];
    var borderBoxValue = name === "width" ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
    var isBorderBox = $d519476296871852$var$isBorderBoxFn(elem);
    var cssBoxValue = 0;
    if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
        borderBoxValue = undefined;
        // Fall back to computed then un computed css if necessary
        cssBoxValue = $d519476296871852$var$getComputedStyleX(elem, name);
        if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) cssBoxValue = elem.style[name] || 0;
        // Normalize '', auto, and prepare for extra
        cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
    }
    if (extra === undefined) extra = isBorderBox ? $d519476296871852$var$BORDER_INDEX : $d519476296871852$var$CONTENT_INDEX;
    var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
    var val = borderBoxValue || cssBoxValue;
    if (extra === $d519476296871852$var$CONTENT_INDEX) {
        if (borderBoxValueOrIsBorderBox) return val - $d519476296871852$var$getPBMWidth(elem, [
            "border",
            "padding"
        ], which);
        return cssBoxValue;
    } else if (borderBoxValueOrIsBorderBox) {
        if (extra === $d519476296871852$var$BORDER_INDEX) return val;
        return val + (extra === $d519476296871852$var$PADDING_INDEX ? -$d519476296871852$var$getPBMWidth(elem, [
            "border"
        ], which) : $d519476296871852$var$getPBMWidth(elem, [
            "margin"
        ], which));
    }
    return cssBoxValue + $d519476296871852$var$getPBMWidth(elem, $d519476296871852$var$BOX_MODELS.slice(extra), which);
}
var $d519476296871852$var$cssShow = {
    position: "absolute",
    visibility: "hidden",
    display: "block"
};
// fix #119 : https://github.com/kissyteam/kissy/issues/119
function $d519476296871852$var$getWHIgnoreDisplay() {
    for(var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++)args[_key2] = arguments[_key2];
    var val;
    var elem = args[0];
    // in case elem is window
    // elem.offsetWidth === undefined
    if (elem.offsetWidth !== 0) val = $d519476296871852$var$getWH.apply(undefined, args);
    else $d519476296871852$var$swap(elem, $d519476296871852$var$cssShow, function() {
        val = $d519476296871852$var$getWH.apply(undefined, args);
    });
    return val;
}
$d519476296871852$var$each([
    "width",
    "height"
], function(name) {
    var first = name.charAt(0).toUpperCase() + name.slice(1);
    $d519476296871852$var$domUtils["outer".concat(first)] = function(el, includeMargin) {
        return el && $d519476296871852$var$getWHIgnoreDisplay(el, name, includeMargin ? $d519476296871852$var$MARGIN_INDEX : $d519476296871852$var$BORDER_INDEX);
    };
    var which = name === "width" ? [
        "Left",
        "Right"
    ] : [
        "Top",
        "Bottom"
    ];
    $d519476296871852$var$domUtils[name] = function(elem, v) {
        var val = v;
        if (val !== undefined) {
            if (elem) {
                var isBorderBox = $d519476296871852$var$isBorderBoxFn(elem);
                if (isBorderBox) val += $d519476296871852$var$getPBMWidth(elem, [
                    "padding",
                    "border"
                ], which);
                return $d519476296871852$var$css(elem, name, val);
            }
            return undefined;
        }
        return elem && $d519476296871852$var$getWHIgnoreDisplay(elem, name, $d519476296871852$var$CONTENT_INDEX);
    };
});
function $d519476296871852$var$mix(to, from) {
    for(var i in from)if (from.hasOwnProperty(i)) to[i] = from[i];
    return to;
}
var $d519476296871852$var$utils = {
    getWindow: function getWindow(node) {
        if (node && node.document && node.setTimeout) return node;
        var doc = node.ownerDocument || node;
        return doc.defaultView || doc.parentWindow;
    },
    getDocument: $d519476296871852$var$getDocument,
    offset: function offset(el, value, option) {
        if (typeof value !== "undefined") $d519476296871852$var$setOffset(el, value, option || {});
        else return $d519476296871852$var$getOffset(el);
    },
    isWindow: $d519476296871852$var$isWindow,
    each: $d519476296871852$var$each,
    css: $d519476296871852$var$css,
    clone: function clone(obj) {
        var i;
        var ret = {};
        for(i in obj)if (obj.hasOwnProperty(i)) ret[i] = obj[i];
        var overflow = obj.overflow;
        if (overflow) {
            for(i in obj)if (obj.hasOwnProperty(i)) ret.overflow[i] = obj.overflow[i];
        }
        return ret;
    },
    mix: $d519476296871852$var$mix,
    getWindowScrollLeft: function getWindowScrollLeft(w) {
        return $d519476296871852$var$getScrollLeft(w);
    },
    getWindowScrollTop: function getWindowScrollTop(w) {
        return $d519476296871852$var$getScrollTop(w);
    },
    merge: function merge() {
        var ret = {};
        for(var i = 0; i < arguments.length; i++)$d519476296871852$var$utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
        return ret;
    },
    viewportWidth: 0,
    viewportHeight: 0
};
$d519476296871852$var$mix($d519476296871852$var$utils, $d519476296871852$var$domUtils);
/**
 * 得到会导致元素显示不全的祖先元素
 */ var $d519476296871852$var$getParent = $d519476296871852$var$utils.getParent;
function $d519476296871852$var$getOffsetParent(element) {
    if ($d519476296871852$var$utils.isWindow(element) || element.nodeType === 9) return null;
    // ie 这个也不是完全可行
    /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */ // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
    //  In other browsers it only includes elements with position absolute, relative or
    // fixed, not elements with overflow set to auto or scroll.
    //        if (UA.ie && ieMode < 8) {
    //            return element.offsetParent;
    //        }
    // 统一的 offsetParent 方法
    var doc = $d519476296871852$var$utils.getDocument(element);
    var body = doc.body;
    var parent;
    var positionStyle = $d519476296871852$var$utils.css(element, "position");
    var skipStatic = positionStyle === "fixed" || positionStyle === "absolute";
    if (!skipStatic) return element.nodeName.toLowerCase() === "html" ? null : $d519476296871852$var$getParent(element);
    for(parent = $d519476296871852$var$getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = $d519476296871852$var$getParent(parent)){
        positionStyle = $d519476296871852$var$utils.css(parent, "position");
        if (positionStyle !== "static") return parent;
    }
    return null;
}
var $d519476296871852$var$getParent$1 = $d519476296871852$var$utils.getParent;
function $d519476296871852$var$isAncestorFixed(element) {
    if ($d519476296871852$var$utils.isWindow(element) || element.nodeType === 9) return false;
    var doc = $d519476296871852$var$utils.getDocument(element);
    var body = doc.body;
    var parent = null;
    for(parent = $d519476296871852$var$getParent$1(element); // 修复元素位于 document.documentElement 下导致崩溃问题
    parent && parent !== body && parent !== doc; parent = $d519476296871852$var$getParent$1(parent)){
        var positionStyle = $d519476296871852$var$utils.css(parent, "position");
        if (positionStyle === "fixed") return true;
    }
    return false;
}
/**
 * 获得元素的显示部分的区域
 */ function $d519476296871852$var$getVisibleRectForElement(element, alwaysByViewport) {
    var visibleRect = {
        left: 0,
        right: Infinity,
        top: 0,
        bottom: Infinity
    };
    var el = $d519476296871852$var$getOffsetParent(element);
    var doc = $d519476296871852$var$utils.getDocument(element);
    var win = doc.defaultView || doc.parentWindow;
    var body = doc.body;
    var documentElement = doc.documentElement;
    // Determine the size of the visible rect by climbing the dom accounting for
    // all scrollable containers.
    while(el){
        // clientWidth is zero for inline block elements in ie.
        if ((navigator.userAgent.indexOf("MSIE") === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
        // viewport. In some browsers, el.offsetParent may be
        // document.documentElement, so check for that too.
        el !== body && el !== documentElement && $d519476296871852$var$utils.css(el, "overflow") !== "visible") {
            var pos = $d519476296871852$var$utils.offset(el);
            // add border
            pos.left += el.clientLeft;
            pos.top += el.clientTop;
            visibleRect.top = Math.max(visibleRect.top, pos.top);
            visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
            pos.left + el.clientWidth);
            visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
            visibleRect.left = Math.max(visibleRect.left, pos.left);
        } else if (el === body || el === documentElement) break;
        el = $d519476296871852$var$getOffsetParent(el);
    }
    // Set element position to fixed
    // make sure absolute element itself don't affect it's visible area
    // https://github.com/ant-design/ant-design/issues/7601
    var originalPosition = null;
    if (!$d519476296871852$var$utils.isWindow(element) && element.nodeType !== 9) {
        originalPosition = element.style.position;
        var position = $d519476296871852$var$utils.css(element, "position");
        if (position === "absolute") element.style.position = "fixed";
    }
    var scrollX = $d519476296871852$var$utils.getWindowScrollLeft(win);
    var scrollY = $d519476296871852$var$utils.getWindowScrollTop(win);
    var viewportWidth = $d519476296871852$var$utils.viewportWidth(win);
    var viewportHeight = $d519476296871852$var$utils.viewportHeight(win);
    var documentWidth = documentElement.scrollWidth;
    var documentHeight = documentElement.scrollHeight;
    // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
    // We should cut this ourself.
    var bodyStyle = window.getComputedStyle(body);
    if (bodyStyle.overflowX === "hidden") documentWidth = win.innerWidth;
    if (bodyStyle.overflowY === "hidden") documentHeight = win.innerHeight;
    // Reset element position after calculate the visible area
    if (element.style) element.style.position = originalPosition;
    if (alwaysByViewport || $d519476296871852$var$isAncestorFixed(element)) {
        // Clip by viewport's size.
        visibleRect.left = Math.max(visibleRect.left, scrollX);
        visibleRect.top = Math.max(visibleRect.top, scrollY);
        visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
        visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
    } else {
        // Clip by document's size.
        var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
        visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
        var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
        visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
    }
    return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}
function $d519476296871852$var$adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
    var pos = $d519476296871852$var$utils.clone(elFuturePos);
    var size = {
        width: elRegion.width,
        height: elRegion.height
    };
    if (overflow.adjustX && pos.left < visibleRect.left) pos.left = visibleRect.left;
    // Left edge inside and right edge outside viewport, try to resize it.
    if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) size.width -= pos.left + size.width - visibleRect.right;
    // Right edge outside viewport, try to move it.
    if (overflow.adjustX && pos.left + size.width > visibleRect.right) // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
    // Top edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top < visibleRect.top) pos.top = visibleRect.top;
    // Top edge inside and bottom edge outside viewport, try to resize it.
    if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) size.height -= pos.top + size.height - visibleRect.bottom;
    // Bottom edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
    return $d519476296871852$var$utils.mix(pos, size);
}
function $d519476296871852$var$getRegion(node) {
    var offset;
    var w;
    var h;
    if (!$d519476296871852$var$utils.isWindow(node) && node.nodeType !== 9) {
        offset = $d519476296871852$var$utils.offset(node);
        w = $d519476296871852$var$utils.outerWidth(node);
        h = $d519476296871852$var$utils.outerHeight(node);
    } else {
        var win = $d519476296871852$var$utils.getWindow(node);
        offset = {
            left: $d519476296871852$var$utils.getWindowScrollLeft(win),
            top: $d519476296871852$var$utils.getWindowScrollTop(win)
        };
        w = $d519476296871852$var$utils.viewportWidth(win);
        h = $d519476296871852$var$utils.viewportHeight(win);
    }
    offset.width = w;
    offset.height = h;
    return offset;
}
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */ function $d519476296871852$var$getAlignOffset(region, align) {
    var V = align.charAt(0);
    var H = align.charAt(1);
    var w = region.width;
    var h = region.height;
    var x = region.left;
    var y = region.top;
    if (V === "c") y += h / 2;
    else if (V === "b") y += h;
    if (H === "c") x += w / 2;
    else if (H === "r") x += w;
    return {
        left: x,
        top: y
    };
}
function $d519476296871852$var$getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
    var p1 = $d519476296871852$var$getAlignOffset(refNodeRegion, points[1]);
    var p2 = $d519476296871852$var$getAlignOffset(elRegion, points[0]);
    var diff = [
        p2.left - p1.left,
        p2.top - p1.top
    ];
    return {
        left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
        top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
    };
}
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */ // http://yiminghe.iteye.com/blog/1124720
function $d519476296871852$var$isFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function $d519476296871852$var$isFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function $d519476296871852$var$isCompleteFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function $d519476296871852$var$isCompleteFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function $d519476296871852$var$flip(points, reg, map) {
    var ret = [];
    $d519476296871852$var$utils.each(points, function(p) {
        ret.push(p.replace(reg, function(m) {
            return map[m];
        }));
    });
    return ret;
}
function $d519476296871852$var$flipOffset(offset, index) {
    offset[index] = -offset[index];
    return offset;
}
function $d519476296871852$var$convertOffset(str, offsetLen) {
    var n;
    if (/%$/.test(str)) n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
    else n = parseInt(str, 10);
    return n || 0;
}
function $d519476296871852$var$normalizeOffset(offset, el) {
    offset[0] = $d519476296871852$var$convertOffset(offset[0], el.width);
    offset[1] = $d519476296871852$var$convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */ function $d519476296871852$var$doAlign(el, tgtRegion, align, isTgtRegionVisible) {
    var points = align.points;
    var offset = align.offset || [
        0,
        0
    ];
    var targetOffset = align.targetOffset || [
        0,
        0
    ];
    var overflow = align.overflow;
    var source = align.source || el;
    offset = [].concat(offset);
    targetOffset = [].concat(targetOffset);
    overflow = overflow || {};
    var newOverflowCfg = {};
    var fail = 0;
    var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
    // 当前节点可以被放置的显示区域
    var visibleRect = $d519476296871852$var$getVisibleRectForElement(source, alwaysByViewport);
    // 当前节点所占的区域, left/top/width/height
    var elRegion = $d519476296871852$var$getRegion(source);
    // 将 offset 转换成数值，支持百分比
    $d519476296871852$var$normalizeOffset(offset, elRegion);
    $d519476296871852$var$normalizeOffset(targetOffset, tgtRegion);
    // 当前节点将要被放置的位置
    var elFuturePos = $d519476296871852$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
    // 当前节点将要所处的区域
    var newElRegion = $d519476296871852$var$utils.merge(elRegion, elFuturePos);
    // 如果可视区域不能完全放置当前节点时允许调整
    if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
        if (overflow.adjustX) // 如果横向不能放下
        {
            if ($d519476296871852$var$isFailX(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var newPoints = $d519476296871852$var$flip(points, /[lr]/gi, {
                    l: "r",
                    r: "l"
                });
                // 偏移量也反下
                var newOffset = $d519476296871852$var$flipOffset(offset, 0);
                var newTargetOffset = $d519476296871852$var$flipOffset(targetOffset, 0);
                var newElFuturePos = $d519476296871852$var$getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
                if (!$d519476296871852$var$isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = newPoints;
                    offset = newOffset;
                    targetOffset = newTargetOffset;
                }
            }
        }
        if (overflow.adjustY) // 如果纵向不能放下
        {
            if ($d519476296871852$var$isFailY(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var _newPoints = $d519476296871852$var$flip(points, /[tb]/gi, {
                    t: "b",
                    b: "t"
                });
                // 偏移量也反下
                var _newOffset = $d519476296871852$var$flipOffset(offset, 1);
                var _newTargetOffset = $d519476296871852$var$flipOffset(targetOffset, 1);
                var _newElFuturePos = $d519476296871852$var$getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
                if (!$d519476296871852$var$isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = _newPoints;
                    offset = _newOffset;
                    targetOffset = _newTargetOffset;
                }
            }
        }
        // 如果失败，重新计算当前节点将要被放置的位置
        if (fail) {
            elFuturePos = $d519476296871852$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
            $d519476296871852$var$utils.mix(newElRegion, elFuturePos);
        }
        var isStillFailX = $d519476296871852$var$isFailX(elFuturePos, elRegion, visibleRect);
        var isStillFailY = $d519476296871852$var$isFailY(elFuturePos, elRegion, visibleRect);
        // 检查反下后的位置是否可以放下了，如果仍然放不下：
        // 1. 复原修改过的定位参数
        if (isStillFailX || isStillFailY) {
            var _newPoints2 = points;
            // 重置对应部分的翻转逻辑
            if (isStillFailX) _newPoints2 = $d519476296871852$var$flip(points, /[lr]/gi, {
                l: "r",
                r: "l"
            });
            if (isStillFailY) _newPoints2 = $d519476296871852$var$flip(points, /[tb]/gi, {
                t: "b",
                b: "t"
            });
            points = _newPoints2;
            offset = align.offset || [
                0,
                0
            ];
            targetOffset = align.targetOffset || [
                0,
                0
            ];
        }
        // 2. 只有指定了可以调整当前方向才调整
        newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
        newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
        // 确实要调整，甚至可能会调整高度宽度
        if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) newElRegion = $d519476296871852$var$adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
    // need judge to in case set fixed with in css on height auto element
    if (newElRegion.width !== elRegion.width) $d519476296871852$var$utils.css(source, "width", $d519476296871852$var$utils.width(source) + newElRegion.width - elRegion.width);
    if (newElRegion.height !== elRegion.height) $d519476296871852$var$utils.css(source, "height", $d519476296871852$var$utils.height(source) + newElRegion.height - elRegion.height);
    // https://github.com/kissyteam/kissy/issues/190
    // 相对于屏幕位置没变，而 left/top 变了
    // 例如 <div 'relative'><el absolute></div>
    $d519476296871852$var$utils.offset(source, {
        left: newElRegion.left,
        top: newElRegion.top
    }, {
        useCssRight: align.useCssRight,
        useCssBottom: align.useCssBottom,
        useCssTransform: align.useCssTransform,
        ignoreShake: align.ignoreShake
    });
    return {
        points: points,
        offset: offset,
        targetOffset: targetOffset,
        overflow: newOverflowCfg
    };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/ function $d519476296871852$var$isOutOfVisibleRect(target, alwaysByViewport) {
    var visibleRect = $d519476296871852$var$getVisibleRectForElement(target, alwaysByViewport);
    var targetRegion = $d519476296871852$var$getRegion(target);
    return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function $d519476296871852$export$ec21431d5ee6c534(el, refNode, align) {
    var target = align.target || refNode;
    var refNodeRegion = $d519476296871852$var$getRegion(target);
    var isTargetNotOutOfVisible = !$d519476296871852$var$isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
    return $d519476296871852$var$doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
$d519476296871852$export$ec21431d5ee6c534.__getOffsetParent = $d519476296871852$var$getOffsetParent;
$d519476296871852$export$ec21431d5ee6c534.__getVisibleRectForElement = $d519476296871852$var$getVisibleRectForElement;
/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */ function $d519476296871852$export$38f0e12f0aa28098(el, tgtPoint, align) {
    var pageX;
    var pageY;
    var doc = $d519476296871852$var$utils.getDocument(el);
    var win = doc.defaultView || doc.parentWindow;
    var scrollX = $d519476296871852$var$utils.getWindowScrollLeft(win);
    var scrollY = $d519476296871852$var$utils.getWindowScrollTop(win);
    var viewportWidth = $d519476296871852$var$utils.viewportWidth(win);
    var viewportHeight = $d519476296871852$var$utils.viewportHeight(win);
    if ("pageX" in tgtPoint) pageX = tgtPoint.pageX;
    else pageX = scrollX + tgtPoint.clientX;
    if ("pageY" in tgtPoint) pageY = tgtPoint.pageY;
    else pageY = scrollY + tgtPoint.clientY;
    var tgtRegion = {
        left: pageX,
        top: pageY,
        width: 0,
        height: 0
    };
    var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
    // Provide default target point
    var points = [
        align.points[0],
        "cc"
    ];
    return $d519476296871852$var$doAlign(el, tgtRegion, $d519476296871852$var$_objectSpread2($d519476296871852$var$_objectSpread2({}, align), {}, {
        points: points
    }), pointInView);
}
var $d519476296871852$export$2e2bcd8739ae039 = $d519476296871852$export$ec21431d5ee6c534;




/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $e5e5184330c59443$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $c196facde74adb39$export$2e2bcd8739ae039)(!circular, "Warning: There may be circular references");
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(a) === "object" && (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(b) === "object") {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $e5e5184330c59443$export$2e2bcd8739ae039 = $e5e5184330c59443$var$isEqual;



var $00310ab02d24bab6$export$2e2bcd8739ae039 = function(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};



var $9nZCP = parcelRequire("9nZCP");

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $5c3e3cad1a762d0b$var$useInternalLayoutEffect = (0, $f14589e789dffb0e$export$2e2bcd8739ae039)() ? $9nZCP.useLayoutEffect : $9nZCP.useEffect;
var $5c3e3cad1a762d0b$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $9nZCP.useRef(true);
    $5c3e3cad1a762d0b$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $5c3e3cad1a762d0b$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $5c3e3cad1a762d0b$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $5c3e3cad1a762d0b$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $5c3e3cad1a762d0b$export$2e2bcd8739ae039 = $5c3e3cad1a762d0b$var$useLayoutEffect;




var $9nZCP = parcelRequire("9nZCP");

var $9nZCP = parcelRequire("9nZCP");
var $b83890186fb16bb5$export$2e2bcd8739ae039 = function(callback, buffer) {
    var calledRef = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useRef(false);
    var timeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useRef(null);
    function cancelTrigger() {
        window.clearTimeout(timeoutRef.current);
    }
    function trigger(force) {
        cancelTrigger();
        if (!calledRef.current || force === true) {
            if (callback(force) === false) // Not delay since callback cancelled self
            return;
            calledRef.current = true;
            timeoutRef.current = window.setTimeout(function() {
                calledRef.current = false;
            }, buffer);
        } else timeoutRef.current = window.setTimeout(function() {
            calledRef.current = false;
            trigger();
        }, buffer);
    }
    return [
        trigger,
        function() {
            calledRef.current = false;
            cancelTrigger();
        }
    ];
};



/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $8da7b27379e7687c$var$MapShim = function() {
    if (typeof Map !== "undefined") return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $8da7b27379e7687c$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
// Returns global object of a current environment.
var $8da7b27379e7687c$var$global$1 = function() {
    if (typeof $parcel$global !== "undefined" && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== "undefined" && self.Math === Math) return self;
    if (typeof window !== "undefined" && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function("return this")();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $8da7b27379e7687c$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === "function") // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($8da7b27379e7687c$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $8da7b27379e7687c$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $8da7b27379e7687c$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $8da7b27379e7687c$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $8da7b27379e7687c$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $8da7b27379e7687c$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $8da7b27379e7687c$var$transitionKeys = [
    "top",
    "right",
    "bottom",
    "left",
    "width",
    "height",
    "size",
    "weight"
];
// Check if MutationObserver is available.
var $8da7b27379e7687c$var$mutationObserverSupported = typeof MutationObserver !== "undefined";
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $8da7b27379e7687c$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $8da7b27379e7687c$var$throttle(this.refresh.bind(this), $8da7b27379e7687c$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$8da7b27379e7687c$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener("transitionend", this.onTransitionEnd_);
        window.addEventListener("resize", this.refresh);
        if ($8da7b27379e7687c$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener("DOMSubtreeModified", this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$8da7b27379e7687c$var$isBrowser || !this.connected_) return;
        document.removeEventListener("transitionend", this.onTransitionEnd_);
        window.removeEventListener("resize", this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener("DOMSubtreeModified", this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $8da7b27379e7687c$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $8da7b27379e7687c$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $8da7b27379e7687c$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $8da7b27379e7687c$var$global$1;
};
// Placeholder of an empty content rectangle.
var $8da7b27379e7687c$var$emptyRect = $8da7b27379e7687c$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $8da7b27379e7687c$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $8da7b27379e7687c$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles["border-" + position + "-width"];
        return size + $8da7b27379e7687c$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $8da7b27379e7687c$var$getPaddings(styles) {
    var positions = [
        "top",
        "right",
        "bottom",
        "left"
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles["padding-" + position];
        paddings[position] = $8da7b27379e7687c$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $8da7b27379e7687c$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $8da7b27379e7687c$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $8da7b27379e7687c$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $8da7b27379e7687c$var$emptyRect;
    var styles = $8da7b27379e7687c$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $8da7b27379e7687c$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $8da7b27379e7687c$var$toFloat(styles.width), height = $8da7b27379e7687c$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === "border-box") {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $8da7b27379e7687c$var$getBordersSize(styles, "left", "right") + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $8da7b27379e7687c$var$getBordersSize(styles, "top", "bottom") + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$8da7b27379e7687c$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $8da7b27379e7687c$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $8da7b27379e7687c$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== "undefined") return function(target) {
        return target instanceof $8da7b27379e7687c$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $8da7b27379e7687c$var$getWindowOf(target).SVGElement && typeof target.getBBox === "function";
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $8da7b27379e7687c$var$isDocumentElement(target) {
    return target === $8da7b27379e7687c$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $8da7b27379e7687c$var$getContentRect(target) {
    if (!$8da7b27379e7687c$var$isBrowser) return $8da7b27379e7687c$var$emptyRect;
    if ($8da7b27379e7687c$var$isSVGGraphicsElement(target)) return $8da7b27379e7687c$var$getSVGContentRect(target);
    return $8da7b27379e7687c$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $8da7b27379e7687c$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $8da7b27379e7687c$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $8da7b27379e7687c$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $8da7b27379e7687c$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $8da7b27379e7687c$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $8da7b27379e7687c$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $8da7b27379e7687c$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $8da7b27379e7687c$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $8da7b27379e7687c$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $8da7b27379e7687c$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $8da7b27379e7687c$var$MapShim();
        if (typeof callback !== "function") throw new TypeError("The callback provided as parameter 1 is not a function.");
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $8da7b27379e7687c$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $8da7b27379e7687c$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $8da7b27379e7687c$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $8da7b27379e7687c$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $8da7b27379e7687c$var$observers = typeof WeakMap !== "undefined" ? new WeakMap() : new $8da7b27379e7687c$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $8da7b27379e7687c$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var controller = $8da7b27379e7687c$var$ResizeObserverController.getInstance();
        var observer = new $8da7b27379e7687c$var$ResizeObserverSPI(callback, controller, this);
        $8da7b27379e7687c$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    "observe",
    "unobserve",
    "disconnect"
].forEach(function(method) {
    $8da7b27379e7687c$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $8da7b27379e7687c$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $8da7b27379e7687c$var$index = function() {
    // Export existing implementation if available.
    if (typeof $8da7b27379e7687c$var$global$1.ResizeObserver !== "undefined") return $8da7b27379e7687c$var$global$1.ResizeObserver;
    return $8da7b27379e7687c$var$ResizeObserver;
}();
var $8da7b27379e7687c$export$2e2bcd8739ae039 = $8da7b27379e7687c$var$index;



function $86cbc0da93c4c577$export$792a4d7b8e9efb33(prev, next) {
    if (prev === next) return true;
    if (!prev || !next) return false;
    if ("pageX" in next && "pageY" in next) return prev.pageX === next.pageX && prev.pageY === next.pageY;
    if ("clientX" in next && "clientY" in next) return prev.clientX === next.clientX && prev.clientY === next.clientY;
    return false;
}
function $86cbc0da93c4c577$export$2284e449d64b22d5(activeElement, container) {
    // Focus back if is in the container
    if (activeElement !== document.activeElement && (0, $a5f4fb2511f41816$export$2e2bcd8739ae039)(container, activeElement) && typeof activeElement.focus === "function") activeElement.focus();
}
function $86cbc0da93c4c577$export$f56787db9e74dfe(element, callback) {
    var prevWidth = null;
    var prevHeight = null;
    function onResize(_ref) {
        var _ref2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_ref, 1), target = _ref2[0].target;
        if (!document.documentElement.contains(target)) return;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) // https://webkit.org/blog/9997/resizeobserver-in-webkit/
        Promise.resolve().then(function() {
            callback({
                width: fixedWidth,
                height: fixedHeight
            });
        });
        prevWidth = fixedWidth;
        prevHeight = fixedHeight;
    }
    var resizeObserver = new (0, $8da7b27379e7687c$export$2e2bcd8739ae039)(onResize);
    if (element) resizeObserver.observe(element);
    return function() {
        resizeObserver.disconnect();
    };
}


function $38129e366659dd04$var$getElement(func) {
    if (typeof func !== "function") return null;
    return func();
}
function $38129e366659dd04$var$getPoint(point) {
    if ((0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(point) !== "object" || !point) return null;
    return point;
}
var $38129e366659dd04$var$Align = function Align(_ref, ref) {
    var children = _ref.children, disabled = _ref.disabled, target = _ref.target, align = _ref.align, onAlign = _ref.onAlign, monitorWindowResize = _ref.monitorWindowResize, _ref$monitorBufferTim = _ref.monitorBufferTime, monitorBufferTime = _ref$monitorBufferTim === void 0 ? 0 : _ref$monitorBufferTim;
    var cacheRef = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useRef({});
    /** Popup node ref */ var nodeRef = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useRef();
    var childNode = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).Children.only(children); // ===================== Align ======================
    // We save the props here to avoid closure makes props ood
    var forceAlignPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useRef({});
    forceAlignPropsRef.current.disabled = disabled;
    forceAlignPropsRef.current.target = target;
    forceAlignPropsRef.current.align = align;
    forceAlignPropsRef.current.onAlign = onAlign;
    var _useBuffer = (0, $b83890186fb16bb5$export$2e2bcd8739ae039)(function() {
        var _forceAlignPropsRef$c = forceAlignPropsRef.current, latestDisabled = _forceAlignPropsRef$c.disabled, latestTarget = _forceAlignPropsRef$c.target, latestAlign = _forceAlignPropsRef$c.align, latestOnAlign = _forceAlignPropsRef$c.onAlign;
        var source = nodeRef.current;
        if (!latestDisabled && latestTarget && source) {
            var _result;
            var _element = $38129e366659dd04$var$getElement(latestTarget);
            var _point = $38129e366659dd04$var$getPoint(latestTarget);
            cacheRef.current.element = _element;
            cacheRef.current.point = _point;
            cacheRef.current.align = latestAlign; // IE lose focus after element realign
            // We should record activeElement and restore later
            var _document = document, activeElement = _document.activeElement; // We only align when element is visible
            if (_element && (0, $00310ab02d24bab6$export$2e2bcd8739ae039)(_element)) _result = (0, $d519476296871852$export$ec21431d5ee6c534)(source, _element, latestAlign);
            else if (_point) _result = (0, $d519476296871852$export$38f0e12f0aa28098)(source, _point, latestAlign);
            (0, $86cbc0da93c4c577$export$2284e449d64b22d5)(activeElement, source);
            if (latestOnAlign && _result) latestOnAlign(source, _result);
            return true;
        }
        return false;
    }, monitorBufferTime), _useBuffer2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useBuffer, 2), _forceAlign = _useBuffer2[0], cancelForceAlign = _useBuffer2[1]; // ===================== Effect =====================
    // Handle props change
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useState(), _React$useState2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useState(), _React$useState4 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_React$useState3, 2), point = _React$useState4[0], setPoint = _React$useState4[1];
    (0, $5c3e3cad1a762d0b$export$2e2bcd8739ae039)(function() {
        setElement($38129e366659dd04$var$getElement(target));
        setPoint($38129e366659dd04$var$getPoint(target));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useEffect(function() {
        if (cacheRef.current.element !== element || !(0, $86cbc0da93c4c577$export$792a4d7b8e9efb33)(cacheRef.current.point, point) || !(0, $e5e5184330c59443$export$2e2bcd8739ae039)(cacheRef.current.align, align)) _forceAlign();
    }); // Watch popup element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useEffect(function() {
        var cancelFn = (0, $86cbc0da93c4c577$export$f56787db9e74dfe)(nodeRef.current, _forceAlign);
        return cancelFn;
    }, [
        nodeRef.current
    ]); // Watch target element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useEffect(function() {
        var cancelFn = (0, $86cbc0da93c4c577$export$f56787db9e74dfe)(element, _forceAlign);
        return cancelFn;
    }, [
        element
    ]); // Listen for disabled change
    (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useEffect(function() {
        if (!disabled) _forceAlign();
        else cancelForceAlign();
    }, [
        disabled
    ]); // Listen for window resize
    (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useEffect(function() {
        if (monitorWindowResize) {
            var cancelFn = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(window, "resize", _forceAlign);
            return cancelFn.remove;
        }
    }, [
        monitorWindowResize
    ]); // Clear all if unmount
    (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useEffect(function() {
        return function() {
            cancelForceAlign();
        };
    }, []); // ====================== Ref =======================
    (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {
                return _forceAlign(true);
            }
        };
    }); // ===================== Render =====================
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).isValidElement(childNode)) childNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).cloneElement(childNode, {
        ref: (0, $ece7587e1886b1b9$export$ab452c34e8e05029)(childNode.ref, nodeRef)
    });
    return childNode;
};
var $38129e366659dd04$var$RcAlign = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).forwardRef($38129e366659dd04$var$Align);
$38129e366659dd04$var$RcAlign.displayName = "Align";
var $38129e366659dd04$export$2e2bcd8739ae039 = $38129e366659dd04$var$RcAlign;


var $69d70584be8875fb$export$2e2bcd8739ae039 = (0, $38129e366659dd04$export$2e2bcd8739ae039);






function $c442b5afd6e896a4$export$2e2bcd8739ae039() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $c442b5afd6e896a4$export$2e2bcd8739ae039 = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw new Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError((0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw new Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}


function $046437010de474b2$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $046437010de474b2$export$2e2bcd8739ae039(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $046437010de474b2$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $046437010de474b2$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var $9nZCP = parcelRequire("9nZCP");


/**
 * Popup should follow the steps for each component work correctly:
 * measure - check for the current stretch size
 * align - let component align the position
 * aligned - re-align again in case additional className changed the size
 * afterAlign - choice next step is trigger motion or finished
 * beforeMotion - should reset motion to invisible so that CSSMotion can do normal motion
 * motion - play the motion
 * stable - everything is done
 */ var $fb886a7d8d3a33c3$var$StatusQueue = [
    "measure",
    "alignPre",
    "align",
    null,
    "motion"
];
var $fb886a7d8d3a33c3$export$2e2bcd8739ae039 = function(visible, doMeasure) {
    var _useState = (0, $4e01688ba8da34ba$export$2e2bcd8739ae039)(null), _useState2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useState, 2), status = _useState2[0], setInternalStatus = _useState2[1];
    var rafRef = (0, $9nZCP.useRef)();
    function setStatus(nextStatus) {
        setInternalStatus(nextStatus, true);
    }
    function cancelRaf() {
        (0, $74c50fa010549a87$export$2e2bcd8739ae039).cancel(rafRef.current);
    }
    function goNextStatus(callback) {
        cancelRaf();
        rafRef.current = (0, $74c50fa010549a87$export$2e2bcd8739ae039)(function() {
            // Only align should be manually trigger
            setStatus(function(prev) {
                switch(status){
                    case "align":
                        return "motion";
                    case "motion":
                        return "stable";
                    default:
                }
                return prev;
            });
            callback === null || callback === void 0 || callback();
        });
    } // Init status
    (0, $9nZCP.useEffect)(function() {
        setStatus("measure");
    }, [
        visible
    ]); // Go next status
    (0, $9nZCP.useEffect)(function() {
        switch(status){
            case "measure":
                doMeasure();
                break;
            default:
        }
        if (status) rafRef.current = (0, $74c50fa010549a87$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $046437010de474b2$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $c442b5afd6e896a4$export$2e2bcd8739ae039)().mark(function _callee() {
            var index, nextStatus;
            return (0, $c442b5afd6e896a4$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        index = $fb886a7d8d3a33c3$var$StatusQueue.indexOf(status);
                        nextStatus = $fb886a7d8d3a33c3$var$StatusQueue[index + 1];
                        if (nextStatus && index !== -1) setStatus(nextStatus);
                    case 3:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        })));
    }, [
        status
    ]);
    (0, $9nZCP.useEffect)(function() {
        return function() {
            cancelRaf();
        };
    }, []);
    return [
        status,
        goNextStatus
    ];
};





var $9nZCP = parcelRequire("9nZCP");
var $c95db9a7865696c9$export$2e2bcd8739ae039 = function(stretch) {
    var _React$useState = $9nZCP.useState({
        width: 0,
        height: 0
    }), _React$useState2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_React$useState, 2), targetSize = _React$useState2[0], setTargetSize = _React$useState2[1];
    function measureStretch(element) {
        var tgtWidth = element.offsetWidth, tgtHeight = element.offsetHeight;
        var _element$getBoundingC = element.getBoundingClientRect(), width = _element$getBoundingC.width, height = _element$getBoundingC.height; // Rect is more accurate than offset, use if near
        if (Math.abs(tgtWidth - width) < 1 && Math.abs(tgtHeight - height) < 1) {
            tgtWidth = width;
            tgtHeight = height;
        }
        setTargetSize({
            width: tgtWidth,
            height: tgtHeight
        });
    } // Merge stretch style
    var style = $9nZCP.useMemo(function() {
        var sizeStyle = {};
        if (stretch) {
            var width = targetSize.width, height = targetSize.height; // Stretch with target
            if (stretch.indexOf("height") !== -1 && height) sizeStyle.height = height;
            else if (stretch.indexOf("minHeight") !== -1 && height) sizeStyle.minHeight = height;
            if (stretch.indexOf("width") !== -1 && width) sizeStyle.width = width;
            else if (stretch.indexOf("minWidth") !== -1 && width) sizeStyle.minWidth = width;
        }
        return sizeStyle;
    }, [
        stretch,
        targetSize
    ]);
    return [
        style,
        measureStretch
    ];
};


var $3356b80a5431cc45$var$PopupInner = /*#__PURE__*/ $9nZCP.forwardRef(function(props, ref) {
    var visible = props.visible, prefixCls = props.prefixCls, className = props.className, style = props.style, children = props.children, zIndex = props.zIndex, stretch = props.stretch, destroyPopupOnHide = props.destroyPopupOnHide, forceRender = props.forceRender, align = props.align, point = props.point, getRootDomNode = props.getRootDomNode, getClassNameFromAlign = props.getClassNameFromAlign, onAlign = props.onAlign, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onMouseDown = props.onMouseDown, onTouchStart = props.onTouchStart, onClick = props.onClick;
    var alignRef = (0, $9nZCP.useRef)();
    var elementRef = (0, $9nZCP.useRef)();
    var _useState = (0, $9nZCP.useState)(), _useState2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useState, 2), alignedClassName = _useState2[0], setAlignedClassName = _useState2[1]; // ======================= Measure ========================
    var _useStretchStyle = (0, $c95db9a7865696c9$export$2e2bcd8739ae039)(stretch), _useStretchStyle2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useStretchStyle, 2), stretchStyle = _useStretchStyle2[0], measureStretchStyle = _useStretchStyle2[1];
    function doMeasure() {
        if (stretch) measureStretchStyle(getRootDomNode());
    } // ======================== Status ========================
    var _useVisibleStatus = (0, $fb886a7d8d3a33c3$export$2e2bcd8739ae039)(visible, doMeasure), _useVisibleStatus2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useVisibleStatus, 2), status = _useVisibleStatus2[0], goNextStatus = _useVisibleStatus2[1]; // ======================== Aligns ========================
    /**
   * `alignedClassName` may modify `source` size,
   * which means one time align may not move to the correct position at once.
   *
   * We will reset `alignTimes` for each status switch to `alignPre`
   * and let `rc-align` to align for multiple times to ensure get final stable place.
   * Currently we mark `alignTimes < 2` repeat align, it will increase if user report for align issue.
   * 
   * Update:
   * In React 18. `rc-align` effect of align may faster than ref called trigger `forceAlign`.
   * We adjust this to `alignTimes < 2`.
   * We need refactor `rc-align` to support mark of `forceAlign` call if this still happen.
   */ var _useState3 = (0, $9nZCP.useState)(0), _useState4 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useState3, 2), alignTimes = _useState4[0], setAlignTimes = _useState4[1];
    var prepareResolveRef = (0, $9nZCP.useRef)();
    (0, $5c3e3cad1a762d0b$export$2e2bcd8739ae039)(function() {
        if (status === "alignPre") setAlignTimes(0);
    }, [
        status
    ]); // `target` on `rc-align` can accept as a function to get the bind element or a point.
    // ref: https://www.npmjs.com/package/rc-align
    function getAlignTarget() {
        if (point) return point;
        return getRootDomNode;
    }
    function forceAlign() {
        var _alignRef$current;
        (_alignRef$current = alignRef.current) === null || _alignRef$current === void 0 || _alignRef$current.forceAlign();
    }
    function onInternalAlign(popupDomNode, matchAlign) {
        var nextAlignedClassName = getClassNameFromAlign(matchAlign);
        if (alignedClassName !== nextAlignedClassName) setAlignedClassName(nextAlignedClassName);
         // We will retry multi times to make sure that the element has been align in the right position.
        setAlignTimes(function(val) {
            return val + 1;
        });
        if (status === "align") onAlign === null || onAlign === void 0 || onAlign(popupDomNode, matchAlign);
    } // Delay to go to next status
    (0, $5c3e3cad1a762d0b$export$2e2bcd8739ae039)(function() {
        if (status === "align") {
            // Repeat until not more align needed
            if (alignTimes < 3) forceAlign();
            else goNextStatus(function() {
                var _prepareResolveRef$cu;
                (_prepareResolveRef$cu = prepareResolveRef.current) === null || _prepareResolveRef$cu === void 0 || _prepareResolveRef$cu.call(prepareResolveRef);
            });
        }
    }, [
        alignTimes
    ]); // ======================== Motion ========================
    var motion = (0, $835511f338e067d8$export$2e2bcd8739ae039)({}, (0, $daa737f1914dfdb8$export$7b8936ddc277a29a)(props));
    [
        "onAppearEnd",
        "onEnterEnd",
        "onLeaveEnd"
    ].forEach(function(eventName) {
        var originHandler = motion[eventName];
        motion[eventName] = function(element, event) {
            goNextStatus();
            return originHandler === null || originHandler === void 0 ? void 0 : originHandler(element, event);
        };
    });
    function onShowPrepare() {
        return new Promise(function(resolve) {
            prepareResolveRef.current = resolve;
        });
    } // Go to stable directly when motion not provided
    $9nZCP.useEffect(function() {
        if (!motion.motionName && status === "motion") goNextStatus();
    }, [
        motion.motionName,
        status
    ]); // ========================= Refs =========================
    $9nZCP.useImperativeHandle(ref, function() {
        return {
            forceAlign: forceAlign,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, stretchStyle), {}, {
        zIndex: zIndex,
        opacity: status === "motion" || status === "stable" || !visible ? undefined : 0,
        // Cannot interact with disappearing elements
        // https://github.com/ant-design/ant-design/issues/35051#issuecomment-1101340714
        pointerEvents: !visible && status !== "stable" ? "none" : undefined
    }, style); // Align status
    var alignDisabled = true;
    if (align !== null && align !== void 0 && align.points && (status === "align" || status === "stable")) alignDisabled = false;
    var childNode = children; // Wrapper when multiple children
    if ($9nZCP.Children.count(children) > 1) childNode = /*#__PURE__*/ $9nZCP.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
    return /*#__PURE__*/ $9nZCP.createElement((0, $ba55528cb86ff86c$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({
        visible: visible,
        ref: elementRef,
        leavedClassName: "".concat(prefixCls, "-hidden")
    }, motion, {
        onAppearPrepare: onShowPrepare,
        onEnterPrepare: onShowPrepare,
        removeOnLeave: destroyPopupOnHide,
        forceRender: forceRender
    }), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))(prefixCls, className, alignedClassName, motionClassName);
        return /*#__PURE__*/ $9nZCP.createElement((0, $69d70584be8875fb$export$2e2bcd8739ae039), {
            target: getAlignTarget(),
            key: "popup",
            ref: alignRef,
            monitorWindowResize: true,
            disabled: alignDisabled,
            align: align,
            onAlign: onInternalAlign
        }, /*#__PURE__*/ $9nZCP.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseDownCapture: onMouseDown,
            onTouchStartCapture: onTouchStart,
            onClick: onClick,
            style: (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, motionStyle), mergedStyle)
        }, childNode));
    });
});
$3356b80a5431cc45$var$PopupInner.displayName = "PopupInner";
var $3356b80a5431cc45$export$2e2bcd8739ae039 = $3356b80a5431cc45$var$PopupInner;





var $9nZCP = parcelRequire("9nZCP");


var $d4b3b7ecbc9a956c$var$MobilePopupInner = /*#__PURE__*/ $9nZCP.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, children = props.children, _props$mobile = props.mobile;
    _props$mobile = _props$mobile === void 0 ? {} : _props$mobile;
    var popupClassName = _props$mobile.popupClassName, popupStyle = _props$mobile.popupStyle, _props$mobile$popupMo = _props$mobile.popupMotion, popupMotion = _props$mobile$popupMo === void 0 ? {} : _props$mobile$popupMo, popupRender = _props$mobile.popupRender, onClick = props.onClick;
    var elementRef = $9nZCP.useRef(); // ========================= Refs =========================
    $9nZCP.useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {},
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $835511f338e067d8$export$2e2bcd8739ae039)({
        zIndex: zIndex
    }, popupStyle);
    var childNode = children; // Wrapper when multiple children
    if ($9nZCP.Children.count(children) > 1) childNode = /*#__PURE__*/ $9nZCP.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
     // Mobile support additional render
    if (popupRender) childNode = popupRender(childNode);
    return /*#__PURE__*/ $9nZCP.createElement((0, $ba55528cb86ff86c$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({
        visible: visible,
        ref: elementRef,
        removeOnLeave: true
    }, popupMotion), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))(prefixCls, popupClassName, motionClassName);
        return /*#__PURE__*/ $9nZCP.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onClick: onClick,
            style: (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, motionStyle), mergedStyle)
        }, childNode);
    });
});
$d4b3b7ecbc9a956c$var$MobilePopupInner.displayName = "MobilePopupInner";
var $d4b3b7ecbc9a956c$export$2e2bcd8739ae039 = $d4b3b7ecbc9a956c$var$MobilePopupInner;


var $5f6996233639d41e$var$_excluded = [
    "visible",
    "mobile"
];
var $5f6996233639d41e$var$Popup = /*#__PURE__*/ $9nZCP.forwardRef(function(_ref, ref) {
    var visible = _ref.visible, mobile = _ref.mobile, props = (0, $d757eeb1353aad21$export$2e2bcd8739ae039)(_ref, $5f6996233639d41e$var$_excluded);
    var _useState = (0, $9nZCP.useState)(visible), _useState2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useState, 2), innerVisible = _useState2[0], serInnerVisible = _useState2[1];
    var _useState3 = (0, $9nZCP.useState)(false), _useState4 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useState3, 2), inMobile = _useState4[0], setInMobile = _useState4[1];
    var cloneProps = (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, props), {}, {
        visible: innerVisible
    }); // We check mobile in visible changed here.
    // And this also delay set `innerVisible` to avoid popup component render flash
    (0, $9nZCP.useEffect)(function() {
        serInnerVisible(visible);
        if (visible && mobile) setInMobile((0, $0be4b22dededee67$export$2e2bcd8739ae039)());
    }, [
        visible,
        mobile
    ]);
    var popupNode = inMobile ? /*#__PURE__*/ $9nZCP.createElement((0, $d4b3b7ecbc9a956c$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({}, cloneProps, {
        mobile: mobile,
        ref: ref
    })) : /*#__PURE__*/ $9nZCP.createElement((0, $3356b80a5431cc45$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({}, cloneProps, {
        ref: ref
    })); // We can use fragment directly but this may failed some selector usage. Keep as origin logic
    return /*#__PURE__*/ $9nZCP.createElement("div", null, /*#__PURE__*/ $9nZCP.createElement((0, $2c5306aae19cdf6e$export$2e2bcd8739ae039), cloneProps), popupNode);
});
$5f6996233639d41e$var$Popup.displayName = "Popup";
var $5f6996233639d41e$export$2e2bcd8739ae039 = $5f6996233639d41e$var$Popup;



var $9nZCP = parcelRequire("9nZCP");
var $e401097ef1d73ab3$var$TriggerContext = /*#__PURE__*/ $9nZCP.createContext(null);
var $e401097ef1d73ab3$export$2e2bcd8739ae039 = $e401097ef1d73ab3$var$TriggerContext;


function $ab2fc57d2029f006$var$noop() {}
function $ab2fc57d2029f006$var$returnEmptyString() {
    return "";
}
function $ab2fc57d2029f006$var$returnDocument(element) {
    if (element) return element.ownerDocument;
    return window.document;
}
var $ab2fc57d2029f006$var$ALL_HANDLERS = [
    "onClick",
    "onMouseDown",
    "onTouchStart",
    "onMouseEnter",
    "onMouseLeave",
    "onFocus",
    "onBlur",
    "onContextMenu"
];
function $ab2fc57d2029f006$export$55e99723d7f71b47(PortalComponent) {
    var Trigger = /*#__PURE__*/ function(_React$Component) {
        (0, $e9432b2dc1794836$export$2e2bcd8739ae039)(Trigger, _React$Component);
        var _super = (0, $d9bb25c2822f374b$export$2e2bcd8739ae039)(Trigger);
        // ensure `getContainer` will be called only once
        function Trigger(props) {
            var _this;
            (0, $760550b9da8dc9e1$export$2e2bcd8739ae039)(this, Trigger);
            _this = _super.call(this, props);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "popupRef", /*#__PURE__*/ $9nZCP.createRef());
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "triggerRef", /*#__PURE__*/ $9nZCP.createRef());
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "portalContainer", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "attachId", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "clickOutsideHandler", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "touchOutsideHandler", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "contextMenuOutsideHandler1", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "contextMenuOutsideHandler2", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "mouseDownTimeout", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "focusTime", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "preClickTime", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "preTouchTime", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "delayTimer", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "hasPopupMouseDown", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onMouseEnter", function(e) {
                var mouseEnterDelay = _this.props.mouseEnterDelay;
                _this.fireEvents("onMouseEnter", e);
                _this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onMouseMove", function(e) {
                _this.fireEvents("onMouseMove", e);
                _this.setPoint(e);
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onMouseLeave", function(e) {
                _this.fireEvents("onMouseLeave", e);
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onPopupMouseEnter", function() {
                _this.clearDelayTimer();
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onPopupMouseLeave", function(e) {
                var _this$popupRef$curren;
                // https://github.com/react-component/trigger/pull/13
                // react bug?
                if (e.relatedTarget && !e.relatedTarget.setTimeout && (0, $a5f4fb2511f41816$export$2e2bcd8739ae039)((_this$popupRef$curren = _this.popupRef.current) === null || _this$popupRef$curren === void 0 ? void 0 : _this$popupRef$curren.getElement(), e.relatedTarget)) return;
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onFocus", function(e) {
                _this.fireEvents("onFocus", e); // incase focusin and focusout
                _this.clearDelayTimer();
                if (_this.isFocusToShow()) {
                    _this.focusTime = Date.now();
                    _this.delaySetPopupVisible(true, _this.props.focusDelay);
                }
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onMouseDown", function(e) {
                _this.fireEvents("onMouseDown", e);
                _this.preClickTime = Date.now();
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onTouchStart", function(e) {
                _this.fireEvents("onTouchStart", e);
                _this.preTouchTime = Date.now();
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onBlur", function(e) {
                _this.fireEvents("onBlur", e);
                _this.clearDelayTimer();
                if (_this.isBlurToHide()) _this.delaySetPopupVisible(false, _this.props.blurDelay);
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onContextMenu", function(e) {
                e.preventDefault();
                _this.fireEvents("onContextMenu", e);
                _this.setPopupVisible(true, e);
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onContextMenuClose", function() {
                if (_this.isContextMenuToShow()) _this.close();
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onClick", function(event) {
                _this.fireEvents("onClick", event); // focus will trigger click
                if (_this.focusTime) {
                    var preTime;
                    if (_this.preClickTime && _this.preTouchTime) preTime = Math.min(_this.preClickTime, _this.preTouchTime);
                    else if (_this.preClickTime) preTime = _this.preClickTime;
                    else if (_this.preTouchTime) preTime = _this.preTouchTime;
                    if (Math.abs(preTime - _this.focusTime) < 20) return;
                    _this.focusTime = 0;
                }
                _this.preClickTime = 0;
                _this.preTouchTime = 0; // Only prevent default when all the action is click.
                // https://github.com/ant-design/ant-design/issues/17043
                // https://github.com/ant-design/ant-design/issues/17291
                if (_this.isClickToShow() && (_this.isClickToHide() || _this.isBlurToHide()) && event && event.preventDefault) event.preventDefault();
                var nextVisible = !_this.state.popupVisible;
                if (_this.isClickToHide() && !nextVisible || nextVisible && _this.isClickToShow()) _this.setPopupVisible(!_this.state.popupVisible, event);
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onPopupMouseDown", function() {
                _this.hasPopupMouseDown = true;
                clearTimeout(_this.mouseDownTimeout);
                _this.mouseDownTimeout = window.setTimeout(function() {
                    _this.hasPopupMouseDown = false;
                }, 0);
                if (_this.context) {
                    var _this$context;
                    (_this$context = _this.context).onPopupMouseDown.apply(_this$context, arguments);
                }
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onDocumentClick", function(event) {
                if (_this.props.mask && !_this.props.maskClosable) return;
                var target = event.target;
                var root = _this.getRootDomNode();
                var popupNode = _this.getPopupDomNode();
                if (// https://github.com/ant-design/ant-design/issues/29853
                (!(0, $a5f4fb2511f41816$export$2e2bcd8739ae039)(root, target) || _this.isContextMenuOnly()) && !(0, $a5f4fb2511f41816$export$2e2bcd8739ae039)(popupNode, target) && !_this.hasPopupMouseDown) _this.close();
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "getRootDomNode", function() {
                var getTriggerDOMNode = _this.props.getTriggerDOMNode;
                if (getTriggerDOMNode) return getTriggerDOMNode(_this.triggerRef.current);
                try {
                    var domNode = (0, $93bb6ec4cced17a6$export$2e2bcd8739ae039)(_this.triggerRef.current);
                    if (domNode) return domNode;
                } catch (err) {}
                return (0, (/*@__PURE__*/$parcel$interopDefault($06928105ffc753ea$exports))).findDOMNode((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this));
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "getPopupClassNameFromAlign", function(align) {
                var className = [];
                var _this$props = _this.props, popupPlacement = _this$props.popupPlacement, builtinPlacements = _this$props.builtinPlacements, prefixCls = _this$props.prefixCls, alignPoint = _this$props.alignPoint, getPopupClassNameFromAlign = _this$props.getPopupClassNameFromAlign;
                if (popupPlacement && builtinPlacements) className.push((0, $d5666b43b133354b$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, align, alignPoint));
                if (getPopupClassNameFromAlign) className.push(getPopupClassNameFromAlign(align));
                return className.join(" ");
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "getComponent", function() {
                var _this$props2 = _this.props, prefixCls = _this$props2.prefixCls, destroyPopupOnHide = _this$props2.destroyPopupOnHide, popupClassName = _this$props2.popupClassName, onPopupAlign = _this$props2.onPopupAlign, popupMotion = _this$props2.popupMotion, popupAnimation = _this$props2.popupAnimation, popupTransitionName = _this$props2.popupTransitionName, popupStyle = _this$props2.popupStyle, mask = _this$props2.mask, maskAnimation = _this$props2.maskAnimation, maskTransitionName = _this$props2.maskTransitionName, maskMotion = _this$props2.maskMotion, zIndex = _this$props2.zIndex, popup = _this$props2.popup, stretch = _this$props2.stretch, alignPoint = _this$props2.alignPoint, mobile = _this$props2.mobile, forceRender = _this$props2.forceRender, onPopupClick = _this$props2.onPopupClick;
                var _this$state = _this.state, popupVisible = _this$state.popupVisible, point = _this$state.point;
                var align = _this.getPopupAlign();
                var mouseProps = {};
                if (_this.isMouseEnterToShow()) mouseProps.onMouseEnter = _this.onPopupMouseEnter;
                if (_this.isMouseLeaveToHide()) mouseProps.onMouseLeave = _this.onPopupMouseLeave;
                mouseProps.onMouseDown = _this.onPopupMouseDown;
                mouseProps.onTouchStart = _this.onPopupMouseDown;
                return /*#__PURE__*/ $9nZCP.createElement((0, $5f6996233639d41e$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({
                    prefixCls: prefixCls,
                    destroyPopupOnHide: destroyPopupOnHide,
                    visible: popupVisible,
                    point: alignPoint && point,
                    className: popupClassName,
                    align: align,
                    onAlign: onPopupAlign,
                    animation: popupAnimation,
                    getClassNameFromAlign: _this.getPopupClassNameFromAlign
                }, mouseProps, {
                    stretch: stretch,
                    getRootDomNode: _this.getRootDomNode,
                    style: popupStyle,
                    mask: mask,
                    zIndex: zIndex,
                    transitionName: popupTransitionName,
                    maskAnimation: maskAnimation,
                    maskTransitionName: maskTransitionName,
                    maskMotion: maskMotion,
                    ref: _this.popupRef,
                    motion: popupMotion,
                    mobile: mobile,
                    forceRender: forceRender,
                    onClick: onPopupClick
                }), typeof popup === "function" ? popup() : popup);
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "attachParent", function(popupContainer) {
                (0, $74c50fa010549a87$export$2e2bcd8739ae039).cancel(_this.attachId);
                var _this$props3 = _this.props, getPopupContainer = _this$props3.getPopupContainer, getDocument = _this$props3.getDocument;
                var domNode = _this.getRootDomNode();
                var mountNode;
                if (!getPopupContainer) mountNode = getDocument(_this.getRootDomNode()).body;
                else if (domNode || getPopupContainer.length === 0) // Compatible for legacy getPopupContainer with domNode argument.
                // If no need `domNode` argument, will call directly.
                // https://codesandbox.io/s/eloquent-mclean-ss93m?file=/src/App.js
                mountNode = getPopupContainer(domNode);
                if (mountNode) mountNode.appendChild(popupContainer);
                else // Retry after frame render in case parent not ready
                _this.attachId = (0, $74c50fa010549a87$export$2e2bcd8739ae039)(function() {
                    _this.attachParent(popupContainer);
                });
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "getContainer", function() {
                if (!_this.portalContainer) {
                    // In React.StrictMode component will call render multiple time in first mount.
                    // When you want to refactor with FC, useRef will also init multiple time and
                    // point to different useRef instance which will create multiple element
                    // (This multiple render will not trigger effect so you can not clean up this
                    // in effect). But this is safe with class component since it always point to same class instance.
                    var getDocument = _this.props.getDocument;
                    var popupContainer = getDocument(_this.getRootDomNode()).createElement("div"); // Make sure default popup container will never cause scrollbar appearing
                    // https://github.com/react-component/trigger/issues/41
                    popupContainer.style.position = "absolute";
                    popupContainer.style.top = "0";
                    popupContainer.style.left = "0";
                    popupContainer.style.width = "100%";
                    _this.portalContainer = popupContainer;
                }
                _this.attachParent(_this.portalContainer);
                return _this.portalContainer;
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "setPoint", function(point) {
                var alignPoint = _this.props.alignPoint;
                if (!alignPoint || !point) return;
                _this.setState({
                    point: {
                        pageX: point.pageX,
                        pageY: point.pageY
                    }
                });
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "handlePortalUpdate", function() {
                if (_this.state.prevPopupVisible !== _this.state.popupVisible) _this.props.afterPopupVisibleChange(_this.state.popupVisible);
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "triggerContextValue", {
                onPopupMouseDown: _this.onPopupMouseDown
            });
            var _popupVisible;
            if ("popupVisible" in props) _popupVisible = !!props.popupVisible;
            else _popupVisible = !!props.defaultPopupVisible;
            _this.state = {
                prevPopupVisible: _popupVisible,
                popupVisible: _popupVisible
            };
            $ab2fc57d2029f006$var$ALL_HANDLERS.forEach(function(h) {
                _this["fire".concat(h)] = function(e) {
                    _this.fireEvents(h, e);
                };
            });
            return _this;
        }
        (0, $e2992e4fbdf715a4$export$2e2bcd8739ae039)(Trigger, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.componentDidUpdate();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate() {
                    var props = this.props;
                    var state = this.state; // We must listen to `mousedown` or `touchstart`, edge case:
                    // https://github.com/ant-design/ant-design/issues/5804
                    // https://github.com/react-component/calendar/issues/250
                    // https://github.com/react-component/trigger/issues/50
                    if (state.popupVisible) {
                        var currentDocument;
                        if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
                            currentDocument = props.getDocument(this.getRootDomNode());
                            this.clickOutsideHandler = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(currentDocument, "mousedown", this.onDocumentClick);
                        } // always hide on mobile
                        if (!this.touchOutsideHandler) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.touchOutsideHandler = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(currentDocument, "touchstart", this.onDocumentClick);
                        } // close popup when trigger type contains 'onContextMenu' and document is scrolling.
                        if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.contextMenuOutsideHandler1 = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(currentDocument, "scroll", this.onContextMenuClose);
                        } // close popup when trigger type contains 'onContextMenu' and window is blur.
                        if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) this.contextMenuOutsideHandler2 = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(window, "blur", this.onContextMenuClose);
                        return;
                    }
                    this.clearOutsideHandler();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.clearDelayTimer();
                    this.clearOutsideHandler();
                    clearTimeout(this.mouseDownTimeout);
                    (0, $74c50fa010549a87$export$2e2bcd8739ae039).cancel(this.attachId);
                }
            },
            {
                key: "getPopupDomNode",
                value: function getPopupDomNode() {
                    var _this$popupRef$curren2;
                    // for test
                    return ((_this$popupRef$curren2 = this.popupRef.current) === null || _this$popupRef$curren2 === void 0 ? void 0 : _this$popupRef$curren2.getElement()) || null;
                }
            },
            {
                key: "getPopupAlign",
                value: function getPopupAlign() {
                    var props = this.props;
                    var popupPlacement = props.popupPlacement, popupAlign = props.popupAlign, builtinPlacements = props.builtinPlacements;
                    if (popupPlacement && builtinPlacements) return (0, $d5666b43b133354b$export$44605b74f7c5d944)(builtinPlacements, popupPlacement, popupAlign);
                    return popupAlign;
                }
            },
            {
                key: "setPopupVisible",
                value: /**
       * @param popupVisible    Show or not the popup element
       * @param event           SyntheticEvent, used for `pointAlign`
       */ function setPopupVisible(popupVisible, event) {
                    var alignPoint = this.props.alignPoint;
                    var prevPopupVisible = this.state.popupVisible;
                    this.clearDelayTimer();
                    if (prevPopupVisible !== popupVisible) {
                        if (!("popupVisible" in this.props)) this.setState({
                            popupVisible: popupVisible,
                            prevPopupVisible: prevPopupVisible
                        });
                        this.props.onPopupVisibleChange(popupVisible);
                    } // Always record the point position since mouseEnterDelay will delay the show
                    if (alignPoint && event && popupVisible) this.setPoint(event);
                }
            },
            {
                key: "delaySetPopupVisible",
                value: function delaySetPopupVisible(visible, delayS, event) {
                    var _this2 = this;
                    var delay = delayS * 1000;
                    this.clearDelayTimer();
                    if (delay) {
                        var point = event ? {
                            pageX: event.pageX,
                            pageY: event.pageY
                        } : null;
                        this.delayTimer = window.setTimeout(function() {
                            _this2.setPopupVisible(visible, point);
                            _this2.clearDelayTimer();
                        }, delay);
                    } else this.setPopupVisible(visible, event);
                }
            },
            {
                key: "clearDelayTimer",
                value: function clearDelayTimer() {
                    if (this.delayTimer) {
                        clearTimeout(this.delayTimer);
                        this.delayTimer = null;
                    }
                }
            },
            {
                key: "clearOutsideHandler",
                value: function clearOutsideHandler() {
                    if (this.clickOutsideHandler) {
                        this.clickOutsideHandler.remove();
                        this.clickOutsideHandler = null;
                    }
                    if (this.contextMenuOutsideHandler1) {
                        this.contextMenuOutsideHandler1.remove();
                        this.contextMenuOutsideHandler1 = null;
                    }
                    if (this.contextMenuOutsideHandler2) {
                        this.contextMenuOutsideHandler2.remove();
                        this.contextMenuOutsideHandler2 = null;
                    }
                    if (this.touchOutsideHandler) {
                        this.touchOutsideHandler.remove();
                        this.touchOutsideHandler = null;
                    }
                }
            },
            {
                key: "createTwoChains",
                value: function createTwoChains(event) {
                    var childPros = this.props.children.props;
                    var props = this.props;
                    if (childPros[event] && props[event]) return this["fire".concat(event)];
                    return childPros[event] || props[event];
                }
            },
            {
                key: "isClickToShow",
                value: function isClickToShow() {
                    var _this$props4 = this.props, action = _this$props4.action, showAction = _this$props4.showAction;
                    return action.indexOf("click") !== -1 || showAction.indexOf("click") !== -1;
                }
            },
            {
                key: "isContextMenuOnly",
                value: function isContextMenuOnly() {
                    var action = this.props.action;
                    return action === "contextMenu" || action.length === 1 && action[0] === "contextMenu";
                }
            },
            {
                key: "isContextMenuToShow",
                value: function isContextMenuToShow() {
                    var _this$props5 = this.props, action = _this$props5.action, showAction = _this$props5.showAction;
                    return action.indexOf("contextMenu") !== -1 || showAction.indexOf("contextMenu") !== -1;
                }
            },
            {
                key: "isClickToHide",
                value: function isClickToHide() {
                    var _this$props6 = this.props, action = _this$props6.action, hideAction = _this$props6.hideAction;
                    return action.indexOf("click") !== -1 || hideAction.indexOf("click") !== -1;
                }
            },
            {
                key: "isMouseEnterToShow",
                value: function isMouseEnterToShow() {
                    var _this$props7 = this.props, action = _this$props7.action, showAction = _this$props7.showAction;
                    return action.indexOf("hover") !== -1 || showAction.indexOf("mouseEnter") !== -1;
                }
            },
            {
                key: "isMouseLeaveToHide",
                value: function isMouseLeaveToHide() {
                    var _this$props8 = this.props, action = _this$props8.action, hideAction = _this$props8.hideAction;
                    return action.indexOf("hover") !== -1 || hideAction.indexOf("mouseLeave") !== -1;
                }
            },
            {
                key: "isFocusToShow",
                value: function isFocusToShow() {
                    var _this$props9 = this.props, action = _this$props9.action, showAction = _this$props9.showAction;
                    return action.indexOf("focus") !== -1 || showAction.indexOf("focus") !== -1;
                }
            },
            {
                key: "isBlurToHide",
                value: function isBlurToHide() {
                    var _this$props10 = this.props, action = _this$props10.action, hideAction = _this$props10.hideAction;
                    return action.indexOf("focus") !== -1 || hideAction.indexOf("blur") !== -1;
                }
            },
            {
                key: "forcePopupAlign",
                value: function forcePopupAlign() {
                    if (this.state.popupVisible) {
                        var _this$popupRef$curren3;
                        (_this$popupRef$curren3 = this.popupRef.current) === null || _this$popupRef$curren3 === void 0 || _this$popupRef$curren3.forceAlign();
                    }
                }
            },
            {
                key: "fireEvents",
                value: function fireEvents(type, e) {
                    var childCallback = this.props.children.props[type];
                    if (childCallback) childCallback(e);
                    var callback = this.props[type];
                    if (callback) callback(e);
                }
            },
            {
                key: "close",
                value: function close() {
                    this.setPopupVisible(false);
                }
            },
            {
                key: "render",
                value: function render() {
                    var popupVisible = this.state.popupVisible;
                    var _this$props11 = this.props, children = _this$props11.children, forceRender = _this$props11.forceRender, alignPoint = _this$props11.alignPoint, className = _this$props11.className, autoDestroy = _this$props11.autoDestroy;
                    var child = $9nZCP.Children.only(children);
                    var newChildProps = {
                        key: "trigger"
                    }; // ============================== Visible Handlers ==============================
                    // >>> ContextMenu
                    if (this.isContextMenuToShow()) newChildProps.onContextMenu = this.onContextMenu;
                    else newChildProps.onContextMenu = this.createTwoChains("onContextMenu");
                     // >>> Click
                    if (this.isClickToHide() || this.isClickToShow()) {
                        newChildProps.onClick = this.onClick;
                        newChildProps.onMouseDown = this.onMouseDown;
                        newChildProps.onTouchStart = this.onTouchStart;
                    } else {
                        newChildProps.onClick = this.createTwoChains("onClick");
                        newChildProps.onMouseDown = this.createTwoChains("onMouseDown");
                        newChildProps.onTouchStart = this.createTwoChains("onTouchStart");
                    } // >>> Hover(enter)
                    if (this.isMouseEnterToShow()) {
                        newChildProps.onMouseEnter = this.onMouseEnter; // Point align
                        if (alignPoint) newChildProps.onMouseMove = this.onMouseMove;
                    } else newChildProps.onMouseEnter = this.createTwoChains("onMouseEnter");
                     // >>> Hover(leave)
                    if (this.isMouseLeaveToHide()) newChildProps.onMouseLeave = this.onMouseLeave;
                    else newChildProps.onMouseLeave = this.createTwoChains("onMouseLeave");
                     // >>> Focus
                    if (this.isFocusToShow() || this.isBlurToHide()) {
                        newChildProps.onFocus = this.onFocus;
                        newChildProps.onBlur = this.onBlur;
                    } else {
                        newChildProps.onFocus = this.createTwoChains("onFocus");
                        newChildProps.onBlur = this.createTwoChains("onBlur");
                    } // =================================== Render ===================================
                    var childrenClassName = (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))(child && child.props && child.props.className, className);
                    if (childrenClassName) newChildProps.className = childrenClassName;
                    var cloneProps = (0, $835511f338e067d8$export$2e2bcd8739ae039)({}, newChildProps);
                    if ((0, $ece7587e1886b1b9$export$c1cec34af06bcf7)(child)) cloneProps.ref = (0, $ece7587e1886b1b9$export$ab452c34e8e05029)(this.triggerRef, child.ref);
                    var trigger = /*#__PURE__*/ $9nZCP.cloneElement(child, cloneProps);
                    var portal; // prevent unmounting after it's rendered
                    if (popupVisible || this.popupRef.current || forceRender) portal = /*#__PURE__*/ $9nZCP.createElement(PortalComponent, {
                        key: "portal",
                        getContainer: this.getContainer,
                        didUpdate: this.handlePortalUpdate
                    }, this.getComponent());
                    if (!popupVisible && autoDestroy) portal = null;
                    return /*#__PURE__*/ $9nZCP.createElement((0, $e401097ef1d73ab3$export$2e2bcd8739ae039).Provider, {
                        value: this.triggerContextValue
                    }, trigger, portal);
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref, prevState) {
                    var popupVisible = _ref.popupVisible;
                    var newState = {};
                    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
                        newState.popupVisible = popupVisible;
                        newState.prevPopupVisible = prevState.popupVisible;
                    }
                    return newState;
                }
            }
        ]);
        return Trigger;
    }($9nZCP.Component);
    (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(Trigger, "contextType", (0, $e401097ef1d73ab3$export$2e2bcd8739ae039));
    (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(Trigger, "defaultProps", {
        prefixCls: "rc-trigger-popup",
        getPopupClassNameFromAlign: $ab2fc57d2029f006$var$returnEmptyString,
        getDocument: $ab2fc57d2029f006$var$returnDocument,
        onPopupVisibleChange: $ab2fc57d2029f006$var$noop,
        afterPopupVisibleChange: $ab2fc57d2029f006$var$noop,
        onPopupAlign: $ab2fc57d2029f006$var$noop,
        popupClassName: "",
        mouseEnterDelay: 0,
        mouseLeaveDelay: 0.1,
        focusDelay: 0,
        blurDelay: 0.15,
        popupStyle: {},
        destroyPopupOnHide: false,
        popupAlign: {},
        defaultPopupVisible: false,
        mask: false,
        maskClosable: true,
        action: [],
        showAction: [],
        hideAction: [],
        autoDestroy: false
    });
    return Trigger;
}
var $ab2fc57d2029f006$export$2e2bcd8739ae039 = $ab2fc57d2029f006$export$55e99723d7f71b47((0, $f28890857a395782$export$2e2bcd8739ae039));


var $7619b09d98a7e935$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $7619b09d98a7e935$var$targetOffset = [
    0,
    0
];
var $7619b09d98a7e935$export$803cd8101b6c182b = {
    left: {
        points: [
            "cr",
            "cl"
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    right: {
        points: [
            "cl",
            "cr"
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    top: {
        points: [
            "bc",
            "tc"
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    bottom: {
        points: [
            "tc",
            "bc"
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    leftTop: {
        points: [
            "tr",
            "tl"
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    rightTop: {
        points: [
            "tl",
            "tr"
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    rightBottom: {
        points: [
            "bl",
            "br"
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    leftBottom: {
        points: [
            "br",
            "bl"
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    }
};
var $7619b09d98a7e935$export$2e2bcd8739ae039 = $7619b09d98a7e935$export$803cd8101b6c182b;



var $9nZCP = parcelRequire("9nZCP");

function $2be2fd6b9ea03ced$export$2e2bcd8739ae039(props) {
    var showArrow = props.showArrow, arrowContent = props.arrowContent, children = props.children, prefixCls = props.prefixCls, id = props.id, overlayInnerStyle = props.overlayInnerStyle, className = props.className, style = props.style;
    return /*#__PURE__*/ $9nZCP.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))("".concat(prefixCls, "-content"), className),
        style: style
    }, showArrow !== false && /*#__PURE__*/ $9nZCP.createElement("div", {
        className: "".concat(prefixCls, "-arrow"),
        key: "arrow"
    }, arrowContent), /*#__PURE__*/ $9nZCP.createElement("div", {
        className: "".concat(prefixCls, "-inner"),
        id: id,
        role: "tooltip",
        style: overlayInnerStyle
    }, typeof children === "function" ? children() : children));
}


var $599f1530db4cdd2a$var$_excluded = [
    "overlayClassName",
    "trigger",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "overlayStyle",
    "prefixCls",
    "children",
    "onVisibleChange",
    "afterVisibleChange",
    "transitionName",
    "animation",
    "motion",
    "placement",
    "align",
    "destroyTooltipOnHide",
    "defaultVisible",
    "getTooltipContainer",
    "overlayInnerStyle",
    "arrowContent",
    "overlay",
    "id",
    "showArrow"
];
var $599f1530db4cdd2a$var$Tooltip = function Tooltip(props, ref) {
    var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        "hover"
    ] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-tooltip" : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, transitionName = props.transitionName, animation = props.animation, motion = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? "right" : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay = props.overlay, id = props.id, _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, restProps = (0, $d757eeb1353aad21$export$2e2bcd8739ae039)(props, $599f1530db4cdd2a$var$_excluded);
    var domRef = (0, $9nZCP.useRef)(null);
    (0, $9nZCP.useImperativeHandle)(ref, function() {
        return domRef.current;
    });
    var extraProps = (0, $835511f338e067d8$export$2e2bcd8739ae039)({}, restProps);
    if ("visible" in props) extraProps.popupVisible = props.visible;
    var getPopupElement = function getPopupElement() {
        return /*#__PURE__*/ $9nZCP.createElement((0, $2be2fd6b9ea03ced$export$2e2bcd8739ae039), {
            showArrow: showArrow,
            arrowContent: arrowContent,
            key: "content",
            prefixCls: prefixCls,
            id: id,
            overlayInnerStyle: overlayInnerStyle
        }, overlay);
    };
    var destroyTooltip = false;
    var autoDestroy = false;
    if (typeof destroyTooltipOnHide === "boolean") destroyTooltip = destroyTooltipOnHide;
    else if (destroyTooltipOnHide && (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(destroyTooltipOnHide) === "object") {
        var keepParent = destroyTooltipOnHide.keepParent;
        destroyTooltip = keepParent === true;
        autoDestroy = keepParent === false;
    }
    return /*#__PURE__*/ $9nZCP.createElement((0, $ab2fc57d2029f006$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({
        popupClassName: overlayClassName,
        prefixCls: prefixCls,
        popup: getPopupElement,
        action: trigger,
        builtinPlacements: (0, $7619b09d98a7e935$export$803cd8101b6c182b),
        popupPlacement: placement,
        ref: domRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltip,
        autoDestroy: autoDestroy,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
    }, extraProps), children);
};
var $599f1530db4cdd2a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $9nZCP.forwardRef)($599f1530db4cdd2a$var$Tooltip);



var $d446dff0e4ef5baa$export$2e2bcd8739ae039 = (0, $599f1530db4cdd2a$export$2e2bcd8739ae039);




var $f7939232b8700452$var$SliderTooltip = /*#__PURE__*/ $9nZCP.forwardRef(function(props, ref) {
    var visible = props.visible, overlay = props.overlay;
    var innerRef = $9nZCP.useRef(null);
    var tooltipRef = (0, $ece7587e1886b1b9$export$ab452c34e8e05029)(ref, innerRef);
    var rafRef = $9nZCP.useRef(null);
    function cancelKeepAlign() {
        (0, $74c50fa010549a87$export$2e2bcd8739ae039).cancel(rafRef.current);
    }
    function keepAlign() {
        rafRef.current = (0, $74c50fa010549a87$export$2e2bcd8739ae039)(function() {
            var _innerRef$current;
            (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 || _innerRef$current.forcePopupAlign();
        });
    }
    $9nZCP.useEffect(function() {
        if (visible) keepAlign();
        else cancelKeepAlign();
        return cancelKeepAlign;
    }, [
        visible,
        overlay
    ]);
    return /*#__PURE__*/ $9nZCP.createElement((0, $d446dff0e4ef5baa$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({
        ref: tooltipRef
    }, props));
});
var $f7939232b8700452$export$2e2bcd8739ae039 = $f7939232b8700452$var$SliderTooltip;



function $63d3d36722fc19de$export$2e2bcd8739ae039(Component) {
    var _a; // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return _a = /*#__PURE__*/ function(_React$Component) {
        (0, $e9432b2dc1794836$export$2e2bcd8739ae039)(ComponentWrapper, _React$Component);
        var _super = (0, $d9bb25c2822f374b$export$2e2bcd8739ae039)(ComponentWrapper);
        function ComponentWrapper() {
            var _this;
            (0, $760550b9da8dc9e1$export$2e2bcd8739ae039)(this, ComponentWrapper);
            _this = _super.apply(this, arguments);
            _this.state = {
                visibles: {}
            };
            _this.handleTooltipVisibleChange = function(index, visible) {
                _this.setState(function(prevState) {
                    return {
                        visibles: (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, prevState.visibles), {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)({}, index, visible))
                    };
                });
            };
            _this.handleWithTooltip = function(_ref) {
                var value = _ref.value, dragging = _ref.dragging, index = _ref.index, disabled = _ref.disabled, restProps = (0, $d757eeb1353aad21$export$2e2bcd8739ae039)(_ref, [
                    "value",
                    "dragging",
                    "index",
                    "disabled"
                ]);
                var _this$props = _this.props, tipFormatter = _this$props.tipFormatter, tipProps = _this$props.tipProps, handleStyle = _this$props.handleStyle, getTooltipContainer = _this$props.getTooltipContainer;
                var _tipProps$prefixCls = tipProps.prefixCls, prefixCls = _tipProps$prefixCls === void 0 ? "rc-slider-tooltip" : _tipProps$prefixCls, _tipProps$overlay = tipProps.overlay, overlay = _tipProps$overlay === void 0 ? tipFormatter(value) : _tipProps$overlay, _tipProps$placement = tipProps.placement, placement = _tipProps$placement === void 0 ? "top" : _tipProps$placement, _tipProps$visible = tipProps.visible, visible = _tipProps$visible === void 0 ? false : _tipProps$visible, restTooltipProps = (0, $d757eeb1353aad21$export$2e2bcd8739ae039)(tipProps, [
                    "prefixCls",
                    "overlay",
                    "placement",
                    "visible"
                ]);
                var handleStyleWithIndex;
                if (Array.isArray(handleStyle)) handleStyleWithIndex = handleStyle[index] || handleStyle[0];
                else handleStyleWithIndex = handleStyle;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement((0, $f7939232b8700452$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({}, restTooltipProps, {
                    getTooltipContainer: getTooltipContainer,
                    prefixCls: prefixCls,
                    overlay: overlay,
                    placement: placement,
                    visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
                    key: index
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement((0, $49e439059d842d52$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({}, restProps, {
                    style: (0, $835511f338e067d8$export$2e2bcd8739ae039)({}, handleStyleWithIndex),
                    value: value,
                    onMouseEnter: function onMouseEnter() {
                        return _this.handleTooltipVisibleChange(index, true);
                    },
                    onMouseLeave: function onMouseLeave() {
                        return _this.handleTooltipVisibleChange(index, false);
                    }
                })));
            };
            return _this;
        }
        (0, $e2992e4fbdf715a4$export$2e2bcd8739ae039)(ComponentWrapper, [
            {
                key: "render",
                value: function render() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement(Component, (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({}, this.props, {
                        handle: this.handleWithTooltip
                    }));
                }
            }
        ]);
        return ComponentWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).Component), _a.defaultProps = {
        tipFormatter: function tipFormatter(value) {
            return value;
        },
        handleStyle: [
            {}
        ],
        tipProps: {},
        getTooltipContainer: function getTooltipContainer(node) {
            return node.parentNode;
        }
    }, _a;
}



var $8fc1eb2c15e0076e$var$InternalSlider = (0, $424139e045fedefc$export$2e2bcd8739ae039);
$8fc1eb2c15e0076e$var$InternalSlider.Range = (0, $1333fa204e4662b3$export$2e2bcd8739ae039);
$8fc1eb2c15e0076e$var$InternalSlider.Handle = (0, $49e439059d842d52$export$2e2bcd8739ae039);
$8fc1eb2c15e0076e$var$InternalSlider.createSliderWithTooltip = (0, $63d3d36722fc19de$export$2e2bcd8739ae039);
var $8fc1eb2c15e0076e$export$2e2bcd8739ae039 = $8fc1eb2c15e0076e$var$InternalSlider;




var $9nZCP = parcelRequire("9nZCP");
var $d6e59866f4ac3ecb$var$a = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
function $d6e59866f4ac3ecb$var$i(t) {
    return function(e) {
        var n = e || {}, r = n.width ? String(n.width) : t.defaultWidth;
        return t.formats[r] || t.formats[t.defaultWidth];
    };
}
var $d6e59866f4ac3ecb$var$o = {
    date: $d6e59866f4ac3ecb$var$i({
        formats: {
            full: "EEEE, MMMM do, y",
            long: "MMMM do, y",
            medium: "MMM d, y",
            short: "MM/dd/yyyy"
        },
        defaultWidth: "full"
    }),
    time: $d6e59866f4ac3ecb$var$i({
        formats: {
            full: "h:mm:ss a zzzz",
            long: "h:mm:ss a z",
            medium: "h:mm:ss a",
            short: "h:mm a"
        },
        defaultWidth: "full"
    }),
    dateTime: $d6e59866f4ac3ecb$var$i({
        formats: {
            full: "{{date}} 'at' {{time}}",
            long: "{{date}} 'at' {{time}}",
            medium: "{{date}}, {{time}}",
            short: "{{date}}, {{time}}"
        },
        defaultWidth: "full"
    })
}, $d6e59866f4ac3ecb$var$u = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
function $d6e59866f4ac3ecb$var$s(t) {
    return function(e, n) {
        var r, a = n || {};
        if ("formatting" === (a.context ? String(a.context) : "standalone") && t.formattingValues) {
            var i = t.defaultFormattingWidth || t.defaultWidth, o = a.width ? String(a.width) : i;
            r = t.formattingValues[o] || t.formattingValues[i];
        } else {
            var u = t.defaultWidth, s = a.width ? String(a.width) : t.defaultWidth;
            r = t.values[s] || t.values[u];
        }
        return r[t.argumentCallback ? t.argumentCallback(e) : e];
    };
}
function $d6e59866f4ac3ecb$var$c(t) {
    return function(e, n) {
        var r = String(e), a = n || {}, i = a.width, o = i && t.matchPatterns[i] || t.matchPatterns[t.defaultMatchWidth], u = r.match(o);
        if (!u) return null;
        var s, c = u[0], d = i && t.parsePatterns[i] || t.parsePatterns[t.defaultParseWidth];
        return s = "[object Array]" === Object.prototype.toString.call(d) ? function(t, e) {
            for(var n = 0; n < t.length; n++)if (e(t[n])) return n;
        }(d, function(t) {
            return t.test(c);
        }) : function(t, e) {
            for(var n in t)if (t.hasOwnProperty(n) && e(t[n])) return n;
        }(d, function(t) {
            return t.test(c);
        }), s = t.valueCallback ? t.valueCallback(s) : s, {
            value: s = a.valueCallback ? a.valueCallback(s) : s,
            rest: r.slice(c.length)
        };
    };
}
var $d6e59866f4ac3ecb$var$d, $d6e59866f4ac3ecb$var$l = {
    code: "en-US",
    formatDistance: function(t, e, n) {
        var r;
        return n = n || {}, r = "string" == typeof $d6e59866f4ac3ecb$var$a[t] ? $d6e59866f4ac3ecb$var$a[t] : 1 === e ? $d6e59866f4ac3ecb$var$a[t].one : $d6e59866f4ac3ecb$var$a[t].other.replace("{{count}}", e), n.addSuffix ? n.comparison > 0 ? "in " + r : r + " ago" : r;
    },
    formatLong: $d6e59866f4ac3ecb$var$o,
    formatRelative: function(t, e, n, r) {
        return $d6e59866f4ac3ecb$var$u[t];
    },
    localize: {
        ordinalNumber: function(t, e) {
            var n = Number(t), r = n % 100;
            if (r > 20 || r < 10) switch(r % 10){
                case 1:
                    return n + "st";
                case 2:
                    return n + "nd";
                case 3:
                    return n + "rd";
            }
            return n + "th";
        },
        era: $d6e59866f4ac3ecb$var$s({
            values: {
                narrow: [
                    "B",
                    "A"
                ],
                abbreviated: [
                    "BC",
                    "AD"
                ],
                wide: [
                    "Before Christ",
                    "Anno Domini"
                ]
            },
            defaultWidth: "wide"
        }),
        quarter: $d6e59866f4ac3ecb$var$s({
            values: {
                narrow: [
                    "1",
                    "2",
                    "3",
                    "4"
                ],
                abbreviated: [
                    "Q1",
                    "Q2",
                    "Q3",
                    "Q4"
                ],
                wide: [
                    "1st quarter",
                    "2nd quarter",
                    "3rd quarter",
                    "4th quarter"
                ]
            },
            defaultWidth: "wide",
            argumentCallback: function(t) {
                return Number(t) - 1;
            }
        }),
        month: $d6e59866f4ac3ecb$var$s({
            values: {
                narrow: [
                    "J",
                    "F",
                    "M",
                    "A",
                    "M",
                    "J",
                    "J",
                    "A",
                    "S",
                    "O",
                    "N",
                    "D"
                ],
                abbreviated: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ],
                wide: [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                ]
            },
            defaultWidth: "wide"
        }),
        day: $d6e59866f4ac3ecb$var$s({
            values: {
                narrow: [
                    "S",
                    "M",
                    "T",
                    "W",
                    "T",
                    "F",
                    "S"
                ],
                short: [
                    "Su",
                    "Mo",
                    "Tu",
                    "We",
                    "Th",
                    "Fr",
                    "Sa"
                ],
                abbreviated: [
                    "Sun",
                    "Mon",
                    "Tue",
                    "Wed",
                    "Thu",
                    "Fri",
                    "Sat"
                ],
                wide: [
                    "Sunday",
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday"
                ]
            },
            defaultWidth: "wide"
        }),
        dayPeriod: $d6e59866f4ac3ecb$var$s({
            values: {
                narrow: {
                    am: "a",
                    pm: "p",
                    midnight: "mi",
                    noon: "n",
                    morning: "morning",
                    afternoon: "afternoon",
                    evening: "evening",
                    night: "night"
                },
                abbreviated: {
                    am: "AM",
                    pm: "PM",
                    midnight: "midnight",
                    noon: "noon",
                    morning: "morning",
                    afternoon: "afternoon",
                    evening: "evening",
                    night: "night"
                },
                wide: {
                    am: "a.m.",
                    pm: "p.m.",
                    midnight: "midnight",
                    noon: "noon",
                    morning: "morning",
                    afternoon: "afternoon",
                    evening: "evening",
                    night: "night"
                }
            },
            defaultWidth: "wide",
            formattingValues: {
                narrow: {
                    am: "a",
                    pm: "p",
                    midnight: "mi",
                    noon: "n",
                    morning: "in the morning",
                    afternoon: "in the afternoon",
                    evening: "in the evening",
                    night: "at night"
                },
                abbreviated: {
                    am: "AM",
                    pm: "PM",
                    midnight: "midnight",
                    noon: "noon",
                    morning: "in the morning",
                    afternoon: "in the afternoon",
                    evening: "in the evening",
                    night: "at night"
                },
                wide: {
                    am: "a.m.",
                    pm: "p.m.",
                    midnight: "midnight",
                    noon: "noon",
                    morning: "in the morning",
                    afternoon: "in the afternoon",
                    evening: "in the evening",
                    night: "at night"
                }
            },
            defaultFormattingWidth: "wide"
        })
    },
    match: {
        ordinalNumber: ($d6e59866f4ac3ecb$var$d = {
            matchPattern: /^(\d+)(th|st|nd|rd)?/i,
            parsePattern: /\d+/i,
            valueCallback: function(t) {
                return parseInt(t, 10);
            }
        }, function(t, e) {
            var n = String(t), r = e || {}, a = n.match($d6e59866f4ac3ecb$var$d.matchPattern);
            if (!a) return null;
            var i = a[0], o = n.match($d6e59866f4ac3ecb$var$d.parsePattern);
            if (!o) return null;
            var u = $d6e59866f4ac3ecb$var$d.valueCallback ? $d6e59866f4ac3ecb$var$d.valueCallback(o[0]) : o[0];
            return {
                value: u = r.valueCallback ? r.valueCallback(u) : u,
                rest: n.slice(i.length)
            };
        }),
        era: $d6e59866f4ac3ecb$var$c({
            matchPatterns: {
                narrow: /^(b|a)/i,
                abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
                wide: /^(before christ|before common era|anno domini|common era)/i
            },
            defaultMatchWidth: "wide",
            parsePatterns: {
                any: [
                    /^b/i,
                    /^(a|c)/i
                ]
            },
            defaultParseWidth: "any"
        }),
        quarter: $d6e59866f4ac3ecb$var$c({
            matchPatterns: {
                narrow: /^[1234]/i,
                abbreviated: /^q[1234]/i,
                wide: /^[1234](th|st|nd|rd)? quarter/i
            },
            defaultMatchWidth: "wide",
            parsePatterns: {
                any: [
                    /1/i,
                    /2/i,
                    /3/i,
                    /4/i
                ]
            },
            defaultParseWidth: "any",
            valueCallback: function(t) {
                return t + 1;
            }
        }),
        month: $d6e59866f4ac3ecb$var$c({
            matchPatterns: {
                narrow: /^[jfmasond]/i,
                abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
                wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
            },
            defaultMatchWidth: "wide",
            parsePatterns: {
                narrow: [
                    /^j/i,
                    /^f/i,
                    /^m/i,
                    /^a/i,
                    /^m/i,
                    /^j/i,
                    /^j/i,
                    /^a/i,
                    /^s/i,
                    /^o/i,
                    /^n/i,
                    /^d/i
                ],
                any: [
                    /^ja/i,
                    /^f/i,
                    /^mar/i,
                    /^ap/i,
                    /^may/i,
                    /^jun/i,
                    /^jul/i,
                    /^au/i,
                    /^s/i,
                    /^o/i,
                    /^n/i,
                    /^d/i
                ]
            },
            defaultParseWidth: "any"
        }),
        day: $d6e59866f4ac3ecb$var$c({
            matchPatterns: {
                narrow: /^[smtwf]/i,
                short: /^(su|mo|tu|we|th|fr|sa)/i,
                abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
                wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
            },
            defaultMatchWidth: "wide",
            parsePatterns: {
                narrow: [
                    /^s/i,
                    /^m/i,
                    /^t/i,
                    /^w/i,
                    /^t/i,
                    /^f/i,
                    /^s/i
                ],
                any: [
                    /^su/i,
                    /^m/i,
                    /^tu/i,
                    /^w/i,
                    /^th/i,
                    /^f/i,
                    /^sa/i
                ]
            },
            defaultParseWidth: "any"
        }),
        dayPeriod: $d6e59866f4ac3ecb$var$c({
            matchPatterns: {
                narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
                any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
            },
            defaultMatchWidth: "any",
            parsePatterns: {
                any: {
                    am: /^a/i,
                    pm: /^p/i,
                    midnight: /^mi/i,
                    noon: /^no/i,
                    morning: /morning/i,
                    afternoon: /afternoon/i,
                    evening: /evening/i,
                    night: /night/i
                }
            },
            defaultParseWidth: "any"
        })
    },
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
function $d6e59866f4ac3ecb$var$f(t) {
    if (null === t || !0 === t || !1 === t) return NaN;
    var e = Number(t);
    return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function $d6e59866f4ac3ecb$var$h(t, e) {
    if (e.length < t) throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function $d6e59866f4ac3ecb$var$m(t) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var e = Object.prototype.toString.call(t);
    return t instanceof Date || "object" == typeof t && "[object Date]" === e ? new Date(t.getTime()) : "number" == typeof t || "[object Number]" === e ? new Date(t) : ("string" != typeof t && "[object String]" !== e || "undefined" == typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"), console.warn(new Error().stack)), new Date(NaN));
}
function $d6e59866f4ac3ecb$var$w(t, e) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var n = $d6e59866f4ac3ecb$var$m(t).getTime(), r = $d6e59866f4ac3ecb$var$f(e);
    return new Date(n + r);
}
function $d6e59866f4ac3ecb$var$g(t, e) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var n = $d6e59866f4ac3ecb$var$f(e);
    return $d6e59866f4ac3ecb$var$w(t, -n);
}
function $d6e59866f4ac3ecb$var$v(t, e) {
    if (null == t) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var n in e = e || {})e.hasOwnProperty(n) && (t[n] = e[n]);
    return t;
}
function $d6e59866f4ac3ecb$var$y(t, e) {
    switch(t){
        case "P":
            return e.date({
                width: "short"
            });
        case "PP":
            return e.date({
                width: "medium"
            });
        case "PPP":
            return e.date({
                width: "long"
            });
        case "PPPP":
        default:
            return e.date({
                width: "full"
            });
    }
}
function $d6e59866f4ac3ecb$var$b(t, e) {
    switch(t){
        case "p":
            return e.time({
                width: "short"
            });
        case "pp":
            return e.time({
                width: "medium"
            });
        case "ppp":
            return e.time({
                width: "long"
            });
        case "pppp":
        default:
            return e.time({
                width: "full"
            });
    }
}
var $d6e59866f4ac3ecb$var$D = {
    p: $d6e59866f4ac3ecb$var$b,
    P: function(t, e) {
        var n, r = t.match(/(P+)(p+)?/), a = r[1], i = r[2];
        if (!i) return $d6e59866f4ac3ecb$var$y(t, e);
        switch(a){
            case "P":
                n = e.dateTime({
                    width: "short"
                });
                break;
            case "PP":
                n = e.dateTime({
                    width: "medium"
                });
                break;
            case "PPP":
                n = e.dateTime({
                    width: "long"
                });
                break;
            case "PPPP":
            default:
                n = e.dateTime({
                    width: "full"
                });
        }
        return n.replace("{{date}}", $d6e59866f4ac3ecb$var$y(a, e)).replace("{{time}}", $d6e59866f4ac3ecb$var$b(i, e));
    }
};
function $d6e59866f4ac3ecb$var$T(t) {
    return t.getTime() % 6e4;
}
function $d6e59866f4ac3ecb$var$p(t) {
    var e = new Date(t.getTime()), n = Math.ceil(e.getTimezoneOffset());
    return e.setSeconds(0, 0), 6e4 * n + (n > 0 ? (6e4 + $d6e59866f4ac3ecb$var$T(e)) % 6e4 : $d6e59866f4ac3ecb$var$T(e));
}
var $d6e59866f4ac3ecb$var$k = [
    "D",
    "DD"
], $d6e59866f4ac3ecb$var$x = [
    "YY",
    "YYYY"
];
function $d6e59866f4ac3ecb$var$C(t) {
    return -1 !== $d6e59866f4ac3ecb$var$k.indexOf(t);
}
function $d6e59866f4ac3ecb$var$M(t) {
    return -1 !== $d6e59866f4ac3ecb$var$x.indexOf(t);
}
function $d6e59866f4ac3ecb$var$U(t) {
    if ("YYYY" === t) throw new RangeError("Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr");
    if ("YY" === t) throw new RangeError("Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr");
    if ("D" === t) throw new RangeError("Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr");
    if ("DD" === t) throw new RangeError("Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr");
}
function $d6e59866f4ac3ecb$var$S(t, e) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var n = e || {}, r = n.locale, a = r && r.options && r.options.weekStartsOn, i = null == a ? 0 : $d6e59866f4ac3ecb$var$f(a), o = null == n.weekStartsOn ? i : $d6e59866f4ac3ecb$var$f(n.weekStartsOn);
    if (!(o >= 0 && o <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var u = $d6e59866f4ac3ecb$var$m(t), s = u.getUTCDay(), c = (s < o ? 7 : 0) + s - o;
    return u.setUTCDate(u.getUTCDate() - c), u.setUTCHours(0, 0, 0, 0), u;
}
function $d6e59866f4ac3ecb$var$P(t, e) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var n = $d6e59866f4ac3ecb$var$m(t, e), r = n.getUTCFullYear(), a = e || {}, i = a.locale, o = i && i.options && i.options.firstWeekContainsDate, u = null == o ? 1 : $d6e59866f4ac3ecb$var$f(o), s = null == a.firstWeekContainsDate ? u : $d6e59866f4ac3ecb$var$f(a.firstWeekContainsDate);
    if (!(s >= 1 && s <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var c = new Date(0);
    c.setUTCFullYear(r + 1, 0, s), c.setUTCHours(0, 0, 0, 0);
    var d = $d6e59866f4ac3ecb$var$S(c, e), l = new Date(0);
    l.setUTCFullYear(r, 0, s), l.setUTCHours(0, 0, 0, 0);
    var w = $d6e59866f4ac3ecb$var$S(l, e);
    return n.getTime() >= d.getTime() ? r + 1 : n.getTime() >= w.getTime() ? r : r - 1;
}
function $d6e59866f4ac3ecb$var$E(t, e, n) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var r = n || {}, a = r.locale, i = a && a.options && a.options.weekStartsOn, o = null == i ? 0 : $d6e59866f4ac3ecb$var$f(i), u = null == r.weekStartsOn ? o : $d6e59866f4ac3ecb$var$f(r.weekStartsOn);
    if (!(u >= 0 && u <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var s = $d6e59866f4ac3ecb$var$m(t), c = $d6e59866f4ac3ecb$var$f(e), d = s.getUTCDay(), l = c % 7, w = (l + 7) % 7, g = (w < u ? 7 : 0) + c - d;
    return s.setUTCDate(s.getUTCDate() + g), s;
}
function $d6e59866f4ac3ecb$var$Y(t) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var e = 1, n = $d6e59866f4ac3ecb$var$m(t), r = n.getUTCDay(), a = (r < e ? 7 : 0) + r - e;
    return n.setUTCDate(n.getUTCDate() - a), n.setUTCHours(0, 0, 0, 0), n;
}
function $d6e59866f4ac3ecb$var$N(t) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var e = $d6e59866f4ac3ecb$var$m(t), n = e.getUTCFullYear(), r = new Date(0);
    r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
    var a = $d6e59866f4ac3ecb$var$Y(r), i = new Date(0);
    i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
    var o = $d6e59866f4ac3ecb$var$Y(i);
    return e.getTime() >= a.getTime() ? n + 1 : e.getTime() >= o.getTime() ? n : n - 1;
}
function $d6e59866f4ac3ecb$var$q(t) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var e = $d6e59866f4ac3ecb$var$N(t), n = new Date(0);
    n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
    var r = $d6e59866f4ac3ecb$var$Y(n);
    return r;
}
function $d6e59866f4ac3ecb$var$B(t) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var e = $d6e59866f4ac3ecb$var$m(t), n = $d6e59866f4ac3ecb$var$Y(e).getTime() - $d6e59866f4ac3ecb$var$q(e).getTime();
    return Math.round(n / 6048e5) + 1;
}
function $d6e59866f4ac3ecb$var$O(t, e) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var n = e || {}, r = n.locale, a = r && r.options && r.options.firstWeekContainsDate, i = null == a ? 1 : $d6e59866f4ac3ecb$var$f(a), o = null == n.firstWeekContainsDate ? i : $d6e59866f4ac3ecb$var$f(n.firstWeekContainsDate), u = $d6e59866f4ac3ecb$var$P(t, e), s = new Date(0);
    s.setUTCFullYear(u, 0, o), s.setUTCHours(0, 0, 0, 0);
    var c = $d6e59866f4ac3ecb$var$S(s, e);
    return c;
}
function $d6e59866f4ac3ecb$var$H(t, e) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var n = $d6e59866f4ac3ecb$var$m(t), r = $d6e59866f4ac3ecb$var$S(n, e).getTime() - $d6e59866f4ac3ecb$var$O(n, e).getTime();
    return Math.round(r / 6048e5) + 1;
}
var $d6e59866f4ac3ecb$var$L = /^(1[0-2]|0?\d)/, $d6e59866f4ac3ecb$var$W = /^(3[0-1]|[0-2]?\d)/, $d6e59866f4ac3ecb$var$F = /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, $d6e59866f4ac3ecb$var$Q = /^(5[0-3]|[0-4]?\d)/, $d6e59866f4ac3ecb$var$R = /^(2[0-3]|[0-1]?\d)/, $d6e59866f4ac3ecb$var$I = /^(2[0-4]|[0-1]?\d)/, $d6e59866f4ac3ecb$var$X = /^(1[0-1]|0?\d)/, $d6e59866f4ac3ecb$var$G = /^(1[0-2]|0?\d)/, $d6e59866f4ac3ecb$var$A = /^[0-5]?\d/, $d6e59866f4ac3ecb$var$z = /^[0-5]?\d/, $d6e59866f4ac3ecb$var$j = /^\d/, $d6e59866f4ac3ecb$var$K = /^\d{1,2}/, $d6e59866f4ac3ecb$var$J = /^\d{1,3}/, $d6e59866f4ac3ecb$var$Z = /^\d{1,4}/, $d6e59866f4ac3ecb$var$_ = /^-?\d+/, $d6e59866f4ac3ecb$var$$ = /^-?\d/, $d6e59866f4ac3ecb$var$V = /^-?\d{1,2}/, $d6e59866f4ac3ecb$var$tt = /^-?\d{1,3}/, $d6e59866f4ac3ecb$var$et = /^-?\d{1,4}/, $d6e59866f4ac3ecb$var$nt = /^([+-])(\d{2})(\d{2})?|Z/, $d6e59866f4ac3ecb$var$rt = /^([+-])(\d{2})(\d{2})|Z/, $d6e59866f4ac3ecb$var$at = /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/, $d6e59866f4ac3ecb$var$it = /^([+-])(\d{2}):(\d{2})|Z/, $d6e59866f4ac3ecb$var$ot = /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/;
function $d6e59866f4ac3ecb$var$ut(t, e, n) {
    var r = e.match(t);
    if (!r) return null;
    var a = parseInt(r[0], 10);
    return {
        value: n ? n(a) : a,
        rest: e.slice(r[0].length)
    };
}
function $d6e59866f4ac3ecb$var$st(t, e) {
    var n = e.match(t);
    return n ? "Z" === n[0] ? {
        value: 0,
        rest: e.slice(1)
    } : {
        value: ("+" === n[1] ? 1 : -1) * (36e5 * (n[2] ? parseInt(n[2], 10) : 0) + 6e4 * (n[3] ? parseInt(n[3], 10) : 0) + 1e3 * (n[5] ? parseInt(n[5], 10) : 0)),
        rest: e.slice(n[0].length)
    } : null;
}
function $d6e59866f4ac3ecb$var$ct(t, e) {
    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$_, t, e);
}
function $d6e59866f4ac3ecb$var$dt(t, e, n) {
    switch(t){
        case 1:
            return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$j, e, n);
        case 2:
            return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$K, e, n);
        case 3:
            return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$J, e, n);
        case 4:
            return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$Z, e, n);
        default:
            return $d6e59866f4ac3ecb$var$ut(new RegExp("^\\d{1," + t + "}"), e, n);
    }
}
function $d6e59866f4ac3ecb$var$lt(t, e, n) {
    switch(t){
        case 1:
            return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$$, e, n);
        case 2:
            return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$V, e, n);
        case 3:
            return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$tt, e, n);
        case 4:
            return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$et, e, n);
        default:
            return $d6e59866f4ac3ecb$var$ut(new RegExp("^-?\\d{1," + t + "}"), e, n);
    }
}
function $d6e59866f4ac3ecb$var$ft(t) {
    switch(t){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $d6e59866f4ac3ecb$var$ht(t, e) {
    var n, r = e > 0, a = r ? e : 1 - e;
    if (a <= 50) n = t || 100;
    else {
        var i = a + 50;
        n = t + 100 * Math.floor(i / 100) - (t >= i % 100 ? 100 : 0);
    }
    return r ? n : 1 - n;
}
var $d6e59866f4ac3ecb$var$mt = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
], $d6e59866f4ac3ecb$var$wt = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $d6e59866f4ac3ecb$var$gt(t) {
    return t % 400 == 0 || t % 4 == 0 && t % 100 != 0;
}
var $d6e59866f4ac3ecb$var$vt = {
    G: {
        priority: 140,
        parse: function(t, e, n, r) {
            switch(e){
                case "G":
                case "GG":
                case "GGG":
                    return n.era(t, {
                        width: "abbreviated"
                    }) || n.era(t, {
                        width: "narrow"
                    });
                case "GGGGG":
                    return n.era(t, {
                        width: "narrow"
                    });
                case "GGGG":
                default:
                    return n.era(t, {
                        width: "wide"
                    }) || n.era(t, {
                        width: "abbreviated"
                    }) || n.era(t, {
                        width: "narrow"
                    });
            }
        },
        set: function(t, e, n, r) {
            return e.era = n, t.setUTCFullYear(n, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "R",
            "u",
            "t",
            "T"
        ]
    },
    y: {
        priority: 130,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return {
                    year: t,
                    isTwoDigitYear: "yy" === e
                };
            };
            switch(e){
                case "y":
                    return $d6e59866f4ac3ecb$var$dt(4, t, a);
                case "yo":
                    return n.ordinalNumber(t, {
                        unit: "year",
                        valueCallback: a
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t, a);
            }
        },
        validate: function(t, e, n) {
            return e.isTwoDigitYear || e.year > 0;
        },
        set: function(t, e, n, r) {
            var a = t.getUTCFullYear();
            if (n.isTwoDigitYear) {
                var i = $d6e59866f4ac3ecb$var$ht(n.year, a);
                return t.setUTCFullYear(i, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
            }
            var o = "era" in e && 1 !== e.era ? 1 - n.year : n.year;
            return t.setUTCFullYear(o, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    Y: {
        priority: 130,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return {
                    year: t,
                    isTwoDigitYear: "YY" === e
                };
            };
            switch(e){
                case "Y":
                    return $d6e59866f4ac3ecb$var$dt(4, t, a);
                case "Yo":
                    return n.ordinalNumber(t, {
                        unit: "year",
                        valueCallback: a
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t, a);
            }
        },
        validate: function(t, e, n) {
            return e.isTwoDigitYear || e.year > 0;
        },
        set: function(t, e, n, r) {
            var a = $d6e59866f4ac3ecb$var$P(t, r);
            if (n.isTwoDigitYear) {
                var i = $d6e59866f4ac3ecb$var$ht(n.year, a);
                return t.setUTCFullYear(i, 0, r.firstWeekContainsDate), t.setUTCHours(0, 0, 0, 0), $d6e59866f4ac3ecb$var$S(t, r);
            }
            var o = "era" in e && 1 !== e.era ? 1 - n.year : n.year;
            return t.setUTCFullYear(o, 0, r.firstWeekContainsDate), t.setUTCHours(0, 0, 0, 0), $d6e59866f4ac3ecb$var$S(t, r);
        },
        incompatibleTokens: [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]
    },
    R: {
        priority: 130,
        parse: function(t, e, n, r) {
            return $d6e59866f4ac3ecb$var$lt("R" === e ? 4 : e.length, t);
        },
        set: function(t, e, n, r) {
            var a = new Date(0);
            return a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0), $d6e59866f4ac3ecb$var$Y(a);
        },
        incompatibleTokens: [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    u: {
        priority: 130,
        parse: function(t, e, n, r) {
            return $d6e59866f4ac3ecb$var$lt("u" === e ? 4 : e.length, t);
        },
        set: function(t, e, n, r) {
            return t.setUTCFullYear(n, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    Q: {
        priority: 120,
        parse: function(t, e, n, r) {
            switch(e){
                case "Q":
                case "QQ":
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
                case "Qo":
                    return n.ordinalNumber(t, {
                        unit: "quarter"
                    });
                case "QQQ":
                    return n.quarter(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.quarter(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "QQQQQ":
                    return n.quarter(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "QQQQ":
                default:
                    return n.quarter(t, {
                        width: "wide",
                        context: "formatting"
                    }) || n.quarter(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.quarter(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 4;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(3 * (n - 1), 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    q: {
        priority: 120,
        parse: function(t, e, n, r) {
            switch(e){
                case "q":
                case "qq":
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
                case "qo":
                    return n.ordinalNumber(t, {
                        unit: "quarter"
                    });
                case "qqq":
                    return n.quarter(t, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || n.quarter(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                case "qqqqq":
                    return n.quarter(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                case "qqqq":
                default:
                    return n.quarter(t, {
                        width: "wide",
                        context: "standalone"
                    }) || n.quarter(t, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || n.quarter(t, {
                        width: "narrow",
                        context: "standalone"
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 4;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(3 * (n - 1), 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    M: {
        priority: 110,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return t - 1;
            };
            switch(e){
                case "M":
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$L, t, a);
                case "MM":
                    return $d6e59866f4ac3ecb$var$dt(2, t, a);
                case "Mo":
                    return n.ordinalNumber(t, {
                        unit: "month",
                        valueCallback: a
                    });
                case "MMM":
                    return n.month(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.month(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "MMMMM":
                    return n.month(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "MMMM":
                default:
                    return n.month(t, {
                        width: "wide",
                        context: "formatting"
                    }) || n.month(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.month(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 11;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(n, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    L: {
        priority: 110,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return t - 1;
            };
            switch(e){
                case "L":
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$L, t, a);
                case "LL":
                    return $d6e59866f4ac3ecb$var$dt(2, t, a);
                case "Lo":
                    return n.ordinalNumber(t, {
                        unit: "month",
                        valueCallback: a
                    });
                case "LLL":
                    return n.month(t, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || n.month(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                case "LLLLL":
                    return n.month(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                case "LLLL":
                default:
                    return n.month(t, {
                        width: "wide",
                        context: "standalone"
                    }) || n.month(t, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || n.month(t, {
                        width: "narrow",
                        context: "standalone"
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 11;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(n, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    w: {
        priority: 100,
        parse: function(t, e, n, r) {
            switch(e){
                case "w":
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$Q, t);
                case "wo":
                    return n.ordinalNumber(t, {
                        unit: "week"
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 53;
        },
        set: function(t, e, n, r) {
            return $d6e59866f4ac3ecb$var$S(function(t, e, n) {
                $d6e59866f4ac3ecb$var$h(2, arguments);
                var r = $d6e59866f4ac3ecb$var$m(t), a = $d6e59866f4ac3ecb$var$f(e), i = $d6e59866f4ac3ecb$var$H(r, n) - a;
                return r.setUTCDate(r.getUTCDate() - 7 * i), r;
            }(t, n, r), r);
        },
        incompatibleTokens: [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]
    },
    I: {
        priority: 100,
        parse: function(t, e, n, r) {
            switch(e){
                case "I":
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$Q, t);
                case "Io":
                    return n.ordinalNumber(t, {
                        unit: "week"
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 53;
        },
        set: function(t, e, n, r) {
            return $d6e59866f4ac3ecb$var$Y(function(t, e) {
                $d6e59866f4ac3ecb$var$h(2, arguments);
                var n = $d6e59866f4ac3ecb$var$m(t), r = $d6e59866f4ac3ecb$var$f(e), a = $d6e59866f4ac3ecb$var$B(n) - r;
                return n.setUTCDate(n.getUTCDate() - 7 * a), n;
            }(t, n, r), r);
        },
        incompatibleTokens: [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    d: {
        priority: 90,
        parse: function(t, e, n, r) {
            switch(e){
                case "d":
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$W, t);
                case "do":
                    return n.ordinalNumber(t, {
                        unit: "date"
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            var r = $d6e59866f4ac3ecb$var$gt(t.getUTCFullYear()), a = t.getUTCMonth();
            return r ? e >= 1 && e <= $d6e59866f4ac3ecb$var$wt[a] : e >= 1 && e <= $d6e59866f4ac3ecb$var$mt[a];
        },
        set: function(t, e, n, r) {
            return t.setUTCDate(n), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    D: {
        priority: 90,
        parse: function(t, e, n, r) {
            switch(e){
                case "D":
                case "DD":
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$F, t);
                case "Do":
                    return n.ordinalNumber(t, {
                        unit: "date"
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return $d6e59866f4ac3ecb$var$gt(t.getUTCFullYear()) ? e >= 1 && e <= 366 : e >= 1 && e <= 365;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(0, n), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    E: {
        priority: 90,
        parse: function(t, e, n, r) {
            switch(e){
                case "E":
                case "EE":
                case "EEE":
                    return n.day(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "EEEEE":
                    return n.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "EEEEEE":
                    return n.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "EEEE":
                default:
                    return n.day(t, {
                        width: "wide",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 6;
        },
        set: function(t, e, n, r) {
            return (t = $d6e59866f4ac3ecb$var$E(t, n, r)).setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    e: {
        priority: 90,
        parse: function(t, e, n, r) {
            var a = function(t) {
                var e = 7 * Math.floor((t - 1) / 7);
                return (t + r.weekStartsOn + 6) % 7 + e;
            };
            switch(e){
                case "e":
                case "ee":
                    return $d6e59866f4ac3ecb$var$dt(e.length, t, a);
                case "eo":
                    return n.ordinalNumber(t, {
                        unit: "day",
                        valueCallback: a
                    });
                case "eee":
                    return n.day(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "eeeee":
                    return n.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "eeeeee":
                    return n.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "eeee":
                default:
                    return n.day(t, {
                        width: "wide",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "short",
                        context: "formatting"
                    }) || n.day(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 6;
        },
        set: function(t, e, n, r) {
            return (t = $d6e59866f4ac3ecb$var$E(t, n, r)).setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]
    },
    c: {
        priority: 90,
        parse: function(t, e, n, r) {
            var a = function(t) {
                var e = 7 * Math.floor((t - 1) / 7);
                return (t + r.weekStartsOn + 6) % 7 + e;
            };
            switch(e){
                case "c":
                case "cc":
                    return $d6e59866f4ac3ecb$var$dt(e.length, t, a);
                case "co":
                    return n.ordinalNumber(t, {
                        unit: "day",
                        valueCallback: a
                    });
                case "ccc":
                    return n.day(t, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || n.day(t, {
                        width: "short",
                        context: "standalone"
                    }) || n.day(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                case "ccccc":
                    return n.day(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                case "cccccc":
                    return n.day(t, {
                        width: "short",
                        context: "standalone"
                    }) || n.day(t, {
                        width: "narrow",
                        context: "standalone"
                    });
                case "cccc":
                default:
                    return n.day(t, {
                        width: "wide",
                        context: "standalone"
                    }) || n.day(t, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || n.day(t, {
                        width: "short",
                        context: "standalone"
                    }) || n.day(t, {
                        width: "narrow",
                        context: "standalone"
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 6;
        },
        set: function(t, e, n, r) {
            return (t = $d6e59866f4ac3ecb$var$E(t, n, r)).setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]
    },
    i: {
        priority: 90,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return 0 === t ? 7 : t;
            };
            switch(e){
                case "i":
                case "ii":
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
                case "io":
                    return n.ordinalNumber(t, {
                        unit: "day"
                    });
                case "iii":
                    return n.day(t, {
                        width: "abbreviated",
                        context: "formatting",
                        valueCallback: a
                    }) || n.day(t, {
                        width: "short",
                        context: "formatting",
                        valueCallback: a
                    }) || n.day(t, {
                        width: "narrow",
                        context: "formatting",
                        valueCallback: a
                    });
                case "iiiii":
                    return n.day(t, {
                        width: "narrow",
                        context: "formatting",
                        valueCallback: a
                    });
                case "iiiiii":
                    return n.day(t, {
                        width: "short",
                        context: "formatting",
                        valueCallback: a
                    }) || n.day(t, {
                        width: "narrow",
                        context: "formatting",
                        valueCallback: a
                    });
                case "iiii":
                default:
                    return n.day(t, {
                        width: "wide",
                        context: "formatting",
                        valueCallback: a
                    }) || n.day(t, {
                        width: "abbreviated",
                        context: "formatting",
                        valueCallback: a
                    }) || n.day(t, {
                        width: "short",
                        context: "formatting",
                        valueCallback: a
                    }) || n.day(t, {
                        width: "narrow",
                        context: "formatting",
                        valueCallback: a
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 7;
        },
        set: function(t, e, n, r) {
            return (t = function(t, e) {
                $d6e59866f4ac3ecb$var$h(2, arguments);
                var n = $d6e59866f4ac3ecb$var$f(e);
                n % 7 == 0 && (n -= 7);
                var r = 1, a = $d6e59866f4ac3ecb$var$m(t), i = a.getUTCDay(), o = n % 7, u = (o + 7) % 7, s = (u < r ? 7 : 0) + n - i;
                return a.setUTCDate(a.getUTCDate() + s), a;
            }(t, n, r)).setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    a: {
        priority: 80,
        parse: function(t, e, n, r) {
            switch(e){
                case "a":
                case "aa":
                case "aaa":
                    return n.dayPeriod(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "aaaaa":
                    return n.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "aaaa":
                default:
                    return n.dayPeriod(t, {
                        width: "wide",
                        context: "formatting"
                    }) || n.dayPeriod(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        set: function(t, e, n, r) {
            return t.setUTCHours($d6e59866f4ac3ecb$var$ft(n), 0, 0, 0), t;
        },
        incompatibleTokens: [
            "b",
            "B",
            "H",
            "K",
            "k",
            "t",
            "T"
        ]
    },
    b: {
        priority: 80,
        parse: function(t, e, n, r) {
            switch(e){
                case "b":
                case "bb":
                case "bbb":
                    return n.dayPeriod(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "bbbbb":
                    return n.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "bbbb":
                default:
                    return n.dayPeriod(t, {
                        width: "wide",
                        context: "formatting"
                    }) || n.dayPeriod(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        set: function(t, e, n, r) {
            return t.setUTCHours($d6e59866f4ac3ecb$var$ft(n), 0, 0, 0), t;
        },
        incompatibleTokens: [
            "a",
            "B",
            "H",
            "K",
            "k",
            "t",
            "T"
        ]
    },
    B: {
        priority: 80,
        parse: function(t, e, n, r) {
            switch(e){
                case "B":
                case "BB":
                case "BBB":
                    return n.dayPeriod(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "BBBBB":
                    return n.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "BBBB":
                default:
                    return n.dayPeriod(t, {
                        width: "wide",
                        context: "formatting"
                    }) || n.dayPeriod(t, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || n.dayPeriod(t, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        set: function(t, e, n, r) {
            return t.setUTCHours($d6e59866f4ac3ecb$var$ft(n), 0, 0, 0), t;
        },
        incompatibleTokens: [
            "a",
            "b",
            "t",
            "T"
        ]
    },
    h: {
        priority: 70,
        parse: function(t, e, n, r) {
            switch(e){
                case "h":
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$G, t);
                case "ho":
                    return n.ordinalNumber(t, {
                        unit: "hour"
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 12;
        },
        set: function(t, e, n, r) {
            var a = t.getUTCHours() >= 12;
            return a && n < 12 ? t.setUTCHours(n + 12, 0, 0, 0) : a || 12 !== n ? t.setUTCHours(n, 0, 0, 0) : t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]
    },
    H: {
        priority: 70,
        parse: function(t, e, n, r) {
            switch(e){
                case "H":
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$R, t);
                case "Ho":
                    return n.ordinalNumber(t, {
                        unit: "hour"
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 23;
        },
        set: function(t, e, n, r) {
            return t.setUTCHours(n, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]
    },
    K: {
        priority: 70,
        parse: function(t, e, n, r) {
            switch(e){
                case "K":
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$X, t);
                case "Ko":
                    return n.ordinalNumber(t, {
                        unit: "hour"
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 11;
        },
        set: function(t, e, n, r) {
            return t.getUTCHours() >= 12 && n < 12 ? t.setUTCHours(n + 12, 0, 0, 0) : t.setUTCHours(n, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "a",
            "b",
            "h",
            "H",
            "k",
            "t",
            "T"
        ]
    },
    k: {
        priority: 70,
        parse: function(t, e, n, r) {
            switch(e){
                case "k":
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$I, t);
                case "ko":
                    return n.ordinalNumber(t, {
                        unit: "hour"
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 24;
        },
        set: function(t, e, n, r) {
            var a = n <= 24 ? n % 24 : n;
            return t.setUTCHours(a, 0, 0, 0), t;
        },
        incompatibleTokens: [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]
    },
    m: {
        priority: 60,
        parse: function(t, e, n, r) {
            switch(e){
                case "m":
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$A, t);
                case "mo":
                    return n.ordinalNumber(t, {
                        unit: "minute"
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 59;
        },
        set: function(t, e, n, r) {
            return t.setUTCMinutes(n, 0, 0), t;
        },
        incompatibleTokens: [
            "t",
            "T"
        ]
    },
    s: {
        priority: 50,
        parse: function(t, e, n, r) {
            switch(e){
                case "s":
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$z, t);
                case "so":
                    return n.ordinalNumber(t, {
                        unit: "second"
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 59;
        },
        set: function(t, e, n, r) {
            return t.setUTCSeconds(n, 0), t;
        },
        incompatibleTokens: [
            "t",
            "T"
        ]
    },
    S: {
        priority: 30,
        parse: function(t, e, n, r) {
            return $d6e59866f4ac3ecb$var$dt(e.length, t, function(t) {
                return Math.floor(t * Math.pow(10, 3 - e.length));
            });
        },
        set: function(t, e, n, r) {
            return t.setUTCMilliseconds(n), t;
        },
        incompatibleTokens: [
            "t",
            "T"
        ]
    },
    X: {
        priority: 10,
        parse: function(t, e, n, r) {
            switch(e){
                case "X":
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$nt, t);
                case "XX":
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$rt, t);
                case "XXXX":
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$at, t);
                case "XXXXX":
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$ot, t);
                case "XXX":
                default:
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$it, t);
            }
        },
        set: function(t, e, n, r) {
            return e.timestampIsSet ? t : new Date(t.getTime() - n);
        },
        incompatibleTokens: [
            "t",
            "T",
            "x"
        ]
    },
    x: {
        priority: 10,
        parse: function(t, e, n, r) {
            switch(e){
                case "x":
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$nt, t);
                case "xx":
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$rt, t);
                case "xxxx":
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$at, t);
                case "xxxxx":
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$ot, t);
                case "xxx":
                default:
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$it, t);
            }
        },
        set: function(t, e, n, r) {
            return e.timestampIsSet ? t : new Date(t.getTime() - n);
        },
        incompatibleTokens: [
            "t",
            "T",
            "X"
        ]
    },
    t: {
        priority: 40,
        parse: function(t, e, n, r) {
            return $d6e59866f4ac3ecb$var$ct(t);
        },
        set: function(t, e, n, r) {
            return [
                new Date(1e3 * n),
                {
                    timestampIsSet: !0
                }
            ];
        },
        incompatibleTokens: "*"
    },
    T: {
        priority: 20,
        parse: function(t, e, n, r) {
            return $d6e59866f4ac3ecb$var$ct(t);
        },
        set: function(t, e, n, r) {
            return [
                new Date(n),
                {
                    timestampIsSet: !0
                }
            ];
        },
        incompatibleTokens: "*"
    }
}, $d6e59866f4ac3ecb$var$yt = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, $d6e59866f4ac3ecb$var$bt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, $d6e59866f4ac3ecb$var$Dt = /^'([^]*?)'?$/, $d6e59866f4ac3ecb$var$Tt = /''/g, $d6e59866f4ac3ecb$var$pt = /\S/, $d6e59866f4ac3ecb$var$kt = /[a-zA-Z]/;
function $d6e59866f4ac3ecb$export$6b862160d295c8e(t, e, n, r) {
    $d6e59866f4ac3ecb$var$h(3, arguments);
    var a = String(t), i = String(e), o = r || {}, u = o.locale || $d6e59866f4ac3ecb$var$l;
    if (!u.match) throw new RangeError("locale must contain match property");
    var s = u.options && u.options.firstWeekContainsDate, c = null == s ? 1 : $d6e59866f4ac3ecb$var$f(s), d = null == o.firstWeekContainsDate ? c : $d6e59866f4ac3ecb$var$f(o.firstWeekContainsDate);
    if (!(d >= 1 && d <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var w = u.options && u.options.weekStartsOn, y = null == w ? 0 : $d6e59866f4ac3ecb$var$f(w), b = null == o.weekStartsOn ? y : $d6e59866f4ac3ecb$var$f(o.weekStartsOn);
    if (!(b >= 0 && b <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if ("" === i) return "" === a ? $d6e59866f4ac3ecb$var$m(n) : new Date(NaN);
    var T, k = {
        firstWeekContainsDate: d,
        weekStartsOn: b,
        locale: u
    }, x = [
        {
            priority: 10,
            set: $d6e59866f4ac3ecb$var$Ct,
            index: 0
        }
    ], S = i.match($d6e59866f4ac3ecb$var$bt).map(function(t) {
        var e = t[0];
        return "p" === e || "P" === e ? (0, $d6e59866f4ac3ecb$var$D[e])(t, u.formatLong, k) : t;
    }).join("").match($d6e59866f4ac3ecb$var$yt), P = [];
    for(T = 0; T < S.length; T++){
        var E = S[T];
        !o.useAdditionalWeekYearTokens && $d6e59866f4ac3ecb$var$M(E) && $d6e59866f4ac3ecb$var$U(E), !o.useAdditionalDayOfYearTokens && $d6e59866f4ac3ecb$var$C(E) && $d6e59866f4ac3ecb$var$U(E);
        var Y = E[0], N = $d6e59866f4ac3ecb$var$vt[Y];
        if (N) {
            var q = N.incompatibleTokens;
            if (Array.isArray(q)) {
                for(var B = void 0, O = 0; O < P.length; O++){
                    var H = P[O].token;
                    if (-1 !== q.indexOf(H) || H === Y) {
                        B = P[O];
                        break;
                    }
                }
                if (B) throw new RangeError("The format string mustn't contain `".concat(B.fullToken, "` and `").concat(E, "` at the same time"));
            } else if ("*" === N.incompatibleTokens && P.length) throw new RangeError("The format string mustn't contain `".concat(E, "` and any other token at the same time"));
            P.push({
                token: Y,
                fullToken: E
            });
            var L = N.parse(a, E, u.match, k);
            if (!L) return new Date(NaN);
            x.push({
                priority: N.priority,
                set: N.set,
                validate: N.validate,
                value: L.value,
                index: x.length
            }), a = L.rest;
        } else {
            if (Y.match($d6e59866f4ac3ecb$var$kt)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + Y + "`");
            if ("''" === E ? E = "'" : "'" === Y && (E = $d6e59866f4ac3ecb$var$Mt(E)), 0 !== a.indexOf(E)) return new Date(NaN);
            a = a.slice(E.length);
        }
    }
    if (a.length > 0 && $d6e59866f4ac3ecb$var$pt.test(a)) return new Date(NaN);
    var W = x.map(function(t) {
        return t.priority;
    }).sort(function(t, e) {
        return e - t;
    }).filter(function(t, e, n) {
        return n.indexOf(t) === e;
    }).map(function(t) {
        return x.filter(function(e) {
            return e.priority === t;
        }).reverse();
    }).map(function(t) {
        return t[0];
    }), F = $d6e59866f4ac3ecb$var$m(n);
    if (isNaN(F)) return new Date(NaN);
    var Q = $d6e59866f4ac3ecb$var$g(F, $d6e59866f4ac3ecb$var$p(F)), R = {};
    for(T = 0; T < W.length; T++){
        var I = W[T];
        if (I.validate && !I.validate(Q, I.value, k)) return new Date(NaN);
        var X = I.set(Q, R, I.value, k);
        X[0] ? (Q = X[0], $d6e59866f4ac3ecb$var$v(R, X[1])) : Q = X;
    }
    return Q;
}
function $d6e59866f4ac3ecb$var$Ct(t, e) {
    if (e.timestampIsSet) return t;
    var n = new Date(0);
    return n.setFullYear(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()), n.setHours(t.getUTCHours(), t.getUTCMinutes(), t.getUTCSeconds(), t.getUTCMilliseconds()), n;
}
function $d6e59866f4ac3ecb$var$Mt(t) {
    return t.match($d6e59866f4ac3ecb$var$Dt)[1].replace($d6e59866f4ac3ecb$var$Tt, "'");
}
function $d6e59866f4ac3ecb$var$Ut(t) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var e = $d6e59866f4ac3ecb$var$m(t);
    return !isNaN(e);
}
function $d6e59866f4ac3ecb$var$St(t, e) {
    for(var n = t < 0 ? "-" : "", r = Math.abs(t).toString(); r.length < e;)r = "0" + r;
    return n + r;
}
var $d6e59866f4ac3ecb$var$Pt = function(t, e) {
    var n = t.getUTCFullYear(), r = n > 0 ? n : 1 - n;
    return $d6e59866f4ac3ecb$var$St("yy" === e ? r % 100 : r, e.length);
}, $d6e59866f4ac3ecb$var$Et = function(t, e) {
    var n = t.getUTCMonth();
    return "M" === e ? String(n + 1) : $d6e59866f4ac3ecb$var$St(n + 1, 2);
}, $d6e59866f4ac3ecb$var$Yt = function(t, e) {
    return $d6e59866f4ac3ecb$var$St(t.getUTCDate(), e.length);
}, $d6e59866f4ac3ecb$var$Nt = function(t, e) {
    return $d6e59866f4ac3ecb$var$St(t.getUTCHours() % 12 || 12, e.length);
}, $d6e59866f4ac3ecb$var$qt = function(t, e) {
    return $d6e59866f4ac3ecb$var$St(t.getUTCHours(), e.length);
}, $d6e59866f4ac3ecb$var$Bt = function(t, e) {
    return $d6e59866f4ac3ecb$var$St(t.getUTCMinutes(), e.length);
}, $d6e59866f4ac3ecb$var$Ot = function(t, e) {
    return $d6e59866f4ac3ecb$var$St(t.getUTCSeconds(), e.length);
}, $d6e59866f4ac3ecb$var$Ht = function(t, e) {
    var n = e.length, r = t.getUTCMilliseconds();
    return $d6e59866f4ac3ecb$var$St(Math.floor(r * Math.pow(10, n - 3)), e.length);
};
var $d6e59866f4ac3ecb$var$Lt = "midnight", $d6e59866f4ac3ecb$var$Wt = "noon", $d6e59866f4ac3ecb$var$Ft = "morning", $d6e59866f4ac3ecb$var$Qt = "afternoon", $d6e59866f4ac3ecb$var$Rt = "evening", $d6e59866f4ac3ecb$var$It = "night", $d6e59866f4ac3ecb$var$Xt = {
    G: function(t, e, n) {
        var r = t.getUTCFullYear() > 0 ? 1 : 0;
        switch(e){
            case "G":
            case "GG":
            case "GGG":
                return n.era(r, {
                    width: "abbreviated"
                });
            case "GGGGG":
                return n.era(r, {
                    width: "narrow"
                });
            case "GGGG":
            default:
                return n.era(r, {
                    width: "wide"
                });
        }
    },
    y: function(t, e, n) {
        if ("yo" === e) {
            var r = t.getUTCFullYear(), a = r > 0 ? r : 1 - r;
            return n.ordinalNumber(a, {
                unit: "year"
            });
        }
        return $d6e59866f4ac3ecb$var$Pt(t, e);
    },
    Y: function(t, e, n, r) {
        var a = $d6e59866f4ac3ecb$var$P(t, r), i = a > 0 ? a : 1 - a;
        return "YY" === e ? $d6e59866f4ac3ecb$var$St(i % 100, 2) : "Yo" === e ? n.ordinalNumber(i, {
            unit: "year"
        }) : $d6e59866f4ac3ecb$var$St(i, e.length);
    },
    R: function(t, e) {
        return $d6e59866f4ac3ecb$var$St($d6e59866f4ac3ecb$var$N(t), e.length);
    },
    u: function(t, e) {
        return $d6e59866f4ac3ecb$var$St(t.getUTCFullYear(), e.length);
    },
    Q: function(t, e, n) {
        var r = Math.ceil((t.getUTCMonth() + 1) / 3);
        switch(e){
            case "Q":
                return String(r);
            case "QQ":
                return $d6e59866f4ac3ecb$var$St(r, 2);
            case "Qo":
                return n.ordinalNumber(r, {
                    unit: "quarter"
                });
            case "QQQ":
                return n.quarter(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "QQQQQ":
                return n.quarter(r, {
                    width: "narrow",
                    context: "formatting"
                });
            case "QQQQ":
            default:
                return n.quarter(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    q: function(t, e, n) {
        var r = Math.ceil((t.getUTCMonth() + 1) / 3);
        switch(e){
            case "q":
                return String(r);
            case "qq":
                return $d6e59866f4ac3ecb$var$St(r, 2);
            case "qo":
                return n.ordinalNumber(r, {
                    unit: "quarter"
                });
            case "qqq":
                return n.quarter(r, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "qqqqq":
                return n.quarter(r, {
                    width: "narrow",
                    context: "standalone"
                });
            case "qqqq":
            default:
                return n.quarter(r, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    M: function(t, e, n) {
        var r = t.getUTCMonth();
        switch(e){
            case "M":
            case "MM":
                return $d6e59866f4ac3ecb$var$Et(t, e);
            case "Mo":
                return n.ordinalNumber(r + 1, {
                    unit: "month"
                });
            case "MMM":
                return n.month(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "MMMMM":
                return n.month(r, {
                    width: "narrow",
                    context: "formatting"
                });
            case "MMMM":
            default:
                return n.month(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    L: function(t, e, n) {
        var r = t.getUTCMonth();
        switch(e){
            case "L":
                return String(r + 1);
            case "LL":
                return $d6e59866f4ac3ecb$var$St(r + 1, 2);
            case "Lo":
                return n.ordinalNumber(r + 1, {
                    unit: "month"
                });
            case "LLL":
                return n.month(r, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "LLLLL":
                return n.month(r, {
                    width: "narrow",
                    context: "standalone"
                });
            case "LLLL":
            default:
                return n.month(r, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    w: function(t, e, n, r) {
        var a = $d6e59866f4ac3ecb$var$H(t, r);
        return "wo" === e ? n.ordinalNumber(a, {
            unit: "week"
        }) : $d6e59866f4ac3ecb$var$St(a, e.length);
    },
    I: function(t, e, n) {
        var r = $d6e59866f4ac3ecb$var$B(t);
        return "Io" === e ? n.ordinalNumber(r, {
            unit: "week"
        }) : $d6e59866f4ac3ecb$var$St(r, e.length);
    },
    d: function(t, e, n) {
        return "do" === e ? n.ordinalNumber(t.getUTCDate(), {
            unit: "date"
        }) : $d6e59866f4ac3ecb$var$Yt(t, e);
    },
    D: function(t, e, n) {
        var r = function(t) {
            $d6e59866f4ac3ecb$var$h(1, arguments);
            var e = $d6e59866f4ac3ecb$var$m(t), n = e.getTime();
            e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
            var r = e.getTime(), a = n - r;
            return Math.floor(a / 864e5) + 1;
        }(t);
        return "Do" === e ? n.ordinalNumber(r, {
            unit: "dayOfYear"
        }) : $d6e59866f4ac3ecb$var$St(r, e.length);
    },
    E: function(t, e, n) {
        var r = t.getUTCDay();
        switch(e){
            case "E":
            case "EE":
            case "EEE":
                return n.day(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "EEEEE":
                return n.day(r, {
                    width: "narrow",
                    context: "formatting"
                });
            case "EEEEEE":
                return n.day(r, {
                    width: "short",
                    context: "formatting"
                });
            case "EEEE":
            default:
                return n.day(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    e: function(t, e, n, r) {
        var a = t.getUTCDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
        switch(e){
            case "e":
                return String(i);
            case "ee":
                return $d6e59866f4ac3ecb$var$St(i, 2);
            case "eo":
                return n.ordinalNumber(i, {
                    unit: "day"
                });
            case "eee":
                return n.day(a, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "eeeee":
                return n.day(a, {
                    width: "narrow",
                    context: "formatting"
                });
            case "eeeeee":
                return n.day(a, {
                    width: "short",
                    context: "formatting"
                });
            case "eeee":
            default:
                return n.day(a, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    c: function(t, e, n, r) {
        var a = t.getUTCDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
        switch(e){
            case "c":
                return String(i);
            case "cc":
                return $d6e59866f4ac3ecb$var$St(i, e.length);
            case "co":
                return n.ordinalNumber(i, {
                    unit: "day"
                });
            case "ccc":
                return n.day(a, {
                    width: "abbreviated",
                    context: "standalone"
                });
            case "ccccc":
                return n.day(a, {
                    width: "narrow",
                    context: "standalone"
                });
            case "cccccc":
                return n.day(a, {
                    width: "short",
                    context: "standalone"
                });
            case "cccc":
            default:
                return n.day(a, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    i: function(t, e, n) {
        var r = t.getUTCDay(), a = 0 === r ? 7 : r;
        switch(e){
            case "i":
                return String(a);
            case "ii":
                return $d6e59866f4ac3ecb$var$St(a, e.length);
            case "io":
                return n.ordinalNumber(a, {
                    unit: "day"
                });
            case "iii":
                return n.day(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "iiiii":
                return n.day(r, {
                    width: "narrow",
                    context: "formatting"
                });
            case "iiiiii":
                return n.day(r, {
                    width: "short",
                    context: "formatting"
                });
            case "iiii":
            default:
                return n.day(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    a: function(t, e, n) {
        var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(e){
            case "a":
            case "aa":
            case "aaa":
                return n.dayPeriod(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaaaa":
                return n.dayPeriod(r, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return n.dayPeriod(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    b: function(t, e, n) {
        var r, a = t.getUTCHours();
        switch(r = 12 === a ? $d6e59866f4ac3ecb$var$Wt : 0 === a ? $d6e59866f4ac3ecb$var$Lt : a / 12 >= 1 ? "pm" : "am", e){
            case "b":
            case "bb":
            case "bbb":
                return n.dayPeriod(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbbbb":
                return n.dayPeriod(r, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return n.dayPeriod(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    B: function(t, e, n) {
        var r, a = t.getUTCHours();
        switch(r = a >= 17 ? $d6e59866f4ac3ecb$var$Rt : a >= 12 ? $d6e59866f4ac3ecb$var$Qt : a >= 4 ? $d6e59866f4ac3ecb$var$Ft : $d6e59866f4ac3ecb$var$It, e){
            case "B":
            case "BB":
            case "BBB":
                return n.dayPeriod(r, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return n.dayPeriod(r, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return n.dayPeriod(r, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    h: function(t, e, n) {
        if ("ho" === e) {
            var r = t.getUTCHours() % 12;
            return 0 === r && (r = 12), n.ordinalNumber(r, {
                unit: "hour"
            });
        }
        return $d6e59866f4ac3ecb$var$Nt(t, e);
    },
    H: function(t, e, n) {
        return "Ho" === e ? n.ordinalNumber(t.getUTCHours(), {
            unit: "hour"
        }) : $d6e59866f4ac3ecb$var$qt(t, e);
    },
    K: function(t, e, n) {
        var r = t.getUTCHours() % 12;
        return "Ko" === e ? n.ordinalNumber(r, {
            unit: "hour"
        }) : $d6e59866f4ac3ecb$var$St(r, e.length);
    },
    k: function(t, e, n) {
        var r = t.getUTCHours();
        return 0 === r && (r = 24), "ko" === e ? n.ordinalNumber(r, {
            unit: "hour"
        }) : $d6e59866f4ac3ecb$var$St(r, e.length);
    },
    m: function(t, e, n) {
        return "mo" === e ? n.ordinalNumber(t.getUTCMinutes(), {
            unit: "minute"
        }) : $d6e59866f4ac3ecb$var$Bt(t, e);
    },
    s: function(t, e, n) {
        return "so" === e ? n.ordinalNumber(t.getUTCSeconds(), {
            unit: "second"
        }) : $d6e59866f4ac3ecb$var$Ot(t, e);
    },
    S: function(t, e) {
        return $d6e59866f4ac3ecb$var$Ht(t, e);
    },
    X: function(t, e, n, r) {
        var a = (r._originalDate || t).getTimezoneOffset();
        if (0 === a) return "Z";
        switch(e){
            case "X":
                return $d6e59866f4ac3ecb$var$At(a);
            case "XXXX":
            case "XX":
                return $d6e59866f4ac3ecb$var$zt(a);
            case "XXXXX":
            case "XXX":
            default:
                return $d6e59866f4ac3ecb$var$zt(a, ":");
        }
    },
    x: function(t, e, n, r) {
        var a = (r._originalDate || t).getTimezoneOffset();
        switch(e){
            case "x":
                return $d6e59866f4ac3ecb$var$At(a);
            case "xxxx":
            case "xx":
                return $d6e59866f4ac3ecb$var$zt(a);
            case "xxxxx":
            case "xxx":
            default:
                return $d6e59866f4ac3ecb$var$zt(a, ":");
        }
    },
    O: function(t, e, n, r) {
        var a = (r._originalDate || t).getTimezoneOffset();
        switch(e){
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $d6e59866f4ac3ecb$var$Gt(a, ":");
            case "OOOO":
            default:
                return "GMT" + $d6e59866f4ac3ecb$var$zt(a, ":");
        }
    },
    z: function(t, e, n, r) {
        var a = (r._originalDate || t).getTimezoneOffset();
        switch(e){
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $d6e59866f4ac3ecb$var$Gt(a, ":");
            case "zzzz":
            default:
                return "GMT" + $d6e59866f4ac3ecb$var$zt(a, ":");
        }
    },
    t: function(t, e, n, r) {
        var a = r._originalDate || t;
        return $d6e59866f4ac3ecb$var$St(Math.floor(a.getTime() / 1e3), e.length);
    },
    T: function(t, e, n, r) {
        return $d6e59866f4ac3ecb$var$St((r._originalDate || t).getTime(), e.length);
    }
};
function $d6e59866f4ac3ecb$var$Gt(t, e) {
    var n = t > 0 ? "-" : "+", r = Math.abs(t), a = Math.floor(r / 60), i = r % 60;
    if (0 === i) return n + String(a);
    var o = e || "";
    return n + String(a) + o + $d6e59866f4ac3ecb$var$St(i, 2);
}
function $d6e59866f4ac3ecb$var$At(t, e) {
    return t % 60 == 0 ? (t > 0 ? "-" : "+") + $d6e59866f4ac3ecb$var$St(Math.abs(t) / 60, 2) : $d6e59866f4ac3ecb$var$zt(t, e);
}
function $d6e59866f4ac3ecb$var$zt(t, e) {
    var n = e || "", r = t > 0 ? "-" : "+", a = Math.abs(t);
    return r + $d6e59866f4ac3ecb$var$St(Math.floor(a / 60), 2) + n + $d6e59866f4ac3ecb$var$St(a % 60, 2);
}
var $d6e59866f4ac3ecb$var$jt = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, $d6e59866f4ac3ecb$var$Kt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, $d6e59866f4ac3ecb$var$Jt = /^'([^]*?)'?$/, $d6e59866f4ac3ecb$var$Zt = /''/g, $d6e59866f4ac3ecb$var$_t = /[a-zA-Z]/;
function $d6e59866f4ac3ecb$var$$t(t, e, n) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var r = String(e), a = n || {}, i = a.locale || $d6e59866f4ac3ecb$var$l, o = i.options && i.options.firstWeekContainsDate, u = null == o ? 1 : $d6e59866f4ac3ecb$var$f(o), s = null == a.firstWeekContainsDate ? u : $d6e59866f4ac3ecb$var$f(a.firstWeekContainsDate);
    if (!(s >= 1 && s <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var c = i.options && i.options.weekStartsOn, d = null == c ? 0 : $d6e59866f4ac3ecb$var$f(c), w = null == a.weekStartsOn ? d : $d6e59866f4ac3ecb$var$f(a.weekStartsOn);
    if (!(w >= 0 && w <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!i.localize) throw new RangeError("locale must contain localize property");
    if (!i.formatLong) throw new RangeError("locale must contain formatLong property");
    var v = $d6e59866f4ac3ecb$var$m(t);
    if (!$d6e59866f4ac3ecb$var$Ut(v)) throw new RangeError("Invalid time value");
    var y = $d6e59866f4ac3ecb$var$p(v), b = $d6e59866f4ac3ecb$var$g(v, y), T = {
        firstWeekContainsDate: s,
        weekStartsOn: w,
        locale: i,
        _originalDate: v
    }, k = r.match($d6e59866f4ac3ecb$var$Kt).map(function(t) {
        var e = t[0];
        return "p" === e || "P" === e ? (0, $d6e59866f4ac3ecb$var$D[e])(t, i.formatLong, T) : t;
    }).join("").match($d6e59866f4ac3ecb$var$jt).map(function(t) {
        if ("''" === t) return "'";
        var e = t[0];
        if ("'" === e) return $d6e59866f4ac3ecb$var$Vt(t);
        var n = $d6e59866f4ac3ecb$var$Xt[e];
        if (n) return !a.useAdditionalWeekYearTokens && $d6e59866f4ac3ecb$var$M(t) && $d6e59866f4ac3ecb$var$U(t), !a.useAdditionalDayOfYearTokens && $d6e59866f4ac3ecb$var$C(t) && $d6e59866f4ac3ecb$var$U(t), n(b, t, i.localize, T);
        if (e.match($d6e59866f4ac3ecb$var$_t)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + e + "`");
        return t;
    }).join("");
    return k;
}
function $d6e59866f4ac3ecb$var$Vt(t) {
    return t.match($d6e59866f4ac3ecb$var$Jt)[1].replace($d6e59866f4ac3ecb$var$Zt, "'");
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $d6e59866f4ac3ecb$var$te(t, e) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var n = $d6e59866f4ac3ecb$var$m(t), r = $d6e59866f4ac3ecb$var$f(e);
    return isNaN(r) ? new Date(NaN) : r ? (n.setDate(n.getDate() + r), n) : n;
}
function $d6e59866f4ac3ecb$var$ee(t, e) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var n = t || {}, r = $d6e59866f4ac3ecb$var$m(n.start), a = $d6e59866f4ac3ecb$var$m(n.end), i = a.getTime();
    if (!(r.getTime() <= i)) throw new RangeError("Invalid interval");
    var o = [], u = r;
    u.setHours(0, 0, 0, 0);
    var s = e && "step" in e ? Number(e.step) : 1;
    if (s < 1 || isNaN(s)) throw new RangeError("`options.step` must be a number greater than 1");
    for(; u.getTime() <= i;)o.push($d6e59866f4ac3ecb$var$m(u)), u.setDate(u.getDate() + s), u.setHours(0, 0, 0, 0);
    return o;
}
function $d6e59866f4ac3ecb$var$ne(t, e) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var n = e || {}, r = n.locale, a = r && r.options && r.options.weekStartsOn, i = null == a ? 0 : $d6e59866f4ac3ecb$var$f(a), o = null == n.weekStartsOn ? i : $d6e59866f4ac3ecb$var$f(n.weekStartsOn);
    if (!(o >= 0 && o <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var u = $d6e59866f4ac3ecb$var$m(t), s = u.getDay(), c = 6 + (s < o ? -7 : 0) - (s - o);
    return u.setDate(u.getDate() + c), u.setHours(23, 59, 59, 999), u;
}
function $d6e59866f4ac3ecb$var$re(t) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var e = $d6e59866f4ac3ecb$var$m(t);
    return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function $d6e59866f4ac3ecb$var$ae(t, e) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var n = e || {}, r = n.locale, a = r && r.options && r.options.weekStartsOn, i = null == a ? 0 : $d6e59866f4ac3ecb$var$f(a), o = null == n.weekStartsOn ? i : $d6e59866f4ac3ecb$var$f(n.weekStartsOn);
    if (!(o >= 0 && o <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var u = $d6e59866f4ac3ecb$var$m(t), s = u.getDay(), c = (s < o ? 7 : 0) + s - o;
    return u.setDate(u.getDate() - c), u.setHours(0, 0, 0, 0), u;
}
function $d6e59866f4ac3ecb$export$fa1807b86c22c08c(t) {
    var e = void 0 === t ? {} : t, n = e.firstDayOfWeek, r = void 0 === n ? 1 : n, a = e.weekdayLabelFormat, i = void 0 === a ? function(t) {
        return $d6e59866f4ac3ecb$var$$t(t, "iiiiii");
    } : a, o = new Date();
    return $d6e59866f4ac3ecb$var$ee({
        start: $d6e59866f4ac3ecb$var$te($d6e59866f4ac3ecb$var$ae(o), r),
        end: $d6e59866f4ac3ecb$var$te($d6e59866f4ac3ecb$var$ne(o), r)
    }).reduce(function(t, e) {
        return t.push(i(e)), t;
    }, []);
}
function $d6e59866f4ac3ecb$export$5f84d4e06c0693c4(t) {
    var e = t.year, n = t.month, r = t.firstDayOfWeek, a = void 0 === r ? 1 : r, i = t.dayLabelFormat, o = void 0 === i ? function(t) {
        return $d6e59866f4ac3ecb$var$$t(t, "dd");
    } : i, u = new Date(e, n), s = $d6e59866f4ac3ecb$var$re(u), c = function(t) {
        $d6e59866f4ac3ecb$var$h(1, arguments);
        var e = $d6e59866f4ac3ecb$var$m(t), n = e.getDay();
        return n;
    }(s), d = function(t) {
        $d6e59866f4ac3ecb$var$h(1, arguments);
        var e = $d6e59866f4ac3ecb$var$m(t), n = e.getMonth();
        return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(23, 59, 59, 999), e;
    }(u);
    return function() {
        for(var t = 0, e = 0, n = arguments.length; e < n; e++)t += arguments[e].length;
        var r = Array(t), a = 0;
        for(e = 0; e < n; e++)for(var i = arguments[e], o = 0, u = i.length; o < u; o++, a++)r[a] = i[o];
        return r;
    }(Array.from(Array(c >= a ? c - a : 6 - a + c + 1).keys()).fill(0), $d6e59866f4ac3ecb$var$ee({
        start: s,
        end: d
    }).map(function(t) {
        return {
            date: t,
            dayLabel: o(t)
        };
    }));
}
var $d6e59866f4ac3ecb$export$ae8ce18f4c87a98d = function(t) {
    return $d6e59866f4ac3ecb$var$$t(t, "dd");
}, $d6e59866f4ac3ecb$export$c91a7ea1bd918f41 = function(t) {
    return $d6e59866f4ac3ecb$var$$t(t, "eeeeee");
}, $d6e59866f4ac3ecb$export$85e553ba2321487b = function(t) {
    return $d6e59866f4ac3ecb$var$$t(t, "MMMM yyyy");
};
function $d6e59866f4ac3ecb$export$41527c87dc759868(e) {
    var n = e.year, r = e.month, a = e.firstDayOfWeek, i = void 0 === a ? 1 : a, o = e.dayLabelFormat, u = void 0 === o ? $d6e59866f4ac3ecb$export$ae8ce18f4c87a98d : o, s = e.weekdayLabelFormat, c = void 0 === s ? $d6e59866f4ac3ecb$export$c91a7ea1bd918f41 : s, d = e.monthLabelFormat, l = void 0 === d ? $d6e59866f4ac3ecb$export$85e553ba2321487b : d;
    return {
        days: (0, $9nZCP.useMemo)(function() {
            return $d6e59866f4ac3ecb$export$5f84d4e06c0693c4({
                year: n,
                month: r,
                firstDayOfWeek: i,
                dayLabelFormat: u
            });
        }, [
            n,
            r,
            i,
            u
        ]),
        weekdayLabels: (0, $9nZCP.useMemo)(function() {
            return $d6e59866f4ac3ecb$export$fa1807b86c22c08c({
                firstDayOfWeek: i,
                weekdayLabelFormat: c
            });
        }, [
            i,
            c
        ]),
        monthLabel: l(new Date(n, r))
    };
}
function $d6e59866f4ac3ecb$var$le(t, e) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var n = $d6e59866f4ac3ecb$var$m(t), r = $d6e59866f4ac3ecb$var$m(e);
    return n.getTime() < r.getTime();
}
function $d6e59866f4ac3ecb$var$fe(t, e) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var n = $d6e59866f4ac3ecb$var$m(t), r = $d6e59866f4ac3ecb$var$m(e);
    return n.getTime() > r.getTime();
}
function $d6e59866f4ac3ecb$var$he(t, e) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var n = e || {}, r = $d6e59866f4ac3ecb$var$m(t).getTime(), a = $d6e59866f4ac3ecb$var$m(n.start).getTime(), i = $d6e59866f4ac3ecb$var$m(n.end).getTime();
    if (!(a <= i)) throw new RangeError("Invalid interval");
    return r >= a && r <= i;
}
function $d6e59866f4ac3ecb$var$me(t) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var e = $d6e59866f4ac3ecb$var$m(t);
    return e.setHours(0, 0, 0, 0), e;
}
function $d6e59866f4ac3ecb$var$we(t, e) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var n = $d6e59866f4ac3ecb$var$me(t), r = $d6e59866f4ac3ecb$var$me(e);
    return n.getTime() === r.getTime();
}
function $d6e59866f4ac3ecb$var$ge(t, e) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var n = $d6e59866f4ac3ecb$var$m(t), r = $d6e59866f4ac3ecb$var$f(e);
    if (isNaN(r)) return new Date(NaN);
    if (!r) return n;
    var a = n.getDate(), i = new Date(n.getTime());
    i.setMonth(n.getMonth() + r + 1, 0);
    var o = i.getDate();
    return a >= o ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), a), n);
}
var $d6e59866f4ac3ecb$var$ve = function(t, e) {
    return void 0 === t && (t = []), t.some(function(t) {
        return $d6e59866f4ac3ecb$var$we(e, t);
    });
};
function $d6e59866f4ac3ecb$export$b165a5bc4ad10935(t, e, n) {
    return !(!e || !n) && $d6e59866f4ac3ecb$var$he(t, {
        start: e,
        end: n
    });
}
function $d6e59866f4ac3ecb$export$8260647f4936851e(t, e, n) {
    return !!(e && $d6e59866f4ac3ecb$var$we(t, e) || n && $d6e59866f4ac3ecb$var$we(t, n));
}
function $d6e59866f4ac3ecb$export$c8db6e7f6335237c(t, e) {
    return !(!e || !$d6e59866f4ac3ecb$var$we(t, e));
}
function $d6e59866f4ac3ecb$export$b3c72c1338a4197(t, e) {
    return !(!e || !$d6e59866f4ac3ecb$var$we(t, e));
}
function $d6e59866f4ac3ecb$export$757515830049c710(t) {
    var e = t.date, n = t.minBookingDate, r = t.maxBookingDate, a = t.isDateBlockedFn, i = t.startDate, o = t.endDate, u = t.minBookingDays, s = void 0 === u ? 1 : u, c = t.unavailableDates, d = void 0 === c ? [] : c, l = n ? new Date(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0, 0) : n, f = r ? new Date(r.getFullYear(), r.getMonth(), r.getDate(), 0, 0, 0) : r;
    return !!($d6e59866f4ac3ecb$var$ve(d, e) || l && $d6e59866f4ac3ecb$var$le(e, l) || f && $d6e59866f4ac3ecb$var$fe(e, f) || i && !o && s > 1 && $d6e59866f4ac3ecb$var$he(e, {
        start: i,
        end: $d6e59866f4ac3ecb$var$te(i, s - 2)
    }) || a && a(e));
}
function $d6e59866f4ac3ecb$export$3046c068c9f01601(t) {
    var e = $d6e59866f4ac3ecb$var$re(t);
    return {
        year: function(t) {
            $d6e59866f4ac3ecb$var$h(1, arguments);
            var e = $d6e59866f4ac3ecb$var$m(t), n = e.getFullYear();
            return n;
        }(e),
        month: function(t) {
            $d6e59866f4ac3ecb$var$h(1, arguments);
            var e = $d6e59866f4ac3ecb$var$m(t), n = e.getMonth();
            return n;
        }(e),
        date: e
    };
}
function $d6e59866f4ac3ecb$export$f446e9d44b503a48() {
    return $d6e59866f4ac3ecb$export$3046c068c9f01601($d6e59866f4ac3ecb$var$me(Date.now()));
}
function $d6e59866f4ac3ecb$export$6b0a3e73eaccfee4(t, e) {
    var n = e ? $d6e59866f4ac3ecb$export$3046c068c9f01601(e) : $d6e59866f4ac3ecb$export$f446e9d44b503a48(), r = n.date, a = [
        n
    ];
    return t > 1 && (a = Array.from(Array(t - 1).keys()).reduce(function(t) {
        return r = $d6e59866f4ac3ecb$var$ge(t[t.length - 1].date, 1), t.concat([
            $d6e59866f4ac3ecb$export$3046c068c9f01601(r)
        ]);
    }, a)), a;
}
function $d6e59866f4ac3ecb$var$Me(t, e, n, r) {
    var a = t[r ? n > 0 ? 0 : t.length - r : n > 0 ? t.length - 1 : 0].date;
    return Array.from(Array(e).keys()).reduce(function(t) {
        return a = 0 === t.length ? $d6e59866f4ac3ecb$var$ge(a, n) : $d6e59866f4ac3ecb$var$ge(a, n >= 0 ? 1 : -1), n > 0 ? t.concat([
            $d6e59866f4ac3ecb$export$3046c068c9f01601(a)
        ]) : [
            $d6e59866f4ac3ecb$export$3046c068c9f01601(a)
        ].concat(t);
    }, []);
}
function $d6e59866f4ac3ecb$export$c5e4b84d2ce61726(t, e, n) {
    return t && "string" == typeof e ? $d6e59866f4ac3ecb$var$$t(t, e) : t && "function" == typeof e ? e(t) : n;
}
function $d6e59866f4ac3ecb$var$Se(t) {
    var e = t.startDate, n = t.endDate, r = t.isDateBlocked, a = t.minBookingDays, i = t.exactMinBookingDays, o = t.minBookingDate, u = t.maxBookingDate, s = !o || !$d6e59866f4ac3ecb$var$le(e, $d6e59866f4ac3ecb$var$te(o, -1)), c = !u || !$d6e59866f4ac3ecb$var$fe($d6e59866f4ac3ecb$var$te(e, a - 1), u);
    return !(!e || 1 !== a || n || r(e)) || (e && a > 1 && !n && !i || e && a > 0 && i && s && c || e && a > 0 && i && !o && !u ? !$d6e59866f4ac3ecb$var$ee({
        start: e,
        end: $d6e59866f4ac3ecb$var$te(e, a - 1)
    }).some(function(t) {
        return r(t);
    }) : !(!e || !n || i) && !$d6e59866f4ac3ecb$var$le(n, $d6e59866f4ac3ecb$var$te(e, a - 1)) && !$d6e59866f4ac3ecb$var$ee({
        start: e,
        end: n
    }).some(function(t) {
        return r(t);
    }));
}
var $d6e59866f4ac3ecb$export$99a467bcc22b8df9 = "startDate", $d6e59866f4ac3ecb$export$1113b91e67d28ba7 = "endDate";
function $d6e59866f4ac3ecb$export$2d9bfdb55c82a287(t) {
    var a = t.startDate, i = t.endDate, o = t.focusedInput, u = t.minBookingDate, s = t.maxBookingDate, c = t.onDatesChange, d = t.initialVisibleMonth, l = t.exactMinBookingDays, f = void 0 !== l && l, h = t.minBookingDays, m = void 0 === h ? 1 : h, w = t.numberOfMonths, g = void 0 === w ? 2 : w, v = t.firstDayOfWeek, y = void 0 === v ? 1 : v, b = t.isDateBlocked, D = void 0 === b ? function() {
        return !1;
    } : b, T = t.unavailableDates, p = void 0 === T ? [] : T, k = t.changeActiveMonthOnSelect, x = void 0 === k || k, C = (0, $9nZCP.useState)(function() {
        return $d6e59866f4ac3ecb$export$6b0a3e73eaccfee4(g, a || d || null);
    }), M = C[0], U = C[1], S = (0, $9nZCP.useState)(null), P = S[0], E = S[1], Y = (0, $9nZCP.useState)(a), N = Y[0], q = Y[1];
    (0, $9nZCP.useEffect)(function() {
        return "undefined" != typeof window && window.addEventListener && window.addEventListener("keydown", L), function() {
            window.removeEventListener && window.removeEventListener("keydown", L);
        };
    });
    var B = function(t) {
        return $d6e59866f4ac3ecb$var$ve(p, t) || D(t);
    }, O = function(t) {
        q(t), (!N || N && !$d6e59866f4ac3ecb$var$we(t, N)) && U($d6e59866f4ac3ecb$export$6b0a3e73eaccfee4(g, t));
    }, H = function(t) {
        return $d6e59866f4ac3ecb$export$757515830049c710({
            date: t,
            minBookingDate: u,
            maxBookingDate: s,
            startDate: a,
            endDate: i,
            minBookingDays: m,
            isDateBlockedFn: B
        });
    };
    function L(t) {
        if (("ArrowRight" === t.key || "ArrowLeft" === t.key || "ArrowDown" === t.key || "ArrowUp" === t.key) && !N) {
            var e = M[0];
            O(e.date), U($d6e59866f4ac3ecb$export$6b0a3e73eaccfee4(g, e.date));
        }
    }
    var W = (0, $9nZCP.useCallback)(function() {
        U($d6e59866f4ac3ecb$var$Me(M, g, -1)), q(null);
    }, [
        M,
        g
    ]), F = (0, $9nZCP.useCallback)(function() {
        U($d6e59866f4ac3ecb$var$Me(M, g, -1, 1)), q(null);
    }, [
        M,
        g
    ]), Q = (0, $9nZCP.useCallback)(function() {
        U($d6e59866f4ac3ecb$var$Me(M, g, 1)), q(null);
    }, [
        M,
        g
    ]), R = (0, $9nZCP.useCallback)(function() {
        U($d6e59866f4ac3ecb$var$Me(M, g, 1, 1)), q(null);
    }, [
        M,
        g
    ]), I = (0, $9nZCP.useCallback)(function(t) {
        U($d6e59866f4ac3ecb$export$6b0a3e73eaccfee4(g, t)), q(null);
    }, [
        g
    ]), X = (0, $9nZCP.useCallback)(function(t) {
        void 0 === t && (t = 1), U($d6e59866f4ac3ecb$var$Me(M, g, -(12 * t - g + 1))), q(null);
    }, [
        M,
        g
    ]), G = (0, $9nZCP.useCallback)(function(t) {
        void 0 === t && (t = 1), U($d6e59866f4ac3ecb$var$Me(M, g, 12 * t - g + 1)), q(null);
    }, [
        M,
        g
    ]);
    return {
        firstDayOfWeek: y,
        activeMonths: M,
        isDateSelected: function(t) {
            return $d6e59866f4ac3ecb$export$b165a5bc4ad10935(t, a, i);
        },
        isDateHovered: function(t) {
            return function(t) {
                var e = t.date, n = t.startDate, r = t.endDate, a = t.isDateBlocked, i = t.hoveredDate, o = t.minBookingDays, u = t.exactMinBookingDays;
                return i && o > 1 && u && $d6e59866f4ac3ecb$var$he(e, {
                    start: i,
                    end: $d6e59866f4ac3ecb$var$te(i, o - 1)
                }) ? !$d6e59866f4ac3ecb$var$ee({
                    start: i,
                    end: $d6e59866f4ac3ecb$var$te(i, o - 1)
                }).some(function(t) {
                    return a(t);
                }) : n && !r && i && $d6e59866f4ac3ecb$var$he(e, {
                    start: n,
                    end: $d6e59866f4ac3ecb$var$te(n, o - 1)
                }) && $d6e59866f4ac3ecb$var$we(n, i) && o > 1 ? !$d6e59866f4ac3ecb$var$ee({
                    start: n,
                    end: $d6e59866f4ac3ecb$var$te(n, o - 1)
                }).some(function(t) {
                    return a(t);
                }) : !(!n || r || !i || $d6e59866f4ac3ecb$var$le(i, n) || !$d6e59866f4ac3ecb$var$he(e, {
                    start: n,
                    end: i
                })) && !$d6e59866f4ac3ecb$var$ee({
                    start: n,
                    end: i
                }).some(function(t) {
                    return a(t);
                });
            }({
                date: t,
                hoveredDate: P,
                startDate: a,
                endDate: i,
                minBookingDays: m,
                exactMinBookingDays: f,
                isDateBlocked: B
            });
        },
        isFirstOrLastSelectedDate: function(t) {
            return $d6e59866f4ac3ecb$export$8260647f4936851e(t, a, i);
        },
        isStartDate: function(t) {
            return $d6e59866f4ac3ecb$export$c8db6e7f6335237c(t, a);
        },
        isEndDate: function(t) {
            return $d6e59866f4ac3ecb$export$b3c72c1338a4197(t, i);
        },
        isDateBlocked: H,
        numberOfMonths: g,
        isDateFocused: function(t) {
            return !!N && $d6e59866f4ac3ecb$var$we(t, N);
        },
        focusedDate: N,
        hoveredDate: P,
        onResetDates: function() {
            c({
                startDate: null,
                endDate: null,
                focusedInput: "startDate"
            });
        },
        onDateHover: function(t) {
            if (t) {
                if (t) {
                    var e = !H(t) || a && $d6e59866f4ac3ecb$var$we(t, a), n = !u || !$d6e59866f4ac3ecb$var$le(t, $d6e59866f4ac3ecb$var$te(u, -1)), r = !s || !$d6e59866f4ac3ecb$var$fe(t, s), o = $d6e59866f4ac3ecb$var$te(t, m - 1), c = !u || !$d6e59866f4ac3ecb$var$le(o, u), d = !s || !$d6e59866f4ac3ecb$var$fe(o, s), l = f && m > 1 && n && r && c && d, h = a && !i && !f && n && r, w = !(m > 1 && a) || $d6e59866f4ac3ecb$var$he(t, {
                        start: a,
                        end: $d6e59866f4ac3ecb$var$te(a, m - 2)
                    }), g = a && $d6e59866f4ac3ecb$var$we(t, a) && w;
                    e && (l || h || g) ? E(t) : null !== P && E(null);
                }
            } else E(null);
        },
        onDateSelect: function(t) {
            ("endDate" === o || "startDate" === o) && m > 0 && f && $d6e59866f4ac3ecb$var$Se({
                minBookingDays: m,
                exactMinBookingDays: f,
                minBookingDate: u,
                maxBookingDate: s,
                isDateBlocked: B,
                startDate: t,
                endDate: null
            }) ? c({
                startDate: t,
                endDate: $d6e59866f4ac3ecb$var$te(t, m - 1),
                focusedInput: null
            }) : ("endDate" === o && a && $d6e59866f4ac3ecb$var$le(t, a) || "startDate" === o && i && $d6e59866f4ac3ecb$var$fe(t, i)) && !f && $d6e59866f4ac3ecb$var$Se({
                minBookingDays: m,
                isDateBlocked: B,
                startDate: t,
                endDate: null
            }) ? c({
                endDate: null,
                startDate: t,
                focusedInput: "endDate"
            }) : "startDate" === o && !f && $d6e59866f4ac3ecb$var$Se({
                minBookingDays: m,
                isDateBlocked: B,
                endDate: i,
                startDate: t
            }) ? c({
                endDate: i,
                startDate: t,
                focusedInput: "endDate"
            }) : "startDate" === o && !f && $d6e59866f4ac3ecb$var$Se({
                minBookingDays: m,
                isDateBlocked: B,
                endDate: null,
                startDate: t
            }) ? c({
                endDate: null,
                startDate: t,
                focusedInput: "endDate"
            }) : "endDate" === o && a && !$d6e59866f4ac3ecb$var$le(t, a) && !f && $d6e59866f4ac3ecb$var$Se({
                minBookingDays: m,
                isDateBlocked: B,
                startDate: a,
                endDate: t
            }) && c({
                startDate: a,
                endDate: t,
                focusedInput: null
            }), "endDate" !== o && (!N || N && !$d6e59866f4ac3ecb$var$we(t, N)) && x && U($d6e59866f4ac3ecb$export$6b0a3e73eaccfee4(g, t));
        },
        onDateFocus: O,
        goToPreviousMonths: W,
        goToPreviousMonthsByOneMonth: F,
        goToNextMonths: Q,
        goToNextMonthsByOneMonth: R,
        goToDate: I,
        goToPreviousYear: X,
        goToNextYear: G
    };
}
function $d6e59866f4ac3ecb$export$1937086c6b64f72d(t) {
    var e = t.date, n = t.focusedDate, a = t.isDateSelected, i = t.isDateFocused, o = t.isFirstOrLastSelectedDate, u = t.isDateHovered, s = t.isDateBlocked, c = t.onDateSelect, d = t.onDateFocus, l = t.onDateHover, f = (0, $9nZCP.useCallback)(function() {
        return c(e);
    }, [
        e,
        c
    ]), h = (0, $9nZCP.useCallback)(function() {
        return l(e);
    }, [
        e,
        l
    ]), m = s(e) && !u(e);
    return {
        tabIndex: null === n || i(e) ? 0 : -1,
        isSelected: a(e),
        isSelectedStartOrEnd: o(e),
        isWithinHoverRange: u(e),
        disabledDate: m,
        onKeyDown: function(t) {
            "ArrowRight" === t.key ? d($d6e59866f4ac3ecb$var$te(e, 1)) : "ArrowLeft" === t.key ? d($d6e59866f4ac3ecb$var$te(e, -1)) : "ArrowUp" === t.key ? d($d6e59866f4ac3ecb$var$te(e, -7)) : "ArrowDown" === t.key && d($d6e59866f4ac3ecb$var$te(e, 7));
        },
        onClick: m ? function() {} : f,
        onMouseEnter: h
    };
}


function $48090fca70e3183a$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $48090fca70e3183a$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Accordion", function() {
    return $48090fca70e3183a$var$$906ee81c6c1db5eb$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "CustomAccordion", function() {
    return $48090fca70e3183a$var$$81cddd8d5c3e47e4$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Button", function() {
    return $48090fca70e3183a$var$$2987665db72ba3c1$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Card", function() {
    return $48090fca70e3183a$var$$48087ec110ef8615$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Box", function() {
    return $48090fca70e3183a$var$$476168fcb44518cc$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "DisplayLarge", function() {
    return $48090fca70e3183a$var$$ec746cba4029e202$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "DisplayIcon", function() {
    return $48090fca70e3183a$var$$e0180679e35f2273$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "DisplaySmall", function() {
    return $48090fca70e3183a$var$$d98b0fa15808b520$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "DropdownSelect", function() {
    return $48090fca70e3183a$var$$69ead81f7adc490a$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "DropdownCascader", function() {
    return $48090fca70e3183a$var$$d8e895830981b43b$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Field", function() {
    return $48090fca70e3183a$var$$2677d04b7028c72d$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Searchbar", function() {
    return $48090fca70e3183a$var$$aa6f4c7dc0f5685c$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Textarea", function() {
    return $48090fca70e3183a$var$$870ba58bccab6eec$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Slider", function() {
    return $48090fca70e3183a$var$$409b8f5f63cd4acf$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "FileUploader", function() {
    return $48090fca70e3183a$var$$eab617fde0d2a814$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Datepicker", function() {
    return $48090fca70e3183a$var$$1d445195934320ed$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Radio", function() {
    return $48090fca70e3183a$var$$86e1d79a67710eda$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Checkbox", function() {
    return $48090fca70e3183a$var$$b679852ecf8e9c02$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Switch", function() {
    return $48090fca70e3183a$var$$34871b0f15f7c161$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "AlertMessage", function() {
    return $48090fca70e3183a$var$$d963730b715e990c$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "PushMessage", function() {
    return $48090fca70e3183a$var$$cadd1c9c3bca1fc9$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "CompactPagination", function() {
    return $48090fca70e3183a$var$$831351fb15d68ad0$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "StandardPagination", function() {
    return $48090fca70e3183a$var$$60c375d8d52bb6d6$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Tabs", function() {
    return $48090fca70e3183a$var$$35a1a5ac66949050$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Breadcrumb", function() {
    return $48090fca70e3183a$var$$a6857e6cae2f9c5f$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "LinearProgress", function() {
    return $48090fca70e3183a$var$$8688d42e9f1d381a$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "CircularProgress", function() {
    return $48090fca70e3183a$var$$e09296aea30ed10d$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Steps", function() {
    return $48090fca70e3183a$var$$250cfcb8116ed97e$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Timeline", function() {
    return $48090fca70e3183a$var$$c3e303edb7751c77$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "CustomTimeline", function() {
    return $48090fca70e3183a$var$$a3f868921843a442$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Tag", function() {
    return $48090fca70e3183a$var$$4c05722f1abfb34c$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Tooltip", function() {
    return $48090fca70e3183a$var$$4ceeceac8d19d80b$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "ScrollbarContainer", function() {
    return $48090fca70e3183a$var$$b252c20c2dedb54c$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Copiable", function() {
    return $48090fca70e3183a$var$$f9cf7fe05b87a0bc$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "lightTheme", function() {
    return $48090fca70e3183a$var$$18386f08588a981e$export$f30cb9bc4f736419;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "darkTheme", function() {
    return $48090fca70e3183a$var$$18386f08588a981e$export$3e936a8db52a10a0;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "veaTheme", function() {
    return $48090fca70e3183a$var$$18386f08588a981e$export$a183395ddd946500;
});
function $48090fca70e3183a$var$$e1b614a35dc83093$export$683480f191c0e3ea(element, callback) {
    (0, $9nZCP.useLayoutEffect)(()=>{
        if (!element) return;
        const observer = new ResizeObserver((entries)=>{
            callback(element, entries[0]);
        });
        observer.observe(element);
        return ()=>{
            observer.disconnect();
        };
    }, [
        callback,
        element
    ]);
}
var $48090fca70e3183a$var$$e1b614a35dc83093$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$e1b614a35dc83093$export$683480f191c0e3ea;
function $48090fca70e3183a$var$$2592152d06a7ba66$export$2b86bedf890eab8() {
    // Mutable values like 'ref.current' aren't valid dependencies
    // because mutating them doesn't re-render the component.
    // Instead, we use a state as a ref to be reactive.
    const [ref, setRef] = (0, $9nZCP.useState)(null);
    const [size, setSize] = (0, $9nZCP.useState)({
        width: 0,
        height: 0
    });
    // Prevent too many rendering using useCallback
    const handleSize = (0, $9nZCP.useCallback)(()=>{
        setSize({
            width: ref?.offsetWidth || 0,
            height: ref?.offsetHeight || 0
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref?.offsetHeight,
        ref?.offsetWidth
    ]);
    (0, $43b84ecb2c55fe21$export$7080b3e976bc91ab)("resize", handleSize);
    (0, $4347d2e3aabe144e$export$700979bc83e7db82)(()=>{
        handleSize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref?.offsetHeight,
        ref?.offsetWidth
    ]);
    $48090fca70e3183a$var$$e1b614a35dc83093$export$683480f191c0e3ea(ref, handleSize);
    return [
        setRef,
        size
    ];
}
var $48090fca70e3183a$var$$2592152d06a7ba66$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$2592152d06a7ba66$export$2b86bedf890eab8;
const $48090fca70e3183a$var$$f15a4f5132e5ea52$var$SvgPlus = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            clipRule: "evenodd",
            d: "M8.697 0H7.302c-.124 0-.186.06-.186.178v6.977H.186c-.124 0-.186.06-.186.178v1.334c0 .118.062.177.186.177h6.93v6.978c0 .119.062.178.186.178h1.395c.124 0 .186-.06.186-.178V8.844h6.931c.124 0 .186-.059.186-.177V7.333c0-.118-.062-.178-.186-.178h-6.93V.178C8.883.059 8.82 0 8.696 0Z"
        })
    });
var $48090fca70e3183a$var$$f15a4f5132e5ea52$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$f15a4f5132e5ea52$var$SvgPlus;
const $48090fca70e3183a$var$$ed272acf889bf255$var$SvgMinus = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M15.826.333H.174A.174.174 0 0 0 0 .507v1.305c0 .095.078.174.174.174h15.652A.174.174 0 0 0 16 1.812V.507a.174.174 0 0 0-.174-.174Z"
        })
    });
var $48090fca70e3183a$var$$ed272acf889bf255$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$ed272acf889bf255$var$SvgMinus;
const $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30 = (styleFn)=>(0, $1d9bd5c523349ec4$exports.css)([
        "@media (max-width:900px){",
        "}"
    ], styleFn());
const $48090fca70e3183a$var$$49a276e58256b44f$export$448e4850cad7c7b0 = (0, $1d9bd5c523349ec4$exports.css)([
    "font-size:24px;font-weight:600;line-height:33px;margin:0;color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$49a276e58256b44f$export$a943aa9a0fca3f0b = (0, $1d9bd5c523349ec4$exports.css)([
    "font-size:16px;font-weight:600;line-height:22px;margin:0;color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$49a276e58256b44f$export$ffb5f4729a158638 = (0, $1d9bd5c523349ec4$exports.css)([
    "font-size:16px;font-weight:400;line-height:22px;margin:0;color:",
    ";overflow-wrap:break-word;"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510 = (0, $1d9bd5c523349ec4$exports.css)([
    "font-size:14px;font-weight:400;line-height:19px;margin:0;color:",
    ";overflow-wrap:break-word;"
], ({ theme: theme })=>theme.klerosUIComponentsSecondaryText);
const $48090fca70e3183a$var$$49a276e58256b44f$export$b4adb3f464574dcf = (0, $1d9bd5c523349ec4$exports.css)([
    "opacity:1;"
]);
const $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68 = (0, $1d9bd5c523349ec4$exports.css)([
    "display:inline-block;vertical-align:middle;"
]);
const $48090fca70e3183a$var$$49a276e58256b44f$export$463b44d9bf3628be = (0, $1d9bd5c523349ec4$exports.css)([
    "display:inline-block;vertical-align:middle;"
]);
const $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6 = (0, $1d9bd5c523349ec4$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;overflow:visible;text-transform:none;-webkit-appearance:button;:hover:enabled{cursor:pointer;}"
]);
const $48090fca70e3183a$var$$49a276e58256b44f$export$b7e3ae3d7c15e42e = (0, $1d9bd5c523349ec4$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;overflow:visible;"
]);
const $48090fca70e3183a$var$$49a276e58256b44f$export$b9d336f245a516e8 = (0, $1d9bd5c523349ec4$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;"
]);
const $48090fca70e3183a$var$$49a276e58256b44f$export$2e6c959c16ff56b8 = (0, $1d9bd5c523349ec4$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;text-transform:none;"
]);
const $48090fca70e3183a$var$$49a276e58256b44f$export$a3574df893ffa88d = (0, $1d9bd5c523349ec4$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;"
]);
const $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26 = (0, $1d9bd5c523349ec4$exports.css)([
    "box-sizing:border-box;*,*:before,*:after{box-sizing:border-box;}"
]);
const $48090fca70e3183a$var$$33bd37d24f01bb71$var$StyledDiv = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "accordion-item__StyledDiv",
    componentId: "sc-17yp2l-0"
})([
    "margin:8px 0px;.accordion-button{",
    " width:100%;background:",
    ";border-radius:3px;padding:11.5px 32px;display:flex;justify-content:space-between;align-items:center;.accordion-svg{",
    " height:16px;width:16px;fill:",
    ";}}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ theme: theme })=>theme.klerosUIComponentsPrimaryPurple, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsLightPurple);
const $48090fca70e3183a$var$$33bd37d24f01bb71$var$Collapsible = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "accordion-item__Collapsible",
    componentId: "sc-17yp2l-1"
})([
    "height:",
    "px;overflow:",
    ";transition:height ease ",
    ";"
], (props)=>props.expanded ? props.totalHeight.toString() : "0", (props)=>props.expanded ? "visible" : "hidden", ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $48090fca70e3183a$var$$33bd37d24f01bb71$var$Body = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "accordion-item__Body",
    componentId: "sc-17yp2l-2"
})([
    "padding:32px;"
]);
const $48090fca70e3183a$var$$33bd37d24f01bb71$var$AccordionItem = ({ title: title, body: body, index: index, expanded: expanded, setExpanded: setExpanded })=>{
    const [ref, { height: height }] = $48090fca70e3183a$var$$2592152d06a7ba66$export$2b86bedf890eab8();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$33bd37d24f01bb71$var$StyledDiv, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("button", {
                className: "accordion-button",
                onClick: ()=>setExpanded(expanded ? -1 : index),
                children: [
                    title,
                    expanded ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$ed272acf889bf255$export$2e2bcd8739ae039, {
                        className: "accordion-svg"
                    }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$f15a4f5132e5ea52$export$2e2bcd8739ae039, {
                        className: "accordion-svg"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$33bd37d24f01bb71$var$Collapsible, {
                expanded: expanded,
                totalHeight: height,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$33bd37d24f01bb71$var$Body, {
                    ref: ref,
                    children: [
                        " ",
                        body,
                        " "
                    ]
                })
            })
        ]
    });
};
var $48090fca70e3183a$var$$33bd37d24f01bb71$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$33bd37d24f01bb71$var$AccordionItem;
const $48090fca70e3183a$var$$906ee81c6c1db5eb$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "accordion__Wrapper",
    componentId: "sc-7o1u6g-0"
})([
    "",
    " display:flex;flex-direction:column;width:1000px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$906ee81c6c1db5eb$var$AccordionTitle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).p.withConfig({
    displayName: "accordion__AccordionTitle",
    componentId: "sc-7o1u6g-1"
})([
    "",
    " width:fit-content;font-weight:600;text-align:center;color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ffb5f4729a158638, ({ theme: theme })=>theme.klerosUIComponentsLightPurple);
const $48090fca70e3183a$var$$906ee81c6c1db5eb$var$DefaultTitle = ({ item: item })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($dde41420777b5d34$exports.Fragment, {
        children: [
            item.icon ?? (item.Icon && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(item.Icon, {})),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$906ee81c6c1db5eb$var$AccordionTitle, {
                children: item.title
            })
        ]
    });
const $48090fca70e3183a$var$$906ee81c6c1db5eb$var$Accordion = ({ items: items, defaultExpanded: defaultExpanded, ...props })=>{
    const [expanded, setExpanded] = (0, $9nZCP.useState)(defaultExpanded ?? -1);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$906ee81c6c1db5eb$var$Wrapper, {
        ...props,
        children: items.map((item, index)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$33bd37d24f01bb71$export$2e2bcd8739ae039, {
                index: index,
                title: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$906ee81c6c1db5eb$var$DefaultTitle, {
                    item: item
                }),
                body: item.body,
                setExpanded: setExpanded,
                expanded: expanded === index
            }, index))
    });
};
var $48090fca70e3183a$var$$906ee81c6c1db5eb$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$906ee81c6c1db5eb$var$Accordion;
const $48090fca70e3183a$var$$81cddd8d5c3e47e4$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "custom__Wrapper",
    componentId: "sc-dc5dy3-0"
})([
    "",
    " display:flex;flex-direction:column;width:1000px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$81cddd8d5c3e47e4$var$CustomAccordion = ({ items: items, ...props })=>{
    const [expanded, setExpanded] = (0, $9nZCP.useState)(-1);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$81cddd8d5c3e47e4$var$Wrapper, {
        ...props,
        children: items.map((item, index)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$33bd37d24f01bb71$export$2e2bcd8739ae039, {
                index: index,
                title: item.title,
                body: item.body,
                setExpanded: setExpanded,
                expanded: expanded === index
            }, index))
    });
};
var $48090fca70e3183a$var$$81cddd8d5c3e47e4$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$81cddd8d5c3e47e4$var$CustomAccordion;
const $48090fca70e3183a$var$$85dbc8aeed51bed3$var$breathing = (0, $1d9bd5c523349ec4$exports.keyframes)([
    "0%{transform:scale(1);}50%{transform:scale(1.3);}100%{transform:scale(1);}"
]);
const $48090fca70e3183a$var$$85dbc8aeed51bed3$var$BaseButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "base__BaseButton",
    componentId: "sc-15fqe1k-0"
})([
    "",
    " ",
    " position:relative;width:fit-content;height:fit-content;display:flex;flex-direction:row;justify-content:center;align-items:center;padding:",
    ";border-radius:3px;border:none;transition:background ease ",
    ";.button-text{",
    " ",
    " font-weight:600;text-align:center;white-space:pre;}.button-svg{",
    " ",
    " height:16px;width:16px;margin-right:8px;}.button-loading{position:absolute;height:22px;fill:",
    ";animation:",
    " 2s ease-out infinite normal;}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, (props)=>{
    if (props.small) return props.variant === "secondary" ? "5px 23px" : "6px 24px";
    return props.variant === "secondary" ? "10.5px 31px" : "11.5px 32px";
}, (props)=>props.theme.klerosUIComponentsTransitionSpeed, $48090fca70e3183a$var$$49a276e58256b44f$export$ffb5f4729a158638, ({ isLoading: isLoading })=>isLoading && "visibility: hidden;", $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ isLoading: isLoading })=>isLoading && "visibility: hidden;", ({ theme: theme })=>theme.klerosUIComponentsStroke, $48090fca70e3183a$var$$85dbc8aeed51bed3$var$breathing);
var $48090fca70e3183a$var$$85dbc8aeed51bed3$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$85dbc8aeed51bed3$var$BaseButton;
const $48090fca70e3183a$var$$64030e1eefd54f6b$var$PrimaryButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$85dbc8aeed51bed3$export$2e2bcd8739ae039).withConfig({
    displayName: "primary__PrimaryButton",
    componentId: "sc-1cfrthg-0"
})([
    "background:",
    ";.button-text{color:",
    ";}.button-svg{fill:",
    ";}.button-loading{fill:",
    ";}:hover{background:",
    ";}"
], (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsSecondaryBlue);
var $48090fca70e3183a$var$$64030e1eefd54f6b$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$64030e1eefd54f6b$var$PrimaryButton;
const $48090fca70e3183a$var$$e015af9dc133eba5$var$SecondaryButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$85dbc8aeed51bed3$export$2e2bcd8739ae039).withConfig({
    displayName: "secondary__SecondaryButton",
    componentId: "sc-urt0vi-0"
})([
    "background:",
    ";border:",
    ";.button-text{color:",
    ";}.button-svg{fill:",
    ";}.button-loading{fill:",
    ";}:hover{background:",
    ";}"
], (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? `1px solid ${props.theme.klerosUIComponentsStroke}` : `1px solid ${props.theme.klerosUIComponentsPrimaryBlue}`, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsMediumBlue);
var $48090fca70e3183a$var$$e015af9dc133eba5$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$e015af9dc133eba5$var$SecondaryButton;
const $48090fca70e3183a$var$$a028db5d769593a3$var$TertiaryButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$85dbc8aeed51bed3$export$2e2bcd8739ae039).withConfig({
    displayName: "tertiary__TertiaryButton",
    componentId: "sc-jvmd2g-0"
})([
    "background:",
    ";.button-text{color:",
    ";}.button-svg{fill:",
    ";}.button-loading{fill:",
    ";}:hover{background:",
    ";}"
], (props)=>props.theme.klerosUIComponentsSecondaryPurple, (props)=>props.theme.klerosUIComponentsWhiteBackground, (props)=>props.theme.klerosUIComponentsWhiteBackground, (props)=>props.theme.klerosUIComponentsWhiteBackground, (props)=>props.theme.klerosUIComponentsPrimaryPurple);
var $48090fca70e3183a$var$$a028db5d769593a3$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$a028db5d769593a3$var$TertiaryButton;
const $48090fca70e3183a$var$$c65a9c2fdb9de77b$var$SvgKleros = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 46 45",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "m14.545 3.992 21.06.94 8.526 18.92L32.1 41.143 10.929 39.79l-8.68-20.5L14.544 3.993Zm15.44 10.906-15.263 6.66L27.77 31.634l2.214-16.736Zm-1.768-3.337L16.02 6.316l-2.562 11.028 14.76-5.783Zm-3.091 22.608-13.257-9.454.321 12.81 12.936-3.356ZM42.013 23.81l-9.033-9.154-2.384 17.604 11.417-8.45Zm-13.78 12.418-11.18 2.918 13.148.84-1.967-3.758Zm12.015-8.264-9.786 7.28 1.944 3.796 7.842-11.076Zm-4.63-20.388-1.9 3.897 7.075 7.182-5.174-11.08ZM33.252 5.71l-12.424-.504 10.248 4.477 2.176-3.973ZM12.73 7.513 4.028 18.487l5.819 1.23L12.73 7.514ZM9.496 21.871 3.65 20.635l6.1 14.352-.254-13.116Z"
        })
    });
var $48090fca70e3183a$var$$c65a9c2fdb9de77b$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$c65a9c2fdb9de77b$var$SvgKleros;
const $48090fca70e3183a$var$$2987665db72ba3c1$var$Button = ({ text: text, variant: variant, Icon: Icon, icon: icon, onClick: onClick, isLoading: isLoading, ...props })=>{
    let ButtonType = $48090fca70e3183a$var$$64030e1eefd54f6b$export$2e2bcd8739ae039;
    if (variant === "secondary") ButtonType = $48090fca70e3183a$var$$e015af9dc133eba5$export$2e2bcd8739ae039;
    if (variant === "tertiary") ButtonType = $48090fca70e3183a$var$$a028db5d769593a3$export$2e2bcd8739ae039;
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)(ButtonType, {
        variant: variant,
        onClick: onClick,
        isLoading: isLoading,
        ...props,
        children: [
            isLoading && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$c65a9c2fdb9de77b$export$2e2bcd8739ae039, {
                className: "button-loading"
            }),
            icon ?? (Icon && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(Icon, {
                className: "button-svg"
            })),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("p", {
                className: "button-text",
                children: text
            })
        ]
    });
};
var $48090fca70e3183a$var$$2987665db72ba3c1$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$2987665db72ba3c1$var$Button;
const $48090fca70e3183a$var$$48087ec110ef8615$var$Card = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "card__Card",
    componentId: "sc-1g2jfm3-0"
})([
    "",
    " background:",
    ";border:1px solid ",
    ";box-shadow:0px 2px 3px ",
    ";border-radius:",
    ";width:328px;height:200px;transition:box-shadow ease ",
    ";",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ theme: theme })=>theme.klerosUIComponentsDefaultShadow, ({ round: round })=>round ? "18px" : "3px", ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, ({ theme: theme, hover: hover })=>hover && `
      :hover {
        box-shadow: 0px 6px 9px ${theme.klerosUIComponentsHoveredShadow};
        cursor: pointer;
      }
  `);
var $48090fca70e3183a$var$$48087ec110ef8615$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$48087ec110ef8615$var$Card;
const $48090fca70e3183a$var$$476168fcb44518cc$var$Box = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "box__Box",
    componentId: "sc-1by74ub-0"
})([
    "",
    " background:",
    ";border-radius:18px;width:328px;height:200px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsMediumBlue);
var $48090fca70e3183a$var$$476168fcb44518cc$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$476168fcb44518cc$var$Box;
const $48090fca70e3183a$var$$ec746cba4029e202$var$StyledCard = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$48087ec110ef8615$export$2e2bcd8739ae039).withConfig({
    displayName: "large__StyledCard",
    componentId: "sc-1f0y32e-0"
})([
    "position:relative;height:80px;width:288px;padding:16px;display:flex;flex-direction:column;align-items:start;justify-content:center;.display-icon{",
    " position:absolute;top:16px;right:16px;max-height:16px;max-width:16px;}.display-text{",
    "}.display-label{",
    "}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, $48090fca70e3183a$var$$49a276e58256b44f$export$448e4850cad7c7b0, $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510);
const $48090fca70e3183a$var$$ec746cba4029e202$var$DisplayLarge = ({ text: text, Icon: Icon, label: label, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$ec746cba4029e202$var$StyledCard, {
        ...props,
        children: [
            Icon && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(Icon, {
                className: "display-icon"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("h1", {
                className: "display-text",
                children: text
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("small", {
                className: "display-label",
                children: label
            })
        ]
    });
var $48090fca70e3183a$var$$ec746cba4029e202$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$ec746cba4029e202$var$DisplayLarge;
const $48090fca70e3183a$var$$e0180679e35f2273$var$StyledCard = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$48087ec110ef8615$export$2e2bcd8739ae039).withConfig({
    displayName: "icon__StyledCard",
    componentId: "sc-12ixf6j-0"
})([
    "height:80px;width:288px;padding:16px;display:flex;"
]);
const $48090fca70e3183a$var$$e0180679e35f2273$var$Text = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "icon__Text",
    componentId: "sc-12ixf6j-1"
})([
    "",
    " height:100%;width:auto;margin-left:16px;flex-direction:column;align-items:start;justify-content:center;.display-text{",
    "}.display-label{",
    "}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, $48090fca70e3183a$var$$49a276e58256b44f$export$448e4850cad7c7b0, $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510);
const $48090fca70e3183a$var$$e0180679e35f2273$var$IconCard = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$48087ec110ef8615$export$2e2bcd8739ae039).withConfig({
    displayName: "icon__IconCard",
    componentId: "sc-12ixf6j-2"
})([
    "height:48px;width:48px;display:flex;justify-content:center;align-items:center;.display-icon{",
    " max-height:32px;max-width:32px;}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $48090fca70e3183a$var$$e0180679e35f2273$var$DisplayIcon = ({ text: text, Icon: Icon, label: label, ...props })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$e0180679e35f2273$var$StyledCard, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$e0180679e35f2273$var$IconCard, {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(Icon, {
                    className: "display-icon"
                })
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$e0180679e35f2273$var$Text, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("h1", {
                        className: "display-text",
                        children: text
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("small", {
                        className: "display-label",
                        children: label
                    })
                ]
            })
        ]
    });
};
var $48090fca70e3183a$var$$e0180679e35f2273$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$e0180679e35f2273$var$DisplayIcon;
const $48090fca70e3183a$var$$d98b0fa15808b520$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "small__Wrapper",
    componentId: "sc-ismyqd-0"
})([
    "",
    " width:217px;display:flex;flex-direction:column;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$d98b0fa15808b520$var$StyledLabel = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "small__StyledLabel",
    componentId: "sc-ismyqd-1"
})([
    "",
    " color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, (props)=>props.theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$d98b0fa15808b520$var$StyledCard = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$48087ec110ef8615$export$2e2bcd8739ae039).withConfig({
    displayName: "small__StyledCard",
    componentId: "sc-ismyqd-2"
})([
    "height:45px;width:100%;margin-top:16px;display:flex;align-items:center;padding:0px 16px;.display-icon{",
    " max-height:16px;max-width:16px;margin-right:8px;}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $48090fca70e3183a$var$$d98b0fa15808b520$var$StyledText = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).h2.withConfig({
    displayName: "small__StyledText",
    componentId: "sc-ismyqd-3"
})([
    "",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$a943aa9a0fca3f0b);
const $48090fca70e3183a$var$$d98b0fa15808b520$var$DisplaySmall = ({ text: text, Icon: Icon, label: label, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$d98b0fa15808b520$var$Wrapper, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d98b0fa15808b520$var$StyledLabel, {
                children: label
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$d98b0fa15808b520$var$StyledCard, {
                children: [
                    Icon && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(Icon, {
                        className: "display-icon"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d98b0fa15808b520$var$StyledText, {
                        children: text
                    })
                ]
            })
        ]
    });
var $48090fca70e3183a$var$$d98b0fa15808b520$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$d98b0fa15808b520$var$DisplaySmall;
//! type
//eslint-disable-next-line @typescript-eslint/ban-types
function $48090fca70e3183a$var$$bfcc265ae6655ec9$var$useFocusOutside(ref, callback) {
    (0, $9nZCP.useEffect)(()=>{
        function handleEvent(event) {
            if (ref.current && !ref.current.contains(event.target)) callback();
        }
        document.addEventListener("focusin", handleEvent);
        document.addEventListener("mousedown", handleEvent);
        return ()=>{
            document.removeEventListener("focusin", handleEvent);
            document.removeEventListener("mousedown", handleEvent);
        };
    }, [
        ref,
        callback
    ]);
}
var $48090fca70e3183a$var$$bfcc265ae6655ec9$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$bfcc265ae6655ec9$var$useFocusOutside;
const $48090fca70e3183a$var$$a4b0ebb54b8823c5$var$SvgArrow = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 12 8",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M11.598.25H.402C.067.25-.121.605.087.847l5.598 6.49c.16.186.468.186.63 0l5.598-6.49c.208-.242.02-.597-.316-.597Z"
        })
    });
var $48090fca70e3183a$var$$a4b0ebb54b8823c5$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$a4b0ebb54b8823c5$var$SvgArrow;
const $48090fca70e3183a$var$$43d9fcbe58645246$var$Container = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "button__Container",
    componentId: "sc-wywpa8-0"
})([
    "",
    " ",
    " width:240px;background:",
    ";border:1px solid ",
    ";border-radius:3px;display:flex;align-items:center;justify-content:space-between;padding:0px 16px 0px 0px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$43d9fcbe58645246$var$StyledArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)(({ ignoredIsOpen: ignoredIsOpen, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a4b0ebb54b8823c5$export$2e2bcd8739ae039, {
        ...props
    })).withConfig({
    displayName: "button__StyledArrow",
    componentId: "sc-wywpa8-1"
})([
    "",
    " width:16px;height:16px;fill:",
    ";",
    " transition:transform ease ",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ ignoredIsOpen: ignoredIsOpen })=>ignoredIsOpen && (0, $1d9bd5c523349ec4$exports.css)([
        "transform:rotate(180deg);"
    ]), ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $48090fca70e3183a$var$$43d9fcbe58645246$var$DropdownButton = ({ node: node, isOpen: isOpen, setIsOpen: setIsOpen, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$43d9fcbe58645246$var$Container, {
        onClick: ()=>setIsOpen(!isOpen),
        ...props,
        children: [
            node,
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$43d9fcbe58645246$var$StyledArrow, {
                ignoredIsOpen: isOpen,
                ...props
            })
        ]
    });
var $48090fca70e3183a$var$$43d9fcbe58645246$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$43d9fcbe58645246$var$DropdownButton;
const $48090fca70e3183a$var$$83ebe14398e57e2d$var$Container = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "simple-button__Container",
    componentId: "sc-rpqfxz-0"
})([
    "",
    " ",
    " background:none;display:flex;align-items:center;padding:0px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6);
const $48090fca70e3183a$var$$83ebe14398e57e2d$var$StyledSmallText = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "simple-button__StyledSmallText",
    componentId: "sc-rpqfxz-1"
})([
    "",
    " font-weight:600;color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$83ebe14398e57e2d$var$StyledBigText = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).h1.withConfig({
    displayName: "simple-button__StyledBigText",
    componentId: "sc-rpqfxz-2"
})([
    "",
    " font-weight:600;color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$448e4850cad7c7b0, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$83ebe14398e57e2d$var$StyledArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)(({ ignoredIsOpen: ignoredIsOpen, ignoredSmall: ignoredSmall, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a4b0ebb54b8823c5$export$2e2bcd8739ae039, {
        ...props
    })).withConfig({
    displayName: "simple-button__StyledArrow",
    componentId: "sc-rpqfxz-3"
})([
    "",
    " width:",
    "px;height:",
    "px;fill:",
    ";",
    " transition:transform ease ",
    ";margin-left:8px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ ignoredSmall: small })=>small ? "8" : "16", ({ ignoredSmall: small })=>small ? "8" : "16", ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ ignoredIsOpen: isOpen })=>isOpen && (0, $1d9bd5c523349ec4$exports.css)([
        "transform:rotate(180deg);"
    ]), ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $48090fca70e3183a$var$$83ebe14398e57e2d$var$DropdownButton = ({ text: text, isOpen: isOpen, setIsOpen: setIsOpen, small: small, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$83ebe14398e57e2d$var$Container, {
        onClick: ()=>setIsOpen(!isOpen),
        ...props,
        children: [
            small ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$83ebe14398e57e2d$var$StyledSmallText, {
                children: text
            }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$83ebe14398e57e2d$var$StyledBigText, {
                children: text
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$83ebe14398e57e2d$var$StyledArrow, {
                ignoredIsOpen: isOpen,
                ignoredSmall: small,
                ...props
            })
        ]
    });
var $48090fca70e3183a$var$$83ebe14398e57e2d$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$83ebe14398e57e2d$var$DropdownButton;
const $48090fca70e3183a$var$$b252c20c2dedb54c$var$CustomScrollbarContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$parcel$interopDefault($b76fad9a3dd6491d$exports)).withConfig({
    displayName: "scrollbar__CustomScrollbarContainer",
    componentId: "sc-16x8nkv-0"
})([
    "",
    " .simplebar-scrollbar:before{background:",
    ";}.simplebar-scrollbar.simplebar-visible:before{opacity:1;}.simplebar-mask{background:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
var $48090fca70e3183a$var$$b252c20c2dedb54c$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$b252c20c2dedb54c$var$CustomScrollbarContainer;
const $48090fca70e3183a$var$$4fc41d5788d8f02e$var$ItemContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "base-item-container__ItemContainer",
    componentId: "sc-1h7f57o-0"
})([
    "",
    " flex:1;width:238px;height:auto;background:",
    ";padding:16px 0px;display:grid;grid-template-rows:repeat(auto-fill,minmax(0,45px));"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $48090fca70e3183a$var$$4fc41d5788d8f02e$var$StyledScrollbarContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$b252c20c2dedb54c$export$2e2bcd8739ae039).withConfig({
    displayName: "base-item-container__StyledScrollbarContainer",
    componentId: "sc-1h7f57o-1"
})([
    "width:238px;max-height:350px;"
]);
const $48090fca70e3183a$var$$4fc41d5788d8f02e$var$ItemContainerWithScrollbar = ({ children: children, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4fc41d5788d8f02e$var$StyledScrollbarContainer, {
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4fc41d5788d8f02e$var$ItemContainer, {
            children: children
        })
    });
var $48090fca70e3183a$var$$4fc41d5788d8f02e$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$4fc41d5788d8f02e$var$ItemContainerWithScrollbar;
const $48090fca70e3183a$var$$66882cfb76c803d6$var$Dot = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "dot__Dot",
    componentId: "sc-1v9nycp-0"
})([
    "",
    " background:",
    ";border-radius:50%;width:8px;height:8px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ color: color })=>color);
var $48090fca70e3183a$var$$66882cfb76c803d6$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$66882cfb76c803d6$var$Dot;
const $48090fca70e3183a$var$$eff5a32ef289d478$var$Item = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "base-item__Item",
    componentId: "sc-1q4tyix-0"
})([
    "",
    " background:",
    ";padding:",
    ";display:flex;align-items:center;",
    " .item-icon{",
    " max-height:16px;max-width:16px;min-height:12px;min-width:12px;}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ selected: selected, theme: theme })=>selected ? theme.klerosUIComponentsMediumBlue : theme.klerosUIComponentsWhiteBackground, ({ current: current })=>current ? "10.5px 16px 10.5px 13px" : "11.5px 16px 11.5px 13px", (props)=>!props.current && (0, $1d9bd5c523349ec4$exports.css)([
        ":hover{background:",
        ";cursor:pointer;}"
    ], props.theme.klerosUIComponentsMediumBlue), $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $48090fca70e3183a$var$$eff5a32ef289d478$var$StyledText = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).p.withConfig({
    displayName: "base-item__StyledText",
    componentId: "sc-1q4tyix-1"
})([
    "",
    " font-size:16px;user-select:none;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ffb5f4729a158638);
const $48090fca70e3183a$var$$eff5a32ef289d478$var$StyledDot = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$66882cfb76c803d6$export$2e2bcd8739ae039).withConfig({
    displayName: "base-item__StyledDot",
    componentId: "sc-1q4tyix-2"
})([
    "margin-right:8px;"
]);
const $48090fca70e3183a$var$$eff5a32ef289d478$var$BaseItem = ({ text: text, Icon: Icon, icon: icon, dot: dot, onClick: onClick, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$eff5a32ef289d478$var$Item, {
        onKeyPress: (e)=>onClick && e.key === "Enter" ? onClick() : undefined,
        onClick: onClick,
        ...props,
        children: [
            icon ?? (Icon && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(Icon, {
                className: "item-icon"
            })),
            dot && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$eff5a32ef289d478$var$StyledDot, {
                color: dot
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$eff5a32ef289d478$var$StyledText, {
                children: text
            })
        ]
    });
var $48090fca70e3183a$var$$eff5a32ef289d478$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$eff5a32ef289d478$var$BaseItem;
const $48090fca70e3183a$var$$bc9b74e06ed8f896$export$7c16ae7705e422c4 = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$eff5a32ef289d478$export$2e2bcd8739ae039).withConfig({
    displayName: "item-container__StyledItem",
    componentId: "sc-b6y23n-0"
})([
    "border-left:3px solid ",
    ";",
    ""
], ({ theme: theme, selected: selected })=>selected ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsWhiteBackground, ({ theme: theme, selected: selected, current: current })=>!current && (0, $1d9bd5c523349ec4$exports.css)([
        ":hover{border-left:3px solid ",
        ";}"
    ], selected ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsMediumBlue));
const $48090fca70e3183a$var$$bc9b74e06ed8f896$var$ItemContainer = ({ items: items, selected: selected, onChange: onChange })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4fc41d5788d8f02e$export$2e2bcd8739ae039, {
        children: items.map(({ text: text, Icon: Icon, icon: icon, dot: dot, value: value }, i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$bc9b74e06ed8f896$export$7c16ae7705e422c4, {
                tabIndex: 0,
                selected: value === selected,
                onClick: ()=>onChange(value),
                text: text,
                dot: dot,
                Icon: Icon,
                icon: icon
            }, i))
    });
var $48090fca70e3183a$var$$bc9b74e06ed8f896$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$bc9b74e06ed8f896$var$ItemContainer;
const $48090fca70e3183a$var$$2d381104713b6d5d$var$SelectButton = ({ item: item, simple: simple, small: small, isOpen: isOpen, setIsOpen: setIsOpen })=>simple ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$83ebe14398e57e2d$export$2e2bcd8739ae039, {
        text: item.text,
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        small: small
    }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$43d9fcbe58645246$export$2e2bcd8739ae039, {
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        node: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$bc9b74e06ed8f896$export$7c16ae7705e422c4, {
            current: true,
            ...item
        })
    });
var $48090fca70e3183a$var$$2d381104713b6d5d$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$2d381104713b6d5d$var$SelectButton;
const $48090fca70e3183a$var$$dad9719307029a16$var$Container = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "dropdown-container__Container",
    componentId: "sc-qkfxj5-0"
})([
    "",
    " ",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme, isOpen: isOpen, alignRight: alignRight })=>(0, $1d9bd5c523349ec4$exports.css)([
        "position:absolute;",
        " z-index:100;visibility:",
        ";transform:scaleY(",
        ");transform-origin:top;transition-property:transform,visibility;transition-duration:",
        ";transition-timing-function:ease;height:auto;background:transparent;box-shadow:0px 2px 3px ",
        ";overflow:hidden;"
    ], alignRight ? "right: 0px;" : "", isOpen ? "visible" : "hidden", isOpen ? "1" : "0", theme.klerosUIComponentsTransitionSpeed, theme.klerosUIComponentsDefaultShadow));
const $48090fca70e3183a$var$$dad9719307029a16$var$DropdownContainer = ({ children: children, isOpen: isOpen, alignRight: alignRight, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$dad9719307029a16$var$Container, {
        isOpen: isOpen,
        alignRight: alignRight,
        ...props,
        children: [
            " ",
            children,
            " "
        ]
    });
var $48090fca70e3183a$var$$dad9719307029a16$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$dad9719307029a16$var$DropdownContainer;
const $48090fca70e3183a$var$$69ead81f7adc490a$var$Container = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "select__Container",
    componentId: "sc-s4pei-0"
})([
    "position:relative;"
]);
const $48090fca70e3183a$var$$69ead81f7adc490a$var$DropdownContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$dad9719307029a16$export$2e2bcd8739ae039).withConfig({
    displayName: "select__DropdownContainer",
    componentId: "sc-s4pei-1"
})([
    "",
    ""
], ({ theme: theme })=>(0, $1d9bd5c523349ec4$exports.css)([
        "background:",
        ";border:1px solid ",
        ";border-radius:3px;"
    ], theme.klerosUIComponentsWhiteBackground, theme.klerosUIComponentsStroke));
const $48090fca70e3183a$var$$69ead81f7adc490a$var$Select = ({ items: items, callback: callback, simpleButton: simpleButton, smallButton: smallButton, defaultValue: defaultValue, placeholder: placeholder, alignRight: alignRight, ...props })=>{
    const [isOpen, setIsOpen] = (0, $9nZCP.useState)(false);
    const containerRef = (0, $9nZCP.useRef)(null);
    $48090fca70e3183a$var$$bfcc265ae6655ec9$export$2e2bcd8739ae039(containerRef, ()=>setIsOpen(false));
    const [selected, setSelected] = (0, $9nZCP.useState)(defaultValue);
    const currentItem = items.find(({ value: value })=>value === selected);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$69ead81f7adc490a$var$Container, {
        ref: containerRef,
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2d381104713b6d5d$export$2e2bcd8739ae039, {
                item: currentItem ? currentItem : placeholder ? placeholder : {
                    text: ""
                },
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                simple: simpleButton,
                small: smallButton
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$69ead81f7adc490a$var$DropdownContainer, {
                isOpen: isOpen,
                alignRight: alignRight,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$bc9b74e06ed8f896$export$2e2bcd8739ae039, {
                    items: items,
                    selected: selected,
                    onChange: (value)=>{
                        new Promise((resolve)=>resolve(callback(value))).then(()=>{
                            setSelected(value);
                            setIsOpen(false);
                        }).catch((error)=>console.error(error));
                    }
                })
            })
        ]
    });
};
var $48090fca70e3183a$var$$69ead81f7adc490a$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$69ead81f7adc490a$var$Select;
const $48090fca70e3183a$var$$be261e7e6de1aa96$var$SvgLightLeft = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 7,
        height: 11,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M6.375 1.143V.107c0-.09-.103-.139-.173-.084L.165 4.739a.427.427 0 0 0 0 .673l6.037 4.716a.107.107 0 0 0 .173-.085V9.008a.217.217 0 0 0-.082-.168L1.472 5.075l4.821-3.765a.217.217 0 0 0 .082-.168Z"
        })
    });
var $48090fca70e3183a$var$$be261e7e6de1aa96$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$be261e7e6de1aa96$var$SvgLightLeft;
const $48090fca70e3183a$var$$2f29ff49e895ab7b$export$a1a71dc089009936 = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$eff5a32ef289d478$export$2e2bcd8739ae039).withConfig({
    displayName: "item-container__StyledBaseItem",
    componentId: "sc-gth5to-0"
})([
    "position:relative;.item-icon{position:absolute;transform:rotate(180deg);right:16px;fill:",
    ";}"
], ({ selected: selected, theme: theme })=>selected ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$2f29ff49e895ab7b$var$ItemContainer = ({ layer: layer, onChange: onChange, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4fc41d5788d8f02e$export$2e2bcd8739ae039, {
        ...props,
        children: layer.items.map((item, i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2f29ff49e895ab7b$export$a1a71dc089009936, {
                tabIndex: 0,
                text: item.label,
                Icon: item.children && $48090fca70e3183a$var$$be261e7e6de1aa96$export$2e2bcd8739ae039,
                onClick: ()=>onChange(item),
                selected: item.value === layer.selected
            }, i))
    });
var $48090fca70e3183a$var$$2f29ff49e895ab7b$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$2f29ff49e895ab7b$var$ItemContainer;
const $48090fca70e3183a$var$$3b159669545f46c0$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "selector__Wrapper",
    componentId: "sc-1nl16fm-0"
})([
    "",
    " border-bottom-left-radius:3px;border-bottom-right-radius:3px;background:",
    ";padding:8px 16px;display:flex;",
    " justify-content:end;align-items:center;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $1d9bd5c523349ec4$exports.css)([
        "justify-content:center;"
    ])));
const $48090fca70e3183a$var$$3b159669545f46c0$var$Selector = ({ currentSelection: currentSelection, onSelect: onSelect, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$3b159669545f46c0$var$Wrapper, {
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2987665db72ba3c1$export$2e2bcd8739ae039, {
            onClick: ()=>onSelect(),
            text: currentSelection ? `Select\n${currentSelection}` : "No Selection",
            disabled: !currentSelection
        })
    });
var $48090fca70e3183a$var$$3b159669545f46c0$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$3b159669545f46c0$var$Selector;
const $48090fca70e3183a$var$$d8e895830981b43b$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$dad9719307029a16$export$2e2bcd8739ae039).withConfig({
    displayName: "cascader__Wrapper",
    componentId: "sc-x4ug59-0"
})([
    "border:1px solid ",
    ";",
    " border-radius:3px;"
], ({ theme: theme })=>theme.klerosUIComponentsStroke, $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $1d9bd5c523349ec4$exports.css)([
        "width:240px;"
    ])));
const $48090fca70e3183a$var$$d8e895830981b43b$var$Container = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "cascader__Container",
    componentId: "sc-x4ug59-1"
})([
    "",
    ""
], ({ theme: theme, path: path, isOpen: isOpen })=>(0, $1d9bd5c523349ec4$exports.css)([
        "background:",
        ";border-bottom:1px solid ",
        ";border-radius:3px;display:grid;grid-template-columns:repeat(",
        ",238px) 0px;grid-template-rows:max-content;gap:1px;",
        ""
    ], isOpen ? theme.klerosUIComponentsStroke : theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke, path.length, $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $1d9bd5c523349ec4$exports.css)([
            "overflow:auto;"
        ]))));
const $48090fca70e3183a$var$$d8e895830981b43b$var$Cascader = ({ items: items, onSelect: onSelect, placeholder: placeholder, value: value, ...props })=>{
    const [path, setPath] = (0, $9nZCP.useState)([
        {
            items: items
        }
    ]);
    const [current, setCurrent] = (0, $9nZCP.useState)();
    const [selected, setSelected] = (0, $9nZCP.useState)();
    const [isOpen, setIsOpen] = (0, $9nZCP.useState)(false);
    const containerRef = (0, $9nZCP.useRef)(null);
    const lastElementRef = (0, $9nZCP.useRef)(null);
    $48090fca70e3183a$var$$bfcc265ae6655ec9$export$2e2bcd8739ae039(containerRef, ()=>setIsOpen(false));
    (0, $9nZCP.useEffect)(()=>{
        if (lastElementRef?.current && isOpen) $48090fca70e3183a$var$$parcel$interopDefault($95dd3fa9eb45140c$exports)(lastElementRef.current);
    //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        path
    ]);
    const label = (0, $9nZCP.useMemo)(()=>value ? $48090fca70e3183a$var$$d8e895830981b43b$var$findLabelByValue(items, value) : undefined, [
        items,
        value
    ]);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("div", {
        ref: containerRef,
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$43d9fcbe58645246$export$2e2bcd8739ae039, {
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                node: selected ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2f29ff49e895ab7b$export$a1a71dc089009936, {
                    current: true,
                    text: selected.label
                }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2f29ff49e895ab7b$export$a1a71dc089009936, {
                    current: true,
                    text: label ?? placeholder
                })
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$d8e895830981b43b$var$Wrapper, {
                isOpen: isOpen,
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$d8e895830981b43b$var$Container, {
                        path: path,
                        isOpen: isOpen,
                        children: [
                            path.map((layer, depth)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2f29ff49e895ab7b$export$2e2bcd8739ae039, {
                                    layer: layer,
                                    onChange: (item)=>{
                                        let newPath;
                                        if (depth < path.length) newPath = path.slice(0, depth + 1);
                                        else newPath = path;
                                        newPath[depth].selected = item.value;
                                        if (item.children) newPath.push({
                                            items: item.children
                                        });
                                        setPath(newPath);
                                        setCurrent(item);
                                    }
                                }, depth)),
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("div", {
                                ref: lastElementRef
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$3b159669545f46c0$export$2e2bcd8739ae039, {
                        onSelect: ()=>{
                            if (current) new Promise((resolve)=>resolve(onSelect(current.value))).then(()=>{
                                setSelected(current);
                                setIsOpen(false);
                            }).catch((error)=>console.error(error));
                        },
                        currentSelection: current?.label
                    })
                ]
            })
        ]
    });
};
/**
 * @param nodes the nodes
 * @param targetValue the value to search, can be string or number
 * @returns the label if the item is found, else returns undefined
 */ function $48090fca70e3183a$var$$d8e895830981b43b$var$findLabelByValue(nodes, targetValue) {
    for (const node of nodes){
        if (node.value == targetValue) return node.label;
        if (node.children) {
            const result = $48090fca70e3183a$var$$d8e895830981b43b$var$findLabelByValue(node.children, targetValue);
            if (result) return result;
        }
    }
    return undefined;
}
var $48090fca70e3183a$var$$d8e895830981b43b$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$d8e895830981b43b$var$Cascader;
const $48090fca70e3183a$var$$1fbc1df023618cf8$var$SvgSuccess = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm9.145-2.84h.837c.116 0 .184.132.114.227L7.694 10.6a.567.567 0 0 1-.923 0L4.545 7.516a.143.143 0 0 1 .116-.227h.837c.184 0 .356.089.463.237l1.271 1.765 2.807-3.893a.569.569 0 0 1 .463-.238Z"
        })
    });
var $48090fca70e3183a$var$$1fbc1df023618cf8$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$1fbc1df023618cf8$var$SvgSuccess;
const $48090fca70e3183a$var$$773dfb225348757e$var$SvgWarning = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm6.037 3.749a.857.857 0 1 1 1.211-1.212.857.857 0 0 1-1.211 1.212Zm1.034-2.606h-.857A.143.143 0 0 1 7.428 9V4.143c0-.079.065-.143.143-.143h.857c.079 0 .143.064.143.143V9a.143.143 0 0 1-.143.143Z"
        })
    });
var $48090fca70e3183a$var$$773dfb225348757e$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$773dfb225348757e$var$SvgWarning;
const $48090fca70e3183a$var$$1055d191a5da0897$var$SvgError = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm9.596-2.967c.079 0 .143.064.143.143 0 .034-.01.068-.032.093L8.741 8.037l2.32 2.766a.148.148 0 0 1 .033.092c0 .08-.064.143-.143.143l-1.178-.005L8 8.919l-1.773 2.116-1.18.005a.143.143 0 0 1-.11-.236L7.26 8.038 4.937 5.271a.149.149 0 0 1-.034-.093c0-.08.065-.143.143-.143l1.18.005L8 7.154l1.775-2.116 1.178-.005Z"
        })
    });
var $48090fca70e3183a$var$$1055d191a5da0897$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$1055d191a5da0897$var$SvgError;
const $48090fca70e3183a$var$$3b81fb62e49a97d5$var$SvgInfo = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm6.037-2.537a.857.857 0 1 1 1.212-1.212.857.857 0 0 1-1.212 1.212Zm.177 1.394h.857c.079 0 .143.064.143.143v4.857a.143.143 0 0 1-.143.143h-.857a.143.143 0 0 1-.143-.143V7c0-.079.065-.143.143-.143Z"
        })
    });
var $48090fca70e3183a$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$3b81fb62e49a97d5$var$SvgInfo;
const $48090fca70e3183a$var$$2677d04b7028c72d$export$ce7158e6888ab5d6 = (0, $1d9bd5c523349ec4$exports.css)([
    "",
    ""
], ({ variant: variant, theme: theme })=>{
    if (variant === "warning") return theme.klerosUIComponentsWarning;
    if (variant === "error") return theme.klerosUIComponentsError;
    if (variant === "success") return theme.klerosUIComponentsSuccess;
    return theme.klerosUIComponentsSecondaryText;
});
const $48090fca70e3183a$var$$2677d04b7028c72d$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "field__Wrapper",
    componentId: "sc-4pge1s-0"
})([
    "",
    " height:45px;width:278px;position:relative;color:red;.field-svg{",
    " height:16px;width:16px;position:absolute;top:14px;right:16px;}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$StyledSuccessIcon = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$1fbc1df023618cf8$export$2e2bcd8739ae039).withConfig({
    displayName: "field__StyledSuccessIcon",
    componentId: "sc-4pge1s-1"
})([
    "fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsSuccess);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$StyledWarningIcon = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$773dfb225348757e$export$2e2bcd8739ae039).withConfig({
    displayName: "field__StyledWarningIcon",
    componentId: "sc-4pge1s-2"
})([
    "fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsWarning);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$StyledErrorIcon = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$1055d191a5da0897$export$2e2bcd8739ae039).withConfig({
    displayName: "field__StyledErrorIcon",
    componentId: "sc-4pge1s-3"
})([
    "fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsError);
const $48090fca70e3183a$var$$2677d04b7028c72d$export$ceeb223748e25cf7 = (0, $1d9bd5c523349ec4$exports.css)([
    "height:100%;width:100%;background:",
    ";border:1px solid ",
    ";border-radius:3px;color:",
    ";:focus{outline:none;border:1px solid ",
    "40;box-shadow:0px 0px 6px ",
    ";border-radius:3px;}::placeholder{color:",
    ";opacity:0.5;}"
], (props)=>props.theme.klerosUIComponentsWhiteBackground, ({ variant: variant, theme: theme })=>variant ? $48090fca70e3183a$var$$2677d04b7028c72d$export$ce7158e6888ab5d6 : theme.klerosUIComponentsStroke, (props)=>props.theme.klerosUIComponentsPrimaryText, (props)=>props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.theme.klerosUIComponentsSecondaryText);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$StyledInput = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).input.withConfig({
    displayName: "field__StyledInput",
    componentId: "sc-4pge1s-4"
})([
    "padding-top:14px;padding-bottom:14px;padding-left:16px;padding-right:",
    ";",
    ""
], ({ Icon: Icon, variant: variant })=>{
    if (Icon) return "56px";
    if (variant) return "44px";
    return "16px";
}, $48090fca70e3183a$var$$2677d04b7028c72d$export$ceeb223748e25cf7);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$StyledSVG = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "field__StyledSVG",
    componentId: "sc-4pge1s-5"
})([
    ""
]);
const $48090fca70e3183a$var$$2677d04b7028c72d$export$ca8581ef51d2f0a9 = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "field__StyledMessage",
    componentId: "sc-4pge1s-6"
})([
    "margin-top:6px;display:flex;align-items:flex-start;& ",
    "{",
    " min-width:16px;max-width:16px;margin-right:8px;fill:",
    ";}"
], $48090fca70e3183a$var$$2677d04b7028c72d$var$StyledSVG, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, $48090fca70e3183a$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$StyledSmall = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "field__StyledSmall",
    componentId: "sc-4pge1s-7"
})([
    "",
    " position:relative;text-align:justify;color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, $48090fca70e3183a$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$IconContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "field__IconContainer",
    componentId: "sc-4pge1s-8"
})([
    "display:flex;width:44px;height:43px;position:absolute;top:1px;right:1px;align-items:center;justify-content:center;background:",
    ";border-left:1px solid ",
    ";"
], (props)=>props.theme.klerosUIComponentsLightBlue, (props)=>props.theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$StyledIconSVG = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "field__StyledIconSVG",
    componentId: "sc-4pge1s-9"
})([
    "width:24px;height:24px;"
]);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$Field = ({ variant: variant, message: message, Icon: Icon, className: className, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$2677d04b7028c72d$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2677d04b7028c72d$var$StyledInput, {
                variant: variant,
                Icon: Icon,
                ...props
            }),
            variant === "success" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2677d04b7028c72d$var$StyledSuccessIcon, {
                className: "field-svg"
            }),
            variant === "warning" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2677d04b7028c72d$var$StyledWarningIcon, {
                className: "field-svg"
            }),
            variant === "error" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2677d04b7028c72d$var$StyledErrorIcon, {
                className: "field-svg"
            }),
            Icon && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2677d04b7028c72d$var$IconContainer, {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2677d04b7028c72d$var$StyledIconSVG, {
                    as: Icon
                })
            }),
            message && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$2677d04b7028c72d$export$ca8581ef51d2f0a9, {
                variant: variant,
                children: [
                    variant === "info" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039, {
                        className: $48090fca70e3183a$var$$2677d04b7028c72d$var$StyledSVG.styledComponentId
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2677d04b7028c72d$var$StyledSmall, {
                        variant: variant,
                        children: message
                    })
                ]
            })
        ]
    });
$48090fca70e3183a$var$$2677d04b7028c72d$var$Field.displayName = "Field";
var $48090fca70e3183a$var$$2677d04b7028c72d$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$2677d04b7028c72d$var$Field;
const $48090fca70e3183a$var$$619d93e693d921a0$var$SvgSearch = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "m15.78 13.833-3.116-3.115a.75.75 0 0 0-.53-.219h-.51a6.468 6.468 0 0 0 1.375-4c0-3.59-2.91-6.499-6.5-6.499S0 2.91 0 6.5s2.91 6.499 6.5 6.499c1.509 0 2.896-.513 3.999-1.375v.51c0 .2.078.39.219.53l3.115 3.116a.747.747 0 0 0 1.06 0l.884-.885a.753.753 0 0 0 .003-1.062ZM6.5 10.499c-2.21 0-4-1.787-4-4 0-2.209 1.787-4 4-4 2.209 0 3.999 1.788 3.999 4 0 2.21-1.787 4-4 4Z"
        })
    });
var $48090fca70e3183a$var$$619d93e693d921a0$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$619d93e693d921a0$var$SvgSearch;
const $48090fca70e3183a$var$$aa6f4c7dc0f5685c$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "searchbar__Wrapper",
    componentId: "sc-1lxp2tc-0"
})([
    "",
    " position:relative;width:278px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$aa6f4c7dc0f5685c$var$StyledField = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$2677d04b7028c72d$export$2e2bcd8739ae039).withConfig({
    displayName: "searchbar__StyledField",
    componentId: "sc-1lxp2tc-1"
})([
    "height:100%;width:100%;input{padding:14px 16px 14px 40px;}"
]);
const $48090fca70e3183a$var$$aa6f4c7dc0f5685c$var$StyledSearchIcon = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$619d93e693d921a0$export$2e2bcd8739ae039).withConfig({
    displayName: "searchbar__StyledSearchIcon",
    componentId: "sc-1lxp2tc-2"
})([
    "position:absolute;left:16px;top:50%;transform:translateY(-50%);width:16px;height:16px;max-width:16px;max-height:16px;fill:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$aa6f4c7dc0f5685c$var$Searchbar = ({ className: className, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$aa6f4c7dc0f5685c$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$aa6f4c7dc0f5685c$var$StyledField, {
                placeholder: "Search",
                ...props
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$aa6f4c7dc0f5685c$var$StyledSearchIcon, {})
        ]
    });
var $48090fca70e3183a$var$$aa6f4c7dc0f5685c$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$aa6f4c7dc0f5685c$var$Searchbar;
const $48090fca70e3183a$var$$870ba58bccab6eec$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "textarea__Wrapper",
    componentId: "sc-bi4jd2-0"
})([
    "",
    " height:115px;width:400px;position:relative;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$870ba58bccab6eec$var$StyledTextarea = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).textarea.withConfig({
    displayName: "textarea__StyledTextarea",
    componentId: "sc-bi4jd2-1"
})([
    "resize:none;padding:16px;display:block;font-family:inherit;",
    ""
], $48090fca70e3183a$var$$2677d04b7028c72d$export$ceeb223748e25cf7);
const $48090fca70e3183a$var$$870ba58bccab6eec$var$StyledSVG = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "textarea__StyledSVG",
    componentId: "sc-bi4jd2-2"
})([
    ""
]);
const $48090fca70e3183a$var$$870ba58bccab6eec$var$Message = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "textarea__Message",
    componentId: "sc-bi4jd2-3"
})([
    "margin-top:12px;display:flex;align-items:flex-start;& ",
    "{",
    " min-width:16px;max-width:16px;margin-right:8px;fill:",
    ";}"
], $48090fca70e3183a$var$$870ba58bccab6eec$var$StyledSVG, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, $48090fca70e3183a$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $48090fca70e3183a$var$$870ba58bccab6eec$var$StyledSmall = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "textarea__StyledSmall",
    componentId: "sc-bi4jd2-4"
})([
    "",
    " position:relative;text-align:justify;color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, $48090fca70e3183a$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $48090fca70e3183a$var$$870ba58bccab6eec$var$Textarea = ({ message: message, variant: variant, className: className, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$870ba58bccab6eec$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$870ba58bccab6eec$var$StyledTextarea, {
                variant: variant,
                ...props
            }),
            message && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$870ba58bccab6eec$var$Message, {
                variant: variant,
                children: [
                    variant === "success" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1fbc1df023618cf8$export$2e2bcd8739ae039, {
                        className: $48090fca70e3183a$var$$870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    variant === "warning" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$773dfb225348757e$export$2e2bcd8739ae039, {
                        className: $48090fca70e3183a$var$$870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    variant === "error" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1055d191a5da0897$export$2e2bcd8739ae039, {
                        className: $48090fca70e3183a$var$$870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    variant === "info" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039, {
                        className: $48090fca70e3183a$var$$870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$870ba58bccab6eec$var$StyledSmall, {
                        variant: variant,
                        children: message
                    })
                ]
            })
        ]
    });
$48090fca70e3183a$var$$870ba58bccab6eec$var$Textarea.displayName = "Textarea";
var $48090fca70e3183a$var$$870ba58bccab6eec$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$870ba58bccab6eec$var$Textarea;
const $48090fca70e3183a$var$$ba3b8df995d5886a$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "handle__Wrapper",
    componentId: "sc-no0w1x-0"
})([
    "",
    " display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;position:relative;top:8px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$ba3b8df995d5886a$var$Label = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "handle__Label",
    componentId: "sc-no0w1x-1"
})([
    "position:relative;left:",
    "%;transform:translateX(-50%);bottom:44px;color:",
    ";"
], ({ offset: offset })=>offset, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$ba3b8df995d5886a$var$StyledHandle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($8fc1eb2c15e0076e$exports.Handle).withConfig({
    displayName: "handle__StyledHandle",
    componentId: "sc-no0w1x-2"
})([
    "width:30px;height:30px;margin-top:-19px;border:3px solid ",
    ";background-color:",
    ";:hover{cursor:pointer;border-color:",
    ";}:active{box-shadow:0 0 5px ",
    ";}"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$ba3b8df995d5886a$var$Handle = ({ label: label, dragging: dragging, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$ba3b8df995d5886a$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$ba3b8df995d5886a$var$Label, {
                offset: props.offset,
                children: label
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$ba3b8df995d5886a$var$StyledHandle, {
                dragging: dragging.toString(),
                ...props
            })
        ]
    });
var $48090fca70e3183a$var$$ba3b8df995d5886a$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$ba3b8df995d5886a$var$Handle;
const $48090fca70e3183a$var$$409b8f5f63cd4acf$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "slider__Wrapper",
    componentId: "sc-5b6ug3-0"
})([
    "",
    " width:500px;margin-top:30px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$409b8f5f63cd4acf$var$StyledSlider = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$parcel$interopDefault($8fc1eb2c15e0076e$exports)).withConfig({
    displayName: "slider__StyledSlider",
    componentId: "sc-5b6ug3-1"
})([
    "width:100%;.rc-slider-handle-click-focused:focus{border-color:",
    ";}"
], (props)=>props.theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$409b8f5f63cd4acf$var$StyledLabel = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "slider__StyledLabel",
    componentId: "sc-5b6ug3-2"
})([
    "",
    " color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, (props)=>props.theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$409b8f5f63cd4acf$var$Labels = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "slider__Labels",
    componentId: "sc-5b6ug3-3"
})([
    "width:100%;margin-top:16px;display:flex;align-items:center;justify-content:space-between;"
]);
const $48090fca70e3183a$var$$409b8f5f63cd4acf$var$Slider = ({ label: label, min: min, max: max, leftLabel: leftLabel, rightLabel: rightLabel, callback: callback, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$409b8f5f63cd4acf$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$409b8f5f63cd4acf$var$StyledSlider, {
                handle: ({ ref: ignored, ...handleProps })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$ba3b8df995d5886a$export$2e2bcd8739ae039, {
                        label: label,
                        ...handleProps
                    }),
                railStyle: {
                    height: "8px",
                    backgroundColor: props.theme.klerosUIComponentsStroke,
                    borderRadius: "30px",
                    cursor: "pointer"
                },
                trackStyle: [
                    {
                        height: "8px",
                        backgroundColor: props.theme.klerosUIComponentsPrimaryBlue,
                        borderRadius: "30px",
                        cursor: "pointer"
                    }
                ],
                onChange: callback,
                min: min,
                max: max,
                ...props
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$409b8f5f63cd4acf$var$Labels, {
                children: [
                    leftLabel && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$409b8f5f63cd4acf$var$StyledLabel, {
                        children: leftLabel
                    }),
                    rightLabel && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$409b8f5f63cd4acf$var$StyledLabel, {
                        children: rightLabel
                    })
                ]
            })
        ]
    });
$48090fca70e3183a$var$$409b8f5f63cd4acf$var$Slider.displayName = "Slider";
var $48090fca70e3183a$var$$409b8f5f63cd4acf$export$2e2bcd8739ae039 = (0, $1d9bd5c523349ec4$exports.withTheme)($48090fca70e3183a$var$$409b8f5f63cd4acf$var$Slider);
const $48090fca70e3183a$var$$a9ca8be356aca825$var$SvgUploadIcon = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M8.406 5.378h2.371V16.91c0 .15.116.273.257.273h1.925c.142 0 .257-.123.257-.273V5.378h2.378c.215 0 .333-.263.202-.44L12.202.105a.26.26 0 0 0-.09-.077.244.244 0 0 0-.224 0 .26.26 0 0 0-.09.077l-3.594 4.83c-.131.18-.013.443.202.443Zm15.337 10.51h-1.925c-.141 0-.257.122-.257.272v5.25H2.44v-5.25c0-.15-.116-.273-.257-.273H.257c-.141 0-.257.123-.257.273v6.75C0 23.511.459 24 1.027 24h21.946c.568 0 1.027-.488 1.027-1.09v-6.75c0-.15-.116-.273-.257-.273Z"
        })
    });
var $48090fca70e3183a$var$$a9ca8be356aca825$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$a9ca8be356aca825$var$SvgUploadIcon;
const $48090fca70e3183a$var$$eab617fde0d2a814$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "file-uploader__Wrapper",
    componentId: "sc-18nhvs2-0"
})([
    "",
    " width:200px;height:64px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$eab617fde0d2a814$var$DropZone = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "file-uploader__DropZone",
    componentId: "sc-18nhvs2-1"
})([
    "",
    " height:100%;width:100%;background:",
    ";border:1px dashed ",
    ";border-radius:3px;display:flex;justify-content:center;align-items:center;font-size:14px;color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ theme: theme })=>theme.klerosUIComponentsMediumBlue, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$eab617fde0d2a814$var$StyledUploadIcon = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$a9ca8be356aca825$export$2e2bcd8739ae039).withConfig({
    displayName: "file-uploader__StyledUploadIcon",
    componentId: "sc-18nhvs2-2"
})([
    "",
    " height:24px;width:24px;fill:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$eab617fde0d2a814$var$FileInput = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).input.withConfig({
    displayName: "file-uploader__FileInput",
    componentId: "sc-18nhvs2-3"
})([
    "display:none;"
]);
const $48090fca70e3183a$var$$eab617fde0d2a814$var$StyledSmall = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "file-uploader__StyledSmall",
    componentId: "sc-18nhvs2-4"
})([
    "",
    " position:relative;top:-1px;text-align:justify;color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, $48090fca70e3183a$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $48090fca70e3183a$var$$eab617fde0d2a814$var$StyledSVG = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "file-uploader__StyledSVG",
    componentId: "sc-18nhvs2-5"
})([
    ""
]);
const $48090fca70e3183a$var$$eab617fde0d2a814$var$Message = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "file-uploader__Message",
    componentId: "sc-18nhvs2-6"
})([
    "margin-top:16px;display:flex;align-items:flex-start;& ",
    "{",
    " min-width:16px;max-width:16px;margin-right:8px;fill:",
    ";}"
], $48090fca70e3183a$var$$eab617fde0d2a814$var$StyledSVG, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, $48090fca70e3183a$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $48090fca70e3183a$var$$eab617fde0d2a814$var$FileUploader = ({ callback: callback, msg: msg, variant: variant, className: className, ...props })=>{
    const fileInputRef = (0, $9nZCP.useRef)(); //! type
    const [fileSelected, setFileSelected] = (0, $9nZCP.useState)();
    const handleDragEnter = (event)=>{
        event.preventDefault();
        event.stopPropagation();
    };
    const handleDragLeave = (event)=>{
        event.preventDefault();
        event.stopPropagation();
    };
    const handleDragOver = (event)=>{
        event.preventDefault();
        event.stopPropagation();
    };
    const handleDrop = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        fileInputRef.current.files = event.dataTransfer?.files;
        setFileSelected(event.dataTransfer?.files[0]);
        callback(event.dataTransfer?.files[0]);
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$eab617fde0d2a814$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$eab617fde0d2a814$var$DropZone, {
                onClick: ()=>fileInputRef?.current.click(),
                onDrop: (e)=>handleDrop(e),
                onDragOver: (e)=>handleDragOver(e),
                onDragEnter: (e)=>handleDragEnter(e),
                onDragLeave: (e)=>handleDragLeave(e),
                children: fileSelected ? fileSelected.name : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$eab617fde0d2a814$var$StyledUploadIcon, {})
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$eab617fde0d2a814$var$FileInput, {
                ref: fileInputRef,
                type: "file",
                onChange: (event)=>{
                    //eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    setFileSelected(event.target.files[0]);
                    //eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    callback(event.target.files[0]);
                },
                ...props
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$eab617fde0d2a814$var$Message, {
                variant: variant,
                children: [
                    variant === "success" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1fbc1df023618cf8$export$2e2bcd8739ae039, {
                        className: $48090fca70e3183a$var$$eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    variant === "warning" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$773dfb225348757e$export$2e2bcd8739ae039, {
                        className: $48090fca70e3183a$var$$eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    variant === "error" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1055d191a5da0897$export$2e2bcd8739ae039, {
                        className: $48090fca70e3183a$var$$eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    variant === "info" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039, {
                        className: $48090fca70e3183a$var$$eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$eab617fde0d2a814$var$StyledSmall, {
                        variant: variant,
                        children: msg
                    })
                ]
            })
        ]
    });
};
var $48090fca70e3183a$var$$eab617fde0d2a814$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$eab617fde0d2a814$var$FileUploader;
const $48090fca70e3183a$var$$1a85d5c881834fd9$var$datepickerContextDefaultValue = {
    focusedDate: null,
    isDateFocused: ()=>false,
    isDateSelected: ()=>false,
    isDateHovered: ()=>false,
    isDateBlocked: ()=>false,
    isFirstOrLastSelectedDate: ()=>false,
    onDateFocus: ()=>{
    //do nothing
    },
    onDateHover: ()=>{
    //do nothing
    },
    onDateSelect: ()=>{
    //do nothing
    }
};
var $48090fca70e3183a$var$$1a85d5c881834fd9$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$parcel$interopDefault($9nZCP).createContext($48090fca70e3183a$var$$1a85d5c881834fd9$var$datepickerContextDefaultValue);
const $48090fca70e3183a$var$$8da322913a568d32$var$SvgCalendar = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M5.625 9h-1.25A.376.376 0 0 1 4 8.625v-1.25C4 7.169 4.169 7 4.375 7h1.25c.206 0 .375.169.375.375v1.25A.376.376 0 0 1 5.625 9ZM9 8.625v-1.25A.376.376 0 0 0 8.625 7h-1.25A.376.376 0 0 0 7 7.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 9 8.625Zm3 0v-1.25A.376.376 0 0 0 11.625 7h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 12 8.625Zm-3 3v-1.25A.376.376 0 0 0 8.625 10h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 9 11.625Zm-3 0v-1.25A.376.376 0 0 0 5.625 10h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 6 11.625Zm6 0v-1.25a.376.376 0 0 0-.375-.375h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25a.376.376 0 0 0 .375-.375ZM15 3.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 14.5v-11A1.5 1.5 0 0 1 2.5 2H4V.375C4 .169 4.169 0 4.375 0h1.25C5.831 0 6 .169 6 .375V2h4V.375c0-.206.169-.375.375-.375h1.25c.206 0 .375.169.375.375V2h1.5A1.5 1.5 0 0 1 15 3.5Zm-1.5 10.813V5h-11v9.313c0 .103.084.187.188.187h10.624a.188.188 0 0 0 .188-.188Z"
        })
    });
var $48090fca70e3183a$var$$8da322913a568d32$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$8da322913a568d32$var$SvgCalendar;
const $48090fca70e3183a$var$$02569186343496d4$var$StyledButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "display-button__StyledButton",
    componentId: "sc-1n9stdw-0"
})([
    "",
    " height:45px;width:330px;background:",
    ";border:1px solid ",
    ";border-radius:3px;padding:0px 16px;display:flex;justify-content:flex-start;align-items:center;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$02569186343496d4$var$StyledDate = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).p.withConfig({
    displayName: "display-button__StyledDate",
    componentId: "sc-1n9stdw-1"
})([
    "",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$ffb5f4729a158638);
const $48090fca70e3183a$var$$02569186343496d4$var$StyledCalendar = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$8da322913a568d32$export$2e2bcd8739ae039).withConfig({
    displayName: "display-button__StyledCalendar",
    componentId: "sc-1n9stdw-2"
})([
    "position:absolute;right:16px;height:16px;width:16px;fill:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$02569186343496d4$var$DisplayButton = ({ onClick: onClick, date: date, time: time })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$02569186343496d4$var$StyledButton, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$02569186343496d4$var$StyledDate, {
                children: [
                    date.toLocaleDateString(),
                    time && `, ${date.getHours().toLocaleString("en-US", {
                        minimumIntegerDigits: 2,
                        useGrouping: false
                    })}:${date.getMinutes().toLocaleString("en-US", {
                        minimumIntegerDigits: 2,
                        useGrouping: false
                    })} Local time`
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$02569186343496d4$var$StyledCalendar, {})
        ]
    });
var $48090fca70e3183a$var$$02569186343496d4$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$02569186343496d4$var$DisplayButton;
const $48090fca70e3183a$var$$1a3cb6cad04c22a8$var$StyledDayNumber = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "day__StyledDayNumber",
    componentId: "sc-1cckfjj-0"
})([
    "",
    " color:",
    " !important;font-weight:600;cursor:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, (props)=>props.isSelected ? props.theme.klerosUIComponentsWhiteBackground : props.disabledDate ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsSecondaryText, (props)=>props.disabledDate ? "not-allowed" : "pointer");
const $48090fca70e3183a$var$$1a3cb6cad04c22a8$var$StyledButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "day__StyledButton",
    componentId: "sc-1cckfjj-1"
})([
    "",
    " height:24px;width:24px;border-radius:12px;background-color:",
    ";padding:0;display:flex;justify-content:center;align-items:center;:hover{background-color:",
    ";& ",
    "{color:",
    " !important;}}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, (props)=>props.isSelected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.isSelected ? props.theme.klerosUIComponentsPrimaryBlue : props.disabledDate ? props.theme.klerosUIComponentsWhiteBackground : props.theme.klerosUIComponentsSecondaryBlue, $48090fca70e3183a$var$$1a3cb6cad04c22a8$var$StyledDayNumber, (props)=>props.disabledDate ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsWhiteBackground);
const $48090fca70e3183a$var$$1a3cb6cad04c22a8$var$Day = ({ date: date, dayLabel: dayLabel })=>{
    const dayRef = (0, $9nZCP.useRef)(null);
    const { isSelected: isSelected, onClick: onClick, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, tabIndex: tabIndex } = (0, $d6e59866f4ac3ecb$export$1937086c6b64f72d)({
        dayRef: dayRef,
        date: date,
        ...(0, $9nZCP.useContext)($48090fca70e3183a$var$$1a85d5c881834fd9$export$2e2bcd8739ae039)
    });
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const isPastDate = date.getTime() < today.getTime();
    const handleClick = ()=>{
        if (!isPastDate) onClick();
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1a3cb6cad04c22a8$var$StyledButton, {
        ref: dayRef,
        isSelected: isSelected,
        onClick: handleClick,
        onKeyDown: onKeyDown,
        onMouseEnter: onMouseEnter,
        tabIndex: tabIndex,
        disabledDate: isPastDate,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1a3cb6cad04c22a8$var$StyledDayNumber, {
            isSelected: isSelected,
            disabledDate: isPastDate,
            children: dayLabel
        })
    });
};
var $48090fca70e3183a$var$$1a3cb6cad04c22a8$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$1a3cb6cad04c22a8$var$Day;
const $48090fca70e3183a$var$$b6c83c11430985d2$var$MonthContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "month__MonthContainer",
    componentId: "sc-1lt566d-0"
})([
    "width:330px;height:220px;padding-top:16px;display:flex;justify-content:center;border-top:1px solid ",
    ";border-bottom:1px solid ",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$b6c83c11430985d2$var$StyledGridContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "month__StyledGridContainer",
    componentId: "sc-1lt566d-1"
})([
    "height:26px;width:32px;display:flex;justify-content:center;align-items:center;"
]);
const $48090fca70e3183a$var$$b6c83c11430985d2$var$StyledWeekDay = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "month__StyledWeekDay",
    componentId: "sc-1lt566d-2"
})([
    "",
    " color:",
    ";font-weight:600;user-select:none;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$b6c83c11430985d2$var$StyledMonth = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "month__StyledMonth",
    componentId: "sc-1lt566d-3"
})([
    "width:fit-content;height:fit-content;display:grid;grid-template-columns:repeat(7,32px);"
]);
const $48090fca70e3183a$var$$b6c83c11430985d2$var$Month = ({ days: days, weekdayLabels: weekdayLabels })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b6c83c11430985d2$var$MonthContainer, {
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$b6c83c11430985d2$var$StyledMonth, {
            children: [
                weekdayLabels.map((dayLabel, i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b6c83c11430985d2$var$StyledGridContainer, {
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b6c83c11430985d2$var$StyledWeekDay, {
                            children: dayLabel
                        })
                    }, i)),
                days.map((day, i)=>typeof day === "number" ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b6c83c11430985d2$var$StyledGridContainer, {}, i) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b6c83c11430985d2$var$StyledGridContainer, {
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1a3cb6cad04c22a8$export$2e2bcd8739ae039, {
                            ...day
                        }, i)
                    }, i))
            ]
        })
    });
var $48090fca70e3183a$var$$b6c83c11430985d2$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$b6c83c11430985d2$var$Month;
const $48090fca70e3183a$var$$51df4a6e8b413d48$var$SvgSimpleLeft = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "m9.197 14.429-.793.786a.859.859 0 0 1-1.21 0L.252 8.335a.841.841 0 0 1 0-1.201L7.194.25a.859.859 0 0 1 1.21 0l.793.786a.846.846 0 0 1-.014 1.214L4.88 6.316h10.263c.475 0 .857.379.857.85v1.133c0 .471-.382.85-.857.85H4.88l4.303 4.065a.84.84 0 0 1 .014 1.215Z"
        })
    });
var $48090fca70e3183a$var$$51df4a6e8b413d48$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$51df4a6e8b413d48$var$SvgSimpleLeft;
const $48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "month-selector__Wrapper",
    componentId: "sc-1tkddgk-0"
})([
    "width:100%;height:64px;padding:24px;display:flex;justify-content:space-between;"
]);
const $48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$StyledMonthTitle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).h2.withConfig({
    displayName: "month-selector__StyledMonthTitle",
    componentId: "sc-1tkddgk-1"
})([
    "",
    " user-select:none;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$a943aa9a0fca3f0b);
const $48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$StyledArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$51df4a6e8b413d48$export$2e2bcd8739ae039).withConfig({
    displayName: "month-selector__StyledArrow",
    componentId: "sc-1tkddgk-2"
})([
    "",
    " width:16px;height:16px;fill:",
    ";transition:fill ease ",
    ";:hover{fill:",
    ";}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue);
const $48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$RightArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$StyledArrow).withConfig({
    displayName: "month-selector__RightArrow",
    componentId: "sc-1tkddgk-3"
})([
    "transform:rotate(180deg);"
]);
const $48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$UnstyledButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "month-selector__UnstyledButton",
    componentId: "sc-1tkddgk-4"
})([
    "",
    " background:none;padding:0;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6);
const $48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$MonthSelector = ({ monthLabel: monthLabel, goToNextMonths: goToNextMonths, goToPreviousMonths: goToPreviousMonths })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$UnstyledButton, {
                onClick: goToPreviousMonths,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$StyledArrow, {})
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$StyledMonthTitle, {
                children: monthLabel
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$UnstyledButton, {
                onClick: goToNextMonths,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$RightArrow, {})
            })
        ]
    });
var $48090fca70e3183a$var$$d9b6f601d2dcc8ac$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$MonthSelector;
const $48090fca70e3183a$var$$5b91024d35847b4a$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "date-selector__Wrapper",
    componentId: "sc-dxn9nj-0"
})([
    "display:flex;flex-direction:column;"
]);
const $48090fca70e3183a$var$$5b91024d35847b4a$var$DateSelector = ({ year: year, month: month, firstDayOfWeek: firstDayOfWeek, goToNextMonths: goToNextMonths, goToPreviousMonths: goToPreviousMonths })=>{
    const { days: days, weekdayLabels: weekdayLabels, monthLabel: monthLabel } = (0, $d6e59866f4ac3ecb$export$41527c87dc759868)({
        year: year,
        month: month,
        firstDayOfWeek: firstDayOfWeek
    });
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$5b91024d35847b4a$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d9b6f601d2dcc8ac$export$2e2bcd8739ae039, {
                monthLabel: monthLabel,
                goToPreviousMonths: goToPreviousMonths,
                goToNextMonths: goToNextMonths
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b6c83c11430985d2$export$2e2bcd8739ae039, {
                days: days,
                weekdayLabels: weekdayLabels
            })
        ]
    });
};
var $48090fca70e3183a$var$$5b91024d35847b4a$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$5b91024d35847b4a$var$DateSelector;
const $48090fca70e3183a$var$$2dfb31ff65652603$var$TimeControl = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "time-controls__TimeControl",
    componentId: "sc-198k8z7-0"
})([
    "flex-grow:1;border-top:1px solid ",
    ";border-bottom:1px solid ",
    ";display:flex;flex-direction:column;"
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$2dfb31ff65652603$var$TimeDisplay = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "time-controls__TimeDisplay",
    componentId: "sc-198k8z7-1"
})([
    "width:100%;height:64px;background-color:",
    ";padding:0px 24px;display:flex;justify-content:space-between;align-items:center;"
], ({ theme: theme })=>theme.klerosUIComponentsMediumBlue);
const $48090fca70e3183a$var$$2dfb31ff65652603$var$StyledTime = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "time-controls__StyledTime",
    componentId: "sc-198k8z7-2"
})([
    "",
    " font-weight:600;color:",
    ";user-select:none;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$2dfb31ff65652603$var$TimeButtons = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$2dfb31ff65652603$var$TimeDisplay).withConfig({
    displayName: "time-controls__TimeButtons",
    componentId: "sc-198k8z7-3"
})([
    "flex-grow:1;background-color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $48090fca70e3183a$var$$2dfb31ff65652603$var$StyledArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$51df4a6e8b413d48$export$2e2bcd8739ae039).withConfig({
    displayName: "time-controls__StyledArrow",
    componentId: "sc-198k8z7-4"
})([
    "",
    " width:16px;height:16px;fill:",
    ";transition:fill ease ",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $48090fca70e3183a$var$$2dfb31ff65652603$var$UpArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$2dfb31ff65652603$var$StyledArrow).withConfig({
    displayName: "time-controls__UpArrow",
    componentId: "sc-198k8z7-5"
})([
    "transform:rotate(90deg);"
]);
const $48090fca70e3183a$var$$2dfb31ff65652603$var$DownArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$2dfb31ff65652603$var$StyledArrow).withConfig({
    displayName: "time-controls__DownArrow",
    componentId: "sc-198k8z7-6"
})([
    "transform:rotate(-90deg);"
]);
const $48090fca70e3183a$var$$2dfb31ff65652603$var$UnstyledButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "time-controls__UnstyledButton",
    componentId: "sc-198k8z7-7"
})([
    "",
    " background:none;padding:0;:hover{& ",
    "{fill:",
    ";}}:disabled{& ",
    "{fill:",
    ";}}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, $48090fca70e3183a$var$$2dfb31ff65652603$var$StyledArrow, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue, $48090fca70e3183a$var$$2dfb31ff65652603$var$StyledArrow, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$2dfb31ff65652603$var$TimeControls = ({ date: date, hours: hours, minutes: minutes, setHours: setHours, setMinutes: setMinutes })=>{
    const today = new Date();
    const disableHourUp = hours === 23;
    const disableMinuteUp = minutes === 59;
    const isToday = date.toDateString() === today.toDateString();
    const currentTime = today.getTime();
    const checkTime = new Date(date).setHours(hours - 1, minutes);
    const disableHourDown = hours === 0 || isToday && (hours - 1 < today.getHours() || hours - 1 === today.getHours() && minutes <= today.getMinutes() || checkTime <= currentTime);
    const disableMinuteDown = minutes === 0 || isToday && (hours < today.getHours() || hours === today.getHours() && minutes - 1 <= today.getMinutes());
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$2dfb31ff65652603$var$TimeControl, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$2dfb31ff65652603$var$TimeButtons, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newHours = hours + 1;
                            setHours(newHours);
                            date.setHours(newHours, minutes);
                        },
                        disabled: disableHourUp,
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$UpArrow, {})
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newMinutes = minutes + 1;
                            setMinutes(newMinutes);
                            date.setHours(hours, newMinutes);
                        },
                        disabled: disableMinuteUp,
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$UpArrow, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$2dfb31ff65652603$var$TimeDisplay, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$StyledTime, {
                        children: hours.toLocaleString("en-US", {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        })
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$StyledTime, {
                        children: ":"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$StyledTime, {
                        children: minutes.toLocaleString("en-US", {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$2dfb31ff65652603$var$TimeButtons, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newHours = hours - 1;
                            setHours(newHours);
                            date.setHours(newHours, minutes);
                        },
                        disabled: disableHourDown,
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$DownArrow, {})
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newMinutes = minutes - 1;
                            setMinutes(newMinutes);
                            date.setHours(hours, newMinutes);
                        },
                        disabled: disableMinuteDown,
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$DownArrow, {})
                    })
                ]
            })
        ]
    });
};
var $48090fca70e3183a$var$$2dfb31ff65652603$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$2dfb31ff65652603$var$TimeControls;
const $48090fca70e3183a$var$$a1eb1518e9214887$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "time-selector__Wrapper",
    componentId: "sc-1i0y3my-0"
})([
    "width:118px;height:284px;border-left:1px solid ",
    ";display:flex;flex-direction:column;",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsStroke, $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $1d9bd5c523349ec4$exports.css)([
        "border:1px solid ",
        ";border-top:none;border-bottom:none;"
    ], ({ theme: theme })=>theme.klerosUIComponentsStroke)));
const $48090fca70e3183a$var$$a1eb1518e9214887$var$Header = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "time-selector__Header",
    componentId: "sc-1i0y3my-1"
})([
    "height:64px;display:flex;justify-content:center;align-items:center;"
]);
const $48090fca70e3183a$var$$a1eb1518e9214887$var$StyledTitle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).h2.withConfig({
    displayName: "time-selector__StyledTitle",
    componentId: "sc-1i0y3my-2"
})([
    "",
    " user-select:none;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$a943aa9a0fca3f0b);
const $48090fca70e3183a$var$$a1eb1518e9214887$var$TimeSelector = (props)=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$a1eb1518e9214887$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a1eb1518e9214887$var$Header, {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a1eb1518e9214887$var$StyledTitle, {
                    children: "Time"
                })
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$export$2e2bcd8739ae039, {
                ...props
            })
        ]
    });
};
var $48090fca70e3183a$var$$a1eb1518e9214887$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$a1eb1518e9214887$var$TimeSelector;
const $48090fca70e3183a$var$$275ab796fce9757e$var$Container = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "dropdown__Container",
    componentId: "sc-xqzukb-0"
})([
    "position:absolute;z-index:100;overflow:hidden;height:",
    ";width:",
    ";transition:height ease ",
    ";background:",
    ";",
    ";box-shadow:0px 2px 3px ",
    ";border-radius:3px;",
    ""
], ({ isOpen: isOpen })=>isOpen ? "auto" : "0", ({ time: time })=>time ? "450px" : "330px", ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ isOpen: isOpen, theme: theme })=>isOpen ? `border: 1px solid ${theme.klerosUIComponentsStroke}` : "", ({ theme: theme })=>theme.klerosUIComponentsDefaultShadow, $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $1d9bd5c523349ec4$exports.css)([
        "width:332px;position:static;margin:0;left:0;top:0;"
    ])));
const $48090fca70e3183a$var$$275ab796fce9757e$var$Selectors = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "dropdown__Selectors",
    componentId: "sc-xqzukb-1"
})([
    "display:flex;",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $1d9bd5c523349ec4$exports.css)([
        "flex-direction:column;align-items:center;justify-content:flex-start;"
    ])));
const $48090fca70e3183a$var$$275ab796fce9757e$var$ButtonContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "dropdown__ButtonContainer",
    componentId: "sc-xqzukb-2"
})([
    "width:100%;padding:16px 24px;display:flex;justify-content:flex-end;align-items:center;",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $1d9bd5c523349ec4$exports.css)([
        "justify-content:center;"
    ])));
const $48090fca70e3183a$var$$275ab796fce9757e$var$Dropdown = ({ onSelect: onSelect, isOpen: isOpen, time: time, date: date, hours: hours, minutes: minutes, setHours: setHours, setMinutes: setMinutes, ...dateSelectorProps })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$275ab796fce9757e$var$Container, {
        isOpen: isOpen,
        time: time,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$275ab796fce9757e$var$Selectors, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$5b91024d35847b4a$export$2e2bcd8739ae039, {
                        ...dateSelectorProps
                    }),
                    time && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a1eb1518e9214887$export$2e2bcd8739ae039, {
                        date: date,
                        hours: hours,
                        minutes: minutes,
                        setHours: setHours,
                        setMinutes: setMinutes
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$275ab796fce9757e$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2987665db72ba3c1$export$2e2bcd8739ae039, {
                    small: true,
                    variant: "primary",
                    text: "Select",
                    onClick: onSelect
                })
            })
        ]
    });
var $48090fca70e3183a$var$$275ab796fce9757e$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$275ab796fce9757e$var$Dropdown;
const $48090fca70e3183a$var$$1d445195934320ed$var$PositionedContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "datepicker__PositionedContainer",
    componentId: "sc-1gv6m20-0"
})([
    "",
    " position:relative;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$1d445195934320ed$var$DatePicker = ({ onSelect: onSelect, time: time })=>{
    const [isOpen, setIsOpen] = (0, $9nZCP.useState)(false);
    const containerRef = (0, $9nZCP.useRef)(null);
    $48090fca70e3183a$var$$bfcc265ae6655ec9$export$2e2bcd8739ae039(containerRef, ()=>setIsOpen(false));
    const [date, setDate] = (0, $9nZCP.useState)(new Date());
    const [hours, setHours] = (0, $9nZCP.useState)(date.getHours());
    const [minutes, setMinutes] = (0, $9nZCP.useState)(date.getMinutes());
    const today = new Date();
    const lastSelectableDate = new Date(today);
    lastSelectableDate.setDate(today.getDate());
    const updateDateWithTime = (selectedDate)=>{
        if (selectedDate.toDateString() === lastSelectableDate.toDateString()) {
            const now = new Date();
            selectedDate.setHours(now.getHours(), now.getMinutes());
            setHours(now.getHours());
            setMinutes(now.getMinutes());
        } else selectedDate.setHours(hours, minutes);
        setDate(selectedDate);
        onSelect(selectedDate);
    };
    const { firstDayOfWeek: firstDayOfWeek, activeMonths: activeMonths, isDateHovered: isDateHovered, isFirstOrLastSelectedDate: isFirstOrLastSelectedDate, isDateBlocked: isDateBlocked, isDateFocused: isDateFocused, focusedDate: focusedDate, onDateHover: onDateHover, onDateSelect: handleDateSelect, onDateFocus: onDateFocus, goToPreviousMonths: goToPreviousMonths, goToNextMonths: goToNextMonths } = (0, $d6e59866f4ac3ecb$export$2d9bfdb55c82a287)({
        startDate: date,
        endDate: date,
        focusedInput: $d6e59866f4ac3ecb$export$99a467bcc22b8df9,
        onDatesChange: (data)=>{
            if (data.startDate) updateDateWithTime(new Date(data.startDate));
        },
        numberOfMonths: 1,
        minBookingDays: 1,
        exactMinBookingDays: true
    });
    const onTimeChange = (newHours, newMinutes)=>{
        const newDate = new Date(date);
        newDate.setHours(newHours, newMinutes);
        setHours(newHours);
        setMinutes(newMinutes);
        setDate(newDate);
        onSelect(newDate);
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1a85d5c881834fd9$export$2e2bcd8739ae039.Provider, {
        value: {
            focusedDate: focusedDate,
            isDateFocused: isDateFocused,
            isDateSelected: (selectedDate)=>{
                return selectedDate.getDate() === date.getDate() && selectedDate.getMonth() === date.getMonth() && selectedDate.getFullYear() === date.getFullYear();
            },
            isDateHovered: isDateHovered,
            isDateBlocked: isDateBlocked,
            isFirstOrLastSelectedDate: isFirstOrLastSelectedDate,
            onDateSelect: (selectedDate)=>{
                handleDateSelect(selectedDate);
                updateDateWithTime(selectedDate);
            },
            onDateFocus: onDateFocus,
            onDateHover: onDateHover
        },
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$1d445195934320ed$var$PositionedContainer, {
            ref: containerRef,
            children: [
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$02569186343496d4$export$2e2bcd8739ae039, {
                    date: date,
                    time: time,
                    onClick: ()=>setIsOpen(!isOpen)
                }),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$275ab796fce9757e$export$2e2bcd8739ae039, {
                    ...activeMonths[0],
                    isOpen: isOpen,
                    time: time,
                    firstDayOfWeek: firstDayOfWeek,
                    goToNextMonths: goToNextMonths,
                    goToPreviousMonths: goToPreviousMonths,
                    date: date,
                    hours: hours,
                    minutes: minutes,
                    setHours: (newHours)=>onTimeChange(newHours, minutes),
                    setMinutes: (newMinutes)=>onTimeChange(hours, newMinutes),
                    onSelect: ()=>{
                        date.setHours(hours, minutes);
                        onSelect(date);
                        setIsOpen(false);
                    }
                })
            ]
        })
    });
};
var $48090fca70e3183a$var$$1d445195934320ed$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$1d445195934320ed$var$DatePicker;
const $48090fca70e3183a$var$$86e1d79a67710eda$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).label.withConfig({
    displayName: "radio__Wrapper",
    componentId: "sc-1jhzktg-0"
})([
    "",
    " display:block;position:relative;cursor:pointer;user-select:none;color:",
    ";",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsPrimaryText, ({ small: small })=>small ? (0, $1d9bd5c523349ec4$exports.css)([
        "font-size:16px;padding-left:28px;"
    ]) : (0, $1d9bd5c523349ec4$exports.css)([
        "font-size:22px;padding-left:35px;"
    ]));
const $48090fca70e3183a$var$$86e1d79a67710eda$var$HiddenInput = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).input.attrs({
    type: "radio"
}).withConfig({
    displayName: "radio__HiddenInput",
    componentId: "sc-1jhzktg-1"
})([
    "position:absolute;opacity:0;cursor:pointer;"
]);
const $48090fca70e3183a$var$$86e1d79a67710eda$var$StyledRadio = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).span.withConfig({
    displayName: "radio__StyledRadio",
    componentId: "sc-1jhzktg-2"
})([
    "position:absolute;top:0;left:0;border:1px solid ",
    ";border-radius:50%;",
    ' :after{content:"";position:absolute;display:none;border-radius:50%;background:',
    ";",
    "}",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ small: small })=>small ? (0, $1d9bd5c523349ec4$exports.css)([
        "width:16px;height:16px;"
    ]) : (0, $1d9bd5c523349ec4$exports.css)([
        "width:24px;height:24px;"
    ]), ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ small: small })=>small ? (0, $1d9bd5c523349ec4$exports.css)([
        "top:3px;left:3px;width:8px;height:8px;"
    ]) : (0, $1d9bd5c523349ec4$exports.css)([
        "top:5px;left:5px;width:12px;height:12px;"
    ]), ({ theme: theme, checked: checked })=>checked && (0, $1d9bd5c523349ec4$exports.css)([
        "background:",
        ";border:1px solid ",
        ";:after{display:block;}"
    ], theme.klerosUIComponentsWhiteBackground, theme.klerosUIComponentsPrimaryBlue));
const $48090fca70e3183a$var$$86e1d79a67710eda$var$Radio = ({ small: small, checked: checked, label: label, className: className, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$86e1d79a67710eda$var$Wrapper, {
        small: small,
        className: className,
        children: [
            label,
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$86e1d79a67710eda$var$HiddenInput, {
                checked: checked,
                ...props
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$86e1d79a67710eda$var$StyledRadio, {
                small: small,
                checked: checked
            })
        ]
    });
var $48090fca70e3183a$var$$86e1d79a67710eda$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$86e1d79a67710eda$var$Radio;
const $48090fca70e3183a$var$$1d196f635349b3e7$var$SvgCheckmark = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 15 12",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M14.416 0h-1.77c-.384 0-.75.185-.977.502L5.737 8.729 3.05 5a1.207 1.207 0 0 0-.978-.502H.302c-.245 0-.388.28-.245.48l4.702 6.52a1.2 1.2 0 0 0 1.951 0L14.658.48A.3.3 0 0 0 14.416 0Z",
            fill: "#fff"
        })
    });
var $48090fca70e3183a$var$$1d196f635349b3e7$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$1d196f635349b3e7$var$SvgCheckmark;
const $48090fca70e3183a$var$$b679852ecf8e9c02$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).label.withConfig({
    displayName: "checkbox__Wrapper",
    componentId: "sc-1qpo0fn-0"
})([
    "",
    " display:block;position:relative;cursor:pointer;user-select:none;color:",
    ";",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsPrimaryText, ({ small: small })=>small ? (0, $1d9bd5c523349ec4$exports.css)([
        "font-size:16px;padding-left:28px;"
    ]) : (0, $1d9bd5c523349ec4$exports.css)([
        "font-size:22px;padding-left:35px;"
    ]));
const $48090fca70e3183a$var$$b679852ecf8e9c02$var$HiddenInput = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).input.attrs({
    type: "checkbox"
}).withConfig({
    displayName: "checkbox__HiddenInput",
    componentId: "sc-1qpo0fn-1"
})([
    "position:absolute;opacity:0;cursor:pointer;height:0;width:0;"
]);
const $48090fca70e3183a$var$$b679852ecf8e9c02$var$StyledCheckmark = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$1d196f635349b3e7$export$2e2bcd8739ae039).withConfig({
    displayName: "checkbox__StyledCheckmark",
    componentId: "sc-1qpo0fn-2"
})([
    "",
    " position:absolute;top:0;left:0;border-radius:3px;border:1px solid ",
    ";",
    " ",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ $small: $small })=>$small ? (0, $1d9bd5c523349ec4$exports.css)([
        "padding:0 3px;width:16px;height:16px;"
    ]) : (0, $1d9bd5c523349ec4$exports.css)([
        "padding:0 4px;width:24px;height:24px;"
    ]), ({ theme: theme, checked: checked })=>checked && (0, $1d9bd5c523349ec4$exports.css)([
        "background:",
        ";border:none;:after{display:block;}"
    ], theme.klerosUIComponentsPrimaryBlue));
const $48090fca70e3183a$var$$b679852ecf8e9c02$var$Checkbox = ({ small: small = false, checked: checked, label: label, className: className, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$b679852ecf8e9c02$var$Wrapper, {
        small: small,
        className: className,
        children: [
            label,
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b679852ecf8e9c02$var$HiddenInput, {
                checked: checked,
                ...props
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b679852ecf8e9c02$var$StyledCheckmark, {
                $small: small,
                checked: checked
            })
        ]
    });
var $48090fca70e3183a$var$$b679852ecf8e9c02$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$b679852ecf8e9c02$var$Checkbox;
const $48090fca70e3183a$var$$34871b0f15f7c161$var$StyledSwitch = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).label.withConfig({
    displayName: "switch__StyledSwitch",
    componentId: "sc-1or3qt0-0"
})([
    "",
    " position:relative;display:inline-block;height:",
    ";width:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ small: small })=>small ? "16px" : "24px", ({ small: small })=>small ? "32px" : "48px");
const $48090fca70e3183a$var$$34871b0f15f7c161$var$HiddenInput = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).input.attrs({
    type: "checkbox"
}).withConfig({
    displayName: "switch__HiddenInput",
    componentId: "sc-1or3qt0-1"
})([
    "opacity:0;width:0;height:0;"
]);
const $48090fca70e3183a$var$$34871b0f15f7c161$var$StyledSlider = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).span.withConfig({
    displayName: "switch__StyledSlider",
    componentId: "sc-1or3qt0-2"
})([
    "position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:",
    ';transition:0.4s;border-radius:34px;&:before{position:absolute;content:"";height:',
    ";width:",
    ";left:2px;bottom:2px;border-radius:50%;background-color:white;transition:0.4s;}",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ small: small })=>small ? "12px" : "20px", ({ small: small })=>small ? "12px" : "20px", ({ checked: checked, theme: theme, small: small })=>checked && (0, $1d9bd5c523349ec4$exports.css)([
        "background-color:",
        ";:before{transform:translateX(",
        ");}"
    ], theme.klerosUIComponentsPrimaryBlue, small ? "16px" : "24px"));
const $48090fca70e3183a$var$$34871b0f15f7c161$var$Switch = ({ small: small, checked: checked, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$34871b0f15f7c161$var$StyledSwitch, {
        small: small,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$34871b0f15f7c161$var$HiddenInput, {
                checked: checked,
                ...props
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$34871b0f15f7c161$var$StyledSlider, {
                small: small,
                checked: checked
            })
        ]
    });
var $48090fca70e3183a$var$$34871b0f15f7c161$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$34871b0f15f7c161$var$Switch;
const $48090fca70e3183a$var$$d963730b715e990c$var$variantColor = (0, $1d9bd5c523349ec4$exports.css)([
    "",
    ""
], ({ theme: theme, variant: variant })=>{
    switch(variant){
        case "success":
            return (0, $1d9bd5c523349ec4$exports.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsSuccess);
        case "warning":
            return (0, $1d9bd5c523349ec4$exports.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsWarning);
        case "error":
            return (0, $1d9bd5c523349ec4$exports.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsError);
        case "info":
        default:
            return (0, $1d9bd5c523349ec4$exports.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsPrimaryBlue);
    }
});
const $48090fca70e3183a$var$$d963730b715e990c$var$borderColor = ({ theme: theme, variant: variant })=>{
    const colors = {
        success: theme.klerosUIComponentsSuccess,
        warning: theme.klerosUIComponentsWarning,
        error: theme.klerosUIComponentsError,
        info: theme.klerosUIComponentsPrimaryBlue
    };
    return colors[variant];
};
const $48090fca70e3183a$var$$d963730b715e990c$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "alert__Wrapper",
    componentId: "sc-rckqp0-0"
})([
    "display:grid;grid-template-columns:24px auto;gap:16px;align-items:center;background:",
    ";border:1px solid ",
    ";border-radius:3px;padding:16px 24px 20px 24px;"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme, variant: variant })=>$48090fca70e3183a$var$$d963730b715e990c$var$borderColor({
        theme: theme,
        variant: variant
    }));
const $48090fca70e3183a$var$$d963730b715e990c$var$IconWrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "alert__IconWrapper",
    componentId: "sc-rckqp0-1"
})([
    "",
    " height:24px;width:24px;svg{",
    " fill:currentColor;}"
], $48090fca70e3183a$var$$d963730b715e990c$var$variantColor, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $48090fca70e3183a$var$$d963730b715e990c$var$StyledTitle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).h2.withConfig({
    displayName: "alert__StyledTitle",
    componentId: "sc-rckqp0-2"
})([
    "",
    " font-size:16px;margin:0;font-weight:600;line-height:24px;"
], $48090fca70e3183a$var$$d963730b715e990c$var$variantColor);
const $48090fca70e3183a$var$$d963730b715e990c$var$TitleAndMessage = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "alert__TitleAndMessage",
    componentId: "sc-rckqp0-3"
})([
    "display:flex;flex-direction:column;",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $1d9bd5c523349ec4$exports.css)([
        "gap:8px;"
    ])));
const $48090fca70e3183a$var$$d963730b715e990c$var$StyledMessage = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "alert__StyledMessage",
    componentId: "sc-rckqp0-4"
})([
    "color:",
    ";font-weight:400;"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$d963730b715e990c$var$Alert = ({ variant: variant, title: title, msg: msg })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$d963730b715e990c$var$Wrapper, {
        variant: variant,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$d963730b715e990c$var$IconWrapper, {
                variant: variant,
                children: [
                    variant === "success" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1fbc1df023618cf8$export$2e2bcd8739ae039, {}),
                    variant === "warning" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$773dfb225348757e$export$2e2bcd8739ae039, {}),
                    variant === "error" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1055d191a5da0897$export$2e2bcd8739ae039, {}),
                    variant === "info" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039, {})
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$d963730b715e990c$var$TitleAndMessage, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d963730b715e990c$var$StyledTitle, {
                        variant: variant,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d963730b715e990c$var$StyledMessage, {
                        children: msg
                    })
                ]
            })
        ]
    });
var $48090fca70e3183a$var$$d963730b715e990c$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$d963730b715e990c$var$Alert;
const $48090fca70e3183a$var$$296cff7698ec0f63$var$SvgSolidSuccess = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0Zm6.91 10.775-7.52 10.429a1.136 1.136 0 0 1-1.847 0l-4.454-6.172a.287.287 0 0 1 .232-.453h1.675c.365 0 .711.175.925.475l2.543 3.528 5.615-7.785c.214-.297.557-.475.925-.475h1.675c.232 0 .367.264.232.453Z"
        })
    });
var $48090fca70e3183a$var$$296cff7698ec0f63$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$296cff7698ec0f63$var$SvgSolidSuccess;
const $48090fca70e3183a$var$$ff1548a205f71f6a$var$SvgSolidError = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0Zm5.907 22.079-2.357-.011L16 17.836l-3.546 4.228-2.361.011a.284.284 0 0 1-.286-.286c0-.068.025-.132.068-.185l4.646-5.536-4.646-5.532a.287.287 0 0 1 .218-.471l2.36.01L16 14.307l3.546-4.228 2.358-.011c.157 0 .285.125.285.286a.297.297 0 0 1-.068.185l-4.639 5.532 4.643 5.536a.287.287 0 0 1-.218.472Z"
        })
    });
var $48090fca70e3183a$var$$ff1548a205f71f6a$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$ff1548a205f71f6a$var$SvgSolidError;
const $48090fca70e3183a$var$$d6917595109333d4$var$SvgSync = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M2.171 11.777a9.807 9.807 0 0 1 2.874-6.726 9.778 9.778 0 0 1 6.951-2.88c1.33 0 2.615.26 3.824.772a9.757 9.757 0 0 1 3.123 2.108c.283.283.548.583.794.898l-1.72 1.342a.229.229 0 0 0 .086.403l5.02 1.229a.23.23 0 0 0 .283-.22l.023-5.169c0-.191-.22-.3-.369-.18l-1.611 1.26A11.967 11.967 0 0 0 11.994 0C5.45 0 .123 5.246 0 11.766A.228.228 0 0 0 .23 12h1.714c.126 0 .226-.1.228-.223Zm21.6.223h-1.714c-.125 0-.226.1-.228.223a9.76 9.76 0 0 1-.769 3.6 9.778 9.778 0 0 1-2.106 3.126 9.786 9.786 0 0 1-6.951 2.88 9.779 9.779 0 0 1-6.949-2.88 9.853 9.853 0 0 1-.794-.898l1.72-1.342a.23.23 0 0 0 .024-.34.229.229 0 0 0-.11-.063l-5.02-1.229a.23.23 0 0 0-.282.22l-.02 5.172c0 .191.22.3.368.18l1.611-1.26A11.973 11.973 0 0 0 12.006 24C18.554 24 23.877 18.751 24 12.234a.229.229 0 0 0-.229-.234Z"
        })
    });
var $48090fca70e3183a$var$$d6917595109333d4$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$d6917595109333d4$var$SvgSync;
const $48090fca70e3183a$var$$88d96d829ac44aee$var$SvgClose = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 8 8",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M4.525 4 7.746.16A.098.098 0 0 0 7.671 0h-.979a.2.2 0 0 0-.15.07L3.884 3.237 1.228.07a.196.196 0 0 0-.15-.07h-.98a.098.098 0 0 0-.075.16L3.244 4 .024 7.84A.098.098 0 0 0 .097 8h.98a.2.2 0 0 0 .15-.07l2.657-3.167L6.54 7.93c.037.044.092.07.151.07h.98a.098.098 0 0 0 .074-.16L4.526 4Z"
        })
    });
var $48090fca70e3183a$var$$88d96d829ac44aee$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$88d96d829ac44aee$var$SvgClose;
const $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledSVG = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "push__StyledSVG",
    componentId: "sc-4wrqai-0"
})([
    ""
]);
const $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "push__Wrapper",
    componentId: "sc-4wrqai-1"
})([
    "",
    " position:relative;height:",
    ";width:",
    ";background:",
    ";border-radius:3px;padding:",
    ";display:flex;align-items:center;& ",
    "{",
    " height:",
    ";width:",
    ";min-height:",
    ";min-width:",
    ";fill:",
    ";}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ small: small })=>small ? "48px" : "100px", ({ small: small })=>small ? "300px" : "422px", ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ small: small })=>small ? "12px 24px 12px 24px" : "16px 32px 16px 24px", $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledSVG, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ small: small })=>small ? "24px" : "32px", ({ small: small })=>small ? "24px" : "32px", ({ small: small })=>small ? "24px" : "32px", ({ small: small })=>small ? "24px" : "32px", ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledTitle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).h2.withConfig({
    displayName: "push__StyledTitle",
    componentId: "sc-4wrqai-2"
})([
    "",
    " color:inherit;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$a943aa9a0fca3f0b);
const $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledMessage = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "push__StyledMessage",
    componentId: "sc-4wrqai-3"
})([
    "",
    " color:inherit;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510);
const $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$Text = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "push__Text",
    componentId: "sc-4wrqai-4"
})([
    "margin-left:16px;color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$CloseButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "push__CloseButton",
    componentId: "sc-4wrqai-5"
})([
    "",
    " position:absolute;top:24px;right:24px;height:8px;width:8px;background:none;padding:0;display:inline-flex;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6);
const $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledCloseIcon = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$88d96d829ac44aee$export$2e2bcd8739ae039).withConfig({
    displayName: "push__StyledCloseIcon",
    componentId: "sc-4wrqai-6"
})([
    "",
    " height:8px;width:8px;min-height:8px;min-width:8px;fill:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$Push = ({ variant: variant, title: title, msg: msg, callback: callback, small: small, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$Wrapper, {
        small: small,
        ...props,
        children: [
            variant === "success" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$296cff7698ec0f63$export$2e2bcd8739ae039, {
                className: $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledSVG.styledComponentId
            }),
            variant === "error" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$ff1548a205f71f6a$export$2e2bcd8739ae039, {
                className: $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledSVG.styledComponentId
            }),
            variant === "sync" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d6917595109333d4$export$2e2bcd8739ae039, {
                className: $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledSVG.styledComponentId
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$Text, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledTitle, {
                        children: title
                    }),
                    !small && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledMessage, {
                        children: msg
                    })
                ]
            }),
            !small && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$CloseButton, {
                onClick: ()=>callback(),
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledCloseIcon, {})
            })
        ]
    });
var $48090fca70e3183a$var$$cadd1c9c3bca1fc9$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$Push;
const $48090fca70e3183a$var$$0ef3fc8611d56815$var$usePagination = (currentPage, numPages, callback, numNeighbors = 2)=>{
    const incrementPage = ()=>{
        const newPage = Math.min(numPages, currentPage + 1);
        callback(newPage);
    };
    const decrementPage = ()=>{
        const newPage = Math.max(1, currentPage - 1);
        callback(newPage);
    };
    const goToPage = (newPage)=>{
        callback(newPage);
    };
    const minPageReached = currentPage === 1;
    const maxPageReached = currentPage === numPages;
    const getPageRange = ()=>{
        const leftBoundary = Math.max(1, currentPage - numNeighbors - Math.max(0, numNeighbors - (numPages - currentPage)));
        const rightBoundary = Math.min(numPages, currentPage + numNeighbors + Math.max(0, numNeighbors - currentPage + 1));
        return [
            ...Array(rightBoundary - leftBoundary + 1).keys()
        ].map((i)=>i + leftBoundary);
    };
    return [
        {
            incrementPage: incrementPage,
            decrementPage: decrementPage,
            goToPage: goToPage,
            minPageReached: minPageReached,
            maxPageReached: maxPageReached,
            getPageRange: getPageRange
        }
    ];
};
var $48090fca70e3183a$var$$0ef3fc8611d56815$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$0ef3fc8611d56815$var$usePagination;
const $48090fca70e3183a$var$$1edefcf4055fc9a6$var$SvgCircleLeft = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0Zm-.124 16.697.52-.527a.572.572 0 0 0-.009-.815L9.56 12.626h6.742a.565.565 0 0 0 .563-.57v-.76a.565.565 0 0 0-.563-.57H9.56l2.827-2.73a.576.576 0 0 0 .01-.814l-.521-.528a.556.556 0 0 0-.796 0l-4.56 4.62a.573.573 0 0 0 0 .806l4.56 4.617a.556.556 0 0 0 .796 0Z"
        })
    });
var $48090fca70e3183a$var$$1edefcf4055fc9a6$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$1edefcf4055fc9a6$var$SvgCircleLeft;
const $48090fca70e3183a$var$$831351fb15d68ad0$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "compact__Wrapper",
    componentId: "sc-1a5y08h-0"
})([
    "",
    " display:flex;align-items:center;justify-content:end;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$831351fb15d68ad0$var$StyledSVG = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "compact__StyledSVG",
    componentId: "sc-1a5y08h-1"
})([
    ""
]);
const $48090fca70e3183a$var$$831351fb15d68ad0$var$ArrowButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "compact__ArrowButton",
    componentId: "sc-1a5y08h-2"
})([
    "",
    " height:24px;width:24px;background:none;padding:0;border-radius:50%;& ",
    "{",
    " height:24px;width:24px;fill:",
    ";transition:fill ease ",
    ";}:hover:enabled{& ",
    "{fill:",
    ";}}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, $48090fca70e3183a$var$$831351fb15d68ad0$var$StyledSVG, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, $48090fca70e3183a$var$$831351fb15d68ad0$var$StyledSVG, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue);
const $48090fca70e3183a$var$$831351fb15d68ad0$var$StyledLabel = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "compact__StyledLabel",
    componentId: "sc-1a5y08h-3"
})([
    "",
    " color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, (props)=>props.theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$831351fb15d68ad0$var$LeftArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$831351fb15d68ad0$var$ArrowButton).withConfig({
    displayName: "compact__LeftArrow",
    componentId: "sc-1a5y08h-4"
})([
    "margin-left:16px;"
]);
const $48090fca70e3183a$var$$831351fb15d68ad0$var$RightArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$831351fb15d68ad0$var$ArrowButton).withConfig({
    displayName: "compact__RightArrow",
    componentId: "sc-1a5y08h-5"
})([
    "margin-left:8px;& ",
    "{transform:rotate(180deg);}"
], $48090fca70e3183a$var$$831351fb15d68ad0$var$StyledSVG);
const $48090fca70e3183a$var$$831351fb15d68ad0$var$CompactPagination = ({ currentPage: currentPage, numPages: numPages, callback: callback, label: label, className: className })=>{
    const [{ incrementPage: incrementPage, decrementPage: decrementPage, minPageReached: minPageReached, maxPageReached: maxPageReached }] = $48090fca70e3183a$var$$0ef3fc8611d56815$export$2e2bcd8739ae039(currentPage, numPages, callback);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$831351fb15d68ad0$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$831351fb15d68ad0$var$StyledLabel, {
                children: label
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$831351fb15d68ad0$var$LeftArrow, {
                disabled: minPageReached,
                onClick: decrementPage,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1edefcf4055fc9a6$export$2e2bcd8739ae039, {
                    className: $48090fca70e3183a$var$$831351fb15d68ad0$var$StyledSVG.styledComponentId
                })
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$831351fb15d68ad0$var$RightArrow, {
                disabled: maxPageReached,
                onClick: incrementPage,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1edefcf4055fc9a6$export$2e2bcd8739ae039, {
                    className: $48090fca70e3183a$var$$831351fb15d68ad0$var$StyledSVG.styledComponentId
                })
            })
        ]
    });
};
var $48090fca70e3183a$var$$831351fb15d68ad0$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$831351fb15d68ad0$var$CompactPagination;
const $48090fca70e3183a$var$$60c375d8d52bb6d6$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "standard__Wrapper",
    componentId: "sc-n01q9o-0"
})([
    "",
    " display:flex;align-items:center;justify-content:center;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$60c375d8d52bb6d6$var$PageButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "standard__PageButton",
    componentId: "sc-n01q9o-1"
})([
    "",
    " height:32px;width:32px;margin:4px;background:",
    ";border:1px solid ",
    ";border-radius:3px;display:flex;align-items:center;justify-content:center;font-size:14px;color:",
    ";:hover:enabled{background:",
    ";border:1px solid ",
    ";color:",
    ";}:hover:disabled{cursor:default;}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, (props)=>props.selected ? props.theme.klerosUIComponentsLightBlue : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsPrimaryText, (props)=>props.selected ? props.theme.klerosUIComponentsWhiteBackground : props.theme.klerosUIComponentsLightBlue, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsSecondaryBlue, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsSecondaryBlue);
const $48090fca70e3183a$var$$60c375d8d52bb6d6$var$StyledArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "standard__StyledArrow",
    componentId: "sc-n01q9o-2"
})([
    ""
]);
const $48090fca70e3183a$var$$60c375d8d52bb6d6$var$ArrowButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$60c375d8d52bb6d6$var$PageButton).withConfig({
    displayName: "standard__ArrowButton",
    componentId: "sc-n01q9o-3"
})([
    "& ",
    "{",
    " fill:",
    ";transition:fill ease ",
    ";}:hover:enabled{& ",
    "{fill:",
    ";}}"
], $48090fca70e3183a$var$$60c375d8d52bb6d6$var$StyledArrow, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryText, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, $48090fca70e3183a$var$$60c375d8d52bb6d6$var$StyledArrow, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue);
const $48090fca70e3183a$var$$60c375d8d52bb6d6$var$LeftArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$60c375d8d52bb6d6$var$ArrowButton).withConfig({
    displayName: "standard__LeftArrow",
    componentId: "sc-n01q9o-4"
})([
    "& ",
    "{padding-right:1px;}"
], $48090fca70e3183a$var$$60c375d8d52bb6d6$var$StyledArrow);
const $48090fca70e3183a$var$$60c375d8d52bb6d6$var$RightArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$60c375d8d52bb6d6$var$ArrowButton).withConfig({
    displayName: "standard__RightArrow",
    componentId: "sc-n01q9o-5"
})([
    "& ",
    "{padding-left:1px;transform:rotate(180deg);}"
], $48090fca70e3183a$var$$60c375d8d52bb6d6$var$StyledArrow);
const $48090fca70e3183a$var$$60c375d8d52bb6d6$var$StandardPagination = ({ currentPage: currentPage, numPages: numPages, callback: callback, disableNumbers: disableNumbers, hideNumbers: hideNumbers, className: className })=>{
    const [{ incrementPage: incrementPage, decrementPage: decrementPage, goToPage: goToPage, minPageReached: minPageReached, maxPageReached: maxPageReached, getPageRange: getPageRange }] = $48090fca70e3183a$var$$0ef3fc8611d56815$export$2e2bcd8739ae039(currentPage, numPages, callback);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$60c375d8d52bb6d6$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$60c375d8d52bb6d6$var$LeftArrow, {
                disabled: minPageReached,
                onClick: decrementPage,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$be261e7e6de1aa96$export$2e2bcd8739ae039, {
                    className: $48090fca70e3183a$var$$60c375d8d52bb6d6$var$StyledArrow.styledComponentId
                })
            }),
            !hideNumbers && getPageRange().map((i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$60c375d8d52bb6d6$var$PageButton, {
                    selected: currentPage === i,
                    onClick: ()=>goToPage(i),
                    disabled: disableNumbers,
                    children: i
                }, i)),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$60c375d8d52bb6d6$var$RightArrow, {
                disabled: maxPageReached,
                onClick: incrementPage,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$be261e7e6de1aa96$export$2e2bcd8739ae039, {
                    className: $48090fca70e3183a$var$$60c375d8d52bb6d6$var$StyledArrow.styledComponentId
                })
            })
        ]
    });
};
var $48090fca70e3183a$var$$60c375d8d52bb6d6$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$60c375d8d52bb6d6$var$StandardPagination;
const $48090fca70e3183a$var$$35a1a5ac66949050$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "tabs__Wrapper",
    componentId: "sc-1dgmogo-0"
})([
    "",
    " height:fit-content;width:500px;display:flex;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$35a1a5ac66949050$var$StyledSVG = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "tabs__StyledSVG",
    componentId: "sc-1dgmogo-1"
})([
    ""
]);
const $48090fca70e3183a$var$$35a1a5ac66949050$var$StyledTab = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "tabs__StyledTab",
    componentId: "sc-1dgmogo-2"
})([
    "",
    " flex-grow:1;height:45px;background:none;border-bottom:3px solid ",
    ";display:flex;align-items:center;justify-content:center;color:",
    ";",
    " & ",
    "{",
    " height:16px;width:16px;margin-right:16px;fill:",
    ";}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke, (props)=>{
    if (props.selected) return props.theme.klerosUIComponentsPrimaryBlue;
    else if (props.disabled) return props.theme.klerosUIComponentsStroke;
    else return props.theme.klerosUIComponentsPrimaryText;
}, (props)=>!props.disabled && !props.selected ? `:hover {
            border-bottom: 3px solid
              ${props.theme.klerosUIComponentsSecondaryBlue};
          }` : "", $48090fca70e3183a$var$$35a1a5ac66949050$var$StyledSVG, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, (props)=>{
    if (props.selected) return props.theme.klerosUIComponentsPrimaryBlue;
    else if (props.disabled) return props.theme.klerosUIComponentsStroke;
    else return props.theme.klerosUIComponentsPrimaryText;
});
const $48090fca70e3183a$var$$35a1a5ac66949050$var$Tabs = ({ items: items, ...props })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$35a1a5ac66949050$var$Wrapper, {
        ...props,
        children: items.map(({ Icon: Icon, icon: icon, text: text, value: value, disabled: disabled })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$35a1a5ac66949050$var$StyledTab, {
                disabled: disabled,
                selected: value === props.currentValue,
                onClick: ()=>props.callback(value),
                children: [
                    icon ?? (Icon && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(Icon, {
                        className: $48090fca70e3183a$var$$35a1a5ac66949050$var$StyledSVG.styledComponentId
                    })),
                    text
                ]
            }, value))
    });
};
var $48090fca70e3183a$var$$35a1a5ac66949050$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$35a1a5ac66949050$var$Tabs;
const $48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "breadcrumb__Wrapper",
    componentId: "sc-2m5bd-0"
})([
    "",
    " display:flex;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Element = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "breadcrumb__Element",
    componentId: "sc-2m5bd-1"
})([
    "",
    " background:none;padding:0;:hover{",
    "}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ clickable: clickable, theme: theme })=>clickable ? `small { color: ${theme.klerosUIComponentsPrimaryText}; }` : `cursor: text !important`);
const $48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Content = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "breadcrumb__Content",
    componentId: "sc-2m5bd-2"
})([
    "",
    " transition:color ease ",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Separator = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Content).withConfig({
    displayName: "breadcrumb__Separator",
    componentId: "sc-2m5bd-3"
})([
    "margin:0px 8px;"
]);
const $48090fca70e3183a$var$$a6857e6cae2f9c5f$var$ActiveElement = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Content).withConfig({
    displayName: "breadcrumb__ActiveElement",
    componentId: "sc-2m5bd-4"
})([
    "color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Breadcrumb = ({ items: items, callback: callback, clickable: clickable, className: className })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Wrapper, {
        className: className,
        children: items.map(({ text: text, value: value }, i)=>i === items.length - 1 ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a6857e6cae2f9c5f$var$ActiveElement, {
                children: text
            }, i) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$parcel$interopDefault($9nZCP).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Element, {
                        onClick: ()=>callback ? callback(value) : null,
                        clickable: clickable,
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Content, {
                            children: text
                        })
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Separator, {
                        children: "/"
                    })
                ]
            }, i))
    });
var $48090fca70e3183a$var$$a6857e6cae2f9c5f$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Breadcrumb;
const $48090fca70e3183a$var$$d623bf354733f290$var$SvgHourglass = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 12,
        height: 15,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M1.275 14.5h9.31a.66.66 0 0 0 .665-.656v-.438a.66.66 0 0 0-.665-.656c0-2.487-1.414-4.586-3.348-5.25 1.934-.664 3.348-2.763 3.348-5.25a.66.66 0 0 0 .665-.656v-.438A.66.66 0 0 0 10.585.5h-9.31a.66.66 0 0 0-.665.656v.438a.66.66 0 0 0 .665.656c0 2.487 1.414 4.586 3.348 5.25-1.934.664-3.348 2.763-3.348 5.25a.66.66 0 0 0-.665.656v.438a.66.66 0 0 0 .665.656ZM3.048 2.25h5.764c0 2.118-1.28 3.938-2.882 3.938-1.601 0-2.882-1.82-2.882-3.938Z"
        })
    });
var $48090fca70e3183a$var$$d623bf354733f290$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$d623bf354733f290$var$SvgHourglass;
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$progressAnimation = (width)=>(0, $1d9bd5c523349ec4$exports.keyframes)([
        "0%{stroke-dasharray:0 ",
        ";}"
    ], width);
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "linear__Wrapper",
    componentId: "sc-bwbdj5-0"
})([
    "",
    " display:flex;flex-direction:column;align-items:center;font-size:14px;color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$StyledText = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).p.withConfig({
    displayName: "linear__StyledText",
    componentId: "sc-bwbdj5-1"
})([
    "",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$ffb5f4729a158638);
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$BarTimerWrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "linear__BarTimerWrapper",
    componentId: "sc-bwbdj5-2"
})([
    "display:flex;flex-direction:column;align-items:flex-start;"
]);
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$LinearChart = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "linear__LinearChart",
    componentId: "sc-bwbdj5-3"
})([
    "",
    " stroke:",
    ";display:block;margin:10px auto;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ width: width })=>width);
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$LineBackground = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).path.withConfig({
    displayName: "linear__LineBackground",
    componentId: "sc-bwbdj5-4"
})([
    "stroke:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$Line = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).path.withConfig({
    displayName: "linear__Line",
    componentId: "sc-bwbdj5-5"
})([
    "stroke:",
    ";",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsSuccess, ({ animated: animated, width: width })=>animated && (0, $1d9bd5c523349ec4$exports.css)([
        "animation:",
        " 1s ease-out forwards;"
    ], $48090fca70e3183a$var$$8688d42e9f1d381a$var$progressAnimation(width)));
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$StyledHourglass = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$d623bf354733f290$export$2e2bcd8739ae039).withConfig({
    displayName: "linear__StyledHourglass",
    componentId: "sc-bwbdj5-6"
})([
    "",
    " margin-right:9.75px;fill:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsError);
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$TimerMessage = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "linear__TimerMessage",
    componentId: "sc-bwbdj5-7"
})([
    "margin-top:5px;display:flex;justify-content:center;align-items:center;color:",
    ";font-weight:600;line-height:1em;"
], ({ theme: theme })=>theme.klerosUIComponentsError);
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$Linear = ({ text: text, progress: progress, width: width, timerText: timerText, animated: animated = true })=>{
    const sw = 8;
    const linePath = `M ${sw / 2} ${sw / 2} h ${width - sw}`;
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$8688d42e9f1d381a$var$Wrapper, {
        children: [
            text && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$8688d42e9f1d381a$var$StyledText, {
                children: text
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$8688d42e9f1d381a$var$BarTimerWrapper, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$8688d42e9f1d381a$var$LinearChart, {
                        width: width,
                        height: sw,
                        fill: "none",
                        strokeWidth: sw,
                        strokeLinecap: "round",
                        children: [
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$8688d42e9f1d381a$var$LineBackground, {
                                d: linePath
                            }),
                            progress && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$8688d42e9f1d381a$var$Line, {
                                animated: animated,
                                width: width,
                                strokeDasharray: `${progress * width / 100} ${width}`,
                                d: linePath
                            })
                        ]
                    }),
                    timerText && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$8688d42e9f1d381a$var$TimerMessage, {
                        children: [
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$8688d42e9f1d381a$var$StyledHourglass, {}),
                            timerText
                        ]
                    })
                ]
            })
        ]
    });
};
var $48090fca70e3183a$var$$8688d42e9f1d381a$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$8688d42e9f1d381a$var$Linear;
const $48090fca70e3183a$var$$e09296aea30ed10d$var$progressAnimation = (circ)=>(0, $1d9bd5c523349ec4$exports.keyframes)([
        "0%{stroke-dasharray:0 ",
        ";}"
    ], circ);
const $48090fca70e3183a$var$$e09296aea30ed10d$var$CircularChart = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "circular__CircularChart",
    componentId: "sc-73w0na-0"
})([
    "",
    " ",
    " display:block;margin:10px auto;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $48090fca70e3183a$var$$e09296aea30ed10d$var$CircleBackground = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).path.withConfig({
    displayName: "circular__CircleBackground",
    componentId: "sc-73w0na-1"
})([
    "stroke:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$e09296aea30ed10d$var$Circle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).path.withConfig({
    displayName: "circular__Circle",
    componentId: "sc-73w0na-2"
})([
    "stroke:",
    ";",
    ""
], (props)=>props.progress < 100 ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsSuccess, ({ animated: animated, circ: circ })=>animated && (0, $1d9bd5c523349ec4$exports.css)([
        "animation:",
        " 1s ease-out forwards;"
    ], $48090fca70e3183a$var$$e09296aea30ed10d$var$progressAnimation(circ)));
const $48090fca70e3183a$var$$e09296aea30ed10d$var$Percentage = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).text.withConfig({
    displayName: "circular__Percentage",
    componentId: "sc-73w0na-3"
})([
    "fill:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$e09296aea30ed10d$var$Circular = ({ progress: progress, small: small, animated: animated = true })=>{
    const width = small ? 80 : 120;
    const sw = width / 20; // stroke-width
    const rad = (width - sw) / 2 + 1;
    const dy = width - sw + 2;
    const circ = 2 * Math.PI * rad;
    const circlePath = `M ${(width + sw) / 2} ${sw / 2}
  a ${rad} ${rad} 0 0 1 0 ${dy}
  a ${rad} ${rad} 0 0 1 0 -${dy}`;
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$e09296aea30ed10d$var$CircularChart, {
        fill: "none",
        strokeWidth: sw,
        strokeLinecap: "round",
        width: width + sw,
        height: width + sw,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$e09296aea30ed10d$var$CircleBackground, {
                d: circlePath
            }),
            progress && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$e09296aea30ed10d$var$Circle, {
                strokeDasharray: `${circ * progress / 100} ${circ}`,
                progress: progress,
                d: circlePath,
                circ: circ,
                animated: animated
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$e09296aea30ed10d$var$Percentage, {
                fontSize: small ? 16 : 24,
                fontWeight: 600,
                textAnchor: "middle",
                dominantBaseline: "middle",
                x: "50%",
                y: "50%",
                children: [
                    progress,
                    "%"
                ]
            })
        ]
    });
};
var $48090fca70e3183a$var$$e09296aea30ed10d$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$e09296aea30ed10d$var$Circular;
const $48090fca70e3183a$var$$757595619553281c$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "bullet-circle__Wrapper",
    componentId: "sc-1bvj53u-0"
})([
    "height:100%;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;"
]);
const $48090fca70e3183a$var$$757595619553281c$var$StyledSuccess = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$1fbc1df023618cf8$export$2e2bcd8739ae039).withConfig({
    displayName: "bullet-circle__StyledSuccess",
    componentId: "sc-1bvj53u-1"
})([
    "height:24px;width:24px;flex-basis:auto;fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$757595619553281c$var$Circle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "bullet-circle__Circle",
    componentId: "sc-1bvj53u-2"
})([
    "height:24px;width:24px;flex-basis:auto;background-color:",
    ";border-radius:12px;border:1px solid ",
    ";display:flex;justify-content:center;align-items:center;font-size:12px;color:",
    ";"
], (props)=>props.active ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.active ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke, (props)=>props.active ? props.theme.klerosUIComponentsWhiteBackground : props.theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$757595619553281c$var$Line = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "bullet-circle__Line",
    componentId: "sc-1bvj53u-3"
})([
    "height:auto;width:0px;flex-grow:1;border-left:1px solid ",
    ";margin:8px 0px;"
], (props)=>props.completed ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$757595619553281c$var$BulletCircle = ({ active: active, completed: completed, line: line, index: index, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$757595619553281c$var$Wrapper, {
        ...props,
        children: [
            completed ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$757595619553281c$var$StyledSuccess, {}) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$757595619553281c$var$Circle, {
                active: active,
                children: [
                    " ",
                    index,
                    " "
                ]
            }),
            line && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$757595619553281c$var$Line, {
                completed: completed
            })
        ]
    });
var $48090fca70e3183a$var$$757595619553281c$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$757595619553281c$var$BulletCircle;
const $48090fca70e3183a$var$$c37ea337805e62b1$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "bullet__Wrapper",
    componentId: "sc-1ly7f40-0"
})([
    "flex-basis:0;flex-grow:1;width:fit-content;display:flex;"
]);
const $48090fca70e3183a$var$$c37ea337805e62b1$var$StyledTitle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).h2.withConfig({
    displayName: "bullet__StyledTitle",
    componentId: "sc-1ly7f40-1"
})([
    ""
]);
const $48090fca70e3183a$var$$c37ea337805e62b1$var$StyledBody = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "bullet__StyledBody",
    componentId: "sc-1ly7f40-2"
})([
    ""
]);
const $48090fca70e3183a$var$$c37ea337805e62b1$var$TextContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "bullet__TextContainer",
    componentId: "sc-1ly7f40-3"
})([
    "margin-left:16px;margin-top:2px;& ",
    "{",
    " font-size:14px;line-height:19px;color:",
    ";}& ",
    "{",
    " font-size:12px;line-height:16px;}"
], $48090fca70e3183a$var$$c37ea337805e62b1$var$StyledTitle, $48090fca70e3183a$var$$49a276e58256b44f$export$a943aa9a0fca3f0b, (props)=>props.active ? props.theme.klerosUIComponentsPrimaryText : props.theme.klerosUIComponentsSecondaryText, $48090fca70e3183a$var$$c37ea337805e62b1$var$StyledBody, $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510);
const $48090fca70e3183a$var$$c37ea337805e62b1$var$SubitemsContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "bullet__SubitemsContainer",
    componentId: "sc-1ly7f40-4"
})([
    "display:flex;flex-direction:column;"
]);
const $48090fca70e3183a$var$$c37ea337805e62b1$var$Bullet = ({ title: title, subitems: subitems, index: index, active: active, completed: completed, line: line, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$c37ea337805e62b1$var$Wrapper, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$757595619553281c$export$2e2bcd8739ae039, {
                index: index,
                active: active,
                completed: completed,
                line: line
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$c37ea337805e62b1$var$TextContainer, {
                active: active,
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$c37ea337805e62b1$var$StyledTitle, {
                        children: title
                    }),
                    subitems && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$c37ea337805e62b1$var$SubitemsContainer, {
                        children: subitems.map((item, i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$c37ea337805e62b1$var$StyledBody, {
                                children: item
                            }, i))
                    })
                ]
            })
        ]
    });
var $48090fca70e3183a$var$$c37ea337805e62b1$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$c37ea337805e62b1$var$Bullet;
const $48090fca70e3183a$var$$2f7d25ee5647072f$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "vertical__Wrapper",
    componentId: "sc-1rvtpa4-0"
})([
    "height:100px;display:flex;flex-direction:column;"
]);
const $48090fca70e3183a$var$$2f7d25ee5647072f$var$BulletsContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "vertical__BulletsContainer",
    componentId: "sc-1rvtpa4-1"
})([
    "height:auto;display:flex;flex-direction:column;flex-grow:1;"
]);
const $48090fca70e3183a$var$$2f7d25ee5647072f$var$LastBullet = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$c37ea337805e62b1$export$2e2bcd8739ae039).withConfig({
    displayName: "vertical__LastBullet",
    componentId: "sc-1rvtpa4-2"
})([
    "flex-basis:auto;flex-grow:0;"
]);
const $48090fca70e3183a$var$$2f7d25ee5647072f$var$Steps = ({ items: items, currentItemIndex: currentItemIndex, ...props })=>{
    const lastItem = items[items.length - 1];
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$2f7d25ee5647072f$var$Wrapper, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2f7d25ee5647072f$var$BulletsContainer, {
                children: items.slice(0, -1).map(({ title: title, subitems: subitems }, i)=>/*#__PURE__*/ (0, $9nZCP.createElement)($48090fca70e3183a$var$$c37ea337805e62b1$export$2e2bcd8739ae039, {
                        title: title,
                        subitems: subitems,
                        completed: i < currentItemIndex,
                        active: i === currentItemIndex,
                        line: !(i + 1 === items.length),
                        index: i + 1,
                        key: i
                    }))
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2f7d25ee5647072f$var$LastBullet, {
                title: lastItem.title,
                subitems: lastItem.subitems,
                completed: items.length - 1 < currentItemIndex,
                active: items.length - 1 === currentItemIndex,
                index: items.length
            })
        ]
    });
};
var $48090fca70e3183a$var$$2f7d25ee5647072f$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$2f7d25ee5647072f$var$Steps;
const $48090fca70e3183a$var$$cf0f856d949d5193$var$Container = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "horizontal-bullet__Container",
    componentId: "sc-1tljr4r-0"
})([
    "position:relative;height:fit-content;display:flex;justify-content:center;align-items:start;",
    ""
], ({ theme: theme, last: last, completed: completed })=>last ? (0, $1d9bd5c523349ec4$exports.css)([
        "flex-grow:0;"
    ]) : (0, $1d9bd5c523349ec4$exports.css)([
        'flex-grow:1;:after{content:"";height:0px;width:auto;flex-grow:1;border-top:1px solid ',
        ";margin:12px 16px;}"
    ], completed ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsStroke));
const $48090fca70e3183a$var$$cf0f856d949d5193$var$TextWrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "horizontal-bullet__TextWrapper",
    componentId: "sc-1tljr4r-1"
})([
    "margin-left:8px;display:flex;flex-direction:column;align-items:start;> h2{",
    " font-size:14px;line-height:24px;color:",
    ";}> small{",
    " font-size:12px;line-height:16px;}",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$a943aa9a0fca3f0b, (props)=>props.active ? props.theme.klerosUIComponentsPrimaryText : props.theme.klerosUIComponentsSecondaryText, $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $1d9bd5c523349ec4$exports.css)([
        "position:absolute;top:24px;left:0;margin-left:0px;transform:translateX(calc(-50% + 12px));align-items:center;text-align:center;> h2{line-height:19px;}"
    ])));
const $48090fca70e3183a$var$$cf0f856d949d5193$var$HorizontalBullet = ({ index: index, title: title, subitems: subitems, active: active, last: last, completed: completed, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$cf0f856d949d5193$var$Container, {
        active: active,
        completed: completed,
        last: last,
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$757595619553281c$export$2e2bcd8739ae039, {
                active: active,
                completed: completed,
                index: index
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$cf0f856d949d5193$var$TextWrapper, {
                active: active,
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("h2", {
                        children: title
                    }),
                    subitems && subitems.map((item, i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("small", {
                            children: item
                        }, i))
                ]
            })
        ]
    });
var $48090fca70e3183a$var$$cf0f856d949d5193$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$cf0f856d949d5193$var$HorizontalBullet;
const $48090fca70e3183a$var$$4987b48a13ec5480$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "horizontal__Wrapper",
    componentId: "sc-12u32gl-0"
})([
    "",
    " width:250px;display:flex;justify-content:center;align-items:start;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$4987b48a13ec5480$var$HorizontalSteps = ({ items: items, currentItemIndex: currentItemIndex, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4987b48a13ec5480$var$Wrapper, {
        ...props,
        children: items.map((item, i)=>/*#__PURE__*/ (0, $9nZCP.createElement)($48090fca70e3183a$var$$cf0f856d949d5193$export$2e2bcd8739ae039, {
                ...item,
                completed: i < currentItemIndex,
                active: i === currentItemIndex,
                last: i + 1 === items.length,
                index: i + 1,
                key: i
            }))
    });
var $48090fca70e3183a$var$$4987b48a13ec5480$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$4987b48a13ec5480$var$HorizontalSteps;
const $48090fca70e3183a$var$$250cfcb8116ed97e$var$Steps = ({ horizontal: horizontal, ...props })=>horizontal ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4987b48a13ec5480$export$2e2bcd8739ae039, {
        ...props
    }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2f7d25ee5647072f$export$2e2bcd8739ae039, {
        ...props
    });
var $48090fca70e3183a$var$$250cfcb8116ed97e$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$250cfcb8116ed97e$var$Steps;
const $48090fca70e3183a$var$$b17bb74d528cffb5$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "spine__Wrapper",
    componentId: "sc-1nqkm41-0"
})([
    "height:auto;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;"
]);
const $48090fca70e3183a$var$$b17bb74d528cffb5$var$colorRegex = new RegExp("^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$");
const $48090fca70e3183a$var$$b17bb74d528cffb5$export$ce7158e6888ab5d6 = (0, $1d9bd5c523349ec4$exports.css)([
    "",
    ""
], ({ variant: variant, theme: theme })=>{
    if (variant === "accepted") return theme.klerosUIComponentsSuccess;
    if (variant === "refused") return theme.klerosUIComponentsError;
    if (variant && $48090fca70e3183a$var$$b17bb74d528cffb5$var$colorRegex.test(variant)) return variant;
    return theme.klerosUIComponentsPrimaryBlue;
});
const $48090fca70e3183a$var$$b17bb74d528cffb5$var$Circle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "spine__Circle",
    componentId: "sc-1nqkm41-1"
})([
    "height:16px;width:16px;flex-basis:auto;background-color:",
    ";border-radius:8px;border:2px solid ",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, $48090fca70e3183a$var$$b17bb74d528cffb5$export$ce7158e6888ab5d6);
const $48090fca70e3183a$var$$b17bb74d528cffb5$var$Line = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "spine__Line",
    componentId: "sc-1nqkm41-2"
})([
    "height:auto;width:0px;flex-grow:1;border-left:1px solid ",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$b17bb74d528cffb5$var$Spine = ({ variant: variant, line: line, Icon: Icon })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$b17bb74d528cffb5$var$Wrapper, {
        children: [
            Icon ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(Icon, {}) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b17bb74d528cffb5$var$Circle, {
                variant: variant
            }),
            line && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b17bb74d528cffb5$var$Line, {})
        ]
    });
var $48090fca70e3183a$var$$b17bb74d528cffb5$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$b17bb74d528cffb5$var$Spine;
const $48090fca70e3183a$var$$febc15bff886858c$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "bullet__Wrapper",
    componentId: "sc-6vrqo5-0"
})([
    "display:flex;justify-content:",
    ";"
], ({ rightSided: rightSided })=>rightSided ? "flex-start" : "flex-end");
const $48090fca70e3183a$var$$febc15bff886858c$var$StyledTitle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).h2.withConfig({
    displayName: "bullet__StyledTitle",
    componentId: "sc-6vrqo5-1"
})([
    ""
]);
const $48090fca70e3183a$var$$febc15bff886858c$var$StyledParty = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).p.withConfig({
    displayName: "bullet__StyledParty",
    componentId: "sc-6vrqo5-2"
})([
    ""
]);
const $48090fca70e3183a$var$$febc15bff886858c$var$StyledSubtitle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "bullet__StyledSubtitle",
    componentId: "sc-6vrqo5-3"
})([
    ""
]);
const $48090fca70e3183a$var$$febc15bff886858c$var$TextContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "bullet__TextContainer",
    componentId: "sc-6vrqo5-4"
})([
    "margin-",
    ":20px;order:",
    ";display:flex;flex-direction:column;margin-bottom:",
    ";gap:2px;text-align:",
    ";@media (max-width:900px){margin-",
    ":16px;margin-bottom:",
    ";gap:4px;}& ",
    "{",
    " order:",
    ";font-size:14px;line-height:19px;color:",
    ";}& ",
    "{",
    " order:",
    ";font-size:14px;line-height:19px;color:",
    ";}& ",
    "{",
    " align-self:flex-",
    ";font-size:12px;line-height:16px;}"
], ({ rightSided: rightSided })=>rightSided ? "left" : "right", ({ rightSided: rightSided })=>rightSided ? 1 : -1, ({ isLast: isLast })=>isLast ? "0" : "18px", ({ rightSided: rightSided })=>rightSided ? "left" : "right", ({ rightSided: rightSided })=>rightSided ? "left" : "right", ({ isLast: isLast })=>isLast ? "0" : "16px", $48090fca70e3183a$var$$febc15bff886858c$var$StyledTitle, $48090fca70e3183a$var$$49a276e58256b44f$export$a943aa9a0fca3f0b, ({ rightSided: rightSided })=>rightSided ? 1 : 2, ({ theme: theme })=>theme.klerosUIComponentsPrimaryText, $48090fca70e3183a$var$$febc15bff886858c$var$StyledParty, $48090fca70e3183a$var$$49a276e58256b44f$export$ffb5f4729a158638, ({ rightSided: rightSided })=>rightSided ? 2 : 1, $48090fca70e3183a$var$$b17bb74d528cffb5$export$ce7158e6888ab5d6, $48090fca70e3183a$var$$febc15bff886858c$var$StyledSubtitle, $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, ({ rightSided: rightSided })=>rightSided ? "start" : "end");
const $48090fca70e3183a$var$$febc15bff886858c$var$PartyTitleContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "bullet__PartyTitleContainer",
    componentId: "sc-6vrqo5-5"
})([
    "display:flex;flex-direction:row;flex-wrap:wrap;gap:4px 8px;justify-content:",
    ";"
], ({ rightSided: rightSided })=>rightSided ? "flex-start" : "flex-end");
const $48090fca70e3183a$var$$febc15bff886858c$var$Bullet = (props)=>{
    const { title: title, party: party, subtitle: subtitle, ...restProps } = props;
    const { rightSided: rightSided, variant: variant, line: line, Icon: Icon, isLast: isLast, ...wrapperProps } = restProps;
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$febc15bff886858c$var$Wrapper, {
        rightSided: rightSided,
        ...wrapperProps,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b17bb74d528cffb5$export$2e2bcd8739ae039, {
                variant: variant,
                line: line,
                Icon: Icon
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$febc15bff886858c$var$TextContainer, {
                variant: variant,
                rightSided: rightSided,
                isLast: isLast,
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$febc15bff886858c$var$PartyTitleContainer, {
                        rightSided: rightSided,
                        children: [
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$febc15bff886858c$var$StyledTitle, {
                                children: title
                            }),
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$febc15bff886858c$var$StyledParty, {
                                children: party
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$febc15bff886858c$var$StyledSubtitle, {
                        children: subtitle
                    })
                ]
            })
        ]
    });
};
var $48090fca70e3183a$var$$febc15bff886858c$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$febc15bff886858c$var$Bullet;
const $48090fca70e3183a$var$$c3e303edb7751c77$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "timeline__Wrapper",
    componentId: "sc-rxkvqs-0"
})([
    "",
    " display:flex;flex-direction:column;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$c3e303edb7751c77$var$StyledBullet = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$febc15bff886858c$export$2e2bcd8739ae039).withConfig({
    displayName: "timeline__StyledBullet",
    componentId: "sc-rxkvqs-1"
})([
    "position:relative;transform:translateX( ",
    " );"
], ({ rightSided: rightSided })=>rightSided ? "calc(50% - 8px)" : "calc(-50% + 8px)");
const $48090fca70e3183a$var$$c3e303edb7751c77$var$LastBullet = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$c3e303edb7751c77$var$StyledBullet).withConfig({
    displayName: "timeline__LastBullet",
    componentId: "sc-rxkvqs-2"
})([
    "height:unset;flex-basis:auto;flex-grow:0;"
]);
const $48090fca70e3183a$var$$c3e303edb7751c77$var$Timeline = ({ items: items, ...props })=>{
    const lastItem = items[items.length - 1];
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$c3e303edb7751c77$var$Wrapper, {
        ...props,
        children: [
            items.slice(0, -1).map((item, i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$c3e303edb7751c77$var$StyledBullet, {
                    line: true,
                    ...item,
                    isLast: false
                }, i)),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$c3e303edb7751c77$var$LastBullet, {
                ...lastItem,
                isLast: true
            })
        ]
    });
};
var $48090fca70e3183a$var$$c3e303edb7751c77$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$c3e303edb7751c77$var$Timeline;
const $48090fca70e3183a$var$$a3f868921843a442$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "custom__Wrapper",
    componentId: "sc-k2o2ay-0"
})([
    "",
    " display:flex;flex-direction:column;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$a3f868921843a442$var$LastBullet = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$febc15bff886858c$export$2e2bcd8739ae039).withConfig({
    displayName: "custom__LastBullet",
    componentId: "sc-k2o2ay-1"
})([
    "height:unset;flex-basis:auto;flex-grow:0;"
]);
const $48090fca70e3183a$var$$a3f868921843a442$var$CustomTimeline = ({ items: items, ...props })=>{
    const lastItem = items[items.length - 1];
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$a3f868921843a442$var$Wrapper, {
        ...props,
        children: [
            items.slice(0, -1).map((item, i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$febc15bff886858c$export$2e2bcd8739ae039, {
                    line: true,
                    ...item,
                    rightSided: true,
                    isLast: false
                }, i)),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a3f868921843a442$var$LastBullet, {
                rightSided: true,
                ...lastItem,
                isLast: true
            })
        ]
    });
};
var $48090fca70e3183a$var$$a3f868921843a442$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$a3f868921843a442$var$CustomTimeline;
const $48090fca70e3183a$var$$4c05722f1abfb34c$var$BaseTag = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "tag__BaseTag",
    componentId: "sc-19f0jzg-0"
})([
    "",
    " ",
    " height:32px;background:",
    ";border:",
    ";border-radius:300px;padding:0 16px;display:flex;justify-content:center;align-items:center;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ theme: theme })=>theme.klerosUIComponentsMediumBlue, ({ theme: theme, active: active })=>active ? `1px solid ${theme.klerosUIComponentsPrimaryBlue}` : "none");
const $48090fca70e3183a$var$$4c05722f1abfb34c$var$StyledText = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).p.withConfig({
    displayName: "tag__StyledText",
    componentId: "sc-19f0jzg-1"
})([
    "",
    " color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ffb5f4729a158638, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$4c05722f1abfb34c$var$Tag = ({ text: text, active: active, as: as, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4c05722f1abfb34c$var$BaseTag, {
        active: active,
        as: as,
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4c05722f1abfb34c$var$StyledText, {
            children: text
        })
    });
var $48090fca70e3183a$var$$4c05722f1abfb34c$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$4c05722f1abfb34c$var$Tag;
const $48090fca70e3183a$var$$4ceeceac8d19d80b$var$StyledText = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "tooltip__StyledText",
    componentId: "sc-2flh2z-0"
})([
    ""
]);
const $48090fca70e3183a$var$$4ceeceac8d19d80b$var$StyledTooltip = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).span.withConfig({
    displayName: "tooltip__StyledTooltip",
    componentId: "sc-2flh2z-1"
})([
    "",
    " ",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ place: place, theme: theme, small: small })=>(0, $1d9bd5c523349ec4$exports.css)([
        "visibility:hidden;position:absolute;z-index:1;width:max-content;max-width:240px;background:",
        ";border-radius:3px;padding:13px 16px;display:flex;justify-content:center;align-items:center;& ",
        "{",
        " font-weight:100;text-align:",
        ";color:",
        ';}::after{content:"";position:absolute;border-width:8px;border-style:solid;}',
        " ",
        " ",
        " ",
        ""
    ], theme.klerosUIComponentsPrimaryBlue, $48090fca70e3183a$var$$4ceeceac8d19d80b$var$StyledText, $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, small ? "center" : "left", theme.klerosUIComponentsWhiteBackground, place === "top" && (0, $1d9bd5c523349ec4$exports.css)([
        "bottom:calc(100% + 16px);left:50%;transform:translateX(-50%);::after{top:100%;left:50%;transform:translateX(-50%);border-color:",
        " transparent transparent transparent;}"
    ], theme.klerosUIComponentsPrimaryBlue), place === "right" && (0, $1d9bd5c523349ec4$exports.css)([
        "top:50%;left:calc(100% + 16px);transform:translateY(-50%);::after{top:50%;right:100%;transform:translateY(-50%);border-color:transparent ",
        " transparent transparent;}"
    ], theme.klerosUIComponentsPrimaryBlue), place === "bottom" && (0, $1d9bd5c523349ec4$exports.css)([
        "top:calc(100% + 16px);left:50%;transform:translateX(-50%);::after{left:50%;bottom:100%;transform:translateX(-50%);border-color:transparent transparent ",
        " transparent;}"
    ], theme.klerosUIComponentsPrimaryBlue), place === "left" && (0, $1d9bd5c523349ec4$exports.css)([
        "top:50%;right:calc(100% + 16px);transform:translateY(-50%);::after{top:50%;left:100%;transform:translateY(-50%);border-color:transparent transparent transparent ",
        ";}"
    ], theme.klerosUIComponentsPrimaryBlue)));
const $48090fca70e3183a$var$$4ceeceac8d19d80b$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "tooltip__Wrapper",
    componentId: "sc-2flh2z-2"
})([
    "position:relative;display:inline-block;&:hover ",
    "{visibility:visible;}"
], $48090fca70e3183a$var$$4ceeceac8d19d80b$var$StyledTooltip);
const $48090fca70e3183a$var$$4ceeceac8d19d80b$var$Tooltip = ({ place: place = "top", text: text, children: children, small: small, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$4ceeceac8d19d80b$var$Wrapper, {
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4ceeceac8d19d80b$var$StyledTooltip, {
                small: small,
                place: place,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4ceeceac8d19d80b$var$StyledText, {
                    children: text
                })
            })
        ]
    });
var $48090fca70e3183a$var$$4ceeceac8d19d80b$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$4ceeceac8d19d80b$var$Tooltip;
const $48090fca70e3183a$var$$a5329119b99a1727$var$SvgCopy = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 15 16",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M13.776 2.06 12.129.44A1.536 1.536 0 0 0 11.05 0H5.587c-.841 0-1.524.672-1.524 1.5V3h-2.54C.684 3 0 3.672 0 4.5v10c0 .828.682 1.5 1.524 1.5h7.11c.843 0 1.525-.672 1.525-1.5V13h2.54c.841 0 1.523-.672 1.523-1.5V3.121c0-.398-.16-.779-.446-1.06ZM8.444 14.5h-6.73a.192.192 0 0 1-.134-.055.186.186 0 0 1-.056-.133V4.688c0-.05.02-.098.056-.133a.192.192 0 0 1 .134-.055h2.35v7c0 .828.682 1.5 1.523 1.5h3.048v1.313c0 .05-.02.097-.056.132a.192.192 0 0 1-.135.055Zm4.064-3h-6.73a.192.192 0 0 1-.135-.055.186.186 0 0 1-.056-.133V1.688c0-.05.02-.098.056-.133a.192.192 0 0 1 .135-.055h3.365v2.75c0 .414.341.75.762.75h2.793v6.313c0 .05-.02.097-.055.132a.192.192 0 0 1-.135.055Zm.19-8h-2.031v-2h.305c.051 0 .1.02.135.055l1.536 1.511a.186.186 0 0 1 .055.133V3.5Z",
            fill: "#009AFF"
        })
    });
var $48090fca70e3183a$var$$a5329119b99a1727$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$a5329119b99a1727$var$SvgCopy;
const $48090fca70e3183a$var$$24ee0e3ed5abf092$var$SvgCopied = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
            clipPath: "url('#clip0_13289_179292')",
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 8.5a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8.5Zm1.357 0a6.644 6.644 0 0 0 13.286 0 6.644 6.644 0 0 0-13.286 0Zm9.145-2.84h.837c.116 0 .184.132.114.227L7.694 11.1a.567.567 0 0 1-.923 0L4.545 8.016a.143.143 0 0 1 .116-.227h.837c.184 0 .356.089.463.237l1.271 1.765 2.807-3.893a.569.569 0 0 1 .463-.238Z",
                fill: "#009AFF"
            })
        })
    });
var $48090fca70e3183a$var$$24ee0e3ed5abf092$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$24ee0e3ed5abf092$var$SvgCopied;
const $48090fca70e3183a$var$$f9cf7fe05b87a0bc$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "copiable__Wrapper",
    componentId: "sc-3t2xjv-0"
})([
    "position:relative;display:inline-flex;align-items:center;gap:8px;"
]);
const $48090fca70e3183a$var$$f9cf7fe05b87a0bc$var$StyledTooltip = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$4ceeceac8d19d80b$export$2e2bcd8739ae039).withConfig({
    displayName: "copiable__StyledTooltip",
    componentId: "sc-3t2xjv-1"
})([
    "> span{padding:8px;}"
]);
const $48090fca70e3183a$var$$f9cf7fe05b87a0bc$var$IconContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "copiable__IconContainer",
    componentId: "sc-3t2xjv-2"
})([
    "cursor:pointer;display:flex;align-items:center;width:16px;height:16px;"
]);
/**
 * @description Wraps a component to make it copiable.
 * @param copiableContent The text to be copied to user's clipboard
 * @param info Modify the message displayed in the copy button's tooltip
 * @param tooltipProps Copy button's tooltip props
 */ const $48090fca70e3183a$var$$f9cf7fe05b87a0bc$var$Copiable = ({ copiableContent: copiableContent, info: info, children: children, tooltipProps: tooltipProps, ...props })=>{
    const [isCopied, setIsCopied] = (0, $9nZCP.useState)(false);
    const handleCopy = ()=>{
        navigator.clipboard.writeText(copiableContent).then(()=>{
            setIsCopied(true);
            setTimeout(()=>setIsCopied(false), 2000);
        }).catch(()=>setIsCopied(false));
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$f9cf7fe05b87a0bc$var$Wrapper, {
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$f9cf7fe05b87a0bc$var$StyledTooltip, {
                text: isCopied ? "Copied!" : `${info ?? "Copy"}`,
                ...tooltipProps,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$f9cf7fe05b87a0bc$var$IconContainer, {
                    className: "icon-container",
                    children: isCopied ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$24ee0e3ed5abf092$export$2e2bcd8739ae039, {
                        className: "copied-icon"
                    }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a5329119b99a1727$export$2e2bcd8739ae039, {
                        className: "copy-icon",
                        onClick: handleCopy
                    })
                })
            })
        ]
    });
};
var $48090fca70e3183a$var$$f9cf7fe05b87a0bc$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$f9cf7fe05b87a0bc$var$Copiable;
const $48090fca70e3183a$var$$18386f08588a981e$export$f30cb9bc4f736419 = {
    klerosUIComponentsPrimaryPurple: "#4D00B4",
    klerosUIComponentsSecondaryPurple: "#9013FE",
    klerosUIComponentsMediumPurple: "#F8F1FF",
    klerosUIComponentsLightPurple: "#FBF9FE",
    klerosUIComponentsPrimaryBlue: "#009AFF",
    klerosUIComponentsSecondaryBlue: "#7BCBFF",
    klerosUIComponentsMediumBlue: "#F0F9FF",
    klerosUIComponentsLightBlue: "#FCFEFF",
    klerosUIComponentsPrimaryText: "#333333",
    klerosUIComponentsSecondaryText: "#999999",
    klerosUIComponentsStroke: "#e5e5e5",
    klerosUIComponentsLightGrey: "#FAFAFA",
    klerosUIComponentsWhiteBackground: "#FFFFFF",
    klerosUIComponentsLightBackground: "#FAFBFC",
    klerosUIComponentsDefaultShadow: "#00000002",
    klerosUIComponentsHoveredShadow: "#00000002",
    klerosUIComponentsSuccess: "#00C42B",
    klerosUIComponentsSuccessLight: "#F0FBF2",
    klerosUIComponentsWarning: "#FF9900",
    klerosUIComponentsWarningLight: "#FFF9F0",
    klerosUIComponentsError: "#F60C36",
    klerosUIComponentsErrorLight: "#FEFF0F3",
    klerosUIComponentsTint: "#D14EFF",
    klerosUIComponentsTintMedium: "#401D6C",
    klerosUIComponentsTintPurple: "#F4F0FA",
    klerosUIComponentsTransitionSpeed: "0.25s"
};
const $48090fca70e3183a$var$$18386f08588a981e$export$3e936a8db52a10a0 = {
    klerosUIComponentsPrimaryPurple: "#7E1BD4",
    klerosUIComponentsSecondaryPurple: "#B45FFF",
    klerosUIComponentsMediumPurple: "#390F6C",
    klerosUIComponentsLightPurple: "#FCFBFF",
    klerosUIComponentsPrimaryBlue: "#6CC5FF",
    klerosUIComponentsSecondaryBlue: "#A5DBFF",
    klerosUIComponentsMediumBlue: "#2E206C",
    klerosUIComponentsLightBlue: "#2A1260",
    klerosUIComponentsPrimaryText: "#DAF0FF",
    klerosUIComponentsSecondaryText: "#BECCE5",
    klerosUIComponentsStroke: "#42498F",
    klerosUIComponentsLightGrey: "#2D1865",
    klerosUIComponentsWhiteBackground: "#220050",
    klerosUIComponentsLightBackground: "#1B003F",
    klerosUIComponentsDefaultShadow: "#00000000",
    klerosUIComponentsHoveredShadow: "#42498f80",
    klerosUIComponentsSuccess: "#65DC7F",
    klerosUIComponentsSuccessLight: "#32355B",
    klerosUIComponentsWarning: "#FFC46B",
    klerosUIComponentsWarningLight: "#451F54",
    klerosUIComponentsError: "#FF5A78",
    klerosUIComponentsErrorLight: "#360652",
    klerosUIComponentsTint: "#DDB6FF",
    klerosUIComponentsTintMedium: "#401D6C",
    klerosUIComponentsTintPurple: "#2F0960",
    klerosUIComponentsTransitionSpeed: "0.25s"
};
const $48090fca70e3183a$var$$18386f08588a981e$export$a183395ddd946500 = {
    klerosUIComponentsPrimaryPurple: "#200F47",
    klerosUIComponentsSecondaryPurple: "#B45FFF",
    klerosUIComponentsMediumPurple: "#390F6C",
    klerosUIComponentsLightPurple: "#FCFBFF",
    klerosUIComponentsPrimaryBlue: "#69C3FC",
    klerosUIComponentsSecondaryBlue: "#A5DBFF",
    klerosUIComponentsMediumBlue: "#2E206C",
    klerosUIComponentsLightBlue: "#2A1260",
    klerosUIComponentsPrimaryText: "#DAF0FF",
    klerosUIComponentsSecondaryText: "#BECCE5",
    klerosUIComponentsStroke: "#42498F",
    klerosUIComponentsLightGrey: "#2D1865",
    klerosUIComponentsWhiteBackground: "#200F47",
    klerosUIComponentsLightBackground: "#1B003F",
    klerosUIComponentsDefaultShadow: "#00000000",
    klerosUIComponentsHoveredShadow: "#42498f80",
    klerosUIComponentsSuccess: "#65DC7F",
    klerosUIComponentsSuccessLight: "#32355B",
    klerosUIComponentsWarning: "#FFC46B",
    klerosUIComponentsWarningLight: "#451F54",
    klerosUIComponentsError: "#FF5A78",
    klerosUIComponentsErrorLight: "#360652",
    klerosUIComponentsTint: "#DDB6FF",
    klerosUIComponentsTintMedium: "#401D6C",
    klerosUIComponentsTintPurple: "#2F0960",
    klerosUIComponentsTransitionSpeed: "0.25s"
};


const $ac10bbe25cb4da94$export$f30cb9bc4f736419 = {
    ...(0, $48090fca70e3183a$exports.lightTheme),
    name: "light",
    white: "#FFFFFF",
    primaryPurple: "#4D00B4",
    secondaryPurple: "#9013FE",
    mediumPurple: "#F8F1FF",
    lightPurple: "#FBF9FE",
    violetPurple: "#6A1DCD",
    lavenderPurple: "#BB72FF",
    primaryBlue: "#009AFF",
    secondaryBlue: "#7BCBFF",
    mediumBlue: "#F0F9FF",
    lightBlue: "#FCFEFF",
    primaryText: "#333333",
    secondaryText: "#999999",
    stroke: "#e5e5e5",
    lightGrey: "#F0F0F0",
    whiteBackground: "#FFFFFF",
    lightBackground: "#FAFBFC",
    defaultShadow: "#00000002",
    hoveredShadow: "#00000002",
    whiteLowOpacity: "#0000000d",
    blackLowOpacity: "#00000080",
    success: "#00C42B",
    successLight: "#F0FBF2",
    warning: "#FF9900",
    warningLight: "#FFF9F0",
    error: "#F60C36",
    errorLight: "#FEF0F3",
    tint: "#D14EFF",
    tintMedium: "#FCF4FF",
    tintPurple: "#F4F0FA",
    transitionSpeed: "0.25s",
    skeletonBackground: "#EBEBEB",
    skeletonHighlight: "#F5F5F5"
};
const $ac10bbe25cb4da94$export$3e936a8db52a10a0 = {
    ...(0, $48090fca70e3183a$exports.darkTheme),
    name: "dark",
    white: "#FFFFFF",
    primaryPurple: "#7E1BD4",
    secondaryPurple: "#B45FFF",
    mediumPurple: "#390F6C",
    lightPurple: "#FCFBFF",
    violetPurple: "#6A1DCD",
    lavenderPurple: "#BB72FF",
    primaryBlue: "#6CC5FF",
    secondaryBlue: "#A5DBFF",
    mediumBlue: "#2E206C",
    lightBlue: "#2A1260",
    primaryText: "#DAF0FF",
    secondaryText: "#BECCE5",
    stroke: "#42498F",
    lightGrey: "#2D1865",
    whiteBackground: "#220050",
    lightBackground: "#1B003F",
    defaultShadow: "#00000000",
    hoveredShadow: "#42498f80",
    whiteLowOpacity: "#FFFFFF0F",
    blackLowOpacity: "#00000080",
    success: "#65DC7F",
    successLight: "#32355B",
    warning: "#FFC46B",
    warningLight: "#451F54",
    error: "#FF5A78",
    errorLight: "#360652",
    tint: "#DDB6FF",
    tintMedium: "#401D6C",
    tintPurple: "#2F0960",
    transitionSpeed: "0.25s",
    skeletonBackground: "#3A2270",
    skeletonHighlight: "#3E307C"
};


const $8416457fc13d8fca$var$StyledComponentsProvider = ({ children: children })=>{
    const [theme, setTheme] = (0, $02bde888b770a5cd$export$86e2cef2561044ac)("theme", "dark");
    const toggleTheme = ()=>{
        if (theme === "light") setTheme("dark");
        else setTheme("light");
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $1d9bd5c523349ec4$export$d8964aec282183a3), {
        theme: theme === "light" ? (0, $ac10bbe25cb4da94$export$f30cb9bc4f736419) : (0, $ac10bbe25cb4da94$export$3e936a8db52a10a0),
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $9bc8dca83e4f2710$export$d3df7f168cf26f4), {
            theme: theme,
            toggleTheme: toggleTheme,
            children: [
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $fadba3057c087eb0$export$f05794e648629f6c), {}),
                children
            ]
        })
    });
};
var $8416457fc13d8fca$export$2e2bcd8739ae039 = $8416457fc13d8fca$var$StyledComponentsProvider;




var $9nZCP = parcelRequire("9nZCP");


const $c5691ed31ffeb609$var$useRefetchOnBlock = ()=>{
    const queryClient = (0, $6d6ab9aaa62ea16f$export$22e77b9572c4fded)();
    const publicClient = (0, $b9a08c139e2d6879$export$724f5280724585ed)();
    (0, $9nZCP.useEffect)(()=>{
        const unwatch = publicClient?.watchBlocks({
            onBlock: (block)=>{
                if (block.number % BigInt(10) === BigInt(0)) queryClient.invalidateQueries([
                    "refetchOnBlock"
                ]);
            }
        });
        return ()=>unwatch?.();
    }, [
        publicClient,
        queryClient
    ]);
};
const $c5691ed31ffeb609$var$RefetchOnBlock = ()=>{
    $c5691ed31ffeb609$var$useRefetchOnBlock();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $dde41420777b5d34$exports.Fragment), {});
};
var $c5691ed31ffeb609$export$2e2bcd8739ae039 = $c5691ed31ffeb609$var$RefetchOnBlock;




var $9nZCP = parcelRequire("9nZCP");

var $749779f5335cf90b$exports = {};
"use strict";
var $749779f5335cf90b$var$__createBinding = $749779f5335cf90b$exports && $749779f5335cf90b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $749779f5335cf90b$var$__setModuleDefault = $749779f5335cf90b$exports && $749779f5335cf90b$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $749779f5335cf90b$var$__importStar = $749779f5335cf90b$exports && $749779f5335cf90b$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $749779f5335cf90b$var$__createBinding(result, mod, k);
    }
    $749779f5335cf90b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($749779f5335cf90b$exports, "__esModule", {
    value: true
});
$749779f5335cf90b$exports.request = $749779f5335cf90b$exports.rawRequest = $749779f5335cf90b$exports.GraphQLClient = $749779f5335cf90b$exports.ClientError = $749779f5335cf90b$exports.batchRequests = $749779f5335cf90b$exports.resolveRequestDocument = $749779f5335cf90b$exports.GraphQLWebSocketClient = $749779f5335cf90b$exports.gql = void 0;
var $82d862471288a54b$exports = {};
"use strict";
Object.defineProperty($82d862471288a54b$exports, "__esModule", {
    value: true
});
$82d862471288a54b$exports.defaultJsonSerializer = void 0;
$82d862471288a54b$exports.defaultJsonSerializer = JSON;


var $5adad46b3f5b0a29$exports = {};
"use strict";
Object.defineProperty($5adad46b3f5b0a29$exports, "__esModule", {
    value: true
});
$5adad46b3f5b0a29$exports.HeadersInstanceToPlainObject = $5adad46b3f5b0a29$exports.uppercase = void 0;
const $5adad46b3f5b0a29$var$uppercase = (str)=>str.toUpperCase();
$5adad46b3f5b0a29$exports.uppercase = $5adad46b3f5b0a29$var$uppercase;
/**
 * Convert Headers instance into regular object
 */ const $5adad46b3f5b0a29$var$HeadersInstanceToPlainObject = (headers)=>{
    const o = {};
    headers.forEach((v, k)=>{
        o[k] = v;
    });
    return o;
};
$5adad46b3f5b0a29$exports.HeadersInstanceToPlainObject = $5adad46b3f5b0a29$var$HeadersInstanceToPlainObject;


var $5daee54a55c14e05$exports = {};
"use strict";
Object.defineProperty($5daee54a55c14e05$exports, "__esModule", {
    value: true
});
$5daee54a55c14e05$exports.parseRawRequestExtendedArgs = $5daee54a55c14e05$exports.parseRequestExtendedArgs = $5daee54a55c14e05$exports.parseBatchRequestArgs = $5daee54a55c14e05$exports.parseRawRequestArgs = $5daee54a55c14e05$exports.parseRequestArgs = void 0;
const $5daee54a55c14e05$var$parseRequestArgs = (documentOrOptions, variables, requestHeaders)=>{
    return documentOrOptions.document ? documentOrOptions : {
        document: documentOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$5daee54a55c14e05$exports.parseRequestArgs = $5daee54a55c14e05$var$parseRequestArgs;
const $5daee54a55c14e05$var$parseRawRequestArgs = (queryOrOptions, variables, requestHeaders)=>{
    return queryOrOptions.query ? queryOrOptions : {
        query: queryOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$5daee54a55c14e05$exports.parseRawRequestArgs = $5daee54a55c14e05$var$parseRawRequestArgs;
const $5daee54a55c14e05$var$parseBatchRequestArgs = (documentsOrOptions, requestHeaders)=>{
    return documentsOrOptions.documents ? documentsOrOptions : {
        documents: documentsOrOptions,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$5daee54a55c14e05$exports.parseBatchRequestArgs = $5daee54a55c14e05$var$parseBatchRequestArgs;
const $5daee54a55c14e05$var$parseRequestExtendedArgs = (urlOrOptions, document, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.document ? urlOrOptions : {
        url: urlOrOptions,
        document: document,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$5daee54a55c14e05$exports.parseRequestExtendedArgs = $5daee54a55c14e05$var$parseRequestExtendedArgs;
const $5daee54a55c14e05$var$parseRawRequestExtendedArgs = (urlOrOptions, query, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.query ? urlOrOptions : {
        url: urlOrOptions,
        query: query,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$5daee54a55c14e05$exports.parseRawRequestExtendedArgs = $5daee54a55c14e05$var$parseRawRequestExtendedArgs;


var $28880f85c8a42137$exports = {};
"use strict";
Object.defineProperty($28880f85c8a42137$exports, "__esModule", {
    value: true
});
$28880f85c8a42137$exports.resolveRequestDocument = void 0;
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $1e2fef5e264bd00f$export$c10d0b04eaa80a43(value) {
    return typeof value == "object" && value !== null;
}


function $15d0c7a69cd3af1f$export$f5708dca728d7177(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}


const $9ab59479d005d1b6$var$LineRegExp = /\r\n|[\n\r]/g;
function $9ab59479d005d1b6$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($9ab59479d005d1b6$var$LineRegExp)){
        typeof match.index === "number" || (0, $15d0c7a69cd3af1f$export$f5708dca728d7177)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}



function $23f6c544316a2d5d$export$96a9681e539deed(location) {
    return $23f6c544316a2d5d$export$867940333fd9f869(location.source, (0, $9ab59479d005d1b6$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $23f6c544316a2d5d$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = "".padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $23f6c544316a2d5d$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    "|",
                    subLine
                ]),
            [
                "|",
                "^".padStart(subLineColumnNum)
            ],
            [
                "|",
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $23f6c544316a2d5d$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            "|",
            "^".padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $23f6c544316a2d5d$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? " " + line : "")).join("\n");
}


function $3ed540063397e65b$var$toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || "kind" in firstArg || "length" in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class $3ed540063397e65b$export$92d6ed0888e7cb7f extends Error {
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = $3ed540063397e65b$var$toNormalizedOptions(rawArgs);
        super(message);
        this.name = "GraphQLError";
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = $3ed540063397e65b$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $3ed540063397e65b$var$undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $9ab59479d005d1b6$export$e7fd20fad3cf4b5f)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, $9ab59479d005d1b6$export$e7fd20fad3cf4b5f)(loc.source, loc.start));
        const originalExtensions = (0, $1e2fef5e264bd00f$export$c10d0b04eaa80a43)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, "stack", {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $3ed540063397e65b$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
    get [Symbol.toStringTag]() {
        return "GraphQLError";
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += "\n\n" + (0, $23f6c544316a2d5d$export$96a9681e539deed)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += "\n\n" + (0, $23f6c544316a2d5d$export$867940333fd9f869)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
}
function $3ed540063397e65b$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $3ed540063397e65b$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $3ed540063397e65b$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}


function $8ba58f28d15a114b$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $3ed540063397e65b$export$92d6ed0888e7cb7f)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $d9046b8c989e4522$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return "Location";
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $d9046b8c989e4522$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return "Token";
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $d9046b8c989e4522$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
const $d9046b8c989e4522$var$kindValues = new Set(Object.keys($d9046b8c989e4522$export$4fcd777a40ccf407));
function $d9046b8c989e4522$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === "string" && $d9046b8c989e4522$var$kindValues.has(maybeKind);
}
/** Name */ var $d9046b8c989e4522$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode["QUERY"] = "query";
    OperationTypeNode["MUTATION"] = "mutation";
    OperationTypeNode["SUBSCRIPTION"] = "subscription";
})($d9046b8c989e4522$export$f58c50edb4aef9d4 || ($d9046b8c989e4522$export$f58c50edb4aef9d4 = {}));


/**
 * The set of allowed directive location values.
 */ var $f9d53977918cb7ab$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation["QUERY"] = "QUERY";
    DirectiveLocation["MUTATION"] = "MUTATION";
    DirectiveLocation["SUBSCRIPTION"] = "SUBSCRIPTION";
    DirectiveLocation["FIELD"] = "FIELD";
    DirectiveLocation["FRAGMENT_DEFINITION"] = "FRAGMENT_DEFINITION";
    DirectiveLocation["FRAGMENT_SPREAD"] = "FRAGMENT_SPREAD";
    DirectiveLocation["INLINE_FRAGMENT"] = "INLINE_FRAGMENT";
    DirectiveLocation["VARIABLE_DEFINITION"] = "VARIABLE_DEFINITION";
    DirectiveLocation["SCHEMA"] = "SCHEMA";
    DirectiveLocation["SCALAR"] = "SCALAR";
    DirectiveLocation["OBJECT"] = "OBJECT";
    DirectiveLocation["FIELD_DEFINITION"] = "FIELD_DEFINITION";
    DirectiveLocation["ARGUMENT_DEFINITION"] = "ARGUMENT_DEFINITION";
    DirectiveLocation["INTERFACE"] = "INTERFACE";
    DirectiveLocation["UNION"] = "UNION";
    DirectiveLocation["ENUM"] = "ENUM";
    DirectiveLocation["ENUM_VALUE"] = "ENUM_VALUE";
    DirectiveLocation["INPUT_OBJECT"] = "INPUT_OBJECT";
    DirectiveLocation["INPUT_FIELD_DEFINITION"] = "INPUT_FIELD_DEFINITION";
})($f9d53977918cb7ab$export$b45ffd2948484c41 || ($f9d53977918cb7ab$export$b45ffd2948484c41 = {}));
 /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ 

/**
 * The set of allowed kind values for AST nodes.
 */ var $d60c070bf0c85158$export$a84bdc57c5122798;
(function(Kind) {
    Kind["NAME"] = "Name";
    Kind["DOCUMENT"] = "Document";
    Kind["OPERATION_DEFINITION"] = "OperationDefinition";
    Kind["VARIABLE_DEFINITION"] = "VariableDefinition";
    Kind["SELECTION_SET"] = "SelectionSet";
    Kind["FIELD"] = "Field";
    Kind["ARGUMENT"] = "Argument";
    Kind["FRAGMENT_SPREAD"] = "FragmentSpread";
    Kind["INLINE_FRAGMENT"] = "InlineFragment";
    Kind["FRAGMENT_DEFINITION"] = "FragmentDefinition";
    Kind["VARIABLE"] = "Variable";
    Kind["INT"] = "IntValue";
    Kind["FLOAT"] = "FloatValue";
    Kind["STRING"] = "StringValue";
    Kind["BOOLEAN"] = "BooleanValue";
    Kind["NULL"] = "NullValue";
    Kind["ENUM"] = "EnumValue";
    Kind["LIST"] = "ListValue";
    Kind["OBJECT"] = "ObjectValue";
    Kind["OBJECT_FIELD"] = "ObjectField";
    Kind["DIRECTIVE"] = "Directive";
    Kind["NAMED_TYPE"] = "NamedType";
    Kind["LIST_TYPE"] = "ListType";
    Kind["NON_NULL_TYPE"] = "NonNullType";
    Kind["SCHEMA_DEFINITION"] = "SchemaDefinition";
    Kind["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
    Kind["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
    Kind["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
    Kind["FIELD_DEFINITION"] = "FieldDefinition";
    Kind["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
    Kind["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
    Kind["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
    Kind["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
    Kind["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
    Kind["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
    Kind["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
    Kind["SCHEMA_EXTENSION"] = "SchemaExtension";
    Kind["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
    Kind["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
    Kind["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
    Kind["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
    Kind["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
    Kind["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})($d60c070bf0c85158$export$a84bdc57c5122798 || ($d60c070bf0c85158$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 



/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $ebe4940248925047$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $ebe4940248925047$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $ebe4940248925047$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $ebe4940248925047$export$45a677ea7cb6d5c8(code) {
    return $ebe4940248925047$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $ebe4940248925047$export$d3f406ff46035894(code) {
    return $ebe4940248925047$export$79c5d5217943d6a7(code) || $ebe4940248925047$export$727d9dbc4fbb948f(code) || code === 0x005f;
}


function $4dcd914c56cc3651$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $4dcd914c56cc3651$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $4dcd914c56cc3651$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $ebe4940248925047$export$3c52dd84024ae72c)(str.charCodeAt(i)))++i;
    return i;
}
function $4dcd914c56cc3651$export$40862a63ef85e395(value) {
    if (value === "") return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $4dcd914c56cc3651$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $ebe4940248925047$export$3c52dd84024ae72c)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith("\\");
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ""; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $ebe4940248925047$export$3c52dd84024ae72c)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += "\n";
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += "\n";
    return '"""' + result + '"""';
}



/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $9a9b48308b55bec1$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind["SOF"] = "<SOF>";
    TokenKind["EOF"] = "<EOF>";
    TokenKind["BANG"] = "!";
    TokenKind["DOLLAR"] = "$";
    TokenKind["AMP"] = "&";
    TokenKind["PAREN_L"] = "(";
    TokenKind["PAREN_R"] = ")";
    TokenKind["SPREAD"] = "...";
    TokenKind["COLON"] = ":";
    TokenKind["EQUALS"] = "=";
    TokenKind["AT"] = "@";
    TokenKind["BRACKET_L"] = "[";
    TokenKind["BRACKET_R"] = "]";
    TokenKind["BRACE_L"] = "{";
    TokenKind["PIPE"] = "|";
    TokenKind["BRACE_R"] = "}";
    TokenKind["NAME"] = "Name";
    TokenKind["INT"] = "Int";
    TokenKind["FLOAT"] = "Float";
    TokenKind["STRING"] = "String";
    TokenKind["BLOCK_STRING"] = "BlockString";
    TokenKind["COMMENT"] = "Comment";
})($9a9b48308b55bec1$export$8b9d26ab11394711 || ($9a9b48308b55bec1$export$8b9d26ab11394711 = {}));
 /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ 

class $7c9a258a88804120$export$6168dc8908a6c652 {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ constructor(source){
        const startOfFileToken = new (0, $d9046b8c989e4522$export$50792b0e93539fde)((0, $9a9b48308b55bec1$export$8b9d26ab11394711).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    get [Symbol.toStringTag]() {
        return "Lexer";
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $9a9b48308b55bec1$export$8b9d26ab11394711).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $7c9a258a88804120$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).COMMENT);
        }
        return token;
    }
}
function $7c9a258a88804120$export$59ac0f4da287406a(kind) {
    return kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BANG || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).DOLLAR || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).AMP || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_L || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_R || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).SPREAD || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).COLON || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).EQUALS || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).AT || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACKET_L || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACKET_R || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).PIPE || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $7c9a258a88804120$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $7c9a258a88804120$var$isSupplementaryCodePoint(body, location) {
    return $7c9a258a88804120$var$isLeadingSurrogate(body.charCodeAt(location)) && $7c9a258a88804120$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $7c9a258a88804120$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $7c9a258a88804120$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */ function $7c9a258a88804120$var$printCodePointAt(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $9a9b48308b55bec1$export$8b9d26ab11394711).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return "U+" + code.toString(16).toUpperCase().padStart(4, "0");
}
/**
 * Create a token with line and column location information.
 */ function $7c9a258a88804120$var$createToken(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $d9046b8c989e4522$export$50792b0e93539fde)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $7c9a258a88804120$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $7c9a258a88804120$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BANG, position, position + 1);
            case 0x0024:
                // $
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).AMP, position, position + 1);
            case 0x0028:
                // (
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).COLON, position, position + 1);
            case 0x003d:
                // =
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).AT, position, position + 1);
            case 0x005b:
                // [
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $7c9a258a88804120$var$readBlockString(lexer, position);
                return $7c9a258a88804120$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $ebe4940248925047$export$727d9dbc4fbb948f)(code) || code === 0x002d) return $7c9a258a88804120$var$readNumber(lexer, position, code);
         // Name
        if ((0, $ebe4940248925047$export$45a677ea7cb6d5c8)(code)) return $7c9a258a88804120$var$readName(lexer, position);
        throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, code === 0x0027 ? "Unexpected single quote character ('), did you mean to use a double quote (\")?" : $7c9a258a88804120$var$isUnicodeScalarValue(code) || $7c9a258a88804120$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$7c9a258a88804120$var$printCodePointAt(lexer, position)}.` : `Invalid character: ${$7c9a258a88804120$var$printCodePointAt(lexer, position)}.`);
    }
    return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $7c9a258a88804120$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($7c9a258a88804120$var$isUnicodeScalarValue(code)) ++position;
        else if ($7c9a258a88804120$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $7c9a258a88804120$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $ebe4940248925047$export$727d9dbc4fbb948f)(code)) throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$7c9a258a88804120$var$printCodePointAt(lexer, position)}.`);
    } else {
        position = $7c9a258a88804120$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $7c9a258a88804120$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $7c9a258a88804120$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $ebe4940248925047$export$45a677ea7cb6d5c8)(code)) throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, expected digit but got: ${$7c9a258a88804120$var$printCodePointAt(lexer, position)}.`);
    return $7c9a258a88804120$var$createToken(lexer, isFloat ? (0, $9a9b48308b55bec1$export$8b9d26ab11394711).FLOAT : (0, $9a9b48308b55bec1$export$8b9d26ab11394711).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $7c9a258a88804120$var$readDigits(lexer, start, firstCode) {
    if (!(0, $ebe4940248925047$export$727d9dbc4fbb948f)(firstCode)) throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, start, `Invalid number, expected digit but got: ${$7c9a258a88804120$var$printCodePointAt(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $ebe4940248925047$export$727d9dbc4fbb948f)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $7c9a258a88804120$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = "";
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $7c9a258a88804120$var$readEscapedUnicodeVariableWidth(lexer, position) : $7c9a258a88804120$var$readEscapedUnicodeFixedWidth(lexer, position) : $7c9a258a88804120$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($7c9a258a88804120$var$isUnicodeScalarValue(code)) ++position;
        else if ($7c9a258a88804120$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$7c9a258a88804120$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, "Unterminated string.");
} // The string value and lexed size of an escape sequence.
function $7c9a258a88804120$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$7c9a258a88804120$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $7c9a258a88804120$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $7c9a258a88804120$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $7c9a258a88804120$var$read16BitHexCode(body, position + 2);
    if ($7c9a258a88804120$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($7c9a258a88804120$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $7c9a258a88804120$var$read16BitHexCode(body, position + 8);
            if ($7c9a258a88804120$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $7c9a258a88804120$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $7c9a258a88804120$var$readHexDigit(body.charCodeAt(position)) << 12 | $7c9a258a88804120$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $7c9a258a88804120$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $7c9a258a88804120$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $7c9a258a88804120$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $7c9a258a88804120$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '"',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: "\\",
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: "/",
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: "\b",
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: "\f",
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: "\n",
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: "\r",
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: "	",
                size: 2
            };
    }
    throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $7c9a258a88804120$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = "";
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, (0, $4dcd914c56cc3651$export$d5ee19b441e8d2ae)(blockLines).join("\n"));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = "";
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($7c9a258a88804120$var$isUnicodeScalarValue(code)) ++position;
        else if ($7c9a258a88804120$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$7c9a258a88804120$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, "Unterminated string.");
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */ function $7c9a258a88804120$var$readName(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $ebe4940248925047$export$d3f406ff46035894)(code)) ++position;
        else break;
    }
    return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME, start, position, body.slice(start, position));
}


function $689afe97a6658f18$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


const $5a5c92f504a86580$var$MAX_ARRAY_LENGTH = 10;
const $5a5c92f504a86580$var$MAX_RECURSIVE_DEPTH = 2;
function $5a5c92f504a86580$export$9dec5d1b3b6a130d(value) {
    return $5a5c92f504a86580$var$formatValue(value, []);
}
function $5a5c92f504a86580$var$formatValue(value, seenValues) {
    switch(typeof value){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? `[function ${value.name}]` : "[function]";
        case "object":
            return $5a5c92f504a86580$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $5a5c92f504a86580$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return "null";
    if (previouslySeenValues.includes(value)) return "[Circular]";
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($5a5c92f504a86580$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === "string" ? jsonValue : $5a5c92f504a86580$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $5a5c92f504a86580$var$formatArray(value, seenValues);
    return $5a5c92f504a86580$var$formatObject(value, seenValues);
}
function $5a5c92f504a86580$var$isJSONable(value) {
    return typeof value.toJSON === "function";
}
function $5a5c92f504a86580$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return "{}";
    if (seenValues.length > $5a5c92f504a86580$var$MAX_RECURSIVE_DEPTH) return "[" + $5a5c92f504a86580$var$getObjectTag(object) + "]";
    const properties = entries.map(([key, value])=>key + ": " + $5a5c92f504a86580$var$formatValue(value, seenValues));
    return "{ " + properties.join(", ") + " }";
}
function $5a5c92f504a86580$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $5a5c92f504a86580$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    const len = Math.min($5a5c92f504a86580$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($5a5c92f504a86580$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return "[" + items.join(", ") + "]";
}
function $5a5c92f504a86580$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        const name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}



const $f3806e602269e159$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === "object" && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $5a5c92f504a86580$export$9dec5d1b3b6a130d)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};


class $606ad5282415c685$export$1d2df86270c81ecb {
    constructor(body, name = "GraphQL request", locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === "string" || (0, $689afe97a6658f18$export$b6cb5906f04696c8)(false, `Body must be a string. Received: ${(0, $5a5c92f504a86580$export$9dec5d1b3b6a130d)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $689afe97a6658f18$export$b6cb5906f04696c8)(false, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, $689afe97a6658f18$export$b6cb5906f04696c8)(false, "column in locationOffset is 1-indexed and must be positive.");
    }
    get [Symbol.toStringTag]() {
        return "Source";
    }
}
function $606ad5282415c685$export$75135ee9ed6e435b(source) {
    return (0, $f3806e602269e159$export$ca03416d6c9e029e)(source, $606ad5282415c685$export$1d2df86270c81ecb);
}



function $b37fb2fe3b4f0cfc$export$98e6a39c04603d36(source, options) {
    const parser = new $b37fb2fe3b4f0cfc$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $b37fb2fe3b4f0cfc$export$5303528d1070ff6f(source, options) {
    const parser = new $b37fb2fe3b4f0cfc$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).EOF);
    return value;
}
function $b37fb2fe3b4f0cfc$export$e14c466bd0916f7a(source, options) {
    const parser = new $b37fb2fe3b4f0cfc$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).EOF);
    return value;
}
function $b37fb2fe3b4f0cfc$export$28b8f402ccc88182(source, options) {
    const parser = new $b37fb2fe3b4f0cfc$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).EOF);
    return type;
}
class $b37fb2fe3b4f0cfc$export$7acfa6ed01010e37 {
    constructor(source, options = {}){
        const sourceObj = (0, $606ad5282415c685$export$75135ee9ed6e435b)(source) ? source : new (0, $606ad5282415c685$export$1d2df86270c81ecb)(source);
        this._lexer = new (0, $7c9a258a88804120$export$6168dc8908a6c652)(sourceObj);
        this._options = options;
        this._tokenCounter = 0;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME);
        return this.node(token, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $9a9b48308b55bec1$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME) {
            switch(keywordToken.value){
                case "schema":
                    return this.parseSchemaDefinition();
                case "scalar":
                    return this.parseScalarTypeDefinition();
                case "type":
                    return this.parseObjectTypeDefinition();
                case "interface":
                    return this.parseInterfaceTypeDefinition();
                case "union":
                    return this.parseUnionTypeDefinition();
                case "enum":
                    return this.parseEnumTypeDefinition();
                case "input":
                    return this.parseInputObjectTypeDefinition();
                case "directive":
                    return this.parseDirectiveDefinition();
            }
            if (hasDescription) throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, "Unexpected description, descriptions are supported only on type definitions.");
            switch(keywordToken.value){
                case "query":
                case "mutation":
                case "subscription":
                    return this.parseOperationDefinition();
                case "fragment":
                    return this.parseFragmentDefinition();
                case "extend":
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L)) return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: (0, $d9046b8c989e4522$export$f58c50edb4aef9d4).QUERY,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case "query":
                return (0, $d9046b8c989e4522$export$f58c50edb4aef9d4).QUERY;
            case "mutation":
                return (0, $d9046b8c989e4522$export$f58c50edb4aef9d4).MUTATION;
            case "subscription":
                return (0, $d9046b8c989e4522$export$f58c50edb4aef9d4).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).DOLLAR);
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, $9a9b48308b55bec1$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_L, item, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek((0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME)) return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        this.expectKeyword("fragment"); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === "on") throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $9a9b48308b55bec1$export$8b9d26ab11394711).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).INT,
                    value: token.value
                });
            case (0, $9a9b48308b55bec1$export$8b9d26ab11394711).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).FLOAT,
                    value: token.value
                });
            case (0, $9a9b48308b55bec1$export$8b9d26ab11394711).STRING:
            case (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME:
                this.advanceLexer();
                switch(token.value){
                    case "true":
                        return this.node(token, {
                            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).BOOLEAN,
                            value: true
                        });
                    case "false":
                        return this.node(token, {
                            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).BOOLEAN,
                            value: false
                        });
                    case "null":
                        return this.node(token, {
                            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).ENUM,
                            value: token.value
                        });
                }
            case (0, $9a9b48308b55bec1$export$8b9d26ab11394711).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).DOLLAR);
                    if (this._lexer.token.kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).LIST,
            values: this.any((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACKET_L, item, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L, item, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $9a9b48308b55bec1$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).AT);
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACKET_R);
            type = this.node(start, {
                kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BANG)) return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, $9a9b48308b55bec1$export$8b9d26ab11394711).STRING) || this.peek((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_R);
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword("implements") ? this.delimitedMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null") throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, `${$b37fb2fe3b4f0cfc$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaExtension();
            case "scalar":
                return this.parseScalarTypeExtension();
            case "type":
                return this.parseObjectTypeExtension();
            case "interface":
                return this.parseInterfaceTypeExtension();
            case "union":
                return this.parseUnionTypeExtension();
            case "enum":
                return this.parseEnumTypeExtension();
            case "input":
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $f9d53977918cb7ab$export$b45ffd2948484c41), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $d9046b8c989e4522$export$18a2be9195644f38)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected ${$b37fb2fe3b4f0cfc$var$getTokenKindDesc(kind)}, found ${$b37fb2fe3b4f0cfc$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME && token.value === value) this.advanceLexer();
        else throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected "${value}", found ${$b37fb2fe3b4f0cfc$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected ${$b37fb2fe3b4f0cfc$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (maxTokens !== undefined && token.kind !== (0, $9a9b48308b55bec1$export$8b9d26ab11394711).EOF) {
            ++this._tokenCounter;
            if (this._tokenCounter > maxTokens) throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function $b37fb2fe3b4f0cfc$var$getTokenDesc(token) {
    const value = token.value;
    return $b37fb2fe3b4f0cfc$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : "");
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $b37fb2fe3b4f0cfc$var$getTokenKindDesc(kind) {
    return (0, $7c9a258a88804120$export$59ac0f4da287406a)(kind) ? `"${kind}"` : kind;
}


/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $1c10e15c8a3a4a77$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($1c10e15c8a3a4a77$var$escapedRegExp, $1c10e15c8a3a4a77$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $1c10e15c8a3a4a77$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $1c10e15c8a3a4a77$var$escapedReplacer(str) {
    return $1c10e15c8a3a4a77$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $1c10e15c8a3a4a77$var$escapeSequences = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000B",
    "\\f",
    "\\r",
    "\\u000E",
    "\\u000F",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001A",
    "\\u001B",
    "\\u001C",
    "\\u001D",
    "\\u001E",
    "\\u001F",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\u007F",
    "\\u0080",
    "\\u0081",
    "\\u0082",
    "\\u0083",
    "\\u0084",
    "\\u0085",
    "\\u0086",
    "\\u0087",
    "\\u0088",
    "\\u0089",
    "\\u008A",
    "\\u008B",
    "\\u008C",
    "\\u008D",
    "\\u008E",
    "\\u008F",
    "\\u0090",
    "\\u0091",
    "\\u0092",
    "\\u0093",
    "\\u0094",
    "\\u0095",
    "\\u0096",
    "\\u0097",
    "\\u0098",
    "\\u0099",
    "\\u009A",
    "\\u009B",
    "\\u009C",
    "\\u009D",
    "\\u009E",
    "\\u009F"
];






const $059788b5609f37ed$export$a89c95c098ac2a58 = Object.freeze({});
function $059788b5609f37ed$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $d9046b8c989e4522$export$4fcd777a40ccf407)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $d60c070bf0c85158$export$a84bdc57c5122798)))enterLeaveMap.set(kind, $059788b5609f37ed$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $d9046b8c989e4522$export$8ee0fc9ee280b4ee)(node) || (0, $689afe97a6658f18$export$b6cb5906f04696c8)(false, `Invalid AST Node: ${(0, $5a5c92f504a86580$export$9dec5d1b3b6a130d)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $059788b5609f37ed$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $d9046b8c989e4522$export$8ee0fc9ee280b4ee)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $059788b5609f37ed$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $d60c070bf0c85158$export$a84bdc57c5122798))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $059788b5609f37ed$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $059788b5609f37ed$export$a89c95c098ac2a58) skipping[i] = $059788b5609f37ed$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $059788b5609f37ed$export$a89c95c098ac2a58) skipping[i] = $059788b5609f37ed$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $059788b5609f37ed$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === "object") // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === "function") // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $059788b5609f37ed$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $059788b5609f37ed$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}


function $51a1e65338c15420$export$c2d084dc44961371(ast) {
    return (0, $059788b5609f37ed$export$bf638b60ea8b89b7)(ast, $51a1e65338c15420$var$printDocASTReducer);
}
const $51a1e65338c15420$var$MAX_LINE_LENGTH = 80;
const $51a1e65338c15420$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>"$" + node.name
    },
    // Document
    Document: {
        leave: (node)=>$51a1e65338c15420$var$join(node.definitions, "\n\n")
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $51a1e65338c15420$var$wrap("(", $51a1e65338c15420$var$join(node.variableDefinitions, ", "), ")");
            const prefix = $51a1e65338c15420$var$join([
                node.operation,
                $51a1e65338c15420$var$join([
                    node.name,
                    varDefs
                ]),
                $51a1e65338c15420$var$join(node.directives, " ")
            ], " "); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === "query" ? "" : prefix + " ") + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ": " + type + $51a1e65338c15420$var$wrap(" = ", defaultValue) + $51a1e65338c15420$var$wrap(" ", $51a1e65338c15420$var$join(directives, " "))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$51a1e65338c15420$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $51a1e65338c15420$var$wrap("", alias, ": ") + name;
            let argsLine = prefix + $51a1e65338c15420$var$wrap("(", $51a1e65338c15420$var$join(args, ", "), ")");
            if (argsLine.length > $51a1e65338c15420$var$MAX_LINE_LENGTH) argsLine = prefix + $51a1e65338c15420$var$wrap("(\n", $51a1e65338c15420$var$indent($51a1e65338c15420$var$join(args, "\n")), "\n)");
            return $51a1e65338c15420$var$join([
                argsLine,
                $51a1e65338c15420$var$join(directives, " "),
                selectionSet
            ], " ");
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>"..." + name + $51a1e65338c15420$var$wrap(" ", $51a1e65338c15420$var$join(directives, " "))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$51a1e65338c15420$var$join([
                "...",
                $51a1e65338c15420$var$wrap("on ", typeCondition),
                $51a1e65338c15420$var$join(directives, " "),
                selectionSet
            ], " ")
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$51a1e65338c15420$var$wrap("(", $51a1e65338c15420$var$join(variableDefinitions, ", "), ")")} ` + `on ${typeCondition} ${$51a1e65338c15420$var$wrap("", $51a1e65338c15420$var$join(directives, " "), " ")}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $4dcd914c56cc3651$export$adb6ca997eeb1f45)(value) : (0, $1c10e15c8a3a4a77$export$3cdec7cf614a0ecc)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? "true" : "false"
    },
    NullValue: {
        leave: ()=>"null"
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>"[" + $51a1e65338c15420$var$join(values, ", ") + "]"
    },
    ObjectValue: {
        leave: ({ fields: fields })=>"{" + $51a1e65338c15420$var$join(fields, ", ") + "}"
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>"@" + name + $51a1e65338c15420$var$wrap("(", $51a1e65338c15420$var$join(args, ", "), ")")
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>"[" + type + "]"
    },
    NonNullType: {
        leave: ({ type: type })=>type + "!"
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$51a1e65338c15420$var$wrap("", description, "\n") + $51a1e65338c15420$var$join([
                "schema",
                $51a1e65338c15420$var$join(directives, " "),
                $51a1e65338c15420$var$block(operationTypes)
            ], " ")
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ": " + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$51a1e65338c15420$var$wrap("", description, "\n") + $51a1e65338c15420$var$join([
                "scalar",
                name,
                $51a1e65338c15420$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$51a1e65338c15420$var$wrap("", description, "\n") + $51a1e65338c15420$var$join([
                "type",
                name,
                $51a1e65338c15420$var$wrap("implements ", $51a1e65338c15420$var$join(interfaces, " & ")),
                $51a1e65338c15420$var$join(directives, " "),
                $51a1e65338c15420$var$block(fields)
            ], " ")
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$51a1e65338c15420$var$wrap("", description, "\n") + name + ($51a1e65338c15420$var$hasMultilineItems(args) ? $51a1e65338c15420$var$wrap("(\n", $51a1e65338c15420$var$indent($51a1e65338c15420$var$join(args, "\n")), "\n)") : $51a1e65338c15420$var$wrap("(", $51a1e65338c15420$var$join(args, ", "), ")")) + ": " + type + $51a1e65338c15420$var$wrap(" ", $51a1e65338c15420$var$join(directives, " "))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$51a1e65338c15420$var$wrap("", description, "\n") + $51a1e65338c15420$var$join([
                name + ": " + type,
                $51a1e65338c15420$var$wrap("= ", defaultValue),
                $51a1e65338c15420$var$join(directives, " ")
            ], " ")
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$51a1e65338c15420$var$wrap("", description, "\n") + $51a1e65338c15420$var$join([
                "interface",
                name,
                $51a1e65338c15420$var$wrap("implements ", $51a1e65338c15420$var$join(interfaces, " & ")),
                $51a1e65338c15420$var$join(directives, " "),
                $51a1e65338c15420$var$block(fields)
            ], " ")
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$51a1e65338c15420$var$wrap("", description, "\n") + $51a1e65338c15420$var$join([
                "union",
                name,
                $51a1e65338c15420$var$join(directives, " "),
                $51a1e65338c15420$var$wrap("= ", $51a1e65338c15420$var$join(types, " | "))
            ], " ")
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$51a1e65338c15420$var$wrap("", description, "\n") + $51a1e65338c15420$var$join([
                "enum",
                name,
                $51a1e65338c15420$var$join(directives, " "),
                $51a1e65338c15420$var$block(values)
            ], " ")
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$51a1e65338c15420$var$wrap("", description, "\n") + $51a1e65338c15420$var$join([
                name,
                $51a1e65338c15420$var$join(directives, " ")
            ], " ")
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$51a1e65338c15420$var$wrap("", description, "\n") + $51a1e65338c15420$var$join([
                "input",
                name,
                $51a1e65338c15420$var$join(directives, " "),
                $51a1e65338c15420$var$block(fields)
            ], " ")
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$51a1e65338c15420$var$wrap("", description, "\n") + "directive @" + name + ($51a1e65338c15420$var$hasMultilineItems(args) ? $51a1e65338c15420$var$wrap("(\n", $51a1e65338c15420$var$indent($51a1e65338c15420$var$join(args, "\n")), "\n)") : $51a1e65338c15420$var$wrap("(", $51a1e65338c15420$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $51a1e65338c15420$var$join(locations, " | ")
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$51a1e65338c15420$var$join([
                "extend schema",
                $51a1e65338c15420$var$join(directives, " "),
                $51a1e65338c15420$var$block(operationTypes)
            ], " ")
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$51a1e65338c15420$var$join([
                "extend scalar",
                name,
                $51a1e65338c15420$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$51a1e65338c15420$var$join([
                "extend type",
                name,
                $51a1e65338c15420$var$wrap("implements ", $51a1e65338c15420$var$join(interfaces, " & ")),
                $51a1e65338c15420$var$join(directives, " "),
                $51a1e65338c15420$var$block(fields)
            ], " ")
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$51a1e65338c15420$var$join([
                "extend interface",
                name,
                $51a1e65338c15420$var$wrap("implements ", $51a1e65338c15420$var$join(interfaces, " & ")),
                $51a1e65338c15420$var$join(directives, " "),
                $51a1e65338c15420$var$block(fields)
            ], " ")
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$51a1e65338c15420$var$join([
                "extend union",
                name,
                $51a1e65338c15420$var$join(directives, " "),
                $51a1e65338c15420$var$wrap("= ", $51a1e65338c15420$var$join(types, " | "))
            ], " ")
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$51a1e65338c15420$var$join([
                "extend enum",
                name,
                $51a1e65338c15420$var$join(directives, " "),
                $51a1e65338c15420$var$block(values)
            ], " ")
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$51a1e65338c15420$var$join([
                "extend input",
                name,
                $51a1e65338c15420$var$join(directives, " "),
                $51a1e65338c15420$var$block(fields)
            ], " ")
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $51a1e65338c15420$var$join(maybeArray, separator = "") {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $51a1e65338c15420$var$block(array) {
    return $51a1e65338c15420$var$wrap("{\n", $51a1e65338c15420$var$indent($51a1e65338c15420$var$join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $51a1e65338c15420$var$wrap(start, maybeString, end = "") {
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function $51a1e65338c15420$var$indent(str) {
    return $51a1e65338c15420$var$wrap("  ", str.replace(/\n/g, "\n  "));
}
function $51a1e65338c15420$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes("\n"))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}


/**
 * helpers
 */ const $28880f85c8a42137$var$extractOperationName = (document)=>{
    let operationName = undefined;
    const operationDefinitions = document.definitions.filter((definition)=>definition.kind === `OperationDefinition`);
    if (operationDefinitions.length === 1) operationName = operationDefinitions[0]?.name?.value;
    return operationName;
};
const $28880f85c8a42137$var$resolveRequestDocument = (document)=>{
    if (typeof document === `string`) {
        let operationName = undefined;
        try {
            const parsedDocument = (0, $b37fb2fe3b4f0cfc$export$98e6a39c04603d36)(document);
            operationName = $28880f85c8a42137$var$extractOperationName(parsedDocument);
        } catch (err) {
        // Failed parsing the document, the operationName will be undefined
        }
        return {
            query: document,
            operationName: operationName
        };
    }
    const operationName = $28880f85c8a42137$var$extractOperationName(document);
    return {
        query: (0, $51a1e65338c15420$export$c2d084dc44961371)(document),
        operationName: operationName
    };
};
$28880f85c8a42137$exports.resolveRequestDocument = $28880f85c8a42137$var$resolveRequestDocument;


var $5d0956dd4df4ae1f$exports = {};
"use strict";
Object.defineProperty($5d0956dd4df4ae1f$exports, "__esModule", {
    value: true
});
$5d0956dd4df4ae1f$exports.ClientError = void 0;
class $5d0956dd4df4ae1f$var$ClientError extends Error {
    constructor(response, request){
        const message = `${$5d0956dd4df4ae1f$var$ClientError.extractMessage(response)}: ${JSON.stringify({
            response: response,
            request: request
        })}`;
        super(message);
        Object.setPrototypeOf(this, $5d0956dd4df4ae1f$var$ClientError.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) Error.captureStackTrace(this, $5d0956dd4df4ae1f$var$ClientError);
    }
    static extractMessage(response) {
        return response.errors?.[0]?.message ?? `GraphQL Error (Code: ${response.status})`;
    }
}
$5d0956dd4df4ae1f$exports.ClientError = $5d0956dd4df4ae1f$var$ClientError;


Object.defineProperty($749779f5335cf90b$exports, "ClientError", {
    enumerable: true,
    get: function() {
        return $5d0956dd4df4ae1f$exports.ClientError;
    }
});

const $749779f5335cf90b$var$cross_fetch_1 = $749779f5335cf90b$var$__importStar((parcelRequire("a141p"))), $749779f5335cf90b$var$CrossFetch = $749779f5335cf90b$var$cross_fetch_1;
/**
 * Convert the given headers configuration into a plain object.
 */ const $749779f5335cf90b$var$resolveHeaders = (headers)=>{
    let oHeaders = {};
    if (headers) {
        if (typeof Headers !== `undefined` && headers instanceof Headers || $749779f5335cf90b$var$CrossFetch && $749779f5335cf90b$var$CrossFetch.Headers && headers instanceof $749779f5335cf90b$var$CrossFetch.Headers) oHeaders = (0, $5adad46b3f5b0a29$exports.HeadersInstanceToPlainObject)(headers);
        else if (Array.isArray(headers)) headers.forEach(([name, value])=>{
            if (name && value !== undefined) oHeaders[name] = value;
        });
        else oHeaders = headers;
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 */ const $749779f5335cf90b$var$cleanQuery = (str)=>str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
/**
 * Create query string for GraphQL request
 */ const $749779f5335cf90b$var$buildRequestConfig = (params)=>{
    if (!Array.isArray(params.query)) {
        const params_ = params;
        const search = [
            `query=${encodeURIComponent($749779f5335cf90b$var$cleanQuery(params_.query))}`
        ];
        if (params.variables) search.push(`variables=${encodeURIComponent(params_.jsonSerializer.stringify(params_.variables))}`);
        if (params_.operationName) search.push(`operationName=${encodeURIComponent(params_.operationName)}`);
        return search.join(`&`);
    }
    if (typeof params.variables !== `undefined` && !Array.isArray(params.variables)) throw new Error(`Cannot create query with given variable type, array expected`);
    // Batch support
    const params_ = params;
    const payload = params.query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: $749779f5335cf90b$var$cleanQuery(currentQuery),
            variables: params_.variables ? params_.jsonSerializer.stringify(params_.variables[index]) : undefined
        });
        return acc;
    }, []);
    return `query=${encodeURIComponent(params_.jsonSerializer.stringify(payload))}`;
};
const $749779f5335cf90b$var$createHttpMethodFetcher = (method)=>async (params)=>{
        const { url: url, query: query, variables: variables, operationName: operationName, fetch: fetch, fetchOptions: fetchOptions, middleware: middleware } = params;
        const headers = {
            ...params.headers
        };
        let queryParams = ``;
        let body = undefined;
        if (method === `POST`) {
            body = $749779f5335cf90b$var$createRequestBody(query, variables, operationName, fetchOptions.jsonSerializer);
            if (typeof body === `string`) // @ts-expect-error todo
            headers[`Content-Type`] = `application/json`;
        } else // @ts-expect-error todo needs ADT for TS to understand the different states
        queryParams = $749779f5335cf90b$var$buildRequestConfig({
            query: query,
            variables: variables,
            operationName: operationName,
            jsonSerializer: fetchOptions.jsonSerializer ?? $82d862471288a54b$exports.defaultJsonSerializer
        });
        const init = {
            method: method,
            headers: headers,
            body: body,
            ...fetchOptions
        };
        let urlResolved = url;
        let initResolved = init;
        if (middleware) {
            const result = await Promise.resolve(middleware({
                ...init,
                url: url,
                operationName: operationName,
                variables: variables
            }));
            const { url: urlNew, ...initNew } = result;
            urlResolved = urlNew;
            initResolved = initNew;
        }
        if (queryParams) urlResolved = `${urlResolved}?${queryParams}`;
        return await fetch(urlResolved, initResolved);
    };
/**
 * GraphQL Client.
 */ class $749779f5335cf90b$var$GraphQLClient {
    constructor(url, requestConfig = {}){
        this.url = url;
        this.requestConfig = requestConfig;
        /**
         * Send a GraphQL query to the server.
         */ this.rawRequest = async (...args)=>{
            const [queryOrOptions, variables, requestHeaders] = args;
            const rawRequestOptions = (0, $5daee54a55c14e05$exports.parseRawRequestArgs)(queryOrOptions, variables, requestHeaders);
            const { headers: headers, fetch: fetch = $749779f5335cf90b$var$cross_fetch_1.default, method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
            const { url: url } = this;
            if (rawRequestOptions.signal !== undefined) fetchOptions.signal = rawRequestOptions.signal;
            const { operationName: operationName } = (0, $28880f85c8a42137$exports.resolveRequestDocument)(rawRequestOptions.query);
            return $749779f5335cf90b$var$makeRequest({
                url: url,
                query: rawRequestOptions.query,
                variables: rawRequestOptions.variables,
                headers: {
                    ...$749779f5335cf90b$var$resolveHeaders($749779f5335cf90b$var$callOrIdentity(headers)),
                    ...$749779f5335cf90b$var$resolveHeaders(rawRequestOptions.requestHeaders)
                },
                operationName: operationName,
                fetch: fetch,
                method: method,
                fetchOptions: fetchOptions,
                middleware: requestMiddleware
            }).then((response)=>{
                if (responseMiddleware) responseMiddleware(response);
                return response;
            }).catch((error)=>{
                if (responseMiddleware) responseMiddleware(error);
                throw error;
            });
        };
    }
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = (0, $5daee54a55c14e05$exports.parseRequestArgs)(documentOrOptions, variables, requestHeaders);
        const { headers: headers, fetch: fetch = $749779f5335cf90b$var$cross_fetch_1.default, method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
        const { url: url } = this;
        if (requestOptions.signal !== undefined) fetchOptions.signal = requestOptions.signal;
        const { query: query, operationName: operationName } = (0, $28880f85c8a42137$exports.resolveRequestDocument)(requestOptions.document);
        return $749779f5335cf90b$var$makeRequest({
            url: url,
            query: query,
            variables: requestOptions.variables,
            headers: {
                ...$749779f5335cf90b$var$resolveHeaders($749779f5335cf90b$var$callOrIdentity(headers)),
                ...$749779f5335cf90b$var$resolveHeaders(requestOptions.requestHeaders)
            },
            operationName: operationName,
            fetch: fetch,
            method: method,
            fetchOptions: fetchOptions,
            middleware: requestMiddleware
        }).then((response)=>{
            if (responseMiddleware) responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (responseMiddleware) responseMiddleware(error);
            throw error;
        });
    }
    // prettier-ignore
    batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = (0, $5daee54a55c14e05$exports.parseBatchRequestArgs)(documentsOrOptions, requestHeaders);
        const { headers: headers, ...fetchOptions } = this.requestConfig;
        if (batchRequestOptions.signal !== undefined) fetchOptions.signal = batchRequestOptions.signal;
        const queries = batchRequestOptions.documents.map(({ document: document })=>(0, $28880f85c8a42137$exports.resolveRequestDocument)(document).query);
        const variables = batchRequestOptions.documents.map(({ variables: variables })=>variables);
        return $749779f5335cf90b$var$makeRequest({
            url: this.url,
            query: queries,
            variables: // @ts-expect-error TODO reconcile batch variables into system.
            variables,
            headers: {
                ...$749779f5335cf90b$var$resolveHeaders($749779f5335cf90b$var$callOrIdentity(headers)),
                ...$749779f5335cf90b$var$resolveHeaders(batchRequestOptions.requestHeaders)
            },
            operationName: undefined,
            fetch: this.requestConfig.fetch ?? $749779f5335cf90b$var$cross_fetch_1.default,
            method: this.requestConfig.method || `POST`,
            fetchOptions: fetchOptions,
            middleware: this.requestConfig.requestMiddleware
        }).then((response)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(error);
            throw error;
        });
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */ setHeader(key, value) {
        const { headers: headers } = this.requestConfig;
        if (headers) // todo what if headers is in nested array form... ?
        //@ts-expect-error todo
        headers[key] = value;
        else this.requestConfig.headers = {
            [key]: value
        };
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */ setEndpoint(value) {
        this.url = value;
        return this;
    }
}
$749779f5335cf90b$exports.GraphQLClient = $749779f5335cf90b$var$GraphQLClient;
const $749779f5335cf90b$var$makeRequest = async (params)=>{
    const { query: query, variables: variables, fetchOptions: fetchOptions } = params;
    const fetcher = $749779f5335cf90b$var$createHttpMethodFetcher((0, $5adad46b3f5b0a29$exports.uppercase)(params.method ?? `post`));
    const isBatchingQuery = Array.isArray(params.query);
    const response = await fetcher(params);
    const result = await $749779f5335cf90b$var$getResult(response, fetchOptions.jsonSerializer ?? $82d862471288a54b$exports.defaultJsonSerializer);
    const successfullyReceivedData = Array.isArray(result) ? !result.some(({ data: data })=>!data) : Boolean(result.data);
    const successfullyPassedErrorPolicy = Array.isArray(result) || !result.errors || Array.isArray(result.errors) && !result.errors.length || fetchOptions.errorPolicy === `all` || fetchOptions.errorPolicy === `ignore`;
    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
        // @ts-expect-error TODO fixme
        const { errors: _, ...rest } = Array.isArray(result) ? result : result;
        const data = fetchOptions.errorPolicy === `ignore` ? rest : result;
        const dataEnvelope = isBatchingQuery ? {
            data: data
        } : data;
        // @ts-expect-error TODO
        return {
            ...dataEnvelope,
            headers: response.headers,
            status: response.status
        };
    } else {
        const errorResult = typeof result === `string` ? {
            error: result
        } : result;
        throw new $5d0956dd4df4ae1f$exports.ClientError(// @ts-expect-error TODO
        {
            ...errorResult,
            status: response.status,
            headers: response.headers
        }, {
            query: query,
            variables: variables
        });
    }
};
/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */ const $749779f5335cf90b$var$rawRequest = async (...args)=>{
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = (0, $5daee54a55c14e05$exports.parseRawRequestExtendedArgs)(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new $749779f5335cf90b$var$GraphQLClient(requestOptions.url);
    return client.rawRequest({
        ...requestOptions
    });
};
$749779f5335cf90b$exports.rawRequest = $749779f5335cf90b$var$rawRequest;
// prettier-ignore
// eslint-disable-next-line
async function $749779f5335cf90b$var$request(urlOrOptions, document, ...variablesAndRequestHeaders) {
    const requestOptions = (0, $5daee54a55c14e05$exports.parseRequestExtendedArgs)(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new $749779f5335cf90b$var$GraphQLClient(requestOptions.url);
    return client.request({
        ...requestOptions
    });
}
$749779f5335cf90b$exports.request = $749779f5335cf90b$var$request;
/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */ const $749779f5335cf90b$var$batchRequests = async (...args)=>{
    const params = $749779f5335cf90b$var$parseBatchRequestsArgsExtended(args);
    const client = new $749779f5335cf90b$var$GraphQLClient(params.url);
    return client.batchRequests(params);
};
$749779f5335cf90b$exports.batchRequests = $749779f5335cf90b$var$batchRequests;
const $749779f5335cf90b$var$parseBatchRequestsArgsExtended = (args)=>{
    if (args.length === 1) return args[0];
    else return {
        url: args[0],
        documents: args[1],
        requestHeaders: args[2],
        signal: undefined
    };
};
const $749779f5335cf90b$var$createRequestBody = (query, variables, operationName, jsonSerializer)=>{
    const jsonSerializer_ = jsonSerializer ?? $82d862471288a54b$exports.defaultJsonSerializer;
    if (!Array.isArray(query)) return jsonSerializer_.stringify({
        query: query,
        variables: variables,
        operationName: operationName
    });
    if (typeof variables !== `undefined` && !Array.isArray(variables)) throw new Error(`Cannot create request body with given variable type, array expected`);
    // Batch support
    const payload = query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: currentQuery,
            variables: variables ? variables[index] : undefined
        });
        return acc;
    }, []);
    return jsonSerializer_.stringify(payload);
};
const $749779f5335cf90b$var$getResult = async (response, jsonSerializer)=>{
    let contentType;
    response.headers.forEach((value, key)=>{
        if (key.toLowerCase() === `content-type`) contentType = value;
    });
    if (contentType && (contentType.toLowerCase().startsWith(`application/json`) || contentType.toLowerCase().startsWith(`application/graphql+json`) || contentType.toLowerCase().startsWith(`application/graphql-response+json`))) return jsonSerializer.parse(await response.text());
    else return response.text();
};
const $749779f5335cf90b$var$callOrIdentity = (value)=>{
    return typeof value === `function` ? value() : value;
};
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 * ```
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 * ```
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */ const $749779f5335cf90b$var$gql = (chunks, ...variables)=>{
    return chunks.reduce((acc, chunk, index)=>`${acc}${chunk}${index in variables ? String(variables[index]) : ``}`, ``);
};
$749779f5335cf90b$exports.gql = $749779f5335cf90b$var$gql;
var $b76a6b00e0fbcee9$exports = {};
"use strict";
Object.defineProperty($b76a6b00e0fbcee9$exports, "__esModule", {
    value: true
});
$b76a6b00e0fbcee9$exports.GraphQLWebSocketClient = void 0;


// import type WebSocket from 'ws'
const $b76a6b00e0fbcee9$var$CONNECTION_INIT = `connection_init`;
const $b76a6b00e0fbcee9$var$CONNECTION_ACK = `connection_ack`;
const $b76a6b00e0fbcee9$var$PING = `ping`;
const $b76a6b00e0fbcee9$var$PONG = `pong`;
const $b76a6b00e0fbcee9$var$SUBSCRIBE = `subscribe`;
const $b76a6b00e0fbcee9$var$NEXT = `next`;
const $b76a6b00e0fbcee9$var$ERROR = `error`;
const $b76a6b00e0fbcee9$var$COMPLETE = `complete`;
class $b76a6b00e0fbcee9$var$GraphQLWebSocketMessage {
    get type() {
        return this._type;
    }
    get id() {
        return this._id;
    }
    get payload() {
        return this._payload;
    }
    constructor(type, payload, id){
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
    get text() {
        const result = {
            type: this.type
        };
        if (this.id != null && this.id != undefined) result.id = this.id;
        if (this.payload != null && this.payload != undefined) result.payload = this.payload;
        return JSON.stringify(result);
    }
    static parse(data, f) {
        const { type: type, payload: payload, id: id } = JSON.parse(data);
        return new $b76a6b00e0fbcee9$var$GraphQLWebSocketMessage(type, f(payload), id);
    }
}
class $b76a6b00e0fbcee9$var$GraphQLWebSocketClient {
    constructor(socket, { onInit: onInit, onAcknowledged: onAcknowledged, onPing: onPing, onPong: onPong }){
        this.socketState = {
            acknowledged: false,
            lastRequestId: 0,
            subscriptions: {}
        };
        this.socket = socket;
        socket.addEventListener(`open`, async (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
            socket.send($b76a6b00e0fbcee9$var$ConnectionInit(onInit ? await onInit() : null).text);
        });
        socket.addEventListener(`close`, (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
        });
        socket.addEventListener(`error`, (e)=>{
            console.error(e);
        });
        socket.addEventListener(`message`, (e)=>{
            try {
                const message = $b76a6b00e0fbcee9$var$parseMessage(e.data);
                switch(message.type){
                    case $b76a6b00e0fbcee9$var$CONNECTION_ACK:
                        if (this.socketState.acknowledged) console.warn(`Duplicate CONNECTION_ACK message ignored`);
                        else {
                            this.socketState.acknowledged = true;
                            if (onAcknowledged) onAcknowledged(message.payload);
                        }
                        return;
                    case $b76a6b00e0fbcee9$var$PING:
                        if (onPing) onPing(message.payload).then((r)=>socket.send($b76a6b00e0fbcee9$var$Pong(r).text));
                        else socket.send($b76a6b00e0fbcee9$var$Pong(null).text);
                        return;
                    case $b76a6b00e0fbcee9$var$PONG:
                        if (onPong) onPong(message.payload);
                        return;
                }
                if (!this.socketState.acknowledged) // Web-socket connection not acknowledged
                return;
                if (message.id === undefined || message.id === null || !this.socketState.subscriptions[message.id]) // No subscription identifer or subscription indentifier is not found
                return;
                const { query: query, variables: variables, subscriber: subscriber } = this.socketState.subscriptions[message.id];
                switch(message.type){
                    case $b76a6b00e0fbcee9$var$NEXT:
                        if (!message.payload.errors && message.payload.data) subscriber.next && subscriber.next(message.payload.data);
                        if (message.payload.errors) subscriber.error && subscriber.error(new $5d0956dd4df4ae1f$exports.ClientError({
                            ...message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $b76a6b00e0fbcee9$var$ERROR:
                        subscriber.error && subscriber.error(new $5d0956dd4df4ae1f$exports.ClientError({
                            errors: message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $b76a6b00e0fbcee9$var$COMPLETE:
                        subscriber.complete && subscriber.complete();
                        delete this.socketState.subscriptions[message.id];
                        return;
                }
            } catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, `Unknown graphql-ws message.`);
        });
    }
    makeSubscribe(query, operationName, subscriber, variables) {
        const subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = {
            query: query,
            variables: variables,
            subscriber: subscriber
        };
        this.socket.send($b76a6b00e0fbcee9$var$Subscribe(subscriptionId, {
            query: query,
            operationName: operationName,
            variables: variables
        }).text);
        return ()=>{
            this.socket.send($b76a6b00e0fbcee9$var$Complete(subscriptionId).text);
            delete this.socketState.subscriptions[subscriptionId];
        };
    }
    rawRequest(query, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.rawSubscribe(query, {
                next: (data, extensions)=>result = {
                        data: data,
                        extensions: extensions
                    },
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    request(document, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.subscribe(document, {
                next: (data)=>result = data,
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    subscribe(document, subscriber, variables) {
        const { query: query, operationName: operationName } = (0, $28880f85c8a42137$exports.resolveRequestDocument)(document);
        return this.makeSubscribe(query, operationName, subscriber, variables);
    }
    rawSubscribe(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    }
    ping(payload) {
        this.socket.send($b76a6b00e0fbcee9$var$Ping(payload).text);
    }
    close() {
        this.socket.close(1000);
    }
}
$b76a6b00e0fbcee9$var$GraphQLWebSocketClient.PROTOCOL = `graphql-transport-ws`;
$b76a6b00e0fbcee9$exports.GraphQLWebSocketClient = $b76a6b00e0fbcee9$var$GraphQLWebSocketClient;
// Helper functions
function $b76a6b00e0fbcee9$var$parseMessage(data, f = (a)=>a) {
    const m = $b76a6b00e0fbcee9$var$GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function $b76a6b00e0fbcee9$var$ConnectionInit(payload) {
    return new $b76a6b00e0fbcee9$var$GraphQLWebSocketMessage($b76a6b00e0fbcee9$var$CONNECTION_INIT, payload);
}
function $b76a6b00e0fbcee9$var$Ping(payload) {
    return new $b76a6b00e0fbcee9$var$GraphQLWebSocketMessage($b76a6b00e0fbcee9$var$PING, payload, undefined);
}
function $b76a6b00e0fbcee9$var$Pong(payload) {
    return new $b76a6b00e0fbcee9$var$GraphQLWebSocketMessage($b76a6b00e0fbcee9$var$PONG, payload, undefined);
}
function $b76a6b00e0fbcee9$var$Subscribe(id, payload) {
    return new $b76a6b00e0fbcee9$var$GraphQLWebSocketMessage($b76a6b00e0fbcee9$var$SUBSCRIBE, payload, id);
}
function $b76a6b00e0fbcee9$var$Complete(id) {
    return new $b76a6b00e0fbcee9$var$GraphQLWebSocketMessage($b76a6b00e0fbcee9$var$COMPLETE, undefined, id);
}


Object.defineProperty($749779f5335cf90b$exports, "GraphQLWebSocketClient", {
    enumerable: true,
    get: function() {
        return $b76a6b00e0fbcee9$exports.GraphQLWebSocketClient;
    }
});

Object.defineProperty($749779f5335cf90b$exports, "resolveRequestDocument", {
    enumerable: true,
    get: function() {
        return $28880f85c8a42137$exports.resolveRequestDocument;
    }
});
$749779f5335cf90b$exports.default = $749779f5335cf90b$var$request;


/**
 * Create a new Deffered
 *
 * @generic T - value of the deffered
 * @returns Deferred<T>
 */ const $18a8c276318e1bd8$export$b37aab7cecdd910a = ()=>{
    let resolve;
    let reject;
    const value = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    return {
        resolve: resolve,
        reject: reject,
        value: value
    };
};


/**
 * Create a batch manager for a given collection of a data type.
 * Will batch all .get calls given inside a scheduled time window into a singel request.
 *
 * @generic T - The type of the data.
 * @generic Q - item query type
 * @generic C - the context of the batcher passed to the fetcher function
 * @param config BatcherConfig<T, Q>
 * @returns Batcher<T, Q>
 */ const $219acb45e8919eaa$export$185802fd694ee1f5 = (config, memory)=>{
    const name = config.name ?? `batcher:${Math.random().toString(16).slice(2)})`;
    const scheduler = config.scheduler ?? $219acb45e8919eaa$export$8a8ab6d4dac9ddbd(10);
    const devtools = globalThis.__BATSHIT_DEVTOOLS__?.for(name);
    let mem = memory ?? {
        seq: 0,
        batch: new Set(),
        currentRequest: (0, $18a8c276318e1bd8$export$b37aab7cecdd910a)(),
        timer: undefined,
        start: null,
        latest: null
    };
    devtools?.create({
        seq: mem.seq
    });
    const nextBatch = ()=>{
        mem.batch = new Set();
        mem.currentRequest = (0, $18a8c276318e1bd8$export$b37aab7cecdd910a)();
        mem.timer = undefined;
        mem.start = null;
        mem.latest = null;
    };
    const fetch = (query)=>{
        if (!mem.start) mem.start = Date.now();
        mem.latest = Date.now();
        mem.batch.add(query);
        clearTimeout(mem.timer);
        const scheduled = scheduler(mem.start, mem.latest, mem.batch.size);
        devtools?.queue({
            seq: mem.seq,
            query: query,
            batch: [
                ...mem.batch
            ],
            scheduled: scheduled,
            latest: mem.latest,
            start: mem.start
        });
        const fetchBatch = ()=>{
            const currentSeq = mem.seq;
            const req = config.fetcher([
                ...mem.batch
            ]);
            const currentRequest = mem.currentRequest;
            devtools?.fetch({
                seq: currentSeq,
                batch: [
                    ...mem.batch
                ]
            });
            nextBatch();
            req.then((data)=>{
                devtools?.data({
                    seq: currentSeq,
                    data: data
                });
                currentRequest.resolve(data);
            }).catch((error)=>{
                devtools?.error({
                    seq: currentSeq,
                    error: error
                });
                currentRequest.reject(error);
            });
            mem.seq++;
            return req;
        };
        if (scheduled === "immediate") {
            const req = mem.currentRequest;
            fetchBatch();
            return req.value.then((items)=>config.resolver(items, query));
        } else if (scheduled === "never") return mem.currentRequest.value.then((items)=>config.resolver(items, query));
        else {
            mem.timer = setTimeout(fetchBatch, scheduled);
            return mem.currentRequest.value.then((items)=>config.resolver(items, query));
        }
    };
    return {
        fetch: fetch
    };
};
/**
 * Resolve by item field of items when response is an array.
 * Create a euquality check to check if the query matches a given key on the item data.
 *
 * @param key keyof T
 * @returns (item:T extends Array<A>, query: Q) => A
 */ const $219acb45e8919eaa$export$3cc90f807e36666d = (key)=>(items, query)=>items.find((item)=>item[key] == query);
/**
 * Resolve by record index when response is an object.
 * Create a euquality check to check if the query matches a given key on the item data.
 *
 * @returns (item:T extends Record<_, A>, query: Q) => A
 */ const $219acb45e8919eaa$export$ee3ee35fb4ea28ba = ()=>(itemsIndex, query)=>itemsIndex[query];
/**
 * Give a window in ms where all queued fetched made within the window will be batched into
 * one singler batch fetch call.
 *
 * @param ms number
 * @returns BatcherScheduler
 */ const $219acb45e8919eaa$export$8a8ab6d4dac9ddbd = (ms)=>(start, latest)=>{
        const spent = latest - start;
        return ms - spent;
    };
/**
 * Give a buffer time in ms. Will give another buffer window when queueing a fetch.
 *
 * @param ms number
 * @returns BatcherScheduler
 */ const $219acb45e8919eaa$export$72014dc9a1100d75 = (ms)=>()=>{
        return ms;
    };
/**
 * Same as windowScheduler, will batch calls made within a window of time OR when the max batch size is reached.
 *
 * @param config: {windowMs: number; maxBatchSize: number;}
 * @returns BatcherScheduler
 */ const $219acb45e8919eaa$export$c588696e674bc1bf = ({ windowMs: windowMs, maxBatchSize: maxBatchSize })=>(start, latest, batchSize)=>{
        if (batchSize >= maxBatchSize) return "immediate";
        const spent = latest - start;
        return windowMs - spent;
    };
/**
 * Will batch calls when the max batch size is reached.
 *
 * @param config: {maxBatchSize: number;}
 * @returns BatcherScheduler
 */ const $219acb45e8919eaa$export$28ce35332f632fd9 = ({ maxBatchSize: maxBatchSize })=>(_start, _latest, batchSize)=>{
        if (batchSize >= maxBatchSize) return "immediate";
        return "never";
    };



var $9nZCP = parcelRequire("9nZCP");
function $5c49ba72c59b8cdc$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $5c49ba72c59b8cdc$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $5c49ba72c59b8cdc$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $5c49ba72c59b8cdc$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $5c49ba72c59b8cdc$export$2e2bcd8739ae039 = $5c49ba72c59b8cdc$export$4f5d2d50c9deca37;


"use client";
const $73d46209e4d80851$var$u = (t)=>"number" == typeof t && !isNaN(t), $73d46209e4d80851$var$d = (t)=>"string" == typeof t, $73d46209e4d80851$var$p = (t)=>"function" == typeof t, $73d46209e4d80851$var$m = (t)=>$73d46209e4d80851$var$d(t) || $73d46209e4d80851$var$p(t) ? t : null, $73d46209e4d80851$var$f = (t)=>(0, $9nZCP.isValidElement)(t) || $73d46209e4d80851$var$d(t) || $73d46209e4d80851$var$p(t) || $73d46209e4d80851$var$u(t);
function $73d46209e4d80851$export$184cca501f1aed7f(t, e, n) {
    void 0 === n && (n = 300);
    const { scrollHeight: o, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = o + "px", s.transition = `all ${n}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(e, n);
        });
    });
}
function $73d46209e4d80851$export$3ff7dc44d332d222(e) {
    let { enter: a, exit: r, appendPosition: i = !1, collapse: l = !0, collapseDuration: c = 300 } = e;
    return function(e) {
        let { children: u, position: d, preventExitTransition: p, done: m, nodeRef: f, isIn: h } = e;
        const y = i ? `${a}--${d}` : a, v = i ? `${r}--${d}` : r, T = (0, $9nZCP.useRef)(0);
        return (0, $9nZCP.useLayoutEffect)(()=>{
            const t = f.current, e = y.split(" "), n = (o)=>{
                o.target === f.current && (t.dispatchEvent(new Event("d")), t.removeEventListener("animationend", n), t.removeEventListener("animationcancel", n), 0 === T.current && "animationcancel" !== o.type && t.classList.remove(...e));
            };
            t.classList.add(...e), t.addEventListener("animationend", n), t.addEventListener("animationcancel", n);
        }, []), (0, $9nZCP.useEffect)(()=>{
            const t = f.current, e = ()=>{
                t.removeEventListener("animationend", e), l ? $73d46209e4d80851$export$184cca501f1aed7f(t, m, c) : m();
            };
            h || (p ? e() : (T.current = 1, t.className += ` ${v}`, t.addEventListener("animationend", e)));
        }, [
            h
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).Fragment, null, u);
    };
}
function $73d46209e4d80851$var$y(t, e) {
    return null != t ? {
        content: t.content,
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        status: e
    } : {};
}
const $73d46209e4d80851$var$v = {
    list: new Map,
    emitQueue: new Map,
    on (t, e) {
        return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(e), this;
    },
    off (t, e) {
        if (e) {
            const n = this.list.get(t).filter((t)=>t !== e);
            return this.list.set(t, n), this;
        }
        return this.list.delete(t), this;
    },
    cancelEmit (t) {
        const e = this.emitQueue.get(t);
        return e && (e.forEach(clearTimeout), this.emitQueue.delete(t)), this;
    },
    emit (t) {
        this.list.has(t) && this.list.get(t).forEach((e)=>{
            const n = setTimeout(()=>{
                e(...[].slice.call(arguments, 1));
            }, 0);
            this.emitQueue.has(t) || this.emitQueue.set(t, []), this.emitQueue.get(t).push(n);
        });
    }
}, $73d46209e4d80851$var$T = (e)=>{
    let { theme: n, type: o, ...s } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: "colored" === n ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...s
    });
}, $73d46209e4d80851$export$4f13f83fd8bb1dac = {
    info: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement($73d46209e4d80851$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        }));
    },
    warning: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement($73d46209e4d80851$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("path", {
            d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        }));
    },
    success: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement($73d46209e4d80851$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        }));
    },
    error: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement($73d46209e4d80851$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("path", {
            d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        }));
    },
    spinner: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
            className: "Toastify__spinner"
        });
    }
};
function $73d46209e4d80851$export$b262e13ca2dd2381(t) {
    const [, o] = (0, $9nZCP.useReducer)((t)=>t + 1, 0), [l, c] = (0, $9nZCP.useState)([]), g = (0, $9nZCP.useRef)(null), h = (0, $9nZCP.useRef)(new Map).current, T = (t)=>-1 !== l.indexOf(t), C = (0, $9nZCP.useRef)({
        toastKey: 1,
        displayedToast: 0,
        count: 0,
        queue: [],
        props: t,
        containerId: null,
        isToastActive: T,
        getToast: (t)=>h.get(t)
    }).current;
    function b(t) {
        let { containerId: e } = t;
        const { limit: n } = C.props;
        !n || e && C.containerId !== e || (C.count -= C.queue.length, C.queue = []);
    }
    function I(t) {
        c((e)=>null == t ? [] : e.filter((e)=>e !== t));
    }
    function _() {
        const { toastContent: t, toastProps: e, staleId: n } = C.queue.shift();
        O(t, e, n);
    }
    function L(t, n) {
        let { delay: s, staleId: r, ...i } = n;
        if (!$73d46209e4d80851$var$f(t) || function(t) {
            return !g.current || C.props.enableMultiContainer && t.containerId !== C.props.containerId || h.has(t.toastId) && null == t.updateId;
        }(i)) return;
        const { toastId: l, updateId: c, data: T } = i, { props: b } = C, L = ()=>I(l), N = null == c;
        N && C.count++;
        const M = {
            ...b,
            style: b.toastStyle,
            key: C.toastKey++,
            ...Object.fromEntries(Object.entries(i).filter((t)=>{
                let [e, n] = t;
                return null != n;
            })),
            toastId: l,
            updateId: c,
            data: T,
            closeToast: L,
            isIn: !1,
            className: $73d46209e4d80851$var$m(i.className || b.toastClassName),
            bodyClassName: $73d46209e4d80851$var$m(i.bodyClassName || b.bodyClassName),
            progressClassName: $73d46209e4d80851$var$m(i.progressClassName || b.progressClassName),
            autoClose: !i.isLoading && (R = i.autoClose, w = b.autoClose, !1 === R || $73d46209e4d80851$var$u(R) && R > 0 ? R : w),
            deleteToast () {
                const t = $73d46209e4d80851$var$y(h.get(l), "removed");
                h.delete(l), $73d46209e4d80851$var$v.emit(4, t);
                const e = C.queue.length;
                if (C.count = null == l ? C.count - C.displayedToast : C.count - 1, C.count < 0 && (C.count = 0), e > 0) {
                    const t = null == l ? C.props.limit : 1;
                    if (1 === e || 1 === t) C.displayedToast++, _();
                    else {
                        const n = t > e ? e : t;
                        C.displayedToast = n;
                        for(let t = 0; t < n; t++)_();
                    }
                } else o();
            }
        };
        var R, w;
        M.iconOut = function(t) {
            let { theme: n, type: o, isLoading: s, icon: r } = t, i = null;
            const l = {
                theme: n,
                type: o
            };
            return !1 === r || ($73d46209e4d80851$var$p(r) ? i = r(l) : (0, $9nZCP.isValidElement)(r) ? i = (0, $9nZCP.cloneElement)(r, l) : $73d46209e4d80851$var$d(r) || $73d46209e4d80851$var$u(r) ? i = r : s ? i = $73d46209e4d80851$export$4f13f83fd8bb1dac.spinner() : ((t)=>t in $73d46209e4d80851$export$4f13f83fd8bb1dac)(o) && (i = $73d46209e4d80851$export$4f13f83fd8bb1dac[o](l))), i;
        }(M), $73d46209e4d80851$var$p(i.onOpen) && (M.onOpen = i.onOpen), $73d46209e4d80851$var$p(i.onClose) && (M.onClose = i.onClose), M.closeButton = b.closeButton, !1 === i.closeButton || $73d46209e4d80851$var$f(i.closeButton) ? M.closeButton = i.closeButton : !0 === i.closeButton && (M.closeButton = !$73d46209e4d80851$var$f(b.closeButton) || b.closeButton);
        let x = t;
        (0, $9nZCP.isValidElement)(t) && !$73d46209e4d80851$var$d(t.type) ? x = (0, $9nZCP.cloneElement)(t, {
            closeToast: L,
            toastProps: M,
            data: T
        }) : $73d46209e4d80851$var$p(t) && (x = t({
            closeToast: L,
            toastProps: M,
            data: T
        })), b.limit && b.limit > 0 && C.count > b.limit && N ? C.queue.push({
            toastContent: x,
            toastProps: M,
            staleId: r
        }) : $73d46209e4d80851$var$u(s) ? setTimeout(()=>{
            O(x, M, r);
        }, s) : O(x, M, r);
    }
    function O(t, e, n) {
        const { toastId: o } = e;
        n && h.delete(n);
        const s = {
            content: t,
            props: e
        };
        h.set(o, s), c((t)=>[
                ...t,
                o
            ].filter((t)=>t !== n)), $73d46209e4d80851$var$v.emit(4, $73d46209e4d80851$var$y(s, null == s.props.updateId ? "added" : "updated"));
    }
    return (0, $9nZCP.useEffect)(()=>(C.containerId = t.containerId, $73d46209e4d80851$var$v.cancelEmit(3).on(0, L).on(1, (t)=>g.current && I(t)).on(5, b).emit(2, C), ()=>{
            h.clear(), $73d46209e4d80851$var$v.emit(3, C);
        }), []), (0, $9nZCP.useEffect)(()=>{
        C.props = t, C.isToastActive = T, C.displayedToast = l.length;
    }), {
        getToastToRender: function(e) {
            const n = new Map, o = Array.from(h.values());
            return t.newestOnTop && o.reverse(), o.forEach((t)=>{
                const { position: e } = t.props;
                n.has(e) || n.set(e, []), n.get(e).push(t);
            }), Array.from(n, (t)=>e(t[0], t[1]));
        },
        containerRef: g,
        isToastActive: T
    };
}
function $73d46209e4d80851$var$b(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
}
function $73d46209e4d80851$var$I(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
}
function $73d46209e4d80851$export$a407b657d3044108(t) {
    const [o, a] = (0, $9nZCP.useState)(!1), [r, l] = (0, $9nZCP.useState)(!1), c = (0, $9nZCP.useRef)(null), u = (0, $9nZCP.useRef)({
        start: 0,
        x: 0,
        y: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        boundingRect: null,
        didMove: !1
    }).current, d = (0, $9nZCP.useRef)(t), { autoClose: m, pauseOnHover: f, closeToast: g, onClick: h, closeOnClick: y } = t;
    function v(e) {
        if (t.draggable) {
            "touchstart" === e.nativeEvent.type && e.nativeEvent.preventDefault(), u.didMove = !1, document.addEventListener("mousemove", _), document.addEventListener("mouseup", L), document.addEventListener("touchmove", _), document.addEventListener("touchend", L);
            const n = c.current;
            u.canCloseOnClick = !0, u.canDrag = !0, u.boundingRect = n.getBoundingClientRect(), n.style.transition = "", u.x = $73d46209e4d80851$var$b(e.nativeEvent), u.y = $73d46209e4d80851$var$I(e.nativeEvent), "x" === t.draggableDirection ? (u.start = u.x, u.removalDistance = n.offsetWidth * (t.draggablePercent / 100)) : (u.start = u.y, u.removalDistance = n.offsetHeight * (80 === t.draggablePercent ? 1.5 * t.draggablePercent : t.draggablePercent / 100));
        }
    }
    function T(e) {
        if (u.boundingRect) {
            const { top: n, bottom: o, left: s, right: a } = u.boundingRect;
            "touchend" !== e.nativeEvent.type && t.pauseOnHover && u.x >= s && u.x <= a && u.y >= n && u.y <= o ? C() : E();
        }
    }
    function E() {
        a(!0);
    }
    function C() {
        a(!1);
    }
    function _(e) {
        const n = c.current;
        u.canDrag && n && (u.didMove = !0, o && C(), u.x = $73d46209e4d80851$var$b(e), u.y = $73d46209e4d80851$var$I(e), u.delta = "x" === t.draggableDirection ? u.x - u.start : u.y - u.start, u.start !== u.x && (u.canCloseOnClick = !1), n.style.transform = `translate${t.draggableDirection}(${u.delta}px)`, n.style.opacity = "" + (1 - Math.abs(u.delta / u.removalDistance)));
    }
    function L() {
        document.removeEventListener("mousemove", _), document.removeEventListener("mouseup", L), document.removeEventListener("touchmove", _), document.removeEventListener("touchend", L);
        const e = c.current;
        if (u.canDrag && u.didMove && e) {
            if (u.canDrag = !1, Math.abs(u.delta) > u.removalDistance) return l(!0), void t.closeToast();
            e.style.transition = "transform 0.2s, opacity 0.2s", e.style.transform = `translate${t.draggableDirection}(0)`, e.style.opacity = "1";
        }
    }
    (0, $9nZCP.useEffect)(()=>{
        d.current = t;
    }), (0, $9nZCP.useEffect)(()=>(c.current && c.current.addEventListener("d", E, {
            once: !0
        }), $73d46209e4d80851$var$p(t.onOpen) && t.onOpen((0, $9nZCP.isValidElement)(t.children) && t.children.props), ()=>{
            const t = d.current;
            $73d46209e4d80851$var$p(t.onClose) && t.onClose((0, $9nZCP.isValidElement)(t.children) && t.children.props);
        }), []), (0, $9nZCP.useEffect)(()=>(t.pauseOnFocusLoss && (document.hasFocus() || C(), window.addEventListener("focus", E), window.addEventListener("blur", C)), ()=>{
            t.pauseOnFocusLoss && (window.removeEventListener("focus", E), window.removeEventListener("blur", C));
        }), [
        t.pauseOnFocusLoss
    ]);
    const O = {
        onMouseDown: v,
        onTouchStart: v,
        onMouseUp: T,
        onTouchEnd: T
    };
    return m && f && (O.onMouseEnter = C, O.onMouseLeave = E), y && (O.onClick = (t)=>{
        h && h(t), u.canCloseOnClick && g();
    }), {
        playToast: E,
        pauseToast: C,
        isRunning: o,
        preventExitTransition: r,
        toastRef: c,
        eventHandlers: O
    };
}
function $73d46209e4d80851$var$L(e) {
    let { closeToast: n, theme: o, ariaLabel: s = "close" } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (t)=>{
            t.stopPropagation(), n(t);
        },
        "aria-label": s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $73d46209e4d80851$var$O(e) {
    let { delay: n, isRunning: o, closeToast: s, type: a = "default", hide: r, className: i, style: l, controlledProgress: u, progress: d, rtl: m, isIn: f, theme: g } = e;
    const h = r || u && 0 === d, y = {
        ...l,
        animationDuration: `${n}ms`,
        animationPlayState: o ? "running" : "paused",
        opacity: h ? 0 : 1
    };
    u && (y.transform = `scaleX(${d})`);
    const v = (0, $5c49ba72c59b8cdc$export$2e2bcd8739ae039)("Toastify__progress-bar", u ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${a}`, {
        "Toastify__progress-bar--rtl": m
    }), T = $73d46209e4d80851$var$p(i) ? i({
        rtl: m,
        type: a,
        defaultClassName: v
    }) : (0, $5c49ba72c59b8cdc$export$2e2bcd8739ae039)(v, i);
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        role: "progressbar",
        "aria-hidden": h ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: y,
        [u && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: u && d < 1 ? null : ()=>{
            f && s();
        }
    });
}
const $73d46209e4d80851$var$N = (n)=>{
    const { isRunning: o, preventExitTransition: s, toastRef: r, eventHandlers: i } = $73d46209e4d80851$export$a407b657d3044108(n), { closeButton: l, children: u, autoClose: d, onClick: m, type: f, hideProgressBar: g, closeToast: h, transition: y, position: v, className: T, style: E, bodyClassName: C, bodyStyle: b, progressClassName: I, progressStyle: N, updateId: M, role: R, progress: w, rtl: x, toastId: $, deleteToast: k, isIn: P, isLoading: B, iconOut: D, closeOnClick: A, theme: z } = n, F = (0, $5c49ba72c59b8cdc$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${z}`, `Toastify__toast--${f}`, {
        "Toastify__toast--rtl": x
    }, {
        "Toastify__toast--close-on-click": A
    }), H = $73d46209e4d80851$var$p(T) ? T({
        rtl: x,
        position: v,
        type: f,
        defaultClassName: F
    }) : (0, $5c49ba72c59b8cdc$export$2e2bcd8739ae039)(F, T), S = !!w || !d, q = {
        closeToast: h,
        type: f,
        theme: z
    };
    let Q = null;
    return !1 === l || (Q = $73d46209e4d80851$var$p(l) ? l(q) : (0, $9nZCP.isValidElement)(l) ? (0, $9nZCP.cloneElement)(l, q) : $73d46209e4d80851$var$L(q)), (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement(y, {
        isIn: P,
        done: k,
        position: v,
        preventExitTransition: s,
        nodeRef: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        id: $,
        onClick: m,
        className: H,
        ...i,
        style: E,
        ref: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        ...P && {
            role: R
        },
        className: $73d46209e4d80851$var$p(C) ? C({
            type: f
        }) : (0, $5c49ba72c59b8cdc$export$2e2bcd8739ae039)("Toastify__toast-body", C),
        style: b
    }, null != D && (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: (0, $5c49ba72c59b8cdc$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            "Toastify--animate-icon Toastify__zoom-enter": !B
        })
    }, D), (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", null, u)), Q, (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement($73d46209e4d80851$var$O, {
        ...M && !S ? {
            key: `pb-${M}`
        } : {},
        rtl: x,
        theme: z,
        delay: d,
        isRunning: o,
        isIn: P,
        closeToast: h,
        hide: g,
        type: f,
        style: N,
        className: I,
        controlledProgress: S,
        progress: w || 0
    })));
}, $73d46209e4d80851$var$M = function(t, e) {
    return void 0 === e && (e = !1), {
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: e
    };
}, $73d46209e4d80851$export$d20e79fdc3899e95 = $73d46209e4d80851$export$3ff7dc44d332d222($73d46209e4d80851$var$M("bounce", !0)), $73d46209e4d80851$export$d8dc01b5c85a37b9 = $73d46209e4d80851$export$3ff7dc44d332d222($73d46209e4d80851$var$M("slide", !0)), $73d46209e4d80851$export$65cfd44a2050f99 = $73d46209e4d80851$export$3ff7dc44d332d222($73d46209e4d80851$var$M("zoom")), $73d46209e4d80851$export$4d2fae537bd90431 = $73d46209e4d80851$export$3ff7dc44d332d222($73d46209e4d80851$var$M("flip")), $73d46209e4d80851$export$f2815235e76a62b9 = (0, $9nZCP.forwardRef)((e, n)=>{
    const { getToastToRender: o, containerRef: a, isToastActive: r } = $73d46209e4d80851$export$b262e13ca2dd2381(e), { className: i, style: l, rtl: u, containerId: d } = e;
    function f(t) {
        const e = (0, $5c49ba72c59b8cdc$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${t}`, {
            "Toastify__toast-container--rtl": u
        });
        return $73d46209e4d80851$var$p(i) ? i({
            position: t,
            rtl: u,
            defaultClassName: e
        }) : (0, $5c49ba72c59b8cdc$export$2e2bcd8739ae039)(e, $73d46209e4d80851$var$m(i));
    }
    return (0, $9nZCP.useEffect)(()=>{
        n && (n.current = a.current);
    }, []), (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        ref: a,
        className: "Toastify",
        id: d
    }, o((e, n)=>{
        const o = n.length ? {
            ...l
        } : {
            ...l,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
            className: f(e),
            style: o,
            key: `container-${e}`
        }, n.map((e, o)=>{
            let { content: s, props: a } = e;
            return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement($73d46209e4d80851$var$N, {
                ...a,
                isIn: r(a.toastId),
                style: {
                    ...a.style,
                    "--nth": o + 1,
                    "--len": n.length
                },
                key: `toast-${a.key}`
            }, s);
        }));
    }));
});
$73d46209e4d80851$export$f2815235e76a62b9.displayName = "ToastContainer", $73d46209e4d80851$export$f2815235e76a62b9.defaultProps = {
    position: "top-right",
    transition: $73d46209e4d80851$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: $73d46209e4d80851$var$L,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    closeOnClick: !0,
    draggable: !0,
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
let $73d46209e4d80851$var$P, $73d46209e4d80851$var$B = new Map, $73d46209e4d80851$var$D = [], $73d46209e4d80851$var$A = 1;
function $73d46209e4d80851$var$z() {
    return "" + $73d46209e4d80851$var$A++;
}
function $73d46209e4d80851$var$F(t) {
    return t && ($73d46209e4d80851$var$d(t.toastId) || $73d46209e4d80851$var$u(t.toastId)) ? t.toastId : $73d46209e4d80851$var$z();
}
function $73d46209e4d80851$var$H(t, e) {
    return $73d46209e4d80851$var$B.size > 0 ? $73d46209e4d80851$var$v.emit(0, t, e) : $73d46209e4d80851$var$D.push({
        content: t,
        options: e
    }), e.toastId;
}
function $73d46209e4d80851$var$S(t, e) {
    return {
        ...e,
        type: e && e.type || t,
        toastId: $73d46209e4d80851$var$F(e)
    };
}
function $73d46209e4d80851$var$q(t) {
    return (e, n)=>$73d46209e4d80851$var$H(e, $73d46209e4d80851$var$S(t, n));
}
function $73d46209e4d80851$export$b410431fab84fa58(t, e) {
    return $73d46209e4d80851$var$H(t, $73d46209e4d80851$var$S("default", e));
}
$73d46209e4d80851$export$b410431fab84fa58.loading = (t, e)=>$73d46209e4d80851$var$H(t, $73d46209e4d80851$var$S("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...e
    })), $73d46209e4d80851$export$b410431fab84fa58.promise = function(t, e, n) {
    let o, { pending: s, error: a, success: r } = e;
    s && (o = $73d46209e4d80851$var$d(s) ? $73d46209e4d80851$export$b410431fab84fa58.loading(s, n) : $73d46209e4d80851$export$b410431fab84fa58.loading(s.render, {
        ...n,
        ...s
    }));
    const i = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, l = (t, e, s)=>{
        if (null == e) return void $73d46209e4d80851$export$b410431fab84fa58.dismiss(o);
        const a = {
            type: t,
            ...i,
            ...n,
            data: s
        }, r = $73d46209e4d80851$var$d(e) ? {
            render: e
        } : e;
        return o ? $73d46209e4d80851$export$b410431fab84fa58.update(o, {
            ...a,
            ...r
        }) : $73d46209e4d80851$export$b410431fab84fa58(r.render, {
            ...a,
            ...r
        }), s;
    }, c = $73d46209e4d80851$var$p(t) ? t() : t;
    return c.then((t)=>l("success", r, t)).catch((t)=>l("error", a, t)), c;
}, $73d46209e4d80851$export$b410431fab84fa58.success = $73d46209e4d80851$var$q("success"), $73d46209e4d80851$export$b410431fab84fa58.info = $73d46209e4d80851$var$q("info"), $73d46209e4d80851$export$b410431fab84fa58.error = $73d46209e4d80851$var$q("error"), $73d46209e4d80851$export$b410431fab84fa58.warning = $73d46209e4d80851$var$q("warning"), $73d46209e4d80851$export$b410431fab84fa58.warn = $73d46209e4d80851$export$b410431fab84fa58.warning, $73d46209e4d80851$export$b410431fab84fa58.dark = (t, e)=>$73d46209e4d80851$var$H(t, $73d46209e4d80851$var$S("default", {
        theme: "dark",
        ...e
    })), $73d46209e4d80851$export$b410431fab84fa58.dismiss = (t)=>{
    $73d46209e4d80851$var$B.size > 0 ? $73d46209e4d80851$var$v.emit(1, t) : $73d46209e4d80851$var$D = $73d46209e4d80851$var$D.filter((e)=>null != t && e.options.toastId !== t);
}, $73d46209e4d80851$export$b410431fab84fa58.clearWaitingQueue = function(t) {
    return void 0 === t && (t = {}), $73d46209e4d80851$var$v.emit(5, t);
}, $73d46209e4d80851$export$b410431fab84fa58.isActive = (t)=>{
    let e = !1;
    return $73d46209e4d80851$var$B.forEach((n)=>{
        n.isToastActive && n.isToastActive(t) && (e = !0);
    }), e;
}, $73d46209e4d80851$export$b410431fab84fa58.update = function(t, e) {
    void 0 === e && (e = {}), setTimeout(()=>{
        const n = function(t, e) {
            let { containerId: n } = e;
            const o = $73d46209e4d80851$var$B.get(n || $73d46209e4d80851$var$P);
            return o && o.getToast(t);
        }(t, e);
        if (n) {
            const { props: o, content: s } = n, a = {
                delay: 100,
                ...o,
                ...e,
                toastId: e.toastId || t,
                updateId: $73d46209e4d80851$var$z()
            };
            a.toastId !== t && (a.staleId = t);
            const r = a.render || s;
            delete a.render, $73d46209e4d80851$var$H(r, a);
        }
    }, 0);
}, $73d46209e4d80851$export$b410431fab84fa58.done = (t)=>{
    $73d46209e4d80851$export$b410431fab84fa58.update(t, {
        progress: 1
    });
}, $73d46209e4d80851$export$b410431fab84fa58.onChange = (t)=>($73d46209e4d80851$var$v.on(4, t), ()=>{
        $73d46209e4d80851$var$v.off(4, t);
    }), $73d46209e4d80851$export$b410431fab84fa58.POSITION = {
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right",
    TOP_CENTER: "top-center",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    BOTTOM_CENTER: "bottom-center"
}, $73d46209e4d80851$export$b410431fab84fa58.TYPE = {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
    DEFAULT: "default"
}, $73d46209e4d80851$var$v.on(2, (t)=>{
    $73d46209e4d80851$var$P = t.containerId || t, $73d46209e4d80851$var$B.set($73d46209e4d80851$var$P, t), $73d46209e4d80851$var$D.forEach((t)=>{
        $73d46209e4d80851$var$v.emit(0, t.content, t.options);
    }), $73d46209e4d80851$var$D = [];
}).on(3, (t)=>{
    $73d46209e4d80851$var$B.delete(t.containerId || t), 0 === $73d46209e4d80851$var$B.size && $73d46209e4d80851$var$v.off(0).off(1).off(5);
});



const $6724d57570dc2c5f$export$8eb3892b442747bd = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored"
};
async function $6724d57570dc2c5f$export$27738200007bd40a(contractWrite, publicClient) {
    (0, $73d46209e4d80851$export$b410431fab84fa58).info("Transaction initiated", $6724d57570dc2c5f$export$8eb3892b442747bd);
    return await contractWrite().then(async (hash)=>await publicClient.waitForTransactionReceipt({
            hash: hash,
            confirmations: 2
        }).then((res)=>{
            const status = res.status === "success";
            if (status) (0, $73d46209e4d80851$export$b410431fab84fa58).success("Transaction mined!", $6724d57570dc2c5f$export$8eb3892b442747bd);
            else (0, $73d46209e4d80851$export$b410431fab84fa58).error("Transaction reverted!", $6724d57570dc2c5f$export$8eb3892b442747bd);
            return {
                status: status,
                result: res
            };
        })).catch((error)=>{
        (0, $73d46209e4d80851$export$b410431fab84fa58).error(error.shortMessage ?? error.message, $6724d57570dc2c5f$export$8eb3892b442747bd);
        return {
            status: false
        };
    });
}
async function $6724d57570dc2c5f$export$944c26d54e826586(promise) {
    return await promise.catch((error)=>(0, $73d46209e4d80851$export$b410431fab84fa58).error(error.shortMessage ?? error.message, $6724d57570dc2c5f$export$8eb3892b442747bd));
}


let $57a54dd193007d45$var$timeoutId;
const $57a54dd193007d45$export$18f70d5facb50d50 = (msg)=>{
    if ($57a54dd193007d45$var$timeoutId) clearTimeout($57a54dd193007d45$var$timeoutId);
    $57a54dd193007d45$var$timeoutId = setTimeout(()=>{
        (0, $73d46209e4d80851$export$b410431fab84fa58).error(msg, (0, $6724d57570dc2c5f$export$8eb3892b442747bd));
    }, 5000);
};



const $5b649234c9d0c98d$var$REACT_APP_ARBSEPOLIA_SUBGRAPH = {
    [(0, $6a02c0f0c34d6c61$export$21799e7ae6cc115).id]: "https://api.studio.thegraph.com/query/61738/escrow-v2-devnet/version/latest" ?? "Wrong Subgraph URL. Please check the environment variables."
};
const $5b649234c9d0c98d$export$c7a04534f7a88653 = (chainId = (0, $6a02c0f0c34d6c61$export$21799e7ae6cc115).id)=>{
    return $5b649234c9d0c98d$var$REACT_APP_ARBSEPOLIA_SUBGRAPH[chainId];
};


const $6dabd7de11302893$var$Context = /*#__PURE__*/ (0, $9nZCP.createContext)(undefined);
const $6dabd7de11302893$var$fetcher = async (queries)=>{
    const promises = queries.map(async ({ id: id, document: document, variables: variables, chainId: chainId })=>{
        const url = (0, $5b649234c9d0c98d$export$c7a04534f7a88653)(chainId ?? (0, $6a02c0f0c34d6c61$export$21799e7ae6cc115).id);
        try {
            return (0, $749779f5335cf90b$exports.request)(url, document, variables).then((result)=>({
                    id: id,
                    result: result
                }));
        } catch (error) {
            console.error("Graph error: ", {
                error: error
            });
            (0, $57a54dd193007d45$export$18f70d5facb50d50)("Graph query error: failed to fetch data.");
            return {
                id: id,
                result: {}
            };
        }
    });
    const data = await Promise.all(promises);
    return data;
};
const $6dabd7de11302893$var$GraphqlBatcherProvider = ({ children: children })=>{
    const graphqlBatcher = (0, $219acb45e8919eaa$export$185802fd694ee1f5)({
        fetcher: $6dabd7de11302893$var$fetcher,
        resolver: (results, query)=>results.find((result)=>result.id === query.id)["result"],
        scheduler: (0, $219acb45e8919eaa$export$c588696e674bc1bf)({
            windowMs: 100,
            maxBatchSize: 5
        })
    });
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($6dabd7de11302893$var$Context.Provider, {
        value: (0, $9nZCP.useMemo)(()=>({
                graphqlBatcher: graphqlBatcher
            }), [
            graphqlBatcher
        ]),
        children: children
    });
};
const $6dabd7de11302893$export$45728877641088dc = ()=>{
    const context = (0, $9nZCP.useContext)($6dabd7de11302893$var$Context);
    if (!context) throw new Error("Context Provider not found.");
    return context;
};
var $6dabd7de11302893$export$2e2bcd8739ae039 = $6dabd7de11302893$var$GraphqlBatcherProvider;




var $9nZCP = parcelRequire("9nZCP");





var $9nZCP = parcelRequire("9nZCP");
/*!
 * OverlayScrollbars
 * Version: 2.4.6
 *
 * Copyright (c) Rene Haas | KingSora.
 * https://github.com/KingSora
 *
 * Released under the MIT license.
 */ const $b5d578355fd299c5$var$createCache = (t, n)=>{
    const { o: o, u: s, _: e } = t;
    let c = o;
    let r;
    const cacheUpdateContextual = (t, n)=>{
        const o = c;
        const l = t;
        const i = n || (s ? !s(o, l) : o !== l);
        if (i || e) {
            c = l;
            r = o;
        }
        return [
            c,
            i,
            r
        ];
    };
    const cacheUpdateIsolated = (t)=>cacheUpdateContextual(n(c, r), t);
    const getCurrentCache = (t)=>[
            c,
            !!t,
            r
        ];
    return [
        n ? cacheUpdateIsolated : cacheUpdateContextual,
        getCurrentCache
    ];
};
const $b5d578355fd299c5$var$t = typeof window !== "undefined";
const $b5d578355fd299c5$var$n = $b5d578355fd299c5$var$t && Node.ELEMENT_NODE;
const { toString: $b5d578355fd299c5$var$o, hasOwnProperty: $b5d578355fd299c5$var$s } = Object.prototype;
const $b5d578355fd299c5$var$e = /^\[object (.+)\]$/;
const $b5d578355fd299c5$var$isUndefined = (t)=>t === void 0;
const $b5d578355fd299c5$var$isNull = (t)=>t === null;
const $b5d578355fd299c5$var$type = (t)=>$b5d578355fd299c5$var$isUndefined(t) || $b5d578355fd299c5$var$isNull(t) ? `${t}` : $b5d578355fd299c5$var$o.call(t).replace($b5d578355fd299c5$var$e, "$1").toLowerCase();
const $b5d578355fd299c5$var$isNumber = (t)=>typeof t === "number";
const $b5d578355fd299c5$var$isString = (t)=>typeof t === "string";
const $b5d578355fd299c5$var$isBoolean = (t)=>typeof t === "boolean";
const $b5d578355fd299c5$var$isFunction = (t)=>typeof t === "function";
const $b5d578355fd299c5$var$isArray = (t)=>Array.isArray(t);
const $b5d578355fd299c5$var$isObject = (t)=>typeof t === "object" && !$b5d578355fd299c5$var$isArray(t) && !$b5d578355fd299c5$var$isNull(t);
const $b5d578355fd299c5$var$isArrayLike = (t)=>{
    const n = !!t && t.length;
    const o = $b5d578355fd299c5$var$isNumber(n) && n > -1 && n % 1 == 0;
    return $b5d578355fd299c5$var$isArray(t) || !$b5d578355fd299c5$var$isFunction(t) && o ? n > 0 && $b5d578355fd299c5$var$isObject(t) ? n - 1 in t : true : false;
};
const $b5d578355fd299c5$var$isPlainObject = (t)=>{
    if (!t || !$b5d578355fd299c5$var$isObject(t) || $b5d578355fd299c5$var$type(t) !== "object") return false;
    let n;
    const o = "constructor";
    const e = t[o];
    const c = e && e.prototype;
    const r = $b5d578355fd299c5$var$s.call(t, o);
    const l = c && $b5d578355fd299c5$var$s.call(c, "isPrototypeOf");
    if (e && !r && !l) return false;
    for(n in t);
    return $b5d578355fd299c5$var$isUndefined(n) || $b5d578355fd299c5$var$s.call(t, n);
};
const $b5d578355fd299c5$var$isHTMLElement = (t)=>{
    const o = HTMLElement;
    return t ? o ? t instanceof o : t.nodeType === $b5d578355fd299c5$var$n : false;
};
const $b5d578355fd299c5$var$isElement = (t)=>{
    const o = Element;
    return t ? o ? t instanceof o : t.nodeType === $b5d578355fd299c5$var$n : false;
};
function $b5d578355fd299c5$var$each(t, n) {
    if ($b5d578355fd299c5$var$isArrayLike(t)) for(let o = 0; o < t.length; o++){
        if (n(t[o], o, t) === false) break;
    }
    else if (t) $b5d578355fd299c5$var$each(Object.keys(t), (o)=>n(t[o], o, t));
    return t;
}
const $b5d578355fd299c5$var$inArray = (t, n)=>t.indexOf(n) >= 0;
const $b5d578355fd299c5$var$concat = (t, n)=>t.concat(n);
const $b5d578355fd299c5$var$push = (t, n, o)=>{
    !o && !$b5d578355fd299c5$var$isString(n) && $b5d578355fd299c5$var$isArrayLike(n) ? Array.prototype.push.apply(t, n) : t.push(n);
    return t;
};
const $b5d578355fd299c5$var$from = (t)=>{
    const n = Array.from;
    const o = [];
    if (n && t) return n(t);
    if (t instanceof Set) t.forEach((t)=>{
        $b5d578355fd299c5$var$push(o, t);
    });
    else $b5d578355fd299c5$var$each(t, (t)=>{
        $b5d578355fd299c5$var$push(o, t);
    });
    return o;
};
const $b5d578355fd299c5$var$createOrKeepArray = (t)=>$b5d578355fd299c5$var$isArray(t) ? t : [
        t
    ];
const $b5d578355fd299c5$var$isEmptyArray = (t)=>!!t && !t.length;
const $b5d578355fd299c5$var$deduplicateArray = (t)=>$b5d578355fd299c5$var$from(new Set(t));
const $b5d578355fd299c5$var$runEachAndClear = (t, n, o)=>{
    const runFn = (t)=>t && t.apply(void 0, n || []);
    $b5d578355fd299c5$var$each(t, runFn);
    !o && (t.length = 0);
};
const $b5d578355fd299c5$var$hasOwnProperty = (t, n)=>Object.prototype.hasOwnProperty.call(t, n);
const $b5d578355fd299c5$var$keys = (t)=>t ? Object.keys(t) : [];
const $b5d578355fd299c5$var$assignDeep = (t, n, o, s, e, c, r)=>{
    const l = [
        n,
        o,
        s,
        e,
        c,
        r
    ];
    if ((typeof t !== "object" || $b5d578355fd299c5$var$isNull(t)) && !$b5d578355fd299c5$var$isFunction(t)) t = {};
    $b5d578355fd299c5$var$each(l, (n)=>{
        $b5d578355fd299c5$var$each(n, (o, s)=>{
            const e = n[s];
            if (t === e) return true;
            const c = $b5d578355fd299c5$var$isArray(e);
            if (e && $b5d578355fd299c5$var$isPlainObject(e)) {
                const n = t[s];
                let o = n;
                if (c && !$b5d578355fd299c5$var$isArray(n)) o = [];
                else if (!c && !$b5d578355fd299c5$var$isPlainObject(n)) o = {};
                t[s] = $b5d578355fd299c5$var$assignDeep(o, e);
            } else t[s] = c ? e.slice() : e;
        });
    });
    return t;
};
const $b5d578355fd299c5$var$removeUndefinedProperties = (t, n)=>$b5d578355fd299c5$var$each($b5d578355fd299c5$var$assignDeep({}, t), (t, o, s)=>{
        if (t === void 0) delete s[o];
        else if (n && t && $b5d578355fd299c5$var$isPlainObject(t)) s[o] = $b5d578355fd299c5$var$removeUndefinedProperties(t, n);
    });
const $b5d578355fd299c5$var$isEmptyObject = (t)=>{
    for(const n in t)return false;
    return true;
};
const $b5d578355fd299c5$var$attr = (t, n, o)=>{
    if ($b5d578355fd299c5$var$isUndefined(o)) return t ? t.getAttribute(n) : null;
    t && t.setAttribute(n, o);
};
const $b5d578355fd299c5$var$getValueSet = (t, n)=>new Set(($b5d578355fd299c5$var$attr(t, n) || "").split(" "));
const $b5d578355fd299c5$var$removeAttr = (t, n)=>{
    t && t.removeAttribute(n);
};
const $b5d578355fd299c5$var$attrClass = (t, n, o, s)=>{
    if (o) {
        const e = $b5d578355fd299c5$var$getValueSet(t, n);
        e[s ? "add" : "delete"](o);
        const c = $b5d578355fd299c5$var$from(e).join(" ").trim();
        $b5d578355fd299c5$var$attr(t, n, c);
    }
};
const $b5d578355fd299c5$var$hasAttrClass = (t, n, o)=>$b5d578355fd299c5$var$getValueSet(t, n).has(o);
const $b5d578355fd299c5$var$c = $b5d578355fd299c5$var$t && Element.prototype;
const $b5d578355fd299c5$var$find = (t, n)=>{
    const o = [];
    const s = n ? $b5d578355fd299c5$var$isElement(n) && n : document;
    return s ? $b5d578355fd299c5$var$push(o, s.querySelectorAll(t)) : o;
};
const $b5d578355fd299c5$var$findFirst = (t, n)=>{
    const o = n ? $b5d578355fd299c5$var$isElement(n) && n : document;
    return o ? o.querySelector(t) : null;
};
const $b5d578355fd299c5$var$is = (t, n)=>{
    if ($b5d578355fd299c5$var$isElement(t)) {
        const o = $b5d578355fd299c5$var$c.matches || $b5d578355fd299c5$var$c.msMatchesSelector;
        return o.call(t, n);
    }
    return false;
};
const $b5d578355fd299c5$var$contents = (t)=>t ? $b5d578355fd299c5$var$from(t.childNodes) : [];
const $b5d578355fd299c5$var$parent = (t)=>t && t.parentElement;
const $b5d578355fd299c5$var$closest = (t, n)=>{
    if ($b5d578355fd299c5$var$isElement(t)) {
        const o = $b5d578355fd299c5$var$c.closest;
        if (o) return o.call(t, n);
        do {
            if ($b5d578355fd299c5$var$is(t, n)) return t;
            t = $b5d578355fd299c5$var$parent(t);
        }while (t);
    }
};
const $b5d578355fd299c5$var$liesBetween = (t, n, o)=>{
    const s = $b5d578355fd299c5$var$closest(t, n);
    const e = t && $b5d578355fd299c5$var$findFirst(o, s);
    const c = $b5d578355fd299c5$var$closest(e, n) === s;
    return s && e ? s === t || e === t || c && $b5d578355fd299c5$var$closest($b5d578355fd299c5$var$closest(t, o), n) !== s : false;
};
const $b5d578355fd299c5$var$noop = ()=>{};
const $b5d578355fd299c5$var$removeElements = (t)=>{
    if ($b5d578355fd299c5$var$isArrayLike(t)) $b5d578355fd299c5$var$each($b5d578355fd299c5$var$from(t), (t)=>$b5d578355fd299c5$var$removeElements(t));
    else if (t) {
        const n = $b5d578355fd299c5$var$parent(t);
        n && n.removeChild(t);
    }
};
const $b5d578355fd299c5$var$before = (t, n, o)=>{
    if (o && t) {
        let s = n;
        let e;
        if ($b5d578355fd299c5$var$isArrayLike(o)) {
            e = document.createDocumentFragment();
            $b5d578355fd299c5$var$each(o, (t)=>{
                if (t === s) s = t.previousSibling;
                e.appendChild(t);
            });
        } else e = o;
        if (n) {
            if (!s) s = t.firstChild;
            else if (s !== n) s = s.nextSibling;
        }
        t.insertBefore(e, s || null);
        return ()=>$b5d578355fd299c5$var$removeElements(o);
    }
    return $b5d578355fd299c5$var$noop;
};
const $b5d578355fd299c5$var$appendChildren = (t, n)=>$b5d578355fd299c5$var$before(t, null, n);
const $b5d578355fd299c5$var$insertBefore = (t, n)=>$b5d578355fd299c5$var$before($b5d578355fd299c5$var$parent(t), t, n);
const $b5d578355fd299c5$var$insertAfter = (t, n)=>$b5d578355fd299c5$var$before($b5d578355fd299c5$var$parent(t), t && t.nextSibling, n);
const $b5d578355fd299c5$var$createDiv = (t)=>{
    const n = document.createElement("div");
    $b5d578355fd299c5$var$attr(n, "class", t);
    return n;
};
const $b5d578355fd299c5$var$createDOM = (t)=>{
    const n = $b5d578355fd299c5$var$createDiv();
    n.innerHTML = t.trim();
    return $b5d578355fd299c5$var$each($b5d578355fd299c5$var$contents(n), (t)=>$b5d578355fd299c5$var$removeElements(t));
};
const $b5d578355fd299c5$var$r = $b5d578355fd299c5$var$t ? window : {};
const $b5d578355fd299c5$var$l = Math.max;
const $b5d578355fd299c5$var$i = Math.min;
const $b5d578355fd299c5$var$a = Math.round;
const $b5d578355fd299c5$var$u = Math.abs;
const $b5d578355fd299c5$var$f = $b5d578355fd299c5$var$r.cancelAnimationFrame;
const $b5d578355fd299c5$var$_ = $b5d578355fd299c5$var$r.requestAnimationFrame;
const $b5d578355fd299c5$var$d = $b5d578355fd299c5$var$r.setTimeout;
const $b5d578355fd299c5$var$v = $b5d578355fd299c5$var$r.clearTimeout;
const $b5d578355fd299c5$var$firstLetterToUpper = (t)=>t.charAt(0).toUpperCase() + t.slice(1);
const $b5d578355fd299c5$var$getDummyStyle = ()=>$b5d578355fd299c5$var$createDiv().style;
const $b5d578355fd299c5$var$h = [
    "-webkit-",
    "-moz-",
    "-o-",
    "-ms-"
];
const $b5d578355fd299c5$var$p = [
    "WebKit",
    "Moz",
    "O",
    "MS",
    "webkit",
    "moz",
    "o",
    "ms"
];
const $b5d578355fd299c5$var$g = {};
const $b5d578355fd299c5$var$b = {};
const $b5d578355fd299c5$var$cssProperty = (t)=>{
    let n = $b5d578355fd299c5$var$b[t];
    if ($b5d578355fd299c5$var$hasOwnProperty($b5d578355fd299c5$var$b, t)) return n;
    const o = $b5d578355fd299c5$var$firstLetterToUpper(t);
    const s = $b5d578355fd299c5$var$getDummyStyle();
    $b5d578355fd299c5$var$each($b5d578355fd299c5$var$h, (e)=>{
        const c = e.replace(/-/g, "");
        const r = [
            t,
            e + t,
            c + o,
            $b5d578355fd299c5$var$firstLetterToUpper(c) + o
        ];
        return !(n = r.find((t)=>s[t] !== void 0));
    });
    return $b5d578355fd299c5$var$b[t] = n || "";
};
const $b5d578355fd299c5$var$jsAPI = (t)=>{
    let n = $b5d578355fd299c5$var$g[t] || $b5d578355fd299c5$var$r[t];
    if ($b5d578355fd299c5$var$hasOwnProperty($b5d578355fd299c5$var$g, t)) return n;
    $b5d578355fd299c5$var$each($b5d578355fd299c5$var$p, (o)=>{
        n = n || $b5d578355fd299c5$var$r[o + $b5d578355fd299c5$var$firstLetterToUpper(t)];
        return !n;
    });
    $b5d578355fd299c5$var$g[t] = n;
    return n;
};
const $b5d578355fd299c5$var$w = $b5d578355fd299c5$var$jsAPI("MutationObserver");
const $b5d578355fd299c5$var$y = $b5d578355fd299c5$var$jsAPI("IntersectionObserver");
const $b5d578355fd299c5$var$S = $b5d578355fd299c5$var$jsAPI("ResizeObserver");
const $b5d578355fd299c5$var$m = $b5d578355fd299c5$var$jsAPI("ScrollTimeline");
const $b5d578355fd299c5$var$bind = (t, ...n)=>t.bind(0, ...n);
const $b5d578355fd299c5$var$selfClearTimeout = (t)=>{
    let n;
    const o = t ? $b5d578355fd299c5$var$d : $b5d578355fd299c5$var$_;
    const s = t ? $b5d578355fd299c5$var$v : $b5d578355fd299c5$var$f;
    return [
        (e)=>{
            s(n);
            n = o(e, $b5d578355fd299c5$var$isFunction(t) ? t() : t);
        },
        ()=>s(n)
    ];
};
const $b5d578355fd299c5$var$debounce = (t, n)=>{
    let o;
    let s;
    let e;
    let c = $b5d578355fd299c5$var$noop;
    const { v: r, p: l, S: i } = n || {};
    const a = function invokeFunctionToDebounce(n) {
        c();
        $b5d578355fd299c5$var$v(o);
        o = s = void 0;
        c = $b5d578355fd299c5$var$noop;
        t.apply(this, n);
    };
    const mergeParms = (t)=>i && s ? i(s, t) : t;
    const flush = ()=>{
        if (c !== $b5d578355fd299c5$var$noop) a(mergeParms(e) || e);
    };
    const u = function debouncedFn() {
        const t = $b5d578355fd299c5$var$from(arguments);
        const n = $b5d578355fd299c5$var$isFunction(r) ? r() : r;
        const i = $b5d578355fd299c5$var$isNumber(n) && n >= 0;
        if (i) {
            const r = $b5d578355fd299c5$var$isFunction(l) ? l() : l;
            const i = $b5d578355fd299c5$var$isNumber(r) && r >= 0;
            const u = n > 0 ? $b5d578355fd299c5$var$d : $b5d578355fd299c5$var$_;
            const h = n > 0 ? $b5d578355fd299c5$var$v : $b5d578355fd299c5$var$f;
            const p = mergeParms(t);
            const g = p || t;
            const b = a.bind(0, g);
            c();
            const w = u(b, n);
            c = ()=>h(w);
            if (i && !o) o = $b5d578355fd299c5$var$d(flush, r);
            s = e = g;
        } else a(t);
    };
    u.m = flush;
    return u;
};
const $b5d578355fd299c5$var$$ = /[^\x20\t\r\n\f]+/g;
const $b5d578355fd299c5$var$classListAction = (t, n, o)=>{
    const s = t && t.classList;
    let e;
    let c = 0;
    let r = false;
    if (s && n && $b5d578355fd299c5$var$isString(n)) {
        const t = n.match($b5d578355fd299c5$var$$) || [];
        r = t.length > 0;
        while(e = t[c++])r = !!o(s, e) && r;
    }
    return r;
};
const $b5d578355fd299c5$var$removeClass = (t, n)=>{
    $b5d578355fd299c5$var$classListAction(t, n, (t, n)=>t.remove(n));
};
const $b5d578355fd299c5$var$addClass = (t, n)=>{
    $b5d578355fd299c5$var$classListAction(t, n, (t, n)=>t.add(n));
    return $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$removeClass, t, n);
};
const $b5d578355fd299c5$var$x = /^--/;
const $b5d578355fd299c5$var$getCSSVal = (t, n)=>t.getPropertyValue(n) || t[n] || "";
const $b5d578355fd299c5$var$validFiniteNumber = (t)=>{
    const n = t || 0;
    return isFinite(n) ? n : 0;
};
const $b5d578355fd299c5$var$parseToZeroOrNumber = (t)=>$b5d578355fd299c5$var$validFiniteNumber(parseFloat(t || ""));
const $b5d578355fd299c5$var$ratioToCssPercent = (t)=>`${($b5d578355fd299c5$var$validFiniteNumber(t) * 100).toFixed(3)}%`;
const $b5d578355fd299c5$var$numberToCssPx = (t)=>`${$b5d578355fd299c5$var$validFiniteNumber(t)}px`;
function $b5d578355fd299c5$var$setStyles(t, n) {
    t && $b5d578355fd299c5$var$each(n, (n, o)=>{
        try {
            const s = t.style;
            const e = $b5d578355fd299c5$var$isNumber(n) ? $b5d578355fd299c5$var$numberToCssPx(n) : n + "";
            if ($b5d578355fd299c5$var$x.test(o)) s.setProperty(o, e);
            else s[o] = e;
        } catch (s) {}
    });
}
function $b5d578355fd299c5$var$getStyles(t, n, o) {
    const s = $b5d578355fd299c5$var$isString(n);
    let e = s ? "" : {};
    if (t) {
        const c = $b5d578355fd299c5$var$r.getComputedStyle(t, o) || t.style;
        e = s ? $b5d578355fd299c5$var$getCSSVal(c, n) : n.reduce((t, n)=>{
            t[n] = $b5d578355fd299c5$var$getCSSVal(c, n);
            return t;
        }, e);
    }
    return e;
}
const $b5d578355fd299c5$var$getDirectionIsRTL = (t)=>$b5d578355fd299c5$var$getStyles(t, "direction") === "rtl";
const $b5d578355fd299c5$var$topRightBottomLeft = (t, n, o)=>{
    const s = n ? `${n}-` : "";
    const e = o ? `-${o}` : "";
    const c = `${s}top${e}`;
    const r = `${s}right${e}`;
    const l = `${s}bottom${e}`;
    const i = `${s}left${e}`;
    const a = $b5d578355fd299c5$var$getStyles(t, [
        c,
        r,
        l,
        i
    ]);
    return {
        t: $b5d578355fd299c5$var$parseToZeroOrNumber(a[c]),
        r: $b5d578355fd299c5$var$parseToZeroOrNumber(a[r]),
        b: $b5d578355fd299c5$var$parseToZeroOrNumber(a[l]),
        l: $b5d578355fd299c5$var$parseToZeroOrNumber(a[i])
    };
};
const $b5d578355fd299c5$var$getTrasformTranslateValue = (t, n)=>`translate${$b5d578355fd299c5$var$isObject(t) ? `(${t.x},${t.y})` : `${n ? "X" : "Y"}(${t})`}`;
const $b5d578355fd299c5$var$O = "paddingTop";
const $b5d578355fd299c5$var$C = "paddingRight";
const $b5d578355fd299c5$var$H = "paddingLeft";
const $b5d578355fd299c5$var$z = "paddingBottom";
const $b5d578355fd299c5$var$I = "marginLeft";
const $b5d578355fd299c5$var$A = "marginRight";
const $b5d578355fd299c5$var$E = "marginBottom";
const $b5d578355fd299c5$var$T = "overflowX";
const $b5d578355fd299c5$var$D = "overflowY";
const $b5d578355fd299c5$var$k = "width";
const $b5d578355fd299c5$var$M = "height";
const $b5d578355fd299c5$var$R = "hidden";
const $b5d578355fd299c5$var$P = {
    w: 0,
    h: 0
};
const $b5d578355fd299c5$var$getElmWidthHeightProperty = (t, n)=>n ? {
        w: n[`${t}Width`],
        h: n[`${t}Height`]
    } : $b5d578355fd299c5$var$P;
const $b5d578355fd299c5$var$windowSize = (t)=>$b5d578355fd299c5$var$getElmWidthHeightProperty("inner", t || $b5d578355fd299c5$var$r);
const $b5d578355fd299c5$var$L = $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$getElmWidthHeightProperty, "offset");
const $b5d578355fd299c5$var$V = $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$getElmWidthHeightProperty, "client");
const $b5d578355fd299c5$var$U = $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$getElmWidthHeightProperty, "scroll");
const $b5d578355fd299c5$var$fractionalSize = (t)=>{
    const n = parseFloat($b5d578355fd299c5$var$getStyles(t, $b5d578355fd299c5$var$k)) || 0;
    const o = parseFloat($b5d578355fd299c5$var$getStyles(t, $b5d578355fd299c5$var$M)) || 0;
    return {
        w: n - $b5d578355fd299c5$var$a(n),
        h: o - $b5d578355fd299c5$var$a(o)
    };
};
const $b5d578355fd299c5$var$getBoundingClientRect = (t)=>t.getBoundingClientRect();
const $b5d578355fd299c5$var$domRectHasDimensions = (t)=>!!(t && (t[$b5d578355fd299c5$var$M] || t[$b5d578355fd299c5$var$k]));
const $b5d578355fd299c5$var$domRectAppeared = (t, n)=>{
    const o = $b5d578355fd299c5$var$domRectHasDimensions(t);
    const s = $b5d578355fd299c5$var$domRectHasDimensions(n);
    return !s && o;
};
const $b5d578355fd299c5$var$animationCurrentTime = ()=>performance.now();
const $b5d578355fd299c5$var$animateNumber = (t, n, o, s, e)=>{
    let c = 0;
    const r = $b5d578355fd299c5$var$animationCurrentTime();
    const i = $b5d578355fd299c5$var$l(0, o);
    const frame = (o)=>{
        const a = $b5d578355fd299c5$var$animationCurrentTime();
        const u = a - r;
        const f = u >= i;
        const d = o ? 1 : 1 - ($b5d578355fd299c5$var$l(0, r + i - a) / i || 0);
        const v = (n - t) * ($b5d578355fd299c5$var$isFunction(e) ? e(d, d * i, 0, 1, i) : d) + t;
        const h = f || d === 1;
        s && s(v, d, h);
        c = h ? 0 : $b5d578355fd299c5$var$_(()=>frame());
    };
    frame();
    return (t)=>{
        $b5d578355fd299c5$var$f(c);
        t && frame(t);
    };
};
const $b5d578355fd299c5$var$equal = (t, n, o, s)=>{
    if (t && n) {
        let e = true;
        $b5d578355fd299c5$var$each(o, (o)=>{
            const c = s ? s(t[o]) : t[o];
            const r = s ? s(n[o]) : n[o];
            if (c !== r) e = false;
        });
        return e;
    }
    return false;
};
const $b5d578355fd299c5$var$equalWH = (t, n)=>$b5d578355fd299c5$var$equal(t, n, [
        "w",
        "h"
    ]);
const $b5d578355fd299c5$var$equalXY = (t, n)=>$b5d578355fd299c5$var$equal(t, n, [
        "x",
        "y"
    ]);
const $b5d578355fd299c5$var$equalTRBL = (t, n)=>$b5d578355fd299c5$var$equal(t, n, [
        "t",
        "r",
        "b",
        "l"
    ]);
const $b5d578355fd299c5$var$equalBCRWH = (t, n, o)=>$b5d578355fd299c5$var$equal(t, n, [
        $b5d578355fd299c5$var$k,
        $b5d578355fd299c5$var$M
    ], o && ((t)=>$b5d578355fd299c5$var$a(t)));
let $b5d578355fd299c5$var$B;
const $b5d578355fd299c5$var$j = "passive";
const $b5d578355fd299c5$var$supportPassiveEvents = ()=>{
    if ($b5d578355fd299c5$var$isUndefined($b5d578355fd299c5$var$B)) {
        $b5d578355fd299c5$var$B = false;
        try {
            $b5d578355fd299c5$var$r.addEventListener($b5d578355fd299c5$var$j, $b5d578355fd299c5$var$noop, Object.defineProperty({}, $b5d578355fd299c5$var$j, {
                get () {
                    $b5d578355fd299c5$var$B = true;
                }
            }));
        } catch (t) {}
    }
    return $b5d578355fd299c5$var$B;
};
const $b5d578355fd299c5$var$splitEventNames = (t)=>t.split(" ");
const $b5d578355fd299c5$var$removeEventListener = (t, n, o, s)=>{
    $b5d578355fd299c5$var$each($b5d578355fd299c5$var$splitEventNames(n), (n)=>{
        t.removeEventListener(n, o, s);
    });
};
const $b5d578355fd299c5$var$addEventListener = (t, n, o, s)=>{
    var e;
    const c = $b5d578355fd299c5$var$supportPassiveEvents();
    const r = (e = c && s && s.$) != null ? e : c;
    const l = s && s.O || false;
    const i = s && s.C || false;
    const a = c ? {
        passive: r,
        capture: l
    } : l;
    return $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$runEachAndClear, $b5d578355fd299c5$var$splitEventNames(n).map((n)=>{
        const s = i ? (e)=>{
            $b5d578355fd299c5$var$removeEventListener(t, n, s, l);
            o(e);
        } : o;
        t.addEventListener(n, s, a);
        return $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$removeEventListener, t, n, s, l);
    }));
};
const $b5d578355fd299c5$var$stopPropagation = (t)=>t.stopPropagation();
const $b5d578355fd299c5$var$preventDefault = (t)=>t.preventDefault();
const $b5d578355fd299c5$var$N = {
    x: 0,
    y: 0
};
const $b5d578355fd299c5$var$absoluteCoordinates = (t)=>{
    const n = t && $b5d578355fd299c5$var$getBoundingClientRect(t);
    return n ? {
        x: n.left + $b5d578355fd299c5$var$r.pageYOffset,
        y: n.top + $b5d578355fd299c5$var$r.pageXOffset
    } : $b5d578355fd299c5$var$N;
};
const $b5d578355fd299c5$var$getRTLCompatibleScrollPosition = (t, n, o)=>o ? o.n ? -t : o.i ? n - t : t : t;
const $b5d578355fd299c5$var$getRTLCompatibleScrollBounds = (t, n)=>[
        n ? n.i ? t : 0 : 0,
        $b5d578355fd299c5$var$getRTLCompatibleScrollPosition(t, t, n)
    ];
const $b5d578355fd299c5$var$scrollElementTo = (t, n)=>{
    const { x: o, y: s } = $b5d578355fd299c5$var$isNumber(n) ? {
        x: n,
        y: n
    } : n || {};
    $b5d578355fd299c5$var$isNumber(o) && (t.scrollLeft = o);
    $b5d578355fd299c5$var$isNumber(s) && (t.scrollTop = s);
};
const $b5d578355fd299c5$var$getElmentScroll = (t)=>({
        x: t.scrollLeft,
        y: t.scrollTop
    });
const $b5d578355fd299c5$var$manageListener = (t, n)=>{
    $b5d578355fd299c5$var$each($b5d578355fd299c5$var$createOrKeepArray(n), t);
};
const $b5d578355fd299c5$var$createEventListenerHub = (t)=>{
    const n = new Map;
    const removeEvent = (t, o)=>{
        if (t) {
            const s = n.get(t);
            $b5d578355fd299c5$var$manageListener((t)=>{
                if (s) s[t ? "delete" : "clear"](t);
            }, o);
        } else {
            n.forEach((t)=>{
                t.clear();
            });
            n.clear();
        }
    };
    const addEvent = (t, o)=>{
        if ($b5d578355fd299c5$var$isString(t)) {
            const s = n.get(t) || new Set;
            n.set(t, s);
            $b5d578355fd299c5$var$manageListener((t)=>{
                $b5d578355fd299c5$var$isFunction(t) && s.add(t);
            }, o);
            return $b5d578355fd299c5$var$bind(removeEvent, t, o);
        }
        if ($b5d578355fd299c5$var$isBoolean(o) && o) removeEvent();
        const s = $b5d578355fd299c5$var$keys(t);
        const e = [];
        $b5d578355fd299c5$var$each(s, (n)=>{
            const o = t[n];
            o && $b5d578355fd299c5$var$push(e, addEvent(n, o));
        });
        return $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$runEachAndClear, e);
    };
    const triggerEvent = (t, o)=>{
        $b5d578355fd299c5$var$each($b5d578355fd299c5$var$from(n.get(t)), (t)=>{
            if (o && !$b5d578355fd299c5$var$isEmptyArray(o)) t.apply(0, o);
            else t();
        });
    };
    addEvent(t || {});
    return [
        addEvent,
        removeEvent,
        triggerEvent
    ];
};
const $b5d578355fd299c5$var$opsStringify = (t)=>JSON.stringify(t, (t, n)=>{
        if ($b5d578355fd299c5$var$isFunction(n)) throw 0;
        return n;
    });
const $b5d578355fd299c5$var$getPropByPath = (t, n)=>t ? `${n}`.split(".").reduce((t, n)=>t && $b5d578355fd299c5$var$hasOwnProperty(t, n) ? t[n] : void 0, t) : void 0;
const $b5d578355fd299c5$var$G = {
    paddingAbsolute: false,
    showNativeOverlaidScrollbars: false,
    update: {
        elementEvents: [
            [
                "img",
                "load"
            ]
        ],
        debounce: [
            0,
            33
        ],
        attributes: null,
        ignoreMutation: null
    },
    overflow: {
        x: "scroll",
        y: "scroll"
    },
    scrollbars: {
        theme: "os-theme-dark",
        visibility: "auto",
        autoHide: "never",
        autoHideDelay: 1300,
        autoHideSuspend: false,
        dragScroll: true,
        clickScroll: false,
        pointers: [
            "mouse",
            "touch",
            "pen"
        ]
    }
};
const $b5d578355fd299c5$var$getOptionsDiff = (t, n)=>{
    const o = {};
    const s = $b5d578355fd299c5$var$concat($b5d578355fd299c5$var$keys(n), $b5d578355fd299c5$var$keys(t));
    $b5d578355fd299c5$var$each(s, (s)=>{
        const e = t[s];
        const c = n[s];
        if ($b5d578355fd299c5$var$isObject(e) && $b5d578355fd299c5$var$isObject(c)) {
            $b5d578355fd299c5$var$assignDeep(o[s] = {}, $b5d578355fd299c5$var$getOptionsDiff(e, c));
            if ($b5d578355fd299c5$var$isEmptyObject(o[s])) delete o[s];
        } else if ($b5d578355fd299c5$var$hasOwnProperty(n, s) && c !== e) {
            let t = true;
            if ($b5d578355fd299c5$var$isArray(e) || $b5d578355fd299c5$var$isArray(c)) try {
                if ($b5d578355fd299c5$var$opsStringify(e) === $b5d578355fd299c5$var$opsStringify(c)) t = false;
            } catch (r) {}
            if (t) o[s] = c;
        }
    });
    return o;
};
const $b5d578355fd299c5$var$createOptionCheck = (t, n, o)=>(s)=>[
            $b5d578355fd299c5$var$getPropByPath(t, s),
            o || $b5d578355fd299c5$var$getPropByPath(n, s) !== void 0
        ];
const $b5d578355fd299c5$var$q = `data-overlayscrollbars`;
const $b5d578355fd299c5$var$F = "os-environment";
const $b5d578355fd299c5$var$W = `${$b5d578355fd299c5$var$F}-flexbox-glue`;
const $b5d578355fd299c5$var$X = `${$b5d578355fd299c5$var$W}-max`;
const $b5d578355fd299c5$var$Y = `os-scrollbar-hidden`;
const $b5d578355fd299c5$var$K = `${$b5d578355fd299c5$var$q}-initialize`;
const $b5d578355fd299c5$var$J = $b5d578355fd299c5$var$q;
const $b5d578355fd299c5$var$Z = `${$b5d578355fd299c5$var$J}-overflow-x`;
const $b5d578355fd299c5$var$Q = `${$b5d578355fd299c5$var$J}-overflow-y`;
const $b5d578355fd299c5$var$tt = "overflowVisible";
const $b5d578355fd299c5$var$nt = "scrollbarHidden";
const $b5d578355fd299c5$var$ot = "scrollbarPressed";
const $b5d578355fd299c5$var$st = "updating";
const $b5d578355fd299c5$var$et = `${$b5d578355fd299c5$var$q}-viewport`;
const $b5d578355fd299c5$var$ct = "arrange";
const $b5d578355fd299c5$var$rt = "scrollbarHidden";
const $b5d578355fd299c5$var$lt = $b5d578355fd299c5$var$tt;
const $b5d578355fd299c5$var$it = `${$b5d578355fd299c5$var$q}-padding`;
const $b5d578355fd299c5$var$at = $b5d578355fd299c5$var$lt;
const $b5d578355fd299c5$var$ut = `${$b5d578355fd299c5$var$q}-content`;
const $b5d578355fd299c5$var$ft = "os-size-observer";
const $b5d578355fd299c5$var$_t = `${$b5d578355fd299c5$var$ft}-appear`;
const $b5d578355fd299c5$var$dt = `${$b5d578355fd299c5$var$ft}-listener`;
const $b5d578355fd299c5$var$vt = `${$b5d578355fd299c5$var$dt}-scroll`;
const $b5d578355fd299c5$var$ht = `${$b5d578355fd299c5$var$dt}-item`;
const $b5d578355fd299c5$var$pt = `${$b5d578355fd299c5$var$ht}-final`;
const $b5d578355fd299c5$var$gt = "os-trinsic-observer";
const $b5d578355fd299c5$var$bt = "os-no-css-vars";
const $b5d578355fd299c5$var$wt = "os-theme-none";
const $b5d578355fd299c5$var$yt = "os-scrollbar";
const $b5d578355fd299c5$var$St = `${$b5d578355fd299c5$var$yt}-rtl`;
const $b5d578355fd299c5$var$mt = `${$b5d578355fd299c5$var$yt}-horizontal`;
const $b5d578355fd299c5$var$$t = `${$b5d578355fd299c5$var$yt}-vertical`;
const $b5d578355fd299c5$var$xt = `${$b5d578355fd299c5$var$yt}-track`;
const $b5d578355fd299c5$var$Ot = `${$b5d578355fd299c5$var$yt}-handle`;
const $b5d578355fd299c5$var$Ct = `${$b5d578355fd299c5$var$yt}-visible`;
const $b5d578355fd299c5$var$Ht = `${$b5d578355fd299c5$var$yt}-cornerless`;
const $b5d578355fd299c5$var$zt = `${$b5d578355fd299c5$var$yt}-transitionless`;
const $b5d578355fd299c5$var$It = `${$b5d578355fd299c5$var$yt}-interaction`;
const $b5d578355fd299c5$var$At = `${$b5d578355fd299c5$var$yt}-unusable`;
const $b5d578355fd299c5$var$Et = `${$b5d578355fd299c5$var$yt}-auto-hide`;
const $b5d578355fd299c5$var$Tt = `${$b5d578355fd299c5$var$Et}-hidden`;
const $b5d578355fd299c5$var$Dt = `${$b5d578355fd299c5$var$yt}-wheel`;
const $b5d578355fd299c5$var$kt = `${$b5d578355fd299c5$var$xt}-interactive`;
const $b5d578355fd299c5$var$Mt = `${$b5d578355fd299c5$var$Ot}-interactive`;
const $b5d578355fd299c5$var$Rt = {};
const $b5d578355fd299c5$var$Pt = {};
const $b5d578355fd299c5$var$addPlugins = (t)=>{
    $b5d578355fd299c5$var$each(t, (t)=>$b5d578355fd299c5$var$each(t, (n, o)=>{
            $b5d578355fd299c5$var$Rt[o] = t[o];
        }));
};
const $b5d578355fd299c5$var$registerPluginModuleInstances = (t, n, o)=>$b5d578355fd299c5$var$keys(t).map((s)=>{
        const { static: e, instance: c } = t[s];
        const [r, l, i] = o || [];
        const a = o ? c : e;
        if (a) {
            const t = o ? a(r, l, n) : a(n);
            return (i || $b5d578355fd299c5$var$Pt)[s] = t;
        }
    });
const $b5d578355fd299c5$var$getStaticPluginModuleInstance = (t)=>$b5d578355fd299c5$var$Pt[t];
const $b5d578355fd299c5$var$Lt = "__osOptionsValidationPlugin";
const $b5d578355fd299c5$var$Vt = "__osSizeObserverPlugin";
const $b5d578355fd299c5$export$c327021fb99a6481 = /* @__PURE__ */ (()=>({
        [$b5d578355fd299c5$var$Vt]: {
            static: ()=>(t, n, o)=>{
                    const s = 3333333;
                    const e = "scroll";
                    const c = $b5d578355fd299c5$var$createDOM(`<div class="${$b5d578355fd299c5$var$ht}" dir="ltr"><div class="${$b5d578355fd299c5$var$ht}"><div class="${$b5d578355fd299c5$var$pt}"></div></div><div class="${$b5d578355fd299c5$var$ht}"><div class="${$b5d578355fd299c5$var$pt}" style="width: 200%; height: 200%"></div></div></div>`);
                    const r = c[0];
                    const l = r.lastChild;
                    const i = r.firstChild;
                    const a = i == null ? void 0 : i.firstChild;
                    let u = $b5d578355fd299c5$var$L(r);
                    let d = u;
                    let v = false;
                    let h;
                    const reset = ()=>{
                        $b5d578355fd299c5$var$scrollElementTo(i, s);
                        $b5d578355fd299c5$var$scrollElementTo(l, s);
                    };
                    const onResized = (t)=>{
                        h = 0;
                        if (v) {
                            u = d;
                            n(t === true);
                        }
                    };
                    const onScroll = (t)=>{
                        d = $b5d578355fd299c5$var$L(r);
                        v = !t || !$b5d578355fd299c5$var$equalWH(d, u);
                        if (t) {
                            $b5d578355fd299c5$var$stopPropagation(t);
                            if (v && !h) {
                                $b5d578355fd299c5$var$f(h);
                                h = $b5d578355fd299c5$var$_(onResized);
                            }
                        } else onResized(t === false);
                        reset();
                    };
                    const p = [
                        $b5d578355fd299c5$var$appendChildren(t, c),
                        $b5d578355fd299c5$var$addEventListener(i, e, onScroll),
                        $b5d578355fd299c5$var$addEventListener(l, e, onScroll)
                    ];
                    $b5d578355fd299c5$var$addClass(t, $b5d578355fd299c5$var$vt);
                    $b5d578355fd299c5$var$setStyles(a, {
                        [$b5d578355fd299c5$var$k]: s,
                        [$b5d578355fd299c5$var$M]: s
                    });
                    $b5d578355fd299c5$var$_(reset);
                    return [
                        o ? $b5d578355fd299c5$var$bind(onScroll, false) : reset,
                        p
                    ];
                }
        }
    }))();
let $b5d578355fd299c5$var$Bt = 0;
const $b5d578355fd299c5$var$jt = "__osScrollbarsHidingPlugin";
const $b5d578355fd299c5$export$8c9a9f9ae72a1689 = /* @__PURE__ */ (()=>({
        [$b5d578355fd299c5$var$jt]: {
            static: ()=>({
                    H: (t)=>{
                        const { I: n, A: o, T: s } = t;
                        const e = !s && !n && (o.x || o.y);
                        const c = e ? document.createElement("style") : false;
                        if (c) {
                            $b5d578355fd299c5$var$attr(c, "id", `${$b5d578355fd299c5$var$et}-${$b5d578355fd299c5$var$ct}-${$b5d578355fd299c5$var$Bt}`);
                            $b5d578355fd299c5$var$Bt++;
                        }
                        return c;
                    },
                    D: (t, n, o, s, e, c, r)=>{
                        const arrangeViewport = (n, c, r, l)=>{
                            if (t) {
                                const { k: t } = e;
                                const { M: i, R: a } = n;
                                const { x: u, y: f } = a;
                                const { x: _, y: d } = i;
                                const v = l ? $b5d578355fd299c5$var$C : $b5d578355fd299c5$var$H;
                                const h = t[v];
                                const p = t.paddingTop;
                                const g = c.w + r.w;
                                const b = c.h + r.h;
                                const w = {
                                    w: d && f ? `${d + g - h}px` : "",
                                    h: _ && u ? `${_ + b - p}px` : ""
                                };
                                if (s) {
                                    const { sheet: t } = s;
                                    if (t) {
                                        const { cssRules: n } = t;
                                        if (n) {
                                            if (!n.length) t.insertRule(`#${$b5d578355fd299c5$var$attr(s, "id")} + [${$b5d578355fd299c5$var$et}~='${$b5d578355fd299c5$var$ct}']::before {}`, 0);
                                            const o = n[0].style;
                                            o[$b5d578355fd299c5$var$k] = w.w;
                                            o[$b5d578355fd299c5$var$M] = w.h;
                                        }
                                    }
                                } else $b5d578355fd299c5$var$setStyles(o, {
                                    "--os-vaw": w.w,
                                    "--os-vah": w.h
                                });
                            }
                            return t;
                        };
                        const undoViewportArrange = (s, l, i)=>{
                            if (t) {
                                const a = i || c(s);
                                const { k: u } = e;
                                const { R: f } = a;
                                const { x: _, y: d } = f;
                                const v = {};
                                const assignProps = (t)=>$b5d578355fd299c5$var$each(t, (t)=>{
                                        v[t] = u[t];
                                    });
                                if (_) assignProps([
                                    $b5d578355fd299c5$var$E,
                                    $b5d578355fd299c5$var$O,
                                    $b5d578355fd299c5$var$z
                                ]);
                                if (d) assignProps([
                                    $b5d578355fd299c5$var$I,
                                    $b5d578355fd299c5$var$A,
                                    $b5d578355fd299c5$var$H,
                                    $b5d578355fd299c5$var$C
                                ]);
                                const h = $b5d578355fd299c5$var$getStyles(o, $b5d578355fd299c5$var$keys(v));
                                $b5d578355fd299c5$var$attrClass(o, $b5d578355fd299c5$var$et, $b5d578355fd299c5$var$ct);
                                if (!n) v[$b5d578355fd299c5$var$M] = "";
                                $b5d578355fd299c5$var$setStyles(o, v);
                                return [
                                    ()=>{
                                        r(a, l, t, h);
                                        $b5d578355fd299c5$var$setStyles(o, h);
                                        $b5d578355fd299c5$var$attrClass(o, $b5d578355fd299c5$var$et, $b5d578355fd299c5$var$ct, true);
                                    },
                                    a
                                ];
                            }
                            return [
                                $b5d578355fd299c5$var$noop
                            ];
                        };
                        return [
                            arrangeViewport,
                            undoViewportArrange
                        ];
                    },
                    P: ()=>{
                        let t = {
                            w: 0,
                            h: 0
                        };
                        let n = 0;
                        const getWindowDPR = ()=>{
                            const t = $b5d578355fd299c5$var$r.screen;
                            const n = t.deviceXDPI || 0;
                            const o = t.logicalXDPI || 1;
                            return $b5d578355fd299c5$var$r.devicePixelRatio || n / o;
                        };
                        const diffBiggerThanOne = (t, n)=>{
                            const o = $b5d578355fd299c5$var$u(t);
                            const s = $b5d578355fd299c5$var$u(n);
                            return !(o === s || o + 1 === s || o - 1 === s);
                        };
                        return (o, s)=>{
                            const e = $b5d578355fd299c5$var$windowSize();
                            const c = {
                                w: e.w - t.w,
                                h: e.h - t.h
                            };
                            if (c.w === 0 && c.h === 0) return;
                            const r = {
                                w: $b5d578355fd299c5$var$u(c.w),
                                h: $b5d578355fd299c5$var$u(c.h)
                            };
                            const l = {
                                w: $b5d578355fd299c5$var$u($b5d578355fd299c5$var$a(e.w / (t.w / 100))),
                                h: $b5d578355fd299c5$var$u($b5d578355fd299c5$var$a(e.h / (t.h / 100)))
                            };
                            const i = getWindowDPR();
                            const f = r.w > 2 && r.h > 2;
                            const _ = !diffBiggerThanOne(l.w, l.h);
                            const d = i !== n && i > 0;
                            const v = f && _ && d;
                            let h;
                            let p;
                            if (v) {
                                [p, h] = s();
                                $b5d578355fd299c5$var$assignDeep(o.L, p);
                            }
                            t = e;
                            n = i;
                            return h;
                        };
                    }
                })
        }
    }))();
const $b5d578355fd299c5$var$Gt = "__osClickScrollPlugin";
const $b5d578355fd299c5$export$1a35b83948406b62 = /* @__PURE__ */ (()=>({
        [$b5d578355fd299c5$var$Gt]: {
            static: ()=>(t, n, o, s, e)=>{
                    let c = 0;
                    let r = $b5d578355fd299c5$var$noop;
                    const animateClickScroll = (l)=>{
                        r = $b5d578355fd299c5$var$animateNumber(l, l + s * Math.sign(o), 133, (o, l, i)=>{
                            t(o);
                            const a = n();
                            const u = a + s;
                            const f = e >= a && e <= u;
                            if (i && !f) {
                                if (c) animateClickScroll(o);
                                else {
                                    const t = $b5d578355fd299c5$var$d(()=>{
                                        animateClickScroll(o);
                                    }, 222);
                                    r = ()=>{
                                        clearTimeout(t);
                                    };
                                }
                                c++;
                            }
                        });
                    };
                    animateClickScroll(0);
                    return ()=>r();
                }
        }
    }))();
let $b5d578355fd299c5$var$Ft;
const $b5d578355fd299c5$var$getNativeScrollbarSize = (t, n, o, s)=>{
    $b5d578355fd299c5$var$appendChildren(t, n);
    const e = $b5d578355fd299c5$var$V(n);
    const c = $b5d578355fd299c5$var$L(n);
    const r = $b5d578355fd299c5$var$fractionalSize(o);
    s && $b5d578355fd299c5$var$removeElements(n);
    return {
        x: c.h - e.h + r.h,
        y: c.w - e.w + r.w
    };
};
const $b5d578355fd299c5$var$getNativeScrollbarsHiding = (t)=>{
    let n = false;
    const o = $b5d578355fd299c5$var$addClass(t, $b5d578355fd299c5$var$Y);
    try {
        n = $b5d578355fd299c5$var$getStyles(t, $b5d578355fd299c5$var$cssProperty("scrollbar-width")) === "none" || $b5d578355fd299c5$var$getStyles(t, "display", "::-webkit-scrollbar") === "none";
    } catch (s) {}
    o();
    return n;
};
const $b5d578355fd299c5$var$getRtlScrollBehavior = (t, n)=>{
    $b5d578355fd299c5$var$setStyles(t, {
        [$b5d578355fd299c5$var$T]: $b5d578355fd299c5$var$R,
        [$b5d578355fd299c5$var$D]: $b5d578355fd299c5$var$R,
        direction: "rtl"
    });
    $b5d578355fd299c5$var$scrollElementTo(t, {
        x: 0
    });
    const o = $b5d578355fd299c5$var$absoluteCoordinates(t);
    const s = $b5d578355fd299c5$var$absoluteCoordinates(n);
    $b5d578355fd299c5$var$scrollElementTo(t, {
        x: -999
    });
    const e = $b5d578355fd299c5$var$absoluteCoordinates(n);
    return {
        i: o.x === s.x,
        n: s.x !== e.x
    };
};
const $b5d578355fd299c5$var$getFlexboxGlue = (t, n)=>{
    const o = $b5d578355fd299c5$var$addClass(t, $b5d578355fd299c5$var$W);
    const s = $b5d578355fd299c5$var$getBoundingClientRect(t);
    const e = $b5d578355fd299c5$var$getBoundingClientRect(n);
    const c = $b5d578355fd299c5$var$equalBCRWH(e, s, true);
    const r = $b5d578355fd299c5$var$addClass(t, $b5d578355fd299c5$var$X);
    const l = $b5d578355fd299c5$var$getBoundingClientRect(t);
    const i = $b5d578355fd299c5$var$getBoundingClientRect(n);
    const a = $b5d578355fd299c5$var$equalBCRWH(i, l, true);
    o();
    r();
    return c && a;
};
const $b5d578355fd299c5$var$createEnvironment = ()=>{
    const { body: t } = document;
    const n = $b5d578355fd299c5$var$createDOM(`<div class="${$b5d578355fd299c5$var$F}"><div></div></div>`);
    const o = n[0];
    const s = o.firstChild;
    const [e, , c] = $b5d578355fd299c5$var$createEventListenerHub();
    const [l, i] = $b5d578355fd299c5$var$createCache({
        o: $b5d578355fd299c5$var$getNativeScrollbarSize(t, o, s),
        u: $b5d578355fd299c5$var$equalXY
    }, $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$getNativeScrollbarSize, t, o, s, true));
    const [a] = i();
    const u = $b5d578355fd299c5$var$getNativeScrollbarsHiding(o);
    const f = {
        x: a.x === 0,
        y: a.y === 0
    };
    const _ = {
        elements: {
            host: null,
            padding: !u,
            viewport: (t)=>u && t === t.ownerDocument.body && t,
            content: false
        },
        scrollbars: {
            slot: true
        },
        cancel: {
            nativeScrollbarsOverlaid: false,
            body: null
        }
    };
    const d = $b5d578355fd299c5$var$assignDeep({}, $b5d578355fd299c5$var$G);
    const v = $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$assignDeep, {}, d);
    const h = $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$assignDeep, {}, _);
    const p = {
        L: a,
        A: f,
        I: u,
        T: $b5d578355fd299c5$var$getStyles(o, "zIndex") === "-1",
        V: !!$b5d578355fd299c5$var$m,
        U: $b5d578355fd299c5$var$getRtlScrollBehavior(o, s),
        B: $b5d578355fd299c5$var$getFlexboxGlue(o, s),
        j: $b5d578355fd299c5$var$bind(e, "r"),
        N: h,
        G: (t)=>$b5d578355fd299c5$var$assignDeep(_, t) && h(),
        q: v,
        F: (t)=>$b5d578355fd299c5$var$assignDeep(d, t) && v(),
        W: $b5d578355fd299c5$var$assignDeep({}, _),
        X: $b5d578355fd299c5$var$assignDeep({}, d)
    };
    $b5d578355fd299c5$var$removeAttr(o, "style");
    $b5d578355fd299c5$var$removeElements(o);
    $b5d578355fd299c5$var$r.addEventListener("resize", ()=>{
        let t;
        if (!u && (!f.x || !f.y)) {
            const n = $b5d578355fd299c5$var$getStaticPluginModuleInstance($b5d578355fd299c5$var$jt);
            const o = n ? n.P() : $b5d578355fd299c5$var$noop;
            t = !!o(p, l);
        }
        c("r", [
            t
        ]);
    });
    return p;
};
const $b5d578355fd299c5$var$getEnvironment = ()=>{
    if (!$b5d578355fd299c5$var$Ft) $b5d578355fd299c5$var$Ft = $b5d578355fd299c5$var$createEnvironment();
    return $b5d578355fd299c5$var$Ft;
};
const $b5d578355fd299c5$var$resolveInitialization = (t, n)=>$b5d578355fd299c5$var$isFunction(n) ? n.apply(0, t) : n;
const $b5d578355fd299c5$var$staticInitializationElement = (t, n, o, s)=>{
    const e = $b5d578355fd299c5$var$isUndefined(s) ? o : s;
    const c = $b5d578355fd299c5$var$resolveInitialization(t, e);
    return c || n.apply(0, t);
};
const $b5d578355fd299c5$var$dynamicInitializationElement = (t, n, o, s)=>{
    const e = $b5d578355fd299c5$var$isUndefined(s) ? o : s;
    const c = $b5d578355fd299c5$var$resolveInitialization(t, e);
    return !!c && ($b5d578355fd299c5$var$isHTMLElement(c) ? c : n.apply(0, t));
};
const $b5d578355fd299c5$var$cancelInitialization = (t, n)=>{
    const { nativeScrollbarsOverlaid: o, body: s } = n || {};
    const { A: e, I: c, N: r } = $b5d578355fd299c5$var$getEnvironment();
    const { nativeScrollbarsOverlaid: l, body: i } = r().cancel;
    const a = o != null ? o : l;
    const u = $b5d578355fd299c5$var$isUndefined(s) ? i : s;
    const f = (e.x || e.y) && a;
    const _ = t && ($b5d578355fd299c5$var$isNull(u) ? !c : u);
    return !!f || !!_;
};
const $b5d578355fd299c5$var$Wt = new WeakMap;
const $b5d578355fd299c5$var$addInstance = (t, n)=>{
    $b5d578355fd299c5$var$Wt.set(t, n);
};
const $b5d578355fd299c5$var$removeInstance = (t)=>{
    $b5d578355fd299c5$var$Wt.delete(t);
};
const $b5d578355fd299c5$var$getInstance = (t)=>$b5d578355fd299c5$var$Wt.get(t);
const $b5d578355fd299c5$var$createEventContentChange = (t, n, o)=>{
    let s = false;
    const e = o ? new WeakMap : false;
    const destroy = ()=>{
        s = true;
    };
    const updateElements = (c)=>{
        if (e && o) {
            const r = o.map((n)=>{
                const [o, s] = n || [];
                const e = s && o ? (c || $b5d578355fd299c5$var$find)(o, t) : [];
                return [
                    e,
                    s
                ];
            });
            $b5d578355fd299c5$var$each(r, (o)=>$b5d578355fd299c5$var$each(o[0], (c)=>{
                    const r = o[1];
                    const l = e.get(c) || [];
                    const i = t.contains(c);
                    if (i && r) {
                        const t = $b5d578355fd299c5$var$addEventListener(c, r.trim(), (o)=>{
                            if (s) {
                                t();
                                e.delete(c);
                            } else n(o);
                        });
                        e.set(c, $b5d578355fd299c5$var$push(l, t));
                    } else {
                        $b5d578355fd299c5$var$runEachAndClear(l);
                        e.delete(c);
                    }
                }));
        }
    };
    updateElements();
    return [
        destroy,
        updateElements
    ];
};
const $b5d578355fd299c5$var$createDOMObserver = (t, n, o, s)=>{
    let e = false;
    const { Y: c, K: r, J: l, Z: i, tt: a, nt: u } = s || {};
    const f = $b5d578355fd299c5$var$debounce(()=>e && o(true), {
        v: 33,
        p: 99
    });
    const [_, d] = $b5d578355fd299c5$var$createEventContentChange(t, f, l);
    const v = c || [];
    const h = r || [];
    const p = $b5d578355fd299c5$var$concat(v, h);
    const observerCallback = (e, c)=>{
        if (!$b5d578355fd299c5$var$isEmptyArray(c)) {
            const r = a || $b5d578355fd299c5$var$noop;
            const l = u || $b5d578355fd299c5$var$noop;
            const f = [];
            const _ = [];
            let v = false;
            let p = false;
            $b5d578355fd299c5$var$each(c, (o)=>{
                const { attributeName: e, target: c, type: a, oldValue: u, addedNodes: d, removedNodes: g } = o;
                const b = a === "attributes";
                const w = a === "childList";
                const y = t === c;
                const S = b && e;
                const m = S ? $b5d578355fd299c5$var$attr(c, e || "") : null;
                const $ = S && u !== m;
                const x = $b5d578355fd299c5$var$inArray(h, e) && $;
                if (n && (w || !y)) {
                    const n = b && $;
                    const a = n && i && $b5d578355fd299c5$var$is(c, i);
                    const _ = a ? !r(c, e, u, m) : !b || n;
                    const v = _ && !l(o, !!a, t, s);
                    $b5d578355fd299c5$var$each(d, (t)=>$b5d578355fd299c5$var$push(f, t));
                    $b5d578355fd299c5$var$each(g, (t)=>$b5d578355fd299c5$var$push(f, t));
                    p = p || v;
                }
                if (!n && y && $ && !r(c, e, u, m)) {
                    $b5d578355fd299c5$var$push(_, e);
                    v = v || x;
                }
            });
            d((t)=>$b5d578355fd299c5$var$deduplicateArray(f).reduce((n, o)=>{
                    $b5d578355fd299c5$var$push(n, $b5d578355fd299c5$var$find(t, o));
                    return $b5d578355fd299c5$var$is(o, t) ? $b5d578355fd299c5$var$push(n, o) : n;
                }, []));
            if (n) {
                !e && p && o(false);
                return [
                    false
                ];
            }
            if (!$b5d578355fd299c5$var$isEmptyArray(_) || v) {
                const t = [
                    $b5d578355fd299c5$var$deduplicateArray(_),
                    v
                ];
                !e && o.apply(0, t);
                return t;
            }
        }
    };
    const g = new $b5d578355fd299c5$var$w($b5d578355fd299c5$var$bind(observerCallback, false));
    return [
        ()=>{
            g.observe(t, {
                attributes: true,
                attributeOldValue: true,
                attributeFilter: p,
                subtree: n,
                childList: n,
                characterData: n
            });
            e = true;
            return ()=>{
                if (e) {
                    _();
                    g.disconnect();
                    e = false;
                }
            };
        },
        ()=>{
            if (e) {
                f.m();
                return observerCallback(true, g.takeRecords());
            }
        }
    ];
};
const $b5d578355fd299c5$var$createSizeObserver = (t, n, o)=>{
    const s = 3333333;
    const { ot: e, st: c } = o || {};
    const r = $b5d578355fd299c5$var$getStaticPluginModuleInstance($b5d578355fd299c5$var$Vt);
    const { U: l } = $b5d578355fd299c5$var$getEnvironment();
    const i = $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$getDirectionIsRTL, t);
    const [a] = $b5d578355fd299c5$var$createCache({
        o: false,
        _: true
    });
    return ()=>{
        const o = [];
        const u = $b5d578355fd299c5$var$createDOM(`<div class="${$b5d578355fd299c5$var$ft}"><div class="${$b5d578355fd299c5$var$dt}"></div></div>`);
        const f = u[0];
        const _ = f.firstChild;
        const onSizeChangedCallbackProxy = (t)=>{
            const o = t instanceof ResizeObserverEntry;
            const c = !o && $b5d578355fd299c5$var$isArray(t);
            let r = false;
            let i = false;
            let u = true;
            if (o) {
                const [n, , o] = a(t.contentRect);
                const s = $b5d578355fd299c5$var$domRectHasDimensions(n);
                const e = $b5d578355fd299c5$var$domRectAppeared(n, o);
                const c = !o;
                i = c || e;
                r = !i && !s;
                u = !r;
            } else if (c) [, u] = t;
            else i = t === true;
            if (e && u) {
                const n = c ? t[0] : $b5d578355fd299c5$var$getDirectionIsRTL(f);
                $b5d578355fd299c5$var$scrollElementTo(f, {
                    x: $b5d578355fd299c5$var$getRTLCompatibleScrollPosition(s, s, n && l),
                    y: s
                });
            }
            if (!r) n({
                et: c ? t : void 0,
                ct: !c,
                st: i
            });
        };
        if ($b5d578355fd299c5$var$S) {
            const t = new $b5d578355fd299c5$var$S((t)=>onSizeChangedCallbackProxy(t.pop()));
            t.observe(_);
            $b5d578355fd299c5$var$push(o, ()=>{
                t.disconnect();
            });
        } else if (r) {
            const [t, n] = r(_, onSizeChangedCallbackProxy, c);
            $b5d578355fd299c5$var$push(o, $b5d578355fd299c5$var$concat([
                $b5d578355fd299c5$var$addClass(f, $b5d578355fd299c5$var$_t),
                $b5d578355fd299c5$var$addEventListener(f, "animationstart", t)
            ], n));
        } else return $b5d578355fd299c5$var$noop;
        if (e) {
            const [t] = $b5d578355fd299c5$var$createCache({
                o: void 0
            }, i);
            $b5d578355fd299c5$var$push(o, $b5d578355fd299c5$var$addEventListener(f, "scroll", (n)=>{
                const o = t();
                const [s, e, c] = o;
                if (e) {
                    $b5d578355fd299c5$var$removeClass(_, "ltr rtl");
                    $b5d578355fd299c5$var$addClass(_, s ? "rtl" : "ltr");
                    onSizeChangedCallbackProxy([
                        !!s,
                        e,
                        c
                    ]);
                }
                $b5d578355fd299c5$var$stopPropagation(n);
            }));
        }
        return $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$runEachAndClear, $b5d578355fd299c5$var$push(o, $b5d578355fd299c5$var$appendChildren(t, f)));
    };
};
const $b5d578355fd299c5$var$createTrinsicObserver = (t, n)=>{
    let o;
    const isHeightIntrinsic = (t)=>t.h === 0 || t.isIntersecting || t.intersectionRatio > 0;
    const s = $b5d578355fd299c5$var$createDiv($b5d578355fd299c5$var$gt);
    const [e] = $b5d578355fd299c5$var$createCache({
        o: false
    });
    const triggerOnTrinsicChangedCallback = (t, o)=>{
        if (t) {
            const s = e(isHeightIntrinsic(t));
            const [, c] = s;
            return c && !o && n(s) && [
                s
            ];
        }
    };
    const intersectionObserverCallback = (t, n)=>triggerOnTrinsicChangedCallback(n.pop(), t);
    return [
        ()=>{
            const n = [];
            if ($b5d578355fd299c5$var$y) {
                o = new $b5d578355fd299c5$var$y($b5d578355fd299c5$var$bind(intersectionObserverCallback, false), {
                    root: t
                });
                o.observe(s);
                $b5d578355fd299c5$var$push(n, ()=>{
                    o.disconnect();
                });
            } else {
                const onSizeChanged = ()=>{
                    const t = $b5d578355fd299c5$var$L(s);
                    triggerOnTrinsicChangedCallback(t);
                };
                $b5d578355fd299c5$var$push(n, $b5d578355fd299c5$var$createSizeObserver(s, onSizeChanged)());
                onSizeChanged();
            }
            return $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$runEachAndClear, $b5d578355fd299c5$var$push(n, $b5d578355fd299c5$var$appendChildren(t, s)));
        },
        ()=>o && intersectionObserverCallback(true, o.takeRecords())
    ];
};
const $b5d578355fd299c5$var$createObserversSetup = (t, n)=>{
    let o;
    let s;
    let e;
    let c;
    let r;
    const { I: l } = $b5d578355fd299c5$var$getEnvironment();
    const i = `[${$b5d578355fd299c5$var$J}]`;
    const a = `[${$b5d578355fd299c5$var$et}]`;
    const u = [
        "tabindex"
    ];
    const f = [
        "wrap",
        "cols",
        "rows"
    ];
    const _ = [
        "id",
        "class",
        "style",
        "open"
    ];
    const d = {
        rt: false,
        lt: $b5d578355fd299c5$var$getDirectionIsRTL(t.it)
    };
    const { it: v, ut: h, ft: p, _t: g, dt: b, vt: w, ht: y } = t;
    const { B: m, j: $ } = $b5d578355fd299c5$var$getEnvironment();
    const [x] = $b5d578355fd299c5$var$createCache({
        u: $b5d578355fd299c5$var$equalWH,
        o: {
            w: 0,
            h: 0
        }
    }, ()=>{
        const t = w($b5d578355fd299c5$var$lt, $b5d578355fd299c5$var$tt);
        const n = w($b5d578355fd299c5$var$ct, "");
        const o = n && $b5d578355fd299c5$var$getElmentScroll(h);
        y($b5d578355fd299c5$var$lt, $b5d578355fd299c5$var$tt);
        y($b5d578355fd299c5$var$ct, "");
        y("", $b5d578355fd299c5$var$st, true);
        const s = $b5d578355fd299c5$var$U(p);
        const e = $b5d578355fd299c5$var$U(h);
        const c = $b5d578355fd299c5$var$fractionalSize(h);
        y($b5d578355fd299c5$var$lt, $b5d578355fd299c5$var$tt, t);
        y($b5d578355fd299c5$var$ct, "", n);
        y("", $b5d578355fd299c5$var$st);
        $b5d578355fd299c5$var$scrollElementTo(h, o);
        return {
            w: e.w + s.w + c.w,
            h: e.h + s.h + c.h
        };
    });
    const O = g ? f : $b5d578355fd299c5$var$concat(_, f);
    const C = $b5d578355fd299c5$var$debounce(n, {
        v: ()=>o,
        p: ()=>s,
        S (t, n) {
            const [o] = t;
            const [s] = n;
            return [
                $b5d578355fd299c5$var$concat($b5d578355fd299c5$var$keys(o), $b5d578355fd299c5$var$keys(s)).reduce((t, n)=>{
                    t[n] = o[n] || s[n];
                    return t;
                }, {})
            ];
        }
    });
    const updateViewportAttrsFromHost = (t)=>{
        $b5d578355fd299c5$var$each(t || u, (t)=>{
            if ($b5d578355fd299c5$var$inArray(u, t)) {
                const n = $b5d578355fd299c5$var$attr(v, t);
                if ($b5d578355fd299c5$var$isString(n)) $b5d578355fd299c5$var$attr(h, t, n);
                else $b5d578355fd299c5$var$removeAttr(h, t);
            }
        });
    };
    const onTrinsicChanged = (t, o)=>{
        const [s, e] = t;
        const c = {
            gt: e
        };
        $b5d578355fd299c5$var$assignDeep(d, {
            rt: s
        });
        !o && n(c);
        return c;
    };
    const onSizeChanged = ({ ct: t, et: o, st: s })=>{
        const e = t && !s && !o;
        const c = !e && l ? C : n;
        const [r, i] = o || [];
        o && $b5d578355fd299c5$var$assignDeep(d, {
            lt: r
        });
        c({
            ct: t || s,
            st: s,
            bt: i
        });
    };
    const onContentMutation = (t, o)=>{
        const [, s] = x();
        const e = {
            wt: s
        };
        const c = t ? n : C;
        s && !o && c(e);
        return e;
    };
    const onHostMutation = (t, n, o)=>{
        const s = {
            yt: n
        };
        if (n && !o) C(s);
        else if (!b) updateViewportAttrsFromHost(t);
        return s;
    };
    const [H, z] = p || !m ? $b5d578355fd299c5$var$createTrinsicObserver(v, onTrinsicChanged) : [];
    const I = !b && $b5d578355fd299c5$var$createSizeObserver(v, onSizeChanged, {
        st: true,
        ot: true
    });
    const [A, E] = $b5d578355fd299c5$var$createDOMObserver(v, false, onHostMutation, {
        K: _,
        Y: $b5d578355fd299c5$var$concat(_, u)
    });
    const T = b && $b5d578355fd299c5$var$S && new $b5d578355fd299c5$var$S((t)=>{
        const n = t[t.length - 1].contentRect;
        onSizeChanged({
            ct: true,
            st: $b5d578355fd299c5$var$domRectAppeared(n, r)
        });
        r = n;
    });
    return [
        ()=>{
            updateViewportAttrsFromHost();
            T && T.observe(v);
            const t = I && I();
            const n = H && H();
            const o = A();
            const s = $((t)=>{
                const [, n] = x();
                C({
                    St: t,
                    wt: n
                });
            });
            return ()=>{
                T && T.disconnect();
                t && t();
                n && n();
                c && c();
                o();
                s();
            };
        },
        ({ $t: t, xt: n, Ot: r })=>{
            const l = {};
            const [u] = t("update.ignoreMutation");
            const [f, _] = t("update.attributes");
            const [d, v] = t("update.elementEvents");
            const [g, w] = t("update.debounce");
            const y = v || _;
            const S = n || r;
            const ignoreMutationFromOptions = (t)=>$b5d578355fd299c5$var$isFunction(u) && u(t);
            if (y) {
                e && e();
                c && c();
                const [t, n] = $b5d578355fd299c5$var$createDOMObserver(p || h, true, onContentMutation, {
                    Y: $b5d578355fd299c5$var$concat(O, f || []),
                    J: d,
                    Z: i,
                    nt: (t, n)=>{
                        const { target: o, attributeName: s } = t;
                        const e = !n && s && !b ? $b5d578355fd299c5$var$liesBetween(o, i, a) : false;
                        return e || !!$b5d578355fd299c5$var$closest(o, `.${$b5d578355fd299c5$var$yt}`) || !!ignoreMutationFromOptions(t);
                    }
                });
                c = t();
                e = n;
            }
            if (w) {
                C.m();
                if ($b5d578355fd299c5$var$isArray(g)) {
                    const t = g[0];
                    const n = g[1];
                    o = $b5d578355fd299c5$var$isNumber(t) && t;
                    s = $b5d578355fd299c5$var$isNumber(n) && n;
                } else if ($b5d578355fd299c5$var$isNumber(g)) {
                    o = g;
                    s = false;
                } else {
                    o = false;
                    s = false;
                }
            }
            if (S) {
                const t = E();
                const n = z && z();
                const o = e && e();
                t && $b5d578355fd299c5$var$assignDeep(l, onHostMutation(t[0], t[1], S));
                n && $b5d578355fd299c5$var$assignDeep(l, onTrinsicChanged(n[0], S));
                o && $b5d578355fd299c5$var$assignDeep(l, onContentMutation(o[0], S));
            }
            return l;
        },
        d
    ];
};
const $b5d578355fd299c5$var$capNumber = (t, n, o)=>$b5d578355fd299c5$var$l(t, $b5d578355fd299c5$var$i(n, o));
const $b5d578355fd299c5$var$getScrollbarHandleOffsetPercent = (t, n, o)=>{
    const s = $b5d578355fd299c5$var$a(n);
    const [e, c] = $b5d578355fd299c5$var$getRTLCompatibleScrollBounds(s, o);
    const r = (c - t) / c;
    const l = t / e;
    const i = t / c;
    const u = o ? o.n ? r : o.i ? l : i : i;
    return $b5d578355fd299c5$var$capNumber(0, 1, u);
};
const $b5d578355fd299c5$var$getScrollbarHandleLengthRatio = (t, n, o)=>{
    if (o) {
        const t = n ? $b5d578355fd299c5$var$k : $b5d578355fd299c5$var$M;
        const { Ct: s, Ht: e } = o;
        const c = $b5d578355fd299c5$var$getBoundingClientRect(e)[t];
        const r = $b5d578355fd299c5$var$getBoundingClientRect(s)[t];
        return $b5d578355fd299c5$var$capNumber(0, 1, c / r);
    }
    const s = n ? "x" : "y";
    const { zt: e, It: c } = t;
    const r = c[s];
    const l = e[s];
    return $b5d578355fd299c5$var$capNumber(0, 1, r / (r + l));
};
const $b5d578355fd299c5$var$getScrollbarHandleOffsetRatio = (t, n, o, s)=>{
    const e = $b5d578355fd299c5$var$getScrollbarHandleLengthRatio(t, s, n);
    return 1 / e * (1 - e) * o;
};
const $b5d578355fd299c5$var$createScrollbarsSetupElements = (t, n, o, s)=>{
    const { N: e, T: c } = $b5d578355fd299c5$var$getEnvironment();
    const { scrollbars: r } = e();
    const { slot: l } = r;
    const { At: i, it: a, ut: u, Et: f, Tt: _, Dt: v, dt: h } = n;
    const { scrollbars: p } = f ? {} : t;
    const { slot: g } = p || {};
    const b = new Map;
    const initScrollTimeline = (t)=>$b5d578355fd299c5$var$m && new $b5d578355fd299c5$var$m({
            source: _,
            axis: t
        });
    const w = initScrollTimeline("x");
    const y = initScrollTimeline("y");
    const S = $b5d578355fd299c5$var$dynamicInitializationElement([
        i,
        a,
        u
    ], ()=>h && v ? i : a, l, g);
    const doRefreshScrollbarOffset = (t)=>h && !v && $b5d578355fd299c5$var$parent(t) === u;
    const getScrollbarOffsetKeyframes = (t, n, o)=>{
        const s = .5 * (o ? 1 : -1);
        const e = n && o ? -1 : 1;
        return {
            transform: [
                $b5d578355fd299c5$var$getTrasformTranslateValue($b5d578355fd299c5$var$numberToCssPx(0 + s), n),
                $b5d578355fd299c5$var$getTrasformTranslateValue($b5d578355fd299c5$var$numberToCssPx(t * e + s), n)
            ]
        };
    };
    const addDirectionRTLKeyframes = (t, n)=>$b5d578355fd299c5$var$assignDeep(t, n ? {
            clear: [
                "left"
            ]
        } : {});
    const cancelElementAnimations = (t)=>{
        b.forEach((n, o)=>{
            const s = t ? $b5d578355fd299c5$var$inArray($b5d578355fd299c5$var$createOrKeepArray(t), o) : true;
            if (s) {
                $b5d578355fd299c5$var$each(n || [], (t)=>{
                    t && t.cancel();
                });
                b.delete(o);
            }
        });
    };
    const setElementAnimation = (t, n, o, s)=>{
        const e = b.get(t) || [];
        const c = e.find((t)=>t && t.timeline === n);
        if (c) c.effect = new KeyframeEffect(t, o, {
            composite: s
        });
        else b.set(t, $b5d578355fd299c5$var$concat(e, [
            t.animate(o, {
                timeline: n,
                composite: s
            })
        ]));
    };
    const scrollbarStructureAddRemoveClass = (t, n, o)=>{
        const s = o ? $b5d578355fd299c5$var$addClass : $b5d578355fd299c5$var$removeClass;
        $b5d578355fd299c5$var$each(t, (t)=>{
            s(t.kt, n);
        });
    };
    const scrollbarStyle = (t, n)=>{
        $b5d578355fd299c5$var$each(t, (t)=>{
            const [o, s] = n(t);
            $b5d578355fd299c5$var$setStyles(o, s);
        });
    };
    const scrollbarStructureRefreshHandleLength = (t, n)=>{
        scrollbarStyle(t, (t)=>{
            const { Ht: s } = t;
            return [
                s,
                {
                    [n ? $b5d578355fd299c5$var$k : $b5d578355fd299c5$var$M]: $b5d578355fd299c5$var$ratioToCssPercent($b5d578355fd299c5$var$getScrollbarHandleLengthRatio(o, n))
                }
            ];
        });
    };
    const scrollbarStructureRefreshHandleOffset = (t, n)=>{
        if (w && y) $b5d578355fd299c5$var$each(t, (t)=>{
            const { kt: s, Ht: e } = t;
            const c = $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$getScrollbarHandleOffsetRatio, o, t);
            const r = n && $b5d578355fd299c5$var$getDirectionIsRTL(s);
            const l = c(r ? 1 : 0, n);
            const i = c(r ? 0 : 1, n);
            setElementAnimation(e, n ? w : y, addDirectionRTLKeyframes({
                transform: [
                    $b5d578355fd299c5$var$getTrasformTranslateValue($b5d578355fd299c5$var$ratioToCssPercent(l), n),
                    $b5d578355fd299c5$var$getTrasformTranslateValue($b5d578355fd299c5$var$ratioToCssPercent(i), n)
                ]
            }, r));
        });
        else scrollbarStyle(t, (t)=>{
            const { Ht: s, kt: e } = t;
            const { U: c } = $b5d578355fd299c5$var$getEnvironment();
            const r = n ? "x" : "y";
            const { zt: l } = o;
            const i = $b5d578355fd299c5$var$getDirectionIsRTL(e);
            const a = $b5d578355fd299c5$var$getScrollbarHandleOffsetRatio(o, t, $b5d578355fd299c5$var$getScrollbarHandleOffsetPercent($b5d578355fd299c5$var$getElmentScroll(_)[r], l[r], n && i && c), n);
            return [
                s,
                {
                    transform: $b5d578355fd299c5$var$getTrasformTranslateValue($b5d578355fd299c5$var$ratioToCssPercent(a), n)
                }
            ];
        });
    };
    const styleScrollbarPosition = (t)=>{
        const { kt: n } = t;
        const o = doRefreshScrollbarOffset(n) && n;
        const { x: s, y: e } = $b5d578355fd299c5$var$getElmentScroll(_);
        return [
            o,
            {
                transform: o ? $b5d578355fd299c5$var$getTrasformTranslateValue({
                    x: $b5d578355fd299c5$var$numberToCssPx(s),
                    y: $b5d578355fd299c5$var$numberToCssPx(e)
                }) : ""
            }
        ];
    };
    const $ = [];
    const x = [];
    const O = [];
    const scrollbarsAddRemoveClass = (t, n, o)=>{
        const s = $b5d578355fd299c5$var$isBoolean(o);
        const e = s ? o : true;
        const c = s ? !o : true;
        e && scrollbarStructureAddRemoveClass(x, t, n);
        c && scrollbarStructureAddRemoveClass(O, t, n);
    };
    const refreshScrollbarsHandleLength = ()=>{
        scrollbarStructureRefreshHandleLength(x, true);
        scrollbarStructureRefreshHandleLength(O);
    };
    const refreshScrollbarsHandleOffset = ()=>{
        scrollbarStructureRefreshHandleOffset(x, true);
        scrollbarStructureRefreshHandleOffset(O);
    };
    const refreshScrollbarsScrollbarOffset = ()=>{
        if (h) {
            if (w && y) {
                const { zt: t } = o;
                const n = !!x.find(({ kt: t })=>$b5d578355fd299c5$var$getDirectionIsRTL(t));
                const setScrollbarElementAnimation = (t, o, s, e, c)=>setElementAnimation(t, o, addDirectionRTLKeyframes(getScrollbarOffsetKeyframes(s, e, c), n), "add");
                $b5d578355fd299c5$var$each($b5d578355fd299c5$var$concat(O, x), ({ kt: o })=>{
                    if (doRefreshScrollbarOffset(o)) {
                        setScrollbarElementAnimation(o, w, t.x, true, n);
                        setScrollbarElementAnimation(o, y, t.y);
                    } else cancelElementAnimations(o);
                });
            } else {
                scrollbarStyle(x, styleScrollbarPosition);
                scrollbarStyle(O, styleScrollbarPosition);
            }
        }
    };
    const generateScrollbarDOM = (t)=>{
        const n = t ? $b5d578355fd299c5$var$mt : $b5d578355fd299c5$var$$t;
        const o = t ? x : O;
        const e = $b5d578355fd299c5$var$isEmptyArray(o) ? $b5d578355fd299c5$var$zt : "";
        const r = $b5d578355fd299c5$var$createDiv(`${$b5d578355fd299c5$var$yt} ${n} ${e}`);
        const l = $b5d578355fd299c5$var$createDiv($b5d578355fd299c5$var$xt);
        const i = $b5d578355fd299c5$var$createDiv($b5d578355fd299c5$var$Ot);
        const a = {
            kt: r,
            Ct: l,
            Ht: i
        };
        if (!c) $b5d578355fd299c5$var$addClass(r, $b5d578355fd299c5$var$bt);
        $b5d578355fd299c5$var$push(o, a);
        $b5d578355fd299c5$var$push($, [
            $b5d578355fd299c5$var$appendChildren(r, l),
            $b5d578355fd299c5$var$appendChildren(l, i),
            $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$removeElements, r),
            cancelElementAnimations,
            s(a, scrollbarsAddRemoveClass, scrollbarStructureRefreshHandleOffset, t)
        ]);
        return a;
    };
    const C = $b5d578355fd299c5$var$bind(generateScrollbarDOM, true);
    const H = $b5d578355fd299c5$var$bind(generateScrollbarDOM, false);
    const appendElements = ()=>{
        $b5d578355fd299c5$var$appendChildren(S, x[0].kt);
        $b5d578355fd299c5$var$appendChildren(S, O[0].kt);
        $b5d578355fd299c5$var$d(()=>{
            scrollbarsAddRemoveClass($b5d578355fd299c5$var$zt);
        }, 300);
        return $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$runEachAndClear, $);
    };
    C();
    H();
    return [
        {
            Mt: refreshScrollbarsHandleLength,
            Rt: refreshScrollbarsHandleOffset,
            Pt: refreshScrollbarsScrollbarOffset,
            Lt: scrollbarsAddRemoveClass,
            Vt: {
                V: w,
                Ut: x,
                Bt: C,
                jt: $b5d578355fd299c5$var$bind(scrollbarStyle, x)
            },
            Nt: {
                V: y,
                Ut: O,
                Bt: H,
                jt: $b5d578355fd299c5$var$bind(scrollbarStyle, O)
            }
        },
        appendElements
    ];
};
const $b5d578355fd299c5$var$createScrollbarsSetupEvents = (t, n, o)=>{
    const { it: s, Tt: e, Gt: c } = n;
    return (n, r, l, i)=>{
        const { kt: u, Ct: f, Ht: _ } = n;
        const [d, v] = $b5d578355fd299c5$var$selfClearTimeout(333);
        const [h, p] = $b5d578355fd299c5$var$selfClearTimeout();
        const g = $b5d578355fd299c5$var$bind(l, [
            n
        ], i);
        const b = !!e.scrollBy;
        const w = `client${i ? "X" : "Y"}`;
        const y = i ? $b5d578355fd299c5$var$k : $b5d578355fd299c5$var$M;
        const S = i ? "left" : "top";
        const m = i ? "w" : "h";
        const $ = i ? "x" : "y";
        const isAffectingTransition = (t)=>t.propertyName.indexOf(y) > -1;
        const createInteractiveScrollEvents = ()=>{
            const n = "pointerup pointerleave pointercancel lostpointercapture";
            const createRelativeHandleMove = (t, n)=>(s)=>{
                    const { zt: c } = o;
                    const r = $b5d578355fd299c5$var$L(f)[m] - $b5d578355fd299c5$var$L(_)[m];
                    const l = n * s / r;
                    const i = l * c[$];
                    $b5d578355fd299c5$var$scrollElementTo(e, {
                        [$]: t + i
                    });
                };
            return $b5d578355fd299c5$var$addEventListener(f, "pointerdown", (o)=>{
                const r = $b5d578355fd299c5$var$closest(o.target, `.${$b5d578355fd299c5$var$Ot}`) === _;
                const l = r ? _ : f;
                const i = t.scrollbars;
                const { button: u, isPrimary: d, pointerType: v } = o;
                const { pointers: h } = i;
                const p = u === 0 && d && i[r ? "dragScroll" : "clickScroll"] && (h || []).includes(v);
                if (p) {
                    const t = !r && o.shiftKey;
                    const i = $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$getBoundingClientRect, _);
                    const u = $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$getBoundingClientRect, f);
                    const getHandleOffset = (t, n)=>(t || i())[S] - (n || u())[S];
                    const d = $b5d578355fd299c5$var$a($b5d578355fd299c5$var$getBoundingClientRect(e)[y]) / $b5d578355fd299c5$var$L(e)[m] || 1;
                    const v = createRelativeHandleMove($b5d578355fd299c5$var$getElmentScroll(e)[$] || 0, 1 / d);
                    const h = o[w];
                    const p = i();
                    const g = u();
                    const b = p[y];
                    const x = getHandleOffset(p, g) + b / 2;
                    const O = h - g[S];
                    const C = r ? 0 : O - x;
                    const releasePointerCapture = (t)=>{
                        $b5d578355fd299c5$var$runEachAndClear(H);
                        l.releasePointerCapture(t.pointerId);
                    };
                    const H = [
                        $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$attrClass, s, $b5d578355fd299c5$var$J, $b5d578355fd299c5$var$ot),
                        $b5d578355fd299c5$var$addEventListener(c, n, releasePointerCapture),
                        $b5d578355fd299c5$var$addEventListener(c, "selectstart", (t)=>$b5d578355fd299c5$var$preventDefault(t), {
                            $: false
                        }),
                        $b5d578355fd299c5$var$addEventListener(f, n, releasePointerCapture),
                        $b5d578355fd299c5$var$addEventListener(f, "pointermove", (n)=>{
                            const o = n[w] - h;
                            if (r || t) v(C + o);
                        })
                    ];
                    $b5d578355fd299c5$var$attrClass(s, $b5d578355fd299c5$var$J, $b5d578355fd299c5$var$ot, true);
                    l.setPointerCapture(o.pointerId);
                    if (t) v(C);
                    else if (!r) {
                        const t = $b5d578355fd299c5$var$getStaticPluginModuleInstance($b5d578355fd299c5$var$Gt);
                        t && $b5d578355fd299c5$var$push(H, t(v, getHandleOffset, C, b, O));
                    }
                }
            });
        };
        let x = true;
        return $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$runEachAndClear, [
            $b5d578355fd299c5$var$addEventListener(u, "pointerenter", ()=>{
                r($b5d578355fd299c5$var$It, true);
            }),
            $b5d578355fd299c5$var$addEventListener(u, "pointerleave pointercancel", ()=>{
                r($b5d578355fd299c5$var$It, false);
            }),
            $b5d578355fd299c5$var$addEventListener(u, "wheel", (t)=>{
                const { deltaX: n, deltaY: o, deltaMode: c } = t;
                if (b && x && c === 0 && $b5d578355fd299c5$var$parent(u) === s) e.scrollBy({
                    left: n,
                    top: o,
                    behavior: "smooth"
                });
                x = false;
                r($b5d578355fd299c5$var$Dt, true);
                d(()=>{
                    x = true;
                    r($b5d578355fd299c5$var$Dt);
                });
                $b5d578355fd299c5$var$preventDefault(t);
            }, {
                $: false,
                O: true
            }),
            $b5d578355fd299c5$var$addEventListener(_, "transitionstart", (t)=>{
                if (isAffectingTransition(t)) {
                    const animateHandleOffset = ()=>{
                        g();
                        h(animateHandleOffset);
                    };
                    animateHandleOffset();
                }
            }),
            $b5d578355fd299c5$var$addEventListener(_, "transitionend transitioncancel", (t)=>{
                if (isAffectingTransition(t)) {
                    p();
                    g();
                }
            }),
            $b5d578355fd299c5$var$addEventListener(u, "mousedown", $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$addEventListener, c, "click", $b5d578355fd299c5$var$stopPropagation, {
                C: true,
                O: true
            }), {
                O: true
            }),
            createInteractiveScrollEvents(),
            v,
            p
        ]);
    };
};
const $b5d578355fd299c5$var$createScrollbarsSetup = (t, n, o, s, e, c)=>{
    let r;
    let l;
    let i;
    let a;
    let u;
    let f = $b5d578355fd299c5$var$noop;
    let _ = 0;
    const [d, v] = $b5d578355fd299c5$var$selfClearTimeout();
    const [h, p] = $b5d578355fd299c5$var$selfClearTimeout();
    const [g, b] = $b5d578355fd299c5$var$selfClearTimeout(100);
    const [w, y] = $b5d578355fd299c5$var$selfClearTimeout(100);
    const [S, m] = $b5d578355fd299c5$var$selfClearTimeout(100);
    const [$, x] = $b5d578355fd299c5$var$selfClearTimeout(()=>_);
    const [O, C] = $b5d578355fd299c5$var$createScrollbarsSetupElements(t, e, s, $b5d578355fd299c5$var$createScrollbarsSetupEvents(n, e, s));
    const { it: H, qt: z, Dt: I } = e;
    const { Lt: A, Mt: E, Rt: T, Pt: D } = O;
    const manageAutoHideSuspension = (t)=>{
        A($b5d578355fd299c5$var$Et, t, true);
        A($b5d578355fd299c5$var$Et, t, false);
    };
    const manageScrollbarsAutoHide = (t, n)=>{
        x();
        if (t) A($b5d578355fd299c5$var$Tt);
        else {
            const t = $b5d578355fd299c5$var$bind(A, $b5d578355fd299c5$var$Tt, true);
            if (_ > 0 && !n) $(t);
            else t();
        }
    };
    const isHoverablePointerType = (t)=>t.pointerType === "mouse";
    const onHostMouseEnter = (t)=>{
        if (isHoverablePointerType(t)) {
            a = l;
            a && manageScrollbarsAutoHide(true);
        }
    };
    const k = [
        b,
        x,
        y,
        m,
        p,
        v,
        ()=>f(),
        $b5d578355fd299c5$var$addEventListener(H, "pointerover", onHostMouseEnter, {
            C: true
        }),
        $b5d578355fd299c5$var$addEventListener(H, "pointerenter", onHostMouseEnter),
        $b5d578355fd299c5$var$addEventListener(H, "pointerleave", (t)=>{
            if (isHoverablePointerType(t)) {
                a = false;
                l && manageScrollbarsAutoHide(false);
            }
        }),
        $b5d578355fd299c5$var$addEventListener(H, "pointermove", (t)=>{
            isHoverablePointerType(t) && r && d(()=>{
                b();
                manageScrollbarsAutoHide(true);
                w(()=>{
                    r && manageScrollbarsAutoHide(false);
                });
            });
        }),
        $b5d578355fd299c5$var$addEventListener(z, "scroll", (t)=>{
            h(()=>{
                T();
                i && manageScrollbarsAutoHide(true);
                g(()=>{
                    i && !a && manageScrollbarsAutoHide(false);
                });
            });
            c(t);
            D();
        })
    ];
    return [
        ()=>$b5d578355fd299c5$var$bind($b5d578355fd299c5$var$runEachAndClear, $b5d578355fd299c5$var$push(k, C())),
        ({ $t: t, Ot: n, Ft: e, Wt: c })=>{
            const { Xt: a, Yt: d, Kt: v } = c || {};
            const { bt: h, st: p } = e || {};
            const { lt: g } = o;
            const { A: b } = $b5d578355fd299c5$var$getEnvironment();
            const { zt: w, Jt: y, Zt: m } = s;
            const [$, x] = t("showNativeOverlaidScrollbars");
            const [O, C] = t("scrollbars.theme");
            const [H, k] = t("scrollbars.visibility");
            const [M, R] = t("scrollbars.autoHide");
            const [P, L] = t("scrollbars.autoHideSuspend");
            const [V] = t("scrollbars.autoHideDelay");
            const [U, B] = t("scrollbars.dragScroll");
            const [j, N] = t("scrollbars.clickScroll");
            const G = p && !n;
            const q = m.x || m.y;
            const F = a || d || h || n;
            const W = v || k;
            const X = $ && b.x && b.y;
            const setScrollbarVisibility = (t, n)=>{
                const o = H === "visible" || H === "auto" && t === "scroll";
                A($b5d578355fd299c5$var$Ct, o, n);
                return o;
            };
            _ = V;
            if (G) {
                if (P && q) {
                    manageAutoHideSuspension(false);
                    f();
                    S(()=>{
                        f = $b5d578355fd299c5$var$addEventListener(z, "scroll", $b5d578355fd299c5$var$bind(manageAutoHideSuspension, true), {
                            C: true
                        });
                    });
                } else manageAutoHideSuspension(true);
            }
            if (x) A($b5d578355fd299c5$var$wt, X);
            if (C) {
                A(u);
                A(O, true);
                u = O;
            }
            if (L && !P) manageAutoHideSuspension(true);
            if (R) {
                r = M === "move";
                l = M === "leave";
                i = M !== "never";
                manageScrollbarsAutoHide(!i, true);
            }
            if (B) A($b5d578355fd299c5$var$Mt, U);
            if (N) A($b5d578355fd299c5$var$kt, j);
            if (W) {
                const t = setScrollbarVisibility(y.x, true);
                const n = setScrollbarVisibility(y.y, false);
                const o = t && n;
                A($b5d578355fd299c5$var$Ht, !o);
            }
            if (F) {
                E();
                T();
                D();
                A($b5d578355fd299c5$var$At, !w.x, true);
                A($b5d578355fd299c5$var$At, !w.y, false);
                A($b5d578355fd299c5$var$St, g && !I);
            }
        },
        {},
        O
    ];
};
const $b5d578355fd299c5$var$createStructureSetupElements = (t)=>{
    const n = $b5d578355fd299c5$var$getEnvironment();
    const { N: o, I: s } = n;
    const e = $b5d578355fd299c5$var$getStaticPluginModuleInstance($b5d578355fd299c5$var$jt);
    const c = e && e.H;
    const { elements: r } = o();
    const { host: l, padding: i, viewport: a, content: u } = r;
    const f = $b5d578355fd299c5$var$isHTMLElement(t);
    const _ = f ? {} : t;
    const { elements: d } = _;
    const { host: v, padding: h, viewport: p, content: g } = d || {};
    const b = f ? t : _.target;
    const w = $b5d578355fd299c5$var$is(b, "textarea");
    const y = b.ownerDocument;
    const S = y.documentElement;
    const m = b === y.body;
    const $ = y.defaultView;
    const x = $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$staticInitializationElement, [
        b
    ]);
    const O = $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$dynamicInitializationElement, [
        b
    ]);
    const C = $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$resolveInitialization, [
        b
    ]);
    const H = $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$createDiv, "");
    const z = $b5d578355fd299c5$var$bind(x, H, a);
    const I = $b5d578355fd299c5$var$bind(O, H, u);
    const A = z(p);
    const E = A === b;
    const T = E && m;
    const D = !E && I(g);
    const k = !E && $b5d578355fd299c5$var$isHTMLElement(A) && A === D;
    const M = k && !!C(u);
    const R = M ? z() : A;
    const P = M ? D : I();
    const L = k ? R : A;
    const V = T ? S : L;
    const U = w ? x(H, l, v) : b;
    const B = T ? V : U;
    const j = k ? P : D;
    const N = y.activeElement;
    const G = !E && $.top === $ && N === b;
    const q = {
        At: b,
        it: B,
        ut: V,
        Qt: !E && O(H, i, h),
        ft: j,
        tn: !E && !s && c && c(n),
        Tt: T ? S : V,
        qt: T ? y : V,
        nn: $,
        Gt: y,
        _t: w,
        Dt: m,
        Et: f,
        dt: E,
        sn: k,
        vt: (t, n)=>$b5d578355fd299c5$var$hasAttrClass(V, E ? $b5d578355fd299c5$var$J : $b5d578355fd299c5$var$et, E ? n : t),
        ht: (t, n, o)=>$b5d578355fd299c5$var$attrClass(V, E ? $b5d578355fd299c5$var$J : $b5d578355fd299c5$var$et, E ? n : t, o)
    };
    const F = $b5d578355fd299c5$var$keys(q).reduce((t, n)=>{
        const o = q[n];
        return $b5d578355fd299c5$var$push(t, o && $b5d578355fd299c5$var$isHTMLElement(o) && !$b5d578355fd299c5$var$parent(o) ? o : false);
    }, []);
    const elementIsGenerated = (t)=>t ? $b5d578355fd299c5$var$inArray(F, t) : null;
    const { At: W, it: X, Qt: tt, ut: nt, ft: ot, tn: st } = q;
    const ct = [
        ()=>{
            $b5d578355fd299c5$var$removeAttr(X, $b5d578355fd299c5$var$J);
            $b5d578355fd299c5$var$removeAttr(X, $b5d578355fd299c5$var$K);
            $b5d578355fd299c5$var$removeAttr(W, $b5d578355fd299c5$var$K);
            if (m) {
                $b5d578355fd299c5$var$removeAttr(S, $b5d578355fd299c5$var$J);
                $b5d578355fd299c5$var$removeAttr(S, $b5d578355fd299c5$var$K);
            }
        }
    ];
    const lt = w && elementIsGenerated(X);
    let at = w ? W : $b5d578355fd299c5$var$contents([
        ot,
        nt,
        tt,
        X,
        W
    ].find((t)=>elementIsGenerated(t) === false));
    const ft = T ? W : ot || nt;
    const _t = $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$runEachAndClear, ct);
    const appendElements = ()=>{
        $b5d578355fd299c5$var$attr(X, $b5d578355fd299c5$var$J, E ? "viewport" : "host");
        $b5d578355fd299c5$var$attr(tt, $b5d578355fd299c5$var$it, "");
        $b5d578355fd299c5$var$attr(ot, $b5d578355fd299c5$var$ut, "");
        if (!E) $b5d578355fd299c5$var$attr(nt, $b5d578355fd299c5$var$et, "");
        const t = m && !E ? $b5d578355fd299c5$var$addClass($b5d578355fd299c5$var$parent(b), $b5d578355fd299c5$var$Y) : $b5d578355fd299c5$var$noop;
        const unwrap = (t)=>{
            $b5d578355fd299c5$var$appendChildren($b5d578355fd299c5$var$parent(t), $b5d578355fd299c5$var$contents(t));
            $b5d578355fd299c5$var$removeElements(t);
        };
        if (lt) {
            $b5d578355fd299c5$var$insertAfter(W, X);
            $b5d578355fd299c5$var$push(ct, ()=>{
                $b5d578355fd299c5$var$insertAfter(X, W);
                $b5d578355fd299c5$var$removeElements(X);
            });
        }
        $b5d578355fd299c5$var$appendChildren(ft, at);
        $b5d578355fd299c5$var$appendChildren(X, tt);
        $b5d578355fd299c5$var$appendChildren(tt || X, !E && nt);
        $b5d578355fd299c5$var$appendChildren(nt, ot);
        $b5d578355fd299c5$var$push(ct, ()=>{
            t();
            $b5d578355fd299c5$var$removeAttr(tt, $b5d578355fd299c5$var$it);
            $b5d578355fd299c5$var$removeAttr(ot, $b5d578355fd299c5$var$ut);
            $b5d578355fd299c5$var$removeAttr(nt, $b5d578355fd299c5$var$Z);
            $b5d578355fd299c5$var$removeAttr(nt, $b5d578355fd299c5$var$Q);
            $b5d578355fd299c5$var$removeAttr(nt, $b5d578355fd299c5$var$et);
            elementIsGenerated(ot) && unwrap(ot);
            elementIsGenerated(nt) && unwrap(nt);
            elementIsGenerated(tt) && unwrap(tt);
        });
        if (s && !E) {
            $b5d578355fd299c5$var$attrClass(nt, $b5d578355fd299c5$var$et, $b5d578355fd299c5$var$rt, true);
            $b5d578355fd299c5$var$push(ct, $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$removeAttr, nt, $b5d578355fd299c5$var$et));
        }
        if (st) {
            $b5d578355fd299c5$var$insertBefore(nt, st);
            $b5d578355fd299c5$var$push(ct, $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$removeElements, st));
        }
        if (G) {
            const t = "tabindex";
            const n = $b5d578355fd299c5$var$attr(nt, t);
            $b5d578355fd299c5$var$attr(nt, t, "-1");
            nt.focus();
            const revertViewportTabIndex = ()=>n ? $b5d578355fd299c5$var$attr(nt, t, n) : $b5d578355fd299c5$var$removeAttr(nt, t);
            const o = $b5d578355fd299c5$var$addEventListener(y, "pointerdown keydown", ()=>{
                revertViewportTabIndex();
                o();
            });
            $b5d578355fd299c5$var$push(ct, [
                revertViewportTabIndex,
                o
            ]);
        } else if (N && N.focus) N.focus();
        at = 0;
        return _t;
    };
    return [
        q,
        appendElements,
        _t
    ];
};
const $b5d578355fd299c5$var$createTrinsicUpdateSegment = ({ ft: t })=>({ Ft: n, en: o, Ot: s })=>{
        const { B: e } = $b5d578355fd299c5$var$getEnvironment();
        const { gt: c } = n || {};
        const { rt: r } = o;
        const l = (t || !e) && (c || s);
        if (l) $b5d578355fd299c5$var$setStyles(t, {
            [$b5d578355fd299c5$var$M]: r ? "" : "100%"
        });
    };
const $b5d578355fd299c5$var$createPaddingUpdateSegment = ({ it: t, Qt: n, ut: o, dt: s }, e)=>{
    const [c, r] = $b5d578355fd299c5$var$createCache({
        u: $b5d578355fd299c5$var$equalTRBL,
        o: $b5d578355fd299c5$var$topRightBottomLeft()
    }, $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$topRightBottomLeft, t, "padding", ""));
    return ({ $t: t, Ft: l, en: i, Ot: a })=>{
        let [u, f] = r(a);
        const { I: _, B: d } = $b5d578355fd299c5$var$getEnvironment();
        const { ct: v, wt: h, bt: p } = l || {};
        const { lt: g } = i;
        const [b, w] = t("paddingAbsolute");
        const y = a || !d && h;
        if (v || f || y) [u, f] = c(a);
        const S = !s && (w || p || f);
        if (S) {
            const t = !b || !n && !_;
            const s = u.r + u.l;
            const c = u.t + u.b;
            const r = {
                [$b5d578355fd299c5$var$A]: t && !g ? -s : 0,
                [$b5d578355fd299c5$var$E]: t ? -c : 0,
                [$b5d578355fd299c5$var$I]: t && g ? -s : 0,
                top: t ? -u.t : 0,
                right: t ? g ? -u.r : "auto" : 0,
                left: t ? g ? "auto" : -u.l : 0,
                [$b5d578355fd299c5$var$k]: t ? `calc(100% + ${s}px)` : ""
            };
            const l = {
                [$b5d578355fd299c5$var$O]: t ? u.t : 0,
                [$b5d578355fd299c5$var$C]: t ? u.r : 0,
                [$b5d578355fd299c5$var$z]: t ? u.b : 0,
                [$b5d578355fd299c5$var$H]: t ? u.l : 0
            };
            $b5d578355fd299c5$var$setStyles(n || o, r);
            $b5d578355fd299c5$var$setStyles(o, l);
            $b5d578355fd299c5$var$assignDeep(e, {
                Qt: u,
                cn: !t,
                k: n ? l : $b5d578355fd299c5$var$assignDeep({}, r, l)
            });
        }
        return {
            rn: S
        };
    };
};
const $b5d578355fd299c5$var$createOverflowUpdateSegment = ({ it: t, Qt: n, ut: o, tn: s, dt: e, ht: c, Dt: i, nn: a }, u)=>{
    const f = $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$l, 0);
    const _ = "visible";
    const d = 42;
    const v = {
        u: $b5d578355fd299c5$var$equalWH,
        o: {
            w: 0,
            h: 0
        }
    };
    const h = {
        u: $b5d578355fd299c5$var$equalXY,
        o: {
            x: $b5d578355fd299c5$var$R,
            y: $b5d578355fd299c5$var$R
        }
    };
    const getOverflowAmount = (t, n)=>{
        const o = $b5d578355fd299c5$var$r.devicePixelRatio % 1 !== 0 ? 1 : 0;
        const s = {
            w: f(t.w - n.w),
            h: f(t.h - n.h)
        };
        return {
            w: s.w > o ? s.w : 0,
            h: s.h > o ? s.h : 0
        };
    };
    const overflowIsVisible = (t)=>t.indexOf(_) === 0;
    const { L: p, B: g, I: b, A: w } = $b5d578355fd299c5$var$getEnvironment();
    const y = $b5d578355fd299c5$var$getStaticPluginModuleInstance($b5d578355fd299c5$var$jt);
    const S = !e && !b && (w.x || w.y);
    const m = i && e;
    const [$, x] = $b5d578355fd299c5$var$createCache(v, $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$fractionalSize, o));
    const [O, P] = $b5d578355fd299c5$var$createCache(v, $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$U, o));
    const [L, B] = $b5d578355fd299c5$var$createCache(v);
    const [j, N] = $b5d578355fd299c5$var$createCache(v);
    const [G] = $b5d578355fd299c5$var$createCache(h);
    const fixFlexboxGlue = (n, s)=>{
        $b5d578355fd299c5$var$setStyles(o, {
            [$b5d578355fd299c5$var$M]: ""
        });
        if (s) {
            const { cn: s, Qt: e } = u;
            const { ln: c, M: r } = n;
            const l = $b5d578355fd299c5$var$fractionalSize(t);
            const i = $b5d578355fd299c5$var$V(t);
            const a = $b5d578355fd299c5$var$getStyles(o, "boxSizing") === "content-box";
            const f = s || a ? e.b + e.t : 0;
            const _ = !(w.x && a);
            $b5d578355fd299c5$var$setStyles(o, {
                [$b5d578355fd299c5$var$M]: i.h + l.h + (c.x && _ ? r.x : 0) - f
            });
        }
    };
    const getViewportOverflowState = (t, n)=>{
        const s = !b && !t ? d : 0;
        const getStatePerAxis = (t, e, c)=>{
            const r = $b5d578355fd299c5$var$getStyles(o, t);
            const l = n ? n[t] : r;
            const i = l === "scroll";
            const a = e ? s : c;
            const u = i && !b ? a : 0;
            const f = e && !!s;
            return [
                r,
                i,
                u,
                f
            ];
        };
        const [e, c, r, l] = getStatePerAxis($b5d578355fd299c5$var$T, w.x, p.x);
        const [i, a, u, f] = getStatePerAxis($b5d578355fd299c5$var$D, w.y, p.y);
        return {
            Jt: {
                x: e,
                y: i
            },
            ln: {
                x: c,
                y: a
            },
            M: {
                x: r,
                y: u
            },
            R: {
                x: l,
                y: f
            }
        };
    };
    const setViewportOverflowState = (t, n, o, s)=>{
        const setAxisOverflowStyle = (t, n)=>{
            const o = overflowIsVisible(t);
            const s = n && o && t.replace(`${_}-`, "") || "";
            return [
                n && !o ? t : "",
                overflowIsVisible(s) ? "hidden" : s
            ];
        };
        const [e, c] = setAxisOverflowStyle(o.x, n.x);
        const [r, l] = setAxisOverflowStyle(o.y, n.y);
        s[$b5d578355fd299c5$var$T] = c && r ? c : e;
        s[$b5d578355fd299c5$var$D] = l && e ? l : r;
        return getViewportOverflowState(t, s);
    };
    const hideNativeScrollbars = (t, n, o, s)=>{
        const { M: e, R: c } = t;
        const { x: r, y: l } = c;
        const { x: i, y: a } = e;
        const { k: f } = u;
        const _ = n ? $b5d578355fd299c5$var$I : $b5d578355fd299c5$var$A;
        const d = n ? $b5d578355fd299c5$var$H : $b5d578355fd299c5$var$C;
        const v = f[_];
        const h = f[$b5d578355fd299c5$var$E];
        const p = f[d];
        const g = f[$b5d578355fd299c5$var$z];
        s[$b5d578355fd299c5$var$k] = `calc(100% + ${a + v * -1}px)`;
        s[_] = -a + v;
        s[$b5d578355fd299c5$var$E] = -i + h;
        if (o) {
            s[d] = p + (l ? a : 0);
            s[$b5d578355fd299c5$var$z] = g + (r ? i : 0);
        }
    };
    const [q, F] = y ? y.D(S, g, o, s, u, getViewportOverflowState, hideNativeScrollbars) : [
        ()=>S,
        ()=>[
                $b5d578355fd299c5$var$noop
            ]
    ];
    return ({ $t: s, Ft: r, en: i, Ot: _ }, { rn: d })=>{
        const { ct: v, yt: h, wt: p, gt: y, bt: S, St: C } = r || {};
        const { rt: H, lt: z } = i;
        const [M, R] = s("showNativeOverlaidScrollbars");
        const [W, X] = s("overflow");
        const Y = M && w.x && w.y;
        const K = !e && !g && (v || p || h || R || y);
        const ot = v || d || p || S || C || R;
        const st = overflowIsVisible(W.x);
        const ct = overflowIsVisible(W.y);
        const ut = st || ct;
        let ft = x(_);
        let _t = P(_);
        let dt = B(_);
        let vt = N(_);
        let ht;
        if (R && b) c($b5d578355fd299c5$var$rt, $b5d578355fd299c5$var$nt, !Y);
        if (K) {
            ht = getViewportOverflowState(Y);
            fixFlexboxGlue(ht, H);
        }
        if (ot) {
            if (ut) c($b5d578355fd299c5$var$lt, $b5d578355fd299c5$var$tt, false);
            const [t, n] = F(Y, z, ht);
            const [s, e] = ft = $(_);
            const [r, i] = _t = O(_);
            const u = $b5d578355fd299c5$var$V(o);
            let d = r;
            let v = u;
            t();
            if ((i || e || R) && n && !Y && q(n, r, s, z)) {
                v = $b5d578355fd299c5$var$V(o);
                d = $b5d578355fd299c5$var$U(o);
            }
            const h = $b5d578355fd299c5$var$windowSize(a);
            const p = {
                w: f($b5d578355fd299c5$var$l(r.w, d.w) + s.w),
                h: f($b5d578355fd299c5$var$l(r.h, d.h) + s.h)
            };
            const g = {
                w: f((m ? h.w : v.w + f(u.w - r.w)) + s.w),
                h: f((m ? h.h : v.h + f(u.h - r.h)) + s.h)
            };
            vt = j(g);
            dt = L(getOverflowAmount(p, g), _);
        }
        const [pt, gt] = vt;
        const [bt, wt] = dt;
        const [yt, St] = _t;
        const [mt, $t] = ft;
        const xt = {
            x: bt.w > 0,
            y: bt.h > 0
        };
        const Ot = st && ct && (xt.x || xt.y) || st && xt.x && !xt.y || ct && xt.y && !xt.x;
        const Ct = d || S || C || $t || St || gt || wt || X || R || K || ot;
        if (Ct) {
            const n = {
                [$b5d578355fd299c5$var$A]: 0,
                [$b5d578355fd299c5$var$E]: 0,
                [$b5d578355fd299c5$var$I]: 0,
                [$b5d578355fd299c5$var$k]: "",
                [$b5d578355fd299c5$var$T]: "",
                [$b5d578355fd299c5$var$D]: ""
            };
            const s = setViewportOverflowState(Y, xt, W, n);
            const c = q(s, yt, mt, z);
            if (!e) hideNativeScrollbars(s, z, c, n);
            if (K) fixFlexboxGlue(s, H);
            if (e) {
                $b5d578355fd299c5$var$attr(t, $b5d578355fd299c5$var$Z, n[$b5d578355fd299c5$var$T]);
                $b5d578355fd299c5$var$attr(t, $b5d578355fd299c5$var$Q, n[$b5d578355fd299c5$var$D]);
            } else $b5d578355fd299c5$var$setStyles(o, n);
        }
        $b5d578355fd299c5$var$attrClass(t, $b5d578355fd299c5$var$J, $b5d578355fd299c5$var$tt, Ot);
        $b5d578355fd299c5$var$attrClass(n, $b5d578355fd299c5$var$it, $b5d578355fd299c5$var$at, Ot);
        if (!e) $b5d578355fd299c5$var$attrClass(o, $b5d578355fd299c5$var$et, $b5d578355fd299c5$var$lt, ut);
        const [Ht, zt] = G(getViewportOverflowState(Y).Jt);
        $b5d578355fd299c5$var$assignDeep(u, {
            Jt: Ht,
            It: {
                x: pt.w,
                y: pt.h
            },
            zt: {
                x: bt.w,
                y: bt.h
            },
            Zt: xt
        });
        return {
            Kt: zt,
            Xt: gt,
            Yt: wt
        };
    };
};
const $b5d578355fd299c5$var$createStructureSetup = (t)=>{
    const [n, o, s] = $b5d578355fd299c5$var$createStructureSetupElements(t);
    const e = {
        Qt: {
            t: 0,
            r: 0,
            b: 0,
            l: 0
        },
        cn: false,
        k: {
            [$b5d578355fd299c5$var$A]: 0,
            [$b5d578355fd299c5$var$E]: 0,
            [$b5d578355fd299c5$var$I]: 0,
            [$b5d578355fd299c5$var$O]: 0,
            [$b5d578355fd299c5$var$C]: 0,
            [$b5d578355fd299c5$var$z]: 0,
            [$b5d578355fd299c5$var$H]: 0
        },
        It: {
            x: 0,
            y: 0
        },
        zt: {
            x: 0,
            y: 0
        },
        Jt: {
            x: $b5d578355fd299c5$var$R,
            y: $b5d578355fd299c5$var$R
        },
        Zt: {
            x: false,
            y: false
        }
    };
    const { At: c, ut: r, ht: l, dt: i } = n;
    const { I: a, A: u, B: f } = $b5d578355fd299c5$var$getEnvironment();
    const _ = !a && (u.x || u.y);
    const d = [
        $b5d578355fd299c5$var$createTrinsicUpdateSegment(n),
        $b5d578355fd299c5$var$createPaddingUpdateSegment(n, e),
        $b5d578355fd299c5$var$createOverflowUpdateSegment(n, e)
    ];
    return [
        o,
        (t)=>{
            const n = {};
            const o = _ || !f;
            const s = o && $b5d578355fd299c5$var$getElmentScroll(r);
            l("", $b5d578355fd299c5$var$st, true);
            $b5d578355fd299c5$var$each(d, (o)=>{
                $b5d578355fd299c5$var$assignDeep(n, o(t, n) || {});
            });
            l("", $b5d578355fd299c5$var$st);
            $b5d578355fd299c5$var$scrollElementTo(r, s);
            !i && $b5d578355fd299c5$var$scrollElementTo(c, 0);
            return n;
        },
        e,
        n,
        s
    ];
};
const $b5d578355fd299c5$var$createSetups = (t, n, o, s)=>{
    const [e, c, r, l, i] = $b5d578355fd299c5$var$createStructureSetup(t);
    const [a, u, f] = $b5d578355fd299c5$var$createObserversSetup(l, (t)=>{
        update({}, t);
    });
    const [_, d, , v] = $b5d578355fd299c5$var$createScrollbarsSetup(t, n, f, r, l, s);
    const updateHintsAreTruthy = (t)=>$b5d578355fd299c5$var$keys(t).some((n)=>!!t[n]);
    const update = (t, s)=>{
        const { an: e, Ot: r, xt: l, un: i } = t;
        const a = e || {};
        const _ = !!r;
        const v = {
            $t: $b5d578355fd299c5$var$createOptionCheck(n, a, _),
            an: a,
            Ot: _
        };
        if (i) {
            d(v);
            return false;
        }
        const h = s || u($b5d578355fd299c5$var$assignDeep({}, v, {
            xt: l
        }));
        const p = c($b5d578355fd299c5$var$assignDeep({}, v, {
            en: f,
            Ft: h
        }));
        d($b5d578355fd299c5$var$assignDeep({}, v, {
            Ft: h,
            Wt: p
        }));
        const g = updateHintsAreTruthy(h);
        const b = updateHintsAreTruthy(p);
        const w = g || b || !$b5d578355fd299c5$var$isEmptyObject(a) || _;
        w && o(t, {
            Ft: h,
            Wt: p
        });
        return w;
    };
    return [
        ()=>{
            const { At: t, ut: n, Gt: o, Dt: s } = l;
            const c = s ? o.documentElement : t;
            const r = $b5d578355fd299c5$var$getElmentScroll(c);
            const i = [
                a(),
                e(),
                _()
            ];
            $b5d578355fd299c5$var$scrollElementTo(n, r);
            return $b5d578355fd299c5$var$bind($b5d578355fd299c5$var$runEachAndClear, i);
        },
        update,
        ()=>({
                fn: f,
                _n: r
            }),
        {
            dn: l,
            vn: v
        },
        i
    ];
};
const $b5d578355fd299c5$export$d08ab3fe303a3356 = (t, n, o)=>{
    const { q: s } = $b5d578355fd299c5$var$getEnvironment();
    const e = $b5d578355fd299c5$var$isHTMLElement(t);
    const c = e ? t : t.target;
    const r = $b5d578355fd299c5$var$getInstance(c);
    if (n && !r) {
        let r = false;
        const l = [];
        const i = {};
        const validateOptions = (t)=>{
            const n = $b5d578355fd299c5$var$removeUndefinedProperties(t, true);
            const o = $b5d578355fd299c5$var$getStaticPluginModuleInstance($b5d578355fd299c5$var$Lt);
            return o ? o(n, true) : n;
        };
        const a = $b5d578355fd299c5$var$assignDeep({}, s(), validateOptions(n));
        const [u, f, _] = $b5d578355fd299c5$var$createEventListenerHub();
        const [d, v, h] = $b5d578355fd299c5$var$createEventListenerHub(o);
        const triggerEvent = (t, n)=>{
            h(t, n);
            _(t, n);
        };
        const [p, g, b, w, y] = $b5d578355fd299c5$var$createSetups(t, a, ({ an: t, Ot: n }, { Ft: o, Wt: s })=>{
            const { ct: e, bt: c, gt: r, wt: l, yt: i, st: a } = o;
            const { Xt: u, Yt: f, Kt: _ } = s;
            triggerEvent("updated", [
                S,
                {
                    updateHints: {
                        sizeChanged: !!e,
                        directionChanged: !!c,
                        heightIntrinsicChanged: !!r,
                        overflowEdgeChanged: !!u,
                        overflowAmountChanged: !!f,
                        overflowStyleChanged: !!_,
                        contentMutation: !!l,
                        hostMutation: !!i,
                        appear: !!a
                    },
                    changedOptions: t || {},
                    force: !!n
                }
            ]);
        }, (t)=>triggerEvent("scroll", [
                S,
                t
            ]));
        const destroy = (t)=>{
            $b5d578355fd299c5$var$removeInstance(c);
            $b5d578355fd299c5$var$runEachAndClear(l);
            r = true;
            triggerEvent("destroyed", [
                S,
                t
            ]);
            f();
            v();
        };
        const S = {
            options (t, n) {
                if (t) {
                    const o = n ? s() : {};
                    const e = $b5d578355fd299c5$var$getOptionsDiff(a, $b5d578355fd299c5$var$assignDeep(o, validateOptions(t)));
                    if (!$b5d578355fd299c5$var$isEmptyObject(e)) {
                        $b5d578355fd299c5$var$assignDeep(a, e);
                        g({
                            an: e
                        });
                    }
                }
                return $b5d578355fd299c5$var$assignDeep({}, a);
            },
            on: d,
            off: (t, n)=>{
                t && n && v(t, n);
            },
            state () {
                const { fn: t, _n: n } = b();
                const { lt: o } = t;
                const { It: s, zt: e, Jt: c, Zt: l, Qt: i, cn: a } = n;
                return $b5d578355fd299c5$var$assignDeep({}, {
                    overflowEdge: s,
                    overflowAmount: e,
                    overflowStyle: c,
                    hasOverflow: l,
                    padding: i,
                    paddingAbsolute: a,
                    directionRTL: o,
                    destroyed: r
                });
            },
            elements () {
                const { At: t, it: n, Qt: o, ut: s, ft: e, Tt: c, qt: r } = w.dn;
                const { Vt: l, Nt: i } = w.vn;
                const translateScrollbarStructure = (t)=>{
                    const { Ht: n, Ct: o, kt: s } = t;
                    return {
                        scrollbar: s,
                        track: o,
                        handle: n
                    };
                };
                const translateScrollbarsSetupElement = (t)=>{
                    const { Ut: n, Bt: o } = t;
                    const s = translateScrollbarStructure(n[0]);
                    return $b5d578355fd299c5$var$assignDeep({}, s, {
                        clone: ()=>{
                            const t = translateScrollbarStructure(o());
                            g({
                                un: true
                            });
                            return t;
                        }
                    });
                };
                return $b5d578355fd299c5$var$assignDeep({}, {
                    target: t,
                    host: n,
                    padding: o || s,
                    viewport: s,
                    content: e || s,
                    scrollOffsetElement: c,
                    scrollEventElement: r,
                    scrollbarHorizontal: translateScrollbarsSetupElement(l),
                    scrollbarVertical: translateScrollbarsSetupElement(i)
                });
            },
            update: (t)=>g({
                    Ot: t,
                    xt: true
                }),
            destroy: $b5d578355fd299c5$var$bind(destroy, false),
            plugin: (t)=>i[$b5d578355fd299c5$var$keys(t)[0]]
        };
        $b5d578355fd299c5$var$push(l, [
            y
        ]);
        $b5d578355fd299c5$var$addInstance(c, S);
        $b5d578355fd299c5$var$registerPluginModuleInstances($b5d578355fd299c5$var$Rt, $b5d578355fd299c5$export$d08ab3fe303a3356, [
            S,
            u,
            i
        ]);
        if ($b5d578355fd299c5$var$cancelInitialization(w.dn.Dt, !e && t.cancel)) {
            destroy(true);
            return S;
        }
        $b5d578355fd299c5$var$push(l, p());
        triggerEvent("initialized", [
            S
        ]);
        S.update(true);
        return S;
    }
    return r;
};
$b5d578355fd299c5$export$d08ab3fe303a3356.plugin = (t)=>{
    const n = $b5d578355fd299c5$var$isArray(t);
    const o = n ? t : [
        t
    ];
    const s = o.map((t)=>$b5d578355fd299c5$var$registerPluginModuleInstances(t, $b5d578355fd299c5$export$d08ab3fe303a3356)[0]);
    $b5d578355fd299c5$var$addPlugins(o);
    return n ? s : s[0];
};
$b5d578355fd299c5$export$d08ab3fe303a3356.valid = (t)=>{
    const n = t && t.elements;
    const o = $b5d578355fd299c5$var$isFunction(n) && n();
    return $b5d578355fd299c5$var$isPlainObject(o) && !!$b5d578355fd299c5$var$getInstance(o.target);
};
$b5d578355fd299c5$export$d08ab3fe303a3356.env = ()=>{
    const { L: t, A: n, I: o, U: s, B: e, T: c, V: r, W: l, X: i, N: a, G: u, q: f, F: _ } = $b5d578355fd299c5$var$getEnvironment();
    return $b5d578355fd299c5$var$assignDeep({}, {
        scrollbarsSize: t,
        scrollbarsOverlaid: n,
        scrollbarsHiding: o,
        rtlScrollBehavior: s,
        flexboxGlue: e,
        cssCustomProperties: c,
        scrollTimeline: r,
        staticDefaultInitialization: l,
        staticDefaultOptions: i,
        getDefaultInitialization: a,
        setDefaultInitialization: u,
        getDefaultOptions: f,
        setDefaultOptions: _
    });
};


const $c29e5efe25af74ec$var$O = ()=>{
    if (typeof window > "u") {
        const n = ()=>{};
        return [
            n,
            n
        ];
    }
    let l, c;
    const t = window, o = typeof t.requestIdleCallback == "function", a = t.requestAnimationFrame, i = t.cancelAnimationFrame, r = o ? t.requestIdleCallback : a, u = o ? t.cancelIdleCallback : i, s = ()=>{
        u(l), i(c);
    };
    return [
        (n, e)=>{
            s(), l = r(o ? ()=>{
                s(), c = a(n);
            } : n, typeof e == "object" ? e : {
                timeout: 2233
            });
        },
        s
    ];
}, $c29e5efe25af74ec$export$98c834f87b3a8a6f = (l)=>{
    const { options: c, events: t, defer: o } = l || {}, [a, i] = (0, $9nZCP.useMemo)($c29e5efe25af74ec$var$O, []), r = (0, $9nZCP.useRef)(null), u = (0, $9nZCP.useRef)(o), s = (0, $9nZCP.useRef)(c), n = (0, $9nZCP.useRef)(t);
    return (0, $9nZCP.useEffect)(()=>{
        u.current = o;
    }, [
        o
    ]), (0, $9nZCP.useEffect)(()=>{
        const { current: e } = r;
        s.current = c, (0, $b5d578355fd299c5$export$d08ab3fe303a3356).valid(e) && e.options(c || {}, !0);
    }, [
        c
    ]), (0, $9nZCP.useEffect)(()=>{
        const { current: e } = r;
        n.current = t, (0, $b5d578355fd299c5$export$d08ab3fe303a3356).valid(e) && e.on(t || {}, !0);
    }, [
        t
    ]), (0, $9nZCP.useEffect)(()=>()=>{
            var e;
            i(), (e = r.current) == null || e.destroy();
        }, []), (0, $9nZCP.useMemo)(()=>[
            (e)=>{
                const y = r.current;
                if ((0, $b5d578355fd299c5$export$d08ab3fe303a3356).valid(y)) return;
                const d = u.current, b = s.current || {}, m = n.current || {}, p = ()=>r.current = (0, $b5d578355fd299c5$export$d08ab3fe303a3356)(e, b, m);
                d ? a(p, d) : p();
            },
            ()=>r.current
        ], []);
}, $c29e5efe25af74ec$var$F = (l, c)=>{
    const { element: t = "div", options: o, events: a, defer: i, children: r, ...u } = l, s = t, n = (0, $9nZCP.useRef)(null), e = (0, $9nZCP.useRef)(null), [y, d] = $c29e5efe25af74ec$export$98c834f87b3a8a6f({
        options: o,
        events: a,
        defer: i
    });
    return (0, $9nZCP.useEffect)(()=>{
        const { current: b } = n, { current: m } = e;
        return b && m && y({
            target: b,
            elements: {
                viewport: m,
                content: m
            }
        }), ()=>{
            var p;
            return (p = d()) == null ? void 0 : p.destroy();
        };
    }, [
        y,
        t
    ]), (0, $9nZCP.useImperativeHandle)(c, ()=>({
            osInstance: d,
            getElement: ()=>n.current
        }), []), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement(s, {
        "data-overlayscrollbars-initialize": "",
        ref: n,
        ...u
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        "data-overlayscrollbars-contents": "",
        ref: e
    }, r));
}, $c29e5efe25af74ec$export$5c3912403b9b36ce = (0, $9nZCP.forwardRef)($c29e5efe25af74ec$var$F);



var $9nZCP = parcelRequire("9nZCP");
const $e4f593b82d8858f8$export$20b5a34f45062e8b = /*#__PURE__*/ (0, $9nZCP.createContext)(null);



parcelRequire("9nZCP");



var $9nZCP = parcelRequire("9nZCP");


var $9nZCP = parcelRequire("9nZCP");

var $0aa9c5ea5f98ac89$var$defaultEvents = [
    "mousedown",
    "touchstart"
];
var $0aa9c5ea5f98ac89$var$useClickAway = function(ref, onClickAway, events) {
    if (events === void 0) events = $0aa9c5ea5f98ac89$var$defaultEvents;
    var savedCallback = (0, $9nZCP.useRef)(onClickAway);
    (0, $9nZCP.useEffect)(function() {
        savedCallback.current = onClickAway;
    }, [
        onClickAway
    ]);
    (0, $9nZCP.useEffect)(function() {
        var handler = function(event) {
            var el = ref.current;
            el && !el.contains(event.target) && savedCallback.current(event);
        };
        for(var _i = 0, events_1 = events; _i < events_1.length; _i++){
            var eventName = events_1[_i];
            (0, $934ed287249205c1$export$af631764ddc44097)(document, eventName, handler);
        }
        return function() {
            for(var _i = 0, events_2 = events; _i < events_2.length; _i++){
                var eventName = events_2[_i];
                (0, $934ed287249205c1$export$8c8705df4a2dcec9)(document, eventName, handler);
            }
        };
    }, [
        events,
        ref
    ]);
};
var $0aa9c5ea5f98ac89$export$2e2bcd8739ae039 = $0aa9c5ea5f98ac89$var$useClickAway;



const $fbf3a9d90d422861$export$4cf8c0e020b1f8b2 = 900;
const $fbf3a9d90d422861$export$7432a1a850ec2b36 = (styleFn)=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
  @media (min-width: ${$fbf3a9d90d422861$export$4cf8c0e020b1f8b2}px) {
    ${()=>styleFn()}
  }
`;




parcelRequire("9nZCP");
const $73eb9db2706756f0$var$SvgEscrow = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        width: 119,
        height: 48,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M57.505 19.996h-6.168v2.609h5.586v1.791h-5.586v2.814h6.168V29h-8.134V18.204h8.134v1.792Zm5.885 9.178c-1.857 0-3.43-.628-4.626-1.744l1.133-1.399c.991.896 2.14 1.462 3.556 1.462 1.337 0 2.03-.66 2.03-1.43 0-.896-.771-1.195-2.502-1.604-2.234-.518-3.792-1.163-3.792-3.19 0-1.886 1.605-3.269 3.886-3.269 1.715 0 3.006.581 4.091 1.509l-1.07 1.446c-.944-.818-2.03-1.273-3.1-1.273-1.085 0-1.825.66-1.825 1.414 0 .88.803 1.195 2.518 1.587 2.25.503 3.76 1.226 3.76 3.19 0 1.934-1.478 3.301-4.059 3.301Zm11.124.016c-3.084 0-5.68-2.562-5.68-5.595s2.596-5.58 5.68-5.58c1.59 0 3.037.677 4.076 1.745l-1.4 1.305c-.662-.77-1.637-1.258-2.676-1.258-1.998 0-3.682 1.73-3.682 3.788 0 2.075 1.684 3.803 3.682 3.803 1.055 0 2.014-.487 2.69-1.257l1.386 1.289a5.638 5.638 0 0 1-4.076 1.76Zm14.429-.189h-2.234l-2.55-3.63h-2.092V29H80.1V18.204h4.705c2.313 0 4.043 1.478 4.043 3.584 0 1.634-1.054 2.891-2.611 3.379L88.943 29Zm-6.876-8.99v3.553h2.517c1.338 0 2.266-.676 2.266-1.776s-.928-1.776-2.266-1.776h-2.517Zm13.83 9.179c-3.084 0-5.68-2.562-5.68-5.595s2.597-5.58 5.68-5.58c3.069 0 5.665 2.547 5.665 5.58s-2.596 5.595-5.665 5.595Zm0-1.792c1.983 0 3.65-1.729 3.65-3.803 0-2.059-1.667-3.788-3.65-3.788-1.998 0-3.681 1.73-3.681 3.788 0 2.075 1.683 3.803 3.681 3.803Zm9.819 1.603-3.43-10.797h2.155l2.313 7.733 2.565-7.733h2.14l2.549 7.733 2.313-7.733h2.155l-3.414 10.797h-1.967l-2.706-8.015-2.722 8.015h-1.951Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 12.26 20.215.601 40.37 12.26v.577c0 14.726-6.659 26.121-19.854 34.096l-.507.306-.513-.297C6.541 39.425.024 28.013.001 12.838v-.579Zm39.37.577c0 14.355-6.457 25.435-19.372 33.24C7.356 38.742 1.024 27.662 1.002 12.837l19.213-11.08 19.155 11.08Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.015 43.11c11.174-6.843 16.774-16.462 16.86-28.899L20.212 4.577 3.502 14.211c.1 12.857 5.595 22.469 16.513 28.9ZM3 13.923c.02 13.277 5.693 23.2 17.02 29.77 11.57-6.99 17.355-16.914 17.355-29.77L20.213 4 3 13.923Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m15.195 13 11.465.506 4.641 10.19-6.548 9.312-11.527-.73L8.5 21.238 15.195 13Zm7.414 17.39-6.073 1.565 7.141.45-1.068-2.015Zm6.526-4.433-5.316 3.905 1.056 2.036 4.26-5.94ZM13.72 24.215l.175 6.87 7.026-1.8-7.2-5.07Zm-4.465-2.189 3.314 7.698-.138-7.035-3.176-.663Zm15.932-3.206-1.295 9.441 6.201-4.531-4.906-4.91Zm-1.627.13-8.29 3.572 7.087 5.404 1.203-8.976Zm-9.372-3.961-4.727 5.886 3.16.66 1.567-6.546Zm12.432.034-1.032 2.09 3.843 3.852-2.81-5.942Zm-10.645-.676-1.392 5.915L22.6 17.16l-6.625-2.813Zm2.61-.595 5.567 2.401 1.182-2.13-6.748-.27Z",
                fill: "#fff"
            })
        ]
    });
var $73eb9db2706756f0$export$2e2bcd8739ae039 = $73eb9db2706756f0$var$SvgEscrow;



parcelRequire("9nZCP");
const $5076370542e920f6$var$SvgHamburger = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M.571 3.292H15.43A.577.577 0 0 0 16 2.708V1.25a.577.577 0 0 0-.571-.583H.57A.577.577 0 0 0 0 1.25v1.458c0 .323.256.584.571.584Zm0 5.833H15.43A.577.577 0 0 0 16 8.542V7.083a.577.577 0 0 0-.571-.583H.57A.577.577 0 0 0 0 7.083v1.459c0 .322.256.583.571.583Zm0 5.833H15.43a.577.577 0 0 0 .571-.583v-1.458a.577.577 0 0 0-.571-.584H.57a.577.577 0 0 0-.571.584v1.458c0 .322.256.583.571.583Z"
        })
    });
var $5076370542e920f6$export$2e2bcd8739ae039 = $5076370542e920f6$var$SvgHamburger;



parcelRequire("9nZCP");


const $072682708a04db72$var$StyledButton = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Button))`
  background-color: transparent;
  padding-left: 0;
  .button-text {
    color: ${({ theme: theme })=>theme.primaryText};
    font-weight: 400;
  }
  .button-svg {
    fill: ${({ theme: theme })=>theme.secondaryPurple};
  }

  :focus,
  :hover {
    background-color: transparent;
  }
`;
const $072682708a04db72$var$LightButton = ({ text: text, Icon: Icon, onClick: onClick, disabled: disabled, className: className })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($072682708a04db72$var$StyledButton, {
        variant: "primary",
        small: true,
        text: text,
        Icon: Icon,
        onClick: onClick,
        disabled: disabled,
        className: className
    });
var $072682708a04db72$export$2e2bcd8739ae039 = $072682708a04db72$var$LightButton;



parcelRequire("9nZCP");




var $9nZCP = parcelRequire("9nZCP");

const $576ec816832a2b72$export$eb909a3d9177a60d = (shouldLock)=>{
    const osInstanceRef = (0, $9nZCP.useContext)((0, $e4f593b82d8858f8$export$20b5a34f45062e8b));
    const lockScroll = (0, $9nZCP.useCallback)(()=>{
        const osInstance = osInstanceRef?.current?.osInstance();
        if (osInstance) osInstance.options({
            overflow: {
                x: "hidden",
                y: "hidden"
            }
        });
    }, [
        osInstanceRef
    ]);
    const unlockScroll = (0, $9nZCP.useCallback)(()=>{
        const osInstance = osInstanceRef?.current?.osInstance();
        if (osInstance) osInstance.options({
            overflow: {
                x: "scroll",
                y: "scroll"
            }
        });
    }, [
        osInstanceRef
    ]);
    (0, $9nZCP.useEffect)(()=>{
        if (shouldLock) lockScroll();
        else unlockScroll();
    }, [
        shouldLock,
        lockScroll,
        unlockScroll
    ]);
};





var $9nZCP = parcelRequire("9nZCP");


/**
 * @description this func applies repsonsiveness to a css property, the value will range from minSize to maxSize
 * @param minSize the minimum value of the property
 * @param maxSize max value of the property
 * @param minScreen the min screen width at which the property will be at minSize
 * @param maxScreen the max screen width at which the property will be at maxSize
 *
 */ const $b2736651d1fdc941$export$1b3e91ab3ce1a831 = (minSize, maxSize, minScreen = 375, maxScreen = 1250)=>`calc(${minSize}px + (${maxSize} - ${minSize}) * (min(max(100vw, ${minScreen}px), ${maxScreen}px) - ${minScreen}px) / (${maxScreen - minScreen}))`;



var $0285652a8605c734$exports = {};

$0285652a8605c734$exports = (parcelRequire("jSc4P")).getBundleURL("dj12v") + "curate-image.d1f1c2c8.png";



parcelRequire("9nZCP");
const $b8bbe59016120a3d$var$SvgDisputeResolver = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 48,
        height: 48,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("g", {
            clipPath: "url('df7ba0745e0482fc')",
            children: [
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M47.953 23.909c0 13.228-10.746 23.943-23.99 23.943C10.716 47.852-.03 37.137-.03 23.909c0-13.228 10.746-23.943 23.991-23.943S47.953 10.681 47.953 23.91Zm-2.3 0c0 11.953-9.711 21.643-21.69 21.643-11.98 0-21.692-9.69-21.692-21.643 0-11.953 9.712-21.643 21.691-21.643 11.98 0 21.691 9.69 21.691 21.643Z",
                    fill: "#9013FE"
                }),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                    d: "M23.962 45.551c11.98 0 21.691-9.69 21.691-21.642 0-11.953-9.711-21.643-21.69-21.643-11.98 0-21.692 9.69-21.692 21.643 0 11.953 9.712 21.642 21.691 21.642Z",
                    fill: "#1E075F"
                }),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "m21.668 19 6.281.277 2.543 5.578-3.588 5.098-6.315-.399L18 23.51 21.668 19Zm4.037 9.474-3.332.855 3.918.247-.587-1.102Zm3.58-2.424-2.917 2.135.58 1.113 2.337-3.248Zm-8.457-.952.096 3.756 3.854-.984-3.95-2.772Zm-2.45-1.197 1.818 4.209-.075-3.846-1.742-.363Zm8.74-1.753-.71 5.162 3.403-2.477-2.692-2.685Zm-.892.071-4.548 1.953 3.888 2.954.66-4.907Zm-5.141-2.165-2.594 3.218 1.734.36.86-3.578Zm6.82.018-.566 1.143 2.108 2.106-1.542-3.249Zm-5.84-.37-.764 3.234 4.399-1.695-3.635-1.538Zm1.432-.324 3.054 1.312.649-1.165-3.703-.147Z",
                    fill: "#9013FE"
                }),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M43.533 31.575c0 1.718-3.398 3.11-7.59 3.11-4.193 0-7.591-1.392-7.591-3.11 0-1.719 15.181-1.719 15.181 0Zm-.53.015c0 .355-3.17.643-7.079.643-3.91 0-7.078-.288-7.078-.643 0-.354 3.169-.642 7.078-.642 3.91 0 7.08.288 7.08.642Z",
                    fill: "#fff"
                }),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                    d: "M35.924 32.233c3.91 0 7.08-.288 7.08-.643 0-.354-3.17-.642-7.08-.642s-7.078.288-7.078.642c0 .355 3.169.643 7.078.643Z",
                    fill: "#009AFF"
                }),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.533 31.575c0 1.718-3.399 3.11-7.59 3.11-4.193 0-7.591-1.392-7.591-3.11 0-1.719 15.18-1.719 15.18 0Zm-.53.015c0 .355-3.17.643-7.079.643-3.91 0-7.079-.288-7.079-.643 0-.354 3.17-.642 7.08-.642 3.909 0 7.078.288 7.078.642Z",
                    fill: "#fff"
                }),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                    d: "M11.924 32.233c3.91 0 7.079-.288 7.079-.643 0-.354-3.17-.642-7.079-.642-3.91 0-7.079.288-7.079.642 0 .355 3.17.643 7.08.643Z",
                    fill: "#009AFF"
                }),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M13.098 20.85c0 .792-.644 1.435-1.439 1.435a1.437 1.437 0 0 1-1.438-1.436c0-.792.644-1.435 1.438-1.435.795 0 1.439.643 1.439 1.435Zm-.606 0a.832.832 0 1 1-1.664-.002.832.832 0 0 1 1.664.002ZM37.93 20.85c0 .792-.643 1.435-1.438 1.435a1.437 1.437 0 0 1-1.438-1.436c0-.792.644-1.435 1.438-1.435.795 0 1.439.643 1.439 1.435Zm-.605 0a.832.832 0 1 1-1.664-.002.832.832 0 0 1 1.664.002Z",
                    fill: "#fff"
                }),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "m24.151 11.528.038-8.762a.265.265 0 0 0-.53-.003l-.038 8.763c0 .034.007.067.018.097l-2.188 2.182c-3.219.64-6.29 2.557-9.206 5.733.36.16.641.463.772.837 3.461-3.797 7.08-5.675 10.87-5.675 3.789 0 7.537 1.879 11.248 5.673.131-.372.412-.674.77-.834-3.126-3.184-6.323-5.102-9.588-5.737l-2.183-2.18a.266.266 0 0 0 .017-.094Zm13.716 8.9a1.43 1.43 0 0 1-.125 1.133h2.1a.567.567 0 1 0 0-1.134h-1.974Zm-.92 1.783a1.437 1.437 0 0 1-.403.073l5.452 8.475c.194.042.374.087.536.134l-5.585-8.682Zm-8.464 9.942a1.158 1.158 0 0 1-.015-.034l-.026.034h.041Zm.916-1.273a8.17 8.17 0 0 1 .578-.14l6.36-8.464a1.435 1.435 0 0 1-.397-.1l-6.541 8.704ZM8.289 20.427h1.995a1.43 1.43 0 0 0 .125 1.134H8.29a.567.567 0 1 1 0-1.134Zm-3.82 11.726.008-.012.006.012h-.014Zm1.366-1.383c-.2.045-.383.092-.547.143l5.78-8.755c.118.053.246.091.38.111L5.834 30.77Zm12.586.092a8.672 8.672 0 0 0-.567-.133l-6.203-8.444h.008c.145 0 .285-.022.416-.061l6.346 8.638Zm6.287-17.269-.784-.782-.779.777a12.594 12.594 0 0 1 1.563.005Z",
                    fill: "#E1BEFF"
                })
            ]
        })
    });
var $b8bbe59016120a3d$export$2e2bcd8739ae039 = $b8bbe59016120a3d$var$SvgDisputeResolver;



parcelRequire("9nZCP");
const $e33cbdb77bc06c3f$var$SvgEscrow = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        width: 48,
        height: 48,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3 11.998 23.805 0 44.55 11.999v.593c0 15.157-6.854 26.885-20.435 35.093l-.522.315-.527-.306c-13.334-7.737-20.04-19.482-20.064-35.1L3 11.998Zm40.52.595c0 14.774-6.646 26.177-19.938 34.21C10.57 39.255 4.053 27.852 4.03 12.594L23.804 1.189 43.52 12.592Z",
                fill: "#4D00B4"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.599 43.752C35.099 36.71 40.863 26.81 40.95 14.01L23.803 4.094l-17.2 9.915c.104 13.232 5.76 23.125 16.996 29.743ZM6.088 13.712c.02 13.665 5.859 23.878 17.516 30.64 11.908-7.195 17.862-17.408 17.862-30.64L23.803 3.5 6.088 13.713Z",
                fill: "#4D00B4"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m18.639 12.763 11.799.52 4.777 10.487-6.74 9.585-11.863-.751-4.864-11.362 6.89-8.48Zm7.63 17.897-6.25 1.611 7.35.464-1.1-2.075Zm6.716-4.562-5.47 4.02 1.086 2.094 4.384-6.114Zm-15.864-1.793.179 7.071 7.231-1.853-7.41-5.218Zm-4.596-2.252 3.41 7.922-.142-7.24-3.268-.682Zm16.397-3.3-1.333 9.717 6.383-4.664-5.05-5.054Zm-1.675.133-8.532 3.676 7.295 5.562 1.237-9.238Zm-9.645-4.076-4.865 6.057 3.253.68 1.612-6.738Zm12.795.034-1.062 2.151 3.955 3.965-2.893-6.116Zm-10.956-.695-1.433 6.087 8.252-3.192-6.82-2.895Zm2.687-.612 5.729 2.47 1.216-2.192-6.945-.278Z",
                fill: "#9013FE"
            })
        ]
    });
var $e33cbdb77bc06c3f$export$2e2bcd8739ae039 = $e33cbdb77bc06c3f$var$SvgEscrow;



parcelRequire("9nZCP");
const $b12c4b12c9aeba20$var$SvgGovernor = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        width: 48,
        height: 48,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M23.204 47.778a1.658 1.658 0 0 0 1.659 0l19.375-11.174a1.655 1.655 0 0 0 .83-1.433V12.828a1.653 1.653 0 0 0-.83-1.434L24.863.222a1.658 1.658 0 0 0-1.659 0L3.83 11.395A1.653 1.653 0 0 0 3 12.828v22.344a1.653 1.653 0 0 0 .829 1.433l19.375 11.173Zm.829-1.434L4.657 35.172V12.828L24.033 1.654l19.376 11.174v22.344L24.033 46.344Z",
                fill: "#4D00B4"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "m40.406 13.786-15.7-9.051a1.351 1.351 0 0 0-1.347 0l-15.7 9.05a1.34 1.34 0 0 0-.671 1.161v18.102a1.342 1.342 0 0 0 .671 1.162l15.7 9.05a1.34 1.34 0 0 0 1.346 0l15.7-9.05a1.342 1.342 0 0 0 .672-1.162V14.946a1.34 1.34 0 0 0-.671-1.16Zm-.13 18.843a1.274 1.274 0 0 1-.64 1.104l-14.963 8.63a1.293 1.293 0 0 1-1.278 0l-14.962-8.63a1.276 1.276 0 0 1-.64-1.107V15.372a1.281 1.281 0 0 1 .64-1.107L23.4 5.64a1.272 1.272 0 0 1 1.278 0l14.964 8.626a1.278 1.278 0 0 1 .633 1.106v17.257Z",
                fill: "#4D00B4"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m21.392 14.61 2.263-2.264a.109.109 0 0 1 .154 0l5.575 5.575a.109.109 0 0 1 0 .154l-2.263 2.263a.109.109 0 0 1-.154 0l-5.575-5.575a.109.109 0 0 1 0-.153Zm-5.286 6.86 5.343-5.344a.5.5 0 0 1 .707 0l3.45 3.45a.5.5 0 0 1 0 .707l-5.343 5.344a.5.5 0 0 1-.707 0l-3.45-3.45a.5.5 0 0 1 0-.707Zm-1.547-.026-2.264 2.264a.109.109 0 0 0 0 .154l5.575 5.575a.109.109 0 0 0 .154 0l2.264-2.264a.109.109 0 0 0 0-.154l-5.575-5.575a.109.109 0 0 0-.154 0Zm8.167 2.037 8.78 9.76c.214.24.724.09 1.13-.334.41-.422.552-.952.322-1.176l-9.386-9.13-.846.88Z",
                fill: "#9021FE"
            })
        ]
    });
var $b12c4b12c9aeba20$export$2e2bcd8739ae039 = $b12c4b12c9aeba20$var$SvgGovernor;



parcelRequire("9nZCP");
const $e11bea8766120eb3$var$SvgKleros = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m14.094 3 24.135 1.079L48 25.794 34.215 45.641 9.948 44.086 0 20.558 14.094 3Zm17.694 12.517-17.492 7.644L29.25 34.726l2.538-19.209Zm-2.025-3.83-13.979-6.02-2.936 12.657 16.915-6.637ZM26.22 37.635l-15.192-10.85.367 14.703 14.825-3.853Zm19.353-11.889L35.221 15.24l-2.733 20.205 13.085-9.698ZM29.782 40l-12.813 3.35 15.067.964L29.782 40Zm13.768-9.485L32.335 38.87l2.228 4.356 8.987-12.712ZM38.245 7.113l-2.178 4.473 8.108 8.244-5.93-12.717Zm-2.714-2.14-14.238-.578 11.745 5.138 2.493-4.56ZM12.014 7.04 2.042 19.637l6.667 1.412 3.306-14.008Zm-3.707 16.48-6.7-1.42 6.991 16.473-.29-15.054Z",
            fill: "#9013FE"
        })
    });
var $e11bea8766120eb3$export$2e2bcd8739ae039 = $e11bea8766120eb3$var$SvgKleros;


var $2df78bcb872b8686$exports = {};

$2df78bcb872b8686$exports = (parcelRequire("jSc4P")).getBundleURL("dj12v") + "poh-image.0ff250c0.png";



parcelRequire("9nZCP");
const $9b3edabd30fc519a$var$SvgVea = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 48,
        height: 48,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M1.297 16.605h14.086L8.34 31.937 1.297 16.605ZM8.34 30.039l5.82-12.636H2.542L8.34 30.04ZM19.081 16.626h10.522v.798h-9.727v6.081h8.46v.798h-8.46v6.534h9.727v.798H19.081V16.626ZM47.173 31.635H33.087l7.043-15.332 7.043 15.332Zm-12.841-.798h11.595L40.13 18.201l-5.798 12.636Z",
            fill: "#9013FE"
        })
    });
var $9b3edabd30fc519a$export$2e2bcd8739ae039 = $9b3edabd30fc519a$var$SvgVea;



parcelRequire("9nZCP");


const $0dd04287469303cc$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).a`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 8px 35px 8px;
  max-width: 100px;
  border-radius: 3px;
  :hover {
    transform: scale(1.05);
    transition: 350ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }
  gap: 8px;
  width: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(100, 130)};

  background-color: ${({ theme: theme })=>theme.lightBackground};
`;
const $0dd04287469303cc$var$StyledIcon = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).svg`
  width: 48px;
  height: 48px;
`;
const $0dd04287469303cc$var$StyledImg = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).img`
  width: 48px;
  height: 48px;
`;
const $0dd04287469303cc$var$StyledSmall = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).small`
  display: flex;
  font-weight: 400;
  line-height: 19px;
  text-align: center;
`;
const $0dd04287469303cc$var$Product = ({ text: text, url: url, Icon: Icon })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($0dd04287469303cc$var$Container, {
        href: url,
        target: "_blank",
        children: [
            typeof Icon === "string" ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($0dd04287469303cc$var$StyledImg, {
                alt: Icon,
                src: Icon
            }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($0dd04287469303cc$var$StyledIcon, {
                as: Icon
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($0dd04287469303cc$var$StyledSmall, {
                children: text
            })
        ]
    });
};
var $0dd04287469303cc$export$2e2bcd8739ae039 = $0dd04287469303cc$var$Product;


const $d848e91eca145ac8$var$Header = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).h1`
  padding-top: 32px;
  padding-bottom: 20px;
  font-size: 24px;
  font-weight: 600;
  line-height: 32.68px;
`;
const $d848e91eca145ac8$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  position: absolute;
  max-height: 340px;
  top: 5%;
  left: 50%;
  transform: translate(-50%);
  z-index: 1;
  flex-direction: column;
  align-items: center;

  width: 86vw;
  max-width: 480px;
  min-width: 300px;
  border-radius: 3px;
  border: 1px solid ${({ theme: theme })=>theme.stroke};
  background-color: ${({ theme: theme })=>theme.whiteBackground};
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.06);

  svg {
    visibility: visible;
  }

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      margin-top: 64px;
      top: 0;
      left: 0;
      right: auto;
      transform: none;
      width: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(300, 480)};
      max-height: 80vh;
    `)}
`;
const $d848e91eca145ac8$var$ItemsDiv = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: grid;
  overflow-y: auto;
  padding: 16px ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(8, 24, 480)};
  row-gap: 8px;
  column-gap: 2px;
  justify-items: center;
  max-width: 480px;
  min-width: 300px;
  width: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(300, 480)};
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
`;
const $d848e91eca145ac8$var$ITEMS = [
    {
        text: "Court V2",
        Icon: (0, $e11bea8766120eb3$export$2e2bcd8739ae039),
        url: "https://v2.kleros.builders/"
    },
    {
        text: "Curate V2",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($0285652a8605c734$exports))),
        url: "https://curate-v2.netlify.app/"
    },
    {
        text: "Resolver V2",
        Icon: (0, $b8bbe59016120a3d$export$2e2bcd8739ae039),
        url: "https://v2.kleros.builders/#/resolver"
    },
    {
        text: "Escrow V2",
        Icon: (0, $e33cbdb77bc06c3f$export$2e2bcd8739ae039),
        url: "https://escrow-v2.kleros.builders/"
    },
    {
        text: "Court V1",
        Icon: (0, $e11bea8766120eb3$export$2e2bcd8739ae039),
        url: "https://court.kleros.io/"
    },
    {
        text: "Curate V1",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($0285652a8605c734$exports))),
        url: "https://curate.kleros.io"
    },
    {
        text: "Resolver V1",
        Icon: (0, $b8bbe59016120a3d$export$2e2bcd8739ae039),
        url: "https://resolve.kleros.io"
    },
    {
        text: "Escrow V1",
        Icon: (0, $e33cbdb77bc06c3f$export$2e2bcd8739ae039),
        url: "https://escrow.kleros.io"
    },
    {
        text: "Vea",
        Icon: (0, $9b3edabd30fc519a$export$2e2bcd8739ae039),
        url: "https://veascan.io"
    },
    {
        text: "Kleros Scout",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($0285652a8605c734$exports))),
        url: "https://klerosscout.eth.limo"
    },
    {
        text: "POH V1",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2df78bcb872b8686$exports))),
        url: "https://app.proofofhumanity.id"
    },
    {
        text: "Governor",
        Icon: (0, $b12c4b12c9aeba20$export$2e2bcd8739ae039),
        url: "https://governor.kleros.io"
    }
];
const $d848e91eca145ac8$var$DappList = ({ toggleIsDappListOpen: toggleIsDappListOpen })=>{
    const containerRef = (0, $9nZCP.useRef)(null);
    (0, $0aa9c5ea5f98ac89$export$2e2bcd8739ae039)(containerRef, ()=>toggleIsDappListOpen());
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($d848e91eca145ac8$var$Container, {
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($d848e91eca145ac8$var$Header, {
                children: "Kleros Solutions"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($d848e91eca145ac8$var$ItemsDiv, {
                children: $d848e91eca145ac8$var$ITEMS.map((item)=>{
                    return /*#__PURE__*/ (0, $9nZCP.createElement)((0, $0dd04287469303cc$export$2e2bcd8739ae039), {
                        ...item,
                        key: item.text
                    });
                })
            })
        ]
    });
};
var $d848e91eca145ac8$export$2e2bcd8739ae039 = $d848e91eca145ac8$var$DappList;



parcelRequire("9nZCP");




const $45e069354dfffd94$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 0px;
  flex-direction: column;

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      flex-direction: row;
      gap: calc(4px + (16 - 4) * ((100vw - 375px) / (1250 - 375)));
    `)};
`;
const $45e069354dfffd94$var$LinkContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  min-height: 32px;
  align-items: center;
`;
const $45e069354dfffd94$var$Title = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).h1`
  display: block;

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      display: none;
    `)};
`;
const $45e069354dfffd94$var$StyledLink = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $544fc37a064f4916$export$a6c7ac8248d6e38a))`
  color: ${({ theme: theme })=>theme.primaryText};
  text-decoration: none;
  font-size: 16px;

  font-weight: ${({ isActive: isActive })=>isActive ? "600" : "normal"};

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      color: ${({ theme: theme })=>theme.white};
    `)};
`;
const $45e069354dfffd94$var$links = [
    {
        to: "/new-transaction",
        text: "New Transaction"
    },
    {
        to: "/my-transactions/display/1/desc/all",
        text: "My Transactions"
    }
];
const $45e069354dfffd94$var$Explore = ()=>{
    const location = (0, $cb6812e0fa529c57$export$45d76561a5302f2b)();
    const { toggleIsOpen: toggleIsOpen } = (0, $1d8f19168641006a$export$25b6956486120489)();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($45e069354dfffd94$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($45e069354dfffd94$var$Title, {
                children: "Explore"
            }),
            $45e069354dfffd94$var$links.map(({ to: to, text: text })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($45e069354dfffd94$var$LinkContainer, {
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($45e069354dfffd94$var$StyledLink, {
                        to: to,
                        onClick: toggleIsOpen,
                        isActive: location.pathname.startsWith(to),
                        children: text
                    })
                }, text))
        ]
    });
};
var $45e069354dfffd94$export$2e2bcd8739ae039 = $45e069354dfffd94$var$Explore;



parcelRequire("9nZCP");




const $a5583d98c7d1626b$export$8372812df8e8183f = (0, $6a02c0f0c34d6c61$export$21799e7ae6cc115).id;
const $a5583d98c7d1626b$export$7000f41a852f3e5 = {
    [(0, $6a02c0f0c34d6c61$export$21799e7ae6cc115).id]: (0, $6a02c0f0c34d6c61$export$21799e7ae6cc115)
};
const $a5583d98c7d1626b$export$6daed389df1cc9ff = Object.keys($a5583d98c7d1626b$export$7000f41a852f3e5);
const $a5583d98c7d1626b$export$cd6990c704c6a5af = {
    [(0, $29073ff13918eb95$export$7a430fb03087826a).id]: (0, $29073ff13918eb95$export$7a430fb03087826a)
};
const $a5583d98c7d1626b$export$fa9a510f72606304 = Object.keys($a5583d98c7d1626b$export$cd6990c704c6a5af);



parcelRequire("9nZCP");



var $25bcc76c6c49e5b4$exports = {};

$25bcc76c6c49e5b4$exports = function(t) {
    var e = {};
    function n(r) {
        if (e[r]) return e[r].exports;
        var u = e[r] = {
            i: r,
            l: !1,
            exports: {}
        };
        return t[r].call(u.exports, u, u.exports, n), u.l = !0, u.exports;
    }
    return n.m = t, n.c = e, n.d = function(t, e, r) {
        n.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: r
        });
    }, n.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        });
    }, n.t = function(t, e) {
        if (1 & e && (t = n(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: t
        }), 2 & e && "string" != typeof t) for(var u in t)n.d(r, u, (function(e) {
            return t[e];
        }).bind(null, u));
        return r;
    }, n.n = function(t) {
        var e = t && t.__esModule ? function() {
            return t.default;
        } : function() {
            return t;
        };
        return n.d(e, "a", e), e;
    }, n.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 0);
}([
    function(t, e, n) {
        "use strict";
        Object.defineProperty(e, "__esModule", {
            value: !0
        });
        var r = n(1), u = i(r), o = i(n(2)), c = i(n(3));
        function i(t) {
            return t && t.__esModule ? t : {
                default: t
            };
        }
        var f = function(t) {
            var e = t.fg, n = t.bg, i = t.count, f = t.palette, l = t.string, a = t.size, d = t.getColor, s = t.padding, g = t.className, p = (0, r.useRef)(null);
            (0, r.useEffect)(function() {
                h(t);
            });
            var h = function() {
                var t = (0, o.default)(l), r = Math.floor(a / i), u = t.slice(0, 6);
                if (f && f.length) {
                    var g = Math.floor((0, c.default)(parseInt(t.slice(-3), 16), 0, 4095, 0, f.length));
                    e = f[g];
                }
                d && d(e || u);
                var h = s;
                p.current.width = r * i + h, p.current.height = r * i + h;
                var v = t.split("").map(function(t) {
                    return (t = parseInt(t, 16)) < 8 ? 0 : 1;
                }), b = [];
                b[0] = b[4] = v.slice(0, 5), b[1] = b[3] = v.slice(5, 10), b[2] = v.slice(10, 15);
                var y = p.current.getContext("2d");
                y.imageSmoothingEnabled = !1, y.clearRect(0, 0, p.current.width, p.current.height), b.forEach(function(t, o) {
                    t.forEach(function(t, c) {
                        t ? (y.fillStyle = e || "#" + u, y.fillRect(r * o + h, r * c + h, r - h, r - h)) : (y.fillStyle = n, y.fillRect(r * o + h, r * c + h, r - h, r - h));
                    });
                });
            };
            return u.default.createElement("canvas", {
                ref: p,
                className: g,
                style: {
                    width: a,
                    height: a
                }
            });
        };
        f.defaultProps = {
            className: "identicon",
            bg: "transparent",
            count: 5,
            palette: null,
            fg: null,
            padding: 0,
            size: 400,
            getColor: null,
            string: ""
        }, e.default = f;
    },
    function(t, e) {
        t.exports = (parcelRequire("9nZCP"));
    },
    function(t, e, n) {
        "use strict";
        var r;
        "function" == typeof Symbol && Symbol.iterator;
        !function(u) {
            function o(t, e) {
                var n = (65535 & t) + (65535 & e);
                return (t >> 16) + (e >> 16) + (n >> 16) << 16 | 65535 & n;
            }
            function c(t, e, n, r, u, c) {
                return o(function(t, e) {
                    return t << e | t >>> 32 - e;
                }(o(o(e, t), o(r, c)), u), n);
            }
            function i(t, e, n, r, u, o, i) {
                return c(e & n | ~e & r, t, e, u, o, i);
            }
            function f(t, e, n, r, u, o, i) {
                return c(e & r | n & ~r, t, e, u, o, i);
            }
            function l(t, e, n, r, u, o, i) {
                return c(e ^ n ^ r, t, e, u, o, i);
            }
            function a(t, e, n, r, u, o, i) {
                return c(n ^ (e | ~r), t, e, u, o, i);
            }
            function d(t, e) {
                t[e >> 5] |= 128 << e % 32, t[14 + (e + 64 >>> 9 << 4)] = e;
                var n, r, u, c, d, s = 1732584193, g = -271733879, p = -1732584194, h = 271733878;
                for(n = 0; n < t.length; n += 16)r = s, u = g, c = p, d = h, g = a(g = a(g = a(g = a(g = l(g = l(g = l(g = l(g = f(g = f(g = f(g = f(g = i(g = i(g = i(g = i(g, p = i(p, h = i(h, s = i(s, g, p, h, t[n], 7, -680876936), g, p, t[n + 1], 12, -389564586), s, g, t[n + 2], 17, 606105819), h, s, t[n + 3], 22, -1044525330), p = i(p, h = i(h, s = i(s, g, p, h, t[n + 4], 7, -176418897), g, p, t[n + 5], 12, 1200080426), s, g, t[n + 6], 17, -1473231341), h, s, t[n + 7], 22, -45705983), p = i(p, h = i(h, s = i(s, g, p, h, t[n + 8], 7, 1770035416), g, p, t[n + 9], 12, -1958414417), s, g, t[n + 10], 17, -42063), h, s, t[n + 11], 22, -1990404162), p = i(p, h = i(h, s = i(s, g, p, h, t[n + 12], 7, 1804603682), g, p, t[n + 13], 12, -40341101), s, g, t[n + 14], 17, -1502002290), h, s, t[n + 15], 22, 1236535329), p = f(p, h = f(h, s = f(s, g, p, h, t[n + 1], 5, -165796510), g, p, t[n + 6], 9, -1069501632), s, g, t[n + 11], 14, 643717713), h, s, t[n], 20, -373897302), p = f(p, h = f(h, s = f(s, g, p, h, t[n + 5], 5, -701558691), g, p, t[n + 10], 9, 38016083), s, g, t[n + 15], 14, -660478335), h, s, t[n + 4], 20, -405537848), p = f(p, h = f(h, s = f(s, g, p, h, t[n + 9], 5, 568446438), g, p, t[n + 14], 9, -1019803690), s, g, t[n + 3], 14, -187363961), h, s, t[n + 8], 20, 1163531501), p = f(p, h = f(h, s = f(s, g, p, h, t[n + 13], 5, -1444681467), g, p, t[n + 2], 9, -51403784), s, g, t[n + 7], 14, 1735328473), h, s, t[n + 12], 20, -1926607734), p = l(p, h = l(h, s = l(s, g, p, h, t[n + 5], 4, -378558), g, p, t[n + 8], 11, -2022574463), s, g, t[n + 11], 16, 1839030562), h, s, t[n + 14], 23, -35309556), p = l(p, h = l(h, s = l(s, g, p, h, t[n + 1], 4, -1530992060), g, p, t[n + 4], 11, 1272893353), s, g, t[n + 7], 16, -155497632), h, s, t[n + 10], 23, -1094730640), p = l(p, h = l(h, s = l(s, g, p, h, t[n + 13], 4, 681279174), g, p, t[n], 11, -358537222), s, g, t[n + 3], 16, -722521979), h, s, t[n + 6], 23, 76029189), p = l(p, h = l(h, s = l(s, g, p, h, t[n + 9], 4, -640364487), g, p, t[n + 12], 11, -421815835), s, g, t[n + 15], 16, 530742520), h, s, t[n + 2], 23, -995338651), p = a(p, h = a(h, s = a(s, g, p, h, t[n], 6, -198630844), g, p, t[n + 7], 10, 1126891415), s, g, t[n + 14], 15, -1416354905), h, s, t[n + 5], 21, -57434055), p = a(p, h = a(h, s = a(s, g, p, h, t[n + 12], 6, 1700485571), g, p, t[n + 3], 10, -1894986606), s, g, t[n + 10], 15, -1051523), h, s, t[n + 1], 21, -2054922799), p = a(p, h = a(h, s = a(s, g, p, h, t[n + 8], 6, 1873313359), g, p, t[n + 15], 10, -30611744), s, g, t[n + 6], 15, -1560198380), h, s, t[n + 13], 21, 1309151649), p = a(p, h = a(h, s = a(s, g, p, h, t[n + 4], 6, -145523070), g, p, t[n + 11], 10, -1120210379), s, g, t[n + 2], 15, 718787259), h, s, t[n + 9], 21, -343485551), s = o(s, r), g = o(g, u), p = o(p, c), h = o(h, d);
                return [
                    s,
                    g,
                    p,
                    h
                ];
            }
            function s(t) {
                var e, n = "", r = 32 * t.length;
                for(e = 0; e < r; e += 8)n += String.fromCharCode(t[e >> 5] >>> e % 32 & 255);
                return n;
            }
            function g(t) {
                var e, n = [];
                for(n[(t.length >> 2) - 1] = void 0, e = 0; e < n.length; e += 1)n[e] = 0;
                var r = 8 * t.length;
                for(e = 0; e < r; e += 8)n[e >> 5] |= (255 & t.charCodeAt(e / 8)) << e % 32;
                return n;
            }
            function p(t) {
                var e, n, r = "";
                for(n = 0; n < t.length; n += 1)e = t.charCodeAt(n), r += "0123456789abcdef".charAt(e >>> 4 & 15) + "0123456789abcdef".charAt(15 & e);
                return r;
            }
            function h(t) {
                return unescape(encodeURIComponent(t));
            }
            function v(t) {
                return function(t) {
                    return s(d(g(t), 8 * t.length));
                }(h(t));
            }
            function b(t, e) {
                return function(t, e) {
                    var n, r, u = g(t), o = [], c = [];
                    for(o[15] = c[15] = void 0, u.length > 16 && (u = d(u, 8 * t.length)), n = 0; n < 16; n += 1)o[n] = 909522486 ^ u[n], c[n] = 1549556828 ^ u[n];
                    return r = d(o.concat(g(e)), 512 + 8 * e.length), s(d(c.concat(r), 640));
                }(h(t), h(e));
            }
            function y(t, e, n) {
                return e ? n ? b(e, t) : function(t, e) {
                    return p(b(t, e));
                }(e, t) : n ? v(t) : function(t) {
                    return p(v(t));
                }(t);
            }
            void 0 === (r = (function() {
                return y;
            }).call(e, n, e, t)) || (t.exports = r);
        }();
    },
    function(t, e, n) {
        "use strict";
        Object.defineProperty(e, "__esModule", {
            value: !0
        });
        e.default = function(t, e, n, r, u) {
            return (t - e) * (u - r) / (n - e) + r;
        };
    }
]);



var $1r7Xu = parcelRequire("1r7Xu");
function $dcb9f356e0e0b2ff$export$e6e2bc9967bf256c(address) {
    if (address.endsWith(".eth")) return address;
    try {
        const formattedAddress = (0, $1r7Xu.getAddress)(address);
        return formattedAddress.substring(0, 6) + "..." + formattedAddress.substring(formattedAddress.length - 4);
    } catch  {
        throw new TypeError("Invalid input, address can't be parsed");
    }
}


const $100828c54b419b1c$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: auto;
  align-items: flex-start;
  gap: 8px;
  align-items: center;
  background-color: ${({ theme: theme })=>theme.whiteBackground};
  padding: 0px;

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      background-color: ${({ theme: theme })=>theme.whiteLowOpacity};
      flex-direction: row;
      align-content: center;
      border-radius: 300px;
      gap: 0px;
      padding: 0 12px;
    `)}
`;
const $100828c54b419b1c$var$AccountContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  min-height: 32px;
  display: flex;
  align-items: center;
  width: fit-content;
  gap: 8px;

  > label {
    font-size: 16px;
    font-weight: 600;
  }

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      gap: 12px;
      > label {
        color: ${({ theme: theme })=>theme.primaryText};
        font-weight: 400;
        font-size: 14px;
      }
    `)}
`;
const $100828c54b419b1c$var$ChainConnectionContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  width: fit-content;
  min-height: 32px;
  align-items: center;
  padding-left: 0px;
  > label {
    color: ${({ theme: theme })=>theme.success};
    font-size: 16px;

    font-weight: 500;
  }

  :before {
    content: "";
    width: 8px;
    height: 8px;
    margin: 0px 13px 0px 3px;
    border-radius: 50%;
    background-color: ${({ theme: theme })=>theme.success};
  }

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      display: none;
    `)}
`;
const $100828c54b419b1c$var$StyledIdenticon = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($25bcc76c6c49e5b4$exports))))`
  align-items: center;
  svg {
    width: ${({ size: size })=>size + "px"};
    height: ${({ size: size })=>size + "px"};
  }
`;
const $100828c54b419b1c$var$StyledAvatar = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).img`
  align-items: center;
  object-fit: cover;
  border-radius: 50%;
  width: ${({ size: size })=>size + "px"};
  height: ${({ size: size })=>size + "px"};
`;
const $100828c54b419b1c$export$f8b4f9182cfa7b1d = ({ size: size = "16", address: propAddress })=>{
    const { address: defaultAddress } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    const address = propAddress || defaultAddress;
    const { data: name } = (0, $b9a08c139e2d6879$export$e7302f55b2684d23)({
        address: address,
        chainId: 1
    });
    const { data: avatar } = (0, $b9a08c139e2d6879$export$182f359dd9766fbb)({
        name: name,
        chainId: 1
    });
    return avatar ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($100828c54b419b1c$var$StyledAvatar, {
        src: avatar,
        alt: "avatar",
        size: size
    }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($100828c54b419b1c$var$StyledIdenticon, {
        size: size,
        string: address
    });
};
const $100828c54b419b1c$export$6cdabdfc8e8da8af = ({ address: propAddress })=>{
    const { address: defaultAddress } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    const address = propAddress || defaultAddress;
    const { data: data } = (0, $b9a08c139e2d6879$export$e7302f55b2684d23)({
        address: address,
        chainId: 1
    });
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("label", {
        children: data ?? (address && (0, $dcb9f356e0e0b2ff$export$e6e2bc9967bf256c)(address))
    });
};
const $100828c54b419b1c$export$97063c1c513ee59f = ()=>{
    const { chain: chain } = (0, $b9a08c139e2d6879$export$553aaf59afc1a2d8)();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("label", {
        children: chain?.name
    });
};
const $100828c54b419b1c$var$AccountDisplay = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($100828c54b419b1c$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($100828c54b419b1c$var$AccountContainer, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($100828c54b419b1c$export$f8b4f9182cfa7b1d, {
                        size: "32"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($100828c54b419b1c$export$6cdabdfc8e8da8af, {})
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($100828c54b419b1c$var$ChainConnectionContainer, {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($100828c54b419b1c$export$97063c1c513ee59f, {})
            })
        ]
    });
};
var $100828c54b419b1c$export$2e2bcd8739ae039 = $100828c54b419b1c$var$AccountDisplay;


const $114c356563326614$export$87dd1b4aceb12c0e = ()=>{
    const { switchNetwork: switchNetwork, isLoading: isLoading } = (0, $b9a08c139e2d6879$export$71b0470720f288c1)();
    const handleSwitch = ()=>{
        if (!switchNetwork) {
            console.error("Cannot switch network. Please do it manually.");
            return;
        }
        try {
            switchNetwork((0, $a5583d98c7d1626b$export$8372812df8e8183f));
        } catch (err) {
            console.error(err);
        }
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.Button), {
        isLoading: isLoading,
        disabled: isLoading,
        text: `Switch to ${(0, $a5583d98c7d1626b$export$7000f41a852f3e5)[0, $a5583d98c7d1626b$export$8372812df8e8183f].name}`,
        onClick: handleSwitch
    });
};
const $114c356563326614$var$ConnectButton = ()=>{
    const { open: open, isOpen: isOpen } = (0, $e6fafce87905c9df$export$69804ca079d47f29)();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.Button), {
        disabled: isOpen,
        small: true,
        text: "Connect",
        onClick: async ()=>open({
                route: "ConnectWallet"
            })
    });
};
const $114c356563326614$var$ConnectWallet = ()=>{
    const { chain: chain } = (0, $b9a08c139e2d6879$export$553aaf59afc1a2d8)();
    const { isConnected: isConnected } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    if (isConnected) {
        if (chain && chain.id !== (0, $a5583d98c7d1626b$export$8372812df8e8183f)) return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($114c356563326614$export$87dd1b4aceb12c0e, {});
        else return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $100828c54b419b1c$export$2e2bcd8739ae039), {});
    } else return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($114c356563326614$var$ConnectButton, {});
};
var $114c356563326614$export$2e2bcd8739ae039 = $114c356563326614$var$ConnectWallet;




const $a4e24e3c9f4f276a$export$c6fdb837b070b4ff = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme: theme })=>theme.blackLowOpacity};
  z-index: 1;
`;



parcelRequire("9nZCP");
const $d0e9659fd2942e08$var$SvgKlerosSolutions = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 16,
        height: 14,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm0 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm8-12a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM8 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm2 3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4-8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm2 3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
        })
    });
var $d0e9659fd2942e08$export$2e2bcd8739ae039 = $d0e9659fd2942e08$var$SvgKlerosSolutions;



parcelRequire("9nZCP");




parcelRequire("9nZCP");
const $fa090fe20ee2d718$var$SvgDarkMode = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 15,
        height: 16,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M8 16a7.985 7.985 0 0 0 6.214-2.962.375.375 0 0 0-.361-.605c-3.881.74-7.446-2.237-7.446-6.155A6.264 6.264 0 0 1 9.58.828a.375.375 0 0 0-.117-.694A8 8 0 0 0 0 8a8 8 0 0 0 8 8Z"
        })
    });
var $fa090fe20ee2d718$export$2e2bcd8739ae039 = $fa090fe20ee2d718$var$SvgDarkMode;



parcelRequire("9nZCP");
const $b72ac035d44eae41$var$SvgHelp = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M8 0a8.001 8.001 0 0 0 0 16A8.001 8.001 0 0 0 8 0Zm0 14.452A6.448 6.448 0 0 1 1.548 8 6.45 6.45 0 0 1 8 1.548 6.45 6.45 0 0 1 14.452 8 6.448 6.448 0 0 1 8 14.452Zm3.46-8.233c0 2.163-2.337 2.197-2.337 2.996v.204a.387.387 0 0 1-.387.387H7.264a.387.387 0 0 1-.387-.387V9.14c0-1.153.874-1.614 1.534-1.984.567-.318.914-.534.914-.955 0-.556-.71-.925-1.283-.925-.748 0-1.094.354-1.579.967a.387.387 0 0 1-.538.068l-.897-.68a.388.388 0 0 1-.085-.528c.762-1.12 1.732-1.748 3.244-1.748 1.583 0 3.273 1.235 3.273 2.864Zm-2.105 5.394c0 .747-.608 1.355-1.355 1.355a1.356 1.356 0 0 1-1.355-1.355c0-.747.608-1.355 1.355-1.355s1.355.608 1.355 1.355Z"
        })
    });
var $b72ac035d44eae41$export$2e2bcd8739ae039 = $b72ac035d44eae41$var$SvgHelp;



parcelRequire("9nZCP");
const $4de06aa8fd10b148$var$SvgLightMode = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 17,
        height: 16,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M8.769 5c-1.654 0-3 1.347-3 3s1.346 3 3 3c1.653 0 3-1.347 3-3s-1.347-3-3-3Zm7.7 2.516-2.96-1.479L14.556 2.9a.54.54 0 0 0-.684-.684l-3.138 1.046L9.253.3c-.2-.4-.769-.4-.969 0L6.806 3.26l-3.14-1.047a.54.54 0 0 0-.685.684l1.047 3.137-2.96 1.482c-.4.2-.4.768 0 .968l2.96 1.479-1.047 3.14a.54.54 0 0 0 .684.684l3.138-1.046L8.28 15.7c.2.4.769.4.969 0l1.478-2.96 3.137 1.047a.54.54 0 0 0 .685-.684l-1.047-3.137 2.96-1.478a.542.542 0 0 0 .006-.972Zm-4.872 3.312a4.004 4.004 0 0 1-5.657 0 4.004 4.004 0 0 1 0-5.656 4.004 4.004 0 0 1 5.657 0 4.004 4.004 0 0 1 0 5.656Z"
        })
    });
var $4de06aa8fd10b148$export$2e2bcd8739ae039 = $4de06aa8fd10b148$var$SvgLightMode;



parcelRequire("9nZCP");
const $432e573c2cd8718f$var$SvgNotifications = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 14,
        height: 16,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M13.68 11.322c-.6-.65-1.726-1.625-1.726-4.822 0-2.428-1.697-4.372-3.984-4.849V1c0-.552-.446-1-.996-1a.998.998 0 0 0-.995 1v.651C3.69 2.128 1.995 4.071 1.995 6.5c0 3.197-1.125 4.173-1.727 4.822A1 1 0 0 0 1 13h11.95a.999.999 0 0 0 .732-1.678ZM2.104 11.5c.66-.874 1.383-2.323 1.386-4.982L3.487 6.5c0-1.933 1.561-3.5 3.487-3.5a3.493 3.493 0 0 1 3.488 3.5l-.002.018c.003 2.66.725 4.108 1.386 4.982H2.103ZM6.974 16c1.1 0 1.992-.895 1.992-2H4.983c0 1.105.892 2 1.991 2Z"
        })
    });
var $432e573c2cd8718f$export$2e2bcd8739ae039 = $432e573c2cd8718f$var$SvgNotifications;



parcelRequire("9nZCP");
const $d9ee60e964d4a7b4$var$SvgSettings = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 16,
        height: 16,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "m15.121 9.923-1.374-.794a6.214 6.214 0 0 0 0-2.264l1.374-.794a.39.39 0 0 0 .178-.452 8.033 8.033 0 0 0-1.765-3.051.388.388 0 0 0-.477-.074l-1.375.793a6.087 6.087 0 0 0-1.96-1.132V.57a.386.386 0 0 0-.304-.377 8.11 8.11 0 0 0-3.523 0 .386.386 0 0 0-.303.377v1.587A6.28 6.28 0 0 0 3.631 3.29L2.26 2.497a.383.383 0 0 0-.478.074A7.986 7.986 0 0 0 .018 5.623a.386.386 0 0 0 .177.451l1.375.794a6.214 6.214 0 0 0 0 2.264l-1.375.794a.39.39 0 0 0-.177.451 8.034 8.034 0 0 0 1.764 3.052.388.388 0 0 0 .478.074l1.374-.793c.577.496 1.242.88 1.961 1.132v1.587c0 .18.126.339.304.377a8.11 8.11 0 0 0 3.522 0 .386.386 0 0 0 .303-.377v-1.587a6.28 6.28 0 0 0 1.962-1.132l1.374.793c.158.09.355.062.477-.074a7.985 7.985 0 0 0 1.765-3.052.398.398 0 0 0-.18-.454Zm-7.464.654a2.584 2.584 0 0 1-2.581-2.58 2.584 2.584 0 0 1 2.58-2.58 2.584 2.584 0 0 1 2.581 2.58 2.584 2.584 0 0 1-2.58 2.58Z"
        })
    });
var $d9ee60e964d4a7b4$export$2e2bcd8739ae039 = $d9ee60e964d4a7b4$var$SvgSettings;



const $580a8ca79c84a57d$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;

  flex-direction: column;
  gap: 0px;

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      flex-direction: row;
      gap: 8px;
    `)}
`;
const $580a8ca79c84a57d$var$ButtonContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  min-height: 32px;
  display: flex;
  align-items: center;

  button {
    padding: 0px;
  }

  .button-text {
    display: block;
  }

  .button-svg {
    fill: ${({ theme: theme })=>theme.secondaryPurple};
  }

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      .button-svg {
        fill: ${({ theme: theme })=>theme.white};
      }
      .button-text {
        display: none;
      }
    `)}
`;
const $580a8ca79c84a57d$var$Menu = ({ toggleIsHelpOpen: toggleIsHelpOpen, toggleIsSettingsOpen: toggleIsSettingsOpen })=>{
    const [theme, toggleTheme] = (0, $9bc8dca83e4f2710$export$c07acc0415d9f757)();
    const isLightTheme = theme === "light";
    const buttons = [
        {
            text: "Notifications",
            Icon: (0, $432e573c2cd8718f$export$2e2bcd8739ae039)
        },
        {
            text: "Settings",
            Icon: (0, $d9ee60e964d4a7b4$export$2e2bcd8739ae039),
            onClick: ()=>toggleIsSettingsOpen()
        },
        {
            text: "Help",
            Icon: (0, $b72ac035d44eae41$export$2e2bcd8739ae039),
            onClick: ()=>{
                toggleIsHelpOpen();
            }
        },
        {
            text: `${isLightTheme ? "Dark" : "Light"} Mode`,
            Icon: isLightTheme ? (0, $fa090fe20ee2d718$export$2e2bcd8739ae039) : (0, $4de06aa8fd10b148$export$2e2bcd8739ae039),
            onClick: ()=>toggleTheme()
        }
    ];
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($580a8ca79c84a57d$var$Container, {
        children: buttons.map(({ text: text, Icon: Icon, onClick: onClick })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($580a8ca79c84a57d$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $072682708a04db72$export$2e2bcd8739ae039), {
                    text: text,
                    onClick: onClick,
                    Icon: Icon
                })
            }, Icon))
    });
};
var $580a8ca79c84a57d$export$2e2bcd8739ae039 = $580a8ca79c84a57d$var$Menu;




var $9nZCP = parcelRequire("9nZCP");




parcelRequire("9nZCP");
const $f048283e8d0ef592$var$SvgBook = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 16,
        height: 16,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M14.838 11.25V.75c0-.416-.33-.75-.741-.75H3.965C2.328 0 1 1.344 1 3v10c0 1.656 1.328 3 2.965 3h10.132c.41 0 .74-.334.74-.75v-.5a.76.76 0 0 0-.274-.584c-.13-.482-.13-1.854 0-2.335a.748.748 0 0 0 .275-.581ZM4.954 4.187c0-.103.083-.187.185-.187h6.548c.102 0 .186.084.186.188v.625a.187.187 0 0 1-.186.187H5.14a.187.187 0 0 1-.185-.188v-.625Zm0 2c0-.103.083-.187.185-.187h6.548c.102 0 .186.084.186.188v.625a.187.187 0 0 1-.186.187H5.14a.187.187 0 0 1-.185-.188v-.625ZM12.78 14H3.965a.993.993 0 0 1-.988-1c0-.55.445-1 .988-1h8.816a11.38 11.38 0 0 0 0 2Z"
        })
    });
var $f048283e8d0ef592$export$2e2bcd8739ae039 = $f048283e8d0ef592$var$SvgBook;



parcelRequire("9nZCP");
const $847b1abcb1af2d9d$var$SvgBug = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 16,
        height: 16,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
            clipPath: "url('a2de8f59ec1d4759')",
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M16 9.028a1.013 1.013 0 0 1-1.02.972h-1.73v.5c0 .683-.153 1.33-.425 1.91l1.882 1.883a1 1 0 0 1-1.414 1.414l-1.71-1.71A4.48 4.48 0 0 1 8.75 15V7.375A.375.375 0 0 0 8.375 7h-.75a.375.375 0 0 0-.375.375V15a4.48 4.48 0 0 1-2.832-1.003l-1.71 1.71a1 1 0 0 1-1.415-1.414l1.882-1.882A4.483 4.483 0 0 1 2.75 10.5V10H1.02A1.014 1.014 0 0 1 0 9.028 1 1 0 0 1 1 8h1.75V6.164L1.293 4.707a1 1 0 0 1 1.414-1.414L4.414 5h7.172l1.707-1.707a1 1 0 0 1 1.414 1.414L13.25 6.164V8H15a1 1 0 0 1 1 1.028ZM8.03 0a3.5 3.5 0 0 0-3.5 3.5h7a3.5 3.5 0 0 0-3.5-3.5Z"
            })
        })
    });
var $847b1abcb1af2d9d$export$2e2bcd8739ae039 = $847b1abcb1af2d9d$var$SvgBug;



parcelRequire("9nZCP");
const $9a272f6bb61c6c5c$var$SvgEth = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 16,
        height: 16,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "m12.445 8.15-4.72 2.9L3 8.15 7.724 0l4.721 8.15Zm-4.72 3.831L3 9.081 7.724 16l4.725-6.919-4.725 2.9Z",
            fill: "#9013FE"
        })
    });
var $9a272f6bb61c6c5c$export$2e2bcd8739ae039 = $9a272f6bb61c6c5c$var$SvgEth;




parcelRequire("9nZCP");
const $2e4ec0f6cbd86dc5$var$SvgTelegram = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
            clipPath: "url('f17f2616b8dd6487')",
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "m16.55 2.197-2.414 11.16c-.182.787-.657.983-1.332.612l-3.68-2.657-1.774 1.673c-.197.193-.361.354-.74.354l.265-3.672 6.818-6.038c.297-.26-.064-.403-.46-.144l-8.43 5.202-3.629-1.113c-.79-.242-.803-.774.165-1.145L15.533 1.07c.657-.241 1.232.144 1.018 1.127Z"
            })
        })
    });
var $2e4ec0f6cbd86dc5$export$2e2bcd8739ae039 = $2e4ec0f6cbd86dc5$var$SvgTelegram;



parcelRequire("9nZCP");


const $82d1f33f0bcdb444$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  label,
  a {
    font-family: "Roboto Mono", monospace;
    line-height: 10px;
    font-size: 10px;
    color: ${({ theme: theme })=>theme.stroke};
  }
`;
const $82d1f33f0bcdb444$var$Version = ()=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("label", {
        children: [
            "v",
            (0, $4ec8515f3272cbaa$export$f1af843f4d252578),
            " ",
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("a", {
                href: (0, $4ec8515f3272cbaa$export$1c46d8639ab5b0b),
                target: "_blank",
                rel: "noreferrer",
                children: [
                    "#",
                    (0, $4ec8515f3272cbaa$export$8439c9c045e5384d)
                ]
            }),
            (0, $4ec8515f3272cbaa$export$512554f3e5add99) && (0, $4ec8515f3272cbaa$export$512554f3e5add99) !== "HEAD" && ` ${0, $4ec8515f3272cbaa$export$512554f3e5add99}`,
            (0, $4ec8515f3272cbaa$export$ac95da7ac2645a99) && ` ${0, $4ec8515f3272cbaa$export$ac95da7ac2645a99}`,
            (0, $4ec8515f3272cbaa$export$91f55afd4519d50b) && ` dirty`
        ]
    });
var $82d1f33f0bcdb444$var$Phases;
(function(Phases) {
    Phases[Phases["staking"] = 0] = "staking";
    Phases[Phases["generating"] = 1] = "generating";
    Phases[Phases["drawing"] = 2] = "drawing";
})($82d1f33f0bcdb444$var$Phases || ($82d1f33f0bcdb444$var$Phases = {}));
// const Phase = () => {
//   const { data: phase } = useSortitionModulePhase({
//     watch: true,
//   });
//   return (
//     <>
//       {phase !== undefined && (
//         <label>
//           <br />
//           phase: {Phases[phase]}
//         </label>
//       )}
//     </>
//   );
// };
const $82d1f33f0bcdb444$var$Debug = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($82d1f33f0bcdb444$var$Container, {
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($82d1f33f0bcdb444$var$Version, {})
    });
};
var $82d1f33f0bcdb444$export$2e2bcd8739ae039 = $82d1f33f0bcdb444$var$Debug;


const $545dc5bc6e41aec9$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  position: absolute;
  max-height: 80vh;
  overflow-y: auto;
  width: 86vw;
  max-width: 444px;
  top: 5%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  padding: 27px 10px;
  gap: 23px;
  border: 1px solid ${({ theme: theme })=>theme.stroke};
  background-color: ${({ theme: theme })=>theme.whiteBackground};
  border-radius: 3px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.06);

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      margin-top: 64px;
      width: 260px;
      top: 0;
      right: 0;
      left: auto;
      transform: none;
    `)}
`;
const $545dc5bc6e41aec9$var$ListItem = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).a`
  display: flex;
  gap: 8px;
  padding: 0px 8px;
  cursor: pointer;
  :hover {
    transform: scale(1.02) translateZ(0);
    transition: 200ms;
    transition-timing-function: cubic-bezier(0.3, 0, 0.2, 1);
    backface-visibility: hidden;
  }

  small {
    font-size: 16px;
    font-weight: 400;
  }
`;
const $545dc5bc6e41aec9$var$Icon = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).svg`
  display: inline-block;
  width: 16px;
  height: 16px;
  fill: ${({ theme: theme })=>theme.secondaryPurple};
`;
const $545dc5bc6e41aec9$var$ITEMS = [
    {
        text: "Get Help",
        Icon: (0, $2e4ec0f6cbd86dc5$export$2e2bcd8739ae039),
        url: "https://t.me/kleros"
    },
    {
        text: "Report a Bug",
        Icon: (0, $847b1abcb1af2d9d$export$2e2bcd8739ae039),
        url: "https://github.com/kleros/escrow-v2/issues"
    },
    {
        text: "DApp Guide",
        Icon: (0, $f048283e8d0ef592$export$2e2bcd8739ae039),
        url: "https://docs.kleros.io/products/escrow"
    },
    {
        text: "Crypto Beginner's Guide",
        Icon: (0, $9a272f6bb61c6c5c$export$2e2bcd8739ae039),
        url: "https://ethereum.org/en/wallets/"
    },
    {
        text: "FAQ",
        Icon: (0, $b72ac035d44eae41$export$2e2bcd8739ae039),
        url: "https://docs.kleros.io/kleros-faq"
    }
];
const $545dc5bc6e41aec9$var$Help = ({ toggleIsHelpOpen: toggleIsHelpOpen })=>{
    const containerRef = (0, $9nZCP.useRef)(null);
    (0, $0aa9c5ea5f98ac89$export$2e2bcd8739ae039)(containerRef, ()=>toggleIsHelpOpen());
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $dde41420777b5d34$exports.Fragment), {
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($545dc5bc6e41aec9$var$Container, {
            ref: containerRef,
            children: [
                $545dc5bc6e41aec9$var$ITEMS.map((item, index)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($545dc5bc6e41aec9$var$ListItem, {
                        href: item.url,
                        target: "_blank",
                        children: [
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($545dc5bc6e41aec9$var$Icon, {
                                as: item.Icon
                            }),
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("small", {
                                children: item.text
                            })
                        ]
                    }, item.text)),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $82d1f33f0bcdb444$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $545dc5bc6e41aec9$export$2e2bcd8739ae039 = $545dc5bc6e41aec9$var$Help;




var $9nZCP = parcelRequire("9nZCP");





parcelRequire("9nZCP");





parcelRequire("9nZCP");



const $c94a24f44dbbed94$export$c640ece8678a7df5 = ({ children: children })=>{
    const { chain: chain } = (0, $b9a08c139e2d6879$export$553aaf59afc1a2d8)();
    return chain && chain.id === (0, $a5583d98c7d1626b$export$8372812df8e8183f) ? children : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $114c356563326614$export$2e2bcd8739ae039), {});
};


const $41d19829f2affbae$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 12px;
`;
const $41d19829f2affbae$var$StyledChainContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  height: 34px;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  :before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ theme: theme })=>theme.success};
  }
  > label {
    color: ${({ theme: theme })=>theme.success};
  }
`;
const $41d19829f2affbae$var$StyledAddressContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  > label {
    color: ${({ theme: theme })=>theme.primaryText};
    font-size: 16px;
    font-weight: 600;
  }
`;
const $41d19829f2affbae$var$StyledAvatarContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  margin-top: 12px;
`;
const $41d19829f2affbae$var$StyledButton = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;
const $41d19829f2affbae$var$EnsureChainContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  padding: 16px;
`;
const $41d19829f2affbae$var$UserContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const $41d19829f2affbae$export$c604e936fdf27a02 = ()=>{
    const { disconnect: disconnect } = (0, $b9a08c139e2d6879$export$83bebf2fe7fead4e)();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.Button), {
        text: `Disconnect`,
        onClick: ()=>disconnect()
    });
};
const $41d19829f2affbae$var$General = ()=>{
    const { address: address } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($41d19829f2affbae$var$EnsureChainContainer, {
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $c94a24f44dbbed94$export$c640ece8678a7df5), {
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($41d19829f2affbae$var$Container, {
                children: address && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($41d19829f2affbae$var$UserContainer, {
                    children: [
                        /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($41d19829f2affbae$var$StyledAvatarContainer, {
                            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $100828c54b419b1c$export$f8b4f9182cfa7b1d), {
                                size: "48"
                            })
                        }),
                        /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($41d19829f2affbae$var$StyledAddressContainer, {
                            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $100828c54b419b1c$export$6cdabdfc8e8da8af), {})
                        }),
                        /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($41d19829f2affbae$var$StyledChainContainer, {
                            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $100828c54b419b1c$export$97063c1c513ee59f), {})
                        }),
                        /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($41d19829f2affbae$var$StyledButton, {
                            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($41d19829f2affbae$export$c604e936fdf27a02, {})
                        })
                    ]
                })
            })
        })
    });
};
var $41d19829f2affbae$export$2e2bcd8739ae039 = $41d19829f2affbae$var$General;



parcelRequire("9nZCP");



var $9nZCP = parcelRequire("9nZCP");





function $cf00fb62a6062303$export$925226e2a01c2566(formData) {
    const authToken = sessionStorage.getItem("auth-token")?.replace(/"/g, "");
    return (0, $73d46209e4d80851$export$b410431fab84fa58).promise(fetch("/.netlify/functions/update-settings", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "x-auth-token": authToken ?? ""
        },
        body: JSON.stringify(formData)
    }).then(async (response)=>{
        if (response.status !== 200) {
            const error = await response.json().catch(()=>({
                    message: "Error uploading to Supabase"
                }));
            throw new Error(error.message);
        }
        return response;
    }), {
        pending: "Saving...",
        success: "Saved successfully!",
        error: {
            render ({ data: error }) {
                return `Upload failed: ${error?.message}`;
            }
        }
    }, (0, $6724d57570dc2c5f$export$8eb3892b442747bd));
}




var $9nZCP = parcelRequire("9nZCP");


const $c637687f275751c9$var$StyledLabel = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).label`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;
const $c637687f275751c9$var$StyledField = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Field))`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
const $c637687f275751c9$var$FormContact = ({ contactLabel: contactLabel, contactPlaceholder: contactPlaceholder, contactInput: contactInput, contactIsValid: contactIsValid, setContactInput: setContactInput, setContactIsValid: setContactIsValid, validator: validator, isEditing: isEditing })=>{
    (0, $9nZCP.useEffect)(()=>{
        setContactIsValid(contactInput === "" ? true : validator.test(contactInput));
    }, [
        contactInput,
        setContactIsValid,
        validator
    ]);
    const handleInputChange = (event)=>{
        event.preventDefault();
        setContactInput(event.target.value);
    };
    const fieldVariant = (0, $9nZCP.useMemo)(()=>{
        if (contactInput === "" || !isEditing) return undefined;
        return contactIsValid ? "success" : "error";
    }, [
        contactInput,
        contactIsValid,
        isEditing
    ]);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($c637687f275751c9$var$StyledLabel, {
                children: contactLabel
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($c637687f275751c9$var$StyledField, {
                variant: fieldVariant,
                value: contactInput,
                onChange: handleInputChange,
                placeholder: contactPlaceholder
            })
        ]
    });
};
var $c637687f275751c9$export$2e2bcd8739ae039 = $c637687f275751c9$var$FormContact;






var $9nZCP = parcelRequire("9nZCP");






var $9nZCP = parcelRequire("9nZCP");

"use client";
const $dd50e9d6cd556be0$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $dd50e9d6cd556be0$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $9nZCP.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $dd50e9d6cd556be0$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $26824e177b094e25$export$2072f68e6c3507cf)(useErrorBoundary, [
        result.error,
        query
    ]);
};


const $d749e48edf6277fb$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
    }
};
const $d749e48edf6277fb$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $d749e48edf6277fb$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $d749e48edf6277fb$export$e0a3f29513afe430(result, isRestoring);
const $d749e48edf6277fb$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });


"use client";
function $2dfccc5642198c47$export$fff0865807e996c5(options, Observer) {
    const queryClient = (0, $6d6ab9aaa62ea16f$export$22e77b9572c4fded)({
        context: options.context
    });
    const isRestoring = (0, $01256efc3ced208c$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $5b612932a4d5ecb0$export$50dfac555130cafd)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic"; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $95cde0856394eaca$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $95cde0856394eaca$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $95cde0856394eaca$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    (0, $d749e48edf6277fb$export$2c40a591ad2dafb1)(defaultedOptions);
    (0, $dd50e9d6cd556be0$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $dd50e9d6cd556be0$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $9nZCP.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, $35a9e77badf401d4$export$306c0aa65ff9ec16)($9nZCP.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, $95cde0856394eaca$export$520687f44db6e1ab).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $9nZCP.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, $d749e48edf6277fb$export$88d3586dfed64df9)(defaultedOptions, result, isRestoring)) throw (0, $d749e48edf6277fb$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, $dd50e9d6cd556be0$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $8c6a367513f3f9c5$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = (0, $013477420ae0c1cc$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $2dfccc5642198c47$export$fff0865807e996c5)(parsedOptions, (0, $2e43c33ae708cf27$export$a06cf8c0066f0d4c));
}


const $c62bd748620e6ea9$export$fce6876652108ab = (maybeObject)=>typeof maybeObject === "undefined";


const $2c4f8190202ecf20$export$8b4f00ca24c1e68e = ()=>{
    const authToken = sessionStorage.getItem("auth-token")?.replace(/"/g, "");
    const isEnabled = !(0, $c62bd748620e6ea9$export$fce6876652108ab)(authToken);
    return (0, $8c6a367513f3f9c5$export$dd0a697e1782aedd)({
        queryKey: [
            "UserSettings"
        ],
        enabled: isEnabled,
        staleTime: Number.POSITIVE_INFINITY,
        queryFn: async ()=>{
            try {
                if (!authToken) return;
                const res = await fetch("/.netlify/functions/fetch-settings", {
                    method: "POST",
                    headers: {
                        "x-auth-token": authToken
                    }
                });
                return (await res.json())?.data;
            } catch  {
                return {};
            }
        }
    });
};


const $29f743294007a17a$var$FormContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).form`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0 ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(12, 32, 300)};
  padding-bottom: 16px;
`;
const $29f743294007a17a$var$ButtonContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: end;
`;
const $29f743294007a17a$var$FormContactContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;
const $29f743294007a17a$var$FormContactDetails = ({ toggleIsSettingsOpen: toggleIsSettingsOpen })=>{
    const [telegramInput, setTelegramInput] = (0, $9nZCP.useState)("");
    const [emailInput, setEmailInput] = (0, $9nZCP.useState)("");
    const [telegramIsValid, setTelegramIsValid] = (0, $9nZCP.useState)(false);
    const [emailIsValid, setEmailIsValid] = (0, $9nZCP.useState)(false);
    const [isUpdatingSettings, setIsUpdatingSettings] = (0, $9nZCP.useState)(false);
    const { address: address } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    const { data: userSettings, refetch: refetchUserSettings } = (0, $2c4f8190202ecf20$export$8b4f00ca24c1e68e)();
    const isEditingEmail = (0, $9nZCP.useMemo)(()=>{
        if (!userSettings?.email && emailInput === "") return false;
        return userSettings?.email !== emailInput;
    }, [
        userSettings,
        emailInput
    ]);
    const isEditingTelegram = (0, $9nZCP.useMemo)(()=>{
        if (!userSettings?.telegram && telegramInput === "") return false;
        return userSettings?.telegram !== telegramInput;
    }, [
        userSettings,
        telegramInput
    ]);
    (0, $9nZCP.useEffect)(()=>{
        refetchUserSettings();
    }, [
        address
    ]);
    (0, $9nZCP.useEffect)(()=>{
        if (!userSettings) return;
        setEmailInput(userSettings.email ?? "");
        setTelegramInput(userSettings.telegram ?? "");
    }, [
        userSettings
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!address) throw new Error("Missing address");
        const data = {
            email: emailInput,
            telegram: telegramInput,
            address: address
        };
        setIsUpdatingSettings(true);
        (0, $cf00fb62a6062303$export$925226e2a01c2566)(data).then(async (res)=>{
            if (res.ok) {
                toggleIsSettingsOpen();
                refetchUserSettings();
            }
        }).catch((err)=>console.log(err)).finally(()=>setIsUpdatingSettings(false));
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($29f743294007a17a$var$FormContainer, {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($29f743294007a17a$var$FormContactContainer, {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $c637687f275751c9$export$2e2bcd8739ae039), {
                    contactLabel: "Email",
                    contactPlaceholder: "your.email@email.com",
                    contactInput: emailInput,
                    contactIsValid: emailIsValid,
                    setContactInput: setEmailInput,
                    setContactIsValid: setEmailIsValid,
                    validator: (0, $4ec8515f3272cbaa$export$7b7637218245c8a),
                    isEditing: isEditingEmail
                })
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($29f743294007a17a$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.Button), {
                    text: "Save",
                    disabled: !isEditingEmail || !emailIsValid || isUpdatingSettings,
                    isLoading: isUpdatingSettings
                })
            })
        ]
    });
};
var $29f743294007a17a$export$2e2bcd8739ae039 = $29f743294007a17a$var$FormContactDetails;





var $9nZCP = parcelRequire("9nZCP");
var $e60fe3255652942b$export$2e2bcd8739ae039 = crypto;
const $e60fe3255652942b$export$600b5603bbac4c6 = (key)=>key instanceof CryptoKey;


const $7244d0ea8a4d9b30$var$digest = async (algorithm, data)=>{
    const subtleDigest = `SHA-${algorithm.slice(-3)}`;
    return new Uint8Array(await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.digest(subtleDigest, data));
};
var $7244d0ea8a4d9b30$export$2e2bcd8739ae039 = $7244d0ea8a4d9b30$var$digest;


const $15ceb15c8014d6a6$export$5486af06137bf21a = new TextEncoder();
const $15ceb15c8014d6a6$export$124c96e6ce37090b = new TextDecoder();
const $15ceb15c8014d6a6$var$MAX_INT32 = 2 ** 32;
function $15ceb15c8014d6a6$export$ee1b3e54f0441b22(...buffers) {
    const size = buffers.reduce((acc, { length: length })=>acc + length, 0);
    const buf = new Uint8Array(size);
    let i = 0;
    for (const buffer of buffers){
        buf.set(buffer, i);
        i += buffer.length;
    }
    return buf;
}
function $15ceb15c8014d6a6$export$256d3ca12372f112(alg, p2sInput) {
    return $15ceb15c8014d6a6$export$ee1b3e54f0441b22($15ceb15c8014d6a6$export$5486af06137bf21a.encode(alg), new Uint8Array([
        0
    ]), p2sInput);
}
function $15ceb15c8014d6a6$var$writeUInt32BE(buf, value, offset) {
    if (value < 0 || value >= $15ceb15c8014d6a6$var$MAX_INT32) throw new RangeError(`value must be >= 0 and <= ${$15ceb15c8014d6a6$var$MAX_INT32 - 1}. Received ${value}`);
    buf.set([
        value >>> 24,
        value >>> 16,
        value >>> 8,
        value & 0xff
    ], offset);
}
function $15ceb15c8014d6a6$export$e7b531e00a18fdd7(value) {
    const high = Math.floor(value / $15ceb15c8014d6a6$var$MAX_INT32);
    const low = value % $15ceb15c8014d6a6$var$MAX_INT32;
    const buf = new Uint8Array(8);
    $15ceb15c8014d6a6$var$writeUInt32BE(buf, high, 0);
    $15ceb15c8014d6a6$var$writeUInt32BE(buf, low, 4);
    return buf;
}
function $15ceb15c8014d6a6$export$74c16dba6c885532(value) {
    const buf = new Uint8Array(4);
    $15ceb15c8014d6a6$var$writeUInt32BE(buf, value);
    return buf;
}
function $15ceb15c8014d6a6$export$c1498c4a3718d967(input) {
    return $15ceb15c8014d6a6$export$ee1b3e54f0441b22($15ceb15c8014d6a6$export$74c16dba6c885532(input.length), input);
}
async function $15ceb15c8014d6a6$export$67163693c21af44f(secret, bits, value) {
    const iterations = Math.ceil((bits >> 3) / 32);
    const res = new Uint8Array(iterations * 32);
    for(let iter = 0; iter < iterations; iter++){
        const buf = new Uint8Array(4 + secret.length + value.length);
        buf.set($15ceb15c8014d6a6$export$74c16dba6c885532(iter + 1));
        buf.set(secret, 4);
        buf.set(value, 4 + secret.length);
        res.set(await (0, $7244d0ea8a4d9b30$export$2e2bcd8739ae039)("sha256", buf), iter * 32);
    }
    return res.slice(0, bits >> 3);
}


const $9f65a7b465b05d12$export$8fb536984ec8b4d7 = (input)=>{
    let unencoded = input;
    if (typeof unencoded === "string") unencoded = (0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode(unencoded);
    const CHUNK_SIZE = 0x8000;
    const arr = [];
    for(let i = 0; i < unencoded.length; i += CHUNK_SIZE)arr.push(String.fromCharCode.apply(null, unencoded.subarray(i, i + CHUNK_SIZE)));
    return btoa(arr.join(""));
};
const $9f65a7b465b05d12$export$c564cdbbe6da493 = (input)=>{
    return $9f65a7b465b05d12$export$8fb536984ec8b4d7(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
const $9f65a7b465b05d12$export$94fdf11bafc8de6b = (encoded)=>{
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return bytes;
};
const $9f65a7b465b05d12$export$2f872c0f2117be69 = (input)=>{
    let encoded = input;
    if (encoded instanceof Uint8Array) encoded = (0, $15ceb15c8014d6a6$export$124c96e6ce37090b).decode(encoded);
    encoded = encoded.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
    try {
        return $9f65a7b465b05d12$export$94fdf11bafc8de6b(encoded);
    } catch  {
        throw new TypeError("The input to be decoded is not correctly encoded.");
    }
};



class $b527c450e4afd840$export$f754d6850d76bf87 extends Error {
    static get code() {
        return "ERR_JOSE_GENERIC";
    }
    constructor(message){
        super(message);
        this.code = "ERR_JOSE_GENERIC";
        this.name = this.constructor.name;
        Error.captureStackTrace?.(this, this.constructor);
    }
}
class $b527c450e4afd840$export$f1e14efb908196e9 extends $b527c450e4afd840$export$f754d6850d76bf87 {
    static get code() {
        return "ERR_JWT_CLAIM_VALIDATION_FAILED";
    }
    constructor(message, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_CLAIM_VALIDATION_FAILED";
        this.claim = claim;
        this.reason = reason;
    }
}
class $b527c450e4afd840$export$4b386bf852b7863d extends $b527c450e4afd840$export$f754d6850d76bf87 {
    static get code() {
        return "ERR_JWT_EXPIRED";
    }
    constructor(message, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_EXPIRED";
        this.claim = claim;
        this.reason = reason;
    }
}
class $b527c450e4afd840$export$d51fd7fedeccc338 extends $b527c450e4afd840$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_ALG_NOT_ALLOWED";
    }
    static get code() {
        return "ERR_JOSE_ALG_NOT_ALLOWED";
    }
}
class $b527c450e4afd840$export$19ddbcbf2016ab28 extends $b527c450e4afd840$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_NOT_SUPPORTED";
    }
    static get code() {
        return "ERR_JOSE_NOT_SUPPORTED";
    }
}
class $b527c450e4afd840$export$1a57512ad9773b2a extends $b527c450e4afd840$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_DECRYPTION_FAILED";
        this.message = "decryption operation failed";
    }
    static get code() {
        return "ERR_JWE_DECRYPTION_FAILED";
    }
}
class $b527c450e4afd840$export$19f281f2275f6a15 extends $b527c450e4afd840$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_INVALID";
    }
    static get code() {
        return "ERR_JWE_INVALID";
    }
}
class $b527c450e4afd840$export$e838de724af3d116 extends $b527c450e4afd840$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_INVALID";
    }
    static get code() {
        return "ERR_JWS_INVALID";
    }
}
class $b527c450e4afd840$export$936b39ada0bbfceb extends $b527c450e4afd840$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWT_INVALID";
    }
    static get code() {
        return "ERR_JWT_INVALID";
    }
}
class $b527c450e4afd840$export$b3992e0f88fb07e3 extends $b527c450e4afd840$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWK_INVALID";
    }
    static get code() {
        return "ERR_JWK_INVALID";
    }
}
class $b527c450e4afd840$export$9b22c2a1e2403b8e extends $b527c450e4afd840$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_INVALID";
    }
    static get code() {
        return "ERR_JWKS_INVALID";
    }
}
class $b527c450e4afd840$export$3d5ed1a538bed04e extends $b527c450e4afd840$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_NO_MATCHING_KEY";
        this.message = "no applicable key found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_NO_MATCHING_KEY";
    }
}
class $b527c450e4afd840$export$dc036de401a5c284 extends $b527c450e4afd840$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
        this.message = "multiple matching keys found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
    }
}
Symbol.asyncIterator;
class $b527c450e4afd840$export$3f30acebf25c04e6 extends $b527c450e4afd840$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_TIMEOUT";
        this.message = "request timed out";
    }
    static get code() {
        return "ERR_JWKS_TIMEOUT";
    }
}
class $b527c450e4afd840$export$c67a0218e7c50378 extends $b527c450e4afd840$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
        this.message = "signature verification failed";
    }
    static get code() {
        return "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
    }
}




var $6b7a00b30de8ad78$export$2e2bcd8739ae039 = (0, $e60fe3255652942b$export$2e2bcd8739ae039).getRandomValues.bind((0, $e60fe3255652942b$export$2e2bcd8739ae039));


function $817761de62c29fec$export$db433e85ac514a95(alg) {
    switch(alg){
        case "A128GCM":
        case "A128GCMKW":
        case "A192GCM":
        case "A192GCMKW":
        case "A256GCM":
        case "A256GCMKW":
            return 96;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            return 128;
        default:
            throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
var $817761de62c29fec$export$2e2bcd8739ae039 = (alg)=>(0, $6b7a00b30de8ad78$export$2e2bcd8739ae039)(new Uint8Array($817761de62c29fec$export$db433e85ac514a95(alg) >> 3));


const $9f17fc1b6f8d7a54$var$checkIvLength = (enc, iv)=>{
    if (iv.length << 3 !== (0, $817761de62c29fec$export$db433e85ac514a95)(enc)) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("Invalid Initialization Vector length");
};
var $9f17fc1b6f8d7a54$export$2e2bcd8739ae039 = $9f17fc1b6f8d7a54$var$checkIvLength;



const $ea083d2aa4bd7e5b$var$checkCekLength = (cek, expected)=>{
    const actual = cek.byteLength << 3;
    if (actual !== expected) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)(`Invalid Content Encryption Key length. Expected ${expected} bits, got ${actual} bits`);
};
var $ea083d2aa4bd7e5b$export$2e2bcd8739ae039 = $ea083d2aa4bd7e5b$var$checkCekLength;


const $e54e422b9814d3c7$var$timingSafeEqual = (a, b)=>{
    if (!(a instanceof Uint8Array)) throw new TypeError("First argument must be a buffer");
    if (!(b instanceof Uint8Array)) throw new TypeError("Second argument must be a buffer");
    if (a.length !== b.length) throw new TypeError("Input buffers must have the same length");
    const len = a.length;
    let out = 0;
    let i = -1;
    while(++i < len)out |= a[i] ^ b[i];
    return out === 0;
};
var $e54e422b9814d3c7$export$2e2bcd8739ae039 = $e54e422b9814d3c7$var$timingSafeEqual;




function $837aef40404c959e$var$unusable(name, prop = "algorithm.name") {
    return new TypeError(`CryptoKey does not support this operation, its ${prop} must be ${name}`);
}
function $837aef40404c959e$var$isAlgorithm(algorithm, name) {
    return algorithm.name === name;
}
function $837aef40404c959e$var$getHashLength(hash) {
    return parseInt(hash.name.slice(4), 10);
}
function $837aef40404c959e$var$getNamedCurve(alg) {
    switch(alg){
        case "ES256":
            return "P-256";
        case "ES384":
            return "P-384";
        case "ES512":
            return "P-521";
        default:
            throw new Error("unreachable");
    }
}
function $837aef40404c959e$var$checkUsage(key, usages) {
    if (usages.length && !usages.some((expected)=>key.usages.includes(expected))) {
        let msg = "CryptoKey does not support this operation, its usages must include ";
        if (usages.length > 2) {
            const last = usages.pop();
            msg += `one of ${usages.join(", ")}, or ${last}.`;
        } else if (usages.length === 2) msg += `one of ${usages[0]} or ${usages[1]}.`;
        else msg += `${usages[0]}.`;
        throw new TypeError(msg);
    }
}
function $837aef40404c959e$export$39a36029eee6729(key, alg, ...usages) {
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            {
                if (!$837aef40404c959e$var$isAlgorithm(key.algorithm, "HMAC")) throw $837aef40404c959e$var$unusable("HMAC");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $837aef40404c959e$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $837aef40404c959e$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "RS256":
        case "RS384":
        case "RS512":
            {
                if (!$837aef40404c959e$var$isAlgorithm(key.algorithm, "RSASSA-PKCS1-v1_5")) throw $837aef40404c959e$var$unusable("RSASSA-PKCS1-v1_5");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $837aef40404c959e$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $837aef40404c959e$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "PS256":
        case "PS384":
        case "PS512":
            {
                if (!$837aef40404c959e$var$isAlgorithm(key.algorithm, "RSA-PSS")) throw $837aef40404c959e$var$unusable("RSA-PSS");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $837aef40404c959e$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $837aef40404c959e$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "EdDSA":
            if (key.algorithm.name !== "Ed25519" && key.algorithm.name !== "Ed448") throw $837aef40404c959e$var$unusable("Ed25519 or Ed448");
            break;
        case "ES256":
        case "ES384":
        case "ES512":
            {
                if (!$837aef40404c959e$var$isAlgorithm(key.algorithm, "ECDSA")) throw $837aef40404c959e$var$unusable("ECDSA");
                const expected = $837aef40404c959e$var$getNamedCurve(alg);
                const actual = key.algorithm.namedCurve;
                if (actual !== expected) throw $837aef40404c959e$var$unusable(expected, "algorithm.namedCurve");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    $837aef40404c959e$var$checkUsage(key, usages);
}
function $837aef40404c959e$export$41a67f89f6678b35(key, alg, ...usages) {
    switch(alg){
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            {
                if (!$837aef40404c959e$var$isAlgorithm(key.algorithm, "AES-GCM")) throw $837aef40404c959e$var$unusable("AES-GCM");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $837aef40404c959e$var$unusable(expected, "algorithm.length");
                break;
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            {
                if (!$837aef40404c959e$var$isAlgorithm(key.algorithm, "AES-KW")) throw $837aef40404c959e$var$unusable("AES-KW");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $837aef40404c959e$var$unusable(expected, "algorithm.length");
                break;
            }
        case "ECDH":
            switch(key.algorithm.name){
                case "ECDH":
                case "X25519":
                case "X448":
                    break;
                default:
                    throw $837aef40404c959e$var$unusable("ECDH, X25519, or X448");
            }
            break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            if (!$837aef40404c959e$var$isAlgorithm(key.algorithm, "PBKDF2")) throw $837aef40404c959e$var$unusable("PBKDF2");
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            {
                if (!$837aef40404c959e$var$isAlgorithm(key.algorithm, "RSA-OAEP")) throw $837aef40404c959e$var$unusable("RSA-OAEP");
                const expected = parseInt(alg.slice(9), 10) || 1;
                const actual = $837aef40404c959e$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $837aef40404c959e$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    $837aef40404c959e$var$checkUsage(key, usages);
}


function $734ae07da0f9ebc0$var$message(msg, actual, ...types) {
    if (types.length > 2) {
        const last = types.pop();
        msg += `one of type ${types.join(", ")}, or ${last}.`;
    } else if (types.length === 2) msg += `one of type ${types[0]} or ${types[1]}.`;
    else msg += `of type ${types[0]}.`;
    if (actual == null) msg += ` Received ${actual}`;
    else if (typeof actual === "function" && actual.name) msg += ` Received function ${actual.name}`;
    else if (typeof actual === "object" && actual != null) {
        if (actual.constructor?.name) msg += ` Received an instance of ${actual.constructor.name}`;
    }
    return msg;
}
var $734ae07da0f9ebc0$export$2e2bcd8739ae039 = (actual, ...types)=>{
    return $734ae07da0f9ebc0$var$message("Key must be ", actual, ...types);
};
function $734ae07da0f9ebc0$export$e94f758d09bc1828(alg, actual, ...types) {
    return $734ae07da0f9ebc0$var$message(`Key for the ${alg} algorithm must be `, actual, ...types);
}



var $b08803cc00854154$export$2e2bcd8739ae039 = (key)=>{
    return (0, $e60fe3255652942b$export$600b5603bbac4c6)(key);
};
const $b08803cc00854154$export$b14ad400b1d09e0f = [
    "CryptoKey"
];


async function $298e2c6c2b0676fa$var$cbcDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, $734ae07da0f9ebc0$export$2e2bcd8739ae039)(cek, "Uint8Array"));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(keySize >> 3), "AES-CBC", false, [
        "decrypt"
    ]);
    const macKey = await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: "HMAC"
    }, false, [
        "sign"
    ]);
    const macData = (0, $15ceb15c8014d6a6$export$ee1b3e54f0441b22)(aad, iv, ciphertext, (0, $15ceb15c8014d6a6$export$e7b531e00a18fdd7)(aad.length << 3));
    const expectedTag = new Uint8Array((await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.sign("HMAC", macKey, macData)).slice(0, keySize >> 3));
    let macCheckPassed;
    try {
        macCheckPassed = (0, $e54e422b9814d3c7$export$2e2bcd8739ae039)(tag, expectedTag);
    } catch  {}
    if (!macCheckPassed) throw new (0, $b527c450e4afd840$export$1a57512ad9773b2a)();
    let plaintext;
    try {
        plaintext = new Uint8Array(await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.decrypt({
            iv: iv,
            name: "AES-CBC"
        }, encKey, ciphertext));
    } catch  {}
    if (!plaintext) throw new (0, $b527c450e4afd840$export$1a57512ad9773b2a)();
    return plaintext;
}
async function $298e2c6c2b0676fa$var$gcmDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.importKey("raw", cek, "AES-GCM", false, [
        "decrypt"
    ]);
    else {
        (0, $837aef40404c959e$export$41a67f89f6678b35)(cek, enc, "decrypt");
        encKey = cek;
    }
    try {
        return new Uint8Array(await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.decrypt({
            additionalData: aad,
            iv: iv,
            name: "AES-GCM",
            tagLength: 128
        }, encKey, (0, $15ceb15c8014d6a6$export$ee1b3e54f0441b22)(ciphertext, tag)));
    } catch  {
        throw new (0, $b527c450e4afd840$export$1a57512ad9773b2a)();
    }
}
const $298e2c6c2b0676fa$var$decrypt = async (enc, cek, ciphertext, iv, tag, aad)=>{
    if (!(0, $e60fe3255652942b$export$600b5603bbac4c6)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, $734ae07da0f9ebc0$export$2e2bcd8739ae039)(cek, ...(0, $b08803cc00854154$export$b14ad400b1d09e0f), "Uint8Array"));
    if (!iv) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Initialization Vector missing");
    if (!tag) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Authentication Tag missing");
    (0, $9f17fc1b6f8d7a54$export$2e2bcd8739ae039)(enc, iv);
    switch(enc){
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            if (cek instanceof Uint8Array) (0, $ea083d2aa4bd7e5b$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(-3), 10));
            return $298e2c6c2b0676fa$var$cbcDecrypt(enc, cek, ciphertext, iv, tag, aad);
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            if (cek instanceof Uint8Array) (0, $ea083d2aa4bd7e5b$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(1, 4), 10));
            return $298e2c6c2b0676fa$var$gcmDecrypt(enc, cek, ciphertext, iv, tag, aad);
        default:
            throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)("Unsupported JWE Content Encryption Algorithm");
    }
};
var $298e2c6c2b0676fa$export$2e2bcd8739ae039 = $298e2c6c2b0676fa$var$decrypt;



const $33a1c842479100e9$var$isDisjoint = (...headers)=>{
    const sources = headers.filter(Boolean);
    if (sources.length === 0 || sources.length === 1) return true;
    let acc;
    for (const header of sources){
        const parameters = Object.keys(header);
        if (!acc || acc.size === 0) {
            acc = new Set(parameters);
            continue;
        }
        for (const parameter of parameters){
            if (acc.has(parameter)) return false;
            acc.add(parameter);
        }
    }
    return true;
};
var $33a1c842479100e9$export$2e2bcd8739ae039 = $33a1c842479100e9$var$isDisjoint;


function $17b531bbb1af817d$var$isObjectLike(value) {
    return typeof value === "object" && value !== null;
}
function $17b531bbb1af817d$export$2e2bcd8739ae039(input) {
    if (!$17b531bbb1af817d$var$isObjectLike(input) || Object.prototype.toString.call(input) !== "[object Object]") return false;
    if (Object.getPrototypeOf(input) === null) return true;
    let proto = input;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(input) === proto;
}


const $ea637772ac3ab9d3$var$bogusWebCrypto = [
    {
        hash: "SHA-256",
        name: "HMAC"
    },
    true,
    [
        "sign"
    ]
];
var $ea637772ac3ab9d3$export$2e2bcd8739ae039 = $ea637772ac3ab9d3$var$bogusWebCrypto;






function $6c9e9a5dbc3065a8$var$checkKeySize(key, alg) {
    if (key.algorithm.length !== parseInt(alg.slice(1, 4), 10)) throw new TypeError(`Invalid key size for alg: ${alg}`);
}
function $6c9e9a5dbc3065a8$var$getCryptoKey(key, alg, usage) {
    if ((0, $e60fe3255652942b$export$600b5603bbac4c6)(key)) {
        (0, $837aef40404c959e$export$41a67f89f6678b35)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) return (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.importKey("raw", key, "AES-KW", true, [
        usage
    ]);
    throw new TypeError((0, $734ae07da0f9ebc0$export$2e2bcd8739ae039)(key, ...(0, $b08803cc00854154$export$b14ad400b1d09e0f), "Uint8Array"));
}
const $6c9e9a5dbc3065a8$export$4997ffc0176396a6 = async (alg, key, cek)=>{
    const cryptoKey = await $6c9e9a5dbc3065a8$var$getCryptoKey(key, alg, "wrapKey");
    $6c9e9a5dbc3065a8$var$checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.importKey("raw", cek, ...(0, $ea637772ac3ab9d3$export$2e2bcd8739ae039));
    return new Uint8Array(await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.wrapKey("raw", cryptoKeyCek, cryptoKey, "AES-KW"));
};
const $6c9e9a5dbc3065a8$export$debb760848ca95a = async (alg, key, encryptedKey)=>{
    const cryptoKey = await $6c9e9a5dbc3065a8$var$getCryptoKey(key, alg, "unwrapKey");
    $6c9e9a5dbc3065a8$var$checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.unwrapKey("raw", encryptedKey, cryptoKey, "AES-KW", ...(0, $ea637772ac3ab9d3$export$2e2bcd8739ae039));
    return new Uint8Array(await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.exportKey("raw", cryptoKeyCek));
};







async function $aca9c64c07567e83$export$87770b6b245073b5(publicKey, privateKey, algorithm, keyLength, apu = new Uint8Array(0), apv = new Uint8Array(0)) {
    if (!(0, $e60fe3255652942b$export$600b5603bbac4c6)(publicKey)) throw new TypeError((0, $734ae07da0f9ebc0$export$2e2bcd8739ae039)(publicKey, ...(0, $b08803cc00854154$export$b14ad400b1d09e0f)));
    (0, $837aef40404c959e$export$41a67f89f6678b35)(publicKey, "ECDH");
    if (!(0, $e60fe3255652942b$export$600b5603bbac4c6)(privateKey)) throw new TypeError((0, $734ae07da0f9ebc0$export$2e2bcd8739ae039)(privateKey, ...(0, $b08803cc00854154$export$b14ad400b1d09e0f)));
    (0, $837aef40404c959e$export$41a67f89f6678b35)(privateKey, "ECDH", "deriveBits");
    const value = (0, $15ceb15c8014d6a6$export$ee1b3e54f0441b22)((0, $15ceb15c8014d6a6$export$c1498c4a3718d967)((0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode(algorithm)), (0, $15ceb15c8014d6a6$export$c1498c4a3718d967)(apu), (0, $15ceb15c8014d6a6$export$c1498c4a3718d967)(apv), (0, $15ceb15c8014d6a6$export$74c16dba6c885532)(keyLength));
    let length;
    if (publicKey.algorithm.name === "X25519") length = 256;
    else if (publicKey.algorithm.name === "X448") length = 448;
    else length = Math.ceil(parseInt(publicKey.algorithm.namedCurve.substr(-3), 10) / 8) << 3;
    const sharedSecret = new Uint8Array(await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.deriveBits({
        name: publicKey.algorithm.name,
        public: publicKey
    }, privateKey, length));
    return (0, $15ceb15c8014d6a6$export$67163693c21af44f)(sharedSecret, keyLength, value);
}
async function $aca9c64c07567e83$export$1338dee8c889e310(key) {
    if (!(0, $e60fe3255652942b$export$600b5603bbac4c6)(key)) throw new TypeError((0, $734ae07da0f9ebc0$export$2e2bcd8739ae039)(key, ...(0, $b08803cc00854154$export$b14ad400b1d09e0f)));
    return (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.generateKey(key.algorithm, true, [
        "deriveBits"
    ]);
}
function $aca9c64c07567e83$export$f28ab77d793719b2(key) {
    if (!(0, $e60fe3255652942b$export$600b5603bbac4c6)(key)) throw new TypeError((0, $734ae07da0f9ebc0$export$2e2bcd8739ae039)(key, ...(0, $b08803cc00854154$export$b14ad400b1d09e0f)));
    return [
        "P-256",
        "P-384",
        "P-521"
    ].includes(key.algorithm.namedCurve) || key.algorithm.name === "X25519" || key.algorithm.name === "X448";
}







function $e80e9fe4969c663b$export$2e2bcd8739ae039(p2s) {
    if (!(p2s instanceof Uint8Array) || p2s.length < 8) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("PBES2 Salt Input must be 8 or more octets");
}






function $ecbc4b45c508be2d$var$getCryptoKey(key, alg) {
    if (key instanceof Uint8Array) return (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.importKey("raw", key, "PBKDF2", false, [
        "deriveBits"
    ]);
    if ((0, $e60fe3255652942b$export$600b5603bbac4c6)(key)) {
        (0, $837aef40404c959e$export$41a67f89f6678b35)(key, alg, "deriveBits", "deriveKey");
        return key;
    }
    throw new TypeError((0, $734ae07da0f9ebc0$export$2e2bcd8739ae039)(key, ...(0, $b08803cc00854154$export$b14ad400b1d09e0f), "Uint8Array"));
}
async function $ecbc4b45c508be2d$var$deriveKey(p2s, alg, p2c, key) {
    (0, $e80e9fe4969c663b$export$2e2bcd8739ae039)(p2s);
    const salt = (0, $15ceb15c8014d6a6$export$256d3ca12372f112)(alg, p2s);
    const keylen = parseInt(alg.slice(13, 16), 10);
    const subtleAlg = {
        hash: `SHA-${alg.slice(8, 11)}`,
        iterations: p2c,
        name: "PBKDF2",
        salt: salt
    };
    const wrapAlg = {
        length: keylen,
        name: "AES-KW"
    };
    const cryptoKey = await $ecbc4b45c508be2d$var$getCryptoKey(key, alg);
    if (cryptoKey.usages.includes("deriveBits")) return new Uint8Array(await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.deriveBits(subtleAlg, cryptoKey, keylen));
    if (cryptoKey.usages.includes("deriveKey")) return (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.deriveKey(subtleAlg, cryptoKey, wrapAlg, false, [
        "wrapKey",
        "unwrapKey"
    ]);
    throw new TypeError('PBKDF2 key "usages" must include "deriveBits" or "deriveKey"');
}
const $ecbc4b45c508be2d$export$5b0f6292f11d1d18 = async (alg, key, cek, p2c = 2048, p2s = (0, $6b7a00b30de8ad78$export$2e2bcd8739ae039)(new Uint8Array(16)))=>{
    const derived = await $ecbc4b45c508be2d$var$deriveKey(p2s, alg, p2c, key);
    const encryptedKey = await (0, $6c9e9a5dbc3065a8$export$4997ffc0176396a6)(alg.slice(-6), derived, cek);
    return {
        encryptedKey: encryptedKey,
        p2c: p2c,
        p2s: (0, $9f65a7b465b05d12$export$c564cdbbe6da493)(p2s)
    };
};
const $ecbc4b45c508be2d$export$e85a0c9a1067c5d3 = async (alg, key, encryptedKey, p2c, p2s)=>{
    const derived = await $ecbc4b45c508be2d$var$deriveKey(p2s, alg, p2c, key);
    return (0, $6c9e9a5dbc3065a8$export$debb760848ca95a)(alg.slice(-6), derived, encryptedKey);
};



function $929d362271508dd9$export$2e2bcd8739ae039(alg) {
    switch(alg){
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            return "RSA-OAEP";
        default:
            throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}





var $1937b5dc3f5c2933$export$2e2bcd8739ae039 = (alg, key)=>{
    if (alg.startsWith("RS") || alg.startsWith("PS")) {
        const { modulusLength: modulusLength } = key.algorithm;
        if (typeof modulusLength !== "number" || modulusLength < 2048) throw new TypeError(`${alg} requires key modulusLength to be 2048 bits or larger`);
    }
};




const $9062bff1c2e82699$export$5b0f6292f11d1d18 = async (alg, key, cek)=>{
    if (!(0, $e60fe3255652942b$export$600b5603bbac4c6)(key)) throw new TypeError((0, $734ae07da0f9ebc0$export$2e2bcd8739ae039)(key, ...(0, $b08803cc00854154$export$b14ad400b1d09e0f)));
    (0, $837aef40404c959e$export$41a67f89f6678b35)(key, alg, "encrypt", "wrapKey");
    (0, $1937b5dc3f5c2933$export$2e2bcd8739ae039)(alg, key);
    if (key.usages.includes("encrypt")) return new Uint8Array(await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.encrypt((0, $929d362271508dd9$export$2e2bcd8739ae039)(alg), key, cek));
    if (key.usages.includes("wrapKey")) {
        const cryptoKeyCek = await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.importKey("raw", cek, ...(0, $ea637772ac3ab9d3$export$2e2bcd8739ae039));
        return new Uint8Array(await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.wrapKey("raw", cryptoKeyCek, key, (0, $929d362271508dd9$export$2e2bcd8739ae039)(alg)));
    }
    throw new TypeError('RSA-OAEP key "usages" must include "encrypt" or "wrapKey" for this operation');
};
const $9062bff1c2e82699$export$e85a0c9a1067c5d3 = async (alg, key, encryptedKey)=>{
    if (!(0, $e60fe3255652942b$export$600b5603bbac4c6)(key)) throw new TypeError((0, $734ae07da0f9ebc0$export$2e2bcd8739ae039)(key, ...(0, $b08803cc00854154$export$b14ad400b1d09e0f)));
    (0, $837aef40404c959e$export$41a67f89f6678b35)(key, alg, "decrypt", "unwrapKey");
    (0, $1937b5dc3f5c2933$export$2e2bcd8739ae039)(alg, key);
    if (key.usages.includes("decrypt")) return new Uint8Array(await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.decrypt((0, $929d362271508dd9$export$2e2bcd8739ae039)(alg), key, encryptedKey));
    if (key.usages.includes("unwrapKey")) {
        const cryptoKeyCek = await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.unwrapKey("raw", encryptedKey, key, (0, $929d362271508dd9$export$2e2bcd8739ae039)(alg), ...(0, $ea637772ac3ab9d3$export$2e2bcd8739ae039));
        return new Uint8Array(await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.exportKey("raw", cryptoKeyCek));
    }
    throw new TypeError('RSA-OAEP key "usages" must include "decrypt" or "unwrapKey" for this operation');
};






function $f7c1f76992b06893$export$db433e85ac514a95(alg) {
    switch(alg){
        case "A128GCM":
            return 128;
        case "A192GCM":
            return 192;
        case "A256GCM":
        case "A128CBC-HS256":
            return 256;
        case "A192CBC-HS384":
            return 384;
        case "A256CBC-HS512":
            return 512;
        default:
            throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
var $f7c1f76992b06893$export$2e2bcd8739ae039 = (alg)=>(0, $6b7a00b30de8ad78$export$2e2bcd8739ae039)(new Uint8Array($f7c1f76992b06893$export$db433e85ac514a95(alg) >> 3));






var $fd22622ecf88d357$export$2e2bcd8739ae039 = (b64, descriptor)=>{
    const newlined = (b64.match(/.{1,64}/g) || []).join("\n");
    return `-----BEGIN ${descriptor}-----\n${newlined}\n-----END ${descriptor}-----`;
};




const $82d11d74ed6867d1$var$genericExport = async (keyType, keyFormat, key)=>{
    if (!(0, $e60fe3255652942b$export$600b5603bbac4c6)(key)) throw new TypeError((0, $734ae07da0f9ebc0$export$2e2bcd8739ae039)(key, ...(0, $b08803cc00854154$export$b14ad400b1d09e0f)));
    if (!key.extractable) throw new TypeError("CryptoKey is not extractable");
    if (key.type !== keyType) throw new TypeError(`key is not a ${keyType} key`);
    return (0, $fd22622ecf88d357$export$2e2bcd8739ae039)((0, $9f65a7b465b05d12$export$8fb536984ec8b4d7)(new Uint8Array(await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.exportKey(keyFormat, key))), `${keyType.toUpperCase()} KEY`);
};
const $82d11d74ed6867d1$export$cfba7e924fe414ca = (key)=>{
    return $82d11d74ed6867d1$var$genericExport("public", "spki", key);
};
const $82d11d74ed6867d1$export$cac76a78a90b914d = (key)=>{
    return $82d11d74ed6867d1$var$genericExport("private", "pkcs8", key);
};
const $82d11d74ed6867d1$var$findOid = (keyData, oid, from = 0)=>{
    if (from === 0) {
        oid.unshift(oid.length);
        oid.unshift(0x06);
    }
    const i = keyData.indexOf(oid[0], from);
    if (i === -1) return false;
    const sub = keyData.subarray(i, i + oid.length);
    if (sub.length !== oid.length) return false;
    return sub.every((value, index)=>value === oid[index]) || $82d11d74ed6867d1$var$findOid(keyData, oid, i + 1);
};
const $82d11d74ed6867d1$var$getNamedCurve = (keyData)=>{
    switch(true){
        case $82d11d74ed6867d1$var$findOid(keyData, [
            0x2a,
            0x86,
            0x48,
            0xce,
            0x3d,
            0x03,
            0x01,
            0x07
        ]):
            return "P-256";
        case $82d11d74ed6867d1$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x22
        ]):
            return "P-384";
        case $82d11d74ed6867d1$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x23
        ]):
            return "P-521";
        case $82d11d74ed6867d1$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6e
        ]):
            return "X25519";
        case $82d11d74ed6867d1$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6f
        ]):
            return "X448";
        case $82d11d74ed6867d1$var$findOid(keyData, [
            0x2b,
            0x65,
            0x70
        ]):
            return "Ed25519";
        case $82d11d74ed6867d1$var$findOid(keyData, [
            0x2b,
            0x65,
            0x71
        ]):
            return "Ed448";
        default:
            throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)("Invalid or unsupported EC Key Curve or OKP Key Sub Type");
    }
};
const $82d11d74ed6867d1$var$genericImport = async (replace, keyFormat, pem, alg, options)=>{
    let algorithm;
    let keyUsages;
    const keyData = new Uint8Array(atob(pem.replace(replace, "")).split("").map((c)=>c.charCodeAt(0)));
    const isPublic = keyFormat === "spki";
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`
            };
            keyUsages = isPublic ? [
                "encrypt",
                "wrapKey"
            ] : [
                "decrypt",
                "unwrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                const namedCurve = $82d11d74ed6867d1$var$getNamedCurve(keyData);
                algorithm = namedCurve.startsWith("P-") ? {
                    name: "ECDH",
                    namedCurve: namedCurve
                } : {
                    name: namedCurve
                };
                keyUsages = isPublic ? [] : [
                    "deriveBits"
                ];
                break;
            }
        case "EdDSA":
            algorithm = {
                name: $82d11d74ed6867d1$var$getNamedCurve(keyData)
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        default:
            throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)('Invalid or unsupported "alg" (Algorithm) value');
    }
    return (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.importKey(keyFormat, keyData, algorithm, options?.extractable ?? false, keyUsages);
};
const $82d11d74ed6867d1$export$224b0a6339c7267f = (pem, alg, options)=>{
    return $82d11d74ed6867d1$var$genericImport(/(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g, "pkcs8", pem, alg, options);
};
const $82d11d74ed6867d1$export$f9a3505cdaa1fb3e = (pem, alg, options)=>{
    return $82d11d74ed6867d1$var$genericImport(/(?:-----(?:BEGIN|END) PUBLIC KEY-----|\s)/g, "spki", pem, alg, options);
};
function $82d11d74ed6867d1$var$getElement(seq) {
    const result = [];
    let next = 0;
    while(next < seq.length){
        const nextPart = $82d11d74ed6867d1$var$parseElement(seq.subarray(next));
        result.push(nextPart);
        next += nextPart.byteLength;
    }
    return result;
}
function $82d11d74ed6867d1$var$parseElement(bytes) {
    let position = 0;
    let tag = bytes[0] & 0x1f;
    position++;
    if (tag === 0x1f) {
        tag = 0;
        while(bytes[position] >= 0x80){
            tag = tag * 128 + bytes[position] - 0x80;
            position++;
        }
        tag = tag * 128 + bytes[position] - 0x80;
        position++;
    }
    let length = 0;
    if (bytes[position] < 0x80) {
        length = bytes[position];
        position++;
    } else if (length === 0x80) {
        length = 0;
        while(bytes[position + length] !== 0 || bytes[position + length + 1] !== 0){
            if (length > bytes.byteLength) throw new TypeError("invalid indefinite form length");
            length++;
        }
        const byteLength = position + length + 2;
        return {
            byteLength: byteLength,
            contents: bytes.subarray(position, position + length),
            raw: bytes.subarray(0, byteLength)
        };
    } else {
        const numberOfDigits = bytes[position] & 0x7f;
        position++;
        length = 0;
        for(let i = 0; i < numberOfDigits; i++){
            length = length * 256 + bytes[position];
            position++;
        }
    }
    const byteLength = position + length;
    return {
        byteLength: byteLength,
        contents: bytes.subarray(position, byteLength),
        raw: bytes.subarray(0, byteLength)
    };
}
function $82d11d74ed6867d1$var$spkiFromX509(buf) {
    const tbsCertificate = $82d11d74ed6867d1$var$getElement($82d11d74ed6867d1$var$getElement($82d11d74ed6867d1$var$parseElement(buf).contents)[0].contents);
    return (0, $9f65a7b465b05d12$export$8fb536984ec8b4d7)(tbsCertificate[tbsCertificate[0].raw[0] === 0xa0 ? 6 : 5].raw);
}
function $82d11d74ed6867d1$var$getSPKI(x509) {
    const pem = x509.replace(/(?:-----(?:BEGIN|END) CERTIFICATE-----|\s)/g, "");
    const raw = (0, $9f65a7b465b05d12$export$94fdf11bafc8de6b)(pem);
    return (0, $fd22622ecf88d357$export$2e2bcd8739ae039)($82d11d74ed6867d1$var$spkiFromX509(raw), "PUBLIC KEY");
}
const $82d11d74ed6867d1$export$ed788b6a8533858f = (pem, alg, options)=>{
    let spki;
    try {
        spki = $82d11d74ed6867d1$var$getSPKI(pem);
    } catch (cause) {
        throw new TypeError("Failed to parse the X.509 certificate", {
            cause: cause
        });
    }
    return $82d11d74ed6867d1$export$f9a3505cdaa1fb3e(spki, alg, options);
};




function $4e4318f816aa92cf$var$subtleMapping(jwk) {
    let algorithm;
    let keyUsages;
    switch(jwk.kty){
        case "RSA":
            switch(jwk.alg){
                case "PS256":
                case "PS384":
                case "PS512":
                    algorithm = {
                        name: "RSA-PSS",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RS256":
                case "RS384":
                case "RS512":
                    algorithm = {
                        name: "RSASSA-PKCS1-v1_5",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RSA-OAEP":
                case "RSA-OAEP-256":
                case "RSA-OAEP-384":
                case "RSA-OAEP-512":
                    algorithm = {
                        name: "RSA-OAEP",
                        hash: `SHA-${parseInt(jwk.alg.slice(-3), 10) || 1}`
                    };
                    keyUsages = jwk.d ? [
                        "decrypt",
                        "unwrapKey"
                    ] : [
                        "encrypt",
                        "wrapKey"
                    ];
                    break;
                default:
                    throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "EC":
            switch(jwk.alg){
                case "ES256":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-256"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES384":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-384"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES512":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-521"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: "ECDH",
                        namedCurve: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "OKP":
            switch(jwk.alg){
                case "EdDSA":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        default:
            throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
    }
    return {
        algorithm: algorithm,
        keyUsages: keyUsages
    };
}
const $4e4318f816aa92cf$var$parse = async (jwk)=>{
    if (!jwk.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
    const { algorithm: algorithm, keyUsages: keyUsages } = $4e4318f816aa92cf$var$subtleMapping(jwk);
    const rest = [
        algorithm,
        jwk.ext ?? false,
        jwk.key_ops ?? keyUsages
    ];
    const keyData = {
        ...jwk
    };
    delete keyData.alg;
    delete keyData.use;
    return (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.importKey("jwk", keyData, ...rest);
};
var $4e4318f816aa92cf$export$2e2bcd8739ae039 = $4e4318f816aa92cf$var$parse;




async function $e63362ecdabc85c1$export$7cdfc961c11d0266(spki, alg, options) {
    if (typeof spki !== "string" || spki.indexOf("-----BEGIN PUBLIC KEY-----") !== 0) throw new TypeError('"spki" must be SPKI formatted string');
    return (0, $82d11d74ed6867d1$export$f9a3505cdaa1fb3e)(spki, alg, options);
}
async function $e63362ecdabc85c1$export$948757ecbbf4a918(x509, alg, options) {
    if (typeof x509 !== "string" || x509.indexOf("-----BEGIN CERTIFICATE-----") !== 0) throw new TypeError('"x509" must be X.509 formatted string');
    return (0, $82d11d74ed6867d1$export$ed788b6a8533858f)(x509, alg, options);
}
async function $e63362ecdabc85c1$export$17f5e7f6d2848df5(pkcs8, alg, options) {
    if (typeof pkcs8 !== "string" || pkcs8.indexOf("-----BEGIN PRIVATE KEY-----") !== 0) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
    return (0, $82d11d74ed6867d1$export$224b0a6339c7267f)(pkcs8, alg, options);
}
async function $e63362ecdabc85c1$export$2b70d37b4d0b888b(jwk, alg) {
    if (!(0, $17b531bbb1af817d$export$2e2bcd8739ae039)(jwk)) throw new TypeError("JWK must be an object");
    alg || (alg = jwk.alg);
    switch(jwk.kty){
        case "oct":
            if (typeof jwk.k !== "string" || !jwk.k) throw new TypeError('missing "k" (Key Value) Parameter value');
            return (0, $9f65a7b465b05d12$export$2f872c0f2117be69)(jwk.k);
        case "RSA":
            if (jwk.oth !== undefined) throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
        case "EC":
        case "OKP":
            return (0, $4e4318f816aa92cf$export$2e2bcd8739ae039)({
                ...jwk,
                alg: alg
            });
        default:
            throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)('Unsupported "kty" (Key Type) Parameter value');
    }
}




const $13e7b60c68902f8e$var$symmetricTypeCheck = (alg, key)=>{
    if (key instanceof Uint8Array) return;
    if (!(0, $b08803cc00854154$export$2e2bcd8739ae039)(key)) throw new TypeError((0, $734ae07da0f9ebc0$export$e94f758d09bc1828)(alg, key, ...(0, $b08803cc00854154$export$b14ad400b1d09e0f), "Uint8Array"));
    if (key.type !== "secret") throw new TypeError(`${(0, $b08803cc00854154$export$b14ad400b1d09e0f).join(" or ")} instances for symmetric algorithms must be of type "secret"`);
};
const $13e7b60c68902f8e$var$asymmetricTypeCheck = (alg, key, usage)=>{
    if (!(0, $b08803cc00854154$export$2e2bcd8739ae039)(key)) throw new TypeError((0, $734ae07da0f9ebc0$export$e94f758d09bc1828)(alg, key, ...(0, $b08803cc00854154$export$b14ad400b1d09e0f)));
    if (key.type === "secret") throw new TypeError(`${(0, $b08803cc00854154$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithms must not be of type "secret"`);
    if (usage === "sign" && key.type === "public") throw new TypeError(`${(0, $b08803cc00854154$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm signing must be of type "private"`);
    if (usage === "decrypt" && key.type === "public") throw new TypeError(`${(0, $b08803cc00854154$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm decryption must be of type "private"`);
    if (key.algorithm && usage === "verify" && key.type === "private") throw new TypeError(`${(0, $b08803cc00854154$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm verifying must be of type "public"`);
    if (key.algorithm && usage === "encrypt" && key.type === "private") throw new TypeError(`${(0, $b08803cc00854154$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm encryption must be of type "public"`);
};
const $13e7b60c68902f8e$var$checkKeyType = (alg, key, usage)=>{
    const symmetric = alg.startsWith("HS") || alg === "dir" || alg.startsWith("PBES2") || /^A\d{3}(?:GCM)?KW$/.test(alg);
    if (symmetric) $13e7b60c68902f8e$var$symmetricTypeCheck(alg, key);
    else $13e7b60c68902f8e$var$asymmetricTypeCheck(alg, key, usage);
};
var $13e7b60c68902f8e$export$2e2bcd8739ae039 = $13e7b60c68902f8e$var$checkKeyType;












async function $140427608378c175$var$cbcEncrypt(enc, plaintext, cek, iv, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, $734ae07da0f9ebc0$export$2e2bcd8739ae039)(cek, "Uint8Array"));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(keySize >> 3), "AES-CBC", false, [
        "encrypt"
    ]);
    const macKey = await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: "HMAC"
    }, false, [
        "sign"
    ]);
    const ciphertext = new Uint8Array(await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.encrypt({
        iv: iv,
        name: "AES-CBC"
    }, encKey, plaintext));
    const macData = (0, $15ceb15c8014d6a6$export$ee1b3e54f0441b22)(aad, iv, ciphertext, (0, $15ceb15c8014d6a6$export$e7b531e00a18fdd7)(aad.length << 3));
    const tag = new Uint8Array((await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.sign("HMAC", macKey, macData)).slice(0, keySize >> 3));
    return {
        ciphertext: ciphertext,
        tag: tag,
        iv: iv
    };
}
async function $140427608378c175$var$gcmEncrypt(enc, plaintext, cek, iv, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.importKey("raw", cek, "AES-GCM", false, [
        "encrypt"
    ]);
    else {
        (0, $837aef40404c959e$export$41a67f89f6678b35)(cek, enc, "encrypt");
        encKey = cek;
    }
    const encrypted = new Uint8Array(await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.encrypt({
        additionalData: aad,
        iv: iv,
        name: "AES-GCM",
        tagLength: 128
    }, encKey, plaintext));
    const tag = encrypted.slice(-16);
    const ciphertext = encrypted.slice(0, -16);
    return {
        ciphertext: ciphertext,
        tag: tag,
        iv: iv
    };
}
const $140427608378c175$var$encrypt = async (enc, plaintext, cek, iv, aad)=>{
    if (!(0, $e60fe3255652942b$export$600b5603bbac4c6)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, $734ae07da0f9ebc0$export$2e2bcd8739ae039)(cek, ...(0, $b08803cc00854154$export$b14ad400b1d09e0f), "Uint8Array"));
    if (iv) (0, $9f17fc1b6f8d7a54$export$2e2bcd8739ae039)(enc, iv);
    else iv = (0, $817761de62c29fec$export$2e2bcd8739ae039)(enc);
    switch(enc){
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            if (cek instanceof Uint8Array) (0, $ea083d2aa4bd7e5b$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(-3), 10));
            return $140427608378c175$var$cbcEncrypt(enc, plaintext, cek, iv, aad);
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            if (cek instanceof Uint8Array) (0, $ea083d2aa4bd7e5b$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(1, 4), 10));
            return $140427608378c175$var$gcmEncrypt(enc, plaintext, cek, iv, aad);
        default:
            throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)("Unsupported JWE Content Encryption Algorithm");
    }
};
var $140427608378c175$export$2e2bcd8739ae039 = $140427608378c175$var$encrypt;




async function $53e24359765f55b2$export$4997ffc0176396a6(alg, key, cek, iv) {
    const jweAlgorithm = alg.slice(0, 7);
    const wrapped = await (0, $140427608378c175$export$2e2bcd8739ae039)(jweAlgorithm, cek, key, iv, new Uint8Array(0));
    return {
        encryptedKey: wrapped.ciphertext,
        iv: (0, $9f65a7b465b05d12$export$c564cdbbe6da493)(wrapped.iv),
        tag: (0, $9f65a7b465b05d12$export$c564cdbbe6da493)(wrapped.tag)
    };
}
async function $53e24359765f55b2$export$debb760848ca95a(alg, key, encryptedKey, iv, tag) {
    const jweAlgorithm = alg.slice(0, 7);
    return (0, $298e2c6c2b0676fa$export$2e2bcd8739ae039)(jweAlgorithm, key, encryptedKey, iv, tag, new Uint8Array(0));
}


async function $cb72a03f614cfa7e$var$decryptKeyManagement(alg, key, encryptedKey, joseHeader, options) {
    (0, $13e7b60c68902f8e$export$2e2bcd8739ae039)(alg, key, "decrypt");
    switch(alg){
        case "dir":
            if (encryptedKey !== undefined) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("Encountered unexpected JWE Encrypted Key");
            return key;
        case "ECDH-ES":
            if (encryptedKey !== undefined) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("Encountered unexpected JWE Encrypted Key");
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                if (!(0, $17b531bbb1af817d$export$2e2bcd8739ae039)(joseHeader.epk)) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)(`JOSE Header "epk" (Ephemeral Public Key) missing or invalid`);
                if (!$aca9c64c07567e83$export$f28ab77d793719b2(key)) throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)("ECDH with the provided key is not allowed or not supported by your javascript runtime");
                const epk = await (0, $e63362ecdabc85c1$export$2b70d37b4d0b888b)(joseHeader.epk, alg);
                let partyUInfo;
                let partyVInfo;
                if (joseHeader.apu !== undefined) {
                    if (typeof joseHeader.apu !== "string") throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)(`JOSE Header "apu" (Agreement PartyUInfo) invalid`);
                    try {
                        partyUInfo = (0, $9f65a7b465b05d12$export$2f872c0f2117be69)(joseHeader.apu);
                    } catch  {
                        throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("Failed to base64url decode the apu");
                    }
                }
                if (joseHeader.apv !== undefined) {
                    if (typeof joseHeader.apv !== "string") throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)(`JOSE Header "apv" (Agreement PartyVInfo) invalid`);
                    try {
                        partyVInfo = (0, $9f65a7b465b05d12$export$2f872c0f2117be69)(joseHeader.apv);
                    } catch  {
                        throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("Failed to base64url decode the apv");
                    }
                }
                const sharedSecret = await $aca9c64c07567e83$export$87770b6b245073b5(epk, key, alg === "ECDH-ES" ? joseHeader.enc : alg, alg === "ECDH-ES" ? (0, $f7c1f76992b06893$export$db433e85ac514a95)(joseHeader.enc) : parseInt(alg.slice(-5, -2), 10), partyUInfo, partyVInfo);
                if (alg === "ECDH-ES") return sharedSecret;
                if (encryptedKey === undefined) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Encrypted Key missing");
                return (0, $6c9e9a5dbc3065a8$export$debb760848ca95a)(alg.slice(-6), sharedSecret, encryptedKey);
            }
        case "RSA1_5":
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            if (encryptedKey === undefined) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Encrypted Key missing");
            return (0, $9062bff1c2e82699$export$e85a0c9a1067c5d3)(alg, key, encryptedKey);
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            {
                if (encryptedKey === undefined) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Encrypted Key missing");
                if (typeof joseHeader.p2c !== "number") throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)(`JOSE Header "p2c" (PBES2 Count) missing or invalid`);
                const p2cLimit = options?.maxPBES2Count || 10000;
                if (joseHeader.p2c > p2cLimit) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)(`JOSE Header "p2c" (PBES2 Count) out is of acceptable bounds`);
                if (typeof joseHeader.p2s !== "string") throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)(`JOSE Header "p2s" (PBES2 Salt) missing or invalid`);
                let p2s;
                try {
                    p2s = (0, $9f65a7b465b05d12$export$2f872c0f2117be69)(joseHeader.p2s);
                } catch  {
                    throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("Failed to base64url decode the p2s");
                }
                return (0, $ecbc4b45c508be2d$export$e85a0c9a1067c5d3)(alg, key, encryptedKey, joseHeader.p2c, p2s);
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            if (encryptedKey === undefined) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Encrypted Key missing");
            return (0, $6c9e9a5dbc3065a8$export$debb760848ca95a)(alg, key, encryptedKey);
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
            {
                if (encryptedKey === undefined) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Encrypted Key missing");
                if (typeof joseHeader.iv !== "string") throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)(`JOSE Header "iv" (Initialization Vector) missing or invalid`);
                if (typeof joseHeader.tag !== "string") throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)(`JOSE Header "tag" (Authentication Tag) missing or invalid`);
                let iv;
                try {
                    iv = (0, $9f65a7b465b05d12$export$2f872c0f2117be69)(joseHeader.iv);
                } catch  {
                    throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("Failed to base64url decode the iv");
                }
                let tag;
                try {
                    tag = (0, $9f65a7b465b05d12$export$2f872c0f2117be69)(joseHeader.tag);
                } catch  {
                    throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("Failed to base64url decode the tag");
                }
                return (0, $53e24359765f55b2$export$debb760848ca95a)(alg, key, encryptedKey, iv, tag);
            }
        default:
            throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)('Invalid or unsupported "alg" (JWE Algorithm) header value');
    }
}
var $cb72a03f614cfa7e$export$2e2bcd8739ae039 = $cb72a03f614cfa7e$var$decryptKeyManagement;





function $ec5ba5202f403f8f$var$validateCrit(Err, recognizedDefault, recognizedOption, protectedHeader, joseHeader) {
    if (joseHeader.crit !== undefined && protectedHeader?.crit === undefined) throw new Err('"crit" (Critical) Header Parameter MUST be integrity protected');
    if (!protectedHeader || protectedHeader.crit === undefined) return new Set();
    if (!Array.isArray(protectedHeader.crit) || protectedHeader.crit.length === 0 || protectedHeader.crit.some((input)=>typeof input !== "string" || input.length === 0)) throw new Err('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
    let recognized;
    if (recognizedOption !== undefined) recognized = new Map([
        ...Object.entries(recognizedOption),
        ...recognizedDefault.entries()
    ]);
    else recognized = recognizedDefault;
    for (const parameter of protectedHeader.crit){
        if (!recognized.has(parameter)) throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)(`Extension Header Parameter "${parameter}" is not recognized`);
        if (joseHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" is missing`);
        if (recognized.get(parameter) && protectedHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" MUST be integrity protected`);
    }
    return new Set(protectedHeader.crit);
}
var $ec5ba5202f403f8f$export$2e2bcd8739ae039 = $ec5ba5202f403f8f$var$validateCrit;


const $1655c7f4cd0c63fd$var$validateAlgorithms = (option, algorithms)=>{
    if (algorithms !== undefined && (!Array.isArray(algorithms) || algorithms.some((s)=>typeof s !== "string"))) throw new TypeError(`"${option}" option must be an array of strings`);
    if (!algorithms) return undefined;
    return new Set(algorithms);
};
var $1655c7f4cd0c63fd$export$2e2bcd8739ae039 = $1655c7f4cd0c63fd$var$validateAlgorithms;


async function $77eb0ea47c773e39$export$b75cd12892ae94d2(jwe, key, options) {
    if (!(0, $17b531bbb1af817d$export$2e2bcd8739ae039)(jwe)) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("Flattened JWE must be an object");
    if (jwe.protected === undefined && jwe.header === undefined && jwe.unprotected === undefined) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JOSE Header missing");
    if (jwe.iv !== undefined && typeof jwe.iv !== "string") throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Initialization Vector incorrect type");
    if (typeof jwe.ciphertext !== "string") throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Ciphertext missing or incorrect type");
    if (jwe.tag !== undefined && typeof jwe.tag !== "string") throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Authentication Tag incorrect type");
    if (jwe.protected !== undefined && typeof jwe.protected !== "string") throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Protected Header incorrect type");
    if (jwe.encrypted_key !== undefined && typeof jwe.encrypted_key !== "string") throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Encrypted Key incorrect type");
    if (jwe.aad !== undefined && typeof jwe.aad !== "string") throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE AAD incorrect type");
    if (jwe.header !== undefined && !(0, $17b531bbb1af817d$export$2e2bcd8739ae039)(jwe.header)) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Shared Unprotected Header incorrect type");
    if (jwe.unprotected !== undefined && !(0, $17b531bbb1af817d$export$2e2bcd8739ae039)(jwe.unprotected)) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Per-Recipient Unprotected Header incorrect type");
    let parsedProt;
    if (jwe.protected) try {
        const protectedHeader = (0, $9f65a7b465b05d12$export$2f872c0f2117be69)(jwe.protected);
        parsedProt = JSON.parse((0, $15ceb15c8014d6a6$export$124c96e6ce37090b).decode(protectedHeader));
    } catch  {
        throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Protected Header is invalid");
    }
    if (!(0, $33a1c842479100e9$export$2e2bcd8739ae039)(parsedProt, jwe.header, jwe.unprotected)) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Protected, JWE Unprotected Header, and JWE Per-Recipient Unprotected Header Parameter names must be disjoint");
    const joseHeader = {
        ...parsedProt,
        ...jwe.header,
        ...jwe.unprotected
    };
    (0, $ec5ba5202f403f8f$export$2e2bcd8739ae039)((0, $b527c450e4afd840$export$19f281f2275f6a15), new Map(), options?.crit, parsedProt, joseHeader);
    if (joseHeader.zip !== undefined) throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
    const { alg: alg, enc: enc } = joseHeader;
    if (typeof alg !== "string" || !alg) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("missing JWE Algorithm (alg) in JWE Header");
    if (typeof enc !== "string" || !enc) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("missing JWE Encryption Algorithm (enc) in JWE Header");
    const keyManagementAlgorithms = options && (0, $1655c7f4cd0c63fd$export$2e2bcd8739ae039)("keyManagementAlgorithms", options.keyManagementAlgorithms);
    const contentEncryptionAlgorithms = options && (0, $1655c7f4cd0c63fd$export$2e2bcd8739ae039)("contentEncryptionAlgorithms", options.contentEncryptionAlgorithms);
    if (keyManagementAlgorithms && !keyManagementAlgorithms.has(alg) || !keyManagementAlgorithms && alg.startsWith("PBES2")) throw new (0, $b527c450e4afd840$export$d51fd7fedeccc338)('"alg" (Algorithm) Header Parameter value not allowed');
    if (contentEncryptionAlgorithms && !contentEncryptionAlgorithms.has(enc)) throw new (0, $b527c450e4afd840$export$d51fd7fedeccc338)('"enc" (Encryption Algorithm) Header Parameter value not allowed');
    let encryptedKey;
    if (jwe.encrypted_key !== undefined) try {
        encryptedKey = (0, $9f65a7b465b05d12$export$2f872c0f2117be69)(jwe.encrypted_key);
    } catch  {
        throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("Failed to base64url decode the encrypted_key");
    }
    let resolvedKey = false;
    if (typeof key === "function") {
        key = await key(parsedProt, jwe);
        resolvedKey = true;
    }
    let cek;
    try {
        cek = await (0, $cb72a03f614cfa7e$export$2e2bcd8739ae039)(alg, key, encryptedKey, joseHeader, options);
    } catch (err) {
        if (err instanceof TypeError || err instanceof (0, $b527c450e4afd840$export$19f281f2275f6a15) || err instanceof (0, $b527c450e4afd840$export$19ddbcbf2016ab28)) throw err;
        cek = (0, $f7c1f76992b06893$export$2e2bcd8739ae039)(enc);
    }
    let iv;
    let tag;
    if (jwe.iv !== undefined) try {
        iv = (0, $9f65a7b465b05d12$export$2f872c0f2117be69)(jwe.iv);
    } catch  {
        throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("Failed to base64url decode the iv");
    }
    if (jwe.tag !== undefined) try {
        tag = (0, $9f65a7b465b05d12$export$2f872c0f2117be69)(jwe.tag);
    } catch  {
        throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("Failed to base64url decode the tag");
    }
    const protectedHeader = (0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode(jwe.protected ?? "");
    let additionalData;
    if (jwe.aad !== undefined) additionalData = (0, $15ceb15c8014d6a6$export$ee1b3e54f0441b22)(protectedHeader, (0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode("."), (0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode(jwe.aad));
    else additionalData = protectedHeader;
    let ciphertext;
    try {
        ciphertext = (0, $9f65a7b465b05d12$export$2f872c0f2117be69)(jwe.ciphertext);
    } catch  {
        throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("Failed to base64url decode the ciphertext");
    }
    const plaintext = await (0, $298e2c6c2b0676fa$export$2e2bcd8739ae039)(enc, cek, ciphertext, iv, tag, additionalData);
    const result = {
        plaintext: plaintext
    };
    if (jwe.protected !== undefined) result.protectedHeader = parsedProt;
    if (jwe.aad !== undefined) try {
        result.additionalAuthenticatedData = (0, $9f65a7b465b05d12$export$2f872c0f2117be69)(jwe.aad);
    } catch  {
        throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("Failed to base64url decode the aad");
    }
    if (jwe.unprotected !== undefined) result.sharedUnprotectedHeader = jwe.unprotected;
    if (jwe.header !== undefined) result.unprotectedHeader = jwe.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}




async function $a13f8dcb9ee0ec30$export$c9a8efe6bfd872ce(jwe, key, options) {
    if (jwe instanceof Uint8Array) jwe = (0, $15ceb15c8014d6a6$export$124c96e6ce37090b).decode(jwe);
    if (typeof jwe !== "string") throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("Compact JWE must be a string or Uint8Array");
    const { 0: protectedHeader, 1: encryptedKey, 2: iv, 3: ciphertext, 4: tag, length: length } = jwe.split(".");
    if (length !== 5) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("Invalid Compact JWE");
    const decrypted = await (0, $77eb0ea47c773e39$export$b75cd12892ae94d2)({
        ciphertext: ciphertext,
        iv: iv || undefined,
        protected: protectedHeader,
        tag: tag || undefined,
        encrypted_key: encryptedKey || undefined
    }, key, options);
    const result = {
        plaintext: decrypted.plaintext,
        protectedHeader: decrypted.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: decrypted.key
    };
    return result;
}






async function $ffc8fb6dccbf6def$export$56bc728c88264430(jwe, key, options) {
    if (!(0, $17b531bbb1af817d$export$2e2bcd8739ae039)(jwe)) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("General JWE must be an object");
    if (!Array.isArray(jwe.recipients) || !jwe.recipients.every((0, $17b531bbb1af817d$export$2e2bcd8739ae039))) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Recipients missing or incorrect type");
    if (!jwe.recipients.length) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Recipients has no members");
    for (const recipient of jwe.recipients)try {
        return await (0, $77eb0ea47c773e39$export$b75cd12892ae94d2)({
            aad: jwe.aad,
            ciphertext: jwe.ciphertext,
            encrypted_key: recipient.encrypted_key,
            header: recipient.header,
            iv: jwe.iv,
            protected: jwe.protected,
            tag: jwe.tag,
            unprotected: jwe.unprotected
        }, key, options);
    } catch  {}
    throw new (0, $b527c450e4afd840$export$1a57512ad9773b2a)();
}
















const $aa89251713d26e4b$var$keyToJWK = async (key)=>{
    if (key instanceof Uint8Array) return {
        kty: "oct",
        k: (0, $9f65a7b465b05d12$export$c564cdbbe6da493)(key)
    };
    if (!(0, $e60fe3255652942b$export$600b5603bbac4c6)(key)) throw new TypeError((0, $734ae07da0f9ebc0$export$2e2bcd8739ae039)(key, ...(0, $b08803cc00854154$export$b14ad400b1d09e0f), "Uint8Array"));
    if (!key.extractable) throw new TypeError("non-extractable CryptoKey cannot be exported as a JWK");
    const { ext: ext, key_ops: key_ops, alg: alg, use: use, ...jwk } = await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.exportKey("jwk", key);
    return jwk;
};
var $aa89251713d26e4b$export$2e2bcd8739ae039 = $aa89251713d26e4b$var$keyToJWK;


async function $b239fe4b0d8ade58$export$7f687badbeed246d(key) {
    return (0, $82d11d74ed6867d1$export$cfba7e924fe414ca)(key);
}
async function $b239fe4b0d8ade58$export$ba4a7192ac1a47fe(key) {
    return (0, $82d11d74ed6867d1$export$cac76a78a90b914d)(key);
}
async function $b239fe4b0d8ade58$export$ffb510cfd482ce82(key) {
    return (0, $aa89251713d26e4b$export$2e2bcd8739ae039)(key);
}




async function $3eb0410d157c2bcf$var$encryptKeyManagement(alg, enc, key, providedCek, providedParameters = {}) {
    let encryptedKey;
    let parameters;
    let cek;
    (0, $13e7b60c68902f8e$export$2e2bcd8739ae039)(alg, key, "encrypt");
    switch(alg){
        case "dir":
            cek = key;
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                if (!$aca9c64c07567e83$export$f28ab77d793719b2(key)) throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)("ECDH with the provided key is not allowed or not supported by your javascript runtime");
                const { apu: apu, apv: apv } = providedParameters;
                let { epk: ephemeralKey } = providedParameters;
                ephemeralKey || (ephemeralKey = (await $aca9c64c07567e83$export$1338dee8c889e310(key)).privateKey);
                const { x: x, y: y, crv: crv, kty: kty } = await (0, $b239fe4b0d8ade58$export$ffb510cfd482ce82)(ephemeralKey);
                const sharedSecret = await $aca9c64c07567e83$export$87770b6b245073b5(key, ephemeralKey, alg === "ECDH-ES" ? enc : alg, alg === "ECDH-ES" ? (0, $f7c1f76992b06893$export$db433e85ac514a95)(enc) : parseInt(alg.slice(-5, -2), 10), apu, apv);
                parameters = {
                    epk: {
                        x: x,
                        crv: crv,
                        kty: kty
                    }
                };
                if (kty === "EC") parameters.epk.y = y;
                if (apu) parameters.apu = (0, $9f65a7b465b05d12$export$c564cdbbe6da493)(apu);
                if (apv) parameters.apv = (0, $9f65a7b465b05d12$export$c564cdbbe6da493)(apv);
                if (alg === "ECDH-ES") {
                    cek = sharedSecret;
                    break;
                }
                cek = providedCek || (0, $f7c1f76992b06893$export$2e2bcd8739ae039)(enc);
                const kwAlg = alg.slice(-6);
                encryptedKey = await (0, $6c9e9a5dbc3065a8$export$4997ffc0176396a6)(kwAlg, sharedSecret, cek);
                break;
            }
        case "RSA1_5":
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            cek = providedCek || (0, $f7c1f76992b06893$export$2e2bcd8739ae039)(enc);
            encryptedKey = await (0, $9062bff1c2e82699$export$5b0f6292f11d1d18)(alg, key, cek);
            break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            {
                cek = providedCek || (0, $f7c1f76992b06893$export$2e2bcd8739ae039)(enc);
                const { p2c: p2c, p2s: p2s } = providedParameters;
                ({ encryptedKey: encryptedKey, ...parameters } = await (0, $ecbc4b45c508be2d$export$5b0f6292f11d1d18)(alg, key, cek, p2c, p2s));
                break;
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            cek = providedCek || (0, $f7c1f76992b06893$export$2e2bcd8739ae039)(enc);
            encryptedKey = await (0, $6c9e9a5dbc3065a8$export$4997ffc0176396a6)(alg, key, cek);
            break;
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
            {
                cek = providedCek || (0, $f7c1f76992b06893$export$2e2bcd8739ae039)(enc);
                const { iv: iv } = providedParameters;
                ({ encryptedKey: encryptedKey, ...parameters } = await (0, $53e24359765f55b2$export$4997ffc0176396a6)(alg, key, cek, iv));
                break;
            }
        default:
            throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)('Invalid or unsupported "alg" (JWE Algorithm) header value');
    }
    return {
        cek: cek,
        encryptedKey: encryptedKey,
        parameters: parameters
    };
}
var $3eb0410d157c2bcf$export$2e2bcd8739ae039 = $3eb0410d157c2bcf$var$encryptKeyManagement;






const $e44154f7f6ea2199$export$39c45cb77eaf132 = Symbol();
class $e44154f7f6ea2199$export$eec23736d3c24809 {
    constructor(plaintext){
        if (!(plaintext instanceof Uint8Array)) throw new TypeError("plaintext must be an instance of Uint8Array");
        this._plaintext = plaintext;
    }
    setKeyManagementParameters(parameters) {
        if (this._keyManagementParameters) throw new TypeError("setKeyManagementParameters can only be called once");
        this._keyManagementParameters = parameters;
        return this;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setSharedUnprotectedHeader(sharedUnprotectedHeader) {
        if (this._sharedUnprotectedHeader) throw new TypeError("setSharedUnprotectedHeader can only be called once");
        this._sharedUnprotectedHeader = sharedUnprotectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    setAdditionalAuthenticatedData(aad) {
        this._aad = aad;
        return this;
    }
    setContentEncryptionKey(cek) {
        if (this._cek) throw new TypeError("setContentEncryptionKey can only be called once");
        this._cek = cek;
        return this;
    }
    setInitializationVector(iv) {
        if (this._iv) throw new TypeError("setInitializationVector can only be called once");
        this._iv = iv;
        return this;
    }
    async encrypt(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader && !this._sharedUnprotectedHeader) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("either setProtectedHeader, setUnprotectedHeader, or sharedUnprotectedHeader must be called before #encrypt()");
        if (!(0, $33a1c842479100e9$export$2e2bcd8739ae039)(this._protectedHeader, this._unprotectedHeader, this._sharedUnprotectedHeader)) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint");
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader,
            ...this._sharedUnprotectedHeader
        };
        (0, $ec5ba5202f403f8f$export$2e2bcd8739ae039)((0, $b527c450e4afd840$export$19f281f2275f6a15), new Map(), options?.crit, this._protectedHeader, joseHeader);
        if (joseHeader.zip !== undefined) throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
        const { alg: alg, enc: enc } = joseHeader;
        if (typeof alg !== "string" || !alg) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)('JWE "alg" (Algorithm) Header Parameter missing or invalid');
        if (typeof enc !== "string" || !enc) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
        let encryptedKey;
        if (this._cek && (alg === "dir" || alg === "ECDH-ES")) throw new TypeError(`setContentEncryptionKey cannot be called with JWE "alg" (Algorithm) Header ${alg}`);
        let cek;
        {
            let parameters;
            ({ cek: cek, encryptedKey: encryptedKey, parameters: parameters } = await (0, $3eb0410d157c2bcf$export$2e2bcd8739ae039)(alg, enc, key, this._cek, this._keyManagementParameters));
            if (parameters) {
                if (options && $e44154f7f6ea2199$export$39c45cb77eaf132 in options) {
                    if (!this._unprotectedHeader) this.setUnprotectedHeader(parameters);
                    else this._unprotectedHeader = {
                        ...this._unprotectedHeader,
                        ...parameters
                    };
                } else if (!this._protectedHeader) this.setProtectedHeader(parameters);
                else this._protectedHeader = {
                    ...this._protectedHeader,
                    ...parameters
                };
            }
        }
        let additionalData;
        let protectedHeader;
        let aadMember;
        if (this._protectedHeader) protectedHeader = (0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode((0, $9f65a7b465b05d12$export$c564cdbbe6da493)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode("");
        if (this._aad) {
            aadMember = (0, $9f65a7b465b05d12$export$c564cdbbe6da493)(this._aad);
            additionalData = (0, $15ceb15c8014d6a6$export$ee1b3e54f0441b22)(protectedHeader, (0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode("."), (0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode(aadMember));
        } else additionalData = protectedHeader;
        const { ciphertext: ciphertext, tag: tag, iv: iv } = await (0, $140427608378c175$export$2e2bcd8739ae039)(enc, this._plaintext, cek, this._iv, additionalData);
        const jwe = {
            ciphertext: (0, $9f65a7b465b05d12$export$c564cdbbe6da493)(ciphertext)
        };
        if (iv) jwe.iv = (0, $9f65a7b465b05d12$export$c564cdbbe6da493)(iv);
        if (tag) jwe.tag = (0, $9f65a7b465b05d12$export$c564cdbbe6da493)(tag);
        if (encryptedKey) jwe.encrypted_key = (0, $9f65a7b465b05d12$export$c564cdbbe6da493)(encryptedKey);
        if (aadMember) jwe.aad = aadMember;
        if (this._protectedHeader) jwe.protected = (0, $15ceb15c8014d6a6$export$124c96e6ce37090b).decode(protectedHeader);
        if (this._sharedUnprotectedHeader) jwe.unprotected = this._sharedUnprotectedHeader;
        if (this._unprotectedHeader) jwe.header = this._unprotectedHeader;
        return jwe;
    }
}








class $a3073d7fcd5b23b4$var$IndividualRecipient {
    constructor(enc, key, options){
        this.parent = enc;
        this.key = key;
        this.options = options;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this.unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this.unprotectedHeader = unprotectedHeader;
        return this;
    }
    addRecipient(...args) {
        return this.parent.addRecipient(...args);
    }
    encrypt(...args) {
        return this.parent.encrypt(...args);
    }
    done() {
        return this.parent;
    }
}
class $a3073d7fcd5b23b4$export$44234adffc6b0b92 {
    constructor(plaintext){
        this._recipients = [];
        this._plaintext = plaintext;
    }
    addRecipient(key, options) {
        const recipient = new $a3073d7fcd5b23b4$var$IndividualRecipient(this, key, {
            crit: options?.crit
        });
        this._recipients.push(recipient);
        return recipient;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setSharedUnprotectedHeader(sharedUnprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setSharedUnprotectedHeader can only be called once");
        this._unprotectedHeader = sharedUnprotectedHeader;
        return this;
    }
    setAdditionalAuthenticatedData(aad) {
        this._aad = aad;
        return this;
    }
    async encrypt() {
        if (!this._recipients.length) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("at least one recipient must be added");
        if (this._recipients.length === 1) {
            const [recipient] = this._recipients;
            const flattened = await new (0, $e44154f7f6ea2199$export$eec23736d3c24809)(this._plaintext).setAdditionalAuthenticatedData(this._aad).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).encrypt(recipient.key, {
                ...recipient.options
            });
            const jwe = {
                ciphertext: flattened.ciphertext,
                iv: flattened.iv,
                recipients: [
                    {}
                ],
                tag: flattened.tag
            };
            if (flattened.aad) jwe.aad = flattened.aad;
            if (flattened.protected) jwe.protected = flattened.protected;
            if (flattened.unprotected) jwe.unprotected = flattened.unprotected;
            if (flattened.encrypted_key) jwe.recipients[0].encrypted_key = flattened.encrypted_key;
            if (flattened.header) jwe.recipients[0].header = flattened.header;
            return jwe;
        }
        let enc;
        for(let i = 0; i < this._recipients.length; i++){
            const recipient = this._recipients[i];
            if (!(0, $33a1c842479100e9$export$2e2bcd8739ae039)(this._protectedHeader, this._unprotectedHeader, recipient.unprotectedHeader)) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)("JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint");
            const joseHeader = {
                ...this._protectedHeader,
                ...this._unprotectedHeader,
                ...recipient.unprotectedHeader
            };
            const { alg: alg } = joseHeader;
            if (typeof alg !== "string" || !alg) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)('JWE "alg" (Algorithm) Header Parameter missing or invalid');
            if (alg === "dir" || alg === "ECDH-ES") throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)('"dir" and "ECDH-ES" alg may only be used with a single recipient');
            if (typeof joseHeader.enc !== "string" || !joseHeader.enc) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
            if (!enc) enc = joseHeader.enc;
            else if (enc !== joseHeader.enc) throw new (0, $b527c450e4afd840$export$19f281f2275f6a15)('JWE "enc" (Encryption Algorithm) Header Parameter must be the same for all recipients');
            (0, $ec5ba5202f403f8f$export$2e2bcd8739ae039)((0, $b527c450e4afd840$export$19f281f2275f6a15), new Map(), recipient.options.crit, this._protectedHeader, joseHeader);
            if (joseHeader.zip !== undefined) throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
        }
        const cek = (0, $f7c1f76992b06893$export$2e2bcd8739ae039)(enc);
        const jwe = {
            ciphertext: "",
            iv: "",
            recipients: [],
            tag: ""
        };
        for(let i = 0; i < this._recipients.length; i++){
            const recipient = this._recipients[i];
            const target = {};
            jwe.recipients.push(target);
            const joseHeader = {
                ...this._protectedHeader,
                ...this._unprotectedHeader,
                ...recipient.unprotectedHeader
            };
            const p2c = joseHeader.alg.startsWith("PBES2") ? 2048 + i : undefined;
            if (i === 0) {
                const flattened = await new (0, $e44154f7f6ea2199$export$eec23736d3c24809)(this._plaintext).setAdditionalAuthenticatedData(this._aad).setContentEncryptionKey(cek).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).setKeyManagementParameters({
                    p2c: p2c
                }).encrypt(recipient.key, {
                    ...recipient.options,
                    [(0, $e44154f7f6ea2199$export$39c45cb77eaf132)]: true
                });
                jwe.ciphertext = flattened.ciphertext;
                jwe.iv = flattened.iv;
                jwe.tag = flattened.tag;
                if (flattened.aad) jwe.aad = flattened.aad;
                if (flattened.protected) jwe.protected = flattened.protected;
                if (flattened.unprotected) jwe.unprotected = flattened.unprotected;
                target.encrypted_key = flattened.encrypted_key;
                if (flattened.header) target.header = flattened.header;
                continue;
            }
            const { encryptedKey: encryptedKey, parameters: parameters } = await (0, $3eb0410d157c2bcf$export$2e2bcd8739ae039)(recipient.unprotectedHeader?.alg || this._protectedHeader?.alg || this._unprotectedHeader?.alg, enc, recipient.key, cek, {
                p2c: p2c
            });
            target.encrypted_key = (0, $9f65a7b465b05d12$export$c564cdbbe6da493)(encryptedKey);
            if (recipient.unprotectedHeader || parameters) target.header = {
                ...recipient.unprotectedHeader,
                ...parameters
            };
        }
        return jwe;
    }
}




function $236cf24823f013ad$export$2e2bcd8739ae039(alg, algorithm) {
    const hash = `SHA-${alg.slice(-3)}`;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            return {
                hash: hash,
                name: "HMAC"
            };
        case "PS256":
        case "PS384":
        case "PS512":
            return {
                hash: hash,
                name: "RSA-PSS",
                saltLength: alg.slice(-3) >> 3
            };
        case "RS256":
        case "RS384":
        case "RS512":
            return {
                hash: hash,
                name: "RSASSA-PKCS1-v1_5"
            };
        case "ES256":
        case "ES384":
        case "ES512":
            return {
                hash: hash,
                name: "ECDSA",
                namedCurve: algorithm.namedCurve
            };
        case "EdDSA":
            return {
                name: algorithm.name
            };
        default:
            throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}








function $31bd7a0de92faaca$export$2e2bcd8739ae039(alg, key, usage) {
    if ((0, $e60fe3255652942b$export$600b5603bbac4c6)(key)) {
        (0, $837aef40404c959e$export$39a36029eee6729)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) {
        if (!alg.startsWith("HS")) throw new TypeError((0, $734ae07da0f9ebc0$export$2e2bcd8739ae039)(key, ...(0, $b08803cc00854154$export$b14ad400b1d09e0f)));
        return (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.importKey("raw", key, {
            hash: `SHA-${alg.slice(-3)}`,
            name: "HMAC"
        }, false, [
            usage
        ]);
    }
    throw new TypeError((0, $734ae07da0f9ebc0$export$2e2bcd8739ae039)(key, ...(0, $b08803cc00854154$export$b14ad400b1d09e0f), "Uint8Array"));
}


const $ae658ef345aebba5$var$verify = async (alg, key, signature, data)=>{
    const cryptoKey = await (0, $31bd7a0de92faaca$export$2e2bcd8739ae039)(alg, key, "verify");
    (0, $1937b5dc3f5c2933$export$2e2bcd8739ae039)(alg, cryptoKey);
    const algorithm = (0, $236cf24823f013ad$export$2e2bcd8739ae039)(alg, cryptoKey.algorithm);
    try {
        return await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.verify(algorithm, cryptoKey, signature, data);
    } catch  {
        return false;
    }
};
var $ae658ef345aebba5$export$2e2bcd8739ae039 = $ae658ef345aebba5$var$verify;









async function $522c6241b5f8e16a$export$b2614975507c40c9(jws, key, options) {
    if (!(0, $17b531bbb1af817d$export$2e2bcd8739ae039)(jws)) throw new (0, $b527c450e4afd840$export$e838de724af3d116)("Flattened JWS must be an object");
    if (jws.protected === undefined && jws.header === undefined) throw new (0, $b527c450e4afd840$export$e838de724af3d116)('Flattened JWS must have either of the "protected" or "header" members');
    if (jws.protected !== undefined && typeof jws.protected !== "string") throw new (0, $b527c450e4afd840$export$e838de724af3d116)("JWS Protected Header incorrect type");
    if (jws.payload === undefined) throw new (0, $b527c450e4afd840$export$e838de724af3d116)("JWS Payload missing");
    if (typeof jws.signature !== "string") throw new (0, $b527c450e4afd840$export$e838de724af3d116)("JWS Signature missing or incorrect type");
    if (jws.header !== undefined && !(0, $17b531bbb1af817d$export$2e2bcd8739ae039)(jws.header)) throw new (0, $b527c450e4afd840$export$e838de724af3d116)("JWS Unprotected Header incorrect type");
    let parsedProt = {};
    if (jws.protected) try {
        const protectedHeader = (0, $9f65a7b465b05d12$export$2f872c0f2117be69)(jws.protected);
        parsedProt = JSON.parse((0, $15ceb15c8014d6a6$export$124c96e6ce37090b).decode(protectedHeader));
    } catch  {
        throw new (0, $b527c450e4afd840$export$e838de724af3d116)("JWS Protected Header is invalid");
    }
    if (!(0, $33a1c842479100e9$export$2e2bcd8739ae039)(parsedProt, jws.header)) throw new (0, $b527c450e4afd840$export$e838de724af3d116)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const joseHeader = {
        ...parsedProt,
        ...jws.header
    };
    const extensions = (0, $ec5ba5202f403f8f$export$2e2bcd8739ae039)((0, $b527c450e4afd840$export$e838de724af3d116), new Map([
        [
            "b64",
            true
        ]
    ]), options?.crit, parsedProt, joseHeader);
    let b64 = true;
    if (extensions.has("b64")) {
        b64 = parsedProt.b64;
        if (typeof b64 !== "boolean") throw new (0, $b527c450e4afd840$export$e838de724af3d116)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    }
    const { alg: alg } = joseHeader;
    if (typeof alg !== "string" || !alg) throw new (0, $b527c450e4afd840$export$e838de724af3d116)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    const algorithms = options && (0, $1655c7f4cd0c63fd$export$2e2bcd8739ae039)("algorithms", options.algorithms);
    if (algorithms && !algorithms.has(alg)) throw new (0, $b527c450e4afd840$export$d51fd7fedeccc338)('"alg" (Algorithm) Header Parameter value not allowed');
    if (b64) {
        if (typeof jws.payload !== "string") throw new (0, $b527c450e4afd840$export$e838de724af3d116)("JWS Payload must be a string");
    } else if (typeof jws.payload !== "string" && !(jws.payload instanceof Uint8Array)) throw new (0, $b527c450e4afd840$export$e838de724af3d116)("JWS Payload must be a string or an Uint8Array instance");
    let resolvedKey = false;
    if (typeof key === "function") {
        key = await key(parsedProt, jws);
        resolvedKey = true;
    }
    (0, $13e7b60c68902f8e$export$2e2bcd8739ae039)(alg, key, "verify");
    const data = (0, $15ceb15c8014d6a6$export$ee1b3e54f0441b22)((0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode(jws.protected ?? ""), (0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode("."), typeof jws.payload === "string" ? (0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode(jws.payload) : jws.payload);
    let signature;
    try {
        signature = (0, $9f65a7b465b05d12$export$2f872c0f2117be69)(jws.signature);
    } catch  {
        throw new (0, $b527c450e4afd840$export$e838de724af3d116)("Failed to base64url decode the signature");
    }
    const verified = await (0, $ae658ef345aebba5$export$2e2bcd8739ae039)(alg, key, signature, data);
    if (!verified) throw new (0, $b527c450e4afd840$export$c67a0218e7c50378)();
    let payload;
    if (b64) try {
        payload = (0, $9f65a7b465b05d12$export$2f872c0f2117be69)(jws.payload);
    } catch  {
        throw new (0, $b527c450e4afd840$export$e838de724af3d116)("Failed to base64url decode the payload");
    }
    else if (typeof jws.payload === "string") payload = (0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode(jws.payload);
    else payload = jws.payload;
    const result = {
        payload: payload
    };
    if (jws.protected !== undefined) result.protectedHeader = parsedProt;
    if (jws.header !== undefined) result.unprotectedHeader = jws.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}




async function $abaf8f16dd45091f$export$996150e72a8992e(jws, key, options) {
    if (jws instanceof Uint8Array) jws = (0, $15ceb15c8014d6a6$export$124c96e6ce37090b).decode(jws);
    if (typeof jws !== "string") throw new (0, $b527c450e4afd840$export$e838de724af3d116)("Compact JWS must be a string or Uint8Array");
    const { 0: protectedHeader, 1: payload, 2: signature, length: length } = jws.split(".");
    if (length !== 3) throw new (0, $b527c450e4afd840$export$e838de724af3d116)("Invalid Compact JWS");
    const verified = await (0, $522c6241b5f8e16a$export$b2614975507c40c9)({
        payload: payload,
        protected: protectedHeader,
        signature: signature
    }, key, options);
    const result = {
        payload: verified.payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}






async function $4c75bb20bfd6857f$export$45b643129436bc63(jws, key, options) {
    if (!(0, $17b531bbb1af817d$export$2e2bcd8739ae039)(jws)) throw new (0, $b527c450e4afd840$export$e838de724af3d116)("General JWS must be an object");
    if (!Array.isArray(jws.signatures) || !jws.signatures.every((0, $17b531bbb1af817d$export$2e2bcd8739ae039))) throw new (0, $b527c450e4afd840$export$e838de724af3d116)("JWS Signatures missing or incorrect type");
    for (const signature of jws.signatures)try {
        return await (0, $522c6241b5f8e16a$export$b2614975507c40c9)({
            header: signature.header,
            payload: jws.payload,
            protected: signature.protected,
            signature: signature.signature
        }, key, options);
    } catch  {}
    throw new (0, $b527c450e4afd840$export$c67a0218e7c50378)();
}





var $ef1f979453a0ecbe$export$2e2bcd8739ae039 = (date)=>Math.floor(date.getTime() / 1000);


const $fde22f4766f790ec$var$minute = 60;
const $fde22f4766f790ec$var$hour = $fde22f4766f790ec$var$minute * 60;
const $fde22f4766f790ec$var$day = $fde22f4766f790ec$var$hour * 24;
const $fde22f4766f790ec$var$week = $fde22f4766f790ec$var$day * 7;
const $fde22f4766f790ec$var$year = $fde22f4766f790ec$var$day * 365.25;
const $fde22f4766f790ec$var$REGEX = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i;
var $fde22f4766f790ec$export$2e2bcd8739ae039 = (str)=>{
    const matched = $fde22f4766f790ec$var$REGEX.exec(str);
    if (!matched || matched[4] && matched[1]) throw new TypeError("Invalid time period format");
    const value = parseFloat(matched[2]);
    const unit = matched[3].toLowerCase();
    let numericDate;
    switch(unit){
        case "sec":
        case "secs":
        case "second":
        case "seconds":
        case "s":
            numericDate = Math.round(value);
            break;
        case "minute":
        case "minutes":
        case "min":
        case "mins":
        case "m":
            numericDate = Math.round(value * $fde22f4766f790ec$var$minute);
            break;
        case "hour":
        case "hours":
        case "hr":
        case "hrs":
        case "h":
            numericDate = Math.round(value * $fde22f4766f790ec$var$hour);
            break;
        case "day":
        case "days":
        case "d":
            numericDate = Math.round(value * $fde22f4766f790ec$var$day);
            break;
        case "week":
        case "weeks":
        case "w":
            numericDate = Math.round(value * $fde22f4766f790ec$var$week);
            break;
        default:
            numericDate = Math.round(value * $fde22f4766f790ec$var$year);
            break;
    }
    if (matched[1] === "-" || matched[4] === "ago") return -numericDate;
    return numericDate;
};



const $2079ffcd52f89977$var$normalizeTyp = (value)=>value.toLowerCase().replace(/^application\//, "");
const $2079ffcd52f89977$var$checkAudiencePresence = (audPayload, audOption)=>{
    if (typeof audPayload === "string") return audOption.includes(audPayload);
    if (Array.isArray(audPayload)) return audOption.some(Set.prototype.has.bind(new Set(audPayload)));
    return false;
};
var $2079ffcd52f89977$export$2e2bcd8739ae039 = (protectedHeader, encodedPayload, options = {})=>{
    const { typ: typ } = options;
    if (typ && (typeof protectedHeader.typ !== "string" || $2079ffcd52f89977$var$normalizeTyp(protectedHeader.typ) !== $2079ffcd52f89977$var$normalizeTyp(typ))) throw new (0, $b527c450e4afd840$export$f1e14efb908196e9)('unexpected "typ" JWT header value', "typ", "check_failed");
    let payload;
    try {
        payload = JSON.parse((0, $15ceb15c8014d6a6$export$124c96e6ce37090b).decode(encodedPayload));
    } catch  {}
    if (!(0, $17b531bbb1af817d$export$2e2bcd8739ae039)(payload)) throw new (0, $b527c450e4afd840$export$936b39ada0bbfceb)("JWT Claims Set must be a top-level JSON object");
    const { requiredClaims: requiredClaims = [], issuer: issuer, subject: subject, audience: audience, maxTokenAge: maxTokenAge } = options;
    const presenceCheck = [
        ...requiredClaims
    ];
    if (maxTokenAge !== undefined) presenceCheck.push("iat");
    if (audience !== undefined) presenceCheck.push("aud");
    if (subject !== undefined) presenceCheck.push("sub");
    if (issuer !== undefined) presenceCheck.push("iss");
    for (const claim of new Set(presenceCheck.reverse())){
        if (!(claim in payload)) throw new (0, $b527c450e4afd840$export$f1e14efb908196e9)(`missing required "${claim}" claim`, claim, "missing");
    }
    if (issuer && !(Array.isArray(issuer) ? issuer : [
        issuer
    ]).includes(payload.iss)) throw new (0, $b527c450e4afd840$export$f1e14efb908196e9)('unexpected "iss" claim value', "iss", "check_failed");
    if (subject && payload.sub !== subject) throw new (0, $b527c450e4afd840$export$f1e14efb908196e9)('unexpected "sub" claim value', "sub", "check_failed");
    if (audience && !$2079ffcd52f89977$var$checkAudiencePresence(payload.aud, typeof audience === "string" ? [
        audience
    ] : audience)) throw new (0, $b527c450e4afd840$export$f1e14efb908196e9)('unexpected "aud" claim value', "aud", "check_failed");
    let tolerance;
    switch(typeof options.clockTolerance){
        case "string":
            tolerance = (0, $fde22f4766f790ec$export$2e2bcd8739ae039)(options.clockTolerance);
            break;
        case "number":
            tolerance = options.clockTolerance;
            break;
        case "undefined":
            tolerance = 0;
            break;
        default:
            throw new TypeError("Invalid clockTolerance option type");
    }
    const { currentDate: currentDate } = options;
    const now = (0, $ef1f979453a0ecbe$export$2e2bcd8739ae039)(currentDate || new Date());
    if ((payload.iat !== undefined || maxTokenAge) && typeof payload.iat !== "number") throw new (0, $b527c450e4afd840$export$f1e14efb908196e9)('"iat" claim must be a number', "iat", "invalid");
    if (payload.nbf !== undefined) {
        if (typeof payload.nbf !== "number") throw new (0, $b527c450e4afd840$export$f1e14efb908196e9)('"nbf" claim must be a number', "nbf", "invalid");
        if (payload.nbf > now + tolerance) throw new (0, $b527c450e4afd840$export$f1e14efb908196e9)('"nbf" claim timestamp check failed', "nbf", "check_failed");
    }
    if (payload.exp !== undefined) {
        if (typeof payload.exp !== "number") throw new (0, $b527c450e4afd840$export$f1e14efb908196e9)('"exp" claim must be a number', "exp", "invalid");
        if (payload.exp <= now - tolerance) throw new (0, $b527c450e4afd840$export$4b386bf852b7863d)('"exp" claim timestamp check failed', "exp", "check_failed");
    }
    if (maxTokenAge) {
        const age = now - payload.iat;
        const max = typeof maxTokenAge === "number" ? maxTokenAge : (0, $fde22f4766f790ec$export$2e2bcd8739ae039)(maxTokenAge);
        if (age - tolerance > max) throw new (0, $b527c450e4afd840$export$4b386bf852b7863d)('"iat" claim timestamp check failed (too far in the past)', "iat", "check_failed");
        if (age < 0 - tolerance) throw new (0, $b527c450e4afd840$export$f1e14efb908196e9)('"iat" claim timestamp check failed (it should be in the past)', "iat", "check_failed");
    }
    return payload;
};



async function $2cfa56cf2ef70cdd$export$c878fd0f8381da51(jwt, key, options) {
    const verified = await (0, $abaf8f16dd45091f$export$996150e72a8992e)(jwt, key, options);
    if (verified.protectedHeader.crit?.includes("b64") && verified.protectedHeader.b64 === false) throw new (0, $b527c450e4afd840$export$936b39ada0bbfceb)("JWTs MUST NOT use unencoded payload");
    const payload = (0, $2079ffcd52f89977$export$2e2bcd8739ae039)(verified.protectedHeader, verified.payload, options);
    const result = {
        payload: payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}





async function $43f7e49ec2f9dd6b$export$6ee899505bc40a19(jwt, key, options) {
    const decrypted = await (0, $a13f8dcb9ee0ec30$export$c9a8efe6bfd872ce)(jwt, key, options);
    const payload = (0, $2079ffcd52f89977$export$2e2bcd8739ae039)(decrypted.protectedHeader, decrypted.plaintext, options);
    const { protectedHeader: protectedHeader } = decrypted;
    if (protectedHeader.iss !== undefined && protectedHeader.iss !== payload.iss) throw new (0, $b527c450e4afd840$export$f1e14efb908196e9)('replicated "iss" claim header parameter mismatch', "iss", "mismatch");
    if (protectedHeader.sub !== undefined && protectedHeader.sub !== payload.sub) throw new (0, $b527c450e4afd840$export$f1e14efb908196e9)('replicated "sub" claim header parameter mismatch', "sub", "mismatch");
    if (protectedHeader.aud !== undefined && JSON.stringify(protectedHeader.aud) !== JSON.stringify(payload.aud)) throw new (0, $b527c450e4afd840$export$f1e14efb908196e9)('replicated "aud" claim header parameter mismatch', "aud", "mismatch");
    const result = {
        payload: payload,
        protectedHeader: protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: decrypted.key
    };
    return result;
}



class $f5952f4dd04e0b40$export$965e4de9938e070e {
    constructor(plaintext){
        this._flattened = new (0, $e44154f7f6ea2199$export$eec23736d3c24809)(plaintext);
    }
    setContentEncryptionKey(cek) {
        this._flattened.setContentEncryptionKey(cek);
        return this;
    }
    setInitializationVector(iv) {
        this._flattened.setInitializationVector(iv);
        return this;
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    setKeyManagementParameters(parameters) {
        this._flattened.setKeyManagementParameters(parameters);
        return this;
    }
    async encrypt(key, options) {
        const jwe = await this._flattened.encrypt(key, options);
        return [
            jwe.protected,
            jwe.encrypted_key,
            jwe.iv,
            jwe.ciphertext,
            jwe.tag
        ].join(".");
    }
}








const $db835eb07a6835fa$var$sign = async (alg, key, data)=>{
    const cryptoKey = await (0, $31bd7a0de92faaca$export$2e2bcd8739ae039)(alg, key, "sign");
    (0, $1937b5dc3f5c2933$export$2e2bcd8739ae039)(alg, cryptoKey);
    const signature = await (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.sign((0, $236cf24823f013ad$export$2e2bcd8739ae039)(alg, cryptoKey.algorithm), cryptoKey, data);
    return new Uint8Array(signature);
};
var $db835eb07a6835fa$export$2e2bcd8739ae039 = $db835eb07a6835fa$var$sign;







class $a42c6e665d9783b0$export$9a8af5200da5ddb1 {
    constructor(payload){
        if (!(payload instanceof Uint8Array)) throw new TypeError("payload must be an instance of Uint8Array");
        this._payload = payload;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    async sign(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader) throw new (0, $b527c450e4afd840$export$e838de724af3d116)("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
        if (!(0, $33a1c842479100e9$export$2e2bcd8739ae039)(this._protectedHeader, this._unprotectedHeader)) throw new (0, $b527c450e4afd840$export$e838de724af3d116)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader
        };
        const extensions = (0, $ec5ba5202f403f8f$export$2e2bcd8739ae039)((0, $b527c450e4afd840$export$e838de724af3d116), new Map([
            [
                "b64",
                true
            ]
        ]), options?.crit, this._protectedHeader, joseHeader);
        let b64 = true;
        if (extensions.has("b64")) {
            b64 = this._protectedHeader.b64;
            if (typeof b64 !== "boolean") throw new (0, $b527c450e4afd840$export$e838de724af3d116)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
        }
        const { alg: alg } = joseHeader;
        if (typeof alg !== "string" || !alg) throw new (0, $b527c450e4afd840$export$e838de724af3d116)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
        (0, $13e7b60c68902f8e$export$2e2bcd8739ae039)(alg, key, "sign");
        let payload = this._payload;
        if (b64) payload = (0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode((0, $9f65a7b465b05d12$export$c564cdbbe6da493)(payload));
        let protectedHeader;
        if (this._protectedHeader) protectedHeader = (0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode((0, $9f65a7b465b05d12$export$c564cdbbe6da493)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode("");
        const data = (0, $15ceb15c8014d6a6$export$ee1b3e54f0441b22)(protectedHeader, (0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode("."), payload);
        const signature = await (0, $db835eb07a6835fa$export$2e2bcd8739ae039)(alg, key, data);
        const jws = {
            signature: (0, $9f65a7b465b05d12$export$c564cdbbe6da493)(signature),
            payload: ""
        };
        if (b64) jws.payload = (0, $15ceb15c8014d6a6$export$124c96e6ce37090b).decode(payload);
        if (this._unprotectedHeader) jws.header = this._unprotectedHeader;
        if (this._protectedHeader) jws.protected = (0, $15ceb15c8014d6a6$export$124c96e6ce37090b).decode(protectedHeader);
        return jws;
    }
}


class $d57704c7ce96e244$export$b6738d8e70498d17 {
    constructor(payload){
        this._flattened = new (0, $a42c6e665d9783b0$export$9a8af5200da5ddb1)(payload);
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    async sign(key, options) {
        const jws = await this._flattened.sign(key, options);
        if (jws.payload === undefined) throw new TypeError("use the flattened module for creating JWS with b64: false");
        return `${jws.protected}.${jws.payload}.${jws.signature}`;
    }
}





class $e8357ba9e7292cee$var$IndividualSignature {
    constructor(sig, key, options){
        this.parent = sig;
        this.key = key;
        this.options = options;
    }
    setProtectedHeader(protectedHeader) {
        if (this.protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this.protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this.unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this.unprotectedHeader = unprotectedHeader;
        return this;
    }
    addSignature(...args) {
        return this.parent.addSignature(...args);
    }
    sign(...args) {
        return this.parent.sign(...args);
    }
    done() {
        return this.parent;
    }
}
class $e8357ba9e7292cee$export$7e2f94727ed1a34b {
    constructor(payload){
        this._signatures = [];
        this._payload = payload;
    }
    addSignature(key, options) {
        const signature = new $e8357ba9e7292cee$var$IndividualSignature(this, key, options);
        this._signatures.push(signature);
        return signature;
    }
    async sign() {
        if (!this._signatures.length) throw new (0, $b527c450e4afd840$export$e838de724af3d116)("at least one signature must be added");
        const jws = {
            signatures: [],
            payload: ""
        };
        for(let i = 0; i < this._signatures.length; i++){
            const signature = this._signatures[i];
            const flattened = new (0, $a42c6e665d9783b0$export$9a8af5200da5ddb1)(this._payload);
            flattened.setProtectedHeader(signature.protectedHeader);
            flattened.setUnprotectedHeader(signature.unprotectedHeader);
            const { payload: payload, ...rest } = await flattened.sign(signature.key, signature.options);
            if (i === 0) jws.payload = payload;
            else if (jws.payload !== payload) throw new (0, $b527c450e4afd840$export$e838de724af3d116)("inconsistent use of JWS Unencoded Payload (RFC7797)");
            jws.signatures.push(rest);
        }
        return jws;
    }
}








function $7a53d20b855a0de2$var$validateInput(label, input) {
    if (!Number.isFinite(input)) throw new TypeError(`Invalid ${label} input`);
    return input;
}
class $7a53d20b855a0de2$export$2ef1b74b7c7e6eb3 {
    constructor(payload = {}){
        if (!(0, $17b531bbb1af817d$export$2e2bcd8739ae039)(payload)) throw new TypeError("JWT Claims Set MUST be an object");
        this._payload = payload;
    }
    setIssuer(issuer) {
        this._payload = {
            ...this._payload,
            iss: issuer
        };
        return this;
    }
    setSubject(subject) {
        this._payload = {
            ...this._payload,
            sub: subject
        };
        return this;
    }
    setAudience(audience) {
        this._payload = {
            ...this._payload,
            aud: audience
        };
        return this;
    }
    setJti(jwtId) {
        this._payload = {
            ...this._payload,
            jti: jwtId
        };
        return this;
    }
    setNotBefore(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            nbf: $7a53d20b855a0de2$var$validateInput("setNotBefore", input)
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            nbf: $7a53d20b855a0de2$var$validateInput("setNotBefore", (0, $ef1f979453a0ecbe$export$2e2bcd8739ae039)(input))
        };
        else this._payload = {
            ...this._payload,
            nbf: (0, $ef1f979453a0ecbe$export$2e2bcd8739ae039)(new Date()) + (0, $fde22f4766f790ec$export$2e2bcd8739ae039)(input)
        };
        return this;
    }
    setExpirationTime(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            exp: $7a53d20b855a0de2$var$validateInput("setExpirationTime", input)
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            exp: $7a53d20b855a0de2$var$validateInput("setExpirationTime", (0, $ef1f979453a0ecbe$export$2e2bcd8739ae039)(input))
        };
        else this._payload = {
            ...this._payload,
            exp: (0, $ef1f979453a0ecbe$export$2e2bcd8739ae039)(new Date()) + (0, $fde22f4766f790ec$export$2e2bcd8739ae039)(input)
        };
        return this;
    }
    setIssuedAt(input) {
        if (typeof input === "undefined") this._payload = {
            ...this._payload,
            iat: (0, $ef1f979453a0ecbe$export$2e2bcd8739ae039)(new Date())
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            iat: $7a53d20b855a0de2$var$validateInput("setIssuedAt", (0, $ef1f979453a0ecbe$export$2e2bcd8739ae039)(input))
        };
        else if (typeof input === "string") this._payload = {
            ...this._payload,
            iat: $7a53d20b855a0de2$var$validateInput("setIssuedAt", (0, $ef1f979453a0ecbe$export$2e2bcd8739ae039)(new Date()) + (0, $fde22f4766f790ec$export$2e2bcd8739ae039)(input))
        };
        else this._payload = {
            ...this._payload,
            iat: $7a53d20b855a0de2$var$validateInput("setIssuedAt", input)
        };
        return this;
    }
}


class $5498f784fd72b1f0$export$88d4e5d23fbe6c84 extends (0, $7a53d20b855a0de2$export$2ef1b74b7c7e6eb3) {
    setProtectedHeader(protectedHeader) {
        this._protectedHeader = protectedHeader;
        return this;
    }
    async sign(key, options) {
        const sig = new (0, $d57704c7ce96e244$export$b6738d8e70498d17)((0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode(JSON.stringify(this._payload)));
        sig.setProtectedHeader(this._protectedHeader);
        if (Array.isArray(this._protectedHeader?.crit) && this._protectedHeader.crit.includes("b64") && this._protectedHeader.b64 === false) throw new (0, $b527c450e4afd840$export$936b39ada0bbfceb)("JWTs MUST NOT use unencoded payload");
        return sig.sign(key, options);
    }
}





class $09af273dc3b2ac51$export$28c9f8d29aec6f3d extends (0, $7a53d20b855a0de2$export$2ef1b74b7c7e6eb3) {
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setKeyManagementParameters(parameters) {
        if (this._keyManagementParameters) throw new TypeError("setKeyManagementParameters can only be called once");
        this._keyManagementParameters = parameters;
        return this;
    }
    setContentEncryptionKey(cek) {
        if (this._cek) throw new TypeError("setContentEncryptionKey can only be called once");
        this._cek = cek;
        return this;
    }
    setInitializationVector(iv) {
        if (this._iv) throw new TypeError("setInitializationVector can only be called once");
        this._iv = iv;
        return this;
    }
    replicateIssuerAsHeader() {
        this._replicateIssuerAsHeader = true;
        return this;
    }
    replicateSubjectAsHeader() {
        this._replicateSubjectAsHeader = true;
        return this;
    }
    replicateAudienceAsHeader() {
        this._replicateAudienceAsHeader = true;
        return this;
    }
    async encrypt(key, options) {
        const enc = new (0, $f5952f4dd04e0b40$export$965e4de9938e070e)((0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode(JSON.stringify(this._payload)));
        if (this._replicateIssuerAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            iss: this._payload.iss
        };
        if (this._replicateSubjectAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            sub: this._payload.sub
        };
        if (this._replicateAudienceAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            aud: this._payload.aud
        };
        enc.setProtectedHeader(this._protectedHeader);
        if (this._iv) enc.setInitializationVector(this._iv);
        if (this._cek) enc.setContentEncryptionKey(this._cek);
        if (this._keyManagementParameters) enc.setKeyManagementParameters(this._keyManagementParameters);
        return enc.encrypt(key, options);
    }
}







const $14e549e891933a9e$var$check = (value, description)=>{
    if (typeof value !== "string" || !value) throw new (0, $b527c450e4afd840$export$b3992e0f88fb07e3)(`${description} missing or invalid`);
};
async function $14e549e891933a9e$export$f1ec189735e8660f(jwk, digestAlgorithm) {
    if (!(0, $17b531bbb1af817d$export$2e2bcd8739ae039)(jwk)) throw new TypeError("JWK must be an object");
    digestAlgorithm ?? (digestAlgorithm = "sha256");
    if (digestAlgorithm !== "sha256" && digestAlgorithm !== "sha384" && digestAlgorithm !== "sha512") throw new TypeError('digestAlgorithm must one of "sha256", "sha384", or "sha512"');
    let components;
    switch(jwk.kty){
        case "EC":
            $14e549e891933a9e$var$check(jwk.crv, '"crv" (Curve) Parameter');
            $14e549e891933a9e$var$check(jwk.x, '"x" (X Coordinate) Parameter');
            $14e549e891933a9e$var$check(jwk.y, '"y" (Y Coordinate) Parameter');
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x,
                y: jwk.y
            };
            break;
        case "OKP":
            $14e549e891933a9e$var$check(jwk.crv, '"crv" (Subtype of Key Pair) Parameter');
            $14e549e891933a9e$var$check(jwk.x, '"x" (Public Key) Parameter');
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x
            };
            break;
        case "RSA":
            $14e549e891933a9e$var$check(jwk.e, '"e" (Exponent) Parameter');
            $14e549e891933a9e$var$check(jwk.n, '"n" (Modulus) Parameter');
            components = {
                e: jwk.e,
                kty: jwk.kty,
                n: jwk.n
            };
            break;
        case "oct":
            $14e549e891933a9e$var$check(jwk.k, '"k" (Key Value) Parameter');
            components = {
                k: jwk.k,
                kty: jwk.kty
            };
            break;
        default:
            throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)('"kty" (Key Type) Parameter missing or unsupported');
    }
    const data = (0, $15ceb15c8014d6a6$export$5486af06137bf21a).encode(JSON.stringify(components));
    return (0, $9f65a7b465b05d12$export$c564cdbbe6da493)(await (0, $7244d0ea8a4d9b30$export$2e2bcd8739ae039)(digestAlgorithm, data));
}
async function $14e549e891933a9e$export$b9879ebc49d4fd7a(jwk, digestAlgorithm) {
    digestAlgorithm ?? (digestAlgorithm = "sha256");
    const thumbprint = await $14e549e891933a9e$export$f1ec189735e8660f(jwk, digestAlgorithm);
    return `urn:ietf:params:oauth:jwk-thumbprint:sha-${digestAlgorithm.slice(-3)}:${thumbprint}`;
}





async function $8df37a4628f11973$export$c51e3062a159ef59(protectedHeader, token) {
    const joseHeader = {
        ...protectedHeader,
        ...token?.header
    };
    if (!(0, $17b531bbb1af817d$export$2e2bcd8739ae039)(joseHeader.jwk)) throw new (0, $b527c450e4afd840$export$e838de724af3d116)('"jwk" (JSON Web Key) Header Parameter must be a JSON object');
    const key = await (0, $e63362ecdabc85c1$export$2b70d37b4d0b888b)({
        ...joseHeader.jwk,
        ext: true
    }, joseHeader.alg);
    if (key instanceof Uint8Array || key.type !== "public") throw new (0, $b527c450e4afd840$export$e838de724af3d116)('"jwk" (JSON Web Key) Header Parameter must be a public key');
    return key;
}





function $4fead85a7539ef55$var$getKtyFromAlg(alg) {
    switch(typeof alg === "string" && alg.slice(0, 2)){
        case "RS":
        case "PS":
            return "RSA";
        case "ES":
            return "EC";
        case "Ed":
            return "OKP";
        default:
            throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)('Unsupported "alg" value for a JSON Web Key Set');
    }
}
function $4fead85a7539ef55$var$isJWKSLike(jwks) {
    return jwks && typeof jwks === "object" && Array.isArray(jwks.keys) && jwks.keys.every($4fead85a7539ef55$var$isJWKLike);
}
function $4fead85a7539ef55$var$isJWKLike(key) {
    return (0, $17b531bbb1af817d$export$2e2bcd8739ae039)(key);
}
function $4fead85a7539ef55$var$clone(obj) {
    if (typeof structuredClone === "function") return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}
class $4fead85a7539ef55$export$cfeaec9a672ea12b {
    constructor(jwks){
        this._cached = new WeakMap();
        if (!$4fead85a7539ef55$var$isJWKSLike(jwks)) throw new (0, $b527c450e4afd840$export$9b22c2a1e2403b8e)("JSON Web Key Set malformed");
        this._jwks = $4fead85a7539ef55$var$clone(jwks);
    }
    async getKey(protectedHeader, token) {
        const { alg: alg, kid: kid } = {
            ...protectedHeader,
            ...token?.header
        };
        const kty = $4fead85a7539ef55$var$getKtyFromAlg(alg);
        const candidates = this._jwks.keys.filter((jwk)=>{
            let candidate = kty === jwk.kty;
            if (candidate && typeof kid === "string") candidate = kid === jwk.kid;
            if (candidate && typeof jwk.alg === "string") candidate = alg === jwk.alg;
            if (candidate && typeof jwk.use === "string") candidate = jwk.use === "sig";
            if (candidate && Array.isArray(jwk.key_ops)) candidate = jwk.key_ops.includes("verify");
            if (candidate && alg === "EdDSA") candidate = jwk.crv === "Ed25519" || jwk.crv === "Ed448";
            if (candidate) switch(alg){
                case "ES256":
                    candidate = jwk.crv === "P-256";
                    break;
                case "ES256K":
                    candidate = jwk.crv === "secp256k1";
                    break;
                case "ES384":
                    candidate = jwk.crv === "P-384";
                    break;
                case "ES512":
                    candidate = jwk.crv === "P-521";
                    break;
            }
            return candidate;
        });
        const { 0: jwk, length: length } = candidates;
        if (length === 0) throw new (0, $b527c450e4afd840$export$3d5ed1a538bed04e)();
        if (length !== 1) {
            const error = new (0, $b527c450e4afd840$export$dc036de401a5c284)();
            const { _cached: _cached } = this;
            error[Symbol.asyncIterator] = async function*() {
                for (const jwk of candidates)try {
                    yield await $4fead85a7539ef55$var$importWithAlgCache(_cached, jwk, alg);
                } catch  {}
            };
            throw error;
        }
        return $4fead85a7539ef55$var$importWithAlgCache(this._cached, jwk, alg);
    }
}
async function $4fead85a7539ef55$var$importWithAlgCache(cache, jwk, alg) {
    const cached = cache.get(jwk) || cache.set(jwk, {}).get(jwk);
    if (cached[alg] === undefined) {
        const key = await (0, $e63362ecdabc85c1$export$2b70d37b4d0b888b)({
            ...jwk,
            ext: true
        }, alg);
        if (key instanceof Uint8Array || key.type !== "public") throw new (0, $b527c450e4afd840$export$9b22c2a1e2403b8e)("JSON Web Key Set members must be public keys");
        cached[alg] = key;
    }
    return cached[alg];
}
function $4fead85a7539ef55$export$4892abc640e5f80e(jwks) {
    const set = new $4fead85a7539ef55$export$cfeaec9a672ea12b(jwks);
    const localJWKSet = async (protectedHeader, token)=>set.getKey(protectedHeader, token);
    Object.defineProperties(localJWKSet, {
        jwks: {
            value: ()=>$4fead85a7539ef55$var$clone(set._jwks),
            enumerable: true,
            configurable: false,
            writable: false
        }
    });
    return localJWKSet;
}



const $b8b6a0a558bac06c$var$fetchJwks = async (url, timeout, options)=>{
    let controller;
    let id;
    let timedOut = false;
    if (typeof AbortController === "function") {
        controller = new AbortController();
        id = setTimeout(()=>{
            timedOut = true;
            controller.abort();
        }, timeout);
    }
    const response = await fetch(url.href, {
        signal: controller ? controller.signal : undefined,
        redirect: "manual",
        headers: options.headers
    }).catch((err)=>{
        if (timedOut) throw new (0, $b527c450e4afd840$export$3f30acebf25c04e6)();
        throw err;
    });
    if (id !== undefined) clearTimeout(id);
    if (response.status !== 200) throw new (0, $b527c450e4afd840$export$f754d6850d76bf87)("Expected 200 OK from the JSON Web Key Set HTTP response");
    try {
        return await response.json();
    } catch  {
        throw new (0, $b527c450e4afd840$export$f754d6850d76bf87)("Failed to parse the JSON Web Key Set HTTP response as JSON");
    }
};
var $b8b6a0a558bac06c$export$2e2bcd8739ae039 = $b8b6a0a558bac06c$var$fetchJwks;




function $17ac704f15929757$var$isCloudflareWorkers() {
    return typeof WebSocketPair !== "undefined" || typeof navigator !== "undefined" && navigator.userAgent === "Cloudflare-Workers" || typeof EdgeRuntime !== "undefined" && EdgeRuntime === "vercel";
}
let $17ac704f15929757$var$USER_AGENT;
if (typeof navigator === "undefined" || !navigator.userAgent?.startsWith?.("Mozilla/5.0 ")) {
    const NAME = "jose";
    const VERSION = "v5.3.0";
    $17ac704f15929757$var$USER_AGENT = `${NAME}/${VERSION}`;
}
class $17ac704f15929757$var$RemoteJWKSet {
    constructor(url, options){
        if (!(url instanceof URL)) throw new TypeError("url must be an instance of URL");
        this._url = new URL(url.href);
        this._options = {
            agent: options?.agent,
            headers: options?.headers
        };
        this._timeoutDuration = typeof options?.timeoutDuration === "number" ? options?.timeoutDuration : 5000;
        this._cooldownDuration = typeof options?.cooldownDuration === "number" ? options?.cooldownDuration : 30000;
        this._cacheMaxAge = typeof options?.cacheMaxAge === "number" ? options?.cacheMaxAge : 600000;
    }
    coolingDown() {
        return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cooldownDuration : false;
    }
    fresh() {
        return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cacheMaxAge : false;
    }
    async getKey(protectedHeader, token) {
        if (!this._local || !this.fresh()) await this.reload();
        try {
            return await this._local(protectedHeader, token);
        } catch (err) {
            if (err instanceof (0, $b527c450e4afd840$export$3d5ed1a538bed04e)) {
                if (this.coolingDown() === false) {
                    await this.reload();
                    return this._local(protectedHeader, token);
                }
            }
            throw err;
        }
    }
    async reload() {
        if (this._pendingFetch && $17ac704f15929757$var$isCloudflareWorkers()) this._pendingFetch = undefined;
        const headers = new Headers(this._options.headers);
        if ($17ac704f15929757$var$USER_AGENT && !headers.has("User-Agent")) {
            headers.set("User-Agent", $17ac704f15929757$var$USER_AGENT);
            this._options.headers = Object.fromEntries(headers.entries());
        }
        this._pendingFetch || (this._pendingFetch = (0, $b8b6a0a558bac06c$export$2e2bcd8739ae039)(this._url, this._timeoutDuration, this._options).then((json)=>{
            this._local = (0, $4fead85a7539ef55$export$4892abc640e5f80e)(json);
            this._jwksTimestamp = Date.now();
            this._pendingFetch = undefined;
        }).catch((err)=>{
            this._pendingFetch = undefined;
            throw err;
        }));
        await this._pendingFetch;
    }
}
function $17ac704f15929757$export$78ce35c2df51c333(url, options) {
    const set = new $17ac704f15929757$var$RemoteJWKSet(url, options);
    const remoteJWKSet = async (protectedHeader, token)=>set.getKey(protectedHeader, token);
    Object.defineProperties(remoteJWKSet, {
        coolingDown: {
            get: ()=>set.coolingDown(),
            enumerable: true,
            configurable: false
        },
        fresh: {
            get: ()=>set.fresh(),
            enumerable: true,
            configurable: false
        },
        reload: {
            value: ()=>set.reload(),
            enumerable: true,
            configurable: false,
            writable: false
        },
        reloading: {
            get: ()=>!!set._pendingFetch,
            enumerable: true,
            configurable: false
        },
        jwks: {
            value: ()=>set._local?.jwks(),
            enumerable: true,
            configurable: false,
            writable: false
        }
    });
    return remoteJWKSet;
}







class $26bb40dde8709a7c$export$6404fb90f16d8733 extends (0, $7a53d20b855a0de2$export$2ef1b74b7c7e6eb3) {
    encode() {
        const header = $9f65a7b465b05d12$export$c564cdbbe6da493(JSON.stringify({
            alg: "none"
        }));
        const payload = $9f65a7b465b05d12$export$c564cdbbe6da493(JSON.stringify(this._payload));
        return `${header}.${payload}.`;
    }
    static decode(jwt, options) {
        if (typeof jwt !== "string") throw new (0, $b527c450e4afd840$export$936b39ada0bbfceb)("Unsecured JWT must be a string");
        const { 0: encodedHeader, 1: encodedPayload, 2: signature, length: length } = jwt.split(".");
        if (length !== 3 || signature !== "") throw new (0, $b527c450e4afd840$export$936b39ada0bbfceb)("Invalid Unsecured JWT");
        let header;
        try {
            header = JSON.parse((0, $15ceb15c8014d6a6$export$124c96e6ce37090b).decode($9f65a7b465b05d12$export$2f872c0f2117be69(encodedHeader)));
            if (header.alg !== "none") throw new Error();
        } catch  {
            throw new (0, $b527c450e4afd840$export$936b39ada0bbfceb)("Invalid Unsecured JWT");
        }
        const payload = (0, $2079ffcd52f89977$export$2e2bcd8739ae039)(header, $9f65a7b465b05d12$export$2f872c0f2117be69(encodedPayload), options);
        return {
            payload: payload,
            header: header
        };
    }
}





const $ff496470569fd4ed$export$c564cdbbe6da493 = $9f65a7b465b05d12$export$c564cdbbe6da493;
const $ff496470569fd4ed$export$2f872c0f2117be69 = $9f65a7b465b05d12$export$2f872c0f2117be69;




function $79c82442b2368419$export$ca23208356ba8d90(token) {
    let protectedB64u;
    if (typeof token === "string") {
        const parts = token.split(".");
        if (parts.length === 3 || parts.length === 5) [protectedB64u] = parts;
    } else if (typeof token === "object" && token) {
        if ("protected" in token) protectedB64u = token.protected;
        else throw new TypeError("Token does not contain a Protected Header");
    }
    try {
        if (typeof protectedB64u !== "string" || !protectedB64u) throw new Error();
        const result = JSON.parse((0, $15ceb15c8014d6a6$export$124c96e6ce37090b).decode((0, $ff496470569fd4ed$export$2f872c0f2117be69)(protectedB64u)));
        if (!(0, $17b531bbb1af817d$export$2e2bcd8739ae039)(result)) throw new Error();
        return result;
    } catch  {
        throw new TypeError("Invalid Token or Protected Header formatting");
    }
}






function $1c2de5312649639f$export$dcef71b8fb9a6794(jwt) {
    if (typeof jwt !== "string") throw new (0, $b527c450e4afd840$export$936b39ada0bbfceb)("JWTs must use Compact JWS serialization, JWT must be a string");
    const { 1: payload, length: length } = jwt.split(".");
    if (length === 5) throw new (0, $b527c450e4afd840$export$936b39ada0bbfceb)("Only JWTs using Compact JWS serialization can be decoded");
    if (length !== 3) throw new (0, $b527c450e4afd840$export$936b39ada0bbfceb)("Invalid JWT");
    if (!payload) throw new (0, $b527c450e4afd840$export$936b39ada0bbfceb)("JWTs must contain a payload");
    let decoded;
    try {
        decoded = (0, $ff496470569fd4ed$export$2f872c0f2117be69)(payload);
    } catch  {
        throw new (0, $b527c450e4afd840$export$936b39ada0bbfceb)("Failed to base64url decode the payload");
    }
    let result;
    try {
        result = JSON.parse((0, $15ceb15c8014d6a6$export$124c96e6ce37090b).decode(decoded));
    } catch  {
        throw new (0, $b527c450e4afd840$export$936b39ada0bbfceb)("Failed to parse the decoded payload as JSON");
    }
    if (!(0, $17b531bbb1af817d$export$2e2bcd8739ae039)(result)) throw new (0, $b527c450e4afd840$export$936b39ada0bbfceb)("Invalid JWT Claims Set");
    return result;
}






async function $6a4ea1d877c61ffc$export$25395fe8d170ad7(alg, options) {
    let length;
    let algorithm;
    let keyUsages;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            length = parseInt(alg.slice(-3), 10);
            algorithm = {
                name: "HMAC",
                hash: `SHA-${length}`,
                length: length
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            length = parseInt(alg.slice(-3), 10);
            return (0, $6b7a00b30de8ad78$export$2e2bcd8739ae039)(new Uint8Array(length >> 3));
        case "A128KW":
        case "A192KW":
        case "A256KW":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-KW",
                length: length
            };
            keyUsages = [
                "wrapKey",
                "unwrapKey"
            ];
            break;
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-GCM",
                length: length
            };
            keyUsages = [
                "encrypt",
                "decrypt"
            ];
            break;
        default:
            throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.generateKey(algorithm, options?.extractable ?? false, keyUsages);
}
function $6a4ea1d877c61ffc$var$getModulusLengthOption(options) {
    const modulusLength = options?.modulusLength ?? 2048;
    if (typeof modulusLength !== "number" || modulusLength < 2048) throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)("Invalid or unsupported modulusLength option provided, 2048 bits or larger keys must be used");
    return modulusLength;
}
async function $6a4ea1d877c61ffc$export$a949d36eab55b41f(alg, options) {
    let algorithm;
    let keyUsages;
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $6a4ea1d877c61ffc$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $6a4ea1d877c61ffc$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $6a4ea1d877c61ffc$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "decrypt",
                "unwrapKey",
                "encrypt",
                "wrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "EdDSA":
            {
                keyUsages = [
                    "sign",
                    "verify"
                ];
                const crv = options?.crv ?? "Ed25519";
                switch(crv){
                    case "Ed25519":
                    case "Ed448":
                        algorithm = {
                            name: crv
                        };
                        break;
                    default:
                        throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)("Invalid or unsupported crv option provided");
                }
                break;
            }
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                keyUsages = [
                    "deriveKey",
                    "deriveBits"
                ];
                const crv = options?.crv ?? "P-256";
                switch(crv){
                    case "P-256":
                    case "P-384":
                    case "P-521":
                        algorithm = {
                            name: "ECDH",
                            namedCurve: crv
                        };
                        break;
                    case "X25519":
                    case "X448":
                        algorithm = {
                            name: crv
                        };
                        break;
                    default:
                        throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)("Invalid or unsupported crv option provided, supported values are P-256, P-384, P-521, X25519, and X448");
                }
                break;
            }
        default:
            throw new (0, $b527c450e4afd840$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, $e60fe3255652942b$export$2e2bcd8739ae039).subtle.generateKey(algorithm, options?.extractable ?? false, keyUsages);
}


async function $c127016b17b61037$export$a949d36eab55b41f(alg, options) {
    return (0, $6a4ea1d877c61ffc$export$a949d36eab55b41f)(alg, options);
}



async function $b240cf252c98a8ba$export$25395fe8d170ad7(alg, options) {
    return (0, $6a4ea1d877c61ffc$export$25395fe8d170ad7)(alg, options);
}



var $086b4d232749dc4a$export$2e2bcd8739ae039 = "WebCryptoAPI";


var $b43c21269aa387f7$export$2e2bcd8739ae039 = (0, $086b4d232749dc4a$export$2e2bcd8739ae039);




var $28932740830c95c9$exports = {};
"use strict";
var $28932740830c95c9$var$__createBinding = $28932740830c95c9$exports && $28932740830c95c9$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $28932740830c95c9$var$__exportStar = $28932740830c95c9$exports && $28932740830c95c9$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $28932740830c95c9$var$__createBinding(exports1, m, p);
};
Object.defineProperty($28932740830c95c9$exports, "__esModule", {
    value: true
});

$28932740830c95c9$var$__exportStar((parcelRequire("k7M45")), $28932740830c95c9$exports);

$28932740830c95c9$var$__exportStar((parcelRequire("brXJH")), $28932740830c95c9$exports);

$28932740830c95c9$var$__exportStar((parcelRequire("eiyYC")), $28932740830c95c9$exports);






var $9nZCP = parcelRequire("9nZCP");
function $9a96efbd4cf69239$export$864b6828bd07eda6(keyName, defaultValue) {
    const [storedValue, setStoredValue] = (0, $9nZCP.useState)(()=>{
        try {
            const value = window.localStorage.getItem(keyName);
            return value ? JSON.parse(value) : defaultValue;
        } catch (err) {
            return defaultValue;
        }
    });
    const setValue = (newValue)=>{
        try {
            window.sessionStorage.setItem(keyName, JSON.stringify(newValue));
        } finally{
            setStoredValue(newValue);
        }
    };
    return [
        storedValue,
        setValue
    ];
}




function $333b236b3ad1062b$export$573a18d76ffbd3e3(authData) {
    return (0, $73d46209e4d80851$export$b410431fab84fa58).promise(fetch("/.netlify/functions/authUser", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(authData)
    }).then(async (response)=>{
        if (response.status !== 200) {
            const error = await response.json().catch(()=>({
                    message: "Error signing in"
                }));
            throw new Error(error.message);
        }
        return response;
    }), {
        pending: `Signing in User...`,
        success: "Signed In successfully!",
        error: {
            render ({ data: error }) {
                return `Sign-In failed: ${error?.message}`;
            }
        }
    }, (0, $6724d57570dc2c5f$export$8eb3892b442747bd));
}
function $333b236b3ad1062b$export$2b85b721e524d74b(address) {
    return (0, $73d46209e4d80851$export$b410431fab84fa58).promise(fetch(`/.netlify/functions/getNonce?address=${address}`, {
        method: "GET"
    }).then(async (response)=>{
        if (response.status !== 200) {
            const error = await response.json().catch(()=>({
                    message: "Error getting nonce"
                }));
            throw new Error(error.message);
        }
        return response;
    }), {
        error: {
            render ({ data: error }) {
                return `${error?.message}`;
            }
        }
    }, (0, $6724d57570dc2c5f$export$8eb3892b442747bd));
}



const $bc945762aaa88e21$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
`;
const $bc945762aaa88e21$var$StyledInfo = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).p`
  margin: 0;
  padding: 0;
`;
const $bc945762aaa88e21$export$997aa44fa3e3c31 = ({ children: children, message: message, buttonText: buttonText, className: className })=>{
    const localToken = window.sessionStorage.getItem("auth-token");
    const [isLoading, setIsLoading] = (0, $9nZCP.useState)(false);
    const [authToken, setAuthToken] = (0, $9a96efbd4cf69239$export$864b6828bd07eda6)("auth-token", localToken);
    const { address: address } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    const { chain: chain } = (0, $b9a08c139e2d6879$export$553aaf59afc1a2d8)();
    const { signMessageAsync: signMessageAsync } = (0, $b9a08c139e2d6879$export$2ec0271a2697cc5f)();
    const isVerified = (0, $9nZCP.useMemo)(()=>{
        if (!authToken || !address) return false;
        const payload = $1c2de5312649639f$export$dcef71b8fb9a6794(authToken);
        if (payload?.id.toLowerCase() !== address.toLowerCase()) return false;
        if (payload.exp && payload.exp < Date.now() / 1000) return false;
        return true;
    }, [
        authToken,
        address
    ]);
    const handleSignIn = async ()=>{
        try {
            setIsLoading(true);
            if (!address) return;
            const message = await $bc945762aaa88e21$var$createSiweMessage(address, "Sign In to Kleros with Ethereum.", chain?.id);
            const signature = await signMessageAsync({
                message: message
            });
            if (!signature) return;
            (0, $333b236b3ad1062b$export$573a18d76ffbd3e3)({
                address: address,
                signature: signature,
                message: message
            }).then(async (res)=>{
                const response = await res.json();
                setAuthToken(response["token"]);
            }).catch((err)=>console.log({
                    err: err
                })).finally(()=>setIsLoading(false));
        } catch (err) {
            setIsLoading(false);
            console.log({
                err: err
            });
        }
    };
    return isVerified ? children : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($bc945762aaa88e21$var$Container, {
        children: [
            message ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($bc945762aaa88e21$var$StyledInfo, {
                children: message
            }) : null,
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.Button), {
                text: buttonText ?? "Sign In",
                onClick: handleSignIn,
                disabled: isLoading,
                isLoading: isLoading,
                className: className
            })
        ]
    });
};
async function $bc945762aaa88e21$var$createSiweMessage(address, statement, chainId = (0, $a5583d98c7d1626b$export$8372812df8e8183f)) {
    const domain = window.location.host;
    const origin = window.location.origin;
    const response = await (0, $333b236b3ad1062b$export$2b85b721e524d74b)(address);
    const nonce = (await response.json()).nonce;
    // signature is valid only for 10 mins
    const expirationTime = new Date(Date.now() + 600000).toISOString();
    const message = new (0, $28932740830c95c9$exports.SiweMessage)({
        domain: domain,
        address: address,
        statement: statement,
        uri: origin,
        version: "1",
        chainId: chainId,
        nonce: nonce,
        expirationTime: expirationTime
    });
    return message.prepareMessage();
}


const $9c8d37820594bb85$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
`;
const $9c8d37820594bb85$var$HeaderContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme: theme })=>theme.primaryText};
  margin-top: 16px;
  margin-bottom: 12px;
`;
const $9c8d37820594bb85$var$HeaderNotifs = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($9c8d37820594bb85$var$HeaderContainer, {
        children: "Contact Details"
    });
};
const $9c8d37820594bb85$var$EnsureChainContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  padding-top: 16px;
  padding-bottom: 16px;
`;
const $9c8d37820594bb85$var$NotificationSettings = ({ toggleIsSettingsOpen: toggleIsSettingsOpen })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($9c8d37820594bb85$var$EnsureChainContainer, {
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $c94a24f44dbbed94$export$c640ece8678a7df5), {
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($9c8d37820594bb85$var$Container, {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $bc945762aaa88e21$export$997aa44fa3e3c31), {
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($9c8d37820594bb85$var$HeaderNotifs, {}),
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $29f743294007a17a$export$2e2bcd8739ae039), {
                                toggleIsSettingsOpen: toggleIsSettingsOpen
                            })
                        ]
                    })
                })
            })
        })
    });
};
var $9c8d37820594bb85$export$2e2bcd8739ae039 = $9c8d37820594bb85$var$NotificationSettings;



const $36740e8f41018c39$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  position: absolute;
  max-height: 80vh;
  overflow-y: auto;
  background-color: ${({ theme: theme })=>theme.whiteBackground};
  flex-direction: column;
  top: 5%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  background-color: ${({ theme: theme })=>theme.whiteBackground};
  border: 1px solid ${({ theme: theme })=>theme.stroke};
  border-radius: 3px;
  overflow-y: auto;

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      margin-top: 64px;
      top: 0;
      right: 0;
      left: auto;
      transform: none;
    `)}
`;
const $36740e8f41018c39$var$StyledSettingsText = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  font-size: 24px;
  color: ${({ theme: theme })=>theme.primaryText};
  margin-top: 24px;
`;
const $36740e8f41018c39$var$StyledTabs = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Tabs))`
  padding: 0 calc(8px + (32 - 8) * ((100vw - 300px) / (1250 - 300)));
  width: 86vw;
  max-width: 660px;

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      width: calc(300px + (424 - 300) * ((100vw - 300px) / (1250 - 300)));
    `)}
`;
const $36740e8f41018c39$var$TABS = [
    {
        text: "General",
        value: 0
    },
    {
        text: "Notifications",
        value: 1
    }
];
const $36740e8f41018c39$var$Settings = ({ toggleIsSettingsOpen: toggleIsSettingsOpen })=>{
    const [currentTab, setCurrentTab] = (0, $9nZCP.useState)(0);
    const containerRef = (0, $9nZCP.useRef)(null);
    (0, $0aa9c5ea5f98ac89$export$2e2bcd8739ae039)(containerRef, ()=>toggleIsSettingsOpen());
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $a4e24e3c9f4f276a$export$c6fdb837b070b4ff), {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($36740e8f41018c39$var$Container, {
                ref: containerRef,
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($36740e8f41018c39$var$StyledSettingsText, {
                        children: "Settings"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($36740e8f41018c39$var$StyledTabs, {
                        currentValue: currentTab,
                        items: $36740e8f41018c39$var$TABS,
                        callback: (n)=>{
                            setCurrentTab(n);
                        }
                    }),
                    currentTab === 0 ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $41d19829f2affbae$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $9c8d37820594bb85$export$2e2bcd8739ae039), {
                        toggleIsSettingsOpen: toggleIsSettingsOpen
                    })
                ]
            })
        ]
    });
};
var $36740e8f41018c39$export$2e2bcd8739ae039 = $36740e8f41018c39$var$Settings;




const $5dbac9da6e36c8e8$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 64px;
  left: 0;
  right: 0;
  max-height: calc(100vh - 64px);
  overflow-y: auto;
  z-index: 1;
  background-color: ${({ theme: theme })=>theme.whiteBackground};
  border: 1px solid ${({ theme: theme })=>theme.stroke};
  box-shadow: 0px 2px 3px ${({ theme: theme })=>theme.defaultShadow};
  transform-origin: top;
  transform: scaleY(${({ isOpen: isOpen })=>isOpen ? "1" : "0"});
  visibility: ${({ isOpen: isOpen })=>isOpen ? "visible" : "hidden"};
  transition-property: transform, visibility;
  transition-duration: ${({ theme: theme })=>theme.transitionSpeed};
  transition-timing-function: ease;
  padding: 24px;

  hr {
    margin: 24px 0;
  }
`;
const $5dbac9da6e36c8e8$var$WalletContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 16px;
  justify-content: space-between;
  flex-wrap: wrap;
`;
const $5dbac9da6e36c8e8$var$DisconnectWalletButtonContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
`;
const $5dbac9da6e36c8e8$var$NavBar = ()=>{
    const { isConnected: isConnected } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    const [isDappListOpen, toggleIsDappListOpen] = (0, $b2e41656ab938cc0$export$2e2bcd8739ae039)(false);
    const [isHelpOpen, toggleIsHelpOpen] = (0, $b2e41656ab938cc0$export$2e2bcd8739ae039)(false);
    const [isSettingsOpen, toggleIsSettingsOpen] = (0, $b2e41656ab938cc0$export$2e2bcd8739ae039)(false);
    const { isOpen: isOpen } = (0, $1d8f19168641006a$export$25b6956486120489)();
    (0, $576ec816832a2b72$export$eb909a3d9177a60d)(isOpen);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($5dbac9da6e36c8e8$var$Container, {
                isOpen: isOpen,
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $072682708a04db72$export$2e2bcd8739ae039), {
                        text: "Kleros Solutions",
                        onClick: ()=>{
                            toggleIsDappListOpen();
                        },
                        Icon: (0, $d0e9659fd2942e08$export$2e2bcd8739ae039)
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $45e069354dfffd94$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($5dbac9da6e36c8e8$var$WalletContainer, {
                        children: [
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $114c356563326614$export$2e2bcd8739ae039), {}),
                            isConnected && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($5dbac9da6e36c8e8$var$DisconnectWalletButtonContainer, {
                                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $41d19829f2affbae$export$c604e936fdf27a02), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $580a8ca79c84a57d$export$2e2bcd8739ae039), {
                        toggleIsHelpOpen: toggleIsHelpOpen,
                        toggleIsSettingsOpen: toggleIsSettingsOpen
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("br", {})
                ]
            }),
            (isDappListOpen || isHelpOpen || isSettingsOpen) && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $fd235df91044b04f$export$cca08eed9de89ba9), {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $a4e24e3c9f4f276a$export$c6fdb837b070b4ff), {}),
                    isDappListOpen && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $d848e91eca145ac8$export$2e2bcd8739ae039), {
                        toggleIsDappListOpen: toggleIsDappListOpen
                    }),
                    isHelpOpen && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $545dc5bc6e41aec9$export$2e2bcd8739ae039), {
                        toggleIsHelpOpen: toggleIsHelpOpen
                    }),
                    isSettingsOpen && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $36740e8f41018c39$export$2e2bcd8739ae039), {
                        toggleIsSettingsOpen: toggleIsSettingsOpen
                    })
                ]
            })
        ]
    });
};
var $5dbac9da6e36c8e8$export$2e2bcd8739ae039 = $5dbac9da6e36c8e8$var$NavBar;


const $1d8f19168641006a$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      display: none;
    `)}
`;
const $1d8f19168641006a$var$StyledLightButton = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $072682708a04db72$export$2e2bcd8739ae039))`
  padding: 0;

  .button-svg {
    margin-right: 0px;
    fill: white;
  }
  .button-text {
    display: none;
  }
`;
const $1d8f19168641006a$var$StyledLink = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $544fc37a064f4916$export$a6c7ac8248d6e38a))`
  min-height: 48px;
`;
const $1d8f19168641006a$var$OpenContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createContext({
    isOpen: false,
    toggleIsOpen: ()=>{
    // Placeholder
    }
});
function $1d8f19168641006a$export$25b6956486120489() {
    return (0, $9nZCP.useContext)($1d8f19168641006a$var$OpenContext);
}
const $1d8f19168641006a$var$MobileHeader = ()=>{
    const [isOpen, toggleIsOpen] = (0, $b2e41656ab938cc0$export$2e2bcd8739ae039)(false);
    const containerRef = (0, $9nZCP.useRef)(null);
    (0, $0aa9c5ea5f98ac89$export$2e2bcd8739ae039)(containerRef, ()=>toggleIsOpen(false));
    const memoizedContext = (0, $9nZCP.useMemo)(()=>({
            isOpen: isOpen,
            toggleIsOpen: toggleIsOpen
        }), [
        isOpen,
        toggleIsOpen
    ]);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($1d8f19168641006a$var$Container, {
        ref: containerRef,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($1d8f19168641006a$var$OpenContext.Provider, {
            value: memoizedContext,
            children: [
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($1d8f19168641006a$var$StyledLink, {
                    to: "/",
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $73eb9db2706756f0$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $5dbac9da6e36c8e8$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($1d8f19168641006a$var$StyledLightButton, {
                    text: "",
                    Icon: (0, $5076370542e920f6$export$2e2bcd8739ae039),
                    onClick: toggleIsOpen
                })
            ]
        })
    });
};
var $1d8f19168641006a$export$2e2bcd8739ae039 = $1d8f19168641006a$var$MobileHeader;



parcelRequire("9nZCP");
















const $d069b501fd860bcb$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: none;
  position: absolute;

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      position: relative;
    `)};
`;
const $d069b501fd860bcb$var$LeftSide = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $d069b501fd860bcb$var$MiddleSide = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: ${({ theme: theme })=>theme.white} !important;
`;
const $d069b501fd860bcb$var$RightSide = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  gap: calc(8px + (16 - 8) * ((100vw - 300px) / (1024 - 300)));
  margin-left: 8px;
  canvas {
    width: 20px;
  }
`;
const $d069b501fd860bcb$var$LightButtonContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 16px;
  margin-left: calc(4px + (8 - 4) * ((100vw - 375px) / (1250 - 375)));
  margin-right: calc(12px + (16 - 12) * ((100vw - 375px) / (1250 - 375)));
`;
const $d069b501fd860bcb$var$StyledLink = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $544fc37a064f4916$export$a6c7ac8248d6e38a))`
  min-height: 48px;
`;
const $d069b501fd860bcb$var$StyledKlerosSolutionsIcon = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $d0e9659fd2942e08$export$2e2bcd8739ae039))`
  fill: ${({ theme: theme })=>theme.white} !important;
`;
const $d069b501fd860bcb$var$ConnectWalletContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  label {
    color: ${({ theme: theme })=>theme.white};
  }
`;
const $d069b501fd860bcb$var$DesktopHeader = ()=>{
    const [isDappListOpen, toggleIsDappListOpen] = (0, $b2e41656ab938cc0$export$2e2bcd8739ae039)(false);
    const [isHelpOpen, toggleIsHelpOpen] = (0, $b2e41656ab938cc0$export$2e2bcd8739ae039)(false);
    const [isSettingsOpen, toggleIsSettingsOpen] = (0, $b2e41656ab938cc0$export$2e2bcd8739ae039)(false);
    (0, $576ec816832a2b72$export$eb909a3d9177a60d)(isDappListOpen || isHelpOpen || isSettingsOpen);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($d069b501fd860bcb$var$Container, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($d069b501fd860bcb$var$LeftSide, {
                        children: [
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($d069b501fd860bcb$var$LightButtonContainer, {
                                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $072682708a04db72$export$2e2bcd8739ae039), {
                                    text: "",
                                    onClick: ()=>{
                                        toggleIsDappListOpen();
                                    },
                                    Icon: $d069b501fd860bcb$var$StyledKlerosSolutionsIcon
                                })
                            }),
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($d069b501fd860bcb$var$StyledLink, {
                                to: "/",
                                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $73eb9db2706756f0$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($d069b501fd860bcb$var$MiddleSide, {
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $45e069354dfffd94$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($d069b501fd860bcb$var$RightSide, {
                        children: [
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($d069b501fd860bcb$var$ConnectWalletContainer, {
                                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $114c356563326614$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $580a8ca79c84a57d$export$2e2bcd8739ae039), {
                                toggleIsHelpOpen: toggleIsHelpOpen,
                                toggleIsSettingsOpen: toggleIsSettingsOpen
                            })
                        ]
                    })
                ]
            }),
            (isDappListOpen || isHelpOpen || isSettingsOpen) && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $fd235df91044b04f$export$cca08eed9de89ba9), {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $a4e24e3c9f4f276a$export$c6fdb837b070b4ff), {}),
                    isDappListOpen && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $d848e91eca145ac8$export$2e2bcd8739ae039), {
                        toggleIsDappListOpen: toggleIsDappListOpen,
                        isDappListOpen: isDappListOpen
                    }),
                    isHelpOpen && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $545dc5bc6e41aec9$export$2e2bcd8739ae039), {
                        toggleIsHelpOpen: toggleIsHelpOpen,
                        isHelpOpen: isHelpOpen
                    }),
                    isSettingsOpen && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $36740e8f41018c39$export$2e2bcd8739ae039), {
                        toggleIsSettingsOpen: toggleIsSettingsOpen,
                        isSettingsOpen: isSettingsOpen
                    })
                ]
            })
        ]
    });
};
var $d069b501fd860bcb$export$2e2bcd8739ae039 = $d069b501fd860bcb$var$DesktopHeader;


const $fd235df91044b04f$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  position: sticky;
  z-index: 1;
  top: 0;
  width: 100%;
  height: 64px;
  background-color: ${({ theme: theme })=>theme.primaryPurple};

  padding: 0 24px;
  display: flex;
`;
const $fd235df91044b04f$export$cca08eed9de89ba9 = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 30;
`;
const $fd235df91044b04f$var$Header = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($fd235df91044b04f$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $d069b501fd860bcb$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $1d8f19168641006a$export$2e2bcd8739ae039), {})
        ]
    });
};
var $fd235df91044b04f$export$2e2bcd8739ae039 = $fd235df91044b04f$var$Header;



parcelRequire("9nZCP");



parcelRequire("9nZCP");
const $518c25c0c8ce7e41$var$SvgSecuredByKleros = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 179,
        height: 24,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
            clipPath: "url('4eaa28e75c5b30a5')",
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#fff",
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M5.598 13.86c0 .779-.281 1.39-.844 1.833-.562.443-1.337.664-2.326.664-.989 0-1.798-.153-2.428-.46v-1.354c.399.188.821.336 1.268.443.45.108.869.162 1.256.162.566 0 .982-.108 1.25-.323.27-.216.406-.505.406-.869 0-.327-.123-.604-.37-.832-.248-.227-.758-.497-1.531-.808-.798-.324-1.36-.693-1.687-1.108-.327-.415-.49-.914-.49-1.497 0-.73.259-1.305.777-1.724.518-.42 1.214-.63 2.087-.63.838 0 1.67.185 2.5.552l-.454 1.167c-.778-.327-1.472-.49-2.082-.49-.462 0-.813.101-1.052.305a.985.985 0 0 0-.359.796c0 .228.048.423.144.587.095.16.253.311.472.455.22.144.614.333 1.184.569.642.267 1.112.517 1.411.748a2.2 2.2 0 0 1 .658.785c.14.291.21.634.21 1.03Zm6.638 2.378H7.29V7.484h4.946v1.21H8.72v2.383h3.295v1.197H8.72v2.749h3.516v1.215Zm3.679-6.778c.47-.583 1.116-.875 1.937-.875.363 0 .708.054 1.035.162.33.104.644.226.939.365l.514-1.191a5.5 5.5 0 0 0-2.476-.563c-.85 0-1.588.182-2.219.545a3.584 3.584 0 0 0-1.447 1.569c-.33.682-.496 1.479-.496 2.389 0 1.445.343 2.556 1.028 3.335.686.774 1.669 1.161 2.949 1.161.869 0 1.646-.13 2.332-.389v-1.227c-.375.116-.735.211-1.082.287a5.299 5.299 0 0 1-1.077.108c-.857 0-1.513-.276-1.967-.826-.45-.551-.676-1.364-.676-2.437 0-1.026.235-1.83.706-2.413ZM28.75 7.484v5.665c0 .646-.14 1.213-.42 1.7a2.773 2.773 0 0 1-1.201 1.12c-.523.26-1.149.389-1.878.389-1.085 0-1.928-.288-2.53-.862-.602-.575-.903-1.366-.903-2.372v-5.64h1.435v5.539c0 .722.168 1.255.503 1.598.335.344.849.515 1.543.515 1.347 0 2.021-.708 2.021-2.125V7.484h1.43Zm4.656 4.072h-.992V8.694h.944c.65 0 1.137.107 1.46.323.323.216.484.57.484 1.066 0 .487-.15.854-.448 1.101-.3.248-.782.372-1.448.372Zm-.992 4.682v-3.497h1.411l2.093 3.497h1.627l-2.47-3.874c1.132-.463 1.698-1.24 1.698-2.33 0-.853-.27-1.492-.813-1.915-.542-.423-1.377-.635-2.506-.635h-2.47v8.754h1.43Zm11.35 0h-4.946V7.484h4.945v1.21h-3.516v2.383h3.295v1.197h-3.295v2.749h3.516v1.215Zm7.806-1.144c.801-.766 1.202-1.872 1.202-3.317 0-1.36-.387-2.417-1.16-3.167-.773-.75-1.856-1.126-3.247-1.126H45.66v8.754h2.446c1.507 0 2.662-.381 3.463-1.144ZM48.33 8.682c1.957 0 2.936 1.048 2.936 3.143 0 2.14-1.053 3.21-3.158 3.21h-1.016V8.682h1.238Zm9.555-1.198h2.47c1.16 0 1.999.174 2.517.521.518.347.778.896.778 1.647 0 .519-.146.948-.437 1.287-.287.335-.708.553-1.262.653v.06c1.328.227 1.992.926 1.992 2.095 0 .783-.266 1.393-.796 1.832-.526.44-1.264.66-2.212.66h-3.05V7.483Zm1.016 3.748h1.675c.717 0 1.234-.111 1.549-.335.315-.228.472-.609.472-1.144 0-.49-.175-.844-.526-1.06-.351-.219-.91-.329-1.675-.329H58.9v2.868Zm0 .863v3.275h1.824c.706 0 1.236-.136 1.591-.407.359-.276.538-.705.538-1.288 0-.543-.183-.942-.55-1.197-.363-.256-.917-.383-1.662-.383H58.9Zm11.482-4.61L68.05 11.86l-2.314-4.377h-1.113l2.913 5.407v3.347h1.028v-3.395l2.919-5.359h-1.1ZM91.387 0l13.567.607 5.494 12.223-7.75 11.17-13.641-.875-5.593-13.243L91.387 0Zm9.947 7.045-9.833 4.303 8.406 6.508 1.427-10.81Zm-1.138-2.156-7.858-3.388-1.651 7.124 9.509-3.736Zm-1.992 14.605-8.54-6.107.206 8.276 8.334-2.169Zm10.88-6.691-5.82-5.914-1.537 11.372 7.357-5.458Zm-8.878 8.021-7.202 1.886 8.47.543-1.268-2.428Zm7.74-5.338-6.304 4.703 1.253 2.452 5.051-7.155Zm-2.982-13.171-1.225 2.518 4.558 4.64-3.333-7.158Zm-1.525-1.205L95.434.785l6.603 2.892 1.402-2.567Zm-13.22 1.164-5.607 7.09 3.748.795 1.858-7.885Zm-2.085 9.276-3.766-.799 3.93 9.272-.164-8.473ZM119.791 11.154h-.456V7.095h-1.22v9.525h1.22v-4.46h.42l3.843 4.698.928-.786-3.697-4.48 3.151-4.003-.929-.731-3.26 4.296Zm10.619-4.059h-1.221v9.525h6.192v-1.097h-4.971V7.095Zm9.469 0h5.919v1.097h-4.699v2.852h3.879v1.097h-3.879v3.382h4.699v1.097h-5.919V7.095Zm14.005 0h-3.224v9.525h1.221v-4.077h1.767l2.421 4.315 1.056-.64-2.33-3.858c1.146-.347 1.929-1.499 1.929-2.669 0-1.846-1.256-2.596-2.84-2.596Zm1.565 2.596c0 1.08-.783 1.755-1.965 1.755h-1.603V8.192h1.965c1.094 0 1.603.64 1.603 1.5Zm12.259 2.175c0 .768-.055 4.918-3.37 4.918-1.53 0-3.369-1.096-3.369-4.918 0-3.802 1.804-4.936 3.369-4.936 1.512 0 3.37 1.097 3.37 4.936Zm-5.464 0c0 1.39.255 3.767 2.094 3.767 1.84 0 2.095-2.377 2.095-3.767 0-1.407-.255-3.784-2.095-3.784-1.839 0-2.094 2.377-2.094 3.784Zm13.113 3.767c-1.275 0-1.84-.86-2.077-2.03l-1.092.348c.292 1.7 1.402 2.833 3.169 2.833 1.748 0 3.006-1.024 3.006-2.833 0-.988-.457-1.756-1.312-2.23l-2.022-.897c-.728-.329-1.275-.585-1.275-1.48 0-.86.765-1.262 1.548-1.262 1.039 0 1.53.658 1.749 1.59l1.166-.347c-.383-1.48-1.312-2.395-2.897-2.395-1.493 0-2.786.896-2.786 2.505 0 1.634 1.091 2.082 2.333 2.592l.362.15c.076.032.153.062.229.093.855.345 1.683.68 1.683 1.754 0 1.06-.782 1.609-1.784 1.609Z"
            })
        })
    });
var $518c25c0c8ce7e41$export$2e2bcd8739ae039 = $518c25c0c8ce7e41$var$SvgSecuredByKleros;



parcelRequire("9nZCP");

parcelRequire("9nZCP");
const $ce2c0e024eb095af$var$SvgEtherscan = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
            clipPath: "url('4ccc07b2e7184681')",
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M3.973 7.358a.679.679 0 0 0-.052.26v4.24a.566.566 0 0 1-.5.562c-.318.037-.584.064-.798.082a1.011 1.011 0 0 1-.965-.5A7.977 7.977 0 0 1 .596 8.002c0-4.438 3.665-8.06 8.1-8a7.982 7.982 0 0 1 7.443 5.394 1.14 1.14 0 0 1-.173 1.064c-.79 1.03-1.784 1.885-2.765 2.596V4.226a.68.68 0 0 0-.679-.679H11.39a.678.678 0 0 0-.679.68v5.863a.567.567 0 0 1-.346.522c-.276.117-.559.231-.559.231V5.925a.68.68 0 0 0-.679-.68H7.995a.679.679 0 0 0-.679.68v5.3a.566.566 0 0 1-.436.55 8.952 8.952 0 0 0-.469.12V7.623a.68.68 0 0 0-.679-.68l-1.13-.003a.678.678 0 0 0-.629.418Zm-.076 7.112Zm0 0a7.994 7.994 0 0 0 12.678-7.017C13.654 11.812 8.26 13.85 3.897 14.47Z"
            })
        })
    });
var $ce2c0e024eb095af$export$2e2bcd8739ae039 = $ce2c0e024eb095af$var$SvgEtherscan;



parcelRequire("9nZCP");
const $246489cf72909fd1$var$SvgGithub = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
            clipPath: "url('49dde1e5b9516625')",
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M5.948 12.964c0 .062-.074.111-.168.111-.106.01-.18-.04-.18-.11 0-.062.074-.111.167-.111.097-.01.18.04.18.11Zm-1.003-.138c-.023.062.042.132.138.15.084.031.18 0 .2-.06.02-.062-.042-.133-.138-.16-.084-.022-.178.009-.2.07Zm1.425-.052c-.093.022-.158.08-.148.15.01.062.094.102.19.08.094-.021.158-.08.149-.14-.01-.06-.097-.1-.19-.09ZM8.493 1C4.019 1 .596 4.235.596 8.497c0 3.408 2.252 6.323 5.468 7.35.413.07.558-.172.558-.372 0-.19-.01-1.242-.01-1.887 0 0-2.258.461-2.732-.915 0 0-.368-.895-.897-1.125 0 0-.738-.482.052-.473 0 0 .803.061 1.245.793.707 1.186 1.89.845 2.352.642.074-.492.284-.833.516-1.036-1.803-.19-3.623-.439-3.623-3.395 0-.845.245-1.269.762-1.81-.084-.2-.359-1.023.083-2.086.675-.2 2.226.83 2.226.83a7.934 7.934 0 0 1 2.026-.261c.687 0 1.38.089 2.026.26 0 0 1.551-1.032 2.226-.829.441 1.066.167 1.887.083 2.087.517.543.833.967.833 1.81 0 2.964-1.9 3.2-3.704 3.394.297.243.549.704.549 1.426 0 1.035-.01 2.317-.01 2.569 0 .2.149.442.558.371 3.226-1.02 5.413-3.935 5.413-7.343C16.596 4.235 12.967 1 8.493 1ZM3.732 11.597c-.042.031-.033.102.022.16.052.05.126.07.168.03.042-.03.032-.1-.023-.159-.051-.05-.125-.07-.167-.03Zm-.349-.249c-.022.04.01.09.074.12.052.03.117.022.14-.021.022-.04-.01-.09-.075-.12-.065-.019-.116-.01-.139.021Zm1.045 1.094c-.051.04-.032.132.042.19.075.071.168.08.21.031.042-.04.023-.132-.042-.19-.07-.07-.168-.08-.21-.03Zm-.367-.451c-.052.03-.052.11 0 .18.051.072.138.102.18.072.052-.04.052-.12 0-.191-.045-.07-.129-.101-.18-.061Z"
            })
        })
    });
var $246489cf72909fd1$export$2e2bcd8739ae039 = $246489cf72909fd1$var$SvgGithub;



parcelRequire("9nZCP");
const $14b9ccbfda6c7470$var$SvgSnapshot = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
            clipPath: "url('fefcbdae7ee14c9f')",
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M1.734 8.646 11.604.1c.332-.288.816.098.61.486L8.99 6.633h5.601c.369 0 .538.459.258.698l-10.012 8.57c-.332.285-.812-.098-.61-.484l3.178-6.074H1.993a.396.396 0 0 1-.26-.697Z"
            })
        })
    });
var $14b9ccbfda6c7470$export$2e2bcd8739ae039 = $14b9ccbfda6c7470$var$SvgSnapshot;



parcelRequire("9nZCP");
const $13f8bae70bc1ba01$var$SvgDiscord = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
            clipPath: "url('269469ff037164bd')",
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M14.162 3.011a.04.04 0 0 0-.021-.018A13.375 13.375 0 0 0 10.884 2a.05.05 0 0 0-.052.024c-.15.266-.285.539-.406.818a12.405 12.405 0 0 0-3.657 0 8.214 8.214 0 0 0-.412-.818.051.051 0 0 0-.053-.024c-1.124.19-2.22.524-3.257.992a.046.046 0 0 0-.021.018C.952 6.053.384 9.02.662 11.95a.053.053 0 0 0 .021.037 13.366 13.366 0 0 0 3.995 1.983.053.053 0 0 0 .057-.018 9.28 9.28 0 0 0 .817-1.306.049.049 0 0 0-.01-.058.052.052 0 0 0-.018-.01 8.804 8.804 0 0 1-1.248-.585.051.051 0 0 1-.025-.04.05.05 0 0 1 .02-.043c.084-.062.168-.126.248-.191a.05.05 0 0 1 .052-.007c2.618 1.174 5.453 1.174 8.04 0a.05.05 0 0 1 .053.006c.08.065.164.13.248.192a.049.049 0 0 1 .016.019.049.049 0 0 1-.003.047.05.05 0 0 1-.017.017 8.265 8.265 0 0 1-1.249.584.051.051 0 0 0-.03.029.049.049 0 0 0 .003.04c.24.454.512.89.817 1.305a.05.05 0 0 0 .056.019 13.32 13.32 0 0 0 4.001-1.983.05.05 0 0 0 .021-.036c.334-3.388-.558-6.332-2.365-8.94Zm-8.22 7.156c-.787 0-1.437-.71-1.437-1.583S5.142 7 5.943 7c.807 0 1.45.717 1.438 1.584 0 .872-.637 1.583-1.438 1.583Zm5.317 0c-.788 0-1.438-.71-1.438-1.583S10.46 7 11.26 7c.808 0 1.45.717 1.438 1.584 0 .872-.63 1.583-1.438 1.583Z"
            })
        })
    });
var $13f8bae70bc1ba01$export$2e2bcd8739ae039 = $13f8bae70bc1ba01$var$SvgDiscord;



parcelRequire("9nZCP");
const $518c00318ff33187$var$SvgX = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 17,
        height: 16,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M12.92 2h2.207l-4.819 5.506L15.977 15h-4.438l-3.478-4.544L4.086 15h-2.21L7.03 9.11 1.596 2h4.55l3.14 4.153L12.921 2Zm-.774 11.681h1.222L5.48 3.251H4.168l7.978 10.43Z"
        })
    });
var $518c00318ff33187$export$2e2bcd8739ae039 = $518c00318ff33187$var$SvgX;



parcelRequire("9nZCP");
const $b414c35f3cf37f1f$var$SvgReddit = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
            clipPath: "url('f98a54531b2686d6')",
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M14.812 5.787c-.506 0-.951.21-1.278.536-1.204-.833-2.826-1.369-4.623-1.426L9.845.688l2.974.668c0 .728.593 1.322 1.322 1.322.742 0 1.339-.61 1.339-1.34C15.48.612 14.886 0 14.14 0c-.518 0-.967.314-1.19.742L9.666.014C9.5-.03 9.339.088 9.295.253L8.27 4.893c-1.784.075-3.39.61-4.597 1.444-.327-.34-.789-.55-1.295-.55-1.875 0-2.488 2.516-.772 3.376-.06.266-.088.55-.088.833 0 2.826 3.184 5.115 7.092 5.115 3.926 0 7.11-2.29 7.11-5.115 0-.284-.031-.58-.105-.847 1.682-.863 1.062-3.362-.803-3.362ZM4.328 9.341c0-.742.593-1.338 1.338-1.338.729 0 1.322.593 1.322 1.338 0 .729-.593 1.322-1.322 1.322a1.328 1.328 0 0 1-1.338-1.322Zm7.226 3.154c-1.227 1.227-4.69 1.227-5.918 0-.135-.118-.135-.328 0-.462a.324.324 0 0 1 .445 0c.938.96 4.047.977 5.025 0a.324.324 0 0 1 .445 0c.138.134.138.344.003.462Zm-.027-1.828a1.324 1.324 0 0 1-1.321-1.322 1.33 1.33 0 1 1 1.321 1.322Z"
            })
        })
    });
var $b414c35f3cf37f1f$export$2e2bcd8739ae039 = $b414c35f3cf37f1f$var$SvgReddit;




parcelRequire("9nZCP");
const $c6d9f4b2d838cf18$var$SvgGhostBlog = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
            clipPath: "url('b54c4412cafcc6dc')",
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M.596 1.5a1.5 1.5 0 0 1 1.5-1.5h6.412a1.5 1.5 0 0 1 1.5 1.5v.294a1.5 1.5 0 0 1-1.5 1.5H2.096a1.5 1.5 0 0 1-1.5-1.5V1.5Zm12.706.001a1.5 1.5 0 0 1 1.5-1.5h.294a1.5 1.5 0 0 1 1.5 1.5v.294a1.5 1.5 0 0 1-1.5 1.5h-.294a1.5 1.5 0 0 1-1.5-1.5v-.294Zm-1.794 11.205a1.5 1.5 0 0 0-1.5 1.5v.294a1.5 1.5 0 0 0 1.5 1.5h3.588a1.5 1.5 0 0 0 1.5-1.5v-.294a1.5 1.5 0 0 0-1.5-1.5h-3.588Zm-10.912 1.5a1.5 1.5 0 0 1 1.5-1.5h3.588a1.5 1.5 0 0 1 1.5 1.5v.294a1.5 1.5 0 0 1-1.5 1.5H2.096a1.5 1.5 0 0 1-1.5-1.5v-.294Zm1.5-8.088a1.5 1.5 0 0 0-1.5 1.5v.294a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v-.294a1.5 1.5 0 0 0-1.5-1.5h-13Z"
            })
        })
    });
var $c6d9f4b2d838cf18$export$2e2bcd8739ae039 = $c6d9f4b2d838cf18$var$SvgGhostBlog;



parcelRequire("9nZCP");
const $224a7147b996282d$var$SvgLinkedin = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
            clipPath: "url('5208cce1688cc391')",
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M4.165 16H.86V5.318h3.305V16ZM2.511 3.86C1.454 3.86.596 2.983.596 1.923.596.86 1.454 0 2.511 0c1.056 0 1.914.86 1.914 1.922 0 1.06-.858 1.939-1.914 1.939ZM16.538 16h-3.299v-5.2c0-1.24-.025-2.828-1.719-2.828-1.718 0-1.982 1.346-1.982 2.739V16H6.236V5.317h3.17v1.457h.047c.441-.84 1.52-1.725 3.128-1.725 3.345 0 3.96 2.21 3.96 5.082V16h-.003Z"
            })
        })
    });
var $224a7147b996282d$export$2e2bcd8739ae039 = $224a7147b996282d$var$SvgLinkedin;


const $701883916351773b$export$53b9549b1f2be1ec = {
    etherscan: {
        icon: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $ce2c0e024eb095af$export$2e2bcd8739ae039), {}),
        url: ""
    },
    github: {
        icon: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $246489cf72909fd1$export$2e2bcd8739ae039), {}),
        url: "https://github.com/kleros"
    },
    snapshot: {
        icon: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $14b9ccbfda6c7470$export$2e2bcd8739ae039), {}),
        url: "https://snapshot.org/#/kleros.eth"
    },
    discord: {
        icon: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $13f8bae70bc1ba01$export$2e2bcd8739ae039), {}),
        url: "https://discord.com/invite/MhXQGCyHd9"
    },
    x: {
        icon: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $518c00318ff33187$export$2e2bcd8739ae039), {}),
        url: "https://x.com/kleros_io"
    },
    reddit: {
        icon: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $b414c35f3cf37f1f$export$2e2bcd8739ae039), {}),
        url: "https://www.reddit.com/r/Kleros/"
    },
    telegram: {
        icon: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $2e4ec0f6cbd86dc5$export$2e2bcd8739ae039), {}),
        url: "https://t.me/kleros"
    },
    ghost: {
        icon: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $c6d9f4b2d838cf18$export$2e2bcd8739ae039), {}),
        url: "https://blog.kleros.io/"
    },
    linkedin: {
        icon: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $224a7147b996282d$export$2e2bcd8739ae039), {}),
        url: "https://www.linkedin.com/company/kleros/"
    }
};


const $d973822dfd52df3a$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  height: 122px;
  width: 100%;
  background-color: ${({ theme: theme })=>theme.primaryPurple};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 32px 8px 32px;
  gap: 24px;

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      height: 64px;
      flex-direction: row;
      justify-content: space-between;
      padding-bottom: 0;
    `)}

  .secured-by-kleros {
    min-height: 24px;
  }

  .socialmedia {
    display: flex;
    gap: 16px;
    justify-content: center;

    a {
      display: inline-block;
      svg {
        height: 16px;
        width: 16px;
        max-heigth: 16px;
        max-width: 16px;
        fill: white;
      }
    }
  }
`;
const $d973822dfd52df3a$var$SecuredByKleros = ()=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("a", {
        className: "secured-by-kleros",
        href: "https://kleros.io",
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $518c25c0c8ce7e41$export$2e2bcd8739ae039), {})
    });
const $d973822dfd52df3a$var$SocialMedia = ()=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("div", {
        className: "socialmedia",
        children: Object.values((0, $701883916351773b$export$53b9549b1f2be1ec)).map((site, i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("a", {
                href: site.url,
                target: "_blank",
                rel: "noreferrer",
                children: site.icon
            }, i))
    });
const $d973822dfd52df3a$var$Footer = ()=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($d973822dfd52df3a$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($d973822dfd52df3a$var$SecuredByKleros, {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($d973822dfd52df3a$var$SocialMedia, {})
        ]
    });
var $d973822dfd52df3a$export$2e2bcd8739ae039 = $d973822dfd52df3a$var$Footer;


const $edb852177c47345e$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 100%;
`;
const $edb852177c47345e$var$StyledOverlayScrollbarsComponent = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $c29e5efe25af74ec$export$5c3912403b9b36ce))`
  height: 100vh;
  width: 100vw;
`;
const $edb852177c47345e$var$StyledToastContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $73d46209e4d80851$export$f2815235e76a62b9))`
  padding: 16px;
  padding-top: 70px;
`;
const $edb852177c47345e$var$OutletContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  flex: 1;
  background-color: ${({ theme: theme })=>theme.lightBackground};
`;
const $edb852177c47345e$var$Layout = ()=>{
    const containerRef = (0, $9nZCP.useRef)(null);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e4f593b82d8858f8$export$20b5a34f45062e8b).Provider, {
        value: containerRef,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($edb852177c47345e$var$StyledOverlayScrollbarsComponent, {
            ref: containerRef,
            options: {
                showNativeOverlaidScrollbars: true
            },
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($edb852177c47345e$var$Container, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $fd235df91044b04f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($edb852177c47345e$var$StyledToastContainer, {}),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($edb852177c47345e$var$OutletContainer, {
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cb6812e0fa529c57$export$910ae8079b2c2852), {})
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $d973822dfd52df3a$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
};
var $edb852177c47345e$export$2e2bcd8739ae039 = $edb852177c47345e$var$Layout;



parcelRequire("9nZCP");



var $9nZCP = parcelRequire("9nZCP");

var $9nZCP = parcelRequire("9nZCP");

var $9nZCP = parcelRequire("9nZCP");

var $9nZCP = parcelRequire("9nZCP");
var $a399543db4802594$var$useEffectOnce = function(effect) {
    (0, $9nZCP.useEffect)(effect, []);
};
var $a399543db4802594$export$2e2bcd8739ae039 = $a399543db4802594$var$useEffectOnce;


var $f5a3c617ad9bbda3$var$useUnmount = function(fn) {
    var fnRef = (0, $9nZCP.useRef)(fn);
    // update the ref each render so if it change the newest callback will be invoked
    fnRef.current = fn;
    (0, $a399543db4802594$export$2e2bcd8739ae039)(function() {
        return function() {
            return fnRef.current();
        };
    });
};
var $f5a3c617ad9bbda3$export$2e2bcd8739ae039 = $f5a3c617ad9bbda3$var$useUnmount;


var $b3a29171e603bf30$var$useRafState = function(initialState) {
    var frame = (0, $9nZCP.useRef)(0);
    var _a = (0, $9nZCP.useState)(initialState), state = _a[0], setState = _a[1];
    var setRafState = (0, $9nZCP.useCallback)(function(value) {
        cancelAnimationFrame(frame.current);
        frame.current = requestAnimationFrame(function() {
            setState(value);
        });
    }, []);
    (0, $f5a3c617ad9bbda3$export$2e2bcd8739ae039)(function() {
        cancelAnimationFrame(frame.current);
    });
    return [
        state,
        setRafState
    ];
};
var $b3a29171e603bf30$export$2e2bcd8739ae039 = $b3a29171e603bf30$var$useRafState;



var $3bc11a3cff85be60$var$useWindowSize = function(initialWidth, initialHeight) {
    if (initialWidth === void 0) initialWidth = Infinity;
    if (initialHeight === void 0) initialHeight = Infinity;
    var _a = (0, $b3a29171e603bf30$export$2e2bcd8739ae039)({
        width: (0, $934ed287249205c1$export$4e09c449d6c407f7) ? window.innerWidth : initialWidth,
        height: (0, $934ed287249205c1$export$4e09c449d6c407f7) ? window.innerHeight : initialHeight
    }), state = _a[0], setState = _a[1];
    (0, $9nZCP.useEffect)(function() {
        if (0, $934ed287249205c1$export$4e09c449d6c407f7) {
            var handler_1 = function() {
                setState({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            };
            (0, $934ed287249205c1$export$af631764ddc44097)(window, "resize", handler_1);
            return function() {
                (0, $934ed287249205c1$export$8c8705df4a2dcec9)(window, "resize", handler_1);
            };
        }
    }, []);
    return state;
};
var $3bc11a3cff85be60$export$2e2bcd8739ae039 = $3bc11a3cff85be60$var$useWindowSize;




parcelRequire("9nZCP");

parcelRequire("9nZCP");


const $e5652d9f4b8c73d1$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).h1`
  margin-bottom: 29px;
  width: 84vw;
  text-align: center;

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      width: auto;
    `)}
`;
const $e5652d9f4b8c73d1$var$Header = ({ text: text })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($e5652d9f4b8c73d1$var$Container, {
        children: text
    });
};
var $e5652d9f4b8c73d1$export$2e2bcd8739ae039 = $e5652d9f4b8c73d1$var$Header;




parcelRequire("9nZCP");





var $9nZCP = parcelRequire("9nZCP");
const $fa4dc73a0abb4258$var$NewTransactionContext = /*#__PURE__*/ (0, $9nZCP.createContext)({
    escrowType: "",
    setEscrowType: ()=>{},
    escrowTitle: "",
    setEscrowTitle: ()=>{},
    deliverableText: "",
    setDeliverableText: ()=>{},
    transactionUri: "",
    setTransactionUri: ()=>{},
    isFileUploading: false,
    setIsFileUploading: ()=>{},
    deliverableFile: undefined,
    setDeliverableFile: ()=>{},
    extraDescriptionUri: "",
    setExtraDescriptionUri: ()=>{},
    receivingQuantity: "",
    setReceivingQuantity: ()=>{},
    receivingToken: "",
    setReceivingToken: ()=>{},
    sellerAddress: "",
    setSellerAddress: ()=>{},
    sendingQuantity: "",
    setSendingQuantity: ()=>{},
    sendingToken: {
        address: "native",
        symbol: "",
        logo: ""
    },
    setSendingToken: ()=>{},
    buyerAddress: "",
    setBuyerAddress: ()=>{},
    deadline: "",
    setDeadline: ()=>{},
    notificationEmail: "",
    setNotificationEmail: ()=>{},
    resetContext: ()=>{},
    hasSufficientNativeBalance: true,
    setHasSufficientNativeBalance: ()=>{},
    isRecipientAddressResolved: false,
    setIsRecipientAddressResolved: ()=>{}
});
const $fa4dc73a0abb4258$export$ab0988b836f3e0ac = ()=>(0, $9nZCP.useContext)($fa4dc73a0abb4258$var$NewTransactionContext);
const $fa4dc73a0abb4258$export$28e9744f9c6a92c7 = ({ children: children })=>{
    const [escrowType, setEscrowType] = (0, $9nZCP.useState)(localStorage.getItem("escrowType") || "general");
    const [escrowTitle, setEscrowTitle] = (0, $9nZCP.useState)(localStorage.getItem("escrowTitle") || "");
    const [deliverableText, setDeliverableText] = (0, $9nZCP.useState)(localStorage.getItem("deliverableText") || "");
    const [deliverableFile, setDeliverableFile] = (0, $9nZCP.useState)();
    const [transactionUri, setTransactionUri] = (0, $9nZCP.useState)(localStorage.getItem("transactionUri") || "");
    const [extraDescriptionUri, setExtraDescriptionUri] = (0, $9nZCP.useState)(localStorage.getItem("extraDescriptionUri") || "");
    const [isFileUploading, setIsFileUploading] = (0, $9nZCP.useState)(false);
    const [hasSufficientNativeBalance, setHasSufficientNativeBalance] = (0, $9nZCP.useState)(true);
    const [receivingQuantity, setReceivingQuantity] = (0, $9nZCP.useState)(localStorage.getItem("receivingQuantity") || "");
    const [receivingToken, setReceivingToken] = (0, $9nZCP.useState)(localStorage.getItem("receivingToken") || "");
    const [sellerAddress, setSellerAddress] = (0, $9nZCP.useState)(localStorage.getItem("sellerAddress") || "");
    const [sendingQuantity, setSendingQuantity] = (0, $9nZCP.useState)(localStorage.getItem("sendingQuantity") || "");
    const [sendingToken, setSendingToken] = (0, $9nZCP.useState)(JSON.parse(localStorage.getItem("sendingToken")) || {
        address: "native",
        symbol: "",
        logo: ""
    });
    const [buyerAddress, setBuyerAddress] = (0, $9nZCP.useState)(localStorage.getItem("buyerAddress") || "");
    const [isRecipientAddressResolved, setIsRecipientAddressResolved] = (0, $9nZCP.useState)(false);
    const [deadline, setDeadline] = (0, $9nZCP.useState)(localStorage.getItem("deadline") || "");
    const [notificationEmail, setNotificationEmail] = (0, $9nZCP.useState)(localStorage.getItem("notificationEmail") || "");
    const resetContext = ()=>{
        setEscrowType("general");
        setEscrowTitle("");
        setDeliverableText("");
        setDeliverableFile(undefined);
        setExtraDescriptionUri("");
        setTransactionUri("");
        setIsFileUploading(false);
        setReceivingQuantity("");
        setReceivingToken("");
        setSellerAddress("");
        setSendingQuantity("");
        setSendingToken({
            address: "native",
            symbol: "",
            logo: ""
        });
        setBuyerAddress("");
        setDeadline("");
        setNotificationEmail("");
        setHasSufficientNativeBalance(true);
    };
    (0, $9nZCP.useEffect)(()=>{
        localStorage.setItem("escrowType", escrowType);
        localStorage.setItem("escrowTitle", escrowTitle);
        localStorage.setItem("deliverableText", deliverableText);
        localStorage.setItem("extraDescriptionUri", extraDescriptionUri);
        localStorage.setItem("transactionUri", transactionUri);
        localStorage.setItem("receivingQuantity", receivingQuantity);
        localStorage.setItem("receivingToken", receivingToken);
        localStorage.setItem("buyerAddress", buyerAddress);
        localStorage.setItem("sendingQuantity", sendingQuantity);
        localStorage.setItem("sendingToken", JSON.stringify(sendingToken));
        localStorage.setItem("sellerAddress", sellerAddress);
        localStorage.setItem("deadline", deadline);
        localStorage.setItem("notificationEmail", notificationEmail);
    }, [
        escrowType,
        escrowTitle,
        deliverableText,
        extraDescriptionUri,
        transactionUri,
        receivingQuantity,
        receivingToken,
        buyerAddress,
        sendingQuantity,
        sendingToken,
        sellerAddress,
        deadline,
        notificationEmail
    ]);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($fa4dc73a0abb4258$var$NewTransactionContext.Provider, {
        value: {
            escrowType: escrowType,
            setEscrowType: setEscrowType,
            escrowTitle: escrowTitle,
            setEscrowTitle: setEscrowTitle,
            deliverableText: deliverableText,
            setDeliverableText: setDeliverableText,
            deliverableFile: deliverableFile,
            setDeliverableFile: setDeliverableFile,
            extraDescriptionUri: extraDescriptionUri,
            setExtraDescriptionUri: setExtraDescriptionUri,
            transactionUri: transactionUri,
            setTransactionUri: setTransactionUri,
            isFileUploading: isFileUploading,
            setIsFileUploading: setIsFileUploading,
            receivingQuantity: receivingQuantity,
            setReceivingQuantity: setReceivingQuantity,
            receivingToken: receivingToken,
            setReceivingToken: setReceivingToken,
            buyerAddress: buyerAddress,
            setBuyerAddress: setBuyerAddress,
            sendingQuantity: sendingQuantity,
            setSendingQuantity: setSendingQuantity,
            hasSufficientNativeBalance: hasSufficientNativeBalance,
            setHasSufficientNativeBalance: setHasSufficientNativeBalance,
            sendingToken: sendingToken,
            setSendingToken: setSendingToken,
            sellerAddress: sellerAddress,
            setSellerAddress: setSellerAddress,
            isRecipientAddressResolved: isRecipientAddressResolved,
            setIsRecipientAddressResolved: setIsRecipientAddressResolved,
            deadline: deadline,
            setDeadline: setDeadline,
            notificationEmail: notificationEmail,
            setNotificationEmail: setNotificationEmail,
            resetContext: resetContext
        },
        children: children
    });
};



const $196fe3f3927325b8$var$StyledField = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Field))`
  width: 84vw;
  input {
    font-size: 16px;
  }

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      width: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(342, 500)};
    `)}
`;
const $196fe3f3927325b8$var$InputField = ()=>{
    const { escrowTitle: escrowTitle, setEscrowTitle: setEscrowTitle } = (0, $fa4dc73a0abb4258$export$ab0988b836f3e0ac)();
    const handleWrite = (event)=>{
        setEscrowTitle(event.target.value);
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($196fe3f3927325b8$var$StyledField, {
        value: escrowTitle,
        onChange: handleWrite,
        placeholder: "e.g. Escrow with John"
    });
};
var $196fe3f3927325b8$export$2e2bcd8739ae039 = $196fe3f3927325b8$var$InputField;



parcelRequire("9nZCP");


parcelRequire("9nZCP");



const $34a71c005c6adc9c$var$StyledButton = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Button))`
  display: ${({ prevRoute: prevRoute })=>prevRoute === "" ? "none" : "flex"};
`;
const $34a71c005c6adc9c$var$ReturnButton = ({ prevRoute: prevRoute })=>{
    const navigate = (0, $cb6812e0fa529c57$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($34a71c005c6adc9c$var$StyledButton, {
        prevRoute: prevRoute,
        onClick: ()=>navigate(prevRoute),
        text: "Return",
        variant: "secondary"
    });
};
var $34a71c005c6adc9c$export$2e2bcd8739ae039 = $34a71c005c6adc9c$var$ReturnButton;




var $9nZCP = parcelRequire("9nZCP");







function $55e97328a1aa5b6e$export$68ac92d968702e27(file) {
    const authToken = sessionStorage.getItem("auth-token")?.replace(/"/g, "");
    return (0, $73d46209e4d80851$export$b410431fab84fa58).promise((async ()=>{
        const formData = new FormData();
        formData.append("file", file, file.name);
        const url = "/.netlify/functions/uploadToIPFS?operation=file";
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "x-auth-token": authToken ?? ""
            },
            body: formData
        });
        if (!response.ok) throw new Error("Error uploading to IPFS");
        return response;
    })(), {
        pending: "Uploading file to IPFS...",
        success: "Uploaded successfully!",
        error: "Upload failed"
    }, (0, $6724d57570dc2c5f$export$8eb3892b442747bd));
}



const $19c13b9878bcc637$export$556c1008a72661c2 = async (transactionDetails)=>{
    const transactionJSON = new File([
        JSON.stringify(transactionDetails)
    ], "transaction.json", {
        type: "application/json"
    });
    const formData = new FormData();
    formData.append("file", transactionJSON);
    try {
        const response = await (0, $55e97328a1aa5b6e$export$68ac92d968702e27)(transactionJSON);
        const responseData = await response.json();
        console.log("Transaction object uploaded to IPFS with hash:", responseData.cids[0]);
        return responseData.cids[0];
    } catch (error) {
        console.error("Error uploading transaction object to IPFS:", error);
    }
};



const $e2f99df188865287$export$5f87a80a990db1a0 = async (escrowTitle, deliverableText, setIsFileUploading, setExtraDescriptionUri, deliverableFile)=>{
    try {
        setIsFileUploading(true);
        const transactionDetails = {
            title: escrowTitle,
            description: deliverableText
        };
        setExtraDescriptionUri("");
        if (deliverableFile) {
            if (deliverableFile.type !== "application/pdf") {
                (0, $73d46209e4d80851$export$b410431fab84fa58).error("That type of file is not valid. Please upload a PDF file.", (0, $6724d57570dc2c5f$export$8eb3892b442747bd));
                setIsFileUploading(false);
                return;
            }
            const fileResponse = await (0, $55e97328a1aa5b6e$export$68ac92d968702e27)(deliverableFile);
            const fileData = await fileResponse.json();
            const fileHash = fileData.cids[0];
            transactionDetails.extraDescriptionUri = fileHash;
            setExtraDescriptionUri(fileHash);
        }
        const transactionObject = await (0, $19c13b9878bcc637$export$556c1008a72661c2)(transactionDetails);
        setIsFileUploading(false);
        return transactionObject;
    } catch (error) {
        console.error("Error in file upload process:", error);
        setIsFileUploading(false);
    }
};


const $bc6948c94a5f7586$export$d1c4b691375413aa = /^0x[a-fA-F0-9]{40}$/;
const $bc6948c94a5f7586$export$8615c39c33cb6186 = /^[a-zA-Z0-9-]{1,}\.eth$/;
const $bc6948c94a5f7586$export$f78173835dcde49f = (input)=>{
    return $bc6948c94a5f7586$export$d1c4b691375413aa.test(input) || $bc6948c94a5f7586$export$8615c39c33cb6186.test(input);
};






const $8c1d8079248e4601$var$NextButton = ({ nextRoute: nextRoute })=>{
    const { address: address } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    const navigate = (0, $cb6812e0fa529c57$export$9770f232ac06a008)();
    const location = (0, $cb6812e0fa529c57$export$45d76561a5302f2b)();
    const { escrowType: escrowType, escrowTitle: escrowTitle, deliverableText: deliverableText, deliverableFile: deliverableFile, isFileUploading: isFileUploading, setIsFileUploading: setIsFileUploading, setExtraDescriptionUri: setExtraDescriptionUri, setTransactionUri: setTransactionUri, buyerAddress: buyerAddress, receivingQuantity: receivingQuantity, receivingToken: receivingToken, sellerAddress: sellerAddress, sendingQuantity: sendingQuantity, sendingToken: sendingToken, deadline: deadline, notificationEmail: notificationEmail, hasSufficientNativeBalance: hasSufficientNativeBalance, isRecipientAddressResolved: isRecipientAddressResolved } = (0, $fa4dc73a0abb4258$export$ab0988b836f3e0ac)();
    const { data: userSettings, isLoading: isLoadingSettings, refetch: refetchUserSettings } = (0, $2c4f8190202ecf20$export$8b4f00ca24c1e68e)();
    const [isUpdatingSettings, setIsUpdatingSettings] = (0, $9nZCP.useState)(false);
    const isBuyerAddressValid = (0, $bc6948c94a5f7586$export$f78173835dcde49f)(buyerAddress);
    const areReceivingFieldsEmpty = !receivingQuantity || !receivingToken || !buyerAddress;
    const isSellerAddressValid = (0, $bc6948c94a5f7586$export$f78173835dcde49f)(sellerAddress);
    const areSendingFieldsEmpty = escrowType === "swap" ? !sendingQuantity || !sendingToken || !sellerAddress : !sendingQuantity || !sellerAddress;
    const isEmailValid = notificationEmail === "" || (0, $4ec8515f3272cbaa$export$7b7637218245c8a).test(notificationEmail);
    const isDeliverableValid = escrowType === "general" ? !!deliverableText && !isFileUploading : !(areReceivingFieldsEmpty || !isBuyerAddressValid);
    const deadlineTimestamp = deadline ? new Date(deadline).getTime() : 0;
    const currentTime = Date.now();
    const isDeadlineInPast = deadlineTimestamp <= currentTime;
    const isButtonDisabled = escrowType === "swap" || location.pathname.includes("/new-transaction/title") && !escrowTitle || location.pathname.includes("/new-transaction/deliverable") && !isDeliverableValid || location.pathname.includes("/new-transaction/payment") && (areSendingFieldsEmpty || !isSellerAddressValid || !isRecipientAddressResolved || !hasSufficientNativeBalance) || location.pathname.includes("/new-transaction/deadline") && (!deadline || isDeadlineInPast) || location.pathname.includes("/new-transaction/notifications") && (!isEmailValid || isUpdatingSettings || isLoadingSettings);
    const handleNextClick = async ()=>{
        try {
            if (location.pathname.includes("/new-transaction/deliverable") && escrowType === "general") {
                const transactionUri = await (0, $e2f99df188865287$export$5f87a80a990db1a0)(escrowTitle, deliverableText, setIsFileUploading, setExtraDescriptionUri, deliverableFile);
                if (transactionUri) {
                    setTransactionUri(transactionUri);
                    navigate(nextRoute);
                }
            } else if (location.pathname.includes("/new-transaction/notifications") && !(0, $c62bd748620e6ea9$export$fce6876652108ab)(address) && userSettings && userSettings.email !== notificationEmail) {
                const data = {
                    email: notificationEmail,
                    telegram: "",
                    address: address
                };
                setIsUpdatingSettings(true);
                const res = await (0, $cf00fb62a6062303$export$925226e2a01c2566)(data);
                if (res.ok) {
                    refetchUserSettings();
                    navigate(nextRoute);
                }
                setIsUpdatingSettings(false);
            } else navigate(nextRoute);
        } catch (error) {
            console.error("Error in upload process:", error);
        }
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.Button), {
        disabled: isButtonDisabled,
        onClick: handleNextClick,
        text: escrowType === "general" ? "Next" : "Coming Soon"
    });
};
var $8c1d8079248e4601$export$2e2bcd8739ae039 = $8c1d8079248e4601$var$NextButton;




var $9nZCP = parcelRequire("9nZCP");




var $hzb7Z = parcelRequire("hzb7Z");
const $65cd6dc33c6d9133$export$19cb1c3cb2bc083 = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address"
            },
            {
                name: "_arbitratorExtraData",
                internalType: "bytes",
                type: "bytes"
            },
            {
                name: "_templateData",
                internalType: "string",
                type: "string"
            },
            {
                name: "_templateDataMappings",
                internalType: "string",
                type: "string"
            },
            {
                name: "_templateRegistry",
                internalType: "contract IDisputeTemplateRegistry",
                type: "address"
            },
            {
                name: "_feeTimeout",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_settlementTimeout",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        type: "error",
        inputs: [],
        name: "ArbitratorOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "BuyerFeeNotCoverArbitrationCosts"
    },
    {
        type: "error",
        inputs: [],
        name: "BuyerOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "BuyerOrSellerOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "DeadlineNotPassed"
    },
    {
        type: "error",
        inputs: [],
        name: "DisputeAlreadyResolved"
    },
    {
        type: "error",
        inputs: [],
        name: "GovernorOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "InvalidRuling"
    },
    {
        type: "error",
        inputs: [],
        name: "MaximumPaymentAmountExceeded"
    },
    {
        type: "error",
        inputs: [],
        name: "NoSettlementProposedOrTransactionMovedOnAcceptSettlement"
    },
    {
        type: "error",
        inputs: [],
        name: "NoSettlementProposedOrTransactionMovedOnPayFeeBuyer"
    },
    {
        type: "error",
        inputs: [],
        name: "NoSettlementProposedOrTransactionMovedOnPayFeeSeller"
    },
    {
        type: "error",
        inputs: [],
        name: "NotWaitingForBuyerFees"
    },
    {
        type: "error",
        inputs: [],
        name: "NotWaitingForSellerFees"
    },
    {
        type: "error",
        inputs: [],
        name: "SellerFeeNotCoverArbitrationCosts"
    },
    {
        type: "error",
        inputs: [],
        name: "SellerOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "SettlementPeriodNotOver"
    },
    {
        type: "error",
        inputs: [],
        name: "TimeoutNotPassed"
    },
    {
        type: "error",
        inputs: [],
        name: "TransactionDisputed"
    },
    {
        type: "error",
        inputs: [],
        name: "TransactionEscalatedForArbitration"
    },
    {
        type: "error",
        inputs: [],
        name: "TransactionExpired"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address",
                indexed: true
            },
            {
                name: "_arbitrableDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_externalDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_templateId",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_templateUri",
                internalType: "string",
                type: "string",
                indexed: false
            }
        ],
        name: "DisputeRequest"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_party",
                internalType: "enum Escrow.Party",
                type: "uint8",
                indexed: false
            }
        ],
        name: "HasToPayFee"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_feeTimeout",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_settlementTimeout",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_arbitratorExtraData",
                internalType: "bytes",
                type: "bytes",
                indexed: false
            }
        ],
        name: "ParameterUpdated"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_party",
                internalType: "address",
                type: "address",
                indexed: false
            }
        ],
        name: "Payment"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address",
                indexed: true
            },
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_ruling",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "Ruling"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_party",
                internalType: "enum Escrow.Party",
                type: "uint8",
                indexed: false
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "SettlementProposed"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_transactionUri",
                internalType: "string",
                type: "string",
                indexed: false
            },
            {
                name: "_buyer",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_seller",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_asset",
                internalType: "string",
                type: "string",
                indexed: false
            },
            {
                name: "_deadline",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "TransactionCreated"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_resolution",
                internalType: "enum Escrow.Resolution",
                type: "uint8",
                indexed: true
            }
        ],
        name: "TransactionResolved"
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "AMOUNT_OF_CHOICES",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "acceptSettlement",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "arbitrator",
        outputs: [
            {
                name: "",
                internalType: "contract IArbitratorV2",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "arbitratorExtraData",
        outputs: [
            {
                name: "",
                internalType: "bytes",
                type: "bytes"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address"
            }
        ],
        name: "changeArbitrator",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_arbitratorExtraData",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "changeArbitratorExtraData",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_templateData",
                internalType: "string",
                type: "string"
            },
            {
                name: "_templateDataMappings",
                internalType: "string",
                type: "string"
            }
        ],
        name: "changeDisputeTemplate",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_feeTimeout",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "changeFeeTimeout",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "changeGovernor",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_settlementTimeout",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "changeSettlementTimeout",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_templateRegistry",
                internalType: "contract IDisputeTemplateRegistry",
                type: "address"
            }
        ],
        name: "changeTemplateRegistry",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "_timeoutPayment",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_transactionUri",
                internalType: "string",
                type: "string"
            },
            {
                name: "_seller",
                internalType: "address payable",
                type: "address"
            },
            {
                name: "_templateData",
                internalType: "string",
                type: "string"
            },
            {
                name: "_templateDataMappings",
                internalType: "string",
                type: "string"
            }
        ],
        name: "createTransaction",
        outputs: [
            {
                name: "transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "disputeIDtoTransactionID",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "executeTransaction",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "feeTimeout",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "getCountTransactions",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "governor",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "pay",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "payArbitrationFeeByBuyer",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "payArbitrationFeeBySeller",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "proposeSettlement",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_amountReimbursed",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "reimburse",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_ruling",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "rule",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "settlementTimeout",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "templateId",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "templateRegistry",
        outputs: [
            {
                name: "",
                internalType: "contract IDisputeTemplateRegistry",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "timeOutByBuyer",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "timeOutBySeller",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "transactions",
        outputs: [
            {
                name: "buyer",
                internalType: "address payable",
                type: "address"
            },
            {
                name: "seller",
                internalType: "address payable",
                type: "address"
            },
            {
                name: "amount",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "settlementBuyer",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "settlementSeller",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "deadline",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "disputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "buyerFee",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "sellerFee",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "lastFeePaymentTime",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "templateData",
                internalType: "string",
                type: "string"
            },
            {
                name: "templateDataMappings",
                internalType: "string",
                type: "string"
            },
            {
                name: "status",
                internalType: "enum Escrow.Status",
                type: "uint8"
            }
        ]
    }
];
const $65cd6dc33c6d9133$export$eb4c2035ed549959 = {
    421614: "0x250AB0477346aDFC010585b58FbF61cff1d8f3ea"
};
const $65cd6dc33c6d9133$export$b51b0cc5e67b439e = {
    address: $65cd6dc33c6d9133$export$eb4c2035ed549959,
    abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083
};
const $65cd6dc33c6d9133$export$e9e4e94a9a009ea7 = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address"
            },
            {
                name: "_arbitratorExtraData",
                internalType: "bytes",
                type: "bytes"
            },
            {
                name: "_templateData",
                internalType: "string",
                type: "string"
            },
            {
                name: "_templateDataMappings",
                internalType: "string",
                type: "string"
            },
            {
                name: "_templateRegistry",
                internalType: "contract IDisputeTemplateRegistry",
                type: "address"
            },
            {
                name: "_feeTimeout",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_settlementTimeout",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        type: "error",
        inputs: [],
        name: "ArbitratorOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "BuyerFeeNotCoverArbitrationCosts"
    },
    {
        type: "error",
        inputs: [],
        name: "BuyerOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "BuyerOrSellerOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "DeadlineNotPassed"
    },
    {
        type: "error",
        inputs: [],
        name: "DisputeAlreadyResolved"
    },
    {
        type: "error",
        inputs: [],
        name: "GovernorOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "InvalidRuling"
    },
    {
        type: "error",
        inputs: [],
        name: "MaximumPaymentAmountExceeded"
    },
    {
        type: "error",
        inputs: [],
        name: "NoSettlementProposedOrTransactionMovedOnAcceptSettlement"
    },
    {
        type: "error",
        inputs: [],
        name: "NoSettlementProposedOrTransactionMovedOnPayFeeBuyer"
    },
    {
        type: "error",
        inputs: [],
        name: "NoSettlementProposedOrTransactionMovedOnPayFeeSeller"
    },
    {
        type: "error",
        inputs: [],
        name: "NotWaitingForBuyerFees"
    },
    {
        type: "error",
        inputs: [],
        name: "NotWaitingForSellerFees"
    },
    {
        type: "error",
        inputs: [],
        name: "SellerFeeNotCoverArbitrationCosts"
    },
    {
        type: "error",
        inputs: [],
        name: "SellerOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "SettlementPeriodNotOver"
    },
    {
        type: "error",
        inputs: [],
        name: "TimeoutNotPassed"
    },
    {
        type: "error",
        inputs: [],
        name: "TokenTransferFailed"
    },
    {
        type: "error",
        inputs: [],
        name: "TransactionDisputed"
    },
    {
        type: "error",
        inputs: [],
        name: "TransactionEscalatedForArbitration"
    },
    {
        type: "error",
        inputs: [],
        name: "TransactionExpired"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address",
                indexed: true
            },
            {
                name: "_arbitrableDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_externalDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_templateId",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_templateUri",
                internalType: "string",
                type: "string",
                indexed: false
            }
        ],
        name: "DisputeRequest"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_party",
                internalType: "enum EscrowToken.Party",
                type: "uint8",
                indexed: false
            }
        ],
        name: "HasToPayFee"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_feeTimeout",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_settlementTimeout",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_arbitratorExtraData",
                internalType: "bytes",
                type: "bytes",
                indexed: false
            }
        ],
        name: "ParameterUpdated"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_party",
                internalType: "address",
                type: "address",
                indexed: false
            }
        ],
        name: "Payment"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address",
                indexed: true
            },
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_ruling",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "Ruling"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_party",
                internalType: "enum EscrowToken.Party",
                type: "uint8",
                indexed: false
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "SettlementProposed"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_transactionUri",
                internalType: "string",
                type: "string",
                indexed: false
            },
            {
                name: "_buyer",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_seller",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_token",
                internalType: "contract IERC20",
                type: "address",
                indexed: false
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_asset",
                internalType: "string",
                type: "string",
                indexed: false
            },
            {
                name: "_deadline",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "TransactionCreated"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_resolution",
                internalType: "enum EscrowToken.Resolution",
                type: "uint8",
                indexed: true
            }
        ],
        name: "TransactionResolved"
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "AMOUNT_OF_CHOICES",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "acceptSettlement",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "arbitrator",
        outputs: [
            {
                name: "",
                internalType: "contract IArbitratorV2",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "arbitratorExtraData",
        outputs: [
            {
                name: "",
                internalType: "bytes",
                type: "bytes"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address"
            }
        ],
        name: "changeArbitrator",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_arbitratorExtraData",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "changeArbitratorExtraData",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_templateData",
                internalType: "string",
                type: "string"
            },
            {
                name: "_templateDataMappings",
                internalType: "string",
                type: "string"
            }
        ],
        name: "changeDisputeTemplate",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_feeTimeout",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "changeFeeTimeout",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "changeGovernor",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_settlementTimeout",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "changeSettlementTimeout",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_templateRegistry",
                internalType: "contract IDisputeTemplateRegistry",
                type: "address"
            }
        ],
        name: "changeTemplateRegistry",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_token",
                internalType: "contract IERC20",
                type: "address"
            },
            {
                name: "_timeoutPayment",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_transactionUri",
                internalType: "string",
                type: "string"
            },
            {
                name: "_seller",
                internalType: "address payable",
                type: "address"
            },
            {
                name: "_templateData",
                internalType: "string",
                type: "string"
            },
            {
                name: "_templateDataMappings",
                internalType: "string",
                type: "string"
            }
        ],
        name: "createTransaction",
        outputs: [
            {
                name: "transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "disputeIDtoTransactionID",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "executeTransaction",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "feeTimeout",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "getCountTransactions",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "governor",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "pay",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "payArbitrationFeeByBuyer",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "payArbitrationFeeBySeller",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "proposeSettlement",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_amountReimbursed",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "reimburse",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_ruling",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "rule",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "settlementTimeout",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "templateId",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "templateRegistry",
        outputs: [
            {
                name: "",
                internalType: "contract IDisputeTemplateRegistry",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "timeOutByBuyer",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "timeOutBySeller",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "transactions",
        outputs: [
            {
                name: "buyer",
                internalType: "address payable",
                type: "address"
            },
            {
                name: "seller",
                internalType: "address payable",
                type: "address"
            },
            {
                name: "amount",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "settlementBuyer",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "settlementSeller",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "deadline",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "disputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "buyerFee",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "sellerFee",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "lastFeePaymentTime",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "templateData",
                internalType: "string",
                type: "string"
            },
            {
                name: "templateDataMappings",
                internalType: "string",
                type: "string"
            },
            {
                name: "status",
                internalType: "enum EscrowToken.Status",
                type: "uint8"
            },
            {
                name: "token",
                internalType: "contract IERC20",
                type: "address"
            }
        ]
    }
];
const $65cd6dc33c6d9133$export$fe479b22cc2d5f0e = {
    421614: "0xe7B52a7Bc50cb4Ff13d057629082844780b6E28D"
};
const $65cd6dc33c6d9133$export$dbd9ad05fb9860cc = {
    address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e,
    abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7
};
const $65cd6dc33c6d9133$export$7f38cc98a67d8093 = [
    {
        stateMutability: "nonpayable",
        type: "constructor",
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address"
            },
            {
                name: "_arbitratorExtraData",
                internalType: "bytes",
                type: "bytes"
            },
            {
                name: "_templateData",
                internalType: "string",
                type: "string"
            },
            {
                name: "_templateDataMappings",
                internalType: "string",
                type: "string"
            },
            {
                name: "_templateRegistry",
                internalType: "contract IDisputeTemplateRegistry",
                type: "address"
            },
            {
                name: "_feeTimeout",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_settlementTimeout",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        type: "error",
        inputs: [],
        name: "ArbitratorOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "BuyerFeeNotCoverArbitrationCosts"
    },
    {
        type: "error",
        inputs: [],
        name: "BuyerOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "BuyerOrSellerOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "DeadlineNotPassed"
    },
    {
        type: "error",
        inputs: [],
        name: "DisputeAlreadyResolved"
    },
    {
        type: "error",
        inputs: [],
        name: "GovernorOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "InvalidRuling"
    },
    {
        type: "error",
        inputs: [],
        name: "MaximumPaymentAmountExceeded"
    },
    {
        type: "error",
        inputs: [],
        name: "NoSettlementProposedOrTransactionMovedOnAcceptSettlement"
    },
    {
        type: "error",
        inputs: [],
        name: "NoSettlementProposedOrTransactionMovedOnPayFeeBuyer"
    },
    {
        type: "error",
        inputs: [],
        name: "NoSettlementProposedOrTransactionMovedOnPayFeeSeller"
    },
    {
        type: "error",
        inputs: [],
        name: "NotSupported"
    },
    {
        type: "error",
        inputs: [],
        name: "NotWaitingForBuyerFees"
    },
    {
        type: "error",
        inputs: [],
        name: "NotWaitingForSellerFees"
    },
    {
        type: "error",
        inputs: [],
        name: "SellerFeeNotCoverArbitrationCosts"
    },
    {
        type: "error",
        inputs: [],
        name: "SellerOnly"
    },
    {
        type: "error",
        inputs: [],
        name: "SettlementPeriodNotOver"
    },
    {
        type: "error",
        inputs: [],
        name: "TimeoutNotPassed"
    },
    {
        type: "error",
        inputs: [],
        name: "TokenTransferFailed"
    },
    {
        type: "error",
        inputs: [],
        name: "TransactionDisputed"
    },
    {
        type: "error",
        inputs: [],
        name: "TransactionEscalatedForArbitration"
    },
    {
        type: "error",
        inputs: [],
        name: "TransactionExpired"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address",
                indexed: true
            },
            {
                name: "_arbitrableDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_externalDisputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_templateId",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_templateUri",
                internalType: "string",
                type: "string",
                indexed: false
            }
        ],
        name: "DisputeRequest"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_transactionUri",
                internalType: "string",
                type: "string",
                indexed: false
            },
            {
                name: "_buyer",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_seller",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_token",
                internalType: "contract IERC20",
                type: "address",
                indexed: false
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_deadline",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "ERC20TransactionCreated"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_party",
                internalType: "enum Party",
                type: "uint8",
                indexed: false
            }
        ],
        name: "HasToPayFee"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_transactionUri",
                internalType: "string",
                type: "string",
                indexed: false
            },
            {
                name: "_buyer",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_seller",
                internalType: "address",
                type: "address",
                indexed: true
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_deadline",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "NativeTransactionCreated"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_feeTimeout",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_settlementTimeout",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_arbitratorExtraData",
                internalType: "bytes",
                type: "bytes",
                indexed: false
            }
        ],
        name: "ParameterUpdated"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            },
            {
                name: "_party",
                internalType: "address",
                type: "address",
                indexed: false
            }
        ],
        name: "Payment"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address",
                indexed: true
            },
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_ruling",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "Ruling"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_party",
                internalType: "enum Party",
                type: "uint8",
                indexed: false
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256",
                indexed: false
            }
        ],
        name: "SettlementProposed"
    },
    {
        type: "event",
        anonymous: false,
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256",
                indexed: true
            },
            {
                name: "_resolution",
                internalType: "enum Resolution",
                type: "uint8",
                indexed: true
            }
        ],
        name: "TransactionResolved"
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "AMOUNT_OF_CHOICES",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "acceptSettlement",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "arbitrator",
        outputs: [
            {
                name: "",
                internalType: "contract IArbitratorV2",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "arbitratorExtraData",
        outputs: [
            {
                name: "",
                internalType: "bytes",
                type: "bytes"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_arbitrator",
                internalType: "contract IArbitratorV2",
                type: "address"
            }
        ],
        name: "changeArbitrator",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_arbitratorExtraData",
                internalType: "bytes",
                type: "bytes"
            }
        ],
        name: "changeArbitratorExtraData",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_templateData",
                internalType: "string",
                type: "string"
            },
            {
                name: "_templateDataMappings",
                internalType: "string",
                type: "string"
            }
        ],
        name: "changeDisputeTemplate",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_feeTimeout",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "changeFeeTimeout",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_governor",
                internalType: "address",
                type: "address"
            }
        ],
        name: "changeGovernor",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_settlementTimeout",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "changeSettlementTimeout",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_templateRegistry",
                internalType: "contract IDisputeTemplateRegistry",
                type: "address"
            }
        ],
        name: "changeTemplateRegistry",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_token",
                internalType: "contract IERC20",
                type: "address"
            },
            {
                name: "_deadline",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_transactionUri",
                internalType: "string",
                type: "string"
            },
            {
                name: "_seller",
                internalType: "address payable",
                type: "address"
            },
            {
                name: "_templateData",
                internalType: "string",
                type: "string"
            },
            {
                name: "_templateDataMappings",
                internalType: "string",
                type: "string"
            }
        ],
        name: "createERC20Transaction",
        outputs: [
            {
                name: "transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "_deadline",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_transactionUri",
                internalType: "string",
                type: "string"
            },
            {
                name: "_seller",
                internalType: "address payable",
                type: "address"
            },
            {
                name: "_templateData",
                internalType: "string",
                type: "string"
            },
            {
                name: "_templateDataMappings",
                internalType: "string",
                type: "string"
            }
        ],
        name: "createNativeTransaction",
        outputs: [
            {
                name: "transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "disputeIDtoTransactionID",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "executeTransaction",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "feeTimeout",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "getTransactionCount",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "governor",
        outputs: [
            {
                name: "",
                internalType: "address",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "pay",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "payArbitrationFeeByBuyer",
        outputs: []
    },
    {
        stateMutability: "payable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "payArbitrationFeeBySeller",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_amount",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "proposeSettlement",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_amountReimbursed",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "reimburse",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_disputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "_ruling",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "rule",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "settlementTimeout",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "templateId",
        outputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ]
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [],
        name: "templateRegistry",
        outputs: [
            {
                name: "",
                internalType: "contract IDisputeTemplateRegistry",
                type: "address"
            }
        ]
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "timeOutByBuyer",
        outputs: []
    },
    {
        stateMutability: "nonpayable",
        type: "function",
        inputs: [
            {
                name: "_transactionID",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "timeOutBySeller",
        outputs: []
    },
    {
        stateMutability: "view",
        type: "function",
        inputs: [
            {
                name: "",
                internalType: "uint256",
                type: "uint256"
            }
        ],
        name: "transactions",
        outputs: [
            {
                name: "buyer",
                internalType: "address payable",
                type: "address"
            },
            {
                name: "seller",
                internalType: "address payable",
                type: "address"
            },
            {
                name: "amount",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "settlementBuyer",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "settlementSeller",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "deadline",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "disputeID",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "buyerFee",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "sellerFee",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "lastFeePaymentTime",
                internalType: "uint256",
                type: "uint256"
            },
            {
                name: "templateData",
                internalType: "string",
                type: "string"
            },
            {
                name: "templateDataMappings",
                internalType: "string",
                type: "string"
            },
            {
                name: "status",
                internalType: "enum Status",
                type: "uint8"
            },
            {
                name: "token",
                internalType: "contract IERC20",
                type: "address"
            }
        ]
    }
];
const $65cd6dc33c6d9133$export$eb29ec29b9f0e4e = {
    421614: "0xBa2cC03e2e34C5DEDaEbC481b2531e06946353De"
};
const $65cd6dc33c6d9133$export$3c4aa2a598d541af = {
    address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e,
    abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093
};
function $65cd6dc33c6d9133$export$40269fe3481f81c8(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$8b7aec8b963ec551(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "AMOUNT_OF_CHOICES",
        ...config
    });
}
function $65cd6dc33c6d9133$export$2caa3f4703e660f5(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "arbitrator",
        ...config
    });
}
function $65cd6dc33c6d9133$export$7ee21ba0e4de0dfb(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "arbitratorExtraData",
        ...config
    });
}
function $65cd6dc33c6d9133$export$116f0051cac6dc9b(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "disputeIDtoTransactionID",
        ...config
    });
}
function $65cd6dc33c6d9133$export$9fe0d0716df6e1a4(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "feeTimeout",
        ...config
    });
}
function $65cd6dc33c6d9133$export$b5f2c227187c2c4f(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "getCountTransactions",
        ...config
    });
}
function $65cd6dc33c6d9133$export$fcfbf7b0b7e29ed9(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "governor",
        ...config
    });
}
function $65cd6dc33c6d9133$export$94f9eaa9f25a4a83(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "settlementTimeout",
        ...config
    });
}
function $65cd6dc33c6d9133$export$9359b5351407239c(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "templateId",
        ...config
    });
}
function $65cd6dc33c6d9133$export$f86b011c4cc6d0f1(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "templateRegistry",
        ...config
    });
}
function $65cd6dc33c6d9133$export$2d8033202411f9bd(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "transactions",
        ...config
    });
}
function $65cd6dc33c6d9133$export$24425f1c91ec5b04(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$4cb66c6a1a14cc50(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "acceptSettlement",
        ...config
    });
}
function $65cd6dc33c6d9133$export$2a6bbba344accf11(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "changeArbitrator",
        ...config
    });
}
function $65cd6dc33c6d9133$export$62ecf541d014c54e(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "changeArbitratorExtraData",
        ...config
    });
}
function $65cd6dc33c6d9133$export$7553ad374e415ff8(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "changeDisputeTemplate",
        ...config
    });
}
function $65cd6dc33c6d9133$export$760e3999ddfd8db7(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "changeFeeTimeout",
        ...config
    });
}
function $65cd6dc33c6d9133$export$24cc4343dc1f5e97(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $65cd6dc33c6d9133$export$56b0d31118b280c1(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "changeSettlementTimeout",
        ...config
    });
}
function $65cd6dc33c6d9133$export$ff2b4552389fb702(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "changeTemplateRegistry",
        ...config
    });
}
function $65cd6dc33c6d9133$export$4125568ecd82e647(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "createTransaction",
        ...config
    });
}
function $65cd6dc33c6d9133$export$d6abde67f26054f2(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "executeTransaction",
        ...config
    });
}
function $65cd6dc33c6d9133$export$e21df113775e3ba(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "pay",
        ...config
    });
}
function $65cd6dc33c6d9133$export$51a394e4db53c3a6(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "payArbitrationFeeByBuyer",
        ...config
    });
}
function $65cd6dc33c6d9133$export$3f0cb95adb36ce6d(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "payArbitrationFeeBySeller",
        ...config
    });
}
function $65cd6dc33c6d9133$export$52daed287903af36(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "proposeSettlement",
        ...config
    });
}
function $65cd6dc33c6d9133$export$3fd5487126f171d6(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "reimburse",
        ...config
    });
}
function $65cd6dc33c6d9133$export$a8f2cf06ccd21437(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "rule",
        ...config
    });
}
function $65cd6dc33c6d9133$export$a946e05c896a318d(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "timeOutByBuyer",
        ...config
    });
}
function $65cd6dc33c6d9133$export$32aa0216076550ce(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "timeOutBySeller",
        ...config
    });
}
function $65cd6dc33c6d9133$export$98c02abcd3165b7f(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$dce81d8d49fd5829(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "acceptSettlement",
        ...config
    });
}
function $65cd6dc33c6d9133$export$1c740089dca00bf8(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "changeArbitrator",
        ...config
    });
}
function $65cd6dc33c6d9133$export$54188d28ddd6c701(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "changeArbitratorExtraData",
        ...config
    });
}
function $65cd6dc33c6d9133$export$3751168f0faa1181(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "changeDisputeTemplate",
        ...config
    });
}
function $65cd6dc33c6d9133$export$9b6ddea61f5dced7(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "changeFeeTimeout",
        ...config
    });
}
function $65cd6dc33c6d9133$export$60d7760544a49119(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $65cd6dc33c6d9133$export$688fa6d33b03e08f(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "changeSettlementTimeout",
        ...config
    });
}
function $65cd6dc33c6d9133$export$cdc30df19b147ca4(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "changeTemplateRegistry",
        ...config
    });
}
function $65cd6dc33c6d9133$export$e51a65983efe25f1(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "createTransaction",
        ...config
    });
}
function $65cd6dc33c6d9133$export$2c16992f7f6dcf5d(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "executeTransaction",
        ...config
    });
}
function $65cd6dc33c6d9133$export$4f1c81ef10398242(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "pay",
        ...config
    });
}
function $65cd6dc33c6d9133$export$4f5a24da9bc07bdd(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "payArbitrationFeeByBuyer",
        ...config
    });
}
function $65cd6dc33c6d9133$export$109aa6e8353b8623(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "payArbitrationFeeBySeller",
        ...config
    });
}
function $65cd6dc33c6d9133$export$943cc96019939eb5(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "proposeSettlement",
        ...config
    });
}
function $65cd6dc33c6d9133$export$84f83bed14c7a335(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "reimburse",
        ...config
    });
}
function $65cd6dc33c6d9133$export$610582612bb4fec6(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "rule",
        ...config
    });
}
function $65cd6dc33c6d9133$export$4cef22dfcf3957f0(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "timeOutByBuyer",
        ...config
    });
}
function $65cd6dc33c6d9133$export$feb5349322bac0b4(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        functionName: "timeOutBySeller",
        ...config
    });
}
function $65cd6dc33c6d9133$export$db8d08c8633bc141(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$dbf5eafc19c2a443(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        eventName: "DisputeRequest",
        ...config
    });
}
function $65cd6dc33c6d9133$export$52d89f96aefa0a00(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        eventName: "HasToPayFee",
        ...config
    });
}
function $65cd6dc33c6d9133$export$b2fc751537c37784(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        eventName: "ParameterUpdated",
        ...config
    });
}
function $65cd6dc33c6d9133$export$e790c47fe4c82708(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        eventName: "Payment",
        ...config
    });
}
function $65cd6dc33c6d9133$export$41f5816a1b977156(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        eventName: "Ruling",
        ...config
    });
}
function $65cd6dc33c6d9133$export$e509d873f53043d4(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        eventName: "SettlementProposed",
        ...config
    });
}
function $65cd6dc33c6d9133$export$65b7b306629ef6e6(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        eventName: "TransactionCreated",
        ...config
    });
}
function $65cd6dc33c6d9133$export$8d4834c3a9466bc5(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        eventName: "TransactionResolved",
        ...config
    });
}
function $65cd6dc33c6d9133$export$a6c0542e320920e5(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$ef065bbe599664e6(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "AMOUNT_OF_CHOICES",
        ...config
    });
}
function $65cd6dc33c6d9133$export$6fcc7fe57546053b(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "arbitrator",
        ...config
    });
}
function $65cd6dc33c6d9133$export$cc90feffad6888ad(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "arbitratorExtraData",
        ...config
    });
}
function $65cd6dc33c6d9133$export$e74335b72e9effa1(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "disputeIDtoTransactionID",
        ...config
    });
}
function $65cd6dc33c6d9133$export$8f5f322d192126e1(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "feeTimeout",
        ...config
    });
}
function $65cd6dc33c6d9133$export$939137bdce56c301(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "getCountTransactions",
        ...config
    });
}
function $65cd6dc33c6d9133$export$699e35b1bb8c9db5(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "governor",
        ...config
    });
}
function $65cd6dc33c6d9133$export$39c468e5ee59f2d0(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "settlementTimeout",
        ...config
    });
}
function $65cd6dc33c6d9133$export$7ecc24cbe63233e5(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "templateId",
        ...config
    });
}
function $65cd6dc33c6d9133$export$15f688b713d109c8(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "templateRegistry",
        ...config
    });
}
function $65cd6dc33c6d9133$export$708d776b735ee90f(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "transactions",
        ...config
    });
}
function $65cd6dc33c6d9133$export$d6b0c3a5be88d370(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$c99a4160900c109(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "acceptSettlement",
        ...config
    });
}
function $65cd6dc33c6d9133$export$1c8d29d7b463003d(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "changeArbitrator",
        ...config
    });
}
function $65cd6dc33c6d9133$export$8b18a7a26bd862d1(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "changeArbitratorExtraData",
        ...config
    });
}
function $65cd6dc33c6d9133$export$38aa85015cb571ea(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "changeDisputeTemplate",
        ...config
    });
}
function $65cd6dc33c6d9133$export$db31cd7080062476(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "changeFeeTimeout",
        ...config
    });
}
function $65cd6dc33c6d9133$export$1bc253d8dc531bd5(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $65cd6dc33c6d9133$export$b7b0d71551edcc29(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "changeSettlementTimeout",
        ...config
    });
}
function $65cd6dc33c6d9133$export$b311940c61e70810(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "changeTemplateRegistry",
        ...config
    });
}
function $65cd6dc33c6d9133$export$2384a630ea7f46b9(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "createTransaction",
        ...config
    });
}
function $65cd6dc33c6d9133$export$565c9f6c45ba64c4(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "executeTransaction",
        ...config
    });
}
function $65cd6dc33c6d9133$export$941a485e8c821e36(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "pay",
        ...config
    });
}
function $65cd6dc33c6d9133$export$d753fe5f9ba5b1b2(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "payArbitrationFeeByBuyer",
        ...config
    });
}
function $65cd6dc33c6d9133$export$b2c6a1527231f4bb(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "payArbitrationFeeBySeller",
        ...config
    });
}
function $65cd6dc33c6d9133$export$449686fe36bca9aa(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "proposeSettlement",
        ...config
    });
}
function $65cd6dc33c6d9133$export$c56b950a95ec7ec8(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "reimburse",
        ...config
    });
}
function $65cd6dc33c6d9133$export$38e4ab6214fe93af(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "rule",
        ...config
    });
}
function $65cd6dc33c6d9133$export$2b73a55cc6f3ac94(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "timeOutByBuyer",
        ...config
    });
}
function $65cd6dc33c6d9133$export$eba69fe2fff081b7(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "timeOutBySeller",
        ...config
    });
}
function $65cd6dc33c6d9133$export$eb55589564591a11(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$ec6e7129fd31ea5b(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "acceptSettlement",
        ...config
    });
}
function $65cd6dc33c6d9133$export$47c9593c4ee41c6d(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "changeArbitrator",
        ...config
    });
}
function $65cd6dc33c6d9133$export$c89c05eb0c51352a(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "changeArbitratorExtraData",
        ...config
    });
}
function $65cd6dc33c6d9133$export$7149f4f0f22f6d63(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "changeDisputeTemplate",
        ...config
    });
}
function $65cd6dc33c6d9133$export$89e7962344d4c0d9(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "changeFeeTimeout",
        ...config
    });
}
function $65cd6dc33c6d9133$export$952ac53f0672f824(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $65cd6dc33c6d9133$export$d50f5a77edd59bc7(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "changeSettlementTimeout",
        ...config
    });
}
function $65cd6dc33c6d9133$export$1881efc547b06e8f(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "changeTemplateRegistry",
        ...config
    });
}
function $65cd6dc33c6d9133$export$2d0318f6fd9e37dc(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "createTransaction",
        ...config
    });
}
function $65cd6dc33c6d9133$export$d4d1c7c6ec7c8016(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "executeTransaction",
        ...config
    });
}
function $65cd6dc33c6d9133$export$a8f385c9b4a8b170(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "pay",
        ...config
    });
}
function $65cd6dc33c6d9133$export$fb6bc51c75a75376(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "payArbitrationFeeByBuyer",
        ...config
    });
}
function $65cd6dc33c6d9133$export$f1fafd1356536abb(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "payArbitrationFeeBySeller",
        ...config
    });
}
function $65cd6dc33c6d9133$export$a5c1fcbd147d9144(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "proposeSettlement",
        ...config
    });
}
function $65cd6dc33c6d9133$export$f51520ae69d86d02(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "reimburse",
        ...config
    });
}
function $65cd6dc33c6d9133$export$17de5d201d2131a8(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "rule",
        ...config
    });
}
function $65cd6dc33c6d9133$export$cd09787bd4c1fb7a(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "timeOutByBuyer",
        ...config
    });
}
function $65cd6dc33c6d9133$export$73ad25dd3d2cd360(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        functionName: "timeOutBySeller",
        ...config
    });
}
function $65cd6dc33c6d9133$export$42ed2c24e2b3091f(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$b1e4a8e2dd1d4df5(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        eventName: "DisputeRequest",
        ...config
    });
}
function $65cd6dc33c6d9133$export$4009effa18ce55df(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        eventName: "HasToPayFee",
        ...config
    });
}
function $65cd6dc33c6d9133$export$555f771c382952a7(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        eventName: "ParameterUpdated",
        ...config
    });
}
function $65cd6dc33c6d9133$export$96d7c099633fda5a(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        eventName: "Payment",
        ...config
    });
}
function $65cd6dc33c6d9133$export$675c764867483ec0(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        eventName: "Ruling",
        ...config
    });
}
function $65cd6dc33c6d9133$export$8452f74bbc13a4df(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        eventName: "SettlementProposed",
        ...config
    });
}
function $65cd6dc33c6d9133$export$7e2532efc8ab4e33(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        eventName: "TransactionCreated",
        ...config
    });
}
function $65cd6dc33c6d9133$export$a2dce422df66e0aa(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        eventName: "TransactionResolved",
        ...config
    });
}
function $65cd6dc33c6d9133$export$d411237ab23ea602(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$b8a60a1513803c3f(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "AMOUNT_OF_CHOICES",
        ...config
    });
}
function $65cd6dc33c6d9133$export$66331d32d49ab369(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "arbitrator",
        ...config
    });
}
function $65cd6dc33c6d9133$export$c500b5ee9512133b(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "arbitratorExtraData",
        ...config
    });
}
function $65cd6dc33c6d9133$export$e65dfbbe00ee9aff(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "disputeIDtoTransactionID",
        ...config
    });
}
function $65cd6dc33c6d9133$export$6204b297e81b1da6(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "feeTimeout",
        ...config
    });
}
function $65cd6dc33c6d9133$export$780c5e9ea722b492(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "getTransactionCount",
        ...config
    });
}
function $65cd6dc33c6d9133$export$6464657b1bf23a4(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "governor",
        ...config
    });
}
function $65cd6dc33c6d9133$export$14322aae7041b982(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "settlementTimeout",
        ...config
    });
}
function $65cd6dc33c6d9133$export$1d8ac8001b755a9(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "templateId",
        ...config
    });
}
function $65cd6dc33c6d9133$export$2c2aa07bcbc45035(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "templateRegistry",
        ...config
    });
}
function $65cd6dc33c6d9133$export$c75db10313101ec2(config = {}) {
    return (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "transactions",
        ...config
    });
}
function $65cd6dc33c6d9133$export$7a93c377e3edf6cf(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$9b6cde88f65d242(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "acceptSettlement",
        ...config
    });
}
function $65cd6dc33c6d9133$export$74c30bdd66615f39(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "changeArbitrator",
        ...config
    });
}
function $65cd6dc33c6d9133$export$23943f3f7453a353(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "changeArbitratorExtraData",
        ...config
    });
}
function $65cd6dc33c6d9133$export$135c44ec004dc87e(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "changeDisputeTemplate",
        ...config
    });
}
function $65cd6dc33c6d9133$export$4cdf8074c6876372(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "changeFeeTimeout",
        ...config
    });
}
function $65cd6dc33c6d9133$export$4d78953be2c31c2(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $65cd6dc33c6d9133$export$fbd85b1b56072f11(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "changeSettlementTimeout",
        ...config
    });
}
function $65cd6dc33c6d9133$export$c207459091ff7994(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "changeTemplateRegistry",
        ...config
    });
}
function $65cd6dc33c6d9133$export$3ffac8bdfc2eec65(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "createERC20Transaction",
        ...config
    });
}
function $65cd6dc33c6d9133$export$dd34cb24bdc4e09b(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "createNativeTransaction",
        ...config
    });
}
function $65cd6dc33c6d9133$export$40eca84d940651c2(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "executeTransaction",
        ...config
    });
}
function $65cd6dc33c6d9133$export$406692f3d67b7258(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "pay",
        ...config
    });
}
function $65cd6dc33c6d9133$export$81a542e519cd3e2b(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "payArbitrationFeeByBuyer",
        ...config
    });
}
function $65cd6dc33c6d9133$export$60f99c111151e20a(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "payArbitrationFeeBySeller",
        ...config
    });
}
function $65cd6dc33c6d9133$export$9658fb246c82807e(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "proposeSettlement",
        ...config
    });
}
function $65cd6dc33c6d9133$export$79ce654a8cbf5d36(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "reimburse",
        ...config
    });
}
function $65cd6dc33c6d9133$export$c69f231470022169(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "rule",
        ...config
    });
}
function $65cd6dc33c6d9133$export$aaae9e332ebd6554(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "timeOutByBuyer",
        ...config
    });
}
function $65cd6dc33c6d9133$export$c882af1c56675709(config = {}) {
    return (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "timeOutBySeller",
        ...config
    });
}
function $65cd6dc33c6d9133$export$4e0191719e376992(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$f99df855bcef3935(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "acceptSettlement",
        ...config
    });
}
function $65cd6dc33c6d9133$export$148ff4711bb3d36f(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "changeArbitrator",
        ...config
    });
}
function $65cd6dc33c6d9133$export$e47df33915aabef6(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "changeArbitratorExtraData",
        ...config
    });
}
function $65cd6dc33c6d9133$export$df194a2e0464a4b9(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "changeDisputeTemplate",
        ...config
    });
}
function $65cd6dc33c6d9133$export$ecb4440a75229440(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "changeFeeTimeout",
        ...config
    });
}
function $65cd6dc33c6d9133$export$4d30667f92c9b113(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "changeGovernor",
        ...config
    });
}
function $65cd6dc33c6d9133$export$cd13a4280f87c27e(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "changeSettlementTimeout",
        ...config
    });
}
function $65cd6dc33c6d9133$export$ddea4241e6e67b97(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "changeTemplateRegistry",
        ...config
    });
}
function $65cd6dc33c6d9133$export$377faf72921dd28f(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "createERC20Transaction",
        ...config
    });
}
function $65cd6dc33c6d9133$export$53db92ba21d0bb92(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "createNativeTransaction",
        ...config
    });
}
function $65cd6dc33c6d9133$export$8d857306e9906350(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "executeTransaction",
        ...config
    });
}
function $65cd6dc33c6d9133$export$55821cc32e809701(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "pay",
        ...config
    });
}
function $65cd6dc33c6d9133$export$3e0fbcee4417d6bb(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "payArbitrationFeeByBuyer",
        ...config
    });
}
function $65cd6dc33c6d9133$export$a7dfc7d070a1292d(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "payArbitrationFeeBySeller",
        ...config
    });
}
function $65cd6dc33c6d9133$export$663dc5ee70f7ae4e(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "proposeSettlement",
        ...config
    });
}
function $65cd6dc33c6d9133$export$8d70dd09249bcae1(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "reimburse",
        ...config
    });
}
function $65cd6dc33c6d9133$export$e7c97397e7fee9b9(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "rule",
        ...config
    });
}
function $65cd6dc33c6d9133$export$5ea62317227a2199(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "timeOutByBuyer",
        ...config
    });
}
function $65cd6dc33c6d9133$export$6809d1cd2599fefd(config = {}) {
    return (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        functionName: "timeOutBySeller",
        ...config
    });
}
function $65cd6dc33c6d9133$export$4fe2a010f5f9b0a7(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$64757b0665aacead(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        eventName: "DisputeRequest",
        ...config
    });
}
function $65cd6dc33c6d9133$export$79ee464d7e4f499e(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        eventName: "ERC20TransactionCreated",
        ...config
    });
}
function $65cd6dc33c6d9133$export$d3629ec433db08d4(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        eventName: "HasToPayFee",
        ...config
    });
}
function $65cd6dc33c6d9133$export$3bd195409fd7aced(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        eventName: "NativeTransactionCreated",
        ...config
    });
}
function $65cd6dc33c6d9133$export$fd6d90bdcd9fed8(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        eventName: "ParameterUpdated",
        ...config
    });
}
function $65cd6dc33c6d9133$export$2e683eaa776c036a(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        eventName: "Payment",
        ...config
    });
}
function $65cd6dc33c6d9133$export$24ce5ab32b4027e5(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        eventName: "Ruling",
        ...config
    });
}
function $65cd6dc33c6d9133$export$36e9c4bd23ce8707(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        eventName: "SettlementProposed",
        ...config
    });
}
function $65cd6dc33c6d9133$export$1f35194f705dd7ba(config = {}) {
    return (0, $b9a08c139e2d6879$export$fa3bb2588a62576e)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        eventName: "TransactionResolved",
        ...config
    });
}
function $65cd6dc33c6d9133$export$bfe6a82b1672c75a(config) {
    return (0, $hzb7Z.getContract)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$c71d0a1fb05c07c6(config) {
    return (0, $hzb7Z.readContract)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$73bcf3f28e3d3ab1(config) {
    return (0, $hzb7Z.writeContract)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$df774e60528e1651(config) {
    return (0, $hzb7Z.prepareWriteContract)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$c53e354cfbdd5e24(config, callback) {
    return (0, $hzb7Z.watchContractEvent)({
        abi: $65cd6dc33c6d9133$export$19cb1c3cb2bc083,
        address: $65cd6dc33c6d9133$export$eb4c2035ed549959[421614],
        ...config
    }, callback);
}
function $65cd6dc33c6d9133$export$8f1f4eb6d1962bb9(config) {
    return (0, $hzb7Z.getContract)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$82f2271febd8c48b(config) {
    return (0, $hzb7Z.readContract)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$f8fee3f63ff9353b(config) {
    return (0, $hzb7Z.writeContract)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$a83770002be6fc0f(config) {
    return (0, $hzb7Z.prepareWriteContract)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$e6fab1deb2650066(config, callback) {
    return (0, $hzb7Z.watchContractEvent)({
        abi: $65cd6dc33c6d9133$export$e9e4e94a9a009ea7,
        address: $65cd6dc33c6d9133$export$fe479b22cc2d5f0e[421614],
        ...config
    }, callback);
}
function $65cd6dc33c6d9133$export$2a3ba265aaaa9312(config) {
    return (0, $hzb7Z.getContract)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$f1fb0cc827694fc(config) {
    return (0, $hzb7Z.readContract)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$8ef1dcf88e6b31ca(config) {
    return (0, $hzb7Z.writeContract)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$8c8b3eb2942dd5bf(config) {
    return (0, $hzb7Z.prepareWriteContract)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        ...config
    });
}
function $65cd6dc33c6d9133$export$ca5ecdff84737cad(config, callback) {
    return (0, $hzb7Z.watchContractEvent)({
        abi: $65cd6dc33c6d9133$export$7f38cc98a67d8093,
        address: $65cd6dc33c6d9133$export$eb29ec29b9f0e4e[421614],
        ...config
    }, callback);
}



var $hzb7Z = parcelRequire("hzb7Z");


var $52Zu6 = parcelRequire("52Zu6");

var $k3teG = parcelRequire("k3teG");
function $db01c9b53f41c580$export$642c4e67bbdc0bc7(ether, unit = "wei") {
    return (0, $k3teG.parseUnits)(ether, (0, $52Zu6.etherUnits)[unit]);
}


var $k3teG = parcelRequire("k3teG");





var $9nZCP = parcelRequire("9nZCP");
const $7f2cd7efc5dd98b6$export$a25b430d4137a40 = ()=>{
    const queryClient = (0, $6d6ab9aaa62ea16f$export$22e77b9572c4fded)();
    const refetchQuery = (0, $9nZCP.useCallback)(async (queryKeys, waitFor = 4000)=>{
        await new Promise((res)=>setTimeout(()=>res(true), waitFor));
        for (const queryKey of queryKeys)queryClient.refetchQueries(queryKey);
    }, [
        queryClient
    ]);
    return refetchQuery;
};



var $9nZCP = parcelRequire("9nZCP");


const $d7f7b0934356ec58$export$6731f25587ad254d = ()=>{
    const navigate = (0, $cb6812e0fa529c57$export$9770f232ac06a008)();
    const osInstanceRef = (0, $9nZCP.useContext)((0, $e4f593b82d8858f8$export$20b5a34f45062e8b));
    const navigateAndScrollTop = (path)=>{
        navigate(path);
        osInstanceRef?.current?.osInstance().elements().viewport.scroll({
            top: 0
        });
    };
    return navigateAndScrollTop;
};


const $358b953fc6ce4b47$var$StyledButton = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Button))``;
const $358b953fc6ce4b47$var$DepositPaymentButton = ()=>{
    const { escrowTitle: escrowTitle, deliverableText: deliverableText, transactionUri: transactionUri, extraDescriptionUri: extraDescriptionUri, sendingQuantity: sendingQuantity, sellerAddress: sellerAddress, deadline: deadline, sendingToken: sendingToken, resetContext: resetContext } = (0, $fa4dc73a0abb4258$export$ab0988b836f3e0ac)();
    const [finalRecipientAddress, setFinalRecipientAddress] = (0, $9nZCP.useState)(sellerAddress);
    const publicClient = (0, $b9a08c139e2d6879$export$3ca3483c611a99c4)();
    const navigateAndScrollTop = (0, $d7f7b0934356ec58$export$6731f25587ad254d)();
    const refetchQuery = (0, $7f2cd7efc5dd98b6$export$a25b430d4137a40)();
    const [isSending, setIsSending] = (0, $9nZCP.useState)(false);
    const [isApproved, setIsApproved] = (0, $9nZCP.useState)(false);
    const { address: address } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    const { chain: chain } = (0, $b9a08c139e2d6879$export$553aaf59afc1a2d8)();
    const ensResult = (0, $b9a08c139e2d6879$export$882e13b9ff368f82)({
        name: sellerAddress,
        chainId: 1
    });
    const deadlineTimestamp = (0, $9nZCP.useMemo)(()=>BigInt(Math.floor(new Date(deadline).getTime() / 1000)), [
        deadline
    ]);
    const isNativeTransaction = sendingToken?.address === "native";
    const transactionValue = (0, $9nZCP.useMemo)(()=>isNativeTransaction ? (0, $db01c9b53f41c580$export$642c4e67bbdc0bc7)(sendingQuantity) : (0, $k3teG.parseUnits)(sendingQuantity, 18), [
        isNativeTransaction,
        sendingQuantity
    ]);
    (0, $9nZCP.useEffect)(()=>{
        setFinalRecipientAddress(ensResult.data || sellerAddress);
    }, [
        sellerAddress,
        ensResult.data
    ]);
    const { data: allowance, refetch: refetchAllowance } = (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        enabled: !isNativeTransaction,
        address: sendingToken?.address,
        abi: (0, $hzb7Z.erc20ABI),
        functionName: "allowance",
        args: [
            address,
            (0, $65cd6dc33c6d9133$export$eb29ec29b9f0e4e)?.[chain?.id]
        ]
    });
    (0, $9nZCP.useEffect)(()=>{
        if (!(0, $c62bd748620e6ea9$export$fce6876652108ab)(allowance)) setIsApproved(allowance >= transactionValue);
    }, [
        allowance,
        transactionValue
    ]);
    const templateData = (0, $9nZCP.useMemo)(()=>JSON.stringify({
            $schema: "../NewDisputeTemplate.schema.json",
            title: escrowTitle,
            description: deliverableText,
            question: "Which party abided by the terms of the contract?",
            answers: [
                {
                    title: "Refund the Buyer",
                    description: "Select this to return the funds to the Buyer."
                },
                {
                    title: "Pay the Seller",
                    description: "Select this to release the funds to the Seller."
                }
            ],
            policyURI: "ipfs://TODO",
            attachment: {
                label: "Transaction Terms",
                uri: extraDescriptionUri
            },
            frontendUrl: `https://escrow-v2.kleros.builders/#/my-transactions/%s`,
            arbitrableChainID: "421614",
            arbitrableAddress: "0x250AB0477346aDFC010585b58FbF61cff1d8f3ea",
            arbitratorChainID: "421614",
            arbitratorAddress: "0xA54e7A16d7460e38a8F324eF46782FB520d58CE8",
            metadata: {
                buyer: address,
                seller: sellerAddress,
                amount: sendingQuantity,
                token: isNativeTransaction ? "native" : sendingToken?.address,
                deadline: deadlineTimestamp.toString(),
                transactionUri: transactionUri
            },
            category: "Escrow",
            specification: "KIPXXX",
            aliases: {
                Buyer: address,
                Seller: sellerAddress
            },
            version: "1.0"
        }), [
        escrowTitle,
        deliverableText,
        extraDescriptionUri,
        sendingQuantity,
        sellerAddress,
        address,
        isNativeTransaction,
        sendingToken?.address,
        deadlineTimestamp,
        transactionUri
    ]);
    const { config: createNativeTransactionConfig } = (0, $65cd6dc33c6d9133$export$53db92ba21d0bb92)({
        enabled: isNativeTransaction && (0, $bc6948c94a5f7586$export$d1c4b691375413aa).test(finalRecipientAddress),
        args: [
            deadlineTimestamp,
            transactionUri,
            finalRecipientAddress,
            templateData,
            ""
        ],
        value: transactionValue
    });
    const { config: createERC20TransactionConfig } = (0, $65cd6dc33c6d9133$export$377faf72921dd28f)({
        enabled: !isNativeTransaction && !(0, $c62bd748620e6ea9$export$fce6876652108ab)(allowance) && allowance >= transactionValue && (0, $bc6948c94a5f7586$export$d1c4b691375413aa).test(finalRecipientAddress),
        args: [
            transactionValue,
            sendingToken?.address,
            deadlineTimestamp,
            transactionUri,
            finalRecipientAddress,
            templateData,
            ""
        ]
    });
    const { writeAsync: createNativeTransaction } = (0, $65cd6dc33c6d9133$export$dd34cb24bdc4e09b)(createNativeTransactionConfig);
    const { writeAsync: createERC20Transaction } = (0, $65cd6dc33c6d9133$export$3ffac8bdfc2eec65)(createERC20TransactionConfig);
    const { config: approveConfig } = (0, $b9a08c139e2d6879$export$f08fad0d21112083)({
        enabled: !isNativeTransaction,
        address: sendingToken?.address,
        abi: (0, $hzb7Z.erc20ABI),
        functionName: "approve",
        args: [
            (0, $65cd6dc33c6d9133$export$eb29ec29b9f0e4e)?.[chain?.id],
            transactionValue
        ]
    });
    const { writeAsync: approve } = (0, $b9a08c139e2d6879$export$f65fbf805a7dc8c5)(approveConfig);
    const handleApproveToken = async ()=>{
        if (!(0, $c62bd748620e6ea9$export$fce6876652108ab)(approve)) {
            setIsSending(true);
            try {
                const wrapResult = await (0, $6724d57570dc2c5f$export$27738200007bd40a)(async ()=>await approve().then((response)=>response.hash), publicClient);
                setIsApproved(wrapResult.status);
                await refetchAllowance();
            } catch (error) {
                console.error("Approval failed:", error);
                setIsApproved(false);
            } finally{
                setIsSending(false);
            }
        }
    };
    const handleCreateTransaction = async ()=>{
        const createTransaction = isNativeTransaction ? createNativeTransaction : createERC20Transaction;
        if (!(0, $c62bd748620e6ea9$export$fce6876652108ab)(createTransaction)) {
            setIsSending(true);
            try {
                const wrapResult = await (0, $6724d57570dc2c5f$export$27738200007bd40a)(async ()=>await createTransaction().then((response)=>response.hash), publicClient);
                if (wrapResult.status) {
                    refetchQuery([
                        [
                            "refetchOnBlock",
                            "useMyTransactionsQuery"
                        ],
                        [
                            "useUserQuery"
                        ]
                    ]);
                    resetContext();
                    navigateAndScrollTop("/my-transactions/display/1/desc/all");
                }
            } catch (error) {
                console.error("Transaction failed:", error);
            } finally{
                setIsSending(false);
            }
        }
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($358b953fc6ce4b47$var$StyledButton, {
        isLoading: isSending,
        disabled: isSending,
        text: isNativeTransaction || isApproved ? "Deposit the Payment" : "Approve Token",
        onClick: isNativeTransaction || isApproved ? handleCreateTransaction : handleApproveToken
    });
};
var $358b953fc6ce4b47$export$2e2bcd8739ae039 = $358b953fc6ce4b47$var$DepositPaymentButton;


const $fab3b51b2e28c7da$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 24px;
  margin-top: 24px;
  flex-wrap: wrap;
  justify-content: center;
`;
const $fab3b51b2e28c7da$var$NavigationButtons = ({ prevRoute: prevRoute, nextRoute: nextRoute })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($fab3b51b2e28c7da$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $34a71c005c6adc9c$export$2e2bcd8739ae039), {
                prevRoute: prevRoute
            }),
            prevRoute === "/new-transaction/notifications" ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $358b953fc6ce4b47$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $8c1d8079248e4601$export$2e2bcd8739ae039), {
                nextRoute: nextRoute
            })
        ]
    });
};
var $fab3b51b2e28c7da$export$2e2bcd8739ae039 = $fab3b51b2e28c7da$var$NavigationButtons;


const $46b299fcafadba5e$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $46b299fcafadba5e$var$Title = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($46b299fcafadba5e$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e5652d9f4b8c73d1$export$2e2bcd8739ae039), {
                text: "Title"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $196fe3f3927325b8$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $fab3b51b2e28c7da$export$2e2bcd8739ae039), {
                prevRoute: "/new-transaction/escrow-type",
                nextRoute: "/new-transaction/deliverable"
            })
        ]
    });
};
var $46b299fcafadba5e$export$2e2bcd8739ae039 = $46b299fcafadba5e$var$Title;



parcelRequire("9nZCP");


parcelRequire("9nZCP");


parcelRequire("9nZCP");


parcelRequire("9nZCP");
const $858ce776e424cb51$var$SvgGeneralEscrow = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        width: 48,
        height: 48,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
                clipPath: "url(#general-escrow_svg__a)",
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                    clipRule: "evenodd",
                    d: "M23.964 48C37.646 40.056 44.5 28.056 44.523 12L23.73 0 3 12c0 15.547 6.988 27.547 20.964 36ZM6.356 13.895 23.733 3.836l17.434 10.062c-.509 13.244-6.176 23.205-17.172 30.198-11.31-7.412-17.123-17.387-17.639-30.201Zm12.721 12.2h1.55v-8.156h2.79v-1.33h-7.13v1.33h2.79v8.155Zm4.827-7.176 2.407 3.51-2.524 3.665h1.726l1.765-2.686 1.77 2.686h1.727l-2.537-3.665 2.413-3.51h-1.725l-1.648 2.51-1.635-2.51h-1.739Z"
                })
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                    id: "general-escrow_svg__a",
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h48v48H0z"
                    })
                })
            })
        ]
    });
var $858ce776e424cb51$export$2e2bcd8739ae039 = $858ce776e424cb51$var$SvgGeneralEscrow;




const $6fb25a38865845a4$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 26px;
`;
const $6fb25a38865845a4$var$StyledLogo = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $858ce776e424cb51$export$2e2bcd8739ae039))`
  path {
    fill: ${({ theme: theme })=>theme.secondaryPurple};
  }
`;
const $6fb25a38865845a4$var$Title = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).p`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  width: 96px;
  text-align: center;
  margin: 0;
`;
const $6fb25a38865845a4$var$GeneralEscrow = ()=>{
    const { escrowType: escrowType, setEscrowType: setEscrowType } = (0, $fa4dc73a0abb4258$export$ab0988b836f3e0ac)();
    const handleSelect = ()=>{
        setEscrowType("general");
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($6fb25a38865845a4$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $573604e9c330a97f$export$94fdbc1f5368d5e4), {
                onClick: handleSelect,
                selected: escrowType === "general",
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($6fb25a38865845a4$var$StyledLogo, {})
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($6fb25a38865845a4$var$Title, {
                children: "General Escrow"
            })
        ]
    });
};
var $6fb25a38865845a4$export$2e2bcd8739ae039 = $6fb25a38865845a4$var$GeneralEscrow;



parcelRequire("9nZCP");


parcelRequire("9nZCP");
const $aa645da847adc54e$var$SvgCryptoSwap = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 48,
        height: 48,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M44.523 12c-.025 16.056-6.877 28.056-20.559 36C9.988 39.547 3 27.547 3 12L23.73 0l20.793 12Zm-20.79-8.164L6.356 13.895c.516 12.814 6.329 22.79 17.64 30.2 10.995-6.992 16.662-16.953 17.17-30.197L23.734 3.836Zm4.24 23.319-15.11.01-.001-1.186 15.11-.01-.002-2.522 6.172 3.11-6.168 3.119-.002-2.521Zm6.168-11.059-15.11.011-.002-2.52-6.168 3.118 6.173 3.11-.002-2.522 15.11-.01-.001-1.187Z",
            fill: "#9013FE"
        })
    });
var $aa645da847adc54e$export$2e2bcd8739ae039 = $aa645da847adc54e$var$SvgCryptoSwap;




const $35d2ee89438de315$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 26px;
  justify-content: center;
`;
const $35d2ee89438de315$var$StyledLogo = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $aa645da847adc54e$export$2e2bcd8739ae039))`
  path {
    fill: ${({ theme: theme })=>theme.secondaryPurple};
  }
`;
const $35d2ee89438de315$var$Title = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).p`
  display: flex;
  width: 100%;
  width: 96px;
  text-align: center;
  margin: 0;
  padding: 0 8px;
  flex-wrap: wrap;
`;
const $35d2ee89438de315$var$CryptoSwap = ()=>{
    const { escrowType: escrowType, setEscrowType: setEscrowType } = (0, $fa4dc73a0abb4258$export$ab0988b836f3e0ac)();
    const handleSelect = ()=>{
        setEscrowType("swap");
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($35d2ee89438de315$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $573604e9c330a97f$export$94fdbc1f5368d5e4), {
                onClick: handleSelect,
                selected: escrowType === "swap",
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($35d2ee89438de315$var$StyledLogo, {})
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($35d2ee89438de315$var$Title, {
                children: "Crypto Swap"
            })
        ]
    });
};
var $35d2ee89438de315$export$2e2bcd8739ae039 = $35d2ee89438de315$var$CryptoSwap;



const $573604e9c330a97f$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  justify-content: center;
  margin-bottom: 32px;
`;
const $573604e9c330a97f$export$94fdbc1f5368d5e4 = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Card))`
  display: flex;
  height: 96px;
  width: 96px;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  cursor: pointer;
  ${({ selected: selected, theme: theme })=>selected && (0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      border: 1px solid ${theme.primaryBlue};
    `}
`;
const $573604e9c330a97f$var$EscrowOptions = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($573604e9c330a97f$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $6fb25a38865845a4$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $35d2ee89438de315$export$2e2bcd8739ae039), {})
        ]
    });
};
var $573604e9c330a97f$export$2e2bcd8739ae039 = $573604e9c330a97f$var$EscrowOptions;




parcelRequire("9nZCP");





const $91ac01e90dfa4514$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  width: 84vw;

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      width: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(342, 618)};
    `)}
`;
const $91ac01e90dfa4514$var$Info = ()=>{
    const { escrowType: escrowType } = (0, $fa4dc73a0abb4258$export$ab0988b836f3e0ac)();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($91ac01e90dfa4514$var$Container, {
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.AlertMessage), {
            variant: "info",
            title: escrowType === "general" ? "General Escrow" : "Crypto Swap",
            msg: escrowType === "general" ? "Hiring an outside contractor? Use the General Escrow to safeguard your transactions. Use this option if you want to define the agreement under your own terms." : "Want to protect your crypto transaction? Use this option to create a safe cross-chain swap. One person escrows an asset based on Ethereum and the funds are released once assets on another blockchain have been moved."
        })
    });
};
var $91ac01e90dfa4514$export$2e2bcd8739ae039 = $91ac01e90dfa4514$var$Info;



const $8e926da7d46a5318$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $8e926da7d46a5318$var$TypeOfEscrow = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($8e926da7d46a5318$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e5652d9f4b8c73d1$export$2e2bcd8739ae039), {
                text: "What kind of escrow do you want to create?"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $573604e9c330a97f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $91ac01e90dfa4514$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $fab3b51b2e28c7da$export$2e2bcd8739ae039), {
                prevRoute: "",
                nextRoute: "/new-transaction/title"
            })
        ]
    });
};
var $8e926da7d46a5318$export$2e2bcd8739ae039 = $8e926da7d46a5318$var$TypeOfEscrow;



parcelRequire("9nZCP");




parcelRequire("9nZCP");
const $858f1539c64df920$var$SvgHeroLightmodeMobile = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        viewBox: "0 0 390 151",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("g", {
                clipPath: "url(#hero-lightmode-mobile_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        d: "M0 0h390v110.413L195.181 151 0 110.337V0Z",
                        fill: "#4D00B4"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        d: "M8.882 112.188c3.836-3.79 5.755-8.555 5.755-14.292L4.35 91.94 0 94.452V95l.024 1.341 4.325-2.496 8.622 4.99c-.211 5.249-2.213 9.537-6.06 12.942l1.97.411ZM390 95v-.88l-3.776-2.179-10.286 5.955c0 5.719 1.906 10.471 5.718 14.256l1.968-.41c-3.822-3.4-5.81-7.677-6.021-12.906l8.622-4.991 3.761 2.17L390 95Z",
                        fill: "#5A00D3"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M54.939 115.759c-6.789-3.942-10.189-9.897-10.2-17.863l10.316-5.955 10.286 5.955c0 7.714-3.467 13.668-10.402 17.863Zm8.737-16.923-8.622-4.991-8.65 4.992c.252 6.572 3.064 11.515 8.52 14.984 5.612-3.677 8.496-8.627 8.752-14.985ZM345.836 97.896c-.012 7.966-3.412 13.921-10.201 17.863-6.935-4.195-10.402-10.149-10.402-17.863l10.286-5.955 10.317 5.955Zm-10.316-4.051-8.622 4.99c.256 6.359 3.14 11.309 8.753 14.986 5.455-3.469 8.268-8.412 8.52-14.984l-8.651-4.992Z",
                        fill: "#5A00D3"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M6.82 65.753c-3.176-1.844-4.767-4.63-4.772-8.358l4.827-2.786 4.813 2.786c0 3.61-1.623 6.396-4.867 8.358Zm4.089-7.918L6.875 55.5l-4.048 2.336c.118 3.075 1.434 5.388 3.987 7.01 2.625-1.72 3.975-4.036 4.095-7.01Zm46.617 7.918c-3.177-1.844-4.768-4.63-4.773-8.358l4.827-2.786 4.813 2.786c0 3.61-1.622 6.396-4.867 8.358Zm4.088-7.918L57.58 55.5l-4.048 2.336c.118 3.075 1.434 5.388 3.987 7.01 2.626-1.72 3.975-4.036 4.095-7.01Z",
                        fill: "#9013FE"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M32.828 81.913c1.906-1.107 2.86-2.778 2.864-5.015l-2.897-1.671-2.887 1.671c0 2.166.973 3.837 2.92 5.015Zm-2.453-4.75 2.42-1.402 2.43 1.401c-.072 1.845-.861 3.233-2.393 4.207-1.575-1.032-2.385-2.422-2.457-4.207Zm53.158 4.75c1.906-1.107 2.86-2.778 2.864-5.015L83.5 75.227l-2.887 1.671c0 2.166.973 3.837 2.92 5.015Zm-2.453-4.75 2.42-1.402 2.43 1.401c-.071 1.845-.86 3.233-2.393 4.207-1.575-1.032-2.385-2.422-2.457-4.207Z",
                        fill: "#F2E3FF"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M388.525 57.395c-.005 3.728-1.596 6.514-4.772 8.358-3.245-1.962-4.868-4.748-4.868-8.358l4.813-2.786 4.827 2.786Zm-4.826-1.895-4.035 2.335c.12 2.975 1.47 5.291 4.096 7.012 2.552-1.623 3.868-3.936 3.986-7.011l-4.047-2.336Zm-45.878 1.895c-.006 3.728-1.597 6.514-4.773 8.358-3.245-1.962-4.867-4.748-4.867-8.358l4.812-2.786 4.828 2.786Zm-4.827-1.895-4.034 2.335c.12 2.975 1.469 5.291 4.095 7.012 2.553-1.623 3.869-3.936 3.987-7.011l-4.048-2.336Z",
                        fill: "#9013FE"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M357.745 81.913c-1.906-1.107-2.86-2.778-2.864-5.015l2.897-1.671 2.888 1.671c0 2.166-.974 3.837-2.921 5.015Zm2.453-4.75-2.421-1.402-2.428 1.401c.071 1.845.86 3.233 2.392 4.207 1.575-1.032 2.385-2.422 2.457-4.207Zm-53.158 4.75c-1.905-1.107-2.86-2.778-2.863-5.015l2.896-1.671 2.888 1.671c0 2.166-.974 3.837-2.921 5.015Zm2.453-4.75-2.42-1.402-2.429 1.401c.071 1.845.86 3.233 2.392 4.207 1.576-1.032 2.385-2.422 2.457-4.207Z",
                        fill: "#F2E3FF"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "m203.159 69.98-15.12-.668-8.829 10.88 6.232 14.58 15.202.964 8.637-12.299-6.122-13.457Zm-13.351 24.366 8.008-2.067 1.41 2.662-9.418-.595Zm9.604-2.764 7.011-5.157-5.618 7.846-1.393-2.689Zm-13.088 1.616-.23-9.074 9.496 6.696-9.266 2.378Zm-1.749-1.798-4.369-10.167 4.188.876.181 9.29Zm14.933-1.932 1.708-12.47 6.471 6.485-8.179 5.985Zm-11.371-7.581 10.934-4.718-1.586 11.855-9.348-7.137Zm-7.66-2.175 6.234-7.774-2.066 8.646-4.168-.872Zm21.268-4.969 1.362-2.76 3.706 7.848-5.068-5.088Zm-14.513 4.159 1.835-7.812 8.738 3.716-10.573 4.096Zm12.62-5.426-7.341-3.171 8.899.357-1.558 2.814Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M171.957 70.53c.026 17.535 7.508 30.641 22.445 39.317 15.259-9.232 22.889-22.338 22.889-39.317l-22.633-13.106-22.701 13.106Zm22.438 38.548c14.737-9.038 22.123-21.742 22.235-38.168l-21.973-12.723-22.039 12.724c.132 16.98 7.379 29.674 21.777 38.167Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "m168 68.33 26.66-15.396 26.581 15.397v.762c0 19.45-8.782 34.499-26.185 45.032l-.669.405-.675-.393c-17.087-9.928-25.681-25-25.711-45.042l-.001-.764Zm51.922.763c0 18.959-8.516 33.593-25.548 43.901-16.673-9.688-25.024-24.321-25.054-43.901l25.339-14.634 25.263 14.634Z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                    id: "hero-lightmode-mobile_svg__a",
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h390v151H0z"
                    })
                })
            })
        ]
    });
var $858f1539c64df920$export$2e2bcd8739ae039 = $858f1539c64df920$var$SvgHeroLightmodeMobile;



parcelRequire("9nZCP");
const $9dc6cda8ea8ece2c$var$SvgHeroDarkmodeMobile = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        viewBox: "0 0 390 151",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("g", {
                clipPath: "url(#hero-darkmode-mobile_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        d: "M0 0h390v110.413L195.181 151 0 110.337V0Z",
                        fill: "#7E1BD4"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        d: "M8.882 112.188c3.836-3.79 5.755-8.555 5.755-14.292L4.35 91.94 0 94.452V95l.024 1.341 4.325-2.496 8.622 4.99c-.211 5.249-2.213 9.537-6.06 12.942l1.97.411ZM390 95v-.88l-3.776-2.179-10.286 5.955c0 5.719 1.906 10.471 5.718 14.256l1.968-.41c-3.822-3.4-5.81-7.677-6.021-12.906l8.622-4.991 3.761 2.17L390 95Z",
                        fill: "#5A00D3"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M54.939 115.759c-6.789-3.942-10.189-9.897-10.2-17.863l10.316-5.955 10.286 5.955c0 7.714-3.467 13.668-10.402 17.863Zm8.737-16.923-8.622-4.991-8.65 4.992c.252 6.572 3.064 11.515 8.52 14.984 5.612-3.677 8.496-8.627 8.752-14.985ZM345.836 97.896c-.012 7.966-3.412 13.921-10.201 17.863-6.935-4.195-10.402-10.149-10.402-17.863l10.286-5.955 10.317 5.955Zm-10.316-4.051-8.622 4.99c.256 6.359 3.14 11.309 8.753 14.986 5.455-3.469 8.268-8.412 8.52-14.984l-8.651-4.992Z",
                        fill: "#5A00D3"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M6.82 65.753c-3.176-1.844-4.767-4.63-4.772-8.358l4.827-2.786 4.813 2.786c0 3.61-1.623 6.396-4.867 8.358Zm4.089-7.918L6.875 55.5l-4.048 2.336c.118 3.075 1.434 5.388 3.987 7.01 2.625-1.72 3.975-4.036 4.095-7.01Zm46.617 7.918c-3.177-1.844-4.768-4.63-4.773-8.358l4.827-2.786 4.813 2.786c0 3.61-1.622 6.396-4.867 8.358Zm4.088-7.918L57.58 55.5l-4.048 2.336c.118 3.075 1.434 5.388 3.987 7.01 2.626-1.72 3.975-4.036 4.095-7.01Z",
                        fill: "#9013FE"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M32.828 81.913c1.906-1.107 2.86-2.778 2.864-5.015l-2.897-1.671-2.887 1.671c0 2.166.973 3.837 2.92 5.015Zm-2.453-4.75 2.42-1.402 2.43 1.401c-.072 1.845-.861 3.233-2.393 4.207-1.575-1.032-2.385-2.422-2.457-4.207Zm53.158 4.75c1.906-1.107 2.86-2.778 2.864-5.015L83.5 75.227l-2.887 1.671c0 2.166.973 3.837 2.92 5.015Zm-2.453-4.75 2.42-1.402 2.43 1.401c-.071 1.845-.86 3.233-2.393 4.207-1.575-1.032-2.385-2.422-2.457-4.207Z",
                        fill: "#F2E3FF"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M388.525 57.395c-.005 3.728-1.596 6.514-4.772 8.358-3.245-1.962-4.868-4.748-4.868-8.358l4.813-2.786 4.827 2.786Zm-4.826-1.895-4.035 2.335c.12 2.975 1.47 5.291 4.096 7.012 2.552-1.623 3.868-3.936 3.986-7.011l-4.047-2.336Zm-45.878 1.895c-.006 3.728-1.597 6.514-4.773 8.358-3.245-1.962-4.867-4.748-4.867-8.358l4.812-2.786 4.828 2.786Zm-4.827-1.895-4.034 2.335c.12 2.975 1.469 5.291 4.095 7.012 2.553-1.623 3.869-3.936 3.987-7.011l-4.048-2.336Z",
                        fill: "#9013FE"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M357.745 81.913c-1.906-1.107-2.86-2.778-2.864-5.015l2.897-1.671 2.888 1.671c0 2.166-.974 3.837-2.921 5.015Zm2.453-4.75-2.421-1.402-2.428 1.401c.071 1.845.86 3.233 2.392 4.207 1.575-1.032 2.385-2.422 2.457-4.207Zm-53.158 4.75c-1.905-1.107-2.86-2.778-2.863-5.015l2.896-1.671 2.888 1.671c0 2.166-.974 3.837-2.921 5.015Zm2.453-4.75-2.42-1.402-2.429 1.401c.071 1.845.86 3.233 2.392 4.207 1.576-1.032 2.385-2.422 2.457-4.207Z",
                        fill: "#F2E3FF"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "m203.159 69.98-15.12-.668-8.829 10.88 6.232 14.58 15.202.964 8.637-12.299-6.122-13.457Zm-13.351 24.366 8.008-2.067 1.41 2.662-9.418-.595Zm9.604-2.764 7.011-5.157-5.618 7.846-1.393-2.689Zm-13.088 1.616-.23-9.074 9.496 6.696-9.266 2.378Zm-1.749-1.798-4.369-10.167 4.188.876.181 9.29Zm14.933-1.932 1.708-12.47 6.471 6.485-8.179 5.985Zm-11.371-7.581 10.934-4.718-1.586 11.855-9.348-7.137Zm-7.66-2.175 6.234-7.774-2.066 8.646-4.168-.872Zm21.268-4.969 1.362-2.76 3.706 7.848-5.068-5.088Zm-14.513 4.159 1.835-7.812 8.738 3.716-10.573 4.096Zm12.62-5.426-7.341-3.171 8.899.357-1.558 2.814Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M171.957 70.53c.026 17.535 7.508 30.641 22.445 39.317 15.259-9.232 22.889-22.338 22.889-39.317l-22.633-13.106-22.701 13.106Zm22.438 38.548c14.737-9.038 22.123-21.742 22.235-38.168l-21.973-12.723-22.039 12.724c.132 16.98 7.379 29.674 21.777 38.167Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "m168 68.33 26.66-15.396 26.581 15.397v.762c0 19.45-8.782 34.499-26.185 45.032l-.669.405-.675-.393c-17.087-9.928-25.681-25-25.711-45.042l-.001-.764Zm51.922.763c0 18.959-8.516 33.593-25.548 43.901-16.673-9.688-25.024-24.321-25.054-43.901l25.339-14.634 25.263 14.634Z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                    id: "hero-darkmode-mobile_svg__a",
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h390v151H0z"
                    })
                })
            })
        ]
    });
var $9dc6cda8ea8ece2c$export$2e2bcd8739ae039 = $9dc6cda8ea8ece2c$var$SvgHeroDarkmodeMobile;



parcelRequire("9nZCP");
const $51cfe7b8bb4bfff1$var$SvgHeroLightmodeDesktop = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        viewBox: "0 0 1440 207",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M0 0h1440v57L720 207 0 57V0Z",
                fill: "#4D00B4"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M295.426 118.548c.367-2.191.551-4.476.551-6.854l-18.461-10.686-17.581 10.146 4.347.906 13.232-7.636 15.474 8.957a37.415 37.415 0 0 1-.458 4.564l2.896.603ZM385.648 137.345c6.886-6.803 10.329-15.353 10.329-25.651l-18.461-10.686L359 111.694c.013 8.377 2.113 15.514 6.3 21.411l4.533.945c-4.928-5.504-7.526-12.36-7.844-20.666l15.525-8.96 15.474 8.957c-.379 9.419-3.972 17.115-10.878 23.227l3.538.737ZM1075.15 133.012c4.14-5.879 6.22-12.985 6.23-21.318l-18.52-10.686-18.46 10.686c0 10.265 3.43 18.793 10.27 25.585l3.53-.736c-6.86-6.101-10.43-13.776-10.81-23.162l15.48-8.957 15.52 8.96c-.31 8.257-2.88 15.081-7.76 20.568l4.52-.94ZM1180.35 111.096l-17.48-10.088-18.47 10.686c0 2.35.18 4.609.54 6.778l2.9-.604c-.24-1.45-.38-2.945-.45-4.487l15.48-8.957 13.13 7.578 4.35-.906Z",
                fill: "#5A00D3"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M468.307 143.753c-12.183-7.075-18.286-17.761-18.307-32.059l18.516-10.686 18.46 10.686c0 13.845-6.223 24.531-18.669 32.059Zm15.681-30.372-15.474-8.957-15.526 8.96c.453 11.794 5.5 20.665 15.292 26.892 10.072-6.6 15.248-15.483 15.708-26.895ZM990.381 111.694c-.022 14.298-6.124 24.984-18.308 32.059-12.446-7.528-18.669-18.214-18.669-32.059l18.461-10.686 18.516 10.686Zm-18.514-7.27-15.474 8.957c.459 11.412 5.636 20.295 15.708 26.895 9.791-6.227 14.839-15.098 15.291-26.892l-15.525-8.96Z",
                fill: "#5A00D3"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M85.566 54.004c-5.7-3.31-8.556-8.31-8.566-15l8.663-5 8.638 5c0 6.478-2.912 11.478-8.735 15Zm7.337-14.21-7.24-4.192-7.265 4.193c.212 5.518 2.574 9.669 7.155 12.582 4.713-3.088 7.135-7.244 7.35-12.584Zm77.097-.79c.01 6.69 2.865 11.69 8.566 15 5.823-3.522 8.735-8.522 8.735-15l-8.638-5-8.663 5Zm8.662-3.402 7.24 4.191c-.215 5.34-2.637 9.496-7.349 12.584-4.582-2.913-6.943-7.064-7.155-12.582l7.264-4.193Zm97.903 18.402c-5.7-3.31-8.556-8.31-8.566-15l8.664-5 8.637 5c0 6.478-2.911 11.478-8.735 15Zm7.337-14.21-7.24-4.192-7.264 4.193c.211 5.518 2.573 9.669 7.154 12.582 4.713-3.088 7.135-7.244 7.35-12.584Zm84.097-.79c.011 6.69 2.866 11.69 8.566 15 5.824-3.522 8.736-8.522 8.736-15l-8.638-5-8.664 5Zm8.663-3.402 7.24 4.191c-.215 5.34-2.637 9.496-7.35 12.584-4.581-2.913-6.942-7.064-7.154-12.582l7.264-4.193ZM459 39.004c.01 6.69 2.865 11.69 8.566 15 5.823-3.522 8.735-8.522 8.735-15l-8.638-5-8.663 5Zm8.662-3.402 7.24 4.191c-.215 5.34-2.637 9.496-7.349 12.584-4.582-2.913-6.943-7.064-7.155-12.582l7.264-4.193Z",
                fill: "#9013FE"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M132.241 83.004c3.42-1.986 5.134-4.986 5.14-9l-5.198-3-5.183 3c0 3.887 1.747 6.887 5.241 9Zm-4.402-8.526 4.344-2.515 4.359 2.515c-.127 3.312-1.544 5.802-4.293 7.55-2.828-1.853-4.281-4.347-4.41-7.55Zm102.542-.474c-.006 4.014-1.719 7.014-5.14 9-3.494-2.113-5.241-5.113-5.241-9l5.183-3 5.198 3Zm-5.198-2.041-4.344 2.515c.129 3.203 1.582 5.697 4.41 7.55 2.749-1.748 4.166-4.239 4.293-7.55l-4.359-2.515Zm98.058 11.04c3.421-1.985 5.134-4.985 5.14-9l-5.198-3-5.183 3c0 3.888 1.747 6.888 5.241 9Zm-4.402-8.525 4.344-2.515 4.359 2.515c-.127 3.312-1.544 5.802-4.293 7.55-2.828-1.853-4.281-4.347-4.41-7.55Zm109.542-.474c-.006 4.014-1.72 7.014-5.14 9-3.494-2.113-5.241-5.113-5.241-9l5.182-3 5.199 3Zm-5.198-2.041-4.344 2.515c.129 3.203 1.582 5.697 4.41 7.55 2.749-1.748 4.165-4.239 4.293-7.55l-4.359-2.515Zm96.198 2.04c-.006 4.015-1.719 7.015-5.14 9-3.494-2.112-5.241-5.112-5.241-9l5.183-3 5.198 3Zm-5.198-2.04-4.344 2.515c.129 3.203 1.582 5.697 4.41 7.55 2.749-1.748 4.166-4.239 4.293-7.55l-4.359-2.515Z",
                fill: "#F2E3FF"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1354.81 54.004c5.71-3.31 8.56-8.31 8.57-15l-8.66-5-8.64 5c0 6.478 2.91 11.478 8.73 15Zm-7.33-14.21 7.24-4.192 7.26 4.193c-.21 5.518-2.57 9.669-7.15 12.582-4.72-3.088-7.14-7.244-7.35-12.584Zm-77.1-.79c-.01 6.69-2.86 11.69-8.57 15-5.82-3.522-8.73-8.522-8.73-15l8.64-5 8.66 5Zm-8.66-3.402-7.24 4.191c.21 5.34 2.63 9.496 7.35 12.584 4.58-2.913 6.94-7.064 7.15-12.582l-7.26-4.193Zm-97.91 18.402c5.71-3.31 8.56-8.31 8.57-15l-8.66-5-8.64 5c0 6.478 2.91 11.478 8.73 15Zm-7.33-14.21 7.24-4.192 7.26 4.193c-.21 5.518-2.57 9.669-7.15 12.582-4.72-3.088-7.14-7.244-7.35-12.584Zm-84.1-.79c-.01 6.69-2.86 11.69-8.57 15-5.82-3.522-8.73-8.522-8.73-15l8.64-5 8.66 5Zm-8.66-3.402-7.24 4.191c.21 5.34 2.63 9.496 7.35 12.584 4.58-2.913 6.94-7.064 7.15-12.582l-7.26-4.193Zm-82.339 3.402c-.01 6.69-2.866 11.69-8.566 15-5.824-3.522-8.735-8.522-8.735-15l8.637-5 8.664 5Zm-8.663-3.402-7.24 4.191c.215 5.34 2.637 9.496 7.35 12.584 4.581-2.913 6.943-7.064 7.154-12.582l-7.264-4.193Z",
                fill: "#9013FE"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1308.14 83.004c-3.42-1.986-5.13-4.986-5.14-9l5.2-3 5.18 3c0 3.887-1.75 6.887-5.24 9Zm4.4-8.526-4.34-2.515-4.36 2.515c.13 3.312 1.54 5.802 4.29 7.55 2.83-1.853 4.28-4.347 4.41-7.55ZM1210 74.004c.01 4.014 1.72 7.014 5.14 9 3.49-2.113 5.24-5.113 5.24-9l-5.18-3-5.2 3Zm5.2-2.041 4.34 2.515c-.13 3.203-1.58 5.697-4.41 7.55-2.75-1.748-4.16-4.239-4.29-7.55l4.36-2.515Zm-98.06 11.04c-3.42-1.985-5.13-4.985-5.14-9l5.2-3 5.18 3c0 3.888-1.75 6.888-5.24 9Zm4.4-8.525-4.34-2.515-4.36 2.515c.13 3.312 1.54 5.802 4.29 7.55 2.83-1.853 4.28-4.347 4.41-7.55ZM1012 74.004c.01 4.014 1.72 7.014 5.14 9 3.49-2.113 5.24-5.113 5.24-9l-5.18-3-5.2 3Zm5.2-2.041 4.34 2.515c-.13 3.203-1.58 5.697-4.41 7.55-2.75-1.748-4.16-4.239-4.29-7.55l4.36-2.515Zm-96.2 2.04c.006 4.015 1.719 7.015 5.139 9 3.495-2.112 5.242-5.112 5.242-9l-5.183-3-5.198 3Zm5.197-2.04 4.345 2.515c-.129 3.203-1.583 5.697-4.41 7.55-2.749-1.748-4.166-4.239-4.293-7.55l4.358-2.515Z",
                fill: "#F2E3FF"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m735.18 61.594-27.135-1.2-15.846 19.527 11.185 26.168 27.283 1.729 15.5-22.073-10.987-24.151Zm-23.961 43.729 14.373-3.71 2.529 4.779-16.902-1.069Zm17.237-4.96 12.582-9.256-10.082 14.081-2.5-4.825Zm-23.49 2.899-.412-16.285 17.042 12.018-16.63 4.267Zm-3.138-3.227-7.842-18.246 7.516 1.572.326 16.674Zm26.8-3.467 3.066-22.38 11.613 11.638-14.679 10.742ZM708.22 82.963l19.622-8.467-2.846 21.276-16.776-12.81Zm-13.747-3.904 11.188-13.951-3.708 15.516-7.48-1.565Zm38.17-8.917 2.444-4.954 6.652 14.085-9.096-9.131Zm-26.048 7.464 3.294-14.02 15.682 6.668-18.976 7.352Zm22.65-9.738-13.176-5.691 15.973.64-2.797 5.05Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M679.181 62.58c.047 31.47 13.475 54.991 40.283 70.563 27.386-16.569 41.079-40.09 41.079-70.563l-40.62-23.52-40.742 23.52Zm40.271 69.183c26.448-16.221 39.704-39.022 39.905-68.5l-39.435-22.835-39.554 22.835c.236 30.474 13.244 53.257 39.084 68.5Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M672.08 58.633 719.927 31l47.705 27.634V60c0 34.907-15.761 61.916-46.995 80.819l-1.2.726-1.212-.704c-30.665-17.818-46.089-44.868-46.143-80.837l-.002-1.372ZM765.265 60c0 34.026-15.284 60.289-45.852 78.79-29.923-17.387-44.911-43.65-44.963-78.79l45.475-26.263 45.34 26.263Z",
                fill: "#fff"
            })
        ]
    });
var $51cfe7b8bb4bfff1$export$2e2bcd8739ae039 = $51cfe7b8bb4bfff1$var$SvgHeroLightmodeDesktop;



parcelRequire("9nZCP");
const $4fed226dd3995e62$var$SvgHeroDarkmodeDesktop = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        viewBox: "0 0 1440 207",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M0 0h1440v57L720 207 0 57V0Z",
                fill: "#7E1BD4"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M295.426 118.548c.367-2.191.551-4.476.551-6.854l-18.461-10.686-17.581 10.146 4.347.906 13.232-7.636 15.474 8.957a37.415 37.415 0 0 1-.458 4.564l2.896.603ZM385.648 137.345c6.886-6.803 10.329-15.353 10.329-25.651l-18.461-10.686L359 111.694c.013 8.377 2.113 15.514 6.3 21.411l4.533.945c-4.928-5.504-7.526-12.36-7.844-20.666l15.525-8.96 15.474 8.957c-.379 9.419-3.972 17.115-10.878 23.227l3.538.737ZM1075.15 133.012c4.14-5.879 6.22-12.985 6.23-21.318l-18.52-10.686-18.46 10.686c0 10.265 3.43 18.793 10.27 25.585l3.53-.736c-6.86-6.101-10.43-13.776-10.81-23.162l15.48-8.957 15.52 8.96c-.31 8.257-2.88 15.081-7.76 20.568l4.52-.94ZM1180.35 111.096l-17.48-10.088-18.47 10.686c0 2.35.18 4.609.54 6.778l2.9-.604c-.24-1.45-.38-2.945-.45-4.487l15.48-8.957 13.13 7.578 4.35-.906Z",
                fill: "#5A00D3"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M468.307 143.753c-12.183-7.075-18.286-17.761-18.307-32.059l18.516-10.686 18.46 10.686c0 13.845-6.223 24.531-18.669 32.059Zm15.681-30.372-15.474-8.957-15.526 8.96c.453 11.794 5.5 20.665 15.292 26.892 10.072-6.6 15.248-15.483 15.708-26.895ZM990.381 111.694c-.022 14.298-6.124 24.984-18.308 32.059-12.446-7.528-18.669-18.214-18.669-32.059l18.461-10.686 18.516 10.686Zm-18.514-7.27-15.474 8.957c.459 11.412 5.636 20.295 15.708 26.895 9.791-6.227 14.839-15.098 15.291-26.892l-15.525-8.96Z",
                fill: "#5A00D3"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M85.566 54.004c-5.7-3.31-8.556-8.31-8.566-15l8.663-5 8.638 5c0 6.478-2.912 11.478-8.735 15Zm7.337-14.21-7.24-4.192-7.265 4.193c.212 5.518 2.574 9.669 7.155 12.582 4.713-3.088 7.135-7.244 7.35-12.584Zm77.097-.79c.01 6.69 2.865 11.69 8.566 15 5.823-3.522 8.735-8.522 8.735-15l-8.638-5-8.663 5Zm8.662-3.402 7.24 4.191c-.215 5.34-2.637 9.496-7.349 12.584-4.582-2.913-6.943-7.064-7.155-12.582l7.264-4.193Zm97.903 18.402c-5.7-3.31-8.556-8.31-8.566-15l8.664-5 8.637 5c0 6.478-2.911 11.478-8.735 15Zm7.337-14.21-7.24-4.192-7.264 4.193c.211 5.518 2.573 9.669 7.154 12.582 4.713-3.088 7.135-7.244 7.35-12.584Zm84.097-.79c.011 6.69 2.866 11.69 8.566 15 5.824-3.522 8.736-8.522 8.736-15l-8.638-5-8.664 5Zm8.663-3.402 7.24 4.191c-.215 5.34-2.637 9.496-7.35 12.584-4.581-2.913-6.942-7.064-7.154-12.582l7.264-4.193ZM459 39.004c.01 6.69 2.865 11.69 8.566 15 5.823-3.522 8.735-8.522 8.735-15l-8.638-5-8.663 5Zm8.662-3.402 7.24 4.191c-.215 5.34-2.637 9.496-7.349 12.584-4.582-2.913-6.943-7.064-7.155-12.582l7.264-4.193Z",
                fill: "#9013FE"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M132.241 83.004c3.42-1.986 5.134-4.986 5.14-9l-5.198-3-5.183 3c0 3.887 1.747 6.887 5.241 9Zm-4.402-8.526 4.344-2.515 4.359 2.515c-.127 3.312-1.544 5.802-4.293 7.55-2.828-1.853-4.281-4.347-4.41-7.55Zm102.542-.474c-.006 4.014-1.719 7.014-5.14 9-3.494-2.113-5.241-5.113-5.241-9l5.183-3 5.198 3Zm-5.198-2.041-4.344 2.515c.129 3.203 1.582 5.697 4.41 7.55 2.749-1.748 4.166-4.239 4.293-7.55l-4.359-2.515Zm98.058 11.04c3.421-1.985 5.134-4.985 5.14-9l-5.198-3-5.183 3c0 3.888 1.747 6.888 5.241 9Zm-4.402-8.525 4.344-2.515 4.359 2.515c-.127 3.312-1.544 5.802-4.293 7.55-2.828-1.853-4.281-4.347-4.41-7.55Zm109.542-.474c-.006 4.014-1.72 7.014-5.14 9-3.494-2.113-5.241-5.113-5.241-9l5.182-3 5.199 3Zm-5.198-2.041-4.344 2.515c.129 3.203 1.582 5.697 4.41 7.55 2.749-1.748 4.165-4.239 4.293-7.55l-4.359-2.515Zm96.198 2.04c-.006 4.015-1.719 7.015-5.14 9-3.494-2.112-5.241-5.112-5.241-9l5.183-3 5.198 3Zm-5.198-2.04-4.344 2.515c.129 3.203 1.582 5.697 4.41 7.55 2.749-1.748 4.166-4.239 4.293-7.55l-4.359-2.515Z",
                fill: "#F2E3FF"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1354.81 54.004c5.71-3.31 8.56-8.31 8.57-15l-8.66-5-8.64 5c0 6.478 2.91 11.478 8.73 15Zm-7.33-14.21 7.24-4.192 7.26 4.193c-.21 5.518-2.57 9.669-7.15 12.582-4.72-3.088-7.14-7.244-7.35-12.584Zm-77.1-.79c-.01 6.69-2.86 11.69-8.57 15-5.82-3.522-8.73-8.522-8.73-15l8.64-5 8.66 5Zm-8.66-3.402-7.24 4.191c.21 5.34 2.63 9.496 7.35 12.584 4.58-2.913 6.94-7.064 7.15-12.582l-7.26-4.193Zm-97.91 18.402c5.71-3.31 8.56-8.31 8.57-15l-8.66-5-8.64 5c0 6.478 2.91 11.478 8.73 15Zm-7.33-14.21 7.24-4.192 7.26 4.193c-.21 5.518-2.57 9.669-7.15 12.582-4.72-3.088-7.14-7.244-7.35-12.584Zm-84.1-.79c-.01 6.69-2.86 11.69-8.57 15-5.82-3.522-8.73-8.522-8.73-15l8.64-5 8.66 5Zm-8.66-3.402-7.24 4.191c.21 5.34 2.63 9.496 7.35 12.584 4.58-2.913 6.94-7.064 7.15-12.582l-7.26-4.193Zm-82.339 3.402c-.01 6.69-2.866 11.69-8.566 15-5.824-3.522-8.735-8.522-8.735-15l8.637-5 8.664 5Zm-8.663-3.402-7.24 4.191c.215 5.34 2.637 9.496 7.35 12.584 4.581-2.913 6.943-7.064 7.154-12.582l-7.264-4.193Z",
                fill: "#9013FE"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1308.14 83.004c-3.42-1.986-5.13-4.986-5.14-9l5.2-3 5.18 3c0 3.887-1.75 6.887-5.24 9Zm4.4-8.526-4.34-2.515-4.36 2.515c.13 3.312 1.54 5.802 4.29 7.55 2.83-1.853 4.28-4.347 4.41-7.55ZM1210 74.004c.01 4.014 1.72 7.014 5.14 9 3.49-2.113 5.24-5.113 5.24-9l-5.18-3-5.2 3Zm5.2-2.041 4.34 2.515c-.13 3.203-1.58 5.697-4.41 7.55-2.75-1.748-4.16-4.239-4.29-7.55l4.36-2.515Zm-98.06 11.04c-3.42-1.985-5.13-4.985-5.14-9l5.2-3 5.18 3c0 3.888-1.75 6.888-5.24 9Zm4.4-8.525-4.34-2.515-4.36 2.515c.13 3.312 1.54 5.802 4.29 7.55 2.83-1.853 4.28-4.347 4.41-7.55ZM1012 74.004c.01 4.014 1.72 7.014 5.14 9 3.49-2.113 5.24-5.113 5.24-9l-5.18-3-5.2 3Zm5.2-2.041 4.34 2.515c-.13 3.203-1.58 5.697-4.41 7.55-2.75-1.748-4.16-4.239-4.29-7.55l4.36-2.515Zm-96.2 2.04c.006 4.015 1.719 7.015 5.139 9 3.495-2.112 5.242-5.112 5.242-9l-5.183-3-5.198 3Zm5.197-2.04 4.345 2.515c-.129 3.203-1.583 5.697-4.41 7.55-2.749-1.748-4.166-4.239-4.293-7.55l4.358-2.515Z",
                fill: "#F2E3FF"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m735.18 61.594-27.135-1.2-15.846 19.527 11.185 26.168 27.283 1.729 15.5-22.073-10.987-24.151Zm-23.961 43.729 14.373-3.71 2.529 4.779-16.902-1.069Zm17.237-4.96 12.582-9.256-10.082 14.081-2.5-4.825Zm-23.49 2.899-.412-16.285 17.042 12.018-16.63 4.267Zm-3.138-3.227-7.842-18.246 7.516 1.572.326 16.674Zm26.8-3.467 3.066-22.38 11.613 11.638-14.679 10.742ZM708.22 82.963l19.622-8.467-2.846 21.276-16.776-12.81Zm-13.747-3.904 11.188-13.951-3.708 15.516-7.48-1.565Zm38.17-8.917 2.444-4.954 6.652 14.085-9.096-9.131Zm-26.048 7.464 3.294-14.02 15.682 6.668-18.976 7.352Zm22.65-9.738-13.176-5.691 15.973.64-2.797 5.05Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M679.181 62.58c.047 31.47 13.475 54.991 40.283 70.563 27.386-16.569 41.079-40.09 41.079-70.563l-40.62-23.52-40.742 23.52Zm40.271 69.183c26.448-16.221 39.704-39.022 39.905-68.5l-39.435-22.835-39.554 22.835c.236 30.474 13.244 53.257 39.084 68.5Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M672.08 58.633 719.927 31l47.705 27.634V60c0 34.907-15.761 61.916-46.995 80.819l-1.2.726-1.212-.704c-30.665-17.818-46.089-44.868-46.143-80.837l-.002-1.372ZM765.265 60c0 34.026-15.284 60.289-45.852 78.79-29.923-17.387-44.911-43.65-44.963-78.79l45.475-26.263 45.34 26.263Z",
                fill: "#fff"
            })
        ]
    });
var $4fed226dd3995e62$export$2e2bcd8739ae039 = $4fed226dd3995e62$var$SvgHeroDarkmodeDesktop;


const $5001e16adf52ef6e$var$HeroImage = ()=>{
    const { width: width } = (0, $3bc11a3cff85be60$export$2e2bcd8739ae039)();
    const theme = (0, $1d9bd5c523349ec4$export$93d4e7f90805808f)();
    const themeIsLight = theme.name === "light";
    const screenIsBig = width > (0, $fbf3a9d90d422861$export$4cf8c0e020b1f8b2);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("div", {
        children: screenIsBig ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($5001e16adf52ef6e$var$HeroDesktop, {
            themeIsLight: themeIsLight
        }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($5001e16adf52ef6e$var$HeroMobile, {
            themeIsLight: themeIsLight
        })
    });
};
const $5001e16adf52ef6e$var$HeroDesktop = ({ themeIsLight: themeIsLight })=>{
    return themeIsLight ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $51cfe7b8bb4bfff1$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $4fed226dd3995e62$export$2e2bcd8739ae039), {});
};
const $5001e16adf52ef6e$var$HeroMobile = ({ themeIsLight: themeIsLight })=>{
    return themeIsLight ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $858f1539c64df920$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $9dc6cda8ea8ece2c$export$2e2bcd8739ae039), {});
};
var $5001e16adf52ef6e$export$2e2bcd8739ae039 = $5001e16adf52ef6e$var$HeroImage;



parcelRequire("9nZCP");




parcelRequire("9nZCP");





parcelRequire("9nZCP");


var $efa304e231097cc9$export$edbc6635a693bcff;
(function(Statuses) {
    Statuses[Statuses["inProgress"] = 0] = "inProgress";
    Statuses[Statuses["settlementWaitingSeller"] = 1] = "settlementWaitingSeller";
    Statuses[Statuses["settlementWaitingBuyer"] = 2] = "settlementWaitingBuyer";
    Statuses[Statuses["raisingDisputeWaitingSeller"] = 3] = "raisingDisputeWaitingSeller";
    Statuses[Statuses["raisingDisputeWaitingBuyer"] = 4] = "raisingDisputeWaitingBuyer";
    Statuses[Statuses["disputed"] = 5] = "disputed";
    Statuses[Statuses["concluded"] = 6] = "concluded";
})($efa304e231097cc9$export$edbc6635a693bcff || ($efa304e231097cc9$export$edbc6635a693bcff = {}));


const $f6465fae5c9dacc3$export$3264e9e2dd88c2d3 = (status)=>{
    switch(status){
        case "NoDispute":
            return (0, $efa304e231097cc9$export$edbc6635a693bcff).inProgress;
        case "WaitingSettlementBuyer":
            return (0, $efa304e231097cc9$export$edbc6635a693bcff).settlementWaitingBuyer;
        case "WaitingSettlementSeller":
            return (0, $efa304e231097cc9$export$edbc6635a693bcff).settlementWaitingSeller;
        case "WaitingBuyer":
            return (0, $efa304e231097cc9$export$edbc6635a693bcff).raisingDisputeWaitingBuyer;
        case "WaitingSeller":
            return (0, $efa304e231097cc9$export$edbc6635a693bcff).raisingDisputeWaitingSeller;
        case "DisputeCreated":
            return (0, $efa304e231097cc9$export$edbc6635a693bcff).disputed;
        case "TransactionResolved":
            return (0, $efa304e231097cc9$export$edbc6635a693bcff).concluded;
    }
};



parcelRequire("9nZCP");


var $9nZCP = parcelRequire("9nZCP");
"use client";
/**
 * @internal
 */ const $7d86fb1e9395869e$var$SkeletonThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createContext({});
/* eslint-disable react/no-array-index-key */ const $7d86fb1e9395869e$var$defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function $7d86fb1e9395869e$var$styleOptionsToCssProperties({ baseColor: baseColor, highlightColor: highlightColor, width: width, height: height, borderRadius: borderRadius, circle: circle, direction: direction, duration: duration, enableAnimation: enableAnimation = $7d86fb1e9395869e$var$defaultEnableAnimation }) {
    const style = {};
    if (direction === "rtl") style["--animation-direction"] = "reverse";
    if (typeof duration === "number") style["--animation-duration"] = `${duration}s`;
    if (!enableAnimation) style["--pseudo-element-display"] = "none";
    if (typeof width === "string" || typeof width === "number") style.width = width;
    if (typeof height === "string" || typeof height === "number") style.height = height;
    if (typeof borderRadius === "string" || typeof borderRadius === "number") style.borderRadius = borderRadius;
    if (circle) style.borderRadius = "50%";
    if (typeof baseColor !== "undefined") style["--base-color"] = baseColor;
    if (typeof highlightColor !== "undefined") style["--highlight-color"] = highlightColor;
    return style;
}
function $7d86fb1e9395869e$export$2e2bcd8739ae039({ count: count = 1, wrapper: Wrapper, className: customClassName, containerClassName: containerClassName, containerTestId: containerTestId, circle: circle = false, style: styleProp, ...originalPropsStyleOptions }) {
    var _a, _b, _c;
    const contextStyleOptions = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useContext($7d86fb1e9395869e$var$SkeletonThemeContext);
    const propsStyleOptions = {
        ...originalPropsStyleOptions
    };
    // DO NOT overwrite style options from the context if `propsStyleOptions`
    // has properties explicity set to undefined
    for (const [key, value] of Object.entries(originalPropsStyleOptions))if (typeof value === "undefined") delete propsStyleOptions[key];
    // Props take priority over context
    const styleOptions = {
        ...contextStyleOptions,
        ...propsStyleOptions,
        circle: circle
    };
    // `styleProp` has the least priority out of everything
    const style = {
        ...styleProp,
        ...$7d86fb1e9395869e$var$styleOptionsToCssProperties(styleOptions)
    };
    let className = "react-loading-skeleton";
    if (customClassName) className += ` ${customClassName}`;
    const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
    const elements = [];
    const countCeil = Math.ceil(count);
    for(let i = 0; i < countCeil; i++){
        let thisStyle = style;
        if (countCeil > count && i === countCeil - 1) {
            // count is not an integer and we've reached the last iteration of
            // the loop, so add a "fractional" skeleton.
            //
            // For example, if count is 3.5, we've already added 3 full
            // skeletons, so now we add one more skeleton that is 0.5 times the
            // original width.
            const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : "100%"; // 100% is the default since that's what's in the CSS
            const fractionalPart = count % 1;
            const fractionalWidth = typeof width === "number" ? width * fractionalPart : `calc(${width} * ${fractionalPart})`;
            thisStyle = {
                ...thisStyle,
                width: fractionalWidth
            };
        }
        const skeletonSpan = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("span", {
            className: className,
            style: thisStyle,
            key: i
        }, "\u200C");
        if (inline) elements.push(skeletonSpan);
        else // Without the <br />, the skeleton lines will all run together if
        // `width` is specified
        elements.push((0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).Fragment, {
            key: i
        }, skeletonSpan, (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("br", null)));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("span", {
        className: containerClassName,
        "data-testid": containerTestId,
        "aria-live": "polite",
        "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : $7d86fb1e9395869e$var$defaultEnableAnimation
    }, Wrapper ? elements.map((el, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement(Wrapper, {
            key: i
        }, el)) : elements);
}
function $7d86fb1e9395869e$export$978f2619783614a7({ children: children, ...styleOptions }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement($7d86fb1e9395869e$var$SkeletonThemeContext.Provider, {
        value: styleOptions
    }, children);
}



const $e467ee9362ed574f$export$e4ecddc59e33f387 = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $7d86fb1e9395869e$export$2e2bcd8739ae039))`
  z-index: 0;
`;
const $e467ee9362ed574f$var$SkeletonTransactionCardContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  width: 100%;
`;
const $e467ee9362ed574f$var$StyledSkeletonTransactionCard = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $7d86fb1e9395869e$export$2e2bcd8739ae039))`
  height: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(270, 296)};
`;
const $e467ee9362ed574f$var$StyledSkeletonTransactionListItem = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $7d86fb1e9395869e$export$2e2bcd8739ae039))`
  height: 80px;
`;
const $e467ee9362ed574f$var$StyledSkeletonEvidenceCard = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $7d86fb1e9395869e$export$2e2bcd8739ae039))`
  height: 146px;
  width: 76vw;
`;
const $e467ee9362ed574f$var$StyledSkeletonButton = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $7d86fb1e9395869e$export$2e2bcd8739ae039))`
  width: 168px;
  height: 45px;
`;
const $e467ee9362ed574f$export$c14ff0889fc7e591 = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $7d86fb1e9395869e$export$2e2bcd8739ae039))`
  margin-left: 92px;
  width: 200px;
`;
const $e467ee9362ed574f$export$6ebe8b6b92b06e62 = ()=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($e467ee9362ed574f$var$SkeletonTransactionCardContainer, {
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($e467ee9362ed574f$var$StyledSkeletonTransactionCard, {})
    });
const $e467ee9362ed574f$export$eeebc3e739bc248f = ()=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($e467ee9362ed574f$var$StyledSkeletonTransactionListItem, {});
const $e467ee9362ed574f$export$f88686ad1229433d = ()=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($e467ee9362ed574f$var$StyledSkeletonEvidenceCard, {});
const $e467ee9362ed574f$export$7387c3f2666b9f16 = ()=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($e467ee9362ed574f$var$StyledSkeletonButton, {});




var $9nZCP = parcelRequire("9nZCP");



const $4c98e343c4c36ef0$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  height: ${({ isCard: isCard })=>isCard ? "45px" : "100%"};
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
  align-items: center;
  padding: ${({ isPreview: isPreview })=>isPreview ? "0" : "0 24px"};
  justify-content: ${({ isCard: isCard })=>isCard ? "space-between" : "start"};
  ${({ isCard: isCard, frontColor: frontColor, backgroundColor: backgroundColor, isPreview: isPreview })=>{
    if (isPreview) return (0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
        border: none;
        background-color: transparent;
        height: auto;
      `;
    else return `
        ${isCard ? `border-top: 5px solid ${frontColor}` : `border-left: 5px solid ${frontColor}`};
        ${isCard ? `background-color: ${backgroundColor}` : null};
      `;
}};
`;
const $4c98e343c4c36ef0$var$StyledLabel = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).label`
  display: flex;
  align-items: center;
  color: ${({ frontColor: frontColor })=>frontColor};

  ${({ withDot: withDot, frontColor: frontColor })=>withDot ? (0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
          ::before {
            content: "";
            height: 8px;
            width: 8px;
            border-radius: 50%;
            margin-right: 8px;
            background-color: ${frontColor};
          }
        ` : null}

  ${({ isCard: isCard })=>!isCard ? (0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
          width: 104px;
        ` : null}
`;
const $4c98e343c4c36ef0$var$StyledNumberLabel = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).label`
  display: flex;
  align-items: center;
  color: ${({ frontColor: frontColor })=>frontColor};

  ${({ isCard: isCard })=>!isCard ? (0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
          width: 32px;
        ` : null}
`;
const $4c98e343c4c36ef0$var$getStatusColors = (status, theme)=>{
    switch(status){
        case (0, $efa304e231097cc9$export$edbc6635a693bcff).inProgress:
            return [
                theme.primaryBlue,
                theme.mediumBlue
            ];
        case (0, $efa304e231097cc9$export$edbc6635a693bcff).settlementWaitingBuyer:
            return [
                theme.warning,
                theme.warningLight
            ];
        case (0, $efa304e231097cc9$export$edbc6635a693bcff).settlementWaitingSeller:
            return [
                theme.warning,
                theme.warningLight
            ];
        case (0, $efa304e231097cc9$export$edbc6635a693bcff).raisingDisputeWaitingBuyer:
            return [
                theme.warning,
                theme.warningLight
            ];
        case (0, $efa304e231097cc9$export$edbc6635a693bcff).raisingDisputeWaitingSeller:
            return [
                theme.warning,
                theme.warningLight
            ];
        case (0, $efa304e231097cc9$export$edbc6635a693bcff).disputed:
            return [
                theme.secondaryPurple,
                theme.mediumPurple
            ];
        case (0, $efa304e231097cc9$export$edbc6635a693bcff).concluded:
            return [
                theme.success,
                theme.successLight
            ];
        default:
            return [
                theme.lightGrey,
                theme.lightGrey
            ];
    }
};
const $4c98e343c4c36ef0$var$getStatusLabel = (status)=>{
    switch(status){
        case (0, $efa304e231097cc9$export$edbc6635a693bcff).inProgress:
            return "In Progress";
        case (0, $efa304e231097cc9$export$edbc6635a693bcff).settlementWaitingBuyer:
            return "Settlement - Waiting Buyer";
        case (0, $efa304e231097cc9$export$edbc6635a693bcff).settlementWaitingSeller:
            return "Settlement - Waiting Seller";
        case (0, $efa304e231097cc9$export$edbc6635a693bcff).raisingDisputeWaitingBuyer:
            return "Raising a Dispute - Waiting Buyer";
        case (0, $efa304e231097cc9$export$edbc6635a693bcff).raisingDisputeWaitingSeller:
            return "Raising a Dispute - Waiting Seller";
        case (0, $efa304e231097cc9$export$edbc6635a693bcff).disputed:
            return "Disputed";
        case (0, $efa304e231097cc9$export$edbc6635a693bcff).concluded:
            return "Concluded";
        default:
            return "";
    }
};
const $4c98e343c4c36ef0$var$StatusBanner = ({ id: id, status: status, isCard: isCard = true, isPreview: isPreview = false })=>{
    const theme = (0, $1d9bd5c523349ec4$export$93d4e7f90805808f)();
    const [frontColor, backgroundColor] = (0, $9nZCP.useMemo)(()=>$4c98e343c4c36ef0$var$getStatusColors(status, theme), [
        theme,
        status
    ]);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($4c98e343c4c36ef0$var$Container, {
        isCard: isCard,
        frontColor: frontColor,
        backgroundColor: backgroundColor,
        isPreview: isPreview,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($4c98e343c4c36ef0$var$StyledLabel, {
                withDot: true,
                isCard: isCard,
                frontColor: frontColor,
                children: $4c98e343c4c36ef0$var$getStatusLabel(status)
            }),
            !(0, $c62bd748620e6ea9$export$fce6876652108ab)(id) ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($4c98e343c4c36ef0$var$StyledNumberLabel, {
                isCard: isCard,
                frontColor: frontColor,
                children: [
                    "#",
                    id
                ]
            }) : null
        ]
    });
};
var $4c98e343c4c36ef0$export$2e2bcd8739ae039 = $4c98e343c4c36ef0$var$StatusBanner;


const $455cbf2ccbf42855$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
`;
const $455cbf2ccbf42855$var$StyledLabel = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).label`
  color: ${({ theme: theme })=>theme.secondaryPurple};
`;
const $455cbf2ccbf42855$var$StyledHeader = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).h1`
  margin: 0;
  flex-wrap: wrap;
  word-break: break-word;
  width: 100%;
`;
const $455cbf2ccbf42855$var$LeftContent = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const $455cbf2ccbf42855$var$Header = ({ escrowType: escrowType, escrowTitle: escrowTitle, id: id, status: status, isCard: isCard })=>{
    const currentStatusEnum = (0, $f6465fae5c9dacc3$export$3264e9e2dd88c2d3)(status);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($455cbf2ccbf42855$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($455cbf2ccbf42855$var$LeftContent, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($455cbf2ccbf42855$var$StyledLabel, {
                        children: escrowType === "general" ? "General Escrow" : "Crypto Swap"
                    }),
                    (0, $c62bd748620e6ea9$export$fce6876652108ab)(escrowTitle) ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e467ee9362ed574f$export$e4ecddc59e33f387), {}) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($455cbf2ccbf42855$var$StyledHeader, {
                        children: escrowTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $4c98e343c4c36ef0$export$2e2bcd8739ae039), {
                status: currentStatusEnum,
                isPreview: true
            })
        ]
    });
};
var $455cbf2ccbf42855$export$2e2bcd8739ae039 = $455cbf2ccbf42855$var$Header;



parcelRequire("9nZCP");





parcelRequire("9nZCP");
const $4e8ce94e96b6a1de$var$SvgCalendar = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 14 15",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
            clipPath: "url('63c151d500708d89')",
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M4.922 8.375H3.828a.33.33 0 0 1-.328-.328V6.953a.33.33 0 0 1 .328-.328h1.094a.33.33 0 0 1 .328.328v1.094a.33.33 0 0 1-.328.328Zm2.953-.328V6.953a.33.33 0 0 0-.328-.328H6.453a.33.33 0 0 0-.328.328v1.094c0 .18.148.328.328.328h1.094a.33.33 0 0 0 .328-.328Zm2.625 0V6.953a.33.33 0 0 0-.328-.328H9.078a.33.33 0 0 0-.328.328v1.094c0 .18.148.328.328.328h1.094a.33.33 0 0 0 .328-.328Zm-2.625 2.625V9.578a.33.33 0 0 0-.328-.328H6.453a.33.33 0 0 0-.328.328v1.094c0 .18.148.328.328.328h1.094a.33.33 0 0 0 .328-.328Zm-2.625 0V9.578a.33.33 0 0 0-.328-.328H3.828a.33.33 0 0 0-.328.328v1.094c0 .18.148.328.328.328h1.094a.33.33 0 0 0 .328-.328Zm5.25 0V9.578a.33.33 0 0 0-.328-.328H9.078a.33.33 0 0 0-.328.328v1.094c0 .18.148.328.328.328h1.094a.33.33 0 0 0 .328-.328Zm2.625-7.11v9.626c0 .724-.588 1.312-1.313 1.312H2.188a1.313 1.313 0 0 1-1.313-1.313V3.563c0-.725.588-1.313 1.313-1.313H3.5V.828A.33.33 0 0 1 3.828.5h1.094a.33.33 0 0 1 .328.328V2.25h3.5V.828A.33.33 0 0 1 9.078.5h1.094a.33.33 0 0 1 .328.328V2.25h1.313c.724 0 1.312.588 1.312 1.313Zm-1.313 9.461V4.875H2.188v8.148c0 .09.073.165.164.165h9.296c.09 0 .165-.074.165-.165Z"
            })
        })
    });
var $4e8ce94e96b6a1de$export$2e2bcd8739ae039 = $4e8ce94e96b6a1de$var$SvgCalendar;



parcelRequire("9nZCP");
const $0f3fba350060a219$var$SvgPileCoins = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 14 15",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
            clipPath: "url('281bdc4d5143cd73')",
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M0 11.582v1.168c0 .965 2.352 1.75 5.25 1.75s5.25-.785 5.25-1.75v-1.168c-1.13.796-3.194 1.168-5.25 1.168S1.13 12.378 0 11.582ZM8.75 4C11.648 4 14 3.215 14 2.25S11.648.5 8.75.5 3.5 1.285 3.5 2.25 5.852 4 8.75 4ZM0 8.714v1.411c0 .965 2.352 1.75 5.25 1.75s5.25-.785 5.25-1.75v-1.41c-1.13.929-3.196 1.41-5.25 1.41S1.13 9.644 0 8.715Zm11.375.3C12.942 8.712 14 8.149 14 7.5V6.332c-.634.449-1.567.755-2.625.944v1.739ZM5.25 4.876C2.352 4.875 0 5.854 0 7.063 0 8.27 2.352 9.25 5.25 9.25s5.25-.979 5.25-2.188c0-1.208-2.352-2.187-5.25-2.187Zm5.996 1.54C12.887 6.118 14 5.538 14 4.874V3.707c-.97.687-2.639 1.056-4.394 1.143.806.391 1.4.916 1.64 1.564Z"
            })
        })
    });
var $0f3fba350060a219$export$2e2bcd8739ae039 = $0f3fba350060a219$var$SvgPileCoins;



parcelRequire("9nZCP");
const $9e26abe2157545b0$var$SvgUser = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 22 22",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M10.892 12.313c3.227 0 5.845-2.646 5.845-5.907C16.737 3.146 14.12.5 10.892.5S5.046 3.146 5.046 6.406c0 3.261 2.619 5.907 5.846 5.907Zm5.196 1.312H13.85a7.012 7.012 0 0 1-2.96.656 7.026 7.026 0 0 1-2.958-.656H5.696c-2.87 0-5.196 2.35-5.196 5.25v.656A1.96 1.96 0 0 0 2.448 21.5h16.887a1.96 1.96 0 0 0 1.949-1.969v-.656c0-2.9-2.326-5.25-5.196-5.25Z"
        })
    });
var $9e26abe2157545b0$export$2e2bcd8739ae039 = $9e26abe2157545b0$var$SvgUser;



parcelRequire("9nZCP");



const $24787cbda30dfbe2$var$FieldContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  word-break: break-word;
  width: 100%;

  svg {
    fill: ${({ theme: theme })=>theme.secondaryPurple};
    margin-right: 8px;
    width: 14px;
  }

  ${({ isList: isList })=>isList && (0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
          width: auto;
        `)}
    `};
  ${({ isPreview: isPreview })=>isPreview && (0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      width: auto;
      gap: 8px;
      svg {
        margin-right: 0;
      }
    `};
`;
const $24787cbda30dfbe2$var$StyledValue = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).label`
  flex-grow: 1;
  text-align: end;
  color: ${({ theme: theme })=>theme.primaryText};
  ${({ isPreview: isPreview })=>isPreview && (0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      font-weight: 600;
      text-align: start;
    `}
`;
const $24787cbda30dfbe2$var$StyledLink = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $544fc37a064f4916$export$a6c7ac8248d6e38a))`
  flex-grow: 1;
  text-align: end;
  color: ${({ theme: theme })=>theme.primaryBlue};
  &:hover {
    cursor: pointer;
  }
`;
const $24787cbda30dfbe2$var$NameLabel = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).label`
  ${({ isList: isList, name: name })=>isList && (0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      display: ${name === "Buyer" || name === "Seller" ? "flex" : "none"};
      margin-right: ${name === "Buyer" || name === "Seller" ? "8px" : "0"};
    `}
  ${({ isPreview: isPreview })=>isPreview && (0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      display: flex;
      margin-right: 0;
    `}
`;
const $24787cbda30dfbe2$var$Field = ({ icon: Icon, name: name, value: value, link: link, width: width, displayAsList: displayAsList, isPreview: isPreview })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($24787cbda30dfbe2$var$FieldContainer, {
        isList: displayAsList,
        isPreview: isPreview,
        width: width,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(Icon, {}),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($24787cbda30dfbe2$var$NameLabel, {
                        isList: displayAsList,
                        name: name,
                        isPreview: isPreview,
                        children: [
                            name,
                            ":"
                        ]
                    })
                ]
            }),
            link ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($24787cbda30dfbe2$var$StyledLink, {
                to: link,
                children: value
            }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($24787cbda30dfbe2$var$StyledValue, {
                isPreview: isPreview,
                children: value
            })
        ]
    });
};
var $24787cbda30dfbe2$export$2e2bcd8739ae039 = $24787cbda30dfbe2$var$Field;



const $f023554fa7f1bc9f$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;
  gap: 8px;
  flex-direction: column;
  justify-content: center;

  ${({ isList: isList })=>isList && (0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
          gap: 0;
          height: 100%;
          flex: 1;
        `)}
    `};
`;
const $f023554fa7f1bc9f$var$RestOfFieldsContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  ${({ isList: isList, isPreview: isPreview })=>isList && !isPreview && (0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-self: flex-end;
          width: auto;
          max-width: 360px;
          height: auto;
          flex-wrap: wrap;
          align-items: center;
          gap: 8px 32px;
          margin-right: 35px;
        `)}
    `};
  ${({ isPreview: isPreview })=>isPreview && (0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      gap: 32px;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
    `};
`;
const $f023554fa7f1bc9f$var$TransactionInfo = ({ amount: amount, assetSymbol: assetSymbol, deadline: deadline, sellerAddress: sellerAddress, buyerAddress: buyerAddress, overrideIsList: overrideIsList, isPreview: isPreview })=>{
    const { isList: isList } = (0, $42c890363ed32eb3$export$efcb02388d4a2108)();
    const displayAsList = isList && !overrideIsList;
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($f023554fa7f1bc9f$var$Container, {
        isList: displayAsList,
        isPreview: isPreview,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($f023554fa7f1bc9f$var$RestOfFieldsContainer, {
            isPreview: isPreview,
            isList: displayAsList,
            children: [
                amount ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $24787cbda30dfbe2$export$2e2bcd8739ae039), {
                    icon: (0, $0f3fba350060a219$export$2e2bcd8739ae039),
                    name: "Amount",
                    value: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
                        children: [
                            amount,
                            " ",
                            !assetSymbol ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $7d86fb1e9395869e$export$2e2bcd8739ae039), {
                                width: 30
                            }) : assetSymbol
                        ]
                    }),
                    displayAsList: displayAsList,
                    isPreview: isPreview
                }) : null,
                deadline ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $24787cbda30dfbe2$export$2e2bcd8739ae039), {
                    icon: (0, $4e8ce94e96b6a1de$export$2e2bcd8739ae039),
                    name: "Delivery Deadline",
                    value: new Date(deadline).toLocaleString(),
                    displayAsList: displayAsList,
                    isPreview: isPreview
                }) : null,
                buyerAddress ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $24787cbda30dfbe2$export$2e2bcd8739ae039), {
                    icon: (0, $9e26abe2157545b0$export$2e2bcd8739ae039),
                    name: "Buyer",
                    value: (0, $dcb9f356e0e0b2ff$export$e6e2bc9967bf256c)(buyerAddress),
                    displayAsList: displayAsList,
                    isPreview: isPreview
                }) : null,
                sellerAddress ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $24787cbda30dfbe2$export$2e2bcd8739ae039), {
                    icon: (0, $9e26abe2157545b0$export$2e2bcd8739ae039),
                    name: "Seller",
                    value: (0, $dcb9f356e0e0b2ff$export$e6e2bc9967bf256c)(sellerAddress),
                    displayAsList: displayAsList,
                    isPreview: isPreview
                }) : null
            ]
        })
    });
};
var $f023554fa7f1bc9f$export$2e2bcd8739ae039 = $f023554fa7f1bc9f$var$TransactionInfo;



parcelRequire("9nZCP");


parcelRequire("9nZCP");



parcelRequire("9nZCP");
const $7dd7afce0412d168$var$SvgAttachment = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
            clipPath: "url('fb97e9c5d1d9c865')",
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M2.091 12.746C.448 11.097.48 8.44 2.131 6.796L8.03.93a3.21 3.21 0 0 1 4.519 0 3.12 3.12 0 0 1 0 4.437l-5.143 5.11a2.14 2.14 0 0 1-3.037-.028 2.077 2.077 0 0 1 .04-2.925L8.454 3.51a.46.46 0 0 1 .636-.006l.643.612c.178.169.18.446.007.618L5.696 8.748c-.138.138-.147.367-.018.5a.306.306 0 0 0 .441.005l5.143-5.11a1.404 1.404 0 0 0 0-1.99 1.376 1.376 0 0 0-1.945 0l-5.9 5.867c-.978.972-.993 2.546-.033 3.508.956.96 2.502.961 3.46.008l4.84-4.812a.46.46 0 0 1 .636-.007l.644.611c.177.17.18.446.007.619l-4.84 4.812a4.28 4.28 0 0 1-6.04-.013Z"
            })
        })
    });
var $7dd7afce0412d168$export$2e2bcd8739ae039 = $7dd7afce0412d168$var$SvgAttachment;



const $dc499933200379fe$export$99de037bb933f932 = (url)=>{
    const formatedIPFSPath = $dc499933200379fe$export$2ccc1cfd45796abd(url);
    return `${0, $4ec8515f3272cbaa$export$8c255d03248f12ab}${formatedIPFSPath}`;
};
const $dc499933200379fe$export$2ccc1cfd45796abd = (url)=>{
    if (url.startsWith("/ipfs/")) return url;
    else if (url.startsWith("ipfs/")) return "/" + url;
    else if (url.startsWith("ipfs://")) return url.replace("ipfs://", "/ipfs/");
    return url;
};


const $31ccc7bb74639a6e$var$StyledA = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).a`
  display: flex;
  gap: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(5, 6)};
  > svg {
    width: 16px;
    fill: ${({ theme: theme })=>theme.primaryBlue};
  }
`;
const $31ccc7bb74639a6e$var$AttachedFile = ({ extraDescriptionUri: extraDescriptionUri })=>{
    const href = extraDescriptionUri && (0, $dc499933200379fe$export$99de037bb933f932)(extraDescriptionUri);
    return extraDescriptionUri ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($31ccc7bb74639a6e$var$StyledA, {
        href: href,
        target: "_blank",
        rel: "noreferrer",
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $7dd7afce0412d168$export$2e2bcd8739ae039), {}),
            "View Attached File"
        ]
    }) : null;
};
var $31ccc7bb74639a6e$export$2e2bcd8739ae039 = $31ccc7bb74639a6e$var$AttachedFile;



parcelRequire("9nZCP");



const $9b18ae66016c0e5e$var$StyledP = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).p`
  margin: 0;
  word-break: break-word;
`;
const $9b18ae66016c0e5e$var$InlineBlockSpan = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).span`
  display: inline-block;
`;
const $9b18ae66016c0e5e$var$Description = ({ escrowType: escrowType, deliverableText: deliverableText, receivingQuantity: receivingQuantity, receivingToken: receivingToken, buyerAddress: buyerAddress, sendingQuantity: sendingQuantity, sendingToken: sendingToken, sellerAddress: sellerAddress, deadline: deadline, assetSymbol: assetSymbol })=>{
    const generalEscrowSummary = /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            "By Paying ",
            sendingQuantity,
            " ",
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($9b18ae66016c0e5e$var$InlineBlockSpan, {
                children: assetSymbol ? assetSymbol : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e467ee9362ed574f$export$e4ecddc59e33f387), {
                    width: 30
                })
            }),
            ", address",
            " ",
            buyerAddress,
            ' should receive "',
            deliverableText,
            '" from address ',
            sellerAddress,
            " before the delivery deadline",
            " ",
            new Date(deadline).toString(),
            "."
        ]
    });
    const cryptoSwapSummary = /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            "By Paying ",
            sendingQuantity,
            " ",
            sendingToken,
            ", [Blockchain] address ",
            buyerAddress,
            " should receive ",
            receivingQuantity,
            " ",
            receivingToken,
            " at the [Blockchain] address ",
            sellerAddress,
            " from [Blockchain] address TODO before the delivery deadline ",
            new Date(deadline).toString(),
            "."
        ]
    });
    return (0, $c62bd748620e6ea9$export$fce6876652108ab)(deliverableText) ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e467ee9362ed574f$export$e4ecddc59e33f387), {}) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($9b18ae66016c0e5e$var$StyledP, {
                children: escrowType === "general" ? generalEscrowSummary : cryptoSwapSummary
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($9b18ae66016c0e5e$var$StyledP, {
                children: "After the delivery deadline, you can start a complaint (propose a settlement or raise a dispute). In case of a dispute, it will be arbitrated by the Kleros Freelancing Court."
            })
        ]
    });
};
var $9b18ae66016c0e5e$export$2e2bcd8739ae039 = $9b18ae66016c0e5e$var$Description;



parcelRequire("9nZCP");

const $cca7f5e74323160f$var$StyledHeader = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).h3`
  margin-bottom: 0;
`;
const $cca7f5e74323160f$var$Header = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($cca7f5e74323160f$var$StyledHeader, {
        children: "Terms"
    });
};
var $cca7f5e74323160f$export$2e2bcd8739ae039 = $cca7f5e74323160f$var$Header;


const $d5fb57762d465895$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const $d5fb57762d465895$var$Terms = ({ escrowType: escrowType, deliverableText: deliverableText, receivingQuantity: receivingQuantity, buyerAddress: buyerAddress, sendingQuantity: sendingQuantity, sellerAddress: sellerAddress, deadline: deadline, assetSymbol: assetSymbol, extraDescriptionUri: extraDescriptionUri })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($d5fb57762d465895$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cca7f5e74323160f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $9b18ae66016c0e5e$export$2e2bcd8739ae039), {
                escrowType: escrowType,
                deliverableText: deliverableText,
                receivingQuantity: receivingQuantity,
                buyerAddress: buyerAddress,
                sendingQuantity: sendingQuantity,
                sellerAddress: sellerAddress,
                deadline: deadline,
                assetSymbol: assetSymbol
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $31ccc7bb74639a6e$export$2e2bcd8739ae039), {
                extraDescriptionUri: extraDescriptionUri
            })
        ]
    });
};
var $d5fb57762d465895$export$2e2bcd8739ae039 = $d5fb57762d465895$var$Terms;



parcelRequire("9nZCP");




var $9nZCP = parcelRequire("9nZCP");


var $c6heD = parcelRequire("c6heD");
const $218991f9f67a317a$export$92521769c5df59ad = (dateString)=>{
    const options = {
        year: "numeric",
        month: "long",
        day: "numeric"
    };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", options);
};


const $ff1cb94149972055$export$2532f7efd056bbd3 = (resolutionValue)=>{
    switch(resolutionValue){
        case 0:
            return "Transaction Executed";
        case 1:
            return "Timeout By Buyer";
        case 2:
            return "Timeout By Seller";
        case 3:
            return "Ruling Enforced";
        case 4:
            return "Settlement Reached";
        default:
            return "Unknown";
    }
};


const $2a96e5229d7c1e33$export$af76f95617fa967a = (seconds)=>{
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor(seconds % 86400 / 3600);
    const minutes = Math.floor(seconds % 3600 / 60);
    const secs = Math.floor(seconds % 60);
    let result = "";
    if (days > 0) result += `${days}d `;
    if (days > 0 || hours > 0) result += `${hours}h `;
    if (days > 0 || hours > 0 || minutes > 0) result += `${minutes}m `;
    result += `${secs}s`;
    return result.trim();
};



parcelRequire("9nZCP");


parcelRequire("9nZCP");
const $201745e006b9410e$var$SvgCheckCircleOutline = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 16,
        height: 17,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
            clipPath: "url('8cf215e9e575f213')",
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 8.5a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8.5Zm1.357 0a6.644 6.644 0 0 0 13.286 0 6.644 6.644 0 0 0-13.286 0Zm9.145-2.84h.837c.116 0 .184.132.114.227L7.694 11.1a.567.567 0 0 1-.923 0L4.545 8.016a.143.143 0 0 1 .116-.227h.837c.184 0 .356.089.463.237l1.271 1.765 2.807-3.893a.569.569 0 0 1 .463-.238Z",
                fill: "#00C42B"
            })
        })
    });
var $201745e006b9410e$export$2e2bcd8739ae039 = $201745e006b9410e$var$SvgCheckCircleOutline;


const $ba41c24dd144274a$var$StyledCheckCircle = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $201745e006b9410e$export$2e2bcd8739ae039))`
  path {
    fill: ${({ theme: theme })=>theme.success};
  }
`;
const $ba41c24dd144274a$var$CheckCircleIcon = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($ba41c24dd144274a$var$StyledCheckCircle, {});
};
var $ba41c24dd144274a$export$2e2bcd8739ae039 = $ba41c24dd144274a$var$CheckCircleIcon;



parcelRequire("9nZCP");


parcelRequire("9nZCP");
const $80c40a89c8f4d1a7$var$SvgLawBalance = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 16,
        height: 16,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
            clipPath: "url('204c6e441e8cce75')",
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.792 3.151c0 .375-.085.59-.222.712l3.777 1.127a.589.589 0 1 1 .635.977l1.322 3.803c.419.066.696.165.696.295 0 .533-1.045.966-2.333.966-1.289 0-2.334-.433-2.334-.966 0-.139.313-.241.777-.308l1.326-3.815a.59.59 0 0 1-.261-.319c-.045-.185-.149-.301-.311-.35-.195-.058-.385-.065-.598-.072-.269-.01-.573-.02-.966-.137l-1.919-.572v3.91a.586.586 0 0 1 .132.827.79.79 0 0 1-.132 1.351v.817c.872.045 1.536.28 1.536.563v.014c1.406.122 2.377.38 2.377.679l.007.417c0 .415-1.871.749-4.184.749-2.312 0-4.184-.34-4.184-.756l-.013-.41c0-.294.94-.549 2.31-.673a.184.184 0 0 1 0-.02c0-.278.642-.51 1.492-.56v-.807a.793.793 0 0 1-.158-1.364.583.583 0 0 1 .158-.845v-4.09l-2.188-.652c-.146-.044-.359-.159-.587-.282-.261-.142-.542-.294-.761-.36-.153-.045-.309-.012-.47.1a.592.592 0 0 1-.1.065l1.32 3.795c.438.066.73.167.73.3 0 .534-1.044.966-2.333.966C1.045 8.226 0 7.794 0 7.26c0-.13.275-.228.692-.294l1.33-3.828a.587.587 0 0 1 .321-1.082.59.59 0 0 1 .564.415L6.3 3.483a1.714 1.714 0 0 1-.028-.332c0-.5.253-1.093.76-1.776.507.683.76 1.275.76 1.776Zm4.073 2.856 1.301 3.743c-.82-.11-2.071-.114-2.919-.01l1.303-3.747a.59.59 0 0 0 .315.014ZM.83 6.946l1.304-3.752a.59.59 0 0 0 .367.016l1.297 3.73c-.85-.109-2.133-.107-2.968.006Z"
            })
        })
    });
var $80c40a89c8f4d1a7$export$2e2bcd8739ae039 = $80c40a89c8f4d1a7$var$SvgLawBalance;


const $65f854fed5bf687b$var$StyledCheckCircle = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $80c40a89c8f4d1a7$export$2e2bcd8739ae039))`
  path {
    fill: ${({ theme: theme })=>theme.secondaryPurple};
  }
`;
const $65f854fed5bf687b$var$LawBalanceIcon = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($65f854fed5bf687b$var$StyledCheckCircle, {});
};
var $65f854fed5bf687b$export$2e2bcd8739ae039 = $65f854fed5bf687b$var$LawBalanceIcon;



function $74caa3e63d515632$var$calculateTimeLeft(timestamp, timeout, currentTime) {
    return Math.max(timeout - (currentTime - timestamp), 0);
}
function $74caa3e63d515632$var$createTimelineItem(formattedDate, title, party, variant, Icon) {
    return {
        title: title,
        party: party,
        subtitle: formattedDate,
        rightSided: true,
        variant: variant,
        ...Icon && {
            Icon: Icon
        }
    };
}
const $74caa3e63d515632$var$useEscrowTimelineItems = (isPreview, transactionCreationTimestamp, status, assetSymbol, buyer, seller, payments, settlementProposals, hasToPayFees, disputeRequest, resolvedEvents, feeTimeout, settlementTimeout)=>{
    const theme = (0, $1d9bd5c523349ec4$export$93d4e7f90805808f)();
    const [currentTime, setCurrentTime] = (0, $9nZCP.useState)(Math.floor(Date.now() / 1000));
    (0, $9nZCP.useEffect)(()=>{
        const interval = setInterval(()=>setCurrentTime(Math.floor(Date.now() / 1000)), 1000);
        return ()=>clearInterval(interval);
    }, []);
    return (0, $9nZCP.useMemo)(()=>{
        let timelineItems = [];
        const formattedCreationDate = isPreview ? (0, $218991f9f67a317a$export$92521769c5df59ad)(new Date()) : (0, $218991f9f67a317a$export$92521769c5df59ad)(new Date(transactionCreationTimestamp * 1000));
        timelineItems.push($74caa3e63d515632$var$createTimelineItem(formattedCreationDate, "Escrow created", "", theme.primaryBlue));
        if (!isPreview) {
            payments?.forEach((payment)=>{
                const isBuyer = payment.party.toLowerCase() === buyer.toLowerCase();
                const formattedDate = (0, $218991f9f67a317a$export$92521769c5df59ad)(new Date(payment.timestamp * 1000));
                const title = /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
                    children: [
                        "The ",
                        isBuyer ? "buyer" : "seller",
                        " paid ",
                        (0, $c6heD.formatEther)(payment.amount),
                        " ",
                        assetSymbol ? assetSymbol : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e467ee9362ed574f$export$e4ecddc59e33f387), {
                            width: 30
                        })
                    ]
                });
                timelineItems.push($74caa3e63d515632$var$createTimelineItem(formattedDate, title, "", theme.secondaryBlue));
            });
            settlementProposals?.forEach((proposal, index)=>{
                const formattedDate = (0, $218991f9f67a317a$export$92521769c5df59ad)(new Date(proposal.timestamp * 1000));
                let subtitle;
                const isLatestProposal = index === settlementProposals.length - 1;
                const timeLeft = $74caa3e63d515632$var$calculateTimeLeft(proposal.timestamp, settlementTimeout, currentTime);
                if (isLatestProposal && hasToPayFees.length === 0 && status !== "WaitingSettlementSeller" && status !== "WaitingSettlementBuyer") subtitle = "Proposal accepted";
                else if (hasToPayFees.length > 0 || !isLatestProposal) subtitle = "Proposal refused";
                else subtitle = `Waiting ${proposal.party === "1" ? "Seller's" : "Buyer's"} answer [Timeout: ${(0, $2a96e5229d7c1e33$export$af76f95617fa967a)(timeLeft)}]`;
                const title = /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
                    children: [
                        "The ",
                        proposal.party === "1" ? "buyer" : "seller",
                        " proposed: Pay ",
                        (0, $c6heD.formatEther)(proposal.amount),
                        " ",
                        assetSymbol ? assetSymbol : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e467ee9362ed574f$export$e4ecddc59e33f387), {
                            width: 30
                        })
                    ]
                });
                timelineItems.push($74caa3e63d515632$var$createTimelineItem(formattedDate, title, subtitle, theme.warning));
            });
            hasToPayFees?.forEach((fee)=>{
                const timeLeft = $74caa3e63d515632$var$calculateTimeLeft(fee.timestamp, feeTimeout, currentTime);
                const formattedDate = (0, $218991f9f67a317a$export$92521769c5df59ad)(new Date(fee.timestamp * 1000));
                const title = `The ${fee.party === "2" ? "buyer" : "seller"} raised a dispute`;
                let timeoutCountdownMessage = timeLeft > 0 ? `'s ` + `Arbitration fee required [Timeout: ${(0, $2a96e5229d7c1e33$export$af76f95617fa967a)(timeLeft)}]` : " failed to deposit the arbitration fee";
                let party = disputeRequest ? "Arbitration fees deposited" : `${fee.party === "2" ? "Seller" : "Buyer"}${timeoutCountdownMessage}`;
                timelineItems.push($74caa3e63d515632$var$createTimelineItem(formattedDate, title, party, theme.secondaryPurple));
            });
            if (disputeRequest) {
                const formattedDate = (0, $218991f9f67a317a$export$92521769c5df59ad)(new Date(disputeRequest.timestamp * 1000));
                timelineItems.push($74caa3e63d515632$var$createTimelineItem(formattedDate, "Dispute created", `Case #${disputeRequest.id}`, theme.secondaryPurple, (0, $65f854fed5bf687b$export$2e2bcd8739ae039)));
            }
            if (status === "TransactionResolved") {
                const resolutionEvent = resolvedEvents?.[resolvedEvents.length - 1];
                if (resolutionEvent) {
                    const formattedDate = (0, $218991f9f67a317a$export$92521769c5df59ad)(new Date(resolutionEvent.timestamp * 1000));
                    timelineItems.push($74caa3e63d515632$var$createTimelineItem(formattedDate, "Concluded", (0, $ff1cb94149972055$export$2532f7efd056bbd3)(resolutionEvent.resolution), theme.success, (0, $ba41c24dd144274a$export$2e2bcd8739ae039)));
                }
            }
        }
        return timelineItems;
    }, [
        isPreview,
        transactionCreationTimestamp,
        status,
        payments,
        settlementProposals,
        hasToPayFees,
        disputeRequest,
        resolvedEvents,
        feeTimeout,
        settlementTimeout,
        currentTime,
        theme,
        assetSymbol,
        buyer,
        seller
    ]);
};
var $74caa3e63d515632$export$2e2bcd8739ae039 = $74caa3e63d515632$var$useEscrowTimelineItems;


const $744b4d7a62ff341b$var$StyledTimeline = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.CustomTimeline))`
  width: 100%;
`;
const $744b4d7a62ff341b$var$EscrowTimeline = ({ isPreview: isPreview, transactionCreationTimestamp: transactionCreationTimestamp, status: status, assetSymbol: assetSymbol, buyerAddress: buyerAddress, sellerAddress: sellerAddress, payments: payments, settlementProposals: settlementProposals, hasToPayFees: hasToPayFees, disputeRequest: disputeRequest, resolvedEvents: resolvedEvents, feeTimeout: feeTimeout, settlementTimeout: settlementTimeout })=>{
    const items = (0, $74caa3e63d515632$export$2e2bcd8739ae039)(isPreview, transactionCreationTimestamp, status, assetSymbol, buyerAddress, sellerAddress, payments, settlementProposals, hasToPayFees, disputeRequest, resolvedEvents, feeTimeout, settlementTimeout);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($744b4d7a62ff341b$var$StyledTimeline, {
        items: items
    });
};
var $744b4d7a62ff341b$export$2e2bcd8739ae039 = $744b4d7a62ff341b$var$EscrowTimeline;




var $9nZCP = parcelRequire("9nZCP");



var $c6heD = parcelRequire("c6heD");


var $9nZCP = parcelRequire("9nZCP");
const $4d51476fd708038f$var$TransactionDetailsContext = /*#__PURE__*/ (0, $9nZCP.createContext)(undefined);
const $4d51476fd708038f$export$57f2782cc8cecbb0 = ()=>{
    const context = (0, $9nZCP.useContext)($4d51476fd708038f$var$TransactionDetailsContext);
    if (!context) throw new Error("useTransactionDetailsContext must be used within a TransactionDetailsProvider");
    const { transactionDetails: transactionDetails, setTransactionDetails: setTransactionDetails } = context;
    return {
        ...transactionDetails,
        setTransactionDetails: setTransactionDetails
    };
};
const $4d51476fd708038f$export$677eeb85ea74455b = ({ children: children })=>{
    const [transactionDetails, setTransactionDetails] = (0, $9nZCP.useState)(undefined);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($4d51476fd708038f$var$TransactionDetailsContext.Provider, {
        value: {
            transactionDetails: transactionDetails,
            setTransactionDetails: setTransactionDetails
        },
        children: children
    });
};



parcelRequire("9nZCP");




var $9nZCP = parcelRequire("9nZCP");


parcelRequire("9nZCP");

const $6b619e4606cd622f$var$StyledP = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).p`
  color: ${({ theme: theme })=>theme.secondaryText};
  margin: 0;
  margin-bottom: 32px;
`;
const $6b619e4606cd622f$var$Description = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($6b619e4606cd622f$var$StyledP, {
        children: "How much should be paid?"
    });
};
var $6b619e4606cd622f$export$2e2bcd8739ae039 = $6b619e4606cd622f$var$Description;




parcelRequire("9nZCP");

const $b03962049a31de04$var$StyledHeader = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).h1`
  margin: 0;
`;
const $b03962049a31de04$var$Header = ({ text: text })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($b03962049a31de04$var$StyledHeader, {
        children: text
    });
};
var $b03962049a31de04$export$2e2bcd8739ae039 = $b03962049a31de04$var$Header;




var $9nZCP = parcelRequire("9nZCP");





const $084e1b9605511e37$export$ed4eff50d964b03e = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Field))`
  width: 100% !important;
  margin-bottom: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(64, 36)};
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    appearance: none;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }

  input {
    font-size: 16px;
  }
`;
const $084e1b9605511e37$var$AmountField = ({ amountProposed: amountProposed, setAmountProposed: setAmountProposed, setIsAmountValid: setIsAmountValid })=>{
    const { amount: amount } = (0, $4d51476fd708038f$export$57f2782cc8cecbb0)();
    const [error, setError] = (0, $9nZCP.useState)("");
    (0, $9nZCP.useEffect)(()=>{
        const transactionAmount = parseFloat(amount);
        const proposedAmount = (0, $db01c9b53f41c580$export$642c4e67bbdc0bc7)(amountProposed);
        if (amountProposed && transactionAmount < proposedAmount) {
            setError("Proposed amount exceeds transaction amount");
            setIsAmountValid(false);
        } else {
            setError("");
            setIsAmountValid(true);
        }
    }, [
        amountProposed,
        amount,
        setIsAmountValid
    ]);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($084e1b9605511e37$export$ed4eff50d964b03e, {
        value: amountProposed,
        onChange: (e)=>setAmountProposed(e.target.value),
        type: "number",
        placeholder: "0",
        variant: error ? "error" : undefined,
        message: error
    });
};
var $084e1b9605511e37$export$2e2bcd8739ae039 = $084e1b9605511e37$var$AmountField;



parcelRequire("9nZCP");




var $9nZCP = parcelRequire("9nZCP");








const $c653aba472624c98$var$ProposeSettlementButton = ({ toggleModal: toggleModal, buttonText: buttonText, amountProposed: amountProposed, isAmountValid: isAmountValid })=>{
    const [isSending, setIsSending] = (0, $9nZCP.useState)(false);
    const publicClient = (0, $b9a08c139e2d6879$export$3ca3483c611a99c4)();
    const { id: id } = (0, $4d51476fd708038f$export$57f2782cc8cecbb0)();
    const refetchQuery = (0, $7f2cd7efc5dd98b6$export$a25b430d4137a40)();
    const { config: proposeSettlementConfig } = (0, $65cd6dc33c6d9133$export$663dc5ee70f7ae4e)({
        args: [
            BigInt(id),
            (0, $db01c9b53f41c580$export$642c4e67bbdc0bc7)(amountProposed)
        ]
    });
    const { writeAsync: proposeSettlement } = (0, $65cd6dc33c6d9133$export$9658fb246c82807e)(proposeSettlementConfig);
    const handleProposeSettlement = ()=>{
        if (!(0, $c62bd748620e6ea9$export$fce6876652108ab)(proposeSettlement)) {
            setIsSending(true);
            (0, $6724d57570dc2c5f$export$27738200007bd40a)(async ()=>await proposeSettlement().then((response)=>response.hash), publicClient).then((wrapResult)=>{
                if (wrapResult.status) {
                    toggleModal && toggleModal();
                    refetchQuery([
                        [
                            "refetchOnBlock",
                            "useTransactionDetailsQuery"
                        ]
                    ]);
                } else setIsSending(false);
            }).catch((error)=>{
                console.error("Error proposing settlement:", error);
                setIsSending(false);
            });
        }
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.Button), {
        isLoading: isSending,
        disabled: isSending || !isAmountValid,
        text: buttonText,
        onClick: handleProposeSettlement
    });
};
var $c653aba472624c98$export$2e2bcd8739ae039 = $c653aba472624c98$var$ProposeSettlementButton;


const $f432ce4546a5a00a$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
`;
const $f432ce4546a5a00a$var$Buttons = ({ toggleModal: toggleModal, amountProposed: amountProposed, isAmountValid: isAmountValid })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($f432ce4546a5a00a$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.Button), {
                variant: "secondary",
                text: "Return",
                onClick: toggleModal
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $c653aba472624c98$export$2e2bcd8739ae039), {
                buttonText: "Propose",
                toggleModal: toggleModal,
                amountProposed: amountProposed,
                isAmountValid: isAmountValid
            })
        ]
    });
};
var $f432ce4546a5a00a$export$2e2bcd8739ae039 = $f432ce4546a5a00a$var$Buttons;



const $199d04a141957ef1$export$8863cf9d79cd26ad = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  position: fixed;
  top: 10vh;
  left: 50%;
  transform: translateX(-50%);
  max-height: 80vh;
  overflow-y: auto;

  z-index: 10;
  flex-direction: column;
  align-items: center;
  width: 86vw;
  max-width: 600px;
  border-radius: 3px;
  border: 1px solid ${({ theme: theme })=>theme.stroke};
  background-color: ${({ theme: theme })=>theme.whiteBackground};
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.06);
  padding: 32px 32px 32px 36px;
`;


const $f63ad02b1a6c2334$var$ProposeSettlementModal = ({ toggleModal: toggleModal, text: text })=>{
    const containerRef = (0, $9nZCP.useRef)(null);
    (0, $0aa9c5ea5f98ac89$export$2e2bcd8739ae039)(containerRef, ()=>toggleModal());
    const [amountProposed, setAmountProposed] = (0, $9nZCP.useState)("0");
    const [isAmountValid, setIsAmountValid] = (0, $9nZCP.useState)(true);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $a4e24e3c9f4f276a$export$c6fdb837b070b4ff), {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $199d04a141957ef1$export$8863cf9d79cd26ad), {
                ref: containerRef,
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $b03962049a31de04$export$2e2bcd8739ae039), {
                        text: text
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $6b619e4606cd622f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $084e1b9605511e37$export$2e2bcd8739ae039), {
                        amountProposed: amountProposed,
                        setAmountProposed: setAmountProposed,
                        setIsAmountValid: setIsAmountValid
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $f432ce4546a5a00a$export$2e2bcd8739ae039), {
                        toggleModal: toggleModal,
                        amountProposed: amountProposed,
                        isAmountValid: isAmountValid
                    })
                ]
            })
        ]
    });
};
var $f63ad02b1a6c2334$export$2e2bcd8739ae039 = $f63ad02b1a6c2334$var$ProposeSettlementModal;


const $42310430474a8cfa$var$OpenModalProposeSettlementButton = ({ buttonText: buttonText })=>{
    const [isModalOpen, toggleModal] = (0, $b2e41656ab938cc0$export$2e2bcd8739ae039)(false);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.Button), {
                variant: "secondary",
                text: buttonText,
                onClick: toggleModal
            }),
            isModalOpen ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $f63ad02b1a6c2334$export$2e2bcd8739ae039), {
                text: "Propose a settlement",
                toggleModal: toggleModal
            }) : null
        ]
    });
};
var $42310430474a8cfa$export$2e2bcd8739ae039 = $42310430474a8cfa$var$OpenModalProposeSettlementButton;



parcelRequire("9nZCP");




var $9nZCP = parcelRequire("9nZCP");

parcelRequire("9nZCP");

const $8baa1d678088f488$var$StyledP = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).p`
  color: ${({ theme: theme })=>theme.secondaryText};
  margin: 0;
`;
const $8baa1d678088f488$var$Description = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($8baa1d678088f488$var$StyledP, {
        children: [
            "In order to raise a dispute, both parties involved need to deposit the arbitration fees. The fees are used to pay the jurors for their work.",
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("br", {}),
            "After both sides deposit the fees the dispute starts. A random pool of jurors is selected to evaluate the case, the evidence, and vote. The side that receives the majority of votes wins the dispute and receives the arbitration fee back.",
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("br", {}),
            "After the juror's decision, both sides can still appeal the case if not satisfied with the result. It leads to another round with different jurors."
        ]
    });
};
var $8baa1d678088f488$export$2e2bcd8739ae039 = $8baa1d678088f488$var$Description;




parcelRequire("9nZCP");

const $a86a83a9e3203087$var$StyledHeader = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).h1`
  margin: 0;
`;
const $a86a83a9e3203087$var$Header = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($a86a83a9e3203087$var$StyledHeader, {
        children: "Raise a dispute"
    });
};
var $a86a83a9e3203087$export$2e2bcd8739ae039 = $a86a83a9e3203087$var$Header;




parcelRequire("9nZCP");




var $9nZCP = parcelRequire("9nZCP");







const $c48e9f30c63c1c27$var$RaiseDisputeButton = ({ toggleModal: toggleModal, buttonText: buttonText, arbitrationCost: arbitrationCost })=>{
    const { address: address } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    const [isSending, setIsSending] = (0, $9nZCP.useState)(false);
    const publicClient = (0, $b9a08c139e2d6879$export$3ca3483c611a99c4)();
    const { buyer: buyer, id: id } = (0, $4d51476fd708038f$export$57f2782cc8cecbb0)();
    const isBuyer = (0, $9nZCP.useMemo)(()=>address?.toLowerCase() === buyer?.toLowerCase(), [
        address,
        buyer
    ]);
    const refetchQuery = (0, $7f2cd7efc5dd98b6$export$a25b430d4137a40)();
    const { config: payArbitrationFeeByBuyerConfig } = (0, $65cd6dc33c6d9133$export$3e0fbcee4417d6bb)({
        args: [
            BigInt(id)
        ],
        value: arbitrationCost
    });
    const { config: payArbitrationFeeBySellerConfig } = (0, $65cd6dc33c6d9133$export$a7dfc7d070a1292d)({
        args: [
            BigInt(id)
        ],
        value: arbitrationCost
    });
    const { writeAsync: payArbitrationFeeByBuyer } = (0, $65cd6dc33c6d9133$export$81a542e519cd3e2b)(payArbitrationFeeByBuyerConfig);
    const { writeAsync: payArbitrationFeeBySeller } = (0, $65cd6dc33c6d9133$export$60f99c111151e20a)(payArbitrationFeeBySellerConfig);
    const handleRaiseDispute = ()=>{
        if (isBuyer && !(0, $c62bd748620e6ea9$export$fce6876652108ab)(payArbitrationFeeByBuyer)) {
            setIsSending(true);
            (0, $6724d57570dc2c5f$export$27738200007bd40a)(async ()=>await payArbitrationFeeByBuyer().then((response)=>response.hash), publicClient).then((wrapResult)=>{
                if (wrapResult.status) {
                    toggleModal && toggleModal();
                    refetchQuery([
                        [
                            "refetchOnBlock",
                            "useTransactionDetailsQuery"
                        ]
                    ]);
                } else setIsSending(false);
            }).catch((error)=>{
                console.error("Error raising dispute as buyer:", error);
                setIsSending(false);
            });
        } else if (!isBuyer && !(0, $c62bd748620e6ea9$export$fce6876652108ab)(payArbitrationFeeBySeller)) {
            setIsSending(true);
            (0, $6724d57570dc2c5f$export$27738200007bd40a)(async ()=>await payArbitrationFeeBySeller().then((response)=>response.hash), publicClient).then((wrapResult)=>{
                if (wrapResult.status) {
                    toggleModal && toggleModal();
                    refetchQuery([
                        [
                            "refetchOnBlock",
                            "useTransactionDetailsQuery"
                        ]
                    ]);
                } else setIsSending(false);
            }).catch((error)=>{
                console.error("Error raising dispute as seller:", error);
                setIsSending(false);
            });
        }
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.Button), {
        isLoading: isSending,
        disabled: isSending,
        text: buttonText,
        onClick: handleRaiseDispute
    });
};
var $c48e9f30c63c1c27$export$2e2bcd8739ae039 = $c48e9f30c63c1c27$var$RaiseDisputeButton;


const $bbdba0f00e9ba1bd$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
`;
const $bbdba0f00e9ba1bd$var$Buttons = ({ toggleModal: toggleModal, arbitrationCost: arbitrationCost })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($bbdba0f00e9ba1bd$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.Button), {
                variant: "secondary",
                text: "Return",
                onClick: toggleModal
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $c48e9f30c63c1c27$export$2e2bcd8739ae039), {
                buttonText: "Raise a dispute",
                toggleModal: toggleModal,
                arbitrationCost: arbitrationCost
            })
        ]
    });
};
var $bbdba0f00e9ba1bd$export$2e2bcd8739ae039 = $bbdba0f00e9ba1bd$var$Buttons;



parcelRequire("9nZCP");



var $c6heD = parcelRequire("c6heD");
const $7d9c9d234e8cdf84$var$StyledCard = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Card))`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme: theme })=>theme.mediumBlue};
  height: 87px;
  width: 100%;
  border: none;
  justify-content: center;
  align-items: center;
  padding: 15px;
  gap: 5px;
`;
const $7d9c9d234e8cdf84$var$StyledHeader = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).p`
  font-size: 14px;
  margin: 0;
  color: ${({ theme: theme })=>theme.primaryBlue};
`;
const $7d9c9d234e8cdf84$var$StyledQuantity = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).p`
  font-size: 24px;
  margin: 0;
  color: ${({ theme: theme })=>theme.primaryBlue};
  font-weight: 600;
`;
const $7d9c9d234e8cdf84$var$FeeRequired = ({ arbitrationCost: arbitrationCost })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($7d9c9d234e8cdf84$var$StyledCard, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($7d9c9d234e8cdf84$var$StyledHeader, {
                children: "Arbitration fee required"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($7d9c9d234e8cdf84$var$StyledQuantity, {
                children: [
                    (0, $c6heD.formatEther)(arbitrationCost),
                    " ETH"
                ]
            })
        ]
    });
};
var $7d9c9d234e8cdf84$export$2e2bcd8739ae039 = $7d9c9d234e8cdf84$var$FeeRequired;




const $6ea94d688e4f5bf6$var$ReStyledModal = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $199d04a141957ef1$export$8863cf9d79cd26ad))`
  gap: 32px;
`;
const $6ea94d688e4f5bf6$var$RaiseDisputeModal = ({ toggleModal: toggleModal, arbitrationCost: arbitrationCost })=>{
    const containerRef = (0, $9nZCP.useRef)(null);
    (0, $0aa9c5ea5f98ac89$export$2e2bcd8739ae039)(containerRef, ()=>toggleModal());
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $a4e24e3c9f4f276a$export$c6fdb837b070b4ff), {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($6ea94d688e4f5bf6$var$ReStyledModal, {
                ref: containerRef,
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $a86a83a9e3203087$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $8baa1d678088f488$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $7d9c9d234e8cdf84$export$2e2bcd8739ae039), {
                        arbitrationCost: arbitrationCost
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $bbdba0f00e9ba1bd$export$2e2bcd8739ae039), {
                        toggleModal: toggleModal,
                        arbitrationCost: arbitrationCost
                    })
                ]
            })
        ]
    });
};
var $6ea94d688e4f5bf6$export$2e2bcd8739ae039 = $6ea94d688e4f5bf6$var$RaiseDisputeModal;


const $f8dc884ffdafec2b$var$OpenModalRaiseDisputeButton = ({ arbitrationCost: arbitrationCost })=>{
    const [isModalOpen, toggleModal] = (0, $b2e41656ab938cc0$export$2e2bcd8739ae039)(false);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.Button), {
                variant: "secondary",
                text: "Raise a dispute",
                onClick: toggleModal
            }),
            isModalOpen ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $6ea94d688e4f5bf6$export$2e2bcd8739ae039), {
                toggleModal: toggleModal,
                arbitrationCost: arbitrationCost
            }) : null
        ]
    });
};
var $f8dc884ffdafec2b$export$2e2bcd8739ae039 = $f8dc884ffdafec2b$var$OpenModalRaiseDisputeButton;




var $9nZCP = parcelRequire("9nZCP");







const $95b92d5573dc98dc$var$AcceptButton = ({ toggleModal: toggleModal })=>{
    const [isSending, setIsSending] = (0, $9nZCP.useState)(false);
    const publicClient = (0, $b9a08c139e2d6879$export$3ca3483c611a99c4)();
    const { id: id } = (0, $4d51476fd708038f$export$57f2782cc8cecbb0)();
    const refetchQuery = (0, $7f2cd7efc5dd98b6$export$a25b430d4137a40)();
    const { config: acceptSettlementConfig } = (0, $65cd6dc33c6d9133$export$f99df855bcef3935)({
        args: [
            BigInt(id)
        ]
    });
    const { writeAsync: acceptSettlement } = (0, $65cd6dc33c6d9133$export$9b6cde88f65d242)(acceptSettlementConfig);
    const handleAcceptSettlement = ()=>{
        if (!(0, $c62bd748620e6ea9$export$fce6876652108ab)(acceptSettlement)) {
            setIsSending(true);
            (0, $6724d57570dc2c5f$export$27738200007bd40a)(async ()=>await acceptSettlement().then((response)=>response.hash), publicClient).then((wrapResult)=>{
                if (!wrapResult.status) setIsSending(false);
                refetchQuery([
                    [
                        "refetchOnBlock",
                        "useTransactionDetailsQuery"
                    ]
                ]);
            }).catch((error)=>{
                console.error("Error raising dispute as buyer:", error);
                setIsSending(false);
            });
        }
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.Button), {
        isLoading: isSending,
        disabled: isSending,
        text: "Accept",
        onClick: handleAcceptSettlement
    });
};
var $95b92d5573dc98dc$export$2e2bcd8739ae039 = $95b92d5573dc98dc$var$AcceptButton;




var $9nZCP = parcelRequire("9nZCP");




parcelRequire("9nZCP");
const $7c76b41b1ccba239$var$SvgArrow = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 16,
        height: 17,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
            clipPath: "url('804205be8eff702d')",
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "m6.516 1.803.792-.784a.86.86 0 0 1 1.211 0l6.942 6.863a.838.838 0 0 1 0 1.197L8.52 15.946a.86.86 0 0 1-1.21 0l-.793-.784a.842.842 0 0 1 .014-1.212l4.303-4.055H.57a.85.85 0 0 1-.857-.848v-1.13a.85.85 0 0 1 .857-.848h10.263L6.53 3.014a.836.836 0 0 1-.014-1.211Z",
                fill: "#009AFF"
            })
        })
    });
var $7c76b41b1ccba239$export$2e2bcd8739ae039 = $7c76b41b1ccba239$var$SvgArrow;



const $646af0346eabee7a$var$StyledButton = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $072682708a04db72$export$2e2bcd8739ae039))`
  display: flex;
  width: auto;
  gap: 8px;
  flex-direction: row-reverse;
  flex-wrap: wrap-reverse;
  > .button-text {
    color: ${({ theme: theme })=>theme.primaryBlue};
    white-space: normal;
    text-align: start;
  }
  padding-top: 0px;
`;
const $646af0346eabee7a$var$ViewCaseButton = ()=>{
    const { disputeRequest: disputeRequest, resolvedEvents: resolvedEvents } = (0, $4d51476fd708038f$export$57f2782cc8cecbb0)();
    const buttonText = (0, $9nZCP.useMemo)(()=>{
        if (disputeRequest?.id && resolvedEvents?.length > 0) return "Check how the jury voted on Kleros Court";
        return "Follow the case on Kleros Court";
    }, [
        disputeRequest,
        resolvedEvents
    ]);
    const buttonLink = (0, $9nZCP.useMemo)(()=>{
        if (disputeRequest?.id && resolvedEvents?.length > 0) return `https://dev--kleros-v2.netlify.app/#/cases/${disputeRequest.id}/voting`;
        return `https://dev--kleros-v2.netlify.app/#/cases/${disputeRequest.id}`;
    }, [
        disputeRequest,
        resolvedEvents
    ]);
    const handleButtonClick = ()=>{
        if (disputeRequest?.id) window.open(buttonLink, "_blank");
    };
    return disputeRequest?.id ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($646af0346eabee7a$var$StyledButton, {
        text: buttonText,
        Icon: (0, $7c76b41b1ccba239$export$2e2bcd8739ae039),
        className: "reverse-button",
        onClick: handleButtonClick
    }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e467ee9362ed574f$export$7387c3f2666b9f16), {});
};
var $646af0346eabee7a$export$2e2bcd8739ae039 = $646af0346eabee7a$var$ViewCaseButton;





var $9nZCP = parcelRequire("9nZCP");







const $1afe72ad1bab2051$var$TimeOutButton = ()=>{
    const { address: address } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    const [isSending, setIsSending] = (0, $9nZCP.useState)(false);
    const publicClient = (0, $b9a08c139e2d6879$export$3ca3483c611a99c4)();
    const { buyer: buyer, id: id } = (0, $4d51476fd708038f$export$57f2782cc8cecbb0)();
    const isBuyer = (0, $9nZCP.useMemo)(()=>address?.toLowerCase() === buyer?.toLowerCase(), [
        address,
        buyer
    ]);
    const refetchQuery = (0, $7f2cd7efc5dd98b6$export$a25b430d4137a40)();
    const { config: timeOutByBuyerConfig } = (0, $65cd6dc33c6d9133$export$5ea62317227a2199)({
        args: [
            BigInt(id)
        ]
    });
    const { config: timeOutBySellerConfig } = (0, $65cd6dc33c6d9133$export$6809d1cd2599fefd)({
        args: [
            BigInt(id)
        ]
    });
    const { writeAsync: timeOutByBuyer } = (0, $65cd6dc33c6d9133$export$aaae9e332ebd6554)(timeOutByBuyerConfig);
    const { writeAsync: timeOutBySeller } = (0, $65cd6dc33c6d9133$export$c882af1c56675709)(timeOutBySellerConfig);
    const handleTimeout = ()=>{
        if (isBuyer && !(0, $c62bd748620e6ea9$export$fce6876652108ab)(timeOutByBuyer)) {
            setIsSending(true);
            (0, $6724d57570dc2c5f$export$27738200007bd40a)(async ()=>await timeOutByBuyer().then((response)=>response.hash), publicClient).then((wrapResult)=>{
                if (!wrapResult.status) {
                    setIsSending(false);
                    refetchQuery([
                        [
                            "refetchOnBlock",
                            "useTransactionDetailsQuery"
                        ]
                    ]);
                }
            }).catch((error)=>{
                console.error("Error timing out as buyer:", error);
                setIsSending(false);
            });
        } else if (!isBuyer && !(0, $c62bd748620e6ea9$export$fce6876652108ab)(timeOutBySeller)) {
            setIsSending(true);
            (0, $6724d57570dc2c5f$export$27738200007bd40a)(async ()=>await timeOutBySeller().then((response)=>response.hash), publicClient).then((wrapResult)=>{
                if (!wrapResult.status) {
                    setIsSending(false);
                    refetchQuery([
                        [
                            "refetchOnBlock",
                            "useTransactionDetailsQuery"
                        ]
                    ]);
                }
            }).catch((error)=>{
                console.error("Error timing out as seller:", error);
                setIsSending(false);
            });
        }
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.Button), {
        isLoading: isSending,
        disabled: isSending,
        text: "Claim full payment back",
        onClick: handleTimeout
    });
};
var $1afe72ad1bab2051$export$2e2bcd8739ae039 = $1afe72ad1bab2051$var$TimeOutButton;


const $82f28ba6b6758dd9$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
`;
const $82f28ba6b6758dd9$var$Buttons = ({ feeTimeout: feeTimeout, settlementTimeout: settlementTimeout, arbitrationCost: arbitrationCost })=>{
    const { address: address } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    const { seller: seller, buyer: buyer, status: status, settlementProposals: settlementProposals, disputeRequest: disputeRequest, hasToPayFees: hasToPayFees, resolvedEvents: resolvedEvents } = (0, $4d51476fd708038f$export$57f2782cc8cecbb0)();
    const connectedAddress = address?.toLowerCase();
    const [currentTime, setCurrentTime] = (0, $9nZCP.useState)(Math.floor(Date.now() / 1000));
    (0, $9nZCP.useEffect)(()=>{
        const interval = setInterval(()=>{
            setCurrentTime(Math.floor(Date.now() / 1000));
        }, 1000);
        return ()=>clearInterval(interval);
    }, []);
    const isBuyer = (0, $9nZCP.useMemo)(()=>address?.toLowerCase() === buyer?.toLowerCase(), [
        address,
        buyer
    ]);
    const shouldPayFee = (0, $9nZCP.useMemo)(()=>hasToPayFees?.some((fee)=>{
            const partyRequiredToPay = fee.party;
            if (partyRequiredToPay === "1" && connectedAddress === buyer.toLowerCase()) return true;
            if (partyRequiredToPay === "2" && connectedAddress === seller.toLowerCase()) return true;
            return false;
        }), [
        hasToPayFees,
        connectedAddress,
        buyer,
        seller
    ]);
    const lastSettlementProposal = (0, $9nZCP.useMemo)(()=>settlementProposals?.[settlementProposals.length - 1], [
        settlementProposals
    ]);
    const isYourSettlementTurn = (0, $9nZCP.useMemo)(()=>lastSettlementProposal ? lastSettlementProposal.party === "1" && connectedAddress === seller.toLowerCase() || lastSettlementProposal.party === "2" && connectedAddress === buyer.toLowerCase() : false, [
        lastSettlementProposal,
        connectedAddress,
        buyer,
        seller
    ]);
    const shouldDisplayRaiseDisputeButton = (0, $9nZCP.useMemo)(()=>shouldPayFee && !disputeRequest && resolvedEvents?.length === 0, [
        shouldPayFee,
        disputeRequest,
        resolvedEvents
    ]);
    const shouldDisplaySettlementButtons = (0, $9nZCP.useMemo)(()=>hasToPayFees?.length === 0 && isYourSettlementTurn && ![
            "Disputed",
            "TransactionResolved",
            "WaitingBuyer",
            "WaitingSeller"
        ].includes(status), [
        hasToPayFees,
        isYourSettlementTurn,
        status
    ]);
    const settlementTimeLeft = (0, $9nZCP.useMemo)(()=>settlementTimeout - (currentTime - lastSettlementProposal?.timestamp), [
        settlementTimeout,
        currentTime,
        lastSettlementProposal
    ]);
    const feeTimeLeft = (0, $9nZCP.useMemo)(()=>feeTimeout - (currentTime - hasToPayFees?.[0]?.timestamp), [
        feeTimeout,
        currentTime,
        hasToPayFees
    ]);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            shouldDisplaySettlementButtons ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($82f28ba6b6758dd9$var$Container, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $95b92d5573dc98dc$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $42310430474a8cfa$export$2e2bcd8739ae039), {
                        buttonText: "Counter-propose"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $f8dc884ffdafec2b$export$2e2bcd8739ae039), {
                        arbitrationCost: arbitrationCost
                    })
                ]
            }) : null,
            shouldDisplayRaiseDisputeButton && arbitrationCost ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($82f28ba6b6758dd9$var$Container, {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $c48e9f30c63c1c27$export$2e2bcd8739ae039), {
                    buttonText: `Deposit the fee: ${(0, $c6heD.formatEther)(arbitrationCost)} ETH`,
                    arbitrationCost: arbitrationCost
                })
            }) : null,
            disputeRequest ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($82f28ba6b6758dd9$var$Container, {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $646af0346eabee7a$export$2e2bcd8739ae039), {})
            }) : null,
            settlementTimeLeft <= 0 && (status === "WaitingSettlementSeller" && isBuyer || status === "WaitingSettlementBuyer" && !isBuyer) ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $f8dc884ffdafec2b$export$2e2bcd8739ae039), {
                arbitrationCost: arbitrationCost
            }) : null,
            feeTimeLeft <= 0 && (status === "WaitingSeller" && isBuyer || status === "WaitingBuyer" && !isBuyer) ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($82f28ba6b6758dd9$var$Container, {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $1afe72ad1bab2051$export$2e2bcd8739ae039), {})
            }) : null
        ]
    });
};
var $82f28ba6b6758dd9$export$2e2bcd8739ae039 = $82f28ba6b6758dd9$var$Buttons;


const $57ea835644a1b14d$export$94fdbc1f5368d5e4 = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Card))`
  height: auto;
  min-height: 100px;
  width: 86vw;
  align-self: center;
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(24, 32)};

  ${({ isPreview: isPreview })=>isPreview && (0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      padding-bottom: 36px;
    `}

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      max-width: 100%;
    `)}
`;
const $57ea835644a1b14d$export$2e0a83ec2e27ecbb = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).hr`
  display: flex;
  border: none;
  height: 1px;
  background-color: ${({ theme: theme })=>theme.stroke};
  margin: 0;
`;
const $57ea835644a1b14d$var$TransactionInfoContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;
const $57ea835644a1b14d$var$PreviewCard = ({ escrowType: escrowType, escrowTitle: escrowTitle, deliverableText: deliverableText, receivingQuantity: receivingQuantity, transactionCreationTimestamp: transactionCreationTimestamp, status: status, buyerAddress: buyerAddress, sendingQuantity: sendingQuantity, sellerAddress: sellerAddress, deadline: deadline, assetSymbol: assetSymbol, overrideIsList: overrideIsList, extraDescriptionUri: extraDescriptionUri, isPreview: isPreview, payments: payments, settlementProposals: settlementProposals, hasToPayFees: hasToPayFees, disputeRequest: disputeRequest, resolvedEvents: resolvedEvents, feeTimeout: feeTimeout, settlementTimeout: settlementTimeout, arbitrationCost: arbitrationCost })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($57ea835644a1b14d$export$94fdbc1f5368d5e4, {
        isPreview: isPreview,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $455cbf2ccbf42855$export$2e2bcd8739ae039), {
                escrowType: escrowType,
                escrowTitle: escrowTitle,
                status: status,
                isCard: false
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($57ea835644a1b14d$var$TransactionInfoContainer, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($57ea835644a1b14d$export$2e0a83ec2e27ecbb, {}),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $f023554fa7f1bc9f$export$2e2bcd8739ae039), {
                        amount: sendingQuantity,
                        isPreview: true,
                        overrideIsList: overrideIsList,
                        deadline: deadline,
                        sellerAddress: sellerAddress,
                        buyerAddress: buyerAddress,
                        assetSymbol: assetSymbol
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($57ea835644a1b14d$export$2e0a83ec2e27ecbb, {})
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $d5fb57762d465895$export$2e2bcd8739ae039), {
                escrowType: escrowType,
                deliverableText: deliverableText,
                receivingQuantity: receivingQuantity,
                buyerAddress: buyerAddress,
                sendingQuantity: sendingQuantity,
                sellerAddress: sellerAddress,
                deadline: deadline,
                assetSymbol: assetSymbol,
                extraDescriptionUri: extraDescriptionUri
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($57ea835644a1b14d$export$2e0a83ec2e27ecbb, {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $744b4d7a62ff341b$export$2e2bcd8739ae039), {
                isPreview: isPreview,
                status: status,
                assetSymbol: assetSymbol,
                transactionCreationTimestamp: transactionCreationTimestamp,
                buyerAddress: buyerAddress,
                sellerAddress: sellerAddress,
                payments: payments,
                settlementProposals: settlementProposals,
                hasToPayFees: hasToPayFees,
                disputeRequest: disputeRequest,
                resolvedEvents: resolvedEvents,
                feeTimeout: feeTimeout,
                settlementTimeout: settlementTimeout
            }),
            !isPreview ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $82f28ba6b6758dd9$export$2e2bcd8739ae039), {
                feeTimeout: feeTimeout,
                settlementTimeout: settlementTimeout,
                arbitrationCost: arbitrationCost
            }) : null
        ]
    });
var $57ea835644a1b14d$export$2e2bcd8739ae039 = $57ea835644a1b14d$var$PreviewCard;



parcelRequire("9nZCP");


const $27b83b1b87662d34$var$StyledHeader = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).h1`
  margin: 0;
  color: ${({ theme: theme })=>theme.secondaryPurple};
  font-weight: 400;
  margin-bottom: 32px;
  margin-top: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(4, 20)};
`;
const $27b83b1b87662d34$var$Header = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($27b83b1b87662d34$var$StyledHeader, {
        children: "Preview"
    });
};
var $27b83b1b87662d34$export$2e2bcd8739ae039 = $27b83b1b87662d34$var$Header;




const $1c28f538a7a87c87$export$e53e2a70ea774bf2 = ()=>{
    const { chain: chain } = (0, $b9a08c139e2d6879$export$553aaf59afc1a2d8)();
    return chain?.nativeCurrency?.symbol;
};


const $d4de675bf8395fa4$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
const $d4de675bf8395fa4$var$Preview = ()=>{
    const { escrowType: escrowType, deliverableText: deliverableText, receivingQuantity: receivingQuantity, sellerAddress: sellerAddress, sendingQuantity: sendingQuantity, sendingToken: sendingToken, escrowTitle: escrowTitle, deadline: deadline, extraDescriptionUri: extraDescriptionUri } = (0, $fa4dc73a0abb4258$export$ab0988b836f3e0ac)();
    const isNativeTransaction = sendingToken.address === "native";
    const nativeTokenSymbol = (0, $1c28f538a7a87c87$export$e53e2a70ea774bf2)();
    const { address: address } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($d4de675bf8395fa4$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $27b83b1b87662d34$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $57ea835644a1b14d$export$2e2bcd8739ae039), {
                buyerAddress: address,
                assetSymbol: isNativeTransaction ? nativeTokenSymbol : sendingToken.symbol,
                overrideIsList: false,
                isPreview: true,
                deadline: new Date(deadline).getTime(),
                receivingQuantity: receivingQuantity,
                sellerAddress: sellerAddress,
                sendingQuantity: sendingQuantity,
                escrowType: escrowType,
                deliverableText: deliverableText,
                escrowTitle: escrowTitle,
                extraDescriptionUri: extraDescriptionUri
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $fab3b51b2e28c7da$export$2e2bcd8739ae039), {
                prevRoute: "/new-transaction/notifications",
                nextRoute: "/new-transaction/deliverable"
            })
        ]
    });
};
var $d4de675bf8395fa4$export$2e2bcd8739ae039 = $d4de675bf8395fa4$var$Preview;



parcelRequire("9nZCP");





const $5d9c633f31e83173$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $5d9c633f31e83173$var$StyledDatepicker = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Datepicker))``;
const $5d9c633f31e83173$var$Deadline = ()=>{
    const { setDeadline: setDeadline } = (0, $fa4dc73a0abb4258$export$ab0988b836f3e0ac)();
    const handleDateSelect = (date)=>{
        setDeadline(date);
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($5d9c633f31e83173$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e5652d9f4b8c73d1$export$2e2bcd8739ae039), {
                text: "Delivery Deadline"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($5d9c633f31e83173$var$StyledDatepicker, {
                time: true,
                onSelect: handleDateSelect
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $fab3b51b2e28c7da$export$2e2bcd8739ae039), {
                prevRoute: "/new-transaction/payment",
                nextRoute: "/new-transaction/notifications"
            })
        ]
    });
};
var $5d9c633f31e83173$export$2e2bcd8739ae039 = $5d9c633f31e83173$var$Deadline;



parcelRequire("9nZCP");









parcelRequire("9nZCP");





var $9nZCP = parcelRequire("9nZCP");





var $9nZCP = parcelRequire("9nZCP");

var $9nZCP = parcelRequire("9nZCP");
function $1cff464e624b80ba$export$2e2bcd8739ae039(fn, ms) {
    if (ms === void 0) ms = 0;
    var ready = (0, $9nZCP.useRef)(false);
    var timeout = (0, $9nZCP.useRef)();
    var callback = (0, $9nZCP.useRef)(fn);
    var isReady = (0, $9nZCP.useCallback)(function() {
        return ready.current;
    }, []);
    var set = (0, $9nZCP.useCallback)(function() {
        ready.current = false;
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(function() {
            ready.current = true;
            callback.current();
        }, ms);
    }, [
        ms
    ]);
    var clear = (0, $9nZCP.useCallback)(function() {
        ready.current = null;
        timeout.current && clearTimeout(timeout.current);
    }, []);
    // update ref when function changes
    (0, $9nZCP.useEffect)(function() {
        callback.current = fn;
    }, [
        fn
    ]);
    // set on mount, clear on unmount
    (0, $9nZCP.useEffect)(function() {
        set();
        return clear;
    }, [
        ms
    ]);
    return [
        isReady,
        clear,
        set
    ];
}


function $c171e39a1b1b690a$export$2e2bcd8739ae039(fn, ms, deps) {
    if (ms === void 0) ms = 0;
    if (deps === void 0) deps = [];
    var _a = (0, $1cff464e624b80ba$export$2e2bcd8739ae039)(fn, ms), isReady = _a[0], cancel = _a[1], reset = _a[2];
    (0, $9nZCP.useEffect)(reset, deps);
    return [
        isReady,
        cancel
    ];
}





const $837bbe77b3d6c5a7$var$StyledField = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Field))`
  width: 84vw;
  margin-bottom: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(68, 40)};

  small {
    margin-top: 6px;
    svg {
      margin-top: 8px;
    }
  }

  input {
    font-size: 16px;
  }

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      width: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(342, 574)};
    `)}
`;
const $837bbe77b3d6c5a7$var$DestinationAddress = ({ recipientAddress: recipientAddress, setRecipientAddress: setRecipientAddress })=>{
    const [isValid, setIsValid] = (0, $9nZCP.useState)(true);
    const [debouncedRecipientAddress, setDebouncedRecipientAddress] = (0, $9nZCP.useState)(recipientAddress);
    const ensResult = (0, $b9a08c139e2d6879$export$882e13b9ff368f82)({
        name: debouncedRecipientAddress,
        chainId: 1
    });
    const { setIsRecipientAddressResolved: setIsRecipientAddressResolved } = (0, $fa4dc73a0abb4258$export$ab0988b836f3e0ac)();
    (0, $c171e39a1b1b690a$export$2e2bcd8739ae039)(()=>setDebouncedRecipientAddress(recipientAddress), 350, [
        recipientAddress
    ]);
    (0, $9nZCP.useEffect)(()=>{
        const isAddressValid = (0, $bc6948c94a5f7586$export$f78173835dcde49f)(debouncedRecipientAddress);
        setIsValid(isAddressValid);
        setIsRecipientAddressResolved(isAddressValid);
        if ((0, $bc6948c94a5f7586$export$8615c39c33cb6186).test(debouncedRecipientAddress)) {
            setIsValid(!!ensResult.data);
            setIsRecipientAddressResolved(!!ensResult.data);
        }
    }, [
        debouncedRecipientAddress,
        ensResult.data,
        setIsRecipientAddressResolved
    ]);
    const handleWrite = (event)=>{
        const input = event.target.value;
        setRecipientAddress(input);
    };
    const message = (0, $9nZCP.useMemo)(()=>{
        if (debouncedRecipientAddress === "" || isValid) return "The ETH address or ENS of the person/entity that will receive the funds.";
        else return "The ETH address or ENS of the person/entity is not correct.";
    }, [
        debouncedRecipientAddress,
        isValid
    ]);
    const variant = (0, $9nZCP.useMemo)(()=>{
        if (debouncedRecipientAddress === "") return "info";
        else if (isValid) return "success";
        else return "error";
    }, [
        debouncedRecipientAddress,
        isValid
    ]);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($837bbe77b3d6c5a7$var$StyledField, {
        type: "text",
        value: recipientAddress,
        onChange: handleWrite,
        placeholder: "eg. 0x123ABC... or john.eth",
        variant: variant,
        message: message,
        maxLength: 42
    });
};
var $837bbe77b3d6c5a7$export$2e2bcd8739ae039 = $837bbe77b3d6c5a7$var$DestinationAddress;



parcelRequire("9nZCP");

const $5ae3f15a3c885771$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).h1`
  margin-bottom: 26px;
`;
const $5ae3f15a3c885771$var$ToDivider = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($5ae3f15a3c885771$var$Container, {
        children: "to"
    });
};
var $5ae3f15a3c885771$export$2e2bcd8739ae039 = $5ae3f15a3c885771$var$ToDivider;



parcelRequire("9nZCP");




parcelRequire("9nZCP");

const $5e6a2487f7ba0959$var$Amount = ({ quantity: quantity, setQuantity: setQuantity })=>{
    const handleWrite = (event)=>{
        setQuantity(event.target.value);
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.Field), {
        value: quantity,
        onChange: handleWrite,
        type: "number",
        placeholder: "eg. 3.6"
    });
};
var $5e6a2487f7ba0959$export$2e2bcd8739ae039 = $5e6a2487f7ba0959$var$Amount;



parcelRequire("9nZCP");


const $a6c58ea25f720cb8$var$StyledDropdownSelect = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.DropdownSelect))`
  button {
    height: 45px;
  }
`;
const $a6c58ea25f720cb8$var$Token = ({ token: token, setToken: setToken })=>{
    const handleTokenChange = (value)=>{
        setToken(value.toString());
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($a6c58ea25f720cb8$var$StyledDropdownSelect, {
        items: [
            {
                text: "xDAI",
                dot: "red",
                value: "xDAI"
            },
            {
                text: "ETH",
                dot: "blue",
                value: "ETH"
            }
        ],
        callback: handleTokenChange
    });
};
var $a6c58ea25f720cb8$export$2e2bcd8739ae039 = $a6c58ea25f720cb8$var$Token;


const $cc1f98f49989504a$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  margin-bottom: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(24, 18)};

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      flex-direction: row;
    `)}
`;
const $cc1f98f49989504a$var$TokenAndAmount = ({ quantity: quantity, setQuantity: setQuantity, token: token, setToken: setToken })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($cc1f98f49989504a$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $5e6a2487f7ba0959$export$2e2bcd8739ae039), {
                quantity: quantity,
                setQuantity: setQuantity
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $a6c58ea25f720cb8$export$2e2bcd8739ae039), {
                token: token,
                setToken: setToken
            })
        ]
    });
};
var $cc1f98f49989504a$export$2e2bcd8739ae039 = $cc1f98f49989504a$var$TokenAndAmount;


const $776a355fdaf8acf0$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $776a355fdaf8acf0$var$TokenTransaction = ({ headerText: headerText, prevRoute: prevRoute, nextRoute: nextRoute, quantity: quantity, setQuantity: setQuantity, token: token, setToken: setToken, recipientAddress: recipientAddress, setRecipientAddress: setRecipientAddress })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($776a355fdaf8acf0$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e5652d9f4b8c73d1$export$2e2bcd8739ae039), {
                text: headerText
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cc1f98f49989504a$export$2e2bcd8739ae039), {
                quantity: quantity,
                setQuantity: setQuantity,
                token: token,
                setToken: setToken
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $5ae3f15a3c885771$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $837bbe77b3d6c5a7$export$2e2bcd8739ae039), {
                recipientAddress: recipientAddress,
                setRecipientAddress: setRecipientAddress
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $fab3b51b2e28c7da$export$2e2bcd8739ae039), {
                prevRoute: prevRoute,
                nextRoute: nextRoute
            })
        ]
    });
};
var $776a355fdaf8acf0$export$2e2bcd8739ae039 = $776a355fdaf8acf0$var$TokenTransaction;



const $640d4adaf86d9f46$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $640d4adaf86d9f46$var$StyledTextArea = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Textarea))`
  width: 84vw;
  height: 200px;
  margin-bottom: 16px;
  textarea {
    font-size: 16px;
  }

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      width: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(342, 699)};
    `)}
`;
const $640d4adaf86d9f46$var$StyledFileUploader = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.FileUploader))`
  width: 84vw;
  margin-bottom: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(72, 52)};

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      width: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(342, 699)};
    `)}
`;
const $640d4adaf86d9f46$var$Deliverable = ()=>{
    const { escrowType: escrowType, deliverableText: deliverableText, setDeliverableText: setDeliverableText, setDeliverableFile: setDeliverableFile, receivingQuantity: receivingQuantity, setReceivingQuantity: setReceivingQuantity, receivingToken: receivingToken, setReceivingToken: setReceivingToken, buyerAddress: buyerAddress, setBuyerAddress: setBuyerAddress } = (0, $fa4dc73a0abb4258$export$ab0988b836f3e0ac)();
    const handleWrite = (event)=>{
        setDeliverableText(event.target.value);
    };
    const handleAttachFile = (file)=>{
        setDeliverableFile(file);
        if (file.type !== "application/pdf") (0, $73d46209e4d80851$export$b410431fab84fa58).error("That type of file is not valid. Please upload a PDF file.", (0, $6724d57570dc2c5f$export$8eb3892b442747bd));
    };
    const fileFootMessage = "You can attach additional information as a PDF file. Important: the above description must reference the relevant parts of the file content.";
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($640d4adaf86d9f46$var$Container, {
        children: escrowType === "general" ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e5652d9f4b8c73d1$export$2e2bcd8739ae039), {
                    text: "Contract Terms"
                }),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($640d4adaf86d9f46$var$StyledTextArea, {
                    value: deliverableText,
                    onChange: handleWrite,
                    placeholder: "eg. I should receive a website created in React with the following specification: x,y,z."
                }),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($640d4adaf86d9f46$var$StyledFileUploader, {
                    callback: handleAttachFile,
                    variant: "info",
                    msg: fileFootMessage
                }),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $fab3b51b2e28c7da$export$2e2bcd8739ae039), {
                    prevRoute: "/new-transaction/title",
                    nextRoute: "/new-transaction/payment"
                })
            ]
        }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $776a355fdaf8acf0$export$2e2bcd8739ae039), {
            headerText: "I should receive",
            prevRoute: "/new-transaction/title",
            nextRoute: "/new-transaction/payment",
            quantity: receivingQuantity,
            setQuantity: setReceivingQuantity,
            token: receivingToken,
            setToken: setReceivingToken,
            recipientAddress: buyerAddress,
            setRecipientAddress: setBuyerAddress
        })
    });
};
var $640d4adaf86d9f46$export$2e2bcd8739ae039 = $640d4adaf86d9f46$var$Deliverable;



parcelRequire("9nZCP");




var $9nZCP = parcelRequire("9nZCP");







const $257b04b32757799e$var$StyledField = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Field))`
  width: 84vw;
  margin-bottom: 48px;

  input {
    font-size: 16px;
  }

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      width: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(342, 476)};
    `)}
`;
const $257b04b32757799e$var$EmailField = ()=>{
    const { notificationEmail: notificationEmail, setNotificationEmail: setNotificationEmail } = (0, $fa4dc73a0abb4258$export$ab0988b836f3e0ac)();
    const [isEmailValid, setIsEmailValid] = (0, $9nZCP.useState)(true);
    const { data: userSettings } = (0, $2c4f8190202ecf20$export$8b4f00ca24c1e68e)();
    (0, $9nZCP.useEffect)(()=>{
        if (!userSettings) return;
        setNotificationEmail(userSettings.email ?? "");
    }, [
        userSettings
    ]);
    const handleWrite = (event)=>{
        const input = event.target.value;
        setNotificationEmail(input);
        setIsEmailValid(input === "" || (0, $4ec8515f3272cbaa$export$7b7637218245c8a).test(input));
    };
    const variant = notificationEmail === "" ? "info" : isEmailValid ? "success" : "error";
    const message = isEmailValid || notificationEmail === "" ? "We advise you to subscribe to notifications to be informed about the escrow progress." : "Email is not valid.";
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($257b04b32757799e$var$StyledField, {
        type: "email",
        value: notificationEmail,
        onChange: handleWrite,
        placeholder: "youremail@email.com",
        variant: variant,
        message: message
    });
};
var $257b04b32757799e$export$2e2bcd8739ae039 = $257b04b32757799e$var$EmailField;



const $47143f5a1b03db38$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $47143f5a1b03db38$var$Notifications = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($47143f5a1b03db38$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e5652d9f4b8c73d1$export$2e2bcd8739ae039), {
                text: "Subscribe for Email Notifications"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $257b04b32757799e$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $fab3b51b2e28c7da$export$2e2bcd8739ae039), {
                prevRoute: "/new-transaction/deadline",
                nextRoute: "/new-transaction/preview"
            })
        ]
    });
};
var $47143f5a1b03db38$export$2e2bcd8739ae039 = $47143f5a1b03db38$var$Notifications;



parcelRequire("9nZCP");



parcelRequire("9nZCP");







var $9nZCP = parcelRequire("9nZCP");





var $c6heD = parcelRequire("c6heD");
var $6u2UO = parcelRequire("6u2UO");
function $a3bb9160bc432d6d$export$de1294767e6ef661(value) {
    const comps = String(value).split(".");
    if (comps.length > 2 || !comps[0].match(/^-?[0-9]*$/) || comps[1] && !comps[1].match(/^[0-9]*$/) || value === "." || value === "-.") return value.toString();
    // Make sure we have at least one whole digit (0 if none)
    let whole = comps[0];
    let negative = "";
    if (whole.substring(0, 1) === "-") {
        negative = "-";
        whole = whole.substring(1);
    }
    // Make sure we have at least 1 whole digit with no leading zeros
    while(whole.substring(0, 1) === "0")whole = whole.substring(1);
    if (whole === "") whole = "0";
    let suffix = "";
    if (comps.length === 2) suffix = "." + (comps[1] || "0");
    while(suffix.length > 2 && suffix[suffix.length - 1] === "0")suffix = suffix.substring(0, suffix.length - 1);
    const formatted = [];
    while(whole.length)if (whole.length <= 3) {
        formatted.unshift(whole);
        break;
    } else {
        const index = whole.length - 3;
        formatted.unshift(whole.substring(index));
        whole = whole.substring(0, index);
    }
    if (suffix === ".0") suffix = "";
    return negative + formatted.join(",") + suffix;
}
function $a3bb9160bc432d6d$export$44b9d1d1a3173788(value) {
    return value.replace(/,/g, "");
}


const $8419175b17e44d0a$export$f78533b8f2581318 = (value, fractionDigits = 0)=>{
    const factor = 10 ** fractionDigits;
    return Math.floor(value * factor) / factor;
};
const $8419175b17e44d0a$export$4adf19926ad5efb5 = (value)=>(0, $6u2UO.formatUnits)(value, 18);
const $8419175b17e44d0a$export$7c4d25c0c3217d8c = (value, fractionDigits, roundDown)=>{
    let units = Number(value);
    if (roundDown) units = $8419175b17e44d0a$export$f78533b8f2581318(units, fractionDigits);
    return (0, $a3bb9160bc432d6d$export$de1294767e6ef661)(units.toFixed(fractionDigits));
};
const $8419175b17e44d0a$export$fe0dbb825775d15c = (value, fractionDigits = 0, roundDown = true)=>$8419175b17e44d0a$export$7c4d25c0c3217d8c($8419175b17e44d0a$export$4adf19926ad5efb5(value), fractionDigits, roundDown);
const $8419175b17e44d0a$export$81d0e33f8b79c8db = (value, fractionDigits = 4, roundDown = true)=>$8419175b17e44d0a$export$7c4d25c0c3217d8c((0, $c6heD.formatEther)(value), fractionDigits, roundDown);
const $8419175b17e44d0a$export$700d496f06f3d38f = (value, fractionDigits = 2)=>"$" + (0, $a3bb9160bc432d6d$export$de1294767e6ef661)(Number(value).toFixed(fractionDigits));


const $ffb69007bd2430e1$export$4356254075e80b7d = (balanceData, token)=>{
    if (!balanceData) return undefined;
    if (token?.symbol === "PNK") return (0, $8419175b17e44d0a$export$fe0dbb825775d15c)(balanceData.value);
    return (0, $8419175b17e44d0a$export$81d0e33f8b79c8db)(balanceData.value);
};



parcelRequire("9nZCP");


const $b1f0ceca2c27d6ce$var$StyledField = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Field))`
  width: 186px;
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    appearance: none;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }

  input {
    font-size: 16px;
    padding-right: ${({ variant: variant })=>variant ? "40px" : "16px"};
  }
`;
const $b1f0ceca2c27d6ce$var$AmountField = ({ quantity: quantity, setQuantity: setQuantity, error: error })=>{
    const handleWrite = (event)=>{
        setQuantity(event.target.value);
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($b1f0ceca2c27d6ce$var$StyledField, {
        value: quantity,
        onChange: handleWrite,
        type: "number",
        placeholder: "Amount",
        variant: error ? "error" : undefined,
        message: error
    });
};
var $b1f0ceca2c27d6ce$export$2e2bcd8739ae039 = $b1f0ceca2c27d6ce$var$AmountField;




var $9nZCP = parcelRequire("9nZCP");



var $l06UM = parcelRequire("l06UM");


const $5d3a7c926109e006$export$3a1cec67629541fd = (chain)=>{
    return {
        symbol: chain?.nativeCurrency?.symbol,
        address: "native"
    };
};


const $0b92f115a791c603$export$36091963c0257325 = async (address, alchemyInstance)=>{
    try {
        const metadata = await alchemyInstance.core.getTokenMetadata(address);
        return {
            symbol: metadata.symbol?.toUpperCase(),
            logo: metadata.logo,
            address: address
        };
    } catch (error) {
        return console.error("Error fetching token info:", error);
    }
};


const $780ca05c679b9e1b$export$f4fdbbc956f2c626 = async (address, setTokens, setLoading, chain, alchemyInstance)=>{
    try {
        setLoading(true);
        const nativeToken = (0, $5d3a7c926109e006$export$3a1cec67629541fd)(chain);
        const balances = await alchemyInstance.core.getTokenBalances(address);
        const tokenList = await Promise.all(balances.tokenBalances.map(async (token)=>{
            const tokenInfo = await (0, $0b92f115a791c603$export$36091963c0257325)(token.contractAddress, alchemyInstance);
            return {
                symbol: tokenInfo.symbol,
                address: tokenInfo.address,
                logo: tokenInfo.logo
            };
        }));
        const allTokens = [
            nativeToken,
            ...tokenList
        ];
        const customTokens = JSON.parse(localStorage.getItem("tokens")) || [];
        const combinedTokens = [
            ...allTokens,
            ...customTokens.filter((customToken)=>!allTokens.some((token)=>token.address === customToken.address))
        ];
        setTokens(combinedTokens);
        localStorage.setItem("tokens", JSON.stringify(combinedTokens));
        setLoading(false);
    } catch (error) {
        console.error("Error initializing tokens:", error);
        setLoading(false);
    }
};




var $l06UM = parcelRequire("l06UM");
function $4f1364bd79ae39c0$export$53fb2f5102ffe75b(chainId) {
    switch(chainId){
        case 1:
            return (0, $l06UM.N).ETH_MAINNET;
        case 11155111:
            return (0, $l06UM.N).ETH_SEPOLIA;
        case 10:
            return (0, $l06UM.N).OPT_MAINNET;
        case 137:
            return (0, $l06UM.N).MATIC_MAINNET;
        case 42161:
            return (0, $l06UM.N).ARB_MAINNET;
        case 421614:
            return (0, $l06UM.N).ARB_SEPOLIA;
        default:
            return (0, $l06UM.N).ARB_SEPOLIA;
    }
}


const $209ce342cf15c0ab$export$3eae92904abeaa77 = (chainId)=>({
        apiKey: (0, $93cb5c29b614ea9a$export$1078a9b7607c322d),
        network: (0, $4f1364bd79ae39c0$export$53fb2f5102ffe75b)(chainId)
    });




parcelRequire("9nZCP");



parcelRequire("9nZCP");


parcelRequire("9nZCP");
const $bb4898f64ecde920$var$SvgArb = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
                clipPath: "url(#arb_svg__a)",
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("g", {
                    clipPath: "url(#arb_svg__b)",
                    children: [
                        /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                            d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
                            fill: "#213147"
                        }),
                        /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("g", {
                            clipPath: "url(#arb_svg__c)",
                            children: [
                                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                                    d: "M5.446 8.864v6.272c0 .403.212.768.564.973l5.433 3.136c.346.198.775.198 1.12 0l5.434-3.136c.345-.199.563-.57.563-.973V8.864c0-.403-.211-.768-.563-.973l-5.434-3.136a1.128 1.128 0 0 0-1.12 0L6.01 7.891c-.346.199-.557.57-.557.973h-.007Z",
                                    fill: "#213147"
                                }),
                                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                                    d: "m13.184 13.216-.774 2.125a.306.306 0 0 0 0 .186l1.33 3.654 1.543-.89-1.85-5.075a.133.133 0 0 0-.249 0ZM14.74 9.645a.133.133 0 0 0-.25 0l-.775 2.125a.306.306 0 0 0 0 .185l2.183 5.984 1.542-.89-2.7-7.398v-.006Z",
                                    fill: "#12AAFF"
                                }),
                                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                                    d: "M12 4.992c.038 0 .077.013.109.032l5.875 3.392c.07.038.109.115.109.192v6.784a.232.232 0 0 1-.109.192l-5.875 3.392a.216.216 0 0 1-.109.032.216.216 0 0 1-.109-.032l-5.875-3.392a.217.217 0 0 1-.109-.192v-6.79c0-.077.045-.154.109-.192l5.875-3.392A.216.216 0 0 1 12 4.986v.006ZM12 4c-.211 0-.416.051-.608.16L5.517 7.552a1.207 1.207 0 0 0-.608 1.05v6.784c0 .435.23.832.608 1.05l5.875 3.391a1.2 1.2 0 0 0 .608.16c.211 0 .416-.051.608-.16l5.875-3.392c.378-.217.608-.614.608-1.05V8.603c0-.436-.23-.832-.608-1.05L12.602 4.16a1.2 1.2 0 0 0-.608-.16H12Z",
                                    fill: "#9DCCED"
                                }),
                                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                                    d: "m8.109 17.946.544-1.485 1.088.902-1.018.935-.614-.352Z",
                                    fill: "#213147"
                                }),
                                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                                    d: "M11.5 8.122h-1.49a.27.27 0 0 0-.25.172L6.566 17.05l1.543.89 3.52-9.646a.132.132 0 0 0-.122-.179l-.006.007ZM14.112 8.122h-1.491a.27.27 0 0 0-.25.172l-3.648 9.997 1.543.89 3.968-10.887a.132.132 0 0 0-.122-.179v.007Z",
                                    fill: "#fff"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                        id: "arb_svg__a",
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h24v24H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                        id: "arb_svg__b",
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h24v24H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                        id: "arb_svg__c",
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(4 4)",
                            d: "M0 0h16v16H0z"
                        })
                    })
                ]
            })
        ]
    });
var $bb4898f64ecde920$export$2e2bcd8739ae039 = $bb4898f64ecde920$var$SvgArb;



parcelRequire("9nZCP");
const $3653ef0161ab937d$var$SvgDai = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
                clipPath: "url(#dai_svg__a)",
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("g", {
                    clipPath: "url(#dai_svg__b)",
                    children: [
                        /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                            d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
                            fill: "#FABB36"
                        }),
                        /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                            d: "M19.116 10.02h-1.424c-.784-2.176-2.892-3.668-5.672-3.668H7.448v3.668H5.86v1.316h1.588v1.38H5.86v1.316h1.588v3.624h4.572c2.748 0 4.84-1.48 5.644-3.624h1.452v-1.316h-1.132a5.97 5.97 0 0 0 .044-.712v-.032c0-.216-.012-.428-.032-.636h1.124V10.02h-.004ZM8.728 7.524h3.292c2.04 0 3.556 1.004 4.256 2.492H8.728V7.524Zm3.292 8.948H8.728v-2.444h7.54c-.704 1.464-2.216 2.444-4.248 2.444Zm4.684-4.44c0 .232-.016.46-.048.68H8.728v-1.38h7.932c.028.216.044.44.044.668v.032Z",
                            fill: "#fff"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                        id: "dai_svg__a",
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h24v24H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                        id: "dai_svg__b",
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h24v24H0z"
                        })
                    })
                ]
            })
        ]
    });
var $3653ef0161ab937d$export$2e2bcd8739ae039 = $3653ef0161ab937d$var$SvgDai;



parcelRequire("9nZCP");
const $af3f5bd2b59709b5$var$SvgEth = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 12,
                fill: "#627EEA"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M12 4v5.915l4.999 2.233-5-8.148Z",
                fill: "#C1CCF7"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "m12 4-5 8.148 5-2.233V4Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M12 15.981V20l5.002-6.92L12 15.98Z",
                fill: "#C1CCF7"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M12 20v-4.02l-5-2.9L12 20Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "m12 15.051 4.999-2.902-5-2.233v5.135Z",
                fill: "#8198EE"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "m7 12.149 5 2.902V9.916l-5 2.232Z",
                fill: "#C1CCF7"
            })
        ]
    });
var $af3f5bd2b59709b5$export$2e2bcd8739ae039 = $af3f5bd2b59709b5$var$SvgEth;



parcelRequire("9nZCP");
const $3cd32baf65af6083$var$SvgGno = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("g", {
                clipPath: "url(#gno_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        d: "M12 24c6.65 0 12-5.35 12-12S18.65 0 12 0 0 5.35 0 12s5.35 12 12 12Z",
                        fill: "#00A6C4"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("g", {
                        clipPath: "url(#gno_svg__b)",
                        fill: "#fff",
                        children: [
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                                d: "M8.703 13.11c.46 0 .908-.153 1.27-.433L7.059 9.76a2.083 2.083 0 0 0 .374 2.92c.366.276.811.43 1.27.43ZM17.376 11.028c0-.46-.154-.909-.434-1.271l-2.916 2.916a2.078 2.078 0 0 0 3.35-1.645Z"
                            }),
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                                d: "m18.845 7.854-1.29 1.29a2.939 2.939 0 0 1-4.138 4.138L12 14.699l-1.413-1.413a2.94 2.94 0 0 1-4.138-4.139l-.662-.661-.628-.632A8 8 0 0 0 12 20a8 8 0 0 0 8-8 7.981 7.981 0 0 0-1.155-4.146Z"
                            }),
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                                d: "M17.787 6.478a7.996 7.996 0 0 0-12.135.655L12 13.484l6.348-6.351a7.727 7.727 0 0 0-.561-.655ZM12 5.047c1.87 0 3.611.721 4.92 2.037L12 12.004l-4.92-4.92A6.876 6.876 0 0 1 12 5.047Z"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                        id: "gno_svg__a",
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h24v24H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                        id: "gno_svg__b",
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(4 4)",
                            d: "M0 0h16v16H0z"
                        })
                    })
                ]
            })
        ]
    });
var $3cd32baf65af6083$export$2e2bcd8739ae039 = $3cd32baf65af6083$var$SvgGno;



parcelRequire("9nZCP");
const $721def65ff36e9bc$var$SvgMatic = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("g", {
                clipPath: "url(#matic_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        d: "M12 24c6.65 0 12-5.35 12-12S18.65 0 12 0 0 5.35 0 12s5.35 12 12 12Z",
                        fill: "#8A46FF"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        d: "M16.074 9.378a.991.991 0 0 0-1.004 0l-2.303 1.394-1.564.909L8.9 13.075a.991.991 0 0 1-1.003 0l-1.83-1.09a1.05 1.05 0 0 1-.502-.88v-2.15c0-.364.177-.698.501-.88l1.801-1.06a.991.991 0 0 1 1.004 0l1.8 1.06c.296.182.502.516.502.88v1.393l1.565-.94V8.016a.987.987 0 0 0-.502-.879l-3.336-2a.991.991 0 0 0-1.003 0l-3.395 2A.987.987 0 0 0 4 8.015v4.03c0 .363.177.697.502.878l3.395 2a.991.991 0 0 0 1.003 0l2.303-1.363 1.565-.94 2.302-1.363a.991.991 0 0 1 1.004 0l1.8 1.06c.296.182.502.515.502.879v2.151a.987.987 0 0 1-.502.879l-1.8 1.09a.991.991 0 0 1-1.004 0l-1.8-1.06a1.05 1.05 0 0 1-.502-.878v-1.394l-1.565.94v1.393c0 .363.177.697.502.879l3.395 2a.991.991 0 0 0 1.003 0l3.395-2a1.05 1.05 0 0 0 .502-.88v-4.029a.987.987 0 0 0-.502-.879l-3.424-2.03Z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                    id: "matic_svg__a",
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
var $721def65ff36e9bc$export$2e2bcd8739ae039 = $721def65ff36e9bc$var$SvgMatic;



parcelRequire("9nZCP");
const $c0300250bfe0b696$var$SvgOp = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("g", {
                clipPath: "url(#op_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        d: "M12 24c6.65 0 12-5.35 12-12S18.65 0 12 0 0 5.35 0 12s5.35 12 12 12Z",
                        fill: "#FF0420"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M6.746 14.685c.456.336 1.042.504 1.756.504.865 0 1.555-.2 2.072-.603.516-.408.88-1.024 1.09-1.847.126-.504.234-1.023.324-1.558.03-.192.045-.35.045-.477 0-.42-.105-.78-.316-1.08a1.89 1.89 0 0 0-.864-.685 3.143 3.143 0 0 0-1.243-.234c-1.7 0-2.753.825-3.161 2.476a29.88 29.88 0 0 0-.334 1.559c-.03.192-.045.354-.045.486 0 .63.225 1.117.676 1.459Zm2.738-1.09a1.28 1.28 0 0 1-.856.297c-.576 0-.864-.276-.864-.828 0-.132.012-.258.036-.379.108-.582.216-1.074.324-1.477.102-.408.27-.711.504-.91.24-.197.529-.296.865-.296.57 0 .855.273.855.82 0 .131-.012.26-.036.386-.072.42-.177.913-.315 1.477-.102.409-.273.712-.513.91Zm2.81 1.441a.19.19 0 0 0 .153.064h1.225c.06 0 .117-.021.17-.063a.258.258 0 0 0 .1-.163l.414-1.972h1.216c.787 0 1.405-.165 1.855-.495.457-.33.76-.841.91-1.532.036-.162.054-.318.054-.468 0-.522-.204-.922-.612-1.198-.403-.276-.937-.414-1.604-.414H13.78a.275.275 0 0 0-.171.063.258.258 0 0 0-.1.162l-1.242 5.854a.215.215 0 0 0 .027.162Zm3.998-3.584a1.073 1.073 0 0 1-.657.207H14.6l.343-1.612h1.08c.247 0 .42.048.523.144.102.09.153.222.153.396 0 .078-.01.168-.027.27a.972.972 0 0 1-.378.595Z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                    id: "op_svg__a",
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
var $c0300250bfe0b696$export$2e2bcd8739ae039 = $c0300250bfe0b696$var$SvgOp;



parcelRequire("9nZCP");
const $9b4b701f848bac55$var$SvgPnk = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 12,
                fill: "#9013FE"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
                clipPath: "url(#pnk_svg__a)",
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "m8.904 5.438 7.543.337L19.5 12.56l-4.308 6.202-7.583-.486L4.5 10.924l4.404-5.486Zm5.53 3.911-5.466 2.389 4.673 3.614.793-6.003ZM13.8 8.152 9.433 6.271l-.918 3.955L13.8 8.152Zm-1.107 8.11L7.946 12.87l.115 4.595 4.633-1.204Zm6.048-3.716-3.236-3.284-.853 6.314 4.089-3.03ZM13.807 17l-4.004 1.046 4.708.302L13.807 17Zm4.303-2.964-3.505 2.61.696 1.362 2.809-3.972Zm-1.658-7.313L15.77 8.12l2.534 2.576-1.853-3.974Zm-.849-.669-4.449-.18 3.67 1.605.78-1.425ZM8.256 6.7l-3.117 3.936 2.084.442L8.255 6.7Zm-1.159 5.15-2.094-.443 2.185 5.147-.091-4.704Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                    id: "pnk_svg__a",
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(4.5 4.5)",
                        d: "M0 0h15v15H0z"
                    })
                })
            })
        ]
    });
var $9b4b701f848bac55$export$2e2bcd8739ae039 = $9b4b701f848bac55$var$SvgPnk;



parcelRequire("9nZCP");
const $6954b5c7a8ed847c$var$SvgUsdc = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("g", {
                clipPath: "url(#usdc_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        d: "M12 24c6.65 0 12-5.35 12-12S18.65 0 12 0 0 5.35 0 12s5.35 12 12 12Z",
                        fill: "#2775CA"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        d: "M15.3 13.9c0-1.75-1.05-2.35-3.15-2.6-1.5-.2-1.8-.6-1.8-1.3 0-.7.5-1.15 1.5-1.15.9 0 1.4.3 1.65 1.05.05.15.2.25.35.25h.8c.2 0 .35-.15.35-.35v-.05c-.2-1.1-1.1-1.95-2.25-2.05V6.5c0-.2-.15-.35-.4-.4h-.75c-.2 0-.35.15-.4.4v1.15c-1.5.2-2.45 1.2-2.45 2.45 0 1.65 1 2.3 3.1 2.55 1.4.25 1.85.55 1.85 1.35s-.7 1.35-1.65 1.35c-1.3 0-1.75-.55-1.9-1.3-.05-.2-.2-.3-.35-.3h-.85c-.2 0-.35.15-.35.35v.05c.2 1.25 1 2.15 2.65 2.4v1.2c0 .2.15.35.4.4h.75c.2 0 .35-.15.4-.4v-1.2c1.5-.25 2.5-1.3 2.5-2.65Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        d: "M9.45 19.15c-3.9-1.4-5.9-5.75-4.45-9.6.75-2.1 2.4-3.7 4.45-4.45.2-.1.3-.25.3-.5v-.7c0-.2-.1-.35-.3-.4-.05 0-.15 0-.2.05C4.5 5.05 1.9 10.1 3.4 14.85c.9 2.8 3.05 4.95 5.85 5.85.2.1.4 0 .45-.2.05-.05.05-.1.05-.2v-.7c0-.15-.15-.35-.3-.45Zm5.3-15.6c-.2-.1-.4 0-.45.2-.05.05-.05.1-.05.2v.7c0 .2.15.4.3.5 3.9 1.4 5.9 5.75 4.45 9.6-.75 2.1-2.4 3.7-4.45 4.45-.2.1-.3.25-.3.5v.7c0 .2.1.35.3.4.05 0 .15 0 .2-.05 4.75-1.5 7.35-6.55 5.85-11.3-.9-2.85-3.1-5-5.85-5.9Z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                    id: "usdc_svg__a",
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
var $6954b5c7a8ed847c$export$2e2bcd8739ae039 = $6954b5c7a8ed847c$var$SvgUsdc;



parcelRequire("9nZCP");
const $40e5067172433a63$var$SvgUsdt = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("g", {
                clipPath: "url(#usdt_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        d: "M12 24c6.65 0 12-5.35 12-12S18.65 0 12 0 0 5.35 0 12s5.35 12 12 12Z",
                        fill: "#50AF95"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M13.424 12.947c-.08.006-.49.03-1.407.03-.73 0-1.247-.021-1.429-.03-2.818-.124-4.921-.616-4.921-1.205 0-.588 2.103-1.08 4.921-1.205v1.92c.185.013.712.045 1.442.045.875 0 1.313-.037 1.392-.044v-1.92c2.812.126 4.91.617 4.91 1.204 0 .588-2.098 1.08-4.91 1.204h.002Zm0-2.608V8.621h3.925V6H6.664v2.62h3.924v1.719c-3.19.146-5.588.78-5.588 1.538 0 .759 2.398 1.391 5.588 1.539v5.507h2.836v-5.51c3.182-.146 5.576-.778 5.576-1.536s-2.392-1.39-5.576-1.538Z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                    id: "usdt_svg__a",
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
var $40e5067172433a63$export$2e2bcd8739ae039 = $40e5067172433a63$var$SvgUsdt;



parcelRequire("9nZCP");
const $76657c57a3d49344$var$SvgWeth = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("g", {
                clipPath: "url(#weth_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("circle", {
                        cx: 12,
                        cy: 12,
                        r: 12,
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M10.628 3.773a7.462 7.462 0 0 1 4.197.91c.9.651 1.74 1.38 2.51 2.177A7.461 7.461 0 0 0 9.86 5.823a7.456 7.456 0 0 0-2.618 11.954c-.578-.372-1.21-1.071-1.845-2.001A18 18 0 0 1 4.16 13.66a1.223 1.223 0 0 1-.118-.335l-.003-.018a2.25 2.25 0 0 0-.041-.185 7.461 7.461 0 0 1 6.63-9.35Z",
                        fill: "#EC1C79"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M5.28 12.164a7.455 7.455 0 0 1 14.836-.359 7.458 7.458 0 0 1-6.805 8.343l-.007-.009a7.456 7.456 0 0 1-6.118-2.431h-.007a7.457 7.457 0 0 1-1.92-4.993v-.013c.001-.18.008-.36.021-.538Zm5.835-7.5a8.214 8.214 0 0 1 3.92.176l-.103-.076-.104-.076a7.465 7.465 0 0 0-8.2.643 7.462 7.462 0 0 0-2.709 4.321l.998.5a8.21 8.21 0 0 1 6.198-5.489Zm-6.423 6.318-.907-.453a7.46 7.46 0 0 0-.02 1.113l.773.356c.026-.296.068-.591.126-.885l.028-.131Zm-.69 2.145a7.458 7.458 0 0 1-.114-.5l.621.287a8.21 8.21 0 0 0 .263 1.872l-.116-.2-.102-.182a15.265 15.265 0 0 1-.39-.74 1.225 1.225 0 0 1-.118-.334l-.003-.018a2.248 2.248 0 0 0-.04-.185Zm11.241-9.068c.814.567 1.67 1.306 2.57 2.22a8.206 8.206 0 0 1 2.488 9.578 8.211 8.211 0 0 1-7.977 5.058c-.632.062-1.764.085-4.398.085-2.513 0-4.549-.742-4.549-1.657 0-.679 1.122-1.263 2.727-1.518-.441-.426-.883-.973-1.325-1.62a18.617 18.617 0 0 1-1.294-2.216 1.95 1.95 0 0 1-.177-.513l-.004-.021a2.216 2.216 0 0 0-.017-.088l-.012-.048a8.212 8.212 0 0 1 11.937-9.28l.031.02Z",
                        fill: "#000"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        d: "M12.706 20.163a7.456 7.456 0 1 0 0-14.913 7.456 7.456 0 0 0 0 14.913Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "m7.129 14.233-.987-2.973h.864l.515 1.708.57-1.716h.703l.57 1.716.514-1.708h.848l-.987 2.973h-.712l-.595-1.7-.59 1.7h-.713Zm3.922-.02V11.26h2.375v.696H11.86v.447h1.417v.646h-1.417v.468h1.586v.696H11.05Zm3.535 0v-2.236H13.7v-.717h2.59v.717h-.886v2.235h-.818Zm2.062 0V11.26h.819v1.105h1.05V11.26h.818v2.952h-.818v-1.121h-1.05v1.121h-.819Z",
                        fill: "#000"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                    id: "weth_svg__a",
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
var $76657c57a3d49344$export$2e2bcd8739ae039 = $76657c57a3d49344$var$SvgWeth;



parcelRequire("9nZCP");
const $1d893445f58f16d7$var$SvgUnknown = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("circle", {
                className: "unknown_svg__circle",
                cx: 12,
                cy: 12,
                r: 12
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M10.272 16.84h3.191V20h-3.19v-3.16ZM7 10.068a6.077 6.077 0 0 1 .366-2.031c.244-.616.576-1.15.996-1.6.433-.452.948-.8 1.544-1.047.61-.26 1.288-.39 2.033-.39.962 0 1.761.137 2.398.41.65.26 1.172.589 1.565.985.393.397.671.828.834 1.293.176.452.264.876.264 1.272 0 .657-.088 1.197-.264 1.621a3.684 3.684 0 0 1-.63 1.088c-.244.3-.522.56-.834.78-.298.205-.582.417-.853.636a4.054 4.054 0 0 0-.732.718c-.203.274-.332.616-.386 1.026v.78h-2.744v-.924c.04-.588.149-1.08.325-1.477.19-.397.407-.732.65-1.005a4.89 4.89 0 0 1 .773-.74c.27-.204.522-.41.752-.615.23-.205.413-.43.549-.677.149-.246.216-.554.203-.923 0-.63-.156-1.095-.467-1.396-.299-.3-.719-.451-1.26-.451-.367 0-.685.075-.956.226a1.874 1.874 0 0 0-.65.574 2.505 2.505 0 0 0-.366.841 4.093 4.093 0 0 0-.122 1.026H7Z",
                fill: "#fff"
            })
        ]
    });
var $1d893445f58f16d7$export$2e2bcd8739ae039 = $1d893445f58f16d7$var$SvgUnknown;


const $c405cb44f0ae608e$export$c9d6f8c9eaaa447f = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).img`
  width: 24px;
  height: 24px;
`;
const $c405cb44f0ae608e$export$930a33815a2be5ca = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $1d893445f58f16d7$export$2e2bcd8739ae039))`
  width: 24px;
  height: 24px;
  circle {
    fill: ${({ theme: theme })=>theme.stroke};
  }
`;
const $c405cb44f0ae608e$var$tokenIcons = {
    arb: (0, $bb4898f64ecde920$export$2e2bcd8739ae039),
    dai: (0, $3653ef0161ab937d$export$2e2bcd8739ae039),
    gno: (0, $3cd32baf65af6083$export$2e2bcd8739ae039),
    matic: (0, $721def65ff36e9bc$export$2e2bcd8739ae039),
    op: (0, $c0300250bfe0b696$export$2e2bcd8739ae039),
    pnk: (0, $9b4b701f848bac55$export$2e2bcd8739ae039),
    usdc: (0, $6954b5c7a8ed847c$export$2e2bcd8739ae039),
    usdt: (0, $40e5067172433a63$export$2e2bcd8739ae039),
    weth: (0, $76657c57a3d49344$export$2e2bcd8739ae039),
    eth: (0, $af3f5bd2b59709b5$export$2e2bcd8739ae039)
};
const $c405cb44f0ae608e$var$getTokenLogo = (tokenSymbol)=>{
    const symbol = tokenSymbol.toLowerCase();
    return $c405cb44f0ae608e$var$tokenIcons[symbol] || null;
};
const $c405cb44f0ae608e$var$TokenIcon = ({ symbol: symbol, logo: logo })=>{
    const TokenLogoComponent = $c405cb44f0ae608e$var$getTokenLogo(symbol);
    if (TokenLogoComponent) return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(TokenLogoComponent, {
        width: 24,
        height: 24
    });
    else if (logo) return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($c405cb44f0ae608e$export$c9d6f8c9eaaa447f, {
        src: logo,
        alt: `${symbol} logo`
    });
    else return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($c405cb44f0ae608e$export$930a33815a2be5ca, {
        width: 24,
        height: 24
    });
};
var $c405cb44f0ae608e$export$2e2bcd8739ae039 = $c405cb44f0ae608e$var$TokenIcon;


const $5a467e7bf9acddbc$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  border: 1px solid ${({ theme: theme })=>theme.stroke};
  border-radius: 3px;
  width: 186px;
  height: 45px;
  position: relative;
  padding: 9.5px 14px;
  cursor: pointer;
  background: ${({ theme: theme })=>theme.whiteBackground};
  color: ${({ theme: theme })=>theme.primaryText};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const $5a467e7bf9acddbc$var$DropdownArrow = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).span`
  border: solid ${({ theme: theme })=>theme.stroke};
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  margin-left: 8px;
`;
const $5a467e7bf9acddbc$var$DropdownContent = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const $5a467e7bf9acddbc$var$LogoSkeleton = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $7d86fb1e9395869e$export$2e2bcd8739ae039))`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-bottom: 2px;
`;
const $5a467e7bf9acddbc$var$SymbolSkeleton = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $7d86fb1e9395869e$export$2e2bcd8739ae039))`
  width: 40px;
  height: 16px;
`;
const $5a467e7bf9acddbc$export$181f40ec41159e56 = ({ loading: loading, sendingToken: sendingToken, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($5a467e7bf9acddbc$var$Container, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($5a467e7bf9acddbc$var$DropdownContent, {
                children: [
                    loading ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($5a467e7bf9acddbc$var$LogoSkeleton, {}) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $c405cb44f0ae608e$export$2e2bcd8739ae039), {
                        symbol: sendingToken.symbol,
                        logo: sendingToken.logo
                    }),
                    loading ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($5a467e7bf9acddbc$var$SymbolSkeleton, {}) : sendingToken?.symbol
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($5a467e7bf9acddbc$var$DropdownArrow, {})
        ]
    });
};




var $9nZCP = parcelRequire("9nZCP");






parcelRequire("9nZCP");



var $9nZCP = parcelRequire("9nZCP");





const $11ac5ef88ab32edd$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).p`
  color: ${({ theme: theme })=>theme.primaryText};
  margin: 0;
`;
const $11ac5ef88ab32edd$var$StyledAmountSkeleton = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $7d86fb1e9395869e$export$2e2bcd8739ae039))`
  width: 52px;
  height: 20px;
`;
const $11ac5ef88ab32edd$var$Balance = ({ token: token })=>{
    const { address: address } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    const { data: balanceData } = (0, $b9a08c139e2d6879$export$4f026b09e764c1f8)({
        address: address,
        token: token?.address === "native" ? undefined : token?.address
    });
    const formattedBalance = (0, $9nZCP.useMemo)(()=>(0, $ffb69007bd2430e1$export$4356254075e80b7d)(balanceData, token), [
        balanceData,
        token
    ]);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($11ac5ef88ab32edd$var$Container, {
        children: [
            (0, $c62bd748620e6ea9$export$fce6876652108ab)(formattedBalance) ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($11ac5ef88ab32edd$var$StyledAmountSkeleton, {}) : null,
            !(0, $c62bd748620e6ea9$export$fce6876652108ab)(formattedBalance) && formattedBalance !== "0" ? formattedBalance : null
        ]
    });
};
var $11ac5ef88ab32edd$export$2e2bcd8739ae039 = $11ac5ef88ab32edd$var$Balance;



const $ecaf106889d48eea$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  padding: 10px 16px;
  cursor: pointer;
  justify-content: space-between;
  background: ${({ theme: theme, selected: selected })=>selected ? theme.mediumBlue : "transparent"};
  border-left: ${({ theme: theme, selected: selected })=>selected ? `3px solid ${theme.primaryBlue}` : "none"};
  padding-left: ${({ selected: selected })=>selected ? "13px" : "16px"};

  &:hover {
    background: ${({ theme: theme })=>theme.lightBlue};
  }
`;
const $ecaf106889d48eea$var$LogoAndLabel = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
const $ecaf106889d48eea$var$TokenLabel = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).span`
  color: ${({ theme: theme })=>theme.primaryText};
`;
const $ecaf106889d48eea$var$TokenItem = ({ token: token, selected: selected, onSelect: onSelect })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($ecaf106889d48eea$var$Container, {
        selected: selected,
        onClick: ()=>onSelect(token),
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($ecaf106889d48eea$var$LogoAndLabel, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $c405cb44f0ae608e$export$2e2bcd8739ae039), {
                        symbol: token.symbol,
                        logo: token.logo
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($ecaf106889d48eea$var$TokenLabel, {
                        children: token.symbol
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $11ac5ef88ab32edd$export$2e2bcd8739ae039), {
                token: token
            })
        ]
    });
};
var $ecaf106889d48eea$export$2e2bcd8739ae039 = $ecaf106889d48eea$var$TokenItem;




var $9nZCP = parcelRequire("9nZCP");

var $9nZCP = parcelRequire("9nZCP");

var $l06UM = parcelRequire("l06UM");


const $8aab0ec431048b51$export$9d829cdfbbd34b71 = (tokenAddress)=>{
    const { chain: chain } = (0, $b9a08c139e2d6879$export$553aaf59afc1a2d8)();
    const [tokenMetadata, setTokenMetadata] = (0, $9nZCP.useState)(null);
    (0, $9nZCP.useEffect)(()=>{
        const fetchTokenMetadata = async ()=>{
            if (!tokenAddress || tokenAddress === "native") return;
            const alchemy = new (0, $l06UM.m)((0, $209ce342cf15c0ab$export$3eae92904abeaa77)(chain?.id));
            try {
                const metadata = await alchemy.core.getTokenMetadata(tokenAddress);
                setTokenMetadata(metadata);
            } catch (error) {
                console.error("Error fetching token metadata:", error);
                setTokenMetadata(null);
            }
        };
        fetchTokenMetadata();
    }, [
        tokenAddress,
        chain?.id
    ]);
    return {
        tokenMetadata: tokenMetadata
    };
};


const $5c04967213eff111$export$9961a6e3396e9734 = (searchQuery, tokens, setTokens, sendingToken)=>{
    const { tokenMetadata: tokenMetadata } = (0, $8aab0ec431048b51$export$9d829cdfbbd34b71)(searchQuery.startsWith("0x") && searchQuery.length === 42 ? searchQuery : null);
    const [filteredTokens, setFilteredTokens] = (0, $9nZCP.useState)([]);
    (0, $9nZCP.useEffect)(()=>{
        const handleSearch = async ()=>{
            let filtered = [];
            if (!searchQuery) {
                filtered = tokens;
                if (sendingToken) filtered = [
                    sendingToken,
                    ...tokens.filter((token)=>token.address !== sendingToken.address)
                ];
            } else if (tokenMetadata) {
                const resultToken = {
                    symbol: tokenMetadata.symbol,
                    address: searchQuery.toLowerCase(),
                    logo: tokenMetadata.logo
                };
                const updatedTokens = [
                    ...tokens,
                    resultToken
                ];
                const uniqueTokens = Array.from(new Set(updatedTokens.map((a)=>a.address))).map((address)=>{
                    return updatedTokens.find((a)=>a.address === address);
                });
                filtered = [
                    resultToken
                ];
                setTokens(uniqueTokens);
                localStorage.setItem("tokens", JSON.stringify(uniqueTokens));
            } else filtered = tokens.filter((token)=>token.symbol.toLowerCase().includes(searchQuery.toLowerCase()));
            setFilteredTokens(filtered);
        };
        handleSearch();
    }, [
        searchQuery,
        tokens,
        setTokens,
        sendingToken,
        tokenMetadata
    ]);
    return {
        filteredTokens: filteredTokens
    };
};




const $fc805674885e9164$var$ReStyledModal = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $199d04a141957ef1$export$8863cf9d79cd26ad))`
  display: flex;
  width: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(320, 500)};
  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      width: 500px;
    `)}
`;
const $fc805674885e9164$var$StyledSearchbar = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Searchbar))`
  width: 100%;
  input {
    font-size: 16px;
  }
`;
const $fc805674885e9164$var$ItemsContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-top: 24px;
`;
const $fc805674885e9164$var$StyledP = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).p`
  display: flex;
  align-self: flex-start;
  font-weight: 600;
  margin: 0;
  margin-bottom: 28px;
`;
const $fc805674885e9164$export$5bdc71d40a58dd44 = ({ setIsOpen: setIsOpen, tokens: tokens, setTokens: setTokens, handleSelectToken: handleSelectToken })=>{
    const [searchQuery, setSearchQuery] = (0, $9nZCP.useState)("");
    const { sendingToken: sendingToken } = (0, $fa4dc73a0abb4258$export$ab0988b836f3e0ac)();
    const { filteredTokens: filteredTokens } = (0, $5c04967213eff111$export$9961a6e3396e9734)(searchQuery, tokens, setTokens, sendingToken);
    const containerRef = (0, $9nZCP.useRef)(null);
    (0, $0aa9c5ea5f98ac89$export$2e2bcd8739ae039)(containerRef, ()=>setIsOpen(false));
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $a4e24e3c9f4f276a$export$c6fdb837b070b4ff), {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($fc805674885e9164$var$ReStyledModal, {
                ref: containerRef,
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($fc805674885e9164$var$StyledP, {
                        children: "Select a token"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($fc805674885e9164$var$StyledSearchbar, {
                        placeholder: "Search by name or paste address",
                        value: searchQuery,
                        onChange: (e)=>setSearchQuery(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($fc805674885e9164$var$ItemsContainer, {
                        children: filteredTokens.map((token)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $ecaf106889d48eea$export$2e2bcd8739ae039), {
                                selected: sendingToken?.address === token.address,
                                onSelect: handleSelectToken,
                                token: token
                            }, token.address))
                    })
                ]
            })
        ]
    });
};


const $a979dd424bf9de57$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
`;
const $a979dd424bf9de57$var$TokenSelector = ()=>{
    const { address: address } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    const { chain: chain } = (0, $b9a08c139e2d6879$export$553aaf59afc1a2d8)();
    const { sendingToken: sendingToken, setSendingToken: setSendingToken } = (0, $fa4dc73a0abb4258$export$ab0988b836f3e0ac)();
    const [tokens, setTokens] = (0, $02bde888b770a5cd$export$86e2cef2561044ac)("tokens", []);
    const [isOpen, setIsOpen] = (0, $9nZCP.useState)(false);
    const containerRef = (0, $9nZCP.useRef)(null);
    const [loading, setLoading] = (0, $9nZCP.useState)(true);
    const alchemyInstance = (0, $9nZCP.useMemo)(()=>new (0, $l06UM.m)((0, $209ce342cf15c0ab$export$3eae92904abeaa77)(chain?.id)), [
        chain?.id
    ]);
    (0, $0aa9c5ea5f98ac89$export$2e2bcd8739ae039)(containerRef, ()=>setIsOpen(false));
    (0, $9nZCP.useEffect)(()=>{
        if (address && chain) {
            localStorage.removeItem("tokens");
            (0, $780ca05c679b9e1b$export$f4fdbbc956f2c626)(address, setTokens, setLoading, chain, alchemyInstance);
        }
    }, [
        address,
        chain,
        alchemyInstance
    ]);
    (0, $9nZCP.useEffect)(()=>{
        if (tokens?.length > 0) {
            const nativeToken = tokens.find((token)=>token.address === "native");
            setSendingToken(JSON.parse(localStorage.getItem("selectedToken")) || nativeToken);
        }
    }, [
        tokens,
        setSendingToken
    ]);
    const handleSelectToken = (token)=>{
        setSendingToken(token);
        localStorage.setItem("selectedToken", JSON.stringify(token));
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($a979dd424bf9de57$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $5a467e7bf9acddbc$export$181f40ec41159e56), {
                loading: loading,
                sendingToken: sendingToken,
                onClick: ()=>setIsOpen(!isOpen)
            }),
            isOpen && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $fc805674885e9164$export$5bdc71d40a58dd44), {
                setIsOpen: setIsOpen,
                tokens: tokens,
                setTokens: setTokens,
                handleSelectToken: handleSelectToken
            })
        ]
    });
};
var $a979dd424bf9de57$export$2e2bcd8739ae039 = $a979dd424bf9de57$var$TokenSelector;



parcelRequire("9nZCP");




const $adc85ebc0b012060$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  align-self: center;
  gap: 4px;

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      align-self: flex-end;
    `)}
`;
const $adc85ebc0b012060$var$LabelAndBalance = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;
const $adc85ebc0b012060$var$Label = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).p`
  margin: 0;
  color: ${({ theme: theme })=>theme.secondaryText};
  font-size: 12px;
`;
const $adc85ebc0b012060$var$Balance = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 12px;
`;
const $adc85ebc0b012060$var$BalanceSkeleton = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $7d86fb1e9395869e$export$2e2bcd8739ae039))`
  width: 63px;
  height: 16px;
`;
const $adc85ebc0b012060$var$MaxButton = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).p`
  margin: 0;
  color: ${({ theme: theme })=>theme.primaryBlue};
  font-size: 12px;
  cursor: pointer;
`;
const $adc85ebc0b012060$var$MaxBalance = ({ formattedBalance: formattedBalance, rawBalance: rawBalance, setQuantity: setQuantity })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($adc85ebc0b012060$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($adc85ebc0b012060$var$LabelAndBalance, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($adc85ebc0b012060$var$Label, {
                        children: "Balance:"
                    }),
                    (0, $c62bd748620e6ea9$export$fce6876652108ab)(formattedBalance) ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($adc85ebc0b012060$var$BalanceSkeleton, {}) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($adc85ebc0b012060$var$Balance, {
                        children: formattedBalance
                    })
                ]
            }),
            !(0, $c62bd748620e6ea9$export$fce6876652108ab)(formattedBalance) ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($adc85ebc0b012060$var$MaxButton, {
                onClick: ()=>setQuantity(String(rawBalance)),
                children: "Max"
            }) : null
        ]
    });
};
var $adc85ebc0b012060$export$2e2bcd8739ae039 = $adc85ebc0b012060$var$MaxBalance;


const $5ab96c56d86938a7$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 24px;
  margin-bottom: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(16, 0)};
  flex-wrap: wrap;
`;
const $5ab96c56d86938a7$var$TokenSelectorAndMaxBalance = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const $5ab96c56d86938a7$var$TokenAndAmount = ({ quantity: quantity, setQuantity: setQuantity })=>{
    const { address: address } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    const { sendingToken: sendingToken, setHasSufficientNativeBalance: setHasSufficientNativeBalance } = (0, $fa4dc73a0abb4258$export$ab0988b836f3e0ac)();
    const { data: balanceData } = (0, $b9a08c139e2d6879$export$4f026b09e764c1f8)({
        address: address,
        token: sendingToken?.address === "native" ? undefined : sendingToken?.address
    });
    const [error, setError] = (0, $9nZCP.useState)("");
    (0, $9nZCP.useEffect)(()=>{
        const balanceAmount = balanceData ? parseFloat(balanceData.formatted) : 0;
        const enteredAmount = parseFloat(quantity);
        if (quantity && balanceAmount < enteredAmount) {
            setError("Insufficient balance");
            setHasSufficientNativeBalance(false);
        } else if (enteredAmount === 0) {
            setError("Amount is zero");
            setHasSufficientNativeBalance(false);
        } else {
            setError("");
            setHasSufficientNativeBalance(true);
        }
    }, [
        balanceData,
        quantity,
        setHasSufficientNativeBalance
    ]);
    const formattedBalance = (0, $9nZCP.useMemo)(()=>(0, $ffb69007bd2430e1$export$4356254075e80b7d)(balanceData, sendingToken), [
        balanceData,
        sendingToken
    ]);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($5ab96c56d86938a7$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $b1f0ceca2c27d6ce$export$2e2bcd8739ae039), {
                quantity: quantity,
                setQuantity: setQuantity,
                error: error
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($5ab96c56d86938a7$var$TokenSelectorAndMaxBalance, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $a979dd424bf9de57$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $adc85ebc0b012060$export$2e2bcd8739ae039), {
                        formattedBalance: formattedBalance,
                        rawBalance: parseFloat(balanceData?.formatted),
                        setQuantity: setQuantity
                    })
                ]
            })
        ]
    });
};
var $5ab96c56d86938a7$export$2e2bcd8739ae039 = $5ab96c56d86938a7$var$TokenAndAmount;



const $e9860dc6054e0e9e$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const $e9860dc6054e0e9e$var$GeneralTransaction = ()=>{
    const { sendingQuantity: sendingQuantity, setSendingQuantity: setSendingQuantity, sellerAddress: sellerAddress, setSellerAddress: setSellerAddress } = (0, $fa4dc73a0abb4258$export$ab0988b836f3e0ac)();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($e9860dc6054e0e9e$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e5652d9f4b8c73d1$export$2e2bcd8739ae039), {
                text: "I am paying"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $5ab96c56d86938a7$export$2e2bcd8739ae039), {
                quantity: sendingQuantity,
                setQuantity: setSendingQuantity
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $5ae3f15a3c885771$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $837bbe77b3d6c5a7$export$2e2bcd8739ae039), {
                recipientAddress: sellerAddress,
                setRecipientAddress: setSellerAddress
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $fab3b51b2e28c7da$export$2e2bcd8739ae039), {
                prevRoute: "/new-transaction/deliverable",
                nextRoute: "/new-transaction/deadline"
            })
        ]
    });
};
var $e9860dc6054e0e9e$export$2e2bcd8739ae039 = $e9860dc6054e0e9e$var$GeneralTransaction;


const $cd9a14b676c1854f$var$Payment = ()=>{
    const { escrowType: escrowType, sendingQuantity: sendingQuantity, setSendingQuantity: setSendingQuantity, sendingToken: sendingToken, setSendingToken: setSendingToken, sellerAddress: sellerAddress, setSellerAddress: setSellerAddress } = (0, $fa4dc73a0abb4258$export$ab0988b836f3e0ac)();
    return escrowType === "general" ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e9860dc6054e0e9e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $776a355fdaf8acf0$export$2e2bcd8739ae039), {
        headerText: "I am paying",
        prevRoute: "/new-transaction/deliverable",
        nextRoute: "/new-transaction/deadline",
        quantity: sendingQuantity,
        setQuantity: setSendingQuantity,
        token: sendingToken,
        setToken: setSendingToken,
        recipientAddress: sellerAddress,
        setRecipientAddress: setSellerAddress
    });
};
var $cd9a14b676c1854f$export$2e2bcd8739ae039 = $cd9a14b676c1854f$var$Payment;



parcelRequire("9nZCP");




const $5e742a98f45308c5$var$StyledSteps = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Steps))`
  display: none;

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      display: flex;
      position: absolute;
      left: 4%;
      height: 200px;
    `)}
`;
const $5e742a98f45308c5$var$items = [
    {
        title: "Escrow Details",
        subitems: [
            "Type of Escrow",
            "Title"
        ]
    },
    {
        title: "Terms",
        subitems: [
            "Deliverable",
            "Payment",
            "Deadline"
        ]
    },
    {
        title: "Preview"
    }
];
const $5e742a98f45308c5$var$Timeline = ()=>{
    const location = (0, $cb6812e0fa529c57$export$45d76561a5302f2b)();
    const routeToIndexMap = {
        "/new-transaction/escrow-type": 0,
        "/new-transaction/title": 0,
        "/new-transaction/deliverable": 1,
        "/new-transaction/payment": 1,
        "/new-transaction/deadline": 1,
        "/new-transaction/notifications": 1,
        "/new-transaction/preview": 2
    };
    const currentItemIndex = Object.entries(routeToIndexMap).reduce((acc, [route, index])=>location.pathname.includes(route) ? index : acc, 0);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($5e742a98f45308c5$var$StyledSteps, {
        items: $5e742a98f45308c5$var$items,
        currentItemIndex: currentItemIndex
    });
};
var $5e742a98f45308c5$export$2e2bcd8739ae039 = $5e742a98f45308c5$var$Timeline;






parcelRequire("9nZCP");







var $9nZCP = parcelRequire("9nZCP");




const $9e2a1c796186274a$export$393e2cd582c6728a = (filter)=>{
    if (Object.keys(filter).length === 0) return "all";
    else return encodeURI(JSON.stringify(filter));
};
const $9e2a1c796186274a$export$839ea60635874ac1 = (filter)=>{
    if (filter === "all") return {};
    else return JSON.parse(decodeURI(filter));
};
const $9e2a1c796186274a$export$e6340d5ca6801d59 = ()=>{
    const location = (0, $cb6812e0fa529c57$export$45d76561a5302f2b)();
    return location.pathname.split("/").slice(0, -3).join("/");
};



function $96ba590d778dec6e$export$130bc0efb3cce789(_documentNode, fragmentType) {
    return fragmentType;
}
function $96ba590d778dec6e$export$4659cb8f146075(data, _fragment) {
    return data;
}
function $96ba590d778dec6e$export$dbf91005d32bdf6a(queryNode, fragmentNode, data) {
    const deferredFields = queryNode.__meta__?.deferredFields;
    if (!deferredFields) return true;
    const fragDef = fragmentNode.definitions[0];
    const fragName = fragDef?.name?.value;
    const fields = fragName && deferredFields[fragName] || [];
    return fields.length > 0 && fields.every((field)=>data && field in data);
}


/* eslint-disable */ /* eslint-disable */ var $e26656e7cb881106$export$72a9f2d0d5047c2c;
(function(Aggregation_Interval) {
    Aggregation_Interval["Day"] = "day";
    Aggregation_Interval["Hour"] = "hour";
})($e26656e7cb881106$export$72a9f2d0d5047c2c || ($e26656e7cb881106$export$72a9f2d0d5047c2c = {}));
var $e26656e7cb881106$export$590abdc92b8dd409;
(function(DisputeRequest_OrderBy) {
    DisputeRequest_OrderBy["Escrow"] = "escrow";
    DisputeRequest_OrderBy["EscrowAmount"] = "escrow__amount";
    DisputeRequest_OrderBy["EscrowArbitratorExtraData"] = "escrow__arbitratorExtraData";
    DisputeRequest_OrderBy["EscrowBuyer"] = "escrow__buyer";
    DisputeRequest_OrderBy["EscrowBuyerFee"] = "escrow__buyerFee";
    DisputeRequest_OrderBy["EscrowDeadline"] = "escrow__deadline";
    DisputeRequest_OrderBy["EscrowFeeTimeout"] = "escrow__feeTimeout";
    DisputeRequest_OrderBy["EscrowId"] = "escrow__id";
    DisputeRequest_OrderBy["EscrowLastFeePaymentTime"] = "escrow__lastFeePaymentTime";
    DisputeRequest_OrderBy["EscrowSeller"] = "escrow__seller";
    DisputeRequest_OrderBy["EscrowSellerFee"] = "escrow__sellerFee";
    DisputeRequest_OrderBy["EscrowSettlementTimeout"] = "escrow__settlementTimeout";
    DisputeRequest_OrderBy["EscrowStatus"] = "escrow__status";
    DisputeRequest_OrderBy["EscrowTemplateData"] = "escrow__templateData";
    DisputeRequest_OrderBy["EscrowTemplateDataMappings"] = "escrow__templateDataMappings";
    DisputeRequest_OrderBy["EscrowTimestamp"] = "escrow__timestamp";
    DisputeRequest_OrderBy["EscrowToken"] = "escrow__token";
    DisputeRequest_OrderBy["EscrowTransactionUri"] = "escrow__transactionUri";
    DisputeRequest_OrderBy["From"] = "from";
    DisputeRequest_OrderBy["Id"] = "id";
    DisputeRequest_OrderBy["Timestamp"] = "timestamp";
})($e26656e7cb881106$export$590abdc92b8dd409 || ($e26656e7cb881106$export$590abdc92b8dd409 = {}));
var $e26656e7cb881106$export$45a0150c75078208;
(function(EscrowParameters_OrderBy) {
    EscrowParameters_OrderBy["ArbitratorExtraData"] = "arbitratorExtraData";
    EscrowParameters_OrderBy["FeeTimeout"] = "feeTimeout";
    EscrowParameters_OrderBy["Id"] = "id";
    EscrowParameters_OrderBy["SettlementTimeout"] = "settlementTimeout";
})($e26656e7cb881106$export$45a0150c75078208 || ($e26656e7cb881106$export$45a0150c75078208 = {}));
var $e26656e7cb881106$export$95d7f5ac844b4275;
(function(Escrow_OrderBy) {
    Escrow_OrderBy["Amount"] = "amount";
    Escrow_OrderBy["ArbitratorExtraData"] = "arbitratorExtraData";
    Escrow_OrderBy["Buyer"] = "buyer";
    Escrow_OrderBy["BuyerFee"] = "buyerFee";
    Escrow_OrderBy["CreatedEvents"] = "createdEvents";
    Escrow_OrderBy["Deadline"] = "deadline";
    Escrow_OrderBy["DisputeRequest"] = "disputeRequest";
    Escrow_OrderBy["DisputeRequestFrom"] = "disputeRequest__from";
    Escrow_OrderBy["DisputeRequestId"] = "disputeRequest__id";
    Escrow_OrderBy["DisputeRequestTimestamp"] = "disputeRequest__timestamp";
    Escrow_OrderBy["FeeTimeout"] = "feeTimeout";
    Escrow_OrderBy["HasToPayFees"] = "hasToPayFees";
    Escrow_OrderBy["Id"] = "id";
    Escrow_OrderBy["LastFeePaymentTime"] = "lastFeePaymentTime";
    Escrow_OrderBy["Payments"] = "payments";
    Escrow_OrderBy["ResolvedEvents"] = "resolvedEvents";
    Escrow_OrderBy["Seller"] = "seller";
    Escrow_OrderBy["SellerFee"] = "sellerFee";
    Escrow_OrderBy["SettlementProposals"] = "settlementProposals";
    Escrow_OrderBy["SettlementTimeout"] = "settlementTimeout";
    Escrow_OrderBy["Status"] = "status";
    Escrow_OrderBy["TemplateData"] = "templateData";
    Escrow_OrderBy["TemplateDataMappings"] = "templateDataMappings";
    Escrow_OrderBy["Timestamp"] = "timestamp";
    Escrow_OrderBy["Token"] = "token";
    Escrow_OrderBy["TransactionUri"] = "transactionUri";
    Escrow_OrderBy["Users"] = "users";
})($e26656e7cb881106$export$95d7f5ac844b4275 || ($e26656e7cb881106$export$95d7f5ac844b4275 = {}));
var $e26656e7cb881106$export$b8e618363a0609f6;
(function(HasToPayFee_OrderBy) {
    HasToPayFee_OrderBy["Escrow"] = "escrow";
    HasToPayFee_OrderBy["EscrowAmount"] = "escrow__amount";
    HasToPayFee_OrderBy["EscrowArbitratorExtraData"] = "escrow__arbitratorExtraData";
    HasToPayFee_OrderBy["EscrowBuyer"] = "escrow__buyer";
    HasToPayFee_OrderBy["EscrowBuyerFee"] = "escrow__buyerFee";
    HasToPayFee_OrderBy["EscrowDeadline"] = "escrow__deadline";
    HasToPayFee_OrderBy["EscrowFeeTimeout"] = "escrow__feeTimeout";
    HasToPayFee_OrderBy["EscrowId"] = "escrow__id";
    HasToPayFee_OrderBy["EscrowLastFeePaymentTime"] = "escrow__lastFeePaymentTime";
    HasToPayFee_OrderBy["EscrowSeller"] = "escrow__seller";
    HasToPayFee_OrderBy["EscrowSellerFee"] = "escrow__sellerFee";
    HasToPayFee_OrderBy["EscrowSettlementTimeout"] = "escrow__settlementTimeout";
    HasToPayFee_OrderBy["EscrowStatus"] = "escrow__status";
    HasToPayFee_OrderBy["EscrowTemplateData"] = "escrow__templateData";
    HasToPayFee_OrderBy["EscrowTemplateDataMappings"] = "escrow__templateDataMappings";
    HasToPayFee_OrderBy["EscrowTimestamp"] = "escrow__timestamp";
    HasToPayFee_OrderBy["EscrowToken"] = "escrow__token";
    HasToPayFee_OrderBy["EscrowTransactionUri"] = "escrow__transactionUri";
    HasToPayFee_OrderBy["Id"] = "id";
    HasToPayFee_OrderBy["Party"] = "party";
    HasToPayFee_OrderBy["Timestamp"] = "timestamp";
})($e26656e7cb881106$export$b8e618363a0609f6 || ($e26656e7cb881106$export$b8e618363a0609f6 = {}));
var $e26656e7cb881106$export$6576b9de878968d6;
(function(OrderDirection) {
    OrderDirection["Asc"] = "asc";
    OrderDirection["Desc"] = "desc";
})($e26656e7cb881106$export$6576b9de878968d6 || ($e26656e7cb881106$export$6576b9de878968d6 = {}));
var $e26656e7cb881106$export$64c9b9257cd1cc44;
(function(Party) {
    Party["Buyer"] = "Buyer";
    Party["None"] = "None";
    Party["Seller"] = "Seller";
})($e26656e7cb881106$export$64c9b9257cd1cc44 || ($e26656e7cb881106$export$64c9b9257cd1cc44 = {}));
var $e26656e7cb881106$export$a358171da5687ab8;
(function(Payment_OrderBy) {
    Payment_OrderBy["Amount"] = "amount";
    Payment_OrderBy["Escrow"] = "escrow";
    Payment_OrderBy["EscrowAmount"] = "escrow__amount";
    Payment_OrderBy["EscrowArbitratorExtraData"] = "escrow__arbitratorExtraData";
    Payment_OrderBy["EscrowBuyer"] = "escrow__buyer";
    Payment_OrderBy["EscrowBuyerFee"] = "escrow__buyerFee";
    Payment_OrderBy["EscrowDeadline"] = "escrow__deadline";
    Payment_OrderBy["EscrowFeeTimeout"] = "escrow__feeTimeout";
    Payment_OrderBy["EscrowId"] = "escrow__id";
    Payment_OrderBy["EscrowLastFeePaymentTime"] = "escrow__lastFeePaymentTime";
    Payment_OrderBy["EscrowSeller"] = "escrow__seller";
    Payment_OrderBy["EscrowSellerFee"] = "escrow__sellerFee";
    Payment_OrderBy["EscrowSettlementTimeout"] = "escrow__settlementTimeout";
    Payment_OrderBy["EscrowStatus"] = "escrow__status";
    Payment_OrderBy["EscrowTemplateData"] = "escrow__templateData";
    Payment_OrderBy["EscrowTemplateDataMappings"] = "escrow__templateDataMappings";
    Payment_OrderBy["EscrowTimestamp"] = "escrow__timestamp";
    Payment_OrderBy["EscrowToken"] = "escrow__token";
    Payment_OrderBy["EscrowTransactionUri"] = "escrow__transactionUri";
    Payment_OrderBy["Id"] = "id";
    Payment_OrderBy["Party"] = "party";
    Payment_OrderBy["Timestamp"] = "timestamp";
})($e26656e7cb881106$export$a358171da5687ab8 || ($e26656e7cb881106$export$a358171da5687ab8 = {}));
var $e26656e7cb881106$export$3e4ff2216a90b8a4;
(function(Resolution) {
    Resolution["RulingEnforced"] = "RulingEnforced";
    Resolution["SettlementReached"] = "SettlementReached";
    Resolution["TimeoutByBuyer"] = "TimeoutByBuyer";
    Resolution["TimeoutBySeller"] = "TimeoutBySeller";
    Resolution["TransactionExecuted"] = "TransactionExecuted";
})($e26656e7cb881106$export$3e4ff2216a90b8a4 || ($e26656e7cb881106$export$3e4ff2216a90b8a4 = {}));
var $e26656e7cb881106$export$ce9d1ff7c530c1c6;
(function(SettlementProposal_OrderBy) {
    SettlementProposal_OrderBy["Amount"] = "amount";
    SettlementProposal_OrderBy["Escrow"] = "escrow";
    SettlementProposal_OrderBy["EscrowAmount"] = "escrow__amount";
    SettlementProposal_OrderBy["EscrowArbitratorExtraData"] = "escrow__arbitratorExtraData";
    SettlementProposal_OrderBy["EscrowBuyer"] = "escrow__buyer";
    SettlementProposal_OrderBy["EscrowBuyerFee"] = "escrow__buyerFee";
    SettlementProposal_OrderBy["EscrowDeadline"] = "escrow__deadline";
    SettlementProposal_OrderBy["EscrowFeeTimeout"] = "escrow__feeTimeout";
    SettlementProposal_OrderBy["EscrowId"] = "escrow__id";
    SettlementProposal_OrderBy["EscrowLastFeePaymentTime"] = "escrow__lastFeePaymentTime";
    SettlementProposal_OrderBy["EscrowSeller"] = "escrow__seller";
    SettlementProposal_OrderBy["EscrowSellerFee"] = "escrow__sellerFee";
    SettlementProposal_OrderBy["EscrowSettlementTimeout"] = "escrow__settlementTimeout";
    SettlementProposal_OrderBy["EscrowStatus"] = "escrow__status";
    SettlementProposal_OrderBy["EscrowTemplateData"] = "escrow__templateData";
    SettlementProposal_OrderBy["EscrowTemplateDataMappings"] = "escrow__templateDataMappings";
    SettlementProposal_OrderBy["EscrowTimestamp"] = "escrow__timestamp";
    SettlementProposal_OrderBy["EscrowToken"] = "escrow__token";
    SettlementProposal_OrderBy["EscrowTransactionUri"] = "escrow__transactionUri";
    SettlementProposal_OrderBy["Id"] = "id";
    SettlementProposal_OrderBy["Party"] = "party";
    SettlementProposal_OrderBy["Timestamp"] = "timestamp";
})($e26656e7cb881106$export$ce9d1ff7c530c1c6 || ($e26656e7cb881106$export$ce9d1ff7c530c1c6 = {}));
var $e26656e7cb881106$export$96e9906d6d93a972;
(function(Status) {
    Status["DisputeCreated"] = "DisputeCreated";
    Status["NoDispute"] = "NoDispute";
    Status["TransactionResolved"] = "TransactionResolved";
    Status["WaitingBuyer"] = "WaitingBuyer";
    Status["WaitingSeller"] = "WaitingSeller";
    Status["WaitingSettlementBuyer"] = "WaitingSettlementBuyer";
    Status["WaitingSettlementSeller"] = "WaitingSettlementSeller";
})($e26656e7cb881106$export$96e9906d6d93a972 || ($e26656e7cb881106$export$96e9906d6d93a972 = {}));
var $e26656e7cb881106$export$4ec08a0b4a0281f3;
(function(TransactionCreated_OrderBy) {
    TransactionCreated_OrderBy["Escrow"] = "escrow";
    TransactionCreated_OrderBy["EscrowAmount"] = "escrow__amount";
    TransactionCreated_OrderBy["EscrowArbitratorExtraData"] = "escrow__arbitratorExtraData";
    TransactionCreated_OrderBy["EscrowBuyer"] = "escrow__buyer";
    TransactionCreated_OrderBy["EscrowBuyerFee"] = "escrow__buyerFee";
    TransactionCreated_OrderBy["EscrowDeadline"] = "escrow__deadline";
    TransactionCreated_OrderBy["EscrowFeeTimeout"] = "escrow__feeTimeout";
    TransactionCreated_OrderBy["EscrowId"] = "escrow__id";
    TransactionCreated_OrderBy["EscrowLastFeePaymentTime"] = "escrow__lastFeePaymentTime";
    TransactionCreated_OrderBy["EscrowSeller"] = "escrow__seller";
    TransactionCreated_OrderBy["EscrowSellerFee"] = "escrow__sellerFee";
    TransactionCreated_OrderBy["EscrowSettlementTimeout"] = "escrow__settlementTimeout";
    TransactionCreated_OrderBy["EscrowStatus"] = "escrow__status";
    TransactionCreated_OrderBy["EscrowTemplateData"] = "escrow__templateData";
    TransactionCreated_OrderBy["EscrowTemplateDataMappings"] = "escrow__templateDataMappings";
    TransactionCreated_OrderBy["EscrowTimestamp"] = "escrow__timestamp";
    TransactionCreated_OrderBy["EscrowToken"] = "escrow__token";
    TransactionCreated_OrderBy["EscrowTransactionUri"] = "escrow__transactionUri";
    TransactionCreated_OrderBy["Id"] = "id";
})($e26656e7cb881106$export$4ec08a0b4a0281f3 || ($e26656e7cb881106$export$4ec08a0b4a0281f3 = {}));
var $e26656e7cb881106$export$8617d7111246c4c9;
(function(TransactionResolved_OrderBy) {
    TransactionResolved_OrderBy["Escrow"] = "escrow";
    TransactionResolved_OrderBy["EscrowAmount"] = "escrow__amount";
    TransactionResolved_OrderBy["EscrowArbitratorExtraData"] = "escrow__arbitratorExtraData";
    TransactionResolved_OrderBy["EscrowBuyer"] = "escrow__buyer";
    TransactionResolved_OrderBy["EscrowBuyerFee"] = "escrow__buyerFee";
    TransactionResolved_OrderBy["EscrowDeadline"] = "escrow__deadline";
    TransactionResolved_OrderBy["EscrowFeeTimeout"] = "escrow__feeTimeout";
    TransactionResolved_OrderBy["EscrowId"] = "escrow__id";
    TransactionResolved_OrderBy["EscrowLastFeePaymentTime"] = "escrow__lastFeePaymentTime";
    TransactionResolved_OrderBy["EscrowSeller"] = "escrow__seller";
    TransactionResolved_OrderBy["EscrowSellerFee"] = "escrow__sellerFee";
    TransactionResolved_OrderBy["EscrowSettlementTimeout"] = "escrow__settlementTimeout";
    TransactionResolved_OrderBy["EscrowStatus"] = "escrow__status";
    TransactionResolved_OrderBy["EscrowTemplateData"] = "escrow__templateData";
    TransactionResolved_OrderBy["EscrowTemplateDataMappings"] = "escrow__templateDataMappings";
    TransactionResolved_OrderBy["EscrowTimestamp"] = "escrow__timestamp";
    TransactionResolved_OrderBy["EscrowToken"] = "escrow__token";
    TransactionResolved_OrderBy["EscrowTransactionUri"] = "escrow__transactionUri";
    TransactionResolved_OrderBy["Id"] = "id";
    TransactionResolved_OrderBy["Resolution"] = "resolution";
    TransactionResolved_OrderBy["Timestamp"] = "timestamp";
})($e26656e7cb881106$export$8617d7111246c4c9 || ($e26656e7cb881106$export$8617d7111246c4c9 = {}));
var $e26656e7cb881106$export$8ad01fc113ebd6d0;
(function(User_OrderBy) {
    User_OrderBy["Escrows"] = "escrows";
    User_OrderBy["Id"] = "id";
    User_OrderBy["TotalDisputedEscrows"] = "totalDisputedEscrows";
    User_OrderBy["TotalEscrows"] = "totalEscrows";
    User_OrderBy["TotalNoDisputedEscrows"] = "totalNoDisputedEscrows";
    User_OrderBy["TotalResolvedEscrows"] = "totalResolvedEscrows";
    User_OrderBy["TotalWaitingBuyerEscrows"] = "totalWaitingBuyerEscrows";
    User_OrderBy["TotalWaitingSellerEscrows"] = "totalWaitingSellerEscrows";
})($e26656e7cb881106$export$8ad01fc113ebd6d0 || ($e26656e7cb881106$export$8ad01fc113ebd6d0 = {}));
var $e26656e7cb881106$export$ac48b316845cbda1;
(function(_SubgraphErrorPolicy_) {
    /** Data will be returned even if the subgraph has indexing errors */ _SubgraphErrorPolicy_["Allow"] = "allow";
    /** If the subgraph has indexing errors, data will be omitted. The default. */ _SubgraphErrorPolicy_["Deny"] = "deny";
})($e26656e7cb881106$export$ac48b316845cbda1 || ($e26656e7cb881106$export$ac48b316845cbda1 = {}));
const $e26656e7cb881106$export$5b123591c7340442 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "TransactionDetails"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Escrow"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "buyer"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "seller"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transactionUri"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "timestamp"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "token"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deadline"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "buyerFee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "sellerFee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastFeePaymentTime"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "templateData"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "templateDataMappings"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "status"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payments"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "party"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timestamp"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "hasToPayFees"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "party"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timestamp"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createdEvents"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "resolvedEvents"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "resolution"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timestamp"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "settlementProposals"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "EnumValue",
                                    "value": "timestamp"
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "EnumValue",
                                    "value": "asc"
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "party"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timestamp"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "disputeRequest"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "from"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "escrow"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timestamp"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $e26656e7cb881106$export$f0e0a894cc57dff1 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "EscrowParametersDetails"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ID"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "escrowParameters"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "feeTimeout"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "settlementTimeout"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "arbitratorExtraData"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $e26656e7cb881106$export$15b323ba4dc866b9 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "MyTransactions"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "userAddress"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Bytes"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "first"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "skip"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "Int"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "where"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Escrow_filter"
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "orderDirection"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "OrderDirection"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "escrows"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "first"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "first"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "skip"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "skip"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "EnumValue",
                                    "value": "timestamp"
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "orderDirection"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "where"
                                },
                                "value": {
                                    "kind": "ObjectValue",
                                    "fields": [
                                        {
                                            "kind": "ObjectField",
                                            "name": {
                                                "kind": "Name",
                                                "value": "and"
                                            },
                                            "value": {
                                                "kind": "ListValue",
                                                "values": [
                                                    {
                                                        "kind": "ObjectValue",
                                                        "fields": [
                                                            {
                                                                "kind": "ObjectField",
                                                                "name": {
                                                                    "kind": "Name",
                                                                    "value": "or"
                                                                },
                                                                "value": {
                                                                    "kind": "ListValue",
                                                                    "values": [
                                                                        {
                                                                            "kind": "ObjectValue",
                                                                            "fields": [
                                                                                {
                                                                                    "kind": "ObjectField",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "buyer"
                                                                                    },
                                                                                    "value": {
                                                                                        "kind": "Variable",
                                                                                        "name": {
                                                                                            "kind": "Name",
                                                                                            "value": "userAddress"
                                                                                        }
                                                                                    }
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ObjectValue",
                                                                            "fields": [
                                                                                {
                                                                                    "kind": "ObjectField",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "seller"
                                                                                    },
                                                                                    "value": {
                                                                                        "kind": "Variable",
                                                                                        "name": {
                                                                                            "kind": "Name",
                                                                                            "value": "userAddress"
                                                                                        }
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "where"
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "TransactionDetails"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "TransactionDetails"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Escrow"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "buyer"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "seller"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transactionUri"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "timestamp"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "token"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deadline"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "buyerFee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "sellerFee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastFeePaymentTime"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "templateData"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "templateDataMappings"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "status"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payments"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "party"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timestamp"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "hasToPayFees"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "party"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timestamp"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createdEvents"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "resolvedEvents"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "resolution"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timestamp"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "settlementProposals"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "EnumValue",
                                    "value": "timestamp"
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "EnumValue",
                                    "value": "asc"
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "party"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timestamp"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "disputeRequest"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "from"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "escrow"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timestamp"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $e26656e7cb881106$export$d8aeb11458a36a81 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "TransactionDetails"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ID"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "escrow"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "TransactionDetails"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "TransactionDetails"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Escrow"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "buyer"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "seller"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "transactionUri"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "timestamp"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "amount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "token"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "deadline"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "buyerFee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "sellerFee"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastFeePaymentTime"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "templateData"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "templateDataMappings"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "status"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "payments"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "party"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timestamp"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "hasToPayFees"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "party"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timestamp"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createdEvents"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "resolvedEvents"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "resolution"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timestamp"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "settlementProposals"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderBy"
                                },
                                "value": {
                                    "kind": "EnumValue",
                                    "value": "timestamp"
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "orderDirection"
                                },
                                "value": {
                                    "kind": "EnumValue",
                                    "value": "asc"
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "party"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timestamp"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "disputeRequest"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "from"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "escrow"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "timestamp"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $e26656e7cb881106$export$5b3636afbb1882d3 = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "User"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "userId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ID"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "user"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "userId"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalEscrows"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalResolvedEscrows"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalNoDisputedEscrows"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalDisputedEscrows"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalWaitingBuyerEscrows"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "totalWaitingSellerEscrows"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


/**
 * Map of all GraphQL operations in the project.
 *
 * This map has several performance disadvantages:
 * 1. It is not tree-shakeable, so it will include all operations in the project.
 * 2. It is not minifiable, so the string of a GraphQL query will be multiple times inside the bundle.
 * 3. It does not support dead code elimination, so it will add unused operations.
 *
 * Therefore it is highly recommended to use the babel or swc plugin for production.
 */ const $119c854c1b94ec44$var$documents = {
    "\n  query EscrowParametersDetails($id: ID!) {\n    escrowParameters(id: $id) {\n      id\n      feeTimeout\n      settlementTimeout\n      arbitratorExtraData\n    }\n  }\n": $e26656e7cb881106$export$f0e0a894cc57dff1,
    "\n  fragment TransactionDetails on Escrow {\n    id\n    buyer\n    seller\n    transactionUri\n    timestamp\n    amount\n    token\n    deadline\n    buyerFee\n    sellerFee\n    lastFeePaymentTime\n    templateData\n    templateDataMappings\n    status\n    payments {\n      id\n      amount\n      party\n      timestamp\n    }\n    hasToPayFees {\n      id\n      party\n      timestamp\n    }\n    createdEvents {\n      id\n    }\n    resolvedEvents {\n      id\n      resolution\n      timestamp\n    }\n    settlementProposals(orderBy: timestamp, orderDirection: asc) {\n      id\n      amount\n      party\n      timestamp\n    }\n    disputeRequest {\n      id\n      from\n      escrow {\n        id\n      }\n      timestamp\n    }\n  }\n": $e26656e7cb881106$export$5b123591c7340442,
    "\n  query MyTransactions(\n    $userAddress: Bytes!\n    $first: Int!\n    $skip: Int!\n    $where: Escrow_filter\n    $orderDirection: OrderDirection\n  ) {\n    escrows(\n      first: $first\n      skip: $skip\n      orderBy: timestamp\n      orderDirection: $orderDirection\n      where: { and: [{ or: [{ buyer: $userAddress }, { seller: $userAddress }] }, $where] }\n    ) {\n      ...TransactionDetails\n    }\n  }\n": $e26656e7cb881106$export$15b323ba4dc866b9,
    "\n  query TransactionDetails($id: ID!) {\n    escrow(id: $id) {\n      ...TransactionDetails\n    }\n  }\n": $e26656e7cb881106$export$d8aeb11458a36a81,
    "\n  query User($userId: ID!) {\n    user(id: $userId) {\n      totalEscrows\n      totalResolvedEscrows\n      totalNoDisputedEscrows\n      totalDisputedEscrows\n      totalWaitingBuyerEscrows\n      totalWaitingSellerEscrows\n    }\n  }\n": $e26656e7cb881106$export$5b3636afbb1882d3
};
function $119c854c1b94ec44$export$1eb4e7c0ed67b035(source) {
    return $119c854c1b94ec44$var$documents[source] ?? {};
}





const $1f6a4b7374e194ad$export$2c418990deeabc = (0, $119c854c1b94ec44$export$1eb4e7c0ed67b035)(`
  fragment TransactionDetails on Escrow {
    id
    buyer
    seller
    transactionUri
    timestamp
    amount
    token
    deadline
    buyerFee
    sellerFee
    lastFeePaymentTime
    templateData
    templateDataMappings
    status
    payments {
      id
      amount
      party
      timestamp
    }
    hasToPayFees {
      id
      party
      timestamp
    }
    createdEvents {
      id
    }
    resolvedEvents {
      id
      resolution
      timestamp
    }
    settlementProposals(orderBy: timestamp, orderDirection: asc) {
      id
      amount
      party
      timestamp
    }
    disputeRequest {
      id
      from
      escrow {
        id
      }
      timestamp
    }
  }
`);
const $1f6a4b7374e194ad$var$myTransactionsQuery = (0, $119c854c1b94ec44$export$1eb4e7c0ed67b035)(`
  query MyTransactions(
    $userAddress: Bytes!
    $first: Int!
    $skip: Int!
    $where: Escrow_filter
    $orderDirection: OrderDirection
  ) {
    escrows(
      first: $first
      skip: $skip
      orderBy: timestamp
      orderDirection: $orderDirection
      where: { and: [{ or: [{ buyer: $userAddress }, { seller: $userAddress }] }, $where] }
    ) {
      ...TransactionDetails
    }
  }
`);
const $1f6a4b7374e194ad$var$transactionDetailsQuery = (0, $119c854c1b94ec44$export$1eb4e7c0ed67b035)(`
  query TransactionDetails($id: ID!) {
    escrow(id: $id) {
      ...TransactionDetails
    }
  }
`);
const $1f6a4b7374e194ad$export$1be7720ad3c07e60 = (transactionId)=>{
    const { graphqlBatcher: graphqlBatcher } = (0, $6dabd7de11302893$export$45728877641088dc)();
    return (0, $8c6a367513f3f9c5$export$dd0a697e1782aedd)({
        queryKey: [
            "refetchOnBlock",
            `useTransactionDetailsQuery`,
            transactionId
        ],
        queryFn: async ()=>await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: $1f6a4b7374e194ad$var$transactionDetailsQuery,
                variables: {
                    id: transactionId
                }
            })
    });
};
const $1f6a4b7374e194ad$export$463e0cc86ede41a3 = (userAddress, first = 9, skip = 0, where, orderDirection)=>{
    const { graphqlBatcher: graphqlBatcher } = (0, $6dabd7de11302893$export$45728877641088dc)();
    return (0, $8c6a367513f3f9c5$export$dd0a697e1782aedd)({
        queryKey: [
            "refetchOnBlock",
            "useMyTransactionsQuery",
            userAddress,
            first,
            skip,
            where,
            orderDirection
        ],
        queryFn: async ()=>await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: $1f6a4b7374e194ad$var$myTransactionsQuery,
                variables: {
                    userAddress: userAddress.toLowerCase(),
                    first: first,
                    skip: skip,
                    where: where,
                    orderDirection: orderDirection
                }
            })
    });
};





const $c0d92291c76b8761$var$userQuery = (0, $119c854c1b94ec44$export$1eb4e7c0ed67b035)(`
  query User($userId: ID!) {
    user(id: $userId) {
      totalEscrows
      totalResolvedEscrows
      totalNoDisputedEscrows
      totalDisputedEscrows
      totalWaitingBuyerEscrows
      totalWaitingSellerEscrows
    }
  }
`);
const $c0d92291c76b8761$export$68dae0b0cacaa18a = (userId)=>{
    const { graphqlBatcher: graphqlBatcher } = (0, $6dabd7de11302893$export$45728877641088dc)();
    return (0, $8c6a367513f3f9c5$export$dd0a697e1782aedd)({
        queryKey: [
            `useUserQuery`,
            userId
        ],
        queryFn: async ()=>await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: $c0d92291c76b8761$var$userQuery,
                variables: {
                    userId: userId.toLowerCase()
                }
            })
    });
};



parcelRequire("9nZCP");



var $9nZCP = parcelRequire("9nZCP");







const $7e45b60f5b565a93$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
        flex-direction: row;
        gap: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(4, 22)};
      `)}
`;
const $7e45b60f5b565a93$var$SearchBarContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 5px;
  z-index: 0;
`;
const $7e45b60f5b565a93$var$StyledSearchbar = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Searchbar))`
  flex: 1;
  flex-basis: 310px;
  input {
    font-size: 16px;
    height: 45px;
    padding-top: 0px;
    padding-bottom: 0px;
  }
`;
const $7e45b60f5b565a93$var$Search = ()=>{
    const { page: page, order: order, filter: filter } = (0, $cb6812e0fa529c57$export$99eaa27ddbbb95ef)();
    const location = (0, $9e2a1c796186274a$export$e6340d5ca6801d59)();
    const decodedFilter = (0, $9e2a1c796186274a$export$839ea60635874ac1)(filter ?? "all");
    const { id: searchValue, ...filterObject } = decodedFilter;
    const [search, setSearch] = (0, $9nZCP.useState)(searchValue ?? "");
    const navigate = (0, $cb6812e0fa529c57$export$9770f232ac06a008)();
    (0, $c171e39a1b1b690a$export$2e2bcd8739ae039)(()=>{
        const newFilters = search === "" ? {
            ...filterObject
        } : {
            ...filterObject,
            id: search
        };
        const encodedFilter = (0, $9e2a1c796186274a$export$393e2cd582c6728a)(newFilters);
        navigate(`${location}/${page}/${order}/${encodedFilter}`);
    }, 500, [
        search
    ]);
    const handleStatusChange = (selectedValue)=>{
        const newFilters = {
            ...filterObject,
            status: selectedValue === "all" ? undefined : selectedValue
        };
        const encodedFilter = (0, $9e2a1c796186274a$export$393e2cd582c6728a)(newFilters);
        navigate(`${location}/${page}/${order}/${encodedFilter}`);
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($7e45b60f5b565a93$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($7e45b60f5b565a93$var$SearchBarContainer, {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($7e45b60f5b565a93$var$StyledSearchbar, {
                    type: "text",
                    placeholder: "Search By ID",
                    value: search,
                    onChange: (e)=>setSearch(e.target.value)
                })
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.DropdownSelect), {
                items: [
                    {
                        text: "All States",
                        dot: "grey",
                        value: "all"
                    },
                    {
                        text: "In Progress",
                        dot: "blue",
                        value: "NoDispute"
                    },
                    {
                        text: "Settlement - Waiting Buyer",
                        dot: "orange",
                        value: "WaitingSettlementBuyer"
                    },
                    {
                        text: "Settlement - Waiting Seller",
                        dot: "orange",
                        value: "WaitingSettlementSeller"
                    },
                    {
                        text: "Raising a Dispute - Waiting Buyer",
                        dot: "blue",
                        value: "WaitingBuyer"
                    },
                    {
                        text: "Raising a Dispute - Waiting Seller",
                        dot: "blue",
                        value: "WaitingSeller"
                    },
                    {
                        text: "Disputed",
                        dot: "purple",
                        value: "DisputeCreated"
                    },
                    {
                        text: "Concluded",
                        dot: "green",
                        value: "TransactionResolved"
                    }
                ],
                defaultValue: decodedFilter.status ?? "all",
                callback: (value)=>handleStatusChange(value)
            })
        ]
    });
};
var $7e45b60f5b565a93$export$2e2bcd8739ae039 = $7e45b60f5b565a93$var$Search;



parcelRequire("9nZCP");


parcelRequire("9nZCP");






parcelRequire("9nZCP");
const $09ce932ebbae6635$var$SvgList = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M3 3a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM1.5 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm0 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm3-7.375h11a.5.5 0 0 0 .5-.5v-1.25a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v1.25a.5.5 0 0 0 .5.5Zm0 5h11a.5.5 0 0 0 .5-.5v-1.25a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v1.25a.5.5 0 0 0 .5.5Zm0 5h11a.5.5 0 0 0 .5-.5v-1.25a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v1.25a.5.5 0 0 0 .5.5Z"
        })
    });
var $09ce932ebbae6635$export$2e2bcd8739ae039 = $09ce932ebbae6635$var$SvgList;



parcelRequire("9nZCP");
const $9a9c625fa44bbc85$var$SvgGrid = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M4.667 2.25v2.5a.75.75 0 0 1-.75.75H.75A.75.75 0 0 1 0 4.75v-2.5a.75.75 0 0 1 .75-.75h3.167a.75.75 0 0 1 .75.75Zm5.666 7.5v-2.5a.75.75 0 0 0-.75-.75H6.417a.75.75 0 0 0-.75.75v2.5c0 .414.335.75.75.75h3.166a.75.75 0 0 0 .75-.75Zm1-7.5v2.5c0 .414.336.75.75.75h3.167a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75h-3.167a.75.75 0 0 0-.75.75Zm-1 2.5v-2.5a.75.75 0 0 0-.75-.75H6.417a.75.75 0 0 0-.75.75v2.5c0 .414.335.75.75.75h3.166a.75.75 0 0 0 .75-.75ZM3.917 6.5H.75a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75h3.167a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75ZM0 12.25v2.5c0 .414.336.75.75.75h3.167a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75H.75a.75.75 0 0 0-.75.75Zm12.083-1.75h3.167a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75h-3.167a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75Zm0 5h3.167a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75h-3.167a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75Zm-6.416-3.25v2.5c0 .414.335.75.75.75h3.166a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75H6.417a.75.75 0 0 0-.75.75Z"
        })
    });
var $9a9c625fa44bbc85$export$2e2bcd8739ae039 = $9a9c625fa44bbc85$var$SvgGrid;




const $b47cbfde1d405f62$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: end;
  gap: 12px;
  width: fit-content;
`;
const $b47cbfde1d405f62$var$StyledGridIcon = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $9a9c625fa44bbc85$export$2e2bcd8739ae039))`
  cursor: pointer;
  transition: filter 0.2s ease;
  fill: ${({ theme: theme })=>theme.primaryBlue};
  width: 16px;
  height: 16px;
  overflow: hidden;
`;
const $b47cbfde1d405f62$var$IconsContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;
const $b47cbfde1d405f62$var$StyledListIcon = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $09ce932ebbae6635$export$2e2bcd8739ae039))`
  cursor: pointer;
  transition: filter 0.2s ease;
  fill: ${({ theme: theme })=>theme.primaryBlue};
  width: 16px;
  height: 16px;
  overflow: hidden;
`;
const $b47cbfde1d405f62$var$Filters = ()=>{
    const theme = (0, $1d9bd5c523349ec4$export$93d4e7f90805808f)();
    const { order: order, filter: filter } = (0, $cb6812e0fa529c57$export$99eaa27ddbbb95ef)();
    const { ruled: ruled, period: period, ...filterObject } = (0, $9e2a1c796186274a$export$839ea60635874ac1)(filter ?? "all");
    const navigate = (0, $cb6812e0fa529c57$export$9770f232ac06a008)();
    const location = (0, $9e2a1c796186274a$export$e6340d5ca6801d59)();
    const handleStatusChange = (value)=>{
        const parsedValue = JSON.parse(value);
        const encodedFilter = (0, $9e2a1c796186274a$export$393e2cd582c6728a)({
            ...filterObject,
            ...parsedValue
        });
        navigate(`${location}/1/${order}/${encodedFilter}`);
    };
    const handleOrderChange = (value)=>{
        const encodedFilter = (0, $9e2a1c796186274a$export$393e2cd582c6728a)({
            ruled: ruled,
            period: period,
            ...filterObject
        });
        navigate(`${location}/1/${value}/${encodedFilter}`);
    };
    const { width: width } = (0, $3bc11a3cff85be60$export$2e2bcd8739ae039)();
    const { isList: isList, setIsList: setIsList } = (0, $42c890363ed32eb3$export$efcb02388d4a2108)();
    const screenIsBig = width > (0, $fbf3a9d90d422861$export$4cf8c0e020b1f8b2);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($b47cbfde1d405f62$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.DropdownSelect), {
                smallButton: true,
                simpleButton: true,
                items: [
                    {
                        value: "desc",
                        text: "Newest"
                    },
                    {
                        value: "asc",
                        text: "Oldest"
                    }
                ],
                defaultValue: order,
                callback: handleOrderChange
            }),
            screenIsBig ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($b47cbfde1d405f62$var$IconsContainer, {
                children: isList ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($b47cbfde1d405f62$var$StyledGridIcon, {
                    onClick: ()=>setIsList(false)
                }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($b47cbfde1d405f62$var$StyledListIcon, {
                    onClick: ()=>{
                        if (screenIsBig) setIsList(true);
                    }
                })
            }) : null
        ]
    });
};
var $b47cbfde1d405f62$export$2e2bcd8739ae039 = $b47cbfde1d405f62$var$Filters;




var $9nZCP = parcelRequire("9nZCP");

const $34a9e7111fbe7ca4$var$FieldWrapper = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: inline-flex;
  gap: 8px;
`;
const $34a9e7111fbe7ca4$var$SeparatorLabel = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).label`
  margin: 0 8px;
  color: ${({ theme: theme })=>theme.primaryText};
`;
const $34a9e7111fbe7ca4$var$StyledLabel = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).label`
  color: ${({ theme: theme })=>theme.primaryText};
`;
const $34a9e7111fbe7ca4$var$Field = ({ label: label, value: value })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($34a9e7111fbe7ca4$var$FieldWrapper, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($34a9e7111fbe7ca4$var$StyledLabel, {
                children: label
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("small", {
                children: value
            })
        ]
    });
const $34a9e7111fbe7ca4$var$Separator = ()=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($34a9e7111fbe7ca4$var$SeparatorLabel, {
        children: "|"
    });
const $34a9e7111fbe7ca4$var$Stats = ({ totalTransactions: totalTransactions, resolvedTransactions: resolvedTransactions })=>{
    const inProgressDisputes = (totalTransactions - resolvedTransactions).toString();
    const fields = [
        {
            label: "Total",
            value: totalTransactions.toString()
        },
        {
            label: "In Progress",
            value: inProgressDisputes
        },
        {
            label: "Concluded",
            value: resolvedTransactions.toString()
        }
    ];
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("div", {
        children: fields.map(({ label: label, value: value }, i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($34a9e7111fbe7ca4$var$Field, {
                        label: label,
                        value: value
                    }),
                    i + 1 < fields.length ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($34a9e7111fbe7ca4$var$Separator, {}) : null
                ]
            }, i))
    });
};
var $34a9e7111fbe7ca4$export$2e2bcd8739ae039 = $34a9e7111fbe7ca4$var$Stats;


const $96ccb2f973c90b49$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 11px;
  margin-bottom: 48px;
  justify-content: space-between;
`;
const $96ccb2f973c90b49$var$StatsAndFilters = ({ totalTransactions: totalTransactions, resolvedTransactions: resolvedTransactions })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($96ccb2f973c90b49$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $34a9e7111fbe7ca4$export$2e2bcd8739ae039), {
                totalTransactions: totalTransactions,
                resolvedTransactions: resolvedTransactions
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $b47cbfde1d405f62$export$2e2bcd8739ae039), {})
        ]
    });
var $96ccb2f973c90b49$export$2e2bcd8739ae039 = $96ccb2f973c90b49$var$StatsAndFilters;




var $9nZCP = parcelRequire("9nZCP");










parcelRequire("9nZCP");




var $c6heD = parcelRequire("c6heD");









var $9nZCP = parcelRequire("9nZCP");

var $dmOVR = parcelRequire("dmOVR");

const $47ed2dc0909781d5$var$useFetchIpfsJson = (ipfsUri)=>{
    const [data, setData] = (0, $9nZCP.useState)(null);
    (0, $9nZCP.useEffect)(()=>{
        const fetchJson = async ()=>{
            if (!ipfsUri) return;
            try {
                const formattedUri = (0, $dc499933200379fe$export$99de037bb933f932)(ipfsUri);
                const response = await (0, (/*@__PURE__*/$parcel$interopDefault($dmOVR)))(formattedUri);
                if (!response.ok) throw new Error(`IPFS fetch failed with status ${response.status}`);
                const jsonData = await response.json();
                setData(jsonData);
            } catch (err) {
                console.error(err);
                setData(null);
            }
        };
        fetchJson();
    }, [
        ipfsUri
    ]);
    return data;
};
var $47ed2dc0909781d5$export$2e2bcd8739ae039 = $47ed2dc0909781d5$var$useFetchIpfsJson;



const $28bc45c6dffe4e6e$var$StyledCard = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Card))`
  width: 100%;
  height: 260px;
`;
const $28bc45c6dffe4e6e$var$StyledListItem = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Card))`
  display: flex;
  flex-grow: 1;
  width: 100%;
  height: 82px;
`;
const $28bc45c6dffe4e6e$var$CardContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  height: calc(100% - 45px);
  padding: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(20, 24)};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const $28bc45c6dffe4e6e$var$ListContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  width: 100%;
`;
const $28bc45c6dffe4e6e$var$ListTitle = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div``;
const $28bc45c6dffe4e6e$var$StyledTitle = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).h3`
  margin: 0;
`;
const $28bc45c6dffe4e6e$var$TruncatedTitle = ({ text: text, maxLength: maxLength })=>{
    const truncatedText = text.length <= maxLength ? text : text.slice(0, maxLength) + "\u2026";
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($28bc45c6dffe4e6e$var$StyledTitle, {
        children: truncatedText
    });
};
const $28bc45c6dffe4e6e$var$TransactionCard = ({ id: id, status: status, overrideIsList: overrideIsList, transactionUri: transactionUri, deadline: deadline, seller: seller, buyer: buyer, amount: amount, token: token })=>{
    const transactionInfo = (0, $47ed2dc0909781d5$export$2e2bcd8739ae039)(transactionUri);
    const { isList: isList } = (0, $42c890363ed32eb3$export$efcb02388d4a2108)();
    const nativeTokenSymbol = (0, $1c28f538a7a87c87$export$e53e2a70ea774bf2)();
    const { tokenMetadata: tokenMetadata } = (0, $8aab0ec431048b51$export$9d829cdfbbd34b71)(token);
    const erc20TokenSymbol = tokenMetadata?.symbol;
    const assetSymbol = token ? erc20TokenSymbol : nativeTokenSymbol;
    const title = transactionInfo?.title;
    const navigateAndScrollTop = (0, $d7f7b0934356ec58$export$6731f25587ad254d)();
    const currentStatusEnum = (0, $f6465fae5c9dacc3$export$3264e9e2dd88c2d3)(status);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $dde41420777b5d34$exports.Fragment), {
        children: !isList || overrideIsList ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($28bc45c6dffe4e6e$var$StyledCard, {
            hover: true,
            onClick: ()=>navigateAndScrollTop(`/my-transactions/${id.toString()}`),
            children: [
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $4c98e343c4c36ef0$export$2e2bcd8739ae039), {
                    id: parseInt(id),
                    status: currentStatusEnum
                }),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($28bc45c6dffe4e6e$var$CardContainer, {
                    children: [
                        !(0, $c62bd748620e6ea9$export$fce6876652108ab)(title) ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($28bc45c6dffe4e6e$var$StyledTitle, {
                            children: title
                        }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e467ee9362ed574f$export$e4ecddc59e33f387), {}),
                        /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $f023554fa7f1bc9f$export$2e2bcd8739ae039), {
                            amount: (0, $c6heD.formatEther)(amount),
                            buyerAddress: buyer,
                            sellerAddress: seller,
                            deadlineDate: new Date(deadline * 1000).toLocaleString(),
                            isPreview: false,
                            assetSymbol: assetSymbol
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($28bc45c6dffe4e6e$var$StyledListItem, {
            hover: true,
            onClick: ()=>navigateAndScrollTop(`/my-transactions/${id.toString()}`),
            children: [
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $4c98e343c4c36ef0$export$2e2bcd8739ae039), {
                    isCard: false,
                    id: parseInt(id),
                    status: currentStatusEnum
                }),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($28bc45c6dffe4e6e$var$ListContainer, {
                    children: [
                        !(0, $c62bd748620e6ea9$export$fce6876652108ab)(title) ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($28bc45c6dffe4e6e$var$ListTitle, {
                            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($28bc45c6dffe4e6e$var$TruncatedTitle, {
                                text: title,
                                maxLength: 50
                            })
                        }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e467ee9362ed574f$export$c14ff0889fc7e591), {}),
                        /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $f023554fa7f1bc9f$export$2e2bcd8739ae039), {
                            amount: (0, $c6heD.formatEther)(amount),
                            buyerAddress: buyer,
                            sellerAddress: seller,
                            deadlineDate: new Date(deadline * 1000).toLocaleString(),
                            isPreview: false,
                            assetSymbol: assetSymbol
                        })
                    ]
                })
            ]
        })
    });
};
var $28bc45c6dffe4e6e$export$2e2bcd8739ae039 = $28bc45c6dffe4e6e$var$TransactionCard;


const $0dc9bb14d95a225a$var$GridContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  --gap: 24px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, max(348px, (100% - var(--gap) * 2)/3)), 1fr));
  align-items: center;
  gap: var(--gap);
`;
const $0dc9bb14d95a225a$var$ListContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
`;
const $0dc9bb14d95a225a$var$StyledPagination = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.StandardPagination))`
  margin-top: 24px;
  margin-left: auto;
  margin-right: auto;
`;
const $0dc9bb14d95a225a$var$TransactionsGrid = ({ transactions: transactions, transactionsPerPage: transactionsPerPage, totalPages: totalPages, currentPage: currentPage, setCurrentPage: setCurrentPage })=>{
    const { filter: filter } = (0, $cb6812e0fa529c57$export$99eaa27ddbbb95ef)();
    const decodedFilter = (0, $9e2a1c796186274a$export$839ea60635874ac1)(filter ?? "all");
    const { id: searchValue } = decodedFilter;
    const { isList: isList } = (0, $42c890363ed32eb3$export$efcb02388d4a2108)();
    const { width: width } = (0, $3bc11a3cff85be60$export$2e2bcd8739ae039)();
    const screenIsBig = (0, $9nZCP.useMemo)(()=>width > (0, $fbf3a9d90d422861$export$4cf8c0e020b1f8b2), [
        width
    ]);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            isList && screenIsBig ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($0dc9bb14d95a225a$var$ListContainer, {
                children: (0, $c62bd748620e6ea9$export$fce6876652108ab)(transactions) ? [
                    ...Array(transactionsPerPage)
                ].map((_, i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e467ee9362ed574f$export$eeebc3e739bc248f), {}, i)) : transactions.map((transaction)=>{
                    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $28bc45c6dffe4e6e$export$2e2bcd8739ae039), {
                        ...transaction
                    }, transaction.id);
                })
            }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($0dc9bb14d95a225a$var$GridContainer, {
                children: (0, $c62bd748620e6ea9$export$fce6876652108ab)(transactions) ? [
                    ...Array(transactionsPerPage)
                ].map((_, i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e467ee9362ed574f$export$6ebe8b6b92b06e62), {}, i)) : transactions.map((transaction)=>{
                    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $28bc45c6dffe4e6e$export$2e2bcd8739ae039), {
                        ...transaction,
                        overrideIsList: true
                    }, transaction.id);
                })
            }),
            (0, $c62bd748620e6ea9$export$fce6876652108ab)(searchValue) ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($0dc9bb14d95a225a$var$StyledPagination, {
                currentPage: currentPage,
                numPages: Math.ceil(totalPages ?? 0),
                callback: (page)=>setCurrentPage(page)
            }) : null
        ]
    });
};
var $0dc9bb14d95a225a$export$2e2bcd8739ae039 = $0dc9bb14d95a225a$var$TransactionsGrid;



const $eda29dbe4bcf6a1f$var$StyledTitle = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).h1`
  margin-bottom: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(32, 48)};
`;
const $eda29dbe4bcf6a1f$var$TransactionsDisplay = ({ transactions: transactions, currentPage: currentPage, setCurrentPage: setCurrentPage, totalTransactions: totalTransactions, resolvedTransactions: resolvedTransactions, transactionsPerPage: transactionsPerPage, title: title = "My Transactions", className: className, totalPages: totalPages })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($eda29dbe4bcf6a1f$var$StyledTitle, {
                children: title
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $7e45b60f5b565a93$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $96ccb2f973c90b49$export$2e2bcd8739ae039), {
                totalTransactions: totalTransactions ?? 0,
                resolvedTransactions: resolvedTransactions ?? 0
            }),
            transactions?.length === 0 ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("h1", {
                children: "No transactions found"
            }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $0dc9bb14d95a225a$export$2e2bcd8739ae039), {
                transactions: transactions,
                transactionsPerPage: transactionsPerPage,
                totalPages: totalPages,
                currentPage: currentPage,
                setCurrentPage: setCurrentPage
            })
        ]
    });
};
var $eda29dbe4bcf6a1f$export$2e2bcd8739ae039 = $eda29dbe4bcf6a1f$var$TransactionsDisplay;




const $93434f328c14df6d$var$TransactionsFetcher = ()=>{
    const { page: page, order: order, filter: filter } = (0, $cb6812e0fa529c57$export$99eaa27ddbbb95ef)();
    const navigate = (0, $cb6812e0fa529c57$export$9770f232ac06a008)();
    const { width: width } = (0, $3bc11a3cff85be60$export$2e2bcd8739ae039)();
    const location = (0, $9e2a1c796186274a$export$e6340d5ca6801d59)();
    const screenIsBig = width > (0, $fbf3a9d90d422861$export$4cf8c0e020b1f8b2);
    const transactionsPerPage = screenIsBig ? 9 : 3;
    const pageNumber = parseInt(page ?? "1", 10);
    const transactionSkip = transactionsPerPage * (pageNumber - 1);
    const { address: address } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    const { data: userData } = (0, $c0d92291c76b8761$export$68dae0b0cacaa18a)(address);
    const decodedFilter = (0, $9e2a1c796186274a$export$839ea60635874ac1)(filter ?? "all");
    const { data: escrowData } = (0, $1f6a4b7374e194ad$export$463e0cc86ede41a3)(address, transactionsPerPage, transactionSkip, decodedFilter, order === "asc" ? (0, $e26656e7cb881106$export$6576b9de878968d6).Asc : (0, $e26656e7cb881106$export$6576b9de878968d6).Desc);
    const { totalTransactions: totalTransactions, totalConcludedTransactions: totalConcludedTransactions } = (0, $9nZCP.useMemo)(()=>{
        switch(decodedFilter.status){
            case "DisputeCreated":
                return {
                    totalTransactions: userData?.user?.totalDisputedEscrows,
                    totalConcludedTransactions: 0
                };
            case "TransactionResolved":
                return {
                    totalTransactions: userData?.user?.totalResolvedEscrows,
                    totalConcludedTransactions: userData?.user?.totalResolvedEscrows
                };
            case "NoDispute":
                return {
                    totalTransactions: userData?.user?.totalNoDisputedEscrows,
                    totalConcludedTransactions: 0
                };
            case "WaitingBuyer":
                return {
                    totalTransactions: userData?.user?.totalWaitingBuyerEscrows,
                    totalConcludedTransactions: 0
                };
            case "WaitingSeller":
                return {
                    totalTransactions: userData?.user?.totalWaitingSellerEscrows,
                    totalConcludedTransactions: 0
                };
            default:
                return {
                    totalTransactions: userData?.user?.totalEscrows,
                    totalConcludedTransactions: userData?.user?.totalResolvedEscrows
                };
        }
    }, [
        userData,
        decodedFilter
    ]);
    const totalPages = (0, $9nZCP.useMemo)(()=>{
        return Math.ceil(totalTransactions / transactionsPerPage) || 1;
    }, [
        totalTransactions,
        transactionsPerPage
    ]);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $eda29dbe4bcf6a1f$export$2e2bcd8739ae039), {
        transactions: escrowData?.escrows,
        totalTransactions: totalTransactions,
        resolvedTransactions: totalConcludedTransactions,
        currentPage: pageNumber,
        setCurrentPage: (newPage)=>navigate(`${location}/${newPage}/${order}/${filter}`),
        totalPages: totalPages,
        transactionsPerPage: transactionsPerPage
    });
};
var $93434f328c14df6d$export$2e2bcd8739ae039 = $93434f328c14df6d$var$TransactionsFetcher;




var $9nZCP = parcelRequire("9nZCP");




var $c6heD = parcelRequire("c6heD");




parcelRequire("9nZCP");



parcelRequire("9nZCP");




var $9nZCP = parcelRequire("9nZCP");




var $9nZCP = parcelRequire("9nZCP");



parcelRequire("9nZCP");


parcelRequire("9nZCP");
const $4fa709d6138e0b50$var$SvgCheckCircleFull = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 32,
        height: 32,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
            clipPath: "url('1c4ee07c74218d0c')",
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0Zm6.91 10.775-7.52 10.429a1.135 1.135 0 0 1-1.847 0l-4.454-6.172a.287.287 0 0 1 .232-.453h1.675c.365 0 .711.175.925.475l2.543 3.528 5.615-7.786c.214-.296.557-.475.925-.475h1.675c.232 0 .367.265.232.454Z",
                fill: "#00C42B"
            })
        })
    });
var $4fa709d6138e0b50$export$2e2bcd8739ae039 = $4fa709d6138e0b50$var$SvgCheckCircleFull;


const $c5c5feaf39e06df7$var$StyledCheckCircleFull = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $4fa709d6138e0b50$export$2e2bcd8739ae039))`
  margin-bottom: 12px;
`;
const $c5c5feaf39e06df7$var$VerifiedLogo = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($c5c5feaf39e06df7$var$StyledCheckCircleFull, {});
};
var $c5c5feaf39e06df7$export$2e2bcd8739ae039 = $c5c5feaf39e06df7$var$VerifiedLogo;



parcelRequire("9nZCP");


var $c6heD = parcelRequire("c6heD");

const $edfe54e30ae9669a$var$StyledHeader = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).h1`
  margin: 0;
  margin-bottom: 24px;
  text-align: center;
`;
const $edfe54e30ae9669a$var$Header = ()=>{
    const { amount: amount, assetSymbol: assetSymbol } = (0, $4d51476fd708038f$export$57f2782cc8cecbb0)();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($edfe54e30ae9669a$var$StyledHeader, {
        children: [
            "Full payment released: ",
            (0, $c6heD.formatEther)(amount),
            " ",
            assetSymbol
        ]
    });
};
var $edfe54e30ae9669a$export$2e2bcd8739ae039 = $edfe54e30ae9669a$var$Header;



parcelRequire("9nZCP");



const $510a3d886c40fe5c$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
  text-align: center;
`;
const $510a3d886c40fe5c$var$StyledEscrowConcluded = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).p`
  margin: 0;
`;
const $510a3d886c40fe5c$var$StyledThanks = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).p`
  margin: 0;
  font-weight: 600;
`;
const $510a3d886c40fe5c$var$Description = ()=>{
    const { seller: seller } = (0, $4d51476fd708038f$export$57f2782cc8cecbb0)();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($510a3d886c40fe5c$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($510a3d886c40fe5c$var$StyledEscrowConcluded, {
                children: [
                    "Escrow concluded. The funds were released to ",
                    (0, $dcb9f356e0e0b2ff$export$e6e2bc9967bf256c)(seller),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($510a3d886c40fe5c$var$StyledThanks, {
                children: "Thanks for using Kleros Escrow."
            })
        ]
    });
};
var $510a3d886c40fe5c$export$2e2bcd8739ae039 = $510a3d886c40fe5c$var$Description;



parcelRequire("9nZCP");

const $2b257708c2cce108$var$CloseButton = ({ toggleModal: toggleModal })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.Button), {
        variant: "secondary",
        text: "Close",
        onClick: toggleModal
    });
};
var $2b257708c2cce108$export$2e2bcd8739ae039 = $2b257708c2cce108$var$CloseButton;



const $52f8f43cf0a0f238$var$PaymentReleased = ({ toggleModal: toggleModal })=>{
    const containerRef = (0, $9nZCP.useRef)(null);
    (0, $0aa9c5ea5f98ac89$export$2e2bcd8739ae039)(containerRef, ()=>toggleModal());
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $a4e24e3c9f4f276a$export$c6fdb837b070b4ff), {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $199d04a141957ef1$export$8863cf9d79cd26ad), {
                ref: containerRef,
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $c5c5feaf39e06df7$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $edfe54e30ae9669a$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $510a3d886c40fe5c$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $2b257708c2cce108$export$2e2bcd8739ae039), {
                        toggleModal: toggleModal
                    })
                ]
            })
        ]
    });
};
var $52f8f43cf0a0f238$export$2e2bcd8739ae039 = $52f8f43cf0a0f238$var$PaymentReleased;








const $20a55024a20c77b2$var$ReleasePaymentButton = ()=>{
    const [isModalOpen, toggleModal] = (0, $b2e41656ab938cc0$export$2e2bcd8739ae039)(false);
    const [isSending, setIsSending] = (0, $9nZCP.useState)(false);
    const publicClient = (0, $b9a08c139e2d6879$export$3ca3483c611a99c4)();
    const { id: id, amount: amount } = (0, $4d51476fd708038f$export$57f2782cc8cecbb0)();
    const refetchQuery = (0, $7f2cd7efc5dd98b6$export$a25b430d4137a40)();
    const { config: releaseFullPaymentConfig } = (0, $65cd6dc33c6d9133$export$55821cc32e809701)({
        args: [
            id,
            amount
        ]
    });
    const { writeAsync: releaseFullPayment } = (0, $65cd6dc33c6d9133$export$406692f3d67b7258)(releaseFullPaymentConfig);
    const handleReleasePayment = ()=>{
        if (!(0, $c62bd748620e6ea9$export$fce6876652108ab)(releaseFullPayment)) {
            setIsSending(true);
            (0, $6724d57570dc2c5f$export$27738200007bd40a)(async ()=>await releaseFullPayment().then((response)=>response.hash), publicClient).then((wrapResult)=>{
                if (wrapResult.status) {
                    toggleModal();
                    refetchQuery([
                        [
                            "refetchOnBlock",
                            "useTransactionDetailsQuery"
                        ]
                    ]);
                }
            }).catch((error)=>{
                console.error("Failed to release payment:", error);
            }).finally(()=>{
                setIsSending(false);
            });
        }
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.Button), {
                isLoading: isSending,
                disabled: isSending,
                text: "Yes. Release full payment",
                onClick: handleReleasePayment
            }),
            isModalOpen ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $52f8f43cf0a0f238$export$2e2bcd8739ae039), {
                toggleModal: toggleModal
            }) : null
        ]
    });
};
var $20a55024a20c77b2$export$2e2bcd8739ae039 = $20a55024a20c77b2$var$ReleasePaymentButton;






var $9nZCP = parcelRequire("9nZCP");








const $c665586e62495117$var$ClaimFullPaymentButton = ()=>{
    const [isModalOpen, toggleModal] = (0, $b2e41656ab938cc0$export$2e2bcd8739ae039)(false);
    const [isSending, setIsSending] = (0, $9nZCP.useState)(false);
    const publicClient = (0, $b9a08c139e2d6879$export$3ca3483c611a99c4)();
    const { id: id } = (0, $4d51476fd708038f$export$57f2782cc8cecbb0)();
    const { config: executeTransactionConfig } = (0, $65cd6dc33c6d9133$export$8d857306e9906350)({
        args: [
            id
        ]
    });
    const { writeAsync: executeTransaction } = (0, $65cd6dc33c6d9133$export$40eca84d940651c2)(executeTransactionConfig);
    const handleExecuteTransaction = ()=>{
        if (!(0, $c62bd748620e6ea9$export$fce6876652108ab)(executeTransaction)) {
            setIsSending(true);
            (0, $6724d57570dc2c5f$export$27738200007bd40a)(async ()=>await executeTransaction().then((response)=>response.hash), publicClient).then((wrapResult)=>{
                if (wrapResult.status) toggleModal();
                else setIsSending(false);
            }).catch((error)=>{
                console.error("Failed to claim payment:", error);
            }).finally(()=>{
                setIsSending(false);
            });
        }
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.Button), {
                isLoading: isSending,
                disabled: isSending,
                text: "No. Claim full payment",
                onClick: handleExecuteTransaction
            }),
            isModalOpen ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $52f8f43cf0a0f238$export$2e2bcd8739ae039), {
                toggleModal: toggleModal
            }) : null
        ]
    });
};
var $c665586e62495117$export$2e2bcd8739ae039 = $c665586e62495117$var$ClaimFullPaymentButton;


const $4d957ef993fff0d4$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px 24px;
  justify-content: center;
  margin-bottom: 32px;
`;
const $4d957ef993fff0d4$var$Buttons = ()=>{
    const { address: address } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    const { buyer: buyer, payments: payments, deadline: deadline } = (0, $4d51476fd708038f$export$57f2782cc8cecbb0)();
    const isBuyer = address?.toLowerCase() === buyer?.toLowerCase();
    const currentTimeUnixSeconds = Math.floor(Date.now() / 1000);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($4d957ef993fff0d4$var$Container, {
        children: [
            isBuyer && payments?.length === 0 ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $20a55024a20c77b2$export$2e2bcd8739ae039), {}) : null,
            currentTimeUnixSeconds < deadline ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $42310430474a8cfa$export$2e2bcd8739ae039), {
                buttonText: "Propose a settlement"
            }) : null,
            currentTimeUnixSeconds > deadline && !isBuyer ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $c665586e62495117$export$2e2bcd8739ae039), {}) : null
        ]
    });
};
var $4d957ef993fff0d4$export$2e2bcd8739ae039 = $4d957ef993fff0d4$var$Buttons;



parcelRequire("9nZCP");

const $8b3bdac8fa125b3a$var$StyledP = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).p`
  color: ${({ theme: theme })=>theme.primaryBlue};
  font-weight: 600;
  margin: 0;
`;
const $8b3bdac8fa125b3a$var$Header = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($8b3bdac8fa125b3a$var$StyledP, {
        children: "Was the agreement fulfilled?"
    });
};
var $8b3bdac8fa125b3a$export$2e2bcd8739ae039 = $8b3bdac8fa125b3a$var$Header;



const $d35d9ba34e04a154$var$StyledCard = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Card))`
  display: flex;
  gap: 22px;
  background-color: ${({ theme: theme })=>theme.mediumBlue};
  border: 1px solid ${({ theme: theme })=>theme.primaryBlue};
  width: 86vw;
  height: auto;
  align-items: center;
  align-self: center;
  flex-direction: column;
  padding: 30px 40px 4px 40px;

  ${(0, $fbf3a9d90d422861$export$7432a1a850ec2b36)(()=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
        gap: 22px;
        width: 100%;
      `)}
`;
const $d35d9ba34e04a154$var$WasItFulfilled = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($d35d9ba34e04a154$var$StyledCard, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $8b3bdac8fa125b3a$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $4d957ef993fff0d4$export$2e2bcd8739ae039), {})
        ]
    });
};
var $d35d9ba34e04a154$export$2e2bcd8739ae039 = $d35d9ba34e04a154$var$WasItFulfilled;



parcelRequire("9nZCP");


parcelRequire("9nZCP");



const $7869c01013a0c2af$var$ArbitrationFeeInfo = ({ pendingParty: pendingParty })=>{
    const { address: address } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    const { seller: seller, buyer: buyer } = (0, $4d51476fd708038f$export$57f2782cc8cecbb0)();
    const isBuyerConnected = address?.toLowerCase() === buyer;
    const isSellerConnected = address?.toLowerCase() === seller;
    const variant = pendingParty === "buyer" && isBuyerConnected || pendingParty === "seller" && isSellerConnected ? "warning" : "info";
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.AlertMessage), {
        variant: variant,
        title: `The ${pendingParty === "buyer" ? "Buyer" : "Seller"} needs to deposit the fee in time not to lose the escrow`,
        msg: pendingParty === "buyer" ? "In case the buyer fails to deposit the arbitration fee in time, the seller will be able to claim the full payment + arbitration fee back." : "In case the seller fails to deposit the arbitration fee in time, the buyer will be able to claim the full payment + arbitration fee back."
    });
};
var $7869c01013a0c2af$export$2e2bcd8739ae039 = $7869c01013a0c2af$var$ArbitrationFeeInfo;



parcelRequire("9nZCP");

const $9e6f67befb3a7a7f$var$DisputeInfo = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.AlertMessage), {
        variant: "info",
        title: "Follow the case closely to avoid missing the deadlines",
        msg: "We suggest you add evidence to support your case. It can be done directly on Kleros Court."
    });
};
var $9e6f67befb3a7a7f$export$2e2bcd8739ae039 = $9e6f67befb3a7a7f$var$DisputeInfo;



parcelRequire("9nZCP");



const $c3980034f2f35b2a$var$SettlementInfo = ({ pendingParty: pendingParty })=>{
    const { address: address } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    const { seller: seller, buyer: buyer } = (0, $4d51476fd708038f$export$57f2782cc8cecbb0)();
    const isBuyerConnected = address?.toLowerCase() === buyer;
    const isSellerConnected = address?.toLowerCase() === seller;
    const message = pendingParty === "buyer" && isBuyerConnected || pendingParty === "seller" && isSellerConnected ? "You can accept the proposal, counter-propose, or raise a dispute." : "Wait for the other party to answer. If the other party takes too long, you will be able to raise a dispute.";
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.AlertMessage), {
        variant: "info",
        title: `The ${pendingParty === "seller" ? "Buyer" : "Seller"} proposed a settlement`,
        msg: message
    });
};
var $c3980034f2f35b2a$export$2e2bcd8739ae039 = $c3980034f2f35b2a$var$SettlementInfo;


const $e99e14d4f57689b3$var$index = ({})=>{
    const { status: status } = (0, $4d51476fd708038f$export$57f2782cc8cecbb0)();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            status === "WaitingSettlementSeller" ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $c3980034f2f35b2a$export$2e2bcd8739ae039), {
                pendingParty: "seller"
            }) : null,
            status === "WaitingSettlementBuyer" ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $c3980034f2f35b2a$export$2e2bcd8739ae039), {
                pendingParty: "buyer"
            }) : null,
            status === "WaitingSeller" ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $7869c01013a0c2af$export$2e2bcd8739ae039), {
                pendingParty: "seller"
            }) : null,
            status === "WaitingBuyer" ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $7869c01013a0c2af$export$2e2bcd8739ae039), {
                pendingParty: "buyer"
            }) : null,
            status === "DisputeCreated" ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $9e6f67befb3a7a7f$export$2e2bcd8739ae039), {}) : null
        ]
    });
};
var $e99e14d4f57689b3$export$2e2bcd8739ae039 = $e99e14d4f57689b3$var$index;





const $c1f80cf802d4b8ef$var$escrowParametersQuery = (0, $119c854c1b94ec44$export$1eb4e7c0ed67b035)`
  query EscrowParametersDetails($id: ID!) {
    escrowParameters(id: $id) {
      id
      feeTimeout
      settlementTimeout
      arbitratorExtraData
    }
  }
`;
const $c1f80cf802d4b8ef$export$e41696b6e0a8ba36 = ()=>{
    const { graphqlBatcher: graphqlBatcher } = (0, $6dabd7de11302893$export$45728877641088dc)();
    return (0, $8c6a367513f3f9c5$export$dd0a697e1782aedd)({
        queryKey: [
            "useEscrowParametersQuery"
        ],
        queryFn: async ()=>await graphqlBatcher.fetch({
                id: crypto.randomUUID(),
                document: $c1f80cf802d4b8ef$var$escrowParametersQuery,
                variables: {
                    id: "singleton"
                }
            })
    });
};




const $44046893db6e1fea$var$KLEROS_CORE_ADDRESS = "0xA54e7A16d7460e38a8F324eF46782FB520d58CE8";
const $44046893db6e1fea$var$KLEROS_CORE_ABI = [
    {
        constant: true,
        inputs: [
            {
                name: "_extraData",
                type: "bytes"
            }
        ],
        name: "arbitrationCost",
        outputs: [
            {
                name: "cost",
                type: "uint256"
            }
        ],
        payable: false,
        stateMutability: "view",
        type: "function"
    }
];
const $44046893db6e1fea$export$9fb8ed4da1003256 = (arbitratorExtraData)=>{
    const { data: data, isError: isError, isLoading: isLoading } = (0, $b9a08c139e2d6879$export$6f78c1774963fe2d)({
        address: $44046893db6e1fea$var$KLEROS_CORE_ADDRESS,
        abi: $44046893db6e1fea$var$KLEROS_CORE_ABI,
        functionName: "arbitrationCost",
        args: [
            arbitratorExtraData
        ]
    });
    return {
        arbitrationCost: data ? data : null,
        isLoading: isLoading,
        isError: isError
    };
};





const $5b6cd79eb0e584ba$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div``;
const $5b6cd79eb0e584ba$var$OverviewContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;
const $5b6cd79eb0e584ba$var$Header = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).h1`
  margin-bottom: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(16, 48)};
`;
const $5b6cd79eb0e584ba$var$TransactionDetails = ()=>{
    const { id: id } = (0, $cb6812e0fa529c57$export$99eaa27ddbbb95ef)();
    const { data: transactionDetails } = (0, $1f6a4b7374e194ad$export$1be7720ad3c07e60)(id);
    const { data: escrowParameters } = (0, $c1f80cf802d4b8ef$export$e41696b6e0a8ba36)();
    const { arbitrationCost: arbitrationCost } = (0, $44046893db6e1fea$export$9fb8ed4da1003256)(escrowParameters?.escrowParameters?.arbitratorExtraData);
    const nativeTokenSymbol = (0, $1c28f538a7a87c87$export$e53e2a70ea774bf2)();
    const { tokenMetadata: tokenMetadata } = (0, $8aab0ec431048b51$export$9d829cdfbbd34b71)(transactionDetails?.escrow?.token);
    const erc20TokenSymbol = tokenMetadata?.symbol;
    const { setTransactionDetails: setTransactionDetails } = (0, $4d51476fd708038f$export$57f2782cc8cecbb0)();
    const { timestamp: timestamp, transactionUri: transactionUri, amount: amount, deadline: deadline, token: token, seller: seller, buyer: buyer, status: status, payments: payments, hasToPayFees: hasToPayFees, settlementProposals: settlementProposals, disputeRequest: disputeRequest, resolvedEvents: resolvedEvents } = (0, $4d51476fd708038f$export$57f2782cc8cecbb0)();
    const transactionInfo = (0, $47ed2dc0909781d5$export$2e2bcd8739ae039)(transactionUri);
    const assetSymbol = token ? erc20TokenSymbol : nativeTokenSymbol;
    (0, $9nZCP.useEffect)(()=>{
        if (transactionDetails?.escrow) {
            const detailsWithSymbol = {
                ...transactionDetails.escrow,
                assetSymbol: assetSymbol
            };
            setTransactionDetails(detailsWithSymbol);
        }
    }, [
        transactionDetails,
        setTransactionDetails,
        assetSymbol
    ]);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($5b6cd79eb0e584ba$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($5b6cd79eb0e584ba$var$Header, {
                children: [
                    "Transaction #",
                    id
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($5b6cd79eb0e584ba$var$OverviewContainer, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $57ea835644a1b14d$export$2e2bcd8739ae039), {
                        escrowType: "general",
                        escrowTitle: transactionInfo?.title,
                        deliverableText: transactionInfo?.description,
                        extraDescriptionUri: transactionInfo?.extraDescriptionUri,
                        receivingQuantity: "",
                        buyerAddress: buyer,
                        sellerAddress: seller,
                        transactionCreationTimestamp: timestamp,
                        sendingQuantity: !(0, $c62bd748620e6ea9$export$fce6876652108ab)(amount) ? (0, $c6heD.formatEther)(amount) : "",
                        deadline: deadline * 1000,
                        overrideIsList: false,
                        amount: !(0, $c62bd748620e6ea9$export$fce6876652108ab)(amount) ? (0, $c6heD.formatEther)(amount) : "",
                        isPreview: false,
                        feeTimeout: escrowParameters?.escrowParameters.feeTimeout,
                        settlementTimeout: escrowParameters?.escrowParameters.settlementTimeout,
                        status: status,
                        token: token,
                        payments: payments,
                        settlementProposals: settlementProposals,
                        hasToPayFees: hasToPayFees,
                        disputeRequest: disputeRequest,
                        resolvedEvents: resolvedEvents,
                        arbitrationCost: arbitrationCost,
                        assetSymbol: assetSymbol
                    }),
                    status === "NoDispute" && payments?.length === 0 ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $d35d9ba34e04a154$export$2e2bcd8739ae039), {}) : null,
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e99e14d4f57689b3$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $5b6cd79eb0e584ba$export$2e2bcd8739ae039 = $5b6cd79eb0e584ba$var$TransactionDetails;



const $8fd3c9a3423b5095$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  width: 100%;
  background-color: ${({ theme: theme })=>theme.lightBackground};
  padding: calc(24px + (136 - 24) * (min(max(100vw, 375px), 1250px) - 375px) / 875);
  padding-top: calc(32px + (80 - 32) * (min(max(100vw, 375px), 1250px) - 375px) / 875);
  padding-bottom: calc(76px + (96 - 76) * (min(max(100vw, 375px), 1250px) - 375px) / 875);
  max-width: 1780px;
  margin: 0 auto;
`;
const $8fd3c9a3423b5095$export$535c19cae08ba30f = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: ${({ theme: theme })=>theme.primaryText};
`;
const $8fd3c9a3423b5095$var$Dashboard = ()=>{
    const { isConnected: isConnected } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    const { chain: chain } = (0, $b9a08c139e2d6879$export$553aaf59afc1a2d8)();
    const isOnSupportedChain = chain?.id === (0, $a5583d98c7d1626b$export$8372812df8e8183f);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($8fd3c9a3423b5095$var$Container, {
        children: isConnected && isOnSupportedChain ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $cb6812e0fa529c57$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cb6812e0fa529c57$export$e7b0ac011bb776c6), {
                    path: "/display/:page/:order/:filter",
                    element: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $93434f328c14df6d$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cb6812e0fa529c57$export$e7b0ac011bb776c6), {
                    path: "/:id/*",
                    element: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $4d51476fd708038f$export$677eeb85ea74455b), {
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $5b6cd79eb0e584ba$export$2e2bcd8739ae039), {})
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($8fd3c9a3423b5095$export$535c19cae08ba30f, {
            children: [
                "To see your transactions, connect first and switch to the supported chain",
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("hr", {}),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $114c356563326614$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $8fd3c9a3423b5095$export$2e2bcd8739ae039 = $8fd3c9a3423b5095$var$Dashboard;




const $e27f649357e3c391$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${({ theme: theme })=>theme.lightBackground};
  padding: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(24, 32)};
  padding-top: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(36, 42)};
  padding-bottom: ${(0, $b2736651d1fdc941$export$1b3e91ab3ce1a831)(76, 96)};
  max-width: 1780px;
  margin: 0 auto;
`;
const $e27f649357e3c391$var$MiddleContentContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
`;
const $e27f649357e3c391$var$NewTransaction = ()=>{
    const location = (0, $cb6812e0fa529c57$export$45d76561a5302f2b)();
    const { width: width } = (0, $3bc11a3cff85be60$export$2e2bcd8739ae039)();
    const { isConnected: isConnected } = (0, $b9a08c139e2d6879$export$83a8e409853da004)();
    const { chain: chain } = (0, $b9a08c139e2d6879$export$553aaf59afc1a2d8)();
    const isPreviewPage = location.pathname.includes("/preview");
    const isMobileView = width <= (0, $fbf3a9d90d422861$export$4cf8c0e020b1f8b2);
    const isOnSupportedChain = chain?.id === (0, $a5583d98c7d1626b$export$8372812df8e8183f);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            !isPreviewPage || isMobileView ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $5001e16adf52ef6e$export$2e2bcd8739ae039), {}) : null,
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($e27f649357e3c391$var$Container, {
                children: [
                    isConnected && isOnSupportedChain && !isPreviewPage ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $5e742a98f45308c5$export$2e2bcd8739ae039), {}) : null,
                    isConnected && isOnSupportedChain ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $bc945762aaa88e21$export$997aa44fa3e3c31), {
                        message: "Sign a message to verify yourself.",
                        buttonText: "Verify",
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($e27f649357e3c391$var$MiddleContentContainer, {
                            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $cb6812e0fa529c57$export$3565eb3d00ca5a74), {
                                children: [
                                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cb6812e0fa529c57$export$e7b0ac011bb776c6), {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cb6812e0fa529c57$export$444b3ab0cb9aec40), {
                                            to: "escrow-type",
                                            replace: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cb6812e0fa529c57$export$e7b0ac011bb776c6), {
                                        path: "/escrow-type/*",
                                        element: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $8e926da7d46a5318$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cb6812e0fa529c57$export$e7b0ac011bb776c6), {
                                        path: "/title/*",
                                        element: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $46b299fcafadba5e$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cb6812e0fa529c57$export$e7b0ac011bb776c6), {
                                        path: "/deliverable/*",
                                        element: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $640d4adaf86d9f46$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cb6812e0fa529c57$export$e7b0ac011bb776c6), {
                                        path: "/payment/*",
                                        element: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cd9a14b676c1854f$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cb6812e0fa529c57$export$e7b0ac011bb776c6), {
                                        path: "/deadline/*",
                                        element: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $5d9c633f31e83173$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cb6812e0fa529c57$export$e7b0ac011bb776c6), {
                                        path: "/notifications/*",
                                        element: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $47143f5a1b03db38$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cb6812e0fa529c57$export$e7b0ac011bb776c6), {
                                        path: "/preview/*",
                                        element: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $d4de675bf8395fa4$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            })
                        })
                    }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $8fd3c9a3423b5095$export$535c19cae08ba30f), {
                        children: [
                            "To create a new escrow transaction, connect first and switch to the supported chain",
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("hr", {}),
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $114c356563326614$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            })
        ]
    });
};
var $e27f649357e3c391$export$2e2bcd8739ae039 = $e27f649357e3c391$var$NewTransaction;




const $7cf329a89708da12$var$App = ()=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $8416457fc13d8fca$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $e1e67658a6d492c4$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $c5691ed31ffeb609$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $6dabd7de11302893$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $93cb5c29b614ea9a$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $42c890363ed32eb3$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $fa4dc73a0abb4258$export$28e9744f9c6a92c7), {
                                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $db670e23ef84c511$export$22a2709142043366), {
                                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $cb6812e0fa529c57$export$e7b0ac011bb776c6), {
                                        path: "/",
                                        element: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $edb852177c47345e$export$2e2bcd8739ae039), {}),
                                        children: [
                                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cb6812e0fa529c57$export$e7b0ac011bb776c6), {
                                                index: true,
                                                element: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cb6812e0fa529c57$export$444b3ab0cb9aec40), {
                                                    to: "new-transaction",
                                                    replace: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cb6812e0fa529c57$export$e7b0ac011bb776c6), {
                                                path: "new-transaction/*",
                                                element: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e27f649357e3c391$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cb6812e0fa529c57$export$e7b0ac011bb776c6), {
                                                path: "my-transactions/*",
                                                element: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $8fd3c9a3423b5095$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $cb6812e0fa529c57$export$e7b0ac011bb776c6), {
                                                path: "*",
                                                element: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("h1", {
                                                    children: "404 not found"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
};
var $7cf329a89708da12$export$2e2bcd8739ae039 = $7cf329a89708da12$var$App;


var $1e156356cfe6a768$exports = {};
"use strict";
Object.defineProperty($1e156356cfe6a768$exports, "__esModule", {
    value: true
});
var $d0b0b2f8690f8b25$exports = {};
"use strict";
Object.defineProperty($d0b0b2f8690f8b25$exports, "__esModule", {
    value: true
});
$d0b0b2f8690f8b25$exports.bodyOpenClassName = $d0b0b2f8690f8b25$exports.portalClassName = undefined;
var $d0b0b2f8690f8b25$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $d0b0b2f8690f8b25$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $9nZCP = parcelRequire("9nZCP");
var $d0b0b2f8690f8b25$var$_react2 = $d0b0b2f8690f8b25$var$_interopRequireDefault($9nZCP);

var $d0b0b2f8690f8b25$var$_reactDom2 = $d0b0b2f8690f8b25$var$_interopRequireDefault($06928105ffc753ea$exports);

var $d0b0b2f8690f8b25$var$_propTypes2 = $d0b0b2f8690f8b25$var$_interopRequireDefault($0287d6dd1c5d0193$exports);
var $40c9c6397b0ffa5b$exports = {};
"use strict";
Object.defineProperty($40c9c6397b0ffa5b$exports, "__esModule", {
    value: true
});
var $40c9c6397b0ffa5b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $40c9c6397b0ffa5b$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $40c9c6397b0ffa5b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $9nZCP = parcelRequire("9nZCP");

var $40c9c6397b0ffa5b$var$_propTypes2 = $40c9c6397b0ffa5b$var$_interopRequireDefault($0287d6dd1c5d0193$exports);
var $1db3fe9ba8e71710$exports = {};
"use strict";
Object.defineProperty($1db3fe9ba8e71710$exports, "__esModule", {
    value: true
});
$1db3fe9ba8e71710$exports.resetState = $1db3fe9ba8e71710$var$resetState;
$1db3fe9ba8e71710$exports.log = $1db3fe9ba8e71710$var$log;
$1db3fe9ba8e71710$exports.handleBlur = $1db3fe9ba8e71710$var$handleBlur;
$1db3fe9ba8e71710$exports.handleFocus = $1db3fe9ba8e71710$var$handleFocus;
$1db3fe9ba8e71710$exports.markForFocusLater = $1db3fe9ba8e71710$var$markForFocusLater;
$1db3fe9ba8e71710$exports.returnFocus = $1db3fe9ba8e71710$var$returnFocus;
$1db3fe9ba8e71710$exports.popWithoutFocus = $1db3fe9ba8e71710$var$popWithoutFocus;
$1db3fe9ba8e71710$exports.setupScopedFocus = $1db3fe9ba8e71710$var$setupScopedFocus;
$1db3fe9ba8e71710$exports.teardownScopedFocus = $1db3fe9ba8e71710$var$teardownScopedFocus;
var $587f9bbebf7310e2$exports = {};
"use strict";
Object.defineProperty($587f9bbebf7310e2$exports, "__esModule", {
    value: true
});
$587f9bbebf7310e2$exports.default = $587f9bbebf7310e2$var$findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */ var $587f9bbebf7310e2$var$DISPLAY_NONE = "none";
var $587f9bbebf7310e2$var$DISPLAY_CONTENTS = "contents";
var $587f9bbebf7310e2$var$tabbableNode = /input|select|textarea|button|object|iframe/;
function $587f9bbebf7310e2$var$isNotOverflowing(element, style) {
    return style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    element.scrollWidth <= 0 && element.scrollHeight <= 0;
}
function $587f9bbebf7310e2$var$hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    // If the node is empty, this is good enough
    if (zeroSize && !element.innerHTML) return true;
    try {
        // Otherwise we need to check some styles
        var style = window.getComputedStyle(element);
        var displayValue = style.getPropertyValue("display");
        return zeroSize ? displayValue !== $587f9bbebf7310e2$var$DISPLAY_CONTENTS && $587f9bbebf7310e2$var$isNotOverflowing(element, style) : displayValue === $587f9bbebf7310e2$var$DISPLAY_NONE;
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.warn("Failed to inspect element style");
        return false;
    }
}
function $587f9bbebf7310e2$var$visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while(parentElement){
        if (parentElement === document.body) break;
        // if we are not hidden yet, skip to checking outside the Web Component
        if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
        if ($587f9bbebf7310e2$var$hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function $587f9bbebf7310e2$var$focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = $587f9bbebf7310e2$var$tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && $587f9bbebf7310e2$var$visible(element);
}
function $587f9bbebf7310e2$var$tabbable(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && $587f9bbebf7310e2$var$focusable(element, !isTabIndexNaN);
}
function $587f9bbebf7310e2$var$findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
        return finished.concat(!el.shadowRoot ? [
            el
        ] : $587f9bbebf7310e2$var$findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter($587f9bbebf7310e2$var$tabbable);
}
$587f9bbebf7310e2$exports = $587f9bbebf7310e2$exports["default"];


var $1db3fe9ba8e71710$var$_tabbable2 = $1db3fe9ba8e71710$var$_interopRequireDefault($587f9bbebf7310e2$exports);
function $1db3fe9ba8e71710$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1db3fe9ba8e71710$var$focusLaterElements = [];
var $1db3fe9ba8e71710$var$modalElement = null;
var $1db3fe9ba8e71710$var$needToFocus = false;
/* eslint-disable no-console */ /* istanbul ignore next */ function $1db3fe9ba8e71710$var$resetState() {
    $1db3fe9ba8e71710$var$focusLaterElements = [];
}
/* istanbul ignore next */ function $1db3fe9ba8e71710$var$log() {}
/* eslint-enable no-console */ function $1db3fe9ba8e71710$var$handleBlur() {
    $1db3fe9ba8e71710$var$needToFocus = true;
}
function $1db3fe9ba8e71710$var$handleFocus() {
    if ($1db3fe9ba8e71710$var$needToFocus) {
        $1db3fe9ba8e71710$var$needToFocus = false;
        if (!$1db3fe9ba8e71710$var$modalElement) return;
        // need to see how jQuery shims document.on('focusin') so we don't need the
        // setTimeout, firefox doesn't support focusin, if it did, we could focus
        // the element outside of a setTimeout. Side-effect of this implementation
        // is that the document.body gets focus, and then we focus our element right
        // after, seems fine.
        setTimeout(function() {
            if ($1db3fe9ba8e71710$var$modalElement.contains(document.activeElement)) return;
            var el = (0, $1db3fe9ba8e71710$var$_tabbable2.default)($1db3fe9ba8e71710$var$modalElement)[0] || $1db3fe9ba8e71710$var$modalElement;
            el.focus();
        }, 0);
    }
}
function $1db3fe9ba8e71710$var$markForFocusLater() {
    $1db3fe9ba8e71710$var$focusLaterElements.push(document.activeElement);
}
/* eslint-disable no-console */ function $1db3fe9ba8e71710$var$returnFocus() {
    var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var toFocus = null;
    try {
        if ($1db3fe9ba8e71710$var$focusLaterElements.length !== 0) {
            toFocus = $1db3fe9ba8e71710$var$focusLaterElements.pop();
            toFocus.focus({
                preventScroll: preventScroll
            });
        }
        return;
    } catch (e) {
        console.warn([
            "You tried to return focus to",
            toFocus,
            "but it is not in the DOM anymore"
        ].join(" "));
    }
}
/* eslint-enable no-console */ function $1db3fe9ba8e71710$var$popWithoutFocus() {
    $1db3fe9ba8e71710$var$focusLaterElements.length > 0 && $1db3fe9ba8e71710$var$focusLaterElements.pop();
}
function $1db3fe9ba8e71710$var$setupScopedFocus(element) {
    $1db3fe9ba8e71710$var$modalElement = element;
    if (window.addEventListener) {
        window.addEventListener("blur", $1db3fe9ba8e71710$var$handleBlur, false);
        document.addEventListener("focus", $1db3fe9ba8e71710$var$handleFocus, true);
    } else {
        window.attachEvent("onBlur", $1db3fe9ba8e71710$var$handleBlur);
        document.attachEvent("onFocus", $1db3fe9ba8e71710$var$handleFocus);
    }
}
function $1db3fe9ba8e71710$var$teardownScopedFocus() {
    $1db3fe9ba8e71710$var$modalElement = null;
    if (window.addEventListener) {
        window.removeEventListener("blur", $1db3fe9ba8e71710$var$handleBlur);
        document.removeEventListener("focus", $1db3fe9ba8e71710$var$handleFocus);
    } else {
        window.detachEvent("onBlur", $1db3fe9ba8e71710$var$handleBlur);
        document.detachEvent("onFocus", $1db3fe9ba8e71710$var$handleFocus);
    }
}


var $40c9c6397b0ffa5b$var$focusManager = $40c9c6397b0ffa5b$var$_interopRequireWildcard($1db3fe9ba8e71710$exports);
var $19685846b97e0df5$exports = {};
"use strict";
Object.defineProperty($19685846b97e0df5$exports, "__esModule", {
    value: true
});
$19685846b97e0df5$exports.default = $19685846b97e0df5$var$scopeTab;

var $19685846b97e0df5$var$_tabbable2 = $19685846b97e0df5$var$_interopRequireDefault($587f9bbebf7310e2$exports);
function $19685846b97e0df5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $19685846b97e0df5$var$getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    return el.activeElement.shadowRoot ? $19685846b97e0df5$var$getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}
function $19685846b97e0df5$var$scopeTab(node, event) {
    var tabbable = (0, $19685846b97e0df5$var$_tabbable2.default)(node);
    if (!tabbable.length) {
        // Do nothing, since there are no elements that can receive focus.
        event.preventDefault();
        return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable[0];
    var tail = tabbable[tabbable.length - 1];
    var activeElement = $19685846b97e0df5$var$getActiveElement();
    // proceed with default browser behavior on tab.
    // Focus on last element on shift + tab.
    if (node === activeElement) {
        if (!shiftKey) return;
        target = tail;
    }
    if (tail === activeElement && !shiftKey) target = head;
    if (head === activeElement && shiftKey) target = tail;
    if (target) {
        event.preventDefault();
        target.focus();
        return;
    }
    // Safari radio issue.
    //
    // Safari does not move the focus to the radio button,
    // so we need to force it to really walk through all elements.
    //
    // This is very error prone, since we are trying to guess
    // if it is a safari browser from the first occurence between
    // chrome or safari.
    //
    // The chrome user agent contains the first ocurrence
    // as the 'chrome/version' and later the 'safari/version'.
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    // If we are not in safari desktop, let the browser control
    // the focus
    if (!isSafariDesktop) return;
    var x = tabbable.indexOf(activeElement);
    if (x > -1) x += shiftKey ? -1 : 1;
    target = tabbable[x];
    // If the tabbable element does not exist,
    // focus head/tail based on shiftKey
    if (typeof target === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
    }
    event.preventDefault();
    target.focus();
}
$19685846b97e0df5$exports = $19685846b97e0df5$exports["default"];


var $40c9c6397b0ffa5b$var$_scopeTab2 = $40c9c6397b0ffa5b$var$_interopRequireDefault($19685846b97e0df5$exports);
var $d6571eab8a22de89$exports = {};
"use strict";
Object.defineProperty($d6571eab8a22de89$exports, "__esModule", {
    value: true
});
$d6571eab8a22de89$exports.resetState = $d6571eab8a22de89$var$resetState;
$d6571eab8a22de89$exports.log = $d6571eab8a22de89$var$log;
$d6571eab8a22de89$exports.assertNodeList = $d6571eab8a22de89$var$assertNodeList;
$d6571eab8a22de89$exports.setElement = $d6571eab8a22de89$var$setElement;
$d6571eab8a22de89$exports.validateElement = $d6571eab8a22de89$var$validateElement;
$d6571eab8a22de89$exports.hide = $d6571eab8a22de89$var$hide;
$d6571eab8a22de89$exports.show = $d6571eab8a22de89$var$show;
$d6571eab8a22de89$exports.documentNotReadyOrSSRTesting = $d6571eab8a22de89$var$documentNotReadyOrSSRTesting;
var $e76d3fbba0413046$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $e76d3fbba0413046$var$__DEV__ = false;
var $e76d3fbba0413046$var$warning = function() {};
if ($e76d3fbba0413046$var$__DEV__) {
    var $e76d3fbba0413046$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $e76d3fbba0413046$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $e76d3fbba0413046$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$e76d3fbba0413046$exports = $e76d3fbba0413046$var$warning;


var $d6571eab8a22de89$var$_warning2 = $d6571eab8a22de89$var$_interopRequireDefault($e76d3fbba0413046$exports);
var $fe466a6806dbcfa6$exports = {};
"use strict";
Object.defineProperty($fe466a6806dbcfa6$exports, "__esModule", {
    value: true
});
$fe466a6806dbcfa6$exports.canUseDOM = $fe466a6806dbcfa6$exports.SafeNodeList = $fe466a6806dbcfa6$exports.SafeHTMLCollection = undefined;
var $adfb37cb0e40d4eb$exports = {};
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    "use strict";
    var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== "undefined",
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === "function" && typeof define.amd === "object" && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, $adfb37cb0e40d4eb$exports) $adfb37cb0e40d4eb$exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();


var $fe466a6806dbcfa6$var$_exenv2 = $fe466a6806dbcfa6$var$_interopRequireDefault($adfb37cb0e40d4eb$exports);
function $fe466a6806dbcfa6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fe466a6806dbcfa6$var$EE = $fe466a6806dbcfa6$var$_exenv2.default;
var $fe466a6806dbcfa6$var$SafeHTMLElement = $fe466a6806dbcfa6$var$EE.canUseDOM ? window.HTMLElement : {};
var $fe466a6806dbcfa6$var$SafeHTMLCollection = $fe466a6806dbcfa6$exports.SafeHTMLCollection = $fe466a6806dbcfa6$var$EE.canUseDOM ? window.HTMLCollection : {};
var $fe466a6806dbcfa6$var$SafeNodeList = $fe466a6806dbcfa6$exports.SafeNodeList = $fe466a6806dbcfa6$var$EE.canUseDOM ? window.NodeList : {};
var $fe466a6806dbcfa6$var$canUseDOM = $fe466a6806dbcfa6$exports.canUseDOM = $fe466a6806dbcfa6$var$EE.canUseDOM;
$fe466a6806dbcfa6$exports.default = $fe466a6806dbcfa6$var$SafeHTMLElement;


function $d6571eab8a22de89$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d6571eab8a22de89$var$globalElement = null;
/* eslint-disable no-console */ /* istanbul ignore next */ function $d6571eab8a22de89$var$resetState() {
    if ($d6571eab8a22de89$var$globalElement) {
        if ($d6571eab8a22de89$var$globalElement.removeAttribute) $d6571eab8a22de89$var$globalElement.removeAttribute("aria-hidden");
        else if ($d6571eab8a22de89$var$globalElement.length != null) $d6571eab8a22de89$var$globalElement.forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
        else document.querySelectorAll($d6571eab8a22de89$var$globalElement).forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
    }
    $d6571eab8a22de89$var$globalElement = null;
}
/* istanbul ignore next */ function $d6571eab8a22de89$var$log() {
    var check;
}
/* eslint-enable no-console */ function $d6571eab8a22de89$var$assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) throw new Error("react-modal: No elements were found for selector " + selector + ".");
}
function $d6571eab8a22de89$var$setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && $fe466a6806dbcfa6$exports.canUseDOM) {
        var el = document.querySelectorAll(useElement);
        $d6571eab8a22de89$var$assertNodeList(el, useElement);
        useElement = el;
    }
    $d6571eab8a22de89$var$globalElement = useElement || $d6571eab8a22de89$var$globalElement;
    return $d6571eab8a22de89$var$globalElement;
}
function $d6571eab8a22de89$var$validateElement(appElement) {
    var el = appElement || $d6571eab8a22de89$var$globalElement;
    if (el) return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [
        el
    ];
    else {
        (0, $d6571eab8a22de89$var$_warning2.default)(false, [
            "react-modal: App element is not defined.",
            "Please use `Modal.setAppElement(el)` or set `appElement={el}`.",
            "This is needed so screen readers don't see main content",
            "when modal is opened. It is not recommended, but you can opt-out",
            "by setting `ariaHideApp={false}`."
        ].join(" "));
        return [];
    }
}
function $d6571eab8a22de89$var$hide(appElement) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = $d6571eab8a22de89$var$validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var el = _step.value;
            el.setAttribute("aria-hidden", "true");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
}
function $d6571eab8a22de89$var$show(appElement) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = $d6571eab8a22de89$var$validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var el = _step2.value;
            el.removeAttribute("aria-hidden");
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
}
function $d6571eab8a22de89$var$documentNotReadyOrSSRTesting() {
    $d6571eab8a22de89$var$globalElement = null;
}


var $40c9c6397b0ffa5b$var$ariaAppHider = $40c9c6397b0ffa5b$var$_interopRequireWildcard($d6571eab8a22de89$exports);
var $ffbb5572801eb55e$exports = {};
"use strict";
Object.defineProperty($ffbb5572801eb55e$exports, "__esModule", {
    value: true
});
$ffbb5572801eb55e$exports.resetState = $ffbb5572801eb55e$var$resetState;
$ffbb5572801eb55e$exports.log = $ffbb5572801eb55e$var$log;
var $ffbb5572801eb55e$var$htmlClassList = {};
var $ffbb5572801eb55e$var$docBodyClassList = {};
/* eslint-disable no-console */ /* istanbul ignore next */ function $ffbb5572801eb55e$var$removeClass(at, cls) {
    at.classList.remove(cls);
}
/* istanbul ignore next */ function $ffbb5572801eb55e$var$resetState() {
    var htmlElement = document.getElementsByTagName("html")[0];
    for(var cls in $ffbb5572801eb55e$var$htmlClassList)$ffbb5572801eb55e$var$removeClass(htmlElement, $ffbb5572801eb55e$var$htmlClassList[cls]);
    var body = document.body;
    for(var _cls in $ffbb5572801eb55e$var$docBodyClassList)$ffbb5572801eb55e$var$removeClass(body, $ffbb5572801eb55e$var$docBodyClassList[_cls]);
    $ffbb5572801eb55e$var$htmlClassList = {};
    $ffbb5572801eb55e$var$docBodyClassList = {};
}
/* istanbul ignore next */ function $ffbb5572801eb55e$var$log() {
    var classes, buffer, x, _x;
}
/* eslint-enable no-console */ /**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $ffbb5572801eb55e$var$incrementReference = function incrementReference(poll, className) {
    if (!poll[className]) poll[className] = 0;
    poll[className] += 1;
    return className;
};
/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $ffbb5572801eb55e$var$decrementReference = function decrementReference(poll, className) {
    if (poll[className]) poll[className] -= 1;
    return className;
};
/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */ var $ffbb5572801eb55e$var$trackClass = function trackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $ffbb5572801eb55e$var$incrementReference(poll, className);
        classListRef.add(className);
    });
};
/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */ var $ffbb5572801eb55e$var$untrackClass = function untrackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $ffbb5572801eb55e$var$decrementReference(poll, className);
        poll[className] === 0 && classListRef.remove(className);
    });
};
/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $ffbb5572801eb55e$var$add = $ffbb5572801eb55e$exports.add = function add(element, classString) {
    return $ffbb5572801eb55e$var$trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $ffbb5572801eb55e$var$htmlClassList : $ffbb5572801eb55e$var$docBodyClassList, classString.split(" "));
};
/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $ffbb5572801eb55e$var$remove = $ffbb5572801eb55e$exports.remove = function remove(element, classString) {
    return $ffbb5572801eb55e$var$untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $ffbb5572801eb55e$var$htmlClassList : $ffbb5572801eb55e$var$docBodyClassList, classString.split(" "));
};


var $40c9c6397b0ffa5b$var$classList = $40c9c6397b0ffa5b$var$_interopRequireWildcard($ffbb5572801eb55e$exports);

var $40c9c6397b0ffa5b$var$_safeHTMLElement2 = $40c9c6397b0ffa5b$var$_interopRequireDefault($fe466a6806dbcfa6$exports);
var $1dda8ece0749af9c$exports = {};
"use strict";
Object.defineProperty($1dda8ece0749af9c$exports, "__esModule", {
    value: true
});
$1dda8ece0749af9c$exports.log = $1dda8ece0749af9c$var$log;
$1dda8ece0749af9c$exports.resetState = $1dda8ece0749af9c$var$resetState;
function $1dda8ece0749af9c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
// Tracks portals that are open and emits events to subscribers
var $1dda8ece0749af9c$var$PortalOpenInstances = function PortalOpenInstances() {
    var _this = this;
    $1dda8ece0749af9c$var$_classCallCheck(this, PortalOpenInstances);
    this.register = function(openInstance) {
        if (_this.openInstances.indexOf(openInstance) !== -1) return;
        _this.openInstances.push(openInstance);
        _this.emit("register");
    };
    this.deregister = function(openInstance) {
        var index = _this.openInstances.indexOf(openInstance);
        if (index === -1) return;
        _this.openInstances.splice(index, 1);
        _this.emit("deregister");
    };
    this.subscribe = function(callback) {
        _this.subscribers.push(callback);
    };
    this.emit = function(eventType) {
        _this.subscribers.forEach(function(subscriber) {
            return subscriber(eventType, // shallow copy to avoid accidental mutation
            _this.openInstances.slice());
        });
    };
    this.openInstances = [];
    this.subscribers = [];
};
var $1dda8ece0749af9c$var$portalOpenInstances = new $1dda8ece0749af9c$var$PortalOpenInstances();
/* eslint-disable no-console */ /* istanbul ignore next */ function $1dda8ece0749af9c$var$log() {
    console.log("portalOpenInstances ----------");
    console.log($1dda8ece0749af9c$var$portalOpenInstances.openInstances.length);
    $1dda8ece0749af9c$var$portalOpenInstances.openInstances.forEach(function(p) {
        return console.log(p);
    });
    console.log("end portalOpenInstances ----------");
}
/* istanbul ignore next */ function $1dda8ece0749af9c$var$resetState() {
    $1dda8ece0749af9c$var$portalOpenInstances = new $1dda8ece0749af9c$var$PortalOpenInstances();
}
/* eslint-enable no-console */ $1dda8ece0749af9c$exports.default = $1dda8ece0749af9c$var$portalOpenInstances;


var $40c9c6397b0ffa5b$var$_portalOpenInstances2 = $40c9c6397b0ffa5b$var$_interopRequireDefault($1dda8ece0749af9c$exports);
var $3db0c479beb24d6a$exports = {};
"use strict";
Object.defineProperty($3db0c479beb24d6a$exports, "__esModule", {
    value: true
});
$3db0c479beb24d6a$exports.resetState = $3db0c479beb24d6a$var$resetState;
$3db0c479beb24d6a$exports.log = $3db0c479beb24d6a$var$log;

var $3db0c479beb24d6a$var$_portalOpenInstances2 = $3db0c479beb24d6a$var$_interopRequireDefault($1dda8ece0749af9c$exports);
function $3db0c479beb24d6a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Body focus trap see Issue #742
var $3db0c479beb24d6a$var$before = void 0, $3db0c479beb24d6a$var$after = void 0, $3db0c479beb24d6a$var$instances = [];
/* eslint-disable no-console */ /* istanbul ignore next */ function $3db0c479beb24d6a$var$resetState() {
    var _arr = [
        $3db0c479beb24d6a$var$before,
        $3db0c479beb24d6a$var$after
    ];
    for(var _i = 0; _i < _arr.length; _i++){
        var item = _arr[_i];
        if (!item) continue;
        item.parentNode && item.parentNode.removeChild(item);
    }
    $3db0c479beb24d6a$var$before = $3db0c479beb24d6a$var$after = null;
    $3db0c479beb24d6a$var$instances = [];
}
/* istanbul ignore next */ function $3db0c479beb24d6a$var$log() {
    console.log("bodyTrap ----------");
    console.log($3db0c479beb24d6a$var$instances.length);
    var _arr2 = [
        $3db0c479beb24d6a$var$before,
        $3db0c479beb24d6a$var$after
    ];
    for(var _i2 = 0; _i2 < _arr2.length; _i2++){
        var item = _arr2[_i2];
        var check = item || {};
        console.log(check.nodeName, check.className, check.id);
    }
    console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */ function $3db0c479beb24d6a$var$focusContent() {
    if ($3db0c479beb24d6a$var$instances.length === 0) return;
    $3db0c479beb24d6a$var$instances[$3db0c479beb24d6a$var$instances.length - 1].focusContent();
}
function $3db0c479beb24d6a$var$bodyTrap(eventType, openInstances) {
    if (!$3db0c479beb24d6a$var$before && !$3db0c479beb24d6a$var$after) {
        $3db0c479beb24d6a$var$before = document.createElement("div");
        $3db0c479beb24d6a$var$before.setAttribute("data-react-modal-body-trap", "");
        $3db0c479beb24d6a$var$before.style.position = "absolute";
        $3db0c479beb24d6a$var$before.style.opacity = "0";
        $3db0c479beb24d6a$var$before.setAttribute("tabindex", "0");
        $3db0c479beb24d6a$var$before.addEventListener("focus", $3db0c479beb24d6a$var$focusContent);
        $3db0c479beb24d6a$var$after = $3db0c479beb24d6a$var$before.cloneNode();
        $3db0c479beb24d6a$var$after.addEventListener("focus", $3db0c479beb24d6a$var$focusContent);
    }
    $3db0c479beb24d6a$var$instances = openInstances;
    if ($3db0c479beb24d6a$var$instances.length > 0) {
        // Add focus trap
        if (document.body.firstChild !== $3db0c479beb24d6a$var$before) document.body.insertBefore($3db0c479beb24d6a$var$before, document.body.firstChild);
        if (document.body.lastChild !== $3db0c479beb24d6a$var$after) document.body.appendChild($3db0c479beb24d6a$var$after);
    } else {
        // Remove focus trap
        if ($3db0c479beb24d6a$var$before.parentElement) $3db0c479beb24d6a$var$before.parentElement.removeChild($3db0c479beb24d6a$var$before);
        if ($3db0c479beb24d6a$var$after.parentElement) $3db0c479beb24d6a$var$after.parentElement.removeChild($3db0c479beb24d6a$var$after);
    }
}
$3db0c479beb24d6a$var$_portalOpenInstances2.default.subscribe($3db0c479beb24d6a$var$bodyTrap);


function $40c9c6397b0ffa5b$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $40c9c6397b0ffa5b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $40c9c6397b0ffa5b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $40c9c6397b0ffa5b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $40c9c6397b0ffa5b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// so that our CSS is statically analyzable
var $40c9c6397b0ffa5b$var$CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
};
/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */ var $40c9c6397b0ffa5b$var$isTabKey = function isTabKey(event) {
    return event.code === "Tab" || event.keyCode === 9;
};
var $40c9c6397b0ffa5b$var$isEscKey = function isEscKey(event) {
    return event.code === "Escape" || event.keyCode === 27;
};
var $40c9c6397b0ffa5b$var$ariaHiddenInstances = 0;
var $40c9c6397b0ffa5b$var$ModalPortal = function(_Component) {
    $40c9c6397b0ffa5b$var$_inherits(ModalPortal, _Component);
    function ModalPortal(props) {
        $40c9c6397b0ffa5b$var$_classCallCheck(this, ModalPortal);
        var _this = $40c9c6397b0ffa5b$var$_possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
        _this.setOverlayRef = function(overlay) {
            _this.overlay = overlay;
            _this.props.overlayRef && _this.props.overlayRef(overlay);
        };
        _this.setContentRef = function(content) {
            _this.content = content;
            _this.props.contentRef && _this.props.contentRef(content);
        };
        _this.afterClose = function() {
            var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName, parentSelector = _this$props.parentSelector;
            var parentDocument = parentSelector && parentSelector().ownerDocument || document;
            // Remove classes.
            bodyOpenClassName && $40c9c6397b0ffa5b$var$classList.remove(parentDocument.body, bodyOpenClassName);
            htmlOpenClassName && $40c9c6397b0ffa5b$var$classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
            // Reset aria-hidden attribute if all modals have been removed
            if (ariaHideApp && $40c9c6397b0ffa5b$var$ariaHiddenInstances > 0) {
                $40c9c6397b0ffa5b$var$ariaHiddenInstances -= 1;
                if ($40c9c6397b0ffa5b$var$ariaHiddenInstances === 0) $40c9c6397b0ffa5b$var$ariaAppHider.show(appElement);
            }
            if (_this.props.shouldFocusAfterRender) {
                if (_this.props.shouldReturnFocusAfterClose) {
                    $40c9c6397b0ffa5b$var$focusManager.returnFocus(_this.props.preventScroll);
                    $40c9c6397b0ffa5b$var$focusManager.teardownScopedFocus();
                } else $40c9c6397b0ffa5b$var$focusManager.popWithoutFocus();
            }
            if (_this.props.onAfterClose) _this.props.onAfterClose();
            $40c9c6397b0ffa5b$var$_portalOpenInstances2.default.deregister(_this);
        };
        _this.open = function() {
            _this.beforeOpen();
            if (_this.state.afterOpen && _this.state.beforeClose) {
                clearTimeout(_this.closeTimer);
                _this.setState({
                    beforeClose: false
                });
            } else {
                if (_this.props.shouldFocusAfterRender) {
                    $40c9c6397b0ffa5b$var$focusManager.setupScopedFocus(_this.node);
                    $40c9c6397b0ffa5b$var$focusManager.markForFocusLater();
                }
                _this.setState({
                    isOpen: true
                }, function() {
                    _this.openAnimationFrame = requestAnimationFrame(function() {
                        _this.setState({
                            afterOpen: true
                        });
                        if (_this.props.isOpen && _this.props.onAfterOpen) _this.props.onAfterOpen({
                            overlayEl: _this.overlay,
                            contentEl: _this.content
                        });
                    });
                });
            }
        };
        _this.close = function() {
            if (_this.props.closeTimeoutMS > 0) _this.closeWithTimeout();
            else _this.closeWithoutTimeout();
        };
        _this.focusContent = function() {
            return _this.content && !_this.contentHasFocus() && _this.content.focus({
                preventScroll: true
            });
        };
        _this.closeWithTimeout = function() {
            var closesAt = Date.now() + _this.props.closeTimeoutMS;
            _this.setState({
                beforeClose: true,
                closesAt: closesAt
            }, function() {
                _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
            });
        };
        _this.closeWithoutTimeout = function() {
            _this.setState({
                beforeClose: false,
                isOpen: false,
                afterOpen: false,
                closesAt: null
            }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
            if ($40c9c6397b0ffa5b$var$isTabKey(event)) (0, $40c9c6397b0ffa5b$var$_scopeTab2.default)(_this.content, event);
            if (_this.props.shouldCloseOnEsc && $40c9c6397b0ffa5b$var$isEscKey(event)) {
                event.stopPropagation();
                _this.requestClose(event);
            }
        };
        _this.handleOverlayOnClick = function(event) {
            if (_this.shouldClose === null) _this.shouldClose = true;
            if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
                if (_this.ownerHandlesClose()) _this.requestClose(event);
                else _this.focusContent();
            }
            _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
            _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
            if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) event.preventDefault();
        };
        _this.handleContentOnClick = function() {
            _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
            _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
            return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
            return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
            return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
            return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
            var classNames = (typeof additional === "undefined" ? "undefined" : $40c9c6397b0ffa5b$var$_typeof(additional)) === "object" ? additional : {
                base: $40c9c6397b0ffa5b$var$CLASS_NAMES[which],
                afterOpen: $40c9c6397b0ffa5b$var$CLASS_NAMES[which] + "--after-open",
                beforeClose: $40c9c6397b0ffa5b$var$CLASS_NAMES[which] + "--before-close"
            };
            var className = classNames.base;
            if (_this.state.afterOpen) className = className + " " + classNames.afterOpen;
            if (_this.state.beforeClose) className = className + " " + classNames.beforeClose;
            return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix, items) {
            return Object.keys(items).reduce(function(acc, name) {
                acc[prefix + "-" + name] = items[name];
                return acc;
            }, {});
        };
        _this.state = {
            afterOpen: false,
            beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
    }
    $40c9c6397b0ffa5b$var$_createClass(ModalPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.isOpen) this.open();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.isOpen && !prevProps.isOpen) this.open();
                else if (!this.props.isOpen && prevProps.isOpen) this.close();
                // Focus only needs to be set once when the modal is being opened
                if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) this.focusContent();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.state.isOpen) this.afterClose();
                clearTimeout(this.closeTimer);
                cancelAnimationFrame(this.openAnimationFrame);
            }
        },
        {
            key: "beforeOpen",
            value: function beforeOpen() {
                var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName, parentSelector = _props.parentSelector;
                var parentDocument = parentSelector && parentSelector().ownerDocument || document;
                // Add classes.
                bodyOpenClassName && $40c9c6397b0ffa5b$var$classList.add(parentDocument.body, bodyOpenClassName);
                htmlOpenClassName && $40c9c6397b0ffa5b$var$classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
                if (ariaHideApp) {
                    $40c9c6397b0ffa5b$var$ariaHiddenInstances += 1;
                    $40c9c6397b0ffa5b$var$ariaAppHider.hide(appElement);
                }
                $40c9c6397b0ffa5b$var$_portalOpenInstances2.default.register(this);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
                var contentStyles = className ? {} : defaultStyles.content;
                var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
                if (this.shouldBeClosed()) return null;
                var overlayProps = {
                    ref: this.setOverlayRef,
                    className: this.buildClassName("overlay", overlayClassName),
                    style: $40c9c6397b0ffa5b$var$_extends({}, overlayStyles, this.props.style.overlay),
                    onClick: this.handleOverlayOnClick,
                    onMouseDown: this.handleOverlayOnMouseDown
                };
                var contentProps = $40c9c6397b0ffa5b$var$_extends({
                    id: id,
                    ref: this.setContentRef,
                    style: $40c9c6397b0ffa5b$var$_extends({}, contentStyles, this.props.style.content),
                    className: this.buildClassName("content", className),
                    tabIndex: "-1",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleContentOnMouseDown,
                    onMouseUp: this.handleContentOnMouseUp,
                    onClick: this.handleContentOnClick,
                    role: this.props.role,
                    "aria-label": this.props.contentLabel
                }, this.attributesFromObject("aria", $40c9c6397b0ffa5b$var$_extends({
                    modal: true
                }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
                    "data-testid": this.props.testId
                });
                var contentElement = this.props.contentElement(contentProps, children);
                return this.props.overlayElement(overlayProps, contentElement);
            }
        }
    ]);
    return ModalPortal;
}($9nZCP.Component);
$40c9c6397b0ffa5b$var$ModalPortal.defaultProps = {
    style: {
        overlay: {},
        content: {}
    },
    defaultStyles: {}
};
$40c9c6397b0ffa5b$var$ModalPortal.propTypes = {
    isOpen: $40c9c6397b0ffa5b$var$_propTypes2.default.bool.isRequired,
    defaultStyles: $40c9c6397b0ffa5b$var$_propTypes2.default.shape({
        content: $40c9c6397b0ffa5b$var$_propTypes2.default.object,
        overlay: $40c9c6397b0ffa5b$var$_propTypes2.default.object
    }),
    style: $40c9c6397b0ffa5b$var$_propTypes2.default.shape({
        content: $40c9c6397b0ffa5b$var$_propTypes2.default.object,
        overlay: $40c9c6397b0ffa5b$var$_propTypes2.default.object
    }),
    className: $40c9c6397b0ffa5b$var$_propTypes2.default.oneOfType([
        $40c9c6397b0ffa5b$var$_propTypes2.default.string,
        $40c9c6397b0ffa5b$var$_propTypes2.default.object
    ]),
    overlayClassName: $40c9c6397b0ffa5b$var$_propTypes2.default.oneOfType([
        $40c9c6397b0ffa5b$var$_propTypes2.default.string,
        $40c9c6397b0ffa5b$var$_propTypes2.default.object
    ]),
    parentSelector: $40c9c6397b0ffa5b$var$_propTypes2.default.func,
    bodyOpenClassName: $40c9c6397b0ffa5b$var$_propTypes2.default.string,
    htmlOpenClassName: $40c9c6397b0ffa5b$var$_propTypes2.default.string,
    ariaHideApp: $40c9c6397b0ffa5b$var$_propTypes2.default.bool,
    appElement: $40c9c6397b0ffa5b$var$_propTypes2.default.oneOfType([
        $40c9c6397b0ffa5b$var$_propTypes2.default.instanceOf($40c9c6397b0ffa5b$var$_safeHTMLElement2.default),
        $40c9c6397b0ffa5b$var$_propTypes2.default.instanceOf($fe466a6806dbcfa6$exports.SafeHTMLCollection),
        $40c9c6397b0ffa5b$var$_propTypes2.default.instanceOf($fe466a6806dbcfa6$exports.SafeNodeList),
        $40c9c6397b0ffa5b$var$_propTypes2.default.arrayOf($40c9c6397b0ffa5b$var$_propTypes2.default.instanceOf($40c9c6397b0ffa5b$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $40c9c6397b0ffa5b$var$_propTypes2.default.func,
    onAfterClose: $40c9c6397b0ffa5b$var$_propTypes2.default.func,
    onRequestClose: $40c9c6397b0ffa5b$var$_propTypes2.default.func,
    closeTimeoutMS: $40c9c6397b0ffa5b$var$_propTypes2.default.number,
    shouldFocusAfterRender: $40c9c6397b0ffa5b$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $40c9c6397b0ffa5b$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $40c9c6397b0ffa5b$var$_propTypes2.default.bool,
    preventScroll: $40c9c6397b0ffa5b$var$_propTypes2.default.bool,
    role: $40c9c6397b0ffa5b$var$_propTypes2.default.string,
    contentLabel: $40c9c6397b0ffa5b$var$_propTypes2.default.string,
    aria: $40c9c6397b0ffa5b$var$_propTypes2.default.object,
    data: $40c9c6397b0ffa5b$var$_propTypes2.default.object,
    children: $40c9c6397b0ffa5b$var$_propTypes2.default.node,
    shouldCloseOnEsc: $40c9c6397b0ffa5b$var$_propTypes2.default.bool,
    overlayRef: $40c9c6397b0ffa5b$var$_propTypes2.default.func,
    contentRef: $40c9c6397b0ffa5b$var$_propTypes2.default.func,
    id: $40c9c6397b0ffa5b$var$_propTypes2.default.string,
    overlayElement: $40c9c6397b0ffa5b$var$_propTypes2.default.func,
    contentElement: $40c9c6397b0ffa5b$var$_propTypes2.default.func,
    testId: $40c9c6397b0ffa5b$var$_propTypes2.default.string
};
$40c9c6397b0ffa5b$exports.default = $40c9c6397b0ffa5b$var$ModalPortal;
$40c9c6397b0ffa5b$exports = $40c9c6397b0ffa5b$exports["default"];


var $d0b0b2f8690f8b25$var$_ModalPortal2 = $d0b0b2f8690f8b25$var$_interopRequireDefault($40c9c6397b0ffa5b$exports);

var $d0b0b2f8690f8b25$var$ariaAppHider = $d0b0b2f8690f8b25$var$_interopRequireWildcard($d6571eab8a22de89$exports);

var $d0b0b2f8690f8b25$var$_safeHTMLElement2 = $d0b0b2f8690f8b25$var$_interopRequireDefault($fe466a6806dbcfa6$exports);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $d50a45a912bb6b4d$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $d50a45a912bb6b4d$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $d50a45a912bb6b4d$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$d50a45a912bb6b4d$var$componentWillMount.__suppressDeprecationWarning = true;
$d50a45a912bb6b4d$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$d50a45a912bb6b4d$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $d50a45a912bb6b4d$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $d50a45a912bb6b4d$var$componentWillMount;
        prototype.componentWillReceiveProps = $d50a45a912bb6b4d$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $d50a45a912bb6b4d$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}


function $d0b0b2f8690f8b25$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $d0b0b2f8690f8b25$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d0b0b2f8690f8b25$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d0b0b2f8690f8b25$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d0b0b2f8690f8b25$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d0b0b2f8690f8b25$var$portalClassName = $d0b0b2f8690f8b25$exports.portalClassName = "ReactModalPortal";
var $d0b0b2f8690f8b25$var$bodyOpenClassName = $d0b0b2f8690f8b25$exports.bodyOpenClassName = "ReactModal__Body--open";
var $d0b0b2f8690f8b25$var$isReact16 = $fe466a6806dbcfa6$exports.canUseDOM && $d0b0b2f8690f8b25$var$_reactDom2.default.createPortal !== undefined;
var $d0b0b2f8690f8b25$var$createHTMLElement = function createHTMLElement(name) {
    return document.createElement(name);
};
var $d0b0b2f8690f8b25$var$getCreatePortal = function getCreatePortal() {
    return $d0b0b2f8690f8b25$var$isReact16 ? $d0b0b2f8690f8b25$var$_reactDom2.default.createPortal : $d0b0b2f8690f8b25$var$_reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function $d0b0b2f8690f8b25$var$getParentElement(parentSelector) {
    return parentSelector();
}
var $d0b0b2f8690f8b25$var$Modal = function(_Component) {
    $d0b0b2f8690f8b25$var$_inherits(Modal, _Component);
    function Modal() {
        var _ref;
        var _temp, _this, _ret;
        $d0b0b2f8690f8b25$var$_classCallCheck(this, Modal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $d0b0b2f8690f8b25$var$_possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.removePortal = function() {
            !$d0b0b2f8690f8b25$var$isReact16 && $d0b0b2f8690f8b25$var$_reactDom2.default.unmountComponentAtNode(_this.node);
            var parent = $d0b0b2f8690f8b25$var$getParentElement(_this.props.parentSelector);
            if (parent && parent.contains(_this.node)) parent.removeChild(_this.node);
            else // eslint-disable-next-line no-console
            console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }, _this.portalRef = function(ref) {
            _this.portal = ref;
        }, _this.renderPortal = function(props) {
            var createPortal = $d0b0b2f8690f8b25$var$getCreatePortal();
            var portal = createPortal(_this, $d0b0b2f8690f8b25$var$_react2.default.createElement($d0b0b2f8690f8b25$var$_ModalPortal2.default, $d0b0b2f8690f8b25$var$_extends({
                defaultStyles: Modal.defaultStyles
            }, props)), _this.node);
            _this.portalRef(portal);
        }, _temp), $d0b0b2f8690f8b25$var$_possibleConstructorReturn(_this, _ret);
    }
    $d0b0b2f8690f8b25$var$_createClass(Modal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$fe466a6806dbcfa6$exports.canUseDOM) return;
                if (!$d0b0b2f8690f8b25$var$isReact16) this.node = $d0b0b2f8690f8b25$var$createHTMLElement("div");
                this.node.className = this.props.portalClassName;
                var parent = $d0b0b2f8690f8b25$var$getParentElement(this.props.parentSelector);
                parent.appendChild(this.node);
                !$d0b0b2f8690f8b25$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var prevParent = $d0b0b2f8690f8b25$var$getParentElement(prevProps.parentSelector);
                var nextParent = $d0b0b2f8690f8b25$var$getParentElement(this.props.parentSelector);
                return {
                    prevParent: prevParent,
                    nextParent: nextParent
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, _, snapshot) {
                if (!$fe466a6806dbcfa6$exports.canUseDOM) return;
                var _props = this.props, isOpen = _props.isOpen, portalClassName = _props.portalClassName;
                if (prevProps.portalClassName !== portalClassName) this.node.className = portalClassName;
                var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
                if (nextParent !== prevParent) {
                    prevParent.removeChild(this.node);
                    nextParent.appendChild(this.node);
                }
                // Stop unnecessary renders if modal is remaining closed
                if (!prevProps.isOpen && !isOpen) return;
                !$d0b0b2f8690f8b25$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$fe466a6806dbcfa6$exports.canUseDOM || !this.node || !this.portal) return;
                var state = this.portal.state;
                var now = Date.now();
                var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
                if (closesAt) {
                    if (!state.beforeClose) this.portal.closeWithTimeout();
                    setTimeout(this.removePortal, closesAt - now);
                } else this.removePortal();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!$fe466a6806dbcfa6$exports.canUseDOM || !$d0b0b2f8690f8b25$var$isReact16) return null;
                if (!this.node && $d0b0b2f8690f8b25$var$isReact16) this.node = $d0b0b2f8690f8b25$var$createHTMLElement("div");
                var createPortal = $d0b0b2f8690f8b25$var$getCreatePortal();
                return createPortal($d0b0b2f8690f8b25$var$_react2.default.createElement($d0b0b2f8690f8b25$var$_ModalPortal2.default, $d0b0b2f8690f8b25$var$_extends({
                    ref: this.portalRef,
                    defaultStyles: Modal.defaultStyles
                }, this.props)), this.node);
            }
        }
    ], [
        {
            key: "setAppElement",
            value: function setAppElement(element) {
                $d0b0b2f8690f8b25$var$ariaAppHider.setElement(element);
            }
        }
    ]);
    return Modal;
}($9nZCP.Component);
$d0b0b2f8690f8b25$var$Modal.propTypes = {
    isOpen: $d0b0b2f8690f8b25$var$_propTypes2.default.bool.isRequired,
    style: $d0b0b2f8690f8b25$var$_propTypes2.default.shape({
        content: $d0b0b2f8690f8b25$var$_propTypes2.default.object,
        overlay: $d0b0b2f8690f8b25$var$_propTypes2.default.object
    }),
    portalClassName: $d0b0b2f8690f8b25$var$_propTypes2.default.string,
    bodyOpenClassName: $d0b0b2f8690f8b25$var$_propTypes2.default.string,
    htmlOpenClassName: $d0b0b2f8690f8b25$var$_propTypes2.default.string,
    className: $d0b0b2f8690f8b25$var$_propTypes2.default.oneOfType([
        $d0b0b2f8690f8b25$var$_propTypes2.default.string,
        $d0b0b2f8690f8b25$var$_propTypes2.default.shape({
            base: $d0b0b2f8690f8b25$var$_propTypes2.default.string.isRequired,
            afterOpen: $d0b0b2f8690f8b25$var$_propTypes2.default.string.isRequired,
            beforeClose: $d0b0b2f8690f8b25$var$_propTypes2.default.string.isRequired
        })
    ]),
    overlayClassName: $d0b0b2f8690f8b25$var$_propTypes2.default.oneOfType([
        $d0b0b2f8690f8b25$var$_propTypes2.default.string,
        $d0b0b2f8690f8b25$var$_propTypes2.default.shape({
            base: $d0b0b2f8690f8b25$var$_propTypes2.default.string.isRequired,
            afterOpen: $d0b0b2f8690f8b25$var$_propTypes2.default.string.isRequired,
            beforeClose: $d0b0b2f8690f8b25$var$_propTypes2.default.string.isRequired
        })
    ]),
    appElement: $d0b0b2f8690f8b25$var$_propTypes2.default.oneOfType([
        $d0b0b2f8690f8b25$var$_propTypes2.default.instanceOf($d0b0b2f8690f8b25$var$_safeHTMLElement2.default),
        $d0b0b2f8690f8b25$var$_propTypes2.default.instanceOf($fe466a6806dbcfa6$exports.SafeHTMLCollection),
        $d0b0b2f8690f8b25$var$_propTypes2.default.instanceOf($fe466a6806dbcfa6$exports.SafeNodeList),
        $d0b0b2f8690f8b25$var$_propTypes2.default.arrayOf($d0b0b2f8690f8b25$var$_propTypes2.default.instanceOf($d0b0b2f8690f8b25$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $d0b0b2f8690f8b25$var$_propTypes2.default.func,
    onRequestClose: $d0b0b2f8690f8b25$var$_propTypes2.default.func,
    closeTimeoutMS: $d0b0b2f8690f8b25$var$_propTypes2.default.number,
    ariaHideApp: $d0b0b2f8690f8b25$var$_propTypes2.default.bool,
    shouldFocusAfterRender: $d0b0b2f8690f8b25$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $d0b0b2f8690f8b25$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $d0b0b2f8690f8b25$var$_propTypes2.default.bool,
    preventScroll: $d0b0b2f8690f8b25$var$_propTypes2.default.bool,
    parentSelector: $d0b0b2f8690f8b25$var$_propTypes2.default.func,
    aria: $d0b0b2f8690f8b25$var$_propTypes2.default.object,
    data: $d0b0b2f8690f8b25$var$_propTypes2.default.object,
    role: $d0b0b2f8690f8b25$var$_propTypes2.default.string,
    contentLabel: $d0b0b2f8690f8b25$var$_propTypes2.default.string,
    shouldCloseOnEsc: $d0b0b2f8690f8b25$var$_propTypes2.default.bool,
    overlayRef: $d0b0b2f8690f8b25$var$_propTypes2.default.func,
    contentRef: $d0b0b2f8690f8b25$var$_propTypes2.default.func,
    id: $d0b0b2f8690f8b25$var$_propTypes2.default.string,
    overlayElement: $d0b0b2f8690f8b25$var$_propTypes2.default.func,
    contentElement: $d0b0b2f8690f8b25$var$_propTypes2.default.func
};
$d0b0b2f8690f8b25$var$Modal.defaultProps = {
    isOpen: false,
    portalClassName: $d0b0b2f8690f8b25$var$portalClassName,
    bodyOpenClassName: $d0b0b2f8690f8b25$var$bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    preventScroll: false,
    parentSelector: function parentSelector() {
        return document.body;
    },
    overlayElement: function overlayElement(props, contentEl) {
        return $d0b0b2f8690f8b25$var$_react2.default.createElement("div", props, contentEl);
    },
    contentElement: function contentElement(props, children) {
        return $d0b0b2f8690f8b25$var$_react2.default.createElement("div", props, children);
    }
};
$d0b0b2f8690f8b25$var$Modal.defaultStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
        position: "absolute",
        top: "40px",
        left: "40px",
        right: "40px",
        bottom: "40px",
        border: "1px solid #ccc",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "4px",
        outline: "none",
        padding: "20px"
    }
};
(0, $d50a45a912bb6b4d$export$cea1c58a6db52bca)($d0b0b2f8690f8b25$var$Modal);
$d0b0b2f8690f8b25$exports.default = $d0b0b2f8690f8b25$var$Modal;


var $1e156356cfe6a768$var$_Modal2 = $1e156356cfe6a768$var$_interopRequireDefault($d0b0b2f8690f8b25$exports);
function $1e156356cfe6a768$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$1e156356cfe6a768$exports.default = $1e156356cfe6a768$var$_Modal2.default;
$1e156356cfe6a768$exports = $1e156356cfe6a768$exports["default"];



const $3345f50ed61ddee0$var$container = document.getElementById("app");
(0, (/*@__PURE__*/$parcel$interopDefault($1e156356cfe6a768$exports))).setAppElement($3345f50ed61ddee0$var$container);
const $3345f50ed61ddee0$var$root = (0, $d6d573f2d6b6d1f8$export$882461b6382ed46c)($3345f50ed61ddee0$var$container);
$3345f50ed61ddee0$var$root.render(/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).StrictMode, {
    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $544fc37a064f4916$export$7221d69dcfc8e36b), {
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $7cf329a89708da12$export$2e2bcd8739ae039), {})
    })
}));

})();
//# sourceMappingURL=index.2ce0f891.js.map
